// GENERATED FILE:
export default {
  "ab": {
    "gui.alerts.lostPeripheralConnection": "Scratch иацәыӡит  {extensionName} аимадара.",
    "gui.alerts.tryAgain": "Даҽазнык игәашәҭ",
    "gui.alerts.download": "Иҭыгатәуп",
    "gui.connection.reconnect": "Даҽазнык аҿакра",
    "gui.backpack.costumeLabel": "акостиум",
    "gui.backpack.soundLabel": "абжьы",
    "gui.backpack.scriptLabel": "апрограмма",
    "gui.backpack.spriteLabel": "анагӡаҩ",
    "gui.backpack.header": "Абӷакыдҵа",
    "gui.backpack.errorBackpack": "Абӷакыдҵа аҭагалараан агха",
    "gui.backpack.loadingBackpack": "Аҭагалара...",
    "gui.backpack.more": "Иҵегь",
    "gui.backpack.emptyBackpack": "Абӷакыдҵа ҭацәуп",
    "gui.unsupportedBrowser.label": "Абраузер аднакылом",
    "gui.unsupportedBrowser.errorLabel": "Иҟалеит агха",
    "gui.unsupportedBrowser.notRecommended": "Гәхьаас иҳамоуп аха, шәхы иашәырхәо абраузер аверсиа Scratch аднакылаӡом. Ишәабжьаҳгоит Scratch здызкыло абраузер аҵыхәтәантәи аверсиа аҟынӡа ишәырҿыцразы, иаҳҳәап Google Chrome, Mozilla Firefox, Microsoft Edge ма Apple Safari.",
    "gui.unsupportedBrowser.description": "Гәхьаас иҳамоуп аха, ари абраузер Scratch аднакылаӡом. Ишәабжьаҳгоит шәхы иашәырхәарц абраузерқәа: Google Chrome, Mozilla Firefox, Microsoft Edge ма Apple Safari рҵыхәтәантәи аверсиақәа.",
    "gui.unsupportedBrowser.back": "Шьҭахьҟа",
    "gui.unsupportedBrowser.previewfaq": "Иаҳа еиҳаны аилкаараз, шәиас {previewFaqLink} ахь. ",
    "gui.unsupportedBrowser.previewfaqlinktext": "ЛЛИ",
    "gui.cards.all-tutorials": "Ахархәагақәа",
    "gui.cards.shrink": "Еикәарҳәтәуп",
    "gui.cards.expand": "Еиҵыхтәуп",
    "gui.cards.close": "Иарктәуп",
    "gui.cards.more-things-to-try": "Игәашәҭ егьырҭ алшарақәа!",
    "gui.cards.see-more": "Еилкаатәуп еиҳаны",
    "gui.comingSoon.message1": "Шәгәы шәырҭынч, ари ҳара аус адулара ҳаҿуп  {emoji}",
    "gui.comingSoon.message2": "Иаарласны...",
    "gui.comingSoon.message3": "Ари, ҳара аус адулара ҳаҿуп {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Аиҿартәырақәа ԥшаам",
    "gui.connection.auto-scanning.prescan": "Аиҿартәыра ааигәа иҟашәҵа, нас шәалага аԥшаара.",
    "gui.connection.auto-scanning.pressbutton": "Аиҿартәыра аҟны шәақәыӷәӷәа акнопка.",
    "gui.connection.auto-scanning.start-search": "Иалагатәуп аԥшаара",
    "gui.connection.connecting-searchbutton": "Аԥшаара...",
    "gui.connection.auto-scanning.try-again": "Игәаҭатәуп иҵегь",
    "gui.connection.auto-scanning.updatePeripheralButton": "Ирҿыцтәуп сара Смаруга",
    "gui.connection.connected": "Аимадара шьақәыргылоуп",
    "gui.connection.disconnect": "Аимадара ықәгатәуп",
    "gui.connection.go-to-editor": "Ииастәуп Аредактор ахь",
    "gui.connection.connecting-cancelbutton": "Аимадара...",
    "gui.connection.error.errorMessage": "Уаҳ, аусқәа ишахәҭам ицеит.",
    "gui.connection.error.tryagainbutton": "Игәаҭатәуп иҵегь",
    "gui.connection.error.helpbutton": "Ацхыраара",
    "gui.connection.peripheral-name-label": "Аиҿартәыра ахьӡ",
    "gui.connection.connect": "Аимадара шьақәыргылатәуп",
    "gui.connection.scanning.lookingforperipherals": "Аиҿартәырақәа рыԥшаара цоит",
    "gui.connection.scanning.noPeripheralsFound": "Аиҿартәырақәа ԥшаам",
    "gui.connection.scanning.instructions": "Иалышәх аиҿартәыра хыхьтәи асиа аҟынтәи.",
    "gui.connection.search": "Ирҿыцтәуп",
    "gui.connection.scanning.updatePeripheralButton": "Ирҿыцтәуп сара Смаруга",
    "gui.connection.unavailable.installscratchlink": "Агәра жәга, апрограмма  Scratch Link шықәыргылои аусура ишаҿуи ",
    "gui.connection.unavailable.enablebluetooth": "Bluetooth шаҿаку гәашәҭ",
    "gui.connection.unavailable.tryagainbutton": "Игәаҭатәуп иҵегь",
    "gui.connection.unavailable.helpbutton": "Ацхыраара",
    "gui.connection.updatePeripheral.microBitConnect": "Иаԥышәшь шәара {extensionName} ари амаруга, шәхы иархәаны USB акабель.",
    "gui.connection.updatePeripheral.pressUpdate": "Шәақәыӷәӷәа \"Имҩаԥгатәуп Арҿыцра\", шәазыԥшы арҿыцра ахыркәшара.",
    "gui.connection.updatePeripheral.progress": "Арҿыцра {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Ирҿыцуп қәҿиарала!",
    "gui.connection.updatePeripheral.updateFailed": "Арҿыцраан агха.",
    "gui.connection.updatePeripheral.goBackButton": "Шьҭахьҟа",
    "gui.connection.updatePeripheral.updateNowButton": "Имҩаԥгатәуп Арҿыцра",
    "gui.connection.updatePeripheral.updateAgainButton": "Даҽазнык игәашәҭ",
    "gui.controls.go": "Ԥхьаҟа",
    "gui.controls.stop": "Иаанкылатәуп",
    "gui.crashMessage.label": "Уаҳ! Аусқәа иашамкәа ицеит.",
    "gui.crashMessage.description": "Ҳара хьаас иҳамоуп, аха Scratch аҟны иҟалеит агха. Агхазы ацҳамҭа автоматикала идәықәҵоуп Scratch акомандахь. Ишәырҿыц адаҟьа, даҽазнык агәаҭараз.",
    "gui.crashMessage.errorNumber": "Шәара шәыгха арегистрациатә код {errorId}",
    "gui.crashMessage.reload": "Аиҭадәықәҵара",
    "gui.customProcedures.myblockModalTitle": "Иаԥҵатәуп аблок",
    "gui.customProcedures.addAnInputNumberText": "Иацҵатәуп аҵакы",
    "gui.customProcedures.numberTextType": "ахыԥхьаӡара ма атекст",
    "gui.customProcedures.addAnInputBoolean": "Иацҵатәуп аҵакы",
    "gui.customProcedures.booleanType": "алогикатә",
    "gui.customProcedures.addALabel": "Иацҵатәуп аҵаҩра",
    "gui.customProcedures.runWithoutScreenRefresh": "Идәықәҵатәуп аекран мырҿыцқәа",
    "gui.customProcedures.cancel": "Иаҟәыхтәуп",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Ахырхарҭа",
    "gui.directionPicker.rotationStyles.allAround": "Иргьежьтәуп",
    "gui.directionPicker.rotationStyles.leftRight": "Армарахь/Арӷьарахь",
    "gui.directionPicker.rotationStyles.dontRotate": "Иргьежьтәӡам",
    "gui.gui.addExtension": "Иацҵатәуп арҭбаара",
    "gui.gui.codeTab": "Акод",
    "gui.gui.backdropsTab": "Аҿаԥшырақәа",
    "gui.gui.costumesTab": "Акостиумқәа",
    "gui.gui.soundsTab": "Абжьқәа",
    "gui.extensionLibrary.comingSoon": "Иаарласны...",
    "gui.extensionLibrary.requires": "Иаҭахуп",
    "gui.extensionLibrary.collaboration": "Аус рыцутәуп",
    "gui.library.filterPlaceholder": "Аԥшаара",
    "gui.library.allTag": "Зегьы",
    "gui.loader.message1": "Аблокқәа раԥҵара...",
    "gui.loader.message2": "Анагӡаҩцәа рҭагалара...",
    "gui.loader.message3": "Абжьқәа рҭагалара...",
    "gui.loader.message4": "Арҭбаарақәа рҭагалара...",
    "gui.loader.message5": "Ацгәқәа рхылаԥшра...",
    "gui.loader.message6": "Нанохәҭаҷқәа рынашьҭра...",
    "gui.loader.message7": "Гобо арчра...",
    "gui.loader.message8": "Асмаиликқәа разырхиара...",
    "gui.loader.headline": "Апроект аҭагалара",
    "gui.loader.creating": "Иаԥҵатәуп апроект",
    "gui.accountMenu.profile": "Апрофиль",
    "gui.accountMenu.myStuff": "Сара суысумҭақәа",
    "gui.accountMenu.myClasses": "Сара сыклассқәа",
    "gui.accountMenu.myClass": "Сара сыкласс",
    "gui.accountMenu.accountSettings": "Аккаунт азырхирақәа",
    "gui.accountMenu.signOut": "Иҭыҵтәуп",
    "gui.authorInfo.byUser": "{username}и(л)ҟынтә",
    "gui.menuBar.seeProjectPage": "Иахәаԥштәуп апроект адаҟьа",
    "gui.menuBar.language": "Абызшәа",
    "general.username": "Ахархәаҩ ихьӡ",
    "general.password": "Ажәамаӡа",
    "general.signIn": "Иҭалатәуп",
    "login.needHelp": "Ишәҭахума ацхыраара?",
    "form.validationRequired": "Ари аҭыԥ ахарҭәаара хымԥадатәиуп",
    "gui.menuBar.tutorialsLibrary": "Ахархәагақәа",
    "gui.menuBar.restoreSprite": "Дырхынҳәтәуп Анагӡаҩ",
    "gui.menuBar.restoreSound": "Ирхынҳәтәуп Абжьы",
    "gui.menuBar.restoreCostume": "Ирхынҳәтәуп Акостиум",
    "gui.menuBar.restore": "Ирхынҳәтәуп",
    "gui.menuBar.saveNow": "Еиқәырхатәуп абыржәы",
    "gui.menuBar.saveAsCopy": "Еиқәырхатәуп акопиа ҳасабла",
    "gui.menuBar.remix": "Аремикс",
    "gui.menuBar.new": "Аҿыц",
    "gui.menuBar.file": "Афаил",
    "gui.menuBar.downloadToComputer": "Еиқәырхатәуп шәкомпиутер аҟны",
    "gui.menuBar.edit": "Аредакциазура",
    "gui.menuBar.turboModeOff": "Иаҿыхтәуп Turbo арежим",
    "gui.menuBar.turboModeOn": "Иаҿактәуп Turbo арежим",
    "gui.menuBar.modeMenu": "Арежим",
    "gui.menuBar.normalMode": "Инормалу арежим",
    "gui.menuBar.caturdayMode": "Кото-асабшатәи арежим",
    "gui.menuBar.joinScratch": "Шәыҽҭажәгал",
    "gui.menuBar.signIn": "Иҭалатәуп",
    "gui.gui.projectTitlePlaceholder": "Апроект ахьӡ",
    "gui.menuBar.saveNowLink": "Еиқәырхатәуп абыржәы",
    "gui.menuBar.settings": "Архиарақәа",
    "gui.menuBar.isShared": "Асаит иҭагалоуп",
    "gui.menuBar.share": "Асаит иҭагалатәуп",
    "gui.menuBar.colorMode": "Аԥштәы арежим",
    "gui.modal.help": "Ацхыраара",
    "gui.modal.back": "Шьҭахьҟа",
    "gui.monitor.listMonitor.empty": "(иҭацәуп)",
    "gui.monitor.listMonitor.listLength": "аура {length}",
    "gui.monitor.contextMenu.default": "истандарту аԥшра",
    "gui.monitor.contextMenu.large": "идуу аԥшра",
    "gui.monitor.contextMenu.slider": "аслаидер",
    "gui.monitor.contextMenu.sliderRange": "иԥсахтәуп аслаидер адиапазон",
    "gui.monitor.contextMenu.import": "аимпорт",
    "gui.monitor.contextMenu.export": "аекспорт",
    "gui.monitor.contextMenu.hide": "аҽыҵәахра",
    "gui.playButton.play": "Иарҳәатәуп",
    "gui.playButton.stop": "Иаанкылатәуп",
    "gui.gui.variableScopeOptionAllSprites": "Анагӡаҩцәа зегьы рзы",
    "gui.gui.variableScopeOptionSpriteOnly": "Абри анагӡаҩ мацара изы",
    "gui.gui.cloudVariableOption": "Аԥсҭҳәатә ҽеиҭак (асервер иҭагалоуп)",
    "gui.gui.variablePromptAllSpritesMessage": "Ари аҽеиҭак анагӡаҩцәа зегь ирызкуп.",
    "gui.gui.listPromptAllSpritesMessage": "Ари асиа, анагӡаҩцәа зегьы ирызкуп",
    "gui.prompt.cancel": "Иаҟәыхтәуп",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Иаанкылатәуп",
    "gui.playbackStep.playMsg": "Иарҳәатәуп",
    "gui.playbackStep.loadingMsg": "Аҭагалара...",
    "gui.playbackStep.saveMsg": "Еиқәырхатәуп",
    "gui.playbackStep.reRecordMsg": "Ҿыц иҭаҩтәуп",
    "gui.recordModal.title": "Иҭаҩтәуп Абжьы",
    "gui.recordingStep.beginRecord": "Шәалага аҭаҩра, ҵаҟатәи акнопка ақәыӷәӷәарала",
    "gui.recordingStep.permission": "{arrow} Шәмикрофон ахархәараз, ҳара иҳамазароуп шәара шәзин",
    "gui.recordingStep.stop": "Иаанкылатәуп аҭаҩра",
    "gui.recordingStep.record": "Иҭаҩтәуп",
    "gui.sliderModal.min": "Иминималу аҵакы",
    "gui.sliderModal.max": "Имаксималу аҵакы",
    "gui.sliderModal.title": "Иԥсахтәуп аслаидер адиапазон",
    "gui.sliderPrompt.cancel": "Аҟәыхра",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Абжьы",
    "gui.soundEditor.play": "Иарҳәатәуп",
    "gui.soundEditor.stop": "Иаанкылатәуп",
    "gui.soundEditor.copy": "Акопиа ахыхтәуп",
    "gui.soundEditor.paste": "Иҭаргылатәуп",
    "gui.soundEditor.copyToNew": "Акопиа Абыжь Ҿыц ахь",
    "gui.soundEditor.delete": "Ианыхтәуп",
    "gui.soundEditor.save": "Еиқәырхатәуп",
    "gui.soundEditor.undo": "Иаҟәыхтәуп",
    "gui.soundEditor.redo": "Ирхынҳәтәуп",
    "gui.soundEditor.faster": "Ирласны",
    "gui.soundEditor.slower": "Имырласкәа",
    "gui.soundEditor.echo": "Аныҩбжьы",
    "gui.soundEditor.robot": "Аробот",
    "gui.soundEditor.louder": "Абжьы ардура",
    "gui.soundEditor.softer": "Абжьы армаҷра",
    "gui.soundEditor.reverse": "Еиҵыхтәуп",
    "gui.soundEditor.fadeOut": "Ашьшьыҳәа арԥсыҽра",
    "gui.soundEditor.fadeIn": "Ашьшьыҳәа арӷәӷәара ",
    "gui.soundEditor.mute": "Иқәгатәуп Абжьы",
    "gui.SpriteInfo.spritePlaceholder": "Ахьӡ",
    "gui.SpriteInfo.showSpriteAction": "Иаарԥштәуп анагӡаҩ",
    "gui.SpriteInfo.hideSpriteAction": "Иҵәахтәуп анагӡаҩ",
    "gui.SpriteInfo.sprite": "Анагӡаҩ",
    "gui.SpriteInfo.show": "Иаарԥштәуп",
    "gui.SpriteInfo.size": "Ашәагаа",
    "gui.spriteSelectorItem.contextMenuDuplicate": "адубликат",
    "gui.spriteSelectorItem.contextMenuExport": "аекспорт",
    "gui.spriteSelectorItem.contextMenuDelete": "ианыхтәуп",
    "gui.spriteSelector.addSpriteFromLibrary": "Далхтәуп Анагӡаҩ",
    "gui.spriteSelector.addSpriteFromPaint": "Иҭыхтәуп",
    "gui.spriteSelector.addSpriteFromSurprise": "Асиурприз",
    "gui.spriteSelector.addSpriteFromFile": "Дҭагалатәуп Анагӡаҩ",
    "gui.stageHeader.stageSizeLarge": "Асцена ду",
    "gui.stageHeader.stageSizeSmall": "Асцена маҷ",
    "gui.stageHeader.stageSizeFull": "Ииастәуп аекран зегь арежим ахь",
    "gui.stageHeader.stageSizeUnFull": "Иҭыҵтәуп аекран зегь арежим ",
    "gui.stageHeader.fullscreenControl": "Аекран зегь арежим",
    "gui.spriteSelector.addBackdropFromLibrary": "Иалхтәуп Аҿаԥшыра",
    "gui.stageSelector.addBackdropFromPaint": "Иҭыхтәуп",
    "gui.stageSelector.addBackdropFromSurprise": "Асиурприз",
    "gui.stageSelector.addBackdropFromFile": "Иҭагалатәуп аҿаԥшыра",
    "gui.stageSelector.stage": "Асцена",
    "gui.stageSelector.backdrops": "Аҿаԥшырақәа",
    "gui.telemetryOptIn.label": "Scratch аиӷьтәразы идәықәышәҵа астатистика",
    "gui.telemetryOptIn.body1": "Scratch Акоманда азҿлымҳауп аилкаара, адунеи зегь аҟны Scratch ахархәашьа. Ари аус шәацхраарцаз, шәара ишәылшоит Scratch азин ашәҭарц, иара ахархәашьаз аинформациа автоматикала адәықәҵара.",
    "gui.telemetryOptIn.body2": "Ҳара еизаҳго аинформациа азкуп: абызшәа, аблокқәа рхархәашьеи егьырҭ ахҭысқәеи, аиқәырхара, апроект аҭагалара. Ҳара ЕИЗАҲГОМ ихатәу аинформациа. Шәахәаԥш {privacyPolicyLink} иаҳа еиҳаны аилкаараз. ",
    "gui.telemetryOptIn.privacyPolicyLink": "Аконфиденциалтә политика",
    "gui.telemetryOptIn.optInText": " Scratch Team акоманда иазыцҳатәуп  ахархәаразы сара исызку аинформациа",
    "gui.telemetryOptIn.optInTooltip": "Ателеметриа аҿактәуп",
    "gui.telemetryOptIn.optOutText": "Scratch Team акоманда иазыцҳатәӡам ахархәаразы сара исызку аинформациа",
    "gui.telemetryOptIn.optOutTooltip": "Ателеметриа аҿыхтәуп",
    "gui.telemetryOptIn.settingWasUpdated": "Шәара шәырхиара рҿыцын.",
    "gui.telemetryOptIn.buttonClose": "Иарктәуп",
    "gui.turboMode.active": "Турбо арежим",
    "gui.webglModal.label": "Шәара шәбраузер иаднакылом WebGL.",
    "gui.webglModal.description": "Ихьаахгоит аха,  шәбраузер ма шәкомпиутер {webGlLink}.  Ари атехнологиа аҭахуп Scratch 3.0. аус аруразы. ",
    "gui.webglModal.webgllink": "WebGL аднакылом",
    "gui.webglModal.back": "Шьҭахьҟа",
    "gui.webglModal.previewfaq": "Иаҳа еиҳаны аилкаараз, шәиас {previewFaqLink} ахь. ",
    "gui.webglModal.previewfaqlinktext": "ЛЛИ",
    "gui.costumeLibrary.chooseABackdrop": "Иалхтәуп Аҿаԥшыра",
    "gui.costumeLibrary.chooseACostume": "Иалхтәуп акостиум",
    "gui.costumeTab.addBackdropFromLibrary": "Иалхтәуп Аҿаԥшыра ",
    "gui.costumeTab.addCostumeFromLibrary": "Иалхтәуп акостиум",
    "gui.costumeTab.addBlankCostume": "Иҭыхтәуп",
    "gui.costumeTab.addSurpriseCostume": "Асиурприз",
    "gui.costumeTab.addFileBackdrop": "Иҭагалатәуп Аҿаԥшыра",
    "gui.costumeTab.addFileCostume": "Иҭагалатәуп акостиум",
    "gui.extensionLibrary.chooseAnExtension": "Иалхтәуп ахарҭәаага",
    "gui.extensionLibrary.extensionUrl": "Иҭажәгал арҭбаара а-URL ",
    "gui.monitors.importListColumnPrompt": "Иарбан еиҵаҩу ихархәатәу (1- {numberOfColumns})? ",
    "gui.recordingStep.alertMsg": "Иамуӡеит аҭаҩра алагара",
    "gui.soundLibrary.chooseASound": "Иалхтәуп Абжьы",
    "gui.soundTab.fileUploadSound": "Иҭагалатәуп Абжьы",
    "gui.soundTab.surpriseSound": "Асиурприз",
    "gui.soundTab.recordSound": "Иҭаҩтәуп",
    "gui.soundTab.addSoundFromLibrary": "Иалхтәуп Абжьы",
    "gui.spriteLibrary.chooseASprite": "Далхтәуп Анагӡаҩ",
    "gui.tipsLibrary.tutorials": "Иалхтәуп ахархәага",
    "gui.alerts.createsuccess": "Апроект ҿыц аԥҵоуп.",
    "gui.alerts.createcopysuccess": "Апроект акопиа еиқәырхоуп.",
    "gui.alerts.createremixsuccess": "Апроект аремикс еиқәырхоуп.",
    "gui.alerts.creating": "Аҿыц аԥҵара...",
    "gui.alerts.creatingCopy": "Апроект акопиа ахыхра...",
    "gui.alerts.creatingRemix": "Апроект аремикс аԥҵара...",
    "gui.alerts.creatingError": "Иамуӡеит апроект аԥҵара. Даҽазнык инашәыгӡа аԥҵара!",
    "gui.alerts.savingError": "Апроект аиқәырхара ауам.",
    "gui.alerts.savesuccess": "Апроект еиқәырхоуп.",
    "gui.alerts.saving": "Апроект аиқәырхара...",
    "gui.alerts.cloudInfo": "Ишәхашәмыршҭын, аԥсҭҳәатә ҽеиҭакқәа цифрақәа мацараз ауп, инбанзар ма исимволзар ауам. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Еиҳаны аилкаара.",
    "gui.alerts.importing": "Аимпорт...",
    "gui.defaultProject.meow": "Миау",
    "gui.defaultProject.variable": "исхатәу аҽеиҭак",
    "gui.howtos.intro-move-sayhello-hat.name": "Излалагатәу",
    "gui.howtos.intro-move.step_stepMove": "Иацышәҵа аиҭаҵратә блок",
    "gui.howtos.add-a-move-block.step_stepSay": "Иацҵатәуп аблок \"иҳәатәуп\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Алагара азы шәақәыӷәӷәа абираҟ иаҵәа!",
    "gui.howtos.intro-getting-started-ASL.name": "Аусура алагра - ASL",
    "gui.howtos.animate-a-name.name": "Ахьӡ Анимациа азутәуп",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Далышәх Анагӡаҩ Анбан",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Иргатәуп Абжьы, ақәыӷәӷәараан",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Далышәх егьи Анагӡаҩ Анбан",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Иԥсахтәуп аԥштәы",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Далышәх егьи Анагӡаҩ нас дшәыргьежь",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Далышәх егьи Анагӡаҩ Анбан нас ишәырдыу иара.",
    "gui.howtos.imagine": "Шәазхәыц шәара шә-Дунеи",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Иҭажәгал ишәҳәарц ишәҭаху",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Алагара азы шәақәыӷәӷәа абираҟ иаҵәа",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Иалышәх иарбанзаалакь Аҿаԥшыра",
    "gui.howtos.imagine.step_imagineChooseSprite": "Далышәх иарбанзаалакь Анагӡаҩ",
    "gui.howtos.imagine.step_imagineFlyAround": "Ақәҵәраараз шәақәыӷәӷәа аклавиша Абжьажь",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Далышәх егьи Анагӡаҩ",
    "gui.howtos.imagine.step_imagineLeftRight": "Аиҭаҵра Армарахь-Арӷьарахь",
    "gui.howtos.imagine.step_imagineUpDown": "Аиҭаҵра Аҩада-Алада",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Акостиумқәа шәыԥсахла",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Акәаԥ ахь ақәҵәраара",
    "gui.howtos.imagine.step_imagineGrowShrink": "Идухалатәуп нас Ихәыҷхалатәуп",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Иалышәх егьи Аҿаԥшыра",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Аҿаԥшырақәа реиҭныԥсахра",
    "gui.howtos.imagine.step_imagineRecordASound": "Иацышәҵа Абжьы",
    "gui.howtos.imagine.step_imagineChooseSound": "Иалышәх Абжьы",
    "gui.howtos.make-music.name": "Иаԥышәҵа амузыка",
    "gui.howtos.Make-Music.step_PickInstrument": "Иалышәх амаруга Анагӡаҩ",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Иргатәуп Абжьы, ақәыӷәӷәараан",
    "gui.howtos.Make-Music.step_MakeSong": "Иаԥышәҵа ашәа",
    "gui.howtos.make-music.step_MakeBeat": "Иалышәх адаулқәа нас иаԥышәҵа аритм",
    "gui.howtos.make-music.step_MakeBeatBox": "Иалышәх амикрофон Sprite & Surprise Beatbox ",
    "gui.howtos.story.name": "Иаԥҵатәуп аҭоурых",
    "gui.howtos.story.step_addbg": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.story.step_addsprite": "Иацҵатәуп Аперсонаж",
    "gui.howtos.story.step_saysomething": "Ишәҳәа џьара акы",
    "gui.howtos.story.step_addanothersprite": "Иацҵатәуп Егьи Аперсонаж",
    "gui.howtos.story.step_flip": "Иаҿагыло ахырхарҭа",
    "gui.howtos.story.step_conversation": "Ацәажәара хацырктәуп",
    "gui.howtos.story.addanotherbg": "Иацҵатәуп егьи Аҿаԥшыра",
    "gui.howtos.story.step_swithbg": "Аҿаԥшырақәа реиҭныԥсахра",
    "gui.howtos.story.step_hidewizard": "Иҵәахтәуп Аперсонаж",
    "gui.howtos.story.step_showwizard": "Иаарԥштәуп Аперсонаж",
    "gui.howtos.make-a-chase-game.name": "Иаԥышәҵа аиԥхныҩлара иазку ахәмарра",
    "gui.howtos.Chase-Game.step_BG": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.chase-game.step_AddOcto": "Дацышәҵа Анагӡаҩ",
    "gui.howtos.make-music.step_LeftRight": "Аиҭаҵра арӷьарахьи армарахьи ахыцқәа рыла",
    "gui.howtos.Chase-Game.step_UpDown": "Аиҭаҵра аҩадеи аладеи ахыцқәа рыла",
    "gui.howtos.Chase-Game.step_AddStar": "Дацҵатәуп егьи анагӡаҩ",
    "gui.howtos.Chase-Game.step_MoveRandom": "Еиҭаҵлатәуп иахьабалакь",
    "gui.howtos.Chase-Game.step_WhenTouch": "Octopus Sprite аҟны ақәыӷәӷәараан иргатәуп Абжьы ",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Иаԥҵатәуп Аԥхьаӡараз аҽеиҭак",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Octopus Sprite аҟны, ақәыӷәӷәараан иацҵатәуп аԥхьаӡара",
    "gui.howtos.animate-char.name": "Аперсонаж Анимациа азутәуп",
    "gui.howtos.animate-char.step_addbg": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.animate-char.step_addsprite": "Дацышәҵа Анагӡаҩ",
    "gui.howtos.animate-char.step_saysomething": "Ишәҳәа џьара акы",
    "gui.howtos.animate-char.step_addsound": "Иацышәҵа Абжьы",
    "gui.howtos.animate-char.step_animatetalking": "Ацәажәара Анимациа азутәуп",
    "gui.howtos.animate-char.step_arrowkeys": "Ахыцқәа зну аклавишақәа рыла аиҭаҵра",
    "gui.howtos.animate-char.step_jump": "Аҵԥара",
    "gui.howtos.animate-char.step_changecolor": "Иԥсахтәуп аԥштәы",
    "gui.howtos.make-a-game.name": "Иаԥышәҵа ахәмарра Clicker ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Далхтәуп Анагӡаҩ",
    "gui.howtos.make-a-game.step_GamePlaySound": "Иргатәуп Абжьы, ақәыӷәӷәараан",
    "gui.howtos.make-a-game.step_GameAddScore": "Иаԥҵатәуп аԥхьаӡараз аҽеиҭак",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ақәыӷәӷәараан аԥхьаӡа иазырҳатәуп",
    "gui.howtos.make-a-game.step_Random": "Ииастәуп иарбанзаалакь апозициа ахь",
    "gui.howtos.make-music.step_GameChangeColor": "Иԥсахтәуп аԥштәы",
    "gui.howtos.make-music.step_ResetScore": "Иқәгатәуп аԥхьаӡа",
    "gui.howtos.make-it-fly.name": "Ишәырԥыр",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Иалышәх Аҿаԥшыра «Ажәҩан»",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Иалышәх Аперсонаж",
    "gui.howtos.fly.step_stepflySaySomething": "Ишәҳәа џьара акы",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Шәеиҭаҵла ахыц зну акнопкақәа рыла",
    "gui.howtos.fly.step_stepflyChooseObject": "Аизгараз иалышәх аобиект",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Аобиект еиҭаҵыртә иҟаҵатәуп",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Иалышәх Аперсонаж ",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Иацышәҵа аԥхьаӡара",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Аԥхьаӡара иацҵа",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Иацышәҵа апеизаж",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Еиҭажәгала апеизаж",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Анаҩстәи акостиум",
    "gui.howtos.pong": "Атеннис маҷ",
    "gui.howtos.pong.step_pongAddBackdrop": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.pong.step_pongAddBallSprite": "Дацҵатәуп Анагӡаҩ Ball (Ампыл)",
    "gui.howtos.pong.step_pongBounceAround": "Шәыԥала анахь-арахь",
    "gui.howtos.pong.step_pongAddPaddle": "Иацышәҵа аракетка",
    "gui.howtos.pong.step_pongMoveThePaddle": "Еиҭажәгала аракетка",
    "gui.howtos.pong.step_pongSelectBallSprite": "Далышәх Анагӡаҩ «Ампыл»",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Иацышәҵа акомандақәа ампыл аракетка ианԥартә азы",
    "gui.howtos.pong.step_pongAddAScore": "Иацышәҵа аԥхьаӡара",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Иалышәх ‘Аԥхьаӡара’ Амениу аҟынтәи",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Иацышәҵа аблок ‘Иԥсахтәуп Аԥхьаӡа’",
    "gui.howtos.pong.step_pongResetScore": "Иқәгатәуп аԥхьаӡара",
    "gui.howtos.pong.step_pongAddLineSprite": "Дацышәҵа Анагӡаҩ Line (аҵәаӷәа) ",
    "gui.howtos.pong.step_pongGameOver": "Ахәмарра Анҵәамҭа",
    "gui.howtos.code-cartoon": "Амультфильм Акод",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Иҳәатәуп Џьара акы Абираҟ иаҵәа Шәанақәыӷәӷәо",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Аперсонаж Шәанақәыӷәӷәалакь иара Анимациа азутәуп",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Иалышәх егьи Аперсонаж",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Шәхы Иашәырхәа Адырга Минус аобиект Аиҵатәраз",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Иҟашәҵа Аперсонаж Идухартәи Ихәыҷхартәи",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Иалышәх егьи Аперсонаж",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Иԥатәуп Аҩадеи Аладеи",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Шәақәыӷәӷәа Аперсонаж Асценақәа Рыԥсахразы",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Ашьшьыҳәа аргьежьра",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Акостиумқәа шәыԥсахла",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Иалышәх Еиҳаны Аперсонажқәа Шәмультик ахь Ацҵаразы",
    "gui.howtos.cartoon-network": "Ахәмарра - Ахҭыс Анимациа азутәуп",
    "gui.howtos.cartoon-network.step_CNcharacter": "Далх ицәырҵраны иҟоу афырхаҵа",
    "gui.howtos.cartoon-network.step_CNsay": "Ишәҳәа џьара акы",
    "gui.howtos.cartoon-network.step_CNglide": "Ашьшьыҳәа аргьежьра",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Иалышәх аобиект",
    "gui.howtos.cartoon-network.step_CNcollect": "Еизыжәгала аобиектқәа",
    "gui.howtos.cartoon-network.step_CNvariable": "Иаԥышәҵа Аԥхьаӡара азы Аҽеиҭак",
    "gui.howtos.cartoon-network.step_CNscore": "Аԥхьаӡара Иацҵала",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Аҩаӡара ҿыц: Ишәыԥсах Аҿаԥшыра",
    "gui.howtos.videosens.name": "Авидео Аиҩдыраара",
    "gui.howtos.videosens.step_addextension": "Иацҵатәуп арҭбаара",
    "gui.howtos.videosens.step_pet": "Ацгәы бжьатәуп",
    "gui.howtos.videosens.step_animate": "Анимациа азутәуп",
    "gui.howtos.videosens.step_pop": "Ашарик ԥжәатәуп",
    "gui.howtos.say-it-out-loud": "Иаԥҵатәуп ицәажәо анимациа",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Иацҵатәуп аблокқәа \"Атекст Ацәажәарахь\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Ишәҳәа џьара акы",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Иқәыргылатәуп Абжьы",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Игьежьлатәуп",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Иацҵатәуп Егьи Аперсонаж",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Иҳәатәуп ашәа",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Иԥсахтәуп аԥштәы",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Иргьежьтәуп",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Идухалатәуп нас Ихәыҷхалатәуп",
    "gui.howtos.talking": "Ицәажо Алакәқәа",
    "gui.howtos.talking.step_talesAddExtension": "Шәақәыӷәӷәа Иацҵатәуп Аблокқәа \"Атекст Ацәажәарахь\"",
    "gui.howtos.talking.step_talesChooseSprite": "Далхтәуп Анагӡаҩ",
    "gui.howtos.talking.step_talesSaySomething": "Аперсонаж Рцәажәатәуп",
    "gui.howtos.talking.step_talesChooseBackdrop": "Иалхтәуп Аҿаԥшыра",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Шәақәыӷәӷәа Аперсонаж Анаҩстәи Аҿаԥшыра ахь Аиасразы",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Далышәх егьи Анагӡаҩ",
    "gui.howtos.talking.step_talesMoveAround": "Игьежьлатәуп",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Иалышәх егьи Аҿаԥшыра",
    "gui.howtos.talking.step_talesAnimateTalking": "Ацәажәара Анимациа азутәуп",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Иалышәх егьи Аҿаԥшыра",
    "gui.howtos.talking.step_talesChooseSound": "Иалышәх Изцыкәашатәу Ашәа",
    "gui.howtos.talking.step_talesDanceMoves": "Акәашара азы Аиҭаҵрақәа",
    "gui.howtos.talking.step_talesAskAnswer": "Акатегориа Асенсорқәа рҟны иалышәх Аблокқәа Иазҵаатәуп-и Аҭак-и",
    "gui.howtos.add-sprite.name": "Дацышәҵа Анагӡаҩ",
    "gui.howtos.add-sprite.step_addSprite": "Дацышәҵа Анагӡаҩ",
    "gui.howtos.add-a-backdrop.name": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Иацышәҵа Аҿаԥшыра",
    "gui.howtos.change-size.name": "Иԥсахтәуп ашәагаа",
    "gui.howtos.change-size.step_changeSize": "Иԥсахтәуп ашәагаа",
    "gui.howtos.glide-around.name": "Ашьшьыҳәа аргьежьра",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Ашьшьыҳәа аргьежьра",
    "gui.howtos.change-size.step_glideAroundPoint": "Акәаԥ ахь ақәҵәраара",
    "gui.howtos.record-a-sound.name": "Иҭаҩтәуп Абжьы",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Шәақәыӷәӷәа ‘Абжьқәа’ ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Шәақәыӷәӷәа 'Иҭаҩтәуп'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Шәақәыӷәӷәа акнопка Иҭаҩтәуп",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Иалышәх ишәҭаху Абжьы",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Ишәырга Абжьы",
    "gui.howtos.spin-video.name": "Иҟаҵатәуп игьежьлартә",
    "gui.howtos.change-size.step_spinTurn": "Инашәырҳәы",
    "gui.howtos.change-size.step_spinPointInDirection": "Иқәыргылатәуп ахырхарҭа",
    "gui.howtos.hide-and-show.name": "Иҵәахтәуп нас иаарԥштәуп",
    "gui.howtos.change-size.step_hideAndShow": "Иҵәахтәуп нас иаарԥштәуп",
    "gui.howtos.switch-costume.name": "Анагӡаҩ Анимациа изутәуп",
    "gui.howtos.change-size.step_switchCostumes": "Анагӡаҩ анимациа изутәуп",
    "gui.howtos.move-around-with-arrow-keys.name": "Ихархәатәуп ахыц зну аклавишақәа",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Аиҭаҵра армарахьи арӷьарахьи",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Аиҭаҵра аҩадеи аладеи",
    "gui.howtos.add-effects.name": "Иацышәҵа аеффектқәа",
    "gui.howtos.videosens.step_addEffects": "Иацҵа аеффектқәа",
    "gui.extension.music.name": "Амузыка",
    "gui.extension.music.description": "Ихәмартәуп амаругақәеи адаулқәеи рҟны.",
    "gui.extension.pen.name": "Акалам",
    "gui.extension.pen.description": "Иҭышәхла анагӡаҩцәа рыла.",
    "gui.extension.videosensing.name": "Авидео Аиҩдыраара",
    "gui.extension.videosensing.description": "Авидеокамера аҟынтәи аиҭаҵра аиҩдыраара.",
    "gui.extension.text2speech.name": "Атекст Ацәажәарахь",
    "gui.extension.text2speech.description": "Шәпроектқәа аԥсы рхашәҵа бжьыла.",
    "gui.extension.translate.name": "Еиҭагатәуп",
    "gui.extension.translate.description": "Еиҭажәгала атекст егьырҭ абызшәақәа рахь.",
    "gui.extension.makeymakey.description": "Иарбанзаалакь акы иалхтәуп ацаԥха.",
    "gui.extension.microbit.description": "Шәпроектқәа адунеи иашәырдыр.",
    "gui.extension.microbit.connectingMessage": "Аимадара",
    "gui.extension.ev3.description": "Иаԥышәҵала аинтерактивтә роботқәеи егьырҭ аобиектқәеи.",
    "gui.extension.ev3.connectingMessage": "Аҿакра. Агәра жәга, EV3  аҟны pin-код 1234 шықәыргылоу.   ",
    "gui.extension.boost.description": "Аробот аԥсы ахашәҵа",
    "gui.extension.boost.connectingMessage": "Аимадара",
    "gui.extension.wedo2.description": "Иаԥышәҵала амоторқәеи асенсорқәеи рхархәарала.",
    "gui.extension.wedo2.connectingMessage": "Аимадара",
    "gui.extension.gdxfor.description": "Иашәоит агәҭасрақәеи арҳәазареи рымчқәеи, аиҭаҵрақәеи аргьежьрақәеи.",
    "gui.extension.gdxfor.connectingMessage": "Аимадара",
    "gui.libraryTags.all": "Зегьы",
    "gui.libraryTags.animals": "Аԥстәқәа",
    "gui.libraryTags.dance": "Акәашара",
    "gui.libraryTags.effects": "Аеффектқәа",
    "gui.libraryTags.fantasy": "Афантастика",
    "gui.libraryTags.fashion": "Амода",
    "gui.libraryTags.food": "Афатә",
    "gui.libraryTags.indoors": "Ауада аҩныҵҟа",
    "gui.libraryTags.loops": "Ациклқәа",
    "gui.libraryTags.music": "Амузыка",
    "gui.libraryTags.notes": "Азгәаҭақәа",
    "gui.libraryTags.outdoors": "Адәахьы",
    "gui.libraryTags.patterns": "Аузорқәа",
    "gui.libraryTags.people": "Ауаа",
    "gui.libraryTags.percussion": "Аперкуссиа",
    "gui.libraryTags.space": "Акосмос",
    "gui.libraryTags.sports": "Аспорт",
    "gui.libraryTags.underwater": "Аӡаҵаҟатәи адунеи",
    "gui.libraryTags.voice": "Абжьы",
    "gui.libraryTags.wacky": "Ахеилагақәа",
    "gui.libraryTags.animation": "Анимациа",
    "gui.libraryTags.art": "Аҟазара",
    "gui.libraryTags.games": "Ахәмаррақәа",
    "gui.libraryTags.stories": "Аҭоурыхқәа",
    "gui.libraryTags.letters": "Анбанқәа",
    "gui.opcodeLabels.direction": "ахырхарҭа",
    "gui.opcodeLabels.xposition": "x апозициа",
    "gui.opcodeLabels.yposition": "y апозициа",
    "gui.opcodeLabels.size": "ашәагаа",
    "gui.opcodeLabels.costumename": "акостиум ахьӡ",
    "gui.opcodeLabels.costumenumber": "акостиум аномер",
    "gui.opcodeLabels.backdropname": "аҿаԥшыра ахьӡ",
    "gui.opcodeLabels.backdropnumber": "аҿаԥшыра аномер",
    "gui.opcodeLabels.volume": "абжьы адура",
    "gui.opcodeLabels.tempo": "атемп",
    "gui.opcodeLabels.answer": "аҭак",
    "gui.opcodeLabels.loudness": "абжьы адура",
    "gui.opcodeLabels.username": "ахархәаҩ ихьӡ",
    "gui.opcodeLabels.year": "ашықәс",
    "gui.opcodeLabels.month": "амза",
    "gui.opcodeLabels.date": "арыцхә",
    "gui.opcodeLabels.dayofweek": "амчыбжь амш",
    "gui.opcodeLabels.hour": "асааҭ",
    "gui.opcodeLabels.minute": "аминуҭ",
    "gui.opcodeLabels.second": "асекунд",
    "gui.opcodeLabels.timer": "атаимер",
    "gui.projectLoader.loadError": "Иалху апроект афаил аҭагалара амуӡеит.",
    "gui.sharedMessages.backdrop": "аҿаԥшыра {index}",
    "gui.sharedMessages.costume": "акостиум {index}",
    "gui.sharedMessages.sprite": "Анагӡаҩ {index}",
    "gui.sharedMessages.pop": "апоп",
    "gui.sharedMessages.replaceProjectWarning": "Иалаԥсахтәума абри апроект аҵанакы?",
    "gui.sharedMessages.loadFromComputerTitle": "Иҭагалатәуп акомпиутер аҟынтәи",
    "gui.theme.default": "Аклассикатә",
    "gui.theme.dark": "Алашьцара",
    "gui.theme.highContrast": "Иҳараку аконтраст",
    "gui.gui.defaultProjectTitle": "Scratch Апроект",
    "boost.color.any": "иарбанзаалакь аԥштәы",
    "boost.color.black": "аиқәаҵәа",
    "boost.color.blue": "жәҩангәыԥштәы",
    "boost.color.green": "аиаҵәа",
    "boost.color.red": "аҟаԥшь",
    "boost.color.white": "ашкәакәа",
    "boost.color.yellow": "аҩеижь",
    "boost.getMotorPosition": "амотор [MOTOR_REPORTER_ID] апозициа ",
    "boost.getTiltAngle": "арнаара акәакь [TILT_DIRECTION]",
    "boost.motorDirection.backward": "анахь",
    "boost.motorDirection.forward": "арахь",
    "boost.motorDirection.reverse": "иԥсахтәуп ахырхарҭа",
    "boost.motorOff": " амотор [MOTOR_ID] аҿыхтәуп",
    "boost.motorOn": " амотор [MOTOR_ID] аҿактәуп",
    "boost.motorOnFor": "иаҿактәуп амотор [MOTOR_ID] [DURATION]  секундк  ",
    "boost.motorOnForRotation": "иаҿактәуп амотор [MOTOR_ID] [ROTATION]-нтә аргьежьра ала   ",
    "boost.seeingColor": "иаҳбома ақьырмыт [COLOR]? ",
    "boost.setLightHue": "иқәыргылатәуп  арлашага аԥштәы [HUE]",
    "boost.setMotorDirection": "иқәыргылатәуп амотор [MOTOR_ID] ахырхарҭа  [MOTOR_DIRECTION] аҟны  ",
    "boost.setMotorPower": "иқәыргылатәуп  [MOTOR_ID] аласра [POWER] % аҟны  ",
    "boost.tiltDirection.any": "иарбанзаалакь ",
    "boost.tiltDirection.down": "алада",
    "boost.tiltDirection.left": "армарахь",
    "boost.tiltDirection.right": "арӷьарахь",
    "boost.tiltDirection.up": "аҩада",
    "boost.whenColor": "ақьырмыт [COLOR] анаҳбо",
    "boost.whenTilted": "[TILT_DIRECTION_ANY] анырнаау",
    "ev3.beepNote": "анота [NOTE] ихәмартәуп [TIME] сек",
    "ev3.buttonPressed": "акнопка [PORT] иақәыӷәӷәоума?",
    "ev3.getBrightness": "ажжара",
    "ev3.getDistance": "ирыбжьоу",
    "ev3.getMotorPosition": "амотор [PORT] апозициа",
    "ev3.motorSetPower": "амотор [PORT] иқәыргылатәуп амчра [POWER] %",
    "ev3.motorTurnClockwise": "амотор [PORT] ыргьежьтәуп арахь [TIME] сек",
    "ev3.motorTurnCounterClockwise": "амотор [PORT] ыргьежьтәуп анахь [TIME] сек",
    "ev3.whenBrightnessLessThan": "ажжара < [DISTANCE] анакәу",
    "ev3.whenButtonPressed": "акнопка [PORT] ианақәыӷәӷәоу",
    "ev3.whenDistanceLessThan": "ирыбжьоу < [DISTANCE] анакәу",
    "gdxfor.getAcceleration": "аццакра [DIRECTION]",
    "gdxfor.getForce": "амч",
    "gdxfor.getSpin": "аргьежьра аласра [DIRECTION]",
    "gdxfor.getTilt": "анаара акәакь [TILT] ",
    "gdxfor.isFreeFalling": "икаҳауама?",
    "gdxfor.isTilted": "ирнааума [TILT]?",
    "gdxfor.pulled": "еиҵыхуп",
    "gdxfor.pushed": "иақәыӷәӷәоуп",
    "gdxfor.shaken": "ирҵысуп",
    "gdxfor.startedFalling": "акаҳара иалагеит",
    "gdxfor.tiltDirectionMenu.any": "иарбанзаалакь ",
    "gdxfor.tiltDirectionMenu.back": "ашьҭахьҟатәи",
    "gdxfor.tiltDirectionMenu.front": "аԥхьаҟатәи",
    "gdxfor.tiltDirectionMenu.left": "армарахьтәи",
    "gdxfor.tiltDirectionMenu.right": "арӷьарахьтәи",
    "gdxfor.turnedFaceDown": "инарҳәуп хаҿыла алада",
    "gdxfor.turnedFaceUp": "инарҳәуп хаҿыла аҩада",
    "gdxfor.whenForcePushedOrPulled": "амч ҳзырбо асенсор [PUSH_PULL] анакәу",
    "gdxfor.whenGesture": "[GESTURE] анакәу",
    "gdxfor.whenTilted": "[TILT] анырнаау",
    "makeymakey.downArrow": "ахыц алада",
    "makeymakey.downArrowShort": "алада",
    "makeymakey.leftArrow": "ахыц армарахь",
    "makeymakey.leftArrowShort": "армарахь",
    "makeymakey.rightArrow": "ахыц арӷьарахь",
    "makeymakey.rightArrowShort": "арӷьарахь",
    "makeymakey.spaceKey": "абжьажьга",
    "makeymakey.upArrow": "ахыц аҩада",
    "makeymakey.upArrowShort": "аҩада",
    "makeymakey.whenKeyPressed": "аклавиша [KEY] ианақәыӷәӷәоу",
    "makeymakey.whenKeysPressedInOrder": "еишьҭаргыланы [SEQUENCE] ақәыӷәӷәараан",
    "microbit.buttonsMenu.any": "иарбанзаалакь",
    "microbit.clearDisplay": "ирыцқьатәуп аекран",
    "microbit.defaultTextToDisplay": "Салам!",
    "microbit.displaySymbol": "иаарԥштәуп [MATRIX]",
    "microbit.displayText": "иаарԥштәуп атекст [TEXT]",
    "microbit.gesturesMenu.jumped": "иԥеит",
    "microbit.gesturesMenu.moved": "инаскьагоуп",
    "microbit.gesturesMenu.shaken": "идырҵысит",
    "microbit.isButtonPressed": "акнопка [BTN] иақәыӷәӷәоума?",
    "microbit.isTilted": "ирнааума [DIRECTION]?",
    "microbit.pinStateMenu.off": "иаҿыхтәуп",
    "microbit.pinStateMenu.on": "иаҿактәуп",
    "microbit.tiltAngle": "арнаара акәакь [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "иарбанзаалакь",
    "microbit.tiltDirectionMenu.back": "шьҭахьҟа",
    "microbit.tiltDirectionMenu.front": "ԥхьаҟа",
    "microbit.tiltDirectionMenu.left": "армарахь",
    "microbit.tiltDirectionMenu.right": "арӷьарахь",
    "microbit.whenButtonPressed": "акнопка [BTN] ианақәыӷәӷәоу",
    "microbit.whenGesture": "[GESTURE] анакәу",
    "microbit.whenPinConnected": "апин [PIN] анаҿаку",
    "microbit.whenTilted": "[DIRECTION] анырнаау",
    "music.categoryName": "Амузыка",
    "music.changeTempo": "иԥсахтәуп атемп [TEMPO] ала",
    "music.drumBass": "(2) Абасстә даул",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Аклаве",
    "music.drumClosedHiHat": "(6) Иарку хаи-хет",
    "music.drumConga": "(14) Аконга",
    "music.drumCowbell": "(11) Аҵәҵәабжьы",
    "music.drumCrashCymbal": "(4) Асаанқәа рысра",
    "music.drumCuica": "(18) Акуика",
    "music.drumGuiro": "(16) Гуиро",
    "music.drumHandClap": "(8) Анапеинҟьабжь",
    "music.drumOpenHiHat": "(5) Иаарту хаи-хет",
    "music.drumSideStick": "(3) Аганахьтәи амаа",
    "music.drumSnare": "(1) Адаул хәыҷы",
    "music.drumTambourine": "(7) Атамбурин",
    "music.drumTriangle": "(12) Ахкәакь",
    "music.drumVibraslap": "(17) Авибрациа ҟазҵо аслеп",
    "music.drumWoodBlock": "(10) Амҿтәы шәындыҟәра хәҷы",
    "music.getTempo": "атемп",
    "music.instrumentBass": "(6) Абасс",
    "music.instrumentBassoon": "(14) Афагот",
    "music.instrumentCello": "(8) Авиолончель",
    "music.instrumentChoir": "(15) Ахор",
    "music.instrumentClarinet": "(10) Акларнет",
    "music.instrumentElectricGuitar": "(5) Аелектрогитара",
    "music.instrumentElectricPiano": "(2) Аелектро пианино",
    "music.instrumentFlute": "(12) Афлеита",
    "music.instrumentGuitar": "(4) Агитара",
    "music.instrumentMarimba": "(19) Маримба",
    "music.instrumentMusicBox": "(17) Амузыкатә шкатулка",
    "music.instrumentOrgan": "(3) Ауарӷан",
    "music.instrumentPiano": "(1) Афортепиано",
    "music.instrumentPizzicato": "(7) Апаццикато",
    "music.instrumentSaxophone": "(11) Асаксафон",
    "music.instrumentSteelDrum": "(18) Аџыртә даул",
    "music.instrumentSynthLead": "(20) Ихадоу асинтезатор",
    "music.instrumentSynthPad": "(21) Асинтезатор Pad",
    "music.instrumentTrombone": "(9) Атрамбон",
    "music.instrumentVibraphone": "(16) Авибрафон",
    "music.instrumentWoodenFlute": "(13) Амҿтәы флеита",
    "music.midiPlayDrumForBeats": "ихәмартәуп адаулқәа [DRUM] рҟны [BEATS] битк",
    "music.midiSetInstrument": "иԥсахтәуп амаруга [INSTRUMENT] ала",
    "music.playDrumForBeats": "ихәмартәуп адаулқәа [DRUM] рҟны [BEATS] битк",
    "music.playNoteForBeats": "анота [NOTE] ихәмартәуп [BEATS] тактк",
    "music.restForBeats": "ааҭгылара аамҭала [BEATS] битк",
    "music.setInstrument": "иқәыргылатәуп амаруга [INSTRUMENT] ",
    "music.setTempo": "иқәыргылатәуп атемп [TEMPO] ",
    "pen.categoryName": "Акалам",
    "pen.changeColorParam": "иԥсахтәуп акалам [COLOR_PARAM][VALUE] ала",
    "pen.changeHue": "иԥсахтәуп акалам аԥштәы [HUE] ала",
    "pen.changeShade": "иԥсахтәуп акалам агага [SHADE] ала",
    "pen.changeSize": "иԥсахтәуп акалам ашәагаа [SIZE] ала",
    "pen.clear": "ианыхтәуп зегьы",
    "pen.colorMenu.brightness": "ажжара",
    "pen.colorMenu.color": "аԥштәы",
    "pen.colorMenu.saturation": "аԥштәылгазаара",
    "pen.colorMenu.transparency": "аҵәцара",
    "pen.penDown": "акалам лашьҭтәуп",
    "pen.penUp": "акалам иҩахатәуп",
    "pen.setColor": "иқәыргылатәуп акалам аԥштәы [COLOR]",
    "pen.setColorParam": "иқәыргылатәуп акалам [COLOR_PARAM] [VALUE] аҟны",
    "pen.setHue": "иқәыргылатәуп акалам аԥштәы [HUE]",
    "pen.setShade": "иқәыргылатәуп акалам агага [SHADE]",
    "pen.setSize": "иқәыргылатәуп акалам ашәагаа [SIZE]",
    "pen.stamp": "аштамп",
    "speech.defaultWhenIHearValue": "иалагатәуп аиҭаҵра",
    "speech.extensionName": "Абжьы Атекст ахь ",
    "speech.listenAndWait": "Иӡырҩтәуп нас иԥштәуп",
    "speech.speechReporter": "ацәажәара",
    "speech.whenIHear": "Сара [PHRASE] ансаҳауа",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "Атекст Арцәажәара",
    "text2speech.defaultTextToSpeak": "салам",
    "text2speech.giant": "агигант",
    "text2speech.kitten": "ацгәы",
    "text2speech.setLanguageBlock": "иқәыргылатәуп абызшәа [LANGUAGE]",
    "text2speech.setVoiceBlock": "иқәыргылатәуп абжьы [VOICE]",
    "text2speech.speakAndWaitBlock": "иҳәатәуп [WORDS]",
    "text2speech.squeak": "аҷыжьбжьы",
    "text2speech.tenor": "атенор",
    "translate.categoryName": "Еиҭагатәуп",
    "translate.defaultTextToTranslate": "салам",
    "translate.translateBlock": "еиҭагатәуп [WORDS] [LANGUAGE] ахь",
    "translate.viewerLanguage": "абызшәа",
    "videoSensing.categoryName": "Авидео Аиҩдыраара",
    "videoSensing.direction": "ахырхарҭа",
    "videoSensing.motion": "аиҭаҵра",
    "videoSensing.off": "иаҿыхтәуп",
    "videoSensing.on": "иаҿактәуп",
    "videoSensing.onFlipped": "иаҿактәуп шьҭахьҟала",
    "videoSensing.setVideoTransparency": "иқәыргылатәуп авидео аҵәцара [TRANSPARENCY]",
    "videoSensing.sprite": "анагӡаҩ",
    "videoSensing.stage": "асцена",
    "videoSensing.videoOn": "авидео [ATTRIBUTE] [SUBJECT] аҟны",
    "videoSensing.videoToggle": "иаҿактәуп авидео [VIDEO_STATE] ",
    "videoSensing.whenMotionGreaterThan": "авидео аласра > [REFERENCE] анакәу",
    "wedo2.getDistance": "ирыбжьоу",
    "wedo2.getTiltAngle": "арнаара акәакь [TILT_DIRECTION]",
    "wedo2.isTilted": "ирнааума [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "анахь",
    "wedo2.motorDirection.forward": "арахь",
    "wedo2.motorDirection.reverse": "иԥсахтәуп ахырхарҭа",
    "wedo2.motorId.a": "амотор A",
    "wedo2.motorId.all": "амоторқәа зегьы",
    "wedo2.motorId.b": "амотор B",
    "wedo2.motorId.default": "амотор",
    "wedo2.motorOff": "иаҿыхтәуп [MOTOR_ID] ",
    "wedo2.motorOn": "иаҿактәуп [MOTOR_ID]",
    "wedo2.motorOnFor": "иаҿактәуп  [MOTOR_ID] [DURATION] сек",
    "wedo2.playNoteFor": "анота [NOTE] ихәмартәуп [DURATION] сек",
    "wedo2.setLightHue": "иқәыргылатәуп  арлашага аԥштәы [HUE]",
    "wedo2.setMotorDirection": "иқәыргылатәуп [MOTOR_ID] ахырхарҭа [MOTOR_DIRECTION] аҟны",
    "wedo2.startMotorPower": "иқәыргылатәуп [MOTOR_ID] амчра [POWER] аҟны",
    "wedo2.tiltDirection.any": "иарбанзаалакь ",
    "wedo2.tiltDirection.down": "алада",
    "wedo2.tiltDirection.left": "армарахь",
    "wedo2.tiltDirection.right": "арӷьарахь",
    "wedo2.tiltDirection.up": "аҩада",
    "wedo2.whenDistance": "ирыбжьоу [OP] [REFERENCE] анакәу",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY] анырнаау",
    "paint.paintEditor.hue": "Аԥштәы",
    "paint.paintEditor.saturation": "Аԥштәылгазаара",
    "paint.paintEditor.brightness": "Ажжара",
    "paint.paintEditor.costume": "Акостиум",
    "paint.paintEditor.group": "Иргәыԥтәуп",
    "paint.paintEditor.ungroup": "Аргәыԥра ықәгатәуп",
    "paint.paintEditor.undo": "Иаҟәыхтәуп",
    "paint.paintEditor.redo": "Ирхынҳәтәуп",
    "paint.paintEditor.forward": "Ԥхьаҟа",
    "paint.paintEditor.backward": "Шьҭахьҟа",
    "paint.paintEditor.front": "Аԥхьатәи аплан ахь",
    "paint.paintEditor.back": "Шьҭахьҟа",
    "paint.paintEditor.more": "Иҵегь",
    "paint.modeTools.brushSize": "Ашәагаа",
    "paint.modeTools.eraserSize": "Аныхга аҭбаара",
    "paint.modeTools.copy": "Акопиа ахыхтәуп",
    "paint.modeTools.paste": "Иҭаргылатәуп",
    "paint.modeTools.delete": "Ианыхтәуп",
    "paint.modeTools.curved": "Архәақәа рахь",
    "paint.modeTools.pointed": "Ирҵарқәоу рахь",
    "paint.modeTools.thickness": "Ашәпара",
    "paint.modeTools.flipHorizontal": "Горизонталла ианырԥшртәуп",
    "paint.modeTools.flipVertical": "Вертикалла ианырԥштәуп",
    "paint.modeTools.filled": "Иҭарҭәоу",
    "paint.modeTools.outlined": "Иҿыкәыршоу",
    "paint.paintEditor.bitmap": "Аконвертациа арастртә графика ахь",
    "paint.paintEditor.vector": "Аконвертациа авектортә графика ахь ",
    "paint.paintEditor.fill": "Аҭарҭәара",
    "paint.paintEditor.stroke": "Аконтур",
    "paint.brushMode.brush": "Ашәыга",
    "paint.eraserMode.eraser": "Аныхга",
    "paint.fillMode.fill": "Аҭарҭәара",
    "paint.lineMode.line": "Аҵәаӷәа",
    "paint.ovalMode.oval": "Агьежь",
    "paint.rectMode.rect": "Акәакьҭаиаша",
    "paint.reshapeMode.reshape": "Аформа аԥсахра",
    "paint.roundedRectMode.roundedRect": "Ихаргьежьу акәакьҭаиаша",
    "paint.selectMode.select": "Иалхтәуп",
    "paint.textMode.text": "Атекст",
    "paint.colorPicker.swap": "Иалаԥсахтәуп"
  },
  "af": {
    "gui.alerts.lostPeripheralConnection": "Scratch het verbinding met {extensionName} verloor .",
    "gui.alerts.tryAgain": "Probeer Weer",
    "gui.alerts.download": "Laai af",
    "gui.connection.reconnect": "Herverbind",
    "gui.backpack.costumeLabel": "kostuum",
    "gui.backpack.soundLabel": "klank",
    "gui.backpack.scriptLabel": "skrip",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Rugsak",
    "gui.backpack.errorBackpack": "Fout kom voor as rugsak laai",
    "gui.backpack.loadingBackpack": "Besig om te laai...",
    "gui.backpack.more": "Meer",
    "gui.backpack.emptyBackpack": "Rugsak is leeg",
    "gui.unsupportedBrowser.label": "Webblaaier word nie ondersteun nie",
    "gui.unsupportedBrowser.errorLabel": "'n Fout Het Voorgekom",
    "gui.unsupportedBrowser.notRecommended": "Ons is baie jammer, maar dit lyk asof jy 'n webblaaier weergawe gebruik wat nie deur Scratch ondersteun word nie. Ons stel voor dat jy na die nuutste weergawe van 'n ondersteunde webblaaier soos Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari opgradeer.",
    "gui.unsupportedBrowser.description": "Ons is baie jammer, maar Scratch ondersteun nie hierdie webblaaier nie. Ons stel voor dat jy na die nuutste weergawe van 'n ondersteunde webblaaier soos Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari opgradeer. ",
    "gui.unsupportedBrowser.back": "Terug",
    "gui.unsupportedBrowser.previewfaq": "Om meer te leer, gaan na die {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "AV",
    "gui.cards.all-tutorials": "Handleidings",
    "gui.cards.shrink": "Krimp",
    "gui.cards.expand": "Brei uit",
    "gui.cards.close": "Maak toe",
    "gui.cards.more-things-to-try": "Meer goed om te probeer!",
    "gui.cards.see-more": "Sien meer",
    "gui.comingSoon.message1": "Moet nie bekommer nie, ons is op dit {emoji}",
    "gui.comingSoon.message2": "Kom Binnekort...",
    "gui.comingSoon.message3": "Ons werk daaraan{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Geen toestelle kon gevind word",
    "gui.connection.auto-scanning.prescan": "Hou jou toestel byderhand, began dan soek.",
    "gui.connection.auto-scanning.pressbutton": "Druk die knoppie op jou toestel.",
    "gui.connection.auto-scanning.start-search": "Begin soek",
    "gui.connection.connecting-searchbutton": "Besig om te soek...",
    "gui.connection.auto-scanning.try-again": "Probeer weer",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Verbind",
    "gui.connection.disconnect": "Ontkoppel",
    "gui.connection.go-to-editor": "Gaan na Redigeerder",
    "gui.connection.connecting-cancelbutton": "Besig om te verbind...",
    "gui.connection.error.errorMessage": "Oeps, dit lyk asof iets skeefgeloop het.",
    "gui.connection.error.tryagainbutton": "Probeer weer",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Toestel naam",
    "gui.connection.connect": "Verbind",
    "gui.connection.scanning.lookingforperipherals": "Soek vir toestelle",
    "gui.connection.scanning.noPeripheralsFound": "Geen toestelle kon gevind word",
    "gui.connection.scanning.instructions": "Kies jou toestel uit die bostaande lys uit.",
    "gui.connection.search": "Verfris",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Maak seker dat Scratch Link geïnstalleer is en dat dit hardloop",
    "gui.connection.unavailable.enablebluetooth": "Maak seker Bluetooth is geaktiveer",
    "gui.connection.unavailable.tryagainbutton": "Probeer weer",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Gaan",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oeps! Iets het skeefgeloop.",
    "gui.crashMessage.description": "Ons is so jammer, maar dit lyk asof Scratch gebom het. Hierdie gogga is outomaties aan die Scratch Span gerapporteer. Verfris asseblief die bladsy om weer te probeer.",
    "gui.crashMessage.errorNumber": "Jou fout is aangeteken met id {errorId}",
    "gui.crashMessage.reload": "Herlaai",
    "gui.customProcedures.myblockModalTitle": "Skep ’n Blok",
    "gui.customProcedures.addAnInputNumberText": "Voeg 'n invoer by",
    "gui.customProcedures.numberTextType": "nommer of teks",
    "gui.customProcedures.addAnInputBoolean": "Voeg 'n invoer by",
    "gui.customProcedures.booleanType": "boolees",
    "gui.customProcedures.addALabel": "Voeg 'n etiket by",
    "gui.customProcedures.runWithoutScreenRefresh": "Hardloop sonder skermverfrissing",
    "gui.customProcedures.cancel": "Kanselleer",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Rigting",
    "gui.directionPicker.rotationStyles.allAround": "Al in die rondte",
    "gui.directionPicker.rotationStyles.leftRight": "Links/Regs",
    "gui.directionPicker.rotationStyles.dontRotate": "Moet nie roteer nie",
    "gui.gui.addExtension": "Voeg Uitbreiding By",
    "gui.gui.codeTab": "Kode",
    "gui.gui.backdropsTab": "Agtergronde",
    "gui.gui.costumesTab": "Kostuums",
    "gui.gui.soundsTab": "Klanke",
    "gui.extensionLibrary.comingSoon": "Kom Binnekort",
    "gui.extensionLibrary.requires": "Vereis",
    "gui.extensionLibrary.collaboration": "Samewerking met",
    "gui.library.filterPlaceholder": "Soek",
    "gui.library.allTag": "Alles",
    "gui.loader.message1": "Besig om blokke te skep ...",
    "gui.loader.message2": "Besig om sprites te laai ...",
    "gui.loader.message3": "Besig om klanke te laai ...",
    "gui.loader.message4": "Besig om uitbreidings te laai ...",
    "gui.loader.message5": "Kry die katte bymekaar ...",
    "gui.loader.message6": "Stuur vir nanos ...",
    "gui.loader.message7": "Blaas gou gobos op ...",
    "gui.loader.message8": "Berei emojis voor...",
    "gui.loader.headline": "Besig om Projek te laai",
    "gui.loader.creating": "Besig om projek te skep",
    "gui.accountMenu.profile": "Profiel",
    "gui.accountMenu.myStuff": "My Goed",
    "gui.accountMenu.myClasses": "My Klasse",
    "gui.accountMenu.myClass": "My Klas",
    "gui.accountMenu.accountSettings": "Rekeninginstellings",
    "gui.accountMenu.signOut": "Teken uit",
    "gui.authorInfo.byUser": "deur {username}",
    "gui.menuBar.seeProjectPage": "Sien Projek Blad",
    "gui.menuBar.language": "Language",
    "general.username": "Gebruikersnaam",
    "general.password": "Wagwoord",
    "general.signIn": "Teken in",
    "login.needHelp": "Kort hulp?",
    "form.validationRequired": "Die veld word vereis",
    "gui.menuBar.tutorialsLibrary": "Handleidings",
    "gui.menuBar.restoreSprite": "Herstel Sprite",
    "gui.menuBar.restoreSound": "Herstel Klank",
    "gui.menuBar.restoreCostume": "Herstel Kostuum",
    "gui.menuBar.restore": "Herstel",
    "gui.menuBar.saveNow": "Stoor nou",
    "gui.menuBar.saveAsCopy": "Stoor as 'n kopie",
    "gui.menuBar.remix": "Hermeng",
    "gui.menuBar.new": "Nuut",
    "gui.menuBar.file": "Lêer",
    "gui.menuBar.downloadToComputer": "Stoor op jou rekenaar",
    "gui.menuBar.edit": "Redigeer",
    "gui.menuBar.turboModeOff": "Skakel Turbo Modus af",
    "gui.menuBar.turboModeOn": "Skakel Turbo Modus aan",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Sluit aan by Scratch",
    "gui.menuBar.signIn": "Teken in",
    "gui.gui.projectTitlePlaceholder": "Projek titel hier",
    "gui.menuBar.saveNowLink": "Stoor Nou",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Gedeel",
    "gui.menuBar.share": "Deel",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Help",
    "gui.modal.back": "Terug",
    "gui.monitor.listMonitor.empty": "(leeg)",
    "gui.monitor.listMonitor.listLength": "lengte {length}",
    "gui.monitor.contextMenu.default": "normale uitlees",
    "gui.monitor.contextMenu.large": "groot uitlees",
    "gui.monitor.contextMenu.slider": "skuifbalk",
    "gui.monitor.contextMenu.sliderRange": "verander skuifreeks",
    "gui.monitor.contextMenu.import": "voer in",
    "gui.monitor.contextMenu.export": "voer uit",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Speel",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Vir alle sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Slegs vir hierdie sprite",
    "gui.gui.cloudVariableOption": "Wolk veranderlike (op bediener gestoor)",
    "gui.gui.variablePromptAllSpritesMessage": "Hierdie veranderlike sal vir alle sprites beskikbaar wees.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Kanselleer",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Speel",
    "gui.playbackStep.loadingMsg": "Besig om te laai...",
    "gui.playbackStep.saveMsg": "Stoor",
    "gui.playbackStep.reRecordMsg": "Heropneem",
    "gui.recordModal.title": "Neem Klank op",
    "gui.recordingStep.beginRecord": "Kliek op die onderstaande knoppie om te begin opneem. ",
    "gui.recordingStep.permission": "{arrow} Ons het jou toestemming nodig om jou mikrofoon te gebruik",
    "gui.recordingStep.stop": "Hou op opneem",
    "gui.recordingStep.record": "Neem op",
    "gui.sliderModal.min": "Minimum waarde",
    "gui.sliderModal.max": "Maksimum waarde",
    "gui.sliderModal.title": "Verander skuifreeks",
    "gui.sliderPrompt.cancel": "Kanselleer",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Klank",
    "gui.soundEditor.play": "Speel",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Kopieer",
    "gui.soundEditor.paste": "Plak",
    "gui.soundEditor.copyToNew": "Kopieer na Nuut",
    "gui.soundEditor.delete": "Skrap",
    "gui.soundEditor.save": "Stoor",
    "gui.soundEditor.undo": "Ontdoen",
    "gui.soundEditor.redo": "Herdoen",
    "gui.soundEditor.faster": "Vinniger",
    "gui.soundEditor.slower": "Stadiger",
    "gui.soundEditor.echo": "Eggo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Harder",
    "gui.soundEditor.softer": "Sagter",
    "gui.soundEditor.reverse": "Keer om",
    "gui.soundEditor.fadeOut": "Uitdoof",
    "gui.soundEditor.fadeIn": "Indoof",
    "gui.soundEditor.mute": "Demp",
    "gui.SpriteInfo.spritePlaceholder": "Naam",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Vertoon",
    "gui.SpriteInfo.size": "Grootte",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dupliseer",
    "gui.spriteSelectorItem.contextMenuExport": "voer uit",
    "gui.spriteSelectorItem.contextMenuDelete": "skrap",
    "gui.spriteSelector.addSpriteFromLibrary": "Kies 'n Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Verf",
    "gui.spriteSelector.addSpriteFromSurprise": "Verrassing",
    "gui.spriteSelector.addSpriteFromFile": "Laai Sprite op",
    "gui.stageHeader.stageSizeLarge": "Ruil na groot verhoog",
    "gui.stageHeader.stageSizeSmall": "Ruil na klein verhoog",
    "gui.stageHeader.stageSizeFull": "Gaan na volskermmodus",
    "gui.stageHeader.stageSizeUnFull": "Verlaat volskermmodus",
    "gui.stageHeader.fullscreenControl": "Volskerm Beheer",
    "gui.spriteSelector.addBackdropFromLibrary": "Kies 'n Agtergrond",
    "gui.stageSelector.addBackdropFromPaint": "Verf",
    "gui.stageSelector.addBackdropFromSurprise": "Verrassing",
    "gui.stageSelector.addBackdropFromFile": "Laai Agtergrond op",
    "gui.stageSelector.stage": "Verhoog",
    "gui.stageSelector.backdrops": "Agtergronde",
    "gui.telemetryOptIn.label": "Rapporteer statistieke om Scratch te verbeter",
    "gui.telemetryOptIn.body1": "Die Scratch Span probeer altyd om beter te verstaan hoe Scratch regoor die wêreld gebruik word. Om hierdie poging te ondersteun, kan jy Scratch toelaat om outomaties gebruiksinligting vir die Scratch Span te stuur.",
    "gui.telemetryOptIn.body2": "Die inligting wat ons versamel sluit taalkeuse, blokgebruik, en gebeurtenisse soos stoor, laai, en oplaai van 'n projek. Ons samel NIE enige persoonlike inligting in NIE. Sien asseblief ons {privacyPolicyLink} vir meer inligting.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privaatheidsbeleid",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo Modus",
    "gui.webglModal.label": "Jou Webblaaier Ondersteun Nie WebGL Nie",
    "gui.webglModal.description": "Ongelukkig wil dit voorkom dat jou webblaaier of rekenaar {webGlLink}. Hierdie tegnologie word benodig om Scratch 3.0 te laat hardloop.",
    "gui.webglModal.webgllink": "WebGL word nie ondersteun nie",
    "gui.webglModal.back": "Terug",
    "gui.webglModal.previewfaq": "Om meer te leer, gaan na die {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "AV",
    "gui.costumeLibrary.chooseABackdrop": "Kies 'n Agtergrond",
    "gui.costumeLibrary.chooseACostume": "Kies 'n Kostuum",
    "gui.costumeTab.addBackdropFromLibrary": "Kies 'n Agtergrond",
    "gui.costumeTab.addCostumeFromLibrary": "Kies 'n Kostuum",
    "gui.costumeTab.addBlankCostume": "Verf",
    "gui.costumeTab.addSurpriseCostume": "Verrassing",
    "gui.costumeTab.addFileBackdrop": "Laai Agtergrond op",
    "gui.costumeTab.addFileCostume": "Laai Kostuum Op",
    "gui.extensionLibrary.chooseAnExtension": "Kies 'n Uitbreiding",
    "gui.extensionLibrary.extensionUrl": "Tik die URL van die uitbreiding in",
    "gui.monitors.importListColumnPrompt": "Watter kolom moet gebruik word (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Kon nie begin opneem nie",
    "gui.soundLibrary.chooseASound": "Kies 'n Klank",
    "gui.soundTab.fileUploadSound": "Laai Klank Op",
    "gui.soundTab.surpriseSound": "Verrassing",
    "gui.soundTab.recordSound": "Neem op",
    "gui.soundTab.addSoundFromLibrary": "Kies 'n Klank",
    "gui.spriteLibrary.chooseASprite": "Kies 'n Sprite",
    "gui.tipsLibrary.tutorials": "Kies 'n Handleiding",
    "gui.alerts.createsuccess": "Nuwe projek geskep.",
    "gui.alerts.createcopysuccess": "Projek as 'n kopie gestoor.",
    "gui.alerts.createremixsuccess": "Projek as 'n hermengsel gestoor.",
    "gui.alerts.creating": "Skep nuwe...",
    "gui.alerts.creatingCopy": "Kopieer projek...",
    "gui.alerts.creatingRemix": "Hermeng projek",
    "gui.alerts.creatingError": "Kon nie die projek skep nie. Probeer asseblief weer!",
    "gui.alerts.savingError": "Projek kon nie stoor nie.",
    "gui.alerts.savesuccess": "Projek is gestoor.",
    "gui.alerts.saving": "Besig om projek te stoor...",
    "gui.alerts.cloudInfo": "Neem asseblief kennis, wolk veranderlikes ondersteun slegs nommers, nie letters of simbole nie. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Leer meer.",
    "gui.alerts.importing": "Besig om in te voer...",
    "gui.defaultProject.meow": "Miaau",
    "gui.defaultProject.variable": "my veranderlike",
    "gui.howtos.intro-move-sayhello-hat.name": "Kom aan die gang",
    "gui.howtos.intro-move.step_stepMove": "Voeg 'n beweegblok by",
    "gui.howtos.add-a-move-block.step_stepSay": "Voeg spraakblok by",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Kliek op die groen vlag om te begin",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animeer 'n Naam",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Kies 'n Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Speel 'n Klank Wanneer Gekliek Word",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Kies Nog 'n Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Verander kleur",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Kies 'n Ander Letter Sprite & Laat Dit Draai",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Kies 'n Ander Letter Sprite & Laat Dit Groei",
    "gui.howtos.imagine": "Verbeel 'n Wêreld",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tik Wat Jy Wil Sê",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Kliek op die Groen Vlag om te Begin",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Kies Enige Agtergrond",
    "gui.howtos.imagine.step_imagineChooseSprite": "Kies Enige Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Druk die Spasiebalk om te gly",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Kies 'n Ander Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Skuif Links-Regs",
    "gui.howtos.imagine.step_imagineUpDown": "Skuif Op-Af",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Verander Kostuums",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Gly na 'n Punt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Groei en Krimp",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Kies 'n Ander Agtergrond",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Ruil Agtergronde",
    "gui.howtos.imagine.step_imagineRecordASound": "Voeg 'n Klank By",
    "gui.howtos.imagine.step_imagineChooseSound": "Kies Jou Klank",
    "gui.howtos.make-music.name": "Maak Musiek",
    "gui.howtos.Make-Music.step_PickInstrument": "Kies 'n Instrument Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Speel Klank Wanneer Gekliek Word",
    "gui.howtos.Make-Music.step_MakeSong": "Skep 'n Liedjie",
    "gui.howtos.make-music.step_MakeBeat": "Kies 'n Trom en Skep 'n Maatslag",
    "gui.howtos.make-music.step_MakeBeatBox": "Kies die Mikrofoon Sprite & Verrassings Blêrboks",
    "gui.howtos.story.name": "Skep 'n Storie",
    "gui.howtos.story.step_addbg": "Voeg 'n Agtergrond by",
    "gui.howtos.story.step_addsprite": "Voeg 'n Karakter by",
    "gui.howtos.story.step_saysomething": "Sê Iets",
    "gui.howtos.story.step_addanothersprite": "Voeg 'n Ander Karakter by",
    "gui.howtos.story.step_flip": "Keer Rigting om",
    "gui.howtos.story.step_conversation": "Gesels",
    "gui.howtos.story.addanotherbg": "Voeg 'n Ander Agtergrond by",
    "gui.howtos.story.step_swithbg": "Ruil Agtergronde",
    "gui.howtos.story.step_hidewizard": "Versteek 'n Karakter",
    "gui.howtos.story.step_showwizard": "Wys 'n Karakter",
    "gui.howtos.make-a-chase-game.name": "Skep 'n Jaag Speletjie",
    "gui.howtos.Chase-Game.step_BG": "Voeg 'n Agtergrond by",
    "gui.howtos.chase-game.step_AddOcto": "Voeg 'n Sprite by",
    "gui.howtos.make-music.step_LeftRight": "Beweeg Regs & Links Met Pyl Sleutels",
    "gui.howtos.Chase-Game.step_UpDown": "Beweeg Op & Af Met Pyl Sleutels",
    "gui.howtos.Chase-Game.step_AddStar": "Voeg Nog 'n Sprite By",
    "gui.howtos.Chase-Game.step_MoveRandom": "Beweeg Lukraak",
    "gui.howtos.Chase-Game.step_WhenTouch": "In Seekat Sprite, Speel Klank as Geraak Word",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Skep Telling Veranderlike",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In Seekat Sprite, Voeg Telling By As Geraak Word ",
    "gui.howtos.animate-char.name": "Animeer 'n Karakter",
    "gui.howtos.animate-char.step_addbg": "Voeg 'n Agtergrond by",
    "gui.howtos.animate-char.step_addsprite": "Voeg 'n Sprite by",
    "gui.howtos.animate-char.step_saysomething": "Sê Iets",
    "gui.howtos.animate-char.step_addsound": "Voeg Klank By",
    "gui.howtos.animate-char.step_animatetalking": "Animeer Praat",
    "gui.howtos.animate-char.step_arrowkeys": "Beweeg Deur Die Pyl Sleutels Te Gebruik",
    "gui.howtos.animate-char.step_jump": "Spring",
    "gui.howtos.animate-char.step_changecolor": "Verander Kleur",
    "gui.howtos.make-a-game.name": "Skep 'n Kliekker Speletjie",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Kies 'n Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Speel Klank Wanneer Gekliek Word",
    "gui.howtos.make-a-game.step_GameAddScore": "Skep Telling Veranderlike",
    "gui.howtos.make-a-game.step_GameChangeScore": "Verhoog Telling Wanneer Gekliek Word",
    "gui.howtos.make-a-game.step_Random": "Gaan na 'n ewekansige posisie",
    "gui.howtos.make-music.step_GameChangeColor": "Verander Kleur",
    "gui.howtos.make-music.step_ResetScore": "Herstel Telling",
    "gui.howtos.make-it-fly.name": "Laat dit Vlieg",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Kies 'n Lug Agtergrond",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Kies 'n Karakter",
    "gui.howtos.fly.step_stepflySaySomething": "Sê Iets",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Beweeg Met Pyltjie Sleutels",
    "gui.howtos.fly.step_stepflyChooseObject": "Kies 'n Voorwerp om te Gaan Haal",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Laat die Voorwerp Beweeg",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Kies Jou Karakter",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Voeg 'n Telling By",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Hou Telling",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Voeg Dekor By",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Skuif die Dekor",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Volgende Kostuum",
    "gui.howtos.pong": "Pong Speletjie",
    "gui.howtos.pong.step_pongAddBackdrop": "Voeg 'n Agtergrond by",
    "gui.howtos.pong.step_pongAddBallSprite": "Voeg 'n Bal Sprite By",
    "gui.howtos.pong.step_pongBounceAround": "Hop Rond",
    "gui.howtos.pong.step_pongAddPaddle": "Voeg 'n Spaan By",
    "gui.howtos.pong.step_pongMoveThePaddle": "Skuif die Spaan",
    "gui.howtos.pong.step_pongSelectBallSprite": "Kies die Bal Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Voeg Kode by om die Bal van die Spaan af te Bons",
    "gui.howtos.pong.step_pongAddAScore": "Voeg 'n Telling By",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Kies 'Telling' van die Kieslys af",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Voeg die 'Verander Telling' Blok in",
    "gui.howtos.pong.step_pongResetScore": "Herstel Telling",
    "gui.howtos.pong.step_pongAddLineSprite": "Voeg die Lyn Sprite by",
    "gui.howtos.pong.step_pongGameOver": "Spel Verby",
    "gui.howtos.code-cartoon": "Kodeer 'n Spotprent",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sê Iets Wanneer Jy Op Die Groen Vlag Kliek",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animeer 'n Karakter As Jy Daarop Kliek",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Kies 'n Ander Karakter",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Gebruik 'n Minus Teken om Kleiner te Word",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Laat 'n Karakter Groei en Krimp",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Kies 'n Ander Karakter",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Spring Op en Af",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Kliek op 'n Karakter om die Tonele te Verander",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Gly Rond",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Verander Kostuums",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Kies Meer Karakters om by Jou Spotprent by te Voeg",
    "gui.howtos.cartoon-network": "Animeer 'n Avontuur Speletjie",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kies 'n Karakter om te Vertoon",
    "gui.howtos.cartoon-network.step_CNsay": "Sê Iets",
    "gui.howtos.cartoon-network.step_CNglide": "Gly Rond",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kies 'n Voorwerp om te Jaag",
    "gui.howtos.cartoon-network.step_CNcollect": "Versamel Voorwerpe",
    "gui.howtos.cartoon-network.step_CNvariable": "Skep 'n Telling Veranderlike",
    "gui.howtos.cartoon-network.step_CNscore": "Hou Telling",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Vlak Op: Verander Agtergrond",
    "gui.howtos.videosens.name": "Video Aanvoeling",
    "gui.howtos.videosens.step_addextension": "Voeg Uitbreiding By",
    "gui.howtos.videosens.step_pet": "Streel die Kat",
    "gui.howtos.videosens.step_animate": "Animeer",
    "gui.howtos.videosens.step_pop": "Bars 'n Ballon",
    "gui.howtos.say-it-out-loud": "Skep Animasies Wat Kan Praat",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Voeg die Teks by die Spraak blokke by",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sê Iets",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Kies 'n Stem",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Beweeg Rond",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Voeg 'n Agtergrond by",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Voeg 'n Ander Karakter by",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Voer 'n Liedjie op",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Verander Kleur",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Draai in die Rondte",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Groei en Krimp",
    "gui.howtos.talking": "Pratende Verhale",
    "gui.howtos.talking.step_talesAddExtension": "Kliek om Teks-na-Spraak Blokke by te Voeg",
    "gui.howtos.talking.step_talesChooseSprite": "Kies 'n Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Laat 'n Karakter Praat",
    "gui.howtos.talking.step_talesChooseBackdrop": "Kies 'n Agtergrond",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Kliek op 'n Karakter om na die Volgende Agtergrond te Gaan",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Kies 'n Ander Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Beweeg Rond",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Kies 'n Ander Agtergrond",
    "gui.howtos.talking.step_talesAnimateTalking": "Animeer Praat",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Kies 'n Ander Agtergrond",
    "gui.howtos.talking.step_talesChooseSound": "Kies 'n Liedjie om op te Dans",
    "gui.howtos.talking.step_talesDanceMoves": "Danspassies",
    "gui.howtos.talking.step_talesAskAnswer": "Kry die Vraag en Antwoord Blokke van die Aanvoeling Kategorie",
    "gui.howtos.add-sprite.name": "Voeg 'n Sprite by",
    "gui.howtos.add-sprite.step_addSprite": "Voeg 'n Sprite by",
    "gui.howtos.add-a-backdrop.name": "Voeg 'n Agtergrond by",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Voeg 'n Agtergrond by",
    "gui.howtos.change-size.name": "Verander Grootte",
    "gui.howtos.change-size.step_changeSize": "Verander Grootte",
    "gui.howtos.glide-around.name": "Gly Rond",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Gly Rond",
    "gui.howtos.change-size.step_glideAroundPoint": "Gly na 'n Punt",
    "gui.howtos.record-a-sound.name": "Neem 'n Klank Op",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Kliek op die 'Klanke' Oortjie",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Kliek 'Neem Op'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Druk die Neem Op Knoppie",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Kies Jou Klank",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Speel Jou Klank",
    "gui.howtos.spin-video.name": "Laat Dit Draai",
    "gui.howtos.change-size.step_spinTurn": "Draai",
    "gui.howtos.change-size.step_spinPointInDirection": "Stel Rigting",
    "gui.howtos.hide-and-show.name": "Verberg en Vertoon",
    "gui.howtos.change-size.step_hideAndShow": "Verberg en Vertoon",
    "gui.howtos.switch-costume.name": "Animeer 'n Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animeer 'n Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Gebruik Pyltjie Sleutels",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Beweeg Links en Regs",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Beweeg Op en Af",
    "gui.howtos.add-effects.name": "Voeg Effekte By",
    "gui.howtos.videosens.step_addEffects": "Voeg Effekte By",
    "gui.extension.music.name": "Musiek",
    "gui.extension.music.description": "Speel instrumente en tromme.",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Teken met jou sprites",
    "gui.extension.videosensing.name": "Video Aanvoeling",
    "gui.extension.videosensing.description": "Voel beweging met die kamera.",
    "gui.extension.text2speech.name": "Teks na Spraak",
    "gui.extension.text2speech.description": "Laat jou projekte praat.",
    "gui.extension.translate.name": "Vertaal",
    "gui.extension.translate.description": "Vertaal teks in baie tale.",
    "gui.extension.makeymakey.description": "Verander enige iets in 'n sleutel in.",
    "gui.extension.microbit.description": "Verbind jou projekte met die wêreld.",
    "gui.extension.microbit.connectingMessage": "Besig om te verbind",
    "gui.extension.ev3.description": "Bou interaktiewe robotte en meer.",
    "gui.extension.ev3.connectingMessage": "Besig om te verbind. Maak seker dat die pin op jou EV3 op 1234 gestel is.",
    "gui.extension.boost.description": "Laat robottiese skeppings lewe kry.",
    "gui.extension.boost.connectingMessage": "Besig om te verbind",
    "gui.extension.wedo2.description": "Bou met motors en sensors.",
    "gui.extension.wedo2.connectingMessage": "Besig om te verbind",
    "gui.extension.gdxfor.description": "Voel druk, trek, beweging en draai aan.",
    "gui.extension.gdxfor.connectingMessage": "Besig om te verbind",
    "gui.libraryTags.all": "Alles",
    "gui.libraryTags.animals": "Diere",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Effekte",
    "gui.libraryTags.fantasy": "Fantasie",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Kos",
    "gui.libraryTags.indoors": "Binnenshuis",
    "gui.libraryTags.loops": "Lusse",
    "gui.libraryTags.music": "Musiek",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Buite",
    "gui.libraryTags.patterns": "Patrone",
    "gui.libraryTags.people": "Mense",
    "gui.libraryTags.percussion": "Perkussie",
    "gui.libraryTags.space": "Ruimte",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Onderwater",
    "gui.libraryTags.voice": "Stem",
    "gui.libraryTags.wacky": "Verspot",
    "gui.libraryTags.animation": "Animasie",
    "gui.libraryTags.art": "Kuns",
    "gui.libraryTags.games": "Speletjies",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "rigting",
    "gui.opcodeLabels.xposition": "x posisie",
    "gui.opcodeLabels.yposition": "y posisie",
    "gui.opcodeLabels.size": "grootte",
    "gui.opcodeLabels.costumename": "kostuumnaam",
    "gui.opcodeLabels.costumenumber": "kostuumnommer",
    "gui.opcodeLabels.backdropname": "agtergrondnaam",
    "gui.opcodeLabels.backdropnumber": "agtergrondnommer",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "antwoord",
    "gui.opcodeLabels.loudness": "hardheid",
    "gui.opcodeLabels.username": "gebruikersnaam",
    "gui.opcodeLabels.year": "jaar",
    "gui.opcodeLabels.month": "maand",
    "gui.opcodeLabels.date": "datum",
    "gui.opcodeLabels.dayofweek": "dag van die week",
    "gui.opcodeLabels.hour": "uur",
    "gui.opcodeLabels.minute": "minuut",
    "gui.opcodeLabels.second": "sekonde",
    "gui.opcodeLabels.timer": "tydhouer",
    "gui.projectLoader.loadError": "Die projekleêr wat gekies is, kon nie laai nie",
    "gui.sharedMessages.backdrop": "agtergrond {index}",
    "gui.sharedMessages.costume": "kostuum {index}",
    "gui.sharedMessages.sprite": "Sprite {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Vervang inhoud van die huidige projek?",
    "gui.sharedMessages.loadFromComputerTitle": "Laai van jou rekenaar",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Projek",
    "boost.color.any": "enige kleur",
    "boost.color.black": "swart",
    "boost.color.blue": "blou",
    "boost.color.green": "groen",
    "boost.color.red": "rooi",
    "boost.color.white": "wit",
    "boost.color.yellow": "geel",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] posisie",
    "boost.getTiltAngle": "kantel hoek [TILT_DIRECTION]",
    "boost.motorDirection.backward": "soontoe",
    "boost.motorDirection.forward": "hierdie kant toe",
    "boost.motorDirection.reverse": "agteruit",
    "boost.motorOff": "skakel motor  [MOTOR_ID] af",
    "boost.motorOn": "skakel motor [MOTOR_ID] aan",
    "boost.motorOnFor": "skakel motor [MOTOR_ID] aan vir [DURATION] sekondes",
    "boost.motorOnForRotation": "skakel motor [MOTOR_ID] aan vir [ROTATION] rotasies",
    "boost.seeingColor": "sien [COLOR] baksteen?",
    "boost.setLightHue": "stel ligkleur na [HUE]",
    "boost.setMotorDirection": "stel motor [MOTOR_ID] rigting [MOTOR_DIRECTION]",
    "boost.setMotorPower": "stel motor [MOTOR_ID] spoed na [POWER] %",
    "boost.tiltDirection.any": "enige",
    "boost.tiltDirection.down": "af",
    "boost.tiltDirection.left": "links",
    "boost.tiltDirection.right": "regs",
    "boost.tiltDirection.up": "op",
    "boost.whenColor": "wanneer [COLOR] baksteen gesien word",
    "boost.whenTilted": "wanneer gekantel  [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "biep noot [NOTE] vir [TIME] sekondes",
    "ev3.buttonPressed": "knoppie [PORT] gedruk?",
    "ev3.getBrightness": "helderheid",
    "ev3.getDistance": "afstand",
    "ev3.getMotorPosition": "motor [PORT] posisie",
    "ev3.motorSetPower": "motor [PORT] stel krag [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] draai hierdie kant toe vir [TIME] sekondes",
    "ev3.motorTurnCounterClockwise": "motor [PORT] draai soontoe vir [TIME] sekondes",
    "ev3.whenBrightnessLessThan": "wanneer helderheid < [DISTANCE]",
    "ev3.whenButtonPressed": "wanneer knoppie [PORT] gedruk word",
    "ev3.whenDistanceLessThan": "wanneer afstand < [DISTANCE]",
    "gdxfor.getAcceleration": "versnelling [DIRECTION]",
    "gdxfor.getForce": "krag",
    "gdxfor.getSpin": "draai spoed [DIRECTION]",
    "gdxfor.getTilt": "kantel hoek [TILT]",
    "gdxfor.isFreeFalling": "Besig om te val?",
    "gdxfor.isTilted": "Gekantel [TILT]?",
    "gdxfor.pulled": "getrek",
    "gdxfor.pushed": "gestoot",
    "gdxfor.shaken": "geskud",
    "gdxfor.startedFalling": "het begin val",
    "gdxfor.tiltDirectionMenu.any": "enige",
    "gdxfor.tiltDirectionMenu.back": "agterkant",
    "gdxfor.tiltDirectionMenu.front": "voorkant",
    "gdxfor.tiltDirectionMenu.left": "links",
    "gdxfor.tiltDirectionMenu.right": "regs",
    "gdxfor.turnedFaceDown": "met die gesig na onder gedraai",
    "gdxfor.turnedFaceUp": "met die gesig na bo gedraai",
    "gdxfor.whenForcePushedOrPulled": "wanneer krag sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "wanneer [GESTURE]",
    "gdxfor.whenTilted": "wanneer gekantel  [TILT]",
    "makeymakey.downArrow": "afwaartsepyl",
    "makeymakey.downArrowShort": "af",
    "makeymakey.leftArrow": "linkerpyl",
    "makeymakey.leftArrowShort": "links",
    "makeymakey.rightArrow": "regterpyl",
    "makeymakey.rightArrowShort": "regs",
    "makeymakey.spaceKey": "spasie",
    "makeymakey.upArrow": "opwaartsepyl",
    "makeymakey.upArrowShort": "op",
    "makeymakey.whenKeyPressed": "wanneer [KEY] sleutel gedruk word",
    "makeymakey.whenKeysPressedInOrder": "wanneer [SEQUENCE] in volgorde gedruk word",
    "microbit.buttonsMenu.any": "enige",
    "microbit.clearDisplay": "verwyder vertooning",
    "microbit.defaultTextToDisplay": "Hallo!",
    "microbit.displaySymbol": "vertoon [MATRIX]",
    "microbit.displayText": "vertoon teks [TEXT]",
    "microbit.gesturesMenu.jumped": "gespring",
    "microbit.gesturesMenu.moved": "geskuif",
    "microbit.gesturesMenu.shaken": "geskud",
    "microbit.isButtonPressed": "[BTN] knoppie gedruk?",
    "microbit.isTilted": "gekantel [DIRECTION]?",
    "microbit.pinStateMenu.off": "af",
    "microbit.pinStateMenu.on": "aan",
    "microbit.tiltAngle": "kantel hoek [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "enige",
    "microbit.tiltDirectionMenu.back": "agterkant",
    "microbit.tiltDirectionMenu.front": "voorkant",
    "microbit.tiltDirectionMenu.left": "links",
    "microbit.tiltDirectionMenu.right": "regs",
    "microbit.whenButtonPressed": "wanneer [BTN] knoppie gedruk word",
    "microbit.whenGesture": "wanneer [GESTURE]",
    "microbit.whenPinConnected": "wanneer pin [PIN] verbind is",
    "microbit.whenTilted": "wanneer [DIRECTION] gekantel",
    "music.categoryName": "Musiek",
    "music.changeTempo": "verander tempo met [TEMPO]",
    "music.drumBass": "(2) Bastrom",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Houtstokkies",
    "music.drumClosedHiHat": "Geslote Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Koeiklok",
    "music.drumCrashCymbal": "(4) Snel Simbaal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Handeklap",
    "music.drumOpenHiHat": "(5) Maak Hi-Hat oop",
    "music.drumSideStick": "(3) Systok",
    "music.drumSnare": "(1) Snaartrom",
    "music.drumTambourine": "(7) Tamboeryn",
    "music.drumTriangle": "(12) Driehoek",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Houtblok",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Tjello",
    "music.instrumentChoir": "(15) Koor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Elektriese Kitaar",
    "music.instrumentElectricPiano": "(2) Elektriese Klavier",
    "music.instrumentFlute": "(12) Fluit",
    "music.instrumentGuitar": "(4) Kitaar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Musiek Boks",
    "music.instrumentOrgan": "(3) Orrel",
    "music.instrumentPiano": "(1) Klavier",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofoon",
    "music.instrumentSteelDrum": "(18) Staaltrom",
    "music.instrumentSynthLead": "(20) Hoof Sintetiseerder",
    "music.instrumentSynthPad": "(21) Agtergrond Sintetiseerder",
    "music.instrumentTrombone": "(9) Tromboon",
    "music.instrumentVibraphone": "(16) Vibrafoon",
    "music.instrumentWoodenFlute": "(13) Houtfluit",
    "music.midiPlayDrumForBeats": "speel trom [DRUM] vir [BEATS] slae ",
    "music.midiSetInstrument": "stel instrument na [INSTRUMENT]",
    "music.playDrumForBeats": "speel drom [DRUM] vir [BEATS] slae",
    "music.playNoteForBeats": "speel noot [NOTE] vir [BEATS] slae ",
    "music.restForBeats": "rus vir [BEATS] slae",
    "music.setInstrument": "stel instrument op [INSTRUMENT]",
    "music.setTempo": "stel tempo op [TEMPO]",
    "pen.categoryName": "Pen",
    "pen.changeColorParam": "verander pen [COLOR_PARAM] met [VALUE]",
    "pen.changeHue": "verander pen kleur met [HUE]",
    "pen.changeShade": "Verander pen skakering met [SHADE]",
    "pen.changeSize": "verander pen grootte met [SIZE]",
    "pen.clear": "vee alles uit",
    "pen.colorMenu.brightness": "helderheid",
    "pen.colorMenu.color": "kleur",
    "pen.colorMenu.saturation": "versadiging",
    "pen.colorMenu.transparency": "deursigtigheid",
    "pen.penDown": "sit pen neer",
    "pen.penUp": "tel pen op",
    "pen.setColor": "stel pen kleur op [COLOR]",
    "pen.setColorParam": "stel pen [COLOR_PARAM] op [VALUE]",
    "pen.setHue": "stel pen kleur op [HUE]",
    "pen.setShade": "stel pen skakering op [SHADE]",
    "pen.setSize": "stel pen grootte op [SIZE]",
    "pen.stamp": "stempel",
    "speech.defaultWhenIHearValue": "Laat ons rol",
    "speech.extensionName": "Spraak na Teks",
    "speech.listenAndWait": "luister en wag",
    "speech.speechReporter": "spraak",
    "speech.whenIHear": "wanneer ek [PHRASE] hoor",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Teks na Spraak",
    "text2speech.defaultTextToSpeak": "hallo",
    "text2speech.giant": "reus",
    "text2speech.kitten": "katjie",
    "text2speech.setLanguageBlock": "stel taal op [LANGUAGE]",
    "text2speech.setVoiceBlock": "stel stem op [VOICE]",
    "text2speech.speakAndWaitBlock": "praat [WORDS]",
    "text2speech.squeak": "piep",
    "text2speech.tenor": "tenoor",
    "translate.categoryName": "Vertaal",
    "translate.defaultTextToTranslate": "hallo",
    "translate.translateBlock": "vertaal [WORDS] na [LANGUAGE]",
    "translate.viewerLanguage": "taal",
    "videoSensing.categoryName": "Video Aanvoeling",
    "videoSensing.direction": "rigting",
    "videoSensing.motion": "beweging",
    "videoSensing.off": "af",
    "videoSensing.on": "aan",
    "videoSensing.onFlipped": "omgekeer",
    "videoSensing.setVideoTransparency": "stel video deursigtigheid op [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "verhoog",
    "videoSensing.videoOn": "video [ATTRIBUTE] op [SUBJECT]",
    "videoSensing.videoToggle": "skakel video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "wanneer video beweging > [REFERENCE]",
    "wedo2.getDistance": "afstand",
    "wedo2.getTiltAngle": "kantel hoek [TILT_DIRECTION]",
    "wedo2.isTilted": "gekantel [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "soontoe",
    "wedo2.motorDirection.forward": "hierdie kant toe",
    "wedo2.motorDirection.reverse": "agteruit",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "skakel [MOTOR_ID] af",
    "wedo2.motorOn": "skakel [MOTOR_ID] aan",
    "wedo2.motorOnFor": "skakel [MOTOR_ID] aan vir [DURATION] sekondes ",
    "wedo2.playNoteFor": "speel noot [NOTE] vir [DURATION] sekondes",
    "wedo2.setLightHue": "stel ligkleur op [HUE]",
    "wedo2.setMotorDirection": "stel [MOTOR_ID] rigting op [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "stel [MOTOR_ID] krag op [POWER]",
    "wedo2.tiltDirection.any": "enige",
    "wedo2.tiltDirection.down": "af",
    "wedo2.tiltDirection.left": "links",
    "wedo2.tiltDirection.right": "regs",
    "wedo2.tiltDirection.up": "op",
    "wedo2.whenDistance": "wanneer afstand [OP] [REFERENCE]",
    "wedo2.whenTilted": "wanneer gekantel  [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kleur",
    "paint.paintEditor.saturation": "Versadiging",
    "paint.paintEditor.brightness": "Helderheid",
    "paint.paintEditor.costume": "Kostuum",
    "paint.paintEditor.group": "Groepeer",
    "paint.paintEditor.ungroup": "Ontgroepeer",
    "paint.paintEditor.undo": "Ontdoen",
    "paint.paintEditor.redo": "Herdoen",
    "paint.paintEditor.forward": "Vorentoe",
    "paint.paintEditor.backward": "Agteruit",
    "paint.paintEditor.front": "Voorkant",
    "paint.paintEditor.back": "Terug",
    "paint.paintEditor.more": "Meer",
    "paint.modeTools.brushSize": "Grootte",
    "paint.modeTools.eraserSize": "Uitveër grootte",
    "paint.modeTools.copy": "Kopie",
    "paint.modeTools.paste": "Plak",
    "paint.modeTools.delete": "Verwyder",
    "paint.modeTools.curved": "Kurwe",
    "paint.modeTools.pointed": "Punt",
    "paint.modeTools.thickness": "Dikte",
    "paint.modeTools.flipHorizontal": "Draai Horisontaal",
    "paint.modeTools.flipVertical": "Draai Vertikaal",
    "paint.modeTools.filled": "Gevul",
    "paint.modeTools.outlined": "Buitelyn ",
    "paint.paintEditor.bitmap": "Omskakel na Bitmap",
    "paint.paintEditor.vector": "Omskakel in Vektor",
    "paint.paintEditor.fill": "Vul",
    "paint.paintEditor.stroke": "Buitelyn",
    "paint.brushMode.brush": "Kwas",
    "paint.eraserMode.eraser": "Uitveër",
    "paint.fillMode.fill": "Vul",
    "paint.lineMode.line": "Lyn",
    "paint.ovalMode.oval": "Sirkel",
    "paint.rectMode.rect": "Reghoek",
    "paint.reshapeMode.reshape": "Hervorm",
    "paint.roundedRectMode.roundedRect": "Geronde Reghoek",
    "paint.selectMode.select": "Kies",
    "paint.textMode.text": "Teks",
    "paint.colorPicker.swap": "Ruil om"
  },
  "ar": {
    "gui.alerts.lostPeripheralConnection": "فقد سكراتش الاتصال مع {extensionName}.",
    "gui.alerts.tryAgain": "حاول ثانيةً",
    "gui.alerts.download": "تنزيل",
    "gui.connection.reconnect": "معاودة الاتصال",
    "gui.backpack.costumeLabel": "مظهر",
    "gui.backpack.soundLabel": "صوت",
    "gui.backpack.scriptLabel": "مقطع برمجي",
    "gui.backpack.spriteLabel": "كائن",
    "gui.backpack.header": "الحقيبة",
    "gui.backpack.errorBackpack": "خطأ في تحميل الحقيبة",
    "gui.backpack.loadingBackpack": "جارٍ التحميل...",
    "gui.backpack.more": "المزيد",
    "gui.backpack.emptyBackpack": "الحقيبة فارغة",
    "gui.unsupportedBrowser.label": "المتصفح غير مدعوم",
    "gui.unsupportedBrowser.errorLabel": "حدث خطأ",
    "gui.unsupportedBrowser.notRecommended": "نأسف للغاية، ولكن يبدو أنك تستخدم إصدارًا من المتصفح لا يدعمه سكراتش. نقترح التحديث إلى النسخة الأحدث من أحد المتصفحات التي يدعمها سكراتش مثل غوغل كروم أو موزيلا فايرفوكس أو مايكروسوفت إيدج أو أبل سفاري.",
    "gui.unsupportedBrowser.description": "نأسف للغاية، ولكن سكراتش لا يدعم المتصفح الذي تستخدمه. نقترح التحديث إلى النسخة الأحدث من أحد المتصفحات التي يدعمها سكراتش مثل غوغل كروم أو موزيلا فايرفوكس أو مايكروسوفت إيدج أو أبل سفاري.",
    "gui.unsupportedBrowser.back": "العودة",
    "gui.unsupportedBrowser.previewfaq": "لمعرفة المزيد اذهب إلى {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "الأسئلة الشائعة",
    "gui.cards.all-tutorials": "دروس",
    "gui.cards.shrink": "إخفاء",
    "gui.cards.expand": "عرض",
    "gui.cards.close": "إغلاق",
    "gui.cards.more-things-to-try": "المزيد مما يمكن تجريبه!",
    "gui.cards.see-more": "مشاهدة المزيد",
    "gui.comingSoon.message1": "لا تقلق فنحن نعمل على ذلك {emoji}",
    "gui.comingSoon.message2": "قريبًا...",
    "gui.comingSoon.message3": "نحن نعمل على ذلك {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "لم يُعثر على تجهيزات",
    "gui.connection.auto-scanning.prescan": "اجلب جهازك قريبًا ثم باشر البحث.",
    "gui.connection.auto-scanning.pressbutton": "اضغط الزر الموجود على جهازك.",
    "gui.connection.auto-scanning.start-search": "بدء البحث",
    "gui.connection.connecting-searchbutton": "جارٍ البحث...",
    "gui.connection.auto-scanning.try-again": "حاول ثانيةً",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "متصل",
    "gui.connection.disconnect": "قطع الاتصال",
    "gui.connection.go-to-editor": "اذهب إلى المحرر",
    "gui.connection.connecting-cancelbutton": "جارٍ الاتصال...",
    "gui.connection.error.errorMessage": "للأسف، يبدو أن هناك خطأً ما.",
    "gui.connection.error.tryagainbutton": "حاول ثانيةً",
    "gui.connection.error.helpbutton": "مساعدة",
    "gui.connection.peripheral-name-label": "اسم الجهاز",
    "gui.connection.connect": "الاتصال بالجهاز",
    "gui.connection.scanning.lookingforperipherals": "جارٍ البحث عن التجهيزات...",
    "gui.connection.scanning.noPeripheralsFound": "لم يتم العثور على الأجهزة",
    "gui.connection.scanning.instructions": "اختر جهازك من القائمة أعلاه.",
    "gui.connection.search": "تحديث",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "تأكد من تثبيت Scratch Link وتشغيله",
    "gui.connection.unavailable.enablebluetooth": "تحقق من تفعيل البلوتوث",
    "gui.connection.unavailable.tryagainbutton": "حاول ثانيةً",
    "gui.connection.unavailable.helpbutton": "المساعدة",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "انطلق",
    "gui.controls.stop": "توقف",
    "gui.crashMessage.label": "للأسف، هناك خطأ ما.",
    "gui.crashMessage.description": "نحن بالغو الأسف، ولكن يبدو أن صفحة سكراتش قد تعطلت. تم إبلاغ فريق سكراتش بهذا الخطأ تلقائيًا. يرجى تحديث صفحتك لإعادة المحاولة.",
    "gui.crashMessage.errorNumber": "تم تسجيل الخطأ مع اسم المستخدم {errorId}",
    "gui.crashMessage.reload": "إعادة تحميل الصفحة",
    "gui.customProcedures.myblockModalTitle": "إنشاء لبنة",
    "gui.customProcedures.addAnInputNumberText": "إضافة حقل",
    "gui.customProcedures.numberTextType": "رقم أو نص",
    "gui.customProcedures.addAnInputBoolean": "إضافة حقل",
    "gui.customProcedures.booleanType": "منطقي",
    "gui.customProcedures.addALabel": "إضافة نص",
    "gui.customProcedures.runWithoutScreenRefresh": "التشغيل دون تحديث الشاشة",
    "gui.customProcedures.cancel": "إلغاء الأمر",
    "gui.customProcedures.ok": "موافق",
    "gui.SpriteInfo.direction": "الاتجاه",
    "gui.directionPicker.rotationStyles.allAround": "جميع الاتجاهات",
    "gui.directionPicker.rotationStyles.leftRight": "يمين/ يسار",
    "gui.directionPicker.rotationStyles.dontRotate": "لا استدارة",
    "gui.gui.addExtension": "إدراج إضافة",
    "gui.gui.codeTab": "المقاطع البرمجية",
    "gui.gui.backdropsTab": "الخلفيات",
    "gui.gui.costumesTab": "المظاهر",
    "gui.gui.soundsTab": "الأصوات",
    "gui.extensionLibrary.comingSoon": "قريبًا",
    "gui.extensionLibrary.requires": "المتطلبات",
    "gui.extensionLibrary.collaboration": "بالتعاون مع",
    "gui.library.filterPlaceholder": "بحث",
    "gui.library.allTag": "الكل",
    "gui.loader.message1": "جار إنشاء اللبنات ...",
    "gui.loader.message2": "جارٍ تحميل الكائنات ...",
    "gui.loader.message3": "جارٍ تحميل الأصوات ...",
    "gui.loader.message4": "جار تحميل الإضافات ...",
    "gui.loader.message5": "جارٍ تحضير الكثير والكثير من الهررة ...",
    "gui.loader.message6": "جار إعداد العنقاء للطيران ...",
    "gui.loader.message7": "جارٍ نفخ الفيلة ...",
    "gui.loader.message8": "جارٍ تحضير الرموز التعبيرية ...",
    "gui.loader.headline": "جارٍ تحميل المشروع",
    "gui.loader.creating": "جارٍ إنشاء المشروع",
    "gui.accountMenu.profile": "الملف الشخصي",
    "gui.accountMenu.myStuff": "أغراضي",
    "gui.accountMenu.myClasses": "صفوفي",
    "gui.accountMenu.myClass": "صفي",
    "gui.accountMenu.accountSettings": "إعدادات الحساب",
    "gui.accountMenu.signOut": "تسجيل الخروج",
    "gui.authorInfo.byUser": "بواسطة {username}",
    "gui.menuBar.seeProjectPage": "شاهد صفحة المشروع ",
    "gui.menuBar.language": "Language",
    "general.username": "اسم المستخدم",
    "general.password": "كلمة المرور",
    "general.signIn": "تسجيل الدخول",
    "login.needHelp": "بحاجة إلى مساعدة؟",
    "form.validationRequired": "هذا الحقل مطلوب",
    "gui.menuBar.tutorialsLibrary": "الدروس",
    "gui.menuBar.restoreSprite": "استعادة الكائن",
    "gui.menuBar.restoreSound": "استعادة الصوت",
    "gui.menuBar.restoreCostume": "استعادة المظهر",
    "gui.menuBar.restore": "استعادة",
    "gui.menuBar.saveNow": "الحفظ الآن",
    "gui.menuBar.saveAsCopy": "حفظ نسخة",
    "gui.menuBar.remix": "مزج",
    "gui.menuBar.new": "جديد",
    "gui.menuBar.file": "ملف",
    "gui.menuBar.downloadToComputer": "الحفظ إلى حاسوبك",
    "gui.menuBar.edit": "تحرير",
    "gui.menuBar.turboModeOff": "إيقاف الوضعية السريعة",
    "gui.menuBar.turboModeOn": "تشغيل الوضعية السريعة",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "انضم إلى سكراتش",
    "gui.menuBar.signIn": "تسجيل الدخول",
    "gui.gui.projectTitlePlaceholder": "اسم المشروع هنا",
    "gui.menuBar.saveNowLink": "الحفظ الآن",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "مشارَك",
    "gui.menuBar.share": "مشاركة",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "مساعدة",
    "gui.modal.back": "عودة إلى السابق",
    "gui.monitor.listMonitor.empty": "(فارغة)",
    "gui.monitor.listMonitor.listLength": "طول {length}",
    "gui.monitor.contextMenu.default": "عرض عادي",
    "gui.monitor.contextMenu.large": "عرض كبير",
    "gui.monitor.contextMenu.slider": "المنزلقة",
    "gui.monitor.contextMenu.sliderRange": "تغيير مجال المنزلقة",
    "gui.monitor.contextMenu.import": "استيراد",
    "gui.monitor.contextMenu.export": "تصدير",
    "gui.monitor.contextMenu.hide": "إخفاء",
    "gui.playButton.play": "تشغيل",
    "gui.playButton.stop": "إيقاف",
    "gui.gui.variableScopeOptionAllSprites": "لجميع الكائنات",
    "gui.gui.variableScopeOptionSpriteOnly": "لهذا الكائن فقط",
    "gui.gui.cloudVariableOption": "متغير سحابي (مخزَّن على المخدّم)",
    "gui.gui.variablePromptAllSpritesMessage": "سيكون هذا المتغير متاحًا لجميع الكائنات.",
    "gui.gui.listPromptAllSpritesMessage": "ستكون هذه اللائحة متاحةً لجميع الكائنات.",
    "gui.prompt.cancel": "إلغاء الأمر",
    "gui.prompt.ok": "موافق",
    "gui.playbackStep.stopMsg": "توقف",
    "gui.playbackStep.playMsg": "تشغيل",
    "gui.playbackStep.loadingMsg": "جارٍ التحميل...",
    "gui.playbackStep.saveMsg": "حفظ",
    "gui.playbackStep.reRecordMsg": "إعادة تسجيل",
    "gui.recordModal.title": "تسجيل صوت",
    "gui.recordingStep.beginRecord": "إضغط على الزر في الأسفل لتبدأ التسجيل",
    "gui.recordingStep.permission": "{arrow} نحتاج إذنك لاستخدام الميكروفون",
    "gui.recordingStep.stop": "إيقاف التسجيل",
    "gui.recordingStep.record": "تسجيل",
    "gui.sliderModal.min": "القيمة الدنيا",
    "gui.sliderModal.max": "القيمة العظمى",
    "gui.sliderModal.title": "تغيير مجال المنزلقة",
    "gui.sliderPrompt.cancel": "إلغاء الأمر",
    "gui.sliderPrompt.ok": "موافق",
    "gui.soundEditor.sound": "الصوت",
    "gui.soundEditor.play": "تشغيل",
    "gui.soundEditor.stop": "إيقاف",
    "gui.soundEditor.copy": "نسخ",
    "gui.soundEditor.paste": "لصق",
    "gui.soundEditor.copyToNew": "نسخ إلى صوت جديد",
    "gui.soundEditor.delete": "حذف",
    "gui.soundEditor.save": "حفظ",
    "gui.soundEditor.undo": "تراجع",
    "gui.soundEditor.redo": "إعادة",
    "gui.soundEditor.faster": "تسريع",
    "gui.soundEditor.slower": "إبطاء",
    "gui.soundEditor.echo": "صدى",
    "gui.soundEditor.robot": "روبوت ",
    "gui.soundEditor.louder": "أعلى",
    "gui.soundEditor.softer": "أخفض",
    "gui.soundEditor.reverse": "عكس ",
    "gui.soundEditor.fadeOut": "تلاشي",
    "gui.soundEditor.fadeIn": "تصاعد",
    "gui.soundEditor.mute": "كتم",
    "gui.SpriteInfo.spritePlaceholder": "اسم",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "الكائن",
    "gui.SpriteInfo.show": "إظهار",
    "gui.SpriteInfo.size": "الحجم",
    "gui.spriteSelectorItem.contextMenuDuplicate": "مضاعفة",
    "gui.spriteSelectorItem.contextMenuExport": "تصدير",
    "gui.spriteSelectorItem.contextMenuDelete": "حذف",
    "gui.spriteSelector.addSpriteFromLibrary": "اختيار كائن",
    "gui.spriteSelector.addSpriteFromPaint": "رسم",
    "gui.spriteSelector.addSpriteFromSurprise": "كائن عشوائي",
    "gui.spriteSelector.addSpriteFromFile": "تحميل كائن",
    "gui.stageHeader.stageSizeLarge": "التبديل إلى منصة كبيرة",
    "gui.stageHeader.stageSizeSmall": "التبديل إلى منصة صغيرة",
    "gui.stageHeader.stageSizeFull": "الدخول في وضعية ملء الشاشة",
    "gui.stageHeader.stageSizeUnFull": "الخروج من وضعية ملء الشاشة",
    "gui.stageHeader.fullscreenControl": "التحكم في وضعية ملء الشاشة",
    "gui.spriteSelector.addBackdropFromLibrary": "اختيار خلفية",
    "gui.stageSelector.addBackdropFromPaint": "رسام",
    "gui.stageSelector.addBackdropFromSurprise": "خلفية عشوائية",
    "gui.stageSelector.addBackdropFromFile": "تحميل خلفية",
    "gui.stageSelector.stage": "المنصة",
    "gui.stageSelector.backdrops": "الخلفيات",
    "gui.telemetryOptIn.label": "إرسال إحصائيات لتحسين سكراتش",
    "gui.telemetryOptIn.body1": "يتطلع فريق سكراتش دومًا إلى فهم أفضل للكيفية التي تستخدم بها سكراتش في أنحاء العالم. للمساعدة في دعم هذا المجهود يمكنك السماح لسكراتش بإرسال معلومات الاستخدام إلى فريق سكراتش تلقائيًا.",
    "gui.telemetryOptIn.body2": "المعلومات التي نجمعها تتضمن اختيار اللغة واستخدام اللبنات وبعض الأحداث مثل الحفظ والتحميل ورفع مشروع. نحن لا نجمع أي معلومات شخصية. فضلًا راجع {privacyPolicyLink} لمزيد من المعلومات.",
    "gui.telemetryOptIn.privacyPolicyLink": "سياسة الخصوصية",
    "gui.telemetryOptIn.optInText": "شارك بيانات الاستخدام الخاصة بي مع فريق سكراتش",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "لا تشارك بيانات الاستخدام الخاصة بي مع فريق سكراتش",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "حُدِّثت إعداداتك.",
    "gui.telemetryOptIn.buttonClose": "إغلاق",
    "gui.turboMode.active": "الوضعية السريعة",
    "gui.webglModal.label": "متصفحك لا يدعم WebGL",
    "gui.webglModal.description": "للأسف، يبدو أن متصفحك أو حاسوبك {webGlLink}. هذه التقنية تلزم لتشغيل سكراتش 3,0.",
    "gui.webglModal.webgllink": "لا يدعم WebGL",
    "gui.webglModal.back": "العودة إلى السابق",
    "gui.webglModal.previewfaq": "لمعرفة المزيد، انتقل إلى {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "الأسئلة متكررة الطرح",
    "gui.costumeLibrary.chooseABackdrop": "اختيار خلفية",
    "gui.costumeLibrary.chooseACostume": "اختيار مظهر",
    "gui.costumeTab.addBackdropFromLibrary": "اختيار خلفية",
    "gui.costumeTab.addCostumeFromLibrary": "اختيار مظهر",
    "gui.costumeTab.addBlankCostume": "رسم",
    "gui.costumeTab.addSurpriseCostume": "مظهر عشوائي",
    "gui.costumeTab.addFileBackdrop": "تحميل الخلفية",
    "gui.costumeTab.addFileCostume": "تحميل مظهر",
    "gui.extensionLibrary.chooseAnExtension": "اختر الاضافات",
    "gui.extensionLibrary.extensionUrl": "أدخل الرابط الخاص بالإضافة",
    "gui.monitors.importListColumnPrompt": "أي عمود يجب استخدامه (1-{numberOfColumns})؟",
    "gui.recordingStep.alertMsg": "لا يمكن بدء تسجيل",
    "gui.soundLibrary.chooseASound": "اختيار صوت",
    "gui.soundTab.fileUploadSound": "تحميل صوت",
    "gui.soundTab.surpriseSound": "صوت عشوائي",
    "gui.soundTab.recordSound": "تسجيل",
    "gui.soundTab.addSoundFromLibrary": "اختيار صوت",
    "gui.spriteLibrary.chooseASprite": "اختيار كائن",
    "gui.tipsLibrary.tutorials": "اختيار درس",
    "gui.alerts.createsuccess": "تم إنشاء مشروع جديد. ",
    "gui.alerts.createcopysuccess": "حُفظ المشروع كنسخة.",
    "gui.alerts.createremixsuccess": "حُفظ المشروع كمزج.",
    "gui.alerts.creating": "جارٍ إنشاء مشروع جديد... ",
    "gui.alerts.creatingCopy": "جارٍ نسخ المشروع...",
    "gui.alerts.creatingRemix": "جارٍ مزج المشروع...",
    "gui.alerts.creatingError": "لم يكن بالإمكان إنشاء المشروع. حاول ثانيةً!",
    "gui.alerts.savingError": "لم يمكن حفظ المشروع.",
    "gui.alerts.savesuccess": "حُفظ المشروع.",
    "gui.alerts.saving": "جارٍ حفظ المشروع...",
    "gui.alerts.cloudInfo": "يرجى ملاحظة أن المتغيرات السحابية تدعم الأرقام فقط، ولا تدعم الحروف أو الرموز. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "اعرف المزيد.",
    "gui.alerts.importing": "جارٍ الاستيراد...",
    "gui.defaultProject.meow": "مواء",
    "gui.defaultProject.variable": "متغيري",
    "gui.howtos.intro-move-sayhello-hat.name": "الشروع في العمل",
    "gui.howtos.intro-move.step_stepMove": "أضف لبنةً للحركة",
    "gui.howtos.add-a-move-block.step_stepSay": "أضف لبنة قل",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "انقر العلم الأخضر للبدء",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "تحريك اسم",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "اختر كائنًا للحرف",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "شغِّل صوتًا عند النقر",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "اختر كائنًا لحرف آخر",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "غيِّر اللون",
    "gui.howtos.animate-a-name.step_AnimateSpin": "اختر حرفًا آخر واجعله يدور",
    "gui.howtos.animate-a-name.step_AnimateGrow": "اختر حرفًا آخر واجعله يكبر",
    "gui.howtos.imagine": "تخيل عالمًا",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "اكتب ما تريد قوله",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "انقر العلم الأخضر للبدء",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "اختر أي خلفية",
    "gui.howtos.imagine.step_imagineChooseSprite": "اختر أي كائن",
    "gui.howtos.imagine.step_imagineFlyAround": "اضغط مفتاح المسافة للانزلاق",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "اختر كائنًا آخر",
    "gui.howtos.imagine.step_imagineLeftRight": "تحرك يمينًا ويسارًا",
    "gui.howtos.imagine.step_imagineUpDown": "تحرك إلى الأعلى والأسفل",
    "gui.howtos.imagine.step_imagineChangeCostumes": "غير المظاهر",
    "gui.howtos.imagine.step_imagineGlideToPoint": "انزلق إلى نقطة محددة",
    "gui.howtos.imagine.step_imagineGrowShrink": "تضخم وانكمش",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "اختر خلفيةً أخرى",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "بدِّل الخلفيات",
    "gui.howtos.imagine.step_imagineRecordASound": "إضافة صوت",
    "gui.howtos.imagine.step_imagineChooseSound": "اختر صوتًا",
    "gui.howtos.make-music.name": "إنشاء موسيقى",
    "gui.howtos.Make-Music.step_PickInstrument": "اختر كائنًا لأداة موسيقية",
    "gui.howtos.Make-Music.step_PlaySoundClick": "شغِّل صوتًا عند النقر",
    "gui.howtos.Make-Music.step_MakeSong": "أنشئ أغنيةً",
    "gui.howtos.make-music.step_MakeBeat": "اختر طبلًا واصنع أداءً",
    "gui.howtos.make-music.step_MakeBeatBox": "اختر كائن الميكروفون وأدِّ بيت بوكس",
    "gui.howtos.story.name": "أنشئ قصةً",
    "gui.howtos.story.step_addbg": "أضف خلفيةً",
    "gui.howtos.story.step_addsprite": "أضف شخصيةً",
    "gui.howtos.story.step_saysomething": "قل شيئًا",
    "gui.howtos.story.step_addanothersprite": "أضف شخصيةً أخرى",
    "gui.howtos.story.step_flip": "اعكس الاتجاه",
    "gui.howtos.story.step_conversation": "أجرِ محادثةً",
    "gui.howtos.story.addanotherbg": "أضف خلفيةً أخرى",
    "gui.howtos.story.step_swithbg": "بدِّل الخلفيات",
    "gui.howtos.story.step_hidewizard": "أخفِ شخصيةً",
    "gui.howtos.story.step_showwizard": "إظهار شخصية",
    "gui.howtos.make-a-chase-game.name": "تصميم لعبة مطاردة",
    "gui.howtos.Chase-Game.step_BG": "أضف خلفيةً",
    "gui.howtos.chase-game.step_AddOcto": "أضف كائنًا",
    "gui.howtos.make-music.step_LeftRight": "تحرك يمينًا ويسارًا بواسطة مفاتيح الأسهم",
    "gui.howtos.Chase-Game.step_UpDown": "تحرك صعودًا وهبوطًا بواسطة مفاتيح الأسهم",
    "gui.howtos.Chase-Game.step_AddStar": "أضف كائنًا آخر",
    "gui.howtos.Chase-Game.step_MoveRandom": "تحرك عشوائيًا",
    "gui.howtos.Chase-Game.step_WhenTouch": "في كائن الأخطبوط: شغل صوتًا عند التلامس",
    "gui.howtos.Chase-Game.step_ScoreVariable": "أنشئ متغيرًا للنقاط",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "في كائن الأخطبوط: عند التلامس زد النقاط",
    "gui.howtos.animate-char.name": "تحريك شخصية",
    "gui.howtos.animate-char.step_addbg": "أضف خلفيةً",
    "gui.howtos.animate-char.step_addsprite": "أضف كائنًا",
    "gui.howtos.animate-char.step_saysomething": "قل شيئًا",
    "gui.howtos.animate-char.step_addsound": "أضف صوتًا",
    "gui.howtos.animate-char.step_animatetalking": "حرِّك الحديث",
    "gui.howtos.animate-char.step_arrowkeys": "تحرك بواسطة مفاتيح الأسهم",
    "gui.howtos.animate-char.step_jump": "اقفز",
    "gui.howtos.animate-char.step_changecolor": "غيِّر اللون",
    "gui.howtos.make-a-game.name": "إنشاء لعبة نقر بالفأرة",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "اختر كائنًا",
    "gui.howtos.make-a-game.step_GamePlaySound": "شغِّل صوتًا عند النقر",
    "gui.howtos.make-a-game.step_GameAddScore": "أنشئ متغيرًا للنقاط",
    "gui.howtos.make-a-game.step_GameChangeScore": "زد النقاط عند النقر",
    "gui.howtos.make-a-game.step_Random": "اذهب إلى موضع عشوائي",
    "gui.howtos.make-music.step_GameChangeColor": "غيِّر اللون",
    "gui.howtos.make-music.step_ResetScore": "صفِّر النتيجة",
    "gui.howtos.make-it-fly.name": "اجعلها تطير",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "اختر سماءً كخلفية",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "اختر شخصية",
    "gui.howtos.fly.step_stepflySaySomething": "قل شيئًا",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "تحرك باستخدام مفاتيح الأسهم",
    "gui.howtos.fly.step_stepflyChooseObject": "اختر غرضًا لجمعه",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "اجعل الغرض يتحرك",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "اختر شخصيتك",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "أضف نقاطًا",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "احفظ النتيجة",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "أضف منظرًا",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "حرك المنظر",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "المظهر التالي",
    "gui.howtos.pong": "لعبة الكرة النطاطة",
    "gui.howtos.pong.step_pongAddBackdrop": "أضف خلفيةً",
    "gui.howtos.pong.step_pongAddBallSprite": "أضف كرةً ككائن",
    "gui.howtos.pong.step_pongBounceAround": "اقفز حول المكان",
    "gui.howtos.pong.step_pongAddPaddle": "أضف مضربًا",
    "gui.howtos.pong.step_pongMoveThePaddle": "حرك المضرب",
    "gui.howtos.pong.step_pongSelectBallSprite": "اختر كائن الكرة",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "أضف البرنامج اللازم لجعل الكرة ترتد عن المضرب",
    "gui.howtos.pong.step_pongAddAScore": "أضف نقاطًا",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "اختر \"النقاط\" من القائمة",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "أدرج لبنة \"غيِّر النقاط\"",
    "gui.howtos.pong.step_pongResetScore": "صفِّر النتيجة",
    "gui.howtos.pong.step_pongAddLineSprite": "أضف كائن الخط",
    "gui.howtos.pong.step_pongGameOver": "اللعبة انتهت",
    "gui.howtos.code-cartoon": "برمج فيلم كرتون",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "قل شيئًا عندما تنقر العلم الأخضر",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "حرِّك شخصيةً عندما تنقرها",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "اختر شخصيةً أخرى",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "استخدم إشارة الناقص للتصغير",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "اجعل شخصيةً تتضخم وتنكمش",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "اختر شخصيةً أخرى",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "اقفز للأعلى والأسفل",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "انقر شخصيةً لتغيير المَشاهد",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "انزلق في الأنحاء",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "غير المظاهر",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "اختر المزيد من الشخصيات لإضافتها إلى فيلمك",
    "gui.howtos.cartoon-network": "تحريك لعبة مغامرات",
    "gui.howtos.cartoon-network.step_CNcharacter": "اختر شخصيةً للعرض",
    "gui.howtos.cartoon-network.step_CNsay": "قل شيئًا",
    "gui.howtos.cartoon-network.step_CNglide": "انزلق في الأنحاء",
    "gui.howtos.cartoon-network.step_CNpicksprite": "اختر كائنًا لمطاردته",
    "gui.howtos.cartoon-network.step_CNcollect": "اجمع الأغراض",
    "gui.howtos.cartoon-network.step_CNvariable": "أنشئ متغيرًا للنتيجة",
    "gui.howtos.cartoon-network.step_CNscore": "احفظ النتيجة",
    "gui.howtos.cartoon-network.step_CNbackdrop": "انتقل إلى مستوىً أعلى: غيِّر الخلفية",
    "gui.howtos.videosens.name": "استشعار الفيديو",
    "gui.howtos.videosens.step_addextension": "أدرج إضافةً",
    "gui.howtos.videosens.step_pet": "ربِّت على الهرة",
    "gui.howtos.videosens.step_animate": "حرِّك",
    "gui.howtos.videosens.step_pop": "فجِّر بالونًا",
    "gui.howtos.say-it-out-loud": "إنشاء رسوم متحركة متكلمة",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "أضف النص إلى لبنات الحديث",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "قل شيئًا ما",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "اختر صوتًا",
    "gui.howtos.say-it-out-loud.step_TXTMove": "تجول في الأنحاء",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "أضف خلفيةً",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "أضف شخصيةً أخرى",
    "gui.howtos.say-it-out-loud.step_TXTSong": "أدِّ أغنيةً",
    "gui.howtos.say-it-out-loud.step_TXTColor": "غيِّر اللون",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "قم بالدوران",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "تضخم وانكمش",
    "gui.howtos.talking": "حكايات ناطقة",
    "gui.howtos.talking.step_talesAddExtension": "انقر لإضافة لبنات تحويل النص إلى كلام",
    "gui.howtos.talking.step_talesChooseSprite": "اختر كائنًا",
    "gui.howtos.talking.step_talesSaySomething": "اجعل شخصيةً تتكلم",
    "gui.howtos.talking.step_talesChooseBackdrop": "اختر خلفيةً",
    "gui.howtos.talking.step_talesSwitchBackdrop": "انقر شخصيةً للانتقال إلى الخلفية التالية",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "اختر كائنًا آخر",
    "gui.howtos.talking.step_talesMoveAround": "تجول في الأنحاء",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "اختر خلفيةً أخرى",
    "gui.howtos.talking.step_talesAnimateTalking": "حرِّك الحديث",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "اختر خلفيةً أخرى",
    "gui.howtos.talking.step_talesChooseSound": "اختر أغنيةً للرقص عليها",
    "gui.howtos.talking.step_talesDanceMoves": "حركات الرقص",
    "gui.howtos.talking.step_talesAskAnswer": "اسحب لبنات السؤال والإجابة من قسم الاستشعار",
    "gui.howtos.add-sprite.name": "أضف كائنًا",
    "gui.howtos.add-sprite.step_addSprite": "أضف كائنًا",
    "gui.howtos.add-a-backdrop.name": "أضف خلفيةً",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "أضف خلفيةً",
    "gui.howtos.change-size.name": "غيِّر الحجم",
    "gui.howtos.change-size.step_changeSize": "غيِّر الحجم",
    "gui.howtos.glide-around.name": "انزلق في الأنحاء",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "انزلق في الأنحاء",
    "gui.howtos.change-size.step_glideAroundPoint": "انزلق إلى نقطة محددة",
    "gui.howtos.record-a-sound.name": "سجِّل صوتًا",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "انقر إطار \"الأصوات\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "انقر \"تسجيل\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "اضغط زر التسجيل",
    "gui.howtos.change-size.step_recordASoundChooseSound": "اختر صوتًا",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "شغل الصوت",
    "gui.howtos.spin-video.name": "اجعلها تدور",
    "gui.howtos.change-size.step_spinTurn": "استدر",
    "gui.howtos.change-size.step_spinPointInDirection": "حدد الاتجاه",
    "gui.howtos.hide-and-show.name": "إخفاء وإظهار",
    "gui.howtos.change-size.step_hideAndShow": "إخفاء وإظهار",
    "gui.howtos.switch-costume.name": "تحريك كائن",
    "gui.howtos.change-size.step_switchCostumes": "تحريك كائن",
    "gui.howtos.move-around-with-arrow-keys.name": "استخدام مفاتيح الأسهم",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "تحرك يمينًا ويسارًا",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "تحرك إلى الأعلى والأسفل",
    "gui.howtos.add-effects.name": "إضافة مؤثرات",
    "gui.howtos.videosens.step_addEffects": "أضف مؤثرات",
    "gui.extension.music.name": "الموسيقى",
    "gui.extension.music.description": "لعزف الآلات الموسيقية والطبول.",
    "gui.extension.pen.name": "القلم",
    "gui.extension.pen.description": "للرسم بواسطة كائناتك.",
    "gui.extension.videosensing.name": "استشعار الفيديو",
    "gui.extension.videosensing.description": "لاستشعار الحركة بواسطة الكاميرا.",
    "gui.extension.text2speech.name": "نص إلى كلام",
    "gui.extension.text2speech.description": "لجعل مشاريعك تتحدث.",
    "gui.extension.translate.name": "الترجمة",
    "gui.extension.translate.description": "لترجمة نص إلى العديد من اللغات.",
    "gui.extension.makeymakey.description": "لتحويل أي شيء إلى مفتاح.",
    "gui.extension.microbit.description": "لربط مشاريعك  بالعالم.",
    "gui.extension.microbit.connectingMessage": "جارٍ التوصيل",
    "gui.extension.ev3.description": "لبناء روبوتات تفاعلية وغيرها.",
    "gui.extension.ev3.connectingMessage": "جارٍ التوصيل. تأكد من أن الرقم السري على جهاز EV3 الخاص بك مضبوط على القيمة 1234.",
    "gui.extension.boost.description": "لبث الروح في كائناتك الروبوتية.",
    "gui.extension.boost.connectingMessage": "جارٍ التوصيل",
    "gui.extension.wedo2.description": "للبناء مستخدمًا المحركات والحساسات.",
    "gui.extension.wedo2.connectingMessage": "جارٍ التوصيل",
    "gui.extension.gdxfor.description": "لاستشعار الدفع والسحب والحركة والدوران.",
    "gui.extension.gdxfor.connectingMessage": "جارٍ التوصيل",
    "gui.libraryTags.all": "الكل",
    "gui.libraryTags.animals": "حيوانات",
    "gui.libraryTags.dance": "رقص",
    "gui.libraryTags.effects": "المؤثرات",
    "gui.libraryTags.fantasy": "عالم الخيال",
    "gui.libraryTags.fashion": "أزياء ",
    "gui.libraryTags.food": "طعام",
    "gui.libraryTags.indoors": "داخلي",
    "gui.libraryTags.loops": "حلقات",
    "gui.libraryTags.music": "موسيقى",
    "gui.libraryTags.notes": "نغمات",
    "gui.libraryTags.outdoors": "خارجي",
    "gui.libraryTags.patterns": "أنماط",
    "gui.libraryTags.people": "بشر",
    "gui.libraryTags.percussion": "إيقاع",
    "gui.libraryTags.space": "فضاء",
    "gui.libraryTags.sports": "رياضة",
    "gui.libraryTags.underwater": "تحت الماء",
    "gui.libraryTags.voice": "صوت",
    "gui.libraryTags.wacky": "لعوب",
    "gui.libraryTags.animation": "رسوم متحركة",
    "gui.libraryTags.art": "فنون",
    "gui.libraryTags.games": "ألعاب",
    "gui.libraryTags.stories": "قصص",
    "gui.libraryTags.letters": "حروف",
    "gui.opcodeLabels.direction": "الاتجاه",
    "gui.opcodeLabels.xposition": "الموضع س",
    "gui.opcodeLabels.yposition": "الموضع ص",
    "gui.opcodeLabels.size": "الحجم",
    "gui.opcodeLabels.costumename": "اسم المظهر",
    "gui.opcodeLabels.costumenumber": "رقم المظهر",
    "gui.opcodeLabels.backdropname": "اسم الخلفية",
    "gui.opcodeLabels.backdropnumber": "رقم الخلفية",
    "gui.opcodeLabels.volume": "شدة الصوت",
    "gui.opcodeLabels.tempo": "سرعة الإيقاع",
    "gui.opcodeLabels.answer": "الإجابة",
    "gui.opcodeLabels.loudness": "الضجيج",
    "gui.opcodeLabels.username": "اسم المستخدم",
    "gui.opcodeLabels.year": "العام",
    "gui.opcodeLabels.month": "الشهر",
    "gui.opcodeLabels.date": "التاريخ",
    "gui.opcodeLabels.dayofweek": "يوم الأسبوع",
    "gui.opcodeLabels.hour": "الساعة",
    "gui.opcodeLabels.minute": "الدقيقة",
    "gui.opcodeLabels.second": "الثانية",
    "gui.opcodeLabels.timer": "المؤقت",
    "gui.projectLoader.loadError": "أخفق تحميل ملف المشروع الذي تم تحديده.",
    "gui.sharedMessages.backdrop": "الخلفية {index}",
    "gui.sharedMessages.costume": "المظهر {index}",
    "gui.sharedMessages.sprite": "الكائن {index}",
    "gui.sharedMessages.pop": "بُب",
    "gui.sharedMessages.replaceProjectWarning": "هل تريد الاستغناء عن محتويات المشروع الحالي؟",
    "gui.sharedMessages.loadFromComputerTitle": "التحميل من حاسوبك",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "مشروع سكراتش",
    "boost.color.any": "أي لون",
    "boost.color.black": "الأسود",
    "boost.color.blue": "الأزرق",
    "boost.color.green": "الأخضر",
    "boost.color.red": "الأحمر",
    "boost.color.white": "الأبيض",
    "boost.color.yellow": "الأصفر",
    "boost.getMotorPosition": "موضع المحرك [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "زاوية الميلان [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ذاك الاتجاه",
    "boost.motorDirection.forward": "هذا الاتجاه",
    "boost.motorDirection.reverse": "عكس الاتجاه",
    "boost.motorOff": "أوقف المحرك [MOTOR_ID]",
    "boost.motorOn": "شغِّل المحرك [MOTOR_ID]",
    "boost.motorOnFor": "شغِّل المحرك [MOTOR_ID] مدة [DURATION] ثانية",
    "boost.motorOnForRotation": "شغِّل المحرك [MOTOR_ID] لـ[ROTATION] دورات",
    "boost.seeingColor": "ترى اللبنة ذات اللون [COLOR]؟",
    "boost.setLightHue": "اجعل لون المصباح مساويًا [HUE]",
    "boost.setMotorDirection": "اجعل اتجاه المحرك [MOTOR_ID] مساويًا [MOTOR_DIRECTION]",
    "boost.setMotorPower": "اجعل سرعة المحرك [MOTOR_ID] مساويةً [POWER] ٪",
    "boost.tiltDirection.any": "أي اتجاه",
    "boost.tiltDirection.down": "الأسفل",
    "boost.tiltDirection.left": "اليسار ",
    "boost.tiltDirection.right": "اليمين",
    "boost.tiltDirection.up": "الأعلى",
    "boost.whenColor": "عندما ترى اللبنة ذات اللون [COLOR]",
    "boost.whenTilted": "عند الإمالة نحو [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "شغل النغمة [NOTE] مدة [TIME] ثوانٍ",
    "ev3.buttonPressed": "الزر [PORT] مضغوط؟",
    "ev3.getBrightness": "شدة الإضاءة",
    "ev3.getDistance": "المسافة",
    "ev3.getMotorPosition": "موضع المحرك [PORT]",
    "ev3.motorSetPower": "اجعل طاقة المحرك [PORT] مساويةً [POWER] ٪",
    "ev3.motorTurnClockwise": "شغل المحرك [PORT] في هذا الاتجاه مدة [TIME] ثوانٍ",
    "ev3.motorTurnCounterClockwise": "شغل المحرك [PORT] في ذاك الاتجاه مدة [TIME] ثوانٍ",
    "ev3.whenBrightnessLessThan": "عندما الإضاءة < [DISTANCE]",
    "ev3.whenButtonPressed": "عند ضغط زر [PORT]",
    "ev3.whenDistanceLessThan": "عندما المسافة < [DISTANCE]",
    "gdxfor.getAcceleration": "التسارع [DIRECTION]",
    "gdxfor.getForce": "القوة",
    "gdxfor.getSpin": "سرعة الدوران [DIRECTION]",
    "gdxfor.getTilt": "زاوية الميلان [TILT]",
    "gdxfor.isFreeFalling": "في حالة سقوط؟",
    "gdxfor.isTilted": "مائل [TILT]؟",
    "gdxfor.pulled": "مسحوب",
    "gdxfor.pushed": "مدفوع",
    "gdxfor.shaken": "مهزوز",
    "gdxfor.startedFalling": "يبدأ السقوط",
    "gdxfor.tiltDirectionMenu.any": "أي اتجاه",
    "gdxfor.tiltDirectionMenu.back": "الخلف",
    "gdxfor.tiltDirectionMenu.front": "الأمام",
    "gdxfor.tiltDirectionMenu.left": "اليسار ",
    "gdxfor.tiltDirectionMenu.right": "اليمين",
    "gdxfor.turnedFaceDown": "يصبح وجهه للأسفل",
    "gdxfor.turnedFaceUp": "يصبح وجهه للأعلى",
    "gdxfor.whenForcePushedOrPulled": "عندما حساس القوة [PUSH_PULL]",
    "gdxfor.whenGesture": "عندما [GESTURE]",
    "gdxfor.whenTilted": "عندما يميل [TILT]",
    "makeymakey.downArrow": "السهم السفلي",
    "makeymakey.downArrowShort": "الأسفل",
    "makeymakey.leftArrow": "السهم الأيسر",
    "makeymakey.leftArrowShort": "يسار",
    "makeymakey.rightArrow": "السهم الأيمن",
    "makeymakey.rightArrowShort": "اليمين",
    "makeymakey.spaceKey": "المسافة",
    "makeymakey.upArrow": "السهم العلوي",
    "makeymakey.upArrowShort": "الأعلى",
    "makeymakey.whenKeyPressed": "عند ضغط مفتاح [KEY]",
    "makeymakey.whenKeysPressedInOrder": "عند ضغط [SEQUENCE] بالترتيب",
    "microbit.buttonsMenu.any": "أي زر",
    "microbit.clearDisplay": "امسح الشاشة",
    "microbit.defaultTextToDisplay": "Ya Hala!",
    "microbit.displaySymbol": "اعرض [MATRIX]",
    "microbit.displayText": "اعرض النص [TEXT]",
    "microbit.gesturesMenu.jumped": "القفز",
    "microbit.gesturesMenu.moved": "الحركة",
    "microbit.gesturesMenu.shaken": "الهز",
    "microbit.isButtonPressed": "الزر [BTN] مضغوط؟",
    "microbit.isTilted": "مائل نحو [DIRECTION]؟",
    "microbit.pinStateMenu.off": "يتوقف",
    "microbit.pinStateMenu.on": "يعمل",
    "microbit.tiltAngle": "زاوية الميل نحو [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "أي اتجاه",
    "microbit.tiltDirectionMenu.back": "الخلف",
    "microbit.tiltDirectionMenu.front": "الأمام",
    "microbit.tiltDirectionMenu.left": "اليسار",
    "microbit.tiltDirectionMenu.right": "اليمين",
    "microbit.whenButtonPressed": "عند ضغط الزر [BTN]",
    "microbit.whenGesture": "عند [GESTURE]",
    "microbit.whenPinConnected": "عند توصيل الرجل [PIN]",
    "microbit.whenTilted": "عند الميل نحو [DIRECTION]",
    "music.categoryName": "الموسيقى",
    "music.changeTempo": "غيّر سرعة الأداء بمقدار [TEMPO]",
    "music.drumBass": "(2) طبل كبير",
    "music.drumBongo": "(13) بونغو",
    "music.drumCabasa": "(15) كاباسا",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) هاي هات مغلق",
    "music.drumConga": "(14) كونغا",
    "music.drumCowbell": "(11) جرس",
    "music.drumCrashCymbal": "(4) صنج",
    "music.drumCuica": "(18) كويكا",
    "music.drumGuiro": "(16) غويرو",
    "music.drumHandClap": "(8) صفقة",
    "music.drumOpenHiHat": "(5) هاي هات مفتوح",
    "music.drumSideStick": "(3) عصا جانبية",
    "music.drumSnare": "(1) طبل جانبي",
    "music.drumTambourine": "(7) دف",
    "music.drumTriangle": "(12) مثلث",
    "music.drumVibraslap": "(17) فيبراسلاب",
    "music.drumWoodBlock": "(10) قطعة خشبية",
    "music.getTempo": "سرعة الأداء",
    "music.instrumentBass": "(6) باس",
    "music.instrumentBassoon": "(14) باسون",
    "music.instrumentCello": "(8) تشيلو",
    "music.instrumentChoir": "(15) جوقة",
    "music.instrumentClarinet": "(10) كلارينيت",
    "music.instrumentElectricGuitar": "(5) غيتار كهربائي",
    "music.instrumentElectricPiano": "(2) بيانو كهربائي",
    "music.instrumentFlute": "(12) ناي",
    "music.instrumentGuitar": "(4) غيتار",
    "music.instrumentMarimba": "(19) ماريمبا",
    "music.instrumentMusicBox": "(17) صندوق موسيقى",
    "music.instrumentOrgan": "(3) أورغن",
    "music.instrumentPiano": "(1) بيانو",
    "music.instrumentPizzicato": "(7) بتسيكاتو",
    "music.instrumentSaxophone": "(11) ساكسفون",
    "music.instrumentSteelDrum": "(18) طبل معدني",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) ترومبون",
    "music.instrumentVibraphone": "(16) فيبرافون",
    "music.instrumentWoodenFlute": "(13) ناي خشبي",
    "music.midiPlayDrumForBeats": "اقرع [DRUM] مدة [BEATS] وحدة إيقاع",
    "music.midiSetInstrument": "اجعل الآلة [INSTRUMENT]",
    "music.playDrumForBeats": "اقرع [DRUM] مدة [BEATS] وحدة إيقاع",
    "music.playNoteForBeats": "اعزف النغمة [NOTE] مدة [BEATS] وحدة إيقاع",
    "music.restForBeats": "استرح مدة [BEATS] وحدة إيقاع",
    "music.setInstrument": "اجعل الآلة [INSTRUMENT]",
    "music.setTempo": "اجعل سرعة الأداء مساويةً [TEMPO] وحدة إيقاع في الدقيقة",
    "pen.categoryName": "القلم",
    "pen.changeColorParam": "غيّر [COLOR_PARAM] القلم بمقدار [VALUE]",
    "pen.changeHue": "غيّر لون القلم بمقدار [HUE]",
    "pen.changeShade": "غيّر تظليل القلم بمقدار [SHADE]",
    "pen.changeSize": "غيّر حجم القلم بمقدار [SIZE]",
    "pen.clear": "امسح كل شيء",
    "pen.colorMenu.brightness": "سطوع لون",
    "pen.colorMenu.color": "لون",
    "pen.colorMenu.saturation": "إشباع لون",
    "pen.colorMenu.transparency": "شفافية",
    "pen.penDown": "أنزل القلم",
    "pen.penUp": "ارفع القلم",
    "pen.setColor": "اجعل لون القلم مساويًا [COLOR]",
    "pen.setColorParam": "اجعل [COLOR_PARAM] القلم مساويًا [VALUE]",
    "pen.setHue": "اجعل لون القلم مساويًا [HUE]",
    "pen.setShade": "اجعل تظليل القلم مساويًا [SHADE]",
    "pen.setSize": "اجعل حجم القلم مساويًا [SIZE]",
    "pen.stamp": "اطبع",
    "speech.defaultWhenIHearValue": "هيا بنا",
    "speech.extensionName": "كلام إلى نص",
    "speech.listenAndWait": "استمع وانتظر",
    "speech.speechReporter": "كلام",
    "speech.whenIHear": "عندما أسمع [PHRASE]",
    "text2speech.alto": "صوت امرأة",
    "text2speech.categoryName": "نص إلى كلام",
    "text2speech.defaultTextToSpeak": "السلام عليكم",
    "text2speech.giant": "عميقًا",
    "text2speech.kitten": "صوت قطقوطة",
    "text2speech.setLanguageBlock": "اجعل اللغة هي [LANGUAGE]",
    "text2speech.setVoiceBlock": "اجعل الصوت [VOICE]",
    "text2speech.speakAndWaitBlock": "تكلم [WORDS]",
    "text2speech.squeak": "رفيعًا",
    "text2speech.tenor": "صوت رجل",
    "translate.categoryName": "ترجم",
    "translate.defaultTextToTranslate": "مرحبًا ",
    "translate.translateBlock": "ترجم [WORDS] إلى [LANGUAGE]",
    "translate.viewerLanguage": "لغتي",
    "videoSensing.categoryName": "استشعار الفيديو",
    "videoSensing.direction": "اتجاه",
    "videoSensing.motion": "حركة",
    "videoSensing.off": "يتوقف",
    "videoSensing.on": "يعمل",
    "videoSensing.onFlipped": "يعمل مقلوبًا",
    "videoSensing.setVideoTransparency": "اجعل شفافية الفيديو مساويةً [TRANSPARENCY]",
    "videoSensing.sprite": "الكائن",
    "videoSensing.stage": "المنصة",
    "videoSensing.videoOn": "[ATTRIBUTE] الفيديو على [SUBJECT]",
    "videoSensing.videoToggle": "اجعل الفيديو [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "عندما حركة الفيديو > [REFERENCE]",
    "wedo2.getDistance": "المسافة",
    "wedo2.getTiltAngle": "زاوية الميل نحو [TILT_DIRECTION]",
    "wedo2.isTilted": "مائل نحو [TILT_DIRECTION_ANY]؟",
    "wedo2.motorDirection.backward": "ذاك الاتجاه",
    "wedo2.motorDirection.forward": "هذا الاتجاه",
    "wedo2.motorDirection.reverse": "المعاكس",
    "wedo2.motorId.a": "المحرك A",
    "wedo2.motorId.all": "جميع المحركات",
    "wedo2.motorId.b": "المحرك B",
    "wedo2.motorId.default": "المحرك",
    "wedo2.motorOff": "أوقف [MOTOR_ID]",
    "wedo2.motorOn": "شغِّل [MOTOR_ID]",
    "wedo2.motorOnFor": "شغّل [MOTOR_ID] مدة [DURATION] ثوانٍ",
    "wedo2.playNoteFor": "اعزف النغمة [NOTE] مدة [DURATION] ثوانٍ",
    "wedo2.setLightHue": "اجعل لون المصباح مساويًا [HUE]",
    "wedo2.setMotorDirection": "اجعل دوران [MOTOR_ID] في [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "اجعل قوة [MOTOR_ID]  مساويةً [POWER]",
    "wedo2.tiltDirection.any": "أي اتجاه",
    "wedo2.tiltDirection.down": "الأسفل",
    "wedo2.tiltDirection.left": "اليسار ",
    "wedo2.tiltDirection.right": "اليمين",
    "wedo2.tiltDirection.up": "الأعلى ",
    "wedo2.whenDistance": "عندما المسافة [OP] [REFERENCE]",
    "wedo2.whenTilted": "عند الإمالة نحو [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "اللون",
    "paint.paintEditor.saturation": "تشبع اللون",
    "paint.paintEditor.brightness": "السطوع",
    "paint.paintEditor.costume": "المظهر",
    "paint.paintEditor.group": "تجميع",
    "paint.paintEditor.ungroup": "فك تجميع",
    "paint.paintEditor.undo": "تراجع",
    "paint.paintEditor.redo": "إعادة",
    "paint.paintEditor.forward": "طبقة إلى الأمام",
    "paint.paintEditor.backward": "طبقة إلى الخلف",
    "paint.paintEditor.front": "وضع في الطبقة الأولى",
    "paint.paintEditor.back": "وضع في الطبقة الأخيرة",
    "paint.paintEditor.more": "المزيد",
    "paint.modeTools.brushSize": "الحجم",
    "paint.modeTools.eraserSize": "حجم الممحاة",
    "paint.modeTools.copy": "نسخ",
    "paint.modeTools.paste": "لصق",
    "paint.modeTools.delete": "حذف",
    "paint.modeTools.curved": "مقوَّس",
    "paint.modeTools.pointed": "مدبب",
    "paint.modeTools.thickness": "الثخانة",
    "paint.modeTools.flipHorizontal": "اعكس أفقيًا",
    "paint.modeTools.flipVertical": "اعكس شاقوليًا",
    "paint.modeTools.filled": "مملوء",
    "paint.modeTools.outlined": "مؤطَّر",
    "paint.paintEditor.bitmap": "تحويل إلى رسم نقطي",
    "paint.paintEditor.vector": "تحويل إلى رسم متجه",
    "paint.paintEditor.fill": "ملء",
    "paint.paintEditor.stroke": "الإطار",
    "paint.brushMode.brush": "فرشاة",
    "paint.eraserMode.eraser": "ممحاة",
    "paint.fillMode.fill": "الملء",
    "paint.lineMode.line": "خط ",
    "paint.ovalMode.oval": "دائرة",
    "paint.rectMode.rect": "مستطيل",
    "paint.reshapeMode.reshape": "إعادة تشكيل",
    "paint.roundedRectMode.roundedRect": "مستطيل مستدير الزوايا",
    "paint.selectMode.select": "تحديد",
    "paint.textMode.text": "نص",
    "paint.colorPicker.swap": "تبديل"
  },
  "am": {
    "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
    "gui.alerts.tryAgain": "Try Again",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Reconnect",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "ቦርሳ",
    "gui.backpack.errorBackpack": "ስሕተት በየቦርሳውን ጭነት",
    "gui.backpack.loadingBackpack": "በመጫን ላይ...",
    "gui.backpack.more": "More",
    "gui.backpack.emptyBackpack": "ቦርሳው ባዶ ነው",
    "gui.unsupportedBrowser.label": "አሳሽው አልተደገፈም ",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "ኋላ",
    "gui.unsupportedBrowser.previewfaq": "ተጨማሪ ለመልመድ፣ {previewFaqLink} ይጎብኙ ",
    "gui.unsupportedBrowser.previewfaqlinktext": "በብዛት የሚጠየቁ ጥያቄዎች",
    "gui.cards.all-tutorials": "መማሪያዎች",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Close",
    "gui.cards.more-things-to-try": "ተጨማሪ ነገሮች ለመሞከር!",
    "gui.cards.see-more": "ተጨማሪ እዩ ",
    "gui.comingSoon.message1": "አትጨነቁ፣ የሰራንበት ነው {emoji}",
    "gui.comingSoon.message2": "በቅርቡ ይደርሳል...",
    "gui.comingSoon.message3": "የሰራንበት ነው {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "መሳርያዎን ጠጋ አድርጉ፣ ከዛ ፍለጋውን ይጀምሩ።",
    "gui.connection.auto-scanning.pressbutton": "መሳርያዎቻቹን ላይ ያለውን ቁልፍ ጫን አድርጉ።",
    "gui.connection.auto-scanning.start-search": "ፍለጋ ጀምር",
    "gui.connection.connecting-searchbutton": "በፍለጋ ላይ...",
    "gui.connection.auto-scanning.try-again": "እንደገና ይሞክሩ ",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "ተገናኝቷል",
    "gui.connection.disconnect": "አቋርጥ",
    "gui.connection.go-to-editor": "ወደ አርታዒ ሂድ",
    "gui.connection.connecting-cancelbutton": "በመገናኘት ላይ...",
    "gui.connection.error.errorMessage": "ዌይ፣ አንድ ስሕተት ተጋጠመ።",
    "gui.connection.error.tryagainbutton": "እንደገና ይሞክሩ ",
    "gui.connection.error.helpbutton": "እርዳታ",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "አገናኝ",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "መሳሪያዎን በላይ ያለውን ዝርዝር ይምረጡ።",
    "gui.connection.search": "አድስ",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Scratch Linkን እንደጫኑና እንደሚሰራ አረጋግጡ",
    "gui.connection.unavailable.enablebluetooth": "Bluetooth እንደበራ አረጋግጡ",
    "gui.connection.unavailable.tryagainbutton": "እንደገና ይሞክሩ ",
    "gui.connection.unavailable.helpbutton": "እርዳታ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "ሂድ",
    "gui.controls.stop": "አቁም",
    "gui.crashMessage.label": "Oops! Something went wrong.",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Reload",
    "gui.customProcedures.myblockModalTitle": "ጡብ ፍጠር",
    "gui.customProcedures.addAnInputNumberText": "ግቤት ጨምር",
    "gui.customProcedures.numberTextType": "ቁጥር ዌይስ ጽሁፍ",
    "gui.customProcedures.addAnInputBoolean": "ግቤት ጨምር",
    "gui.customProcedures.booleanType": "ቡልያዊ",
    "gui.customProcedures.addALabel": "መሰየሚያ ለጥፍ",
    "gui.customProcedures.runWithoutScreenRefresh": "ፕሮግራሙን ያለ ስክሪኑ ማደስ ክፈት",
    "gui.customProcedures.cancel": "ይቁም",
    "gui.customProcedures.ok": "እሺ",
    "gui.SpriteInfo.direction": "አቅጣጫ",
    "gui.directionPicker.rotationStyles.allAround": "ዙሪያውን",
    "gui.directionPicker.rotationStyles.leftRight": "ግራ/ቀኝ",
    "gui.directionPicker.rotationStyles.dontRotate": "አትዞር",
    "gui.gui.addExtension": "ቅጥያ ጨምር",
    "gui.gui.codeTab": "ኮድ",
    "gui.gui.backdropsTab": "የጀርባ ምስሎች",
    "gui.gui.costumesTab": "አልባሳት",
    "gui.gui.soundsTab": "ድምጾች",
    "gui.extensionLibrary.comingSoon": "በቅርቡ ይመጣል",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "Collaboration with",
    "gui.library.filterPlaceholder": "ፈልጉ",
    "gui.library.allTag": "All",
    "gui.loader.message1": "ጥምሮች በመፍጠር ላይ...",
    "gui.loader.message2": "ስፕራይት በመጫን ላይ...",
    "gui.loader.message3": "ድምጽ በመጫን ላይ...",
    "gui.loader.message4": "ቅጥያ በመጫን ላይ...",
    "gui.loader.message5": "ድመት በማጎራት ላይ...",
    "gui.loader.message6": "ናኖዎች በማሰራጨት ላይ...",
    "gui.loader.message7": "ጎቦዎች በመንፋት ላይ...",
    "gui.loader.message8": "ኤሞጂዎች በማዘጋቸት ላይ...",
    "gui.loader.headline": "ፕሮጀክት በመጫን ላይ",
    "gui.loader.creating": "Creating Project",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "My Stuff",
    "gui.accountMenu.myClasses": "My Classes",
    "gui.accountMenu.myClass": "My Class",
    "gui.accountMenu.accountSettings": "Account settings",
    "gui.accountMenu.signOut": "Sign out",
    "gui.authorInfo.byUser": "by {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "gui.menuBar.language": "Language",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Sign in",
    "login.needHelp": "Need Help?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "መማሪያዎች",
    "gui.menuBar.restoreSprite": "ስፕራይቱን መልስ",
    "gui.menuBar.restoreSound": "ድምጹን መልስ",
    "gui.menuBar.restoreCostume": "ልብሱን መልስ",
    "gui.menuBar.restore": "መልስ",
    "gui.menuBar.saveNow": "አሁን አስቀምጥ",
    "gui.menuBar.saveAsCopy": "እንደ ቅጂ  አስቀምጥ",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "አዲስ",
    "gui.menuBar.file": "ፋይል",
    "gui.menuBar.downloadToComputer": "ወደ ኮምፒዩተርዎ ይቀመጥ",
    "gui.menuBar.edit": "ቀይር",
    "gui.menuBar.turboModeOff": "ቱርቦ ሞድ አጥፋ",
    "gui.menuBar.turboModeOn": "ቱርቦ ሞድ አብራ",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Join Scratch",
    "gui.menuBar.signIn": "Sign in",
    "gui.gui.projectTitlePlaceholder": "Project title here",
    "gui.menuBar.saveNowLink": "Save Now",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Shared",
    "gui.menuBar.share": "አጋራ",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "እርዳታ",
    "gui.modal.back": "ኋላ",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "length {length}",
    "gui.monitor.contextMenu.default": "መደበኛ የሚነበብ ነገር",
    "gui.monitor.contextMenu.large": "ትልቅ የሚነበብ ነገር",
    "gui.monitor.contextMenu.slider": "ማንሸራተቻ",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "ለሁሉም ስፕራይቶች",
    "gui.gui.variableScopeOptionSpriteOnly": "ለዚህ ስፕራይት ብቻ",
    "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
    "gui.gui.variablePromptAllSpritesMessage": "ይህ ተለዋዋጭ ለሁሉም ስፕራይቶች ጠቀቃሚ ይሆናል።",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "ይቁም",
    "gui.prompt.ok": "እሺ",
    "gui.playbackStep.stopMsg": "አቁም",
    "gui.playbackStep.playMsg": "ይጫወታሉ",
    "gui.playbackStep.loadingMsg": "በመጫን ላይ...",
    "gui.playbackStep.saveMsg": "አስቀምጥ",
    "gui.playbackStep.reRecordMsg": "በድጋሜ ቅዳ",
    "gui.recordModal.title": "ድምጹ ቅዳ",
    "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "Stop recording",
    "gui.recordingStep.record": "Record",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "ድምጽ",
    "gui.soundEditor.play": "ይጫወታሉ",
    "gui.soundEditor.stop": "አቁም",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "አስቀምጥ",
    "gui.soundEditor.undo": "መልስ",
    "gui.soundEditor.redo": "ድጋሜ አድርግ",
    "gui.soundEditor.faster": "በፍጥነት",
    "gui.soundEditor.slower": "በዝግታ",
    "gui.soundEditor.echo": "ማስተጋባት",
    "gui.soundEditor.robot": "ሮቦት",
    "gui.soundEditor.louder": "ከፍ በል",
    "gui.soundEditor.softer": "ቀስ በል",
    "gui.soundEditor.reverse": "ቀልብስ",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "ስም",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "ገፀ-ባህርይ",
    "gui.SpriteInfo.show": "አሳይ",
    "gui.SpriteInfo.size": "ልክ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "አባዛ",
    "gui.spriteSelectorItem.contextMenuExport": "ማስወጣት",
    "gui.spriteSelectorItem.contextMenuDelete": "ደምስስ",
    "gui.spriteSelector.addSpriteFromLibrary": "ስፕራይትን ምረጥ",
    "gui.spriteSelector.addSpriteFromPaint": "ቀለም ቅባ",
    "gui.spriteSelector.addSpriteFromSurprise": "አድናቆት",
    "gui.spriteSelector.addSpriteFromFile": "ስፕራይቱን ስቀል",
    "gui.stageHeader.stageSizeLarge": "ወደ የተለቀ መድረክ ለውጥ",
    "gui.stageHeader.stageSizeSmall": "ወደ ያነሰ መድረክ ለውጥ",
    "gui.stageHeader.stageSizeFull": "ሙሉ ማሳያ ሞድ ውስጥ ግባ",
    "gui.stageHeader.stageSizeUnFull": "ከሙሉ ማሳያ ሞድ ውስጥ ውጣ",
    "gui.stageHeader.fullscreenControl": "ሙሉ ማሳይ አመራር",
    "gui.spriteSelector.addBackdropFromLibrary": "የጀርባ ምስል ይምረጡ",
    "gui.stageSelector.addBackdropFromPaint": "ቀለም ቅባ",
    "gui.stageSelector.addBackdropFromSurprise": "አድናቆት",
    "gui.stageSelector.addBackdropFromFile": "የጀርባ ምስሉን ስቀል",
    "gui.stageSelector.stage": "መድረክ",
    "gui.stageSelector.backdrops": "የጀርባ ምስሎች",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "ተርቦ ሞድ",
    "gui.webglModal.label": "የእርስዎ አሳሽ WebGL አይደግፍም",
    "gui.webglModal.description": "ይቅርታ፣ የእርዎ አሳሽ ዌይስ ኮምፒዩተር {webGlLink}ን አይደግፍም። ይህ ቴክኖሎጂ አስፈላጊ ነው ለScratch 3.0።",
    "gui.webglModal.webgllink": "WebGLን አይደግፍም",
    "gui.webglModal.back": "ኋላ",
    "gui.webglModal.previewfaq": "ተጨማሪ ለመልመድ፣ {previewFaqLink} ይጎብኙ።",
    "gui.webglModal.previewfaqlinktext": "በብዛት የሚጠየቁ ጥያቄዎች",
    "gui.costumeLibrary.chooseABackdrop": "የጀርባ ምስል ይምረጡ",
    "gui.costumeLibrary.chooseACostume": "ልብስ ይምረጡ",
    "gui.costumeTab.addBackdropFromLibrary": "የጀርባ ምስል ይምረጡ",
    "gui.costumeTab.addCostumeFromLibrary": "ልብስ ይምረጡ",
    "gui.costumeTab.addBlankCostume": "ቀለም ቅባ",
    "gui.costumeTab.addSurpriseCostume": "አድናቆት",
    "gui.costumeTab.addFileBackdrop": "የጀርባ ምስሉን ስቀል",
    "gui.costumeTab.addFileCostume": "ልብሱን ስቀል",
    "gui.extensionLibrary.chooseAnExtension": "ቅጥያ ይምረጡ",
    "gui.extensionLibrary.extensionUrl": "የቅጥያው ገፅ አድራሻ ያስገቡ",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "መቅዳት መጀመር አልተቻለም",
    "gui.soundLibrary.chooseASound": "ድምጽ ይምረጡ",
    "gui.soundTab.fileUploadSound": "ድምጹን ስቀል",
    "gui.soundTab.surpriseSound": "አድናቆት",
    "gui.soundTab.recordSound": "ቅዳ",
    "gui.soundTab.addSoundFromLibrary": "ድምጽ ይምረጡ",
    "gui.spriteLibrary.chooseASprite": "ስፕራይትን ምረጥ",
    "gui.tipsLibrary.tutorials": "አጋዥ ስልጠና ይምረጡ",
    "gui.alerts.createsuccess": "New project created.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Could not create the project. Please try again!",
    "gui.alerts.savingError": "Project could not save.",
    "gui.alerts.savesuccess": "Project saved.",
    "gui.alerts.saving": "Saving project…",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "መጀመር",
    "gui.howtos.intro-move.step_stepMove": "የእንቅስቃሴ ብሎኬታ ይጨመር",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "ስምዎን ያቀናብሩ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "የፊደል ስፕራይት ይምረጡ",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "ድምጽ ይጫወት ጠቅ ሲደረግ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "ሌላ ፊደል ይምረጡ",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "ቀለም ቀይር",
    "gui.howtos.animate-a-name.step_AnimateSpin": "ተጨማሪ የፊደል ስፕራይት ይምረጡና ያዘዋውሩት",
    "gui.howtos.animate-a-name.step_AnimateGrow": "ተጨማሪ የፊደል ስፕራይት ይምረጡና ያሳድጉት",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "ሙዚቃ ይፍጠሩ",
    "gui.howtos.Make-Music.step_PickInstrument": "የመሳሪያ ስፕራይት ይምረጡ",
    "gui.howtos.Make-Music.step_PlaySoundClick": "ድምጽ አጫውት ጠቅ ሲደረግ",
    "gui.howtos.Make-Music.step_MakeSong": "ዘፈን ይፍጠሩ",
    "gui.howtos.make-music.step_MakeBeat": "ታምቡር ይምረጡና ምት ይስሩ",
    "gui.howtos.make-music.step_MakeBeatBox": "የማይክሮፎን ስፕራይቱንና አድናቆት ቢትቦክሱን ይምረጡ",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "የክትትል ጨዋታ ይገንቡ",
    "gui.howtos.Chase-Game.step_BG": "የጀርባ ምስልን ጨምር",
    "gui.howtos.chase-game.step_AddOcto": "ስፕራይትን ጨምር",
    "gui.howtos.make-music.step_LeftRight": "ወደ ቀኝና ግራ ተንቀሳቅስ ከየቀስት ቁልፎች",
    "gui.howtos.Chase-Game.step_UpDown": "ወደ ላይና ታች ተንቀሳቅስ ከየቀስት ቁልፎች",
    "gui.howtos.Chase-Game.step_AddStar": "ሌላ ስፕራይት ጨምር",
    "gui.howtos.Chase-Game.step_MoveRandom": "በራንደም ተንቀሳቅስ",
    "gui.howtos.Chase-Game.step_WhenTouch": "በኦክቶፐስ ስፕራይቱ፣ ሲነካ ድምጽ አጫውት",
    "gui.howtos.Chase-Game.step_ScoreVariable": "የቆጣሪ ተለዋዋጭ ይፍጠሩ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "በኦክቶፐስ ስፕራይቱ፣ ሲነካ ቆጣሪ ጨምር",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "የጠቅ ጨዋታ ይገንቡ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "ስፕራይትን ይምረጡ",
    "gui.howtos.make-a-game.step_GamePlaySound": "ድምጽ አጫውት ጠቅ ሲደረግ",
    "gui.howtos.make-a-game.step_GameAddScore": "የቆጣሪ ተለዋዋጭ ይፍጠሩ",
    "gui.howtos.make-a-game.step_GameChangeScore": "ጠቅ ሲደረግ ቆጣሪው ይጨመር",
    "gui.howtos.make-a-game.step_Random": "ወደ ራንደም ቦታ ሂድ",
    "gui.howtos.make-music.step_GameChangeColor": "ቀለም ቀይር",
    "gui.howtos.make-music.step_ResetScore": "ቆጣሪውን ደግምህ አስጀምር",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "ስፕራይትን ጨምር",
    "gui.howtos.add-sprite.step_addSprite": "ስፕራይትን ጨምር",
    "gui.howtos.add-a-backdrop.name": "የጀርባ ምስል ጨምር",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "ልኩን ቀይር",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "ተንሸራተት",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "ድምጽን ቅዳ",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "አሽከርክረው",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "ደብቅና አሳይ",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "ስፕራይትን አኒሜት አድርግ",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "ቀስት ቁልፎች ይጠቀሙ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "ተጽእኖዎች ጨምር",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "ሙዚቃ",
    "gui.extension.music.description": "መሳሪያዎችና ታምቡሮች ተጫወት",
    "gui.extension.pen.name": "ብዕር",
    "gui.extension.pen.description": "ከየእርስዎ ስፕራይቶች ይሳሉ",
    "gui.extension.videosensing.name": "የቪድዮ ህዋስ",
    "gui.extension.videosensing.description": "እንቅስቃሴ ስማ ከካሜራው",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description": "Translate text into many languages.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "የእርስዎ ፕሮጀክቶች ያገናኙ ከዓለሙ ጋር",
    "gui.extension.microbit.connectingMessage": "በመገናኘት ላይ ነው",
    "gui.extension.ev3.description": "በይነግንኙነት ሮቦቶችና ተጨማሪ ነገሮች ይገንቡ",
    "gui.extension.ev3.connectingMessage": "በመገናኘት ላይ ነው። EV3 ላይ ያለው ዕስፒልዎ ወደ 1234 እንደተቀየረ ያረጋግጡ።",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "ከሞተሮችና ቃኚዎች ይገንቡ።",
    "gui.extension.wedo2.connectingMessage": "በመገናኘት ላይ ነው",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "All",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dance",
    "gui.libraryTags.effects": "Effects",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Indoors",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Music",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Outdoors",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "People",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Underwater",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Games",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "size",
    "gui.opcodeLabels.costumename": "costume name",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "backdrop name",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "answer",
    "gui.opcodeLabels.loudness": "loudness",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "year",
    "gui.opcodeLabels.month": "month",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "day of week",
    "gui.opcodeLabels.hour": "hour",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "second",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "የተመረጠው ፕሮጀክት ሰንድ ለመጫን አልተሳካም",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "በ[NOTE] ኖታ ጲጵ በል ለ[TIME] ሰከንድ",
    "ev3.buttonPressed": "[PORT]ን ቁልፍ ተጭኗል?",
    "ev3.getBrightness": "የብርሀን መጠን",
    "ev3.getDistance": "ርቀት",
    "ev3.getMotorPosition": "[PORT]ን ሞተር አኳኋን",
    "ev3.motorSetPower": "የ [PORT]ን ሞተር ሃይል ወደ [POWER]% ለውጥ",
    "ev3.motorTurnClockwise": "የ[PORT] ሞተር በዚህ አቅጣጫ አዙር ለ[TIME] ሰከንድ",
    "ev3.motorTurnCounterClockwise": "የ[PORT] ሞተር በዚያ አቅጣጫ አዙር ለ[TIME] ሰከንድ",
    "ev3.whenBrightnessLessThan": "ብሩህነት < [DISTANCE] ሲሆን",
    "ev3.whenButtonPressed": "[PORT]ን ቁልፍ ሲጫን",
    "ev3.whenDistanceLessThan": "ርቀት < [DISTANCE] ሲሆን",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "down",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "left",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "right",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "up",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "የቱም",
    "microbit.clearDisplay": "ማሳያ አጽዳ",
    "microbit.defaultTextToDisplay": "ሰላም!",
    "microbit.displaySymbol": "[MATRIX]ን አሳይ",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gesturesMenu.jumped": "ዘልሏል",
    "microbit.gesturesMenu.moved": "ተንቀሳቅሷል",
    "microbit.gesturesMenu.shaken": "አራድቷል",
    "microbit.isButtonPressed": "[BTN]ን ቁልፍ ተጭኗል?",
    "microbit.isTilted": "በ[DIRECTION] አቅጣጫ ተዘነብሏል?",
    "microbit.pinStateMenu.off": "የጠፋ",
    "microbit.pinStateMenu.on": "እየሰራ ያለ",
    "microbit.tiltAngle": "ማዕዘን በ[DIRECTION] አቅጣጫ አዘንብል",
    "microbit.tiltDirectionMenu.any": "የቱም",
    "microbit.tiltDirectionMenu.back": "ኋላ",
    "microbit.tiltDirectionMenu.front": "ፊት",
    "microbit.tiltDirectionMenu.left": "ግራ",
    "microbit.tiltDirectionMenu.right": "ቀኝ",
    "microbit.whenButtonPressed": "[BTN]ን ቁልፍ ሲጫን",
    "microbit.whenGesture": "[GESTURE]ን ሲሰጥ",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "በ[DIRECTION] አቅጣጫ ሲዘነብል",
    "music.categoryName": "ሙዚቃ",
    "music.changeTempo": "ሰልት ቀይር በ[TEMPO]",
    "music.drumBass": "(2) ትልቅ ታምቡር",
    "music.drumBongo": "(13) ቦንጎ",
    "music.drumCabasa": "(13) ካባሳ",
    "music.drumClaves": "(9) ክላቭ",
    "music.drumClosedHiHat": "(6) የተዘጋ ድምፀ ብረት",
    "music.drumConga": "(14) ኮንጋ",
    "music.drumCowbell": "(11) የላም ቃጭል",
    "music.drumCrashCymbal": "(4) ጸናጽል",
    "music.drumCuica": "(18) ኲካ",
    "music.drumGuiro": "(16) ጒሮ",
    "music.drumHandClap": "(8) ጭብጨባ",
    "music.drumOpenHiHat": "(5) የተከፈተ ድምፀ ብረት",
    "music.drumSideStick": "(3) የጎን በትር",
    "music.drumSnare": "(1) ነዛሪ ታምቡር",
    "music.drumTambourine": "(7) ታምቡሪን",
    "music.drumTriangle": "(12) ትራያንግል",
    "music.drumVibraslap": "(17) ቫይብራስላፕ",
    "music.drumWoodBlock": "(10) የእንጨት ብሎኬት",
    "music.getTempo": "ምት",
    "music.instrumentBass": "(6) ባስ",
    "music.instrumentBassoon": "(14) ባዙን",
    "music.instrumentCello": "(8) ቼሎ",
    "music.instrumentChoir": "(15) ሕብረ-ዝማሬ",
    "music.instrumentClarinet": "(10) ክላርኔት",
    "music.instrumentElectricGuitar": "(5) ኤሌክትሪክ ጊታር",
    "music.instrumentElectricPiano": "(2) ኤሌክትሪክ ፒያኖ",
    "music.instrumentFlute": "(12) ፍሉት",
    "music.instrumentGuitar": "(4) ጊታር",
    "music.instrumentMarimba": "(19) ማሪምባ",
    "music.instrumentMusicBox": "(17) የሙዚቃ ሳጥን",
    "music.instrumentOrgan": "(3) ኦርጋን",
    "music.instrumentPiano": "(1) ፒያኖ",
    "music.instrumentPizzicato": "(7) ፒዚካቶ",
    "music.instrumentSaxophone": "(11) ሳክስፎን",
    "music.instrumentSteelDrum": "(18) ብረት ታምቡር",
    "music.instrumentSynthLead": "(20) የመራሄ ድምፅ መምሪያ",
    "music.instrumentSynthPad": "(21) የመራሄ ድምፅ ደረብ",
    "music.instrumentTrombone": "(9) ትሮምቦን",
    "music.instrumentVibraphone": "(16) ቫይብራፎን",
    "music.instrumentWoodenFlute": "(13) የእንጨት ፍሉት",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
    "music.playDrumForBeats": "[DRUM]ን ታምቡር ለ[BEATS] ምት ተጫውት",
    "music.playNoteForBeats": "[NOTE]ን ኖታ ለ[BEATS] ምት ተጫውት",
    "music.restForBeats": "እረፍ ለ[BEATS] ምት",
    "music.setInstrument": "መሳሪያ ለውጥ ወደ [INSTRUMENT]",
    "music.setTempo": "ስልት ለውጥ ወደ [TEMPO]",
    "pen.categoryName": "ብዕር",
    "pen.changeColorParam": "የእስክሪብቶን [COLOR_PARAM] ቀይር በ[VALUE]",
    "pen.changeHue": "የእስክሪብቶን ቀልም ቀይር በ[HUE]",
    "pen.changeShade": "የእስክሪብቶን ጥቁረት ቀይር በ[SHADE]",
    "pen.changeSize": "የእስክሪብቶን ልክ ቀይር በ[SIZE]",
    "pen.clear": "ሁሉንም አስወግድ",
    "pen.colorMenu.brightness": "የብርሀን መጠን",
    "pen.colorMenu.color": "ቀለም",
    "pen.colorMenu.saturation": "ርኬት",
    "pen.colorMenu.transparency": "አሳይነት",
    "pen.penDown": "ብእር አሳርፍ",
    "pen.penUp": "ብእር አንሳ",
    "pen.setColor": "የእስክሪብቶን ቀልም ወደ [COLOR] ለውጥ",
    "pen.setColorParam": "የእስክሪብቶን [COLOR_PARAM] ወደ [VALUE] ለውጥ",
    "pen.setHue": "የእስክሪብቶን ቀለም ወደ [HUE] ለውጥ",
    "pen.setShade": "የእስክሪብቶን ጥቁረት ወደ [SHADE] ለውጥ",
    "pen.setSize": "የእስክሪብቶን ልክ ወደ [SIZE] ለውጥ",
    "pen.stamp": "ምልክት",
    "speech.defaultWhenIHearValue": "ዕንሂድ",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "አዳምጥና ጠብቅ",
    "speech.speechReporter": "ንግግር",
    "speech.whenIHear": "[PHRASE]ን ሣዳምጥ",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "giant",
    "text2speech.kitten": "የድመት ግልገል",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "ድምጽ ወደ [VOICE] ለውጥ",
    "text2speech.speakAndWaitBlock": "[WORDS]ን ተናገር",
    "text2speech.squeak": "ሲጢት ማለት",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Translate",
    "translate.defaultTextToTranslate": "ሰላም",
    "translate.translateBlock": "[WORDS]ን ተርጉም ወደ [LANGUAGE]",
    "translate.viewerLanguage": "ቋንቋ",
    "videoSensing.categoryName": "የቪድዮ ህዋስ",
    "videoSensing.direction": "አቅጣጫ",
    "videoSensing.motion": "እንቅስቃሴ",
    "videoSensing.off": "የጠፋ",
    "videoSensing.on": "እየሰራ ያለ",
    "videoSensing.onFlipped": "ሲገለብጥ",
    "videoSensing.setVideoTransparency": "የቪድዮ አሳይነት ወደ [TRANSPARENCY] ለውጥ",
    "videoSensing.sprite": "ስፕራይት",
    "videoSensing.stage": "መድረክ",
    "videoSensing.videoOn": "ቪድዮ [ATTRIBUTE] ስለ [SUBJECT]",
    "videoSensing.videoToggle": "ቪድዮ ወደ [VIDEO_STATE] ቀይር",
    "videoSensing.whenMotionGreaterThan": "የቪድዮ እንቅስቃሴ > [REFERENCE] ሲሆን",
    "wedo2.getDistance": "ርቀት",
    "wedo2.getTiltAngle": "የዝንባሌ ማዕዘን [TILT_DIRECTION]",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY]ተዘነብሏል? ",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "reverse",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "[MOTOR_ID]ን ሞተር አጥፋ",
    "wedo2.motorOn": "[MOTOR_ID]ን ሞተር አብራ",
    "wedo2.motorOnFor": "[MOTOR_ID]ን ሞተር አብራ ለ[DURATION] ሰከንድ ",
    "wedo2.playNoteFor": "[NOTE]ን ኖታ ለ[DURATION] ተጫወት",
    "wedo2.setLightHue": "የመብራት ቀለም ወደ [HUE] ለውጥ",
    "wedo2.setMotorDirection": "የ[MOTOR_ID]ን ሞተር አቅጣጫ ወደ [MOTOR_DIRECTION] ለውጥ",
    "wedo2.startMotorPower": "የ[MOTOR_ID]ን ሞተር ኃይል ወደ [POWER] ለውጥ",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "down",
    "wedo2.tiltDirection.left": "left",
    "wedo2.tiltDirection.right": "right",
    "wedo2.tiltDirection.up": "up",
    "wedo2.whenDistance": "ርቀት [OP] [REFERENCE] ሲሆን",
    "wedo2.whenTilted": "በ[TILT_DIRECTION_ANY] ሲዘነብል",
    "paint.paintEditor.hue": "ቀለም",
    "paint.paintEditor.saturation": "ርኬት",
    "paint.paintEditor.brightness": "ብሩህነት",
    "paint.paintEditor.costume": "ልብስ",
    "paint.paintEditor.group": "ቡድን",
    "paint.paintEditor.ungroup": "በቡድን የተመደበውን በተን",
    "paint.paintEditor.undo": "መልስ",
    "paint.paintEditor.redo": "ድጋሜ አድርግ",
    "paint.paintEditor.forward": "ወደፊት",
    "paint.paintEditor.backward": "ወደኋላ",
    "paint.paintEditor.front": "ፊት",
    "paint.paintEditor.back": "ኋላ",
    "paint.paintEditor.more": "ተጨማሪ",
    "paint.modeTools.brushSize": "ልክ",
    "paint.modeTools.eraserSize": "የላጲስ ልክ",
    "paint.modeTools.copy": "ቅዳ",
    "paint.modeTools.paste": "ለጥፍ",
    "paint.modeTools.delete": "አጥፋ",
    "paint.modeTools.curved": "የታጠፈ",
    "paint.modeTools.pointed": "ሾለ",
    "paint.modeTools.thickness": "ውፍረት",
    "paint.modeTools.flipHorizontal": "በግድምታ አሽከርክር",
    "paint.modeTools.flipVertical": "በሽቅብዮሽ አሽከርክር",
    "paint.modeTools.filled": "የተሟላ",
    "paint.modeTools.outlined": "የተቀረፀ",
    "paint.paintEditor.bitmap": "ወደ ንድፈ ቅንጣት ለውጥ",
    "paint.paintEditor.vector": "ወደ ቬክተር ለውጥ",
    "paint.paintEditor.fill": "ምላት",
    "paint.paintEditor.stroke": "ቅረፅ",
    "paint.brushMode.brush": "ብሩሽ",
    "paint.eraserMode.eraser": "ላጲስ",
    "paint.fillMode.fill": "ምላት",
    "paint.lineMode.line": "መስመር",
    "paint.ovalMode.oval": "ክብ",
    "paint.rectMode.rect": "አራት ማዕዘን",
    "paint.reshapeMode.reshape": "እንደገና ቅረጽ",
    "paint.roundedRectMode.roundedRect": "የተድበለበለ አራት ማዕዘን",
    "paint.selectMode.select": "ምረጥ",
    "paint.textMode.text": "ጽሀፍ",
    "paint.colorPicker.swap": "ለዋውጥ"
  },
  "an": {
    "gui.alerts.lostPeripheralConnection": "S'ha perdiu la connexión con {extensionName}.",
    "gui.alerts.tryAgain": "Torna a prebar-lo",
    "gui.alerts.download": "Descargar",
    "gui.connection.reconnect": "Reconnectar",
    "gui.backpack.costumeLabel": "vestiu",
    "gui.backpack.soundLabel": "son",
    "gui.backpack.scriptLabel": "programa",
    "gui.backpack.spriteLabel": "obchecto",
    "gui.backpack.header": "Muchila",
    "gui.backpack.errorBackpack": "Error en cargar la muchila",
    "gui.backpack.loadingBackpack": "Cargando...",
    "gui.backpack.more": "Mas",
    "gui.backpack.emptyBackpack": "La muchila ye vueda",
    "gui.unsupportedBrowser.label": "Lo navegador no ye compatible",
    "gui.unsupportedBrowser.errorLabel": "Ha ocurriu una error",
    "gui.unsupportedBrowser.notRecommended": "Lo sentimos muito, pero pareixe que Scratch no suporta la versión d'o tuyo navegador. Te recomendamos actualizar a la zaguera versión d'un navegador con suporte, como Google Chrome, Mozilla Firefox, Microsoft Edge u Apple Safari.",
    "gui.unsupportedBrowser.description": "Lo sentimos muito, pero Scratch no ofreix suporte pa este navegador. Te recomendamos actualizar a la zaguera versión d'un navegador con suporte, como Google Chrome, Mozilla Firefox, Microsoft Edge u Apple Safari.",
    "gui.unsupportedBrowser.back": "Dezaga",
    "gui.unsupportedBrowser.previewfaq": "Pa conoixer mas, visita las {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Preguntas freqüents (FAQ)",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Achiquir",
    "gui.cards.expand": "Expandir",
    "gui.cards.close": "Zarrar",
    "gui.cards.more-things-to-try": "Mas cosetas pa prebar!",
    "gui.cards.see-more": "Veyer mas",
    "gui.comingSoon.message1": "No te'n fagas, somos en ixo {emoji}",
    "gui.comingSoon.message2": "Proximament...",
    "gui.comingSoon.message3": "Somos treballando en ixo {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No s'han trobau dispositivos",
    "gui.connection.auto-scanning.prescan": "Tiene lo tuyo dispositivo cerca, y alavez empecipia a buscar.",
    "gui.connection.auto-scanning.pressbutton": "Preta lo botón d'o tuyo dispositivo.",
    "gui.connection.auto-scanning.start-search": "Empecipiar a buscar",
    "gui.connection.connecting-searchbutton": "Buscando...",
    "gui.connection.auto-scanning.try-again": "Prebar de nuevo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Actualizar lo mío dispositivo",
    "gui.connection.connected": "Connectau",
    "gui.connection.disconnect": "Desconnectar",
    "gui.connection.go-to-editor": "Ir ta lo editor",
    "gui.connection.connecting-cancelbutton": "Connectando...",
    "gui.connection.error.errorMessage": "Ups, pareixe que bella cosa ha fallau.",
    "gui.connection.error.tryagainbutton": "Prebar de nuevo",
    "gui.connection.error.helpbutton": "Aduya",
    "gui.connection.peripheral-name-label": "Nombre d'o dispositivo",
    "gui.connection.connect": "Connectar",
    "gui.connection.scanning.lookingforperipherals": "Buscando dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "No s'ha trobau dispositivos",
    "gui.connection.scanning.instructions": "Tría lo tuyo dispositivo d'a lista.",
    "gui.connection.search": "Actualizar",
    "gui.connection.scanning.updatePeripheralButton": "Actualizar lo mío dispositivo",
    "gui.connection.unavailable.installscratchlink": "Asegura-te que tiens Scratch Link instalau y ubierto",
    "gui.connection.unavailable.enablebluetooth": "Compreba que Bluetooth sía habilitau",
    "gui.connection.unavailable.tryagainbutton": "Prebar de nuevo",
    "gui.connection.unavailable.helpbutton": "Aduya",
    "gui.connection.updatePeripheral.microBitConnect": "Connecta lo tuyo {extensionName}a este dispositivo per medio d'un cable USB.",
    "gui.connection.updatePeripheral.pressUpdate": "Preta \"Actualizar\" y deixa que se complete l'actualización.",
    "gui.connection.updatePeripheral.progress": "Actualizando {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Actualización completada!",
    "gui.connection.updatePeripheral.updateFailed": "Error d'actualización.",
    "gui.connection.updatePeripheral.goBackButton": "Retornar",
    "gui.connection.updatePeripheral.updateNowButton": "Actualizar",
    "gui.connection.updatePeripheral.updateAgainButton": "Torna a prebar-lo",
    "gui.controls.go": "Ir",
    "gui.controls.stop": "Aturar",
    "gui.crashMessage.label": "Ups! Bella cosa ha fallau.",
    "gui.crashMessage.description": "Lo sentimos muito, pero pareixe que Scratch ha deixau de funcionar. Ya hemos informau d'este fallo a lo Scratch Team. Per favor, torna a cargar la pachina y preba-lo de nuevo.",
    "gui.crashMessage.errorNumber": "La suya error ha estau rechistrada con ID {errorId}",
    "gui.crashMessage.reload": "Tornar a cargar",
    "gui.customProcedures.myblockModalTitle": "Creyar un bloque",
    "gui.customProcedures.addAnInputNumberText": "Anyadir una dentrada",
    "gui.customProcedures.numberTextType": "numero u texto",
    "gui.customProcedures.addAnInputBoolean": "Anyadir una dentrada",
    "gui.customProcedures.booleanType": "lochica",
    "gui.customProcedures.addALabel": "Anyadir una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Executar a l'inte",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "Acceptar",
    "gui.SpriteInfo.direction": "Dirección",
    "gui.directionPicker.rotationStyles.allAround": "Tot alredor",
    "gui.directionPicker.rotationStyles.leftRight": "Zurda/Dreita",
    "gui.directionPicker.rotationStyles.dontRotate": "No rotar",
    "gui.gui.addExtension": "Anyadir extensión",
    "gui.gui.codeTab": "Codigo",
    "gui.gui.backdropsTab": "Fondos",
    "gui.gui.costumesTab": "Vestius",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Proximament...",
    "gui.extensionLibrary.requires": "Requiere",
    "gui.extensionLibrary.collaboration": "En colaboración con",
    "gui.library.filterPlaceholder": "Busca",
    "gui.library.allTag": "Totz",
    "gui.loader.message1": "Creyando bloques ...",
    "gui.loader.message2": "Cargando obchectos...",
    "gui.loader.message3": "Cargando sons...",
    "gui.loader.message4": "Cargando extensions...",
    "gui.loader.message5": "Muyindo cardelinas...",
    "gui.loader.message6": "Transmitindo nanos...",
    "gui.loader.message7": "Inflando gobos...",
    "gui.loader.message8": "Preparando emojis...",
    "gui.loader.headline": "Cargando prochecto",
    "gui.loader.creating": "Creyando lo prochecto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Las mías cosetas",
    "gui.accountMenu.myClasses": "Las mías clases",
    "gui.accountMenu.myClass": "La mía clase",
    "gui.accountMenu.accountSettings": "Configuración d'a cuenta",
    "gui.accountMenu.signOut": "Salir",
    "gui.authorInfo.byUser": "per {username}",
    "gui.menuBar.seeProjectPage": "Veyer pachina d'o prochecto",
    "gui.menuBar.language": "Idioma",
    "general.username": "Nombre d'usuario",
    "general.password": "Clau",
    "general.signIn": "Iniciar sesión",
    "login.needHelp": "Te cal aduya?",
    "form.validationRequired": "Este campo ye obligatorio",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Restaurar obchecto",
    "gui.menuBar.restoreSound": "Restaurar son",
    "gui.menuBar.restoreCostume": "Restaurar disfraz",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Alzar agora",
    "gui.menuBar.saveAsCopy": "Alzar una copia",
    "gui.menuBar.remix": "Remesclar",
    "gui.menuBar.new": "Nuevo",
    "gui.menuBar.file": "Fichero",
    "gui.menuBar.downloadToComputer": "Alzar en o tuyo ordinador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desactivar lo modo Turbo",
    "gui.menuBar.turboModeOn": "Activar lo modo Turbo",
    "gui.menuBar.modeMenu": "Modo",
    "gui.menuBar.normalMode": "Modo normal",
    "gui.menuBar.caturdayMode": "Modo Caturday",
    "gui.menuBar.joinScratch": "#Unir a Scratch",
    "gui.menuBar.signIn": "Iniciar sesión",
    "gui.gui.projectTitlePlaceholder": "Nombre d'o prochecto aquí",
    "gui.menuBar.saveNowLink": "Alzar agora",
    "gui.menuBar.settings": "Configuracions",
    "gui.menuBar.isShared": "Compartius",
    "gui.menuBar.share": "Compartir",
    "gui.menuBar.colorMode": "Modo de color",
    "gui.modal.help": "Aduya",
    "gui.modal.back": "Dezaga",
    "gui.monitor.listMonitor.empty": "(vueda)",
    "gui.monitor.listMonitor.listLength": "longaria {length}",
    "gui.monitor.contextMenu.default": "grandaria normal",
    "gui.monitor.contextMenu.large": "grandaria gran",
    "gui.monitor.contextMenu.slider": "eslizador",
    "gui.monitor.contextMenu.sliderRange": "cambiar rango d'o eslizador",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "amagar",
    "gui.playButton.play": "Reproducir",
    "gui.playButton.stop": "Aturar",
    "gui.gui.variableScopeOptionAllSprites": "Pa totz los obchectos",
    "gui.gui.variableScopeOptionSpriteOnly": "Nomás pa este obchecto",
    "gui.gui.cloudVariableOption": "Variable en a boira (alzada en o servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variable será disponible en totz los obchectos.",
    "gui.gui.listPromptAllSpritesMessage": "Esta lista será disponible pa totz los obchectos.",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "Acceptar",
    "gui.playbackStep.stopMsg": "Aturar",
    "gui.playbackStep.playMsg": "Reproducir",
    "gui.playbackStep.loadingMsg": "Cargando...",
    "gui.playbackStep.saveMsg": "Alzar",
    "gui.playbackStep.reRecordMsg": "Tornar a gravar",
    "gui.recordModal.title": "Gravar son",
    "gui.recordingStep.beginRecord": "Prencipia a gravar fendo clic en o siguient botón",
    "gui.recordingStep.permission": "{arrow}Nos cal lo tuyo permiso pa usar lo microfono",
    "gui.recordingStep.stop": "Deixar de gravar",
    "gui.recordingStep.record": "Gravar",
    "gui.sliderModal.min": "Valor minima",
    "gui.sliderModal.max": "Valor maxima",
    "gui.sliderModal.title": "Cambiar rango d'o eslizador",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "Acceptar",
    "gui.soundEditor.sound": "Son",
    "gui.soundEditor.play": "Reproducir",
    "gui.soundEditor.stop": "Aturar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Apegar",
    "gui.soundEditor.copyToNew": "Copiar en nuevo",
    "gui.soundEditor.delete": "Eliminar",
    "gui.soundEditor.save": "Alzar",
    "gui.soundEditor.undo": "Desfer",
    "gui.soundEditor.redo": "Refer",
    "gui.soundEditor.faster": "Mas rapido",
    "gui.soundEditor.slower": "Mas lento",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Mas fuerte",
    "gui.soundEditor.softer": "Mas suau",
    "gui.soundEditor.reverse": "Invertir",
    "gui.soundEditor.fadeOut": "Desapareixer",
    "gui.soundEditor.fadeIn": "Amaneixer",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nombre",
    "gui.SpriteInfo.showSpriteAction": "Amostrar obchecto",
    "gui.SpriteInfo.hideSpriteAction": "Amagar obchecto",
    "gui.SpriteInfo.sprite": "Obchecto",
    "gui.SpriteInfo.show": "Amostrar",
    "gui.SpriteInfo.size": "Grandaria",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "borrar",
    "gui.spriteSelector.addSpriteFromLibrary": "Tría un obchecto",
    "gui.spriteSelector.addSpriteFromPaint": "Pinta",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Puyar obchecto",
    "gui.stageHeader.stageSizeLarge": "Cambiar a escenario gran",
    "gui.stageHeader.stageSizeSmall": "Cambiar a escenario chicot",
    "gui.stageHeader.stageSizeFull": "Ir a modo pantalla completa",
    "gui.stageHeader.stageSizeUnFull": "Salir d'o modo de pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control a pantalla completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Tría un fondo",
    "gui.stageSelector.addBackdropFromPaint": "Pinta",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Carga un fondo",
    "gui.stageSelector.stage": "Escenario",
    "gui.stageSelector.backdrops": "Fondos",
    "gui.telemetryOptIn.label": "Reportar las estatisticas pa amillorar Scratch",
    "gui.telemetryOptIn.body1": "L'Equipo de Scratch busca comprender d'a millor forma cómo s'utiliza Scratch arredol d'o mundo. Pa emparar istos esfuerzos, puede permitir que Scratch ninvie información d'uso de forma automatica a l'Equipo de Scratch.",
    "gui.telemetryOptIn.body2": "La información que recopilamos incluye selección d'idioma, uso de bloques y qualques eventos como alzar, cargar y puyar un prochecto. NO replegamos garra información personal. Per favor, consulta nuestra {privacyPolicyLink} pa mas información.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politica de privacidat",
    "gui.telemetryOptIn.optInText": "Compartir os míos datos d'uso con l'equipo de Scratch",
    "gui.telemetryOptIn.optInTooltip": "Habilitar telemetría",
    "gui.telemetryOptIn.optOutText": "No compartir os míos datos d'uso con l'equipo de Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Desactivar la telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "A tuya configuración estió actualizada.",
    "gui.telemetryOptIn.buttonClose": "Zarrar",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "Lo tuyo navegador no suporta WebGL",
    "gui.webglModal.description": "Lamentablement pareixe que lo tuyo navegador u ordinador {webGlLink}. Esta tecnolochía ye necesaria pa executar Scratch 3.0.",
    "gui.webglModal.webgllink": "no suporta WebGL",
    "gui.webglModal.back": "Dezaga",
    "gui.webglModal.previewfaq": "Pa conoixer mas, visita las {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Preguntas freqüents (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "Tría un fondo",
    "gui.costumeLibrary.chooseACostume": "Tría un disfraz",
    "gui.costumeTab.addBackdropFromLibrary": "Tría un fondo",
    "gui.costumeTab.addCostumeFromLibrary": "Tría un disfraz",
    "gui.costumeTab.addBlankCostume": "Pinta",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Carga un fondo",
    "gui.costumeTab.addFileCostume": "Carga un vestiu",
    "gui.extensionLibrary.chooseAnExtension": "Tría una extensión",
    "gui.extensionLibrary.extensionUrl": "Introduz la URL d'a extensión",
    "gui.monitors.importListColumnPrompt": "Qué columna ha d'usar-se (1- {numberOfColumns})?",
    "gui.recordingStep.alertMsg": "No s'ha puesto empecipiar a gravar",
    "gui.soundLibrary.chooseASound": "Tría un son",
    "gui.soundTab.fileUploadSound": "Carga un son",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Gravar",
    "gui.soundTab.addSoundFromLibrary": "Tría un son",
    "gui.spriteLibrary.chooseASprite": "Tría un obchecto",
    "gui.tipsLibrary.tutorials": "Tría un tutorial",
    "gui.alerts.createsuccess": "Nuevo prochecto creyau.",
    "gui.alerts.createcopysuccess": "Prochecto alzau como copia.",
    "gui.alerts.createremixsuccess": "Prochecto alzau como remescla.",
    "gui.alerts.creating": "Creyando nuevo...",
    "gui.alerts.creatingCopy": "Copiando prochecto...",
    "gui.alerts.creatingRemix": "Remesclando prochecto...",
    "gui.alerts.creatingError": "No s'ha puesto creyar lo prochecto. Per favor, preba-lo de nuevo!",
    "gui.alerts.savingError": "No s'ha puesto alzar lo prochecto.",
    "gui.alerts.savesuccess": "Prochecto alzau.",
    "gui.alerts.saving": "Alzando prochecto...",
    "gui.alerts.cloudInfo": "Faga-se cuenta que las variables en a boira nomás admiten numeros, no letras ni simbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Mas información.",
    "gui.alerts.importing": "Importando…",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "lo mío variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Pa empecipiar",
    "gui.howtos.intro-move.step_stepMove": "Anyade un bloque de movimiento",
    "gui.howtos.add-a-move-block.step_stepSay": "Anyade un bloque de decir",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Fe clic en a bandera verde pa empecipiar",
    "gui.howtos.intro-getting-started-ASL.name": "Pa empecipiar - ASL (Luenga de sinyals americana)",
    "gui.howtos.animate-a-name.name": "Animar un nombre",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Tría un obchecto de letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "En fer clic, toca un son",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Tría unatra letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambia la color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Tría unatra letra y fe-la chirar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Tría unatra letra y fe-la creixer",
    "gui.howtos.imagine": "Imachina un mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Escribe lo que quieras decir",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Fe clic en a bandera verde pa empecipiar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Tría qualsequier fondo",
    "gui.howtos.imagine.step_imagineChooseSprite": "Tría qualsequier obchecto",
    "gui.howtos.imagine.step_imagineFlyAround": "Preta la tecla de espacio pa eslizar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Tría unatro obchecto",
    "gui.howtos.imagine.step_imagineLeftRight": "Mover de zurda enta dreita",
    "gui.howtos.imagine.step_imagineUpDown": "Mover d'alto enta abaixo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Cambia de vestiu",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Esliza-te a un punto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Fe que creixca y atapice",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Tría unatro fondo",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cambia Fondo",
    "gui.howtos.imagine.step_imagineRecordASound": "Anyadir un son",
    "gui.howtos.imagine.step_imagineChooseSound": "Tría lo tuyo son",
    "gui.howtos.make-music.name": "Creyar mosica",
    "gui.howtos.Make-Music.step_PickInstrument": "Tría un obchecto de instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "En fer clic, toca un son",
    "gui.howtos.Make-Music.step_MakeSong": "Compone una canta",
    "gui.howtos.make-music.step_MakeBeat": "Tría un tambor y crea un ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Tría l'obchecto microfono y la caixa de sons sorpresa",
    "gui.howtos.story.name": "Creyar una historia",
    "gui.howtos.story.step_addbg": "Anyade un fondo",
    "gui.howtos.story.step_addsprite": "Anyade un personache",
    "gui.howtos.story.step_saysomething": "Diga bella cosa",
    "gui.howtos.story.step_addanothersprite": "Anyade unatro personache",
    "gui.howtos.story.step_flip": "Cambia de dirección",
    "gui.howtos.story.step_conversation": "Tiene una Conversación",
    "gui.howtos.story.addanotherbg": "Anyade unatro Fondo",
    "gui.howtos.story.step_swithbg": "Cambia Fondo",
    "gui.howtos.story.step_hidewizard": "Amaga un Personache",
    "gui.howtos.story.step_showwizard": "Amuestra un Personache",
    "gui.howtos.make-a-chase-game.name": "Crear un chuego de persecución",
    "gui.howtos.Chase-Game.step_BG": "Anyade un fondo",
    "gui.howtos.chase-game.step_AddOcto": "Anyade un obchecto",
    "gui.howtos.make-music.step_LeftRight": "Mueve a dreita y zurda con as flechas",
    "gui.howtos.Chase-Game.step_UpDown": "Mueve alto y abaixo con as flechas",
    "gui.howtos.Chase-Game.step_AddStar": "Anyade unatro obchecto",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mueve-lo de forma aleatoria",
    "gui.howtos.Chase-Game.step_WhenTouch": "En l'obchecto pulpo, en tocar reproduz un son",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Creya la variable \"puntos\"",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En l'obchecto pulpo, en tocar anyade puntos",
    "gui.howtos.animate-char.name": "Animar un personache",
    "gui.howtos.animate-char.step_addbg": "Anyade un fondo",
    "gui.howtos.animate-char.step_addsprite": "Anyade un obchecto",
    "gui.howtos.animate-char.step_saysomething": "Di bella cosa",
    "gui.howtos.animate-char.step_addsound": "Anyade un son",
    "gui.howtos.animate-char.step_animatetalking": "Animar una conversa",
    "gui.howtos.animate-char.step_arrowkeys": "Mueve con as Teclas de Flechas",
    "gui.howtos.animate-char.step_jump": "Blinca",
    "gui.howtos.animate-char.step_changecolor": "Cambiar la color",
    "gui.howtos.make-a-game.name": "Creyar un chuego de fer clic",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Tría un obchecto",
    "gui.howtos.make-a-game.step_GamePlaySound": "En fer clic, toca un son",
    "gui.howtos.make-a-game.step_GameAddScore": "Creya una variable \"puntos\"",
    "gui.howtos.make-a-game.step_GameChangeScore": "En fer clic incrementa los puntos",
    "gui.howtos.make-a-game.step_Random": "Ir a una posición aleatoria",
    "gui.howtos.make-music.step_GameChangeColor": "Cambia la color",
    "gui.howtos.make-music.step_ResetScore": "Reinicia los puntos",
    "gui.howtos.make-it-fly.name": "Fe-lo volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Tría un fondo de ciel",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Tría un personache",
    "gui.howtos.fly.step_stepflySaySomething": "Di bella cosa",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mueve-te con as flechas",
    "gui.howtos.fly.step_stepflyChooseObject": "Tría un obchecto que replegar",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fe que se mueva",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Tría lo tuyo personache",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Anyade una puntuación",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Alza la puntuación",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Anyade un decorau",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mueve lo decorau",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Siguient vestiu",
    "gui.howtos.pong": "Chuego de Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Anyade un fondo",
    "gui.howtos.pong.step_pongAddBallSprite": "Anyade una pilota",
    "gui.howtos.pong.step_pongBounceAround": "Rebota",
    "gui.howtos.pong.step_pongAddPaddle": "Anyade una paleta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mueve la paleta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Tría la pilota",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Rebota la pilota con a paleta",
    "gui.howtos.pong.step_pongAddAScore": "Anyade una puntuación",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Tría 'Puntos' en o menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Fica lo bloque 'sumar a puntos'",
    "gui.howtos.pong.step_pongResetScore": "Reinicia los puntos",
    "gui.howtos.pong.step_pongAddLineSprite": "Anyade l'obchecto linia",
    "gui.howtos.pong.step_pongGameOver": "Fin d'o chuego",
    "gui.howtos.code-cartoon": "Programar un dibuixo animau",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Decir bella cosa en fer clic en a bandera verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anima un personache en fer clic en ell",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Tría un personache distinto",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usa lo signo menos pa fer-lo mas chicot",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fe que un personache creixca u atapice",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Tría un personache distinto",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Blinca alto y abaixo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Fe clic en un personache pa cambiar de scena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Esliza-te",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Cambia de vestiu",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Tría mas personaches pa anyadir a lo tuyo dibuixo animau",
    "gui.howtos.cartoon-network": "Animar un chuego d'aventuras",
    "gui.howtos.cartoon-network.step_CNcharacter": "Tría qué personache amostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Di bella cosa",
    "gui.howtos.cartoon-network.step_CNglide": "Eslizar-se",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Tría qué obchecto encorrer",
    "gui.howtos.cartoon-network.step_CNcollect": "Recolecta obchectos",
    "gui.howtos.cartoon-network.step_CNvariable": "Creya una variable \"puntos\"",
    "gui.howtos.cartoon-network.step_CNscore": "Alzar puntuación",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Puya de libel: cambia de fondo",
    "gui.howtos.videosens.name": "Sensor de vídeo",
    "gui.howtos.videosens.step_addextension": "Anyade Extensión",
    "gui.howtos.videosens.step_pet": "Amorosiar a lo Gato",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Esclata un Globo",
    "gui.howtos.say-it-out-loud": "Creyar animacions que charren",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Anyade los bloques de \"Texto a Voz\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Di bella cosa",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Tría una voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mueve-te",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Anyadir un fondo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Anyade unatro personache",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Tanye una canta",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambiar la color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Da tornadas",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Fe que creixca y atapice",
    "gui.howtos.talking": "Cuentos que charran",
    "gui.howtos.talking.step_talesAddExtension": "Fe clic pa anyadir los bloques de Texto-a-voz",
    "gui.howtos.talking.step_talesChooseSprite": "Tría un obchecto",
    "gui.howtos.talking.step_talesSaySomething": "Fe que lo personache charre",
    "gui.howtos.talking.step_talesChooseBackdrop": "Tría un fondo",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Fe clic en o personache pa ir a lo siguient fondo",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Tría unatro obchecto",
    "gui.howtos.talking.step_talesMoveAround": "Mueve-te",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Tría unatro fondo",
    "gui.howtos.talking.step_talesAnimateTalking": "Animar una conversa",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Tría unatro fondo",
    "gui.howtos.talking.step_talesChooseSound": "Tría una canta pa bailar",
    "gui.howtos.talking.step_talesDanceMoves": "Movimientos de baile",
    "gui.howtos.talking.step_talesAskAnswer": "Tría los bloques de preguntar y responder d'a categoría de Sensors",
    "gui.howtos.add-sprite.name": "Anyadir un obchecto",
    "gui.howtos.add-sprite.step_addSprite": "Anyade un obchecto",
    "gui.howtos.add-a-backdrop.name": "Anyadir un fondo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Anyade un fondo",
    "gui.howtos.change-size.name": "Cambiar grandaria",
    "gui.howtos.change-size.step_changeSize": "Cambia la grandaria",
    "gui.howtos.glide-around.name": "Eslizar-se",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Esliza-te",
    "gui.howtos.change-size.step_glideAroundPoint": "Esliza-te a un punto",
    "gui.howtos.record-a-sound.name": "Gravar un son",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Fe clic en a pestanya 'Sons'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Fe clic en 'Gravar'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Fe clic en o botón de gravar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Tría lo tuyo son",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Reproduz lo tuyo son",
    "gui.howtos.spin-video.name": "Fe-lo chirar",
    "gui.howtos.change-size.step_spinTurn": "Chira",
    "gui.howtos.change-size.step_spinPointInDirection": "Fixa la dirección",
    "gui.howtos.hide-and-show.name": "Lo esconderite",
    "gui.howtos.change-size.step_hideAndShow": "Lo esconderite",
    "gui.howtos.switch-costume.name": "Animar un obchecto",
    "gui.howtos.change-size.step_switchCostumes": "Anima un obchecto",
    "gui.howtos.move-around-with-arrow-keys.name": "Usar las teclas de flecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mueve-te a zurda y dreita",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mueve-te alto y abaixo",
    "gui.howtos.add-effects.name": "Anyadir efectos",
    "gui.howtos.videosens.step_addEffects": "Anyade efectos",
    "gui.extension.music.name": "Mosica",
    "gui.extension.music.description": "Toca trastes y percusión.",
    "gui.extension.pen.name": "Lapiz",
    "gui.extension.pen.description": "Dibuixa con os tuyos obchectos.",
    "gui.extension.videosensing.name": "Sensor de vídeo",
    "gui.extension.videosensing.description": "Detecta movimientos con a camera.",
    "gui.extension.text2speech.name": "Texto a voz",
    "gui.extension.text2speech.description": "Fe que los tuyos prochectos charren.",
    "gui.extension.translate.name": "Traducir",
    "gui.extension.translate.description": "Traduz texto a muitos idiomas.",
    "gui.extension.makeymakey.description": "Convierte qualsequier coseta en una tecla.",
    "gui.extension.microbit.description": "Connecta los tuyos prochectos con o mundo.",
    "gui.extension.microbit.connectingMessage": "Connectando",
    "gui.extension.ev3.description": "Construye robots interactivos y muito mas.",
    "gui.extension.ev3.connectingMessage": "Connectando. Asegura-te que lo PIN d'a tuya EV3 ye 1234.",
    "gui.extension.boost.description": "Da-le vida a las tuyas creacions roboticas.",
    "gui.extension.boost.connectingMessage": "Connectando",
    "gui.extension.wedo2.description": "Construye con motors y sensors.",
    "gui.extension.wedo2.connectingMessage": "Connectando",
    "gui.extension.gdxfor.description": "Detecta empuixe, tirón, movimiento u chiro.",
    "gui.extension.gdxfor.connectingMessage": "Connectando",
    "gui.libraryTags.all": "Totz",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Bailar",
    "gui.libraryTags.effects": "Efectos",
    "gui.libraryTags.fantasy": "Fantesía",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Minchada",
    "gui.libraryTags.indoors": "Interiors",
    "gui.libraryTags.loops": "Bucles",
    "gui.libraryTags.music": "Mosica",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exteriors",
    "gui.libraryTags.patterns": "Patrons",
    "gui.libraryTags.people": "Chent",
    "gui.libraryTags.percussion": "Percusión",
    "gui.libraryTags.space": "Espacio",
    "gui.libraryTags.sports": "Esportes",
    "gui.libraryTags.underwater": "Baixo lo #mar",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Locuras",
    "gui.libraryTags.animation": "Animación",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Chuegos",
    "gui.libraryTags.stories": "Historias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "dirección",
    "gui.opcodeLabels.xposition": "posición en x",
    "gui.opcodeLabels.yposition": "posición en y",
    "gui.opcodeLabels.size": "grandaria",
    "gui.opcodeLabels.costumename": "nombre de vestiu",
    "gui.opcodeLabels.costumenumber": "numero de vestiu",
    "gui.opcodeLabels.backdropname": "nombre de fondo",
    "gui.opcodeLabels.backdropnumber": "numero de fondo",
    "gui.opcodeLabels.volume": "volumen",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "respuesta",
    "gui.opcodeLabels.loudness": "volumen d'o son",
    "gui.opcodeLabels.username": "nombre d'usuario",
    "gui.opcodeLabels.year": "anyo",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "día d'a semana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "menuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronometro",
    "gui.projectLoader.loadError": "No s'ha puesto cargar lo prochecto triau.",
    "gui.sharedMessages.backdrop": "fondo{index}",
    "gui.sharedMessages.costume": "vestiu{index}",
    "gui.sharedMessages.sprite": "Obchecto{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Reemplazar lo conteniu d'o prochecto actual?",
    "gui.sharedMessages.loadFromComputerTitle": "Cargar dende lo tuyo ordinador",
    "gui.theme.default": "Orichinal",
    "gui.theme.dark": "Fosco",
    "gui.theme.highContrast": "Alto contraste",
    "gui.gui.defaultProjectTitle": "Prochecto de Scratch",
    "boost.color.any": "de qualsiquier color",
    "boost.color.black": "negro",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "royo",
    "boost.color.white": "blanco",
    "boost.color.yellow": "amariello",
    "boost.getMotorPosition": "posición d'o motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "anglo d'inclinación enta [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ta un costau",
    "boost.motorDirection.forward": "ta l'atro costau",
    "boost.motorDirection.reverse": "a la inversa",
    "boost.motorOff": "amortar motor [MOTOR_ID]",
    "boost.motorOn": "enchegar motor [MOTOR_ID]",
    "boost.motorOnFor": "chirar motor [MOTOR_ID] [DURATION] segundos",
    "boost.motorOnForRotation": "chirar motor [MOTOR_ID] [ROTATION] vueltas",
    "boost.seeingColor": "detecta lo bloque [COLOR]?",
    "boost.setLightHue": "fixar color d'a luz a [HUE]",
    "boost.setMotorDirection": "fixar adreza d'o motor [MOTOR_ID] [MOTOR_DIRECTION]",
    "boost.setMotorPower": "fixar velocidat d'o motor [MOTOR_ID] a o [POWER] %",
    "boost.tiltDirection.any": "qualsequiera",
    "boost.tiltDirection.down": "abaixo",
    "boost.tiltDirection.left": "zurda",
    "boost.tiltDirection.right": "dreita",
    "boost.tiltDirection.up": "alto",
    "boost.whenColor": "en detectar lo bloque [COLOR]",
    "boost.whenTilted": "en abocar-se enta [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tanyer nota [NOTE] [TIME] segundos",
    "ev3.buttonPressed": "botón [PORT] pretau?",
    "ev3.getBrightness": "brilo",
    "ev3.getDistance": "distancia",
    "ev3.getMotorPosition": "posición d'o motor [PORT]",
    "ev3.motorSetPower": "motor [PORT] fixar potencia a [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] chirar ta un costau [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "motor [PORT] chirar a l'atro costau [TIME] segundos",
    "ev3.whenBrightnessLessThan": "quan brilo < [DISTANCE]",
    "ev3.whenButtonPressed": "en pretar botón [PORT]",
    "ev3.whenDistanceLessThan": "quan distancia < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleración [DIRECTION]",
    "gdxfor.getForce": "fuerza",
    "gdxfor.getSpin": "velocidat de chiro [DIRECTION]",
    "gdxfor.getTilt": "anglo d'inclinación [TILT]",
    "gdxfor.isFreeFalling": "cayendo?",
    "gdxfor.isTilted": "abocau [TILT]?",
    "gdxfor.pulled": "estirau enta difuera",
    "gdxfor.pushed": "empuixau enta dintro",
    "gdxfor.shaken": "sobatiu",
    "gdxfor.startedFalling": "prencipiau a cayer",
    "gdxfor.tiltDirectionMenu.any": "en qualsiquier dirección",
    "gdxfor.tiltDirectionMenu.back": "dezaga",
    "gdxfor.tiltDirectionMenu.front": "debant",
    "gdxfor.tiltDirectionMenu.left": "zurda",
    "gdxfor.tiltDirectionMenu.right": "dreita",
    "gdxfor.turnedFaceDown": "cara enta abaixo",
    "gdxfor.turnedFaceUp": "cara enta alto",
    "gdxfor.whenForcePushedOrPulled": "quan o sensor de fuerza [PUSH_PULL]",
    "gdxfor.whenGesture": "quan [GESTURE]",
    "gdxfor.whenTilted": "en abocar-se [TILT]",
    "makeymakey.downArrow": "flecha enta abaixo",
    "makeymakey.downArrowShort": "abaixo",
    "makeymakey.leftArrow": "flecha enta la zurda",
    "makeymakey.leftArrowShort": "zurda",
    "makeymakey.rightArrow": "flecha enta la dreita",
    "makeymakey.rightArrowShort": "dreita",
    "makeymakey.spaceKey": "espacio",
    "makeymakey.upArrow": "flecha enta alto",
    "makeymakey.upArrowShort": "alto",
    "makeymakey.whenKeyPressed": "en presionar tecla [KEY]",
    "makeymakey.whenKeysPressedInOrder": "en presionar [SEQUENCE] en orden",
    "microbit.buttonsMenu.any": "qualsiquiera",
    "microbit.clearDisplay": "limpiar pantalla",
    "microbit.defaultTextToDisplay": "Ola!",
    "microbit.displaySymbol": "amostrar [MATRIX]",
    "microbit.displayText": "amostrar texto [TEXT]",
    "microbit.gesturesMenu.jumped": "blincau",
    "microbit.gesturesMenu.moved": "moviu",
    "microbit.gesturesMenu.shaken": "sobatiu",
    "microbit.isButtonPressed": "botón [BTN] presionau?",
    "microbit.isTilted": "abocau enta [DIRECTION]?",
    "microbit.pinStateMenu.off": "amortar",
    "microbit.pinStateMenu.on": "enchegar",
    "microbit.tiltAngle": "anglo d'inclinación enta [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "qualsequiera",
    "microbit.tiltDirectionMenu.back": "dezaga",
    "microbit.tiltDirectionMenu.front": "debant",
    "microbit.tiltDirectionMenu.left": "zurda",
    "microbit.tiltDirectionMenu.right": "dreita",
    "microbit.whenButtonPressed": "en pretar botón [BTN]",
    "microbit.whenGesture": "quan [GESTURE]",
    "microbit.whenPinConnected": "en connectar pin [PIN]",
    "microbit.whenTilted": "en abocar-se enta [DIRECTION]",
    "music.categoryName": "Mosica",
    "music.changeTempo": "cambiar tempo por [TEMPO]",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claus",
    "music.drumClosedHiHat": "(6) Charleston zarrau",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Esquilla",
    "music.drumCrashCymbal": "(4) Plated crash",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Palmada",
    "music.drumOpenHiHat": "(5) Charleston ubierto",
    "music.drumSideStick": "(3) Truco lateral",
    "music.drumSnare": "(1) Caixa",
    "music.drumTambourine": "(7) Pandereta",
    "music.drumTriangle": "(12) Trianglo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Caixa chinesa",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Baixo",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violonchelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Guitarra electrica",
    "music.instrumentElectricPiano": "(2) Piano electrico",
    "music.instrumentFlute": "(12) Chiflo",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caixa de mosica",
    "music.instrumentOrgan": "(3) Organo",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Tambor metalico",
    "music.instrumentSynthLead": "(20) Sintetizador melodico",
    "music.instrumentSynthPad": "(21) Sintetizador de fondo",
    "music.instrumentTrombone": "(9) Trompón",
    "music.instrumentVibraphone": "(16) Vibrafono",
    "music.instrumentWoodenFlute": "(13) Chiflo de fusta",
    "music.midiPlayDrumForBeats": "tanyer tambor [DRUM] por [BEATS] tiempos",
    "music.midiSetInstrument": "fixar instrumento a [INSTRUMENT]",
    "music.playDrumForBeats": "tanyer tambor [DRUM] por [BEATS] tiempos",
    "music.playNoteForBeats": "tanyer nota [NOTE] por [BEATS] tiempos",
    "music.restForBeats": "silencio de [BEATS] tiempos",
    "music.setInstrument": "fixar instrumento a [INSTRUMENT]",
    "music.setTempo": "dar a tempo a valor [TEMPO]",
    "pen.categoryName": "Lapicero",
    "pen.changeColorParam": "cambiar [COLOR_PARAM] de lapicero por [VALUE]",
    "pen.changeHue": "cambiar color de lapicero por [HUE]",
    "pen.changeShade": "cambiar uembra de lapicero por [SHADE]",
    "pen.changeSize": "cambiar grandaria de lapicero por [SIZE]",
    "pen.clear": "borrar tot",
    "pen.colorMenu.brightness": "brilo",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "transparencia",
    "pen.penDown": "baixar lapicero",
    "pen.penUp": "puyar lapicero",
    "pen.setColor": "fixar color de lapicero a [COLOR]",
    "pen.setColorParam": "fixar [COLOR_PARAM] de lapicero a [VALUE]",
    "pen.setHue": "fixar color de lapicero a [HUE]",
    "pen.setShade": "fixar uembra de lapicero a [SHADE]",
    "pen.setSize": "fixar grandaria de lapicero a [SIZE]",
    "pen.stamp": "sellar",
    "speech.defaultWhenIHearValue": "Au, nos n'imos",
    "speech.extensionName": "Reconoixencia de voz",
    "speech.listenAndWait": "escuitar y aguardar",
    "speech.speechReporter": "frase",
    "speech.whenIHear": "quan sienta [PHRASE]",
    "text2speech.alto": "contralto",
    "text2speech.categoryName": "Texto a voz",
    "text2speech.defaultTextToSpeak": "ola",
    "text2speech.giant": "chigant",
    "text2speech.kitten": "gatolín",
    "text2speech.setLanguageBlock": "fixar idioma a [LANGUAGE]",
    "text2speech.setVoiceBlock": "fixar voz a [VOICE]",
    "text2speech.speakAndWaitBlock": "decir [WORDS]",
    "text2speech.squeak": "chilo",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducción",
    "translate.defaultTextToTranslate": "ola",
    "translate.translateBlock": "traducir [WORDS] enta lo [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Sensor de video",
    "videoSensing.direction": "dirección",
    "videoSensing.motion": "movimiento",
    "videoSensing.off": "amortar",
    "videoSensing.on": "enchegar",
    "videoSensing.onFlipped": "contornar",
    "videoSensing.setVideoTransparency": "fixar transparencia de video a [TRANSPARENCY]",
    "videoSensing.sprite": "obchecto",
    "videoSensing.stage": "scenario",
    "videoSensing.videoOn": "[ATTRIBUTE] de video en [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] video",
    "videoSensing.whenMotionGreaterThan": "quan movimiento de video > [REFERENCE]",
    "wedo2.getDistance": "distancia",
    "wedo2.getTiltAngle": "anglo d'inclinación enta [TILT_DIRECTION]",
    "wedo2.isTilted": "abocau enta [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "per astí",
    "wedo2.motorDirection.forward": "per aquí",
    "wedo2.motorDirection.reverse": "inversa",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "totz los motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "amortar [MOTOR_ID]",
    "wedo2.motorOn": "enchegar [MOTOR_ID]",
    "wedo2.motorOnFor": "enchegar [MOTOR_ID] por [DURATION] segundos",
    "wedo2.playNoteFor": "tanyer nota [NOTE] por [DURATION] segundos",
    "wedo2.setLightHue": "fixar color d'a luz a [HUE]",
    "wedo2.setMotorDirection": "fixar dirección de [MOTOR_ID] a [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "fixar potencia de [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "qualsequier",
    "wedo2.tiltDirection.down": "abaixo",
    "wedo2.tiltDirection.left": "zurda",
    "wedo2.tiltDirection.right": "dreita",
    "wedo2.tiltDirection.up": "alto",
    "wedo2.whenDistance": "quan distancia [OP] [REFERENCE]",
    "wedo2.whenTilted": "en abocar-se enta [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "Brilo",
    "paint.paintEditor.costume": "Vestiu",
    "paint.paintEditor.group": "Grupo",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Desfer",
    "paint.paintEditor.redo": "Refer",
    "paint.paintEditor.forward": "Enta debant",
    "paint.paintEditor.backward": "Enta zaga",
    "paint.paintEditor.front": "Debant",
    "paint.paintEditor.back": "Dezaga",
    "paint.paintEditor.more": "Mas",
    "paint.modeTools.brushSize": "Grandaria",
    "paint.modeTools.eraserSize": "Grandaria d'o borrador",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Apegar",
    "paint.modeTools.delete": "Borrar",
    "paint.modeTools.curved": "Curva",
    "paint.modeTools.pointed": "Puncha",
    "paint.modeTools.thickness": "Gordaria",
    "paint.modeTools.flipHorizontal": "Chirar en horizontal",
    "paint.modeTools.flipVertical": "Chirar en vertical",
    "paint.modeTools.filled": "Repleno",
    "paint.modeTools.outlined": "Deliniau",
    "paint.paintEditor.bitmap": "Tornar en mapa de bits",
    "paint.paintEditor.vector": "Tornar en vectorial",
    "paint.paintEditor.fill": "Replenar",
    "paint.paintEditor.stroke": "Linia",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Borrador",
    "paint.fillMode.fill": "Replenar",
    "paint.lineMode.line": "Linia",
    "paint.ovalMode.oval": "Cerclo",
    "paint.rectMode.rect": "Rectanglo",
    "paint.reshapeMode.reshape": "Cambiar forma",
    "paint.roundedRectMode.roundedRect": "Rectanglo redondiau",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Cambiar"
  },
  "ast": {
    "gui.alerts.lostPeripheralConnection": "Scratch perdió la conexón a {extensionName}.",
    "gui.alerts.tryAgain": "Intentar otra vuelta",
    "gui.alerts.download": "Descargar",
    "gui.connection.reconnect": "Reconeutar",
    "gui.backpack.costumeLabel": "disfraz",
    "gui.backpack.soundLabel": "soníu",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "personaxe",
    "gui.backpack.header": "Maletu",
    "gui.backpack.errorBackpack": "Error cargando'l maletu",
    "gui.backpack.loadingBackpack": "Cargando...",
    "gui.backpack.more": "Más",
    "gui.backpack.emptyBackpack": "Maletu vacíu",
    "gui.unsupportedBrowser.label": "Restolador non soportáu",
    "gui.unsupportedBrowser.errorLabel": "Hebo un Fallu",
    "gui.unsupportedBrowser.notRecommended": "Sentísmolo muncho pero tal paez que tas usando un restolador que Scratch nun soporta. Recomendámoste anovar a la postrer versión d'un restolador soportáu como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.description": "Sentísmoslo muncho pero Scratch nun soporta esti restolador. Recomendamos qu'anoves a la postrer versión d'un restolador soportáu como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.back": "Atrás",
    "gui.unsupportedBrowser.previewfaq": "Pa saber más vete a {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutoriales",
    "gui.cards.shrink": "Encoyer",
    "gui.cards.expand": "Espurrir",
    "gui.cards.close": "Zarrar",
    "gui.cards.more-things-to-try": "¡Más coses a intentar!",
    "gui.cards.see-more": "Ver más",
    "gui.comingSoon.message1": "Nun t'esmolezas, tamos nello {emoji}",
    "gui.comingSoon.message2": "Aportando en Breve...",
    "gui.comingSoon.message3": "Tamos trabayando nello {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nun s'atoparon preseos",
    "gui.connection.auto-scanning.prescan": "Ten el preséu cerca y entama la gueta.",
    "gui.connection.auto-scanning.pressbutton": "Calca'l botón nel preséu.",
    "gui.connection.auto-scanning.start-search": "Entamar Gueta",
    "gui.connection.connecting-searchbutton": "Guetando...",
    "gui.connection.auto-scanning.try-again": "Intentar otra vuelta",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Coneutáu",
    "gui.connection.disconnect": "Desconeutáu",
    "gui.connection.go-to-editor": "Dir al editor",
    "gui.connection.connecting-cancelbutton": "Coneutando...",
    "gui.connection.error.errorMessage": "Ups, daqué salió mal.",
    "gui.connection.error.tryagainbutton": "Intentar otra vuelta",
    "gui.connection.error.helpbutton": "Ayuda",
    "gui.connection.peripheral-name-label": "Nome del preséu",
    "gui.connection.connect": "Coneutar",
    "gui.connection.scanning.lookingforperipherals": "Guetando preseos",
    "gui.connection.scanning.noPeripheralsFound": "Nun s'atoparon preseos",
    "gui.connection.scanning.instructions": "Esbiya'l preséu na llista d'arriba.",
    "gui.connection.search": "Recargar",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Asegúrate que Scratch Link ta instaláu y furrulando",
    "gui.connection.unavailable.enablebluetooth": "Comprueba que ta actváu'l Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Intentar otra vuelta",
    "gui.connection.unavailable.helpbutton": "Ayuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Dir",
    "gui.controls.stop": "Parar",
    "gui.crashMessage.label": "¡Ups! Daqué salió mal.",
    "gui.crashMessage.description": "Sentímoslo muncho pero tal parez que Scratch colgóse. L'Equipu Scratch va ser informáu darréu automáticamente d'esti bug. Recarga la páxina pa intentalo otra vuelta.",
    "gui.crashMessage.errorNumber": "L'error foi grabáu col id {errorId}",
    "gui.crashMessage.reload": "Recargar",
    "gui.customProcedures.myblockModalTitle": "Crear un Bloque",
    "gui.customProcedures.addAnInputNumberText": "Amestar una entrada",
    "gui.customProcedures.numberTextType": "númberu o testu",
    "gui.customProcedures.addAnInputBoolean": "Amestar una entrada",
    "gui.customProcedures.booleanType": "boleana",
    "gui.customProcedures.addALabel": "Amestar una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Executar ensin refrescu de pantalla",
    "gui.customProcedures.cancel": "Encaboxar",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direición",
    "gui.directionPicker.rotationStyles.allAround": "Too alredor",
    "gui.directionPicker.rotationStyles.leftRight": "Izquierda/Drecha",
    "gui.directionPicker.rotationStyles.dontRotate": "Nun xirar",
    "gui.gui.addExtension": "Amestar Extensión",
    "gui.gui.codeTab": "Códigu",
    "gui.gui.backdropsTab": "Fondos",
    "gui.gui.costumesTab": "Disfraces",
    "gui.gui.soundsTab": "Soníos",
    "gui.extensionLibrary.comingSoon": "Aportando en Breve",
    "gui.extensionLibrary.requires": "Requisitos",
    "gui.extensionLibrary.collaboration": "Colaboración con",
    "gui.library.filterPlaceholder": "Guetar",
    "gui.library.allTag": "Too",
    "gui.loader.message1": "Creando bloques...",
    "gui.loader.message2": "Cargando personaxes...",
    "gui.loader.message3": "Cargando soníos...",
    "gui.loader.message4": "Cargando extensiones...",
    "gui.loader.message5": "Tenemos más paya que tená...",
    "gui.loader.message6": "Cazando gamusinos...",
    "gui.loader.message7": "Guetando cordobeyos..",
    "gui.loader.message8": "Preparando emoticonos...",
    "gui.loader.headline": "Cargando proyeutu",
    "gui.loader.creating": "Creando proyeutu",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Estoyu",
    "gui.accountMenu.myClasses": "Les Mios Clases",
    "gui.accountMenu.myClass": "La Mio Clas",
    "gui.accountMenu.accountSettings": "Configuración de la cuenta",
    "gui.accountMenu.signOut": "Salir",
    "gui.authorInfo.byUser": "por {username}",
    "gui.menuBar.seeProjectPage": "Ver la Páxina del Proyeutu",
    "gui.menuBar.language": "Language",
    "general.username": "Nome d'usuariu",
    "general.password": "Contraseña",
    "general.signIn": "Entrar",
    "login.needHelp": "¿Precises ayuda?",
    "form.validationRequired": "Esti campu ye necesariu",
    "gui.menuBar.tutorialsLibrary": "Tutoriales",
    "gui.menuBar.restoreSprite": "Restaurar Personaxe",
    "gui.menuBar.restoreSound": "Restaurar Soníu",
    "gui.menuBar.restoreCostume": "Restaurar Disfraz",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Guardar agora",
    "gui.menuBar.saveAsCopy": "Guardar como una copia",
    "gui.menuBar.remix": "Remecer",
    "gui.menuBar.new": "Nuevu",
    "gui.menuBar.file": "Ficheru",
    "gui.menuBar.downloadToComputer": "Guardar nel ordenador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desactivar Mou Turbu",
    "gui.menuBar.turboModeOn": "Prender Mou Turbu",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Xunise a Scratch",
    "gui.menuBar.signIn": "Entrar",
    "gui.gui.projectTitlePlaceholder": "Títulu del Proyeutu",
    "gui.menuBar.saveNowLink": "Guardar Agora",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Compartíu",
    "gui.menuBar.share": "Compartir",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ayuda",
    "gui.modal.back": "Atrás",
    "gui.monitor.listMonitor.empty": "(ermu)",
    "gui.monitor.listMonitor.listLength": "llargura {length}",
    "gui.monitor.contextMenu.default": "llectura de salida normal",
    "gui.monitor.contextMenu.large": "llectura de salida llarga",
    "gui.monitor.contextMenu.slider": "eslizador",
    "gui.monitor.contextMenu.sliderRange": "cambiar el rangu del eslizador",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "esportar",
    "gui.monitor.contextMenu.hide": "anubrir",
    "gui.playButton.play": "Tocar",
    "gui.playButton.stop": "Parar",
    "gui.gui.variableScopeOptionAllSprites": "Pa tolos personaxes",
    "gui.gui.variableScopeOptionSpriteOnly": "Pa esti personaxe namás",
    "gui.gui.cloudVariableOption": "Variables na Ñube (agospiaes nel sirvidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variable va tar disponible pa tolos personaxes.",
    "gui.gui.listPromptAllSpritesMessage": "Esta llista va tar disponibles pa tolos personaxes.",
    "gui.prompt.cancel": "Encaboxar",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Parar",
    "gui.playbackStep.playMsg": "Tocar",
    "gui.playbackStep.loadingMsg": "Cargando...",
    "gui.playbackStep.saveMsg": "Guardar",
    "gui.playbackStep.reRecordMsg": "Re-grabar",
    "gui.recordModal.title": "Grabar soníu",
    "gui.recordingStep.beginRecord": "Entamar grabación calcando nel botón d'abaxo",
    "gui.recordingStep.permission": "{arrow}Necesitamos el to permisu pa usar el micrófonu",
    "gui.recordingStep.stop": "Parar grabación",
    "gui.recordingStep.record": "Grabar",
    "gui.sliderModal.min": "Valor mínimu",
    "gui.sliderModal.max": "Valor máximu",
    "gui.sliderModal.title": "Cambiar el rangu del eslizador",
    "gui.sliderPrompt.cancel": "Encaboxar",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Soníu",
    "gui.soundEditor.play": "Tocar",
    "gui.soundEditor.stop": "Parar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Apegar",
    "gui.soundEditor.copyToNew": "Copiar a Nuevu",
    "gui.soundEditor.delete": "Esborrar",
    "gui.soundEditor.save": "Guardar",
    "gui.soundEditor.undo": "Desfacer",
    "gui.soundEditor.redo": "Refacer",
    "gui.soundEditor.faster": "Más rápido",
    "gui.soundEditor.slower": "Más lento",
    "gui.soundEditor.echo": "Ecu",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Más alto",
    "gui.soundEditor.softer": "Más baxo",
    "gui.soundEditor.reverse": "Inversu",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nome",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Personaxe",
    "gui.SpriteInfo.show": "Amosar",
    "gui.SpriteInfo.size": "Tamañu",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "esportar",
    "gui.spriteSelectorItem.contextMenuDelete": "esborrar",
    "gui.spriteSelector.addSpriteFromLibrary": "Escoyer un Personaxe",
    "gui.spriteSelector.addSpriteFromPaint": "Pintar",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Subir Personaxe",
    "gui.stageHeader.stageSizeLarge": "Cambiar a escenariu grande",
    "gui.stageHeader.stageSizeSmall": "Cambiar a escenariu pequeñu",
    "gui.stageHeader.stageSizeFull": "Pasar a mou de pantala completa",
    "gui.stageHeader.stageSizeUnFull": "Salir del mou de pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control Pantalla Completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Escueyi un Fondu",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Subir un Fondu",
    "gui.stageSelector.stage": "Escenariu",
    "gui.stageSelector.backdrops": "Fondos",
    "gui.telemetryOptIn.label": "Unviar estadístiques p'ameyorar Scratch",
    "gui.telemetryOptIn.body1": "El Equipu de Scratch intenta siempres entender meyor cómo s'usa Scratch a lo llargo'l mundu. P'ayudar nesti esfuerzu puedes permitir a Scratch unviar automáticamente información sobre l'usu al Equipu Scratch.",
    "gui.telemetryOptIn.body2": "Recoyemos información qu'inclúi llingua seleicionada, bloques usaos y dalgunos eventos como guardar, cargar y subir proyectos. NUN recoyemos nenguna información personal. Mira la nuesa {privacyPolicyLink} pa más información.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de Privacidá",
    "gui.telemetryOptIn.optInText": "Compartir los datos d'usu col Equipu de Scratch",
    "gui.telemetryOptIn.optInTooltip": "Activar telemetría",
    "gui.telemetryOptIn.optOutText": "Nun compartir los mios datos d'usu col Equipu Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Desactivar telemetría",
    "gui.telemetryOptIn.settingWasUpdated": "Configuración anovada.",
    "gui.telemetryOptIn.buttonClose": "Zarrar",
    "gui.turboMode.active": "Mou Turbu",
    "gui.webglModal.label": "El Restolador Nun Soporta WebGL",
    "gui.webglModal.description": "Llamentándolo muncho paez que'l restolador o l'ordenador {webGlLink}. Esta tecnoloxía ye necesaria pa executar Scratch 3.0.",
    "gui.webglModal.webgllink": "nun soporta WebGL",
    "gui.webglModal.back": "Atrá",
    "gui.webglModal.previewfaq": "Pa saber más vete a {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Escueyi un Fondu",
    "gui.costumeLibrary.chooseACostume": "Escueyi un Disfraz",
    "gui.costumeTab.addBackdropFromLibrary": "Escueyi un Fondu",
    "gui.costumeTab.addCostumeFromLibrary": "Escueyi un Disfraz",
    "gui.costumeTab.addBlankCostume": "Pintar",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Subir un Fondu",
    "gui.costumeTab.addFileCostume": "Subir Disfraz",
    "gui.extensionLibrary.chooseAnExtension": "Escueyi una Extensión",
    "gui.extensionLibrary.extensionUrl": "Introduz la URL de la extensión",
    "gui.monitors.importListColumnPrompt": "¿Cuáles columnes deberíen ser usaes (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nun se pudo entamar a grabar",
    "gui.soundLibrary.chooseASound": "Escoyer un Soníu",
    "gui.soundTab.fileUploadSound": "Subir Soníu",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Grabar",
    "gui.soundTab.addSoundFromLibrary": "Escoyer un Soníu",
    "gui.spriteLibrary.chooseASprite": "Escoyer un Personaxe",
    "gui.tipsLibrary.tutorials": "Escoyer un Tutorial",
    "gui.alerts.createsuccess": "Creáu nuevu proyectu",
    "gui.alerts.createcopysuccess": "Proyectu guardáu como una copia.",
    "gui.alerts.createremixsuccess": "Proyectu guardáu como un remix.",
    "gui.alerts.creating": "Creando nuevu...",
    "gui.alerts.creatingCopy": "Copiand proyectu...",
    "gui.alerts.creatingRemix": "Remeciendo proyectu...",
    "gui.alerts.creatingError": "Nun se pudo crear el proyectu. ¡Intétalo otra vuelta!",
    "gui.alerts.savingError": "El proyectu nun se puedo guardar.",
    "gui.alerts.savesuccess": "Proyectu guardáu.",
    "gui.alerts.saving": "Guardando proyectu...",
    "gui.alerts.cloudInfo": "Atención, les variables na ñube namás soporten númberos, nin lletres nin símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Aprendi más.",
    "gui.alerts.importing": "Importando...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "la mio variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Entamando",
    "gui.howtos.intro-move.step_stepMove": "Amestar un bloque de movimientu",
    "gui.howtos.add-a-move-block.step_stepSay": "Amestar un bloque de diálogu",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Calca na bandera verde pa entamar",
    "gui.howtos.intro-getting-started-ASL.name": "Entamando - ASL",
    "gui.howtos.animate-a-name.name": "Animar un Nome",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Escueyi una Lletra Personax",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Sonar al Calcar",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Escoyer otra Lletra Personax",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Camudar color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Escoyer otra Lletra Personax y Facela Xirar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Escoyer otra Lletra Personax y Facela Medrar",
    "gui.howtos.imagine": "Imaxina un Mundu",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Escribir Lo Que Quieras Dicir",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Calca na Bandera Verde pa Entamar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Escoyer Un Fondu",
    "gui.howtos.imagine.step_imagineChooseSprite": "Escoyer Cualquier Personaxe",
    "gui.howtos.imagine.step_imagineFlyAround": "Calca la Barra Espaciadora pa Eslizar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Escueyi Otru Personaxe",
    "gui.howtos.imagine.step_imagineLeftRight": "Mover d'Izquierda a Drecha",
    "gui.howtos.imagine.step_imagineUpDown": "Mover d'Arriba p'Abaxo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Camudar los Disfraces",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Eslizar a un Puntu",
    "gui.howtos.imagine.step_imagineGrowShrink": "Medrar y Menguar",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Escueyi otru Fondu",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Camudar Fondos",
    "gui.howtos.imagine.step_imagineRecordASound": "Amestar un Soníu",
    "gui.howtos.imagine.step_imagineChooseSound": "Escoyer el To Soníu",
    "gui.howtos.make-music.name": "Facer Música",
    "gui.howtos.Make-Music.step_PickInstrument": "Escoyer un Instrumentu Personax",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Reproducir un Soníu al Calcar",
    "gui.howtos.Make-Music.step_MakeSong": "Crear una Canción",
    "gui.howtos.make-music.step_MakeBeat": "Escoyer un Tambor y dar un Toque",
    "gui.howtos.make-music.step_MakeBeatBox": "Escoyer un Micrófonu Personax y Sorprender al Beatbox",
    "gui.howtos.story.name": "Crear una Historia",
    "gui.howtos.story.step_addbg": "Amestar un Fondu",
    "gui.howtos.story.step_addsprite": "Amestar un Personax",
    "gui.howtos.story.step_saysomething": "Dicir Daqué",
    "gui.howtos.story.step_addanothersprite": "Amestar otru Personax",
    "gui.howtos.story.step_flip": "Camudar de Direición",
    "gui.howtos.story.step_conversation": "Charrar",
    "gui.howtos.story.addanotherbg": "Amestar otru Fondu",
    "gui.howtos.story.step_swithbg": "Camudar Fondos",
    "gui.howtos.story.step_hidewizard": "Tapecer un Personaxe",
    "gui.howtos.story.step_showwizard": "Amosar un Personaxe",
    "gui.howtos.make-a-chase-game.name": "Facer un xuegu d'escorrer",
    "gui.howtos.Chase-Game.step_BG": "Amestar un fondu",
    "gui.howtos.chase-game.step_AddOcto": "Amestar un personax",
    "gui.howtos.make-music.step_LeftRight": "Mover a la mandrecha y manzorga coles tecles de les fleches",
    "gui.howtos.Chase-Game.step_UpDown": "Mover arriba y abaxo coles tecles de les fleches",
    "gui.howtos.Chase-Game.step_AddStar": "Amestar otru personax",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mover al debalu",
    "gui.howtos.Chase-Game.step_WhenTouch": "Al tocar al personax pulpu reproducir soníos",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crear una variable marcador",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Al tocar al personax pulpu amestar resultáu",
    "gui.howtos.animate-char.name": "Animar un personax",
    "gui.howtos.animate-char.step_addbg": "Amestar un fondu",
    "gui.howtos.animate-char.step_addsprite": "Amestar un personax",
    "gui.howtos.animate-char.step_saysomething": "Dicir daqué",
    "gui.howtos.animate-char.step_addsound": "Amestar un soníu",
    "gui.howtos.animate-char.step_animatetalking": "Animación que fala",
    "gui.howtos.animate-char.step_arrowkeys": "Mover usando les fleches del tecláu",
    "gui.howtos.animate-char.step_jump": "Saltar",
    "gui.howtos.animate-char.step_changecolor": "Camudar color",
    "gui.howtos.make-a-game.name": "Facer un xuegu de calcar",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Escoyer un personax",
    "gui.howtos.make-a-game.step_GamePlaySound": "Sonar al calcar",
    "gui.howtos.make-a-game.step_GameAddScore": "Crear una variable de marcador",
    "gui.howtos.make-a-game.step_GameChangeScore": "Al calcar aumentar la puntuación",
    "gui.howtos.make-a-game.step_Random": "Dir a una posición al debalu",
    "gui.howtos.make-music.step_GameChangeColor": "Camudar color",
    "gui.howtos.make-music.step_ResetScore": "Poner marcador a ceru",
    "gui.howtos.make-it-fly.name": "Fáilo volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Escoyer un fondu de cielu",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Escoyer un personaxe",
    "gui.howtos.fly.step_stepflySaySomething": "Dicir daqué",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mover coles fleches del tecláu",
    "gui.howtos.fly.step_stepflyChooseObject": "Escueyi un oxetu pa recoyer",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Facer que l'oxetu se mueva",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Escoyer el to personaxe",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Amestar un marcador",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Caltener puntuación",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Amestar escenariu",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mover l'escenariu",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Siguiente personax",
    "gui.howtos.pong": "Xuegu de pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Amestar un fondu",
    "gui.howtos.pong.step_pongAddBallSprite": "Amestar un personax balón",
    "gui.howtos.pong.step_pongBounceAround": "Rebotar alredor",
    "gui.howtos.pong.step_pongAddPaddle": "Amestar una paleta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mover la paleta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Escoyer un personax balón",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Amestar un códigu pa rebotar la pelota fuera de la paleta",
    "gui.howtos.pong.step_pongAddAScore": "Amestar un marcador",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Escoyer 'Marcador' dende'l menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insertar el bloque 'Camudar puntuación'",
    "gui.howtos.pong.step_pongResetScore": "Poner marcador a ceru",
    "gui.howtos.pong.step_pongAddLineSprite": "Amestar llinia de personax",
    "gui.howtos.pong.step_pongGameOver": "Acabóse'l xuegu",
    "gui.howtos.code-cartoon": "Codificar una caricatura",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Di daqué al calcar na bandera verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animar un personaxe cuando calques nelli",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Escoyer un personax diferente",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usar el signu menos pa menguar",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Facer qu'un personaxe medre y mengue",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Escoyer un personax diferente",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Saltar p'arriba y p'abaxo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Calca nun personaxe pa camudar les escenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Eslizar alredor",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Camudar los traxes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Escoyer más personaxes pa amestar al to dibuxu animáu",
    "gui.howtos.cartoon-network": "Animar un xuegu d'aventures",
    "gui.howtos.cartoon-network.step_CNcharacter": "Escoyer un personaxe p'amosar",
    "gui.howtos.cartoon-network.step_CNsay": "Dicir daqué",
    "gui.howtos.cartoon-network.step_CNglide": "Eslizar alredor",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Escoyer un oxetu pa escorrer",
    "gui.howtos.cartoon-network.step_CNcollect": "Recoyer oxetos",
    "gui.howtos.cartoon-network.step_CNvariable": "Facer una variable marcador",
    "gui.howtos.cartoon-network.step_CNscore": "Caltener puntuación",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Xubir de nivel: Camudar fondu",
    "gui.howtos.videosens.name": "Deteición de videu",
    "gui.howtos.videosens.step_addextension": "Amestar Extensión",
    "gui.howtos.videosens.step_pet": "Afalaga'l gatu",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Españar un globu",
    "gui.howtos.say-it-out-loud": "Crear dibuxos animaos que falen",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Amestar el testu a los bocadiellos",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dicir daqué",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Afitar una voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mover alredor",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Amestar un fondu",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Amestar otru personax",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cantar una canción",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Camudar color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Xirar alredor",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Medrar y menguar",
    "gui.howtos.talking": "Cuentos que falen",
    "gui.howtos.talking.step_talesAddExtension": "Calcar p'amestar el testu a los bocadiellos",
    "gui.howtos.talking.step_talesChooseSprite": "Escoyer un Personaxe",
    "gui.howtos.talking.step_talesSaySomething": "Facer qu'un personax fale",
    "gui.howtos.talking.step_talesChooseBackdrop": "Escueyi un Fondu",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Calca nun personax pa dir al siguiente fondu",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Escueyi otru personaxe",
    "gui.howtos.talking.step_talesMoveAround": "Mover alredor",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Escueyi otru Fondu",
    "gui.howtos.talking.step_talesAnimateTalking": "Animación que fala",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Escueyi otru Fondu",
    "gui.howtos.talking.step_talesChooseSound": "Escueyi una canción pa baillar pa",
    "gui.howtos.talking.step_talesDanceMoves": "Movimientos de baille",
    "gui.howtos.talking.step_talesAskAnswer": "Obtener los bloques entrugar y responder de la estaya Deteición",
    "gui.howtos.add-sprite.name": "Amestar un personax",
    "gui.howtos.add-sprite.step_addSprite": "Amestar un personax",
    "gui.howtos.add-a-backdrop.name": "Amestar un fondu",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Amestar un fondu",
    "gui.howtos.change-size.name": "Camudar tamañu",
    "gui.howtos.change-size.step_changeSize": "Camudar tamañu",
    "gui.howtos.glide-around.name": "Eslizar alredor",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Eslizar alredor",
    "gui.howtos.change-size.step_glideAroundPoint": "Eslizar a un puntu",
    "gui.howtos.record-a-sound.name": "Grabar un soníu",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Calcar na pestaña 'Soníos'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Calcar 'Grabar'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Calcar nel botón Grabar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Escoyer el to soníu",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Facer sonar el to soníu",
    "gui.howtos.spin-video.name": "Fáilo xirar",
    "gui.howtos.change-size.step_spinTurn": "Xirar",
    "gui.howtos.change-size.step_spinPointInDirection": "Afitar direición",
    "gui.howtos.hide-and-show.name": "Anubrir y amosar",
    "gui.howtos.change-size.step_hideAndShow": "Anubrir y amosar",
    "gui.howtos.switch-costume.name": "Animar a personax",
    "gui.howtos.change-size.step_switchCostumes": "Animar a personax",
    "gui.howtos.move-around-with-arrow-keys.name": "Usar fleches del tecláu",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mover a manzorga y mandrecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mover arriba y abaxo",
    "gui.howtos.add-effects.name": "Amestar efeutos",
    "gui.howtos.videosens.step_addEffects": "Amestar efeutos",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Tocar instrumentos y tambores.",
    "gui.extension.pen.name": "Llápiz",
    "gui.extension.pen.description": "Dibuxar colos tos personaxes.",
    "gui.extension.videosensing.name": "Deteición de videu",
    "gui.extension.videosensing.description": "Sensor de movimientu cola cámara",
    "gui.extension.text2speech.name": "Testu pa dicir",
    "gui.extension.text2speech.description": "Fai que los tos proyeutos falen.",
    "gui.extension.translate.name": "Traducir",
    "gui.extension.translate.description": "Traducir el testu en delles llingües.",
    "gui.extension.makeymakey.description": "Convierte cualquier cosa nuna llave.",
    "gui.extension.microbit.description": "Coneuta los tos proyeutos col mundu",
    "gui.extension.microbit.connectingMessage": "Coneutando",
    "gui.extension.ev3.description": "Construyir robots interautivos y más coses",
    "gui.extension.ev3.connectingMessage": "Coneutando. Asegúrate de que'l pin del to EV3 ye 1234",
    "gui.extension.boost.description": "Da vida a les creaciones robótiques",
    "gui.extension.boost.connectingMessage": "Coneutando",
    "gui.extension.wedo2.description": "Construyir con motores y sensores.",
    "gui.extension.wedo2.connectingMessage": "Coneutando",
    "gui.extension.gdxfor.description": "Sensor d'emburrie, tiru, movimientu y xiru.",
    "gui.extension.gdxfor.connectingMessage": "Coneutando",
    "gui.libraryTags.all": "Too",
    "gui.libraryTags.animals": "Animales",
    "gui.libraryTags.dance": "Baillar",
    "gui.libraryTags.effects": "Efeutos",
    "gui.libraryTags.fantasy": "Fantasía",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Comida",
    "gui.libraryTags.indoors": "Interiores",
    "gui.libraryTags.loops": "Llazos",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Esteriores",
    "gui.libraryTags.patterns": "Patrones",
    "gui.libraryTags.people": "Xente",
    "gui.libraryTags.percussion": "Percusión",
    "gui.libraryTags.space": "Espaciu",
    "gui.libraryTags.sports": "Deportes",
    "gui.libraryTags.underwater": "Somarín",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Fatu",
    "gui.libraryTags.animation": "Animación",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Xuegos",
    "gui.libraryTags.stories": "Histories",
    "gui.libraryTags.letters": "Lletres",
    "gui.opcodeLabels.direction": "direición",
    "gui.opcodeLabels.xposition": "posición x",
    "gui.opcodeLabels.yposition": "posición y",
    "gui.opcodeLabels.size": "tamañu",
    "gui.opcodeLabels.costumename": "nome del disfraz",
    "gui.opcodeLabels.costumenumber": "númberu de disfraz",
    "gui.opcodeLabels.backdropname": "nombre de fondu",
    "gui.opcodeLabels.backdropnumber": "númberu de fondu",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "respuesta",
    "gui.opcodeLabels.loudness": "volume del soníu",
    "gui.opcodeLabels.username": "nome d'usuariu",
    "gui.opcodeLabels.year": "añu",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "día de la selman",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minutu",
    "gui.opcodeLabels.second": "segundu",
    "gui.opcodeLabels.timer": "cronómetru",
    "gui.projectLoader.loadError": "Falló la carga del ficheru del proyectu seleicionáu.",
    "gui.sharedMessages.backdrop": "fondu {index}",
    "gui.sharedMessages.costume": "disfraz {index}",
    "gui.sharedMessages.sprite": "Personax {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "¿Reemplazar conteníos del proyeutu actual?",
    "gui.sharedMessages.loadFromComputerTitle": "Cargar del to ordenador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proyeutu Scratch",
    "boost.color.any": "cualquier color",
    "boost.color.black": "negru",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "coloráu",
    "boost.color.white": "blancu",
    "boost.color.yellow": "mariellu",
    "boost.getMotorPosition": "posición [MOTOR_REPORTER_ID] motor",
    "boost.getTiltAngle": "ángulu d'enclín [TILT_DIRECTION]",
    "boost.motorDirection.backward": "per ehí",
    "boost.motorDirection.forward": "per equí",
    "boost.motorDirection.reverse": "inversu",
    "boost.motorOff": "apagar motor [MOTOR_ID]",
    "boost.motorOn": "prender motor [MOTOR_ID]",
    "boost.motorOnFor": "prender motor [MOTOR_ID] pa [DURATION] segundos",
    "boost.motorOnForRotation": "prender motor [MOTOR_ID] pa [ROTATION] rotaciones",
    "boost.seeingColor": "¿viendo [COLOR] lladriyu?",
    "boost.setLightHue": "afitar color de lluz pa [HUE]",
    "boost.setMotorDirection": "afitar direición del [MOTOR_ID] motor [MOTOR_DIRECTION]",
    "boost.setMotorPower": "afitar velocidá del [MOTOR_ID] motor pa [POWER] %",
    "boost.tiltDirection.any": "cualisquier",
    "boost.tiltDirection.down": "abaxo",
    "boost.tiltDirection.left": "izquierda",
    "boost.tiltDirection.right": "drecha",
    "boost.tiltDirection.up": "arriba",
    "boost.whenColor": "cuando [COLOR] lladriyu asemeya",
    "boost.whenTilted": "cuando l'enclín [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "pitíu [NOTE] pa [TIME] segundos",
    "ev3.buttonPressed": "¿botón [PORT] calcáu?",
    "ev3.getBrightness": "brillu",
    "ev3.getDistance": "distancia",
    "ev3.getMotorPosition": "posición del [PORT] motor",
    "ev3.motorSetPower": "motor [PORT] afitar potencia [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] torcer nesti sentíu pa [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "motor [PORT] torcer nesi sentíu pa [TIME] segundos",
    "ev3.whenBrightnessLessThan": "cuando'l brillu < [DISTANCE]",
    "ev3.whenButtonPressed": "col botón [PORT] calcáu",
    "ev3.whenDistanceLessThan": "cuando la distancia < [DISTANCE]",
    "gdxfor.getAcceleration": "aceleración [DIRECTION]",
    "gdxfor.getForce": "fuerza",
    "gdxfor.getSpin": "velocidá de xiru [DIRECTION]",
    "gdxfor.getTilt": "ángulu d'enclín [TILT]",
    "gdxfor.isFreeFalling": "¿cayendo?",
    "gdxfor.isTilted": "¿enclináu [TILT]?",
    "gdxfor.pulled": "tirao",
    "gdxfor.pushed": "emburriao",
    "gdxfor.shaken": "batulláu",
    "gdxfor.startedFalling": "entamó a cayer",
    "gdxfor.tiltDirectionMenu.any": "cualisquier",
    "gdxfor.tiltDirectionMenu.back": "atrás",
    "gdxfor.tiltDirectionMenu.front": "frente",
    "gdxfor.tiltDirectionMenu.left": "izquierda",
    "gdxfor.tiltDirectionMenu.right": "drecha",
    "gdxfor.turnedFaceDown": "pámpana abaxo",
    "gdxfor.turnedFaceUp": "pámpana arriba",
    "gdxfor.whenForcePushedOrPulled": "cuando'l sensor de fuerza [PUSH_PULL]",
    "gdxfor.whenGesture": "cuando [GESTURE]",
    "gdxfor.whenTilted": "cuando l'enclín [TILT]",
    "makeymakey.downArrow": "flecha abaxo",
    "makeymakey.downArrowShort": "abaxo",
    "makeymakey.leftArrow": "flecha izquierda",
    "makeymakey.leftArrowShort": "izquierda",
    "makeymakey.rightArrow": "flecha drecha",
    "makeymakey.rightArrowShort": "drecha",
    "makeymakey.spaceKey": "espaciu",
    "makeymakey.upArrow": "flecha arriba",
    "makeymakey.upArrowShort": "arriba",
    "makeymakey.whenKeyPressed": "cuando [KEY] la tecla tea calcada",
    "makeymakey.whenKeysPressedInOrder": "cuando [SEQUENCE] tea calcáu n'orde",
    "microbit.buttonsMenu.any": "cualisquier",
    "microbit.clearDisplay": "llimpiar pantalla",
    "microbit.defaultTextToDisplay": "¡Hola!",
    "microbit.displaySymbol": "pantalla [MATRIX]",
    "microbit.displayText": "amosar testu [TEXT]",
    "microbit.gesturesMenu.jumped": "saltó",
    "microbit.gesturesMenu.moved": "movió",
    "microbit.gesturesMenu.shaken": "batulláu",
    "microbit.isButtonPressed": "¿ [BTN] botón calcáu",
    "microbit.isTilted": "¿enclín [DIRECTION]?",
    "microbit.pinStateMenu.off": "apagáu",
    "microbit.pinStateMenu.on": "encesu",
    "microbit.tiltAngle": "ángulu d'enclín [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "cualisquier",
    "microbit.tiltDirectionMenu.back": "atrás",
    "microbit.tiltDirectionMenu.front": "frente",
    "microbit.tiltDirectionMenu.left": "izquierda",
    "microbit.tiltDirectionMenu.right": "drecha",
    "microbit.whenButtonPressed": "col [BTN] botón calcáu",
    "microbit.whenGesture": "cuando [GESTURE]",
    "microbit.whenPinConnected": "col pin [PIN] conectáu",
    "microbit.whenTilted": "cuando l'enclín [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "camudar el tempo por [TEMPO]",
    "music.drumBass": "(2) Bombu",
    "music.drumBongo": "(13) Bongu",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charles zarráu",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Lloqueru",
    "music.drumCrashCymbal": "(4) Platiyos",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Aplausu",
    "music.drumOpenHiHat": "(5) Charles abiertu",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Tambor",
    "music.drumTambourine": "(7) Pandereta",
    "music.drumTriangle": "(12) Triángulu",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Clave",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Baxu",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Chelu",
    "music.instrumentChoir": "(15) Coru",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra llétrica",
    "music.instrumentElectricPiano": "(2) Pianu llétricu",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caxa de música",
    "music.instrumentOrgan": "(3) Órganu",
    "music.instrumentPiano": "(1) Pianu",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Caxa",
    "music.instrumentSynthLead": "(20) Sintetizador lead",
    "music.instrumentSynthPad": "(21) Sintetizador Pad",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibrafonu",
    "music.instrumentWoodenFlute": "(13) Faluta de madera",
    "music.midiPlayDrumForBeats": "tocar el tambor [DRUM] pa [BEATS] pulsos",
    "music.midiSetInstrument": "afitar instrumentu pa [INSTRUMENT]",
    "music.playDrumForBeats": "tocar el tambor [DRUM] pa [BEATS] pulsos",
    "music.playNoteForBeats": "tocar una nota [NOTE] pa [BEATS] pulsos",
    "music.restForBeats": "silenciu pa [BEATS] pulsos",
    "music.setInstrument": "afitar instrumentu pa [INSTRUMENT]",
    "music.setTempo": "afitar el tempu en [TEMPO]",
    "pen.categoryName": "Llápiz",
    "pen.changeColorParam": "camudar el llápiz [COLOR_PARAM] por [VALUE]",
    "pen.changeHue": "camudar el llápiz por [HUE]",
    "pen.changeShade": "camudar la intensidá del llápiz por [SHADE]",
    "pen.changeSize": "camudar el tamañu del llápiz por [SIZE]",
    "pen.clear": "esborriar too",
    "pen.colorMenu.brightness": "brillu",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "tresparencia",
    "pen.penDown": "baxar llápiz",
    "pen.penUp": "xubir llápiz",
    "pen.setColor": "afitar el color del llápiz en [COLOR]",
    "pen.setColorParam": "afitar el llápiz [COLOR_PARAM] como [VALUE]",
    "pen.setHue": "afitar el llápiz como [HUE]",
    "pen.setShade": "afitar el llápiz como [SHADE]",
    "pen.setSize": "apitar el tamañu del llápiz como [SIZE]",
    "pen.stamp": "sellu",
    "speech.defaultWhenIHearValue": "Vamos",
    "speech.extensionName": "Dictáu a testu",
    "speech.listenAndWait": "escuchar y esperar",
    "speech.speechReporter": "fala",
    "speech.whenIHear": "cuando siento [PHRASE]",
    "text2speech.alto": "altu",
    "text2speech.categoryName": "Testu pa dicir",
    "text2speech.defaultTextToSpeak": "hola",
    "text2speech.giant": "xigante",
    "text2speech.kitten": "gatín",
    "text2speech.setLanguageBlock": "afitar llingua como [LANGUAGE]",
    "text2speech.setVoiceBlock": "afitar voz como [VOICE]",
    "text2speech.speakAndWaitBlock": "falar [WORDS]",
    "text2speech.squeak": "chirríu",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducir",
    "translate.defaultTextToTranslate": "hola",
    "translate.translateBlock": "traducir [WORDS] al [LANGUAGE]",
    "translate.viewerLanguage": "llingua",
    "videoSensing.categoryName": "Deteición de videu",
    "videoSensing.direction": "direición",
    "videoSensing.motion": "movimientu",
    "videoSensing.off": "encesu",
    "videoSensing.on": "encesu",
    "videoSensing.onFlipped": "nel xiru",
    "videoSensing.setVideoTransparency": "afitar tresparencia del videu como [TRANSPARENCY]",
    "videoSensing.sprite": "personaxe",
    "videoSensing.stage": "escenariu",
    "videoSensing.videoOn": "videu [ATTRIBUTE] en [SUBJECT]",
    "videoSensing.videoToggle": "videu [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "cuando'l movimientu del videu > [REFERENCE]",
    "wedo2.getDistance": "distancia",
    "wedo2.getTiltAngle": "ángulu d'enclín [TILT_DIRECTION]",
    "wedo2.isTilted": "¿ enclín [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "per ehí",
    "wedo2.motorDirection.forward": "per equí",
    "wedo2.motorDirection.reverse": "inversu",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "tolos motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "apagar [MOTOR_ID]",
    "wedo2.motorOn": "prender [MOTOR_ID]",
    "wedo2.motorOnFor": "prender [MOTOR_ID] pa [DURATION] segundos",
    "wedo2.playNoteFor": "tocar una nota [NOTE] por [DURATION] segundos",
    "wedo2.setLightHue": "afitar color de lluz pa [HUE]",
    "wedo2.setMotorDirection": "afitar [MOTOR_ID] direición como [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "afitar [MOTOR_ID] potencia como [POWER]",
    "wedo2.tiltDirection.any": "cualisquier",
    "wedo2.tiltDirection.down": "abaxo",
    "wedo2.tiltDirection.left": "izquierda",
    "wedo2.tiltDirection.right": "drecha",
    "wedo2.tiltDirection.up": "arriba",
    "wedo2.whenDistance": "cuando la distancia [OP] [REFERENCE]",
    "wedo2.whenTilted": "cuando l'enclín [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "Brillu",
    "paint.paintEditor.costume": "Disfraz",
    "paint.paintEditor.group": "Grupu",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Desfacer",
    "paint.paintEditor.redo": "Refacer",
    "paint.paintEditor.forward": "P'alantre",
    "paint.paintEditor.backward": "P'atrás",
    "paint.paintEditor.front": "Frente",
    "paint.paintEditor.back": "Atrás",
    "paint.paintEditor.more": "Más",
    "paint.modeTools.brushSize": "Tamañu",
    "paint.modeTools.eraserSize": "Tamañu del borrador",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Apegar",
    "paint.modeTools.delete": "Esborrar",
    "paint.modeTools.curved": "En curva",
    "paint.modeTools.pointed": "Afiláu",
    "paint.modeTools.thickness": "Espesor",
    "paint.modeTools.flipHorizontal": "Xirar horizontalmente",
    "paint.modeTools.flipVertical": "Xirar verticalmente",
    "paint.modeTools.filled": "Rellenu",
    "paint.modeTools.outlined": "Contorniáu",
    "paint.paintEditor.bitmap": "Convertir a Bitmap",
    "paint.paintEditor.vector": "Convertir a vector",
    "paint.paintEditor.fill": "Rellenar",
    "paint.paintEditor.stroke": "Contornu",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Borrador",
    "paint.fillMode.fill": "Rellenar",
    "paint.lineMode.line": "Llinia",
    "paint.ovalMode.oval": "Círculu",
    "paint.rectMode.rect": "Rectángulu",
    "paint.reshapeMode.reshape": "Remodelar",
    "paint.roundedRectMode.roundedRect": "Rectángulu arrondiáu",
    "paint.selectMode.select": "Escoyer",
    "paint.textMode.text": "Testu",
    "paint.colorPicker.swap": "Intercambiar"
  },
  "az": {
    "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
    "gui.alerts.tryAgain": "Try Again",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Reconnect",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Bel çantası",
    "gui.backpack.errorBackpack": "Bel çantasının yüklənməsində yanlışlıq",
    "gui.backpack.loadingBackpack": "Yüklənir ...",
    "gui.backpack.more": "More",
    "gui.backpack.emptyBackpack": "Bel çantası boşdur",
    "gui.unsupportedBrowser.label": "Brauzer dəstəklənmir",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Geri",
    "gui.unsupportedBrowser.previewfaq": "Daha çox məlumat üçün {previewFaqLink} linkinə keçid edin.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Təlimatlar",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Close",
    "gui.cards.more-things-to-try": "Yoxlamağa daha çox imkan!",
    "gui.cards.see-more": "Daha çox",
    "gui.comingSoon.message1": "Narahat olmayın, biz bunun üzərində çalışırıq {emoji}",
    "gui.comingSoon.message2": "Tezliklə ...",
    "gui.comingSoon.message3": "Biz bunun üzərində çalışırıq {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "Axtarışı başlatmaq üçün cihazınızı yaxınlıqda yerləşdirin.",
    "gui.connection.auto-scanning.pressbutton": "Cihazınızdakı düyməyə basın.",
    "gui.connection.auto-scanning.start-search": "Axtarışa başlayın",
    "gui.connection.connecting-searchbutton": "Axtarılır...",
    "gui.connection.auto-scanning.try-again": "Yenidən cəhd edin",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Qoşuludur",
    "gui.connection.disconnect": "Qoşulma",
    "gui.connection.go-to-editor": "Redaktora keçin",
    "gui.connection.connecting-cancelbutton": "Qoşulur ...",
    "gui.connection.error.errorMessage": "Ups! Görünür ki, nə isə səhv getdi.",
    "gui.connection.error.tryagainbutton": "Yenidən cəhd et",
    "gui.connection.error.helpbutton": "Yardım",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "Qoşul",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "Yuxarıdakı siyahıdan öz cihazınızı seçin.",
    "gui.connection.search": "Yenilə",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Skreç linkinin yüklənməyində və işləməyindən əmin olun",
    "gui.connection.unavailable.enablebluetooth": "Bluetoothun aktiv olduğunu yoxlayın",
    "gui.connection.unavailable.tryagainbutton": "Yenidən cəhd et",
    "gui.connection.unavailable.helpbutton": "Yardım",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Başlat",
    "gui.controls.stop": "Dayandır",
    "gui.crashMessage.label": "Oops! Something went wrong.",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Reload",
    "gui.customProcedures.myblockModalTitle": "Blok yarat",
    "gui.customProcedures.addAnInputNumberText": "Dəyişən əlavə et",
    "gui.customProcedures.numberTextType": "rəqəm və ya mətn",
    "gui.customProcedures.addAnInputBoolean": "Dəyişən əlavə et",
    "gui.customProcedures.booleanType": "məntiqi",
    "gui.customProcedures.addALabel": "Yarlıq əlavə et",
    "gui.customProcedures.runWithoutScreenRefresh": "Ekranı yeniləmədən işə sal",
    "gui.customProcedures.cancel": "Ləğv et",
    "gui.customProcedures.ok": "Oldu",
    "gui.SpriteInfo.direction": "İstiqamət",
    "gui.directionPicker.rotationStyles.allAround": "Ətrafında",
    "gui.directionPicker.rotationStyles.leftRight": "Sol/Sağ",
    "gui.directionPicker.rotationStyles.dontRotate": "Döndərmə",
    "gui.gui.addExtension": "Genişlənmə əlavə et",
    "gui.gui.codeTab": "Kod",
    "gui.gui.backdropsTab": "Fonlar",
    "gui.gui.costumesTab": "Libaslar",
    "gui.gui.soundsTab": "Səslər",
    "gui.extensionLibrary.comingSoon": "Tezliklə ...",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "Collaboration with",
    "gui.library.filterPlaceholder": "Axtarış",
    "gui.library.allTag": "All",
    "gui.loader.message1": "Bloklar yaradılır ...",
    "gui.loader.message2": "Spraytlar yüklənir ...",
    "gui.loader.message3": "Səslər yüklənir ...",
    "gui.loader.message4": "Genişlənmələr yüklənir ...",
    "gui.loader.message5": "Tənbəl pişiklər...",
    "gui.loader.message6": "Böyük həcmli layihənin ötürülməsi",
    "gui.loader.message7": "Gobolar şişir",
    "gui.loader.message8": "Emojilər hazırlanır ...",
    "gui.loader.headline": "Layihə yüklənir",
    "gui.loader.creating": "Creating Project",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "My Stuff",
    "gui.accountMenu.myClasses": "My Classes",
    "gui.accountMenu.myClass": "My Class",
    "gui.accountMenu.accountSettings": "Account settings",
    "gui.accountMenu.signOut": "Sign out",
    "gui.authorInfo.byUser": "by {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "gui.menuBar.language": "Language",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Sign in",
    "login.needHelp": "Need Help?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "Təlimatlar",
    "gui.menuBar.restoreSprite": "Spraytı bərpa edin",
    "gui.menuBar.restoreSound": "Restore Sound",
    "gui.menuBar.restoreCostume": "Restore Costume",
    "gui.menuBar.restore": "Restore",
    "gui.menuBar.saveNow": "İndi saxla",
    "gui.menuBar.saveAsCopy": "Save as a copy",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Yeni",
    "gui.menuBar.file": "Fayl",
    "gui.menuBar.downloadToComputer": "Kompüterə yüklə",
    "gui.menuBar.edit": "Düzəliş et",
    "gui.menuBar.turboModeOff": "Turn off Turbo Mode",
    "gui.menuBar.turboModeOn": "Turn on Turbo Mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Join Scratch",
    "gui.menuBar.signIn": "Sign in",
    "gui.gui.projectTitlePlaceholder": "Project title here",
    "gui.menuBar.saveNowLink": "Save Now",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Shared",
    "gui.menuBar.share": "Paylaş",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Yardım",
    "gui.modal.back": "Geri",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "length {length}",
    "gui.monitor.contextMenu.default": "normal readout",
    "gui.monitor.contextMenu.large": "large readout",
    "gui.monitor.contextMenu.slider": "sürüşkən",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Bütün spraytlar üçün",
    "gui.gui.variableScopeOptionSpriteOnly": "Yalnız bu sprayt üçün",
    "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
    "gui.gui.variablePromptAllSpritesMessage": "Bu dəyişən bütün spraytlar üçün mövcud olacaq.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Ləğv et",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Dayandır",
    "gui.playbackStep.playMsg": "Oynat",
    "gui.playbackStep.loadingMsg": "Yüklənir ...",
    "gui.playbackStep.saveMsg": "Saxla",
    "gui.playbackStep.reRecordMsg": "Səsi yenidən yaz",
    "gui.recordModal.title": "Səs yaz",
    "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "Stop recording",
    "gui.recordingStep.record": "Record",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Səs",
    "gui.soundEditor.play": "Çal",
    "gui.soundEditor.stop": "dayandır",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Saxla",
    "gui.soundEditor.undo": "Ləğv et",
    "gui.soundEditor.redo": "Redo",
    "gui.soundEditor.faster": "Cəld",
    "gui.soundEditor.slower": "Yavaş",
    "gui.soundEditor.echo": "Əks-səda",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Uca",
    "gui.soundEditor.softer": "Softer",
    "gui.soundEditor.reverse": "Tərsinə çevirmək",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Ad",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprayt",
    "gui.SpriteInfo.show": "Göstər",
    "gui.SpriteInfo.size": "Ölçü",
    "gui.spriteSelectorItem.contextMenuDuplicate": "Dublikat yarat",
    "gui.spriteSelectorItem.contextMenuExport": "ixrac et",
    "gui.spriteSelectorItem.contextMenuDelete": "sil",
    "gui.spriteSelector.addSpriteFromLibrary": "Sprayt seç",
    "gui.spriteSelector.addSpriteFromPaint": "Çək",
    "gui.spriteSelector.addSpriteFromSurprise": "Sürpriz",
    "gui.spriteSelector.addSpriteFromFile": "Upload Sprite",
    "gui.stageHeader.stageSizeLarge": "Böyük səhnəyə keçid",
    "gui.stageHeader.stageSizeSmall": "Kiçik səhnəyə keç",
    "gui.stageHeader.stageSizeFull": "Tam ekran rejiminə daxil ol",
    "gui.stageHeader.stageSizeUnFull": "Tam ekran rejimindən çıx",
    "gui.stageHeader.fullscreenControl": "Tam ekran idarəedicisi",
    "gui.spriteSelector.addBackdropFromLibrary": "Fon seç",
    "gui.stageSelector.addBackdropFromPaint": "Paint",
    "gui.stageSelector.addBackdropFromSurprise": "Sürpriz",
    "gui.stageSelector.addBackdropFromFile": "Fon yüklə",
    "gui.stageSelector.stage": "Səhnə",
    "gui.stageSelector.backdrops": "Fonlar",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo rejim",
    "gui.webglModal.label": "Sənin Brauzerin WebGL-i dəstəkləmir",
    "gui.webglModal.description": "Təəssüf ki, brauzerinizdə və ya kompüterinizdə  {webGlLink} olmadığı kimi görünür. Bu texnologiya Skreç 3.0-ın işləməsi üçün vacibdir.",
    "gui.webglModal.webgllink": "WebGL-i dəstəkləmir",
    "gui.webglModal.back": "Geri",
    "gui.webglModal.previewfaq": "Daha çox məlumat üçün {previewFaqLink} linkinə keçid edin.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Fon seç",
    "gui.costumeLibrary.chooseACostume": "Libas seç",
    "gui.costumeTab.addBackdropFromLibrary": "Fon seç",
    "gui.costumeTab.addCostumeFromLibrary": "Libas seç",
    "gui.costumeTab.addBlankCostume": "Paint",
    "gui.costumeTab.addSurpriseCostume": "Sürpriz",
    "gui.costumeTab.addFileBackdrop": "Fon yüklə",
    "gui.costumeTab.addFileCostume": "Libas yüklə",
    "gui.extensionLibrary.chooseAnExtension": "Genişlənmə seç",
    "gui.extensionLibrary.extensionUrl": "Genişlənmənin URL-ini daxil edin",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Yazmağa başlaya bilmədi",
    "gui.soundLibrary.chooseASound": "Səs seç",
    "gui.soundTab.fileUploadSound": "Səs yüklə",
    "gui.soundTab.surpriseSound": "Sürpriz",
    "gui.soundTab.recordSound": "Record",
    "gui.soundTab.addSoundFromLibrary": "Səs seç",
    "gui.spriteLibrary.chooseASprite": "Sprayt seç",
    "gui.tipsLibrary.tutorials": "Təlimat seçin",
    "gui.alerts.createsuccess": "New project created.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Could not create the project. Please try again!",
    "gui.alerts.savingError": "Project could not save.",
    "gui.alerts.savesuccess": "Project saved.",
    "gui.alerts.saving": "Saving project…",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Yeni başlayanlar",
    "gui.howtos.intro-move.step_stepMove": "Hərəkət bloku əlavə et",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animate a Name",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Hərf Spraytı götür",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Kliklənəndə Səsi ifa et",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Başqa Hərf Spraytı götür",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Rəngi dəyiş",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Başqa hərf götür & fırlat",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Başqa hərf götür & Böyüt",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Musiqi Yarat",
    "gui.howtos.Make-Music.step_PickInstrument": "Alət Spraytı götür",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Kliklənəndə Səsi ifa et",
    "gui.howtos.Make-Music.step_MakeSong": "Mahnı yarat",
    "gui.howtos.make-music.step_MakeBeat": "Baraban seç & Çal",
    "gui.howtos.make-music.step_MakeBeatBox": "Choose the Microphone Sprite & Surprise Beatbox",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Ov Oyunu yarat",
    "gui.howtos.Chase-Game.step_BG": "Fon əlavə et",
    "gui.howtos.chase-game.step_AddOcto": "Sprayt əlavə et",
    "gui.howtos.make-music.step_LeftRight": "Move Right & Left With Arrow Keys",
    "gui.howtos.Chase-Game.step_UpDown": "İstiqamət düymələri vasitəsilə Yuxarı & Aşağı hərəkət et",
    "gui.howtos.Chase-Game.step_AddStar": "Başqa Sprayt əlavə et",
    "gui.howtos.Chase-Game.step_MoveRandom": "Təsadüfi hərəkət et",
    "gui.howtos.Chase-Game.step_WhenTouch": "Oktapod Spraytında, Səsi ifa edə toxunan zaman",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Hesab dəyişəni yarat",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In Octopus Sprite, When Touching Add Score",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "Klikləmə Oyunu yarat",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Sprayt götür",
    "gui.howtos.make-a-game.step_GamePlaySound": "Kliklənəndə Səsi ifa et",
    "gui.howtos.make-a-game.step_GameAddScore": "Hesab dəyişəni yarat",
    "gui.howtos.make-a-game.step_GameChangeScore": "Klikləndikdə hesabı artır",
    "gui.howtos.make-a-game.step_Random": "Təsadüfi mövqeyə get",
    "gui.howtos.make-music.step_GameChangeColor": "Rəngi dəyiş",
    "gui.howtos.make-music.step_ResetScore": "Hesabı sıfırla",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Sprayt əlavə et",
    "gui.howtos.add-sprite.step_addSprite": "Sprayt əlavə et",
    "gui.howtos.add-a-backdrop.name": "Fon əlavə et",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Ölçünü dəyiş",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Ətrafında sürüş",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Səs yaz",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Make It Spin",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Gizlət və Göstər",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Sprayta animasiya ver",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Use Arrow Keys",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Effektlər əlavə et",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Musiqi",
    "gui.extension.music.description": "Alətlər və barabanlar çal.",
    "gui.extension.pen.name": "Qələm",
    "gui.extension.pen.description": "Spraytlarınla çək.",
    "gui.extension.videosensing.name": "Video Sensoru",
    "gui.extension.videosensing.description": "Kamera ilə hissi hərəkət",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description": "Translate text into many languages.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "Layihələrinizi dünyayla paylaşın.",
    "gui.extension.microbit.connectingMessage": "Qoşulur",
    "gui.extension.ev3.description": "İnteraktiv robotlar və daha çoxunu qurun.",
    "gui.extension.ev3.connectingMessage": "Qoşulur. EV3-dəki pin kodun 1234 təyin olunduğundan əmin olun.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Mühərriklər və sensorlar ilə qurun.",
    "gui.extension.wedo2.connectingMessage": "Connecting",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "All",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dance",
    "gui.libraryTags.effects": "Effects",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Indoors",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Music",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Outdoors",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "People",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Underwater",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Games",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "size",
    "gui.opcodeLabels.costumename": "costume name",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "backdrop name",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "answer",
    "gui.opcodeLabels.loudness": "loudness",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "year",
    "gui.opcodeLabels.month": "month",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "day of week",
    "gui.opcodeLabels.hour": "hour",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "second",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "Seçilmiş layihənin yüklənməsi uğursuz olmuşdur.",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "[NOTE] notunu [TIME] saniyə səsləndir",
    "ev3.buttonPressed": "[PORT] düyməsi basılıb?",
    "ev3.getBrightness": "parlaqlıq",
    "ev3.getDistance": "məsafə",
    "ev3.getMotorPosition": "[PORT] mühərrikinin mövqeyi",
    "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
    "ev3.whenButtonPressed": "when button [PORT] pressed",
    "ev3.whenDistanceLessThan": "when distance < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "down",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "left",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "right",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "up",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "any",
    "microbit.clearDisplay": "clear display",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] button pressed?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "off",
    "microbit.pinStateMenu.on": "on",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "any",
    "microbit.tiltDirectionMenu.back": "back",
    "microbit.tiltDirectionMenu.front": "front",
    "microbit.tiltDirectionMenu.left": "left",
    "microbit.tiltDirectionMenu.right": "right",
    "microbit.whenButtonPressed": "when [BTN] button pressed",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "music.categoryName": "Musiqi",
    "music.changeTempo": "tempi [TEMPO] qədər dəyiş",
    "music.drumBass": "(2) Bas barabanı",
    "music.drumBongo": "(13) Bonqo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Klavesin",
    "music.drumClosedHiHat": "(6) Bağlı Hi-Hat",
    "music.drumConga": "(14) Konqa",
    "music.drumCowbell": "(11) Zınqırov",
    "music.drumCrashCymbal": "(4) Zərb aləti",
    "music.drumCuica": "(18) Kuika",
    "music.drumGuiro": "(16) Quiro",
    "music.drumHandClap": "(8) Əl çalmaq",
    "music.drumOpenHiHat": "(5) Açıq Hi-Hat",
    "music.drumSideStick": "(3) Çubuqlu nağara",
    "music.drumSnare": "(1) Kiçik baraban",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Üçbucaq",
    "music.drumVibraslap": "(17) Vibrasiya edən sləp",
    "music.drumWoodBlock": "(10) Taxta qutu",
    "music.getTempo": "temp",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Faqot",
    "music.instrumentCello": "(8) Violonçel",
    "music.instrumentChoir": "(15) Xor",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Elektro gitara",
    "music.instrumentElectricPiano": "(2) Elektro pianino",
    "music.instrumentFlute": "(12) Fleyta",
    "music.instrumentGuitar": "(4) Gitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Musiqi qutusu",
    "music.instrumentOrgan": "(3) Orqan",
    "music.instrumentPiano": "(1) Pianino",
    "music.instrumentPizzicato": "(7) Pizzikato",
    "music.instrumentSaxophone": "(11) Saksafon",
    "music.instrumentSteelDrum": "(18) Polad baraban",
    "music.instrumentSynthLead": "(20) Aparıcı Sintezator",
    "music.instrumentSynthPad": "(21) Sintezator Pad",
    "music.instrumentTrombone": "(9) Trambon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Taxta fleyta",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
    "music.playDrumForBeats": "[DRUM] barabanını [BEATS] takt çal",
    "music.playNoteForBeats": "[NOTE] notunu [BEATS] takt çal",
    "music.restForBeats": "[BEATS] takt çalma",
    "music.setInstrument": "aləti [INSTRUMENT] təyin et",
    "music.setTempo": "tempi [TEMPO] təyin et",
    "pen.categoryName": "Qələm",
    "pen.changeColorParam": "qələmin [COLOR_PARAM] rəngini [VALUE] qədər dəyiş",
    "pen.changeHue": "qələmin rəngini [HUE] qədər dəyiş",
    "pen.changeShade": "qələmin çalarını [SHADE] qədər dəyiş",
    "pen.changeSize": "qələmin ölçüsünü [SIZE] qədər dəyiş",
    "pen.clear": "hamısını sil",
    "pen.colorMenu.brightness": "parlaqlıq",
    "pen.colorMenu.color": "rəng",
    "pen.colorMenu.saturation": "dolğunluq",
    "pen.colorMenu.transparency": "şəffaflıq",
    "pen.penDown": "qələmi endir",
    "pen.penUp": "qələmi qaldır",
    "pen.setColor": "qələmin rəngini [COLOR] təyin et",
    "pen.setColorParam": "qələmin [COLOR_PARAM] rəngini [VALUE] təyin et",
    "pen.setHue": "qələmin rəngini [HUE] təyin et",
    "pen.setShade": "qələmin çalarını [SHADE] təyin et",
    "pen.setSize": "qələmin ölçüsünü [SIZE] təyin et",
    "pen.stamp": "möhürlə",
    "speech.defaultWhenIHearValue": "gedək",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "dinlə və gözlə",
    "speech.speechReporter": "danışıq",
    "speech.whenIHear": "Mən [PHRASE] eşitdikdə",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "giant",
    "text2speech.kitten": "kitten",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "set voice to [VOICE]",
    "text2speech.speakAndWaitBlock": "speak [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Translate",
    "translate.defaultTextToTranslate": "salam",
    "translate.translateBlock": "[WORDS] ifadəsini [LANGUAGE] dilinə tərcümə et",
    "translate.viewerLanguage": "dil",
    "videoSensing.categoryName": "Video Sensoru",
    "videoSensing.direction": "istiqamət",
    "videoSensing.motion": "hərəkət",
    "videoSensing.off": "söndür",
    "videoSensing.on": "on",
    "videoSensing.onFlipped": "çevrilmiş",
    "videoSensing.setVideoTransparency": "videonun şəffaflığını [TRANSPARENCY] təyin et",
    "videoSensing.sprite": "sprayt",
    "videoSensing.stage": "səhnə",
    "videoSensing.videoOn": "videonun [ATTRIBUTE] atributları [SUBJECT] aid",
    "videoSensing.videoToggle": "videonu [VIDEO_STATE] çevir",
    "videoSensing.whenMotionGreaterThan": "videonun hərəkəti > [REFERENCE]  olduqda",
    "wedo2.getDistance": "distance",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "reverse",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
    "wedo2.setLightHue": "set light color to [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "down",
    "wedo2.tiltDirection.left": "left",
    "wedo2.tiltDirection.right": "right",
    "wedo2.tiltDirection.up": "up",
    "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Rəng",
    "paint.paintEditor.saturation": "Dolğunluq",
    "paint.paintEditor.brightness": "Parlaqlıq",
    "paint.paintEditor.costume": "Libas",
    "paint.paintEditor.group": "Qrup",
    "paint.paintEditor.ungroup": "Qrupu ləğv et",
    "paint.paintEditor.undo": "Ləğv et",
    "paint.paintEditor.redo": "Redo",
    "paint.paintEditor.forward": "İrəli",
    "paint.paintEditor.backward": "Geri",
    "paint.paintEditor.front": "Ön",
    "paint.paintEditor.back": "Geri",
    "paint.paintEditor.more": "Daha çox",
    "paint.modeTools.brushSize": "Ölçü",
    "paint.modeTools.eraserSize": "Pozanın ölçüsü",
    "paint.modeTools.copy": "Kopyala",
    "paint.modeTools.paste": "Yerləşdir",
    "paint.modeTools.delete": "Sil",
    "paint.modeTools.curved": "Əyri",
    "paint.modeTools.pointed": "İşarələnmiş",
    "paint.modeTools.thickness": "Qalınlıq",
    "paint.modeTools.flipHorizontal": "Üfiqi çevir",
    "paint.modeTools.flipVertical": "Şaquli çevir",
    "paint.modeTools.filled": "Dolu",
    "paint.modeTools.outlined": "Konturlanmış",
    "paint.paintEditor.bitmap": "Rastr qrafikasına çevir",
    "paint.paintEditor.vector": "Vektor qrafikasına çevir",
    "paint.paintEditor.fill": "Rənglə doldur",
    "paint.paintEditor.stroke": "Kontur",
    "paint.brushMode.brush": "Brush",
    "paint.eraserMode.eraser": "Eraser",
    "paint.fillMode.fill": "Fill",
    "paint.lineMode.line": "Line",
    "paint.ovalMode.oval": "Circle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Reshape",
    "paint.roundedRectMode.roundedRect": "Rounded Rectangle",
    "paint.selectMode.select": "Select",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Dəyişdir"
  },
  "id": {
    "gui.alerts.lostPeripheralConnection": "Scratch putus hubungan dengan {extensionName}.",
    "gui.alerts.tryAgain": "Coba Lagi",
    "gui.alerts.download": "Unduh",
    "gui.connection.reconnect": "Hubungkan Ulang",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Ransel",
    "gui.backpack.errorBackpack": "Gagal memuat ransel",
    "gui.backpack.loadingBackpack": "Memuat...",
    "gui.backpack.more": "Lebih",
    "gui.backpack.emptyBackpack": "Ransel kosong",
    "gui.unsupportedBrowser.label": "Peramban tidak didukung",
    "gui.unsupportedBrowser.errorLabel": "Sebuah Kesalahan Terjadi",
    "gui.unsupportedBrowser.notRecommended": "Kami minta maaf, tapi tampaknya Anda menggunakan sebuah versi peramban yang tidak didukung Scratch. Kami menyarankan memperbarui ke versi terbaru peramban yang didukung seperti Google Chrome, Mozilla Firefox, Microsoft Edge, atau Apple Safari.",
    "gui.unsupportedBrowser.description": "Kami minta maaf, tapi Scratch tidak mendukung peramban ini. Kami menyarankan memperbarui ke versi terbaru peramban yang didukung seperti Google Chrome, Mozilla Firefox, Microsoft Edge, atau Apple Safari.",
    "gui.unsupportedBrowser.back": "Kembali",
    "gui.unsupportedBrowser.previewfaq": "Untuk belajar lebih lanjut, pergi ke {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutorial",
    "gui.cards.shrink": "Kecilkan",
    "gui.cards.expand": "Perluas",
    "gui.cards.close": "Tutup",
    "gui.cards.more-things-to-try": "Lebih banyak hal untuk dicoba!",
    "gui.cards.see-more": "Lihat lebih banyak",
    "gui.comingSoon.message1": "Jangan khawatir, kami sedang mengerjakannya {emoji}",
    "gui.comingSoon.message2": "Akan Segera Datang",
    "gui.comingSoon.message3": "Kami sedang mengerjakannya {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Tidak ada gawai yang ditemukan.",
    "gui.connection.auto-scanning.prescan": "Letakkan gawaimu di dekat, lalu mulai pencarian.",
    "gui.connection.auto-scanning.pressbutton": "Tekan tombol di gawaimu.",
    "gui.connection.auto-scanning.start-search": "Mulai Mencari",
    "gui.connection.connecting-searchbutton": "Mencari...",
    "gui.connection.auto-scanning.try-again": "Coba lagi",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Terhubung",
    "gui.connection.disconnect": "Putus hubungan",
    "gui.connection.go-to-editor": "Pergi ke Editor",
    "gui.connection.connecting-cancelbutton": "Menyambung...",
    "gui.connection.error.errorMessage": "Ups, terjadi suatu kesalahan.",
    "gui.connection.error.tryagainbutton": "Coba lagi",
    "gui.connection.error.helpbutton": "Bantuan",
    "gui.connection.peripheral-name-label": "Nama gawai",
    "gui.connection.connect": "Sambung",
    "gui.connection.scanning.lookingforperipherals": "Mencari gawai-gawai",
    "gui.connection.scanning.noPeripheralsFound": "Tidak ada gawai yang ditemukan.",
    "gui.connection.scanning.instructions": "Pilih gawaimu dari daftar di atas.",
    "gui.connection.search": "Perbarui",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Pastikan bahwa Scratch Link telah dipasang dan sedang berjalan",
    "gui.connection.unavailable.enablebluetooth": "Pastikan Bluetooth menyala",
    "gui.connection.unavailable.tryagainbutton": "Coba lagi",
    "gui.connection.unavailable.helpbutton": "Bantuan",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Jalankan",
    "gui.controls.stop": "Hentikan",
    "gui.crashMessage.label": "Ups! Suatu kesalahan terjadi",
    "gui.crashMessage.description": "Kami minta maaf, tampaknya Scratch sedang macet. Kesalahan ini akan secara otomatis dilaporkan ke Scratch Team. Tolong perbarui halamanmu untuk mencoba lagi.",
    "gui.crashMessage.errorNumber": "Kesalahan yang terjadi tercatat dengan id {errorId}",
    "gui.crashMessage.reload": "Muat ulang",
    "gui.customProcedures.myblockModalTitle": "Buat sebuah Balok",
    "gui.customProcedures.addAnInputNumberText": "Tambahkan input",
    "gui.customProcedures.numberTextType": "angka atau teks",
    "gui.customProcedures.addAnInputBoolean": "Tambahkan input",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Tambahkan label",
    "gui.customProcedures.runWithoutScreenRefresh": "Bekerja secara instan",
    "gui.customProcedures.cancel": "Batal",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Arah",
    "gui.directionPicker.rotationStyles.allAround": "Semua arah",
    "gui.directionPicker.rotationStyles.leftRight": "Kiri/Kanan",
    "gui.directionPicker.rotationStyles.dontRotate": "Jangan berputar",
    "gui.gui.addExtension": "Tambahkan Ekstensi",
    "gui.gui.codeTab": "Kode",
    "gui.gui.backdropsTab": "Latar",
    "gui.gui.costumesTab": "Kostum",
    "gui.gui.soundsTab": "Suara",
    "gui.extensionLibrary.comingSoon": "Akan Segera Datang",
    "gui.extensionLibrary.requires": "Memerlukan",
    "gui.extensionLibrary.collaboration": "Kolaborasi dengan",
    "gui.library.filterPlaceholder": "Cari",
    "gui.library.allTag": "Semua",
    "gui.loader.message1": "Membuat balok-balok …",
    "gui.loader.message2": "Memuat sprite-sprite …",
    "gui.loader.message3": "Memuat suara …",
    "gui.loader.message4": "Memuat ekstensi …",
    "gui.loader.message5": "Menggembala kucing-kucing …",
    "gui.loader.message6": "Mengirim nano-nano …",
    "gui.loader.message7": "Memompa gobo-gobo …",
    "gui.loader.message8": "Menyiapkan emoji-emoji …",
    "gui.loader.headline": "Memuat Karya",
    "gui.loader.creating": "Membuat Karya",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Karyaku",
    "gui.accountMenu.myClasses": "Kelas Saya",
    "gui.accountMenu.myClass": "Kelas Saya",
    "gui.accountMenu.accountSettings": "Pengaturan akun",
    "gui.accountMenu.signOut": "Keluar",
    "gui.authorInfo.byUser": "oleh {username}",
    "gui.menuBar.seeProjectPage": "Lihat Halaman Karya",
    "gui.menuBar.language": "Language",
    "general.username": "Nama Pengguna",
    "general.password": "Sandi",
    "general.signIn": "Masuk",
    "login.needHelp": "Perlu Bantuan?",
    "form.validationRequired": "Bagian ini mesti diisi",
    "gui.menuBar.tutorialsLibrary": "Tutorial",
    "gui.menuBar.restoreSprite": "Kembalikan Sprite",
    "gui.menuBar.restoreSound": "Kembalikan Suara",
    "gui.menuBar.restoreCostume": "Kembalikan Kostum",
    "gui.menuBar.restore": "Kembalikan",
    "gui.menuBar.saveNow": "Simpan sekarang",
    "gui.menuBar.saveAsCopy": "Simpan sebagai salinan",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Baru",
    "gui.menuBar.file": "Berkas",
    "gui.menuBar.downloadToComputer": "Simpan ke komputermu",
    "gui.menuBar.edit": "Sunting",
    "gui.menuBar.turboModeOff": "Matikan Mode Turbo",
    "gui.menuBar.turboModeOn": "Nyalakan Mode Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Bergabung dengan Scratch",
    "gui.menuBar.signIn": "Masuk",
    "gui.gui.projectTitlePlaceholder": "Judul karya di sini",
    "gui.menuBar.saveNowLink": "Simpan Sekarang",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Terbagikan",
    "gui.menuBar.share": "Bagikan",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Bantuan",
    "gui.modal.back": "Kembali",
    "gui.monitor.listMonitor.empty": "(kosong)",
    "gui.monitor.listMonitor.listLength": "panjang {length}",
    "gui.monitor.contextMenu.default": "tampilan normal",
    "gui.monitor.contextMenu.large": "tampilan besar",
    "gui.monitor.contextMenu.slider": "slider",
    "gui.monitor.contextMenu.sliderRange": "ubah rentang slider",
    "gui.monitor.contextMenu.import": "impor",
    "gui.monitor.contextMenu.export": "ekspor",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Putar",
    "gui.playButton.stop": "Berhenti",
    "gui.gui.variableScopeOptionAllSprites": "Untuk semua sprite",
    "gui.gui.variableScopeOptionSpriteOnly": "Hanya untuk sprite ini",
    "gui.gui.cloudVariableOption": "Variabel Cloud (disimpan di server)",
    "gui.gui.variablePromptAllSpritesMessage": "Variabel ini bakal tersedia untuk semua sprite.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Batal",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Hentikan",
    "gui.playbackStep.playMsg": "Putar",
    "gui.playbackStep.loadingMsg": "Memuat...",
    "gui.playbackStep.saveMsg": "Simpan",
    "gui.playbackStep.reRecordMsg": "Rekam ulang",
    "gui.recordModal.title": "Rekam Suara",
    "gui.recordingStep.beginRecord": "Mulai merekam dengan mengklik tombol di bawah",
    "gui.recordingStep.permission": "{arrow}Kami memerlukan izinmu untuk menggunakan mikrofonmu",
    "gui.recordingStep.stop": "Berhenti merekam",
    "gui.recordingStep.record": "Rekam",
    "gui.sliderModal.min": "Nilai minimum",
    "gui.sliderModal.max": "Nilai maksimum",
    "gui.sliderModal.title": "Ubah rentang slider",
    "gui.sliderPrompt.cancel": "Batalkan",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Suara",
    "gui.soundEditor.play": "Putar",
    "gui.soundEditor.stop": "Berhenti",
    "gui.soundEditor.copy": "Salin",
    "gui.soundEditor.paste": "Tempel",
    "gui.soundEditor.copyToNew": "Salin ke Baru",
    "gui.soundEditor.delete": "Hapus",
    "gui.soundEditor.save": "Simpan",
    "gui.soundEditor.undo": "Batalkan",
    "gui.soundEditor.redo": "Ulangi",
    "gui.soundEditor.faster": "Lebih cepat",
    "gui.soundEditor.slower": "Lebih lambat",
    "gui.soundEditor.echo": "Gema",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Lebih nyaring",
    "gui.soundEditor.softer": "Lebih lembut",
    "gui.soundEditor.reverse": "Balikkan arah",
    "gui.soundEditor.fadeOut": "Pudar akhir",
    "gui.soundEditor.fadeIn": "Pudar awal",
    "gui.soundEditor.mute": "Bisukan",
    "gui.SpriteInfo.spritePlaceholder": "Judul",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Tampilkan",
    "gui.SpriteInfo.size": "Ukuran",
    "gui.spriteSelectorItem.contextMenuDuplicate": "gandakan",
    "gui.spriteSelectorItem.contextMenuExport": "ekspor",
    "gui.spriteSelectorItem.contextMenuDelete": "hapus",
    "gui.spriteSelector.addSpriteFromLibrary": "Pilih Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Lukis",
    "gui.spriteSelector.addSpriteFromSurprise": "Kejutan",
    "gui.spriteSelector.addSpriteFromFile": "Unggah Sprite",
    "gui.stageHeader.stageSizeLarge": "Ganti ke panggung besar",
    "gui.stageHeader.stageSizeSmall": "Ganti ke panggung kecil",
    "gui.stageHeader.stageSizeFull": "Masuk mode layar penuh",
    "gui.stageHeader.stageSizeUnFull": "Keluar dari mode seluruh layar",
    "gui.stageHeader.fullscreenControl": "Kendali Layar Penuh",
    "gui.spriteSelector.addBackdropFromLibrary": "Pilih Latar",
    "gui.stageSelector.addBackdropFromPaint": "Lukis",
    "gui.stageSelector.addBackdropFromSurprise": "Kejutan",
    "gui.stageSelector.addBackdropFromFile": "Unggah Latar",
    "gui.stageSelector.stage": "Panggung",
    "gui.stageSelector.backdrops": "Latar",
    "gui.telemetryOptIn.label": "Laporkan statistik untuk memperbaiki Scratch",
    "gui.telemetryOptIn.body1": "Scratch Team selalu mencari cara untuk mengerti dengan lebih baik bagaimana Scratch digunakan di segala penjuru dunia. Untuk mendukung usaha ini, kamu bisa memperbolehkan Scratch untuk otomatis mengirim informasi penggunaan ke Scratch Team.",
    "gui.telemetryOptIn.body2": "Informasi yang kami kumpulkan termasuk pemilihan bahasa, penggunaan balok, dan sebagian kejadian seperti penyimpanan, pemuatan, dan pengunggahan karya. Kami TIDAK mengumpulkan informasi pribadi. Mohon lihat {privacyPolicyLink}kami untuk informasi lebih jauh.",
    "gui.telemetryOptIn.privacyPolicyLink": "Kebijakan Privasi",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Mode Turbo",
    "gui.webglModal.label": "Perambanmu Tidak Mendukung WebGL",
    "gui.webglModal.description": "Sayangnya tampaknya peramban atau komputermu {webGlLink}. Teknologi ini diperlukan untuk menjalankan Scratch 3.0.",
    "gui.webglModal.webgllink": "tidak mendukung WebGL",
    "gui.webglModal.back": "Kembali",
    "gui.webglModal.previewfaq": "Untuk belajar lebih lanjut, pergi ke {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Pilih Latar",
    "gui.costumeLibrary.chooseACostume": "Pilih Kostum",
    "gui.costumeTab.addBackdropFromLibrary": "Pilih Latar",
    "gui.costumeTab.addCostumeFromLibrary": "Pilih Kostum",
    "gui.costumeTab.addBlankCostume": "Lukis",
    "gui.costumeTab.addSurpriseCostume": "Kejutan",
    "gui.costumeTab.addFileBackdrop": "Unggah Latar",
    "gui.costumeTab.addFileCostume": "Unggah Kostum",
    "gui.extensionLibrary.chooseAnExtension": "Pilih Ekstensi",
    "gui.extensionLibrary.extensionUrl": "Masukkan URL ekstensi",
    "gui.monitors.importListColumnPrompt": "Kolom mana yang mesti digunakan (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Tidak dapat mulai merekam",
    "gui.soundLibrary.chooseASound": "Pilih Suara",
    "gui.soundTab.fileUploadSound": "Unggah Suara",
    "gui.soundTab.surpriseSound": "Kejutan",
    "gui.soundTab.recordSound": "Rekam",
    "gui.soundTab.addSoundFromLibrary": "Pilih Suara",
    "gui.spriteLibrary.chooseASprite": "Pilih Sprite",
    "gui.tipsLibrary.tutorials": "Pilih sebuah Tutorial",
    "gui.alerts.createsuccess": "Karya baru terbuat.",
    "gui.alerts.createcopysuccess": "Karya disimpan sebagai salinan.",
    "gui.alerts.createremixsuccess": "Karya disimpan sebagai sebuah remix.",
    "gui.alerts.creating": "Buat baru...",
    "gui.alerts.creatingCopy": "Menyalin karya...",
    "gui.alerts.creatingRemix": "Meremix karya...",
    "gui.alerts.creatingError": "Tidak bisa membuat karya. Tolong coba lagi!",
    "gui.alerts.savingError": "Karya tidak bisa disimpan.",
    "gui.alerts.savesuccess": "Karya tersimpan.",
    "gui.alerts.saving": "Menyimpan karya...",
    "gui.alerts.cloudInfo": "Tolong ingat, bahwa variabel cloud hanya mendukung angka-angka, tidak huruf atau simbol. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Pelajari lebih lanjut.",
    "gui.alerts.importing": "Mengimpor ...",
    "gui.defaultProject.meow": "Meong",
    "gui.defaultProject.variable": "variabel saya",
    "gui.howtos.intro-move-sayhello-hat.name": "Memulai Scratch",
    "gui.howtos.intro-move.step_stepMove": "Tambahkan sebuah balok gerakan",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animasikan Sebuah Nama",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pilih Sebuah Sprite Huruf",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Mainkan Sebuah Suara Ketika Diklik",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pilih Sprite Huruf Lainnya",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Ubah warna",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pilih Sprite Huruf Lainnya & Buatnya Berputar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pilih Sprite Huruf Lainnya & Buatnya Tumbuh",
    "gui.howtos.imagine": "Bayangkan Sebuah Dunia",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Ketik Apa yang Ingin Kamu Katakan",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klik Bendera Hijau untuk Memulai",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Pilih Latar Manapun",
    "gui.howtos.imagine.step_imagineChooseSprite": "Pilih Sprite Manapun",
    "gui.howtos.imagine.step_imagineFlyAround": "Tekan Tombol Spasi untuk Meluncur",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Pilih Sprite Lain",
    "gui.howtos.imagine.step_imagineLeftRight": "Bergerak ke Kiri-Kanan",
    "gui.howtos.imagine.step_imagineUpDown": "Bergerak Naik-Turun",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Mengganti Kostum",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Meluncur ke Titik Tertentu",
    "gui.howtos.imagine.step_imagineGrowShrink": "Membesar dan Mengecil",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Pilih Latar Lain",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Ganti Latar",
    "gui.howtos.imagine.step_imagineRecordASound": "Tambahan Sebuah Suara",
    "gui.howtos.imagine.step_imagineChooseSound": "Pilih Suaramu",
    "gui.howtos.make-music.name": "Membuat Musik",
    "gui.howtos.Make-Music.step_PickInstrument": "Pilih Sebuah Sprite Instrumen",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Mainkan Suara Ketika Dikli",
    "gui.howtos.Make-Music.step_MakeSong": "Buat Sebuah Lagu",
    "gui.howtos.make-music.step_MakeBeat": "Pilih Sebuah Drum % Buat Sebuah Ketukan",
    "gui.howtos.make-music.step_MakeBeatBox": "Pilih Sprite Mikrofon & Beatbox Kejutan",
    "gui.howtos.story.name": "Buat Sebuah Cerita",
    "gui.howtos.story.step_addbg": "Tambahkan sebuah Latar",
    "gui.howtos.story.step_addsprite": "Tambahkan Seorang Karakter",
    "gui.howtos.story.step_saysomething": "Katakan Sesuatu",
    "gui.howtos.story.step_addanothersprite": "Tambahkan Karakter Lain",
    "gui.howtos.story.step_flip": "Balikkan Arah",
    "gui.howtos.story.step_conversation": "Adakan Sebuah Percakapan",
    "gui.howtos.story.addanotherbg": "Tambahkan Sebuah Latar",
    "gui.howtos.story.step_swithbg": "Ganti Latar",
    "gui.howtos.story.step_hidewizard": "Sembunyikan Seorang Karakter",
    "gui.howtos.story.step_showwizard": "Tampilkan Seorang Karakter",
    "gui.howtos.make-a-chase-game.name": "Buat Sebuah Permainan Kejar-Kejaran",
    "gui.howtos.Chase-Game.step_BG": "Tambahkan sebuah Latar",
    "gui.howtos.chase-game.step_AddOcto": "Tambahkan sebuah Sprite",
    "gui.howtos.make-music.step_LeftRight": "Bergerak Kanan & Kiri Dengan Tombol Panah",
    "gui.howtos.Chase-Game.step_UpDown": "Bergerak Naik & Turun Dengan Tombol Panah",
    "gui.howtos.Chase-Game.step_AddStar": "Tambahkan Sprite Lain",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bergerak Secara Sembarang",
    "gui.howtos.Chase-Game.step_WhenTouch": "Di Sprite Gurita, Ketika Menyentuh Mainkan Suara",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Buat Variabel Nilai",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Di Sprite Gurita, Ketika Menyentuh Tambahkan Nilai",
    "gui.howtos.animate-char.name": "Animasikan Seorang Karakter",
    "gui.howtos.animate-char.step_addbg": "Tambahkan sebuah Latar",
    "gui.howtos.animate-char.step_addsprite": "Tambahkan sebuah Sprite",
    "gui.howtos.animate-char.step_saysomething": "Katakan Sesuatu",
    "gui.howtos.animate-char.step_addsound": "Tambahkan Suara",
    "gui.howtos.animate-char.step_animatetalking": "Animasikan Pembicaraan",
    "gui.howtos.animate-char.step_arrowkeys": "Bergerkan Menggunakan Tombol Panah",
    "gui.howtos.animate-char.step_jump": "Lompat",
    "gui.howtos.animate-char.step_changecolor": "Ubah Warna",
    "gui.howtos.make-a-game.name": "Buat Sebuah Permainan Klik-Klikan",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pilih Sebuah Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Mainkan Suara Ketika Diklik",
    "gui.howtos.make-a-game.step_GameAddScore": "Buat Variabel Nilai",
    "gui.howtos.make-a-game.step_GameChangeScore": "Meningkatkan Skor Ketika Diklik",
    "gui.howtos.make-a-game.step_Random": "Pergi ke posisi sembarang",
    "gui.howtos.make-music.step_GameChangeColor": "Ubah Warna",
    "gui.howtos.make-music.step_ResetScore": "Kosongkan Nilai",
    "gui.howtos.make-it-fly.name": "Terbangkan",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Pilih Sebuah Latar Langit",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Pilih Sebuah Karakter",
    "gui.howtos.fly.step_stepflySaySomething": "Katakan Sesuatu",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Bergerak dengan Tombol Panah",
    "gui.howtos.fly.step_stepflyChooseObject": "Pilih Objek untuk Dikumpulkan",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Buat Objeknya Bergerak",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Pilih Karaktermu",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Tambahkan Skor",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Simpan Skor",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Tambahkan Pemandangan",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Gerakkan Pemandangannya",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Kostum Berikutnya",
    "gui.howtos.pong": "Permainan Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Tambahkan Sebuah Latar",
    "gui.howtos.pong.step_pongAddBallSprite": "Tambahkan Sebuah Sprite Bola",
    "gui.howtos.pong.step_pongBounceAround": "Melambung Keliling",
    "gui.howtos.pong.step_pongAddPaddle": "Tambahkan Pemukul",
    "gui.howtos.pong.step_pongMoveThePaddle": "Gerakkan Pemukulnya",
    "gui.howtos.pong.step_pongSelectBallSprite": "Pilih Sprite Bolanya",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Tambahkan Kode untuk Melambungkan Bola dari Pemukul",
    "gui.howtos.pong.step_pongAddAScore": "Tambahkan Skor",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Pilih 'Skor' dari Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Sisipkan Balok 'Ubah Skor'",
    "gui.howtos.pong.step_pongResetScore": "Kosongkan Skor",
    "gui.howtos.pong.step_pongAddLineSprite": "Tambahkan Sprite Garis",
    "gui.howtos.pong.step_pongGameOver": "Tamat",
    "gui.howtos.code-cartoon": "Buat Kartun dengan Kode",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Katakan Sesuatu Saat Kamu Mengklik Bendera Hijau",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animasikan Seorang Karakter Ketika Kamu Klik",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Pilih Karakter Lain",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Gunakan Tanda Minus untuk Mengecil",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Buat Karakter Membesar dan Mengecil",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Pilih Karakter Lain",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Melompat-Lompat",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klik Karakter untuk Mengubah Adegan",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Meluncur Keliling",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Mengganti Kostum",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Pilih Lebih Banyak Karakter untuk Kartunmu",
    "gui.howtos.cartoon-network": "Animasikan Sebuah Permainan Petualangan",
    "gui.howtos.cartoon-network.step_CNcharacter": "Pilih Sebuah Karakter Untuk Ditampilkan",
    "gui.howtos.cartoon-network.step_CNsay": "Katakan Sesuatu",
    "gui.howtos.cartoon-network.step_CNglide": "Meluncur Keliling",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Pilih Sebuah Obyek Untuk Dikejar",
    "gui.howtos.cartoon-network.step_CNcollect": "Kumpulkan Obyek-Obyek",
    "gui.howtos.cartoon-network.step_CNvariable": "Buat Sebuah Variabel Skor",
    "gui.howtos.cartoon-network.step_CNscore": "Simpan Nilai",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Naik Level: Ubah Latar",
    "gui.howtos.videosens.name": "Sensor Video",
    "gui.howtos.videosens.step_addextension": "Tambah Ekstensi",
    "gui.howtos.videosens.step_pet": "Elus si Kucing",
    "gui.howtos.videosens.step_animate": "Animasikan",
    "gui.howtos.videosens.step_pop": "Letuskan Sebuah Balon",
    "gui.howtos.say-it-out-loud": "Buat Animasi yang Berbicara",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Tambahkan balok-balok Teks ke Ucapan",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Katakan Sesuatu",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Atur Sebuah Suara",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Bergerak",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Tambahkan sebuah Latar",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Tambahkan Karakter Lain",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Tampilkan Sebuah Lagu",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Ubah Warna",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Berputar",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Membesar dan Mengecil",
    "gui.howtos.talking": "Cerita Berbicara",
    "gui.howtos.talking.step_talesAddExtension": "Klik untuk Menambahkan Balok Teks-ke-Ucapan",
    "gui.howtos.talking.step_talesChooseSprite": "Pilih Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Buat Karakter Berbicara",
    "gui.howtos.talking.step_talesChooseBackdrop": "Pilih Latar",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klik Seorang Karakter untuk Pergi ke Latar Berikutnya",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Pilih Sprite Lain",
    "gui.howtos.talking.step_talesMoveAround": "Bergerak",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Pilih Latar Lain",
    "gui.howtos.talking.step_talesAnimateTalking": "Animasikan Pembicaraan",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Pilih Latar Lain",
    "gui.howtos.talking.step_talesChooseSound": "Pilih Lagu Teman Menari",
    "gui.howtos.talking.step_talesDanceMoves": "Gerakan Tarian",
    "gui.howtos.talking.step_talesAskAnswer": "Dapatkan Balok Tanya dan Jawab dari Kelompok Sensor",
    "gui.howtos.add-sprite.name": "Tambahkan sebuah Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Tambahkan sebuah Sprite",
    "gui.howtos.add-a-backdrop.name": "Tambahkan sebuah Latar",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Tambahkan Sebuah Latar",
    "gui.howtos.change-size.name": "Ubah Ukuran",
    "gui.howtos.change-size.step_changeSize": "Ubah Ukuran",
    "gui.howtos.glide-around.name": "Meluncur Keliling",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Meluncur Keliling",
    "gui.howtos.change-size.step_glideAroundPoint": "Meluncur ke Sebuah Titik",
    "gui.howtos.record-a-sound.name": "Rekam Sebuah Suara",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klik Tab 'Suara'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klik 'Rekam'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Tekan Tombol Rekam",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Pilih Suaramu",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Mainkan Suaramu",
    "gui.howtos.spin-video.name": "Buat Mereka Berputar",
    "gui.howtos.change-size.step_spinTurn": "Berputar",
    "gui.howtos.change-size.step_spinPointInDirection": "Atur Arah",
    "gui.howtos.hide-and-show.name": "Sembunyikan dan Munculkan",
    "gui.howtos.change-size.step_hideAndShow": "Sembunyikan dan Munculkan",
    "gui.howtos.switch-costume.name": "Animasikan Sebuah Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animasikan Sebuah Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Gunakan Tombol Panah",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Bergerak Kiri dan Kanan",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bergerak Naik dan Turun",
    "gui.howtos.add-effects.name": "Tambahkan Efek",
    "gui.howtos.videosens.step_addEffects": "Tambahkan Efek",
    "gui.extension.music.name": "Musik",
    "gui.extension.music.description": "Mainkan instrumen dan drum.",
    "gui.extension.pen.name": "Pena",
    "gui.extension.pen.description": "Menggambar dengan sprite-spritemu.",
    "gui.extension.videosensing.name": "Sensor Video",
    "gui.extension.videosensing.description": "Mendeteksi gerakan dengan kamera.",
    "gui.extension.text2speech.name": "Teks ke Ucapan.",
    "gui.extension.text2speech.description": "Buat karya-karyamu berbicara.",
    "gui.extension.translate.name": "Terjemahkan",
    "gui.extension.translate.description": "Terjemahkan teks menjadi berbagai bahasa.",
    "gui.extension.makeymakey.description": "Buat apapun menjadi sebuah tombol.",
    "gui.extension.microbit.description": "Hubungkan karya-karyamu ke dunia.",
    "gui.extension.microbit.connectingMessage": "Menyambung",
    "gui.extension.ev3.description": "Buat robot-robot interaktif dan lebih banyak lagi.",
    "gui.extension.ev3.connectingMessage": "Menyambung. Pastikan pin di EV3 kamu diatur ke 1234.",
    "gui.extension.boost.description": "Hidupkan kreasi-kreasi robotik.",
    "gui.extension.boost.connectingMessage": "Menghubungkan",
    "gui.extension.wedo2.description": "Berkreasi dengan motor dan sensor.",
    "gui.extension.wedo2.connectingMessage": "Menyambung",
    "gui.extension.gdxfor.description": "Mendeteksi dorongan, tarikan, gerakan, dan putaran.",
    "gui.extension.gdxfor.connectingMessage": "Menghubungkan",
    "gui.libraryTags.all": "Semua",
    "gui.libraryTags.animals": "Hewan",
    "gui.libraryTags.dance": "Menari",
    "gui.libraryTags.effects": "Efek",
    "gui.libraryTags.fantasy": "Fantasi",
    "gui.libraryTags.fashion": "Fesyen",
    "gui.libraryTags.food": "Makanan",
    "gui.libraryTags.indoors": "Dalam ruangan",
    "gui.libraryTags.loops": "Perulangan",
    "gui.libraryTags.music": "Musik",
    "gui.libraryTags.notes": "Catatan",
    "gui.libraryTags.outdoors": "Luar Ruangan",
    "gui.libraryTags.patterns": "Pola",
    "gui.libraryTags.people": "Orang",
    "gui.libraryTags.percussion": "Perkusi",
    "gui.libraryTags.space": "Luar angkasa",
    "gui.libraryTags.sports": "Olahraga",
    "gui.libraryTags.underwater": "Di bawah laut",
    "gui.libraryTags.voice": "Suara",
    "gui.libraryTags.wacky": "Aneh",
    "gui.libraryTags.animation": "Animasi",
    "gui.libraryTags.art": "Kesenian",
    "gui.libraryTags.games": "Permainan",
    "gui.libraryTags.stories": "Cerita",
    "gui.libraryTags.letters": "Huruf",
    "gui.opcodeLabels.direction": "arah",
    "gui.opcodeLabels.xposition": "posisi x",
    "gui.opcodeLabels.yposition": "posisi y",
    "gui.opcodeLabels.size": "ukuran",
    "gui.opcodeLabels.costumename": "nama kostum",
    "gui.opcodeLabels.costumenumber": "nomor kostum",
    "gui.opcodeLabels.backdropname": "nama latar",
    "gui.opcodeLabels.backdropnumber": "nomor latar",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "jawaban",
    "gui.opcodeLabels.loudness": "kenyaringan",
    "gui.opcodeLabels.username": "nama pengguna",
    "gui.opcodeLabels.year": "tahun",
    "gui.opcodeLabels.month": "bulan",
    "gui.opcodeLabels.date": "tanggal",
    "gui.opcodeLabels.dayofweek": "nama hari",
    "gui.opcodeLabels.hour": "jam",
    "gui.opcodeLabels.minute": "menit",
    "gui.opcodeLabels.second": "detik",
    "gui.opcodeLabels.timer": "pengatur waktu",
    "gui.projectLoader.loadError": "Berkas karya yang dipilih gagal dimuat.",
    "gui.sharedMessages.backdrop": "latar {index}",
    "gui.sharedMessages.costume": "kostum {index}",
    "gui.sharedMessages.sprite": "Sprite {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Ganti isi dari karya sekarang?",
    "gui.sharedMessages.loadFromComputerTitle": "Muat dari komputermu",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Karya Scratch",
    "boost.color.any": "warna apapun",
    "boost.color.black": "hitam",
    "boost.color.blue": "biru",
    "boost.color.green": "hijau",
    "boost.color.red": "merah",
    "boost.color.white": "putih",
    "boost.color.yellow": "kuning",
    "boost.getMotorPosition": "posisi motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "sudut kemiringan [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ke arah sana",
    "boost.motorDirection.forward": "ke arah sini",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "matikan motor [MOTOR_ID]",
    "boost.motorOn": "nyalakan motor [MOTOR_ID]",
    "boost.motorOnFor": "nyalakan motor [MOTOR_ID] selama [DURATION] detik",
    "boost.motorOnForRotation": "nyalakan motor [MOTOR_ID] selama [ROTATION] rotasi",
    "boost.seeingColor": "melihat bata [COLOR]?",
    "boost.setLightHue": "atur warna lampu ke [HUE]",
    "boost.setMotorDirection": "atur arah motor [MOTOR_ID] [MOTOR_DIRECTION]",
    "boost.setMotorPower": "atur kecepatan motor [MOTOR_ID] ke [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "bawah",
    "boost.tiltDirection.left": "kiri",
    "boost.tiltDirection.right": "kanan",
    "boost.tiltDirection.up": "atas",
    "boost.whenColor": "ketika bata [COLOR] dilihat",
    "boost.whenTilted": "ketika dimiringkan [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "bunyikan nada [NOTE] selama [TIME] detik",
    "ev3.buttonPressed": "tombol [PORT] ditekan?",
    "ev3.getBrightness": "kecerahan",
    "ev3.getDistance": "jarak",
    "ev3.getMotorPosition": "posisi motor [PORT]",
    "ev3.motorSetPower": "motor [PORT] atur kekuatan [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] belok ke arah ini selama [TIME] detik",
    "ev3.motorTurnCounterClockwise": "motor [PORT] belok ke arah itu selama [TIME] detik",
    "ev3.whenBrightnessLessThan": "ketika kecerahan < [DISTANCE]",
    "ev3.whenButtonPressed": "ketika tombol [PORT] ditekan",
    "ev3.whenDistanceLessThan": "ketika jarak < [DISTANCE]",
    "gdxfor.getAcceleration": "akselerasi [DIRECTION]",
    "gdxfor.getForce": "gaya",
    "gdxfor.getSpin": "kecepatan berputar [DIRECTION]",
    "gdxfor.getTilt": "sudut kemiringan [TILT]",
    "gdxfor.isFreeFalling": "sedang jatuh bebas?",
    "gdxfor.isTilted": "dimiringkan [TILT]?",
    "gdxfor.pulled": "ditarik",
    "gdxfor.pushed": "didorong",
    "gdxfor.shaken": "digoyang",
    "gdxfor.startedFalling": "mulai jatuh bebas",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "belakang",
    "gdxfor.tiltDirectionMenu.front": "depan",
    "gdxfor.tiltDirectionMenu.left": "kiri",
    "gdxfor.tiltDirectionMenu.right": "kanan",
    "gdxfor.turnedFaceDown": "tengkurap",
    "gdxfor.turnedFaceUp": "telentang",
    "gdxfor.whenForcePushedOrPulled": "ketika sensor gaya [PUSH_PULL]",
    "gdxfor.whenGesture": "ketika [GESTURE]",
    "gdxfor.whenTilted": "ketika dimiringkan [TILT]",
    "makeymakey.downArrow": "panah bawah",
    "makeymakey.downArrowShort": "bawah",
    "makeymakey.leftArrow": "panah kiri",
    "makeymakey.leftArrowShort": "kiri",
    "makeymakey.rightArrow": "panah kanan",
    "makeymakey.rightArrowShort": "kanan",
    "makeymakey.spaceKey": "spasi",
    "makeymakey.upArrow": "panah atas",
    "makeymakey.upArrowShort": "atas",
    "makeymakey.whenKeyPressed": "ketika tombol [KEY] ditekan",
    "makeymakey.whenKeysPressedInOrder": "ketika [SEQUENCE] ditekan dalam urutan tersebut",
    "microbit.buttonsMenu.any": "manapun",
    "microbit.clearDisplay": "bersihkan tampilan",
    "microbit.defaultTextToDisplay": "Halo!",
    "microbit.displaySymbol": "tampilkan [MATRIX]",
    "microbit.displayText": "tampilkan teks [TEXT]",
    "microbit.gesturesMenu.jumped": "melompat",
    "microbit.gesturesMenu.moved": "bergerak",
    "microbit.gesturesMenu.shaken": "tergoyang",
    "microbit.isButtonPressed": "tombol [BTN] ditekan?",
    "microbit.isTilted": "miring [DIRECTION]?",
    "microbit.pinStateMenu.off": "mati",
    "microbit.pinStateMenu.on": "hidup",
    "microbit.tiltAngle": "sudut miring [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "manapun",
    "microbit.tiltDirectionMenu.back": "belakang",
    "microbit.tiltDirectionMenu.front": "depan",
    "microbit.tiltDirectionMenu.left": "kiri",
    "microbit.tiltDirectionMenu.right": "kanan",
    "microbit.whenButtonPressed": "ketika tombol [BTN] ditekan",
    "microbit.whenGesture": "ketika [GESTURE]",
    "microbit.whenPinConnected": "ketika pin [PIN] disambung",
    "microbit.whenTilted": "ketika dimiringkan [DIRECTION]",
    "music.categoryName": "Musik",
    "music.changeTempo": "ubah tempo sebesar [TEMPO]",
    "music.drumBass": "(2) Drum Bass",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Hi-Hat Tertutup",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Lonceng Sapi",
    "music.drumCrashCymbal": "(4) Simbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Tepukan Tangan",
    "music.drumOpenHiHat": "(5) Hi-Hat Terbuka",
    "music.drumSideStick": "(3) Tongkat Samping",
    "music.drumSnare": "(1) Drum Senar",
    "music.drumTambourine": "(7) Tamborin",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Balok Kayu",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Paduan Suara",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Gitar Listrik",
    "music.instrumentElectricPiano": "(2) Piano Listrik",
    "music.instrumentFlute": "(12) Seruling",
    "music.instrumentGuitar": "(4) Gitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Kotak Musik",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Drum Baja",
    "music.instrumentSynthLead": "(20) Sintesis Pimpinan",
    "music.instrumentSynthPad": "(21) Pad Sintesis",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Seruling Kayu",
    "music.midiPlayDrumForBeats": "mainkan drum [DRUM] selama [BEATS] ketukan",
    "music.midiSetInstrument": "atur instrumen ke [INSTRUMENT]",
    "music.playDrumForBeats": "mainkan drum [DRUM] selama [BEATS] ketukan",
    "music.playNoteForBeats": "mainkan nada [NOTE] selama [BEATS] ketukan",
    "music.restForBeats": "diam selama [BEATS] ketukan",
    "music.setInstrument": "atur instrumen ke [INSTRUMENT]",
    "music.setTempo": "atur tempo ke [TEMPO]",
    "pen.categoryName": "Pena",
    "pen.changeColorParam": "ubah [COLOR_PARAM] pena sebesar [VALUE]",
    "pen.changeHue": "ubah warna pena sebesar [HUE]",
    "pen.changeShade": "ubah kegelapan pena sebesar [SHADE]",
    "pen.changeSize": "ubah ukuran pena sebesar [SIZE]",
    "pen.clear": "hapus semua",
    "pen.colorMenu.brightness": "kecerahan",
    "pen.colorMenu.color": "warna",
    "pen.colorMenu.saturation": "saturasi",
    "pen.colorMenu.transparency": "transparansi",
    "pen.penDown": "tekan pena",
    "pen.penUp": "angkat pena",
    "pen.setColor": "atur warna pena ke [COLOR]",
    "pen.setColorParam": "atur [COLOR_PARAM] pena ke [VALUE]",
    "pen.setHue": "atur warna pena ke [HUE]",
    "pen.setShade": "atur kegelapan pena sebesar [SHADE]",
    "pen.setSize": "atur ukuran pena ke [SIZE]",
    "pen.stamp": "cap",
    "speech.defaultWhenIHearValue": "ayo pergi",
    "speech.extensionName": "Ucapan ke Teks",
    "speech.listenAndWait": "dengarkan dan tunggu",
    "speech.speechReporter": "ucapan",
    "speech.whenIHear": "ketika aku mendengar [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Teks ke Ucapan.",
    "text2speech.defaultTextToSpeak": "halo",
    "text2speech.giant": "raksasa",
    "text2speech.kitten": "anak kucing",
    "text2speech.setLanguageBlock": "atur bahasa ke [LANGUAGE]",
    "text2speech.setVoiceBlock": "atur suara ke [VOICE]",
    "text2speech.speakAndWaitBlock": "ujarkan [WORDS]",
    "text2speech.squeak": "mencicit",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Terjemahkan",
    "translate.defaultTextToTranslate": "halo",
    "translate.translateBlock": "terjemahkan [WORDS] ke [LANGUAGE]",
    "translate.viewerLanguage": "bahasa",
    "videoSensing.categoryName": "Sensor Video",
    "videoSensing.direction": "arah",
    "videoSensing.motion": "gerakan",
    "videoSensing.off": "mati",
    "videoSensing.on": "hidup",
    "videoSensing.onFlipped": "nyala dibalik",
    "videoSensing.setVideoTransparency": "atur transparansi video ke [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "panggung",
    "videoSensing.videoOn": "video [ATTRIBUTE] di [SUBJECT]",
    "videoSensing.videoToggle": "nyalakan video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "ketika gerakan video > [REFERENCE]",
    "wedo2.getDistance": "jarak",
    "wedo2.getTiltAngle": "sudut kemiringan [TILT_DIRECTION]",
    "wedo2.isTilted": "dimiringkan [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ke arah sana",
    "wedo2.motorDirection.forward": "ke arah sini",
    "wedo2.motorDirection.reverse": "balikkan arah",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "semua motor",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "matikan [MOTOR_ID]",
    "wedo2.motorOn": "nyalakan [MOTOR_ID]",
    "wedo2.motorOnFor": "nyalakan [MOTOR_ID] selama [DURATION] detik",
    "wedo2.playNoteFor": "mainkan nada [NOTE] selama [DURATION] detik",
    "wedo2.setLightHue": "atur warna lampu ke [HUE]",
    "wedo2.setMotorDirection": "atur arah [MOTOR_ID] ke [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "atur kekuatan [MOTOR_ID] ke [POWER]",
    "wedo2.tiltDirection.any": "manapun",
    "wedo2.tiltDirection.down": "bawah",
    "wedo2.tiltDirection.left": "kiri",
    "wedo2.tiltDirection.right": "kanan",
    "wedo2.tiltDirection.up": "atas",
    "wedo2.whenDistance": "ketika jarak [OP] [REFERENCE]",
    "wedo2.whenTilted": "ketika dimiringkan [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Warna",
    "paint.paintEditor.saturation": "Saturasi",
    "paint.paintEditor.brightness": "Keterangan",
    "paint.paintEditor.costume": "Kostum",
    "paint.paintEditor.group": "Kelompokkan",
    "paint.paintEditor.ungroup": "Pisahkan",
    "paint.paintEditor.undo": "Undo",
    "paint.paintEditor.redo": "Ulangi",
    "paint.paintEditor.forward": "Maju",
    "paint.paintEditor.backward": "Mundur",
    "paint.paintEditor.front": "Depan",
    "paint.paintEditor.back": "Back",
    "paint.paintEditor.more": "Lebih",
    "paint.modeTools.brushSize": "Ukuran",
    "paint.modeTools.eraserSize": "Ukuran penghapus",
    "paint.modeTools.copy": "Salin",
    "paint.modeTools.paste": "Tempel",
    "paint.modeTools.delete": "Hapus",
    "paint.modeTools.curved": "Bundar",
    "paint.modeTools.pointed": "Tajam",
    "paint.modeTools.thickness": "Ketebalan",
    "paint.modeTools.flipHorizontal": "Balikkan Secara Horisontal",
    "paint.modeTools.flipVertical": "Balikkan Secara Vertikal",
    "paint.modeTools.filled": "Terisi",
    "paint.modeTools.outlined": "Garis besar",
    "paint.paintEditor.bitmap": "Sesuaikan ke Bitmap",
    "paint.paintEditor.vector": "Sesuaikan ke Vektor",
    "paint.paintEditor.fill": "Isi",
    "paint.paintEditor.stroke": "Garis besar",
    "paint.brushMode.brush": "Kuas",
    "paint.eraserMode.eraser": "Penghapus",
    "paint.fillMode.fill": "Isi",
    "paint.lineMode.line": "Garis",
    "paint.ovalMode.oval": "Lingkaran",
    "paint.rectMode.rect": "Persegi panjang",
    "paint.reshapeMode.reshape": "Bentuk ulang",
    "paint.roundedRectMode.roundedRect": "Persegi Bulat",
    "paint.selectMode.select": "Pilih",
    "paint.textMode.text": "Teks",
    "paint.colorPicker.swap": "Tukar"
  },
  "bn": {
    "gui.alerts.lostPeripheralConnection": "{extensionName} এর সাথে Scratch সংযোগ হারিয়েছে",
    "gui.alerts.tryAgain": "আবার চেষ্টা কর",
    "gui.alerts.download": "ডাউনলোড",
    "gui.connection.reconnect": "পুনঃসংযোগ",
    "gui.backpack.costumeLabel": "পোশাক",
    "gui.backpack.soundLabel": "শব্দ",
    "gui.backpack.scriptLabel": "স্ক্রিপ্ট",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "ব্যাকপ্যাক",
    "gui.backpack.errorBackpack": "ব্যাকপ্যাক লোড করার সময় ত্রুটি",
    "gui.backpack.loadingBackpack": "লোড হচ্ছে...",
    "gui.backpack.more": "আরও",
    "gui.backpack.emptyBackpack": "ব্যাকপ্যাক খালি",
    "gui.unsupportedBrowser.label": "ব্রাউজার সমর্থিত নয়",
    "gui.unsupportedBrowser.errorLabel": "একটি ইরর হয়েছে",
    "gui.unsupportedBrowser.notRecommended": "আমরা খুবই দুঃখিত, কিন্তু মনে হচ্ছে তুমি কোন একটি ব্রাউজারের এমন সংস্করণ ব্যবহার করছ যা Scratch সমর্থন করে না। আমরা কোন সমর্থিত ব্রাউজার যেমন Google Chrome, Mozilla Firefox, Microsoft Edge অথবা Apple Safari এর সর্বশেষ সংস্করণে আপডেট করার পরামর্শ দিচ্ছি। ",
    "gui.unsupportedBrowser.description": "আমরা খুবই দুঃখিত, কিন্তু Scratch এই ব্রাউজার সমর্থন করে না। আমরা কোন সমর্থিত ব্রাউজার যেমন Google Chrome, Mozilla Firefox, Microsoft Edge, অথবা Apple Safari এর সর্বশেষ সংস্করণে আপডেট করার পরামর্শ দিচ্ছি।",
    "gui.unsupportedBrowser.back": "পিছনে",
    "gui.unsupportedBrowser.previewfaq": "আরও জানতে, {previewFaqLink} এ যাও।",
    "gui.unsupportedBrowser.previewfaqlinktext": "বজিপ্র",
    "gui.cards.all-tutorials": "টিউটোরিয়াল",
    "gui.cards.shrink": "সংকোচন",
    "gui.cards.expand": "বৃদ্ধি",
    "gui.cards.close": "বন্ধ কর",
    "gui.cards.more-things-to-try": "আরো জিনিস চেষ্টা কর!",
    "gui.cards.see-more": "আরও দেখ",
    "gui.comingSoon.message1": "চিন্তা কর না, আমরা এটা করছি{emoji}",
    "gui.comingSoon.message2": "শীঘ্রই আসছে...",
    "gui.comingSoon.message3": "আমরা এটা নিয়ে কাজ করছি {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "কোন ডিভাইস খুঁজে পাওয়া যায়নি",
    "gui.connection.auto-scanning.prescan": "তোমার ডিভাইসটি কি কাছাকাছি, তাহলে খোঁজা শুরু কর।",
    "gui.connection.auto-scanning.pressbutton": "তোমার ডিভাইসের বাটনটিতে চাপ দাও।",
    "gui.connection.auto-scanning.start-search": "খোঁজা শুরু কর",
    "gui.connection.connecting-searchbutton": "খোঁজা হচ্ছে...",
    "gui.connection.auto-scanning.try-again": "আবার চেষ্টা কর",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "সংযুক্ত",
    "gui.connection.disconnect": "সংযোগ বিচ্ছিন্ন কর",
    "gui.connection.go-to-editor": "এডিটরে যাও",
    "gui.connection.connecting-cancelbutton": "সংযুক্ত হচ্ছে... ",
    "gui.connection.error.errorMessage": "উফ, মনে হচ্ছে কিছু ভুল হয়েছে।",
    "gui.connection.error.tryagainbutton": "আবার চেষ্টা কর ",
    "gui.connection.error.helpbutton": "সাহায্য",
    "gui.connection.peripheral-name-label": "ডিভাইসের নাম",
    "gui.connection.connect": "সংযুক্ত",
    "gui.connection.scanning.lookingforperipherals": "ডিভাইস খুঁজা হচ্ছে",
    "gui.connection.scanning.noPeripheralsFound": "কোন ডিভাইস খুঁজে পাওয়া যায়নি",
    "gui.connection.scanning.instructions": "উপরের তালিকা থেকে তোমার ডিভাইস নির্বাচন কর।",
    "gui.connection.search": "রিফ্রেশ",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "নিশ্চিত কর তোমার Scratch লিংকটি ইন্সটল করা এবং চলমান আছে",
    "gui.connection.unavailable.enablebluetooth": "ব্লুটুথ চালু আছে কিনা যাচাই কর",
    "gui.connection.unavailable.tryagainbutton": "আবার চেষ্টা কর ",
    "gui.connection.unavailable.helpbutton": "সাহায্য",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "ফিরে যাও",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "আবার চেষ্টা কর",
    "gui.controls.go": "যাও ",
    "gui.controls.stop": "থামাও ",
    "gui.crashMessage.label": "উফ! কিছু একটা সমস্যা হয়েছে।",
    "gui.crashMessage.description": "আমরা আন্তরিকভাবে দুঃখিত, কিন্তু মনে হচ্ছে Scratch ক্র্যাস করেছে। এই বাগ সম্পর্কে ইতিমধ্যেই Scratch টিমকে রিপোর্ট করা হয়েছে। অনুগ্রহ করে তোমার পেইজ রিফ্রেশ করে আবার চেষ্টা কর।",
    "gui.crashMessage.errorNumber": "তোমার ইররটি {errorId} আইডি থেকে লগ করা",
    "gui.crashMessage.reload": "রিলোড",
    "gui.customProcedures.myblockModalTitle": "একটি ব্লক তৈরি কর",
    "gui.customProcedures.addAnInputNumberText": "একটি ইনপুট যোগ কর",
    "gui.customProcedures.numberTextType": "সংখ্যা অথবা টেক্সট",
    "gui.customProcedures.addAnInputBoolean": "একটি ইনপুট যোগ কর ",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "একটি লেবেল যোগ কর",
    "gui.customProcedures.runWithoutScreenRefresh": " স্ক্রিন রিফ্রেশ না করে চালাও",
    "gui.customProcedures.cancel": "বাতিল কর",
    "gui.customProcedures.ok": "ঠিক আছে",
    "gui.SpriteInfo.direction": "দিক",
    "gui.directionPicker.rotationStyles.allAround": "চারপাশে ",
    "gui.directionPicker.rotationStyles.leftRight": "বাম/ডান",
    "gui.directionPicker.rotationStyles.dontRotate": "ঘুরাইয়ো না",
    "gui.gui.addExtension": "এক্সটেনশন যোগ কর",
    "gui.gui.codeTab": "কোড ",
    "gui.gui.backdropsTab": "ব্যাকড্রপগুলো ",
    "gui.gui.costumesTab": "পোশাক ",
    "gui.gui.soundsTab": "শব্দগুলো",
    "gui.extensionLibrary.comingSoon": "শীঘ্রই আসছে",
    "gui.extensionLibrary.requires": "প্রয়োজনীয়",
    "gui.extensionLibrary.collaboration": "এর সাথে সহযোগিতা",
    "gui.library.filterPlaceholder": "অনুসন্ধান",
    "gui.library.allTag": "সব",
    "gui.loader.message1": "ব্লকসমূহ তৈরি হচ্ছে ...",
    "gui.loader.message2": "স্প্রাইটগুলো লোড হচ্ছে …",
    "gui.loader.message3": "শব্দ লোড হচ্ছে ...",
    "gui.loader.message4": "এক্সটেনশন লোড হচ্ছে ...",
    "gui.loader.message5": "পোষা বিড়াল ...",
    "gui.loader.message6": "Transmitting nanos …",
    "gui.loader.message7": "Inflating gobos …",
    "gui.loader.message8": "ইমোজিগুলো তৈরি করা হচ্ছে ...",
    "gui.loader.headline": "প্রজেক্ট লোড হচ্ছে",
    "gui.loader.creating": "প্রজেক্ট তৈরি হচ্ছে",
    "gui.accountMenu.profile": "প্রোফাইল",
    "gui.accountMenu.myStuff": "আমার প্রজেক্ট",
    "gui.accountMenu.myClasses": "আমার ক্লাসগুলো",
    "gui.accountMenu.myClass": "আমার শ্রেণি",
    "gui.accountMenu.accountSettings": "এ্যাকাউন্ট সেটিংস",
    "gui.accountMenu.signOut": "সাইন আউট ",
    "gui.authorInfo.byUser": "{username} দ্বারা",
    "gui.menuBar.seeProjectPage": "প্রজেক্ট পেইজ দেখ",
    "gui.menuBar.language": "ভাষা",
    "general.username": "ইউজারনেম",
    "general.password": "পাসওয়ার্ড",
    "general.signIn": "সাইন ইন",
    "login.needHelp": "সাহায্য প্রয়োজন? ",
    "form.validationRequired": "ঘরটি অবশ্যই পূরণ করতে হবে",
    "gui.menuBar.tutorialsLibrary": "টিউটোরিয়াল",
    "gui.menuBar.restoreSprite": "স্প্রাইট পুনরুদ্ধার কর",
    "gui.menuBar.restoreSound": "শব্দ পুনরুদ্ধার কর",
    "gui.menuBar.restoreCostume": "পোশাক পুনরুদ্ধার কর",
    "gui.menuBar.restore": "পুনরুদ্ধার",
    "gui.menuBar.saveNow": "এখনই সংরক্ষন কর",
    "gui.menuBar.saveAsCopy": "একটি কপি হিসেবে সংরক্ষন কর",
    "gui.menuBar.remix": "রিমিক্স",
    "gui.menuBar.new": "নতুন",
    "gui.menuBar.file": "ফাইল",
    "gui.menuBar.downloadToComputer": "তোমার কম্পিউটারে সংরক্ষন কর",
    "gui.menuBar.edit": "সম্পাদনা",
    "gui.menuBar.turboModeOff": "টার্বো মোড বন্ধ কর",
    "gui.menuBar.turboModeOn": "টার্বো মোড চালু কর ",
    "gui.menuBar.modeMenu": "মোড",
    "gui.menuBar.normalMode": "সাধারন মোড",
    "gui.menuBar.caturdayMode": "ক্যাটারডে মোড",
    "gui.menuBar.joinScratch": "Scratch এ যুক্ত হও",
    "gui.menuBar.signIn": "সাইন ইন",
    "gui.gui.projectTitlePlaceholder": "প্রজেক্ট এর নাম এখানে",
    "gui.menuBar.saveNowLink": "সংরক্ষন কর",
    "gui.menuBar.settings": "সেটিংস",
    "gui.menuBar.isShared": "শেয়ার করেছিল",
    "gui.menuBar.share": "শেয়ার",
    "gui.menuBar.colorMode": "রঙ মোড",
    "gui.modal.help": "সাহায্য",
    "gui.modal.back": "পিছনে",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "লম্বা {length} ",
    "gui.monitor.contextMenu.default": "সাধারণ রিডআউট",
    "gui.monitor.contextMenu.large": "বড় করে পড় ",
    "gui.monitor.contextMenu.slider": "স্লাইডার",
    "gui.monitor.contextMenu.sliderRange": "স্লাইডার ব্যাপ্তি পরিবর্তন কর",
    "gui.monitor.contextMenu.import": "ইম্পোর্ট",
    "gui.monitor.contextMenu.export": "এক্সপোর্ট",
    "gui.monitor.contextMenu.hide": "লুকাও",
    "gui.playButton.play": "শুরু কর ",
    "gui.playButton.stop": "থামাও ",
    "gui.gui.variableScopeOptionAllSprites": "সব স্প্রাইটের জন্য",
    "gui.gui.variableScopeOptionSpriteOnly": "শুধু এই স্প্রাইটের জন্য",
    "gui.gui.cloudVariableOption": "ক্লাউড ভেরিয়েবল (সার্ভারে সংরক্ষিত হয়েছে)",
    "gui.gui.variablePromptAllSpritesMessage": "এই ভ্যারিয়েবল সব স্প্রাইটের জন্য পাওয়া যাবে।",
    "gui.gui.listPromptAllSpritesMessage": "এই তালিকাটি সব স্প্রাইটের জন্য পাওয়া যাবে।",
    "gui.prompt.cancel": "বাতিল",
    "gui.prompt.ok": "ঠিক আছে",
    "gui.playbackStep.stopMsg": "থামাও",
    "gui.playbackStep.playMsg": "বাজাও",
    "gui.playbackStep.loadingMsg": "লোড হচ্ছে...",
    "gui.playbackStep.saveMsg": "সংরক্ষন",
    "gui.playbackStep.reRecordMsg": "পুনরায় রেকর্ড কর",
    "gui.recordModal.title": "শব্দ রেকর্ড কর",
    "gui.recordingStep.beginRecord": "নিচের বোতাম ক্লিক করে রেকর্ড করা শুরু কর",
    "gui.recordingStep.permission": "{arrow} তোমার মাইক্রোফোনটি ব্যবহার করার জন্য আমাদের তোমার অনুমতি দরকার",
    "gui.recordingStep.stop": "রেকর্ড করা বন্ধ কর",
    "gui.recordingStep.record": "রেকর্ড",
    "gui.sliderModal.min": "সর্বনিন্ম মান ",
    "gui.sliderModal.max": "সর্বোচ্চ মান ",
    "gui.sliderModal.title": "স্লাইডার ব্যাপ্তি পরিবর্তন কর",
    "gui.sliderPrompt.cancel": "বাতিল কর",
    "gui.sliderPrompt.ok": "ঠিক আছে",
    "gui.soundEditor.sound": "শব্দ",
    "gui.soundEditor.play": "বাজাও",
    "gui.soundEditor.stop": "থামাও ",
    "gui.soundEditor.copy": "কপি",
    "gui.soundEditor.paste": "পেস্ট",
    "gui.soundEditor.copyToNew": "নতুন একটি কপি কর",
    "gui.soundEditor.delete": "অপসারণ",
    "gui.soundEditor.save": "সংরক্ষন",
    "gui.soundEditor.undo": "পূর্বাবস্থায় ফেরত",
    "gui.soundEditor.redo": "পুনরায় কর",
    "gui.soundEditor.faster": "দ্রুত গতি",
    "gui.soundEditor.slower": "ধীর গতি",
    "gui.soundEditor.echo": "প্রতিধ্বনি",
    "gui.soundEditor.robot": "রোবট",
    "gui.soundEditor.louder": "উচ্চ স্বর",
    "gui.soundEditor.softer": "কোমল",
    "gui.soundEditor.reverse": "বিপরীত",
    "gui.soundEditor.fadeOut": "উজ্জ্বল",
    "gui.soundEditor.fadeIn": "ফ্যাকাসে",
    "gui.soundEditor.mute": "মিউট",
    "gui.SpriteInfo.spritePlaceholder": "নাম",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "স্প্রাইট",
    "gui.SpriteInfo.show": "দেখাও ",
    "gui.SpriteInfo.size": "আকার",
    "gui.spriteSelectorItem.contextMenuDuplicate": "অনুরূপ",
    "gui.spriteSelectorItem.contextMenuExport": "এক্সপোর্ট",
    "gui.spriteSelectorItem.contextMenuDelete": "অপসারণ",
    "gui.spriteSelector.addSpriteFromLibrary": "একটি স্প্রাইট বাছাই কর",
    "gui.spriteSelector.addSpriteFromPaint": "আঁক ",
    "gui.spriteSelector.addSpriteFromSurprise": "চমক",
    "gui.spriteSelector.addSpriteFromFile": " স্প্রাইট আপলোড কর",
    "gui.stageHeader.stageSizeLarge": "বড় মঞ্চে পরিবর্তন কর",
    "gui.stageHeader.stageSizeSmall": "ছোট মঞ্চে পরিবর্তন কর",
    "gui.stageHeader.stageSizeFull": "ফুলস্ক্রিন মুডে প্রবেশ কর",
    "gui.stageHeader.stageSizeUnFull": "ফুলস্ক্রিন মুড থেকে বাহির হও",
    "gui.stageHeader.fullscreenControl": "ফুলস্ক্রিন নিয়ন্ত্রণ",
    "gui.spriteSelector.addBackdropFromLibrary": "একটি ব্যাকড্রপ বাছাই কর",
    "gui.stageSelector.addBackdropFromPaint": "আঁক",
    "gui.stageSelector.addBackdropFromSurprise": "চমক",
    "gui.stageSelector.addBackdropFromFile": " ব্যাকড্রপ আপলোড কর",
    "gui.stageSelector.stage": "মঞ্চ",
    "gui.stageSelector.backdrops": "ব্যাকড্রপগুলো",
    "gui.telemetryOptIn.label": "Scratch আরও উন্নত করতে পরিসংখ্যানটি রিপোর্ট কর",
    "gui.telemetryOptIn.body1": "Scratch টিম সর্বদা বিশ্বজুড়ে Scratch কিভাবে ব্যবহৃত হয় তা আরও ভালোভাবে জানার চেষ্টা করছে। এই প্রচেষ্টাকে সমর্থন করার জন্য, তুমি Scratch এর ব্যবহারের তথ্য Scratch টিমের কাছে স্বয়ংক্রিয়ভাবে প্রেরণের অনুমতি দিতে পার।",
    "gui.telemetryOptIn.body2": "আমরা যে তথ্য সংগ্রহ করি সেগুলোর মধ্যে ভাষা নির্বাচন, ব্লকসমূহ ব্যবহার এবং কিছু ইভেন্টস যেমন সেভ করা, লোডিং এবং প্রজেক্ট আপলোডিং অন্তর্ভুক্ত। আমরা কোন ব্যক্তিগত তথ্য সংগ্রহ করি না। অনুগ্রহ করে আরও তথ্যের জন্য আমাদের {privacyPolicyLink} দেখ।",
    "gui.telemetryOptIn.privacyPolicyLink": "গোপনীয়তা নীতি",
    "gui.telemetryOptIn.optInText": "Scratch টিমের সাথে আমার ব্যবহৃত ডাটা শেয়ার কর",
    "gui.telemetryOptIn.optInTooltip": " telemetry সচল কর",
    "gui.telemetryOptIn.optOutText": "আমার ব্যবহৃত ডাটা Scratch টিমের সাথে শেয়ার কর না। ",
    "gui.telemetryOptIn.optOutTooltip": "telemetry অচল কর",
    "gui.telemetryOptIn.settingWasUpdated": "তোমার সেটিংস আপডেট করা হয়েছে।",
    "gui.telemetryOptIn.buttonClose": "বন্ধ কর",
    "gui.turboMode.active": "টার্বো মোড",
    "gui.webglModal.label": "তোমার ব্রাউজার WebGL সমর্থন করে না",
    "gui.webglModal.description": "দুর্ভাগ্যক্রমে এটি তোমার ব্রাউজার বা কম্পিউটারের মতো দেখাচ্ছে  {webGlLink}। এই প্রযুক্তিটি Scratch 3.0 চালানোর জন্য প্রয়োজন।",
    "gui.webglModal.webgllink": "WebGL সমর্থন করে না",
    "gui.webglModal.back": "পিছনে",
    "gui.webglModal.previewfaq": "আরও জানতে, {previewFaqLink} এ যাও।",
    "gui.webglModal.previewfaqlinktext": "বজিপ্র",
    "gui.costumeLibrary.chooseABackdrop": "একটি ব্যাকড্রপ বাছাই কর",
    "gui.costumeLibrary.chooseACostume": "একটি পোশাক বাছাই কর",
    "gui.costumeTab.addBackdropFromLibrary": "একটি ব্যাকড্রপ বাছাই কর",
    "gui.costumeTab.addCostumeFromLibrary": "একটি পোশাক বাছাই কর",
    "gui.costumeTab.addBlankCostume": "আঁক",
    "gui.costumeTab.addSurpriseCostume": "চমক",
    "gui.costumeTab.addFileBackdrop": "ব্যাকড্রপ আপলোড কর",
    "gui.costumeTab.addFileCostume": "পোশাক আপলোড কর",
    "gui.extensionLibrary.chooseAnExtension": "এক্সটেনশন বাছাই কর",
    "gui.extensionLibrary.extensionUrl": "এক্সটেনশনের URL প্রবেশ করাও",
    "gui.monitors.importListColumnPrompt": "কোন কলামটি ব্যবহার করা উচিত (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "রেকর্ডিং শুরু করা যাচ্ছে না",
    "gui.soundLibrary.chooseASound": "একটি শব্দ বাছাই কর",
    "gui.soundTab.fileUploadSound": " শব্দ আপলোড কর",
    "gui.soundTab.surpriseSound": "চমক",
    "gui.soundTab.recordSound": "রেকর্ড",
    "gui.soundTab.addSoundFromLibrary": "একটি শব্দ বাছাই কর",
    "gui.spriteLibrary.chooseASprite": "একটি স্প্রাইট বাছাই কর",
    "gui.tipsLibrary.tutorials": "টিউটোরিয়াল বাছাই কর",
    "gui.alerts.createsuccess": "নতুন প্রজেক্ট তৈরি হয়েছে।",
    "gui.alerts.createcopysuccess": "প্রজেক্ট কপি হিসেবে সেভ হয়েছে।",
    "gui.alerts.createremixsuccess": "প্রজেক্ট রিমিক্স হয়ে সেভ হয়েছে",
    "gui.alerts.creating": "নতুন তৈরি হচ্ছে...",
    "gui.alerts.creatingCopy": "প্রজেক্টে কপি হচ্ছে...",
    "gui.alerts.creatingRemix": "প্রজেক্ট রিমিক্সি হচ্ছে...",
    "gui.alerts.creatingError": "প্রজেক্ট তৈরি করা যায় নি। অনুগ্রহ করে আবার চেষ্টা কর!",
    "gui.alerts.savingError": "প্রজেক্ট সংরক্ষিত হচ্ছে না।",
    "gui.alerts.savesuccess": "প্রজেক্ট সংরক্ষিত।",
    "gui.alerts.saving": "প্রজেক্টে সংরক্ষিত হচ্ছে...",
    "gui.alerts.cloudInfo": "নোট, ক্লাউড ভেরিয়েবল কেবলমাত্র সংখ্যাগুলো সমর্থন করে, অক্ষর বা চিহ্ন নয়। {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "আরও জানো।",
    "gui.alerts.importing": "ইম্পোর্ট হচ্ছে…",
    "gui.defaultProject.meow": "মিউ",
    "gui.defaultProject.variable": "আমার ভ্যারিয়েবল",
    "gui.howtos.intro-move-sayhello-hat.name": "শুরু কর",
    "gui.howtos.intro-move.step_stepMove": "একটি ধাপ পরিবর্তন করার ব্লক যোগ কর",
    "gui.howtos.add-a-move-block.step_stepSay": "একটি কথা বলার ব্লক যুক্ত কর",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "শুরু করতে সবুজ পতাকা তে ক্লিক কর",
    "gui.howtos.intro-getting-started-ASL.name": "শুরু কর - ASL",
    "gui.howtos.animate-a-name.name": "একটি নাম অ্যানিমেট কর",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "একটি অক্ষর স্প্রাইট নাও",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "ক্লিক করলে শব্দ কর",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "আরও একটি অক্ষর স্প্রাইট নাও",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "রঙ পরিবর্তন কর",
    "gui.howtos.animate-a-name.step_AnimateSpin": "আরও একটি অক্ষর স্প্রাইট নাও এবং এটিকে ঘুরাও",
    "gui.howtos.animate-a-name.step_AnimateGrow": "আরও একটি অক্ষর স্প্রাইট নাও এবং এটি বড় কর",
    "gui.howtos.imagine": "একটি পৃথিবী কল্পনা কর",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "তুমি যা বলতে চাও তা লিখ",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "শুরু করতে সবুজ পতাকায় ক্লিক কর",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "যেকোন একটি ব্যাকড্রপ বাছাই কর",
    "gui.howtos.imagine.step_imagineChooseSprite": "যেকোন একটি স্প্রাইট বাছাই কর",
    "gui.howtos.imagine.step_imagineFlyAround": "গ্লাইড করার জন্য স্পেস কী চাপ দাও ",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "  অন্য একটি স্প্রাইট বাছাই কর",
    "gui.howtos.imagine.step_imagineLeftRight": "বামে-ডানে সরাও",
    "gui.howtos.imagine.step_imagineUpDown": "উপর-নীচে সরাও",
    "gui.howtos.imagine.step_imagineChangeCostumes": "পোশাক পরিবর্তন কর",
    "gui.howtos.imagine.step_imagineGlideToPoint": "একটা নির্দিষ্ট স্থান পর্যন্ত গ্লাইড কর",
    "gui.howtos.imagine.step_imagineGrowShrink": "বড় এবং ছোট কর",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "অন্য একটি ব্যাকড্রপ বাছাই কর",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "ব্যাকড্রপগুলো পরিবর্তন কর",
    "gui.howtos.imagine.step_imagineRecordASound": "একটি শব্দ যোগ কর",
    "gui.howtos.imagine.step_imagineChooseSound": "তোমার শব্দ বাছাই কর",
    "gui.howtos.make-music.name": "সঙ্গীত তৈরি কর",
    "gui.howtos.Make-Music.step_PickInstrument": "একটি যন্ত্র স্প্রাইট নাও",
    "gui.howtos.Make-Music.step_PlaySoundClick": " শব্দ কর যখন ক্লিক করা হয়",
    "gui.howtos.Make-Music.step_MakeSong": "একটি গান তৈরি কর",
    "gui.howtos.make-music.step_MakeBeat": "একটি ড্রাম বাছাই করে একটি বিট তৈরি কর ",
    "gui.howtos.make-music.step_MakeBeatBox": "মাইক্রোফোন স্প্রাইট বাছাই কর এবং বিটবক্সকে চমকে দাও",
    "gui.howtos.story.name": "গল্প তৈরি কর",
    "gui.howtos.story.step_addbg": "ব্যাকড্রপ যোগ কর",
    "gui.howtos.story.step_addsprite": "একটি ক্যারেক্টার যোগ কর",
    "gui.howtos.story.step_saysomething": "কিছু বল ",
    "gui.howtos.story.step_addanothersprite": "অন্য একটি ক্যারেক্টার যোগ কর",
    "gui.howtos.story.step_flip": "উল্টা দিক",
    "gui.howtos.story.step_conversation": " একটি কথোপকথন কর",
    "gui.howtos.story.addanotherbg": "অন্য একটি ব্যাকড্রপ যোগ কর",
    "gui.howtos.story.step_swithbg": "ব্যাকড্রপগুলো পরিবর্তন কর",
    "gui.howtos.story.step_hidewizard": " একটি ক্যারেক্টার লুকাও",
    "gui.howtos.story.step_showwizard": "একটি ক্যারেক্টার দেখাও",
    "gui.howtos.make-a-chase-game.name": "একটি দাবা খেলা তৈরি কর",
    "gui.howtos.Chase-Game.step_BG": "ব্যাকড্রপ যোগ কর",
    "gui.howtos.chase-game.step_AddOcto": "একটি স্প্রাইট যোগ কর",
    "gui.howtos.make-music.step_LeftRight": " অ্যারো কী গুলো দিয়ে ডানে এবং বামে সরাও",
    "gui.howtos.Chase-Game.step_UpDown": "অ্যারো কী এর সাহায্যে উপরে এবং নিচে সরাও",
    "gui.howtos.Chase-Game.step_AddStar": "  অন্য একটি স্প্রাইট যোগ কর",
    "gui.howtos.Chase-Game.step_MoveRandom": "এলোমেলো ভাবে সরাও",
    "gui.howtos.Chase-Game.step_WhenTouch": " অক্টোপাস স্প্রাইটে, যখন স্পর্শ করবে শব্দ কর",
    "gui.howtos.Chase-Game.step_ScoreVariable": "স্কোর ভ্যারিয়েবল তৈরি কর",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "অক্টোপাস স্প্রাইটে, যখন স্পর্শ করবে স্কোর যোগ কর",
    "gui.howtos.animate-char.name": "একটি ক্যারেক্টার অ্যানিমেট কর",
    "gui.howtos.animate-char.step_addbg": "ব্যাকড্রপ যোগ কর",
    "gui.howtos.animate-char.step_addsprite": "একটি স্প্রাইট যোগ কর",
    "gui.howtos.animate-char.step_saysomething": "কিছু বল ",
    "gui.howtos.animate-char.step_addsound": "শব্দ যোগ কর",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "অ্যারো কী গুলো ব্যবহার করে সরাও",
    "gui.howtos.animate-char.step_jump": "লাফ দাও",
    "gui.howtos.animate-char.step_changecolor": "রঙ পরিবর্তন কর",
    "gui.howtos.make-a-game.name": "একটি ক্লিকার গেম তৈরি কর",
    "gui.howtos.Make-A-Game.step_GamePickSprite": " একটি স্প্রাইট নাও",
    "gui.howtos.make-a-game.step_GamePlaySound": "ক্লিক করলে শব্দ কর",
    "gui.howtos.make-a-game.step_GameAddScore": "স্কোর ভ্যারিয়েবল তৈরি কর",
    "gui.howtos.make-a-game.step_GameChangeScore": "ক্লিক করলে স্কোর বাড়াও",
    "gui.howtos.make-a-game.step_Random": "যেকোন জায়গায় যাও",
    "gui.howtos.make-music.step_GameChangeColor": "রঙ পরিবর্তন কর",
    "gui.howtos.make-music.step_ResetScore": "স্কোর রিসেট কর",
    "gui.howtos.make-it-fly.name": "এটাকে উড়াও",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "একটা আকাশের ব্রাকগ্রাউন্ড বাছাই কর",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "একটি ক্যারেক্টার বাছাই কর",
    "gui.howtos.fly.step_stepflySaySomething": "কিছু বল ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "অ্যারো কী গুলোর সাথে সরাও",
    "gui.howtos.fly.step_stepflyChooseObject": "সংগ্রহের জন্য একটি অবজেক্ট বাছাই কর",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "অবজেক্টটি সচল কর",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "তোমার ক্যারেক্টার নির্বাচন কর",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "একটি স্কোর যোগ কর",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "স্কোর সংরক্ষণ",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "দৃশ্যাবলী যোগ কর",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": " দৃশ্যটিকে সরাও ",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "পরবর্তী পোশাক",
    "gui.howtos.pong": "পং খেলা",
    "gui.howtos.pong.step_pongAddBackdrop": "একটি ব্যাকড্রপ যোগ কর",
    "gui.howtos.pong.step_pongAddBallSprite": " একটি বলের স্প্রাইট যোগ কর",
    "gui.howtos.pong.step_pongBounceAround": "চারিদিকে লাফাও ",
    "gui.howtos.pong.step_pongAddPaddle": "একটা প্যাডেল যোগ কর",
    "gui.howtos.pong.step_pongMoveThePaddle": "প্যাডেল টি সরাও",
    "gui.howtos.pong.step_pongSelectBallSprite": "বল স্প্রাইট টি সিলেক্ট কর",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "বলটি প্যাডেল থেকে লাফিয়ে উঠার জন্য কোড যোগ কর",
    "gui.howtos.pong.step_pongAddAScore": "একটি স্কোর যোগ কর",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "মেনু থেকে 'স্কোর' বাছাই কর",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "'স্কোর পরিবর্তন' ব্লকটি প্রবেশ করাও",
    "gui.howtos.pong.step_pongResetScore": "স্কোর রিসেট",
    "gui.howtos.pong.step_pongAddLineSprite": "একটি লাইন স্প্রাইট যোগ কর",
    "gui.howtos.pong.step_pongGameOver": "খেলা শেষ",
    "gui.howtos.code-cartoon": " একটি কার্টুন কোড কর",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "যখন তুমি সবুজ পতাকায় ক্লিক কর তখন কিছু বল",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "একটি ক্যারেক্টার অ্যানিমেট কর যখন তুমি এটিকে ক্লিক কর",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": " একটি ভিন্ন ক্যারেক্টার নির্বাচন কর",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "ছোট করতে মাইনাস চিহ্ন ব্যবহার কর",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "একটি ক্যারেক্টার বড় ও ছোট কর",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": " একটি ভিন্ন ক্যারেক্টার নির্বাচন কর",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "উপরে ও নিচে লাফাও",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": " দৃশ্য পরিবর্তন করতে একটি ক্যারেক্টার ক্লিক কর",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "চতুর্দিকে গ্লাইড কর ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "পোশাক পরিবর্তন কর",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "তোমার কার্টুনে যোগ করতে আরও ক্যারেক্টার বাছাই কর",
    "gui.howtos.cartoon-network": "একটি এডভেঞ্চার গেইম অ্যানিমেট কর",
    "gui.howtos.cartoon-network.step_CNcharacter": "দেখাবার জন্য একটি ক্যারেক্টার বাছাই কর",
    "gui.howtos.cartoon-network.step_CNsay": "কিছু বল ",
    "gui.howtos.cartoon-network.step_CNglide": "চতুর্দিকে গ্লাইড কর ",
    "gui.howtos.cartoon-network.step_CNpicksprite": "তাড়া করার জন্য একটি অবজেক্ট বাছাই কর",
    "gui.howtos.cartoon-network.step_CNcollect": " অবজেক্ট সংগ্রহ কর",
    "gui.howtos.cartoon-network.step_CNvariable": "একটি স্কোর ভ্যারিয়েবল তৈরি কর",
    "gui.howtos.cartoon-network.step_CNscore": " স্কোর রাখো",
    "gui.howtos.cartoon-network.step_CNbackdrop": "লেভেল বাড়াও: ব্যাকড্রপ পরিবর্তন কর",
    "gui.howtos.videosens.name": "ভিডিও অনুমান",
    "gui.howtos.videosens.step_addextension": "এক্সটেনশন যোগ কর",
    "gui.howtos.videosens.step_pet": "বিড়ালটিকে পোষ মানাও",
    "gui.howtos.videosens.step_animate": "অ্যানিমেট",
    "gui.howtos.videosens.step_pop": "একটি বেলুন ফোটাও",
    "gui.howtos.say-it-out-loud": " কথা বলার অ্যানিমেশন তৈরি কর",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "টেক্সট টু স্পিচ ব্লকগুলো যোগ কর",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "কিছু বল",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "একটি ভয়েস নির্ধারণ কর",
    "gui.howtos.say-it-out-loud.step_TXTMove": " চতুর্দিকে ঘুর",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "ব্যাকড্রপ যোগ কর",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "অন্য একটি ক্যারেক্টার যোগ কর",
    "gui.howtos.say-it-out-loud.step_TXTSong": "একটি গান গাও ",
    "gui.howtos.say-it-out-loud.step_TXTColor": "রঙ পরিবর্তন কর",
    "gui.howtos.say-it-out-loud.step_TXTSpin": " চতুর্দিকে ঘুরাও",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "বড় এবং ছোট কর",
    "gui.howtos.talking": "গল্প বলছে",
    "gui.howtos.talking.step_talesAddExtension": "টেক্সট-টু-স্পিচ ব্লকগুলো যোগ করতে ক্লিক কর",
    "gui.howtos.talking.step_talesChooseSprite": "একটি স্প্রাইট বাছাই কর",
    "gui.howtos.talking.step_talesSaySomething": " একটি ক্যারেক্টারকে কথা বলাও",
    "gui.howtos.talking.step_talesChooseBackdrop": "একটি ব্যাকড্রপ বাছাই কর",
    "gui.howtos.talking.step_talesSwitchBackdrop": "পরবর্তী ব্যাকড্রপে যেতে একটি ক্যারেক্টার ক্লিক কর",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "  অন্য একটি স্প্রাইট বাছাই কর",
    "gui.howtos.talking.step_talesMoveAround": "  চতুর্দিকে চল",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "অন্য একটি ব্যাকড্রপ বাছাই কর",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "অন্য একটি ব্যাকড্রপ বাছাই কর",
    "gui.howtos.talking.step_talesChooseSound": " নাচের জন্য একটি গান বাছাই কর",
    "gui.howtos.talking.step_talesDanceMoves": "নাচের মুদ্রা",
    "gui.howtos.talking.step_talesAskAnswer": "অনুভব বিভাগ থেকে প্রশ্ন ও উত্তর ব্লকগুলো পাও ",
    "gui.howtos.add-sprite.name": "একটি স্প্রাইট যোগ কর",
    "gui.howtos.add-sprite.step_addSprite": "একটি স্প্রাইট যোগ কর",
    "gui.howtos.add-a-backdrop.name": "ব্যাকড্রপ যোগ কর",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "একটি ব্যাকড্রপ যোগ কর",
    "gui.howtos.change-size.name": "আকার পরিবর্তন",
    "gui.howtos.change-size.step_changeSize": "আকার পরিবর্তন",
    "gui.howtos.glide-around.name": "চতুর্দিকে গ্লাইড কর ",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "চতুর্দিকে গ্লাইড কর ",
    "gui.howtos.change-size.step_glideAroundPoint": "একটা নির্দিষ্ট স্থান পর্যন্ত গ্লাইড কর",
    "gui.howtos.record-a-sound.name": " শব্দ রেকর্ড কর",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "'শব্দগুলো' ট্যাবে ক্লিক কর",
    "gui.howtos.change-size.step_recordASoundClickRecord": "'রেকর্ড' ক্লিক কর",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "রেকর্ড বাটনে চাপ দাও",
    "gui.howtos.change-size.step_recordASoundChooseSound": "তোমার শব্দ টি বাছাই কর",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "তোমার শব্দ বাজাও",
    "gui.howtos.spin-video.name": "এটাকে ঘুরাও",
    "gui.howtos.change-size.step_spinTurn": "ঘোরাও",
    "gui.howtos.change-size.step_spinPointInDirection": "দিক নির্ধারণ কর",
    "gui.howtos.hide-and-show.name": " লুকাও এবং দেখাও ",
    "gui.howtos.change-size.step_hideAndShow": "লুকাও এবং দেখাও",
    "gui.howtos.switch-costume.name": " একটি স্প্রাইট অ্যানিমেট কর",
    "gui.howtos.change-size.step_switchCostumes": "একটি স্প্রাইট অ্যানিমেট কর",
    "gui.howtos.move-around-with-arrow-keys.name": "অ্যারো কী গুলো ব্যবহার কর",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "বামে ও ডানে সরাও",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "উপরে ও নীচে সরাও",
    "gui.howtos.add-effects.name": "ইফেক্ট যোগ কর",
    "gui.howtos.videosens.step_addEffects": "ইফেক্ট যোগ কর",
    "gui.extension.music.name": "সঙ্গীত",
    "gui.extension.music.description": "ঢোল এবং ইন্সটুমেন্টগুলো বাজাও।",
    "gui.extension.pen.name": "কলম",
    "gui.extension.pen.description": " তোমার স্প্রাইটের সাহায্যে আঁক",
    "gui.extension.videosensing.name": "ভিডিও অনুমান ",
    "gui.extension.videosensing.description": "ক্যামারার সাহায্যে গতি অনুভব কর। ",
    "gui.extension.text2speech.name": "টেক্সট টু স্পিচ",
    "gui.extension.text2speech.description": "তোমার প্রজেক্টটিকে কথা বলাও। ",
    "gui.extension.translate.name": "অনুবাদ",
    "gui.extension.translate.description": " অনেক ভাষায় টেক্সট অনুবাদ কর",
    "gui.extension.makeymakey.description": "যেকোন কিছুকে কী তে পরিণত কর",
    "gui.extension.microbit.description": "  পৃথিবীর সাথে তোমার প্রজেক্ট যুক্ত কর।",
    "gui.extension.microbit.connectingMessage": "সংযুক্ত হচ্ছে",
    "gui.extension.ev3.description": "  ইন্টারেক্টিভ রোবট বানাও এবং অন্যান্য।",
    "gui.extension.ev3.connectingMessage": "সংযুক্ত হচ্ছে। নিশ্চিত কর তোমার EV3 পিনটি 1234 নির্ধারণ করা আছে",
    "gui.extension.boost.description": "রোবোটিক সৃষ্টিগুলোকে প্রাণবন্ত কর।",
    "gui.extension.boost.connectingMessage": "সংযোগ হচ্ছে",
    "gui.extension.wedo2.description": "মোটর এবং সেন্সরের সাহায্যে তৈরি কর।",
    "gui.extension.wedo2.connectingMessage": "সংযুক্ত হচ্ছে",
    "gui.extension.gdxfor.description": "ধাক্কা, টান, গতি ও ঘুর্নণ অনুভব কর। ",
    "gui.extension.gdxfor.connectingMessage": "সংযোগ হচ্ছে",
    "gui.libraryTags.all": "সব",
    "gui.libraryTags.animals": "পশুপাখি",
    "gui.libraryTags.dance": "নাচ",
    "gui.libraryTags.effects": "   ইফেক্ট সমূহ",
    "gui.libraryTags.fantasy": "  কল্পনা",
    "gui.libraryTags.fashion": "ফ্যাশন",
    "gui.libraryTags.food": "খাবার",
    "gui.libraryTags.indoors": "ইনডোর",
    "gui.libraryTags.loops": "লুপ",
    "gui.libraryTags.music": "সঙ্গীত",
    "gui.libraryTags.notes": "নোট",
    "gui.libraryTags.outdoors": "বাড়ির বাইরে",
    "gui.libraryTags.patterns": "প্যাটার্নস",
    "gui.libraryTags.people": "মানুষ",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "খেলাধুলা",
    "gui.libraryTags.underwater": "পানির নিচে",
    "gui.libraryTags.voice": "শব্দ",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "অ্যানিমেশন",
    "gui.libraryTags.art": "আর্ট ",
    "gui.libraryTags.games": "খেলা",
    "gui.libraryTags.stories": "গল্পগুলো",
    "gui.libraryTags.letters": "অক্ষর",
    "gui.opcodeLabels.direction": "দিক",
    "gui.opcodeLabels.xposition": "x এর অবস্থান",
    "gui.opcodeLabels.yposition": "y এর অবস্থান",
    "gui.opcodeLabels.size": "আকার",
    "gui.opcodeLabels.costumename": "পোশাক এর নাম",
    "gui.opcodeLabels.costumenumber": "পোশাক নম্বর",
    "gui.opcodeLabels.backdropname": "ব্যাকড্রপ এর নাম",
    "gui.opcodeLabels.backdropnumber": "ব্যাকড্রপ নম্বর",
    "gui.opcodeLabels.volume": "শব্দের মাত্রা",
    "gui.opcodeLabels.tempo": "তাল",
    "gui.opcodeLabels.answer": "উত্তর",
    "gui.opcodeLabels.loudness": "শব্দের মাত্রা",
    "gui.opcodeLabels.username": "ইউজারনেম",
    "gui.opcodeLabels.year": "বছর",
    "gui.opcodeLabels.month": "মাস",
    "gui.opcodeLabels.date": "তারিখ",
    "gui.opcodeLabels.dayofweek": "সপ্তাহের দিন",
    "gui.opcodeLabels.hour": "ঘন্টা",
    "gui.opcodeLabels.minute": "মিনিট",
    "gui.opcodeLabels.second": "সেকেন্ড",
    "gui.opcodeLabels.timer": "সময়",
    "gui.projectLoader.loadError": "নির্বাচিত প্রজেক্ট ফাইলটি লোড হতে ব্যর্থ হয়েছে।",
    "gui.sharedMessages.backdrop": "ব্যাকড্রপ{index}",
    "gui.sharedMessages.costume": "পোশাক{index}",
    "gui.sharedMessages.sprite": "স্প্রাইট{index} ",
    "gui.sharedMessages.pop": "পপ",
    "gui.sharedMessages.replaceProjectWarning": "বর্তমান প্রজেক্ট এর কনটেন্ট প্রতিস্থাপন করবে? ",
    "gui.sharedMessages.loadFromComputerTitle": " তোমার কম্পিউটার থেকে লোড কর",
    "gui.theme.default": "প্রাথমিক",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "উচ্চ কনট্রাস্ট",
    "gui.gui.defaultProjectTitle": "Scratch প্রকল্প",
    "boost.color.any": "যেকোন রঙে",
    "boost.color.black": "কালো",
    "boost.color.blue": "নীল",
    "boost.color.green": "সবুজ",
    "boost.color.red": "লাল",
    "boost.color.white": "সাদা",
    "boost.color.yellow": "হলুদ",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] মোটরের অবস্থান",
    "boost.getTiltAngle": "টিল্ট কোণ [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ঐ দিকে",
    "boost.motorDirection.forward": "এই দিকে",
    "boost.motorDirection.reverse": "উল্টো দিকে",
    "boost.motorOff": "[MOTOR_ID] মোটরটি বন্ধ কর",
    "boost.motorOn": "[MOTOR_ID] মোটরটি চালু কর",
    "boost.motorOnFor": "[MOTOR_ID] মটরটি [DURATION] সেকেন্ডের জন্যে ঘোরাও",
    "boost.motorOnForRotation": "[MOTOR_ID] মটরটি [ROTATION] বারের জন্যে ঘোরাও ",
    "boost.seeingColor": "[COLOR] রঙের ইট দেখা যাচ্ছে?",
    "boost.setLightHue": "লাইটের রঙ [HUE] কর",
    "boost.setMotorDirection": "[MOTOR_ID] মোটরটি [MOTOR_DIRECTION] দিকে নির্ধারণ কর",
    "boost.setMotorPower": "মোটর [MOTOR_ID] এর গতি [POWER] % নির্ধারণ কর",
    "boost.tiltDirection.any": "যেকোন",
    "boost.tiltDirection.down": "নিচে",
    "boost.tiltDirection.left": "বামে",
    "boost.tiltDirection.right": "ডানে ",
    "boost.tiltDirection.up": "উপরে ",
    "boost.whenColor": "[COLOR] ইট দেখা গেলে",
    "boost.whenTilted": "[TILT_DIRECTION_ANY] কাত হয়ে গেলে",
    "ev3.beepNote": "[TIME] সেকেন্ডের জন্য বীপ নোট [NOTE]",
    "ev3.buttonPressed": "[PORT] বোতামটি চাপ দেয়া?  ",
    "ev3.getBrightness": "উজ্জ্বলতা",
    "ev3.getDistance": "দুরত্ব",
    "ev3.getMotorPosition": "মোটর [PORT] এর স্থান",
    "ev3.motorSetPower": "মোটর [PORT] এ শক্তি নির্ধারণ কর [POWER] %",
    "ev3.motorTurnClockwise": "মোটর [PORT] [TIME] সেকেন্ডের জন্য এই পথে ঘুরিয়ে দাও",
    "ev3.motorTurnCounterClockwise": "মোটর [PORT] [TIME] সেকেন্ডের জন্য সে পথে ঘুরিয়ে দাও",
    "ev3.whenBrightnessLessThan": "যখন উজ্জ্বলতা < [DISTANCE]",
    "ev3.whenButtonPressed": "যখন [PORT] বোতামটি চাপা হবে",
    "ev3.whenDistanceLessThan": "যখন দূরত্ব < [DISTANCE]",
    "gdxfor.getAcceleration": "[DIRECTION] গতিবেগ বৃদ্ধি",
    "gdxfor.getForce": "বল",
    "gdxfor.getSpin": "ঘুর্নণ গতি [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "পরে যাচ্ছে?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "টেনেছে ",
    "gdxfor.pushed": "ধাক্কা দিয়েছে ",
    "gdxfor.shaken": "ঝাঁকান হয়েছে",
    "gdxfor.startedFalling": "পরতে শুরু করেছে",
    "gdxfor.tiltDirectionMenu.any": "যেকোন",
    "gdxfor.tiltDirectionMenu.back": "পিছনে",
    "gdxfor.tiltDirectionMenu.front": "সামনে",
    "gdxfor.tiltDirectionMenu.left": "বামে",
    "gdxfor.tiltDirectionMenu.right": "ডানে ",
    "gdxfor.turnedFaceDown": "নিচের দিকে মুখ কর",
    "gdxfor.turnedFaceUp": " উপরের দিকে মুখ কর",
    "gdxfor.whenForcePushedOrPulled": "যখন ফোর্স সেন্সর [PUSH_PULL]",
    "gdxfor.whenGesture": "যখন [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "নিম্নমুখী অ্যারো",
    "makeymakey.downArrowShort": "নিচে",
    "makeymakey.leftArrow": "বামমুখী তীরচিহ্ন",
    "makeymakey.leftArrowShort": "বাম",
    "makeymakey.rightArrow": "ডানমুখী অ্যারো",
    "makeymakey.rightArrowShort": "ডানে ",
    "makeymakey.spaceKey": "স্পেস",
    "makeymakey.upArrow": "ঊর্ধ্বমুখী অ্যারো",
    "makeymakey.upArrowShort": "উপরে ",
    "makeymakey.whenKeyPressed": "যখন [KEY] কী চাপা হবে ",
    "makeymakey.whenKeysPressedInOrder": "যখন [SEQUENCE] ক্রমে চাপ দেওয়া হবে",
    "microbit.buttonsMenu.any": "যেকোন",
    "microbit.clearDisplay": "পর্দার সব পরিষ্কার কর",
    "microbit.defaultTextToDisplay": "হ্যালো!",
    "microbit.displaySymbol": "[MATRIX] প্রদর্শন",
    "microbit.displayText": "[TEXT] টেক্সট প্রদর্শন কর",
    "microbit.gesturesMenu.jumped": "লাফ দিয়েছিল",
    "microbit.gesturesMenu.moved": "সরানো হয়েছে",
    "microbit.gesturesMenu.shaken": "ঝাঁকাও",
    "microbit.isButtonPressed": "[BTN] বোতামটি চাপা হয়েছে?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "বন্ধ",
    "microbit.pinStateMenu.on": "চালু",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "যেকোনো",
    "microbit.tiltDirectionMenu.back": "পিছনে",
    "microbit.tiltDirectionMenu.front": "সামনে",
    "microbit.tiltDirectionMenu.left": "বাম",
    "microbit.tiltDirectionMenu.right": "ডান ",
    "microbit.whenButtonPressed": "যখন [BTN] বোতামটি চাপ দেওয়া থাকবে",
    "microbit.whenGesture": "যখন [GESTURE]",
    "microbit.whenPinConnected": "যখন [PIN] পিনটি সংযুক্ত করা হবে",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "music.categoryName": "সঙ্গীত",
    "music.changeTempo": "[TEMPO] ব্যবহার করে টেম্পো পরিবর্তন কর",
    "music.drumBass": "(2) বেজ ড্রাম",
    "music.drumBongo": "(13) বংগো",
    "music.drumCabasa": "(15) কাবসা",
    "music.drumClaves": "(9) ক্লেভস ",
    "music.drumClosedHiHat": "(6) হাই-হ্যাট বন্ধ",
    "music.drumConga": "(14) কঙ্গা",
    "music.drumCowbell": "(11) গরুর গলার ঘণ্টা",
    "music.drumCrashCymbal": " (4)  ক্র্যাশ সিম্বল",
    "music.drumCuica": "(18) কুইকা",
    "music.drumGuiro": "(16) গাইরো",
    "music.drumHandClap": "(8) হাত তালি",
    "music.drumOpenHiHat": "(5) হাই-হ্যাট খোল",
    "music.drumSideStick": "(3) সাইড স্টিক",
    "music.drumSnare": "(1) স্নেয়ার ড্রাম",
    "music.drumTambourine": "(7) ট্যামবোরিন",
    "music.drumTriangle": "(12) ত্রিভুজ",
    "music.drumVibraslap": "(17) ভাইরাসল্যাপ",
    "music.drumWoodBlock": "(10) কাঠের ব্লক",
    "music.getTempo": "তাল",
    "music.instrumentBass": "(6) বেজ ",
    "music.instrumentBassoon": "(14) ব্যাসোন",
    "music.instrumentCello": "(8) সেলো",
    "music.instrumentChoir": "(15) গায়কদল",
    "music.instrumentClarinet": "(10) ক্লারিনেট",
    "music.instrumentElectricGuitar": "(5) বৈদ্যুতিক গিটার",
    "music.instrumentElectricPiano": "(2) বৈদ্যুতিক পিয়ানো",
    "music.instrumentFlute": "(12) বাঁশি",
    "music.instrumentGuitar": "(4) গিটার",
    "music.instrumentMarimba": "(19) ম্যারিম্বা",
    "music.instrumentMusicBox": "(17) সঙ্গীত বাক্স",
    "music.instrumentOrgan": "(3) অর্গ্যান",
    "music.instrumentPiano": "(1) পিয়ানো ",
    "music.instrumentPizzicato": "(7) পিজ্জাটো",
    "music.instrumentSaxophone": "(11) স্যাক্সোফোন",
    "music.instrumentSteelDrum": "(18) ইস্পাতের ড্রাম",
    "music.instrumentSynthLead": "(20) সিন্থ লিড",
    "music.instrumentSynthPad": "(21) সিন্থ প্যাড",
    "music.instrumentTrombone": "(9) ট্রমবন",
    "music.instrumentVibraphone": "(16) ভাইব্রাফোন",
    "music.instrumentWoodenFlute": "(13) কাঠের বাঁশি",
    "music.midiPlayDrumForBeats": "[BEATS] বিটের জন্য ড্রাম [DRUM] বাজাও",
    "music.midiSetInstrument": "[INSTRUMENT] বাদ্যযন্ত্রটি নির্ধারণ কর।",
    "music.playDrumForBeats": "[BEATS] বিটে [DRUM] ড্রাম বাজাও ",
    "music.playNoteForBeats": "[BEATS] বিটের  জন্য [NOTE] নোট চালু কর",
    "music.restForBeats": "[BEATS] বিটের জন্য অপেক্ষা",
    "music.setInstrument": "[INSTRUMENT] বাদ্যযন্ত্রটি নির্ধারণ কর",
    "music.setTempo": "টেম্পো [TEMPO] নির্ধারণ কর",
    "pen.categoryName": "কলম",
    "pen.changeColorParam": "কলমের [COLOR_PARAM] [VALUE] দ্বারা পরিবর্তন কর",
    "pen.changeHue": "কলমের রঙ [HUE] দ্বারা পরিবর্তন",
    "pen.changeShade": " কলমের ছায়া [SHADE] দ্বারা পরিবর্তন কর",
    "pen.changeSize": "কলমের আকার [SIZE] তে পরিবর্তন কর",
    "pen.clear": "সব মুছে ফেল",
    "pen.colorMenu.brightness": "উজ্জ্বলতা",
    "pen.colorMenu.color": "রঙ",
    "pen.colorMenu.saturation": "saturation",
    "pen.colorMenu.transparency": "স্বচ্ছতা",
    "pen.penDown": "কলম নিচে নামাও",
    "pen.penUp": "কলম উপরে উঠাও",
    "pen.setColor": "কলমের রঙ [COLOR] নির্ধারণ কর",
    "pen.setColorParam": "কলমের [COLOR_PARAM] [VALUE] এ নির্ধারণ কর",
    "pen.setHue": "কলমের রঙ [HUE] এ নির্ধারণ কর",
    "pen.setShade": "কলমের ছায়া [SHADE] নির্ধারণ কর",
    "pen.setSize": "কলমের আকার [SIZE] নির্ধারণ কর",
    "pen.stamp": "স্ট্যাম্প",
    "speech.defaultWhenIHearValue": "চল যাই",
    "speech.extensionName": "স্পিচ টু টেক্সট",
    "speech.listenAndWait": "শোন এবং অপেক্ষা কর",
    "speech.speechReporter": "কথা",
    "speech.whenIHear": "যখন আমি [PHRASE] শুনি",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "টেক্সট টু স্পিচ",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "দানব",
    "text2speech.kitten": "বিড়ালছানা",
    "text2speech.setLanguageBlock": " [LANGUAGE] এ ভাষা নির্ধারণ কর",
    "text2speech.setVoiceBlock": "[VOICE] ভয়েস নির্ধারণ কর",
    "text2speech.speakAndWaitBlock": "বল [WORDS]",
    "text2speech.squeak": "চিৎকার",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "অনুবাদ",
    "translate.defaultTextToTranslate": "hello",
    "translate.translateBlock": "[WORDS] [LANGUAGE] ভাষায় অনুবাদ কর ",
    "translate.viewerLanguage": "ভাষা",
    "videoSensing.categoryName": "ভিডিও অনুমান",
    "videoSensing.direction": "দিক",
    "videoSensing.motion": "গতি",
    "videoSensing.off": "বন্ধ",
    "videoSensing.on": "চালু",
    "videoSensing.onFlipped": "উল্টানো থাকলে ",
    "videoSensing.setVideoTransparency": "ভিডিওর স্বচ্ছতা [TRANSPARENCY] নির্ধারণ কর",
    "videoSensing.sprite": "স্প্রাইট",
    "videoSensing.stage": "মঞ্চ",
    "videoSensing.videoOn": "[SUBJECT] এর উপর ভিডিও [ATTRIBUTE]",
    "videoSensing.videoToggle": "ভিডিও [VIDEO_STATE] ঘুরাও",
    "videoSensing.whenMotionGreaterThan": "যখন ভিডিওর গতি > [REFERENCE]",
    "wedo2.getDistance": "দুরত্ব",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ঐ দিকে",
    "wedo2.motorDirection.forward": "এই পথে",
    "wedo2.motorDirection.reverse": "বিপরীত",
    "wedo2.motorId.a": "মোটর A",
    "wedo2.motorId.all": "সব মোটরগুলো",
    "wedo2.motorId.b": "মোটর B",
    "wedo2.motorId.default": "মোটর ",
    "wedo2.motorOff": "[MOTOR_ID] বন্ধ কর",
    "wedo2.motorOn": "[MOTOR_ID] চালু কর",
    "wedo2.motorOnFor": "[DURATION] সেকেন্ডের জন্য [MOTOR_ID] চালু কর",
    "wedo2.playNoteFor": "[DURATION] সেকেন্ডের জন্য নোটটি [NOTE] বাজাও",
    "wedo2.setLightHue": "লাইটের রঙ [HUE] নির্ধারণ কর",
    "wedo2.setMotorDirection": "[MOTOR_DIRECTION] এ [MOTOR_ID] এর দিক নির্ধারণ কর",
    "wedo2.startMotorPower": "[MOTOR_ID] শক্তি [POWER] নির্ধারণ কর",
    "wedo2.tiltDirection.any": "যেকোন",
    "wedo2.tiltDirection.down": "নিচে",
    "wedo2.tiltDirection.left": "বাম",
    "wedo2.tiltDirection.right": "ডানে ",
    "wedo2.tiltDirection.up": "উপরে ",
    "wedo2.whenDistance": "যখন দূরুত্ব [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "রঙ",
    "paint.paintEditor.saturation": "সম্পৃক্ত",
    "paint.paintEditor.brightness": "উজ্জ্বলতা",
    "paint.paintEditor.costume": "পোশাক",
    "paint.paintEditor.group": "দল",
    "paint.paintEditor.ungroup": "দলমুক্ত",
    "paint.paintEditor.undo": "পূর্বাবস্থায় ফেরত",
    "paint.paintEditor.redo": "পুনরায় কর",
    "paint.paintEditor.forward": "সামনে",
    "paint.paintEditor.backward": "পিছনে",
    "paint.paintEditor.front": "সামনে",
    "paint.paintEditor.back": "পিছনে",
    "paint.paintEditor.more": "আরও",
    "paint.modeTools.brushSize": "আকার",
    "paint.modeTools.eraserSize": "রবারের আকার",
    "paint.modeTools.copy": "কপি",
    "paint.modeTools.paste": "পেস্ট",
    "paint.modeTools.delete": "অপসারণ",
    "paint.modeTools.curved": "বাঁকা",
    "paint.modeTools.pointed": "তীক্ষ্ন",
    "paint.modeTools.thickness": "পুরুত্ব",
    "paint.modeTools.flipHorizontal": "হরিজেন্টালি উল্টাও ",
    "paint.modeTools.flipVertical": "ভার্টিক্যালি উল্টাও",
    "paint.modeTools.filled": "ভরাট করা",
    "paint.modeTools.outlined": "আউটলাইন",
    "paint.paintEditor.bitmap": "বিটম্যাপে রূপান্তর কর",
    "paint.paintEditor.vector": "ভেক্টরে রূপান্তর কর ",
    "paint.paintEditor.fill": "পূরণ",
    "paint.paintEditor.stroke": "আউটলাইন",
    "paint.brushMode.brush": "তুলি",
    "paint.eraserMode.eraser": "রবার",
    "paint.fillMode.fill": "ভরাট",
    "paint.lineMode.line": "রেখা",
    "paint.ovalMode.oval": "বৃত্তাকার",
    "paint.rectMode.rect": "আয়তক্ষেত্র",
    "paint.reshapeMode.reshape": "পুনর্গঠন",
    "paint.roundedRectMode.roundedRect": "গোলাকার আয়তক্ষেত্র",
    "paint.selectMode.select": "নির্বাচন কর",
    "paint.textMode.text": "পাঠ",
    "paint.colorPicker.swap": "বিনিময়"
  },
  "be": {
    "gui.alerts.lostPeripheralConnection": "Scratch страціў сувязь з {extensionName}.",
    "gui.alerts.tryAgain": "Паспрабуйце яшчэ",
    "gui.alerts.download": "Спампаваць",
    "gui.connection.reconnect": "Перападлучыцца",
    "gui.backpack.costumeLabel": "касцюм",
    "gui.backpack.soundLabel": "гук",
    "gui.backpack.scriptLabel": "скрыпт",
    "gui.backpack.spriteLabel": "спрайт",
    "gui.backpack.header": "Заплечнік",
    "gui.backpack.errorBackpack": "Памылка пры загрузцы заплечніка",
    "gui.backpack.loadingBackpack": "Загрузка...",
    "gui.backpack.more": "Яшчэ",
    "gui.backpack.emptyBackpack": "Заплечнік пусты",
    "gui.unsupportedBrowser.label": "Браўзер не падтрымліваецца",
    "gui.unsupportedBrowser.errorLabel": "Адбылася памылка",
    "gui.unsupportedBrowser.notRecommended": "Нам вельмі шкада, але вы карыстаецеся версіей браўзера, якую не падтрымлівае Scratch. Мы раім скарыстацца апошнімі версіямі такіх браўзераў як Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safari.",
    "gui.unsupportedBrowser.description": "Нам вельмі вельмі шкада, але Scratch не падтрымлівае гэты браўзер. Мы раім скарыстацца апошнімі версіямі такіх браўзераў як Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "Каб даведацца больш, перайдзіце па спасылцы {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "Частыя пытанні (FAQ)",
    "gui.cards.all-tutorials": "Падручнікі",
    "gui.cards.shrink": "Сціснуць",
    "gui.cards.expand": "Разгарнуць",
    "gui.cards.close": "Закрыць",
    "gui.cards.more-things-to-try": "Дадатковыя магчымасці!",
    "gui.cards.see-more": "Даведацца больш",
    "gui.comingSoon.message1": "Не хвалюйцеся, мы працуем над гэтым {emoji}",
    "gui.comingSoon.message2": "У бліжэйшы час...",
    "gui.comingSoon.message3": "Мы працуем над гэтым {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Прылады не знойдзены",
    "gui.connection.auto-scanning.prescan": "Размясціце вашу прыладу паблізу і пачніце пошук.",
    "gui.connection.auto-scanning.pressbutton": "Націсніце кнопку на вашай прыладзе.",
    "gui.connection.auto-scanning.start-search": "Пачаць пошук",
    "gui.connection.connecting-searchbutton": "Пошук...",
    "gui.connection.auto-scanning.try-again": "Паспрабуйце яшчэ",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Злучана",
    "gui.connection.disconnect": "Адлучыць",
    "gui.connection.go-to-editor": "Перайсці да рэдактара",
    "gui.connection.connecting-cancelbutton": "Злучэнне...",
    "gui.connection.error.errorMessage": "Ой! Здаецца, штосьці пайшло не так.",
    "gui.connection.error.tryagainbutton": "Паспрабуйце яшчэ",
    "gui.connection.error.helpbutton": "Даведка",
    "gui.connection.peripheral-name-label": "Назва прылады",
    "gui.connection.connect": "Злучыць",
    "gui.connection.scanning.lookingforperipherals": "Ідзе пошук прылад",
    "gui.connection.scanning.noPeripheralsFound": "Прылады не знойдзены",
    "gui.connection.scanning.instructions": "Выберыце сваю прыладу са спіса",
    "gui.connection.search": "Абнавіць",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Пераканайцеся ў тым, што вы ўсталявалі і запусцілі Scratсh Link",
    "gui.connection.unavailable.enablebluetooth": "Праверце, ці ўключаны Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Паспрабуйце яшчэ",
    "gui.connection.unavailable.helpbutton": "Даведка",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Выканаць",
    "gui.controls.stop": "Спыніць",
    "gui.crashMessage.label": "Ой! Штосьці пайшло не так.",
    "gui.crashMessage.description": "Нам вельмі шкада, але падобна што Scratch даў збой. Паведамленне пра памылку было аўтаматычна адпраўлена камандзе Scratch. Калі ласка, абнавіце старонку каб паспрабаваць яшчэ раз.",
    "gui.crashMessage.errorNumber": "Ваша памылка зарэгістраваная з ідэнтыфікатарам {errorId}",
    "gui.crashMessage.reload": "Перазагрузіць",
    "gui.customProcedures.myblockModalTitle": "Стварыць блок",
    "gui.customProcedures.addAnInputNumberText": "Дадаць значэнне",
    "gui.customProcedures.numberTextType": "лічба або тэкст",
    "gui.customProcedures.addAnInputBoolean": "Дадаць значэнне",
    "gui.customProcedures.booleanType": "лагічны",
    "gui.customProcedures.addALabel": "Дадаць подпіс",
    "gui.customProcedures.runWithoutScreenRefresh": "Выканаць без аднаўлення экрану",
    "gui.customProcedures.cancel": "Скасаваць",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Кірунак",
    "gui.directionPicker.rotationStyles.allAround": "Кругом",
    "gui.directionPicker.rotationStyles.leftRight": "Налева/Направа",
    "gui.directionPicker.rotationStyles.dontRotate": "Не круціць",
    "gui.gui.addExtension": "Дадаць пашырэнне",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Фоны",
    "gui.gui.costumesTab": "Касцюмы",
    "gui.gui.soundsTab": "Гукі",
    "gui.extensionLibrary.comingSoon": "У бліжэйшы час...",
    "gui.extensionLibrary.requires": "Патрабуюцца",
    "gui.extensionLibrary.collaboration": "У супрацоўніцтве",
    "gui.library.filterPlaceholder": "Шукаць",
    "gui.library.allTag": "Усе",
    "gui.loader.message1": "Стварэнне блокаў...",
    "gui.loader.message2": "Загрузка спрайтаў...",
    "gui.loader.message3": "Загрузка гукаў...",
    "gui.loader.message4": "Загрузка пашырэнняў…",
    "gui.loader.message5": "Гадуем кацянятаў...",
    "gui.loader.message6": "Перадача наначасціц…",
    "gui.loader.message7": "Напампоўваем Гоба...",
    "gui.loader.message8": "Падрыхтоўка смайлікаў...",
    "gui.loader.headline": "Загрузка праекта",
    "gui.loader.creating": "Стварыць праект",
    "gui.accountMenu.profile": "Профіль",
    "gui.accountMenu.myStuff": "Мае Праекты",
    "gui.accountMenu.myClasses": "Мае класы",
    "gui.accountMenu.myClass": "Мой клас",
    "gui.accountMenu.accountSettings": "Наладкі профілю",
    "gui.accountMenu.signOut": "Выйсці",
    "gui.authorInfo.byUser": "ад {username}",
    "gui.menuBar.seeProjectPage": "Старонка праекта",
    "gui.menuBar.language": "Language",
    "general.username": "Імя карыстальніка",
    "general.password": "Пароль",
    "general.signIn": "Увайсці",
    "login.needHelp": "Патрэбна дапамога?",
    "form.validationRequired": "Гэта поле абавязковае",
    "gui.menuBar.tutorialsLibrary": "Падручнікі",
    "gui.menuBar.restoreSprite": "Аднавіць спрайт",
    "gui.menuBar.restoreSound": "Аднавіць гук",
    "gui.menuBar.restoreCostume": "Аднавіць касцюм",
    "gui.menuBar.restore": "Аднавіць",
    "gui.menuBar.saveNow": "Захаваць",
    "gui.menuBar.saveAsCopy": "Захаваць як копію",
    "gui.menuBar.remix": "Рэмікс",
    "gui.menuBar.new": "Новы",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Захаваць на свой камп'ютар",
    "gui.menuBar.edit": "Змяніць",
    "gui.menuBar.turboModeOff": "Выключыць Турба рэжым",
    "gui.menuBar.turboModeOn": "Уключыць Турба рэжым",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Далучыцца да Scratch",
    "gui.menuBar.signIn": "Увайсці",
    "gui.gui.projectTitlePlaceholder": "Назва праекта",
    "gui.menuBar.saveNowLink": "Захаваць",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Апублікаваны",
    "gui.menuBar.share": "Апублікаваць",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Даведка",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(пусты)",
    "gui.monitor.listMonitor.listLength": "даўжыня {length}",
    "gui.monitor.contextMenu.default": "звычайны выгляд",
    "gui.monitor.contextMenu.large": "павялічаны выгляд",
    "gui.monitor.contextMenu.slider": "паўзунок",
    "gui.monitor.contextMenu.sliderRange": "змяніць дыяпазон паўзунка",
    "gui.monitor.contextMenu.import": "імпарт",
    "gui.monitor.contextMenu.export": "экспарт",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Іграць",
    "gui.playButton.stop": "Спыніць",
    "gui.gui.variableScopeOptionAllSprites": "Для ўсіх спрайтаў",
    "gui.gui.variableScopeOptionSpriteOnly": "Толькі для гэтага спрайта",
    "gui.gui.cloudVariableOption": "Воблачная зменная (захоўваецца на серверы)",
    "gui.gui.variablePromptAllSpritesMessage": "Гэтая зменная будзе даступна для ўсіх спрайтаў.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Скасаваць",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Спыніць",
    "gui.playbackStep.playMsg": "Іграць",
    "gui.playbackStep.loadingMsg": "Загрузка...",
    "gui.playbackStep.saveMsg": "Захаваць",
    "gui.playbackStep.reRecordMsg": "Перазапісаць",
    "gui.recordModal.title": "Запісаць гук",
    "gui.recordingStep.beginRecord": "Пачаць запіс, націснуўшы кнопку ніжэй",
    "gui.recordingStep.permission": "{arrow}Нам патрэбен ваш дазвол для доступу да мікрафона",
    "gui.recordingStep.stop": "Спыніць запіс",
    "gui.recordingStep.record": "Запісаць",
    "gui.sliderModal.min": "Мінімальнае значэнне",
    "gui.sliderModal.max": "Максімальнае значэнне",
    "gui.sliderModal.title": "Змяніць дыяпазон паўзунка",
    "gui.sliderPrompt.cancel": "Скасаваць",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Гук",
    "gui.soundEditor.play": "Іграць",
    "gui.soundEditor.stop": "Спыніць",
    "gui.soundEditor.copy": "Капіраваць",
    "gui.soundEditor.paste": "Уставіць",
    "gui.soundEditor.copyToNew": "Капіраваць у новы",
    "gui.soundEditor.delete": "Выдаліць",
    "gui.soundEditor.save": "Захаваць",
    "gui.soundEditor.undo": "Адмяніць",
    "gui.soundEditor.redo": "Вярнуць",
    "gui.soundEditor.faster": "Хутчэй",
    "gui.soundEditor.slower": "Павольней",
    "gui.soundEditor.echo": "Рэха",
    "gui.soundEditor.robot": "Робат",
    "gui.soundEditor.louder": "Гучней",
    "gui.soundEditor.softer": "Цішэй",
    "gui.soundEditor.reverse": "У адваротным парадку",
    "gui.soundEditor.fadeOut": "Паступовае знікненне",
    "gui.soundEditor.fadeIn": "Паступовае ўзмацненне",
    "gui.soundEditor.mute": "Выкл гук",
    "gui.SpriteInfo.spritePlaceholder": "Імя",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Паказаць",
    "gui.SpriteInfo.size": "Памер",
    "gui.spriteSelectorItem.contextMenuDuplicate": "падвоіць",
    "gui.spriteSelectorItem.contextMenuExport": "экспарт",
    "gui.spriteSelectorItem.contextMenuDelete": "выдаліць",
    "gui.spriteSelector.addSpriteFromLibrary": "Выбраць спрайт",
    "gui.spriteSelector.addSpriteFromPaint": "Намаляваць",
    "gui.spriteSelector.addSpriteFromSurprise": "Сюрпрыз",
    "gui.spriteSelector.addSpriteFromFile": "Загрузіць спрайт",
    "gui.stageHeader.stageSizeLarge": "Пераключыцца на вялікую сцэну",
    "gui.stageHeader.stageSizeSmall": "Пераключыцца на маленькую сцэну",
    "gui.stageHeader.stageSizeFull": "Поўнаэкранны рэжым",
    "gui.stageHeader.stageSizeUnFull": "Выхад з поўнаэкраннага рэжыму",
    "gui.stageHeader.fullscreenControl": "Поўнаэкранны рэжым",
    "gui.spriteSelector.addBackdropFromLibrary": "Выбраць фон",
    "gui.stageSelector.addBackdropFromPaint": "Намаляваць",
    "gui.stageSelector.addBackdropFromSurprise": "Сюрпрыз",
    "gui.stageSelector.addBackdropFromFile": "Загрузіць фон",
    "gui.stageSelector.stage": "Сцэна",
    "gui.stageSelector.backdrops": "Фоны",
    "gui.telemetryOptIn.label": "Адправіць статыстыку, каб палепшыць Scratch",
    "gui.telemetryOptIn.body1": "Каманда Scratch заўсёды імкнецца вывучаць, як Scratch выкарыстоўваецца ва ўсім сьвеце. Каб дапамагчы нам, калі ласка, дазвольце Scratch аўтаматычна дасылаць нам інфармацыю аб яго выкарыстанні",
    "gui.telemetryOptIn.body2": "Інфармацыя, якую мы збіраем, датычыцца моўнага выбару, выкарыстання блокаў, а таксама захавання, пампавання і загрузкі праектаў. Мы НЕ збіраем асабістую інфармацыю. Каб даведацца больш, калі ласка, звяртайцеся да нашае {privacyPolicyLink}.",
    "gui.telemetryOptIn.privacyPolicyLink": "Палітыка канфідэнцыяльнасці",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Рэжым турба",
    "gui.webglModal.label": "Ваш браўзер не падтрымлівае WebGL",
    "gui.webglModal.description": "На жаль, ваш браўзер ці камп'ютар {webGlLink}. Гэта тэхналогія патрэбна для запуску Scratch 3.0. ",
    "gui.webglModal.webgllink": "не падтрымлівае WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "Каб даведацца больш, перайдзіце па спасылцы {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "Частыя пытаньні (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "Выбраць фон",
    "gui.costumeLibrary.chooseACostume": "Выбраць касцюм",
    "gui.costumeTab.addBackdropFromLibrary": "Выбраць фон",
    "gui.costumeTab.addCostumeFromLibrary": "Выбраць касцюм",
    "gui.costumeTab.addBlankCostume": "Намаляваць",
    "gui.costumeTab.addSurpriseCostume": "Сюрпрыз",
    "gui.costumeTab.addFileBackdrop": "Загрузіць фон",
    "gui.costumeTab.addFileCostume": "Загрузіць касцюм",
    "gui.extensionLibrary.chooseAnExtension": "Выбраць пашырэнне",
    "gui.extensionLibrary.extensionUrl": "Увядзіце URL пашырэння",
    "gui.monitors.importListColumnPrompt": "Якая калонка павінна быць выкарыстана (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Немагчыма пачаць запіс",
    "gui.soundLibrary.chooseASound": "Выбраць гук",
    "gui.soundTab.fileUploadSound": "Загрузіць гук",
    "gui.soundTab.surpriseSound": "Сюрпрыз",
    "gui.soundTab.recordSound": "Запісаць",
    "gui.soundTab.addSoundFromLibrary": "Выбраць гук",
    "gui.spriteLibrary.chooseASprite": "Выбраць спрайт",
    "gui.tipsLibrary.tutorials": "Выбраць падручнік",
    "gui.alerts.createsuccess": "Новы праект створаны.",
    "gui.alerts.createcopysuccess": "Праект захаваны як копія.",
    "gui.alerts.createremixsuccess": "Праект захаваны як рэмікс.",
    "gui.alerts.creating": "Стварэнне новага...",
    "gui.alerts.creatingCopy": "Капіраванне праекта...",
    "gui.alerts.creatingRemix": "Рэмікс праекта...",
    "gui.alerts.creatingError": "Немагчыма стварыць праект. Паспрабуйце яшчэ раз!",
    "gui.alerts.savingError": "Праект не можа быць захаваны.",
    "gui.alerts.savesuccess": "Праект захаваны.",
    "gui.alerts.saving": "Захаванне праекта...",
    "gui.alerts.cloudInfo": "Воблачныя зменныя могуць быць толькі лічбамі, а не літарамі ці знакамі. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Даведацца больш.",
    "gui.alerts.importing": "Імпарт...",
    "gui.defaultProject.meow": "Мяў",
    "gui.defaultProject.variable": "мая зменная",
    "gui.howtos.intro-move-sayhello-hat.name": "З чаго пачаць",
    "gui.howtos.intro-move.step_stepMove": "Дадаць рухомы блок",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Націснуць на зялёны сцяг, каб пачаць",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Ажывіць Імя",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Выбраць Спрайт Літару",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Граць гук пры націсканні",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Выбраць іншага Спрайта-Літару",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Змяніць колер",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Выбраць іншага Спрайта-Літару і прымусіць яго круціцца",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Выбраць іншага Спрайта-Літару і павялічыць яго",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Націснуць на зялёны сцяг, каб пачаць",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Выбраць любы фон",
    "gui.howtos.imagine.step_imagineChooseSprite": "Выбраць любы Спрайт",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Выбраць іншы Спрайт",
    "gui.howtos.imagine.step_imagineLeftRight": "Рухаць налева-направа",
    "gui.howtos.imagine.step_imagineUpDown": "Рухаць угору-долу",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Змяняць касцюмы",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Слізгаць да кропкі",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Выбраць іншы фон",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Дадаць гук",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Стварыць музыку",
    "gui.howtos.Make-Music.step_PickInstrument": "Выбраць Спрайт Інструмент",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Граць гук пры націсканні",
    "gui.howtos.Make-Music.step_MakeSong": "Стварыць песню",
    "gui.howtos.make-music.step_MakeBeat": "Выбраць барабан і паслухаць гук",
    "gui.howtos.make-music.step_MakeBeatBox": "Выбраць Мікрафон Спрайт і Куфар для сюрпрызаў",
    "gui.howtos.story.name": "Стварыць гісторыю",
    "gui.howtos.story.step_addbg": "Дадаць Фон",
    "gui.howtos.story.step_addsprite": "Дадаць персанаж",
    "gui.howtos.story.step_saysomething": "Сказаць што-небудзь",
    "gui.howtos.story.step_addanothersprite": "Дадаць другі персанаж",
    "gui.howtos.story.step_flip": "Змяніць кірунак на адваротны",
    "gui.howtos.story.step_conversation": "Пачаць гутарку",
    "gui.howtos.story.addanotherbg": "Дадаць іншы фон",
    "gui.howtos.story.step_swithbg": "Змяніць фоны",
    "gui.howtos.story.step_hidewizard": "Схаваць персанаж",
    "gui.howtos.story.step_showwizard": "Паказаць персанаж",
    "gui.howtos.make-a-chase-game.name": "Стварыць гульню з пагоняй",
    "gui.howtos.Chase-Game.step_BG": "Дадаць Фон",
    "gui.howtos.chase-game.step_AddOcto": "Дадаць Спрайт",
    "gui.howtos.make-music.step_LeftRight": "Рухаць у правы ці ў левы бок, выкарыстоўваючы кнопкі са стрэлкамі",
    "gui.howtos.Chase-Game.step_UpDown": "Рухаць уверх і ўніз, выкарыстоўваючы кнопкі са стрэлкамі",
    "gui.howtos.Chase-Game.step_AddStar": "Дадаць іншы Спрайт",
    "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
    "gui.howtos.Chase-Game.step_WhenTouch": "У Спрутавым Спрайце пры дотыку будьзе чутны гук",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Стварыць зменную для ліку",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "У Спрутавым Спрайце пры дотыку будзе ўзрастаць лік",
    "gui.howtos.animate-char.name": "Ажывіць персанаж",
    "gui.howtos.animate-char.step_addbg": "Дадаць Фон",
    "gui.howtos.animate-char.step_addsprite": "Дадаць Спрайт",
    "gui.howtos.animate-char.step_saysomething": "Сказаць што-небудзь",
    "gui.howtos.animate-char.step_addsound": "Дадаць гук",
    "gui.howtos.animate-char.step_animatetalking": "Ажывіць размову",
    "gui.howtos.animate-char.step_arrowkeys": "Рухаць, выкарыстоўваючы кнопкі са стрэлкамі",
    "gui.howtos.animate-char.step_jump": "Скокнуць",
    "gui.howtos.animate-char.step_changecolor": "Змяніць колер",
    "gui.howtos.make-a-game.name": "Стварыць гульню з націсканнямі",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Выбраць Спрайт А",
    "gui.howtos.make-a-game.step_GamePlaySound": "Граць гук пры націсканні",
    "gui.howtos.make-a-game.step_GameAddScore": "Стварыць зменную для ліку",
    "gui.howtos.make-a-game.step_GameChangeScore": "Павялічваць лік пры націсканні",
    "gui.howtos.make-a-game.step_Random": "Перайсці ў якую-небудзь пазіцыю",
    "gui.howtos.make-music.step_GameChangeColor": "Змяніць колер",
    "gui.howtos.make-music.step_ResetScore": "Скінуць лік",
    "gui.howtos.make-it-fly.name": "Зрабіць, каб ляталі",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Выбраць фон неба",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Выбраць персанаж",
    "gui.howtos.fly.step_stepflySaySomething": "Сказаць што-небудзь",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Рухаць кнопкамі са стрэлкамі",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Наступны касцюм",
    "gui.howtos.pong": "Гульня Pong (пінг-понг)",
    "gui.howtos.pong.step_pongAddBackdrop": "Дадаць фон",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Выбраць спрайт Мяч",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Гульня скончана",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Аніміраваць гульню-прыгоду",
    "gui.howtos.cartoon-network.step_CNcharacter": "Выбраць персанаж для паказу",
    "gui.howtos.cartoon-network.step_CNsay": "Сказаць што-небудзь",
    "gui.howtos.cartoon-network.step_CNglide": "Праслізнуць вакол",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Выбраць аб'ект для пагоні",
    "gui.howtos.cartoon-network.step_CNcollect": "Сабраць аб'екты разам",
    "gui.howtos.cartoon-network.step_CNvariable": "Стварыць зменную для ліку",
    "gui.howtos.cartoon-network.step_CNscore": "Захаваць лік",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Новы ўзровень: змяніць фон",
    "gui.howtos.videosens.name": "Відэадатчыкі",
    "gui.howtos.videosens.step_addextension": "Дадаць пашырэнне",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Ажывіць",
    "gui.howtos.videosens.step_pop": "Дадаць усплываючы нататак",
    "gui.howtos.say-it-out-loud": "Стварыць анімацыі, якія размаўляюць",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Дадаць блокі Тэкст у Маўленне",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Сказаць што-небудзь",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Устанавіць голас",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Рухацца вакол",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Дадаць фон",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Дадаць другі персанаж",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Праспяваць песню",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Змяніць колер",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Пакруціць",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Павялічыць і паменшыць",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Выбраць песню для танца",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Дадаць Спрайт",
    "gui.howtos.add-sprite.step_addSprite": "Дадаць Спрайт",
    "gui.howtos.add-a-backdrop.name": "Дадаць фон",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Дадаць фон",
    "gui.howtos.change-size.name": "Змяніць памер",
    "gui.howtos.change-size.step_changeSize": "Змяніць памер",
    "gui.howtos.glide-around.name": "Праслізнуць вакол",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Слізгаць да кропкі",
    "gui.howtos.record-a-sound.name": "Запісаць гук",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Націснуць на ўкладку \"Гукі\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Выбраць свой гук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Пакруціць гэта",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Задаць кірунак",
    "gui.howtos.hide-and-show.name": "Схаваць і паказаць",
    "gui.howtos.change-size.step_hideAndShow": "Схаваць і паказаць",
    "gui.howtos.switch-costume.name": "Ажывіць Спрайт",
    "gui.howtos.change-size.step_switchCostumes": "Ажывіць Спрайт",
    "gui.howtos.move-around-with-arrow-keys.name": "Выкарыстаць кнопкі са стрэлкамі",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Рухаць налева і направа",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Рухаць уверх і ўніз",
    "gui.howtos.add-effects.name": "Дадаць эфекты",
    "gui.howtos.videosens.step_addEffects": "Дадаць эфекты",
    "gui.extension.music.name": "Музыка",
    "gui.extension.music.description": "Граць на музычных інструментах і барабанах",
    "gui.extension.pen.name": "Аловак",
    "gui.extension.pen.description": "Draw with your sprites.",
    "gui.extension.videosensing.name": "Відэадатчыкі",
    "gui.extension.videosensing.description": "Заўважыць рух з дапамогай камеры",
    "gui.extension.text2speech.name": "пераўтварыць Тэкст у Маўленне",
    "gui.extension.text2speech.description": "Навучыць вашыя праекты размаўляць",
    "gui.extension.translate.name": "Перакладчык",
    "gui.extension.translate.description": "Перакладаць тэксты на іншыя мовы.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "Злучыць вашыя праекты з усім светам",
    "gui.extension.microbit.connectingMessage": "Злучыць",
    "gui.extension.ev3.description": "Build interactive robots and more.",
    "gui.extension.ev3.connectingMessage": "Злучэнне. Праверце, каб pin нумар на вашым EV3 быў усталяваны на 1234.",
    "gui.extension.boost.description": "Ажывіце робататэхнічныя мадэлі.",
    "gui.extension.boost.connectingMessage": "Злучыць",
    "gui.extension.wedo2.description": "Працаваць з рухавікамі і датчыкамі.",
    "gui.extension.wedo2.connectingMessage": "Connecting",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Злучыць",
    "gui.libraryTags.all": "Усе",
    "gui.libraryTags.animals": "Жывёлы",
    "gui.libraryTags.dance": "Танцы",
    "gui.libraryTags.effects": "Эфекты",
    "gui.libraryTags.fantasy": "Фэнтэзі",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Ежа",
    "gui.libraryTags.indoors": "У памяшканні",
    "gui.libraryTags.loops": "Цыклы",
    "gui.libraryTags.music": "Музыка",
    "gui.libraryTags.notes": "Музычныя ноты",
    "gui.libraryTags.outdoors": "На вольным паветры",
    "gui.libraryTags.patterns": "Узоры",
    "gui.libraryTags.people": "Людзі",
    "gui.libraryTags.percussion": "Перкусія",
    "gui.libraryTags.space": "Космас",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Падводны свет",
    "gui.libraryTags.voice": "Голас",
    "gui.libraryTags.wacky": "Дурнаваты",
    "gui.libraryTags.animation": "Анімацыя",
    "gui.libraryTags.art": "Мастацтва",
    "gui.libraryTags.games": "Гульні",
    "gui.libraryTags.stories": "Гісторыі",
    "gui.libraryTags.letters": "Літары",
    "gui.opcodeLabels.direction": "кірунак",
    "gui.opcodeLabels.xposition": "пазіцыя X",
    "gui.opcodeLabels.yposition": "пазіцыя Y",
    "gui.opcodeLabels.size": "памер",
    "gui.opcodeLabels.costumename": "імя касцюма",
    "gui.opcodeLabels.costumenumber": "нумар касцюма",
    "gui.opcodeLabels.backdropname": "імя фону",
    "gui.opcodeLabels.backdropnumber": "нумар фону",
    "gui.opcodeLabels.volume": "гучнасць",
    "gui.opcodeLabels.tempo": "тэмп",
    "gui.opcodeLabels.answer": "адказ",
    "gui.opcodeLabels.loudness": "гучнасць",
    "gui.opcodeLabels.username": "імя карыстальніка",
    "gui.opcodeLabels.year": "год",
    "gui.opcodeLabels.month": "месяц",
    "gui.opcodeLabels.date": "дата",
    "gui.opcodeLabels.dayofweek": "дзень тыдня",
    "gui.opcodeLabels.hour": "гадзіна",
    "gui.opcodeLabels.minute": "хвіліна",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Не атрымалася загрузіць файл праекта, які быў абраны.",
    "gui.sharedMessages.backdrop": "фон {index}",
    "gui.sharedMessages.costume": "касцюм {index}",
    "gui.sharedMessages.sprite": "Спрайт {index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Замяніць змесціва гэтага праекта?",
    "gui.sharedMessages.loadFromComputerTitle": "Загрузіць з камп'ютара",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Праект Scratch",
    "boost.color.any": "любы колер",
    "boost.color.black": "чорны",
    "boost.color.blue": "сіні",
    "boost.color.green": "зялёны",
    "boost.color.red": "чырвоны",
    "boost.color.white": "белы",
    "boost.color.yellow": "жоўты",
    "boost.getMotorPosition": "пазіцыя рухавіка [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "вугал нахілу [TILT_DIRECTION]",
    "boost.motorDirection.backward": "супраць гадзіннікавай стэлкі",
    "boost.motorDirection.forward": "па гадзіннікавай стрэлцы",
    "boost.motorDirection.reverse": "у адваротны бок",
    "boost.motorOff": "выключыць рухавік [MOTOR_ID]",
    "boost.motorOn": "уключыць рухавік [MOTOR_ID]",
    "boost.motorOnFor": "уключыць рухавік [MOTOR_ID] на [DURATION] секунд",
    "boost.motorOnForRotation": "уключыць рухавік [MOTOR_ID] на [ROTATION] абаротаў",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "устанавіць колер святла [HUE]",
    "boost.setMotorDirection": "устанавіць напрамак [MOTOR_DIRECTION] для рухавіка [MOTOR_ID]",
    "boost.setMotorPower": "устанавіць рухавіку [MOTOR_ID] хуткасць [POWER] %",
    "boost.tiltDirection.any": "як-небудзь",
    "boost.tiltDirection.down": "уніз",
    "boost.tiltDirection.left": "налева",
    "boost.tiltDirection.right": "направа",
    "boost.tiltDirection.up": "уверх",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "калі нахілены [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "іграць ноту [NOTE]на працягу [TIME] секунд",
    "ev3.buttonPressed": "кнопка [PORT] націснутая?",
    "ev3.getBrightness": "яркасць",
    "ev3.getDistance": "адлегласць",
    "ev3.getMotorPosition": "пазіцыя рухавіка [PORT]",
    "ev3.motorSetPower": "рухавіку [PORT] устанавіць магутнасць [POWER] % ",
    "ev3.motorTurnClockwise": "рухавік [PORT]павярнуць па гадзіннікавай стрэлцы на [TIME] секундаў ",
    "ev3.motorTurnCounterClockwise": "рухавік [PORT] павярнуць супраць гадзіннікавай стрэлкі на [TIME] секундаў ",
    "ev3.whenBrightnessLessThan": "калі яркасць < [DISTANCE]",
    "ev3.whenButtonPressed": "калі кнопка [PORT] націснутая",
    "ev3.whenDistanceLessThan": "калі адлегласць < [DISTANCE]",
    "gdxfor.getAcceleration": "паскарэнне [DIRECTION]",
    "gdxfor.getForce": "сіла",
    "gdxfor.getSpin": "хуткасць кручэння[DIRECTION]",
    "gdxfor.getTilt": "вугал нахілу [TILT]",
    "gdxfor.isFreeFalling": "падае?",
    "gdxfor.isTilted": "нахілены [TILT]?",
    "gdxfor.pulled": "пацягнуць",
    "gdxfor.pushed": "націснуць",
    "gdxfor.shaken": "патрэсці",
    "gdxfor.startedFalling": "пачаў падаць",
    "gdxfor.tiltDirectionMenu.any": "любы",
    "gdxfor.tiltDirectionMenu.back": "назад",
    "gdxfor.tiltDirectionMenu.front": "наперад",
    "gdxfor.tiltDirectionMenu.left": "налева",
    "gdxfor.tiltDirectionMenu.right": "направа",
    "gdxfor.turnedFaceDown": "павярнуўся тварам уніз",
    "gdxfor.turnedFaceUp": "павярнуўся тварам уверх",
    "gdxfor.whenForcePushedOrPulled": "калі сэнсар сілы [PUSH_PULL]",
    "gdxfor.whenGesture": "калі [GESTURE]",
    "gdxfor.whenTilted": "калі нахілены [TILT]",
    "makeymakey.downArrow": "стрэлка ўніз",
    "makeymakey.downArrowShort": "уніз",
    "makeymakey.leftArrow": "стрэлка налева",
    "makeymakey.leftArrowShort": "налева",
    "makeymakey.rightArrow": "стрэлка направа",
    "makeymakey.rightArrowShort": "направа",
    "makeymakey.spaceKey": "прабел",
    "makeymakey.upArrow": "стрэлка ўверх",
    "makeymakey.upArrowShort": "уверх",
    "makeymakey.whenKeyPressed": "калі клавіша [KEY] націснутая",
    "makeymakey.whenKeysPressedInOrder": "калі націснутыя [SEQUENCE] па парадку",
    "microbit.buttonsMenu.any": "любы",
    "microbit.clearDisplay": "ачысціць дісплэй",
    "microbit.defaultTextToDisplay": "Вітаю!",
    "microbit.displaySymbol": "паказаць [MATRIX]",
    "microbit.displayText": "паказаць тэкст [TEXT]",
    "microbit.gesturesMenu.jumped": "падкінуць",
    "microbit.gesturesMenu.moved": "зрушыць",
    "microbit.gesturesMenu.shaken": "патрэсці",
    "microbit.isButtonPressed": "[BTN]кнопка націснутая? ",
    "microbit.isTilted": "нахілены [DIRECTION]?",
    "microbit.pinStateMenu.off": "выкл",
    "microbit.pinStateMenu.on": "укл",
    "microbit.tiltAngle": "вугал нахілу [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "любы",
    "microbit.tiltDirectionMenu.back": "назад",
    "microbit.tiltDirectionMenu.front": "наперад",
    "microbit.tiltDirectionMenu.left": "налева",
    "microbit.tiltDirectionMenu.right": "направа",
    "microbit.whenButtonPressed": "калі [BTN] кнопка націснутая",
    "microbit.whenGesture": "калі [GESTURE]",
    "microbit.whenPinConnected": "калі падлучаны pin [PIN]",
    "microbit.whenTilted": "калі нахілены [DIRECTION]",
    "music.categoryName": "Музыка",
    "music.changeTempo": "змяніць тэмп на [TEMPO]",
    "music.drumBass": "(2) Турэцкі барабан",
    "music.drumBongo": "(13) Бонга",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клавесін",
    "music.drumClosedHiHat": "(6) Закрытыя талеркі",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Званочак",
    "music.drumCrashCymbal": "(4) Крэш-талерка",
    "music.drumCuica": "(18) Куіка",
    "music.drumGuiro": "(16) Гуіра",
    "music.drumHandClap": "(8) Пляскат далоняў",
    "music.drumOpenHiHat": "(5) Адкрытыя талеркі",
    "music.drumSideStick": "(3) Удар па барабану збоку",
    "music.drumSnare": "(1) Малы барабан",
    "music.drumTambourine": "(7) Тамбурын",
    "music.drumTriangle": "(12) Трохвугольнік",
    "music.drumVibraslap": "(17) Вібраслэп",
    "music.drumWoodBlock": "(10) Драўляная скрыначка",
    "music.getTempo": "тэмп",
    "music.instrumentBass": "(6) Бас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Віяланчэль",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларнет",
    "music.instrumentElectricGuitar": "(5) Электрагітара",
    "music.instrumentElectricPiano": "(2) Лічбавае піяніна",
    "music.instrumentFlute": "(12) Флейта",
    "music.instrumentGuitar": "(4) Гітара",
    "music.instrumentMarimba": "(19) Марымба",
    "music.instrumentMusicBox": "(17) Музычная скрынка",
    "music.instrumentOrgan": "(3) Арган",
    "music.instrumentPiano": "(1) Піяніна",
    "music.instrumentPizzicato": "(7) Піцыката",
    "music.instrumentSaxophone": "(11) Саксафон",
    "music.instrumentSteelDrum": "(18) Стальны барабан",
    "music.instrumentSynthLead": "(20) Вядучы сінтэзатар",
    "music.instrumentSynthPad": "(21) Сінтэзатар Pad",
    "music.instrumentTrombone": "(9) Трамбон",
    "music.instrumentVibraphone": "(16) Вібрафон",
    "music.instrumentWoodenFlute": "(13) Драўляная флейта",
    "music.midiPlayDrumForBeats": "барабану [DRUM]іграць [BEATS] тактаў",
    "music.midiSetInstrument": "выбраць інструмент [INSTRUMENT]",
    "music.playDrumForBeats": "барабану [DRUM]іграць [BEATS] тактаў",
    "music.playNoteForBeats": "іграць ноту [NOTE] [BEATS] тактаў",
    "music.restForBeats": "пачакаць [BEATS] тактаў",
    "music.setInstrument": "выбраць інструмент [INSTRUMENT]",
    "music.setTempo": "устанавіць тэмп [TEMPO]",
    "pen.categoryName": "Аловак",
    "pen.changeColorParam": "змяніць [COLOR_PARAM] алоўка на [VALUE]",
    "pen.changeHue": "змяніць колер алоўка на [HUE]",
    "pen.changeShade": "змяніць цень алоўка на [SHADE]",
    "pen.changeSize": "змяніць памер алоўка на [SIZE]",
    "pen.clear": "сцерці ўсё",
    "pen.colorMenu.brightness": "яркасць",
    "pen.colorMenu.color": "колер",
    "pen.colorMenu.saturation": "насычанасць",
    "pen.colorMenu.transparency": "празрыстасць",
    "pen.penDown": "апусціць аловак",
    "pen.penUp": "падняць аловак",
    "pen.setColor": "устанавіць колер алоўка [COLOR]",
    "pen.setColorParam": "устанавіць [COLOR_PARAM] алоўка [VALUE]",
    "pen.setHue": "устанавіць колер алоўка [HUE]",
    "pen.setShade": "устанавіць цень алоўка [SHADE]",
    "pen.setSize": "устанавіць памер алоўка [SIZE]",
    "pen.stamp": "штамп",
    "speech.defaultWhenIHearValue": "пачынаем",
    "speech.extensionName": "Маўленне ў Тэкст",
    "speech.listenAndWait": "слухаць і чакаць",
    "speech.speechReporter": "маўленне",
    "speech.whenIHear": "калі я чую [PHRASE]",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "пераўтварыць Тэкст у Маўленне",
    "text2speech.defaultTextToSpeak": "вітаю",
    "text2speech.giant": "гігант",
    "text2speech.kitten": "кацяня",
    "text2speech.setLanguageBlock": "устанавіць мову [LANGUAGE]",
    "text2speech.setVoiceBlock": "устанавіць голас [VOICE]",
    "text2speech.speakAndWaitBlock": "сказаць [WORDS]",
    "text2speech.squeak": "піск",
    "text2speech.tenor": "тэнар",
    "translate.categoryName": "Перакладчык",
    "translate.defaultTextToTranslate": "вітаю",
    "translate.translateBlock": "перакласці [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "мова",
    "videoSensing.categoryName": "Відэадатчыкі",
    "videoSensing.direction": "кірунак",
    "videoSensing.motion": "рух",
    "videoSensing.off": "выключыць",
    "videoSensing.on": "уключыць",
    "videoSensing.onFlipped": "у адваротны бок",
    "videoSensing.setVideoTransparency": "устанавіць празрыстасць відэа [TRANSPARENCY]",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "сцэна",
    "videoSensing.videoOn": "відэа [ATTRIBUTE] на [SUBJECT]",
    "videoSensing.videoToggle": "запіс відэа [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "калі рухаў відэа > [REFERENCE]",
    "wedo2.getDistance": "адлегласць",
    "wedo2.getTiltAngle": "вугал нахілу [TILT_DIRECTION]",
    "wedo2.isTilted": "нахілены [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "супраць гадзіннікавай стэлкі",
    "wedo2.motorDirection.forward": "па гадзіннікавай стрэлцы",
    "wedo2.motorDirection.reverse": "у адваротны бок",
    "wedo2.motorId.a": "рухавік А",
    "wedo2.motorId.all": "усе рухавікі",
    "wedo2.motorId.b": "рукавік В",
    "wedo2.motorId.default": "рухавік",
    "wedo2.motorOff": "выключыць [MOTOR_ID]",
    "wedo2.motorOn": "уключыць [MOTOR_ID]",
    "wedo2.motorOnFor": "уключыць [MOTOR_ID] на [DURATION] секунд",
    "wedo2.playNoteFor": "іграць ноту [NOTE] на працягу [DURATION] секунд",
    "wedo2.setLightHue": "устанавіць колер святла [HUE]",
    "wedo2.setMotorDirection": "устанавіць напрамак [MOTOR_ID] як [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "устанавіць магутнасць рухавіку [MOTOR_ID] як [POWER]",
    "wedo2.tiltDirection.any": "любы",
    "wedo2.tiltDirection.down": "уніз",
    "wedo2.tiltDirection.left": "налева",
    "wedo2.tiltDirection.right": "направа",
    "wedo2.tiltDirection.up": "уверх",
    "wedo2.whenDistance": "калі адлегласць [OP] [REFERENCE]",
    "wedo2.whenTilted": "калі нахілены [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Колер",
    "paint.paintEditor.saturation": "Насычанасць",
    "paint.paintEditor.brightness": "Яркасць",
    "paint.paintEditor.costume": "Касцюм",
    "paint.paintEditor.group": "Згрупаваць",
    "paint.paintEditor.ungroup": "Разгрупаваць",
    "paint.paintEditor.undo": "Адмяніць",
    "paint.paintEditor.redo": "Вярнуць",
    "paint.paintEditor.forward": "Наперад",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "На пярэдні план",
    "paint.paintEditor.back": "Назад",
    "paint.paintEditor.more": "Яшчэ",
    "paint.modeTools.brushSize": "Памер",
    "paint.modeTools.eraserSize": "Памер гумкі",
    "paint.modeTools.copy": "Капіраваць",
    "paint.modeTools.paste": "Уставіць",
    "paint.modeTools.delete": "Выдаліць",
    "paint.modeTools.curved": "Выгнутыя",
    "paint.modeTools.pointed": "Завостраныя",
    "paint.modeTools.thickness": "Таўшчыня",
    "paint.modeTools.flipHorizontal": "Адлюстраваць па гарызанталі",
    "paint.modeTools.flipVertical": "Адлюстраваць па вертыкалі",
    "paint.modeTools.filled": "Заліты",
    "paint.modeTools.outlined": "Абведзены",
    "paint.paintEditor.bitmap": "Канвертаваць у растравую графіку",
    "paint.paintEditor.vector": "Канвертаваць у вектарную графіку",
    "paint.paintEditor.fill": "Заліўка",
    "paint.paintEditor.stroke": "Контур",
    "paint.brushMode.brush": "Пэндзлік",
    "paint.eraserMode.eraser": "Гумка",
    "paint.fillMode.fill": "Заліўка",
    "paint.lineMode.line": "Рыса",
    "paint.ovalMode.oval": "Кола",
    "paint.rectMode.rect": "Прамавугольнік",
    "paint.reshapeMode.reshape": "Змяніць форму",
    "paint.roundedRectMode.roundedRect": "Скруглёны прамавугольнік",
    "paint.selectMode.select": "Выбраць",
    "paint.textMode.text": "Тэкст",
    "paint.colorPicker.swap": "Замяніць"
  },
  "bg": {
    "gui.alerts.lostPeripheralConnection": "Scratch загуби връзка с/ъс {extensionName}.",
    "gui.alerts.tryAgain": "Опитай пак",
    "gui.alerts.download": "Сваляне",
    "gui.connection.reconnect": "Повторно свързване",
    "gui.backpack.costumeLabel": "костюм",
    "gui.backpack.soundLabel": "звук",
    "gui.backpack.scriptLabel": "скрипт",
    "gui.backpack.spriteLabel": "спрайт",
    "gui.backpack.header": "Раница",
    "gui.backpack.errorBackpack": "Грешка при зареждането на раница",
    "gui.backpack.loadingBackpack": "Зареждане…",
    "gui.backpack.more": "Още",
    "gui.backpack.emptyBackpack": "Раницата е празна",
    "gui.unsupportedBrowser.label": "Браузърът не се поддържа",
    "gui.unsupportedBrowser.errorLabel": "Възникна грешка",
    "gui.unsupportedBrowser.notRecommended": "За съжаление изглежда, че версията на браузъра ви не поддържа Scratch . Препоръчваме ви да използвате последна версия на някой от поддържаните браузъри, като Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.description": "За съжаление, Scratch не поддържа този браузър. Препоръчваме ви да използвате последна версия на някой от поддържаните браузъри, като Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "За да научите повече, разгледайте {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "ЧЗВ",
    "gui.cards.all-tutorials": "Обучения",
    "gui.cards.shrink": "Смаляване",
    "gui.cards.expand": "Разширяване",
    "gui.cards.close": "Затвори",
    "gui.cards.more-things-to-try": "Още неща, които да опиташ!",
    "gui.cards.see-more": "Виж още",
    "gui.comingSoon.message1": "Не се притеснявайте, заели сме се с това{emoji}",
    "gui.comingSoon.message2": "Очаквайте скоро…",
    "gui.comingSoon.message3": "Работим по това {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Не са открити устройства",
    "gui.connection.auto-scanning.prescan": "Приближи устройствата и започни търсенето.",
    "gui.connection.auto-scanning.pressbutton": "Натисни бутона на устройството си.",
    "gui.connection.auto-scanning.start-search": "Започни търсене",
    "gui.connection.connecting-searchbutton": "Търсене...",
    "gui.connection.auto-scanning.try-again": "Опитай пак",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Свързан",
    "gui.connection.disconnect": "Прекрати връзка",
    "gui.connection.go-to-editor": "Отиди в Редактора",
    "gui.connection.connecting-cancelbutton": "Свързване...",
    "gui.connection.error.errorMessage": "Опа, изглежда нещо се обърка",
    "gui.connection.error.tryagainbutton": "Опитай пак",
    "gui.connection.error.helpbutton": "Помощ",
    "gui.connection.peripheral-name-label": "Име на устройството",
    "gui.connection.connect": "Свързвам",
    "gui.connection.scanning.lookingforperipherals": "Търсене на устройства",
    "gui.connection.scanning.noPeripheralsFound": "Не са открити устройства",
    "gui.connection.scanning.instructions": "Избери устройство от списъка по-горе.",
    "gui.connection.search": "Обнови",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Проверете дали имате инсталиран Scratch Link и дали работи",
    "gui.connection.unavailable.enablebluetooth": "Проверете дали Bluetooth е включен",
    "gui.connection.unavailable.tryagainbutton": "Опитай пак",
    "gui.connection.unavailable.helpbutton": "Помощ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Старт",
    "gui.controls.stop": "Спиране",
    "gui.crashMessage.label": "Опа! Нещо се обърка",
    "gui.crashMessage.description": "Много съжаляваме, но изглежда Scratch се повреди. Тази неизправност е докладвана на екипа отговорен за Scratch. Презаредете страницата и опитайте отново.",
    "gui.crashMessage.errorNumber": "Грешката ви беше записана с id {errorId}",
    "gui.crashMessage.reload": "Презареди",
    "gui.customProcedures.myblockModalTitle": "Създаване на блок",
    "gui.customProcedures.addAnInputNumberText": "Добави поле за въвеждане",
    "gui.customProcedures.numberTextType": "число или текст",
    "gui.customProcedures.addAnInputBoolean": "Добави поле за въвеждане",
    "gui.customProcedures.booleanType": "да-не въвеждане",
    "gui.customProcedures.addALabel": "Добавяне на етикет",
    "gui.customProcedures.runWithoutScreenRefresh": "Стартиране без обновяване на екрана",
    "gui.customProcedures.cancel": "Отказ",
    "gui.customProcedures.ok": "Добре",
    "gui.SpriteInfo.direction": "Посока",
    "gui.directionPicker.rotationStyles.allAround": "Пълно завъртане",
    "gui.directionPicker.rotationStyles.leftRight": "Ляво/Дясно",
    "gui.directionPicker.rotationStyles.dontRotate": "Без въртене",
    "gui.gui.addExtension": "Добавяне на разширение",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Фонове",
    "gui.gui.costumesTab": "Костюми",
    "gui.gui.soundsTab": "Звуци",
    "gui.extensionLibrary.comingSoon": "Очаквайте скоро",
    "gui.extensionLibrary.requires": "Изисква",
    "gui.extensionLibrary.collaboration": "В партньорство с ",
    "gui.library.filterPlaceholder": "Търсене",
    "gui.library.allTag": "Всички",
    "gui.loader.message1": "Създаване на блокчетата…",
    "gui.loader.message2": "Зареждане на спрайтове…",
    "gui.loader.message3": "Зареждане на звукове…",
    "gui.loader.message4": "Зареждане на разширенията…",
    "gui.loader.message5": "Събиране на котките…",
    "gui.loader.message6": "Предаване на нанота …",
    "gui.loader.message7": "Надуване на гобота ...",
    "gui.loader.message8": "Подготвяне на емоджитата…",
    "gui.loader.headline": "Зареждане на проекта",
    "gui.loader.creating": "Създай Проект",
    "gui.accountMenu.profile": "Профил",
    "gui.accountMenu.myStuff": "Моите неща",
    "gui.accountMenu.myClasses": "Моите класове",
    "gui.accountMenu.myClass": "Моят клас",
    "gui.accountMenu.accountSettings": "Настройки на акаунта",
    "gui.accountMenu.signOut": "Изход",
    "gui.authorInfo.byUser": "от {username}",
    "gui.menuBar.seeProjectPage": "Виж Страницата на Проекта",
    "gui.menuBar.language": "Language",
    "general.username": "Потребителско име",
    "general.password": "Парола",
    "general.signIn": "Вход",
    "login.needHelp": "Имате нужда от помощ?",
    "form.validationRequired": "Това поле е задължително",
    "gui.menuBar.tutorialsLibrary": "Обучения",
    "gui.menuBar.restoreSprite": "Възстанови Спрайта",
    "gui.menuBar.restoreSound": "Възстанови звука",
    "gui.menuBar.restoreCostume": "Възстанови костюма",
    "gui.menuBar.restore": "Възстанови",
    "gui.menuBar.saveNow": "Записване сега",
    "gui.menuBar.saveAsCopy": "Записване като копие",
    "gui.menuBar.remix": "Ремиксиране",
    "gui.menuBar.new": "Нов",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Запиши на вашия компютър",
    "gui.menuBar.edit": "Редактиране",
    "gui.menuBar.turboModeOff": "Изключи Turbo mode",
    "gui.menuBar.turboModeOn": "Включи Turbo mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Присъединяване в Scratch",
    "gui.menuBar.signIn": "Вход",
    "gui.gui.projectTitlePlaceholder": "Заглавие на проекта тук",
    "gui.menuBar.saveNowLink": "Записване Сега",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Споделено",
    "gui.menuBar.share": "Споделяне",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Помощ",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(празен)",
    "gui.monitor.listMonitor.listLength": "дължина {length}",
    "gui.monitor.contextMenu.default": "нормално изписване",
    "gui.monitor.contextMenu.large": "уголемено изписване",
    "gui.monitor.contextMenu.slider": "плъзгач",
    "gui.monitor.contextMenu.sliderRange": "промяна на обхвата на плъзгача",
    "gui.monitor.contextMenu.import": "импорт",
    "gui.monitor.contextMenu.export": "експорт",
    "gui.monitor.contextMenu.hide": "скрий се",
    "gui.playButton.play": "Пускане",
    "gui.playButton.stop": "Спиране",
    "gui.gui.variableScopeOptionAllSprites": "За всички спрайтове",
    "gui.gui.variableScopeOptionSpriteOnly": "Само за този спрайт",
    "gui.gui.cloudVariableOption": "Облачна променлива (съхранявана на сървър)",
    "gui.gui.variablePromptAllSpritesMessage": "Тази променлива ще бъде достъпна за всички спрайтове.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Отказ",
    "gui.prompt.ok": "Добре",
    "gui.playbackStep.stopMsg": "Спиране",
    "gui.playbackStep.playMsg": "Пускане",
    "gui.playbackStep.loadingMsg": "Зареждане…",
    "gui.playbackStep.saveMsg": "Запазване",
    "gui.playbackStep.reRecordMsg": "Презапис",
    "gui.recordModal.title": "Запиши звук",
    "gui.recordingStep.beginRecord": "Започни запис, като натиснеш бутона по-долу.",
    "gui.recordingStep.permission": "{arrow}Трябва ни Вашето разрешение, за да използваме микрофона Ви",
    "gui.recordingStep.stop": "Спри записа",
    "gui.recordingStep.record": "Запис",
    "gui.sliderModal.min": "Минимална стойност",
    "gui.sliderModal.max": "Максимална стойност",
    "gui.sliderModal.title": "Промяна на обхвата на плъзгача",
    "gui.sliderPrompt.cancel": "Отказ",
    "gui.sliderPrompt.ok": "Добре",
    "gui.soundEditor.sound": "Звук",
    "gui.soundEditor.play": "Пускане",
    "gui.soundEditor.stop": "Спиране",
    "gui.soundEditor.copy": "Копиране",
    "gui.soundEditor.paste": "Поставяне",
    "gui.soundEditor.copyToNew": "Копиране в Нов",
    "gui.soundEditor.delete": "Изтриване",
    "gui.soundEditor.save": "Запазване",
    "gui.soundEditor.undo": "Отмяна",
    "gui.soundEditor.redo": "Повтаряне",
    "gui.soundEditor.faster": "По-бързо",
    "gui.soundEditor.slower": "По-бавно",
    "gui.soundEditor.echo": "Ехо",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "По-силно",
    "gui.soundEditor.softer": "По-меко",
    "gui.soundEditor.reverse": "Размени",
    "gui.soundEditor.fadeOut": "Затихване",
    "gui.soundEditor.fadeIn": "Засилване",
    "gui.soundEditor.mute": "Без звук",
    "gui.SpriteInfo.spritePlaceholder": "Име",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Показване",
    "gui.SpriteInfo.size": "Размер",
    "gui.spriteSelectorItem.contextMenuDuplicate": "копиране",
    "gui.spriteSelectorItem.contextMenuExport": "експорт",
    "gui.spriteSelectorItem.contextMenuDelete": "изтриване",
    "gui.spriteSelector.addSpriteFromLibrary": "Избор на спрайт",
    "gui.spriteSelector.addSpriteFromPaint": "Нарисувай",
    "gui.spriteSelector.addSpriteFromSurprise": "Изненада",
    "gui.spriteSelector.addSpriteFromFile": "Качи Спрайт",
    "gui.stageHeader.stageSizeLarge": "Превключване към голяма сцена",
    "gui.stageHeader.stageSizeSmall": "Превключване към малка сцена",
    "gui.stageHeader.stageSizeFull": "Влизане в режим \"Full screen\"",
    "gui.stageHeader.stageSizeUnFull": "Излизане от режим \"Full screen\"",
    "gui.stageHeader.fullscreenControl": "Цял Екран",
    "gui.spriteSelector.addBackdropFromLibrary": "Избор на фон",
    "gui.stageSelector.addBackdropFromPaint": "Нарисувай",
    "gui.stageSelector.addBackdropFromSurprise": "Изненада",
    "gui.stageSelector.addBackdropFromFile": "Качи Декор",
    "gui.stageSelector.stage": "Сцена",
    "gui.stageSelector.backdrops": "Фонове",
    "gui.telemetryOptIn.label": "Пращайте статистики, за да подобряваме Scratch",
    "gui.telemetryOptIn.body1": "Екипът на Scratch винаги се опитва да да разбере как Scratch се използва навсякъде по света. За да помогнете за това, можете да разрешите на Scratch автоматично да изпраща информация относно използването му към екипът на Scratch.",
    "gui.telemetryOptIn.body2": "Информацията, която събираме съдържа избор на език, използване на блокове и неща като запазване, зареждане и качване на проект. НЕ събираме никаква лична информация. Моля вижте нашата {privacyPolicyLink} за повече информация.",
    "gui.telemetryOptIn.privacyPolicyLink": "Декларация за поверителност",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Активиране на телеметрията",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Деактивиране на телеметрията",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Затвори",
    "gui.turboMode.active": "Режим Турбо",
    "gui.webglModal.label": "Браузърът не поддържа WebGL",
    "gui.webglModal.description": "Изглежда браузърът или компютърът Ви {webGlLink}, а Scratch 3.0 се нуждае от тази технология, за да работи.",
    "gui.webglModal.webgllink": "не поддържа WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "За да научите повече, разгледайте {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "ЧЗВ",
    "gui.costumeLibrary.chooseABackdrop": "Избор на фон",
    "gui.costumeLibrary.chooseACostume": "Избор на костюм",
    "gui.costumeTab.addBackdropFromLibrary": "Избор на фон",
    "gui.costumeTab.addCostumeFromLibrary": "Избор на костюм",
    "gui.costumeTab.addBlankCostume": "Нарисувай",
    "gui.costumeTab.addSurpriseCostume": "Изненада",
    "gui.costumeTab.addFileBackdrop": "Качи Декор",
    "gui.costumeTab.addFileCostume": "Качи Костюм",
    "gui.extensionLibrary.chooseAnExtension": "Избери разширение",
    "gui.extensionLibrary.extensionUrl": "Въведете URL адреса на разширението",
    "gui.monitors.importListColumnPrompt": "Коя колона трябва да бъде използвана (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Записването не можа да започне",
    "gui.soundLibrary.chooseASound": "Избор на звук",
    "gui.soundTab.fileUploadSound": "Качване на звук",
    "gui.soundTab.surpriseSound": "Изненада",
    "gui.soundTab.recordSound": "Запис",
    "gui.soundTab.addSoundFromLibrary": "Избор на звук",
    "gui.spriteLibrary.chooseASprite": "Избор на картинка",
    "gui.tipsLibrary.tutorials": "Избери Урок",
    "gui.alerts.createsuccess": "Създаден е нов проект.",
    "gui.alerts.createcopysuccess": "Проектът бе запазен като копие.",
    "gui.alerts.createremixsuccess": "Проектът бе запазен като ремикс.",
    "gui.alerts.creating": "Създаване на нов...",
    "gui.alerts.creatingCopy": "Проектът се копира...",
    "gui.alerts.creatingRemix": "Проектът се ремиксира...",
    "gui.alerts.creatingError": "Проектът не можа да се създаде. Моля опитайте пак!",
    "gui.alerts.savingError": "Проектът не можа да се запази.",
    "gui.alerts.savesuccess": "Проектът е записан.",
    "gui.alerts.saving": "Запис проект...",
    "gui.alerts.cloudInfo": "Моля помнете, че клауд променливите могат да съдържат само числа, без букви и символи.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Научи повече",
    "gui.alerts.importing": "Импортиране...",
    "gui.defaultProject.meow": "Мяу",
    "gui.defaultProject.variable": "моята променлива",
    "gui.howtos.intro-move-sayhello-hat.name": "Първи стъпки",
    "gui.howtos.intro-move.step_stepMove": "Добави блок за движение",
    "gui.howtos.add-a-move-block.step_stepSay": "Добави блок за говор",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Натисни зеленото знаме за старт",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Анимирано име",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Вземи Спрайт-Буква",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Пусни Звук, Когато е Кликнато",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Вземи Друг Спрайт-Буква",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Промени цвета",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Вземи Друг Спрайт-Буква & Го Завърти",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Вземи Друг Спрайт-Буква & Го Уголеми",
    "gui.howtos.imagine": "Представи си Свят",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Въведи това, което искаш да каже",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Натисни зеленото знаме за старт",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Избери фон",
    "gui.howtos.imagine.step_imagineChooseSprite": "Избери спрайт",
    "gui.howtos.imagine.step_imagineFlyAround": "Натисни \"интервал\", за плъзгане",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Избери друг спрайт",
    "gui.howtos.imagine.step_imagineLeftRight": "Движение Ляво-Дясно",
    "gui.howtos.imagine.step_imagineUpDown": "Движение Нагоре-Надолу",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Смяна на Костюми",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Плъзни до точка",
    "gui.howtos.imagine.step_imagineGrowShrink": "Порастване и Смаляване",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Избори друг фон",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Смени Фоновете",
    "gui.howtos.imagine.step_imagineRecordASound": "Добави Звук",
    "gui.howtos.imagine.step_imagineChooseSound": "Избори Твоя Звук",
    "gui.howtos.make-music.name": "Правете музика",
    "gui.howtos.Make-Music.step_PickInstrument": "Вземи Спрайт-Музикален инструмент",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Пусни Звук, Когато е Кликнато",
    "gui.howtos.Make-Music.step_MakeSong": "Създай песен",
    "gui.howtos.make-music.step_MakeBeat": "Избери Барабан & Направи Тон",
    "gui.howtos.make-music.step_MakeBeatBox": "Избери Спрайтът Микрофон & Изненадващ Бийтбокс",
    "gui.howtos.story.name": "Измисли История",
    "gui.howtos.story.step_addbg": "Добави Декор",
    "gui.howtos.story.step_addsprite": "Добави Герой",
    "gui.howtos.story.step_saysomething": "Кажи нещо",
    "gui.howtos.story.step_addanothersprite": "Добави Друг Герой",
    "gui.howtos.story.step_flip": "Обърни се на 180 градуса",
    "gui.howtos.story.step_conversation": "Разговаряй",
    "gui.howtos.story.addanotherbg": "Добави Друг Декор",
    "gui.howtos.story.step_swithbg": "Смени Фоновете",
    "gui.howtos.story.step_hidewizard": "Скрий Герой",
    "gui.howtos.story.step_showwizard": "Покажи Герой",
    "gui.howtos.make-a-chase-game.name": "Направи Игра с Гонене",
    "gui.howtos.Chase-Game.step_BG": "Добави Декор",
    "gui.howtos.chase-game.step_AddOcto": "Добави Спрайт",
    "gui.howtos.make-music.step_LeftRight": "Движи се Надясно & Наляво Със Стрелките",
    "gui.howtos.Chase-Game.step_UpDown": "Движи се Нагоре & Надолу Със Стрелките",
    "gui.howtos.Chase-Game.step_AddStar": "Добави Друг Спрайт",
    "gui.howtos.Chase-Game.step_MoveRandom": "Движи се Случайно",
    "gui.howtos.Chase-Game.step_WhenTouch": "В Спрайта Октопод, когато Докоснете Изсвирете Звук ",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Направи Променлива за Резултат",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "В Спрайта Октопод, когато Докоснете Добавете Резултат",
    "gui.howtos.animate-char.name": "Анимирай Герой",
    "gui.howtos.animate-char.step_addbg": "Добави Декор",
    "gui.howtos.animate-char.step_addsprite": "Добави Спрайт",
    "gui.howtos.animate-char.step_saysomething": "Кажи нещо",
    "gui.howtos.animate-char.step_addsound": "Добави Звук",
    "gui.howtos.animate-char.step_animatetalking": "Анимирай Говорене",
    "gui.howtos.animate-char.step_arrowkeys": "Движи се със Стрелките",
    "gui.howtos.animate-char.step_jump": "Скочи",
    "gui.howtos.animate-char.step_changecolor": "Промени цвета",
    "gui.howtos.make-a-game.name": "Направи Клик Игра",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Избери Спрайт",
    "gui.howtos.make-a-game.step_GamePlaySound": "Пусни Звук, Когато е Кликнато",
    "gui.howtos.make-a-game.step_GameAddScore": "Направи Променлива за Резултат",
    "gui.howtos.make-a-game.step_GameChangeScore": "Когато е Кликнато, Повиши Резултата",
    "gui.howtos.make-a-game.step_Random": "Отиди до случайна позиция",
    "gui.howtos.make-music.step_GameChangeColor": "Промени цвета",
    "gui.howtos.make-music.step_ResetScore": "Нулирай Резултата",
    "gui.howtos.make-it-fly.name": "Нека полети",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Избор на небесен фон",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Избери Герой",
    "gui.howtos.fly.step_stepflySaySomething": "Кажи нещо",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Движи със стрелките",
    "gui.howtos.fly.step_stepflyChooseObject": "Избери Обект за Събиране",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Придвижи Обект",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Избери товя Герой",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Добави Резултат",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Запази Резултата",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Добави Пейзаж",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Помести Пейзаж",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Следващ костюм",
    "gui.howtos.pong": "Игра на Понг",
    "gui.howtos.pong.step_pongAddBackdrop": "Добави Декор",
    "gui.howtos.pong.step_pongAddBallSprite": "Добави Спрайт Топка",
    "gui.howtos.pong.step_pongBounceAround": "Подскачай Наоколо",
    "gui.howtos.pong.step_pongAddPaddle": "Добави Гребло",
    "gui.howtos.pong.step_pongMoveThePaddle": "Помести Гребло",
    "gui.howtos.pong.step_pongSelectBallSprite": "Избери Спрайтът Топка",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Добави Код за да Отскоти Топката от Греблото",
    "gui.howtos.pong.step_pongAddAScore": "Добави Резултат",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Избери 'Резултат' от Менюто",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Добави Блокът 'Промени Резултат'",
    "gui.howtos.pong.step_pongResetScore": "Нулирай Резултата",
    "gui.howtos.pong.step_pongAddLineSprite": "Добави Спрайт Линия",
    "gui.howtos.pong.step_pongGameOver": "Край на играта",
    "gui.howtos.code-cartoon": "Накоди анимация",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Кажи Нещо, Когато Натиснеш Зеления Флаг",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Анимирай Герой Когато го Натиснеш",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Избери Друг Герой",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Използвай минус, за Смаляване",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Накарай Герой да се Смалява и Уголемява",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Избери Друг Герой",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Скачай Нагоре-Надолу",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Натисни Герой за да Смениш Сцените",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Плъзгай се Наоколо",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Смяна на Костюми",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Избери Още Герои и ги Добави в Твоята Анимация",
    "gui.howtos.cartoon-network": "Анимирай Приключенска Игра",
    "gui.howtos.cartoon-network.step_CNcharacter": "Избери Герой, който да се Покаже",
    "gui.howtos.cartoon-network.step_CNsay": "Кажи нещо",
    "gui.howtos.cartoon-network.step_CNglide": "Плсъзай се Наоколо",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Избери Обект за Гонене",
    "gui.howtos.cartoon-network.step_CNcollect": "Събирай Обекти",
    "gui.howtos.cartoon-network.step_CNvariable": "Направи Променлива за Резултат",
    "gui.howtos.cartoon-network.step_CNscore": "Запази Резултата",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Следващо Ниво: Смени Фона",
    "gui.howtos.videosens.name": "Видео Усет",
    "gui.howtos.videosens.step_addextension": "Добавяне на разширение",
    "gui.howtos.videosens.step_pet": "Погали котката",
    "gui.howtos.videosens.step_animate": "Анимирай",
    "gui.howtos.videosens.step_pop": "Спукай Балон",
    "gui.howtos.say-it-out-loud": "Направи Анимации, Които Говорят",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Добави Текст за Изговаряне блоковете",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Кажи нещо",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Задай звук",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Движи се Наоколо",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Добави Декор",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Добави Друг Герой",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Направи Песен",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Промени цвета",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Върти се Наоколо",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Порастване и Смаляване",
    "gui.howtos.talking": "Говорещи приказки",
    "gui.howtos.talking.step_talesAddExtension": "Натисни за да Добавиш Текст-към-Реч Блокчета",
    "gui.howtos.talking.step_talesChooseSprite": "Избор на спрайт",
    "gui.howtos.talking.step_talesSaySomething": "Накарай Герой да Говори",
    "gui.howtos.talking.step_talesChooseBackdrop": "Избор на фон",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Натисни Герой за да Отидеш до Следващия Декор",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Избери друг спрайт",
    "gui.howtos.talking.step_talesMoveAround": "Движи се Наоколо",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Избори друг фон",
    "gui.howtos.talking.step_talesAnimateTalking": "Анимирай Говорене",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Избори друг фон",
    "gui.howtos.talking.step_talesChooseSound": "Избери Песен за Танци",
    "gui.howtos.talking.step_talesDanceMoves": "Танцувални Движения",
    "gui.howtos.talking.step_talesAskAnswer": "Вземете блокове за Въпрос и Отговор от Категория на сензорите",
    "gui.howtos.add-sprite.name": "Добави Спрайт",
    "gui.howtos.add-sprite.step_addSprite": "Добави Спрайт",
    "gui.howtos.add-a-backdrop.name": "Добави Декор",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Добави Декор",
    "gui.howtos.change-size.name": "Промени Размера",
    "gui.howtos.change-size.step_changeSize": "Промени Размера",
    "gui.howtos.glide-around.name": "Плъзгай се Наоколо",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Плъзгай се Наоколо",
    "gui.howtos.change-size.step_glideAroundPoint": "Плъзни до точка",
    "gui.howtos.record-a-sound.name": "Запиши Звук",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Натисни на Таб 'Звуци'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Кликни \"Запис\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Натисни бутона Запис",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Избори Твоя Звук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Пусни твоя звук",
    "gui.howtos.spin-video.name": "Завърти Го",
    "gui.howtos.change-size.step_spinTurn": "Завърти се",
    "gui.howtos.change-size.step_spinPointInDirection": "Задай посока",
    "gui.howtos.hide-and-show.name": "Покажи се и се Скрий",
    "gui.howtos.change-size.step_hideAndShow": "Покажи се и се Скрий",
    "gui.howtos.switch-costume.name": "Анимирай Спрайт",
    "gui.howtos.change-size.step_switchCostumes": "Анимирай Спрайт",
    "gui.howtos.move-around-with-arrow-keys.name": "Използвай Стрелките",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Движение наляво и надясно",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Движи се Нагоре и Надолу",
    "gui.howtos.add-effects.name": "Добави Ефекти",
    "gui.howtos.videosens.step_addEffects": "Добави Ефекти",
    "gui.extension.music.name": "Музика",
    "gui.extension.music.description": "Изсвирете с инструменти и барабани.",
    "gui.extension.pen.name": "Молив",
    "gui.extension.pen.description": "Рисувайте с вашите спрайтове.",
    "gui.extension.videosensing.name": "Видео Усет",
    "gui.extension.videosensing.description": "Доловете движение с камерата.",
    "gui.extension.text2speech.name": "Текст за Произнасяне",
    "gui.extension.text2speech.description": "Накарай проектите си да говорят.",
    "gui.extension.translate.name": "Преведи",
    "gui.extension.translate.description": "Превеждай текст на много езици.",
    "gui.extension.makeymakey.description": "Направи всичко на клавиш.",
    "gui.extension.microbit.description": "Свържи проектите си със света.",
    "gui.extension.microbit.connectingMessage": "Свързване",
    "gui.extension.ev3.description": "Построй интерактивни роботи и други неща.",
    "gui.extension.ev3.connectingMessage": "Свързване. Уверете се, че кода на Вашия EV3 е настроен на 1234.",
    "gui.extension.boost.description": "Вдъхни живот на роботите.",
    "gui.extension.boost.connectingMessage": "Свързване",
    "gui.extension.wedo2.description": "Направи ги с мотори и сензори.",
    "gui.extension.wedo2.connectingMessage": "Свързване",
    "gui.extension.gdxfor.description": "Сензор за натиск, опън,  движете, и въртете.",
    "gui.extension.gdxfor.connectingMessage": "Свързване",
    "gui.libraryTags.all": "Всички",
    "gui.libraryTags.animals": "Животни",
    "gui.libraryTags.dance": "Танци",
    "gui.libraryTags.effects": "Ефекти",
    "gui.libraryTags.fantasy": "Фантастика",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Храни",
    "gui.libraryTags.indoors": "На закрито",
    "gui.libraryTags.loops": "Цикли",
    "gui.libraryTags.music": "Музика",
    "gui.libraryTags.notes": "Бележки",
    "gui.libraryTags.outdoors": "На открито",
    "gui.libraryTags.patterns": "Шаблони",
    "gui.libraryTags.people": "Хора",
    "gui.libraryTags.percussion": "Перкусионни",
    "gui.libraryTags.space": "Космос",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Подводни",
    "gui.libraryTags.voice": "Гласове",
    "gui.libraryTags.wacky": "Шантави",
    "gui.libraryTags.animation": "Анимации",
    "gui.libraryTags.art": "Изкуство",
    "gui.libraryTags.games": "Игри",
    "gui.libraryTags.stories": "Истории",
    "gui.libraryTags.letters": "Букви",
    "gui.opcodeLabels.direction": "посока",
    "gui.opcodeLabels.xposition": "x позиция",
    "gui.opcodeLabels.yposition": "y позиция",
    "gui.opcodeLabels.size": "размер",
    "gui.opcodeLabels.costumename": "име на костюм",
    "gui.opcodeLabels.costumenumber": "номер на костюм",
    "gui.opcodeLabels.backdropname": "име на декор",
    "gui.opcodeLabels.backdropnumber": "декор номер",
    "gui.opcodeLabels.volume": "сила на звука",
    "gui.opcodeLabels.tempo": "темпо",
    "gui.opcodeLabels.answer": "отговор",
    "gui.opcodeLabels.loudness": "шумно",
    "gui.opcodeLabels.username": "потребителско име",
    "gui.opcodeLabels.year": "година",
    "gui.opcodeLabels.month": "месец",
    "gui.opcodeLabels.date": "дата",
    "gui.opcodeLabels.dayofweek": "ден от седмицата",
    "gui.opcodeLabels.hour": "час",
    "gui.opcodeLabels.minute": "минута",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Проектът, който бе избран, не можа да се зареди.",
    "gui.sharedMessages.backdrop": "декор {index}",
    "gui.sharedMessages.costume": "костюм {index}",
    "gui.sharedMessages.sprite": "Спрайт {index}",
    "gui.sharedMessages.pop": "пук",
    "gui.sharedMessages.replaceProjectWarning": "Да се замени ли съдържанието от текущия проект?",
    "gui.sharedMessages.loadFromComputerTitle": "Зареди от своя компютър",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Проект",
    "boost.color.any": "който и да е цвят",
    "boost.color.black": "черно",
    "boost.color.blue": "синьо",
    "boost.color.green": "зелено",
    "boost.color.red": "червено",
    "boost.color.white": "бяло",
    "boost.color.yellow": "жълто",
    "boost.getMotorPosition": "мотор [MOTOR_REPORTER_ID] на позиция ",
    "boost.getTiltAngle": "наклон на ъгъла [TILT_DIRECTION]",
    "boost.motorDirection.backward": "назад",
    "boost.motorDirection.forward": "напред",
    "boost.motorDirection.reverse": "обръщане",
    "boost.motorOff": "изключи мотор [MOTOR_ID] ",
    "boost.motorOn": "включи мотор [MOTOR_ID]",
    "boost.motorOnFor": "включи мотор [MOTOR_ID] за [DURATION] секунди",
    "boost.motorOnForRotation": "включи мотор [MOTOR_ID] за [ROTATION] оборота",
    "boost.seeingColor": "виждам [COLOR] тухла?",
    "boost.setLightHue": "направи светлината на цвета на [HUE]",
    "boost.setMotorDirection": "задай на мотор [MOTOR_ID] посока [MOTOR_DIRECTION]",
    "boost.setMotorPower": "задай скоростта на мотор [MOTOR_ID] на [POWER] %",
    "boost.tiltDirection.any": "който и да е",
    "boost.tiltDirection.down": "надолу",
    "boost.tiltDirection.left": "наляво",
    "boost.tiltDirection.right": "надясно",
    "boost.tiltDirection.up": "нагоре",
    "boost.whenColor": "когато се вижда тухла с цвят [COLOR] ",
    "boost.whenTilted": "при наклон [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "изсвири тон [NOTE] за [TIME] секунди",
    "ev3.buttonPressed": "бутон [PORT] натиснат ли е?",
    "ev3.getBrightness": "яркост",
    "ev3.getDistance": "разстояние",
    "ev3.getMotorPosition": "позиция на мотор [PORT]",
    "ev3.motorSetPower": "мотор [PORT] направи мощност на [POWER] %",
    "ev3.motorTurnClockwise": "моторът [PORT] се върти по часовника за [TIME] секунди",
    "ev3.motorTurnCounterClockwise": "моторът [PORT] се върти обратно на часовника за [TIME] секунди",
    "ev3.whenBrightnessLessThan": "когато яркост < [DISTANCE]",
    "ev3.whenButtonPressed": "когато бутон [PORT] е натиснат",
    "ev3.whenDistanceLessThan": "когато дистанция < [DISTANCE]",
    "gdxfor.getAcceleration": "ускорение [DIRECTION]",
    "gdxfor.getForce": "сила",
    "gdxfor.getSpin": "скорост на въртене [DIRECTION]",
    "gdxfor.getTilt": "наклон на ъгъла [TILT]",
    "gdxfor.isFreeFalling": "падане? ",
    "gdxfor.isTilted": "наклон [TILT]?",
    "gdxfor.pulled": "издърпан",
    "gdxfor.pushed": "натиснат",
    "gdxfor.shaken": "разтърсен",
    "gdxfor.startedFalling": "започна да пада",
    "gdxfor.tiltDirectionMenu.any": "който и да е",
    "gdxfor.tiltDirectionMenu.back": "отзад",
    "gdxfor.tiltDirectionMenu.front": "отпред",
    "gdxfor.tiltDirectionMenu.left": "ляво",
    "gdxfor.tiltDirectionMenu.right": "дясно",
    "gdxfor.turnedFaceDown": "обърната с лицето надолу",
    "gdxfor.turnedFaceUp": "обърната с лицето нагоре",
    "gdxfor.whenForcePushedOrPulled": "когато сензор за сила [PUSH_PULL]",
    "gdxfor.whenGesture": "когато [GESTURE]",
    "gdxfor.whenTilted": "при наклон [TILT]",
    "makeymakey.downArrow": "стрелка надолу",
    "makeymakey.downArrowShort": "надолу",
    "makeymakey.leftArrow": "лява стрелка",
    "makeymakey.leftArrowShort": "наляво",
    "makeymakey.rightArrow": "дясна стрелка",
    "makeymakey.rightArrowShort": "надясно",
    "makeymakey.spaceKey": "интервал",
    "makeymakey.upArrow": "стрелка нагоре",
    "makeymakey.upArrowShort": "нагоре",
    "makeymakey.whenKeyPressed": "когато е натиснат клавиш [KEY]",
    "makeymakey.whenKeysPressedInOrder": "когато [SEQUENCE] е натисната последователно",
    "microbit.buttonsMenu.any": "произволен",
    "microbit.clearDisplay": "изчисти екрана",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "покажи [MATRIX]",
    "microbit.displayText": "покажи текст [TEXT]",
    "microbit.gesturesMenu.jumped": "подхвърлен",
    "microbit.gesturesMenu.moved": "преместен",
    "microbit.gesturesMenu.shaken": "разтърсен",
    "microbit.isButtonPressed": "[BTN] бутон натиснат ли е?",
    "microbit.isTilted": "наклонен [DIRECTION]?",
    "microbit.pinStateMenu.off": "изключено",
    "microbit.pinStateMenu.on": "включено",
    "microbit.tiltAngle": "наклон на ъгъла [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "произволен",
    "microbit.tiltDirectionMenu.back": "отзад",
    "microbit.tiltDirectionMenu.front": "отпред",
    "microbit.tiltDirectionMenu.left": "наляво",
    "microbit.tiltDirectionMenu.right": "надясно",
    "microbit.whenButtonPressed": "когато [BTN] бутон е натиснат",
    "microbit.whenGesture": "когато [GESTURE]",
    "microbit.whenPinConnected": "когато пин [PIN] е свързан",
    "microbit.whenTilted": "при наклон [DIRECTION]",
    "music.categoryName": "Музика",
    "music.changeTempo": "увеличи темпо с [TEMPO]",
    "music.drumBass": "(2) Бас Барабан",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клавес",
    "music.drumClosedHiHat": "(6) Затворен педален чинел",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Пастирски Звънец",
    "music.drumCrashCymbal": "(4) Краш чинел",
    "music.drumCuica": "(18) Куика",
    "music.drumGuiro": "(16) Гуиро",
    "music.drumHandClap": "(8) Ръкопляскане",
    "music.drumOpenHiHat": "(5) Отворен педален чинел",
    "music.drumSideStick": "(3) Малък барабан",
    "music.drumSnare": "(1) Малък Барабан",
    "music.drumTambourine": "(7) Дайре",
    "music.drumTriangle": "(12) Триъгълник",
    "music.drumVibraslap": "(17) Вибраслап",
    "music.drumWoodBlock": "(10) Дървени Блокчета",
    "music.getTempo": "темпо",
    "music.instrumentBass": "(6) Контрабас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Виолончело",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларинет",
    "music.instrumentElectricGuitar": "(5) Електрическа Китара",
    "music.instrumentElectricPiano": "(2) Електрическо Пиано",
    "music.instrumentFlute": "(12) Флейта",
    "music.instrumentGuitar": "(4) Китара",
    "music.instrumentMarimba": "(19) Маримба",
    "music.instrumentMusicBox": "(17) Музикална Кутия",
    "music.instrumentOrgan": "(3) Орган",
    "music.instrumentPiano": "(1) Пиано",
    "music.instrumentPizzicato": "(7) Пицикато",
    "music.instrumentSaxophone": "(11) Саксофон",
    "music.instrumentSteelDrum": "(18) Стилпан",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Полисинтезатор",
    "music.instrumentTrombone": "(9) Тромбон",
    "music.instrumentVibraphone": "(16) Вибрафон",
    "music.instrumentWoodenFlute": "(13) Дървена Флейта",
    "music.midiPlayDrumForBeats": "изсвири барабан [DRUM] за [BEATS] времена",
    "music.midiSetInstrument": "задай инструмента на [INSTRUMENT]",
    "music.playDrumForBeats": "изсвири барабан [DRUM] за [BEATS] времена",
    "music.playNoteForBeats": "изсвири нота [NOTE] за [BEATS] времена",
    "music.restForBeats": "спри за [BEATS] времена",
    "music.setInstrument": "направи инструмента на [INSTRUMENT]",
    "music.setTempo": "направи темпо на [TEMPO]",
    "pen.categoryName": "Молив",
    "pen.changeColorParam": "промени [COLOR_PARAM] на молива с/ъс [VALUE]",
    "pen.changeHue": "промени цвета на молива с [HUE]",
    "pen.changeShade": "промени плътността на молива с/ъс [SHADE]",
    "pen.changeSize": "промени pen size by [SIZE]",
    "pen.clear": "изтрий всичко",
    "pen.colorMenu.brightness": "яркост",
    "pen.colorMenu.color": "цвят",
    "pen.colorMenu.saturation": "наситеност",
    "pen.colorMenu.transparency": "прозрачност",
    "pen.penDown": "молив долу",
    "pen.penUp": "молив горе",
    "pen.setColor": "направи цвета на молива [COLOR]",
    "pen.setColorParam": "направи [COLOR_PARAM] на молива на [VALUE]",
    "pen.setHue": "направи цвета на молива [HUE]",
    "pen.setShade": "направи яркостта на молива [SHADE]",
    "pen.setSize": "направи дебелината на молива [SIZE]",
    "pen.stamp": "отпечати",
    "speech.defaultWhenIHearValue": "старт",
    "speech.extensionName": "Изписване на Говор",
    "speech.listenAndWait": "слушай и чакай",
    "speech.speechReporter": "реч",
    "speech.whenIHear": "когато чуя [PHRASE]",
    "text2speech.alto": "нормален",
    "text2speech.categoryName": "Текст към Реч",
    "text2speech.defaultTextToSpeak": "здравей",
    "text2speech.giant": "великан",
    "text2speech.kitten": "коте",
    "text2speech.setLanguageBlock": "промени езика на [LANGUAGE]",
    "text2speech.setVoiceBlock": "направи звука на [VOICE]",
    "text2speech.speakAndWaitBlock": "кажи [WORDS]",
    "text2speech.squeak": "скърцане",
    "text2speech.tenor": "висок",
    "translate.categoryName": "Преведи",
    "translate.defaultTextToTranslate": "здравей",
    "translate.translateBlock": "преведи [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "език",
    "videoSensing.categoryName": "Видео Усет",
    "videoSensing.direction": "посока",
    "videoSensing.motion": "движение",
    "videoSensing.off": "изключено",
    "videoSensing.on": "включено",
    "videoSensing.onFlipped": "включи огледално",
    "videoSensing.setVideoTransparency": "направи плътност на видеото на [TRANSPARENCY]",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "сцена",
    "videoSensing.videoOn": "видео [ATTRIBUTE] на [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] видео",
    "videoSensing.whenMotionGreaterThan": "когато видео движение > [REFERENCE]",
    "wedo2.getDistance": "разстояние",
    "wedo2.getTiltAngle": "наклон на ъгъла [TILT_DIRECTION]",
    "wedo2.isTilted": "наклонен [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "натам",
    "wedo2.motorDirection.forward": "насам",
    "wedo2.motorDirection.reverse": "обръщане",
    "wedo2.motorId.a": "мотор A",
    "wedo2.motorId.all": "всички мотори",
    "wedo2.motorId.b": "Мотор B",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": "изключи [MOTOR_ID]",
    "wedo2.motorOn": "включи [MOTOR_ID]",
    "wedo2.motorOnFor": "включи [MOTOR_ID] за [DURATION] секунди",
    "wedo2.playNoteFor": "изсвири тон [NOTE] за [DURATION] секунди",
    "wedo2.setLightHue": "задай цвета на светлината на [HUE]",
    "wedo2.setMotorDirection": "задай на [MOTOR_ID] посока [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "направи мощност на [MOTOR_ID] на [POWER]",
    "wedo2.tiltDirection.any": "произволен",
    "wedo2.tiltDirection.down": "надолу",
    "wedo2.tiltDirection.left": "наляво",
    "wedo2.tiltDirection.right": "надясно",
    "wedo2.tiltDirection.up": "нагоре",
    "wedo2.whenDistance": "когато дистанция [OP] [REFERENCE]",
    "wedo2.whenTilted": "при наклон [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Цвят",
    "paint.paintEditor.saturation": "Наситеност",
    "paint.paintEditor.brightness": "Яркост",
    "paint.paintEditor.costume": "Костюм",
    "paint.paintEditor.group": "Групиране",
    "paint.paintEditor.ungroup": "Разгрупиране",
    "paint.paintEditor.undo": "Отмяна",
    "paint.paintEditor.redo": "Повтаряне",
    "paint.paintEditor.forward": "Напред",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "Отпред",
    "paint.paintEditor.back": "Отзад",
    "paint.paintEditor.more": "Още",
    "paint.modeTools.brushSize": "Размер",
    "paint.modeTools.eraserSize": "Размер на гумата",
    "paint.modeTools.copy": "Копиране",
    "paint.modeTools.paste": "Поставяне",
    "paint.modeTools.delete": "Изтриване",
    "paint.modeTools.curved": "Заоблен",
    "paint.modeTools.pointed": "Заострен",
    "paint.modeTools.thickness": "Дебелина",
    "paint.modeTools.flipHorizontal": "Хоризонтално обръщане",
    "paint.modeTools.flipVertical": "Вертикално обръщане",
    "paint.modeTools.filled": "Запълнен",
    "paint.modeTools.outlined": "Подчертан",
    "paint.paintEditor.bitmap": "Преобразуване в растерен режим",
    "paint.paintEditor.vector": "Преобразуване във векторен режим",
    "paint.paintEditor.fill": "Запълване",
    "paint.paintEditor.stroke": "Подчертаване",
    "paint.brushMode.brush": "Четка",
    "paint.eraserMode.eraser": "Гума",
    "paint.fillMode.fill": "Запълване",
    "paint.lineMode.line": "Линия",
    "paint.ovalMode.oval": "Окръжност",
    "paint.rectMode.rect": "Правоъгълник",
    "paint.reshapeMode.reshape": "Оформяне",
    "paint.roundedRectMode.roundedRect": "Заоблен правоъгълник",
    "paint.selectMode.select": "Маркиране",
    "paint.textMode.text": "Текст",
    "paint.colorPicker.swap": "Замяна"
  },
  "ca": {
    "gui.alerts.lostPeripheralConnection": "Scratch ha perdut la connexió amb {extensionName}.",
    "gui.alerts.tryAgain": "Torna-ho a intentar",
    "gui.alerts.download": "Descarrega",
    "gui.connection.reconnect": "Torna a connectar",
    "gui.backpack.costumeLabel": "vestit",
    "gui.backpack.soundLabel": "so",
    "gui.backpack.scriptLabel": "programa",
    "gui.backpack.spriteLabel": "personatge",
    "gui.backpack.header": "Motxilla",
    "gui.backpack.errorBackpack": "Error al carregar la motxilla",
    "gui.backpack.loadingBackpack": "Carregant...",
    "gui.backpack.more": "Més",
    "gui.backpack.emptyBackpack": "La motxilla està buida",
    "gui.unsupportedBrowser.label": "Aquest navegador no està suportat",
    "gui.unsupportedBrowser.errorLabel": "Hi ha hagut un error",
    "gui.unsupportedBrowser.notRecommended": "Ho sentim, però sembla que està utilitzant una versió del navegador que Scratch no suporta. Recomanem actualitzar a la versió més recent d'un navegador compatible com ara Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.description": "Ho sentim, però Scratch no és compatible amb aquest navegador. Recomanem actualitzar a la versió més recent d'un navegador compatible com ara Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.back": "Enrere",
    "gui.unsupportedBrowser.previewfaq": "Si vols saber-ne més, vés a la {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Preguntes freqüents",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Encongeix",
    "gui.cards.expand": "Desplega",
    "gui.cards.close": "Tanca",
    "gui.cards.more-things-to-try": "Més coses per provar!",
    "gui.cards.see-more": "Veure més",
    "gui.comingSoon.message1": "Hi estem treballant {emoji}",
    "gui.comingSoon.message2": "Properament...",
    "gui.comingSoon.message3": "Hi estem treballant {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No s'ha trobat cap dispositiu",
    "gui.connection.auto-scanning.prescan": "Situa el dispositiu a prop i llavors inicia la cerca.",
    "gui.connection.auto-scanning.pressbutton": "Prem el botó del teu dispositiu.",
    "gui.connection.auto-scanning.start-search": "Comença a buscar",
    "gui.connection.connecting-searchbutton": "Cercant...",
    "gui.connection.auto-scanning.try-again": "Prova de nou",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Connectat",
    "gui.connection.disconnect": "Desconnecta",
    "gui.connection.go-to-editor": "Vés a l'Editor",
    "gui.connection.connecting-cancelbutton": "Connectant...",
    "gui.connection.error.errorMessage": "Vaja, alguna cosa ha anat malament.",
    "gui.connection.error.tryagainbutton": "Prova de nou",
    "gui.connection.error.helpbutton": "Ajuda",
    "gui.connection.peripheral-name-label": "Nom del dispositiu",
    "gui.connection.connect": "Connecta",
    "gui.connection.scanning.lookingforperipherals": "Buscant dispositius",
    "gui.connection.scanning.noPeripheralsFound": "No s'ha trobat cap dispositiu",
    "gui.connection.scanning.instructions": "Selecciona el teu dispositiu a la llista de dalt.",
    "gui.connection.search": "Actualitza",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Comprova que has instal·lat l'Scratch Link i s'està executant",
    "gui.connection.unavailable.enablebluetooth": "Comprova que el Bluetooth està habilitat",
    "gui.connection.unavailable.tryagainbutton": "Prova de nou",
    "gui.connection.unavailable.helpbutton": "Ajuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Vés",
    "gui.controls.stop": "Atura",
    "gui.crashMessage.label": "Vaja! Alguna cosa ha anat malament.",
    "gui.crashMessage.description": "Ho sentim però sembla que l'Scratch ha fallat. Aquest error ha estat enviat a l'Equip de Scratch automàticament. Si us plau torna a carregar la pàgina per provar-ho de nou.",
    "gui.crashMessage.errorNumber": "El teu error ha estat registrat amb l'id {errorId}",
    "gui.crashMessage.reload": "Recarrega",
    "gui.customProcedures.myblockModalTitle": "Crea un bloc",
    "gui.customProcedures.addAnInputNumberText": "Afegeix una entrada",
    "gui.customProcedures.numberTextType": "nombre o text",
    "gui.customProcedures.addAnInputBoolean": "Afegeix una entrada",
    "gui.customProcedures.booleanType": "booleà",
    "gui.customProcedures.addALabel": "Afegeix una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Funciona sense refrescar la pantalla",
    "gui.customProcedures.cancel": "Cancel·la",
    "gui.customProcedures.ok": "D'acord",
    "gui.SpriteInfo.direction": "Direcció",
    "gui.directionPicker.rotationStyles.allAround": "Al voltant",
    "gui.directionPicker.rotationStyles.leftRight": "Esquerra/Dreta",
    "gui.directionPicker.rotationStyles.dontRotate": "No giris",
    "gui.gui.addExtension": "Afegeix una Extensió",
    "gui.gui.codeTab": "Codi",
    "gui.gui.backdropsTab": "Fons",
    "gui.gui.costumesTab": "Vestits",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Properament",
    "gui.extensionLibrary.requires": "Requisits",
    "gui.extensionLibrary.collaboration": "En col·laboració amb",
    "gui.library.filterPlaceholder": "Cerca",
    "gui.library.allTag": "Tots",
    "gui.loader.message1": "Creant blocs ...",
    "gui.loader.message2": "S'estan pujant els personatges ...",
    "gui.loader.message3": "S'estan pujant els sons ...",
    "gui.loader.message4": "Carregant les extensions ...",
    "gui.loader.message5": "Activant els personatges...",
    "gui.loader.message6": "Carregant: mans a la feina!",
    "gui.loader.message7": "Donant cos als personatges...",
    "gui.loader.message8": "Preparant emojis ...",
    "gui.loader.headline": "S'està carregant el projecte",
    "gui.loader.creating": "Creant projecte",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Les Meves Coses",
    "gui.accountMenu.myClasses": "Les meves classes",
    "gui.accountMenu.myClass": "La meva classe",
    "gui.accountMenu.accountSettings": "Configuració del compte",
    "gui.accountMenu.signOut": "Finalitza la sessió",
    "gui.authorInfo.byUser": "per {username}",
    "gui.menuBar.seeProjectPage": "Veure la pàgina del projecte",
    "gui.menuBar.language": "Language",
    "general.username": "Nom d'usuari",
    "general.password": "Contrasenya",
    "general.signIn": "Inicia la sessió",
    "login.needHelp": "Necessites ajuda?",
    "form.validationRequired": "Aquest camp és necessari",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Recupera el personatge",
    "gui.menuBar.restoreSound": "Recupera el so",
    "gui.menuBar.restoreCostume": "Recupera el vestit",
    "gui.menuBar.restore": "Recupera",
    "gui.menuBar.saveNow": "Desa ara",
    "gui.menuBar.saveAsCopy": "Desa una còpia",
    "gui.menuBar.remix": "Reinventa",
    "gui.menuBar.new": "Nou",
    "gui.menuBar.file": "Fitxer",
    "gui.menuBar.downloadToComputer": "Desa al teu ordinador",
    "gui.menuBar.edit": "Edita",
    "gui.menuBar.turboModeOff": "Desactiva el Mode Turbo",
    "gui.menuBar.turboModeOn": "Activa el Mode Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Mode normal",
    "gui.menuBar.caturdayMode": "Mode de gat",
    "gui.menuBar.joinScratch": "Uneix-te a l'Scratch",
    "gui.menuBar.signIn": "Inicia la sessió",
    "gui.gui.projectTitlePlaceholder": "Títol del projecte aquí",
    "gui.menuBar.saveNowLink": "Desa ara",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Compartit",
    "gui.menuBar.share": "Comparteix",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ajuda",
    "gui.modal.back": "Enrere",
    "gui.monitor.listMonitor.empty": "(buida)",
    "gui.monitor.listMonitor.listLength": "llargada {length}",
    "gui.monitor.contextMenu.default": "pantalla normal",
    "gui.monitor.contextMenu.large": "pantalla gran",
    "gui.monitor.contextMenu.slider": "lliscador",
    "gui.monitor.contextMenu.sliderRange": "canvia el rang del lliscador",
    "gui.monitor.contextMenu.import": "importa",
    "gui.monitor.contextMenu.export": "exporta",
    "gui.monitor.contextMenu.hide": "amaga't",
    "gui.playButton.play": "Reprodueix",
    "gui.playButton.stop": "Atura",
    "gui.gui.variableScopeOptionAllSprites": "Per a tots els personatges",
    "gui.gui.variableScopeOptionSpriteOnly": "Només per a aquest personatge",
    "gui.gui.cloudVariableOption": "Variable al núvol (emmagatzemada en el servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Aquesta variable estarà disponible per a tots els personatges.",
    "gui.gui.listPromptAllSpritesMessage": "Aquesta llista estarà disponible per a tots els sprites.",
    "gui.prompt.cancel": "Cancel·la",
    "gui.prompt.ok": "D'acord",
    "gui.playbackStep.stopMsg": "Atura",
    "gui.playbackStep.playMsg": "Reprodueix",
    "gui.playbackStep.loadingMsg": "Carregant...",
    "gui.playbackStep.saveMsg": "Desa",
    "gui.playbackStep.reRecordMsg": "Torna a gravar",
    "gui.recordModal.title": "Grava un so",
    "gui.recordingStep.beginRecord": "Comença la gravació fent clic al botó de sota",
    "gui.recordingStep.permission": "{arrow}Necessitem el teu permís per utilitzar el teu micròfon",
    "gui.recordingStep.stop": "Atura la gravació",
    "gui.recordingStep.record": "Enregistra",
    "gui.sliderModal.min": "valor mínim",
    "gui.sliderModal.max": "valor màxim",
    "gui.sliderModal.title": "Canvia el rang del lliscador",
    "gui.sliderPrompt.cancel": "Cancel·la",
    "gui.sliderPrompt.ok": "D'acord",
    "gui.soundEditor.sound": "So",
    "gui.soundEditor.play": "Reprodueix",
    "gui.soundEditor.stop": "Atura",
    "gui.soundEditor.copy": "Copia",
    "gui.soundEditor.paste": "Enganxa",
    "gui.soundEditor.copyToNew": "Copia en un nou so",
    "gui.soundEditor.delete": "Elimina",
    "gui.soundEditor.save": "Desa",
    "gui.soundEditor.undo": "Desfés",
    "gui.soundEditor.redo": "Torna-hi",
    "gui.soundEditor.faster": "Més ràpid",
    "gui.soundEditor.slower": "Més lent",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Més fort",
    "gui.soundEditor.softer": "Més fluix",
    "gui.soundEditor.reverse": "Inverteix",
    "gui.soundEditor.fadeOut": "Fosa de tancament",
    "gui.soundEditor.fadeIn": "Fosa d'obertura",
    "gui.soundEditor.mute": "Silencia",
    "gui.SpriteInfo.spritePlaceholder": "Nom",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Personatge",
    "gui.SpriteInfo.show": "Mostra",
    "gui.SpriteInfo.size": "Mida",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplica",
    "gui.spriteSelectorItem.contextMenuExport": "exporta",
    "gui.spriteSelectorItem.contextMenuDelete": "esborra",
    "gui.spriteSelector.addSpriteFromLibrary": "Tria un personatge",
    "gui.spriteSelector.addSpriteFromPaint": "Dibuixa",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Puja un personatge",
    "gui.stageHeader.stageSizeLarge": "Canvia a vista àmplia",
    "gui.stageHeader.stageSizeSmall": "Canvia a vista petita",
    "gui.stageHeader.stageSizeFull": "Canvia a mode Pantalla completa",
    "gui.stageHeader.stageSizeUnFull": "Surt del mode Pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control de pantalla completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Tria un fons",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Puja un fons",
    "gui.stageSelector.stage": "Escenari",
    "gui.stageSelector.backdrops": "Fons",
    "gui.telemetryOptIn.label": "Informa d'estadístiques per millorar Scratch",
    "gui.telemetryOptIn.body1": "L'equip Scratch sempre busca comprendre millor com s'utilitza Scratch a tot el món. Per ajudar a donar suport, podeu permetre que Scratch enviï automàticament informació d'ús a l'equip Scratch.",
    "gui.telemetryOptIn.body2": "La informació que recopilem inclou selecció de llenguatges, blocs d'ús i alguns esdeveniments, com desar, carregar i penjar un projecte. NO recopilem cap informació personal. Si us plau mireu la nostra {privacyPolicyLink} per a més informació.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de Privacitat",
    "gui.telemetryOptIn.optInText": "Comparteix les meves dades d'ús amb l'equip de Scratch",
    "gui.telemetryOptIn.optInTooltip": "Activa la telemetria",
    "gui.telemetryOptIn.optOutText": "No comparteixis les meves dades d'ús amb l'equip de Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Desactiva la telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "S'ha actualitzat la configuració.",
    "gui.telemetryOptIn.buttonClose": "Tanca",
    "gui.turboMode.active": "Mode Turbo",
    "gui.webglModal.label": "El teu navegador no suporta WebGL",
    "gui.webglModal.description": "Malauradament sembla que el teu navegador o ordinador {webGlLink}. Aquesta tecnologia és necessària per a que Scratch 3.0 funcioni.",
    "gui.webglModal.webgllink": "no suporta WebGL",
    "gui.webglModal.back": "Enrere",
    "gui.webglModal.previewfaq": "Si vols saber-ne més, vés a la {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Preguntes freqüents",
    "gui.costumeLibrary.chooseABackdrop": "Tria un fons",
    "gui.costumeLibrary.chooseACostume": "Tria un vestit",
    "gui.costumeTab.addBackdropFromLibrary": "Tria un fons",
    "gui.costumeTab.addCostumeFromLibrary": "Tria un vestit",
    "gui.costumeTab.addBlankCostume": "Dibuixa un nou vestit",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Puja un fons",
    "gui.costumeTab.addFileCostume": "Puja un vestit",
    "gui.extensionLibrary.chooseAnExtension": "Tria una extensió",
    "gui.extensionLibrary.extensionUrl": "Escriu la URL de l'extensió",
    "gui.monitors.importListColumnPrompt": "Quina columna s'ha d'utilitzar (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "No s'ha pogut començar a gravar",
    "gui.soundLibrary.chooseASound": "Tria un so",
    "gui.soundTab.fileUploadSound": "Puja un so",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Enregistra",
    "gui.soundTab.addSoundFromLibrary": "Tria un so",
    "gui.spriteLibrary.chooseASprite": "Tria un personatge",
    "gui.tipsLibrary.tutorials": "Tria un tutorial",
    "gui.alerts.createsuccess": "Nou projecte creat.",
    "gui.alerts.createcopysuccess": "Projecte desat com a còpia.",
    "gui.alerts.createremixsuccess": "Projecte desat com a reinvenció.",
    "gui.alerts.creating": "Creant nou...",
    "gui.alerts.creatingCopy": "Copiant projecte...",
    "gui.alerts.creatingRemix": "Reinventant projecte...",
    "gui.alerts.creatingError": "No s'ha pogut crear el projecte. Torna a intentar-ho!",
    "gui.alerts.savingError": "No s'ha pogut desar el projecte.",
    "gui.alerts.savesuccess": "Projecte guardat.",
    "gui.alerts.saving": "Desant projecte...",
    "gui.alerts.cloudInfo": "Tingues en compte que les variables del núvol només admeten nombres, no lletres o símbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Aprèn més.",
    "gui.alerts.importing": "Important...",
    "gui.defaultProject.meow": "Mèu",
    "gui.defaultProject.variable": "la meva variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Comença",
    "gui.howtos.intro-move.step_stepMove": "Afegeix un bloc de moviment",
    "gui.howtos.add-a-move-block.step_stepSay": "Afegeix un bloc \"digues\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Prem la bandera verda per començar",
    "gui.howtos.intro-getting-started-ASL.name": "Primers passos - ASL",
    "gui.howtos.animate-a-name.name": "Anima un nom",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Tria un personatge de Lletra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Reprodueix un so quan es cliqui",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Tria un altre personatge de Lletra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Canvia el color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Tria un altre personatge de Lletra i fes-lo girar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Tria un altre personatge de Lletra i fes-lo créixer",
    "gui.howtos.imagine": "Imagina un món",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Escriu el que vols dir",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Prem la bandera verda per començar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Tria un fons",
    "gui.howtos.imagine.step_imagineChooseSprite": "Tria un personatge",
    "gui.howtos.imagine.step_imagineFlyAround": "Prem la tecla espai per lliscar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Tria un altre personatge",
    "gui.howtos.imagine.step_imagineLeftRight": "Mou esquerra-dreta",
    "gui.howtos.imagine.step_imagineUpDown": "Mou amunt-avall",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Canvia els vestits",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Llisca fins a un punt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Creix i encongeix",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Tria un altre fons",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Canvia els fons",
    "gui.howtos.imagine.step_imagineRecordASound": "Afegeix un so",
    "gui.howtos.imagine.step_imagineChooseSound": "Tria el teu so",
    "gui.howtos.make-music.name": "Crea música",
    "gui.howtos.Make-Music.step_PickInstrument": "Tria un personatge d'Instrument",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Reprodueix un so quan es cliqui",
    "gui.howtos.Make-Music.step_MakeSong": "Crea una cançó",
    "gui.howtos.make-music.step_MakeBeat": "Tria un tambor i fes un batec",
    "gui.howtos.make-music.step_MakeBeatBox": "Tria el personatge Microphone & Surprise Beatbox",
    "gui.howtos.story.name": "Crea una història",
    "gui.howtos.story.step_addbg": "Afegeix un fons",
    "gui.howtos.story.step_addsprite": "Afegeix un personatge",
    "gui.howtos.story.step_saysomething": "Digues alguna cosa",
    "gui.howtos.story.step_addanothersprite": "Afegeix un altre personatge",
    "gui.howtos.story.step_flip": "Volteja la direcció",
    "gui.howtos.story.step_conversation": "Mantenir una conversa",
    "gui.howtos.story.addanotherbg": "Afegeix un altre fons",
    "gui.howtos.story.step_swithbg": "Canvia els fons",
    "gui.howtos.story.step_hidewizard": "Amaga el personatge",
    "gui.howtos.story.step_showwizard": "Mostra el personatge",
    "gui.howtos.make-a-chase-game.name": "Fes un joc de persecució",
    "gui.howtos.Chase-Game.step_BG": "Afegeix un fons",
    "gui.howtos.chase-game.step_AddOcto": "Afegeix un personatge",
    "gui.howtos.make-music.step_LeftRight": "Mou a dreta i esquerra amb les fletxes",
    "gui.howtos.Chase-Game.step_UpDown": "Mou amunt i avall amb les fletxes",
    "gui.howtos.Chase-Game.step_AddStar": "Afegeix un altre personatge",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mou a l'atzar",
    "gui.howtos.Chase-Game.step_WhenTouch": "En el personatge Octopus, quan es toqui reprodueix un so",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crea una variable de puntuació",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En el personatge Octopus, quan es toqui afegeix puntuació",
    "gui.howtos.animate-char.name": "Anima un personatge",
    "gui.howtos.animate-char.step_addbg": "Afegeix un fons",
    "gui.howtos.animate-char.step_addsprite": "Afegeix un personatge",
    "gui.howtos.animate-char.step_saysomething": "Digues alguna cosa",
    "gui.howtos.animate-char.step_addsound": "Afegeix un so",
    "gui.howtos.animate-char.step_animatetalking": "Anima la parla",
    "gui.howtos.animate-char.step_arrowkeys": "Mou utilitzant les tecles de fletxes ",
    "gui.howtos.animate-char.step_jump": "Salta",
    "gui.howtos.animate-char.step_changecolor": "Canvia el color",
    "gui.howtos.make-a-game.name": "Fes un joc de clics",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Tria un personatge",
    "gui.howtos.make-a-game.step_GamePlaySound": "Reprodueix un so quan es cliqui",
    "gui.howtos.make-a-game.step_GameAddScore": "Crea una variable de puntuació",
    "gui.howtos.make-a-game.step_GameChangeScore": "Augmenta la puntuació quan es cliqui",
    "gui.howtos.make-a-game.step_Random": "Vés a una posició aleatòria",
    "gui.howtos.make-music.step_GameChangeColor": "Canvia el color",
    "gui.howtos.make-music.step_ResetScore": "Reinicia la puntuació",
    "gui.howtos.make-it-fly.name": "Fes-lo volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Tria un fons de cel",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Tria un personatge",
    "gui.howtos.fly.step_stepflySaySomething": "Digues alguna cosa",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mou utilitzant les tecles de fletxes",
    "gui.howtos.fly.step_stepflyChooseObject": "Tria un objecte per recollir",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fes que l'objecte es mogui",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Selecciona el teu personatge",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Afegeix una puntuació",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Desa la puntuació",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Afegeix paisatge",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mou el paisatge",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Següent vestit",
    "gui.howtos.pong": "Joc del Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Afegeix un fons",
    "gui.howtos.pong.step_pongAddBallSprite": "Afegeix una Pilota",
    "gui.howtos.pong.step_pongBounceAround": "Rebota per tot arreu",
    "gui.howtos.pong.step_pongAddPaddle": "Afegeix una pala",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mou la pala",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selecciona la pilota",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Afegeix el codi per a que la pilota reboti a la pala",
    "gui.howtos.pong.step_pongAddAScore": "Afegeix una puntuació",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Tria 'Puntuació' del menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insereix el bloc 'augmenta puntuació'",
    "gui.howtos.pong.step_pongResetScore": "Reinicia la puntuació",
    "gui.howtos.pong.step_pongAddLineSprite": "Afegeix la línia",
    "gui.howtos.pong.step_pongGameOver": "Fi del joc",
    "gui.howtos.code-cartoon": "Programa un dibuix animat",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Digues alguna cosa quan la bandera verda es cliqui",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anima un personatge quan aquest es cliqui",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Tria un personatge diferent",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Utilitza un signe menys per fer-lo més petit",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fes que el personatge creixi i s’encongeixi",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Tria un personatge diferent",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Salta amunt i avall",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Fes clic a un personatge per canviar escenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Llisca al voltant",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Canvia els vestits",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Tria més personatges per afegir al teu dibuix animat",
    "gui.howtos.cartoon-network": "Anima un joc d'aventures",
    "gui.howtos.cartoon-network.step_CNcharacter": "Tria un personatge a mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Digues alguna cosa",
    "gui.howtos.cartoon-network.step_CNglide": "Llisca al voltant",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Tria un objecte a capturar",
    "gui.howtos.cartoon-network.step_CNcollect": "Recull objectes",
    "gui.howtos.cartoon-network.step_CNvariable": "Crea una variable de puntuació",
    "gui.howtos.cartoon-network.step_CNscore": "Desa la puntuació",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Nivell superat: canvia el fons",
    "gui.howtos.videosens.name": "Detecció de vídeo",
    "gui.howtos.videosens.step_addextension": "Afegeix una Extensió",
    "gui.howtos.videosens.step_pet": "Acaricia el gat",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Explotar un globus",
    "gui.howtos.say-it-out-loud": "Crea animacions que parlin",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Afegeix els blocs De text a parla",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Digues alguna cosa",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Estableix una veu",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mou-te a voltant",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Afegeix un fons",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Afegeix un altre personatge",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Realitza una cançó",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Canvia el color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Gira al voltant",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Creix i encongeix",
    "gui.howtos.talking": "Contes que parlen",
    "gui.howtos.talking.step_talesAddExtension": "Fes clic per afegir els blocs de text a parla",
    "gui.howtos.talking.step_talesChooseSprite": "Tria un personatge",
    "gui.howtos.talking.step_talesSaySomething": "Fes que un personatge parli",
    "gui.howtos.talking.step_talesChooseBackdrop": "Tria un fons",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Fes clic a un personatge per anar al fons següent",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Tria un altre personatge",
    "gui.howtos.talking.step_talesMoveAround": "Mou-te a voltant",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Tria un altre fons",
    "gui.howtos.talking.step_talesAnimateTalking": "Anima la parla",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Tria un altre fons",
    "gui.howtos.talking.step_talesChooseSound": "Tria una cançó per ballar",
    "gui.howtos.talking.step_talesDanceMoves": "Moviments de ball",
    "gui.howtos.talking.step_talesAskAnswer": "Tria els blocs de Pregunta i Resposta de la categoria de Sensors",
    "gui.howtos.add-sprite.name": "Afegeix un personatge",
    "gui.howtos.add-sprite.step_addSprite": "Afegeix un personatge",
    "gui.howtos.add-a-backdrop.name": "Afegeix un fons",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Afegeix un fons",
    "gui.howtos.change-size.name": "Augmenta la mida",
    "gui.howtos.change-size.step_changeSize": "Augmenta la mida",
    "gui.howtos.glide-around.name": "Llisca al voltant",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Llisca al voltant",
    "gui.howtos.change-size.step_glideAroundPoint": "Llisca fins a un punt",
    "gui.howtos.record-a-sound.name": "Grava un so",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clica a la pestanya 'Sons'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clica 'Enregistra'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Prem el botó d'enregistrament",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Tria el teu so",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Reprodueix el teu so",
    "gui.howtos.spin-video.name": "Fes-lo girar",
    "gui.howtos.change-size.step_spinTurn": "Gira",
    "gui.howtos.change-size.step_spinPointInDirection": "Estableix la direcció",
    "gui.howtos.hide-and-show.name": "Fet i Amagar",
    "gui.howtos.change-size.step_hideAndShow": "Fet i Amagar",
    "gui.howtos.switch-costume.name": "Anima un personatge",
    "gui.howtos.change-size.step_switchCostumes": "Anima un personatge",
    "gui.howtos.move-around-with-arrow-keys.name": "Utilitza les fletxes de direcció",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mou-ho a esquerra i a dreta",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mou amunt i avall",
    "gui.howtos.add-effects.name": "Afegeix efectes",
    "gui.howtos.videosens.step_addEffects": "Afegeix efectes",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toca instruments i tambors.",
    "gui.extension.pen.name": "Llapis",
    "gui.extension.pen.description": "Dibuixa amb els teus personatges.",
    "gui.extension.videosensing.name": "Detecció de vídeo",
    "gui.extension.videosensing.description": "Detecta moviment amb la càmera.",
    "gui.extension.text2speech.name": "De text a parla",
    "gui.extension.text2speech.description": "Fes que els teus projectes parlin.",
    "gui.extension.translate.name": "Tradueix",
    "gui.extension.translate.description": "Tradueix text en molts idiomes.",
    "gui.extension.makeymakey.description": "Converteix qualsevol cosa en una tecla.",
    "gui.extension.microbit.description": "Connecta els projectes amb el món.",
    "gui.extension.microbit.connectingMessage": "Connectant",
    "gui.extension.ev3.description": "Construeix robots interactius i més.",
    "gui.extension.ev3.connectingMessage": "Connectant. Assegura't que el codi en el teu EV3 és 1234.",
    "gui.extension.boost.description": "Porta a la vida les creacions.",
    "gui.extension.boost.connectingMessage": "Connectant",
    "gui.extension.wedo2.description": "Construeix amb motors i sensors.",
    "gui.extension.wedo2.connectingMessage": "Connectant",
    "gui.extension.gdxfor.description": "Detecta quan s'empeny, s'estira, es mou i es gira.",
    "gui.extension.gdxfor.connectingMessage": "Connectant",
    "gui.libraryTags.all": "Tots",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Balla",
    "gui.libraryTags.effects": "Efectes",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Menjar",
    "gui.libraryTags.indoors": "Interiors",
    "gui.libraryTags.loops": "Repeticions",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notes musicals",
    "gui.libraryTags.outdoors": "Exteriors",
    "gui.libraryTags.patterns": "Patrons",
    "gui.libraryTags.people": "Gent",
    "gui.libraryTags.percussion": "Percussió",
    "gui.libraryTags.space": "Espai",
    "gui.libraryTags.sports": "Esports",
    "gui.libraryTags.underwater": "Sota l'aigua",
    "gui.libraryTags.voice": "Veu",
    "gui.libraryTags.wacky": "Divertit",
    "gui.libraryTags.animation": "Animació",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Jocs",
    "gui.libraryTags.stories": "Històries",
    "gui.libraryTags.letters": "Lletres",
    "gui.opcodeLabels.direction": "direcció",
    "gui.opcodeLabels.xposition": "posició x",
    "gui.opcodeLabels.yposition": "posició y",
    "gui.opcodeLabels.size": "mida",
    "gui.opcodeLabels.costumename": "nom del vestit",
    "gui.opcodeLabels.costumenumber": "número de vestit",
    "gui.opcodeLabels.backdropname": "nom del fons",
    "gui.opcodeLabels.backdropnumber": "número de fons",
    "gui.opcodeLabels.volume": "volum",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "resposta",
    "gui.opcodeLabels.loudness": "volum del so",
    "gui.opcodeLabels.username": "nom d'usuari",
    "gui.opcodeLabels.year": "any",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "dia de la setmana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minut",
    "gui.opcodeLabels.second": "segon",
    "gui.opcodeLabels.timer": "cronòmetre",
    "gui.projectLoader.loadError": "No s'ha pogut carregar el fitxer del projecte seleccionat.",
    "gui.sharedMessages.backdrop": "fons{index}",
    "gui.sharedMessages.costume": "vestit{index}",
    "gui.sharedMessages.sprite": "Personatge{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Vols substituir els continguts del projecte actual?",
    "gui.sharedMessages.loadFromComputerTitle": "Carrega des del teu ordinador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Projecte de Scratch",
    "boost.color.any": "qualsevol color",
    "boost.color.black": "negre",
    "boost.color.blue": "blau",
    "boost.color.green": "verd",
    "boost.color.red": "vermell",
    "boost.color.white": "blanc",
    "boost.color.yellow": "groc",
    "boost.getMotorPosition": "posició del motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "angle d'inclinació [TILT_DIRECTION]",
    "boost.motorDirection.backward": "cap aquí",
    "boost.motorDirection.forward": "cap allà",
    "boost.motorDirection.reverse": "invertit",
    "boost.motorOff": "apaga el motor [MOTOR_ID]",
    "boost.motorOn": "activa el motor [MOTOR_ID]",
    "boost.motorOnFor": "activa el motor [MOTOR_ID] durant [DURATION] segons",
    "boost.motorOnForRotation": "activa el motor [MOTOR_ID] durant [ROTATION] rotacions",
    "boost.seeingColor": "detecta el bloc [COLOR]?",
    "boost.setLightHue": "fixa el color del llum a [HUE]",
    "boost.setMotorDirection": "fixa la direcció del motor [MOTOR_ID] a [MOTOR_DIRECTION]",
    "boost.setMotorPower": "fixa la velocitat del motor [MOTOR_ID] a [POWER] %",
    "boost.tiltDirection.any": "qualsevol",
    "boost.tiltDirection.down": "avall",
    "boost.tiltDirection.left": "esquerra",
    "boost.tiltDirection.right": "dreta",
    "boost.tiltDirection.up": "amunt",
    "boost.whenColor": "quan detecti el bloc [COLOR]",
    "boost.whenTilted": "quan la inclinació [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "fes sonar la nota [NOTE] durant [TIME] segons",
    "ev3.buttonPressed": "botó [PORT] premut?",
    "ev3.getBrightness": "brillantor",
    "ev3.getDistance": "distància",
    "ev3.getMotorPosition": "posició del motor [PORT]",
    "ev3.motorSetPower": "motor [PORT] potència [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] cap aquí durant [TIME] segons",
    "ev3.motorTurnCounterClockwise": "motor [PORT] cap allà durant [TIME] segons",
    "ev3.whenBrightnessLessThan": "quan la brillantor < [DISTANCE]",
    "ev3.whenButtonPressed": "quan el botó [PORT] es premi",
    "ev3.whenDistanceLessThan": "quan la distància < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleració [DIRECTION]",
    "gdxfor.getForce": "força",
    "gdxfor.getSpin": "velocitat de gir [DIRECTION]",
    "gdxfor.getTilt": "angle d'inclinació [TILT]",
    "gdxfor.isFreeFalling": "caient?",
    "gdxfor.isTilted": "inclinat [TILT]?",
    "gdxfor.pulled": "tirat",
    "gdxfor.pushed": "empès",
    "gdxfor.shaken": "es sacsegi",
    "gdxfor.startedFalling": "ha començat a caure",
    "gdxfor.tiltDirectionMenu.any": "qualsevol",
    "gdxfor.tiltDirectionMenu.back": "darrere",
    "gdxfor.tiltDirectionMenu.front": "davant",
    "gdxfor.tiltDirectionMenu.left": "esquerra",
    "gdxfor.tiltDirectionMenu.right": "dreta",
    "gdxfor.turnedFaceDown": "girat cara avall",
    "gdxfor.turnedFaceUp": "girat cara amunt",
    "gdxfor.whenForcePushedOrPulled": "quan el sensor de força [PUSH_PULL]",
    "gdxfor.whenGesture": "quan [GESTURE]",
    "gdxfor.whenTilted": "quan s'inclini [TILT]",
    "makeymakey.downArrow": "fletxa avall",
    "makeymakey.downArrowShort": "avall",
    "makeymakey.leftArrow": "fletxa esquerra",
    "makeymakey.leftArrowShort": "esquerra",
    "makeymakey.rightArrow": "fletxa dreta",
    "makeymakey.rightArrowShort": "dreta",
    "makeymakey.spaceKey": "espai",
    "makeymakey.upArrow": "fletxa amunt",
    "makeymakey.upArrowShort": "amunt",
    "makeymakey.whenKeyPressed": "quan la tecla [KEY] es premi",
    "makeymakey.whenKeysPressedInOrder": "quan [SEQUENCE] es premin en ordre",
    "microbit.buttonsMenu.any": "qualsevol",
    "microbit.clearDisplay": "no mostris res",
    "microbit.defaultTextToDisplay": "Hola!",
    "microbit.displaySymbol": "mostra [MATRIX]",
    "microbit.displayText": "mostra text [TEXT]",
    "microbit.gesturesMenu.jumped": "salti",
    "microbit.gesturesMenu.moved": "es mogui",
    "microbit.gesturesMenu.shaken": "es sacsegi",
    "microbit.isButtonPressed": "[BTN] botó premut?",
    "microbit.isTilted": "inclinat [DIRECTION]?",
    "microbit.pinStateMenu.off": "apaga",
    "microbit.pinStateMenu.on": "activa",
    "microbit.tiltAngle": "angle d'inclinació [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "qualsevol",
    "microbit.tiltDirectionMenu.back": "darrere",
    "microbit.tiltDirectionMenu.front": "al davant",
    "microbit.tiltDirectionMenu.left": "esquerra",
    "microbit.tiltDirectionMenu.right": "dreta",
    "microbit.whenButtonPressed": "quan el botó [BTN] es premi",
    "microbit.whenGesture": "quan [GESTURE]",
    "microbit.whenPinConnected": "quan el pin [PIN] connectat",
    "microbit.whenTilted": "quan s'inclini [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "augmenta [TEMPO] el tempo",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabassa",
    "music.drumClaves": "(9) Claus",
    "music.drumClosedHiHat": "(6) Xarles tancat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Esquella",
    "music.drumCrashCymbal": "(4) Platets",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Aplaudiment",
    "music.drumOpenHiHat": "(5) Xarles obert",
    "music.drumSideStick": "(3) Cop lateral",
    "music.drumSnare": "(1) Tambor militar petit",
    "music.drumTambourine": "(7) Tamborí",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibra-Slap",
    "music.drumWoodBlock": "(10) Bloc de fusta",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Baix",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violoncel",
    "music.instrumentChoir": "(15) Cor",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Guitarra elèctrica",
    "music.instrumentElectricPiano": "(2) Piano elèctric",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caixa de música",
    "music.instrumentOrgan": "(3) Orgue",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxòfon",
    "music.instrumentSteelDrum": "(18) Tambor d'acer",
    "music.instrumentSynthLead": "(20) Sintetitzador solista",
    "music.instrumentSynthPad": "(21) Sintetitzador de fons",
    "music.instrumentTrombone": "(9) Trombó",
    "music.instrumentVibraphone": "(16) Vibràfon",
    "music.instrumentWoodenFlute": "(13) Flauta dolça",
    "music.midiPlayDrumForBeats": "toca el tambor [DRUM] durant [BEATS] pulsacions",
    "music.midiSetInstrument": "fixa l'instrument a [INSTRUMENT]",
    "music.playDrumForBeats": "toca el tambor [DRUM] durant [BEATS] pulsacions",
    "music.playNoteForBeats": "toca la nota [NOTE] durant [BEATS] pulsacions",
    "music.restForBeats": "espera [BEATS] pulsacions",
    "music.setInstrument": "fixa instrument a [INSTRUMENT]",
    "music.setTempo": "fixa el tempo a [TEMPO]",
    "pen.categoryName": "Llapis",
    "pen.changeColorParam": "augmenta [COLOR_PARAM] del llapis en [VALUE]",
    "pen.changeHue": "augmenta [HUE] el color del llapis",
    "pen.changeShade": "augmenta [SHADE] la intensitat del llapis",
    "pen.changeSize": "augmenta [SIZE] la mida del llapis",
    "pen.clear": "esborra-ho tot",
    "pen.colorMenu.brightness": "brillantor",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturació",
    "pen.colorMenu.transparency": "transparència",
    "pen.penDown": "baixa el llapis",
    "pen.penUp": "puja el llapis",
    "pen.setColor": "fixa el color del llapis a [COLOR]",
    "pen.setColorParam": "fixa [COLOR_PARAM] del llapis a [VALUE]",
    "pen.setHue": "fixa el color del llapis a [HUE]",
    "pen.setShade": "fixa la intensitat del llapis a [SHADE]",
    "pen.setSize": "fixa la mida del llapis a [SIZE]",
    "pen.stamp": "estampa",
    "speech.defaultWhenIHearValue": "anem",
    "speech.extensionName": "De parla a text",
    "speech.listenAndWait": "escolta i espera ",
    "speech.speechReporter": "parla",
    "speech.whenIHear": "quan senti [PHRASE]",
    "text2speech.alto": "contralt",
    "text2speech.categoryName": "De text a parla",
    "text2speech.defaultTextToSpeak": "hola",
    "text2speech.giant": "gegant",
    "text2speech.kitten": "gatet",
    "text2speech.setLanguageBlock": "fixa l'idioma a [LANGUAGE]",
    "text2speech.setVoiceBlock": "fixa la veu a [VOICE]",
    "text2speech.speakAndWaitBlock": "parla [WORDS]",
    "text2speech.squeak": "veu divertida",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Tradueix",
    "translate.defaultTextToTranslate": "hola",
    "translate.translateBlock": "tradueix [WORDS] a [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Captura de vídeo",
    "videoSensing.direction": "direcció",
    "videoSensing.motion": "moviment",
    "videoSensing.off": "apaga",
    "videoSensing.on": "activa",
    "videoSensing.onFlipped": "voltejat actiu",
    "videoSensing.setVideoTransparency": "fixa la transparència del vídeo a [TRANSPARENCY]",
    "videoSensing.sprite": "personatge",
    "videoSensing.stage": "escenari",
    "videoSensing.videoOn": "vídeo [ATTRIBUTE] a [SUBJECT]",
    "videoSensing.videoToggle": "posa vídeo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "quan el moviment de vídeo > [REFERENCE]",
    "wedo2.getDistance": "distància",
    "wedo2.getTiltAngle": "angle d'inclinació [TILT_DIRECTION]",
    "wedo2.isTilted": "inclinat [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "cap aquí",
    "wedo2.motorDirection.forward": "cap allà",
    "wedo2.motorDirection.reverse": "invertit",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "tots els motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "apaga motor [MOTOR_ID]",
    "wedo2.motorOn": "activa el motor [MOTOR_ID]",
    "wedo2.motorOnFor": "activa [MOTOR_ID] durant [DURATION] segons",
    "wedo2.playNoteFor": "toca la nota [NOTE] durant [DURATION] segons",
    "wedo2.setLightHue": "fixa el color del llum a [HUE]",
    "wedo2.setMotorDirection": "fixa la direcció de [MOTOR_ID] a [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "fixa la potència de [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "qualsevol",
    "wedo2.tiltDirection.down": "avall",
    "wedo2.tiltDirection.left": "esquerra",
    "wedo2.tiltDirection.right": "dreta",
    "wedo2.tiltDirection.up": "amunt",
    "wedo2.whenDistance": "quan la distància [OP] [REFERENCE]",
    "wedo2.whenTilted": "quan la inclinació [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturació",
    "paint.paintEditor.brightness": "Lluminositat",
    "paint.paintEditor.costume": "Vestit",
    "paint.paintEditor.group": "Agrupa",
    "paint.paintEditor.ungroup": "Desagrupa",
    "paint.paintEditor.undo": "Desfés",
    "paint.paintEditor.redo": "Torna-hi",
    "paint.paintEditor.forward": "Endavant",
    "paint.paintEditor.backward": "Enrere",
    "paint.paintEditor.front": "Al davant",
    "paint.paintEditor.back": "Al darrere",
    "paint.paintEditor.more": "Més",
    "paint.modeTools.brushSize": "Mida",
    "paint.modeTools.eraserSize": "Ample de l'esborrador",
    "paint.modeTools.copy": "Copia",
    "paint.modeTools.paste": "Enganxa",
    "paint.modeTools.delete": "Elimina",
    "paint.modeTools.curved": "Corbat",
    "paint.modeTools.pointed": "Afila conjunt de punts",
    "paint.modeTools.thickness": "Gruix",
    "paint.modeTools.flipHorizontal": "Gira horitzontalment",
    "paint.modeTools.flipVertical": "Gira verticalment",
    "paint.modeTools.filled": "Omplert",
    "paint.modeTools.outlined": "Contorn",
    "paint.paintEditor.bitmap": "Converteix a mapa de bits",
    "paint.paintEditor.vector": "Converteix a vectorial",
    "paint.paintEditor.fill": "Omple",
    "paint.paintEditor.stroke": "Línia exterior",
    "paint.brushMode.brush": "Pinzell",
    "paint.eraserMode.eraser": "Goma d'esborrar",
    "paint.fillMode.fill": "Omple",
    "paint.lineMode.line": "Línia",
    "paint.ovalMode.oval": "Cercle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Redibuixa",
    "paint.roundedRectMode.roundedRect": "Rectangle amb cantonades arrodonides",
    "paint.selectMode.select": "Selecciona",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Intercanvia"
  },
  "cs": {
    "gui.alerts.lostPeripheralConnection": "Scratch ztratil připojení k {extensionName}.",
    "gui.alerts.tryAgain": "Zkusit znovu",
    "gui.alerts.download": "Stáhnout",
    "gui.connection.reconnect": "Znovu připojit",
    "gui.backpack.costumeLabel": "kostým",
    "gui.backpack.soundLabel": "zvuk",
    "gui.backpack.scriptLabel": "skript",
    "gui.backpack.spriteLabel": "postava",
    "gui.backpack.header": "Batoh",
    "gui.backpack.errorBackpack": "Chyba při načítání batohu",
    "gui.backpack.loadingBackpack": "Nahrávám..",
    "gui.backpack.more": "Více",
    "gui.backpack.emptyBackpack": "Batoh je prázdný",
    "gui.unsupportedBrowser.label": "Prohlížeč není podporován",
    "gui.unsupportedBrowser.errorLabel": "Došlo k chybě",
    "gui.unsupportedBrowser.notRecommended": "Je nám velmi líto, ale zdá se, že používáš prohlížeč, který Scratch nepodporuje. Doporučujeme aktualizovaci na poslední verzi podporovaného prohlížeče, jako je Google Chrome, Mozilla Firefox, Microsoft Edge nebo Apple Safari.",
    "gui.unsupportedBrowser.description": "Je nám velmi líto, ale Scratch nepodporuje tento prohlížeč. Doporučujeme aktualizovaci na poslední verzi podporovaného prohlížeče, jako je Google Chrome, Mozilla Firefox, Microsoft Edge nebo Apple Safari.",
    "gui.unsupportedBrowser.back": "Zpět",
    "gui.unsupportedBrowser.previewfaq": "Pro další info jdi na {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Návody",
    "gui.cards.shrink": "Zmenši",
    "gui.cards.expand": "Zvětši",
    "gui.cards.close": "Zavřít",
    "gui.cards.more-things-to-try": "Více věcí na vyzkoušení!",
    "gui.cards.see-more": "Další informace",
    "gui.comingSoon.message1": "Neboj, pracujeme na tom {emoji}",
    "gui.comingSoon.message2": "Již brzy...",
    "gui.comingSoon.message3": "Pracujeme na tom {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nenalezena žádná zařízení",
    "gui.connection.auto-scanning.prescan": "Umísti své zařízení na dosah, pak začni vyhledávat.",
    "gui.connection.auto-scanning.pressbutton": "Stiskni tlačítko na svém zařízení.",
    "gui.connection.auto-scanning.start-search": "Start vyhledávání",
    "gui.connection.connecting-searchbutton": "Vyhledávám...",
    "gui.connection.auto-scanning.try-again": "Zkus znovu",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Propojeno",
    "gui.connection.disconnect": "Odpojit",
    "gui.connection.go-to-editor": "Jít do editoru",
    "gui.connection.connecting-cancelbutton": "Propojování...",
    "gui.connection.error.errorMessage": "Běda, zdá se, že se něco pokazilo.",
    "gui.connection.error.tryagainbutton": "Zkus znovu",
    "gui.connection.error.helpbutton": "Pomoc",
    "gui.connection.peripheral-name-label": "Název zařízení",
    "gui.connection.connect": "Propojit",
    "gui.connection.scanning.lookingforperipherals": "Hledám zařízení",
    "gui.connection.scanning.noPeripheralsFound": "Nenalezena žádná zařízení",
    "gui.connection.scanning.instructions": "Vyber své zařízení ze seznamu výše.",
    "gui.connection.search": "Aktualizovat",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Ujisti se, že máš Scratch Link nainstalovaný a spuštěný",
    "gui.connection.unavailable.enablebluetooth": "Zkontroluj, zda máš zapnuté Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Zkus znovu",
    "gui.connection.unavailable.helpbutton": "Pomoc",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Jít zpět",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Zkusit znovu",
    "gui.controls.go": "Spustit",
    "gui.controls.stop": "Zastavit",
    "gui.crashMessage.label": "Jejda! Něco se pokazilo.",
    "gui.crashMessage.description": "Je nám líto, ale zdá se, že Scratch spadl. Tato chyba byla automaticky nahlášena týmu Scratch. Prosím, obnov stránku pro další pokus.",
    "gui.crashMessage.errorNumber": "Tvá chyba byla evidována s id {errorId}",
    "gui.crashMessage.reload": "Znovu načíst",
    "gui.customProcedures.myblockModalTitle": "Vytvořit blok",
    "gui.customProcedures.addAnInputNumberText": "Přidej parametr",
    "gui.customProcedures.numberTextType": "číslo nebo text",
    "gui.customProcedures.addAnInputBoolean": "Přidat vstup",
    "gui.customProcedures.booleanType": "logický",
    "gui.customProcedures.addALabel": "Přidej popisek",
    "gui.customProcedures.runWithoutScreenRefresh": "Spustit bez obnovy obrazovky",
    "gui.customProcedures.cancel": "Zrušit",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Směr",
    "gui.directionPicker.rotationStyles.allAround": "Dokola",
    "gui.directionPicker.rotationStyles.leftRight": "Vlevo/vpravo",
    "gui.directionPicker.rotationStyles.dontRotate": "Neotáčet",
    "gui.gui.addExtension": "Přidej rozšíření",
    "gui.gui.codeTab": "Scénáře",
    "gui.gui.backdropsTab": "Pozadí",
    "gui.gui.costumesTab": "Kostýmy",
    "gui.gui.soundsTab": "Zvuky",
    "gui.extensionLibrary.comingSoon": "Již brzy",
    "gui.extensionLibrary.requires": "Vyžaduje",
    "gui.extensionLibrary.collaboration": "Spolupráce s",
    "gui.library.filterPlaceholder": "Hledat",
    "gui.library.allTag": "Všechno",
    "gui.loader.message1": "Vytvářím bloky ...",
    "gui.loader.message2": "Načítám postavy ...",
    "gui.loader.message3": "Načítání zvuků...",
    "gui.loader.message4": "Načítám rozšíření ...",
    "gui.loader.message5": "Kočkování koček...",
    "gui.loader.message6": "Přenáším ...",
    "gui.loader.message7": "Nafukování planet...",
    "gui.loader.message8": "Připravuji smajlíky ...",
    "gui.loader.headline": "Nahrávám projekt...",
    "gui.loader.creating": "Vytváření projektu",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Moje věci",
    "gui.accountMenu.myClasses": "Moje třídy",
    "gui.accountMenu.myClass": "Moje třída",
    "gui.accountMenu.accountSettings": "Nastavení účtu",
    "gui.accountMenu.signOut": "Odhlášení",
    "gui.authorInfo.byUser": "od uživatele {username}",
    "gui.menuBar.seeProjectPage": "Shlédni stránku projektu",
    "gui.menuBar.language": "Jazyk",
    "general.username": "Jméno uživatele",
    "general.password": "Heslo",
    "general.signIn": "Přihlášení",
    "login.needHelp": "Potřebujete pomoc?",
    "form.validationRequired": "Povinné pole",
    "gui.menuBar.tutorialsLibrary": "Návody",
    "gui.menuBar.restoreSprite": "Obnovit postavu",
    "gui.menuBar.restoreSound": "Obnovit zvuk",
    "gui.menuBar.restoreCostume": "Obnovit kostým",
    "gui.menuBar.restore": "Obnovit",
    "gui.menuBar.saveNow": "Uložit aktuální stav",
    "gui.menuBar.saveAsCopy": "Uložit jako kopii",
    "gui.menuBar.remix": "Vytvoř si kopii",
    "gui.menuBar.new": "Nový",
    "gui.menuBar.file": "Soubor",
    "gui.menuBar.downloadToComputer": "Ulož do svého počítače",
    "gui.menuBar.edit": "Upravit",
    "gui.menuBar.turboModeOff": "Vypni turbo režim",
    "gui.menuBar.turboModeOn": "Zapni turbo režim",
    "gui.menuBar.modeMenu": "Styl",
    "gui.menuBar.normalMode": "Normální styl",
    "gui.menuBar.caturdayMode": "Kočičí styl",
    "gui.menuBar.joinScratch": "Připojit se ke Scratchi",
    "gui.menuBar.signIn": "Přihlášení",
    "gui.gui.projectTitlePlaceholder": "Název projektu",
    "gui.menuBar.saveNowLink": "Uložit teď",
    "gui.menuBar.settings": "Nastavení",
    "gui.menuBar.isShared": "Sdílené",
    "gui.menuBar.share": "Sdílet",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Pomoc",
    "gui.modal.back": "Zpět",
    "gui.monitor.listMonitor.empty": "(prázdný)",
    "gui.monitor.listMonitor.listLength": "délka {length}",
    "gui.monitor.contextMenu.default": "normální zobrazení",
    "gui.monitor.contextMenu.large": "zvětšené zobrazení",
    "gui.monitor.contextMenu.slider": "posuvník",
    "gui.monitor.contextMenu.sliderRange": "změnit rozsah posuvníku",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "skryj se",
    "gui.playButton.play": "Hraj",
    "gui.playButton.stop": "Zastav",
    "gui.gui.variableScopeOptionAllSprites": "Pro všechny postavy",
    "gui.gui.variableScopeOptionSpriteOnly": "Jen pro tuto postavu",
    "gui.gui.cloudVariableOption": "cloudová proměnná (uložená na serveru)",
    "gui.gui.variablePromptAllSpritesMessage": "Tato proměnná bude dostupná všem postavám.",
    "gui.gui.listPromptAllSpritesMessage": "Tento seznam bude dostupný pro všechny postavy.",
    "gui.prompt.cancel": "Zrušit",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Zastavit",
    "gui.playbackStep.playMsg": "Přehrát",
    "gui.playbackStep.loadingMsg": "Nahrávám..",
    "gui.playbackStep.saveMsg": "Uložit",
    "gui.playbackStep.reRecordMsg": "Znovu nahrát",
    "gui.recordModal.title": "Nahrát zvuk",
    "gui.recordingStep.beginRecord": "Začni natáčet kliknutím na tlačítko níže",
    "gui.recordingStep.permission": "{arrow}Potřebujeme povolení k používání tvého mikrofonu",
    "gui.recordingStep.stop": "Zastavit natáčení",
    "gui.recordingStep.record": "Nahraj",
    "gui.sliderModal.min": "Nejmenší hodnota",
    "gui.sliderModal.max": "Největší hodnota",
    "gui.sliderModal.title": "Změnit rozsah posuvníku",
    "gui.sliderPrompt.cancel": "Zrušit",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Zvuk",
    "gui.soundEditor.play": "Hraj",
    "gui.soundEditor.stop": "Zastavit",
    "gui.soundEditor.copy": "Zkopírovat",
    "gui.soundEditor.paste": "Vložit",
    "gui.soundEditor.copyToNew": "Zkopírovat do nového",
    "gui.soundEditor.delete": "Odstranit",
    "gui.soundEditor.save": "Uložit",
    "gui.soundEditor.undo": "Zpět",
    "gui.soundEditor.redo": "Znovu",
    "gui.soundEditor.faster": "Rychleji",
    "gui.soundEditor.slower": "Pomaleji",
    "gui.soundEditor.echo": "Ozvěna",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Zesílit",
    "gui.soundEditor.softer": "Zeslabit",
    "gui.soundEditor.reverse": "Pozpátku",
    "gui.soundEditor.fadeOut": "Postupné ztišení",
    "gui.soundEditor.fadeIn": "Postupný náběh",
    "gui.soundEditor.mute": "Ztišit",
    "gui.SpriteInfo.spritePlaceholder": "Název",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Postava",
    "gui.SpriteInfo.show": "Ukázat",
    "gui.SpriteInfo.size": "Velikost",
    "gui.spriteSelectorItem.contextMenuDuplicate": "zkopíruj",
    "gui.spriteSelectorItem.contextMenuExport": "export",
    "gui.spriteSelectorItem.contextMenuDelete": "smazat",
    "gui.spriteSelector.addSpriteFromLibrary": "Vyber postavu",
    "gui.spriteSelector.addSpriteFromPaint": "Kreslit",
    "gui.spriteSelector.addSpriteFromSurprise": "Překvapení",
    "gui.spriteSelector.addSpriteFromFile": "Nahrát postavu",
    "gui.stageHeader.stageSizeLarge": "Přepni na velkou scénu",
    "gui.stageHeader.stageSizeSmall": "Přepni na malou scénu",
    "gui.stageHeader.stageSizeFull": "Vstup do režimu celé obrazovky",
    "gui.stageHeader.stageSizeUnFull": "Ukončit režim celé obrazovky",
    "gui.stageHeader.fullscreenControl": "Ovládání celé obrazovky",
    "gui.spriteSelector.addBackdropFromLibrary": "Vybrat pozadí",
    "gui.stageSelector.addBackdropFromPaint": "Kresli",
    "gui.stageSelector.addBackdropFromSurprise": "Překvapení",
    "gui.stageSelector.addBackdropFromFile": "Nahrát pozadí",
    "gui.stageSelector.stage": "Scéna",
    "gui.stageSelector.backdrops": "Pozadí",
    "gui.telemetryOptIn.label": "Hlášení statistik kvůli vylepšení Scratch",
    "gui.telemetryOptIn.body1": "Tým Scratch se neustále snaží o lepší pochopení toho, jak je Scratch ve světě užíván. Pro podporu tohoto úsilí můžeš povolit programu Scratch,\n aby zasílal automaticky informace o používání do týmu Scratch.",
    "gui.telemetryOptIn.body2": "Sbírané informace obsahují volbu jazyka, použití bloků a některé události, jako ukládání, stahování a nahrávání projektu. NESBÍRÁME žádné osobní informace. Prosím navštiv naši stránku {privacyPolicyLink} pro další informace.",
    "gui.telemetryOptIn.privacyPolicyLink": "Zásady ochrany osobních údajů",
    "gui.telemetryOptIn.optInText": "Sdílet moje údaje o používání s týmem Scratch",
    "gui.telemetryOptIn.optInTooltip": "Povolit telemetrii",
    "gui.telemetryOptIn.optOutText": "Nesdílet moje údaje o používání s týmem Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Vypnout telemetrii",
    "gui.telemetryOptIn.settingWasUpdated": "Tvoje nastavení bylo aktualizováno",
    "gui.telemetryOptIn.buttonClose": "Zavřít",
    "gui.turboMode.active": "Turbo režim",
    "gui.webglModal.label": "Tvůj prohlížeč nepodporuje WebGL",
    "gui.webglModal.description": "Bohužel to vypadá, že tvůj prohlížeč nebo počítač  {webGlLink}. Scratch 3.0 tuto technologii potřebuje, aby šel spustit.",
    "gui.webglModal.webgllink": "nepodporuje WebGL",
    "gui.webglModal.back": "Zpět",
    "gui.webglModal.previewfaq": "Pro další info jdi na {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Vybrat pozadí",
    "gui.costumeLibrary.chooseACostume": "Vyber kostým",
    "gui.costumeTab.addBackdropFromLibrary": "Vybrat pozadí",
    "gui.costumeTab.addCostumeFromLibrary": "Vyber kostým",
    "gui.costumeTab.addBlankCostume": "Kreslit",
    "gui.costumeTab.addSurpriseCostume": "Překvapení",
    "gui.costumeTab.addFileBackdrop": "Nahrát pozadí",
    "gui.costumeTab.addFileCostume": "Nahrát kostým",
    "gui.extensionLibrary.chooseAnExtension": "Vyber rozšíření",
    "gui.extensionLibrary.extensionUrl": "Zadej URL rozšíření",
    "gui.monitors.importListColumnPrompt": "Který sloupec se má použít (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nemohu začít nahrávat",
    "gui.soundLibrary.chooseASound": "Vybrat zvuk",
    "gui.soundTab.fileUploadSound": "Nahrát zvuk",
    "gui.soundTab.surpriseSound": "Překvapení",
    "gui.soundTab.recordSound": "Nahraj",
    "gui.soundTab.addSoundFromLibrary": "Vyber zvuk.",
    "gui.spriteLibrary.chooseASprite": "Vyber si postavu",
    "gui.tipsLibrary.tutorials": "Vyber si návod",
    "gui.alerts.createsuccess": "Vytvořen nový projekt.",
    "gui.alerts.createcopysuccess": "Projekt uložen jako kopie.",
    "gui.alerts.createremixsuccess": "Projekt uložen jako remix.",
    "gui.alerts.creating": "Vytvářím nový...",
    "gui.alerts.creatingCopy": "Kopíruji projekt...",
    "gui.alerts.creatingRemix": "Remixuji projekt...",
    "gui.alerts.creatingError": "Nelze vytvořit projekt. Zkuste to znovu!",
    "gui.alerts.savingError": "Projekt nemohl být uložen.",
    "gui.alerts.savesuccess": "Projekt uložen.",
    "gui.alerts.saving": "Ukládám projekt...",
    "gui.alerts.cloudInfo": "Všimni si, prosím, že cloudové proměnné podporují jen čísla, ne písmena nebo symboly. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Další poučení.",
    "gui.alerts.importing": "Importování...",
    "gui.defaultProject.meow": "Mňau",
    "gui.defaultProject.variable": "moje proměnná",
    "gui.howtos.intro-move-sayhello-hat.name": "Začínáme",
    "gui.howtos.intro-move.step_stepMove": "Přidej blok pohybu",
    "gui.howtos.add-a-move-block.step_stepSay": "Přidej blok bublina",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klikni na zelenou vlajku pro spuštění",
    "gui.howtos.intro-getting-started-ASL.name": "Začínáme - ASL",
    "gui.howtos.animate-a-name.name": "Animuj jméno",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Vyber si písmeno",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Zahraj zvuk po kliknutí",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Vyber si další písmeno",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Změn barvu",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Vyber si další písmeno a přinuť ho k otáčení",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Vyber si další písmeno a přinuť ho se zvětšovat",
    "gui.howtos.imagine": "Vymysli si svět",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Napiš, co chceš říct",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klikni na zelený  praporek pro spuštění",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Vyber nějaké pozadí",
    "gui.howtos.imagine.step_imagineChooseSprite": "Vyber nějakou postavu",
    "gui.howtos.imagine.step_imagineFlyAround": "Stiskni mezerník pro klouzání",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Vyber jinou postavu",
    "gui.howtos.imagine.step_imagineLeftRight": "Pohyb vlevo-vpravo",
    "gui.howtos.imagine.step_imagineUpDown": "Pohyb nahoru-dolů",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Změň kostýmy",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Klouzej na místo",
    "gui.howtos.imagine.step_imagineGrowShrink": "Zvětšuj a zmenšuj",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Vyber jiné pozadí",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Přepni pozadí",
    "gui.howtos.imagine.step_imagineRecordASound": "Přidej zvuk",
    "gui.howtos.imagine.step_imagineChooseSound": "Vyber si svůj zvuk",
    "gui.howtos.make-music.name": "Vytvoř hudbu",
    "gui.howtos.Make-Music.step_PickInstrument": "Zvol si postavu nástroje",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Zahraj zvuk po kliknutí",
    "gui.howtos.Make-Music.step_MakeSong": "Vytvoř písničku",
    "gui.howtos.make-music.step_MakeBeat": "Vyber si buben a udělej takt",
    "gui.howtos.make-music.step_MakeBeatBox": "Vyber si postavy Mikrofon a Překvapující Beatbox",
    "gui.howtos.story.name": "Vytvoř si příběh",
    "gui.howtos.story.step_addbg": "Přidej pozadí",
    "gui.howtos.story.step_addsprite": "Přidej postavu",
    "gui.howtos.story.step_saysomething": "Řekni něco",
    "gui.howtos.story.step_addanothersprite": "Přidej další postavu",
    "gui.howtos.story.step_flip": "Přepni  směr",
    "gui.howtos.story.step_conversation": "Rozmlouvej",
    "gui.howtos.story.addanotherbg": "Přidej další pozadí",
    "gui.howtos.story.step_swithbg": "Přepni pozadí",
    "gui.howtos.story.step_hidewizard": "Skryj postavu",
    "gui.howtos.story.step_showwizard": "Ukaž postavu",
    "gui.howtos.make-a-chase-game.name": "Udělej si honičku",
    "gui.howtos.Chase-Game.step_BG": "Přidej pozadí",
    "gui.howtos.chase-game.step_AddOcto": " Přidej postavu",
    "gui.howtos.make-music.step_LeftRight": "Pohybuj se doprava a doleva s pomocí šipek",
    "gui.howtos.Chase-Game.step_UpDown": "Pohybuj se nahoru a dolů s pomocí šipek",
    "gui.howtos.Chase-Game.step_AddStar": "Přidej jinou postavu",
    "gui.howtos.Chase-Game.step_MoveRandom": "Pohybuj se náhodně",
    "gui.howtos.Chase-Game.step_WhenTouch": "V postavě Chobotnice, při doteku přehraj zvuk",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Vytvoř proměnnou skóre",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "V postavě Chobotnice, při doteku přidej skóre",
    "gui.howtos.animate-char.name": "Animuj postavu",
    "gui.howtos.animate-char.step_addbg": "Přidej pozadí",
    "gui.howtos.animate-char.step_addsprite": " Přidej postavu",
    "gui.howtos.animate-char.step_saysomething": "Řekni něco",
    "gui.howtos.animate-char.step_addsound": "Přidej zvuk",
    "gui.howtos.animate-char.step_animatetalking": "Animuj mluvení",
    "gui.howtos.animate-char.step_arrowkeys": "Hýbání pomocí šipek",
    "gui.howtos.animate-char.step_jump": "Skok",
    "gui.howtos.animate-char.step_changecolor": "Změna barvy",
    "gui.howtos.make-a-game.name": "Udělej hru kliker",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Vyber si postavu",
    "gui.howtos.make-a-game.step_GamePlaySound": "Zahraj zvuk po kliknutí",
    "gui.howtos.make-a-game.step_GameAddScore": "Vytvoř proměnnou skóre",
    "gui.howtos.make-a-game.step_GameChangeScore": "Při kliknutí navyš skóre",
    "gui.howtos.make-a-game.step_Random": "Skoč na náhodnou pozici",
    "gui.howtos.make-music.step_GameChangeColor": "Změna barvy",
    "gui.howtos.make-music.step_ResetScore": "Vynuluj skóre",
    "gui.howtos.make-it-fly.name": "Nauč létat",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Zvol pozadí oblohy",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Vyber si postavu",
    "gui.howtos.fly.step_stepflySaySomething": "Řekni něco",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Hýbání pomocí šipek",
    "gui.howtos.fly.step_stepflyChooseObject": "Vyber objekt ke sbírání",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Rozpohybuj objekt",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Zvol si svoji postavu",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Přidej skóre",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Udržuj skóre",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Přidej scénu",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Pohybuj scénou",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Další kostým",
    "gui.howtos.pong": "Hra Ping pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Přidej pozadí",
    "gui.howtos.pong.step_pongAddBallSprite": " Přidej postavu míče",
    "gui.howtos.pong.step_pongBounceAround": "Odrážení dokola",
    "gui.howtos.pong.step_pongAddPaddle": "Přidej pálku",
    "gui.howtos.pong.step_pongMoveThePaddle": "Pohybuj pálkou",
    "gui.howtos.pong.step_pongSelectBallSprite": " Zvol postavu míče",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Přidej kód pro odraz míče pálkou",
    "gui.howtos.pong.step_pongAddAScore": "Přidej skóre",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Vyber 'Score' z menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Vlož blok 'Změň Score'",
    "gui.howtos.pong.step_pongResetScore": "Vynuluj skóre",
    "gui.howtos.pong.step_pongAddLineSprite": " Přidej postavu čáry",
    "gui.howtos.pong.step_pongGameOver": "Hra skončila",
    "gui.howtos.code-cartoon": "Naprogramuj komiks",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Řekni něco, když klikneš na zelený praporek",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animuj postavu, když na ni klikneš",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Zvol si jinou postavu",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Použij znaménko mínus ke zmenšení",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Přinuť postavu růst i zmenšovat",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Zvol si jinou postavu",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Skákej nahoru a dolů",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klikni na postavu, aby se měnily scény",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Klouzej okolo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Změň kostýmy",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Vyber si více postav pro přidání do tvého komiksu",
    "gui.howtos.cartoon-network": "Animuj dobrodružnou hru",
    "gui.howtos.cartoon-network.step_CNcharacter": "Vyber postavu do show",
    "gui.howtos.cartoon-network.step_CNsay": "Řekni něco",
    "gui.howtos.cartoon-network.step_CNglide": "Klouzej okolo",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Vyber objekt k následování",
    "gui.howtos.cartoon-network.step_CNcollect": "Sesbírej objekty",
    "gui.howtos.cartoon-network.step_CNvariable": "Udělej proměnnou Skóre",
    "gui.howtos.cartoon-network.step_CNscore": "Udržuj skóre",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Další úroveň: Změň pozadí",
    "gui.howtos.videosens.name": "Vnímání videa",
    "gui.howtos.videosens.step_addextension": "Přidej rozšíření",
    "gui.howtos.videosens.step_pet": "Pohlaď kočku",
    "gui.howtos.videosens.step_animate": "Animuj",
    "gui.howtos.videosens.step_pop": "Praskni balon",
    "gui.howtos.say-it-out-loud": "Vytvoř animace, které mluví",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Přidej bloky Text na hlas",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Řekni něco",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Nastav hlas",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Pohybuj",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Přidej pozadí",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Přidej další postavu",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Zazpívej písničku",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Změna barvy",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Otoč se dokola",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Zvětšuj a zmenšuj",
    "gui.howtos.talking": "Vyprávění příběhů",
    "gui.howtos.talking.step_talesAddExtension": "Klikni pro přidání bloků Text-na-hlas",
    "gui.howtos.talking.step_talesChooseSprite": "Vyber si postavu",
    "gui.howtos.talking.step_talesSaySomething": "Nauč postavu mluvit",
    "gui.howtos.talking.step_talesChooseBackdrop": "Vybrat pozadí",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klikni na postavu pro přechod na další pozadí",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Vyber jinou postavu",
    "gui.howtos.talking.step_talesMoveAround": "Pohybuj",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Vyber jiné pozadí",
    "gui.howtos.talking.step_talesAnimateTalking": "Animuj mluvení",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Vyber jiné pozadí",
    "gui.howtos.talking.step_talesChooseSound": "Vyber si písničku k tanci",
    "gui.howtos.talking.step_talesDanceMoves": "Taneční pohyby",
    "gui.howtos.talking.step_talesAskAnswer": "Vezmi si bloky Otázka a Odpověď z kategorie Vnímání",
    "gui.howtos.add-sprite.name": " Přidej postavu",
    "gui.howtos.add-sprite.step_addSprite": " Přidej postavu",
    "gui.howtos.add-a-backdrop.name": "Přidej pozadí",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Přidej pozadí",
    "gui.howtos.change-size.name": "Změň velikost",
    "gui.howtos.change-size.step_changeSize": "Změň velikost",
    "gui.howtos.glide-around.name": "Klouzej okolo",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Klouzej okolo",
    "gui.howtos.change-size.step_glideAroundPoint": "Klouzej na místo",
    "gui.howtos.record-a-sound.name": "Nahraj zvuk",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klikni na záložku 'Zvuky'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikni na 'Nahraj'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Stiskni tlačítko Nahraj",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Vyber si svůj zvuk.",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Zahraj svůj zvuk",
    "gui.howtos.spin-video.name": "Roztoč to ",
    "gui.howtos.change-size.step_spinTurn": "Otoč",
    "gui.howtos.change-size.step_spinPointInDirection": "Nastav směr",
    "gui.howtos.hide-and-show.name": "Schovej se a ukaž se",
    "gui.howtos.change-size.step_hideAndShow": "Schovej se a ukaž se",
    "gui.howtos.switch-costume.name": "Animuj postavu",
    "gui.howtos.change-size.step_switchCostumes": "Animuj postavu",
    "gui.howtos.move-around-with-arrow-keys.name": "Použití šipkových kláves",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Pohybuj se vlevo a vpravo",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Pohybuj se nahoru a dolů",
    "gui.howtos.add-effects.name": "Přidej Efekty",
    "gui.howtos.videosens.step_addEffects": "Přidej efekty",
    "gui.extension.music.name": "Hudba",
    "gui.extension.music.description": "Hraní na nástroje a bicí.",
    "gui.extension.pen.name": "Pero",
    "gui.extension.pen.description": "Kreslení s tvými postavami.",
    "gui.extension.videosensing.name": "Vnímání videa",
    "gui.extension.videosensing.description": "Zjišťování pohybu kamerou.",
    "gui.extension.text2speech.name": "Text na hlas",
    "gui.extension.text2speech.description": "Nech svůj projekt mluvit.",
    "gui.extension.translate.name": "Překlad",
    "gui.extension.translate.description": "Překládání textu do mnoha jazyků.",
    "gui.extension.makeymakey.description": "Udělej vše do klíče.",
    "gui.extension.microbit.description": "Propojení tvých projektů se světem.",
    "gui.extension.microbit.connectingMessage": "Propojování",
    "gui.extension.ev3.description": "Stavění interaktivních robotů a mnoho dalšího.",
    "gui.extension.ev3.connectingMessage": "Propojuje se. Ujisti, se že PIN na svém EV3 máš nastavený na 1234.",
    "gui.extension.boost.description": "Oživit robotická stvoření.",
    "gui.extension.boost.connectingMessage": "Propojování",
    "gui.extension.wedo2.description": "Stavění s motory a čidly.",
    "gui.extension.wedo2.connectingMessage": "Propojování",
    "gui.extension.gdxfor.description": "Vnímá strkání, tažení, pohyb a točení.",
    "gui.extension.gdxfor.connectingMessage": "Propojování",
    "gui.libraryTags.all": "Všechno",
    "gui.libraryTags.animals": "Zvířata",
    "gui.libraryTags.dance": "Tanec",
    "gui.libraryTags.effects": "Efekty",
    "gui.libraryTags.fantasy": "Fantazie",
    "gui.libraryTags.fashion": "Móda",
    "gui.libraryTags.food": "Jídlo",
    "gui.libraryTags.indoors": "Uvnitř",
    "gui.libraryTags.loops": "Smyčky",
    "gui.libraryTags.music": "Hudba",
    "gui.libraryTags.notes": "Noty",
    "gui.libraryTags.outdoors": "Vnější",
    "gui.libraryTags.patterns": "Vzory",
    "gui.libraryTags.people": "Lidé",
    "gui.libraryTags.percussion": "Bicí",
    "gui.libraryTags.space": "Vesmír",
    "gui.libraryTags.sports": "Sporty",
    "gui.libraryTags.underwater": "Podvodní",
    "gui.libraryTags.voice": "Hlasy",
    "gui.libraryTags.wacky": "Divné",
    "gui.libraryTags.animation": "Animace",
    "gui.libraryTags.art": "Umění",
    "gui.libraryTags.games": "Hry",
    "gui.libraryTags.stories": "Příběhy",
    "gui.libraryTags.letters": "Písmena",
    "gui.opcodeLabels.direction": "směr",
    "gui.opcodeLabels.xposition": "x",
    "gui.opcodeLabels.yposition": "y",
    "gui.opcodeLabels.size": "velikost",
    "gui.opcodeLabels.costumename": "název kostýmu",
    "gui.opcodeLabels.costumenumber": "číslo kostýmu",
    "gui.opcodeLabels.backdropname": "název pozadí",
    "gui.opcodeLabels.backdropnumber": "číslo pozadí",
    "gui.opcodeLabels.volume": "hlasitost",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "odpověď",
    "gui.opcodeLabels.loudness": "hlasitost",
    "gui.opcodeLabels.username": "jméno uživatele",
    "gui.opcodeLabels.year": "rok",
    "gui.opcodeLabels.month": "měsíc",
    "gui.opcodeLabels.date": "den v měsíci",
    "gui.opcodeLabels.dayofweek": "den týdne",
    "gui.opcodeLabels.hour": "hodina",
    "gui.opcodeLabels.minute": "minuta",
    "gui.opcodeLabels.second": "sekunda",
    "gui.opcodeLabels.timer": "stopky",
    "gui.projectLoader.loadError": "Zvolený soubor projektu se nepodařilo nahrát.",
    "gui.sharedMessages.backdrop": "pozadí{index}",
    "gui.sharedMessages.costume": "kostým{index}",
    "gui.sharedMessages.sprite": "Postava{index}",
    "gui.sharedMessages.pop": "prask",
    "gui.sharedMessages.replaceProjectWarning": "Nahradit obsah aktuálního projektu?",
    "gui.sharedMessages.loadFromComputerTitle": "Načti z tvého počítače",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Můj projekt",
    "boost.color.any": "libovolná barva",
    "boost.color.black": "černá",
    "boost.color.blue": "modrá",
    "boost.color.green": "zelená",
    "boost.color.red": "červená",
    "boost.color.white": "bílá",
    "boost.color.yellow": "žlutá",
    "boost.getMotorPosition": "pozice motoru [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "úhel náklonu [TILT_DIRECTION]",
    "boost.motorDirection.backward": "jinak",
    "boost.motorDirection.forward": "takto",
    "boost.motorDirection.reverse": "pozpátku",
    "boost.motorOff": "vypni motor [MOTOR_ID]",
    "boost.motorOn": "zapni motor [MOTOR_ID]",
    "boost.motorOnFor": "zapni motor [MOTOR_ID] na [DURATION] sekundy",
    "boost.motorOnForRotation": "zapni motor [MOTOR_ID] na [ROTATION] otočky",
    "boost.seeingColor": "je vidět [COLOR] cihla?",
    "boost.setLightHue": "nastav barvu světla na [HUE]",
    "boost.setMotorDirection": "nastav směr motoru [MOTOR_ID] na [MOTOR_DIRECTION]",
    "boost.setMotorPower": "nastav rychlost motoru [MOTOR_ID] na [POWER] %",
    "boost.tiltDirection.any": "libovolný",
    "boost.tiltDirection.down": "dolů",
    "boost.tiltDirection.left": "vlevo",
    "boost.tiltDirection.right": "vpravo",
    "boost.tiltDirection.up": "nahoru",
    "boost.whenColor": "když je vidět [COLOR] cihla",
    "boost.whenTilted": "když nakloněný [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "hraj notu [NOTE] příštích [TIME] sekund",
    "ev3.buttonPressed": "je tlačítko [PORT] stisknuto?",
    "ev3.getBrightness": "jas",
    "ev3.getDistance": "vzdálenost",
    "ev3.getMotorPosition": "pozice motoru [PORT]",
    "ev3.motorSetPower": "nastav motoru [PORT] rychlost [POWER] %",
    "ev3.motorTurnClockwise": "toč motorem [PORT] ve směru hodin [TIME] sekund",
    "ev3.motorTurnCounterClockwise": "toč motorem [PORT] proti směru hodin [TIME] sekund",
    "ev3.whenBrightnessLessThan": "když je jas < [DISTANCE]",
    "ev3.whenButtonPressed": "po stisku tlačítka [PORT]",
    "ev3.whenDistanceLessThan": "když vzdálenost < [DISTANCE]",
    "gdxfor.getAcceleration": "zrychlení [DIRECTION]",
    "gdxfor.getForce": "síla",
    "gdxfor.getSpin": "rychlost otáčení [DIRECTION]",
    "gdxfor.getTilt": "úhel náklonu [TILT]",
    "gdxfor.isFreeFalling": "padá?",
    "gdxfor.isTilted": "nakloněné [TILT]?",
    "gdxfor.pulled": "tažený",
    "gdxfor.pushed": "tlačený",
    "gdxfor.shaken": "se třese",
    "gdxfor.startedFalling": "počátek pádu",
    "gdxfor.tiltDirectionMenu.any": "libovolný",
    "gdxfor.tiltDirectionMenu.back": "dozadu",
    "gdxfor.tiltDirectionMenu.front": "dopředu",
    "gdxfor.tiltDirectionMenu.left": "vlevo",
    "gdxfor.tiltDirectionMenu.right": "vpravo",
    "gdxfor.turnedFaceDown": "otočený lícem dolů",
    "gdxfor.turnedFaceUp": "otočený lícem nahoru",
    "gdxfor.whenForcePushedOrPulled": "když senzor síly [PUSH_PULL]",
    "gdxfor.whenGesture": "když [GESTURE]",
    "gdxfor.whenTilted": "když nakloněný [TILT]",
    "makeymakey.downArrow": "šipka dolů",
    "makeymakey.downArrowShort": "dolů",
    "makeymakey.leftArrow": "šipka vlevo",
    "makeymakey.leftArrowShort": "vlevo",
    "makeymakey.rightArrow": "šipka vpravo",
    "makeymakey.rightArrowShort": "vpravo",
    "makeymakey.spaceKey": "mezerník",
    "makeymakey.upArrow": "šipka nahoru",
    "makeymakey.upArrowShort": "nahoru",
    "makeymakey.whenKeyPressed": "když je stisknuta klávesa [KEY]",
    "makeymakey.whenKeysPressedInOrder": "když [SEQUENCE] stisknuto postupně",
    "microbit.buttonsMenu.any": "libovolný",
    "microbit.clearDisplay": "smaž displej",
    "microbit.defaultTextToDisplay": "Ahoj!",
    "microbit.displaySymbol": "zobraz [MATRIX]",
    "microbit.displayText": "displej textu [TEXT]",
    "microbit.gesturesMenu.jumped": "poskočí",
    "microbit.gesturesMenu.moved": "se pohne",
    "microbit.gesturesMenu.shaken": "se zatřese",
    "microbit.isButtonPressed": "tlačítko [BTN] stisknuto?",
    "microbit.isTilted": "nakloněno [DIRECTION]?",
    "microbit.pinStateMenu.off": "vypnuto",
    "microbit.pinStateMenu.on": "zapnuto",
    "microbit.tiltAngle": "úhel náklonu [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "libovolně",
    "microbit.tiltDirectionMenu.back": "dozadu",
    "microbit.tiltDirectionMenu.front": "dopředu",
    "microbit.tiltDirectionMenu.left": "vlevo",
    "microbit.tiltDirectionMenu.right": "vpravo",
    "microbit.whenButtonPressed": "po stisku tlačítka [BTN]",
    "microbit.whenGesture": "když [GESTURE]",
    "microbit.whenPinConnected": "když je pin [PIN] propojený",
    "microbit.whenTilted": "když nakloněný [DIRECTION]",
    "music.categoryName": "Hudba",
    "music.changeTempo": "změň tempo o [TEMPO]",
    "music.drumBass": "(2) Velký buben",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Uzavřený hi-hat",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Kravský zvonec",
    "music.drumCrashCymbal": "(4) Crash činel",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Tlesknutí",
    "music.drumOpenHiHat": "(5) Otevřený hi-hat",
    "music.drumSideStick": "(3) Okraj bubínku",
    "music.drumSnare": "(1) Malý bubínek virbl",
    "music.drumTambourine": "(7) Tamburína",
    "music.drumTriangle": "(12) Triangl",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Dřevěný blok",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Kontrabas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violoncello",
    "music.instrumentChoir": "(15) Sbor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Elektronická kytara",
    "music.instrumentElectricPiano": "(2) Elektronické piáno",
    "music.instrumentFlute": "(12) Flétna",
    "music.instrumentGuitar": "(4) Kytara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Hrací skříňka",
    "music.instrumentOrgan": "(3) Varhany",
    "music.instrumentPiano": "(1) Piáno",
    "music.instrumentPizzicato": "(7) Drnkání prstem",
    "music.instrumentSaxophone": "(11) Saxofon",
    "music.instrumentSteelDrum": "(18) Ocelový buben",
    "music.instrumentSynthLead": "(20) Syntetizátor sólo",
    "music.instrumentSynthPad": "(21) Syntetizátor pozadí",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Dřevěná flétna",
    "music.midiPlayDrumForBeats": "bubnuj [DRUM] příštích [BEATS] taktů",
    "music.midiSetInstrument": "nastav nástroj na [INSTRUMENT]",
    "music.playDrumForBeats": "bubnuj [DRUM] příštích [BEATS] taktů",
    "music.playNoteForBeats": "hraj notu [NOTE] příštích [BEATS] taktů",
    "music.restForBeats": "pauza [BEATS] taktů",
    "music.setInstrument": "nastav nástroj na [INSTRUMENT]",
    "music.setTempo": "nastav tempo na [TEMPO]",
    "pen.categoryName": "Pero",
    "pen.changeColorParam": "změň [COLOR_PARAM] pera o [VALUE]",
    "pen.changeHue": "změň barvu pera o [HUE]",
    "pen.changeShade": "změň odstín pera o [SHADE]",
    "pen.changeSize": "změň tloušťku pera o [SIZE]",
    "pen.clear": "smaž",
    "pen.colorMenu.brightness": "jas",
    "pen.colorMenu.color": "barva",
    "pen.colorMenu.saturation": "sytost",
    "pen.colorMenu.transparency": "průhlednost",
    "pen.penDown": "pero zapni",
    "pen.penUp": "pero vypni",
    "pen.setColor": "nastav barvu pera na [COLOR]",
    "pen.setColorParam": "nastav [COLOR_PARAM] pera na [VALUE]",
    "pen.setHue": "nastav barvu pera na [HUE]",
    "pen.setShade": "nastav odstín pera na [SHADE]",
    "pen.setSize": "nastav tloušťku pera na [SIZE]",
    "pen.stamp": "otiskni se",
    "speech.defaultWhenIHearValue": "do toho",
    "speech.extensionName": "Převod řeči na text",
    "speech.listenAndWait": "poslouchej a čekej",
    "speech.speechReporter": "řeč",
    "speech.whenIHear": "když slyším [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text na hlas",
    "text2speech.defaultTextToSpeak": "ahoj",
    "text2speech.giant": "obr",
    "text2speech.kitten": "kotě",
    "text2speech.setLanguageBlock": "nastav jazyk na [LANGUAGE]",
    "text2speech.setVoiceBlock": "nastav hlas na [VOICE]",
    "text2speech.speakAndWaitBlock": "řekni [WORDS]",
    "text2speech.squeak": "kvik",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Překlad",
    "translate.defaultTextToTranslate": "ahoj",
    "translate.translateBlock": "přelož [WORDS] do [LANGUAGE]",
    "translate.viewerLanguage": "jazyk",
    "videoSensing.categoryName": "Vnímání videa",
    "videoSensing.direction": "směr",
    "videoSensing.motion": "pohyb",
    "videoSensing.off": "vypni",
    "videoSensing.on": "zapni",
    "videoSensing.onFlipped": "na převrácené straně",
    "videoSensing.setVideoTransparency": "nastav průhlednost videa na [TRANSPARENCY]",
    "videoSensing.sprite": "postava",
    "videoSensing.stage": "scéna",
    "videoSensing.videoOn": "video [ATTRIBUTE] na [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] video",
    "videoSensing.whenMotionGreaterThan": "při pohybu na videu > [REFERENCE]",
    "wedo2.getDistance": "vzdálenost",
    "wedo2.getTiltAngle": "úhel náklonu [TILT_DIRECTION]",
    "wedo2.isTilted": "nakloněno [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "proti směru hodin",
    "wedo2.motorDirection.forward": "po směru hodin",
    "wedo2.motorDirection.reverse": "pozpátku",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "všechny motory",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "vypni [MOTOR_ID]",
    "wedo2.motorOn": "zapni [MOTOR_ID]",
    "wedo2.motorOnFor": "zapni [MOTOR_ID] na [DURATION] sekund",
    "wedo2.playNoteFor": "hraj notu [NOTE] příštích [DURATION] sekund",
    "wedo2.setLightHue": "nastav barvu světla na [HUE]",
    "wedo2.setMotorDirection": "nastav [MOTOR_ID] směrem [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "pro [MOTOR_ID] nastav rychlost  [POWER]",
    "wedo2.tiltDirection.any": "libovolně",
    "wedo2.tiltDirection.down": "dolů",
    "wedo2.tiltDirection.left": "vlevo",
    "wedo2.tiltDirection.right": "vpravo",
    "wedo2.tiltDirection.up": "nahoru",
    "wedo2.whenDistance": "když vzdálenost [OP] [REFERENCE]",
    "wedo2.whenTilted": "když nakloněný [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Barva",
    "paint.paintEditor.saturation": "Sytost",
    "paint.paintEditor.brightness": "Světlost",
    "paint.paintEditor.costume": "Kostým",
    "paint.paintEditor.group": "Seskupit",
    "paint.paintEditor.ungroup": "Odskupit",
    "paint.paintEditor.undo": "Vrátit",
    "paint.paintEditor.redo": "Znovu provést",
    "paint.paintEditor.forward": "Dopředu",
    "paint.paintEditor.backward": "Dozadu",
    "paint.paintEditor.front": "Dopředu",
    "paint.paintEditor.back": "Zpět",
    "paint.paintEditor.more": "Více",
    "paint.modeTools.brushSize": "Velikost",
    "paint.modeTools.eraserSize": "Velikost gumy",
    "paint.modeTools.copy": "Zkopírovat",
    "paint.modeTools.paste": "Vložit",
    "paint.modeTools.delete": "Odstranit",
    "paint.modeTools.curved": "Zakřivit",
    "paint.modeTools.pointed": "Zašpičatět",
    "paint.modeTools.thickness": "Tloušťka",
    "paint.modeTools.flipHorizontal": "Přetočit horizontálně",
    "paint.modeTools.flipVertical": "Přetočit vertikálně",
    "paint.modeTools.filled": "Výplň",
    "paint.modeTools.outlined": "Obrys",
    "paint.paintEditor.bitmap": "Převést do bitmapy",
    "paint.paintEditor.vector": "Převeď na vektor",
    "paint.paintEditor.fill": "Vyplnit",
    "paint.paintEditor.stroke": "Obrys",
    "paint.brushMode.brush": "Štětec",
    "paint.eraserMode.eraser": "Guma",
    "paint.fillMode.fill": "Vyplnit",
    "paint.lineMode.line": "Úsečka",
    "paint.ovalMode.oval": "Kružnice",
    "paint.rectMode.rect": "Obdélník",
    "paint.reshapeMode.reshape": "Změna tvaru",
    "paint.roundedRectMode.roundedRect": "Zaoblený obdélník",
    "paint.selectMode.select": "Výběr",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Záměna"
  },
  "cy": {
    "gui.alerts.lostPeripheralConnection": "Mae Scratch wedi colli cysylltiad â {extensionName}.",
    "gui.alerts.tryAgain": "Ceisio Eto",
    "gui.alerts.download": "Llwytho i lawr",
    "gui.connection.reconnect": "Ailgysyslltu",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Pecyn Cefn",
    "gui.backpack.errorBackpack": "Gwall wrth lwytho'r pecyn cefn",
    "gui.backpack.loadingBackpack": "Llwytho...",
    "gui.backpack.more": "Rhagor",
    "gui.backpack.emptyBackpack": "Mae pecyn cefn yn wag",
    "gui.unsupportedBrowser.label": "Nid yw eich porwr yn cael ei gynnal",
    "gui.unsupportedBrowser.errorLabel": "Digwyddodd gwall",
    "gui.unsupportedBrowser.notRecommended": "Mae'n ddrwg gennym ond mae'n ymddangos eich bod yn defnyddio fersiwn o borwr nad yw Scratch yn ei gynnal. Rydym yn argymell eich bod yn diweddaru i'r fersiynau diweddaraf o borwyr sy'n cael eu cynnal fel Google Chrome, Mozilla Firefox, Microsoft Edge neu Apple Safari.",
    "gui.unsupportedBrowser.description": "Mae'n ddrwg gennym ond nid yw Scratch yn cynnal y porwr hwn. Rydym yn argymell eich bod yn diweddaru i'r fersiynau diweddaraf o borwyr sy'n cael eu cynnal fel Google Chrome, Mozilla Firefox, Microsoft Edge neu Apple Safari.",
    "gui.unsupportedBrowser.back": "Nôl",
    "gui.unsupportedBrowser.previewfaq": "I wybod mwy, ewch i {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Cwestiynau Cyffredin",
    "gui.cards.all-tutorials": "Tiwtorialau",
    "gui.cards.shrink": "Lleihau",
    "gui.cards.expand": "Ehangu",
    "gui.cards.close": "Cau",
    "gui.cards.more-things-to-try": "Pethau eraill i'w gwneud!",
    "gui.cards.see-more": "Gweld rhagor",
    "gui.comingSoon.message1": "Peidiwch poeni, rydym wrthi {emoji}",
    "gui.comingSoon.message2": "Yn Dod Cyn Bo Hir",
    "gui.comingSoon.message3": "Rydym yn gweithio arno {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Heb ganfod dyfais",
    "gui.connection.auto-scanning.prescan": "Cadwch eich dyfais wrth law, yna cychwyn chwilio.",
    "gui.connection.auto-scanning.pressbutton": "Pwyswch y botwm ar eich dyfais.",
    "gui.connection.auto-scanning.start-search": "Cychwyn Chwilio",
    "gui.connection.connecting-searchbutton": "Chwilio...",
    "gui.connection.auto-scanning.try-again": "Ceisio eto",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Wedi cysylltu",
    "gui.connection.disconnect": "Datgysylltu",
    "gui.connection.go-to-editor": "Mynd i'r Golygydd",
    "gui.connection.connecting-cancelbutton": "Cysylltu...",
    "gui.connection.error.errorMessage": "Wps! Aeth rhywbeth o'i le",
    "gui.connection.error.tryagainbutton": "Ceisio eto",
    "gui.connection.error.helpbutton": "Cymorth",
    "gui.connection.peripheral-name-label": "Enw dyfais",
    "gui.connection.connect": "Cysylltu",
    "gui.connection.scanning.lookingforperipherals": "Chwilio am ddyfeisiau",
    "gui.connection.scanning.noPeripheralsFound": "Heb ganfod dyfais",
    "gui.connection.scanning.instructions": "Dewis y ddyfais o'r rhestr uchod",
    "gui.connection.search": "Adnewyddu",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Gwnewch yn siwr fod Scratch Link wedi ei osod ac yn rhedeg",
    "gui.connection.unavailable.enablebluetooth": "Gwirio fod Bluetooth wedi ei alluogi",
    "gui.connection.unavailable.tryagainbutton": "Ceisio eto",
    "gui.connection.unavailable.helpbutton": "Cymorth",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Mynd",
    "gui.controls.stop": "Aros",
    "gui.crashMessage.label": "Wps! Aeth rhywbeth o'i le",
    "gui.crashMessage.description": "Ymddiheuriadau ond mae'n ymddangos fod Scratch wedi chwalu. Mae'r gwall wedi ei adrodd yn awtomatig i Dîm Scratch. Adnewyddwch eich tudalen i geisio eto.",
    "gui.crashMessage.errorNumber": "Cofnodwyd eich gwall gydag id {errorId}",
    "gui.crashMessage.reload": "Ail-lwytho",
    "gui.customProcedures.myblockModalTitle": "Creu Bloc",
    "gui.customProcedures.addAnInputNumberText": "Ychwanegu mewnbwn",
    "gui.customProcedures.numberTextType": "rhif neu destun",
    "gui.customProcedures.addAnInputBoolean": "Ychwanegu mewnbwn",
    "gui.customProcedures.booleanType": "boole",
    "gui.customProcedures.addALabel": "Ychwanegwch label",
    "gui.customProcedures.runWithoutScreenRefresh": "Yn rhedeg heb adnewyddu'r sgrin",
    "gui.customProcedures.cancel": "Diddymu",
    "gui.customProcedures.ok": "Iawn",
    "gui.SpriteInfo.direction": "Cyfeiriad",
    "gui.directionPicker.rotationStyles.allAround": "O Amgylch",
    "gui.directionPicker.rotationStyles.leftRight": "Chwith/De",
    "gui.directionPicker.rotationStyles.dontRotate": "Peidiwch troi",
    "gui.gui.addExtension": "Ychwanegu Estyniad",
    "gui.gui.codeTab": "Cod",
    "gui.gui.backdropsTab": "Cefnlenni",
    "gui.gui.costumesTab": "Gwisgoedd",
    "gui.gui.soundsTab": "Seiniau",
    "gui.extensionLibrary.comingSoon": "Yn Dod Cyn Bo Hir",
    "gui.extensionLibrary.requires": "Angen",
    "gui.extensionLibrary.collaboration": "Cydweithio gyda",
    "gui.library.filterPlaceholder": "Chwilio",
    "gui.library.allTag": "Y Cyfan",
    "gui.loader.message1": "Creu blociau …",
    "gui.loader.message2": "Yn llwytho ciplun ...",
    "gui.loader.message3": "Yn llwytho seiniau …",
    "gui.loader.message4": "Yn llwytho estyniadau …",
    "gui.loader.message5": "Casglu cathod …",
    "gui.loader.message6": "Darlledu nanos …",
    "gui.loader.message7": "Enchwythu gobos …",
    "gui.loader.message8": "Paratoi emojis …",
    "gui.loader.headline": "Llwytho Project",
    "gui.loader.creating": "Yn Creu Project",
    "gui.accountMenu.profile": "Proffil",
    "gui.accountMenu.myStuff": "Fy Mhethau",
    "gui.accountMenu.myClasses": "Fy Nosbarthiadau",
    "gui.accountMenu.myClass": "Fy Nosbarth",
    "gui.accountMenu.accountSettings": "Gosodiadau cyfrif",
    "gui.accountMenu.signOut": "Allgofnodi",
    "gui.authorInfo.byUser": "gan {username}",
    "gui.menuBar.seeProjectPage": "Gweld y Dudalen Project",
    "gui.menuBar.language": "Language",
    "general.username": "Enw defnyddwir",
    "general.password": "Cyfrinair",
    "general.signIn": "Mewngofnodi",
    "login.needHelp": "Angen Cymorth?",
    "form.validationRequired": "Mae'r maes yma'n angenrheidiol",
    "gui.menuBar.tutorialsLibrary": "Tiwtorialau",
    "gui.menuBar.restoreSprite": "Adfer Corlun",
    "gui.menuBar.restoreSound": "Adfer Sain",
    "gui.menuBar.restoreCostume": "Adfer Gwisg",
    "gui.menuBar.restore": "Adfer",
    "gui.menuBar.saveNow": "Cadw nawr",
    "gui.menuBar.saveAsCopy": "Cadw fel copi",
    "gui.menuBar.remix": "Ailgymysgu",
    "gui.menuBar.new": "Newydd",
    "gui.menuBar.file": "Ffeil",
    "gui.menuBar.downloadToComputer": "Cadw i'ch cyfrifiadur",
    "gui.menuBar.edit": "Golygu",
    "gui.menuBar.turboModeOff": "Diffodd y Modd Tyrbo",
    "gui.menuBar.turboModeOn": "`Cychwyn y Modd Tyrbo",
    "gui.menuBar.modeMenu": "Modd",
    "gui.menuBar.normalMode": "Modd arferol",
    "gui.menuBar.caturdayMode": "Modd Cathddydd",
    "gui.menuBar.joinScratch": "Ymuno â Scratch",
    "gui.menuBar.signIn": "Mewngofnodi",
    "gui.gui.projectTitlePlaceholder": "Teitl project yma",
    "gui.menuBar.saveNowLink": "Cadw Nawr",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Wedi eu Rhannu",
    "gui.menuBar.share": "Rhannu",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Cymorth",
    "gui.modal.back": "Nôl",
    "gui.monitor.listMonitor.empty": "(gwag)",
    "gui.monitor.listMonitor.listLength": "hyd {length}",
    "gui.monitor.contextMenu.default": "darlleniad arferol",
    "gui.monitor.contextMenu.large": "sgrîn fawr",
    "gui.monitor.contextMenu.slider": "llithrydd",
    "gui.monitor.contextMenu.sliderRange": "newid ystod llithrydd",
    "gui.monitor.contextMenu.import": "mewnforio",
    "gui.monitor.contextMenu.export": "allforio",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Chwarae",
    "gui.playButton.stop": "Aros",
    "gui.gui.variableScopeOptionAllSprites": "Ar gyfer pob ciplun",
    "gui.gui.variableScopeOptionSpriteOnly": "Ar gyfer y ciplun yma'n unig",
    "gui.gui.cloudVariableOption": "Newidyn cwmwl (cedwir ar y gweinydd)",
    "gui.gui.variablePromptAllSpritesMessage": "Bydd y newidyn yma ar gael ar gyfer pob corlun.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Diddymu",
    "gui.prompt.ok": "Iawn",
    "gui.playbackStep.stopMsg": "Aros",
    "gui.playbackStep.playMsg": "Chwarae",
    "gui.playbackStep.loadingMsg": "Llwytho...",
    "gui.playbackStep.saveMsg": "Cadw",
    "gui.playbackStep.reRecordMsg": "Ail Recordio",
    "gui.recordModal.title": "Recordio Sain",
    "gui.recordingStep.beginRecord": "Cychwyn recordio drwy glicio ar y botwm isod",
    "gui.recordingStep.permission": "{arrow}Rydym angen eich caniatâd i ddefnyddio eich meicroffon",
    "gui.recordingStep.stop": "Atal y recordio",
    "gui.recordingStep.record": "Recordio",
    "gui.sliderModal.min": "Lleiafswm gwerth",
    "gui.sliderModal.max": "Uchafswm gwerth",
    "gui.sliderModal.title": "Newid ystod llithrydd",
    "gui.sliderPrompt.cancel": "Diddymu",
    "gui.sliderPrompt.ok": "Iawn",
    "gui.soundEditor.sound": "Sain",
    "gui.soundEditor.play": "Chwarae",
    "gui.soundEditor.stop": "Aros",
    "gui.soundEditor.copy": "Copïo",
    "gui.soundEditor.paste": "Gludo",
    "gui.soundEditor.copyToNew": "Copïo i'r Newydd",
    "gui.soundEditor.delete": "Dileu",
    "gui.soundEditor.save": "Cadw",
    "gui.soundEditor.undo": "Dadwneud",
    "gui.soundEditor.redo": "Ailwneud",
    "gui.soundEditor.faster": "Yn gyflymach",
    "gui.soundEditor.slower": "Arafach",
    "gui.soundEditor.echo": "Atsain",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Yn uwch",
    "gui.soundEditor.softer": "Yn feddalach",
    "gui.soundEditor.reverse": "Gwrthdroi",
    "gui.soundEditor.fadeOut": "Pylu allan",
    "gui.soundEditor.fadeIn": "Pylu mewn",
    "gui.soundEditor.mute": "Tewi",
    "gui.SpriteInfo.spritePlaceholder": "Enw",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Ciplun",
    "gui.SpriteInfo.show": "Dangos",
    "gui.SpriteInfo.size": "Maint",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dyblygu",
    "gui.spriteSelectorItem.contextMenuExport": "allforio",
    "gui.spriteSelectorItem.contextMenuDelete": "dileu",
    "gui.spriteSelector.addSpriteFromLibrary": "Dewiswch Gorlun",
    "gui.spriteSelector.addSpriteFromPaint": "Paentio",
    "gui.spriteSelector.addSpriteFromSurprise": "Annisgwyl",
    "gui.spriteSelector.addSpriteFromFile": "Llwytho Corlun i Fyny",
    "gui.stageHeader.stageSizeLarge": "Newid i lwyfan mawr",
    "gui.stageHeader.stageSizeSmall": "Newid i lwyfan bach",
    "gui.stageHeader.stageSizeFull": "Mynd i'r modd sgrin llawn",
    "gui.stageHeader.stageSizeUnFull": "Gadael y modd sgrin llawn",
    "gui.stageHeader.fullscreenControl": "Rheolydd Sgrin Llawn",
    "gui.spriteSelector.addBackdropFromLibrary": "Dewiswch Gefnlen",
    "gui.stageSelector.addBackdropFromPaint": "Paent",
    "gui.stageSelector.addBackdropFromSurprise": "Annisgwyl",
    "gui.stageSelector.addBackdropFromFile": "Llwytho'r Gefnlen i Fyny",
    "gui.stageSelector.stage": "Llwyfan",
    "gui.stageSelector.backdrops": "Cefnlenni",
    "gui.telemetryOptIn.label": "Adrodd ystadegau er mwyn gwella Scratch",
    "gui.telemetryOptIn.body1": "Mae Tîm Scratch yn chwilio'n barhaus am ffyrdd i ddeall yn well sut mae Scratch yn cael ei ddefnyddio o amgylch y byd. I helpu i gefnogi'r ymdrech, gallwch ganiatáu i Scratch anfon manylion defnydd at Dîm Scratch.",
    "gui.telemetryOptIn.body2": "Mae'rr manylion rydym ynn eu casglu yn cynnwys dewis iaith, dewis blociau a rhai digwyddiadau fel, cadw, llwytho a llwytho project i fyny. NID YDYM yn casglu unrhyw fanylion personol. Darllenwch ein  {privacyPolicyLink} am ragor o wybodaeth.",
    "gui.telemetryOptIn.privacyPolicyLink": "Polisi Preifatrwydd",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Modd Tyrbo",
    "gui.webglModal.label": "Nid yw eich Porwr yn Cynnal WebGL",
    "gui.webglModal.description": "Yn anffodus, mae'n edrych mai eich porwr neu gyfrifiadur {webGlLink}. Mae angen y dechnoleg yma i redeg Scratch 3.0",
    "gui.webglModal.webgllink": "nid yw'#n cynnal WebGL",
    "gui.webglModal.back": "Nôl",
    "gui.webglModal.previewfaq": "I wybod mwy, ewch i {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Cwestiynau Cyffredin",
    "gui.costumeLibrary.chooseABackdrop": "Dewiswch Gefnlen",
    "gui.costumeLibrary.chooseACostume": "Dewiswch Wisg",
    "gui.costumeTab.addBackdropFromLibrary": "Dewiswch Gefnlen",
    "gui.costumeTab.addCostumeFromLibrary": "Dewiswch Wisg",
    "gui.costumeTab.addBlankCostume": "Paentio",
    "gui.costumeTab.addSurpriseCostume": "Annisgwyl",
    "gui.costumeTab.addFileBackdrop": "Llwytho Cefnlen i Fyny",
    "gui.costumeTab.addFileCostume": "Llwytho Gwisg i Fyny",
    "gui.extensionLibrary.chooseAnExtension": "Dewis Estyniad",
    "gui.extensionLibrary.extensionUrl": "Rhowch URL yr estyniad",
    "gui.monitors.importListColumnPrompt": "Pa golofn ddylai gael ei defnyddio (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Methwyd cychwyn recordio",
    "gui.soundLibrary.chooseASound": "Dewiswch Sain",
    "gui.soundTab.fileUploadSound": "Llwytho Sain i Fyny...",
    "gui.soundTab.surpriseSound": "Annisgwyl",
    "gui.soundTab.recordSound": "Recordio",
    "gui.soundTab.addSoundFromLibrary": "Dewis Sain",
    "gui.spriteLibrary.chooseASprite": "Dewis Corlun",
    "gui.tipsLibrary.tutorials": "Dewis Tiwtorial",
    "gui.alerts.createsuccess": "Project newydd wedi'i greu",
    "gui.alerts.createcopysuccess": "Project wedi ei gadw fel copi.",
    "gui.alerts.createremixsuccess": "Project wedi'i gadw fel ailgymysgiad.",
    "gui.alerts.creating": "Creu un newydd...",
    "gui.alerts.creatingCopy": "Copïo project...",
    "gui.alerts.creatingRemix": "Ailgymysgu project...",
    "gui.alerts.creatingError": "Methu creu'r project. Ceisiwch eto!",
    "gui.alerts.savingError": "Methodd y project gadw.",
    "gui.alerts.savesuccess": "Project wedi'i gadw.",
    "gui.alerts.saving": "Yn cadw project...",
    "gui.alerts.cloudInfo": "Sylwch, dim ond rhifau, nid llythrennau na symbolau mae amrywiolion cwmwl yn eu cynnal. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Dysgu rhagor.",
    "gui.alerts.importing": "Mewnforio...",
    "gui.defaultProject.meow": "Miaw",
    "gui.defaultProject.variable": "fy newidyn",
    "gui.howtos.intro-move-sayhello-hat.name": "Cychwyn Arni",
    "gui.howtos.intro-move.step_stepMove": "Ychwanegu bloc symud",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animeiddio Enw",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Dewis Corlun Llythyren",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Chwarae Sain Wrth Glicio",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Dewis Corlun Llythyren Arall",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Newid lliw",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Dewiswch Corlun Llythyren Arall a'i Wneud i Droi",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Dewis Corlun Llythyren Arall a Gwneud Iddo Dyfu",
    "gui.howtos.imagine": "Dychmygwch Fyd",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Teipio Beth Rydych am ei Ddweud",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Cliciwch y Faner Werdd i Gychwyn",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Dewiswch Unrhyw Gefnlen",
    "gui.howtos.imagine.step_imagineChooseSprite": "Dewiswch Unrhyw Gorlun",
    "gui.howtos.imagine.step_imagineFlyAround": "Pwyswch y Bylchwr i Lithro",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Dewiswch Gorlun Arall",
    "gui.howtos.imagine.step_imagineLeftRight": "Symud Chwith-De",
    "gui.howtos.imagine.step_imagineUpDown": "Symud i Fyny-i Lawr",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Newid Gwisgoedd",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Llithro i Bwynt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Tyfu a Lleihau",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Dewiswch Gefnlen Arall",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Newid Cefnlenni",
    "gui.howtos.imagine.step_imagineRecordASound": "Ychwanegu Sain",
    "gui.howtos.imagine.step_imagineChooseSound": "Dewiswch Eich Sain",
    "gui.howtos.make-music.name": "Creu Cerddoriaeth",
    "gui.howtos.Make-Music.step_PickInstrument": "Dewis Corlun Offeryn",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Chware Sain Wrth ei Glicio",
    "gui.howtos.Make-Music.step_MakeSong": "Creu Cân",
    "gui.howtos.make-music.step_MakeBeat": "Dewis Drwm a Chreu Curiad",
    "gui.howtos.make-music.step_MakeBeatBox": "Dewiswch y Corlun Meicroffon a'r Blwch Taro Annisgwyl",
    "gui.howtos.story.name": "Creu Stori",
    "gui.howtos.story.step_addbg": "Ychwanegu Cefnlen",
    "gui.howtos.story.step_addsprite": "Ychwanegu Cymeriad",
    "gui.howtos.story.step_saysomething": "Dweud Rhywbeth",
    "gui.howtos.story.step_addanothersprite": "Ychwanegu Cymeriad Arall",
    "gui.howtos.story.step_flip": "Newid Cyfeiriad",
    "gui.howtos.story.step_conversation": "Cael Sgwrs",
    "gui.howtos.story.addanotherbg": "Ychwanegu Cefnlen Arall",
    "gui.howtos.story.step_swithbg": "Newid Cefnlenni",
    "gui.howtos.story.step_hidewizard": "Cuddio Cymeriad",
    "gui.howtos.story.step_showwizard": "Dangos Cymeriad",
    "gui.howtos.make-a-chase-game.name": "Creu Gêm Ymlid",
    "gui.howtos.Chase-Game.step_BG": "Ychwanegu Cefndir",
    "gui.howtos.chase-game.step_AddOcto": "Ychwanegu Corlun",
    "gui.howtos.make-music.step_LeftRight": "Symud i'r Dde a'r Chwith gyda'r Bysellau Saeth",
    "gui.howtos.Chase-Game.step_UpDown": "Symud i Fyny ac i Lawr gyda Bysellau Saeth",
    "gui.howtos.Chase-Game.step_AddStar": "Ychwanegu Corlun Arall",
    "gui.howtos.Chase-Game.step_MoveRandom": "Symud ar Hap",
    "gui.howtos.Chase-Game.step_WhenTouch": "Mewn Corlun Octopws, Pan yn Cyffwrdd Chwaraea Sain ",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Creu Newidyn Sgôr",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Yn y Corlun Octopws, Pan yn Cyffwrdd Ychwanega Sgôr",
    "gui.howtos.animate-char.name": "Animeiddio Cymeriad",
    "gui.howtos.animate-char.step_addbg": "Ychwanegu Cefnlen",
    "gui.howtos.animate-char.step_addsprite": "Ychwanegu Corlun",
    "gui.howtos.animate-char.step_saysomething": "Dweud Rhywbeth",
    "gui.howtos.animate-char.step_addsound": "Ychwanegu Sain",
    "gui.howtos.animate-char.step_animatetalking": "Animeiddio Siarad",
    "gui.howtos.animate-char.step_arrowkeys": "Symud gan Ddefnyddio'r Bysellau Saeth",
    "gui.howtos.animate-char.step_jump": "Neidio",
    "gui.howtos.animate-char.step_changecolor": "Newid Lliw",
    "gui.howtos.make-a-game.name": "Creu Gêm Cliciwr",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Dewis Corlun",
    "gui.howtos.make-a-game.step_GamePlaySound": "Chware Sain Wrth ei Glicio",
    "gui.howtos.make-a-game.step_GameAddScore": "Creu Newidyn Sgôr",
    "gui.howtos.make-a-game.step_GameChangeScore": "Pan Fydd Wedi ei Glicio, Cynyddu'r Sgor",
    "gui.howtos.make-a-game.step_Random": "Mynd i fan ar hap",
    "gui.howtos.make-music.step_GameChangeColor": "Newid Lliw",
    "gui.howtos.make-music.step_ResetScore": "Ailosod y Sgôr",
    "gui.howtos.make-it-fly.name": "Gwneud Iddo Hedfan",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Dewis Cefndir Awyr",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Dewis Cymeriad",
    "gui.howtos.fly.step_stepflySaySomething": "Dweud Rhywbeth",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Symud gyda Bysellau Saeth",
    "gui.howtos.fly.step_stepflyChooseObject": "Dewis Gwrthrych i'w Gasglu",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Gwnewch i Wrthrych Symud",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Dewiswch Eich Cymeriad",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ychwanegwch Sgôr",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Cadw Sgôr",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ychwanegu Golygfa",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Symud yr Olygfa",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Gwisg Nesaf",
    "gui.howtos.pong": "Gêm Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Ychwanegu Cefnlen",
    "gui.howtos.pong.step_pongAddBallSprite": "Ychwanegu Corlun Pêl",
    "gui.howtos.pong.step_pongBounceAround": "Bownsio o Amgylch",
    "gui.howtos.pong.step_pongAddPaddle": "Ychwanegu Rodlen",
    "gui.howtos.pong.step_pongMoveThePaddle": "Symud y Rhodlen",
    "gui.howtos.pong.step_pongSelectBallSprite": "Dewis Corlun Pêl",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ychwanegu Cod i Fownsio'r Bêl Oddi ar y Rhodlen",
    "gui.howtos.pong.step_pongAddAScore": "Ychwanegu Sgôr",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Dewis 'Sgôr' o'r Ddewislen",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Mewnosod y Bloc 'Newid Sgôr'",
    "gui.howtos.pong.step_pongResetScore": "Ailosod y Sgôr",
    "gui.howtos.pong.step_pongAddLineSprite": "Ychwanegu'r Corlun Llinell",
    "gui.howtos.pong.step_pongGameOver": "Gêm Drosodd",
    "gui.howtos.code-cartoon": "Codio Cartŵn",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dweud Rhywbeth Pan Fyddwch yn Clicio'r Faner Werdd.",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animeiddio Cymeriad Pan Fyddwch yn ei Glicio",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Dewiswch Gymeriad Gwahanol",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Defnyddiwch Arwydd Minws i Fynd yn Llai",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Gwneud i Gymeriad Dyfu a Lleihau",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Dewiswch Gymeriad Gwahanol",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Neidio i Fyny ac i Lawr",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Cliciwch ar Gymeriad i Newid Golygfa",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Llithro o Amgylch",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Newid Gwisgoedd",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Dewiswch Rhagor o Gymeriadau i'w Hychwanegu at eich Cartŵn",
    "gui.howtos.cartoon-network": "Animeiddio Gêm Antur",
    "gui.howtos.cartoon-network.step_CNcharacter": "Dewis pa Gymeriad i'w Ddangos",
    "gui.howtos.cartoon-network.step_CNsay": "Dweud Rhywbeth",
    "gui.howtos.cartoon-network.step_CNglide": "Llithro o Amgylch",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Dewis pa Wrthrych i Redeg ar ei Ôl",
    "gui.howtos.cartoon-network.step_CNcollect": "Casglu Gwrthrychau",
    "gui.howtos.cartoon-network.step_CNvariable": "Creu Newidyn Sgôr",
    "gui.howtos.cartoon-network.step_CNscore": "Cadw Sgôr",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Lefel i Fyny: Newid Cefnlen",
    "gui.howtos.videosens.name": "Synhwyro Fideo",
    "gui.howtos.videosens.step_addextension": "Ychwanegu Estyniad",
    "gui.howtos.videosens.step_pet": "Mwytho'r Gath",
    "gui.howtos.videosens.step_animate": "Animeiddio",
    "gui.howtos.videosens.step_pop": "Popio Balŵn",
    "gui.howtos.say-it-out-loud": "Creu Animeiddiadau sy'n Siarad",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ychwanegu'r Testun i Flociau Siarad",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dweud Rhywbeth",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Gosod Llais",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Symud o Amgylch",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ychwanegu Cefnlen",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ychwanegu Cymeriad Arall",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Canu Cân",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Newid Lliw",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Troelli",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Tyfu a Lleihau",
    "gui.howtos.talking": "Chwedleua",
    "gui.howtos.talking.step_talesAddExtension": "Cliciwch i Ychwanegu'r Blociau Testun i Lais",
    "gui.howtos.talking.step_talesChooseSprite": "Dewis Corlun",
    "gui.howtos.talking.step_talesSaySomething": "Gwneud i Gymeriad Siarad",
    "gui.howtos.talking.step_talesChooseBackdrop": "Dewiswch Gefnlen",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Cliciwch ar Gymeriad i Fynd i'r Gefnlen Nesaf",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Dewiswch Gorlun Arall",
    "gui.howtos.talking.step_talesMoveAround": "Symud o Amgylch",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Dewiswch Gefnlen Arall",
    "gui.howtos.talking.step_talesAnimateTalking": "Animeiddio Siarad",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Dewiswch Gefnlen Arall",
    "gui.howtos.talking.step_talesChooseSound": "Dewiswch Gân i Ddawnsio Iddi",
    "gui.howtos.talking.step_talesDanceMoves": "Symudiadau Dawnsio",
    "gui.howtos.talking.step_talesAskAnswer": "Estyn y Blociau Gofyn ac Ateb o'r Categori Synhwyro",
    "gui.howtos.add-sprite.name": "Ychwanegu Corlun",
    "gui.howtos.add-sprite.step_addSprite": "Ychwanegu Corlun",
    "gui.howtos.add-a-backdrop.name": "Ychwanegu Cefnlen",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ychwanegu Cefnlen",
    "gui.howtos.change-size.name": "Newid Maint",
    "gui.howtos.change-size.step_changeSize": "Newid Maint",
    "gui.howtos.glide-around.name": "Llithro o Amgylch",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Llithro o Amgylch",
    "gui.howtos.change-size.step_glideAroundPoint": "Llithro i Bwynt",
    "gui.howtos.record-a-sound.name": "Recordio Sain",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Cliciwch ar y Tab 'Seiniau'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Cliciwch 'Recordio'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pwyswch y Botwm Recordio",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Dewis Eich Sain",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Chwaraewch eich Sain",
    "gui.howtos.spin-video.name": "Gwnewch iddo Droelli",
    "gui.howtos.change-size.step_spinTurn": "Troi",
    "gui.howtos.change-size.step_spinPointInDirection": "Gosod Cyfeiriad",
    "gui.howtos.hide-and-show.name": "Cuddio a Dangos",
    "gui.howtos.change-size.step_hideAndShow": "Cuddio a Dangos",
    "gui.howtos.switch-costume.name": "Animeiddio Corlun",
    "gui.howtos.change-size.step_switchCostumes": "Animeiddio Corlun",
    "gui.howtos.move-around-with-arrow-keys.name": "Defnyddiwch y Botymau Saeth",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Symud i'r Chwith a'r Dde",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Symud i Fyny ac i Lawr",
    "gui.howtos.add-effects.name": "Ychwanegu Effeithiau",
    "gui.howtos.videosens.step_addEffects": "Ychwanegu Effeithiau",
    "gui.extension.music.name": "Cerddoriaeth",
    "gui.extension.music.description": "Chwarae offerynau a drymiau",
    "gui.extension.pen.name": "Pin",
    "gui.extension.pen.description": "Lluniadu gyda'ch corluniau.",
    "gui.extension.videosensing.name": "Synhwyro Fideo",
    "gui.extension.videosensing.description": "Synhwyro symudiad gyda'r camera",
    "gui.extension.text2speech.name": "Testun i Leferydd",
    "gui.extension.text2speech.description": "Gwnewch i'ch projectau siarad.",
    "gui.extension.translate.name": "Cyfieithu",
    "gui.extension.translate.description": "Cyfieithu testun i lawer o ieithoedd.",
    "gui.extension.makeymakey.description": "Gwneud unrhywbeth yn allwedd.",
    "gui.extension.microbit.description": "Cysylltu eich project â'r byd.",
    "gui.extension.microbit.connectingMessage": "Cysylltu",
    "gui.extension.ev3.description": "Adeiladu robotiaid rhyngweithiol a mwy.",
    "gui.extension.ev3.connectingMessage": "Wrthi'n cysylltu. Gwnewch yn siwr fod y PIN ar eich EV3 wedi ei osod i 1234.",
    "gui.extension.boost.description": "Dod â creadigaethau robotig yn fyw.",
    "gui.extension.boost.connectingMessage": "Cysylltu",
    "gui.extension.wedo2.description": "Adeiladu gyda moduron a synwyryddion",
    "gui.extension.wedo2.connectingMessage": "Cysylltu",
    "gui.extension.gdxfor.description": "Synhwyro gwthio, tynnu, symudiad a throelli.",
    "gui.extension.gdxfor.connectingMessage": "Cysylltu",
    "gui.libraryTags.all": "Y Cyfan",
    "gui.libraryTags.animals": "Anifeiliaid",
    "gui.libraryTags.dance": "Dawns",
    "gui.libraryTags.effects": "Effeithiau",
    "gui.libraryTags.fantasy": "Ffantasi",
    "gui.libraryTags.fashion": "Ffasiwn",
    "gui.libraryTags.food": "Bwyd",
    "gui.libraryTags.indoors": "Dan do",
    "gui.libraryTags.loops": "Cylchoedd",
    "gui.libraryTags.music": "Cerddoriaeth",
    "gui.libraryTags.notes": "Nodiadau",
    "gui.libraryTags.outdoors": "Tu allan",
    "gui.libraryTags.patterns": "Patrymau",
    "gui.libraryTags.people": "Pobl",
    "gui.libraryTags.percussion": "Offerynnau taro",
    "gui.libraryTags.space": "Gofod",
    "gui.libraryTags.sports": "Chwaraeon",
    "gui.libraryTags.underwater": "O dan y dŵr",
    "gui.libraryTags.voice": "Llais",
    "gui.libraryTags.wacky": "Gwirion",
    "gui.libraryTags.animation": "Animeiddio",
    "gui.libraryTags.art": "Celf",
    "gui.libraryTags.games": "Gemau",
    "gui.libraryTags.stories": "Straeon",
    "gui.libraryTags.letters": "Llythyrau",
    "gui.opcodeLabels.direction": "cyfeiriad",
    "gui.opcodeLabels.xposition": "safle x",
    "gui.opcodeLabels.yposition": "safle y",
    "gui.opcodeLabels.size": "maint",
    "gui.opcodeLabels.costumename": "enw'r wisg",
    "gui.opcodeLabels.costumenumber": "rhif gwisg",
    "gui.opcodeLabels.backdropname": "enw cefnlen",
    "gui.opcodeLabels.backdropnumber": "rhif cefnlen",
    "gui.opcodeLabels.volume": "lefel sain",
    "gui.opcodeLabels.tempo": "amseriad",
    "gui.opcodeLabels.answer": "ateb",
    "gui.opcodeLabels.loudness": "cryfder sain",
    "gui.opcodeLabels.username": "enw defnyddiwr",
    "gui.opcodeLabels.year": "blwyddyn",
    "gui.opcodeLabels.month": "mis",
    "gui.opcodeLabels.date": "dyddiad",
    "gui.opcodeLabels.dayofweek": "diwrnod o'r wythnos",
    "gui.opcodeLabels.hour": "awr",
    "gui.opcodeLabels.minute": "munud",
    "gui.opcodeLabels.second": "eiliad",
    "gui.opcodeLabels.timer": "amserydd",
    "gui.projectLoader.loadError": "Methodd y ffeil sydd wedi ei dewis â llwytho.",
    "gui.sharedMessages.backdrop": "cefnlen {index}",
    "gui.sharedMessages.costume": "gwisg{index}",
    "gui.sharedMessages.sprite": "Corlun{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Newid cynnwys y project hwn?",
    "gui.sharedMessages.loadFromComputerTitle": "Llwytho o'ch cyfrifiadur",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Project Scratch",
    "boost.color.any": "unrhyw liw",
    "boost.color.black": "du",
    "boost.color.blue": "glas",
    "boost.color.green": "gwyrdd",
    "boost.color.red": "coch",
    "boost.color.white": "gwyn",
    "boost.color.yellow": "melyn",
    "boost.getMotorPosition": "safle [MOTOR_REPORTER_ID]  modur",
    "boost.getTiltAngle": "ongl gogwyddo [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ffordd acw",
    "boost.motorDirection.forward": "ffordd yma",
    "boost.motorDirection.reverse": "gwrthdroi",
    "boost.motorOff": "diffodd [MOTOR_ID]",
    "boost.motorOn": "cychwyn [MOTOR_ID]",
    "boost.motorOnFor": "cychwyn [MOTOR_ID] am [DURATION] eiliad",
    "boost.motorOnForRotation": "cychwyn [MOTOR_ID] am [ROTATION] troad",
    "boost.seeingColor": "gweld bric [COLOR]?",
    "boost.setLightHue": "gosod lliw'r golau i [HUE]",
    "boost.setMotorDirection": "gosod cyfeiriad modur [MOTOR_ID] i [MOTOR_DIRECTION]",
    "boost.setMotorPower": "gosod cyflymder modur [MOTOR_ID] i [POWER]",
    "boost.tiltDirection.any": "unrhyw",
    "boost.tiltDirection.down": "i lawr",
    "boost.tiltDirection.left": "chwith",
    "boost.tiltDirection.right": "de",
    "boost.tiltDirection.up": "i fyny",
    "boost.whenColor": "pan welir bric [COLOR] ",
    "boost.whenTilted": "pan mae wedi ei ogwyddo [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "bipio nodyn [NOTE] am [TIME]eiliad",
    "ev3.buttonPressed": "botwm [PORT] wedi ei bwyso?",
    "ev3.getBrightness": "disgleirdeb",
    "ev3.getDistance": "pellter",
    "ev3.getMotorPosition": "safle [PORT]modur  ",
    "ev3.motorSetPower": "gosod pŵer modur [PORT] i [POWER] %",
    "ev3.motorTurnClockwise": "modur [PORT] yn troi ffordd hyn am [TIME] eiliad",
    "ev3.motorTurnCounterClockwise": "modur [PORT] yn troi ffordd yna am [TIME] eiliad",
    "ev3.whenBrightnessLessThan": "pan mae'r disgleirdeb < [DISTANCE]",
    "ev3.whenButtonPressed": "pan mae'r botwm [PORT]yn cael ei bwyso",
    "ev3.whenDistanceLessThan": "pan mae'r pellter < [DISTANCE]",
    "gdxfor.getAcceleration": "cyflymu [DIRECTION]",
    "gdxfor.getForce": "grym",
    "gdxfor.getSpin": "cyflymder troelli [DIRECTION]",
    "gdxfor.getTilt": "ongl gogwyddo [TILT]",
    "gdxfor.isFreeFalling": "yn syrthio?",
    "gdxfor.isTilted": "gogwyddo [TILT]?",
    "gdxfor.pulled": "tynnwyd",
    "gdxfor.pushed": "gwthiwyd",
    "gdxfor.shaken": "ysgydwyd",
    "gdxfor.startedFalling": "wedi cychwyn syrthio",
    "gdxfor.tiltDirectionMenu.any": "unrhyw",
    "gdxfor.tiltDirectionMenu.back": "cefn",
    "gdxfor.tiltDirectionMenu.front": "blaen",
    "gdxfor.tiltDirectionMenu.left": "chwith",
    "gdxfor.tiltDirectionMenu.right": "de",
    "gdxfor.turnedFaceDown": "wedi ei droi'n wyneb i waered",
    "gdxfor.turnedFaceUp": "wedi ei droi wyneb i fyny",
    "gdxfor.whenForcePushedOrPulled": "pan mae synhwyrydd grym [PUSH_PULL]",
    "gdxfor.whenGesture": "pan [GESTURE]",
    "gdxfor.whenTilted": "pan mae wedi gogwyddo [TILT]",
    "makeymakey.downArrow": "saeth i lawr",
    "makeymakey.downArrowShort": "i lawr",
    "makeymakey.leftArrow": "saeth chwith",
    "makeymakey.leftArrowShort": "chwith",
    "makeymakey.rightArrow": "saeth de",
    "makeymakey.rightArrowShort": "de",
    "makeymakey.spaceKey": "bwlch",
    "makeymakey.upArrow": "saeth i fyny",
    "makeymakey.upArrowShort": "i fyny",
    "makeymakey.whenKeyPressed": "pan mae [KEY] allwedd wedi'i phwyso",
    "makeymakey.whenKeysPressedInOrder": "pan mae [SEQUENCE] wedi'i bwyso mewn trefn",
    "microbit.buttonsMenu.any": "unrhyw",
    "microbit.clearDisplay": "clirio'r dangosydd",
    "microbit.defaultTextToDisplay": "Helo!",
    "microbit.displaySymbol": "dangos [MATRIX]",
    "microbit.displayText": "dangos testun [TEXT]",
    "microbit.gesturesMenu.jumped": "neidiodd",
    "microbit.gesturesMenu.moved": "symudodd",
    "microbit.gesturesMenu.shaken": "ysgydwyd",
    "microbit.isButtonPressed": "botwm [BTN] wedi ei bwyso?",
    "microbit.isTilted": "[DIRECTION] ar ogwydd?",
    "microbit.pinStateMenu.off": "i ffwrdd",
    "microbit.pinStateMenu.on": "ymlaen",
    "microbit.tiltAngle": "ongl gogwydd [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "unrhyw",
    "microbit.tiltDirectionMenu.back": "cefn",
    "microbit.tiltDirectionMenu.front": "blaen",
    "microbit.tiltDirectionMenu.left": "chwith",
    "microbit.tiltDirectionMenu.right": "de",
    "microbit.whenButtonPressed": "pan mae botwm [BTN] yn cael ei bwyso",
    "microbit.whenGesture": "pan [GESTURE]",
    "microbit.whenPinConnected": "pan mae pin [PIN] wedi ei gysylltu",
    "microbit.whenTilted": "pan mae wedi gogwyddo i'r [DIRECTION]",
    "music.categoryName": "Cerddoriaeth",
    "music.changeTempo": "Newid tempo gan [TEMPO]",
    "music.drumBass": "(2) Drwm Bas",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Clafiau",
    "music.drumClosedHiHat": "(^) Symbalau Pedal Troed Caeëdig",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cloch Buwch",
    "music.drumCrashCymbal": "(4) Symbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Clap Llaw",
    "music.drumOpenHiHat": "(5) Symbalau Pedal Troed Agored",
    "music.drumSideStick": "(3) Pren ochr",
    "music.drumSnare": "(1) Drwm Gwifrau",
    "music.drumTambourine": "(7) Tambwrîn",
    "music.drumTriangle": "(12) Triongl",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Bloc Pren",
    "music.getTempo": "amseriad",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Basŵn",
    "music.instrumentCello": "(8) Sielo",
    "music.instrumentChoir": "(15) Côr",
    "music.instrumentClarinet": "(10) Clarinét",
    "music.instrumentElectricGuitar": "(5) Gitâr Drydan",
    "music.instrumentElectricPiano": "(2) Piano Trydan",
    "music.instrumentFlute": "(12) Ffliwt",
    "music.instrumentGuitar": "(4) Gitâr",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Blwch Cerddoriaeth",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Sacsoffon",
    "music.instrumentSteelDrum": "(18) Drwm Dur",
    "music.instrumentSynthLead": "(20) Synth Blaen",
    "music.instrumentSynthPad": "(21) Pad Synth",
    "music.instrumentTrombone": "(9) Trombôn",
    "music.instrumentVibraphone": "(16) Fibraffon",
    "music.instrumentWoodenFlute": "(13) Ffliwt Pren",
    "music.midiPlayDrumForBeats": "chwarae drwm [DRUM] am [BEATS] guriad",
    "music.midiSetInstrument": "gosod offeryn i [INSTRUMENT]",
    "music.playDrumForBeats": "chwarae drwm [DRUM] am [BEATS] curiad",
    "music.playNoteForBeats": "chwarae nodyn[NOTE]am [BEATS]curiad",
    "music.restForBeats": "oedi am [BEATS]curiad",
    "music.setInstrument": "gosod offeryn i [INSTRUMENT]",
    "music.setTempo": "gosod tempo [TEMPO]",
    "pen.categoryName": "Pin",
    "pen.changeColorParam": "newid pin [COLOR_PARAM]gan [VALUE]",
    "pen.changeHue": "newid lliw pin gan [HUE]",
    "pen.changeShade": "newid arlliw pin gan [SHADE]",
    "pen.changeSize": "newid maint pin gan [SIZE]",
    "pen.clear": "dileu popeth",
    "pen.colorMenu.brightness": "disgleirdeb",
    "pen.colorMenu.color": "lliw",
    "pen.colorMenu.saturation": "dirlawnder",
    "pen.colorMenu.transparency": "tryloywder",
    "pen.penDown": "pin i lawr",
    "pen.penUp": "pin i fyny",
    "pen.setColor": "gosod lliw pin i [COLOR]",
    "pen.setColorParam": "gosod y pin [COLOR_PARAM]i [VALUE]",
    "pen.setHue": "gosod lliw pin i [HUE]",
    "pen.setShade": "gosod arlliw pin i [SHADE]",
    "pen.setSize": "gosod maint pin i [SIZE]",
    "pen.stamp": "stampio",
    "speech.defaultWhenIHearValue": "ffwrdd a ni",
    "speech.extensionName": "Lleferydd i Destun",
    "speech.listenAndWait": "gwrando ac aros",
    "speech.speechReporter": "lleferydd",
    "speech.whenIHear": "pan fydda i'n clywed [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Testun i Leferydd",
    "text2speech.defaultTextToSpeak": "helo",
    "text2speech.giant": "cawr",
    "text2speech.kitten": "cath fach",
    "text2speech.setLanguageBlock": "gosod iaith i [LANGUAGE]",
    "text2speech.setVoiceBlock": "gosod llais i [VOICE]",
    "text2speech.speakAndWaitBlock": "siarad [WORDS]",
    "text2speech.squeak": "gwich",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Cyfieithu",
    "translate.defaultTextToTranslate": "helo",
    "translate.translateBlock": "cyfieithu[WORDS] i'r [LANGUAGE]",
    "translate.viewerLanguage": "iaith",
    "videoSensing.categoryName": "Synhwyro Fideo",
    "videoSensing.direction": "cyfeiriad",
    "videoSensing.motion": "symudiad",
    "videoSensing.off": "i ffwrdd",
    "videoSensing.on": "ymlaen",
    "videoSensing.onFlipped": "wrth ei fflipio",
    "videoSensing.setVideoTransparency": "gosod tryloywder fideo i [TRANSPARENCY]",
    "videoSensing.sprite": "corlun",
    "videoSensing.stage": "llwyfan",
    "videoSensing.videoOn": "fideo [ATTRIBUTE] ar [SUBJECT]",
    "videoSensing.videoToggle": "troi fideo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "pan mae symud fideo > [REFERENCE]",
    "wedo2.getDistance": "pellter",
    "wedo2.getTiltAngle": "ongl gogwyddo [TILT_DIRECTION]",
    "wedo2.isTilted": "wedi ei ogwyddo [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ffordd acw",
    "wedo2.motorDirection.forward": "ffordd yma",
    "wedo2.motorDirection.reverse": "gwrthdroi",
    "wedo2.motorId.a": "modur A",
    "wedo2.motorId.all": "pob modur",
    "wedo2.motorId.b": "modur B",
    "wedo2.motorId.default": "modur",
    "wedo2.motorOff": "diffodd [MOTOR_ID]",
    "wedo2.motorOn": "cychwyn [MOTOR_ID]",
    "wedo2.motorOnFor": "cychwyn [MOTOR_ID] am [DURATION] eiliad",
    "wedo2.playNoteFor": "chwarae nodyn [NOTE] am [DURATION] eiliad",
    "wedo2.setLightHue": "gosod lliw'r golau i [HUE]",
    "wedo2.setMotorDirection": "gosod cyfeiriad [MOTOR_ID] i [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "gosod pŵer [MOTOR_ID] i [POWER]",
    "wedo2.tiltDirection.any": "unrhyw",
    "wedo2.tiltDirection.down": "i lawr",
    "wedo2.tiltDirection.left": "chwith",
    "wedo2.tiltDirection.right": "de",
    "wedo2.tiltDirection.up": "i fyny",
    "wedo2.whenDistance": "pam mae'r pellter [OP] [REFERENCE]",
    "wedo2.whenTilted": "pan mae wedi ei ogwyddo [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Lliw",
    "paint.paintEditor.saturation": "Dirlawnder",
    "paint.paintEditor.brightness": "Disgleirdeb",
    "paint.paintEditor.costume": "Gwisg",
    "paint.paintEditor.group": "Grŵp",
    "paint.paintEditor.ungroup": "Dad-grwpio",
    "paint.paintEditor.undo": "Dadwneud",
    "paint.paintEditor.redo": "Ailwneud",
    "paint.paintEditor.forward": "Ymlaen",
    "paint.paintEditor.backward": "Nôl",
    "paint.paintEditor.front": "Blaen",
    "paint.paintEditor.back": "Nôl",
    "paint.paintEditor.more": "Rhagor",
    "paint.modeTools.brushSize": "Maint",
    "paint.modeTools.eraserSize": "Maint rhwbiwr",
    "paint.modeTools.copy": "Copïo",
    "paint.modeTools.paste": "Gludo",
    "paint.modeTools.delete": "Dileu",
    "paint.modeTools.curved": "Crwm",
    "paint.modeTools.pointed": "Gyda Blaen",
    "paint.modeTools.thickness": "Trwch",
    "paint.modeTools.flipHorizontal": "Fflipio'n Llorweddol",
    "paint.modeTools.flipVertical": "Fflipio'n Fertigol",
    "paint.modeTools.filled": "Llanwyd",
    "paint.modeTools.outlined": "Amlinellwyd",
    "paint.paintEditor.bitmap": "Trosi i Ddidfap",
    "paint.paintEditor.vector": "Trosi i Fector",
    "paint.paintEditor.fill": "Llanw",
    "paint.paintEditor.stroke": "Amlinell",
    "paint.brushMode.brush": "Brwsh",
    "paint.eraserMode.eraser": "Rhwbiwr",
    "paint.fillMode.fill": "Llanw",
    "paint.lineMode.line": "Llinell",
    "paint.ovalMode.oval": "Cylch",
    "paint.rectMode.rect": "Petryal",
    "paint.reshapeMode.reshape": "Ail siapio",
    "paint.roundedRectMode.roundedRect": "Petryal Crwm",
    "paint.selectMode.select": "Dewis",
    "paint.textMode.text": "Testun",
    "paint.colorPicker.swap": "Cyfnewid"
  },
  "da": {
    "gui.alerts.lostPeripheralConnection": "Scratch har tabt forbindelsen til {extensionName}.",
    "gui.alerts.tryAgain": "Prøv igen",
    "gui.alerts.download": "Gem",
    "gui.connection.reconnect": "Forbind igen",
    "gui.backpack.costumeLabel": "kostume",
    "gui.backpack.soundLabel": "lyd",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Rygsæk",
    "gui.backpack.errorBackpack": "Fejl, kan ikke indlæse rygsækken",
    "gui.backpack.loadingBackpack": "Indlæser ...",
    "gui.backpack.more": "Mere",
    "gui.backpack.emptyBackpack": "Rygsækken er tom",
    "gui.unsupportedBrowser.label": "Browseren kan ikke bruges",
    "gui.unsupportedBrowser.errorLabel": "Der opstod en fejl",
    "gui.unsupportedBrowser.notRecommended": "Desværre det ser ud som om, at du bruger en version af en browser, som Scratch ikke understøtter. Vi anbefaler, at du opdaterer din browser til den seneste version af Google Chrome, Mozilla Firefox, Microsoft Edge, eller Apple Safari.",
    "gui.unsupportedBrowser.description": "Desværre Scratch understøtter ikke denne browser. Vi anbefaler, at du opdaterer din browser til den seneste version af Google Chrome, Mozilla Firefox, Microsoft Edge, eller Apple Safari.",
    "gui.unsupportedBrowser.back": "Tilbage",
    "gui.unsupportedBrowser.previewfaq": "For at lære mere, gå til {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Vejledninger",
    "gui.cards.shrink": "Mindre",
    "gui.cards.expand": "Udvid",
    "gui.cards.close": "Luk",
    "gui.cards.more-things-to-try": "Flere ting, som du kan prøve!",
    "gui.cards.see-more": "Se mere",
    "gui.comingSoon.message1": "Du skal ikke bekymre dig, vi arbejder på sagen {emoji}",
    "gui.comingSoon.message2": "Kommer snart...",
    "gui.comingSoon.message3": "Vi arbejder på sagen {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Ingen enheder fundet",
    "gui.connection.auto-scanning.prescan": "Stil din enhed tæt på, derefter begynd at søge",
    "gui.connection.auto-scanning.pressbutton": "Tryk på knappen på din device",
    "gui.connection.auto-scanning.start-search": "Start søgningen",
    "gui.connection.connecting-searchbutton": "Søger...",
    "gui.connection.auto-scanning.try-again": "Prøv igen",
    "gui.connection.auto-scanning.updatePeripheralButton": "Opdatér min enhed",
    "gui.connection.connected": "Forbundet",
    "gui.connection.disconnect": "Afbryd",
    "gui.connection.go-to-editor": "Gå til editor",
    "gui.connection.connecting-cancelbutton": "Forbinder...",
    "gui.connection.error.errorMessage": "Ups, det ser ud som om at noget gik galt.",
    "gui.connection.error.tryagainbutton": "Prøv igen",
    "gui.connection.error.helpbutton": "Hjælp",
    "gui.connection.peripheral-name-label": "Navn på enhed",
    "gui.connection.connect": "Forbind",
    "gui.connection.scanning.lookingforperipherals": "Søger efter enheder",
    "gui.connection.scanning.noPeripheralsFound": "Ingen enheder fundet",
    "gui.connection.scanning.instructions": "Vælg din enhed fra listen herover.",
    "gui.connection.search": "Opdater",
    "gui.connection.scanning.updatePeripheralButton": "Opdatér min enhed",
    "gui.connection.unavailable.installscratchlink": "Vær sikker på at Scratch linket er installeret og kører",
    "gui.connection.unavailable.enablebluetooth": "Tjek at Bluetooth er slået til",
    "gui.connection.unavailable.tryagainbutton": "Prøv igen",
    "gui.connection.unavailable.helpbutton": "Hjælp",
    "gui.connection.updatePeripheral.microBitConnect": "Forbind din {extensionName} til denne enhed med et USB kabel.",
    "gui.connection.updatePeripheral.pressUpdate": "Tryk på \"Start opdatering\" og vent indtil opdateringen er gennemført.",
    "gui.connection.updatePeripheral.progress": "Opdaterer {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Opdateringen lykkes!",
    "gui.connection.updatePeripheral.updateFailed": "Opdatering mislykkedes",
    "gui.connection.updatePeripheral.goBackButton": "Gå tilbage",
    "gui.connection.updatePeripheral.updateNowButton": "Start opdatering",
    "gui.connection.updatePeripheral.updateAgainButton": "Prøv igen",
    "gui.controls.go": "Gå",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Ups! Noget gik galt.",
    "gui.crashMessage.description": "Vi er kede af det, men det ser ud som om at Scratch er gået ned. Denne fejl er automatisk blevet sendt til Scratch Teamet. Prøv at genindlæse siden.",
    "gui.crashMessage.errorNumber": "Din fejl er registreret med id {errorId}",
    "gui.crashMessage.reload": "Genindlæs",
    "gui.customProcedures.myblockModalTitle": "Lav en brik",
    "gui.customProcedures.addAnInputNumberText": "Tilføj input",
    "gui.customProcedures.numberTextType": "tal eller tekst",
    "gui.customProcedures.addAnInputBoolean": "Tilføj input",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Tilføj en label",
    "gui.customProcedures.runWithoutScreenRefresh": "Kør uden skærmopdatering",
    "gui.customProcedures.cancel": "Annuller",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Retning",
    "gui.directionPicker.rotationStyles.allAround": "Alle retninger",
    "gui.directionPicker.rotationStyles.leftRight": "Venstre/højre",
    "gui.directionPicker.rotationStyles.dontRotate": "Drej ikke",
    "gui.gui.addExtension": "Tilføj udvidelse",
    "gui.gui.codeTab": "Kode",
    "gui.gui.backdropsTab": "Baggrunde",
    "gui.gui.costumesTab": "Kostumer",
    "gui.gui.soundsTab": "Lyde",
    "gui.extensionLibrary.comingSoon": "Kommer snart",
    "gui.extensionLibrary.requires": "Kræver",
    "gui.extensionLibrary.collaboration": "Samarbejde med",
    "gui.library.filterPlaceholder": "Søg",
    "gui.library.allTag": "Alle",
    "gui.loader.message1": "Laver brikker ...",
    "gui.loader.message2": "Indlæser sprites ...",
    "gui.loader.message3": "Indlæser lyde ...",
    "gui.loader.message4": "Indlæser udvidelser ...",
    "gui.loader.message5": "Passer katte ...",
    "gui.loader.message6": "Transmitterer nanos ...",
    "gui.loader.message7": "Puster gobos op ...",
    "gui.loader.message8": "Forbereder emojis …",
    "gui.loader.headline": "Indlæser projekt",
    "gui.loader.creating": "Laver projekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Mine ting",
    "gui.accountMenu.myClasses": "Mine klasser",
    "gui.accountMenu.myClass": "Min klasse",
    "gui.accountMenu.accountSettings": "Kontoindstillinger",
    "gui.accountMenu.signOut": "Log ud",
    "gui.authorInfo.byUser": "af {username}",
    "gui.menuBar.seeProjectPage": "Se projekt side",
    "gui.menuBar.language": "Sprog",
    "general.username": "Brugernavn",
    "general.password": "Kodeord",
    "general.signIn": "Log på",
    "login.needHelp": "Brug for hjælp?",
    "form.validationRequired": "Dette felt skal udfyldes",
    "gui.menuBar.tutorialsLibrary": "Vejledninger",
    "gui.menuBar.restoreSprite": "Gendan Sprite",
    "gui.menuBar.restoreSound": "Gendan lyd",
    "gui.menuBar.restoreCostume": "Gendan kostume",
    "gui.menuBar.restore": "Gendan",
    "gui.menuBar.saveNow": "Gem nu",
    "gui.menuBar.saveAsCopy": "Gem som kopi",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Ny",
    "gui.menuBar.file": "Fil",
    "gui.menuBar.downloadToComputer": "Gem på din computer",
    "gui.menuBar.edit": "Redigér",
    "gui.menuBar.turboModeOff": "Slå turbo fra",
    "gui.menuBar.turboModeOn": "Sæt turbo på",
    "gui.menuBar.modeMenu": "Indstillinger",
    "gui.menuBar.normalMode": "Normal",
    "gui.menuBar.caturdayMode": "Katte",
    "gui.menuBar.joinScratch": "Meld dig ind i Scratch",
    "gui.menuBar.signIn": "Log på",
    "gui.gui.projectTitlePlaceholder": "Skriv projektets navn her",
    "gui.menuBar.saveNowLink": "Gem nu",
    "gui.menuBar.settings": "Indstillinger",
    "gui.menuBar.isShared": "Delte",
    "gui.menuBar.share": "Del",
    "gui.menuBar.colorMode": "Farvevalg",
    "gui.modal.help": "Hjælp",
    "gui.modal.back": "Tilbage",
    "gui.monitor.listMonitor.empty": "(tom)",
    "gui.monitor.listMonitor.listLength": "længde {length}",
    "gui.monitor.contextMenu.default": "normal visning",
    "gui.monitor.contextMenu.large": "stor visning",
    "gui.monitor.contextMenu.slider": "skyder",
    "gui.monitor.contextMenu.sliderRange": "ændre på skyderens rækkevidde",
    "gui.monitor.contextMenu.import": "importer",
    "gui.monitor.contextMenu.export": "eksporter",
    "gui.monitor.contextMenu.hide": "skjul",
    "gui.playButton.play": "Leg",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "For alle sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Kun for denne sprite",
    "gui.gui.cloudVariableOption": "Sky variabler (gemt på server)",
    "gui.gui.variablePromptAllSpritesMessage": "Denne variabel kan bruges ved alle sprites.",
    "gui.gui.listPromptAllSpritesMessage": "Denne liste kan bruges ved alle sprites.",
    "gui.prompt.cancel": "Annuller",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Spil",
    "gui.playbackStep.loadingMsg": "Indlæser ...",
    "gui.playbackStep.saveMsg": "Gem",
    "gui.playbackStep.reRecordMsg": "Optag igen",
    "gui.recordModal.title": "Optag lyd",
    "gui.recordingStep.beginRecord": "Begynd at optage ved at klikke på knappen herunder",
    "gui.recordingStep.permission": "{arrow}Vi skal bruge din tilladelse til at bruge din mikrofon",
    "gui.recordingStep.stop": "Stop med at optage",
    "gui.recordingStep.record": "Optag",
    "gui.sliderModal.min": "Minimumsværdi",
    "gui.sliderModal.max": "Maksimumværdi",
    "gui.sliderModal.title": "Ændre på skyderens rækkevidde",
    "gui.sliderPrompt.cancel": "Annuller",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Lyd",
    "gui.soundEditor.play": "Spil",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Kopier",
    "gui.soundEditor.paste": "Sæt ind",
    "gui.soundEditor.copyToNew": "Kopier til ny",
    "gui.soundEditor.delete": "Slet",
    "gui.soundEditor.save": "Gem",
    "gui.soundEditor.undo": "Fortryd",
    "gui.soundEditor.redo": "Gør om",
    "gui.soundEditor.faster": "Hurtigere",
    "gui.soundEditor.slower": "Langsommere",
    "gui.soundEditor.echo": "Ekko",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Højere",
    "gui.soundEditor.softer": "Blødere",
    "gui.soundEditor.reverse": "Baglæns",
    "gui.soundEditor.fadeOut": "Nedtoning",
    "gui.soundEditor.fadeIn": "Optoning",
    "gui.soundEditor.mute": "Slå lyden fra",
    "gui.SpriteInfo.spritePlaceholder": "Navn",
    "gui.SpriteInfo.showSpriteAction": "Vis sprite",
    "gui.SpriteInfo.hideSpriteAction": "Skjul sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Vis",
    "gui.SpriteInfo.size": "Størrelse",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kopier",
    "gui.spriteSelectorItem.contextMenuExport": "eksporter",
    "gui.spriteSelectorItem.contextMenuDelete": "slet",
    "gui.spriteSelector.addSpriteFromLibrary": "Vælg en sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Tegn",
    "gui.spriteSelector.addSpriteFromSurprise": "Overraskelse",
    "gui.spriteSelector.addSpriteFromFile": "Hent sprite",
    "gui.stageHeader.stageSizeLarge": "Skift til stor scene",
    "gui.stageHeader.stageSizeSmall": "Skift til lille scene",
    "gui.stageHeader.stageSizeFull": "Gå til fuld skærm",
    "gui.stageHeader.stageSizeUnFull": "Gå ud af fuld skærm",
    "gui.stageHeader.fullscreenControl": "Fuld skærm",
    "gui.spriteSelector.addBackdropFromLibrary": "Vælg en baggrund",
    "gui.stageSelector.addBackdropFromPaint": "Tegn",
    "gui.stageSelector.addBackdropFromSurprise": "Overraskelse",
    "gui.stageSelector.addBackdropFromFile": "Hent baggrund",
    "gui.stageSelector.stage": "Scene",
    "gui.stageSelector.backdrops": "Baggrunde",
    "gui.telemetryOptIn.label": "Rapporter statistik for at forbedre Scratch",
    "gui.telemetryOptIn.body1": "Scratch Teamet prøver altid på at blive bedre til at forstå hvordan Scratch bliver brugt rundt omkring i verden. For at støtte dette arbejde kan du give tilladelse til, at Scratch automatisk sender information til Scratch Teamet om hvordan du bruger det.",
    "gui.telemetryOptIn.body2": "Dén information som vi indsamler, inkluderer sprogvalg, brugen af brikker og nogle funktioner såsom at gemme, åbne og uploade et projekt. . Vi indsamler IKKE personlige informationer. Se vores politik om personlige oplysninger {privacyPolicyLink} hvis du vil vide mere.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politik om private oplysninger",
    "gui.telemetryOptIn.optInText": "Del mine brugsdata med Scratch Teamet",
    "gui.telemetryOptIn.optInTooltip": "Aktivér telemetri",
    "gui.telemetryOptIn.optOutText": "Del ikke mine brugsdata med Scratch Teamet",
    "gui.telemetryOptIn.optOutTooltip": "Deaktivér telemetri",
    "gui.telemetryOptIn.settingWasUpdated": "Dine indstillinger er opdateret.",
    "gui.telemetryOptIn.buttonClose": "Luk",
    "gui.turboMode.active": "Sæt turbo på",
    "gui.webglModal.label": "Din browser understøtter ikke WebGL",
    "gui.webglModal.description": "Det ser desværre ud som om at din browser eller computer {webGlLink}. Denne teknologi er nødvendigt for at kunne bruge Scratch 3.0.",
    "gui.webglModal.webgllink": "understøtter ikke WebGL",
    "gui.webglModal.back": "Tilbage",
    "gui.webglModal.previewfaq": "For at lære mere, gå til {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Vælg en baggrund",
    "gui.costumeLibrary.chooseACostume": "Vælg et kostume",
    "gui.costumeTab.addBackdropFromLibrary": "Vælg en baggrund",
    "gui.costumeTab.addCostumeFromLibrary": "Vælg et kostume",
    "gui.costumeTab.addBlankCostume": "Tegn",
    "gui.costumeTab.addSurpriseCostume": "Overraskelse",
    "gui.costumeTab.addFileBackdrop": "Hent baggrund",
    "gui.costumeTab.addFileCostume": "Hent kostume",
    "gui.extensionLibrary.chooseAnExtension": "Vælg en udvidelse",
    "gui.extensionLibrary.extensionUrl": "Indtast udvidelsens URL",
    "gui.monitors.importListColumnPrompt": "Hvilken kolonne skal bruges (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Kunne ikke starte optagelsen",
    "gui.soundLibrary.chooseASound": "Vælg en lyd",
    "gui.soundTab.fileUploadSound": "Hent lyd",
    "gui.soundTab.surpriseSound": "Overraskelse",
    "gui.soundTab.recordSound": "Optag",
    "gui.soundTab.addSoundFromLibrary": "Vælg en lyd",
    "gui.spriteLibrary.chooseASprite": "Vælg en sprite",
    "gui.tipsLibrary.tutorials": "Vælg en vejledning",
    "gui.alerts.createsuccess": "Et nyt projekt er lavet.",
    "gui.alerts.createcopysuccess": "Projekt gemt som en kopi.",
    "gui.alerts.createremixsuccess": "Projekt gemt som et remix.",
    "gui.alerts.creating": "Laver nyt...",
    "gui.alerts.creatingCopy": "Kopierer projekt...",
    "gui.alerts.creatingRemix": "Remixer projekt...",
    "gui.alerts.creatingError": "Kunne ikke lave projektet. Prøv igen!",
    "gui.alerts.savingError": "Projektet kunne ikke gemmes.",
    "gui.alerts.savesuccess": "Projekt er gemt.",
    "gui.alerts.saving": "Gemmer projekt...",
    "gui.alerts.cloudInfo": "Vær opmærksom på at sky variabler kun kan indeholde tal, ikke bogstaver eller symboler. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lær mere.",
    "gui.alerts.importing": "Importerer...",
    "gui.defaultProject.meow": "Mijav",
    "gui.defaultProject.variable": "min variabel",
    "gui.howtos.intro-move-sayhello-hat.name": "Kom i gang",
    "gui.howtos.intro-move.step_stepMove": "Tilføj en gå brik",
    "gui.howtos.add-a-move-block.step_stepSay": "Tilføj en taleboble-brik",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klik på det grønne flag for at starte",
    "gui.howtos.intro-getting-started-ASL.name": "Kom i gang - ASL",
    "gui.howtos.animate-a-name.name": "Leg med et navn",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Vælg en bogstav sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Afspil en lyd ved klik",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Vælg en anden bogstav sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Skift farve",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Vælg en anden bogstav sprite og få den til at dreje rundt",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Vælg en anden bogstav sprite & få den til at vokse",
    "gui.howtos.imagine": "Forestil dig en verden",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Skriv hvad du vil sige",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klik på det grønne flag for at starte",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Vælg en baggrund",
    "gui.howtos.imagine.step_imagineChooseSprite": "Vælg en sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Tryk på mellemrumstasten for at glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Vælg en anden sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Bevæg venstre-højre",
    "gui.howtos.imagine.step_imagineUpDown": "Bevæg op-ned",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Skift kostumer",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glid til et punkt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Større og mindre",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Vælg en anden baggrund",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Skift baggrunde",
    "gui.howtos.imagine.step_imagineRecordASound": "Tilføj en lyd",
    "gui.howtos.imagine.step_imagineChooseSound": "Vælg din lyd",
    "gui.howtos.make-music.name": "Lav musik",
    "gui.howtos.Make-Music.step_PickInstrument": "Vælg en instrument sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Afspil lyd ved klik",
    "gui.howtos.Make-Music.step_MakeSong": "Lav en sang",
    "gui.howtos.make-music.step_MakeBeat": "Vælg en tromme & lav et slag",
    "gui.howtos.make-music.step_MakeBeatBox": "Vælg spriten med mikrofonen & overraskelses trommemaskinen",
    "gui.howtos.story.name": "Lav en historie",
    "gui.howtos.story.step_addbg": "Tilføj en baggrund",
    "gui.howtos.story.step_addsprite": "Tilføj en figur",
    "gui.howtos.story.step_saysomething": "Sig noget",
    "gui.howtos.story.step_addanothersprite": "Tilføj en ny figur",
    "gui.howtos.story.step_flip": "Vend denne vej",
    "gui.howtos.story.step_conversation": "Snak sammen",
    "gui.howtos.story.addanotherbg": "Tilføj en anden baggrund",
    "gui.howtos.story.step_swithbg": "Skift baggrunde",
    "gui.howtos.story.step_hidewizard": "Skjul en figur",
    "gui.howtos.story.step_showwizard": "Vis en figur",
    "gui.howtos.make-a-chase-game.name": "Lav en fangeleg",
    "gui.howtos.Chase-Game.step_BG": "Tilføj en baggrund",
    "gui.howtos.chase-game.step_AddOcto": "Tilføj en sprite",
    "gui.howtos.make-music.step_LeftRight": "Gå mod højre og venstre med piletaster",
    "gui.howtos.Chase-Game.step_UpDown": "Gå op & ned med piletaster",
    "gui.howtos.Chase-Game.step_AddStar": "Tilføj en anden sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Gå tilfældigt",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ved spriten med blæksprutten, afspil lyd, når den rører ved noget.",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Lav en variabel til point",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ved spriten med blæksprutten, tilføj point, når den rører ved noget.",
    "gui.howtos.animate-char.name": "Animér en figur",
    "gui.howtos.animate-char.step_addbg": "Tilføj en baggrund",
    "gui.howtos.animate-char.step_addsprite": "Tilføj en sprite",
    "gui.howtos.animate-char.step_saysomething": "Sig noget",
    "gui.howtos.animate-char.step_addsound": "Tilføj lyd",
    "gui.howtos.animate-char.step_animatetalking": "Animér snak",
    "gui.howtos.animate-char.step_arrowkeys": "Gå ved hjælp af piletaster",
    "gui.howtos.animate-char.step_jump": "Hop",
    "gui.howtos.animate-char.step_changecolor": "Skift farve",
    "gui.howtos.make-a-game.name": "Lav et klikke spil",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Vælg en sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Afspil lyd ved klik",
    "gui.howtos.make-a-game.step_GameAddScore": "Lav en variabel til point",
    "gui.howtos.make-a-game.step_GameChangeScore": "Når der klikkes, øg scoren",
    "gui.howtos.make-a-game.step_Random": "Gå til en tilfældig position",
    "gui.howtos.make-music.step_GameChangeColor": "Skift farve",
    "gui.howtos.make-music.step_ResetScore": "Nulstil point",
    "gui.howtos.make-it-fly.name": "Få det til at flyve",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Vælg en baggrund med en himmel",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Vælg en figur",
    "gui.howtos.fly.step_stepflySaySomething": "Sig noget",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Gå med piletaster",
    "gui.howtos.fly.step_stepflyChooseObject": "Væg en ting, som skal samles",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Få tingen til at bevæge sig",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Vælg din figur",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Tilføj en score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Før regnskab",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Tilføj landskab",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Bevæg landskabet",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Næste kostume",
    "gui.howtos.pong": "Pong spil",
    "gui.howtos.pong.step_pongAddBackdrop": "Tilføj en baggrund",
    "gui.howtos.pong.step_pongAddBallSprite": "Tilføj en boldsprite",
    "gui.howtos.pong.step_pongBounceAround": "Hop rundt",
    "gui.howtos.pong.step_pongAddPaddle": "Tilføj et bat",
    "gui.howtos.pong.step_pongMoveThePaddle": "Bevæg battet",
    "gui.howtos.pong.step_pongSelectBallSprite": "Vælg boldspriten",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Tilføj kode så bolden hopper væk fra battet",
    "gui.howtos.pong.step_pongAddAScore": "Tilføj en score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Vælg 'Score\" fra menuen",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Indsæt brikken med 'Ændre score\"",
    "gui.howtos.pong.step_pongResetScore": "Nulstil point",
    "gui.howtos.pong.step_pongAddLineSprite": "Tilføj liniespriten",
    "gui.howtos.pong.step_pongGameOver": "Spillet er slut",
    "gui.howtos.code-cartoon": "Kod en tegneserie",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sig noget når du klikker det grønne flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animér en figur når du klikker på den",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Vælg en anden figur",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Brug et minustegn for at blive mindre",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Få en figur til at blive større og mindre",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Vælg en anden figur",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hop op og ned",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klik på en figur for at ændre scener",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glid rundt",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Skift kostumer",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Vælg flere figurer som skal være med i din tegneserie",
    "gui.howtos.cartoon-network": "Gå på eventyr spil",
    "gui.howtos.cartoon-network.step_CNcharacter": "Vælg hvilken sprite der skal vises",
    "gui.howtos.cartoon-network.step_CNsay": "Sig noget",
    "gui.howtos.cartoon-network.step_CNglide": "Glid rundt",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Vælg en ting der skal fanges",
    "gui.howtos.cartoon-network.step_CNcollect": "Indsaml ting",
    "gui.howtos.cartoon-network.step_CNvariable": "Lav en variabel med point",
    "gui.howtos.cartoon-network.step_CNscore": "Før regnskab",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Næste level: skift baggrund",
    "gui.howtos.videosens.name": "Video Registrering",
    "gui.howtos.videosens.step_addextension": "Tilføj udvidelse",
    "gui.howtos.videosens.step_pet": "Kæl med katten",
    "gui.howtos.videosens.step_animate": "Animér",
    "gui.howtos.videosens.step_pop": "Spræng en ballon",
    "gui.howtos.say-it-out-loud": "Snak sammen",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Tilføj teksten til talebrikker",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sig noget",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Vælg en stemme",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Bevæg den rundt",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Tilføj en baggrund",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Tilføj en ny sprite",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Syng en sang",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Skift farve",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Drej rundt",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Bliv større og mindre",
    "gui.howtos.talking": "Tale historier",
    "gui.howtos.talking.step_talesAddExtension": "Klik for at tilføje tekst-til-tale-brikkerne",
    "gui.howtos.talking.step_talesChooseSprite": "Vælg en sprite",
    "gui.howtos.talking.step_talesSaySomething": "Få en figur til at tale",
    "gui.howtos.talking.step_talesChooseBackdrop": "Vælg en baggrund",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klik på en figur for at gå til den næste baggrund",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Vælg en anden sprite",
    "gui.howtos.talking.step_talesMoveAround": "Bevæg den rundt",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Vælg en anden baggrund",
    "gui.howtos.talking.step_talesAnimateTalking": "Animér tale",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Vælg en anden baggrund",
    "gui.howtos.talking.step_talesChooseSound": "Vælg en sang som der kan danses til",
    "gui.howtos.talking.step_talesDanceMoves": "Dansetrin",
    "gui.howtos.talking.step_talesAskAnswer": "Hent spørgsmål og svar brikkerne fra kategorien Registrering",
    "gui.howtos.add-sprite.name": "Tilføj en sprite",
    "gui.howtos.add-sprite.step_addSprite": "Tilføj en sprite",
    "gui.howtos.add-a-backdrop.name": "Tilføj en baggrund",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Tilføj en baggrund",
    "gui.howtos.change-size.name": "Ændre størrelse",
    "gui.howtos.change-size.step_changeSize": "Ændre størrelse",
    "gui.howtos.glide-around.name": "Glid rundt",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glid rundt",
    "gui.howtos.change-size.step_glideAroundPoint": "Glid til et punkt",
    "gui.howtos.record-a-sound.name": "Optag en lyd",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klik på fanen med 'Lyde\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klik 'Optag\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Klik på optageknappen",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Vælg din lyd",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spil din lyd",
    "gui.howtos.spin-video.name": "Lad det dreje rundt",
    "gui.howtos.change-size.step_spinTurn": "Drej",
    "gui.howtos.change-size.step_spinPointInDirection": "Vælg retning",
    "gui.howtos.hide-and-show.name": "Skjul og Vis",
    "gui.howtos.change-size.step_hideAndShow": "Skjul og Vis",
    "gui.howtos.switch-costume.name": "Animér en sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animér en sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Brug piletaster",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Bevæg mod venstre og højre",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bevæg op og ned",
    "gui.howtos.add-effects.name": "Tilføj effekter",
    "gui.howtos.videosens.step_addEffects": "Tilføj effekter",
    "gui.extension.music.name": "Musik",
    "gui.extension.music.description": "Spil på instrumenter og trommer",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Tegn med dine sprites.",
    "gui.extension.videosensing.name": "Video Registrering",
    "gui.extension.videosensing.description": "Registrerer bevægelse med kameraet",
    "gui.extension.text2speech.name": "Tekst til tale",
    "gui.extension.text2speech.description": "Få dine projekter til at tale.",
    "gui.extension.translate.name": "Oversæt",
    "gui.extension.translate.description": "Oversæt tekst til mange sprog.",
    "gui.extension.makeymakey.description": "Gør alting til en tast",
    "gui.extension.microbit.description": "Forbind dine projekter med den fysiske verden.",
    "gui.extension.microbit.connectingMessage": "Forbinder",
    "gui.extension.ev3.description": "Byg interaktive robotter og mere.",
    "gui.extension.ev3.connectingMessage": "Forbinder. Vær sikker på at pin'en på din EV3 er sat til 1234.",
    "gui.extension.boost.description": "Gør dine robtter levende.",
    "gui.extension.boost.connectingMessage": "Forbinder",
    "gui.extension.wedo2.description": "Byg med motorer og sensorer",
    "gui.extension.wedo2.connectingMessage": "Forbinder",
    "gui.extension.gdxfor.description": "Registrér skub, træk, bevægelse og drejen rundt.",
    "gui.extension.gdxfor.connectingMessage": "Forbinder",
    "gui.libraryTags.all": "Alle",
    "gui.libraryTags.animals": "Dyr",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Effekter",
    "gui.libraryTags.fantasy": "Fantasi",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Mad",
    "gui.libraryTags.indoors": "Indendørs",
    "gui.libraryTags.loops": "Gentagelser",
    "gui.libraryTags.music": "Musik",
    "gui.libraryTags.notes": "Noder",
    "gui.libraryTags.outdoors": "Udendørs",
    "gui.libraryTags.patterns": "Mønstre",
    "gui.libraryTags.people": "Mennesker",
    "gui.libraryTags.percussion": "Slagtøj",
    "gui.libraryTags.space": "Rummet",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Under vandet",
    "gui.libraryTags.voice": "Stemme",
    "gui.libraryTags.wacky": "Skør",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Spil",
    "gui.libraryTags.stories": "Historier",
    "gui.libraryTags.letters": "Bogstaver",
    "gui.opcodeLabels.direction": "retning",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "størrelse",
    "gui.opcodeLabels.costumename": "navn på kostume",
    "gui.opcodeLabels.costumenumber": "kostume nummer",
    "gui.opcodeLabels.backdropname": "navn på baggrund",
    "gui.opcodeLabels.backdropnumber": "baggrund nummer",
    "gui.opcodeLabels.volume": "lydstyrke",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "svar",
    "gui.opcodeLabels.loudness": "lydstyrke",
    "gui.opcodeLabels.username": "brugernavn",
    "gui.opcodeLabels.year": "år",
    "gui.opcodeLabels.month": "måned",
    "gui.opcodeLabels.date": "dato",
    "gui.opcodeLabels.dayofweek": "ugedag",
    "gui.opcodeLabels.hour": "time",
    "gui.opcodeLabels.minute": "minut",
    "gui.opcodeLabels.second": "sekund",
    "gui.opcodeLabels.timer": "stopur",
    "gui.projectLoader.loadError": "Den valgte projekt vil kan ikke hentes.",
    "gui.sharedMessages.backdrop": "baggrund{index}",
    "gui.sharedMessages.costume": "kostume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "knald",
    "gui.sharedMessages.replaceProjectWarning": "Erstat indholdet af det nuværende projekt?",
    "gui.sharedMessages.loadFromComputerTitle": "Hent fra din computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Mørk",
    "gui.theme.highContrast": "Høj kontrast",
    "gui.gui.defaultProjectTitle": "Scratch Projekt",
    "boost.color.any": "alle farver",
    "boost.color.black": "sort",
    "boost.color.blue": "blå",
    "boost.color.green": "grøm",
    "boost.color.red": "rød",
    "boost.color.white": "hvid",
    "boost.color.yellow": "gul",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "vippet vinkel [TILT_DIRECTION]",
    "boost.motorDirection.backward": "den vej",
    "boost.motorDirection.forward": "den anden vej",
    "boost.motorDirection.reverse": "skift retning",
    "boost.motorOff": "sluk motor [MOTOR_ID]",
    "boost.motorOn": "tænd motor [MOTOR_ID]",
    "boost.motorOnFor": "tænd motor [MOTOR_ID] i [DURATION] sekunder",
    "boost.motorOnForRotation": "tænd motor [MOTOR_ID] i [ROTATION] rotationer",
    "boost.seeingColor": "ser [COLOR] brik?",
    "boost.setLightHue": "sæt farven på lyset til [HUE]",
    "boost.setMotorDirection": "sæt motor [MOTOR_ID] retning til [MOTOR_DIRECTION]",
    "boost.setMotorPower": "sæt motor [MOTOR_ID] hastighed til [POWER] %",
    "boost.tiltDirection.any": "vilkårlig",
    "boost.tiltDirection.down": "ned",
    "boost.tiltDirection.left": "venstre",
    "boost.tiltDirection.right": "højre",
    "boost.tiltDirection.up": "op",
    "boost.whenColor": "når [COLOR] brikken ses",
    "boost.whenTilted": "er vippet [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "spil tone [NOTE] i [TIME] sekunder",
    "ev3.buttonPressed": "tryksensor [PORT] trykket ind?",
    "ev3.getBrightness": "lysstyrke",
    "ev3.getDistance": "afstand",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "motor [PORT] indstil styrke  [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] drej en vej i [TIME] sekunder",
    "ev3.motorTurnCounterClockwise": "motor [PORT] drej anden vej i [TIME] sekunder",
    "ev3.whenBrightnessLessThan": "når lysstyrke < [DISTANCE]",
    "ev3.whenButtonPressed": "tryksensor [PORT] trykket ind",
    "ev3.whenDistanceLessThan": "når afstanden  < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "kraft",
    "gdxfor.getSpin": "spin hastighed [DIRECTION]",
    "gdxfor.getTilt": "vippet vinkel [TILT]",
    "gdxfor.isFreeFalling": "falder?",
    "gdxfor.isTilted": "vippet [TILT]?",
    "gdxfor.pulled": "trukket",
    "gdxfor.pushed": "skubbet",
    "gdxfor.shaken": "rystet",
    "gdxfor.startedFalling": "begyndte at falde",
    "gdxfor.tiltDirectionMenu.any": "vilkårlig",
    "gdxfor.tiltDirectionMenu.back": "bagover",
    "gdxfor.tiltDirectionMenu.front": "fremover",
    "gdxfor.tiltDirectionMenu.left": "venstre",
    "gdxfor.tiltDirectionMenu.right": "højre",
    "gdxfor.turnedFaceDown": "vendt nedad",
    "gdxfor.turnedFaceUp": "vendt opad",
    "gdxfor.whenForcePushedOrPulled": "når kraft sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "når [GESTURE]",
    "gdxfor.whenTilted": "når vippet [TILT]",
    "makeymakey.downArrow": "pil nedad",
    "makeymakey.downArrowShort": "ned",
    "makeymakey.leftArrow": "venstre pil",
    "makeymakey.leftArrowShort": "venstre",
    "makeymakey.rightArrow": "højre pil",
    "makeymakey.rightArrowShort": "højre",
    "makeymakey.spaceKey": "mellemrum",
    "makeymakey.upArrow": "pil opad",
    "makeymakey.upArrowShort": "op",
    "makeymakey.whenKeyPressed": "når [KEY] tast er trykket",
    "makeymakey.whenKeysPressedInOrder": "når [SEQUENCE] er trykket i rækkefølge",
    "microbit.buttonsMenu.any": "vilkårlig",
    "microbit.clearDisplay": "ryd display",
    "microbit.defaultTextToDisplay": "Hej!",
    "microbit.displaySymbol": "vis [MATRIX]",
    "microbit.displayText": "vis tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "hoppet",
    "microbit.gesturesMenu.moved": "bevæget",
    "microbit.gesturesMenu.shaken": "rystet",
    "microbit.isButtonPressed": "[BTN] knap trykket?",
    "microbit.isTilted": "vippet [DIRECTION]?",
    "microbit.pinStateMenu.off": "slukket",
    "microbit.pinStateMenu.on": "tændt",
    "microbit.tiltAngle": "vippet [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "vilkårlig",
    "microbit.tiltDirectionMenu.back": "bagover",
    "microbit.tiltDirectionMenu.front": "fremover",
    "microbit.tiltDirectionMenu.left": "venstre",
    "microbit.tiltDirectionMenu.right": "højre",
    "microbit.whenButtonPressed": "tryksensor [BTN] trykket ind",
    "microbit.whenGesture": "når [GESTURE]",
    "microbit.whenPinConnected": "når pin [PIN] er forbundet",
    "microbit.whenTilted": "er vippet [DIRECTION]",
    "music.categoryName": "Musik",
    "music.changeTempo": "ændre tempo med [TEMPO]",
    "music.drumBass": "(2) Stortromme",
    "music.drumBongo": "(13) Bongotromme",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Lukket hi-hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Koklokke",
    "music.drumCrashCymbal": "(4) Bækken",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Klap med hænderne",
    "music.drumOpenHiHat": "(5) Åben hi-hat",
    "music.drumSideStick": "(3) Kantslag",
    "music.drumSnare": "(1) Lilletromme",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Træklods",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Kor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Elektrisk guitar",
    "music.instrumentElectricPiano": "(2) Elektrisk klaver",
    "music.instrumentFlute": "(12) Fløjte",
    "music.instrumentGuitar": "(4) Guitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Spilledåse",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Klaver",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofon",
    "music.instrumentSteelDrum": "(18) Ståltromme",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trækbasun",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Træfløjte",
    "music.midiPlayDrumForBeats": "spil tromme [DRUM] i [BEATS] slag",
    "music.midiSetInstrument": "skift instrument til [INSTRUMENT]",
    "music.playDrumForBeats": "spil [DRUM] i [BEATS] slag",
    "music.playNoteForBeats": "spil tone [NOTE] i [BEATS] slag",
    "music.restForBeats": "pause i [BEATS] slag",
    "music.setInstrument": "skift instrument til [INSTRUMENT]",
    "music.setTempo": "sæt tempo til [TEMPO]",
    "pen.categoryName": "Pen",
    "pen.changeColorParam": "ændre pen [COLOR_PARAM] med [VALUE]",
    "pen.changeHue": "ændre penfarve med [HUE]",
    "pen.changeShade": "ændre skyggen på pennen med [SHADE]",
    "pen.changeSize": "ændre pen størrelse med[SIZE]",
    "pen.clear": "slet alt",
    "pen.colorMenu.brightness": "lysstyrke",
    "pen.colorMenu.color": "farve",
    "pen.colorMenu.saturation": "farvemætning",
    "pen.colorMenu.transparency": "gennemsigtighed",
    "pen.penDown": "pen ned",
    "pen.penUp": "pen op",
    "pen.setColor": "skift penfarve til [COLOR]",
    "pen.setColorParam": "sæt pen [COLOR_PARAM] til [VALUE]",
    "pen.setHue": "sæt penfarve til [HUE]",
    "pen.setShade": "sæt skyggen på pennen til [SHADE]",
    "pen.setSize": "sæt penstørrelse til [SIZE]",
    "pen.stamp": "stempel",
    "speech.defaultWhenIHearValue": "lad os komme i gang",
    "speech.extensionName": "Fra tale til tekst",
    "speech.listenAndWait": "lyt og vent",
    "speech.speechReporter": "tale",
    "speech.whenIHear": "når jeg hører [PHRASE]",
    "text2speech.alto": "kvinde",
    "text2speech.categoryName": "Tekst til tale",
    "text2speech.defaultTextToSpeak": "hej",
    "text2speech.giant": "kæmpe",
    "text2speech.kitten": "killing",
    "text2speech.setLanguageBlock": "sæt sprog til [LANGUAGE]",
    "text2speech.setVoiceBlock": "indstil stemme til [VOICE]",
    "text2speech.speakAndWaitBlock": "sig [WORDS]",
    "text2speech.squeak": "knirkende",
    "text2speech.tenor": "mand",
    "translate.categoryName": "Oversæt",
    "translate.defaultTextToTranslate": "hej",
    "translate.translateBlock": "oversæt [WORDS] til [LANGUAGE]",
    "translate.viewerLanguage": "sprog",
    "videoSensing.categoryName": "Video Registrering",
    "videoSensing.direction": "retning",
    "videoSensing.motion": "bevægelse",
    "videoSensing.off": "slukket",
    "videoSensing.on": "tændt",
    "videoSensing.onFlipped": "spejlvendt",
    "videoSensing.setVideoTransparency": "sæt video gennemsigtighed til [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "scene",
    "videoSensing.videoOn": "video [ATTRIBUTE] på [SUBJECT]",
    "videoSensing.videoToggle": "video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "når video bevægelse > [REFERENCE]",
    "wedo2.getDistance": "afstand",
    "wedo2.getTiltAngle": "vippet vinkel [TILT_DIRECTION]",
    "wedo2.isTilted": "vippet [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "den vej",
    "wedo2.motorDirection.forward": "den anden vej",
    "wedo2.motorDirection.reverse": "skift retning",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motorer",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "sluk [MOTOR_ID] ",
    "wedo2.motorOn": "tænd [MOTOR_ID]",
    "wedo2.motorOnFor": "tænd [MOTOR_ID] i [DURATION] sekunder",
    "wedo2.playNoteFor": "spil tone [NOTE] i [DURATION] sekunder",
    "wedo2.setLightHue": "sæt farven på lyset til [HUE]",
    "wedo2.setMotorDirection": "sæt [MOTOR_ID] retning til [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "sæt [MOTOR_ID] styrke til [POWER]",
    "wedo2.tiltDirection.any": "vilkårlig",
    "wedo2.tiltDirection.down": "ned",
    "wedo2.tiltDirection.left": "venstre",
    "wedo2.tiltDirection.right": "højre",
    "wedo2.tiltDirection.up": "op",
    "wedo2.whenDistance": "når afstanden [OP] [REFERENCE]",
    "wedo2.whenTilted": "er vippet [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Farve",
    "paint.paintEditor.saturation": "Farvemætning",
    "paint.paintEditor.brightness": "Lysstyrke",
    "paint.paintEditor.costume": "Kostume",
    "paint.paintEditor.group": "Gruppe",
    "paint.paintEditor.ungroup": "Opdel",
    "paint.paintEditor.undo": "Fortryd",
    "paint.paintEditor.redo": "Gør om",
    "paint.paintEditor.forward": "Forrest",
    "paint.paintEditor.backward": "Bagerst",
    "paint.paintEditor.front": "Foran",
    "paint.paintEditor.back": "Bagved",
    "paint.paintEditor.more": "Mere",
    "paint.modeTools.brushSize": "Størrelse",
    "paint.modeTools.eraserSize": "Viskelæderets størrelse",
    "paint.modeTools.copy": "Kopier",
    "paint.modeTools.paste": "Sæt ind",
    "paint.modeTools.delete": "Slet",
    "paint.modeTools.curved": "Buet",
    "paint.modeTools.pointed": "Spids",
    "paint.modeTools.thickness": "Tykkelse",
    "paint.modeTools.flipHorizontal": "Vend venstre-højre",
    "paint.modeTools.flipVertical": "Vend op og ned",
    "paint.modeTools.filled": "Fyldt",
    "paint.modeTools.outlined": "Kant streg",
    "paint.paintEditor.bitmap": "Konverter til Bitmap",
    "paint.paintEditor.vector": "Konverter til Vektor",
    "paint.paintEditor.fill": "Fyld",
    "paint.paintEditor.stroke": "Kant",
    "paint.brushMode.brush": "Pensel",
    "paint.eraserMode.eraser": "Viskelæder",
    "paint.fillMode.fill": "Fyld",
    "paint.lineMode.line": "Linje",
    "paint.ovalMode.oval": "Cirkel",
    "paint.rectMode.rect": "Rektangel",
    "paint.reshapeMode.reshape": "Omform",
    "paint.roundedRectMode.roundedRect": "Afrundet rektangel",
    "paint.selectMode.select": "Vælg",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Byt"
  },
  "de": {
    "gui.alerts.lostPeripheralConnection": "Scratch hat die Verbindung zu{extensionName} verloren.",
    "gui.alerts.tryAgain": "Erneut versuchen",
    "gui.alerts.download": "Herunterladen",
    "gui.connection.reconnect": "Erneut verbinden",
    "gui.backpack.costumeLabel": "Kostüm",
    "gui.backpack.soundLabel": "Klang",
    "gui.backpack.scriptLabel": "Skript",
    "gui.backpack.spriteLabel": "Figur",
    "gui.backpack.header": "Lager",
    "gui.backpack.errorBackpack": "Fehler beim Laden des Lagers",
    "gui.backpack.loadingBackpack": "Wird geladen ...",
    "gui.backpack.more": "Mehr",
    "gui.backpack.emptyBackpack": "Das Lager ist leer",
    "gui.unsupportedBrowser.label": "Browser wird nicht unterstützt",
    "gui.unsupportedBrowser.errorLabel": "Ein Fehler ist aufgetreten.",
    "gui.unsupportedBrowser.notRecommended": "Es tut uns sehr leid, aber du benutzt offenbar eine Browserversion, die Scratch nicht unterstützt. Wir empfehlen, auf die neueste Version eines unterstützten Browsers wie Google Chrome, Mozilla Firefox, Microsoft Edge, oder Apple Safari zu aktualisieren.",
    "gui.unsupportedBrowser.description": "Es tut uns sehr leid, aber Scratch unterstützt diesen Browser nicht. Wir empfehlen, auf die neueste Version eines unterstützten Browsers wie Google Chrome, Mozilla Firefox, Microsoft Edge, oder Apple Safari zu aktualisieren.",
    "gui.unsupportedBrowser.back": "Zurück",
    "gui.unsupportedBrowser.previewfaq": "Besuche die {previewFaqLink}, um mehr zu erfahren.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Häufig gestellte Fragen",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Zuklappen",
    "gui.cards.expand": "Aufklappen",
    "gui.cards.close": "Schließen",
    "gui.cards.more-things-to-try": "Probiere mehr Dinge aus",
    "gui.cards.see-more": "Mehr erfahren",
    "gui.comingSoon.message1": "Keine Sorge, wir kümmern uns darum {emoji}",
    "gui.comingSoon.message2": "Bald verfügbar ...",
    "gui.comingSoon.message3": "Wir arbeiten daran {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Keine Geräte gefunden",
    "gui.connection.auto-scanning.prescan": "Starte die Suche, wenn du ein Gerät in der Nähe hast.",
    "gui.connection.auto-scanning.pressbutton": "Drücke den Button an deinem Gerät.",
    "gui.connection.auto-scanning.start-search": "Suche starten",
    "gui.connection.connecting-searchbutton": "Suche läuft...",
    "gui.connection.auto-scanning.try-again": "Versuche es noch einmal",
    "gui.connection.auto-scanning.updatePeripheralButton": "Mein Gerät aktualisieren",
    "gui.connection.connected": "Verbunden",
    "gui.connection.disconnect": "Trenne",
    "gui.connection.go-to-editor": "Gehe zum Editor",
    "gui.connection.connecting-cancelbutton": "Ich verbinde...",
    "gui.connection.error.errorMessage": "Hoppla, etwas hat wohl nicht funktioniert.",
    "gui.connection.error.tryagainbutton": "Versuche es noch einmal",
    "gui.connection.error.helpbutton": "Hilfe",
    "gui.connection.peripheral-name-label": "Gerätename",
    "gui.connection.connect": "Verbinde",
    "gui.connection.scanning.lookingforperipherals": "Suche Geräte",
    "gui.connection.scanning.noPeripheralsFound": "Keine Geräte gefunden",
    "gui.connection.scanning.instructions": "Wähle dein Gerät oben in der Liste.",
    "gui.connection.search": "Aktualisieren",
    "gui.connection.scanning.updatePeripheralButton": "Mein Gerät aktualisieren",
    "gui.connection.unavailable.installscratchlink": "Überprüfe, ob du Scratch Link installiert hast und das Programm läuft.",
    "gui.connection.unavailable.enablebluetooth": "Überprüfe, ob Bluetooth aktiviert ist",
    "gui.connection.unavailable.tryagainbutton": "Versuche es noch einmal",
    "gui.connection.unavailable.helpbutton": "Hilfe",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Drücke auf \"Aktualisieren\" und warte, bis es abgeschlossen ist.",
    "gui.connection.updatePeripheral.progress": "Aktualisierung zu {progressPercentage}% abgeschlossen",
    "gui.connection.updatePeripheral.updateSuccessful": "Aktualisierung erfolgreich!",
    "gui.connection.updatePeripheral.updateFailed": "Aktualisierung fehlgeschlagen.",
    "gui.connection.updatePeripheral.goBackButton": "Zurück",
    "gui.connection.updatePeripheral.updateNowButton": "Aktualisieren",
    "gui.connection.updatePeripheral.updateAgainButton": "Erneut versuchen",
    "gui.controls.go": "Los",
    "gui.controls.stop": "Stopp",
    "gui.crashMessage.label": "Hoppla! Da ist was schief gegangen.",
    "gui.crashMessage.description": "Es tut uns leid, anscheinend ist ein Fehler bei Scratch aufgetreten. Das Scratch-Team wurde informiert. Bitte aktualisiere die Seite, um es erneut zu versuchen.",
    "gui.crashMessage.errorNumber": "Der Fehler wurde unter der ID {errorId} gespeichert.",
    "gui.crashMessage.reload": "Neu laden",
    "gui.customProcedures.myblockModalTitle": "Neuer Block",
    "gui.customProcedures.addAnInputNumberText": "Eingabefeld hinzufügen",
    "gui.customProcedures.numberTextType": "Zahl oder Text",
    "gui.customProcedures.addAnInputBoolean": "Eingabefeld hinzufügen",
    "gui.customProcedures.booleanType": "Wahrheitswert",
    "gui.customProcedures.addALabel": "Beschriftung hinzufügen",
    "gui.customProcedures.runWithoutScreenRefresh": "Ohne Bildschirmaktualisierung laufen lassen",
    "gui.customProcedures.cancel": "Abbrechen",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Richtung",
    "gui.directionPicker.rotationStyles.allAround": "Rundherum",
    "gui.directionPicker.rotationStyles.leftRight": "Links/Rechts",
    "gui.directionPicker.rotationStyles.dontRotate": "Nicht drehen",
    "gui.gui.addExtension": "Erweiterung hinzufügen",
    "gui.gui.codeTab": "Skripte",
    "gui.gui.backdropsTab": "Hintergrundbilder",
    "gui.gui.costumesTab": "Kostüme",
    "gui.gui.soundsTab": "Klänge",
    "gui.extensionLibrary.comingSoon": "Bald verfügbar",
    "gui.extensionLibrary.requires": "Erfordert",
    "gui.extensionLibrary.collaboration": "Zusammenarbeit mit",
    "gui.library.filterPlaceholder": "Suche",
    "gui.library.allTag": "Alles",
    "gui.loader.message1": "Blöcke werden erstellt ...",
    "gui.loader.message2": "Figuren werden geladen ...",
    "gui.loader.message3": "Klänge werden geladen ...",
    "gui.loader.message4": "Erweiterungen werden geladen ...",
    "gui.loader.message5": "Katzen werden eingesammelt ...",
    "gui.loader.message6": "Nanos werden übertragen ...",
    "gui.loader.message7": "Gobos werden aufgeblasen ...",
    "gui.loader.message8": "Emojis werden vorbereitet ...",
    "gui.loader.headline": "Projekt wird geladen",
    "gui.loader.creating": "Projekt wird erstellt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Meine Sachen",
    "gui.accountMenu.myClasses": "Meine Klassen",
    "gui.accountMenu.myClass": "Meine Klasse",
    "gui.accountMenu.accountSettings": "Kontoeinstellungen",
    "gui.accountMenu.signOut": "Abmelden",
    "gui.authorInfo.byUser": "von {username}",
    "gui.menuBar.seeProjectPage": "Zeige Projektseite",
    "gui.menuBar.language": "Sprache",
    "general.username": "Benutzername",
    "general.password": "Kennwort",
    "general.signIn": "Anmelden",
    "login.needHelp": "Brauchst du Hilfe?",
    "form.validationRequired": "Dieses Feld wird benötigt",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Figur wiederherstellen",
    "gui.menuBar.restoreSound": "Klang wiederherstellen",
    "gui.menuBar.restoreCostume": "Kostüm wiederherstellen",
    "gui.menuBar.restore": "Wiederherstellen",
    "gui.menuBar.saveNow": "Jetzt speichern",
    "gui.menuBar.saveAsCopy": "Eine Kopie speichern",
    "gui.menuBar.remix": "Remixen",
    "gui.menuBar.new": "Neu",
    "gui.menuBar.file": "Datei",
    "gui.menuBar.downloadToComputer": "Auf deinem Computer speichern",
    "gui.menuBar.edit": "Bearbeiten",
    "gui.menuBar.turboModeOff": "Turbo-Modus ausschalten",
    "gui.menuBar.turboModeOn": "Turbo-Modus einschalten",
    "gui.menuBar.modeMenu": "Modus",
    "gui.menuBar.normalMode": "Normaler Modus",
    "gui.menuBar.caturdayMode": "Katzen-Modus",
    "gui.menuBar.joinScratch": "Scratcher werden",
    "gui.menuBar.signIn": "Anmelden",
    "gui.gui.projectTitlePlaceholder": "Projekttitel",
    "gui.menuBar.saveNowLink": "Jetzt speichern",
    "gui.menuBar.settings": "Einstellungen",
    "gui.menuBar.isShared": "Veröffentlicht",
    "gui.menuBar.share": "Veröffentlichen",
    "gui.menuBar.colorMode": "Farbmodus",
    "gui.modal.help": "Hilfe",
    "gui.modal.back": "Zurück",
    "gui.monitor.listMonitor.empty": "(leer)",
    "gui.monitor.listMonitor.listLength": "Länge: {length}",
    "gui.monitor.contextMenu.default": "Normale Anzeigengröße",
    "gui.monitor.contextMenu.large": "Großanzeige",
    "gui.monitor.contextMenu.slider": "Schieberegler",
    "gui.monitor.contextMenu.sliderRange": "Wertebereich des Schiebereglers ändern",
    "gui.monitor.contextMenu.import": "Importieren",
    "gui.monitor.contextMenu.export": "Exportieren",
    "gui.monitor.contextMenu.hide": "Verbergen",
    "gui.playButton.play": "Abspielen",
    "gui.playButton.stop": "Stopp",
    "gui.gui.variableScopeOptionAllSprites": "Für alle Figuren",
    "gui.gui.variableScopeOptionSpriteOnly": "Nur für diese Figur",
    "gui.gui.cloudVariableOption": "Cloud-Variable (auf dem Server gespeichert)",
    "gui.gui.variablePromptAllSpritesMessage": "Diese Variable wird für alle Figuren verfügbar sein.",
    "gui.gui.listPromptAllSpritesMessage": "Diese Liste wird für alle Figuren sichtbar sein.",
    "gui.prompt.cancel": "Abbrechen",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stopp",
    "gui.playbackStep.playMsg": "Abspielen",
    "gui.playbackStep.loadingMsg": "Wird geladen ...",
    "gui.playbackStep.saveMsg": "Speichern",
    "gui.playbackStep.reRecordMsg": "Erneut aufnehmen",
    "gui.recordModal.title": "Klang aufnehmen",
    "gui.recordingStep.beginRecord": "Starte die Aufnahme, indem du auf den Knopf unten klickst",
    "gui.recordingStep.permission": "{arrow}Wir benötigen deine Zustimmung, um dein Mikrofon zu benutzen",
    "gui.recordingStep.stop": "Aufnahme beenden",
    "gui.recordingStep.record": "Aufnehmen",
    "gui.sliderModal.min": "Kleinster Wert",
    "gui.sliderModal.max": "Größter Wert",
    "gui.sliderModal.title": "Wertebereich des Schiebereglers ändern",
    "gui.sliderPrompt.cancel": "Abbrechen",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Klang",
    "gui.soundEditor.play": "Abspielen",
    "gui.soundEditor.stop": "Stopp",
    "gui.soundEditor.copy": "Kopieren",
    "gui.soundEditor.paste": "Einfügen",
    "gui.soundEditor.copyToNew": "Duplizieren",
    "gui.soundEditor.delete": "Löschen",
    "gui.soundEditor.save": "Speichern",
    "gui.soundEditor.undo": "Rückgängig",
    "gui.soundEditor.redo": "Wiederherstellen",
    "gui.soundEditor.faster": "Schneller",
    "gui.soundEditor.slower": "Langsamer",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Roboter",
    "gui.soundEditor.louder": "Lauter",
    "gui.soundEditor.softer": "Leiser",
    "gui.soundEditor.reverse": "Umkehren",
    "gui.soundEditor.fadeOut": "Ausblenden",
    "gui.soundEditor.fadeIn": "Einblenden",
    "gui.soundEditor.mute": "Stummschalten",
    "gui.SpriteInfo.spritePlaceholder": "Name",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Figur",
    "gui.SpriteInfo.show": "Sichtbarkeit",
    "gui.SpriteInfo.size": "Größe",
    "gui.spriteSelectorItem.contextMenuDuplicate": "Duplizieren",
    "gui.spriteSelectorItem.contextMenuExport": "Exportieren",
    "gui.spriteSelectorItem.contextMenuDelete": "Löschen",
    "gui.spriteSelector.addSpriteFromLibrary": "Figur wählen",
    "gui.spriteSelector.addSpriteFromPaint": "Malen",
    "gui.spriteSelector.addSpriteFromSurprise": "Überraschung",
    "gui.spriteSelector.addSpriteFromFile": "Figur hochladen",
    "gui.stageHeader.stageSizeLarge": "Schalte auf große Bühne um",
    "gui.stageHeader.stageSizeSmall": "Schalte auf kleine Bühne um",
    "gui.stageHeader.stageSizeFull": "Vollbildmodus",
    "gui.stageHeader.stageSizeUnFull": "Vollbildmodus verlassen",
    "gui.stageHeader.fullscreenControl": "Vollbildkontrolle",
    "gui.spriteSelector.addBackdropFromLibrary": "Hintergrund wählen",
    "gui.stageSelector.addBackdropFromPaint": "Malen",
    "gui.stageSelector.addBackdropFromSurprise": "Überraschung",
    "gui.stageSelector.addBackdropFromFile": "Hintergrund hochladen",
    "gui.stageSelector.stage": "Bühne",
    "gui.stageSelector.backdrops": "Hintergrundbilder",
    "gui.telemetryOptIn.label": "Statistiken zur Verbesserung von Scratch übermitteln",
    "gui.telemetryOptIn.body1": "Das Scratch-Team interessiert sich dafür, wie Scratch weltweit verwendet wird. Um dabei zu helfen, kannst du Scratch erlauben, Daten über seine Verwendung automatisch an das Scratch-Team zu schicken.",
    "gui.telemetryOptIn.body2": "Die Informationen, die wir sammeln, umfassen Sprachauswahl, Verwendung der Blöcke sowie Vorgänge wie Speichern, Laden und Hochladen von Projekten. Wir sammeln KEINERLEI personenbezogene Informationen. Weitere Informationen dazu finden sich unter {privacyPolicyLink}.",
    "gui.telemetryOptIn.privacyPolicyLink": "Datenschutzrichtlinien",
    "gui.telemetryOptIn.optInText": "Meine Nutzungsdaten mit dem Scratch-Team teilen",
    "gui.telemetryOptIn.optInTooltip": "Telemetrie aktivieren",
    "gui.telemetryOptIn.optOutText": "Meine Nutzungsdaten nicht mit dem Scratch-Team teilen",
    "gui.telemetryOptIn.optOutTooltip": "Telemetrie deaktivieren",
    "gui.telemetryOptIn.settingWasUpdated": "Deine Einstellung wurde aktualisiert.",
    "gui.telemetryOptIn.buttonClose": "Schließen",
    "gui.turboMode.active": "Turbo-Modus",
    "gui.webglModal.label": "Dein Browser unterstützt kein WebGL",
    "gui.webglModal.description": "Es sieht leider so aus, als ob dein Browser oder Computer {webGlLink}. Diese Technologie wird benötigt, um Scratch 3.0 auszuführen.",
    "gui.webglModal.webgllink": "unterstützt kein WebGL",
    "gui.webglModal.back": "Zurück",
    "gui.webglModal.previewfaq": "Besuche die {previewFaqLink}, um mehr zu erfahren.",
    "gui.webglModal.previewfaqlinktext": "Häufig gestellte Fragen",
    "gui.costumeLibrary.chooseABackdrop": "Wähle einen Hintergrund",
    "gui.costumeLibrary.chooseACostume": "Wähle ein Kostüm",
    "gui.costumeTab.addBackdropFromLibrary": "Wähle einen Hintergrund",
    "gui.costumeTab.addCostumeFromLibrary": "Wähle ein Kostüm",
    "gui.costumeTab.addBlankCostume": "Malen",
    "gui.costumeTab.addSurpriseCostume": "Überraschung",
    "gui.costumeTab.addFileBackdrop": "Hintergrund hochladen",
    "gui.costumeTab.addFileCostume": "Kostüm hochladen",
    "gui.extensionLibrary.chooseAnExtension": "Erweiterung auswählen",
    "gui.extensionLibrary.extensionUrl": "Gib die URL der Erweiterung ein",
    "gui.monitors.importListColumnPrompt": "Welche Spalte soll verwendet werden (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Aufnahme konnte nicht gestartet werden",
    "gui.soundLibrary.chooseASound": "Klang wählen",
    "gui.soundTab.fileUploadSound": "Klang hochladen",
    "gui.soundTab.surpriseSound": "Überraschung",
    "gui.soundTab.recordSound": "Aufnehmen",
    "gui.soundTab.addSoundFromLibrary": "Klang wählen",
    "gui.spriteLibrary.chooseASprite": "Figur wählen",
    "gui.tipsLibrary.tutorials": "Wähle ein Tutorial",
    "gui.alerts.createsuccess": "Ein neues Projekt wurde erstellt.",
    "gui.alerts.createcopysuccess": "Das Projekt wurde als Kopie gespeichert.",
    "gui.alerts.createremixsuccess": "Das Projekt wurde als Remix gespeichert.",
    "gui.alerts.creating": "Ein neues Projekt wird erzeugt...",
    "gui.alerts.creatingCopy": "Das Projekt wird kopiert...",
    "gui.alerts.creatingRemix": "Das Projekt wird remixt...",
    "gui.alerts.creatingError": "Das Projekt konnte nicht erstellt werden. Versuche es bitte erneut! ",
    "gui.alerts.savingError": "Das Projekt konnte nicht gespeichert werden.",
    "gui.alerts.savesuccess": "Das Projekt wurde gespeichert.",
    "gui.alerts.saving": "Das Projekt wird gespeichert...",
    "gui.alerts.cloudInfo": "Beachte bitte, dass Cloud-Variablen nur Zahlen unterstützen, keine Buchstaben oder Symbole. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Erfahre mehr.",
    "gui.alerts.importing": "Importiere...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "meine Variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Erste Schritte",
    "gui.howtos.intro-move.step_stepMove": "Füge einen Bewegungsblock hinzu",
    "gui.howtos.add-a-move-block.step_stepSay": "Füge einen „sage“-Block hinzu",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klicke zum Starten auf die grüne Flagge",
    "gui.howtos.intro-getting-started-ASL.name": "Erste Schritte - ASL",
    "gui.howtos.animate-a-name.name": "Animiere einen Namen",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Wähle eine Buchstabenfigur",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spiele einen Klang, wenn angeklickt",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Wähle eine weitere Buchstabenfigur",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Ändere die Farbe",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Wähle eine weitere Buchstabenfigur und lass sie sich drehen",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Wähle einen weiteren Buchstaben und lass ihn wachsen",
    "gui.howtos.imagine": "Stell dir eine Welt vor",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Gib ein, was du sagen willst",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klicke zum Starten auf die grüne Flagge",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Wähle irgendeinen Hintergrund",
    "gui.howtos.imagine.step_imagineChooseSprite": "Figur wählen",
    "gui.howtos.imagine.step_imagineFlyAround": "Drücke die Leertaste, um zu gleiten",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Wähle eine andere Figur",
    "gui.howtos.imagine.step_imagineLeftRight": "Nach links und rechts bewegen",
    "gui.howtos.imagine.step_imagineUpDown": "Nach oben und unten bewegen",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Kostüme ändern",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Zu einem Punkt gleiten",
    "gui.howtos.imagine.step_imagineGrowShrink": "Wachsen und Schrumpfen",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Wähle einen weiteren Hintergrund",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Tausche die Hintergrundbilder",
    "gui.howtos.imagine.step_imagineRecordASound": "Füge einen Klang hinzu",
    "gui.howtos.imagine.step_imagineChooseSound": "Wähl deinen Sound aus",
    "gui.howtos.make-music.name": "Mach Musik",
    "gui.howtos.Make-Music.step_PickInstrument": "Wähle eine Instrumentenfigur",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spiele einen Klang, wenn angeklickt",
    "gui.howtos.Make-Music.step_MakeSong": "Komponiere ein Lied",
    "gui.howtos.make-music.step_MakeBeat": "Wähle ein Schlaginstrument und spiele einen Rhythmus",
    "gui.howtos.make-music.step_MakeBeatBox": "Wähle die Mikrofonfigur & Überraschungs-Beatbox",
    "gui.howtos.story.name": "Erzähle eine Geschichte",
    "gui.howtos.story.step_addbg": "Füge einen Hintergrund hinzu",
    "gui.howtos.story.step_addsprite": "Füge eine Figur hinzu",
    "gui.howtos.story.step_saysomething": "Sag etwas",
    "gui.howtos.story.step_addanothersprite": "Füge eine weitere Figur hinzu",
    "gui.howtos.story.step_flip": "Dreh die Figur um",
    "gui.howtos.story.step_conversation": "Lass sie sich unterhalten",
    "gui.howtos.story.addanotherbg": "Füge einen weiteren Hintergrund hinzu",
    "gui.howtos.story.step_swithbg": "Tausche die Hintergrundbilder",
    "gui.howtos.story.step_hidewizard": "Verstecke eine Figur",
    "gui.howtos.story.step_showwizard": "Zeige eine Figur",
    "gui.howtos.make-a-chase-game.name": "Mach ein Fangspiel",
    "gui.howtos.Chase-Game.step_BG": "Füge einen Hintergrund hinzu",
    "gui.howtos.chase-game.step_AddOcto": "Füge eine Figur hinzu",
    "gui.howtos.make-music.step_LeftRight": "Bewege mit den Pfeiltasten nach links und rechts",
    "gui.howtos.Chase-Game.step_UpDown": "Bewege mit den Pfeiltasten nach oben und unten",
    "gui.howtos.Chase-Game.step_AddStar": "Füge eine weitere Figur hinzu",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bewege zufällig",
    "gui.howtos.Chase-Game.step_WhenTouch": "In der Oktopusfigur: Spiele bei Berührung einen Klang",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Erstelle eine Punktestandsvariable",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In der Oktopusfigur: Füge bei Berührung einen Punkt hinzu",
    "gui.howtos.animate-char.name": "Animiere eine Figur",
    "gui.howtos.animate-char.step_addbg": "Füge einen Hintergrund hinzu",
    "gui.howtos.animate-char.step_addsprite": "Füge eine Figur hinzu",
    "gui.howtos.animate-char.step_saysomething": "Sag etwas",
    "gui.howtos.animate-char.step_addsound": "Füge einen Klang hinzu",
    "gui.howtos.animate-char.step_animatetalking": "Animiere das Sprechen",
    "gui.howtos.animate-char.step_arrowkeys": "Bewege mit den Pfeiltasten",
    "gui.howtos.animate-char.step_jump": "Springe",
    "gui.howtos.animate-char.step_changecolor": "Ändere die Farbe",
    "gui.howtos.make-a-game.name": "Mach ein Klick-Spiel",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Wähle eine Figur",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spiele einen, Klang wenn angeklickt",
    "gui.howtos.make-a-game.step_GameAddScore": "Erstelle eine Punktestandsvariable",
    "gui.howtos.make-a-game.step_GameChangeScore": "Erhöhe den Punktestand, wenn angeklickt",
    "gui.howtos.make-a-game.step_Random": "Geh zu einer Zufallsposition",
    "gui.howtos.make-music.step_GameChangeColor": "Ändere die Farbe",
    "gui.howtos.make-music.step_ResetScore": "Setze den Punktestand zurück",
    "gui.howtos.make-it-fly.name": "Lasse sie fliegen",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Wähle ein Bühnenbild mit Himmel",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Wähle eine Figur",
    "gui.howtos.fly.step_stepflySaySomething": "Sag etwas",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Bewege mit den Pfeiltasten",
    "gui.howtos.fly.step_stepflyChooseObject": "Wähle einen Gegenstand zum Sammeln",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Lasse den Gegenstand bewegen",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Wähle deine Figur",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Füge die Punktezahl hinzu",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Speichere den Spielstand",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Szenario hinzufügen",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Bewege die Szene",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Nächstes Kostüm",
    "gui.howtos.pong": "Pong-Spiel",
    "gui.howtos.pong.step_pongAddBackdrop": "Füge einen Hintergrund hinzu",
    "gui.howtos.pong.step_pongAddBallSprite": "Füge eine Ball-Figur hinzu",
    "gui.howtos.pong.step_pongBounceAround": "Rumhüpfen",
    "gui.howtos.pong.step_pongAddPaddle": "Füge das Paddle hinzu",
    "gui.howtos.pong.step_pongMoveThePaddle": "Bewege das Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Wähle die Ball-Figur",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Lasse den Ball vom Paddle abprallen",
    "gui.howtos.pong.step_pongAddAScore": "Füge die Punktezahl hinzu",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Wähle \"Punktezahl\", resp. \"Score\"  aus dem Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Füge \"ändere Punktezahl\"-Block hinzu",
    "gui.howtos.pong.step_pongResetScore": "Setze den Punktestand zurück",
    "gui.howtos.pong.step_pongAddLineSprite": "Füge die Line-Figur hinzu",
    "gui.howtos.pong.step_pongGameOver": "Spiel vorbei",
    "gui.howtos.code-cartoon": "Programmiere eine Karikatur",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Klicke die grüne Fahne, um etwas zu sagen",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Klicke auf die Figur, um sie zu animieren",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Wähle eine andere Figur",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Verwende das Minuszeichen um zu verkleinern",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Lasse die Figur wachsen und schrumpfen",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Wähle eine andere Figur",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hüpfe rauf und runter",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klicke auf Figur, um Bühnenbild zu wechseln",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Gleite umher",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Kostüme wechseln",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Füge mehr Figuren deiner Karikatur hinzu",
    "gui.howtos.cartoon-network": "Animiere ein Abenteuerspiel",
    "gui.howtos.cartoon-network.step_CNcharacter": "Wähle die Figur, die gezeigt werden soll",
    "gui.howtos.cartoon-network.step_CNsay": "Sag etwas",
    "gui.howtos.cartoon-network.step_CNglide": "Gleite umher",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Wähle ein Objekt, das verfolgt werden soll",
    "gui.howtos.cartoon-network.step_CNcollect": "Sammle Objekte",
    "gui.howtos.cartoon-network.step_CNvariable": "Erzeuge eine Variable für den Spielstand",
    "gui.howtos.cartoon-network.step_CNscore": "Speichere den Spielstand",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Nächstes Level: Ändere den Hintergrund",
    "gui.howtos.videosens.name": "Video-Erfassung",
    "gui.howtos.videosens.step_addextension": "Füge eine Erweiterung hinzu",
    "gui.howtos.videosens.step_pet": "Streichle die Katze",
    "gui.howtos.videosens.step_animate": "Animiere",
    "gui.howtos.videosens.step_pop": "Lass einen Ballon platzen",
    "gui.howtos.say-it-out-loud": "Erstelle Animationen, die sprechen können",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Füge die \"Text zu Sprache\"-Blöcke hinzu",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sag etwas",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Wähle eine Stimme",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Bewege dich umher",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Füge einen Hintergrund hinzu",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Füge eine weitere Figur hinzu",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Führe ein Lied auf",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Ändere die Farbe",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Dreh dich im Kreis",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Wachse und Schrumpfe",
    "gui.howtos.talking": "Geschichten erzählen",
    "gui.howtos.talking.step_talesAddExtension": "Klicke  \"Erweiterung\" um \"Text zu Sprache\" Blöcke hinzuzufügen",
    "gui.howtos.talking.step_talesChooseSprite": "Figur wählen",
    "gui.howtos.talking.step_talesSaySomething": "Lasse die Figur sprechen",
    "gui.howtos.talking.step_talesChooseBackdrop": "Wähle einen Hintergrund",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klicke auf eine Figur, um zum nächsten Hintergrund zu kommen.",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Wähle eine andere Figur",
    "gui.howtos.talking.step_talesMoveAround": "Umher bewegen",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Wähle einen weiteren Hintergrund",
    "gui.howtos.talking.step_talesAnimateTalking": "Animiere das Sprechen",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Wähle einen weiteren Hintergrund",
    "gui.howtos.talking.step_talesChooseSound": "Wähle einen Klang zum Tanzen",
    "gui.howtos.talking.step_talesDanceMoves": "Tanzbewegungen",
    "gui.howtos.talking.step_talesAskAnswer": "Verwende \"Frage\"- und \"Antwort\"-Blöcke der Fühlen-Kategorie",
    "gui.howtos.add-sprite.name": "Füge eine Figur hinzu",
    "gui.howtos.add-sprite.step_addSprite": "Füge eine Figur hinzu",
    "gui.howtos.add-a-backdrop.name": "Füge einen Hintergrund hinzu",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Füge einen Hintergrund hinzu",
    "gui.howtos.change-size.name": "Ändere die Größe",
    "gui.howtos.change-size.step_changeSize": "Ändere die Grösse",
    "gui.howtos.glide-around.name": "Gleite umher",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Gleite umher",
    "gui.howtos.change-size.step_glideAroundPoint": "Zu einem Punkt gleiten",
    "gui.howtos.record-a-sound.name": "Einen Klang aufnehmen",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klicke auf das \"Klänge\"-Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klicke auf \"Aufnehmen\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Klicke den \"Aufnehmen\"-Knopf",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Wähl deinen Klang aus",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spiele deine Aufnahme ab",
    "gui.howtos.spin-video.name": "Lass es sich drehen",
    "gui.howtos.change-size.step_spinTurn": "Drehen",
    "gui.howtos.change-size.step_spinPointInDirection": "Richtung festlegen",
    "gui.howtos.hide-and-show.name": "Verstecken und Zeigen",
    "gui.howtos.change-size.step_hideAndShow": "Verstecken und Zeigen",
    "gui.howtos.switch-costume.name": "Animiere eine Figur",
    "gui.howtos.change-size.step_switchCostumes": "Animiere eine Figur",
    "gui.howtos.move-around-with-arrow-keys.name": "Benutze die Pfeiltasten",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Nach rechts und links bewegen",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Nach oben und unten bewegen",
    "gui.howtos.add-effects.name": "Füge Effekte hinzu",
    "gui.howtos.videosens.step_addEffects": "Füge Effekte hinzu",
    "gui.extension.music.name": "Musik",
    "gui.extension.music.description": "Spiele Instrumente und Schlagzeug.",
    "gui.extension.pen.name": "Malstift",
    "gui.extension.pen.description": "Zeichne mit deinen Figuren.",
    "gui.extension.videosensing.name": "Video-Erfassung",
    "gui.extension.videosensing.description": "Erfasse Bewegung mit der Kamera.",
    "gui.extension.text2speech.name": "Text zu Sprache",
    "gui.extension.text2speech.description": "Bring deinen Projekten das Sprechen bei.",
    "gui.extension.translate.name": "Übersetzen",
    "gui.extension.translate.description": "Übersetze den Text in viele Sprachen.",
    "gui.extension.makeymakey.description": "Mach alles zu einer Taste.",
    "gui.extension.microbit.description": "Verbinde deine Projekte mit der realen Welt.",
    "gui.extension.microbit.connectingMessage": "Verbinde",
    "gui.extension.ev3.description": "Baue interaktive Roboter und mehr.",
    "gui.extension.ev3.connectingMessage": "Verbinde. Stelle sicher, dass das Kennwort auf deiner EV3 auf 1234 gesetzt ist.",
    "gui.extension.boost.description": "Erwecke Roboterkreationen zum Leben.",
    "gui.extension.boost.connectingMessage": "Verbinde",
    "gui.extension.wedo2.description": "Baue mit Motoren und Sensoren.",
    "gui.extension.wedo2.connectingMessage": "Verbinde",
    "gui.extension.gdxfor.description": "Spüre Druck, Zug, Bewegung und Drehung",
    "gui.extension.gdxfor.connectingMessage": "Verbinde",
    "gui.libraryTags.all": "Alles",
    "gui.libraryTags.animals": "Tiere",
    "gui.libraryTags.dance": "Tanz",
    "gui.libraryTags.effects": "Effekte",
    "gui.libraryTags.fantasy": "Fantasie",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Essen",
    "gui.libraryTags.indoors": "Innenräume",
    "gui.libraryTags.loops": "Schleifen",
    "gui.libraryTags.music": "Musik",
    "gui.libraryTags.notes": "Noten",
    "gui.libraryTags.outdoors": "Landschaften",
    "gui.libraryTags.patterns": "Muster",
    "gui.libraryTags.people": "Personen",
    "gui.libraryTags.percussion": "Schlagwerk",
    "gui.libraryTags.space": "Weltraum",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Unterwasserwelt",
    "gui.libraryTags.voice": "Stimmen",
    "gui.libraryTags.wacky": "Verrücktes",
    "gui.libraryTags.animation": "Animationen",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Spiele",
    "gui.libraryTags.stories": "Geschichten",
    "gui.libraryTags.letters": "Buchstaben",
    "gui.opcodeLabels.direction": "Richtung",
    "gui.opcodeLabels.xposition": "x-Position",
    "gui.opcodeLabels.yposition": "y-Position",
    "gui.opcodeLabels.size": "Größe",
    "gui.opcodeLabels.costumename": "Kostümname",
    "gui.opcodeLabels.costumenumber": "Kostümnummer",
    "gui.opcodeLabels.backdropname": "Hintergrundbezeichnung",
    "gui.opcodeLabels.backdropnumber": "Hintergrundnummer",
    "gui.opcodeLabels.volume": "Lautstärke",
    "gui.opcodeLabels.tempo": "Tempo",
    "gui.opcodeLabels.answer": "Antwort",
    "gui.opcodeLabels.loudness": "Lautstärke",
    "gui.opcodeLabels.username": "Benutzername",
    "gui.opcodeLabels.year": "Jahr",
    "gui.opcodeLabels.month": "Monat",
    "gui.opcodeLabels.date": "Datum",
    "gui.opcodeLabels.dayofweek": "Wochentag",
    "gui.opcodeLabels.hour": "Stunde",
    "gui.opcodeLabels.minute": "Minute",
    "gui.opcodeLabels.second": "Sekunde",
    "gui.opcodeLabels.timer": "Stoppuhr",
    "gui.projectLoader.loadError": "Die gewählte Projekt-Datei konnte nicht geladen werden.",
    "gui.sharedMessages.backdrop": "Hintergrund{index}",
    "gui.sharedMessages.costume": "Kostüm{index}",
    "gui.sharedMessages.sprite": "Figur{index}",
    "gui.sharedMessages.pop": "Plopp",
    "gui.sharedMessages.replaceProjectWarning": "Inhalte des aktuellen Projektes ersetzen?",
    "gui.sharedMessages.loadFromComputerTitle": "Von deinem Computer hochladen",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dunkel",
    "gui.theme.highContrast": "Hoher Kontrast",
    "gui.gui.defaultProjectTitle": "Scratch-Projekt",
    "boost.color.any": "Irgendeine Farbe",
    "boost.color.black": "Schwarz",
    "boost.color.blue": "Blau",
    "boost.color.green": "Grün",
    "boost.color.red": "Rot",
    "boost.color.white": "Weiss",
    "boost.color.yellow": "Gelb",
    "boost.getMotorPosition": "Position des Motors [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "Neigungswinkel [TILT_DIRECTION]",
    "boost.motorDirection.backward": "linksherum",
    "boost.motorDirection.forward": "rechtsherum",
    "boost.motorDirection.reverse": "andersherum",
    "boost.motorOff": "Schalte Motor [MOTOR_ID] aus",
    "boost.motorOn": "Schalte Motor [MOTOR_ID] ein",
    "boost.motorOnFor": "Schalte Motor [MOTOR_ID] für [DURATION] Sekunden ein",
    "boost.motorOnForRotation": "Schalte Motor [MOTOR_ID] für [ROTATION] Umdrehungen ein",
    "boost.seeingColor": "Sehe Farbe [COLOR]?",
    "boost.setLightHue": "setze Lichtfarbe auf [HUE]",
    "boost.setMotorDirection": "Setze Richtung von Motor [MOTOR_ID] auf [MOTOR_DIRECTION]",
    "boost.setMotorPower": "Setze von Motor [MOTOR_ID] die Geschwindigkeit auf [POWER]%",
    "boost.tiltDirection.any": "irgendwohin",
    "boost.tiltDirection.down": "nach unten",
    "boost.tiltDirection.left": "nach links",
    "boost.tiltDirection.right": "nach rechts",
    "boost.tiltDirection.up": "nach oben",
    "boost.whenColor": "Wenn [COLOR] gesehen wird",
    "boost.whenTilted": "Wenn [TILT_DIRECTION_ANY] geneigt",
    "ev3.beepNote": "piepse Note [NOTE] für [TIME] Sek.",
    "ev3.buttonPressed": "Knopf [PORT] gedrückt?",
    "ev3.getBrightness": "Helligkeit",
    "ev3.getDistance": "Abstand",
    "ev3.getMotorPosition": "Position von Motor [PORT]",
    "ev3.motorSetPower": "setze Leistung von Motor [PORT] auf [POWER]%",
    "ev3.motorTurnClockwise": "drehe Motor [PORT] für [TIME]Sekunden rechtsherum",
    "ev3.motorTurnCounterClockwise": "drehe Motor [PORT]für [TIME]Sekunden linksherum",
    "ev3.whenBrightnessLessThan": "Wenn Helligkeit < [DISTANCE]",
    "ev3.whenButtonPressed": "Wenn der Knopf [PORT] gedrückt wird",
    "ev3.whenDistanceLessThan": "Wenn Abstand < [DISTANCE]",
    "gdxfor.getAcceleration": "Beschleunigung [DIRECTION]",
    "gdxfor.getForce": "Kraft",
    "gdxfor.getSpin": "Rotationsgeschwindigkeit [DIRECTION]",
    "gdxfor.getTilt": "Neigungswinkel [TILT]",
    "gdxfor.isFreeFalling": "fallend?",
    "gdxfor.isTilted": "geneigt [TILT]?",
    "gdxfor.pulled": "gezogen",
    "gdxfor.pushed": "gedrückt",
    "gdxfor.shaken": "geschüttelt",
    "gdxfor.startedFalling": "begonnen zu fallen",
    "gdxfor.tiltDirectionMenu.any": "irgendwohin",
    "gdxfor.tiltDirectionMenu.back": "nach hinten",
    "gdxfor.tiltDirectionMenu.front": "nach vorne",
    "gdxfor.tiltDirectionMenu.left": "nach links",
    "gdxfor.tiltDirectionMenu.right": "nach rechts",
    "gdxfor.turnedFaceDown": "nach unten gerichtet",
    "gdxfor.turnedFaceUp": "nach oben gerichtet",
    "gdxfor.whenForcePushedOrPulled": "Wenn Kraftsensor [PUSH_PULL]",
    "gdxfor.whenGesture": "Wenn [GESTURE]",
    "gdxfor.whenTilted": "Wenn geneigt [TILT]",
    "makeymakey.downArrow": "Pfeil nach unten",
    "makeymakey.downArrowShort": "nach unten",
    "makeymakey.leftArrow": "Pfeil nach links",
    "makeymakey.leftArrowShort": "nach links",
    "makeymakey.rightArrow": "Pfeil nach rechts",
    "makeymakey.rightArrowShort": "nach rechts",
    "makeymakey.spaceKey": "Leertaste",
    "makeymakey.upArrow": "Pfeil nach oben",
    "makeymakey.upArrowShort": "nach oben",
    "makeymakey.whenKeyPressed": "Wenn Taste [KEY] gedrückt",
    "makeymakey.whenKeysPressedInOrder": "Wenn [SEQUENCE] der Reihe nach gedrückt",
    "microbit.buttonsMenu.any": "beliebiger",
    "microbit.clearDisplay": "zeige nichts an",
    "microbit.defaultTextToDisplay": "Hallo!",
    "microbit.displaySymbol": "zeige [MATRIX] an",
    "microbit.displayText": "zeige Text [TEXT] an",
    "microbit.gesturesMenu.jumped": "hochgehüpft",
    "microbit.gesturesMenu.moved": "bewegt",
    "microbit.gesturesMenu.shaken": "geschüttelt",
    "microbit.isButtonPressed": "Knopf [BTN] gedrückt? ",
    "microbit.isTilted": "[DIRECTION] geneigt?",
    "microbit.pinStateMenu.off": "aus",
    "microbit.pinStateMenu.on": "an",
    "microbit.tiltAngle": "Neigungswinkel [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "beliebig",
    "microbit.tiltDirectionMenu.back": "nach hinten",
    "microbit.tiltDirectionMenu.front": "nach vorne",
    "microbit.tiltDirectionMenu.left": "nach links",
    "microbit.tiltDirectionMenu.right": "nach rechts",
    "microbit.whenButtonPressed": "Wenn Knopf [BTN]gedrückt wird",
    "microbit.whenGesture": "Wenn [GESTURE]",
    "microbit.whenPinConnected": "Wenn Pin [PIN] angeschlossen ist",
    "microbit.whenTilted": "Wenn [DIRECTION] geneigt",
    "music.categoryName": "Musik",
    "music.changeTempo": "ändere Tempo um [TEMPO]",
    "music.drumBass": "(2) Basstrommel",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Klangstäbe",
    "music.drumClosedHiHat": "(6) Geschlossene Hi-Hat",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Kuhglocke",
    "music.drumCrashCymbal": "(4) Crash-Becken",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Klatschen",
    "music.drumOpenHiHat": "(5) Offene Hi-Hat",
    "music.drumSideStick": "(3) Side-Stick",
    "music.drumSnare": "(1) Snare-Drum",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Holzblock",
    "music.getTempo": "Tempo",
    "music.instrumentBass": "(6) Bass-Gitarre",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Chor",
    "music.instrumentClarinet": "(10) Klarinette",
    "music.instrumentElectricGuitar": "(5) E-Gitarre",
    "music.instrumentElectricPiano": "(2) E-Piano",
    "music.instrumentFlute": "(12) Querflöte",
    "music.instrumentGuitar": "(4) Gitarre",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Musikbox",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Klavier",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophon",
    "music.instrumentSteelDrum": "(18) Steel-Drum",
    "music.instrumentSynthLead": "(20) Lead-Synthesizer",
    "music.instrumentSynthPad": "(21) Pad-Synthesizer",
    "music.instrumentTrombone": "(9) Posaune",
    "music.instrumentVibraphone": "(16) Vibraphon",
    "music.instrumentWoodenFlute": "(13) Blockflöte",
    "music.midiPlayDrumForBeats": "spiele Schlaginstrument [DRUM] für [BEATS] Schläge",
    "music.midiSetInstrument": "setze Instrument auf [INSTRUMENT]",
    "music.playDrumForBeats": "spiele Schlaginstrument [DRUM] für [BEATS] Schläge",
    "music.playNoteForBeats": "spiele Ton [NOTE] für [BEATS] Schläge",
    "music.restForBeats": "pausiere [BEATS] Schläge",
    "music.setInstrument": "setze Instrument auf [INSTRUMENT]",
    "music.setTempo": "setze Tempo auf [TEMPO]",
    "pen.categoryName": "Malstift",
    "pen.changeColorParam": "ändere Stift [COLOR_PARAM] um [VALUE]",
    "pen.changeHue": "ändere Stiftfarbe um [HUE]",
    "pen.changeShade": "ändere Farbstärke um [SHADE]",
    "pen.changeSize": "ändere Stiftdicke um [SIZE]",
    "pen.clear": "lösche alles",
    "pen.colorMenu.brightness": "Helligkeit",
    "pen.colorMenu.color": "Farbe",
    "pen.colorMenu.saturation": "Sättigung",
    "pen.colorMenu.transparency": "Transparenz",
    "pen.penDown": "schalte Stift ein",
    "pen.penUp": "schalte Stift aus",
    "pen.setColor": "setze Stiftfarbe auf [COLOR]",
    "pen.setColorParam": "setze Stift [COLOR_PARAM] auf [VALUE]",
    "pen.setHue": "setze Stiftfarbe auf [HUE]",
    "pen.setShade": "setze Farbstärke auf [SHADE]",
    "pen.setSize": "setze Stiftdicke auf [SIZE]",
    "pen.stamp": "hinterlasse Abdruck",
    "speech.defaultWhenIHearValue": "los geht's",
    "speech.extensionName": "Sprache zu Text",
    "speech.listenAndWait": "hör zu und warte",
    "speech.speechReporter": "Gesprochenes",
    "speech.whenIHear": "Wenn ich [PHRASE]höre",
    "text2speech.alto": "Alt",
    "text2speech.categoryName": "Text zu Sprache",
    "text2speech.defaultTextToSpeak": "Hallo",
    "text2speech.giant": "Riese",
    "text2speech.kitten": "Kätzchen",
    "text2speech.setLanguageBlock": "setze Sprache auf [LANGUAGE]",
    "text2speech.setVoiceBlock": "ändere die Stimme zu [VOICE]",
    "text2speech.speakAndWaitBlock": "sage [WORDS]",
    "text2speech.squeak": "Quietschen",
    "text2speech.tenor": "Tenor",
    "translate.categoryName": "Übersetzung",
    "translate.defaultTextToTranslate": "Hallo",
    "translate.translateBlock": "übersetze [WORDS] nach [LANGUAGE]",
    "translate.viewerLanguage": "Sprache",
    "videoSensing.categoryName": "Video-Erfassung",
    "videoSensing.direction": "Richtung",
    "videoSensing.motion": "Bewegung",
    "videoSensing.off": "aus",
    "videoSensing.on": "an",
    "videoSensing.onFlipped": "auf gespiegelt",
    "videoSensing.setVideoTransparency": "setze Video-Transparenz auf [TRANSPARENCY]",
    "videoSensing.sprite": "Figur",
    "videoSensing.stage": "Bühne",
    "videoSensing.videoOn": "Video-[ATTRIBUTE] von [SUBJECT]",
    "videoSensing.videoToggle": "schalte Video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "Wenn Video-Bewegung > [REFERENCE]",
    "wedo2.getDistance": "Abstand",
    "wedo2.getTiltAngle": "Neigungswinkel [TILT_DIRECTION]",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] geneigt?",
    "wedo2.motorDirection.backward": "linksherum",
    "wedo2.motorDirection.forward": "rechtsherum",
    "wedo2.motorDirection.reverse": "andersherum",
    "wedo2.motorId.a": "Motor A",
    "wedo2.motorId.all": "alle Motoren",
    "wedo2.motorId.b": "Motor B",
    "wedo2.motorId.default": "Motor",
    "wedo2.motorOff": "schalte [MOTOR_ID] aus",
    "wedo2.motorOn": "schalte [MOTOR_ID] an",
    "wedo2.motorOnFor": "schalte [MOTOR_ID] für [DURATION] Sekunden an",
    "wedo2.playNoteFor": "spiele Note [NOTE] für [DURATION] Sekunden",
    "wedo2.setLightHue": "setze Lichtfarbe auf [HUE]",
    "wedo2.setMotorDirection": "setze Richtung von [MOTOR_ID] auf [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "setze Leistung von [MOTOR_ID] auf [POWER]",
    "wedo2.tiltDirection.any": "beliebig",
    "wedo2.tiltDirection.down": "nach unten",
    "wedo2.tiltDirection.left": "nach links",
    "wedo2.tiltDirection.right": "nach rechts",
    "wedo2.tiltDirection.up": "nach oben",
    "wedo2.whenDistance": "Wenn Abstand [OP] [REFERENCE]",
    "wedo2.whenTilted": "Wenn [TILT_DIRECTION_ANY] geneigt",
    "paint.paintEditor.hue": "Farbe",
    "paint.paintEditor.saturation": "Sättigung",
    "paint.paintEditor.brightness": "Helligkeit",
    "paint.paintEditor.costume": "Kostüm",
    "paint.paintEditor.group": "Gruppieren",
    "paint.paintEditor.ungroup": "Gruppierung aufheben",
    "paint.paintEditor.undo": "Rückgängig",
    "paint.paintEditor.redo": "Wiederherstellen",
    "paint.paintEditor.forward": "nach vorne",
    "paint.paintEditor.backward": "nach hinten",
    "paint.paintEditor.front": "Ganz nach vorne",
    "paint.paintEditor.back": "Ganz nach hinten",
    "paint.paintEditor.more": "Mehr",
    "paint.modeTools.brushSize": "Größe",
    "paint.modeTools.eraserSize": "Radiererbreite",
    "paint.modeTools.copy": "Kopieren",
    "paint.modeTools.paste": "Einfügen",
    "paint.modeTools.delete": "Löschen",
    "paint.modeTools.curved": "gekrümmt",
    "paint.modeTools.pointed": "gerade",
    "paint.modeTools.thickness": "Linienstärke",
    "paint.modeTools.flipHorizontal": "Horizontal spiegeln",
    "paint.modeTools.flipVertical": "Vertikal spiegeln",
    "paint.modeTools.filled": "Ausgefüllt",
    "paint.modeTools.outlined": "Umrandet",
    "paint.paintEditor.bitmap": "In Rastergrafik umwandeln",
    "paint.paintEditor.vector": "In Vektorgrafik umwandeln",
    "paint.paintEditor.fill": "Füllfarbe",
    "paint.paintEditor.stroke": "Randfarbe",
    "paint.brushMode.brush": "Pinsel",
    "paint.eraserMode.eraser": "Radierer",
    "paint.fillMode.fill": "Fülleimer",
    "paint.lineMode.line": "Linie",
    "paint.ovalMode.oval": "Kreis",
    "paint.rectMode.rect": "Rechteck",
    "paint.reshapeMode.reshape": "Verformen",
    "paint.roundedRectMode.roundedRect": "Abgerundetes Rechteck ",
    "paint.selectMode.select": "Auswählen",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Tauschen"
  },
  "et": {
    "gui.alerts.lostPeripheralConnection": "Scratch kaotas ühenduse {extensionName}-ga.",
    "gui.alerts.tryAgain": "Proovi uuesti",
    "gui.alerts.download": "Laadi alla",
    "gui.connection.reconnect": "Ühenda uuesti",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Seljakott",
    "gui.backpack.errorBackpack": "Viga seljakoti laadimisel",
    "gui.backpack.loadingBackpack": "Laadib...",
    "gui.backpack.more": "Rohkem",
    "gui.backpack.emptyBackpack": "Seljakott on tühi",
    "gui.unsupportedBrowser.label": "Veebilehitsejat ei toetata",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Tagasi",
    "gui.unsupportedBrowser.previewfaq": "Lisainfoks mine {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "KKK",
    "gui.cards.all-tutorials": "Õpetused",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Sulge",
    "gui.cards.more-things-to-try": "Proovi veel asju!",
    "gui.cards.see-more": "Vaata veel",
    "gui.comingSoon.message1": "Ära muretse, tegeleme sellega {emoji}",
    "gui.comingSoon.message2": "Ilmub varsti...",
    "gui.comingSoon.message3": "Tegeleme sellega {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Seadmeid ei leidnud",
    "gui.connection.auto-scanning.prescan": "Kui seade on olemas, siis alusta otsimist.",
    "gui.connection.auto-scanning.pressbutton": "Vajuta oma seadme nuppu.",
    "gui.connection.auto-scanning.start-search": "Alusta otsimist",
    "gui.connection.connecting-searchbutton": "Otsing...",
    "gui.connection.auto-scanning.try-again": "Proovi uuesti",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ühendatud",
    "gui.connection.disconnect": "Ühenda lahti",
    "gui.connection.go-to-editor": "Mine redaktorisse",
    "gui.connection.connecting-cancelbutton": "Ühendub...",
    "gui.connection.error.errorMessage": "Oih! Midagi läks valesti.",
    "gui.connection.error.tryagainbutton": "Proovi uuesti",
    "gui.connection.error.helpbutton": "Abi",
    "gui.connection.peripheral-name-label": "Seadme nimi",
    "gui.connection.connect": "Ühenda",
    "gui.connection.scanning.lookingforperipherals": "Seadmete otsimine",
    "gui.connection.scanning.noPeripheralsFound": "Seadmeid ei leidnud",
    "gui.connection.scanning.instructions": "Vali oma seade loendist.",
    "gui.connection.search": "Värskenda",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Hoolitse, et Scratch Link on installeeritud ja töötab",
    "gui.connection.unavailable.enablebluetooth": "Kontrolli, et Bluetooth on lubatud",
    "gui.connection.unavailable.tryagainbutton": "Proovi uuesti",
    "gui.connection.unavailable.helpbutton": "Abi",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Mine",
    "gui.controls.stop": "Stopp",
    "gui.crashMessage.label": "Oih! Midagi läks valesti.",
    "gui.crashMessage.description": "Väga kahju, kuid Scratch on kokku jooksnud. Scratchi meeskond saab selle vea kohta automaatteate. Värskenda lehte ja proovi uuesti.",
    "gui.crashMessage.errorNumber": "See viga logiti tunnusega {errorId}",
    "gui.crashMessage.reload": "Laadi uuesti",
    "gui.customProcedures.myblockModalTitle": "Loo Plokk",
    "gui.customProcedures.addAnInputNumberText": "Lisa parameeter",
    "gui.customProcedures.numberTextType": "arv või tekst",
    "gui.customProcedures.addAnInputBoolean": "Lisa parameeter",
    "gui.customProcedures.booleanType": "tõeväärtus",
    "gui.customProcedures.addALabel": "Lisa märgend",
    "gui.customProcedures.runWithoutScreenRefresh": "Täida ekraanikuva uuendamata",
    "gui.customProcedures.cancel": "Katkesta",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Suund",
    "gui.directionPicker.rotationStyles.allAround": "suvaline",
    "gui.directionPicker.rotationStyles.leftRight": "vasak/parem",
    "gui.directionPicker.rotationStyles.dontRotate": "ei pöördu",
    "gui.gui.addExtension": "Lisa laiendus",
    "gui.gui.codeTab": "Kood",
    "gui.gui.backdropsTab": "Taustad",
    "gui.gui.costumesTab": "Kostüümid",
    "gui.gui.soundsTab": "Helid",
    "gui.extensionLibrary.comingSoon": "Ilmub varsti...",
    "gui.extensionLibrary.requires": "Nõuded",
    "gui.extensionLibrary.collaboration": "Koostöö",
    "gui.library.filterPlaceholder": "Otsing",
    "gui.library.allTag": "Kõik",
    "gui.loader.message1": "Plokkide loomine...",
    "gui.loader.message2": "Spraitide laadimine...",
    "gui.loader.message3": "Helide laadimine...",
    "gui.loader.message4": "Laienduste laadimine...",
    "gui.loader.message5": "Kaslaste karjatamine...",
    "gui.loader.message6": "Nanode edastamine...",
    "gui.loader.message7": "Gobode vuntsimine...",
    "gui.loader.message8": "Emotikonide valmistamine...",
    "gui.loader.headline": "Projekti laadimine",
    "gui.loader.creating": "Projekti loomine",
    "gui.accountMenu.profile": "Profiil",
    "gui.accountMenu.myStuff": "Minu asjad",
    "gui.accountMenu.myClasses": "Minu Klassid",
    "gui.accountMenu.myClass": "Minu Klass",
    "gui.accountMenu.accountSettings": "Konto seaded",
    "gui.accountMenu.signOut": "Logi välja",
    "gui.authorInfo.byUser": " {username}",
    "gui.menuBar.seeProjectPage": "Vaata projektilehte",
    "gui.menuBar.language": "Language",
    "general.username": "Kasutajanimi",
    "general.password": "Parool",
    "general.signIn": "Logi sisse",
    "login.needHelp": "Vajad abi?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "Juhendid",
    "gui.menuBar.restoreSprite": "Taasta sprait",
    "gui.menuBar.restoreSound": "Taasta heli",
    "gui.menuBar.restoreCostume": "Taasta kostüüm",
    "gui.menuBar.restore": "Taasta",
    "gui.menuBar.saveNow": "Salvesta nüüd",
    "gui.menuBar.saveAsCopy": "Salvesta koopiana",
    "gui.menuBar.remix": "Remiksi",
    "gui.menuBar.new": "Uus",
    "gui.menuBar.file": "Fail",
    "gui.menuBar.downloadToComputer": "Salvesta oma arvutisse",
    "gui.menuBar.edit": "Redigeeri",
    "gui.menuBar.turboModeOff": "Turborežiim välja",
    "gui.menuBar.turboModeOn": "Turborežiim sisse",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Ühine Scratchiga",
    "gui.menuBar.signIn": "Logi sisse",
    "gui.gui.projectTitlePlaceholder": "Projekti nimetus",
    "gui.menuBar.saveNowLink": "Salvesta nüüd",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Jagatud",
    "gui.menuBar.share": "Jaga",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Abi",
    "gui.modal.back": "Tagasi",
    "gui.monitor.listMonitor.empty": "(tühi)",
    "gui.monitor.listMonitor.listLength": "{length} pikkus",
    "gui.monitor.contextMenu.default": "tavaline näidik",
    "gui.monitor.contextMenu.large": "suur näidik",
    "gui.monitor.contextMenu.slider": "liugur",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Kõikide spraitide jaoks",
    "gui.gui.variableScopeOptionSpriteOnly": "Ainult selle spraidi jaoks",
    "gui.gui.cloudVariableOption": "Pilvemuutuja (serveris)",
    "gui.gui.variablePromptAllSpritesMessage": "See muutuja on kättesaadav kõigile spraitidele",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Katkesta",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stopp",
    "gui.playbackStep.playMsg": "Käivita",
    "gui.playbackStep.loadingMsg": "Laadib...",
    "gui.playbackStep.saveMsg": "Salvesta",
    "gui.playbackStep.reRecordMsg": "Salvesta uuesti",
    "gui.recordModal.title": "Salvesta heli",
    "gui.recordingStep.beginRecord": "Salvestamise alustamiseks vajuta allolevale nupule",
    "gui.recordingStep.permission": "{arrow} Vajame luba mikrofoni kasutamiseks",
    "gui.recordingStep.stop": "Lõpeta salvestamine",
    "gui.recordingStep.record": "Salvesta",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Heli",
    "gui.soundEditor.play": "Käivita",
    "gui.soundEditor.stop": "Stopp",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Salvesta",
    "gui.soundEditor.undo": "Võta tagasi",
    "gui.soundEditor.redo": "Tee uuesti",
    "gui.soundEditor.faster": "Kiiremini",
    "gui.soundEditor.slower": "Aeglasemalt",
    "gui.soundEditor.echo": "Kaja",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Valjemini",
    "gui.soundEditor.softer": "Pehmemalt",
    "gui.soundEditor.reverse": "Tagurpidi",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Nimi",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprait",
    "gui.SpriteInfo.show": "Näita",
    "gui.SpriteInfo.size": "Suurus",
    "gui.spriteSelectorItem.contextMenuDuplicate": "paljunda",
    "gui.spriteSelectorItem.contextMenuExport": "eksport",
    "gui.spriteSelectorItem.contextMenuDelete": "eemalda",
    "gui.spriteSelector.addSpriteFromLibrary": "Vali sprait",
    "gui.spriteSelector.addSpriteFromPaint": "Joonista",
    "gui.spriteSelector.addSpriteFromSurprise": "Juhuslik",
    "gui.spriteSelector.addSpriteFromFile": "Laadi sprait",
    "gui.stageHeader.stageSizeLarge": "Suurem lava",
    "gui.stageHeader.stageSizeSmall": "Väiksem lava",
    "gui.stageHeader.stageSizeFull": "Täisekraan",
    "gui.stageHeader.stageSizeUnFull": "Sulge täisekraan",
    "gui.stageHeader.fullscreenControl": "Täisekraan sisse/välja",
    "gui.spriteSelector.addBackdropFromLibrary": "Vali taust",
    "gui.stageSelector.addBackdropFromPaint": "Joonista",
    "gui.stageSelector.addBackdropFromSurprise": "Juhuslik",
    "gui.stageSelector.addBackdropFromFile": "Laadi taust",
    "gui.stageSelector.stage": "Lava",
    "gui.stageSelector.backdrops": "Taustad",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turborežiim",
    "gui.webglModal.label": "Su veebilehitseja ei toeta WebGL-i",
    "gui.webglModal.description": "Kahjuks su veebilehtiseja või arvuti {webGlLink}. Seda tehnoloogiat on vaja Scratch 3.0 käivitamiseks.",
    "gui.webglModal.webgllink": "ei toeta WebGL-i",
    "gui.webglModal.back": "Tagasi",
    "gui.webglModal.previewfaq": "Lisainfo saamiseks mine {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "KKK",
    "gui.costumeLibrary.chooseABackdrop": "Vali taust",
    "gui.costumeLibrary.chooseACostume": "Vali kostüüm",
    "gui.costumeTab.addBackdropFromLibrary": "Vali taust",
    "gui.costumeTab.addCostumeFromLibrary": "Vali kostüüm",
    "gui.costumeTab.addBlankCostume": "Joonista",
    "gui.costumeTab.addSurpriseCostume": "Juhuslik",
    "gui.costumeTab.addFileBackdrop": "Laadi taust",
    "gui.costumeTab.addFileCostume": "Laadi kostüüm",
    "gui.extensionLibrary.chooseAnExtension": "Vali laiendus",
    "gui.extensionLibrary.extensionUrl": "Lisa laienduse URL",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ei saa salvestada...",
    "gui.soundLibrary.chooseASound": "Vali heli",
    "gui.soundTab.fileUploadSound": "Laadi heli",
    "gui.soundTab.surpriseSound": "Juhuslik",
    "gui.soundTab.recordSound": "Salvesta",
    "gui.soundTab.addSoundFromLibrary": "Vali heli",
    "gui.spriteLibrary.chooseASprite": "Vali sprait",
    "gui.tipsLibrary.tutorials": "Vali juhend",
    "gui.alerts.createsuccess": "Loodi uus projekt.",
    "gui.alerts.createcopysuccess": "Projekt salvestati koopiana.",
    "gui.alerts.createremixsuccess": "Projekt salvestati remiksina.",
    "gui.alerts.creating": "Projekti loomine...",
    "gui.alerts.creatingCopy": "Projekti kopeerimine...",
    "gui.alerts.creatingRemix": "Projekti remiksimine...",
    "gui.alerts.creatingError": "Projekti loomine ei õnnestunud. Palun proovi uuesti!",
    "gui.alerts.savingError": "Projekti salvestamine ei õnnestu.",
    "gui.alerts.savesuccess": "Projekt on salvestatud.",
    "gui.alerts.saving": "Projekti salvestamine...",
    "gui.alerts.cloudInfo": "Palun arvesta, et pilvemuutujad taluvad vaid numbred, mitte tähti või muid sümboleid. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lisainfo.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Näu",
    "gui.defaultProject.variable": "minu muutuja",
    "gui.howtos.intro-move-sayhello-hat.name": "Alustamine",
    "gui.howtos.intro-move.step_stepMove": "Lisa liikumisplokk",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animeeri nimi",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Vali tähesprait",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Klõpsamisel mängi heli",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Vali mingi tähesprait",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Muuda värvi",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Vali mingi tähesprait ja pane see keerlema",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Vali mingi tähesprait ja pane see kasvama",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Tee muusikat",
    "gui.howtos.Make-Music.step_PickInstrument": "Vali instrumendisprait",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Klõpsamisel mängi heli",
    "gui.howtos.Make-Music.step_MakeSong": "Loo laul",
    "gui.howtos.make-music.step_MakeBeat": "Vali trumm ja mängi rütmi",
    "gui.howtos.make-music.step_MakeBeatBox": "Vali mikrofonisprait",
    "gui.howtos.story.name": "Loo mingi lugu",
    "gui.howtos.story.step_addbg": "Lisa taust",
    "gui.howtos.story.step_addsprite": "Lisa tegelane",
    "gui.howtos.story.step_saysomething": "Ütle midagi",
    "gui.howtos.story.step_addanothersprite": "Lisa uus tegelane",
    "gui.howtos.story.step_flip": "Muuda suunda",
    "gui.howtos.story.step_conversation": "Loo vestlus",
    "gui.howtos.story.addanotherbg": "Lisa mingi taust",
    "gui.howtos.story.step_swithbg": "Muuda tausta",
    "gui.howtos.story.step_hidewizard": "Peida tegelane",
    "gui.howtos.story.step_showwizard": "Näita tegelast",
    "gui.howtos.make-a-chase-game.name": "Loo püüdmismäng",
    "gui.howtos.Chase-Game.step_BG": "Lisa taust",
    "gui.howtos.chase-game.step_AddOcto": "Lisa sprait",
    "gui.howtos.make-music.step_LeftRight": "Liigu nooleklahvidega paremale-vasakule ",
    "gui.howtos.Chase-Game.step_UpDown": "Liigu nooleklahvidega üles-alla",
    "gui.howtos.Chase-Game.step_AddStar": "Lisa uus sprait",
    "gui.howtos.Chase-Game.step_MoveRandom": "Liigu juhuslikult",
    "gui.howtos.Chase-Game.step_WhenTouch": "Kui puudutab kaheksajalga, mängi heli",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Loo skoorimuutuja",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Kui puudutab kaheksajalga, saab punkti",
    "gui.howtos.animate-char.name": "Tegelase animeerimine",
    "gui.howtos.animate-char.step_addbg": "Lisa taust",
    "gui.howtos.animate-char.step_addsprite": "Lisa sprait",
    "gui.howtos.animate-char.step_saysomething": "Ütle midagi",
    "gui.howtos.animate-char.step_addsound": "Lisa heli",
    "gui.howtos.animate-char.step_animatetalking": "Vestluse animeerimine",
    "gui.howtos.animate-char.step_arrowkeys": "Liigu nooleklahvide abil",
    "gui.howtos.animate-char.step_jump": "Hüppa",
    "gui.howtos.animate-char.step_changecolor": "Muuda värvi",
    "gui.howtos.make-a-game.name": "Loo klõpsamismäng",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Vali sprait",
    "gui.howtos.make-a-game.step_GamePlaySound": "Klõpsamisel mängi heli",
    "gui.howtos.make-a-game.step_GameAddScore": "Loo skoorimuutuja",
    "gui.howtos.make-a-game.step_GameChangeScore": "Klõpsamisel suurenda skoori",
    "gui.howtos.make-a-game.step_Random": "Mine juhuslikku kohta",
    "gui.howtos.make-music.step_GameChangeColor": "Muuda värvi",
    "gui.howtos.make-music.step_ResetScore": "Nulli skoor",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animeeri seiklusmäng",
    "gui.howtos.cartoon-network.step_CNcharacter": "Vali etenduse jaoks tegelane",
    "gui.howtos.cartoon-network.step_CNsay": "Ütle midagi",
    "gui.howtos.cartoon-network.step_CNglide": "Liuglemine",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Vali objekt püüdmiseks",
    "gui.howtos.cartoon-network.step_CNcollect": "Objektide kokkukorjamine",
    "gui.howtos.cartoon-network.step_CNvariable": "Loo skoorimuutuja",
    "gui.howtos.cartoon-network.step_CNscore": "Pea arvestust",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Taseme muutmine: vaheta tausta",
    "gui.howtos.videosens.name": "Videoandurid",
    "gui.howtos.videosens.step_addextension": "Lisa laiendus",
    "gui.howtos.videosens.step_pet": "Paita kassi",
    "gui.howtos.videosens.step_animate": "Animeeri",
    "gui.howtos.videosens.step_pop": "Tee õhupall katki",
    "gui.howtos.say-it-out-loud": "Loo rääkivaid animatsioone",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Lisa tekst kõneplokki",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Määra hääl",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Liikumine",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Lisa taust",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Lisa uus tegelane",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Esita laul",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Muuda värvi",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Keerlemine",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Kasva ja kahane",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Lisa sprait",
    "gui.howtos.add-sprite.step_addSprite": "Lisa sprait",
    "gui.howtos.add-a-backdrop.name": "Lisa taust",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Muuda suurust",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Liuglemine",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Salvesta heli",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Pane pöörlema",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Peida ja näita",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animeeri sprait",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Kasuta nooleklahve",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Lisa efektid",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Muusika",
    "gui.extension.music.description": "Mängi pille ja trumme.",
    "gui.extension.pen.name": "Pliiats",
    "gui.extension.pen.description": "Joonista spraitidega",
    "gui.extension.videosensing.name": "Videoandurid",
    "gui.extension.videosensing.description": "Kaamerapildi liikumise tajumine",
    "gui.extension.text2speech.name": "Teksti muutmine kõneks",
    "gui.extension.text2speech.description": "Pane oma projekt rääkima",
    "gui.extension.translate.name": "Tõlgi",
    "gui.extension.translate.description": "Tõlgi tekst eri keeltesse",
    "gui.extension.makeymakey.description": "Muuda kõik võtmeks",
    "gui.extension.microbit.description": "Ühenda oma projektid pärismaailmaga.",
    "gui.extension.microbit.connectingMessage": "Ühendamine",
    "gui.extension.ev3.description": "Ehita interaktiivseid roboteid ja muud",
    "gui.extension.ev3.connectingMessage": "Ühendamine. Kontrolli, kas EV3 pin-kood on 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Ehita mootorite ja anduritega.",
    "gui.extension.wedo2.connectingMessage": "Ühendamine",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Kõik",
    "gui.libraryTags.animals": "Loomad",
    "gui.libraryTags.dance": "Tantsimine",
    "gui.libraryTags.effects": "Efektid",
    "gui.libraryTags.fantasy": "Fantaasia",
    "gui.libraryTags.fashion": "Mood",
    "gui.libraryTags.food": "Toit",
    "gui.libraryTags.indoors": "Ruumis",
    "gui.libraryTags.loops": "Kordused",
    "gui.libraryTags.music": "Muusika",
    "gui.libraryTags.notes": "Noodid",
    "gui.libraryTags.outdoors": "Õues",
    "gui.libraryTags.patterns": "Mustrid",
    "gui.libraryTags.people": "Inimesed",
    "gui.libraryTags.percussion": "Löökpillid",
    "gui.libraryTags.space": "Kosmos",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Vee all",
    "gui.libraryTags.voice": "Hääled",
    "gui.libraryTags.wacky": "Jabur",
    "gui.libraryTags.animation": "Animatsioon",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Mängud",
    "gui.libraryTags.stories": "Lood",
    "gui.libraryTags.letters": "Tähed",
    "gui.opcodeLabels.direction": "suund",
    "gui.opcodeLabels.xposition": "x",
    "gui.opcodeLabels.yposition": "y",
    "gui.opcodeLabels.size": "suurus",
    "gui.opcodeLabels.costumename": "kostüümi nimi",
    "gui.opcodeLabels.costumenumber": "kostüümi nr",
    "gui.opcodeLabels.backdropname": "tausta nimi",
    "gui.opcodeLabels.backdropnumber": "tausta nr",
    "gui.opcodeLabels.volume": "helitugevus",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "vastus",
    "gui.opcodeLabels.loudness": "valjus",
    "gui.opcodeLabels.username": "kasutajanimi",
    "gui.opcodeLabels.year": "aasta",
    "gui.opcodeLabels.month": "kuu",
    "gui.opcodeLabels.date": "kuupäev",
    "gui.opcodeLabels.dayofweek": "nädalapäev",
    "gui.opcodeLabels.hour": "tunnid",
    "gui.opcodeLabels.minute": "minutid",
    "gui.opcodeLabels.second": "sekundid",
    "gui.opcodeLabels.timer": "taimer",
    "gui.projectLoader.loadError": "Valitud projekti faili laadimine ebaõnnestus.",
    "gui.sharedMessages.backdrop": "taust{index}",
    "gui.sharedMessages.costume": "kostüüm{index}",
    "gui.sharedMessages.sprite": "Sprait{index}",
    "gui.sharedMessages.pop": "pops",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratchi projekt",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "mängi nooti [NOTE] [TIME] sek",
    "ev3.buttonPressed": "nupp [PORT] all?",
    "ev3.getBrightness": "heledus",
    "ev3.getDistance": "kaugus",
    "ev3.getMotorPosition": "mootori [PORT] positsioon",
    "ev3.motorSetPower": "võta mootori [PORT] võimsus [POWER] %",
    "ev3.motorTurnClockwise": "pööra mootor [PORT] päripäeva [TIME] sek",
    "ev3.motorTurnCounterClockwise": "pööra mootor [PORT] vastupäeva [TIME] sek",
    "ev3.whenBrightnessLessThan": "kui heledus < [DISTANCE]",
    "ev3.whenButtonPressed": "kui nupp [PORT] all",
    "ev3.whenDistanceLessThan": "kui kaugus < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "nool alla",
    "makeymakey.downArrowShort": "alla",
    "makeymakey.leftArrow": "nool vasakule",
    "makeymakey.leftArrowShort": "vasakule",
    "makeymakey.rightArrow": "nool paremale",
    "makeymakey.rightArrowShort": "paremale",
    "makeymakey.spaceKey": "tühik",
    "makeymakey.upArrow": "nool üles",
    "makeymakey.upArrowShort": "üles",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "mõni",
    "microbit.clearDisplay": "tühjenda kuva",
    "microbit.defaultTextToDisplay": "Tere!",
    "microbit.displaySymbol": "kuva [MATRIX]",
    "microbit.displayText": "kuva tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "hüppas",
    "microbit.gesturesMenu.moved": "liikus",
    "microbit.gesturesMenu.shaken": "rappus",
    "microbit.isButtonPressed": "[BTN] nupp all?",
    "microbit.isTilted": "kallutatud [DIRECTION]?",
    "microbit.pinStateMenu.off": "väljas",
    "microbit.pinStateMenu.on": "sees",
    "microbit.tiltAngle": "kaldenurk [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "mõni",
    "microbit.tiltDirectionMenu.back": "tagasi",
    "microbit.tiltDirectionMenu.front": "edasi",
    "microbit.tiltDirectionMenu.left": "vasakule",
    "microbit.tiltDirectionMenu.right": "paremale",
    "microbit.whenButtonPressed": "kui [BTN] nupp all",
    "microbit.whenGesture": "kui [GESTURE]",
    "microbit.whenPinConnected": "Kui [PIN] ühendas",
    "microbit.whenTilted": "kui kallutatud [DIRECTION]",
    "music.categoryName": "Muusika",
    "music.changeTempo": "muuda tempot [TEMPO] võrra",
    "music.drumBass": "(2) Basstrumm",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Pulgad",
    "music.drumClosedHiHat": "(6) Suletud Hi-Hat",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Lehmakell",
    "music.drumCrashCymbal": "(4) Taldrikud",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Käteplaks",
    "music.drumOpenHiHat": "(5) Lahtine Hi-Hat",
    "music.drumSideStick": "(3) Trummi serv",
    "music.drumSnare": "(1) Soolotrumm",
    "music.drumTambourine": "(7) Tamburiin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Põskvibrafon",
    "music.drumWoodBlock": "(10) Puitklots",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Tšello",
    "music.instrumentChoir": "(15) Koor",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Elektrikitarr",
    "music.instrumentElectricPiano": "(2) Elektriklaver",
    "music.instrumentFlute": "(12) Flööt",
    "music.instrumentGuitar": "(4) Kitarr",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Mängutoos",
    "music.instrumentOrgan": "(3) Orel",
    "music.instrumentPiano": "(1) Klaver",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Terastrumm",
    "music.instrumentSynthLead": "(20) Süntesaatori soolo",
    "music.instrumentSynthPad": "(21) Süntesaatori taust",
    "music.instrumentTrombone": "(9) Tromboon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Puitflööt",
    "music.midiPlayDrumForBeats": "mängi trummi [DRUM] kestusega [BEATS]",
    "music.midiSetInstrument": "võta instrumendiks [INSTRUMENT]",
    "music.playDrumForBeats": "mängi trummi [DRUM] kestusega [BEATS]",
    "music.playNoteForBeats": "mängi nooti [NOTE] [BEATS] lööki",
    "music.restForBeats": "paus [BEATS] lööki",
    "music.setInstrument": "võta instrumendiks [INSTRUMENT]",
    "music.setTempo": "võta tempoks [TEMPO]",
    "pen.categoryName": "Pliiats",
    "pen.changeColorParam": "muuda pliiatsi [COLOR_PARAM] [VALUE] võrra",
    "pen.changeHue": "muuda pliiatsi värvi [HUE] võrra",
    "pen.changeShade": "muuda pliiatsi varjundit [SHADE] võrra",
    "pen.changeSize": "muuda pliiatsi suurust [SIZE] võrra",
    "pen.clear": "kustuta kõik",
    "pen.colorMenu.brightness": "heledus",
    "pen.colorMenu.color": "värv",
    "pen.colorMenu.saturation": "küllastus",
    "pen.colorMenu.transparency": "läbipaistvus",
    "pen.penDown": "pliiats alla",
    "pen.penUp": "pliiats üles",
    "pen.setColor": "võta pliiatsi värviks [COLOR]",
    "pen.setColorParam": "võta pliiatsi [COLOR_PARAM] [VALUE]",
    "pen.setHue": "võta pliiatsi värviks [HUE]",
    "pen.setShade": "võta pliiatsi varjundiks [SHADE]",
    "pen.setSize": "võta pliiatsi suuruseks [SIZE]",
    "pen.stamp": "jäljend",
    "speech.defaultWhenIHearValue": "alustame",
    "speech.extensionName": "Kõnetuvastus",
    "speech.listenAndWait": "kuula ja oota",
    "speech.speechReporter": "kõne",
    "speech.whenIHear": "kui kuulen [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "mörin",
    "text2speech.kitten": "kiisu",
    "text2speech.setLanguageBlock": "võta keeleks [LANGUAGE]",
    "text2speech.setVoiceBlock": "võta hääleks [VOICE]",
    "text2speech.speakAndWaitBlock": "ütle [WORDS]",
    "text2speech.squeak": "piiksumine",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Tõlgi",
    "translate.defaultTextToTranslate": "tere",
    "translate.translateBlock": "tõlgi [WORDS] [LANGUAGE] keelde",
    "translate.viewerLanguage": "keel",
    "videoSensing.categoryName": "Videoandurid",
    "videoSensing.direction": "suund",
    "videoSensing.motion": "liikumine",
    "videoSensing.off": "välja",
    "videoSensing.on": "sisse",
    "videoSensing.onFlipped": "peegeldatuna",
    "videoSensing.setVideoTransparency": "võta video läbipaistvus [TRANSPARENCY]",
    "videoSensing.sprite": "sprait",
    "videoSensing.stage": "lava",
    "videoSensing.videoOn": "[SUBJECT] video [ATTRIBUTE] ",
    "videoSensing.videoToggle": "lülita video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kui video liikumine > [REFERENCE]",
    "wedo2.getDistance": "kaugus",
    "wedo2.getTiltAngle": "kaldenurk [TILT_DIRECTION]",
    "wedo2.isTilted": "kallutatud [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "tagurpidi",
    "wedo2.motorDirection.forward": "edaspidi",
    "wedo2.motorDirection.reverse": "vastupidi",
    "wedo2.motorId.a": "mootor A",
    "wedo2.motorId.all": "kõik mootorid",
    "wedo2.motorId.b": "mootor B",
    "wedo2.motorId.default": "mootor",
    "wedo2.motorOff": "lülita [MOTOR_ID] välja",
    "wedo2.motorOn": "lülita [MOTOR_ID] sisse",
    "wedo2.motorOnFor": "lülita [MOTOR_ID] sisse [DURATION] sek",
    "wedo2.playNoteFor": "mängi nooti [NOTE] [DURATION] sek",
    "wedo2.setLightHue": "võta LED värviks [HUE]",
    "wedo2.setMotorDirection": "võta [MOTOR_ID] suunaks [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "võta [MOTOR_ID] võimsuseks [POWER]",
    "wedo2.tiltDirection.any": "mingi",
    "wedo2.tiltDirection.down": "alla",
    "wedo2.tiltDirection.left": "vasakule",
    "wedo2.tiltDirection.right": "paremale",
    "wedo2.tiltDirection.up": "üles",
    "wedo2.whenDistance": "kui kaugus [OP] [REFERENCE]",
    "wedo2.whenTilted": "kui kallutatud [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Värv",
    "paint.paintEditor.saturation": "Küllastus",
    "paint.paintEditor.brightness": "Heledus",
    "paint.paintEditor.costume": "Kostüüm",
    "paint.paintEditor.group": "Rühmita",
    "paint.paintEditor.ungroup": "Tühista rühmitus",
    "paint.paintEditor.undo": "Võta tagasi",
    "paint.paintEditor.redo": "Tee uuesti",
    "paint.paintEditor.forward": "Ettepoole",
    "paint.paintEditor.backward": "Tahapoole",
    "paint.paintEditor.front": "Esiplaanile",
    "paint.paintEditor.back": "Tahaplaanile",
    "paint.paintEditor.more": "Rohkem",
    "paint.modeTools.brushSize": "Suurus",
    "paint.modeTools.eraserSize": "Kustutaja suurus",
    "paint.modeTools.copy": "Kopeeri",
    "paint.modeTools.paste": "Kleebi",
    "paint.modeTools.delete": "Kustuta",
    "paint.modeTools.curved": "Kõver",
    "paint.modeTools.pointed": "Teravatipuline",
    "paint.modeTools.thickness": "Paksus",
    "paint.modeTools.flipHorizontal": "Horisontaalne peegeldus",
    "paint.modeTools.flipVertical": "Vertikaalne peegeldus",
    "paint.modeTools.filled": "Täidetud",
    "paint.modeTools.outlined": "Piirjoonega",
    "paint.paintEditor.bitmap": "Rastergraafikasse",
    "paint.paintEditor.vector": "Vektorgraafikasse",
    "paint.paintEditor.fill": "Täide",
    "paint.paintEditor.stroke": "Piirjoon",
    "paint.brushMode.brush": "Pintsel",
    "paint.eraserMode.eraser": "Kustutaja",
    "paint.fillMode.fill": "Täide",
    "paint.lineMode.line": "Joon",
    "paint.ovalMode.oval": "Ring",
    "paint.rectMode.rect": "Ristkülik",
    "paint.reshapeMode.reshape": "Kuju muutmine",
    "paint.roundedRectMode.roundedRect": "Ümarate nurkadega ristkülik",
    "paint.selectMode.select": "Vali",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Vaheta"
  },
  "el": {
    "gui.alerts.lostPeripheralConnection": "Το Scratch αποσυνδέθηκε από το {extensionName}.",
    "gui.alerts.tryAgain": "Δοκίμασε Ξανά",
    "gui.alerts.download": "Λήψη",
    "gui.connection.reconnect": "Επανασύνδεση",
    "gui.backpack.costumeLabel": "ενδυμασία",
    "gui.backpack.soundLabel": "ήχος",
    "gui.backpack.scriptLabel": "σενάριο",
    "gui.backpack.spriteLabel": "αντικείμενο",
    "gui.backpack.header": "Σακίδιο",
    "gui.backpack.errorBackpack": "Σφάλμα κατά τη φόρτωση σακιδίου",
    "gui.backpack.loadingBackpack": "Γίνεται φόρτωση...",
    "gui.backpack.more": "Περισσότερα",
    "gui.backpack.emptyBackpack": "Το σακίδιο είναι άδειο",
    "gui.unsupportedBrowser.label": "Ο φυλλομετρητής δεν υποστηρίζεται",
    "gui.unsupportedBrowser.errorLabel": "Προέκυψε σφάλμα",
    "gui.unsupportedBrowser.notRecommended": "Λυπούμαστε, αλλά φαίνεται ότι χρησιμοποιείτε μια έκδοση φυλλομετρητή που δεν υποστηρίζει το Scratch. Συνιστούμε να κάνετε ενημέρωση στην πιο πρόσφατη έκδοση ενός υποστηριζόμενου φυλλομετρητή όπως Google Chrome, Mozilla Firefox, Microsoft Edge, ή Apple Safari.",
    "gui.unsupportedBrowser.description": "Λυπούμαστε, αλλά το Scratch δεν υποστηρίζει αυτόν τον φυλλομετρητή. Συνιστούμε να κάνετε ενημέρωση στην πιο πρόσφατη έκδοση ενός υποστηριζόμενου φυλλομετρητή όπως Google Chrome, Mozilla Firefox, Microsoft Edge, ή Apple Safari.",
    "gui.unsupportedBrowser.back": "Πίσω",
    "gui.unsupportedBrowser.previewfaq": "Για να μάθετε περισσότερα πηγαίνετε στο {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Συχνές Ερωτήσεις",
    "gui.cards.all-tutorials": "Εκπαιδευτικό υλικό",
    "gui.cards.shrink": "Σύμπτυξη",
    "gui.cards.expand": "Ανάπτυξη",
    "gui.cards.close": "Κλείσιμο",
    "gui.cards.more-things-to-try": "Περισσότερα πράγματα για να δοκιμάσετε!",
    "gui.cards.see-more": "Δείτε περισσότερα",
    "gui.comingSoon.message1": "Μην ανησυχείτε, το επεξεργαζόμαστε {emoji}",
    "gui.comingSoon.message2": "Έρχεται Σύντομα...",
    "gui.comingSoon.message3": "Το επεξεργαζόμαστε {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Δε βρέθηκαν συσκευές",
    "gui.connection.auto-scanning.prescan": "Έχετε τη συσκευή σας κοντά, και έπειτα ξεκινήστε την αναζήτηση.",
    "gui.connection.auto-scanning.pressbutton": "Πατήστε το κουμπί στη συσκευή σας.",
    "gui.connection.auto-scanning.start-search": "Έναρξη Αναζήτησης",
    "gui.connection.connecting-searchbutton": "Αναζήτηση...",
    "gui.connection.auto-scanning.try-again": "Δοκιμάστε ξανά",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Συνδέθηκε",
    "gui.connection.disconnect": "Αποσύνδεση",
    "gui.connection.go-to-editor": "Πήγαινε στον Επεξεργαστή",
    "gui.connection.connecting-cancelbutton": "Σύνδεση...",
    "gui.connection.error.errorMessage": "Ωπ, φαίνεται ότι κάτι πήγε στραβά.",
    "gui.connection.error.tryagainbutton": "Δοκιμάστε ξανά",
    "gui.connection.error.helpbutton": "Βοήθεια",
    "gui.connection.peripheral-name-label": "Όνομα συσκευής",
    "gui.connection.connect": "Σύνδεση",
    "gui.connection.scanning.lookingforperipherals": "Αναζήτηση για συσκευές",
    "gui.connection.scanning.noPeripheralsFound": "Δε βρέθηκαν συσκευές",
    "gui.connection.scanning.instructions": "Διάλεξε τη συσκευή σου από την παραπάνω λίστα.",
    "gui.connection.search": "Ανανέωση",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Βεβαιωθείτε ότι έχετε εγκαταστήσει το πρόγραμμα Scratch Link και ότι αυτό εκτελείται.",
    "gui.connection.unavailable.enablebluetooth": "Ελέγξτε ότι το Bluetooth είναι ενεργοποιημένο",
    "gui.connection.unavailable.tryagainbutton": "Δοκιμάστε ξανά",
    "gui.connection.unavailable.helpbutton": "Βοήθεια",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ξεκίνα",
    "gui.controls.stop": "Σταμάτα",
    "gui.crashMessage.label": "Ωπ! Κάτι πήγε στραβά.",
    "gui.crashMessage.description": "Λυπούμαστε, αλλά φαίνεται πως το Scratch τερματίστηκε απροσδόκητα. Αυτό το πρόβλημα έχει αναφερθεί αυτόματα στην Ομάδα του Scratch. Παρακαλούμε επαναφορτώστε τη σελίδα σας για να ξαναπροσπαθήσετε.",
    "gui.crashMessage.errorNumber": "Το σφάλμα σας καταχωρήθηκε με id {errorId}",
    "gui.crashMessage.reload": "Επαναφόρτωση",
    "gui.customProcedures.myblockModalTitle": "Δημιούργησε ένα τετράγωνο εντολών",
    "gui.customProcedures.addAnInputNumberText": "Πρόσθεσε είσοδο δεδομένων",
    "gui.customProcedures.numberTextType": "αριθμός ή κείμενο",
    "gui.customProcedures.addAnInputBoolean": "Πρόσθεσε είσοδο δεδομένων",
    "gui.customProcedures.booleanType": "λογική",
    "gui.customProcedures.addALabel": "Πρόσθεσε ετικέτα",
    "gui.customProcedures.runWithoutScreenRefresh": "Εκτέλεση χωρίς ανανέωση οθόνης",
    "gui.customProcedures.cancel": "Ακύρωση",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Κατεύθυνση",
    "gui.directionPicker.rotationStyles.allAround": "Πλήρης Περιστροφή",
    "gui.directionPicker.rotationStyles.leftRight": "Αριστερά/Δεξιά",
    "gui.directionPicker.rotationStyles.dontRotate": "Χωρίς περιστροφή",
    "gui.gui.addExtension": "Προσθήκη Επέκτασης",
    "gui.gui.codeTab": "Κώδικας",
    "gui.gui.backdropsTab": "Yπόβαθρα",
    "gui.gui.costumesTab": "Ενδυμασίες",
    "gui.gui.soundsTab": "Ήχοι",
    "gui.extensionLibrary.comingSoon": "Έρχεται Σύντομα",
    "gui.extensionLibrary.requires": "Απαιτεί",
    "gui.extensionLibrary.collaboration": "Σε συνεργασία με ",
    "gui.library.filterPlaceholder": "Αναζήτηση",
    "gui.library.allTag": "Όλα",
    "gui.loader.message1": "Δημιουργία εντολών...",
    "gui.loader.message2": "Φόρτωση αντικειμένων ...",
    "gui.loader.message3": "Φόρτωση ήχων ...",
    "gui.loader.message4": "Φόρτωση επεκτάσεων ...",
    "gui.loader.message5": "Υπερφόρτωση ...",
    "gui.loader.message6": "Μετάδοση νανο ...",
    "gui.loader.message7": "Αρχικοποίηση του Gobo...",
    "gui.loader.message8": "Προετοιμασία emoji...",
    "gui.loader.headline": "Φόρτωση Έργου",
    "gui.loader.creating": "Δημιουργία έργου",
    "gui.accountMenu.profile": "Προφίλ",
    "gui.accountMenu.myStuff": "Τα πράγματά μου",
    "gui.accountMenu.myClasses": "Οι τάξεις μου",
    "gui.accountMenu.myClass": "Η τάξη μου",
    "gui.accountMenu.accountSettings": "Ρυθμίσεις Λογαριασμού",
    "gui.accountMenu.signOut": "Αποσύνδεση",
    "gui.authorInfo.byUser": "από {username}",
    "gui.menuBar.seeProjectPage": "Δείτε τη Σελίδα του Έργου",
    "gui.menuBar.language": "Language",
    "general.username": "Όνομα χρήστη",
    "general.password": "Κωδικός",
    "general.signIn": "Σύνδεση",
    "login.needHelp": "Χρειάζεστε Βοήθεια;",
    "form.validationRequired": "Αυτό το πεδίο είναι υποχρεωτικό",
    "gui.menuBar.tutorialsLibrary": "Εκπαιδευτικό υλικό",
    "gui.menuBar.restoreSprite": "Επαναφορά Αντικείμενου",
    "gui.menuBar.restoreSound": "Επαναφορά Ήχου",
    "gui.menuBar.restoreCostume": "Επαναφορά Ενδυμασίας",
    "gui.menuBar.restore": "Επαναφορά",
    "gui.menuBar.saveNow": "Αποθήκευση τώρα",
    "gui.menuBar.saveAsCopy": "Αποθήκευση ως Αντιγράφου",
    "gui.menuBar.remix": "Ανάμειξη",
    "gui.menuBar.new": "Νέο Έργο",
    "gui.menuBar.file": "Αρχείο",
    "gui.menuBar.downloadToComputer": "Αποθήκευση στον υπολογιστή σου",
    "gui.menuBar.edit": "Επεξεργασία",
    "gui.menuBar.turboModeOff": "Απενεργοποίηση Κατάστασης Turbo",
    "gui.menuBar.turboModeOn": "Ενεργοποίηση Κατάστασης Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Εγγραφή στο Scratch",
    "gui.menuBar.signIn": "Σύνδεση",
    "gui.gui.projectTitlePlaceholder": "Τίτλος Έργου εδώ",
    "gui.menuBar.saveNowLink": "Αποθήκευση Τώρα",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Σε κοινή χρήση",
    "gui.menuBar.share": "Μοιραστείτε",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Βοήθεια",
    "gui.modal.back": "Πίσω",
    "gui.monitor.listMonitor.empty": "(άδεια)",
    "gui.monitor.listMonitor.listLength": "μήκος {length}",
    "gui.monitor.contextMenu.default": "κανονική προβολή κειμένου",
    "gui.monitor.contextMenu.large": "μεγάλη προβολή κειμένου",
    "gui.monitor.contextMenu.slider": "γραμμή κύλισης",
    "gui.monitor.contextMenu.sliderRange": "αλλαγή εύρους γραμμής κύλισης",
    "gui.monitor.contextMenu.import": "εισαγωγή",
    "gui.monitor.contextMenu.export": "εξαγωγή",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Αναπαραγωγή",
    "gui.playButton.stop": "Διακοπή",
    "gui.gui.variableScopeOptionAllSprites": "Για όλα τα αντικείμενα",
    "gui.gui.variableScopeOptionSpriteOnly": "Μόνο για αυτό το αντικείμενο",
    "gui.gui.cloudVariableOption": "Μεταβλητή cloud (αποθηκευμένη στον server)",
    "gui.gui.variablePromptAllSpritesMessage": "Η μεταβλητή αυτή είναι διαθέσιμη σε όλα τα αντικείμενα.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Ακύρωση",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Διακοπή",
    "gui.playbackStep.playMsg": "Αναπαραγωγή",
    "gui.playbackStep.loadingMsg": "Γίνεται φόρτωση...",
    "gui.playbackStep.saveMsg": "Αποθήκευση",
    "gui.playbackStep.reRecordMsg": "Επανάληψη εγγραφής",
    "gui.recordModal.title": "Εγγραφή Ήχου",
    "gui.recordingStep.beginRecord": "Ξεκίνα την ηχογράφηση πατώντας το παρακάτω κουμπί",
    "gui.recordingStep.permission": "{arrow}Χρειαζόμαστε την άδεια σου για τη χρήση του μικρόφωνου",
    "gui.recordingStep.stop": "Τέλος ηχογράφησης",
    "gui.recordingStep.record": "Ηχογράφηση",
    "gui.sliderModal.min": "Ελάχιστη τιμή",
    "gui.sliderModal.max": "Μέγιστη τιμή",
    "gui.sliderModal.title": "Αλλαγή εύρους γραμμής κύλισης",
    "gui.sliderPrompt.cancel": "Ακύρωση",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Ήχος",
    "gui.soundEditor.play": "Αναπαραγωγή",
    "gui.soundEditor.stop": "Διακοπή",
    "gui.soundEditor.copy": "Αντιγραφή",
    "gui.soundEditor.paste": "Επικόλληση",
    "gui.soundEditor.copyToNew": "Αντιγραφή σε Νέο",
    "gui.soundEditor.delete": "Διαγραφή",
    "gui.soundEditor.save": "Αποθήκευση",
    "gui.soundEditor.undo": "Αναίρεση",
    "gui.soundEditor.redo": "Επανάληψη",
    "gui.soundEditor.faster": "Γρηγορότερα",
    "gui.soundEditor.slower": "Πιο αργά",
    "gui.soundEditor.echo": "Ηχώ",
    "gui.soundEditor.robot": "Ρομπότ",
    "gui.soundEditor.louder": "Δυνατότερα",
    "gui.soundEditor.softer": "Απαλότερα",
    "gui.soundEditor.reverse": "Αντιστροφή",
    "gui.soundEditor.fadeOut": "Σβήσιμο",
    "gui.soundEditor.fadeIn": "Σταδιακή είσοδος",
    "gui.soundEditor.mute": "Σίγαση",
    "gui.SpriteInfo.spritePlaceholder": "Όνομα",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Αντικείμενο",
    "gui.SpriteInfo.show": "Προβολή",
    "gui.SpriteInfo.size": "Μέγεθος",
    "gui.spriteSelectorItem.contextMenuDuplicate": "διπλασιασμός",
    "gui.spriteSelectorItem.contextMenuExport": "εξαγωγή",
    "gui.spriteSelectorItem.contextMenuDelete": "διαγραφή",
    "gui.spriteSelector.addSpriteFromLibrary": "Επιλέξτε ένα Αντικείμενο",
    "gui.spriteSelector.addSpriteFromPaint": "Ζωγραφική",
    "gui.spriteSelector.addSpriteFromSurprise": "Έκπληξη",
    "gui.spriteSelector.addSpriteFromFile": "Μεταφόρτωση Αντικείμενου",
    "gui.stageHeader.stageSizeLarge": "Εναλλαγή σε μεγάλη σκηνή",
    "gui.stageHeader.stageSizeSmall": "Εναλλαγή σε μικρή σκηνή",
    "gui.stageHeader.stageSizeFull": "Προβολή πλήρους οθόνης",
    "gui.stageHeader.stageSizeUnFull": "Έξοδος από προβολή πλήρους οθόνης",
    "gui.stageHeader.fullscreenControl": "Έλεγχος Πλήρους Οθόνης",
    "gui.spriteSelector.addBackdropFromLibrary": "Επιλέξτε Υπόβαθρο",
    "gui.stageSelector.addBackdropFromPaint": "Ζωγραφική",
    "gui.stageSelector.addBackdropFromSurprise": "Έκπληξη",
    "gui.stageSelector.addBackdropFromFile": "Μεταφόρτωση Υποβάθρου",
    "gui.stageSelector.stage": "Σκηνή",
    "gui.stageSelector.backdrops": "Yπόβαθρα",
    "gui.telemetryOptIn.label": "Αναφορά στατιστικών για βελτίωση του Scratch",
    "gui.telemetryOptIn.body1": "Η Ομάδα του Scratch επιζητά πάντοτε να κατανοήσει καλύτερα τον τρόπο χρήσης του Scratch σε όλον τον κόσμο. Για να συνδράμετε στην υποστήριξη αυτής της προσπάθειας, μπορείτε να επιτρέψετε στο Scratch να αποστέλλει αυτόματα πληροφορίες χρήσης στην ομάδα του Scratch.",
    "gui.telemetryOptIn.body2": "Οι πληροφορίες που συλλέγουμε περιλαμβάνουν επιλογή γλώσσας, χρήση εντολών, και κάποια γεγονότα όπως αποθήκευση, φόρτωση, και ανέβασμα ενός έργου. ΔΕ συλλέγουμε καμία προσωπική πληροφορία. Παρακαλούμε να δείτε την {privacyPolicyLink}μας για περισσότερες πληροφορίες.",
    "gui.telemetryOptIn.privacyPolicyLink": "Πολιτική Απορρήτου",
    "gui.telemetryOptIn.optInText": "Κοινή χρήση των δεδομένων χρήσης μου με την Ομάδα του Scratch",
    "gui.telemetryOptIn.optInTooltip": "Ενεργοποίηση τηλεμετρίας",
    "gui.telemetryOptIn.optOutText": "Όχι κοινή χρήση των δεδομένων χρήσης μου με την Ομάδα του Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Απενεργοποίηση τηλεμετρίας",
    "gui.telemetryOptIn.settingWasUpdated": "Η ρύθμισή σας ενημερώθηκε.",
    "gui.telemetryOptIn.buttonClose": "Κλείσιμο",
    "gui.turboMode.active": "Λειτουργία Turbo",
    "gui.webglModal.label": "Ο φυλλομετρητής σας δεν υποστηρίζει WebGL",
    "gui.webglModal.description": "Δυστυχώς, φαίνεται ότι ο φυλλομετρητής σας ή ο υπολογιστής σας {webGlLink}. Αυτή η τεχνολογία χρειάζεται για να λειτουργήσει το Scratch 3.0.",
    "gui.webglModal.webgllink": "δεν υποστηρίζει WebGL",
    "gui.webglModal.back": "Πίσω",
    "gui.webglModal.previewfaq": "Για να μάθετε περισσότερα, πηγαίνετε στο {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Συχνές Ερωτήσεις",
    "gui.costumeLibrary.chooseABackdrop": "Επιλέξτε Υπόβαθρο",
    "gui.costumeLibrary.chooseACostume": "Επιλέξτε Ενδυμασία",
    "gui.costumeTab.addBackdropFromLibrary": "Επιλέξτε Υπόβαθρο",
    "gui.costumeTab.addCostumeFromLibrary": "Επιλέξτε Ενδυμασία",
    "gui.costumeTab.addBlankCostume": "Ζωγραφική",
    "gui.costumeTab.addSurpriseCostume": "Έκπληξη",
    "gui.costumeTab.addFileBackdrop": "Μεταφόρτωση Υποβάθρου",
    "gui.costumeTab.addFileCostume": "Μεταφόρτωση Ενδυμασίας",
    "gui.extensionLibrary.chooseAnExtension": "Επιλέξτε μια Επέκταση",
    "gui.extensionLibrary.extensionUrl": "Εισάγετε το URL της επέκτασης",
    "gui.monitors.importListColumnPrompt": "Ποια στήλη να χρησιμοποιηθεί (1-{numberOfColumns});",
    "gui.recordingStep.alertMsg": "Η εγγραφή δεν ήταν δυνατό να ξεκινήσει",
    "gui.soundLibrary.chooseASound": "Διάλεξε Ήχο",
    "gui.soundTab.fileUploadSound": "Μεταφόρτωση Ήχου",
    "gui.soundTab.surpriseSound": "Έκπληξη",
    "gui.soundTab.recordSound": "Ηχογράφηση",
    "gui.soundTab.addSoundFromLibrary": "Διάλεξε Ήχο",
    "gui.spriteLibrary.chooseASprite": "Διάλεξε Αντικείμενο",
    "gui.tipsLibrary.tutorials": "Διάλεξε Εκπαιδευτικό Υλικό",
    "gui.alerts.createsuccess": "Δημιουργήθηκε νέο έργο.",
    "gui.alerts.createcopysuccess": "Το έργο αποθηκεύτηκε ως αντίγραφο.",
    "gui.alerts.createremixsuccess": "Το έργο αποθηκεύτηκε ως ανάμειξη.",
    "gui.alerts.creating": "Γίνεται δημιουργία...",
    "gui.alerts.creatingCopy": "Γίνεται αντιγραφή έργου...",
    "gui.alerts.creatingRemix": "Γίνεται ανάμειξη έργου...",
    "gui.alerts.creatingError": "Η δημιουργία του έργου απέτυχε. Παρακαλώ δοκιμάστε πάλι!",
    "gui.alerts.savingError": "Το έργο δεν αποθηκεύτηκε.",
    "gui.alerts.savesuccess": "Το έργο αποθηκεύτηκε.",
    "gui.alerts.saving": "Αποθήκευση έργου...",
    "gui.alerts.cloudInfo": "Επισημαίνεται ότι οι cloud μεταβλητές υποστηρίζουν μόνο αριθμούς, όχι γράμματα ή σύμβολα. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Μάθε περισσότερα.",
    "gui.alerts.importing": "Γίνεται εισαγωγή...",
    "gui.defaultProject.meow": "Νιάου",
    "gui.defaultProject.variable": "η μεταβλητή μου",
    "gui.howtos.intro-move-sayhello-hat.name": "Ξεκινώντας",
    "gui.howtos.intro-move.step_stepMove": "Πρόσθεσε ένα μπλοκ κίνησης",
    "gui.howtos.add-a-move-block.step_stepSay": "Πρόσθεσε ένα μπλοκ \"πες\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Κάνε κλικ στην πράσινη σημαία για να ξεκινήσεις",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Ζωντάνεψε ένα Όνομα",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Διάλεξε ένα Αντικείμενο Γράμματος",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Παίξε έναν Ήχο Όταν Πατηθεί",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Διάλεξε ένα Άλλο Αντικείμενο Γράμματος",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Άλλαξε χρώμα",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Διάλεξε ένα Άλλο Αντικείμενο Γράμματος & Κάνε το να Περιστραφεί",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Διάλεξε ένα Άλλο Αντικείμενο Γράμματος & Κάνε το να Μεγαλώσει",
    "gui.howtos.imagine": "Φαντάσου έναν Κόσμο",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Πληκτρολόγησε Τι Θέλεις Να Πεις",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Κάνε Κλικ στην Πράσινη Σημαία για να Ξεκινήσει",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Επίλεξε Κάποιο Υπόβαθρο",
    "gui.howtos.imagine.step_imagineChooseSprite": "Επίλεξε Κάποιον Χαρακτήρα",
    "gui.howtos.imagine.step_imagineFlyAround": "Πίεσε το Πλήκτρο του Διαστήματος για να Ολισθήσει",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Επίλεξε Έναν Άλλο Χαρακτήρα",
    "gui.howtos.imagine.step_imagineLeftRight": "Κινήσου Αριστερά-Δεξιά",
    "gui.howtos.imagine.step_imagineUpDown": "Κινήσου Πάνω-Κάτω",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Άλλαξε Ενδυμασίες",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Ολίσθησε σε ένα Σημείο",
    "gui.howtos.imagine.step_imagineGrowShrink": "Μεγάλωσε και Μίκρυνε",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Επίλεξε Ένα Άλλο Υπόβαθρο",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Άλλαξε Υπόβαθρα",
    "gui.howtos.imagine.step_imagineRecordASound": "Πρόσθεσε έναν Ήχο",
    "gui.howtos.imagine.step_imagineChooseSound": "Επίλεξε τον Ήχο Σου",
    "gui.howtos.make-music.name": "Δημιούργησε Μουσική",
    "gui.howtos.Make-Music.step_PickInstrument": "Διάλεξε ένα Αντικείμενο Μουσικού οργάνου",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Παίξε Ήχο Όταν Πατηθεί",
    "gui.howtos.Make-Music.step_MakeSong": "Δημιούργησε ένα Τραγούδι",
    "gui.howtos.make-music.step_MakeBeat": "Διάλεξε ένα Τύμπανο & Δημιούργησε έναν Ρυθμό",
    "gui.howtos.make-music.step_MakeBeatBox": "Διάλεξε το Αντικείμενο Μικρόφωνο & Ξάφνιασε το Beatbox",
    "gui.howtos.story.name": "Δημιούργησε μια Ιστορία",
    "gui.howtos.story.step_addbg": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.story.step_addsprite": "Πρόσθεσε Χαρακτήρα",
    "gui.howtos.story.step_saysomething": "Πες Κάτι",
    "gui.howtos.story.step_addanothersprite": "Πρόσθεσε έναν Άλλον Χαρακτήρα",
    "gui.howtos.story.step_flip": "Ανάστρεψε Κατεύθυνση",
    "gui.howtos.story.step_conversation": "Συζήτησε",
    "gui.howtos.story.addanotherbg": "Πρόσθεσε ένα Άλλο Υπόβαθρο",
    "gui.howtos.story.step_swithbg": "Άλλαξε Υπόβαθρα",
    "gui.howtos.story.step_hidewizard": "Εξαφάνισε Χαρακτήρα",
    "gui.howtos.story.step_showwizard": "Εμφάνισε Χαρακτήρα",
    "gui.howtos.make-a-chase-game.name": "Δημιούργησε ένα Παιχνίδι Κυνηγητού",
    "gui.howtos.Chase-Game.step_BG": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.chase-game.step_AddOcto": "Πρόσθεσε Αντικείμενο",
    "gui.howtos.make-music.step_LeftRight": "Κινήσου Δεξιά & Αριστερά με Βελάκια",
    "gui.howtos.Chase-Game.step_UpDown": "Κινήσου Πάνω & Κάτω με Βελάκια",
    "gui.howtos.Chase-Game.step_AddStar": "Πρόσθεσε ένα Άλλο Αντικείμενο",
    "gui.howtos.Chase-Game.step_MoveRandom": "Κινήσου Τυχαία",
    "gui.howtos.Chase-Game.step_WhenTouch": "Στο Αντικείμενο Χταπόδι, Όταν Αγγίζεις, Παίξε Ήχο",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Δημιούργησε Μεταβλητή Σκορ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Στο Αντικείμενο Χταπόδι, Όταν Αγγίζεις, Πρόσθεσε Σκορ",
    "gui.howtos.animate-char.name": "Ζωντάνεψε Έναν Χαρακτήρα",
    "gui.howtos.animate-char.step_addbg": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.animate-char.step_addsprite": "Πρόσθεσε Αντικείμενο",
    "gui.howtos.animate-char.step_saysomething": "Πες Κάτι",
    "gui.howtos.animate-char.step_addsound": "Πρόσθεσε Ήχο",
    "gui.howtos.animate-char.step_animatetalking": "Ζωντάνεψε την Ομιλία",
    "gui.howtos.animate-char.step_arrowkeys": "Κινήσου Με Βελάκια",
    "gui.howtos.animate-char.step_jump": "Πήδα",
    "gui.howtos.animate-char.step_changecolor": "Άλλαξε Χρώμα",
    "gui.howtos.make-a-game.name": "Φτιάξε ένα Παιχνίδι με Κλικ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Επίλεξε ένα Αντικείμενο",
    "gui.howtos.make-a-game.step_GamePlaySound": "Παίξε Ήχο Όταν Πατηθεί",
    "gui.howtos.make-a-game.step_GameAddScore": "Δημιούργησε Μεταβλητή Σκορ",
    "gui.howtos.make-a-game.step_GameChangeScore": "Όταν Πατηθεί, Αύξησε το Σκορ",
    "gui.howtos.make-a-game.step_Random": "Πήγαινε σε μια τυχαία θέση",
    "gui.howtos.make-music.step_GameChangeColor": "Άλλαξε Χρώμα",
    "gui.howtos.make-music.step_ResetScore": "Επανάφερε το Σκορ",
    "gui.howtos.make-it-fly.name": "Κάνε το να Πετάξει",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Επίλεξε ένα Υπόβαθρο με Ουρανό",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Επίλεξε Έναν Χαρακτήρα",
    "gui.howtos.fly.step_stepflySaySomething": "Πες Κάτι",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Κινήσου Με Τα Βέλη",
    "gui.howtos.fly.step_stepflyChooseObject": "Επίλεξε ένα Αντικείμενο για Συλλογή",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Κάνε το Αντικείμενο να Κινείται",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Επίλεξε τον Χαρακτήρα Σου",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Πρόσθεσε Σκορ",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Κράτησε Σκορ",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Πρόσθεσε Σκηνικό",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Μετακίνησε το Σκηνικό",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Επόμενη Ενδυμασία",
    "gui.howtos.pong": "Παιχνίδι Πινγκ-Πονγκ",
    "gui.howtos.pong.step_pongAddBackdrop": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.pong.step_pongAddBallSprite": "Πρόσθεσε ένα Αντικείμενο Μπάλα",
    "gui.howtos.pong.step_pongBounceAround": "Αναπήδα Τριγύρω",
    "gui.howtos.pong.step_pongAddPaddle": "Πρόσθεσε μια Σανίδα",
    "gui.howtos.pong.step_pongMoveThePaddle": "Κίνησε τη Σανίδα",
    "gui.howtos.pong.step_pongSelectBallSprite": "Επίλεξε το Αντικείμενο Μπάλα",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Πρόσθεσε Κώδικα για να Αναπηδήσει η Μπάλα Από τη Σανίδα",
    "gui.howtos.pong.step_pongAddAScore": "Πρόσθεσε Σκορ",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Επίλεξε 'Σκορ' από το Μενού",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Πρόσθεσε την Εντολή 'Άλλαξε Σκορ'",
    "gui.howtos.pong.step_pongResetScore": "Επανάφερε το Σκορ",
    "gui.howtos.pong.step_pongAddLineSprite": "Πρόσθεσε το Αντικείμενο Γραμμή",
    "gui.howtos.pong.step_pongGameOver": "Τέλος Παιχνιδιού",
    "gui.howtos.code-cartoon": "Προγραμμάτισε ένα Κινούμενο Σχέδιο",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Πες Κάτι Όταν Κάνεις Κλικ στην Πράσινη Σημαία",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Ζωντάνεψε έναν Χαρακτήρα Όταν Κάνεις Κλικ Πάνω του",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Επίλεξε έναν Διαφορετικό Χαρακτήρα",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Χρησιμοποίησε το Σύμβολο Μείον για να Μικρύνει",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Κάνε έναν Χαρακτήρα να Μεγαλώνει και να Μικραίνει",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Επίλεξε έναν Διαφορετικό Χαρακτήρα",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Πήδα Πάνω Κάτω",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Κάνε Κλικ πάνω σε έναν Χαρακτήρα για να Αλλάξει Σκηνικά",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Ολίσθησε Τριγύρω",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Άλλαξε Ενδυμασίες",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Επίλεξε Περισσότερους Χαρακτήρες για να Προσθέσεις στο Κινούμενο Σχέδιό Σου",
    "gui.howtos.cartoon-network": "Ζωντάνεψε ένα Παιχνίδι Περιπέτειας",
    "gui.howtos.cartoon-network.step_CNcharacter": "Επίλεξε Χαρακτήρα για Εμφάνιση",
    "gui.howtos.cartoon-network.step_CNsay": "Πες Κάτι",
    "gui.howtos.cartoon-network.step_CNglide": "Ολίσθησε Τριγύρω",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Διάλεξε ένα Αντικείμενο για να το Κυνηγήσεις",
    "gui.howtos.cartoon-network.step_CNcollect": "Μάζεψε Αντικείμενα",
    "gui.howtos.cartoon-network.step_CNvariable": "Δημιούργησε μια Μεταβλητή Σκορ",
    "gui.howtos.cartoon-network.step_CNscore": "Κράτησε Σκορ",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Επίπεδο Πάνω: Άλλαξε Υπόβαθρο",
    "gui.howtos.videosens.name": "Προβολή από Κάμερα",
    "gui.howtos.videosens.step_addextension": "Πρόσθεσε Επέκταση",
    "gui.howtos.videosens.step_pet": "Χάιδεψε τη Γάτα",
    "gui.howtos.videosens.step_animate": "Ζωντάνεψε",
    "gui.howtos.videosens.step_pop": "Σκάσε ένα Μπαλόνι",
    "gui.howtos.say-it-out-loud": "Δημιούργησε Κινούμενα Σχέδια Που Μιλούν",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Πρόσθεσε τις εντολές Κείμενο σε Ομιλία",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Πες Κάτι",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Όρισε Φωνή",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Κινήσου Τριγύρω",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Πρόσθεσε έναν Άλλον Χαρακτήρα",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Πες ένα Τραγούδι",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Άλλαξε Χρώμα",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Κάνε Περιστροφή",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Μεγάλωσε και Μίκρυνε",
    "gui.howtos.talking": "Ιστορίες που Μιλάνε",
    "gui.howtos.talking.step_talesAddExtension": "Κάνε Κλικ για να προσθέσεις τις Εντολές Κείμενο-σε-Ομιλία",
    "gui.howtos.talking.step_talesChooseSprite": "Επίλεξε Αντικείμενο",
    "gui.howtos.talking.step_talesSaySomething": "Κάνε έναν Χαρακτήρα να Μιλήσει",
    "gui.howtos.talking.step_talesChooseBackdrop": "Επίλεξε Υπόβαθρο",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Κάνε Κλικ Πάνω σε έναν Χαρακτήρα για να Πάει στο Επόμενο Υπόβαθρο",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Επίλεξε Ένα Άλλο Αντικείμενο",
    "gui.howtos.talking.step_talesMoveAround": "Κινήσου Τριγύρω",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Επίλεξε Ένα Άλλο Υπόβαθρο",
    "gui.howtos.talking.step_talesAnimateTalking": "Ζωντάνεψε την Ομιλία",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Επίλεξε Ένα Άλλο Υπόβαθρο",
    "gui.howtos.talking.step_talesChooseSound": "Επίλεξε Τραγούδι για να Χορέψει",
    "gui.howtos.talking.step_talesDanceMoves": "Χορευτικές Κινήσεις",
    "gui.howtos.talking.step_talesAskAnswer": "Φέρε τις Εντολές Ρώτα και Απάντησε από την Κατηγορία Προβολή από Κάμερα",
    "gui.howtos.add-sprite.name": "Πρόσθεσε Αντικείμενο",
    "gui.howtos.add-sprite.step_addSprite": "Πρόσθεσε Αντικείμενο",
    "gui.howtos.add-a-backdrop.name": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Πρόσθεσε Υπόβαθρο",
    "gui.howtos.change-size.name": "Άλλαξε Μέγεθος",
    "gui.howtos.change-size.step_changeSize": "Άλλαξε Μέγεθος",
    "gui.howtos.glide-around.name": "Ολίσθησε Τριγύρω",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Ολίσθησε Τριγύρω",
    "gui.howtos.change-size.step_glideAroundPoint": "Ολίσθησε σε ένα Σημείο",
    "gui.howtos.record-a-sound.name": "Κάνε Εγγραφή Ήχου",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Κάνε Κλικ στην Καρτέλα 'Ήχοι'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Κάνε Κλικ στο 'Εγγραφή'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Πάτησε το Κουμπί Εγγραφής",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Επίλεξε τον Ήχο Σου",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Παίξε τον Ήχο Σου",
    "gui.howtos.spin-video.name": "Κάνε Το να Περιστρέφεται",
    "gui.howtos.change-size.step_spinTurn": "Στρίψε",
    "gui.howtos.change-size.step_spinPointInDirection": "Όρισε Κατεύθυνση",
    "gui.howtos.hide-and-show.name": "Εξαφάνισε και Εμφάνισε",
    "gui.howtos.change-size.step_hideAndShow": "Εξαφάνισε και Εμφάνισε",
    "gui.howtos.switch-costume.name": "Ζωντάνεψε ένα Αντικείμενο",
    "gui.howtos.change-size.step_switchCostumes": "Ζωντάνεψε ένα Αντικείμενο",
    "gui.howtos.move-around-with-arrow-keys.name": "Χρησιμοποίησε τα Βελάκια",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Κινήσου Αριστερά και Δεξιά",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Κινήσου Πάνω και Κάτω",
    "gui.howtos.add-effects.name": "Πρόσθεσε Εφέ",
    "gui.howtos.videosens.step_addEffects": "Πρόσθεσε Εφέ",
    "gui.extension.music.name": "Μουσική",
    "gui.extension.music.description": "Παίξε όργανα και τύμπανα.",
    "gui.extension.pen.name": "Πένα",
    "gui.extension.pen.description": "Σχεδίασε με τα αντικείμενά σου.",
    "gui.extension.videosensing.name": "Προβολή από Κάμερα",
    "gui.extension.videosensing.description": "Ανίχνευση κίνησης με την κάμερα.",
    "gui.extension.text2speech.name": "Κείμενο σε Ομιλία",
    "gui.extension.text2speech.description": "Κάνε τα έργα σου να μιλούν.",
    "gui.extension.translate.name": "Μετάφραση",
    "gui.extension.translate.description": "Μετάφρασε κείμενο σε πολλές γλώσσες.",
    "gui.extension.makeymakey.description": "Μετάτρεψε οτιδήποτε σε πλήκτρο.",
    "gui.extension.microbit.description": "Σύνδεσε τα έργα σου με τον πραγματικό κόσμο.",
    "gui.extension.microbit.connectingMessage": "Γίνεται σύνδεση",
    "gui.extension.ev3.description": "Φτιάξε διαδραστικά ρομπότ και άλλα.",
    "gui.extension.ev3.connectingMessage": "Γίνεται σύνδεση. Βεβαιωθείτε ότι η ακίδα στο EV3 σας έχει οριστεί σε 1234.",
    "gui.extension.boost.description": "Ζωντάνεψε ρομποτικές δημιουργίες.",
    "gui.extension.boost.connectingMessage": "Γίνεται σύνδεση",
    "gui.extension.wedo2.description": "Κατασκεύασε με κινητήρες και αισθητήρες.",
    "gui.extension.wedo2.connectingMessage": "Γίνεται σύνδεση",
    "gui.extension.gdxfor.description": "Ανίχνευσε σπρώξιμο, τράβηγμα, κίνηση, και περιστροφή.",
    "gui.extension.gdxfor.connectingMessage": "Γίνεται σύνδεση",
    "gui.libraryTags.all": "Όλα",
    "gui.libraryTags.animals": "Ζώα",
    "gui.libraryTags.dance": "Χορός",
    "gui.libraryTags.effects": "Εφέ",
    "gui.libraryTags.fantasy": "Φαντασία",
    "gui.libraryTags.fashion": "Μόδα",
    "gui.libraryTags.food": "Τρόφιμα",
    "gui.libraryTags.indoors": "Εσωτερικοί χώροι",
    "gui.libraryTags.loops": "Λούπες",
    "gui.libraryTags.music": "Μουσική",
    "gui.libraryTags.notes": "Νότες",
    "gui.libraryTags.outdoors": "Εξωτερικοί Χώροι",
    "gui.libraryTags.patterns": "Μοτίβα",
    "gui.libraryTags.people": "Άνθρωποι",
    "gui.libraryTags.percussion": "Κρουστά",
    "gui.libraryTags.space": "Διάστημα",
    "gui.libraryTags.sports": "Αθλήματα",
    "gui.libraryTags.underwater": "Υποβρύχια",
    "gui.libraryTags.voice": "Φωνή",
    "gui.libraryTags.wacky": "Αστείοι ήχοι",
    "gui.libraryTags.animation": "Κινούμενα σχέδια",
    "gui.libraryTags.art": "Τέχνη",
    "gui.libraryTags.games": "Παιχνίδια",
    "gui.libraryTags.stories": "Ιστορίες",
    "gui.libraryTags.letters": "Γράμματα",
    "gui.opcodeLabels.direction": "κατεύθυνση",
    "gui.opcodeLabels.xposition": "θέση x",
    "gui.opcodeLabels.yposition": "θέση y",
    "gui.opcodeLabels.size": "μέγεθος",
    "gui.opcodeLabels.costumename": "όνομα ενδυμασίας",
    "gui.opcodeLabels.costumenumber": "αριθμός ενδυμασίας",
    "gui.opcodeLabels.backdropname": "όνομα υποβάθρου",
    "gui.opcodeLabels.backdropnumber": "αριθμός υποβάθρου",
    "gui.opcodeLabels.volume": "ένταση",
    "gui.opcodeLabels.tempo": "ρυθμός",
    "gui.opcodeLabels.answer": "απάντηση",
    "gui.opcodeLabels.loudness": "ένταση",
    "gui.opcodeLabels.username": "όνομα χρήστη",
    "gui.opcodeLabels.year": "έτος",
    "gui.opcodeLabels.month": "μήνας",
    "gui.opcodeLabels.date": "ημερομηνία",
    "gui.opcodeLabels.dayofweek": "μέρα της εβδομάδας",
    "gui.opcodeLabels.hour": "ώρα",
    "gui.opcodeLabels.minute": "λεπτό",
    "gui.opcodeLabels.second": "δευτερόλεπτο",
    "gui.opcodeLabels.timer": "χρονόμετρο",
    "gui.projectLoader.loadError": "Απέτυχε η φόρτωση του αρχείου έργου που επιλέχθηκε.",
    "gui.sharedMessages.backdrop": "υπόβαθρο{index}",
    "gui.sharedMessages.costume": "ενδυμασία{index}",
    "gui.sharedMessages.sprite": "Αντικείμενο{index}",
    "gui.sharedMessages.pop": "ποπ",
    "gui.sharedMessages.replaceProjectWarning": "Αντικατάσταση περιεχομένων του παρόντος έργου;",
    "gui.sharedMessages.loadFromComputerTitle": "Φόρτωση από τον υπολογιστή σου",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Έργο Scratch",
    "boost.color.any": "όποιο χρώμα",
    "boost.color.black": "μαύρο",
    "boost.color.blue": "μπλε",
    "boost.color.green": "πράσινο",
    "boost.color.red": "κόκκινο",
    "boost.color.white": "άσπρο",
    "boost.color.yellow": "κίτρινο",
    "boost.getMotorPosition": "θέση κινητήρα [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "γωνία κλίσης [TILT_DIRECTION]",
    "boost.motorDirection.backward": "προς εκείνη την κατεύθυνση",
    "boost.motorDirection.forward": "προς αυτήν την κατεύθυνση",
    "boost.motorDirection.reverse": "αντιστροφή",
    "boost.motorOff": "απενεργοποίησε κινητήρα [MOTOR_ID]",
    "boost.motorOn": "ενεργοποίσε κινητήρα [MOTOR_ID]",
    "boost.motorOnFor": "ενεργοποίησε κινητήρα [MOTOR_ID] για [DURATION] δευτ.",
    "boost.motorOnForRotation": "ενεργοποίησε κινητήρα [MOTOR_ID] για [ROTATION] περιστροφές",
    "boost.seeingColor": "βλέπει [COLOR] τούβλο;",
    "boost.setLightHue": "όρισε χρώμα φωτός σε [HUE]",
    "boost.setMotorDirection": "όρισε κατεύθυνση [MOTOR_DIRECTION] κινητήρα [MOTOR_ID]",
    "boost.setMotorPower": "όρισε ταχύτητα κινητήρα [MOTOR_ID] σε [POWER] %",
    "boost.tiltDirection.any": "οπουδήποτε",
    "boost.tiltDirection.down": "κάτω",
    "boost.tiltDirection.left": "αριστερά",
    "boost.tiltDirection.right": "δεξιά",
    "boost.tiltDirection.up": "πάνω",
    "boost.whenColor": "όταν έχει δει [COLOR] τούβλο",
    "boost.whenTilted": "όταν κλίση [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "παίξε τη νότα [NOTE] για [TIME] δευτ.",
    "ev3.buttonPressed": "πατήθηκε το κουμπί [PORT];",
    "ev3.getBrightness": "φωτεινότητα",
    "ev3.getDistance": "απόσταση",
    "ev3.getMotorPosition": "θέση κινητήρα [PORT]",
    "ev3.motorSetPower": "κινητήρα [PORT] όρισε ισχύ [POWER] %",
    "ev3.motorTurnClockwise": "κινητήρα [PORT] στρίψε προς αυτήν την κατεύθυνση για [TIME] δευτ.",
    "ev3.motorTurnCounterClockwise": "κινητήρα [PORT] στρίψε προς την άλλη κατεύθυνση για [TIME] δευτ.",
    "ev3.whenBrightnessLessThan": "όταν φωτεινότητα < [DISTANCE]",
    "ev3.whenButtonPressed": "όταν πατηθεί το κουμπί [PORT] ",
    "ev3.whenDistanceLessThan": "όταν απόσταση < [DISTANCE]",
    "gdxfor.getAcceleration": "επιτάχυνση [DIRECTION]",
    "gdxfor.getForce": "ισχύς",
    "gdxfor.getSpin": "ταχύτητα περιστροφής [DIRECTION]",
    "gdxfor.getTilt": "γωνία κλίσης [TILT]",
    "gdxfor.isFreeFalling": "σε πτώση;",
    "gdxfor.isTilted": "σε κλίση [TILT];",
    "gdxfor.pulled": "τραβηχτεί",
    "gdxfor.pushed": "πιεστεί",
    "gdxfor.shaken": "τρανταχθεί",
    "gdxfor.startedFalling": "αρχίσει πτώση",
    "gdxfor.tiltDirectionMenu.any": "οπουδήποτε",
    "gdxfor.tiltDirectionMenu.back": "πίσω",
    "gdxfor.tiltDirectionMenu.front": "μπροστά",
    "gdxfor.tiltDirectionMenu.left": "αριστερά",
    "gdxfor.tiltDirectionMenu.right": "δεξιά",
    "gdxfor.turnedFaceDown": "στραμμένο προς τα κάτω",
    "gdxfor.turnedFaceUp": "στραμμένο προς τα πάνω",
    "gdxfor.whenForcePushedOrPulled": "όταν αισθητήρας ισχύος [PUSH_PULL]",
    "gdxfor.whenGesture": "όταν [GESTURE]",
    "gdxfor.whenTilted": "όταν σε κλίση[TILT]",
    "makeymakey.downArrow": "κάτω βέλος",
    "makeymakey.downArrowShort": "κάτω",
    "makeymakey.leftArrow": "αριστερό βέλος",
    "makeymakey.leftArrowShort": "αριστερά",
    "makeymakey.rightArrow": "δεξί βέλος",
    "makeymakey.rightArrowShort": "δεξιά",
    "makeymakey.spaceKey": "διάστημα",
    "makeymakey.upArrow": "πάνω βέλος",
    "makeymakey.upArrowShort": "πάνω",
    "makeymakey.whenKeyPressed": "όταν πατηθεί το κουμπί [KEY]",
    "makeymakey.whenKeysPressedInOrder": "όταν πατηθεί με σειρά [SEQUENCE]",
    "microbit.buttonsMenu.any": "οποιοδήποτε",
    "microbit.clearDisplay": "καθάρισε οθόνη",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "εμφάνισε [MATRIX]",
    "microbit.displayText": "εμφάνισε κείμενο [TEXT]",
    "microbit.gesturesMenu.jumped": "αναπηδήσει",
    "microbit.gesturesMenu.moved": "κινηθεί",
    "microbit.gesturesMenu.shaken": "τρανταχθεί",
    "microbit.isButtonPressed": "πατήθηκε το κουμπί [BTN];",
    "microbit.isTilted": "σε κλίση [DIRECTION];",
    "microbit.pinStateMenu.off": "ανενεργό",
    "microbit.pinStateMenu.on": "ενεργό",
    "microbit.tiltAngle": "γωνία κλίσης [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "οπουδήποτε",
    "microbit.tiltDirectionMenu.back": "πίσω",
    "microbit.tiltDirectionMenu.front": "μπροστά",
    "microbit.tiltDirectionMenu.left": "αριστερά",
    "microbit.tiltDirectionMenu.right": "δεξιά",
    "microbit.whenButtonPressed": "όταν πατηθεί το κουμπί [BTN]",
    "microbit.whenGesture": "όταν [GESTURE]",
    "microbit.whenPinConnected": "όταν ακίδσ [PIN] συνδεθεί",
    "microbit.whenTilted": "όταν σε κλίση [DIRECTION]",
    "music.categoryName": "Μουσική",
    "music.changeTempo": "άλλαξε ρυθμό κατά [TEMPO]",
    "music.drumBass": "(2) Μπάσο Τύμπανο",
    "music.drumBongo": "(13) Μπόνγκο",
    "music.drumCabasa": "(15) Καμπάσα",
    "music.drumClaves": "(9) Κλάβες",
    "music.drumClosedHiHat": "(6) Κλειστά Πιατίνια",
    "music.drumConga": "(14) Κόνγκα",
    "music.drumCowbell": "(11) Κουδούνα",
    "music.drumCrashCymbal": "(4) Κύμβαλο Crash",
    "music.drumCuica": "(18) Κουίκα",
    "music.drumGuiro": "(16) Γκουίρο",
    "music.drumHandClap": "(8) Παλαμάκια",
    "music.drumOpenHiHat": "(5) Ανοικτά Πιατίνια",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Ταμπούρο",
    "music.drumTambourine": "(7) Ντέφι",
    "music.drumTriangle": "(12) Τρίγωνο",
    "music.drumVibraslap": "(17) Βίμπρασλαπ",
    "music.drumWoodBlock": "(10) Ξύλινη Κασετίνα",
    "music.getTempo": "ρυθμός",
    "music.instrumentBass": "(6) Μπάσο",
    "music.instrumentBassoon": "(14) Φαγκότο",
    "music.instrumentCello": "(8) Τσέλο",
    "music.instrumentChoir": "(15) Χορωδία",
    "music.instrumentClarinet": "(10) Κλαρινέτο",
    "music.instrumentElectricGuitar": "(5) Ηλεκτρική κιθάρα",
    "music.instrumentElectricPiano": "(2) Ηλεκτρικό πιάνο",
    "music.instrumentFlute": "(12) Φλάουτο",
    "music.instrumentGuitar": "(4) Κιθάρα",
    "music.instrumentMarimba": "(19) Μαρίμπα",
    "music.instrumentMusicBox": "(17) Μουσικό Κουτί",
    "music.instrumentOrgan": "(3) Εκκλησιαστικό Όργανο",
    "music.instrumentPiano": "(1) Πιάνο",
    "music.instrumentPizzicato": "(7) Πιτσικάτο",
    "music.instrumentSaxophone": "(11) Σαξόφωνο",
    "music.instrumentSteelDrum": "(18) Μεταλλικό Τύμπανο",
    "music.instrumentSynthLead": "(20) Εισαγωγή Συνθεσάιζερ",
    "music.instrumentSynthPad": "(21) Πληκτρολόγιο Συνθεσάιζερ",
    "music.instrumentTrombone": "(9) Τρομπόνι",
    "music.instrumentVibraphone": "(16) Βιμπράφωνο",
    "music.instrumentWoodenFlute": "(13) Ξύλινο φλάουτο",
    "music.midiPlayDrumForBeats": "παίξε τύμπανο [DRUM] για [BEATS] χτύπους",
    "music.midiSetInstrument": "όρισε όργανο σε [INSTRUMENT]",
    "music.playDrumForBeats": "παίξε τύμπανο [DRUM] για [BEATS] χτύπους",
    "music.playNoteForBeats": "παίξε νότα [NOTE] για [BEATS] χτύπους",
    "music.restForBeats": "κάνε παύση για [BEATS] χτύπους",
    "music.setInstrument": "όρισε όργανο σε [INSTRUMENT]",
    "music.setTempo": "όρισε ρυθμό σε [TEMPO]",
    "pen.categoryName": "Πένα",
    "pen.changeColorParam": "άλλαξε [COLOR_PARAM] πένας κατά [VALUE]",
    "pen.changeHue": "άλλαξε χρώμα πένας κατά [HUE]",
    "pen.changeShade": "άλλαξε σκιά πένας κατά [SHADE]",
    "pen.changeSize": "άλλαξε μέγεθος πένας κατά [SIZE]",
    "pen.clear": "καθάρισε όλα",
    "pen.colorMenu.brightness": "φωτεινότητα",
    "pen.colorMenu.color": "χρώμα",
    "pen.colorMenu.saturation": "κορεσμό",
    "pen.colorMenu.transparency": "διαφάνεια",
    "pen.penDown": "κατέβασε πένα",
    "pen.penUp": "σήκωσε πένα",
    "pen.setColor": "όρισε χρώμα πένας σε [COLOR]",
    "pen.setColorParam": "όρισε [COLOR_PARAM] πένας σε [VALUE]",
    "pen.setHue": "όρισε χρώμα πένας σε [HUE]",
    "pen.setShade": "όρισε σκιά πένας σε [SHADE]",
    "pen.setSize": "όρισε μέγεθος πένας σε [SIZE]",
    "pen.stamp": "σφραγίδα",
    "speech.defaultWhenIHearValue": "let's go",
    "speech.extensionName": "Ομιλία σε Κείμενο",
    "speech.listenAndWait": "άκουσε και περίμενε",
    "speech.speechReporter": "ομιλία",
    "speech.whenIHear": "όταν ακούσω [PHRASE]",
    "text2speech.alto": "άλτο",
    "text2speech.categoryName": "Κείμενο σε Ομιλία",
    "text2speech.defaultTextToSpeak": "γεια",
    "text2speech.giant": "γίγαντας",
    "text2speech.kitten": "γατάκι",
    "text2speech.setLanguageBlock": "όρισε γλώσσα σε [LANGUAGE]",
    "text2speech.setVoiceBlock": "όρισε φωνή σε [VOICE]",
    "text2speech.speakAndWaitBlock": "μίλησε [WORDS]",
    "text2speech.squeak": "στριγκλιά ",
    "text2speech.tenor": "τενόρος",
    "translate.categoryName": "Μετάφρασε",
    "translate.defaultTextToTranslate": "γεια",
    "translate.translateBlock": "μετάφρασε [WORDS] σε [LANGUAGE]",
    "translate.viewerLanguage": "γλώσσα",
    "videoSensing.categoryName": "Προβολή από Κάμερα",
    "videoSensing.direction": "κατεύθυνση",
    "videoSensing.motion": "κίνηση",
    "videoSensing.off": "απενεργοποιημένο",
    "videoSensing.on": "ενεργοποιημένο",
    "videoSensing.onFlipped": "αναστραμμένο",
    "videoSensing.setVideoTransparency": "όρισε διαφάνεια βίντεο σε [TRANSPARENCY]",
    "videoSensing.sprite": "αντικείμενο",
    "videoSensing.stage": "σκηνή",
    "videoSensing.videoOn": "βίντεο [ATTRIBUTE] για [SUBJECT]",
    "videoSensing.videoToggle": "βίντεο [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "όταν κίνηση βίντεο > [REFERENCE]",
    "wedo2.getDistance": "απόσταση",
    "wedo2.getTiltAngle": "γωνία κλίσης [TILT_DIRECTION]",
    "wedo2.isTilted": "έχει κλίση [TILT_DIRECTION_ANY];",
    "wedo2.motorDirection.backward": "προς εκείνη την κατεύθυνση",
    "wedo2.motorDirection.forward": "προς αυτήν την κατεύθυνση",
    "wedo2.motorDirection.reverse": "αντιστροφή",
    "wedo2.motorId.a": "κινητήρα A",
    "wedo2.motorId.all": "όλους κινητήρες",
    "wedo2.motorId.b": "κινητήρα B",
    "wedo2.motorId.default": "κινητήρα",
    "wedo2.motorOff": "απενεργοποίησε κινητήρα [MOTOR_ID]",
    "wedo2.motorOn": "ενεργοποίησε κινητήρα [MOTOR_ID]",
    "wedo2.motorOnFor": "ενεργοποίησε [MOTOR_ID] για [DURATION] δευτ.",
    "wedo2.playNoteFor": "παίξε νότα [NOTE] για [DURATION] δευτ.",
    "wedo2.setLightHue": "όρισε χρώμα φωτός σε [HUE]",
    "wedo2.setMotorDirection": "όρισε κατεύθυνση [MOTOR_DIRECTION] στον [MOTOR_ID]",
    "wedo2.startMotorPower": "όρισε ισχύ του [MOTOR_ID] σε [POWER]",
    "wedo2.tiltDirection.any": "οπουδήποτε",
    "wedo2.tiltDirection.down": "κάτω",
    "wedo2.tiltDirection.left": "αριστερά",
    "wedo2.tiltDirection.right": "δεξιά",
    "wedo2.tiltDirection.up": "πάνω",
    "wedo2.whenDistance": "όταν απόσταση [OP] [REFERENCE]",
    "wedo2.whenTilted": "όταν κλίση [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Χρώμα",
    "paint.paintEditor.saturation": "Κορεσμός",
    "paint.paintEditor.brightness": "Φωτεινότητα",
    "paint.paintEditor.costume": "Ενδυμασία",
    "paint.paintEditor.group": "Ομαδοποίηση",
    "paint.paintEditor.ungroup": "Διαχωρισμός",
    "paint.paintEditor.undo": "Αναίρεση",
    "paint.paintEditor.redo": "Επανάληψη",
    "paint.paintEditor.forward": "Προς τα εμπρός",
    "paint.paintEditor.backward": "Προς τα πίσω",
    "paint.paintEditor.front": "Προσκήνιο",
    "paint.paintEditor.back": "Παρασκήνιο",
    "paint.paintEditor.more": "Περισσότερα",
    "paint.modeTools.brushSize": "Μέγεθος",
    "paint.modeTools.eraserSize": "Μέγεθος γόμας",
    "paint.modeTools.copy": "Αντιγραφή",
    "paint.modeTools.paste": "Επικόλληση",
    "paint.modeTools.delete": "Διαγραφή",
    "paint.modeTools.curved": "Καμπύλες",
    "paint.modeTools.pointed": "Μυτερό",
    "paint.modeTools.thickness": "Πάχος",
    "paint.modeTools.flipHorizontal": "Οριζόντια Αναστροφή",
    "paint.modeTools.flipVertical": "Κατακόρυφη Αναστροφή",
    "paint.modeTools.filled": "Γεμάτο",
    "paint.modeTools.outlined": "Με περίγραμμα",
    "paint.paintEditor.bitmap": "Μετατροπή σε Ψηφιοαπεικόνιση (Bitmap)",
    "paint.paintEditor.vector": "Μετατροπή σε Διάνυσμα (Vector)",
    "paint.paintEditor.fill": "Γέμισμα",
    "paint.paintEditor.stroke": "Περίγραμμα",
    "paint.brushMode.brush": "Πινέλο",
    "paint.eraserMode.eraser": "Γόμα",
    "paint.fillMode.fill": "Γέμισμα",
    "paint.lineMode.line": "Γραμμή",
    "paint.ovalMode.oval": "Κύκλος",
    "paint.rectMode.rect": "Ορθογώνιο",
    "paint.reshapeMode.reshape": "Αλλαγή σχήματος",
    "paint.roundedRectMode.roundedRect": "Στρογγυλεμένο Ορθογώνιο",
    "paint.selectMode.select": "Επιλογή",
    "paint.textMode.text": "Κείμενο",
    "paint.colorPicker.swap": "Αντιμετάθεση"
  },
  "emoji": {
    "gui.alerts.lostPeripheralConnection": "❌🔌 {extensionName}.",
    "gui.alerts.tryAgain": "🔁",
    "gui.alerts.download": "💾⬇️🖥️",
    "gui.connection.reconnect": "🔁🔌",
    "gui.backpack.costumeLabel": "🎭",
    "gui.backpack.soundLabel": "🔊",
    "gui.backpack.scriptLabel": "🧱",
    "gui.backpack.spriteLabel": "😺",
    "gui.backpack.header": "🎒",
    "gui.backpack.errorBackpack": "❌🚚🎒",
    "gui.backpack.loadingBackpack": "🚚⌚",
    "gui.backpack.more": "▶️",
    "gui.backpack.emptyBackpack": "🎒🔲",
    "gui.unsupportedBrowser.label": "Browser is not supported",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Back",
    "gui.unsupportedBrowser.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "💡",
    "gui.cards.shrink": "➡️🐭",
    "gui.cards.expand": "➡️🐘",
    "gui.cards.close": "📪",
    "gui.cards.more-things-to-try": "More things to try!",
    "gui.cards.see-more": "See more",
    "gui.comingSoon.message1": "😸🔨⌚ {emoji}",
    "gui.comingSoon.message2": "🛬⌚",
    "gui.comingSoon.message3": "🔨⌚ {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "Have your device nearby, then begin searching.",
    "gui.connection.auto-scanning.pressbutton": "Press the button on your device.",
    "gui.connection.auto-scanning.start-search": "Start Searching",
    "gui.connection.connecting-searchbutton": "Searching...",
    "gui.connection.auto-scanning.try-again": "Try again",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Connected",
    "gui.connection.disconnect": "Disconnect",
    "gui.connection.go-to-editor": "Go to Editor",
    "gui.connection.connecting-cancelbutton": "Connecting...",
    "gui.connection.error.errorMessage": "Oops, looks like something went wrong.",
    "gui.connection.error.tryagainbutton": "Try again",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "Connect",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "Select your device in the list above.",
    "gui.connection.search": "Refresh",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Make sure you have Scratch Link installed and running",
    "gui.connection.unavailable.enablebluetooth": "Check that Bluetooth is enabled",
    "gui.connection.unavailable.tryagainbutton": "Try again",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "🏁",
    "gui.controls.stop": "🛑",
    "gui.crashMessage.label": "😯⚠️",
    "gui.crashMessage.description": "😢😺💥🔄️📄",
    "gui.crashMessage.errorNumber": "⚠️📜🆔 {errorId}",
    "gui.crashMessage.reload": "🔄️",
    "gui.customProcedures.myblockModalTitle": "🔨🧱",
    "gui.customProcedures.addAnInputNumberText": "➕✏️",
    "gui.customProcedures.numberTextType": "🔢🔡",
    "gui.customProcedures.addAnInputBoolean": "➕✏️",
    "gui.customProcedures.booleanType": "👌",
    "gui.customProcedures.addALabel": "➕🔤",
    "gui.customProcedures.runWithoutScreenRefresh": "🔨🏃💨🐇",
    "gui.customProcedures.cancel": "❌",
    "gui.customProcedures.ok": "👌",
    "gui.SpriteInfo.direction": "🧭",
    "gui.directionPicker.rotationStyles.allAround": "👥",
    "gui.directionPicker.rotationStyles.leftRight": "↔️",
    "gui.directionPicker.rotationStyles.dontRotate": "❌🔄️",
    "gui.gui.addExtension": "➕🤖",
    "gui.gui.codeTab": "🧱🧱",
    "gui.gui.backdropsTab": "🌆🌆",
    "gui.gui.costumesTab": "🎭🎭",
    "gui.gui.soundsTab": "🔊🔊",
    "gui.extensionLibrary.comingSoon": "🛬⌚",
    "gui.extensionLibrary.requires": "❗",
    "gui.extensionLibrary.collaboration": "🤝",
    "gui.library.filterPlaceholder": "🔍",
    "gui.library.allTag": "👥",
    "gui.loader.message1": "🔨🧱⌚",
    "gui.loader.message2": "🚚😺⌚",
    "gui.loader.message3": "🚚🔊⌚",
    "gui.loader.message4": "🚚🤖⌚",
    "gui.loader.message5": "🐈🐈⌚",
    "gui.loader.message6": "📻👾⌚",
    "gui.loader.message7": "🎈🐡⌚",
    "gui.loader.message8": "🔨🙂⌚",
    "gui.loader.headline": "🚚⌚",
    "gui.loader.creating": "🔨⌚",
    "gui.accountMenu.profile": "👤🖼️",
    "gui.accountMenu.myStuff": "👤📦",
    "gui.accountMenu.myClasses": "👤🏫🏫",
    "gui.accountMenu.myClass": "👤🏫",
    "gui.accountMenu.accountSettings": "👤🛠️",
    "gui.accountMenu.signOut": "👤📤",
    "gui.authorInfo.byUser": "{username}",
    "gui.menuBar.seeProjectPage": "👁️📦📄",
    "gui.menuBar.language": "🌐💬",
    "general.username": "👤📛",
    "general.password": "📟",
    "general.signIn": "👤📥",
    "login.needHelp": "❓",
    "form.validationRequired": "❗",
    "gui.menuBar.tutorialsLibrary": "💡",
    "gui.menuBar.restoreSprite": "↩️🗑️😺",
    "gui.menuBar.restoreSound": "↩️🗑️🔊",
    "gui.menuBar.restoreCostume": "↩️🗑️🎭",
    "gui.menuBar.restore": "↩️🗑️",
    "gui.menuBar.saveNow": "💾",
    "gui.menuBar.saveAsCopy": "💾📄📄",
    "gui.menuBar.remix": "💿",
    "gui.menuBar.new": "🆕",
    "gui.menuBar.file": "📁",
    "gui.menuBar.downloadToComputer": "💾⬇️🖥️",
    "gui.menuBar.edit": "✍️",
    "gui.menuBar.turboModeOff": "🏃💨🌚",
    "gui.menuBar.turboModeOn": "🏃💨🌝",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "➕😺",
    "gui.menuBar.signIn": "👤📥",
    "gui.gui.projectTitlePlaceholder": "📦📛",
    "gui.menuBar.saveNowLink": "💾",
    "gui.menuBar.settings": "🛠️",
    "gui.menuBar.isShared": "🍕👌",
    "gui.menuBar.share": "🍕",
    "gui.menuBar.colorMode": "🎨",
    "gui.modal.help": "❓",
    "gui.modal.back": "⬅️",
    "gui.monitor.listMonitor.empty": "🔲",
    "gui.monitor.listMonitor.listLength": "📏 {length}",
    "gui.monitor.contextMenu.default": "👁️😐",
    "gui.monitor.contextMenu.large": "👁️🐘",
    "gui.monitor.contextMenu.slider": "🎚️",
    "gui.monitor.contextMenu.sliderRange": "🎚️↔️",
    "gui.monitor.contextMenu.import": "🚢⬆️",
    "gui.monitor.contextMenu.export": "🚢⬇️",
    "gui.monitor.contextMenu.hide": "🫥",
    "gui.playButton.play": "▶️",
    "gui.playButton.stop": "⏹️",
    "gui.gui.variableScopeOptionAllSprites": "👥😺",
    "gui.gui.variableScopeOptionSpriteOnly": "1️⃣😺",
    "gui.gui.cloudVariableOption": "📜☁️ (💾☁️🖥️)",
    "gui.gui.variablePromptAllSpritesMessage": "📜➡️👥😺",
    "gui.gui.listPromptAllSpritesMessage": "📋➡️👥😺",
    "gui.prompt.cancel": "❌",
    "gui.prompt.ok": "👌",
    "gui.playbackStep.stopMsg": "⏹️",
    "gui.playbackStep.playMsg": "▶️",
    "gui.playbackStep.loadingMsg": "🚚⌚",
    "gui.playbackStep.saveMsg": "💾",
    "gui.playbackStep.reRecordMsg": "🔄️⏺️",
    "gui.recordModal.title": "⏺️➡️🆕🔊",
    "gui.recordingStep.beginRecord": "🏁⏺️👇",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "⏹️⏺️",
    "gui.recordingStep.record": "⏺️",
    "gui.sliderModal.min": "🐣",
    "gui.sliderModal.max": "🐘",
    "gui.sliderModal.title": "🎚️↔️",
    "gui.sliderPrompt.cancel": "❌",
    "gui.sliderPrompt.ok": "👌",
    "gui.soundEditor.sound": "🔊",
    "gui.soundEditor.play": "▶️",
    "gui.soundEditor.stop": "⏹️",
    "gui.soundEditor.copy": "📄📄",
    "gui.soundEditor.paste": "📋",
    "gui.soundEditor.copyToNew": "📄📄➡️🆕",
    "gui.soundEditor.delete": "✂️",
    "gui.soundEditor.save": "💾",
    "gui.soundEditor.undo": "↩️",
    "gui.soundEditor.redo": "↪️",
    "gui.soundEditor.faster": "🐇",
    "gui.soundEditor.slower": "🐢",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "🤖",
    "gui.soundEditor.louder": "🔊",
    "gui.soundEditor.softer": "🔉",
    "gui.soundEditor.reverse": "↩️",
    "gui.soundEditor.fadeOut": "⬜🔲⬛",
    "gui.soundEditor.fadeIn": "⬛🔲⬜",
    "gui.soundEditor.mute": "🔇",
    "gui.SpriteInfo.spritePlaceholder": "📛",
    "gui.SpriteInfo.showSpriteAction": "😐😺",
    "gui.SpriteInfo.hideSpriteAction": "🫥😺",
    "gui.SpriteInfo.sprite": "😺",
    "gui.SpriteInfo.show": "😐",
    "gui.SpriteInfo.size": "🐘",
    "gui.spriteSelectorItem.contextMenuDuplicate": "🐑🐑",
    "gui.spriteSelectorItem.contextMenuExport": "🚢⬇️",
    "gui.spriteSelectorItem.contextMenuDelete": "🗑️",
    "gui.spriteSelector.addSpriteFromLibrary": "😺👇📚",
    "gui.spriteSelector.addSpriteFromPaint": "🖌️",
    "gui.spriteSelector.addSpriteFromSurprise": "🎲",
    "gui.spriteSelector.addSpriteFromFile": "🚚⬆️🖥️😺",
    "gui.stageHeader.stageSizeLarge": "🐘🌆",
    "gui.stageHeader.stageSizeSmall": "🐣🌆",
    "gui.stageHeader.stageSizeFull": "➡️🖥️🌆",
    "gui.stageHeader.stageSizeUnFull": "⬅️🖥️🌆",
    "gui.stageHeader.fullscreenControl": "🖥️🌆",
    "gui.spriteSelector.addBackdropFromLibrary": "🌆👇📚",
    "gui.stageSelector.addBackdropFromPaint": "🖌️",
    "gui.stageSelector.addBackdropFromSurprise": "🎲",
    "gui.stageSelector.addBackdropFromFile": "🚚⬆️🖥️🌆",
    "gui.stageSelector.stage": "🌆",
    "gui.stageSelector.backdrops": "🌆🌆",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "🏃💨",
    "gui.webglModal.label": "Your Browser Does Not Support WebGL",
    "gui.webglModal.description": "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Scratch 3.0 to run.",
    "gui.webglModal.webgllink": "does not support WebGL",
    "gui.webglModal.back": "Back",
    "gui.webglModal.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "🌆👇📚",
    "gui.costumeLibrary.chooseACostume": "🎭👇📚",
    "gui.costumeTab.addBackdropFromLibrary": "🌆👇📚",
    "gui.costumeTab.addCostumeFromLibrary": "🎭👇📚",
    "gui.costumeTab.addBlankCostume": "🖌️",
    "gui.costumeTab.addSurpriseCostume": "🎲",
    "gui.costumeTab.addFileBackdrop": "🚚⬆️🖥️🌆",
    "gui.costumeTab.addFileCostume": "🚚⬆️🖥️🎭",
    "gui.extensionLibrary.chooseAnExtension": "🤖👇📚",
    "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
    "gui.monitors.importListColumnPrompt": "🗼#️⃣🚢⬆️❓ (1-{numberOfColumns})",
    "gui.recordingStep.alertMsg": "❌🏁⏺️",
    "gui.soundLibrary.chooseASound": "🔊👇📚",
    "gui.soundTab.fileUploadSound": "🚚⬆️🖥️🔊",
    "gui.soundTab.surpriseSound": "🎲",
    "gui.soundTab.recordSound": "⏺️",
    "gui.soundTab.addSoundFromLibrary": "🔊👇📚",
    "gui.spriteLibrary.chooseASprite": "😺👇📚",
    "gui.tipsLibrary.tutorials": "💡👇📚",
    "gui.alerts.createsuccess": "🆕📦✅",
    "gui.alerts.createcopysuccess": "💾📄📄👌",
    "gui.alerts.createremixsuccess": "💾💿👌",
    "gui.alerts.creating": "🛠️🆕⌚",
    "gui.alerts.creatingCopy": "📄📄⌚",
    "gui.alerts.creatingRemix": "💿⌚",
    "gui.alerts.creatingError": "❌🛠️📦🔄️",
    "gui.alerts.savingError": "❌💾📦",
    "gui.alerts.savesuccess": "💾👌",
    "gui.alerts.saving": "💾⌚",
    "gui.alerts.cloudInfo": "📜☁️✅🔢❌🔡❌*️⃣ {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "➕ℹ️",
    "gui.alerts.importing": "🚢⬆️⌚",
    "gui.defaultProject.meow": "🐈",
    "gui.defaultProject.variable": "👤📜",
    "gui.howtos.intro-move-sayhello-hat.name": "Getting Started",
    "gui.howtos.intro-move.step_stepMove": "Add a move block",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animate a Name",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pick a Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Play a Sound When Clicked",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pick Another Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Change color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pick Another Letter Sprite & Make It Grow",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Make Music",
    "gui.howtos.Make-Music.step_PickInstrument": "Pick an Instrument Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Play Sound When Clicked",
    "gui.howtos.Make-Music.step_MakeSong": "Create a Song",
    "gui.howtos.make-music.step_MakeBeat": "Choose a Drum & Make a Beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Choose the Microphone Sprite & Surprise Beatbox",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Make a Chase Game",
    "gui.howtos.Chase-Game.step_BG": "Add a Backdrop",
    "gui.howtos.chase-game.step_AddOcto": "Add a Sprite",
    "gui.howtos.make-music.step_LeftRight": "Move Right & Left With Arrow Keys",
    "gui.howtos.Chase-Game.step_UpDown": "Move Up & Down With Arrow Keys",
    "gui.howtos.Chase-Game.step_AddStar": "Add Another Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
    "gui.howtos.Chase-Game.step_WhenTouch": "In Octopus Sprite, When Touching Play Sound",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Create Score Variable",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In Octopus Sprite, When Touching Add Score",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "Make a Clicker Game",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pick A Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Play Sound When Clicked",
    "gui.howtos.make-a-game.step_GameAddScore": "Create Score Variable",
    "gui.howtos.make-a-game.step_GameChangeScore": "When Clicked Increase Score",
    "gui.howtos.make-a-game.step_Random": "Go to a random position",
    "gui.howtos.make-music.step_GameChangeColor": "Change Color",
    "gui.howtos.make-music.step_ResetScore": "Reset Score",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "😺👇📚",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Add a Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Add a Sprite",
    "gui.howtos.add-a-backdrop.name": "Add a Backdrop",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Change Size",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Glide Around",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Record a Sound",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Make It Spin",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Hide and Show",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animate a Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Use Arrow Keys",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Add Effects",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "🎵",
    "gui.extension.music.description": "🎸🎹🥁",
    "gui.extension.pen.name": "✏️",
    "gui.extension.pen.description": "😺🐾✏️🖌️",
    "gui.extension.videosensing.name": "🎥👁️",
    "gui.extension.videosensing.description": "📷👁️🚶",
    "gui.extension.text2speech.name": "🔡➡️💬",
    "gui.extension.text2speech.description": "👤📦💬",
    "gui.extension.translate.name": "🌐💬",
    "gui.extension.translate.description": "🔡➡️🌐💬",
    "gui.extension.makeymakey.description": "🍌➡️⌨️",
    "gui.extension.microbit.description": "👤📦🔌🌍",
    "gui.extension.microbit.connectingMessage": "🔌⌚",
    "gui.extension.ev3.description": "🛠️🤖",
    "gui.extension.ev3.connectingMessage": "🔌⌚🔧 EV3 ➡️ 1234.",
    "gui.extension.boost.description": "🤖➡️😸",
    "gui.extension.boost.connectingMessage": "🔌⌚",
    "gui.extension.wedo2.description": "🛠️🛵👁️",
    "gui.extension.wedo2.connectingMessage": "🔌⌚",
    "gui.extension.gdxfor.description": "👁️🚂🚶🌀",
    "gui.extension.gdxfor.connectingMessage": "🔌⌚",
    "gui.libraryTags.all": "👥",
    "gui.libraryTags.animals": "😺🐶",
    "gui.libraryTags.dance": "🕺",
    "gui.libraryTags.effects": "🪄",
    "gui.libraryTags.fantasy": "🧙‍♂️",
    "gui.libraryTags.fashion": "👗👔",
    "gui.libraryTags.food": "🍕🍎",
    "gui.libraryTags.indoors": "🏨",
    "gui.libraryTags.loops": "🎵🔁",
    "gui.libraryTags.music": "🎵",
    "gui.libraryTags.notes": "🎹🎶",
    "gui.libraryTags.outdoors": "🛣️",
    "gui.libraryTags.patterns": "❤️",
    "gui.libraryTags.people": "🧑",
    "gui.libraryTags.percussion": "🥁",
    "gui.libraryTags.space": "🌌",
    "gui.libraryTags.sports": "🏓",
    "gui.libraryTags.underwater": "🐟",
    "gui.libraryTags.voice": "🧑🎤",
    "gui.libraryTags.wacky": "🙃",
    "gui.libraryTags.animation": "🚶🚶",
    "gui.libraryTags.art": "🎨🖌️",
    "gui.libraryTags.games": "🎮",
    "gui.libraryTags.stories": "📖",
    "gui.libraryTags.letters": "🔤",
    "gui.opcodeLabels.direction": "🧭",
    "gui.opcodeLabels.xposition": "↔️",
    "gui.opcodeLabels.yposition": "↕️",
    "gui.opcodeLabels.size": "🐘",
    "gui.opcodeLabels.costumename": "🎭🔤",
    "gui.opcodeLabels.costumenumber": "🎭#️⃣",
    "gui.opcodeLabels.backdropname": "🌆🔤",
    "gui.opcodeLabels.backdropnumber": "🌆#️⃣",
    "gui.opcodeLabels.volume": "🔊",
    "gui.opcodeLabels.tempo": "🕺🏃",
    "gui.opcodeLabels.answer": "💬",
    "gui.opcodeLabels.loudness": "🔊",
    "gui.opcodeLabels.username": "👤📛",
    "gui.opcodeLabels.year": "☀️",
    "gui.opcodeLabels.month": "🌛",
    "gui.opcodeLabels.date": "📆",
    "gui.opcodeLabels.dayofweek": "📆7️⃣",
    "gui.opcodeLabels.hour": "⌛",
    "gui.opcodeLabels.minute": "⏰",
    "gui.opcodeLabels.second": "⏱️",
    "gui.opcodeLabels.timer": "⏲️",
    "gui.projectLoader.loadError": "❌🚚📦",
    "gui.sharedMessages.backdrop": "🌆{index}",
    "gui.sharedMessages.costume": "🎭{index}",
    "gui.sharedMessages.sprite": "😺{index}",
    "gui.sharedMessages.pop": "🍾",
    "gui.sharedMessages.replaceProjectWarning": "👇📦➡️🆕📦❓",
    "gui.sharedMessages.loadFromComputerTitle": "🚚⬆️🖥️",
    "gui.theme.default": "😺",
    "gui.theme.dark": "🌛",
    "gui.theme.highContrast": "⚫⚪",
    "gui.gui.defaultProjectTitle": "😺📦",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "🤣 [TILT_DIRECTION]",
    "boost.motorDirection.backward": "👈",
    "boost.motorDirection.forward": "👉",
    "boost.motorDirection.reverse": "↩️",
    "boost.motorOff": "🛵 [MOTOR_ID] 🛑",
    "boost.motorOn": "🛵 [MOTOR_ID] 🏃",
    "boost.motorOnFor": "🛵 [MOTOR_ID] 🏃🔢 [DURATION] ⏱️",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "🛵 [MOTOR_ID] 🧭➡️ [MOTOR_DIRECTION]",
    "boost.setMotorPower": "🛵 [MOTOR_ID] 💪➡️🔢 [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "👇",
    "boost.tiltDirection.left": "👈",
    "boost.tiltDirection.right": "👉",
    "boost.tiltDirection.up": "👆",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "❗🤣 [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
    "ev3.buttonPressed": "[PORT] 👇❓",
    "ev3.getBrightness": "brightness",
    "ev3.getDistance": "📏",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "🛵 [PORT] 💪➡️🔢 [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
    "ev3.whenButtonPressed": "❗ [PORT] 👇",
    "ev3.whenDistanceLessThan": "❗📏◀️🔢 [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "🤣 [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "🤣 [TILT] ❓",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "👈",
    "gdxfor.tiltDirectionMenu.right": "👉",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "❗🤣 [TILT]",
    "makeymakey.downArrow": "⬇️",
    "makeymakey.downArrowShort": "⬇️",
    "makeymakey.leftArrow": "⬅️",
    "makeymakey.leftArrowShort": "⬅️",
    "makeymakey.rightArrow": "➡️",
    "makeymakey.rightArrowShort": "➡️",
    "makeymakey.spaceKey": "🌌",
    "makeymakey.upArrow": "⬆️",
    "makeymakey.upArrowShort": "⬆️",
    "makeymakey.whenKeyPressed": "❗⌨️ [KEY] 👇",
    "makeymakey.whenKeysPressedInOrder": "❗⌨️ [SEQUENCE] 👇👇",
    "microbit.buttonsMenu.any": "any",
    "microbit.clearDisplay": "clear display",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] 👇❓",
    "microbit.isTilted": "🤣 [DIRECTION] ❓",
    "microbit.pinStateMenu.off": "🌚",
    "microbit.pinStateMenu.on": "🌝",
    "microbit.tiltAngle": "🤣 [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "any",
    "microbit.tiltDirectionMenu.back": "back",
    "microbit.tiltDirectionMenu.front": "front",
    "microbit.tiltDirectionMenu.left": "👈",
    "microbit.tiltDirectionMenu.right": "👉",
    "microbit.whenButtonPressed": "❗ [BTN] 👇",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "❗🤣 [DIRECTION]",
    "music.categoryName": "🎵",
    "music.changeTempo": "🕺🏃🔛🔢 [TEMPO]",
    "music.drumBass": "(2) 🥁🐡",
    "music.drumBongo": "(13) 🥁🥁",
    "music.drumCabasa": "(15) 🪇",
    "music.drumClaves": "(9) 🥢🐘",
    "music.drumClosedHiHat": "(6) 👋🎓📪",
    "music.drumConga": "(14) 🪘",
    "music.drumCowbell": "(11) 🔔🐄",
    "music.drumCrashCymbal": "(4) 💥",
    "music.drumCuica": "(18) 🐵",
    "music.drumGuiro": "(16) 🦗",
    "music.drumHandClap": "(8) 👏",
    "music.drumOpenHiHat": "(5) 👋🎓📬",
    "music.drumSideStick": "(3) 🥢",
    "music.drumSnare": "(1) 🥁",
    "music.drumTambourine": "(7) 🧂",
    "music.drumTriangle": "(12) 🔺",
    "music.drumVibraslap": "(17) 🎹🧇✋",
    "music.drumWoodBlock": "(10) 🧱🪵",
    "music.getTempo": "🕺🏃",
    "music.instrumentBass": "(6) 🎸🐡",
    "music.instrumentBassoon": "(14) 🪈 🐡🐡",
    "music.instrumentCello": "(8) 🎻",
    "music.instrumentChoir": "(15) 🤵",
    "music.instrumentClarinet": "(10) 🪈 🐡",
    "music.instrumentElectricGuitar": "(5) 🎸⚡",
    "music.instrumentElectricPiano": "(2) 🎹⚡",
    "music.instrumentFlute": "(12) 🪈",
    "music.instrumentGuitar": "(4) 🎸",
    "music.instrumentMarimba": "(19) 🎹🪵",
    "music.instrumentMusicBox": "(17) 📦🎵",
    "music.instrumentOrgan": "(3) 🎹🪈",
    "music.instrumentPiano": "(1) 🎹",
    "music.instrumentPizzicato": "(7) 🎻🩳",
    "music.instrumentSaxophone": "(11) 🎷",
    "music.instrumentSteelDrum": "(18) 🥁🪙",
    "music.instrumentSynthLead": "(20) 🎹👾",
    "music.instrumentSynthPad": "(21) 🎹",
    "music.instrumentTrombone": "(9) 🎺🐡",
    "music.instrumentVibraphone": "(16) 🎹🧇",
    "music.instrumentWoodenFlute": "(13) 🪈🪵",
    "music.midiPlayDrumForBeats": "🥁 [DRUM] 🔢 [BEATS] 👏",
    "music.midiSetInstrument": "🎹➡️ [INSTRUMENT]",
    "music.playDrumForBeats": "🥁 [DRUM] 🔢 [BEATS] 👏",
    "music.playNoteForBeats": "🎹🎶 [NOTE] 🔢 [BEATS] 👏",
    "music.restForBeats": "🔇🔢 [BEATS] 👏",
    "music.setInstrument": "🎹➡️ [INSTRUMENT]",
    "music.setTempo": "🕺🏃➡️🔢 [TEMPO]",
    "pen.categoryName": "✏️",
    "pen.changeColorParam": "✏️ [COLOR_PARAM] 🔛🔢 [VALUE]",
    "pen.changeHue": "✏️🎨🔛🔢 [HUE]",
    "pen.changeShade": "✏️💡🔛🔢 [SHADE]",
    "pen.changeSize": "✏️🐘🔛🔢 [SIZE]",
    "pen.clear": "🧼",
    "pen.colorMenu.brightness": "💡",
    "pen.colorMenu.color": "🎨",
    "pen.colorMenu.saturation": "⚪↔🔴",
    "pen.colorMenu.transparency": "☁️",
    "pen.penDown": "✏️⬇️",
    "pen.penUp": "✏️⬆️",
    "pen.setColor": "✏️🎨➡️🌈 [COLOR]",
    "pen.setColorParam": "✏️ [COLOR_PARAM] ➡️🔢 [VALUE]",
    "pen.setHue": "✏️🎨➡️🔢 [HUE]",
    "pen.setShade": "✏️💡➡️🔢 [SHADE]",
    "pen.setSize": "✏️🐘➡️🔢 [SIZE]",
    "pen.stamp": "🐾",
    "speech.defaultWhenIHearValue": "let''s go",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "listen and wait",
    "speech.speechReporter": "speech",
    "speech.whenIHear": "when I hear [PHRASE]",
    "text2speech.alto": "👩",
    "text2speech.categoryName": "🔡➡️💬",
    "text2speech.defaultTextToSpeak": "👋",
    "text2speech.giant": "🐘",
    "text2speech.kitten": "😺",
    "text2speech.setLanguageBlock": "🌐➡️ [LANGUAGE]",
    "text2speech.setVoiceBlock": "🎤➡️ [VOICE]",
    "text2speech.speakAndWaitBlock": "💬 [WORDS]",
    "text2speech.squeak": "🦜",
    "text2speech.tenor": "👨",
    "translate.categoryName": "🌐💬",
    "translate.defaultTextToTranslate": "👋",
    "translate.translateBlock": "🔡 [WORDS] ➡️🌐💬 [LANGUAGE]",
    "translate.viewerLanguage": "👤🌐💬",
    "videoSensing.categoryName": "🎥👁️",
    "videoSensing.direction": "🧭",
    "videoSensing.motion": "🚶",
    "videoSensing.off": "🌚",
    "videoSensing.on": "🌝",
    "videoSensing.onFlipped": "🌝↔️",
    "videoSensing.setVideoTransparency": "🎥☁️➡️🔢 [TRANSPARENCY]",
    "videoSensing.sprite": "😺",
    "videoSensing.stage": "🌆",
    "videoSensing.videoOn": "🎥 [ATTRIBUTE] 👇 [SUBJECT]",
    "videoSensing.videoToggle": "🎥 [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "❗🎥🚶▶️🔢 [REFERENCE]",
    "wedo2.getDistance": "📏",
    "wedo2.getTiltAngle": "🤣 [TILT_DIRECTION]",
    "wedo2.isTilted": "🤣 [TILT_DIRECTION_ANY] ❓",
    "wedo2.motorDirection.backward": "👈",
    "wedo2.motorDirection.forward": "👉",
    "wedo2.motorDirection.reverse": "↩️",
    "wedo2.motorId.a": "🛵 A",
    "wedo2.motorId.all": "🛵👥",
    "wedo2.motorId.b": "🛵 B",
    "wedo2.motorId.default": "🛵",
    "wedo2.motorOff": "🛵 [MOTOR_ID] 🛑",
    "wedo2.motorOn": "🛵 [MOTOR_ID] 🏃",
    "wedo2.motorOnFor": "🛵 [MOTOR_ID] 🏃🔢 [DURATION] ⏱️",
    "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
    "wedo2.setLightHue": "💡🎨➡️🔢 [HUE]",
    "wedo2.setMotorDirection": "🛵 [MOTOR_ID] 🧭➡️ [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "🛵 [MOTOR_ID] 💪➡️🔢 [POWER]",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "👇",
    "wedo2.tiltDirection.left": "👈",
    "wedo2.tiltDirection.right": "👉",
    "wedo2.tiltDirection.up": "👆",
    "wedo2.whenDistance": "❗📏 [OP] 🔢 [REFERENCE]",
    "wedo2.whenTilted": "❗🤣 [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "🎨",
    "paint.paintEditor.saturation": "⚪↔🔴",
    "paint.paintEditor.brightness": "💡",
    "paint.paintEditor.costume": "🎭",
    "paint.paintEditor.group": "👤👤",
    "paint.paintEditor.ungroup": "↩️👤👤",
    "paint.paintEditor.undo": "↩️",
    "paint.paintEditor.redo": "↪️",
    "paint.paintEditor.forward": "⬆️1️⃣🍰",
    "paint.paintEditor.backward": "⬇️1️⃣🍰",
    "paint.paintEditor.front": "⬆️⬆️⬆️",
    "paint.paintEditor.back": "⬇️⬇️⬇️",
    "paint.paintEditor.more": "🔽",
    "paint.modeTools.brushSize": "🐘",
    "paint.modeTools.eraserSize": "🧼🐘",
    "paint.modeTools.copy": "📄📄",
    "paint.modeTools.paste": "📋",
    "paint.modeTools.delete": "🗑️",
    "paint.modeTools.curved": "🟢",
    "paint.modeTools.pointed": "🟩",
    "paint.modeTools.thickness": "📐🐘",
    "paint.modeTools.flipHorizontal": "🐬↔️",
    "paint.modeTools.flipVertical": "🐬↕️",
    "paint.modeTools.filled": "🪣",
    "paint.modeTools.outlined": "✏️📐",
    "paint.paintEditor.bitmap": "🔲👾",
    "paint.paintEditor.vector": "🔲👽",
    "paint.paintEditor.fill": "🪣",
    "paint.paintEditor.stroke": "✏️📐",
    "paint.brushMode.brush": "🖌️",
    "paint.eraserMode.eraser": "🧼",
    "paint.fillMode.fill": "🪣",
    "paint.lineMode.line": "📐",
    "paint.ovalMode.oval": "🔴",
    "paint.rectMode.rect": "🟦",
    "paint.reshapeMode.reshape": "✍️🟦",
    "paint.roundedRectMode.roundedRect": "🟢🟩",
    "paint.selectMode.select": "👇",
    "paint.textMode.text": "🔡",
    "paint.colorPicker.swap": "↔"
  },
  "en": {
    "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
    "gui.alerts.tryAgain": "Try Again",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Reconnect",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Backpack",
    "gui.backpack.errorBackpack": "Error loading backpack",
    "gui.backpack.loadingBackpack": "Loading...",
    "gui.backpack.more": "More",
    "gui.backpack.emptyBackpack": "Backpack is empty",
    "gui.unsupportedBrowser.label": "Browser is not supported",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Back",
    "gui.unsupportedBrowser.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Close",
    "gui.cards.more-things-to-try": "More things to try!",
    "gui.cards.see-more": "See more",
    "gui.comingSoon.message1": "Don't worry, we're on it {emoji}",
    "gui.comingSoon.message2": "Coming Soon...",
    "gui.comingSoon.message3": "We're working on it {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "Have your device nearby, then begin searching.",
    "gui.connection.auto-scanning.pressbutton": "Press the button on your device.",
    "gui.connection.auto-scanning.start-search": "Start Searching",
    "gui.connection.connecting-searchbutton": "Searching...",
    "gui.connection.auto-scanning.try-again": "Try again",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Connected",
    "gui.connection.disconnect": "Disconnect",
    "gui.connection.go-to-editor": "Go to Editor",
    "gui.connection.connecting-cancelbutton": "Connecting...",
    "gui.connection.error.errorMessage": "Oops, looks like something went wrong.",
    "gui.connection.error.tryagainbutton": "Try again",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "Connect",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "Select your device in the list above.",
    "gui.connection.search": "Refresh",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Make sure you have Scratch Link installed and running",
    "gui.connection.unavailable.enablebluetooth": "Check that Bluetooth is enabled",
    "gui.connection.unavailable.tryagainbutton": "Try again",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Go",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oops! Something went wrong.",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Reload",
    "gui.customProcedures.myblockModalTitle": "Make a Block",
    "gui.customProcedures.addAnInputNumberText": "Add an input",
    "gui.customProcedures.numberTextType": "number or text",
    "gui.customProcedures.addAnInputBoolean": "Add an input",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Add a label",
    "gui.customProcedures.runWithoutScreenRefresh": "Run without screen refresh",
    "gui.customProcedures.cancel": "Cancel",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direction",
    "gui.directionPicker.rotationStyles.allAround": "All Around",
    "gui.directionPicker.rotationStyles.leftRight": "Left/Right",
    "gui.directionPicker.rotationStyles.dontRotate": "Do not rotate",
    "gui.gui.addExtension": "Add Extension",
    "gui.gui.codeTab": "Code",
    "gui.gui.backdropsTab": "Backdrops",
    "gui.gui.costumesTab": "Costumes",
    "gui.gui.soundsTab": "Sounds",
    "gui.extensionLibrary.comingSoon": "Coming Soon",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "Collaboration with",
    "gui.library.filterPlaceholder": "Search",
    "gui.library.allTag": "All",
    "gui.loader.message1": "Creating blocks …",
    "gui.loader.message2": "Loading sprites …",
    "gui.loader.message3": "Loading sounds …",
    "gui.loader.message4": "Loading extensions …",
    "gui.loader.message5": "Herding cats …",
    "gui.loader.message6": "Transmitting nanos …",
    "gui.loader.message7": "Inflating gobos …",
    "gui.loader.message8": "Preparing emojis …",
    "gui.loader.headline": "Loading Project",
    "gui.loader.creating": "Creating Project",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "My Stuff",
    "gui.accountMenu.myClasses": "My Classes",
    "gui.accountMenu.myClass": "My Class",
    "gui.accountMenu.accountSettings": "Account settings",
    "gui.accountMenu.signOut": "Sign out",
    "gui.authorInfo.byUser": "by {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "gui.menuBar.language": "Language",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Sign in",
    "login.needHelp": "Need Help?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Restore Sprite",
    "gui.menuBar.restoreSound": "Restore Sound",
    "gui.menuBar.restoreCostume": "Restore Costume",
    "gui.menuBar.restore": "Restore",
    "gui.menuBar.saveNow": "Save now",
    "gui.menuBar.saveAsCopy": "Save as a copy",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "New",
    "gui.menuBar.file": "File",
    "gui.menuBar.downloadToComputer": "Save to your computer",
    "gui.menuBar.edit": "Edit",
    "gui.menuBar.turboModeOff": "Turn off Turbo Mode",
    "gui.menuBar.turboModeOn": "Turn on Turbo Mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Join Scratch",
    "gui.menuBar.signIn": "Sign in",
    "gui.gui.projectTitlePlaceholder": "Project title here",
    "gui.menuBar.saveNowLink": "Save Now",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Shared",
    "gui.menuBar.share": "Share",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Help",
    "gui.modal.back": "Back",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "length {length}",
    "gui.monitor.contextMenu.default": "normal readout",
    "gui.monitor.contextMenu.large": "large readout",
    "gui.monitor.contextMenu.slider": "slider",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "For all sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "For this sprite only",
    "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
    "gui.gui.variablePromptAllSpritesMessage": "This variable will be available to all sprites.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cancel",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Play",
    "gui.playbackStep.loadingMsg": "Loading...",
    "gui.playbackStep.saveMsg": "Save",
    "gui.playbackStep.reRecordMsg": "Re-record",
    "gui.recordModal.title": "Record Sound",
    "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "Stop recording",
    "gui.recordingStep.record": "Record",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Sound",
    "gui.soundEditor.play": "Play",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Save",
    "gui.soundEditor.undo": "Undo",
    "gui.soundEditor.redo": "Redo",
    "gui.soundEditor.faster": "Faster",
    "gui.soundEditor.slower": "Slower",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Louder",
    "gui.soundEditor.softer": "Softer",
    "gui.soundEditor.reverse": "Reverse",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Name",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Show",
    "gui.SpriteInfo.size": "Size",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicate",
    "gui.spriteSelectorItem.contextMenuExport": "export",
    "gui.spriteSelectorItem.contextMenuDelete": "delete",
    "gui.spriteSelector.addSpriteFromLibrary": "Choose a Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Paint",
    "gui.spriteSelector.addSpriteFromSurprise": "Surprise",
    "gui.spriteSelector.addSpriteFromFile": "Upload Sprite",
    "gui.stageHeader.stageSizeLarge": "Switch to large stage",
    "gui.stageHeader.stageSizeSmall": "Switch to small stage",
    "gui.stageHeader.stageSizeFull": "Enter full screen mode",
    "gui.stageHeader.stageSizeUnFull": "Exit full screen mode",
    "gui.stageHeader.fullscreenControl": "Full Screen Control",
    "gui.spriteSelector.addBackdropFromLibrary": "Choose a Backdrop",
    "gui.stageSelector.addBackdropFromPaint": "Paint",
    "gui.stageSelector.addBackdropFromSurprise": "Surprise",
    "gui.stageSelector.addBackdropFromFile": "Upload Backdrop",
    "gui.stageSelector.stage": "Stage",
    "gui.stageSelector.backdrops": "Backdrops",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo Mode",
    "gui.webglModal.label": "Your Browser Does Not Support WebGL",
    "gui.webglModal.description": "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Scratch 3.0 to run.",
    "gui.webglModal.webgllink": "does not support WebGL",
    "gui.webglModal.back": "Back",
    "gui.webglModal.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Choose a Backdrop",
    "gui.costumeLibrary.chooseACostume": "Choose a Costume",
    "gui.costumeTab.addBackdropFromLibrary": "Choose a Backdrop",
    "gui.costumeTab.addCostumeFromLibrary": "Choose a Costume",
    "gui.costumeTab.addBlankCostume": "Paint",
    "gui.costumeTab.addSurpriseCostume": "Surprise",
    "gui.costumeTab.addFileBackdrop": "Upload Backdrop",
    "gui.costumeTab.addFileCostume": "Upload Costume",
    "gui.extensionLibrary.chooseAnExtension": "Choose an Extension",
    "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Could not start recording",
    "gui.soundLibrary.chooseASound": "Choose a Sound",
    "gui.soundTab.fileUploadSound": "Upload Sound",
    "gui.soundTab.surpriseSound": "Surprise",
    "gui.soundTab.recordSound": "Record",
    "gui.soundTab.addSoundFromLibrary": "Choose a Sound",
    "gui.spriteLibrary.chooseASprite": "Choose a Sprite",
    "gui.tipsLibrary.tutorials": "Choose a Tutorial",
    "gui.alerts.createsuccess": "New project created.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Could not create the project. Please try again!",
    "gui.alerts.savingError": "Project could not save.",
    "gui.alerts.savesuccess": "Project saved.",
    "gui.alerts.saving": "Saving project…",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Getting Started",
    "gui.howtos.intro-move.step_stepMove": "Add a move block",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animate a Name",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pick a Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Play a Sound When Clicked",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pick Another Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Change color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pick Another Letter Sprite & Make It Grow",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Make Music",
    "gui.howtos.Make-Music.step_PickInstrument": "Pick an Instrument Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Play Sound When Clicked",
    "gui.howtos.Make-Music.step_MakeSong": "Create a Song",
    "gui.howtos.make-music.step_MakeBeat": "Choose a Drum & Make a Beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Choose the Microphone Sprite & Surprise Beatbox",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Make a Chase Game",
    "gui.howtos.Chase-Game.step_BG": "Add a Backdrop",
    "gui.howtos.chase-game.step_AddOcto": "Add a Sprite",
    "gui.howtos.make-music.step_LeftRight": "Move Right & Left With Arrow Keys",
    "gui.howtos.Chase-Game.step_UpDown": "Move Up & Down With Arrow Keys",
    "gui.howtos.Chase-Game.step_AddStar": "Add Another Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
    "gui.howtos.Chase-Game.step_WhenTouch": "In Octopus Sprite, When Touching Play Sound",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Create Score Variable",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In Octopus Sprite, When Touching Add Score",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "Make a Clicker Game",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pick A Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Play Sound When Clicked",
    "gui.howtos.make-a-game.step_GameAddScore": "Create Score Variable",
    "gui.howtos.make-a-game.step_GameChangeScore": "When Clicked Increase Score",
    "gui.howtos.make-a-game.step_Random": "Go to a random position",
    "gui.howtos.make-music.step_GameChangeColor": "Change Color",
    "gui.howtos.make-music.step_ResetScore": "Reset Score",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Add a Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Add a Sprite",
    "gui.howtos.add-a-backdrop.name": "Add a Backdrop",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Change Size",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Glide Around",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Record a Sound",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Make It Spin",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Hide and Show",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animate a Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Use Arrow Keys",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Add Effects",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Music",
    "gui.extension.music.description": "Play instruments and drums.",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Draw with your sprites.",
    "gui.extension.videosensing.name": "Video Sensing",
    "gui.extension.videosensing.description": "Sense motion with the camera.",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description": "Translate text into many languages.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "Connect your projects with the world.",
    "gui.extension.microbit.connectingMessage": "Connecting",
    "gui.extension.ev3.description": "Build interactive robots and more.",
    "gui.extension.ev3.connectingMessage": "Connecting. Make sure the pin on your EV3 is set to 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Build with motors and sensors.",
    "gui.extension.wedo2.connectingMessage": "Connecting",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "All",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dance",
    "gui.libraryTags.effects": "Effects",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Indoors",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Music",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Outdoors",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "People",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Underwater",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Games",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "size",
    "gui.opcodeLabels.costumename": "costume name",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "backdrop name",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "answer",
    "gui.opcodeLabels.loudness": "loudness",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "year",
    "gui.opcodeLabels.month": "month",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "day of week",
    "gui.opcodeLabels.hour": "hour",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "second",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "The project file that was selected failed to load.",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
    "ev3.buttonPressed": "button [PORT] pressed?",
    "ev3.getBrightness": "brightness",
    "ev3.getDistance": "distance",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
    "ev3.whenButtonPressed": "when button [PORT] pressed",
    "ev3.whenDistanceLessThan": "when distance < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "down",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "left",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "right",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "up",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "any",
    "microbit.clearDisplay": "clear display",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] button pressed?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "off",
    "microbit.pinStateMenu.on": "on",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "any",
    "microbit.tiltDirectionMenu.back": "back",
    "microbit.tiltDirectionMenu.front": "front",
    "microbit.tiltDirectionMenu.left": "left",
    "microbit.tiltDirectionMenu.right": "right",
    "microbit.whenButtonPressed": "when [BTN] button pressed",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "music.categoryName": "Music",
    "music.changeTempo": "change tempo by [TEMPO]",
    "music.drumBass": "(2) Bass Drum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Closed Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Hand Clap",
    "music.drumOpenHiHat": "(5) Open Hi-Hat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snare Drum",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood Block",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Choir",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Electric Guitar",
    "music.instrumentElectricPiano": "(2) Electric Piano",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Guitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Music Box",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Wooden Flute",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
    "music.playDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.playNoteForBeats": "play note [NOTE] for [BEATS] beats",
    "music.restForBeats": "rest for [BEATS] beats",
    "music.setInstrument": "set instrument to [INSTRUMENT]",
    "music.setTempo": "set tempo to [TEMPO]",
    "pen.categoryName": "Pen",
    "pen.changeColorParam": "change pen [COLOR_PARAM] by [VALUE]",
    "pen.changeHue": "change pen color by [HUE]",
    "pen.changeShade": "change pen shade by [SHADE]",
    "pen.changeSize": "change pen size by [SIZE]",
    "pen.clear": "erase all",
    "pen.colorMenu.brightness": "brightness",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturation",
    "pen.colorMenu.transparency": "transparency",
    "pen.penDown": "pen down",
    "pen.penUp": "pen up",
    "pen.setColor": "set pen color to [COLOR]",
    "pen.setColorParam": "set pen [COLOR_PARAM] to [VALUE]",
    "pen.setHue": "set pen color to [HUE]",
    "pen.setShade": "set pen shade to [SHADE]",
    "pen.setSize": "set pen size to [SIZE]",
    "pen.stamp": "stamp",
    "speech.defaultWhenIHearValue": "let''s go",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "listen and wait",
    "speech.speechReporter": "speech",
    "speech.whenIHear": "when I hear [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "giant",
    "text2speech.kitten": "kitten",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "set voice to [VOICE]",
    "text2speech.speakAndWaitBlock": "speak [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Translate",
    "translate.defaultTextToTranslate": "hello",
    "translate.translateBlock": "translate [WORDS] to [LANGUAGE]",
    "translate.viewerLanguage": "language",
    "videoSensing.categoryName": "Video Sensing",
    "videoSensing.direction": "direction",
    "videoSensing.motion": "motion",
    "videoSensing.off": "off",
    "videoSensing.on": "on",
    "videoSensing.onFlipped": "on flipped",
    "videoSensing.setVideoTransparency": "set video transparency to [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "stage",
    "videoSensing.videoOn": "video [ATTRIBUTE] on [SUBJECT]",
    "videoSensing.videoToggle": "turn video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "when video motion > [REFERENCE]",
    "wedo2.getDistance": "distance",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "reverse",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
    "wedo2.setLightHue": "set light color to [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "down",
    "wedo2.tiltDirection.left": "left",
    "wedo2.tiltDirection.right": "right",
    "wedo2.tiltDirection.up": "up",
    "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturation",
    "paint.paintEditor.brightness": "Brightness",
    "paint.paintEditor.costume": "Costume",
    "paint.paintEditor.group": "Group",
    "paint.paintEditor.ungroup": "Ungroup",
    "paint.paintEditor.undo": "Undo",
    "paint.paintEditor.redo": "Redo",
    "paint.paintEditor.forward": "Forward",
    "paint.paintEditor.backward": "Backward",
    "paint.paintEditor.front": "Front",
    "paint.paintEditor.back": "Back",
    "paint.paintEditor.more": "More",
    "paint.modeTools.brushSize": "Size",
    "paint.modeTools.eraserSize": "Eraser size",
    "paint.modeTools.copy": "Copy",
    "paint.modeTools.paste": "Paste",
    "paint.modeTools.delete": "Delete",
    "paint.modeTools.curved": "Curved",
    "paint.modeTools.pointed": "Pointed",
    "paint.modeTools.thickness": "Thickness",
    "paint.modeTools.flipHorizontal": "Flip Horizontal",
    "paint.modeTools.flipVertical": "Flip Vertical",
    "paint.modeTools.filled": "Filled",
    "paint.modeTools.outlined": "Outlined",
    "paint.paintEditor.bitmap": "Convert to Bitmap",
    "paint.paintEditor.vector": "Convert to Vector",
    "paint.paintEditor.fill": "Fill",
    "paint.paintEditor.stroke": "Outline",
    "paint.brushMode.brush": "Brush",
    "paint.eraserMode.eraser": "Eraser",
    "paint.fillMode.fill": "Fill",
    "paint.lineMode.line": "Line",
    "paint.ovalMode.oval": "Circle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Reshape",
    "paint.roundedRectMode.roundedRect": "Rounded Rectangle",
    "paint.selectMode.select": "Select",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Swap"
  },
  "es": {
    "gui.alerts.lostPeripheralConnection": "Scratch ha perdido la conexión con {extensionName}.",
    "gui.alerts.tryAgain": "Vuelve a intentarlo",
    "gui.alerts.download": "Descargar",
    "gui.connection.reconnect": "Reconectar",
    "gui.backpack.costumeLabel": "disfraz",
    "gui.backpack.soundLabel": "sonido",
    "gui.backpack.scriptLabel": "programa",
    "gui.backpack.spriteLabel": "objeto",
    "gui.backpack.header": "Mochila",
    "gui.backpack.errorBackpack": "Error al cargar la mochila",
    "gui.backpack.loadingBackpack": "Cargando...",
    "gui.backpack.more": "Más",
    "gui.backpack.emptyBackpack": "La mochila está vacía",
    "gui.unsupportedBrowser.label": "El navegador no es compatible",
    "gui.unsupportedBrowser.errorLabel": "Ha ocurrido un error",
    "gui.unsupportedBrowser.notRecommended": "Lo sentimos mucho, pero parece que Scratch no soporta la versión de tu navegador. Te recomendamos actualizar a la última versión de un navegador con soporte, como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.description": "Lo sentimos mucho, pero Scratch no ofrece soporte para este navegador. Te recomendamos actualizar a la última versión de un navegador con soporte, como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.back": "Atrás",
    "gui.unsupportedBrowser.previewfaq": "Para conocer más, visita las {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Preguntas frecuentes (FAQ)",
    "gui.cards.all-tutorials": "Tutoriales",
    "gui.cards.shrink": "Encoger",
    "gui.cards.expand": "Expandir",
    "gui.cards.close": "Cerrar",
    "gui.cards.more-things-to-try": "¡Más cosas para probar!",
    "gui.cards.see-more": "Ver más",
    "gui.comingSoon.message1": "No te preocupes, estamos en ello {emoji}",
    "gui.comingSoon.message2": "Próximamente...",
    "gui.comingSoon.message3": "Estamos trabajando en ello {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No se han encontrado dispositivos",
    "gui.connection.auto-scanning.prescan": "Ten tu dispositivo cerca, y entonces empieza a buscar.",
    "gui.connection.auto-scanning.pressbutton": "Presiona el botón de tu dispositivo.",
    "gui.connection.auto-scanning.start-search": "Empezar a buscar",
    "gui.connection.connecting-searchbutton": "Buscando...",
    "gui.connection.auto-scanning.try-again": "Intentar de nuevo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Conectado",
    "gui.connection.disconnect": "Desconectar",
    "gui.connection.go-to-editor": "Ir al editor",
    "gui.connection.connecting-cancelbutton": "Conectando...",
    "gui.connection.error.errorMessage": "Ups, parece que algo ha fallado.",
    "gui.connection.error.tryagainbutton": "Intentar de nuevo",
    "gui.connection.error.helpbutton": "Ayuda",
    "gui.connection.peripheral-name-label": "Nombre del dispositivo",
    "gui.connection.connect": "Conectar",
    "gui.connection.scanning.lookingforperipherals": "Buscando dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "No se han encontrado dispositivos",
    "gui.connection.scanning.instructions": "Elige tu dispositivo de la lista.",
    "gui.connection.search": "Actualizar",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Asegúrate de que tienes Scratch Link instalado y abierto",
    "gui.connection.unavailable.enablebluetooth": "Comprueba que Bluetooth esté habilitado",
    "gui.connection.unavailable.tryagainbutton": "Intentar de nuevo",
    "gui.connection.unavailable.helpbutton": "Ayuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ir",
    "gui.controls.stop": "Detener",
    "gui.crashMessage.label": "¡Ups! Algo ha fallado.",
    "gui.crashMessage.description": "Lo sentimos mucho, pero parece que Scratch ha dejado de funcionar. Ya hemos informado de este fallo al Scratch Team. Por favor, vuelve a cargar la página e inténtalo de nuevo.",
    "gui.crashMessage.errorNumber": "Su error ha sido registrado con id {errorId}",
    "gui.crashMessage.reload": "Volver a cargar",
    "gui.customProcedures.myblockModalTitle": "Crear un bloque",
    "gui.customProcedures.addAnInputNumberText": "Añadir una entrada",
    "gui.customProcedures.numberTextType": "número o texto",
    "gui.customProcedures.addAnInputBoolean": "Añadir una entrada",
    "gui.customProcedures.booleanType": "lógica",
    "gui.customProcedures.addALabel": "Añadir una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Ejecutar al instante",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "Aceptar",
    "gui.SpriteInfo.direction": "Dirección",
    "gui.directionPicker.rotationStyles.allAround": "En todas direcciones",
    "gui.directionPicker.rotationStyles.leftRight": "Izquierda/Derecha",
    "gui.directionPicker.rotationStyles.dontRotate": "No rotar",
    "gui.gui.addExtension": "Añadir extensión",
    "gui.gui.codeTab": "Código",
    "gui.gui.backdropsTab": "Fondos",
    "gui.gui.costumesTab": "Disfraces",
    "gui.gui.soundsTab": "Sonidos",
    "gui.extensionLibrary.comingSoon": "Pronto",
    "gui.extensionLibrary.requires": "Requiere",
    "gui.extensionLibrary.collaboration": "En colaboración con",
    "gui.library.filterPlaceholder": "Busca",
    "gui.library.allTag": "Todos",
    "gui.loader.message1": "Creando bloques ...",
    "gui.loader.message2": "Cargando objetos...",
    "gui.loader.message3": "Cargando sonidos...",
    "gui.loader.message4": "Cargando extensiones...",
    "gui.loader.message5": "Pastoreando gatos...",
    "gui.loader.message6": "Transmitiendo nanos...",
    "gui.loader.message7": "Inflando gobos...",
    "gui.loader.message8": "Preparando emojis...",
    "gui.loader.headline": "Cargando proyecto",
    "gui.loader.creating": "Creando el proyecto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Mis cosas",
    "gui.accountMenu.myClasses": "Mis clases",
    "gui.accountMenu.myClass": "Mi clase",
    "gui.accountMenu.accountSettings": "Configuración de la cuenta",
    "gui.accountMenu.signOut": "Salir",
    "gui.authorInfo.byUser": "por {username}",
    "gui.menuBar.seeProjectPage": "Ver página del proyecto",
    "gui.menuBar.language": "Language",
    "general.username": "Nombre de Usuario",
    "general.password": "Contraseña",
    "general.signIn": "Iniciar sesión",
    "login.needHelp": "¿Necesitas ayuda?",
    "form.validationRequired": "Este campo es obligatorio",
    "gui.menuBar.tutorialsLibrary": "Tutoriales",
    "gui.menuBar.restoreSprite": "Restaurar objeto",
    "gui.menuBar.restoreSound": "Restaurar sonido",
    "gui.menuBar.restoreCostume": "Restaurar disfraz",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Guardar ahora",
    "gui.menuBar.saveAsCopy": "Guardar una copia",
    "gui.menuBar.remix": "Reinventar",
    "gui.menuBar.new": "Nuevo",
    "gui.menuBar.file": "Archivo",
    "gui.menuBar.downloadToComputer": "Guardar en tu ordenador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desactivar el modo Turbo",
    "gui.menuBar.turboModeOn": "Activar el modo Turbo",
    "gui.menuBar.modeMenu": "Modo",
    "gui.menuBar.normalMode": "Modo normal",
    "gui.menuBar.caturdayMode": "Modo sabado gatuno",
    "gui.menuBar.joinScratch": "Únete a Scratch",
    "gui.menuBar.signIn": "Iniciar sesión",
    "gui.gui.projectTitlePlaceholder": "Nombre del proyecto aquí",
    "gui.menuBar.saveNowLink": "Guardar ahora",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Compartidos",
    "gui.menuBar.share": "Compartir",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ayuda",
    "gui.modal.back": "Atrás",
    "gui.monitor.listMonitor.empty": "(vacía)",
    "gui.monitor.listMonitor.listLength": "longitud {length}",
    "gui.monitor.contextMenu.default": "tamaño normal",
    "gui.monitor.contextMenu.large": "tamaño grande",
    "gui.monitor.contextMenu.slider": "deslizador",
    "gui.monitor.contextMenu.sliderRange": "cambiar rango del deslizador",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Reproducir",
    "gui.playButton.stop": "Detener",
    "gui.gui.variableScopeOptionAllSprites": "Para todos los objetos",
    "gui.gui.variableScopeOptionSpriteOnly": "Sólo para este objeto",
    "gui.gui.cloudVariableOption": "Variable en la nube (guardada en el servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variable estará disponible en todos los objetos.",
    "gui.gui.listPromptAllSpritesMessage": "Esta lista estará disponible para todos los objetos",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "Aceptar",
    "gui.playbackStep.stopMsg": "Detener",
    "gui.playbackStep.playMsg": "Reproducir",
    "gui.playbackStep.loadingMsg": "Cargando...",
    "gui.playbackStep.saveMsg": "Guardar",
    "gui.playbackStep.reRecordMsg": "Volver a grabar",
    "gui.recordModal.title": "Grabar sonido",
    "gui.recordingStep.beginRecord": "Comienza a grabar haciendo clic en el siguiente botón",
    "gui.recordingStep.permission": "{arrow}Necesitamos tu permiso para usar el micrófono",
    "gui.recordingStep.stop": "Dejar de grabar",
    "gui.recordingStep.record": "Grabar",
    "gui.sliderModal.min": "Valor mínimo",
    "gui.sliderModal.max": "Valor máximo",
    "gui.sliderModal.title": "Cambiar rango del deslizador",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "Aceptar",
    "gui.soundEditor.sound": "Sonido",
    "gui.soundEditor.play": "Reproducir",
    "gui.soundEditor.stop": "Detener",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Pegar",
    "gui.soundEditor.copyToNew": "Copiar en nuevo",
    "gui.soundEditor.delete": "Eliminar",
    "gui.soundEditor.save": "Guardar",
    "gui.soundEditor.undo": "Deshacer",
    "gui.soundEditor.redo": "Rehacer",
    "gui.soundEditor.faster": "Más rápido",
    "gui.soundEditor.slower": "Más lento",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Más fuerte",
    "gui.soundEditor.softer": "Más suave",
    "gui.soundEditor.reverse": "Invertir",
    "gui.soundEditor.fadeOut": "Desaparecer",
    "gui.soundEditor.fadeIn": "Aparecer",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nombre",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Objeto",
    "gui.SpriteInfo.show": "Mostrar",
    "gui.SpriteInfo.size": "Tamaño",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "borrar",
    "gui.spriteSelector.addSpriteFromLibrary": "Elige un objeto",
    "gui.spriteSelector.addSpriteFromPaint": "Pinta",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Subir objeto",
    "gui.stageHeader.stageSizeLarge": "Cambiar a escenario grande",
    "gui.stageHeader.stageSizeSmall": "Cambiar a escenario pequeño",
    "gui.stageHeader.stageSizeFull": "Ir a modo pantalla completa",
    "gui.stageHeader.stageSizeUnFull": "Salir del modo de pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control a pantalla completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Elige un fondo",
    "gui.stageSelector.addBackdropFromPaint": "Pinta",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Carga un fondo",
    "gui.stageSelector.stage": "Escenario",
    "gui.stageSelector.backdrops": "Fondos",
    "gui.telemetryOptIn.label": "Reportar las estadísticas para mejorar Scratch",
    "gui.telemetryOptIn.body1": "El Equipo de Scratch busca comprender de la mejor forma cómo se utiliza Scratch en todo el mundo. Para apoyar estos esfuerzos, puede permitir que Scratch envíe información de uso de forma automática al Equipo de Scratch.",
    "gui.telemetryOptIn.body2": "La información que recopilamos incluye selección de idioma, uso de bloques y algunos eventos como guardar, cargar y subir un proyecto. NO recogemos ninguna información personal. Por favor, consulta nuestra {privacyPolicyLink} para más información.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de privacidad",
    "gui.telemetryOptIn.optInText": "Compartir mis datos de uso con el Equipo de Scratch",
    "gui.telemetryOptIn.optInTooltip": "Habilitar telemetría",
    "gui.telemetryOptIn.optOutText": "No compartir mis datos de uso con el Equipo de Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Desactivar telemetría",
    "gui.telemetryOptIn.settingWasUpdated": "Tu configuración se ha actualizado correctamente.",
    "gui.telemetryOptIn.buttonClose": "Cerrar",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "Tu navegador no soporta WebGL",
    "gui.webglModal.description": "Lamentablemente parece que tu navegador u ordenador {webGlLink}. Esta tecnología es necesaria para ejecutar Scratch 3.0.",
    "gui.webglModal.webgllink": "no soporta WebGL",
    "gui.webglModal.back": "Atrás",
    "gui.webglModal.previewfaq": "Para conocer más, visita las {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Preguntas frecuentes (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "Elige un fondo",
    "gui.costumeLibrary.chooseACostume": "Elige un disfraz",
    "gui.costumeTab.addBackdropFromLibrary": "Elige un fondo",
    "gui.costumeTab.addCostumeFromLibrary": "Elige un disfraz",
    "gui.costumeTab.addBlankCostume": "Pinta",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Carga un fondo",
    "gui.costumeTab.addFileCostume": "Carga un disfraz",
    "gui.extensionLibrary.chooseAnExtension": "Elige una extensión",
    "gui.extensionLibrary.extensionUrl": "Introduce la URL de la extensión",
    "gui.monitors.importListColumnPrompt": "¿Qué columna debe usarse (1- {numberOfColumns})?",
    "gui.recordingStep.alertMsg": "No se ha podido empezar a grabar",
    "gui.soundLibrary.chooseASound": "Elige un sonido",
    "gui.soundTab.fileUploadSound": "Carga un sonido",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Grabar",
    "gui.soundTab.addSoundFromLibrary": "Elige un sonido",
    "gui.spriteLibrary.chooseASprite": "Elige un objeto",
    "gui.tipsLibrary.tutorials": "Elige un tutorial",
    "gui.alerts.createsuccess": "Nuevo proyecto creado.",
    "gui.alerts.createcopysuccess": "Proyecto guardado como copia.",
    "gui.alerts.createremixsuccess": "Proyecto guardado como reinvención.",
    "gui.alerts.creating": "Creando nuevo...",
    "gui.alerts.creatingCopy": "Copiando proyecto...",
    "gui.alerts.creatingRemix": "Reinventando proyecto...",
    "gui.alerts.creatingError": "No se ha podido crear el proyecto. Por favor, ¡inténtalo de nuevo!",
    "gui.alerts.savingError": "No se ha podido guardar el proyecto.",
    "gui.alerts.savesuccess": "Proyecto guardado.",
    "gui.alerts.saving": "Guardando proyecto...",
    "gui.alerts.cloudInfo": "Ten en cuenta que las variables en la nube solo admiten números, no letras ni símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Más información.",
    "gui.alerts.importing": "Importando…",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "mi variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Para empezar",
    "gui.howtos.intro-move.step_stepMove": "Añade un bloque de movimiento",
    "gui.howtos.add-a-move-block.step_stepSay": "Añade un bloque de decir",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Haz clic en la bandera verde para empezar",
    "gui.howtos.intro-getting-started-ASL.name": "Empezando - ASL",
    "gui.howtos.animate-a-name.name": "Animar un nombre",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Elige un objeto de letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Al hacer clic, toca un sonido",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Elige otra letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambia el color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Elige otra letra y hazla girar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Elige otra letra y hazla crecer",
    "gui.howtos.imagine": "Imagina un Mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Escribe lo que quieres decir",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Haz clic en la bandera verde para empezar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Elige un fondo",
    "gui.howtos.imagine.step_imagineChooseSprite": "Elige un objeto",
    "gui.howtos.imagine.step_imagineFlyAround": "Presiona la tecla espacio para deslizarte",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Elige otro objeto",
    "gui.howtos.imagine.step_imagineLeftRight": "Muévete a izquierda y derecha",
    "gui.howtos.imagine.step_imagineUpDown": "Muévete arriba y abajo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Cambia de disfraz",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Deslízate a un punto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Haz que crezca y encoja",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Elige otro fondo",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cambia el fondo",
    "gui.howtos.imagine.step_imagineRecordASound": "Añade un sonido",
    "gui.howtos.imagine.step_imagineChooseSound": "Elige tu sonido",
    "gui.howtos.make-music.name": "Crear música",
    "gui.howtos.Make-Music.step_PickInstrument": "Elige un objeto de instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Al hacer clic, toca un sonido",
    "gui.howtos.Make-Music.step_MakeSong": "Compón una canción",
    "gui.howtos.make-music.step_MakeBeat": "Elige un tambor y crea un ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Elige el objeto micrófono y la caja de sonidos sorpresa",
    "gui.howtos.story.name": "Crear una historia",
    "gui.howtos.story.step_addbg": "Añade un fondo",
    "gui.howtos.story.step_addsprite": "Añade un personaje",
    "gui.howtos.story.step_saysomething": "Di algo",
    "gui.howtos.story.step_addanothersprite": "Añade otro personaje",
    "gui.howtos.story.step_flip": "Cambia de Dirección",
    "gui.howtos.story.step_conversation": "Ten una Conversación",
    "gui.howtos.story.addanotherbg": "Añade otro Fondo",
    "gui.howtos.story.step_swithbg": "Cambia Fondo",
    "gui.howtos.story.step_hidewizard": "Esconde un Personaje",
    "gui.howtos.story.step_showwizard": "Muestra un Personaje",
    "gui.howtos.make-a-chase-game.name": "Crear un juego de persecución",
    "gui.howtos.Chase-Game.step_BG": "Añade un fondo",
    "gui.howtos.chase-game.step_AddOcto": "Añade un objeto",
    "gui.howtos.make-music.step_LeftRight": "Mueve a derecha e izquierda con las flechas",
    "gui.howtos.Chase-Game.step_UpDown": "Mueve arriba y abajo con las flechas",
    "gui.howtos.Chase-Game.step_AddStar": "Añade otro objeto",
    "gui.howtos.Chase-Game.step_MoveRandom": "Muévelo de forma aleatoria",
    "gui.howtos.Chase-Game.step_WhenTouch": "En el objeto pulpo, al tocar reproduce un sonido",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crea la variable \"puntos\"",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En el objeto pulpo, al tocar añade puntos",
    "gui.howtos.animate-char.name": "Animar un personaje",
    "gui.howtos.animate-char.step_addbg": "Añade un fondo",
    "gui.howtos.animate-char.step_addsprite": "Añade un objeto",
    "gui.howtos.animate-char.step_saysomething": "Di algo",
    "gui.howtos.animate-char.step_addsound": "Añade un sonido",
    "gui.howtos.animate-char.step_animatetalking": "Animar una conversación",
    "gui.howtos.animate-char.step_arrowkeys": "Mueve con las Teclas de Flechas",
    "gui.howtos.animate-char.step_jump": "Salta",
    "gui.howtos.animate-char.step_changecolor": "Cambiar el color",
    "gui.howtos.make-a-game.name": "Crear un juego de hacer clic",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Elige un objeto",
    "gui.howtos.make-a-game.step_GamePlaySound": "Al hacer clic, toca un sonido",
    "gui.howtos.make-a-game.step_GameAddScore": "Crea una variable \"puntos\"",
    "gui.howtos.make-a-game.step_GameChangeScore": "Al hacer clic incrementa los puntos",
    "gui.howtos.make-a-game.step_Random": "Ir a una posición aleatoria",
    "gui.howtos.make-music.step_GameChangeColor": "Cambia el color",
    "gui.howtos.make-music.step_ResetScore": "Reinicia los puntos",
    "gui.howtos.make-it-fly.name": "Hazlo volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Elige un fondo de cielo",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Elige un personaje",
    "gui.howtos.fly.step_stepflySaySomething": "Di algo",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Muévete con las flechas",
    "gui.howtos.fly.step_stepflyChooseObject": "Elige un objeto que recoger",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Haz que se mueva",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Elige tu personaje",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Añade una puntuación",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Guarda la puntuación",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Añade un decorado",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mueve el decorado",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Siguiente disfraz",
    "gui.howtos.pong": "Juego de Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Añade un fondo",
    "gui.howtos.pong.step_pongAddBallSprite": "Añade una pelota",
    "gui.howtos.pong.step_pongBounceAround": "Rebota",
    "gui.howtos.pong.step_pongAddPaddle": "Añade una paleta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mueve la paleta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selecciona la pelota",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Rebota la pelota con la paleta",
    "gui.howtos.pong.step_pongAddAScore": "Añade una puntuación",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Elige 'Puntos' en el menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Inserta el bloque 'sumar a puntos'",
    "gui.howtos.pong.step_pongResetScore": "Reinicia los puntos",
    "gui.howtos.pong.step_pongAddLineSprite": "Añade el objeto línea",
    "gui.howtos.pong.step_pongGameOver": "Fin del juego",
    "gui.howtos.code-cartoon": "Programar unos dibujos animados",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Di algo al hacer clic en la bandera verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anima un personaje al hacer clic en él",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Elige un personaje distinto",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usa el signo menos para hacerlo más pequeño",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Haz que un personaje crezca o encoja",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Elige un personaje distinto",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Salta arriba y abajo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Haz clic en un personaje para cambiar de escena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Deslízate",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Cambia de disfraz",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Elige más personajes para añadir a tus dibujos",
    "gui.howtos.cartoon-network": "Animar un juego de aventuras",
    "gui.howtos.cartoon-network.step_CNcharacter": "Elige qué personaje mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Decir algo",
    "gui.howtos.cartoon-network.step_CNglide": "Deslizarse",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Elige qué objeto perseguir",
    "gui.howtos.cartoon-network.step_CNcollect": "Recolecta objetos",
    "gui.howtos.cartoon-network.step_CNvariable": "Crea una variable \"puntos\"",
    "gui.howtos.cartoon-network.step_CNscore": "Guardar puntuación",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Sube de nivel: cambia de fondo",
    "gui.howtos.videosens.name": "Sensor de vídeo",
    "gui.howtos.videosens.step_addextension": "Añade Extensión",
    "gui.howtos.videosens.step_pet": "Acaricia al Gato",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Explota un Globo",
    "gui.howtos.say-it-out-loud": "Crear animaciones que hablen",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Añade los bloques de \"Texto a Voz\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Di algo",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Elige una voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Muévete",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Añadir un fondo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Añade otro personaje",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Toca una canción",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambiar el color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Da vueltas",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Haz que crezca y encoja",
    "gui.howtos.talking": "Cuentos que hablan",
    "gui.howtos.talking.step_talesAddExtension": "Haz clic para añadir los bloques de Texto-a-voz",
    "gui.howtos.talking.step_talesChooseSprite": "Elige un objeto",
    "gui.howtos.talking.step_talesSaySomething": "Haz que el personaje hable",
    "gui.howtos.talking.step_talesChooseBackdrop": "Elige un fondo",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Haz clic en el personaje para ir al siguiente fondo",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Elige otro objeto",
    "gui.howtos.talking.step_talesMoveAround": "Muévete",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Elige otro fondo",
    "gui.howtos.talking.step_talesAnimateTalking": "Animar una conversación",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Elige otro fondo",
    "gui.howtos.talking.step_talesChooseSound": "Elige una canción para bailar",
    "gui.howtos.talking.step_talesDanceMoves": "Movimientos de baile",
    "gui.howtos.talking.step_talesAskAnswer": "Elige los bloques de preguntar y respuesta de la categoría de Sensores",
    "gui.howtos.add-sprite.name": "Añadir un objeto",
    "gui.howtos.add-sprite.step_addSprite": "Añade un objeto",
    "gui.howtos.add-a-backdrop.name": "Añadir un fondo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Añade un fondo",
    "gui.howtos.change-size.name": "Cambiar tamaño",
    "gui.howtos.change-size.step_changeSize": "Cambia el tamaño",
    "gui.howtos.glide-around.name": "Deslizarse",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Deslízate",
    "gui.howtos.change-size.step_glideAroundPoint": "Deslízate a un punto",
    "gui.howtos.record-a-sound.name": "Grabar un sonido",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Haz clic en la pestaña 'Sonidos'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Haz clic en 'Grabar'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Haz clic en el botón de grabar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Elige tu sonido",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Reproduce tu sonido",
    "gui.howtos.spin-video.name": "Hazlo girar",
    "gui.howtos.change-size.step_spinTurn": "Gira",
    "gui.howtos.change-size.step_spinPointInDirection": "Fija la dirección",
    "gui.howtos.hide-and-show.name": "El escondite",
    "gui.howtos.change-size.step_hideAndShow": "El escondite",
    "gui.howtos.switch-costume.name": "Animar un objeto",
    "gui.howtos.change-size.step_switchCostumes": "Anima un objeto",
    "gui.howtos.move-around-with-arrow-keys.name": "Usar las teclas de flecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Muévete a izquierda y derecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Muévete arriba y abajo",
    "gui.howtos.add-effects.name": "Añadir efectos",
    "gui.howtos.videosens.step_addEffects": "Añade efectos",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toca instrumentos y percusión.",
    "gui.extension.pen.name": "Lápiz",
    "gui.extension.pen.description": "Dibuja con tus objetos.",
    "gui.extension.videosensing.name": "Sensor de vídeo",
    "gui.extension.videosensing.description": "Detecta movimientos con la cámara.",
    "gui.extension.text2speech.name": "Texto a voz",
    "gui.extension.text2speech.description": "Haz que tus proyectos hablen.",
    "gui.extension.translate.name": "Traducir",
    "gui.extension.translate.description": "Traduce texto a muchos idiomas.",
    "gui.extension.makeymakey.description": "Convierte cualquier cosa en una tecla.",
    "gui.extension.microbit.description": "Conecta tus proyectos con el mundo.",
    "gui.extension.microbit.connectingMessage": "Conectando",
    "gui.extension.ev3.description": "Construye robots interactivos y mucho más.",
    "gui.extension.ev3.connectingMessage": "Conectando. Asegúrate de que el PIN de tu EV3 es 1234.",
    "gui.extension.boost.description": "Dale vida a tus creaciones robóticas.",
    "gui.extension.boost.connectingMessage": "Conectando",
    "gui.extension.wedo2.description": "Construye con motores y sensores.",
    "gui.extension.wedo2.connectingMessage": "Conectando",
    "gui.extension.gdxfor.description": "Detecta empuje, tirón, movimiento y giro.",
    "gui.extension.gdxfor.connectingMessage": "Conectando",
    "gui.libraryTags.all": "Todos",
    "gui.libraryTags.animals": "Animales",
    "gui.libraryTags.dance": "Bailar",
    "gui.libraryTags.effects": "Efectos",
    "gui.libraryTags.fantasy": "Fantasía",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Comida",
    "gui.libraryTags.indoors": "Interiores",
    "gui.libraryTags.loops": "Bucles",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exteriores",
    "gui.libraryTags.patterns": "Patrones",
    "gui.libraryTags.people": "Gente",
    "gui.libraryTags.percussion": "Percusión",
    "gui.libraryTags.space": "Espacio",
    "gui.libraryTags.sports": "Deportes",
    "gui.libraryTags.underwater": "Bajo el mar",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Locuras",
    "gui.libraryTags.animation": "Animación",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Juegos",
    "gui.libraryTags.stories": "Historias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "dirección",
    "gui.opcodeLabels.xposition": "posición en x",
    "gui.opcodeLabels.yposition": "posición en y",
    "gui.opcodeLabels.size": "tamaño",
    "gui.opcodeLabels.costumename": "nombre de disfraz",
    "gui.opcodeLabels.costumenumber": "número de disfraz",
    "gui.opcodeLabels.backdropname": "nombre de fondo",
    "gui.opcodeLabels.backdropnumber": "número de fondo",
    "gui.opcodeLabels.volume": "volumen",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "respuesta",
    "gui.opcodeLabels.loudness": "volumen del sonido",
    "gui.opcodeLabels.username": "nombre de usuario",
    "gui.opcodeLabels.year": "año",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "día",
    "gui.opcodeLabels.dayofweek": "día de la semana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronómetro",
    "gui.projectLoader.loadError": "No se ha podido cargar el proyecto seleccionado.",
    "gui.sharedMessages.backdrop": "fondo{index}",
    "gui.sharedMessages.costume": "disfraz{index}",
    "gui.sharedMessages.sprite": "Objeto{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "¿Reemplazar el contenido del proyecto actual?",
    "gui.sharedMessages.loadFromComputerTitle": "Cargar desde tu ordenador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proyecto de Scratch",
    "boost.color.any": "de cualquier color",
    "boost.color.black": "negra",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "roja",
    "boost.color.white": "blanca",
    "boost.color.yellow": "amarilla",
    "boost.getMotorPosition": "posición del motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "ángulo de inclinación hacia [TILT_DIRECTION]",
    "boost.motorDirection.backward": "a un lado",
    "boost.motorDirection.forward": "al otro lado",
    "boost.motorDirection.reverse": "a la inversa",
    "boost.motorOff": "apagar motor [MOTOR_ID]",
    "boost.motorOn": "encender motor [MOTOR_ID]",
    "boost.motorOnFor": "girar motor [MOTOR_ID] [DURATION] segundos",
    "boost.motorOnForRotation": "girar motor [MOTOR_ID] [ROTATION] vueltas",
    "boost.seeingColor": "¿ve pieza [COLOR]?",
    "boost.setLightHue": "fijar color de la luz a [HUE]",
    "boost.setMotorDirection": "fijar dirección del motor [MOTOR_ID] [MOTOR_DIRECTION]",
    "boost.setMotorPower": "fijar velocidad del motor [MOTOR_ID] al [POWER] %",
    "boost.tiltDirection.any": "cualquiera",
    "boost.tiltDirection.down": "abajo",
    "boost.tiltDirection.left": "izquierda",
    "boost.tiltDirection.right": "derecha",
    "boost.tiltDirection.up": "arriba",
    "boost.whenColor": "cuando vea pieza [COLOR]",
    "boost.whenTilted": "al inclinar hacia [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tocar nota [NOTE] durante [TIME] segundos",
    "ev3.buttonPressed": "¿botón [PORT] presionado?",
    "ev3.getBrightness": "brillo",
    "ev3.getDistance": "distancia",
    "ev3.getMotorPosition": "posición del motor [PORT]",
    "ev3.motorSetPower": "motor [PORT] fijar potencia a [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] girar a un lado [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "motor [PORT] girar al otro lado [TIME] segundos",
    "ev3.whenBrightnessLessThan": "cuando brillo < [DISTANCE]",
    "ev3.whenButtonPressed": "al presionar botón [PORT]",
    "ev3.whenDistanceLessThan": "cuando distancia < [DISTANCE]",
    "gdxfor.getAcceleration": "aceleración [DIRECTION]",
    "gdxfor.getForce": "fuerza",
    "gdxfor.getSpin": "velocidad de giro [DIRECTION]",
    "gdxfor.getTilt": "ángulo de inclinación [TILT]",
    "gdxfor.isFreeFalling": "¿cayendo?",
    "gdxfor.isTilted": "¿inclinado [TILT]?",
    "gdxfor.pulled": "empuje",
    "gdxfor.pushed": "tire",
    "gdxfor.shaken": "agitar",
    "gdxfor.startedFalling": "comenzar a caer",
    "gdxfor.tiltDirectionMenu.any": "en cualquier dirección",
    "gdxfor.tiltDirectionMenu.back": "atrás",
    "gdxfor.tiltDirectionMenu.front": "adelante",
    "gdxfor.tiltDirectionMenu.left": "a la izquierda",
    "gdxfor.tiltDirectionMenu.right": "a la derecha",
    "gdxfor.turnedFaceDown": "girar hacia abajo",
    "gdxfor.turnedFaceUp": "girar hacia arriba",
    "gdxfor.whenForcePushedOrPulled": "cuando el sensor de fuerza [PUSH_PULL]",
    "gdxfor.whenGesture": "al [GESTURE]",
    "gdxfor.whenTilted": "al inclinar [TILT]",
    "makeymakey.downArrow": "flecha abajo",
    "makeymakey.downArrowShort": "abajo",
    "makeymakey.leftArrow": "flecha izquierda",
    "makeymakey.leftArrowShort": "izquierda",
    "makeymakey.rightArrow": "flecha derecha",
    "makeymakey.rightArrowShort": "derecha",
    "makeymakey.spaceKey": "espacio",
    "makeymakey.upArrow": "flecha arriba",
    "makeymakey.upArrowShort": "arriba",
    "makeymakey.whenKeyPressed": "al presionar tecla [KEY]",
    "makeymakey.whenKeysPressedInOrder": "al presionar [SEQUENCE] en orden",
    "microbit.buttonsMenu.any": "cualquiera",
    "microbit.clearDisplay": "limpiar pantalla",
    "microbit.defaultTextToDisplay": "¡Hola!",
    "microbit.displaySymbol": "mostrar [MATRIX]",
    "microbit.displayText": "mostrar texto [TEXT]",
    "microbit.gesturesMenu.jumped": "saltar",
    "microbit.gesturesMenu.moved": "mover",
    "microbit.gesturesMenu.shaken": "agitar",
    "microbit.isButtonPressed": "¿botón [BTN] presionado?",
    "microbit.isTilted": "¿inclinado hacia [DIRECTION]?",
    "microbit.pinStateMenu.off": "apagar",
    "microbit.pinStateMenu.on": "encender",
    "microbit.tiltAngle": "ángulo de inclinación hacia [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "cualquiera",
    "microbit.tiltDirectionMenu.back": "atrás",
    "microbit.tiltDirectionMenu.front": "delante",
    "microbit.tiltDirectionMenu.left": "izquierda",
    "microbit.tiltDirectionMenu.right": "derecha",
    "microbit.whenButtonPressed": "al presionar botón [BTN]",
    "microbit.whenGesture": "al [GESTURE]",
    "microbit.whenPinConnected": "al conectar pin [PIN]",
    "microbit.whenTilted": "al inclinar hacia [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "cambiar tempo por [TEMPO]",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charles cerrado",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cencerro",
    "music.drumCrashCymbal": "(4) Platillo crash",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Palmada",
    "music.drumOpenHiHat": "(5) Charles abierto",
    "music.drumSideStick": "(3) Golpe lateral",
    "music.drumSnare": "(1) Caja",
    "music.drumTambourine": "(7) Pandereta",
    "music.drumTriangle": "(12) Triángulo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Caja china",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bajo",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violonchelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra eléctrica",
    "music.instrumentElectricPiano": "(2) Piano eléctrico",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caja de música",
    "music.instrumentOrgan": "(3) Órgano",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Tambor metálico",
    "music.instrumentSynthLead": "(20) Sintetizador melódico",
    "music.instrumentSynthPad": "(21) Sintetizador de fondo",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibráfono",
    "music.instrumentWoodenFlute": "(13) Flauta de madera",
    "music.midiPlayDrumForBeats": "tocar tambor [DRUM] durante [BEATS] tiempos",
    "music.midiSetInstrument": "fijar instrumento a [INSTRUMENT]",
    "music.playDrumForBeats": "tocar tambor [DRUM] durante [BEATS] tiempos",
    "music.playNoteForBeats": "tocar nota [NOTE] durante [BEATS] tiempos",
    "music.restForBeats": "silencio de [BEATS] tiempos",
    "music.setInstrument": "fijar instrumento a [INSTRUMENT]",
    "music.setTempo": "dar al tempo el valor [TEMPO]",
    "pen.categoryName": "Lápiz",
    "pen.changeColorParam": "cambiar [COLOR_PARAM] de lápiz por [VALUE]",
    "pen.changeHue": "cambiar color de lápiz por [HUE]",
    "pen.changeShade": "cambiar sombra de lápiz por [SHADE]",
    "pen.changeSize": "cambiar tamaño de lápiz por [SIZE]",
    "pen.clear": "borrar todo",
    "pen.colorMenu.brightness": "brillo",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "transparencia",
    "pen.penDown": "bajar lápiz",
    "pen.penUp": "subir lápiz",
    "pen.setColor": "fijar color de lápiz a [COLOR]",
    "pen.setColorParam": "fijar [COLOR_PARAM] de lápiz a [VALUE]",
    "pen.setHue": "fijar color de lápiz a [HUE]",
    "pen.setShade": "fijar sombra de lápiz a [SHADE]",
    "pen.setSize": "fijar tamaño de lápiz a [SIZE]",
    "pen.stamp": "sellar",
    "speech.defaultWhenIHearValue": "vamos",
    "speech.extensionName": "Reconocimiento de voz",
    "speech.listenAndWait": "escuchar y esperar",
    "speech.speechReporter": "frase",
    "speech.whenIHear": "cuando oiga [PHRASE]",
    "text2speech.alto": "contralto",
    "text2speech.categoryName": "Texto a voz",
    "text2speech.defaultTextToSpeak": "hola",
    "text2speech.giant": "gigante",
    "text2speech.kitten": "gatito",
    "text2speech.setLanguageBlock": "fijar idioma a [LANGUAGE]",
    "text2speech.setVoiceBlock": "asignar voz a [VOICE]",
    "text2speech.speakAndWaitBlock": "decir [WORDS]",
    "text2speech.squeak": "chillido",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducción",
    "translate.defaultTextToTranslate": "hola",
    "translate.translateBlock": "traducir [WORDS] al [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Sensor de video",
    "videoSensing.direction": "dirección",
    "videoSensing.motion": "movimiento",
    "videoSensing.off": "apagar",
    "videoSensing.on": "encender",
    "videoSensing.onFlipped": "invertir",
    "videoSensing.setVideoTransparency": "fijar transparencia de vídeo a [TRANSPARENCY]",
    "videoSensing.sprite": "objeto",
    "videoSensing.stage": "escenario",
    "videoSensing.videoOn": "[ATTRIBUTE] de vídeo en [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] vídeo",
    "videoSensing.whenMotionGreaterThan": "cuando movimiento de vídeo > [REFERENCE]",
    "wedo2.getDistance": "distancia",
    "wedo2.getTiltAngle": "ángulo de inclinación hacia [TILT_DIRECTION]",
    "wedo2.isTilted": "¿inclinado hacia [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "un lado",
    "wedo2.motorDirection.forward": "otro lado",
    "wedo2.motorDirection.reverse": "inversa",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "todos los motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "apagar [MOTOR_ID]",
    "wedo2.motorOn": "encender [MOTOR_ID]",
    "wedo2.motorOnFor": "encender [MOTOR_ID] durante [DURATION] segundos",
    "wedo2.playNoteFor": "tocar nota [NOTE] durante [DURATION] segundos",
    "wedo2.setLightHue": "fijar color de la luz a [HUE]",
    "wedo2.setMotorDirection": "fijar dirección de [MOTOR_ID] a [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "fijar potencia de [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "cualquier",
    "wedo2.tiltDirection.down": "abajo",
    "wedo2.tiltDirection.left": "izquierda",
    "wedo2.tiltDirection.right": "derecha",
    "wedo2.tiltDirection.up": "arriba",
    "wedo2.whenDistance": "cuando distancia [OP] [REFERENCE]",
    "wedo2.whenTilted": "al inclinar hacia [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "Brillo",
    "paint.paintEditor.costume": "Disfraz",
    "paint.paintEditor.group": "Agrupar",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Deshacer",
    "paint.paintEditor.redo": "Rehacer",
    "paint.paintEditor.forward": "Adelante",
    "paint.paintEditor.backward": "Atrás",
    "paint.paintEditor.front": "Al frente",
    "paint.paintEditor.back": "Al fondo",
    "paint.paintEditor.more": "Más",
    "paint.modeTools.brushSize": "Tamaño",
    "paint.modeTools.eraserSize": "Tamaño de la goma",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Pegar",
    "paint.modeTools.delete": "Eliminar",
    "paint.modeTools.curved": "Curvado",
    "paint.modeTools.pointed": "Recto",
    "paint.modeTools.thickness": "Grosor",
    "paint.modeTools.flipHorizontal": "Voltear horizontalmente",
    "paint.modeTools.flipVertical": "Voltear verticalmente",
    "paint.modeTools.filled": "Relleno",
    "paint.modeTools.outlined": "Contorneado",
    "paint.paintEditor.bitmap": "Convertir a mapa de bits",
    "paint.paintEditor.vector": "Convertir a vector",
    "paint.paintEditor.fill": "Rellenar",
    "paint.paintEditor.stroke": "Borde",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Goma",
    "paint.fillMode.fill": "Rellenar",
    "paint.lineMode.line": "Línea",
    "paint.ovalMode.oval": "Círculo",
    "paint.rectMode.rect": "Rectángulo",
    "paint.reshapeMode.reshape": "Volver a dar forma",
    "paint.roundedRectMode.roundedRect": "Rectángulo con bordes redoneados",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Invertir"
  },
  "es-419": {
    "gui.alerts.lostPeripheralConnection": "Scratch ha perdido su conexión a {extensionName}.",
    "gui.alerts.tryAgain": "Vuelve a intentar",
    "gui.alerts.download": "Descargar",
    "gui.connection.reconnect": "Reconectar",
    "gui.backpack.costumeLabel": "disfraz",
    "gui.backpack.soundLabel": "sonido",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "objeto",
    "gui.backpack.header": "Mochila",
    "gui.backpack.errorBackpack": "Error al cargar la mochila",
    "gui.backpack.loadingBackpack": "Cargando...",
    "gui.backpack.more": "Más",
    "gui.backpack.emptyBackpack": "La mochila está vacía",
    "gui.unsupportedBrowser.label": "El navegador no es compatible",
    "gui.unsupportedBrowser.errorLabel": "Ocurrió un error",
    "gui.unsupportedBrowser.notRecommended": "Lo sentimos mucho, pero parece que estas usando una versión de navegador que no es compatible con Scratch. Recomendamos actualizar a la versión más reciente de un navegador compatible como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.description": "Lo sentimos mucho, pero Scratch no es compatible con este navegador. Recomendamos probar con la versión más reciente de un navegador compatible como Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.back": "Regresar",
    "gui.unsupportedBrowser.previewfaq": "Para obtener más información, ve a {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Preguntas frecuentes (FAQ)",
    "gui.cards.all-tutorials": "Tutoriales",
    "gui.cards.shrink": "Encoger",
    "gui.cards.expand": "Expandir",
    "gui.cards.close": "Cerrar",
    "gui.cards.more-things-to-try": "¡Más cosas para probar!",
    "gui.cards.see-more": "Ver más",
    "gui.comingSoon.message1": "No te preocupes, estamos en eso {emoji}",
    "gui.comingSoon.message2": "Próximamente...",
    "gui.comingSoon.message3": "Estamos trabajando en ello {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No se encontró ningún dispositivo",
    "gui.connection.auto-scanning.prescan": "Ten tu dispositivo cerca, luego inicia la búsqueda.",
    "gui.connection.auto-scanning.pressbutton": "Presiona el botón en tu dispositivo.",
    "gui.connection.auto-scanning.start-search": "Inicia la búsqueda",
    "gui.connection.connecting-searchbutton": "Buscando...",
    "gui.connection.auto-scanning.try-again": "Volver a intentar",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Conectado",
    "gui.connection.disconnect": "Desconectar",
    "gui.connection.go-to-editor": "Ir al Editor",
    "gui.connection.connecting-cancelbutton": "Conectando...",
    "gui.connection.error.errorMessage": "¡Uy! Parece que algo salió mal.",
    "gui.connection.error.tryagainbutton": "Volver a intentar",
    "gui.connection.error.helpbutton": "Ayuda",
    "gui.connection.peripheral-name-label": "Nombre del dispositivo",
    "gui.connection.connect": "Conectar",
    "gui.connection.scanning.lookingforperipherals": "Buscando dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "No se encontró ningún dispositivo",
    "gui.connection.scanning.instructions": "Selecciona tu dispositivo en la lista de arriba.",
    "gui.connection.search": "Actualizar",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Asegúrate de tener Scratch Link instalado y corriendo",
    "gui.connection.unavailable.enablebluetooth": "Revisa que el Bluetooth esté habilitado",
    "gui.connection.unavailable.tryagainbutton": "Volver a intentar",
    "gui.connection.unavailable.helpbutton": "Ayuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ir",
    "gui.controls.stop": "Detener",
    "gui.crashMessage.label": "¡Uy! Algo salió mal.",
    "gui.crashMessage.description": "Lo sentimos mucho, pero Scratch no responde. Este error ha sido reportado automáticamente al Equipo de Scratch. Por favor, actualiza tu página para volver a intentarlo.",
    "gui.crashMessage.errorNumber": "Su error ha sido registrado con id {errorId}",
    "gui.crashMessage.reload": "Recargar",
    "gui.customProcedures.myblockModalTitle": "Crear un bloque",
    "gui.customProcedures.addAnInputNumberText": "Agregar una entrada",
    "gui.customProcedures.numberTextType": "número o texto",
    "gui.customProcedures.addAnInputBoolean": "Agregar una entrada",
    "gui.customProcedures.booleanType": "booleano",
    "gui.customProcedures.addALabel": "Agregar una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Ejecutar sin actualizar la pantalla",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "De acuerdo",
    "gui.SpriteInfo.direction": "Dirección",
    "gui.directionPicker.rotationStyles.allAround": "En todas direcciones",
    "gui.directionPicker.rotationStyles.leftRight": "Izquierda/Derecha",
    "gui.directionPicker.rotationStyles.dontRotate": "No rotar",
    "gui.gui.addExtension": "Agregar Extensión",
    "gui.gui.codeTab": "Código",
    "gui.gui.backdropsTab": "Fondos",
    "gui.gui.costumesTab": "Disfraces",
    "gui.gui.soundsTab": "Sonidos",
    "gui.extensionLibrary.comingSoon": "Próximamente",
    "gui.extensionLibrary.requires": "Requiere",
    "gui.extensionLibrary.collaboration": "Colaboración con",
    "gui.library.filterPlaceholder": "Buscar",
    "gui.library.allTag": "Todos",
    "gui.loader.message1": "Creando bloques",
    "gui.loader.message2": "Cargando objetos ...",
    "gui.loader.message3": "Cargando sonidos ...",
    "gui.loader.message4": "Cargando extensiones ...",
    "gui.loader.message5": "Arreando gatos …",
    "gui.loader.message6": "Transmitiendo nanos ...",
    "gui.loader.message7": "Inflando Gobos ...",
    "gui.loader.message8": "Preparando emojis ...",
    "gui.loader.headline": "Cargando proyecto",
    "gui.loader.creating": "Creando un proyecto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Mis Cosas",
    "gui.accountMenu.myClasses": "Mis Clases",
    "gui.accountMenu.myClass": "Mi Clase",
    "gui.accountMenu.accountSettings": "Configuración de la cuenta",
    "gui.accountMenu.signOut": "Cerrar sesión",
    "gui.authorInfo.byUser": "por {username}",
    "gui.menuBar.seeProjectPage": "Ver página del proyecto",
    "gui.menuBar.language": "Language",
    "general.username": "Nombre de Usuario",
    "general.password": "Contraseña",
    "general.signIn": "Iniciar sesión",
    "login.needHelp": "¿Necesitas ayuda?",
    "form.validationRequired": "Este campo es requerido",
    "gui.menuBar.tutorialsLibrary": "Tutoriales",
    "gui.menuBar.restoreSprite": "Restaurar Objeto",
    "gui.menuBar.restoreSound": "Restaurar Sonido",
    "gui.menuBar.restoreCostume": "Restaurar Disfraz",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Guardar ahora",
    "gui.menuBar.saveAsCopy": "Guardar como copia",
    "gui.menuBar.remix": "Reinventar",
    "gui.menuBar.new": "Nuevo",
    "gui.menuBar.file": "Archivo",
    "gui.menuBar.downloadToComputer": "Guardar en tu computador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desactivar Modo turbo",
    "gui.menuBar.turboModeOn": "Activar Modo turbo",
    "gui.menuBar.modeMenu": "Modo",
    "gui.menuBar.normalMode": "Modo normal",
    "gui.menuBar.caturdayMode": "Modo sabado gatuno",
    "gui.menuBar.joinScratch": "Únete a Scratch",
    "gui.menuBar.signIn": "Iniciar sesión",
    "gui.gui.projectTitlePlaceholder": "Título del proyecto aquí",
    "gui.menuBar.saveNowLink": "Guardar ahora",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Compartidos",
    "gui.menuBar.share": "Compartir",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ayuda",
    "gui.modal.back": "Regresar",
    "gui.monitor.listMonitor.empty": "(vacío)",
    "gui.monitor.listMonitor.listLength": "largo {length}",
    "gui.monitor.contextMenu.default": "tamaño normal",
    "gui.monitor.contextMenu.large": "tamaño grande",
    "gui.monitor.contextMenu.slider": "deslizador",
    "gui.monitor.contextMenu.sliderRange": "cambiar rango del deslizador",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Reproducir",
    "gui.playButton.stop": "Detener",
    "gui.gui.variableScopeOptionAllSprites": "Para todos los objetos",
    "gui.gui.variableScopeOptionSpriteOnly": "Sólo para este objeto",
    "gui.gui.cloudVariableOption": "Variable de la nube (guardada en el servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variable estará disponible para todos los objetos.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "De acuerdo",
    "gui.playbackStep.stopMsg": "Detener",
    "gui.playbackStep.playMsg": "Reproducir",
    "gui.playbackStep.loadingMsg": "Cargando...",
    "gui.playbackStep.saveMsg": "Guardar",
    "gui.playbackStep.reRecordMsg": "Volver a grabar",
    "gui.recordModal.title": "Grabar Sonido",
    "gui.recordingStep.beginRecord": "Empieza a grabar haciendo clic en el botón de abajo",
    "gui.recordingStep.permission": "{arrow}Necesitamos permiso para utilizar tu micrófono",
    "gui.recordingStep.stop": "Parar de grabar",
    "gui.recordingStep.record": "Grabar",
    "gui.sliderModal.min": "Valor mínimo",
    "gui.sliderModal.max": "Valor máximo",
    "gui.sliderModal.title": "Cambiar rango del deslizador",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "De acuerdo",
    "gui.soundEditor.sound": "Sonido",
    "gui.soundEditor.play": "Jugar",
    "gui.soundEditor.stop": "Detener",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Pegar",
    "gui.soundEditor.copyToNew": "Copiar a uno nuevo",
    "gui.soundEditor.delete": "Eliminar",
    "gui.soundEditor.save": "Guardar",
    "gui.soundEditor.undo": "Deshacer",
    "gui.soundEditor.redo": "Rehacer",
    "gui.soundEditor.faster": "Más rápido",
    "gui.soundEditor.slower": "Más lento",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Más fuerte",
    "gui.soundEditor.softer": "Más suave",
    "gui.soundEditor.reverse": "Reversa",
    "gui.soundEditor.fadeOut": "Desvanecer",
    "gui.soundEditor.fadeIn": "Aparecer",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nombre",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Objeto",
    "gui.SpriteInfo.show": "mostrar",
    "gui.SpriteInfo.size": "Tamaño",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "eliminar",
    "gui.spriteSelector.addSpriteFromLibrary": "Elegir un objeto",
    "gui.spriteSelector.addSpriteFromPaint": "Pintar",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Subir un objeto",
    "gui.stageHeader.stageSizeLarge": "Cambiar a un escenario grande",
    "gui.stageHeader.stageSizeSmall": "Cambiar a un escenario pequeño",
    "gui.stageHeader.stageSizeFull": "Ingresar al modo de pantalla completa",
    "gui.stageHeader.stageSizeUnFull": "Salir del modo de pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control de Pantalla Completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Elige un fondo",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Subir Fondo",
    "gui.stageSelector.stage": "Escenario",
    "gui.stageSelector.backdrops": "Fondos",
    "gui.telemetryOptIn.label": "Reportar las estadísticas para mejorar Scratch",
    "gui.telemetryOptIn.body1": "El equipo de Scratch siempre busca entender mejor cómo se usa Scratch en el mundo. Para aportar a esta iniciativa, puede permitir que Scratch envíe automáticamente la información de uso al equipo de Scratch.",
    "gui.telemetryOptIn.body2": "La información que recopilamos incluye selección de idioma, uso de bloques y algunos eventos como guardar, cargar y subir un proyecto. NO recogemos ninguna información personal. Por favor vea nuestra {privacyPolicyLink} para más información.",
    "gui.telemetryOptIn.privacyPolicyLink": "política de privacidad",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Habilitar telemetría",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Desactivar la telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Cerrar",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "Su navegador no es compatible con WebGL",
    "gui.webglModal.description": "Lamentablemente, parece que su navegador o computadora {webGlLink}. Esta tecnología es necesaria para ejecutar Scratch 3.0.",
    "gui.webglModal.webgllink": "no es compatible con WebGL",
    "gui.webglModal.back": "Regresar",
    "gui.webglModal.previewfaq": "Para obtener más información, vaya a {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Preguntas frecuentes (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "Escoger un fondo",
    "gui.costumeLibrary.chooseACostume": "Escoger un disfraz",
    "gui.costumeTab.addBackdropFromLibrary": "Escoger un fondo",
    "gui.costumeTab.addCostumeFromLibrary": "Escoger un disfraz",
    "gui.costumeTab.addBlankCostume": "Pintar",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Subir fondo",
    "gui.costumeTab.addFileCostume": "Subir disfraz",
    "gui.extensionLibrary.chooseAnExtension": "Eligir una extensión",
    "gui.extensionLibrary.extensionUrl": "Ingrese la URL de la extensión",
    "gui.monitors.importListColumnPrompt": "¿Qué columna debe usarse (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "No se pudo comenzar a grabar",
    "gui.soundLibrary.chooseASound": "Elige un sonido",
    "gui.soundTab.fileUploadSound": "Subir sonido",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Grabar",
    "gui.soundTab.addSoundFromLibrary": "Elige un sonido",
    "gui.spriteLibrary.chooseASprite": "Elige un objeto",
    "gui.tipsLibrary.tutorials": "Elige un tutorial",
    "gui.alerts.createsuccess": "Nuevo proyecto creado.",
    "gui.alerts.createcopysuccess": "Proyecto guardado como copia.",
    "gui.alerts.createremixsuccess": "Proyecto guardado como reinvención.",
    "gui.alerts.creating": "Creando nuevo...",
    "gui.alerts.creatingCopy": "Copiando proyecto...",
    "gui.alerts.creatingRemix": "Reinventando proyecto...",
    "gui.alerts.creatingError": "No pudimos crear el proyecto. ¡Por favor, inténtalo de nuevo!",
    "gui.alerts.savingError": "El proyecto no se pudo guardar.",
    "gui.alerts.savesuccess": "Proyecto guardado.",
    "gui.alerts.saving": "Guardando proyecto...",
    "gui.alerts.cloudInfo": "Tenga en cuenta que las variables de la nube solo admiten números, no letras ni símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Aprende más.",
    "gui.alerts.importing": "Importando...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "mi variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Cómo comenzar",
    "gui.howtos.intro-move.step_stepMove": "Agrega un bloque de movimiento",
    "gui.howtos.add-a-move-block.step_stepSay": "Añadir un bloque decir",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Haz clic en la bandera verde para empezar",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Anima un nombre",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Escoge un objeto de letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Inicia el sonido con un clic",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Escoge otro objeto de letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambia el color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Escoge otro objeto de letra & hazla girar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Escoge otro objeto de letra & hazla girar",
    "gui.howtos.imagine": "Imagina un mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Escribe lo que quieres decir",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Haz clic en la bandera verde para comenzar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Escoge cualquier fondo",
    "gui.howtos.imagine.step_imagineChooseSprite": "Escoge un objeto",
    "gui.howtos.imagine.step_imagineFlyAround": "Presiona la barra espaciadora para deslizar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Escoge otro objeto",
    "gui.howtos.imagine.step_imagineLeftRight": "Mueve a la izquierda y a la derecha",
    "gui.howtos.imagine.step_imagineUpDown": "Mueve arriba y abajo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Cambia de disfraz",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Desliza a un punto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Hazlo crecer y encogerse",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Escoge otro fondo",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cambia de fondo",
    "gui.howtos.imagine.step_imagineRecordASound": "Añade un sonido",
    "gui.howtos.imagine.step_imagineChooseSound": "Escoge un sonido",
    "gui.howtos.make-music.name": "Crea música",
    "gui.howtos.Make-Music.step_PickInstrument": "Escoge un objeto de instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Inicia el sonido con un clic",
    "gui.howtos.Make-Music.step_MakeSong": "Crea una canción",
    "gui.howtos.make-music.step_MakeBeat": "Escoge un tambor & crea un ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Escoge el objeto de micrófono y crea un beatbox sorpresa",
    "gui.howtos.story.name": "Crea una historia",
    "gui.howtos.story.step_addbg": "Agrega un Fondo",
    "gui.howtos.story.step_addsprite": "Agrega un personaje",
    "gui.howtos.story.step_saysomething": "Di algo",
    "gui.howtos.story.step_addanothersprite": "Agrega otro personaje",
    "gui.howtos.story.step_flip": "Cambia de dirección",
    "gui.howtos.story.step_conversation": "Ten una conversación",
    "gui.howtos.story.addanotherbg": "Agrega otro fondo",
    "gui.howtos.story.step_swithbg": "Cambia de fondo",
    "gui.howtos.story.step_hidewizard": "Esconde un personaje",
    "gui.howtos.story.step_showwizard": "Muestra un personaje",
    "gui.howtos.make-a-chase-game.name": "Haz un juego de perseguir",
    "gui.howtos.Chase-Game.step_BG": "Agrega un dondo",
    "gui.howtos.chase-game.step_AddOcto": "Añade un objeto",
    "gui.howtos.make-music.step_LeftRight": "Muévete a la derecha y a la izquierda con las teclas de flecha",
    "gui.howtos.Chase-Game.step_UpDown": "Muévete hacia arriba y abajo con las teclas de flecha",
    "gui.howtos.Chase-Game.step_AddStar": "Agrega otro objeto",
    "gui.howtos.Chase-Game.step_MoveRandom": "Muévelo de manera aleatoria",
    "gui.howtos.Chase-Game.step_WhenTouch": "En el objeto del pulpo, haz un sonido cuando lo toques",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crear una variable para el puntaje",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En el objeto del pulpo, cuando lo tocas agrega puntos",
    "gui.howtos.animate-char.name": "Anima un personaje",
    "gui.howtos.animate-char.step_addbg": "Agrega un fondo",
    "gui.howtos.animate-char.step_addsprite": "Agrega un objeto",
    "gui.howtos.animate-char.step_saysomething": "Decir algo",
    "gui.howtos.animate-char.step_addsound": "Añade un sonido",
    "gui.howtos.animate-char.step_animatetalking": "Anima la boca del personaje",
    "gui.howtos.animate-char.step_arrowkeys": "Muévete usando las flechas",
    "gui.howtos.animate-char.step_jump": "Salta",
    "gui.howtos.animate-char.step_changecolor": "Cambiar color",
    "gui.howtos.make-a-game.name": "Haz un juego de cliquear",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Escoge un objeto",
    "gui.howtos.make-a-game.step_GamePlaySound": "Inicia el sonido con un click",
    "gui.howtos.make-a-game.step_GameAddScore": "Crea una variable de resultado",
    "gui.howtos.make-a-game.step_GameChangeScore": "Con un clic incrementa el puntaje",
    "gui.howtos.make-a-game.step_Random": "Ir a una posición aleatoria",
    "gui.howtos.make-music.step_GameChangeColor": "Cambia de color",
    "gui.howtos.make-music.step_ResetScore": "Reinicia el puntaje",
    "gui.howtos.make-it-fly.name": "Hazlo volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Escoge un fondo para el cielo",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Escoge un personaje",
    "gui.howtos.fly.step_stepflySaySomething": "Di algo",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Muévelo con las flechas",
    "gui.howtos.fly.step_stepflyChooseObject": "Escoge un objeto a recoger",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Haz que el objeto se mueva",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Escoge tu personaje",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Añade un puntaje",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Registra el puntaje",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Agrega escenografía",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mueve la escenografía",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Siguiente disfraz",
    "gui.howtos.pong": "Juego de Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Agrega un fondo",
    "gui.howtos.pong.step_pongAddBallSprite": "Agrega una bola",
    "gui.howtos.pong.step_pongBounceAround": "Rebota",
    "gui.howtos.pong.step_pongAddPaddle": "Agrega una paleta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mueve la paleta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Escoge el objeto de la pelota",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Agrega código para que la pelota rebote en la paleta",
    "gui.howtos.pong.step_pongAddAScore": "Añade un puntaje",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Escoge \"puntaje\" en el menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Inserta el bloque \"cambiar puntaje\"",
    "gui.howtos.pong.step_pongResetScore": "Reinicia el puntaje",
    "gui.howtos.pong.step_pongAddLineSprite": "Agrega una línea",
    "gui.howtos.pong.step_pongGameOver": "Juego terminado",
    "gui.howtos.code-cartoon": "Programa una caricatura",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Di algo al hacer clic en la bandera verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anima a un personaje al hacerle clic",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selecciona otro personaje",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usa un signo menos para hacerlo más pequeño",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Haz que un personaje se agrande o se achique",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selecciona otro personaje",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Salta arriba y abajo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Haz clic en un personaje para cambiar de escena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Desliza alrededor",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Cambia de disfraz",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Escoge más personajes para añadir a tu caricatura",
    "gui.howtos.cartoon-network": "Anima un juego de aventura",
    "gui.howtos.cartoon-network.step_CNcharacter": "Elige un personaje para mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Di algo",
    "gui.howtos.cartoon-network.step_CNglide": "Desliza alrededor",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Elige un objeto que perseguir",
    "gui.howtos.cartoon-network.step_CNcollect": "Colecciona objetos",
    "gui.howtos.cartoon-network.step_CNvariable": "Crea una variable para el puntaje",
    "gui.howtos.cartoon-network.step_CNscore": "Registra el puntaje",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Siguiente nivel: Cambia el fondo",
    "gui.howtos.videosens.name": "Sensor de video",
    "gui.howtos.videosens.step_addextension": "Agregar Extensión",
    "gui.howtos.videosens.step_pet": "Acaricia al gato",
    "gui.howtos.videosens.step_animate": "Anima",
    "gui.howtos.videosens.step_pop": "Haz estallar un globo",
    "gui.howtos.say-it-out-loud": "Crea animaciones que hablen",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Agrega bloques de Texto a Voz",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Di algo",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Escoge una voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Muévelo alrededor",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Agrega un fondo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Agrega otro personaje",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Interpreta una canción",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambia de color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Da vueltas",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Hazlo crecer y encogerse",
    "gui.howtos.talking": "Cuentos que hablan",
    "gui.howtos.talking.step_talesAddExtension": "Haz clic para agregar los bloques de texto a voz",
    "gui.howtos.talking.step_talesChooseSprite": "Elegir un objeto",
    "gui.howtos.talking.step_talesSaySomething": "Haz que un personaje hable",
    "gui.howtos.talking.step_talesChooseBackdrop": "Escoger un fondo",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Haz clic en un personaje para ir al fondo siguiente",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Escoge otro objeto",
    "gui.howtos.talking.step_talesMoveAround": "Muévelo alrededor",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Escoge otro fondo",
    "gui.howtos.talking.step_talesAnimateTalking": "Anima la boca del personaje",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Escoge otro fondo",
    "gui.howtos.talking.step_talesChooseSound": "Escoge una canción para bailar",
    "gui.howtos.talking.step_talesDanceMoves": "Pasos de baile",
    "gui.howtos.talking.step_talesAskAnswer": "Toma los bloques de pregunta y respuesta en la categoría Sensores",
    "gui.howtos.add-sprite.name": "Agrega un Objeto",
    "gui.howtos.add-sprite.step_addSprite": "Agrega un Objeto",
    "gui.howtos.add-a-backdrop.name": "Agrega un Fondo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Agrega un fondo",
    "gui.howtos.change-size.name": "Cambiar tamaño",
    "gui.howtos.change-size.step_changeSize": "Cambiar tamaño",
    "gui.howtos.glide-around.name": "Deslizar alrededor",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Desliza alrededor",
    "gui.howtos.change-size.step_glideAroundPoint": "Desliza a un punto",
    "gui.howtos.record-a-sound.name": "Grabar un sonido",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Haz clic en la pestaña \"Sonidos\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Haz clic en \"Grabar\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Presiona el botón de Grabar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Escoge un sonido",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Reproduce el sonido",
    "gui.howtos.spin-video.name": "Hazlo girar",
    "gui.howtos.change-size.step_spinTurn": "Gira",
    "gui.howtos.change-size.step_spinPointInDirection": "Fija una dirección",
    "gui.howtos.hide-and-show.name": "Ocultar y mostrar",
    "gui.howtos.change-size.step_hideAndShow": "Ocultar y mostrar",
    "gui.howtos.switch-costume.name": "Anima un objeto",
    "gui.howtos.change-size.step_switchCostumes": "Anima un objeto",
    "gui.howtos.move-around-with-arrow-keys.name": "Usar las flechas",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Muévete a la izquierda y a la derecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Muévete arriba y abajo",
    "gui.howtos.add-effects.name": "Añade efectos",
    "gui.howtos.videosens.step_addEffects": "Añade efectos",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toca instrumentos y tambores.",
    "gui.extension.pen.name": "Lápiz",
    "gui.extension.pen.description": "Dibuja con tus objetos.",
    "gui.extension.videosensing.name": "Sensor de video",
    "gui.extension.videosensing.description": "Detecta movimiento con tu cámara",
    "gui.extension.text2speech.name": "Texto a Voz",
    "gui.extension.text2speech.description": "Haz que tu proyecto hable.",
    "gui.extension.translate.name": "Traductor",
    "gui.extension.translate.description": "Traduce texto a muchos lenguajes.",
    "gui.extension.makeymakey.description": "Haz que cualquier cosa sea una tecla.",
    "gui.extension.microbit.description": "Conecta tus proyectos con el mundo.",
    "gui.extension.microbit.connectingMessage": "Conectando",
    "gui.extension.ev3.description": "Construye robots interactivos y más.",
    "gui.extension.ev3.connectingMessage": "Conectando. Asegúrate que el pin en tu EV3 sea 1234.",
    "gui.extension.boost.description": "Dale vida a tus creaciones robóticas.",
    "gui.extension.boost.connectingMessage": "Conectando",
    "gui.extension.wedo2.description": "Construye con motores y sensores.",
    "gui.extension.wedo2.connectingMessage": "Conectando",
    "gui.extension.gdxfor.description": "Sensores de empuje, movimiento y giro.",
    "gui.extension.gdxfor.connectingMessage": "Conectando",
    "gui.libraryTags.all": "Todos",
    "gui.libraryTags.animals": "Animales",
    "gui.libraryTags.dance": "Bailes",
    "gui.libraryTags.effects": "Efectos",
    "gui.libraryTags.fantasy": "Fantasía",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Alimento",
    "gui.libraryTags.indoors": "Interiores",
    "gui.libraryTags.loops": "Ciclos",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exteriores",
    "gui.libraryTags.patterns": "Patrones",
    "gui.libraryTags.people": "Gente",
    "gui.libraryTags.percussion": "Percusión",
    "gui.libraryTags.space": "Espacio",
    "gui.libraryTags.sports": "Deportes",
    "gui.libraryTags.underwater": "Bajo el mar",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Loco",
    "gui.libraryTags.animation": "Animación",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Juegos",
    "gui.libraryTags.stories": "Historias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "dirección",
    "gui.opcodeLabels.xposition": "posición x",
    "gui.opcodeLabels.yposition": "posición y",
    "gui.opcodeLabels.size": "tamaño",
    "gui.opcodeLabels.costumename": "nombre del disfraz",
    "gui.opcodeLabels.costumenumber": "número de disfraz",
    "gui.opcodeLabels.backdropname": "nombre de fondo",
    "gui.opcodeLabels.backdropnumber": "número de fondo",
    "gui.opcodeLabels.volume": "volumen",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "respuesta",
    "gui.opcodeLabels.loudness": "volumen del sonido",
    "gui.opcodeLabels.username": "nombre de usuario",
    "gui.opcodeLabels.year": "año",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "fecha",
    "gui.opcodeLabels.dayofweek": "día de la semana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronómetro",
    "gui.projectLoader.loadError": "El archivo de proyecto seleccionado falló al cargar.",
    "gui.sharedMessages.backdrop": "fondo{index}",
    "gui.sharedMessages.costume": "disfraz{index}",
    "gui.sharedMessages.sprite": "Objeto{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "¿Reemplazar el contenido del proyecto actual?",
    "gui.sharedMessages.loadFromComputerTitle": "Subir desde tu computador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proyecto Scratch",
    "boost.color.any": "de cualquier color",
    "boost.color.black": "negra",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "roja",
    "boost.color.white": "blanca",
    "boost.color.yellow": "amarilla",
    "boost.getMotorPosition": "posición de motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "ángulo de inclinación hacia [TILT_DIRECTION]",
    "boost.motorDirection.backward": "allá",
    "boost.motorDirection.forward": "acá",
    "boost.motorDirection.reverse": "reversa",
    "boost.motorOff": "apagar motor [MOTOR_ID]",
    "boost.motorOn": "encender motor [MOTOR_ID]",
    "boost.motorOnFor": "girar motor [MOTOR_ID] durante [DURATION] segundos",
    "boost.motorOnForRotation": "girar motor [MOTOR_ID] por [ROTATION] vueltas",
    "boost.seeingColor": "¿viendo pieza [COLOR]?",
    "boost.setLightHue": "fijar color de luz a [HUE]",
    "boost.setMotorDirection": "fijar dirección de motor [MOTOR_ID] hacia [MOTOR_DIRECTION]",
    "boost.setMotorPower": "fijar velocidad del motor [MOTOR_ID] a [POWER] %",
    "boost.tiltDirection.any": "cualquier dirección",
    "boost.tiltDirection.down": "abajo",
    "boost.tiltDirection.left": "izquierda",
    "boost.tiltDirection.right": "derecha",
    "boost.tiltDirection.up": "arriba",
    "boost.whenColor": "cuando vea pieza [COLOR]",
    "boost.whenTilted": "al inclinar hacia [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tocar nota [NOTE] durante [TIME] segundos",
    "ev3.buttonPressed": "¿botón [PORT] presionado?",
    "ev3.getBrightness": "brillo",
    "ev3.getDistance": "distancia",
    "ev3.getMotorPosition": "posición del motor [PORT] ",
    "ev3.motorSetPower": "fijar potencia de motor [PORT] a [POWER]%",
    "ev3.motorTurnClockwise": "girar motor [PORT] hacia acá durante [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "girar motor [PORT] hacia allá durante [TIME] segundos",
    "ev3.whenBrightnessLessThan": "cuando brillo < [DISTANCE]",
    "ev3.whenButtonPressed": "al presionar botón [PORT]",
    "ev3.whenDistanceLessThan": "cuando distancia < [DISTANCE]",
    "gdxfor.getAcceleration": "aceleración [DIRECTION]",
    "gdxfor.getForce": "fuerza",
    "gdxfor.getSpin": " velocidad de giro [DIRECTION]",
    "gdxfor.getTilt": "ángulo de inclinación hacia [TILT]",
    "gdxfor.isFreeFalling": "¿cayendo?",
    "gdxfor.isTilted": "¿inclinado hacia [TILT]?",
    "gdxfor.pulled": "tirado",
    "gdxfor.pushed": "empujado",
    "gdxfor.shaken": "agitar",
    "gdxfor.startedFalling": "comenzar a caer",
    "gdxfor.tiltDirectionMenu.any": "cualquier dirección",
    "gdxfor.tiltDirectionMenu.back": "atrás",
    "gdxfor.tiltDirectionMenu.front": "adelante",
    "gdxfor.tiltDirectionMenu.left": "la izquierda",
    "gdxfor.tiltDirectionMenu.right": "la derecha",
    "gdxfor.turnedFaceDown": "estar hacia abajo",
    "gdxfor.turnedFaceUp": "estar hacia arriba",
    "gdxfor.whenForcePushedOrPulled": "cuando el sensor de fuerza es [PUSH_PULL]",
    "gdxfor.whenGesture": "al [GESTURE]",
    "gdxfor.whenTilted": "al inclinarse hacia [TILT]",
    "makeymakey.downArrow": "flecha abajo",
    "makeymakey.downArrowShort": "abajo",
    "makeymakey.leftArrow": "flecha izquierda",
    "makeymakey.leftArrowShort": "izquierda",
    "makeymakey.rightArrow": "flecha derecha",
    "makeymakey.rightArrowShort": "derecha",
    "makeymakey.spaceKey": "espacio",
    "makeymakey.upArrow": "flecha arriba",
    "makeymakey.upArrowShort": "arriba",
    "makeymakey.whenKeyPressed": "al presionar la tecla [KEY]",
    "makeymakey.whenKeysPressedInOrder": "al presionar en orden [SEQUENCE] ",
    "microbit.buttonsMenu.any": "cualquiera",
    "microbit.clearDisplay": "limpiar pantalla",
    "microbit.defaultTextToDisplay": "¡Hola!",
    "microbit.displaySymbol": "mostrar [MATRIX]",
    "microbit.displayText": "mostrar texto [TEXT]",
    "microbit.gesturesMenu.jumped": "saltar",
    "microbit.gesturesMenu.moved": "mover",
    "microbit.gesturesMenu.shaken": "agitar",
    "microbit.isButtonPressed": "¿botón [BTN] presionado?",
    "microbit.isTilted": "¿inclinado hacia [DIRECTION]?",
    "microbit.pinStateMenu.off": "apagado",
    "microbit.pinStateMenu.on": "encendido",
    "microbit.tiltAngle": "ángulo de inclinación hacia [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "cualquier dirección",
    "microbit.tiltDirectionMenu.back": "atrás",
    "microbit.tiltDirectionMenu.front": "delante",
    "microbit.tiltDirectionMenu.left": "izquierda",
    "microbit.tiltDirectionMenu.right": "derecha",
    "microbit.whenButtonPressed": "al presionar botón [BTN]",
    "microbit.whenGesture": "al [GESTURE]",
    "microbit.whenPinConnected": "al conectar pin [PIN]",
    "microbit.whenTilted": "al inclinar [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "cambiar el tempo en [TEMPO]",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongó",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charles Cerrado",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cencerro",
    "music.drumCrashCymbal": "(4) Platillo Crash",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Aplauso",
    "music.drumOpenHiHat": "(5) Charles abierto",
    "music.drumSideStick": "(3) Golpe lateral",
    "music.drumSnare": "(1) Caja",
    "music.drumTambourine": "(7) Pandereta",
    "music.drumTriangle": "(12) Triángulo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Caja china",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bajo",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violonchelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra Eléctrica",
    "music.instrumentElectricPiano": "(2) Piano Eléctrico",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caja de música",
    "music.instrumentOrgan": "(3) Órgano",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Tambor metálico",
    "music.instrumentSynthLead": "(20) Sintetizador melódico",
    "music.instrumentSynthPad": "(21) Sintetizador de fondo",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibráfono",
    "music.instrumentWoodenFlute": "(13) Flauta de Madera",
    "music.midiPlayDrumForBeats": "tocar tambor [DRUM] durante [BEATS] tiempos",
    "music.midiSetInstrument": "fijar instrumento a [INSTRUMENT]",
    "music.playDrumForBeats": "tocar tambor [DRUM] durante [BEATS] tiempos",
    "music.playNoteForBeats": "tocar nota [NOTE] durante [BEATS] tiempos",
    "music.restForBeats": "silenciar durante [BEATS] tiempos",
    "music.setInstrument": "fijar instrumento a [INSTRUMENT]",
    "music.setTempo": "fijar tempo a [TEMPO]",
    "pen.categoryName": "Lápiz",
    "pen.changeColorParam": "cambiar [COLOR_PARAM] de lápiz en [VALUE]",
    "pen.changeHue": "cambiar color de lápiz en [HUE]",
    "pen.changeShade": "cambiar sombra de lápiz en [SHADE]",
    "pen.changeSize": "cambiar tamaño de lápiz en [SIZE]",
    "pen.clear": "borrar todo",
    "pen.colorMenu.brightness": "brillo",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "transparencia",
    "pen.penDown": "bajar lápiz",
    "pen.penUp": "subir lápiz",
    "pen.setColor": "fijar color de lápiz a [COLOR]",
    "pen.setColorParam": "fijar [COLOR_PARAM] de lápiz a [VALUE]",
    "pen.setHue": "fijar color de lápiz a [HUE]",
    "pen.setShade": "fijar sombra de lápiz a [SHADE]",
    "pen.setSize": "fijar tamaño de lápiz a [SIZE]",
    "pen.stamp": "sellar",
    "speech.defaultWhenIHearValue": "vamos",
    "speech.extensionName": "Voz a texto",
    "speech.listenAndWait": "escuchar y esperar",
    "speech.speechReporter": "voz",
    "speech.whenIHear": "al escuchar [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Texto a Voz",
    "text2speech.defaultTextToSpeak": "hola",
    "text2speech.giant": "gigante",
    "text2speech.kitten": "gatito",
    "text2speech.setLanguageBlock": "fijar idioma a [LANGUAGE]",
    "text2speech.setVoiceBlock": "fijar voz a [VOICE]",
    "text2speech.speakAndWaitBlock": "decir [WORDS]",
    "text2speech.squeak": "chillido",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducir",
    "translate.defaultTextToTranslate": "hola",
    "translate.translateBlock": "traducir [WORDS] al [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Sensor de video",
    "videoSensing.direction": "dirección",
    "videoSensing.motion": "movimiento",
    "videoSensing.off": "apagar",
    "videoSensing.on": "encender",
    "videoSensing.onFlipped": "invertir",
    "videoSensing.setVideoTransparency": "fijar transparencia de video a [TRANSPARENCY]",
    "videoSensing.sprite": "objeto",
    "videoSensing.stage": "escenario",
    "videoSensing.videoOn": "[ATTRIBUTE] del video en [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] video",
    "videoSensing.whenMotionGreaterThan": "cuando el movimiento del video > [REFERENCE]",
    "wedo2.getDistance": "distancia",
    "wedo2.getTiltAngle": "ángulo de inclinación hacia [TILT_DIRECTION]",
    "wedo2.isTilted": "¿inclinado hacia [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "allá",
    "wedo2.motorDirection.forward": "acá",
    "wedo2.motorDirection.reverse": "reversa",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "todos los motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "apagar [MOTOR_ID]",
    "wedo2.motorOn": "encender [MOTOR_ID]",
    "wedo2.motorOnFor": "encender [MOTOR_ID] durante [DURATION] segundos",
    "wedo2.playNoteFor": "tocar nota [NOTE] durante [DURATION] segundos",
    "wedo2.setLightHue": "fijar color de la luz a [HUE]",
    "wedo2.setMotorDirection": "fijar dirección de [MOTOR_ID] hacia [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "fijar potencia de [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "cualquier dirección",
    "wedo2.tiltDirection.down": "abajo",
    "wedo2.tiltDirection.left": "izquierda",
    "wedo2.tiltDirection.right": "derecha",
    "wedo2.tiltDirection.up": "arriba",
    "wedo2.whenDistance": "cuando distancia [OP] [REFERENCE]",
    "wedo2.whenTilted": "al inclinar hacia [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "Brillo",
    "paint.paintEditor.costume": "Disfraz",
    "paint.paintEditor.group": "Agrupar",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Deshacer",
    "paint.paintEditor.redo": "Rehacer",
    "paint.paintEditor.forward": "Adelante",
    "paint.paintEditor.backward": "Atrás",
    "paint.paintEditor.front": "Al frente",
    "paint.paintEditor.back": "Al fondo",
    "paint.paintEditor.more": "Más",
    "paint.modeTools.brushSize": "Tamaño",
    "paint.modeTools.eraserSize": "Tamaño del borrador",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Pegar",
    "paint.modeTools.delete": "Eliminar",
    "paint.modeTools.curved": "Curvo",
    "paint.modeTools.pointed": "Puntiagudo",
    "paint.modeTools.thickness": "Grosor",
    "paint.modeTools.flipHorizontal": "Voltear horizontal",
    "paint.modeTools.flipVertical": "Voltear vertical",
    "paint.modeTools.filled": "Relleno",
    "paint.modeTools.outlined": "Con contorno",
    "paint.paintEditor.bitmap": "Convertir a mapa de bits",
    "paint.paintEditor.vector": "Convertir a vector",
    "paint.paintEditor.fill": "Relleno",
    "paint.paintEditor.stroke": "Contorno",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Borrador",
    "paint.fillMode.fill": "Relleno",
    "paint.lineMode.line": "Línea",
    "paint.ovalMode.oval": "Círculo",
    "paint.rectMode.rect": "Rectángulo",
    "paint.reshapeMode.reshape": "Cambiar forma",
    "paint.roundedRectMode.roundedRect": "Rectángulo redondeado",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Intercambiar"
  },
  "eo": {
    "gui.alerts.lostPeripheralConnection": "Scratch perdis sian konekton al {extensionName}.",
    "gui.alerts.tryAgain": "Reprovi",
    "gui.alerts.download": "Elŝuti",
    "gui.connection.reconnect": "Rekonekti",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Dorsosako",
    "gui.backpack.errorBackpack": "Eraro dum malfermo de dorsosako",
    "gui.backpack.loadingBackpack": "Ŝargado...",
    "gui.backpack.more": "Pli",
    "gui.backpack.emptyBackpack": "Dorsosako estas malplena",
    "gui.unsupportedBrowser.label": "Scratch ne funkcias kun via TTT-legilo",
    "gui.unsupportedBrowser.errorLabel": "Okazis eraro",
    "gui.unsupportedBrowser.notRecommended": "Bedaŭrinde vi ŝajne uzas retumilon, kiu ne funkcias kun Scratch. Ni rekomendas uzi lastatempan version de retumilo kiel Google Chrome, Mozilla Firefox, Microsoft Edge aŭ Apple Safari.",
    "gui.unsupportedBrowser.description": "Ni bedaŭras sed Scratch ne funkcias kun via retumilo. Ni rekomendas lastatempan version de Google Chrome, Mozilla Firefox, Microsoft Edge aŭ Apple Safari.",
    "gui.unsupportedBrowser.back": "Reen",
    "gui.unsupportedBrowser.previewfaq": "Por lerni pli, iru al la {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Demandaro",
    "gui.cards.all-tutorials": "Instruilo",
    "gui.cards.shrink": "Malgrandigi",
    "gui.cards.expand": "Vidigi",
    "gui.cards.close": "Fermi",
    "gui.cards.more-things-to-try": "Aliaj aferoj por provi!",
    "gui.cards.see-more": "Vidi pli",
    "gui.comingSoon.message1": "Ne zorgu, ni baldaŭ okupiĝos pri tio {emoji}",
    "gui.comingSoon.message2": "Venos baldaŭ...",
    "gui.comingSoon.message3": "Ni laboras pri tio {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Neniu aparato trovita",
    "gui.connection.auto-scanning.prescan": "Alproksimigu vian aparaton, kaj ekigi la serĉon.",
    "gui.connection.auto-scanning.pressbutton": "Tuŝu la butonon sur via aparato.",
    "gui.connection.auto-scanning.start-search": "Komenci serĉi",
    "gui.connection.connecting-searchbutton": "Serĉado...",
    "gui.connection.auto-scanning.try-again": "Reprovi",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Konektita",
    "gui.connection.disconnect": "Malkonekti",
    "gui.connection.go-to-editor": "Iri al Redaktilo",
    "gui.connection.connecting-cancelbutton": "Konektado...",
    "gui.connection.error.errorMessage": "Ups, ŝajne okazis ia eraro.",
    "gui.connection.error.tryagainbutton": "Reprovi",
    "gui.connection.error.helpbutton": "Helpo",
    "gui.connection.peripheral-name-label": "Nomo de aparato",
    "gui.connection.connect": "Konekti",
    "gui.connection.scanning.lookingforperipherals": "Serĉado por aparatoj...",
    "gui.connection.scanning.noPeripheralsFound": "Neniu aparato trovita",
    "gui.connection.scanning.instructions": "Elektu vian aparaton el la ĉi-supra listo.",
    "gui.connection.search": "Re-serĉi",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Kontrolu, ke Scratch Link estas instalita kaj aktuale funkcias",
    "gui.connection.unavailable.enablebluetooth": "Kontrolu, ke Bluetooth estas ŝaltita",
    "gui.connection.unavailable.tryagainbutton": "Reprovi",
    "gui.connection.unavailable.helpbutton": "Helpo",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ek!",
    "gui.controls.stop": "Halti",
    "gui.crashMessage.label": "Ups! Eraro okazis.",
    "gui.crashMessage.description": "Bedaŭrinde, ŝajnas ke Scratch kraŝis. La teamo de Scratch jam ricevis aŭtomatan raporton pri tio. Provu reŝargi la paĝon nun.",
    "gui.crashMessage.errorNumber": "Via eraro estas registrita kun la ID {errorId}",
    "gui.crashMessage.reload": "Reŝargi",
    "gui.customProcedures.myblockModalTitle": "Krei blokon",
    "gui.customProcedures.addAnInputNumberText": "Aldoni enigon",
    "gui.customProcedures.numberTextType": "numero aŭ teksto",
    "gui.customProcedures.addAnInputBoolean": "Aldoni enigon",
    "gui.customProcedures.booleanType": "bulea",
    "gui.customProcedures.addALabel": "Aldoni etikedon",
    "gui.customProcedures.runWithoutScreenRefresh": "Rulumi sen redesegni la ekranon",
    "gui.customProcedures.cancel": "Rezigni",
    "gui.customProcedures.ok": "Bone",
    "gui.SpriteInfo.direction": "Direkto",
    "gui.directionPicker.rotationStyles.allAround": "turniĝi libere",
    "gui.directionPicker.rotationStyles.leftRight": "nur dekstre-maldekstre",
    "gui.directionPicker.rotationStyles.dontRotate": "ne turniĝi",
    "gui.gui.addExtension": "Aldoni kromaĵon",
    "gui.gui.codeTab": "Skriptoj",
    "gui.gui.backdropsTab": "Fonoj",
    "gui.gui.costumesTab": "Kostumoj",
    "gui.gui.soundsTab": "Sonoj",
    "gui.extensionLibrary.comingSoon": "Baldaŭ venos",
    "gui.extensionLibrary.requires": "Bezonas",
    "gui.extensionLibrary.collaboration": "Kunlaboro kun",
    "gui.library.filterPlaceholder": "Serĉi",
    "gui.library.allTag": "Ĉion",
    "gui.loader.message1": "Kreado de blokoj...",
    "gui.loader.message2": "Ŝargado de roluloj...",
    "gui.loader.message3": "Ŝargado de sonoj...",
    "gui.loader.message4": "Ŝargado de kromprogramoj..",
    "gui.loader.message5": "Grupigado de katidoj...",
    "gui.loader.message6": "Serĉado de Nano...",
    "gui.loader.message7": "Ordigado de Gobooj...",
    "gui.loader.message8": "Preparado de emoĝioj...",
    "gui.loader.headline": "Ŝargado de projekto",
    "gui.loader.creating": "Kreado de projekto",
    "gui.accountMenu.profile": "Profilo",
    "gui.accountMenu.myStuff": "Miaj Aferoj",
    "gui.accountMenu.myClasses": "Miaj klasoj",
    "gui.accountMenu.myClass": "Mia klaso",
    "gui.accountMenu.accountSettings": "Agordoj de via konto",
    "gui.accountMenu.signOut": "Elsaluti",
    "gui.authorInfo.byUser": "de {username}",
    "gui.menuBar.seeProjectPage": "Vidi projektan paĝon",
    "gui.menuBar.language": "Language",
    "general.username": "Salutnomo",
    "general.password": "Pasvorto",
    "general.signIn": "Ensaluti",
    "login.needHelp": "Ĉu vi bezonas helpon?",
    "form.validationRequired": "Tiu ĉi kampo estas deviga",
    "gui.menuBar.tutorialsLibrary": "Instruilo",
    "gui.menuBar.restoreSprite": "Malfari forigon de rolulo",
    "gui.menuBar.restoreSound": "Malfari forigon de sono",
    "gui.menuBar.restoreCostume": "Malfari forigon de kostumo",
    "gui.menuBar.restore": "Malfari forigon",
    "gui.menuBar.saveNow": "Konservi nun",
    "gui.menuBar.saveAsCopy": "Konservi kiel kopion",
    "gui.menuBar.remix": "Remiksi",
    "gui.menuBar.new": "Nova",
    "gui.menuBar.file": "Dosiero",
    "gui.menuBar.downloadToComputer": "Konservi ĉe via komputilo",
    "gui.menuBar.edit": "Redakti",
    "gui.menuBar.turboModeOff": "Malŝalti turbinan reĝimon",
    "gui.menuBar.turboModeOn": "Ŝalti turbinan reĝimon",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Krei Scratch-konton",
    "gui.menuBar.signIn": "Ensaluti",
    "gui.gui.projectTitlePlaceholder": "Sentitola projekto",
    "gui.menuBar.saveNowLink": "Konservi nun",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Kunhavigita",
    "gui.menuBar.share": "Kunhavigi",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Helpo",
    "gui.modal.back": "Reen",
    "gui.monitor.listMonitor.empty": "(malplena)",
    "gui.monitor.listMonitor.listLength": "longo {length}",
    "gui.monitor.contextMenu.default": "kutima montrilo",
    "gui.monitor.contextMenu.large": "granda indikilo",
    "gui.monitor.contextMenu.slider": "ŝovilo",
    "gui.monitor.contextMenu.sliderRange": "ŝanĝi amplekson de ŝovilo",
    "gui.monitor.contextMenu.import": "importi",
    "gui.monitor.contextMenu.export": "eksporti",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Aǔdigi",
    "gui.playButton.stop": "Halti",
    "gui.gui.variableScopeOptionAllSprites": "Por ĉiuj roluloj",
    "gui.gui.variableScopeOptionSpriteOnly": "Nur por tiu ĉi rolulo",
    "gui.gui.cloudVariableOption": "Ennuba variablo (stokita ĉe la servilo)",
    "gui.gui.variablePromptAllSpritesMessage": "Tiu ĉi variablo estos atingebla de ĉiu rolulo.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Rezigni",
    "gui.prompt.ok": "Bone",
    "gui.playbackStep.stopMsg": "Halti",
    "gui.playbackStep.playMsg": "Aǔdigi",
    "gui.playbackStep.loadingMsg": "Ŝargado...",
    "gui.playbackStep.saveMsg": "Konservi",
    "gui.playbackStep.reRecordMsg": "Re-registri",
    "gui.recordModal.title": "Registri sonon",
    "gui.recordingStep.beginRecord": "Komenci registri per la butono sube",
    "gui.recordingStep.permission": "{arrow} Ni bezonas vian permeson por uzi vian mikrofonon",
    "gui.recordingStep.stop": "Fini registri",
    "gui.recordingStep.record": "Registri",
    "gui.sliderModal.min": "Minimuma valoro",
    "gui.sliderModal.max": "Maksimuma valoro",
    "gui.sliderModal.title": "Ŝanĝi amplekson de ŝovilo",
    "gui.sliderPrompt.cancel": "Rezigni",
    "gui.sliderPrompt.ok": "Bone",
    "gui.soundEditor.sound": "Sono",
    "gui.soundEditor.play": "Aǔdigi",
    "gui.soundEditor.stop": "Halti",
    "gui.soundEditor.copy": "Kopii",
    "gui.soundEditor.paste": "Alglui",
    "gui.soundEditor.copyToNew": "Kopii al nova",
    "gui.soundEditor.delete": "Forigi",
    "gui.soundEditor.save": "Konservi",
    "gui.soundEditor.undo": "Malfari",
    "gui.soundEditor.redo": "Refari",
    "gui.soundEditor.faster": "Plirapidigi",
    "gui.soundEditor.slower": "Malplirapidigi",
    "gui.soundEditor.echo": "Eĥo",
    "gui.soundEditor.robot": "Roboto",
    "gui.soundEditor.louder": "Plilaŭtigi",
    "gui.soundEditor.softer": "Malplilaŭtigi",
    "gui.soundEditor.reverse": "Inversigi",
    "gui.soundEditor.fadeOut": "Poiome mallaŭtigi",
    "gui.soundEditor.fadeIn": "Poiome laŭtigi",
    "gui.soundEditor.mute": "Silentigi",
    "gui.SpriteInfo.spritePlaceholder": "Nomo",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Rolulo",
    "gui.SpriteInfo.show": "Montri",
    "gui.SpriteInfo.size": "Grandeco",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplikati",
    "gui.spriteSelectorItem.contextMenuExport": "eksporti",
    "gui.spriteSelectorItem.contextMenuDelete": "forigi",
    "gui.spriteSelector.addSpriteFromLibrary": "Elekti rolulon",
    "gui.spriteSelector.addSpriteFromPaint": "Desegni",
    "gui.spriteSelector.addSpriteFromSurprise": "Hazarda",
    "gui.spriteSelector.addSpriteFromFile": "Alŝuti rolulon",
    "gui.stageHeader.stageSizeLarge": "Ŝanĝi al granda scenejo",
    "gui.stageHeader.stageSizeSmall": "Ŝanĝi al malgranda scenejo",
    "gui.stageHeader.stageSizeFull": "Uzi plenan ekranon",
    "gui.stageHeader.stageSizeUnFull": "Ne uzi plenan ekranon",
    "gui.stageHeader.fullscreenControl": "Regilo de plenekrana reĝimo",
    "gui.spriteSelector.addBackdropFromLibrary": "Elekti scenejon",
    "gui.stageSelector.addBackdropFromPaint": "Desegni",
    "gui.stageSelector.addBackdropFromSurprise": "Hazarda",
    "gui.stageSelector.addBackdropFromFile": "Alŝuti scenejon",
    "gui.stageSelector.stage": "Scenejo",
    "gui.stageSelector.backdrops": "Fonoj",
    "gui.telemetryOptIn.label": "Raporti statistikojn por plibonigi Scratch",
    "gui.telemetryOptIn.body1": "La skipo de Scratch ĉiam volas pli bone kompreni kiel Scratch uziĝas ĉirkaŭ la mondo. Por helpi kun tio, vi povas permesi, ke Scratch resendu anonimajn informojn pri via uzo al la skipo de Scratch.",
    "gui.telemetryOptIn.body2": "La informoj kolektitaj estas ekzemple pri la lingvo, la blokoj uzitaj, kaj kelkaj eventoj kiel konservi, ŝargi, alŝuti, k.s. Ni NENIAM kolektas personajn informojn pri vi. Nia {privacyPolicyLink} enhavas pli da informoj pri tio. ",
    "gui.telemetryOptIn.privacyPolicyLink": "Privateca Politiko",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Rapidega Reĝimo",
    "gui.webglModal.label": "WebGL ne funkcias en via retumilo.",
    "gui.webglModal.description": "Bedaŭrinde ŝajnas, ke {webGlLink} en via komputilo aŭ retumilo. Tiu teknologio estas bezonata por funkciigi Scratch 3.0.",
    "gui.webglModal.webgllink": "mankas WebGL",
    "gui.webglModal.back": "Reen",
    "gui.webglModal.previewfaq": "Por lerni pli, iru al la {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Demandaro",
    "gui.costumeLibrary.chooseABackdrop": "Elekti scenejon",
    "gui.costumeLibrary.chooseACostume": "Elekti kostumon",
    "gui.costumeTab.addBackdropFromLibrary": "Elekti scenejon",
    "gui.costumeTab.addCostumeFromLibrary": "Elekti kostumon",
    "gui.costumeTab.addBlankCostume": "Desegni",
    "gui.costumeTab.addSurpriseCostume": "Hazarda",
    "gui.costumeTab.addFileBackdrop": "Alŝuti scenejon",
    "gui.costumeTab.addFileCostume": "Alŝuti kostumon",
    "gui.extensionLibrary.chooseAnExtension": "Elekti kromprogramon",
    "gui.extensionLibrary.extensionUrl": "Tajpu la URL-on de la kromprogramo",
    "gui.monitors.importListColumnPrompt": "Kiun kolumnon ni uzu? (inter 1 kaj {numberOfColumns})",
    "gui.recordingStep.alertMsg": "Ne eblis komenci registri",
    "gui.soundLibrary.chooseASound": "Elekti sonon",
    "gui.soundTab.fileUploadSound": "Alŝuti sonon",
    "gui.soundTab.surpriseSound": "Hazarda",
    "gui.soundTab.recordSound": "Registri",
    "gui.soundTab.addSoundFromLibrary": "Elekti sonon",
    "gui.spriteLibrary.chooseASprite": "Elekti rolulon",
    "gui.tipsLibrary.tutorials": "Elekti lernilon",
    "gui.alerts.createsuccess": "Nova projekto kreita.",
    "gui.alerts.createcopysuccess": "Projekto konservita kiel kopio",
    "gui.alerts.createremixsuccess": "Projekto konservita kiel remikso.",
    "gui.alerts.creating": "Kreado de nova...",
    "gui.alerts.creatingCopy": "Kopiado de projekto...",
    "gui.alerts.creatingRemix": "Remiksado de projekto...",
    "gui.alerts.creatingError": "Ne eblis krei la projekton. Bonvolu reprovi!",
    "gui.alerts.savingError": "Ne eblis konservi la projekton.",
    "gui.alerts.savesuccess": "Projekto konservita.",
    "gui.alerts.saving": "Konservado de projekto...",
    "gui.alerts.cloudInfo": "Notu, ke nuba variablo povas teni nur numeron, ne literojn nek simbolojn. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lerni pli pri tio.",
    "gui.alerts.importing": "Importado...",
    "gui.defaultProject.meow": "Miaŭ",
    "gui.defaultProject.variable": "mia variablo",
    "gui.howtos.intro-move-sayhello-hat.name": "Unuaj Paŝoj",
    "gui.howtos.intro-move.step_stepMove": "Aldoni blokon por movi",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animacii nomon",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Elekti litero-rolulon",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Aŭdigi sonon kiam alklakita",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Elekti alian litero-rolulon",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Ŝanĝi koloron",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Elekti alian liter-rolulon kaj turni ĝin",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Elekti alian liter-rolulon kaj pligrandigi ĝin",
    "gui.howtos.imagine": "Imagu alian mondon",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tajpi tion, kion vi volas diri",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Alklaku la verdan flagon por komenci",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Elekti iun ajn scenejon",
    "gui.howtos.imagine.step_imagineChooseSprite": "Elekti iun ajn rolulon",
    "gui.howtos.imagine.step_imagineFlyAround": "Tuŝi la spacoklavo por gliti",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Elekti alian rolulon",
    "gui.howtos.imagine.step_imagineLeftRight": "Moviĝi dekstren-maldekstren",
    "gui.howtos.imagine.step_imagineUpDown": "Moviĝi supren-malsupren",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Ŝanĝi kostumojn",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Gliti ĝis iu punkto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Pli- kaj malpli-grandiĝi",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Elekti alian scenejon",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Ŝanĝi la scenejon",
    "gui.howtos.imagine.step_imagineRecordASound": "Aldoni sonon",
    "gui.howtos.imagine.step_imagineChooseSound": "Elekti sonon",
    "gui.howtos.make-music.name": "Krei muzikon",
    "gui.howtos.Make-Music.step_PickInstrument": "Elekti instrument-rolulon",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Aŭdigi sonon kiam alklakita",
    "gui.howtos.Make-Music.step_MakeSong": "Krei kanton",
    "gui.howtos.make-music.step_MakeBeat": "Elekti tamburon kaj krei ritmon",
    "gui.howtos.make-music.step_MakeBeatBox": "Elekti la mikrofon-rolulon kaj krei surprizan sonmaŝinon",
    "gui.howtos.story.name": "Krei rakonton",
    "gui.howtos.story.step_addbg": "Aldoni scenejon",
    "gui.howtos.story.step_addsprite": "Aldoni rolulon",
    "gui.howtos.story.step_saysomething": "Diri ion",
    "gui.howtos.story.step_addanothersprite": "Aldoni alian rolulon",
    "gui.howtos.story.step_flip": "Inversigi direkton",
    "gui.howtos.story.step_conversation": "Fari konversacion",
    "gui.howtos.story.addanotherbg": "Aldoni plian fonon",
    "gui.howtos.story.step_swithbg": "Ŝanĝi la scenejon",
    "gui.howtos.story.step_hidewizard": "Kaŝi rolulon",
    "gui.howtos.story.step_showwizard": "Montri rolulon",
    "gui.howtos.make-a-chase-game.name": "Krei ĉas-ludon",
    "gui.howtos.Chase-Game.step_BG": "Aldoni scenejon",
    "gui.howtos.chase-game.step_AddOcto": "Aldoni rolulon",
    "gui.howtos.make-music.step_LeftRight": "Movi dekstren-maldekstren per la sagoklavoj",
    "gui.howtos.Chase-Game.step_UpDown": "Movi supren-malsupren per la sagoklavoj",
    "gui.howtos.Chase-Game.step_AddStar": "Aldoni plian rolulon",
    "gui.howtos.Chase-Game.step_MoveRandom": "Movi hazarde",
    "gui.howtos.Chase-Game.step_WhenTouch": "En la Polpo-rolulo, aŭdigi sonon kiam tuŝita",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Krei variablon \"Poentoj\"",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En la Polpo-rolulo, aldoni poenton kiam tuŝita",
    "gui.howtos.animate-char.name": "Krei animacion",
    "gui.howtos.animate-char.step_addbg": "Aldoni scenejon",
    "gui.howtos.animate-char.step_addsprite": "Aldoni rolulon",
    "gui.howtos.animate-char.step_saysomething": "Diri ion",
    "gui.howtos.animate-char.step_addsound": "Aldoni sonon",
    "gui.howtos.animate-char.step_animatetalking": "Parolanta animacio",
    "gui.howtos.animate-char.step_arrowkeys": "Movi per la sagoklavoj",
    "gui.howtos.animate-char.step_jump": "Salti",
    "gui.howtos.animate-char.step_changecolor": "Ŝanĝi koloron",
    "gui.howtos.make-a-game.name": "Krei Klak-ludon",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Elekti rolulon",
    "gui.howtos.make-a-game.step_GamePlaySound": "Aŭdigi sonon kiam alklakita",
    "gui.howtos.make-a-game.step_GameAddScore": "Krei variablon \"Poentoj\"",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kiam alklakita, aldoni poenton",
    "gui.howtos.make-a-game.step_Random": "Iri al hazarda loko",
    "gui.howtos.make-music.step_GameChangeColor": "Ŝanĝi koloron",
    "gui.howtos.make-music.step_ResetScore": "Nuligi poentojn",
    "gui.howtos.make-it-fly.name": "Flugigi ĝin",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Elekti ĉielan fonon",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Elekti rolulon",
    "gui.howtos.fly.step_stepflySaySomething": "Diri ion",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Movi per sagoklavoj",
    "gui.howtos.fly.step_stepflyChooseObject": "Elekti objekton por kolekti",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Movi la objekton",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Elekti vian rolulon",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Aldoni poentojn",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Registri poentojn",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Aldoni scenejon",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Movi la scenejon",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Sekva kostumo",
    "gui.howtos.pong": "Pong-ludo",
    "gui.howtos.pong.step_pongAddBackdrop": "Aldoni scenejon",
    "gui.howtos.pong.step_pongAddBallSprite": "Aldoni pilko-rolulon",
    "gui.howtos.pong.step_pongBounceAround": "Resalti ĉien",
    "gui.howtos.pong.step_pongAddPaddle": "Aldoni batilon",
    "gui.howtos.pong.step_pongMoveThePaddle": "Movi la batilon",
    "gui.howtos.pong.step_pongSelectBallSprite": "Elekti la pilko-rolulon",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Aldoni kodon por resaltigi la pilkon kontraŭ la batilo",
    "gui.howtos.pong.step_pongAddAScore": "Aldoni poentojn",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Elekti 'Poentoj'n el la menuo",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Eldoni la blokon 'Ŝanĝi poentojn'",
    "gui.howtos.pong.step_pongResetScore": "Nuligi poentojn",
    "gui.howtos.pong.step_pongAddLineSprite": "Aldoni la linio-rolulon",
    "gui.howtos.pong.step_pongGameOver": "FINO",
    "gui.howtos.code-cartoon": "Programi kartunon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Diri ion kiam vi alklakas la verdan flagon",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Lanĉi movadon kiam vi alklakas",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Elekti alian rolulon",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Uzi minus-signon por malpligrandigi",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Pli- kaj malpli-grandigi la rolulon",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Elekti alian rolulon",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Salti",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Alklaki rolulon por ŝanĝi la scenejon",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Gliti tien kaj reen",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Ŝanĝi kostumojn",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Elekti pli da roluloj por aldoni al via kartuno",
    "gui.howtos.cartoon-network": "Animaciigi aventuran ludon",
    "gui.howtos.cartoon-network.step_CNcharacter": "Elekti rolulon por montri",
    "gui.howtos.cartoon-network.step_CNsay": "Diri ion",
    "gui.howtos.cartoon-network.step_CNglide": "Gliti tien kaj reen",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Elekti objekton por postkuri",
    "gui.howtos.cartoon-network.step_CNcollect": "Kolekti objektojn",
    "gui.howtos.cartoon-network.step_CNvariable": "Krei variablon por nombri poentojn",
    "gui.howtos.cartoon-network.step_CNscore": "Registri poentojn",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Sekva nivelo: ŝanĝi fonon",
    "gui.howtos.videosens.name": "Video-sentiloj",
    "gui.howtos.videosens.step_addextension": "Aldoni kromaĵon",
    "gui.howtos.videosens.step_pet": "Karesi la katon",
    "gui.howtos.videosens.step_animate": "Animacio",
    "gui.howtos.videosens.step_pop": "Krevi balonon",
    "gui.howtos.say-it-out-loud": "Krei animaciojn, kiuj parolas",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Aldoni la blokojn por laŭtlegi tekston",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Diri ion",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Elekti voĉon",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Moviĝi",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Aldoni scenejon",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Aldoni alian rolulon",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Kanti",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Ŝanĝi koloron",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Turniĝi",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Pli- kaj malpli-grandiĝi",
    "gui.howtos.talking": "Parolado",
    "gui.howtos.talking.step_talesAddExtension": "Alklaki por aldoni la parolsintezajn blokojn",
    "gui.howtos.talking.step_talesChooseSprite": "Elekti rolulon",
    "gui.howtos.talking.step_talesSaySomething": "Paroligi vian rolulon",
    "gui.howtos.talking.step_talesChooseBackdrop": "Elekti scenejon",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Alklaki rolulon por antaŭenigi la scenejon",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Elekti alian rolulon",
    "gui.howtos.talking.step_talesMoveAround": "Moviĝi",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Elekti alian scenejon",
    "gui.howtos.talking.step_talesAnimateTalking": "Parolanta animacio",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Elekti alian scenejon",
    "gui.howtos.talking.step_talesChooseSound": "Elekti kanton por danci",
    "gui.howtos.talking.step_talesDanceMoves": "Danc-movoj",
    "gui.howtos.talking.step_talesAskAnswer": "Elekti la blokojn Demandi kaj Respondi el la kategorio Sentiloj",
    "gui.howtos.add-sprite.name": "Aldoni rolulon",
    "gui.howtos.add-sprite.step_addSprite": "Aldoni rolulon",
    "gui.howtos.add-a-backdrop.name": "Aldoni scenejon",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Aldoni scenejon",
    "gui.howtos.change-size.name": "Ŝanĝi grandon",
    "gui.howtos.change-size.step_changeSize": "Ŝanĝi grandon",
    "gui.howtos.glide-around.name": "Gliti tien kaj reen",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Gliti tien kaj reen",
    "gui.howtos.change-size.step_glideAroundPoint": "Gliti ĝis iu punkto",
    "gui.howtos.record-a-sound.name": "Registri sonon",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Alklaki la langeton 'Sonoj'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Alklaki 'Registri'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Tuŝi la butonon 'Registri'",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Elekti sonon",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Aŭdigi vian sonon",
    "gui.howtos.spin-video.name": "Turni ĝin",
    "gui.howtos.change-size.step_spinTurn": "Turni",
    "gui.howtos.change-size.step_spinPointInDirection": "Agordi direkton",
    "gui.howtos.hide-and-show.name": "Kaŝi kaj montri",
    "gui.howtos.change-size.step_hideAndShow": "Kaŝi kaj montri",
    "gui.howtos.switch-costume.name": "Animi rolulon",
    "gui.howtos.change-size.step_switchCostumes": "Animi rolulon",
    "gui.howtos.move-around-with-arrow-keys.name": "Uzi sagoklavojn",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Moviĝi dekstren kaj maldekstren",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Moviĝi supren kaj malsupren",
    "gui.howtos.add-effects.name": "Aldoni efikojn",
    "gui.howtos.videosens.step_addEffects": "Aldoni efikojn",
    "gui.extension.music.name": "Muziko",
    "gui.extension.music.description": "Ludi instrumentojn kaj tamburojn.",
    "gui.extension.pen.name": "Skribilo",
    "gui.extension.pen.description": "Desegni per viaj roluloj.",
    "gui.extension.videosensing.name": "Video-sentiloj",
    "gui.extension.videosensing.description": "Detekti movojn per la kamerao",
    "gui.extension.text2speech.name": "Teksto al parolado",
    "gui.extension.text2speech.description": "Paroligi viajn projektojn",
    "gui.extension.translate.name": "Traduki",
    "gui.extension.translate.description": "Traduki tekston al multaj lingvoj.",
    "gui.extension.makeymakey.description": "Fari butonon el io ajn.",
    "gui.extension.microbit.description": "Konekti viajn projektojn al la mondo.",
    "gui.extension.microbit.connectingMessage": "Konektado",
    "gui.extension.ev3.description": "Konstrui interaktivajn robotojn, kaj pli.",
    "gui.extension.ev3.connectingMessage": "Konektado daŭras... Kontrolu, ke vi agordis la sekretan numeron de via EV3 al 1234.",
    "gui.extension.boost.description": "Vivigi robotajn kreaĵojn.",
    "gui.extension.boost.connectingMessage": "Konektado",
    "gui.extension.wedo2.description": "Konstrui per motoroj kaj detektiloj",
    "gui.extension.wedo2.connectingMessage": "Konektado",
    "gui.extension.gdxfor.description": "Detekti puŝojn, tirojn, movojn kaj turnojn",
    "gui.extension.gdxfor.connectingMessage": "Konektado",
    "gui.libraryTags.all": "Ĉion",
    "gui.libraryTags.animals": "Bestoj",
    "gui.libraryTags.dance": "Danci",
    "gui.libraryTags.effects": "Efektoj",
    "gui.libraryTags.fantasy": "Fantazio",
    "gui.libraryTags.fashion": "Modo",
    "gui.libraryTags.food": "Nutraĵoj",
    "gui.libraryTags.indoors": "En konstruaĵo",
    "gui.libraryTags.loops": "Iteracioj",
    "gui.libraryTags.music": "Muziko",
    "gui.libraryTags.notes": "Notoj",
    "gui.libraryTags.outdoors": "Ekstere",
    "gui.libraryTags.patterns": "Ŝablonoj",
    "gui.libraryTags.people": "Homoj",
    "gui.libraryTags.percussion": "Frapinstrumentoj",
    "gui.libraryTags.space": "La Kosmo",
    "gui.libraryTags.sports": "Sportoj",
    "gui.libraryTags.underwater": "Subakve",
    "gui.libraryTags.voice": "Voĉo",
    "gui.libraryTags.wacky": "Frenezaĵoj",
    "gui.libraryTags.animation": "Animacio",
    "gui.libraryTags.art": "Arto",
    "gui.libraryTags.games": "Ludoj",
    "gui.libraryTags.stories": "Rakontoj",
    "gui.libraryTags.letters": "Literoj",
    "gui.opcodeLabels.direction": "orientiĝo",
    "gui.opcodeLabels.xposition": "x-pozicio",
    "gui.opcodeLabels.yposition": "y-pozicio",
    "gui.opcodeLabels.size": "grando",
    "gui.opcodeLabels.costumename": "nomo de kostumo",
    "gui.opcodeLabels.costumenumber": "numero de kostumo",
    "gui.opcodeLabels.backdropname": "nomo de fono",
    "gui.opcodeLabels.backdropnumber": "numero de fono",
    "gui.opcodeLabels.volume": "laŭteco",
    "gui.opcodeLabels.tempo": "rapido",
    "gui.opcodeLabels.answer": "respondo",
    "gui.opcodeLabels.loudness": "laŭto",
    "gui.opcodeLabels.username": "salutnomo",
    "gui.opcodeLabels.year": "jaro",
    "gui.opcodeLabels.month": "monato",
    "gui.opcodeLabels.date": "dato",
    "gui.opcodeLabels.dayofweek": "tago de la semajno",
    "gui.opcodeLabels.hour": "horo",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "sekundo",
    "gui.opcodeLabels.timer": "horloĝo",
    "gui.projectLoader.loadError": "La elektita projektodosiero ne sukcesis ŝargiĝi",
    "gui.sharedMessages.backdrop": "fono n-ro {index}",
    "gui.sharedMessages.costume": "kostumo n-ro {index}",
    "gui.sharedMessages.sprite": "rolulo n-ro {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Forigi enhavon de aktuala projekto, ĉu?",
    "gui.sharedMessages.loadFromComputerTitle": "Alŝuti de via komputilo",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch-projekto",
    "boost.color.any": "iu ajn koloro",
    "boost.color.black": "nigra",
    "boost.color.blue": "blua",
    "boost.color.green": "verda",
    "boost.color.red": "ruĝa",
    "boost.color.white": "blanka",
    "boost.color.yellow": "flava",
    "boost.getMotorPosition": "pozicio de motoro [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "angulo de klino [TILT_DIRECTION]",
    "boost.motorDirection.backward": "tien",
    "boost.motorDirection.forward": "ĉi tien",
    "boost.motorDirection.reverse": "renversi",
    "boost.motorOff": "malŝalti motoron [MOTOR_ID]",
    "boost.motorOn": "ŝalti motoron [MOTOR_ID]",
    "boost.motorOnFor": "ŝalti motoron [MOTOR_ID] dum [DURATION] sekundoj",
    "boost.motorOnForRotation": "ŝalti motoron [MOTOR_ID] dum [ROTATION] turnoj",
    "boost.seeingColor": "ĉu [COLOR] briko videblas?",
    "boost.setLightHue": "kolorigi LED al [HUE]",
    "boost.setMotorDirection": "motoro [MOTOR_ID] turniĝu [MOTOR_DIRECTION]",
    "boost.setMotorPower": "motoro [MOTOR_ID] turniĝu kun rapideco [POWER] %",
    "boost.tiltDirection.any": "iu ajn",
    "boost.tiltDirection.down": "malsupre",
    "boost.tiltDirection.left": "maldekstra",
    "boost.tiltDirection.right": "dekstre",
    "boost.tiltDirection.up": "supre",
    "boost.whenColor": "kiam [COLOR] briko videblas",
    "boost.whenTilted": "kiam klinita [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "sonorigi noton [NOTE] dum [TIME] sekundoj",
    "ev3.buttonPressed": "ĉu butono [PORT] estas premita?",
    "ev3.getBrightness": "heleco",
    "ev3.getDistance": "distanco",
    "ev3.getMotorPosition": "pozicio de motoro ĉe pordo [PORT]",
    "ev3.motorSetPower": "motoro ĉe pordo [PORT] turniĝu kun rapideco [POWER] %",
    "ev3.motorTurnClockwise": "motoro ĉe pordo [PORT] turniĝu dekstrume dum [TIME] sekundoj",
    "ev3.motorTurnCounterClockwise": "motoro ĉe pordo [PORT] turniĝu maldekstrume dum [TIME] sekundoj",
    "ev3.whenBrightnessLessThan": "kiam brileco < [DISTANCE]",
    "ev3.whenButtonPressed": "kiam butono ĉe pordo [PORT] estas premita",
    "ev3.whenDistanceLessThan": "kiam distanco < [DISTANCE]",
    "gdxfor.getAcceleration": "akcelo [DIRECTION]",
    "gdxfor.getForce": "forto",
    "gdxfor.getSpin": "rapideco de turnado [DIRECTION]",
    "gdxfor.getTilt": "angulo de klino [TILT]",
    "gdxfor.isFreeFalling": "ĉu falanta?",
    "gdxfor.isTilted": "ĉu klinita [TILT]?",
    "gdxfor.pulled": "tirita",
    "gdxfor.pushed": "puŝita",
    "gdxfor.shaken": "ŝancelita",
    "gdxfor.startedFalling": "ekfalas",
    "gdxfor.tiltDirectionMenu.any": "iu ajn",
    "gdxfor.tiltDirectionMenu.back": "fona",
    "gdxfor.tiltDirectionMenu.front": "malfona",
    "gdxfor.tiltDirectionMenu.left": "maldekstra",
    "gdxfor.tiltDirectionMenu.right": "dekstre",
    "gdxfor.turnedFaceDown": "turnita frontosuben",
    "gdxfor.turnedFaceUp": "turnita frontosupren",
    "gdxfor.whenForcePushedOrPulled": "kiam fortodetektilo [PUSH_PULL]",
    "gdxfor.whenGesture": "kiam [GESTURE]",
    "gdxfor.whenTilted": "kiam klinita [TILT]",
    "makeymakey.downArrow": "sago malsupra",
    "makeymakey.downArrowShort": "malsupre",
    "makeymakey.leftArrow": "sago maldekstra",
    "makeymakey.leftArrowShort": "maldekstra",
    "makeymakey.rightArrow": "sago dekstra",
    "makeymakey.rightArrowShort": "dekstre",
    "makeymakey.spaceKey": "spacetklavo",
    "makeymakey.upArrow": "sago supra",
    "makeymakey.upArrowShort": "supre",
    "makeymakey.whenKeyPressed": "kiam klavo [KEY] premita",
    "makeymakey.whenKeysPressedInOrder": "kiam sinsekvo [SEQUENCE] tajpita",
    "microbit.buttonsMenu.any": "iu ajn",
    "microbit.clearDisplay": "viŝi matricon",
    "microbit.defaultTextToDisplay": "Saluton!",
    "microbit.displaySymbol": "afiŝi [MATRIX]",
    "microbit.displayText": "afiŝi tekston [TEXT]",
    "microbit.gesturesMenu.jumped": "saltigita",
    "microbit.gesturesMenu.moved": "movita",
    "microbit.gesturesMenu.shaken": "ŝancelita",
    "microbit.isButtonPressed": "ĉu butono [BTN] premita?",
    "microbit.isTilted": "ĉu klinita [DIRECTION]?",
    "microbit.pinStateMenu.off": "malŝaltita",
    "microbit.pinStateMenu.on": "ŝaltita",
    "microbit.tiltAngle": "angulo de kliniĝo [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "iu",
    "microbit.tiltDirectionMenu.back": "reen",
    "microbit.tiltDirectionMenu.front": "malfona",
    "microbit.tiltDirectionMenu.left": "maldekstra",
    "microbit.tiltDirectionMenu.right": "dekstre",
    "microbit.whenButtonPressed": "kiam butono [BTN] premita",
    "microbit.whenGesture": "kiam [GESTURE]",
    "microbit.whenPinConnected": "kiam stifto [PIN] konektita",
    "microbit.whenTilted": "kiam klinita [DIRECTION]",
    "music.categoryName": "Muziko",
    "music.changeTempo": "ŝanĝi muziktempon je [TEMPO]",
    "music.drumBass": "(2) Bastamburo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabaso",
    "music.drumClaves": "(9) Klaveo",
    "music.drumClosedHiHat": "(6) Fermita ĉarlestono",
    "music.drumConga": "(14) Kongao",
    "music.drumCowbell": "(11) Bovtintilo",
    "music.drumCrashCymbal": "(4) cimbalo",
    "music.drumCuica": "(18) Kuiko",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Manfrapo",
    "music.drumOpenHiHat": "(5) Malferma ĉarlestono",
    "music.drumSideStick": "(3) Batil-flanke",
    "music.drumSnare": "(1) Tambureto",
    "music.drumTambourine": "(7) Tamburino",
    "music.drumTriangle": "(12) Triangulo",
    "music.drumVibraslap": "(17) Vibrafrapo",
    "music.drumWoodBlock": "(10) Lignobloko",
    "music.getTempo": "rapido",
    "music.instrumentBass": "(6) Baso",
    "music.instrumentBassoon": "(14) Fagoto",
    "music.instrumentCello": "(8) Violonĉelo",
    "music.instrumentChoir": "(15) Ĥoro",
    "music.instrumentClarinet": "(10) Klarneto",
    "music.instrumentElectricGuitar": "(5) Elektra gitaro",
    "music.instrumentElectricPiano": "(2) Elektra piano",
    "music.instrumentFlute": "(12) Transversa fluto",
    "music.instrumentGuitar": "(4) Gitaro",
    "music.instrumentMarimba": "(19) Marimbo",
    "music.instrumentMusicBox": "(17) Musik-skatolo",
    "music.instrumentOrgan": "(3) Orgeno",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofono",
    "music.instrumentSteelDrum": "(18) Ŝtaltamburo",
    "music.instrumentSynthLead": "(20) Sintezilo 1",
    "music.instrumentSynthPad": "(21) Sintezilo 2",
    "music.instrumentTrombone": "(9) Trombono",
    "music.instrumentVibraphone": "(16) Vibrafono",
    "music.instrumentWoodenFlute": "(13) Ligna fluto",
    "music.midiPlayDrumForBeats": "ludi tamburon [DRUM] dum [BEATS] taktoj",
    "music.midiSetInstrument": "elekti instrumenton [INSTRUMENT]",
    "music.playDrumForBeats": "ludi tamburon [DRUM] dum [BEATS] taktoj",
    "music.playNoteForBeats": "ludi noton [NOTE] dum [BEATS] taktoj",
    "music.restForBeats": "silenti dum [BEATS] taktoj",
    "music.setInstrument": "elekti instrumenton [INSTRUMENT]",
    "music.setTempo": "agordi muziktempon al [TEMPO]",
    "pen.categoryName": "Skribilo",
    "pen.changeColorParam": "ŝanĝi skribilon [COLOR_PARAM] je [VALUE]",
    "pen.changeHue": "ŝanĝi koloron de skribilo de [HUE]",
    "pen.changeShade": "ŝanĝi kolornuancon de skribilo de [SHADE]",
    "pen.changeSize": "ŝanĝi grandon de skribilo de [SIZE]",
    "pen.clear": "forigi ĉion",
    "pen.colorMenu.brightness": "heleca",
    "pen.colorMenu.color": "kolora",
    "pen.colorMenu.saturation": "satureco",
    "pen.colorMenu.transparency": "travedebleco",
    "pen.penDown": "ekskribi",
    "pen.penUp": "ĉesi skribi",
    "pen.setColor": "kolorigi skribilon al [COLOR]",
    "pen.setColorParam": "agordi [COLOR_PARAM] de skribilo al [VALUE]",
    "pen.setHue": "kolorigi skribilon al [HUE]",
    "pen.setShade": "agordi kolornuancon de skribilo al [SHADE]",
    "pen.setSize": "agordi grandon de skribilo al [SIZE]",
    "pen.stamp": "stampi",
    "speech.defaultWhenIHearValue": "ek!",
    "speech.extensionName": "Parolado al teksto",
    "speech.listenAndWait": "aŭskulti kaj atendi",
    "speech.speechReporter": "parolaĵo",
    "speech.whenIHear": "kiam mi aŭdas [PHRASE]",
    "text2speech.alto": "aldo",
    "text2speech.categoryName": "Teksto al parolado",
    "text2speech.defaultTextToSpeak": "saluton",
    "text2speech.giant": "gigantulo",
    "text2speech.kitten": "katido",
    "text2speech.setLanguageBlock": "agordi lingvon al [LANGUAGE]",
    "text2speech.setVoiceBlock": "agordi voĉon al [VOICE]",
    "text2speech.speakAndWaitBlock": "diri [WORDS]",
    "text2speech.squeak": "muso",
    "text2speech.tenor": "tenoro",
    "translate.categoryName": "Traduki",
    "translate.defaultTextToTranslate": "saluton",
    "translate.translateBlock": "traduki [WORDS] al [LANGUAGE]",
    "translate.viewerLanguage": "lingvo",
    "videoSensing.categoryName": "Video-detektiloj",
    "videoSensing.direction": "orientiĝo",
    "videoSensing.motion": "movado",
    "videoSensing.off": "malŝaltita",
    "videoSensing.on": "ŝaltita",
    "videoSensing.onFlipped": "ŝaltita kaj inversita",
    "videoSensing.setVideoTransparency": "agordi travideblecon de video al [TRANSPARENCY]",
    "videoSensing.sprite": "rolulo",
    "videoSensing.stage": "scenejo",
    "videoSensing.videoOn": "[ATTRIBUTE] de video sur [SUBJECT]",
    "videoSensing.videoToggle": "agordi videon [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kiam movo en video > [REFERENCE]",
    "wedo2.getDistance": "distanco",
    "wedo2.getTiltAngle": "angulo de klino [TILT_DIRECTION]",
    "wedo2.isTilted": "ĉu inklinita [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "tien",
    "wedo2.motorDirection.forward": "ĉi tien",
    "wedo2.motorDirection.reverse": "renversi",
    "wedo2.motorId.a": "motoro A",
    "wedo2.motorId.all": "ĉiuj motoroj",
    "wedo2.motorId.b": "motoro B",
    "wedo2.motorId.default": "motoro",
    "wedo2.motorOff": "malŝalti [MOTOR_ID]",
    "wedo2.motorOn": "ŝalti [MOTOR_ID]",
    "wedo2.motorOnFor": "ŝalti [MOTOR_ID] dum [DURATION] sekundoj",
    "wedo2.playNoteFor": "ludi noton [NOTE] dum [DURATION] sekundoj",
    "wedo2.setLightHue": "kolorigi LED al [HUE]",
    "wedo2.setMotorDirection": "agordi direkton de [MOTOR_ID] al [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "agordi rapidecon de [MOTOR_ID] al [POWER]",
    "wedo2.tiltDirection.any": "iu",
    "wedo2.tiltDirection.down": "malsupre",
    "wedo2.tiltDirection.left": "maldekstra",
    "wedo2.tiltDirection.right": "dekstre",
    "wedo2.tiltDirection.up": "supre",
    "wedo2.whenDistance": "kiam distanco [OP] [REFERENCE]",
    "wedo2.whenTilted": "kiam klinita [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Koloro",
    "paint.paintEditor.saturation": "Satureco",
    "paint.paintEditor.brightness": "Heleco",
    "paint.paintEditor.costume": "Kostumo",
    "paint.paintEditor.group": "Grupo",
    "paint.paintEditor.ungroup": "Malgrupigi",
    "paint.paintEditor.undo": "Malfari",
    "paint.paintEditor.redo": "Refari",
    "paint.paintEditor.forward": "supren",
    "paint.paintEditor.backward": "malsupren",
    "paint.paintEditor.front": "al la supro",
    "paint.paintEditor.back": "Reen",
    "paint.paintEditor.more": "Pli",
    "paint.modeTools.brushSize": "Grandeco",
    "paint.modeTools.eraserSize": "grando de forviŝilo",
    "paint.modeTools.copy": "Kopii",
    "paint.modeTools.paste": "Alglui",
    "paint.modeTools.delete": "Forigi",
    "paint.modeTools.curved": "Kurbigi",
    "paint.modeTools.pointed": "akrigi",
    "paint.modeTools.thickness": "Larĝo",
    "paint.modeTools.flipHorizontal": "inversi horizontale",
    "paint.modeTools.flipVertical": "inversi vertikale",
    "paint.modeTools.filled": "Plenigita",
    "paint.modeTools.outlined": "Konturo",
    "paint.paintEditor.bitmap": "Konverti al rastruma bildo",
    "paint.paintEditor.vector": "Konverti al vektora bildo",
    "paint.paintEditor.fill": "Plenigi",
    "paint.paintEditor.stroke": "Konturo",
    "paint.brushMode.brush": "Peniko",
    "paint.eraserMode.eraser": "Forviŝilo",
    "paint.fillMode.fill": "Plenigi",
    "paint.lineMode.line": "Linio",
    "paint.ovalMode.oval": "Cirklo",
    "paint.rectMode.rect": "Rektangulo",
    "paint.reshapeMode.reshape": "Ŝanĝi formon",
    "paint.roundedRectMode.roundedRect": "Rondigita rektangulo",
    "paint.selectMode.select": "Elekti",
    "paint.textMode.text": "Teksto",
    "paint.colorPicker.swap": "Interŝanĝi"
  },
  "eu": {
    "gui.alerts.lostPeripheralConnection": "Scratchek konexioa galdu du {extensionName} gehigarriarekin",
    "gui.alerts.tryAgain": "Saiatu berriro",
    "gui.alerts.download": "Deskargatu",
    "gui.connection.reconnect": "Birkonektatu",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "soinua",
    "gui.backpack.scriptLabel": "script-a",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Motxila",
    "gui.backpack.errorBackpack": "Errorea motxila kargatzean",
    "gui.backpack.loadingBackpack": "Kargatzen...",
    "gui.backpack.more": "Gehiago",
    "gui.backpack.emptyBackpack": "Motxila hutsik dago",
    "gui.unsupportedBrowser.label": "Nabigatzailea ez da onartzen",
    "gui.unsupportedBrowser.errorLabel": "Errore bat gertatu da",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Atzera",
    "gui.unsupportedBrowser.previewfaq": "Gehiago jakiteko joan hona:  {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutorialak",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Itxi",
    "gui.cards.more-things-to-try": "Probatzeko gauza gehiago!",
    "gui.cards.see-more": "Ikusi gehiago",
    "gui.comingSoon.message1": "Lasai, horretan gabiltza {emoji}",
    "gui.comingSoon.message2": "Laster ...",
    "gui.comingSoon.message3": "Horretan ari gara {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Ez da gailurik aurkitu",
    "gui.connection.auto-scanning.prescan": "Gailua hurbil badaukazu,  hasi bilatzen.",
    "gui.connection.auto-scanning.pressbutton": "Sakatu zure gailuko botoia.",
    "gui.connection.auto-scanning.start-search": "Hasi bilatzen",
    "gui.connection.connecting-searchbutton": "Bilatzen...",
    "gui.connection.auto-scanning.try-again": "Saiatu berriro",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Konektatuta",
    "gui.connection.disconnect": "Konexiorik gabe",
    "gui.connection.go-to-editor": "Joan editorera",
    "gui.connection.connecting-cancelbutton": "Konektatzen...",
    "gui.connection.error.errorMessage": "Ene! Ematen du zerbait oker dabilela",
    "gui.connection.error.tryagainbutton": "Saiatu berriro",
    "gui.connection.error.helpbutton": "Laguntza",
    "gui.connection.peripheral-name-label": "Gailuaren izena",
    "gui.connection.connect": "Konektatu",
    "gui.connection.scanning.lookingforperipherals": "Gailuak bilatzen",
    "gui.connection.scanning.noPeripheralsFound": "Ez da gailurik aurkitu",
    "gui.connection.scanning.instructions": "Hautatu zure gailua goiko zerrendan.",
    "gui.connection.search": "Freskatu",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Egiaztatu Scratch Link instalatuta duzula eta martxan dagoela",
    "gui.connection.unavailable.enablebluetooth": "Egiaztatu bluetootha aktibo dagoela",
    "gui.connection.unavailable.tryagainbutton": "Saiatu berriro",
    "gui.connection.unavailable.helpbutton": "Laguntza",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Abiatu",
    "gui.controls.stop": "Gelditu",
    "gui.crashMessage.label": "Ene! Zerbaitek huts egin du",
    "gui.crashMessage.description": "Asko sentitzen dugu, baina ematen du Scratch-ek huts egin duela. Intzidentzia hau era automatikoan bidali zaio Scratch taldeari. Freskatu orria berriro saiatzeko.",
    "gui.crashMessage.errorNumber": "Zure errorea id honekin erregistratu da:  {errorId}",
    "gui.crashMessage.reload": "Kargatu berriro",
    "gui.customProcedures.myblockModalTitle": "Sortu bloke bat",
    "gui.customProcedures.addAnInputNumberText": "Gehitu sarrera bat",
    "gui.customProcedures.numberTextType": "zenbakia edo testua",
    "gui.customProcedures.addAnInputBoolean": "Gehitu sarrera bat",
    "gui.customProcedures.booleanType": "boolearra",
    "gui.customProcedures.addALabel": "Gehitu etiketa bat",
    "gui.customProcedures.runWithoutScreenRefresh": "Abiatu pantaila eguneratu gabe",
    "gui.customProcedures.cancel": "Utzi",
    "gui.customProcedures.ok": "Ados",
    "gui.SpriteInfo.direction": "Norabidea",
    "gui.directionPicker.rotationStyles.allAround": "Norabide guztietara",
    "gui.directionPicker.rotationStyles.leftRight": "Ezker/Eskuin",
    "gui.directionPicker.rotationStyles.dontRotate": "Ez biratu",
    "gui.gui.addExtension": "Gehitu gehigarri bat",
    "gui.gui.codeTab": "Kodea",
    "gui.gui.backdropsTab": "Atzeko oihalak",
    "gui.gui.costumesTab": "Tankerak",
    "gui.gui.soundsTab": "Soinuak",
    "gui.extensionLibrary.comingSoon": "Laster",
    "gui.extensionLibrary.requires": "Eskakizunak",
    "gui.extensionLibrary.collaboration": "Hauekin elkar lanean",
    "gui.library.filterPlaceholder": "Bilatu",
    "gui.library.allTag": "Guztiak",
    "gui.loader.message1": "Blokeak sortzen ...",
    "gui.loader.message2": "Pertsonaiak kargatzen ...",
    "gui.loader.message3": "Soinuak kargatzen ...",
    "gui.loader.message4": "Gehigarriak kargatzen ...",
    "gui.loader.message5": "Katuak gidatzen...",
    "gui.loader.message6": "Nanoak igortzen ...",
    "gui.loader.message7": "Puxikak puzten ...",
    "gui.loader.message8": "Emojiak prestatzen ...",
    "gui.loader.headline": "Proiektua kargatzen",
    "gui.loader.creating": "Proiektua sortzen",
    "gui.accountMenu.profile": "Profila",
    "gui.accountMenu.myStuff": "Nire gauzak",
    "gui.accountMenu.myClasses": "Nire gelak",
    "gui.accountMenu.myClass": "Nire gela",
    "gui.accountMenu.accountSettings": "Kontuaren ezarpenak",
    "gui.accountMenu.signOut": "Amaitu saioa",
    "gui.authorInfo.byUser": "egilea {username}",
    "gui.menuBar.seeProjectPage": "Ikusi proiektuaren orria",
    "gui.menuBar.language": "Language",
    "general.username": "Erabiltzaile-izena",
    "general.password": "Pasahitza",
    "general.signIn": "Hasi saioa",
    "login.needHelp": "Laguntza behar duzu?",
    "form.validationRequired": "Eremu hau beharrezkoa da",
    "gui.menuBar.tutorialsLibrary": "Tutorialak",
    "gui.menuBar.restoreSprite": "Berreskuratu pertsonaia",
    "gui.menuBar.restoreSound": "Berreskuratu soinua",
    "gui.menuBar.restoreCostume": "Berreskuratu tankera",
    "gui.menuBar.restore": "Berreskuratu",
    "gui.menuBar.saveNow": "Gorde orain",
    "gui.menuBar.saveAsCopy": "Gorde kopia gisa",
    "gui.menuBar.remix": "Birnahastu",
    "gui.menuBar.new": "Berria",
    "gui.menuBar.file": "Fitxategia",
    "gui.menuBar.downloadToComputer": "Gorde zure ordenagailuan",
    "gui.menuBar.edit": "Editatu",
    "gui.menuBar.turboModeOff": "Itzali turbo modua",
    "gui.menuBar.turboModeOn": "Piztu turbo modua",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Batu Scratchera",
    "gui.menuBar.signIn": "Hasi saioa",
    "gui.gui.projectTitlePlaceholder": "Hemen proiektuaren titulua",
    "gui.menuBar.saveNowLink": "Gorde orain",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Partekatuak",
    "gui.menuBar.share": "Partekatu",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Laguntza",
    "gui.modal.back": "Atzera",
    "gui.monitor.listMonitor.empty": "(hutsik)",
    "gui.monitor.listMonitor.listLength": "luzera  {length}",
    "gui.monitor.contextMenu.default": "ohiko tamaina",
    "gui.monitor.contextMenu.large": "tamaina handia",
    "gui.monitor.contextMenu.slider": "graduatzailea",
    "gui.monitor.contextMenu.sliderRange": "aldatu graduatzailearen mugak",
    "gui.monitor.contextMenu.import": "inportatu",
    "gui.monitor.contextMenu.export": "esportatu",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Erreproduzitu",
    "gui.playButton.stop": "Gelditu",
    "gui.gui.variableScopeOptionAllSprites": "Pertsonai guztientzat",
    "gui.gui.variableScopeOptionSpriteOnly": "Pertsonai honentzat soilik",
    "gui.gui.cloudVariableOption": "Hodei-aldagaia (zerbitzarian gordea)",
    "gui.gui.variablePromptAllSpritesMessage": "Aldagai hau pertsonai guztientzat erabili daiteke.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Utzi",
    "gui.prompt.ok": "Ados",
    "gui.playbackStep.stopMsg": "Gelditu",
    "gui.playbackStep.playMsg": "Erreproduzitu",
    "gui.playbackStep.loadingMsg": "Kargatzen...",
    "gui.playbackStep.saveMsg": "Gorde",
    "gui.playbackStep.reRecordMsg": "Grabatu berriz",
    "gui.recordModal.title": "Grabatu soinua",
    "gui.recordingStep.beginRecord": "Hasi grabaketa beheko botoia sakatuz",
    "gui.recordingStep.permission": "{arrow}Zure mikrofonoa erabiltzeko baimena behar dugu",
    "gui.recordingStep.stop": "Gelditu grabaketa",
    "gui.recordingStep.record": "Grabatu",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Aldatu graduatzailearen mugak",
    "gui.sliderPrompt.cancel": "Utzi",
    "gui.sliderPrompt.ok": "Ados",
    "gui.soundEditor.sound": "Soinua",
    "gui.soundEditor.play": "Erreproduzitu",
    "gui.soundEditor.stop": "Gelditu",
    "gui.soundEditor.copy": "Kopiatu",
    "gui.soundEditor.paste": "Itsatsi",
    "gui.soundEditor.copyToNew": "Kopiatu berrira",
    "gui.soundEditor.delete": "Ezabatu",
    "gui.soundEditor.save": "Gorde",
    "gui.soundEditor.undo": "Desegin",
    "gui.soundEditor.redo": "Berregin",
    "gui.soundEditor.faster": "Azkarrago",
    "gui.soundEditor.slower": "Motelago",
    "gui.soundEditor.echo": "Oihartzuna",
    "gui.soundEditor.robot": "Robota",
    "gui.soundEditor.louder": "Ozenago",
    "gui.soundEditor.softer": "Isilago",
    "gui.soundEditor.reverse": "Alderantzikatu",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Izena",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Pertsonaia",
    "gui.SpriteInfo.show": "Erakutsi",
    "gui.SpriteInfo.size": "Tamaina",
    "gui.spriteSelectorItem.contextMenuDuplicate": "bikoiztu",
    "gui.spriteSelectorItem.contextMenuExport": "esportatu",
    "gui.spriteSelectorItem.contextMenuDelete": "ezabatu",
    "gui.spriteSelector.addSpriteFromLibrary": "Aukeratu pertsonai bat",
    "gui.spriteSelector.addSpriteFromPaint": "Margotu",
    "gui.spriteSelector.addSpriteFromSurprise": "Ezustekoa",
    "gui.spriteSelector.addSpriteFromFile": "Kargatu pertsonaia",
    "gui.stageHeader.stageSizeLarge": "Aldatu eszena handira",
    "gui.stageHeader.stageSizeSmall": "Aldatu eszena txikira",
    "gui.stageHeader.stageSizeFull": "Sartu pantaila osoko moduan",
    "gui.stageHeader.stageSizeUnFull": "Atera pantaila osoko modutik",
    "gui.stageHeader.fullscreenControl": "Pantaila osoa",
    "gui.spriteSelector.addBackdropFromLibrary": "Aukeratu atzeko oihal bat",
    "gui.stageSelector.addBackdropFromPaint": "Margotu",
    "gui.stageSelector.addBackdropFromSurprise": "Ezustekoa",
    "gui.stageSelector.addBackdropFromFile": "Kargatu atzeko oihala",
    "gui.stageSelector.stage": "Eszena",
    "gui.stageSelector.backdrops": "Atzeko oihalak",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Itxi",
    "gui.turboMode.active": "Turbo modua",
    "gui.webglModal.label": "Zure nabigatzaileak ez du WebGL onartzen",
    "gui.webglModal.description": "Tamalez ematen du zure nabigatzaileak edo ordenagailuak {webGlLink}. Teknologia hau beharrezkoa da Scratch 3.0 erabiltzeko.",
    "gui.webglModal.webgllink": "ez duela WebGL onartzen",
    "gui.webglModal.back": "Atzera",
    "gui.webglModal.previewfaq": "Gehiago jakiteko joan hona:  {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Aukeratu atzeko oihal bat",
    "gui.costumeLibrary.chooseACostume": "Aukeratu tankera bat",
    "gui.costumeTab.addBackdropFromLibrary": "Aukeratu atzeko oihal bat",
    "gui.costumeTab.addCostumeFromLibrary": "Aukeratu tankera bat",
    "gui.costumeTab.addBlankCostume": "Margotu",
    "gui.costumeTab.addSurpriseCostume": "Ezustekoa",
    "gui.costumeTab.addFileBackdrop": "Kargatu atzeko oihala",
    "gui.costumeTab.addFileCostume": "Kargatu tankera",
    "gui.extensionLibrary.chooseAnExtension": "Aukeratu gehigarri bat",
    "gui.extensionLibrary.extensionUrl": "Sartu gehigarriaren URLa",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ezin izan da hasi grabatzen",
    "gui.soundLibrary.chooseASound": "Aukeratu soinu bat",
    "gui.soundTab.fileUploadSound": "Kargatu soinua",
    "gui.soundTab.surpriseSound": "Ezustekoa",
    "gui.soundTab.recordSound": "Grabatu",
    "gui.soundTab.addSoundFromLibrary": "Aukeratu soinu bat",
    "gui.spriteLibrary.chooseASprite": "Aukeratu pertsonai bat",
    "gui.tipsLibrary.tutorials": "Aukeratu tutorial bat",
    "gui.alerts.createsuccess": "Sortu da proiektu berria.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Ezin izan da proiektua sortu. Saiatu berriro!",
    "gui.alerts.savingError": "Ezin izan da proiektua gorde.",
    "gui.alerts.savesuccess": "Proiektua gorde da.",
    "gui.alerts.saving": "Proiektua gordetzen...",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Inportatzen...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "nire aldagaia",
    "gui.howtos.intro-move-sayhello-hat.name": "Hasten",
    "gui.howtos.intro-move.step_stepMove": "Gehitu mugimendu bloke bat",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klikatu bandera berdea hasteko",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animatu izen bat",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Aukeratu letra-pertsonai bat",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Erreproduzitu soinua klikatzean",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Aukeratu beste letra-pertsonai bat",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Aldatu kolorea",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Aukeratu beste letra-pertsonai bat eta biratu",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Aukeratu beste letra-pertsonai bat eta handiagotu",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Soinu bat gehitu",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Egin musika",
    "gui.howtos.Make-Music.step_PickInstrument": "Aukeratu tresna-pertsonai bat",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Erreproduzitu soinua klikatzean",
    "gui.howtos.Make-Music.step_MakeSong": "Sortu abesti bat",
    "gui.howtos.make-music.step_MakeBeat": "Aukeratu danbor bat eta egin erritmo bat",
    "gui.howtos.make-music.step_MakeBeatBox": "Aukeratu mikrofono-pertsonaia eta ezustekoen erritmo-kutxa",
    "gui.howtos.story.name": "Sortu istorio bat",
    "gui.howtos.story.step_addbg": "Gehitu atzeko oihal bat",
    "gui.howtos.story.step_addsprite": "Gehitu karaktere bat",
    "gui.howtos.story.step_saysomething": "Esan zerbait",
    "gui.howtos.story.step_addanothersprite": "Gehitu beste karaktere bat",
    "gui.howtos.story.step_flip": "Alderantzikatu norabidea",
    "gui.howtos.story.step_conversation": "Mantendu elkarrizketa bat",
    "gui.howtos.story.addanotherbg": "Gehitu beste atzeko oihal bat",
    "gui.howtos.story.step_swithbg": "Aldatu atzeko oihalak",
    "gui.howtos.story.step_hidewizard": "Ezkutatu karaktere bat",
    "gui.howtos.story.step_showwizard": "Erakutsi karaktere bat",
    "gui.howtos.make-a-chase-game.name": "Sortu harrapaketa jolas bat",
    "gui.howtos.Chase-Game.step_BG": "Gehitu atzeko oihal bat",
    "gui.howtos.chase-game.step_AddOcto": "Gehitu pertsonai bat",
    "gui.howtos.make-music.step_LeftRight": "Mugitu eskuin-ezker gezien teklen bidez",
    "gui.howtos.Chase-Game.step_UpDown": "Mugitu gora-behera gezien teklen bidez",
    "gui.howtos.Chase-Game.step_AddStar": "Gehitu beste pertsonai bat",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mugitu ausazko jitoan",
    "gui.howtos.Chase-Game.step_WhenTouch": "Olagarro pertsonaia ukitzean erreproduzitu soinua",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Sortu puntuazio-aldagaia",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Olagarro pertsonaia ukitzean handitu puntuazioa",
    "gui.howtos.animate-char.name": "Animatu karaktere bat",
    "gui.howtos.animate-char.step_addbg": "Gehitu atzeko oihal bat",
    "gui.howtos.animate-char.step_addsprite": "Gehitu pertsonai bat",
    "gui.howtos.animate-char.step_saysomething": "Esan zerbait",
    "gui.howtos.animate-char.step_addsound": "Gehitu soinua",
    "gui.howtos.animate-char.step_animatetalking": "Animatu hizkera",
    "gui.howtos.animate-char.step_arrowkeys": "Mugitu gezi teklekin",
    "gui.howtos.animate-char.step_jump": "Saltatu",
    "gui.howtos.animate-char.step_changecolor": "Aldatu kolorea",
    "gui.howtos.make-a-game.name": "Sortu klikatzeko jolas bat",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Aukeratu pertsonai bat",
    "gui.howtos.make-a-game.step_GamePlaySound": "Erreproduzitu soinua klikatzean",
    "gui.howtos.make-a-game.step_GameAddScore": "Sortu puntuazio-aldagaia",
    "gui.howtos.make-a-game.step_GameChangeScore": "Klikatzean handitu puntuazioa",
    "gui.howtos.make-a-game.step_Random": "Joan ausazko kokapen batera",
    "gui.howtos.make-music.step_GameChangeColor": "Aldatu kolorea",
    "gui.howtos.make-music.step_ResetScore": "Berrabiarazi puntuazioa",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Sortu abentura jolas bat",
    "gui.howtos.cartoon-network.step_CNcharacter": "Hautatu karaktere bat erakusteko",
    "gui.howtos.cartoon-network.step_CNsay": "Esan zerbait",
    "gui.howtos.cartoon-network.step_CNglide": "Irristatu inguruan",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Hautatu objektu bat jarraitzeko",
    "gui.howtos.cartoon-network.step_CNcollect": "Bildu objektuak",
    "gui.howtos.cartoon-network.step_CNvariable": "Sortu puntuazio aldagai bat",
    "gui.howtos.cartoon-network.step_CNscore": "Puntuaketa mantendu",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Maila gora: Aldatu atzeko ohiala",
    "gui.howtos.videosens.name": "Bideo-sentsorea",
    "gui.howtos.videosens.step_addextension": "Gehitu gehigarri bat",
    "gui.howtos.videosens.step_pet": "Laztandu katua",
    "gui.howtos.videosens.step_animate": "Animatu",
    "gui.howtos.videosens.step_pop": "Lehertu puxika bat",
    "gui.howtos.say-it-out-loud": "Sortu hitz egiten duten animazioak",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Gehitu Testua irakurri blokeak",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Ezarri ahots bat",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mugitu inguruan",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Gehitu atzeko oihal bat",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Gehitu beste karaktere bat",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Jo kantu bat",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Aldatu kolorea",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Biratu inguruan",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Hazi eta txikitu",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Gehitu pertsonai bat",
    "gui.howtos.add-sprite.step_addSprite": "Gehitu pertsonai bat",
    "gui.howtos.add-a-backdrop.name": "Gehitu atzeko oihal bat",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Aldatu tamaina",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Txirrist egin inguruan",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Grabatu soinu bat",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Jarri biraka",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Ezkutatu eta erakutsi",
    "gui.howtos.change-size.step_hideAndShow": "Ezkutatu eta erakutsi",
    "gui.howtos.switch-costume.name": "Animatu pertsonai bat",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Erabili gezien teklak",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Gehitu efektuak",
    "gui.howtos.videosens.step_addEffects": "Gehitu efektuak",
    "gui.extension.music.name": "Musika",
    "gui.extension.music.description": "Jo musika tresnak eta danborrak.",
    "gui.extension.pen.name": "Arkatza",
    "gui.extension.pen.description": "Marraztu zure pertsonaiaz.",
    "gui.extension.videosensing.name": "Bideo-sentsorea",
    "gui.extension.videosensing.description": "Atzeman mugimendua kameraren bidez",
    "gui.extension.text2speech.name": "Testua irakurri",
    "gui.extension.text2speech.description": "Eman hitza zure proiektuei",
    "gui.extension.translate.name": "Itzuli",
    "gui.extension.translate.description": "Itzuli testua hainbat hizkuntzatara",
    "gui.extension.makeymakey.description": "Egin edozer tekla batekin.",
    "gui.extension.microbit.description": "Konektatu zure proiektuak munduarekin.",
    "gui.extension.microbit.connectingMessage": "Konektatzen",
    "gui.extension.ev3.description": "Eraiki robot interaktiboak eta gauza gehiago.",
    "gui.extension.ev3.connectingMessage": "Konektatzen. Egiaztatu zure EV3ko PINa 1234 gisa ezarrita dagoela.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Konektatzen",
    "gui.extension.wedo2.description": "Eraiki motorra eta sentsoreen bidez.",
    "gui.extension.wedo2.connectingMessage": "Konektatzen",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Konektatzen",
    "gui.libraryTags.all": "Guztiak",
    "gui.libraryTags.animals": "Animaliak",
    "gui.libraryTags.dance": "Dantza",
    "gui.libraryTags.effects": "Efektuak",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Janaria",
    "gui.libraryTags.indoors": "Barnealdeak",
    "gui.libraryTags.loops": "Begiztak",
    "gui.libraryTags.music": "Musika",
    "gui.libraryTags.notes": "Notak",
    "gui.libraryTags.outdoors": "Kanpoaldeak",
    "gui.libraryTags.patterns": "Patroiak",
    "gui.libraryTags.people": "Jendea",
    "gui.libraryTags.percussion": "Perkusioa",
    "gui.libraryTags.space": "Espazioa",
    "gui.libraryTags.sports": "Kirolak",
    "gui.libraryTags.underwater": "Itsaspean",
    "gui.libraryTags.voice": "Ahotsa",
    "gui.libraryTags.wacky": "Zoroa",
    "gui.libraryTags.animation": "Animazioa",
    "gui.libraryTags.art": "Artea",
    "gui.libraryTags.games": "Jolasak",
    "gui.libraryTags.stories": "Istorioak",
    "gui.libraryTags.letters": "Hizkiak",
    "gui.opcodeLabels.direction": "norabidea",
    "gui.opcodeLabels.xposition": "x kokapena",
    "gui.opcodeLabels.yposition": "y kokapena",
    "gui.opcodeLabels.size": "tamaina",
    "gui.opcodeLabels.costumename": "tankeraren izena",
    "gui.opcodeLabels.costumenumber": "pertsonaia zenbakia",
    "gui.opcodeLabels.backdropname": "atzeko oihalaren izena",
    "gui.opcodeLabels.backdropnumber": "atzeko oihal zenbakia",
    "gui.opcodeLabels.volume": "bolumena",
    "gui.opcodeLabels.tempo": "tempoa",
    "gui.opcodeLabels.answer": "erantzuna",
    "gui.opcodeLabels.loudness": "ozentasuna",
    "gui.opcodeLabels.username": "erabiltzaile-izena",
    "gui.opcodeLabels.year": "urtea",
    "gui.opcodeLabels.month": "hilabetea",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "asteko eguna",
    "gui.opcodeLabels.hour": "ordua",
    "gui.opcodeLabels.minute": "minutua",
    "gui.opcodeLabels.second": "segundoa",
    "gui.opcodeLabels.timer": "kronometroa",
    "gui.projectLoader.loadError": "Huts egin du hautatutako proiektu-fitxategia kargatzen.",
    "gui.sharedMessages.backdrop": "atzeko oihala{index}",
    "gui.sharedMessages.costume": "tankera{index}",
    "gui.sharedMessages.sprite": "Personaia{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Kargatu zure ordenagailutik",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch proiektua",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "jo [NOTE] nota [TIME] segundoz",
    "ev3.buttonPressed": " [PORT] botoia sakatuta dago?",
    "ev3.getBrightness": "distira",
    "ev3.getDistance": "distantzia",
    "ev3.getMotorPosition": " [PORT] motorraren kokapena",
    "ev3.motorSetPower": "ezarri [PORT] motorra % [POWER] potentzian",
    "ev3.motorTurnClockwise": "biratu [PORT] motorra norabide honetan [TIME] segundoz",
    "ev3.motorTurnCounterClockwise": "biratu  [PORT] motorra norabide horretan [TIME] segundoz",
    "ev3.whenBrightnessLessThan": "distira < [DISTANCE] denean",
    "ev3.whenButtonPressed": " [PORT] botoia sakatzean",
    "ev3.whenDistanceLessThan": "distantzia < [DISTANCE] denean",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "behera gezia",
    "makeymakey.downArrowShort": "behera",
    "makeymakey.leftArrow": "ezkerrera gezia",
    "makeymakey.leftArrowShort": "ezkerra",
    "makeymakey.rightArrow": "eskuinera gezia",
    "makeymakey.rightArrowShort": "eskuina",
    "makeymakey.spaceKey": "zuriunea",
    "makeymakey.upArrow": "gora gezia",
    "makeymakey.upArrowShort": "gora",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "edozein",
    "microbit.clearDisplay": "garbitu pantaila",
    "microbit.defaultTextToDisplay": "Kaixo!",
    "microbit.displaySymbol": "bistaratu [MATRIX]",
    "microbit.displayText": "bistaratu [TEXT] testua",
    "microbit.gesturesMenu.jumped": "salto egina",
    "microbit.gesturesMenu.moved": "mugitua",
    "microbit.gesturesMenu.shaken": "astindua",
    "microbit.isButtonPressed": "[BTN] botoia sakatuta dago?",
    "microbit.isTilted": " [DIRECTION]-ra okertuta dago?",
    "microbit.pinStateMenu.off": "itzalita",
    "microbit.pinStateMenu.on": "piztuta",
    "microbit.tiltAngle": "okertu angelua [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "edozein",
    "microbit.tiltDirectionMenu.back": "atzealdea",
    "microbit.tiltDirectionMenu.front": "aurrealdea",
    "microbit.tiltDirectionMenu.left": "ezkerra",
    "microbit.tiltDirectionMenu.right": "eskuina",
    "microbit.whenButtonPressed": "[BTN] botoia sakatzean",
    "microbit.whenGesture": "[GESTURE] antzematean",
    "microbit.whenPinConnected": "[PIN] pina konektatuta dagoenean",
    "microbit.whenTilted": " [DIRECTION]-ra okertuta dagoenean",
    "music.categoryName": "Musika",
    "music.changeTempo": "aldatu tempoa [TEMPO] unitate",
    "music.drumBass": "(2) Dunbala",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Klabeak",
    "music.drumClosedHiHat": "(6) Charleston txindata itxiak",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Zintzarria",
    "music.drumCrashCymbal": "(4) Txindata",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Txaloa",
    "music.drumOpenHiHat": "(5) Charleston txindata irekiak",
    "music.drumSideStick": "(3) Albo kolpea",
    "music.drumSnare": "(1) Kaxa danborra",
    "music.drumTambourine": "(7) Panderoa",
    "music.drumTriangle": "(12) Triangelua",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Egur blokea",
    "music.getTempo": "tempoa",
    "music.instrumentBass": "(6) Baxua",
    "music.instrumentBassoon": "(14) Fagota",
    "music.instrumentCello": "(8) Txeloa",
    "music.instrumentChoir": "(15) Korua",
    "music.instrumentClarinet": "(10) Klarinetea",
    "music.instrumentElectricGuitar": "(5) Gitarra elektrikoa",
    "music.instrumentElectricPiano": "(2) Piano elektrikoa",
    "music.instrumentFlute": "(12) Txirula",
    "music.instrumentGuitar": "(4) Gitarra",
    "music.instrumentMarimba": "(19) Marinba",
    "music.instrumentMusicBox": "(17) Musika kaxa",
    "music.instrumentOrgan": "(3) Organoa",
    "music.instrumentPiano": "(1) Pianoa",
    "music.instrumentPizzicato": "(7) Pizzikatoa",
    "music.instrumentSaxophone": "(11) Saxofoia",
    "music.instrumentSteelDrum": "(18) Altzairuzko danborra",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Tronboia",
    "music.instrumentVibraphone": "(16) Bibrafonoa",
    "music.instrumentWoodenFlute": "(13) Zurezko txirula",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "ezarri tresna: [INSTRUMENT]",
    "music.playDrumForBeats": "jo  [DRUM]danborrean [BEATS] pultsuz",
    "music.playNoteForBeats": "jo [NOTE] nota [BEATS] pultsuz",
    "music.restForBeats": "isilunea [BEATS] pultsuz",
    "music.setInstrument": "ezarri [INSTRUMENT] tresna",
    "music.setTempo": "ezarri [TEMPO] tempoa",
    "pen.categoryName": "Arkatza",
    "pen.changeColorParam": "aldatu arkatzaren [COLOR_PARAM][VALUE] unitate",
    "pen.changeHue": "aldatu arkatzaren kolorea [HUE] tonu",
    "pen.changeShade": "aldatu arkatzaren itzala [SHADE] unitate",
    "pen.changeSize": "aldatu arkatzaren tamaina [SIZE] unitate",
    "pen.clear": "ezabatu guztia",
    "pen.colorMenu.brightness": "distira",
    "pen.colorMenu.color": "kolorea",
    "pen.colorMenu.saturation": "asetasuna",
    "pen.colorMenu.transparency": "gardentasuna",
    "pen.penDown": "jaitsi arkatza ",
    "pen.penUp": "igo arkatza",
    "pen.setColor": "ezarri arkatzaren kolorea: [COLOR]",
    "pen.setColorParam": "ezarri arkatzaren [COLOR_PARAM]: [VALUE]",
    "pen.setHue": "ezarri arkatzaren kolorea: [HUE]",
    "pen.setShade": "ezarri arkatzaren itzala: [SHADE]",
    "pen.setSize": "ezarri arkatzaren tamaina: [SIZE]",
    "pen.stamp": "zigilatu",
    "speech.defaultWhenIHearValue": "goazen",
    "speech.extensionName": "Hizketatik testura",
    "speech.listenAndWait": "entzun eta itxaron",
    "speech.speechReporter": "hizketa",
    "speech.whenIHear": " [PHRASE] entzutean",
    "text2speech.alto": "altua",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "erraldoia",
    "text2speech.kitten": "katutxoa",
    "text2speech.setLanguageBlock": "ezarri hizkuntza: [LANGUAGE]",
    "text2speech.setVoiceBlock": "ezarri ahotsa: [VOICE]",
    "text2speech.speakAndWaitBlock": "esan [WORDS]",
    "text2speech.squeak": "kirrinka",
    "text2speech.tenor": "tenorea",
    "translate.categoryName": "Itzuli",
    "translate.defaultTextToTranslate": "kaixo",
    "translate.translateBlock": "itzuli [WORDS]  [LANGUAGE]-ra",
    "translate.viewerLanguage": "hizkuntza",
    "videoSensing.categoryName": "Bideo-sentsorea",
    "videoSensing.direction": "norabidea",
    "videoSensing.motion": "mugimendua",
    "videoSensing.off": "itzali",
    "videoSensing.on": "piztu",
    "videoSensing.onFlipped": "piztu alderantziz",
    "videoSensing.setVideoTransparency": "ezarri bideo gardentasuna: [TRANSPARENCY]",
    "videoSensing.sprite": "pertsonaia",
    "videoSensing.stage": "eszena",
    "videoSensing.videoOn": "bideo- [ATTRIBUTE] hemen: [SUBJECT]",
    "videoSensing.videoToggle": " [VIDEO_STATE] bideoa",
    "videoSensing.whenMotionGreaterThan": "bideo-mugimendua > [REFERENCE] denean",
    "wedo2.getDistance": "distantzia",
    "wedo2.getTiltAngle": "inklinazio angelua [TILT_DIRECTION]",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] okertuta?",
    "wedo2.motorDirection.backward": "norabide horretan",
    "wedo2.motorDirection.forward": "norabide honetan",
    "wedo2.motorDirection.reverse": "alderantzikatu",
    "wedo2.motorId.a": "A motorra",
    "wedo2.motorId.all": "motor guztiak",
    "wedo2.motorId.b": "B motorra",
    "wedo2.motorId.default": "motorra",
    "wedo2.motorOff": "itzali [MOTOR_ID]",
    "wedo2.motorOn": "piztu [MOTOR_ID] ",
    "wedo2.motorOnFor": "piztu [MOTOR_ID]  [DURATION] segundoz",
    "wedo2.playNoteFor": "jo [NOTE] nota [DURATION] segundoz",
    "wedo2.setLightHue": "ezarri argiaren kolorea: [HUE]",
    "wedo2.setMotorDirection": "ezarri [MOTOR_ID] norabidea: [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "ezarri [MOTOR_ID] potentzia: [POWER]",
    "wedo2.tiltDirection.any": "edozein",
    "wedo2.tiltDirection.down": "behera",
    "wedo2.tiltDirection.left": "ezkerra",
    "wedo2.tiltDirection.right": "eskuina",
    "wedo2.tiltDirection.up": "gora",
    "wedo2.whenDistance": "distantzia [OP] [REFERENCE] denean",
    "wedo2.whenTilted": "okertasuna [TILT_DIRECTION_ANY] denean",
    "paint.paintEditor.hue": "Kolorea",
    "paint.paintEditor.saturation": "Asetasuna",
    "paint.paintEditor.brightness": "Distira",
    "paint.paintEditor.costume": "Tankera",
    "paint.paintEditor.group": "Taldekatu",
    "paint.paintEditor.ungroup": "Desegin taldea",
    "paint.paintEditor.undo": "Desegin",
    "paint.paintEditor.redo": "Berregin",
    "paint.paintEditor.forward": "Aurrealderantz",
    "paint.paintEditor.backward": "Atzealderantz",
    "paint.paintEditor.front": "Aurrealdera",
    "paint.paintEditor.back": "Atzealdera",
    "paint.paintEditor.more": "Gehiago",
    "paint.modeTools.brushSize": "Tamaina",
    "paint.modeTools.eraserSize": "Ezabatzailearen tamaina",
    "paint.modeTools.copy": "Kopiatu",
    "paint.modeTools.paste": "Itsatsi",
    "paint.modeTools.delete": "Ezabatu",
    "paint.modeTools.curved": "Kurbatua",
    "paint.modeTools.pointed": "Zorrotza",
    "paint.modeTools.thickness": "Lodiera",
    "paint.modeTools.flipHorizontal": "Islatu horizontalki",
    "paint.modeTools.flipVertical": "Islatu bertikalki",
    "paint.modeTools.filled": "Betea",
    "paint.modeTools.outlined": "Eskematizatua",
    "paint.paintEditor.bitmap": "Bihurtu Bitmap",
    "paint.paintEditor.vector": "Bihurtu bektore",
    "paint.paintEditor.fill": "Bete",
    "paint.paintEditor.stroke": "Eskema",
    "paint.brushMode.brush": "Pintzela",
    "paint.eraserMode.eraser": "Ezabatzailea",
    "paint.fillMode.fill": "Bete",
    "paint.lineMode.line": "Marra",
    "paint.ovalMode.oval": "Zirkuloa",
    "paint.rectMode.rect": "Laukizuzena",
    "paint.reshapeMode.reshape": "Aldatu forma",
    "paint.roundedRectMode.roundedRect": "Laukizuzen biribildua",
    "paint.selectMode.select": "Hautatu",
    "paint.textMode.text": "Testua",
    "paint.colorPicker.swap": "Trukatu"
  },
  "fa": {
    "gui.alerts.lostPeripheralConnection": "اتصال اسکرچ به {extensionName} قطع شد.",
    "gui.alerts.tryAgain": "دوباره تلاش کنید",
    "gui.alerts.download": "دانلود",
    "gui.connection.reconnect": "اتصال دوباره",
    "gui.backpack.costumeLabel": "حالت",
    "gui.backpack.soundLabel": "صدا",
    "gui.backpack.scriptLabel": "برنامه",
    "gui.backpack.spriteLabel": "شکلک",
    "gui.backpack.header": "کوله پشتی",
    "gui.backpack.errorBackpack": "خطا در بارگیری کوله پشتی",
    "gui.backpack.loadingBackpack": "در حال بارگذاری...",
    "gui.backpack.more": "بیشتر",
    "gui.backpack.emptyBackpack": "کوله پشتی خالی است",
    "gui.unsupportedBrowser.label": "مرورگر پشتیبانی نمی‌شود",
    "gui.unsupportedBrowser.errorLabel": "خطایی رخ داد",
    "gui.unsupportedBrowser.notRecommended": "ما بسیار متاسفیم، اما به نظر می‌رسد شما از نسخه‌ای از یک مرورگر استفاده می‌کنید که اسکرچ را پشتیبانی نمی‌کند. توصیه می‌کنیم به آخرین نسخه‌ی مرورگر پشتیبانی شده مانند گوگل کروم، موزیلا فایرفاکس، مایکروسافت اج یا اپل سافاری به‌روزرسانی کنید.",
    "gui.unsupportedBrowser.description": "ما بسیار متاسفیم، اما اسکرچ از این مرورگر پشتیبانی نمی‌کند. توصیه می‌کنیم به آخرین نسخه‌ی مرورگر پشتیبانی شده‌ای مانند گوگل کروم، موزیلا فایرفاکس، مایکروسافت اج یا اپل سافاری به‌روزرسانی کنید.",
    "gui.unsupportedBrowser.back": "بازگشت",
    "gui.unsupportedBrowser.previewfaq": "برای یادگیری بیشتر، به {previewFaqLink} بروید.",
    "gui.unsupportedBrowser.previewfaqlinktext": "سوالات متداول",
    "gui.cards.all-tutorials": "آموزش‌ها",
    "gui.cards.shrink": "جمع کردن",
    "gui.cards.expand": "باز کردن",
    "gui.cards.close": "بستن",
    "gui.cards.more-things-to-try": "چیز‌های بیشتری را امتحان کنید!",
    "gui.cards.see-more": "بیشتر ببینید",
    "gui.comingSoon.message1": "نگران نباشید، ما داریم روی آن کار می‌کنیم {emoji}",
    "gui.comingSoon.message2": "به زودی...",
    "gui.comingSoon.message3": "ما در حال کار بر روی آن هستیم {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "هیچ دستگاهی پیدا نشد",
    "gui.connection.auto-scanning.prescan": "دستگاه خود را نزدیک نگه دارید، سپس شروع به جستجو کنید.",
    "gui.connection.auto-scanning.pressbutton": "دکمه‌ی روی دستگاه خود را فشار دهید.",
    "gui.connection.auto-scanning.start-search": "شروع جستجو",
    "gui.connection.connecting-searchbutton": "در حال جستجو ...",
    "gui.connection.auto-scanning.try-again": "دوباره تلاش کنید",
    "gui.connection.auto-scanning.updatePeripheralButton": "دستگاه من را به‌روز کنید",
    "gui.connection.connected": "متصل شد",
    "gui.connection.disconnect": "قطع",
    "gui.connection.go-to-editor": "برو به ویرایشگر",
    "gui.connection.connecting-cancelbutton": "در حال اتصال",
    "gui.connection.error.errorMessage": "ببخشید، به نظر می‌رسد که یک چیزی اشتباه شده است.",
    "gui.connection.error.tryagainbutton": "دوباره تلاش کنید",
    "gui.connection.error.helpbutton": "راهنما",
    "gui.connection.peripheral-name-label": "نام دستگاه",
    "gui.connection.connect": "اتصال",
    "gui.connection.scanning.lookingforperipherals": "در حال جستجوی دستگاه‌ها",
    "gui.connection.scanning.noPeripheralsFound": "هیچ دستگاهی پیدا نشد",
    "gui.connection.scanning.instructions": "دستگاه خود را از لیست زیر انتخاب کنید.",
    "gui.connection.search": "تازه کردن",
    "gui.connection.scanning.updatePeripheralButton": "دستگاه من را به‌روز کنید",
    "gui.connection.unavailable.installscratchlink": "مطمئن شوید که Scratch Link نصب و همچنین اجرا شده است.",
    "gui.connection.unavailable.enablebluetooth": "فعال بودن بلوتوث را بررسی کنید",
    "gui.connection.unavailable.tryagainbutton": "دوباره تلاش کنید",
    "gui.connection.unavailable.helpbutton": "راهنما",
    "gui.connection.updatePeripheral.microBitConnect": "{extensionName} خود را با استفاده از کابل USB به این دستگاه وصل کنید.",
    "gui.connection.updatePeripheral.pressUpdate": "دکمه «به‌روزرسانی کنید» را فشار دهید و اجازه دهید به‌روزرسانی کامل شود.",
    "gui.connection.updatePeripheral.progress": "در حال به‌روزرسانی {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "به‌روزرسانی موفقیت آمیز بود!",
    "gui.connection.updatePeripheral.updateFailed": "به‌روزرسانی ناموفق بود.",
    "gui.connection.updatePeripheral.goBackButton": "برگرد به عقب",
    "gui.connection.updatePeripheral.updateNowButton": "به‌روزرسانی کنید",
    "gui.connection.updatePeripheral.updateAgainButton": "دوباره تلاش کنید",
    "gui.controls.go": "برو",
    "gui.controls.stop": "توقف",
    "gui.crashMessage.label": "اوه! به نظر می‌رسد که چیزی اشتباه شده است.",
    "gui.crashMessage.description": "با عرض پوزش، به نظر می‌رسد که اسکرچ قفل کرده است. این ایراد به صورت خودکار به تیم اسکرچ گزارش خواهد شد. لطفا صفحه‌ی خود را برای تلاش مجدد تازه سازی کنید.",
    "gui.crashMessage.errorNumber": "خطای شما با شناسه‌ی {errorId} وارد شد.",
    "gui.crashMessage.reload": "بارگذاری مجدد",
    "gui.customProcedures.myblockModalTitle": "ایجاد یک قطعه",
    "gui.customProcedures.addAnInputNumberText": "افزودن یک ورودی",
    "gui.customProcedures.numberTextType": "عددی یا متنی",
    "gui.customProcedures.addAnInputBoolean": "افزودن یک ورودی",
    "gui.customProcedures.booleanType": "منطقی",
    "gui.customProcedures.addALabel": "افزودن یک برچسب",
    "gui.customProcedures.runWithoutScreenRefresh": "اجرا بدون تازه سازی صفحه",
    "gui.customProcedures.cancel": "لغو",
    "gui.customProcedures.ok": "تایید",
    "gui.SpriteInfo.direction": "جهت",
    "gui.directionPicker.rotationStyles.allAround": "همه طرف",
    "gui.directionPicker.rotationStyles.leftRight": "چپ/راست",
    "gui.directionPicker.rotationStyles.dontRotate": "گردش ممنوع",
    "gui.gui.addExtension": "اضافه کردن افزونه",
    "gui.gui.codeTab": "کد",
    "gui.gui.backdropsTab": "پس‌زمینه",
    "gui.gui.costumesTab": "حالت‌ها",
    "gui.gui.soundsTab": "صداها",
    "gui.extensionLibrary.comingSoon": "به زودی",
    "gui.extensionLibrary.requires": "مورد نیاز",
    "gui.extensionLibrary.collaboration": "همکاری با",
    "gui.library.filterPlaceholder": "جستجو",
    "gui.library.allTag": "همه",
    "gui.loader.message1": "در حال ایجاد قطعه‌‌ها...",
    "gui.loader.message2": "در حال بارگیری شکلک‌‌ها...",
    "gui.loader.message3": "در حال بارگیری صدا‌ها...",
    "gui.loader.message4": "در حال بارگیری افزونه‌‌ها...",
    "gui.loader.message5": "تو حوض خونه‌ی ما، ماهی‌های رنگارنگ ...",
    "gui.loader.message6": "جوجه جوجه طلایی، نوکت سرخ و حنایی ...",
    "gui.loader.message7": "صد دانه یاقوووت دسته به دسته ...",
    "gui.loader.message8": "در حال آماده کردن ایموجی‌ها...",
    "gui.loader.headline": "در حال بارگیری پروژه",
    "gui.loader.creating": "در حال ایجاد پروژه",
    "gui.accountMenu.profile": "نمایه",
    "gui.accountMenu.myStuff": "کارهای من",
    "gui.accountMenu.myClasses": "کلاس‌های من",
    "gui.accountMenu.myClass": "کلاس من",
    "gui.accountMenu.accountSettings": "تنظیمات حساب کاربری",
    "gui.accountMenu.signOut": "خروج",
    "gui.authorInfo.byUser": "توسط {username}",
    "gui.menuBar.seeProjectPage": "مشاهده صفحه‌‎ی پروژه",
    "gui.menuBar.language": "زبان",
    "general.username": "نام کاربری",
    "general.password": "رمز عبور",
    "general.signIn": "ورود",
    "login.needHelp": "کمک لازم دارید؟",
    "form.validationRequired": "این کادر مورد نیاز است",
    "gui.menuBar.tutorialsLibrary": "آموزش‌ها",
    "gui.menuBar.restoreSprite": "بازیابی شکلک ",
    "gui.menuBar.restoreSound": "بازیابی صدا",
    "gui.menuBar.restoreCostume": "بازیابی حالت",
    "gui.menuBar.restore": "بازیابی",
    "gui.menuBar.saveNow": "الان ذخیره کن",
    "gui.menuBar.saveAsCopy": "ذخیره به عنوان یک کپی",
    "gui.menuBar.remix": "باز‌ترکیب",
    "gui.menuBar.new": "جدید",
    "gui.menuBar.file": "فایل",
    "gui.menuBar.downloadToComputer": "ذخیره در کامپیوتر شما",
    "gui.menuBar.edit": "ویرایش",
    "gui.menuBar.turboModeOff": "خاموش کردن حالت سریع",
    "gui.menuBar.turboModeOn": "روشن کردن حالت سریع",
    "gui.menuBar.modeMenu": "حالت",
    "gui.menuBar.normalMode": "حالت عادی",
    "gui.menuBar.caturdayMode": "حالت روز گربه",
    "gui.menuBar.joinScratch": "پیوستن به اسکرچ",
    "gui.menuBar.signIn": "ورود",
    "gui.gui.projectTitlePlaceholder": "اینجا برای نام پروژه است",
    "gui.menuBar.saveNowLink": "الان ذخیره کن",
    "gui.menuBar.settings": "تنظیمات",
    "gui.menuBar.isShared": "به اشتراک گذاشته شده",
    "gui.menuBar.share": "به اشتراک گذاشتن",
    "gui.menuBar.colorMode": "حالت رنگ",
    "gui.modal.help": "راهنما",
    "gui.modal.back": "بازگشت",
    "gui.monitor.listMonitor.empty": "(خالی)",
    "gui.monitor.listMonitor.listLength": "طول {length}",
    "gui.monitor.contextMenu.default": "نمایشگر عادی",
    "gui.monitor.contextMenu.large": "نمایشگر بزرگ",
    "gui.monitor.contextMenu.slider": "اسلایدر",
    "gui.monitor.contextMenu.sliderRange": "تغییر محدوده‌ی اسلایدر",
    "gui.monitor.contextMenu.import": "خواندن داده‌ها از فایل",
    "gui.monitor.contextMenu.export": "ذخیره داده‌ها در فایل",
    "gui.monitor.contextMenu.hide": "پنهان شو",
    "gui.playButton.play": "پخش",
    "gui.playButton.stop": "توقف",
    "gui.gui.variableScopeOptionAllSprites": "برای همه‌ی شکلک‌ها",
    "gui.gui.variableScopeOptionSpriteOnly": "فقط برای این شکلک",
    "gui.gui.cloudVariableOption": "متغیر ابری (در سرور ذخیره می‌شود)",
    "gui.gui.variablePromptAllSpritesMessage": "این متغیر در دسترس همه‌ی شکلک‌ها خواهد بود.",
    "gui.gui.listPromptAllSpritesMessage": "این لیست در دسترس همه‌ی شکلک‌ها خواهد بود.",
    "gui.prompt.cancel": "لغو",
    "gui.prompt.ok": "تایید",
    "gui.playbackStep.stopMsg": "توقف",
    "gui.playbackStep.playMsg": "پخش",
    "gui.playbackStep.loadingMsg": "بارگذاری...",
    "gui.playbackStep.saveMsg": "ذخیره",
    "gui.playbackStep.reRecordMsg": "ضبط مجدد",
    "gui.recordModal.title": "ضبط صدا",
    "gui.recordingStep.beginRecord": "با کلیک روی دکمه‌ی زیر ضبط را شروع کنید",
    "gui.recordingStep.permission": "{arrow}برای استفاده از میکروفون شما، به اجازه‌ی شما نیاز داریم",
    "gui.recordingStep.stop": "توقف ضبط",
    "gui.recordingStep.record": "ضبط",
    "gui.sliderModal.min": "کم‌ترین مقدار",
    "gui.sliderModal.max": "بیشترین مقدار",
    "gui.sliderModal.title": "تغییر محدوده‌ی اسلایدر",
    "gui.sliderPrompt.cancel": "لغو",
    "gui.sliderPrompt.ok": "باشه",
    "gui.soundEditor.sound": "صدا",
    "gui.soundEditor.play": "پخش",
    "gui.soundEditor.stop": "توقف",
    "gui.soundEditor.copy": "کپی",
    "gui.soundEditor.paste": "جای‌گذاری",
    "gui.soundEditor.copyToNew": "کپی در صدایی جدید",
    "gui.soundEditor.delete": "حذف",
    "gui.soundEditor.save": "ذخیره",
    "gui.soundEditor.undo": "واگـرد",
    "gui.soundEditor.redo": "باز انجام",
    "gui.soundEditor.faster": "سریع‌تر",
    "gui.soundEditor.slower": "آهسته‌تر",
    "gui.soundEditor.echo": "پژواک",
    "gui.soundEditor.robot": "ربات",
    "gui.soundEditor.louder": "بلند‌تر",
    "gui.soundEditor.softer": "آرام‌تر",
    "gui.soundEditor.reverse": "معکوس",
    "gui.soundEditor.fadeOut": "محو شدن در انتها",
    "gui.soundEditor.fadeIn": "محو شدن در ابتدا",
    "gui.soundEditor.mute": "بی‌صدا",
    "gui.SpriteInfo.spritePlaceholder": "نام",
    "gui.SpriteInfo.showSpriteAction": "شکلک را نشان بده",
    "gui.SpriteInfo.hideSpriteAction": "شکلک را مخفی کن",
    "gui.SpriteInfo.sprite": "شکلک",
    "gui.SpriteInfo.show": "نمایش",
    "gui.SpriteInfo.size": "اندازه",
    "gui.spriteSelectorItem.contextMenuDuplicate": "تکثیر",
    "gui.spriteSelectorItem.contextMenuExport": "ذخیره در فایل",
    "gui.spriteSelectorItem.contextMenuDelete": "حذف",
    "gui.spriteSelector.addSpriteFromLibrary": "شکلکی را انتخاب کنید",
    "gui.spriteSelector.addSpriteFromPaint": "نقاشی",
    "gui.spriteSelector.addSpriteFromSurprise": "غافل‌گیر کننده",
    "gui.spriteSelector.addSpriteFromFile": "بارگذاری شکلک",
    "gui.stageHeader.stageSizeLarge": "تغییر به صحنه بزرگ",
    "gui.stageHeader.stageSizeSmall": "تغییر به صحنه کوچک",
    "gui.stageHeader.stageSizeFull": "ورود به نمای تمام صفحه",
    "gui.stageHeader.stageSizeUnFull": "خروج از نمای تمام صفحه",
    "gui.stageHeader.fullscreenControl": "نمای تمام صفحه",
    "gui.spriteSelector.addBackdropFromLibrary": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.stageSelector.addBackdropFromPaint": "نقاشی",
    "gui.stageSelector.addBackdropFromSurprise": "غافل‌گیر کننده",
    "gui.stageSelector.addBackdropFromFile": "بارگذاری پس‌زمینه",
    "gui.stageSelector.stage": "صحنه",
    "gui.stageSelector.backdrops": "پس‌زمینه‌ها",
    "gui.telemetryOptIn.label": "گزارش دادن آمار برای بهبود اسکرچ",
    "gui.telemetryOptIn.body1": "گروه اسکرچ همیشه به دنبال درک بهتر چگونگی استفاده از برنامه اسکرچ در سراسر دنیا، هستند. برای کمک به پشتیبانی از این تلاش، شما می‌توانید به برنامه‌ی اسکرچ اجازه دهید تا به‌طور خودکار،اطلاعات استفاده را به تیم اسکرچ ارسال نماید.",
    "gui.telemetryOptIn.body2": "اطلاعاتی که ما جمع آوری می کنیم شامل انتخاب زبان، استفاده از قطعه‌ها و بعضی رویدادها مانند ذخیره سازی، بارگذاری و آپلود کردن یک پروژه می‌شود. ما هیچ‌گونه اطلاعات شخصی را جمع آوری نمی‌کنیم. لطفاً برای اطلاعات بیشتر {privacyPolicyLink} را مشاهده کنید.",
    "gui.telemetryOptIn.privacyPolicyLink": "حریم خصوصی",
    "gui.telemetryOptIn.optInText": "اطلاعات استفاده من را با تیم اسکرچ به اشتراک بگذارید",
    "gui.telemetryOptIn.optInTooltip": "فعال کردن اندازه گیری از دور",
    "gui.telemetryOptIn.optOutText": "اطلاعات استفاده من را با تیم اسکرچ به اشتراک نگذارید",
    "gui.telemetryOptIn.optOutTooltip": "غیر‌فعال کردن اندازه گیری از دور",
    "gui.telemetryOptIn.settingWasUpdated": "تنظیمات شما به‌روز شد.",
    "gui.telemetryOptIn.buttonClose": "بستن",
    "gui.turboMode.active": "حالت سریع",
    "gui.webglModal.label": "مرورگری که شما استفاده می‌کنید، قابلیت WebGL را پشتیبانی نمی‌کند.",
    "gui.webglModal.description": "متأسفانه به نظر می‌رسد که مرورگر یا کامپیوتر شما {webGlLink}. این فناوری برای اجرای اسکرچ ۳٫۰ لازم است.",
    "gui.webglModal.webgllink": "قابلیت WebGL پشتیبانی نمی‌شود",
    "gui.webglModal.back": "برگشت",
    "gui.webglModal.previewfaq": "برای یادگیری بیشتر، به {previewFaqLink} بروید",
    "gui.webglModal.previewfaqlinktext": "سوالات متداول",
    "gui.costumeLibrary.chooseABackdrop": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.costumeLibrary.chooseACostume": "حالتی را انتخاب کنید",
    "gui.costumeTab.addBackdropFromLibrary": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.costumeTab.addCostumeFromLibrary": "حالتی را انتخاب کنید",
    "gui.costumeTab.addBlankCostume": "نقاشی",
    "gui.costumeTab.addSurpriseCostume": "غافل‌گیر کننده",
    "gui.costumeTab.addFileBackdrop": "آپلود پس‌زمینه",
    "gui.costumeTab.addFileCostume": "بارگذاری حالت",
    "gui.extensionLibrary.chooseAnExtension": "افزونه‌ای را انتخاب کنید",
    "gui.extensionLibrary.extensionUrl": "آدرس اینترنتی افزونه را وارد کنید",
    "gui.monitors.importListColumnPrompt": "کدام ستون باید استفاده شود (1-{numberOfColumns} ) ؟",
    "gui.recordingStep.alertMsg": "نمی‌توان ضبط را شروع کرد",
    "gui.soundLibrary.chooseASound": "صدایی را انتخاب کنید",
    "gui.soundTab.fileUploadSound": "بارگذاری صدا",
    "gui.soundTab.surpriseSound": "غافل‌گیر کننده",
    "gui.soundTab.recordSound": "ضبط",
    "gui.soundTab.addSoundFromLibrary": "صدایی را انتخاب کنید",
    "gui.spriteLibrary.chooseASprite": "شکلکی را انتخاب کنید",
    "gui.tipsLibrary.tutorials": "آموزشی را انتخاب کنید",
    "gui.alerts.createsuccess": "پروژه‌ای جدید ایجاد شد.",
    "gui.alerts.createcopysuccess": "کپی پروژه ذخیره شد.",
    "gui.alerts.createremixsuccess": "پروژه به‌عنوان یک بازترکیب ذخیره شد.",
    "gui.alerts.creating": "در حال ایجاد جدید ...",
    "gui.alerts.creatingCopy": "در حال ایجاد یک کپی از پروژه...",
    "gui.alerts.creatingRemix": "در حال بازترکیب پروژه...",
    "gui.alerts.creatingError": "نتوانستیم پروژه را بسازیم. لطفاً دوباره تلاش کنید!",
    "gui.alerts.savingError": "پروژه ذخیره نشد.",
    "gui.alerts.savesuccess": "پروژه ذخیره شد.",
    "gui.alerts.saving": "در حال ذخیره‌ی پروژه...",
    "gui.alerts.cloudInfo": "لطفاً توجه کنید، متغیرهای ابری فقط از اعداد پشتیبانی می‌کنند و حروف و علائم را پشتیبانی نمی‌کنند. {learnMoreLink} ",
    "gui.alerts.cloudInfoLearnMore": "بیشتر بدانید.",
    "gui.alerts.importing": "درحال وارد کردن...",
    "gui.defaultProject.meow": "میو",
    "gui.defaultProject.variable": "متغیر من",
    "gui.howtos.intro-move-sayhello-hat.name": "شروع کنید",
    "gui.howtos.intro-move.step_stepMove": "یک قطعه‌ی حرکت اضافه کنید",
    "gui.howtos.add-a-move-block.step_stepSay": "دستور «بگو» را اضافه کنید",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "برای شروع پرچم سبز را کلیک کنید ",
    "gui.howtos.intro-getting-started-ASL.name": "شروع به کار - زبان اشاره آمریکایی",
    "gui.howtos.animate-a-name.name": "متحرک‌سازی یک اسم",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "یک شکلک حرف بردارید",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "وقتی که کلیک شد صدایی را پخش کنید",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "یک شکلک حرف دیگر بردارید",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "رنگش رو عوض کن",
    "gui.howtos.animate-a-name.step_AnimateSpin": "یک شکلک حرف دیگر بردار و بچرخانش",
    "gui.howtos.animate-a-name.step_AnimateGrow": "یک شکلک حرف دیگری رو بردار و درشتش کن",
    "gui.howtos.imagine": "دنیایی خیالی",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "آنچه می‌خواهید بگویید را تایپ کنید",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "برای شروع پرچم سبز را کلیک کنید ",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "هر شکلکی را که می‌خواهید انتخاب کنید",
    "gui.howtos.imagine.step_imagineChooseSprite": "هر شکلکی را که میخواهید را انتخاب کنید",
    "gui.howtos.imagine.step_imagineFlyAround": "برای سرخوردن کلید فاصله را فشار دهید",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "شکلک دیگری را انتخاب کنید",
    "gui.howtos.imagine.step_imagineLeftRight": "به چپ - راست حرکت کنید",
    "gui.howtos.imagine.step_imagineUpDown": "به بالا - پایین حرکت کنید",
    "gui.howtos.imagine.step_imagineChangeCostumes": "حالت‌ها را تغییر بده",
    "gui.howtos.imagine.step_imagineGlideToPoint": "به نقطه‌ای سر بخور",
    "gui.howtos.imagine.step_imagineGrowShrink": "چیزها را بزرگ‌ و کوچک‌ کن",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "پس‌زمینه‌ی دیگری را انتخاب کنید",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "پس‌زمینه‌ها را عوض کن",
    "gui.howtos.imagine.step_imagineRecordASound": "صدایی را اضافه کنید",
    "gui.howtos.imagine.step_imagineChooseSound": "صدای خودتان را انتخاب کنید",
    "gui.howtos.make-music.name": "ساختن موسیقی",
    "gui.howtos.Make-Music.step_PickInstrument": "سازی را انتخاب کن",
    "gui.howtos.Make-Music.step_PlaySoundClick": "وقتی که کلیک شد صدایی را پخش کن",
    "gui.howtos.Make-Music.step_MakeSong": "آوازی بساز",
    "gui.howtos.make-music.step_MakeBeat": "یک طبل را انتخاب کن و یک ضرب موسیقی بساز",
    "gui.howtos.make-music.step_MakeBeatBox": "شکلک میکروفون را انتخاب کن و با تقلید صدای ساز‌ها با دهان خود، هنرنمایی کن",
    "gui.howtos.story.name": "ساخت یک داستان",
    "gui.howtos.story.step_addbg": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.story.step_addsprite": "افزودن یک شخصیت ",
    "gui.howtos.story.step_saysomething": "چیزی بگو",
    "gui.howtos.story.step_addanothersprite": "افزودن یک شخصیت دیگر",
    "gui.howtos.story.step_flip": "برگرداندن جهت",
    "gui.howtos.story.step_conversation": "یک مکالمه داشته باشید",
    "gui.howtos.story.addanotherbg": "پس‌زمینه‌‌ی دیگری را انتخاب کنید",
    "gui.howtos.story.step_swithbg": "تغییر پس‌زمینه‌ها",
    "gui.howtos.story.step_hidewizard": "مخفی کردن یک شخصیت",
    "gui.howtos.story.step_showwizard": "نمایش یک شخصیت",
    "gui.howtos.make-a-chase-game.name": "بازی دنبال کردن",
    "gui.howtos.Chase-Game.step_BG": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.chase-game.step_AddOcto": "شکلکی را اضافه کنید",
    "gui.howtos.make-music.step_LeftRight": "با کلید‌های جهت‌دار به راست و چپ حرکت کنید",
    "gui.howtos.Chase-Game.step_UpDown": "با کلیدهای جهت‌دار به بالا و پایین حرکت کنید",
    "gui.howtos.Chase-Game.step_AddStar": "یک شکلک دیگر اضافه کنید",
    "gui.howtos.Chase-Game.step_MoveRandom": "تصادفی حرکت کنید",
    "gui.howtos.Chase-Game.step_WhenTouch": "در شکلک هشت‌پا، صدایی در هنگام برخورد پخش می‌شود",
    "gui.howtos.Chase-Game.step_ScoreVariable": "یک متغیر امتیاز ایجاد کنید",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "در شکلک هشت‌پا، امتیاز در برخورد اضافه می‌شود",
    "gui.howtos.animate-char.name": "متحرک‌سازی یک بازیگر",
    "gui.howtos.animate-char.step_addbg": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.animate-char.step_addsprite": "شکلکی را اضافه کنید",
    "gui.howtos.animate-char.step_saysomething": "چیزی بگو",
    "gui.howtos.animate-char.step_addsound": "افزودن صدا",
    "gui.howtos.animate-char.step_animatetalking": "اینطوری می‌تونه حرف بزنه",
    "gui.howtos.animate-char.step_arrowkeys": "حرکت با کلیدهای جهت‌دار",
    "gui.howtos.animate-char.step_jump": "پریدن",
    "gui.howtos.animate-char.step_changecolor": "رنگش رو عوض کن",
    "gui.howtos.make-a-game.name": "ساخت بازی کلیکی",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "یک شکلک را بردار",
    "gui.howtos.make-a-game.step_GamePlaySound": "وقتی که کلیک شد صدا را پخش کن",
    "gui.howtos.make-a-game.step_GameAddScore": "یک متغیر امتیاز ایجاد کنید",
    "gui.howtos.make-a-game.step_GameChangeScore": "وقتی که کلیک شد امتیاز را اضافه کن",
    "gui.howtos.make-a-game.step_Random": "برو به یک موقعیت تصادفی",
    "gui.howtos.make-music.step_GameChangeColor": "رنگش رو عوض کن",
    "gui.howtos.make-music.step_ResetScore": "بازنشانی امتیاز",
    "gui.howtos.make-it-fly.name": "پرواز کردن",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "یک پس‌زمینه آسمان انتخاب کنید",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "بازیگری را انتخاب کنید",
    "gui.howtos.fly.step_stepflySaySomething": "چیزی بگو",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "با کلیدهای جهت حرکت کن",
    "gui.howtos.fly.step_stepflyChooseObject": "یک شی برای جمع‌آوری انتخاب کنید",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "شی را به حرکت در آورید",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "کاراکتر خود را انتخاب کنید",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "یک امتیاز اضافه کن",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "نگه‌داری امتیاز",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "چشم‌انداز اضافه کنید",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "صحنه را حرکت بده",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "حالت بعدی",
    "gui.howtos.pong": "بازی پینگ پونگ",
    "gui.howtos.pong.step_pongAddBackdrop": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.pong.step_pongAddBallSprite": "شکلک توپ را اضافه کنید",
    "gui.howtos.pong.step_pongBounceAround": "این طرف و آن طرف بپر",
    "gui.howtos.pong.step_pongAddPaddle": "یک راکت اضافه کن",
    "gui.howtos.pong.step_pongMoveThePaddle": "راکت را حرکت بده",
    "gui.howtos.pong.step_pongSelectBallSprite": "شکلک توپ را انتخاب کنید",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "کدی اضافه کنید تا توپ از روی راکت بپرد",
    "gui.howtos.pong.step_pongAddAScore": "یک امتیاز اضافه کن",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "\"امتیاز\" را از منو انتخاب کنید",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "بلوک «تغییر امتیاز» را وارد کنید",
    "gui.howtos.pong.step_pongResetScore": "بازنشانی امتیاز",
    "gui.howtos.pong.step_pongAddLineSprite": "شکلک خط را اضافه کنید",
    "gui.howtos.pong.step_pongGameOver": "بازی تمام شد",
    "gui.howtos.code-cartoon": "برنامه‌نویسی کارتون",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "با کلیک کردن روی پرچم سبزی، چیزی را بگو",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "متحرک‌سازی یک بازیگر، وقتی که وی آن کلیک می‌کنید",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "انتخاب یک شخصیت دیگه",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "برای کوچک کردن، از علامت منفی استفاده کن",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "بازیگری رو بزرگ‌تر و کوچک کن",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "انتخاب یک شخصیت دیگه",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "بپر بالا و پایین",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "روی یک شخصیت کلیک کن تا صحنه رو عوض کنی",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "به اطراف سُر بخورید",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "حالت‌ها رو تغییر بده",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "به کارتونی که ساختی بازیگرهای بیشتری رو اضافه کن",
    "gui.howtos.cartoon-network": "متحرک‌سازی بازی ماجراجویی",
    "gui.howtos.cartoon-network.step_CNcharacter": "یک شخصیت را برای نمایش دادن انتخاب کنید",
    "gui.howtos.cartoon-network.step_CNsay": "چیزی بگو",
    "gui.howtos.cartoon-network.step_CNglide": "سر خوردن در اطراف",
    "gui.howtos.cartoon-network.step_CNpicksprite": "چیزی را برای تعقیب کردن انتخاب کنید",
    "gui.howtos.cartoon-network.step_CNcollect": "جمع آوری اشیا",
    "gui.howtos.cartoon-network.step_CNvariable": "یک متغیر امتیاز بسازید",
    "gui.howtos.cartoon-network.step_CNscore": "نگه‌داری امتیاز",
    "gui.howtos.cartoon-network.step_CNbackdrop": "سطح بالا : تغییر پس‌زمینه",
    "gui.howtos.videosens.name": "تشخیص ویدئویی",
    "gui.howtos.videosens.step_addextension": "اضافه کردن افزونه",
    "gui.howtos.videosens.step_pet": "حیوان خانگی گربه",
    "gui.howtos.videosens.step_animate": "متحرک‌سازی",
    "gui.howtos.videosens.step_pop": "ترکاندن یک بادکنک",
    "gui.howtos.say-it-out-loud": "ساخت انیمیشنی که صحبت می‌کند",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "قطعه‌های تبدیل متن به گفتار را اضافه کنید",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "چیزی بگو",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "صدایی را انتخاب کنید.",
    "gui.howtos.say-it-out-loud.step_TXTMove": "در اطراف حرکت کن",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "افزودن یک شخصیت دیگر",
    "gui.howtos.say-it-out-loud.step_TXTSong": "آوازی رو اجرا کن",
    "gui.howtos.say-it-out-loud.step_TXTColor": "رنگش رو عوض کن",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "چرخیدن در اطراف",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "چیزها را بزرگ‌ و کوچک‌ کن",
    "gui.howtos.talking": "صداگذاری در قصه‌ها",
    "gui.howtos.talking.step_talesAddExtension": "برای اضافه کردن بلوک \"تبدیل متن به گفتار\"، کلیک کن",
    "gui.howtos.talking.step_talesChooseSprite": "شکلکی را انتخاب کنید",
    "gui.howtos.talking.step_talesSaySomething": " بازیگری بساز تا بتونه حرف بزنه",
    "gui.howtos.talking.step_talesChooseBackdrop": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.talking.step_talesSwitchBackdrop": "روی یک شخصیت کلیک کن تا بری به پشت صحنه بعدی",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "شکلک دیگری را انتخاب کنید",
    "gui.howtos.talking.step_talesMoveAround": "حرکت در اطراف",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "پس‌زمینه‌ی دیگری را انتخاب کنید",
    "gui.howtos.talking.step_talesAnimateTalking": "اینطوری می‌تونه حرف بزنه",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "پس‌زمینه‌ی دیگری را انتخاب کنید",
    "gui.howtos.talking.step_talesChooseSound": "آهنگی رو برای رقصیدنش انتخاب کن",
    "gui.howtos.talking.step_talesDanceMoves": "اینطوری می‌رقصه",
    "gui.howtos.talking.step_talesAskAnswer": "بلوک بپرس و پاسخ رو از گروه تشخیص بردار",
    "gui.howtos.add-sprite.name": "شکلکی اضافه کنید",
    "gui.howtos.add-sprite.step_addSprite": "شکلکی را اضافه کنید",
    "gui.howtos.add-a-backdrop.name": "اضافه کردن پس‌زمینه‌",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "پس‌زمینه‌ای را انتخاب کنید",
    "gui.howtos.change-size.name": "تغییر اندازه",
    "gui.howtos.change-size.step_changeSize": "تغییر اندازه",
    "gui.howtos.glide-around.name": "گشت و گذاری به اطراف",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "به اطراف سُر بخورید",
    "gui.howtos.change-size.step_glideAroundPoint": "به نقطه‌ای سر بخور",
    "gui.howtos.record-a-sound.name": "ضبط یک صدا",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "روی زبانه \"صداها\" کلیک کنید",
    "gui.howtos.change-size.step_recordASoundClickRecord": "\"ضبط کردن\" را کلیک کنید",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "دکمه ضبط را فشار دهید",
    "gui.howtos.change-size.step_recordASoundChooseSound": "صدای خودتان را انتخاب کنید",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "صدای خودتان را پخش کنید",
    "gui.howtos.spin-video.name": "آن را بچرخان",
    "gui.howtos.change-size.step_spinTurn": "بچرخ",
    "gui.howtos.change-size.step_spinPointInDirection": "جهت را تنظیم کنید",
    "gui.howtos.hide-and-show.name": "پنهان کردن و نمایش دادن",
    "gui.howtos.change-size.step_hideAndShow": "پنهان کردن و نمایش دادن",
    "gui.howtos.switch-costume.name": "متحرک‌سازی بازیگر",
    "gui.howtos.change-size.step_switchCostumes": "شکلکی را به حرکت در آورید.",
    "gui.howtos.move-around-with-arrow-keys.name": "استفاده از کلید‌های جهت‌دار",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "به چپ و راست حرکت کن",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "به بالا و پایین حرکت کن",
    "gui.howtos.add-effects.name": "کار با جلوه‌ها",
    "gui.howtos.videosens.step_addEffects": "جلوه‌ای را اضافه کن",
    "gui.extension.music.name": "موسیقی",
    "gui.extension.music.description": "ساز‌ها و طبل‌ها را بنوازید.",
    "gui.extension.pen.name": "قلم",
    "gui.extension.pen.description": "شکلک‌های خودتان را نقاشی کنید.",
    "gui.extension.videosensing.name": "تشخیص ویدئویی",
    "gui.extension.videosensing.description": "حرکتی را با دوربین تشخیص دهید.",
    "gui.extension.text2speech.name": "متن به گفتار",
    "gui.extension.text2speech.description": "پروژه‌های خود را سخن‌گو کنید.",
    "gui.extension.translate.name": "ترجمه",
    "gui.extension.translate.description": "متنی را به زبان‌های مختلف ترجمه کنید.",
    "gui.extension.makeymakey.description": "همه چیز را درون یک کلید قرار دهید.",
    "gui.extension.microbit.description": "پروژه‌تان را به دنیای فیزیکی متصل کنید.",
    "gui.extension.microbit.connectingMessage": "درحال اتصال",
    "gui.extension.ev3.description": "ربات‌های قابل هدایت و ... بسازید.",
    "gui.extension.ev3.connectingMessage": "در حال اتصال. مطمئن شوید که مقدار پین دستگاه EV3 شما به 1234 تنظیم شده است.",
    "gui.extension.boost.description": "به ساخته‌های رباتی زندگی ببخشید.",
    "gui.extension.boost.connectingMessage": "درحال اتصال",
    "gui.extension.wedo2.description": "با موتور‌ها و حسگر‌ها بسازید.",
    "gui.extension.wedo2.connectingMessage": "درحال اتصال",
    "gui.extension.gdxfor.description": "تشخیص فشار، کشش، حرکت و چرخش.",
    "gui.extension.gdxfor.connectingMessage": "درحال اتصال",
    "gui.libraryTags.all": "همه",
    "gui.libraryTags.animals": "حیوانات",
    "gui.libraryTags.dance": "رقص",
    "gui.libraryTags.effects": "جلوه‌ها",
    "gui.libraryTags.fantasy": "خیالی",
    "gui.libraryTags.fashion": "سبک",
    "gui.libraryTags.food": "خوراکی",
    "gui.libraryTags.indoors": "داخل خانه",
    "gui.libraryTags.loops": "تکرار شونده",
    "gui.libraryTags.music": "موسیقی",
    "gui.libraryTags.notes": "نت‌ها",
    "gui.libraryTags.outdoors": "بیرون",
    "gui.libraryTags.patterns": "الگو‌ها",
    "gui.libraryTags.people": "مردم",
    "gui.libraryTags.percussion": "موسیقی ضربی",
    "gui.libraryTags.space": "فضایی",
    "gui.libraryTags.sports": "ورزش‌ها",
    "gui.libraryTags.underwater": "زیر آب",
    "gui.libraryTags.voice": "صدا",
    "gui.libraryTags.wacky": "گیج",
    "gui.libraryTags.animation": "انمیشن",
    "gui.libraryTags.art": "هنری",
    "gui.libraryTags.games": "بازی‌ها",
    "gui.libraryTags.stories": "داستان‌ها",
    "gui.libraryTags.letters": "حروف",
    "gui.opcodeLabels.direction": "جهت",
    "gui.opcodeLabels.xposition": "موقعیت x",
    "gui.opcodeLabels.yposition": "موقعیت y",
    "gui.opcodeLabels.size": "اندازه",
    "gui.opcodeLabels.costumename": "نام حالت",
    "gui.opcodeLabels.costumenumber": "شماره‌ی حالت",
    "gui.opcodeLabels.backdropname": "نام پس‌زمینه",
    "gui.opcodeLabels.backdropnumber": "شماره‌ی پس‌زمینه",
    "gui.opcodeLabels.volume": "بلندی صدا",
    "gui.opcodeLabels.tempo": "سرعت نواختن",
    "gui.opcodeLabels.answer": "پاسخ",
    "gui.opcodeLabels.loudness": "بلندی صدا",
    "gui.opcodeLabels.username": "نام کاربری",
    "gui.opcodeLabels.year": "سال",
    "gui.opcodeLabels.month": "ماه",
    "gui.opcodeLabels.date": "تاریخ",
    "gui.opcodeLabels.dayofweek": "روز هفته",
    "gui.opcodeLabels.hour": "ساعت",
    "gui.opcodeLabels.minute": "دقیقه",
    "gui.opcodeLabels.second": "ثانیه",
    "gui.opcodeLabels.timer": "زمان‌سنج",
    "gui.projectLoader.loadError": "خطا در بارگذاری فایل پروژه‌ انتخاب شده ",
    "gui.sharedMessages.backdrop": "پس‌زمینه‌ی {index}",
    "gui.sharedMessages.costume": "حالت {index}",
    "gui.sharedMessages.sprite": "شکلک {index}",
    "gui.sharedMessages.pop": "ترکیدن",
    "gui.sharedMessages.replaceProjectWarning": "محتویات پروژه فعلی جایگزین گردد؟",
    "gui.sharedMessages.loadFromComputerTitle": "بارگذاری از کامپیوتر شما",
    "gui.theme.default": "اصلی",
    "gui.theme.dark": "تیره",
    "gui.theme.highContrast": "تضاد شدید",
    "gui.gui.defaultProjectTitle": "پروژه‌ی اسکرچ",
    "boost.color.any": "هر رنگی",
    "boost.color.black": "سیاه",
    "boost.color.blue": "آبی",
    "boost.color.green": "سبز",
    "boost.color.red": "قرمز",
    "boost.color.white": "سفید",
    "boost.color.yellow": "زرد",
    "boost.getMotorPosition": " موقعیت [MOTOR_REPORTER_ID]  موتور",
    "boost.getTiltAngle": "زاویه‌ی کج شدن [TILT_DIRECTION]",
    "boost.motorDirection.backward": "پادساعتگرد",
    "boost.motorDirection.forward": "ساعتگرد",
    "boost.motorDirection.reverse": "برعکس",
    "boost.motorOff": "موتور  [MOTOR_ID] خاموش شود",
    "boost.motorOn": "موتور  [MOTOR_ID] روشن شود",
    "boost.motorOnFor": "موتور  [MOTOR_ID] به‌ مدت [DURATION] ثانیه بچرخد",
    "boost.motorOnForRotation": "موتور [MOTOR_ID] [ROTATION] دور بچرخد",
    "boost.seeingColor": "قطعه [COLOR] را دید؟",
    "boost.setLightHue": "رنگ [HUE] شود",
    "boost.setMotorDirection": "جهت موتور [MOTOR_ID] [MOTOR_DIRECTION] شود",
    "boost.setMotorPower": "سرعت موتور  [MOTOR_ID] % [POWER] شود",
    "boost.tiltDirection.any": "هر سمتی",
    "boost.tiltDirection.down": "پایین",
    "boost.tiltDirection.left": "به سمت چپ",
    "boost.tiltDirection.right": "به سمت راست",
    "boost.tiltDirection.up": "بالا",
    "boost.whenColor": "وقتی قطعه‌ی [COLOR] را دید",
    "boost.whenTilted": "وقتی [TILT_DIRECTION_ANY] کج شد",
    "ev3.beepNote": "نت [NOTE] را به مدت [TIME] ثانیه بزن",
    "ev3.buttonPressed": "دکمه‌ی [PORT] فشرده شده؟",
    "ev3.getBrightness": "روشنایی",
    "ev3.getDistance": "فاصله",
    "ev3.getMotorPosition": "موقعیت موتور [PORT]",
    "ev3.motorSetPower": "قدرت موتور [PORT] % [POWER] شود",
    "ev3.motorTurnClockwise": "موتور [PORT] به مدت [TIME] ثانیه ساعتگرد بچرخد",
    "ev3.motorTurnCounterClockwise": "موتور [PORT] به مدت [TIME] ثانیه پادساعتگرد بچرخد",
    "ev3.whenBrightnessLessThan": "وقتی  [DISTANCE] > روشنایی",
    "ev3.whenButtonPressed": "وقتی دکمه‌ی [PORT] فشار داده شد",
    "ev3.whenDistanceLessThan": "وقتی  [DISTANCE] > فاصله",
    "gdxfor.getAcceleration": "شتاب [DIRECTION]",
    "gdxfor.getForce": "نیرو",
    "gdxfor.getSpin": "سرعت چرخش [DIRECTION]",
    "gdxfor.getTilt": "زاویه‌ی شیب [TILT]",
    "gdxfor.isFreeFalling": "در حال سقوطه؟",
    "gdxfor.isTilted": "[TILT] کج شده؟",
    "gdxfor.pulled": "کشیده شد",
    "gdxfor.pushed": "فشرده",
    "gdxfor.shaken": "تکان داده شد",
    "gdxfor.startedFalling": "سقوط شروع شد",
    "gdxfor.tiltDirectionMenu.any": "هر سمتی",
    "gdxfor.tiltDirectionMenu.back": "به سمت عقب",
    "gdxfor.tiltDirectionMenu.front": "به سمت جلو",
    "gdxfor.tiltDirectionMenu.left": "به سمت چپ",
    "gdxfor.tiltDirectionMenu.right": "به سمت راست",
    "gdxfor.turnedFaceDown": "رو به پایین شد",
    "gdxfor.turnedFaceUp": "رو به بالا شد",
    "gdxfor.whenForcePushedOrPulled": "وقتی حسگر نیرو [PUSH_PULL]",
    "gdxfor.whenGesture": "وقتی [GESTURE]",
    "gdxfor.whenTilted": "وقتی  [TILT] کج شد",
    "makeymakey.downArrow": "جهت پایین",
    "makeymakey.downArrowShort": "پایین",
    "makeymakey.leftArrow": "جهت چپ",
    "makeymakey.leftArrowShort": "چپ",
    "makeymakey.rightArrow": "جهت راست",
    "makeymakey.rightArrowShort": "راست",
    "makeymakey.spaceKey": "فاصله",
    "makeymakey.upArrow": "جهت بالا",
    "makeymakey.upArrowShort": "بالا",
    "makeymakey.whenKeyPressed": "وقتی کلید [KEY] فشرده شد",
    "makeymakey.whenKeysPressedInOrder": "وقتی [SEQUENCE] به ترتیب فشرده شدند",
    "microbit.buttonsMenu.any": "A یا B",
    "microbit.clearDisplay": "پاک کردن صفحه‌ی نمایش",
    "microbit.defaultTextToDisplay": "Salam!",
    "microbit.displaySymbol": "نمایش [MATRIX]",
    "microbit.displayText": "نمایش متن [TEXT]",
    "microbit.gesturesMenu.jumped": "پرید",
    "microbit.gesturesMenu.moved": "حرکت کرد",
    "microbit.gesturesMenu.shaken": "تکان داده شد",
    "microbit.isButtonPressed": "دکمه‌ی [BTN] فشار داده شد؟",
    "microbit.isTilted": "[DIRECTION] کج شد؟",
    "microbit.pinStateMenu.off": "خاموش",
    "microbit.pinStateMenu.on": "روشن",
    "microbit.tiltAngle": "زاویه‌ی شیب [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "هر سمتی",
    "microbit.tiltDirectionMenu.back": "به سمت عقب",
    "microbit.tiltDirectionMenu.front": "به سمت جلو",
    "microbit.tiltDirectionMenu.left": "به سمت چپ",
    "microbit.tiltDirectionMenu.right": "به سمت راست",
    "microbit.whenButtonPressed": "وقتی دکمه [BTN] فشار داده شد",
    "microbit.whenGesture": "وقتی [GESTURE]",
    "microbit.whenPinConnected": "وقتی پین [PIN] وصل شد",
    "microbit.whenTilted": "وقتی [DIRECTION] کج شد",
    "music.categoryName": "موسیقی",
    "music.changeTempo": "تغییر سرعت نواختن به اندازه [TEMPO] تا",
    "music.drumBass": "(2) طبل بزرگ بم",
    "music.drumBongo": "(13) طبل بانگو",
    "music.drumCabasa": "(15) جغجغه‌ی کاباسا",
    "music.drumClaves": "(9) چوب‌های کلیوز",
    "music.drumClosedHiHat": "(6) ضرب دوسنج موازی نزدیک به هم",
    "music.drumConga": "(14) تیمپوی مدل کنگا",
    "music.drumCowbell": "(11) زنگ مدل کبل",
    "music.drumCrashCymbal": "(4) سنج تک پایه دار",
    "music.drumCuica": "(18) طبل مدل کویکا",
    "music.drumGuiro": "(16) جغجغه‌ی چوبی گویرو",
    "music.drumHandClap": "(8) دست زدن",
    "music.drumOpenHiHat": "(5) سنج دوگانه‌ی موازی ضربه‌ای با چوب",
    "music.drumSideStick": "(3) ضربه ی کنار چوب ",
    "music.drumSnare": "(1) طبل کوچک",
    "music.drumTambourine": "(7) دایره زنگی",
    "music.drumTriangle": "(12) زنگ مثلثی",
    "music.drumVibraslap": "(17) ضربه‌ی ارتعاشی",
    "music.drumWoodBlock": "(10) قطعه‌ی چوب ",
    "music.getTempo": "سرعت نواختن",
    "music.instrumentBass": "(6) گیتار بیس",
    "music.instrumentBassoon": "(14) باسون",
    "music.instrumentCello": "(8) ویولن سل",
    "music.instrumentChoir": "(15) گروه کر",
    "music.instrumentClarinet": "(10) کلارینت",
    "music.instrumentElectricGuitar": "(5) گیتار الکتریک",
    "music.instrumentElectricPiano": "(2) پیانو الکتریک",
    "music.instrumentFlute": "(12) فلوت",
    "music.instrumentGuitar": "(4) گیتار",
    "music.instrumentMarimba": "(19) سنتور چوبی آفریقایی مدل ماریمبا",
    "music.instrumentMusicBox": "(17) جعبه‌ی موسیقی",
    "music.instrumentOrgan": "(3) ارگ",
    "music.instrumentPiano": "(1) پیانو",
    "music.instrumentPizzicato": "(7)صدای پیتزیکاتو",
    "music.instrumentSaxophone": "(11) ساکسیفون",
    "music.instrumentSteelDrum": "(18) طبل فولادی",
    "music.instrumentSynthLead": "(20) صدای زیر ساز برقی ",
    "music.instrumentSynthPad": "(21) صدای پایدار ساز برقی",
    "music.instrumentTrombone": "(9) ترومبون",
    "music.instrumentVibraphone": "(16) ویبرافون",
    "music.instrumentWoodenFlute": "(13) فلوت چوبی",
    "music.midiPlayDrumForBeats": "نواختن درامز [DRUM] در مدت [BEATS] ضرب",
    "music.midiSetInstrument": "ساز [INSTRUMENT] شود",
    "music.playDrumForBeats": "نواختن درامز [DRUM] در مدت [BEATS] ضرب",
    "music.playNoteForBeats": "نواختن نت [NOTE] در مدت  [BEATS] ضرب",
    "music.restForBeats": " [BEATS] ضرب سکوت کن",
    "music.setInstrument": "ساز  [INSTRUMENT] شود",
    "music.setTempo": "سرعت نواختن [TEMPO] شود",
    "pen.categoryName": "قلم",
    "pen.changeColorParam": "تغییر [COLOR_PARAM] قلم به اندازه [VALUE] تا",
    "pen.changeHue": "تغییر رنگ قلم به اندازه [HUE] تا",
    "pen.changeShade": "تغییر سایه قلم به اندازه [SHADE] تا",
    "pen.changeSize": "تغییر ضخامت قلم به اندازه [SIZE] تا",
    "pen.clear": "همه را پاک کن",
    "pen.colorMenu.brightness": "روشنایی",
    "pen.colorMenu.color": "رنگ",
    "pen.colorMenu.saturation": "شدت رنگ",
    "pen.colorMenu.transparency": "شفافیت",
    "pen.penDown": "قلم پایین بیاید",
    "pen.penUp": "قلم بالا برود",
    "pen.setColor": "رنگ قلم [COLOR] شود",
    "pen.setColorParam": "[COLOR_PARAM] [VALUE] شود",
    "pen.setHue": "رنگ قلم [HUE] شود",
    "pen.setShade": "سایه‌ی قلم [SHADE] شود",
    "pen.setSize": "ضخامت قلم [SIZE] شود",
    "pen.stamp": "مُـهـر بزن",
    "speech.defaultWhenIHearValue": "بیایید شروع کنیم",
    "speech.extensionName": "گفتار به متن",
    "speech.listenAndWait": "بشنو و منتظر بمان",
    "speech.speechReporter": "گفتار",
    "speech.whenIHear": "وقتی من [PHRASE] را شنیدم",
    "text2speech.alto": "زیر",
    "text2speech.categoryName": "متن به گفتار",
    "text2speech.defaultTextToSpeak": "سلام",
    "text2speech.giant": "غول",
    "text2speech.kitten": "بچه گربه‌ای",
    "text2speech.setLanguageBlock": "زبان [LANGUAGE] شود",
    "text2speech.setVoiceBlock": "صدا [VOICE] شود",
    "text2speech.speakAndWaitBlock": "بگو [WORDS]",
    "text2speech.squeak": "کودکانه",
    "text2speech.tenor": "بم",
    "translate.categoryName": "ترجمه",
    "translate.defaultTextToTranslate": "سلام",
    "translate.translateBlock": " ترجمه کن [WORDS] را به [LANGUAGE]",
    "translate.viewerLanguage": "زبان",
    "videoSensing.categoryName": "تشخیص ویدئو",
    "videoSensing.direction": "جهت",
    "videoSensing.motion": "حرکت",
    "videoSensing.off": "خاموش",
    "videoSensing.on": "روشن",
    "videoSensing.onFlipped": "روشن و قرینه",
    "videoSensing.setVideoTransparency": "شفافیت ویدئو [TRANSPARENCY] شود",
    "videoSensing.sprite": "شکلک",
    "videoSensing.stage": "صحنه",
    "videoSensing.videoOn": "[ATTRIBUTE]  ویدئو بر روی [SUBJECT]",
    "videoSensing.videoToggle": "تشخیص ویدئویی [VIDEO_STATE] شود",
    "videoSensing.whenMotionGreaterThan": "وقتی  [REFERENCE] < حرکت ویدئو",
    "wedo2.getDistance": "فاصله",
    "wedo2.getTiltAngle": "زاویه‌ ی کج شدن [TILT_DIRECTION]",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] کج شده؟",
    "wedo2.motorDirection.backward": "پادساعتگرد",
    "wedo2.motorDirection.forward": "ساعتگرد",
    "wedo2.motorDirection.reverse": "برعکس",
    "wedo2.motorId.a": "موتور A",
    "wedo2.motorId.all": "همه‌ی موتورها",
    "wedo2.motorId.b": "موتور B",
    "wedo2.motorId.default": "موتور",
    "wedo2.motorOff": "[MOTOR_ID] خاموش شود",
    "wedo2.motorOn": " [MOTOR_ID] روشن شود",
    "wedo2.motorOnFor": "روشن کردن [MOTOR_ID] به مدت [DURATION] ثانیه",
    "wedo2.playNoteFor": "نواختن نت [NOTE] در مدت [DURATION] ثانیه",
    "wedo2.setLightHue": "رنگ نور [HUE] شود",
    "wedo2.setMotorDirection": "جهت [MOTOR_ID] [MOTOR_DIRECTION] شود",
    "wedo2.startMotorPower": "قدرت [MOTOR_ID] [POWER] شود",
    "wedo2.tiltDirection.any": "هر سمتی",
    "wedo2.tiltDirection.down": "پایین",
    "wedo2.tiltDirection.left": "چپ",
    "wedo2.tiltDirection.right": "راست",
    "wedo2.tiltDirection.up": "بالا",
    "wedo2.whenDistance": "وقتی [REFERENCE] [OP] فاصله‌",
    "wedo2.whenTilted": "وقتی به [TILT_DIRECTION_ANY] کج شد",
    "paint.paintEditor.hue": "رنگ",
    "paint.paintEditor.saturation": "شدت رنگ",
    "paint.paintEditor.brightness": "روشنایی",
    "paint.paintEditor.costume": "حالت",
    "paint.paintEditor.group": "گروه",
    "paint.paintEditor.ungroup": "تفکیک",
    "paint.paintEditor.undo": "واگـرد",
    "paint.paintEditor.redo": "باز انجام",
    "paint.paintEditor.forward": "جلوتر",
    "paint.paintEditor.backward": "عقب‌تر",
    "paint.paintEditor.front": "اولین",
    "paint.paintEditor.back": "آخرین",
    "paint.paintEditor.more": "بیشتر",
    "paint.modeTools.brushSize": "اندازه",
    "paint.modeTools.eraserSize": "اندازه‌ی پاک‌ کن",
    "paint.modeTools.copy": "کپی",
    "paint.modeTools.paste": "جای‌گذاری",
    "paint.modeTools.delete": "حذف",
    "paint.modeTools.curved": "خمیده",
    "paint.modeTools.pointed": "تیز",
    "paint.modeTools.thickness": "ضخامت",
    "paint.modeTools.flipHorizontal": "قرینه عمودی",
    "paint.modeTools.flipVertical": "قرینه‌ی افقی",
    "paint.modeTools.filled": "تو پُــر",
    "paint.modeTools.outlined": "تو خالی",
    "paint.paintEditor.bitmap": "تبدیل به بیت‌مپ",
    "paint.paintEditor.vector": "تبدیل به بردار",
    "paint.paintEditor.fill": "رنگ",
    "paint.paintEditor.stroke": "خط دور",
    "paint.brushMode.brush": "قلم‌مو",
    "paint.eraserMode.eraser": "پاک‌ کن",
    "paint.fillMode.fill": "سطل رنگ",
    "paint.lineMode.line": "خط",
    "paint.ovalMode.oval": "دایره",
    "paint.rectMode.rect": "مستطیل",
    "paint.reshapeMode.reshape": "تغییر شکل",
    "paint.roundedRectMode.roundedRect": "مستطیل دور گرد",
    "paint.selectMode.select": "انتخاب",
    "paint.textMode.text": "متن",
    "paint.colorPicker.swap": "جابه‌جا"
  },
  "fil": {
    "gui.alerts.lostPeripheralConnection": "Nawala ang koneksyon ng Scratch sa {extensionName}.",
    "gui.alerts.tryAgain": "Subukan Muli",
    "gui.alerts.download": "I-download",
    "gui.connection.reconnect": "Kumonekta Ulit",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "tunog",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Backpack",
    "gui.backpack.errorBackpack": "Nagka-error sa pag-load sa backpack",
    "gui.backpack.loadingBackpack": "Naglo-load...",
    "gui.backpack.more": "Higit pa",
    "gui.backpack.emptyBackpack": "Walang laman ang backpack",
    "gui.unsupportedBrowser.label": "Di suportado ang browser",
    "gui.unsupportedBrowser.errorLabel": "Nagka-error",
    "gui.unsupportedBrowser.notRecommended": "Paumanhin, pero mukha yatang gumagamit po kayo ng isang bersyon ng browser na di suportado ng Scratch. Rinerekomenda po namin na gamitin ang pinakabagong bersyon ng isang suportadong browser tulad ng Google Chrome, Mozilla Firefox, Microsoft Edge, o Apple Safari.",
    "gui.unsupportedBrowser.description": "Paumanhin, pero hindi po suportado ng Scratch ang browser na ito. Rinerekomenda po namin na gamitin ang pinakabagong bersyon ng isang suportadong browser tulad ng Google Chrome, Mozilla Firefox, Microsoft Edge, o Apple Safari.",
    "gui.unsupportedBrowser.back": "Balik",
    "gui.unsupportedBrowser.previewfaq": "Upang matuto pa, puntahan ang {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Mga Madalas Itanong",
    "gui.cards.all-tutorials": "Mga Tutorial",
    "gui.cards.shrink": "Paliitin",
    "gui.cards.expand": "Palakihin",
    "gui.cards.close": "Isara",
    "gui.cards.more-things-to-try": "Maraming masusubukan!",
    "gui.cards.see-more": "Tingnan pa",
    "gui.comingSoon.message1": "Wag kang mag-alala, ginagawa na namin ito{emoji}",
    "gui.comingSoon.message2": "Abangan...",
    "gui.comingSoon.message3": "Ginagawa na namin ito {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Walang nakitang device",
    "gui.connection.auto-scanning.prescan": "Ilapit ang iyong device, tapos simulan ang paghahanap.",
    "gui.connection.auto-scanning.pressbutton": "Pindutin ang button ng iyong device.",
    "gui.connection.auto-scanning.start-search": "Simulan ang Paghahanap",
    "gui.connection.connecting-searchbutton": "Naghahanap...",
    "gui.connection.auto-scanning.try-again": "Subukan muli",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Konektado",
    "gui.connection.disconnect": "Nadiskonekta",
    "gui.connection.go-to-editor": "Pumunta sa Editor",
    "gui.connection.connecting-cancelbutton": "Kumokonekta...",
    "gui.connection.error.errorMessage": "Hala, mukha yatang may mali.",
    "gui.connection.error.tryagainbutton": "Subukan muli",
    "gui.connection.error.helpbutton": "Tulong",
    "gui.connection.peripheral-name-label": "Pangalan ng device",
    "gui.connection.connect": "Ikonekta",
    "gui.connection.scanning.lookingforperipherals": "Naghahanap ng mga device",
    "gui.connection.scanning.noPeripheralsFound": "Walang nahanap na device",
    "gui.connection.scanning.instructions": "Piliin ang iyong device sa listahan sa taas.",
    "gui.connection.search": "I-refresh",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Siguraduhing naka-install at nakabukas ang Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "Siguraduhing nakabukas ang Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Subukan muli",
    "gui.connection.unavailable.helpbutton": "Tulong",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Magsimula",
    "gui.controls.stop": "Itigil",
    "gui.crashMessage.label": "Hala! May mali.",
    "gui.crashMessage.description": "Paumanhin, pero mukha yatang nag-crash ang Scratch. Kusang naiulat na po ang bug na ito sa Scratch Team. Paki-refresh po ng page para masubukan muli.",
    "gui.crashMessage.errorNumber": "Nai-log ang iyong error na may id na {errorId}",
    "gui.crashMessage.reload": "I-reload",
    "gui.customProcedures.myblockModalTitle": "Gumawa ng Block",
    "gui.customProcedures.addAnInputNumberText": "Magdagdag ng input",
    "gui.customProcedures.numberTextType": "bilang o teksto",
    "gui.customProcedures.addAnInputBoolean": "Magdagdag ng input",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Magdagdag ng label",
    "gui.customProcedures.runWithoutScreenRefresh": "Patakbuhin nang walang refresh ng screen",
    "gui.customProcedures.cancel": "Ikansela",
    "gui.customProcedures.ok": "Sige",
    "gui.SpriteInfo.direction": "Direksyon",
    "gui.directionPicker.rotationStyles.allAround": "Lahatan",
    "gui.directionPicker.rotationStyles.leftRight": "Kaliwa/Kanan",
    "gui.directionPicker.rotationStyles.dontRotate": "Wag paikutin",
    "gui.gui.addExtension": "Magdagdag ng Extension",
    "gui.gui.codeTab": "Code",
    "gui.gui.backdropsTab": "Mga Likod",
    "gui.gui.costumesTab": "Mga Costume",
    "gui.gui.soundsTab": "Mga Tunog",
    "gui.extensionLibrary.comingSoon": "Abangan",
    "gui.extensionLibrary.requires": "Kailangan ng",
    "gui.extensionLibrary.collaboration": "Collaboration kasama ang",
    "gui.library.filterPlaceholder": "Maghanap",
    "gui.library.allTag": "Lahat",
    "gui.loader.message1": "Ginagawa ang mga block...",
    "gui.loader.message2": "Nilo-load ang mga sprite...",
    "gui.loader.message3": "Nilo-load ang mga tunog...",
    "gui.loader.message4": "Nilo-load ang mga extension...",
    "gui.loader.message5": "Nagpapakalat ng pusa...",
    "gui.loader.message6": "Kailan ba ito matatapos?",
    "gui.loader.message7": "Pinapataba si Gobo...",
    "gui.loader.message8": "Inihahanda ang mga emoji...",
    "gui.loader.headline": "Nilo-load ang Proyekto",
    "gui.loader.creating": "Ginagawa ang Proyekto",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "Gawa Ko",
    "gui.accountMenu.myClasses": "Mga Klase Ko",
    "gui.accountMenu.myClass": "Klase Ko",
    "gui.accountMenu.accountSettings": "Pagsasaayos sa account",
    "gui.accountMenu.signOut": "Mag-logout",
    "gui.authorInfo.byUser": "ni {username}",
    "gui.menuBar.seeProjectPage": "Tingnan ang Pahina ng Proyekto",
    "gui.menuBar.language": "Language",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Mag-login",
    "login.needHelp": "Kailangan ng tulong?",
    "form.validationRequired": "Kailangan ito",
    "gui.menuBar.tutorialsLibrary": "Mga Tutorial",
    "gui.menuBar.restoreSprite": "I-restore ang Sprite",
    "gui.menuBar.restoreSound": "I-restore ang Tunog",
    "gui.menuBar.restoreCostume": "I-restore ang Costume",
    "gui.menuBar.restore": "I-restore",
    "gui.menuBar.saveNow": "I-save na",
    "gui.menuBar.saveAsCopy": "I-save bilang kopya",
    "gui.menuBar.remix": "I-remix",
    "gui.menuBar.new": "Bago",
    "gui.menuBar.file": "File",
    "gui.menuBar.downloadToComputer": "I-save sa kompyuter mo",
    "gui.menuBar.edit": "Baguhin",
    "gui.menuBar.turboModeOff": "Isara ang Turbo Mode",
    "gui.menuBar.turboModeOn": "Buksan ang Turbo Mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal",
    "gui.menuBar.caturdayMode": "Pusabado",
    "gui.menuBar.joinScratch": "Sumali sa Scratch",
    "gui.menuBar.signIn": "Mag-login",
    "gui.gui.projectTitlePlaceholder": "Pangalan ng proyekto dito",
    "gui.menuBar.saveNowLink": "I-save na",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Ibinahagi",
    "gui.menuBar.share": "Ibahagi",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Tulong",
    "gui.modal.back": "Balik",
    "gui.monitor.listMonitor.empty": "(walang laman)",
    "gui.monitor.listMonitor.listLength": "haba {length}",
    "gui.monitor.contextMenu.default": "normal na readout",
    "gui.monitor.contextMenu.large": "malaking readout",
    "gui.monitor.contextMenu.slider": "slider",
    "gui.monitor.contextMenu.sliderRange": "palitan ang slider range",
    "gui.monitor.contextMenu.import": "i-import",
    "gui.monitor.contextMenu.export": "i-export",
    "gui.monitor.contextMenu.hide": "itago",
    "gui.playButton.play": "I-play",
    "gui.playButton.stop": "Itigil",
    "gui.gui.variableScopeOptionAllSprites": "Para sa lahat ng sprite",
    "gui.gui.variableScopeOptionSpriteOnly": "Para lang sa sprite na ito",
    "gui.gui.cloudVariableOption": "Variable sa cloud (nakalagay sa server)",
    "gui.gui.variablePromptAllSpritesMessage": "Magagamit ang variable na ito sa lahat ng sprite.",
    "gui.gui.listPromptAllSpritesMessage": "Magagamit ang listahan na ito ng lahat ng sprite.",
    "gui.prompt.cancel": "Ikansela",
    "gui.prompt.ok": "Sige",
    "gui.playbackStep.stopMsg": "Itigil",
    "gui.playbackStep.playMsg": "I-play",
    "gui.playbackStep.loadingMsg": "Naglo-load...",
    "gui.playbackStep.saveMsg": "I-save",
    "gui.playbackStep.reRecordMsg": "Muling mag-record",
    "gui.recordModal.title": "Mag-record ng Tunog",
    "gui.recordingStep.beginRecord": "Pindutin ang button sa baba para makapag-record",
    "gui.recordingStep.permission": "{arrow} Kailangan namin ng permiso mo para magamit ang iyong mikropono",
    "gui.recordingStep.stop": "Itigil ang pag-record",
    "gui.recordingStep.record": "Mag-record",
    "gui.sliderModal.min": "Pinakamababa",
    "gui.sliderModal.max": "Pinakamataas",
    "gui.sliderModal.title": "Baguhin ang slider range",
    "gui.sliderPrompt.cancel": "Kanselahin",
    "gui.sliderPrompt.ok": "Sige",
    "gui.soundEditor.sound": "Tunog",
    "gui.soundEditor.play": "I-play",
    "gui.soundEditor.stop": "Itigil",
    "gui.soundEditor.copy": "Kopyahin",
    "gui.soundEditor.paste": "I-paste",
    "gui.soundEditor.copyToNew": "Kopyahin sa Bago",
    "gui.soundEditor.delete": "Burahin",
    "gui.soundEditor.save": "I-save",
    "gui.soundEditor.undo": "I-undo",
    "gui.soundEditor.redo": "I-redo",
    "gui.soundEditor.faster": "Pabilisin",
    "gui.soundEditor.slower": "Pabagalin",
    "gui.soundEditor.echo": "Alingawngaw",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Palakasin",
    "gui.soundEditor.softer": "Pahinain",
    "gui.soundEditor.reverse": "Baligtarin",
    "gui.soundEditor.fadeOut": "I-fadeout",
    "gui.soundEditor.fadeIn": "I-fadein",
    "gui.soundEditor.mute": "I-mute",
    "gui.SpriteInfo.spritePlaceholder": "Pangalan",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Ipakita",
    "gui.SpriteInfo.size": "Laki",
    "gui.spriteSelectorItem.contextMenuDuplicate": "doblehin",
    "gui.spriteSelectorItem.contextMenuExport": "i-export",
    "gui.spriteSelectorItem.contextMenuDelete": "burahin",
    "gui.spriteSelector.addSpriteFromLibrary": "Pumili ng Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Pinta",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Mag-upload ng Sprite",
    "gui.stageHeader.stageSizeLarge": "Lumipat sa malaking stage",
    "gui.stageHeader.stageSizeSmall": "Lumipat sa maliit na stage",
    "gui.stageHeader.stageSizeFull": "Pumasok sa fullscreen",
    "gui.stageHeader.stageSizeUnFull": "Lumabas sa fullscreen",
    "gui.stageHeader.fullscreenControl": "Kontrol sa fullscreen",
    "gui.spriteSelector.addBackdropFromLibrary": "Pumili ng Likod",
    "gui.stageSelector.addBackdropFromPaint": "Pinta",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Mag-upload ng Likod",
    "gui.stageSelector.stage": "Stage",
    "gui.stageSelector.backdrops": "Mga Likod",
    "gui.telemetryOptIn.label": "Mag-ulat ng mga statistics para mapaganda pa ang Scratch",
    "gui.telemetryOptIn.body1": "Palaging inaalam po ng Scratch Team kung papaano ginagamit ang Scratch sa iba't ibang panig ng mundo. Para makatulong, pwede niyo pong payagan ang Scrath na kusang magpadala ng impormasyon sa paggamit sa Scratch Team.",
    "gui.telemetryOptIn.body2": "Ang mga impormasyon na kinokolekta po namin ay ang wikang pinili, paggamit sa mga block, at ilang mga pangyayari tulad ng pag-save, pag-load, at pag-upload sa isang proyekto. HINDI PO NAMIN kokolektahin ang kahit anong personal na impormasyon. Pakitingnan po ang aming {privacyPolicyLink} para sa karagdagang impormasyon.",
    "gui.telemetryOptIn.privacyPolicyLink": "Patakaran sa Pagkapribado",
    "gui.telemetryOptIn.optInText": "Ibahagi ang data ng paggamit ko sa Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Buksan ang telemetry",
    "gui.telemetryOptIn.optOutText": "Wag ibahagi ang data ng paggamit ko sa Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Isara ang telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Na-update na ang pagsasaayos mo.",
    "gui.telemetryOptIn.buttonClose": "Isara",
    "gui.turboMode.active": "Turbo Mode",
    "gui.webglModal.label": "Di suportado ng browser mo ang WebGL",
    "gui.webglModal.description": "Mukha yata {webGlLink} ng browser o kompyuter mo. Kailangan ang teknolohiyang ito para gumana ang Scratch 3.0.",
    "gui.webglModal.webgllink": "di suportado ang WebGL",
    "gui.webglModal.back": "Balik",
    "gui.webglModal.previewfaq": "Para matuto pa, pumunta sa {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Mga Madalas Itanong",
    "gui.costumeLibrary.chooseABackdrop": "Pumili ng Likod",
    "gui.costumeLibrary.chooseACostume": "Pumili ng Costume",
    "gui.costumeTab.addBackdropFromLibrary": "Pumili ng Likod",
    "gui.costumeTab.addCostumeFromLibrary": "Pumili ng Costume",
    "gui.costumeTab.addBlankCostume": "Pinta",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Mag-upload ng Likod",
    "gui.costumeTab.addFileCostume": "Mag-upload ng Costume",
    "gui.extensionLibrary.chooseAnExtension": "Pumili ng Extension",
    "gui.extensionLibrary.extensionUrl": "I-type ang URL ng extension",
    "gui.monitors.importListColumnPrompt": "Anong hanay ang dapat gamitin (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Di masimulan ang pag-record",
    "gui.soundLibrary.chooseASound": "Pumili ng Tunog",
    "gui.soundTab.fileUploadSound": "Mag-upload ng Tunog",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Mag-record",
    "gui.soundTab.addSoundFromLibrary": "Pumili ng Tunog",
    "gui.spriteLibrary.chooseASprite": "Pumili ng Sprite",
    "gui.tipsLibrary.tutorials": "Pumili ng Tutorial",
    "gui.alerts.createsuccess": "Nagawa na ang bagong proyeko.",
    "gui.alerts.createcopysuccess": "Nai-save na ang proyekto bilang kopya.",
    "gui.alerts.createremixsuccess": "Nai-save na ang proyekto bilang remix.",
    "gui.alerts.creating": "Gumagawa ng bago...",
    "gui.alerts.creatingCopy": "Kinokopya ang proyekto...",
    "gui.alerts.creatingRemix": "Rine-remix ang proyeko...",
    "gui.alerts.creatingError": "Di magawa ang proyekto. Pakisubukan muli!",
    "gui.alerts.savingError": "Di mai-save ang proyekto.",
    "gui.alerts.savesuccess": "Nai-save na ang proyekto.",
    "gui.alerts.saving": "Sine-save ang proyekto...",
    "gui.alerts.cloudInfo": "Tandaan, sinusuportahan lang ng mga variable sa cloud ang mga bilang, hindi letra o simbolo. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Matuto pa.",
    "gui.alerts.importing": "Ini-import...",
    "gui.defaultProject.meow": "Ngiyaw...",
    "gui.defaultProject.variable": "variable ko",
    "gui.howtos.intro-move-sayhello-hat.name": "Magsimula",
    "gui.howtos.intro-move.step_stepMove": "Magdagdag ng block sa paggalaw",
    "gui.howtos.add-a-move-block.step_stepSay": "Magdagdag ng block sa pagsalita",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Pindutin ang berdeng bandila para magsimula",
    "gui.howtos.intro-getting-started-ASL.name": "Magsimula - ASL",
    "gui.howtos.animate-a-name.name": "Pagalawin ang Pangalan",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pumili ng Sprite na Letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Mag-play ng Tunog Kapag Pinindot",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pumili ng Isa Pang Sprite na Letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Pumili ng kulay",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pumili ng Isa Pang Sprite na Letra & Paikutin Ito",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pumili ng Isa Pang Sprite na Letra & Palakihin Ito",
    "gui.howtos.imagine": "Mag-isip ng Mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "I-type ang Gusto Mong Sabihin",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Pindutin ang Berdeng Bandila para Magsimula",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Pumili ng Kahit Anong Likod",
    "gui.howtos.imagine.step_imagineChooseSprite": "Pumili ng Kahit Anong Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Pinduin ang Space para Dumulas",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Pumili ng Isa Pang Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Gumalaw Kaliwa-Kanan",
    "gui.howtos.imagine.step_imagineUpDown": "Gumalaw Taas-Baba",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Magpalit ng Costume",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Dumulas patungo sa isang Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Palakihin at Paliitin",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Pumili ng Isa Pang Likod",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Magpalit ng Likod",
    "gui.howtos.imagine.step_imagineRecordASound": "Magdagdag ng Tunog",
    "gui.howtos.imagine.step_imagineChooseSound": "Piliin ang Tunog Mo",
    "gui.howtos.make-music.name": "Gumawa ng Musika",
    "gui.howtos.Make-Music.step_PickInstrument": "Pumili ng Sprite na Instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Mag-play ng Tunog Kapag Pinindot",
    "gui.howtos.Make-Music.step_MakeSong": "Gumawa ng Kanta",
    "gui.howtos.make-music.step_MakeBeat": "Pumili ng Tambol & Gumawa ng Beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Piliin ang Sprite na Mikropono & Sorpresang Beatbox",
    "gui.howtos.story.name": "Gumawa ng Kuwento",
    "gui.howtos.story.step_addbg": "Magdagdag ng Likod",
    "gui.howtos.story.step_addsprite": "Magdagdag ng Tauhan",
    "gui.howtos.story.step_saysomething": "Magsabi ng Kahit Ano",
    "gui.howtos.story.step_addanothersprite": "Magdagdag ng Isa Pang Tauhan",
    "gui.howtos.story.step_flip": "Ibahin ang Direksyon",
    "gui.howtos.story.step_conversation": "Gumawa ng Usapan",
    "gui.howtos.story.addanotherbg": "Magdagdag ng Isa Pang Likod",
    "gui.howtos.story.step_swithbg": "Magpalit ng Likod",
    "gui.howtos.story.step_hidewizard": "Itago ang Tauhan",
    "gui.howtos.story.step_showwizard": "Ipakita ang Tauhan",
    "gui.howtos.make-a-chase-game.name": "Gumawa ng Larong Habulan",
    "gui.howtos.Chase-Game.step_BG": "Magdagdag ng Likod",
    "gui.howtos.chase-game.step_AddOcto": "Magdagdag ng Sprite",
    "gui.howtos.make-music.step_LeftRight": "Gumalaw Pakanan & Pakaliwa Gamit Arrow Keys",
    "gui.howtos.Chase-Game.step_UpDown": "Gumalaw Pataas & Pababa Gamit Arrow Keys",
    "gui.howtos.Chase-Game.step_AddStar": "Magdagdag ng Isa Pang Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Gumalaw sa Kung Saan-saan",
    "gui.howtos.Chase-Game.step_WhenTouch": "Sa Sprite na Pugita, Kapag Tumama Mag-play ng Tunog",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Gumawa ng Variable ng Iskor",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Sa Sprite na Pugita, Kapag Tumama Magdagdag ng Iskor",
    "gui.howtos.animate-char.name": "Pagalawin ang Karakter",
    "gui.howtos.animate-char.step_addbg": "Magdagdag ng Likod",
    "gui.howtos.animate-char.step_addsprite": "Magdagdag ng Sprite",
    "gui.howtos.animate-char.step_saysomething": "Magsabi ng Kahit Ano",
    "gui.howtos.animate-char.step_addsound": "Magdagdag ng Tunog",
    "gui.howtos.animate-char.step_animatetalking": "I-animate ang Pagsasalita",
    "gui.howtos.animate-char.step_arrowkeys": "Gumalaw Gamit Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Tumalon",
    "gui.howtos.animate-char.step_changecolor": "Magpalit ng Kulay",
    "gui.howtos.make-a-game.name": "Gumawa ng Larong Pindutan",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pumili ng Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Mag-play ng Tunog Kapag Pinindot",
    "gui.howtos.make-a-game.step_GameAddScore": "Gumawa ng Variable ng Iskor",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kapag Pinindto Pataasin ang Iskor",
    "gui.howtos.make-a-game.step_Random": "Pumunta sa kahit anong posisyon",
    "gui.howtos.make-music.step_GameChangeColor": "Magpalit ng Kulay",
    "gui.howtos.make-music.step_ResetScore": "I-reset ang Iskor",
    "gui.howtos.make-it-fly.name": "Paliparin",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Pumili ng Langit bilang Likod",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Pumili ng Karakter",
    "gui.howtos.fly.step_stepflySaySomething": "Magsabi ng Kahit Ano",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Gumalaw Gamit Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Pumili ng Bagay na Kokolektahin",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Pagalawin ang Bagay",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Piliin ang Karakter Mo",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Magdagdag ng Iskor",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Itabi ang Iskor",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Magdagdag ng Tanawin",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Pagalawin ang Tanawin",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Susunod na Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Magdagdag ng Likod",
    "gui.howtos.pong.step_pongAddBallSprite": "Magdagdag ng Sprite na Bola",
    "gui.howtos.pong.step_pongBounceAround": "Patalbugin",
    "gui.howtos.pong.step_pongAddPaddle": "Magdagdag ng Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Pagalawin ang Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Piliin ang Sprite na Bola",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Mag-code para Patalbugin ang Bola sa Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Magdagdag ng Iskor",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Piliin ang 'Iskor' sa Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Isingit ang Block na 'Baguhin ang Iskor'",
    "gui.howtos.pong.step_pongResetScore": "I-reset ang Iskor",
    "gui.howtos.pong.step_pongAddLineSprite": "Magdagdag ng Sprite na Linya",
    "gui.howtos.pong.step_pongGameOver": "Talo Na",
    "gui.howtos.code-cartoon": "Mag-code ng Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Magsalita ng Kahit Ano Kapag Pinindot Mo ang Berdeng Bandila",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Pagalawin ang Karakter Kapag Pinindot Mo Ito",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Pumili ng Ibang Karakter",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Gamitin ang Minus Sign para Lumiit",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Palakihin at Paliitin ang Karakter",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Pumili ng Ibang Karakter",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Patalunin Pataas Pababa",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Pindutin ang Karakter para Magpalit ng Eksena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Padulasin",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Magpalit ng Costume",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Pumili pa ng Mas Maraming Karakter na Idadagdag sa Cartoon Mo",
    "gui.howtos.cartoon-network": "I-animate ang Larong Adventure",
    "gui.howtos.cartoon-network.step_CNcharacter": "Piliin ang Karakter na Ipapakita",
    "gui.howtos.cartoon-network.step_CNsay": "Magsabi ng Kahit Ano",
    "gui.howtos.cartoon-network.step_CNglide": "Padulasin",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Piliin ang Hahabuling Bagay",
    "gui.howtos.cartoon-network.step_CNcollect": "Mangolekta ng mga Bagay",
    "gui.howtos.cartoon-network.step_CNvariable": "Gumawa ng Variable na Iskor",
    "gui.howtos.cartoon-network.step_CNscore": "Itabi ang Iskor",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Ibahin ang Likod",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Magdagdag ng Dugtong",
    "gui.howtos.videosens.step_pet": "Himasmasin ang Pusa",
    "gui.howtos.videosens.step_animate": "I-animate",
    "gui.howtos.videosens.step_pop": "Putukin ang Lobo",
    "gui.howtos.say-it-out-loud": "Gumawa ng mga Animation na Nagsasalita",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Idagdag ang mga block na Text to Speech",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Magsabi ng Kahit Ano",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Magtakda ng Boses",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Gumalaw-galaw",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Magdagdag ng Likod",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Magdagdag ng Isa Pang Tauhan",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Umawit",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Magpalit ng Kulay",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Umikot-ikot",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Palakihin at Paliitin",
    "gui.howtos.talking": "Kuwento-kuwento",
    "gui.howtos.talking.step_talesAddExtension": "Pindutin ang mga block sa Text to Speech",
    "gui.howtos.talking.step_talesChooseSprite": "Pumili ng Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Pasalitain ang isang Karakter",
    "gui.howtos.talking.step_talesChooseBackdrop": "Pumili ng Likod",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Pumili ng Karakter at Pumunta sa Susunod na Likod",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Pumili ng Isa Pang Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Gumalaw-galaw",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Pumili ng Isa Pang Likod",
    "gui.howtos.talking.step_talesAnimateTalking": "I-animate ang Pagsasalita",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Pumili ng Isa Pang Likod",
    "gui.howtos.talking.step_talesChooseSound": "Piliin ang Kantang Sasayawan",
    "gui.howtos.talking.step_talesDanceMoves": "Mga Dance Move",
    "gui.howtos.talking.step_talesAskAnswer": "Kunin ang mga block na Magtanong at Sumagot mula sa Sensing",
    "gui.howtos.add-sprite.name": "Magdagdag ng Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Magdagdag ng Sprite",
    "gui.howtos.add-a-backdrop.name": "Magdagdag ng Likod",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Magdagdag ng Likod",
    "gui.howtos.change-size.name": "Ibahin ang Laki",
    "gui.howtos.change-size.step_changeSize": "Ibahin ang Laki",
    "gui.howtos.glide-around.name": "Padulasin",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Padulasin",
    "gui.howtos.change-size.step_glideAroundPoint": "Dumulas patungo sa isang Point",
    "gui.howtos.record-a-sound.name": "Mag-record ng Tunog",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Pumunta sa 'Mga Tunog'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Pindutin ang 'Mag-record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pindutin ang Button sa Pag-record",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Piliin ang Tunog Mo",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "I-play ang Tunog Mo",
    "gui.howtos.spin-video.name": "Paikutin Ito",
    "gui.howtos.change-size.step_spinTurn": "Ikutin",
    "gui.howtos.change-size.step_spinPointInDirection": "Magtakda ng Direksyon",
    "gui.howtos.hide-and-show.name": "Itago at Ipakita",
    "gui.howtos.change-size.step_hideAndShow": "Itago at Ipakita",
    "gui.howtos.switch-costume.name": "Pagalawin ang Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Pagalawin ang Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Gamitin ang Arrow Keys",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Gumalaw Kaliwa Kanan",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Gumalaw Taas Baba",
    "gui.howtos.add-effects.name": "Magdagdag ng mga Epekto",
    "gui.howtos.videosens.step_addEffects": "Magdagdag ng mga Epekto",
    "gui.extension.music.name": "Musika",
    "gui.extension.music.description": "Mag-play ng mga instrumento at tambol.",
    "gui.extension.pen.name": "Panulat",
    "gui.extension.pen.description": "Gumuhit gamit ang mga sprite mo.",
    "gui.extension.videosensing.name": "Video Sensing",
    "gui.extension.videosensing.description": "I-sense ang galaw gamit ang kamera.",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Pasalitain ang mga proyekto mo.",
    "gui.extension.translate.name": "Magsalin",
    "gui.extension.translate.description": "Isalin ang teksto sa ibang mga wika.",
    "gui.extension.makeymakey.description": "Gawing key ang kahit ano.",
    "gui.extension.microbit.description": "Ikonekta ang mga proyekto mo sa mundo.",
    "gui.extension.microbit.connectingMessage": "Kinokonekta",
    "gui.extension.ev3.description": "Gumawa ng mga interactive na robot at marami pa.",
    "gui.extension.ev3.connectingMessage": "Kinokonekta. Siguraduhing nakatakda ang pin ng EV3 mo sa 1234.",
    "gui.extension.boost.description": "Bigyang-buhay ang mga robot mo.",
    "gui.extension.boost.connectingMessage": "Kinokonekta",
    "gui.extension.wedo2.description": "Gumawa kasama ang mga motor at sensor.",
    "gui.extension.wedo2.connectingMessage": "Kinokonekta",
    "gui.extension.gdxfor.description": "I-sense ang pagtulak, paghila, paggalaw, at pag-ikot.",
    "gui.extension.gdxfor.connectingMessage": "Kinokonekta",
    "gui.libraryTags.all": "Lahat",
    "gui.libraryTags.animals": "Mga Hayop",
    "gui.libraryTags.dance": "Sayaw",
    "gui.libraryTags.effects": "Mga Epekto",
    "gui.libraryTags.fantasy": "Pantasya",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Pagkain",
    "gui.libraryTags.indoors": "Loob",
    "gui.libraryTags.loops": "Mga Loop",
    "gui.libraryTags.music": "Musika",
    "gui.libraryTags.notes": "Mga Nota",
    "gui.libraryTags.outdoors": "Labas",
    "gui.libraryTags.patterns": "Mga Pattern",
    "gui.libraryTags.people": "Mga Tao",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Kalawakan",
    "gui.libraryTags.sports": "Palakasan",
    "gui.libraryTags.underwater": "Katubigan",
    "gui.libraryTags.voice": "Boses",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Sining",
    "gui.libraryTags.games": "Mga Laro",
    "gui.libraryTags.stories": "Mga Kuwento",
    "gui.libraryTags.letters": "Mga Letra",
    "gui.opcodeLabels.direction": "direksyon",
    "gui.opcodeLabels.xposition": "posisyong x",
    "gui.opcodeLabels.yposition": "posisyong y",
    "gui.opcodeLabels.size": "laki",
    "gui.opcodeLabels.costumename": "pangalan ng costume",
    "gui.opcodeLabels.costumenumber": "bilang ng costume",
    "gui.opcodeLabels.backdropname": "pangalan ng likod",
    "gui.opcodeLabels.backdropnumber": "bilang ng likod",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "bilis",
    "gui.opcodeLabels.answer": "sagot",
    "gui.opcodeLabels.loudness": "lakas",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "taon",
    "gui.opcodeLabels.month": "buwan",
    "gui.opcodeLabels.date": "petsa",
    "gui.opcodeLabels.dayofweek": "araw ng linggo",
    "gui.opcodeLabels.hour": "oras",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "Di nai-load ang piniling file ng proyekto.",
    "gui.sharedMessages.backdrop": "likod{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "putok",
    "gui.sharedMessages.replaceProjectWarning": "Palitan ang nilalaman ng kasalukuyang proyekto?",
    "gui.sharedMessages.loadFromComputerTitle": "I-load mula sa kompyuter mo",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proyekto sa Scratch",
    "boost.color.any": "kahit anong kulay",
    "boost.color.black": "itim",
    "boost.color.blue": "bughaw",
    "boost.color.green": "berde",
    "boost.color.red": "pula",
    "boost.color.white": "puti",
    "boost.color.yellow": "dilaw",
    "boost.getMotorPosition": "posisyon ng motor na [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "anggulo ng pagtagilid [TILT_DIRECTION]",
    "boost.motorDirection.backward": "papunta doon",
    "boost.motorDirection.forward": "papunta rito",
    "boost.motorDirection.reverse": "pabalik",
    "boost.motorOff": "isara ang motor na [MOTOR_ID]",
    "boost.motorOn": "buksan ang motor na [MOTOR_ID]",
    "boost.motorOnFor": "buksan ang motor na [MOTOR_ID] nang [DURATION] (na) segundo",
    "boost.motorOnForRotation": "buksan ang motor na [MOTOR_ID] nang [ROTATION] (na) ikot",
    "boost.seeingColor": "nakikita ang brick na [COLOR]?",
    "boost.setLightHue": "itakda ang kulay ng ilaw bilang [HUE]",
    "boost.setMotorDirection": "itakda sa direksyong [MOTOR_DIRECTION] ang motor na [MOTOR_ID]",
    "boost.setMotorPower": "itakda sa bilis na [POWER] % ang motor na [MOTOR_ID]",
    "boost.tiltDirection.any": "kahit ano",
    "boost.tiltDirection.down": "baba",
    "boost.tiltDirection.left": "kaliwa",
    "boost.tiltDirection.right": "kanan",
    "boost.tiltDirection.up": "taas",
    "boost.whenColor": "kapag nakita ang brick na [COLOR]",
    "boost.whenTilted": "kapag nakatagilid [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "i-beep ang notang [NOTE] nang [TIME] (na) segundo",
    "ev3.buttonPressed": "pinindot ang button na [PORT]?",
    "ev3.getBrightness": "liwanag",
    "ev3.getDistance": "layo",
    "ev3.getMotorPosition": "posisyon ng motor na [PORT]",
    "ev3.motorSetPower": "itakda ang lakas na [POWER] % sa motor na [PORT]",
    "ev3.motorTurnClockwise": "paikutin dito nang [TIME] (na) seguno ang motor na [PORT]",
    "ev3.motorTurnCounterClockwise": "paikutin doon nang [TIME] (na) segundo ang motor na [PORT]",
    "ev3.whenBrightnessLessThan": "kapag ang liwanag < [DISTANCE]",
    "ev3.whenButtonPressed": "kapag pinindot ang button na [PORT]",
    "ev3.whenDistanceLessThan": "kapag ang layo < [DISTANCE]",
    "gdxfor.getAcceleration": "pagbilis [DIRECTION]",
    "gdxfor.getForce": "pwersa",
    "gdxfor.getSpin": "bilis ng pag-ikot [DIRECTION]",
    "gdxfor.getTilt": "anggulo ng pagtagilid [TILT]",
    "gdxfor.isFreeFalling": "nahuhulog?",
    "gdxfor.isTilted": "nakatagilid [TILT]?",
    "gdxfor.pulled": "hinila",
    "gdxfor.pushed": "tinulak",
    "gdxfor.shaken": "niyugyog",
    "gdxfor.startedFalling": "nagsimulang mahulog",
    "gdxfor.tiltDirectionMenu.any": "kahit ano",
    "gdxfor.tiltDirectionMenu.back": "likod",
    "gdxfor.tiltDirectionMenu.front": "harap",
    "gdxfor.tiltDirectionMenu.left": "kaliwa",
    "gdxfor.tiltDirectionMenu.right": "kanan",
    "gdxfor.turnedFaceDown": "nakaharap pababa",
    "gdxfor.turnedFaceUp": "nakaharap pataas",
    "gdxfor.whenForcePushedOrPulled": "kapag ang sensor ng pwersa ay [PUSH_PULL]",
    "gdxfor.whenGesture": "kapag [GESTURE]",
    "gdxfor.whenTilted": "kapag nakatagilid [TILT]",
    "makeymakey.downArrow": "pababang arrow",
    "makeymakey.downArrowShort": "baba",
    "makeymakey.leftArrow": "kaliwang arrow",
    "makeymakey.leftArrowShort": "kaliwa",
    "makeymakey.rightArrow": "kanang arrow",
    "makeymakey.rightArrowShort": "kanan",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "pataas na arrow",
    "makeymakey.upArrowShort": "taas",
    "makeymakey.whenKeyPressed": "kapag pinindot ang key na [KEY]",
    "makeymakey.whenKeysPressedInOrder": "kapag diretsong pinindot ang [SEQUENCE]",
    "microbit.buttonsMenu.any": "kahit ano",
    "microbit.clearDisplay": "linisin ang display",
    "microbit.defaultTextToDisplay": "Kamusta",
    "microbit.displaySymbol": "i-display ang [MATRIX]",
    "microbit.displayText": "i-display ang teksto na [TEXT]",
    "microbit.gesturesMenu.jumped": "tumalon",
    "microbit.gesturesMenu.moved": "gumalaw",
    "microbit.gesturesMenu.shaken": "niyugyog",
    "microbit.isButtonPressed": "pinindot ang button na [BTN]?",
    "microbit.isTilted": "nakatagilid [DIRECTION]?",
    "microbit.pinStateMenu.off": "nakasara",
    "microbit.pinStateMenu.on": "nakabukas",
    "microbit.tiltAngle": "anggulo ng pagtagilid [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "kahit ano",
    "microbit.tiltDirectionMenu.back": "likod",
    "microbit.tiltDirectionMenu.front": "harap",
    "microbit.tiltDirectionMenu.left": "kaliwa",
    "microbit.tiltDirectionMenu.right": "kanan",
    "microbit.whenButtonPressed": "kapag pinindot ang button na [BTN]",
    "microbit.whenGesture": "kapag [GESTURE]",
    "microbit.whenPinConnected": "kapag konektado ang pin na [PIN]",
    "microbit.whenTilted": "kapag nakatagilid [DIRECTION]",
    "music.categoryName": "Musika",
    "music.changeTempo": "baguhin ang bilis nang [TEMPO]",
    "music.drumBass": "(2) Bass Drum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Closed Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Hand Clap",
    "music.drumOpenHiHat": "(5) Open Hi-Hat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snare Drum",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood Block",
    "music.getTempo": "bilis",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Choir",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Electric Guitar",
    "music.instrumentElectricPiano": "(2) Electric Piano",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Guitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Music Box",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Wooden Flute",
    "music.midiPlayDrumForBeats": "i-play ang tambol na [DRUM] nang [BEATS] (na) beat",
    "music.midiSetInstrument": "itakda ang instrumento bilang [INSTRUMENT]",
    "music.playDrumForBeats": "i-play ang tambol na [DRUM] nang [BEATS] (na) beat",
    "music.playNoteForBeats": "i-play ang notang [NOTE] nang [BEATS] (na) beat",
    "music.restForBeats": "magpahinga nang [BEATS] (na) beat",
    "music.setInstrument": "itakda ang instrumento bilang [INSTRUMENT]",
    "music.setTempo": "itakda ang bilis bilang [TEMPO]",
    "pen.categoryName": "Panulat",
    "pen.changeColorParam": "baguhin ang panulat [COLOR_PARAM] ng [VALUE]",
    "pen.changeHue": "baguhin ang kulay ng panulat sa [HUE]",
    "pen.changeShade": "baguhin ang shade ng panulat sa [SHADE]",
    "pen.changeSize": "baguhin ang laki ng panulat nang [SIZE]",
    "pen.clear": "burahin lahat",
    "pen.colorMenu.brightness": "liwanag",
    "pen.colorMenu.color": "kulay",
    "pen.colorMenu.saturation": "tingkad",
    "pen.colorMenu.transparency": "labo",
    "pen.penDown": "ibaba ang panulat",
    "pen.penUp": "itaas ang panulat",
    "pen.setColor": "itakda ang kulay ng panulat sa [COLOR]",
    "pen.setColorParam": "itakda ang panulat [COLOR_PARAM] sa [VALUE]",
    "pen.setHue": "itakda ang kulay ng panulat sa [HUE]",
    "pen.setShade": "itakda ang shade ng panulat sa [SHADE]",
    "pen.setSize": "itakda ang laki ng panulat sa [SIZE]",
    "pen.stamp": "i-stamp",
    "speech.defaultWhenIHearValue": "tara",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "makinig at maghintay",
    "speech.speechReporter": "sinabi",
    "speech.whenIHear": "kapag narinig ko ang [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "kamusta",
    "text2speech.giant": "higante",
    "text2speech.kitten": "kuting",
    "text2speech.setLanguageBlock": "itakda ang wika sa [LANGUAGE]",
    "text2speech.setVoiceBlock": "itakda ang boses sa [VOICE]",
    "text2speech.speakAndWaitBlock": "sabihin ang [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Magsalin",
    "translate.defaultTextToTranslate": "kamusta",
    "translate.translateBlock": "isalin ang [WORDS] sa [LANGUAGE]",
    "translate.viewerLanguage": "wika",
    "videoSensing.categoryName": "Video Sensing",
    "videoSensing.direction": "direksyon",
    "videoSensing.motion": "galaw",
    "videoSensing.off": "sarado",
    "videoSensing.on": "bukas",
    "videoSensing.onFlipped": "pabaligtad",
    "videoSensing.setVideoTransparency": "itakda ang labo ng video sa [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "stage",
    "videoSensing.videoOn": "[ATTRIBUTE] ng video sa [SUBJECT]",
    "videoSensing.videoToggle": "itakda ang video sa [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kapag ang paggalaw sa video > [REFERENCE]",
    "wedo2.getDistance": "layo",
    "wedo2.getTiltAngle": "anggulo ng pagtagilid [TILT_DIRECTION]",
    "wedo2.isTilted": "nakatagilid [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "papunta doon",
    "wedo2.motorDirection.forward": "papunta rito",
    "wedo2.motorDirection.reverse": "pabalik",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "lahat ng motor",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "patayin ang [MOTOR_ID]",
    "wedo2.motorOn": "buksan ang [MOTOR_ID]",
    "wedo2.motorOnFor": "buksan ang [MOTOR_ID] nang [DURATION] (na) segundo",
    "wedo2.playNoteFor": "i-play ang notang [NOTE] nang [DURATION] (na) segundo",
    "wedo2.setLightHue": "itakda ang kulay ng ilaw bilang [HUE]",
    "wedo2.setMotorDirection": "itakda ang direksyon ng [MOTOR_ID] sa [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "itakda ang lakas ng [MOTOR_ID] sa [POWER]",
    "wedo2.tiltDirection.any": "kahit ano",
    "wedo2.tiltDirection.down": "baba",
    "wedo2.tiltDirection.left": "kaliwa",
    "wedo2.tiltDirection.right": "kanan",
    "wedo2.tiltDirection.up": "taas",
    "wedo2.whenDistance": "kapag ang layo [OP] [REFERENCE]",
    "wedo2.whenTilted": "kapag nakatagilid [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kulay",
    "paint.paintEditor.saturation": "Tingkad",
    "paint.paintEditor.brightness": "Liwanag",
    "paint.paintEditor.costume": "Costume",
    "paint.paintEditor.group": "Igrupo",
    "paint.paintEditor.ungroup": "Wag igrupo",
    "paint.paintEditor.undo": "I-undo",
    "paint.paintEditor.redo": "I-redo",
    "paint.paintEditor.forward": "Iharap",
    "paint.paintEditor.backward": "Ilikod",
    "paint.paintEditor.front": "Harap",
    "paint.paintEditor.back": "Balik",
    "paint.paintEditor.more": "Higit pa",
    "paint.modeTools.brushSize": "Laki",
    "paint.modeTools.eraserSize": "Laki ng pambura",
    "paint.modeTools.copy": "Kopyahin",
    "paint.modeTools.paste": "I-paste",
    "paint.modeTools.delete": "Burahin",
    "paint.modeTools.curved": "Nakakurba",
    "paint.modeTools.pointed": "Matulis",
    "paint.modeTools.thickness": "Kapal",
    "paint.modeTools.flipHorizontal": "Baligtarin Pahiga",
    "paint.modeTools.flipVertical": "Baligtarin Patayo",
    "paint.modeTools.filled": "Kinulayan",
    "paint.modeTools.outlined": "Nakabakas",
    "paint.paintEditor.bitmap": "I-convert sa Bitmap",
    "paint.paintEditor.vector": "I-convert sa Vector",
    "paint.paintEditor.fill": "Kulayan",
    "paint.paintEditor.stroke": "Bakas",
    "paint.brushMode.brush": "Brush",
    "paint.eraserMode.eraser": "Pambura",
    "paint.fillMode.fill": "Kulayan",
    "paint.lineMode.line": "Linya",
    "paint.ovalMode.oval": "Bilog",
    "paint.rectMode.rect": "Parihaba",
    "paint.reshapeMode.reshape": "Ibahin ang hugis",
    "paint.roundedRectMode.roundedRect": "Parihabang pabilog",
    "paint.selectMode.select": "Pumili",
    "paint.textMode.text": "Teksto",
    "paint.colorPicker.swap": "Magpalitan"
  },
  "fr": {
    "gui.alerts.lostPeripheralConnection": "Connexion entre Scratch et {extensionName} perdue.",
    "gui.alerts.tryAgain": "Essayer à nouveau",
    "gui.alerts.download": "Télécharger",
    "gui.connection.reconnect": "Se reconnecter",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "son",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Sac à dos",
    "gui.backpack.errorBackpack": "Erreur lors du chargement du sac à dos",
    "gui.backpack.loadingBackpack": "Chargement...",
    "gui.backpack.more": "Plus",
    "gui.backpack.emptyBackpack": "Le sac à dos est vide",
    "gui.unsupportedBrowser.label": "Navigateur non pris en charge",
    "gui.unsupportedBrowser.errorLabel": "Une erreur est survenue",
    "gui.unsupportedBrowser.notRecommended": "Nous sommes désolés, mais on dirait que la version de votre navigateur n'est pas supportée par Scratch. Nous vous recommandons une mise à jour vers la dernière version d'un navigateur qui est supporté par Scratch comme Google Chrome, Mozilla Firefox, Microsoft Edge ou Apple Safari.",
    "gui.unsupportedBrowser.description": "Nous sommes désolés mais ce navigateur n'est pas supporté par Scratch. Nous vous recommandons d'utiliser la dernière version d'un navigateur comme Google Chrome, Mozilla Firefox, Microsoft Edge ou Apple Safari.",
    "gui.unsupportedBrowser.back": "Retour",
    "gui.unsupportedBrowser.previewfaq": "Pour en savoir plus, allez sur la {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutoriels",
    "gui.cards.shrink": "Réduire",
    "gui.cards.expand": "Agrandir",
    "gui.cards.close": "Fermer",
    "gui.cards.more-things-to-try": "Plus de choses à essayer !",
    "gui.cards.see-more": "Voir plus",
    "gui.comingSoon.message1": "Ne t'inquiète pas, nous y travaillons {emoji}",
    "gui.comingSoon.message2": "Ça arrive bientôt...",
    "gui.comingSoon.message3": "Nous y travaillons {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Aucun appareil trouvé",
    "gui.connection.auto-scanning.prescan": "Assurez-vous d'avoir votre appareil à proximité puis commencez la recherche.",
    "gui.connection.auto-scanning.pressbutton": "Appuyez sur le bouton de votre appareil.",
    "gui.connection.auto-scanning.start-search": "Commencer la recherche",
    "gui.connection.connecting-searchbutton": "Recherche en cours...",
    "gui.connection.auto-scanning.try-again": "Essayer à nouveau",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Connecté",
    "gui.connection.disconnect": "Se déconnecter",
    "gui.connection.go-to-editor": "Aller à l'Éditeur",
    "gui.connection.connecting-cancelbutton": "Connexion...",
    "gui.connection.error.errorMessage": "Oups, on dirait que quelque chose s'est mal passé.",
    "gui.connection.error.tryagainbutton": "Essayer à nouveau",
    "gui.connection.error.helpbutton": "Aide",
    "gui.connection.peripheral-name-label": "Nom de l'appareil",
    "gui.connection.connect": "Se connecter",
    "gui.connection.scanning.lookingforperipherals": "Recherche d'appareils en cours",
    "gui.connection.scanning.noPeripheralsFound": "Aucun appareil trouvé",
    "gui.connection.scanning.instructions": "Sélectionnez un appareil dans la liste ci-dessus.",
    "gui.connection.search": "Rafraîchir",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Veillez à ce que vous ayez Scratch Link d'installé et lancé",
    "gui.connection.unavailable.enablebluetooth": "Vérifiez que le Bluetooth soit activé",
    "gui.connection.unavailable.tryagainbutton": "Essayer à nouveau",
    "gui.connection.unavailable.helpbutton": "Aide",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Commencer",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oups ! Quelque chose s'est mal passé.",
    "gui.crashMessage.description": "Nous sommes désolés, mais on dirait que Scratch a planté. Ce bug a été rapporté automatiquement à l'Equipe Scratch. Merci de rafraîchir la page pour essayer à nouveau.",
    "gui.crashMessage.errorNumber": "Votre erreur a été enregistrée avec l'identificateur  {errorId}.",
    "gui.crashMessage.reload": "Recharger",
    "gui.customProcedures.myblockModalTitle": "Créer un bloc",
    "gui.customProcedures.addAnInputNumberText": "Ajouter une entrée",
    "gui.customProcedures.numberTextType": "nombre ou texte",
    "gui.customProcedures.addAnInputBoolean": "Ajouter une entrée",
    "gui.customProcedures.booleanType": "booléenne",
    "gui.customProcedures.addALabel": "Ajouter une étiquette",
    "gui.customProcedures.runWithoutScreenRefresh": "Exécuter sans rafraîchissement d'écran",
    "gui.customProcedures.cancel": "Annuler",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direction",
    "gui.directionPicker.rotationStyles.allAround": "Tout autour",
    "gui.directionPicker.rotationStyles.leftRight": "Gauche/Droite",
    "gui.directionPicker.rotationStyles.dontRotate": "Ne pivote pas",
    "gui.gui.addExtension": "Ajouter une extension",
    "gui.gui.codeTab": "Code",
    "gui.gui.backdropsTab": "Arrière-plans",
    "gui.gui.costumesTab": "Costumes",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Ça arrive bientôt",
    "gui.extensionLibrary.requires": "Nécessite",
    "gui.extensionLibrary.collaboration": "En collaboration avec ",
    "gui.library.filterPlaceholder": "Rechercher",
    "gui.library.allTag": "Tout",
    "gui.loader.message1": "Création des blocs ...",
    "gui.loader.message2": "Chargement de sprites...",
    "gui.loader.message3": "Chargement des sons...",
    "gui.loader.message4": "Chargement des extensions ...",
    "gui.loader.message5": "Rassemblement des chats ...",
    "gui.loader.message6": "Transmission des nanos ...",
    "gui.loader.message7": "Gonflement des gobos ...",
    "gui.loader.message8": "Préparation des émojis ...",
    "gui.loader.headline": "Chargement du projet",
    "gui.loader.creating": " Création du projet",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Mes projets",
    "gui.accountMenu.myClasses": "Mes classes",
    "gui.accountMenu.myClass": "Ma classe",
    "gui.accountMenu.accountSettings": "Paramètres du compte",
    "gui.accountMenu.signOut": "Déconnexion",
    "gui.authorInfo.byUser": "créé par {username}",
    "gui.menuBar.seeProjectPage": "Voir la page du projet",
    "gui.menuBar.language": "Langue",
    "general.username": "Nom d'utilisateur",
    "general.password": "Mot de passe",
    "general.signIn": "Se connecter",
    "login.needHelp": "Besoin d'aide ?",
    "form.validationRequired": "Ce champ est requis",
    "gui.menuBar.tutorialsLibrary": "Tutoriels",
    "gui.menuBar.restoreSprite": "Restaurer le sprite",
    "gui.menuBar.restoreSound": "Restaurer le son",
    "gui.menuBar.restoreCostume": "Restaurer le costume",
    "gui.menuBar.restore": "Restaurer",
    "gui.menuBar.saveNow": "Enregistrer maintenant",
    "gui.menuBar.saveAsCopy": "Enregistrer comme copie",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Nouveau",
    "gui.menuBar.file": "Fichier",
    "gui.menuBar.downloadToComputer": "Sauvegarder sur votre ordinateur",
    "gui.menuBar.edit": "Modifier",
    "gui.menuBar.turboModeOff": "Désactiver le mode Turbo",
    "gui.menuBar.turboModeOn": "Activer le mode Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Mode normal",
    "gui.menuBar.caturdayMode": "Mode Chamedi",
    "gui.menuBar.joinScratch": "Rejoindre Scratch",
    "gui.menuBar.signIn": "Se connecter",
    "gui.gui.projectTitlePlaceholder": "Titre du projet ici",
    "gui.menuBar.saveNowLink": "Enregistrer maintenant",
    "gui.menuBar.settings": "Paramètres",
    "gui.menuBar.isShared": "Partagé",
    "gui.menuBar.share": "Partager",
    "gui.menuBar.colorMode": "Mode de couleur",
    "gui.modal.help": "Aide",
    "gui.modal.back": "Retour",
    "gui.monitor.listMonitor.empty": "(vide)",
    "gui.monitor.listMonitor.listLength": "longueur {length}",
    "gui.monitor.contextMenu.default": "lecture normale",
    "gui.monitor.contextMenu.large": "grande lecture",
    "gui.monitor.contextMenu.slider": "barre de défilement",
    "gui.monitor.contextMenu.sliderRange": "modifier les valeurs de la barre de défilement",
    "gui.monitor.contextMenu.import": "importer",
    "gui.monitor.contextMenu.export": "exporter",
    "gui.monitor.contextMenu.hide": "cacher",
    "gui.playButton.play": "Jouer",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Pour tous les sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Pour ce sprite uniquement",
    "gui.gui.cloudVariableOption": "Variable serveur (stockée sur le Cloud)",
    "gui.gui.variablePromptAllSpritesMessage": "La variable sera disponible pour tous les sprites.",
    "gui.gui.listPromptAllSpritesMessage": "Cette liste sera disponible pour tous les sprites.",
    "gui.prompt.cancel": "Annuler",
    "gui.prompt.ok": "Ok",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Jouer",
    "gui.playbackStep.loadingMsg": "Chargement...",
    "gui.playbackStep.saveMsg": "Sauvegarder",
    "gui.playbackStep.reRecordMsg": "Réenregistrer",
    "gui.recordModal.title": "Enregistre un Son",
    "gui.recordingStep.beginRecord": "Commence à enregistrer en cliquant sur le bouton ci-dessous.",
    "gui.recordingStep.permission": "{arrow}Nous avons besoin de votre permission pour utiliser votre micro",
    "gui.recordingStep.stop": "Arrêter l'enregistrement",
    "gui.recordingStep.record": "Enregistrer",
    "gui.sliderModal.min": "Valeur minimum",
    "gui.sliderModal.max": "Valeur maximum",
    "gui.sliderModal.title": "Modifier les valeurs de la barre de défilement",
    "gui.sliderPrompt.cancel": "Annuler",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Son",
    "gui.soundEditor.play": "Jouer",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Copier",
    "gui.soundEditor.paste": "Coller",
    "gui.soundEditor.copyToNew": "Copier dans un nouveau",
    "gui.soundEditor.delete": "Supprimer",
    "gui.soundEditor.save": "Enregistrer",
    "gui.soundEditor.undo": "Restaurer",
    "gui.soundEditor.redo": "Refaire",
    "gui.soundEditor.faster": "Plus vite",
    "gui.soundEditor.slower": "Moins vite",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Plus fort",
    "gui.soundEditor.softer": "Plus doux",
    "gui.soundEditor.reverse": "Inverser",
    "gui.soundEditor.fadeOut": "Fondu de fermeture",
    "gui.soundEditor.fadeIn": "Fondu d'ouverture",
    "gui.soundEditor.mute": "Muet",
    "gui.SpriteInfo.spritePlaceholder": "Nom",
    "gui.SpriteInfo.showSpriteAction": "Afficher le sprite",
    "gui.SpriteInfo.hideSpriteAction": "Cacher le sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Afficher",
    "gui.SpriteInfo.size": "Taille",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dupliquer",
    "gui.spriteSelectorItem.contextMenuExport": "exporter",
    "gui.spriteSelectorItem.contextMenuDelete": "supprimer",
    "gui.spriteSelector.addSpriteFromLibrary": "Choisir un sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Peindre",
    "gui.spriteSelector.addSpriteFromSurprise": "Surprise",
    "gui.spriteSelector.addSpriteFromFile": "Importer un sprite",
    "gui.stageHeader.stageSizeLarge": "Passer à la grande scène",
    "gui.stageHeader.stageSizeSmall": "Passer à la petite scène",
    "gui.stageHeader.stageSizeFull": "Entrer en mode plein-écran",
    "gui.stageHeader.stageSizeUnFull": "Sortir du mode plein-écran",
    "gui.stageHeader.fullscreenControl": "Contrôle du plein écran",
    "gui.spriteSelector.addBackdropFromLibrary": "Choisir un arrière-plan",
    "gui.stageSelector.addBackdropFromPaint": "Peindre",
    "gui.stageSelector.addBackdropFromSurprise": "Surprise",
    "gui.stageSelector.addBackdropFromFile": "Importer un arrière-plan",
    "gui.stageSelector.stage": "Scène",
    "gui.stageSelector.backdrops": "Arrière-plans",
    "gui.telemetryOptIn.label": "Envoyer des statistiques pour améliorer Scratch",
    "gui.telemetryOptIn.body1": "L'Equipe Scratch cherche à toujours mieux comprendre comment Scratch est utilisé dans le monde. Pour nous aider, vous pouvez autoriser Scratch à envoyer automatiquement des rapports d'utilisation à l'Equipe Scratch.",
    "gui.telemetryOptIn.body2": "Les informations que nous collectons incluent la langue sélectionnée, la fréquence d'utilisation des blocs et de certains événements, comme les sauvegardes, l'ouverture de projet et la publication de projets. Nous ne collectons PAS d'informations personnelles. Voir notre {privacyPolicyLink} pour plus d'informations.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politique de confidentialité",
    "gui.telemetryOptIn.optInText": "Partager mes données d'utilisation avec l'Équipe Scratch",
    "gui.telemetryOptIn.optInTooltip": "Activer la télémétrie",
    "gui.telemetryOptIn.optOutText": "Ne pas partager mes données d'utilisation avec l'Équipe Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Désactiver la télémétrie",
    "gui.telemetryOptIn.settingWasUpdated": "Vos préférences ont été mises à jour.",
    "gui.telemetryOptIn.buttonClose": "Fermer",
    "gui.turboMode.active": "Mode Turbo",
    "gui.webglModal.label": "Votre navigateur ne supporte pas WebGL",
    "gui.webglModal.description": "Malheureusement il semble que votre navigateur ou votre ordinateur {webGlLink}. Cette technologie est nécessaire pour faire fonctionner Scratch 3.0.",
    "gui.webglModal.webgllink": "ne supporte pas WebGL",
    "gui.webglModal.back": "Retour",
    "gui.webglModal.previewfaq": "Pour en savoir plus, allez sur {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Choisir un arrière-plan",
    "gui.costumeLibrary.chooseACostume": "Choisir un costume",
    "gui.costumeTab.addBackdropFromLibrary": "Choisir un arrière-plan",
    "gui.costumeTab.addCostumeFromLibrary": "Choisir un costume",
    "gui.costumeTab.addBlankCostume": "Peindre",
    "gui.costumeTab.addSurpriseCostume": "Surprise",
    "gui.costumeTab.addFileBackdrop": "Importer un arrière-plan",
    "gui.costumeTab.addFileCostume": "Importer un Costume",
    "gui.extensionLibrary.chooseAnExtension": "Choisis une extension",
    "gui.extensionLibrary.extensionUrl": "Entrer l'URL de l'extension",
    "gui.monitors.importListColumnPrompt": "Quelle colonne doit être utilisée (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Impossible de démarrer l'enregistrement",
    "gui.soundLibrary.chooseASound": "Choisir un son",
    "gui.soundTab.fileUploadSound": "Importer un son",
    "gui.soundTab.surpriseSound": "Surprise",
    "gui.soundTab.recordSound": "Enregistrer",
    "gui.soundTab.addSoundFromLibrary": "Choisir un son",
    "gui.spriteLibrary.chooseASprite": "Choisir un sprite",
    "gui.tipsLibrary.tutorials": "Choisis un tutoriel",
    "gui.alerts.createsuccess": "Nouveau projet créé.",
    "gui.alerts.createcopysuccess": " Projet enregistré en copie.",
    "gui.alerts.createremixsuccess": " Projet enregistré en remix.",
    "gui.alerts.creating": "Création d'un nouveau projet...",
    "gui.alerts.creatingCopy": "Copie du projet...",
    "gui.alerts.creatingRemix": "Remixage du projet...",
    "gui.alerts.creatingError": "Impossible de créer le projet. Merci de réessayer !",
    "gui.alerts.savingError": "Le projet n'a pas pu être sauvegardé.",
    "gui.alerts.savesuccess": "Projet enregistré.",
    "gui.alerts.saving": "Sauvegarde du projet...",
    "gui.alerts.cloudInfo": "Veuillez noter que les variables serveurs ne prennent en charge que les chiffres, pas les lettres ni les symboles. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "En savoir plus.",
    "gui.alerts.importing": "Importation en cours...",
    "gui.defaultProject.meow": "Miaou",
    "gui.defaultProject.variable": "ma variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Prise en main",
    "gui.howtos.intro-move.step_stepMove": "Ajoute un bloc de mouvement",
    "gui.howtos.add-a-move-block.step_stepSay": "Ajoute un bloc \"dire\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Clique sur le drapeau vert pour commencer",
    "gui.howtos.intro-getting-started-ASL.name": "Prise en main - ASL",
    "gui.howtos.animate-a-name.name": "Anime un nom",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Choisis un sprite en forme de lettre",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Jouer un son quand cliqué",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Choisis un autre sprite en forme de lettre",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Change la couleur",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Choisis un costume avec une autre lettre et fais la tourner",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Choisis un costume avec une autre lettre et fais la grandir",
    "gui.howtos.imagine": "Imagine un monde",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tape ce que tu veux dire",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Clique sur le drapeau vert pour commencer",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choisis un arrière-plan",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choisis un sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Appuie sur la barre d’espace pour glisser",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choisis un autre sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Bouger Gauche-Droite",
    "gui.howtos.imagine.step_imagineUpDown": "Bouger en haut-en bas",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change de costume",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glisser vers un point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grandis et rapetisse",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choisis un autre arrière-plan",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Change les arrière-plans",
    "gui.howtos.imagine.step_imagineRecordASound": "Ajoute un son",
    "gui.howtos.imagine.step_imagineChooseSound": "Choisis ton son",
    "gui.howtos.make-music.name": "Fais de la musique",
    "gui.howtos.Make-Music.step_PickInstrument": "Choisis un sprite instrument",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Jouer un son quand cliqué",
    "gui.howtos.Make-Music.step_MakeSong": "Crée un son",
    "gui.howtos.make-music.step_MakeBeat": "Choisis un tambour et fait un battement",
    "gui.howtos.make-music.step_MakeBeatBox": "Choisis le sprite micro et la boite à sons surprise",
    "gui.howtos.story.name": "Crée une histoire",
    "gui.howtos.story.step_addbg": "Ajoute un arrière-plan",
    "gui.howtos.story.step_addsprite": "Ajoute un personnage",
    "gui.howtos.story.step_saysomething": "Dis quelque chose",
    "gui.howtos.story.step_addanothersprite": "Ajouter un autre personnage",
    "gui.howtos.story.step_flip": "Change la direction",
    "gui.howtos.story.step_conversation": "Fais une conversation",
    "gui.howtos.story.addanotherbg": "Ajoute un autre arrière-plan",
    "gui.howtos.story.step_swithbg": "Change les arrière-plans",
    "gui.howtos.story.step_hidewizard": "Cache un personnage",
    "gui.howtos.story.step_showwizard": "Montre un personnage",
    "gui.howtos.make-a-chase-game.name": "Fais un jeu de poursuite",
    "gui.howtos.Chase-Game.step_BG": "Ajoute un arrière-plan",
    "gui.howtos.chase-game.step_AddOcto": "Ajoute un sprite",
    "gui.howtos.make-music.step_LeftRight": "Bouge vers la droite et vers la gauche avec les flèches du clavier",
    "gui.howtos.Chase-Game.step_UpDown": "Bouge vers le haut et vers le bas avec les flèches du clavier",
    "gui.howtos.Chase-Game.step_AddStar": "Ajoute un autre sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bouger aléatoirement",
    "gui.howtos.Chase-Game.step_WhenTouch": "Dans le sprite pieuvre, Quand touché, Jouer un son",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crée une variable score",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Dans le sprite pieuvre, Quand touché, Ajouter un score",
    "gui.howtos.animate-char.name": "Anime un personnage",
    "gui.howtos.animate-char.step_addbg": "Ajoute un arrière-plan",
    "gui.howtos.animate-char.step_addsprite": "Ajoute un sprite",
    "gui.howtos.animate-char.step_saysomething": "Dis quelque chose",
    "gui.howtos.animate-char.step_addsound": "Ajoute un son",
    "gui.howtos.animate-char.step_animatetalking": "Anime la discussion",
    "gui.howtos.animate-char.step_arrowkeys": "Bouge en utilisant les flèches du clavier",
    "gui.howtos.animate-char.step_jump": "Saute",
    "gui.howtos.animate-char.step_changecolor": "Change la couleur",
    "gui.howtos.make-a-game.name": "Crée un jeu Clicker",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Choisis un sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Jouer un son quand cliqué",
    "gui.howtos.make-a-game.step_GameAddScore": "Crée une variable score",
    "gui.howtos.make-a-game.step_GameChangeScore": "Quand cliqué augmente le score",
    "gui.howtos.make-a-game.step_Random": "Va à une position aléatoire",
    "gui.howtos.make-music.step_GameChangeColor": "Change la couleur",
    "gui.howtos.make-music.step_ResetScore": "Remets le score à zéro",
    "gui.howtos.make-it-fly.name": "Fais-le voler",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choisis un arrière-plan ciel",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choisis un personnage",
    "gui.howtos.fly.step_stepflySaySomething": "Dis quelque chose",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Déplace-toi avec les flèches du clavier",
    "gui.howtos.fly.step_stepflyChooseObject": "Choisis un objet à récupérer",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fais bouger l'objet",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Choisis ton personnage",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ajoute un score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Conserve le score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ajoute des paysages",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Fais bouger le paysage",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Costume suivant",
    "gui.howtos.pong": "Jeu de Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Ajoute un arrière-plan",
    "gui.howtos.pong.step_pongAddBallSprite": "Ajoute un sprite balle",
    "gui.howtos.pong.step_pongBounceAround": "Rebondir",
    "gui.howtos.pong.step_pongAddPaddle": "Ajoute une raquette",
    "gui.howtos.pong.step_pongMoveThePaddle": "Fais bouger la raquette",
    "gui.howtos.pong.step_pongSelectBallSprite": "Sélectionne le sprite balle",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ajoute du code pour faire rebondir la balle sur la raquette",
    "gui.howtos.pong.step_pongAddAScore": "Ajoute un score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choisis \"Score\" depuis le menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insère le bloc \"ajouter à score\"",
    "gui.howtos.pong.step_pongResetScore": "Remets le score à zéro",
    "gui.howtos.pong.step_pongAddLineSprite": "Ajoute le sprite ligne",
    "gui.howtos.pong.step_pongGameOver": "Partie terminée",
    "gui.howtos.code-cartoon": "Programme un dessin animé",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dis quelque chose quand tu cliques sur le drapeau vert",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anime un personnage quand tu cliques dessus",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Choisis un autre personnage",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Utilise le signe \"moins\" pour diminuer",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fais grandir et rétrécir un personnage",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Choisis un autre personnage",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Sauter en haut et en bas",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Clique sur un personnage pour changer de scène",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glisser tout autour",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change de costume",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choisis d'autres personnages à ajouter à ton dessin animé",
    "gui.howtos.cartoon-network": "Animer un jeu d'aventure",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choisis un personnage à afficher",
    "gui.howtos.cartoon-network.step_CNsay": "Dis quelque chose",
    "gui.howtos.cartoon-network.step_CNglide": "Glisser tout autour",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choisis un objet à pourchasser",
    "gui.howtos.cartoon-network.step_CNcollect": "Collecte les objets",
    "gui.howtos.cartoon-network.step_CNvariable": "Fais une variable score",
    "gui.howtos.cartoon-network.step_CNscore": "Conserve le score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Niveau supérieur : Change d'arrière-plan",
    "gui.howtos.videosens.name": "Détection vidéo",
    "gui.howtos.videosens.step_addextension": "Ajouter une extension",
    "gui.howtos.videosens.step_pet": "Caresse le chat",
    "gui.howtos.videosens.step_animate": "Anime",
    "gui.howtos.videosens.step_pop": "Éclate un ballon",
    "gui.howtos.say-it-out-loud": "Crée des animations qui parlent",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ajoute le texte dans les blocs \"Synthèse vocale\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dis quelque chose",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Choisis une voix",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Déplace-toi",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ajoute un arrière-plan",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ajoute un autre personnage",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Chante une chanson",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change la couleur",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Tourner autour",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grandis et rapetisse",
    "gui.howtos.talking": "Histoires parlantes",
    "gui.howtos.talking.step_talesAddExtension": "Clique sur le bouton pour ajouter les blocs \"Synthèse vocale\"",
    "gui.howtos.talking.step_talesChooseSprite": "Choisis un sprite",
    "gui.howtos.talking.step_talesSaySomething": "Fais parler un personnage",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choisir un arrière-plan",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Clique sur un personnage pour passer à l'arrière-plan suivant",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choisis un autre sprite",
    "gui.howtos.talking.step_talesMoveAround": "Déplace-toi",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choisis un autre arrière-plan",
    "gui.howtos.talking.step_talesAnimateTalking": "Anime la discussion",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choisis un autre arrière-plan",
    "gui.howtos.talking.step_talesChooseSound": "Choisis une musique sur laquelle danser",
    "gui.howtos.talking.step_talesDanceMoves": "Pas de dance",
    "gui.howtos.talking.step_talesAskAnswer": "Prends les blocs \"demander\" et \"réponse\" dans la catégorie \"Capteurs\"",
    "gui.howtos.add-sprite.name": "Ajoute un sprite",
    "gui.howtos.add-sprite.step_addSprite": "Ajoute un sprite",
    "gui.howtos.add-a-backdrop.name": "Ajoute un arrière-plan",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ajoute un arrière-plan",
    "gui.howtos.change-size.name": "Change la taille",
    "gui.howtos.change-size.step_changeSize": "Change la taille",
    "gui.howtos.glide-around.name": "Glisser tout autour",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glisser tout autour",
    "gui.howtos.change-size.step_glideAroundPoint": "Glisser vers un point",
    "gui.howtos.record-a-sound.name": "Enregistrer un son",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clique sur l'onglet \"Sons\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clique sur \"Enregistrer\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Appuie sur le bouton Enregistrer",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choisis ton son",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Fais jouer ton son",
    "gui.howtos.spin-video.name": "Fais-le tourner",
    "gui.howtos.change-size.step_spinTurn": "Tourner",
    "gui.howtos.change-size.step_spinPointInDirection": "Définir la direction",
    "gui.howtos.hide-and-show.name": "Se cacher & se montrer",
    "gui.howtos.change-size.step_hideAndShow": "Cacher et Monter",
    "gui.howtos.switch-costume.name": "Anime un sprite",
    "gui.howtos.change-size.step_switchCostumes": "Anime un sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Utilise les flèches directionnelles",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Bouger à gauche et à droite",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bouger en haut et en bas",
    "gui.howtos.add-effects.name": "Ajouter des effets",
    "gui.howtos.videosens.step_addEffects": "Ajouter des effets",
    "gui.extension.music.name": "Musique",
    "gui.extension.music.description": "Jouer des instruments et du tambour.",
    "gui.extension.pen.name": "Stylo",
    "gui.extension.pen.description": "Dessiner avec vos sprites.",
    "gui.extension.videosensing.name": "Détection vidéo",
    "gui.extension.videosensing.description": "Capter du mouvement avec la caméra.",
    "gui.extension.text2speech.name": "Synthèse vocale",
    "gui.extension.text2speech.description": "Fais parler tes projets.",
    "gui.extension.translate.name": "Traduire",
    "gui.extension.translate.description": "Traduire du texte dans différentes langues.",
    "gui.extension.makeymakey.description": "Transforme n'importe quoi en touche.",
    "gui.extension.microbit.description": "Connecter vos projets avec le monde.",
    "gui.extension.microbit.connectingMessage": "Connexion",
    "gui.extension.ev3.description": "Construire des robots interactifs et plus.",
    "gui.extension.ev3.connectingMessage": "Connexion. Vérifiez que le pin sur votre EV3 est mis sur 1234.",
    "gui.extension.boost.description": "Donner vie à des créations robotiques.",
    "gui.extension.boost.connectingMessage": "Connexion",
    "gui.extension.wedo2.description": "Construire avec des moteurs et des capteurs.",
    "gui.extension.wedo2.connectingMessage": "Connexion",
    "gui.extension.gdxfor.description": "Sentir quand on pousse, tire, bouge et tourne.",
    "gui.extension.gdxfor.connectingMessage": "Connexion",
    "gui.libraryTags.all": "Tout",
    "gui.libraryTags.animals": "Animaux",
    "gui.libraryTags.dance": "Danser",
    "gui.libraryTags.effects": "Effets",
    "gui.libraryTags.fantasy": "Fantaisie",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Nourriture",
    "gui.libraryTags.indoors": "Intérieur",
    "gui.libraryTags.loops": "Boucles",
    "gui.libraryTags.music": "Musique",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Dehors",
    "gui.libraryTags.patterns": "Motifs",
    "gui.libraryTags.people": "Gens",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Espace",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Monde aquatique",
    "gui.libraryTags.voice": "Voix",
    "gui.libraryTags.wacky": "Farfelu",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Jeux",
    "gui.libraryTags.stories": "Histoires",
    "gui.libraryTags.letters": "Lettres",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "abscisse x",
    "gui.opcodeLabels.yposition": "ordonnée y",
    "gui.opcodeLabels.size": "taille",
    "gui.opcodeLabels.costumename": "nom du costume",
    "gui.opcodeLabels.costumenumber": "numéro de costume",
    "gui.opcodeLabels.backdropname": "nom de l'arrière-plan",
    "gui.opcodeLabels.backdropnumber": "numéro d'arrière-plan",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "réponse",
    "gui.opcodeLabels.loudness": "volume sonore",
    "gui.opcodeLabels.username": "nom d'utilisateur",
    "gui.opcodeLabels.year": "année",
    "gui.opcodeLabels.month": "mois",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "jour de la semaine",
    "gui.opcodeLabels.hour": "heure",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "seconde",
    "gui.opcodeLabels.timer": "chronomètre",
    "gui.projectLoader.loadError": "Le fichier du projet qui a été sélectionné n'a pas réussi à être chargé.",
    "gui.sharedMessages.backdrop": "arrière-plan{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": " Remplacer le contenu du projet actuel ?",
    "gui.sharedMessages.loadFromComputerTitle": "Importer depuis votre ordinateur",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Sombre",
    "gui.theme.highContrast": "Contraste élevé",
    "gui.gui.defaultProjectTitle": "Projet Scratch",
    "boost.color.any": "de n'importe quelle couleur",
    "boost.color.black": "noire",
    "boost.color.blue": "bleue",
    "boost.color.green": "verte",
    "boost.color.red": "rouge",
    "boost.color.white": "blanche",
    "boost.color.yellow": "jaune",
    "boost.getMotorPosition": "position du moteur [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "angle d'inclinaison [TILT_DIRECTION]",
    "boost.motorDirection.backward": "par là",
    "boost.motorDirection.forward": "par ici",
    "boost.motorDirection.reverse": "inversée",
    "boost.motorOff": "éteindre le moteur [MOTOR_ID]",
    "boost.motorOn": "allumer le moteur [MOTOR_ID]",
    "boost.motorOnFor": "faire tourner le moteur [MOTOR_ID] pendant [DURATION] secondes",
    "boost.motorOnForRotation": "faire tourner le moteur [MOTOR_ID] de [ROTATION] rotations",
    "boost.seeingColor": "brique [COLOR] vue ?",
    "boost.setLightHue": "mettre la couleur de la lampe à [HUE]",
    "boost.setMotorDirection": "mettre la direction du moteur [MOTOR_ID] à [MOTOR_DIRECTION]",
    "boost.setMotorPower": "mettre la vitesse du moteur [MOTOR_ID] à [POWER] %",
    "boost.tiltDirection.any": "n'importe laquelle",
    "boost.tiltDirection.down": "vers le bas",
    "boost.tiltDirection.left": "à gauche",
    "boost.tiltDirection.right": "à droite",
    "boost.tiltDirection.up": "vers le haut",
    "boost.whenColor": "quand une brique [COLOR] est vue",
    "boost.whenTilted": "quand incliné [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "jouer la note [NOTE] pendant [TIME] secondes",
    "ev3.buttonPressed": "bouton [PORT] appuyé ?",
    "ev3.getBrightness": "luminosité",
    "ev3.getDistance": "distance",
    "ev3.getMotorPosition": "position du moteur [PORT]",
    "ev3.motorSetPower": "mettre la puissance du moteur [PORT] à [POWER] %",
    "ev3.motorTurnClockwise": "faire tourner le moteur [PORT] dans ce sens-ci pendant [TIME] secondes",
    "ev3.motorTurnCounterClockwise": "faire tourner le moteur [PORT] dans ce sens-là pendant [TIME] secondes",
    "ev3.whenBrightnessLessThan": "quand la luminosité < [DISTANCE]",
    "ev3.whenButtonPressed": "quand le bouton [PORT] est appuyé",
    "ev3.whenDistanceLessThan": "quand la distance < [DISTANCE]",
    "gdxfor.getAcceleration": "accélération [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "vitesse de rotation [DIRECTION]",
    "gdxfor.getTilt": "angle d'inclinaison [TILT]",
    "gdxfor.isFreeFalling": "tombe ?",
    "gdxfor.isTilted": "incliné [TILT] ?",
    "gdxfor.pulled": "tiré",
    "gdxfor.pushed": "poussé",
    "gdxfor.shaken": "secoué",
    "gdxfor.startedFalling": "commençant à tomber",
    "gdxfor.tiltDirectionMenu.any": "n'importe laquelle",
    "gdxfor.tiltDirectionMenu.back": "en arrière",
    "gdxfor.tiltDirectionMenu.front": "en avant",
    "gdxfor.tiltDirectionMenu.left": "à gauche",
    "gdxfor.tiltDirectionMenu.right": "à droite",
    "gdxfor.turnedFaceDown": "tourné vers le bas",
    "gdxfor.turnedFaceUp": "tourné vers le haut",
    "gdxfor.whenForcePushedOrPulled": "quand le capteur de force est [PUSH_PULL]",
    "gdxfor.whenGesture": "quand [GESTURE]",
    "gdxfor.whenTilted": "quand incliné [TILT]",
    "makeymakey.downArrow": "flèche bas",
    "makeymakey.downArrowShort": "bas",
    "makeymakey.leftArrow": "flèche gauche",
    "makeymakey.leftArrowShort": "gauche",
    "makeymakey.rightArrow": "flèche droite",
    "makeymakey.rightArrowShort": "droite",
    "makeymakey.spaceKey": "espace",
    "makeymakey.upArrow": "flèche haut",
    "makeymakey.upArrowShort": "haut",
    "makeymakey.whenKeyPressed": "quand la touche [KEY] pressée",
    "makeymakey.whenKeysPressedInOrder": "quand [SEQUENCE] sont pressés dans l'ordre",
    "microbit.buttonsMenu.any": "n'importe lequel",
    "microbit.clearDisplay": "effacer l'écran",
    "microbit.defaultTextToDisplay": "Bonjour !",
    "microbit.displaySymbol": "afficher [MATRIX]",
    "microbit.displayText": "afficher le texte [TEXT]",
    "microbit.gesturesMenu.jumped": "sauté",
    "microbit.gesturesMenu.moved": "bougé",
    "microbit.gesturesMenu.shaken": "secoué",
    "microbit.isButtonPressed": "bouton [BTN] appuyé ?",
    "microbit.isTilted": "incliné [DIRECTION] ?",
    "microbit.pinStateMenu.off": "désactivée",
    "microbit.pinStateMenu.on": "activée",
    "microbit.tiltAngle": "angle d'inclinaison [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "dans n'importe quelle direction",
    "microbit.tiltDirectionMenu.back": "en arrière",
    "microbit.tiltDirectionMenu.front": "en avant",
    "microbit.tiltDirectionMenu.left": "à gauche",
    "microbit.tiltDirectionMenu.right": "à droite",
    "microbit.whenButtonPressed": "quand le bouton [BTN] est appuyé",
    "microbit.whenGesture": "quand [GESTURE]",
    "microbit.whenPinConnected": "quand la broche [PIN] est connectée",
    "microbit.whenTilted": "quand incliné [DIRECTION]",
    "music.categoryName": "Musique",
    "music.changeTempo": "ajouter [TEMPO] au tempo",
    "music.drumBass": "(2) Grosse caisse",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charleston fermé",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Sonnaille",
    "music.drumCrashCymbal": "(4) Cymbale crash",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Claquement de main",
    "music.drumOpenHiHat": "(5) Charleston ouvert",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Caisse claire",
    "music.drumTambourine": "(7) Tambourin",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood-block",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Basse",
    "music.instrumentBassoon": "(14) Basson",
    "music.instrumentCello": "(8) Violoncelle",
    "music.instrumentChoir": "(15) Chorale",
    "music.instrumentClarinet": "(10) Clarinette",
    "music.instrumentElectricGuitar": "(5) Guitare électrique",
    "music.instrumentElectricPiano": "(2) Piano électrique",
    "music.instrumentFlute": "(12) Flûte",
    "music.instrumentGuitar": "(4) Guitare",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Boîte à musique",
    "music.instrumentOrgan": "(3) Orgue",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Lead synthétisé",
    "music.instrumentSynthPad": "(21) Pad synthétisé",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Flûte en bois",
    "music.midiPlayDrumForBeats": "jouer du tambour [DRUM] pendant [BEATS] temps",
    "music.midiSetInstrument": "choisir l'instrument n° [INSTRUMENT]",
    "music.playDrumForBeats": "jouer du tambour [DRUM] pendant [BEATS] temps",
    "music.playNoteForBeats": "jouer la note [NOTE] pendant [BEATS] temps",
    "music.restForBeats": "faire une pause pendant [BEATS] temps",
    "music.setInstrument": "choisir l'instrument n° [INSTRUMENT]",
    "music.setTempo": "mettre le tempo à [TEMPO]",
    "pen.categoryName": "Stylo",
    "pen.changeColorParam": "ajouter [VALUE] à la [COLOR_PARAM] du stylo",
    "pen.changeHue": "ajouter [HUE] à la couleur du stylo",
    "pen.changeShade": "ajouter [SHADE] à l'intensité du stylo",
    "pen.changeSize": "ajouter [SIZE] à la taille du stylo",
    "pen.clear": "effacer tout",
    "pen.colorMenu.brightness": "luminosité",
    "pen.colorMenu.color": "couleur",
    "pen.colorMenu.saturation": "saturation",
    "pen.colorMenu.transparency": "transparence",
    "pen.penDown": "stylo en position d'écriture",
    "pen.penUp": "relever le stylo",
    "pen.setColor": "mettre la couleur du stylo à [COLOR]",
    "pen.setColorParam": "mettre la [COLOR_PARAM] du stylo à [VALUE]",
    "pen.setHue": "mettre la couleur du stylo à [HUE]",
    "pen.setShade": "mettre l'intensité du stylo à [SHADE]",
    "pen.setSize": "mettre la taille du stylo à [SIZE]",
    "pen.stamp": "estampiller",
    "speech.defaultWhenIHearValue": "allons-y",
    "speech.extensionName": "Synthèse vocale",
    "speech.listenAndWait": "écouter et attendre",
    "speech.speechReporter": "parole",
    "speech.whenIHear": "quand j'entends [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Synthèse vocale",
    "text2speech.defaultTextToSpeak": "bonjour",
    "text2speech.giant": "géant",
    "text2speech.kitten": "chaton",
    "text2speech.setLanguageBlock": "mettre la langue à [LANGUAGE]",
    "text2speech.setVoiceBlock": "choisir la voix du [VOICE]",
    "text2speech.speakAndWaitBlock": "prononcer [WORDS]",
    "text2speech.squeak": "piailler",
    "text2speech.tenor": "ténor",
    "translate.categoryName": "Traduire",
    "translate.defaultTextToTranslate": "bonjour",
    "translate.translateBlock": "traduire [WORDS] en [LANGUAGE]",
    "translate.viewerLanguage": "langue",
    "videoSensing.categoryName": "Détection vidéo",
    "videoSensing.direction": "direction",
    "videoSensing.motion": "mouvement",
    "videoSensing.off": "désactiver",
    "videoSensing.on": "activer",
    "videoSensing.onFlipped": "inverser",
    "videoSensing.setVideoTransparency": "mettre la transparence de la vidéo à [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "scène",
    "videoSensing.videoOn": "[ATTRIBUTE] de la vidéo de [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] la vidéo",
    "videoSensing.whenMotionGreaterThan": "quand le mouvement de la vidéo > [REFERENCE]",
    "wedo2.getDistance": "distance",
    "wedo2.getTiltAngle": "angle d'inclinaison [TILT_DIRECTION]",
    "wedo2.isTilted": "incliné [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "par là",
    "wedo2.motorDirection.forward": "par ici",
    "wedo2.motorDirection.reverse": "inversé",
    "wedo2.motorId.a": "moteur A",
    "wedo2.motorId.all": "tous les moteurs",
    "wedo2.motorId.b": "moteur B",
    "wedo2.motorId.default": "moteur",
    "wedo2.motorOff": "éteindre [MOTOR_ID]",
    "wedo2.motorOn": "allumer [MOTOR_ID]",
    "wedo2.motorOnFor": "allumer [MOTOR_ID] pendant [DURATION] secondes",
    "wedo2.playNoteFor": "jouer la note [NOTE] pendant [DURATION] secondes",
    "wedo2.setLightHue": "mettre la couleur de la lampe à [HUE]",
    "wedo2.setMotorDirection": "mettre la direction de [MOTOR_ID] à [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "dans n'importe quelle direction",
    "wedo2.tiltDirection.down": "vers le bas",
    "wedo2.tiltDirection.left": "à gauche",
    "wedo2.tiltDirection.right": "à droite",
    "wedo2.tiltDirection.up": "vers le haut",
    "wedo2.whenDistance": "quand la distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "quand incliné [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Couleur",
    "paint.paintEditor.saturation": "Saturation",
    "paint.paintEditor.brightness": "Luminosité",
    "paint.paintEditor.costume": "Costume",
    "paint.paintEditor.group": "Grouper",
    "paint.paintEditor.ungroup": "Dégrouper",
    "paint.paintEditor.undo": "Restaurer",
    "paint.paintEditor.redo": "Refaire",
    "paint.paintEditor.forward": "Avancer",
    "paint.paintEditor.backward": "Reculer",
    "paint.paintEditor.front": "Avant-plan",
    "paint.paintEditor.back": "Arrière-plan",
    "paint.paintEditor.more": "Plus",
    "paint.modeTools.brushSize": "Taille",
    "paint.modeTools.eraserSize": "Taille de la gomme",
    "paint.modeTools.copy": "Copier",
    "paint.modeTools.paste": "Coller",
    "paint.modeTools.delete": "Supprimer",
    "paint.modeTools.curved": "Courbé",
    "paint.modeTools.pointed": "Pointu",
    "paint.modeTools.thickness": "Épaisseur",
    "paint.modeTools.flipHorizontal": "Retourner horizontalement",
    "paint.modeTools.flipVertical": "Retourner verticalement",
    "paint.modeTools.filled": "Plein",
    "paint.modeTools.outlined": "Contours",
    "paint.paintEditor.bitmap": "Convertir en bitmap",
    "paint.paintEditor.vector": "Convertir en Vecteur",
    "paint.paintEditor.fill": "Remplissage",
    "paint.paintEditor.stroke": "Contour",
    "paint.brushMode.brush": "Pinceau",
    "paint.eraserMode.eraser": "Gomme",
    "paint.fillMode.fill": "Remplissage",
    "paint.lineMode.line": "Ligne",
    "paint.ovalMode.oval": "Cercle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Redessiner",
    "paint.roundedRectMode.roundedRect": "Rectangle arrondi",
    "paint.selectMode.select": "Sélectionner",
    "paint.textMode.text": "Texte",
    "paint.colorPicker.swap": "Inverser"
  },
  "fy": {
    "gui.alerts.lostPeripheralConnection": "Scratch ferlear ferbining mei {extensionName}",
    "gui.alerts.tryAgain": "Besykje nochris",
    "gui.alerts.download": "Dellade",
    "gui.connection.reconnect": "Opnij ferbine",
    "gui.backpack.costumeLabel": "kostúm",
    "gui.backpack.soundLabel": "lûd",
    "gui.backpack.scriptLabel": "skript",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Rêchsek",
    "gui.backpack.errorBackpack": "Flater by laden fan rêchsek",
    "gui.backpack.loadingBackpack": "Lade ...",
    "gui.backpack.more": "Mear",
    "gui.backpack.emptyBackpack": "Rêchsek is leech",
    "gui.unsupportedBrowser.label": "Browser wurdt net stipe",
    "gui.unsupportedBrowser.errorLabel": "Der wie in flater",
    "gui.unsupportedBrowser.notRecommended": "It spyt ús, mar it liket derop dat jo in browserferzje brûke dy't Scratch net stipet. Wy advisearje de browser by te wurkjen nei de lêste ferzje (Google Chrome, Mozilla Firefox, Microsoft Edge of Safari).",
    "gui.unsupportedBrowser.description": "It spyt ús,  mar Scratch stipet dizze browser net. Wy advisearje in browser, bywurke nei de lêste ferzje (Google Chrome, Mozilla Firefox, Microsoft Edge of Safari).",
    "gui.unsupportedBrowser.back": "Werom",
    "gui.unsupportedBrowser.previewfaq": "Om mear te witten te kommen, gean nei de {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Faak stelde fragen",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Lytser meitsje",
    "gui.cards.expand": "Mear sjen litte",
    "gui.cards.close": "Slute",
    "gui.cards.more-things-to-try": "Mear dingen om te besykjen!",
    "gui.cards.see-more": "Mear sjen",
    "gui.comingSoon.message1": "Gjin need, wy wurkje deroan {emoji}",
    "gui.comingSoon.message2": "Meikoarten...",
    "gui.comingSoon.message3": "Wy wurkje deroan {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Gjin apparaten fûn",
    "gui.connection.auto-scanning.prescan": "Hâld jo apparaat klear en begjin mei sykjen.",
    "gui.connection.auto-scanning.pressbutton": "Druk op de knop op jo apparaat.",
    "gui.connection.auto-scanning.start-search": "Begjin mei sykjen",
    "gui.connection.connecting-searchbutton": "Sykje...",
    "gui.connection.auto-scanning.try-again": "Besykje nochris",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ferbûn",
    "gui.connection.disconnect": "Ferbining ferbrekke",
    "gui.connection.go-to-editor": "Gean nei Editor",
    "gui.connection.connecting-cancelbutton": "Ferbine...",
    "gui.connection.error.errorMessage": "Oeps, it liket derop dat der wat misgie.",
    "gui.connection.error.tryagainbutton": "Besykje nochris",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Namme fan it apparaat",
    "gui.connection.connect": "Ferbine",
    "gui.connection.scanning.lookingforperipherals": "Sykje nei apparaten",
    "gui.connection.scanning.noPeripheralsFound": "Gjin apparaten fûn",
    "gui.connection.scanning.instructions": "Selektearje jo apparaat yn boppesteande list.",
    "gui.connection.search": "Fernije",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Soargje derfoar dat jo Scratch Link ynstallearre en aktyf hawwe",
    "gui.connection.unavailable.enablebluetooth": "Kontrolearje oft Bluetooth ynskeakele is",
    "gui.connection.unavailable.tryagainbutton": "Besykje nochris",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Start",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oeps! Der is wat misgien.",
    "gui.crashMessage.description": "It spyt ús, mar it liket derop dat Scratch fêstrûn is. It probleem is automatysk rapporteare oan it Scratch Team. Fernij de side om it nochris te besykjen.",
    "gui.crashMessage.errorNumber": "Jo flater is oanmeld mei id {errorId}",
    "gui.crashMessage.reload": "Op 'e nij lade",
    "gui.customProcedures.myblockModalTitle": "Meitsje in Blok",
    "gui.customProcedures.addAnInputNumberText": "Foegje in ynput ta",
    "gui.customProcedures.numberTextType": "getal of tekst",
    "gui.customProcedures.addAnInputBoolean": "Foegje in ynput ta",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Foegje in kaartsje ta",
    "gui.customProcedures.runWithoutScreenRefresh": "Utfiere sûnder skermfernijing",
    "gui.customProcedures.cancel": "Ofbrekke",
    "gui.customProcedures.ok": "Okee",
    "gui.SpriteInfo.direction": "Rjochting",
    "gui.directionPicker.rotationStyles.allAround": "Oeral",
    "gui.directionPicker.rotationStyles.leftRight": "Links/Rjochts",
    "gui.directionPicker.rotationStyles.dontRotate": "Net draaie",
    "gui.gui.addExtension": "Ekstinsje tafoegje",
    "gui.gui.codeTab": "Koade",
    "gui.gui.backdropsTab": "Eftergrûnen",
    "gui.gui.costumesTab": "Kostúms",
    "gui.gui.soundsTab": "Lûden",
    "gui.extensionLibrary.comingSoon": "Meikoarten",
    "gui.extensionLibrary.requires": "Fereasket",
    "gui.extensionLibrary.collaboration": "Gearwurking mei",
    "gui.library.filterPlaceholder": "Sykje",
    "gui.library.allTag": "Alle",
    "gui.loader.message1": "Blokken oanmeitsje...",
    "gui.loader.message2": "Sprites wurde laden...",
    "gui.loader.message3": "Lûden wurde laden...",
    "gui.loader.message4": "Ekstinsjes wurde laden...",
    "gui.loader.message5": "Katten byinoar roppe...",
    "gui.loader.message6": "Nano's útstjoere...",
    "gui.loader.message7": "Gobo's opblaze...",
    "gui.loader.message8": "Emoji's tariede...",
    "gui.loader.headline": "Projekt wurdt laden",
    "gui.loader.creating": "Projekt wurdt oanmakke",
    "gui.accountMenu.profile": "Profyl",
    "gui.accountMenu.myStuff": "Myn Guod",
    "gui.accountMenu.myClasses": "Myn Klassen",
    "gui.accountMenu.myClass": "Myn Klasse",
    "gui.accountMenu.accountSettings": "Akkountynstellings",
    "gui.accountMenu.signOut": "Utlogge",
    "gui.authorInfo.byUser": "troch {username}",
    "gui.menuBar.seeProjectPage": "Besjoch projektpagina",
    "gui.menuBar.language": "Language",
    "general.username": "Brûkersnamme",
    "general.password": "Wachtwurd",
    "general.signIn": "Ynlogge",
    "login.needHelp": "Help nedich?",
    "form.validationRequired": "Dit fjild is ferplichte",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Sprite weromsette",
    "gui.menuBar.restoreSound": "Lûd weromsette",
    "gui.menuBar.restoreCostume": "Kostúm weromsette",
    "gui.menuBar.restore": "Weromsette",
    "gui.menuBar.saveNow": "No bewarje",
    "gui.menuBar.saveAsCopy": "Bewarje as kopy",
    "gui.menuBar.remix": "Mjukse",
    "gui.menuBar.new": "Nij",
    "gui.menuBar.file": "Bestân",
    "gui.menuBar.downloadToComputer": "Bewarje op jo kompjûter",
    "gui.menuBar.edit": "Bewurkje",
    "gui.menuBar.turboModeOff": "Turbo-modus útsette",
    "gui.menuBar.turboModeOn": "Turbo-modus oansette",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Doch mei oan Scratch",
    "gui.menuBar.signIn": "Ynlogge",
    "gui.gui.projectTitlePlaceholder": "Projektitel hjir",
    "gui.menuBar.saveNowLink": "Bewarje no",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Dield",
    "gui.menuBar.share": "Diele",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Help",
    "gui.modal.back": "Werom",
    "gui.monitor.listMonitor.empty": "(leech)",
    "gui.monitor.listMonitor.listLength": "lingte {length}",
    "gui.monitor.contextMenu.default": "normale útfier",
    "gui.monitor.contextMenu.large": "grutte útfier",
    "gui.monitor.contextMenu.slider": "skúfútfier",
    "gui.monitor.contextMenu.sliderRange": "feroarje skúfberik",
    "gui.monitor.contextMenu.import": "ymportearje",
    "gui.monitor.contextMenu.export": "eksportearje",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Ofspylje",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Foar alle sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Allinich foar dizze sprite",
    "gui.gui.cloudVariableOption": "Cloud-fariabele (opslein op server)",
    "gui.gui.variablePromptAllSpritesMessage": "Dizze fariabele sil beskikber wêze foar alle sprites.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Ofbrekke",
    "gui.prompt.ok": "Okee",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Ofspylje",
    "gui.playbackStep.loadingMsg": "Lade...",
    "gui.playbackStep.saveMsg": "Bewarje",
    "gui.playbackStep.reRecordMsg": "Opnij opnimme",
    "gui.recordModal.title": "Lûd opnimme",
    "gui.recordingStep.beginRecord": "Begjin opname troch te klikken op de knop hjirûnder",
    "gui.recordingStep.permission": "{arrow}Wy hawwe jo tastimming nedich om jo mikrofoan te brûken",
    "gui.recordingStep.stop": "Stopje de opname",
    "gui.recordingStep.record": "Opnimme",
    "gui.sliderModal.min": "Minimumwearde",
    "gui.sliderModal.max": "Maksimumwearde",
    "gui.sliderModal.title": "Feroarje skúfberik",
    "gui.sliderPrompt.cancel": "Ofbrekke",
    "gui.sliderPrompt.ok": "Okee",
    "gui.soundEditor.sound": "Lûd",
    "gui.soundEditor.play": "Ofspylje",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Kopiearje",
    "gui.soundEditor.paste": "Plakke",
    "gui.soundEditor.copyToNew": "Kopiearje nei Nij",
    "gui.soundEditor.delete": "Fuortsmite",
    "gui.soundEditor.save": "Bewarje",
    "gui.soundEditor.undo": "Ungedien meitsje",
    "gui.soundEditor.redo": "Op 'e nij dwaan",
    "gui.soundEditor.faster": "Flugger",
    "gui.soundEditor.slower": "Stadiger",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Lûder",
    "gui.soundEditor.softer": "Sêfter",
    "gui.soundEditor.reverse": "Efterút",
    "gui.soundEditor.fadeOut": "Uitferfage",
    "gui.soundEditor.fadeIn": "Ynferfage",
    "gui.soundEditor.mute": "Lûd út",
    "gui.SpriteInfo.spritePlaceholder": "Namme",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Sjen litte",
    "gui.SpriteInfo.size": "Grutte",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplisearje",
    "gui.spriteSelectorItem.contextMenuExport": "eksportearje",
    "gui.spriteSelectorItem.contextMenuDelete": "fuortsmite",
    "gui.spriteSelector.addSpriteFromLibrary": "Kies in Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Paint",
    "gui.spriteSelector.addSpriteFromSurprise": "Ferrassing",
    "gui.spriteSelector.addSpriteFromFile": "Sprite ynlade",
    "gui.stageHeader.stageSizeLarge": "Wikselje nei grut poadium",
    "gui.stageHeader.stageSizeSmall": "Wikselje nei lyts poadium",
    "gui.stageHeader.stageSizeFull": "Folslein skerm",
    "gui.stageHeader.stageSizeUnFull": "Folslein skerm ôfslute",
    "gui.stageHeader.fullscreenControl": "Folslein skerm",
    "gui.spriteSelector.addBackdropFromLibrary": "Kies in eftergrûn",
    "gui.stageSelector.addBackdropFromPaint": "Paint",
    "gui.stageSelector.addBackdropFromSurprise": "Ferrassing",
    "gui.stageSelector.addBackdropFromFile": "Eftergrûn ynlade",
    "gui.stageSelector.stage": "Poadium",
    "gui.stageSelector.backdrops": "Eftergrûnen",
    "gui.telemetryOptIn.label": "Rapportearje statistiken om Scratch te ferbetterjen",
    "gui.telemetryOptIn.body1": "It Scratch Team wol hieltyd better begripe hoe't Scratch oer de hiele wrâld  brûkt wurdt. Om dy ynspanning te stypjen, kinne jo Scratch tastean om ynformaasje oer it gebrûk automatysk nei it Scratch Team te stjoeren.",
    "gui.telemetryOptIn.body2": "De ynformaasje dy't wy sammelje omfettet taalseleksje, it gebrûk fan blokken, en guon saken lykas in projekt opslaan, lade en ynlade. Wy sammelje GJIN persoanlike ynformaasje. Besjoch ek ús {privacyPolicyLink} foar mear ynformaasje.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacybelied",
    "gui.telemetryOptIn.optInText": "Diel myn gebrûkgegevens mei it Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Telemetry ynskeakelje",
    "gui.telemetryOptIn.optOutText": "Diel myn gebrûkgegevens net mei it Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Telemetry útsette",
    "gui.telemetryOptIn.settingWasUpdated": "Jo ynstelling is bywurke.",
    "gui.telemetryOptIn.buttonClose": "Slute",
    "gui.turboMode.active": "Turbo Modus",
    "gui.webglModal.label": "Jo browser stipet WebGL net",
    "gui.webglModal.description": "Spitigernôch liket it derop dat jo browser of kompjûter {webGlLink}. Dy technology is nedich om Scratch 3.0 te brûken.",
    "gui.webglModal.webgllink": "stipet WebGL net",
    "gui.webglModal.back": "Werom",
    "gui.webglModal.previewfaq": "Om mear te witten te kommen, gean nei de {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Faak stelde fragen",
    "gui.costumeLibrary.chooseABackdrop": "Kies in eftergrûn",
    "gui.costumeLibrary.chooseACostume": "Kies in kostúm",
    "gui.costumeTab.addBackdropFromLibrary": "Kies in eftergrûn",
    "gui.costumeTab.addCostumeFromLibrary": "Kies in kostúm",
    "gui.costumeTab.addBlankCostume": "Leech kostúm",
    "gui.costumeTab.addSurpriseCostume": "Ferrassing",
    "gui.costumeTab.addFileBackdrop": "Eftergrûn ynlade",
    "gui.costumeTab.addFileCostume": "Kostúm ynlade",
    "gui.extensionLibrary.chooseAnExtension": "Kies in ekstinsje",
    "gui.extensionLibrary.extensionUrl": "Fier de URL fan de ekstinsje yn",
    "gui.monitors.importListColumnPrompt": "Hokker kolom moat brûkt wurde (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Koe de opname net begjinne",
    "gui.soundLibrary.chooseASound": "Kies in lûd",
    "gui.soundTab.fileUploadSound": "Lûd ynlade",
    "gui.soundTab.surpriseSound": "Ferrassing",
    "gui.soundTab.recordSound": "Opnimme",
    "gui.soundTab.addSoundFromLibrary": "Kies in Lûd",
    "gui.spriteLibrary.chooseASprite": "Kies in Sprite",
    "gui.tipsLibrary.tutorials": "Kies in Tutorial",
    "gui.alerts.createsuccess": "Nij projekt makke.",
    "gui.alerts.createcopysuccess": "Projekt bewarre as kopy.",
    "gui.alerts.createremixsuccess": "Projekt bewarre as mjuks.",
    "gui.alerts.creating": "Nij oanmeitsje ...",
    "gui.alerts.creatingCopy": "Projekt kopiearje...",
    "gui.alerts.creatingRemix": "Projekt mikse...",
    "gui.alerts.creatingError": "Koe it projekt net oanmeitsje. Besykje it nochris!",
    "gui.alerts.savingError": "Koe it projekt net bewarje.",
    "gui.alerts.savesuccess": "Projekt bewarre.",
    "gui.alerts.saving": "Projekt bewarje...",
    "gui.alerts.cloudInfo": "Tink derom, wolkefariabelen stypje allinich getallen, gjin letters of symboalen. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Kom mear te witten.",
    "gui.alerts.importing": "Ymportearje...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "myn fariabele",
    "gui.howtos.intro-move-sayhello-hat.name": "Begjinne",
    "gui.howtos.intro-move.step_stepMove": "Foegje in ferpleatsblok ta",
    "gui.howtos.add-a-move-block.step_stepSay": "Foegje in sisblok ta",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klikje op de griene flagge om te begjinnen",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animearje in namme",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Kies in Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spylje in Lûd as Klikt wurdt",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Kies noch in Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Feroarje kleur",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Kies noch in Letter Sprite & Lit him draaie",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Kies noch in Letter Sprite & Lit him groeie",
    "gui.howtos.imagine": "Stel jo in wrâld foar",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Typ wat jo sizze wolle",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klikje op it Griene Flagchje om te begjinnen",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Kies in eftergrûn",
    "gui.howtos.imagine.step_imagineChooseSprite": "Kies in Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Druk op spaasje om te glydzjen",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Kies noch in Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Nei links of rjochts ferpleatse",
    "gui.howtos.imagine.step_imagineUpDown": "Op en del ferpleatse",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Kostúms feroarje",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Nei in punt ta glydzje",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grutter en lytser meitsje",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Kies in oare eftergrûn",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Wikselje eftergrûnen",
    "gui.howtos.imagine.step_imagineRecordASound": "Foegje in lûd ta",
    "gui.howtos.imagine.step_imagineChooseSound": "Kies jo lûd",
    "gui.howtos.make-music.name": "Meitsje muzyk",
    "gui.howtos.Make-Music.step_PickInstrument": "Kies in ynstrumint-Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spylje lûd as klikt wurdt",
    "gui.howtos.Make-Music.step_MakeSong": "Meitsje in ferske",
    "gui.howtos.make-music.step_MakeBeat": "Kies in trommel & meitsje in beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Kies de microfoan-Sprite & Surprise Beatbox",
    "gui.howtos.story.name": "Meitsje in ferhaal",
    "gui.howtos.story.step_addbg": "Foegje in eftergrûn ta",
    "gui.howtos.story.step_addsprite": "Foegje in karakter ta",
    "gui.howtos.story.step_saysomething": "Sis wat",
    "gui.howtos.story.step_addanothersprite": "Foegje noch in karakter ta",
    "gui.howtos.story.step_flip": "Omkearrjochting",
    "gui.howtos.story.step_conversation": "Hâldt in petear",
    "gui.howtos.story.addanotherbg": "Foegje noch in eftergrûn ta",
    "gui.howtos.story.step_swithbg": "Wikselje fan eftergrûn",
    "gui.howtos.story.step_hidewizard": "Ferstopje in karakter",
    "gui.howtos.story.step_showwizard": "Lit in karakter sjen",
    "gui.howtos.make-a-chase-game.name": "Meitsje in jeispultsje",
    "gui.howtos.Chase-Game.step_BG": "Foegje in eftergrûn ta",
    "gui.howtos.chase-game.step_AddOcto": "Foegje in Sprite ta",
    "gui.howtos.make-music.step_LeftRight": "Ferpleats nei rjochts en links mei de pylkjestoetsen",
    "gui.howtos.Chase-Game.step_UpDown": "Gean op & del mei de pylkjestoetsen",
    "gui.howtos.Chase-Game.step_AddStar": "Foegje noch in Sprite ta",
    "gui.howtos.Chase-Game.step_MoveRandom": "Willekeurich beweegje",
    "gui.howtos.Chase-Game.step_WhenTouch": "Yn oktopus-Sprite, by oanreitsjen lûd ôfspylje",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Meitsje skoarefariabele",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Yn oktopus-Sprite, by oanreitsjen skoare tafoegje",
    "gui.howtos.animate-char.name": "In karakter animearje",
    "gui.howtos.animate-char.step_addbg": "Foegje in eftergrûn ta",
    "gui.howtos.animate-char.step_addsprite": "Foegje in Sprite ta",
    "gui.howtos.animate-char.step_saysomething": "Sis wat",
    "gui.howtos.animate-char.step_addsound": "Lûd tafoegje",
    "gui.howtos.animate-char.step_animatetalking": "Prate animearje",
    "gui.howtos.animate-char.step_arrowkeys": "Ferpleatse mei de pylkjestoetsen",
    "gui.howtos.animate-char.step_jump": "Springe",
    "gui.howtos.animate-char.step_changecolor": "Kleur feroarje",
    "gui.howtos.make-a-game.name": "Meitsje in klikspultsje",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Kies in Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spylje lûd as klikt wurdt",
    "gui.howtos.make-a-game.step_GameAddScore": "Meitsje skoarefariabele",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ferheegje skoare as klikt wurdt",
    "gui.howtos.make-a-game.step_Random": "Gean nei in willekeurige posysje",
    "gui.howtos.make-music.step_GameChangeColor": "Kleur feroarje",
    "gui.howtos.make-music.step_ResetScore": "Skoare weromsette",
    "gui.howtos.make-it-fly.name": "Lit it fleane",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Kies in eftergrûn mei de loft",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Kies in karakter",
    "gui.howtos.fly.step_stepflySaySomething": "Sis wat",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mei de pylkjestoetsen ferpleatse",
    "gui.howtos.fly.step_stepflyChooseObject": "Kies in objekt om te sammeljen",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Lit it objekt ferpleatse",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Selektearje jo karakter",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Foegje in skoare ta",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Skoare byhâlde",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Dekôr tafoegje",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Ferpleats it Dekôr",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Folgjende kostúm",
    "gui.howtos.pong": "Pongspultsje",
    "gui.howtos.pong.step_pongAddBackdrop": "Foegje in eftergrûn ta",
    "gui.howtos.pong.step_pongAddBallSprite": "Foegje in bal-Sprite ta",
    "gui.howtos.pong.step_pongBounceAround": "Omstuiterje",
    "gui.howtos.pong.step_pongAddPaddle": "Foegje in batsje ta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Ferpleats it batsje",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selektearje de bal-Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Koade tafoegje om de bal fan it batsje stuiterje te litten",
    "gui.howtos.pong.step_pongAddAScore": "Foegje in skoare ta",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Kies 'Skoare' yn it menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Foegje it blok 'Skoare wizigje' yn",
    "gui.howtos.pong.step_pongResetScore": "Skoare weromsette",
    "gui.howtos.pong.step_pongAddLineSprite": "Foegje de line-Sprite ta",
    "gui.howtos.pong.step_pongGameOver": "Spultsje oer",
    "gui.howtos.code-cartoon": "Programmearje in Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sis wat as jo op de griene flagge klikke",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animearje in karakter as jo derop klikke",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selektearje in oar karakter",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Brûk in minteken om lytser te wurden",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Lit in karakter grutter en lytser wurde",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selektearje in oar karakter",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Spring op en del",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klik op in karakter om sênes te feroarjen",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Omglydzje",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Kostúms feroarje",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Kies mear tekens om oan jo Cartoon ta te foegjen",
    "gui.howtos.cartoon-network": "Animearje in aventuerspultsje",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kies in karakter om sjen te litten",
    "gui.howtos.cartoon-network.step_CNsay": "Sis wat",
    "gui.howtos.cartoon-network.step_CNglide": "Omglydzje",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kies in objekt om op te jeien",
    "gui.howtos.cartoon-network.step_CNcollect": "Objekten sammelje",
    "gui.howtos.cartoon-network.step_CNvariable": "Meitsje in skoarefariabele",
    "gui.howtos.cartoon-network.step_CNscore": "Skoare byhâlde",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Nivo omheech: Feroarje eftergrûn",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Ekstinsje tafoegje",
    "gui.howtos.videosens.step_pet": "Aai de kat",
    "gui.howtos.videosens.step_animate": "Animearje",
    "gui.howtos.videosens.step_pop": "Prik in ballon lek",
    "gui.howtos.say-it-out-loud": "Meitsje animaasjes dy't prate",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Foegje de tekst ta oan spraakblokken",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sis wat",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Stel in stim yn",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Beweegje",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Foegje in eftergrûn ta",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Foegje noch in karakter ta",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Sjong of spylje in ferske",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Feroarje de kleur",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Rûntsjes draaie",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grutter en lytser wurde",
    "gui.howtos.talking": "Pratende Ferhalen",
    "gui.howtos.talking.step_talesAddExtension": "Klikje om de tekst-nei-spraakblokken ta te foegjen",
    "gui.howtos.talking.step_talesChooseSprite": "Kies in Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Lit in karakter prate",
    "gui.howtos.talking.step_talesChooseBackdrop": "Kies in eftergrûn",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klik op in karakter om nei de folgjende eftergrûn te gean",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Kies noch in sprite",
    "gui.howtos.talking.step_talesMoveAround": "Beweegje",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Kies noch in eftergrûn",
    "gui.howtos.talking.step_talesAnimateTalking": "Prate animearje",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Kies in oare eftergrûn",
    "gui.howtos.talking.step_talesChooseSound": "Kies in ferske om op te dûnsjen",
    "gui.howtos.talking.step_talesDanceMoves": "Dûnsbewegingen",
    "gui.howtos.talking.step_talesAskAnswer": "Krij de fraach- en antwurdblokken út de Sensing-kategory",
    "gui.howtos.add-sprite.name": "Foegje in Sprite ta",
    "gui.howtos.add-sprite.step_addSprite": "Foegje in Sprite ta",
    "gui.howtos.add-a-backdrop.name": "Foegje in eftergrûn ta",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Foegje in eftergrûn ta",
    "gui.howtos.change-size.name": "Grutte feroarje",
    "gui.howtos.change-size.step_changeSize": "Grutte feroarje",
    "gui.howtos.glide-around.name": "Omglydzje",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Omglydzje",
    "gui.howtos.change-size.step_glideAroundPoint": "Glydzje nei in punt ta",
    "gui.howtos.record-a-sound.name": "Nim in lûd op",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klik op it tabblêd 'Lûden'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikje op 'Opnimme'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Druk op de Opnimknop",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Kies jo lûd",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spylje jo lûd",
    "gui.howtos.spin-video.name": "Lit it draaie",
    "gui.howtos.change-size.step_spinTurn": "Draaie",
    "gui.howtos.change-size.step_spinPointInDirection": "Rjochting ynstelle",
    "gui.howtos.hide-and-show.name": "Ferstopje en sjen litte",
    "gui.howtos.change-size.step_hideAndShow": "Ferstopje en sjen litte",
    "gui.howtos.switch-costume.name": "Animearje in sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animearje in sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Brûk de pylkjestoetsen",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Nei links en rjochts ferpleatse",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Op en del ferpleatse",
    "gui.howtos.add-effects.name": "Effekten tafoegje",
    "gui.howtos.videosens.step_addEffects": "Effekten tafoegje",
    "gui.extension.music.name": "Muzyk",
    "gui.extension.music.description": "Spylje ynstruminten en trommels.",
    "gui.extension.pen.name": "Pinne",
    "gui.extension.pen.description": "Tekenje mei jo Sprites.",
    "gui.extension.videosensing.name": "Video Sensing",
    "gui.extension.videosensing.description": "Fernim beweging mei de kamera.",
    "gui.extension.text2speech.name": "Tekst nei spraak",
    "gui.extension.text2speech.description": "Lit jo projekten prate.",
    "gui.extension.translate.name": "Oersette",
    "gui.extension.translate.description": "Tekst oersette nei in protte talen.",
    "gui.extension.makeymakey.description": "Meitsje fan alles in kaai.",
    "gui.extension.microbit.description": "Ferbyn jo projekten mei de wrâld.",
    "gui.extension.microbit.connectingMessage": "Ferbine",
    "gui.extension.ev3.description": "Bou ynteraktive robots en mear.",
    "gui.extension.ev3.connectingMessage": "Ferbine. Soargje derfoar dat de pin op jo EV3 op 1234 is ynsteld.",
    "gui.extension.boost.description": "Bring robotkreaasjes ta libben.",
    "gui.extension.boost.connectingMessage": "Ferbine",
    "gui.extension.wedo2.description": "Bouwe mei motors en sensoaren.",
    "gui.extension.wedo2.connectingMessage": "Ferbine",
    "gui.extension.gdxfor.description": "Fernim triuwe, lûke, beweging en draaie.",
    "gui.extension.gdxfor.connectingMessage": "Ferbine",
    "gui.libraryTags.all": "Alle",
    "gui.libraryTags.animals": "Bisten",
    "gui.libraryTags.dance": "Dûnsje",
    "gui.libraryTags.effects": "Effekten",
    "gui.libraryTags.fantasy": "Fantasij",
    "gui.libraryTags.fashion": "Moade",
    "gui.libraryTags.food": "Iten",
    "gui.libraryTags.indoors": "Binnen",
    "gui.libraryTags.loops": "Lussen",
    "gui.libraryTags.music": "Muzyk",
    "gui.libraryTags.notes": "Oantekeningen",
    "gui.libraryTags.outdoors": "Bûten",
    "gui.libraryTags.patterns": "Patroanen",
    "gui.libraryTags.people": "Minsken",
    "gui.libraryTags.percussion": "Slachwurk",
    "gui.libraryTags.space": "Romte",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Under wetter",
    "gui.libraryTags.voice": "Stim",
    "gui.libraryTags.wacky": "Gek",
    "gui.libraryTags.animation": "Animaasje",
    "gui.libraryTags.art": "Keunst",
    "gui.libraryTags.games": "Spultsjes",
    "gui.libraryTags.stories": "Ferhalen",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "rjochting",
    "gui.opcodeLabels.xposition": "posysje fan x",
    "gui.opcodeLabels.yposition": "posysje fan y",
    "gui.opcodeLabels.size": "grutte",
    "gui.opcodeLabels.costumename": "namme fan kostúm",
    "gui.opcodeLabels.costumenumber": "kostúmnûmer",
    "gui.opcodeLabels.backdropname": "namme fan eftergrûn",
    "gui.opcodeLabels.backdropnumber": "eftergrûnnûmer",
    "gui.opcodeLabels.volume": "folume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "antwurd",
    "gui.opcodeLabels.loudness": "lûdens",
    "gui.opcodeLabels.username": "brûkersnamme",
    "gui.opcodeLabels.year": "jier",
    "gui.opcodeLabels.month": "moanne",
    "gui.opcodeLabels.date": "datum",
    "gui.opcodeLabels.dayofweek": "dei fan 'e wike",
    "gui.opcodeLabels.hour": "oere",
    "gui.opcodeLabels.minute": "minút",
    "gui.opcodeLabels.second": "sekonde",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "It selektearre projektbestân koe net laden wurde.",
    "gui.sharedMessages.backdrop": "eftergrûn{index}",
    "gui.sharedMessages.costume": "kostúm{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Ynhâld ferfange fan dit projekt?",
    "gui.sharedMessages.loadFromComputerTitle": "Ynlade fan jo kompjûter ôf",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratchprojekt",
    "boost.color.any": "elke kleur",
    "boost.color.black": "swart",
    "boost.color.blue": "blau",
    "boost.color.green": "grien",
    "boost.color.red": "read",
    "boost.color.white": "wyt",
    "boost.color.yellow": "giel",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] posysje",
    "boost.getTiltAngle": "kantelhoek [TILT_DIRECTION]",
    "boost.motorDirection.backward": "op dy manier",
    "boost.motorDirection.forward": "dizze manier",
    "boost.motorDirection.reverse": "omkeare",
    "boost.motorOff": "set motor [MOTOR_ID] út",
    "boost.motorOn": "set motor [MOTOR_ID] oan",
    "boost.motorOnFor": "lit motor [MOTOR_ID] [DURATION] sekonden draaie",
    "boost.motorOnForRotation": "lit motor [MOTOR_ID] [ROTATION] rûntsjes draaie",
    "boost.seeingColor": "is it [COLOR] stientsje te sjen?",
    "boost.setLightHue": "stel de kleur fan it ljocht yn op [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] yn de rjochting [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] op [POWER]% snelheid",
    "boost.tiltDirection.any": "elk",
    "boost.tiltDirection.down": "nei ûnder",
    "boost.tiltDirection.left": "links",
    "boost.tiltDirection.right": "rjochts",
    "boost.tiltDirection.up": "omheech",
    "boost.whenColor": "as it [COLOR] stientsje te sjen is",
    "boost.whenTilted": "as kantele [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "lit [NOTE] [TIME] sekonden hearre",
    "ev3.buttonPressed": "knop [PORT] yndrukt?",
    "ev3.getBrightness": "helderheid",
    "ev3.getDistance": "ôfstân",
    "ev3.getMotorPosition": "motor [PORT] posysje",
    "ev3.motorSetPower": "stel motor [PORT] yn op [POWER]% krêft",
    "ev3.motorTurnClockwise": "draai motor [PORT] dizze kant út foar [TIME] sekonden",
    "ev3.motorTurnCounterClockwise": "draai motor [PORT] dy kant út foar [TIME] sekonden",
    "ev3.whenBrightnessLessThan": "as helderheid <[DISTANCE]",
    "ev3.whenButtonPressed": "as knop [PORT] yndrukt wurdt",
    "ev3.whenDistanceLessThan": "wannear't ôfstân <[DISTANCE]",
    "gdxfor.getAcceleration": "fersnelling [DIRECTION]",
    "gdxfor.getForce": "krêft",
    "gdxfor.getSpin": "draaisnelheid [DIRECTION]",
    "gdxfor.getTilt": "kantelhoeke [TILT]",
    "gdxfor.isFreeFalling": "falt?",
    "gdxfor.isTilted": "kantele [TILT]?",
    "gdxfor.pulled": "lutsen",
    "gdxfor.pushed": "treaun",
    "gdxfor.shaken": "skodde",
    "gdxfor.startedFalling": "begûn te fallen",
    "gdxfor.tiltDirectionMenu.any": "elk",
    "gdxfor.tiltDirectionMenu.back": "efterút",
    "gdxfor.tiltDirectionMenu.front": "foarkant",
    "gdxfor.tiltDirectionMenu.left": "links",
    "gdxfor.tiltDirectionMenu.right": "rjochts",
    "gdxfor.turnedFaceDown": "nei ûnder rjochte",
    "gdxfor.turnedFaceUp": "nei boppe rjochte",
    "gdxfor.whenForcePushedOrPulled": "as krêftsensor [PUSH_PULL]",
    "gdxfor.whenGesture": "as [GESTURE]",
    "gdxfor.whenTilted": "as kantele [TILT]",
    "makeymakey.downArrow": "pylkje nei ûnder",
    "makeymakey.downArrowShort": "nei ûnder",
    "makeymakey.leftArrow": "pylje nei links",
    "makeymakey.leftArrowShort": "links",
    "makeymakey.rightArrow": "pylkje nei rjochts",
    "makeymakey.rightArrowShort": "rjochts",
    "makeymakey.spaceKey": "spaasje",
    "makeymakey.upArrow": " pylkje omheech",
    "makeymakey.upArrowShort": "omheech",
    "makeymakey.whenKeyPressed": "as [KEY] toets yndrukt wurdt",
    "makeymakey.whenKeysPressedInOrder": "as [SEQUENCE] yn folchoarder yndrukt wurdt",
    "microbit.buttonsMenu.any": "elk",
    "microbit.clearDisplay": "Skerm skjinmeitsje",
    "microbit.defaultTextToDisplay": "Hoi!",
    "microbit.displaySymbol": "skerm [MATRIX]",
    "microbit.displayText": "skerm tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "sprong",
    "microbit.gesturesMenu.moved": "bewege",
    "microbit.gesturesMenu.shaken": "skodde",
    "microbit.isButtonPressed": "[BTN] knop yndrukt?",
    "microbit.isTilted": "kantele [DIRECTION]?",
    "microbit.pinStateMenu.off": "út",
    "microbit.pinStateMenu.on": "op",
    "microbit.tiltAngle": "kantelhoek [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "elk",
    "microbit.tiltDirectionMenu.back": "nei achter",
    "microbit.tiltDirectionMenu.front": "nei foaren",
    "microbit.tiltDirectionMenu.left": "nei links",
    "microbit.tiltDirectionMenu.right": "nei rjochts",
    "microbit.whenButtonPressed": "as [BTN] knop yndrukt wurdt",
    "microbit.whenGesture": "as [GESTURE]",
    "microbit.whenPinConnected": "as pin [PIN] ferbûn is",
    "microbit.whenTilted": "as kantele nei [DIRECTION]",
    "music.categoryName": "Muzyk",
    "music.changeTempo": "tempo feroarje mei [TEMPO]",
    "music.drumBass": "(2) Bass Drum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Klaves",
    "music.drumClosedHiHat": "(6) Sletten Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Bekken",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Hânklap",
    "music.drumOpenHiHat": "(5) Iepen Hi-Hat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snaartrom",
    "music.drumTambourine": "(7) Tamboeryn",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Houtblok",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Tsjello",
    "music.instrumentChoir": "(15) Koar",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Elektryske Gitaar",
    "music.instrumentElectricPiano": "(2) Elektryske Piano",
    "music.instrumentFlute": "(12) Fluit",
    "music.instrumentGuitar": "(4) Gitaar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Muzykdoaze",
    "music.instrumentOrgan": "(3) Oargel",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofoan",
    "music.instrumentSteelDrum": "(18) Stieltrommel",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Tromboane",
    "music.instrumentVibraphone": "(16) Vibrafoan",
    "music.instrumentWoodenFlute": "(13) Houten fluit",
    "music.midiPlayDrumForBeats": "spylje trommel [DRUM] foar [BEATS] beats",
    "music.midiSetInstrument": "ynstrumint ynstelle op [INSTRUMENT]",
    "music.playDrumForBeats": "spylje trommel [DRUM] foar [BEATS] beats",
    "music.playNoteForBeats": "play noat [NOTE] foar [BEATS] beats",
    "music.restForBeats": "rêst foar [BEATS] beats",
    "music.setInstrument": "ynstrumint ynstelle op [INSTRUMENT]",
    "music.setTempo": "set tempo yn op [TEMPO]",
    "pen.categoryName": "Pinne",
    "pen.changeColorParam": "feroarje pinne [COLOR_PARAM] troch [VALUE]",
    "pen.changeHue": "feroarje pennekleur troch [HUE]",
    "pen.changeShade": "feroarje penskerm troch [SHADE]",
    "pen.changeSize": "pennegrutte feroarje mei [SIZE]",
    "pen.clear": "wiskje alles",
    "pen.colorMenu.brightness": "helderheid",
    "pen.colorMenu.color": "kleur",
    "pen.colorMenu.saturation": "sêding",
    "pen.colorMenu.transparency": "transparânsje",
    "pen.penDown": "pen omleech",
    "pen.penUp": "pen omheech",
    "pen.setColor": "set pennekleur yn op [COLOR]",
    "pen.setColorParam": "set pinne [COLOR_PARAM] yn op [VALUE]",
    "pen.setHue": "set pennekleur yn op [HUE]",
    "pen.setShade": "set penskerm op [SHADE]",
    "pen.setSize": "set pennegrutte yn op [SIZE]",
    "pen.stamp": "stimpel",
    "speech.defaultWhenIHearValue": "litte wy gean",
    "speech.extensionName": "Spraak nei tekst",
    "speech.listenAndWait": "harkje en wachtsje",
    "speech.speechReporter": "speech",
    "speech.whenIHear": "as ik [PHRASE] hear",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Tekst nei spraak",
    "text2speech.defaultTextToSpeak": "Hoi",
    "text2speech.giant": "reus",
    "text2speech.kitten": "kitten",
    "text2speech.setLanguageBlock": "set taal yn op [LANGUAGE]",
    "text2speech.setVoiceBlock": "set stim op [VOICE]",
    "text2speech.speakAndWaitBlock": "sprekke [WORDS]",
    "text2speech.squeak": "piipje",
    "text2speech.tenor": "tenoar",
    "translate.categoryName": "Oersette",
    "translate.defaultTextToTranslate": "Hoi",
    "translate.translateBlock": "oersette [WORDS] nei [LANGUAGE]",
    "translate.viewerLanguage": "taal",
    "videoSensing.categoryName": "Fideo Fiele",
    "videoSensing.direction": "rjochting",
    "videoSensing.motion": "moasje",
    "videoSensing.off": "út",
    "videoSensing.on": "op",
    "videoSensing.onFlipped": "op omdraaid",
    "videoSensing.setVideoTransparency": "set fideotransparânsje yn op [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "poadium",
    "videoSensing.videoOn": "fideo [ATTRIBUTE] op [SUBJECT]",
    "videoSensing.videoToggle": "keare fideo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "wannear fideobeweging> [REFERENCE]",
    "wedo2.getDistance": "ôfstân",
    "wedo2.getTiltAngle": "kantelhoek [TILT_DIRECTION]",
    "wedo2.isTilted": "kantele [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "op dy manier",
    "wedo2.motorDirection.forward": "dizze manier",
    "wedo2.motorDirection.reverse": "omkeare",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "set [MOTOR_ID] út",
    "wedo2.motorOn": "skeakelje [MOTOR_ID] yn",
    "wedo2.motorOnFor": "skeakelje [MOTOR_ID] [DURATION] sekonden yn",
    "wedo2.playNoteFor": "spylje noat [NOTE] foar [DURATION] sekonden",
    "wedo2.setLightHue": "set ljochtkleur yn op [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] rjochting yn op [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] macht yn op [POWER]",
    "wedo2.tiltDirection.any": "elk",
    "wedo2.tiltDirection.down": "omleech",
    "wedo2.tiltDirection.left": "links",
    "wedo2.tiltDirection.right": "rjochts",
    "wedo2.tiltDirection.up": "op",
    "wedo2.whenDistance": "wannear ôfstân [OP] [REFERENCE]",
    "wedo2.whenTilted": "as kantele [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kleur",
    "paint.paintEditor.saturation": "Sêding",
    "paint.paintEditor.brightness": "Helderheid",
    "paint.paintEditor.costume": "Kostúm",
    "paint.paintEditor.group": "Groep",
    "paint.paintEditor.ungroup": "Ut groep helje",
    "paint.paintEditor.undo": "Ungedien meitsje",
    "paint.paintEditor.redo": "Op 'e nij dwaan",
    "paint.paintEditor.forward": "Foarút",
    "paint.paintEditor.backward": "Efterút",
    "paint.paintEditor.front": "Foarkant",
    "paint.paintEditor.back": "Werom",
    "paint.paintEditor.more": "Mear",
    "paint.modeTools.brushSize": "Grutte",
    "paint.modeTools.eraserSize": "Gumgrutte",
    "paint.modeTools.copy": "Kopiearje",
    "paint.modeTools.paste": "Plakke",
    "paint.modeTools.delete": "Fuorthelje",
    "paint.modeTools.curved": "Bûgd",
    "paint.modeTools.pointed": "Oanwiisd",
    "paint.modeTools.thickness": "Dikte",
    "paint.modeTools.flipHorizontal": "Horizontaal omdraaie",
    "paint.modeTools.flipVertical": "Fertikaal omdraaie",
    "paint.modeTools.filled": "Folle",
    "paint.modeTools.outlined": "Bûtenste râne",
    "paint.paintEditor.bitmap": "Omsette nei Bitmap",
    "paint.paintEditor.vector": "Omsette nei Fektor",
    "paint.paintEditor.fill": "Folje",
    "paint.paintEditor.stroke": "Râne",
    "paint.brushMode.brush": "Kwast",
    "paint.eraserMode.eraser": "Gum",
    "paint.fillMode.fill": "Folje",
    "paint.lineMode.line": "Rigel",
    "paint.ovalMode.oval": "Sirkel",
    "paint.rectMode.rect": "Rjochthoek",
    "paint.reshapeMode.reshape": "Foarm feroarje",
    "paint.roundedRectMode.roundedRect": "Rjochthoek mei rûne hoeken",
    "paint.selectMode.select": "Selektearje",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Ruilje"
  },
  "ga": {
    "gui.alerts.lostPeripheralConnection": "Chaill Scratch an ceangal le {extensionName}.",
    "gui.alerts.tryAgain": "Bain Triail Eile As",
    "gui.alerts.download": "Íoslódáil",
    "gui.connection.reconnect": "Athcheangail",
    "gui.backpack.costumeLabel": "culaith",
    "gui.backpack.soundLabel": "fuaim",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprid",
    "gui.backpack.header": "Mála Droma",
    "gui.backpack.errorBackpack": "Earráid agus an mála droma á lódáil",
    "gui.backpack.loadingBackpack": "Á Lódáil...",
    "gui.backpack.more": "Tuilleadh",
    "gui.backpack.emptyBackpack": "Tá an mála droma folamh",
    "gui.unsupportedBrowser.label": "Ní thacaímid leis an mbrabhsálaí seo",
    "gui.unsupportedBrowser.errorLabel": "Tharla Earráid",
    "gui.unsupportedBrowser.notRecommended": "Ár leithscéal, ach dealraíonn sé go bhfuil tú ag úsáid brabhsálaí nach dtacaíonn Scratch leis. Molaimid duit an leagan is déanaí de bhrabhsálaí tacaithe a shuiteáil, mar shampla Google Chrome, Mozilla Firefox, Microsoft Edge, nó Apple Safari.",
    "gui.unsupportedBrowser.description": "Ár leithscéal, ach ní thacaíonn Scratch leis an mbrabhsálaí seo. Molaimid duit an leagan is déanaí de bhrabhsálaí tacaithe a shuiteáil, mar shampla Google Chrome, Mozilla Firefox, Microsoft Edge, nó Apple Safari.",
    "gui.unsupportedBrowser.back": "Ar ais",
    "gui.unsupportedBrowser.previewfaq": "Féach ar {previewFaqLink} le tuilleadh eolais a fháil.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Ceisteanna Coitianta",
    "gui.cards.all-tutorials": "Cúrsaí Teagaisc",
    "gui.cards.shrink": "Laghdaigh",
    "gui.cards.expand": "Leathnaigh",
    "gui.cards.close": "Dún",
    "gui.cards.more-things-to-try": "Tuilleadh rudaí le triail a bhaint astu!",
    "gui.cards.see-more": "Tuilleadh",
    "gui.comingSoon.message1": "Ná buair do cheann, táimid ag plé leis {emoji}",
    "gui.comingSoon.message2": "Le teacht go luath...",
    "gui.comingSoon.message3": "Táimid ag plé leis {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Níor aimsíodh aon ghléas",
    "gui.connection.auto-scanning.prescan": "Coinnigh do ghléas in aice láimhe, ansin déan cuardach.",
    "gui.connection.auto-scanning.pressbutton": "Brúigh an cnaipe ar do ghléas.",
    "gui.connection.auto-scanning.start-search": "Déan Cuardach",
    "gui.connection.connecting-searchbutton": "Cuardach ar siúl...",
    "gui.connection.auto-scanning.try-again": "Bain triail eile as",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ceangailte",
    "gui.connection.disconnect": "Dícheangail",
    "gui.connection.go-to-editor": "Fill ar an Eagarthóir",
    "gui.connection.connecting-cancelbutton": "Ag ceangal...",
    "gui.connection.error.errorMessage": "Úps, dealraíonn sé go ndeachaigh rud éigin in abar.",
    "gui.connection.error.tryagainbutton": "Bain triail eile as",
    "gui.connection.error.helpbutton": "Cabhair",
    "gui.connection.peripheral-name-label": "Ainm an ghléis",
    "gui.connection.connect": "Ceangail",
    "gui.connection.scanning.lookingforperipherals": "Ag lorg gléasanna",
    "gui.connection.scanning.noPeripheralsFound": "Níor aimsíodh aon ghléas",
    "gui.connection.scanning.instructions": "Roghnaigh do ghléas sa liosta thuas.",
    "gui.connection.search": "Athnuaigh",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Deimhnigh gur shuiteáil tú Scratch Link agus go bhfuil sé ar siúl",
    "gui.connection.unavailable.enablebluetooth": "Deimhnigh go bhfuil Bluetooth cumasaithe",
    "gui.connection.unavailable.tryagainbutton": "Bain triail eile as",
    "gui.connection.unavailable.helpbutton": "Cabhair",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Tosaigh",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Úps! Tharla earráid.",
    "gui.crashMessage.description": "Ár leithscéal, ach tá Scratch tar éis tuairteála de réir cosúlachta. Seoladh na mionsonraí chuig Foireann Scratch go huathoibríoch. Athlódáil an leathanach agus bain triail eile as.",
    "gui.crashMessage.errorNumber": "Scríobhadh an earráid seo sa logchomhad le ID {errorId}",
    "gui.crashMessage.reload": "Athlódáil",
    "gui.customProcedures.myblockModalTitle": "Cruthaigh Bloc",
    "gui.customProcedures.addAnInputNumberText": "Cuir réimse ionchurtha leis",
    "gui.customProcedures.numberTextType": "uimhir nó téacs",
    "gui.customProcedures.addAnInputBoolean": "Cuir réimse ionchurtha leis",
    "gui.customProcedures.booleanType": "athróg Boole",
    "gui.customProcedures.addALabel": "Cuir lipéad leis",
    "gui.customProcedures.runWithoutScreenRefresh": "Rith gan an scáileán a athnuachan",
    "gui.customProcedures.cancel": "Cealaigh",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Treo",
    "gui.directionPicker.rotationStyles.allAround": "Timpeall ar fad",
    "gui.directionPicker.rotationStyles.leftRight": "Clé/Deas",
    "gui.directionPicker.rotationStyles.dontRotate": "Ná rothlaigh",
    "gui.gui.addExtension": "Cuir Breiseán Leis",
    "gui.gui.codeTab": "Cód",
    "gui.gui.backdropsTab": "Cúlraí",
    "gui.gui.costumesTab": "Cultacha",
    "gui.gui.soundsTab": "Fuaimeanna",
    "gui.extensionLibrary.comingSoon": "Le teacht go luath",
    "gui.extensionLibrary.requires": "Riachtanais",
    "gui.extensionLibrary.collaboration": "I gcomhar le",
    "gui.library.filterPlaceholder": "Cuardaigh",
    "gui.library.allTag": "Uile",
    "gui.loader.message1": "Blocanna á gcruthú...",
    "gui.loader.message2": "Sprideanna á lódáil...",
    "gui.loader.message3": "Fuaimeanna á lódáil...",
    "gui.loader.message4": "Breiseáin á lódáil...",
    "gui.loader.message5": "Cait á gcluicheadh...",
    "gui.loader.message6": "Nanónna á dtarchur...",
    "gui.loader.message7": "Góbónna á séideadh...",
    "gui.loader.message8": "Emoji á n-ullmhú...",
    "gui.loader.headline": "Tionscadal á Lódáil",
    "gui.loader.creating": "Tionscadal a Chruthú",
    "gui.accountMenu.profile": "Próifíl",
    "gui.accountMenu.myStuff": "Mo Chuid Stuif",
    "gui.accountMenu.myClasses": "Mo Ranganna",
    "gui.accountMenu.myClass": "Mo Rang",
    "gui.accountMenu.accountSettings": "Socruithe an chuntais",
    "gui.accountMenu.signOut": "Logáil amach",
    "gui.authorInfo.byUser": "le {username}",
    "gui.menuBar.seeProjectPage": "Leathanach an Tionscadail",
    "gui.menuBar.language": "Language",
    "general.username": "Ainm úsáideora",
    "general.password": "Focal Faire",
    "general.signIn": "Logáil isteach",
    "login.needHelp": "Cabhair uait?",
    "form.validationRequired": "Tá sé seo de dhíth",
    "gui.menuBar.tutorialsLibrary": "Cúrsaí Teagaisc",
    "gui.menuBar.restoreSprite": "Athchóirigh an Sprid",
    "gui.menuBar.restoreSound": "Athchóirigh an Fhuaim Scriosta",
    "gui.menuBar.restoreCostume": "Athchóirigh an Chulaith Scriosta",
    "gui.menuBar.restore": "Athchóirigh",
    "gui.menuBar.saveNow": "Sábháil anois",
    "gui.menuBar.saveAsCopy": "Sábháil mar chóip",
    "gui.menuBar.remix": "Athmheasc",
    "gui.menuBar.new": "Nua",
    "gui.menuBar.file": "Comhad",
    "gui.menuBar.downloadToComputer": "Sábháil ar do ríomhaire",
    "gui.menuBar.edit": "Eagar",
    "gui.menuBar.turboModeOff": "Múch an Mód Turbó",
    "gui.menuBar.turboModeOn": "Tosaigh an Mód Turbó",
    "gui.menuBar.modeMenu": "Mód",
    "gui.menuBar.normalMode": "Gnáthmhód",
    "gui.menuBar.caturdayMode": "Mód na gCatbhlocanna",
    "gui.menuBar.joinScratch": "Cláraigh le Scratch",
    "gui.menuBar.signIn": "Logáil isteach",
    "gui.gui.projectTitlePlaceholder": "Teideal an tionscadail anseo",
    "gui.menuBar.saveNowLink": "Sábháil Anois",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Comhroinnte",
    "gui.menuBar.share": "Comhroinn",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Cabhair",
    "gui.modal.back": "Ar ais",
    "gui.monitor.listMonitor.empty": "(folamh)",
    "gui.monitor.listMonitor.listLength": "fad {length}",
    "gui.monitor.contextMenu.default": "gnáth-asléamh",
    "gui.monitor.contextMenu.large": "asléamh mór",
    "gui.monitor.contextMenu.slider": "sleamhnán",
    "gui.monitor.contextMenu.sliderRange": "athraigh raon an tsleamhnáin",
    "gui.monitor.contextMenu.import": "iompórtáil",
    "gui.monitor.contextMenu.export": "easpórtáil",
    "gui.monitor.contextMenu.hide": "folaigh",
    "gui.playButton.play": "Seinn",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Na sprideanna go léir",
    "gui.gui.variableScopeOptionSpriteOnly": "An sprid seo amháin",
    "gui.gui.cloudVariableOption": "Néalathróg (sábháilte ar an bhfreastalaí)",
    "gui.gui.variablePromptAllSpritesMessage": "Beidh an athróg seo ar fáil do gach sprid.",
    "gui.gui.listPromptAllSpritesMessage": "Beidh an liosta seo ar fáil do gach sprid.",
    "gui.prompt.cancel": "Cealaigh",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Seinn",
    "gui.playbackStep.loadingMsg": "Á Lódáil...",
    "gui.playbackStep.saveMsg": "Sábháil",
    "gui.playbackStep.reRecordMsg": "Ataifead",
    "gui.recordModal.title": "Taifeadadh",
    "gui.recordingStep.beginRecord": "Cliceáil an cnaipe thíos chun an taifeadadh a thosú",
    "gui.recordingStep.permission": "{arrow}Tá do chead ag teastáil uainn chun an micreafón a úsáid",
    "gui.recordingStep.stop": "Stop ag taifeadadh",
    "gui.recordingStep.record": "Taifead",
    "gui.sliderModal.min": "Íosluach",
    "gui.sliderModal.max": "Uasluach",
    "gui.sliderModal.title": "Athraigh raon an tsleamhnáin",
    "gui.sliderPrompt.cancel": "Cealaigh",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Fuaim",
    "gui.soundEditor.play": "Seinn",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Cóipeáil",
    "gui.soundEditor.paste": "Greamaigh",
    "gui.soundEditor.copyToNew": "Cóipeáil mar fhuaim nua",
    "gui.soundEditor.delete": "Scrios",
    "gui.soundEditor.save": "Sábháil",
    "gui.soundEditor.undo": "Cealaigh",
    "gui.soundEditor.redo": "Athdhéan",
    "gui.soundEditor.faster": "Níos Sciobtha",
    "gui.soundEditor.slower": "Níos Moille",
    "gui.soundEditor.echo": "Macalla",
    "gui.soundEditor.robot": "Róbat",
    "gui.soundEditor.louder": "Níos Airde",
    "gui.soundEditor.softer": "Níos Ciúine",
    "gui.soundEditor.reverse": "Aisiompaigh",
    "gui.soundEditor.fadeOut": "Céimnigh amach",
    "gui.soundEditor.fadeIn": "Céimnigh isteach",
    "gui.soundEditor.mute": "Balbhaigh",
    "gui.SpriteInfo.spritePlaceholder": "Ainm",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprid",
    "gui.SpriteInfo.show": "Taispeáin",
    "gui.SpriteInfo.size": "Méid",
    "gui.spriteSelectorItem.contextMenuDuplicate": "cóip",
    "gui.spriteSelectorItem.contextMenuExport": "easpórtáil",
    "gui.spriteSelectorItem.contextMenuDelete": "scrios",
    "gui.spriteSelector.addSpriteFromLibrary": "Roghnaigh Sprid",
    "gui.spriteSelector.addSpriteFromPaint": "Péint",
    "gui.spriteSelector.addSpriteFromSurprise": "Randamach",
    "gui.spriteSelector.addSpriteFromFile": "Uaslódáil Sprid",
    "gui.stageHeader.stageSizeLarge": "Úsáid stáitse mór",
    "gui.stageHeader.stageSizeSmall": "Úsáid stáitse beag",
    "gui.stageHeader.stageSizeFull": "Mód lánscáileáin",
    "gui.stageHeader.stageSizeUnFull": "Scoir den lánscáileán",
    "gui.stageHeader.fullscreenControl": "Rialú Lánscáileáin",
    "gui.spriteSelector.addBackdropFromLibrary": "Roghnaigh Cúlra",
    "gui.stageSelector.addBackdropFromPaint": "Péint",
    "gui.stageSelector.addBackdropFromSurprise": "Randamach",
    "gui.stageSelector.addBackdropFromFile": "Uaslódáil Cúlra",
    "gui.stageSelector.stage": "Stáitse",
    "gui.stageSelector.backdrops": "Cúlraí",
    "gui.telemetryOptIn.label": "Roinn staitisticí linn chun Scratch a fheabhsú",
    "gui.telemetryOptIn.body1": "Bíonn Foireann Scratch ag lorg tuiscint níos fearr ar na bealaí a úsáidtear Scratch timpeall an domhain. Chun cabhrú leis seo, is féidir leat cead a thabhairt do Scratch faisnéis úsáide a sheoladh chuig Foireann Scratch go huathoibríoch.",
    "gui.telemetryOptIn.body2": "I measc na faisnéise a bhailímid: do rogha teanga, na blocanna a úsáideann tú, agus uaireanta a dhéanann tú sábháil, lódáil, nó uaslódáil ar thionscadal. NÍ BHAILÍMID aon sonraí pearsanta. Féach ar ár {privacyPolicyLink} chun tuilleadh eolais a fháil.",
    "gui.telemetryOptIn.privacyPolicyLink": "bPolasaí Príobháideachta",
    "gui.telemetryOptIn.optInText": "Comhroinn mo chuid sonraí úsáide le Foireann Scratch",
    "gui.telemetryOptIn.optInTooltip": "Cumasaigh teiliméadaracht",
    "gui.telemetryOptIn.optOutText": "Ná comhroinn mo chuid sonraí úsáide le Foireann Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Díchumasaigh teiliméadaracht",
    "gui.telemetryOptIn.settingWasUpdated": "Sábháladh do rogha.",
    "gui.telemetryOptIn.buttonClose": "Dún",
    "gui.turboMode.active": "Mód Turbó",
    "gui.webglModal.label": "Ní thacaíonn do bhrabhsálaí le WebGL",
    "gui.webglModal.description": "Faraor is cosúil {webGlLink}. Tá an teicneolaíocht seo ag teastáil le Scratch 3.0 a úsáid.",
    "gui.webglModal.webgllink": "nach dtacaíonn do bhrabhsálaí le WebGL",
    "gui.webglModal.back": "Siar",
    "gui.webglModal.previewfaq": "Féach ar {previewFaqLink} le tuilleadh eolais a fháil.",
    "gui.webglModal.previewfaqlinktext": "Ceisteanna Coitianta",
    "gui.costumeLibrary.chooseABackdrop": "Roghnaigh Cúlra",
    "gui.costumeLibrary.chooseACostume": "Roghnaigh Culaith",
    "gui.costumeTab.addBackdropFromLibrary": "Roghnaigh Cúlra",
    "gui.costumeTab.addCostumeFromLibrary": "Roghnaigh Culaith",
    "gui.costumeTab.addBlankCostume": "Péint",
    "gui.costumeTab.addSurpriseCostume": "Randamach",
    "gui.costumeTab.addFileBackdrop": "Uaslódáil Cúlra",
    "gui.costumeTab.addFileCostume": "Uaslódáil Culaith",
    "gui.extensionLibrary.chooseAnExtension": "Roghnaigh Breiseán",
    "gui.extensionLibrary.extensionUrl": "Cuir isteach URL an bhreiseáin",
    "gui.monitors.importListColumnPrompt": "An colún le húsáid (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Níorbh fhéidir taifead a thosú",
    "gui.soundLibrary.chooseASound": "Roghnaigh Fuaim",
    "gui.soundTab.fileUploadSound": "Uaslódáil Comhad Fuaime",
    "gui.soundTab.surpriseSound": "Randamach",
    "gui.soundTab.recordSound": "Taifead",
    "gui.soundTab.addSoundFromLibrary": "Roghnaigh Fuaim",
    "gui.spriteLibrary.chooseASprite": "Roghnaigh Sprid",
    "gui.tipsLibrary.tutorials": "Roghnaigh Cúrsa Teagaisc",
    "gui.alerts.createsuccess": "Cruthaíodh an tionscadal nua.",
    "gui.alerts.createcopysuccess": "Sábháladh cóip den tionscadal.",
    "gui.alerts.createremixsuccess": "Sábháladh leagan athmheasctha den tionscadal.",
    "gui.alerts.creating": "Tionscadal nua á chruthú...",
    "gui.alerts.creatingCopy": "An tionscadal á chóipeáil...",
    "gui.alerts.creatingRemix": "An tionscadal á athmheascadh...",
    "gui.alerts.creatingError": "Níorbh fhéidir an tionscadal a chruthú. Bain triail eile as!",
    "gui.alerts.savingError": "Níorbh fhéidir an tionscadal an shábháil.",
    "gui.alerts.savesuccess": "Sábháladh an tionscadal.",
    "gui.alerts.saving": "An tionscadal á shábháil...",
    "gui.alerts.cloudInfo": "Ní féidir leat litreacha nó siombailí a shábháil i néalathróga, uimhreacha amháin. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Tuilleadh eolais.",
    "gui.alerts.importing": "Á Iompórtáil...",
    "gui.defaultProject.meow": "Míáú",
    "gui.defaultProject.variable": "m'athróg",
    "gui.howtos.intro-move-sayhello-hat.name": "Tús Maith",
    "gui.howtos.intro-move.step_stepMove": "Bloc \"bog\" a chur leis",
    "gui.howtos.add-a-move-block.step_stepSay": "Cuir bloc “abair” leis",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Cliceáil an bhratach uaine le tosú",
    "gui.howtos.intro-getting-started-ASL.name": "Tús Maith — ASL",
    "gui.howtos.animate-a-name.name": "Beochan a chur le d'ainm",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Litir a roghnú",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Fuaim a chasadh nuair a chliceáiltear",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Litir eile a roghnú",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "An dath a athrú",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Litir eile a roghnú agus a chur ar casadh",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Litir eile a roghnú agus a chur ag fás",
    "gui.howtos.imagine": "Samhlaigh domhan nua",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Céard ba mhaith leat a rá?",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Cliceáil an bhratach uaine le tosú",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Roghnaigh aon chúlra",
    "gui.howtos.imagine.step_imagineChooseSprite": "Roghnaigh aon sprid",
    "gui.howtos.imagine.step_imagineFlyAround": "Brúigh an spásbharra le sleamhnú",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Roghnaigh sprid eile",
    "gui.howtos.imagine.step_imagineLeftRight": "Bogadh ar chlé-ar dheis",
    "gui.howtos.imagine.step_imagineUpDown": "Bogadh suas-síos",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Culaith a athrú",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Sleamhnú",
    "gui.howtos.imagine.step_imagineGrowShrink": "Fás is Crapadh",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Roghnaigh cúlra eile",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "An cúlra a athrú",
    "gui.howtos.imagine.step_imagineRecordASound": "Cuir fuaim leis",
    "gui.howtos.imagine.step_imagineChooseSound": "Roghnaigh fuaim",
    "gui.howtos.make-music.name": "Ceol a chumadh",
    "gui.howtos.Make-Music.step_PickInstrument": "Ionstraim a roghnú",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Fuaim a chasadh nuair a chliceáiltear",
    "gui.howtos.Make-Music.step_MakeSong": "Amhrán a chumadh",
    "gui.howtos.make-music.step_MakeBeat": "Druma a roghnú agus buille a dhéanamh",
    "gui.howtos.make-music.step_MakeBeatBox": "Sprid micreafón agus buillebhosca randamach a roghnú",
    "gui.howtos.story.name": "Scéal a insint",
    "gui.howtos.story.step_addbg": "Cúlraí",
    "gui.howtos.story.step_addsprite": "Carachtar a chruthú",
    "gui.howtos.story.step_saysomething": "Abair leat",
    "gui.howtos.story.step_addanothersprite": "Carachtar nua a chruthú",
    "gui.howtos.story.step_flip": "An treo a athrú",
    "gui.howtos.story.step_conversation": "Comhrá a dhéanamh",
    "gui.howtos.story.addanotherbg": "Cúlra nua a chruthú",
    "gui.howtos.story.step_swithbg": "An cúlra a athrú",
    "gui.howtos.story.step_hidewizard": "Carachtar a chur i bhfolach",
    "gui.howtos.story.step_showwizard": "Carachtar a thaispeáint",
    "gui.howtos.make-a-chase-game.name": "Cluiche leaisteanna",
    "gui.howtos.Chase-Game.step_BG": "Cúlra a chur leis",
    "gui.howtos.chase-game.step_AddOcto": "Sprid nua a chur leis",
    "gui.howtos.make-music.step_LeftRight": "Bogadh ar dheis agus ar chlé leis na saigheada",
    "gui.howtos.Chase-Game.step_UpDown": "Bogadh suas anuas leis na saigheada",
    "gui.howtos.Chase-Game.step_AddStar": "Sprid eile a chur leis",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bogadh randamach",
    "gui.howtos.Chase-Game.step_WhenTouch": "Fuaim a sheinm nuair a theagmhaíonn an t-ochtapas rud éigin",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Athróg scóir a chruthú",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Fuaim a sheinm nuair a theagmhaíonn an t-ochtapas rud éigin",
    "gui.howtos.animate-char.name": "Beochan",
    "gui.howtos.animate-char.step_addbg": "Cúlraí",
    "gui.howtos.animate-char.step_addsprite": "Sprid nua",
    "gui.howtos.animate-char.step_saysomething": "Abair leat",
    "gui.howtos.animate-char.step_addsound": "Fuaimeanna",
    "gui.howtos.animate-char.step_animatetalking": "Comhrá a bheochan",
    "gui.howtos.animate-char.step_arrowkeys": "Na Saighde",
    "gui.howtos.animate-char.step_jump": "Léim",
    "gui.howtos.animate-char.step_changecolor": "An dath a athrú",
    "gui.howtos.make-a-game.name": "Cluiche cliceála",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Sprid a roghnú",
    "gui.howtos.make-a-game.step_GamePlaySound": "Fuaim a chasadh nuair a chliceáiltear",
    "gui.howtos.make-a-game.step_GameAddScore": "Athróg scóir a chruthú",
    "gui.howtos.make-a-game.step_GameChangeScore": "An scór a mhéadú nuair a chliceáiltear",
    "gui.howtos.make-a-game.step_Random": "Léim go háit randamach",
    "gui.howtos.make-music.step_GameChangeColor": "An dath a athrú",
    "gui.howtos.make-music.step_ResetScore": "An scór a athshocrú",
    "gui.howtos.make-it-fly.name": "Cuir ar eitilt é",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Roghnaigh an spéir",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Roghnaigh carachtar",
    "gui.howtos.fly.step_stepflySaySomething": "Abair leat",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Saigheadeochracha",
    "gui.howtos.fly.step_stepflyChooseObject": "Roghnaigh rud éigin le bailiú",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Cuir ar siúl é",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Roghnaigh carachtar",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Cuir scór leis",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Marcáil an scór",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Cuir radharcra leis",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Bog an radharcra",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "An chéad chulaith eile",
    "gui.howtos.pong": "Cluiche Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Cúlraí",
    "gui.howtos.pong.step_pongAddBallSprite": "Cuir liathróid leis",
    "gui.howtos.pong.step_pongBounceAround": "Preabadh thart",
    "gui.howtos.pong.step_pongAddPaddle": "Cuir slacán leis",
    "gui.howtos.pong.step_pongMoveThePaddle": "Bog an slacán",
    "gui.howtos.pong.step_pongSelectBallSprite": "Roghnaigh an liathróid",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Cód a phreabann an liathróid ar an slacán",
    "gui.howtos.pong.step_pongAddAScore": "Cuir scór leis",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Roghnaigh 'Scór' ón roghchlár",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Úsáid an bloc 'Athraigh an Scór'",
    "gui.howtos.pong.step_pongResetScore": "An scór a athshocrú",
    "gui.howtos.pong.step_pongAddLineSprite": "Cuir líne leis",
    "gui.howtos.pong.step_pongGameOver": "Cluiche thart",
    "gui.howtos.code-cartoon": "Códáil Chartúin",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Abair rud éigin nuair a chliceáiltear an bhratach uaine",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Beochan a chur le carachtar nuair a chliceáiltear é",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Roghnaigh carachtar difriúil",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Úsáid an comhartha lúide le laghdú",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Carachtar a fhás is a chrapadh",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Roghnaigh carachtar difriúil",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Léim suas agus síos",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Cliceáil carachtar chun an radharc a athrú",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Sleamhnú thart",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Culaith a athrú",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Roghnaigh tuilleadh carachtar le cur le do chartún",
    "gui.howtos.cartoon-network": "Cluiche Eachtraíochta",
    "gui.howtos.cartoon-network.step_CNcharacter": "Carachtar le taispeáint",
    "gui.howtos.cartoon-network.step_CNsay": "Abair leat",
    "gui.howtos.cartoon-network.step_CNglide": "Sleamhnú thart",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Roghnaigh rud le leanúint",
    "gui.howtos.cartoon-network.step_CNcollect": "Rudaí a bhailiú",
    "gui.howtos.cartoon-network.step_CNvariable": "Athróg don scór",
    "gui.howtos.cartoon-network.step_CNscore": "Marcáil an scór",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Leibhéal níos airde: An cúlra a athrú",
    "gui.howtos.videosens.name": "Físbhraiteacht",
    "gui.howtos.videosens.step_addextension": "Breiseáin",
    "gui.howtos.videosens.step_pet": "An cat a chuimilt",
    "gui.howtos.videosens.step_animate": "Beochan",
    "gui.howtos.videosens.step_pop": "Balún a phléascadh",
    "gui.howtos.say-it-out-loud": "Beochaintí le cumas cainte",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Úsáid blocanna Téacs-go-Caint",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Abair leat",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Guth a roghnú",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Bogadh thart",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Cúlraí",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Carachtar nua a chruthú",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Amhrán a chasadh",
    "gui.howtos.say-it-out-loud.step_TXTColor": "An dath a athrú",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Casadh timpeall",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Fás is Crapadh",
    "gui.howtos.talking": "Béalscéalta",
    "gui.howtos.talking.step_talesAddExtension": "Cliceáil chun blocanna téacs-go-caint a chur leis",
    "gui.howtos.talking.step_talesChooseSprite": "Roghnaigh sprid",
    "gui.howtos.talking.step_talesSaySomething": "Carachtar a chur ag labhairt",
    "gui.howtos.talking.step_talesChooseBackdrop": "Roghnaigh cúlra",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Cliceáil carachtar chun dul ar aghaidh go dtí an chéad chúlra eile",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Roghnaigh sprid eile",
    "gui.howtos.talking.step_talesMoveAround": "Bogadh thart",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Roghnaigh cúlra eile",
    "gui.howtos.talking.step_talesAnimateTalking": "Comhrá a bheochan",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Roghnaigh cúlra eile",
    "gui.howtos.talking.step_talesChooseSound": "Roghnaigh ceol damhsa",
    "gui.howtos.talking.step_talesDanceMoves": "Steipeanna damhsa",
    "gui.howtos.talking.step_talesAskAnswer": "Faigh na blocanna Fiafraí agus Freagra ón chatagóir Braiteacht",
    "gui.howtos.add-sprite.name": "Sprid nua a chur leis",
    "gui.howtos.add-sprite.step_addSprite": "Sprid nua a chur leis",
    "gui.howtos.add-a-backdrop.name": "Cúlraí",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Cúlraí",
    "gui.howtos.change-size.name": "Méideanna a athrú",
    "gui.howtos.change-size.step_changeSize": "Méideanna a athrú",
    "gui.howtos.glide-around.name": "Sleamhnú thart",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Sleamhnú Thart",
    "gui.howtos.change-size.step_glideAroundPoint": "Sleamhnú",
    "gui.howtos.record-a-sound.name": "Fuaim a thaifeadadh",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Cliceáil an cluaisín 'Fuaimeanna'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Cliceáil 'Taifead'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Brúigh an cnaipe Taifead",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Roghnaigh fuaim",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Seinn an fhuaim",
    "gui.howtos.spin-video.name": "Cur ar casadh é",
    "gui.howtos.change-size.step_spinTurn": "Casadh",
    "gui.howtos.change-size.step_spinPointInDirection": "Socraigh an treo",
    "gui.howtos.hide-and-show.name": "Folú agus Taispeáint",
    "gui.howtos.change-size.step_hideAndShow": "Folú agus Taispeáint",
    "gui.howtos.switch-costume.name": "Beochan a chur le sprid",
    "gui.howtos.change-size.step_switchCostumes": "Beochan a chur le sprid",
    "gui.howtos.move-around-with-arrow-keys.name": "Na Saigheada",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Bogadh ar chlé agus ar dheis",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bogadh suas agus síos",
    "gui.howtos.add-effects.name": "Maisíochtaí",
    "gui.howtos.videosens.step_addEffects": "Maisíochtaí",
    "gui.extension.music.name": "Ceol",
    "gui.extension.music.description": "Casadh ceoil le hionstraimí agus le drumaí.",
    "gui.extension.pen.name": "Peann",
    "gui.extension.pen.description": "Dearadh le do chuid sprideanna.",
    "gui.extension.videosensing.name": "Físbhraiteacht",
    "gui.extension.videosensing.description": "Gluaiseacht a bhrath leis an gceamara.",
    "gui.extension.text2speech.name": "Téacs-go-Caint",
    "gui.extension.text2speech.description": "Tabhair cumas cainte do do thionscadail.",
    "gui.extension.translate.name": "Aistriúchán",
    "gui.extension.translate.description": "Aistriúcháin i mórán teangacha.",
    "gui.extension.makeymakey.description": "Déan eochair as aon rud.",
    "gui.extension.microbit.description": "Cuir do chuid tionscadal os comhair an domhain.",
    "gui.extension.microbit.connectingMessage": "Ceangal",
    "gui.extension.ev3.description": "Róbait idirghníomhacha agus tuilleadh.",
    "gui.extension.ev3.connectingMessage": "Ag ceangal. Deimhnigh gurb é 1234 an PIN ar do EV3.",
    "gui.extension.boost.description": "Cuir beocht i róbat.",
    "gui.extension.boost.connectingMessage": "Ceangal",
    "gui.extension.wedo2.description": "Tógáil le mótair agus le braiteoirí.",
    "gui.extension.wedo2.connectingMessage": "Ceangal",
    "gui.extension.gdxfor.description": "Breiseán a bhraitheann brú, tarraingt, gluaiseacht, agus casadh.",
    "gui.extension.gdxfor.connectingMessage": "Ceangal",
    "gui.libraryTags.all": "Uile",
    "gui.libraryTags.animals": "Ainmhithe",
    "gui.libraryTags.dance": "Damhsa",
    "gui.libraryTags.effects": "Maisíochtaí",
    "gui.libraryTags.fantasy": "Fantaisíocht",
    "gui.libraryTags.fashion": "Faisean",
    "gui.libraryTags.food": "Bia",
    "gui.libraryTags.indoors": "Taobh Istigh",
    "gui.libraryTags.loops": "Lúba",
    "gui.libraryTags.music": "Ceol",
    "gui.libraryTags.notes": "Nótaí",
    "gui.libraryTags.outdoors": "Amuigh Faoin Aer",
    "gui.libraryTags.patterns": "Patrúin",
    "gui.libraryTags.people": "Daoine",
    "gui.libraryTags.percussion": "Cnaguirlisí",
    "gui.libraryTags.space": "Spás",
    "gui.libraryTags.sports": "Spórt",
    "gui.libraryTags.underwater": "Faoi uisce",
    "gui.libraryTags.voice": "Guth",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Beochan",
    "gui.libraryTags.art": "Ealaín",
    "gui.libraryTags.games": "Cluichí",
    "gui.libraryTags.stories": "Scéalta",
    "gui.libraryTags.letters": "Litreacha",
    "gui.opcodeLabels.direction": "treo",
    "gui.opcodeLabels.xposition": "ionad x",
    "gui.opcodeLabels.yposition": "ionad y",
    "gui.opcodeLabels.size": "méid",
    "gui.opcodeLabels.costumename": "ainm na culaithe",
    "gui.opcodeLabels.costumenumber": "uimhir na culaithe",
    "gui.opcodeLabels.backdropname": "ainm an chúlra",
    "gui.opcodeLabels.backdropnumber": "uimhir an chúlra",
    "gui.opcodeLabels.volume": "airde",
    "gui.opcodeLabels.tempo": "luas",
    "gui.opcodeLabels.answer": "freagra",
    "gui.opcodeLabels.loudness": "treise",
    "gui.opcodeLabels.username": "ainm úsáideora",
    "gui.opcodeLabels.year": "bliain",
    "gui.opcodeLabels.month": "mí",
    "gui.opcodeLabels.date": "dáta",
    "gui.opcodeLabels.dayofweek": "lá den tseachtain",
    "gui.opcodeLabels.hour": "uair",
    "gui.opcodeLabels.minute": "nóiméad",
    "gui.opcodeLabels.second": "soicind",
    "gui.opcodeLabels.timer": "amadóir",
    "gui.projectLoader.loadError": "Níorbh fhéidir an comhad tionscadail sin a lódáil.",
    "gui.sharedMessages.backdrop": "cúlra{index}",
    "gui.sharedMessages.costume": "culaith{index}",
    "gui.sharedMessages.sprite": "Sprid{index}",
    "gui.sharedMessages.pop": "pléasc",
    "gui.sharedMessages.replaceProjectWarning": "An bhfuil tú cinnte gur mhaith leat ábhar an tionscadail reatha a fhorscríobh?",
    "gui.sharedMessages.loadFromComputerTitle": "Lódáil ó do ríomhaire",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Tionscadal Scratch",
    "boost.color.any": "dath ar bith",
    "boost.color.black": "dubh",
    "boost.color.blue": "gorm",
    "boost.color.green": "uaine",
    "boost.color.red": "dearg",
    "boost.color.white": "bán",
    "boost.color.yellow": "buí",
    "boost.getMotorPosition": "ionad mótair [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "uillinn chlaonta [TILT_DIRECTION]",
    "boost.motorDirection.backward": "an treo sin",
    "boost.motorDirection.forward": "an treo seo",
    "boost.motorDirection.reverse": "droim ar ais",
    "boost.motorOff": "múch mótar [MOTOR_ID]",
    "boost.motorOn": "cuir mótar [MOTOR_ID] ar siúl",
    "boost.motorOnFor": "cas mótar [MOTOR_ID] ar feadh [DURATION] soicind",
    "boost.motorOnForRotation": "cas mótar [MOTOR_ID] ar feadh [ROTATION] rothlú",
    "boost.seeingColor": "an bhfeictear bríce [COLOR]?",
    "boost.setLightHue": "socraigh dath an tsolais: [HUE]",
    "boost.setMotorDirection": "socraigh treo mótair [MOTOR_ID]: [MOTOR_DIRECTION]",
    "boost.setMotorPower": "socraigh luas mótair [MOTOR_ID]: [POWER] %",
    "boost.tiltDirection.any": "ceann ar bith",
    "boost.tiltDirection.down": "síos",
    "boost.tiltDirection.left": "ar chlé",
    "boost.tiltDirection.right": "ar dheis",
    "boost.tiltDirection.up": "suas",
    "boost.whenColor": "nuair a fheictear bríce [COLOR]",
    "boost.whenTilted": "agus claonta [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "seinn nóta [NOTE] mar bhíp ar feadh [TIME] soicind",
    "ev3.buttonPressed": "cnaipe [PORT] brúite?",
    "ev3.getBrightness": "gile",
    "ev3.getDistance": "fad slí",
    "ev3.getMotorPosition": "treoshuíomh mótair [PORT]",
    "ev3.motorSetPower": "socraigh cumhacht mhótar [PORT]: [POWER]%",
    "ev3.motorTurnClockwise": "cas mótar [PORT] sa treo seo ar feadh [TIME] soicind",
    "ev3.motorTurnCounterClockwise": "cas mótar [PORT] sa treo sin ar feadh [TIME] soicind",
    "ev3.whenBrightnessLessThan": "agus gile < [DISTANCE]",
    "ev3.whenButtonPressed": "agus cnaipe [PORT] brúite",
    "ev3.whenDistanceLessThan": "agus fad < [DISTANCE]",
    "gdxfor.getAcceleration": "luasghéarú [DIRECTION]",
    "gdxfor.getForce": "fórsa",
    "gdxfor.getSpin": "luas casta [DIRECTION]",
    "gdxfor.getTilt": "uillinn chlaonta [TILT]",
    "gdxfor.isFreeFalling": "ag titim?",
    "gdxfor.isTilted": "claonta [TILT]?",
    "gdxfor.pulled": "tarraingthe",
    "gdxfor.pushed": "brúite",
    "gdxfor.shaken": "croite",
    "gdxfor.startedFalling": "tús titime",
    "gdxfor.tiltDirectionMenu.any": "ceann ar bith",
    "gdxfor.tiltDirectionMenu.back": "cúl",
    "gdxfor.tiltDirectionMenu.front": "tosach",
    "gdxfor.tiltDirectionMenu.left": "ar chlé",
    "gdxfor.tiltDirectionMenu.right": "ar dheis",
    "gdxfor.turnedFaceDown": "casta béal faoi",
    "gdxfor.turnedFaceUp": "casta béal suas",
    "gdxfor.whenForcePushedOrPulled": "nuair atá an braiteoir fórsa [PUSH_PULL]",
    "gdxfor.whenGesture": "nuair a bhraitear [GESTURE]",
    "gdxfor.whenTilted": "agus claonta [TILT]",
    "makeymakey.downArrow": "saighead síos",
    "makeymakey.downArrowShort": "síos",
    "makeymakey.leftArrow": "saighead chlé",
    "makeymakey.leftArrowShort": "ar chlé",
    "makeymakey.rightArrow": "saighead dheas",
    "makeymakey.rightArrowShort": "ar dheis",
    "makeymakey.spaceKey": "spás",
    "makeymakey.upArrow": "saighead suas",
    "makeymakey.upArrowShort": "suas",
    "makeymakey.whenKeyPressed": "nuair a bhrúitear eochair [KEY]",
    "makeymakey.whenKeysPressedInOrder": "nuair a bhrúitear [SEQUENCE] in ord",
    "microbit.buttonsMenu.any": "ceann ar bith",
    "microbit.clearDisplay": "glan an scáileán",
    "microbit.defaultTextToDisplay": "Dia dhuit!",
    "microbit.displaySymbol": "taispeáin [MATRIX]",
    "microbit.displayText": "taispeáin téacs [TEXT]",
    "microbit.gesturesMenu.jumped": "léimthe",
    "microbit.gesturesMenu.moved": "bogtha",
    "microbit.gesturesMenu.shaken": "croite",
    "microbit.isButtonPressed": "cnaipe [BTN] brúite?",
    "microbit.isTilted": "claonta [DIRECTION]?",
    "microbit.pinStateMenu.off": "as",
    "microbit.pinStateMenu.on": "ann",
    "microbit.tiltAngle": "uillinn [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ceann ar bith",
    "microbit.tiltDirectionMenu.back": "cúl",
    "microbit.tiltDirectionMenu.front": "tosach",
    "microbit.tiltDirectionMenu.left": "ar chlé",
    "microbit.tiltDirectionMenu.right": "ar dheis",
    "microbit.whenButtonPressed": "agus cnaipe [BTN] brúite",
    "microbit.whenGesture": "nuair a bhraitear [GESTURE]",
    "microbit.whenPinConnected": "nuair atá pionna [PIN] ceangailte",
    "microbit.whenTilted": "agus claonta i dtreo [DIRECTION]",
    "music.categoryName": "Ceol",
    "music.changeTempo": "athraigh an luas de [TEMPO]",
    "music.drumBass": "(2) Dord-Druma",
    "music.drumBongo": "(13) Bongó",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Clabhaí",
    "music.drumClosedHiHat": "(6) Ard-hata dúnta",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Clog Bó",
    "music.drumCrashCymbal": "(4) Ciombal Plimpe",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guíoró",
    "music.drumHandClap": "(8) Bualadh Bos",
    "music.drumOpenHiHat": "(5) Ard-Hata Oscailte",
    "music.drumSideStick": "(3) Maide Taoibh",
    "music.drumSnare": "(1) Sreangdhruma",
    "music.drumTambourine": "(7) Tambóirín",
    "music.drumTriangle": "(12) Triantán",
    "music.drumVibraslap": "(17) Vibreaslap",
    "music.drumWoodBlock": "(10) Bloc Adhmaid",
    "music.getTempo": "luas",
    "music.instrumentBass": "(6) Dord",
    "music.instrumentBassoon": "(14) Basún",
    "music.instrumentCello": "(8) Dordveidhil",
    "music.instrumentChoir": "(15) Cór",
    "music.instrumentClarinet": "(10) Clairinéad",
    "music.instrumentElectricGuitar": "(5) Giotár Leictreach",
    "music.instrumentElectricPiano": "(2) Pianó Leictreach",
    "music.instrumentFlute": "(12) Fliúit",
    "music.instrumentGuitar": "(4) Giotár",
    "music.instrumentMarimba": "(19) Mairimbe",
    "music.instrumentMusicBox": "(17) Ceolbhosca",
    "music.instrumentOrgan": "(3) Orgán",
    "music.instrumentPiano": "(1) Pianó",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Sacsafón",
    "music.instrumentSteelDrum": "(18) Druma Cruach",
    "music.instrumentSynthLead": "(20) Príomhshintéiseoir",
    "music.instrumentSynthPad": "(21) Ceapshintéiseoir",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibreafón",
    "music.instrumentWoodenFlute": "(13) Fliúit Adhmaid",
    "music.midiPlayDrumForBeats": "seinn druma [DRUM] ar feadh [BEATS] buille",
    "music.midiSetInstrument": "socraigh an ionstraim: [INSTRUMENT]",
    "music.playDrumForBeats": "seinn druma [DRUM] ar feadh [BEATS] buille",
    "music.playNoteForBeats": "seinn nóta [NOTE] ar feadh [BEATS] buille",
    "music.restForBeats": "stad ar feadh [BEATS] buille",
    "music.setInstrument": "socraigh an ionstraim: [INSTRUMENT]",
    "music.setTempo": "socraigh an luas: [TEMPO]",
    "pen.categoryName": "Peann",
    "pen.changeColorParam": "athraigh [COLOR_PARAM] an phinn de [VALUE]",
    "pen.changeHue": "athraigh dath an phinn de [HUE]",
    "pen.changeShade": "athraigh dorchadas an phinn de [SHADE]",
    "pen.changeSize": "athraigh méid an phinn de [SIZE]",
    "pen.clear": "scrios uile",
    "pen.colorMenu.brightness": "gile",
    "pen.colorMenu.color": "dath",
    "pen.colorMenu.saturation": "sáithiú",
    "pen.colorMenu.transparency": "trédhearcacht",
    "pen.penDown": "peann síos",
    "pen.penUp": "peann suas",
    "pen.setColor": "socraigh dath an phinn: [COLOR]",
    "pen.setColorParam": "socraigh [COLOR_PARAM] an phinn: [VALUE]",
    "pen.setHue": "socraigh dath an phinn: [HUE]",
    "pen.setShade": "socraigh dorchadas an phinn: [SHADE]",
    "pen.setSize": "socraigh méid an phinn: [SIZE]",
    "pen.stamp": "stampa",
    "speech.defaultWhenIHearValue": "ar aghaidh linn",
    "speech.extensionName": "Caint go Téacs",
    "speech.listenAndWait": "éist agus fan",
    "speech.speechReporter": "caint",
    "speech.whenIHear": "nuair a chloisim [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Téacs-go-Caint",
    "text2speech.defaultTextToSpeak": "dia dhuit",
    "text2speech.giant": "fathach",
    "text2speech.kitten": "piscín",
    "text2speech.setLanguageBlock": "socraigh an teanga: [LANGUAGE]",
    "text2speech.setVoiceBlock": "socraigh an guth: [VOICE]",
    "text2speech.speakAndWaitBlock": "abair [WORDS]",
    "text2speech.squeak": "gíog",
    "text2speech.tenor": "teanór",
    "translate.categoryName": "Aistriúchán",
    "translate.defaultTextToTranslate": "dia dhuit",
    "translate.translateBlock": "aistrigh [WORDS] go [LANGUAGE]",
    "translate.viewerLanguage": "teanga",
    "videoSensing.categoryName": "Físbhraiteacht",
    "videoSensing.direction": "treo",
    "videoSensing.motion": "gluaiseacht",
    "videoSensing.off": "as",
    "videoSensing.on": "ann",
    "videoSensing.onFlipped": "ann-smeachta",
    "videoSensing.setVideoTransparency": "socraigh an trédhearcacht físe: [TRANSPARENCY]",
    "videoSensing.sprite": "sprid",
    "videoSensing.stage": "stáitse",
    "videoSensing.videoOn": "[ATTRIBUTE] físe ar [SUBJECT]",
    "videoSensing.videoToggle": "cas an físeán [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "Nuair atá físghluaiseacht > [REFERENCE]",
    "wedo2.getDistance": "fad slí",
    "wedo2.getTiltAngle": "uillinn chlaonta [TILT_DIRECTION]",
    "wedo2.isTilted": "claonta [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "an treo sin",
    "wedo2.motorDirection.forward": "an treo seo",
    "wedo2.motorDirection.reverse": "droim ar ais",
    "wedo2.motorId.a": "mótar A",
    "wedo2.motorId.all": "gach mótar",
    "wedo2.motorId.b": "mótar B",
    "wedo2.motorId.default": "mótar",
    "wedo2.motorOff": "múch [MOTOR_ID]",
    "wedo2.motorOn": "cuir [MOTOR_ID] ar siúl",
    "wedo2.motorOnFor": "cuir [MOTOR_ID] ar siúl ar feadh [DURATION] soicind",
    "wedo2.playNoteFor": "seinn nóta [NOTE] ar feadh [DURATION] soicind",
    "wedo2.setLightHue": "socraigh dath an tsolais: [HUE]",
    "wedo2.setMotorDirection": "socraigh treo [MOTOR_ID]: [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "socraigh cumhacht [MOTOR_ID]: [POWER]",
    "wedo2.tiltDirection.any": "ceann ar bith",
    "wedo2.tiltDirection.down": "síos",
    "wedo2.tiltDirection.left": "ar chlé",
    "wedo2.tiltDirection.right": "ar dheis",
    "wedo2.tiltDirection.up": "suas",
    "wedo2.whenDistance": "agus fad [OP] [REFERENCE]",
    "wedo2.whenTilted": "agus claonta [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Dath",
    "paint.paintEditor.saturation": "Sáithiú",
    "paint.paintEditor.brightness": "Gile",
    "paint.paintEditor.costume": "Culaith",
    "paint.paintEditor.group": "Grúpa",
    "paint.paintEditor.ungroup": "Díghrúpáil",
    "paint.paintEditor.undo": "Cealaigh",
    "paint.paintEditor.redo": "Athdhéan",
    "paint.paintEditor.forward": "Ar aghaidh",
    "paint.paintEditor.backward": "Ar gcúl",
    "paint.paintEditor.front": "Chun tosaigh",
    "paint.paintEditor.back": "Chun deiridh",
    "paint.paintEditor.more": "Tuilleadh",
    "paint.modeTools.brushSize": "Méid",
    "paint.modeTools.eraserSize": "Méid an léirscriosáin",
    "paint.modeTools.copy": "Cóipeáil",
    "paint.modeTools.paste": "Greamaigh",
    "paint.modeTools.delete": "Scrios",
    "paint.modeTools.curved": "Cuartha",
    "paint.modeTools.pointed": "Bioraithe",
    "paint.modeTools.thickness": "Leithead",
    "paint.modeTools.flipHorizontal": "Smeach go cothrománach",
    "paint.modeTools.flipVertical": "Smeach go hingearach",
    "paint.modeTools.filled": "Líonta",
    "paint.modeTools.outlined": "Imlínithe",
    "paint.paintEditor.bitmap": "Tiontaigh go mapa giotán",
    "paint.paintEditor.vector": "Mód Veicteora",
    "paint.paintEditor.fill": "Líon",
    "paint.paintEditor.stroke": "Imlíne",
    "paint.brushMode.brush": "Scuab",
    "paint.eraserMode.eraser": "Léirscriosán",
    "paint.fillMode.fill": "Líon",
    "paint.lineMode.line": "Líne",
    "paint.ovalMode.oval": "Ciorcal",
    "paint.rectMode.rect": "Dronuilleog",
    "paint.reshapeMode.reshape": "Athdheilbhigh",
    "paint.roundedRectMode.roundedRect": "Dronuilleog Chruinn",
    "paint.selectMode.select": "Roghnaigh",
    "paint.textMode.text": "Téacs",
    "paint.colorPicker.swap": "Babhtáil"
  },
  "gd": {
    "gui.alerts.lostPeripheralConnection": "Chaill Scratch an ceangal ri {extensionName}.",
    "gui.alerts.tryAgain": "Feuch ris a-rithist",
    "gui.alerts.download": "Luchdaich a-nuas",
    "gui.connection.reconnect": "Ath-cheangail",
    "gui.backpack.costumeLabel": "dreach",
    "gui.backpack.soundLabel": "fuaim",
    "gui.backpack.scriptLabel": "sgriobt",
    "gui.backpack.spriteLabel": "sprìd",
    "gui.backpack.header": "Màla-droma",
    "gui.backpack.errorBackpack": "Mearachd le luchdadh na màla-droma",
    "gui.backpack.loadingBackpack": "’Ga luchdadh…",
    "gui.backpack.more": "Barrachd",
    "gui.backpack.emptyBackpack": "Tha a’ mhàla-droma falamh",
    "gui.unsupportedBrowser.label": "Cha chuir sinn taic ris a’ bhrabhsair",
    "gui.unsupportedBrowser.errorLabel": "Thachair mearachd",
    "gui.unsupportedBrowser.notRecommended": "Tha sinn glè dhuilich ach tha coltas gu bheil thu a’ cleachdadh brabhsair ris nach cuir Scratch taic. Mholamaid gun ùraich thu e gun tionndadh as ùire de bhrabhsair ris an cuir sinn taic, can Google Chrome, Mozilla Firefox, Microsoft Edge no Apple Safari.",
    "gui.unsupportedBrowser.description": "Tha sinn glè dhuilich ach cha cuir Scratch taic ris a’ bhrabhsair seo. Mholamaid gun ùraich thu e gun tionndadh as ùire de bhrabhsair ris an cuir sinn taic, can Google Chrome, Mozilla Firefox, Microsoft Edge no Apple Safari.",
    "gui.unsupportedBrowser.back": "Air ais",
    "gui.unsupportedBrowser.previewfaq": "Tadhail air {previewFaqLink} airson barrachd fiosrachaidh.",
    "gui.unsupportedBrowser.previewfaqlinktext": "CÀBHA",
    "gui.cards.all-tutorials": "Oideachadh",
    "gui.cards.shrink": "Crùb",
    "gui.cards.expand": "Leudaich",
    "gui.cards.close": "Dùin",
    "gui.cards.more-things-to-try": "Barrachd rudan ri am feuchainn!",
    "gui.cards.see-more": "Seall a bharrachd",
    "gui.comingSoon.message1": "Na gabh dragh, tha sinn ag obair air {emoji}",
    "gui.comingSoon.message2": "Ri thighinn a dh’aithghearr…",
    "gui.comingSoon.message3": "Tha sinn ag obair air {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Cha deach uidheam a lorg",
    "gui.connection.auto-scanning.prescan": "Cuir an t-uidheam agad faisg air is dèan lorg an uairsin.",
    "gui.connection.auto-scanning.pressbutton": "Brùth air a’ phutan air an uidheam agad.",
    "gui.connection.auto-scanning.start-search": "Dèan lorg",
    "gui.connection.connecting-searchbutton": "Ga lorg…",
    "gui.connection.auto-scanning.try-again": "Feuch ris a‑rithist",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ceangailte",
    "gui.connection.disconnect": "Bris an ceangal",
    "gui.connection.go-to-editor": "Rach dhan deasaiche",
    "gui.connection.connecting-cancelbutton": "Ga cheangal…",
    "gui.connection.error.errorMessage": "Oich, tha coltas gun deach rudeigin ceàrr.",
    "gui.connection.error.tryagainbutton": "Feuch ris a‑rithist",
    "gui.connection.error.helpbutton": "Cobhair",
    "gui.connection.peripheral-name-label": "Ainm an uidheim",
    "gui.connection.connect": "Ceangail",
    "gui.connection.scanning.lookingforperipherals": "A’ lorg nan uidheaman",
    "gui.connection.scanning.noPeripheralsFound": "Cha deach uidheam a lorg",
    "gui.connection.scanning.instructions": "Tagh an t‑uidheam agad san liosta gu h‑àrd.",
    "gui.connection.search": "Ath-nuadhaich",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Dèan cinnteach gun deach Scratch Link a stàladh ’s gu bheil e ga ruith",
    "gui.connection.unavailable.enablebluetooth": "Dèan cinnteach gu bheil Bluetooth an comas",
    "gui.connection.unavailable.tryagainbutton": "Feuch ris a‑rithist",
    "gui.connection.unavailable.helpbutton": "Cobhair",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Air ais",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Feuch ris a-rithist",
    "gui.controls.go": "Siuthad",
    "gui.controls.stop": "Cuir stad air",
    "gui.crashMessage.label": "Oich! Chaidh rudeigin ceàrr.",
    "gui.crashMessage.description": "Tha sinn duilich ach tha coltas gun do thuislich Scratch. Fhuair sgioba Scratch fios mu dhèidhinn gu fèin-obrachail. Ath-nuadhaich an duilleag airson fheuchainn ris a‑rithist.",
    "gui.crashMessage.errorNumber": "Chaidh a’ mhearachd agad a chlàradh le ID {errorId}",
    "gui.crashMessage.reload": "Ath-luchdaich",
    "gui.customProcedures.myblockModalTitle": "Cruthaich bloca",
    "gui.customProcedures.addAnInputNumberText": "Cuir raon ris",
    "gui.customProcedures.numberTextType": "àireamh no teacsa",
    "gui.customProcedures.addAnInputBoolean": "Cuir raon ris",
    "gui.customProcedures.booleanType": "Booleach",
    "gui.customProcedures.addALabel": "Cuir leubail ris",
    "gui.customProcedures.runWithoutScreenRefresh": "Ruith às aonais ath-nuadhachadh na sgrìn",
    "gui.customProcedures.cancel": "Sguir dheth",
    "gui.customProcedures.ok": "Ceart ma-thà",
    "gui.SpriteInfo.direction": "Comhair",
    "gui.directionPicker.rotationStyles.allAround": "Cuairt shlàn",
    "gui.directionPicker.rotationStyles.leftRight": "Gu clì/deas",
    "gui.directionPicker.rotationStyles.dontRotate": "Na cuairtich",
    "gui.gui.addExtension": "Cuir leudachan ris",
    "gui.gui.codeTab": "Còd",
    "gui.gui.backdropsTab": "Cùlaibhean",
    "gui.gui.costumesTab": "Dreachan",
    "gui.gui.soundsTab": "Fuaimean",
    "gui.extensionLibrary.comingSoon": "Ri thighinn a dh’aithghearr",
    "gui.extensionLibrary.requires": "Riatanasan",
    "gui.extensionLibrary.collaboration": "Co-obrachadh le",
    "gui.library.filterPlaceholder": "Lorg",
    "gui.library.allTag": "Na h-uile",
    "gui.loader.message1": "A’ cruthachadh nam blocaichean…",
    "gui.loader.message2": "A’ luchdadh nan sprìdean…",
    "gui.loader.message3": "A’ luchdadh nam fuaimean…",
    "gui.loader.message4": "A’ luchdadh nan leudachan…",
    "gui.loader.message5": "Cho foighidinneach ri cat…",
    "gui.loader.message6": "A’ slìobadh a’ chait…",
    "gui.loader.message7": "A’ leigeil an cat às a phòca…",
    "gui.loader.message8": "Ag ullachadh nan emojis…",
    "gui.loader.headline": "A’ luchdadh a’ phròiseict",
    "gui.loader.creating": "A’ cruthachadh pròiseact",
    "gui.accountMenu.profile": "Pròifil",
    "gui.accountMenu.myStuff": "An stuth agam",
    "gui.accountMenu.myClasses": "Na clasaichean agam",
    "gui.accountMenu.myClass": "An clas agam",
    "gui.accountMenu.accountSettings": "Roghainnean a’ chunntais",
    "gui.accountMenu.signOut": "Clàraich a-mach",
    "gui.authorInfo.byUser": "le {username}",
    "gui.menuBar.seeProjectPage": "Seall duilleag a’ phròiseict",
    "gui.menuBar.language": "Cànan",
    "general.username": "Ainm-cleachdaiche",
    "general.password": "Facal-faire",
    "general.signIn": "Clàraich a-steach",
    "login.needHelp": "Feumach air taic?",
    "form.validationRequired": "Tha an raon seo riatanach",
    "gui.menuBar.tutorialsLibrary": "Oideachadh",
    "gui.menuBar.restoreSprite": "Aisig an an sprìd",
    "gui.menuBar.restoreSound": "Aisig an fhuaim",
    "gui.menuBar.restoreCostume": "Aisig an dreach",
    "gui.menuBar.restore": "Aisig",
    "gui.menuBar.saveNow": "Sàbhail an-dràsta",
    "gui.menuBar.saveAsCopy": "Sàbhail mar lethbhreac",
    "gui.menuBar.remix": "Ath-mheasgaich",
    "gui.menuBar.new": "Ùr",
    "gui.menuBar.file": "Faidhle",
    "gui.menuBar.downloadToComputer": "Sàbhail air a’ choimpiutair agad",
    "gui.menuBar.edit": "Deasaich",
    "gui.menuBar.turboModeOff": "Cuir dheth am modh turbo",
    "gui.menuBar.turboModeOn": "Cuir air am modh turbo",
    "gui.menuBar.modeMenu": "Modh",
    "gui.menuBar.normalMode": "Modh àbhaisteach",
    "gui.menuBar.caturdayMode": "Modh nan cat",
    "gui.menuBar.joinScratch": "Ballrachd",
    "gui.menuBar.signIn": "Clàraich a-steach",
    "gui.gui.projectTitlePlaceholder": "Cuir ainm a’ pròiseict an-seo",
    "gui.menuBar.saveNowLink": "Sàbhail an-dràsta",
    "gui.menuBar.settings": "Roghainnean",
    "gui.menuBar.isShared": "Air a cho-roinneadh",
    "gui.menuBar.share": "Co-roinn",
    "gui.menuBar.colorMode": "Modh nan dath",
    "gui.modal.help": "Cobhair",
    "gui.modal.back": "Air ais",
    "gui.monitor.listMonitor.empty": "(falamh)",
    "gui.monitor.listMonitor.listLength": "faide {length}",
    "gui.monitor.contextMenu.default": "sealladh àbhaisteach",
    "gui.monitor.contextMenu.large": "sealladh mòr",
    "gui.monitor.contextMenu.slider": "an sleamhnachan",
    "gui.monitor.contextMenu.sliderRange": "atharraich rainse an t-sleamhnachain",
    "gui.monitor.contextMenu.import": "ion-phortaich",
    "gui.monitor.contextMenu.export": "às-phortaich",
    "gui.monitor.contextMenu.hide": "falaich",
    "gui.playButton.play": "Cluich",
    "gui.playButton.stop": "Cuir stad air",
    "gui.gui.variableScopeOptionAllSprites": "Airson a h‑uile sprìd",
    "gui.gui.variableScopeOptionSpriteOnly": "Airson na sprìde seo a‑mhàin",
    "gui.gui.cloudVariableOption": "Caochladair neòil (ga stòradh air an fhrithealaiche)",
    "gui.gui.variablePromptAllSpritesMessage": "Bidh an caochladair seo ri làimh dhan a h‑uile sprìd.",
    "gui.gui.listPromptAllSpritesMessage": "Bidh an liosta seo ri làimh dhan a h‑uile sprìd.",
    "gui.prompt.cancel": "Sguir dheth",
    "gui.prompt.ok": "Ceart ma-thà",
    "gui.playbackStep.stopMsg": "Cuir stad air",
    "gui.playbackStep.playMsg": "Cluich",
    "gui.playbackStep.loadingMsg": "Ga luchdadh…",
    "gui.playbackStep.saveMsg": "Sàbhail",
    "gui.playbackStep.reRecordMsg": "Clàraich a‑rithist e",
    "gui.recordModal.title": "Clàraich fuaim",
    "gui.recordingStep.beginRecord": "Briog air a’ phutan gu h-ìosal a thòiseachadh leis a’ chlàradh",
    "gui.recordingStep.permission": "{arrow}Tha sinn feumach air cead gus am micreofon agad a chleachdadh",
    "gui.recordingStep.stop": "Cuir stad air a’ chlàradh",
    "gui.recordingStep.record": "Clàraich",
    "gui.sliderModal.min": "Luach as lugha",
    "gui.sliderModal.max": "Luach as motha",
    "gui.sliderModal.title": "Atharraich rainse an t-sleamhnachain",
    "gui.sliderPrompt.cancel": "Sguir dheth",
    "gui.sliderPrompt.ok": "Ceart ma-thà",
    "gui.soundEditor.sound": "Fuaim",
    "gui.soundEditor.play": "Cluich",
    "gui.soundEditor.stop": "Cuir stad air",
    "gui.soundEditor.copy": "Dèan lethbhreac",
    "gui.soundEditor.paste": "Cuir ann",
    "gui.soundEditor.copyToNew": "Cuir lethbhreac gu fear ùr",
    "gui.soundEditor.delete": "Sguab às",
    "gui.soundEditor.save": "Sàbhail",
    "gui.soundEditor.undo": "Neo-dhèan",
    "gui.soundEditor.redo": "Ath-dhèan",
    "gui.soundEditor.faster": "Nas luaithe",
    "gui.soundEditor.slower": "Nas maille",
    "gui.soundEditor.echo": "Mac-talla",
    "gui.soundEditor.robot": "Robotair",
    "gui.soundEditor.louder": "Nas àirde",
    "gui.soundEditor.softer": "Nas ìsle",
    "gui.soundEditor.reverse": "Contrarra",
    "gui.soundEditor.fadeOut": "Crìon a-mach",
    "gui.soundEditor.fadeIn": "Crìon a-steach",
    "gui.soundEditor.mute": "Mùch",
    "gui.SpriteInfo.spritePlaceholder": "Ainm",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprìd",
    "gui.SpriteInfo.show": "Seall",
    "gui.SpriteInfo.size": "Meud",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dùblaich",
    "gui.spriteSelectorItem.contextMenuExport": "às-phortaich",
    "gui.spriteSelectorItem.contextMenuDelete": "sguab às",
    "gui.spriteSelector.addSpriteFromLibrary": "Tagh sprìd",
    "gui.spriteSelector.addSpriteFromPaint": "Peant",
    "gui.spriteSelector.addSpriteFromSurprise": "Tagh tè dhomh",
    "gui.spriteSelector.addSpriteFromFile": "Luchdaich suas sprìd",
    "gui.stageHeader.stageSizeLarge": "Atharraich gu àrd-ùrlar mòr",
    "gui.stageHeader.stageSizeSmall": "Atharraich gu àrd-ùrlar beag",
    "gui.stageHeader.stageSizeFull": "Modh na làn-sgrìn",
    "gui.stageHeader.stageSizeUnFull": "Fàg modh na làn-sgrìn",
    "gui.stageHeader.fullscreenControl": "Toglaich am modh làn-sgrìn",
    "gui.spriteSelector.addBackdropFromLibrary": "Tagh cùlaibh",
    "gui.stageSelector.addBackdropFromPaint": "Peant",
    "gui.stageSelector.addBackdropFromSurprise": "Tagh fear dhomh",
    "gui.stageSelector.addBackdropFromFile": "Luchdaich suas cùlaibh",
    "gui.stageSelector.stage": "Àrd-ùrlar",
    "gui.stageSelector.backdrops": "Cùlaibhean",
    "gui.telemetryOptIn.label": "Aithris stadastaireachd a chum leasachadh Scratch",
    "gui.telemetryOptIn.body1": "Mu mhiann le sgioba Scratch tuigsinn mar a thathar a’ cleachdadh Scratch air feadh an t-saoghail. Airson taic a chur ri sin, ’s urrainn dhut cead a thoirt do Scratch ach an cuir sinn fiosrachadh mun chleachdadh gu sgioba Scratch gu fèin-obrachail.",
    "gui.telemetryOptIn.body2": "Gabhaidh am fiosrachadh a chruinnicheas sinn a-staigh roghainn a’ chànan, cleachdadh nam blocaichean agus chuid a thachartasan, can sàbhaladh, luchdadh is luchdadh suas pròiseict. Cha chruinnich sinn fiosrachadh pearsanta idir. Seall am {privacyPolicyLink} againn airson barrachd fiorachaidh.",
    "gui.telemetryOptIn.privacyPolicyLink": "Poileasaidh prìobhaideachd",
    "gui.telemetryOptIn.optInText": "Co-roinn dàta a’ chleachdaidh agam le sgioba Scratch",
    "gui.telemetryOptIn.optInTooltip": "Cuir an telemeatraidh an comas",
    "gui.telemetryOptIn.optOutText": "Na co-roinn dàta a’ chleachdaidh agam le sgioba Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Cuir an telemeatraidh à comas",
    "gui.telemetryOptIn.settingWasUpdated": "Chaidh an roghainn agad ùrachadh.",
    "gui.telemetryOptIn.buttonClose": "Dùin",
    "gui.turboMode.active": "Modh turbo",
    "gui.webglModal.label": "Cha chuir am brabhsair agad taic ri WebGL",
    "gui.webglModal.description": "Gu mì-fhortanach, tha coltas nach cuir am brabhsair no an coimpiutair agad {webGlLink}. Chan obraich Scratch 3.0 às aonais.",
    "gui.webglModal.webgllink": "taic ri WebGL",
    "gui.webglModal.back": "Air ais",
    "gui.webglModal.previewfaq": "Tadhail air {previewFaqLink} airson barrachd fiosrachaidh.",
    "gui.webglModal.previewfaqlinktext": "CÀBHA",
    "gui.costumeLibrary.chooseABackdrop": "Tagh cùlaibh",
    "gui.costumeLibrary.chooseACostume": "Tagh dreach",
    "gui.costumeTab.addBackdropFromLibrary": "Tagh cùlaibh",
    "gui.costumeTab.addCostumeFromLibrary": "Tagh dreach",
    "gui.costumeTab.addBlankCostume": "Peant",
    "gui.costumeTab.addSurpriseCostume": "Tagh fear dhomh",
    "gui.costumeTab.addFileBackdrop": "Luchdaich suas cùlaibh",
    "gui.costumeTab.addFileCostume": "Luchdaich suas dreach",
    "gui.extensionLibrary.chooseAnExtension": "Tagh leudachan",
    "gui.extensionLibrary.extensionUrl": "Cuir a‑steach URL an leudachain",
    "gui.monitors.importListColumnPrompt": "Dè an colbh (1-{numberOfColumns}) a bu chòir dhuinn cleachdadh?",
    "gui.recordingStep.alertMsg": "Cha b’ urrainn dhuinn tòiseachadh air a’ chlàradh",
    "gui.soundLibrary.chooseASound": "Tagh fuaim",
    "gui.soundTab.fileUploadSound": "Luchdaich suas fuaim",
    "gui.soundTab.surpriseSound": "Tagh tè dhomh",
    "gui.soundTab.recordSound": "Clàraich",
    "gui.soundTab.addSoundFromLibrary": "Tagh fuaim",
    "gui.spriteLibrary.chooseASprite": "Tagh sprìd",
    "gui.tipsLibrary.tutorials": "Tagh oideachadh",
    "gui.alerts.createsuccess": "Chaidh pròiseact ùr a chruthachadh.",
    "gui.alerts.createcopysuccess": "Chaidh am pròiseact a shàbhaladh mar lethbhreac.",
    "gui.alerts.createremixsuccess": "Chaidh am pròiseact a shàbhaladh mar ath-mheasgachadh.",
    "gui.alerts.creating": "A’ cruthachadh fear ùr…",
    "gui.alerts.creatingCopy": "A’ dèanamh lethbhreac den pròiseact…",
    "gui.alerts.creatingRemix": "Ag ath-mheasgachadh a’ phròiseict…",
    "gui.alerts.creatingError": "Cha b’ urrainn dhuinn am pròiseact a chruthachadh. Am feuch thu ris a-rithist?",
    "gui.alerts.savingError": "Cha b’ urrainn dhuinn am pròiseact a shàbhaladh.",
    "gui.alerts.savesuccess": "Chaidh am pròiseact a shàbhaladh.",
    "gui.alerts.saving": "A’ sàbhaladh a’ pròiseict…",
    "gui.alerts.cloudInfo": "Thoir an aire nach cuir caochladairean neòil taic ach ri àireamhan seach litrichean no samhlaidhean. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Barrachd fiosrachaidh.",
    "gui.alerts.importing": "Ga ion-phortadh…",
    "gui.defaultProject.meow": "Miamh",
    "gui.defaultProject.variable": "an caochladair agam",
    "gui.howtos.intro-move-sayhello-hat.name": "Dèan toiseach-tòiseachaidh",
    "gui.howtos.intro-move.step_stepMove": "Cuir bloca “gluais” ris",
    "gui.howtos.add-a-move-block.step_stepSay": "Cuir bloca “can” ris",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Briog air a’ bhratach uaine airson tòiseachadh",
    "gui.howtos.intro-getting-started-ASL.name": "Toiseach-tòiseachaidh – Cainnt-shanais Ameireagaidh",
    "gui.howtos.animate-a-name.name": "Beòthaich ainm",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Tagh sprìd litreach",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Cluich fuaim nuair a thèid briogadh air",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Tagh sprìd litreach eile",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Atharraich an dath",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Tagh sprìd litreach eile ⁊ cuir i car mu char",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Tagh sprìd litreach eile ⁊ thoir fàs oirre",
    "gui.howtos.imagine": "Cruthaich saoghal",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Sgrìobh na bu toil leat a ràdh",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Briog air a’ bhratach uaine airson tòiseachadh",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Tagh cùlaibh sam bith",
    "gui.howtos.imagine.step_imagineChooseSprite": "Tagh sprìd sam bith",
    "gui.howtos.imagine.step_imagineFlyAround": "Brùth air an iuchair Space airson gluasad",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Tagh sprìd eile",
    "gui.howtos.imagine.step_imagineLeftRight": "Gluais gu clì is deas",
    "gui.howtos.imagine.step_imagineUpDown": "Gluais suas is sìos",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Atharraich an dreach",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Gluais gu puing",
    "gui.howtos.imagine.step_imagineGrowShrink": "Fàs is crùb",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Tagh cùlaibh eile",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Atharraich an cùlaibh",
    "gui.howtos.imagine.step_imagineRecordASound": "Cuir fuaim ris",
    "gui.howtos.imagine.step_imagineChooseSound": "Tagh an fhuaim agad",
    "gui.howtos.make-music.name": "Cluich ceòl",
    "gui.howtos.Make-Music.step_PickInstrument": "Tagh sprìd inneil-chiùil",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Cluich fuaim nuair a thèid briogadh air",
    "gui.howtos.Make-Music.step_MakeSong": "Cruthaich òran",
    "gui.howtos.make-music.step_MakeBeat": "Tagh druma ⁊ cruthaich ruitheam",
    "gui.howtos.make-music.step_MakeBeatBox": "Tagh sprìd a’ mhicreofon ⁊ bogsa-buille iongnaidh",
    "gui.howtos.story.name": "Innis sgeulachd",
    "gui.howtos.story.step_addbg": "Cuir cùlaibh ris",
    "gui.howtos.story.step_addsprite": "Cuir pearsa ris",
    "gui.howtos.story.step_saysomething": "Bruidhinn",
    "gui.howtos.story.step_addanothersprite": "Cuir ris pearsa eile",
    "gui.howtos.story.step_flip": "Thoir flip air a’ chomhair",
    "gui.howtos.story.step_conversation": "Dèan còmhradh",
    "gui.howtos.story.addanotherbg": "Cuir cùlaibh eile ris",
    "gui.howtos.story.step_swithbg": "Atharraich an cùlaibh",
    "gui.howtos.story.step_hidewizard": "Falaich pearsa",
    "gui.howtos.story.step_showwizard": "Seall pearsa",
    "gui.howtos.make-a-chase-game.name": "Cruthaich geama seilg",
    "gui.howtos.Chase-Game.step_BG": "Cuir cùlaibh ris",
    "gui.howtos.chase-game.step_AddOcto": "Cuir sprìd ris",
    "gui.howtos.make-music.step_LeftRight": "Gluais gun taobh deas ⁊ chlì leis na h‑iuchraichean-saighde",
    "gui.howtos.Chase-Game.step_UpDown": "Gluais suas ⁊ sìos leis na h‑iuchraichean-saighde",
    "gui.howtos.Chase-Game.step_AddStar": "Cuir sprìd eile ris",
    "gui.howtos.Chase-Game.step_MoveRandom": "Gluais air thuaiream",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ann an sprìd an ochd-chasaich, cluich fuaim nuair a bhios e a’ beantainn ris",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Cruthaich caochladair sgòir",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ann an sprìd an ochd-chasaich, cuir ris an sgòr nuair a bhios e a’ beantainn ris",
    "gui.howtos.animate-char.name": "Beòthaich pearsa",
    "gui.howtos.animate-char.step_addbg": "Cuir cùlaibh ris",
    "gui.howtos.animate-char.step_addsprite": "Cuir sprìd ris",
    "gui.howtos.animate-char.step_saysomething": "Bruidhinn",
    "gui.howtos.animate-char.step_addsound": "Cuir fuaim ris",
    "gui.howtos.animate-char.step_animatetalking": "Beòthaich bruidhinn",
    "gui.howtos.animate-char.step_arrowkeys": "Gluais leis na h-iuchraichean saighde",
    "gui.howtos.animate-char.step_jump": "Thoir leum",
    "gui.howtos.animate-char.step_changecolor": "Atharrachadh an datha",
    "gui.howtos.make-a-game.name": "Cruthaich geama briogaidh",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Tagh sprìd",
    "gui.howtos.make-a-game.step_GamePlaySound": "Cluich fuaim nuair a thèid briogadh air",
    "gui.howtos.make-a-game.step_GameAddScore": "Cruthaich caochladair sgòir",
    "gui.howtos.make-a-game.step_GameChangeScore": "Meudaich an sgòr leis gach briogadh air",
    "gui.howtos.make-a-game.step_Random": "Rach gu ionad air thuaiream",
    "gui.howtos.make-music.step_GameChangeColor": "Atharrachadh an datha",
    "gui.howtos.make-music.step_ResetScore": "Ath-shuidhich an sgòr",
    "gui.howtos.make-it-fly.name": "Air sgèith",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Tagh cùlaibh speura",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Tagh pearsa",
    "gui.howtos.fly.step_stepflySaySomething": "Bruidhinn",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Gluais leis na h-iuchraichean saighde",
    "gui.howtos.fly.step_stepflyChooseObject": "Tagh nì ri chruinneachadh",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Thoir air an nì gluasad",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Tagh do phearsa",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Cuir sgòr ris",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Cuimhneachadh sgòir",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Cuir sealladh-dùthcha ris",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Gluais an sealladh-dùthcha",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "An t-ath-dhreach",
    "gui.howtos.pong": "Geama pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Cuir cùlaibh ris",
    "gui.howtos.pong.step_pongAddBallSprite": "Cuir sprìd bàla ris",
    "gui.howtos.pong.step_pongBounceAround": "Dèan bocadh",
    "gui.howtos.pong.step_pongAddPaddle": "Cuir pleadhag ris",
    "gui.howtos.pong.step_pongMoveThePaddle": "Gluais a’ phleadhag",
    "gui.howtos.pong.step_pongSelectBallSprite": "Tagh sprìd a’ bhàla",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Cuir ris còd ach am boc am bàla far na pleadhaige",
    "gui.howtos.pong.step_pongAddAScore": "Cuir sgòr ris",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Tagh “Sgòr” on chlàr-taice",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Cuir a-steach bloca “Atharraich an sgòr”",
    "gui.howtos.pong.step_pongResetScore": "Ath-shuidhich an sgòr",
    "gui.howtos.pong.step_pongAddLineSprite": "Cuir ris sprìd na loidhne",
    "gui.howtos.pong.step_pongGameOver": "Crìoch a’ gheama",
    "gui.howtos.code-cartoon": "Beòthaich cartùn",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Can rudeigin le briogadh air a’ bhratach uaine",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Beòthaich pearsa le briogadh air",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Tagh pearsa eile",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Cleachd samhla “toir air falbh” airson fàs nas lugha",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Thoir fàs is crùbadh air pearsa",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Tagh pearsa eile",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Leum suas is sìos",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Briog air pearsa airson gluasad gu sealladh eile",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Dèan gluasad",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Atharraich an dreach",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Tagh barrachd phearsachan a chuireas tu ris a’ chartùn agad",
    "gui.howtos.cartoon-network": "Beothaich dàna-thuras",
    "gui.howtos.cartoon-network.step_CNcharacter": "Tagh pearsa a sheallas tu",
    "gui.howtos.cartoon-network.step_CNsay": "Bruidhinn",
    "gui.howtos.cartoon-network.step_CNglide": "Dèan gluasad",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Tagh nì ri shealg",
    "gui.howtos.cartoon-network.step_CNcollect": "Cruinnich nithean",
    "gui.howtos.cartoon-network.step_CNvariable": "Cruthaich caochladair sgòir",
    "gui.howtos.cartoon-network.step_CNscore": "Cuimhneachadh sgòir",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Leibheil suas: atharraich an cùlaibhAtharraich an cùlaibh",
    "gui.howtos.videosens.name": "Mothachadh video",
    "gui.howtos.videosens.step_addextension": "Cuir leudachan ris",
    "gui.howtos.videosens.step_pet": "Tàlaidh an cat",
    "gui.howtos.videosens.step_animate": "Beothaich",
    "gui.howtos.videosens.step_pop": "Brag bailiùn",
    "gui.howtos.say-it-out-loud": "Beòthaich bruidhinn",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Cuir ris blocaichean “Teacsa na chainnt”",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Bruidhinn",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Suidhich guth",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Gabh ceum",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Cuir cùlaibh ris",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Cuir ris pearsa eile",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Gabh òran",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Atharrachadh an datha",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Dèan cuairteachadh",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Fàs is crùb",
    "gui.howtos.talking": "Sgeulachdan a bhruidhneas",
    "gui.howtos.talking.step_talesAddExtension": "Briog airson blocaichean “Teacsa na chainnt” a chur ris",
    "gui.howtos.talking.step_talesChooseSprite": "Tagh sprìd",
    "gui.howtos.talking.step_talesSaySomething": "Thoir bruidhinn air pearsa",
    "gui.howtos.talking.step_talesChooseBackdrop": "Tagh cùlaibh",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Briog air pearsa airson gluasad dhan ath-chùlaibh",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Tagh sprìd eile",
    "gui.howtos.talking.step_talesMoveAround": "Gabh ceum",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Tagh cùlaibh eile",
    "gui.howtos.talking.step_talesAnimateTalking": "Beòthaich bruidhinn",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Tagh cùlaibh eile",
    "gui.howtos.talking.step_talesChooseSound": "Tagh òran airson dannsa",
    "gui.howtos.talking.step_talesDanceMoves": "Gluasadan dannsa",
    "gui.howtos.talking.step_talesAskAnswer": "Faigh blocaichean “faighnich is fan” agus “freagairt” on roinn-seòrsa “Mothachadh”",
    "gui.howtos.add-sprite.name": "Cuir sprìd ris",
    "gui.howtos.add-sprite.step_addSprite": "Cuir sprìd ris",
    "gui.howtos.add-a-backdrop.name": "Cuir cùlaibh ris",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Cuir cùlaibh ris",
    "gui.howtos.change-size.name": "Atharraich am meud",
    "gui.howtos.change-size.step_changeSize": "Atharraich am meud",
    "gui.howtos.glide-around.name": "Dèan gluasad",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Dèan gluasad",
    "gui.howtos.change-size.step_glideAroundPoint": "Gluais gu puing",
    "gui.howtos.record-a-sound.name": "Clàraich fuaim",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Briog air a taba “Fuaimean”",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Briog air “Clàraich”",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Brùth air a’ phutan “Clàraich”",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Tagh an fhuaim agad",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Cluich an fhuaim agad",
    "gui.howtos.spin-video.name": "Cuir e car mu char",
    "gui.howtos.change-size.step_spinTurn": "Cuairtich",
    "gui.howtos.change-size.step_spinPointInDirection": "Suidhich a’ chomhair",
    "gui.howtos.hide-and-show.name": "Falaich is seall",
    "gui.howtos.change-size.step_hideAndShow": "Falaich is seall",
    "gui.howtos.switch-costume.name": "Beòthaich sprìd",
    "gui.howtos.change-size.step_switchCostumes": "Beòthaich sprìd",
    "gui.howtos.move-around-with-arrow-keys.name": "Cleachd iuchair-saighde",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Gluais gu clì is deas",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Gluais suas is sìos",
    "gui.howtos.add-effects.name": "Cuir èifeachdan ris",
    "gui.howtos.videosens.step_addEffects": "Cuir èifeachdan ris",
    "gui.extension.music.name": "Ceòl",
    "gui.extension.music.description": "Cluich innealan-ciùil is drumaichean.",
    "gui.extension.pen.name": "Peann",
    "gui.extension.pen.description": "Tarraing leis na sprìdean agad.",
    "gui.extension.videosensing.name": "Mothachadh video",
    "gui.extension.videosensing.description": "Mothaich do ghluasad leis a’ chamara.",
    "gui.extension.text2speech.name": "Teacsa na chainnt",
    "gui.extension.text2speech.description": "Cuir comas bruidhinn air na pròiseactan agad.",
    "gui.extension.translate.name": "Eadar-theangaich",
    "gui.extension.translate.description": "Eadar-theangaich teacsa gu iomadh cànan.",
    "gui.extension.makeymakey.description": "Dèan iuchair de rud sam bith.",
    "gui.extension.microbit.description": "Ceanglaich na pròiseactan agad ris an t-saoghal.",
    "gui.extension.microbit.connectingMessage": "Ceangal",
    "gui.extension.ev3.description": "Tog robotairean eadar-ghnìomhach is a bharrachd.",
    "gui.extension.ev3.connectingMessage": "’Ga cheangal. Dèan cinnteach gun deach am PIN aig an EV3 agad a shuidheachadh air 1234.",
    "gui.extension.boost.description": "Beòthaich robotairean.",
    "gui.extension.boost.connectingMessage": "Ceangal",
    "gui.extension.wedo2.description": "Tog nithean le einnseanan is mothaichearan.",
    "gui.extension.wedo2.connectingMessage": "Ceangal",
    "gui.extension.gdxfor.description": "Mothaich do bhrùthadh, tarraing, gluasad is cuairteachadh.",
    "gui.extension.gdxfor.connectingMessage": "Ceangal",
    "gui.libraryTags.all": "Na h-uile",
    "gui.libraryTags.animals": "Beathaichean",
    "gui.libraryTags.dance": "Dannsa",
    "gui.libraryTags.effects": "Èifeachdan",
    "gui.libraryTags.fantasy": "Fantastachd",
    "gui.libraryTags.fashion": "Fasan",
    "gui.libraryTags.food": "Biadh",
    "gui.libraryTags.indoors": "Taobh a-staigh",
    "gui.libraryTags.loops": "Lùban",
    "gui.libraryTags.music": "Ceòl",
    "gui.libraryTags.notes": "Pongan",
    "gui.libraryTags.outdoors": "Taobh a-muigh",
    "gui.libraryTags.patterns": "Pàtranan",
    "gui.libraryTags.people": "Daoine",
    "gui.libraryTags.percussion": "Beum-ionnsramaid",
    "gui.libraryTags.space": "Fànas",
    "gui.libraryTags.sports": "Spòrs",
    "gui.libraryTags.underwater": "Fon uisge",
    "gui.libraryTags.voice": "Guth",
    "gui.libraryTags.wacky": "Èibhinn",
    "gui.libraryTags.animation": "Beòthachadh",
    "gui.libraryTags.art": "Ealan",
    "gui.libraryTags.games": "Geamannan",
    "gui.libraryTags.stories": "Sgeòil",
    "gui.libraryTags.letters": "Litrichean",
    "gui.opcodeLabels.direction": "comhair",
    "gui.opcodeLabels.xposition": "ionad x",
    "gui.opcodeLabels.yposition": "ionad y",
    "gui.opcodeLabels.size": "meud",
    "gui.opcodeLabels.costumename": "ainm an dreacha",
    "gui.opcodeLabels.costumenumber": "àireamh an dreacha",
    "gui.opcodeLabels.backdropname": "ainm a’ chùlaibh",
    "gui.opcodeLabels.backdropnumber": "àireamh a’ chùlaibh",
    "gui.opcodeLabels.volume": "àirde na fuaime",
    "gui.opcodeLabels.tempo": "luaths",
    "gui.opcodeLabels.answer": "freagairt",
    "gui.opcodeLabels.loudness": "àirde na fuaime",
    "gui.opcodeLabels.username": "ainm-cleachdaiche",
    "gui.opcodeLabels.year": "am bliadhna",
    "gui.opcodeLabels.month": "am mìos",
    "gui.opcodeLabels.date": "an ceann-là",
    "gui.opcodeLabels.dayofweek": "latha na seachdaine",
    "gui.opcodeLabels.hour": "an uair",
    "gui.opcodeLabels.minute": "a’ mhionaid",
    "gui.opcodeLabels.second": "an diog",
    "gui.opcodeLabels.timer": "an tìmear",
    "gui.projectLoader.loadError": "Dh’fhàillig le luchdadh faidhle a’ phròiseict a thagh thu.",
    "gui.sharedMessages.backdrop": "cùlaibh{index}",
    "gui.sharedMessages.costume": "dreach{index}",
    "gui.sharedMessages.sprite": "Sprìd{index}",
    "gui.sharedMessages.pop": "cnap",
    "gui.sharedMessages.replaceProjectWarning": "A bheil thu airson seo a chur an àite susbaint a’ phròiseict làithrich?",
    "gui.sharedMessages.loadFromComputerTitle": "Luchdaich on choimpiutair agad",
    "gui.theme.default": "Tùsail",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "Iomsgaradh àrd",
    "gui.gui.defaultProjectTitle": "Pròiseact Scratch",
    "boost.color.any": "sam bith",
    "boost.color.black": "dhubh",
    "boost.color.blue": "ghorm",
    "boost.color.green": "uaine",
    "boost.color.red": "dhearg",
    "boost.color.white": "gheal",
    "boost.color.yellow": "bhuidhe",
    "boost.getMotorPosition": "ionad a’ mhotair [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "ceàrn claonaidh [TILT_DIRECTION]",
    "boost.motorDirection.backward": "an dàrna taobh",
    "boost.motorDirection.forward": "an taobh eile",
    "boost.motorDirection.reverse": "comhair contrarra",
    "boost.motorOff": "cuir motar [MOTOR_ID] dheth",
    "boost.motorOn": "cuir motar [MOTOR_ID] air",
    "boost.motorOnFor": "cuairtich motar [MOTOR_ID] fad [DURATION] diog",
    "boost.motorOnForRotation": "cuir [ROTATION] car air motar [MOTOR_ID]",
    "boost.seeingColor": "thu a’ faicinn breige [COLOR]",
    "boost.setLightHue": "suidhich dath an t-solais air [HUE]",
    "boost.setMotorDirection": "cuir motar [MOTOR_ID] an comhair [MOTOR_DIRECTION]",
    "boost.setMotorPower": "suidhich luaths a’ mhotair [MOTOR_ID] air [POWER] %",
    "boost.tiltDirection.any": "sam bith",
    "boost.tiltDirection.down": "sìos",
    "boost.tiltDirection.left": "gu clì",
    "boost.tiltDirection.right": "gu deas",
    "boost.tiltDirection.up": "suas",
    "boost.whenColor": "nuair a chì thu breige [COLOR]",
    "boost.whenTilted": "le claonadh [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "bìd pong [NOTE] fad [TIME] diog",
    "ev3.buttonPressed": "putan [PORT] ga bhrùthadh",
    "ev3.getBrightness": "soilleireachd",
    "ev3.getDistance": "astar",
    "ev3.getMotorPosition": "ionad a’ mhotair [PORT]",
    "ev3.motorSetPower": "suidhich cumhachd motar [PORT] air [POWER] %",
    "ev3.motorTurnClockwise": "gluais motar [PORT] dhan dàrna taobh fad [TIME] diog",
    "ev3.motorTurnCounterClockwise": "gluais motar [PORT] dhan taobh eile fad [TIME] diog",
    "ev3.whenBrightnessLessThan": "nuair a thèid an t-soilleireachd < [DISTANCE]",
    "ev3.whenButtonPressed": "le brùthadh air putan [PORT]",
    "ev3.whenDistanceLessThan": "nuair a thèid an t-astar < [DISTANCE]",
    "gdxfor.getAcceleration": "luathachadh [DIRECTION]",
    "gdxfor.getForce": "forsa",
    "gdxfor.getSpin": "luaths a’ chuir [DIRECTION]",
    "gdxfor.getTilt": "ceàrn claonaidh [TILT]",
    "gdxfor.isFreeFalling": "a’ tuiteam",
    "gdxfor.isTilted": "claonadh [TILT] air",
    "gdxfor.pulled": "tarraing",
    "gdxfor.pushed": "brùthadh",
    "gdxfor.shaken": "crith",
    "gdxfor.startedFalling": "tòiseachadh tuiteim",
    "gdxfor.tiltDirectionMenu.any": "sam bith",
    "gdxfor.tiltDirectionMenu.back": "dhan chùlaibh",
    "gdxfor.tiltDirectionMenu.front": "dhan bheulaibh",
    "gdxfor.tiltDirectionMenu.left": "gu clì",
    "gdxfor.tiltDirectionMenu.right": "gu deas",
    "gdxfor.turnedFaceDown": "beul fodha",
    "gdxfor.turnedFaceUp": "aghaidh os a chionn",
    "gdxfor.whenForcePushedOrPulled": "le [PUSH_PULL] air mothaichear an fhorsa",
    "gdxfor.whenGesture": "le mothachadh air [GESTURE]",
    "gdxfor.whenTilted": "le claonadh [TILT]",
    "makeymakey.downArrow": "saighead sìos",
    "makeymakey.downArrowShort": "sìos",
    "makeymakey.leftArrow": "saighead gu clì",
    "makeymakey.leftArrowShort": "gu clì",
    "makeymakey.rightArrow": "saighead gu deas",
    "makeymakey.rightArrowShort": "gu deas",
    "makeymakey.spaceKey": "spàs",
    "makeymakey.upArrow": "saighead suas",
    "makeymakey.upArrowShort": "suas",
    "makeymakey.whenKeyPressed": "le brùthadh iuchrach [KEY]",
    "makeymakey.whenKeysPressedInOrder": "nuair a bhrùthar air [SEQUENCE] às dèidh a chèile",
    "microbit.buttonsMenu.any": "sam bith",
    "microbit.clearDisplay": "falamhaich an sgrìn",
    "microbit.defaultTextToDisplay": "Shin thu!",
    "microbit.displaySymbol": "seall [MATRIX]",
    "microbit.displayText": "seall an teacsa [TEXT]",
    "microbit.gesturesMenu.jumped": "leum",
    "microbit.gesturesMenu.moved": "gluasad",
    "microbit.gesturesMenu.shaken": "crith",
    "microbit.isButtonPressed": "putan [BTN] ga bhrùthadh",
    "microbit.isTilted": "claonadh [DIRECTION] air",
    "microbit.pinStateMenu.off": "dheth",
    "microbit.pinStateMenu.on": "air",
    "microbit.tiltAngle": "ceàrn claonaidh [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "sam bith",
    "microbit.tiltDirectionMenu.back": "dhan chùlaibh",
    "microbit.tiltDirectionMenu.front": "dhan bheulaibh",
    "microbit.tiltDirectionMenu.left": "gu clì",
    "microbit.tiltDirectionMenu.right": "gu deas",
    "microbit.whenButtonPressed": "le brùthadh air putan [BTN]",
    "microbit.whenGesture": "le mothachadh air [GESTURE]",
    "microbit.whenPinConnected": "nuair a thèid prìne [PIN] a cheangal",
    "microbit.whenTilted": "le claonadh [DIRECTION]",
    "music.categoryName": "Ceòl",
    "music.changeTempo": "atharraich an luaths le [TEMPO]",
    "music.drumBass": "(2) Beus-dhruma",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Hi-hat dùinte",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Clag bà",
    "music.drumCrashCymbal": "(4) Ciombal crash",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Bualadh bhasan",
    "music.drumOpenHiHat": "(5) Hi-hat fosgailte",
    "music.drumSideStick": "(3) Taobh biorain",
    "music.drumSnare": "(1) Druma-tormain",
    "music.drumTambourine": "(7) Guit-dhruma",
    "music.drumTriangle": "(12) Triantan",
    "music.drumVibraslap": "(17) Crith-sgleog",
    "music.drumWoodBlock": "(10) Bloca fiodha",
    "music.getTempo": "luaths",
    "music.instrumentBass": "(6) Beus",
    "music.instrumentBassoon": "(14) Torm-fheadan",
    "music.instrumentCello": "(8) Beus-fhìdheall",
    "music.instrumentChoir": "(15) Còisir",
    "music.instrumentClarinet": "(10) Clàirneid",
    "music.instrumentElectricGuitar": "(5) Giotàr dealain",
    "music.instrumentElectricPiano": "(2) Piàno dealain",
    "music.instrumentFlute": "(12) Duiseal",
    "music.instrumentGuitar": "(4) Giotàr",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Bogsa-ciùil",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piàno",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Sacsafon",
    "music.instrumentSteelDrum": "(18) Druma stàillinn",
    "music.instrumentSynthLead": "(20) Sinteisear seirme",
    "music.instrumentSynthPad": "(21) Sinteisear pada",
    "music.instrumentTrombone": "(9) Trompan",
    "music.instrumentVibraphone": "(16) Critheafon",
    "music.instrumentWoodenFlute": "(13) Duiseal fiodha",
    "music.midiPlayDrumForBeats": "cluich druma [DRUM] fad [BEATS] buille",
    "music.midiSetInstrument": "suidhich an t‑inneal-ciùil air [INSTRUMENT]",
    "music.playDrumForBeats": "cluich druma [DRUM] fad [BEATS] buille",
    "music.playNoteForBeats": "cluich pong [NOTE] fad [BEATS] buille",
    "music.restForBeats": "tost fad [BEATS] buille",
    "music.setInstrument": "suidhich an t‑inneal-ciùil air [INSTRUMENT]",
    "music.setTempo": "suidhich an luaths air [TEMPO]",
    "pen.categoryName": "Peann",
    "pen.changeColorParam": "atharraich [COLOR_PARAM] a’ phinn le [VALUE]",
    "pen.changeHue": "atharraich dath a’ phinn le [HUE]",
    "pen.changeShade": "atharraich tuar a’ phinn le [SHADE]",
    "pen.changeSize": "atharraich meud a’ phinn le [SIZE]",
    "pen.clear": "suath às na h‑uile",
    "pen.colorMenu.brightness": "soilleireachd",
    "pen.colorMenu.color": "dath",
    "pen.colorMenu.saturation": "sàthachd",
    "pen.colorMenu.transparency": "trìd-shoillearachd",
    "pen.penDown": "peann sìos",
    "pen.penUp": "peann suas",
    "pen.setColor": "suidhich dath a’ phinn air [COLOR]",
    "pen.setColorParam": "suidhich [COLOR_PARAM] a’ phinn air [VALUE]",
    "pen.setHue": "suidhich dath a’ phinn air [HUE]",
    "pen.setShade": "suidhich tuar a’ phinn air [SHADE]",
    "pen.setSize": "suidhich meud a’ phinn air [SIZE]",
    "pen.stamp": "stampa",
    "speech.defaultWhenIHearValue": "tiugainn",
    "speech.extensionName": "Cainnt na theacsa",
    "speech.listenAndWait": "èist is fan",
    "speech.speechReporter": "cainnt",
    "speech.whenIHear": "nuair a chluinneas mi [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Teacsa na chainnt",
    "text2speech.defaultTextToSpeak": "shin thu",
    "text2speech.giant": "famhair",
    "text2speech.kitten": "piseag",
    "text2speech.setLanguageBlock": "suidhich an cànan air [LANGUAGE]",
    "text2speech.setVoiceBlock": "suidhich a’ ghuth air [VOICE]",
    "text2speech.speakAndWaitBlock": "can [WORDS] gu h-àrd",
    "text2speech.squeak": "bìog",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Eadar-theangaich",
    "translate.defaultTextToTranslate": "shin thu",
    "translate.translateBlock": "eadar-theangaich [WORDS] gu [LANGUAGE]",
    "translate.viewerLanguage": "cànan",
    "videoSensing.categoryName": "Mothachadh video",
    "videoSensing.direction": "comhair",
    "videoSensing.motion": "gluasad",
    "videoSensing.off": "dheth",
    "videoSensing.on": "air",
    "videoSensing.onFlipped": "air, le flip",
    "videoSensing.setVideoTransparency": "suidhich trìd-shoillse a’ video air [TRANSPARENCY]",
    "videoSensing.sprite": "an sprìd",
    "videoSensing.stage": "an àrd-ùrlar",
    "videoSensing.videoOn": "[ATTRIBUTE] a’ video air [SUBJECT]",
    "videoSensing.videoToggle": "cuir a’ video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "nuair a thèid gluasad a’ video > [REFERENCE]",
    "wedo2.getDistance": "astar",
    "wedo2.getTiltAngle": "ceàrn claonaidh [TILT_DIRECTION]",
    "wedo2.isTilted": "claonadh [TILT_DIRECTION_ANY] air",
    "wedo2.motorDirection.backward": "an dàrna taobh",
    "wedo2.motorDirection.forward": "an taobh eile",
    "wedo2.motorDirection.reverse": "comhair contrarra",
    "wedo2.motorId.a": "motar A",
    "wedo2.motorId.all": "a h-uile motar",
    "wedo2.motorId.b": "motar B",
    "wedo2.motorId.default": "motar",
    "wedo2.motorOff": "cuir [MOTOR_ID] dheth",
    "wedo2.motorOn": "cuir [MOTOR_ID] air",
    "wedo2.motorOnFor": "cuir [MOTOR_ID] air fad [DURATION] diog",
    "wedo2.playNoteFor": "cluich pong [NOTE] fad [DURATION] diog",
    "wedo2.setLightHue": "suidhich dath an t-solais air [HUE]",
    "wedo2.setMotorDirection": "suidhich comhair [MOTOR_ID] air [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "suidhich cumhachd [MOTOR_ID] air [POWER]",
    "wedo2.tiltDirection.any": "sam bith",
    "wedo2.tiltDirection.down": "sìos",
    "wedo2.tiltDirection.left": "gu clì",
    "wedo2.tiltDirection.right": "gu deas",
    "wedo2.tiltDirection.up": "suas",
    "wedo2.whenDistance": "nuair a thèid an t-astar [OP] [REFERENCE]",
    "wedo2.whenTilted": "le claonadh [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Dath",
    "paint.paintEditor.saturation": "Sàthachd",
    "paint.paintEditor.brightness": "Soilleireachd",
    "paint.paintEditor.costume": "Dreach",
    "paint.paintEditor.group": "Buidhnich",
    "paint.paintEditor.ungroup": "Sgaoil am buidheann",
    "paint.paintEditor.undo": "Neo-dhèan",
    "paint.paintEditor.redo": "Ath-dhèan",
    "paint.paintEditor.forward": "Gluais an comhair a’ bheòil",
    "paint.paintEditor.backward": "Gluais an comhair a’ chùil",
    "paint.paintEditor.front": "Gluais dhan fhìor-bheulaibh",
    "paint.paintEditor.back": "Gluais dhan fhìor-chùlaibh",
    "paint.paintEditor.more": "Barrachd",
    "paint.modeTools.brushSize": "Meud na bruise",
    "paint.modeTools.eraserSize": "Meud an t‑suathain",
    "paint.modeTools.copy": "Dèan lethbhreac",
    "paint.modeTools.paste": "Cuir ann",
    "paint.modeTools.delete": "Sguab às",
    "paint.modeTools.curved": "Cruinn",
    "paint.modeTools.pointed": "Biorach",
    "paint.modeTools.thickness": "Tiughad",
    "paint.modeTools.flipHorizontal": "Flip air a’ chòmhnard",
    "paint.modeTools.flipVertical": "Flip gu h‑inghearach",
    "paint.modeTools.filled": "Lìonta",
    "paint.modeTools.outlined": "Oir‑loidhne",
    "paint.paintEditor.bitmap": "Iompaich na bitmap",
    "paint.paintEditor.vector": "Iompaich na vector",
    "paint.paintEditor.fill": "Lìonadh",
    "paint.paintEditor.stroke": "Oir‑loidhne",
    "paint.brushMode.brush": "Bruis",
    "paint.eraserMode.eraser": "Suathan",
    "paint.fillMode.fill": "Lìonadh",
    "paint.lineMode.line": "Loidhne",
    "paint.ovalMode.oval": "Cearcall",
    "paint.rectMode.rect": "Ceart-cheàrnach",
    "paint.reshapeMode.reshape": "Cumadh",
    "paint.roundedRectMode.roundedRect": "Ceart-cheàrnach cruinnte",
    "paint.selectMode.select": "Tagh",
    "paint.textMode.text": "Teacsa",
    "paint.colorPicker.swap": "Suaip"
  },
  "gl": {
    "gui.alerts.lostPeripheralConnection": "Scratch perdeu a conexión con {extensionName}.",
    "gui.alerts.tryAgain": "Téntao de novo",
    "gui.alerts.download": "Descargar",
    "gui.connection.reconnect": "Reconectar",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "son",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Mochila",
    "gui.backpack.errorBackpack": "Produciuse un erro ao cargar a mochila",
    "gui.backpack.loadingBackpack": "A cargar...",
    "gui.backpack.more": "Máis",
    "gui.backpack.emptyBackpack": "A mochila está baleira",
    "gui.unsupportedBrowser.label": "Este navegador non é compatíbel",
    "gui.unsupportedBrowser.errorLabel": "Produciuse un erro",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Atrás",
    "gui.unsupportedBrowser.previewfaq": "Para aprender máis, vai a {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Preguntas frecuentes",
    "gui.cards.all-tutorials": "Titoriais",
    "gui.cards.shrink": "Recoller",
    "gui.cards.expand": "Estender",
    "gui.cards.close": "Pechar",
    "gui.cards.more-things-to-try": "Máis cousas coas que experimentar!",
    "gui.cards.see-more": "Ver máis",
    "gui.comingSoon.message1": "Non te preocupes, andamos niso {emoji}",
    "gui.comingSoon.message2": "Proximamente...",
    "gui.comingSoon.message3": "Andamos a traballar nisto {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Non se atopou ningún dispositivo",
    "gui.connection.auto-scanning.prescan": "Pon o dispositivo preto e comeza a buscar.",
    "gui.connection.auto-scanning.pressbutton": "Preme o botón do dispositivo.",
    "gui.connection.auto-scanning.start-search": "Comeza a buscar",
    "gui.connection.connecting-searchbutton": "A buscar...",
    "gui.connection.auto-scanning.try-again": "Téntao de novo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Conectado",
    "gui.connection.disconnect": "Desconectar",
    "gui.connection.go-to-editor": "Ir ao editor",
    "gui.connection.connecting-cancelbutton": "A conectar...",
    "gui.connection.error.errorMessage": "Vaites! Parece que algo foi mal.",
    "gui.connection.error.tryagainbutton": "Téntao de novo",
    "gui.connection.error.helpbutton": "Axuda",
    "gui.connection.peripheral-name-label": "Nome do dispositivo",
    "gui.connection.connect": "Conectar",
    "gui.connection.scanning.lookingforperipherals": "A buscar dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "Non se atopou ningún dispositivo",
    "gui.connection.scanning.instructions": "Selecciona o dispositivo na lista de arriba.",
    "gui.connection.search": "Actualizar",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Comproba que Scratch Link estea instalado e en execución",
    "gui.connection.unavailable.enablebluetooth": "Comproba que o Bluetooth estea activado",
    "gui.connection.unavailable.tryagainbutton": "Téntao de novo",
    "gui.connection.unavailable.helpbutton": "Axuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ir",
    "gui.controls.stop": "Parar",
    "gui.crashMessage.label": "Vaites! Algo vai mal.",
    "gui.crashMessage.description": "Desculpa! Aparentemente, o Scratch fallou. O Equipo de Scratch acaba de recibir información sobre este erro. Actualiza a páxina para tentalo de novo.",
    "gui.crashMessage.errorNumber": "Informouse do fallo, con id {errorId}",
    "gui.crashMessage.reload": "Actualizar",
    "gui.customProcedures.myblockModalTitle": "Crear un bloque",
    "gui.customProcedures.addAnInputNumberText": "Engadir unha entrada",
    "gui.customProcedures.numberTextType": "número ou texto",
    "gui.customProcedures.addAnInputBoolean": "Engadir unha entrada",
    "gui.customProcedures.booleanType": "booleana",
    "gui.customProcedures.addALabel": "Engadir unha etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Executar sen actualizar a pantalla",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "Aceptar",
    "gui.SpriteInfo.direction": "Dirección",
    "gui.directionPicker.rotationStyles.allAround": "En todas as direccións",
    "gui.directionPicker.rotationStyles.leftRight": "Esquerda/Dereita",
    "gui.directionPicker.rotationStyles.dontRotate": "Non rotar",
    "gui.gui.addExtension": "Engadir extensión",
    "gui.gui.codeTab": "Código",
    "gui.gui.backdropsTab": "Fondos",
    "gui.gui.costumesTab": "Traxes",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Proximamente",
    "gui.extensionLibrary.requires": "Require",
    "gui.extensionLibrary.collaboration": "En colaboración con",
    "gui.library.filterPlaceholder": "Buscar",
    "gui.library.allTag": "Todos",
    "gui.loader.message1": "A crear os bloques ...",
    "gui.loader.message2": "A cargar as figuras ...",
    "gui.loader.message3": "A cargar os sons...",
    "gui.loader.message4": "A cargar as extensións ...",
    "gui.loader.message5": "O amor que arde de présa consómese logo...",
    "gui.loader.message6": "Boa vida non quer présa...",
    "gui.loader.message7": "Canta máis présa máis vagar ...",
    "gui.loader.message8": "A preparar os emojis ...",
    "gui.loader.headline": "Estase a cargar o proxecto",
    "gui.loader.creating": "Creando proxecto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "As miñas cousas",
    "gui.accountMenu.myClasses": "As miñas clases",
    "gui.accountMenu.myClass": "A miña clase",
    "gui.accountMenu.accountSettings": "Configuración da conta",
    "gui.accountMenu.signOut": "Saír",
    "gui.authorInfo.byUser": "de {username}",
    "gui.menuBar.seeProjectPage": "Ver a páxina do proxecto",
    "gui.menuBar.language": "Language",
    "general.username": "Nome de usuario",
    "general.password": "Contrasinal",
    "general.signIn": "Entrar",
    "login.needHelp": "Precisas axuda?",
    "form.validationRequired": "Este campo é necesario",
    "gui.menuBar.tutorialsLibrary": "Titoriais",
    "gui.menuBar.restoreSprite": "Restaurar a figura",
    "gui.menuBar.restoreSound": "Restaurar o son",
    "gui.menuBar.restoreCostume": "Restaurar o traxe",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Gardar agora",
    "gui.menuBar.saveAsCopy": "Gardar como copia",
    "gui.menuBar.remix": "Mesturar",
    "gui.menuBar.new": "Novo",
    "gui.menuBar.file": "Ficheiro",
    "gui.menuBar.downloadToComputer": "Gardar no teu ordenador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desactivar o modo turbo",
    "gui.menuBar.turboModeOn": "Activar o modo turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Únete a Scratch",
    "gui.menuBar.signIn": "Entrar",
    "gui.gui.projectTitlePlaceholder": "Aquí o título do proxecto",
    "gui.menuBar.saveNowLink": "Gardar agora",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Compartidos",
    "gui.menuBar.share": "Compartir",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Axuda",
    "gui.modal.back": "Atrás",
    "gui.monitor.listMonitor.empty": "(baleiro)",
    "gui.monitor.listMonitor.listLength": "lonxitude {length}",
    "gui.monitor.contextMenu.default": "tamaño normal",
    "gui.monitor.contextMenu.large": "tamaño grande",
    "gui.monitor.contextMenu.slider": "barra de desprazamento",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Reproducir",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Para todas as figuras",
    "gui.gui.variableScopeOptionSpriteOnly": "Só para esta figura",
    "gui.gui.cloudVariableOption": "Variábel na nube (gardada no servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variábel aplícase a todas as figuras.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "Aceptar",
    "gui.playbackStep.stopMsg": "Parar",
    "gui.playbackStep.playMsg": "Reproducir",
    "gui.playbackStep.loadingMsg": "A cargar...",
    "gui.playbackStep.saveMsg": "Gardar",
    "gui.playbackStep.reRecordMsg": "Gravar outra vez",
    "gui.recordModal.title": "Gravar son",
    "gui.recordingStep.beginRecord": "Comeza a gravar premendo o botón de embaixo",
    "gui.recordingStep.permission": "{arrow}Precisamos do teu permiso para usarmos o micrófono",
    "gui.recordingStep.stop": "Parar de gravar",
    "gui.recordingStep.record": "Gravar",
    "gui.sliderModal.min": "Valor mínimo",
    "gui.sliderModal.max": "Valor máximo",
    "gui.sliderModal.title": "Cambiar o rango da barra de desprazamento",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "Aceptar",
    "gui.soundEditor.sound": "Son",
    "gui.soundEditor.play": "Reproducir",
    "gui.soundEditor.stop": "Parar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Pegar",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Eliminar",
    "gui.soundEditor.save": "Gardar",
    "gui.soundEditor.undo": "Desfacer",
    "gui.soundEditor.redo": "Refacer",
    "gui.soundEditor.faster": "Máis rápido",
    "gui.soundEditor.slower": "Máis lento",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Máis forte",
    "gui.soundEditor.softer": "Máis suave",
    "gui.soundEditor.reverse": "Reverter",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nome",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Figura",
    "gui.SpriteInfo.show": "Amosar",
    "gui.SpriteInfo.size": "Tamaño",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "eliminar",
    "gui.spriteSelector.addSpriteFromLibrary": "Escoller unha figura",
    "gui.spriteSelector.addSpriteFromPaint": "Pintar",
    "gui.spriteSelector.addSpriteFromSurprise": "Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Cargar unha figura",
    "gui.stageHeader.stageSizeLarge": "Pasar a un escenario grande",
    "gui.stageHeader.stageSizeSmall": "Pasar a un escenario pequeno",
    "gui.stageHeader.stageSizeFull": "Entrar no modo de pantalla completa",
    "gui.stageHeader.stageSizeUnFull": "Saír do modo de pantalla completa",
    "gui.stageHeader.fullscreenControl": "Control de pantalla completa",
    "gui.spriteSelector.addBackdropFromLibrary": "Escoller un fondo",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Cargar un fondo",
    "gui.stageSelector.stage": "Escenario",
    "gui.stageSelector.backdrops": "Fondos",
    "gui.telemetryOptIn.label": "Informar de estatísticas para mellorar o Scratch",
    "gui.telemetryOptIn.body1": "O Equipo de Scratch está sempre tentando comprender mellor como se usa Scratch no mundo. Para axudar con este esforzo podes permitir que Scratch lle envíe automaticamente información de uso ao Equipo de Scratch.",
    "gui.telemetryOptIn.body2": "A información que recollemos inclúe o idioma, os bloques utilizados e algúns actos como gardar, cargar e subir proxectos. NON recollemos información persoal. Consulta a nosa {privacyPolicyLink} para máis información.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de privacidade",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "O navegador non admite WebGL",
    "gui.webglModal.description": "Desafortunadamente parece que o navegador ou o computador {webGlLink}. Esta tecnoloxía é necesaria para executar Scratch 3.0.",
    "gui.webglModal.webgllink": "non é compatíbel con WebGL",
    "gui.webglModal.back": "Atrás",
    "gui.webglModal.previewfaq": "Para aprender máis, vai a {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Preguntas frecuentes",
    "gui.costumeLibrary.chooseABackdrop": "Escoller un fondo",
    "gui.costumeLibrary.chooseACostume": "Escoller un traxe",
    "gui.costumeTab.addBackdropFromLibrary": "Escoller un fondo",
    "gui.costumeTab.addCostumeFromLibrary": "Escoller un traxe",
    "gui.costumeTab.addBlankCostume": "Pintar",
    "gui.costumeTab.addSurpriseCostume": "Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Cargar un fondo",
    "gui.costumeTab.addFileCostume": "Cargar un traxe",
    "gui.extensionLibrary.chooseAnExtension": "Escoller unha extensión",
    "gui.extensionLibrary.extensionUrl": "Introduce o URL da extensión",
    "gui.monitors.importListColumnPrompt": "Cal columna debe usarse (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Non foi posíbel comezar a gravar",
    "gui.soundLibrary.chooseASound": "Escoller un son",
    "gui.soundTab.fileUploadSound": "Cargar un son",
    "gui.soundTab.surpriseSound": "Sorpresa",
    "gui.soundTab.recordSound": "Gravar",
    "gui.soundTab.addSoundFromLibrary": "Escoller un son",
    "gui.spriteLibrary.chooseASprite": "Escoller unha figura",
    "gui.tipsLibrary.tutorials": "Escoller un titorial",
    "gui.alerts.createsuccess": "Creouse o novo proxecto.",
    "gui.alerts.createcopysuccess": "O proxecto gardouse como unha copia.",
    "gui.alerts.createremixsuccess": "O proxecto gardouse como unha recreación.",
    "gui.alerts.creating": "Creando o novo proxecto...",
    "gui.alerts.creatingCopy": "Copiando o proxecto...",
    "gui.alerts.creatingRemix": "Recreando o proxecto...",
    "gui.alerts.creatingError": "Non foi posíbel crear o proxecto. Téntao de novo.",
    "gui.alerts.savingError": "Non foi posíbel gardar o proxecto.",
    "gui.alerts.savesuccess": "Proxecto gardado.",
    "gui.alerts.saving": "Gardando o proxecto...",
    "gui.alerts.cloudInfo": "Por favor ten en conta que as variables na nube só aceptan números, non letras nin símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Saber máis.",
    "gui.alerts.importing": "Estase a importar...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "a miña variábel",
    "gui.howtos.intro-move-sayhello-hat.name": "Primeiros pasos",
    "gui.howtos.intro-move.step_stepMove": "Engade un bloque de mover",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Preme na bandeira verde para comezar",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Anima un nome",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Escolle unha  letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Toca un son cando a premas",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Escolle outra letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambialle a cor",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Escolle outra letra e faina xirar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Escolle outra letra e cambialle o tamaño",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Fai música",
    "gui.howtos.Make-Music.step_PickInstrument": "Escolle un instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Toca un son cando o premas",
    "gui.howtos.Make-Music.step_MakeSong": "Crea unha canción",
    "gui.howtos.make-music.step_MakeBeat": "Escolle unha caixa e crea un ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Escolle a figura do micrófono e a caixa de ritmos de sorpresas",
    "gui.howtos.story.name": "Crea unha historia",
    "gui.howtos.story.step_addbg": "Engade un fondo",
    "gui.howtos.story.step_addsprite": "Engade unha personaxe",
    "gui.howtos.story.step_saysomething": "Fai que diga algo",
    "gui.howtos.story.step_addanothersprite": "Engade outra personaxe",
    "gui.howtos.story.step_flip": "Inverte a dirección",
    "gui.howtos.story.step_conversation": "Parola",
    "gui.howtos.story.addanotherbg": "Engade outro fondo",
    "gui.howtos.story.step_swithbg": "Muda os fondos",
    "gui.howtos.story.step_hidewizard": "Agocha unha personaxe",
    "gui.howtos.story.step_showwizard": "Mostra unha personaxe",
    "gui.howtos.make-a-chase-game.name": "Crea un xogo de persecución",
    "gui.howtos.Chase-Game.step_BG": "Engade un fondo",
    "gui.howtos.chase-game.step_AddOcto": " Engade unha figura",
    "gui.howtos.make-music.step_LeftRight": "Móvea á dereita e á esquerda coas teclas das frechas",
    "gui.howtos.Chase-Game.step_UpDown": "Sube e baixa coas teclas das frechas",
    "gui.howtos.Chase-Game.step_AddStar": "Engade outra figura",
    "gui.howtos.Chase-Game.step_MoveRandom": "Móvea ao chou",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ao tocar na figura do polbo, reproduce un son",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crea unha variábel para a puntuación",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ao tocar na figura do polbo,  aumentar a puntuación",
    "gui.howtos.animate-char.name": "Anima unha personaxe",
    "gui.howtos.animate-char.step_addbg": "Engade un fondo",
    "gui.howtos.animate-char.step_addsprite": " Engade unha figura",
    "gui.howtos.animate-char.step_saysomething": "Fai que diga algo",
    "gui.howtos.animate-char.step_addsound": "Engade un son",
    "gui.howtos.animate-char.step_animatetalking": "Anima unha conversa",
    "gui.howtos.animate-char.step_arrowkeys": "Move usando as teclas de frecha",
    "gui.howtos.animate-char.step_jump": "Salta",
    "gui.howtos.animate-char.step_changecolor": "Cambia a cor",
    "gui.howtos.make-a-game.name": "Crea un xogo de facer clic",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Escolle unha figura",
    "gui.howtos.make-a-game.step_GamePlaySound": "Toca un son cando a premas",
    "gui.howtos.make-a-game.step_GameAddScore": "Crea unha variábel para a puntuación",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ao premer aumenta a puntuación",
    "gui.howtos.make-a-game.step_Random": "Vai para unha posición ao chou",
    "gui.howtos.make-music.step_GameChangeColor": "Cambia a cor",
    "gui.howtos.make-music.step_ResetScore": "Anula a puntuación",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Escolle 'Puntuación' no Menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Anima un xogo de aventuras",
    "gui.howtos.cartoon-network.step_CNcharacter": "Escolle un carácter para mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Fai que diga algo",
    "gui.howtos.cartoon-network.step_CNglide": "Mover polo escenario",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Escolle un obxecto para perseguilo",
    "gui.howtos.cartoon-network.step_CNcollect": "Fai a colleita",
    "gui.howtos.cartoon-network.step_CNvariable": "Crea unha variábel para a puntuación",
    "gui.howtos.cartoon-network.step_CNscore": "Garda os puntos",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Pasamos de nivel: Muda o fondo",
    "gui.howtos.videosens.name": "Sensor de vídeo",
    "gui.howtos.videosens.step_addextension": "Engadir extensión",
    "gui.howtos.videosens.step_pet": "Aloumiña o gato",
    "gui.howtos.videosens.step_animate": "Move",
    "gui.howtos.videosens.step_pop": "Estoupa un globo",
    "gui.howtos.say-it-out-loud": "Crea animacións que falen",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Engade os bloques de «Texto a fala»",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Escolle unha voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Móvete arredor",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Engade un fondo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Engade outra personaxe",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Canta unha canción",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambia a cor",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Vira arredor",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Medra e encolle",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Atopa os Bloques para Preguntar e Resposta na Categoría Sensores",
    "gui.howtos.add-sprite.name": " Engade unha figura",
    "gui.howtos.add-sprite.step_addSprite": " Engade unha figura",
    "gui.howtos.add-a-backdrop.name": "Engade un fondo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Cambia o tamaño",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Mover polo escenario",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Gravar un son",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Fai que xire sobre si mesma",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Agochar e amosar",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Anima unha figura",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Empregar as teclas de frecha",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Engadir efectos",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toca instrumentos e tambores.",
    "gui.extension.pen.name": "Lapis",
    "gui.extension.pen.description": "Debuxa coas túas figuras.",
    "gui.extension.videosensing.name": "Sensor de vídeo",
    "gui.extension.videosensing.description": "Sente movemento coa cámara.",
    "gui.extension.text2speech.name": "Texto a fala",
    "gui.extension.text2speech.description": "Fai que os teus proxectos falen.",
    "gui.extension.translate.name": "Traducir",
    "gui.extension.translate.description": "Traduce texto a moitos idiomas.",
    "gui.extension.makeymakey.description": "Fai calquera cousa cunha tecla.",
    "gui.extension.microbit.description": "Conecta os teus proxectos co mundo.",
    "gui.extension.microbit.connectingMessage": "A conectar.",
    "gui.extension.ev3.description": "Constrúe robots interactivos e máis.",
    "gui.extension.ev3.connectingMessage": "A conectar. Comproba que o pin do teu EV3 é 1234.",
    "gui.extension.boost.description": "Dalle vida aos robots.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Constrúe con motores e sensores.",
    "gui.extension.wedo2.connectingMessage": "A conectar",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Todas",
    "gui.libraryTags.animals": "Animais",
    "gui.libraryTags.dance": "Baile",
    "gui.libraryTags.effects": "Efectos",
    "gui.libraryTags.fantasy": "Fantasía",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Comida",
    "gui.libraryTags.indoors": "Interiores",
    "gui.libraryTags.loops": "Bucles",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exteriores",
    "gui.libraryTags.patterns": "Patróns",
    "gui.libraryTags.people": "Xente",
    "gui.libraryTags.percussion": "Percusión",
    "gui.libraryTags.space": "Espazo",
    "gui.libraryTags.sports": "Deportes",
    "gui.libraryTags.underwater": "Baixo a auga",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Extravagante",
    "gui.libraryTags.animation": "Animación",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Xogos",
    "gui.libraryTags.stories": "Historias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "dirección",
    "gui.opcodeLabels.xposition": "posición en x",
    "gui.opcodeLabels.yposition": "posición en y",
    "gui.opcodeLabels.size": "tamaño",
    "gui.opcodeLabels.costumename": "nome do traxe",
    "gui.opcodeLabels.costumenumber": "número de traxe",
    "gui.opcodeLabels.backdropname": "nome do fondo",
    "gui.opcodeLabels.backdropnumber": "número de fondo",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "resposta",
    "gui.opcodeLabels.loudness": "intensidade do son",
    "gui.opcodeLabels.username": "nome de usuario",
    "gui.opcodeLabels.year": "ano",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "día da semana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronómetro",
    "gui.projectLoader.loadError": "Non foi posíbel cargar o ficheiro do proxecto que se seleccionou.",
    "gui.sharedMessages.backdrop": "fondo{index}",
    "gui.sharedMessages.costume": "traxe {index}",
    "gui.sharedMessages.sprite": "Figura{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Cargar desde o teu ordenador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proxecto de Scratch",
    "boost.color.any": "calquera cor",
    "boost.color.black": "negro",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "vermello",
    "boost.color.white": "branco",
    "boost.color.yellow": "amarelo",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "ángulo de inclinación [TILT_DIRECTION]",
    "boost.motorDirection.backward": "recuar",
    "boost.motorDirection.forward": "avanzar",
    "boost.motorDirection.reverse": "inverter",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "pór a cor da luz a [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "calquera",
    "boost.tiltDirection.down": "abaixo",
    "boost.tiltDirection.left": "esquerda",
    "boost.tiltDirection.right": "dereita",
    "boost.tiltDirection.up": "arriba",
    "boost.whenColor": "Ao ver un bloque [COLOR]",
    "boost.whenTilted": "Cando estea inclinado cara [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tocar a nota [NOTE] durante [TIME] segundos",
    "ev3.buttonPressed": "está premido o botón [PORT]",
    "ev3.getBrightness": "luminosidade",
    "ev3.getDistance": "distancia",
    "ev3.getMotorPosition": "posición do motor [PORT]",
    "ev3.motorSetPower": "pór o motor [PORT] ao [POWER]% de potencia",
    "ev3.motorTurnClockwise": "virar o motor [PORT] para aquí durante [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "virar o motor [PORT] para alá durante [TIME] segundos",
    "ev3.whenBrightnessLessThan": "Cando o brillo < [DISTANCE]",
    "ev3.whenButtonPressed": "Ao premer o botón [PORT]",
    "ev3.whenDistanceLessThan": "Cando a distancia < [DISTANCE]",
    "gdxfor.getAcceleration": "a aceleración [DIRECTION]",
    "gdxfor.getForce": "a forza",
    "gdxfor.getSpin": "a velocidade angular [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "está a caer?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "levou un tirón",
    "gdxfor.pushed": "foi empurrado",
    "gdxfor.shaken": "abalado",
    "gdxfor.startedFalling": "comezou a caer",
    "gdxfor.tiltDirectionMenu.any": "calquera",
    "gdxfor.tiltDirectionMenu.back": "por detrás",
    "gdxfor.tiltDirectionMenu.front": "adiante",
    "gdxfor.tiltDirectionMenu.left": "a esquerda",
    "gdxfor.tiltDirectionMenu.right": "a dereita",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "Cando o sensor de forza [PUSH_PULL]",
    "gdxfor.whenGesture": "Cando é [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "frecha abaixo",
    "makeymakey.downArrowShort": "abaixo",
    "makeymakey.leftArrow": "frecha esquerda",
    "makeymakey.leftArrowShort": "esquerda",
    "makeymakey.rightArrow": "frecha dereita",
    "makeymakey.rightArrowShort": "dereita",
    "makeymakey.spaceKey": "espazo",
    "makeymakey.upArrow": "frecha arriba",
    "makeymakey.upArrowShort": "arriba",
    "makeymakey.whenKeyPressed": "Ao premer a tecla [KEY]",
    "makeymakey.whenKeysPressedInOrder": "Ao premer en orde [SEQUENCE]",
    "microbit.buttonsMenu.any": "calquera",
    "microbit.clearDisplay": "limpar a pantalla",
    "microbit.defaultTextToDisplay": "Ola!",
    "microbit.displaySymbol": "mostrar [MATRIX]",
    "microbit.displayText": "mostrar o texto [TEXT]",
    "microbit.gesturesMenu.jumped": "saltado",
    "microbit.gesturesMenu.moved": "movido",
    "microbit.gesturesMenu.shaken": "abalado",
    "microbit.isButtonPressed": "está premido o botón [BTN]",
    "microbit.isTilted": "inclinado cara [DIRECTION]",
    "microbit.pinStateMenu.off": "apagado",
    "microbit.pinStateMenu.on": "aceso",
    "microbit.tiltAngle": "ángulo de inclinación cara [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "calquera",
    "microbit.tiltDirectionMenu.back": "atrás",
    "microbit.tiltDirectionMenu.front": "adiante",
    "microbit.tiltDirectionMenu.left": "a esquerda",
    "microbit.tiltDirectionMenu.right": "a dereita",
    "microbit.whenButtonPressed": "Ao premer o botón [BTN]",
    "microbit.whenGesture": "Cando é [GESTURE]",
    "microbit.whenPinConnected": "Cando o pin [PIN] estea conectado",
    "microbit.whenTilted": "Ao estar inclinado cara [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "aumentar o tempo en [TEMPO]",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongó",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charles pechado",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Chocallo",
    "music.drumCrashCymbal": "(4) Prato de ataque",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Palmada",
    "music.drumOpenHiHat": "(5) Charles aberto",
    "music.drumSideStick": "(3) Golpe lateral",
    "music.drumSnare": "(1) Tambor de caixa",
    "music.drumTambourine": "(7) Pandeireta",
    "music.drumTriangle": "(12) Triángulo",
    "music.drumVibraslap": "(17) Trafaplás",
    "music.drumWoodBlock": "(10) Bloque de madeira",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Baixo",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violonchelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra eléctrica",
    "music.instrumentElectricPiano": "(2) Piano eléctrico",
    "music.instrumentFlute": "(12) Frauta traveseira",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caixa de música",
    "music.instrumentOrgan": "(3) Órgano",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Tambor metálico",
    "music.instrumentSynthLead": "(20) Sintetizador melódico",
    "music.instrumentSynthPad": "(21) Sintetizador de fondo",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibráfono",
    "music.instrumentWoodenFlute": "(13) Frauta de madeira",
    "music.midiPlayDrumForBeats": "tocar o tambor [DRUM] durante [BEATS] pulsos",
    "music.midiSetInstrument": "tocar o instrumento [INSTRUMENT]",
    "music.playDrumForBeats": "tocar o tambor [DRUM] durante [BEATS] pulsos",
    "music.playNoteForBeats": "tocar a nota [NOTE] durante [BEATS] pulsos",
    "music.restForBeats": "descanso de [BEATS] pulsos",
    "music.setInstrument": "usar o instrumento [INSTRUMENT]",
    "music.setTempo": "aplicar un tempo de [TEMPO]",
    "pen.categoryName": "Lapis",
    "pen.changeColorParam": "sumar [VALUE] á [COLOR_PARAM] do lapis",
    "pen.changeHue": "sumar [HUE] á cor do lapis",
    "pen.changeShade": "sumar [SHADE] a intensidade do lapis",
    "pen.changeSize": "aumentar o tamaño do lapis en [SIZE]",
    "pen.clear": "borrar todo",
    "pen.colorMenu.brightness": "luminosidade",
    "pen.colorMenu.color": "cor",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "transparencia",
    "pen.penDown": "baixar o lapis",
    "pen.penUp": "subir o lapis",
    "pen.setColor": "usar un lapis de cor [COLOR]",
    "pen.setColorParam": "pór a [COLOR_PARAM] do lapis en [VALUE]",
    "pen.setHue": "usar un lapis de cor [HUE]",
    "pen.setShade": "pór a intensidade do lapis a [SHADE]",
    "pen.setSize": "usar un lapis de tamaño [SIZE]",
    "pen.stamp": "selar",
    "speech.defaultWhenIHearValue": "Imos aló",
    "speech.extensionName": "Fala a texto",
    "speech.listenAndWait": "escoitar e agardar",
    "speech.speechReporter": "ler en voz alta",
    "speech.whenIHear": "ao ouvir [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Texto a fala",
    "text2speech.defaultTextToSpeak": "Ola",
    "text2speech.giant": "xigante",
    "text2speech.kitten": "gatiño",
    "text2speech.setLanguageBlock": "usar o idioma [LANGUAGE]",
    "text2speech.setVoiceBlock": "darlle a voz de [VOICE]",
    "text2speech.speakAndWaitBlock": "falar [WORDS]",
    "text2speech.squeak": "bradar",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducir",
    "translate.defaultTextToTranslate": "Ola",
    "translate.translateBlock": "traducir [WORDS] a [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Sensor de vídeo",
    "videoSensing.direction": "dirección",
    "videoSensing.motion": "movemento",
    "videoSensing.off": "apagado",
    "videoSensing.on": "aceso",
    "videoSensing.onFlipped": "ao voltear",
    "videoSensing.setVideoTransparency": "pór a transparencia de vídeo en [TRANSPARENCY]",
    "videoSensing.sprite": "figura",
    "videoSensing.stage": "escenario",
    "videoSensing.videoOn": "[ATTRIBUTE] de vídeo a [SUBJECT]",
    "videoSensing.videoToggle": "vídeo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "Cando o movemento de vídeo > [REFERENCE]",
    "wedo2.getDistance": "distancia",
    "wedo2.getTiltAngle": "ángulo de inclinación [TILT_DIRECTION]",
    "wedo2.isTilted": "inclinado á [TILT_DIRECTION_ANY]",
    "wedo2.motorDirection.backward": "cara alá",
    "wedo2.motorDirection.forward": "por aquí",
    "wedo2.motorDirection.reverse": "inverter",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "todos os motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "apagar [MOTOR_ID]",
    "wedo2.motorOn": "acender [MOTOR_ID]",
    "wedo2.motorOnFor": "acender [MOTOR_ID] durante [DURATION] segundos",
    "wedo2.playNoteFor": "tocar a nota [NOTE] durante [DURATION] segundos",
    "wedo2.setLightHue": "pór a cor da luz a [HUE]",
    "wedo2.setMotorDirection": "trocar a dirección de [MOTOR_ID] por [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "pór a potencia de [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "calquera",
    "wedo2.tiltDirection.down": "abaixo",
    "wedo2.tiltDirection.left": "a esquerda",
    "wedo2.tiltDirection.right": "a dereita",
    "wedo2.tiltDirection.up": "arriba",
    "wedo2.whenDistance": "Cando a distancia [OP] [REFERENCE]",
    "wedo2.whenTilted": "Cando estea inclinado cara [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Cor",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "Luminosidade",
    "paint.paintEditor.costume": "Traxe",
    "paint.paintEditor.group": "Agrupar",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Desfacer",
    "paint.paintEditor.redo": "Refacer",
    "paint.paintEditor.forward": "Adiante",
    "paint.paintEditor.backward": "Atrás",
    "paint.paintEditor.front": "Traer á fronte",
    "paint.paintEditor.back": "Levar ao fondo",
    "paint.paintEditor.more": "Máis",
    "paint.modeTools.brushSize": "Tamaño",
    "paint.modeTools.eraserSize": "Tamaño do borrador",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Pegar",
    "paint.modeTools.delete": "Eliminar",
    "paint.modeTools.curved": "A curvas",
    "paint.modeTools.pointed": "Bordes Afiados",
    "paint.modeTools.thickness": "Gordura",
    "paint.modeTools.flipHorizontal": "Voltear en horizontal",
    "paint.modeTools.flipVertical": "Voltear en vertical",
    "paint.modeTools.filled": "Enchido",
    "paint.modeTools.outlined": "Bordos",
    "paint.paintEditor.bitmap": "Converter en mapa de bits",
    "paint.paintEditor.vector": "Converter en vectores",
    "paint.paintEditor.fill": "Recheo",
    "paint.paintEditor.stroke": "Bordo",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Borrador",
    "paint.fillMode.fill": "Encher",
    "paint.lineMode.line": "Liña",
    "paint.ovalMode.oval": "Círculo",
    "paint.rectMode.rect": "Rectángulo",
    "paint.reshapeMode.reshape": "Reformar",
    "paint.roundedRectMode.roundedRect": "Rectángulo arredondado",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Trocar"
  },
  "ko": {
    "gui.alerts.lostPeripheralConnection": "스크래치와 {extensionName} 사이의 연결이 끊어졌습니다.",
    "gui.alerts.tryAgain": "다시 시도",
    "gui.alerts.download": "다운로드",
    "gui.connection.reconnect": "다시 연결",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "개인 저장소",
    "gui.backpack.errorBackpack": "개인 저장소를 불러오는 중 오류 ",
    "gui.backpack.loadingBackpack": "로딩중...",
    "gui.backpack.more": "더 보기",
    "gui.backpack.emptyBackpack": "개인 저장소가 비었습니다",
    "gui.unsupportedBrowser.label": "브라우저가 지원되지 않습니다.",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "뒤로",
    "gui.unsupportedBrowser.previewfaq": "더 알아보려면, {previewFaqLink}로 이동하세요.",
    "gui.unsupportedBrowser.previewfaqlinktext": "자주 묻는 질문(FAQ)",
    "gui.cards.all-tutorials": "튜토리얼",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "닫기",
    "gui.cards.more-things-to-try": "해 볼 만한 다른 것들!",
    "gui.cards.see-more": "더 보기",
    "gui.comingSoon.message1": "걱정 마세요, 작업 중입니다 {emoji}",
    "gui.comingSoon.message2": "곧 이용 가능합니다...",
    "gui.comingSoon.message3": "작업 중입니다 {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "발견된 기기가 없습니다",
    "gui.connection.auto-scanning.prescan": "주변에 기기가 있는 지 확인 후 검색을 시작하세요. ",
    "gui.connection.auto-scanning.pressbutton": "기기의 버튼을 누르세요",
    "gui.connection.auto-scanning.start-search": "검색 시작",
    "gui.connection.connecting-searchbutton": "검색 중...",
    "gui.connection.auto-scanning.try-again": "다시 시도",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "연결됨 ",
    "gui.connection.disconnect": "연결 끊기 ",
    "gui.connection.go-to-editor": "편집기로 가기 ",
    "gui.connection.connecting-cancelbutton": "연결 중...",
    "gui.connection.error.errorMessage": "이런, 뭔가 잘못된 것 같네요. ",
    "gui.connection.error.tryagainbutton": "다시 시도",
    "gui.connection.error.helpbutton": "도움말",
    "gui.connection.peripheral-name-label": "기기 이름",
    "gui.connection.connect": "연결하기",
    "gui.connection.scanning.lookingforperipherals": "기기를 찾는 중",
    "gui.connection.scanning.noPeripheralsFound": "발견된 기기가 없습니다",
    "gui.connection.scanning.instructions": "위의 목록에서 사용자의 기기를 선택하세요.",
    "gui.connection.search": "새로 고침",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Scratch Link가 설치되었고 실행되는지 확인하세요",
    "gui.connection.unavailable.enablebluetooth": "블루투스가 사용 가능한지 확인하세요",
    "gui.connection.unavailable.tryagainbutton": "다시 시도",
    "gui.connection.unavailable.helpbutton": "도움말",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "시작하기",
    "gui.controls.stop": "멈추기",
    "gui.crashMessage.label": "이런! 무언가가 잘못되었습니다.",
    "gui.crashMessage.description": "정말로 죄송하지만, 스크래치에 문제가 생긴 것으로 보입니다. 이 오류는 자동으로 스크래치 팀에게 접수되었습니다. 다시 시도하려면 페이지를 새로고침하세요.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "새로 고침",
    "gui.customProcedures.myblockModalTitle": "블록 만들기",
    "gui.customProcedures.addAnInputNumberText": "입력값 추가하기",
    "gui.customProcedures.numberTextType": "숫자 또는 문자열",
    "gui.customProcedures.addAnInputBoolean": "입력값 추가하기",
    "gui.customProcedures.booleanType": "논리값",
    "gui.customProcedures.addALabel": "라벨 넣기",
    "gui.customProcedures.runWithoutScreenRefresh": "화면 새로고침 없이 실행하기",
    "gui.customProcedures.cancel": "취소",
    "gui.customProcedures.ok": "확인",
    "gui.SpriteInfo.direction": "방향",
    "gui.directionPicker.rotationStyles.allAround": "회전하기",
    "gui.directionPicker.rotationStyles.leftRight": "왼쪽/오른쪽",
    "gui.directionPicker.rotationStyles.dontRotate": "회전하지 않기",
    "gui.gui.addExtension": "확장 기능 추가하기",
    "gui.gui.codeTab": "코드",
    "gui.gui.backdropsTab": "배경",
    "gui.gui.costumesTab": "모양",
    "gui.gui.soundsTab": "소리",
    "gui.extensionLibrary.comingSoon": "곧 이용 가능",
    "gui.extensionLibrary.requires": "요구사항",
    "gui.extensionLibrary.collaboration": "협력사",
    "gui.library.filterPlaceholder": "검색",
    "gui.library.allTag": "모두",
    "gui.loader.message1": "블록을 생성하는 중...",
    "gui.loader.message2": "스프라이트를 불러오는 중...",
    "gui.loader.message3": "소리를 불러오는 중...",
    "gui.loader.message4": "확장 기능을 불러오는 중...",
    "gui.loader.message5": "고양이를 몰고 가는 중...",
    "gui.loader.message6": "나노를 전송하는 중...",
    "gui.loader.message7": "고보를 팽창시키는 중...",
    "gui.loader.message8": "이모티콘을 준비하는 중...",
    "gui.loader.headline": "프로젝트를 불러오는 중",
    "gui.loader.creating": "생성된 프로젝트",
    "gui.accountMenu.profile": "내 정보",
    "gui.accountMenu.myStuff": "내 작업실",
    "gui.accountMenu.myClasses": "내 학급",
    "gui.accountMenu.myClass": "내 학급",
    "gui.accountMenu.accountSettings": "계정 설정",
    "gui.accountMenu.signOut": "로그아웃",
    "gui.authorInfo.byUser": "제작자: {username}",
    "gui.menuBar.seeProjectPage": "프로젝트 페이지 보기",
    "gui.menuBar.language": "언어",
    "general.username": "사용자 이름",
    "general.password": "비밀번호",
    "general.signIn": "로그인",
    "login.needHelp": "도움이 필요한가요?",
    "form.validationRequired": "필수 항목입니다",
    "gui.menuBar.tutorialsLibrary": "튜토리얼",
    "gui.menuBar.restoreSprite": "스프라이트 되돌리기",
    "gui.menuBar.restoreSound": "소리 되돌리기",
    "gui.menuBar.restoreCostume": "모양 되돌리기",
    "gui.menuBar.restore": "되돌리기",
    "gui.menuBar.saveNow": "저장하기",
    "gui.menuBar.saveAsCopy": "복사본 저장하기",
    "gui.menuBar.remix": "리믹스",
    "gui.menuBar.new": "새로 만들기",
    "gui.menuBar.file": "파일",
    "gui.menuBar.downloadToComputer": "컴퓨터에 저장하기 ",
    "gui.menuBar.edit": "편집",
    "gui.menuBar.turboModeOff": "터보 모드 끄기",
    "gui.menuBar.turboModeOn": "터보 모드 켜기",
    "gui.menuBar.modeMenu": "모드",
    "gui.menuBar.normalMode": "그냥 스크래치 모드",
    "gui.menuBar.caturdayMode": "냥토 모드",
    "gui.menuBar.joinScratch": "스크래치 가입",
    "gui.menuBar.signIn": "로그인",
    "gui.gui.projectTitlePlaceholder": "프로젝트 제목을 입력하세요",
    "gui.menuBar.saveNowLink": "바로 저장하기",
    "gui.menuBar.settings": "설정",
    "gui.menuBar.isShared": "공유됨",
    "gui.menuBar.share": "공유",
    "gui.menuBar.colorMode": "색상 모드",
    "gui.modal.help": "도움말",
    "gui.modal.back": "뒤로",
    "gui.monitor.listMonitor.empty": "(비어 있음)",
    "gui.monitor.listMonitor.listLength": "길이 {length}",
    "gui.monitor.contextMenu.default": "변수이름-변수값 보기",
    "gui.monitor.contextMenu.large": "변수값 크게 보기",
    "gui.monitor.contextMenu.slider": "슬라이더 사용하기",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "가져오기",
    "gui.monitor.contextMenu.export": "내보내기",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "모든 스프라이트에서 사용",
    "gui.gui.variableScopeOptionSpriteOnly": "이 스프라이트에서만 사용",
    "gui.gui.cloudVariableOption": "클라우드 변수 (서버에 저장됨)",
    "gui.gui.variablePromptAllSpritesMessage": "이 변수는 모든 스프라이트에서 사용할 수 있습니다.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "취소",
    "gui.prompt.ok": "확인",
    "gui.playbackStep.stopMsg": "멈추기",
    "gui.playbackStep.playMsg": "재생",
    "gui.playbackStep.loadingMsg": "로딩 중...",
    "gui.playbackStep.saveMsg": "저장",
    "gui.playbackStep.reRecordMsg": "다시 녹음하기",
    "gui.recordModal.title": "소리 녹음하기",
    "gui.recordingStep.beginRecord": "아래에 있는 버튼을 눌러서 녹음을 시작하세요",
    "gui.recordingStep.permission": "{arrow}마이크를 사용하려면 사용자의 허락이 필요합니다",
    "gui.recordingStep.stop": "녹음 멈추기",
    "gui.recordingStep.record": "녹음하기",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "소리",
    "gui.soundEditor.play": "재생",
    "gui.soundEditor.stop": "멈추기",
    "gui.soundEditor.copy": "복사",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "새로운 소리로 복사",
    "gui.soundEditor.delete": "삭제",
    "gui.soundEditor.save": "저장",
    "gui.soundEditor.undo": "되돌리기",
    "gui.soundEditor.redo": "재시도",
    "gui.soundEditor.faster": "빠르게",
    "gui.soundEditor.slower": "느리게",
    "gui.soundEditor.echo": "메아리",
    "gui.soundEditor.robot": "로봇",
    "gui.soundEditor.louder": "크게",
    "gui.soundEditor.softer": "작게",
    "gui.soundEditor.reverse": "뒤집기",
    "gui.soundEditor.fadeOut": "점점 작게",
    "gui.soundEditor.fadeIn": "점점 크게",
    "gui.soundEditor.mute": "음소거",
    "gui.SpriteInfo.spritePlaceholder": "이름",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "스프라이트",
    "gui.SpriteInfo.show": "보이기",
    "gui.SpriteInfo.size": "크기",
    "gui.spriteSelectorItem.contextMenuDuplicate": "복사",
    "gui.spriteSelectorItem.contextMenuExport": "내보내기",
    "gui.spriteSelectorItem.contextMenuDelete": "삭제",
    "gui.spriteSelector.addSpriteFromLibrary": "스프라이트 고르기",
    "gui.spriteSelector.addSpriteFromPaint": "그리기",
    "gui.spriteSelector.addSpriteFromSurprise": "서프라이즈",
    "gui.spriteSelector.addSpriteFromFile": "스프라이트 업로드하기",
    "gui.stageHeader.stageSizeLarge": "큰 무대로 전환하기",
    "gui.stageHeader.stageSizeSmall": "작은 무대로 전환하기 ",
    "gui.stageHeader.stageSizeFull": "전체 화면 모드로 전환하기 ",
    "gui.stageHeader.stageSizeUnFull": "전체 화면 모드 종료하기",
    "gui.stageHeader.fullscreenControl": "전체 화면",
    "gui.spriteSelector.addBackdropFromLibrary": "배경 고르기",
    "gui.stageSelector.addBackdropFromPaint": "그리기",
    "gui.stageSelector.addBackdropFromSurprise": "서프라이즈 ",
    "gui.stageSelector.addBackdropFromFile": "배경 업로드하기",
    "gui.stageSelector.stage": "무대",
    "gui.stageSelector.backdrops": "배경",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "개인정보보호 정책",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "터보 모드",
    "gui.webglModal.label": "브라우저가 WebGL을 지원하지 않습니다",
    "gui.webglModal.description": "아쉽지만 브라우저 또는 컴퓨터가 {webGlLink}로 보입니다. 스크래치 3.0을 실행하려면 이 장치가 필요합니다.",
    "gui.webglModal.webgllink": "WebGL을 지원하지 않는 상태",
    "gui.webglModal.back": "뒤로",
    "gui.webglModal.previewfaq": "더 알아보려면, {previewFaqLink}로 이동하세요.",
    "gui.webglModal.previewfaqlinktext": "자주 묻는 질문(FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "배경 고르기",
    "gui.costumeLibrary.chooseACostume": "모양 고르기",
    "gui.costumeTab.addBackdropFromLibrary": "배경 고르기",
    "gui.costumeTab.addCostumeFromLibrary": "모양 고르기",
    "gui.costumeTab.addBlankCostume": "그리기",
    "gui.costumeTab.addSurpriseCostume": "서프라이즈 ",
    "gui.costumeTab.addFileBackdrop": "배경 업로드하기",
    "gui.costumeTab.addFileCostume": "모양 업로드하기",
    "gui.extensionLibrary.chooseAnExtension": "확장 기능 고르기",
    "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "녹음을 시작할 수 없음",
    "gui.soundLibrary.chooseASound": "소리 고르기",
    "gui.soundTab.fileUploadSound": "소리 업로드하기",
    "gui.soundTab.surpriseSound": "서프라이즈 ",
    "gui.soundTab.recordSound": "녹음하기",
    "gui.soundTab.addSoundFromLibrary": "소리 고르기",
    "gui.spriteLibrary.chooseASprite": "스프라이트 고르기",
    "gui.tipsLibrary.tutorials": "튜토리얼 고르기",
    "gui.alerts.createsuccess": "새 프로젝트가 생성되었습니다.",
    "gui.alerts.createcopysuccess": "복사본으로 프로젝트가 저장되었습니다.",
    "gui.alerts.createremixsuccess": "리믹스로 프로젝트가 저장되었습니다.",
    "gui.alerts.creating": "새로 만드는 중...",
    "gui.alerts.creatingCopy": "프로젝트 복사중...",
    "gui.alerts.creatingRemix": "프로젝트 리믹스 중...",
    "gui.alerts.creatingError": "프로젝트를 생성하지 못했습니다. 다시 시도해 주세요!",
    "gui.alerts.savingError": "프로젝트를 저장하지 못했습니다.",
    "gui.alerts.savesuccess": "프로젝트가 저장되었습니다.",
    "gui.alerts.saving": "프로젝트 저장 중...",
    "gui.alerts.cloudInfo": "클라우드 변수는 숫자만 지원하며 문자나 특수기호는 지원하지 않습니다. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "더 알아보기",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "야옹",
    "gui.defaultProject.variable": "나의 변수",
    "gui.howtos.intro-move-sayhello-hat.name": "시작하기",
    "gui.howtos.intro-move.step_stepMove": "이동 블록 추가하기 ",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "이름으로 애니메이션 만들기",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "글자 스프라이트 선택하기 ",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "클릭할 때 소리 재생하기",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "다른 글자 스프라이트 선택하기 ",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "색 바꾸기",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
    "gui.howtos.animate-a-name.step_AnimateGrow": "다른 글자 스프라이트를 선택하고 크기 늘리기",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "음악 만들기",
    "gui.howtos.Make-Music.step_PickInstrument": "악기 스프라이트 선택하기 ",
    "gui.howtos.Make-Music.step_PlaySoundClick": "클릭할 때 소리 재생",
    "gui.howtos.Make-Music.step_MakeSong": "노래 만들기",
    "gui.howtos.make-music.step_MakeBeat": "타악기 고르기 & 리듬 만들기",
    "gui.howtos.make-music.step_MakeBeatBox": "마이크 스프라이트 및 서프라이즈 비트박스 선택하기",
    "gui.howtos.story.name": "이야기 만들기",
    "gui.howtos.story.step_addbg": "배경 추가하기",
    "gui.howtos.story.step_addsprite": "캐릭터 추가하기",
    "gui.howtos.story.step_saysomething": "무엇이든지 말하기",
    "gui.howtos.story.step_addanothersprite": "다른 캐릭터 추가하기",
    "gui.howtos.story.step_flip": "방향 바꾸기",
    "gui.howtos.story.step_conversation": "대화하기",
    "gui.howtos.story.addanotherbg": "다른 배경 추가하기",
    "gui.howtos.story.step_swithbg": "배경 바꾸기",
    "gui.howtos.story.step_hidewizard": "캐릭터 숨기기",
    "gui.howtos.story.step_showwizard": "캐릭터 보이기",
    "gui.howtos.make-a-chase-game.name": "잡기 게임 만들기",
    "gui.howtos.Chase-Game.step_BG": "배경 추가하기",
    "gui.howtos.chase-game.step_AddOcto": "스프라이트 추가하기",
    "gui.howtos.make-music.step_LeftRight": "방향키를 눌러서 왼쪽 & 오른쪽으로 움직이기",
    "gui.howtos.Chase-Game.step_UpDown": "방향키를 눌러서 위쪽 & 아래쪽으로 움직이기",
    "gui.howtos.Chase-Game.step_AddStar": "다른 스프라이트 추가하기",
    "gui.howtos.Chase-Game.step_MoveRandom": "무작위로 움직이기",
    "gui.howtos.Chase-Game.step_WhenTouch": "문어 스프라이트가 닿을 때 소리 재생하기",
    "gui.howtos.Chase-Game.step_ScoreVariable": "점수 변수 만들기 ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "문어 스프라이트가 닿을 때 점수 올리기",
    "gui.howtos.animate-char.name": "캐릭터를 애니메이션으로 만들기",
    "gui.howtos.animate-char.step_addbg": "배경 추가하기",
    "gui.howtos.animate-char.step_addsprite": "스프라이트 추가하기",
    "gui.howtos.animate-char.step_saysomething": "무엇이든지 말하기",
    "gui.howtos.animate-char.step_addsound": "소리 추가하기",
    "gui.howtos.animate-char.step_animatetalking": "대화를 애니메이션으로 만들기",
    "gui.howtos.animate-char.step_arrowkeys": "방향키로 움직이기",
    "gui.howtos.animate-char.step_jump": "점프하기",
    "gui.howtos.animate-char.step_changecolor": "색 바꾸기",
    "gui.howtos.make-a-game.name": "클릭하는 게임 만들기",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "스프라이트 고르기",
    "gui.howtos.make-a-game.step_GamePlaySound": "클릭할 때 소리 재생하기",
    "gui.howtos.make-a-game.step_GameAddScore": "점수 변수 만들기 ",
    "gui.howtos.make-a-game.step_GameChangeScore": "클릭할 때 점수 올리기",
    "gui.howtos.make-a-game.step_Random": "아무 데나 이동하기",
    "gui.howtos.make-music.step_GameChangeColor": "색 바꾸기",
    "gui.howtos.make-music.step_ResetScore": "점수 초기화하기",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "어드벤처 게임을 움직이게 만들기",
    "gui.howtos.cartoon-network.step_CNcharacter": "보여줄 캐릭터 고르기",
    "gui.howtos.cartoon-network.step_CNsay": "무엇이든지 말하기",
    "gui.howtos.cartoon-network.step_CNglide": "미끄러지듯 이동하기",
    "gui.howtos.cartoon-network.step_CNpicksprite": "쫓아갈 물건 고르기",
    "gui.howtos.cartoon-network.step_CNcollect": "물건 모으기",
    "gui.howtos.cartoon-network.step_CNvariable": "점수 변수 만들기 ",
    "gui.howtos.cartoon-network.step_CNscore": "점수 저장하기",
    "gui.howtos.cartoon-network.step_CNbackdrop": "레벨 업: 배경 바꾸기",
    "gui.howtos.videosens.name": "비디오 감지",
    "gui.howtos.videosens.step_addextension": "확장 기능 추가하기",
    "gui.howtos.videosens.step_pet": "고양이 쓰다듬기",
    "gui.howtos.videosens.step_animate": "애니메이션으로 만들기",
    "gui.howtos.videosens.step_pop": "풍선 터트리기",
    "gui.howtos.say-it-out-loud": "대화하는 애니메이션 만들기",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "텍스트 음성 변환 블록 추가하기",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "목소리 정하기",
    "gui.howtos.say-it-out-loud.step_TXTMove": "돌아다니기",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "배경 추가하기",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "다른 캐릭터 추가하기",
    "gui.howtos.say-it-out-loud.step_TXTSong": "노래 자랑하기",
    "gui.howtos.say-it-out-loud.step_TXTColor": "색 바꾸기",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "빙글빙글 돌기",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "커지고 작아지기",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "스프라이트 추가하기",
    "gui.howtos.add-sprite.step_addSprite": "스프라이트 추가하기",
    "gui.howtos.add-a-backdrop.name": "배경 추가하기",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "크기 바꾸기",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "미끄러지듯 이동하기",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "소리 녹음하기",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "회전하게 만들기",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "숨기기와 보이기",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "스프라이트를 애니메이션으로 만들기",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "방향키 사용하기",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "효과 넣기",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "음악",
    "gui.extension.music.description": "악기와 타악기를 연주하세요.",
    "gui.extension.pen.name": "펜",
    "gui.extension.pen.description": "스프라이트를 사용하여 그려 보세요. ",
    "gui.extension.videosensing.name": "비디오 감지",
    "gui.extension.videosensing.description": "카메라를 이용하여 움직임을 감지해 보세요.",
    "gui.extension.text2speech.name": "텍스트 음성 변환(TTS)",
    "gui.extension.text2speech.description": "프로젝트가 말을 하도록 만들어 보세요.",
    "gui.extension.translate.name": "번역",
    "gui.extension.translate.description": "텍스트를 여러 가지 언어로 번역해 보세요.",
    "gui.extension.makeymakey.description": "무엇이든지 키보드 자판으로 만들어 보세요.",
    "gui.extension.microbit.description": "프로젝트를 세계와 연결해 보세요.",
    "gui.extension.microbit.connectingMessage": "연결 중",
    "gui.extension.ev3.description": "감지하고 반응하는 로봇 등을 만들어 보세요.",
    "gui.extension.ev3.connectingMessage": "연결 중입니다. EV3의 pin이 1234로 설정되었는지 확인하세요.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "모터 및 센서를 이용하여 만들어 보세요. ",
    "gui.extension.wedo2.connectingMessage": "연결 중",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "모두",
    "gui.libraryTags.animals": "동물",
    "gui.libraryTags.dance": "댄스",
    "gui.libraryTags.effects": "효과",
    "gui.libraryTags.fantasy": "판타지",
    "gui.libraryTags.fashion": "패션",
    "gui.libraryTags.food": "음식",
    "gui.libraryTags.indoors": "실내",
    "gui.libraryTags.loops": "반복",
    "gui.libraryTags.music": "음악",
    "gui.libraryTags.notes": "음표",
    "gui.libraryTags.outdoors": "실외",
    "gui.libraryTags.patterns": "패턴",
    "gui.libraryTags.people": "사람들",
    "gui.libraryTags.percussion": "타악기",
    "gui.libraryTags.space": "우주",
    "gui.libraryTags.sports": "스포츠",
    "gui.libraryTags.underwater": "바닷속",
    "gui.libraryTags.voice": "목소리",
    "gui.libraryTags.wacky": "엉뚱한 소리",
    "gui.libraryTags.animation": "애니메이션",
    "gui.libraryTags.art": "예술",
    "gui.libraryTags.games": "게임",
    "gui.libraryTags.stories": "이야기",
    "gui.libraryTags.letters": "글자",
    "gui.opcodeLabels.direction": "방향",
    "gui.opcodeLabels.xposition": "x 좌표",
    "gui.opcodeLabels.yposition": "y 좌표",
    "gui.opcodeLabels.size": "크기",
    "gui.opcodeLabels.costumename": "모양 이름",
    "gui.opcodeLabels.costumenumber": "모양 번호",
    "gui.opcodeLabels.backdropname": "배경 이름",
    "gui.opcodeLabels.backdropnumber": "배경 번호",
    "gui.opcodeLabels.volume": "음량",
    "gui.opcodeLabels.tempo": "빠르기",
    "gui.opcodeLabels.answer": "대답",
    "gui.opcodeLabels.loudness": "음량",
    "gui.opcodeLabels.username": "사용자 이름",
    "gui.opcodeLabels.year": "년",
    "gui.opcodeLabels.month": "월",
    "gui.opcodeLabels.date": "일",
    "gui.opcodeLabels.dayofweek": "요일",
    "gui.opcodeLabels.hour": "시",
    "gui.opcodeLabels.minute": "분",
    "gui.opcodeLabels.second": "초",
    "gui.opcodeLabels.timer": "타이머",
    "gui.projectLoader.loadError": "The project file that was selected failed to load.",
    "gui.sharedMessages.backdrop": "배경 {index}",
    "gui.sharedMessages.costume": "모양 {index}",
    "gui.sharedMessages.sprite": "스프라이트 {index}",
    "gui.sharedMessages.pop": "팝",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "컴퓨터에서 가져오기",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "고대비",
    "gui.gui.defaultProjectTitle": "스크래치 프로젝트",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "[TIME] 초 동안 [NOTE] 번 음 울리기",
    "ev3.buttonPressed": " [PORT] 번 버튼이 눌러졌는가?",
    "ev3.getBrightness": "밝기",
    "ev3.getDistance": "거리",
    "ev3.getMotorPosition": "모터 [PORT] 위치",
    "ev3.motorSetPower": "[PORT] 모터 강도를 [POWER] %로 정하기",
    "ev3.motorTurnClockwise": "[PORT] 모터를 [TIME] 초 동안 이쪽으로 돌리기",
    "ev3.motorTurnCounterClockwise": "[PORT] 모터를 [TIME] 초 동안 저쪽으로 돌리기",
    "ev3.whenBrightnessLessThan": "밝기 <  [DISTANCE]일 때",
    "ev3.whenButtonPressed": "[PORT] 번 버튼이 눌러졌을 때",
    "ev3.whenDistanceLessThan": "거리 < [DISTANCE]일 때",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "아래쪽",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "왼쪽",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "오른쪽",
    "makeymakey.spaceKey": "스페이스",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "위쪽",
    "makeymakey.whenKeyPressed": "[KEY] 키를 눌렀을 때",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] 키를 순서대로 눌렀을 때",
    "microbit.buttonsMenu.any": "아무",
    "microbit.clearDisplay": "화면 지우기",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "[MATRIX] 보여주기",
    "microbit.displayText": "글자 [TEXT] 보여주기",
    "microbit.gesturesMenu.jumped": "점프하였을",
    "microbit.gesturesMenu.moved": "움직일",
    "microbit.gesturesMenu.shaken": "흔들어졌을",
    "microbit.isButtonPressed": "[BTN] 버튼이 눌려졌는가?",
    "microbit.isTilted": "[DIRECTION] 방향으로 기울어졌는가?",
    "microbit.pinStateMenu.off": "끄기",
    "microbit.pinStateMenu.on": "켜기",
    "microbit.tiltAngle": "[DIRECTION] 방향으로 기울어진 각도",
    "microbit.tiltDirectionMenu.any": "아무",
    "microbit.tiltDirectionMenu.back": "뒤쪽",
    "microbit.tiltDirectionMenu.front": "앞쪽",
    "microbit.tiltDirectionMenu.left": "왼쪽",
    "microbit.tiltDirectionMenu.right": "오른쪽",
    "microbit.whenButtonPressed": "[BTN] 버튼이 눌러졌을 때",
    "microbit.whenGesture": "[GESTURE] 때",
    "microbit.whenPinConnected": "[PIN]번 핀이 연결되었을 때",
    "microbit.whenTilted": "[DIRECTION] 방향으로 기울어졌을 때",
    "music.categoryName": "음악",
    "music.changeTempo": "빠르기를 [TEMPO] 만큼 바꾸기",
    "music.drumBass": "(2) 베이스 드럼",
    "music.drumBongo": "(13) 봉고",
    "music.drumCabasa": "(15) 카바사",
    "music.drumClaves": "(9) 클라베",
    "music.drumClosedHiHat": "(6) 닫힌 하이햇",
    "music.drumConga": "(14) 콩가",
    "music.drumCowbell": "(11) 카우벨 ",
    "music.drumCrashCymbal": "(4) 크래시 심벌",
    "music.drumCuica": "(18) 쿠이카 ",
    "music.drumGuiro": "(16) 귀로 ",
    "music.drumHandClap": "(8) 박수",
    "music.drumOpenHiHat": "(5) 열린 하이햇",
    "music.drumSideStick": "(3) 사이드 스틱",
    "music.drumSnare": "(1) 스네어 드럼 ",
    "music.drumTambourine": "(7) 탬버린",
    "music.drumTriangle": "(12) 트라이앵글 ",
    "music.drumVibraslap": "(17) 비브라슬랩 ",
    "music.drumWoodBlock": "(10) 나무 블록",
    "music.getTempo": "빠르기",
    "music.instrumentBass": "(6) 베이스",
    "music.instrumentBassoon": "(14) 바순",
    "music.instrumentCello": "(8) 첼로 ",
    "music.instrumentChoir": "(15) 합창단 ",
    "music.instrumentClarinet": "(10) 클라리넷 ",
    "music.instrumentElectricGuitar": "(5) 전자 기타 ",
    "music.instrumentElectricPiano": "(2) 전자 피아노 ",
    "music.instrumentFlute": "(12) 플루트 ",
    "music.instrumentGuitar": "(4) 기타",
    "music.instrumentMarimba": "(19) 마림바 ",
    "music.instrumentMusicBox": "(17) 뮤직 박스",
    "music.instrumentOrgan": "(3) 오르간",
    "music.instrumentPiano": "(1) 피아노",
    "music.instrumentPizzicato": "(7) 피치카토 ",
    "music.instrumentSaxophone": "(11) 색소폰 ",
    "music.instrumentSteelDrum": "(18) 스틸 드럼 ",
    "music.instrumentSynthLead": "(20) 신드 리드",
    "music.instrumentSynthPad": "(21) 신드 패드 ",
    "music.instrumentTrombone": "(9) 트럼본",
    "music.instrumentVibraphone": "(16) 비브라폰",
    "music.instrumentWoodenFlute": "(13) 나무 플루트 ",
    "music.midiPlayDrumForBeats": "[DRUM]번 타악기를 [BEATS] 박자로 연주하기",
    "music.midiSetInstrument": "악기를 [INSTRUMENT](으)로 정하기",
    "music.playDrumForBeats": "[DRUM]번 타악기를 [BEATS] 박자로 연주하기",
    "music.playNoteForBeats": "[NOTE]번 음을 [BEATS] 박자로 연주하기",
    "music.restForBeats": "[BEATS] 박자 쉬기 ",
    "music.setInstrument": "악기를 [INSTRUMENT](으)로 정하기",
    "music.setTempo": "빠르기를 [TEMPO](으)로 정하기",
    "pen.categoryName": "펜",
    "pen.changeColorParam": "펜 [COLOR_PARAM]을(를) [VALUE]만큼 바꾸기",
    "pen.changeHue": "펜 색깔을 [HUE]만큼 바꾸기",
    "pen.changeShade": "펜 명암을 [SHADE] 만큼 바꾸기 ",
    "pen.changeSize": "펜 굵기를 [SIZE] 만큼 바꾸기",
    "pen.clear": "모두 지우기",
    "pen.colorMenu.brightness": "명도",
    "pen.colorMenu.color": "색깔",
    "pen.colorMenu.saturation": "채도 ",
    "pen.colorMenu.transparency": "투명도",
    "pen.penDown": "펜 내리기",
    "pen.penUp": "펜 올리기",
    "pen.setColor": "펜 색깔을 [COLOR](으)로 정하기 ",
    "pen.setColorParam": "펜 [COLOR_PARAM]을(를) [VALUE](으)로 정하기",
    "pen.setHue": "펜 색깔을 [HUE](으)로 정하기",
    "pen.setShade": "펜 명암을 [SHADE](으)로 정하기 ",
    "pen.setSize": "펜 굵기를 [SIZE](으)로 정하기",
    "pen.stamp": "도장찍기",
    "speech.defaultWhenIHearValue": "시작합시다",
    "speech.extensionName": "음성 인식",
    "speech.listenAndWait": "듣고 기다리기",
    "speech.speechReporter": "인식된 말",
    "speech.whenIHear": "[PHRASE] 이(가) 들릴 때",
    "text2speech.alto": "중고음",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "안녕 ",
    "text2speech.giant": "저음",
    "text2speech.kitten": "고양이",
    "text2speech.setLanguageBlock": "언어를 [LANGUAGE]로 정하기",
    "text2speech.setVoiceBlock": "음성을 [VOICE]로 정하기",
    "text2speech.speakAndWaitBlock": "[WORDS] 말하기",
    "text2speech.squeak": "고음",
    "text2speech.tenor": "중저음",
    "translate.categoryName": "번역",
    "translate.defaultTextToTranslate": "안녕 ",
    "translate.translateBlock": "[WORDS]을(를) [LANGUAGE]로 번역하기",
    "translate.viewerLanguage": "언어",
    "videoSensing.categoryName": "비디오 감지",
    "videoSensing.direction": "방향",
    "videoSensing.motion": "동작",
    "videoSensing.off": "끄기",
    "videoSensing.on": "켜기",
    "videoSensing.onFlipped": "뒤집힌 상태로 켜기",
    "videoSensing.setVideoTransparency": "비디오 투명도를 [TRANSPARENCY] (으)로 정하기",
    "videoSensing.sprite": "스프라이트",
    "videoSensing.stage": "무대 ",
    "videoSensing.videoOn": "비디오 [ATTRIBUTE]에 대한 [SUBJECT]에서의 관찰값",
    "videoSensing.videoToggle": "비디오 [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "비디오 동작 > [REFERENCE]일 때 ",
    "wedo2.getDistance": "거리",
    "wedo2.getTiltAngle": "[TILT_DIRECTION] 방향으로 기울어진 각도",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] 방향으로 기울어졌는가?",
    "wedo2.motorDirection.backward": "저쪽",
    "wedo2.motorDirection.forward": "이쪽",
    "wedo2.motorDirection.reverse": "반대쪽",
    "wedo2.motorId.a": "모터 A",
    "wedo2.motorId.all": "모든 모터",
    "wedo2.motorId.b": "모터 B",
    "wedo2.motorId.default": "모터",
    "wedo2.motorOff": "[MOTOR_ID] 끄기",
    "wedo2.motorOn": "[MOTOR_ID] 켜기",
    "wedo2.motorOnFor": "[DURATION] 초 동안 [MOTOR_ID] 켜기",
    "wedo2.playNoteFor": "[NOTE] 번 음을 [DURATION]초 간 연주하기",
    "wedo2.setLightHue": "빛의 색을  [HUE]로 정하기",
    "wedo2.setMotorDirection": "[MOTOR_ID]의 방향을 [MOTOR_DIRECTION]으로 정하기",
    "wedo2.startMotorPower": "[MOTOR_ID] 모터 강도를 [POWER]로 정하기",
    "wedo2.tiltDirection.any": "아무",
    "wedo2.tiltDirection.down": "아래쪽",
    "wedo2.tiltDirection.left": "왼쪽",
    "wedo2.tiltDirection.right": "오른쪽",
    "wedo2.tiltDirection.up": "위쪽",
    "wedo2.whenDistance": "거리 [OP] [REFERENCE] 일 때",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY] 방향으로 기울일 때",
    "paint.paintEditor.hue": "색상",
    "paint.paintEditor.saturation": "채도",
    "paint.paintEditor.brightness": "명도",
    "paint.paintEditor.costume": "모양",
    "paint.paintEditor.group": "그룹화 적용",
    "paint.paintEditor.ungroup": "그룹화 해제",
    "paint.paintEditor.undo": "되돌리기",
    "paint.paintEditor.redo": "재시도",
    "paint.paintEditor.forward": "앞으로",
    "paint.paintEditor.backward": "뒤로",
    "paint.paintEditor.front": "맨 앞으로",
    "paint.paintEditor.back": "맨 뒤로",
    "paint.paintEditor.more": "기타",
    "paint.modeTools.brushSize": "크기",
    "paint.modeTools.eraserSize": "지우개 크기",
    "paint.modeTools.copy": "복사",
    "paint.modeTools.paste": "붙이기",
    "paint.modeTools.delete": "삭제",
    "paint.modeTools.curved": "굽은 모양",
    "paint.modeTools.pointed": "꺾인 모양",
    "paint.modeTools.thickness": "굵기",
    "paint.modeTools.flipHorizontal": "좌우 뒤집기",
    "paint.modeTools.flipVertical": "상하 뒤집기",
    "paint.modeTools.filled": "채우기",
    "paint.modeTools.outlined": "윤곽선",
    "paint.paintEditor.bitmap": "비트맵으로 바꾸기",
    "paint.paintEditor.vector": "벡터로 바꾸기",
    "paint.paintEditor.fill": "채우기 색",
    "paint.paintEditor.stroke": "윤곽선 색",
    "paint.brushMode.brush": "붓",
    "paint.eraserMode.eraser": "지우개",
    "paint.fillMode.fill": "채우기 색",
    "paint.lineMode.line": "선",
    "paint.ovalMode.oval": "원",
    "paint.rectMode.rect": "직사각형",
    "paint.reshapeMode.reshape": "형태 고치기",
    "paint.roundedRectMode.roundedRect": "모서리가 둥근 직사각형",
    "paint.selectMode.select": "선택",
    "paint.textMode.text": "텍스트",
    "paint.colorPicker.swap": "바꾸기"
  },
  "ha": {
    "gui.alerts.lostPeripheralConnection": "Scratch ya rasa sadarwa zuwa {extensionName}",
    "gui.alerts.tryAgain": "sake gwadawa",
    "gui.alerts.download": "saukar",
    "gui.connection.reconnect": "Sake haɗawa",
    "gui.backpack.costumeLabel": "fasali",
    "gui.backpack.soundLabel": "sauti",
    "gui.backpack.scriptLabel": "rubutun",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "masarrafa",
    "gui.backpack.errorBackpack": "An samu kuskuren buɗe masarrafa",
    "gui.backpack.loadingBackpack": "Ana buɗewa...",
    "gui.backpack.more": "ƙari",
    "gui.backpack.emptyBackpack": "babu komai a masarrafa ",
    "gui.unsupportedBrowser.label": "Burausar ba ta daidaituwa",
    "gui.unsupportedBrowser.errorLabel": "Kuskure Ya Faru",
    "gui.unsupportedBrowser.notRecommended": "Mun yi nadama sosai, amma yayi kama da ana amfani da sigar burauzar da Scratch baya daidaituwa da ita. Muna ba da shawarar ɗaukaka burauza zuwa mafi sabon sigar da zai daidaitu, kamar irin su Google Chrome, Mozilla Firefox, Microsoft Edge, ko Apple Safari.",
    "gui.unsupportedBrowser.description": "Mun yi nadama sosai, amma Scratch baya daidaituwa da wannan burauzar. Muna ba da shawarar ɗaukaka burauza zuwa mafi sabon sigar burauzar da  zai daidaitu kamar irin su Google Chrome, Mozilla Firefox, Microsoft Edge, ko Apple Safari.",
    "gui.unsupportedBrowser.back": "Baya",
    "gui.unsupportedBrowser.previewfaq": "Don ƙarin bayani, je zuwa {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "Tambayoyin da aka fi yi",
    "gui.cards.all-tutorials": "koyarwa",
    "gui.cards.shrink": "Rage",
    "gui.cards.expand": "Faɗaɗa",
    "gui.cards.close": "Kulle",
    "gui.cards.more-things-to-try": "Ƙarin abubuwan da za a gwada!",
    "gui.cards.see-more": "Duba ƙari",
    "gui.comingSoon.message1": "Kar ka damu, muna kan dubawa {emoji}",
    "gui.comingSoon.message2": "Yana nan Tafe...",
    "gui.comingSoon.message3": "Muna aiki a kai {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Babu na'urorin da aka samu",
    "gui.connection.auto-scanning.prescan": "Sanya na'urarka a kusa, sannan ka fara bincike.",
    "gui.connection.auto-scanning.pressbutton": "Danna madannin kan na'urarka.",
    "gui.connection.auto-scanning.start-search": "Fara Bincike",
    "gui.connection.connecting-searchbutton": "Bincikawa...",
    "gui.connection.auto-scanning.try-again": "Sake gwadawa",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Yana sadarwa",
    "gui.connection.disconnect": "Ba ya sadarwa",
    "gui.connection.go-to-editor": "Je zuwa wajen gyara",
    "gui.connection.connecting-cancelbutton": "Yana ƙoƙarin fara sadarwa...",
    "gui.connection.error.errorMessage": "Kash, da alama wani abu ya kuskure.",
    "gui.connection.error.tryagainbutton": "Sake gwadawa ",
    "gui.connection.error.helpbutton": "Taimoko",
    "gui.connection.peripheral-name-label": "Sunan na'ura",
    "gui.connection.connect": "Haɗa",
    "gui.connection.scanning.lookingforperipherals": "Neman na'urori",
    "gui.connection.scanning.noPeripheralsFound": "Babu na'urorin da aka samu",
    "gui.connection.scanning.instructions": "Zaɓi na'urar ka a cikin jerin da ke sama.",
    "gui.connection.search": "Sake sabuntawa",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Tabbatar cewa kana da rubutaccen mahaɗar Scratch (link) a ciki kuma yana aiki",
    "gui.connection.unavailable.enablebluetooth": "Duba cewa an kunna Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Sake gwadawa ",
    "gui.connection.unavailable.helpbutton": "taimoko",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Tafi",
    "gui.controls.stop": "Dakata",
    "gui.crashMessage.label": "Kash! wani abu ya samu matsala.",
    "gui.crashMessage.description": "Mun yi nadama sosai, amma da alama Scratch ya tsaya. An ba da rahoton wannan matsalar ga tawagar Scratch. Da fatan za ka sabunta shafin dan sake gwadawa.",
    "gui.crashMessage.errorNumber": "An shigar da kuskurenka da lambar {errorId}",
    "gui.crashMessage.reload": "Sake buɗewa",
    "gui.customProcedures.myblockModalTitle": "Yi wani tubali",
    "gui.customProcedures.addAnInputNumberText": "Ƙara shigarwar",
    "gui.customProcedures.numberTextType": "lamba ko rubutu",
    "gui.customProcedures.addAnInputBoolean": "Kara shigawar",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Ƙara laƙabi",
    "gui.customProcedures.runWithoutScreenRefresh": "Tafi ba tare da sabunta allo ba",
    "gui.customProcedures.cancel": "Soke",
    "gui.customProcedures.ok": "TOH",
    "gui.SpriteInfo.direction": "Mafuskanta",
    "gui.directionPicker.rotationStyles.allAround": "Ko'ina",
    "gui.directionPicker.rotationStyles.leftRight": "Hagu/Dama",
    "gui.directionPicker.rotationStyles.dontRotate": "Kar ka juya",
    "gui.gui.addExtension": "Ƙara Ƙari",
    "gui.gui.codeTab": "Lambar fasaha",
    "gui.gui.backdropsTab": "Hotunan fage",
    "gui.gui.costumesTab": "Fasali",
    "gui.gui.soundsTab": "sauti",
    "gui.extensionLibrary.comingSoon": "Yana nan tafe",
    "gui.extensionLibrary.requires": "Abun buƙata",
    "gui.extensionLibrary.collaboration": "Haɗin kai tare da",
    "gui.library.filterPlaceholder": "Bincika",
    "gui.library.allTag": "Duka",
    "gui.loader.message1": "Ƙirƙirar tubalai…",
    "gui.loader.message2": "Ana buɗo sprites…",
    "gui.loader.message3": "Ana buɗo sautuna…",
    "gui.loader.message4": "Ana buɗo ƙareƙare ...",
    "gui.loader.message5": "Ana kiwon maguna ...",
    "gui.loader.message6": "Ana watsa nanos…",
    "gui.loader.message7": "Haɓaka gobos…",
    "gui.loader.message8": "Ana shirya emojis…",
    "gui.loader.headline": "Ana buɗa aiki",
    "gui.loader.creating": "Ana Ƙirƙirar Aiki",
    "gui.accountMenu.profile": "Bayanan mai aiki",
    "gui.accountMenu.myStuff": "Kaya na",
    "gui.accountMenu.myClasses": "Azuzuwa na",
    "gui.accountMenu.myClass": "Aji na",
    "gui.accountMenu.accountSettings": "Saita bayanan asusu",
    "gui.accountMenu.signOut": "Fita",
    "gui.authorInfo.byUser": "ta {username}",
    "gui.menuBar.seeProjectPage": "Duba Shafin Aiki",
    "gui.menuBar.language": "Language",
    "general.username": "Sunan mai amfani",
    "general.password": "kalmar bada iznin wucewa",
    "general.signIn": "Shiga",
    "login.needHelp": "Bukatar Taimako?",
    "form.validationRequired": "ana buƙatar cike wannan fillin ",
    "gui.menuBar.tutorialsLibrary": "Koyarwa",
    "gui.menuBar.restoreSprite": "Sabunta Sprite",
    "gui.menuBar.restoreSound": "Sabunta sauti",
    "gui.menuBar.restoreCostume": "Sabunta fasali",
    "gui.menuBar.restore": "Sabuntawa",
    "gui.menuBar.saveNow": "Ajiye yanzu",
    "gui.menuBar.saveAsCopy": "Ajiye a matsayin kwafi",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Sabo",
    "gui.menuBar.file": "Fayil",
    "gui.menuBar.downloadToComputer": "Ajiye a kwamfutarka",
    "gui.menuBar.edit": "Gyara",
    "gui.menuBar.turboModeOff": "Kashe yanayin hanzari",
    "gui.menuBar.turboModeOn": "Kunna yanayin hanzari",
    "gui.menuBar.modeMenu": "Yanayi",
    "gui.menuBar.normalMode": "Yanayin ainihi",
    "gui.menuBar.caturdayMode": "yanayi sauyayye",
    "gui.menuBar.joinScratch": "Shiga Scratch",
    "gui.menuBar.signIn": "Shiga",
    "gui.gui.projectTitlePlaceholder": "Taken aikin anan",
    "gui.menuBar.saveNowLink": "Ajiye Yanzu",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "An yaɗa",
    "gui.menuBar.share": "Yaɗa",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "taimako",
    "gui.modal.back": "Baya",
    "gui.monitor.listMonitor.empty": "(Ba komai)",
    "gui.monitor.listMonitor.listLength": "Tsayi {length}",
    "gui.monitor.contextMenu.default": "asalin karatu",
    "gui.monitor.contextMenu.large": "babban karatu",
    "gui.monitor.contextMenu.slider": "mai zamewa",
    "gui.monitor.contextMenu.sliderRange": "canza kewayen mai zamewa",
    "gui.monitor.contextMenu.import": "shigo da",
    "gui.monitor.contextMenu.export": "fidda",
    "gui.monitor.contextMenu.hide": "ɓoye",
    "gui.playButton.play": "Kunna",
    "gui.playButton.stop": "Dakata",
    "gui.gui.variableScopeOptionAllSprites": "Ga duka sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Ga wannan sprite ɗin kawai",
    "gui.gui.cloudVariableOption": "Yanayin canjin girgije (an adana akan saba)",
    "gui.gui.variablePromptAllSpritesMessage": "Wannan abun mai canzawa zai samu ga duka sprites.",
    "gui.gui.listPromptAllSpritesMessage": "Wannan jerin zai samu ga duka sprites.",
    "gui.prompt.cancel": "Soke",
    "gui.prompt.ok": "TOH",
    "gui.playbackStep.stopMsg": "Dakata",
    "gui.playbackStep.playMsg": "Kunna",
    "gui.playbackStep.loadingMsg": "Ana lodawa...",
    "gui.playbackStep.saveMsg": "Ajiye",
    "gui.playbackStep.reRecordMsg": "Sake-ɗaukar tariya",
    "gui.recordModal.title": "ɗauki tariyar sauti",
    "gui.recordingStep.beginRecord": "Fara ɗaukar tariya ta hanyar danna madannin da ke ƙasa",
    "gui.recordingStep.permission": "{arrow}Muna buƙatar izinin ka domin yin amfani da na'urar ɗaukar sautin ka",
    "gui.recordingStep.stop": "Dakatar da ɗaukar tariya",
    "gui.recordingStep.record": "ɗaukar tariya",
    "gui.sliderModal.min": "Mafi ƙarancin ƙima",
    "gui.sliderModal.max": "Mafi girman ƙima",
    "gui.sliderModal.title": "Canza kewayon darjewa",
    "gui.sliderPrompt.cancel": "Soke",
    "gui.sliderPrompt.ok": "TOH",
    "gui.soundEditor.sound": "Sauti",
    "gui.soundEditor.play": "Kunna",
    "gui.soundEditor.stop": "Dakata",
    "gui.soundEditor.copy": "Kwafa",
    "gui.soundEditor.paste": "Manna",
    "gui.soundEditor.copyToNew": "Kwafa zuwa Sabo",
    "gui.soundEditor.delete": "Goge",
    "gui.soundEditor.save": "Ajiye",
    "gui.soundEditor.undo": "warware ",
    "gui.soundEditor.redo": "Sake yi",
    "gui.soundEditor.faster": "Kara sauri",
    "gui.soundEditor.slower": "Sannu a hankali",
    "gui.soundEditor.echo": "amsa kuwa",
    "gui.soundEditor.robot": "mutum-mutumi mai aiki da na'urar fasaha",
    "gui.soundEditor.louder": "Da ƙarfi",
    "gui.soundEditor.softer": "Da laushi",
    "gui.soundEditor.reverse": "da baya",
    "gui.soundEditor.fadeOut": "ɓace a hankali",
    "gui.soundEditor.fadeIn": "fito a hankali",
    "gui.soundEditor.mute": "Yi shiru",
    "gui.SpriteInfo.spritePlaceholder": "Suna",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Nuna",
    "gui.SpriteInfo.size": "Girma",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kofi",
    "gui.spriteSelectorItem.contextMenuExport": "fitarwa",
    "gui.spriteSelectorItem.contextMenuDelete": "goge",
    "gui.spriteSelector.addSpriteFromLibrary": "Zaɓi Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Fenti",
    "gui.spriteSelector.addSpriteFromSurprise": "Ban Mamaki",
    "gui.spriteSelector.addSpriteFromFile": "Sanya Sprite",
    "gui.stageHeader.stageSizeLarge": "Canja zuwa babban mataki",
    "gui.stageHeader.stageSizeSmall": "Canja zuwa ƙaramin mataki",
    "gui.stageHeader.stageSizeFull": "Shigar da yanayin cikakken allo",
    "gui.stageHeader.stageSizeUnFull": "Fita daga yanayin cikakken allo",
    "gui.stageHeader.fullscreenControl": "Ikon cikakken allo",
    "gui.spriteSelector.addBackdropFromLibrary": "Zaɓi hoton fage",
    "gui.stageSelector.addBackdropFromPaint": "Fenti",
    "gui.stageSelector.addBackdropFromSurprise": "Ban Mamaki",
    "gui.stageSelector.addBackdropFromFile": "Saka hoton fage",
    "gui.stageSelector.stage": "Mataki",
    "gui.stageSelector.backdrops": "hotunan fage",
    "gui.telemetryOptIn.label": "Yi rahoton ƙididdiga dan inganta Scratch",
    "gui.telemetryOptIn.body1": "Tawagar Scratch koyaushe tana neman fahimtar yadda ake amfani da Scratch a duniya. Dan taimakawa wannan ƙoƙarin, zaka iya ƙyale Scratch ya aika bayanan yadda ake amfani da shi da kansa zuwa Tawagar Scratch.",
    "gui.telemetryOptIn.body2": "Bayanan da muke tattarawa sun haɗa da zaɓin harshe, amfanin tubali, da wasu abubuwan da ke faruwa kamar adanawa, buɗewa, da saka aiki. BA mu tattara kowanne bayanin sirri. Da fatan za a duba {privacyPolicyLink} dan ƙarin bayani.",
    "gui.telemetryOptIn.privacyPolicyLink": " ƙa'idojin sirri",
    "gui.telemetryOptIn.optInText": "Yaɗa bayanan amfanin data na tare da Tawagar Scratch",
    "gui.telemetryOptIn.optInTooltip": "Kunna telemetry",
    "gui.telemetryOptIn.optOutText": "Kada ku yaɗa bayanan amfanin data na tare da Tawagar Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Kashe telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "An sabunta saitin ka.",
    "gui.telemetryOptIn.buttonClose": "Kulle",
    "gui.turboMode.active": "Yanayin hanzari",
    "gui.webglModal.label": "Burauzar bata daidaituwa da WebGL",
    "gui.webglModal.description": "Abin takaici, yana kama da burauzar ka ko kwamfutar {webGlLink}. Ana buƙatar wannan fasahar don Scratch 3.0 ya gudana.",
    "gui.webglModal.webgllink": "ba ya daidaituwa da WebGL",
    "gui.webglModal.back": "Baya",
    "gui.webglModal.previewfaq": "Don ƙarin bayani, je zuwa {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "Tambayoyin da aka fi yi",
    "gui.costumeLibrary.chooseABackdrop": "Zaɓi hoton fage",
    "gui.costumeLibrary.chooseACostume": "Zaɓi fasali",
    "gui.costumeTab.addBackdropFromLibrary": "Zaɓi hoton fage",
    "gui.costumeTab.addCostumeFromLibrary": "Zaɓi fasali",
    "gui.costumeTab.addBlankCostume": "Fenti",
    "gui.costumeTab.addSurpriseCostume": "Ban Mamaki",
    "gui.costumeTab.addFileBackdrop": "Saka hoton fage",
    "gui.costumeTab.addFileCostume": "Saka fasali",
    "gui.extensionLibrary.chooseAnExtension": "Zaɓi ƙari",
    "gui.extensionLibrary.extensionUrl": "shigar da URL ɗin ƙarin",
    "gui.monitors.importListColumnPrompt": "Wanne ginshiƙi ya kamata a yi amfani da (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "An kasa fara ɗaukar tariya",
    "gui.soundLibrary.chooseASound": "Zaɓi Sauti",
    "gui.soundTab.fileUploadSound": "Saka sauti",
    "gui.soundTab.surpriseSound": "Ban Mamaki",
    "gui.soundTab.recordSound": "ɗaukar tariya",
    "gui.soundTab.addSoundFromLibrary": "Zaɓi Sauti",
    "gui.spriteLibrary.chooseASprite": "Zaɓi Sprite",
    "gui.tipsLibrary.tutorials": "Zaɓi koyarwa",
    "gui.alerts.createsuccess": "An ƙirƙiri sabon aiki.",
    "gui.alerts.createcopysuccess": "An ajiye aikin a matsayin kwafi.",
    "gui.alerts.createremixsuccess": "An ajiye aikin a matsayin remix.",
    "gui.alerts.creating": "Ƙirƙirar sabo…",
    "gui.alerts.creatingCopy": "Ana kwafin aikin…",
    "gui.alerts.creatingRemix": "Ana sabunta aikin…",
    "gui.alerts.creatingError": "An kasa haɗa aikin. A yi haƙuri a sake gwadawa!",
    "gui.alerts.savingError": "an kasa ajiye aikin",
    "gui.alerts.savesuccess": "An ajiye aikin.",
    "gui.alerts.saving": "Ana Ajiye aikin…",
    "gui.alerts.cloudInfo": "Dan Allah a lura, girgijen ma'adanan kwamfuta mai iya canzawa ya na iya tallafawa lambobi ne kawai, banda haruffa ko alamomi.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Samu Ƙarin bayani",
    "gui.alerts.importing": "Ana shigo da…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "abubuwa masu canzawa na",
    "gui.howtos.intro-move-sayhello-hat.name": "Farawa",
    "gui.howtos.intro-move.step_stepMove": "Ƙara tubalin motsi",
    "gui.howtos.add-a-move-block.step_stepSay": "Ƙara tubalin cewa",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Danna alamar koriyar tuta dan farawa",
    "gui.howtos.intro-getting-started-ASL.name": "Farawa - ASL",
    "gui.howtos.animate-a-name.name": "Sa suna ya motsa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Zabi Harafin sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Kunna Sauti Lokacin da aka Danna",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Zabi Wani Harafi Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Canza launi",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Zaɓi wani harafi Sprite sannan a sanya shi ya juya",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Zaɓi wani harafi Sprite sannan a sa shi ya girma",
    "gui.howtos.imagine": "Yi tunanin wata duniya",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Rubuta abin da kake son faɗi",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Danna koriyar tuta dan farawa",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Zaɓi kowane hoton fage",
    "gui.howtos.imagine.step_imagineChooseSprite": "Zaɓi kowane Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "dannna madannin gurbi dan tafiya",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Zaɓi wani sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Matsa Hagu-Dama",
    "gui.howtos.imagine.step_imagineUpDown": "Matsa Sama-ƙasa",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Canza fasali",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Matsa zuwa wani wuri",
    "gui.howtos.imagine.step_imagineGrowShrink": "Yin girma da Ƙanƙancewa",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Zaɓi wani hoton fagen",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Sauya hoton fage",
    "gui.howtos.imagine.step_imagineRecordASound": "Ƙara Sauti",
    "gui.howtos.imagine.step_imagineChooseSound": "Zaɓi Sautin ka",
    "gui.howtos.make-music.name": "haɗa kiɗa",
    "gui.howtos.Make-Music.step_PickInstrument": "Zaɓi kayan aiki Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Kunna Sauti Lokacin da Aka danna",
    "gui.howtos.Make-Music.step_MakeSong": "Ƙirƙiri waƙa",
    "gui.howtos.make-music.step_MakeBeat": "Zaɓi ganga sai a haɗa bugu",
    "gui.howtos.make-music.step_MakeBeatBox": "Zaɓi na'urar sautin Sprite da akwatin bugun mamaki",
    "gui.howtos.story.name": "Ƙirƙiri Labari",
    "gui.howtos.story.step_addbg": "Ƙara hoton fage",
    "gui.howtos.story.step_addsprite": "Ƙara ɗan wasa",
    "gui.howtos.story.step_saysomething": "Ce wani abu",
    "gui.howtos.story.step_addanothersprite": "Ƙara wani ɗan wasan",
    "gui.howtos.story.step_flip": "Juya mafuskanta ",
    "gui.howtos.story.step_conversation": "Yi Tattaunawa",
    "gui.howtos.story.addanotherbg": "Ƙara wani hoton fagen",
    "gui.howtos.story.step_swithbg": "Canza hoton fage",
    "gui.howtos.story.step_hidewizard": "ɓoye ɗan wasa",
    "gui.howtos.story.step_showwizard": "Nuna ɗan wasa",
    "gui.howtos.make-a-chase-game.name": "haɗa wasan farauta",
    "gui.howtos.Chase-Game.step_BG": "Ƙara hoton fage",
    "gui.howtos.chase-game.step_AddOcto": "Ƙara Sprite",
    "gui.howtos.make-music.step_LeftRight": "Matsa Dama da Hagu da madannan kibiya",
    "gui.howtos.Chase-Game.step_UpDown": "Matsa sama da ƙasa da madannan kibiya",
    "gui.howtos.Chase-Game.step_AddStar": "Ƙara Wani Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Matsa a hargitse",
    "gui.howtos.Chase-Game.step_WhenTouch": "A cikin Octopus Sprite, lokacin da ake taɓa kunna sauti",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Ƙirƙiri maki mai canzawa",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "A cikin Octopus Sprite, lokacin da ake taɓa Ƙara maki",
    "gui.howtos.animate-char.name": "Sa ɗan wasan ya zama mai motsi",
    "gui.howtos.animate-char.step_addbg": "Ƙara hoton fage",
    "gui.howtos.animate-char.step_addsprite": "Ƙara Sprite",
    "gui.howtos.animate-char.step_saysomething": "Ce wani abu",
    "gui.howtos.animate-char.step_addsound": "Ƙara sauti ",
    "gui.howtos.animate-char.step_animatetalking": "Yi motsi da yin magana",
    "gui.howtos.animate-char.step_arrowkeys": "Matsa ta amfani da madannin Kibiya",
    "gui.howtos.animate-char.step_jump": "Tsalle",
    "gui.howtos.animate-char.step_changecolor": "Canza Launi",
    "gui.howtos.make-a-game.name": "Yi Wasan Danne Danne",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Zaɓi sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Kunna Sauti Lokacin da aka Danna",
    "gui.howtos.make-a-game.step_GameAddScore": "Ƙirƙiri maki mai sauyawa",
    "gui.howtos.make-a-game.step_GameChangeScore": "Lokacin da aka Danna Ƙara Maki",
    "gui.howtos.make-a-game.step_Random": "Je zuwa matsayi a hargitse",
    "gui.howtos.make-music.step_GameChangeColor": "Canza launi",
    "gui.howtos.make-music.step_ResetScore": "Sake saita Maki",
    "gui.howtos.make-it-fly.name": "Saka shi ya tashi sama",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Zaɓi hoton fage mai kamar sama",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Zaɓi ɗan wasa",
    "gui.howtos.fly.step_stepflySaySomething": "Ce wani abu",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Matsa da madannan kibiya",
    "gui.howtos.fly.step_stepflyChooseObject": "Zaɓi Abun da za a Tattara",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Sa abun ya matsa",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Zaɓi dan wasan ka",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ƙara Maki",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Riƙe Maki",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ƙara abun kwalliya",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Matsar da abun kwalliya",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Fasali na gaba",
    "gui.howtos.pong": "Wasan pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Ƙara hoton fage",
    "gui.howtos.pong.step_pongAddBallSprite": "Ƙara Sprite na kwallo",
    "gui.howtos.pong.step_pongBounceAround": "Maimaita tsalle a kewaye",
    "gui.howtos.pong.step_pongAddPaddle": "Kara filafili",
    "gui.howtos.pong.step_pongMoveThePaddle": "Matsar da filafili",
    "gui.howtos.pong.step_pongSelectBallSprite": "zabi sprite na kwallo",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ƙara Lamba dan maimaita tsallen Ƙwallon zuwa gefen filafilin",
    "gui.howtos.pong.step_pongAddAScore": "Ƙara Maki",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Zaɓi 'Maki' daga Mazaɓa",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Saka tubalin 'canza maki'",
    "gui.howtos.pong.step_pongResetScore": "Sake saita Maki",
    "gui.howtos.pong.step_pongAddLineSprite": "Ƙara Layin Sprite",
    "gui.howtos.pong.step_pongGameOver": "Wasa Ya Ƙare",
    "gui.howtos.code-cartoon": "yi ma zanen ban dariya lambar sirri",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Faɗi Wani Abu Lokacin Da Ka Danna Koriyar Tutar",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Mayar da dan wasan zane mai motsi Lokacin da Ka Danna Shi",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Zaɓi wani ɗan wasan Na daban",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Yi amfani da Alamar Ragewa dan Ƙanƙantarwa",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Sa ɗan wasa ya yi Girma ya kuma Ƙanƙance",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Zaɓi ɗan wasa na daban",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Yi tsalle sama da ƙasa",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Danna ɗan wasa dan canza yanayin kwalliya",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Zame a kewaye",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Canza fasali ",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Zaɓi ƙarin yan wasa dan ƙara ma zanen ban dariyan ka",
    "gui.howtos.cartoon-network": "Mayar da wasan kasada mai motsi",
    "gui.howtos.cartoon-network.step_CNcharacter": "Zaɓi dan wasa da za a bayyana",
    "gui.howtos.cartoon-network.step_CNsay": "Fadi Wani Abu",
    "gui.howtos.cartoon-network.step_CNglide": "Zame a Kewaye",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Zaɓi Abun da za a bi",
    "gui.howtos.cartoon-network.step_CNcollect": "Tattara Abubuwa",
    "gui.howtos.cartoon-network.step_CNvariable": "Yi Maki mai canzawa",
    "gui.howtos.cartoon-network.step_CNscore": "Ajiye Maki",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Matakin Sama: Canza hoton fage",
    "gui.howtos.videosens.name": "Fasahar gano yanayin bidiyo",
    "gui.howtos.videosens.step_addextension": "Ƙara Ƙari",
    "gui.howtos.videosens.step_pet": "Wasa da Mage",
    "gui.howtos.videosens.step_animate": "maidawa zuwa motsi",
    "gui.howtos.videosens.step_pop": "buga balan-balan",
    "gui.howtos.say-it-out-loud": "Ƙirƙiri zane mai motsi da ke Magana",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ƙara tubalin maida rubutu zuwa magana",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Fadi wani abu",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Saita Murya",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Zagaya",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ƙara hoton fage",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ƙara wani ɗan wasa",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Rera waƙa",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Canza launi",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Juya a Kewaye",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Yi girma sai a Ƙanƙance",
    "gui.howtos.talking": "Maganan Tatsuniya",
    "gui.howtos.talking.step_talesAddExtension": "Danna domin Ƙara Tubalan maida Rubutu zuwa Magana",
    "gui.howtos.talking.step_talesChooseSprite": "Zaɓi Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Saka ɗan wasa yayi Magana ",
    "gui.howtos.talking.step_talesChooseBackdrop": "Zaɓi hoton fage",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Danna ɗan wasa dan zuwa ga hoton fage na gaba",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Zabi Wani Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Zagaya",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Zaɓi wani hoton fage",
    "gui.howtos.talking.step_talesAnimateTalking": "Mayar zuwa motsi mai magana",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Zaɓi wani hoton fagen",
    "gui.howtos.talking.step_talesChooseSound": "Zaɓi waƙar da za a yi ma rawa",
    "gui.howtos.talking.step_talesDanceMoves": "Motsin rawa",
    "gui.howtos.talking.step_talesAskAnswer": "Samu Tubalan Tambaya da Amsa daga tsinkayar ganowa",
    "gui.howtos.add-sprite.name": "Ƙara Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Ƙara Sprite",
    "gui.howtos.add-a-backdrop.name": "Ƙara hoton fage",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ƙara hoton fage",
    "gui.howtos.change-size.name": "Canza Girma",
    "gui.howtos.change-size.step_changeSize": "Canza Girma",
    "gui.howtos.glide-around.name": "Zame a Kewaye",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Zame a Kewaye",
    "gui.howtos.change-size.step_glideAroundPoint": "Zame zuwa wani wurin",
    "gui.howtos.record-a-sound.name": "Yi tariyar Sauti",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Danna allon 'Sauti' ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Danna 'ɗaukar tariya'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Danna madannin ɗaukar tariya",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Zabi Sautin ka",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Kunna Sautin ka",
    "gui.howtos.spin-video.name": "Sa shi ya juya",
    "gui.howtos.change-size.step_spinTurn": "Juya",
    "gui.howtos.change-size.step_spinPointInDirection": "Saita mafuskanta ",
    "gui.howtos.hide-and-show.name": "Boyewa da Nunawa",
    "gui.howtos.change-size.step_hideAndShow": "Boyewa da Nunawa",
    "gui.howtos.switch-costume.name": "Mayar da Sprite zuwa zane mai motsi",
    "gui.howtos.change-size.step_switchCostumes": "Mayar da sprite zuwa zane mai motsi",
    "gui.howtos.move-around-with-arrow-keys.name": "Yi amfani da madannan kibiya",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Matsa Hagu da Dama",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Matsa sama da ƙasa",
    "gui.howtos.add-effects.name": "Ƙara tsaruka",
    "gui.howtos.videosens.step_addEffects": "Ƙara tsaruka",
    "gui.extension.music.name": "Kiɗa",
    "gui.extension.music.description": "Buga kayan kiɗa da ganga",
    "gui.extension.pen.name": "Alƙalami",
    "gui.extension.pen.description": "Zana da sprites dinka.",
    "gui.extension.videosensing.name": "fasahar gano yanayin bidiyo ",
    "gui.extension.videosensing.description": "gano motsi da kamara.",
    "gui.extension.text2speech.name": "Rubutu zuwa Magana",
    "gui.extension.text2speech.description": "Sanya ayyukanka suyi magana.",
    "gui.extension.translate.name": "Fassara",
    "gui.extension.translate.description": "Fassara rubutu zuwa yaruka da yawa.",
    "gui.extension.makeymakey.description": "Maida komai zuma madanni.",
    "gui.extension.microbit.description": "Sada ayyukanka zuwa ga duniya.",
    "gui.extension.microbit.connectingMessage": "Yana Sadarwa",
    "gui.extension.ev3.description": "Gina mutum-mutumi masu mu'amala da kuma ƙari.",
    "gui.extension.ev3.connectingMessage": "Yana sadarwa. Tabbatar cewa fin ɗin dake a EV3 ɗinka an saita shi zuwa 1234.",
    "gui.extension.boost.description": "Maida ƙirƙire-ƙirƙiren mutum-mutumi masu fasaha zuwa rayuwa.",
    "gui.extension.boost.connectingMessage": "Yana sadarwa",
    "gui.extension.wedo2.description": "Gina tare da mota da kuma na'urar ganowa",
    "gui.extension.wedo2.connectingMessage": "Yana Sadarwa",
    "gui.extension.gdxfor.description": "Gano turi, ja, motsi da juyi.",
    "gui.extension.gdxfor.connectingMessage": "Yana sadarwa ",
    "gui.libraryTags.all": "Duka",
    "gui.libraryTags.animals": "dabbobi",
    "gui.libraryTags.dance": "rawa",
    "gui.libraryTags.effects": "Tasirin",
    "gui.libraryTags.fantasy": "Ruɗi",
    "gui.libraryTags.fashion": "Salon ƙawatarwa",
    "gui.libraryTags.food": "Abinci",
    "gui.libraryTags.indoors": "Daga ciki",
    "gui.libraryTags.loops": "Maimaituwa",
    "gui.libraryTags.music": "Waka",
    "gui.libraryTags.notes": "Rubutu",
    "gui.libraryTags.outdoors": "Daga waje",
    "gui.libraryTags.patterns": "Tsaruka",
    "gui.libraryTags.people": "Mutane",
    "gui.libraryTags.percussion": "Goguwa",
    "gui.libraryTags.space": "Gurbi",
    "gui.libraryTags.sports": "Wasanni",
    "gui.libraryTags.underwater": "Karkashin ruwa",
    "gui.libraryTags.voice": "Murya",
    "gui.libraryTags.wacky": "Marar tsari",
    "gui.libraryTags.animation": "Zane mai motsi",
    "gui.libraryTags.art": "Zanen fasaha",
    "gui.libraryTags.games": "Wasanni",
    "gui.libraryTags.stories": "Labarai",
    "gui.libraryTags.letters": "harfofi",
    "gui.opcodeLabels.direction": "mafuskanta",
    "gui.opcodeLabels.xposition": "matsayin x",
    "gui.opcodeLabels.yposition": "matsayin y",
    "gui.opcodeLabels.size": "Girma",
    "gui.opcodeLabels.costumename": "Sunan fasali",
    "gui.opcodeLabels.costumenumber": "Lambar fasali ",
    "gui.opcodeLabels.backdropname": "Sunan hoton fage ",
    "gui.opcodeLabels.backdropnumber": "Lambar hoton fage ",
    "gui.opcodeLabels.volume": "ƙarfin sauti",
    "gui.opcodeLabels.tempo": "Saurin sauti",
    "gui.opcodeLabels.answer": "Amsa",
    "gui.opcodeLabels.loudness": "Yanayin ƙara",
    "gui.opcodeLabels.username": "Sunnan mai amfani",
    "gui.opcodeLabels.year": "Shekara",
    "gui.opcodeLabels.month": "Wata",
    "gui.opcodeLabels.date": "Kwanan wata",
    "gui.opcodeLabels.dayofweek": "ranar mako",
    "gui.opcodeLabels.hour": "sa'a ",
    "gui.opcodeLabels.minute": "minti ",
    "gui.opcodeLabels.second": "Daƙiƙa",
    "gui.opcodeLabels.timer": "Abun ƙidayar lokaci ",
    "gui.projectLoader.loadError": "Fayil ɗin aikin da aka zaɓa ya kasa buɗewa",
    "gui.sharedMessages.backdrop": "hoton fage {index}",
    "gui.sharedMessages.costume": "Fasali{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Shin za a canza abubuwan da ke cikin wannan aikin na yanzu?",
    "gui.sharedMessages.loadFromComputerTitle": "buɗe daga kwanfutarka",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Aikin scratch",
    "boost.color.any": "kowane launi",
    "boost.color.black": "baƙi",
    "boost.color.blue": "shuɗi",
    "boost.color.green": "kore",
    "boost.color.red": "ja",
    "boost.color.white": "fari",
    "boost.color.yellow": "rawaya",
    "boost.getMotorPosition": "matsayin moto [MOTOR_REPORTER_ID] ",
    "boost.getTiltAngle": "karkata kwanar [TILT_DIRECTION]",
    "boost.motorDirection.backward": "waccan hanyar",
    "boost.motorDirection.forward": "wannan hanyar",
    "boost.motorDirection.reverse": "da baya",
    "boost.motorOff": "kashe motar [MOTOR_ID]",
    "boost.motorOn": "kunna motar [MOTOR_ID]",
    "boost.motorOnFor": "juya motar [MOTOR_ID] na daƙiƙoƙi [DURATION] ",
    "boost.motorOnForRotation": "juya motar [MOTOR_ID] na juyawa [ROTATION] ",
    "boost.seeingColor": "ganin tubalin [COLOR] ?",
    "boost.setLightHue": "saita launin haske zuwa [HUE]",
    "boost.setMotorDirection": "saita motar [MOTOR_ID] mafuskantar [MOTOR_DIRECTION]",
    "boost.setMotorPower": "saita gudun motar [MOTOR_ID] zuwa [POWER] %",
    "boost.tiltDirection.any": "kowanne ",
    "boost.tiltDirection.down": "ƙasa",
    "boost.tiltDirection.left": "hagu",
    "boost.tiltDirection.right": "dama",
    "boost.tiltDirection.up": "sama",
    "boost.whenColor": "a lokacin da aka ga tubalin [COLOR] ",
    "boost.whenTilted": "a lokacin da aka karkata [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "yi ƙaran bif ɗin  [NOTE] na daƙiƙa [TIME]",
    "ev3.buttonPressed": "an danna madannin [PORT] ?",
    "ev3.getBrightness": "haske",
    "ev3.getDistance": "nisa",
    "ev3.getMotorPosition": "matsayin motar [PORT]",
    "ev3.motorSetPower": "motar [PORT] saita ƙarfi [POWER] %",
    "ev3.motorTurnClockwise": "motar [PORT] juya wannan hanyar na daƙiƙoƙi [TIME] ",
    "ev3.motorTurnCounterClockwise": "motar [PORT] juya waccan hanyar na daƙiƙoƙi [TIME] ",
    "ev3.whenBrightnessLessThan": "a lokacin da haske < [DISTANCE]",
    "ev3.whenButtonPressed": "a lokacin da aka danna madannin [PORT] ",
    "ev3.whenDistanceLessThan": "a lokacin da nisa < [DISTANCE]",
    "gdxfor.getAcceleration": "sauri [DIRECTION]",
    "gdxfor.getForce": "ƙarfi",
    "gdxfor.getSpin": "gudun juyawa [DIRECTION]",
    "gdxfor.getTilt": "karkata kwanar [TILT]",
    "gdxfor.isFreeFalling": "faɗuwa?",
    "gdxfor.isTilted": "an karkata [TILT]",
    "gdxfor.pulled": "an ja",
    "gdxfor.pushed": "an tura",
    "gdxfor.shaken": "an girgiza",
    "gdxfor.startedFalling": "ya fara faɗuwa",
    "gdxfor.tiltDirectionMenu.any": "kowanne ",
    "gdxfor.tiltDirectionMenu.back": "baya",
    "gdxfor.tiltDirectionMenu.front": "gaba",
    "gdxfor.tiltDirectionMenu.left": "hagu",
    "gdxfor.tiltDirectionMenu.right": "dama",
    "gdxfor.turnedFaceDown": "an juya fuskar na kallon ƙasa",
    "gdxfor.turnedFaceUp": "an juya fuskar na kallon sama",
    "gdxfor.whenForcePushedOrPulled": "a lokacin da na'urar gano ƙarfi a [PUSH_PULL]",
    "gdxfor.whenGesture": "a lokacin da [GESTURE]",
    "gdxfor.whenTilted": "a lokacin da aka karkata [TILT]",
    "makeymakey.downArrow": "kibiyar ƙasa",
    "makeymakey.downArrowShort": "ƙasa",
    "makeymakey.leftArrow": "kibiyar hagu",
    "makeymakey.leftArrowShort": "hagu",
    "makeymakey.rightArrow": "kibiyar dama",
    "makeymakey.rightArrowShort": "dama",
    "makeymakey.spaceKey": "gurbi",
    "makeymakey.upArrow": "kibiyar sama",
    "makeymakey.upArrowShort": "sama",
    "makeymakey.whenKeyPressed": "a lokacin da aka danna madannin [KEY] ",
    "makeymakey.whenKeysPressedInOrder": "a lokacin da aka danna [SEQUENCE] a tsari",
    "microbit.buttonsMenu.any": "kowanne ",
    "microbit.clearDisplay": "share nunawa",
    "microbit.defaultTextToDisplay": "Barka!",
    "microbit.displaySymbol": "nuna [MATRIX]",
    "microbit.displayText": "nuna rubutun [TEXT]",
    "microbit.gesturesMenu.jumped": "anyi tsalle",
    "microbit.gesturesMenu.moved": "an motsa",
    "microbit.gesturesMenu.shaken": "an girgiza",
    "microbit.isButtonPressed": "an danna madannin [BTN] ?",
    "microbit.isTilted": "an karkata [DIRECTION]? ",
    "microbit.pinStateMenu.off": "kashe",
    "microbit.pinStateMenu.on": "kunna",
    "microbit.tiltAngle": "karkata kwanar [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "kowanne ",
    "microbit.tiltDirectionMenu.back": "baya",
    "microbit.tiltDirectionMenu.front": "gaba",
    "microbit.tiltDirectionMenu.left": "hagu",
    "microbit.tiltDirectionMenu.right": "dama",
    "microbit.whenButtonPressed": "a lokacin da aka danna madannin [BTN]",
    "microbit.whenGesture": "a lokacin da [GESTURE]",
    "microbit.whenPinConnected": "a lokacin da mabudin sirri [PIN] ya sadu",
    "microbit.whenTilted": "a lokacin da aka karkata [DIRECTION]",
    "music.categoryName": "waƙa",
    "music.changeTempo": "canza saurin da [TEMPO]",
    "music.drumBass": "(2) ƙaran ganga",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) rufaffen Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) tafin hannu",
    "music.drumOpenHiHat": "(5) buda Hi-Hat",
    "music.drumSideStick": "(3) Sandar gefe",
    "music.drumSnare": "(1) Gangar Snare",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) alwatika",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Tubalin katako",
    "music.getTempo": "sauri",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Mawaƙa",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Jitan wuta ",
    "music.instrumentElectricPiano": "(2) Fiyanon wuta",
    "music.instrumentFlute": "(12) Siriki",
    "music.instrumentGuitar": "(4) Jita",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) akwatin kiɗa",
    "music.instrumentOrgan": "(3) Sassa",
    "music.instrumentPiano": "(1) Fiyano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Gangar tasa",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Sirikin katako",
    "music.midiPlayDrumForBeats": "buga gangar [DRUM] na bugun [BEATS]",
    "music.midiSetInstrument": "saita kayan aikin zuwa [INSTRUMENT]",
    "music.playDrumForBeats": "buga gangar [DRUM] na bugun [BEATS]",
    "music.playNoteForBeats": "buga rubutun [NOTE] na bugun [BEATS]",
    "music.restForBeats": "huta na bugun [BEATS]",
    "music.setInstrument": "saita kayan aikin zuwa [INSTRUMENT]",
    "music.setTempo": "saita saurin zuwa [TEMPO]",
    "pen.categoryName": "alƙalami",
    "pen.changeColorParam": "canja alƙalami [COLOR_PARAM] da [VALUE]",
    "pen.changeHue": "canja launin alkalami da [HUE]",
    "pen.changeShade": "canja launin zanen alkalami da [SHADE]",
    "pen.changeSize": "canja girman alkalamin da [SIZE]",
    "pen.clear": "share duka",
    "pen.colorMenu.brightness": "haske",
    "pen.colorMenu.color": "launi",
    "pen.colorMenu.saturation": "yanayin launi",
    "pen.colorMenu.transparency": "bayyanar da asali",
    "pen.penDown": "alkalamin kasa",
    "pen.penUp": "alkalamin sama",
    "pen.setColor": "saita launin alƙalamin zuwa [COLOR]",
    "pen.setColorParam": "saita alkalamin [COLOR_PARAM] zuwa [VALUE]",
    "pen.setHue": "saita launin alkalami zuwa [HUE]",
    "pen.setShade": "saita yanayin launin alkalami zuwa [SHADE]",
    "pen.setSize": "saita girman alkalami zuwa [SIZE]",
    "pen.stamp": "tambari",
    "speech.defaultWhenIHearValue": "mu je",
    "speech.extensionName": "Magana zuwa rubutu",
    "speech.listenAndWait": "ji kuma a jira",
    "speech.speechReporter": "magana",
    "speech.whenIHear": "a lokacin da na ji [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "rubutu zuwa jawabi",
    "text2speech.defaultTextToSpeak": "barka",
    "text2speech.giant": "basamude",
    "text2speech.kitten": "kyanwa",
    "text2speech.setLanguageBlock": "saita yare zuwa [LANGUAGE]",
    "text2speech.setVoiceBlock": "saita murya zuwa [VOICE]",
    "text2speech.speakAndWaitBlock": "yi magana[WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "fassara",
    "translate.defaultTextToTranslate": "barka",
    "translate.translateBlock": "fassara [WORDS] zuwa [LANGUAGE]",
    "translate.viewerLanguage": "yare",
    "videoSensing.categoryName": "fasahar gano yanayin bidiyo",
    "videoSensing.direction": "mafuskanta",
    "videoSensing.motion": "motsi",
    "videoSensing.off": "kashe",
    "videoSensing.on": "kunna",
    "videoSensing.onFlipped": "kunna juyayye",
    "videoSensing.setVideoTransparency": "Saita ganin bayyanar bidiyon zuwa [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "mataki",
    "videoSensing.videoOn": "bidiyon [ATTRIBUTE] akan [SUBJECT]",
    "videoSensing.videoToggle": "juya bidiyon [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "a lokacin da motsin bidiyon > [REFERENCE]",
    "wedo2.getDistance": "nisa",
    "wedo2.getTiltAngle": "karkata kwanan [TILT_DIRECTION]",
    "wedo2.isTilted": "an karkata [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "waccan hanyar",
    "wedo2.motorDirection.forward": "wannan hanyar",
    "wedo2.motorDirection.reverse": "da baya",
    "wedo2.motorId.a": "motar A",
    "wedo2.motorId.all": "dukkan motoci",
    "wedo2.motorId.b": "motar B",
    "wedo2.motorId.default": "mota",
    "wedo2.motorOff": "kashe [MOTOR_ID]",
    "wedo2.motorOn": "kunna [MOTOR_ID]",
    "wedo2.motorOnFor": "kunna [MOTOR_ID] na daƙiƙoƙi [DURATION] ",
    "wedo2.playNoteFor": "kunna sautin [NOTE] na daƙiƙoƙi [DURATION]",
    "wedo2.setLightHue": "saita launin haske zuwa [HUE]",
    "wedo2.setMotorDirection": "saita mafuskantar [MOTOR_ID] zuwa [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "saita ƙarfin [MOTOR_ID] zuwa [POWER] ",
    "wedo2.tiltDirection.any": "kowanne ",
    "wedo2.tiltDirection.down": "ƙasa",
    "wedo2.tiltDirection.left": "hagu",
    "wedo2.tiltDirection.right": "dama",
    "wedo2.tiltDirection.up": "sama",
    "wedo2.whenDistance": "a lokacin nisan [OP] [REFERENCE]",
    "wedo2.whenTilted": "a lokacin da aka karkata [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "launi",
    "paint.paintEditor.saturation": "Yanayin tumbatsa",
    "paint.paintEditor.brightness": "yanayin haske",
    "paint.paintEditor.costume": "Fasali ",
    "paint.paintEditor.group": "Rukuni",
    "paint.paintEditor.ungroup": "Raba rukuni",
    "paint.paintEditor.undo": "warwarewa",
    "paint.paintEditor.redo": "sake yi",
    "paint.paintEditor.forward": "ci gaba",
    "paint.paintEditor.backward": "ci baya",
    "paint.paintEditor.front": "Gaba",
    "paint.paintEditor.back": "Baya",
    "paint.paintEditor.more": "ƙari",
    "paint.modeTools.brushSize": "girma",
    "paint.modeTools.eraserSize": "Girman abun gogewa",
    "paint.modeTools.copy": "kwafa",
    "paint.modeTools.paste": "manna",
    "paint.modeTools.delete": "goge",
    "paint.modeTools.curved": "mai lanƙwasa",
    "paint.modeTools.pointed": "An nuna",
    "paint.modeTools.thickness": "kauri",
    "paint.modeTools.flipHorizontal": "Jefa a kwance",
    "paint.modeTools.flipVertical": "Jefa a tsaye",
    "paint.modeTools.filled": "an cika",
    "paint.modeTools.outlined": "ƙayyadadde",
    "paint.paintEditor.bitmap": "Maida zuwa bitmap",
    "paint.paintEditor.vector": "maida zuwa tataccen zanen kwamfuta",
    "paint.paintEditor.fill": "cika",
    "paint.paintEditor.stroke": "ƙayyadewa",
    "paint.brushMode.brush": "burushi",
    "paint.eraserMode.eraser": "abun gogewa",
    "paint.fillMode.fill": "cika",
    "paint.lineMode.line": "layi",
    "paint.ovalMode.oval": "da'ira",
    "paint.rectMode.rect": "murabba'i mai dari",
    "paint.reshapeMode.reshape": "sake siffantawa",
    "paint.roundedRectMode.roundedRect": "Lanƙwasasshen murabba'i mai dari ",
    "paint.selectMode.select": "Zaɓa",
    "paint.textMode.text": "rubutu",
    "paint.colorPicker.swap": "musanya"
  },
  "hy": {
    "gui.alerts.lostPeripheralConnection": "Scratch -ը կորցրեց կապը {extensionName}-ի հետ։",
    "gui.alerts.tryAgain": "Կրկին փորձեք",
    "gui.alerts.download": "Ներբեռնել",
    "gui.connection.reconnect": "Վերամիացում",
    "gui.backpack.costumeLabel": "զգեստ",
    "gui.backpack.soundLabel": "ձայն",
    "gui.backpack.scriptLabel": "սցենար",
    "gui.backpack.spriteLabel": "կերպար",
    "gui.backpack.header": "Ուսապարկ",
    "gui.backpack.errorBackpack": "Չհաջողվեց բեռնել ուսապարկը",
    "gui.backpack.loadingBackpack": "Բեռնում․․․",
    "gui.backpack.more": "Ավելին",
    "gui.backpack.emptyBackpack": "Ուսապարկը դատարկ է",
    "gui.unsupportedBrowser.label": "Զննարկիչը չի սպասարկվում",
    "gui.unsupportedBrowser.errorLabel": "Սխալ է տեղի ունեցել",
    "gui.unsupportedBrowser.notRecommended": "Շատ ենք ցավում, բայց կարծես դուք օգտագործում եք մի զննարկիչի տարբերակ, որը չի սպասաարկվում Scratch-ում: Խորհուրդ ենք տալիս թարմացնել սպասարկվող զննարկիչի վերջին տարբերակը, ինչպիսիք են «Գուգլ Քրոմ», Mozilla Firefox, Microsoft Edge կամ Apple Safari:",
    "gui.unsupportedBrowser.description": "Շատ ենք ցավում, բայց Scratch -ը չի սպասարկում այս զննարկիչը: Մենք խորհուրդ ենք տալիս թարմացնել սպասարկվող զննարկչի վերջին տարբերակը `Google Chrome, Mozilla Firefox, Microsoft Edge կամ Apple Safari:",
    "gui.unsupportedBrowser.back": "Հետ գնալ",
    "gui.unsupportedBrowser.previewfaq": "Ավելին իմանալու համար այցելեք {previewFaqLink}: ",
    "gui.unsupportedBrowser.previewfaqlinktext": "ՀՏՀ",
    "gui.cards.all-tutorials": "Ձեռնարկներ",
    "gui.cards.shrink": "Փոքրացնել",
    "gui.cards.expand": "Ընդլայնել",
    "gui.cards.close": "Փակել",
    "gui.cards.more-things-to-try": "Փորձել ավելին",
    "gui.cards.see-more": "Տեսնել ավելին",
    "gui.comingSoon.message1": "Մի անհանգստացեք, մենք աշխատում ենք դրա վրա {emoji}",
    "gui.comingSoon.message2": "Շուտով...",
    "gui.comingSoon.message3": "Մենք աշխատում ենք դրա վրա {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Ոչ մի սարք չի գտնվել",
    "gui.connection.auto-scanning.prescan": "Մոտեցրեք սարքը և սկսեք որոնումը:",
    "gui.connection.auto-scanning.pressbutton": "Սեղմեք սարքի վրայի կոճակը։",
    "gui.connection.auto-scanning.start-search": "Սկսել որոնումը",
    "gui.connection.connecting-searchbutton": "Որոնում․․․",
    "gui.connection.auto-scanning.try-again": "Կրկին փորձեք",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Միացված է ",
    "gui.connection.disconnect": "Անջատել",
    "gui.connection.go-to-editor": "Գնալ խմբագիր",
    "gui.connection.connecting-cancelbutton": "Միացում․․․",
    "gui.connection.error.errorMessage": "Վա՜յ, կարծես սխալ է տեղի ունեցել:",
    "gui.connection.error.tryagainbutton": "Կրկին փորձեք",
    "gui.connection.error.helpbutton": "Օգնություն ",
    "gui.connection.peripheral-name-label": "Սարքի անունը",
    "gui.connection.connect": "Միանալ",
    "gui.connection.scanning.lookingforperipherals": "Սարքերի որոնում",
    "gui.connection.scanning.noPeripheralsFound": "Ոչ մի սարք չի գտնվել",
    "gui.connection.scanning.instructions": "Վերը նշված ցուցակից ընտրեք Ձեր սարքը:",
    "gui.connection.search": "Թարմացնել",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Համոզվեք, որ Scratch link-ն տեղադրված և գործարկված է",
    "gui.connection.unavailable.enablebluetooth": "Ստուգեք, որ բլութութը միացած լինի",
    "gui.connection.unavailable.tryagainbutton": "Կրկին փորձեք",
    "gui.connection.unavailable.helpbutton": "Օգնություն ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Գնալ",
    "gui.controls.stop": "Դադար",
    "gui.crashMessage.label": "Վա՜յ, ինչ որ բան այնպես չգնաց:",
    "gui.crashMessage.description": "Շատ ենք ցավում, բայց Scratch-ը խափանվել է: Այս սխալը ինքնաբերաբար հաղորդվում է Scratch-ի թիմին: Խնդրում ենք թարմացնել էջը կրկին փորձելու համար:",
    "gui.crashMessage.errorNumber": "Ձեր սխալը գրանցվել է {errorId} id-ով  ",
    "gui.crashMessage.reload": "Նորից բեռնել",
    "gui.customProcedures.myblockModalTitle": "Ստեղծել մասնիկ",
    "gui.customProcedures.addAnInputNumberText": "Ավելացնել ներմուծման դաշտ",
    "gui.customProcedures.numberTextType": "թվային կամ տեքստ",
    "gui.customProcedures.addAnInputBoolean": "Ավելացնել ներմուծման դաշտ",
    "gui.customProcedures.booleanType": "Տրամաբանական",
    "gui.customProcedures.addALabel": "Ավելացնել պիտակ",
    "gui.customProcedures.runWithoutScreenRefresh": "Գործարկել առանց էկրանը թարմացնելու",
    "gui.customProcedures.cancel": "Չեղարկել",
    "gui.customProcedures.ok": "Լավ",
    "gui.SpriteInfo.direction": "Ուղղություն",
    "gui.directionPicker.rotationStyles.allAround": "Շուրջ բոլորը",
    "gui.directionPicker.rotationStyles.leftRight": "Ձախ/Աջ",
    "gui.directionPicker.rotationStyles.dontRotate": "Չպտտել",
    "gui.gui.addExtension": "Ավելացնել ընդլայնում",
    "gui.gui.codeTab": "Սցենարներ",
    "gui.gui.backdropsTab": "Ետնապատկեր",
    "gui.gui.costumesTab": "Զգեստներ",
    "gui.gui.soundsTab": "Ձայն",
    "gui.extensionLibrary.comingSoon": "Շուտով",
    "gui.extensionLibrary.requires": "Պահանջվում է",
    "gui.extensionLibrary.collaboration": "Համագործակցությունը",
    "gui.library.filterPlaceholder": "Որոնել",
    "gui.library.allTag": "Բոլորը",
    "gui.loader.message1": "Մասնիկի ստեղծում ․․․ ",
    "gui.loader.message2": "Կերպարների բեռնում ․․․ ",
    "gui.loader.message3": "Ձայների բեռնում ․․․",
    "gui.loader.message4": "Ընդլայնումների բեռնում ․․․",
    "gui.loader.message5": "Մկների ժողով ...  ",
    "gui.loader.message6": "«Նանո» կերպարի փոխանցում…",
    "gui.loader.message7": "Գոբոսների ուռեցում ․․․ ",
    "gui.loader.message8": "Սմայլիկների նախապատրաստում ...",
    "gui.loader.headline": "Նախագծի բեռնում ․․․",
    "gui.loader.creating": "Նախագծի ստեղծում",
    "gui.accountMenu.profile": "Անհատական էջ",
    "gui.accountMenu.myStuff": "Իմ ունեցածը",
    "gui.accountMenu.myClasses": "Իմ դասերը",
    "gui.accountMenu.myClass": "Իմ դասը",
    "gui.accountMenu.accountSettings": "Հաշվի կարգավորումներ",
    "gui.accountMenu.signOut": "Դուրս գալ",
    "gui.authorInfo.byUser": "{username}-ի կողմից",
    "gui.menuBar.seeProjectPage": "Տեսնել նախագծի էջը",
    "gui.menuBar.language": "Language",
    "general.username": "Մուտքանուն",
    "general.password": "Գաղտնաբառ",
    "general.signIn": "Մուտք գործել",
    "login.needHelp": "Օգնության կարի՞ք ունեք:",
    "form.validationRequired": "Այս դաշտը պարտադիր է",
    "gui.menuBar.tutorialsLibrary": "Ձեռնարկներ",
    "gui.menuBar.restoreSprite": "Վերականգնել կերպարը",
    "gui.menuBar.restoreSound": "Վերականգնել ձայնը",
    "gui.menuBar.restoreCostume": "Վերականգնել զգեստը",
    "gui.menuBar.restore": "Վերականգնել",
    "gui.menuBar.saveNow": "Պահել հիմա",
    "gui.menuBar.saveAsCopy": "Պահել, որպես պատճեն",
    "gui.menuBar.remix": "Նոր տարբերակ",
    "gui.menuBar.new": "Նոր",
    "gui.menuBar.file": "Նիշք",
    "gui.menuBar.downloadToComputer": "Պահել համակարգչում ",
    "gui.menuBar.edit": "Խմբագրել",
    "gui.menuBar.turboModeOff": "Անջատել արագացված ռեժիմը",
    "gui.menuBar.turboModeOn": "Միացնել արագացված ռեժիմը",
    "gui.menuBar.modeMenu": "Ռեժիմ",
    "gui.menuBar.normalMode": "Նորմալ ռեժիմ",
    "gui.menuBar.caturdayMode": "Կատվի օրվա ռեժիմ",
    "gui.menuBar.joinScratch": "Միանալ Scratch-ին",
    "gui.menuBar.signIn": "Մուտք գործել",
    "gui.gui.projectTitlePlaceholder": "Նախագծի անվանումն այստեղ",
    "gui.menuBar.saveNowLink": "Պահել հիմա",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Կիսված է",
    "gui.menuBar.share": "Կիսվել",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Օգնություն ",
    "gui.modal.back": "Հետ գնալ",
    "gui.monitor.listMonitor.empty": "(դատարկ)",
    "gui.monitor.listMonitor.listLength": "երկարություն {length}",
    "gui.monitor.contextMenu.default": "Ընթերցման նորմալ էկրան",
    "gui.monitor.contextMenu.large": "Ընթերցման մեծ էկրան",
    "gui.monitor.contextMenu.slider": "սահիչ",
    "gui.monitor.contextMenu.sliderRange": "փոխել սահիչի միջակայքը",
    "gui.monitor.contextMenu.import": "ներմուծել",
    "gui.monitor.contextMenu.export": "արտահանել",
    "gui.monitor.contextMenu.hide": "թաքցնել",
    "gui.playButton.play": "Արտաբերել",
    "gui.playButton.stop": "Դադար",
    "gui.gui.variableScopeOptionAllSprites": "Բոլոր կերպարների համար",
    "gui.gui.variableScopeOptionSpriteOnly": "Միայն այս կերպարի համար",
    "gui.gui.cloudVariableOption": "Ամպային փոփոխական (պահպանվում է սերվերում)",
    "gui.gui.variablePromptAllSpritesMessage": "Այս փոփոխականը հասանելի կլինի բոլոր կերպարների համար։",
    "gui.gui.listPromptAllSpritesMessage": "Սա հասանելի կլինի բոլոր կերպարների համար։",
    "gui.prompt.cancel": "Չեղարկել",
    "gui.prompt.ok": "Լավ",
    "gui.playbackStep.stopMsg": "Դադար",
    "gui.playbackStep.playMsg": "Արտաբերել",
    "gui.playbackStep.loadingMsg": "Բեռնում․․․",
    "gui.playbackStep.saveMsg": "Պահել",
    "gui.playbackStep.reRecordMsg": "Վերաձայնագրել",
    "gui.recordModal.title": "Ձայնագրություն",
    "gui.recordingStep.beginRecord": "Սկսել ձայնագրությունը`  սեղմելով ներգևի կոճակը",
    "gui.recordingStep.permission": "{arrow} Խոսափողն օգտագործելու համար հարկավոր է Ձեր թույլտվությունը ",
    "gui.recordingStep.stop": "Դադարեցնել ձայնագրումը",
    "gui.recordingStep.record": "Ձայնագրել",
    "gui.sliderModal.min": "Նվազագույն արժեք",
    "gui.sliderModal.max": "Առավելագույն արժեք",
    "gui.sliderModal.title": "Փոխել սահման միջակայքը",
    "gui.sliderPrompt.cancel": "Չեղարկել",
    "gui.sliderPrompt.ok": "Լավ",
    "gui.soundEditor.sound": "Ձայն",
    "gui.soundEditor.play": "Արտաբերել",
    "gui.soundEditor.stop": "Դադար",
    "gui.soundEditor.copy": "Պատճենել",
    "gui.soundEditor.paste": "Զետեղել",
    "gui.soundEditor.copyToNew": "Պատճենել նորին",
    "gui.soundEditor.delete": "Ջնջել",
    "gui.soundEditor.save": "Պահել",
    "gui.soundEditor.undo": "Հետ գնալ",
    "gui.soundEditor.redo": "Առաջ գնալ",
    "gui.soundEditor.faster": "Ավելի արագ",
    "gui.soundEditor.slower": "Ավելի դանդաղ",
    "gui.soundEditor.echo": "Արձագանք",
    "gui.soundEditor.robot": "Ռոբոտ",
    "gui.soundEditor.louder": "Ավելի բարձր",
    "gui.soundEditor.softer": "Ավելի մեղմ",
    "gui.soundEditor.reverse": "Հակադարձել",
    "gui.soundEditor.fadeOut": "Մարել",
    "gui.soundEditor.fadeIn": "Հզորացնել",
    "gui.soundEditor.mute": "Անձայն",
    "gui.SpriteInfo.spritePlaceholder": "Անուն",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Կերպար",
    "gui.SpriteInfo.show": "Ցույց տալ",
    "gui.SpriteInfo.size": "Չափս",
    "gui.spriteSelectorItem.contextMenuDuplicate": "կրկնօրինակել",
    "gui.spriteSelectorItem.contextMenuExport": "արտահանել",
    "gui.spriteSelectorItem.contextMenuDelete": "ջնջել",
    "gui.spriteSelector.addSpriteFromLibrary": "Ընտրել կերպարը",
    "gui.spriteSelector.addSpriteFromPaint": "Նկարել",
    "gui.spriteSelector.addSpriteFromSurprise": "Անակնկալ",
    "gui.spriteSelector.addSpriteFromFile": "Վերբեռնել կերպար",
    "gui.stageHeader.stageSizeLarge": "Անցնել մեծ բեմի",
    "gui.stageHeader.stageSizeSmall": "Անցնել փոքր բեմի",
    "gui.stageHeader.stageSizeFull": "Ակտիվացնել լիաէկրան ռեժիմը",
    "gui.stageHeader.stageSizeUnFull": "Դուրս գալ լիաէկրան ռեժիմից",
    "gui.stageHeader.fullscreenControl": "Լիաէկրան կառավարում",
    "gui.spriteSelector.addBackdropFromLibrary": "Ընտրել ետնապատկերը",
    "gui.stageSelector.addBackdropFromPaint": "Նկարել",
    "gui.stageSelector.addBackdropFromSurprise": "Անակնկալ",
    "gui.stageSelector.addBackdropFromFile": "Վերբեռնել ետնապատկեր",
    "gui.stageSelector.stage": "Բեմ",
    "gui.stageSelector.backdrops": "Ետնապատկեր",
    "gui.telemetryOptIn.label": "Զեկուցել վիճակագրությունը Scratch-ը բարելավելու համար",
    "gui.telemetryOptIn.body1": "Scratch -ի թիմը միշտ փորձում է ավելի լավ հասկանալ, թե ինչպես է Scratch-ն օգտագործվում ամբողջ աշխարհում: Այս ջանքերը սատարելու համար դուք կարող եք թույլ տալ, որ ծրագիրն ինքնաբերաբար ուղարկի օգտագործման տվյալները Scratch-ի թիմին:",
    "gui.telemetryOptIn.body2": "Հավաքվող տվյալներն են՝ լեզվի ընտրությունը, մասնիկների օգտագործում, և որոշ իրադարձություններ, ոոնցից են պահպանումը, բեռնումն ու նախագծի վերբեռնումը ։ Մենք ՉԵՆՔ հավաքում անհատական տվյալներ։ Խնդրում ենք կարդալ {privacyPolicyLink} -ը՝ լրացուցիչ ինֆորմացիայի համար: ",
    "gui.telemetryOptIn.privacyPolicyLink": "Գաղտնիության քաղաքականություն",
    "gui.telemetryOptIn.optInText": "Scratch թիմի հետ կիսվել ծրագրի օգտագործման տվյալները",
    "gui.telemetryOptIn.optInTooltip": "Ակտիվացնել հեռաչափումը",
    "gui.telemetryOptIn.optOutText": "Scratch թիմի հետ չկիսվել ծրագրի օգտագործման տվյալները",
    "gui.telemetryOptIn.optOutTooltip": "Անջատել հեռաչափումը",
    "gui.telemetryOptIn.settingWasUpdated": "Կարգավորումները թարմացված են։",
    "gui.telemetryOptIn.buttonClose": "Փակել",
    "gui.turboMode.active": "Արագացված ռեժիմ",
    "gui.webglModal.label": "Ձեր զննարկիչը չունի WebGL -ի հնարավորություն",
    "gui.webglModal.description": "Ցավոք Ձեր զննարկիչը կամ համակարգիչը չի օգտագործում {webGlLink}։ Այս տեխնոլոգիան անհրաժեշտ է Scratch 3.0 գործարկման համար։",
    "gui.webglModal.webgllink": "չունի WebGL -ի հնարավորություն",
    "gui.webglModal.back": "Վերադառնալ",
    "gui.webglModal.previewfaq": "Ավելի շատ տեղեկություններ ստանալու համար այցելեք այստեղ {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "ՀՏՀ",
    "gui.costumeLibrary.chooseABackdrop": "Ընտրել ետնապատկերը",
    "gui.costumeLibrary.chooseACostume": "Ընտրել զգեստը",
    "gui.costumeTab.addBackdropFromLibrary": "Ընտրել ետնապատկերը",
    "gui.costumeTab.addCostumeFromLibrary": "Ընտրել զգեստը",
    "gui.costumeTab.addBlankCostume": "Նկարել",
    "gui.costumeTab.addSurpriseCostume": "Անակնկալ",
    "gui.costumeTab.addFileBackdrop": "Վերբեռնել ետնապատկեր",
    "gui.costumeTab.addFileCostume": "Վերբեռնել զգեստ",
    "gui.extensionLibrary.chooseAnExtension": "Ընտրել ընդլայնումը",
    "gui.extensionLibrary.extensionUrl": "Մուտքագրել ընդլայնման URL-ը",
    "gui.monitors.importListColumnPrompt": "Ո՞ր սյունը պէտք է օգտագործվի (1-{numberOfColumns})։",
    "gui.recordingStep.alertMsg": "Չհաջողվեց սկսել ձայնագրությունը",
    "gui.soundLibrary.chooseASound": "Ընտրել ձայնը",
    "gui.soundTab.fileUploadSound": "Վերբեռնել ձայն",
    "gui.soundTab.surpriseSound": "Անակնկալ",
    "gui.soundTab.recordSound": "Ձայնագրել",
    "gui.soundTab.addSoundFromLibrary": "Ընտրել ձայնը",
    "gui.spriteLibrary.chooseASprite": "Ընտրել կերպարը",
    "gui.tipsLibrary.tutorials": "Ընտրել ձեռնարկը",
    "gui.alerts.createsuccess": "Նոր նախագիծը ստեղծվել է ",
    "gui.alerts.createcopysuccess": "Ծրագիրը պահպանվել է, որպես պատճեն:",
    "gui.alerts.createremixsuccess": "Ծրագիրը պահպանվել է, որպես վերամշակում:",
    "gui.alerts.creating": "Ստեղծվում է նորը...",
    "gui.alerts.creatingCopy": "Նախագծի պատճենում․․․",
    "gui.alerts.creatingRemix": "Նախագծի վերամշակում...",
    "gui.alerts.creatingError": "Հնարավոր չէ ստեղծել նախագիծը: Խնդրում ենք կրկին փորձել։",
    "gui.alerts.savingError": "Նախագիծը չի պահվել:",
    "gui.alerts.savesuccess": "Նախագիծը պահվել է:",
    "gui.alerts.saving": "Պահում է նախագիծը․․․",
    "gui.alerts.cloudInfo": "Հիշեք, որ ամպային փոփոխականները կարող են միայն թվեր լինել, այլ ոչ տառեր կամ նիշեր։ {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Իմանալ ավելին:",
    "gui.alerts.importing": "Ներմուծում ...",
    "gui.defaultProject.meow": "միաու",
    "gui.defaultProject.variable": "իմ փոփոխականը",
    "gui.howtos.intro-move-sayhello-hat.name": "Սկսել",
    "gui.howtos.intro-move.step_stepMove": "Ավելացնել շարժման մասնիկը",
    "gui.howtos.add-a-move-block.step_stepSay": "ավելացնել ասել մասնիկը",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Սեղմել կանաչ դրոշը, գործարկելու համար",
    "gui.howtos.intro-getting-started-ASL.name": "Սկսել - ASL (Ամերիկյան ժեստերի լեզու)",
    "gui.howtos.animate-a-name.name": "Անիմացնել անունը",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Ընտրել տառային կերպար",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Երբ սեղմված է արտաբերել ձայնը",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Ընտրել ուրիշ տառային կերպար",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Փոխեք գույնը",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Ընտրել ուրիշ կերպար և ստիպեք նրան պտտվել",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Ընտրել ուրիշ տառային կերպար և ստիպեք նրան մեծանալ ",
    "gui.howtos.imagine": "Պատկերացրեք մի աշխարհ",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Մուտքագրեք այն, ինչ ուզում եք ասել",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Սեղմել կանաչ դրոշը, գործարկելու համար",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Ընտրեք ցանկացած ետնապատկեր",
    "gui.howtos.imagine.step_imagineChooseSprite": "Ընտրեք ցանկացած կերպար",
    "gui.howtos.imagine.step_imagineFlyAround": "Սեղմեք բացատ ստեղնը սահելու համար",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Ընտրեք ցանկացած ուրիշ կերպար",
    "gui.howtos.imagine.step_imagineLeftRight": "Շարժել ձախից աջ",
    "gui.howtos.imagine.step_imagineUpDown": "Շարժել վերից վար",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Փոխել զգեստը",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Սահել դեպի կետը",
    "gui.howtos.imagine.step_imagineGrowShrink": "Աճել և փոքրանալ",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Ընտրել այլ ետնապատկեր",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Փոխարկել ետնապատկերները",
    "gui.howtos.imagine.step_imagineRecordASound": "Ավելացնել ձայնը",
    "gui.howtos.imagine.step_imagineChooseSound": "Ընտրիր քո ձայնը",
    "gui.howtos.make-music.name": "Ստեղծել երաժշտություն",
    "gui.howtos.Make-Music.step_PickInstrument": "Ընտրել գործիքների կերպարը",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Երբ սեղմված է արտաբերել ձայնը",
    "gui.howtos.Make-Music.step_MakeSong": "Գրել երգ",
    "gui.howtos.make-music.step_MakeBeat": "Ընտրել թմբուկն ու ստեղծել ռիթմ",
    "gui.howtos.make-music.step_MakeBeatBox": "Ընտրել խոսափող կերպարն ու անակնկալ բիթբոքսը",
    "gui.howtos.story.name": "Ստեղծել պատմություն",
    "gui.howtos.story.step_addbg": "Ավելացնել ետնապատկերը",
    "gui.howtos.story.step_addsprite": "Ավելացնել կերպարը",
    "gui.howtos.story.step_saysomething": "Ասա որևէ բան",
    "gui.howtos.story.step_addanothersprite": "Ավելացնել այլ կերպար",
    "gui.howtos.story.step_flip": "Փոխել ուղղությունը",
    "gui.howtos.story.step_conversation": "Սկսել զրույցը",
    "gui.howtos.story.addanotherbg": "Ավելացնել այլ ետնապատկեր",
    "gui.howtos.story.step_swithbg": "Փոխարկել ետնապատկերը",
    "gui.howtos.story.step_hidewizard": "Թաքցնել կերպարը",
    "gui.howtos.story.step_showwizard": "Ցույց տալ կերպարը",
    "gui.howtos.make-a-chase-game.name": "Ստեղծել հետապնդումներ պարունակող խաղ",
    "gui.howtos.Chase-Game.step_BG": "Ավելացնել ետնապատկեր",
    "gui.howtos.chase-game.step_AddOcto": "Ավելացնել կերպարն",
    "gui.howtos.make-music.step_LeftRight": "Շարժվի՛ր աջ ու ձախ սլաք ստեղների միջոցով",
    "gui.howtos.Chase-Game.step_UpDown": "Շարժվի՛ր վեր ու վար սլաք ստեղների միջոցով",
    "gui.howtos.Chase-Game.step_AddStar": "Ավելացնել ուրիշ կերպար",
    "gui.howtos.Chase-Game.step_MoveRandom": "Շարժվել պատահականորեն",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ութոտնուկի կերպարին դիպչելիս արտաբերել ձայնը",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Ստեղծել «միավոր» փոփոխականը ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ութոտնուկի կերպարին դիպչելիս ավելացնել միավորը",
    "gui.howtos.animate-char.name": "Անիմացնել կերպարը",
    "gui.howtos.animate-char.step_addbg": "Ավելացնել ետնապատկերը",
    "gui.howtos.animate-char.step_addsprite": "Ավելացնել կերպարը",
    "gui.howtos.animate-char.step_saysomething": "Ասա որևէ բան",
    "gui.howtos.animate-char.step_addsound": "Ավելացնել ձայն",
    "gui.howtos.animate-char.step_animatetalking": "Անիմացնել խոսքը",
    "gui.howtos.animate-char.step_arrowkeys": "Տեղաշարժել «սլաք» ստեղների օգնությամբ",
    "gui.howtos.animate-char.step_jump": "Ցատկել",
    "gui.howtos.animate-char.step_changecolor": "Փոխել գույնը",
    "gui.howtos.make-a-game.name": "Ստեղծել սեղմելով խաղ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Ընտրել կերպարը",
    "gui.howtos.make-a-game.step_GamePlaySound": "Երբ սեղմված է արտաբերել ձայնը",
    "gui.howtos.make-a-game.step_GameAddScore": "Ստեղծել «միավոր» փոփոխականը",
    "gui.howtos.make-a-game.step_GameChangeScore": "Երբ սեղմված է միավորը մեծացնել",
    "gui.howtos.make-a-game.step_Random": "Գնալ պատահական դիրք",
    "gui.howtos.make-music.step_GameChangeColor": "Փոխել գույնը",
    "gui.howtos.make-music.step_ResetScore": "Զրոյացնել միավորը",
    "gui.howtos.make-it-fly.name": "Դարձրեք այն թռչող",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Ընտրեք «երկինք» ետնապատկերը",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Ընտրեք կերպարը",
    "gui.howtos.fly.step_stepflySaySomething": "Ասա որևէ բան",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Տեղաշարժել «սլաք» ստեղների օգնությամբ",
    "gui.howtos.fly.step_stepflyChooseObject": "Ընտրել առարկան հավաքման համար",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Դարձրեք առարկան շարժվող",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Ընտրեք Ձեր կերպարին",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ավելացնել «միավոր»-ը",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Պահել միավորը",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ավելացնել տեսարան",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Շարժել տեսարանը",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Հաջորդ զգեստը",
    "gui.howtos.pong": "Պինգ-Պոնգ խաղ",
    "gui.howtos.pong.step_pongAddBackdrop": "Ավելացնել ետնապատկեր",
    "gui.howtos.pong.step_pongAddBallSprite": "Ավելացնել գնդակի կերպարը",
    "gui.howtos.pong.step_pongBounceAround": "Թռչկոտել այս ու այն կողմ",
    "gui.howtos.pong.step_pongAddPaddle": "Ավելացնել հրթիռ",
    "gui.howtos.pong.step_pongMoveThePaddle": "Շարժել հրթիռը",
    "gui.howtos.pong.step_pongSelectBallSprite": "Ընտրել գնդակի կերպարը",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ավելացնել հրամաններ, որպեսզի գնդակը դուրս գա հրթիռից",
    "gui.howtos.pong.step_pongAddAScore": "Ավելացնել հաշիվը",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Մենյուից ընտրիր «Միավոր»-ը",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Զետեղել «փոխել միավորը» մասնիկը",
    "gui.howtos.pong.step_pongResetScore": "Զրոյացնել հաշիվը ",
    "gui.howtos.pong.step_pongAddLineSprite": "Ավելացնել տող կերպարը",
    "gui.howtos.pong.step_pongGameOver": "Խաղն ավարտված է",
    "gui.howtos.code-cartoon": "Կոդավորել մուլտֆիլմ",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Ասեք որևէ բան, երբ սեղմում եք կանաչ դրոշակը",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Անիմացնել կերպարը, երբ սեղմում եք այն",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Ընտրեք ուրիշ կերպար",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Փոքրացնելու համար օգտագործեք «հանում» նշանը",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Ստիպել կերպարին մեծանալ և փոքրանալ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Ընտրել ուրիշ կերպար",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Ցատկիր վեր ու վար ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Տեսարանը փոխելու համար սեղմել կերպարի վրա",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Սահել շուրջը",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Փոխել զգեստները",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Ընտրեք ավելի շատ կերպարներ Ձեր մուլտֆիլմին ավելացնելու համար",
    "gui.howtos.cartoon-network": "Անիմացնել արկածային խաղ",
    "gui.howtos.cartoon-network.step_CNcharacter": "Ընտրել ցուցադրվող կերպարը",
    "gui.howtos.cartoon-network.step_CNsay": "Ասա որևէ բան",
    "gui.howtos.cartoon-network.step_CNglide": "Սահել շուրջը",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Ընտրեք որևէ առարկա հետապնդելու համար",
    "gui.howtos.cartoon-network.step_CNcollect": "Հավաքել առարկաներ",
    "gui.howtos.cartoon-network.step_CNvariable": "Ստեղծել «միավոր» փոփոխականը",
    "gui.howtos.cartoon-network.step_CNscore": "Պահել միավորը",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Նոր մակարդակ՝ փոխել ետնապատկերը",
    "gui.howtos.videosens.name": "Տեսա\nազդակ",
    "gui.howtos.videosens.step_addextension": "Ավելացնել ընդլայնում",
    "gui.howtos.videosens.step_pet": "Շոյվել կատվին",
    "gui.howtos.videosens.step_animate": "Անիմացնել",
    "gui.howtos.videosens.step_pop": "Պայթեցնել փուչիկը",
    "gui.howtos.say-it-out-loud": "Ստեղծեք անիմացիաներ, որոնք խոսում են",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ավելացրեք տեքստը խոսքի վերածող մասնիկներ",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Ասա որևէ բան",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Սահմանել ձայնը",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Շարժվել շուրջը",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ավելացնել ետնապատկերը",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ավելացնել մեկ այլ կերպար",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Երգել",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Փոխել գույնը",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Պտտվել շուրջը",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Աճել ու փոքրանալ",
    "gui.howtos.talking": "Խոսող հեքիաթներ",
    "gui.howtos.talking.step_talesAddExtension": "Սեղմեք տեքստը-խոսքի վերածելու մասնիկներ ավելացնելու համար",
    "gui.howtos.talking.step_talesChooseSprite": "Ընտրել կերպարը",
    "gui.howtos.talking.step_talesSaySomething": "Դարձնել խոսող կերպար",
    "gui.howtos.talking.step_talesChooseBackdrop": "Ընտրել ետնապատկերը",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Սեղմեք կերպարի վրա, որ անցնեք հաջորդ ետնապատկերին",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Ընտրեք այլ կերպար",
    "gui.howtos.talking.step_talesMoveAround": "Շարժվել շուրջը",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Ընտրել այլ ետնապատկեր",
    "gui.howtos.talking.step_talesAnimateTalking": "Անիմացնել խոսքը",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Ընտրել այլ ետնապատկեր",
    "gui.howtos.talking.step_talesChooseSound": "Ընտրել երգ՝ պարելու համար",
    "gui.howtos.talking.step_talesDanceMoves": "Պարային շարժումներ",
    "gui.howtos.talking.step_talesAskAnswer": "Ստացեք «հարց ու պատասխան» մասնիկներն ընկալում բաժնից",
    "gui.howtos.add-sprite.name": "Ավելացնել կերպարը",
    "gui.howtos.add-sprite.step_addSprite": "Ավելացնել կերպարը",
    "gui.howtos.add-a-backdrop.name": "Ավելացնել ետնապատկերը",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ավելացնել ետնապատկերը",
    "gui.howtos.change-size.name": "Փոխել չափսը",
    "gui.howtos.change-size.step_changeSize": "Փոխել չափսը",
    "gui.howtos.glide-around.name": "Սահել շուրջը",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Սահել շուրջը",
    "gui.howtos.change-size.step_glideAroundPoint": "Սահել դեպի կետը",
    "gui.howtos.record-a-sound.name": "Ձայնագրել",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Սեղմել «Ձայն» ներդիրը",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Սեղմել «Ձայնագրել» ",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Սեղմիր ձայնագրման կոճակը",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Ընտրիր քո ձայնը",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Արտաբերել Ձեր ձայնը",
    "gui.howtos.spin-video.name": "Պտտել",
    "gui.howtos.change-size.step_spinTurn": "Շրջվել",
    "gui.howtos.change-size.step_spinPointInDirection": "Ուղղությունը՝",
    "gui.howtos.hide-and-show.name": "Թաքցնել և ցույց տալ",
    "gui.howtos.change-size.step_hideAndShow": "Թաքցնել և ցույց տալ",
    "gui.howtos.switch-costume.name": "Անիմացնել կերպարը",
    "gui.howtos.change-size.step_switchCostumes": "Անիմացնել կերպարը",
    "gui.howtos.move-around-with-arrow-keys.name": "Օգտվիր «սլաք» ստեղներից",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Տեղաշարժվիր ձախ և աջ ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Տեղաշարժվիր վեր և վար ",
    "gui.howtos.add-effects.name": "Ավելացնել էֆեկտներ",
    "gui.howtos.videosens.step_addEffects": "Ավելացնել էֆեկտներ",
    "gui.extension.music.name": "Երաժշտություն",
    "gui.extension.music.description": "Նվագել գործիքներով ու թմբուկներով։",
    "gui.extension.pen.name": "Գրիչ",
    "gui.extension.pen.description": "Նկարել Ձեր կերպարներով։",
    "gui.extension.videosensing.name": "Տեսա\nազդակ",
    "gui.extension.videosensing.description": "Ճանաչել շարժումը տեսախցիկով",
    "gui.extension.text2speech.name": "Տեքստը խոսքի վերածող",
    "gui.extension.text2speech.description": "Տվեք նախագծերին խոսելու ունակություն",
    "gui.extension.translate.name": "Թարգմանել",
    "gui.extension.translate.description": "Թարգմանել տեքստը բազմաթիվ լեզուներով:",
    "gui.extension.makeymakey.description": "Դարձրեք ցանկացած բան ստեղնով հրամանի",
    "gui.extension.microbit.description": "Կապեք Ձեր նախագծերը աշխարհի հետ",
    "gui.extension.microbit.connectingMessage": "Միացում",
    "gui.extension.ev3.description": "Ստեղծել փոխգործակցող և այլ ռոբոտներ:",
    "gui.extension.ev3.connectingMessage": "Միացում: Համոզվեք, որ Ձեր EV3-ի ծածկագիրը սահմնանված է 1234-ի։",
    "gui.extension.boost.description": "Դարձրեք կենդանի ռոբոտներ:",
    "gui.extension.boost.connectingMessage": "Միացում",
    "gui.extension.wedo2.description": "Կառուցել շարժիչներով և տվիչներով։",
    "gui.extension.wedo2.connectingMessage": "Միացում",
    "gui.extension.gdxfor.description": "Չափում է հրման և քարշի ուժերը, շարժումը և շրջադարձը։",
    "gui.extension.gdxfor.connectingMessage": "Միացում",
    "gui.libraryTags.all": "Բոլորը",
    "gui.libraryTags.animals": "Կենդանիներ",
    "gui.libraryTags.dance": "Պարել",
    "gui.libraryTags.effects": "Էֆեկտներ",
    "gui.libraryTags.fantasy": "Երևակայական",
    "gui.libraryTags.fashion": "Նորաձևություն",
    "gui.libraryTags.food": "Ուտելիք",
    "gui.libraryTags.indoors": "Ներսում",
    "gui.libraryTags.loops": "Հանգույցներ",
    "gui.libraryTags.music": "Երաժշտություն",
    "gui.libraryTags.notes": "Նշումներ",
    "gui.libraryTags.outdoors": "Դրսում",
    "gui.libraryTags.patterns": "Նմուշներ",
    "gui.libraryTags.people": "Մարդիկ",
    "gui.libraryTags.percussion": "Հարվածային գործիքներ",
    "gui.libraryTags.space": "Տարածություն",
    "gui.libraryTags.sports": "Սպորտ",
    "gui.libraryTags.underwater": "Ստորջրյա ",
    "gui.libraryTags.voice": "Ձայն",
    "gui.libraryTags.wacky": "Խենթ",
    "gui.libraryTags.animation": "Անիմացիա",
    "gui.libraryTags.art": "Արվեստ",
    "gui.libraryTags.games": "Խաղեր",
    "gui.libraryTags.stories": "Պատմություններ",
    "gui.libraryTags.letters": "Տառեր",
    "gui.opcodeLabels.direction": "ուղղություն",
    "gui.opcodeLabels.xposition": "x -ը",
    "gui.opcodeLabels.yposition": "y -ը",
    "gui.opcodeLabels.size": "չափս",
    "gui.opcodeLabels.costumename": "զգեստի անունը",
    "gui.opcodeLabels.costumenumber": "զգեստի համարը",
    "gui.opcodeLabels.backdropname": "ետնապատկերի անունը",
    "gui.opcodeLabels.backdropnumber": "ետնապատկերի համարը",
    "gui.opcodeLabels.volume": "ձայնը",
    "gui.opcodeLabels.tempo": "տեմպ",
    "gui.opcodeLabels.answer": "պատասխան",
    "gui.opcodeLabels.loudness": "բարձրաձայն",
    "gui.opcodeLabels.username": "մուտքանուն",
    "gui.opcodeLabels.year": "տարի",
    "gui.opcodeLabels.month": "ամիս",
    "gui.opcodeLabels.date": "ամսաթիվ",
    "gui.opcodeLabels.dayofweek": "շաբաթվա օր",
    "gui.opcodeLabels.hour": "ժամ",
    "gui.opcodeLabels.minute": "րոպե",
    "gui.opcodeLabels.second": "երկրորդ",
    "gui.opcodeLabels.timer": "վայրկյանաչափ",
    "gui.projectLoader.loadError": "Ընտրված նախագիծը չհաջողվեց բեռնել:",
    "gui.sharedMessages.backdrop": "ետնապատկեր {index}",
    "gui.sharedMessages.costume": "զգեստ {index}",
    "gui.sharedMessages.sprite": "Կերպար {index}",
    "gui.sharedMessages.pop": "փոփ",
    "gui.sharedMessages.replaceProjectWarning": "Փոխարինե՞լ ընթացիկ նախագծի պարունակությունը:",
    "gui.sharedMessages.loadFromComputerTitle": "Բեռնել համակարգչից",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch նախագիծ",
    "boost.color.any": "Ցանկացած գույն",
    "boost.color.black": "Սև",
    "boost.color.blue": "Կապույտ",
    "boost.color.green": "Կանաչ",
    "boost.color.red": "Կարմիր",
    "boost.color.white": "Սպիտակ",
    "boost.color.yellow": "Դեղին",
    "boost.getMotorPosition": "տեղաշարժել [MOTOR_REPORTER_ID] ",
    "boost.getTiltAngle": "թեքել անկյունը [TILT_DIRECTION]",
    "boost.motorDirection.backward": "այդ ուղղությամբ",
    "boost.motorDirection.forward": "այս ուղղությամբ",
    "boost.motorDirection.reverse": "շրջել",
    "boost.motorOff": "անջատել [MOTOR_ID]",
    "boost.motorOn": "միացնել [MOTOR_ID]",
    "boost.motorOnFor": "միացնել [MOTOR_ID] շարժիչը [DURATION] վայրկյանով",
    "boost.motorOnForRotation": "պտտել [MOTOR_ID] շարժիչը [ROTATION] աստիճանով ",
    "boost.seeingColor": "երևո՞ւմ է [COLOR] աղյուսը",
    "boost.setLightHue": "սահմանել լույսի գույնը [HUE]",
    "boost.setMotorDirection": "սահմանել [MOTOR_ID]-ի ուղղությունը [MOTOR_DIRECTION]",
    "boost.setMotorPower": "սահմանել  [MOTOR_ID]-ի  արագությունը մինչև [POWER] %",
    "boost.tiltDirection.any": "ցանկացած",
    "boost.tiltDirection.down": "ներքև",
    "boost.tiltDirection.left": "ձախ",
    "boost.tiltDirection.right": "աջ",
    "boost.tiltDirection.up": "վեր",
    "boost.whenColor": "երբ երևում է [COLOR] աղյուսը",
    "boost.whenTilted": "երբ թեքված է [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "միացնել [NOTE] ազդանշանաը [TIME] վայրկյան",
    "ev3.buttonPressed": "կոճակ [PORT]  սեղմվա՞ծ է",
    "ev3.getBrightness": "պայծառություն",
    "ev3.getDistance": "հեռավորություն",
    "ev3.getMotorPosition": "շարժիչի  [PORT] դիրքը ",
    "ev3.motorSetPower": " շարժիչ  [PORT] հզորությունը  [POWER] %",
    "ev3.motorTurnClockwise": "շարժիչ  [PORT] պտտել այս կողմ [TIME] վայրկյանով",
    "ev3.motorTurnCounterClockwise": "շարժիչ  [PORT] պտտել այդ կողմ  [TIME] վայրկյանով",
    "ev3.whenBrightnessLessThan": "երբ պայծառությունը < [DISTANCE]",
    "ev3.whenButtonPressed": "երբ [PORT] կոճակը սեղմված է",
    "ev3.whenDistanceLessThan": "երբ հեռավորությունը < [DISTANCE]",
    "gdxfor.getAcceleration": "արագացում  [DIRECTION]",
    "gdxfor.getForce": "ուժ",
    "gdxfor.getSpin": "պտտման արագություն [DIRECTION]",
    "gdxfor.getTilt": "անկյան թեքվածություն [TILT]",
    "gdxfor.isFreeFalling": "ընկնում",
    "gdxfor.isTilted": "թեքվա՞ծ [TILT]",
    "gdxfor.pulled": "քաշված",
    "gdxfor.pushed": "հրած",
    "gdxfor.shaken": "թափահարած",
    "gdxfor.startedFalling": "սկսել է ընկնել",
    "gdxfor.tiltDirectionMenu.any": "ցանկացած",
    "gdxfor.tiltDirectionMenu.back": "ետեվ",
    "gdxfor.tiltDirectionMenu.front": "դիմաց",
    "gdxfor.tiltDirectionMenu.left": "ձախ",
    "gdxfor.tiltDirectionMenu.right": "աջ",
    "gdxfor.turnedFaceDown": "գլուխը ներքև",
    "gdxfor.turnedFaceUp": "գլուխը վերև",
    "gdxfor.whenForcePushedOrPulled": "երբ ուժի տվիչը [PUSH_PULL] ",
    "gdxfor.whenGesture": "երբ [GESTURE]",
    "gdxfor.whenTilted": "երբ թեքություն կա [TILT]",
    "makeymakey.downArrow": "վար սլաքը",
    "makeymakey.downArrowShort": "ներքև",
    "makeymakey.leftArrow": "ձախ սլաք",
    "makeymakey.leftArrowShort": "ձախ",
    "makeymakey.rightArrow": "աջ սլաքը ",
    "makeymakey.rightArrowShort": "աջ",
    "makeymakey.spaceKey": "բացատ",
    "makeymakey.upArrow": " վեր սլաքը",
    "makeymakey.upArrowShort": "վեր",
    "makeymakey.whenKeyPressed": "երբ [KEY] ստեղնը սեղմված է",
    "makeymakey.whenKeysPressedInOrder": "երբ [SEQUENCE] սեղմված է ըստ հաջորդականության",
    "microbit.buttonsMenu.any": "ցանկացած",
    "microbit.clearDisplay": "մաքրել էկրանը",
    "microbit.defaultTextToDisplay": "Բարև",
    "microbit.displaySymbol": "ցույց տալ [MATRIX]",
    "microbit.displayText": "ցույց տալ տեքստ [TEXT]",
    "microbit.gesturesMenu.jumped": "ցատկած",
    "microbit.gesturesMenu.moved": "շարժված",
    "microbit.gesturesMenu.shaken": "թափահարած",
    "microbit.isButtonPressed": "[BTN] կոճակը սեղմվա՞ծ է",
    "microbit.isTilted": "թեքվա՞ծ է [DIRECTION]",
    "microbit.pinStateMenu.off": "Անջատել",
    "microbit.pinStateMenu.on": "Միացնել",
    "microbit.tiltAngle": "թեքել անկյունը [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ցանկացած",
    "microbit.tiltDirectionMenu.back": "ետ",
    "microbit.tiltDirectionMenu.front": "դիմաց",
    "microbit.tiltDirectionMenu.left": "ձախ",
    "microbit.tiltDirectionMenu.right": "աջ",
    "microbit.whenButtonPressed": "երբ [BTN] կոճակը սեղմված է",
    "microbit.whenGesture": "երբ [GESTURE]",
    "microbit.whenPinConnected": "երբ  [PIN] փինը միացված է",
    "microbit.whenTilted": "երբ թեքված է [DIRECTION]",
    "music.categoryName": "Երաժշտություն",
    "music.changeTempo": "փոխել տեմպը [TEMPO]-ով",
    "music.drumBass": "(2) Բաս Թմբուկ",
    "music.drumBongo": "(13) Բոնգո",
    "music.drumCabasa": "(15) Կաբասա",
    "music.drumClaves": "(9) Քլեյվս",
    "music.drumClosedHiHat": "(6) Փակված Ծնծղա",
    "music.drumConga": "(14) Քոնգա",
    "music.drumCowbell": "(11) Կովի զանգակ",
    "music.drumCrashCymbal": "(4) Թմբուկի բարձր ձայն",
    "music.drumCuica": "(18) Կուիկա",
    "music.drumGuiro": "(16) Գուիրո",
    "music.drumHandClap": "(8) Ծափահարություն",
    "music.drumOpenHiHat": "(5) Բաց Ծնծղա",
    "music.drumSideStick": "(3) Կողային Փայտիկ",
    "music.drumSnare": "(1) Փոքր Թմբուկ",
    "music.drumTambourine": "(7) Դափ",
    "music.drumTriangle": "(12) Եռանկյունի",
    "music.drumVibraslap": "(17) Թրթռահարված",
    "music.drumWoodBlock": "(10) Փայտե Տուփ",
    "music.getTempo": "տեմպ",
    "music.instrumentBass": "(6) Բաս",
    "music.instrumentBassoon": "(14) Ֆագոտ",
    "music.instrumentCello": "(8) Թավջութակ",
    "music.instrumentChoir": "(15) Երգչախումբ",
    "music.instrumentClarinet": "(10) Կլառնետ",
    "music.instrumentElectricGuitar": "(5) Էլեկտրական Կիթառ",
    "music.instrumentElectricPiano": "(2) Էլեկտրական Դաշնամուր",
    "music.instrumentFlute": "(12) Ֆլեյտա",
    "music.instrumentGuitar": "(4) Կիթառ",
    "music.instrumentMarimba": "(19) Մարիմբա",
    "music.instrumentMusicBox": "(17) Երաժշտական Տուփ ",
    "music.instrumentOrgan": "(3) Երգեհոն",
    "music.instrumentPiano": "(1) Դաշնամուր",
    "music.instrumentPizzicato": "(7) Պիցցիկատո",
    "music.instrumentSaxophone": "(11) Սաքսոֆոն",
    "music.instrumentSteelDrum": "(18) Պողպատե Թմբուկ",
    "music.instrumentSynthLead": "(20) Սինթեզատորի Մեղեդի",
    "music.instrumentSynthPad": "(21) Սինթեզատորի Ակորդներ ",
    "music.instrumentTrombone": "(9) Տրոմբոն",
    "music.instrumentVibraphone": "(16) Վիբրաֆոն",
    "music.instrumentWoodenFlute": "(13) Փայտե ֆլեյտա",
    "music.midiPlayDrumForBeats": "նվագել թմբուկով [DRUM]  [BEATS] տակտով",
    "music.midiSetInstrument": "սահմանել երաժշտական գործիքը [INSTRUMENT]",
    "music.playDrumForBeats": "նվագել թմբուկով [DRUM]  [BEATS] տակտով",
    "music.playNoteForBeats": "միացնել [NOTE] [BEATS] տակտերով",
    "music.restForBeats": "դադարեցնել [BEATS] տակտով",
    "music.setInstrument": "սահմանել երաժշտական գործիքը [INSTRUMENT]",
    "music.setTempo": "սահմանել տեմպը [TEMPO]",
    "pen.categoryName": "Գրիչ",
    "pen.changeColorParam": "փոխել գրիչի գույնը [COLOR_PARAM]  [VALUE]-ով",
    "pen.changeHue": "փոխել գրիչի գույնը [HUE]-ով",
    "pen.changeShade": "փոխել գրիչի ստվերը [SHADE]-ով",
    "pen.changeSize": "փոխել գրիչի չափը [SIZE]-ով",
    "pen.clear": "ջնջել բոլորը",
    "pen.colorMenu.brightness": "պայծառություն",
    "pen.colorMenu.color": "գույն",
    "pen.colorMenu.saturation": "հագեցվածություն",
    "pen.colorMenu.transparency": "թափանցիկություն",
    "pen.penDown": "գրիչն իջեցնել",
    "pen.penUp": "գրիչը բարձրացնել",
    "pen.setColor": "սահմանել գրիչի գույնը [COLOR]",
    "pen.setColorParam": "սահմենլ գրիչի [COLOR_PARAM] [VALUE]-ի",
    "pen.setHue": "սահմանել գրիչի գույնը [HUE]",
    "pen.setShade": "սահմանել գրիչի ստվերը [SHADE]",
    "pen.setSize": "սահմանել գրիչի չափսը [SIZE]",
    "pen.stamp": "կնիք",
    "speech.defaultWhenIHearValue": "գնացինք",
    "speech.extensionName": "Խոսքի ճանաչելիություն",
    "speech.listenAndWait": "լսել և սպասել",
    "speech.speechReporter": "խոսք",
    "speech.whenIHear": "երբ լսում եմ [PHRASE]",
    "text2speech.alto": "ալտ",
    "text2speech.categoryName": "Ավելացնել տեքստը խոսքի բլոկներին",
    "text2speech.defaultTextToSpeak": "բարև",
    "text2speech.giant": "հսկա",
    "text2speech.kitten": "կատվի ձագ",
    "text2speech.setLanguageBlock": "սահմանել լեզուն [LANGUAGE]",
    "text2speech.setVoiceBlock": "սահմանել ձայնը [VOICE]",
    "text2speech.speakAndWaitBlock": "ասել [WORDS]",
    "text2speech.squeak": "ճզմել",
    "text2speech.tenor": "տենոր",
    "translate.categoryName": "Թարգմանել",
    "translate.defaultTextToTranslate": "բարև",
    "translate.translateBlock": "թարգմանել [WORDS]֊ը [LANGUAGE]",
    "translate.viewerLanguage": "լեզու",
    "videoSensing.categoryName": " Տեսա ազդակ",
    "videoSensing.direction": "ուղղություն",
    "videoSensing.motion": "շարժում",
    "videoSensing.off": "Անջատել",
    "videoSensing.on": "Միացնել",
    "videoSensing.onFlipped": "արտացոլված",
    "videoSensing.setVideoTransparency": " սահմանել տեսանյութի թափանցիկությունը [TRANSPARENCY]",
    "videoSensing.sprite": "կերպար",
    "videoSensing.stage": "բեմ",
    "videoSensing.videoOn": "Տեսանյութի [ATTRIBUTE]֊ը [SUBJECT]֊ում",
    "videoSensing.videoToggle": "միացնել տեսանյութը [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "երբ տեսանյութի շարժը > [REFERENCE]",
    "wedo2.getDistance": "հեռավորություն",
    "wedo2.getTiltAngle": "թեքել անկյունը [TILT_DIRECTION]",
    "wedo2.isTilted": "թեքվա՞ծ է որևէ ուղղությամբ [TILT_DIRECTION_ANY]",
    "wedo2.motorDirection.backward": "այդ ուղղությամբ",
    "wedo2.motorDirection.forward": "այս ուղղությամբ",
    "wedo2.motorDirection.reverse": "շրջել",
    "wedo2.motorId.a": "շարժիչ Ա",
    "wedo2.motorId.all": "բոլոր շարժիչները",
    "wedo2.motorId.b": "շարժիչ Բ",
    "wedo2.motorId.default": "շարժիչ",
    "wedo2.motorOff": "անջատել [MOTOR_ID]",
    "wedo2.motorOn": "միացնել [MOTOR_ID]",
    "wedo2.motorOnFor": "միացնել [MOTOR_ID] շարժիչը [DURATION] վայրկյանով",
    "wedo2.playNoteFor": "միացնել [NOTE] [DURATION] վայրկյանով",
    "wedo2.setLightHue": "սահմանել լույսի գույնը [HUE]",
    "wedo2.setMotorDirection": "սահմանել [MOTOR_ID] ուղղությունը դեպի [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "սահմանել [MOTOR_ID]  արագությունը մինչև [POWER] ",
    "wedo2.tiltDirection.any": "ցանկացած",
    "wedo2.tiltDirection.down": "ներքև",
    "wedo2.tiltDirection.left": "ձախ",
    "wedo2.tiltDirection.right": "աջ",
    "wedo2.tiltDirection.up": "վեր",
    "wedo2.whenDistance": "երբ հեռավորություն [OP] [REFERENCE]",
    "wedo2.whenTilted": "երբ թեքված է [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Գույն",
    "paint.paintEditor.saturation": "Հագեցվածություն",
    "paint.paintEditor.brightness": "Պայծառություն",
    "paint.paintEditor.costume": "Զգեստ",
    "paint.paintEditor.group": "Խումբ",
    "paint.paintEditor.ungroup": "Ցրել խումբը",
    "paint.paintEditor.undo": "Հետ գնալ",
    "paint.paintEditor.redo": "Առաջ գնալ",
    "paint.paintEditor.forward": "Դեպի առաջ",
    "paint.paintEditor.backward": "Դեպի հետ",
    "paint.paintEditor.front": "Դիմաց",
    "paint.paintEditor.back": "Հետ գնալ",
    "paint.paintEditor.more": "Ավելին",
    "paint.modeTools.brushSize": "Չափս",
    "paint.modeTools.eraserSize": "Ռետինի չափսը",
    "paint.modeTools.copy": "Պատճենել",
    "paint.modeTools.paste": "Զետեղել",
    "paint.modeTools.delete": "Ջնջել",
    "paint.modeTools.curved": "Ծռված",
    "paint.modeTools.pointed": "Նշված",
    "paint.modeTools.thickness": "Հաստություն",
    "paint.modeTools.flipHorizontal": "Հորիզոնական շրջադարձ",
    "paint.modeTools.flipVertical": "Ուղղահայաց շրջադարձ",
    "paint.modeTools.filled": "Լցված",
    "paint.modeTools.outlined": "Եզրագծած",
    "paint.paintEditor.bitmap": "Փոխակերպել կետապատկերայինի",
    "paint.paintEditor.vector": "Փոխակերպել վեկտորի",
    "paint.paintEditor.fill": "Լցնել",
    "paint.paintEditor.stroke": "Եզրագիծ",
    "paint.brushMode.brush": "Վրձին",
    "paint.eraserMode.eraser": "Ռետին",
    "paint.fillMode.fill": "Լցնել",
    "paint.lineMode.line": "Գիծ",
    "paint.ovalMode.oval": "Շրջանագիծ",
    "paint.rectMode.rect": "Ուղղանկյուն",
    "paint.reshapeMode.reshape": "Ձևափոխել",
    "paint.roundedRectMode.roundedRect": "Կլորացված ուղղանկյուն",
    "paint.selectMode.select": "Ընտրել",
    "paint.textMode.text": "Տեքստ",
    "paint.colorPicker.swap": "Փոխարինում"
  },
  "he": {
    "gui.alerts.lostPeripheralConnection": "סקראץ' איבדה את החיבור ל{extensionName}.",
    "gui.alerts.tryAgain": "נסה שוב",
    "gui.alerts.download": "הורד",
    "gui.connection.reconnect": "התחברו שוב",
    "gui.backpack.costumeLabel": "תלבושת",
    "gui.backpack.soundLabel": "צליל",
    "gui.backpack.scriptLabel": "תסריט",
    "gui.backpack.spriteLabel": "דמות",
    "gui.backpack.header": "תרמיל",
    "gui.backpack.errorBackpack": "אירעה שגיאה בטעינת התרמיל",
    "gui.backpack.loadingBackpack": "טוען...",
    "gui.backpack.more": "עוד",
    "gui.backpack.emptyBackpack": "התרמיל ריק",
    "gui.unsupportedBrowser.label": "הדפדפן אינו נתמך",
    "gui.unsupportedBrowser.errorLabel": "יש תקלה",
    "gui.unsupportedBrowser.notRecommended": "אתם משתמשים בגרסת דפדפן שלא נתמכת על-ידי סקראץ'. אנו ממליצים לעדכן לגרסה האחרונה של דפדפן נתמך, כמו כרום, פיירפוקס, אדג', או ספארי.",
    "gui.unsupportedBrowser.description": "סקראץ' לא תומך בדפדפן זה. אנו ממליצים לעדכן לגרסה האחרונה של דפדפן נתמך, כמו כרום, פיירפוקס, אדג', או ספארי.",
    "gui.unsupportedBrowser.back": "חזרה",
    "gui.unsupportedBrowser.previewfaq": "למידע נוסף, עברו אל {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "שאלות נפוצות",
    "gui.cards.all-tutorials": "מדריכים",
    "gui.cards.shrink": "הקטן",
    "gui.cards.expand": "הרחב",
    "gui.cards.close": "סגירה",
    "gui.cards.more-things-to-try": "עוד דברים לנסות!",
    "gui.cards.see-more": "ראו עוד",
    "gui.comingSoon.message1": "אל דאגה, אנחנו מטפלים בזה {emoji}",
    "gui.comingSoon.message2": "בקרוב ...",
    "gui.comingSoon.message3": "אנחנו עובדים על זה {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "לא נמצאו מכשירים",
    "gui.connection.auto-scanning.prescan": "במשכיר שלך בסמוך אליך אז התחל בחיפוש",
    "gui.connection.auto-scanning.pressbutton": "לחץ את הכפתור על המכשיר שלך",
    "gui.connection.auto-scanning.start-search": "התחל חיפוש",
    "gui.connection.connecting-searchbutton": "מחפש...",
    "gui.connection.auto-scanning.try-again": "נסו שוב",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "מחובר",
    "gui.connection.disconnect": "התנתקו",
    "gui.connection.go-to-editor": "עברו לעורך",
    "gui.connection.connecting-cancelbutton": "מתחבר...",
    "gui.connection.error.errorMessage": "אופס, נראה שמשהו השתבש.",
    "gui.connection.error.tryagainbutton": "נסו שוב",
    "gui.connection.error.helpbutton": "עזרה",
    "gui.connection.peripheral-name-label": "שם מכשיר",
    "gui.connection.connect": "התחברו",
    "gui.connection.scanning.lookingforperipherals": "מחפש מכשירים",
    "gui.connection.scanning.noPeripheralsFound": "לא נמצאו מכשירים",
    "gui.connection.scanning.instructions": "בחרו את המכשיר שלכם מהרשימה למעלה",
    "gui.connection.search": "ריענון",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "וודאו שיש לכם Scratch Link מותקן ופועל.",
    "gui.connection.unavailable.enablebluetooth": "וודאו שה־Bluetooth דלוק",
    "gui.connection.unavailable.tryagainbutton": "נסו שוב",
    "gui.connection.unavailable.helpbutton": "עזרה",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "הפעל",
    "gui.controls.stop": "עצירה",
    "gui.crashMessage.label": "אופס! משהו השתבש",
    "gui.crashMessage.description": "מצטערים, אבל נראה שסקראץ' קרס. הבאג הזה דווח באופן אוטומטי לצוות סקראץ'. אנא רעננו את העמוד כדי לנסות שוב.",
    "gui.crashMessage.errorNumber": "התקלה נרשמה עם מזהה {errorId}",
    "gui.crashMessage.reload": "טעינה מחדש",
    "gui.customProcedures.myblockModalTitle": "צרו לבנה",
    "gui.customProcedures.addAnInputNumberText": "הוסיפו קלט",
    "gui.customProcedures.numberTextType": "מספר או טקסט",
    "gui.customProcedures.addAnInputBoolean": "הוסיפו קלט",
    "gui.customProcedures.booleanType": "בוליאני",
    "gui.customProcedures.addALabel": "הוסיפו תווית",
    "gui.customProcedures.runWithoutScreenRefresh": "הפעלה ללא רענון מסך",
    "gui.customProcedures.cancel": "ביטול",
    "gui.customProcedures.ok": "אישור",
    "gui.SpriteInfo.direction": "כיוון",
    "gui.directionPicker.rotationStyles.allAround": "כל הכיוונים",
    "gui.directionPicker.rotationStyles.leftRight": "שמאל-ימין",
    "gui.directionPicker.rotationStyles.dontRotate": "לא לסובב",
    "gui.gui.addExtension": "הוסיפו הרחבה",
    "gui.gui.codeTab": "קוד",
    "gui.gui.backdropsTab": "רקעים",
    "gui.gui.costumesTab": "תלבושות",
    "gui.gui.soundsTab": "צלילים",
    "gui.extensionLibrary.comingSoon": "בקרוב",
    "gui.extensionLibrary.requires": "דורש",
    "gui.extensionLibrary.collaboration": "שיתוף פעולה עם",
    "gui.library.filterPlaceholder": "חיפוש",
    "gui.library.allTag": "הכול",
    "gui.loader.message1": "יצירת לבנים …",
    "gui.loader.message2": "טוען דמויות …",
    "gui.loader.message3": "טוען צלילים …",
    "gui.loader.message4": "טוען הרחבות …",
    "gui.loader.message5": "מבריש את פרוות החתולים …",
    "gui.loader.message6": "מעביר ננואים ...",
    "gui.loader.message7": "מנפח גובואים …",
    "gui.loader.message8": "מכין אימוג'ים ...",
    "gui.loader.headline": "העלו פרוייקט",
    "gui.loader.creating": "יוצר פרויקט",
    "gui.accountMenu.profile": "פרופיל",
    "gui.accountMenu.myStuff": "הדברים שלי",
    "gui.accountMenu.myClasses": "הכיתות שלי",
    "gui.accountMenu.myClass": "הכיתה שלי",
    "gui.accountMenu.accountSettings": "הגדרות חשבון",
    "gui.accountMenu.signOut": "התנתקות",
    "gui.authorInfo.byUser": "מ{username}",
    "gui.menuBar.seeProjectPage": "ראו דף פרויקט",
    "gui.menuBar.language": "Language",
    "general.username": "שם משתמש",
    "general.password": "סיסמה",
    "general.signIn": "כניסה",
    "login.needHelp": "צריך עזרה?",
    "form.validationRequired": "זהו שדה חובה",
    "gui.menuBar.tutorialsLibrary": "מדריכים",
    "gui.menuBar.restoreSprite": "שחזר דמות",
    "gui.menuBar.restoreSound": "שחזר שמע",
    "gui.menuBar.restoreCostume": "שחזר תלבושת",
    "gui.menuBar.restore": "שחזר",
    "gui.menuBar.saveNow": "שמור עכשיו",
    "gui.menuBar.saveAsCopy": "שמירה כעותק",
    "gui.menuBar.remix": "עריכה מחדש",
    "gui.menuBar.new": "חדש",
    "gui.menuBar.file": "קובץ",
    "gui.menuBar.downloadToComputer": "הורידו למחשב",
    "gui.menuBar.edit": "עריכה",
    "gui.menuBar.turboModeOff": "כבו מצב טורבו",
    "gui.menuBar.turboModeOn": "הפעילו מצב טורבו",
    "gui.menuBar.modeMenu": "מצב",
    "gui.menuBar.normalMode": "מצב רגיל",
    "gui.menuBar.caturdayMode": "מצב שבתול",
    "gui.menuBar.joinScratch": "הצטרפו לסקראץ'",
    "gui.menuBar.signIn": "כניסה",
    "gui.gui.projectTitlePlaceholder": "כתבו כאן את כותרת הפרויקט",
    "gui.menuBar.saveNowLink": "שמור עכשיו",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "משותף",
    "gui.menuBar.share": "שיתוף",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "עזרה",
    "gui.modal.back": "אחורה",
    "gui.monitor.listMonitor.empty": "(ריק)",
    "gui.monitor.listMonitor.listLength": "אורך {length}",
    "gui.monitor.contextMenu.default": "תצוגה רגילה",
    "gui.monitor.contextMenu.large": "תצוגה גדולה",
    "gui.monitor.contextMenu.slider": "סרגל גרירה",
    "gui.monitor.contextMenu.sliderRange": "שינוי טווח סרגל",
    "gui.monitor.contextMenu.import": "יבוא",
    "gui.monitor.contextMenu.export": "יצוא",
    "gui.monitor.contextMenu.hide": "הסתר",
    "gui.playButton.play": "נגן",
    "gui.playButton.stop": "עצור",
    "gui.gui.variableScopeOptionAllSprites": "לכל הדמויות",
    "gui.gui.variableScopeOptionSpriteOnly": "רק לדמות זו",
    "gui.gui.cloudVariableOption": "משתנה ענן (מאוחסן בשרת)",
    "gui.gui.variablePromptAllSpritesMessage": "המשתנה הזה יהיה זמין לכל הדמויות",
    "gui.gui.listPromptAllSpritesMessage": "רשימה זו תהיה זמינה לכל הדמויות",
    "gui.prompt.cancel": "ביטול",
    "gui.prompt.ok": "אישור",
    "gui.playbackStep.stopMsg": "עצירה",
    "gui.playbackStep.playMsg": "נגינה",
    "gui.playbackStep.loadingMsg": "טוען...",
    "gui.playbackStep.saveMsg": "שמירה",
    "gui.playbackStep.reRecordMsg": "הקליטו מחדש",
    "gui.recordModal.title": "הקליטו צליל",
    "gui.recordingStep.beginRecord": "לחצו על הכפתור למטה להתחלת הקלטה",
    "gui.recordingStep.permission": "{arrow}אנו זקוקים לרשות להשתמש במיקרופון",
    "gui.recordingStep.stop": "עצירת הקלטה",
    "gui.recordingStep.record": "הקלטה",
    "gui.sliderModal.min": "הערך הקטן ביותר",
    "gui.sliderModal.max": "הערך הגדול ביותר ",
    "gui.sliderModal.title": "שינוי טווח סרגל",
    "gui.sliderPrompt.cancel": "ביטול",
    "gui.sliderPrompt.ok": "אישור",
    "gui.soundEditor.sound": "צליל",
    "gui.soundEditor.play": "נגינה",
    "gui.soundEditor.stop": "עצירה",
    "gui.soundEditor.copy": "העתק",
    "gui.soundEditor.paste": "הדבק",
    "gui.soundEditor.copyToNew": "העתק לחדש",
    "gui.soundEditor.delete": "מחק",
    "gui.soundEditor.save": "שמירה",
    "gui.soundEditor.undo": "ביטול",
    "gui.soundEditor.redo": "שחזור",
    "gui.soundEditor.faster": "מהר יותר",
    "gui.soundEditor.slower": "איטי יותר",
    "gui.soundEditor.echo": "הד",
    "gui.soundEditor.robot": "רובוט",
    "gui.soundEditor.louder": "חזק יותר",
    "gui.soundEditor.softer": "חלש יותר",
    "gui.soundEditor.reverse": "הפוך",
    "gui.soundEditor.fadeOut": "דעיכה",
    "gui.soundEditor.fadeIn": "התעצמות",
    "gui.soundEditor.mute": "השתקה",
    "gui.SpriteInfo.spritePlaceholder": "שם",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "דמות",
    "gui.SpriteInfo.show": "הצגה",
    "gui.SpriteInfo.size": "גודל",
    "gui.spriteSelectorItem.contextMenuDuplicate": "שכפול",
    "gui.spriteSelectorItem.contextMenuExport": "יצוא",
    "gui.spriteSelectorItem.contextMenuDelete": "מחיקה",
    "gui.spriteSelector.addSpriteFromLibrary": "בחרו דמות",
    "gui.spriteSelector.addSpriteFromPaint": "צייר",
    "gui.spriteSelector.addSpriteFromSurprise": "הפתעה",
    "gui.spriteSelector.addSpriteFromFile": "העלו דמות",
    "gui.stageHeader.stageSizeLarge": "עברו לבמה גדולה",
    "gui.stageHeader.stageSizeSmall": "עברו לבמה קטנה",
    "gui.stageHeader.stageSizeFull": "כניסה למסך מלא",
    "gui.stageHeader.stageSizeUnFull": "יציאה ממסך מלא",
    "gui.stageHeader.fullscreenControl": "בקרת מסך מלא",
    "gui.spriteSelector.addBackdropFromLibrary": "בחרו רקע",
    "gui.stageSelector.addBackdropFromPaint": "צייר",
    "gui.stageSelector.addBackdropFromSurprise": "הפתעה",
    "gui.stageSelector.addBackdropFromFile": "העלו רקע",
    "gui.stageSelector.stage": "במה",
    "gui.stageSelector.backdrops": "רקע",
    "gui.telemetryOptIn.label": "דיווח סטטיסטיקה לשיפור סקראץ'",
    "gui.telemetryOptIn.body1": "צוות סקראץ' תמיד מנסה להבין טוב יותר כיצד משתמשים בסקראץ' מסביב לעולם. לתמיכה במאמץ זה, אתם יכולים לאפשר לסקראץ' לשלוח באופן אוטומטי מידע לצוות.",
    "gui.telemetryOptIn.body2": "המידע שאנו אוספים כולל בחירת שפה, לבנים, שימוש ואירועים כמו שמירה, טעינה והעלאת פרויקט. אנו לא אוספים אף מידע אישי. למידע נוסף ראו את {privacyPolicyLink} שלנו.",
    "gui.telemetryOptIn.privacyPolicyLink": "מדיניות פרטיות",
    "gui.telemetryOptIn.optInText": "שיתוף נתוני הפעילות שלי עם צוות סקראץ'",
    "gui.telemetryOptIn.optInTooltip": "הפעלת טלמטריה",
    "gui.telemetryOptIn.optOutText": "ביטול שיתוף נתוני הפעילות שלי עם צוות סקראץ'",
    "gui.telemetryOptIn.optOutTooltip": "כבוי טלמטריה",
    "gui.telemetryOptIn.settingWasUpdated": "הגדרות עודכנו.",
    "gui.telemetryOptIn.buttonClose": "סגירה",
    "gui.turboMode.active": "מצב טורבו",
    "gui.webglModal.label": "הדפדפן שלך אינו תומך ב־WebGL",
    "gui.webglModal.description": "לרוע המזל, נראה שהדפדפן או המחשב שלך {webGlLink}. טכנולוגיה זו דרושה להרצת סקראץ' 3.0.",
    "gui.webglModal.webgllink": "אינו תומך ב־WebGL",
    "gui.webglModal.back": "חזרה",
    "gui.webglModal.previewfaq": "למידע נוסף, עברו אל {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "שאלות נפוצות",
    "gui.costumeLibrary.chooseABackdrop": "בחרו רקע",
    "gui.costumeLibrary.chooseACostume": "בחרו תלבושת",
    "gui.costumeTab.addBackdropFromLibrary": "בחרו רקע",
    "gui.costumeTab.addCostumeFromLibrary": "בחרו תלבושת",
    "gui.costumeTab.addBlankCostume": "צייר",
    "gui.costumeTab.addSurpriseCostume": "הפתעות",
    "gui.costumeTab.addFileBackdrop": "העלו רקע",
    "gui.costumeTab.addFileCostume": "העלו תלבושת",
    "gui.extensionLibrary.chooseAnExtension": "בחרו הרחבה",
    "gui.extensionLibrary.extensionUrl": "הכניסו את ה־URL של ההרחבה",
    "gui.monitors.importListColumnPrompt": "באיזה טור להשתמש ({numberOfColumns} - 1)?",
    "gui.recordingStep.alertMsg": "לא ניתן להתחיל הקלטה",
    "gui.soundLibrary.chooseASound": "בחרו צליל",
    "gui.soundTab.fileUploadSound": "העלו צליל",
    "gui.soundTab.surpriseSound": "הפתעה",
    "gui.soundTab.recordSound": "הקלטה",
    "gui.soundTab.addSoundFromLibrary": "בחרו צליל",
    "gui.spriteLibrary.chooseASprite": "בחרו דמות",
    "gui.tipsLibrary.tutorials": "בחרו מדריך",
    "gui.alerts.createsuccess": "פרויקט חדש נוצר",
    "gui.alerts.createcopysuccess": "פרויקט נשמר כעותק",
    "gui.alerts.createremixsuccess": "פרויקט נשמר כעריכה מחדש",
    "gui.alerts.creating": "יוצר חדש...",
    "gui.alerts.creatingCopy": "מעתיק פרויקט...",
    "gui.alerts.creatingRemix": "עריכה מחדש...",
    "gui.alerts.creatingError": "לא יכולנו ליצור את הפרויקט. נסה שוב!",
    "gui.alerts.savingError": "הפרויקט לא נשמר",
    "gui.alerts.savesuccess": "פרויקט נשמר.",
    "gui.alerts.saving": "שומר פרויקט...",
    "gui.alerts.cloudInfo": "שימו לב כי משתני ענן תומכים רק במספרים, ולא באותיות או בסמלים. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "למדו עוד.",
    "gui.alerts.importing": "מייבא...",
    "gui.defaultProject.meow": "מיאו",
    "gui.defaultProject.variable": "המשתנה שלי",
    "gui.howtos.intro-move-sayhello-hat.name": "מתחילים",
    "gui.howtos.intro-move.step_stepMove": "הוסיפו לבנת תנועה",
    "gui.howtos.add-a-move-block.step_stepSay": "הוסיפו בלוק \"אמור\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "לחצו על הדגל הירוק כדי להתחיל",
    "gui.howtos.intro-getting-started-ASL.name": "התחילו",
    "gui.howtos.animate-a-name.name": "הנפשת שם",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "בחרו בדמות של אות",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "השמעת צליל בלחיצה",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "בחרו דמות אות נוספת",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "שינוי צבע",
    "gui.howtos.animate-a-name.step_AnimateSpin": "בחרו אות נוספת וגרמו לה להסתובב",
    "gui.howtos.animate-a-name.step_AnimateGrow": "בחרו עוד אות וגרמו לה לגדול",
    "gui.howtos.imagine": "דמיינו עולם",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "הקלידו מה ברצונכם לומר",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "לחצו על הדגל הירוק כדי להתחיל",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "בחרו כל רקע",
    "gui.howtos.imagine.step_imagineChooseSprite": "בחרו כל דמות",
    "gui.howtos.imagine.step_imagineFlyAround": "לחצו על מקש הרווח כדי לגלוש",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "בחרו דמות אחרת",
    "gui.howtos.imagine.step_imagineLeftRight": "זוזו שמאלה-ימינה",
    "gui.howtos.imagine.step_imagineUpDown": "זוזו מעלה-מטה",
    "gui.howtos.imagine.step_imagineChangeCostumes": "החליפו תלבושת",
    "gui.howtos.imagine.step_imagineGlideToPoint": "גלשו לנקודה",
    "gui.howtos.imagine.step_imagineGrowShrink": "שנו גודל",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "בחרן רקע אחר",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "החליפו רקע",
    "gui.howtos.imagine.step_imagineRecordASound": "הוסיפו צליל",
    "gui.howtos.imagine.step_imagineChooseSound": "בחרו צליל משלכם",
    "gui.howtos.make-music.name": "צרו מוזיקה",
    "gui.howtos.Make-Music.step_PickInstrument": "בחרו בדמות של כלי נגינה",
    "gui.howtos.Make-Music.step_PlaySoundClick": "השמעת צליל בלחיצה",
    "gui.howtos.Make-Music.step_MakeSong": "חברו שיר",
    "gui.howtos.make-music.step_MakeBeat": "בחרו תוף וצרו קצב",
    "gui.howtos.make-music.step_MakeBeatBox": "בחר בדמות המיקרופון ובהפתעת Beatbox ",
    "gui.howtos.story.name": "יצירת סיפורים",
    "gui.howtos.story.step_addbg": "הוסיפו רקע",
    "gui.howtos.story.step_addsprite": "הוסף דמות",
    "gui.howtos.story.step_saysomething": "אמור דבר מה",
    "gui.howtos.story.step_addanothersprite": "הוסף תו נוסף",
    "gui.howtos.story.step_flip": "שנה כיוון",
    "gui.howtos.story.step_conversation": "דו-שיח",
    "gui.howtos.story.addanotherbg": "הוסף עוד רקע",
    "gui.howtos.story.step_swithbg": "החלף רקע",
    "gui.howtos.story.step_hidewizard": "הסתר דמות",
    "gui.howtos.story.step_showwizard": "הצג דמות",
    "gui.howtos.make-a-chase-game.name": "בנו משחק תופסת",
    "gui.howtos.Chase-Game.step_BG": "הוסיפו רקע",
    "gui.howtos.chase-game.step_AddOcto": "הוסיפו דמות",
    "gui.howtos.make-music.step_LeftRight": " זוזו ימינה ושמאלה באמצעות לחצני החיצים",
    "gui.howtos.Chase-Game.step_UpDown": "זוזו למעלה ולמטה באמצעות לחצני החיצים",
    "gui.howtos.Chase-Game.step_AddStar": "הוסיפו דמות נוספת",
    "gui.howtos.Chase-Game.step_MoveRandom": "תנועה אקראית",
    "gui.howtos.Chase-Game.step_WhenTouch": "בדמות התמנון, כאשר היא נוגעת נגן צליל",
    "gui.howtos.Chase-Game.step_ScoreVariable": "צרו משתנה ניקוד",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "בדמות התמנון, כאשר היא נוגעת הוסף ניקוד",
    "gui.howtos.animate-char.name": "הנפשת דמויות (אנימציה)",
    "gui.howtos.animate-char.step_addbg": "הוסיפו רקע",
    "gui.howtos.animate-char.step_addsprite": "הוסיפו דמות",
    "gui.howtos.animate-char.step_saysomething": "אמור דבר מה",
    "gui.howtos.animate-char.step_addsound": "הוסף צליל",
    "gui.howtos.animate-char.step_animatetalking": "הנפשת דיבור",
    "gui.howtos.animate-char.step_arrowkeys": "תנועה עם מקשי החצים",
    "gui.howtos.animate-char.step_jump": "קפיצה",
    "gui.howtos.animate-char.step_changecolor": "שינוי צבע",
    "gui.howtos.make-a-game.name": "צרו משחק לחיצות",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "בחרו דמות",
    "gui.howtos.make-a-game.step_GamePlaySound": "השמעת צליל בלחיצה",
    "gui.howtos.make-a-game.step_GameAddScore": "צרו משתנה ניקוד",
    "gui.howtos.make-a-game.step_GameChangeScore": "כאשר נלחץ העלה ניקוד",
    "gui.howtos.make-a-game.step_Random": "קפיצה אל מקום אקראי",
    "gui.howtos.make-music.step_GameChangeColor": "שינוי צבע",
    "gui.howtos.make-music.step_ResetScore": "איפוס ניקוד",
    "gui.howtos.make-it-fly.name": "בואו נעוף",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "בחרו רקע של שמיים",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "ביחרו דמות",
    "gui.howtos.fly.step_stepflySaySomething": "אימרו דבר מה",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "זוזו עם החצים",
    "gui.howtos.fly.step_stepflyChooseObject": "ביחרו חפץ לאסוף",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "גרמו לחפץ לזוז",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "ביחרו את הדמות שלכם",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "הוסיפו ניקוד",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "עיקבו אחר התוצאה",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "הוסיפו תפאורה",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "הזיזו את התפאורה",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "התלבושת הבאה",
    "gui.howtos.pong": "משחק פונג",
    "gui.howtos.pong.step_pongAddBackdrop": "הוסיפו רקע",
    "gui.howtos.pong.step_pongAddBallSprite": "הוסיפו דמות של כדור",
    "gui.howtos.pong.step_pongBounceAround": "שנו כיוון במסגרת",
    "gui.howtos.pong.step_pongAddPaddle": "הוסיפו מחבט",
    "gui.howtos.pong.step_pongMoveThePaddle": "הזיזו את המחבט",
    "gui.howtos.pong.step_pongSelectBallSprite": "ביחרו את הדמות של הכדור",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "הוסיפו קוד כדי להקפיץ את הכדור מהמחבט",
    "gui.howtos.pong.step_pongAddAScore": "הוסיפו ניקוד",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "ביחרו 'ניקוד' מהתפריט",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "הוסיפו בלוק 'שנה ניקוד'",
    "gui.howtos.pong.step_pongResetScore": "אפסו את הניקוד",
    "gui.howtos.pong.step_pongAddLineSprite": "הוסיפו את דמות ה\"קו\"",
    "gui.howtos.pong.step_pongGameOver": "המשחק נגמר",
    "gui.howtos.code-cartoon": "תכנתו דמות מצוירת",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "אמרו משהו כאשר לוחצים על הדגל הירוק",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "הנפישו דמות בלחיצה",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "ביחרו דמות אחרת",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "השתמשו בסימן המינוס כדי להקטין",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "הגדילו והקטינו את הדמות",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "ביחרו דמות אחרת",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "קפיצה למעלה ולמטה",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "שנו רקע בלחיצה על דמות",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "גלישה מסביב",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "שינוי תלבושת",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "ביחרו עוד דמויות לסרט המצויר",
    "gui.howtos.cartoon-network": "הנפישו משחק הרפתקאות",
    "gui.howtos.cartoon-network.step_CNcharacter": "בחרו דמות להראות",
    "gui.howtos.cartoon-network.step_CNsay": "אמור דבר מה",
    "gui.howtos.cartoon-network.step_CNglide": "החליקו סביב",
    "gui.howtos.cartoon-network.step_CNpicksprite": "בחרו אובייקט לרדוף אחריו",
    "gui.howtos.cartoon-network.step_CNcollect": "איספו אובייקטים",
    "gui.howtos.cartoon-network.step_CNvariable": "צרו משתנה ניקוד",
    "gui.howtos.cartoon-network.step_CNscore": "עקבו אחר התוצאה",
    "gui.howtos.cartoon-network.step_CNbackdrop": "שלב הבא: רקע",
    "gui.howtos.videosens.name": "חיישן מצלמה",
    "gui.howtos.videosens.step_addextension": "הוסיפו הרחבה",
    "gui.howtos.videosens.step_pet": "לטף את החתול",
    "gui.howtos.videosens.step_animate": "הנפּש",
    "gui.howtos.videosens.step_pop": "פוצץ בלון",
    "gui.howtos.say-it-out-loud": "צור הנפשות מדברות",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "הוסיפו את הלבנים של טקסט לדיבור",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "אמרו משהו",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "קבע קול",
    "gui.howtos.say-it-out-loud.step_TXTMove": "תזוזה במרחב",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "הוסיפו רקע",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "הוסף תו נוסף",
    "gui.howtos.say-it-out-loud.step_TXTSong": "בצע שיר",
    "gui.howtos.say-it-out-loud.step_TXTColor": "שינוי צבע",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "הסתובבו",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "הגדל והקטן",
    "gui.howtos.talking": "סיפורים מדברים",
    "gui.howtos.talking.step_talesAddExtension": "ליחצו כדי להוסיף בלוקים \"מטקסט לדיבור\"",
    "gui.howtos.talking.step_talesChooseSprite": "ביחרו דמות",
    "gui.howtos.talking.step_talesSaySomething": "גירמו לדמות לדבר",
    "gui.howtos.talking.step_talesChooseBackdrop": "בחרו רקע",
    "gui.howtos.talking.step_talesSwitchBackdrop": "ליחצו על דמות כדי לעבור לרקע הבא",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "ביחרו דמות אחרת",
    "gui.howtos.talking.step_talesMoveAround": "תזוזה במרחב",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "ביחרו רקע אחר",
    "gui.howtos.talking.step_talesAnimateTalking": "הנפשת דיבור",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "ביחרו רקע אחר",
    "gui.howtos.talking.step_talesChooseSound": "ביחרו שיר לרקוד לצליליו",
    "gui.howtos.talking.step_talesDanceMoves": "תנועות ריקוד",
    "gui.howtos.talking.step_talesAskAnswer": "קחו את הבלוקים \"שאל\" ו\"תשובה\" מקטגוריית החיישנים",
    "gui.howtos.add-sprite.name": "הוסיפו דמות",
    "gui.howtos.add-sprite.step_addSprite": "הוסיפו דמות",
    "gui.howtos.add-a-backdrop.name": "הוסיפו רקע",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "הוסיפו רקע",
    "gui.howtos.change-size.name": "שינוי גודל",
    "gui.howtos.change-size.step_changeSize": "שנו גודל",
    "gui.howtos.glide-around.name": "החליקו סביב",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "גלישה מסביב",
    "gui.howtos.change-size.step_glideAroundPoint": "גלישה לנקודה",
    "gui.howtos.record-a-sound.name": "הקלטת צליל",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "לחצו על הלשונית \"צלילים\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "לחצו \"הקלט\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "לחצו על כפתור ההקלטה",
    "gui.howtos.change-size.step_recordASoundChooseSound": "בחרו את הקול שלכם",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "נגנו את הצליל שלכם",
    "gui.howtos.spin-video.name": "גרום לזה להסתובב",
    "gui.howtos.change-size.step_spinTurn": "סובבו",
    "gui.howtos.change-size.step_spinPointInDirection": "קבעו כיוון",
    "gui.howtos.hide-and-show.name": "הסתרה והצגה",
    "gui.howtos.change-size.step_hideAndShow": "הסתר והצג",
    "gui.howtos.switch-costume.name": "הנפשת דמות",
    "gui.howtos.change-size.step_switchCostumes": "הנפשת דמות",
    "gui.howtos.move-around-with-arrow-keys.name": "השתמשו במקשי החצים",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "זוזו שמאלה וימינה",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "זוזו למעלה ולמטה",
    "gui.howtos.add-effects.name": "הוסיפו אפקטים",
    "gui.howtos.videosens.step_addEffects": "הוסיפו אפקטים",
    "gui.extension.music.name": "מוזיקה",
    "gui.extension.music.description": "נגנו בכלי נגינה ובתופים",
    "gui.extension.pen.name": "עט",
    "gui.extension.pen.description": "ציירו עם הדמות שלכם",
    "gui.extension.videosensing.name": "חיישן מצלמה",
    "gui.extension.videosensing.description": "זיהוי תנועה באמצעות המצלמה",
    "gui.extension.text2speech.name": "טקסט לדיבור",
    "gui.extension.text2speech.description": "גרמו לפרויקט שלכם לדבר",
    "gui.extension.translate.name": "תרגום",
    "gui.extension.translate.description": "תרגום טקסט להרבה שפות",
    "gui.extension.makeymakey.description": "הפוך כל דבר לקליד",
    "gui.extension.microbit.description": "חברו את הפרויקטים שלכם לעולם",
    "gui.extension.microbit.connectingMessage": "מתחבר",
    "gui.extension.ev3.description": "בנה רובוטים אינטראקטיביים ועוד.",
    "gui.extension.ev3.connectingMessage": "מתחבר. וודאו שקוד ה־PIN שמוגדר ב־EV3 הוא 1234",
    "gui.extension.boost.description": "תנו חיים ליצירות רובוטיות",
    "gui.extension.boost.connectingMessage": "מתחבר",
    "gui.extension.wedo2.description": "בנו עם מנועים וחיישנים",
    "gui.extension.wedo2.connectingMessage": "מתחבר",
    "gui.extension.gdxfor.description": "הרגש דחיפה, משיכה, תנועה וסיבוב",
    "gui.extension.gdxfor.connectingMessage": "מתחבר",
    "gui.libraryTags.all": "הכול",
    "gui.libraryTags.animals": "חיות",
    "gui.libraryTags.dance": "ריקוד",
    "gui.libraryTags.effects": "אפקטים",
    "gui.libraryTags.fantasy": "פנטסיה",
    "gui.libraryTags.fashion": "אופנה",
    "gui.libraryTags.food": "אוכל",
    "gui.libraryTags.indoors": "בפנים",
    "gui.libraryTags.loops": "לולאות",
    "gui.libraryTags.music": "מוזיקה",
    "gui.libraryTags.notes": "רשימות",
    "gui.libraryTags.outdoors": "בחוץ",
    "gui.libraryTags.patterns": "תבניות",
    "gui.libraryTags.people": "אנשים",
    "gui.libraryTags.percussion": "כלי הקשה",
    "gui.libraryTags.space": "חלל",
    "gui.libraryTags.sports": "ספורט",
    "gui.libraryTags.underwater": "תת-מימי",
    "gui.libraryTags.voice": "קול",
    "gui.libraryTags.wacky": "משוגע",
    "gui.libraryTags.animation": "הנפשה",
    "gui.libraryTags.art": "אומנות",
    "gui.libraryTags.games": "משחקים",
    "gui.libraryTags.stories": "סיפורים",
    "gui.libraryTags.letters": "אותיות",
    "gui.opcodeLabels.direction": "כיוון",
    "gui.opcodeLabels.xposition": "מיקום על ציר x",
    "gui.opcodeLabels.yposition": "מיקום על ציר y",
    "gui.opcodeLabels.size": "גודל",
    "gui.opcodeLabels.costumename": "שם תלבושת",
    "gui.opcodeLabels.costumenumber": "מספר תלבושת",
    "gui.opcodeLabels.backdropname": "שם רקע",
    "gui.opcodeLabels.backdropnumber": "מספר רקע",
    "gui.opcodeLabels.volume": "עוצמה",
    "gui.opcodeLabels.tempo": "קצב",
    "gui.opcodeLabels.answer": "תשובה",
    "gui.opcodeLabels.loudness": "קולניות",
    "gui.opcodeLabels.username": "שם משתמש",
    "gui.opcodeLabels.year": "שנה",
    "gui.opcodeLabels.month": "חודש",
    "gui.opcodeLabels.date": "תאריך",
    "gui.opcodeLabels.dayofweek": "יום בשבוע",
    "gui.opcodeLabels.hour": "שעה",
    "gui.opcodeLabels.minute": "דקה",
    "gui.opcodeLabels.second": "שניה",
    "gui.opcodeLabels.timer": "שעון עצר",
    "gui.projectLoader.loadError": "טעינת הפרויקט שנבחר נכשלה",
    "gui.sharedMessages.backdrop": "רקע{index}",
    "gui.sharedMessages.costume": "תלבושת{index}",
    "gui.sharedMessages.sprite": "דמות{index}",
    "gui.sharedMessages.pop": "פופ",
    "gui.sharedMessages.replaceProjectWarning": "להחליף את תוכן הפרויקט הנוכחי?",
    "gui.sharedMessages.loadFromComputerTitle": "טעינה מהמחשב שלך",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "פרויקט סקראץ'",
    "boost.color.any": "צבע כלשהו",
    "boost.color.black": "שחור",
    "boost.color.blue": "כחול",
    "boost.color.green": "ירוק",
    "boost.color.red": "אדום",
    "boost.color.white": "לבן",
    "boost.color.yellow": "צהוב",
    "boost.getMotorPosition": "מיקום מנוע [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "זווית הטיה [TILT_DIRECTION]",
    "boost.motorDirection.backward": "בדרך ההיא",
    "boost.motorDirection.forward": "בדרך הזאת",
    "boost.motorDirection.reverse": "הפוך",
    "boost.motorOff": "כבה את מנוע [MOTOR_ID]",
    "boost.motorOn": "הדלק את מנוע [MOTOR_ID]",
    "boost.motorOnFor": "הדלקת [MOTOR_ID] למשך [DURATION] שניות",
    "boost.motorOnForRotation": "הדלק מנוע [MOTOR_ID] למשך [ROTATION] סיבובים",
    "boost.seeingColor": "רואים לבנה בצבע [COLOR]?",
    "boost.setLightHue": "קבע צבע אור ל [HUE]",
    "boost.setMotorDirection": "קבע כיוון [MOTOR_ID] ל[MOTOR_DIRECTION]",
    "boost.setMotorPower": "קבע מהירות של [MOTOR_ID] ל[POWER] %",
    "boost.tiltDirection.any": "הכל",
    "boost.tiltDirection.down": "למטה",
    "boost.tiltDirection.left": "שמאלה",
    "boost.tiltDirection.right": "ימינה",
    "boost.tiltDirection.up": "למעלה",
    "boost.whenColor": "כאשר רואים לבנה בצבע [COLOR]",
    "boost.whenTilted": "כאשר מוטה [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "צפצף תו [NOTE]ל[TIME]שניות",
    "ev3.buttonPressed": "כפתור [PORT] נלחץ?",
    "ev3.getBrightness": "בהירות",
    "ev3.getDistance": "מרחק",
    "ev3.getMotorPosition": "מצב מנוע ב[PORT] ",
    "ev3.motorSetPower": "קבע מנוע[PORT] להספק של [POWER] %",
    "ev3.motorTurnClockwise": "סובב את מנוע[PORT] בכיוון זה במשך [TIME] שניות",
    "ev3.motorTurnCounterClockwise": "סובב את מנוע [PORT] בכיוון ההוא במשך [TIME] שניות",
    "ev3.whenBrightnessLessThan": "כאשר בהירות <[DISTANCE]",
    "ev3.whenButtonPressed": "כאשר לוחצים על כפתור [PORT]",
    "ev3.whenDistanceLessThan": "כאשר מרחק < [DISTANCE]",
    "gdxfor.getAcceleration": "תאוצה [DIRECTION]",
    "gdxfor.getForce": "כוח",
    "gdxfor.getSpin": "מהירות סיבוב [DIRECTION]",
    "gdxfor.getTilt": "זווית הטיה [TILT]",
    "gdxfor.isFreeFalling": "נופל?",
    "gdxfor.isTilted": "מוטה [TILT]",
    "gdxfor.pulled": "נמשך",
    "gdxfor.pushed": "נדחף",
    "gdxfor.shaken": "נוער",
    "gdxfor.startedFalling": "החל ליפול",
    "gdxfor.tiltDirectionMenu.any": "הכל",
    "gdxfor.tiltDirectionMenu.back": "לאחור",
    "gdxfor.tiltDirectionMenu.front": "קדימה",
    "gdxfor.tiltDirectionMenu.left": "שמאלה",
    "gdxfor.tiltDirectionMenu.right": "ימינה",
    "gdxfor.turnedFaceDown": "פונה כלפי מטה",
    "gdxfor.turnedFaceUp": "פונה כלפי מעלה",
    "gdxfor.whenForcePushedOrPulled": "כאשר חיישן הכוח [PUSH_PULL]",
    "gdxfor.whenGesture": "כאשר [GESTURE]",
    "gdxfor.whenTilted": "כאשר מוטה [TILT]",
    "makeymakey.downArrow": "חץ מטה",
    "makeymakey.downArrowShort": "מטה",
    "makeymakey.leftArrow": "חץ שמאלי",
    "makeymakey.leftArrowShort": "שמאלה",
    "makeymakey.rightArrow": "חץ ימני",
    "makeymakey.rightArrowShort": "ימינה",
    "makeymakey.spaceKey": "רווח",
    "makeymakey.upArrow": "חץ מעלה",
    "makeymakey.upArrowShort": "מעלה",
    "makeymakey.whenKeyPressed": "כאשר לוחצים על מקש [KEY]",
    "makeymakey.whenKeysPressedInOrder": "כאשר מקישים את הרצף [SEQUENCE] ",
    "microbit.buttonsMenu.any": "כל",
    "microbit.clearDisplay": "נקה תצוגה",
    "microbit.defaultTextToDisplay": "שלום!",
    "microbit.displaySymbol": "הצג [MATRIX]",
    "microbit.displayText": "הצגת טקסט [TEXT]",
    "microbit.gesturesMenu.jumped": "קפץ",
    "microbit.gesturesMenu.moved": "זז",
    "microbit.gesturesMenu.shaken": "רעד",
    "microbit.isButtonPressed": "לחצו על כפתור [BTN]‏ ?",
    "microbit.isTilted": "נוטה[DIRECTION]?",
    "microbit.pinStateMenu.off": "כבה",
    "microbit.pinStateMenu.on": "הפעל",
    "microbit.tiltAngle": "זווית הטיה [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "כל",
    "microbit.tiltDirectionMenu.back": "אחורית",
    "microbit.tiltDirectionMenu.front": "קדמית",
    "microbit.tiltDirectionMenu.left": "שמאלה",
    "microbit.tiltDirectionMenu.right": "ימינה",
    "microbit.whenButtonPressed": "כאשר לוחצים על כפתור [BTN]",
    "microbit.whenGesture": "כאשר [GESTURE]",
    "microbit.whenPinConnected": "כאשר פין [PIN] מחובר",
    "microbit.whenTilted": "כאשר מוטה [DIRECTION]",
    "music.categoryName": "מוזיקה",
    "music.changeTempo": "שנה קצב ב [TEMPO]",
    "music.drumBass": "(2) תוף בס",
    "music.drumBongo": "(13) בונגו",
    "music.drumCabasa": "(15) קבסה",
    "music.drumClaves": "(9) מקלות הקשה",
    "music.drumClosedHiHat": "(6) מצילה סגורה",
    "music.drumConga": "(14) קונגה",
    "music.drumCowbell": "(11) פעמון פרה",
    "music.drumCrashCymbal": "(4) מצילתיים",
    "music.drumCuica": "(18) קויקה",
    "music.drumGuiro": "(16) גווירו",
    "music.drumHandClap": "(8) מחיאת כף",
    "music.drumOpenHiHat": "(5) מצילה פתוחה",
    "music.drumSideStick": "(3) מקל על צד התוף",
    "music.drumSnare": "(1) תוף סנר",
    "music.drumTambourine": "(7) תוף מרים",
    "music.drumTriangle": "(12) משולש",
    "music.drumVibraslap": "(17) ויברסלאפ",
    "music.drumWoodBlock": "(10) לבנת עץ",
    "music.getTempo": "קצב",
    "music.instrumentBass": "(6) בס",
    "music.instrumentBassoon": "(14) בסון",
    "music.instrumentCello": "(8) צ'לו",
    "music.instrumentChoir": "(15) מקהלה",
    "music.instrumentClarinet": "(10) קלרינט",
    "music.instrumentElectricGuitar": "(5) גיטרה חשמלית",
    "music.instrumentElectricPiano": "(2) פסנתר חשמלי",
    "music.instrumentFlute": "(12) חליל",
    "music.instrumentGuitar": "(4) גיטרה",
    "music.instrumentMarimba": "(19) מרימבה",
    "music.instrumentMusicBox": "(17) תיבת נגינה ",
    "music.instrumentOrgan": "(3) אורגן",
    "music.instrumentPiano": "(1) פסנתר",
    "music.instrumentPizzicato": "(7) פיציקטו",
    "music.instrumentSaxophone": "(11) סקסופון",
    "music.instrumentSteelDrum": "(18) תוף פלדה",
    "music.instrumentSynthLead": "(20) סינתיסייזר לד",
    "music.instrumentSynthPad": "(21) סינתיסייזר פאד",
    "music.instrumentTrombone": "(9) טרומבון",
    "music.instrumentVibraphone": "(16) ויברפון",
    "music.instrumentWoodenFlute": "(13) חליל עץ",
    "music.midiPlayDrumForBeats": "נגן בתוף [DRUM] למשך [BEATS] פעימות",
    "music.midiSetInstrument": "קביעת כלי נגינה ל[INSTRUMENT]",
    "music.playDrumForBeats": "נגן בתוף [DRUM] למשך [BEATS] פעימות",
    "music.playNoteForBeats": "נגן תו [NOTE] במשך [BEATS] פעימות",
    "music.restForBeats": "נוח למשך [BEATS] פעימות",
    "music.setInstrument": "קבע כלי נגינה ל [INSTRUMENT]",
    "music.setTempo": "קבע קצב ל [TEMPO]",
    "pen.categoryName": "עט",
    "pen.changeColorParam": "שנה [COLOR_PARAM] עט ב[VALUE]",
    "pen.changeHue": "שנה צבע עט ב[HUE]",
    "pen.changeShade": "שנה הצללת עט ב[SHADE]",
    "pen.changeSize": "שנה גודל עט ב[SIZE]",
    "pen.clear": "מחק הכול",
    "pen.colorMenu.brightness": "בהירות",
    "pen.colorMenu.color": "צבע",
    "pen.colorMenu.saturation": "רווי צבע",
    "pen.colorMenu.transparency": "שקיפות",
    "pen.penDown": "עט מטה",
    "pen.penUp": "עט מעלה",
    "pen.setColor": "קבע צבע עט ל[COLOR]",
    "pen.setColorParam": "קבע [COLOR_PARAM] עט ל[VALUE]",
    "pen.setHue": "קבע צבע עט ל[HUE]",
    "pen.setShade": "קבע הצללת עט ל[SHADE]",
    "pen.setSize": "קבע גודל עט ל[SIZE]",
    "pen.stamp": "חתום",
    "speech.defaultWhenIHearValue": "קדימה!",
    "speech.extensionName": "דיבור לטקסט",
    "speech.listenAndWait": "הקשב וחכה",
    "speech.speechReporter": "דיבור",
    "speech.whenIHear": "כאשר אני שומע [PHRASE]",
    "text2speech.alto": "אלט",
    "text2speech.categoryName": "טקסט לדיבור",
    "text2speech.defaultTextToSpeak": "שלום",
    "text2speech.giant": "ענק",
    "text2speech.kitten": "חתלתול",
    "text2speech.setLanguageBlock": "קבע שפה ל[LANGUAGE]",
    "text2speech.setVoiceBlock": "קבע קול ל [VOICE]",
    "text2speech.speakAndWaitBlock": "הקרא [WORDS]",
    "text2speech.squeak": "ציוץ",
    "text2speech.tenor": "טנור",
    "translate.categoryName": "תרגום",
    "translate.defaultTextToTranslate": "שלום",
    "translate.translateBlock": "תרגם[WORDS] ל[LANGUAGE]",
    "translate.viewerLanguage": "שפה",
    "videoSensing.categoryName": "חיישן מצלמה",
    "videoSensing.direction": "כיוון",
    "videoSensing.motion": "תנועה",
    "videoSensing.off": "כבה",
    "videoSensing.on": "הפעל",
    "videoSensing.onFlipped": "הפעל כתמונת ראי",
    "videoSensing.setVideoTransparency": "קבע שקיפות מצלמה ל [TRANSPARENCY]",
    "videoSensing.sprite": "דמות",
    "videoSensing.stage": "במה",
    "videoSensing.videoOn": "[ATTRIBUTE] של המצלמה על [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] את המצלמה",
    "videoSensing.whenMotionGreaterThan": "כאשר התנועה במצלמה > [REFERENCE]",
    "wedo2.getDistance": "מרחק",
    "wedo2.getTiltAngle": "זווית הטיה [TILT_DIRECTION]",
    "wedo2.isTilted": "מוטה[TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "בדרך ההיא",
    "wedo2.motorDirection.forward": "בדרך הזאת",
    "wedo2.motorDirection.reverse": "הפוך",
    "wedo2.motorId.a": "מנוע A",
    "wedo2.motorId.all": "כל המנועים",
    "wedo2.motorId.b": "מנוע B",
    "wedo2.motorId.default": "מנוע",
    "wedo2.motorOff": "כיבוי [MOTOR_ID]",
    "wedo2.motorOn": "הדלקת [MOTOR_ID]",
    "wedo2.motorOnFor": "הדלקת[MOTOR_ID] למשך [DURATION] שניות",
    "wedo2.playNoteFor": "ניגון תו [NOTE] למשך [DURATION] שניות",
    "wedo2.setLightHue": "קבע צבע אור ל [HUE]",
    "wedo2.setMotorDirection": "קבע כיוון[MOTOR_ID] ל [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "קבע הספק של[MOTOR_ID] ל [POWER]",
    "wedo2.tiltDirection.any": "כל",
    "wedo2.tiltDirection.down": "מטה",
    "wedo2.tiltDirection.left": "שמאלה",
    "wedo2.tiltDirection.right": "ימינה",
    "wedo2.tiltDirection.up": "מעלה",
    "wedo2.whenDistance": "כאשר מרחק [OP] [REFERENCE]",
    "wedo2.whenTilted": "כאשר מוטה [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "צבע",
    "paint.paintEditor.saturation": "רוויה",
    "paint.paintEditor.brightness": "בהירות",
    "paint.paintEditor.costume": "תלבושת",
    "paint.paintEditor.group": "קבץ",
    "paint.paintEditor.ungroup": "בטל קיבוץ",
    "paint.paintEditor.undo": "בטל",
    "paint.paintEditor.redo": "בצע שוב",
    "paint.paintEditor.forward": "קדימה",
    "paint.paintEditor.backward": "אחורה",
    "paint.paintEditor.front": "העבר לקידמה",
    "paint.paintEditor.back": "העבר לרקע",
    "paint.paintEditor.more": "עוד",
    "paint.modeTools.brushSize": "גודל",
    "paint.modeTools.eraserSize": "גודל מחק",
    "paint.modeTools.copy": "העתק",
    "paint.modeTools.paste": "הדבק",
    "paint.modeTools.delete": "מחק",
    "paint.modeTools.curved": "מעוקל",
    "paint.modeTools.pointed": "מחודד",
    "paint.modeTools.thickness": "עובי",
    "paint.modeTools.flipHorizontal": "הפוך אופקית",
    "paint.modeTools.flipVertical": "הפוך אנכית",
    "paint.modeTools.filled": "מלא",
    "paint.modeTools.outlined": "מסורטט",
    "paint.paintEditor.bitmap": "המרה למפת סיביות",
    "paint.paintEditor.vector": "המרה לוקטור",
    "paint.paintEditor.fill": "מילוי",
    "paint.paintEditor.stroke": "מסגרת",
    "paint.brushMode.brush": "מברשת",
    "paint.eraserMode.eraser": "מחק",
    "paint.fillMode.fill": "מילוי",
    "paint.lineMode.line": "קו",
    "paint.ovalMode.oval": "עיגול",
    "paint.rectMode.rect": "מלבן",
    "paint.reshapeMode.reshape": "שנה צורה",
    "paint.roundedRectMode.roundedRect": "מלבן מעוגל",
    "paint.selectMode.select": "בחר",
    "paint.textMode.text": "טקסט",
    "paint.colorPicker.swap": "החלף"
  },
  "hi": {
    "gui.alerts.lostPeripheralConnection": "स्क्रैच ने  {extensionName} का कनेक्शन खो दिया।",
    "gui.alerts.tryAgain": "पुनः प्रयास करें",
    "gui.alerts.download": "डाउनलोड",
    "gui.connection.reconnect": "पुनः जोड़े ",
    "gui.backpack.costumeLabel": "पोशाक",
    "gui.backpack.soundLabel": "आवाज़",
    "gui.backpack.scriptLabel": "लिपि",
    "gui.backpack.spriteLabel": "स्प्राइट",
    "gui.backpack.header": "बैगपैक",
    "gui.backpack.errorBackpack": "बैगपैक लोड करने में त्रुटि ",
    "gui.backpack.loadingBackpack": "लोड कर रहे हैं ...",
    "gui.backpack.more": "और ",
    "gui.backpack.emptyBackpack": "बैगपैक खाली है ",
    "gui.unsupportedBrowser.label": "वेब ब्राउज़र सहायक नहीं है ",
    "gui.unsupportedBrowser.errorLabel": "एक गलती पाई गई है",
    "gui.unsupportedBrowser.notRecommended": "हमें बहुत खेद है, लेकिन ऐसा लगता है कि आप एक ऐसे ब्राउज़र संस्करण का उपयोग कर रहे हैं जो स्क्रैच का समर्थन नहीं करता है। हम गूगल क्रोम, मोज़िला फ़ायरफ़ॉक्स, माइक्रोसॉफ्ट एज, या एप्पल सफारी जैसे समर्थित ब्राउज़र के नवीनतम संस्करण को अपडेट करने की सलाह देते हैं।",
    "gui.unsupportedBrowser.description": "हमें बहुत खेद है, लेकिन स्क्रैच इस ब्राउज़र का समर्थन नहीं करता है। हम गूगल क्रोम, मोज़िला फ़ायरफ़ॉक्स, माइक्रोसॉफ्ट एज, या एप्पल सफारी जैसे समर्थित ब्राउज़र के नवीनतम संस्करण को अपडेट करने की सलाह देते हैं।",
    "gui.unsupportedBrowser.back": "वापस ",
    "gui.unsupportedBrowser.previewfaq": "ज्यादा जानकारी के लिए {previewFaqLink} पर जाये  ",
    "gui.unsupportedBrowser.previewfaqlinktext": "अक्सर पूछे जाने वाले प्रश्न ",
    "gui.cards.all-tutorials": "ट्यूटोरियल",
    "gui.cards.shrink": "छोटा करें",
    "gui.cards.expand": "बड़ा करें",
    "gui.cards.close": "बंद करें ",
    "gui.cards.more-things-to-try": "अभ्यास हेतु अन्य चीजें",
    "gui.cards.see-more": "और देखें ",
    "gui.comingSoon.message1": "चिन्ता ना करें , हम इसपर कार्य कर रहे हैं  {emoji}",
    "gui.comingSoon.message2": "शीघ्रः प्रस्तुत होगा ",
    "gui.comingSoon.message3": "हम इसपर कार्य कर रहे हैं  {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "सम्बंधित यन्त्र नहीं मिला ",
    "gui.connection.auto-scanning.prescan": "अपना उपकरण पास में रखें, फिर खोजना शुरू करें",
    "gui.connection.auto-scanning.pressbutton": "अपने यन्त्र पर बटन दबाएं ",
    "gui.connection.auto-scanning.start-search": "खोजना शुरू करें ",
    "gui.connection.connecting-searchbutton": "खोज रहें हैं ...",
    "gui.connection.auto-scanning.try-again": "पुनः प्रयास करें ",
    "gui.connection.auto-scanning.updatePeripheralButton": "मेरे डिवाइस को अपडेट करें\n ",
    "gui.connection.connected": "जुड़ा हुआ ",
    "gui.connection.disconnect": "बिना जुड़ा हुआ ",
    "gui.connection.go-to-editor": "संपादक को जाये ",
    "gui.connection.connecting-cancelbutton": "जुड़ रहा है ...",
    "gui.connection.error.errorMessage": "लगता है कुछ गलत हुआ है",
    "gui.connection.error.tryagainbutton": "पुनः प्रयास करें ",
    "gui.connection.error.helpbutton": "सहायता",
    "gui.connection.peripheral-name-label": "यन्त्र का नाम ",
    "gui.connection.connect": "जुड़ें ",
    "gui.connection.scanning.lookingforperipherals": "यंत्रो की  तलाश में",
    "gui.connection.scanning.noPeripheralsFound": "सम्बंधित यन्त्र नहीं मिला ",
    "gui.connection.scanning.instructions": "ऊपर दी गई सूची मैं अपना यन्त्र चुनिए ",
    "gui.connection.search": "ताजा ",
    "gui.connection.scanning.updatePeripheralButton": "मेरे डिवाइस को अपडेट करें\n ",
    "gui.connection.unavailable.installscratchlink": "सुनिश्चित करिये की आपने स्क्रैच संस्थापित किया है और वो कार्यान्वित है ",
    "gui.connection.unavailable.enablebluetooth": "सुनिश्चित करिये की ब्लूटूथ कार्य कर रहा है ",
    "gui.connection.unavailable.tryagainbutton": "पुनः प्रयास करें ",
    "gui.connection.unavailable.helpbutton": "सहायता",
    "gui.connection.updatePeripheral.microBitConnect": "एक USB केबल का उपयोग करके इस उपकरण से अपने {extensionName} को कनेक्ट करें।",
    "gui.connection.updatePeripheral.pressUpdate": "बटन 'अपडेट करें' दबाएं और अपडेट को पूरा होने दें।",
    "gui.connection.updatePeripheral.progress": "{progressPercentage} अपडेट हो रहा है",
    "gui.connection.updatePeripheral.updateSuccessful": "अपडेट सफल हुआ",
    "gui.connection.updatePeripheral.updateFailed": "अपडेट विफल हुआ",
    "gui.connection.updatePeripheral.goBackButton": "वापस ",
    "gui.connection.updatePeripheral.updateNowButton": "अपडेट करें",
    "gui.connection.updatePeripheral.updateAgainButton": "पुनः प्रयास करें",
    "gui.controls.go": "शुरू करें ",
    "gui.controls.stop": "रोकें ",
    "gui.crashMessage.label": "लगता है कुछ गलत हुआ है ",
    "gui.crashMessage.description": "हमें बहुत खेद है , लगता है की स्क्रैच ध्वस्त हो गया है. इस घटना के बारे में स्क्रैच दल को स्वतः सूचित कर दिया गया है। कृपया इस पृष्ठ को पुनः ताजा करें ",
    "gui.crashMessage.errorNumber": "आपकी त्रुटि आईडी{errorId} से लॉग इन की गई थी",
    "gui.crashMessage.reload": "पुनः ताजा करें ",
    "gui.customProcedures.myblockModalTitle": "खंड बनाये",
    "gui.customProcedures.addAnInputNumberText": "इनपुट जोड़े ",
    "gui.customProcedures.numberTextType": "संख्या या शब्द ",
    "gui.customProcedures.addAnInputBoolean": "इनपुट जोड़े ",
    "gui.customProcedures.booleanType": "बूलियन",
    "gui.customProcedures.addALabel": "उपनाम जोड़ें ",
    "gui.customProcedures.runWithoutScreenRefresh": "बिना स्क्रीन रिफ्रेश किये आदेशों को संचालित करें ",
    "gui.customProcedures.cancel": "रद्द करें ",
    "gui.customProcedures.ok": "ठीक है ",
    "gui.SpriteInfo.direction": "प्रवाह ",
    "gui.directionPicker.rotationStyles.allAround": "चारों तरफ ",
    "gui.directionPicker.rotationStyles.leftRight": "बायें / दायें ",
    "gui.directionPicker.rotationStyles.dontRotate": "और न घुमाये ",
    "gui.gui.addExtension": "एक्सटेंशन जोड़िये ",
    "gui.gui.codeTab": "कोड ",
    "gui.gui.backdropsTab": "पृष्ठभूमि",
    "gui.gui.costumesTab": "पोशाक ",
    "gui.gui.soundsTab": "ध्वनि नियंत्रण",
    "gui.extensionLibrary.comingSoon": "शीघ्रः प्रस्तुत होगा",
    "gui.extensionLibrary.requires": "की आवश्यकता है",
    "gui.extensionLibrary.collaboration": "सहयोग से",
    "gui.library.filterPlaceholder": "खोज",
    "gui.library.allTag": "सब",
    "gui.loader.message1": "ब्लॉक बनाना",
    "gui.loader.message2": "स्प्राइट लोड हो रहें हैं",
    "gui.loader.message3": "ध्वनि लोड हो रही है ...",
    "gui.loader.message4": "एक्सटेंशन लोड हो रहा है ...",
    "gui.loader.message5": "मुश्किल प्रबंधन",
    "gui.loader.message6": "नैनो र्टान्समिट हो रहें हैं ...",
    "gui.loader.message7": "गोबो शक्तिशाली हो रहे हैं ",
    "gui.loader.message8": "इमोजी तैयार हो रहे हैं  ",
    "gui.loader.headline": "परीयोजना लोङ हो रही है",
    "gui.loader.creating": "परीयोजना बन रही है",
    "gui.accountMenu.profile": "प्रोफ़ाइल",
    "gui.accountMenu.myStuff": "मेरी चीज़ें",
    "gui.accountMenu.myClasses": "मेरी कक्षाएं",
    "gui.accountMenu.myClass": "मेरी कक्षा",
    "gui.accountMenu.accountSettings": "खाते की सेटिंग्स",
    "gui.accountMenu.signOut": "साइन आउट",
    "gui.authorInfo.byUser": "{username} द्वारा",
    "gui.menuBar.seeProjectPage": "परियोजना के पेज को देखें",
    "gui.menuBar.language": "भाषा ",
    "general.username": "यूज़र नेम",
    "general.password": "पासवर्ड",
    "general.signIn": "साइन इन",
    "login.needHelp": "मदद चाहिए?",
    "form.validationRequired": "यह फ़ील्ड आवश्यक है",
    "gui.menuBar.tutorialsLibrary": "शिक्षण सामग्री",
    "gui.menuBar.restoreSprite": "स्प्राइट को पुनःस्थापित करें",
    "gui.menuBar.restoreSound": "आवाज़ को पुनःस्थापित करें",
    "gui.menuBar.restoreCostume": "पोशाक को पुनःस्थापित करें",
    "gui.menuBar.restore": "पुनःस्थापित करें",
    "gui.menuBar.saveNow": "अभी सुरक्षित  करें",
    "gui.menuBar.saveAsCopy": "कॉपी के रूप में सुरक्षित करें",
    "gui.menuBar.remix": "रीमिक्स",
    "gui.menuBar.new": "नया",
    "gui.menuBar.file": "फाइल",
    "gui.menuBar.downloadToComputer": "कमप्यूटर पर सुरक्षित करें",
    "gui.menuBar.edit": "संपादित करे",
    "gui.menuBar.turboModeOff": "टर्बो मोड को बंद करें",
    "gui.menuBar.turboModeOn": "टर्बो मोड चालू करें",
    "gui.menuBar.modeMenu": "मोड",
    "gui.menuBar.normalMode": "सामान्य मोड",
    "gui.menuBar.caturdayMode": "कैटरडे मोड",
    "gui.menuBar.joinScratch": "स्क्रैच में शामिल हों",
    "gui.menuBar.signIn": "साइन इन",
    "gui.gui.projectTitlePlaceholder": "परियोजना का शीर्षक यहाँ",
    "gui.menuBar.saveNowLink": "अभी सुरक्षित  करें",
    "gui.menuBar.settings": "सेटिंग्स",
    "gui.menuBar.isShared": "शेयर हो गया है",
    "gui.menuBar.share": "शेयर",
    "gui.menuBar.colorMode": "रंग मोड",
    "gui.modal.help": "सहायता",
    "gui.modal.back": "वापस ",
    "gui.monitor.listMonitor.empty": "(खाली)",
    "gui.monitor.listMonitor.listLength": "लंबाई {length}",
    "gui.monitor.contextMenu.default": "सामान्य पठन",
    "gui.monitor.contextMenu.large": "बड़ा पठन",
    "gui.monitor.contextMenu.slider": "स्लाइडर",
    "gui.monitor.contextMenu.sliderRange": "स्लाइडर की रेंज बदलें",
    "gui.monitor.contextMenu.import": "आयात",
    "gui.monitor.contextMenu.export": "निर्यात",
    "gui.monitor.contextMenu.hide": "छुपाएँ",
    "gui.playButton.play": "चलाएँ",
    "gui.playButton.stop": "रोकें ",
    "gui.gui.variableScopeOptionAllSprites": "सभी स्प्राइट के लिए",
    "gui.gui.variableScopeOptionSpriteOnly": "इसी स्प्राइट के लिए",
    "gui.gui.cloudVariableOption": "क्लाउड वेरिएबल्स (सर्वर पर स्टोर किये हुए)",
    "gui.gui.variablePromptAllSpritesMessage": "यह वेरिएबल सभी स्प्राइटस के लिए उपलब्ध होगा ",
    "gui.gui.listPromptAllSpritesMessage": "यह सूची सभी स्प्राइट्स के लिए उपलब्ध होगी।",
    "gui.prompt.cancel": "रद्द करें ",
    "gui.prompt.ok": "ठीक है ",
    "gui.playbackStep.stopMsg": "रोकें ",
    "gui.playbackStep.playMsg": "चलाएँ",
    "gui.playbackStep.loadingMsg": "लोड कर रहे हैं ...",
    "gui.playbackStep.saveMsg": "सुरक्षित करें ",
    "gui.playbackStep.reRecordMsg": "दोबारा दर्ज करे",
    "gui.recordModal.title": "ध्वनि रिकॉर्ड करें",
    "gui.recordingStep.beginRecord": "नीचे दिए गए बटन पर क्लिक करके रिकॉर्डिंग शुरू करें",
    "gui.recordingStep.permission": "{arrow}हमें आपके माइक्रोफ़ोन का उपयोग करने के लिए आपकी अनुमति की आवश्यकता है",
    "gui.recordingStep.stop": "रिकॉर्डिंग बंद करें",
    "gui.recordingStep.record": "रिकॉर्ड",
    "gui.sliderModal.min": "न्यूनतम मूल्य",
    "gui.sliderModal.max": "अधिकतम मूल्य",
    "gui.sliderModal.title": "स्लाइडर की रेंज बदलें",
    "gui.sliderPrompt.cancel": "रद्द करें ",
    "gui.sliderPrompt.ok": "ठीक है ",
    "gui.soundEditor.sound": "आवाज",
    "gui.soundEditor.play": "चलाएँ",
    "gui.soundEditor.stop": "रोकें ",
    "gui.soundEditor.copy": "प्रतिलिपि ",
    "gui.soundEditor.paste": "चिपकाना ",
    "gui.soundEditor.copyToNew": "नए में कॉपी करें",
    "gui.soundEditor.delete": "मिटाये",
    "gui.soundEditor.save": "सुरक्षित करें ",
    "gui.soundEditor.undo": "पूर्ववत",
    "gui.soundEditor.redo": "पुनः करें",
    "gui.soundEditor.faster": "और तेज़",
    "gui.soundEditor.slower": "और धीरे",
    "gui.soundEditor.echo": "गूंज",
    "gui.soundEditor.robot": "रोबोट",
    "gui.soundEditor.louder": "और ऊॅंचा",
    "gui.soundEditor.softer": "और धीमा",
    "gui.soundEditor.reverse": "उलटना",
    "gui.soundEditor.fadeOut": "फेड आउट ",
    "gui.soundEditor.fadeIn": "फेड इन ",
    "gui.soundEditor.mute": "आवाज बंद",
    "gui.SpriteInfo.spritePlaceholder": "नाम",
    "gui.SpriteInfo.showSpriteAction": "स्प्राइट दिखाएं",
    "gui.SpriteInfo.hideSpriteAction": "स्प्राइट छिपाएं",
    "gui.SpriteInfo.sprite": "स्प्राइट",
    "gui.SpriteInfo.show": "दिखाएं",
    "gui.SpriteInfo.size": "माप ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "प्रतिरुप",
    "gui.spriteSelectorItem.contextMenuExport": "निर्यात",
    "gui.spriteSelectorItem.contextMenuDelete": "मिटाना",
    "gui.spriteSelector.addSpriteFromLibrary": "स्प्राइट चुनें",
    "gui.spriteSelector.addSpriteFromPaint": "रंग",
    "gui.spriteSelector.addSpriteFromSurprise": "आश्चर्य",
    "gui.spriteSelector.addSpriteFromFile": "स्प्राइट अपलोड करें",
    "gui.stageHeader.stageSizeLarge": "बड़े स्तर पर स्विच करें",
    "gui.stageHeader.stageSizeSmall": "छोटे स्तर पर स्विच करें",
    "gui.stageHeader.stageSizeFull": "पूर्ण स्क्रीन मोड करें",
    "gui.stageHeader.stageSizeUnFull": "पूर्ण स्क्रीन मोड बंद करें",
    "gui.stageHeader.fullscreenControl": "पूर्ण स्क्रीन नियंत्रण",
    "gui.spriteSelector.addBackdropFromLibrary": "पृष्ठभूमि चुनें",
    "gui.stageSelector.addBackdropFromPaint": "रंग",
    "gui.stageSelector.addBackdropFromSurprise": "आश्चर्य",
    "gui.stageSelector.addBackdropFromFile": "पृष्ठभूमि अपलोड करें",
    "gui.stageSelector.stage": "मंच",
    "gui.stageSelector.backdrops": "पृष्ठभूमि",
    "gui.telemetryOptIn.label": "स्क्रैच को बेहतर बनाने के लिए आंकड़ों को रिपोर्ट करें",
    "gui.telemetryOptIn.body1": "स्क्रैच टीम बेहतर समझने के लिए हरदम दुनिया भर में देख रही है कि स्क्रैच का उपयोग कैसे किया जाता है। इस प्रयास का समर्थन करने में मदद करने के लिए, आप स्क्रैच को स्वचालित रूप से स्क्रैच टीम को उपयोग जानकारी भेजने की अनुमति दे सकते हैं।",
    "gui.telemetryOptIn.body2": "हम जो जानकारी इकट्ठा करते हैं उसमे भाषा का चुनाव, ब्लॉक के उपयोग, और सेविंग, लोडिंग और प्रोजेक्ट को अपलोड करने जैसे कुछ इवेंट्स। हम किसी तरह की व्यक्तिगत जानकारी इकट्ठा नहीं करते। अधिक जानकारी के लिए कृपया यह लिंक देखें {privacyPolicyLink} ",
    "gui.telemetryOptIn.privacyPolicyLink": "गोपनीयता नीति",
    "gui.telemetryOptIn.optInText": "स्क्रैच टीम के साथ मेरा उपयोग करना डेटा साझा करें",
    "gui.telemetryOptIn.optInTooltip": "दूरमापी सक्षम करें",
    "gui.telemetryOptIn.optOutText": "स्क्रैच टीम के साथ मेरा उपयोग करना डेटा नहीं साझा करें",
    "gui.telemetryOptIn.optOutTooltip": "दूरमापी अक्षम करें",
    "gui.telemetryOptIn.settingWasUpdated": "आपकी सेटिंग अपडेट की गई थी।",
    "gui.telemetryOptIn.buttonClose": "बंद करें ",
    "gui.turboMode.active": "टर्बो मोड",
    "gui.webglModal.label": "आपका ब्राउज़र WebGL का समर्थन नहीं करता है",
    "gui.webglModal.description": "दुर्भाग्य से लगता है आपका ब्राउज़र या कमप्यूटर {webGlLink} है   । स्क्रैच  3.0 को चलाने के लिए इस टैकनोलजी की आवश्यकता है",
    "gui.webglModal.webgllink": "WebGL का समर्थन नहीं करता है",
    "gui.webglModal.back": "वापस ",
    "gui.webglModal.previewfaq": "ज्यादा जानकारी के लिया {previewFaqLink} पर जाये  ",
    "gui.webglModal.previewfaqlinktext": "अक्सर पूछे जाने वाले प्रश्न ",
    "gui.costumeLibrary.chooseABackdrop": "बैक्ड्राप चुनें",
    "gui.costumeLibrary.chooseACostume": "पोशाक चुनें",
    "gui.costumeTab.addBackdropFromLibrary": "बैक्ड्राप चुनें",
    "gui.costumeTab.addCostumeFromLibrary": "पोशाक चुनें",
    "gui.costumeTab.addBlankCostume": "रंग",
    "gui.costumeTab.addSurpriseCostume": "आश्चर्य",
    "gui.costumeTab.addFileBackdrop": "बैक्ड्राप अपलोड करें",
    "gui.costumeTab.addFileCostume": "पोशाक अपलोड करें",
    "gui.extensionLibrary.chooseAnExtension": "एक्सटेनशन चुनें",
    "gui.extensionLibrary.extensionUrl": "एक्सटेंशन का यूआरएल दर्ज करें",
    "gui.monitors.importListColumnPrompt": "किस कॉलम का उपयोग करना चाहिए (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "रिकॉर्डिंग शुरू नहीं हो सकी",
    "gui.soundLibrary.chooseASound": "ध्वनि चुनें",
    "gui.soundTab.fileUploadSound": "ध्वनि अपलोड करें",
    "gui.soundTab.surpriseSound": "आश्चर्य",
    "gui.soundTab.recordSound": "रिकॉर्ड",
    "gui.soundTab.addSoundFromLibrary": "ध्वनि चुनें",
    "gui.spriteLibrary.chooseASprite": "स्प्राइट चुनें",
    "gui.tipsLibrary.tutorials": "शिक्षण चुनें",
    "gui.alerts.createsuccess": "नई परियोजना बनाएं",
    "gui.alerts.createcopysuccess": "परियोजना को कॉपी के रूप में सुरक्षित  करें",
    "gui.alerts.createremixsuccess": "परियोजना को रिमिक्स के रूप में सुरक्षित किया गया है",
    "gui.alerts.creating": "नया बन रहा है",
    "gui.alerts.creatingCopy": "काॅपी हो रहा है",
    "gui.alerts.creatingRemix": "परियोजना को रिमिक्स किया जा रहा है",
    "gui.alerts.creatingError": "परियोजना नहीं बना सका। कृपया पुन: प्रयास करें!",
    "gui.alerts.savingError": "परियोजना सेव नहीं हो सका ",
    "gui.alerts.savesuccess": "परियोजना सेव हो गई",
    "gui.alerts.saving": "परीयोजना सेव हो रही है",
    "gui.alerts.cloudInfo": "कृपया ध्यान दें. क्लाउड वेरिएबल्स में आप केवल नंबर्स/ आंकड़े/ संख्या लिख सकते हैं. यह अक्षर और विशेष चिन्हों को सपोर्ट नहीं करता  {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "और अधिक जानें",
    "gui.alerts.importing": "आयात हो रहा है...",
    "gui.defaultProject.meow": "म्याऊँ",
    "gui.defaultProject.variable": "मेरा वेरिएबल",
    "gui.howtos.intro-move-sayhello-hat.name": "शुरू हो रहा है",
    "gui.howtos.intro-move.step_stepMove": "मूव ब्लॉक जोड़ें",
    "gui.howtos.add-a-move-block.step_stepSay": "वर्णन ब्लॉक जोड़ें",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "शुरू करने के लिए हरी झंडी पर क्लिक करें",
    "gui.howtos.intro-getting-started-ASL.name": "शुरू करना - ए.एस.एल",
    "gui.howtos.animate-a-name.name": "एक नाम को एनिमेट कीजिए ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "अक्षर स्प्राइट चुनें",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "क्लिक करने पर ध्वनि चलाएँ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "एक और अक्षर स्प्राइट चुनें",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "रंग बदले",
    "gui.howtos.animate-a-name.step_AnimateSpin": "एक और लेटर वाला स्प्राइट चुनिए और उसे घुमाइए ",
    "gui.howtos.animate-a-name.step_AnimateGrow": "एक और लेटर वाला स्प्राइट चुनिए और उसका आकार बढ़ाइए",
    "gui.howtos.imagine": "एक ऐसी दुनिया की कल्पना करें",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "आप जो कहना चाहते हैं उसे टाइप कीजिये",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "शुरू करने के लिए  ग्रीन फ्लॅग पर क्लिक कीजिये",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "कोई भी बैक्ड्राप चुनें ",
    "gui.howtos.imagine.step_imagineChooseSprite": "कोई भी स्प्राइट चुनें",
    "gui.howtos.imagine.step_imagineFlyAround": "ग्लाइड करने के लिए स्पेस की दबाइये",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "दूसरा स्प्राइट चुनिए",
    "gui.howtos.imagine.step_imagineLeftRight": "दाएं-बाएं चलिए ",
    "gui.howtos.imagine.step_imagineUpDown": "ऊपर-नीचे जाइए",
    "gui.howtos.imagine.step_imagineChangeCostumes": "कॉस्ट्यूम बदलिए",
    "gui.howtos.imagine.step_imagineGlideToPoint": "एक बिन्दु तक ग्लाइड कीजिए",
    "gui.howtos.imagine.step_imagineGrowShrink": "बढ़ें और सिकुड़ें",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "दूसरा बैकड्रॉप चुनिए",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "बैक्ड्राप बदलें",
    "gui.howtos.imagine.step_imagineRecordASound": "एक आवाज जोड़िए ",
    "gui.howtos.imagine.step_imagineChooseSound": "ध्वनि चुनें",
    "gui.howtos.make-music.name": "संगीत बनाओ",
    "gui.howtos.Make-Music.step_PickInstrument": "वाद्ययंत्र स्प्राइट चुनें",
    "gui.howtos.Make-Music.step_PlaySoundClick": "आवाज़ चलाएं जब क्लिक करें ",
    "gui.howtos.Make-Music.step_MakeSong": "एक गीत बनाएँ",
    "gui.howtos.make-music.step_MakeBeat": "ड्रम चुनें और ताल बनाएं",
    "gui.howtos.make-music.step_MakeBeatBox": " माइक्रोफ़ोन स्प्राइट और सरप्राइज़ बीटबॉक्स चुनिए",
    "gui.howtos.story.name": "एक कहानी बनाएं",
    "gui.howtos.story.step_addbg": "बैक्ड्राप जोड़ें",
    "gui.howtos.story.step_addsprite": "एक पात्र जोडें",
    "gui.howtos.story.step_saysomething": "कुछ कहे ",
    "gui.howtos.story.step_addanothersprite": "और पात्र जोडें",
    "gui.howtos.story.step_flip": "दिशा पलटें",
    "gui.howtos.story.step_conversation": "बातचीत करें",
    "gui.howtos.story.addanotherbg": "एक और बैक्ड्राप जोड़ें",
    "gui.howtos.story.step_swithbg": "बैक्ड्राप बदलें",
    "gui.howtos.story.step_hidewizard": "कॅरेक्टर को छुपाइये",
    "gui.howtos.story.step_showwizard": "कॅरेक्टर को दिखाइए",
    "gui.howtos.make-a-chase-game.name": "पीछा करने का खेल बनायें",
    "gui.howtos.Chase-Game.step_BG": "बैक्ड्राप जोड़ें",
    "gui.howtos.chase-game.step_AddOcto": "स्प्राइट जोड़ें",
    "gui.howtos.make-music.step_LeftRight": "एरो कीज़ द्वारा दाएँ और बाएँ ले जाएँ",
    "gui.howtos.Chase-Game.step_UpDown": "एरो कीज़ द्वारा ऊपर और नीचे ले जाएँ",
    "gui.howtos.Chase-Game.step_AddStar": "और स्प्राइट जोड़ें",
    "gui.howtos.Chase-Game.step_MoveRandom": "अनियमित रूप से बदलना",
    "gui.howtos.Chase-Game.step_WhenTouch": "ऑक्टोपस के स्प्राइट को छूने पर आवाज हो",
    "gui.howtos.Chase-Game.step_ScoreVariable": "स्कोर वेरिएबल बनाइए ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "ऑक्टोपस के स्प्राइट को छूने पर स्कोर बढे",
    "gui.howtos.animate-char.name": "कॅरेक्टर को एनिमेट कीजिए",
    "gui.howtos.animate-char.step_addbg": "बैक्ड्राप जोड़ें",
    "gui.howtos.animate-char.step_addsprite": "स्प्राइट जोड़ें",
    "gui.howtos.animate-char.step_saysomething": "कुछ कहे ",
    "gui.howtos.animate-char.step_addsound": "ध्वनि जोड़ें",
    "gui.howtos.animate-char.step_animatetalking": "बोलचाल का एनिमेशन बनाइये",
    "gui.howtos.animate-char.step_arrowkeys": "एरो कीज का प्रयोग कर के चलें",
    "gui.howtos.animate-char.step_jump": "कूदें",
    "gui.howtos.animate-char.step_changecolor": "रंग बदले",
    "gui.howtos.make-a-game.name": "क्लिकर गेम बनाइए ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "स्प्राइट चुनें",
    "gui.howtos.make-a-game.step_GamePlaySound": "क्लिक करने पर ध्वनि चलाएँ",
    "gui.howtos.make-a-game.step_GameAddScore": "स्कोर वेरिएबल बनाइए ",
    "gui.howtos.make-a-game.step_GameChangeScore": "जब क्लिक किया जाएँ स्कोर बढ़ाएँ",
    "gui.howtos.make-a-game.step_Random": "रैंडम पोजीशन पर जाइए ",
    "gui.howtos.make-music.step_GameChangeColor": "रंग बदले",
    "gui.howtos.make-music.step_ResetScore": "स्कोर को दोबारा सेट करें",
    "gui.howtos.make-it-fly.name": "इसे उड़ाइए ",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "स्काई बैकग्राउंड को चुनें",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "एक कॅरेक्टर चुनें",
    "gui.howtos.fly.step_stepflySaySomething": "कुछ कहे ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "एरो कीज से चलाइये",
    "gui.howtos.fly.step_stepflyChooseObject": "इकट्ठा करने के लिए कोई चीज चुनिए ",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "उस चीज को चलाइए ",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "अपना कॅरेक्टर चुनिए ",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "स्कोर जोड़िए ",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "स्कोर गिनें ",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "दृश्य जोड़ें ",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "दृश्य को सरकाइये ",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "अगला पोशाक",
    "gui.howtos.pong": "पाँग गेम ",
    "gui.howtos.pong.step_pongAddBackdrop": "बैक्ड्राप जोड़ें",
    "gui.howtos.pong.step_pongAddBallSprite": "एक बॉल वाला स्प्राइट जोड़िए ",
    "gui.howtos.pong.step_pongBounceAround": "सब तरफ उछालिए ",
    "gui.howtos.pong.step_pongAddPaddle": "एक पैडल जोड़िए ",
    "gui.howtos.pong.step_pongMoveThePaddle": "पैड़ल को सरकाइये ",
    "gui.howtos.pong.step_pongSelectBallSprite": "बॉल वाले स्प्राइट को चुनिए ",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "बॉल को पैडल से बाउंस करने के लिए कोड जोड़ें ",
    "gui.howtos.pong.step_pongAddAScore": "स्कोर जोड़िए ",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "मेनू से स्कोर चुनें ",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "'Change Score' ब्लॉक को इसमें जोड़ें ",
    "gui.howtos.pong.step_pongResetScore": "स्कोर को दोबारा सेट करें",
    "gui.howtos.pong.step_pongAddLineSprite": "लाइन स्प्राइट को जोड़ें ",
    "gui.howtos.pong.step_pongGameOver": "खेल समाप्त ",
    "gui.howtos.code-cartoon": "एक कार्टून कोड करें",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "जब आप ग्रीन फ्लैग क्लिक करें तो कुछ कहिए ",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "जब आप किसी कॅरेक्टर पर क्लिक करें तो उसे एनिमेट करें  ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "एक अलग कॅरेक्टर चुनिए",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "आकार छोटा करने के लिए माइनस साईन का प्रयोग करें",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "एक कॅरेक्टर का आकार बढ़ाएं या छोटा करें",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "एक अलग कॅरेक्टर चुनिए",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "ऊपर नीचे कूदिये",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "दृश्य को बदलने के लिए कॅरेक्टर पर क्लिक कीजिए",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "चारों ओर सरकना",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "कॉस्ट्यूम बदलिए",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "अपने कार्टून में जोड़ने के लिए और कॅरेक्टर्स चुनिए",
    "gui.howtos.cartoon-network": "एक एडवेंचर गेम को एनिमेट करें ",
    "gui.howtos.cartoon-network.step_CNcharacter": "दिखाने के लिए कोई कॅरेक्टर चुनें ",
    "gui.howtos.cartoon-network.step_CNsay": "कुछ कहे ",
    "gui.howtos.cartoon-network.step_CNglide": "चारों ओर सरकना",
    "gui.howtos.cartoon-network.step_CNpicksprite": "पीछा करने के लिए कोई चीज चुनें ",
    "gui.howtos.cartoon-network.step_CNcollect": "चीजें इकट्ठा करें ",
    "gui.howtos.cartoon-network.step_CNvariable": "स्कोर नाम से एक वेरिएबल बनाइये ",
    "gui.howtos.cartoon-network.step_CNscore": "अंकों का घ्यान रखें",
    "gui.howtos.cartoon-network.step_CNbackdrop": "लेवल अप: बॅकड्रॉप बदलें ",
    "gui.howtos.videosens.name": "वीडियो संवेदन",
    "gui.howtos.videosens.step_addextension": "विस्तार जोड़िये ",
    "gui.howtos.videosens.step_pet": "बिल्ली को सहलाएं ",
    "gui.howtos.videosens.step_animate": "ऐनिमेट",
    "gui.howtos.videosens.step_pop": "गुब्बारे को फोड़िये",
    "gui.howtos.say-it-out-loud": "बोलने वाले एनिमेशन्स बनाइए",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "स्पीच ब्लॉक्स में टेक्स्ट लिखिए ",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "कुछ कहे ",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "आवाज़ सेट करें",
    "gui.howtos.say-it-out-loud.step_TXTMove": "चारों ओर घूमें",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "बैक्ड्राप जोड़ें",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "और पात्र जोडें",
    "gui.howtos.say-it-out-loud.step_TXTSong": "कोई गाना गाएं",
    "gui.howtos.say-it-out-loud.step_TXTColor": "रंग बदले",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "चक्कर लगाएं",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "बढ़ें और सिकुड़ें",
    "gui.howtos.talking": "बोलनेवाली कहानियां",
    "gui.howtos.talking.step_talesAddExtension": "टेक्स्ट से स्पीच ब्लॉक्स जोड़ने के लिए क्लिक कीजिए ",
    "gui.howtos.talking.step_talesChooseSprite": "स्प्राइट चुनें",
    "gui.howtos.talking.step_talesSaySomething": "एक कॅरेक्टर को बुलवाएं",
    "gui.howtos.talking.step_talesChooseBackdrop": "बैक्ड्राप चुनें",
    "gui.howtos.talking.step_talesSwitchBackdrop": "अगले बॅकड्रॉप पर जाने के लिए किसी कॅरेक्टर पर क्लिक कीजिए ",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "दूसरा स्प्राइट चुनिए",
    "gui.howtos.talking.step_talesMoveAround": "चारों ओर घूमें",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "दूसरा बैकड्रॉप चुनिए",
    "gui.howtos.talking.step_talesAnimateTalking": "बोलचाल का एनिमेशन बनाइये",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "दूसरा बैकड्रॉप चुनिए",
    "gui.howtos.talking.step_talesChooseSound": "नाचने के लिए गाना चुनिए ",
    "gui.howtos.talking.step_talesDanceMoves": "डांस के स्टेप्स",
    "gui.howtos.talking.step_talesAskAnswer": "सेंसिंग कॅटेगरी से आस्क एंड आंसर ब्लॉक लीजिए  ",
    "gui.howtos.add-sprite.name": "स्प्राइट जोड़ें",
    "gui.howtos.add-sprite.step_addSprite": "स्प्राइट जोड़ें",
    "gui.howtos.add-a-backdrop.name": "बैक्ड्राप जोड़ें",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "बैक्ड्राप जोड़ें",
    "gui.howtos.change-size.name": "आकार बदलें",
    "gui.howtos.change-size.step_changeSize": "आकार बदलें",
    "gui.howtos.glide-around.name": "चारों ओर सरकना",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "चारों ओर सरकना",
    "gui.howtos.change-size.step_glideAroundPoint": "एक बिन्दु तक ग्लाइड कीजिए",
    "gui.howtos.record-a-sound.name": "ध्वनि रिकॉर्ड करें",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "साउंड टॅब पर क्लिक कीजिये ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "रिकॉर्ड बटन पर क्लिक कीजिये ",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "रिकॉर्ड बटन पर क्लिक कीजिये ",
    "gui.howtos.change-size.step_recordASoundChooseSound": "ध्वनि चुनें",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "अपनी आवाज प्ले कीजिये/ सुनाइए ",
    "gui.howtos.spin-video.name": "इसे स्पिन करें",
    "gui.howtos.change-size.step_spinTurn": "घूमिये ",
    "gui.howtos.change-size.step_spinPointInDirection": "दिशा तय कीजिये ",
    "gui.howtos.hide-and-show.name": "छिपाएं और दिखाएं",
    "gui.howtos.change-size.step_hideAndShow": "छिपाएं और दिखाएं",
    "gui.howtos.switch-costume.name": "एक स्प्राइट को एनिमेट कीजिये ",
    "gui.howtos.change-size.step_switchCostumes": "एक स्प्राइट को एनिमेट कीजिये ",
    "gui.howtos.move-around-with-arrow-keys.name": "एरो कीज का प्रयोग कीजिये ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "दाएं - बाएं चलिए ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "ऊपर - नीचे चलिए ",
    "gui.howtos.add-effects.name": "इफेक्ट्स डालिये ",
    "gui.howtos.videosens.step_addEffects": "इफेक्ट्स डालिये ",
    "gui.extension.music.name": "संगीत ",
    "gui.extension.music.description": "वाद्ययंत्र और ड्रम बजाएं",
    "gui.extension.pen.name": "पेन",
    "gui.extension.pen.description": "अपने स्प्राइट्स के साथ ड्रा करें।",
    "gui.extension.videosensing.name": "वीडियो संवेदन",
    "gui.extension.videosensing.description": "कॅमेरे से हलचल का पता लगाइये ",
    "gui.extension.text2speech.name": "लिखित से बोली में बदलना",
    "gui.extension.text2speech.description": "अपने प्रोजेक्ट्स से बुलवाइए ",
    "gui.extension.translate.name": "भाषांतर",
    "gui.extension.translate.description": "कई भाषाओं में पाठ का अनुवाद करें।",
    "gui.extension.makeymakey.description": "किसी भी चीज़ को बटन बनाएं",
    "gui.extension.microbit.description": "अपनी परियोजना को संसार से जोडें",
    "gui.extension.microbit.connectingMessage": "जुड़ रहा है ",
    "gui.extension.ev3.description": "इंटरैक्टिव रोबोट और अधिक बनाएँ।",
    "gui.extension.ev3.connectingMessage": "जुड़ रहे हैं। सुनिश्चित करें कि आपके EV3 पर पिन 1234 पर सेट है।",
    "gui.extension.boost.description": "रोबोट कृतियों को जीवित बनाएं",
    "gui.extension.boost.connectingMessage": "जुड़ रहा है ",
    "gui.extension.wedo2.description": "मोटर्स और सेंसर के साथ बनाएँ।",
    "gui.extension.wedo2.connectingMessage": "जुड़ रहा है ",
    "gui.extension.gdxfor.description": "पुश/जोर, पुल/खिंचाव,  मोशन/गति  और स्पिन/घुमाव का पता लगाइये ",
    "gui.extension.gdxfor.connectingMessage": "जुड़ रहा है ",
    "gui.libraryTags.all": "सब",
    "gui.libraryTags.animals": "पशु",
    "gui.libraryTags.dance": "नाचें",
    "gui.libraryTags.effects": "इफेक्ट्स ",
    "gui.libraryTags.fantasy": "कल्पना",
    "gui.libraryTags.fashion": "फैशन",
    "gui.libraryTags.food": "भोजन",
    "gui.libraryTags.indoors": "भीतरी",
    "gui.libraryTags.loops": "लूप्स ",
    "gui.libraryTags.music": "संगीत ",
    "gui.libraryTags.notes": "सुर",
    "gui.libraryTags.outdoors": "बाहरी",
    "gui.libraryTags.patterns": "पैटर्न",
    "gui.libraryTags.people": "लोग",
    "gui.libraryTags.percussion": "ताल वाद्य ",
    "gui.libraryTags.space": "अंतरिक्ष",
    "gui.libraryTags.sports": "खेल",
    "gui.libraryTags.underwater": "पानी के नीचे",
    "gui.libraryTags.voice": "आवाज़",
    "gui.libraryTags.wacky": "निराला",
    "gui.libraryTags.animation": "एनीमेशन ",
    "gui.libraryTags.art": "कला",
    "gui.libraryTags.games": "खेल",
    "gui.libraryTags.stories": "कहानियाँ",
    "gui.libraryTags.letters": "अक्षर",
    "gui.opcodeLabels.direction": "दिशा",
    "gui.opcodeLabels.xposition": "x स्थिति",
    "gui.opcodeLabels.yposition": "y स्थिति",
    "gui.opcodeLabels.size": "आकार",
    "gui.opcodeLabels.costumename": "पोशाक का नाम",
    "gui.opcodeLabels.costumenumber": "पोशाक संख्या",
    "gui.opcodeLabels.backdropname": "बैक्ड्राप का नाम",
    "gui.opcodeLabels.backdropnumber": "बैक्ड्राप संख्या",
    "gui.opcodeLabels.volume": "आवाज़",
    "gui.opcodeLabels.tempo": "टेम्पो",
    "gui.opcodeLabels.answer": "जवाब",
    "gui.opcodeLabels.loudness": "आवाज़ की उंचाई",
    "gui.opcodeLabels.username": "यूजर नेम",
    "gui.opcodeLabels.year": "वर्ष",
    "gui.opcodeLabels.month": "महीना",
    "gui.opcodeLabels.date": "तारीख",
    "gui.opcodeLabels.dayofweek": "हफ़ते का दिन",
    "gui.opcodeLabels.hour": "घंटा",
    "gui.opcodeLabels.minute": "मिनट",
    "gui.opcodeLabels.second": "सेकंद",
    "gui.opcodeLabels.timer": "घड़ी",
    "gui.projectLoader.loadError": "चयनित परियोजना फ़ाइल लोड होने में विफल रही",
    "gui.sharedMessages.backdrop": "बैक्ड्राप{index}",
    "gui.sharedMessages.costume": "पोशाक{index}",
    "gui.sharedMessages.sprite": "स्प्राइट{index}",
    "gui.sharedMessages.pop": "पॉप",
    "gui.sharedMessages.replaceProjectWarning": "वर्तमान परियोजना की सामग्री बदलें?",
    "gui.sharedMessages.loadFromComputerTitle": "कमप्यूटर से लोङ करें",
    "gui.theme.default": "मूलरूप",
    "gui.theme.dark": "डार्क",
    "gui.theme.highContrast": "हाई कॉन्ट्रास्ट\n ",
    "gui.gui.defaultProjectTitle": "स्क्रैच परियोजना",
    "boost.color.any": "कोइ भी रंग",
    "boost.color.black": "काला",
    "boost.color.blue": "नीला",
    "boost.color.green": "हरा",
    "boost.color.red": "लाल",
    "boost.color.white": "श्वेत",
    "boost.color.yellow": "पीला",
    "boost.getMotorPosition": "मोटर [MOTOR_REPORTER_ID] की स्थिति ",
    "boost.getTiltAngle": "झुकाव की दिशा [TILT_DIRECTION]",
    "boost.motorDirection.backward": "उस  ओर ",
    "boost.motorDirection.forward": "इस ओर ",
    "boost.motorDirection.reverse": "उलटी दिशामे ",
    "boost.motorOff": "[MOTOR_ID] मोटर को बंद करें",
    "boost.motorOn": "[MOTOR_ID] मोटर को चालू करें",
    "boost.motorOnFor": "[MOTOR_ID] मोटर को चलाए [DURATION] क्षणो के लिए",
    "boost.motorOnForRotation": "[MOTOR_ID] मोटर को चलाए [ROTATION] चक्करों के लिए",
    "boost.seeingColor": "[COLOR] के रंग की ईंट देखी?",
    "boost.setLightHue": "लाइट के रंग को [HUE] सेट करें",
    "boost.setMotorDirection": "[MOTOR_ID] मोटर  को [MOTOR_DIRECTION] दिशा में सेट करें",
    "boost.setMotorPower": "[MOTOR_ID] मोटर  की [POWER]% ताकत सेट करें",
    "boost.tiltDirection.any": "कोई",
    "boost.tiltDirection.down": "नीचे",
    "boost.tiltDirection.left": "बाएं",
    "boost.tiltDirection.right": "दांए",
    "boost.tiltDirection.up": "ऊपर",
    "boost.whenColor": "जब [COLOR] ईंट देखी",
    "boost.whenTilted": "जब झुकाव [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "[NOTE] बीप लय को [TIME]  क्षण तक चलाए ",
    "ev3.buttonPressed": "क्या [PORT] बटन दबाया ?",
    "ev3.getBrightness": "चमक",
    "ev3.getDistance": "दूरी",
    "ev3.getMotorPosition": "[PORT] मोटर की स्थिति ",
    "ev3.motorSetPower": "[PORT]मोटर की ताकत [POWER]% पर सेट करे ",
    "ev3.motorTurnClockwise": "[PORT] मोटर को सीधी  दिशा में   [TIME] क्षणों तक घुमाए ",
    "ev3.motorTurnCounterClockwise": "[PORT] मोटर को उलटी  दिशा में [TIME] क्षणों तक घुमाए",
    "ev3.whenBrightnessLessThan": "जब चमक < [DISTANCE]",
    "ev3.whenButtonPressed": "जब [PORT] बटन दबा हुआ हो ",
    "ev3.whenDistanceLessThan": "जब दुरी < [DISTANCE]",
    "gdxfor.getAcceleration": "त्वरण [DIRECTION]",
    "gdxfor.getForce": "जोर",
    "gdxfor.getSpin": "घूमने की गति [DIRECTION]",
    "gdxfor.getTilt": "झुकाव का कोण [TILT]",
    "gdxfor.isFreeFalling": "गिरने लगा?",
    "gdxfor.isTilted": "झुका [TILT] ?",
    "gdxfor.pulled": "खींच लिया",
    "gdxfor.pushed": "धकेल दिया",
    "gdxfor.shaken": "हिला हुआ",
    "gdxfor.startedFalling": "गिरने लगा",
    "gdxfor.tiltDirectionMenu.any": "कोई",
    "gdxfor.tiltDirectionMenu.back": "पीछे",
    "gdxfor.tiltDirectionMenu.front": "अक्षर",
    "gdxfor.tiltDirectionMenu.left": "बाएं",
    "gdxfor.tiltDirectionMenu.right": "दांए",
    "gdxfor.turnedFaceDown": "मूह को  नीचे  करें ",
    "gdxfor.turnedFaceUp": "मूह को ऊपर करें ",
    "gdxfor.whenForcePushedOrPulled": "जब बल संवेदन [PUSH_PULL] हुआ",
    "gdxfor.whenGesture": "जब [GESTURE]",
    "gdxfor.whenTilted": "जब झुका [TILT]",
    "makeymakey.downArrow": "निचला एरो ",
    "makeymakey.downArrowShort": "नीचे",
    "makeymakey.leftArrow": "बया एरो  ",
    "makeymakey.leftArrowShort": "बाएं",
    "makeymakey.rightArrow": "दाहिना एरो",
    "makeymakey.rightArrowShort": "दांए",
    "makeymakey.spaceKey": "स्पेस ",
    "makeymakey.upArrow": "ऊपरी बाण ",
    "makeymakey.upArrowShort": "ऊपर",
    "makeymakey.whenKeyPressed": "जब [KEY] बटन दबाया",
    "makeymakey.whenKeysPressedInOrder": "जब [SEQUENCE] क्रम मे दबाया गया",
    "microbit.buttonsMenu.any": "कोई",
    "microbit.clearDisplay": "स्पष्ट प्रदर्शन",
    "microbit.defaultTextToDisplay": "नमस्ते!",
    "microbit.displaySymbol": "प्रदर्शन [MATRIX]",
    "microbit.displayText": "प्रदर्शन अक्षर [TEXT]",
    "microbit.gesturesMenu.jumped": "छलाँग ",
    "microbit.gesturesMenu.moved": "स्थलांतरित ",
    "microbit.gesturesMenu.shaken": "हिला हुआ",
    "microbit.isButtonPressed": "क्या [BTN] बटन दबा हुआ है ?",
    "microbit.isTilted": "क्या [DIRECTION] दिशा में झुका है ?",
    "microbit.pinStateMenu.off": "बंद",
    "microbit.pinStateMenu.on": "चालू",
    "microbit.tiltAngle": "झुकाव का कोण [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "कोई",
    "microbit.tiltDirectionMenu.back": "पीछे",
    "microbit.tiltDirectionMenu.front": "सामने",
    "microbit.tiltDirectionMenu.left": "बाएं",
    "microbit.tiltDirectionMenu.right": "दाहे",
    "microbit.whenButtonPressed": "जब [BTN] बटन दबा हुआ हो",
    "microbit.whenGesture": "जब [GESTURE]",
    "microbit.whenPinConnected": "जब पिन [PIN] जुडी हो ",
    "microbit.whenTilted": "जब [DIRECTION] दिशामे झुका हो ",
    "music.categoryName": "संगीत ",
    "music.changeTempo": "ताल [TEMPO] से बदलिए ",
    "music.drumBass": "(2) बास ड्रम  ",
    "music.drumBongo": "(13) बोंगो",
    "music.drumCabasa": "(15)कबासा",
    "music.drumClaves": "(9) क्लेव",
    "music.drumClosedHiHat": "(6) क्लोज़ हाय-हैट",
    "music.drumConga": "(14) कोंगा",
    "music.drumCowbell": "(11) घंटी ",
    "music.drumCrashCymbal": "(4) क्रैश सिंबल",
    "music.drumCuica": "(18) क्यूका",
    "music.drumGuiro": "(16) गायरो",
    "music.drumHandClap": "(8) ताली",
    "music.drumOpenHiHat": "(5) ओपन हाय-हैट",
    "music.drumSideStick": "(3) साइड स्टिक",
    "music.drumSnare": "(1) स्नेर ड्रम",
    "music.drumTambourine": "(7) डफली",
    "music.drumTriangle": "(12) त्रिकोण",
    "music.drumVibraslap": "(17) वाइब्रेस्लेप",
    "music.drumWoodBlock": "(10) लकड़ी लट्ठा",
    "music.getTempo": "टेम्पो",
    "music.instrumentBass": "(6) बास",
    "music.instrumentBassoon": "(14) अलगोजा",
    "music.instrumentCello": "(8) सेलो",
    "music.instrumentChoir": "(15) गायक मंडलियां",
    "music.instrumentClarinet": "(10) शहनाई",
    "music.instrumentElectricGuitar": "(5) इलेक्ट्रिक गिटार",
    "music.instrumentElectricPiano": "(2) इलेक्ट्रिक पियानो",
    "music.instrumentFlute": "(12) बांसुरी",
    "music.instrumentGuitar": "(4) गिटार",
    "music.instrumentMarimba": "(19) मरिम्बा",
    "music.instrumentMusicBox": "(17) म्यूजिक बॉक्स",
    "music.instrumentOrgan": "(3) ऑर्गन",
    "music.instrumentPiano": "(1) पियानो",
    "music.instrumentPizzicato": "(7) पिज्जीकोटो",
    "music.instrumentSaxophone": "(11) सैक्सोफोन",
    "music.instrumentSteelDrum": "(18) स्टील ड्रम",
    "music.instrumentSynthLead": "(20) सिंथ लीड",
    "music.instrumentSynthPad": "(21) सिंथ पैड",
    "music.instrumentTrombone": "(9) ट्रंबोन",
    "music.instrumentVibraphone": "(16) विब्रफ़ोन",
    "music.instrumentWoodenFlute": "(13) लकड़ी बांसुरी",
    "music.midiPlayDrumForBeats": "[DRUM] ड्रम को [BEATS] स्पंदन  तक बजाए ",
    "music.midiSetInstrument": "संगीत वाद्य को [INSTRUMENT] पर स्थित करे",
    "music.playDrumForBeats": "[DRUM] ड्रम को [BEATS] स्पंदन  तक बजाए ",
    "music.playNoteForBeats": "[NOTE] नोट को चलाए [BEATS] ताल के लिए",
    "music.restForBeats": "[BEATS] ताल के लिए रुकें",
    "music.setInstrument": "संगीत वाद्य को [INSTRUMENT] पर स्थित करे",
    "music.setTempo": "गति को सेट कीजिए  [TEMPO]  पर",
    "pen.categoryName": "लेखनी",
    "pen.changeColorParam": "[COLOR_PARAM] लेखनी को [VALUE] से बदलें",
    "pen.changeHue": "लेखनी का रंग [HUE] से बदलें",
    "pen.changeShade": "लेखनी का शेङ [SHADE] से बदलें",
    "pen.changeSize": "लेखनी का आकार [SIZE] से बदलें",
    "pen.clear": "सब मिटा दो",
    "pen.colorMenu.brightness": "चमक",
    "pen.colorMenu.color": "रंग",
    "pen.colorMenu.saturation": "परिपूर्णता",
    "pen.colorMenu.transparency": "पारदर्शिता",
    "pen.penDown": "लेखनी नीचे",
    "pen.penUp": "लेखनी ऊपर",
    "pen.setColor": "लेखनी के रंग को [COLOR] सेट करें",
    "pen.setColorParam": "[COLOR_PARAM] लेखनी को [VALUE] सेट करें",
    "pen.setHue": "लेखनी के रंग को [HUE] पर सेट करें",
    "pen.setShade": "लेखनी के शेङ को [SHADE] पर सेट करें",
    "pen.setSize": "लेखनी के आकार को [SIZE] सेट करें",
    "pen.stamp": "ठप्पा ",
    "speech.defaultWhenIHearValue": "शुरू करें",
    "speech.extensionName": "आवाज से अक्षर ",
    "speech.listenAndWait": "सुने और रुके",
    "speech.speechReporter": "आवाज़",
    "speech.whenIHear": "जब मैनें सुना [PHRASE]",
    "text2speech.alto": "आलाप",
    "text2speech.categoryName": "लिखित से बोली में बदलना",
    "text2speech.defaultTextToSpeak": "नमस्ते",
    "text2speech.giant": "विशाल",
    "text2speech.kitten": "बिल्ली का बच्चा",
    "text2speech.setLanguageBlock": "भाषा को सेट करें [LANGUAGE] में",
    "text2speech.setVoiceBlock": "आवाज़ को सेट करो [VOICE] पर",
    "text2speech.speakAndWaitBlock": "बोलो [WORDS]",
    "text2speech.squeak": "चीख",
    "text2speech.tenor": "ऊचीं आवाज़",
    "translate.categoryName": "अनुवाद",
    "translate.defaultTextToTranslate": "नमस्ते",
    "translate.translateBlock": "अनुवाद कीजिए [WORDS]  को [LANGUAGE] में",
    "translate.viewerLanguage": "भाषा",
    "videoSensing.categoryName": "वीडियो संवेदन",
    "videoSensing.direction": "दिशा",
    "videoSensing.motion": "गति",
    "videoSensing.off": "बंद",
    "videoSensing.on": "चालू",
    "videoSensing.onFlipped": "फ्लिप किया ",
    "videoSensing.setVideoTransparency": "[TRANSPARENCY] पर  वीडियो की पारदर्शकता सेट करे ",
    "videoSensing.sprite": "स्प्राइट",
    "videoSensing.stage": "मंच",
    "videoSensing.videoOn": "वीडियो [ATTRIBUTE] पर [SUBJECT]",
    "videoSensing.videoToggle": "विडिओ स्थिति [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "जब विडिओ की गति >[REFERENCE]",
    "wedo2.getDistance": "दूरी",
    "wedo2.getTiltAngle": "झुकाव की दिशा [TILT_DIRECTION]",
    "wedo2.isTilted": "झुकाव [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "उस  ओर ",
    "wedo2.motorDirection.forward": "इस ओर ",
    "wedo2.motorDirection.reverse": "उलटी दिशा मे ",
    "wedo2.motorId.a": "मोटर A ",
    "wedo2.motorId.all": "सभी मोटर",
    "wedo2.motorId.b": "मोटर B ",
    "wedo2.motorId.default": "मोटर ",
    "wedo2.motorOff": "[MOTOR_ID] बंद करे",
    "wedo2.motorOn": "[MOTOR_ID] चालू करे",
    "wedo2.motorOnFor": "[MOTOR_ID] मोटर को चलाए [DURATION] क्षणो के लिए",
    "wedo2.playNoteFor": "[NOTE] नोट को चलाए [DURATION] क्षणों के लिए",
    "wedo2.setLightHue": "लाइट के रंग को [HUE] सेट करें",
    "wedo2.setMotorDirection": "[MOTOR_ID] मोटर  को [MOTOR_DIRECTION] दिशा में सेट करें",
    "wedo2.startMotorPower": "[MOTOR_ID] की [POWER] ताकत सेट करें",
    "wedo2.tiltDirection.any": "कोई",
    "wedo2.tiltDirection.down": "नीचे",
    "wedo2.tiltDirection.left": "बाएं",
    "wedo2.tiltDirection.right": "दांए",
    "wedo2.tiltDirection.up": "ऊपर",
    "wedo2.whenDistance": "जब दुरी  [OP] [REFERENCE]",
    "wedo2.whenTilted": "जब झुकाव [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "रंग",
    "paint.paintEditor.saturation": "संतृप्ति",
    "paint.paintEditor.brightness": "चमक",
    "paint.paintEditor.costume": "पोशाक",
    "paint.paintEditor.group": "समूह ",
    "paint.paintEditor.ungroup": "असमूहीकृत",
    "paint.paintEditor.undo": "पूर्ववत",
    "paint.paintEditor.redo": "पुनः करें",
    "paint.paintEditor.forward": "आगे ",
    "paint.paintEditor.backward": "पीछे ",
    "paint.paintEditor.front": "सामने",
    "paint.paintEditor.back": "वापस ",
    "paint.paintEditor.more": "और ",
    "paint.modeTools.brushSize": "माप ",
    "paint.modeTools.eraserSize": "रबड़ का माप ",
    "paint.modeTools.copy": "प्रतिलिपि ",
    "paint.modeTools.paste": "चिपकाना ",
    "paint.modeTools.delete": "मिटाये",
    "paint.modeTools.curved": "मुड़ा हुआ ",
    "paint.modeTools.pointed": "नोकीला ",
    "paint.modeTools.thickness": "मोटाई ",
    "paint.modeTools.flipHorizontal": "क्षितिज के समानांतर पलटिये ",
    "paint.modeTools.flipVertical": "ऊर्ध्वाधर के समानांतर पलटिये",
    "paint.modeTools.filled": "भरा हुआ ",
    "paint.modeTools.outlined": "उल्लिखित",
    "paint.paintEditor.bitmap": "बिटमैप में बदलें ",
    "paint.paintEditor.vector": "वेक्टर में बदलें ",
    "paint.paintEditor.fill": "भरो",
    "paint.paintEditor.stroke": "सीमा ",
    "paint.brushMode.brush": "ब्रश",
    "paint.eraserMode.eraser": "रबड़",
    "paint.fillMode.fill": "भरो",
    "paint.lineMode.line": "रेखा ",
    "paint.ovalMode.oval": "घेरा ",
    "paint.rectMode.rect": "आयत ",
    "paint.reshapeMode.reshape": "फिर से आकार बनाएं ",
    "paint.roundedRectMode.roundedRect": "कोनो पर मुड़े हुए आयताकार ",
    "paint.selectMode.select": "चुनें ",
    "paint.textMode.text": "अक्षर ",
    "paint.colorPicker.swap": "आपस में बदलें "
  },
  "hr": {
    "gui.alerts.lostPeripheralConnection": "Scratch je izgubio vezu s {extensionName}.",
    "gui.alerts.tryAgain": "Pokušajte ponovo",
    "gui.alerts.download": "Preuzmi",
    "gui.connection.reconnect": "Ponovno povezivanje",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Ruksak",
    "gui.backpack.errorBackpack": "Pogreška pri učitavanju",
    "gui.backpack.loadingBackpack": "Učitavanje...",
    "gui.backpack.more": "Više",
    "gui.backpack.emptyBackpack": "Ruksak je prazan",
    "gui.unsupportedBrowser.label": "Preglednik nije podržan",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Nazad",
    "gui.unsupportedBrowser.previewfaq": "Da biste saznali više, idite na{previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Često postavljana pitanja",
    "gui.cards.all-tutorials": "Tutoriali",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Zatvori",
    "gui.cards.more-things-to-try": "Isprobaj i ovo!",
    "gui.cards.see-more": "Vidi više",
    "gui.comingSoon.message1": "Ne brini, radimo na tome{emoji}",
    "gui.comingSoon.message2": "Uskoro...",
    "gui.comingSoon.message3": "Radimo na tome{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nije pronađen nijedan uređaj",
    "gui.connection.auto-scanning.prescan": "Neka Vaš uređaj bude u blizini, a zatim započnite s pretraživanjem.",
    "gui.connection.auto-scanning.pressbutton": "Pritisnite gumb na uređaju.",
    "gui.connection.auto-scanning.start-search": "Počnite tražiti",
    "gui.connection.connecting-searchbutton": "Traženje...",
    "gui.connection.auto-scanning.try-again": "Pokušajte ponovo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Povezan",
    "gui.connection.disconnect": "Isključiti",
    "gui.connection.go-to-editor": "Idite na uređivač",
    "gui.connection.connecting-cancelbutton": "Povezivanje...",
    "gui.connection.error.errorMessage": "Ups! Nešto je pošlo po krivom.",
    "gui.connection.error.tryagainbutton": "Pokušajte ponovo",
    "gui.connection.error.helpbutton": "Pomoć",
    "gui.connection.peripheral-name-label": "Naziv uređaja",
    "gui.connection.connect": "Poveži",
    "gui.connection.scanning.lookingforperipherals": "Tražim uređaje",
    "gui.connection.scanning.noPeripheralsFound": "Nema uređaja",
    "gui.connection.scanning.instructions": "Odaberite svoj uređaj na gornjem popisu.",
    "gui.connection.search": "Osvježi",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Provjerite jeste li instalirali i pokrenuli Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "Provjerite je li Bluetooth omogućen",
    "gui.connection.unavailable.tryagainbutton": "Pokušajte ponovo",
    "gui.connection.unavailable.helpbutton": "Pomoć",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Počni",
    "gui.controls.stop": "Zaustavi",
    "gui.crashMessage.label": "Ups! Nešto je pošlo po krivom.",
    "gui.crashMessage.description": "Žao nam je, ali izgleda da se Scratch srušio. Greška  je automatski prijavljena Scratch Timu. Osvježite stranicu i pokušajte ponovno.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Ponovno učitaj",
    "gui.customProcedures.myblockModalTitle": "Napravi blok",
    "gui.customProcedures.addAnInputNumberText": "Dodaj ulaz",
    "gui.customProcedures.numberTextType": "broj ili tekst",
    "gui.customProcedures.addAnInputBoolean": "Dodaj ulaz",
    "gui.customProcedures.booleanType": "bulov izraz",
    "gui.customProcedures.addALabel": "Dodajte natpis",
    "gui.customProcedures.runWithoutScreenRefresh": "Izvršite bez osvježavanja zaslona",
    "gui.customProcedures.cancel": "Otkaži",
    "gui.customProcedures.ok": "U redu",
    "gui.SpriteInfo.direction": "Smjer",
    "gui.directionPicker.rotationStyles.allAround": "Na sve strane",
    "gui.directionPicker.rotationStyles.leftRight": "Lijevo/Desno",
    "gui.directionPicker.rotationStyles.dontRotate": "Bez okretanja",
    "gui.gui.addExtension": "Dodaj proširenje",
    "gui.gui.codeTab": "Skripte",
    "gui.gui.backdropsTab": "Pozadine",
    "gui.gui.costumesTab": "Kostimi",
    "gui.gui.soundsTab": "Zvukovi",
    "gui.extensionLibrary.comingSoon": "Dolazi uskoro",
    "gui.extensionLibrary.requires": "Potrebno",
    "gui.extensionLibrary.collaboration": "Suradnja s",
    "gui.library.filterPlaceholder": "Traži",
    "gui.library.allTag": "Sve",
    "gui.loader.message1": "Izrada blokova ...",
    "gui.loader.message2": "Učitavanje likova...",
    "gui.loader.message3": "Učitavanje zvuka...",
    "gui.loader.message4": "Učitavanje proširenja ...",
    "gui.loader.message5": "Udomljavanje mačaka ...",
    "gui.loader.message6": "Prijenos nano ...",
    "gui.loader.message7": "Napuhavanje gobova ...",
    "gui.loader.message8": "Pripremam smajliće ...",
    "gui.loader.headline": "Učitavanje projekta",
    "gui.loader.creating": "Kreiranje projekta",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Moje stvari",
    "gui.accountMenu.myClasses": "Moji razredi",
    "gui.accountMenu.myClass": "Moj razred",
    "gui.accountMenu.accountSettings": "Postavke računa",
    "gui.accountMenu.signOut": "Odjava",
    "gui.authorInfo.byUser": "od {username}",
    "gui.menuBar.seeProjectPage": "Pogledaj stranicu projekta",
    "gui.menuBar.language": "Language",
    "general.username": "Nadimak",
    "general.password": "Lozinka",
    "general.signIn": "Prijava",
    "login.needHelp": "Trebate li pomoć?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "Tutoriali",
    "gui.menuBar.restoreSprite": "Vrati lika",
    "gui.menuBar.restoreSound": "Vrati zvuk",
    "gui.menuBar.restoreCostume": "Vrati kostim",
    "gui.menuBar.restore": "Vrati obrisano",
    "gui.menuBar.saveNow": "Spremi sada",
    "gui.menuBar.saveAsCopy": "Spremi kao kopiju",
    "gui.menuBar.remix": "Obrada",
    "gui.menuBar.new": "Novo",
    "gui.menuBar.file": "Datoteka",
    "gui.menuBar.downloadToComputer": "Spremi na računalo",
    "gui.menuBar.edit": "Uredi",
    "gui.menuBar.turboModeOff": "Isključite turbo način rada",
    "gui.menuBar.turboModeOn": "Uključite turbo način rada",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Pridruži se Scratchu",
    "gui.menuBar.signIn": "Prijavite se",
    "gui.gui.projectTitlePlaceholder": "Naslov projekta ",
    "gui.menuBar.saveNowLink": "Spremi sada",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Dijeljeno",
    "gui.menuBar.share": "Dijeli",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Pomoć",
    "gui.modal.back": "Nazad",
    "gui.monitor.listMonitor.empty": "(prazno)",
    "gui.monitor.listMonitor.listLength": "dužina{length}",
    "gui.monitor.contextMenu.default": "normalni prikaz",
    "gui.monitor.contextMenu.large": "veliki prikaz",
    "gui.monitor.contextMenu.slider": "klizač",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Za sve likove",
    "gui.gui.variableScopeOptionSpriteOnly": "Samo za ovaj lik",
    "gui.gui.cloudVariableOption": "Varijabla na poslužitelju",
    "gui.gui.variablePromptAllSpritesMessage": "Ova će varijabla biti dostupna svim likovima.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Otkaži",
    "gui.prompt.ok": "U redu",
    "gui.playbackStep.stopMsg": "Zaustavi",
    "gui.playbackStep.playMsg": "Pokreni",
    "gui.playbackStep.loadingMsg": "Učitavam...",
    "gui.playbackStep.saveMsg": "Spremi",
    "gui.playbackStep.reRecordMsg": "Snimi ponovno",
    "gui.recordModal.title": "Snimi zvuk",
    "gui.recordingStep.beginRecord": "Započnite snimanje klikom na gumb u nastavku",
    "gui.recordingStep.permission": "{arrow}Trebamo vašu dozvolu za korištenje mikrofona",
    "gui.recordingStep.stop": "Zaustavi snimanje",
    "gui.recordingStep.record": "Snimi",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Zvuk",
    "gui.soundEditor.play": "Pokreni",
    "gui.soundEditor.stop": "Zaustavi",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Spremi",
    "gui.soundEditor.undo": "Poništi",
    "gui.soundEditor.redo": "Ponovi",
    "gui.soundEditor.faster": "Brže",
    "gui.soundEditor.slower": "Sporije",
    "gui.soundEditor.echo": "Jeka",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Glasnije",
    "gui.soundEditor.softer": "Blaže",
    "gui.soundEditor.reverse": "Obrnuto",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Ime",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Lik",
    "gui.SpriteInfo.show": "Prikaži",
    "gui.SpriteInfo.size": "Veličina",
    "gui.spriteSelectorItem.contextMenuDuplicate": "Dupliciraj",
    "gui.spriteSelectorItem.contextMenuExport": "izvoz",
    "gui.spriteSelectorItem.contextMenuDelete": "obriši",
    "gui.spriteSelector.addSpriteFromLibrary": "Odaberi lik",
    "gui.spriteSelector.addSpriteFromPaint": "Naslikaj",
    "gui.spriteSelector.addSpriteFromSurprise": "Iznenađenje",
    "gui.spriteSelector.addSpriteFromFile": "Učitaj lik",
    "gui.stageHeader.stageSizeLarge": "Prijeđi na veliku pozornicu",
    "gui.stageHeader.stageSizeSmall": "Prijeđi na malu pozornicu",
    "gui.stageHeader.stageSizeFull": "Rad preko cijelog zaslona",
    "gui.stageHeader.stageSizeUnFull": "Izađite iz cijelog zaslona",
    "gui.stageHeader.fullscreenControl": "Kontrola cijelog zaslona",
    "gui.spriteSelector.addBackdropFromLibrary": "Odaberi pozadinu",
    "gui.stageSelector.addBackdropFromPaint": "Naslikaj",
    "gui.stageSelector.addBackdropFromSurprise": "Iznenađenje",
    "gui.stageSelector.addBackdropFromFile": "Učitaj pozadinu",
    "gui.stageSelector.stage": "Pozornica",
    "gui.stageSelector.backdrops": "Pozadine",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo način",
    "gui.webglModal.label": "Preglednik ne podržava WebGL",
    "gui.webglModal.description": "Nažalost, izgleda kao da Vaš preglednik ili računalo{webGlLink}. Ova tehnologija je neophodna za pokretanje Scratcha 3.0.",
    "gui.webglModal.webgllink": "ne podržava WebGL",
    "gui.webglModal.back": "Nazad",
    "gui.webglModal.previewfaq": "Da biste saznali više, idite na stranicu {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Često postavljana pitanja",
    "gui.costumeLibrary.chooseABackdrop": "Odaberi pozadinu",
    "gui.costumeLibrary.chooseACostume": "Odaberi kostim",
    "gui.costumeTab.addBackdropFromLibrary": "Odaberi pozadinu",
    "gui.costumeTab.addCostumeFromLibrary": "Odaberi kostim",
    "gui.costumeTab.addBlankCostume": "Naslikaj",
    "gui.costumeTab.addSurpriseCostume": "Iznenađenje",
    "gui.costumeTab.addFileBackdrop": "Učitaj pozadinu",
    "gui.costumeTab.addFileCostume": "Prenesi kostim",
    "gui.extensionLibrary.chooseAnExtension": "Odaberi proširenje",
    "gui.extensionLibrary.extensionUrl": "Unesi URL proširenja",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nije moguće započeti snimanje",
    "gui.soundLibrary.chooseASound": "Odaberi zvuk",
    "gui.soundTab.fileUploadSound": "Učitaj zvuk",
    "gui.soundTab.surpriseSound": "Iznenađenje",
    "gui.soundTab.recordSound": "Snimi",
    "gui.soundTab.addSoundFromLibrary": "Odaberi zvuk",
    "gui.spriteLibrary.chooseASprite": "Odaberi lik",
    "gui.tipsLibrary.tutorials": "Odaberi vodič",
    "gui.alerts.createsuccess": "Novi projekt kreiran.",
    "gui.alerts.createcopysuccess": "Projekt je spremljen kao kopija",
    "gui.alerts.createremixsuccess": "Projekt je spremljen kao remix.",
    "gui.alerts.creating": "Stvaram novi...",
    "gui.alerts.creatingCopy": "Kopiram projekt...",
    "gui.alerts.creatingRemix": "Remixam projekt...",
    "gui.alerts.creatingError": "Projekt nije bilo moguće kreirati. Molimo pokušaj ponovo!",
    "gui.alerts.savingError": "Projekt nije bilo moguće spremiti.",
    "gui.alerts.savesuccess": "Projekt je spremljen.",
    "gui.alerts.saving": "Spremam projekt...",
    "gui.alerts.cloudInfo": "Imaj na umu da varijable oblaka podržavaju samo brojeve, a ne slova ili simbole. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Nauči više.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Mijau",
    "gui.defaultProject.variable": "moja varijabla",
    "gui.howtos.intro-move-sayhello-hat.name": "Početak rada",
    "gui.howtos.intro-move.step_stepMove": "Dodaj blok za premještanje",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animiraj ime",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Odaberi lik slovo ",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Pusti zvuk kad je kliknuto",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Odaberi još jedan lik slovo",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Promijeni boju",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Odaberi još jedan lik slovo& Zavrti ga",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Odaberi još jedan lik slovo& Povećaj ga",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Napravi glazbu",
    "gui.howtos.Make-Music.step_PickInstrument": "Odaberi lik Instrument",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Pokreni zvuk kad je kliknuto",
    "gui.howtos.Make-Music.step_MakeSong": "Stvori pjesmu",
    "gui.howtos.make-music.step_MakeBeat": "Odaberi bubanj& stvori ritam",
    "gui.howtos.make-music.step_MakeBeatBox": "Odaberi lik Mikrofon&Iznenadi pozornicu",
    "gui.howtos.story.name": "Stvori priču",
    "gui.howtos.story.step_addbg": "Dodaj pozadinu",
    "gui.howtos.story.step_addsprite": "Dodaj znak",
    "gui.howtos.story.step_saysomething": "Reci nešto",
    "gui.howtos.story.step_addanothersprite": "Dodaj još jedan znak",
    "gui.howtos.story.step_flip": "Zrcaljenje",
    "gui.howtos.story.step_conversation": "Razgovaraj",
    "gui.howtos.story.addanotherbg": "Dodaj još jednu Pozadinu",
    "gui.howtos.story.step_swithbg": "Zamijeni Pozadine",
    "gui.howtos.story.step_hidewizard": "Sakrij znak",
    "gui.howtos.story.step_showwizard": "Prikaži znak",
    "gui.howtos.make-a-chase-game.name": "Napravi igru lovice",
    "gui.howtos.Chase-Game.step_BG": "Dodaj pozadinu",
    "gui.howtos.chase-game.step_AddOcto": "Dodaj novi lik",
    "gui.howtos.make-music.step_LeftRight": "Pomiči se desno i lijevo s tipkama sa strelicama",
    "gui.howtos.Chase-Game.step_UpDown": "Pomiči se gore i dolje tipkama sa strelicama",
    "gui.howtos.Chase-Game.step_AddStar": "Dodaj još jedan lik",
    "gui.howtos.Chase-Game.step_MoveRandom": "Nasumično kretanje",
    "gui.howtos.Chase-Game.step_WhenTouch": "U liku hobotnice, kad dodirne sviraj zvuk",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Napravi varijablu za rezultat",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "U liku hobotnice, kad je dodiruje dodaj rezultat",
    "gui.howtos.animate-char.name": "Animiraj znak",
    "gui.howtos.animate-char.step_addbg": "Dodaj pozadinu",
    "gui.howtos.animate-char.step_addsprite": "Dodaj novi lik",
    "gui.howtos.animate-char.step_saysomething": "Reci nešto",
    "gui.howtos.animate-char.step_addsound": "Dodaj zvuk",
    "gui.howtos.animate-char.step_animatetalking": "Animiraj razgovor",
    "gui.howtos.animate-char.step_arrowkeys": "Pomiči se korištenjem navigacijskih tipki",
    "gui.howtos.animate-char.step_jump": "Skoči",
    "gui.howtos.animate-char.step_changecolor": "Promijeni boju",
    "gui.howtos.make-a-game.name": "Napravi igru ​​klikova",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Odaberi lika",
    "gui.howtos.make-a-game.step_GamePlaySound": "Pokreni zvuk kad je kliknuto",
    "gui.howtos.make-a-game.step_GameAddScore": "Napravi varijablu za rezultat",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kad je kliknuto uvećaj rezultat",
    "gui.howtos.make-a-game.step_Random": "Idi na slučajni položaj",
    "gui.howtos.make-music.step_GameChangeColor": "Promijeni boju",
    "gui.howtos.make-music.step_ResetScore": "Poništi rezultat",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animiraj  avanturističku igru",
    "gui.howtos.cartoon-network.step_CNcharacter": "Odaberi znak za prikaz",
    "gui.howtos.cartoon-network.step_CNsay": "Reci nešto",
    "gui.howtos.cartoon-network.step_CNglide": "Klizi",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Odaberi objekt za potragu",
    "gui.howtos.cartoon-network.step_CNcollect": "Prikupiti objekte",
    "gui.howtos.cartoon-network.step_CNvariable": "Napravi varijablu za rezultat",
    "gui.howtos.cartoon-network.step_CNscore": "Sačuvaj rezultat",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Sljedeća  razina: promjena pozadine",
    "gui.howtos.videosens.name": "Video",
    "gui.howtos.videosens.step_addextension": "Dodaj proširenje",
    "gui.howtos.videosens.step_pet": "Pomazi macu",
    "gui.howtos.videosens.step_animate": "Animiraj",
    "gui.howtos.videosens.step_pop": "Napuši balon",
    "gui.howtos.say-it-out-loud": "Napravi animacije koje govore",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Dodaj tekst u blokove govora",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Postavike za glas",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Pomakni se ",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Dodaj pozadinu",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Dodaj još jedan znak",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Izvedi pjesmu",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Promijeni boju",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Zavrti se",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Uvećajte se i smanjite",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Dodaj novi lik",
    "gui.howtos.add-sprite.step_addSprite": "Dodaj novi lik",
    "gui.howtos.add-a-backdrop.name": "Dodaj pozadinu",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Promijeni veličinu",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Klizi",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Snimi zvuk",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Rotiraj",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Sakrij i pokaži",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animiraj lik",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Koristi navigacijske tipke",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Dodaj efekt",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Glazba",
    "gui.extension.music.description": "Sviraj na instrumentima i bubnjevima.",
    "gui.extension.pen.name": "Olovka",
    "gui.extension.pen.description": "Crtaj pomoću likova.",
    "gui.extension.videosensing.name": "Video",
    "gui.extension.videosensing.description": "Osjećaj pokreta s kamerom.",
    "gui.extension.text2speech.name": "Tekst u govor",
    "gui.extension.text2speech.description": "Likovi u projektima govore.",
    "gui.extension.translate.name": "Prevedi",
    "gui.extension.translate.description": "Prevedi tekst na puno jezika.",
    "gui.extension.makeymakey.description": "Pretvori bilo što u tipku.",
    "gui.extension.microbit.description": "Poveži svoj projekt sa svijetom.",
    "gui.extension.microbit.connectingMessage": "Povezivanje",
    "gui.extension.ev3.description": "Izgradi interaktivne robote i još mnogo toga.",
    "gui.extension.ev3.connectingMessage": "Spajanje. Provjeri je li pin na EV3 postavljen na 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Gradi s motorima i senzorima.",
    "gui.extension.wedo2.connectingMessage": "Povezivanje",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Sve",
    "gui.libraryTags.animals": "Životinje",
    "gui.libraryTags.dance": "Ples",
    "gui.libraryTags.effects": "Efekti",
    "gui.libraryTags.fantasy": "Fantazija",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Hrana",
    "gui.libraryTags.indoors": "Unutra",
    "gui.libraryTags.loops": "Petlje",
    "gui.libraryTags.music": "Glazba",
    "gui.libraryTags.notes": "Bilješke",
    "gui.libraryTags.outdoors": "Vani",
    "gui.libraryTags.patterns": "Uzorak",
    "gui.libraryTags.people": "Ljudi",
    "gui.libraryTags.percussion": "Udaraljke",
    "gui.libraryTags.space": "Prostor",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Podvodni",
    "gui.libraryTags.voice": "Glas",
    "gui.libraryTags.wacky": "Ćaknut",
    "gui.libraryTags.animation": "Animacija",
    "gui.libraryTags.art": "Umjetnost",
    "gui.libraryTags.games": "Igre",
    "gui.libraryTags.stories": "Priče",
    "gui.libraryTags.letters": "Slova",
    "gui.opcodeLabels.direction": "smjer",
    "gui.opcodeLabels.xposition": "x položaj",
    "gui.opcodeLabels.yposition": "y položaj",
    "gui.opcodeLabels.size": "veličina",
    "gui.opcodeLabels.costumename": "naziv kostima",
    "gui.opcodeLabels.costumenumber": "Broj kostima",
    "gui.opcodeLabels.backdropname": "naziv pozadine",
    "gui.opcodeLabels.backdropnumber": "Broj pozadine",
    "gui.opcodeLabels.volume": "jačina zvuka",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "odgovor",
    "gui.opcodeLabels.loudness": "glasnoća",
    "gui.opcodeLabels.username": "nadimak",
    "gui.opcodeLabels.year": "godina",
    "gui.opcodeLabels.month": "mjesec",
    "gui.opcodeLabels.date": "dan",
    "gui.opcodeLabels.dayofweek": "dan u tjednu",
    "gui.opcodeLabels.hour": "sat",
    "gui.opcodeLabels.minute": "minuta",
    "gui.opcodeLabels.second": "sekunda",
    "gui.opcodeLabels.timer": "štoperica",
    "gui.projectLoader.loadError": "Odabrana datoteka projekta nije se učitala.",
    "gui.sharedMessages.backdrop": "pozadina{index}",
    "gui.sharedMessages.costume": "kostim{index}",
    "gui.sharedMessages.sprite": "Lik{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch projekt",
    "boost.color.any": "bilo koja boja",
    "boost.color.black": "crna",
    "boost.color.blue": "plava",
    "boost.color.green": "zelena",
    "boost.color.red": "crvena",
    "boost.color.white": "bijela",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "kut nagiba [TILT_DIRECTION]",
    "boost.motorDirection.backward": "smjer kazaljke na satu",
    "boost.motorDirection.forward": "suprotno kazaljke na satu",
    "boost.motorDirection.reverse": "obrnuto",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "bilo koja",
    "boost.tiltDirection.down": "dolje",
    "boost.tiltDirection.left": "lijevo",
    "boost.tiltDirection.right": "desno",
    "boost.tiltDirection.up": "gore",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "kada je nagnuto [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "sviraj ton [NOTE]  [TIME] sekundi",
    "ev3.buttonPressed": "gumb [PORT] pritisnut?",
    "ev3.getBrightness": "osvjetljenje",
    "ev3.getDistance": "udaljenost",
    "ev3.getMotorPosition": "motor [PORT] pozicija",
    "ev3.motorSetPower": "motor [PORT] postavi snagu na [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] okreni ovako na [TIME] sekundi",
    "ev3.motorTurnCounterClockwise": "motor [PORT] okreni suprotno od kazaljke na satu na [TIME] sekunde",
    "ev3.whenBrightnessLessThan": "kada je osvjeteljnje < [DISTANCE]",
    "ev3.whenButtonPressed": "kada je tipka [PORT] pritisnuta",
    "ev3.whenDistanceLessThan": "kada je udaljenost < [DISTANCE]",
    "gdxfor.getAcceleration": "ubrzanje [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "strelica dolje",
    "makeymakey.downArrowShort": "dolje",
    "makeymakey.leftArrow": "strelica lijevo",
    "makeymakey.leftArrowShort": "lijevo",
    "makeymakey.rightArrow": "strelica desno",
    "makeymakey.rightArrowShort": "desno",
    "makeymakey.spaceKey": "razmaknica",
    "makeymakey.upArrow": "strelica gore",
    "makeymakey.upArrowShort": "gore",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "bilo koja",
    "microbit.clearDisplay": "očisti ekran",
    "microbit.defaultTextToDisplay": "Bok!",
    "microbit.displaySymbol": "prikaži [MATRIX]",
    "microbit.displayText": "prikaži tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "skok",
    "microbit.gesturesMenu.moved": "pomaknuto",
    "microbit.gesturesMenu.shaken": "protresen",
    "microbit.isButtonPressed": "gumb [BTN] pritisnut?",
    "microbit.isTilted": "nagnuto [DIRECTION]?",
    "microbit.pinStateMenu.off": "isključeno",
    "microbit.pinStateMenu.on": "uključeno",
    "microbit.tiltAngle": "kut nagiba [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "bilo koja",
    "microbit.tiltDirectionMenu.back": "nazad",
    "microbit.tiltDirectionMenu.front": "naprijed",
    "microbit.tiltDirectionMenu.left": "lijevo",
    "microbit.tiltDirectionMenu.right": "desno",
    "microbit.whenButtonPressed": "kada je gumb [BTN] pritisnut",
    "microbit.whenGesture": "kada je [GESTURE]",
    "microbit.whenPinConnected": "kada je pin [PIN] spojen",
    "microbit.whenTilted": "kada je nagnuto [DIRECTION]",
    "music.categoryName": "Glazba",
    "music.changeTempo": "promijeni tempo za [TEMPO]",
    "music.drumBass": "(2) Bass bubanj",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Drveni štapići",
    "music.drumClosedHiHat": "(6) Zatvorene činele",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Kravlje zvonce",
    "music.drumCrashCymbal": "(4) Crash činele",
    "music.drumCuica": "(18) Cuica bubanj",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Pljesak",
    "music.drumOpenHiHat": "(5) Otvorene činele",
    "music.drumSideStick": "(3) Side Stick zvuk",
    "music.drumSnare": "(1) Mali bubanj",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangl",
    "music.drumVibraslap": "(17) Vibrafon",
    "music.drumWoodBlock": "(10) Drveni block",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violončelo",
    "music.instrumentChoir": "(15) Zbor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Električna gitara",
    "music.instrumentElectricPiano": "(2) Električni piano",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Gitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Muzička kutijica",
    "music.instrumentOrgan": "(3) Orgulje",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Čelični bubanj",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Drvena flauta",
    "music.midiPlayDrumForBeats": "bubnjaj [DRUM] [BEATS] puta",
    "music.midiSetInstrument": "postavi instrument na [INSTRUMENT]",
    "music.playDrumForBeats": "bubnjaj [DRUM] [BEATS] puta",
    "music.playNoteForBeats": "sviraj ton [NOTE] [BEATS] puta",
    "music.restForBeats": "preskoči [BEATS] puta",
    "music.setInstrument": "postavi instrument na [INSTRUMENT]",
    "music.setTempo": "postavi tempo na [TEMPO]",
    "pen.categoryName": "Olovka",
    "pen.changeColorParam": "promijeni [COLOR_PARAM] olovke za [VALUE]",
    "pen.changeHue": "promijeni boju olovke za [HUE]",
    "pen.changeShade": "promjeni sjenu olovke za [SHADE]",
    "pen.changeSize": "promijeni debljinu olovke za [SIZE]",
    "pen.clear": "izbriši sve",
    "pen.colorMenu.brightness": "osvjetljenje",
    "pen.colorMenu.color": "boja",
    "pen.colorMenu.saturation": "saturacija",
    "pen.colorMenu.transparency": "providnost",
    "pen.penDown": "spusti olovku",
    "pen.penUp": "podigni olovku",
    "pen.setColor": "postavi boju olovke na [COLOR]",
    "pen.setColorParam": "postavi [COLOR_PARAM] olovke na [VALUE]",
    "pen.setHue": "postavi boju olovke na [HUE]",
    "pen.setShade": "postavi sjenu olovke na [SHADE]",
    "pen.setSize": "postavi debljinu olovke na [SIZE]",
    "pen.stamp": "žig",
    "speech.defaultWhenIHearValue": "Krenimo",
    "speech.extensionName": "Govor u tekst",
    "speech.listenAndWait": "slušaj i čekaj",
    "speech.speechReporter": "govor",
    "speech.whenIHear": "kada čujem [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "div",
    "text2speech.kitten": "mačić",
    "text2speech.setLanguageBlock": "postavi jezik na [LANGUAGE]",
    "text2speech.setVoiceBlock": "postavi glas na [VOICE]",
    "text2speech.speakAndWaitBlock": "govori [WORDS]",
    "text2speech.squeak": "cviljenje",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Prevedi",
    "translate.defaultTextToTranslate": "Bok",
    "translate.translateBlock": "prevedi [WORDS] na [LANGUAGE]",
    "translate.viewerLanguage": "jezik",
    "videoSensing.categoryName": "Video",
    "videoSensing.direction": "smjer",
    "videoSensing.motion": "gibanje",
    "videoSensing.off": "isključeno",
    "videoSensing.on": "uključeno",
    "videoSensing.onFlipped": "uključeno zrcaljenje",
    "videoSensing.setVideoTransparency": "postavi providnost videa na [TRANSPARENCY]",
    "videoSensing.sprite": "lik",
    "videoSensing.stage": "pozornica",
    "videoSensing.videoOn": "video [ATTRIBUTE] na [SUBJECT]",
    "videoSensing.videoToggle": "postavi video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kada je gibanje videa > [REFERENCE]",
    "wedo2.getDistance": "udaljenost",
    "wedo2.getTiltAngle": "kut nagiba [TILT_DIRECTION]",
    "wedo2.isTilted": "nagnuto [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "smjer kazaljke na satu",
    "wedo2.motorDirection.forward": "suprotno kazaljke na satu",
    "wedo2.motorDirection.reverse": "obrnuto",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "svi motori",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "isključi [MOTOR_ID]",
    "wedo2.motorOn": "uključi [MOTOR_ID]",
    "wedo2.motorOnFor": "uključi [MOTOR_ID] na [DURATION] sekundi",
    "wedo2.playNoteFor": "sviraj ton [NOTE] [DURATION] sekundi",
    "wedo2.setLightHue": "postavi  boju svjetla na [HUE]",
    "wedo2.setMotorDirection": "postavi smjer [MOTOR_ID] na [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "postavi snagu [MOTOR_ID] na [POWER]",
    "wedo2.tiltDirection.any": "bilo koja",
    "wedo2.tiltDirection.down": "dolje",
    "wedo2.tiltDirection.left": "lijevo",
    "wedo2.tiltDirection.right": "desno",
    "wedo2.tiltDirection.up": "gore",
    "wedo2.whenDistance": "kada je udaljenost [OP] [REFERENCE]",
    "wedo2.whenTilted": "kada je nagnuto [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Boja",
    "paint.paintEditor.saturation": "Saturacija",
    "paint.paintEditor.brightness": "Osvjetljenje",
    "paint.paintEditor.costume": "Kostim",
    "paint.paintEditor.group": "Grupiraj",
    "paint.paintEditor.ungroup": "Razgrupiraj",
    "paint.paintEditor.undo": "Poništi",
    "paint.paintEditor.redo": "Ponovi",
    "paint.paintEditor.forward": "Naprijed",
    "paint.paintEditor.backward": "Natrag",
    "paint.paintEditor.front": "prednji",
    "paint.paintEditor.back": "Stražnji",
    "paint.paintEditor.more": "Više",
    "paint.modeTools.brushSize": "Veličina",
    "paint.modeTools.eraserSize": "Debljina gumice",
    "paint.modeTools.copy": "Kopiraj",
    "paint.modeTools.paste": "Zalijepi",
    "paint.modeTools.delete": "Izbriši",
    "paint.modeTools.curved": "Zaobljen",
    "paint.modeTools.pointed": "Šiljast",
    "paint.modeTools.thickness": "Debljina",
    "paint.modeTools.flipHorizontal": "Obrni vodoravno",
    "paint.modeTools.flipVertical": "Obrni okomito",
    "paint.modeTools.filled": "Ispunjeno",
    "paint.modeTools.outlined": "Obrubljeno",
    "paint.paintEditor.bitmap": "Pretvori u mapu bitova",
    "paint.paintEditor.vector": "Pretvori u vektor",
    "paint.paintEditor.fill": "Ispuna",
    "paint.paintEditor.stroke": "Obrub",
    "paint.brushMode.brush": "Kist",
    "paint.eraserMode.eraser": "Gumica",
    "paint.fillMode.fill": "Ispuna",
    "paint.lineMode.line": "Linija",
    "paint.ovalMode.oval": "Kružnica",
    "paint.rectMode.rect": "Pravokutnik",
    "paint.reshapeMode.reshape": "Preoblikuj",
    "paint.roundedRectMode.roundedRect": "Pravokutnik",
    "paint.selectMode.select": "Označi",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Zamijeni"
  },
  "xh": {
    "gui.alerts.lostPeripheralConnection": "u-Scratch ulahlekene nokuqhagamshelana ku {extensionName}",
    "gui.alerts.tryAgain": "Zama kwakhona",
    "gui.alerts.download": "Khuphela",
    "gui.connection.reconnect": "Qhagamshelana kwakhona",
    "gui.backpack.costumeLabel": "isinxibo",
    "gui.backpack.soundLabel": "isandi",
    "gui.backpack.scriptLabel": "Iskriphth",
    "gui.backpack.spriteLabel": "i-sprite",
    "gui.backpack.header": "Ubhaka",
    "gui.backpack.errorBackpack": "Kubekho ingxaki ekulaysheni ubhaka ",
    "gui.backpack.loadingBackpack": "Iyalaysha",
    "gui.backpack.more": "Ngaphezulu",
    "gui.backpack.emptyBackpack": "Ubhaka akaqulathanga nto",
    "gui.unsupportedBrowser.label": "Isikhangeli asixhaswanga",
    "gui.unsupportedBrowser.errorLabel": "Impazamo yenzekile",
    "gui.unsupportedBrowser.notRecommended": "Siyaxolisa, kodwa kubonakala ngathi usebenzisa uhlobo lwesikhangeli eingaxhaswayo ngu -Scratch. Sicebisa ukuba uphuculele kuhlobo olusha  olufana no-Google Chrome, Mozilla Firefox, Microsoft Edge kunye okanye u-Apple Safari.",
    "gui.unsupportedBrowser.description": "Siyaxolisa, kodwa u-Scratch akasixhasi esi sikhangeli. sicebisa ukuba uphuculele kwisikhangeli esitsha esixhaswayo esifana no-Google Chrome, Mozilla Firefox, Microsoft Edge, okanye uApple Safari.",
    "gui.unsupportedBrowser.back": "emva",
    "gui.unsupportedBrowser.previewfaq": "Ukuzifunda nangaphezulu, yiya kwi {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Izifundo",
    "gui.cards.shrink": "Nciphisa",
    "gui.cards.expand": "Yandisa",
    "gui.cards.close": "Vala",
    "gui.cards.more-things-to-try": "Izinto ezingaphezulu onokuzizama!",
    "gui.cards.see-more": "Bona nangakumbi",
    "gui.comingSoon.message1": "Ungakhathazeki, siphezu kwayo {emoji}",
    "gui.comingSoon.message2": "Iyeza kamsinyane...",
    "gui.comingSoon.message3": "Sisebenza kuyo{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Akukho zixhobo zifunyenweyo",
    "gui.connection.auto-scanning.prescan": "Yiba nezixhobo zakho, ze uqalise ukukhangela.",
    "gui.connection.auto-scanning.pressbutton": "Cofa iqhosha kwisixhobo sakho.",
    "gui.connection.auto-scanning.start-search": "Qalisa Ukhangela",
    "gui.connection.connecting-searchbutton": "Iyahangela...",
    "gui.connection.auto-scanning.try-again": "Zama kwakhona",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ziqhagamshelene",
    "gui.connection.disconnect": "Qhawula uqhagamshelwano",
    "gui.connection.go-to-editor": "Yiya ku- Editor",
    "gui.connection.connecting-cancelbutton": "Iyaqhagamshelana...",
    "gui.connection.error.errorMessage": "Yhoo, kubonakala ngathi ikhona into engahambanga kakuhle.",
    "gui.connection.error.tryagainbutton": "Zama kwakhona",
    "gui.connection.error.helpbutton": "Nceda",
    "gui.connection.peripheral-name-label": "Igama lesixhobo",
    "gui.connection.connect": "Qhagamshelanisa",
    "gui.connection.scanning.lookingforperipherals": "Ukukhangela izixhobo",
    "gui.connection.scanning.noPeripheralsFound": "Akukho zixhobo zifunyenweyo",
    "gui.connection.scanning.instructions": "Khangela isixhobo sakho kuluhlu olungasentla",
    "gui.connection.search": "Yenza ntsha",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Qinisekisa ukuba ukuba u- Scratch Link ufakelwe kwaye uyasebenza",
    "gui.connection.unavailable.enablebluetooth": "Jonga ukuba iBluetooth ivuliwe",
    "gui.connection.unavailable.tryagainbutton": "Zama kwakhona",
    "gui.connection.unavailable.helpbutton": "Nceda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Hamba",
    "gui.controls.stop": "Yima",
    "gui.crashMessage.label": "Yhoo! Ikhona into engahambanga kakuhle.",
    "gui.crashMessage.description": "Siyaxolisa, kodwa kubonakala ngathi uScratch umoshakele. ingxaki seyixelwe ngokuzenzekelayo kwiqela le- Scratch. Nceda wenze litsha iphepha lakho ukuzama kwakhona.",
    "gui.crashMessage.errorNumber": "Ingxaki yakho ingeniswe ngala ngale id {errorId}",
    "gui.crashMessage.reload": "Phinda uyilayshe",
    "gui.customProcedures.myblockModalTitle": "Yenza ibhloko kwakhona",
    "gui.customProcedures.addAnInputNumberText": "Faka igalelo",
    "gui.customProcedures.numberTextType": "inani okanye umbhalo",
    "gui.customProcedures.addAnInputBoolean": "Faka igalelo",
    "gui.customProcedures.booleanType": "I-boolean",
    "gui.customProcedures.addALabel": "Faka uphawu",
    "gui.customProcedures.runWithoutScreenRefresh": "Sebenza ngaphandle ngokwenziwa ntsha kwe -screen",
    "gui.customProcedures.cancel": "Rhoxisa",
    "gui.customProcedures.ok": "Kulungile",
    "gui.SpriteInfo.direction": "Isalathiso",
    "gui.directionPicker.rotationStyles.allAround": "Kuzo Zonke",
    "gui.directionPicker.rotationStyles.leftRight": "Ekhohlo/Ekunene",
    "gui.directionPicker.rotationStyles.dontRotate": "Sukujikelezisa",
    "gui.gui.addExtension": "Faka Ulwandiso",
    "gui.gui.codeTab": "Ikhowdi",
    "gui.gui.backdropsTab": "Imiva",
    "gui.gui.costumesTab": "ikhostyum",
    "gui.gui.soundsTab": "Izandi",
    "gui.extensionLibrary.comingSoon": "iyeza kamsinyame",
    "gui.extensionLibrary.requires": "Ifuna",
    "gui.extensionLibrary.collaboration": "Intsebenziswano no",
    "gui.library.filterPlaceholder": "Khangela",
    "gui.library.allTag": "Konke",
    "gui.loader.message1": "Ukwenza iibhloko",
    "gui.loader.message2": "Ukulaysha iz-prite",
    "gui.loader.message3": "Ukulaysha izandi",
    "gui.loader.message4": "Ukulaysha izandiso",
    "gui.loader.message5": "Ukwalusa iikati",
    "gui.loader.message6": "Ukusasaza ii - nano",
    "gui.loader.message7": "Ukwenyusa ii -gobo",
    "gui.loader.message8": "Ukulungiselela ii -emoji",
    "gui.loader.headline": "Ukulaysha Iprojekhth",
    "gui.loader.creating": "Ukwensza Iprpjekhth",
    "gui.accountMenu.profile": "Iprofayl",
    "gui.accountMenu.myStuff": "Izinto Zam",
    "gui.accountMenu.myClasses": "IIklasi Zam",
    "gui.accountMenu.myClass": "Iklasi Yam",
    "gui.accountMenu.accountSettings": "Ukulungiselelwa kwe-akhawnt",
    "gui.accountMenu.signOut": "Phuma",
    "gui.authorInfo.byUser": "ngu {username}",
    "gui.menuBar.seeProjectPage": "Jonga Iphepha leprojekhth",
    "gui.menuBar.language": "Language",
    "general.username": "Igama Lomsebenzisi",
    "general.password": "Amagama Okudlula",
    "general.signIn": "Ngena",
    "login.needHelp": "dinga Uncedo?",
    "form.validationRequired": "Le ndawo iyafuneka",
    "gui.menuBar.tutorialsLibrary": "Izifundo",
    "gui.menuBar.restoreSprite": "Buyisela i-Sprite",
    "gui.menuBar.restoreSound": "Buyisela Isandi",
    "gui.menuBar.restoreCostume": "Buyisa Ikhostyum",
    "gui.menuBar.restore": "Buyisela",
    "gui.menuBar.saveNow": "Gcina ngoku",
    "gui.menuBar.saveAsCopy": "Gcina njenge kopi",
    "gui.menuBar.remix": "Xuba kwakhona",
    "gui.menuBar.new": "Entsha",
    "gui.menuBar.file": "Ifayl",
    "gui.menuBar.downloadToComputer": "Gcina ekhomputeni yakho",
    "gui.menuBar.edit": "Hlela",
    "gui.menuBar.turboModeOff": "Cima i - Turbo Mode",
    "gui.menuBar.turboModeOn": "Vula i - Turbo Mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Zibandakanye no - Scratch",
    "gui.menuBar.signIn": "Ngena",
    "gui.gui.projectTitlePlaceholder": "Igama leprojekhth apha",
    "gui.menuBar.saveNowLink": "Gcina Ngoku",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Wabelene",
    "gui.menuBar.share": "Yabelana",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Nceda",
    "gui.modal.back": "Emva",
    "gui.monitor.listMonitor.empty": "(ayiqulathanga nto)",
    "gui.monitor.listMonitor.listLength": "ubude{length}",
    "gui.monitor.contextMenu.default": "indlela yokufunda yesiqhelo",
    "gui.monitor.contextMenu.large": "ukufunda okukhulu",
    "gui.monitor.contextMenu.slider": "umtyibilikisi",
    "gui.monitor.contextMenu.sliderRange": "guqula umgama womtyibilikisi",
    "gui.monitor.contextMenu.import": "ivela ngaphandle",
    "gui.monitor.contextMenu.export": "ithunyelwa ngaphandle",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Dlala",
    "gui.playButton.stop": "Yima",
    "gui.gui.variableScopeOptionAllSprites": "Yazo zonke ii-Sprite",
    "gui.gui.variableScopeOptionSpriteOnly": "Yeyesi-Sprite sodwa",
    "gui.gui.cloudVariableOption": "I - variable ye -Cloud (igcinwe kwi - server ))",
    "gui.gui.variablePromptAllSpritesMessage": "Le - variable izawufumaneka kuzo zonke ii-sprites.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Rhoxisa",
    "gui.prompt.ok": "Kulungille",
    "gui.playbackStep.stopMsg": "Yima",
    "gui.playbackStep.playMsg": "Dlala",
    "gui.playbackStep.loadingMsg": "Iyalaysha...",
    "gui.playbackStep.saveMsg": "Gcina",
    "gui.playbackStep.reRecordMsg": "Shicilela kwakhona",
    "gui.recordModal.title": "Shicilela isandi",
    "gui.recordingStep.beginRecord": "Qalisa ukushicilela ngokucofa iqhosha elingezantsi",
    "gui.recordingStep.permission": "{arrow} Sidinga imvume yakho ukusebenzisa umboko wakho.",
    "gui.recordingStep.stop": "Pheza ukushicilela",
    "gui.recordingStep.record": "Shicilelea",
    "gui.sliderModal.min": "Elona xabiso lincinci",
    "gui.sliderModal.max": "Elona xabiso liphezulu",
    "gui.sliderModal.title": "Guqula ubungakanani bomtyibilizisi ",
    "gui.sliderPrompt.cancel": "Rhoxisa",
    "gui.sliderPrompt.ok": "Kulungile",
    "gui.soundEditor.sound": "Isandi",
    "gui.soundEditor.play": "Dlala",
    "gui.soundEditor.stop": "Yima",
    "gui.soundEditor.copy": "Khuphela",
    "gui.soundEditor.paste": "Ncamathisela",
    "gui.soundEditor.copyToNew": "Khuphela kwentsha",
    "gui.soundEditor.delete": "Cima",
    "gui.soundEditor.save": "Gcina",
    "gui.soundEditor.undo": "Susa",
    "gui.soundEditor.redo": "Phinda wenze",
    "gui.soundEditor.faster": "Ngokukhawuleza okuthe chatha",
    "gui.soundEditor.slower": "Ngokucotha okuthe kratya",
    "gui.soundEditor.echo": "Isandi esilinganisayo",
    "gui.soundEditor.robot": "i-Roboth",
    "gui.soundEditor.louder": "Khwaza nangaphezulu",
    "gui.soundEditor.softer": "Ngokuthambe nangaphezulu",
    "gui.soundEditor.reverse": "Buya umva",
    "gui.soundEditor.fadeOut": "Mbatsha",
    "gui.soundEditor.fadeIn": "Gqama",
    "gui.soundEditor.mute": "Thula",
    "gui.SpriteInfo.spritePlaceholder": "Igama",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "i-Sprite",
    "gui.SpriteInfo.show": "Bonisa",
    "gui.SpriteInfo.size": "Ubungakanani",
    "gui.spriteSelectorItem.contextMenuDuplicate": "Phinda",
    "gui.spriteSelectorItem.contextMenuExport": "thumela ngaphandle",
    "gui.spriteSelectorItem.contextMenuDelete": "cima",
    "gui.spriteSelector.addSpriteFromLibrary": "Khetha i - Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Peynta",
    "gui.spriteSelector.addSpriteFromSurprise": "Mangalisa",
    "gui.spriteSelector.addSpriteFromFile": "Faka i-Sprite",
    "gui.stageHeader.stageSizeLarge": "Guqulela kwiqonga elikhulu",
    "gui.stageHeader.stageSizeSmall": "Guqulela kwelincinci iqonga",
    "gui.stageHeader.stageSizeFull": "Ngena kwimo yeskrin esikhulu",
    "gui.stageHeader.stageSizeUnFull": "Phuma kwimo yeskrin esikhulu",
    "gui.stageHeader.fullscreenControl": "Ulawulo Leskrini Esigcweleyo",
    "gui.spriteSelector.addBackdropFromLibrary": "Zikhethele Umva",
    "gui.stageSelector.addBackdropFromPaint": "Peynta",
    "gui.stageSelector.addBackdropFromSurprise": "Mangalisa",
    "gui.stageSelector.addBackdropFromFile": "Faka Umva",
    "gui.stageSelector.stage": "iqonga",
    "gui.stageSelector.backdrops": "Imiva",
    "gui.telemetryOptIn.label": "Xela iinkcukacha zophucula u-Scratch",
    "gui.telemetryOptIn.body1": "Iqela le-Scratch lihlala likhangela iindlela zokuqonda ukuba u - scratch usetyenziswa njani ehlabathini jikelelele. Ukuzama ukuxhasa ezi nzame ungavumela u-Scratch ukuba athumele ngokuzenzekelayo zokusetyenziswa zakho kwiqela le - Scratch.",
    "gui.telemetryOptIn.body2": "Iinkcukhankca esiziqokelelayo zibandakanya  ukukhethwa kolwimi, ukusetyenziswa kweebhloko, kwaneziganeko ezifana nokonga, kwanokufaka iprojekhth. ASIQOKELELI naziphi na iinkcukhakca ezingomntu. Nceda jonga eyethu i {privacyPolicyLink} ngolwazi oluthe vetshe.",
    "gui.telemetryOptIn.privacyPolicyLink": "Imigaqo - siseko yabucala",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Ubume be - Turbo",
    "gui.webglModal.label": "Isikhangeli sakho asiyixhasi i - WebGL",
    "gui.webglModal.description": "Ngelishwa kubonakala ngathi yindlela isikhangeli sakho okanye ikhompyutha yakho{webGlLink}. Le tekhnoloji iyafuneka ku-Scratch 3.0 ukuze asebenze",
    "gui.webglModal.webgllink": "asiyixhasi i - WebGL",
    "gui.webglModal.back": "emva",
    "gui.webglModal.previewfaq": "Ukufunda nangakumbi, yiya kwi {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Khetha Umva",
    "gui.costumeLibrary.chooseACostume": "Khetha Ikhostyum",
    "gui.costumeTab.addBackdropFromLibrary": "Khetha Umva",
    "gui.costumeTab.addCostumeFromLibrary": "Khetha Ikhostyum",
    "gui.costumeTab.addBlankCostume": "Peynta",
    "gui.costumeTab.addSurpriseCostume": "Mangalisa",
    "gui.costumeTab.addFileBackdrop": "Faka Umva",
    "gui.costumeTab.addFileCostume": "Faka Ikhostyum",
    "gui.extensionLibrary.chooseAnExtension": "Khetha Ulwandiso",
    "gui.extensionLibrary.extensionUrl": "Ngena kulwandiso lwe URL",
    "gui.monitors.importListColumnPrompt": "Loluphi uluhlu ekufuneka lusetyenzisiwe (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Asikwazanga ukuqalisa ukushicilela",
    "gui.soundLibrary.chooseASound": "Khetha Isandi",
    "gui.soundTab.fileUploadSound": "Faka Isandi",
    "gui.soundTab.surpriseSound": "Mangalisa",
    "gui.soundTab.recordSound": "Shicilela",
    "gui.soundTab.addSoundFromLibrary": "Khetha Isandi",
    "gui.spriteLibrary.chooseASprite": "Khetha i-Sprite",
    "gui.tipsLibrary.tutorials": "Khetha isifundo",
    "gui.alerts.createsuccess": "Iprojekhth entsha yenziwe",
    "gui.alerts.createcopysuccess": "Iprojekhth igcinwe wayikopi",
    "gui.alerts.createremixsuccess": "Iprojekhth igcinwe ngokuxutywa ngokutsha",
    "gui.alerts.creating": "Qala entsha...",
    "gui.alerts.creatingCopy": "Ukukhuphela iprojekhth",
    "gui.alerts.creatingRemix": "Xuba iprojekhth okutsha...",
    "gui.alerts.creatingError": "Iprojekhth ayenzekanga. Nceda uzame kwakhona",
    "gui.alerts.savingError": "Iprojekhth ayikeazanga ukugcineka.",
    "gui.alerts.savesuccess": "Iprojekhth igcinekile",
    "gui.alerts.saving": "Sigcina iprojekhth",
    "gui.alerts.cloudInfo": "Nceda qaphela, icloud variable ixhasa amani kuphela, hayi amagama neempawu.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Funda nangakumbi",
    "gui.alerts.importing": "sithatha ngaphandle...",
    "gui.defaultProject.meow": "i-Meow",
    "gui.defaultProject.variable": "i-variable yam",
    "gui.howtos.intro-move-sayhello-hat.name": "Ukuqalisa",
    "gui.howtos.intro-move.step_stepMove": "Yongeza Ibhloko Ye - move",
    "gui.howtos.add-a-move-block.step_stepSay": "Yongeza ibhloko ye - say",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Cofa iflegi eluhlaza ukuqalisa",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Nika Igama Ubomi ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Khetha i-Sprite Sikanobumba",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Dlala isandi xa icofiwe",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Khetha esinye kwi-Sprite sikanobumba",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Guqula umbala",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Khetha Esinye i-Sprite Sikanomumba Usenze Sijikeleze",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Khetha Esinye i-Sprite Sikanobumba Usenze Sikhule",
    "gui.howtos.imagine": "Yiba nomfanekisongqondqweni Wehlabathi",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Bhala Ofuna Ukukuthetha",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Cofa Iflegi Eluhlaza Ukuqalisa",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Khetha Nawuphina Umva",
    "gui.howtos.imagine.step_imagineChooseSprite": "khetha Nasiphina i-Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Cofa Iqhosha Lespace liye ku Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Khetha Esnye i-Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Hamba ekhohlo-kunene",
    "gui.howtos.imagine.step_imagineUpDown": "Hamba Phantsi-Phezulu",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Tshintsha iikhostyum",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Tyibilikela endaweni",
    "gui.howtos.imagine.step_imagineGrowShrink": "Khula ze Unciphe",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Khetha Omnye Umva",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Tshintsha Imiva",
    "gui.howtos.imagine.step_imagineRecordASound": "Fakela Isandi",
    "gui.howtos.imagine.step_imagineChooseSound": "Khetha Isandi Sakho",
    "gui.howtos.make-music.name": "Yenza Umculo",
    "gui.howtos.Make-Music.step_PickInstrument": "Khetha i-Sprite Sesixhobo",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Dlala Isandi Xa Ucofile",
    "gui.howtos.Make-Music.step_MakeSong": "Yenza ingoma",
    "gui.howtos.make-music.step_MakeBeat": "Khetha Igubu Wenze Isingqi",
    "gui.howtos.make-music.step_MakeBeatBox": "Khetha i-Sprite se-micophone Wothuse i - Beatbox ",
    "gui.howtos.story.name": "Yenza Ibali",
    "gui.howtos.story.step_addbg": "Faka Umva",
    "gui.howtos.story.step_addsprite": "Faka Umlinganiswa",
    "gui.howtos.story.step_saysomething": "Thetha ",
    "gui.howtos.story.step_addanothersprite": "Faka Omnye Umlinganiswa",
    "gui.howtos.story.step_flip": "Tshintsha Isalathiso ",
    "gui.howtos.story.step_conversation": "Yiba Nencoko",
    "gui.howtos.story.addanotherbg": "Yongeza Omnye Umva",
    "gui.howtos.story.step_swithbg": "Guqula Imiva",
    "gui.howtos.story.step_hidewizard": "Fihla Umlinganiswa",
    "gui.howtos.story.step_showwizard": "Bonisa Umlinganiswa",
    "gui.howtos.make-a-chase-game.name": "Yenza Umdlalo Wokuleqa",
    "gui.howtos.Chase-Game.step_BG": "Yongea Umva",
    "gui.howtos.chase-game.step_AddOcto": "Faka i-Sprite",
    "gui.howtos.make-music.step_LeftRight": "Hambisa Ekunene Nasekhohlo Ngamaqhosha Otolo",
    "gui.howtos.Chase-Game.step_UpDown": "Hambisa Phantsi na-Phezulu Ngamaqhosha Otolo",
    "gui.howtos.Chase-Game.step_AddStar": "Yongeza Esinye i-Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Hambisa Naphina",
    "gui.howtos.Chase-Game.step_WhenTouch": "i-Sprite Sengwane, Xa Ucofa uPlay Sound",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Yenza i-Variable Yenqaku",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Kwi-Sprite Sengwane, Xa Ucofe uAdd score",
    "gui.howtos.animate-char.name": "Nika Umlinganiswa Ubomi",
    "gui.howtos.animate-char.step_addbg": "Faka Umva",
    "gui.howtos.animate-char.step_addsprite": "Faka i-Sprite",
    "gui.howtos.animate-char.step_saysomething": "Thetha ",
    "gui.howtos.animate-char.step_addsound": "Faka Isandi",
    "gui.howtos.animate-char.step_animatetalking": "Nika Intetha Ubomi",
    "gui.howtos.animate-char.step_arrowkeys": "Hambisa Usebenzisa Amaqhosha Otolo",
    "gui.howtos.animate-char.step_jump": "Tsiba",
    "gui.howtos.animate-char.step_changecolor": "Guqula Umbala",
    "gui.howtos.make-a-game.name": "Yenza Umdlalo Womcofi",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Khetha i-Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Dlala Isandi Xa Kucofiwe",
    "gui.howtos.make-a-game.step_GameAddScore": "Yenza i-Variable Yenqaku",
    "gui.howtos.make-a-game.step_GameChangeScore": "Xa Kucofiwe Yandisa Amanqaku",
    "gui.howtos.make-a-game.step_Random": "Yiya Naphina",
    "gui.howtos.make-music.step_GameChangeColor": "Guqula Umbala",
    "gui.howtos.make-music.step_ResetScore": "Lungiselela Amanqaku Okutsha",
    "gui.howtos.make-it-fly.name": "Yibhabhise",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Khetha Umva Osisibhakabhaka",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Lhetha Umlinganiswa",
    "gui.howtos.fly.step_stepflySaySomething": "Thetha ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Hambisa ngeentolo",
    "gui.howtos.fly.step_stepflyChooseObject": "Khetha Into Ongayiqokelela",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Yenza Into Ihambe",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Khetha Umlinganiswa Wakho",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Yongeza Inqaku",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Gcina Amanqaku",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Faka Imbonakalo Entle",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Hambisa Imbonakalo Entle",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Ikhostyum Elandelayo",
    "gui.howtos.pong": "Umdlalo we-Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Faka Umva",
    "gui.howtos.pong.step_pongAddBallSprite": "Faka i-Sprite Sebhola ",
    "gui.howtos.pong.step_pongBounceAround": "Bhampa Ndawoyonke",
    "gui.howtos.pong.step_pongAddPaddle": "Faka  i-Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Hambisa i-Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Khetha i-Sprie Sebhola",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Faka Ikhowd Yokwenza ibhola ibhampele Ngaphandle kwi - Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Faka Amanqaku",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Khetha 'Scre' kwi Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Faka Ibhlok Yo \" Ukuguquka Amanqaku\"",
    "gui.howtos.pong.step_pongResetScore": "Lungiselela Amanqaku Okutsha",
    "gui.howtos.pong.step_pongAddLineSprite": "Faka Umgca we-Sprite",
    "gui.howtos.pong.step_pongGameOver": "Umdlalo Uphelile",
    "gui.howtos.code-cartoon": "Khowuda Umzobo Ohlekisayo",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Thetha Xa Ucofa Ifleg Eluhlaza",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Fakela Umlinganiswa Ubomi Xa Umcofile ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Khetha Umlinganiswa Owahlukileyo",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Sebenzisa Uphawo Lokunciphisa Ukufumana Umncinane",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Yenza Umlinganiswa Akhule Kwaye Anciphe",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Khetha Umlinganiswa Owahlukileyo",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Xhuma Phezulu Naphantsi",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Cofa Umlinganiswa Ukuguqula Imbonakalo Entle",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Tyibilika Ndawo Yonke",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Tshintsha Ikhostyum",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Khetha Abalinganiswa Abangaphezulu Ukongeza Kumzobo wakho Ohlekisayo",
    "gui.howtos.cartoon-network": "Faka Ubomi Kumdlalo Wokonwaba",
    "gui.howtos.cartoon-network.step_CNcharacter": "Khetha Umlingamiswa  Wokubonisa",
    "gui.howtos.cartoon-network.step_CNsay": "Thetha",
    "gui.howtos.cartoon-network.step_CNglide": "Tyibilika Ndawo Yonke",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Khetha Into Yokuleqa",
    "gui.howtos.cartoon-network.step_CNcollect": "Qokelela Izinto",
    "gui.howtos.cartoon-network.step_CNvariable": "Yenza i-Variable Yamanqaku",
    "gui.howtos.cartoon-network.step_CNscore": "Gcina Amanqaku",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Phakamisa Umgangatho: Guqula Umva",
    "gui.howtos.videosens.name": "Ukuva Ividyo",
    "gui.howtos.videosens.step_addextension": "Faka Ulwandiso",
    "gui.howtos.videosens.step_pet": "Fuya ikati",
    "gui.howtos.videosens.step_animate": "Faka Ubpmi",
    "gui.howtos.videosens.step_pop": "Gqabuza Ibhaloni",
    "gui.howtos.say-it-out-loud": "Yenza Ufakobomi Obuthethayo                               ",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Yongeza Umbhalo Kwiibhloko Zokuthetha",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Thetha",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Lungiselela Ilizwi",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Hamba ndawo yonke",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Faka Umva",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Faka Omnye Umlinganiswa",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cula Ingoma",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Guqula Umbala",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Jikelezisa Macala Onke",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Khula Uze Unciphe",
    "gui.howtos.talking": "Amabali ezithethay0",
    "gui.howtos.talking.step_talesAddExtension": "Cofa Ukufaka Iibhloko Zombhalo Ukuya Kwintetha  ",
    "gui.howtos.talking.step_talesChooseSprite": "Khetha i-Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Yenza Umlinganiswa Athethe",
    "gui.howtos.talking.step_talesChooseBackdrop": "Khetha Umva",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Cofa Umlinganiswa Ukuya Kumva Olandelayo",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Khetha Esinye i-Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Hamba Ndawo Yonke",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Khetha Omnye Umva",
    "gui.howtos.talking.step_talesAnimateTalking": "Faka Ubomi Kwintetha",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Khetha Omnye Umva",
    "gui.howtos.talking.step_talesChooseSound": "Khetha Ingoma Ongayidanisela",
    "gui.howtos.talking.step_talesDanceMoves": "IIntshukumo Zomdaniso",
    "gui.howtos.talking.step_talesAskAnswer": "Fumana iibhloko Zokubuza Nokuphendula Kwicandela Lokuva",
    "gui.howtos.add-sprite.name": "Faka i-Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Faka i-Sprite",
    "gui.howtos.add-a-backdrop.name": "Faka Umva",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Faka Umva",
    "gui.howtos.change-size.name": "Guqulaa Ubungakanani",
    "gui.howtos.change-size.step_changeSize": "Guqula Ubungakanani",
    "gui.howtos.glide-around.name": "Tyibilika Ndawo Yonke",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Tyibilika Ndawo Yonke",
    "gui.howtos.change-size.step_glideAroundPoint": "Tyibilikela Ndaweni Ithile",
    "gui.howtos.record-a-sound.name": "Shicilela Isandi",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Cofa iqhosha \"Sounds\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Cofa \"Record\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Cofa Iqhosha Lokushicilela",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Khetha Isandi Sakho",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Dlala Isandi Sakho",
    "gui.howtos.spin-video.name": "Yenze Ijikeleze",
    "gui.howtos.change-size.step_spinTurn": "Guqula",
    "gui.howtos.change-size.step_spinPointInDirection": "Lungiselela Isalathisi",
    "gui.howtos.hide-and-show.name": "Fihla Uze Ubonise",
    "gui.howtos.change-size.step_hideAndShow": "Fihla Uze Ubonise",
    "gui.howtos.switch-costume.name": "Nika i-Sprite Ubomi",
    "gui.howtos.change-size.step_switchCostumes": "Nika i-Sprite Ubomi",
    "gui.howtos.move-around-with-arrow-keys.name": "Sebenzisa Amaqhosa Eentolo",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "hambisa Ekhohlo NaseKunene",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Hambisa Phezulu Nasezantsi",
    "gui.howtos.add-effects.name": "Faka Ifuthe",
    "gui.howtos.videosens.step_addEffects": "Faka Ifuthe",
    "gui.extension.music.name": "Umculo",
    "gui.extension.music.description": "Dlala izixhobo kunye namagubu",
    "gui.extension.pen.name": "Usiba",
    "gui.extension.pen.description": "Zoba nge-Sprites zakho",
    "gui.extension.videosensing.name": "Ukuva Ividyo",
    "gui.extension.videosensing.description": "Yiva intshukumo ngekhamera",
    "gui.extension.text2speech.name": "Umbhalo ukuya Kwintetho",
    "gui.extension.text2speech.description": "Yenza Iiprojekhth zakho zithethe",
    "gui.extension.translate.name": "Tolika",
    "gui.extension.translate.description": "Tolukela umbhalo kwiilwimi ezininzi",
    "gui.extension.makeymakey.description": "Yenza nantonina ibe sisitshixo",
    "gui.extension.microbit.description": "Qhagamshelanisa iiprojekhth zakho nehlabathi.",
    "gui.extension.microbit.connectingMessage": "Ukudibanisa",
    "gui.extension.ev3.description": "Yakha iirobhothi ezisebenzisanayo nangaphezulu",
    "gui.extension.ev3.connectingMessage": "Iyaqhagamshelana. Qinisekisa ukuba i-pini ekwi-EV3 yakho ilundiselelwe ukuba ibe ngu-1234.",
    "gui.extension.boost.description": "Zisa izidalwa zeerobhothi ebomini",
    "gui.extension.boost.connectingMessage": "Ukuqhagamshelana",
    "gui.extension.wedo2.description": "Yakha ngemooto mezixhobo zokuva",
    "gui.extension.wedo2.connectingMessage": "Ukuqhagamshelana",
    "gui.extension.gdxfor.description": "Yiva, tyhala, tsala, intshukumo, uze ujikelezise",
    "gui.extension.gdxfor.connectingMessage": "Ukuqhagamshelana",
    "gui.libraryTags.all": "Konke",
    "gui.libraryTags.animals": "Izilwanyana",
    "gui.libraryTags.dance": "Danisa",
    "gui.libraryTags.effects": "Ifuthe",
    "gui.libraryTags.fantasy": "Umbono",
    "gui.libraryTags.fashion": "Imfashoni",
    "gui.libraryTags.food": "Ukutya",
    "gui.libraryTags.indoors": "Ngaphakathi",
    "gui.libraryTags.loops": "Isikroba",
    "gui.libraryTags.music": "Umculo",
    "gui.libraryTags.notes": "Imibhalo",
    "gui.libraryTags.outdoors": "Ngaphandle",
    "gui.libraryTags.patterns": "Iipateni",
    "gui.libraryTags.people": "Abantu",
    "gui.libraryTags.percussion": "Isixhobo Somculo Esihlokomayo",
    "gui.libraryTags.space": "Isithuba",
    "gui.libraryTags.sports": "Imidlalo",
    "gui.libraryTags.underwater": "Ngaphantsi Kwamanzi",
    "gui.libraryTags.voice": "Ilizwi",
    "gui.libraryTags.wacky": "Ehlekisayo",
    "gui.libraryTags.animation": "Ukufakela Ubomi",
    "gui.libraryTags.art": "Ubugcisa",
    "gui.libraryTags.games": "Imidlalo",
    "gui.libraryTags.stories": "Amabali",
    "gui.libraryTags.letters": "Oonobumba",
    "gui.opcodeLabels.direction": "Isalathisi",
    "gui.opcodeLabels.xposition": "indawo ka x",
    "gui.opcodeLabels.yposition": "indawo ka y",
    "gui.opcodeLabels.size": "Ubungakanani",
    "gui.opcodeLabels.costumename": "Igama Lekhostyum",
    "gui.opcodeLabels.costumenumber": "Inani lekhostyum",
    "gui.opcodeLabels.backdropname": "igama lomva",
    "gui.opcodeLabels.backdropnumber": "inani lomva",
    "gui.opcodeLabels.volume": "umlinganiselo wesandi",
    "gui.opcodeLabels.tempo": "isantya",
    "gui.opcodeLabels.answer": "impendulo",
    "gui.opcodeLabels.loudness": "ingxolo",
    "gui.opcodeLabels.username": "igama lomsebenzisi",
    "gui.opcodeLabels.year": "unyaka",
    "gui.opcodeLabels.month": "inyanaga",
    "gui.opcodeLabels.date": "usuku",
    "gui.opcodeLabels.dayofweek": "usuku lweveki",
    "gui.opcodeLabels.hour": "iyure",
    "gui.opcodeLabels.minute": "umzuzu",
    "gui.opcodeLabels.second": "umzuzwana",
    "gui.opcodeLabels.timer": "isibali xesha",
    "gui.projectLoader.loadError": " Ifalyl yeprojekhth ekhethileyo awkwazanga ukungena.",
    "gui.sharedMessages.backdrop": "Umva {index}",
    "gui.sharedMessages.costume": "ikhostyum{index}",
    "gui.sharedMessages.sprite": "i-Sprite{index}",
    "gui.sharedMessages.pop": "Gqabhuza",
    "gui.sharedMessages.replaceProjectWarning": "Faka okunye endaweni yoku okuqulethwe yiprojekhth yalo mzuzu?",
    "gui.sharedMessages.loadFromComputerTitle": "Thata ekhompyutheni yakho",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Iprojekhth ye - Scratch",
    "boost.color.any": "Nawuphina umbala",
    "boost.color.black": "mnyama",
    "boost.color.blue": "luhlaza okwesibhakabhaka",
    "boost.color.green": "luhlaza",
    "boost.color.red": "bomvu",
    "boost.color.white": "mhlophe",
    "boost.color.yellow": "mthubi",
    "boost.getMotorPosition": "imoto [MOTOR_REPORTER_ID] indawo",
    "boost.getTiltAngle": "kekelisaa iengile [TILT_DIRECTION]",
    "boost.motorDirection.backward": "la ndlela",
    "boost.motorDirection.forward": "le ndlela",
    "boost.motorDirection.reverse": "buya umva",
    "boost.motorOff": "jika imoto [MOTOR_ID] icime",
    "boost.motorOn": "jika imoto [MOTOR_ID] idume",
    "boost.motorOnFor": "cima imoto [MOTOR_ID] idume [DURATION] yemizuzwana",
    "boost.motorOnForRotation": "guqula motor [MOTOR_ID] eyenzelwe [ROTATION] ijikeleze",
    "boost.seeingColor": "ubona [COLOR] isitena?",
    "boost.setLightHue": "lungiselela umbala wokukhanya [HUE]",
    "boost.setMotorDirection": "lungiselela motor [MOTOR_ID] isalathiso [MOTOR_DIRECTION]",
    "boost.setMotorPower": "lungiselela motor [MOTOR_ID] isatya sibe [POWER] %",
    "boost.tiltDirection.any": "nayiphi",
    "boost.tiltDirection.down": "phantsi",
    "boost.tiltDirection.left": "ekhohlo",
    "boost.tiltDirection.right": "ekunene",
    "boost.tiltDirection.up": "phezulu",
    "boost.whenColor": "xa [COLOR] isitena siboniwe",
    "boost.whenTilted": "xa ikekelisiwe [TILT_DIRECTION_ANY] ",
    "ev3.beepNote": "ukuqaphle iBEEP [NOTE] kanga [TIME] mizuzwana",
    "ev3.buttonPressed": "iqosha [PORT] lIcofiwe?",
    "ev3.getBrightness": "Ukuqaqamba",
    "ev3.getDistance": "umgama",
    "ev3.getMotorPosition": "imoto [PORT] indawo",
    "ev3.motorSetPower": "imoto [PORT] lungiselela amadla [POWER] %",
    "ev3.motorTurnClockwise": "imoto [PORT] jonga ngapha [TIME] imizuzwana",
    "ev3.motorTurnCounterClockwise": "imoto [PORT] jongisa ngaphaya [TIME] mizuzwana",
    "ev3.whenBrightnessLessThan": "xa ukuqaqamba < [DISTANCE]",
    "ev3.whenButtonPressed": "xa iqosha [PORT] licofiwe",
    "ev3.whenDistanceLessThan": "xa umgama < [DISTANCE]",
    "gdxfor.getAcceleration": "ukwanda kwesantya [DIRECTION]",
    "gdxfor.getForce": "nyanzelisa",
    "gdxfor.getSpin": "jikelezisa isantya [DIRECTION]",
    "gdxfor.getTilt": "kekelisa iengile [TILT]",
    "gdxfor.isFreeFalling": "iyawa?",
    "gdxfor.isTilted": "kekele [TILT]?",
    "gdxfor.pulled": "tsalile",
    "gdxfor.pushed": "tyhalile",
    "gdxfor.shaken": "shukumiswe",
    "gdxfor.startedFalling": "qalise ukuwa",
    "gdxfor.tiltDirectionMenu.any": "nayiphi",
    "gdxfor.tiltDirectionMenu.back": "emva",
    "gdxfor.tiltDirectionMenu.front": "phambili",
    "gdxfor.tiltDirectionMenu.left": "ekhohlo",
    "gdxfor.tiltDirectionMenu.right": "ekunene",
    "gdxfor.turnedFaceDown": "jongise ubuso phantsi",
    "gdxfor.turnedFaceUp": "jongise ubuso phezulu",
    "gdxfor.whenForcePushedOrPulled": "xa isivo sinyanzeliso [PUSH_PULL]",
    "gdxfor.whenGesture": "xa [GESTURE]",
    "gdxfor.whenTilted": "xa ikekelisiwe [TILT]",
    "makeymakey.downArrow": "utolo oluphantsi",
    "makeymakey.downArrowShort": "phantsi",
    "makeymakey.leftArrow": "utolo olusekhohlo",
    "makeymakey.leftArrowShort": "ekhohlo",
    "makeymakey.rightArrow": "utolo olusekunene",
    "makeymakey.rightArrowShort": "ekunene",
    "makeymakey.spaceKey": "isithuba",
    "makeymakey.upArrow": "utolo oluphezulu",
    "makeymakey.upArrowShort": "phezulu",
    "makeymakey.whenKeyPressed": "xa [KEY] licofiwe",
    "makeymakey.whenKeysPressedInOrder": "xa [SEQUENCE] licofwe ngendlela",
    "microbit.buttonsMenu.any": "nayiphi",
    "microbit.clearDisplay": "ukubonisa okucacileyo",
    "microbit.defaultTextToDisplay": "Mholo",
    "microbit.displaySymbol": "Bonisa [MATRIX]",
    "microbit.displayText": "bonisa umbhalo [TEXT]",
    "microbit.gesturesMenu.jumped": "yatsiba",
    "microbit.gesturesMenu.moved": "isuile",
    "microbit.gesturesMenu.shaken": "shukunyisiwe",
    "microbit.isButtonPressed": "[BTN] qhosha licofiwe?",
    "microbit.isTilted": "kekele [DIRECTION]?",
    "microbit.pinStateMenu.off": "cimile",
    "microbit.pinStateMenu.on": "iyasebenza",
    "microbit.tiltAngle": "kekele i-engile [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "nayiphi",
    "microbit.tiltDirectionMenu.back": "emva",
    "microbit.tiltDirectionMenu.front": "phambili",
    "microbit.tiltDirectionMenu.left": "ekhohlo",
    "microbit.tiltDirectionMenu.right": "ekunene",
    "microbit.whenButtonPressed": "xa [BTN] iqhosha licofiwe",
    "microbit.whenGesture": "xa [GESTURE]",
    "microbit.whenPinConnected": "xa i-pini [PIN] Iqhagashelanisiwe",
    "microbit.whenTilted": "xa ikekele [DIRECTION]",
    "music.categoryName": "Umculo",
    "music.changeTempo": "guqula isantya nge [TEMPO]",
    "music.drumBass": "(2) Igubu lebass",
    "music.drumBongo": "(13) i-Bongo",
    "music.drumCabasa": "(15) i-Cabasa",
    "music.drumClaves": "(9) ii-claves",
    "music.drumClosedHiHat": "(6) Evaliweyo i-Hit-Hat",
    "music.drumConga": "(14) igubu",
    "music.drumCowbell": "(11) intsimbi yenkomo",
    "music.drumCrashCymbal": "(4) ngquba i-nkcenkce",
    "music.drumCuica": "(18) i-Cuica",
    "music.drumGuiro": "(16) i-Guiro",
    "music.drumHandClap": "(8) Ukuqhwatywa kwezandla",
    "music.drumOpenHiHat": "(5) Vula i-Hit-Hat",
    "music.drumSideStick": "(3) Ukhuni lwasecaleni ",
    "music.drumSnare": "(1) igubu le-snare",
    "music.drumTambourine": "(7) i-Tambourine",
    "music.drumTriangle": "(12) Unxantathu",
    "music.drumVibraslap": "(17) i-Vibraslap",
    "music.drumWoodBlock": "(10) istena seplanga",
    "music.getTempo": "isantya",
    "music.instrumentBass": "(6) i-Bass",
    "music.instrumentBassoon": "(14) i-Basson",
    "music.instrumentCello": "(8) i-Cello",
    "music.instrumentChoir": "(15) ikwayara",
    "music.instrumentClarinet": "(10) i-Clarinet",
    "music.instrumentElectricGuitar": "(5) ikatara yombane",
    "music.instrumentElectricPiano": "(2) ipiyano yombane",
    "music.instrumentFlute": "(12) ifluthi",
    "music.instrumentGuitar": "(4) Ikatara",
    "music.instrumentMarimba": "(19) Imarimba",
    "music.instrumentMusicBox": "(17) Ibhokisi yomculo",
    "music.instrumentOrgan": "(3) Iogan",
    "music.instrumentPiano": "(1) Ipiyano",
    "music.instrumentPizzicato": "(7) i-Pizzicato",
    "music.instrumentSaxophone": "(11) Ixilongo",
    "music.instrumentSteelDrum": "(18) igubu lentsimbi",
    "music.instrumentSynthLead": "(20) i-Synth ekhokelayo",
    "music.instrumentSynthPad": "(21) incwadana ye-Synth ",
    "music.instrumentTrombone": "(9) i-Trombone",
    "music.instrumentVibraphone": "(16) I-vibraphone",
    "music.instrumentWoodenFlute": "(13) i-flute yeplanga",
    "music.midiPlayDrumForBeats": "dlala igubu [DRUM] kule [BEATS] ",
    "music.midiSetInstrument": "lungiselela isixhobo ku [INSTRUMENT]",
    "music.playDrumForBeats": "dlala igubu [DRUM] kule [BEATS] ",
    "music.playNoteForBeats": "dlala isandi [NOTE] kule [BEATS] ",
    "music.restForBeats": "phumza i [BEATS] ",
    "music.setInstrument": "lungiselela isixhobo kwi [INSTRUMENT]",
    "music.setTempo": "lungiselela isantya [TEMPO]",
    "pen.categoryName": "Usiba",
    "pen.changeColorParam": "guqula usiba [COLOR_PARAM] nge [VALUE]",
    "pen.changeHue": "guqula umbala wesiba nge [HUE]",
    "pen.changeShade": "guqula usiba ngesithunzi [SHADE]",
    "pen.changeSize": "guqula usiba ngobungakanani [SIZE]",
    "pen.clear": "cima konke",
    "pen.colorMenu.brightness": "ukuqaqamba",
    "pen.colorMenu.color": "umbala",
    "pen.colorMenu.saturation": "izele",
    "pen.colorMenu.transparency": "ukubonakalisa kwelinye icala",
    "pen.penDown": "usiba phantsi",
    "pen.penUp": "usiba phezulu",
    "pen.setColor": "lungiselela umbala wosiba ube [COLOR]",
    "pen.setColorParam": "lungiselela usiba [COLOR_PARAM] ku [VALUE]",
    "pen.setHue": "lungiselela umbala wosiba ube [HUE]",
    "pen.setShade": "lungiselela isithinzi sosiba sibe [SHADE]",
    "pen.setSize": "lungiselela ubungakanani bosiba bube [SIZE]",
    "pen.stamp": "ngqisha",
    "speech.defaultWhenIHearValue": "masihambe",
    "speech.extensionName": "Intetho ibe ngumyalezo",
    "speech.listenAndWait": "mamela kwaye ulinde",
    "speech.speechReporter": "intetho",
    "speech.whenIHear": "xa ndisiva [PHRASE]",
    "text2speech.alto": "i-alto",
    "text2speech.categoryName": "umbhalo ubeyintetho",
    "text2speech.defaultTextToSpeak": "Mholo",
    "text2speech.giant": "isigebenga",
    "text2speech.kitten": "intshontsho lekati",
    "text2speech.setLanguageBlock": "lungisa ulwimi lube [LANGUAGE]",
    "text2speech.setVoiceBlock": "lungiselela ilizwi libe [VOICE]",
    "text2speech.speakAndWaitBlock": "thetha [WORDS]",
    "text2speech.squeak": "tswina",
    "text2speech.tenor": "i-tenor",
    "translate.categoryName": "Tolika",
    "translate.defaultTextToTranslate": "Mholo",
    "translate.translateBlock": "tolika [WORDS] abe [LANGUAGE]",
    "translate.viewerLanguage": "ulwimi",
    "videoSensing.categoryName": "Ukuva ividyo",
    "videoSensing.direction": "isalathiso",
    "videoSensing.motion": "intshukumo",
    "videoSensing.off": "icimile",
    "videoSensing.on": "iyasebenza",
    "videoSensing.onFlipped": "iguqulwe",
    "videoSensing.setVideoTransparency": "lungiselela ukubonisa kwelinye icala kwevidyo [TRANSPARENCY]",
    "videoSensing.sprite": "i-sprite",
    "videoSensing.stage": "iqonga",
    "videoSensing.videoOn": "ividiyo [ATTRIBUTE] malunga ne [SUBJECT]",
    "videoSensing.videoToggle": "guqula ividyo [VIDEO_STATE] ",
    "videoSensing.whenMotionGreaterThan": "xa ukushukuma kwevidyo > [REFERENCE]",
    "wedo2.getDistance": "umgama",
    "wedo2.getTiltAngle": "kwekelisa i-engile [TILT_DIRECTION]",
    "wedo2.isTilted": "ikekele [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "la ndlela",
    "wedo2.motorDirection.forward": "le ndlela",
    "wedo2.motorDirection.reverse": "buya umva",
    "wedo2.motorId.a": "imoto A",
    "wedo2.motorId.all": "zonke iimoto",
    "wedo2.motorId.b": "moto B",
    "wedo2.motorId.default": "imoto",
    "wedo2.motorOff": "jija [MOTOR_ID] icime",
    "wedo2.motorOn": "jija [MOTOR_ID] idume",
    "wedo2.motorOnFor": "jijaa [MOTOR_ID] idume [DURATION] yemizuzwana",
    "wedo2.playNoteFor": "dlala isandi [NOTE] ixesha [DURATION] mizuzwana",
    "wedo2.setLightHue": "lungiselela ukukhanya kombala kube [HUE]",
    "wedo2.setMotorDirection": "lungiselela i [MOTOR_ID] isalathiso sibe [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "lungiselela i [MOTOR_ID] amandla abe [POWER]",
    "wedo2.tiltDirection.any": "nayiphi",
    "wedo2.tiltDirection.down": "phantsi",
    "wedo2.tiltDirection.left": "ekhohlo",
    "wedo2.tiltDirection.right": "ekunene",
    "wedo2.tiltDirection.up": "phezulu",
    "wedo2.whenDistance": "xa umgama [OP] [REFERENCE]",
    "wedo2.whenTilted": "xa ikekele [TILT_DIRECTION_ANY] ",
    "paint.paintEditor.hue": "Umbala",
    "paint.paintEditor.saturation": "Ukugcwala",
    "paint.paintEditor.brightness": "Ukuqaqamba",
    "paint.paintEditor.costume": "Ikhostyum",
    "paint.paintEditor.group": "Iqela",
    "paint.paintEditor.ungroup": "Phasalakisa",
    "paint.paintEditor.undo": "Qhaqha",
    "paint.paintEditor.redo": "Yenza kwakhona",
    "paint.paintEditor.forward": "Phambili",
    "paint.paintEditor.backward": "Emva",
    "paint.paintEditor.front": "Ngaphambili",
    "paint.paintEditor.back": "emva",
    "paint.paintEditor.more": "Ngaphezulu",
    "paint.modeTools.brushSize": "Ubungakanani",
    "paint.modeTools.eraserSize": "Ubungakanani besicimi",
    "paint.modeTools.copy": "Khuphela",
    "paint.modeTools.paste": "Ncamathisela",
    "paint.modeTools.delete": "Cima",
    "paint.modeTools.curved": "Inamagophe",
    "paint.modeTools.pointed": "Yolathe",
    "paint.modeTools.thickness": "Ubungqindilili",
    "paint.modeTools.flipHorizontal": "Guqula ububanzi",
    "paint.modeTools.flipVertical": "Guqula ubunzulu",
    "paint.modeTools.filled": "Ugcwalise",
    "paint.modeTools.outlined": "Uyicacise nzulu",
    "paint.paintEditor.bitmap": "Qhagamshela ku-Bitmap",
    "paint.paintEditor.vector": "Guqula ibe yi- Vector",
    "paint.paintEditor.fill": "Gcwalisa",
    "paint.paintEditor.stroke": "Cacisa nzulu",
    "paint.brushMode.brush": "Phulula",
    "paint.eraserMode.eraser": "Isixhobo sokucima",
    "paint.fillMode.fill": "Gcwalisa",
    "paint.lineMode.line": "Umgca",
    "paint.ovalMode.oval": "Isangqa",
    "paint.rectMode.rect": "Ixande",
    "paint.reshapeMode.reshape": "Milisa okutsha",
    "paint.roundedRectMode.roundedRect": "Unxantathu owenziwe ronte",
    "paint.selectMode.select": "Khetha",
    "paint.textMode.text": "Umbhalo",
    "paint.colorPicker.swap": "Tshintsha"
  },
  "zu": {
    "gui.alerts.lostPeripheralConnection": "uScratch uhlulekile ukudonsa ku{extensionName}.",
    "gui.alerts.tryAgain": "Zama futhi",
    "gui.alerts.download": "Downloda  gcina manje",
    "gui.connection.reconnect": "Hlanganisa kabusha",
    "gui.backpack.costumeLabel": "imvunulo",
    "gui.backpack.soundLabel": "umsindo",
    "gui.backpack.scriptLabel": "umbhalo",
    "gui.backpack.spriteLabel": "umlingisi",
    "gui.backpack.header": "Isikhwama",
    "gui.backpack.errorBackpack": "Kukhona okungalungile ekufakeni ibackpack",
    "gui.backpack.loadingBackpack": "Kusangena...",
    "gui.backpack.more": "Okunye",
    "gui.backpack.emptyBackpack": "iBackpack ayinalutho",
    "gui.unsupportedBrowser.label": "Ibrowza ayisekeliwe",
    "gui.unsupportedBrowser.errorLabel": "Sekwenzeke iphutha ",
    "gui.unsupportedBrowser.notRecommended": "Siyaxolisa kakhulu sibona ukuthi uhlelo leBrowser oyisebenzisayo ayisaphothi, Sibona kungcono ukuthi uyikhuphule ngoGoogle Chrome Mozilla Firefox, Microsoft Edge noma Apple Safari.",
    "gui.unsupportedBrowser.description": "Siyaxolisa kakhulu kodwa uScratch awulamukeli uhlelo lwakho leBrowser sicela uzame amanye ama browser kungaba uGoogle Chrome, Mozilla Firefox, Microsoft Edge noma Apple safari ",
    "gui.unsupportedBrowser.back": "Emuva",
    "gui.unsupportedBrowser.previewfaq": "Ukufunda kabanzi, hamba uye {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "AmaTutorials",
    "gui.cards.shrink": "Nciphisa",
    "gui.cards.expand": "Kwandise ",
    "gui.cards.close": "Vala",
    "gui.cards.more-things-to-try": "Okunye okuningi eningakuzama",
    "gui.cards.see-more": "Buka okunye",
    "gui.comingSoon.message1": "Sisebenza kona kuyimanje {emoji}",
    "gui.comingSoon.message2": "Kuyeza Maduzane...",
    "gui.comingSoon.message3": "Sisebenza kona kuyimanje {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Akukho maDevice atholiwe",
    "gui.connection.auto-scanning.prescan": "Idevice ayibeseduza ukuqala ukusesha.",
    "gui.connection.auto-scanning.pressbutton": "Cindezela inkinombo kwi device yakho",
    "gui.connection.auto-scanning.start-search": "Qala useshe",
    "gui.connection.connecting-searchbutton": "Sisasesha...",
    "gui.connection.auto-scanning.try-again": "Phinda uzame",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Sekuxhumekile",
    "gui.connection.disconnect": "Akuxhumekile",
    "gui.connection.go-to-editor": "Hamba uye Kumhleli",
    "gui.connection.connecting-cancelbutton": "Siyayixhuma...",
    "gui.connection.error.errorMessage": "Oops, kubukeka kungathi khona okungalungile.",
    "gui.connection.error.tryagainbutton": "Phinda uzame",
    "gui.connection.error.helpbutton": "Usizo",
    "gui.connection.peripheral-name-label": "Igama leDevice",
    "gui.connection.connect": "Xhuma",
    "gui.connection.scanning.lookingforperipherals": "Sibheka amaDevices",
    "gui.connection.scanning.noPeripheralsFound": "Akukho maDevice atholiwe",
    "gui.connection.scanning.instructions": "Khetha iDevice kulawa akhona",
    "gui.connection.search": "Lungisa kabusha",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Yenza isiqiniseko ukuthi iScratch Link ifakiwe futhi iyasebenza",
    "gui.connection.unavailable.enablebluetooth": "Bheka iBluetooth ukuthi ivumelekile",
    "gui.connection.unavailable.tryagainbutton": "Phinda uzame",
    "gui.connection.unavailable.helpbutton": "Usizo",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Hamba",
    "gui.controls.stop": "Ima",
    "gui.crashMessage.label": "Oops! Khona okungalungile",
    "gui.crashMessage.description": "Siyaxolisa, kubukeka sengathi uScratch unenkinga. Lenkinga isizithumele ngokwayo ethimbeni lika Scratch. Phinda uqale kabusha uzame futhi. ",
    "gui.crashMessage.errorNumber": "Iphutha lakho lingeniswe kuID {errorId}",
    "gui.crashMessage.reload": "Asiphinde sigcwalise",
    "gui.customProcedures.myblockModalTitle": "Enza amabhulokisi",
    "gui.customProcedures.addAnInputNumberText": "Faka ngegalelo",
    "gui.customProcedures.numberTextType": "Inamba noma umbhalo",
    "gui.customProcedures.addAnInputBoolean": "Faka  ngegalelo",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Faka i-label",
    "gui.customProcedures.runWithoutScreenRefresh": "Baleka ngaphandle kokuvuselela isikrini",
    "gui.customProcedures.cancel": "Cima",
    "gui.customProcedures.ok": "Kulungile",
    "gui.SpriteInfo.direction": "Indlela",
    "gui.directionPicker.rotationStyles.allAround": "Yonke indawo",
    "gui.directionPicker.rotationStyles.leftRight": "isinxele-nangakwesokudla",
    "gui.directionPicker.rotationStyles.dontRotate": "Ungayiphenduli",
    "gui.gui.addExtension": "Faka okokunezelela ",
    "gui.gui.codeTab": "Ikhodi",
    "gui.gui.backdropsTab": "Izindawo",
    "gui.gui.costumesTab": "Izimpahla",
    "gui.gui.soundsTab": "Imisindo",
    "gui.extensionLibrary.comingSoon": "Kuyeza Maduzane...",
    "gui.extensionLibrary.requires": "Okudingekayo",
    "gui.extensionLibrary.collaboration": "Ngokuhambisana ne",
    "gui.library.filterPlaceholder": "Cinga",
    "gui.library.allTag": "Yonke",
    "gui.loader.message1": "Asakheni amabhulokisi ...",
    "gui.loader.message2": "Kungena umlingisi ...",
    "gui.loader.message3": "Kungena umsindo ...",
    "gui.loader.message4": "Isaloda ukulula ...",
    "gui.loader.message5": "Herding cats ...",
    "gui.loader.message6": "Transmitting nanos ...",
    "gui.loader.message7": "Inflating gobos ...",
    "gui.loader.message8": "Silungisa amaEmojis ...",
    "gui.loader.headline": "Kungena iProject",
    "gui.loader.creating": "Akha iprojekthi",
    "gui.accountMenu.profile": "Ubuwena",
    "gui.accountMenu.myStuff": "Izinto zami",
    "gui.accountMenu.myClasses": "Ikilasi lami",
    "gui.accountMenu.myClass": "Ikilasi lami",
    "gui.accountMenu.accountSettings": "Lungisa iakhawunti",
    "gui.accountMenu.signOut": "Phuma",
    "gui.authorInfo.byUser": "yenziwe ngu {username}",
    "gui.menuBar.seeProjectPage": "Bona ikhasi leprojekthi",
    "gui.menuBar.language": "Language",
    "general.username": "Isidlaliso",
    "general.password": "Iphasiwedi",
    "general.signIn": "Ngena ngemvume",
    "login.needHelp": "Udingnsizo?",
    "form.validationRequired": "Lenkundla iyadingeka",
    "gui.menuBar.tutorialsLibrary": "AmaTutorials",
    "gui.menuBar.restoreSprite": "Buyisela Umlingisi",
    "gui.menuBar.restoreSound": "Buyisela Umsindo",
    "gui.menuBar.restoreCostume": "Buyisela Impahla",
    "gui.menuBar.restore": "Buyisela",
    "gui.menuBar.saveNow": "Gcina manje",
    "gui.menuBar.saveAsCopy": "Gcina njenge khophi",
    "gui.menuBar.remix": "Ingxube",
    "gui.menuBar.new": "Entsha",
    "gui.menuBar.file": "Ifayela",
    "gui.menuBar.downloadToComputer": "Gcina kweyakho ikhomputha",
    "gui.menuBar.edit": "Lungisa",
    "gui.menuBar.turboModeOff": "Vala ithebho modi",
    "gui.menuBar.turboModeOn": "Vula ithebho modi",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Hlanganisa Scratch",
    "gui.menuBar.signIn": "Ngena ngemvume",
    "gui.gui.projectTitlePlaceholder": "Isihloko se-Projecti lana",
    "gui.menuBar.saveNowLink": "Gcina manje",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "uPhiwe",
    "gui.menuBar.share": "Yipha",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Usizo",
    "gui.modal.back": "Emuva",
    "gui.monitor.listMonitor.empty": "(akukho)",
    "gui.monitor.listMonitor.listLength": "ubude {length}",
    "gui.monitor.contextMenu.default": "okujwayelekile bomphumelo",
    "gui.monitor.contextMenu.large": "ubukhulu bomphumelo",
    "gui.monitor.contextMenu.slider": "shibilika",
    "gui.monitor.contextMenu.sliderRange": "Shitsha iSlider ukuyaphansi/ukuyaphezulu ",
    "gui.monitor.contextMenu.import": "ngenisa",
    "gui.monitor.contextMenu.export": "isithumela",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Dlala",
    "gui.playButton.stop": "Ima",
    "gui.gui.variableScopeOptionAllSprites": "Ngabo bonke omlingisi",
    "gui.gui.variableScopeOptionSpriteOnly": "Ngalomlingsi kuphela",
    "gui.gui.cloudVariableOption": "I-khlawudi variyabhulI (ibekwe kwiseva )",
    "gui.gui.variablePromptAllSpritesMessage": "Lokuguquka kwenzeke kubo bonke",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cima",
    "gui.prompt.ok": "Kulungile",
    "gui.playbackStep.stopMsg": "Ima",
    "gui.playbackStep.playMsg": "Dlala",
    "gui.playbackStep.loadingMsg": "Kusangena...",
    "gui.playbackStep.saveMsg": "Gcina",
    "gui.playbackStep.reRecordMsg": "Phinda urekhode",
    "gui.recordModal.title": "Rekhoda umsindo",
    "gui.recordingStep.beginRecord": "Qala ukuqoda ngokuchofoza inkinobho",
    "gui.recordingStep.permission": "{arrow} Sidinga imvume yakho ukusebenzisa imicrophone yakho",
    "gui.recordingStep.stop": "Ima ukurekhoda",
    "gui.recordingStep.record": "Qopha",
    "gui.sliderModal.min": "Ivelu engaphansi ",
    "gui.sliderModal.max": "Ivelu engaphezulu ",
    "gui.sliderModal.title": "Shitsha Islider ukuyaphansi/ukuyaphezulu",
    "gui.sliderPrompt.cancel": "Cima",
    "gui.sliderPrompt.ok": "Kulungile",
    "gui.soundEditor.sound": "Umsindo",
    "gui.soundEditor.play": "Dlala",
    "gui.soundEditor.stop": "Ima",
    "gui.soundEditor.copy": "Khopisha",
    "gui.soundEditor.paste": "Namathisela",
    "gui.soundEditor.copyToNew": "Kopisha kuyekokusha ",
    "gui.soundEditor.delete": "Susa",
    "gui.soundEditor.save": "Gcina",
    "gui.soundEditor.undo": "Yenza kabusha",
    "gui.soundEditor.redo": "Ukwenzakabusha",
    "gui.soundEditor.faster": "Shesha",
    "gui.soundEditor.slower": "Kacane",
    "gui.soundEditor.echo": "Ukunanela",
    "gui.soundEditor.robot": "Robhothi",
    "gui.soundEditor.louder": "Kakhulu",
    "gui.soundEditor.softer": "Kuthambile",
    "gui.soundEditor.reverse": "Hlehlisa emumva",
    "gui.soundEditor.fadeOut": "Ukuwehlisa umsindo ",
    "gui.soundEditor.fadeIn": "Ukukhuphula umsindo",
    "gui.soundEditor.mute": "Awuthule umsindo ",
    "gui.SpriteInfo.spritePlaceholder": "Igama",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Umlingisi",
    "gui.SpriteInfo.show": "Khombisa",
    "gui.SpriteInfo.size": "Isisindo",
    "gui.spriteSelectorItem.contextMenuDuplicate": "fanisa",
    "gui.spriteSelectorItem.contextMenuExport": "isithumela",
    "gui.spriteSelectorItem.contextMenuDelete": "khipha",
    "gui.spriteSelector.addSpriteFromLibrary": "Khetha Umlingisi",
    "gui.spriteSelector.addSpriteFromPaint": "Penda",
    "gui.spriteSelector.addSpriteFromSurprise": "Isimanga",
    "gui.spriteSelector.addSpriteFromFile": "Faka Umlingisi",
    "gui.stageHeader.stageSizeLarge": "Shintshela kwinkundla enkulu",
    "gui.stageHeader.stageSizeSmall": "Shintshela kwinkundla encane",
    "gui.stageHeader.stageSizeFull": "Ngena kwindlela ezolula isikhrini sibe sikhula",
    "gui.stageHeader.stageSizeUnFull": "Phma kwindlela elula iskhrini sibe sikhulu",
    "gui.stageHeader.fullscreenControl": "Indlela egcwele yokulawula isinkrini",
    "gui.spriteSelector.addBackdropFromLibrary": "Khetha Indawo",
    "gui.stageSelector.addBackdropFromPaint": "Penda",
    "gui.stageSelector.addBackdropFromSurprise": "Isimanga",
    "gui.stageSelector.addBackdropFromFile": "Faka Indawo",
    "gui.stageSelector.stage": "Isiteji",
    "gui.stageSelector.backdrops": "Izindawo",
    "gui.telemetryOptIn.label": "Sitshele ngemiphumela ukuze uthuthukise ukusebenzisa kwakho uScratch ",
    "gui.telemetryOptIn.body1": "Ithimu Scratch ihlale ifuna izindlela ezingcono zokufundisa ukuthi uScratch usetshenziswa kanjani emhlabeni wonke. Ukubalekelela emfuthweni  abanawo, Ungakwazi ukuvumela uScratch ukuthi uthumele imilayezo ngimeninigwane yakho ngokusebenzisa uScratch kuyo iScratch Thimu ",
    "gui.telemetryOptIn.body2": "Ulwazi esiluqoqile liphethe lapho ongakhetha khona uhlobo lolwimi, ukusentshenziswa kwamabhulokisi nokunye okwenzakalayo njengoku beka ukufaka iPhrojethi. ASIVUMI Ukuqoqa ulwazi lwangasese lomuntu. Sicela ubone {privacyPolicyLink} ukuthola eminye imininigwane ",
    "gui.telemetryOptIn.privacyPolicyLink": "Ngasese umgomo",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Sheshisa Indlela",
    "gui.webglModal.label": "iBrowser yakho ayisekeli iWebGL",
    "gui.webglModal.description": "Ngeshwa kubukeka yakho khomphuta noma browza {webGlLink}. Lobu buchwepheshe buyadinge ukuze uScratch 3.0 asebenze",
    "gui.webglModal.webgllink": "Ayisekeli iWebGL",
    "gui.webglModal.back": "Emuva",
    "gui.webglModal.previewfaq": "Ukufunda kabanzi, hamba uye {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Khetha Indawo",
    "gui.costumeLibrary.chooseACostume": "Khetha impahla",
    "gui.costumeTab.addBackdropFromLibrary": "Khetha Indawo",
    "gui.costumeTab.addCostumeFromLibrary": "Khetha impahla",
    "gui.costumeTab.addBlankCostume": "Penda",
    "gui.costumeTab.addSurpriseCostume": "Isimanga",
    "gui.costumeTab.addFileBackdrop": "Faka Indawo",
    "gui.costumeTab.addFileCostume": "Faka Impahla",
    "gui.extensionLibrary.chooseAnExtension": "Khetha Isiluli",
    "gui.extensionLibrary.extensionUrl": "Faka iURL yokulula",
    "gui.monitors.importListColumnPrompt": "Iyiphi ikholumu ekufanele isentshenziswe (1-{numberOfColumns})? ",
    "gui.recordingStep.alertMsg": "Ayikwazi ukuqola ukuqopha",
    "gui.soundLibrary.chooseASound": "Khetha Umsindo",
    "gui.soundTab.fileUploadSound": "Faka Umsindo",
    "gui.soundTab.surpriseSound": "Isimanga",
    "gui.soundTab.recordSound": "Qopha",
    "gui.soundTab.addSoundFromLibrary": "Khetha Umsindo",
    "gui.spriteLibrary.chooseASprite": "Khetha Umlingisi",
    "gui.tipsLibrary.tutorials": "Khetha iTutorial",
    "gui.alerts.createsuccess": "Iprojekthi entsha yakhiwe",
    "gui.alerts.createcopysuccess": "Iprojekthi igcinwe njengkhophi",
    "gui.alerts.createremixsuccess": "Iprojekthi igcinwe njengomxubo",
    "gui.alerts.creating": "Akha entsha...",
    "gui.alerts.creatingCopy": "Kopisha iprojekthi...",
    "gui.alerts.creatingRemix": "Ukuxutshwa kweprojekthi",
    "gui.alerts.creatingError": "Akukwazanga ukwakha iprojekthi. Cela uzama futhi!",
    "gui.alerts.savingError": "iprojekthi ayigcinekanga",
    "gui.alerts.savesuccess": "Iyagcina iprojekthi.",
    "gui.alerts.saving": "Gcina umsebenzi...",
    "gui.alerts.cloudInfo": "Cela wazi, uluthi i-cloud variable isekela izinombolo, hhayi izinhlamvu noma amasimbholi {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Funda kabanzi.",
    "gui.alerts.importing": "Ukungenisa...",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "i-variable yami",
    "gui.howtos.intro-move-sayhello-hat.name": "Sesizoqala",
    "gui.howtos.intro-move.step_stepMove": "Faka  ibhulokisi lokunyakaza",
    "gui.howtos.add-a-move-block.step_stepSay": "Engeza iblokhi yokusho",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Chofoza ifulegi eluhlaza okotshani ukuze uqale",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Yenza igama elinyakazayo",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Khetha umlingisi oyigama",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Dlala umsindo uma uchofoziwe ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Khetha elinye igama elizoba umlingisi",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Shintsha umbala",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Khetha elinye igama lomlingisi iuliphendule",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Khetha elinye igama lomlingisi iulikhulise",
    "gui.howtos.imagine": "Cabanga Izwe",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Kubhale Ofuna Ukukusho ",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Chofoza ifulegi eluhlaza okotshani ukuze uqale",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Khetha Noma Yikuphi Kwasemuva ",
    "gui.howtos.imagine.step_imagineChooseSprite": "Khetha Noma Imuphi Umlingisi ",
    "gui.howtos.imagine.step_imagineFlyAround": "Cindezela Isikhala Sokhiye Undize ",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Khetha omunye umlingisi ",
    "gui.howtos.imagine.step_imagineLeftRight": "Nyakaza kwesobunxele-nakwesokudla ",
    "gui.howtos.imagine.step_imagineUpDown": "Nyakaza ukuyaphezulu- nokuyaphansi ",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Shitsha Izimpahla ",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Ndiza uyekuleli Phoyinti ",
    "gui.howtos.imagine.step_imagineGrowShrink": "Khulisa futhi Unciphise",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Khetha  Enye Ingamuva",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Shintsha Ingamuva",
    "gui.howtos.imagine.step_imagineRecordASound": "Engeza Umsindo ",
    "gui.howtos.imagine.step_imagineChooseSound": "Khetha Owakho Umsindo ",
    "gui.howtos.make-music.name": "Wenze Umculo",
    "gui.howtos.Make-Music.step_PickInstrument": "Khetha umlingisi oyi instrumenti",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Dlala umsindo uma uchofoziwe ",
    "gui.howtos.Make-Music.step_MakeSong": "Sungula Iculo",
    "gui.howtos.make-music.step_MakeBeat": "Khetha idlamu mase wenza ibhithi",
    "gui.howtos.make-music.step_MakeBeatBox": "Khetha umlingiswa wemykrofoni neBeatbox ethusayo",
    "gui.howtos.story.name": "Akha indaba",
    "gui.howtos.story.step_addbg": "Faka Indawo ",
    "gui.howtos.story.step_addsprite": "Faka umlingiswa",
    "gui.howtos.story.step_saysomething": "Yisho Okuthize",
    "gui.howtos.story.step_addanothersprite": "Faka omunye umlingisi",
    "gui.howtos.story.step_flip": "Shintsha indlela",
    "gui.howtos.story.step_conversation": "Iba nengxoxo",
    "gui.howtos.story.addanotherbg": "Faka enye indawo",
    "gui.howtos.story.step_swithbg": "Shintsha izindawo",
    "gui.howtos.story.step_hidewizard": "Fihla umlingiswa",
    "gui.howtos.story.step_showwizard": "Veza umlingiswa",
    "gui.howtos.make-a-chase-game.name": "Enza Umdlalo Wokujahha",
    "gui.howtos.Chase-Game.step_BG": "Nezelela Indawo ",
    "gui.howtos.chase-game.step_AddOcto": "Faka  umlingisi",
    "gui.howtos.make-music.step_LeftRight": "Yiya kwesokudla nakwesokunxele ngomcibisholo",
    "gui.howtos.Chase-Game.step_UpDown": "Yiya phezulu naphansi ngomcibisholo",
    "gui.howtos.Chase-Game.step_AddStar": "Faka omunye umlingisi ",
    "gui.howtos.Chase-Game.step_MoveRandom": "Nyakaza noma ikephi",
    "gui.howtos.Chase-Game.step_WhenTouch": "Kumlingisi weoctopus uma uthinta dlala umsindo",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Yenza ivariabuli yescore",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Mothinta umlingisi Octopus nezelela isko",
    "gui.howtos.animate-char.name": "Nyakazisa umlingiswa",
    "gui.howtos.animate-char.step_addbg": "Faka Indawo ",
    "gui.howtos.animate-char.step_addsprite": "Faka Nomlingisi ",
    "gui.howtos.animate-char.step_saysomething": "Yisho Okuthize",
    "gui.howtos.animate-char.step_addsound": "Faka umsindo",
    "gui.howtos.animate-char.step_animatetalking": "Nyakazisa inkulumo",
    "gui.howtos.animate-char.step_arrowkeys": "Nyakazisa ngokusebenzisa okhiye bomcibilisholo ",
    "gui.howtos.animate-char.step_jump": "Gxuma",
    "gui.howtos.animate-char.step_changecolor": "Shintsha Umbala",
    "gui.howtos.make-a-game.name": "Enza Umdlalo Wokuchofoza",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Khetha Umlingisi",
    "gui.howtos.make-a-game.step_GamePlaySound": "Dlala umsindo uma uchofoziwe ",
    "gui.howtos.make-a-game.step_GameAddScore": "Yenza ivariabuli yescore",
    "gui.howtos.make-a-game.step_GameChangeScore": "Makuchofozwe akunyuke isko.  ",
    "gui.howtos.make-a-game.step_Random": "Hamba indawo engajwayelekile",
    "gui.howtos.make-music.step_GameChangeColor": "Shintsha Umbala",
    "gui.howtos.make-music.step_ResetScore": "Qalaphansi Isko",
    "gui.howtos.make-it-fly.name": "Yenza indize",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Khetha indawo eluhlaza okwesibhakabhaka ",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Khetha umlingisi ",
    "gui.howtos.fly.step_stepflySaySomething": " Isho Okuthile",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Nyakaza ngokusebenzisa okhiye bemicibilisholo ",
    "gui.howtos.fly.step_stepflyChooseObject": "Khetha Into ozoyiqoqa ",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Enzakunyakaze into   ",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Khetha umlingisi wakho  ",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Faka amaphuzu ",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Gcina Amaphuzu",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Faka indawo ",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Nyakazisa  indawo ",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Impahla elandelayo ",
    "gui.howtos.pong": "Umdlalo wePong ",
    "gui.howtos.pong.step_pongAddBackdrop": "Faka Indawo ",
    "gui.howtos.pong.step_pongAddBallSprite": "Faka ibhola lomlingisi ",
    "gui.howtos.pong.step_pongBounceAround": "Gxuma yonke indawo ",
    "gui.howtos.pong.step_pongAddPaddle": "Faka i-paddle ",
    "gui.howtos.pong.step_pongMoveThePaddle": "Nyakazisa I-Paddle ",
    "gui.howtos.pong.step_pongSelectBallSprite": "Khetha ibhola lomlingisi ",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Phinda ngokufaka ikhodi ukuze ibhola ligxume malithinta i-paddle ",
    "gui.howtos.pong.step_pongAddAScore": "Faka amaphuzu ",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Khetha 'Amaphuzu' kwi-Menu ",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Faka bhulokisi 'Shitsha amaphuzu' ",
    "gui.howtos.pong.step_pongResetScore": "Qalaphansi Isko",
    "gui.howtos.pong.step_pongAddLineSprite": "Faka umlingisi owulayini. ",
    "gui.howtos.pong.step_pongGameOver": "Uphelile umdlalo ",
    "gui.howtos.code-cartoon": "Khoda Ikhathoni",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Yisho Okuthile Lapho Uchofozo Ifulegi Eluhlaza okotshani ",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Nyakazisa Umlingisa Lapho Umchofoza",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Khetha Umlingisi Ohlukile",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Sebenzisa Uphawu Lokukhipha Ukuthola Okuncane",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Yenza Umlingisi Akhule bese Unciphisa",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Khetha Umlingisi Ohlukile",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Gxuma Uye Phezulu Naphansi",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Chofoza Umlingisi Ukushintsha Izindawo",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Ndiza  Yonke Indawo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Shitsha Izimpahla",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Khetha Abalingisi Abaningi Ukwengeza Kukhathoni Lakho",
    "gui.howtos.cartoon-network": "Zakhele iGame yakho",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kheta umlingisi ozomkhombisa",
    "gui.howtos.cartoon-network.step_CNsay": "Yisho Okuthize",
    "gui.howtos.cartoon-network.step_CNglide": "Kekela yonke indawo",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kheta into ozoyijahha",
    "gui.howtos.cartoon-network.step_CNcollect": "Qoqa izinto",
    "gui.howtos.cartoon-network.step_CNvariable": "Yenza i-variable yescore",
    "gui.howtos.cartoon-network.step_CNscore": "Gcina Amaphuzu",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Izinga Eliphezulu: Shintsha Indawo",
    "gui.howtos.videosens.name": "Ividiyo yesithombemagama",
    "gui.howtos.videosens.step_addextension": "Ukulula",
    "gui.howtos.videosens.step_pet": "Fuya ikati",
    "gui.howtos.videosens.step_animate": "Nyakazisa",
    "gui.howtos.videosens.step_pop": "Qhumisa ibhelunde",
    "gui.howtos.say-it-out-loud": "Yenza Upopayi Okhulumayo",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Yengeza umbhalo kwibhulokisi lenkulumo",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Yisho Okuthize",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Lungisa izwi",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Nyakaza",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Nezelela Indawo ",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Faka omunye umlingisi",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Yenza iculo",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Shintsha Umbala",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Jikeleza",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Khulisa futhi unciphise",
    "gui.howtos.talking": "Izinganekwane Ezikhulumayo",
    "gui.howtos.talking.step_talesAddExtension": "Chofoza ukuze Wengeze Umbhalo Kumablokhi Enkulumo",
    "gui.howtos.talking.step_talesChooseSprite": "Khetha Umlingisi",
    "gui.howtos.talking.step_talesSaySomething": "Yenza Umlingisi Akhulume",
    "gui.howtos.talking.step_talesChooseBackdrop": "Khetha Indawo Yasemuva",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Chofoza Umlingisi ukuze Uye Endaweni Elandelayo Yasemuva",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Khetha Omunye Umlingisi ",
    "gui.howtos.talking.step_talesMoveAround": "Zulazula",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Khetha  Enye Indawo Yasemuva",
    "gui.howtos.talking.step_talesAnimateTalking": "Vusa Ukukhuluma",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Khetha  Enye Indawo Yasemuva",
    "gui.howtos.talking.step_talesChooseSound": "Khatha Ingoma Ozoyidansela",
    "gui.howtos.talking.step_talesDanceMoves": "Yangakazisa Ukudansa ",
    "gui.howtos.talking.step_talesAskAnswer": "Thola Amabloki Okubuza Nezimpndulo ku-Sensing Category",
    "gui.howtos.add-sprite.name": "Faka  umlingisi",
    "gui.howtos.add-sprite.step_addSprite": "Faka  umlingisi",
    "gui.howtos.add-a-backdrop.name": "Faka  Indawo  ",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Faka Indawo ",
    "gui.howtos.change-size.name": "Shintsha Uzayizi",
    "gui.howtos.change-size.step_changeSize": "Shintsha Uzayizi",
    "gui.howtos.glide-around.name": "Kekela yonke indawo",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Shibilika  yonke indawo",
    "gui.howtos.change-size.step_glideAroundPoint": "Shibilikisa ukuyise kuleli phoyinti ",
    "gui.howtos.record-a-sound.name": "Qopha Umsindo",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klikha ithebhu yomsindo ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikhi 'Ukuqhopha' ",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Cindezela inkinobho yokuqhopha ",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Khetha owakho umsindo ",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Dlala umsindo wakho",
    "gui.howtos.spin-video.name": "Yenze Iphenduke",
    "gui.howtos.change-size.step_spinTurn": "Jika ",
    "gui.howtos.change-size.step_spinPointInDirection": "Hlela indlela ",
    "gui.howtos.hide-and-show.name": "Cashisa uphinde ukhombise ",
    "gui.howtos.change-size.step_hideAndShow": "Cashisa uphinde ukhombise ",
    "gui.howtos.switch-costume.name": "Yenza upopayi womlingisi",
    "gui.howtos.change-size.step_switchCostumes": "Enza umlingisi wakho aphile ",
    "gui.howtos.move-around-with-arrow-keys.name": "Sebenzisa Umcibisholo Okhiye",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Nyakaza kwesobunxele nakwe sokudla ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Nyakaza Phezulu futhi Naphansi ",
    "gui.howtos.add-effects.name": "Faka  Imithelela",
    "gui.howtos.videosens.step_addEffects": "Faka Imithelela",
    "gui.extension.music.name": "uMculo",
    "gui.extension.music.description": "Dlala isikhali kanye nam dilamu",
    "gui.extension.pen.name": "Ipeni",
    "gui.extension.pen.description": "Dweba nabalingisibakho",
    "gui.extension.videosensing.name": "Ukubona ividiyo",
    "gui.extension.videosensing.description": "Izwa ukunyakaza ngeKhamera",
    "gui.extension.text2speech.name": "Bhala kwinkulumo",
    "gui.extension.text2speech.description": "Yenza iProject yakho ikhulume",
    "gui.extension.translate.name": "Humusha",
    "gui.extension.translate.description": "Shintsela umbhalo kwezinye izilimu",
    "gui.extension.makeymakey.description": "Yenza noma yini ibe ukhiye.",
    "gui.extension.microbit.description": "Xhumanisa amaProject akho nomhlaba",
    "gui.extension.microbit.connectingMessage": "Siyayixhuma",
    "gui.extension.ev3.description": "Yakha amaRobhothi akwaziyo ukukhuluma nokunye",
    "gui.extension.ev3.connectingMessage": "Isaxhumanisa. Qinisekisa ukuthi ipin ekuEV3 isethiwe ku1234.",
    "gui.extension.boost.description": "Ukuletha izakhiwo zama ROBOTS empilweni ",
    "gui.extension.boost.connectingMessage": "Kuyaxhumana",
    "gui.extension.wedo2.description": "Yakha ngemishini kanye nezinhloli",
    "gui.extension.wedo2.connectingMessage": "Kuyaxhumana",
    "gui.extension.gdxfor.description": "Sensa ukuphusha, ukudonsa, ukunyakaza noku spina ",
    "gui.extension.gdxfor.connectingMessage": "Kuyaxhumana",
    "gui.libraryTags.all": "Yonke",
    "gui.libraryTags.animals": "Izilwane",
    "gui.libraryTags.dance": "Dansa",
    "gui.libraryTags.effects": "Imithelela",
    "gui.libraryTags.fantasy": "Uphupha/Ubuhle",
    "gui.libraryTags.fashion": "Imfashini",
    "gui.libraryTags.food": "Ukudla",
    "gui.libraryTags.indoors": "Ngaphakathi",
    "gui.libraryTags.loops": "Amaluphu",
    "gui.libraryTags.music": "uMculo",
    "gui.libraryTags.notes": "Amanothi",
    "gui.libraryTags.outdoors": "Ngaphandle",
    "gui.libraryTags.patterns": "Iphethini",
    "gui.libraryTags.people": "Abantu",
    "gui.libraryTags.percussion": "Idilamu Lomculo",
    "gui.libraryTags.space": "Isikhala",
    "gui.libraryTags.sports": "Imidlalo",
    "gui.libraryTags.underwater": "Ngaphansi kwamanzi",
    "gui.libraryTags.voice": "Izwi",
    "gui.libraryTags.wacky": "Engasile ",
    "gui.libraryTags.animation": "Khathuni",
    "gui.libraryTags.art": "Imidwebo",
    "gui.libraryTags.games": "Umdlalo",
    "gui.libraryTags.stories": "Izindaba",
    "gui.libraryTags.letters": "Izinhlamvu",
    "gui.opcodeLabels.direction": "indlela",
    "gui.opcodeLabels.xposition": "x indlela yokuma",
    "gui.opcodeLabels.yposition": "y indlela yokuma",
    "gui.opcodeLabels.size": "isisindo",
    "gui.opcodeLabels.costumename": "igama lempahla",
    "gui.opcodeLabels.costumenumber": "Inamba yempahla",
    "gui.opcodeLabels.backdropname": "igama lendawo",
    "gui.opcodeLabels.backdropnumber": "Inamba indawo",
    "gui.opcodeLabels.volume": "umsindo",
    "gui.opcodeLabels.tempo": "izinsimbi",
    "gui.opcodeLabels.answer": "phendula",
    "gui.opcodeLabels.loudness": "umsindo omkhulu",
    "gui.opcodeLabels.username": "igama elisebenzile",
    "gui.opcodeLabels.year": "unyaka",
    "gui.opcodeLabels.month": "inyanga",
    "gui.opcodeLabels.date": "usuku",
    "gui.opcodeLabels.dayofweek": "usuku lwesonto",
    "gui.opcodeLabels.hour": "ihora",
    "gui.opcodeLabels.minute": "umzuzu",
    "gui.opcodeLabels.second": "umzuzwana",
    "gui.opcodeLabels.timer": "iwashi elicushiwe",
    "gui.projectLoader.loadError": "Ifayela yaleprojekthiebikhethiwe ihlulekile ukuloda",
    "gui.sharedMessages.backdrop": "Indawo{index}",
    "gui.sharedMessages.costume": "Impahla{index}",
    "gui.sharedMessages.sprite": "Umlingisi{index}",
    "gui.sharedMessages.pop": "qhumisa",
    "gui.sharedMessages.replaceProjectWarning": "Buyisela imininingwane yeprojekthi yamanje?",
    "gui.sharedMessages.loadFromComputerTitle": "Thathela kweyakho ikhomputha",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "iProject ka Scratch",
    "boost.color.any": "Noma imuphi umbala",
    "boost.color.black": "okumnyama",
    "boost.color.blue": "oluhlaza",
    "boost.color.green": "oluhlaza kwatshani ",
    "boost.color.red": "okubomvu ",
    "boost.color.white": "okumhlophe ",
    "boost.color.yellow": "Okuphuzi ",
    "boost.getMotorPosition": "Moto [MOTOR_REPORTER_ID] indawo ",
    "boost.getTiltAngle": "tshekisa engeli  [TILT_DIRECTION]",
    "boost.motorDirection.backward": "leyandlela",
    "boost.motorDirection.forward": "lendlela",
    "boost.motorDirection.reverse": "buyelemumva ",
    "boost.motorOff": "Jikisa imoto [MOTOR_ID] Uyivale ",
    "boost.motorOn": "Jikisa imoto [MOTOR_ID] uyivule ",
    "boost.motorOnFor": "Jikisa imoto [MOTOR_ID] isikhathi [DURATION] imizuzwana ",
    "boost.motorOnForRotation": "Jikisa imoto[MOTOR_ID] Uku [ROTATION] Ukuphendukisa ",
    "boost.seeingColor": "Ukubona [COLOR] Brick? ",
    "boost.setLightHue": "hlela ukhanya kombala ukuyise [HUE]",
    "boost.setMotorDirection": "lungisa imoto [MOTOR_ID] indlela [MOTOR_DIRECTION] ",
    "boost.setMotorPower": "Lungisa imotor [MOTOR_ID] ijubane uliyise [POWER] ",
    "boost.tiltDirection.any": "noma ikuphi",
    "boost.tiltDirection.down": "ezansi",
    "boost.tiltDirection.left": "Kwesobunxele ",
    "boost.tiltDirection.right": "Kwesokudla ",
    "boost.tiltDirection.up": "phezulu",
    "boost.whenColor": "Uma [COLOR] ukubonakala kwe brick ",
    "boost.whenTilted": "Umakutshekisiwe [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "Inothi beep [NOTE] isikhathi [TIME] imizuzwana",
    "ev3.buttonPressed": "inkinobho [PORT] ecindezeliwe?",
    "ev3.getBrightness": "ukukhanya",
    "ev3.getDistance": "ibanga",
    "ev3.getMotorPosition": "indawo yemotho [PORT]",
    "ev3.motorSetPower": "hlela amandla [POWER]% eMotho [PORT]",
    "ev3.motorTurnClockwise": "Imotho [PORT] ayijike ngalendlela isikhathi [TIME]Imizuzwana  ",
    "ev3.motorTurnCounterClockwise": "imotho [PORT] ayijike ngaleyandlela isikhathi [TIME] imizuzwana",
    "ev3.whenBrightnessLessThan": "uma ukukhanya <[DISTANCE]",
    "ev3.whenButtonPressed": "Inkinobho [PORT] mayicindezeliwe",
    "ev3.whenDistanceLessThan": "uma ibanga < [DISTANCE]",
    "gdxfor.getAcceleration": "Ukusheshisa [DIRECTION]",
    "gdxfor.getForce": "Ngamandla ",
    "gdxfor.getSpin": "ukuphenduka ngejubane [DIRECTION]",
    "gdxfor.getTilt": "Tshekisa engeli [TILT]",
    "gdxfor.isFreeFalling": "Kuyawa ? ",
    "gdxfor.isTilted": "Kutshekisiwe [TILT]?",
    "gdxfor.pulled": "Kudonsekile ",
    "gdxfor.pushed": "Kuphushekile ",
    "gdxfor.shaken": "ukunyakaziswa ",
    "gdxfor.startedFalling": "Sekuqalile kuyawa ",
    "gdxfor.tiltDirectionMenu.any": "noma ikuphi",
    "gdxfor.tiltDirectionMenu.back": "emuva",
    "gdxfor.tiltDirectionMenu.front": "phambili",
    "gdxfor.tiltDirectionMenu.left": "inxele",
    "gdxfor.tiltDirectionMenu.right": "sokudla",
    "gdxfor.turnedFaceDown": "Jika ubuso buyephansi ",
    "gdxfor.turnedFaceUp": "Jika ubuso buyephezulu ",
    "gdxfor.whenForcePushedOrPulled": "Uma kuphushwe isensor [PUSH_PULL]",
    "gdxfor.whenGesture": "uma [GESTURE]",
    "gdxfor.whenTilted": "Makutshekisiwe [TILT]",
    "makeymakey.downArrow": "umcibisholo ophansi",
    "makeymakey.downArrowShort": "ngezansi",
    "makeymakey.leftArrow": "umcibisholo kwesobunxele",
    "makeymakey.leftArrowShort": "inxele",
    "makeymakey.rightArrow": "umcibilisholo kwesokudla",
    "makeymakey.rightArrowShort": "sokudla",
    "makeymakey.spaceKey": "isikhala",
    "makeymakey.upArrow": "umcibilisholo phezulu",
    "makeymakey.upArrowShort": "phezulu",
    "makeymakey.whenKeyPressed": "Uma [KEY]kucindezeliwe ",
    "makeymakey.whenKeysPressedInOrder": "Uma [SEQUENCE]kucindezeliwe ngendlela ",
    "microbit.buttonsMenu.any": "noma ikuphi",
    "microbit.clearDisplay": "isiboniso esicacile",
    "microbit.defaultTextToDisplay": "Sawubona!",
    "microbit.displaySymbol": "Isibonisi [MATRIX]",
    "microbit.displayText": "Isibonisi samagama abhaliwe [TEXT]",
    "microbit.gesturesMenu.jumped": "gxumile",
    "microbit.gesturesMenu.moved": "nyakazile",
    "microbit.gesturesMenu.shaken": "ukunyakaziswa ",
    "microbit.isButtonPressed": "[BTN] inkinobho icindezelwe?",
    "microbit.isTilted": "Itshekile [DIRECTION]?",
    "microbit.pinStateMenu.off": "cisha",
    "microbit.pinStateMenu.on": "khanyile",
    "microbit.tiltAngle": "tshekisa engeli [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "noma ikuphi",
    "microbit.tiltDirectionMenu.back": "emuva",
    "microbit.tiltDirectionMenu.front": "phambili",
    "microbit.tiltDirectionMenu.left": "inxele",
    "microbit.tiltDirectionMenu.right": "sokudla",
    "microbit.whenButtonPressed": "Inkinobho [BTN] mayicindezeliwe ",
    "microbit.whenGesture": "uma [GESTURE]",
    "microbit.whenPinConnected": "uma uphini [PIN] uxhunyiwe ",
    "microbit.whenTilted": "uma kutshesiwe [DIRECTION]",
    "music.categoryName": "uMculo",
    "music.changeTempo": "shintsha iThempo nge [TEMPO]",
    "music.drumBass": "(2) Isigubhu esi nebhesi",
    "music.drumBongo": "(13) Bhongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Zinduku",
    "music.drumClosedHiHat": "(6) Ihi-Hat Evaliwe",
    "music.drumConga": "(14) Ikhonga",
    "music.drumCowbell": "(11) Insimbi yenkomo",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Ihlombe",
    "music.drumOpenHiHat": "(5) Vula Hi-Hat",
    "music.drumSideStick": "(3) Induku eseceleni",
    "music.drumSnare": "(1) Idilamu Snare",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Nxantathu",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Ikhuni amabhulokisi",
    "music.getTempo": "izinsimbi",
    "music.instrumentBass": "(6) Bhesi",
    "music.instrumentBassoon": "(14) Icilongo",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Ikwaya",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Isigingci sagesi",
    "music.instrumentElectricPiano": "(2) Upiyano wagesi",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Isiginci",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Ibhokisi lomculo",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Upiyano",
    "music.instrumentPizzicato": "(7) Umculo osheshayo",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Isigubhu Sensimbi",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Ikhwela Flute",
    "music.midiPlayDrumForBeats": "dlala idilamu [DRUM] le [BEATS] ibhithi",
    "music.midiSetInstrument": "hlela isikhali sokusebenza [INSTRUMENT]",
    "music.playDrumForBeats": "dlala idilamu [DRUM] le [BEATS] ibhithi",
    "music.playNoteForBeats": "dlala inothi [NOTE] le [BEATS] bhithi",
    "music.restForBeats": "okuseleyo nge [BEATS] bhithi  ",
    "music.setInstrument": "hlela isikhali sokusebenza [INSTRUMENT]",
    "music.setTempo": "hlela ithempo ku [TEMPO]",
    "pen.categoryName": "Ipeni",
    "pen.changeColorParam": "shintsha ipeni [COLOR_PARAM] nge [VALUE]",
    "pen.changeHue": "shintsha umbala wepeni nge [HUE]",
    "pen.changeShade": "shintsha ipeni usithe nge [SHADE]",
    "pen.changeSize": "shintsha usayizi wepeni ngo [SIZE]",
    "pen.clear": "kususe konke ",
    "pen.colorMenu.brightness": "ukukhanya",
    "pen.colorMenu.color": "umbala",
    "pen.colorMenu.saturation": "ukukhanya kombala ",
    "pen.colorMenu.transparency": "obala",
    "pen.penDown": "ipeni phansi",
    "pen.penUp": "ipeni phezulu",
    "pen.setColor": "hlela umbala wepeni [COLOR]",
    "pen.setColorParam": "hlela ipeni [COLOR_PARAM] uliyise kwi [VALUE]",
    "pen.setHue": "hlela umbala wepeni uwuyise [HUE]",
    "pen.setShade": "hlela ukusitha ngepeni ukuyise [SHADE]",
    "pen.setSize": "hlela ubukhulu bepeni ubuyise [SIZE]",
    "pen.stamp": "isitembu",
    "speech.defaultWhenIHearValue": "asambe ",
    "speech.extensionName": "Inkulumo eyiswa emagameni abhalwayo",
    "speech.listenAndWait": "lalela ulinde ",
    "speech.speechReporter": "inkulumo",
    "speech.whenIHear": "uma ngizwa [PHRASE]",
    "text2speech.alto": "I -altho",
    "text2speech.categoryName": "Bhala kwinkulumo",
    "text2speech.defaultTextToSpeak": "sawubona",
    "text2speech.giant": "isiqhwaga ",
    "text2speech.kitten": "Ingane yekati",
    "text2speech.setLanguageBlock": "hlela ulimi uliyise [LANGUAGE]",
    "text2speech.setVoiceBlock": "hlela izwi uliyise [VOICE]",
    "text2speech.speakAndWaitBlock": "khuluma [WORDS]",
    "text2speech.squeak": "Tswininiza",
    "text2speech.tenor": "I-thena",
    "translate.categoryName": "Humusha ",
    "translate.defaultTextToTranslate": "sawubona",
    "translate.translateBlock": "humusha [WORDS] uyise [LANGUAGE]",
    "translate.viewerLanguage": "ulimi",
    "videoSensing.categoryName": "Ukubona ividiyo",
    "videoSensing.direction": "indlela",
    "videoSensing.motion": "ukunyakaza",
    "videoSensing.off": "cisha",
    "videoSensing.on": "ivulekile",
    "videoSensing.onFlipped": "kuphenyiwe ",
    "videoSensing.setVideoTransparency": "hlela ukubonakala kweVidiyo ukuyise [TRANSPARENCY]",
    "videoSensing.sprite": "umlingisi",
    "videoSensing.stage": "isiteji",
    "videoSensing.videoOn": "vidiyo [ATTRIBUTE] ku [SUBJECT]",
    "videoSensing.videoToggle": "phendula ividiyo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "umakunyakaza ividiyo > [REFERENCE]",
    "wedo2.getDistance": "ibanga",
    "wedo2.getTiltAngle": "tshekisa engeli  [TILT_DIRECTION]",
    "wedo2.isTilted": "itshekile [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "leyandlela",
    "wedo2.motorDirection.forward": "lendlela",
    "wedo2.motorDirection.reverse": "buyelemunva",
    "wedo2.motorId.a": "imotho A ",
    "wedo2.motorId.all": "wonke amamotho ",
    "wedo2.motorId.b": "imotho B",
    "wedo2.motorId.default": "imotho",
    "wedo2.motorOff": "yicishe [MOTOR_ID]",
    "wedo2.motorOn": "yivule [MOTOR_ID]",
    "wedo2.motorOnFor": "yivule [MOTOR_ID] isikhathi [DURATION] imizuzwana",
    "wedo2.playNoteFor": "dlala inothi [NOTE] isikathi [DURATION] imizuzwana  ",
    "wedo2.setLightHue": "hlela ukhanya kombala ukuyise [HUE]",
    "wedo2.setMotorDirection": "hlela indlela ye [MOTOR_ID] ukuyise [MOTOR_DIRECTION] ",
    "wedo2.startMotorPower": "hlela [MOTOR_ID] amandla uwayise [POWER]",
    "wedo2.tiltDirection.any": "noma ikuphi",
    "wedo2.tiltDirection.down": "ngezansi",
    "wedo2.tiltDirection.left": "inxele",
    "wedo2.tiltDirection.right": "sokudla",
    "wedo2.tiltDirection.up": "phezulu",
    "wedo2.whenDistance": "uma ibanga [OP] [REFERENCE]",
    "wedo2.whenTilted": "Umakutshekisiwe [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Umbala",
    "paint.paintEditor.saturation": "Ukukhanya kombala",
    "paint.paintEditor.brightness": "Ukukhanya",
    "paint.paintEditor.costume": "Impahla",
    "paint.paintEditor.group": "Iqembu",
    "paint.paintEditor.ungroup": "Hlukanisa",
    "paint.paintEditor.undo": "Yenza kabusha",
    "paint.paintEditor.redo": "Ukwenzakabusha",
    "paint.paintEditor.forward": "Phambili",
    "paint.paintEditor.backward": "Emuva",
    "paint.paintEditor.front": "Phambili",
    "paint.paintEditor.back": "Emuva",
    "paint.paintEditor.more": "Okunye",
    "paint.modeTools.brushSize": "Isisindo",
    "paint.modeTools.eraserSize": "Irabha ubude",
    "paint.modeTools.copy": "Khopisha",
    "paint.modeTools.paste": "Namathisela",
    "paint.modeTools.delete": "Susa",
    "paint.modeTools.curved": "Lugobile ",
    "paint.modeTools.pointed": "Iphoyinti",
    "paint.modeTools.thickness": "Ugqinsi",
    "paint.modeTools.flipHorizontal": "Phendula ngokuya emaceleni",
    "paint.modeTools.flipVertical": "Phendula ngokuya phansi naphezulu",
    "paint.modeTools.filled": "Kugcwele",
    "paint.modeTools.outlined": "Kugqamile",
    "paint.paintEditor.bitmap": "Shitsela kuBitmap",
    "paint.paintEditor.vector": "Shitsela kuVector",
    "paint.paintEditor.fill": "Gcwalisa",
    "paint.paintEditor.stroke": "Kugqamise",
    "paint.brushMode.brush": "Ibhrashi",
    "paint.eraserMode.eraser": "Irabha",
    "paint.fillMode.fill": "Gcwalisa",
    "paint.lineMode.line": "Umugqa",
    "paint.ovalMode.oval": "Indingiliza",
    "paint.rectMode.rect": "Irectangle",
    "paint.reshapeMode.reshape": "Ukubuyisele esimeni",
    "paint.roundedRectMode.roundedRect": "Indingiliza yerectangle",
    "paint.selectMode.select": "Khetha",
    "paint.textMode.text": "Umbhalo",
    "paint.colorPicker.swap": "Shitsha "
  },
  "is": {
    "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
    "gui.alerts.tryAgain": "Try Again",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Reconnect",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Bakpoki",
    "gui.backpack.errorBackpack": "Villa kom upp þegar reynt var að sækja bakpokann",
    "gui.backpack.loadingBackpack": "Hleð inn ...",
    "gui.backpack.more": "More",
    "gui.backpack.emptyBackpack": "Bakpokinn er tómur",
    "gui.unsupportedBrowser.label": "Styður ekki vafra",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Til baka",
    "gui.unsupportedBrowser.previewfaq": "Til að læra meira {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Spurt & svarað",
    "gui.cards.all-tutorials": "Kennsluefni",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Close",
    "gui.cards.more-things-to-try": "Fleiri hlutir til að prófa!",
    "gui.cards.see-more": "Sjá fleiri",
    "gui.comingSoon.message1": "Ekki hafa áhyggjur, við erum að vinna í þessu {emoji}",
    "gui.comingSoon.message2": "Kemur bráðlega...",
    "gui.comingSoon.message3": "Við erum að vinna í þessu {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "Have your device nearby, then begin searching.",
    "gui.connection.auto-scanning.pressbutton": "Press the button on your device.",
    "gui.connection.auto-scanning.start-search": "Start Searching",
    "gui.connection.connecting-searchbutton": "Searching...",
    "gui.connection.auto-scanning.try-again": "Try again",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Tengt",
    "gui.connection.disconnect": "Aftengja",
    "gui.connection.go-to-editor": "Fara til baka í ritil",
    "gui.connection.connecting-cancelbutton": "Að tengjast...",
    "gui.connection.error.errorMessage": "Úps, eitthvað fór úrskeiðis",
    "gui.connection.error.tryagainbutton": "Reyna aftur",
    "gui.connection.error.helpbutton": "Hjálp",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "Tengjast",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "Veldu tækið þitt í listanum að ofan.",
    "gui.connection.search": "Endurhlaða",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Vertu viss um að hafa sett upp Scratch Link og það sé í gangi",
    "gui.connection.unavailable.enablebluetooth": "Athugaðu hvort að það sé kveikt á Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Reyna aftur",
    "gui.connection.unavailable.helpbutton": "Hjálp",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Keyra",
    "gui.controls.stop": "Stopp",
    "gui.crashMessage.label": "Oops! Something went wrong.",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Reload",
    "gui.customProcedures.myblockModalTitle": "Búa til kubb",
    "gui.customProcedures.addAnInputNumberText": "Bæta við inntaki",
    "gui.customProcedures.numberTextType": "Tala eða texti",
    "gui.customProcedures.addAnInputBoolean": "Bæta við inntaki",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Bæta við merki",
    "gui.customProcedures.runWithoutScreenRefresh": "Keyra án þess að uppfæra skjámynd",
    "gui.customProcedures.cancel": "Hætta við",
    "gui.customProcedures.ok": "Í lagi",
    "gui.SpriteInfo.direction": "Átt",
    "gui.directionPicker.rotationStyles.allAround": "Allt í kring",
    "gui.directionPicker.rotationStyles.leftRight": "Vinstri/hægri",
    "gui.directionPicker.rotationStyles.dontRotate": "Ekki snúast",
    "gui.gui.addExtension": "Bæta við viðbót",
    "gui.gui.codeTab": "Kóði",
    "gui.gui.backdropsTab": "Bakgrunnar",
    "gui.gui.costumesTab": "Búningar",
    "gui.gui.soundsTab": "Hljóð",
    "gui.extensionLibrary.comingSoon": "Kemur bráðlega",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "Collaboration with",
    "gui.library.filterPlaceholder": "Leita",
    "gui.library.allTag": "All",
    "gui.loader.message1": "Verið að búa til kubba ...",
    "gui.loader.message2": "Sæki teikningu ...",
    "gui.loader.message3": "Sæki hljóð ...",
    "gui.loader.message4": "Sæki viðbætur ...",
    "gui.loader.message5": "Safna saman köttunum ...",
    "gui.loader.message6": "Erum að vinna í þessu ...",
    "gui.loader.message7": "Erum að blása upp gobos ...",
    "gui.loader.message8": "Undirbúið broskalla ...",
    "gui.loader.headline": "Hleð inn verkefni ",
    "gui.loader.creating": "Creating Project",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "My Stuff",
    "gui.accountMenu.myClasses": "My Classes",
    "gui.accountMenu.myClass": "My Class",
    "gui.accountMenu.accountSettings": "Account settings",
    "gui.accountMenu.signOut": "Sign out",
    "gui.authorInfo.byUser": "by {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "gui.menuBar.language": "Language",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Sign in",
    "login.needHelp": "Need Help?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.tutorialsLibrary": "Kennsluefni",
    "gui.menuBar.restoreSprite": "Restore Sprite",
    "gui.menuBar.restoreSound": "Restore Sound",
    "gui.menuBar.restoreCostume": "Restore Costume",
    "gui.menuBar.restore": "Restore",
    "gui.menuBar.saveNow": "Vista núna",
    "gui.menuBar.saveAsCopy": "Vista sem afrit",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Ný",
    "gui.menuBar.file": "Skrá",
    "gui.menuBar.downloadToComputer": "Vista á tölvuna þína",
    "gui.menuBar.edit": "Breyta",
    "gui.menuBar.turboModeOff": "Slökkva á snöggham",
    "gui.menuBar.turboModeOn": "Kveikja á snöggham",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Join Scratch",
    "gui.menuBar.signIn": "Sign in",
    "gui.gui.projectTitlePlaceholder": "Project title here",
    "gui.menuBar.saveNowLink": "Save Now",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Shared",
    "gui.menuBar.share": "Deila",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Hjálp",
    "gui.modal.back": "Til baka",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "length {length}",
    "gui.monitor.contextMenu.default": "venjuleg leturgerð",
    "gui.monitor.contextMenu.large": "Stór leturgerð",
    "gui.monitor.contextMenu.slider": "renna",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Fyrir allar teikningar",
    "gui.gui.variableScopeOptionSpriteOnly": "Aðeins fyrir þessa teikningu",
    "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
    "gui.gui.variablePromptAllSpritesMessage": "Þessi breyta verður aðgengileg öllum teikningunum.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Hætta við",
    "gui.prompt.ok": "Í lagi",
    "gui.playbackStep.stopMsg": "Stopp",
    "gui.playbackStep.playMsg": "Spila",
    "gui.playbackStep.loadingMsg": "Hleð inn ...",
    "gui.playbackStep.saveMsg": "Vista",
    "gui.playbackStep.reRecordMsg": "Taka upp aftur",
    "gui.recordModal.title": "Taka upp hljóð",
    "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "Stop recording",
    "gui.recordingStep.record": "Record",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Hljóð",
    "gui.soundEditor.play": "Spila",
    "gui.soundEditor.stop": "Stopp",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Vista",
    "gui.soundEditor.undo": "Afgera",
    "gui.soundEditor.redo": "Endurgera",
    "gui.soundEditor.faster": "Hraðar",
    "gui.soundEditor.slower": "Hægar",
    "gui.soundEditor.echo": "Bergmál",
    "gui.soundEditor.robot": "Vélmenni",
    "gui.soundEditor.louder": "Hærra",
    "gui.soundEditor.softer": "Mýkja",
    "gui.soundEditor.reverse": "Snúa við",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Nafn",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Teikning",
    "gui.SpriteInfo.show": "Sýna",
    "gui.SpriteInfo.size": "Stærð",
    "gui.spriteSelectorItem.contextMenuDuplicate": "tvöfalda",
    "gui.spriteSelectorItem.contextMenuExport": "flytja út",
    "gui.spriteSelectorItem.contextMenuDelete": "eyða",
    "gui.spriteSelector.addSpriteFromLibrary": "Veldu teikningu",
    "gui.spriteSelector.addSpriteFromPaint": "Mála",
    "gui.spriteSelector.addSpriteFromSurprise": "Koma á óvart",
    "gui.spriteSelector.addSpriteFromFile": "Sækja teikningu",
    "gui.stageHeader.stageSizeLarge": "Skipta yfir á stórt svið",
    "gui.stageHeader.stageSizeSmall": "Skipta yfir á lítið svið",
    "gui.stageHeader.stageSizeFull": "Fylla í skjáinn",
    "gui.stageHeader.stageSizeUnFull": "Minnka skjáinn",
    "gui.stageHeader.fullscreenControl": "Fylla í skjá stýring",
    "gui.spriteSelector.addBackdropFromLibrary": "Veldu bakgrunn",
    "gui.stageSelector.addBackdropFromPaint": "Málning",
    "gui.stageSelector.addBackdropFromSurprise": "Koma á óvart",
    "gui.stageSelector.addBackdropFromFile": "Sækja bakgrunn",
    "gui.stageSelector.stage": "Svið",
    "gui.stageSelector.backdrops": "Bakgrunnar",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Snögghamur",
    "gui.webglModal.label": "Vafrinn þinn styður ekki WebGL",
    "gui.webglModal.description": "Því miður vantar vafrann þinn eða tölvuna {webGlLink}. Það þarf þessa tækni til að nota Scratch 3.0.",
    "gui.webglModal.webgllink": "styður ekki WebGL",
    "gui.webglModal.back": "Til baka",
    "gui.webglModal.previewfaq": "Til að læra meira {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Spurt & svarað",
    "gui.costumeLibrary.chooseABackdrop": "Veldu bakgrunn",
    "gui.costumeLibrary.chooseACostume": "Velja búning",
    "gui.costumeTab.addBackdropFromLibrary": "Veldu bakgrunn",
    "gui.costumeTab.addCostumeFromLibrary": "Velja búning",
    "gui.costumeTab.addBlankCostume": "Málning",
    "gui.costumeTab.addSurpriseCostume": "Koma á óvart",
    "gui.costumeTab.addFileBackdrop": "Sækja bakgrunn",
    "gui.costumeTab.addFileCostume": "Sækja búning",
    "gui.extensionLibrary.chooseAnExtension": "Veldu viðbót",
    "gui.extensionLibrary.extensionUrl": "Sett inn hlekk á viðbótinni",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Gat ekki hafið upptöku",
    "gui.soundLibrary.chooseASound": "Veldu hljóð",
    "gui.soundTab.fileUploadSound": "Sækja hljóð",
    "gui.soundTab.surpriseSound": "Koma á óvart",
    "gui.soundTab.recordSound": "Taka upp",
    "gui.soundTab.addSoundFromLibrary": "Veldu hljóð",
    "gui.spriteLibrary.chooseASprite": "Veldu teikningu",
    "gui.tipsLibrary.tutorials": "Veldu kennsuefni",
    "gui.alerts.createsuccess": "New project created.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Could not create the project. Please try again!",
    "gui.alerts.savingError": "Project could not save.",
    "gui.alerts.savesuccess": "Project saved.",
    "gui.alerts.saving": "Saving project…",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Hefjast handa",
    "gui.howtos.intro-move.step_stepMove": "Bættu við hreyfi kubb",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Hreyfa nafn",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Veldu stafa teikningu",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spila hljóð þegar það er klikkað",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Veldu aðra stafa teikningu",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Breyta lit",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Veldu aðra stafa teikningu & láttu hana snúast",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Veldu aðra stafa teikningu & láttu hana vaxa",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Búa til tónlist",
    "gui.howtos.Make-Music.step_PickInstrument": "Veldu hljóðfæra teikningu",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spila hljóð þegar það er smellt",
    "gui.howtos.Make-Music.step_MakeSong": "Búa til lag",
    "gui.howtos.make-music.step_MakeBeat": "Veldu trommu og búðu til takt",
    "gui.howtos.make-music.step_MakeBeatBox": "Veldu míkrafón teikninguna og taktkassa sem kemur á óvart",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Búðu til eltingarleik",
    "gui.howtos.Chase-Game.step_BG": "Bæta við bakgrunn",
    "gui.howtos.chase-game.step_AddOcto": "Bæta við teikningu",
    "gui.howtos.make-music.step_LeftRight": "Færa til hægri og vinstri með örvatökkunum",
    "gui.howtos.Chase-Game.step_UpDown": "Færa upp og niður með örvatökkunum",
    "gui.howtos.Chase-Game.step_AddStar": "Bæta við annari teikningu",
    "gui.howtos.Chase-Game.step_MoveRandom": "Færa handahófskennt",
    "gui.howtos.Chase-Game.step_WhenTouch": "Kolkrabba teikningin á að spila hljóð þegar hún snertir einhvað",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Búðu til stiga breytu",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Þegar kolkrabba teikningin snertir einhvað, er bætt við stigi",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "Búðu til leik þar sem hægt er að smella á hluti",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Veldu teikningu",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spila hljóð þegar það er smellt",
    "gui.howtos.make-a-game.step_GameAddScore": "Búðu til stiga breytu",
    "gui.howtos.make-a-game.step_GameChangeScore": "Hækka stig það er smellt",
    "gui.howtos.make-a-game.step_Random": "Fara á handahófskennda staðsetningu",
    "gui.howtos.make-music.step_GameChangeColor": "Breyta lit",
    "gui.howtos.make-music.step_ResetScore": "Endurstilla stig",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Bæta við teikningu",
    "gui.howtos.add-sprite.step_addSprite": "Bæta við teikningu",
    "gui.howtos.add-a-backdrop.name": "Bæta við bakgrunn",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Breyta stærð",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Svífa um",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Taka upp hljóð",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Láta snúast",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Fela og sýna",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Hreyfa teikninguna",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Nota örvatakka",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Bæta við effektum",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Tónlist",
    "gui.extension.music.description": "Spila hljóðfæri og trommur. ",
    "gui.extension.pen.name": "Penni",
    "gui.extension.pen.description": "Teiknaðu með teikningunum þínum. ",
    "gui.extension.videosensing.name": "Vídeó mæling",
    "gui.extension.videosensing.description": "Skynja hreyfingu með myndavélinni",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description": "Translate text into many languages.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "Tengdu verkefnin þín við heiminn. ",
    "gui.extension.microbit.connectingMessage": "Tengjast",
    "gui.extension.ev3.description": "Búðu til gagnvirk vélmenni og fleira. ",
    "gui.extension.ev3.connectingMessage": "Tengist. Passaðu að pinnið í EV3 sé 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Byggt með mótorum og skynjurum.",
    "gui.extension.wedo2.connectingMessage": "Connecting",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "All",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dance",
    "gui.libraryTags.effects": "Effects",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Indoors",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Music",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Outdoors",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "People",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Underwater",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Games",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "size",
    "gui.opcodeLabels.costumename": "costume name",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "backdrop name",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "answer",
    "gui.opcodeLabels.loudness": "loudness",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "year",
    "gui.opcodeLabels.month": "month",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "day of week",
    "gui.opcodeLabels.hour": "hour",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "second",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "Tókst ekki að hlaða skránni með verkefninu sem var valið.",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
    "ev3.buttonPressed": "button [PORT] pressed?",
    "ev3.getBrightness": "brightness",
    "ev3.getDistance": "distance",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
    "ev3.whenButtonPressed": "when button [PORT] pressed",
    "ev3.whenDistanceLessThan": "when distance < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "down",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "left",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "right",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "up",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "any",
    "microbit.clearDisplay": "clear display",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] button pressed?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "off",
    "microbit.pinStateMenu.on": "on",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "any",
    "microbit.tiltDirectionMenu.back": "back",
    "microbit.tiltDirectionMenu.front": "front",
    "microbit.tiltDirectionMenu.left": "left",
    "microbit.tiltDirectionMenu.right": "right",
    "microbit.whenButtonPressed": "when [BTN] button pressed",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "music.categoryName": "Tónlist",
    "music.changeTempo": "breyta hraða um  [TEMPO]",
    "music.drumBass": "(2) Bassa tromma",
    "music.drumBongo": "(13) Bongo tromma",
    "music.drumCabasa": "(15) Hrista",
    "music.drumClaves": "(9) Taktstangir",
    "music.drumClosedHiHat": "(6) Lokaður Hi-Hat",
    "music.drumConga": "(14) Konga tromma",
    "music.drumCowbell": "(11) Kúabjalla",
    "music.drumCrashCymbal": "(4) Glamrandi simball",
    "music.drumCuica": "(18) Cuica tromma",
    "music.drumGuiro": "(16) Guíró",
    "music.drumHandClap": "(8) Klapp",
    "music.drumOpenHiHat": "(5) Opinn Hi-Hat",
    "music.drumSideStick": "(3) Hliðar prik",
    "music.drumSnare": "(1) Sneriltromma",
    "music.drumTambourine": "(7) Tambúrína",
    "music.drumTriangle": "(12) Þríhyrningur",
    "music.drumVibraslap": "(17) Víbrastrengur",
    "music.drumWoodBlock": "(10) Viðarblokk",
    "music.getTempo": "taktur",
    "music.instrumentBass": "(6) Bassi",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Selló",
    "music.instrumentChoir": "(15) Kór",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Rafmagnsgítar",
    "music.instrumentElectricPiano": "(2) Rafmagnspíanó",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Gítar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Spiladós",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Píanó",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxófónn",
    "music.instrumentSteelDrum": "(18) Stál tromma",
    "music.instrumentSynthLead": "(20) Aðal hljóðgervill",
    "music.instrumentSynthPad": "(21) Hljóðgervill ",
    "music.instrumentTrombone": "(9) Básúna",
    "music.instrumentVibraphone": "(16) Víbrafónn",
    "music.instrumentWoodenFlute": "(13) Viðar flauta",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
    "music.playDrumForBeats": "spila trommu [DRUM] í [BEATS] slög",
    "music.playNoteForBeats": "spila nótu [NOTE] í [BEATS] slög",
    "music.restForBeats": "bíða í [BEATS] slög",
    "music.setInstrument": "setja hljóðfæri sem [INSTRUMENT]",
    "music.setTempo": "setja hraða sem [TEMPO]",
    "pen.categoryName": "Penni",
    "pen.changeColorParam": "breyta lit penna [COLOR_PARAM] í [VALUE]",
    "pen.changeHue": "breyta lit penna um [HUE]",
    "pen.changeShade": "breyta litbrigði penna um [SHADE]",
    "pen.changeSize": "breyta stærð penna um [SIZE]",
    "pen.clear": "hreinsa allt",
    "pen.colorMenu.brightness": "birtustig",
    "pen.colorMenu.color": "litur",
    "pen.colorMenu.saturation": "mettun",
    "pen.colorMenu.transparency": "gegnsæi",
    "pen.penDown": "penni niður",
    "pen.penUp": "penni upp",
    "pen.setColor": "setja lit penna sem [COLOR]",
    "pen.setColorParam": "setja lit penna [COLOR_PARAM]í [VALUE]",
    "pen.setHue": "setja lit penna sem [HUE]",
    "pen.setShade": "setja skugga penna í [SHADE]",
    "pen.setSize": "setja stærð penna í [SIZE]",
    "pen.stamp": "stimpla",
    "speech.defaultWhenIHearValue": "förum",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "hlustaðu og bíddu",
    "speech.speechReporter": "tal",
    "speech.whenIHear": "þegar ég heyri [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "giant",
    "text2speech.kitten": "kettlingur",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "setja rödd sem [VOICE]",
    "text2speech.speakAndWaitBlock": "tala [WORDS]",
    "text2speech.squeak": "tíst",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Translate",
    "translate.defaultTextToTranslate": "halló",
    "translate.translateBlock": "þýða [WORDS] á [LANGUAGE]",
    "translate.viewerLanguage": "tungumál",
    "videoSensing.categoryName": "Vídeó mæling",
    "videoSensing.direction": "átt",
    "videoSensing.motion": "hreyfing",
    "videoSensing.off": "af",
    "videoSensing.on": "á",
    "videoSensing.onFlipped": "á flippi",
    "videoSensing.setVideoTransparency": "setja gegnsæi hreyfimyndar í [TRANSPARENCY]",
    "videoSensing.sprite": "teikning",
    "videoSensing.stage": "svið",
    "videoSensing.videoOn": "vídeó [ATTRIBUTE] á [SUBJECT]",
    "videoSensing.videoToggle": "breyta vídeó [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "þegar hreyfing í vídeó > [REFERENCE]",
    "wedo2.getDistance": "distance",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "reverse",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
    "wedo2.setLightHue": "set light color to [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "down",
    "wedo2.tiltDirection.left": "left",
    "wedo2.tiltDirection.right": "right",
    "wedo2.tiltDirection.up": "up",
    "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Litur",
    "paint.paintEditor.saturation": "mettun",
    "paint.paintEditor.brightness": "Birtustig",
    "paint.paintEditor.costume": "Búningur",
    "paint.paintEditor.group": "Hópur",
    "paint.paintEditor.ungroup": "Leysa upp hóp",
    "paint.paintEditor.undo": "Afgera",
    "paint.paintEditor.redo": "Endurgera",
    "paint.paintEditor.forward": "Áfram",
    "paint.paintEditor.backward": "Aftur á bak",
    "paint.paintEditor.front": "Fremst",
    "paint.paintEditor.back": "Til baka",
    "paint.paintEditor.more": "Meira",
    "paint.modeTools.brushSize": "Stærð",
    "paint.modeTools.eraserSize": "Stærð strokleðurs",
    "paint.modeTools.copy": "Afrita",
    "paint.modeTools.paste": "Líma",
    "paint.modeTools.delete": "Eyða",
    "paint.modeTools.curved": "Sveigja",
    "paint.modeTools.pointed": "Oddmjótt",
    "paint.modeTools.thickness": "Þykkt",
    "paint.modeTools.flipHorizontal": "Flippa lárétt",
    "paint.modeTools.flipVertical": "Flippa lóðrétt",
    "paint.modeTools.filled": "Fylla",
    "paint.modeTools.outlined": "Útlína",
    "paint.paintEditor.bitmap": "Umbreyta í Bitmap",
    "paint.paintEditor.vector": "Umbreyta í vektor",
    "paint.paintEditor.fill": "Fylla",
    "paint.paintEditor.stroke": "Útlína",
    "paint.brushMode.brush": "Bursti",
    "paint.eraserMode.eraser": "Strokleður",
    "paint.fillMode.fill": "Fylla",
    "paint.lineMode.line": "Lína",
    "paint.ovalMode.oval": "Hringur",
    "paint.rectMode.rect": "Ferhyrningur",
    "paint.reshapeMode.reshape": "Ummynda",
    "paint.roundedRectMode.roundedRect": "Rúnaður ferhyrningur",
    "paint.selectMode.select": "Velja",
    "paint.textMode.text": "Texti",
    "paint.colorPicker.swap": "Skipta"
  },
  "it": {
    "gui.alerts.lostPeripheralConnection": "Scratch ha perso il collegamento con {extensionName}.",
    "gui.alerts.tryAgain": "Prova di Nuovo",
    "gui.alerts.download": "Salva sul tuo computer",
    "gui.connection.reconnect": "Ricollega",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "suono",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Valigetta",
    "gui.backpack.errorBackpack": "Errore nel caricamento dello zaino",
    "gui.backpack.loadingBackpack": "Caricamento in corso...",
    "gui.backpack.more": "Altro",
    "gui.backpack.emptyBackpack": "Lo zaino è vuoto",
    "gui.unsupportedBrowser.label": "Browser non supportato",
    "gui.unsupportedBrowser.errorLabel": "Si è Verificato un Errore",
    "gui.unsupportedBrowser.notRecommended": "Ci dispiace, ma sembra che tu stia usando una versione di un browser non supportata da Scratch. Ti raccomandiamo di usare la versione più recente di uno dei browser supportati, come Chrome, Firefox, Edge o Safari.",
    "gui.unsupportedBrowser.description": "Ci dispiace, ma sembra che tu stia usando un browser non supportato da Scratch. Ti raccomandiamo di usare la versione più recente di un browser supportato, come Chrome, Firefox, Edge o Safari.",
    "gui.unsupportedBrowser.back": "Indietro",
    "gui.unsupportedBrowser.previewfaq": "Per saperne di più, vai alla pagina {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Domande Frequenti",
    "gui.cards.all-tutorials": "Tutorial",
    "gui.cards.shrink": "Riduci",
    "gui.cards.expand": "Espandi",
    "gui.cards.close": "Chiudi",
    "gui.cards.more-things-to-try": "Altre cose da provare!",
    "gui.cards.see-more": "Ulteriori informazioni",
    "gui.comingSoon.message1": "Non preoccuparti, ci stiamo lavorando {emoji}",
    "gui.comingSoon.message2": "Disponibile a breve...",
    "gui.comingSoon.message3": "Ci stiamo lavorando {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nessun dispositivo trovato",
    "gui.connection.auto-scanning.prescan": "Tieni il tuo dispositivo a portata, quindi inizia la ricerca.",
    "gui.connection.auto-scanning.pressbutton": "Premi il pulsante sul tuo dispositivo.",
    "gui.connection.auto-scanning.start-search": "Inizio Ricerca",
    "gui.connection.connecting-searchbutton": "Ricerca in corso...",
    "gui.connection.auto-scanning.try-again": "Prova ancora",
    "gui.connection.auto-scanning.updatePeripheralButton": "Aggiorna il Dispositivo",
    "gui.connection.connected": "Connesso",
    "gui.connection.disconnect": "Scollega",
    "gui.connection.go-to-editor": "Torna all'Editor",
    "gui.connection.connecting-cancelbutton": "Collegamento in corso...",
    "gui.connection.error.errorMessage": "Ops, sembra che qualcosa non abbia funzionato.",
    "gui.connection.error.tryagainbutton": "Prova ancora",
    "gui.connection.error.helpbutton": "Aiuto",
    "gui.connection.peripheral-name-label": "Nome del dispositivo",
    "gui.connection.connect": "Collega",
    "gui.connection.scanning.lookingforperipherals": "Ricerca dispositivi in corso",
    "gui.connection.scanning.noPeripheralsFound": "Nessun dispositivo trovato",
    "gui.connection.scanning.instructions": "Seleziona il dispositivo nella lista.",
    "gui.connection.search": "Aggiorna",
    "gui.connection.scanning.updatePeripheralButton": "Aggiorna il Dispositivo",
    "gui.connection.unavailable.installscratchlink": "Assicurati che Scratch Link sia installato e correttamente funzionante",
    "gui.connection.unavailable.enablebluetooth": "Accertati che il Bluetooth sia attivato",
    "gui.connection.unavailable.tryagainbutton": "Prova ancora",
    "gui.connection.unavailable.helpbutton": "Aiuto",
    "gui.connection.updatePeripheral.microBitConnect": "Collega {extensionName} al dispositivo usando un cavo USB.",
    "gui.connection.updatePeripheral.pressUpdate": "Premi \"Aggiorna\" e attendi che l'aggiornamento sia completato.",
    "gui.connection.updatePeripheral.progress": "Aggiornamento {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "L'aggiornamento si è concluso con successo!",
    "gui.connection.updatePeripheral.updateFailed": "Aggiornamento fallito.",
    "gui.connection.updatePeripheral.goBackButton": "Indietro",
    "gui.connection.updatePeripheral.updateNowButton": "Aggiorna",
    "gui.connection.updatePeripheral.updateAgainButton": "Riprova",
    "gui.controls.go": "Vai",
    "gui.controls.stop": "Ferma tutto",
    "gui.crashMessage.label": "Ops! Qualcosa non ha funzionato.",
    "gui.crashMessage.description": "Siamo spiacenti, ma sembra che Scratch si sia bloccato. Il problema è stato automaticamente segnalato al Team di Scratch. Aggiorna la pagina per riprovare.",
    "gui.crashMessage.errorNumber": "L'errore è stato loggato con id {errorId}",
    "gui.crashMessage.reload": "Ricarica",
    "gui.customProcedures.myblockModalTitle": "Crea un Blocco",
    "gui.customProcedures.addAnInputNumberText": "Aggiungi un argomento",
    "gui.customProcedures.numberTextType": "numero o testo",
    "gui.customProcedures.addAnInputBoolean": "Aggiungi un argomento",
    "gui.customProcedures.booleanType": "booleano",
    "gui.customProcedures.addALabel": "Aggiungi una scritta",
    "gui.customProcedures.runWithoutScreenRefresh": "Esegui senza aggiornare lo schermo",
    "gui.customProcedures.cancel": "Annulla",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direzione",
    "gui.directionPicker.rotationStyles.allAround": "Può Ruotare",
    "gui.directionPicker.rotationStyles.leftRight": "Sinistra-Destra",
    "gui.directionPicker.rotationStyles.dontRotate": "Non ruotare",
    "gui.gui.addExtension": "Aggiungi un'Estensione",
    "gui.gui.codeTab": "Codice",
    "gui.gui.backdropsTab": "Sfondi",
    "gui.gui.costumesTab": "Costumi",
    "gui.gui.soundsTab": "Suoni",
    "gui.extensionLibrary.comingSoon": "Disponibile a Breve",
    "gui.extensionLibrary.requires": "Richiede",
    "gui.extensionLibrary.collaboration": "In collaborazione con",
    "gui.library.filterPlaceholder": "Cerca",
    "gui.library.allTag": "Tutti",
    "gui.loader.message1": "Creazione dei blocchi...",
    "gui.loader.message2": "Caricamento degli sprite...",
    "gui.loader.message3": "Caricamento dei suoni...",
    "gui.loader.message4": "Caricamento delle estensioni...",
    "gui.loader.message5": "Tranquillizzare i gatti...",
    "gui.loader.message6": "Trasmissione dei nano...",
    "gui.loader.message7": "Espansione dei gobo...",
    "gui.loader.message8": "Preparazione delle emoji...",
    "gui.loader.headline": "Caricamento del Progetto in corso",
    "gui.loader.creating": "Creazione del progetto in corso...",
    "gui.accountMenu.profile": "Profilo",
    "gui.accountMenu.myStuff": "Le mie Cose",
    "gui.accountMenu.myClasses": "Le mie Classi",
    "gui.accountMenu.myClass": "La mia Classe",
    "gui.accountMenu.accountSettings": "Impostazioni account",
    "gui.accountMenu.signOut": "Esci",
    "gui.authorInfo.byUser": "di {username}",
    "gui.menuBar.seeProjectPage": "Vai alla Pagina del Progetto",
    "gui.menuBar.language": "Lingua",
    "general.username": "Nome utente",
    "general.password": "Password",
    "general.signIn": "Entra",
    "login.needHelp": "Hai bisogno di aiuto?",
    "form.validationRequired": "Questa campo è obbligatorio",
    "gui.menuBar.tutorialsLibrary": "Tutorial",
    "gui.menuBar.restoreSprite": "Ripristina lo Sprite",
    "gui.menuBar.restoreSound": "Annulla rimozione Suono",
    "gui.menuBar.restoreCostume": "Annulla rimozione Costume",
    "gui.menuBar.restore": "Ripristina",
    "gui.menuBar.saveNow": "Salva ora",
    "gui.menuBar.saveAsCopy": "Salva una copia",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Nuovo",
    "gui.menuBar.file": "File",
    "gui.menuBar.downloadToComputer": "Salva sul tuo computer",
    "gui.menuBar.edit": "Modifica",
    "gui.menuBar.turboModeOff": "Disattiva Modalità Turbo",
    "gui.menuBar.turboModeOn": "Attiva Modalità Turbo",
    "gui.menuBar.modeMenu": "Modalità",
    "gui.menuBar.normalMode": "Modalità normale",
    "gui.menuBar.caturdayMode": "Modalità Gattbato",
    "gui.menuBar.joinScratch": "Unisciti alla comunità di Scratch",
    "gui.menuBar.signIn": "Entra",
    "gui.gui.projectTitlePlaceholder": "Inserisci il titolo del progetto",
    "gui.menuBar.saveNowLink": "Salva Ora",
    "gui.menuBar.settings": "Impostazioni",
    "gui.menuBar.isShared": "Condiviso",
    "gui.menuBar.share": "Condividi",
    "gui.menuBar.colorMode": "Colori",
    "gui.modal.help": "Aiuto",
    "gui.modal.back": "Indietro",
    "gui.monitor.listMonitor.empty": "(vuota)",
    "gui.monitor.listMonitor.listLength": "lunghezza {length}",
    "gui.monitor.contextMenu.default": "normale",
    "gui.monitor.contextMenu.large": "grande",
    "gui.monitor.contextMenu.slider": "cursore",
    "gui.monitor.contextMenu.sliderRange": "scegli min e max del cursore",
    "gui.monitor.contextMenu.import": "importa",
    "gui.monitor.contextMenu.export": "esporta",
    "gui.monitor.contextMenu.hide": "nascondi",
    "gui.playButton.play": "Riproduci",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Per tutti gli sprite",
    "gui.gui.variableScopeOptionSpriteOnly": "Solo per questo sprite",
    "gui.gui.cloudVariableOption": "Variabile cloud  (salvata sul server)",
    "gui.gui.variablePromptAllSpritesMessage": "Questa variabile potrà essere letta e modificata da tutti gli sprite.",
    "gui.gui.listPromptAllSpritesMessage": "Questa lista potrà essere letta e modificata da tutti gli sprite.",
    "gui.prompt.cancel": "Annulla",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Riproduci",
    "gui.playbackStep.loadingMsg": "Caricamento in corso...",
    "gui.playbackStep.saveMsg": "Salva",
    "gui.playbackStep.reRecordMsg": "Ripeti la registrazione",
    "gui.recordModal.title": "Registra Suono",
    "gui.recordingStep.beginRecord": "Inizia a registrare cliccando il pulsante qui sotto",
    "gui.recordingStep.permission": "{arrow}Ci occorre il tuo permesso per poter usare il microfono",
    "gui.recordingStep.stop": "Arresta la registrazione",
    "gui.recordingStep.record": "Registra",
    "gui.sliderModal.min": "Valore minimo",
    "gui.sliderModal.max": "Valore massimo",
    "gui.sliderModal.title": "Intervallo del cursore",
    "gui.sliderPrompt.cancel": "Annulla",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Suono",
    "gui.soundEditor.play": "Riproduci",
    "gui.soundEditor.stop": "Arresta",
    "gui.soundEditor.copy": "Copia",
    "gui.soundEditor.paste": "Incolla",
    "gui.soundEditor.copyToNew": "Copialo come Nuovo Suono",
    "gui.soundEditor.delete": "Cancella",
    "gui.soundEditor.save": "Salva",
    "gui.soundEditor.undo": "Annulla",
    "gui.soundEditor.redo": "Ripristina",
    "gui.soundEditor.faster": "Accelera",
    "gui.soundEditor.slower": "Rallenta",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Effetto Robot",
    "gui.soundEditor.louder": "Aumenta volume",
    "gui.soundEditor.softer": "Diminuisci volume",
    "gui.soundEditor.reverse": "Inverti",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Muto",
    "gui.SpriteInfo.spritePlaceholder": "Nome",
    "gui.SpriteInfo.showSpriteAction": "Mostra sprite",
    "gui.SpriteInfo.hideSpriteAction": "Nascondi sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Mostra",
    "gui.SpriteInfo.size": "Dimensione",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplica",
    "gui.spriteSelectorItem.contextMenuExport": "esporta",
    "gui.spriteSelectorItem.contextMenuDelete": "cancella",
    "gui.spriteSelector.addSpriteFromLibrary": "Scegli uno Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Disegna un nuovo sprite",
    "gui.spriteSelector.addSpriteFromSurprise": "Aggiungi uno sprite a Sorpresa",
    "gui.spriteSelector.addSpriteFromFile": "Importa Sprite",
    "gui.stageHeader.stageSizeLarge": "Passa alla visualizzazione con Stage grande",
    "gui.stageHeader.stageSizeSmall": "Passa alla visualizzazione con Stage ridotto",
    "gui.stageHeader.stageSizeFull": "Passa alla modalità presentazione",
    "gui.stageHeader.stageSizeUnFull": "Esci dalla modalità presentazione",
    "gui.stageHeader.fullscreenControl": "Pulsante modalità presentazione",
    "gui.spriteSelector.addBackdropFromLibrary": "Scegli uno Sfondo",
    "gui.stageSelector.addBackdropFromPaint": "Disegna un nuovo sfondo",
    "gui.stageSelector.addBackdropFromSurprise": "Aggiungi uno sfondo a Sorpresa",
    "gui.stageSelector.addBackdropFromFile": "Importa Sfondo",
    "gui.stageSelector.stage": "Stage",
    "gui.stageSelector.backdrops": "Sfondi",
    "gui.telemetryOptIn.label": "Trasmetti statistiche per migliorare Scratch",
    "gui.telemetryOptIn.body1": "Il Team di Scratch cerca continuamente di capire in che modo Scratch viene usato in tutto il mondo. Per supportare questo sforzo puoi permettere a Scratch di inviare automaticamente al Team di Scratch informazioni sul modo in cui lo usi.",
    "gui.telemetryOptIn.body2": "Le informazioni che raccogliamo includono il linguaggio selezionato, l'uso dei diversi blocchi e alcuni eventi come salvare, aprire e caricare un progetto. NON raccogliamo informazioni personali. Ti invitiamo a visitare la pagina della nostra {privacyPolicyLink} per ulteriori informazioni.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politica della Privacy",
    "gui.telemetryOptIn.optInText": "Condividi le mie statistiche di uso con lo Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Abilita telemetria",
    "gui.telemetryOptIn.optOutText": "Non condividere le mie statistiche di uso con lo Scratch Team ",
    "gui.telemetryOptIn.optOutTooltip": "Disabilita telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "Le impostazioni sono state aggiornate.",
    "gui.telemetryOptIn.buttonClose": "Chiudi",
    "gui.turboMode.active": "Modalità Turbo",
    "gui.webglModal.label": "Il Tuo Browser Non Supporta WebGL",
    "gui.webglModal.description": "Sfortunatamente sembra che il tuo browser o il tuo computer {webGlLink}. Questa tecnologia è necessaria per eseguire Scratch 3.0.",
    "gui.webglModal.webgllink": "non supporta WebGL",
    "gui.webglModal.back": "Indietro",
    "gui.webglModal.previewfaq": "Per saperne di più, vai alla pagina {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Domande Frequenti",
    "gui.costumeLibrary.chooseABackdrop": "Scegli uno Sfondo",
    "gui.costumeLibrary.chooseACostume": "Scegli un Costume",
    "gui.costumeTab.addBackdropFromLibrary": "Scegli uno Sfondo",
    "gui.costumeTab.addCostumeFromLibrary": "Scegli un Costume",
    "gui.costumeTab.addBlankCostume": "Disegna un nuovo costume",
    "gui.costumeTab.addSurpriseCostume": "Scegli un costume a Sorpresa",
    "gui.costumeTab.addFileBackdrop": "Importa Sfondo",
    "gui.costumeTab.addFileCostume": "Importa Costume",
    "gui.extensionLibrary.chooseAnExtension": "Scegli una Estensione",
    "gui.extensionLibrary.extensionUrl": "Inserisci l'URL dell'estensione",
    "gui.monitors.importListColumnPrompt": "Quale colonna vuoi che venga usata (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Impossibile iniziare la registrazione",
    "gui.soundLibrary.chooseASound": "Scegli un Suono",
    "gui.soundTab.fileUploadSound": "Carica un Suono",
    "gui.soundTab.surpriseSound": "Aggiungi un suono a Sorpresa",
    "gui.soundTab.recordSound": "Registra",
    "gui.soundTab.addSoundFromLibrary": "Scegli un Suono",
    "gui.spriteLibrary.chooseASprite": "Scegli uno Sprite",
    "gui.tipsLibrary.tutorials": "Scegli un Tutorial.",
    "gui.alerts.createsuccess": "Creato nuovo progetto.",
    "gui.alerts.createcopysuccess": "Salvata una copia del progetto.",
    "gui.alerts.createremixsuccess": "Salvato un remix del progetto.",
    "gui.alerts.creating": "Creazione di un nuovo progetto in corso...",
    "gui.alerts.creatingCopy": "Copia del progetto in corso...",
    "gui.alerts.creatingRemix": "Remix del progetto in corso...",
    "gui.alerts.creatingError": "Impossibile creare il progetto. Prova di nuovo!",
    "gui.alerts.savingError": "Non è possibile salvare il progetto.",
    "gui.alerts.savesuccess": "Progetto salvato.",
    "gui.alerts.saving": "Salvataggio del progetto in corso...",
    "gui.alerts.cloudInfo": "Ricorda che le variabili cloud supportano solo numeri, non supportano lettere o simboli. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Per saperne di più.",
    "gui.alerts.importing": "Importazione in corso...",
    "gui.defaultProject.meow": "Miao",
    "gui.defaultProject.variable": "la mia variabile",
    "gui.howtos.intro-move-sayhello-hat.name": "Per Iniziare",
    "gui.howtos.intro-move.step_stepMove": "Aggiungi un blocco di movimento",
    "gui.howtos.add-a-move-block.step_stepSay": "Aggiungere un blocco dire",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Clicca la bandiera verde per avviarlo",
    "gui.howtos.intro-getting-started-ASL.name": "Per iniziare - ASL",
    "gui.howtos.animate-a-name.name": "Anima un nome",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Aggiungi una Lettera",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Produci un Suono Quando viene Cliccato",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Aggiungi un'Altra Lettera",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambiare colore",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Scegli un'Altra Lettera & Falla Ruotare",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Scegli un'Altra Lettera & Falla Ingrandire",
    "gui.howtos.imagine": "Immagina un Mondo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Inserisci Quello Che Voi Dire",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Clicca la Bandiera Verde per Avviarlo",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Scegli uno Sfondo a Piacere",
    "gui.howtos.imagine.step_imagineChooseSprite": "Scegli uno Sprite a Piacere",
    "gui.howtos.imagine.step_imagineFlyAround": "Premi il Tasto Spazio per Scivolare",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Scegli un Altro Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Spostati a Destra e a Sinistra",
    "gui.howtos.imagine.step_imagineUpDown": "Spostati in Su e in Giù",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Cambia Costume",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Scivola verso un Punto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Ingrandire e Ridurre",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Scegli un Altro Sfondo",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cambiare Sfondo",
    "gui.howtos.imagine.step_imagineRecordASound": "Aggiungere un Suono",
    "gui.howtos.imagine.step_imagineChooseSound": "Scegli il Tuo Suono",
    "gui.howtos.make-music.name": "Crea un po' di Musica",
    "gui.howtos.Make-Music.step_PickInstrument": "Scegli uno Sprite Strumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Produci un Suono Quando viene Cliccato",
    "gui.howtos.Make-Music.step_MakeSong": "Creare una Canzone",
    "gui.howtos.make-music.step_MakeBeat": "Scegliere un Tamburo & Creare un Ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Scegliere lo sprite Microfono & un Beatbox a sorpresa",
    "gui.howtos.story.name": "Creare Una Storia",
    "gui.howtos.story.step_addbg": "Aggiungi uno Sfondo",
    "gui.howtos.story.step_addsprite": "Aggiungere un Personaggio",
    "gui.howtos.story.step_saysomething": "Dire Qualcosa",
    "gui.howtos.story.step_addanothersprite": "Aggiungere un'altro Personaggio",
    "gui.howtos.story.step_flip": "Invertire la Direzione",
    "gui.howtos.story.step_conversation": "Fare Una Conversazione",
    "gui.howtos.story.addanotherbg": "Aggiungere un'altro Sfondo",
    "gui.howtos.story.step_swithbg": "Cambiare gli Sfondi",
    "gui.howtos.story.step_hidewizard": "Nascondere un Personaggio",
    "gui.howtos.story.step_showwizard": "Mostrare un Personaggio",
    "gui.howtos.make-a-chase-game.name": "Crea un Gioco di Acchiapparella",
    "gui.howtos.Chase-Game.step_BG": "Aggiungi uno Sfondo",
    "gui.howtos.chase-game.step_AddOcto": "Aggiungi uno Sprite",
    "gui.howtos.make-music.step_LeftRight": "Muoversi a Destra & a Sinistra con i Tasti Freccia",
    "gui.howtos.Chase-Game.step_UpDown": "Muoversi in Su & in Giù con i Tasti Freccia",
    "gui.howtos.Chase-Game.step_AddStar": "Aggiungere un'Altro Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Muoversi a Caso",
    "gui.howtos.Chase-Game.step_WhenTouch": "Nello Sprite Piovra, Quando si Tocca Riproduce un Suono",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crea una Variabile per tenere il Punteggio",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Nello Sprite Piovra, Quando si Tocca Aumenta il Punteggio",
    "gui.howtos.animate-char.name": "Animare un Personaggio",
    "gui.howtos.animate-char.step_addbg": "Aggiungi uno Sfondo",
    "gui.howtos.animate-char.step_addsprite": "Aggiungi uno Sprite",
    "gui.howtos.animate-char.step_saysomething": "Dire Qualcosa",
    "gui.howtos.animate-char.step_addsound": "Aggiungi un Suono",
    "gui.howtos.animate-char.step_animatetalking": "Anima la Bocca",
    "gui.howtos.animate-char.step_arrowkeys": "Muoversi Usando i Tasti Freccia",
    "gui.howtos.animate-char.step_jump": "Saltare",
    "gui.howtos.animate-char.step_changecolor": "Cambiare Colore",
    "gui.howtos.make-a-game.name": "Crea un Click Game",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Scegli uno Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Produrre un Suono Quando viene Cliccato",
    "gui.howtos.make-a-game.step_GameAddScore": "Creare una Variabile per tenere il Punteggio",
    "gui.howtos.make-a-game.step_GameChangeScore": "Aumentare il punteggio ogni volta che si clicca",
    "gui.howtos.make-a-game.step_Random": "Andare ad una posizione a caso",
    "gui.howtos.make-music.step_GameChangeColor": "Cambiare Colore",
    "gui.howtos.make-music.step_ResetScore": "Azzerare il Punteggio",
    "gui.howtos.make-it-fly.name": "Fallo Volare",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Scegli uno Sfondo come Cielo",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Scegli un Personaggio",
    "gui.howtos.fly.step_stepflySaySomething": "Dire Qualcosa",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Muoversi con le Frecce",
    "gui.howtos.fly.step_stepflyChooseObject": "Scegli un Oggetto da Raccogliere",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fai Muovere l'Oggetto",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Seleziona un Personaggio",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Aggiungi il Punteggio",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Tenere il Punteggio",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Aggiungi uno Scenario",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Muovi lo Sfondo",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Costume Successivo",
    "gui.howtos.pong": "Gioco del Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Aggiungi uno Sfondo",
    "gui.howtos.pong.step_pongAddBallSprite": "Aggiungi uno Sprite come Palla",
    "gui.howtos.pong.step_pongBounceAround": "Rimbalza Qua e Là",
    "gui.howtos.pong.step_pongAddPaddle": "Aggiungi una Racchetta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Muovere la Racchetta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Seleziona lo Sprite Palla",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Aggiungere Codice per far Rimbalzare la Palla sulla Racchetta",
    "gui.howtos.pong.step_pongAddAScore": "Aggiungi il Punteggio",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Scegli 'Punteggio' nel Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Inserisci il Blocco 'Cambia Punteggio'",
    "gui.howtos.pong.step_pongResetScore": "Azzerare il Punteggio",
    "gui.howtos.pong.step_pongAddLineSprite": "Aggiungere lo Sprite Linea",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Programmare un Cartone Animato",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dire Qualcosa Quando Clicchi la Bandiera Verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animare un Personaggio Quando Lo Clicchi",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selezionare un Diverso Personaggio",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usare il Segno Meno per Diventare Più Piccolo",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Far Ingrandire o Ridurre un Personaggio",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selezionare un Diverso Personaggio",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Saltare Su e Giù",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Cliccare un Personaggio per Cambiare Scena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Scivola di Qua e di Là",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Cambia Costume",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Scegli Altri Personaggi da Aggiungere al Tuo Cartone Animato",
    "gui.howtos.cartoon-network": "Animare un'Avventura",
    "gui.howtos.cartoon-network.step_CNcharacter": "Scegli un Personaggio da Mostrare",
    "gui.howtos.cartoon-network.step_CNsay": "Dire Qualcosa",
    "gui.howtos.cartoon-network.step_CNglide": "Scivola di Qua e di Là",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Scegli un Oggetto da Acchiappare",
    "gui.howtos.cartoon-network.step_CNcollect": "Raccogli gli Oggetti",
    "gui.howtos.cartoon-network.step_CNvariable": "Crea una Variabile per il Punteggio",
    "gui.howtos.cartoon-network.step_CNscore": "Tenere il Punteggio",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Impariamo qualcosa di Nuovo: come Cambiare lo Sfondo",
    "gui.howtos.videosens.name": "Movimento Webcam",
    "gui.howtos.videosens.step_addextension": "Aggiungi un'Estensione",
    "gui.howtos.videosens.step_pet": "Coccolare il Gatto",
    "gui.howtos.videosens.step_animate": "Animare",
    "gui.howtos.videosens.step_pop": "Far Esplodere un Pallone",
    "gui.howtos.say-it-out-loud": "Creare Animazioni Che Parlano",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Aggiungere i blocchi da Testo a Voce",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dire Qualcosa",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Scegli una Voce",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Muoviti Qua e Là",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Aggiungi uno Sfondo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Aggiungere un'Altro Personaggio",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Canta una Canzone",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambiare Colore",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Fare la Trottola",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Ingrandire e Rimpicciolire",
    "gui.howtos.talking": "Favole Parlanti",
    "gui.howtos.talking.step_talesAddExtension": "Cliccare per Aggiungere i Blocchi Da Testo A Voce",
    "gui.howtos.talking.step_talesChooseSprite": "Scegli uno Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Far Parlare un Personaggio",
    "gui.howtos.talking.step_talesChooseBackdrop": "Scegli uno Sfondo",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Cliccare un Personaggio per Andare allo Sfondo Seguente",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Scegli un Altro Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Muoviti Qua e Là",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Scegli un Altro Sfondo",
    "gui.howtos.talking.step_talesAnimateTalking": "Anima la Bocca",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Scegli un Altro Sfondo",
    "gui.howtos.talking.step_talesChooseSound": "Scegliere una Canzone su cui Ballare sulle Note",
    "gui.howtos.talking.step_talesDanceMoves": "Movimenti di Ballo",
    "gui.howtos.talking.step_talesAskAnswer": "Prendi i blocchi Chiedi e Risposta dalla Categoria Sensori",
    "gui.howtos.add-sprite.name": "Aggiungi uno Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Aggiungi uno Sprite",
    "gui.howtos.add-a-backdrop.name": "Aggiungi uno Sfondo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Aggiungi uno Sfondo",
    "gui.howtos.change-size.name": "Cambia Dimensione",
    "gui.howtos.change-size.step_changeSize": "Cambia Dimensione",
    "gui.howtos.glide-around.name": "Scivola di Qua e di Là",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Scivola di Qua e di Là",
    "gui.howtos.change-size.step_glideAroundPoint": "Scivola verso un Punto",
    "gui.howtos.record-a-sound.name": "Registra un Suono",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clicca la Scheda 'Suoni'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clicca 'Registra'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Premi il Pulsante Registra",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Scegli il Tuo Suono",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Fai Riprodurre il Suono",
    "gui.howtos.spin-video.name": "Falla Ruotare",
    "gui.howtos.change-size.step_spinTurn": "Gira",
    "gui.howtos.change-size.step_spinPointInDirection": "Definire la Direzione",
    "gui.howtos.hide-and-show.name": "Mostra e Nascondi",
    "gui.howtos.change-size.step_hideAndShow": "Mostra e Nascondi",
    "gui.howtos.switch-costume.name": "Anima uno Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Anima uno Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Usa i Tasti Freccia",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Spostarsi a Destra e a Sinistra",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Muoversi in Su e in Giù",
    "gui.howtos.add-effects.name": "Aggiungi qualche Effetto",
    "gui.howtos.videosens.step_addEffects": "Aggiungi qualche Effetto",
    "gui.extension.music.name": "Musica",
    "gui.extension.music.description": "Suona strumenti e percussioni.",
    "gui.extension.pen.name": "Penna",
    "gui.extension.pen.description": "Disegna usando gli sprite.",
    "gui.extension.videosensing.name": "Movimento Webcam",
    "gui.extension.videosensing.description": "Rileva il movimento con la tua webcam.",
    "gui.extension.text2speech.name": "Da Testo a Voce",
    "gui.extension.text2speech.description": "Fai parlare i tuoi progetti",
    "gui.extension.translate.name": "Traduci",
    "gui.extension.translate.description": "Traduci un testo in molte altre lingue.",
    "gui.extension.makeymakey.description": "Trasforma qualunque cosa in un pulsante",
    "gui.extension.microbit.description": "Collega il tuo progetto con il mondo che ti circonda",
    "gui.extension.microbit.connectingMessage": "Collegamento in corso",
    "gui.extension.ev3.description": "Costruisci robot interattivi e altro ancora.",
    "gui.extension.ev3.connectingMessage": "Connessione in corso. Assicurati che il pin sul tuo EV3 sia 1234.",
    "gui.extension.boost.description": "Dai vita alle tue creazione robotiche.",
    "gui.extension.boost.connectingMessage": "Collegamento in corso",
    "gui.extension.wedo2.description": "Costruisci qualcosa usando motori e sensori.",
    "gui.extension.wedo2.connectingMessage": "Collegamento in corso",
    "gui.extension.gdxfor.description": "Rileva spinte, trazioni, movimenti e rotazioni.",
    "gui.extension.gdxfor.connectingMessage": "Collegamento in corso",
    "gui.libraryTags.all": "Tutti",
    "gui.libraryTags.animals": "Animali",
    "gui.libraryTags.dance": "Danza",
    "gui.libraryTags.effects": "Effetti",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Cibi",
    "gui.libraryTags.indoors": "Interni",
    "gui.libraryTags.loops": "Loop",
    "gui.libraryTags.music": "Musica",
    "gui.libraryTags.notes": "Note",
    "gui.libraryTags.outdoors": "Esterni",
    "gui.libraryTags.patterns": "Pattern",
    "gui.libraryTags.people": "Persone",
    "gui.libraryTags.percussion": "Percussioni",
    "gui.libraryTags.space": "Spazio",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Fondo del mare",
    "gui.libraryTags.voice": "Voce",
    "gui.libraryTags.wacky": "Strani",
    "gui.libraryTags.animation": "Animazioni",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Giochi",
    "gui.libraryTags.stories": "Storie",
    "gui.libraryTags.letters": "Lettere",
    "gui.opcodeLabels.direction": "direzione",
    "gui.opcodeLabels.xposition": "posizione x",
    "gui.opcodeLabels.yposition": "posizione y",
    "gui.opcodeLabels.size": "dimensione",
    "gui.opcodeLabels.costumename": "nome del costume",
    "gui.opcodeLabels.costumenumber": "numero del costume",
    "gui.opcodeLabels.backdropname": "nome dello sfondo",
    "gui.opcodeLabels.backdropnumber": "numero dello sfondo",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "risposta",
    "gui.opcodeLabels.loudness": "volume microfono",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "anno",
    "gui.opcodeLabels.month": "mese",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "giorno della settimana",
    "gui.opcodeLabels.hour": "ora",
    "gui.opcodeLabels.minute": "minuti",
    "gui.opcodeLabels.second": "secondi",
    "gui.opcodeLabels.timer": "cronometro",
    "gui.projectLoader.loadError": "Il caricamento del progetto selezionato è fallito.",
    "gui.sharedMessages.backdrop": "sfondo{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Vuoi rimpiazzare il contenuto del progetto corrente?",
    "gui.sharedMessages.loadFromComputerTitle": "Carica dal computer",
    "gui.theme.default": "Originali",
    "gui.theme.dark": "Scura",
    "gui.theme.highContrast": "Elevato Contrasto",
    "gui.gui.defaultProjectTitle": "Progetto Scratch",
    "boost.color.any": "colore qualunque",
    "boost.color.black": "nero",
    "boost.color.blue": "blu",
    "boost.color.green": "verde",
    "boost.color.red": "rosso",
    "boost.color.white": "bianco",
    "boost.color.yellow": "giallo",
    "boost.getMotorPosition": "posizione motore [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "angolo inclinazione [TILT_DIRECTION]",
    "boost.motorDirection.backward": "da quella parte",
    "boost.motorDirection.forward": "da questa parte",
    "boost.motorDirection.reverse": "inversa",
    "boost.motorOff": "spegni motore [MOTOR_ID]",
    "boost.motorOn": "accendi motore [MOTOR_ID]",
    "boost.motorOnFor": "accendi motore [MOTOR_ID] per [DURATION] secondi",
    "boost.motorOnForRotation": "accendi motore [MOTOR_ID] per [ROTATION] rotazioni",
    "boost.seeingColor": "vedo mattoncino [COLOR]",
    "boost.setLightHue": "porta colore luci a [HUE]",
    "boost.setMotorDirection": "porta direzione motore [MOTOR_ID] a [MOTOR_DIRECTION]",
    "boost.setMotorPower": "porta potenza [MOTOR_ID] a [POWER]",
    "boost.tiltDirection.any": "in direzione qualunque",
    "boost.tiltDirection.down": "in giù",
    "boost.tiltDirection.left": "a sinistra",
    "boost.tiltDirection.right": "a destra",
    "boost.tiltDirection.up": "in su",
    "boost.whenColor": "quando vedo mattoncino [COLOR]",
    "boost.whenTilted": "quando inclinato [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "emetti nota [NOTE] per [TIME] secondi",
    "ev3.buttonPressed": "pulsante [PORT] premuto",
    "ev3.getBrightness": "luminosità",
    "ev3.getDistance": "distanza",
    "ev3.getMotorPosition": "posizione motore [PORT]",
    "ev3.motorSetPower": "porta potenza motore [PORT] a [POWER] %",
    "ev3.motorTurnClockwise": "aziona il motore [PORT] in questa direzione per [TIME] secondi",
    "ev3.motorTurnCounterClockwise": "azione il motore [PORT] nell'altra direzione per [TIME] secondi",
    "ev3.whenBrightnessLessThan": "quando luminosità < [DISTANCE]",
    "ev3.whenButtonPressed": "quando pulsante [PORT] premuto",
    "ev3.whenDistanceLessThan": "quando distanza < [DISTANCE]",
    "gdxfor.getAcceleration": "accelerazione [DIRECTION]",
    "gdxfor.getForce": "forza",
    "gdxfor.getSpin": "velocità di rotazione [DIRECTION]",
    "gdxfor.getTilt": "angolo inclinazione [TILT]",
    "gdxfor.isFreeFalling": "sto cadendo",
    "gdxfor.isTilted": "inclinato [TILT]",
    "gdxfor.pulled": "vengo tirato",
    "gdxfor.pushed": "sono spinto",
    "gdxfor.shaken": "è scosso",
    "gdxfor.startedFalling": "inizia a cadere",
    "gdxfor.tiltDirectionMenu.any": "in direzione qualunque",
    "gdxfor.tiltDirectionMenu.back": "indietro",
    "gdxfor.tiltDirectionMenu.front": "in avanti",
    "gdxfor.tiltDirectionMenu.left": "a sinistra",
    "gdxfor.tiltDirectionMenu.right": "a destra",
    "gdxfor.turnedFaceDown": "è a faccia in giù",
    "gdxfor.turnedFaceUp": "è a faccia in su",
    "gdxfor.whenForcePushedOrPulled": "quando il sensore di forza rileva che [PUSH_PULL]",
    "gdxfor.whenGesture": "quando [GESTURE]",
    "gdxfor.whenTilted": "quando inclinato [TILT]",
    "makeymakey.downArrow": "freccia giù",
    "makeymakey.downArrowShort": "giù",
    "makeymakey.leftArrow": "freccia sinistra",
    "makeymakey.leftArrowShort": "a sinistra",
    "makeymakey.rightArrow": "freccia destra",
    "makeymakey.rightArrowShort": "a destra",
    "makeymakey.spaceKey": "spazio",
    "makeymakey.upArrow": "freccia su",
    "makeymakey.upArrowShort": "su",
    "makeymakey.whenKeyPressed": "quando si preme il tasto [KEY]",
    "makeymakey.whenKeysPressedInOrder": "quando si preme la sequenza di tasti [SEQUENCE]",
    "microbit.buttonsMenu.any": "in direzione qualunque",
    "microbit.clearDisplay": "cancella display",
    "microbit.defaultTextToDisplay": "Ciao!",
    "microbit.displaySymbol": "mostra [MATRIX] su display",
    "microbit.displayText": "mostra testo [TEXT]",
    "microbit.gesturesMenu.jumped": "salta",
    "microbit.gesturesMenu.moved": "si muove",
    "microbit.gesturesMenu.shaken": "si scuote",
    "microbit.isButtonPressed": "pulsante [BTN] premuto",
    "microbit.isTilted": "inclinato [DIRECTION]",
    "microbit.pinStateMenu.off": "spento",
    "microbit.pinStateMenu.on": "acceso",
    "microbit.tiltAngle": "angolo inclinazione [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "in direzione qualunque",
    "microbit.tiltDirectionMenu.back": "indietro",
    "microbit.tiltDirectionMenu.front": "in avanti",
    "microbit.tiltDirectionMenu.left": "a sinistra",
    "microbit.tiltDirectionMenu.right": "a destra",
    "microbit.whenButtonPressed": "quando pulsante [BTN] premuto",
    "microbit.whenGesture": "quando [GESTURE]",
    "microbit.whenPinConnected": "quando il pin [PIN] è collegato",
    "microbit.whenTilted": "quando inclinato [DIRECTION]",
    "music.categoryName": "Musica",
    "music.changeTempo": "cambia tempo di [TEMPO]",
    "music.drumBass": "(2) Grancassa",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabassa",
    "music.drumClaves": "(9) Legnetti",
    "music.drumClosedHiHat": "(6) Charleston",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Campanaccio",
    "music.drumCrashCymbal": "(4) Piatto Crash",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Battimano",
    "music.drumOpenHiHat": "(5) Hi-Hat aperto",
    "music.drumSideStick": "(3) Bacchette",
    "music.drumSnare": "(1) Rullante",
    "music.drumTambourine": "(7) Tamburello",
    "music.drumTriangle": "(12) Triangolo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Blocchetto di legno",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Basso elettrico",
    "music.instrumentBassoon": "(14) Fagotto",
    "music.instrumentCello": "(8) Violoncello",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinetto",
    "music.instrumentElectricGuitar": "(5) Chitarra elettrica",
    "music.instrumentElectricPiano": "(2) Piano elettrico",
    "music.instrumentFlute": "(12) Flauto",
    "music.instrumentGuitar": "(4) Chitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Carillon",
    "music.instrumentOrgan": "(3) Organo",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Sassofono",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Sintetizzatore",
    "music.instrumentSynthPad": "(21) Sintetizzatore (suoni di sottofondo)",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafono",
    "music.instrumentWoodenFlute": "(13) Flauto di legno",
    "music.midiPlayDrumForBeats": "suona tamburo [DRUM] per [BEATS] battute",
    "music.midiSetInstrument": "passa a strumento [INSTRUMENT]",
    "music.playDrumForBeats": "suona il tamburo [DRUM] per [BEATS] battute",
    "music.playNoteForBeats": "suona la nota [NOTE] per [BEATS] battute",
    "music.restForBeats": "pausa di [BEATS] battute",
    "music.setInstrument": "passa a strumento [INSTRUMENT]",
    "music.setTempo": "imposta tempo a [TEMPO] bpm",
    "pen.categoryName": "Penna",
    "pen.changeColorParam": "cambia [COLOR_PARAM] penna di [VALUE]",
    "pen.changeHue": "cambia colore penna di [HUE]",
    "pen.changeShade": "cambia luminosità penna di [SHADE]",
    "pen.changeSize": "cambia spessore penna di [SIZE]",
    "pen.clear": "pulisci",
    "pen.colorMenu.brightness": "luminosità",
    "pen.colorMenu.color": "colore",
    "pen.colorMenu.saturation": "intensità colore",
    "pen.colorMenu.transparency": "trasparenza",
    "pen.penDown": "penna giù",
    "pen.penUp": "penna su",
    "pen.setColor": "usa penna di colore [COLOR]",
    "pen.setColorParam": "porta [COLOR_PARAM] penna a [VALUE]",
    "pen.setHue": "usa penna di colore [HUE]",
    "pen.setShade": "porta luminosità penna a [SHADE]",
    "pen.setSize": "usa penna di spessore [SIZE]",
    "pen.stamp": "timbra",
    "speech.defaultWhenIHearValue": "via!",
    "speech.extensionName": "Riconoscimento della voce",
    "speech.listenAndWait": "ascolta e attendi",
    "speech.speechReporter": "parole pronunciate",
    "speech.whenIHear": "quando sento [PHRASE]",
    "text2speech.alto": "da contralto",
    "text2speech.categoryName": "Da Testo a Voce",
    "text2speech.defaultTextToSpeak": "ciao",
    "text2speech.giant": "da gigante",
    "text2speech.kitten": "da gattino",
    "text2speech.setLanguageBlock": "usa lingua [LANGUAGE]",
    "text2speech.setVoiceBlock": "usa voce [VOICE]",
    "text2speech.speakAndWaitBlock": "pronuncia [WORDS]",
    "text2speech.squeak": "stridula",
    "text2speech.tenor": "da tenore",
    "translate.categoryName": "Traduci",
    "translate.defaultTextToTranslate": "ciao",
    "translate.translateBlock": "traduci [WORDS] in [LANGUAGE]",
    "translate.viewerLanguage": "lingua",
    "videoSensing.categoryName": "Movimento Webcam",
    "videoSensing.direction": "direzione",
    "videoSensing.motion": "movimento",
    "videoSensing.off": "spegni",
    "videoSensing.on": "accendi",
    "videoSensing.onFlipped": "accendi e inverti orizzontalmente",
    "videoSensing.setVideoTransparency": "porta trasparenza webcam a [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "stage",
    "videoSensing.videoOn": "[ATTRIBUTE] del video su [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] il video della webcam",
    "videoSensing.whenMotionGreaterThan": "quando movimento video è > [REFERENCE]",
    "wedo2.getDistance": "distanza",
    "wedo2.getTiltAngle": "angolo inclinazione [TILT_DIRECTION]",
    "wedo2.isTilted": "inclinato [TILT_DIRECTION_ANY]",
    "wedo2.motorDirection.backward": "da quella parte",
    "wedo2.motorDirection.forward": "da questa parte",
    "wedo2.motorDirection.reverse": "inversa",
    "wedo2.motorId.a": "motore A",
    "wedo2.motorId.all": "tutti i motori",
    "wedo2.motorId.b": "motore B",
    "wedo2.motorId.default": "motore",
    "wedo2.motorOff": "spegni [MOTOR_ID]",
    "wedo2.motorOn": "accendi [MOTOR_ID]",
    "wedo2.motorOnFor": "accendi [MOTOR_ID] per [DURATION] secondi",
    "wedo2.playNoteFor": "suona nota [NOTE] per [DURATION] secondi",
    "wedo2.setLightHue": "porta colore luci a [HUE]",
    "wedo2.setMotorDirection": "porta direzione [MOTOR_ID] a [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "porta potenza [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "in direzione qualunque",
    "wedo2.tiltDirection.down": "in giù",
    "wedo2.tiltDirection.left": "a sinistra",
    "wedo2.tiltDirection.right": "a destra",
    "wedo2.tiltDirection.up": "in su",
    "wedo2.whenDistance": "quando distanza [OP] [REFERENCE]",
    "wedo2.whenTilted": "quando inclinato [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Colore",
    "paint.paintEditor.saturation": "Saturazione",
    "paint.paintEditor.brightness": "Luminosità",
    "paint.paintEditor.costume": "Costume",
    "paint.paintEditor.group": "Raggruppa",
    "paint.paintEditor.ungroup": "Separa",
    "paint.paintEditor.undo": "Annulla",
    "paint.paintEditor.redo": "Ripristina",
    "paint.paintEditor.forward": "Porta avanti",
    "paint.paintEditor.backward": "Porta indietro",
    "paint.paintEditor.front": "Primo piano",
    "paint.paintEditor.back": "Secondo piano",
    "paint.paintEditor.more": "Altro",
    "paint.modeTools.brushSize": "Dimensione",
    "paint.modeTools.eraserSize": "Dimensione gomma",
    "paint.modeTools.copy": "Copia",
    "paint.modeTools.paste": "Incolla",
    "paint.modeTools.delete": "Cancella",
    "paint.modeTools.curved": "Curva",
    "paint.modeTools.pointed": "Angolo",
    "paint.modeTools.thickness": "Spessore",
    "paint.modeTools.flipHorizontal": "Rifletti in Orizzontale",
    "paint.modeTools.flipVertical": "Capovolgi",
    "paint.modeTools.filled": "Riempito",
    "paint.modeTools.outlined": "Contorno",
    "paint.paintEditor.bitmap": "Converti in Bitmap",
    "paint.paintEditor.vector": "Converti in Vettoriale",
    "paint.paintEditor.fill": "Riempimento",
    "paint.paintEditor.stroke": "Contorno",
    "paint.brushMode.brush": "Pennello",
    "paint.eraserMode.eraser": "Gomma",
    "paint.fillMode.fill": "Riempimento",
    "paint.lineMode.line": "Linea",
    "paint.ovalMode.oval": "Cerchio",
    "paint.rectMode.rect": "Rettangolo",
    "paint.reshapeMode.reshape": "Modifica contorno",
    "paint.roundedRectMode.roundedRect": "Rettangolo Arrotondato",
    "paint.selectMode.select": "Seleziona",
    "paint.textMode.text": "Testo",
    "paint.colorPicker.swap": "Scambia"
  },
  "ka": {
    "gui.alerts.lostPeripheralConnection": "Scratch-მა დაკარგა კავშირი {extensionName}-თან.",
    "gui.alerts.tryAgain": "კიდევ სცადე",
    "gui.alerts.download": "ჩამოტვირთვა",
    "gui.connection.reconnect": "ხელახლა დაკავშირება",
    "gui.backpack.costumeLabel": "კოსტიუმი",
    "gui.backpack.soundLabel": "ხმა",
    "gui.backpack.scriptLabel": "სკრიპტი",
    "gui.backpack.spriteLabel": "სპრაიტი",
    "gui.backpack.header": "ზურგჩანთა",
    "gui.backpack.errorBackpack": "შეცდომა ზურგჩანთის ჩატვირთვისას",
    "gui.backpack.loadingBackpack": "იტვირთება...",
    "gui.backpack.more": "სხვა",
    "gui.backpack.emptyBackpack": "ზურგჩანთა ცარიელია",
    "gui.unsupportedBrowser.label": "ბრაუზერის მხარდაჭერა არ არის",
    "gui.unsupportedBrowser.errorLabel": "შეცდომა მოხდა",
    "gui.unsupportedBrowser.notRecommended": "ძალიან ვწუხვართ, მაგრამ როგორც ეტყობა, თქვენ იყენებთ  Scratch-თან შეუთავსებელ ბრაუზერის ვერსიას. გირჩევთ გამოიყენოთ ერთ-ერთი თავსებადი ბრაუზერის - Google Chrome, Mozilla Firefox, Microsoft Edge ან Apple Safari-ის უახლესი ვერსია.",
    "gui.unsupportedBrowser.description": "ძალიან ვწუხვართ, მაგრამ ეს ბრაუზერი შეუთავსებელია Scratch-თან. გირჩევთ გამოიყენოთ ერთ-ერთი თავსებადი ბრაუზერის - Google Chrome, Mozilla Firefox, Microsoft Edge ან Apple Safari-ის უახლესი ვერსია.",
    "gui.unsupportedBrowser.back": "უკან",
    "gui.unsupportedBrowser.previewfaq": "მეტის გასაგებად, გადადი {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "კითხვა-პასუხი",
    "gui.cards.all-tutorials": "გაკვეთილები",
    "gui.cards.shrink": "აკეცვა",
    "gui.cards.expand": "გაშლა",
    "gui.cards.close": "დახურვა",
    "gui.cards.more-things-to-try": "სცადე უფრო მეტი!",
    "gui.cards.see-more": "მეტის ნახვა",
    "gui.comingSoon.message1": "ნუ ღელავ, ჩვენ ვმუშაობთ ამ პრობლემაზე {emoji}",
    "gui.comingSoon.message2": "მალე იქნება...",
    "gui.comingSoon.message3": "ჩვენ ვმუშაობთ ამ პრობლემაზე {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "მოწყობილობა ვერ მოიძებნა",
    "gui.connection.auto-scanning.prescan": "თან იქონიეთ თქვენი მოწყობილობა, შემდეგ დაიწყეთ ძებნა.",
    "gui.connection.auto-scanning.pressbutton": "დააჭირეთ თქვენი მოწყობილობის ღილაკზე.",
    "gui.connection.auto-scanning.start-search": "ძებნის დაწყება",
    "gui.connection.connecting-searchbutton": "იძებნება...",
    "gui.connection.auto-scanning.try-again": "კიდევ სცადე",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "დაკავშირებულია",
    "gui.connection.disconnect": "კავშირის გაწყვეტა",
    "gui.connection.go-to-editor": "რედაქტორზე გადასვლა",
    "gui.connection.connecting-cancelbutton": "კავშირი მყარდება...",
    "gui.connection.error.errorMessage": "უკაცრავად, როგორც ჩანს შეცდომა მოხდა.",
    "gui.connection.error.tryagainbutton": "კიდევ სცადე",
    "gui.connection.error.helpbutton": "დახმარება",
    "gui.connection.peripheral-name-label": "მოწყობილობის სახელი",
    "gui.connection.connect": "დაკავშირება",
    "gui.connection.scanning.lookingforperipherals": "მიმდინარეობს მოწყობილობის ძებნა",
    "gui.connection.scanning.noPeripheralsFound": "მოწყობილობა ვერ მოიძებნა",
    "gui.connection.scanning.instructions": "აირჩიე შენი მოწყობილობა ამ სიიდან",
    "gui.connection.search": "განახლება",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "დარწმუნდი, რომ Scratch Link დაყენებულია და მუშაობს",
    "gui.connection.unavailable.enablebluetooth": "დარწმუნდი, რომ Bluetooth ჩართულია",
    "gui.connection.unavailable.tryagainbutton": "კიდევ სცადე",
    "gui.connection.unavailable.helpbutton": "დახმარება",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "გადასვლა",
    "gui.controls.stop": "გაჩერება",
    "gui.crashMessage.label": "უკაცრავად, შეცდომა მოხდა.",
    "gui.crashMessage.description": "ვწუხვართ, მაგრამ როგორც ეტყობა, Scratch-მა მარცხი განიცადა. შეტყობინება შეცდომის შესახებ ავტომატურად გაეგზავნა Scratch-ის გუნდს. გთხოვთ განაახლოთ გვერდი კვლავ საცდელად.",
    "gui.crashMessage.errorNumber": "თქვენი შეცდომა აღრიცხულია იდენტიფიკატორით {errorId}",
    "gui.crashMessage.reload": "ხელახლა ჩატვირთვა",
    "gui.customProcedures.myblockModalTitle": "შექმენი ბლოკი",
    "gui.customProcedures.addAnInputNumberText": "დაამატე შესაყვანი",
    "gui.customProcedures.numberTextType": "რიცხვი ან ტექსტი",
    "gui.customProcedures.addAnInputBoolean": "დაამატე შესაყვანი",
    "gui.customProcedures.booleanType": "ლოგიკური",
    "gui.customProcedures.addALabel": "დაამატე იარლიყი",
    "gui.customProcedures.runWithoutScreenRefresh": "მუშაობა ეკრანის განახლების გარეშე",
    "gui.customProcedures.cancel": "გააუქმება",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "მიმართულება",
    "gui.directionPicker.rotationStyles.allAround": "გარშემო",
    "gui.directionPicker.rotationStyles.leftRight": "მარცხენა/მარჯვენა",
    "gui.directionPicker.rotationStyles.dontRotate": "ტრიალის გარეშე",
    "gui.gui.addExtension": "გაფართოების დამატება",
    "gui.gui.codeTab": "კოდი",
    "gui.gui.backdropsTab": "ფონები",
    "gui.gui.costumesTab": "კოსტიუმები",
    "gui.gui.soundsTab": "ხმები",
    "gui.extensionLibrary.comingSoon": "მალე იქნება",
    "gui.extensionLibrary.requires": "მოითხოვს",
    "gui.extensionLibrary.collaboration": "თანამშრომლობაში",
    "gui.library.filterPlaceholder": "ძიება",
    "gui.library.allTag": "ყველა",
    "gui.loader.message1": "იქმნება ბლოკები...",
    "gui.loader.message2": "იტვირთება სპრაიტები...",
    "gui.loader.message3": "იტვირთება ხმები...",
    "gui.loader.message4": "იტვირთება გაფართოებები",
    "gui.loader.message5": "კატების მწყემსვა...",
    "gui.loader.message6": "ნანოების გადაცემა...",
    "gui.loader.message7": "გობოების გაბერვა...",
    "gui.loader.message8": "ემოჯის დამზადება...",
    "gui.loader.headline": "პროექტი იტვირთება",
    "gui.loader.creating": "იქმნება პროექტი",
    "gui.accountMenu.profile": "პროფილი",
    "gui.accountMenu.myStuff": "ჩემი ნაშრომები",
    "gui.accountMenu.myClasses": "ჩემი კლასები",
    "gui.accountMenu.myClass": "ჩემი კლასი",
    "gui.accountMenu.accountSettings": "ანგარიშის პარამეტრები",
    "gui.accountMenu.signOut": "გამოსვლა",
    "gui.authorInfo.byUser": "{username} მიერ",
    "gui.menuBar.seeProjectPage": "იხილე პროექტის გვერდი",
    "gui.menuBar.language": "Language",
    "general.username": "მომხმარებლის სახელი",
    "general.password": "პაროლი",
    "general.signIn": "შესვლა",
    "login.needHelp": "დახმარება გჭირდება?",
    "form.validationRequired": "ამ ველის შევსება აუცილებელია",
    "gui.menuBar.tutorialsLibrary": "გაკვეთილები",
    "gui.menuBar.restoreSprite": "სპრაიტის აღდგენა ",
    "gui.menuBar.restoreSound": "ხმის აღდგენა",
    "gui.menuBar.restoreCostume": "კოსტიუმის აღდგენა",
    "gui.menuBar.restore": "აღდგენა",
    "gui.menuBar.saveNow": "შეინახე ახლა",
    "gui.menuBar.saveAsCopy": "შეინახე როგორც ასლი",
    "gui.menuBar.remix": "რემიქსი",
    "gui.menuBar.new": "ახალი",
    "gui.menuBar.file": "ფაილი",
    "gui.menuBar.downloadToComputer": "შეინახე შენს კომპიუტერზე",
    "gui.menuBar.edit": "რედაქტირება",
    "gui.menuBar.turboModeOff": "გამორთე ტურბო რეჟიმი",
    "gui.menuBar.turboModeOn": "ჩართე ტურბო რეჟიმი",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "შემოგვიერთდი",
    "gui.menuBar.signIn": "შესვლა",
    "gui.gui.projectTitlePlaceholder": "პროექტის სახელი აქ",
    "gui.menuBar.saveNowLink": "შეინახე ახლა",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "ზიარი",
    "gui.menuBar.share": "გააზიარე",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "დახმარება",
    "gui.modal.back": "უკან",
    "gui.monitor.listMonitor.empty": "(ცარიელი)",
    "gui.monitor.listMonitor.listLength": "სიგრძე {length}",
    "gui.monitor.contextMenu.default": "ჩვეულებრივი წასაკითხი ხედი",
    "gui.monitor.contextMenu.large": "დიდი წასაკითხი ხედი",
    "gui.monitor.contextMenu.slider": "ცოცია",
    "gui.monitor.contextMenu.sliderRange": "ცოციას დიაპაზონის შეცვლა",
    "gui.monitor.contextMenu.import": "იმპორტი",
    "gui.monitor.contextMenu.export": "ექსპორტი",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "დაკვრა",
    "gui.playButton.stop": "გაჩერება",
    "gui.gui.variableScopeOptionAllSprites": "ყველა სპრაიტისთვის",
    "gui.gui.variableScopeOptionSpriteOnly": "მხოლოდ ამ სპრაიტისთვის",
    "gui.gui.cloudVariableOption": "ღრუბლის ცვლადი (ინახება სერვერზე)",
    "gui.gui.variablePromptAllSpritesMessage": "ეს ცვლადი მისაწვდომი იქნება ყველა სპრაიტისთვის.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "გაუქმება",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "გაჩერება",
    "gui.playbackStep.playMsg": "დაკვრა",
    "gui.playbackStep.loadingMsg": "იტვირთება...",
    "gui.playbackStep.saveMsg": "შენახვა",
    "gui.playbackStep.reRecordMsg": "ხელახლა ჩაწერა",
    "gui.recordModal.title": "ხმის ჩაწერა",
    "gui.recordingStep.beginRecord": "დაიწყე ჩაწერა ქვემო ღილაკის დაჭერით",
    "gui.recordingStep.permission": "{arrow} საჭიროა თქვენი ნებართვა მიკროფონის გამოსაყენებლად",
    "gui.recordingStep.stop": "ჩაწერის შეწყვეტა",
    "gui.recordingStep.record": "ჩაწერა",
    "gui.sliderModal.min": "მინიმალური მნიშვნელობა",
    "gui.sliderModal.max": "მაქსიმალური მნიშვნელობა",
    "gui.sliderModal.title": "ცოციას დიაპაზონის შეცვლა",
    "gui.sliderPrompt.cancel": "გაუქმება",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "ხმა",
    "gui.soundEditor.play": "დაკვრა",
    "gui.soundEditor.stop": "გაჩერება",
    "gui.soundEditor.copy": "კოპირება",
    "gui.soundEditor.paste": "ჩასმა",
    "gui.soundEditor.copyToNew": "კოპირება ახალში",
    "gui.soundEditor.delete": "წაშლა",
    "gui.soundEditor.save": "შენახვა",
    "gui.soundEditor.undo": "გაუქმება",
    "gui.soundEditor.redo": "აღდგენა",
    "gui.soundEditor.faster": "აჩქარება",
    "gui.soundEditor.slower": "შენელება",
    "gui.soundEditor.echo": "ექო",
    "gui.soundEditor.robot": "რობოტი",
    "gui.soundEditor.louder": "ხმის ამაღლება",
    "gui.soundEditor.softer": "დარბილება",
    "gui.soundEditor.reverse": "უკან მიბრუნება",
    "gui.soundEditor.fadeOut": "თანდათან გაყუჩება",
    "gui.soundEditor.fadeIn": "თანდათან მომატება",
    "gui.soundEditor.mute": "უხმოდ",
    "gui.SpriteInfo.spritePlaceholder": "სახელი",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "სპრაიტი",
    "gui.SpriteInfo.show": "ჩვენება",
    "gui.SpriteInfo.size": "ზომა",
    "gui.spriteSelectorItem.contextMenuDuplicate": "დუბლირება",
    "gui.spriteSelectorItem.contextMenuExport": "ექსპორტი",
    "gui.spriteSelectorItem.contextMenuDelete": "წაშლა",
    "gui.spriteSelector.addSpriteFromLibrary": "აირჩიე სპრაიტი",
    "gui.spriteSelector.addSpriteFromPaint": "დახატვა",
    "gui.spriteSelector.addSpriteFromSurprise": "სიურპრიზი",
    "gui.spriteSelector.addSpriteFromFile": "ატვირთე სპრაიტი",
    "gui.stageHeader.stageSizeLarge": "გადაერთე დიდ სცენაზე",
    "gui.stageHeader.stageSizeSmall": "გადაერთე პატარა სცენაზე",
    "gui.stageHeader.stageSizeFull": "გადაერთე სრული ეკრანის რეჟიმზე",
    "gui.stageHeader.stageSizeUnFull": "გამოდი სრული ეკრანის რეჟიმიდან",
    "gui.stageHeader.fullscreenControl": "სრული ეკრანის კონტროლი",
    "gui.spriteSelector.addBackdropFromLibrary": "აირჩიე ფონი",
    "gui.stageSelector.addBackdropFromPaint": "დახატვა",
    "gui.stageSelector.addBackdropFromSurprise": "სიურპრიზი",
    "gui.stageSelector.addBackdropFromFile": "ატვირთე ფონი",
    "gui.stageSelector.stage": "სცენა",
    "gui.stageSelector.backdrops": "ფონები",
    "gui.telemetryOptIn.label": "გააგზავნე სტატისტიკა Scratch-ის გასაუმჯობესებლად",
    "gui.telemetryOptIn.body1": "Scratch-ის გუნდი მუდმივად დაინტერესებულია უკეთესად ესმოდეს, თუ როგორ გამოიყენაბა Scratch-ი მსოფლიოში. ამ ძალისხმევის მხარდასაჭერად შეგიძლია ნება დართო Scratch-ს ავტომატურად გაუგზავნოს გამოყენების ინფორმაცია Scratch-ის გუნდს.",
    "gui.telemetryOptIn.body2": "ინფორმაცია, რომელსაც ჩვენ ვაგროვებთ, მოიცავს ენის არჩევანს, ბლოკების გამოყენებას და ზოგიერთ მოვლენებს, როგორიცაა პროექტის შენახვა, ჩამოტვირთვა და ატვირთვა. ჩვენ არ ვაგროვებთ არავითარ პერსონალურ ინფორმაციას. იხილე ჩვენი {privacyPolicyLink} დამატებითი ინფორმაციისთვის.",
    "gui.telemetryOptIn.privacyPolicyLink": "კონფიდენციალურობის პოლიტიკა",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "ტურბო რეჟიმი",
    "gui.webglModal.label": "თქვენი ბრაუზერი არაა თავსებადი WebGL-თან",
    "gui.webglModal.description": "უკაცრავად, როგორც ჩანს თქვენი ბრაუზერი ან კომპიუტერი {webGlLink}. ეს ტექნოლოგიაა საჭიროა Scratch 3.0-ის სამუშაოდ.",
    "gui.webglModal.webgllink": " არაა თავსებადი WebGL-თან",
    "gui.webglModal.back": "უკან",
    "gui.webglModal.previewfaq": "მეტის გასაგებად გადადი {previewFaqLink}-ზე.",
    "gui.webglModal.previewfaqlinktext": "კითხვა-პასუხი",
    "gui.costumeLibrary.chooseABackdrop": "აირჩიე ფონი",
    "gui.costumeLibrary.chooseACostume": "აირჩიე კოსტიუმი",
    "gui.costumeTab.addBackdropFromLibrary": "აირჩიე ფონი",
    "gui.costumeTab.addCostumeFromLibrary": "აირჩიე კოსტიუმი",
    "gui.costumeTab.addBlankCostume": "დახატვა",
    "gui.costumeTab.addSurpriseCostume": "სიურპრიზი",
    "gui.costumeTab.addFileBackdrop": "ფონის ატვირთვა",
    "gui.costumeTab.addFileCostume": "კოსტიუმის ატვირთვა",
    "gui.extensionLibrary.chooseAnExtension": "აირჩიე გაფართოება",
    "gui.extensionLibrary.extensionUrl": "შეიყვანე გაფართოების URL",
    "gui.monitors.importListColumnPrompt": "რომელი სვეტი უნდა გამოიყენოს (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "შეუძლებელია ჩაწერის დაწყება",
    "gui.soundLibrary.chooseASound": "ხმის არჩევა",
    "gui.soundTab.fileUploadSound": "ხმის ატვირთვა",
    "gui.soundTab.surpriseSound": "სიურპრიზი",
    "gui.soundTab.recordSound": "ჩაწერა",
    "gui.soundTab.addSoundFromLibrary": "ხმის არჩევა",
    "gui.spriteLibrary.chooseASprite": "სპრაიტის არჩევა",
    "gui.tipsLibrary.tutorials": "გაკვეთილის არჩევა",
    "gui.alerts.createsuccess": "ახალი პროექტი შექმნილია.",
    "gui.alerts.createcopysuccess": "პროექტი შენახულია როგორც ასლი.",
    "gui.alerts.createremixsuccess": "პროექტი შენახულია როგორც რემიქსი.",
    "gui.alerts.creating": "იქმნება ახალი...",
    "gui.alerts.creatingCopy": "იქმნება პროექტის ასლი...",
    "gui.alerts.creatingRemix": "იქმნება პროექტის რემიქსი...",
    "gui.alerts.creatingError": "პროექტის შექმნა ვერ მოხერხდა. გთხოვთ კიდევ სცადოთ!\n",
    "gui.alerts.savingError": "პროექტის შენახვა ვერ მოხერხდა.",
    "gui.alerts.savesuccess": "პროექტი შენახულია.",
    "gui.alerts.saving": "პროექტი ინახება...",
    "gui.alerts.cloudInfo": "გთხოვთ გაითვალისწინოთ, რომ ღრუბლოვანი ცვლადები წარმოადგენენ მხოლოდ რიცხვებს და არა ასოებსა და სიმბოლოებს. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "გაიგე მეტი.",
    "gui.alerts.importing": "წარმოებს იმპორტი...",
    "gui.defaultProject.meow": "მიაუ",
    "gui.defaultProject.variable": "ჩემი ცვლადი",
    "gui.howtos.intro-move-sayhello-hat.name": "პირველი ნაბიჯები",
    "gui.howtos.intro-move.step_stepMove": "დაამატე გადაადგილების ბლოკი",
    "gui.howtos.add-a-move-block.step_stepSay": "დაამატე ბლოკი “თქვი”",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "დააჭირე მწვანე დროშას დასაწყებად",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "გააცოცხლე სახელი",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "აირჩიე ასოს სპრაიტი",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "დაჭერისას დაუკარი ხმა",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "აირჩიე სხვა ასოს სპრაიტი",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "ფერის შეცვლა",
    "gui.howtos.animate-a-name.step_AnimateSpin": "აირჩიე სხვა ასოს სპრაიტი და დაატრიალე ის",
    "gui.howtos.animate-a-name.step_AnimateGrow": "აირჩიე სხვა ასოს სპრაიტი და გაადიდე ის",
    "gui.howtos.imagine": "წარმოიდგინე სამყარო",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "დაბეჭდე რისი თქმაც გინდა",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "დააჭირე მწვანე დროშას დასაწყებად",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "აირჩიე ნებისმიერი ფონი",
    "gui.howtos.imagine.step_imagineChooseSprite": "აირჩიე ნებისმიერი სპრაიტი",
    "gui.howtos.imagine.step_imagineFlyAround": "დააჭირე დაშორების ღილაკს გასასრიალებლად",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "აირჩიე სხვა სპრაიტი",
    "gui.howtos.imagine.step_imagineLeftRight": "გადაადგილდი მარცხნივ-მარჯვნივ",
    "gui.howtos.imagine.step_imagineUpDown": "გადაადგილდი ზევით-ქვევით",
    "gui.howtos.imagine.step_imagineChangeCostumes": "შეცვალე კოსტიუმები",
    "gui.howtos.imagine.step_imagineGlideToPoint": "გასრიალდი წერტილისაკენ",
    "gui.howtos.imagine.step_imagineGrowShrink": "გაზრდა და შემცირება",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "აირჩიე სხვა ფონი",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "გადართე ფონები",
    "gui.howtos.imagine.step_imagineRecordASound": "დაამატე ხმა",
    "gui.howtos.imagine.step_imagineChooseSound": "აირჩიე ხმა",
    "gui.howtos.make-music.name": "შექმენი მუსიკა",
    "gui.howtos.Make-Music.step_PickInstrument": "აირჩიე ინსტრუმენტის სპრაიტი",
    "gui.howtos.Make-Music.step_PlaySoundClick": "დაჭერისას დაუკარი ხმა",
    "gui.howtos.Make-Music.step_MakeSong": "შექმენი სიმღერა",
    "gui.howtos.make-music.step_MakeBeat": "აირჩიე დოლი და დაუკარი",
    "gui.howtos.make-music.step_MakeBeatBox": "აირჩიე მიკროფონის სპრაიტი და ბიტბოქსი სიურპრიზი",
    "gui.howtos.story.name": "შექმენი ამბავი",
    "gui.howtos.story.step_addbg": "დაამატე ფონი",
    "gui.howtos.story.step_addsprite": "დაამატე პერსონაჟი",
    "gui.howtos.story.step_saysomething": "თქვი რამე",
    "gui.howtos.story.step_addanothersprite": "დაამატე სხვა პერსონაჟი",
    "gui.howtos.story.step_flip": "გადატრიალების მიმართულება",
    "gui.howtos.story.step_conversation": "წამოიწყე საუბარი",
    "gui.howtos.story.addanotherbg": "დაამატე სხვა ფონი",
    "gui.howtos.story.step_swithbg": "გადართე ფონები",
    "gui.howtos.story.step_hidewizard": "დამალე პერსონაჟი",
    "gui.howtos.story.step_showwizard": "გამოაჩინე პერსონაჟი",
    "gui.howtos.make-a-chase-game.name": "შექმენი ნადირობანას თამაში",
    "gui.howtos.Chase-Game.step_BG": "დაამატე ფონი",
    "gui.howtos.chase-game.step_AddOcto": "დაამატე სპრაიტი",
    "gui.howtos.make-music.step_LeftRight": "იმოძრავე მარჯვნივ და მარცხნივ ისარის ღილაკებით",
    "gui.howtos.Chase-Game.step_UpDown": "იმოძრავე ზევით და ქვევით ისრების ღილაკებით",
    "gui.howtos.Chase-Game.step_AddStar": "დაამატე კიდევ ერთი სპრაიტი",
    "gui.howtos.Chase-Game.step_MoveRandom": "იმოძრავე შემთხვევითად",
    "gui.howtos.Chase-Game.step_WhenTouch": "რვაფეხას სპრაიტში, შეხებისას დაუკარი ხმა",
    "gui.howtos.Chase-Game.step_ScoreVariable": "შექმენი ანგარიშის ცვლადი",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "რვაფეხას სპრაიტში, შეხებისას დაამატე ქულა",
    "gui.howtos.animate-char.name": "გააცოცხლე პერსონაჟი",
    "gui.howtos.animate-char.step_addbg": "დაამატე ფონი",
    "gui.howtos.animate-char.step_addsprite": "დაამატე სპრაიტი",
    "gui.howtos.animate-char.step_saysomething": "თქვი რამე",
    "gui.howtos.animate-char.step_addsound": "დაამატე ხმა",
    "gui.howtos.animate-char.step_animatetalking": "გააცოცხლე საუბარი",
    "gui.howtos.animate-char.step_arrowkeys": "იმოძრავე ისარიანი ღილაკების მეშვეობით",
    "gui.howtos.animate-char.step_jump": "ახტი",
    "gui.howtos.animate-char.step_changecolor": "შეცვალე ფერი",
    "gui.howtos.make-a-game.name": "შექმენი წკაპუნა თამაში",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "აირჩიე სპრაიტი",
    "gui.howtos.make-a-game.step_GamePlaySound": "დაჭერისას დაუკარი ხმა",
    "gui.howtos.make-a-game.step_GameAddScore": "შექმენი ანგარიშის ცვლადი",
    "gui.howtos.make-a-game.step_GameChangeScore": "დაჭერისას დაამატე ქულა",
    "gui.howtos.make-a-game.step_Random": "გადადი შემთხვევით მდებარეობაზე",
    "gui.howtos.make-music.step_GameChangeColor": "შეცვალე ფერი",
    "gui.howtos.make-music.step_ResetScore": "გაანულე ანგარიში",
    "gui.howtos.make-it-fly.name": "გავფრინდეთ?",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "აირჩიე ფონი ცით",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "აირჩიე პერსონაჟი",
    "gui.howtos.fly.step_stepflySaySomething": "თქვი რამე",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "იმოძრავე ისარიანი ღილაკების მეშვეობით",
    "gui.howtos.fly.step_stepflyChooseObject": "აირჩიე ობიექტი შესაგროვებლად",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "გადაადგილე ობიექტი",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "აირჩიე პერსონაჟი",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "დაამატე ანგარიში",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "დაითვალე ქულები",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "დაამატე პეიზაჟი",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "ამოძრავე პეიზაჟი",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "შემდეგი კოსტიუმი",
    "gui.howtos.pong": "პინგ-პონგის თამაში",
    "gui.howtos.pong.step_pongAddBackdrop": "დაამატე ფონი",
    "gui.howtos.pong.step_pongAddBallSprite": "დაამატე სპრაიტი ბურთი (Ball)",
    "gui.howtos.pong.step_pongBounceAround": "იხტუნე აქეთ-იქით",
    "gui.howtos.pong.step_pongAddPaddle": "დაამატე ჩოგანი (Paddle)",
    "gui.howtos.pong.step_pongMoveThePaddle": "გადაადგილე ჩოგანი",
    "gui.howtos.pong.step_pongSelectBallSprite": "აირჩიე სპრაიტი ბურთი (Ball)",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "დაამატე კოდი ბურთის ჩოგნით მოსაგერიებლად",
    "gui.howtos.pong.step_pongAddAScore": "დაამატე ანგარიში",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "აირჩიე \"ანგარიში\" მენიუში",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "დაამატე ბლოკი \"შეცვალე ანგარიში\"",
    "gui.howtos.pong.step_pongResetScore": "გაანულე ანგარიში",
    "gui.howtos.pong.step_pongAddLineSprite": "დაამატე სპრაიტი ხაზი (Line)",
    "gui.howtos.pong.step_pongGameOver": "თამაში დასრულებულია",
    "gui.howtos.code-cartoon": "შექმენი მულტფილმის პროგრამა",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "თქვი რაიმე როდესაც მწვანე დროშას დააჭერ",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "გააცოცხლე პერსონაჟი მასზე დაწკაპუნებით",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "არჩიე განსხვავებული პერსონაჟი",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "გამოიყენე მინუსის ნიშანი შესამცირებლად",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "გაადიდე და შეამცირე პერსონაჟი",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "აირჩიე განსხვავებული პერსონაჟი",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "იხტუნე ზევით-ქვევით",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "დააჭირე პერსონაჟს სცენის შესაცვლელად",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "ისრიალე გარშემო",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "ცვალე კოსტიუმები",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "აირჩიე მეტი პერსონაჟები მულტფილმში დასამატებლად",
    "gui.howtos.cartoon-network": "სათავგადასავლო თამაში",
    "gui.howtos.cartoon-network.step_CNcharacter": "აირჩიე პერსონაჟი გამოსაჩენად",
    "gui.howtos.cartoon-network.step_CNsay": "თქვი რამე",
    "gui.howtos.cartoon-network.step_CNglide": "ისრიალე გარშემო",
    "gui.howtos.cartoon-network.step_CNpicksprite": "აირჩიე ობიექტი სანადიროდ",
    "gui.howtos.cartoon-network.step_CNcollect": "შეაგროვე ობიექტები",
    "gui.howtos.cartoon-network.step_CNvariable": "შექმენი ანგარიშის ცვლადი",
    "gui.howtos.cartoon-network.step_CNscore": "დაითვალე ქულები",
    "gui.howtos.cartoon-network.step_CNbackdrop": "შემდეგი საფეხური: შეცვალე ფონი",
    "gui.howtos.videosens.name": "ვიდეო მგრძნობელობა ",
    "gui.howtos.videosens.step_addextension": "დაამატე გაფართოება",
    "gui.howtos.videosens.step_pet": "მიუალერსე კატას",
    "gui.howtos.videosens.step_animate": "გააცოცხლე",
    "gui.howtos.videosens.step_pop": "გახეთქე ბუშტი",
    "gui.howtos.say-it-out-loud": "შექმენი მოსაუბრე ანიმაცია",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "დაამატე ბლოკები \"ტექსტის ამეტყველება\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "თქვი რამე",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "აირჩიე ხმა",
    "gui.howtos.say-it-out-loud.step_TXTMove": "იმოძრავე ირგვლივ",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "დაამატე ფონი",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "დაამატე სხვა პერსონაჟი",
    "gui.howtos.say-it-out-loud.step_TXTSong": "შეასრულე სიმღერა",
    "gui.howtos.say-it-out-loud.step_TXTColor": "შეცვალე ფერი",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "დატრიალდი",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "გაზრდა და შემცირება",
    "gui.howtos.talking": "მოლაპარაკე ზღაპრები",
    "gui.howtos.talking.step_talesAddExtension": "დააჭირე ტექსტის ამეტყელების ბლოკების დასამატებლად",
    "gui.howtos.talking.step_talesChooseSprite": "აირჩიე სპრაიტი",
    "gui.howtos.talking.step_talesSaySomething": "აამეტყველე პერსონაჟი",
    "gui.howtos.talking.step_talesChooseBackdrop": "აირჩიე ფონი",
    "gui.howtos.talking.step_talesSwitchBackdrop": "დააჭირე პერსონაჟს შემდეგ ფონზე გადასართავად",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "აირჩიე სხვა სპრაიტი",
    "gui.howtos.talking.step_talesMoveAround": "იმოძრავე ირგვლივ",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "აირჩიე სხვა ფონი",
    "gui.howtos.talking.step_talesAnimateTalking": "გააცოცხლე საუბარი",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "აირჩიე სხვა ფონი",
    "gui.howtos.talking.step_talesChooseSound": "აირჩიე სიმღერა საცეკვაოდ",
    "gui.howtos.talking.step_talesDanceMoves": "საცეკვაო ილეთები",
    "gui.howtos.talking.step_talesAskAnswer": "გამოიყენე კითხვა-პასუხის ბლოკები სენსორების კატეგორიიდან",
    "gui.howtos.add-sprite.name": "დაამატე სპრაიტი",
    "gui.howtos.add-sprite.step_addSprite": "დაამატე სპრაიტი",
    "gui.howtos.add-a-backdrop.name": "დაამატე ფონი",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "დაამატე ფონი",
    "gui.howtos.change-size.name": "შეცვალე ზომა",
    "gui.howtos.change-size.step_changeSize": "შეცვალე ზომა",
    "gui.howtos.glide-around.name": "ისრიალე გარშემო",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "ისრიალე გარშემო",
    "gui.howtos.change-size.step_glideAroundPoint": "გასრიალდი წერტილისაკენ",
    "gui.howtos.record-a-sound.name": "ჩაწერე ხმა",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "დააჭირე ჩანართს \"ხმა\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "აირჩიე \"ჩაწერა\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "დააჭირე ღილაკს \"ჩაწერა\"",
    "gui.howtos.change-size.step_recordASoundChooseSound": "აირჩიე ხმა",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "დაუკარი ხმა",
    "gui.howtos.spin-video.name": "დაატრიალე",
    "gui.howtos.change-size.step_spinTurn": "მოტრიალდი",
    "gui.howtos.change-size.step_spinPointInDirection": "აირჩიე მიმართულება",
    "gui.howtos.hide-and-show.name": "დამალე და უჩვენე",
    "gui.howtos.change-size.step_hideAndShow": "დამალე და უჩვენე",
    "gui.howtos.switch-costume.name": "გააცოცხლე სპრაიტი",
    "gui.howtos.change-size.step_switchCostumes": "გააცოცხლე სპრაიტი",
    "gui.howtos.move-around-with-arrow-keys.name": "გამოიყენე ისრიანი ღილაკები",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "გადაადგილდი მარცხნივ და მარჯვნივ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "გადაადგილდი ზევით და ქვევით",
    "gui.howtos.add-effects.name": "დაამატე ეფექტები",
    "gui.howtos.videosens.step_addEffects": "დაამატე ეფექტები",
    "gui.extension.music.name": "მუსიკა",
    "gui.extension.music.description": "დაუკარი ინსტრუმენტებზე და დოლებზე.",
    "gui.extension.pen.name": "კალამი",
    "gui.extension.pen.description": "ხატე სპრაიტებით.",
    "gui.extension.videosensing.name": "ვიდეო მგრძნობელობა ",
    "gui.extension.videosensing.description": "იგრძენი მოძრაობა კამერის საშუალებით.",
    "gui.extension.text2speech.name": "ტექსტის ამეტყველება",
    "gui.extension.text2speech.description": "აამეტყველე შენი პროექტები.",
    "gui.extension.translate.name": "თარგმნე",
    "gui.extension.translate.description": "თარგმნე ტექსტი სხვადასხვა ენებზე.",
    "gui.extension.makeymakey.description": "გადააქციე ნებისმიერი რამ გასაღებად.",
    "gui.extension.microbit.description": "დაუკავშირდი მსოფლიოს შენი პროექტებით.",
    "gui.extension.microbit.connectingMessage": "კავშირის დამყარება",
    "gui.extension.ev3.description": "ააგე ინტერაქტიული რობოტები და ბევრი სხვა რამ.",
    "gui.extension.ev3.connectingMessage": "კავშირის დამყარება. დარწმუნდი, რომ შენს EV3-ზე დაყენებულია პინის მნიშვნელობა 1234.",
    "gui.extension.boost.description": "შთანერგე რობოტებს სიცოცხლე.",
    "gui.extension.boost.connectingMessage": "კავშირის დამყარება",
    "gui.extension.wedo2.description": "ააგე ძრავების და სენსორების საშუალებით.",
    "gui.extension.wedo2.connectingMessage": "კავშირის დამყარება",
    "gui.extension.gdxfor.description": "იგრძენი დაწოლა, გაწევა, მოძრაობა და ბრუნვა.",
    "gui.extension.gdxfor.connectingMessage": "კავშირის დამყარება",
    "gui.libraryTags.all": "ყველა",
    "gui.libraryTags.animals": "ცხოველები",
    "gui.libraryTags.dance": "ცეკვა",
    "gui.libraryTags.effects": "ეფექტები",
    "gui.libraryTags.fantasy": "ფანტაზია",
    "gui.libraryTags.fashion": "მოდა",
    "gui.libraryTags.food": "საკვები",
    "gui.libraryTags.indoors": "შენობაში",
    "gui.libraryTags.loops": "ციკლები",
    "gui.libraryTags.music": "მუსიკა",
    "gui.libraryTags.notes": "ნოტები",
    "gui.libraryTags.outdoors": "ღია ცის ქვეშ",
    "gui.libraryTags.patterns": "მოხატულობა",
    "gui.libraryTags.people": "ადამიანები",
    "gui.libraryTags.percussion": "დამრტყმელები",
    "gui.libraryTags.space": "კოსმოსი",
    "gui.libraryTags.sports": "სპორტი",
    "gui.libraryTags.underwater": "წყალქვეშ",
    "gui.libraryTags.voice": "ხმა",
    "gui.libraryTags.wacky": "უცნაური",
    "gui.libraryTags.animation": "ანიმაცია",
    "gui.libraryTags.art": "ხელოვნება",
    "gui.libraryTags.games": "თამაშები",
    "gui.libraryTags.stories": "ამბები",
    "gui.libraryTags.letters": "ასოები",
    "gui.opcodeLabels.direction": "მიმართულება",
    "gui.opcodeLabels.xposition": "x მდებარეობა",
    "gui.opcodeLabels.yposition": "y მდებარეობა",
    "gui.opcodeLabels.size": "ზომა",
    "gui.opcodeLabels.costumename": "კოსტიუმის სახელი",
    "gui.opcodeLabels.costumenumber": "კოსტიუმის ნომერი",
    "gui.opcodeLabels.backdropname": "ფონის სახელი",
    "gui.opcodeLabels.backdropnumber": "ფონის ნომერი",
    "gui.opcodeLabels.volume": "ხმის სიმაღლე",
    "gui.opcodeLabels.tempo": "ტემპი",
    "gui.opcodeLabels.answer": "პასუხი",
    "gui.opcodeLabels.loudness": "მაღალი ხმა",
    "gui.opcodeLabels.username": "მომხმარებელი",
    "gui.opcodeLabels.year": "წელი",
    "gui.opcodeLabels.month": "თვე",
    "gui.opcodeLabels.date": "თარიღი",
    "gui.opcodeLabels.dayofweek": "კვირის დღე",
    "gui.opcodeLabels.hour": "საათი",
    "gui.opcodeLabels.minute": "წუთი",
    "gui.opcodeLabels.second": "წამი",
    "gui.opcodeLabels.timer": "წამზომი",
    "gui.projectLoader.loadError": "არჩეული პროექტის ფაილი ვერ გადმოიტვირთა.",
    "gui.sharedMessages.backdrop": "ზურგჩანთა{index}",
    "gui.sharedMessages.costume": "კოსტიუმი{index}",
    "gui.sharedMessages.sprite": "სპრაიტი{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "შევანაცვლო მიმდინარე პროექტის შიგთავსი?",
    "gui.sharedMessages.loadFromComputerTitle": "ატვირთე შენი კომპიუტერიდან",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch პროექტი",
    "boost.color.any": "ნებისმიერი ფერი",
    "boost.color.black": "შავი",
    "boost.color.blue": "ლურჯი",
    "boost.color.green": "მწვანე",
    "boost.color.red": "წითელი",
    "boost.color.white": "თეთრი",
    "boost.color.yellow": "ყვითელი",
    "boost.getMotorPosition": "ძრავის [MOTOR_REPORTER_ID] მდგომარეობა",
    "boost.getTiltAngle": "დახრის კუთხე [TILT_DIRECTION]",
    "boost.motorDirection.backward": "აქეთ",
    "boost.motorDirection.forward": "იქით",
    "boost.motorDirection.reverse": "უკუსვლა",
    "boost.motorOff": "გამორთე ძრავა [MOTOR_ID]",
    "boost.motorOn": "ჩართე ძრავა [MOTOR_ID]",
    "boost.motorOnFor": "ჩართე ძრავა [MOTOR_ID] [DURATION] წამით",
    "boost.motorOnForRotation": "ჩართე ძრავა [MOTOR_ID] [ROTATION] ბრუნით",
    "boost.seeingColor": "ხედავ [COLOR] აგურს?",
    "boost.setLightHue": "დააყენე ნათურის ფერი [HUE]",
    "boost.setMotorDirection": "დააყენე ძრავის [MOTOR_ID] მიმართულება [MOTOR_DIRECTION]",
    "boost.setMotorPower": "დააყენე ძრავის [MOTOR_ID] სიჩქარე [POWER] %",
    "boost.tiltDirection.any": "ნებისმიერი",
    "boost.tiltDirection.down": "ქვევით",
    "boost.tiltDirection.left": "მარცხნივ",
    "boost.tiltDirection.right": "მარჯვნივ",
    "boost.tiltDirection.up": "ზევით",
    "boost.whenColor": "როდესაც ხედავ [COLOR] აგურს",
    "boost.whenTilted": "როდესაც დახრილია [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "დაუკარი ნოტა [NOTE] [TIME] წამი",
    "ev3.buttonPressed": "ღილაკი [PORT] დაჭერილია?",
    "ev3.getBrightness": "სიკაშკაშე",
    "ev3.getDistance": "მანძილი",
    "ev3.getMotorPosition": "ძრავის მდგომარეობა [PORT]",
    "ev3.motorSetPower": "ძრავას [PORT] დაუყენე სიმძლავრე [POWER] %",
    "ev3.motorTurnClockwise": "ძრავა [PORT] აბრუნე აქეთ [TIME] წამი",
    "ev3.motorTurnCounterClockwise": "ძრავა [PORT] აბრუნე იქით [TIME] წამი",
    "ev3.whenBrightnessLessThan": "როდესაც სიკაშკაშე < [DISTANCE]",
    "ev3.whenButtonPressed": "როდესაც ღილაკი [PORT] დაჭერილია",
    "ev3.whenDistanceLessThan": "როდესაც მანძილი < [DISTANCE]",
    "gdxfor.getAcceleration": "აჩქარება [DIRECTION]",
    "gdxfor.getForce": "ძალა",
    "gdxfor.getSpin": "ბრუნვის სიჩქარე [DIRECTION]",
    "gdxfor.getTilt": "დახრის კუთხე [TILT]",
    "gdxfor.isFreeFalling": "ვარდება?",
    "gdxfor.isTilted": "დახრილია [TILT]?",
    "gdxfor.pulled": "გამოწეულია",
    "gdxfor.pushed": "დაჭერილია",
    "gdxfor.shaken": "შერხეულია",
    "gdxfor.startedFalling": "ვარდნა დაიწყო",
    "gdxfor.tiltDirectionMenu.any": "ნებისმიერი",
    "gdxfor.tiltDirectionMenu.back": "უკან",
    "gdxfor.tiltDirectionMenu.front": "წინ",
    "gdxfor.tiltDirectionMenu.left": "მარცხნივ",
    "gdxfor.tiltDirectionMenu.right": "მარჯვნივ",
    "gdxfor.turnedFaceDown": "მოტრიალებულია პირით ქვევით",
    "gdxfor.turnedFaceUp": "მოტრიალებულია პირით ზევით",
    "gdxfor.whenForcePushedOrPulled": "როდესაც ძალის სენსორი [PUSH_PULL]",
    "gdxfor.whenGesture": "როდესაც [GESTURE]",
    "gdxfor.whenTilted": "როდესაც დახრილია [TILT]",
    "makeymakey.downArrow": "ისარი ქვევით",
    "makeymakey.downArrowShort": "ქვევით",
    "makeymakey.leftArrow": "ისარი მარცხნივ",
    "makeymakey.leftArrowShort": "მარცხნივ",
    "makeymakey.rightArrow": "ისარი მარჯვნივ",
    "makeymakey.rightArrowShort": "მარჯვნივ",
    "makeymakey.spaceKey": "დაშორება",
    "makeymakey.upArrow": "ისარი ზევით",
    "makeymakey.upArrowShort": "ზევით",
    "makeymakey.whenKeyPressed": "როდესაც [KEY] ღილაკი დაჭერილია",
    "makeymakey.whenKeysPressedInOrder": "როდესაც [SEQUENCE] რიგითაა დაჭერილი",
    "microbit.buttonsMenu.any": "ნებისმიერი",
    "microbit.clearDisplay": "გაწმინდე ეკრანი",
    "microbit.defaultTextToDisplay": "გამარჯობა!",
    "microbit.displaySymbol": "ეკრანი [MATRIX]",
    "microbit.displayText": "აჩვენე ტექსტი [TEXT]",
    "microbit.gesturesMenu.jumped": "გადახტა",
    "microbit.gesturesMenu.moved": "გადაადგილდა",
    "microbit.gesturesMenu.shaken": "შეირხა",
    "microbit.isButtonPressed": "[BTN] ღილაკი დაჭერილია?",
    "microbit.isTilted": "გადაიხარა [DIRECTION]?",
    "microbit.pinStateMenu.off": "გამორთვა",
    "microbit.pinStateMenu.on": "ჩართვა",
    "microbit.tiltAngle": "დახრის კუთხე [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ნებისმიერი",
    "microbit.tiltDirectionMenu.back": "უკან",
    "microbit.tiltDirectionMenu.front": "წინ",
    "microbit.tiltDirectionMenu.left": "მარცხნივ",
    "microbit.tiltDirectionMenu.right": "მარჯვნივ",
    "microbit.whenButtonPressed": "როდესაც [BTN] ღილაკი დაჭერილია",
    "microbit.whenGesture": "როდესაც [GESTURE]",
    "microbit.whenPinConnected": "როდესაც კონტაქტი [PIN] ჩართულია",
    "microbit.whenTilted": "როდესაც დახრილია [DIRECTION]",
    "music.categoryName": "მუსიკა",
    "music.changeTempo": "შეცვალე ტემპი [TEMPO]-ით",
    "music.drumBass": "(2) ბას დოლი",
    "music.drumBongo": "(13) ბონგო",
    "music.drumCabasa": "(15) კაბასა",
    "music.drumClaves": "(9) კლავე",
    "music.drumClosedHiHat": "(6) დახურული ჰაი-ჰეთი",
    "music.drumConga": "(14) კონგა",
    "music.drumCowbell": "(11) კაუბელი",
    "music.drumCrashCymbal": "(4) კრეშ თეფშები",
    "music.drumCuica": "(18) კუიკა",
    "music.drumGuiro": "(16) გუირო",
    "music.drumHandClap": "(98) ტაში",
    "music.drumOpenHiHat": "(5) ღია ჰაი-ჰეთი",
    "music.drumSideStick": "(3) გვერდითი დასარტყამი",
    "music.drumSnare": "(1) ზამბარიანი დოლი",
    "music.drumTambourine": "(7) დაირა",
    "music.drumTriangle": "(12) სამკუთხედი",
    "music.drumVibraslap": "(17) ვიბრასლეფი",
    "music.drumWoodBlock": "(10) ხის ბლოკი",
    "music.getTempo": "ტემპი",
    "music.instrumentBass": "(6) ბასი",
    "music.instrumentBassoon": "(14) ფაგოტი",
    "music.instrumentCello": "(8) ჩელო",
    "music.instrumentChoir": "(15) გუნდი",
    "music.instrumentClarinet": "(10) კლარნეტი",
    "music.instrumentElectricGuitar": "(5) ელექტრო გიტარა",
    "music.instrumentElectricPiano": "(2) ელექტრო პიანინო",
    "music.instrumentFlute": "(12) ფლეიტა",
    "music.instrumentGuitar": "(4) გიტარა",
    "music.instrumentMarimba": "(19) მარიმბა",
    "music.instrumentMusicBox": "(17) მუსიკალური ყუთი",
    "music.instrumentOrgan": "(3) ორღანი",
    "music.instrumentPiano": "(1) ფორტეპიანო",
    "music.instrumentPizzicato": "(7) პიციკატო",
    "music.instrumentSaxophone": "(11) საქსაფონი",
    "music.instrumentSteelDrum": "(18) ფოლადის დოლი",
    "music.instrumentSynthLead": "(20) წამყვანი სინთეზატორი",
    "music.instrumentSynthPad": "(21) ფონის სინთეზატორი",
    "music.instrumentTrombone": "(9) ტრომბონი",
    "music.instrumentVibraphone": "(16) ვიბრაფონი",
    "music.instrumentWoodenFlute": "(13) ხის ფლეიტა",
    "music.midiPlayDrumForBeats": "დაუკარი დოლი [DRUM]  [BEATS] ბიტით",
    "music.midiSetInstrument": "აირჩიე ინსტრუმენტი [INSTRUMENT]",
    "music.playDrumForBeats": "დაუკარი დოლი [DRUM]  [BEATS] ბიტით",
    "music.playNoteForBeats": "დაუკარი ნოტა [NOTE]  [BEATS] ბიტით",
    "music.restForBeats": "პაუზა [BEATS] ბიტით",
    "music.setInstrument": "აირჩიე ინსტრუმენტი [INSTRUMENT]",
    "music.setTempo": "დააყენე ტემპი [TEMPO]",
    "pen.categoryName": "კალამი",
    "pen.changeColorParam": "შეცვალე კალმის [COLOR_PARAM]  [VALUE]-ით",
    "pen.changeHue": "შეცვალე კალმის ფერი [HUE]-თი",
    "pen.changeShade": "შეცვალე კალმის ელფერი [SHADE]-ით",
    "pen.changeSize": "შეცვალე კალმის ზომა [SIZE]-ით",
    "pen.clear": "წაშალე ყველაფერი",
    "pen.colorMenu.brightness": "სიკაშკაშე",
    "pen.colorMenu.color": "ფერი",
    "pen.colorMenu.saturation": "გაჯერება",
    "pen.colorMenu.transparency": "გამჭვირვალობა",
    "pen.penDown": "კალამი ქვევით",
    "pen.penUp": "კალამი ზევით",
    "pen.setColor": "დააყენე კალმის ფერი [COLOR]",
    "pen.setColorParam": "დააყენე კალმის [COLOR_PARAM]  [VALUE]",
    "pen.setHue": "დააყენე კალმის ფერი [HUE]",
    "pen.setShade": "დააყენე კალმის ელფერი [SHADE]",
    "pen.setSize": "დააყენე კალმის ზომა [SIZE]",
    "pen.stamp": "ბეჭდვა",
    "speech.defaultWhenIHearValue": "მოდი დავიწყოთ",
    "speech.extensionName": "მეტყველების ტექსტად გარდაქმნა",
    "speech.listenAndWait": "მოუსმინე და დაელოდე",
    "speech.speechReporter": "მეტყველება",
    "speech.whenIHear": "როდესაც მესმის [PHRASE]",
    "text2speech.alto": "ალტი",
    "text2speech.categoryName": "ტექსტის ამეტყველება",
    "text2speech.defaultTextToSpeak": "გამარჯობა",
    "text2speech.giant": "გიგანტი",
    "text2speech.kitten": "კნუტი",
    "text2speech.setLanguageBlock": "აირჩიე ენა [LANGUAGE]",
    "text2speech.setVoiceBlock": "აირჩიე ხმა [VOICE]",
    "text2speech.speakAndWaitBlock": "თქვი [WORDS]",
    "text2speech.squeak": "წრიპინი",
    "text2speech.tenor": "ტენორი",
    "translate.categoryName": "თარგმნე",
    "translate.defaultTextToTranslate": "სალამი",
    "translate.translateBlock": "თარგმნე [WORDS] [LANGUAGE]-ად",
    "translate.viewerLanguage": "ენა",
    "videoSensing.categoryName": "ვიდეო სენსორი",
    "videoSensing.direction": "მიმართულება",
    "videoSensing.motion": "მოძრაობა",
    "videoSensing.off": "გამორთვა",
    "videoSensing.on": "ჩართვა",
    "videoSensing.onFlipped": "ჩართვა პირიქით",
    "videoSensing.setVideoTransparency": "დააყენე ვიდეოს გამჭვირვალობა [TRANSPARENCY]",
    "videoSensing.sprite": "სპრაიტი",
    "videoSensing.stage": "სცენა",
    "videoSensing.videoOn": "ვიდეო [ATTRIBUTE] [SUBJECT]",
    "videoSensing.videoToggle": "ჩართე ვიდეო [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "როდესაც ვიდეო მოძრაობა > [REFERENCE]",
    "wedo2.getDistance": "მანძილი",
    "wedo2.getTiltAngle": "დახრის კუთხე [TILT_DIRECTION]",
    "wedo2.isTilted": "დახრილია [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "აქეთ",
    "wedo2.motorDirection.forward": "იქით",
    "wedo2.motorDirection.reverse": "უკუსვლა",
    "wedo2.motorId.a": "ძრავა A",
    "wedo2.motorId.all": "ყველა ძრავა",
    "wedo2.motorId.b": "ძრავა B",
    "wedo2.motorId.default": "ძრავა",
    "wedo2.motorOff": "გამორთე [MOTOR_ID]",
    "wedo2.motorOn": "ჩართე [MOTOR_ID]",
    "wedo2.motorOnFor": "ჩართე ძრავა [MOTOR_ID] [DURATION] წამით",
    "wedo2.playNoteFor": "დაუკარი ნოტა [NOTE] [DURATION] წამი",
    "wedo2.setLightHue": "დააყენე ნათურის ფერი [HUE]",
    "wedo2.setMotorDirection": "დააყენე [MOTOR_ID]-ის მიმართულება [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "დააყენე [MOTOR_ID]-ის ძალა [POWER]",
    "wedo2.tiltDirection.any": "ნებისმიერი",
    "wedo2.tiltDirection.down": "ქვევით",
    "wedo2.tiltDirection.left": "მარცხნივ",
    "wedo2.tiltDirection.right": "მარჯვნივ",
    "wedo2.tiltDirection.up": "ზევით",
    "wedo2.whenDistance": "როდესაც მანძილი [OP] [REFERENCE]",
    "wedo2.whenTilted": "როდესაც დახრილია [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "ფერი",
    "paint.paintEditor.saturation": "გაჯერება",
    "paint.paintEditor.brightness": "სიკაშკაშე",
    "paint.paintEditor.costume": "კოსტიუმი",
    "paint.paintEditor.group": "დაჯგუფება",
    "paint.paintEditor.ungroup": "ჯგუფის დაშლა ",
    "paint.paintEditor.undo": "გაუქმება",
    "paint.paintEditor.redo": "აღდგენა",
    "paint.paintEditor.forward": "წინ",
    "paint.paintEditor.backward": "უკან",
    "paint.paintEditor.front": "წინა პლანზე",
    "paint.paintEditor.back": "უკანა პლანზე",
    "paint.paintEditor.more": "სხვა",
    "paint.modeTools.brushSize": "ზომა",
    "paint.modeTools.eraserSize": "საშლელის ზომა",
    "paint.modeTools.copy": "კოპირება",
    "paint.modeTools.paste": "ჩასმა",
    "paint.modeTools.delete": "წაშლა",
    "paint.modeTools.curved": "გამრუდებული",
    "paint.modeTools.pointed": "მიმართული",
    "paint.modeTools.thickness": "სისქე",
    "paint.modeTools.flipHorizontal": "ჰორიზონტალურად არეკვლა",
    "paint.modeTools.flipVertical": "ვერტიკალურად არეკვლა",
    "paint.modeTools.filled": "შევსებული",
    "paint.modeTools.outlined": "შემოხაზული",
    "paint.paintEditor.bitmap": "რასტრულ გამოსახულებად გარდაქმნა",
    "paint.paintEditor.vector": "ვექტორულ გამოსახულებად გარდაქმნა",
    "paint.paintEditor.fill": "შევსება",
    "paint.paintEditor.stroke": "გამოკვეთე",
    "paint.brushMode.brush": "ფუნჯი",
    "paint.eraserMode.eraser": "საშლელი",
    "paint.fillMode.fill": "შევსება",
    "paint.lineMode.line": "ხაზი",
    "paint.ovalMode.oval": "წრე",
    "paint.rectMode.rect": "მართკუთხედი",
    "paint.reshapeMode.reshape": "ფორმის შეცვლა",
    "paint.roundedRectMode.roundedRect": "დამრგვალებული მართკუთხედი",
    "paint.selectMode.select": "არჩევა",
    "paint.textMode.text": "ტექსტი",
    "paint.colorPicker.swap": "შეცვლა"
  },
  "kk": {
    "gui.alerts.lostPeripheralConnection": "Scratch {extensionName}-мен байланысын жоғалтып алды ",
    "gui.alerts.tryAgain": "Қайта жасап көр",
    "gui.alerts.download": "Жүктеп алу",
    "gui.connection.reconnect": "Байланысты қайта орнату",
    "gui.backpack.costumeLabel": "Спрайт",
    "gui.backpack.soundLabel": "дыбыс",
    "gui.backpack.scriptLabel": "скрипт",
    "gui.backpack.spriteLabel": "спрайт",
    "gui.backpack.header": "Рюкзак",
    "gui.backpack.errorBackpack": "Қателер жиналатын иыққап",
    "gui.backpack.loadingBackpack": "Жүктелуде...",
    "gui.backpack.more": "Көбірек",
    "gui.backpack.emptyBackpack": "Иыққап бос",
    "gui.unsupportedBrowser.label": "Браузер қолданылмайды",
    "gui.unsupportedBrowser.errorLabel": "Қате орын алды",
    "gui.unsupportedBrowser.notRecommended": "Өкінішке қарай, сіз Scratch қолдамайтын браузерді қолданып отырған сияқтысыз. Біз сізге  Google Chrome, Mozilla Firefox, Microsoft Edge, немесе Apple Safari секілді браузерлердің соңғы нұсқасын жүктеп алуды ұсынамыз.",
    "gui.unsupportedBrowser.description": "Өкінішке қарай, Scratch бұл браузерді қолдамайды. Біз сізге Google Chrome, Mozilla Firefox, Microsoft Edge, немесе Apple Safari секілді браузерлердің соңғы нұсқасын жүктеп алуды ұсынамыз.",
    "gui.unsupportedBrowser.back": "Артқа",
    "gui.unsupportedBrowser.previewfaq": "Көбірек білу үшін өтіңіз{previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "Жиі қойылатын сұрақтар",
    "gui.cards.all-tutorials": "Оқулықтар",
    "gui.cards.shrink": "Кішірейту",
    "gui.cards.expand": "Кеңейту",
    "gui.cards.close": "Жабу",
    "gui.cards.more-things-to-try": "Тағы бір нәрсе көріңіз!",
    "gui.cards.see-more": "Толығырақ",
    "gui.comingSoon.message1": "Уайымдамаңыз, біз оған дайынбыз{emoji}\n ",
    "gui.comingSoon.message2": "Жуырда...",
    "gui.comingSoon.message3": "Біз бұнымен жұмыс істеп жатырмыз{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Құрылғылар табылмады",
    "gui.connection.auto-scanning.prescan": "Құрылғыны жақындатыңыз да, іздеуді бастаңыз",
    "gui.connection.auto-scanning.pressbutton": "Құрылғыдағы батырманы басыңыз",
    "gui.connection.auto-scanning.start-search": "Іздеуді бастау",
    "gui.connection.connecting-searchbutton": "Іздеу...",
    "gui.connection.auto-scanning.try-again": "Қайта байқап көру",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Қосылды",
    "gui.connection.disconnect": "Ажыратылды",
    "gui.connection.go-to-editor": "Редакторға өту",
    "gui.connection.connecting-cancelbutton": "Қосылуда...",
    "gui.connection.error.errorMessage": "Упс, бірнәрсе жұрыс емес сияқты.",
    "gui.connection.error.tryagainbutton": "Қайта байқап көру",
    "gui.connection.error.helpbutton": "Көмек",
    "gui.connection.peripheral-name-label": "Құрылғының атауы",
    "gui.connection.connect": "Қосылу",
    "gui.connection.scanning.lookingforperipherals": "Құрылғыларды іздеу",
    "gui.connection.scanning.noPeripheralsFound": "Құрылғылар табылмады",
    "gui.connection.scanning.instructions": "Жоғарыдағы тізімнен өз құрылғыңды таңда",
    "gui.connection.search": "Жаңарту",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Сізде  Scratch Link орнатылып, іске қосылғанына көз жеткізіңіз",
    "gui.connection.unavailable.enablebluetooth": "Bluetooth-дің қосылғанына көз жеткізіңіз",
    "gui.connection.unavailable.tryagainbutton": "Қайта байқап көру",
    "gui.connection.unavailable.helpbutton": "Көмек",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Кеттік",
    "gui.controls.stop": "Стоп",
    "gui.crashMessage.label": "Упс! Бір нәрсе дұрыс емес.",
    "gui.crashMessage.description": "Өкінішке қарай, Scratch бұзылып қалған сияқты. Бұл парақ автоматты түрде Scratch командасына жіберіледі. Қайта көру үшін парақшаны жаңартыңыз.",
    "gui.crashMessage.errorNumber": "Бұл қате {errorId}идентификаторымен тіркелді",
    "gui.crashMessage.reload": "Қайта жүктеу",
    "gui.customProcedures.myblockModalTitle": "Блок жасау",
    "gui.customProcedures.addAnInputNumberText": "Енгізуді қосу",
    "gui.customProcedures.numberTextType": "сан немесе  текст",
    "gui.customProcedures.addAnInputBoolean": "Енгізуді қосу",
    "gui.customProcedures.booleanType": "логикалық",
    "gui.customProcedures.addALabel": "Жапсырма қосу",
    "gui.customProcedures.runWithoutScreenRefresh": "Экранды жаңартусыз іске қосу",
    "gui.customProcedures.cancel": "Болдырмау",
    "gui.customProcedures.ok": "Жақсы",
    "gui.SpriteInfo.direction": "Бағыты",
    "gui.directionPicker.rotationStyles.allAround": "Айналада",
    "gui.directionPicker.rotationStyles.leftRight": "Сол/Оң",
    "gui.directionPicker.rotationStyles.dontRotate": "Айналдырмау",
    "gui.gui.addExtension": "Қосымша қосу",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Фондар",
    "gui.gui.costumesTab": "Костюмдер",
    "gui.gui.soundsTab": "Дыбыстар",
    "gui.extensionLibrary.comingSoon": "Жуырда...",
    "gui.extensionLibrary.requires": "Талап етеді",
    "gui.extensionLibrary.collaboration": "бірлесу",
    "gui.library.filterPlaceholder": "Іздеу",
    "gui.library.allTag": "Барлығы",
    "gui.loader.message1": "Блоктарды құру",
    "gui.loader.message2": "Спрайттарды жүктеу",
    "gui.loader.message3": "Дыбыстарды жүктеу",
    "gui.loader.message4": "Қосымшаларды жүктеу",
    "gui.loader.message5": "Мысықтарды бағу...",
    "gui.loader.message6": "Нанобөлшектерді беру....",
    "gui.loader.message7": "Гоболарды үрлеу....",
    "gui.loader.message8": "Эмоджиларды дайындау...",
    "gui.loader.headline": "Проектті жүктеу",
    "gui.loader.creating": "Проектті ашу",
    "gui.accountMenu.profile": "Профиль",
    "gui.accountMenu.myStuff": "Менің жұмыстарым",
    "gui.accountMenu.myClasses": "Менің сыныптарым",
    "gui.accountMenu.myClass": "Менің сыныбым",
    "gui.accountMenu.accountSettings": "Аккаунт баптаулары",
    "gui.accountMenu.signOut": "Шығу",
    "gui.authorInfo.byUser": "{username}",
    "gui.menuBar.seeProjectPage": "Проект парақшасын көру",
    "gui.menuBar.language": "Language",
    "general.username": "Пайдаланушының аты",
    "general.password": "Құпиясөз",
    "general.signIn": "Кіру",
    "login.needHelp": "Көмек керек пе?",
    "form.validationRequired": "Бұл тармақ міндетті түрде толтыру үшін",
    "gui.menuBar.tutorialsLibrary": "Оқулықтар",
    "gui.menuBar.restoreSprite": "Спрайтты қайтару",
    "gui.menuBar.restoreSound": "Дыбысты қайтару",
    "gui.menuBar.restoreCostume": "Костюмді қайтару",
    "gui.menuBar.restore": "Қайтару",
    "gui.menuBar.saveNow": "Қазір сақтау",
    "gui.menuBar.saveAsCopy": "Көшірме ретінде сақтау",
    "gui.menuBar.remix": "Ремикс",
    "gui.menuBar.new": "Жаңа",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Компьютерге сақтау",
    "gui.menuBar.edit": "Түзету",
    "gui.menuBar.turboModeOff": "Турбо режимін өшіру",
    "gui.menuBar.turboModeOn": "Турбо режимін қосу",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Scratch-ке қосылу",
    "gui.menuBar.signIn": "Кіру",
    "gui.gui.projectTitlePlaceholder": "Проекттің атауы осы жерде",
    "gui.menuBar.saveNowLink": "Қазір сақтау",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Бөлісті",
    "gui.menuBar.share": "Бөлісу",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Көмек",
    "gui.modal.back": "Артқа",
    "gui.monitor.listMonitor.empty": "(бос)",
    "gui.monitor.listMonitor.listLength": "ұзындығы{length}",
    "gui.monitor.contextMenu.default": "қалыпты көрсеткіш",
    "gui.monitor.contextMenu.large": "үлкен көрсеткіш",
    "gui.monitor.contextMenu.slider": "тетікше",
    "gui.monitor.contextMenu.sliderRange": "жүгірткінің диапазонын өзгерту",
    "gui.monitor.contextMenu.import": "импорттау",
    "gui.monitor.contextMenu.export": "экспорттау",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Ойнау",
    "gui.playButton.stop": "Стоп",
    "gui.gui.variableScopeOptionAllSprites": "Барлық спрайтар үшін",
    "gui.gui.variableScopeOptionSpriteOnly": "Тек осы спрайт үшін",
    "gui.gui.cloudVariableOption": "Бұлттық айнымалы (серверде сақталады)",
    "gui.gui.variablePromptAllSpritesMessage": "Бұл айнымалы барлық спрайттар үшін қол жетімді",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Болдырмау",
    "gui.prompt.ok": "Жақсы",
    "gui.playbackStep.stopMsg": "Стоп",
    "gui.playbackStep.playMsg": "Ойнау",
    "gui.playbackStep.loadingMsg": "Жүктелуде...",
    "gui.playbackStep.saveMsg": "Сақтау",
    "gui.playbackStep.reRecordMsg": "Қайта жазу",
    "gui.recordModal.title": "Дауысты жазу",
    "gui.recordingStep.beginRecord": "Жазу үшін төменде орналасқан батырманы басыңыз",
    "gui.recordingStep.permission": "{arrow}Микрофонды қолдану үшін бізге сіздің рұқсатыңыз керек",
    "gui.recordingStep.stop": "Жазуды тоқтату",
    "gui.recordingStep.record": "Жазу",
    "gui.sliderModal.min": "Мимималды мән",
    "gui.sliderModal.max": "Максималды мән",
    "gui.sliderModal.title": "Жүгірткінің диапазонын өзгерту",
    "gui.sliderPrompt.cancel": "Болдырмау",
    "gui.sliderPrompt.ok": "Жақсы",
    "gui.soundEditor.sound": "Дыбыс",
    "gui.soundEditor.play": "Ойнау",
    "gui.soundEditor.stop": "Стоп",
    "gui.soundEditor.copy": "Көшіру",
    "gui.soundEditor.paste": "Қою",
    "gui.soundEditor.copyToNew": "Жаңаға көшіру",
    "gui.soundEditor.delete": "Жою",
    "gui.soundEditor.save": "Сақтау",
    "gui.soundEditor.undo": "Болдырмау",
    "gui.soundEditor.redo": "Қайталау",
    "gui.soundEditor.faster": "Жылдамырақ",
    "gui.soundEditor.slower": "Баяуырақ",
    "gui.soundEditor.echo": "Жаңғырық",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "Қаттырақ",
    "gui.soundEditor.softer": "Жұмсағырақ",
    "gui.soundEditor.reverse": "Кері",
    "gui.soundEditor.fadeOut": "Жоғалу",
    "gui.soundEditor.fadeIn": "Пайда болу",
    "gui.soundEditor.mute": "Дыбысын өшіру",
    "gui.SpriteInfo.spritePlaceholder": "Есімі",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Көрсету",
    "gui.SpriteInfo.size": "өлшем",
    "gui.spriteSelectorItem.contextMenuDuplicate": "көшірмесін жасау",
    "gui.spriteSelectorItem.contextMenuExport": "экспорттау",
    "gui.spriteSelectorItem.contextMenuDelete": "жою",
    "gui.spriteSelector.addSpriteFromLibrary": "Спрайтты таңдаңыз",
    "gui.spriteSelector.addSpriteFromPaint": "Бояу",
    "gui.spriteSelector.addSpriteFromSurprise": "Тосын сый",
    "gui.spriteSelector.addSpriteFromFile": "Спрайтты жүктеу",
    "gui.stageHeader.stageSizeLarge": "Үлкен сахнаға ауысу",
    "gui.stageHeader.stageSizeSmall": "Кіші сахнаға ауысу",
    "gui.stageHeader.stageSizeFull": "Толық экран режиміне өту",
    "gui.stageHeader.stageSizeUnFull": "Толық экран режимінен шығу",
    "gui.stageHeader.fullscreenControl": "Толық экранды басқару",
    "gui.spriteSelector.addBackdropFromLibrary": "Фонды таңдаңыз",
    "gui.stageSelector.addBackdropFromPaint": "Бояу",
    "gui.stageSelector.addBackdropFromSurprise": "Тосын сый",
    "gui.stageSelector.addBackdropFromFile": "Фонды жүктеу",
    "gui.stageSelector.stage": "Сахна",
    "gui.stageSelector.backdrops": "фондар",
    "gui.telemetryOptIn.label": "Скретчті жақсарту үшін статистика туралы есеп беру",
    "gui.telemetryOptIn.body1": "Scratch Командасы әрдайым «Scratch»-ті бүкіл әлемде қалай қолданылатындығы туралы жақсы түсінуге тырысады. Бұл әрекетті қолдауға көмектесу үшін,  Сіз Scratch бағдарламасына қолдану туралы ақпаратын автоматты түрде  Scratch Командасына жіберуге рұқсат етуіңізге болады.",
    "gui.telemetryOptIn.body2": "Біз жинаған ақпарат тіл таңдауды, блоктарды пайдалануды және жобаны сақтау, жүктеу және шығару сияқты кейбір оқиғаларды қамтиды. Біз ешқандай жеке ақпаратты жинамаймыз. Қосымша ақпарат алу үшін біздің Құпиялылық саясатымызды {privacyPolicyLink}қараңыз.",
    "gui.telemetryOptIn.privacyPolicyLink": "Құпиялылық саясаты",
    "gui.telemetryOptIn.optInText": "Қолданыс материалын Скратч командасымен бөліс",
    "gui.telemetryOptIn.optInTooltip": "Телеметрияны қосу",
    "gui.telemetryOptIn.optOutText": "Қолданыс материалымен Скратч командасымен бөліспеу ",
    "gui.telemetryOptIn.optOutTooltip": "Телеметрияны өшіру",
    "gui.telemetryOptIn.settingWasUpdated": "Сіздің баптауларыңыз жаңартылды.",
    "gui.telemetryOptIn.buttonClose": "Жабу",
    "gui.turboMode.active": "Турбо режим",
    "gui.webglModal.label": "Сіздің браузеріңіз WebGL-ді қолдамайды",
    "gui.webglModal.description": "Өкінішке қарай сіздің компьютеріңіз немесе браузеріңіз {webGlLink} сияқты. Бұл технология Scratch 3.0 іске қосуды қажет етеді. ",
    "gui.webglModal.webgllink": "WebGL қолдамайды",
    "gui.webglModal.back": "Артқа",
    "gui.webglModal.previewfaq": "Көбірек білу үшін өтіңіз{previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "Жиі қойылатын сұрақтар",
    "gui.costumeLibrary.chooseABackdrop": "Фонды таңдаңыз",
    "gui.costumeLibrary.chooseACostume": "Костюмді таңдау",
    "gui.costumeTab.addBackdropFromLibrary": "Фонды таңдаңыз",
    "gui.costumeTab.addCostumeFromLibrary": "Костюмді таңдау",
    "gui.costumeTab.addBlankCostume": "Бояу",
    "gui.costumeTab.addSurpriseCostume": "Тосын сый",
    "gui.costumeTab.addFileBackdrop": "Фонды жүктеу",
    "gui.costumeTab.addFileCostume": "Костюмді жүктеу",
    "gui.extensionLibrary.chooseAnExtension": "Қосмшаны таңдау",
    "gui.extensionLibrary.extensionUrl": "Қосымшаның URL-ін енгізіңіз",
    "gui.monitors.importListColumnPrompt": "Қай баған қолданылуы керек (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Жазу мүмкін емес",
    "gui.soundLibrary.chooseASound": "Дыбысты таңдау",
    "gui.soundTab.fileUploadSound": "Дыбысты жүктеу",
    "gui.soundTab.surpriseSound": "Тосын сый",
    "gui.soundTab.recordSound": "Жазу",
    "gui.soundTab.addSoundFromLibrary": "Дыбысты таңдау",
    "gui.spriteLibrary.chooseASprite": "Спрайтты таңдаңыз",
    "gui.tipsLibrary.tutorials": "Туториалды таңдау",
    "gui.alerts.createsuccess": "Жаңа проект құрылды.",
    "gui.alerts.createcopysuccess": "Проект көшірме ретінде сақталды.",
    "gui.alerts.createremixsuccess": "Проект ремикс ретінде сақталды.",
    "gui.alerts.creating": "Жаңасын құру...",
    "gui.alerts.creatingCopy": "Проектті көшіру...",
    "gui.alerts.creatingRemix": "Проектті ремикстеу...",
    "gui.alerts.creatingError": "Проектті құру мүмкін емес. Қайта көріңіз!",
    "gui.alerts.savingError": "Проект сақталмады.",
    "gui.alerts.savesuccess": "Проект сақталды.",
    "gui.alerts.saving": "Проект  сақталуда...",
    "gui.alerts.cloudInfo": "Назар аударыңыз, бұлтты айнымалылар символдар мен әріптерді емес,  тек сандарды ғана қолдайды{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Толығырақ.",
    "gui.alerts.importing": "Импорттау...",
    "gui.defaultProject.meow": "Мяу",
    "gui.defaultProject.variable": "менің айнымалым",
    "gui.howtos.intro-move-sayhello-hat.name": "Неден бастауға болады",
    "gui.howtos.intro-move.step_stepMove": "Қозғалу блогын қосу",
    "gui.howtos.add-a-move-block.step_stepSay": "Айту блогын қосу",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Бастау үшін жасыл жалаушаны басыңыз",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Есімге анимация жаса",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Әріп Спрайтты Таңдау",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Басқан Кезде Дыбысты Ойнату",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Басқа Әріп Спрайтты Таңдау",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Түсті өзгерту",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Басқа Әріп Спрайтты Таңдау & Оны Айналдыру",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Басқа Әріп Спрайтты Таңдау & Оны Үлкейту",
    "gui.howtos.imagine": "Әлемді елестетіңіз",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Не Айтқыңыз Келетінін Жазыңыз",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Бастау үшін Жасыл Жалаушаны Басыңыз",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Кез келген Фонды Таңдау",
    "gui.howtos.imagine.step_imagineChooseSprite": "Кез келген Спрайтты Таңдау",
    "gui.howtos.imagine.step_imagineFlyAround": "Сырғу үшін Бос Орын пернесін басу",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Басқа Спрайтты таңдау",
    "gui.howtos.imagine.step_imagineLeftRight": "Оңға-Солға Қозғалту",
    "gui.howtos.imagine.step_imagineUpDown": "Жоғары-Төмен Қозғалту",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Костюмдерді Өзгерту",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Нүктеге Сырғу",
    "gui.howtos.imagine.step_imagineGrowShrink": "Өсу және кішірею",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Басқа Фонды Таңдау",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Фондарды өзгертіңіз",
    "gui.howtos.imagine.step_imagineRecordASound": "Дыбысты қосыңыз",
    "gui.howtos.imagine.step_imagineChooseSound": "Өз Дыбысыңды Таңдау",
    "gui.howtos.make-music.name": "Әуенді жаса",
    "gui.howtos.Make-Music.step_PickInstrument": "Аспап Спрайтты Таңдау",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Басқан Кезде Дыбысты Ойнату",
    "gui.howtos.Make-Music.step_MakeSong": "Ән Құрастыру",
    "gui.howtos.make-music.step_MakeBeat": "Дабылды Таңдау & Ырғақ Құру",
    "gui.howtos.make-music.step_MakeBeatBox": "Микрофон Спрайтты  & Битбокс Тосын сыйын Таңдау",
    "gui.howtos.story.name": "Оқиға Құру",
    "gui.howtos.story.step_addbg": "Фонды қосыңыз",
    "gui.howtos.story.step_addsprite": "Кейіпкер Қосу",
    "gui.howtos.story.step_saysomething": "Бір нәрсе айтыңыз",
    "gui.howtos.story.step_addanothersprite": "Басқа Кейіпкер Қосу",
    "gui.howtos.story.step_flip": "Бағытты ауыстыру",
    "gui.howtos.story.step_conversation": "Әңгімелесу",
    "gui.howtos.story.addanotherbg": "Басқа Фон Қосу",
    "gui.howtos.story.step_swithbg": "Фондарды өзгертіңіз",
    "gui.howtos.story.step_hidewizard": "Кейіпкерді Жасыру",
    "gui.howtos.story.step_showwizard": "Кейіпкерді Көрсету",
    "gui.howtos.make-a-chase-game.name": "Қуыспақ Ойынын Жасау",
    "gui.howtos.Chase-Game.step_BG": "Фонды қосыңыз",
    "gui.howtos.chase-game.step_AddOcto": "Спрайтты қосыңыз",
    "gui.howtos.make-music.step_LeftRight": "Бағытауыш Пернелер Арқылы Оңға & Солға Қозғалту ",
    "gui.howtos.Chase-Game.step_UpDown": "Бағытауыш Пернелер Арқылы Жоғары & Төмен Қозғалту ",
    "gui.howtos.Chase-Game.step_AddStar": "Басқа Спрайтты Қосу",
    "gui.howtos.Chase-Game.step_MoveRandom": "Кездейсоқ Қозғалту",
    "gui.howtos.Chase-Game.step_WhenTouch": "Сегізаяқ Спрайтын Басқан Кезде Дыбысты Ойнату",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Ұпай Айнымалысын Құру",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Сегізаяқ Спрайтын Басқан Кезде Ұпайды Қосу",
    "gui.howtos.animate-char.name": "Кейіпкерді Анимациялау",
    "gui.howtos.animate-char.step_addbg": "Фонды қосыңыз",
    "gui.howtos.animate-char.step_addsprite": "Спрайтты қосыңыз",
    "gui.howtos.animate-char.step_saysomething": "Бір нәрсе айтыңыз",
    "gui.howtos.animate-char.step_addsound": "Дыбысты қосу",
    "gui.howtos.animate-char.step_animatetalking": "Әңгімелесуді Анимациялау",
    "gui.howtos.animate-char.step_arrowkeys": "Бағыттауыш Пернелерді Қолданып Қозғалту",
    "gui.howtos.animate-char.step_jump": "Секіру",
    "gui.howtos.animate-char.step_changecolor": "Түсті өзгертіңіз",
    "gui.howtos.make-a-game.name": "Кликер Ойынын Жасау",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Спрайтты Таңдау",
    "gui.howtos.make-a-game.step_GamePlaySound": "Басқан Кезде Дыбысты Ойнату",
    "gui.howtos.make-a-game.step_GameAddScore": "Ұпай Айнымалысын Құру",
    "gui.howtos.make-a-game.step_GameChangeScore": "Басқан Кезде Ұпайды Арттыру",
    "gui.howtos.make-a-game.step_Random": "Кездейсоқ орынға бару",
    "gui.howtos.make-music.step_GameChangeColor": "Түсті өзгертіңіз",
    "gui.howtos.make-music.step_ResetScore": "Ұпайды Қалпына келтіру",
    "gui.howtos.make-it-fly.name": "Ұшыру",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Аспан Фонын Таңдау",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Кейіпкерді таңдаңыз",
    "gui.howtos.fly.step_stepflySaySomething": "Бір нәрсе айтыңыз",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Бағыттауыш Пернелер Арқылы Қозғалту",
    "gui.howtos.fly.step_stepflyChooseObject": "Жинауға арналған Объектті Таңдау",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Объектті қозғалту",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Өз Кейіпкеріңді Таңдау",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ұпайды Қосу",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Ұпайды Сақтау",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Декорация қосыңыз",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Көріністі Қозғалту",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Келесі Костюм",
    "gui.howtos.pong": "Үстел теннис ойыны",
    "gui.howtos.pong.step_pongAddBackdrop": "Фонды қосыңыз",
    "gui.howtos.pong.step_pongAddBallSprite": "Доп Спрайтты Қосу",
    "gui.howtos.pong.step_pongBounceAround": "Секіру",
    "gui.howtos.pong.step_pongAddPaddle": "Ескекті Қосу",
    "gui.howtos.pong.step_pongMoveThePaddle": "Ескекті Қозғалту",
    "gui.howtos.pong.step_pongSelectBallSprite": "Доп Спрайтты Қозғалту",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Доптың ракеткадан кері ұшатын кодын жазу",
    "gui.howtos.pong.step_pongAddAScore": "Ұпайды Қосу",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Менюден \"Ұпайды\" таңдау",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "\"Ұпайды Өзгерту\" Блогын Енгізу",
    "gui.howtos.pong.step_pongResetScore": "Ұпайды Қалпына келтіру",
    "gui.howtos.pong.step_pongAddLineSprite": "Түзу Спрайтын Қосу",
    "gui.howtos.pong.step_pongGameOver": "Ойын Аяқталды",
    "gui.howtos.code-cartoon": "Мультфильмді кодтау",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Жасыл Жалаушаны Басқан Кезде Бір Нәрсе Айту",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Кейіпкерді Басқан Кезде Оны Анимациялау",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Әртүрлі Кейіпкерлерді Таңдау",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Кішірейту Үшін Минус Таңбасын Қолдану",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Кейіпкерді Өсіру және Кішірейту",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Әртүрлі Кейіпкерлерді Таңдау",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Жоғары және Төмен Секіру",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Сахналарды Ауыстыру үшін Кейіпкерді Басу",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Айналада Сырғанау",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Костюмдерді Өзгерту",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Өз Мультфильміңе Қосу үшін Көбірек Кейіпкерлерді Таңдау",
    "gui.howtos.cartoon-network": "Шытырман Оқиғалы Ойынды Анимациялау",
    "gui.howtos.cartoon-network.step_CNcharacter": "Көрсететін Кейіпкерді Таңдау",
    "gui.howtos.cartoon-network.step_CNsay": "Бір нәрсе айтыңыз",
    "gui.howtos.cartoon-network.step_CNglide": "Айналада Сырғанау",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Қуалайтын Объектті Таңдау",
    "gui.howtos.cartoon-network.step_CNcollect": "Объекттерді Жинау",
    "gui.howtos.cartoon-network.step_CNvariable": "Ұпай Айнымалысын Құру",
    "gui.howtos.cartoon-network.step_CNscore": "Ұпайды Сақтау",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Деңгейді Көтеру: Фонды Өзгерту",
    "gui.howtos.videosens.name": "Бейнебақылау",
    "gui.howtos.videosens.step_addextension": "Қосымша қосу",
    "gui.howtos.videosens.step_pet": "Мысықты Сипау",
    "gui.howtos.videosens.step_animate": "Анимациялау",
    "gui.howtos.videosens.step_pop": "Шарды Жару",
    "gui.howtos.say-it-out-loud": "Сөйлейтін Анмацияны Құру",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Мәтінді Сөйлеу Блоктарына Қосу",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Бір нәрсе айтыңыз",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Дауысты Орнату",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Айнала Қоғалу",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Фонды қосыңыз",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Басқа Кейіпкер Қосу",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Әнді Орындау",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Түсті өзгертіңіз",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Айналу",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Өсу және кішірею",
    "gui.howtos.talking": "Сөйлейтін Ертегілер",
    "gui.howtos.talking.step_talesAddExtension": "Мәтінді Сөйлеу Блоктарына Қосу үшін Басу",
    "gui.howtos.talking.step_talesChooseSprite": "Спрайтты таңдаңыз",
    "gui.howtos.talking.step_talesSaySomething": "Кейіпкерді Сөйлету",
    "gui.howtos.talking.step_talesChooseBackdrop": "Фонды таңдаңыз",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Келесі Фонға Өту үшін Кейіпкерді Басу",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Басқа Спрайтты таңдау",
    "gui.howtos.talking.step_talesMoveAround": "Айнала Қоғалу",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Басқа Фонды Таңдау",
    "gui.howtos.talking.step_talesAnimateTalking": "Әңгімелесуді Анимациялау",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Басқа Фонды Таңдау",
    "gui.howtos.talking.step_talesChooseSound": "Билейтін Өлеңді Таңдау",
    "gui.howtos.talking.step_talesDanceMoves": "Би Қимылдары",
    "gui.howtos.talking.step_talesAskAnswer": "Зерттеу Категориясынан Сұрау және Жауап беру Блоктарын Алу",
    "gui.howtos.add-sprite.name": "Спрайтты қосыңыз",
    "gui.howtos.add-sprite.step_addSprite": "Спрайтты қосыңыз",
    "gui.howtos.add-a-backdrop.name": "Фонды қосыңыз",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Фонды қосыңыз",
    "gui.howtos.change-size.name": "Өлшемін Өзгерту",
    "gui.howtos.change-size.step_changeSize": "Өлшемін Өзгерту",
    "gui.howtos.glide-around.name": "Айналада Сырғанау",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Айналада Сырғанау",
    "gui.howtos.change-size.step_glideAroundPoint": "Нүктеге Сырғу",
    "gui.howtos.record-a-sound.name": "Дыбысты Жазу",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "\"Дыбыстар\" Батырмасын Басу",
    "gui.howtos.change-size.step_recordASoundClickRecord": "\"Жазу\"-ды Басу",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Жазу Батырмасын Басу",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Өз Дыбысыңды Таңдау",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Өз Дыбысыңды Ойнату",
    "gui.howtos.spin-video.name": "Оны айналдырыңыз",
    "gui.howtos.change-size.step_spinTurn": "Бұру",
    "gui.howtos.change-size.step_spinPointInDirection": "Бағытты орнату",
    "gui.howtos.hide-and-show.name": "Тығу және Көрсету",
    "gui.howtos.change-size.step_hideAndShow": "Тығу және Көрсету",
    "gui.howtos.switch-costume.name": "Спрайтты Анимациялау",
    "gui.howtos.change-size.step_switchCostumes": "Спрайтты Анимациялау",
    "gui.howtos.move-around-with-arrow-keys.name": "Бағыттауыш Пернелерді Қолдану",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Оңға және Солға Қозғалту",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Жоғары және Төмен Қозғалту",
    "gui.howtos.add-effects.name": "Әсерер қосыңыз",
    "gui.howtos.videosens.step_addEffects": "Әсерер қосыңыз",
    "gui.extension.music.name": "Музыка",
    "gui.extension.music.description": "Аспаптарда және дабылда ойнау",
    "gui.extension.pen.name": "Қалам",
    "gui.extension.pen.description": "Өз спрайтыңды салу",
    "gui.extension.videosensing.name": "Бейнебақылау",
    "gui.extension.videosensing.description": "Қозғалысты камера арқылы сезу",
    "gui.extension.text2speech.name": "Текстті дауысқа айналдыру",
    "gui.extension.text2speech.description": "Өз проектіңді сөйлету",
    "gui.extension.translate.name": "Аудару",
    "gui.extension.translate.description": "Текстті көптеген тілдерге аудару",
    "gui.extension.makeymakey.description": "Кілтке Бірнәрсе Жасау",
    "gui.extension.microbit.description": "Өз проектіңді әлеммен байланыстыр",
    "gui.extension.microbit.connectingMessage": "Қосылуда...",
    "gui.extension.ev3.description": "Интерактивті Роботтарды Құрастыру",
    "gui.extension.ev3.connectingMessage": "Қосылуда. Өз EV3-де 1234 пині орнатылғанын көз жеткізіңіз.",
    "gui.extension.boost.description": "Роботтандырылған туындыларды өмірге енгізіңіз",
    "gui.extension.boost.connectingMessage": "Қосылуда...",
    "gui.extension.wedo2.description": "Қозғалтқыштар мен датчиктермен құрастырыңыз",
    "gui.extension.wedo2.connectingMessage": "Қосылуда...",
    "gui.extension.gdxfor.description": "Итеруді, тартуды, қозғалысты және айналуды сезініңіз",
    "gui.extension.gdxfor.connectingMessage": "Қосылуда...",
    "gui.libraryTags.all": "Барлығы",
    "gui.libraryTags.animals": "Жануарлар",
    "gui.libraryTags.dance": "Би",
    "gui.libraryTags.effects": "Эффекттер",
    "gui.libraryTags.fantasy": "Қиял",
    "gui.libraryTags.fashion": "Сән",
    "gui.libraryTags.food": "Тағам",
    "gui.libraryTags.indoors": "Ғимарат ішінде",
    "gui.libraryTags.loops": "Түйіндер",
    "gui.libraryTags.music": "Музыка",
    "gui.libraryTags.notes": "Нота",
    "gui.libraryTags.outdoors": "Ашық ауада",
    "gui.libraryTags.patterns": "Өрнектер",
    "gui.libraryTags.people": "Адамдар",
    "gui.libraryTags.percussion": "Перкуссия",
    "gui.libraryTags.space": "Пробел",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Су асты әлемі",
    "gui.libraryTags.voice": "Дауыс",
    "gui.libraryTags.wacky": "Тентек",
    "gui.libraryTags.animation": "Анимация",
    "gui.libraryTags.art": "Өнер",
    "gui.libraryTags.games": "Ойындар",
    "gui.libraryTags.stories": "Әңгімелер",
    "gui.libraryTags.letters": "Әріптер",
    "gui.opcodeLabels.direction": "бағыт",
    "gui.opcodeLabels.xposition": "x қалпында",
    "gui.opcodeLabels.yposition": "y қалпында",
    "gui.opcodeLabels.size": "өлшем",
    "gui.opcodeLabels.costumename": "костюм аты",
    "gui.opcodeLabels.costumenumber": "костюм нөмірі",
    "gui.opcodeLabels.backdropname": "фонның атауы",
    "gui.opcodeLabels.backdropnumber": "фон нөмірі",
    "gui.opcodeLabels.volume": "дыбыс",
    "gui.opcodeLabels.tempo": "қарқын",
    "gui.opcodeLabels.answer": "жауап",
    "gui.opcodeLabels.loudness": "дыбыс деңгейі",
    "gui.opcodeLabels.username": "пайдаланушының аты",
    "gui.opcodeLabels.year": "жыл",
    "gui.opcodeLabels.month": "ай",
    "gui.opcodeLabels.date": "күні",
    "gui.opcodeLabels.dayofweek": "апта күні",
    "gui.opcodeLabels.hour": "сағат",
    "gui.opcodeLabels.minute": "минут",
    "gui.opcodeLabels.second": "секунд",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Таңдалған проекттің файлы жүкелмеді",
    "gui.sharedMessages.backdrop": "фон{index}",
    "gui.sharedMessages.costume": "костюм{index}",
    "gui.sharedMessages.sprite": "Спрайт{index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Ағымдағы проекттің мазмұнын ауыстыру керек пе?",
    "gui.sharedMessages.loadFromComputerTitle": "Компьютерден жүктеу",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch  проекті",
    "boost.color.any": "кез келген түс",
    "boost.color.black": "қара",
    "boost.color.blue": "көк",
    "boost.color.green": "жасыл",
    "boost.color.red": "қызыл",
    "boost.color.white": "ақ",
    "boost.color.yellow": "сары",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] моторының орны",
    "boost.getTiltAngle": "[TILT_DIRECTION] еңкею бұрышы ",
    "boost.motorDirection.backward": "осы жолмен",
    "boost.motorDirection.forward": "осылайша",
    "boost.motorDirection.reverse": "қайту",
    "boost.motorOff": " [MOTOR_ID] моторын өшір",
    "boost.motorOn": " [MOTOR_ID] моторын іске қос",
    "boost.motorOnFor": "[MOTOR_ID] моторын [DURATION] секундқа қос",
    "boost.motorOnForRotation": "[MOTOR_ID] моторын [ROTATION] рет айналуға қос",
    "boost.seeingColor": " [COLOR] кірпіші көрініп тұр ма?",
    "boost.setLightHue": "жарық түсін [HUE] орнат",
    "boost.setMotorDirection": "[MOTOR_ID]  моторын [MOTOR_DIRECTION] бағытында орнат",
    "boost.setMotorPower": "[MOTOR_ID] моторының жылдамдығын  [POWER] % орнат",
    "boost.tiltDirection.any": "кез келген",
    "boost.tiltDirection.down": "төмен",
    "boost.tiltDirection.left": "солға",
    "boost.tiltDirection.right": "оңға",
    "boost.tiltDirection.up": "жоғары",
    "boost.whenColor": " [COLOR]  кірпіші көрінгенде",
    "boost.whenTilted": " [TILT_DIRECTION_ANY] еңкейгенде",
    "ev3.beepNote": "[NOTE] жазбасының [TIME] секундқа дыбысын қос",
    "ev3.buttonPressed": "[PORT] пернесі басылды ма?",
    "ev3.getBrightness": "жарықтық",
    "ev3.getDistance": "арақашықтық",
    "ev3.getMotorPosition": " [PORT] моторының орны",
    "ev3.motorSetPower": " [PORT] моторына [POWER] % қуатын орнату",
    "ev3.motorTurnClockwise": " [PORT] моторын осы бағытта [TIME] секунд бойы бұру",
    "ev3.motorTurnCounterClockwise": " [PORT] моторын осы бағытта [TIME] секунд бойы бұр",
    "ev3.whenBrightnessLessThan": "жарықтығы < [DISTANCE] болғанда",
    "ev3.whenButtonPressed": " [PORT] пернесі басылғанда",
    "ev3.whenDistanceLessThan": "қашықтыңы < [DISTANCE] болғанда",
    "gdxfor.getAcceleration": " [DIRECTION] үдеу",
    "gdxfor.getForce": "күш",
    "gdxfor.getSpin": "айналу жылдамдығы [DIRECTION]",
    "gdxfor.getTilt": "еңкею бұрышы [TILT]",
    "gdxfor.isFreeFalling": "құлап бара жатыр ма?",
    "gdxfor.isTilted": "[TILT] еңкейді ме?",
    "gdxfor.pulled": "тартылды",
    "gdxfor.pushed": "итерілді",
    "gdxfor.shaken": "шайқалды",
    "gdxfor.startedFalling": "құлай бастады",
    "gdxfor.tiltDirectionMenu.any": "кез келген",
    "gdxfor.tiltDirectionMenu.back": "арты",
    "gdxfor.tiltDirectionMenu.front": "алды",
    "gdxfor.tiltDirectionMenu.left": "солға",
    "gdxfor.tiltDirectionMenu.right": "оңға",
    "gdxfor.turnedFaceDown": "беті тқмен қарады",
    "gdxfor.turnedFaceUp": "беті жоғары қарады",
    "gdxfor.whenForcePushedOrPulled": "сенсорда [PUSH_PULL] әрекеті болғанда",
    "gdxfor.whenGesture": "[GESTURE] болғанда",
    "gdxfor.whenTilted": "[TILT] еңкейгенде",
    "makeymakey.downArrow": "нұсқары төмен",
    "makeymakey.downArrowShort": "төмен",
    "makeymakey.leftArrow": "нұсқары солға",
    "makeymakey.leftArrowShort": "солға",
    "makeymakey.rightArrow": "нұсқары оңға",
    "makeymakey.rightArrowShort": "оңға",
    "makeymakey.spaceKey": "пробел",
    "makeymakey.upArrow": "нұсқары жоғары",
    "makeymakey.upArrowShort": "жоғары",
    "makeymakey.whenKeyPressed": "[KEY] пернесі басылғанда",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] ретпен басылғанда",
    "microbit.buttonsMenu.any": "кез келген",
    "microbit.clearDisplay": "дисплейді тазалау",
    "microbit.defaultTextToDisplay": "Сәлем!",
    "microbit.displaySymbol": "[MATRIX] көрсету",
    "microbit.displayText": "[TEXT] мәтінін көрсету",
    "microbit.gesturesMenu.jumped": "секірді",
    "microbit.gesturesMenu.moved": "қозғалды",
    "microbit.gesturesMenu.shaken": "шайқалды",
    "microbit.isButtonPressed": "[BTN] пернесі басылды ма?",
    "microbit.isTilted": "[DIRECTION] еңкейді ме?",
    "microbit.pinStateMenu.off": "өшіру",
    "microbit.pinStateMenu.on": "қосу",
    "microbit.tiltAngle": "еңкею бұрышы [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "кез келген",
    "microbit.tiltDirectionMenu.back": "арты",
    "microbit.tiltDirectionMenu.front": "алды",
    "microbit.tiltDirectionMenu.left": "солға",
    "microbit.tiltDirectionMenu.right": "оңға",
    "microbit.whenButtonPressed": "[BTN] пернесі басылғанда",
    "microbit.whenGesture": "[GESTURE] болғанда",
    "microbit.whenPinConnected": "[PIN] істігі қосылғанда",
    "microbit.whenTilted": "[DIRECTION] бағытында еңкейгенде",
    "music.categoryName": "Музыка",
    "music.changeTempo": "темпті [TEMPO] өзгерткенде",
    "music.drumBass": "(2) бас дабылы",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "Клавес",
    "music.drumClosedHiHat": "Жабық хай-хэт",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": " Cowbell",
    "music.drumCrashCymbal": "Табақшалардың соғылуы",
    "music.drumCuica": "Куика",
    "music.drumGuiro": "Гуиро",
    "music.drumHandClap": "Шапалақтау",
    "music.drumOpenHiHat": "Ашық хай-хэт",
    "music.drumSideStick": "Бүйір қалам",
    "music.drumSnare": "Дабыл",
    "music.drumTambourine": "Тамбурин",
    "music.drumTriangle": "Үшбұрыш",
    "music.drumVibraslap": "Вибраслэп",
    "music.drumWoodBlock": "Ағаш қорапша",
    "music.getTempo": "Дыбыс ырғағы",
    "music.instrumentBass": "Бас",
    "music.instrumentBassoon": "Фагот",
    "music.instrumentCello": "Виолончель",
    "music.instrumentChoir": "Хор",
    "music.instrumentClarinet": "Кларнет",
    "music.instrumentElectricGuitar": "Электрлік гитара",
    "music.instrumentElectricPiano": "Электрлік пианино",
    "music.instrumentFlute": "Флейта",
    "music.instrumentGuitar": "Гитара",
    "music.instrumentMarimba": "Маримба",
    "music.instrumentMusicBox": "Музыкалық сандық",
    "music.instrumentOrgan": "Орган",
    "music.instrumentPiano": "Пианино",
    "music.instrumentPizzicato": "Пиццикато",
    "music.instrumentSaxophone": "Саксофон",
    "music.instrumentSteelDrum": "Болат дабыл",
    "music.instrumentSynthLead": "Жетекші синтезатор",
    "music.instrumentSynthPad": "Pad синтезаторі",
    "music.instrumentTrombone": "Тромбон",
    "music.instrumentVibraphone": "Вибрафон",
    "music.instrumentWoodenFlute": "Ағаш флейта",
    "music.midiPlayDrumForBeats": "[DRUM]  дабылында [BEATS]  такт ойнау",
    "music.midiSetInstrument": "[INSTRUMENT] аспабын орнату",
    "music.playDrumForBeats": "[DRUM]  дабылында [BEATS]  такт ойнау",
    "music.playNoteForBeats": "[NOTE]  нотасында [BEATS]  такт ойнау",
    "music.restForBeats": " [BEATS]  такт күту",
    "music.setInstrument": "[INSTRUMENT] аспабын орнату",
    "music.setTempo": "Ырғақты [TEMPO] орнатыңыз",
    "pen.categoryName": "Қалам",
    "pen.changeColorParam": "[COLOR_PARAM]  қаламның түсін  [VALUE] бойынша өзгерту",
    "pen.changeHue": "қаламның түсін [HUE]  өзгерту ",
    "pen.changeShade": "қалам реңін [SHADE] өзгерту",
    "pen.changeSize": "қаламның өлшемін [SIZE] өзгерту ",
    "pen.clear": "Бәрін өшіру",
    "pen.colorMenu.brightness": "жарықтық",
    "pen.colorMenu.color": "түс",
    "pen.colorMenu.saturation": "Қанықтылық",
    "pen.colorMenu.transparency": "мөлдірлік",
    "pen.penDown": "қауырсынды түсіру",
    "pen.penUp": "қауырсынды көтеру",
    "pen.setColor": "қаламның түсін [COLOR] орнату",
    "pen.setColorParam": "[COLOR_PARAM] қаламның түсін  [VALUE] бойынша орнату",
    "pen.setHue": "қаламның түсін  [HUE] орнату",
    "pen.setShade": "қалам реңін [SHADE] өзгерту",
    "pen.setSize": "қаламның өлшемін [SIZE] орнату",
    "pen.stamp": "марка",
    "speech.defaultWhenIHearValue": "Кеттік",
    "speech.extensionName": "Дауысты текстке айналдыру",
    "speech.listenAndWait": "тыңдау және күту",
    "speech.speechReporter": "сөз",
    "speech.whenIHear": "Мен  [PHRASE] естіген кезде",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "Текстті дауысқа айналдыру",
    "text2speech.defaultTextToSpeak": "сәлем",
    "text2speech.giant": "алып",
    "text2speech.kitten": "марғау",
    "text2speech.setLanguageBlock": "тілді [LANGUAGE] орнату",
    "text2speech.setVoiceBlock": "дауысты  [VOICE] орнату",
    "text2speech.speakAndWaitBlock": "[WORDS] айту",
    "text2speech.squeak": "сықырлау",
    "text2speech.tenor": "тенор",
    "translate.categoryName": "Аудару",
    "translate.defaultTextToTranslate": "сәлем",
    "translate.translateBlock": "[WORDS] [LANGUAGE] тіліне аудару",
    "translate.viewerLanguage": "тіл",
    "videoSensing.categoryName": "Бейнебақылау",
    "videoSensing.direction": "бағыт",
    "videoSensing.motion": "қозғалыс",
    "videoSensing.off": "өшіру",
    "videoSensing.on": "қосу",
    "videoSensing.onFlipped": "төңкерілген",
    "videoSensing.setVideoTransparency": "бейне ашықтығын [TRANSPARENCY]  орнату",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "stage",
    "videoSensing.videoOn": "[SUBJECT]-тегі видео [ATTRIBUTE] ",
    "videoSensing.videoToggle": "[VIDEO_STATE] видеоны іске қосу",
    "videoSensing.whenMotionGreaterThan": "видео қозғалысы > [REFERENCE]",
    "wedo2.getDistance": "арақашықтық",
    "wedo2.getTiltAngle": "[TILT_DIRECTION] еңкею бұрышы ",
    "wedo2.isTilted": " [TILT_DIRECTION_ANY] еңкейген бе?",
    "wedo2.motorDirection.backward": "осы жолмен",
    "wedo2.motorDirection.forward": "осылайша",
    "wedo2.motorDirection.reverse": "қайту",
    "wedo2.motorId.a": "А моторы",
    "wedo2.motorId.all": "барлық моторлар",
    "wedo2.motorId.b": "Б моторы",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": " [MOTOR_ID] моторын өшір",
    "wedo2.motorOn": " [MOTOR_ID] моторын іске қос",
    "wedo2.motorOnFor": "[MOTOR_ID] моторын [DURATION] секундқа қос",
    "wedo2.playNoteFor": "[NOTE]  нотасын [DURATION] секунд ойнату",
    "wedo2.setLightHue": "жарық түсін [HUE] орнат",
    "wedo2.setMotorDirection": "[MOTOR_ID]  моторын [MOTOR_DIRECTION] бағытында орнат",
    "wedo2.startMotorPower": "[MOTOR_ID] қуатын [POWER] орнату",
    "wedo2.tiltDirection.any": "кез келген",
    "wedo2.tiltDirection.down": "төмен",
    "wedo2.tiltDirection.left": "солға",
    "wedo2.tiltDirection.right": "оңға",
    "wedo2.tiltDirection.up": "жоғары",
    "wedo2.whenDistance": "арақашықтық [OP] [REFERENCE] болған кезде",
    "wedo2.whenTilted": " [TILT_DIRECTION_ANY] еңкейгенде",
    "paint.paintEditor.hue": "Түс",
    "paint.paintEditor.saturation": "Қанықтылық",
    "paint.paintEditor.brightness": "Жарықтығы",
    "paint.paintEditor.costume": "Костюм",
    "paint.paintEditor.group": "Топтау",
    "paint.paintEditor.ungroup": "топтан шығару",
    "paint.paintEditor.undo": "Болдырмау",
    "paint.paintEditor.redo": "Қайталау",
    "paint.paintEditor.forward": "Алға",
    "paint.paintEditor.backward": "Артқа",
    "paint.paintEditor.front": "Фронт",
    "paint.paintEditor.back": "Артқа",
    "paint.paintEditor.more": "Көбірек",
    "paint.modeTools.brushSize": "өлшем",
    "paint.modeTools.eraserSize": "Өшіргіштің өлшемі",
    "paint.modeTools.copy": "Көшіру",
    "paint.modeTools.paste": "Қою",
    "paint.modeTools.delete": "Жою",
    "paint.modeTools.curved": "Қисық",
    "paint.modeTools.pointed": "Көрсетілген\n",
    "paint.modeTools.thickness": "Қалыңдығы",
    "paint.modeTools.flipHorizontal": "Көлденеңінен аудару",
    "paint.modeTools.flipVertical": "Тігінен аудару",
    "paint.modeTools.filled": "Толтырылған",
    "paint.modeTools.outlined": "Сызылған",
    "paint.paintEditor.bitmap": "Растрлық графикаға ауыстыру",
    "paint.paintEditor.vector": "Векторлық графикаға ауыстыру",
    "paint.paintEditor.fill": "Толтыру",
    "paint.paintEditor.stroke": "контур",
    "paint.brushMode.brush": "Қылқалам",
    "paint.eraserMode.eraser": "Өшіргіш",
    "paint.fillMode.fill": "Толтыру",
    "paint.lineMode.line": "Сызық",
    "paint.ovalMode.oval": "Шеңбер",
    "paint.rectMode.rect": "Тікбұрыш",
    "paint.reshapeMode.reshape": "Форманы өзгерту",
    "paint.roundedRectMode.roundedRect": "Дөңгелек бұрышты төртбұрыш",
    "paint.selectMode.select": "Таңдау",
    "paint.textMode.text": "Мәтін",
    "paint.colorPicker.swap": "Ауыстыру"
  },
  "qu": {
    "gui.alerts.lostPeripheralConnection": "Scratch chinkarun tupachisqaman {extensionName}",
    "gui.alerts.tryAgain": "Yapamanta Ruray",
    "gui.alerts.download": "Hurquy",
    "gui.connection.reconnect": "Yapamanta Qallariy",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Qipina",
    "gui.backpack.errorBackpack": "Mana allinchu llamkay",
    "gui.backpack.loadingBackpack": "Llamkachkan...",
    "gui.backpack.more": "aswan",
    "gui.backpack.emptyBackpack": "Mana imayuq qipina",
    "gui.unsupportedBrowser.label": "maskaynin manam allinchu kaywan",
    "gui.unsupportedBrowser.errorLabel": "Manam Yaykunchu",
    "gui.unsupportedBrowser.notRecommended": "Llakikunin qanmanta, icha Scratch llamkasqayki kay nabiqador mana kumpatibliblichus kanman. yuyachisaqiki musuq nabiqadurta churay chay Goole chrome, Mozilla Firefox, Microsoft Edge utaq Apple safari nisqankipi. ",
    "gui.unsupportedBrowser.description": "llakikunin qanmanta, icha Scratch manam kumpatiblichu kay nabiqadurwan. yuyachisqayki musuq nabiqadurta churay chay Goole chrome, Mozilla Firefox, Microsoft Edge utaq Apple safari nisqankipi.",
    "gui.unsupportedBrowser.back": "hipaman",
    "gui.unsupportedBrowser.previewfaq": "Yachayta munaspaykiqa kayman ripuy {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "Ima riqsiq munay",
    "gui.cards.all-tutorials": "Yanapawansunchik",
    "gui.cards.shrink": "Qintikuchkan",
    "gui.cards.expand": "Hatunyachiy",
    "gui.cards.close": "Wichqay",
    "gui.cards.more-things-to-try": "Ancha Yanapay Qawanapaq!",
    "gui.cards.see-more": "Acha Qaway",
    "gui.comingSoon.message1": "ama llakikuychu chanipunim {emoji}",
    "gui.comingSoon.message2": "Hukninkama...",
    "gui.comingSoon.message3": "chay punim llamkachkaniku {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Manan Ima Llamkaynin Tarikunchu",
    "gui.connection.auto-scanning.prescan": "Ima lamkaynikita kuskapuni churay, chaymanta Qallariy Maskariyta.",
    "gui.connection.auto-scanning.pressbutton": "llamkaynikipi butunta ñipuy",
    "gui.connection.auto-scanning.start-search": "Maskay Qallariq",
    "gui.connection.connecting-searchbutton": "Maskariy",
    "gui.connection.auto-scanning.try-again": "Yapamanta Ruray",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Kuskachasqa",
    "gui.connection.disconnect": "Wañuchina",
    "gui.connection.go-to-editor": "Maukachinapaq",
    "gui.connection.connecting-cancelbutton": "Kuskachasqa",
    "gui.connection.error.errorMessage": "Karay, manam allintachus Lluqsichkan.",
    "gui.connection.error.tryagainbutton": "Yapamanta Ruray",
    "gui.connection.error.helpbutton": "yanapay",
    "gui.connection.peripheral-name-label": "Llamkaynikipa Sutin",
    "gui.connection.connect": "Kuskasqa",
    "gui.connection.scanning.lookingforperipherals": "Llamkaynikita Maskariy",
    "gui.connection.scanning.noPeripheralsFound": "Manan Ima Llamkaynin Tarikunchu",
    "gui.connection.scanning.instructions": "Akllay ima llamkayniki Tarikusqanta. ",
    "gui.connection.search": "Musuqyachi",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Yuyari Scratch Link tupachisqa kanqa allin llamkanaykipaq",
    "gui.connection.unavailable.enablebluetooth": "Chiqanchay Bluetooth kuyurichisqa kachun",
    "gui.connection.unavailable.tryagainbutton": "Yapamanta Ruray",
    "gui.connection.unavailable.helpbutton": "yanapay",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Riy",
    "gui.controls.stop": "Sayay",
    "gui.crashMessage.label": "Ay! Mana allintachu lluqsirun",
    "gui.crashMessage.description": "Llakikunin qanmanta, icha Scratch mana allinchu kan. kay pantachisqata Scratch Ikipunman apachikurqa utqayllaman. ama hina kaspalla, musuqyachi Paqinaykita yapamanta qallarinaykipaq.",
    "gui.crashMessage.errorNumber": "pantasqaykiqa churakurqun kay id-wan {errorId}",
    "gui.crashMessage.reload": "Yapamanta qallariy",
    "gui.customProcedures.myblockModalTitle": "ruray huk champata",
    "gui.customProcedures.addAnInputNumberText": "Yapay huk yaykuqta",
    "gui.customProcedures.numberTextType": "yupaychay qillqanata",
    "gui.customProcedures.addAnInputBoolean": "Yapay huk Yaykuqta",
    "gui.customProcedures.booleanType": "buulianu",
    "gui.customProcedures.addALabel": "yapay huk itikitata",
    "gui.customProcedures.runWithoutScreenRefresh": "Llamkariy mana yapamanta qallarichispa",
    "gui.customProcedures.cancel": "Manaña llamkaychu",
    "gui.customProcedures.ok": "ARI",
    "gui.SpriteInfo.direction": "Maypi",
    "gui.directionPicker.rotationStyles.allAround": "Maymanpas Muyuq",
    "gui.directionPicker.rotationStyles.leftRight": "Ichuq - Alliq",
    "gui.directionPicker.rotationStyles.dontRotate": "Mana Muyuq",
    "gui.gui.addExtension": "Yapay qawanata",
    "gui.gui.codeTab": "kudiqu",
    "gui.gui.backdropsTab": "Hipayninkuna",
    "gui.gui.costumesTab": "Pachakuna",
    "gui.gui.soundsTab": "Uyarikusqan",
    "gui.extensionLibrary.comingSoon": "Hukninkama",
    "gui.extensionLibrary.requires": "Munariy",
    "gui.extensionLibrary.collaboration": "Yanapakuykuy",
    "gui.library.filterPlaceholder": "Maskay",
    "gui.library.allTag": "Llapan",
    "gui.loader.message1": "Champata Ruray",
    "gui.loader.message2": "Qallarichkan Sprites ...",
    "gui.loader.message3": "Uyarinan qallarichkan",
    "gui.loader.message4": "Qallarichkan qawana",
    "gui.loader.message5": "Mishita Qatiy ...",
    "gui.loader.message6": "Qayarichkanchik nanosta",
    "gui.loader.message7": "Gobos punkichkan ...",
    "gui.loader.message8": "emojis Waqichkan ...",
    "gui.loader.headline": "Llamkay Qallarichkan",
    "gui.loader.creating": "Llamkayta Ruray",
    "gui.accountMenu.profile": "Runa yachaynin",
    "gui.accountMenu.myStuff": "Imayniykuna",
    "gui.accountMenu.myClasses": "Yachayniykuna",
    "gui.accountMenu.myClass": "Yachayniy",
    "gui.accountMenu.accountSettings": "Llamkayniykiman Yaykunayki",
    "gui.accountMenu.signOut": "Lluksiy",
    "gui.authorInfo.byUser": "llamkay sutinrayku {username}",
    "gui.menuBar.seeProjectPage": "Qaway Rapi Ruwasqaykita",
    "gui.menuBar.language": "Language",
    "general.username": "Llamkaqpa sutin",
    "general.password": "Kuntrasiñayki",
    "general.signIn": "Sutichakuy",
    "login.needHelp": "Munankichu yanapanayta?",
    "form.validationRequired": "Kay kichanaykipaq munanki.",
    "gui.menuBar.tutorialsLibrary": "Yanapawansunchik",
    "gui.menuBar.restoreSprite": "iqiqom allichachkan",
    "gui.menuBar.restoreSound": "qapariqnin Allichachkan",
    "gui.menuBar.restoreCostume": "pacha alichachkan",
    "gui.menuBar.restore": "Allichay",
    "gui.menuBar.saveNow": "waqaychay kunan",
    "gui.menuBar.saveAsCopy": "Waqaychay huk kupiyapi",
    "gui.menuBar.remix": "Kambiyay",
    "gui.menuBar.new": "Musuq",
    "gui.menuBar.file": "Qillqasqa",
    "gui.menuBar.downloadToComputer": "Kumputaduraykiman waqaychay",
    "gui.menuBar.edit": "Allichay",
    "gui.menuBar.turboModeOff": "wañuchiy turbu muduta",
    "gui.menuBar.turboModeOn": "Turbupi Qallariy Hina",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Hukllapakuy Scratch",
    "gui.menuBar.signIn": "Sutichakuy",
    "gui.gui.projectTitlePlaceholder": "Llamkaynikipa sutin",
    "gui.menuBar.saveNowLink": "waqaychay kunan",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Rakisqa",
    "gui.menuBar.share": "Rakiy",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "yanapay",
    "gui.modal.back": "hipaman",
    "gui.monitor.listMonitor.empty": "(Mana imayuq)",
    "gui.monitor.listMonitor.listLength": "sunin {length}",
    "gui.monitor.contextMenu.default": "liyiy-kuy",
    "gui.monitor.contextMenu.large": "Hatun qaway",
    "gui.monitor.contextMenu.slider": "lluchkay",
    "gui.monitor.contextMenu.sliderRange": "tikray lluchkay Hatunyariqta",
    "gui.monitor.contextMenu.import": "impurtay",
    "gui.monitor.contextMenu.export": "ixpurtay",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Pukllay",
    "gui.playButton.stop": "Sayay",
    "gui.gui.variableScopeOptionAllSprites": "llapan sprites-kunapaq",
    "gui.gui.variableScopeOptionSpriteOnly": "sprite kunallapaq",
    "gui.gui.cloudVariableOption": "puyu redpi Variabli (sirvidurllapi waqaychasqa)",
    "gui.gui.variablePromptAllSpritesMessage": "Kay variabliqa llapam sprites-paqmi.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Manaña llamkaychu",
    "gui.prompt.ok": "ARI",
    "gui.playbackStep.stopMsg": "Sayay",
    "gui.playbackStep.playMsg": "Pukllay",
    "gui.playbackStep.loadingMsg": "Llamkachkan...",
    "gui.playbackStep.saveMsg": "Waqaychay",
    "gui.playbackStep.reRecordMsg": "yapamanta qrabay",
    "gui.recordModal.title": "Luqyariqta Grabay",
    "gui.recordingStep.beginRecord": "Qallari qrabayta butun uraypi klikyaykuspa ",
    "gui.recordingStep.permission": "{arrow}munaniku pirmisuykita mikruphuno usanaykupaq. ",
    "gui.recordingStep.stop": "Qrabayta sayay",
    "gui.recordingStep.record": "Qrabay",
    "gui.sliderModal.min": "Pisi balurlla",
    "gui.sliderModal.max": "Ancha balur",
    "gui.sliderModal.title": "tikray lluchkay Hatunyariqta",
    "gui.sliderPrompt.cancel": "Manaña llamkanchu",
    "gui.sliderPrompt.ok": "ARI",
    "gui.soundEditor.sound": "qapariqnin",
    "gui.soundEditor.play": "Pukllay",
    "gui.soundEditor.stop": "Sayay",
    "gui.soundEditor.copy": "kupyay",
    "gui.soundEditor.paste": "Laqay",
    "gui.soundEditor.copyToNew": "Musuqman Kupyay",
    "gui.soundEditor.delete": "Pichay",
    "gui.soundEditor.save": "Waqaychay",
    "gui.soundEditor.undo": "ruraray",
    "gui.soundEditor.redo": "kutipay",
    "gui.soundEditor.faster": "Utqayllaman",
    "gui.soundEditor.slower": "Allillamanta",
    "gui.soundEditor.echo": "Ruwasqa",
    "gui.soundEditor.robot": "Rubut",
    "gui.soundEditor.louder": "Hatunkaray",
    "gui.soundEditor.softer": "Llampulla",
    "gui.soundEditor.reverse": "Qipaman puriy",
    "gui.soundEditor.fadeOut": "Chinkarichiy",
    "gui.soundEditor.fadeIn": "Hichay",
    "gui.soundEditor.mute": "Upallay",
    "gui.SpriteInfo.spritePlaceholder": "Suti",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Spriti",
    "gui.SpriteInfo.show": "qawanapaq",
    "gui.SpriteInfo.size": "Hatun",
    "gui.spriteSelectorItem.contextMenuDuplicate": "iskaychay",
    "gui.spriteSelectorItem.contextMenuExport": "ixpurtay",
    "gui.spriteSelectorItem.contextMenuDelete": "pichay",
    "gui.spriteSelector.addSpriteFromLibrary": "Akllay huk Spritiyta",
    "gui.spriteSelector.addSpriteFromPaint": "Llimpiy",
    "gui.spriteSelector.addSpriteFromSurprise": "Muspay",
    "gui.spriteSelector.addSpriteFromFile": "Sprite Qispinan",
    "gui.stageHeader.stageSizeLarge": "Tikray hatun Qawarinaman",
    "gui.stageHeader.stageSizeSmall": "Tikray uchuy Qawarinaman",
    "gui.stageHeader.stageSizeFull": "Yaykuy qawana Intiruman",
    "gui.stageHeader.stageSizeUnFull": "Lluqsiy qawana Intirumanta",
    "gui.stageHeader.fullscreenControl": "Kamachiy qawanata",
    "gui.spriteSelector.addBackdropFromLibrary": "Warkunata Akllay hipayninmanta ",
    "gui.stageSelector.addBackdropFromPaint": "Llimpiy",
    "gui.stageSelector.addBackdropFromSurprise": "Muspay",
    "gui.stageSelector.addBackdropFromFile": "Warkunata Huqariy hipayninmanta ",
    "gui.stageSelector.stage": "chimpa qaway",
    "gui.stageSelector.backdrops": "Hipayninkuna",
    "gui.telemetryOptIn.label": "niykuy hayka punitaq allichana Scratch-ta",
    "gui.telemetryOptIn.body1": "Scratch ikipunmi maskanku allin llamkayta scratchwan llapan pachapi. yanapanampaq llapa rurayninpi, icha Scratchmi apachin utqallaman willakuyta scratch ikipunam.",
    "gui.telemetryOptIn.body2": "willakuyta hapisqanchik kanmi simikunata, churay champakunata hinaspapas huk iwintukunta waqaychanapaqpas, churay hinaspa llamkay churaypas. manam pallanchikchu willakuy pirsunalnikita. ama hina kaspalla qaway{privacyPolicyLink} willakuykunata.",
    "gui.telemetryOptIn.privacyPolicyLink": "Chiqanchikkuna Kikillanchikpaq",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbu Mudu",
    "gui.webglModal.label": "maskasqaykipi manam kallparinchu WebGL nisgan",
    "gui.webglModal.description": "Kunputaduraykim manam allinchu {webGlLink}. kay musuqRuraymi ancha munaymi 3.0 Scratch llamkananpaqmi.",
    "gui.webglModal.webgllink": "manan allinchu WebGL",
    "gui.webglModal.back": "hipaman",
    "gui.webglModal.previewfaq": "Yachayta munaspaykiqa kayman ripuy {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "Ima riqsiq munay",
    "gui.costumeLibrary.chooseABackdrop": "Warkunata Akllay hipayninmanta ",
    "gui.costumeLibrary.chooseACostume": "Akllay huk Pachata",
    "gui.costumeTab.addBackdropFromLibrary": "Warkunata Akllay hipayninmanta ",
    "gui.costumeTab.addCostumeFromLibrary": "Akllay huk Pachata",
    "gui.costumeTab.addBlankCostume": "Llimpiy",
    "gui.costumeTab.addSurpriseCostume": "Achalaw",
    "gui.costumeTab.addFileBackdrop": "Warkunata Huqariy hipayninmanta ",
    "gui.costumeTab.addFileCostume": "Pacha Qispiy",
    "gui.extensionLibrary.chooseAnExtension": "Akllaykuy hatuyninta",
    "gui.extensionLibrary.extensionUrl": "churaykuy URL intirnitmanta.",
    "gui.monitors.importListColumnPrompt": "Ima munasqaykita churanki (1-{numberOfColumns} )?",
    "gui.recordingStep.alertMsg": "Qrabasion manan qallariyta atinchu.",
    "gui.soundLibrary.chooseASound": "Akllay Luqyariqta",
    "gui.soundTab.fileUploadSound": "Qispiriy Luqyariqta",
    "gui.soundTab.surpriseSound": "Muspay",
    "gui.soundTab.recordSound": "Qrabay",
    "gui.soundTab.addSoundFromLibrary": "Akllay Luqyariqta",
    "gui.spriteLibrary.chooseASprite": "Akllay huk Spritiyta",
    "gui.tipsLibrary.tutorials": "Akllay Yanapaykunata",
    "gui.alerts.createsuccess": "Musuq llamkay rurasqa.",
    "gui.alerts.createcopysuccess": "Llakayqa waqaychakun huk kupiyapi",
    "gui.alerts.createremixsuccess": "llamkay waqaychasqa takiqhina.",
    "gui.alerts.creating": "Musuq ruray ...",
    "gui.alerts.creatingCopy": "kupiyay llamkaynikita ...",
    "gui.alerts.creatingRemix": "Kambiyasqa llamkay...",
    "gui.alerts.creatingError": "llamkay manam ruwarinchu. ama hina kaspalla yapamanta qallariy!",
    "gui.alerts.savingError": "llamkay manam waqaychakurqachu",
    "gui.alerts.savesuccess": "llamkay qispichiy.",
    "gui.alerts.saving": "Waqaychay llamkay ...",
    "gui.alerts.cloudInfo": "Yuyariy kay puyu wariabliqa manam munanchu yupata,qillqata ni simbulutapas. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Anchay yachaykuy",
    "gui.alerts.importing": "impurtay...",
    "gui.defaultProject.meow": "Mawllay",
    "gui.defaultProject.variable": "hukniraqni",
    "gui.howtos.intro-move-sayhello-hat.name": "qallarimuchkan",
    "gui.howtos.intro-move.step_stepMove": "Yapay champa kuyuriqta",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Kawsarichiy huk Sutita ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Akllaykuy huk Kartata Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Klikyaykuptiki takiyta Qallarinqa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Akllaykuy huk Qillqay Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "tikray kulurta",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Akllaykuy huk Qillqay Sprite hinaspa Muyurichiy",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Akllaykuy huk Qillqay Sprite hinaspa Wiñarichiy",
    "gui.howtos.imagine": "Umachay huk  Pachata",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Qillqay rimay munasqaykita",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "klikta ruray qumir wifalapi qallarinaykipaq",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Akllay hipaynin munasqaykita",
    "gui.howtos.imagine.step_imagineChooseSprite": "Akllay munasqayki Spritta",
    "gui.howtos.imagine.step_imagineFlyAround": "Ñitiy ispasiyasqa tiklamanta huchunampaq",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "akllay huknin Spritta",
    "gui.howtos.imagine.step_imagineLeftRight": "Muyuq Ichuqman-Alliqman",
    "gui.howtos.imagine.step_imagineUpDown": "Kuyuchiy hanayman - urayman",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Tikray Pachakunata",
    "gui.howtos.imagine.step_imagineGlideToPoint": "apay huk puntuman",
    "gui.howtos.imagine.step_imagineGrowShrink": "Wiñariy hinaspa Qintichiy",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Huknin Hipayninta Akllay",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "kicharina hipayninkunata",
    "gui.howtos.imagine.step_imagineRecordASound": "Yapay huk Qapariqnin",
    "gui.howtos.imagine.step_imagineChooseSound": "Akllay qapariqnikita",
    "gui.howtos.make-music.name": "Takichiy",
    "gui.howtos.Make-Music.step_PickInstrument": "Akllaykuy huk  takita Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Klikyaykuptiki takiyta Qallarinqa",
    "gui.howtos.Make-Music.step_MakeSong": "Huk takita Ruray",
    "gui.howtos.make-music.step_MakeBeat": "Akllay huk Tamburta hinapa luqluqyachiy",
    "gui.howtos.make-music.step_MakeBeatBox": "akllay Sprit mikrufunuta & Surprise Beatbox nisqanmi",
    "gui.howtos.story.name": "Ruray Huk willakuyta",
    "gui.howtos.story.step_addbg": "Aapay Hipayninman",
    "gui.howtos.story.step_addsprite": "Yapay huk Runa-niraqta ",
    "gui.howtos.story.step_saysomething": "Imatapas Ni",
    "gui.howtos.story.step_addanothersprite": "Yapay huk Runa-kaqta",
    "gui.howtos.story.step_flip": "Tikray Maypi",
    "gui.howtos.story.step_conversation": "Tukay instumintuta tanburtapas",
    "gui.howtos.story.addanotherbg": "Yapay Hipaynin Warkunata",
    "gui.howtos.story.step_swithbg": "kicharina hipayninkunata",
    "gui.howtos.story.step_hidewizard": "Pakay huk Runa-niraqta ",
    "gui.howtos.story.step_showwizard": "Gawachiy huk Runa-niraqta ",
    "gui.howtos.make-a-chase-game.name": "ruray huk qatikachaq pukllayta ",
    "gui.howtos.Chase-Game.step_BG": "Aapay Hipayninman",
    "gui.howtos.chase-game.step_AddOcto": "yapay huk Sprite",
    "gui.howtos.make-music.step_LeftRight": "kuyuchiy alliqman ichuqmanpas tiklawan",
    "gui.howtos.Chase-Game.step_UpDown": "kuyuchiy anayman uraymanpas tiklawan",
    "gui.howtos.Chase-Game.step_AddStar": "yapay huk Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "muyunqa munasqaykiman",
    "gui.howtos.Chase-Game.step_WhenTouch": "Octupus spriti Nisqampi, llataykuptiki purichiy qaparinata",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Ruray tikrasqa yupachachakunata",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Octupus spriti Nisqampi, llatay puntuta yapanampaq",
    "gui.howtos.animate-char.name": "Runa Niraqta Kawsarichiy",
    "gui.howtos.animate-char.step_addbg": "Aapay Hipayninman",
    "gui.howtos.animate-char.step_addsprite": "yapay huk Sprite",
    "gui.howtos.animate-char.step_saysomething": "Imatapas Ni",
    "gui.howtos.animate-char.step_addsound": "yapay qapariqninta",
    "gui.howtos.animate-char.step_animatetalking": "Kawsachina Rimaspa",
    "gui.howtos.animate-char.step_arrowkeys": "muyuchiy wachi tiklawan",
    "gui.howtos.animate-char.step_jump": "Paway",
    "gui.howtos.animate-char.step_changecolor": "tikray Llipiyta",
    "gui.howtos.make-a-game.name": "Huk Cliker pucllayta ruray ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Akllay huk Spriteta",
    "gui.howtos.make-a-game.step_GamePlaySound": "Klikyaykuptiki takiyta Qallarinqa",
    "gui.howtos.make-a-game.step_GameAddScore": "Ruray tikrasqa yupachachakunata",
    "gui.howtos.make-a-game.step_GameChangeScore": "Yapamanta Yupaychasqaykita Ruray",
    "gui.howtos.make-a-game.step_Random": "ri huk law akllarisqaman",
    "gui.howtos.make-music.step_GameChangeColor": "tikray Llipiyta",
    "gui.howtos.make-music.step_ResetScore": "Yapamanta yupaychasqaykita ruray",
    "gui.howtos.make-it-fly.name": "Pawarqachiy",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Akllaykuy hanay pacha hipayninpaq",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Runata Akllaykuy",
    "gui.howtos.fly.step_stepflySaySomething": "Imatapas Ni",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Kuyuchiy wachi tiklakunawan",
    "gui.howtos.fly.step_stepflyChooseObject": "Akllay Imatapas Uqarinaykipaq",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Imkunatapas Muyuchinki",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "runata akllay",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Hayka ruwasqaykita churay",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Hatalliy Puntuykita",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Yapay Paysahita",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Muyuchiy Paysahita",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Qatiq Pachata",
    "gui.howtos.pong": "Punq Pukllay",
    "gui.howtos.pong.step_pongAddBackdrop": "Aapay Hipayninman",
    "gui.howtos.pong.step_pongAddBallSprite": "Yapay Sprit Ballta",
    "gui.howtos.pong.step_pongBounceAround": "Muyuriqnimpi Butichiy",
    "gui.howtos.pong.step_pongAddPaddle": "Yapay palitata",
    "gui.howtos.pong.step_pongMoveThePaddle": "Muyuq palitata",
    "gui.howtos.pong.step_pongSelectBallSprite": "Akllaykuy Ruyru Spritmanta",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Yapay kudiquta bulata ributachinaykipaq palitapi hawa palitapi",
    "gui.howtos.pong.step_pongAddAScore": "Hayka ruwasqaykita churay",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Akllay 'Yupaychasqata' Minumanta",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Churay 'Yupay Tikray' Champata",
    "gui.howtos.pong.step_pongResetScore": "Yapamanta yupaychasqaykita ruray",
    "gui.howtos.pong.step_pongAddLineSprite": "Yapay Siqi Spriyta",
    "gui.howtos.pong.step_pongGameOver": "Pukllay Tukusqa",
    "gui.howtos.code-cartoon": "Kudiqu Kartun nisqata",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Rimay imatapas klikyaykuptiki qumir wifalapi",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "kawsarichiy runaqa klikyaykuptiki chaypi",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Akllay huk rikchaq runakuna",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usay minus siqnuta uchuychanaykipaq",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Ruray runanchikta hatunyanampaq uchuyanampaq",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Akllay huk rikchaq runakuna",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Paway hanayman urayman",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klikyayakuy huk runapi tikranampaq qawananta",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "apay muyuriqninman",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Tikray Pachakunata",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "akllay achka runanirakunata yapanaykipaq karikaturaykiman",
    "gui.howtos.cartoon-network": "ruray pukllay kuyuriqkunata",
    "gui.howtos.cartoon-network.step_CNcharacter": "Akllaykuy Runa-niraqta Qawachinaykipaq",
    "gui.howtos.cartoon-network.step_CNsay": "Imatapas Ni",
    "gui.howtos.cartoon-network.step_CNglide": "apay muyuriqninman",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Akllaykuy imatapas Qatikachanampaq",
    "gui.howtos.cartoon-network.step_CNcollect": "Imakunatapas Pallanampaq",
    "gui.howtos.cartoon-network.step_CNvariable": "Ruwana huknin tikranapaq ",
    "gui.howtos.cartoon-network.step_CNscore": "Hatalliy Puntuykita",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Pasay Nivilta: Tikray Hipayninta",
    "gui.howtos.videosens.name": "Tarisqa Qawana",
    "gui.howtos.videosens.step_addextension": "Yapay qawanata",
    "gui.howtos.videosens.step_pet": "Kuyay Mishita",
    "gui.howtos.videosens.step_animate": "Kawsarichisqa",
    "gui.howtos.videosens.step_pop": "Tuqyay Glubuta",
    "gui.howtos.say-it-out-loud": "Ruray kawsariqkunata rimanampaq",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Yapay qillqay champa rimayman",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Imatapas Ni",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Huk Rimayllata Churay",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Kuyurikuy",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Aapay Hipayninman",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Yapay huk Runa-kaqta",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Takirikuy",
    "gui.howtos.say-it-out-loud.step_TXTColor": "tikray kulurta",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Muyuriy",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Wiñariy hinaspa Qintichiy",
    "gui.howtos.talking": "Willakuykuna rimaq",
    "gui.howtos.talking.step_talesAddExtension": "Kikyaykuy  yapanaykipaq champa qillqanata rimaypi",
    "gui.howtos.talking.step_talesChooseSprite": "Akllay huk Spritiyta",
    "gui.howtos.talking.step_talesSaySomething": "Ruray huk runaniraqta rimanampaq",
    "gui.howtos.talking.step_talesChooseBackdrop": "Warkunata Akllay hipayninmanta ",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klikyaykuy runapi pasay qatiq hipaynin ",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "akllay huknin Spritta",
    "gui.howtos.talking.step_talesMoveAround": "Kuyurikuy",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Huknin Hipayninta Akllay",
    "gui.howtos.talking.step_talesAnimateTalking": "Kawsachina Rimaspa",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Huknin Hipayninta Akllay",
    "gui.howtos.talking.step_talesChooseSound": "Akllay huk takita tusunapaq",
    "gui.howtos.talking.step_talesDanceMoves": "Tusuypa Kuyuyninkuna",
    "gui.howtos.talking.step_talesAskAnswer": "Uyway champakuna Tapurispa kutichiy musyay katiquriyata",
    "gui.howtos.add-sprite.name": "yapay huk Sprite",
    "gui.howtos.add-sprite.step_addSprite": "yapay huk Sprite",
    "gui.howtos.add-a-backdrop.name": "Aapay Hipayninman",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Aapay Hipayninman",
    "gui.howtos.change-size.name": "tikray Hatuninta",
    "gui.howtos.change-size.step_changeSize": "tikray Hatuninta",
    "gui.howtos.glide-around.name": "apay muyuriqninman",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "apay muyuriqninman",
    "gui.howtos.change-size.step_glideAroundPoint": "apay huk puntuman",
    "gui.howtos.record-a-sound.name": "Huk Luqyariqta Grabay",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "klikyaykuy 'Qaparina' Pistañapi",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikyay 'Qrabanaykipaq'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Ñitiykuy Butunpi Qrabanaykipaq ",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Akllay qapariqnikita",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Tukachiy Qapariqninta",
    "gui.howtos.spin-video.name": "Muyurichirquy",
    "gui.howtos.change-size.step_spinTurn": "Muyun",
    "gui.howtos.change-size.step_spinPointInDirection": "Maymanmi Purinqa",
    "gui.howtos.hide-and-show.name": "Pakay hinaspa Qawachi ",
    "gui.howtos.change-size.step_hideAndShow": "Pakay hinaspa Qawachi ",
    "gui.howtos.switch-costume.name": "Kawsarichiy huk Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Kawsarichiy huk Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "llamkay tiklapa diricciunninwan",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "muyuq Ichuqman - Alliqman",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Hanay Urayman Muyuq",
    "gui.howtos.add-effects.name": "yapay iphiktukunata",
    "gui.howtos.videosens.step_addEffects": "yapay iphiktukunata",
    "gui.extension.music.name": "Taki",
    "gui.extension.music.description": "tukay instumintuta tanburtapas.",
    "gui.extension.pen.name": "qillqay kaspi",
    "gui.extension.pen.description": "Spritwam llimpiy.",
    "gui.extension.videosensing.name": "Tarisqa Qawana",
    "gui.extension.videosensing.description": "Kamarawan kuyuyta sintiy.",
    "gui.extension.text2speech.name": "Qillqa Rimay ",
    "gui.extension.text2speech.description": "Ruway Llamkasqaykikuna rimarinampaq",
    "gui.extension.translate.name": "Tikray",
    "gui.extension.translate.description": "Tikray Qillqaykunata Llapam Simiman",
    "gui.extension.makeymakey.description": "Munasqaykita rurachun llawipi",
    "gui.extension.microbit.description": "Tupachiy llamkaykikunata llapam hatun aylluman.",
    "gui.extension.microbit.connectingMessage": "Kuskachasqa",
    "gui.extension.ev3.description": "ruray rubut puririnanta himatas.",
    "gui.extension.ev3.connectingMessage": "tupachkan qawariy EV3 nikipi pinnin 1234 kunfiqurasqa tarikuchun.",
    "gui.extension.boost.description": "Kawsariyninta rubutkunaman churaykuy.",
    "gui.extension.boost.connectingMessage": "Kuskachasqa",
    "gui.extension.wedo2.description": "ruray mutur musyaqkunawan.",
    "gui.extension.wedo2.connectingMessage": "Kuskachasqa",
    "gui.extension.gdxfor.description": "musyay, tanqay, chutay, kuyuy hinaspa muyuy",
    "gui.extension.gdxfor.connectingMessage": "Kuskachasqa",
    "gui.libraryTags.all": "Llapan",
    "gui.libraryTags.animals": "Uywakunata",
    "gui.libraryTags.dance": "Tusuykuna",
    "gui.libraryTags.effects": "Iphictukuna",
    "gui.libraryTags.fantasy": "Fantasiyakuna",
    "gui.libraryTags.fashion": "Pacha",
    "gui.libraryTags.food": "mikuna",
    "gui.libraryTags.indoors": "Hukupi",
    "gui.libraryTags.loops": "Kutimanta",
    "gui.libraryTags.music": "Taki",
    "gui.libraryTags.notes": "Qillqaykuna",
    "gui.libraryTags.outdoors": "Wayra kachasqa",
    "gui.libraryTags.patterns": "Patrunkuna",
    "gui.libraryTags.people": "Runa",
    "gui.libraryTags.percussion": "Pirkusionkuna",
    "gui.libraryTags.space": "Chimpa",
    "gui.libraryTags.sports": "Pukllaykuna",
    "gui.libraryTags.underwater": "Yaku-ukunpi puriq",
    "gui.libraryTags.voice": "Rimaq",
    "gui.libraryTags.wacky": "Upa",
    "gui.libraryTags.animation": "Kawsachina",
    "gui.libraryTags.art": "Rakiri",
    "gui.libraryTags.games": "Pukllaykuna",
    "gui.libraryTags.stories": "Willakuy",
    "gui.libraryTags.letters": "Qillqakuna",
    "gui.opcodeLabels.direction": "maypi",
    "gui.opcodeLabels.xposition": "x sayay",
    "gui.opcodeLabels.yposition": "y sayay",
    "gui.opcodeLabels.size": "hatunin",
    "gui.opcodeLabels.costumename": "pachapa sutin",
    "gui.opcodeLabels.costumenumber": "pachapa yupaynin",
    "gui.opcodeLabels.backdropname": "hipaynin sutin",
    "gui.opcodeLabels.backdropnumber": "yupa hipaynin ",
    "gui.opcodeLabels.volume": "ancha uyarina",
    "gui.opcodeLabels.tempo": "pacha",
    "gui.opcodeLabels.answer": "kutichiy rimayta",
    "gui.opcodeLabels.loudness": "qapariknin",
    "gui.opcodeLabels.username": "sutiyki",
    "gui.opcodeLabels.year": "wata",
    "gui.opcodeLabels.month": "killa",
    "gui.opcodeLabels.date": "pacha",
    "gui.opcodeLabels.dayofweek": "punchawkuna",
    "gui.opcodeLabels.hour": "pacha",
    "gui.opcodeLabels.minute": "minutu",
    "gui.opcodeLabels.second": "wawa pacha",
    "gui.opcodeLabels.timer": "yupachaq",
    "gui.projectLoader.loadError": "Kay qillqasqa llamkayqa manan qipiyta atinchu.",
    "gui.sharedMessages.backdrop": "hipaynin{index}",
    "gui.sharedMessages.costume": "pacha {index}",
    "gui.sharedMessages.sprite": "Sprit {index}",
    "gui.sharedMessages.pop": "pup",
    "gui.sharedMessages.replaceProjectWarning": "Musuqmanta ruray Llamkasqaykita?",
    "gui.sharedMessages.loadFromComputerTitle": "Kumputaduraykimanta Llamkariy",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch llamkay",
    "boost.color.any": "mayqin kulurpas",
    "boost.color.black": "yana",
    "boost.color.blue": "anqas",
    "boost.color.green": "qumir",
    "boost.color.red": "puka",
    "boost.color.white": "yuraq",
    "boost.color.yellow": "qellu",
    "boost.getMotorPosition": "kallpanchaq churasqa [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "Kuchuq kinraychasqa [TILT_DIRECTION]",
    "boost.motorDirection.backward": "chayna puniy",
    "boost.motorDirection.forward": "kayna puniy",
    "boost.motorDirection.reverse": "qipaman puriy",
    "boost.motorOff": "mutur wañuchisqa [MOTOR_ID]",
    "boost.motorOn": "Kallpanchaq qallarichisqa [MOTOR_ID]",
    "boost.motorOnFor": "mutur muyuq [MOTOR_ID] icha [DURATION] siqundupi",
    "boost.motorOnForRotation": "mutur muyuq [MOTOR_ID] icha [ROTATION] muyuriqnin",
    "boost.seeingColor": "qawaspa [COLOR] champa?",
    "boost.setLightHue": "akchiqpa llimpinta churay [HUE]",
    "boost.setMotorDirection": "muturta churaykuy [MOTOR_ID] riqman [MOTOR_DIRECTION]",
    "boost.setMotorPower": "utqayllaman churay [MOTOR_ID] muturpa [POWER]%",
    "boost.tiltDirection.any": "mayqimpas",
    "boost.tiltDirection.down": "urayman",
    "boost.tiltDirection.left": "ichuq",
    "boost.tiltDirection.right": "alliq",
    "boost.tiltDirection.up": "hawampi",
    "boost.whenColor": " imayna [COLOR] champa qawakuptin",
    "boost.whenTilted": "kinraykachisqa kaptin [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tukachi [NOTE] kaywan [TIME] wawa pachawan",
    "ev3.buttonPressed": "butun [PORT] nitisqa?",
    "ev3.getBrightness": "kanchiq",
    "ev3.getDistance": "karuchan",
    "ev3.getMotorPosition": "Kallpanchachiq [PORT] churay",
    "ev3.motorSetPower": "Kallpanchaq [PORT] churay kallpachaykuy [POWER] %",
    "ev3.motorTurnClockwise": "Kallpanchaq [PORT] muyurichi waklawman [TIME] wawa pachapi",
    "ev3.motorTurnCounterClockwise": "Kallpanchaq [PORT] muyurichi kaylawman [TIME] wawa pachapi",
    "ev3.whenBrightnessLessThan": "akchiriq kaptin < [DISTANCE]",
    "ev3.whenButtonPressed": "butun [PORT] ñitisqa kaptin",
    "ev3.whenDistanceLessThan": "karu kaptin < [DISTANCE]",
    "gdxfor.getAcceleration": "utqallaman [DIRECTION]",
    "gdxfor.getForce": "kallpa",
    "gdxfor.getSpin": "utqayman muyuq [DIRECTION]",
    "gdxfor.getTilt": "kuchusta chinruri [TILT]",
    "gdxfor.isFreeFalling": "imam wichin?",
    "gdxfor.isTilted": "chinrusqachu [TILT]?",
    "gdxfor.pulled": "wikapasqa",
    "gdxfor.pushed": "tamqarisqa",
    "gdxfor.shaken": "tapsiy",
    "gdxfor.startedFalling": "wichiyta qallarichkan",
    "gdxfor.tiltDirectionMenu.any": "mayqimpas",
    "gdxfor.tiltDirectionMenu.back": "hipa",
    "gdxfor.tiltDirectionMenu.front": "chimpa",
    "gdxfor.tiltDirectionMenu.left": "ichuq",
    "gdxfor.tiltDirectionMenu.right": "alliq",
    "gdxfor.turnedFaceDown": "urayman tikrasqa",
    "gdxfor.turnedFaceUp": "anayman tikrasqa",
    "gdxfor.whenForcePushedOrPulled": "kallpachaq musiaq kaptin [PUSH_PULL]",
    "gdxfor.whenGesture": "imay [GESTURE]",
    "gdxfor.whenTilted": "chinrusqa kaptin [TILT]",
    "makeymakey.downArrow": "urayman qillqana",
    "makeymakey.downArrowShort": "urayman",
    "makeymakey.leftArrow": "lluqiman qillqana",
    "makeymakey.leftArrowShort": "ichuq",
    "makeymakey.rightArrow": "alliqman qillqana",
    "makeymakey.rightArrowShort": "alliq",
    "makeymakey.spaceKey": "chimpa",
    "makeymakey.upArrow": "hanayman qillqana",
    "makeymakey.upArrowShort": "hawampi",
    "makeymakey.whenKeyPressed": "imayna [KEY] tikla ñitisqa",
    "makeymakey.whenKeysPressedInOrder": "Hayka [SEQUENCE] nitisqa hukllamanta",
    "microbit.buttonsMenu.any": "mayqimpas",
    "microbit.clearDisplay": "picahay qawanata",
    "microbit.defaultTextToDisplay": "Rimaykullayki!",
    "microbit.displaySymbol": "qawana [MATRIX]",
    "microbit.displayText": "qillqata qawarina [TEXT]",
    "microbit.gesturesMenu.jumped": "pawarqun",
    "microbit.gesturesMenu.moved": "musuqmi",
    "microbit.gesturesMenu.shaken": "tapsiy",
    "microbit.isButtonPressed": "[BTN] butun ñitisqa?",
    "microbit.isTilted": "chinrusqa [DIRECTION]?",
    "microbit.pinStateMenu.off": "wañuy",
    "microbit.pinStateMenu.on": "rikchari",
    "microbit.tiltAngle": "kuchusta chinru [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "mayqimpas",
    "microbit.tiltDirectionMenu.back": "kutiy",
    "microbit.tiltDirectionMenu.front": "chimpa",
    "microbit.tiltDirectionMenu.left": "ichuq",
    "microbit.tiltDirectionMenu.right": "alliq",
    "microbit.whenButtonPressed": "imayna [BTN] butun ñitisqa",
    "microbit.whenGesture": "imay [GESTURE]",
    "microbit.whenPinConnected": "imayna tipi [PIN] tupachisqa",
    "microbit.whenTilted": "chinrusqa kaptin [DIRECTION]",
    "music.categoryName": "Taki",
    "music.changeTempo": "tikray pachata [TEMPO]",
    "music.drumBass": "(2) tinya",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Hit-Hat wichkasqa",
    "music.drumConga": "(14) Konqa",
    "music.drumCowbell": "(11) Kowbell",
    "music.drumCrashCymbal": "(4) Platillo Tupachisqa ",
    "music.drumCuica": "(18) Kuika",
    "music.drumGuiro": "(16) Quiru",
    "music.drumHandClap": "(8) Maqui Taqllay",
    "music.drumOpenHiHat": "(5) Hit-Hat Kichasqa",
    "music.drumSideStick": "(3) tamburpa waqtan takasqa",
    "music.drumSnare": "(1) Tambur",
    "music.drumTambourine": "(7) Sunaha",
    "music.drumTriangle": "(12) Chinisku",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10)Kullu tuqyaq",
    "music.getTempo": "pacha",
    "music.instrumentBass": "(6) Bahu",
    "music.instrumentBassoon": "(14) Bassuun",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Takiri",
    "music.instrumentClarinet": "(10) Klariniti",
    "music.instrumentElectricGuitar": "(5) Qitarra iliktriku",
    "music.instrumentElectricPiano": "(2) Piyanu iliktriku",
    "music.instrumentFlute": "(12)Pinkuyllu",
    "music.instrumentGuitar": "(4)Quitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17)kahita Takiq",
    "music.instrumentOrgan": "(3) Urqanu",
    "music.instrumentPiano": "(1)piyanu",
    "music.instrumentPizzicato": "(7) Pisikato",
    "music.instrumentSaxophone": "(11) Sakso",
    "music.instrumentSteelDrum": "(18) tinya latamanta",
    "music.instrumentSynthLead": "(20) Synth Lead nisqan",
    "music.instrumentSynthPad": "(21) Synth Pad nisqan",
    "music.instrumentTrombone": "(9) Trumbun",
    "music.instrumentVibraphone": "(16)wibraphuni",
    "music.instrumentWoodenFlute": "(13) Qina",
    "music.midiPlayDrumForBeats": "tukay tambur [DRUM] chaypaq [BEATS] luqluqyaqkuna",
    "music.midiSetInstrument": "tiquy inkilltupa [INSTRUMENT] ",
    "music.playDrumForBeats": "tukay tambur [DRUM] chaypaq [BEATS] luqluqyaqkuna",
    "music.playNoteForBeats": "pukllayta tukay [NOTE] chayman [BEATS] luqluqyaqkuna",
    "music.restForBeats": " samachiy [BEATS] luqluqyaqkuna",
    "music.setInstrument": "tiquy inkilltupa [INSTRUMENT] ",
    "music.setTempo": "churay pachata [TEMPO]",
    "pen.categoryName": "qillqay kaspi",
    "pen.changeColorParam": "tikray qillqay kaspi [COLOR_PARAM] rayku [VALUE]",
    "pen.changeHue": "tikray qillqay kaspi kulur-rayku [HUE]",
    "pen.changeShade": "tikray qillqay llantunninta [SHADE]",
    "pen.changeSize": "tikray qillqay hatunninta [SIZE]",
    "pen.clear": "llapanta pichay",
    "pen.colorMenu.brightness": "kanchiq",
    "pen.colorMenu.color": "kulur",
    "pen.colorMenu.saturation": "Llimpi yuraqchay",
    "pen.colorMenu.transparency": "chuyarayaq",
    "pen.penDown": "qillqana uraypi",
    "pen.penUp": "qillqay hanaypi",
    "pen.setColor": "tikray qillqay kaspi Llimpiy-rayku [COLOR]",
    "pen.setColorParam": "churay qillqay kaspita [COLOR_PARAM] rayku [VALUE]",
    "pen.setHue": "churaykuy llimpinman qillqaq kaspita [HUE]",
    "pen.setShade": "churaykuy qillqapa llantuyninta [SHADE]",
    "pen.setSize": "churay qillqay kaspipa hatuyninta [SIZE]",
    "pen.stamp": "sello nisqan",
    "speech.defaultWhenIHearValue": "Hakuchik",
    "speech.extensionName": "Rimaymanta Qillqay",
    "speech.listenAndWait": "uyari hinaspa suyay",
    "speech.speechReporter": "rimay",
    "speech.whenIHear": "uyaripti [PHRASE]",
    "text2speech.alto": "Sayachiy",
    "text2speech.categoryName": "Qillqa Rimay ",
    "text2speech.defaultTextToSpeak": "imaynalla ",
    "text2speech.giant": "hatunkaray",
    "text2speech.kitten": "misicha",
    "text2speech.setLanguageBlock": "churay simiman [LANGUAGE] ",
    "text2speech.setVoiceBlock": "churay Rimaqman [VOICE]",
    "text2speech.speakAndWaitBlock": "rimay [WORDS]",
    "text2speech.squeak": "qapariy",
    "text2speech.tenor": "tinur",
    "translate.categoryName": "Tikray",
    "translate.defaultTextToTranslate": "imaynalla ",
    "translate.translateBlock": "tikray [WORDS] chaymanta [LANGUAGE]",
    "translate.viewerLanguage": "Simi",
    "videoSensing.categoryName": "Tarisqa Qawana",
    "videoSensing.direction": "maypi",
    "videoSensing.motion": "kuyuchiy",
    "videoSensing.off": "wañuy",
    "videoSensing.on": "rikchari",
    "videoSensing.onFlipped": "tikray",
    "videoSensing.setVideoTransparency": "churay vidio chhuyaqniman [TRANSPARENCY]",
    "videoSensing.sprite": "Sprite",
    "videoSensing.stage": "Chimpa qaway",
    "videoSensing.videoOn": "widiu [ATTRIBUTE] in [SUBJECT]",
    "videoSensing.videoToggle": "muyuchiy widiuta [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "hayka widiu muyuptin > [REFERENCE]",
    "wedo2.getDistance": "karuchan",
    "wedo2.getTiltAngle": "Kuchuq kinraychasqa [TILT_DIRECTION]",
    "wedo2.isTilted": "kinray [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "chayna puniy",
    "wedo2.motorDirection.forward": "kayna puniy",
    "wedo2.motorDirection.reverse": "qipaman puriy",
    "wedo2.motorId.a": "kallpachaq A",
    "wedo2.motorId.all": "llapan kallpachaqkuna",
    "wedo2.motorId.b": "kallpachaq B",
    "wedo2.motorId.default": "kallpanchachiq",
    "wedo2.motorOff": "muyuq [MOTOR_ID] wañuchisqa",
    "wedo2.motorOn": "qallarichiy [MOTOR_ID]",
    "wedo2.motorOnFor": "qallariy [MOTOR_ID] icha [DURATION] siqundupi",
    "wedo2.playNoteFor": "qillqay luqyay [NOTE] icha [DURATION] siqundupi",
    "wedo2.setLightHue": "akchiqpa llimpinta churay [HUE]",
    "wedo2.setMotorDirection": "rinayta churaykuy [MOTOR_ID] inpi [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "churaykuy [MOTOR_ID] kallapachiqninta [POWER]",
    "wedo2.tiltDirection.any": "mayqimpas",
    "wedo2.tiltDirection.down": "urayman",
    "wedo2.tiltDirection.left": "ichuq",
    "wedo2.tiltDirection.right": "alliq",
    "wedo2.tiltDirection.up": "hawampi",
    "wedo2.whenDistance": "karu kaptin [OP] [REFERENCE]",
    "wedo2.whenTilted": "kinraykachisqa kaptin [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "kulur",
    "paint.paintEditor.saturation": "Llimpi yuraqchay",
    "paint.paintEditor.brightness": "kanchiq",
    "paint.paintEditor.costume": "Pacha",
    "paint.paintEditor.group": "Huñusqa",
    "paint.paintEditor.ungroup": "Rakisqa",
    "paint.paintEditor.undo": "ruraray",
    "paint.paintEditor.redo": "kutipay",
    "paint.paintEditor.forward": "Ñawpaqman",
    "paint.paintEditor.backward": "Qipaman",
    "paint.paintEditor.front": "Chimpa",
    "paint.paintEditor.back": "Hipaman",
    "paint.paintEditor.more": "aswan",
    "paint.modeTools.brushSize": "Hatun",
    "paint.modeTools.eraserSize": "Hatun Pichana",
    "paint.modeTools.copy": "kupyay",
    "paint.modeTools.paste": "Laqay",
    "paint.modeTools.delete": "Pichay",
    "paint.modeTools.curved": "Muyo",
    "paint.modeTools.pointed": "Tupsuyaq",
    "paint.modeTools.thickness": "Rakuqnin",
    "paint.modeTools.flipHorizontal": "Kinrayman Tikrasqa",
    "paint.modeTools.flipVertical": "Sayaqman Tikrasqa",
    "paint.modeTools.filled": "Huntasqa",
    "paint.modeTools.outlined": "Sikwiy",
    "paint.paintEditor.bitmap": "Tikrayay MapaBitman",
    "paint.paintEditor.vector": "Tikray Vikturman",
    "paint.paintEditor.fill": "huntay",
    "paint.paintEditor.stroke": "Muyuriqnin",
    "paint.brushMode.brush": "Llimpinapaq",
    "paint.eraserMode.eraser": "Pichana",
    "paint.fillMode.fill": "Huntasqa",
    "paint.lineMode.line": "Sikwi",
    "paint.ovalMode.oval": "Muyu",
    "paint.rectMode.rect": "Tawa Kuchuyuq",
    "paint.reshapeMode.reshape": "Allichana",
    "paint.roundedRectMode.roundedRect": "Muyuq hina Tawa Kuchu",
    "paint.selectMode.select": "Akllasqa",
    "paint.textMode.text": "Qillqay",
    "paint.colorPicker.swap": "Hukniraqchay"
  },
  "sw": {
    "gui.alerts.lostPeripheralConnection": "Unganisho la Scratch lilipotea kwa {extensionName}.",
    "gui.alerts.tryAgain": "Jaribu Tena",
    "gui.alerts.download": "Pakua",
    "gui.connection.reconnect": "Jaribu Tena Kuunganisha",
    "gui.backpack.costumeLabel": "mtindo",
    "gui.backpack.soundLabel": "sauti",
    "gui.backpack.scriptLabel": "hati",
    "gui.backpack.spriteLabel": "kihusika",
    "gui.backpack.header": "Mkoba",
    "gui.backpack.errorBackpack": "Kosa limetokea kupakia mkoba",
    "gui.backpack.loadingBackpack": "Inapakia...",
    "gui.backpack.more": "Zaidi",
    "gui.backpack.emptyBackpack": "Hakuna kitu kwenye mkoba",
    "gui.unsupportedBrowser.label": "Kivinjari hakikubaliwi",
    "gui.unsupportedBrowser.errorLabel": "Tatizo limetokea",
    "gui.unsupportedBrowser.notRecommended": "Tunasikitika, kivinjari unachotumia hakikubaliwi na Scratch. Tunapendekeza usasishe kivinjari unachotumia kiwe toleo mpya kinachokubaliwa kama Google Chrome, Mozilla Firefox, Microsoft Edge ama Apple Safari.",
    "gui.unsupportedBrowser.description": "Tunasikitika, kivinjari hakikubaliwi na Scratch. Tunapendekeza usasishe kivinjari unachotumia kiwe toleo mpya kinachokubaliwa kama Google Chrome, Mozilla Firefox, Microsoft Edge ama Apple Safari.",
    "gui.unsupportedBrowser.back": "Rudi",
    "gui.unsupportedBrowser.previewfaq": "Kupata maelezo zaidi fuata {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Maswali Yanayoulizwa Sana",
    "gui.cards.all-tutorials": "Mafunzo",
    "gui.cards.shrink": "Punguza Ukubwa",
    "gui.cards.expand": "Panua",
    "gui.cards.close": "Funga",
    "gui.cards.more-things-to-try": "Vitu zaidi vya kujaribu!",
    "gui.cards.see-more": "Tazama zaidi",
    "gui.comingSoon.message1": "Tunaishughulikia {emoji}",
    "gui.comingSoon.message2": "Inakuja hivi karibuni...",
    "gui.comingSoon.message3": "Tunaishughulikia {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Hakuna vifaa vilivyopatikana",
    "gui.connection.auto-scanning.prescan": "Kuwa na kifaa chako karibu, kisha anza kutafuta.",
    "gui.connection.auto-scanning.pressbutton": "Bonyeza kitufe kwenye kifaa chako.",
    "gui.connection.auto-scanning.start-search": "Anza Kutafuta",
    "gui.connection.connecting-searchbutton": "Inatafuta...",
    "gui.connection.auto-scanning.try-again": "Jaribu tena",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Imeunganishwa",
    "gui.connection.disconnect": "Tenganisha",
    "gui.connection.go-to-editor": "Enda kwa Kihariri",
    "gui.connection.connecting-cancelbutton": "Inaunganisha...",
    "gui.connection.error.errorMessage": "Inaonekana kama kuna kitu kimeenda vibaya.",
    "gui.connection.error.tryagainbutton": "Jaribu tena",
    "gui.connection.error.helpbutton": "Usaidizi",
    "gui.connection.peripheral-name-label": "Jina la kifaa",
    "gui.connection.connect": "Unganisha",
    "gui.connection.scanning.lookingforperipherals": "Inatafuta vifaa",
    "gui.connection.scanning.noPeripheralsFound": "Hakuna vifaa vilivyopatikana",
    "gui.connection.scanning.instructions": "Chagua kifaa chako kwenye orodha hapo juu.",
    "gui.connection.search": "Pakia Mpya",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Hakikisha umesakinisha Scratch Link na inaendesha",
    "gui.connection.unavailable.enablebluetooth": "Angalia kuwa muunganisho wa Bluetooth umewezeshwa",
    "gui.connection.unavailable.tryagainbutton": "Jaribu tena",
    "gui.connection.unavailable.helpbutton": "Usaidizi",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Anza",
    "gui.controls.stop": "Komesha",
    "gui.crashMessage.label": "Kuna kitu kimeenda vibaya.",
    "gui.crashMessage.description": "Tunasikitika, Scratch haifanyi kazi na imefungwa. Shida hii imeripotiwa kwa Timu ya Scratch. Tafadhali pakia ukurasa wako kujaribu tena.",
    "gui.crashMessage.errorNumber": "Kosa lako lilihifadhiwa kutumia kitambulisho {errorId}",
    "gui.crashMessage.reload": "Pakia tena",
    "gui.customProcedures.myblockModalTitle": "Unda Bloku",
    "gui.customProcedures.addAnInputNumberText": "Ongeza uingizaji",
    "gui.customProcedures.numberTextType": "nambari ama maandishi",
    "gui.customProcedures.addAnInputBoolean": "Ongeza uingizaji",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Ongeza lebo",
    "gui.customProcedures.runWithoutScreenRefresh": "Endesha bila kupakia skrini",
    "gui.customProcedures.cancel": "Katisha",
    "gui.customProcedures.ok": "Sawa",
    "gui.SpriteInfo.direction": "Mwelekeo",
    "gui.directionPicker.rotationStyles.allAround": "Pande Zote",
    "gui.directionPicker.rotationStyles.leftRight": "Kushoto/Kulia",
    "gui.directionPicker.rotationStyles.dontRotate": "Isizunguke",
    "gui.gui.addExtension": "Ongeza Kiendelezi",
    "gui.gui.codeTab": "Msimbo",
    "gui.gui.backdropsTab": "Mandhari Za Nyuma",
    "gui.gui.costumesTab": "Mitindo",
    "gui.gui.soundsTab": "Sauti",
    "gui.extensionLibrary.comingSoon": "Inakuja Hivi Karibuni",
    "gui.extensionLibrary.requires": "Mahitaji",
    "gui.extensionLibrary.collaboration": "Kushirikiana na",
    "gui.library.filterPlaceholder": "Tafuta",
    "gui.library.allTag": "Kila kitu",
    "gui.loader.message1": "Inaunda bloki ...",
    "gui.loader.message2": "Inapakia vihusika ...",
    "gui.loader.message3": "Inapakia sauti...",
    "gui.loader.message4": "Inapakia viendelezi ...",
    "gui.loader.message5": "Inatafuta paka ...",
    "gui.loader.message6": "Inakimbiza ng'ombe ...",
    "gui.loader.message7": "Inafukuza kuku ...",
    "gui.loader.message8": "Inandaa emojis …",
    "gui.loader.headline": "Inapakia Mradi",
    "gui.loader.creating": "Inaunda Mradi",
    "gui.accountMenu.profile": "Wasifu",
    "gui.accountMenu.myStuff": "Vitu Vyangu",
    "gui.accountMenu.myClasses": "Madarasa Yangu",
    "gui.accountMenu.myClass": "Darasa Langu",
    "gui.accountMenu.accountSettings": "Mipangilio ya akaunti",
    "gui.accountMenu.signOut": "Toka",
    "gui.authorInfo.byUser": "ni mradi wa {username}",
    "gui.menuBar.seeProjectPage": "Tazama Ukurasa Wa Mradi",
    "gui.menuBar.language": "Language",
    "general.username": "Jina La Mtumiaji",
    "general.password": "Nenosiri",
    "general.signIn": "Ingia",
    "login.needHelp": "Unahitaji Usaidizi?",
    "form.validationRequired": "Sehemu hii inahitajika",
    "gui.menuBar.tutorialsLibrary": "Mafunzo",
    "gui.menuBar.restoreSprite": "Rejesha Kihusika",
    "gui.menuBar.restoreSound": "Rejesha Sauti",
    "gui.menuBar.restoreCostume": "Rejesha Mtindo",
    "gui.menuBar.restore": "Rejesha",
    "gui.menuBar.saveNow": "Hifadhi sasa",
    "gui.menuBar.saveAsCopy": "Hifadhi kama nakala",
    "gui.menuBar.remix": "Geuza",
    "gui.menuBar.new": "Mpya",
    "gui.menuBar.file": "Faili",
    "gui.menuBar.downloadToComputer": "Hifadhi kwa kompyuta yako",
    "gui.menuBar.edit": "Hariri",
    "gui.menuBar.turboModeOff": "Zima Uharaka",
    "gui.menuBar.turboModeOn": "Washa Uharaka",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Ungana na Scratch",
    "gui.menuBar.signIn": "Ingia",
    "gui.gui.projectTitlePlaceholder": "Kichwa cha mradi hapa",
    "gui.menuBar.saveNowLink": "Hifadhi sasa",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Imesambazwa",
    "gui.menuBar.share": "Sambaza",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Usaidizi",
    "gui.modal.back": "Rudi",
    "gui.monitor.listMonitor.empty": "(tupu)",
    "gui.monitor.listMonitor.listLength": "urefu {length}",
    "gui.monitor.contextMenu.default": "maonyesho ya kawaida",
    "gui.monitor.contextMenu.large": "maonyesho kubwa",
    "gui.monitor.contextMenu.slider": "kitelezi",
    "gui.monitor.contextMenu.sliderRange": "badilisha kiwango cha kitelezi",
    "gui.monitor.contextMenu.import": "ingiza",
    "gui.monitor.contextMenu.export": "hamisha",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Cheza",
    "gui.playButton.stop": "Komesha",
    "gui.gui.variableScopeOptionAllSprites": "Kwa vihusika vyote",
    "gui.gui.variableScopeOptionSpriteOnly": "Kwa kihusika hiki pekee",
    "gui.gui.cloudVariableOption": "Kibadilika cha mtandaoni (kinachohifadhiwa kwa seva)",
    "gui.gui.variablePromptAllSpritesMessage": "Kibadilika hiki kitapatikana kwa vihusika vyote.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Katisha",
    "gui.prompt.ok": "Sawa",
    "gui.playbackStep.stopMsg": "Komesha",
    "gui.playbackStep.playMsg": "Cheza",
    "gui.playbackStep.loadingMsg": "Inapakia...",
    "gui.playbackStep.saveMsg": "Hifadhi",
    "gui.playbackStep.reRecordMsg": "Rekodi tena",
    "gui.recordModal.title": "Rekodi Sauti",
    "gui.recordingStep.beginRecord": "Anza kurekodi kwa kubonyeza kitufe hapa chini",
    "gui.recordingStep.permission": "{arrow}Tunahitaji ruhusa yako kutumia maikrofoni yako",
    "gui.recordingStep.stop": "Komesha kurekodi",
    "gui.recordingStep.record": "Rekodi",
    "gui.sliderModal.min": "Thamani ya chini",
    "gui.sliderModal.max": "Thamani ya juu",
    "gui.sliderModal.title": "Badilisha kiwango cha kitelezi",
    "gui.sliderPrompt.cancel": "Katisha",
    "gui.sliderPrompt.ok": "Sawa",
    "gui.soundEditor.sound": "Sauti",
    "gui.soundEditor.play": "Cheza",
    "gui.soundEditor.stop": "Komesha",
    "gui.soundEditor.copy": "Nakala",
    "gui.soundEditor.paste": "Bandika",
    "gui.soundEditor.copyToNew": "Nakili Kama Mpya",
    "gui.soundEditor.delete": "Futa",
    "gui.soundEditor.save": "Hifadhi",
    "gui.soundEditor.undo": "Ondoa",
    "gui.soundEditor.redo": "Rudia",
    "gui.soundEditor.faster": "Haraka",
    "gui.soundEditor.slower": "Polepole",
    "gui.soundEditor.echo": "Mwangwi",
    "gui.soundEditor.robot": "Roboti",
    "gui.soundEditor.louder": "Ongeza Kiasi ya Sauti",
    "gui.soundEditor.softer": "Punguza Kiasi ya Sauti",
    "gui.soundEditor.reverse": "Upande Mwingine",
    "gui.soundEditor.fadeOut": "Fifia Sauti",
    "gui.soundEditor.fadeIn": "Fufua Sauti",
    "gui.soundEditor.mute": "Zima Sauti",
    "gui.SpriteInfo.spritePlaceholder": "Jina",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Kihusika",
    "gui.SpriteInfo.show": "Onyesha",
    "gui.SpriteInfo.size": "Ukubwa",
    "gui.spriteSelectorItem.contextMenuDuplicate": "nakili bloku",
    "gui.spriteSelectorItem.contextMenuExport": "hamisha",
    "gui.spriteSelectorItem.contextMenuDelete": "futa",
    "gui.spriteSelector.addSpriteFromLibrary": "Chagua Kihusika",
    "gui.spriteSelector.addSpriteFromPaint": "Chora",
    "gui.spriteSelector.addSpriteFromSurprise": "Kihusika Chochote",
    "gui.spriteSelector.addSpriteFromFile": "Pakia Kihusika",
    "gui.stageHeader.stageSizeLarge": "Badilisha kwa jukwaa kubwa",
    "gui.stageHeader.stageSizeSmall": "Badilisha kwa jukwaa ndogo",
    "gui.stageHeader.stageSizeFull": "Ingiza hali kamili ya skrini",
    "gui.stageHeader.stageSizeUnFull": "Toka hali kamili ya skrini",
    "gui.stageHeader.fullscreenControl": "Udhibiti Kamili Wa Skrini",
    "gui.spriteSelector.addBackdropFromLibrary": "Chagua Mandhari Ya Nyuma",
    "gui.stageSelector.addBackdropFromPaint": "Chora",
    "gui.stageSelector.addBackdropFromSurprise": "Jukwaa Lolote",
    "gui.stageSelector.addBackdropFromFile": "Pakia Mandhari Ya Nyuma",
    "gui.stageSelector.stage": "Jukwaa",
    "gui.stageSelector.backdrops": "Mandhari Za Nyuma",
    "gui.telemetryOptIn.label": "Ripoti takwimu za kuboresha Scratch",
    "gui.telemetryOptIn.body1": "Timu ya Scratch inataka kuelewa jinsi Scratch inayotumika duniani kote. Ili kusaidia msaada huu, unaweza kuruhusu Scratch kutuma habari ya utumiaji kwa Timu ya Scratch.",
    "gui.telemetryOptIn.body2": "Habari tunayokusanya ni pamoja na uteuzi wa lugha, utumiaji wa bloku, na matukio kadhaa kama kuhifadhi, kupakia, na kupakua mradi. Hatukusanyi habari yoyote ya kibinafsi. Tafadhali tazama  {privacyPolicyLink} yetu kwa habari zaidi.",
    "gui.telemetryOptIn.privacyPolicyLink": "Sera ya Faragha",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Harakisha",
    "gui.webglModal.label": "Kivinjari chako hakikubali WebGL",
    "gui.webglModal.description": "Inaonekana kama kivinjari chako au kompyuta {webGlLink}. Teknolojia hii inahitajika kuendesha Scratch 3.0.",
    "gui.webglModal.webgllink": "haikubali WebGL",
    "gui.webglModal.back": "Rudi",
    "gui.webglModal.previewfaq": "Kupata maelezo zaidi fuata {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Maswali Yanayoulizwa Sana",
    "gui.costumeLibrary.chooseABackdrop": "Chagua Mandhari Ya Nyuma",
    "gui.costumeLibrary.chooseACostume": "Chagua Mtindo",
    "gui.costumeTab.addBackdropFromLibrary": "Chagua Mandhari Ya Nyuma",
    "gui.costumeTab.addCostumeFromLibrary": "Chagua Mtindo",
    "gui.costumeTab.addBlankCostume": "Chora",
    "gui.costumeTab.addSurpriseCostume": "Mtindo Wowote",
    "gui.costumeTab.addFileBackdrop": "Pakia Mandhari Ya Nyuma",
    "gui.costumeTab.addFileCostume": "Pakia Mtindo",
    "gui.extensionLibrary.chooseAnExtension": "Chagua Kiendelezi",
    "gui.extensionLibrary.extensionUrl": "Ingiza kiungo cha kiendelezi",
    "gui.monitors.importListColumnPrompt": "Safu gani inapaswa kutumika (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Haikuweza kuanza kurekodi",
    "gui.soundLibrary.chooseASound": "Chagua Sauti",
    "gui.soundTab.fileUploadSound": "Pakia Sauti",
    "gui.soundTab.surpriseSound": "Sauti Yoyote",
    "gui.soundTab.recordSound": "Rekodi",
    "gui.soundTab.addSoundFromLibrary": "Chagua Sauti",
    "gui.spriteLibrary.chooseASprite": "Chagua Kihusika",
    "gui.tipsLibrary.tutorials": "Chagua Funzo",
    "gui.alerts.createsuccess": "Mradi mpya umeundwa.",
    "gui.alerts.createcopysuccess": "Mradi umehifadhiwa kama nakala.",
    "gui.alerts.createremixsuccess": "Mradi umehifadhiwa kama kigeuzi.",
    "gui.alerts.creating": "Inaunda mradi mpya...",
    "gui.alerts.creatingCopy": "Inanakili mradi…",
    "gui.alerts.creatingRemix": "Inatengeneza kigeuzi cha mradi...",
    "gui.alerts.creatingError": "Haikuweza kuunda mradi. Tafadhali jaribu tena!",
    "gui.alerts.savingError": "Mradi hauwezi kuhifadhiwa",
    "gui.alerts.savesuccess": "Mradi umehifadhiwa.",
    "gui.alerts.saving": "Mradi unahifadhiwa...",
    "gui.alerts.cloudInfo": "Tafadhali kumbuka, vibadilika vya mtandaoni vinakubali nambari tu, sio herufi au alama. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Pata maelezo zaidi.",
    "gui.alerts.importing": "Unaingizwa...",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "kibadilika changu",
    "gui.howtos.intro-move-sayhello-hat.name": "Kuanza",
    "gui.howtos.intro-move.step_stepMove": "Ongeza bloku ya kusonga",
    "gui.howtos.add-a-move-block.step_stepSay": "Ongeza bloku ya sema",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Bonyeza bendera kijani kuanza",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Unda Kibonzo Cha Jina",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Chagua Kihusika Cha Herufi",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Cheza Sauti Ikibonyezwa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Changua Kihusika Cha Herufi Kingine",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Badilisha rangi",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Chagua Kihusika Cha Herufi Kingine na Fanya Kizunguke",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Chagua Kihusika Cha Herufi Kingine na Fanya Kikue",
    "gui.howtos.imagine": "Buni Ulimwengu",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Chapa Unachotaka Kusema",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Bonyeza Bendera Kijani Kuanza",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Chagua Mandhari Ya Nyuma Yoyote",
    "gui.howtos.imagine.step_imagineChooseSprite": "Chagua Kihusika Chochote",
    "gui.howtos.imagine.step_imagineFlyAround": "Nyiririka Kwa Kubonyeza Kitufe Cha Nafasi",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Chagua Kihusika Kingine",
    "gui.howtos.imagine.step_imagineLeftRight": "Songa Kushoto-Kulia",
    "gui.howtos.imagine.step_imagineUpDown": "Songa Juu-Chini",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Badilisha Mitindo",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Nyiririka hadi Mahali Fulani",
    "gui.howtos.imagine.step_imagineGrowShrink": "Kubwa na Ndogo",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Chagua Mandhari Ya Nyuma Nyingine",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Badilisha Mandhari Za Nyuma",
    "gui.howtos.imagine.step_imagineRecordASound": "Ongeza Sauti",
    "gui.howtos.imagine.step_imagineChooseSound": "Chagua Sauti Yako",
    "gui.howtos.make-music.name": "Tengeneza Muziki",
    "gui.howtos.Make-Music.step_PickInstrument": "Chagua Kihusika Cha Ala Ya Muziki",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Cheza Sauti Ikibonyezwa",
    "gui.howtos.Make-Music.step_MakeSong": "Unda Wimbo",
    "gui.howtos.make-music.step_MakeBeat": "Chagua Ngoma na Unda Midundo",
    "gui.howtos.make-music.step_MakeBeatBox": "Chagua Kihusika Cha Maikrofoni na Unda Midundo",
    "gui.howtos.story.name": "Unda Hadithi",
    "gui.howtos.story.step_addbg": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.story.step_addsprite": "Ongeza Mhusika",
    "gui.howtos.story.step_saysomething": "Sema Kitu",
    "gui.howtos.story.step_addanothersprite": "Ongeza Mhusika Mwengine",
    "gui.howtos.story.step_flip": "Pindua Mwelekeo",
    "gui.howtos.story.step_conversation": "Kuwa na Mazungumzo",
    "gui.howtos.story.addanotherbg": "Ongeza Mandhari Ya Nyuma Nyingine",
    "gui.howtos.story.step_swithbg": "Badilisha Mandhari Za Nyuma",
    "gui.howtos.story.step_hidewizard": "Ficha Mhusika",
    "gui.howtos.story.step_showwizard": "Onyesha Mhusika",
    "gui.howtos.make-a-chase-game.name": "Unda Mchezo wa Kufukuzana",
    "gui.howtos.Chase-Game.step_BG": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.chase-game.step_AddOcto": "Ongeza Kihusiku",
    "gui.howtos.make-music.step_LeftRight": "Songa Kulia Na Kushoto Kutumia Vitufe Yya Vishale",
    "gui.howtos.Chase-Game.step_UpDown": "Songa Juu Na Chini Kutumia Vitufe Vya Vishale",
    "gui.howtos.Chase-Game.step_AddStar": "Chagua Kihusika Kingine",
    "gui.howtos.Chase-Game.step_MoveRandom": "Songa Mahali Popote",
    "gui.howtos.Chase-Game.step_WhenTouch": "Kwa Kihusika Cha Pweza, Cheza Sauti Kinaposhikwa",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Unda Kibadilika cha Alama",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Kwa Kihusika Cha Pweza, Ongeza Alama Kinaposhikwa",
    "gui.howtos.animate-char.name": "Unda Kibonzo Cha Mhusika",
    "gui.howtos.animate-char.step_addbg": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.animate-char.step_addsprite": "Ongeza Kihusika",
    "gui.howtos.animate-char.step_saysomething": "Sema Kitu",
    "gui.howtos.animate-char.step_addsound": "Ongeza Sauti",
    "gui.howtos.animate-char.step_animatetalking": "Ongea Kutumia Vibonzo",
    "gui.howtos.animate-char.step_arrowkeys": "Songa Kutumia Vitufe Vya Vishale",
    "gui.howtos.animate-char.step_jump": "Ruka",
    "gui.howtos.animate-char.step_changecolor": "Badilisha Rangi",
    "gui.howtos.make-a-game.name": "Unda Mchezo Wa Kubonyeza",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Chagua Kihusika",
    "gui.howtos.make-a-game.step_GamePlaySound": "Cheza Sauti Ikibonyezwa",
    "gui.howtos.make-a-game.step_GameAddScore": "Unda Kibadilika Cha Alama",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ongeza Alama Inapobonyezwa",
    "gui.howtos.make-a-game.step_Random": "Enda mahali popote",
    "gui.howtos.make-music.step_GameChangeColor": "Badilisha Rangi",
    "gui.howtos.make-music.step_ResetScore": "Rudisha Alama",
    "gui.howtos.make-it-fly.name": "Peperusha",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Chagua Mandhari Ya Nyuma Ya Anga ",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Chagua Mhusika",
    "gui.howtos.fly.step_stepflySaySomething": "Sema Kitu",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Songa Kutumia Vitufe Vya Vishale",
    "gui.howtos.fly.step_stepflyChooseObject": "Chagua Chombo Cha Kukusanya",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Songesha Chombo",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Chagua Mhusika Wako",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ongeza Alama",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Weka Alama",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ongeza Mazingira",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Songa Mazingira",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Mtindo ufuatao",
    "gui.howtos.pong": "Mchezo Wa Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.pong.step_pongAddBallSprite": "Ongeza Kihusika Cha Mpira",
    "gui.howtos.pong.step_pongBounceAround": "Rukaruka",
    "gui.howtos.pong.step_pongAddPaddle": "Ongeza Kafi",
    "gui.howtos.pong.step_pongMoveThePaddle": "Songa Kafi",
    "gui.howtos.pong.step_pongSelectBallSprite": "Ongeza Kihusika Cha Mpira",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ongeza Msimbo Ili Mpira Udunde Kwenye Kafi",
    "gui.howtos.pong.step_pongAddAScore": "Ongeza Alama",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Chagua 'Alama' Kutoka Menyu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Weka Bloku Ya 'Badilisha Alama'",
    "gui.howtos.pong.step_pongResetScore": "Rudisha Alama",
    "gui.howtos.pong.step_pongAddLineSprite": "Ongeza Kihusika Cha Mstari",
    "gui.howtos.pong.step_pongGameOver": "Shindano Limekamilika",
    "gui.howtos.code-cartoon": "Unda Katuni",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sema kitu wakati unapobonyeza bendera kijani",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Unda Kibonzo Cha Mhusika Wakati Utakapokibonyeza",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Chagua Mhusika Tofauti",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Tumia ishara ya kuondoa ili upunguze ukumbwa",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fanya mhusika awe mkumbwa na mdogo",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Chagua Mhusika Tofauti",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Ruka Juu na Chini",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Bonyeza Mhusika kubadilisha Mandhari",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Teleza Kote",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Badilisha Mitindo",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Chagua Wahusika Zaidi wa Kuongeza kwenye Katuni Yako",
    "gui.howtos.cartoon-network": "Tengeneza Mchezo Wa Shani Kutumia Vibonzo",
    "gui.howtos.cartoon-network.step_CNcharacter": "Chagua Mhusika Kuonyesha",
    "gui.howtos.cartoon-network.step_CNsay": "Sema Kitu",
    "gui.howtos.cartoon-network.step_CNglide": "Teleza Kote",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Chagua Chombo cha Kufukuza",
    "gui.howtos.cartoon-network.step_CNcollect": "Kusanya Vyombo",
    "gui.howtos.cartoon-network.step_CNvariable": "Unda Kibadilika cha Alama",
    "gui.howtos.cartoon-network.step_CNscore": "Weka Alama",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Kiwango Cha Juu: Chagua Mandhari Ya Nyuma",
    "gui.howtos.videosens.name": "Uhisi Wa Video",
    "gui.howtos.videosens.step_addextension": "Ongeza Kiendelezi",
    "gui.howtos.videosens.step_pet": "Papasa Paka",
    "gui.howtos.videosens.step_animate": "Tumia Vibonzo",
    "gui.howtos.videosens.step_pop": "Pasua Puto",
    "gui.howtos.say-it-out-loud": "Unda Vibonzo Vinavyoongea",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ongeza bloku za Maandishi kwa Matamshi",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sema Kitu",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Weka Sauti",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Zunguka",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ongeza Mhusika Mwengine",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Fanya Wimbo",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Badilisha Rangi",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Zunguka Kote",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Kubwa na Ndogo",
    "gui.howtos.talking": "Hekaya",
    "gui.howtos.talking.step_talesAddExtension": "Bonyeza kuongeza bloku za Maandishi kwa Matamshi",
    "gui.howtos.talking.step_talesChooseSprite": "Chagua Kihusika",
    "gui.howtos.talking.step_talesSaySomething": "Fanya Mhusika Aongee",
    "gui.howtos.talking.step_talesChooseBackdrop": "Chagua Mandhari Ya Nyuma",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Mhusika kuenda kwa mandhari ya nyuma ifuatayo",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Chagua Kihusika Kingine",
    "gui.howtos.talking.step_talesMoveAround": "Zunguka",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Chagua Mandhari Ya Nyuma Nyingine",
    "gui.howtos.talking.step_talesAnimateTalking": "Ongea Kutumia Vibonzo",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Chagua Mandhari Ya Nyuma Nyingine",
    "gui.howtos.talking.step_talesChooseSound": "Chagua Wimbo",
    "gui.howtos.talking.step_talesDanceMoves": "Miondoko ya Dansi",
    "gui.howtos.talking.step_talesAskAnswer": "Tumia bloku ya Kuuliza na Kujibu katika kategoria ya Hisi",
    "gui.howtos.add-sprite.name": "Ongeza Kihusika",
    "gui.howtos.add-sprite.step_addSprite": "Ongeza Kihusika",
    "gui.howtos.add-a-backdrop.name": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ongeza Mandhari Ya Nyuma",
    "gui.howtos.change-size.name": "Badilisha Ukubwa",
    "gui.howtos.change-size.step_changeSize": "Badilisha Ukubwa",
    "gui.howtos.glide-around.name": "Teleza Kote",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Teleza Kote",
    "gui.howtos.change-size.step_glideAroundPoint": "Teleza Mpaka Mahali Fulani",
    "gui.howtos.record-a-sound.name": "Rekodi Sauti",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Bonyeza Tabo Ya 'Sauti'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Bonyeza 'Rekodi'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Bonyeza Kitufe Cha Rekodi",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Chagua Sauti Yako",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Cheza Sauti Yako",
    "gui.howtos.spin-video.name": "Fanya Kizunguke",
    "gui.howtos.change-size.step_spinTurn": "Zunguka",
    "gui.howtos.change-size.step_spinPointInDirection": "Weka Mwelekeo",
    "gui.howtos.hide-and-show.name": "Ficha na Onyesha",
    "gui.howtos.change-size.step_hideAndShow": "Ficha na Onyesha",
    "gui.howtos.switch-costume.name": "Unda Kibonzo Cha Kihusika",
    "gui.howtos.change-size.step_switchCostumes": "Unda Kibonzo Cha Kihusika",
    "gui.howtos.move-around-with-arrow-keys.name": "Tumia Vitufe Vya Vishale",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Songa Kushoto na Kulia",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Songa Juu na Chini",
    "gui.howtos.add-effects.name": "Ongeza Athari",
    "gui.howtos.videosens.step_addEffects": "Ongeza Athari",
    "gui.extension.music.name": "Muziki",
    "gui.extension.music.description": "Cheza vyombo vya muziki na ngoma.",
    "gui.extension.pen.name": "Kalamu",
    "gui.extension.pen.description": "Chora kutumia vihusika vyako.",
    "gui.extension.videosensing.name": "Uhisi Wa Video",
    "gui.extension.videosensing.description": "Hisi mwendo kutumia kamera.",
    "gui.extension.text2speech.name": "Maandishi kwa Matamshi",
    "gui.extension.text2speech.description": "Fanya miradi yako izungumze.",
    "gui.extension.translate.name": "Tafsiri",
    "gui.extension.translate.description": "Tafsiri maandishi katika lugha nyingi.",
    "gui.extension.makeymakey.description": "Badilisha kitu chochote kuwa kitufe",
    "gui.extension.microbit.description": "Unganisha miradi yako na dunia.",
    "gui.extension.microbit.connectingMessage": "Inaunganisha",
    "gui.extension.ev3.description": "Jenga roboti inayounganika na mambo mengineyo.",
    "gui.extension.ev3.connectingMessage": "Inaunganisha. Hakikisha kuwa pini kwenye EV3 yako ni 1234.",
    "gui.extension.boost.description": "Fufua roboti.",
    "gui.extension.boost.connectingMessage": "Inaunganisha",
    "gui.extension.wedo2.description": "Jenga kutumia mota na vihisia.",
    "gui.extension.wedo2.connectingMessage": "Inaunganisha",
    "gui.extension.gdxfor.description": "Hisi msukumo, mvuto, mwendo na mzunguko.",
    "gui.extension.gdxfor.connectingMessage": "Inaunganisha",
    "gui.libraryTags.all": "Kila Kitu",
    "gui.libraryTags.animals": "Wanyama",
    "gui.libraryTags.dance": "Dansi",
    "gui.libraryTags.effects": "Athari",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Mtindo",
    "gui.libraryTags.food": "Chakula",
    "gui.libraryTags.indoors": "Ndani Ya Nyumba",
    "gui.libraryTags.loops": "Vitanzi",
    "gui.libraryTags.music": "Muziki",
    "gui.libraryTags.notes": "Noti",
    "gui.libraryTags.outdoors": "Nje",
    "gui.libraryTags.patterns": "Ruwaza",
    "gui.libraryTags.people": "Watu",
    "gui.libraryTags.percussion": "Vyombo Vya Kugongwa",
    "gui.libraryTags.space": "Angani",
    "gui.libraryTags.sports": "Spoti",
    "gui.libraryTags.underwater": "Chini Ya Maji",
    "gui.libraryTags.voice": "Sauti",
    "gui.libraryTags.wacky": "Kuchekesha",
    "gui.libraryTags.animation": "Kibonzo",
    "gui.libraryTags.art": "Sanaa",
    "gui.libraryTags.games": "Michezo",
    "gui.libraryTags.stories": "Hadithi",
    "gui.libraryTags.letters": "Herufi",
    "gui.opcodeLabels.direction": "mwelekeo",
    "gui.opcodeLabels.xposition": "Nafasi ya x",
    "gui.opcodeLabels.yposition": "Nafasi ya y",
    "gui.opcodeLabels.size": "ukubwa",
    "gui.opcodeLabels.costumename": "jina la mtindo",
    "gui.opcodeLabels.costumenumber": "nambari ya mtindo",
    "gui.opcodeLabels.backdropname": "jina la mandhari ya nyuma",
    "gui.opcodeLabels.backdropnumber": "nambari ya mandhari ya nyuma",
    "gui.opcodeLabels.volume": "kiasi ya sauti",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "jibu",
    "gui.opcodeLabels.loudness": "ukubwa wa sauti",
    "gui.opcodeLabels.username": "jina la mtumiaji",
    "gui.opcodeLabels.year": "mwaka",
    "gui.opcodeLabels.month": "mwezi",
    "gui.opcodeLabels.date": "tarehe",
    "gui.opcodeLabels.dayofweek": "siku ya wiki",
    "gui.opcodeLabels.hour": "saa",
    "gui.opcodeLabels.minute": "dakika",
    "gui.opcodeLabels.second": "sekunde",
    "gui.opcodeLabels.timer": "kipima muda",
    "gui.projectLoader.loadError": "Faili ya mradi iliyochaguliwa ilishindwa kupakia.",
    "gui.sharedMessages.backdrop": "mandhari ya nyuma{index}",
    "gui.sharedMessages.costume": "mtindo{index}",
    "gui.sharedMessages.sprite": "Kihusika{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Badilisha yaliyomo kwenye mradi wa sasa?",
    "gui.sharedMessages.loadFromComputerTitle": "Pakisha kutoka kwa kompyuta yako",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Mradi Wa Scratch",
    "boost.color.any": "rangi yoyote",
    "boost.color.black": "nyeusi",
    "boost.color.blue": "buluu",
    "boost.color.green": "kijani",
    "boost.color.red": "nyekundu",
    "boost.color.white": "nyeupe",
    "boost.color.yellow": "manjano",
    "boost.getMotorPosition": "nafasi ya mota [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "pembe ya mwinamo [TILT_DIRECTION]",
    "boost.motorDirection.backward": "njia hiyo",
    "boost.motorDirection.forward": "njia hii",
    "boost.motorDirection.reverse": "pindua",
    "boost.motorOff": "zima mota [MOTOR_ID]",
    "boost.motorOn": "washa mota [MOTOR_ID]",
    "boost.motorOnFor": "washa mota [MOTOR_ID] kwa sekunde [DURATION]",
    "boost.motorOnForRotation": "washa mota [MOTOR_ID] kwa mizunguko [ROTATION]",
    "boost.seeingColor": "tofali la [COLOR] inaonekana?",
    "boost.setLightHue": "weka rangi ya mwangaza kuwa [HUE]",
    "boost.setMotorDirection": "weka mwelekeo wa mota [MOTOR_ID] kuwa [MOTOR_DIRECTION]",
    "boost.setMotorPower": "weka kasi ya mota [MOTOR_ID] kuwa [POWER] %",
    "boost.tiltDirection.any": "mwelekeo wowote",
    "boost.tiltDirection.down": "chini",
    "boost.tiltDirection.left": "kushoto",
    "boost.tiltDirection.right": "kulia",
    "boost.tiltDirection.up": "juu",
    "boost.whenColor": "tofali la [COLOR] linapoonekana",
    "boost.whenTilted": "inapoinamishwa [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "cheza noti [NOTE] kwa sekunde [TIME]",
    "ev3.buttonPressed": "kitufe cha [PORT] kimebonyezwa?",
    "ev3.getBrightness": "mng'aro",
    "ev3.getDistance": "umbali",
    "ev3.getMotorPosition": "nafasi ya mota [PORT]",
    "ev3.motorSetPower": "weka nguvu ya mota [PORT] kuwa [POWER] %",
    "ev3.motorTurnClockwise": "mota [PORT] kuzunguka hivi kwa sekunde [TIME]",
    "ev3.motorTurnCounterClockwise": "mota [PORT] kuzunguka hivyo kwa sekunde [TIME]",
    "ev3.whenBrightnessLessThan": "wakati mng'aro < [DISTANCE]",
    "ev3.whenButtonPressed": "kitufe [PORT] kinapobonyezwa",
    "ev3.whenDistanceLessThan": "mwelekeo unapokuwa < [DISTANCE]",
    "gdxfor.getAcceleration": "kasi [DIRECTION]",
    "gdxfor.getForce": "nguvu",
    "gdxfor.getSpin": "kasi ya mzunguko [DIRECTION]",
    "gdxfor.getTilt": "pembe ya mwinamo [TILT]",
    "gdxfor.isFreeFalling": "inaanguka?",
    "gdxfor.isTilted": "imeinamishwa [TILT]?",
    "gdxfor.pulled": "kinapovutwa",
    "gdxfor.pushed": "kinaposukumwa",
    "gdxfor.shaken": "kutikiswa",
    "gdxfor.startedFalling": "kuanza kuanguka",
    "gdxfor.tiltDirectionMenu.any": "mwelekeo wowote",
    "gdxfor.tiltDirectionMenu.back": "nyuma",
    "gdxfor.tiltDirectionMenu.front": "mbele",
    "gdxfor.tiltDirectionMenu.left": "kushoto",
    "gdxfor.tiltDirectionMenu.right": "kulia",
    "gdxfor.turnedFaceDown": "kupinduka juu chini",
    "gdxfor.turnedFaceUp": "kupinduka mbele juu",
    "gdxfor.whenForcePushedOrPulled": "kihisia cha nguvu [PUSH_PULL]",
    "gdxfor.whenGesture": "wakati [GESTURE]",
    "gdxfor.whenTilted": "inapoinamishwa [TILT]",
    "makeymakey.downArrow": "kishale cha chini",
    "makeymakey.downArrowShort": "chini",
    "makeymakey.leftArrow": "kishale cha kushoto",
    "makeymakey.leftArrowShort": "kushoto",
    "makeymakey.rightArrow": "kishale cha kulia",
    "makeymakey.rightArrowShort": "kulia",
    "makeymakey.spaceKey": "nafasi",
    "makeymakey.upArrow": "kishale cha juu",
    "makeymakey.upArrowShort": "juu",
    "makeymakey.whenKeyPressed": "kitufe [KEY] kinapobonyezwa",
    "makeymakey.whenKeysPressedInOrder": "vitufe vinapobonyezwa kwa utaratibu wa [SEQUENCE]",
    "microbit.buttonsMenu.any": "mwelekeo wowote",
    "microbit.clearDisplay": "futa skrini",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "onyesha [MATRIX]",
    "microbit.displayText": "onyesha maandishi [TEXT]",
    "microbit.gesturesMenu.jumped": "inaporushwa",
    "microbit.gesturesMenu.moved": "inaposongwa",
    "microbit.gesturesMenu.shaken": "inapotikiswa",
    "microbit.isButtonPressed": "kitufe [BTN] kimebonyezwa?",
    "microbit.isTilted": "imeinamishwa [DIRECTION]?",
    "microbit.pinStateMenu.off": "zima",
    "microbit.pinStateMenu.on": "washa",
    "microbit.tiltAngle": "pembe ya mwinamo [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "mwelekeo wowote",
    "microbit.tiltDirectionMenu.back": "nyuma",
    "microbit.tiltDirectionMenu.front": "mbele",
    "microbit.tiltDirectionMenu.left": "kushoto",
    "microbit.tiltDirectionMenu.right": "kulia",
    "microbit.whenButtonPressed": "kitufe [BTN] kinapobonyezwa",
    "microbit.whenGesture": "wakati [GESTURE]",
    "microbit.whenPinConnected": "pini [PIN] inapounganishwa",
    "microbit.whenTilted": "inapoinamishwa [DIRECTION]",
    "music.categoryName": "Muziki",
    "music.changeTempo": "badilisha tempo kwa [TEMPO]",
    "music.drumBass": "(2) Ngoma Ya Bass",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Closed Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Makofi",
    "music.drumOpenHiHat": "(5) Open Hi-Hat",
    "music.drumSideStick": "(3) Vijiti Vya Ngoma",
    "music.drumSnare": "(1) Ngoma ya Snare",
    "music.drumTambourine": "(7) Manyanga",
    "music.drumTriangle": "(12) Ala ya Pembetatu",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Mbao",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Basuni",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Kwaya",
    "music.instrumentClarinet": "(10) Klarineti",
    "music.instrumentElectricGuitar": "(5) Gitaa La Umeme",
    "music.instrumentElectricPiano": "(2) Piano Ya Umeme",
    "music.instrumentFlute": "(12) Filimbi",
    "music.instrumentGuitar": "(4) Gitaa",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Sanduku La Muziki",
    "music.instrumentOrgan": "(3) Kinanda Cha Filimbi",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Fidla",
    "music.instrumentSaxophone": "(11) Saksafoni",
    "music.instrumentSteelDrum": "(18) Ngoma Ya Chuma",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Tromboni",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Zumari",
    "music.midiPlayDrumForBeats": "cheza ngoma [DRUM] kwa midundo [BEATS]",
    "music.midiSetInstrument": "weka ala ya muziki kuwa [INSTRUMENT]",
    "music.playDrumForBeats": "cheza ngoma [DRUM] kwa midundo [BEATS]",
    "music.playNoteForBeats": "cheza noti [NOTE] kwa midundo [BEATS]",
    "music.restForBeats": "pumzika kwa midundo [BEATS]",
    "music.setInstrument": "weka ala ya muziki kuwa [INSTRUMENT]",
    "music.setTempo": "weka tempo kuwa [TEMPO]",
    "pen.categoryName": "Kalamu",
    "pen.changeColorParam": "badilisha [COLOR_PARAM] kwa [VALUE]",
    "pen.changeHue": "badilisha rangi ya kalamu kwa [HUE]",
    "pen.changeShade": "badilisha namna ya rangi ya kalamu kwa [SHADE]",
    "pen.changeSize": "badilisha ukubwa wa kalamu kwa [SIZE]",
    "pen.clear": "futa yote",
    "pen.colorMenu.brightness": "mng'aro",
    "pen.colorMenu.color": "rangi",
    "pen.colorMenu.saturation": "kiasi ya rangi",
    "pen.colorMenu.transparency": "upenyeko wa nuru",
    "pen.penDown": "kalamu chini",
    "pen.penUp": "kalamu juu",
    "pen.setColor": "weka rangi ya kalamu kuwa [COLOR]",
    "pen.setColorParam": "weka [COLOR_PARAM] kuwa [VALUE]",
    "pen.setHue": "weka rangi ya kalamu kuwa [HUE]",
    "pen.setShade": "weka namna ya rangi ya kalamu kuwa [SHADE]",
    "pen.setSize": "weka ukubwa wa kalamu kuwa [SIZE]",
    "pen.stamp": "muhuri",
    "speech.defaultWhenIHearValue": "twende",
    "speech.extensionName": "Matamshi kwa Maandishi",
    "speech.listenAndWait": "sikiliza na subiri",
    "speech.speechReporter": "matamshi",
    "speech.whenIHear": "ninaposikia [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Maandishi kwa Matamshi",
    "text2speech.defaultTextToSpeak": "habari",
    "text2speech.giant": "jitu",
    "text2speech.kitten": "paka",
    "text2speech.setLanguageBlock": "weka lugha kuwa [LANGUAGE]",
    "text2speech.setVoiceBlock": "weka sauti kuwa [VOICE]",
    "text2speech.speakAndWaitBlock": "sema [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Tafsiri",
    "translate.defaultTextToTranslate": "habari",
    "translate.translateBlock": "tafsiri [WORDS] hadi [LANGUAGE]",
    "translate.viewerLanguage": "lugha",
    "videoSensing.categoryName": "Uhisi Wa Video",
    "videoSensing.direction": "mwelekeo",
    "videoSensing.motion": "mwendo",
    "videoSensing.off": "zima",
    "videoSensing.on": "washa",
    "videoSensing.onFlipped": "ikipinduliwa",
    "videoSensing.setVideoTransparency": "weka upenyeko wa nuru kuwa [TRANSPARENCY]",
    "videoSensing.sprite": "kihusika",
    "videoSensing.stage": "jukwaa",
    "videoSensing.videoOn": "[ATTRIBUTE] wa video uwe kwa [SUBJECT]",
    "videoSensing.videoToggle": "video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "wakati mwendo wa video > [REFERENCE]",
    "wedo2.getDistance": "umbali",
    "wedo2.getTiltAngle": "pembe ya mwinamo [TILT_DIRECTION]",
    "wedo2.isTilted": "imeinamishwa [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "hivyo",
    "wedo2.motorDirection.forward": "hivi",
    "wedo2.motorDirection.reverse": "upande mwingine",
    "wedo2.motorId.a": "mota A",
    "wedo2.motorId.all": "mota zote",
    "wedo2.motorId.b": "mota B",
    "wedo2.motorId.default": "mota",
    "wedo2.motorOff": "zima [MOTOR_ID]",
    "wedo2.motorOn": "washa [MOTOR_ID]",
    "wedo2.motorOnFor": "washa [MOTOR_ID] kwa sekunde [DURATION]",
    "wedo2.playNoteFor": "cheza noti [NOTE] kwa sekunde [DURATION]",
    "wedo2.setLightHue": "weka rangi ya mwangaza kuwa [HUE]",
    "wedo2.setMotorDirection": "weka mwelekeo wa [MOTOR_ID] kuwa [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "weka nguvu ya [MOTOR_ID] kuwa [POWER]",
    "wedo2.tiltDirection.any": "mwelekeo wowote",
    "wedo2.tiltDirection.down": "chini",
    "wedo2.tiltDirection.left": "kushoto",
    "wedo2.tiltDirection.right": "kulia",
    "wedo2.tiltDirection.up": "juu",
    "wedo2.whenDistance": "wakati mwelekeo [OP] [REFERENCE]",
    "wedo2.whenTilted": "inapoinamishwa [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Rangi",
    "paint.paintEditor.saturation": "Kiasi Ya Rangi",
    "paint.paintEditor.brightness": "Mng'aro",
    "paint.paintEditor.costume": "Mtindo",
    "paint.paintEditor.group": "Kusanya",
    "paint.paintEditor.ungroup": "Toa Kwenye Kundi",
    "paint.paintEditor.undo": "Ondoa",
    "paint.paintEditor.redo": "Rudia",
    "paint.paintEditor.forward": "Enda Mbele",
    "paint.paintEditor.backward": "Rudi Nyuma",
    "paint.paintEditor.front": "Mbele",
    "paint.paintEditor.back": "Nyuma",
    "paint.paintEditor.more": "Zaidi",
    "paint.modeTools.brushSize": "Ukubwa ",
    "paint.modeTools.eraserSize": "Ukubwa wa kifutio",
    "paint.modeTools.copy": "Nakala",
    "paint.modeTools.paste": "Bandika",
    "paint.modeTools.delete": "Futa",
    "paint.modeTools.curved": "Fanya Mzingo",
    "paint.modeTools.pointed": "Fanya Kipeo",
    "paint.modeTools.thickness": "Unene",
    "paint.modeTools.flipHorizontal": "Zungusha Kwa Mlalo",
    "paint.modeTools.flipVertical": "Zungusha Kwa Wima",
    "paint.modeTools.filled": "Iliyojazwa",
    "paint.modeTools.outlined": "Mstari Uliozungukwa",
    "paint.paintEditor.bitmap": "Badilisha kuwa Bitmap",
    "paint.paintEditor.vector": "Badilisha kuwa Vector",
    "paint.paintEditor.fill": "Jaza Rangi",
    "paint.paintEditor.stroke": "Mstari Wa Kuzunguka",
    "paint.brushMode.brush": "Brashi",
    "paint.eraserMode.eraser": "Kifutio",
    "paint.fillMode.fill": "Jaza Rangi",
    "paint.lineMode.line": "Mstari",
    "paint.ovalMode.oval": "Duara",
    "paint.rectMode.rect": "Mstatili",
    "paint.reshapeMode.reshape": "Badilisha Umbo",
    "paint.roundedRectMode.roundedRect": "Mstatili Uilo Na Pembe Za Mviringo",
    "paint.selectMode.select": "Chagua",
    "paint.textMode.text": "Maandishi",
    "paint.colorPicker.swap": "Badilisha"
  },
  "ht": {
    "gui.alerts.lostPeripheralConnection": "Scratch pèdi koneksyon ak {extensionName}",
    "gui.alerts.tryAgain": "Eseye ankò",
    "gui.alerts.download": "Telechaje",
    "gui.connection.reconnect": "Rekonekte",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "aktè",
    "gui.backpack.header": "Valiz lekòl",
    "gui.backpack.errorBackpack": "Erè chajman valiz lekòl",
    "gui.backpack.loadingBackpack": "Chajman...",
    "gui.backpack.more": "Plis",
    "gui.backpack.emptyBackpack": "Valiz lekòl la vid",
    "gui.unsupportedBrowser.label": "Pa gen sipò pou navigatè sa a",
    "gui.unsupportedBrowser.errorLabel": "Yon pwoblèm te rive",
    "gui.unsupportedBrowser.notRecommended": "Nou regrèt anpil, men Scratch pa sipòte vèsyon navigate w ap itilize a. Nou rekòmande w pou w mete ajou ak dènye vèsyon yon navigate ki gen sipò tankou Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "Nou regrèt anpil, men Scratch pa sipòte vèsyon navigatè sa a. Nou rekòmande w pou w mete ajou ak dènye vèsyon yon navigatè ki gen sipò tankou Google Chrome, Mozilla Firefox, Microsoft Edge, oubyen Apple Safari.",
    "gui.unsupportedBrowser.back": "Retounen",
    "gui.unsupportedBrowser.previewfaq": "Pou aprann plis, ale nan{previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "Kesyon moun konn poze souvan",
    "gui.cards.all-tutorials": "Leson",
    "gui.cards.shrink": "Ratresi",
    "gui.cards.expand": "Elaji",
    "gui.cards.close": "Fèmen",
    "gui.cards.more-things-to-try": "Plis bagay pou w eseye !",
    "gui.cards.see-more": "Gade plis",
    "gui.comingSoon.message1": "Pa enkyete w, n ap travay sou li{emoji}",
    "gui.comingSoon.message2": "Disponib Talè",
    "gui.comingSoon.message3": "N ap travay sou li{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nou pa jwenn okenn aparèy",
    "gui.connection.auto-scanning.prescan": "Mete aparèy ou la tou pre, epi kòmanse chèche",
    "gui.connection.auto-scanning.pressbutton": "Peze bouton nan aparèy ou an.",
    "gui.connection.auto-scanning.start-search": "Kòmanse Chèche",
    "gui.connection.connecting-searchbutton": "L ap chèche...",
    "gui.connection.auto-scanning.try-again": "Eseye ankò",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Konekte",
    "gui.connection.disconnect": "Dekonekte",
    "gui.connection.go-to-editor": "Ale nan Editè",
    "gui.connection.connecting-cancelbutton": "L ap konekte...",
    "gui.connection.error.errorMessage": "Wouch, sanble yon bagay mal pase.",
    "gui.connection.error.tryagainbutton": "Eseye ankò",
    "gui.connection.error.helpbutton": "Èd",
    "gui.connection.peripheral-name-label": "Non aparèy ",
    "gui.connection.connect": "Konekte",
    "gui.connection.scanning.lookingforperipherals": "L ap chèche aparèy",
    "gui.connection.scanning.noPeripheralsFound": "Nou pa jwenn okenn aparèy",
    "gui.connection.scanning.instructions": "Chwazi aparèy ou la nan lis ki an wo a.",
    "gui.connection.search": "Chaje ankò",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Asire Lyen Scratch la enstale epi l ap mache",
    "gui.connection.unavailable.enablebluetooth": "Tcheke Bluetooth aktive",
    "gui.connection.unavailable.tryagainbutton": "Eseye ankò",
    "gui.connection.unavailable.helpbutton": "Èd",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Ale",
    "gui.controls.stop": "Kanpe",
    "gui.crashMessage.label": "Wouch! Gen yon bagay ki te mal pase. ",
    "gui.crashMessage.description": "Nou regrèt anpil, men sanble Scratch kraze. Yo voye ekip Scratch la enfòmasyon sou pwoblèm sa a otomatikman. Tanpri chaje paj la ankò pou w eseye yon lòt fwa.",
    "gui.crashMessage.errorNumber": "Pwoblèm ou lan anrejistre ak idantite{errorId}",
    "gui.crashMessage.reload": "Rechaje",
    "gui.customProcedures.myblockModalTitle": "Fè yon blòk ",
    "gui.customProcedures.addAnInputNumberText": "Ajoute yon antre",
    "gui.customProcedures.numberTextType": "chif oubyen tèks",
    "gui.customProcedures.addAnInputBoolean": "Ajoute yon antre",
    "gui.customProcedures.booleanType": "bouleyen",
    "gui.customProcedures.addALabel": "Ajoute yon etikèt",
    "gui.customProcedures.runWithoutScreenRefresh": "Fè mache san chaje ekran an ankò",
    "gui.customProcedures.cancel": "Anile",
    "gui.customProcedures.ok": "Oke",
    "gui.SpriteInfo.direction": "Direksyon",
    "gui.directionPicker.rotationStyles.allAround": "Toutotou",
    "gui.directionPicker.rotationStyles.leftRight": "Goch/Dwat",
    "gui.directionPicker.rotationStyles.dontRotate": "Pa vire ",
    "gui.gui.addExtension": "Ajoute ekstansyon",
    "gui.gui.codeTab": "Kòd",
    "gui.gui.backdropsTab": "Fon ",
    "gui.gui.costumesTab": "Kostim",
    "gui.gui.soundsTab": "Son",
    "gui.extensionLibrary.comingSoon": "Disponib Talè",
    "gui.extensionLibrary.requires": "Egzije",
    "gui.extensionLibrary.collaboration": "Kolaborasyon ak",
    "gui.library.filterPlaceholder": "Chèche",
    "gui.library.allTag": "Tout",
    "gui.loader.message1": "N ap kreye blòk ...",
    "gui.loader.message2": "Chajman aktè ...",
    "gui.loader.message3": "Chajman son ...",
    "gui.loader.message4": "Chajman ekstansyon ...",
    "gui.loader.message5": "N ap rasanble dènye chat la ...",
    "gui.loader.message6": "N ap voye nano yo ba w ...",
    "gui.loader.message7": "N ap gonfle gobo ...",
    "gui.loader.message8": "N ap prepare emoji ...",
    "gui.loader.headline": "Chajman pwojè",
    "gui.loader.creating": "Kreye pwojè",
    "gui.accountMenu.profile": "Pwofil",
    "gui.accountMenu.myStuff": "Bagay mwen yo",
    "gui.accountMenu.myClasses": "Klas mwen yo",
    "gui.accountMenu.myClass": "Klas mwen an",
    "gui.accountMenu.accountSettings": "Paramèt kont",
    "gui.accountMenu.signOut": "Dekonekte",
    "gui.authorInfo.byUser": "Otè : {username}",
    "gui.menuBar.seeProjectPage": "Gade paj pwojè a",
    "gui.menuBar.language": "Language",
    "general.username": "Non itilizatè",
    "general.password": "Mo d pas",
    "general.signIn": "Konekte",
    "login.needHelp": "Ou bezwen èd ?",
    "form.validationRequired": "Ou oblije ranpli seksyon sa a",
    "gui.menuBar.tutorialsLibrary": "Leson",
    "gui.menuBar.restoreSprite": "Fè aktè la retounen",
    "gui.menuBar.restoreSound": "Fè son an retounen",
    "gui.menuBar.restoreCostume": "Fè kostim lan retounen",
    "gui.menuBar.restore": "Fè l retounen",
    "gui.menuBar.saveNow": "Sovgade kounye a",
    "gui.menuBar.saveAsCopy": "Sovgade kòm yon kopi",
    "gui.menuBar.remix": "Remikse",
    "gui.menuBar.new": "Nouvo",
    "gui.menuBar.file": "Fichye",
    "gui.menuBar.downloadToComputer": "Sovgade sou òdinatè w a",
    "gui.menuBar.edit": "Modifye",
    "gui.menuBar.turboModeOff": "Fèmen Mòd Turbo a",
    "gui.menuBar.turboModeOn": "Ouvri Mòd Turbo a",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Kreye yon kont sou Scratch",
    "gui.menuBar.signIn": "Konekte",
    "gui.gui.projectTitlePlaceholder": "Tit Pwojè isi",
    "gui.menuBar.saveNowLink": "Sovgade Kounye a",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Pataje",
    "gui.menuBar.share": "Pataje",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Èd",
    "gui.modal.back": "Retounen",
    "gui.monitor.listMonitor.empty": "(vid)",
    "gui.monitor.listMonitor.listLength": "longè{length}",
    "gui.monitor.contextMenu.default": "lekti nòmal",
    "gui.monitor.contextMenu.large": "gran lekti",
    "gui.monitor.contextMenu.slider": "kisè",
    "gui.monitor.contextMenu.sliderRange": "Chanje zòn kisè ",
    "gui.monitor.contextMenu.import": "enpòte",
    "gui.monitor.contextMenu.export": "espòte",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Jwe",
    "gui.playButton.stop": "Koupe",
    "gui.gui.variableScopeOptionAllSprites": "Pou tout aktè",
    "gui.gui.variableScopeOptionSpriteOnly": "Pou aktè sa a sèlman",
    "gui.gui.cloudVariableOption": "Varyab nyaj (estoke sou sèvè a)",
    "gui.gui.variablePromptAllSpritesMessage": "Varyab sa ap disponib pou tout aktè.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Anile",
    "gui.prompt.ok": "Oke",
    "gui.playbackStep.stopMsg": "Kanpe",
    "gui.playbackStep.playMsg": "Jwe",
    "gui.playbackStep.loadingMsg": "Chajman...",
    "gui.playbackStep.saveMsg": "Sovgade",
    "gui.playbackStep.reRecordMsg": "Anrejistre ankò",
    "gui.recordModal.title": "Anrejistre son",
    "gui.recordingStep.beginRecord": "Kòmanse anrejistre nan klike sou bouton an ba a",
    "gui.recordingStep.permission": "{arrow}Nou bezwen pèmisyon w pou n itilize mikwofòn ou nan",
    "gui.recordingStep.stop": "Sispann anrejistre",
    "gui.recordingStep.record": "Anrejistre",
    "gui.sliderModal.min": "Nonm minimòm",
    "gui.sliderModal.max": "Nonm maksimòm",
    "gui.sliderModal.title": "Chanje zòn kisè",
    "gui.sliderPrompt.cancel": "Anile",
    "gui.sliderPrompt.ok": "Oke",
    "gui.soundEditor.sound": "Son",
    "gui.soundEditor.play": "Jwe",
    "gui.soundEditor.stop": "Kanpe",
    "gui.soundEditor.copy": "Kopye",
    "gui.soundEditor.paste": "Kole",
    "gui.soundEditor.copyToNew": "Kopye nan Nouvo",
    "gui.soundEditor.delete": "Efase",
    "gui.soundEditor.save": "Sovgade",
    "gui.soundEditor.undo": "Defèt",
    "gui.soundEditor.redo": "Refè",
    "gui.soundEditor.faster": "Pi rapid",
    "gui.soundEditor.slower": "Pi dousman",
    "gui.soundEditor.echo": "Eko",
    "gui.soundEditor.robot": "Wobo",
    "gui.soundEditor.louder": "Pi fò",
    "gui.soundEditor.softer": "Pi ba",
    "gui.soundEditor.reverse": "Ranvèse",
    "gui.soundEditor.fadeOut": "Disparèt gradyèlman",
    "gui.soundEditor.fadeIn": "Antre gradyèlman",
    "gui.soundEditor.mute": "Sou silans",
    "gui.SpriteInfo.spritePlaceholder": "Non",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Aktè",
    "gui.SpriteInfo.show": "Montre",
    "gui.SpriteInfo.size": "Tay",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kopye",
    "gui.spriteSelectorItem.contextMenuExport": "espòte",
    "gui.spriteSelectorItem.contextMenuDelete": "efase",
    "gui.spriteSelector.addSpriteFromLibrary": "Chwazi yon aktè",
    "gui.spriteSelector.addSpriteFromPaint": "Pentire",
    "gui.spriteSelector.addSpriteFromSurprise": "Sipriz",
    "gui.spriteSelector.addSpriteFromFile": "Ajoute aktè",
    "gui.stageHeader.stageSizeLarge": "Chanje sèn lan ak yon gwo sèn",
    "gui.stageHeader.stageSizeSmall": "Chanje sèn lan ak yon ti sèn",
    "gui.stageHeader.stageSizeFull": "Antre nan mòd ekran plen",
    "gui.stageHeader.stageSizeUnFull": "Sòti nan mòd ekran plen",
    "gui.stageHeader.fullscreenControl": "Kontwòl ekran plen",
    "gui.spriteSelector.addBackdropFromLibrary": "Chwazi yon fon ",
    "gui.stageSelector.addBackdropFromPaint": "Pentire",
    "gui.stageSelector.addBackdropFromSurprise": "Sipriz",
    "gui.stageSelector.addBackdropFromFile": "Ajoute yon fon ",
    "gui.stageSelector.stage": "Sèn",
    "gui.stageSelector.backdrops": "Fon ",
    "gui.telemetryOptIn.label": "Voye estatistik ou pou ede Scratch vin pi bon",
    "gui.telemetryOptIn.body1": "Ekip Scratch la toujou ap chèche pou l pi byen konprann ki jan moun itilize Scratch tou pa tou sou latè. Pou sipòte efò sa a, ou ka pèmèt Scratch  voye enfòmasyon itilizasyon w bay Ekip Scratch la otomatikman",
    "gui.telemetryOptIn.body2": "Enfòmasyon nou kolekte yo gen ladan seleksyon lang, itilizasyon blòk yo, ak kèk evènman tankou sovgade, chajman, ak ajoute yon pwojè. Nou PA kolekte OKENN enfòmasyon pèsonèl. Tanpri gade{privacyPolicyLink} pou plis enfòmasyon.",
    "gui.telemetryOptIn.privacyPolicyLink": "Règleman sou enfòmasyon ki dwe rete prive",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Mòd Turbo",
    "gui.webglModal.label": "Navigatè w a pa sipòte WebGL",
    "gui.webglModal.description": "Malerezman sanble navigatè w a oswa òdinatè w a {webGlLink}.  Scratch 3.0 bezwen teknoloji sa a pou l ka fonksyone.",
    "gui.webglModal.webgllink": "pa sipòte WebGL",
    "gui.webglModal.back": "Retounen",
    "gui.webglModal.previewfaq": "Pou aprann plis, ale nan{previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "Kesyon moun konn poze souvan",
    "gui.costumeLibrary.chooseABackdrop": "Chwazi yon fon ",
    "gui.costumeLibrary.chooseACostume": "Chwazi yon kostim",
    "gui.costumeTab.addBackdropFromLibrary": "Chwazi yon fon ",
    "gui.costumeTab.addCostumeFromLibrary": "Chwazi yon kostim",
    "gui.costumeTab.addBlankCostume": "Pentire",
    "gui.costumeTab.addSurpriseCostume": "Sipriz",
    "gui.costumeTab.addFileBackdrop": "Ajoute yon fon",
    "gui.costumeTab.addFileCostume": "Ajoute yon kostim",
    "gui.extensionLibrary.chooseAnExtension": "Chwazi yon ekstansyon",
    "gui.extensionLibrary.extensionUrl": "Antre URL ekstansyon an",
    "gui.monitors.importListColumnPrompt": "Ki kolòn pou n itilize (1-{numberOfColumns}) ?",
    "gui.recordingStep.alertMsg": "Nou pa t kapab kòmanse anrejistreman",
    "gui.soundLibrary.chooseASound": "Chwazi yon son",
    "gui.soundTab.fileUploadSound": "Ajoute yon Son",
    "gui.soundTab.surpriseSound": "Sipriz",
    "gui.soundTab.recordSound": "Anrejistre",
    "gui.soundTab.addSoundFromLibrary": "Chwazi yon son",
    "gui.spriteLibrary.chooseASprite": "Chwazi yon aktè",
    "gui.tipsLibrary.tutorials": "Chwazi yon leson",
    "gui.alerts.createsuccess": "Nou kreye yon nouvo pwojè. ",
    "gui.alerts.createcopysuccess": "Nou sovgade pwojè a kòm yon kopi. ",
    "gui.alerts.createremixsuccess": "Nou sovgade pwojè a kòm yon remiks.",
    "gui.alerts.creating": "Kreye nouvo ...",
    "gui.alerts.creatingCopy": "Kopye pwojè ...",
    "gui.alerts.creatingRemix": "Remikse pwojè ...",
    "gui.alerts.creatingError": "Nou pa t ka kreye pwojè a. Tanpri eseye ankò !",
    "gui.alerts.savingError": "Nou pa t ka sovgade pwojè a.",
    "gui.alerts.savesuccess": "Nou sovgade pwojè a",
    "gui.alerts.saving": "Sovgade pwojè...",
    "gui.alerts.cloudInfo": "Tanpri sonje, varyab nyaj yo sèlman sipòte chif, pa lèt ak senbòl.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Aprann plis.",
    "gui.alerts.importing": "Enpòte...",
    "gui.defaultProject.meow": "Myaw",
    "gui.defaultProject.variable": "varyab mwen la",
    "gui.howtos.intro-move-sayhello-hat.name": "Pou Kòmanse",
    "gui.howtos.intro-move.step_stepMove": "Ajoute yon blòk mouvman",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Anime yon non",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Chwazi yon aktè lèt",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Lè l klike, jwe yon son",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Chwazi yon lòt aktè lèt",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Chanje koulè",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Chwazi yon lòt aktè Lèt  e fè l vire",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Chwazi yon lòt aktè lèt e anlaji l",
    "gui.howtos.imagine": "Imajine yon mond",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tape sa ou ta renmen di",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klike drapo vèt la pou kòmanse",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Chwazi nenpòt fon ",
    "gui.howtos.imagine.step_imagineChooseSprite": "Chwazi nenpòt aktè",
    "gui.howtos.imagine.step_imagineFlyAround": "Peze touch espas la pou glise",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Chwazi yon lòt aktè",
    "gui.howtos.imagine.step_imagineLeftRight": "Deplase goch-dwat",
    "gui.howtos.imagine.step_imagineUpDown": "Deplase an wo-an ba",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Chanje kostim",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glise rive nan yon pwen",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grandi e Ratresi",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Chwazi yon lòt twal fon",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Chanje twal fon",
    "gui.howtos.imagine.step_imagineRecordASound": "Ajoute yon son",
    "gui.howtos.imagine.step_imagineChooseSound": "Chwazi son ou an",
    "gui.howtos.make-music.name": "Fè mizik",
    "gui.howtos.Make-Music.step_PickInstrument": "Chwazi yon aktè enstriman",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Lè l klike, jwe yon son",
    "gui.howtos.Make-Music.step_MakeSong": "Kreye yon chan",
    "gui.howtos.make-music.step_MakeBeat": "Chwazi yon tanbou e fè yon bit",
    "gui.howtos.make-music.step_MakeBeatBox": "Chwazi aktè mikrofòn lan & bwat bit sipriz la",
    "gui.howtos.story.name": "Kreye yon istwa",
    "gui.howtos.story.step_addbg": "Ajoute yon twal fon",
    "gui.howtos.story.step_addsprite": "Ajoute yon pèsonaj",
    "gui.howtos.story.step_saysomething": "Di yon bagay",
    "gui.howtos.story.step_addanothersprite": "Ajoute yon lòt pèsonaj",
    "gui.howtos.story.step_flip": "Chanje direksyon",
    "gui.howtos.story.step_conversation": "Koze ansanm",
    "gui.howtos.story.addanotherbg": "Ajoute yon lòt twal fon",
    "gui.howtos.story.step_swithbg": "Chanje twal fon",
    "gui.howtos.story.step_hidewizard": "Kache yon pèsonaj",
    "gui.howtos.story.step_showwizard": "Montre yon pèsonaj",
    "gui.howtos.make-a-chase-game.name": "Fè yon jwèt chas",
    "gui.howtos.Chase-Game.step_BG": "Ajoute yon twal fon",
    "gui.howtos.chase-game.step_AddOcto": "Ajoute yon aktè",
    "gui.howtos.make-music.step_LeftRight": "Deplase adwat e agoch ak flèch yo",
    "gui.howtos.Chase-Game.step_UpDown": "Deplase an wo e an ba ak flèch yo",
    "gui.howtos.Chase-Game.step_AddStar": "Ajoute yon lòt aktè",
    "gui.howtos.Chase-Game.step_MoveRandom": "Deplase pa aza",
    "gui.howtos.Chase-Game.step_WhenTouch": "Nan aktè pyèv la, lè w touche jwe son",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Kreye yon varyab eskò",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Nan aktè pyèv la, lè w touche ajoute eskò",
    "gui.howtos.animate-char.name": "Anime yon pèsonaj",
    "gui.howtos.animate-char.step_addbg": "Ajoute yon twal fon",
    "gui.howtos.animate-char.step_addsprite": "Ajoute yon aktè",
    "gui.howtos.animate-char.step_saysomething": "Di yon bagay",
    "gui.howtos.animate-char.step_addsound": "Ajoute son",
    "gui.howtos.animate-char.step_animatetalking": "Anime pale",
    "gui.howtos.animate-char.step_arrowkeys": "Sèvi ak touch flèch yo pou w deplase",
    "gui.howtos.animate-char.step_jump": "Sote",
    "gui.howtos.animate-char.step_changecolor": "Chanje koulè",
    "gui.howtos.make-a-game.name": "Fè yon jwèt klikè",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Chwazi yon aktè",
    "gui.howtos.make-a-game.step_GamePlaySound": "Jwe son lè l klike",
    "gui.howtos.make-a-game.step_GameAddScore": "Kreye yon varyab eskò",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ogmante eskò a chak fwa yo klike",
    "gui.howtos.make-a-game.step_Random": "Ale nan yon pozisyon oaza",
    "gui.howtos.make-music.step_GameChangeColor": "Chanje koulè",
    "gui.howtos.make-music.step_ResetScore": "Rekòmanse eskò a zewo",
    "gui.howtos.make-it-fly.name": "Fè l vole",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Chwazi yon fon syèl",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Chwazi yon pèsonaj",
    "gui.howtos.fly.step_stepflySaySomething": "Di yon bagay",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Deplase avèk touch flèch ",
    "gui.howtos.fly.step_stepflyChooseObject": "Chwazi yon objè pou ranmase",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fè objè a deplase",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Chwazi pèsonaj ou la",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Ajoute yon eskò",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Konte eskò",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Ajoute yon dekò",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Deplase dekò a",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Pwochenn Kostim",
    "gui.howtos.pong": "Jwèt Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Ajoute yon twal fon",
    "gui.howtos.pong.step_pongAddBallSprite": "Ajoute yon aktè boul",
    "gui.howtos.pong.step_pongBounceAround": "Rebondi oz alantou",
    "gui.howtos.pong.step_pongAddPaddle": "Ajoute yon ram",
    "gui.howtos.pong.step_pongMoveThePaddle": "Deplase ram lan",
    "gui.howtos.pong.step_pongSelectBallSprite": "Seleksyone aktè boul la",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ajoute kòd pou rebondi boul la sou ram lan",
    "gui.howtos.pong.step_pongAddAScore": "Ajoute yon eskò",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Chwazi 'eskò' nan meni a",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Antre blòk 'Chanje eskò\" ",
    "gui.howtos.pong.step_pongResetScore": "Rekòmanse eskò a zewo",
    "gui.howtos.pong.step_pongAddLineSprite": "Ajoute aktè liy la",
    "gui.howtos.pong.step_pongGameOver": "Jwèt fini",
    "gui.howtos.code-cartoon": "Kode yon desen anime",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Di yon bagay lè ou klike sou drapo vèt la",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anime yon pèsonaj lè ou klike sou li",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Seleksyone yon lòt pèsonaj ",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Sèvi ak yon siy mwens pou vin pi piti",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fè yon pèsonaj grandi e ratresi",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Seleksyone yon lòt pèsonaj",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Sote ponpe",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klike sou yon pèsonaj pou chanje sèn",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glise oz alantou",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Chanje kostim",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Chwazi plis pèsonaj pou antre desen anime ou a",
    "gui.howtos.cartoon-network": "Anime yon jwèt avanti",
    "gui.howtos.cartoon-network.step_CNcharacter": "Chwazi yon pèsonaj pou montre",
    "gui.howtos.cartoon-network.step_CNsay": "Di yon bagay",
    "gui.howtos.cartoon-network.step_CNglide": "Glise oz alantou",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Chwazi yon objè pou chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Ranmase objè",
    "gui.howtos.cartoon-network.step_CNvariable": "Kreye yon varyab eskò",
    "gui.howtos.cartoon-network.step_CNscore": "Make eskò",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Nivo pi wo : Chanje twal fon",
    "gui.howtos.videosens.name": "Deteksyon videyo",
    "gui.howtos.videosens.step_addextension": "Ajoute ekstansyon",
    "gui.howtos.videosens.step_pet": "Karese chat la",
    "gui.howtos.videosens.step_animate": "Anime",
    "gui.howtos.videosens.step_pop": "Pete yon blad",
    "gui.howtos.say-it-out-loud": "Kreye animasyon ki pale",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Ajoute blòk \"Tèks an Vwa\" yo",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Di yon bagay",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Fikse yon vwa",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Deplase oz alantou",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Ajoute yon twal fon",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Ajoute yon lòt pèsonaj",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Chante yon chan",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Chanje koulè",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Vire oz alantou",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grandi e Ratresi",
    "gui.howtos.talking": "Kont ki pale",
    "gui.howtos.talking.step_talesAddExtension": "Klike pou ajoute blòk  \"Tèks-an-Vwa\" yo",
    "gui.howtos.talking.step_talesChooseSprite": "Chwazi yon aktè",
    "gui.howtos.talking.step_talesSaySomething": "Fè yon pèsonaj pale",
    "gui.howtos.talking.step_talesChooseBackdrop": "Chwazi yon fon ",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klike sou yon pèsonaj pou w avanse nan pwochenn fon an",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Chwazi yon lòt aktè",
    "gui.howtos.talking.step_talesMoveAround": "Deplase oz alantou",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Chwazi yon lòt fon",
    "gui.howtos.talking.step_talesAnimateTalking": "Anime pale",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Chwazi yon lòt fon ",
    "gui.howtos.talking.step_talesChooseSound": "Chwazi yon chan pou w danse",
    "gui.howtos.talking.step_talesDanceMoves": "Mouvman Dans yo",
    "gui.howtos.talking.step_talesAskAnswer": "Jwenn blòk \"Kesyon ak Repons\" yo nan kategori Deteksyon a",
    "gui.howtos.add-sprite.name": "Ajoute yon aktè",
    "gui.howtos.add-sprite.step_addSprite": "Ajoute yon aktè",
    "gui.howtos.add-a-backdrop.name": "Ajoute yon twal fon",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Ajoute yon twal fon",
    "gui.howtos.change-size.name": "Chanje tay",
    "gui.howtos.change-size.step_changeSize": "Chanje tay",
    "gui.howtos.glide-around.name": "Glise oz alantou",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glise oz alantou",
    "gui.howtos.change-size.step_glideAroundPoint": "Glise rive nan yon pwen",
    "gui.howtos.record-a-sound.name": "Anrejistre yon son",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klike sou ongle 'Son' an",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klike sou 'anrejistre'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Peze bouton anrejjstre a",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Chwazi son w an",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Jwe son w an",
    "gui.howtos.spin-video.name": "Fè l vire",
    "gui.howtos.change-size.step_spinTurn": "Vire",
    "gui.howtos.change-size.step_spinPointInDirection": "Fikse direksyon",
    "gui.howtos.hide-and-show.name": "Kache e Montre",
    "gui.howtos.change-size.step_hideAndShow": "Kache e Montre",
    "gui.howtos.switch-costume.name": "Anime yon aktè",
    "gui.howtos.change-size.step_switchCostumes": "Anime yon aktè",
    "gui.howtos.move-around-with-arrow-keys.name": "Sèvi ak touch flèch ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Deplase agoch e adwat",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Monte e desann",
    "gui.howtos.add-effects.name": "Ajoute efè",
    "gui.howtos.videosens.step_addEffects": "Ajoute efè",
    "gui.extension.music.name": "Mizik",
    "gui.extension.music.description": "Jwe enstriman ak tanbou. ",
    "gui.extension.pen.name": "Plim",
    "gui.extension.pen.description": "Desinen ak aktè ou yo.",
    "gui.extension.videosensing.name": "Deteksyon videyo",
    "gui.extension.videosensing.description": "Detekte mouvman avèk kamera a.",
    "gui.extension.text2speech.name": "Tèks an Vwa",
    "gui.extension.text2speech.description": "Fè pwojè w yo pale.",
    "gui.extension.translate.name": "Tradwi",
    "gui.extension.translate.description": "Tradwi tèks nan plizyè lang. ",
    "gui.extension.makeymakey.description": "Fè nenpòt bagay tounen yon kle. ",
    "gui.extension.microbit.description": "Konekte pwojè ou yo ak anviwònman w. ",
    "gui.extension.microbit.connectingMessage": "L ap konekte",
    "gui.extension.ev3.description": "Konstwi wobo entèraktif e plis toujou",
    "gui.extension.ev3.connectingMessage": "L ap konekte. Asire PIN EV3 ou a se 1234 li ye.",
    "gui.extension.boost.description": "Fè kreyasyon wobotik ou yo tounen vivan",
    "gui.extension.boost.connectingMessage": "L ap konekte",
    "gui.extension.wedo2.description": "Konstwi ak motè epi detektè.",
    "gui.extension.wedo2.connectingMessage": "L ap konekte",
    "gui.extension.gdxfor.description": "Detekte pouse, rale, mouvman, ak vire.",
    "gui.extension.gdxfor.connectingMessage": "L ap konekte",
    "gui.libraryTags.all": "Tout",
    "gui.libraryTags.animals": "Bèt",
    "gui.libraryTags.dance": "Danse",
    "gui.libraryTags.effects": "Efè",
    "gui.libraryTags.fantasy": "Imajinè",
    "gui.libraryTags.fashion": "Rad",
    "gui.libraryTags.food": "Manje",
    "gui.libraryTags.indoors": "An dedan kay",
    "gui.libraryTags.loops": "Bouk ",
    "gui.libraryTags.music": "Mizik",
    "gui.libraryTags.notes": "Nòt",
    "gui.libraryTags.outdoors": "Deyò",
    "gui.libraryTags.patterns": "Modèl ",
    "gui.libraryTags.people": "Moun",
    "gui.libraryTags.percussion": "Batri",
    "gui.libraryTags.space": "Espas",
    "gui.libraryTags.sports": "Espò",
    "gui.libraryTags.underwater": "An ba dlo",
    "gui.libraryTags.voice": "Vwa",
    "gui.libraryTags.wacky": "Biza",
    "gui.libraryTags.animation": "Animasyon",
    "gui.libraryTags.art": "Atizay",
    "gui.libraryTags.games": "Jwèt ",
    "gui.libraryTags.stories": "Istwa ",
    "gui.libraryTags.letters": "Lèt ",
    "gui.opcodeLabels.direction": "direksyon",
    "gui.opcodeLabels.xposition": "pozisyon x",
    "gui.opcodeLabels.yposition": "pozisyon y",
    "gui.opcodeLabels.size": "gwosè",
    "gui.opcodeLabels.costumename": "non kostim",
    "gui.opcodeLabels.costumenumber": "nimewo kostim",
    "gui.opcodeLabels.backdropname": "non twal fon an",
    "gui.opcodeLabels.backdropnumber": "mimewo twal fon",
    "gui.opcodeLabels.volume": "volim",
    "gui.opcodeLabels.tempo": "tenmpo",
    "gui.opcodeLabels.answer": "repons",
    "gui.opcodeLabels.loudness": "volim ",
    "gui.opcodeLabels.username": "non itilizatè",
    "gui.opcodeLabels.year": "ane",
    "gui.opcodeLabels.month": "mwa",
    "gui.opcodeLabels.date": "jou",
    "gui.opcodeLabels.dayofweek": "jou nan semenn lan",
    "gui.opcodeLabels.hour": "lè",
    "gui.opcodeLabels.minute": "minit",
    "gui.opcodeLabels.second": "segond",
    "gui.opcodeLabels.timer": "kwonomèt",
    "gui.projectLoader.loadError": "Fichye pwojè ki te seleksyone a pa t rive chaje",
    "gui.sharedMessages.backdrop": "Twal fon{index}",
    "gui.sharedMessages.costume": "Kostim{index}",
    "gui.sharedMessages.sprite": "Aktè{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Ranplase kontni pwojè aktyèl la ?",
    "gui.sharedMessages.loadFromComputerTitle": "Chaje yon pwojè sou òdinatè w ",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Pwojè Scratch",
    "boost.color.any": "nenpòt koulè",
    "boost.color.black": "nwa",
    "boost.color.blue": "ble",
    "boost.color.green": "vèt",
    "boost.color.red": "wouj",
    "boost.color.white": "blan",
    "boost.color.yellow": "jòn",
    "boost.getMotorPosition": "pozisyon motè [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "ang li panche [TILT_DIRECTION]",
    "boost.motorDirection.backward": "lòt direksyon an",
    "boost.motorDirection.forward": "direksyon sa a",
    "boost.motorDirection.reverse": "fè bak",
    "boost.motorOff": "rete motè [MOTOR_ID]",
    "boost.motorOn": "mete motè [MOTOR_ID] an mach",
    "boost.motorOnFor": "fè motè a woule [MOTOR_ID] pandan [DURATION] segond",
    "boost.motorOnForRotation": "fè motè woule [MOTOR_ID] pandan [ROTATION] rotasyon",
    "boost.seeingColor": "èske l wè brik [COLOR] ?",
    "boost.setLightHue": "mete koulè limyè sou [HUE]",
    "boost.setMotorDirection": "fikse direksyon motè [MOTOR_ID] a [MOTOR_DIRECTION]",
    "boost.setMotorPower": "fikse vitès motè [MOTOR_ID] a [POWER] %",
    "boost.tiltDirection.any": "nenpòt",
    "boost.tiltDirection.down": "an ba",
    "boost.tiltDirection.left": "goch",
    "boost.tiltDirection.right": "dwat",
    "boost.tiltDirection.up": "an wo",
    "boost.whenColor": "lè l wè brik [COLOR] ",
    "boost.whenTilted": "lè l panche [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "bipe ton [NOTE] pandan [TIME] segond",
    "ev3.buttonPressed": "èske bouton [PORT] an peze ?",
    "ev3.getBrightness": "ekleraj",
    "ev3.getDistance": "distans",
    "ev3.getMotorPosition": "Pozisyon motè [PORT]",
    "ev3.motorSetPower": "fikse fòs motè [PORT] a [POWER] %",
    "ev3.motorTurnClockwise": "motè [PORT] pran direksyon sa a pandan [TIME] segond",
    "ev3.motorTurnCounterClockwise": "motè [PORT] pran lòt direksyon an pandan [TIME] segond",
    "ev3.whenBrightnessLessThan": "lè ekleraj < [DISTANCE]",
    "ev3.whenButtonPressed": "lè bouton [PORT] peze",
    "ev3.whenDistanceLessThan": "lè distans < [DISTANCE]",
    "gdxfor.getAcceleration": "akselere an [DIRECTION]",
    "gdxfor.getForce": "fòs",
    "gdxfor.getSpin": "vitès rotasyon [DIRECTION]",
    "gdxfor.getTilt": "ang l ap panche [TILT]",
    "gdxfor.isFreeFalling": "èske l ap tonbe ?",
    "gdxfor.isTilted": "èske l ap panche [TILT] ?",
    "gdxfor.pulled": "rale",
    "gdxfor.pushed": "pouse",
    "gdxfor.shaken": "te souke",
    "gdxfor.startedFalling": "kòmanse tonbe",
    "gdxfor.tiltDirectionMenu.any": "nenpòt",
    "gdxfor.tiltDirectionMenu.back": "dèyè",
    "gdxfor.tiltDirectionMenu.front": "devan",
    "gdxfor.tiltDirectionMenu.left": "goch",
    "gdxfor.tiltDirectionMenu.right": "dwat",
    "gdxfor.turnedFaceDown": "vire tèt an ba",
    "gdxfor.turnedFaceUp": "vire tèt an lè",
    "gdxfor.whenForcePushedOrPulled": "lè kaptè fòs [PUSH_PULL]",
    "gdxfor.whenGesture": "lè [GESTURE]",
    "gdxfor.whenTilted": "lè l panche [TILT]",
    "makeymakey.downArrow": "flèch an ba",
    "makeymakey.downArrowShort": "an ba",
    "makeymakey.leftArrow": "flèch goch",
    "makeymakey.leftArrowShort": "goch",
    "makeymakey.rightArrow": "flèch dwat",
    "makeymakey.rightArrowShort": "dwat",
    "makeymakey.spaceKey": "espas",
    "makeymakey.upArrow": "flèch an wo",
    "makeymakey.upArrowShort": "anwo",
    "makeymakey.whenKeyPressed": "lè [KEY] touch peze",
    "makeymakey.whenKeysPressedInOrder": "lè [SEQUENCE] peze nan lòd",
    "microbit.buttonsMenu.any": "nenpòt",
    "microbit.clearDisplay": "netwaye ekran",
    "microbit.defaultTextToDisplay": "Alo !",
    "microbit.displaySymbol": "afiche [MATRIX]",
    "microbit.displayText": "afiche tèks [TEXT]",
    "microbit.gesturesMenu.jumped": "sote",
    "microbit.gesturesMenu.moved": "deplase",
    "microbit.gesturesMenu.shaken": "te souke",
    "microbit.isButtonPressed": "èske bouton [BTN] peze ?",
    "microbit.isTilted": "èske l panche a [DIRECTION] ?",
    "microbit.pinStateMenu.off": "fèmen",
    "microbit.pinStateMenu.on": "limen",
    "microbit.tiltAngle": "ang li panche an [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "nenpòt",
    "microbit.tiltDirectionMenu.back": "dèyè",
    "microbit.tiltDirectionMenu.front": "devan",
    "microbit.tiltDirectionMenu.left": "goch",
    "microbit.tiltDirectionMenu.right": "dwat",
    "microbit.whenButtonPressed": "lè bouton [BTN]  peze",
    "microbit.whenGesture": "lè [GESTURE]",
    "microbit.whenPinConnected": "lè zepeng [PIN] konekte",
    "microbit.whenTilted": "lè l panche an [DIRECTION]",
    "music.categoryName": "Mizik",
    "music.changeTempo": "chanje tenmpo pa [TEMPO]",
    "music.drumBass": "(2) Gwo kès",
    "music.drumBongo": "(13) Tanbou marasa",
    "music.drumCabasa": "(15) Kalbas (Cabasa Amerik Latin, Shekere afriken)",
    "music.drumClaves": "(9) Clave kiben",
    "music.drumClosedHiHat": "(6) Senbal sali-chapo femèn",
    "music.drumConga": "(14) Batri petwo (Konga kiben)",
    "music.drumCowbell": "(11) Klochèt",
    "music.drumCrashCymbal": "(4) Woule mazon sou yon senbal",
    "music.drumCuica": "(18) Tanbou samba (Cuica brezilyen)",
    "music.drumGuiro": "(16) Enstriman salsa (Guiro Amerik Latin)",
    "music.drumHandClap": "(8) Bat bravo",
    "music.drumOpenHiHat": "(5) Senbal sali-chapo tou louvri",
    "music.drumSideStick": "(3) Manch tanbou",
    "music.drumSnare": "(1) Tanbou kès",
    "music.drumTambourine": "(7) Tanbouren",
    "music.drumTriangle": "(12) Triyang",
    "music.drumVibraslap": "(17) Zo machwè (Kiyada Amerik Latin, Vibraslap)",
    "music.drumWoodBlock": "(10) Blòk bwa",
    "music.getTempo": "tenmpo",
    "music.instrumentBass": "(6) Kontrebas",
    "music.instrumentBassoon": "(14) Bason",
    "music.instrumentCello": "(8) vyolonsèl",
    "music.instrumentChoir": "(15) Koral",
    "music.instrumentClarinet": "(10) Klarinèt",
    "music.instrumentElectricGuitar": "(5) Gita elektrik",
    "music.instrumentElectricPiano": "(2) Pyano elektrik",
    "music.instrumentFlute": "(12) Flit",
    "music.instrumentGuitar": "(4) Gita",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Kariyon",
    "music.instrumentOrgan": "(3) Òg",
    "music.instrumentPiano": "(1) Pyano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofòn",
    "music.instrumentSteelDrum": "(18) Tanbou Asye (Trinidad ak Tobago)",
    "music.instrumentSynthLead": "(20) Sentetizè pou melodi (lead)",
    "music.instrumentSynthPad": "(21) Sentetizè pou mikse (pad)",
    "music.instrumentTrombone": "(9) Twonbòn",
    "music.instrumentVibraphone": "(16) Vibrafòn (djaz)",
    "music.instrumentWoodenFlute": "(13) Flit an bwa",
    "music.midiPlayDrumForBeats": "jwe tanbou [DRUM] pandan [BEATS] batman",
    "music.midiSetInstrument": "chwazi enstriman [INSTRUMENT]",
    "music.playDrumForBeats": "jwe tanbou [DRUM] pandan [BEATS] batman",
    "music.playNoteForBeats": "jwe ton [NOTE] pandan [BEATS] batman",
    "music.restForBeats": "repoze pandan [BEATS] batman",
    "music.setInstrument": "chwazi enstriman [INSTRUMENT]",
    "music.setTempo": "fikse tenmpo a [TEMPO]",
    "pen.categoryName": "Plim",
    "pen.changeColorParam": "chanje plim [COLOR_PARAM] pa [VALUE]",
    "pen.changeHue": "chanje koulè plim pa [HUE]",
    "pen.changeShade": "chanje lonbraj plim pa [SHADE]",
    "pen.changeSize": "chanje tay plim pa [SIZE]",
    "pen.clear": "efase tout",
    "pen.colorMenu.brightness": "ekleraj",
    "pen.colorMenu.color": "koulè",
    "pen.colorMenu.saturation": "satirasyon",
    "pen.colorMenu.transparency": "transparans",
    "pen.penDown": "bese plim la",
    "pen.penUp": "leve plim la",
    "pen.setColor": "fikse koulè plim nan [COLOR]",
    "pen.setColorParam": "fikse plim [COLOR_PARAM] sou [VALUE]",
    "pen.setHue": "fikse koulè plim sou [HUE]",
    "pen.setShade": "fikse lonbraj plim a [SHADE]",
    "pen.setSize": "fikse tay plim sou [SIZE]",
    "pen.stamp": "mete so",
    "speech.defaultWhenIHearValue": "an n ale",
    "speech.extensionName": "Vwa an Tèks",
    "speech.listenAndWait": "koute e tann",
    "speech.speechReporter": "vwa",
    "speech.whenIHear": "lè mwen tande [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Tèks an Vwa",
    "text2speech.defaultTextToSpeak": "bonjou",
    "text2speech.giant": "gran",
    "text2speech.kitten": "ti chat",
    "text2speech.setLanguageBlock": "chwazi lang [LANGUAGE]",
    "text2speech.setVoiceBlock": "fikse vwa a [VOICE]",
    "text2speech.speakAndWaitBlock": "pale [WORDS]",
    "text2speech.squeak": "kriye",
    "text2speech.tenor": "tenò",
    "translate.categoryName": "Tradwi",
    "translate.defaultTextToTranslate": "bonjou",
    "translate.translateBlock": "tradwi [WORDS] an [LANGUAGE]",
    "translate.viewerLanguage": "lang",
    "videoSensing.categoryName": "Deteksyon videyo",
    "videoSensing.direction": "direksyon",
    "videoSensing.motion": "mouvman",
    "videoSensing.off": "rete",
    "videoSensing.on": "jwe",
    "videoSensing.onFlipped": "sou ranvèse",
    "videoSensing.setVideoTransparency": "fikse transparans videyo a [TRANSPARENCY]",
    "videoSensing.sprite": "aktè",
    "videoSensing.stage": "sèn",
    "videoSensing.videoOn": "videyo [ATTRIBUTE] sou [SUBJECT]",
    "videoSensing.videoToggle": "fè videyo [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "lè mouvman videyo > [REFERENCE]",
    "wedo2.getDistance": "distans",
    "wedo2.getTiltAngle": "ang li panche [TILT_DIRECTION]",
    "wedo2.isTilted": "èske li panche [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "lòt direksyon an",
    "wedo2.motorDirection.forward": "direksyon sa a",
    "wedo2.motorDirection.reverse": "fè bak",
    "wedo2.motorId.a": "motè A",
    "wedo2.motorId.all": "tout motè ",
    "wedo2.motorId.b": "motè B",
    "wedo2.motorId.default": "motè",
    "wedo2.motorOff": "rete [MOTOR_ID] ",
    "wedo2.motorOn": "mete [MOTOR_ID] an mach",
    "wedo2.motorOnFor": "fè [MOTOR_ID] woule pandan [DURATION] segond",
    "wedo2.playNoteFor": "jwe ton [NOTE] pandan [DURATION] segond",
    "wedo2.setLightHue": "mete koulè limyè sou [HUE]",
    "wedo2.setMotorDirection": "mete [MOTOR_ID] sou direksyon [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "fikse fòs [MOTOR_ID] a [POWER]",
    "wedo2.tiltDirection.any": "nenpòt",
    "wedo2.tiltDirection.down": "an ba",
    "wedo2.tiltDirection.left": "goch",
    "wedo2.tiltDirection.right": "dwat",
    "wedo2.tiltDirection.up": "an wo",
    "wedo2.whenDistance": "lè distans [OP] [REFERENCE]",
    "wedo2.whenTilted": "lè l panche [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Koulè",
    "paint.paintEditor.saturation": "Satirasyon",
    "paint.paintEditor.brightness": "Ekleraj",
    "paint.paintEditor.costume": "Kostim",
    "paint.paintEditor.group": "Gwoup",
    "paint.paintEditor.ungroup": "Degwoupe",
    "paint.paintEditor.undo": "Anile",
    "paint.paintEditor.redo": "Fè ankò",
    "paint.paintEditor.forward": "Avanse",
    "paint.paintEditor.backward": "Bak",
    "paint.paintEditor.front": "Douvan",
    "paint.paintEditor.back": "Dèyè",
    "paint.paintEditor.more": "Plis",
    "paint.modeTools.brushSize": "Tay",
    "paint.modeTools.eraserSize": "Tay gòm",
    "paint.modeTools.copy": "Kopye",
    "paint.modeTools.paste": "Kole",
    "paint.modeTools.delete": "Efase",
    "paint.modeTools.curved": "Koube",
    "paint.modeTools.pointed": "Pwenti",
    "paint.modeTools.thickness": "Epesè",
    "paint.modeTools.flipHorizontal": "Ranvèse orizontalman",
    "paint.modeTools.flipVertical": "Ranvèse vètikalman",
    "paint.modeTools.filled": "Ranpli",
    "paint.modeTools.outlined": "An kontou",
    "paint.paintEditor.bitmap": "Konvèti an Bitmap",
    "paint.paintEditor.vector": "Konvèti an vektè",
    "paint.paintEditor.fill": "Ranpli",
    "paint.paintEditor.stroke": "Kontou",
    "paint.brushMode.brush": "Penso",
    "paint.eraserMode.eraser": "Gòm",
    "paint.fillMode.fill": "Ranpli",
    "paint.lineMode.line": "Liy",
    "paint.ovalMode.oval": "Sèk",
    "paint.rectMode.rect": "Rektang",
    "paint.reshapeMode.reshape": "Refòme",
    "paint.roundedRectMode.roundedRect": "Rektang Awondi",
    "paint.selectMode.select": "Seleksyone",
    "paint.textMode.text": "Tèks",
    "paint.colorPicker.swap": "Echanje"
  },
  "ku": {
    "gui.alerts.lostPeripheralConnection": "Girêdana Scratchê bi {extensionName}ê re qut bû.",
    "gui.alerts.tryAgain": "Dîsa Biceribîne",
    "gui.alerts.download": "Daxîne",
    "gui.connection.reconnect": "Dîsa girêde",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Çenteyê Piştê",
    "gui.backpack.errorBackpack": "Di barkirina çenteyê pişte de çewtî çêbû",
    "gui.backpack.loadingBackpack": "Tê barkirin...",
    "gui.backpack.more": "Zêdetir",
    "gui.backpack.emptyBackpack": "Çenteyê Piştê vala ye",
    "gui.unsupportedBrowser.label": "Gerok nayê piştgirîkirin",
    "gui.unsupportedBrowser.errorLabel": "Çewtiyek Çêbû",
    "gui.unsupportedBrowser.notRecommended": "Em pir xemgîn in, wisa dixuye ku tu guhertoyek kevn a gerokê bi kar tîne û ew jî ji aliyê Scratchê ve nayê piştgirîkirin. Em pêşniyar dikin ku tu gerokeke tê piştgirîkirin wekî Google Chrome, Mozilla Firefox, Microsoft Edge, an jî Apple Safariyê hildemîne guhertoya herî dawîn.",
    "gui.unsupportedBrowser.description": "Em pir xemgîn in, ev gerok ji aliyê Scratchê ve nayê piştgirîkirin. Em pêşniyar dikin ku tu gerokeke tê piştgirîkirin wekî Google Chrome, Mozilla Firefox, Microsoft Edge, an jî Apple Safariyê hildemîne guhertoya herî dawîn.",
    "gui.unsupportedBrowser.back": "Paşve",
    "gui.unsupportedBrowser.previewfaq": "Ji bo zanyariyên zêdetir, serdana {previewFaqLink}ê bike.",
    "gui.unsupportedBrowser.previewfaqlinktext": "PPP",
    "gui.cards.all-tutorials": "Fêrgeh",
    "gui.cards.shrink": "Biçûk bike",
    "gui.cards.expand": "Fireh bike",
    "gui.cards.close": "Bigire",
    "gui.cards.more-things-to-try": "Ji bo ceribandinê tiştên zêdetir!",
    "gui.cards.see-more": "Zêdetir Bibîne",
    "gui.comingSoon.message1": "Xemgîn nebe, em hene {emoji}",
    "gui.comingSoon.message2": "Pir Nêz de...",
    "gui.comingSoon.message3": "Em li ser dixebitin {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Cîhaz nehatin dîtin",
    "gui.connection.auto-scanning.prescan": "Cîhaza xwe li nêzîka xwe bihêle, paşê dest bi lêgerînê bike.",
    "gui.connection.auto-scanning.pressbutton": "Pêlî bişkoka li ser cîhaza xwe bike.",
    "gui.connection.auto-scanning.start-search": "Dest bi Lêgerînê Bike",
    "gui.connection.connecting-searchbutton": "Tê gerîn...",
    "gui.connection.auto-scanning.try-again": "Dîsa biceribîne",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Hate girêdan",
    "gui.connection.disconnect": "Girêdanê Qut Bike",
    "gui.connection.go-to-editor": "Biçe Edîtorê",
    "gui.connection.connecting-cancelbutton": "Tê girêdan...",
    "gui.connection.error.errorMessage": "Weyy, wiha dixuye ku hinek tişt berevajî çûn.",
    "gui.connection.error.tryagainbutton": "Dîsa biceribîne",
    "gui.connection.error.helpbutton": "Alîkarî",
    "gui.connection.peripheral-name-label": "Navê cîhazê",
    "gui.connection.connect": "Girê bide",
    "gui.connection.scanning.lookingforperipherals": "Li cîhazan tê gerîn",
    "gui.connection.scanning.noPeripheralsFound": "Cîhaz nehatin dîtin",
    "gui.connection.scanning.instructions": "Ji lîsteya jorîn cîhaza xwe hilbijêre.",
    "gui.connection.search": "Nû bike",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Ji sazbûn û xebitandina Scratch Linkê piştrast be",
    "gui.connection.unavailable.enablebluetooth": "Çalakbûna Bluetoothê kontrol bike",
    "gui.connection.unavailable.tryagainbutton": "Dîsa biceribîne",
    "gui.connection.unavailable.helpbutton": "Alîkarî",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Here",
    "gui.controls.stop": "Rawestîne",
    "gui.crashMessage.label": "Weyy, Hinek tişt çewt çûn.",
    "gui.crashMessage.description": "Em pir xemgîn in, dixuye ku Scratch hedimî ye. Ev kêşe bixweberî ji tîma Scratchê re hate ragihandin. Ji kerema xwe rûpela xwe nû bike û dîsa biceribîne.",
    "gui.crashMessage.errorNumber": "Çewtiyek bi hejmara {errorId} hate tomarkirin",
    "gui.crashMessage.reload": "Dîsa bar bike",
    "gui.customProcedures.myblockModalTitle": "Blokekê Çê Bike",
    "gui.customProcedures.addAnInputNumberText": "Têketanekê tevlî bike",
    "gui.customProcedures.numberTextType": "hejmar an jî nivîs",
    "gui.customProcedures.addAnInputBoolean": "Têketanekê tevlî bike",
    "gui.customProcedures.booleanType": "mantiqî",
    "gui.customProcedures.addALabel": "Etîketekê tevlî bike",
    "gui.customProcedures.runWithoutScreenRefresh": "Bila beyî nûkirina ekranê bixebite",
    "gui.customProcedures.cancel": "Betal",
    "gui.customProcedures.ok": "Baş e",
    "gui.SpriteInfo.direction": "Hêl",
    "gui.directionPicker.rotationStyles.allAround": "Bi Hemû Hêla ve",
    "gui.directionPicker.rotationStyles.leftRight": "Rastê/Çepê",
    "gui.directionPicker.rotationStyles.dontRotate": "Ne zîvirîne",
    "gui.gui.addExtension": "Pêvek Tevlî Bike",
    "gui.gui.codeTab": "Kod",
    "gui.gui.backdropsTab": "Dekor",
    "gui.gui.costumesTab": "Kostum",
    "gui.gui.soundsTab": "Deng",
    "gui.extensionLibrary.comingSoon": "Pir Nêz de...",
    "gui.extensionLibrary.requires": "Hewceyî",
    "gui.extensionLibrary.collaboration": "Bi hevkarî",
    "gui.library.filterPlaceholder": "Lêgerîn",
    "gui.library.allTag": "Hemû",
    "gui.loader.message1": "Blok têne afirandin ...",
    "gui.loader.message2": "Pêlîstik têne barkirin …",
    "gui.loader.message3": "Deng têne barkirin ...",
    "gui.loader.message4": "Pêvek têne barkirin ...",
    "gui.loader.message5": "Pisîkan têne hevdan ...",
    "gui.loader.message6": "Nano têne veguhestin ...",
    "gui.loader.message7": "Gobo têne nepixandin ...",
    "gui.loader.message8": "Emojî têne amadekirin ...",
    "gui.loader.headline": "Proje Tê Barkirin",
    "gui.loader.creating": "Proje Tê Afirandin",
    "gui.accountMenu.profile": "Profîl",
    "gui.accountMenu.myStuff": "Xebatên Min",
    "gui.accountMenu.myClasses": "Polên min",
    "gui.accountMenu.myClass": "Pola Min",
    "gui.accountMenu.accountSettings": "Sazkariyên hesêb",
    "gui.accountMenu.signOut": "Derkeve",
    "gui.authorInfo.byUser": "Ji aliye {username} ve",
    "gui.menuBar.seeProjectPage": "Rûpela Projeyê Bibîne",
    "gui.menuBar.language": "Language",
    "general.username": "Navê Bikarhêner",
    "general.password": "Pêborîn",
    "general.signIn": "Têkeve",
    "login.needHelp": "Alîkarî Hewce ye?",
    "form.validationRequired": "Ev qad pêwîst e",
    "gui.menuBar.tutorialsLibrary": "Fêrgeh",
    "gui.menuBar.restoreSprite": "Pêlîstikê Vegerîne",
    "gui.menuBar.restoreSound": "Deng Vegerîne",
    "gui.menuBar.restoreCostume": "Kostumê Vegerîne",
    "gui.menuBar.restore": "Vegerîne",
    "gui.menuBar.saveNow": "Aniha tomar bike",
    "gui.menuBar.saveAsCopy": "Wekî kopî tomar bike",
    "gui.menuBar.remix": "Remîks",
    "gui.menuBar.new": "Nû",
    "gui.menuBar.file": "Pelge",
    "gui.menuBar.downloadToComputer": "Li kombersa xwe tomar bike",
    "gui.menuBar.edit": "Sererast bike",
    "gui.menuBar.turboModeOff": "Moda Turboyê bigire",
    "gui.menuBar.turboModeOn": "Moda Turboyê veke",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Beşdarî Scratchê Bibe",
    "gui.menuBar.signIn": "Têkeve",
    "gui.gui.projectTitlePlaceholder": "Li vira serika projeyê",
    "gui.menuBar.saveNowLink": "Aniha Tomar Bike",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Parvekirî",
    "gui.menuBar.share": "Parve bike",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Alîkarî",
    "gui.modal.back": "Paşve",
    "gui.monitor.listMonitor.empty": "(vala)",
    "gui.monitor.listMonitor.listLength": "dirêjî {length}",
    "gui.monitor.contextMenu.default": "xuyanga normal",
    "gui.monitor.contextMenu.large": "xuyanga fireh",
    "gui.monitor.contextMenu.slider": "pêşeker",
    "gui.monitor.contextMenu.sliderRange": "rêjeya şemitandinê biguherîne",
    "gui.monitor.contextMenu.import": "têxîne nav",
    "gui.monitor.contextMenu.export": "derxîne",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Lêxe",
    "gui.playButton.stop": "Rawestîne",
    "gui.gui.variableScopeOptionAllSprites": "Ji bo hemû pêlîstikan",
    "gui.gui.variableScopeOptionSpriteOnly": "Tenê ji bo vê pêlîstikê",
    "gui.gui.cloudVariableOption": "Guheroka Ewr (li ser serverê hatiye hilanîn)",
    "gui.gui.variablePromptAllSpritesMessage": "Ev guherok dê ji bo hemû pêlîstikan derbasdar be.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Betal",
    "gui.prompt.ok": "Baş e",
    "gui.playbackStep.stopMsg": "Rawestîne",
    "gui.playbackStep.playMsg": "Lêxe",
    "gui.playbackStep.loadingMsg": "Tê barkirin...",
    "gui.playbackStep.saveMsg": "Tomar bike",
    "gui.playbackStep.reRecordMsg": "Dîsa tomar bike",
    "gui.recordModal.title": "Deng Tomar Bike",
    "gui.recordingStep.beginRecord": "Bi pêlîkirina bişkoka jêrîn ve dest bi tomarkirinê bike",
    "gui.recordingStep.permission": "Ji bo {arrow} mikrofona te bi kar bîne pêwîstiya wê bi destûra te heye",
    "gui.recordingStep.stop": "Tomarkirinê rawestîne",
    "gui.recordingStep.record": "Tomar bike",
    "gui.sliderModal.min": "Nirxê herî nizm",
    "gui.sliderModal.max": "Nirxê herî bilind",
    "gui.sliderModal.title": "Rêjeya şemitandinê biguherîne",
    "gui.sliderPrompt.cancel": "Betal",
    "gui.sliderPrompt.ok": "Baş e",
    "gui.soundEditor.sound": "Deng",
    "gui.soundEditor.play": "Lêxe",
    "gui.soundEditor.stop": "Rawestîne",
    "gui.soundEditor.copy": "Kopî bike",
    "gui.soundEditor.paste": "Bizeliqîne",
    "gui.soundEditor.copyToNew": "Li ya Nû kopî bike",
    "gui.soundEditor.delete": "Jê bibe",
    "gui.soundEditor.save": "Tomar bike",
    "gui.soundEditor.undo": "Vegerîne",
    "gui.soundEditor.redo": "Dîsa pêşve",
    "gui.soundEditor.faster": "Zûtir",
    "gui.soundEditor.slower": "Hêdîtir",
    "gui.soundEditor.echo": "Dengvedan",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Dengê bilindtir",
    "gui.soundEditor.softer": "Nermtir",
    "gui.soundEditor.reverse": "Berevajî",
    "gui.soundEditor.fadeOut": "Tarî bike",
    "gui.soundEditor.fadeIn": "Ronî bike",
    "gui.soundEditor.mute": "Bêdeng bike",
    "gui.SpriteInfo.spritePlaceholder": "Nav",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Pêlîstik",
    "gui.SpriteInfo.show": "Nîşan bide",
    "gui.SpriteInfo.size": "Mezinahî",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kopiya wê derxe",
    "gui.spriteSelectorItem.contextMenuExport": "derxîne",
    "gui.spriteSelectorItem.contextMenuDelete": "jê bibe",
    "gui.spriteSelector.addSpriteFromLibrary": "Pêlîstikekê Hilbijêre",
    "gui.spriteSelector.addSpriteFromPaint": "Rengandin",
    "gui.spriteSelector.addSpriteFromSurprise": "Surprîz",
    "gui.spriteSelector.addSpriteFromFile": "Pêlîstikê Hilbixîne",
    "gui.stageHeader.stageSizeLarge": "Derbasî dika fireh bibe",
    "gui.stageHeader.stageSizeSmall": "Derbasî dika biçûk bibe",
    "gui.stageHeader.stageSizeFull": "Derbasî moda ekrana tije bibe",
    "gui.stageHeader.stageSizeUnFull": "Ji moda ekrana tije derkeve",
    "gui.stageHeader.fullscreenControl": "Kontrola Ekrana Tije",
    "gui.spriteSelector.addBackdropFromLibrary": "Dekorekê Hilbijêre",
    "gui.stageSelector.addBackdropFromPaint": "Rengandin",
    "gui.stageSelector.addBackdropFromSurprise": "Surprîz",
    "gui.stageSelector.addBackdropFromFile": "Dekorê Hilbixîne",
    "gui.stageSelector.stage": "Dik",
    "gui.stageSelector.backdrops": "Dekor",
    "gui.telemetryOptIn.label": "Ji bo pêşxistina Scratchê rêjejimaran ragihîne",
    "gui.telemetryOptIn.body1": "Ji bo bi awayekî baştir were fêhmkirin ku Scratch li seranserê dinyayê çawa tê bikaranîn Tîma Scratchê her dem di nav hewldanan de ye. Ji bo ku piştgiriya van hewldanan bikî, tu dikare destûrê bide ku Scratch bixweberî agahdariyên bikaranînê ji Tîma Scratchê re bişîne.",
    "gui.telemetryOptIn.body2": "Agahiyên em berhev dikin ev in; hilbijartina ziman, bikaranîna blokan, barkirin û hilxistina projeyan û hinek çalakiyên wekî din. Em agahiyên kesane hîç berhev NAKIN. Ji kerema xwe ji bo zanyariyên zêdetir here rûpela {privacyPolicyLink}ê.",
    "gui.telemetryOptIn.privacyPolicyLink": "Polîtîkaya Nihêniyê",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Moda Turboyê",
    "gui.webglModal.label": "Geroka Te Piştgiriya WebGLê Nake",
    "gui.webglModal.description": "Mixabin dixuye ku kombers an jî geroka te wekî {webGlLink}ê ye. Ji bo Scratch 3.0 bixebite ev teknolojî pêwîst e.",
    "gui.webglModal.webgllink": "WebGL nayê piştgirîkirin",
    "gui.webglModal.back": "Paşve",
    "gui.webglModal.previewfaq": "Ji bo zanyariyên zêdetir, serdana {previewFaqLink}ê bike.",
    "gui.webglModal.previewfaqlinktext": "PPP",
    "gui.costumeLibrary.chooseABackdrop": "Dekorekê Hilbijêre",
    "gui.costumeLibrary.chooseACostume": "Kostumekê Hilbijêre",
    "gui.costumeTab.addBackdropFromLibrary": "Dekorekê Hilbijêre",
    "gui.costumeTab.addCostumeFromLibrary": "Kostumekê Hilbijêre",
    "gui.costumeTab.addBlankCostume": "Rengandin",
    "gui.costumeTab.addSurpriseCostume": "Surprîz",
    "gui.costumeTab.addFileBackdrop": "Dekor Hilbixîne",
    "gui.costumeTab.addFileCostume": "Kostum Hilbixîne",
    "gui.extensionLibrary.chooseAnExtension": "Pêvekekê Hilbijêre",
    "gui.extensionLibrary.extensionUrl": "URLa pêvekê têxîne",
    "gui.monitors.importListColumnPrompt": "Divê kîjan stûn were bi kar anîn(1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Tomarkirina deng nayê destpêkirin",
    "gui.soundLibrary.chooseASound": "Dengekî Hilbijêre",
    "gui.soundTab.fileUploadSound": "Deng Hilbixîne",
    "gui.soundTab.surpriseSound": "Surprîz",
    "gui.soundTab.recordSound": "Tomarkirin",
    "gui.soundTab.addSoundFromLibrary": "Dengekî Hilbijêre",
    "gui.spriteLibrary.chooseASprite": "Pêlîstikekê Hilbijêre",
    "gui.tipsLibrary.tutorials": "Derseke Fêrbûnê Hilbijêre",
    "gui.alerts.createsuccess": "Projeya nû hate afirandin.",
    "gui.alerts.createcopysuccess": "Proje wekî kopî hate tomarkirin.",
    "gui.alerts.createremixsuccess": "Proje wekî remîkskirî hate tomarkirin.",
    "gui.alerts.creating": "Nû tê afirandin...",
    "gui.alerts.creatingCopy": "Proje tê kopîkirin...",
    "gui.alerts.creatingRemix": "Proje tê remîkskirin...",
    "gui.alerts.creatingError": "Proje nehate afirandin. Ji kerema xwe dîsa biceribîne!",
    "gui.alerts.savingError": "Proje tomar nebû.",
    "gui.alerts.savesuccess": "Proje tomar bû.",
    "gui.alerts.saving": "Proje tê tomarkirin...",
    "gui.alerts.cloudInfo": "Ji kerema xwe hişyar be, guherokên ewrê tenê piştgiriya hejmaran dike, piştgiriya herf û sembolan nake. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Zêdetir bizane.",
    "gui.alerts.importing": "Têxistinî nav dibe...",
    "gui.defaultProject.meow": "Miyaw",
    "gui.defaultProject.variable": "guheroka min",
    "gui.howtos.intro-move-sayhello-hat.name": "Dest pê bike",
    "gui.howtos.intro-move.step_stepMove": "Blokeke tevgerê tevlî bike",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Navekî Zindî Bike",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pêlîstikeke Herfan Hilbijêre",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Dema ku Hat Pêlîkirin Dengekî Lêxe",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pêlîstikeke Herfa ya Din Hilbijêre",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Reng biguherîne",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pêlîstikeke Herfa ya Din Hilbijêre û Wê Bizîvirîne",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pêlîstikeke Herfa ya Din Hilbijêre û Wê Mezin Bike",
    "gui.howtos.imagine": "Dinyayekê Xeyal Bike",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tiştê ku Tu Dixwazî Bibêje, Binivîse",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Ji bo Destpêkirinê Pêlî Ala Kesk Bike",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Bi ketoberî dekorekê hilbijêre",
    "gui.howtos.imagine.step_imagineChooseSprite": "Bi ketoberî pêlîstikekê hilbijêre",
    "gui.howtos.imagine.step_imagineFlyAround": "Ji bo şemitandinê pêlî bişkoka valahiyê bike",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Pêlîstikeke Din Hilbijêre",
    "gui.howtos.imagine.step_imagineLeftRight": "Veguhezîne Rastê-Çepê",
    "gui.howtos.imagine.step_imagineUpDown": "Bilivîne Jêr-Jor",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Kostuman Biguherîne",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Bişemitîne Nuqteyekê",
    "gui.howtos.imagine.step_imagineGrowShrink": "Mezin û Biçûk Bibe",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Dekoreke Din Hilbijêre",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Dekoran Biguherîne",
    "gui.howtos.imagine.step_imagineRecordASound": "Dengekî Tevlî Bike",
    "gui.howtos.imagine.step_imagineChooseSound": "Dengê Xwe Hilbijêre",
    "gui.howtos.make-music.name": "Muzîk Çêke",
    "gui.howtos.Make-Music.step_PickInstrument": "Pêlîstikeke Amûrê Hilbijêre",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Dema ku Hat Pêlîkirin Deng Lêxe",
    "gui.howtos.Make-Music.step_MakeSong": "Stranekê Biafirîne",
    "gui.howtos.make-music.step_MakeBeat": "Daholekê Hilbijêre û Lêdanekê Çêke",
    "gui.howtos.make-music.step_MakeBeatBox": "Pêlîstika Mîkrofonê û Beatbox a Surprîz Hilbijêre",
    "gui.howtos.story.name": "Çîrokekê Biafirîne",
    "gui.howtos.story.step_addbg": "Dekorekê Biafirîne",
    "gui.howtos.story.step_addsprite": "Karakter Tevlî Bike",
    "gui.howtos.story.step_saysomething": "Tîştekî Bibêje",
    "gui.howtos.story.step_addanothersprite": "Karaktereke Din Tevlî Bike",
    "gui.howtos.story.step_flip": "Berê wê Bizîvirîne",
    "gui.howtos.story.step_conversation": "Hevpeyvînekê Bike",
    "gui.howtos.story.addanotherbg": "Dekoreke Din Tevlî Bike",
    "gui.howtos.story.step_swithbg": "Dekoran Biguherîne",
    "gui.howtos.story.step_hidewizard": "Karakteran Veşêre",
    "gui.howtos.story.step_showwizard": "Karakteran Nîşan Bide",
    "gui.howtos.make-a-chase-game.name": "Lîstokeke Nêçîrê Çêke",
    "gui.howtos.Chase-Game.step_BG": "Dekorekê Biafirîne",
    "gui.howtos.chase-game.step_AddOcto": "Pêlîstikekê Tevlî Bike",
    "gui.howtos.make-music.step_LeftRight": "Bi Bişkokên Tîrê Bilivîne Rastê û Çepê",
    "gui.howtos.Chase-Game.step_UpDown": "Bi Bişkokên Tîrê Bilivîne Jêr û Jor",
    "gui.howtos.Chase-Game.step_AddStar": "Pêlîstikeke Din Tevlî Bike",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bi Ketoberî Tevbigere",
    "gui.howtos.Chase-Game.step_WhenTouch": "Dema ku di Pêlîstika Axtapotê de \"Pêlî Deng Lêxe\"yê bû",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Guheroka Skorê Biafirîne",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Dema ku di Pêlîstika Axtopotê de \"Pêlî Skor Tevlî Bike\"yê bû",
    "gui.howtos.animate-char.name": "Karakteran Zindî Bike",
    "gui.howtos.animate-char.step_addbg": "Dekorekê Biafirîne",
    "gui.howtos.animate-char.step_addsprite": "Pêlîstikekê Tevlî Bike",
    "gui.howtos.animate-char.step_saysomething": "Tîştekî Bibêje",
    "gui.howtos.animate-char.step_addsound": "Deng Tevlî Bike",
    "gui.howtos.animate-char.step_animatetalking": "Axaftinê Zindî Bike",
    "gui.howtos.animate-char.step_arrowkeys": "Bi Bikaranîna Bişkokên Tîrê, Tevbigerîne",
    "gui.howtos.animate-char.step_jump": "Xwe Çeng Bike",
    "gui.howtos.animate-char.step_changecolor": "Reng Biguherîne",
    "gui.howtos.make-a-game.name": "Lîstokeke Tikandinê Çêke",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pêlîstikekê Hilbijêre",
    "gui.howtos.make-a-game.step_GamePlaySound": "Dema ku Hat Pêlîkirin Deng Lêxe",
    "gui.howtos.make-a-game.step_GameAddScore": "Guheroka Skorê Biafirîne",
    "gui.howtos.make-a-game.step_GameChangeScore": "Dema ku Hat Tikandin Skorê Zêde Bike",
    "gui.howtos.make-a-game.step_Random": "Bi ketoberî here ciyekî",
    "gui.howtos.make-music.step_GameChangeColor": "Reng Biguherîne",
    "gui.howtos.make-music.step_ResetScore": "Skorê Nûsaz Bike",
    "gui.howtos.make-it-fly.name": "Bifirîne",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Paşrûyeke Esmanî Hilbijêre",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Karakterekê Hilbêre",
    "gui.howtos.fly.step_stepflySaySomething": "Tîştekî Bibêje",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Bi Bişkokên Tîrê, Veguhezîne",
    "gui.howtos.fly.step_stepflyChooseObject": "Objeyeke Hevdanê Hilbijêre",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Objeyê Bilivîne",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Karaktera Xwe Hilbijêre",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Skorekê Tevlî Bike",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Skorê Biparêze",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Dekora Dikê Tevlî Bike",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Sahneyê Bilivîne",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Kostumê Pêş",
    "gui.howtos.pong": "Lîstoka Pongê",
    "gui.howtos.pong.step_pongAddBackdrop": "Dekorekê Tevlî Bike",
    "gui.howtos.pong.step_pongAddBallSprite": "Pêlîstikeke Topê Tevlî Bike",
    "gui.howtos.pong.step_pongBounceAround": "Li Derdorê Hilpeke",
    "gui.howtos.pong.step_pongAddPaddle": "Raketekê Tevlî Bike",
    "gui.howtos.pong.step_pongMoveThePaddle": "Raketê Bilivîne",
    "gui.howtos.pong.step_pongSelectBallSprite": "Lîstika Topê Hilbijêre",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Ji bo Pengizandina Topê ji Raketê Kodê Tevlî Bike",
    "gui.howtos.pong.step_pongAddAScore": "Skorekê Tevlî Bike",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Ji Menuyê 'Skor'ê Hilbijêre",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Bloka 'Skorê Biguherîne'yê Tevlî Bike",
    "gui.howtos.pong.step_pongResetScore": "Skorê Nûsaz Bike",
    "gui.howtos.pong.step_pongAddLineSprite": "Pêlîstika Xêzê Tevlî Bike",
    "gui.howtos.pong.step_pongGameOver": "Lîstok Qediya",
    "gui.howtos.code-cartoon": "Xêzefîlmekê Bikodîne",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dema ku li Ala Kesk Hate Tikandin Tiştekî Bibêje",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Dema ku Karakterek Hate Tikandin, Zindî Bike",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Karaktereke Cuda Hilbijêre",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Ji bo Biçûktirkirinê Kêmekê bi kar bîne",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Karakterekî Mezin û Biçûk Bike",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Karaktereke Cuda Hilbijêre",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Bipengize Jor û Jêr",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Ji bo Dikê Biguherînî, li Karakterekî Bitikîne",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Li Derdorê Bifire",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Kostuman Biguherîne",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Ji bo Tevlî Xêzefîlma Xwe Bikî, Karakterên Zêdetir Hilbijêre",
    "gui.howtos.cartoon-network": "Lîstokeke Macerayê Zindî Bike",
    "gui.howtos.cartoon-network.step_CNcharacter": "Karakterekî ji bo Nîşandanê Hilbijêre",
    "gui.howtos.cartoon-network.step_CNsay": "Tîştekî Bibêje",
    "gui.howtos.cartoon-network.step_CNglide": "Li Derdorê Bifire",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Objeyekê ji bo Nêçîrê Hilbijêre",
    "gui.howtos.cartoon-network.step_CNcollect": "Objeyan Berhev Bike",
    "gui.howtos.cartoon-network.step_CNvariable": "Guherokeke Skorê Çêke",
    "gui.howtos.cartoon-network.step_CNscore": "Skorê Biparêze",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Asta Bilind: Dekorê Biguherîne",
    "gui.howtos.videosens.name": "Pêhisîna Vîdyoyê",
    "gui.howtos.videosens.step_addextension": "Pêvek Tevlî Bike",
    "gui.howtos.videosens.step_pet": "Pisîkê Bifirkîne",
    "gui.howtos.videosens.step_animate": "Zindî bike",
    "gui.howtos.videosens.step_pop": "Nepoxekê Biteqîne",
    "gui.howtos.say-it-out-loud": "Anîmasyonên Dipeyivin, Biafirîne",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Nivîsê tevlî blokên axaftinê bike",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Tîştekî Bibêje",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Dengekî Saz Bike",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Li Dorê Bizîvire",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Dekorekê Tevlî Bike",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Karaktereke Din Tevlî Bike",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Stranekê Bibêje",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Reng Biguherîne",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Li Dorê Bizîvire",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Mezin û Biçûk Bike",
    "gui.howtos.talking": "Çîrokên Diaxivin",
    "gui.howtos.talking.step_talesAddExtension": "Ji bo Blokên ji Nivîsê bo Axaftinê Tevkî Bikî, Bitikîne",
    "gui.howtos.talking.step_talesChooseSprite": "Pêlîstikekê Hilbijêre",
    "gui.howtos.talking.step_talesSaySomething": "Karakterekê Biaxivîne",
    "gui.howtos.talking.step_talesChooseBackdrop": "Dekorekê Hilbijêre",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Ji bo here Dekora Pêştir, li Karakterekê Bitikîne",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Pêlîstikeke Din Hilbijêre",
    "gui.howtos.talking.step_talesMoveAround": "Li Dorê Bizîvire",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Dekoreke Din Hilbijêre",
    "gui.howtos.talking.step_talesAnimateTalking": "Axaftinê Zindî Bike",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Dekoreke Din Hilbijêre",
    "gui.howtos.talking.step_talesChooseSound": "Ji bo Dansê Stranekê Hilbijêre",
    "gui.howtos.talking.step_talesDanceMoves": "Hereketên Dansê",
    "gui.howtos.talking.step_talesAskAnswer": "Ji Kategoriya Pêhisînê, Blokên Pirs û Bersivan Bistîne",
    "gui.howtos.add-sprite.name": "Pêlîstikekê Tevlî bike",
    "gui.howtos.add-sprite.step_addSprite": "Pêlîstikekê Tevlî bike",
    "gui.howtos.add-a-backdrop.name": "Dekorekê Tevlî Bike",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Dekorekê Tevlî Bike",
    "gui.howtos.change-size.name": "Mezinahiyê Biguherîne",
    "gui.howtos.change-size.step_changeSize": "Mezinahiyê Biguherîne",
    "gui.howtos.glide-around.name": "Li Derdorê Bifire",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Li Derdorê Bifire",
    "gui.howtos.change-size.step_glideAroundPoint": "Bişemitîne Nuqteyekê",
    "gui.howtos.record-a-sound.name": "Dengekî Tomar Bike",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Pêlî Hilpeka 'Deng'ê Bike",
    "gui.howtos.change-size.step_recordASoundClickRecord": "'Tomar bike'yê Bitikîne",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pêlî Bişkoka \"Tomarê bike\"yê bike",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Dengê Xwe Hilbijêre",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Dengê Xwe Lêxe",
    "gui.howtos.spin-video.name": "Li Dora Wê Bizîvirîne",
    "gui.howtos.change-size.step_spinTurn": "Bizîvire",
    "gui.howtos.change-size.step_spinPointInDirection": "Hêlê Saz Bike",
    "gui.howtos.hide-and-show.name": "Veşêre û Nîşan bide",
    "gui.howtos.change-size.step_hideAndShow": "Veşêre û Nîşan bide",
    "gui.howtos.switch-costume.name": "Pêlîstikekê Zindî Bike",
    "gui.howtos.change-size.step_switchCostumes": "Pêlîstikekê Zindî Bike",
    "gui.howtos.move-around-with-arrow-keys.name": "Bişkokên Tîrê bi kar bîne",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Veguhezîne Rastê û Çepê",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bilivîne Jêr û Jor",
    "gui.howtos.add-effects.name": "Efektan Tevlî Bike",
    "gui.howtos.videosens.step_addEffects": "Efektan Tevlî Bike",
    "gui.extension.music.name": "Muzîk",
    "gui.extension.music.description": "Amûran û daholê lêxe.",
    "gui.extension.pen.name": "Pênûs",
    "gui.extension.pen.description": "Bi pêlîstika xwe xêz bike.",
    "gui.extension.videosensing.name": "Pêhisîna Vîdyoyê",
    "gui.extension.videosensing.description": "Bi kamerayê li tevgerê bihise.",
    "gui.extension.text2speech.name": "Ji Nivîsê bo Deng",
    "gui.extension.text2speech.description": "Projeyên xwe biaxivîne.",
    "gui.extension.translate.name": "Werger",
    "gui.extension.translate.description": "Nivîsê li gelek zimanan wergerîne.",
    "gui.extension.makeymakey.description": "Her tiştî bi bişkokekê çêke.",
    "gui.extension.microbit.description": "Projeyên xwe bi dinyayê re parve bike.",
    "gui.extension.microbit.connectingMessage": "Tê girêdan",
    "gui.extension.ev3.description": "Robotên înteraktîv û zêdetirî wan ava bike.",
    "gui.extension.ev3.connectingMessage": "Tê girêdan. Ji sazbûna pîna EV3ê wekî 1234 piştrast be.",
    "gui.extension.boost.description": "Kreasyonên robotîk tevlî jiyanê bike.",
    "gui.extension.boost.connectingMessage": "Tê girêdan",
    "gui.extension.wedo2.description": "Bi motor û sensoran ava bike.",
    "gui.extension.wedo2.connectingMessage": "Tê girêdan",
    "gui.extension.gdxfor.description": "Bi dehfdan, kişandin, tevger û zîvirandinê bihise.",
    "gui.extension.gdxfor.connectingMessage": "Tê girêdan",
    "gui.libraryTags.all": "Hemû",
    "gui.libraryTags.animals": "Ajel/Heywan",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Efekt",
    "gui.libraryTags.fantasy": "Fantazî",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Xurek",
    "gui.libraryTags.indoors": "Hundir",
    "gui.libraryTags.loops": "Zîvir",
    "gui.libraryTags.music": "Muzîk",
    "gui.libraryTags.notes": "Nota",
    "gui.libraryTags.outdoors": "Derveyî",
    "gui.libraryTags.patterns": "Nexş",
    "gui.libraryTags.people": "Mirov",
    "gui.libraryTags.percussion": "Amûrên Lêdanê",
    "gui.libraryTags.space": "Feza",
    "gui.libraryTags.sports": "Werzîş",
    "gui.libraryTags.underwater": "Jêrav",
    "gui.libraryTags.voice": "Deng",
    "gui.libraryTags.wacky": "Ecêb",
    "gui.libraryTags.animation": "Anîmasyon",
    "gui.libraryTags.art": "Huner",
    "gui.libraryTags.games": "Lîstok",
    "gui.libraryTags.stories": "Serpêhatî",
    "gui.libraryTags.letters": "Herf",
    "gui.opcodeLabels.direction": "hêl",
    "gui.opcodeLabels.xposition": "cîgeha x'ê",
    "gui.opcodeLabels.yposition": "cîgeha y'yê",
    "gui.opcodeLabels.size": "mezinahî",
    "gui.opcodeLabels.costumename": "navê kostumê",
    "gui.opcodeLabels.costumenumber": "hejmara kostumê",
    "gui.opcodeLabels.backdropname": "navê dekorê",
    "gui.opcodeLabels.backdropnumber": "hejmara dekorê",
    "gui.opcodeLabels.volume": "deng",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "bersiv",
    "gui.opcodeLabels.loudness": "bilindahiya deng",
    "gui.opcodeLabels.username": "navê bikarhêner",
    "gui.opcodeLabels.year": "sal",
    "gui.opcodeLabels.month": "meh",
    "gui.opcodeLabels.date": "dîrok",
    "gui.opcodeLabels.dayofweek": "roja hefteyê",
    "gui.opcodeLabels.hour": "demjimêr",
    "gui.opcodeLabels.minute": "xulek",
    "gui.opcodeLabels.second": "çirke",
    "gui.opcodeLabels.timer": "demsazker",
    "gui.projectLoader.loadError": "Pelgeprojeya ku hatiye hilbijartin nehat barkirin.",
    "gui.sharedMessages.backdrop": "dekor{index}",
    "gui.sharedMessages.costume": "kostum {index}",
    "gui.sharedMessages.sprite": "Pêlîstik {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Bila naveroka projeya heyî were guhertin?",
    "gui.sharedMessages.loadFromComputerTitle": "Ji kombersa xwe bar bike",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Projeya Scratchê",
    "boost.color.any": "her çi rengek",
    "boost.color.black": "reş",
    "boost.color.blue": "şîn",
    "boost.color.green": "kesk",
    "boost.color.red": "sor",
    "boost.color.white": "spî",
    "boost.color.yellow": "zer",
    "boost.getMotorPosition": "cîgeha motora [MOTOR_REPORTER_ID]ê",
    "boost.getTiltAngle": "pîvana xwarbûnê [TILT_DIRECTION]",
    "boost.motorDirection.backward": "wê hêla",
    "boost.motorDirection.forward": "vê hêla",
    "boost.motorDirection.reverse": "berevajî wê",
    "boost.motorOff": "motora [MOTOR_ID]ê bigire",
    "boost.motorOn": "motora [MOTOR_ID]ê veke",
    "boost.motorOnFor": "motora [MOTOR_ID]ê [DURATION] çirkeyan bixebitîne",
    "boost.motorOnForRotation": "motora [MOTOR_ID]ê [ROTATION] cara bizîvirîne",
    "boost.seeingColor": "parçeyê [COLOR] dibînî?",
    "boost.setLightHue": "rengê ronahiyê bike [HUE]",
    "boost.setMotorDirection": "berê motora [MOTOR_ID]ê wekî [MOTOR_DIRECTION] saz bike",
    "boost.setMotorPower": "hêza motora [MOTOR_ID]ê wekî % [POWER] saz bike",
    "boost.tiltDirection.any": "her çi yek",
    "boost.tiltDirection.down": "jêr",
    "boost.tiltDirection.left": "çep",
    "boost.tiltDirection.right": "rast",
    "boost.tiltDirection.up": "jor",
    "boost.whenColor": "dema ku parçeyê bi rengê [COLOR] hat dîtin",
    "boost.whenTilted": "dema ku [TILT_DIRECTION_ANY] xwar bû",
    "ev3.beepNote": "notaya [NOTE]ê [TIME] çirkeyan lêxe",
    "ev3.buttonPressed": "pêlî bişkoka [PORT]ê hate kirin?",
    "ev3.getBrightness": "ronahî",
    "ev3.getDistance": "mesafe",
    "ev3.getMotorPosition": "cîgeha motora [PORT]ê",
    "ev3.motorSetPower": "hêza motora [PORT]ê wekî % [POWER] saz bike",
    "ev3.motorTurnClockwise": "motora [PORT]ê bi vê hêlê ( > ) ve [TIME] çirkeyan bizîvirîne",
    "ev3.motorTurnCounterClockwise": "motora [PORT]ê bi vê hêla ( < ) [TIME] çirkeyan bizîvirîne",
    "ev3.whenBrightnessLessThan": "dema ku ronahî bû < [DISTANCE]",
    "ev3.whenButtonPressed": "dema ku pêlî bişkoka [PORT]ê hate kirin",
    "ev3.whenDistanceLessThan": "dema ku mesafe bû < [DISTANCE]",
    "gdxfor.getAcceleration": "lezîn [DIRECTION]",
    "gdxfor.getForce": "hêz",
    "gdxfor.getSpin": "leza zîvirînê [DIRECTION]",
    "gdxfor.getTilt": "pîvana xwarbûnê [TILT]",
    "gdxfor.isFreeFalling": "dikeve?",
    "gdxfor.isTilted": " ma [TILT] xwar e?",
    "gdxfor.pulled": "kişandî",
    "gdxfor.pushed": "dehfdandî",
    "gdxfor.shaken": "hejandî",
    "gdxfor.startedFalling": "dest bi ketinê kiriye",
    "gdxfor.tiltDirectionMenu.any": "her çi yek",
    "gdxfor.tiltDirectionMenu.back": "paşve",
    "gdxfor.tiltDirectionMenu.front": "pêşve",
    "gdxfor.tiltDirectionMenu.left": "çepê",
    "gdxfor.tiltDirectionMenu.right": "rastê",
    "gdxfor.turnedFaceDown": "berê wê bi jêr ve",
    "gdxfor.turnedFaceUp": "berê wê bi jor ve",
    "gdxfor.whenForcePushedOrPulled": "dema ku hêza sensorê bû [PUSH_PULL]",
    "gdxfor.whenGesture": "dema ku bû [GESTURE]",
    "gdxfor.whenTilted": "dema ku xwarbûn bibe [TILT]",
    "makeymakey.downArrow": "tîra jêr",
    "makeymakey.downArrowShort": "jêr",
    "makeymakey.leftArrow": "tîra çepê",
    "makeymakey.leftArrowShort": "çep",
    "makeymakey.rightArrow": "tîra rastê",
    "makeymakey.rightArrowShort": "rast",
    "makeymakey.spaceKey": "valahî",
    "makeymakey.upArrow": "tîra jor",
    "makeymakey.upArrowShort": "jor",
    "makeymakey.whenKeyPressed": "dema ku pêlî bişkoka [KEY]ê hate kirin",
    "makeymakey.whenKeysPressedInOrder": "dema ku bi rêzê pêlî [SEQUENCE]ê hate kirin",
    "microbit.buttonsMenu.any": "her çi yek",
    "microbit.clearDisplay": "ekranê paqij bike",
    "microbit.defaultTextToDisplay": "Silav!",
    "microbit.displaySymbol": "[MATRIX]ê nîşan bide",
    "microbit.displayText": "nivîsa [TEXT]ê nîşan bide",
    "microbit.gesturesMenu.jumped": "gavkirî",
    "microbit.gesturesMenu.moved": "veguheztî",
    "microbit.gesturesMenu.shaken": "hejandî",
    "microbit.isButtonPressed": "pêlî bişkoka [BTN]ê hatiye kirin?",
    "microbit.isTilted": "[DIRECTION] hatiye xwarkirin?",
    "microbit.pinStateMenu.off": "girtî",
    "microbit.pinStateMenu.on": "vekirî",
    "microbit.tiltAngle": "pîvana xwarbûnê [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "her çi yek",
    "microbit.tiltDirectionMenu.back": "paşve",
    "microbit.tiltDirectionMenu.front": "pêşî",
    "microbit.tiltDirectionMenu.left": "çep",
    "microbit.tiltDirectionMenu.right": "rast",
    "microbit.whenButtonPressed": "dema ku pêlî bişkoka [BTN]ê hate kirin",
    "microbit.whenGesture": "dema ku bû [GESTURE]",
    "microbit.whenPinConnected": "dema ku pîn [PIN]ê hate girêdan",
    "microbit.whenTilted": "dema ku [DIRECTION] hate xwarkirin",
    "music.categoryName": "Muzîk",
    "music.changeTempo": "tempoyê bike [TEMPO]",
    "music.drumBass": "(2) Bas Dahol",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Klaves",
    "music.drumClosedHiHat": "(6) Hi-Hata Girtî",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Zingil",
    "music.drumCrashCymbal": "(4) Sentûr",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Çepik",
    "music.drumOpenHiHat": "(5) Zengila Vekirî",
    "music.drumSideStick": "(3) Darikê Kêlekê",
    "music.drumSnare": "(1) Trampet",
    "music.drumTambourine": "(7) Def",
    "music.drumTriangle": "(12) Sêgoşe",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Bloka Text",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Selo",
    "music.instrumentChoir": "(15) Koro",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Elektro Gîtar",
    "music.instrumentElectricPiano": "(2) Elektro Piyano",
    "music.instrumentFlute": "(12) Flut",
    "music.instrumentGuitar": "(4) Gîtar",
    "music.instrumentMarimba": "(19) Marîmba",
    "music.instrumentMusicBox": "(17) Qutiya Muzîkê",
    "music.instrumentOrgan": "(3) Org",
    "music.instrumentPiano": "(1) Piyano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksafon",
    "music.instrumentSteelDrum": "(18) Dahola Polayê",
    "music.instrumentSynthLead": "(20) Syntha Gulle",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vîbrafon",
    "music.instrumentWoodenFlute": "(13) Bilûr",
    "music.midiPlayDrumForBeats": "dahola [DRUM]ê [BEATS] lêdana lêxe",
    "music.midiSetInstrument": "amûrê bike [INSTRUMENT]",
    "music.playDrumForBeats": "dahola [DRUM]ê [BEATS] lêdana lêxe",
    "music.playNoteForBeats": "notaya [NOTE]ê [BEATS] lêdana lêxe",
    "music.restForBeats": "[BEATS] lêdana bisekine",
    "music.setInstrument": "amûrê bike [INSTRUMENT]",
    "music.setTempo": "tempoyê bike [TEMPO]",
    "pen.categoryName": "Pênûs",
    "pen.changeColorParam": "pênûsa [COLOR_PARAM]ê bi [VALUE] re biguherîne",
    "pen.changeHue": "rengê pênûsê bi qasî [HUE] zêde bike",
    "pen.changeShade": "sîbera pênûsê bi qasî [SHADE] zêde bike",
    "pen.changeSize": "mezinahiya pênûsê bi qasî [SIZE] zêde bike",
    "pen.clear": "hemûyan jê bibe",
    "pen.colorMenu.brightness": "ronahî",
    "pen.colorMenu.color": "reng",
    "pen.colorMenu.saturation": "têrbûn",
    "pen.colorMenu.transparency": "zelalî",
    "pen.penDown": "pênûsê pêxîne",
    "pen.penUp": "pênûsê bilind bike",
    "pen.setColor": "rengê pênûsê bike [COLOR]",
    "pen.setColorParam": "pênûsa [COLOR_PARAM]ê bike [VALUE]",
    "pen.setHue": "rengê pênûsê bike [HUE]",
    "pen.setShade": "sîbera pênûsê bike [SHADE]",
    "pen.setSize": "mezinahiya pênûsê bike [SIZE]",
    "pen.stamp": "mohr bike",
    "speech.defaultWhenIHearValue": "ka em dest pê bikin",
    "speech.extensionName": "Ji Axaftinê bo Nivîsê",
    "speech.listenAndWait": "guhdarî bike û bisekine",
    "speech.speechReporter": "axaftin",
    "speech.whenIHear": "dema ku min [PHRASE]ê bihîst",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Ji Nivîsê bo Deng",
    "text2speech.defaultTextToSpeak": "silav",
    "text2speech.giant": "dêw(hût)",
    "text2speech.kitten": "çêlika pisîkê",
    "text2speech.setLanguageBlock": "ziman bike [LANGUAGE]",
    "text2speech.setVoiceBlock": "deng bike [VOICE]",
    "text2speech.speakAndWaitBlock": "bipeyive [WORDS]",
    "text2speech.squeak": "hawar",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Werger",
    "translate.defaultTextToTranslate": "silav",
    "translate.translateBlock": "nivîsa [WORDS]ê wergerîne zimanê [LANGUAGE]",
    "translate.viewerLanguage": "ziman",
    "videoSensing.categoryName": "Pêhisîna Vîdyoyê",
    "videoSensing.direction": "hêla",
    "videoSensing.motion": "tevgera",
    "videoSensing.off": "bigire",
    "videoSensing.on": "veke",
    "videoSensing.onFlipped": "berevajîkirî",
    "videoSensing.setVideoTransparency": "zelalbûna vîdyoyê bike [TRANSPARENCY]",
    "videoSensing.sprite": "pêlîstik",
    "videoSensing.stage": "dik",
    "videoSensing.videoOn": "vîdyoya [ATTRIBUTE]ê ya li ser [SUBJECT]ê",
    "videoSensing.videoToggle": "vîdyoyê [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "dema ku tevgera vîdyoyê bû > [REFERENCE]",
    "wedo2.getDistance": "mesafe",
    "wedo2.getTiltAngle": "pîvana xwarbûnê [TILT_DIRECTION]",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] xwar bûye?",
    "wedo2.motorDirection.backward": "wê hêla",
    "wedo2.motorDirection.forward": "vê hêla",
    "wedo2.motorDirection.reverse": "berevajî",
    "wedo2.motorId.a": "motora A",
    "wedo2.motorId.all": "tevahiya motoran",
    "wedo2.motorId.b": "motora B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "[MOTOR_ID]ê bigire",
    "wedo2.motorOn": "[MOTOR_ID]ê veke",
    "wedo2.motorOnFor": "[MOTOR_ID]ê [DURATION] çirkeyan bixebitîne",
    "wedo2.playNoteFor": "notaya [NOTE]ê [DURATION] çirkeyan lêxe",
    "wedo2.setLightHue": "rengê ronahiyê wekî [HUE] saz bike",
    "wedo2.setMotorDirection": "berê motora [MOTOR_ID]ê bide [MOTOR_DIRECTION]ê",
    "wedo2.startMotorPower": "hêza motora [MOTOR_ID]ê bike % [POWER]",
    "wedo2.tiltDirection.any": "her çi yek",
    "wedo2.tiltDirection.down": "jêr",
    "wedo2.tiltDirection.left": "çep",
    "wedo2.tiltDirection.right": "rast",
    "wedo2.tiltDirection.up": "jor",
    "wedo2.whenDistance": "dema ku mesafe bû [OP] [REFERENCE]",
    "wedo2.whenTilted": "dema ku [TILT_DIRECTION_ANY] xwar bû",
    "paint.paintEditor.hue": "Reng",
    "paint.paintEditor.saturation": "Têrbûna Reng",
    "paint.paintEditor.brightness": "Ronahî",
    "paint.paintEditor.costume": "Kostum",
    "paint.paintEditor.group": "Kom",
    "paint.paintEditor.ungroup": "Komê belav bike",
    "paint.paintEditor.undo": "Vegerîne",
    "paint.paintEditor.redo": "Dîsa pêşve",
    "paint.paintEditor.forward": "Pêşve",
    "paint.paintEditor.backward": "Paşve",
    "paint.paintEditor.front": "Herî Pêşî",
    "paint.paintEditor.back": "Herî Paşî",
    "paint.paintEditor.more": "Zêdetir",
    "paint.modeTools.brushSize": "Mezinahî",
    "paint.modeTools.eraserSize": "Mezinahiya jêbirkê",
    "paint.modeTools.copy": "Kopî bike",
    "paint.modeTools.paste": "Bizeliqîne",
    "paint.modeTools.delete": "Jê bibe",
    "paint.modeTools.curved": "Badayî",
    "paint.modeTools.pointed": "Nîşankirî",
    "paint.modeTools.thickness": "Qalindbûn",
    "paint.modeTools.flipHorizontal": "Vexistî Bizîvirîne",
    "paint.modeTools.flipVertical": "Stûnî Bizîvirîne",
    "paint.modeTools.filled": "Tijebûyî",
    "paint.modeTools.outlined": "Kurte",
    "paint.paintEditor.bitmap": "Veguherîne Bitmapê",
    "paint.paintEditor.vector": "Veguherîne Vektorê",
    "paint.paintEditor.fill": "Tije bike",
    "paint.paintEditor.stroke": "Puxte",
    "paint.brushMode.brush": "Firçe",
    "paint.eraserMode.eraser": "Jêbirk",
    "paint.fillMode.fill": "Tije bike",
    "paint.lineMode.line": "Çixêz",
    "paint.ovalMode.oval": "Çember",
    "paint.rectMode.rect": "Çarqozî",
    "paint.reshapeMode.reshape": "Şêweyê biguherîne",
    "paint.roundedRectMode.roundedRect": "Çarqoziya Çerxkirî",
    "paint.selectMode.select": "Hilbijêre",
    "paint.textMode.text": "Nivîs",
    "paint.colorPicker.swap": "Pev Biguherîne"
  },
  "ckb": {
    "gui.alerts.lostPeripheralConnection": "سکڕاچ پەیوەندی پچڕا بە {extensionName}.",
    "gui.alerts.tryAgain": "دوبارە هەوڵدەوە",
    "gui.alerts.download": "داگرتن",
    "gui.connection.reconnect": "پێکەوەبەستنەوە",
    "gui.backpack.costumeLabel": "بەرگ",
    "gui.backpack.soundLabel": "دەنگ",
    "gui.backpack.scriptLabel": "سکریپت",
    "gui.backpack.spriteLabel": "تەن",
    "gui.backpack.header": "کۆڵەپشت",
    "gui.backpack.errorBackpack": "لە ئامادەکردنی کۆڵەپشت هەڵەڕوویدا",
    "gui.backpack.loadingBackpack": "ئامادەکردن...",
    "gui.backpack.more": "زیاتر",
    "gui.backpack.emptyBackpack": "کۆڵەپشت بەتاڵە",
    "gui.unsupportedBrowser.label": "وێبگەڕ پاڵپشتی نەکراوە",
    "gui.unsupportedBrowser.errorLabel": "هەڵەیەک ڕوویدا",
    "gui.unsupportedBrowser.notRecommended": "ئێمە زۆر بەداخەوەین، بەڵام پێدەچێت تۆ واشانی وێبگەڕێک بەکاردێنی کە سكڕاچ پاڵپشتی ناکات. پێشنیاری تازەکردنەوە بۆ نوێترین وەشانی وێبگەڕە پاڵپشتی کراوەکانی وەک Google Chrome، Mozilla Firefox, Microsoft Edge یان Apple Safari دەکەین.",
    "gui.unsupportedBrowser.description": "ئێمە زۆر بەداخەوەین، بەڵام سكڕاچ پاڵپشتی ئەم وێبگەڕە ناکات. پێشنیاری تازەکردنەوە بۆ نوێترین وەشانی وێبگەڕە پاڵپشتی کراوەکانی وەک Google Chrome، Mozilla Firefox, Microsoft Edge یان Apple Safari دەکەین.",
    "gui.unsupportedBrowser.back": "دواوە",
    "gui.unsupportedBrowser.previewfaq": "بۆ فێربوونی زیاتر، بڕۆ بۆ {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "پرسیارە دووبارەبووەکان",
    "gui.cards.all-tutorials": "فێرکارییەکان",
    "gui.cards.shrink": "وێک هاتن",
    "gui.cards.expand": "فراوان کردن",
    "gui.cards.close": "داخستن",
    "gui.cards.more-things-to-try": "شتی زیاتر بۆ تاقیکردنەوە!",
    "gui.cards.see-more": "زیاتر ببینە",
    "gui.comingSoon.message1": "نیگەران مەبە، ئێمە خەریکین {emoji}",
    "gui.comingSoon.message2": "بەم زووانە...",
    "gui.comingSoon.message3": "ئێمە کاری لەسەر دەکەین {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "هیچ ئامێرێک نەدۆزرایەوە",
    "gui.connection.auto-scanning.prescan": "ئامێرەکەت لەم نزیکانەیە، دواتر دەست بکە بە گەران.",
    "gui.connection.auto-scanning.pressbutton": "دوگمەکە داگرە لەسەر ئامێرەکەت.",
    "gui.connection.auto-scanning.start-search": "دەستپێکردنی گەڕان",
    "gui.connection.connecting-searchbutton": "گەڕان...",
    "gui.connection.auto-scanning.try-again": "دوبارە هەوڵدەوە",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "پێکەوەبەستراو",
    "gui.connection.disconnect": "پچڕانی پەیوەندی",
    "gui.connection.go-to-editor": "بڕۆ بۆ سەرنووسەر",
    "gui.connection.connecting-cancelbutton": "پێکەوەبەستن...",
    "gui.connection.error.errorMessage": "ئۆو، پێدەچێت هەڵەیەک ڕویدابێت.",
    "gui.connection.error.tryagainbutton": "دوبارە هەوڵدەوە",
    "gui.connection.error.helpbutton": "یارمەتی",
    "gui.connection.peripheral-name-label": "ناوی ئامێر",
    "gui.connection.connect": "پێکەوەبەستن",
    "gui.connection.scanning.lookingforperipherals": "گەڕان بۆ ئامێرەکان",
    "gui.connection.scanning.noPeripheralsFound": "هیچ ئامێرێک نەدۆزرایەوە",
    "gui.connection.scanning.instructions": "ئامێرەکەت لە لیستەکەی سەرەوە دیاری بکە.",
    "gui.connection.search": "تازەکردنەوە",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "دڵنیابە لەوەی کە بەستەری سکڕاچ دامەزراوە و لە جێبەجێکردندایە",
    "gui.connection.unavailable.enablebluetooth": "پشکنین بکە کە بلوتووس چالاککراوە",
    "gui.connection.unavailable.tryagainbutton": "دوبارە هەوڵدەوە",
    "gui.connection.unavailable.helpbutton": "یارمەتی",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "بڕۆ",
    "gui.controls.stop": "وەستان",
    "gui.crashMessage.label": "ئۆو! هەڵەیەک ڕوویدا.",
    "gui.crashMessage.description": "ئێمە زۆر بەداخەوەین، بەڵام پێدەچێت سکڕاچ تێکشکاوە. ئەم هەڵەیە بە خۆکارانە نێردرا بۆ تیمی سکڕاچ. تکایە پەڕەکە تازەبکەوە بۆ دوبارە هەوڵدان.",
    "gui.crashMessage.errorNumber": "هەڵەکەت تۆمارکرا بە ژمارەی {errorId}",
    "gui.crashMessage.reload": "ئامادەکردن",
    "gui.customProcedures.myblockModalTitle": "دروستکردنی بلۆکێک",
    "gui.customProcedures.addAnInputNumberText": "زیادکردنی تێخستەیەک",
    "gui.customProcedures.numberTextType": "ژمارە یان دەق",
    "gui.customProcedures.addAnInputBoolean": "زیادکردنی تێخستەیەک",
    "gui.customProcedures.booleanType": "بوولی",
    "gui.customProcedures.addALabel": "زیادکردنی ناونیشان",
    "gui.customProcedures.runWithoutScreenRefresh": "جێبەجێی بکە بەبێ نوێبوونەوەی شاشە",
    "gui.customProcedures.cancel": "پاشگەزبوونەوە",
    "gui.customProcedures.ok": "باشە",
    "gui.SpriteInfo.direction": "ئاڕاستە",
    "gui.directionPicker.rotationStyles.allAround": "بەدەوری",
    "gui.directionPicker.rotationStyles.leftRight": "چەپ/ڕاست",
    "gui.directionPicker.rotationStyles.dontRotate": "مەیسوڕێنە",
    "gui.gui.addExtension": "زیادکردنی زیادکراوە",
    "gui.gui.codeTab": "کۆد",
    "gui.gui.backdropsTab": "پاشبنه‌ماکان",
    "gui.gui.costumesTab": "بەرگەکان",
    "gui.gui.soundsTab": "دەنگەکان",
    "gui.extensionLibrary.comingSoon": "بەم زووانە",
    "gui.extensionLibrary.requires": "پێویستییەکان",
    "gui.extensionLibrary.collaboration": "هاوکاریکردن لەگەڵ",
    "gui.library.filterPlaceholder": "گەڕان",
    "gui.library.allTag": "هەموو",
    "gui.loader.message1": "دروستکردنی بلۆکەکان...",
    "gui.loader.message2": "ئامادەکردنی تەنەکان...",
    "gui.loader.message3": "ئامادەکردنی دەنگەکان...",
    "gui.loader.message4": "ئامادەکردنی زیادکراوەکان...",
    "gui.loader.message5": "شوانی پشیلەکان...",
    "gui.loader.message6": "پەخشکردنی نانۆ...",
    "gui.loader.message7": "گەورەکردنی داپۆشەر...",
    "gui.loader.message8": "ئامادەکردنی ئیمۆجیەکان...",
    "gui.loader.headline": "ئامادەکردنی پڕۆژە",
    "gui.loader.creating": "دروستکردنی پڕۆژە",
    "gui.accountMenu.profile": "پڕۆفایل",
    "gui.accountMenu.myStuff": "کەرەستەکانم",
    "gui.accountMenu.myClasses": "پۆلەکانم",
    "gui.accountMenu.myClass": "پۆلەکەم",
    "gui.accountMenu.accountSettings": "ڕێکخستنەکانی هەژمار",
    "gui.accountMenu.signOut": "دەرچوون",
    "gui.authorInfo.byUser": "لەلایەن {username}",
    "gui.menuBar.seeProjectPage": "بینینی پەڕەی پڕۆژە",
    "gui.menuBar.language": "Language",
    "general.username": "ناوی بەکارهێنەر",
    "general.password": "تێپەڕەوشە",
    "general.signIn": "چوونەژوورەوە",
    "login.needHelp": "یارمەتیت پێویستە؟",
    "form.validationRequired": "ئەم خانەیە داواکراوە",
    "gui.menuBar.tutorialsLibrary": "فێرکارییەکان",
    "gui.menuBar.restoreSprite": "گەڕاندنەوەی تەن",
    "gui.menuBar.restoreSound": "گەڕاندنەوەی دەنگ",
    "gui.menuBar.restoreCostume": "گەڕاندنەوەی بەرگ",
    "gui.menuBar.restore": "گەڕاندنەوە",
    "gui.menuBar.saveNow": "ئێستا پاشەکەوتی بکە",
    "gui.menuBar.saveAsCopy": "پاشەکەوتکردن وەک لەبەرگیراوەیەک",
    "gui.menuBar.remix": "تێکەڵاوکردنەوە",
    "gui.menuBar.new": "نوێ",
    "gui.menuBar.file": "پەڕگە",
    "gui.menuBar.downloadToComputer": "پاشەکەوتکردن لە کۆمپیوتەرەکەت",
    "gui.menuBar.edit": "دەستکاری",
    "gui.menuBar.turboModeOff": "کوژانەوەی دۆخی توربۆ",
    "gui.menuBar.turboModeOn": "هەڵکردنی دۆخی توربۆ",
    "gui.menuBar.modeMenu": "دۆخ",
    "gui.menuBar.normalMode": "دۆخی ئاسایی",
    "gui.menuBar.caturdayMode": "دۆخی کاتوردەی",
    "gui.menuBar.joinScratch": "پەیوەندی بکە بە سکڕاچ",
    "gui.menuBar.signIn": "چوونەژوورەوە",
    "gui.gui.projectTitlePlaceholder": "ناونیشانی پڕۆژە لێرە",
    "gui.menuBar.saveNowLink": "ئێستا پاشەکەوتی بکە",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "هاوبەش کراو",
    "gui.menuBar.share": "هاوبەشی کردن",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "یارمەتی",
    "gui.modal.back": "دواوە",
    "gui.monitor.listMonitor.empty": "(بەتاڵ)",
    "gui.monitor.listMonitor.listLength": "درێژی {length}",
    "gui.monitor.contextMenu.default": "پیشاندانی ئاسایی",
    "gui.monitor.contextMenu.large": "پیشاندانی گەورە",
    "gui.monitor.contextMenu.slider": "خلیسکێنەر",
    "gui.monitor.contextMenu.sliderRange": "گۆڕینی ڕادەی خلیسکێنەر",
    "gui.monitor.contextMenu.import": "هێنان",
    "gui.monitor.contextMenu.export": "ناردنەدەرەوە",
    "gui.monitor.contextMenu.hide": "شاردنەوە",
    "gui.playButton.play": "لێدان",
    "gui.playButton.stop": "وەستان",
    "gui.gui.variableScopeOptionAllSprites": "بۆ هەموو تەنەکان",
    "gui.gui.variableScopeOptionSpriteOnly": "تەنها بۆ ئەم تەنە",
    "gui.gui.cloudVariableOption": "گۆڕاوی هەور (پاشەکەوتکرا لەسەر ڕاژە)",
    "gui.gui.variablePromptAllSpritesMessage": "ئەم گۆڕاوە بەردەستە بۆ هەموو تەنەکان.",
    "gui.gui.listPromptAllSpritesMessage": "ئەم لیستە بەردەستە بۆ هەموو تەنەکان.",
    "gui.prompt.cancel": "پاشگەزبوونەوە",
    "gui.prompt.ok": "باشە",
    "gui.playbackStep.stopMsg": "وەستان",
    "gui.playbackStep.playMsg": "لێدان",
    "gui.playbackStep.loadingMsg": "ئامادەکردن...",
    "gui.playbackStep.saveMsg": "پاشەکەوتکردن",
    "gui.playbackStep.reRecordMsg": "تۆمارکردنەوە",
    "gui.recordModal.title": "تۆمارکردنی دەنگ",
    "gui.recordingStep.beginRecord": "دەستپێکردنی تۆمارکردن بە کرتەکردن لەسەر دوگمەی خوارەوە",
    "gui.recordingStep.permission": "{arrow}پێویستمان بە مۆڵەتی تۆیە بۆ بەکارهێنانی کامێڕاکەت",
    "gui.recordingStep.stop": "وەستانی تۆمارکردن",
    "gui.recordingStep.record": "تۆمارکردن",
    "gui.sliderModal.min": "نزمترین نرخ",
    "gui.sliderModal.max": "بەرزترین نرخ",
    "gui.sliderModal.title": "گۆڕینی ڕادەی خلیسکێنەر",
    "gui.sliderPrompt.cancel": "پاشگەزبوونەوە",
    "gui.sliderPrompt.ok": "باشە",
    "gui.soundEditor.sound": "دەنگ",
    "gui.soundEditor.play": "لێدان",
    "gui.soundEditor.stop": "وەستان",
    "gui.soundEditor.copy": "لەبەرگرتنەوە",
    "gui.soundEditor.paste": "لکاندن",
    "gui.soundEditor.copyToNew": "لەبەرگرتنەوە بۆ نوێ",
    "gui.soundEditor.delete": "سڕینەوە",
    "gui.soundEditor.save": "پاشەکەوتکردن",
    "gui.soundEditor.undo": "هه‌ڵوه‌شاندنه‌وه‌",
    "gui.soundEditor.redo": "کردنەوە",
    "gui.soundEditor.faster": "خێراتر",
    "gui.soundEditor.slower": "هێواشتر",
    "gui.soundEditor.echo": "دەنگ دانەوە",
    "gui.soundEditor.robot": "ڕۆبۆت",
    "gui.soundEditor.louder": "بەرزتر",
    "gui.soundEditor.softer": "نەرمتر",
    "gui.soundEditor.reverse": "پێچەوانە",
    "gui.soundEditor.fadeOut": "کاڵبوونەوە",
    "gui.soundEditor.fadeIn": "چڕبوون",
    "gui.soundEditor.mute": "بێدەنگکردن",
    "gui.SpriteInfo.spritePlaceholder": "ناو",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "تەن",
    "gui.SpriteInfo.show": "بینین",
    "gui.SpriteInfo.size": "قەبارە",
    "gui.spriteSelectorItem.contextMenuDuplicate": "هاوشێوەکردنەوە",
    "gui.spriteSelectorItem.contextMenuExport": "ناردنەدەرەوە",
    "gui.spriteSelectorItem.contextMenuDelete": "سڕینەوە",
    "gui.spriteSelector.addSpriteFromLibrary": "هەڵبژاردنی تەن",
    "gui.spriteSelector.addSpriteFromPaint": "وێنەکێشان",
    "gui.spriteSelector.addSpriteFromSurprise": "سەرسام بوون",
    "gui.spriteSelector.addSpriteFromFile": "بارکردنی تەن",
    "gui.stageHeader.stageSizeLarge": "گۆڕین بۆ سەکۆی گەورە",
    "gui.stageHeader.stageSizeSmall": "گۆڕین بۆ سەکۆی بچووک",
    "gui.stageHeader.stageSizeFull": "چوونە شێوازی پڕ بەشاشە",
    "gui.stageHeader.stageSizeUnFull": "دەرچوون لە شێوازی پڕ بەشاشە",
    "gui.stageHeader.fullscreenControl": "کۆنتڕۆڵی پڕ بەشاشە",
    "gui.spriteSelector.addBackdropFromLibrary": "هەڵبژاردنی پاشبنەمایەک",
    "gui.stageSelector.addBackdropFromPaint": "وێنەکێشان",
    "gui.stageSelector.addBackdropFromSurprise": "سەرسام بوون",
    "gui.stageSelector.addBackdropFromFile": "بارکردنی پاشبنەما",
    "gui.stageSelector.stage": "سەکۆ",
    "gui.stageSelector.backdrops": "پاشبنه‌ماکان",
    "gui.telemetryOptIn.label": "ڕاپۆرت کردنی ئامارەکان بۆ پێشخستنی سکڕاچ",
    "gui.telemetryOptIn.body1": "تیمی سكڕاچ هەردەم بە هیوان بۆ تێگەیشتنی باشتر کە چۆن سکڕاچ بەکاردێت لە هەموو دونیا. بۆ یارمەتی ئەم ئەرکە، تۆ دەتوانیت ڕێگە بدەیت سکڕاچ خۆکارانە زانیاری بەکارهاتوو بنێرێت بۆ تیمی سکڕاچ.",
    "gui.telemetryOptIn.body2": "ئەو زانیارییانەی کە ئێمە کۆی دەکەینەوە بریتین لە هەڵبژاردەی زمان، بەکارهێنانەکانی بلۆک و هەندێک کرداری وەک پاشەکەوتکردن، ئامادەکردن و بارکردنی پڕۆژەیەک. ئێمە هیچ زانیارییەکی کەسی کۆ ناکەینەوە. تکایە {privacyPolicyLink} ئێمە ببینە بۆ زانیاری زیاتر.",
    "gui.telemetryOptIn.privacyPolicyLink": "ڕێسای تایبەتمەندێتی",
    "gui.telemetryOptIn.optInText": "داتاکانی بەکارهێنانم لەگەڵ تیمی سکراچ هاوبەش بکە",
    "gui.telemetryOptIn.optInTooltip": "چالاککردنی پێوانە لە دوورەوە",
    "gui.telemetryOptIn.optOutText": "داتاکانی بەکارهێنانم لەگەڵ تیمی سکراچ هاوبەش مەکە",
    "gui.telemetryOptIn.optOutTooltip": "ناچالاککردنی پێوانە لە دوورەوە",
    "gui.telemetryOptIn.settingWasUpdated": "ڕێکخستنەکەت نوێکرایەوە.",
    "gui.telemetryOptIn.buttonClose": "داخستن",
    "gui.turboMode.active": "دۆخی توربۆ",
    "gui.webglModal.label": "وێبگەڕەکەت پاڵپشتی WebGL ناکات",
    "gui.webglModal.description": "بەداخەوە پێدەچێت وێبگەڕەکەت یان کۆمپیوتەرەکەت {webGlLink}. ئەم تەکنۆلۆجیایە پێویستە بۆ جێبەجێکردنی سکڕاچ ٣.٠.",
    "gui.webglModal.webgllink": "پاڵپشتی WebGL ناکات",
    "gui.webglModal.back": "دواوە",
    "gui.webglModal.previewfaq": "بۆ فێربوونی زیاتر، بڕۆ بۆ {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "پرسیارە دووبارەبووەکان",
    "gui.costumeLibrary.chooseABackdrop": "هەڵبژاردنی پاشبنەمایەک",
    "gui.costumeLibrary.chooseACostume": "هەڵبژاردنی بەرگێک",
    "gui.costumeTab.addBackdropFromLibrary": "هەڵبژاردنی پاشبنەمایەک",
    "gui.costumeTab.addCostumeFromLibrary": "هەڵبژاردنی بەرگێک",
    "gui.costumeTab.addBlankCostume": "وێنەکێشان",
    "gui.costumeTab.addSurpriseCostume": "سەرسام بوون",
    "gui.costumeTab.addFileBackdrop": "بارکردنی پاشبنەما",
    "gui.costumeTab.addFileCostume": "بارکردنی بەرگ",
    "gui.extensionLibrary.chooseAnExtension": "زیادکراوەیەک هەڵبژێرە",
    "gui.extensionLibrary.extensionUrl": "بەستەری زیادکراوە داخڵ بکە",
    "gui.monitors.importListColumnPrompt": "کام ستوون پێویستە بەکاربێت (1-{numberOfColumns})؟",
    "gui.recordingStep.alertMsg": "تۆمارکردن نەتوانرا دەست پێبکرێت",
    "gui.soundLibrary.chooseASound": "هەڵبژاردنی دەنگێک",
    "gui.soundTab.fileUploadSound": "بارکردنی دەنگ",
    "gui.soundTab.surpriseSound": "سەرسام بوون",
    "gui.soundTab.recordSound": "تۆمارکردن",
    "gui.soundTab.addSoundFromLibrary": "هەڵبژاردنی دەنگێک",
    "gui.spriteLibrary.chooseASprite": "هەڵبژاردنی تەنێک",
    "gui.tipsLibrary.tutorials": "فێرکارییەک هەڵبژێرە",
    "gui.alerts.createsuccess": "پڕۆژەی نوێ دروستکرا.",
    "gui.alerts.createcopysuccess": "پڕۆژە پاشەکەوتکرا وەک لەبەرگیراوەیەک.",
    "gui.alerts.createremixsuccess": "پڕۆژەکە پاشەکەوت وەک تێکەڵاوییەک.",
    "gui.alerts.creating": "دروستکردنی نوێ...",
    "gui.alerts.creatingCopy": "لەبەرگرتنەوەی پڕۆژە...",
    "gui.alerts.creatingRemix": "تێکەڵاوکردنی پڕۆژە...",
    "gui.alerts.creatingError": "پڕۆژەکە نەتوانرا دروست بکرێت. تکایە دوبارە هەوڵبدەوە!",
    "gui.alerts.savingError": "پڕۆژەکە نەتوانرا پاشەکەوت بکرێت.",
    "gui.alerts.savesuccess": "پڕۆژە پاشەکەوتکرا.",
    "gui.alerts.saving": "پڕۆژە پاشەکەوتدەکرێت...",
    "gui.alerts.cloudInfo": "تکایە بزانە، گۆڕاوەکانی هەور تەنها پاڵپشتی ژمارە دەکەن، نەک پیتەکان و هێماکان. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "زیاتر فێربە.",
    "gui.alerts.importing": "هێنان...",
    "gui.defaultProject.meow": "میاو",
    "gui.defaultProject.variable": "گۆڕاوەکەم",
    "gui.howtos.intro-move-sayhello-hat.name": "دەستپێکردن",
    "gui.howtos.intro-move.step_stepMove": "زیادکردنی بلۆکێکی جوڵاو",
    "gui.howtos.add-a-move-block.step_stepSay": "زیادکردنی بلۆکێکی بڵێ",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "کرتەی ئاڵا سەوزەکە بکە بۆ دەستپێکردن",
    "gui.howtos.intro-getting-started-ASL.name": "دەستپێکردن - زمانی ئاماژەی ئەمریکی",
    "gui.howtos.animate-a-name.name": "جوڵەپێکردنی ناوێک",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "هەڵبژاردنی تەنێکی پیتی",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "دەنگێک لێدە کاتێک کرتەکرا",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "هەڵبژاردنی تەنێکی پیتی تر",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "گۆڕینی ڕەنگ",
    "gui.howtos.animate-a-name.step_AnimateSpin": "هەڵبژاردنی تەنێکی پیتی تر و بیسوڕێنەوە",
    "gui.howtos.animate-a-name.step_AnimateGrow": "هەڵبژاردنی تەنێکی پیتی تر و گەشە بکات",
    "gui.howtos.imagine": "وێناکردنی جیهانێک",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "ئەوەی دەتەوێت بیڵێی بینووسە",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "کرتەی ئاڵا سەوزەکە بکە بۆ دەستپێکردن",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "هەر پاشبنەمایەک هەڵبژێرە",
    "gui.howtos.imagine.step_imagineChooseSprite": "هەر تەنێک هەڵبژێرە",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "تەنێکی تر هەڵبژێرە",
    "gui.howtos.imagine.step_imagineLeftRight": "بجوڵێ چەپ-ڕاست",
    "gui.howtos.imagine.step_imagineUpDown": "بجوڵێ سەرەوە-خوارەوە",
    "gui.howtos.imagine.step_imagineChangeCostumes": "گۆڕینی بەرگەکان",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "گەشەکردن و هاتنەوەیەک",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "پاشبنەمایەکی تر هەڵبژێرە",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "گۆڕینی پاشبنه‌ماکان",
    "gui.howtos.imagine.step_imagineRecordASound": "دەنگێک زیاد بکە",
    "gui.howtos.imagine.step_imagineChooseSound": "هەڵبژاردنی دەنگەکەت",
    "gui.howtos.make-music.name": "دروستکردنی میوزیک",
    "gui.howtos.Make-Music.step_PickInstrument": "هەڵبژاردنی تەنێکی ئامراز",
    "gui.howtos.Make-Music.step_PlaySoundClick": "دەنگ لێدە کاتێک کرتەکرا",
    "gui.howtos.Make-Music.step_MakeSong": "دروستکردنی گۆرانی",
    "gui.howtos.make-music.step_MakeBeat": "تەپڵێک هەڵبژێرە و لێدان دروست بکە",
    "gui.howtos.make-music.step_MakeBeatBox": "تەنی مایکڕۆفۆن و لاسایی لاناکاو هەڵبژێرە",
    "gui.howtos.story.name": "دروستکردنی چیرۆکێک",
    "gui.howtos.story.step_addbg": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.story.step_addsprite": "زیادکردنی کەسایەتییەک",
    "gui.howtos.story.step_saysomething": "شتێک بڵێ",
    "gui.howtos.story.step_addanothersprite": "زیادکردنی کەسایەتییەکی تر",
    "gui.howtos.story.step_flip": "هەڵگەڕانەوەی ئاڕاستە",
    "gui.howtos.story.step_conversation": "هەبوونی گفتوگۆیەک",
    "gui.howtos.story.addanotherbg": "زیادکردنی پاشبنەمایەکی تر",
    "gui.howtos.story.step_swithbg": "گۆڕینی پاشبنه‌ماکان",
    "gui.howtos.story.step_hidewizard": "شاردنەوەی کەسایەتییەک",
    "gui.howtos.story.step_showwizard": "پیشاندانی کەسایەتییەک",
    "gui.howtos.make-a-chase-game.name": "دروستکردنی یاری ڕاونان",
    "gui.howtos.Chase-Game.step_BG": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.chase-game.step_AddOcto": "زیادکردنی تەنێک",
    "gui.howtos.make-music.step_LeftRight": "جوڵان بۆ ڕاست و چەپ بە دوگمەی تیرەکان",
    "gui.howtos.Chase-Game.step_UpDown": "جوڵان بۆ سەروو و خواروو بە دوگمەی تیرەکان",
    "gui.howtos.Chase-Game.step_AddStar": "زیادکردنی تەنێکی تر",
    "gui.howtos.Chase-Game.step_MoveRandom": "جوڵانی هەڕەمەکی",
    "gui.howtos.Chase-Game.step_WhenTouch": "لە تەنی هەشت پەل، کاتێک بەردەکەوێت دەنگ لێدە",
    "gui.howtos.Chase-Game.step_ScoreVariable": "دروستکردنی گۆڕاوی ئەنجام",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "لە تەنی هەشت پەل، کاتێک بەردەکەوێت ئەنجام زیادبکە",
    "gui.howtos.animate-char.name": "جوڵەپێکردنی کەسایەتییەک",
    "gui.howtos.animate-char.step_addbg": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.animate-char.step_addsprite": "زیادکردنی تەنێک",
    "gui.howtos.animate-char.step_saysomething": "شتێک بڵێ",
    "gui.howtos.animate-char.step_addsound": "زیادکردنی دەنگ",
    "gui.howtos.animate-char.step_animatetalking": "جوڵەپێکردنی قسەکردن",
    "gui.howtos.animate-char.step_arrowkeys": "جوڵان بە بەکارهێنانی دوگمەی تیرەکان",
    "gui.howtos.animate-char.step_jump": "بازدان",
    "gui.howtos.animate-char.step_changecolor": "گۆڕینی ڕەنگ",
    "gui.howtos.make-a-game.name": "دروستکردنی یاری کرتەکردن",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "هەڵبژاردنی تەنێک",
    "gui.howtos.make-a-game.step_GamePlaySound": "دەنگ لێدە کاتێک کرتەکرا",
    "gui.howtos.make-a-game.step_GameAddScore": "دروستکردنی گۆڕاوی ئەنجام",
    "gui.howtos.make-a-game.step_GameChangeScore": "کاتێک کرتەکرا ئەنجام زیادبکە",
    "gui.howtos.make-a-game.step_Random": "بڕۆ بۆ شوێنێک بە هەڕەمەکی",
    "gui.howtos.make-music.step_GameChangeColor": "گۆڕینی ڕەنگ",
    "gui.howtos.make-music.step_ResetScore": "سڕینەوەی ئەنجام",
    "gui.howtos.make-it-fly.name": "ئەنجامدانی فڕین",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "هەڵبژاردنی پاشبنەمای ئاسمانی",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "هەڵبژاردنی کەسایەتییەک",
    "gui.howtos.fly.step_stepflySaySomething": "شتێک بڵێ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "پاراستنی ئەنجام",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "بەرگی دواتر",
    "gui.howtos.pong": "یاری پۆنگ",
    "gui.howtos.pong.step_pongAddBackdrop": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "سڕینەوەی ئەنجام",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "یاری کۆتاییهات",
    "gui.howtos.code-cartoon": "کارتۆنێک کۆد بکە",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "بازدان بۆ سەرەوە و خوارەوە",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "خلیسکان بەدەور",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "گۆڕینی بەرگەکان",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "جوڵەپێکردنی یارییەکی سەرکەشی",
    "gui.howtos.cartoon-network.step_CNcharacter": "هەڵبژاردنی کەسایەتییەک بۆ پیشاندان",
    "gui.howtos.cartoon-network.step_CNsay": "شتێک بڵێ",
    "gui.howtos.cartoon-network.step_CNglide": "خلیسکان بەدەور",
    "gui.howtos.cartoon-network.step_CNpicksprite": "هەڵبژاردنی تەنێک بۆ ڕاونان",
    "gui.howtos.cartoon-network.step_CNcollect": "کۆکردنەوەی تەنەکان",
    "gui.howtos.cartoon-network.step_CNvariable": "دروستکردنی گۆڕاوێکی ئەنجام",
    "gui.howtos.cartoon-network.step_CNscore": "پاراستنی ئەنجام",
    "gui.howtos.cartoon-network.step_CNbackdrop": "ئاستی بەرزتر: گۆڕینی پاشبنەما",
    "gui.howtos.videosens.name": "هەستی ڤیدیۆیی",
    "gui.howtos.videosens.step_addextension": "زیادکردنی زیادکراوە",
    "gui.howtos.videosens.step_pet": "لاواندنەوەی پشیلە",
    "gui.howtos.videosens.step_animate": "جوڵەپێکردن",
    "gui.howtos.videosens.step_pop": "تەقاندنی میزڵدان",
    "gui.howtos.say-it-out-loud": "دروستکردنی وێنەی جوڵاو کە قسە بکەن",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "زیادکردنی دەق بۆ بلۆکەکانی قسە",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "شتێک بڵێ",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "دانانی دەنگێک",
    "gui.howtos.say-it-out-loud.step_TXTMove": "جوڵان بەدەور",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "زیادکردنی کەسایەتییەکی تر",
    "gui.howtos.say-it-out-loud.step_TXTSong": "وتنی گۆرانییەک",
    "gui.howtos.say-it-out-loud.step_TXTColor": "گۆڕینی ڕەنگ",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "خولانەوە بەدەور",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "گەشەکردن و هاتنەوەیەک",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "هەڵبژاردنی تەنێک",
    "gui.howtos.talking.step_talesSaySomething": "کەسایەتییەک بە قسە بێنە",
    "gui.howtos.talking.step_talesChooseBackdrop": "هەڵبژاردنی پاشبنەمایەک",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "تەنێکی تر هەڵبژێرە",
    "gui.howtos.talking.step_talesMoveAround": "جوڵان بەدەور",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "پاشبنەمایەکی تر هەڵبژێرە",
    "gui.howtos.talking.step_talesAnimateTalking": "جوڵەپێکردنی قسەکردن",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "پاشبنەمایەکی تر هەڵبژێرە",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "زیادکردنی تەن",
    "gui.howtos.add-sprite.step_addSprite": "زیادکردنی تەن",
    "gui.howtos.add-a-backdrop.name": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "زیادکردنی پاشبنەمایەک",
    "gui.howtos.change-size.name": "گۆڕینی قەبارە",
    "gui.howtos.change-size.step_changeSize": "گۆڕینی قەبارە",
    "gui.howtos.glide-around.name": "خلیسکان بەدەور",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "خلیسکان بەدەور",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "تۆمارکردنی دەنگێک",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "کرتەی 'تۆمارکردن' بکە",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "دوگمەی تۆمارکردن داگرە",
    "gui.howtos.change-size.step_recordASoundChooseSound": "هەڵبژاردنی دەنگەکەت",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "لێدانی دەنگەکەت",
    "gui.howtos.spin-video.name": "ئەنجامدانی خولانەوە",
    "gui.howtos.change-size.step_spinTurn": "سووڕ",
    "gui.howtos.change-size.step_spinPointInDirection": "دانانی ئاڕاستە",
    "gui.howtos.hide-and-show.name": "شاردنەوە و پیشاندان",
    "gui.howtos.change-size.step_hideAndShow": "شاردنەوە و پیشاندان",
    "gui.howtos.switch-costume.name": "جوڵەپێکردنی تەنێک",
    "gui.howtos.change-size.step_switchCostumes": "جوڵەپێکردنی تەنێک",
    "gui.howtos.move-around-with-arrow-keys.name": "بەکارهێنانی دوگمەی تیرەکان",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "جوڵان بۆ چەپ و ڕاست",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "جوڵان بۆ سەرەوە و خوارەوە",
    "gui.howtos.add-effects.name": "زیادکردنی کاریگەرییەکان",
    "gui.howtos.videosens.step_addEffects": "زیادکردنی کاریگەرییەکان",
    "gui.extension.music.name": "میوزیک",
    "gui.extension.music.description": "لێدانی ئامرازەکان و تەپڵەکان.",
    "gui.extension.pen.name": "پێنووس",
    "gui.extension.pen.description": "بکێشە لەگەڵ تەنەکانت.",
    "gui.extension.videosensing.name": "هەستی ڤیدیۆیی",
    "gui.extension.videosensing.description": "هەستی جوڵان لەگەڵ کامێڕا.",
    "gui.extension.text2speech.name": "دەق بۆ قسە",
    "gui.extension.text2speech.description": "پڕۆژەکانت بە قسە بێنە.",
    "gui.extension.translate.name": "وەرگێڕان",
    "gui.extension.translate.description": "وەرگێڕانی دەق بۆ زۆر زمان.",
    "gui.extension.makeymakey.description": "هەموو شتێک بخە سەر دوگمە.",
    "gui.extension.microbit.description": "پڕۆژەکانت ببەستەوە لەگەڵ جیهان.",
    "gui.extension.microbit.connectingMessage": "پێکەوەبەستن...",
    "gui.extension.ev3.description": "ڕۆبۆتی بە کاردانەوە دروست بکە و زیاتر.",
    "gui.extension.ev3.connectingMessage": "پەیوەندیکردن. دڵنیابە کە نێرکی EV3ەکەت داناوە بە 1234.",
    "gui.extension.boost.description": "هێنانی دروستکراوی ڕۆبۆتی بۆ ژیان.",
    "gui.extension.boost.connectingMessage": "پێکەوەبەستن...",
    "gui.extension.wedo2.description": "لەگەڵ ماتۆڕ و هەستەوەرەکان دروست بکە.",
    "gui.extension.wedo2.connectingMessage": "پێکەوەبەستن...",
    "gui.extension.gdxfor.description": "هەستی پاڵنان، ڕاکێشان، جوڵان و سوڕان.",
    "gui.extension.gdxfor.connectingMessage": "پێکەوەبەستن...",
    "gui.libraryTags.all": "هەموو",
    "gui.libraryTags.animals": "ئاژەڵەکان",
    "gui.libraryTags.dance": "سەما",
    "gui.libraryTags.effects": "کاریگەرییەکان",
    "gui.libraryTags.fantasy": "خەیاڵاوی",
    "gui.libraryTags.fashion": "مۆدە",
    "gui.libraryTags.food": "خواردن",
    "gui.libraryTags.indoors": "ناوەوە",
    "gui.libraryTags.loops": "دووبارەبوونەوەکان",
    "gui.libraryTags.music": "میوزیک",
    "gui.libraryTags.notes": "تێبینییەکان",
    "gui.libraryTags.outdoors": "دەرەوە",
    "gui.libraryTags.patterns": "شێوەکان",
    "gui.libraryTags.people": "خەڵک",
    "gui.libraryTags.percussion": "ئاواز",
    "gui.libraryTags.space": "بۆشایی",
    "gui.libraryTags.sports": "یارییەکان",
    "gui.libraryTags.underwater": "لەژێر ئاو",
    "gui.libraryTags.voice": "دەنگ",
    "gui.libraryTags.wacky": "سەیر",
    "gui.libraryTags.animation": "وێنەی جوڵاو",
    "gui.libraryTags.art": "هونەر",
    "gui.libraryTags.games": "یارییەکان",
    "gui.libraryTags.stories": "چیرۆکەکان",
    "gui.libraryTags.letters": "پیتەکان",
    "gui.opcodeLabels.direction": "ئاڕاستە",
    "gui.opcodeLabels.xposition": "شوێنی x",
    "gui.opcodeLabels.yposition": "شوێنی y",
    "gui.opcodeLabels.size": "قەبارە",
    "gui.opcodeLabels.costumename": "ناوی بەرگ",
    "gui.opcodeLabels.costumenumber": "ژمارەی بەرگ",
    "gui.opcodeLabels.backdropname": "ناوی پاشبنەما",
    "gui.opcodeLabels.backdropnumber": "ژمارەی پاشبنەما",
    "gui.opcodeLabels.volume": "قەبارە",
    "gui.opcodeLabels.tempo": "خێرایی",
    "gui.opcodeLabels.answer": "وەڵام",
    "gui.opcodeLabels.loudness": "دەنگەدەنگ",
    "gui.opcodeLabels.username": "ناوی بەکارهێنەر",
    "gui.opcodeLabels.year": "ساڵ",
    "gui.opcodeLabels.month": "مانگ",
    "gui.opcodeLabels.date": "بەروار",
    "gui.opcodeLabels.dayofweek": "ڕۆژی هەفتە",
    "gui.opcodeLabels.hour": "کاتژمێر",
    "gui.opcodeLabels.minute": "خولەک",
    "gui.opcodeLabels.second": "چرکە",
    "gui.opcodeLabels.timer": "کاتێنەر",
    "gui.projectLoader.loadError": "پەڕگەی پڕۆژە کە هەڵبژێردراوە سەرکەوتوو نەبوو بۆ ئامادەکردن.",
    "gui.sharedMessages.backdrop": "پاشبنەما{index}",
    "gui.sharedMessages.costume": "بەرگ{index}",
    "gui.sharedMessages.sprite": "تەن{index}",
    "gui.sharedMessages.pop": "پۆپ",
    "gui.sharedMessages.replaceProjectWarning": "گۆڕینەوەی ناوەڕۆکی پڕۆژەی ئێستا؟",
    "gui.sharedMessages.loadFromComputerTitle": "هێنان لە کۆمپیوتەرەکەت",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "پڕۆژەی سکڕاچ",
    "boost.color.any": "هەر ڕەنگێک",
    "boost.color.black": "ڕەش",
    "boost.color.blue": "شین",
    "boost.color.green": "سەوز",
    "boost.color.red": "سور",
    "boost.color.white": "سپی",
    "boost.color.yellow": "زەرد",
    "boost.getMotorPosition": "ماتۆڕ [MOTOR_REPORTER_ID] شوێن",
    "boost.getTiltAngle": "گۆشەی لاری [TILT_DIRECTION]",
    "boost.motorDirection.backward": "بەم ڕێگەیە",
    "boost.motorDirection.forward": "بەو ڕێگەیە",
    "boost.motorDirection.reverse": "پێچەوانە",
    "boost.motorOff": "ماتۆڕی [MOTOR_ID] بکوژێنەوە",
    "boost.motorOn": "ماتۆڕی [MOTOR_ID] پێبکە",
    "boost.motorOnFor": "ماتۆڕی [MOTOR_ID] پێبکە بۆ [DURATION] چرکە",
    "boost.motorOnForRotation": "ماتۆڕی [MOTOR_ID] پێبکە بۆ [ROTATION] سوڕان",
    "boost.seeingColor": "بینینی خشتی [COLOR]؟",
    "boost.setLightHue": "دانانی ڕووناکی ڕەنگ بە [HUE]",
    "boost.setMotorDirection": "دانانی ئاڕاستەی ماتۆڕی [MOTOR_ID] بە [MOTOR_DIRECTION]",
    "boost.setMotorPower": "دانانی خێرایی ماتۆڕی [MOTOR_ID] بە [POWER] %",
    "boost.tiltDirection.any": "هەر کام",
    "boost.tiltDirection.down": "ژێرەوە",
    "boost.tiltDirection.left": "چەپ",
    "boost.tiltDirection.right": "ڕاست",
    "boost.tiltDirection.up": "سەرەوە",
    "boost.whenColor": "کاتێک خشتی [COLOR] بینرا",
    "boost.whenTilted": "کاتێک لارکرا [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "ئاماژەی بیپ [NOTE] بۆ [TIME] چرکە",
    "ev3.buttonPressed": "دوگمەی [PORT] کرتەکرا؟",
    "ev3.getBrightness": "ڕووناکی",
    "ev3.getDistance": "دووری",
    "ev3.getMotorPosition": "ماتۆڕ [PORT] شوێن",
    "ev3.motorSetPower": "ماتۆڕ [PORT] دانانی هێز [POWER] ٪",
    "ev3.motorTurnClockwise": "ماتۆڕ [PORT] ئەم ڕێگایە بگرە بۆ [TIME] چرکە",
    "ev3.motorTurnCounterClockwise": "ماتۆڕ [PORT] ئەو ڕێگایە بگرە بۆ [TIME] چرکە",
    "ev3.whenBrightnessLessThan": "کاتێک ڕووناکی < [DISTANCE]",
    "ev3.whenButtonPressed": "کاتێک دوگمەی [PORT] کرتەکرا",
    "ev3.whenDistanceLessThan": "کاتێک دووری < [DISTANCE]",
    "gdxfor.getAcceleration": "گوڕ [DIRECTION]",
    "gdxfor.getForce": "هێز",
    "gdxfor.getSpin": "خێرایی خولانەوە [DIRECTION]",
    "gdxfor.getTilt": "گۆشەی لارکردنەوە [TILT]",
    "gdxfor.isFreeFalling": "دەکەوێت؟",
    "gdxfor.isTilted": "لارکراو [TILT]؟",
    "gdxfor.pulled": "ڕاکێشراو",
    "gdxfor.pushed": "پاڵنراو",
    "gdxfor.shaken": "هەژاو",
    "gdxfor.startedFalling": "دەستی بە کەوتن کرد",
    "gdxfor.tiltDirectionMenu.any": "هەر کام",
    "gdxfor.tiltDirectionMenu.back": "دواوە",
    "gdxfor.tiltDirectionMenu.front": "پێشەوە",
    "gdxfor.tiltDirectionMenu.left": "چەپ",
    "gdxfor.tiltDirectionMenu.right": "ڕاست",
    "gdxfor.turnedFaceDown": "خوارکردنەوەی ڕوو",
    "gdxfor.turnedFaceUp": "بەرزکردنەوەی ڕوو",
    "gdxfor.whenForcePushedOrPulled": "کاتێک هەستەوەری هێز [PUSH_PULL]",
    "gdxfor.whenGesture": "کاتێک [GESTURE]",
    "gdxfor.whenTilted": "کاتێک لارکرا [TILT]",
    "makeymakey.downArrow": "تیری خواروو",
    "makeymakey.downArrowShort": "ژێرەوە",
    "makeymakey.leftArrow": "تیری چەپ",
    "makeymakey.leftArrowShort": "چەپ",
    "makeymakey.rightArrow": "تیری ڕاست",
    "makeymakey.rightArrowShort": "ڕاست",
    "makeymakey.spaceKey": "بۆشایی",
    "makeymakey.upArrow": "تیری سەروو",
    "makeymakey.upArrowShort": "سەرەوە",
    "makeymakey.whenKeyPressed": "کاتێک دوگمەی [KEY] کرتەکرا",
    "makeymakey.whenKeysPressedInOrder": "کاتێک [SEQUENCE] کرتەکرا بە ڕیزبەندی",
    "microbit.buttonsMenu.any": "هەر کام",
    "microbit.clearDisplay": "سڕینەوەی شاشە",
    "microbit.defaultTextToDisplay": "سڵاو!",
    "microbit.displaySymbol": "پیشاندانی [MATRIX]",
    "microbit.displayText": "پیشاندانی دەق [TEXT]",
    "microbit.gesturesMenu.jumped": "بازدراو",
    "microbit.gesturesMenu.moved": "جوڵاو",
    "microbit.gesturesMenu.shaken": "هەژاو",
    "microbit.isButtonPressed": "دوگمەی [BTN] کرتەکرا؟",
    "microbit.isTilted": "لارکراو [DIRECTION]؟",
    "microbit.pinStateMenu.off": "ناکارا",
    "microbit.pinStateMenu.on": "کارا",
    "microbit.tiltAngle": "گۆشەی لاری [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "هەر کام",
    "microbit.tiltDirectionMenu.back": "دواوە",
    "microbit.tiltDirectionMenu.front": "پێشەوە",
    "microbit.tiltDirectionMenu.left": "چەپ",
    "microbit.tiltDirectionMenu.right": "ڕاست",
    "microbit.whenButtonPressed": "کاتێک دوگمەی [BTN] کرتەکرا",
    "microbit.whenGesture": "کاتێک [GESTURE]",
    "microbit.whenPinConnected": "کاتێک نێرکی [PIN] بەسترابوو",
    "microbit.whenTilted": "کاتێک لارکرا [DIRECTION]",
    "music.categoryName": "میوزیک",
    "music.changeTempo": "گۆڕینی خێرایی بە [TEMPO]",
    "music.drumBass": "(2) تەپڵی دەنگ قووڵ",
    "music.drumBongo": "(13) بۆنگۆ",
    "music.drumCabasa": "(15) کاباسا",
    "music.drumClaves": "(9) کڵاڤیس",
    "music.drumClosedHiHat": "(6) داخستنی Hi-Hat",
    "music.drumConga": "(14) کۆنگا",
    "music.drumCowbell": "(11) زەنگوڵە",
    "music.drumCrashCymbal": "(4) سنج لێدان",
    "music.drumCuica": "(18) کویکا",
    "music.drumGuiro": "(16) گویڕۆ",
    "music.drumHandClap": "(8) چەپڵە لێدان",
    "music.drumOpenHiHat": "(5) کردنەوەی Hi-Hat",
    "music.drumSideStick": "داری لا",
    "music.drumSnare": "(1) تەپڵی داو",
    "music.drumTambourine": "(7) تەپل",
    "music.drumTriangle": "(12) سێگۆشە",
    "music.drumVibraslap": "(17) ڤیبراسلاپ",
    "music.drumWoodBlock": "(10) بلۆکی تەختە",
    "music.getTempo": "خێرایی",
    "music.instrumentBass": "(6) دەنگ قووڵ",
    "music.instrumentBassoon": "(14) دووزەلە",
    "music.instrumentCello": "(8) چەلۆ",
    "music.instrumentChoir": "(15) دەستەی گۆرانی",
    "music.instrumentClarinet": "(10) کلارنێت",
    "music.instrumentElectricGuitar": "(5) گیتاری ئەلیکترۆنی",
    "music.instrumentElectricPiano": "(2) پیانۆی ئەلیکترۆنی",
    "music.instrumentFlute": "(12) فلوت",
    "music.instrumentGuitar": "(4) گیتار",
    "music.instrumentMarimba": "(19) ماريمبا",
    "music.instrumentMusicBox": "(17) قوتوی میوزیک",
    "music.instrumentOrgan": "(3) ئەندام",
    "music.instrumentPiano": "(1) پیانۆ",
    "music.instrumentPizzicato": "(7) پیزەکاتۆ",
    "music.instrumentSaxophone": "(11) ساکسۆفۆن",
    "music.instrumentSteelDrum": "(18) تەپڵی ئاسن",
    "music.instrumentSynthLead": "(20) ژەنینی پێشەنگ",
    "music.instrumentSynthPad": "(21) ژەنینی ناوەندی",
    "music.instrumentTrombone": "(9) ترۆمبۆن",
    "music.instrumentVibraphone": "(16) ڤیبرافۆن",
    "music.instrumentWoodenFlute": "(13) فلوتی دار",
    "music.midiPlayDrumForBeats": "لێدانی تەپڵ [DRUM] بۆ [BEATS] لێدان",
    "music.midiSetInstrument": "دانانی ئامێر بە [INSTRUMENT]",
    "music.playDrumForBeats": "لێدانی تەپڵ [DRUM] بۆ [BEATS] لیدان",
    "music.playNoteForBeats": "لێدانی ئاماژەی [NOTE] بۆ [BEATS] لێدان",
    "music.restForBeats": "پشوو بۆ [BEATS] لێدان",
    "music.setInstrument": "دانانی ئامێر بە [INSTRUMENT]",
    "music.setTempo": "دانانی خێرایی بە [TEMPO]",
    "pen.categoryName": "پێنووس",
    "pen.changeColorParam": "گۆڕینی پێنووس [COLOR_PARAM] بە [VALUE]",
    "pen.changeHue": "گۆڕینی ڕەنگی پێنووس بە [HUE]",
    "pen.changeShade": "گۆڕینی سێبەری پێنووس بە [SHADE]",
    "pen.changeSize": "گۆڕینی قەبارەی پێنووس بە [SIZE]",
    "pen.clear": "سڕینەوەی هەموو",
    "pen.colorMenu.brightness": "ڕووناکی",
    "pen.colorMenu.color": "ڕەنگ",
    "pen.colorMenu.saturation": "تێری",
    "pen.colorMenu.transparency": "ڕۆشنایی",
    "pen.penDown": "پێنووس داگرتن",
    "pen.penUp": "پێنووس بەرزکردن",
    "pen.setColor": "دانانی ڕەنگی پێنووس بە [COLOR]",
    "pen.setColorParam": "دانانی پێنووس [COLOR_PARAM] بە [VALUE]",
    "pen.setHue": "دانانی ڕەنگی پێنووس بە [HUE]",
    "pen.setShade": "دانانی سێبەری پێنووس بە [SHADE]",
    "pen.setSize": "دانانی قەبارەی پێنووس بە [SIZE]",
    "pen.stamp": "مۆر",
    "speech.defaultWhenIHearValue": "با بڕۆین",
    "speech.extensionName": "قسە بۆ دەق",
    "speech.listenAndWait": "گوێبگرە و چاوەڕێ بکە",
    "speech.speechReporter": "وتە",
    "speech.whenIHear": "کاتێک گوێم دەبێت لە [PHRASE]",
    "text2speech.alto": "دەنگی مامناوەند",
    "text2speech.categoryName": "دەق بۆ قسە",
    "text2speech.defaultTextToSpeak": "سڵاو",
    "text2speech.giant": "زل",
    "text2speech.kitten": "بێچوه پشیله",
    "text2speech.setLanguageBlock": "دانانی زمان بە [LANGUAGE]",
    "text2speech.setVoiceBlock": "دانانی دەنگ بە [VOICE]",
    "text2speech.speakAndWaitBlock": "قسە بکە [WORDS]",
    "text2speech.squeak": "قیڕە",
    "text2speech.tenor": "دەنگی مامناوەند",
    "translate.categoryName": "وەرگێڕان",
    "translate.defaultTextToTranslate": "سڵاو",
    "translate.translateBlock": "وەرگێڕانی [WORDS] بۆ [LANGUAGE]",
    "translate.viewerLanguage": "زمان",
    "videoSensing.categoryName": "هەستی ڤیدیۆیی",
    "videoSensing.direction": "ئاڕاستە",
    "videoSensing.motion": "جوڵان",
    "videoSensing.off": "ناکارا",
    "videoSensing.on": "کارا",
    "videoSensing.onFlipped": "لە هەڵگەڕانەوە",
    "videoSensing.setVideoTransparency": "دانانی ڕۆشنایی ڤیدیۆ بە [TRANSPARENCY]",
    "videoSensing.sprite": "تەن",
    "videoSensing.stage": "سەکۆ",
    "videoSensing.videoOn": "ڤیدیۆ [ATTRIBUTE] لەسەر [SUBJECT]",
    "videoSensing.videoToggle": "ڤیدیۆ بکە بە [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "کاتێک جوڵەی ڤیدیۆ > [REFERENCE]",
    "wedo2.getDistance": "دووری",
    "wedo2.getTiltAngle": "گۆشەی لاری [TILT_DIRECTION]",
    "wedo2.isTilted": "لارکراو [TILT_DIRECTION_ANY]؟",
    "wedo2.motorDirection.backward": "بەم ڕێگەیە",
    "wedo2.motorDirection.forward": "بەو ڕێگەیە",
    "wedo2.motorDirection.reverse": "پێچەوانە",
    "wedo2.motorId.a": "ماتۆڕ A",
    "wedo2.motorId.all": "هەموو ماتۆڕەکان",
    "wedo2.motorId.b": "ماتۆڕ B",
    "wedo2.motorId.default": "ماتۆڕ",
    "wedo2.motorOff": "[MOTOR_ID] بکوژێنەوە",
    "wedo2.motorOn": "[MOTOR_ID] پێبکە",
    "wedo2.motorOnFor": "[MOTOR_ID] پێبکە بۆ [DURATION] چرکە",
    "wedo2.playNoteFor": "لێدانی ئاماژەی [NOTE] بۆ [DURATION] چرکە",
    "wedo2.setLightHue": "دانانی ڕووناکی ڕەنگ بە [HUE]",
    "wedo2.setMotorDirection": "دانانی ئاڕاستەی [MOTOR_ID] بە [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "دانانی هێزی [MOTOR_ID] بە [POWER]",
    "wedo2.tiltDirection.any": "هەر کام",
    "wedo2.tiltDirection.down": "ژێرەوە",
    "wedo2.tiltDirection.left": "چەپ",
    "wedo2.tiltDirection.right": "ڕاست",
    "wedo2.tiltDirection.up": "سەرەوە",
    "wedo2.whenDistance": "کاتێک دووری [OP] [REFERENCE]",
    "wedo2.whenTilted": "کاتێک لارکرا [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "ڕەنگ",
    "paint.paintEditor.saturation": "تێری",
    "paint.paintEditor.brightness": "ڕووناکی",
    "paint.paintEditor.costume": "بەرگ",
    "paint.paintEditor.group": "گروپ کردن",
    "paint.paintEditor.ungroup": "نا گروپ کردن",
    "paint.paintEditor.undo": "هه‌ڵوه‌شاندنه‌وه‌",
    "paint.paintEditor.redo": "کردنەوە",
    "paint.paintEditor.forward": "بۆ پێشەوە",
    "paint.paintEditor.backward": "بۆ دواوە",
    "paint.paintEditor.front": "پێشەوە",
    "paint.paintEditor.back": "دواوە",
    "paint.paintEditor.more": "زیاتر",
    "paint.modeTools.brushSize": "قەبارە",
    "paint.modeTools.eraserSize": "قەبارەی سڕەوە",
    "paint.modeTools.copy": "لەبەرگرتنەوە",
    "paint.modeTools.paste": "لکاندن",
    "paint.modeTools.delete": "سڕینەوە",
    "paint.modeTools.curved": "چەماوە",
    "paint.modeTools.pointed": "ئاماژە بۆکراو",
    "paint.modeTools.thickness": "ئەستوورایی",
    "paint.modeTools.flipHorizontal": "هەڵگەڕانەوەی ئاسۆیی",
    "paint.modeTools.flipVertical": "هەڵگەڕانەوەی ستوونی",
    "paint.modeTools.filled": "پڕکراوە",
    "paint.modeTools.outlined": "چوارچێوەکراو",
    "paint.paintEditor.bitmap": "گۆڕینی بۆ Bitmap",
    "paint.paintEditor.vector": "گۆڕینی بۆ Vector",
    "paint.paintEditor.fill": "پڕکردنەوە",
    "paint.paintEditor.stroke": "چوارچێوە",
    "paint.brushMode.brush": "فڵچە",
    "paint.eraserMode.eraser": "سڕەوە",
    "paint.fillMode.fill": "پڕکردنەوە",
    "paint.lineMode.line": "هێڵ",
    "paint.ovalMode.oval": "بازنە",
    "paint.rectMode.rect": "لاکێشە",
    "paint.reshapeMode.reshape": "شێوەکردنەوە",
    "paint.roundedRectMode.roundedRect": "لاکێشەی خڕ",
    "paint.selectMode.select": "دیاریکردن",
    "paint.textMode.text": "دەق",
    "paint.colorPicker.swap": "ئاڵوگۆڕ"
  },
  "lv": {
    "gui.alerts.lostPeripheralConnection": "Scratch zaudēja savienojumu ar {extensionName}.",
    "gui.alerts.tryAgain": "Mēģini vēlreiz",
    "gui.alerts.download": "Lejupielādēt",
    "gui.connection.reconnect": "Savienot vēlreiz",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Mugursoma",
    "gui.backpack.errorBackpack": "Kļūda ielādējot mugursomu",
    "gui.backpack.loadingBackpack": "Ielādē ...",
    "gui.backpack.more": "Vairāk",
    "gui.backpack.emptyBackpack": "Mugursoma tukša",
    "gui.unsupportedBrowser.label": "Pārlūks netiek atbalstīts",
    "gui.unsupportedBrowser.errorLabel": "Radās kļūda",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Atpakaļ",
    "gui.unsupportedBrowser.previewfaq": "Lai uzzinātu vairāk, dodies uz {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "BUJ",
    "gui.cards.all-tutorials": "Apmācības",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Aizvērt",
    "gui.cards.more-things-to-try": "Izmēģināt citas lietas!",
    "gui.cards.see-more": "Skatīt vairāk",
    "gui.comingSoon.message1": "Neuztraucies, mēs pie tā strādājam {emoji}",
    "gui.comingSoon.message2": "Drīzumā...",
    "gui.comingSoon.message3": "Mēs pie tā strādājam {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nav atrasta neviena ierīce",
    "gui.connection.auto-scanning.prescan": "Pārliecinies, ka ierīce ir tuvumā, tad sāc meklēšanu.",
    "gui.connection.auto-scanning.pressbutton": "Spied pogu uz savas ierīces.",
    "gui.connection.auto-scanning.start-search": "Sākt meklēšanu",
    "gui.connection.connecting-searchbutton": "Meklē...",
    "gui.connection.auto-scanning.try-again": "Mēģināt vēlreiz",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Savienots",
    "gui.connection.disconnect": "Atvienot",
    "gui.connection.go-to-editor": "Doties uz redaktoru",
    "gui.connection.connecting-cancelbutton": "Savienojas...",
    "gui.connection.error.errorMessage": "Kaut kas nogāja greizi...",
    "gui.connection.error.tryagainbutton": "Mēģināt vēlreiz",
    "gui.connection.error.helpbutton": "Palīdzība",
    "gui.connection.peripheral-name-label": "Ierīces nosaukums",
    "gui.connection.connect": "Savienot",
    "gui.connection.scanning.lookingforperipherals": "Meklē ierīces",
    "gui.connection.scanning.noPeripheralsFound": "Nav atrasta neviena ierīce",
    "gui.connection.scanning.instructions": "Izvēlies ierīci augšējā sarakstā.",
    "gui.connection.search": "Atsvaidzināt",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Pārliecinies, ka Scratch Link ir instalēts un darbojas",
    "gui.connection.unavailable.enablebluetooth": "Pārliecinies, ka Bluetooth ir iespējots",
    "gui.connection.unavailable.tryagainbutton": "Mēģināt vēlreiz",
    "gui.connection.unavailable.helpbutton": "Palīdzība",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Palaist",
    "gui.controls.stop": "Apturēt",
    "gui.crashMessage.label": "Kaut kas nogāja greizi...",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Jūsu kļūda tika reģistrēta ar id {errorId}",
    "gui.crashMessage.reload": "Pārlādēt",
    "gui.customProcedures.myblockModalTitle": "Izveidot bloku",
    "gui.customProcedures.addAnInputNumberText": "Pievienot ievadi",
    "gui.customProcedures.numberTextType": "skaitlis vai teksts",
    "gui.customProcedures.addAnInputBoolean": "Pievienot ievadi",
    "gui.customProcedures.booleanType": "loģiskais lauks - jā/nē",
    "gui.customProcedures.addALabel": "Pievienot etiķeti",
    "gui.customProcedures.runWithoutScreenRefresh": "Palaist bez ekrāna atsvaidzināšanas",
    "gui.customProcedures.cancel": "Atcelt",
    "gui.customProcedures.ok": "Labi",
    "gui.SpriteInfo.direction": "Virziens",
    "gui.directionPicker.rotationStyles.allAround": "Jebkurā virzienā",
    "gui.directionPicker.rotationStyles.leftRight": "Pa labi/Pa kreisi",
    "gui.directionPicker.rotationStyles.dontRotate": "Nerotēt",
    "gui.gui.addExtension": "Pievienot paplašinājumu",
    "gui.gui.codeTab": "Kods",
    "gui.gui.backdropsTab": "Foni",
    "gui.gui.costumesTab": "Tērpi",
    "gui.gui.soundsTab": "Skaņas",
    "gui.extensionLibrary.comingSoon": "Drīzumā",
    "gui.extensionLibrary.requires": "Nepieciešams",
    "gui.extensionLibrary.collaboration": "Sadarbībā ar",
    "gui.library.filterPlaceholder": "Meklēt",
    "gui.library.allTag": "Viss",
    "gui.loader.message1": "Veido blokus...",
    "gui.loader.message2": "Ielādē gariņus ...",
    "gui.loader.message3": "Ielādē skaņas ...",
    "gui.loader.message4": "Ielādē paplašinājumus ...",
    "gui.loader.message5": "Sauc palīgā kaķus, lai ielādētu šo projektu ...",
    "gui.loader.message6": "Pārsūta nano ...",
    "gui.loader.message7": "Iefliltrē gobo ...",
    "gui.loader.message8": "Sagatavo emocijzīmes ...",
    "gui.loader.headline": "Ielādē projektu",
    "gui.loader.creating": "Veido projektu",
    "gui.accountMenu.profile": "Profils",
    "gui.accountMenu.myStuff": "Manas lietas",
    "gui.accountMenu.myClasses": "Manas klases",
    "gui.accountMenu.myClass": "Manas klase",
    "gui.accountMenu.accountSettings": "Konta iestatījumi",
    "gui.accountMenu.signOut": "Iziet",
    "gui.authorInfo.byUser": "autors {username}",
    "gui.menuBar.seeProjectPage": "Skatīt projekta lapu",
    "gui.menuBar.language": "Language",
    "general.username": "Lietotājvārds",
    "general.password": "Parole",
    "general.signIn": "Ienākt",
    "login.needHelp": "Nepieciešama palīdzība?",
    "form.validationRequired": "Šis lauks ir obligāts",
    "gui.menuBar.tutorialsLibrary": "Apmācības",
    "gui.menuBar.restoreSprite": "Atjaunot gariņu",
    "gui.menuBar.restoreSound": "Atjaunot skaņu",
    "gui.menuBar.restoreCostume": "Atjaunot tērpu",
    "gui.menuBar.restore": "Atjaunot",
    "gui.menuBar.saveNow": "Saglabāt tagad",
    "gui.menuBar.saveAsCopy": "Saglabāt kā kopiju",
    "gui.menuBar.remix": "Remikss",
    "gui.menuBar.new": "Jauns",
    "gui.menuBar.file": "Fails",
    "gui.menuBar.downloadToComputer": "Saglabāt šajā datorā",
    "gui.menuBar.edit": "Rediģēt",
    "gui.menuBar.turboModeOff": "Izslēgt turbo režīmu",
    "gui.menuBar.turboModeOn": "Ieslēgt turbo režīmu",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Pievienojies Scratch",
    "gui.menuBar.signIn": "Ienākt",
    "gui.gui.projectTitlePlaceholder": "Projekta virsraksts",
    "gui.menuBar.saveNowLink": "Saglabāt tagad",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Kopīgotie",
    "gui.menuBar.share": "Kopīgot",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Palīdzība",
    "gui.modal.back": "Atpakaļ",
    "gui.monitor.listMonitor.empty": "(tukšs)",
    "gui.monitor.listMonitor.listLength": "garums {length}",
    "gui.monitor.contextMenu.default": "normāls rādījums",
    "gui.monitor.contextMenu.large": "liels rādījums",
    "gui.monitor.contextMenu.slider": "slīdnis",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "importēt",
    "gui.monitor.contextMenu.export": "eksportēt",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Visiem gariņiem",
    "gui.gui.variableScopeOptionSpriteOnly": "Tikai šim gariņam",
    "gui.gui.cloudVariableOption": "Mākoņmainīgais (saglabāts serverī)",
    "gui.gui.variablePromptAllSpritesMessage": "Šis mainīgais būs pieejams visiem gariņiem.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Atcelt",
    "gui.prompt.ok": "Labi",
    "gui.playbackStep.stopMsg": "Apturēt",
    "gui.playbackStep.playMsg": "Atskaņot",
    "gui.playbackStep.loadingMsg": "Ielādē ...",
    "gui.playbackStep.saveMsg": "Saglabāt",
    "gui.playbackStep.reRecordMsg": "Atkārtoti ierakstīt",
    "gui.recordModal.title": "Ierakstīt skaņu",
    "gui.recordingStep.beginRecord": "Sāc ierakstīšanu, spiežot pogu zemāk",
    "gui.recordingStep.permission": "{arrow}Mums nepieciešama tava atļauja, lai izmantotu mikrofonu",
    "gui.recordingStep.stop": "Beigt ierakstīšanu",
    "gui.recordingStep.record": "Ierakstīt",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Skaņa",
    "gui.soundEditor.play": "Atskaņot",
    "gui.soundEditor.stop": "Apturēt",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Saglabāt",
    "gui.soundEditor.undo": "Atsaukt",
    "gui.soundEditor.redo": "Atcelt atsaukšanu",
    "gui.soundEditor.faster": "Ātrāk",
    "gui.soundEditor.slower": "Lēnāk",
    "gui.soundEditor.echo": "Atbalss",
    "gui.soundEditor.robot": "Robots",
    "gui.soundEditor.louder": "Skaļāk",
    "gui.soundEditor.softer": "Klusāk",
    "gui.soundEditor.reverse": "Atpakaļgaitā",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Nosaukums",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Gariņš",
    "gui.SpriteInfo.show": "Rādīt",
    "gui.SpriteInfo.size": "Izmērs",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dublēt",
    "gui.spriteSelectorItem.contextMenuExport": "eksportēt",
    "gui.spriteSelectorItem.contextMenuDelete": "dzēst",
    "gui.spriteSelector.addSpriteFromLibrary": "Izvēlēties gariņu",
    "gui.spriteSelector.addSpriteFromPaint": "Zīmēt",
    "gui.spriteSelector.addSpriteFromSurprise": "Pārsteigums",
    "gui.spriteSelector.addSpriteFromFile": "Augšupielādēt gariņu",
    "gui.stageHeader.stageSizeLarge": "Pārslēgties uz lielu skatuvi",
    "gui.stageHeader.stageSizeSmall": "Pārslēgties uz mazu skatuvi",
    "gui.stageHeader.stageSizeFull": "Ieiet pilnekrāna režīmā",
    "gui.stageHeader.stageSizeUnFull": "Iziet no pilnekrāna režīma",
    "gui.stageHeader.fullscreenControl": "Pilnekrāna kontrole",
    "gui.spriteSelector.addBackdropFromLibrary": "Izvēlēties Fonu",
    "gui.stageSelector.addBackdropFromPaint": "Zīmēt",
    "gui.stageSelector.addBackdropFromSurprise": "Pārsteigums",
    "gui.stageSelector.addBackdropFromFile": "Augšupielādēt fonu",
    "gui.stageSelector.stage": "Skatuve",
    "gui.stageSelector.backdrops": "Foni",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privātuma politika",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo režīms",
    "gui.webglModal.label": "Tavs Pārlūks Neatbalsta WebGL",
    "gui.webglModal.description": "Diemžēl izskatās, ka tavs pārlūks vai dators  {webGlLink}. Šī tehnoloģija nepieciešama Scratch 3.0, lai darbotos.",
    "gui.webglModal.webgllink": "neatbalsta WebGL",
    "gui.webglModal.back": "Atpakaļ",
    "gui.webglModal.previewfaq": "Lai uzzinātu vairāk, dodies uz {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "BUJ",
    "gui.costumeLibrary.chooseABackdrop": "Izvēlēties Fonu",
    "gui.costumeLibrary.chooseACostume": "Izvēlēties tērpu",
    "gui.costumeTab.addBackdropFromLibrary": "Izvēlēties Fonu",
    "gui.costumeTab.addCostumeFromLibrary": "Izvēlēties tērpu",
    "gui.costumeTab.addBlankCostume": "Zīmēt",
    "gui.costumeTab.addSurpriseCostume": "Pārsteigums",
    "gui.costumeTab.addFileBackdrop": "Augšupielādēt fonu",
    "gui.costumeTab.addFileCostume": "Augšupielādēt tērpu",
    "gui.extensionLibrary.chooseAnExtension": "Izvēlēties paplašinājumu",
    "gui.extensionLibrary.extensionUrl": "Ievadīt URL paplašinājumam",
    "gui.monitors.importListColumnPrompt": "Kura kolonna jāizmanto (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nevar sākt ierakstīšanu",
    "gui.soundLibrary.chooseASound": "Izvēlēties skaņu",
    "gui.soundTab.fileUploadSound": "Augšupielādēt skaņu",
    "gui.soundTab.surpriseSound": "Pārsteigums",
    "gui.soundTab.recordSound": "Ierakstīt",
    "gui.soundTab.addSoundFromLibrary": "Izvēlēties skaņu",
    "gui.spriteLibrary.chooseASprite": "Izvēlēties gariņu",
    "gui.tipsLibrary.tutorials": "Izvēlēties apmācību",
    "gui.alerts.createsuccess": "Jauns projekts izveidots.",
    "gui.alerts.createcopysuccess": "Projekts saglabāts kā kopija.",
    "gui.alerts.createremixsuccess": "Projekts saglabāts kā remikss.",
    "gui.alerts.creating": "Veido jaunu...",
    "gui.alerts.creatingCopy": "Kopē projektu...",
    "gui.alerts.creatingRemix": "Remiksē projektu...",
    "gui.alerts.creatingError": "Nevar izveidot projektu. Mēģini vēlreiz!",
    "gui.alerts.savingError": "Projektu nevar saglabāt.",
    "gui.alerts.savesuccess": "Projekts saglabāts.",
    "gui.alerts.saving": "Saglabā projektu...",
    "gui.alerts.cloudInfo": "Lūdzu ievērojiet, ka mākoņmainīgie atbalsta tikai ciparus, nevis burtus vai simbolus. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Uzzināt vairāk.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Ņau",
    "gui.defaultProject.variable": "mans mainīgais",
    "gui.howtos.intro-move-sayhello-hat.name": "Getting Started",
    "gui.howtos.intro-move.step_stepMove": "Pievieno pārvietošanas bloku",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animē vārdu",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Izvēlies burta gariņu",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Atskaņo skaņu kad noklikšķināts",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Izvēlies citu burta gariņu",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Maini krāsu",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Izvēlies citu burta gariņu un liec tam griezties",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Izvēlies citu burta gariņu un liec tam augt",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Veido mūziku",
    "gui.howtos.Make-Music.step_PickInstrument": "Izvēlies instrumenta gariņu",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Atskaņo skaņu kad noklikšķināts",
    "gui.howtos.Make-Music.step_MakeSong": "Izveido dziesmu",
    "gui.howtos.make-music.step_MakeBeat": "Izvēlies bungas un izveido ritmu",
    "gui.howtos.make-music.step_MakeBeatBox": "Izvēlies mikrofona gariņu un pārsteiguma bītboksu",
    "gui.howtos.story.name": "Izveido stāstu",
    "gui.howtos.story.step_addbg": "Pievieno fonu",
    "gui.howtos.story.step_addsprite": "Pievieno personāžu",
    "gui.howtos.story.step_saysomething": "Saki kaut ko",
    "gui.howtos.story.step_addanothersprite": "Pievieno citu personāžu",
    "gui.howtos.story.step_flip": "Maini virzienu",
    "gui.howtos.story.step_conversation": "Sarunājies",
    "gui.howtos.story.addanotherbg": "Pievieno citu fonu",
    "gui.howtos.story.step_swithbg": "Maini fonus",
    "gui.howtos.story.step_hidewizard": "Slēp personāžu",
    "gui.howtos.story.step_showwizard": "Parādi personāžu",
    "gui.howtos.make-a-chase-game.name": "Izveido pakaļdzīšanās spēli",
    "gui.howtos.Chase-Game.step_BG": "Pievieno fonu",
    "gui.howtos.chase-game.step_AddOcto": "Pievieno gariņu",
    "gui.howtos.make-music.step_LeftRight": "Pārvietojies pa labi un pa kreisi ar bulttaustiņiem",
    "gui.howtos.Chase-Game.step_UpDown": "Pārvietojies uz augšu un uz leju ar bulttaustiņiem",
    "gui.howtos.Chase-Game.step_AddStar": "Pievieno citu gariņu",
    "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
    "gui.howtos.Chase-Game.step_WhenTouch": "In Octopus Sprite, When Touching Play Sound",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Create Score Variable",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Astoņkāja gariņā, kad tam pieskaras, pieskaiti punktu",
    "gui.howtos.animate-char.name": "Animē personāžu",
    "gui.howtos.animate-char.step_addbg": "Pievieno fonu",
    "gui.howtos.animate-char.step_addsprite": "Pievieno gariņu",
    "gui.howtos.animate-char.step_saysomething": "Saki kaut ko",
    "gui.howtos.animate-char.step_addsound": "Pievieno skaņu",
    "gui.howtos.animate-char.step_animatetalking": "Animē runāšanu",
    "gui.howtos.animate-char.step_arrowkeys": "Pārvietojies izmantojot bulttaustiņus",
    "gui.howtos.animate-char.step_jump": "Lec",
    "gui.howtos.animate-char.step_changecolor": "Maini krāsu",
    "gui.howtos.make-a-game.name": "Izveido klikšķināšanas spēli",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Izvēlies gariņu",
    "gui.howtos.make-a-game.step_GamePlaySound": "Atskaņo skaņu kad noklikšķināts",
    "gui.howtos.make-a-game.step_GameAddScore": "Create Score Variable",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kad noklikšķināts, palielini punktu skaitu",
    "gui.howtos.make-a-game.step_Random": "Dodies uz nejaušu pozīciju",
    "gui.howtos.make-music.step_GameChangeColor": "Maini krāsu",
    "gui.howtos.make-music.step_ResetScore": "Atiestati rezultāta punktus",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Izveido animētu piedzīvojumu spēli",
    "gui.howtos.cartoon-network.step_CNcharacter": "Izvēlies personāžu",
    "gui.howtos.cartoon-network.step_CNsay": "Saki kaut ko",
    "gui.howtos.cartoon-network.step_CNglide": "Slidini visapkārt",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Izvēlies objektu, kurš tiks ķerts",
    "gui.howtos.cartoon-network.step_CNcollect": "Krāj objektus",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Paturi rezultātu",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video uztveršana",
    "gui.howtos.videosens.step_addextension": "Pievieno paplašinājumu",
    "gui.howtos.videosens.step_pet": "Paglaudi kaķi",
    "gui.howtos.videosens.step_animate": "Animē",
    "gui.howtos.videosens.step_pop": "Uzspridzini balonu",
    "gui.howtos.say-it-out-loud": "Izveido animācijas, kuras runā",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Iestati balsi",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Pārvietojies visapkārt",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Pievieno fonu",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Pievieno citu personāžu",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Izpildi dziesmu",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Maini krāsu",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Griezies apkārt",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Audz un saraujies",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Pievieno gariņu",
    "gui.howtos.add-sprite.step_addSprite": "Pievieno gariņu",
    "gui.howtos.add-a-backdrop.name": "Pievieno fonu",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Maini izmēru",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Slidini visapkārt",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Ieraksti skaņu",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Liec tam griezties",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Slēp un parādi",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animē gariņu",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Izmanto bulttaustiņus",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Pievieno efektus",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Mūzika",
    "gui.extension.music.description": "Spēlē instrumentus un bungas.",
    "gui.extension.pen.name": "Zīmulis",
    "gui.extension.pen.description": "Zīmē ar saviem gariņiem.",
    "gui.extension.videosensing.name": "Video uztveršana",
    "gui.extension.videosensing.description": "Uztver kustības ar kameru.",
    "gui.extension.text2speech.name": "Teksta pārvēršana runā",
    "gui.extension.text2speech.description": "Liec saviem projektiem runāt.",
    "gui.extension.translate.name": "Tulkot",
    "gui.extension.translate.description": "Pārtulko tekstu vairākās valodās.",
    "gui.extension.makeymakey.description": "Pārveido jebkuru lietu par taustiņu.",
    "gui.extension.microbit.description": "Savieno savus projektus ar pasauli.",
    "gui.extension.microbit.connectingMessage": "Savienojas",
    "gui.extension.ev3.description": "Būvē interaktīvus robotus un daudz ko citu.",
    "gui.extension.ev3.connectingMessage": "Savienojas. Pārliecinies, ka tava EV3 pin kods ir 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Būvēt ar motoriem un sensoriem.",
    "gui.extension.wedo2.connectingMessage": "Savienojas",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Viss",
    "gui.libraryTags.animals": "Dzīvnieki",
    "gui.libraryTags.dance": "Dejas",
    "gui.libraryTags.effects": "Efekti",
    "gui.libraryTags.fantasy": "Fantāzija",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Ēdiens",
    "gui.libraryTags.indoors": "Iekštelpas",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Mūzika",
    "gui.libraryTags.notes": "Notis",
    "gui.libraryTags.outdoors": "Brīvā daba",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "Cilvēki",
    "gui.libraryTags.percussion": "Perkusijas",
    "gui.libraryTags.space": "Kosmoss",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Zemūdens",
    "gui.libraryTags.voice": "Balss",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animācijas",
    "gui.libraryTags.art": "Māksla",
    "gui.libraryTags.games": "Spēles",
    "gui.libraryTags.stories": "Stāsti",
    "gui.libraryTags.letters": "Burti",
    "gui.opcodeLabels.direction": "virziens",
    "gui.opcodeLabels.xposition": "x pozīcija",
    "gui.opcodeLabels.yposition": "y pozīcija",
    "gui.opcodeLabels.size": "izmērs",
    "gui.opcodeLabels.costumename": "tērpa nosaukums",
    "gui.opcodeLabels.costumenumber": "tērpa numurs",
    "gui.opcodeLabels.backdropname": "fona nosaukums",
    "gui.opcodeLabels.backdropnumber": "fona numurs",
    "gui.opcodeLabels.volume": "skaļums",
    "gui.opcodeLabels.tempo": "temps",
    "gui.opcodeLabels.answer": "atbilde",
    "gui.opcodeLabels.loudness": "skaļums",
    "gui.opcodeLabels.username": "lietotājvārds",
    "gui.opcodeLabels.year": "gads",
    "gui.opcodeLabels.month": "mēnesis",
    "gui.opcodeLabels.date": "datums",
    "gui.opcodeLabels.dayofweek": "nedēļas diena",
    "gui.opcodeLabels.hour": "stunda",
    "gui.opcodeLabels.minute": "minūte",
    "gui.opcodeLabels.second": "sekunde",
    "gui.opcodeLabels.timer": "taimeris",
    "gui.projectLoader.loadError": "Neizdevās ielādēt izvēlēto projekta failu.",
    "gui.sharedMessages.backdrop": "fons{index}",
    "gui.sharedMessages.costume": "tērps{index}",
    "gui.sharedMessages.sprite": "Gariņš{index}",
    "gui.sharedMessages.pop": "paukšķis",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch projekts",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "pīkstināt noti [NOTE] [TIME] sekundes",
    "ev3.buttonPressed": "poga [PORT] piespiesta?",
    "ev3.getBrightness": "gaišums",
    "ev3.getDistance": "attālums",
    "ev3.getMotorPosition": "motora [PORT] pozīcija",
    "ev3.motorSetPower": "motoram [PORT] iestatīt enerģiju uz [POWER] %",
    "ev3.motorTurnClockwise": "motoru [PORT] pagriezt šajā virzienā [TIME] sekundes",
    "ev3.motorTurnCounterClockwise": "motoru [PORT] pagriezt tajā virzienā [TIME] sekundes",
    "ev3.whenBrightnessLessThan": "kad gaišums < [DISTANCE]",
    "ev3.whenButtonPressed": "kad poga [PORT] piespiesta",
    "ev3.whenDistanceLessThan": "kad attālums < [DISTANCE]",
    "gdxfor.getAcceleration": "paātrinājums [DIRECTION]",
    "gdxfor.getForce": "spēks",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "lejuptaustiņš",
    "makeymakey.downArrowShort": "uz leju",
    "makeymakey.leftArrow": "kreisais bulttaustiņš",
    "makeymakey.leftArrowShort": "pa kreisi",
    "makeymakey.rightArrow": "labais bulttaustiņš",
    "makeymakey.rightArrowShort": "pa labi",
    "makeymakey.spaceKey": "atstarpe",
    "makeymakey.upArrow": "augšuptaustiņš",
    "makeymakey.upArrowShort": "uz augšu",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "jebkāds",
    "microbit.clearDisplay": "notīrīt ekrānu",
    "microbit.defaultTextToDisplay": "Sveiki!",
    "microbit.displaySymbol": "rādīt [MATRIX]",
    "microbit.displayText": "rādīt tekstu [TEXT]",
    "microbit.gesturesMenu.jumped": "palēcās",
    "microbit.gesturesMenu.moved": "pārvietojās",
    "microbit.gesturesMenu.shaken": "pakratījās",
    "microbit.isButtonPressed": "[BTN] poga piespiesta?",
    "microbit.isTilted": "noliekts [DIRECTION]?",
    "microbit.pinStateMenu.off": "izslēgts",
    "microbit.pinStateMenu.on": "ieslēgts",
    "microbit.tiltAngle": "noliekt leņķī [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "jebkur",
    "microbit.tiltDirectionMenu.back": "uz aizmuguri",
    "microbit.tiltDirectionMenu.front": "uz priekšu",
    "microbit.tiltDirectionMenu.left": "pa kreisi",
    "microbit.tiltDirectionMenu.right": "pa labi",
    "microbit.whenButtonPressed": "kad poga [BTN] piespiesta",
    "microbit.whenGesture": "kad [GESTURE]",
    "microbit.whenPinConnected": "kad spraudnis [PIN] savienots",
    "microbit.whenTilted": "kad noliekts [DIRECTION]",
    "music.categoryName": "Mūzika",
    "music.changeTempo": "mainīt tempu par [TEMPO]",
    "music.drumBass": "(2) Basa bungas",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Klaves",
    "music.drumClosedHiHat": "(6) Slēgtais Hi-Hat šķīvis",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Zvans",
    "music.drumCrashCymbal": "(4) Crash šķīvji",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Roku plaukšķis",
    "music.drumOpenHiHat": "(5) Atvērts Hi-Hat šķīvis",
    "music.drumSideStick": "(3) Bungu malas piesitiens",
    "music.drumSnare": "(1) Solo bungas",
    "music.drumTambourine": "(7) Tamburīns",
    "music.drumTriangle": "(12) Trijstūris",
    "music.drumVibraslap": "(17) Vibra slaperis",
    "music.drumWoodBlock": "(10) Koka bloks",
    "music.getTempo": "temps",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fagots",
    "music.instrumentCello": "(8) Čells",
    "music.instrumentChoir": "(15) Koris",
    "music.instrumentClarinet": "(10) Klarnete",
    "music.instrumentElectricGuitar": "(5) Elektriskā ģitāra",
    "music.instrumentElectricPiano": "(2) Elektriskās klavieres",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Ģitāra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Mūzikas lādīte",
    "music.instrumentOrgan": "(3) Ērģeles",
    "music.instrumentPiano": "(1)  Klavieres",
    "music.instrumentPizzicato": "(7) Pičkato",
    "music.instrumentSaxophone": "(11) Saksofons",
    "music.instrumentSteelDrum": "(18) Metāla bungas",
    "music.instrumentSynthLead": "(20) Galvenais sintezators",
    "music.instrumentSynthPad": "(21) Pavadošais sintezators",
    "music.instrumentTrombone": "(9) Trombons",
    "music.instrumentVibraphone": "(16) Ksilofons",
    "music.instrumentWoodenFlute": "(13) Koka flauta",
    "music.midiPlayDrumForBeats": "spēlēt bungas [DRUM] [BEATS] sitienus",
    "music.midiSetInstrument": "iestatīt instrumentu uz [INSTRUMENT]",
    "music.playDrumForBeats": "spēlēt bungas [DRUM] [BEATS] sitienus",
    "music.playNoteForBeats": "spēlēt noti [NOTE] [BEATS] sitienus",
    "music.restForBeats": "pauze [BEATS] sitienus",
    "music.setInstrument": "iestatīt instrumentu uz [INSTRUMENT]",
    "music.setTempo": "iestatīt tempu uz [TEMPO]",
    "pen.categoryName": "Zīmulis",
    "pen.changeColorParam": "mainīt zīmuļa [COLOR_PARAM] par [VALUE]",
    "pen.changeHue": "mainīt zīmuļa krāsu par [HUE]",
    "pen.changeShade": "mainīt zīmuļa tumšumu par [SHADE]",
    "pen.changeSize": "mainīt zīmuļa izmēru par [SIZE]",
    "pen.clear": "notīrīt visu",
    "pen.colorMenu.brightness": "gaišums",
    "pen.colorMenu.color": "krāsa",
    "pen.colorMenu.saturation": "piesātinājums",
    "pen.colorMenu.transparency": "caurspīdīgums",
    "pen.penDown": "zīmulis piespiests",
    "pen.penUp": "zīmulis pacelts",
    "pen.setColor": "iestatīt zīmuļa krāsu uz [COLOR]",
    "pen.setColorParam": "iestatīt zīmuļa [COLOR_PARAM] uz [VALUE]",
    "pen.setHue": "iestatīt zīmuļa krāsu uz [HUE]",
    "pen.setShade": "iestatīt zīmuļa tumšumu uz [SHADE]",
    "pen.setSize": "iestatīt zīmuļa izmēru uz [SIZE]",
    "pen.stamp": "zīmogs",
    "speech.defaultWhenIHearValue": "aiziet",
    "speech.extensionName": "Runas pārvēršana tekstā",
    "speech.listenAndWait": "klausīties un gaidīt",
    "speech.speechReporter": "runa",
    "speech.whenIHear": "kad es dzirdu [PHRASE]",
    "text2speech.alto": "alts",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "milzis",
    "text2speech.kitten": "kaķēns",
    "text2speech.setLanguageBlock": "iestatīt valodu uz [LANGUAGE]",
    "text2speech.setVoiceBlock": "iestatīt balsi uz [VOICE]",
    "text2speech.speakAndWaitBlock": "teikt [WORDS]",
    "text2speech.squeak": "pīkstiens",
    "text2speech.tenor": "tenors",
    "translate.categoryName": "Tulkot",
    "translate.defaultTextToTranslate": "sveiki",
    "translate.translateBlock": "tulkot [WORDS] uz [LANGUAGE]",
    "translate.viewerLanguage": "valoda",
    "videoSensing.categoryName": "Video uztveršana",
    "videoSensing.direction": "virziens",
    "videoSensing.motion": "kustība",
    "videoSensing.off": "izslēgt",
    "videoSensing.on": "ieslēgt",
    "videoSensing.onFlipped": "ieslēgt apgrieztu",
    "videoSensing.setVideoTransparency": "iestatīt video caurspīdīgumu uz [TRANSPARENCY]",
    "videoSensing.sprite": "gariņš",
    "videoSensing.stage": "skatuve",
    "videoSensing.videoOn": "video [ATTRIBUTE] uz [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE]video",
    "videoSensing.whenMotionGreaterThan": "kad video kustība > [REFERENCE]",
    "wedo2.getDistance": "attālums",
    "wedo2.getTiltAngle": "noliekt leņķī [TILT_DIRECTION]",
    "wedo2.isTilted": "noliekts [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "uz otru pusi",
    "wedo2.motorDirection.forward": "uz šo pusi",
    "wedo2.motorDirection.reverse": "apgriezt pretējā virzienā",
    "wedo2.motorId.a": "motors A",
    "wedo2.motorId.all": "visi motori",
    "wedo2.motorId.b": "motors B",
    "wedo2.motorId.default": "motors",
    "wedo2.motorOff": "izslēgt [MOTOR_ID]",
    "wedo2.motorOn": "ieslēgt [MOTOR_ID]",
    "wedo2.motorOnFor": "ieslēgt [MOTOR_ID] [DURATION] sekundes",
    "wedo2.playNoteFor": "spēlēt noti [NOTE] [DURATION] sekundes",
    "wedo2.setLightHue": "iestatīt gaismas krāsu uz [HUE]",
    "wedo2.setMotorDirection": "iestatīt [MOTOR_ID] virzienu uz [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "iestatīt [MOTOR_ID] enerģiju uz [POWER]",
    "wedo2.tiltDirection.any": "jebkādā virzienā",
    "wedo2.tiltDirection.down": "uz leju",
    "wedo2.tiltDirection.left": "pa kreisi",
    "wedo2.tiltDirection.right": "pa labi",
    "wedo2.tiltDirection.up": "uz augšu",
    "wedo2.whenDistance": "kad attālums [OP][REFERENCE]",
    "wedo2.whenTilted": "kad noliekts [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Krāsa",
    "paint.paintEditor.saturation": "Piesātinājums",
    "paint.paintEditor.brightness": "Gaišums",
    "paint.paintEditor.costume": "Tērps",
    "paint.paintEditor.group": "Grupēt",
    "paint.paintEditor.ungroup": "Atgrupēt",
    "paint.paintEditor.undo": "Atsaukt",
    "paint.paintEditor.redo": "Atcelt atsaukšanu",
    "paint.paintEditor.forward": "Uz priekšu",
    "paint.paintEditor.backward": "Atpakaļ",
    "paint.paintEditor.front": "Uz priekšpusi",
    "paint.paintEditor.back": "Uz aizmuguri",
    "paint.paintEditor.more": "Vairāk",
    "paint.modeTools.brushSize": "Izmērs",
    "paint.modeTools.eraserSize": "Dzēšgumijas izmērs",
    "paint.modeTools.copy": "Kopēt",
    "paint.modeTools.paste": "Ielīmēt",
    "paint.modeTools.delete": "Dzēst",
    "paint.modeTools.curved": "Izliekts",
    "paint.modeTools.pointed": "Lauzts",
    "paint.modeTools.thickness": "Biezums",
    "paint.modeTools.flipHorizontal": "Apmest horizontāli",
    "paint.modeTools.flipVertical": "Apmest vertikāli",
    "paint.modeTools.filled": "Aizpildīts",
    "paint.modeTools.outlined": "Neaizpildīts",
    "paint.paintEditor.bitmap": "Pārvērst rastra grafikā",
    "paint.paintEditor.vector": "Pārvērst vektorgrafikā",
    "paint.paintEditor.fill": "Aizpildīt",
    "paint.paintEditor.stroke": "Kontūra",
    "paint.brushMode.brush": "Ota",
    "paint.eraserMode.eraser": "Dzēšgumija",
    "paint.fillMode.fill": "Aizpildīt",
    "paint.lineMode.line": "Līnija",
    "paint.ovalMode.oval": "Aplis",
    "paint.rectMode.rect": "Taisnstūris",
    "paint.reshapeMode.reshape": "Pārveidot",
    "paint.roundedRectMode.roundedRect": "Noapaļots taisnstūris",
    "paint.selectMode.select": "Atlasīt",
    "paint.textMode.text": "Teksts",
    "paint.colorPicker.swap": "Mainīt"
  },
  "lt": {
    "gui.alerts.lostPeripheralConnection": "Scratch prarado ryšį su {extensionName}.",
    "gui.alerts.tryAgain": "Pabandyk dar kartą",
    "gui.alerts.download": "Atsisiųsti",
    "gui.connection.reconnect": "Prisijungti iš naujo",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Kopijavimo aplankas",
    "gui.backpack.errorBackpack": "Klaida įkeliant iš kopijavimo aplanko",
    "gui.backpack.loadingBackpack": "Kraunasi...",
    "gui.backpack.more": "Daugiau",
    "gui.backpack.emptyBackpack": "Kopijavimo aplankas tuščias",
    "gui.unsupportedBrowser.label": "Naršyklė nepalaikoma",
    "gui.unsupportedBrowser.errorLabel": "Įvyko klaida",
    "gui.unsupportedBrowser.notRecommended": "Atsiprašome, bet panašu, kad naudojate naršyklės versiją, kuri nepalaiko Scratch. Rekomenduojame atnaujinti į naujausią versiją vieną iš Scratch palaikančių naršyklių: Google Chrome, Mozilla Firefox, Microsoft Edge, arba Apple Safari.",
    "gui.unsupportedBrowser.description": "Atsiprašome, bet Scratch nepalaiko jūsų naršyklės. Rekomenduojame vieną iš šių naršyklių: Google Chrome, Mozilla Firefox, Microsoft Edge, arba Apple Safari.",
    "gui.unsupportedBrowser.back": "Atgal",
    "gui.unsupportedBrowser.previewfaq": "Norėdami sužinoti daugiau, eikite į {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "DUK",
    "gui.cards.all-tutorials": "Pamokos",
    "gui.cards.shrink": "Sumažinti",
    "gui.cards.expand": "Išskleisti",
    "gui.cards.close": "Uždaryti",
    "gui.cards.more-things-to-try": "Išbandyk daugiau dalykų!",
    "gui.cards.see-more": "Žiūrėti daugiau",
    "gui.comingSoon.message1": "Nesijaudink, mes tobuliname {emoji}",
    "gui.comingSoon.message2": "Netrukus...",
    "gui.comingSoon.message3": "Mes stengiamės ir tobuliname {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nerasta jokių įrenginių",
    "gui.connection.auto-scanning.prescan": "Pasiimk įrenginį prie savęs ir pradėk paiešką.",
    "gui.connection.auto-scanning.pressbutton": "Nuspauskite mygtuką savo įrenginyje.",
    "gui.connection.auto-scanning.start-search": "Pradėti paiešką",
    "gui.connection.connecting-searchbutton": "Ieškoma...",
    "gui.connection.auto-scanning.try-again": "Bandyti iš naujo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Prisijungta",
    "gui.connection.disconnect": "Atsijungti",
    "gui.connection.go-to-editor": "Grįžti į Redaktorių",
    "gui.connection.connecting-cancelbutton": "Jungiamasi...",
    "gui.connection.error.errorMessage": "Oi, atrodo kažkas ne taip.",
    "gui.connection.error.tryagainbutton": "Bandyti iš naujo",
    "gui.connection.error.helpbutton": "Pagalba",
    "gui.connection.peripheral-name-label": "Įrenginio pavadinimas",
    "gui.connection.connect": "Prisijungti",
    "gui.connection.scanning.lookingforperipherals": "Ieškoma įrenginių",
    "gui.connection.scanning.noPeripheralsFound": "Nerasta jokių įrenginių",
    "gui.connection.scanning.instructions": "Pasirink įrenginį iš aukščiau esančio sąrašo.",
    "gui.connection.search": "Atnaujinti",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Įsitikinkite, kad įdiegta ir veikia Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "Patikrinkite, ar Bluetooth funkcija įjungta",
    "gui.connection.unavailable.tryagainbutton": "Bandyti iš naujo",
    "gui.connection.unavailable.helpbutton": "Pagalba",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Pradėti",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oi, atrodo kažkas ne taip.",
    "gui.crashMessage.description": "Deja, atrodo, kad Scratch užstrigo. Apie šią klaidą automatiškai pranešama Scratch darbuotojų komandai. Galite atnaujinti puslapį, kad pakartotumėte veiksmą.",
    "gui.crashMessage.errorNumber": "Klaida buvo užregistruota su ID {errorId}",
    "gui.crashMessage.reload": "Atnaujinti",
    "gui.customProcedures.myblockModalTitle": "Sukurti bloką",
    "gui.customProcedures.addAnInputNumberText": "Pridėti įvestį",
    "gui.customProcedures.numberTextType": "skaičius arba tekstas",
    "gui.customProcedures.addAnInputBoolean": "Pridėti įvestį",
    "gui.customProcedures.booleanType": "loginis tipas",
    "gui.customProcedures.addALabel": "Pridėti etiketę",
    "gui.customProcedures.runWithoutScreenRefresh": "Vykdyti be ekrano atnaujinimo",
    "gui.customProcedures.cancel": "Atšaukti",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Kryptis",
    "gui.directionPicker.rotationStyles.allAround": "Aplinkui",
    "gui.directionPicker.rotationStyles.leftRight": "kairėn/dešinėn",
    "gui.directionPicker.rotationStyles.dontRotate": "Nesisukti",
    "gui.gui.addExtension": "Pridėti plėtinį",
    "gui.gui.codeTab": "Programos kodas",
    "gui.gui.backdropsTab": "Fonai",
    "gui.gui.costumesTab": "Kaukės",
    "gui.gui.soundsTab": "Garsai",
    "gui.extensionLibrary.comingSoon": "Netrukus",
    "gui.extensionLibrary.requires": "Reikalavimai",
    "gui.extensionLibrary.collaboration": "Bendradarbiaujant su",
    "gui.library.filterPlaceholder": "Paieška",
    "gui.library.allTag": "Viskas",
    "gui.loader.message1": "Kuriami blokai…",
    "gui.loader.message2": "Įkeliami veikėjai…",
    "gui.loader.message3": "Įkeliami garsai…",
    "gui.loader.message4": "Įkeliami plėtiniai…",
    "gui.loader.message5": "Gaudome kates…",
    "gui.loader.message6": "Nano kažkur kraustosi…",
    "gui.loader.message7": "Pripučiama Gobo…",
    "gui.loader.message8": "Ruošiame emoji…",
    "gui.loader.headline": "Kraunamas projektas",
    "gui.loader.creating": "Projektas kuriamas",
    "gui.accountMenu.profile": "Profilis",
    "gui.accountMenu.myStuff": "Mano projektai",
    "gui.accountMenu.myClasses": "Mano pamokos",
    "gui.accountMenu.myClass": "Mano pamokos",
    "gui.accountMenu.accountSettings": "Paskyros nustatymai",
    "gui.accountMenu.signOut": "Atsijungti",
    "gui.authorInfo.byUser": "sukūrė {username}",
    "gui.menuBar.seeProjectPage": "Į projekto puslapį",
    "gui.menuBar.language": "Language",
    "general.username": "Naudotojo vardas",
    "general.password": "Slaptažodis",
    "general.signIn": "Prisijungti",
    "login.needHelp": "Reikia pagalbos?",
    "form.validationRequired": "Šį laukelį būtina užpildyti",
    "gui.menuBar.tutorialsLibrary": "Pamokos",
    "gui.menuBar.restoreSprite": "Atstatyti veikėją",
    "gui.menuBar.restoreSound": "Atstatyti garsą",
    "gui.menuBar.restoreCostume": "Atstatyti kaukę",
    "gui.menuBar.restore": "Atstatyti",
    "gui.menuBar.saveNow": "Išsaugoti dabar",
    "gui.menuBar.saveAsCopy": "Išsaugoti kopiją",
    "gui.menuBar.remix": "Perdaroma kūryba (remiksas)",
    "gui.menuBar.new": "Naujas",
    "gui.menuBar.file": "Failas",
    "gui.menuBar.downloadToComputer": "Išsaugoti savo kompiuteryje",
    "gui.menuBar.edit": "Taisyti",
    "gui.menuBar.turboModeOff": "Išjungti Turbo režimą",
    "gui.menuBar.turboModeOn": "Įjungti Turbo režimą",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Prisiregistruoti Scratch",
    "gui.menuBar.signIn": "Prisijungti",
    "gui.gui.projectTitlePlaceholder": "Vieta projekto pavadinimui",
    "gui.menuBar.saveNowLink": "Išsaugoti dabar",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Dalinamasi",
    "gui.menuBar.share": "Dalintis",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Pagalba",
    "gui.modal.back": "Atgal",
    "gui.monitor.listMonitor.empty": "(tuščia)",
    "gui.monitor.listMonitor.listLength": "ilgis {length}",
    "gui.monitor.contextMenu.default": "rodyti įprastai",
    "gui.monitor.contextMenu.large": "rodyti didesnį",
    "gui.monitor.contextMenu.slider": "slinktis",
    "gui.monitor.contextMenu.sliderRange": "pakeisti slankiklio diapazoną",
    "gui.monitor.contextMenu.import": "įkelti",
    "gui.monitor.contextMenu.export": "eksportuoti",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Paleisti",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Visiems veikėjams",
    "gui.gui.variableScopeOptionSpriteOnly": "Tik šiam veikėjui",
    "gui.gui.cloudVariableOption": "Kintamasis debesyje (išsaugotas serveryje)",
    "gui.gui.variablePromptAllSpritesMessage": "Šis kintamasis bus prieinamas visiems veikėjams",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Atšaukti",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Paleisti",
    "gui.playbackStep.loadingMsg": "Kraunasi...",
    "gui.playbackStep.saveMsg": "Išsaugoti",
    "gui.playbackStep.reRecordMsg": "Įrašyti iš naujo",
    "gui.recordModal.title": "Įrašyti garsą",
    "gui.recordingStep.beginRecord": "Įrašui pradėti paspausk žemiau esantį mygtuką",
    "gui.recordingStep.permission": "{arrow}Reikia tavo leidimo naudoti mikrofoną",
    "gui.recordingStep.stop": "Baigti įrašymą",
    "gui.recordingStep.record": "Įrašyti",
    "gui.sliderModal.min": "Minimalus dydis",
    "gui.sliderModal.max": "Maksimalus dydis",
    "gui.sliderModal.title": "pakeisti slankiklio diapazoną",
    "gui.sliderPrompt.cancel": "Atšaukti",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Garsas",
    "gui.soundEditor.play": "Paleisti",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Kopijuoti",
    "gui.soundEditor.paste": "Įklijuoti",
    "gui.soundEditor.copyToNew": "Kopijuoti kaip naują",
    "gui.soundEditor.delete": "Ištrinti",
    "gui.soundEditor.save": "Išsaugoti",
    "gui.soundEditor.undo": "Atšaukti",
    "gui.soundEditor.redo": "Grąžinti",
    "gui.soundEditor.faster": "Greičiau",
    "gui.soundEditor.slower": "Lėčiau",
    "gui.soundEditor.echo": "Aidas",
    "gui.soundEditor.robot": "Robotas",
    "gui.soundEditor.louder": "Garsiau",
    "gui.soundEditor.softer": "Tyliau",
    "gui.soundEditor.reverse": "Atbulai",
    "gui.soundEditor.fadeOut": "Išnykti",
    "gui.soundEditor.fadeIn": "Išnyks",
    "gui.soundEditor.mute": "Nutildyti",
    "gui.SpriteInfo.spritePlaceholder": "Pavadinimas",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Veikėjas",
    "gui.SpriteInfo.show": "Rodyti",
    "gui.SpriteInfo.size": "Dydis",
    "gui.spriteSelectorItem.contextMenuDuplicate": "padaryti kopiją",
    "gui.spriteSelectorItem.contextMenuExport": "eksportuoti",
    "gui.spriteSelectorItem.contextMenuDelete": "šalinti",
    "gui.spriteSelector.addSpriteFromLibrary": "Pasirink veikėją",
    "gui.spriteSelector.addSpriteFromPaint": "Piešti",
    "gui.spriteSelector.addSpriteFromSurprise": "Siurprizas",
    "gui.spriteSelector.addSpriteFromFile": "Įkelti veikėją",
    "gui.stageHeader.stageSizeLarge": "Pakeisti į didelę sceną",
    "gui.stageHeader.stageSizeSmall": "Pakeisti į mažą sceną",
    "gui.stageHeader.stageSizeFull": "Rodyti per visą ekraną",
    "gui.stageHeader.stageSizeUnFull": "Išjungti rodymą per visą ekraną",
    "gui.stageHeader.fullscreenControl": "Per visą ekraną",
    "gui.spriteSelector.addBackdropFromLibrary": "Pasirink foną",
    "gui.stageSelector.addBackdropFromPaint": "Piešti",
    "gui.stageSelector.addBackdropFromSurprise": "Siurprizas",
    "gui.stageSelector.addBackdropFromFile": "Įkelti foną",
    "gui.stageSelector.stage": "Scena",
    "gui.stageSelector.backdrops": "Fonai",
    "gui.telemetryOptIn.label": "Dalinkis naudojimo statistika ir padėk mums tobulinti Scratch.",
    "gui.telemetryOptIn.body1": "„Scratch“ komanda visada siekia geriau suprasti, kaip „Scratch“ naudojama visame pasaulyje. Norėdami padėti palaikyti šias pastangas, galite leisti „Scratch“ automatiškai siųsti naudojimo informaciją „Scratch“ komandai.",
    "gui.telemetryOptIn.body2": "Mūsų renkama informacija apima kalbos pasirinkimą, blokų (komandų) naudojimą ir kai kuriuos įvykius, tokius kaip projekto išsaugojimas, įkėlimas ir pasidalijimas su kitais vartotojais. Mes nerenkame jokios asmeninės informacijos. Norėdami gauti daugiau informacijos, skaitykite mūsų {privacyPolicyLink}.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privatumo politika",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo režimas",
    "gui.webglModal.label": "Ši naršyklė nepalaiko WebGL",
    "gui.webglModal.description": "Deja, atrodo, kad naršyklė ar kompiuteris {webGlLink}. Ši technologija reikalinga kad veiktų Scratch 3.0.",
    "gui.webglModal.webgllink": "nepalaiko WebGL",
    "gui.webglModal.back": "Atgal",
    "gui.webglModal.previewfaq": "Norėdami sužinoti daugiau, eikite į {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "DUK",
    "gui.costumeLibrary.chooseABackdrop": "Pasirink foną",
    "gui.costumeLibrary.chooseACostume": "Pasirink kaukę",
    "gui.costumeTab.addBackdropFromLibrary": "Pasirink foną",
    "gui.costumeTab.addCostumeFromLibrary": "Pasirink kaukę",
    "gui.costumeTab.addBlankCostume": "Piešti",
    "gui.costumeTab.addSurpriseCostume": "Siurprizas",
    "gui.costumeTab.addFileBackdrop": "Įkelti foną",
    "gui.costumeTab.addFileCostume": "Įkelti kaukę",
    "gui.extensionLibrary.chooseAnExtension": "Pasirink plėtinį",
    "gui.extensionLibrary.extensionUrl": "Įveskite plėtinio URL",
    "gui.monitors.importListColumnPrompt": "Kuris stulpelis turėtų būti naudojamas (1- {numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nepavyko pradėti įrašo",
    "gui.soundLibrary.chooseASound": "Pasirink garsą",
    "gui.soundTab.fileUploadSound": "Įkelti garsą",
    "gui.soundTab.surpriseSound": "Siurprizas",
    "gui.soundTab.recordSound": "Įrašyti",
    "gui.soundTab.addSoundFromLibrary": "Pasirink garsą",
    "gui.spriteLibrary.chooseASprite": "Pasirink veikėją",
    "gui.tipsLibrary.tutorials": "Pasirink pamoką",
    "gui.alerts.createsuccess": "Sukurta sėkmingai.",
    "gui.alerts.createcopysuccess": "Projektas išsaugotas kaip kopija",
    "gui.alerts.createremixsuccess": "Projektas išsaugotas kaip remiksas.",
    "gui.alerts.creating": "Kuriamas naujas...",
    "gui.alerts.creatingCopy": "Projektas kopijuojamas...",
    "gui.alerts.creatingRemix": "Remiktuojamas projektas ...",
    "gui.alerts.creatingError": "Nepavyko sukurti projekto. Pabandykite iš naujo!",
    "gui.alerts.savingError": "Projekto išsaugoti nepavyko.",
    "gui.alerts.savesuccess": "Projektas išsaugotas.",
    "gui.alerts.saving": "Išsaugoma...",
    "gui.alerts.cloudInfo": "Atminkite, kad debesų kintamieji palaiko tik skaičius, o ne raides ar simbolius. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Sužinok daugiau.",
    "gui.alerts.importing": "Importuoti",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "mano kintamasis",
    "gui.howtos.intro-move-sayhello-hat.name": "Kaip pradėti",
    "gui.howtos.intro-move.step_stepMove": "Pridėk judėjimo bloką",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Sukurti vardo animaciją",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pasirinkti veikėją-raidę",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spustelėjus groti garsą",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pasirinkti kitą veikėją-raidę",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Keisti spalvą",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Rinktis kitą veikėją-raidę, kuri suksis aplink",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Rinktis kitą veikėją-raidę, kuri augs",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Kurti muziką",
    "gui.howtos.Make-Music.step_PickInstrument": "Rinktis veikėją-instrumentą",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spustelėjus groti garsą",
    "gui.howtos.Make-Music.step_MakeSong": "Kurti dainą",
    "gui.howtos.make-music.step_MakeBeat": "Rinktis būgną ir kurti ritmą",
    "gui.howtos.make-music.step_MakeBeatBox": "Rinktis veikėją-mikrofoną ir nustebinti Beatbox'u",
    "gui.howtos.story.name": "Sukurk istoriją",
    "gui.howtos.story.step_addbg": "Pridėk foną",
    "gui.howtos.story.step_addsprite": "Pridėk veikėją",
    "gui.howtos.story.step_saysomething": "Sakyk Ką Nors",
    "gui.howtos.story.step_addanothersprite": "Pridėti kitą veikėją",
    "gui.howtos.story.step_flip": "Pakeisti kryptį",
    "gui.howtos.story.step_conversation": "Pasikalbėkite",
    "gui.howtos.story.addanotherbg": "Pridėk dar vieną foną",
    "gui.howtos.story.step_swithbg": "Keisk fonus",
    "gui.howtos.story.step_hidewizard": "Slėpti veikėją",
    "gui.howtos.story.step_showwizard": "Rodyti veikėją",
    "gui.howtos.make-a-chase-game.name": "Kurti gaudynių žaidimą",
    "gui.howtos.Chase-Game.step_BG": "Pridėk foną",
    "gui.howtos.chase-game.step_AddOcto": "Pridėk Veikėją",
    "gui.howtos.make-music.step_LeftRight": "Judėti dešinėn ir kairėn rodyklių klavišais",
    "gui.howtos.Chase-Game.step_UpDown": "Judėti aukštyn ir žemyn rodyklių klavišais",
    "gui.howtos.Chase-Game.step_AddStar": "Pridėti dar vieną veikėją",
    "gui.howtos.Chase-Game.step_MoveRandom": "Judėti kaip papuola",
    "gui.howtos.Chase-Game.step_WhenTouch": "Beliečiant veikėją-aštuonkojį, groti garsą",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Sukurti kintamąjį, kuris saugos taškų skaičių",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Beliečiant veikėją-aštuonkojį pridėti taškų",
    "gui.howtos.animate-char.name": "Animuoti veikėją",
    "gui.howtos.animate-char.step_addbg": "Pridėk foną",
    "gui.howtos.animate-char.step_addsprite": "Pridėk Veikėją",
    "gui.howtos.animate-char.step_saysomething": "Sakyk Ką Nors",
    "gui.howtos.animate-char.step_addsound": "Pridėk Garsą",
    "gui.howtos.animate-char.step_animatetalking": "Animuoti veikėją, kai jis/ji kalba",
    "gui.howtos.animate-char.step_arrowkeys": "Judėti naudojantis rodyklių klavišais",
    "gui.howtos.animate-char.step_jump": "Peršokti",
    "gui.howtos.animate-char.step_changecolor": "Keisk Spalvą",
    "gui.howtos.make-a-game.name": "Kurti spustelėjimų žaidimą",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pasirinkti veikėją",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spustelėjus groti garsą",
    "gui.howtos.make-a-game.step_GameAddScore": "Sukurti kintamąjį, kuris saugos taškų skaičių",
    "gui.howtos.make-a-game.step_GameChangeScore": "Spustelėjus pridėti tašką",
    "gui.howtos.make-a-game.step_Random": "Eiti į atsitiktinai parinktą vietą",
    "gui.howtos.make-music.step_GameChangeColor": "Keisk Spalvą",
    "gui.howtos.make-music.step_ResetScore": "Nunulinti taškus",
    "gui.howtos.make-it-fly.name": "Padarykite, kad skristų",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Pasirinkite dangaus foną",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Išsirink veikėją",
    "gui.howtos.fly.step_stepflySaySomething": "Sakyk Ką Nors",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Judėti kartu su rodyklėmis",
    "gui.howtos.fly.step_stepflyChooseObject": "Pasirinkite objektą kolekcijai",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Paverskite objektą judančiu",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Pažymėkite savo veikėją",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Įveskite greitį",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Skaičiuoti taškus",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Pridėk aplinką",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Perkelkite peizažą",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Sekantis veikėjas",
    "gui.howtos.pong": "Pong žaidimas",
    "gui.howtos.pong.step_pongAddBackdrop": "Pridėk foną",
    "gui.howtos.pong.step_pongAddBallSprite": "Įdėkite Kamuolio kaukę",
    "gui.howtos.pong.step_pongBounceAround": "Šokinėti aplink",
    "gui.howtos.pong.step_pongAddPaddle": "Įdėti raketę",
    "gui.howtos.pong.step_pongMoveThePaddle": "Pajudinti raketę",
    "gui.howtos.pong.step_pongSelectBallSprite": "Pažymėti Kamuolio kaukę",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Pridėkite kodą, kad kamuolys atšoktų ant raketės",
    "gui.howtos.pong.step_pongAddAScore": "Pridėkite taškų skaičiavimą",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Pasirinkite \"Taškai\" (\"Score\") iš  Meniu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Įterpkite \"Pakeiskite taškus (score)\" komandą",
    "gui.howtos.pong.step_pongResetScore": "Nunulinti taškus",
    "gui.howtos.pong.step_pongAddLineSprite": "Įdėkite \"Linijos\" veikėją",
    "gui.howtos.pong.step_pongGameOver": "Žaidimas baigtas",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Kurti nuotykių žaidimo animaciją",
    "gui.howtos.cartoon-network.step_CNcharacter": "Rinktis, kurį veikėją rodys",
    "gui.howtos.cartoon-network.step_CNsay": "Sakyk Ką Nors",
    "gui.howtos.cartoon-network.step_CNglide": "Slinkti",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Pasirink objektą, kurį veikėjas vysis",
    "gui.howtos.cartoon-network.step_CNcollect": "Surinkti objektus",
    "gui.howtos.cartoon-network.step_CNvariable": "Kurti taškų skaičiaus kintamąjį",
    "gui.howtos.cartoon-network.step_CNscore": "Skaičiuoti taškus",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Pakeltas lygis: pakeistas fonas",
    "gui.howtos.videosens.name": "Vaizdo jutikliai",
    "gui.howtos.videosens.step_addextension": "Pridėti plėtinį",
    "gui.howtos.videosens.step_pet": "Paglostyk katę",
    "gui.howtos.videosens.step_animate": "Animuoti",
    "gui.howtos.videosens.step_pop": "Susprogdink balioną",
    "gui.howtos.say-it-out-loud": "Kurti kalbančias animacijas",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Pridėti tekstą į kalbos blokus",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sakyk ką nors",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Nustatyti balsą",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Judėti aplink",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Pridėk foną",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Pridėk kitą veikėją",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Sudainuoti dainą",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Keisk Spalvą",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Sukis aplink",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Išaugti ir susitraukti",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Pridėk Veikėją",
    "gui.howtos.add-sprite.step_addSprite": "Pridėk Veikėją",
    "gui.howtos.add-a-backdrop.name": "Pridėk foną",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Pridėk foną",
    "gui.howtos.change-size.name": "Keisti dydį",
    "gui.howtos.change-size.step_changeSize": "Keisti dydį",
    "gui.howtos.glide-around.name": "Slinkti",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Slinkti",
    "gui.howtos.change-size.step_glideAroundPoint": "Slinkti į tašką",
    "gui.howtos.record-a-sound.name": "Įrašyti garsą",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Paspausk kortelę \"Garsas\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Paspausk \"Įrašyti\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Paspausk įrašymo mygtuką",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Panaudokite savo garsą",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Grok savo garsą",
    "gui.howtos.spin-video.name": "Priversk suktis",
    "gui.howtos.change-size.step_spinTurn": "  Pasukti",
    "gui.howtos.change-size.step_spinPointInDirection": "Nustatykite kryptį",
    "gui.howtos.hide-and-show.name": "Slėpti ir rodyti",
    "gui.howtos.change-size.step_hideAndShow": "Slėpti ir rodyti",
    "gui.howtos.switch-costume.name": "Kurti veikėjo animaciją",
    "gui.howtos.change-size.step_switchCostumes": "Kurti veikėjo animaciją",
    "gui.howtos.move-around-with-arrow-keys.name": "Naudoti rodyklių klavišus",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Judėkite kairėn ir dešinėn",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Judėkite aukštyn ir žemyn",
    "gui.howtos.add-effects.name": "Pridėti efektų",
    "gui.howtos.videosens.step_addEffects": "Pridėti efektų",
    "gui.extension.music.name": "Muzika",
    "gui.extension.music.description": "Groti instrumentais ir būgnais.",
    "gui.extension.pen.name": "Pieštukas",
    "gui.extension.pen.description": "Piešti savo veikėjus.",
    "gui.extension.videosensing.name": "Vaizdo jutikliai",
    "gui.extension.videosensing.description": "Aptikti judesį naudojant kamerą.",
    "gui.extension.text2speech.name": "Skaityti tekstą",
    "gui.extension.text2speech.description": "Tavo projektai galės kalbėti.",
    "gui.extension.translate.name": "Išversti",
    "gui.extension.translate.description": "Versti tekstą į kitas kalbas.",
    "gui.extension.makeymakey.description": "Iš bet ko padaryk klavišą.",
    "gui.extension.microbit.description": "Jungti projektus su visu pasauliu.",
    "gui.extension.microbit.connectingMessage": "Jungiamasi",
    "gui.extension.ev3.description": "Sukurkite interaktyvius robotus ir dar daugiau.",
    "gui.extension.ev3.connectingMessage": "Prisijungimas. Įsitikinkite, kad jūsų EV3 PIN kodas yra 1234.",
    "gui.extension.boost.description": "Suteikite robotui gyvenimiškų bruožų",
    "gui.extension.boost.connectingMessage": "Jungiamasi",
    "gui.extension.wedo2.description": "Kurkite su motorais ir jutikliais.",
    "gui.extension.wedo2.connectingMessage": "Jungiamasi",
    "gui.extension.gdxfor.description": "Juskite traukimą, stūmimą, judesį ir sukimąsi",
    "gui.extension.gdxfor.connectingMessage": "Jungiamasi",
    "gui.libraryTags.all": "Viskas",
    "gui.libraryTags.animals": "Gyvūnai",
    "gui.libraryTags.dance": "Šokis",
    "gui.libraryTags.effects": "Efektai",
    "gui.libraryTags.fantasy": "Fantazija",
    "gui.libraryTags.fashion": "Mada",
    "gui.libraryTags.food": "Maistas",
    "gui.libraryTags.indoors": "Viduje",
    "gui.libraryTags.loops": "Ciklai",
    "gui.libraryTags.music": "Muzika",
    "gui.libraryTags.notes": "Natos",
    "gui.libraryTags.outdoors": "Lauke",
    "gui.libraryTags.patterns": "Raštai",
    "gui.libraryTags.people": "Žmonės",
    "gui.libraryTags.percussion": "Mušamieji",
    "gui.libraryTags.space": "Kosmosas",
    "gui.libraryTags.sports": "Sportas",
    "gui.libraryTags.underwater": "Povandeninis pasaulis",
    "gui.libraryTags.voice": "Balsas",
    "gui.libraryTags.wacky": "Pašėlę",
    "gui.libraryTags.animation": "Animacija",
    "gui.libraryTags.art": "Menas",
    "gui.libraryTags.games": "Žaidimai",
    "gui.libraryTags.stories": "Pasakojimai",
    "gui.libraryTags.letters": "Raidės",
    "gui.opcodeLabels.direction": "kryptis",
    "gui.opcodeLabels.xposition": "x koordinatė",
    "gui.opcodeLabels.yposition": "y koordinatė",
    "gui.opcodeLabels.size": "dydis",
    "gui.opcodeLabels.costumename": "kaukės pavadinimas",
    "gui.opcodeLabels.costumenumber": "kaukės numeris",
    "gui.opcodeLabels.backdropname": "fono pavadinimas",
    "gui.opcodeLabels.backdropnumber": "fono numeris",
    "gui.opcodeLabels.volume": "garsas",
    "gui.opcodeLabels.tempo": "tempas",
    "gui.opcodeLabels.answer": "atsakymas",
    "gui.opcodeLabels.loudness": "garsumas",
    "gui.opcodeLabels.username": "vartotojo vardas",
    "gui.opcodeLabels.year": "metai",
    "gui.opcodeLabels.month": "mėnuo",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "savaitės diena",
    "gui.opcodeLabels.hour": "valanda",
    "gui.opcodeLabels.minute": "minutė",
    "gui.opcodeLabels.second": "sekundė",
    "gui.opcodeLabels.timer": "laikmatis",
    "gui.projectLoader.loadError": "Nepavyko įkelti pasirinkto projekto failo.",
    "gui.sharedMessages.backdrop": "fonas{index}",
    "gui.sharedMessages.costume": "kaukė{index}",
    "gui.sharedMessages.sprite": "Veikėjas{index}",
    "gui.sharedMessages.pop": "pokšt",
    "gui.sharedMessages.replaceProjectWarning": "Ar nori pakeisti šio projekto turinį?",
    "gui.sharedMessages.loadFromComputerTitle": "Įkelti iš kompiuterio",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Mano projektas",
    "boost.color.any": "bet kuri spalva",
    "boost.color.black": "juoda",
    "boost.color.blue": "mėlyna",
    "boost.color.green": "žalia",
    "boost.color.red": "raudona",
    "boost.color.white": "balta",
    "boost.color.yellow": "geltona",
    "boost.getMotorPosition": "variklio [MOTOR_REPORTER_ID] pozicija",
    "boost.getTiltAngle": "paversk kryptimi [TILT_DIRECTION]",
    "boost.motorDirection.backward": "šen",
    "boost.motorDirection.forward": "ten",
    "boost.motorDirection.reverse": "atvirkščiai",
    "boost.motorOff": "išjunk variklį [MOTOR_ID] ",
    "boost.motorOn": "įjunk variklį [MOTOR_ID] ",
    "boost.motorOnFor": "suk variklį [MOTOR_ID]  [DURATION] sekundes",
    "boost.motorOnForRotation": "suk variklį [MOTOR_ID]  [ROTATION] apsukas",
    "boost.seeingColor": "matoma [COLOR] blokų?",
    "boost.setLightHue": "keisti šviesos spalvą į [HUE]",
    "boost.setMotorDirection": "nustatyti variklio [MOTOR_ID] kryptį [MOTOR_DIRECTION]",
    "boost.setMotorPower": "nustatyti variklio [MOTOR_ID] greitį į [POWER] %",
    "boost.tiltDirection.any": "bet kur",
    "boost.tiltDirection.down": "žemyn",
    "boost.tiltDirection.left": "kairėn",
    "boost.tiltDirection.right": "dešinėn",
    "boost.tiltDirection.up": "aukštyn",
    "boost.whenColor": "kai [COLOR] bloko matoma ",
    "boost.whenTilted": "kai paversta [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "groti natą [NOTE]tiek sekundžių: [TIME]",
    "ev3.buttonPressed": "ar mygtukas [PORT] nuspaustas?",
    "ev3.getBrightness": "šviesumas",
    "ev3.getDistance": "atstumas",
    "ev3.getMotorPosition": "[PORT] variklio pozicija",
    "ev3.motorSetPower": "[PORT] varikliui nustatyti jėgą [POWER] %",
    "ev3.motorTurnClockwise": "[PORT] variklį sukti šia kryptimi tiek sekundžių: [TIME]",
    "ev3.motorTurnCounterClockwise": "[PORT] variklį sukti šia kryptimi tiek sekundžių: [TIME]",
    "ev3.whenBrightnessLessThan": "kai šviesumas < [DISTANCE]",
    "ev3.whenButtonPressed": "kai nuspaudžiamas mygtukas [PORT]",
    "ev3.whenDistanceLessThan": "kai atstumas < [DISTANCE]",
    "gdxfor.getAcceleration": "pagreitis [DIRECTION]",
    "gdxfor.getForce": "jėga",
    "gdxfor.getSpin": "sukimosi greitis [DIRECTION]]",
    "gdxfor.getTilt": "pasvirk kampu [TILT]",
    "gdxfor.isFreeFalling": "krenta?",
    "gdxfor.isTilted": "Pasukta [TILT]?",
    "gdxfor.pulled": "traukiama",
    "gdxfor.pushed": "stumiama",
    "gdxfor.shaken": "papurtyta",
    "gdxfor.startedFalling": "pradėjo kristi",
    "gdxfor.tiltDirectionMenu.any": "bet kur",
    "gdxfor.tiltDirectionMenu.back": "atgal",
    "gdxfor.tiltDirectionMenu.front": "priekin",
    "gdxfor.tiltDirectionMenu.left": "kairėn",
    "gdxfor.tiltDirectionMenu.right": "dešinėn",
    "gdxfor.turnedFaceDown": "pasukti veidu žemyn",
    "gdxfor.turnedFaceUp": "pasukti veidu aukštyn",
    "gdxfor.whenForcePushedOrPulled": "kai jėgos jutiklis [PUSH_PULL]",
    "gdxfor.whenGesture": "kai [GESTURE]",
    "gdxfor.whenTilted": "pakreipus [TILT]",
    "makeymakey.downArrow": "rodyklė žemyn",
    "makeymakey.downArrowShort": "žemyn",
    "makeymakey.leftArrow": "rodyklė kairėn",
    "makeymakey.leftArrowShort": "kairėn",
    "makeymakey.rightArrow": "rodyklė dešinėn",
    "makeymakey.rightArrowShort": "dešinėn",
    "makeymakey.spaceKey": "tarpas",
    "makeymakey.upArrow": "rodyklė aukštyn",
    "makeymakey.upArrowShort": "aukštyn",
    "makeymakey.whenKeyPressed": "Kai [KEY] paspaustas",
    "makeymakey.whenKeysPressedInOrder": "Kai seka [SEQUENCE] suvesta",
    "microbit.buttonsMenu.any": "bet kuris",
    "microbit.clearDisplay": "išvalyti ekraną",
    "microbit.defaultTextToDisplay": "Sveiki!",
    "microbit.displaySymbol": "rodyti [MATRIX]",
    "microbit.displayText": "rodyti tekstą [TEXT]",
    "microbit.gesturesMenu.jumped": "šuolis",
    "microbit.gesturesMenu.moved": "pajudinta",
    "microbit.gesturesMenu.shaken": "papurtyta",
    "microbit.isButtonPressed": "ar nuspaustas mygtukas [BTN]?",
    "microbit.isTilted": "ar paversta [DIRECTION]?",
    "microbit.pinStateMenu.off": "išjungti",
    "microbit.pinStateMenu.on": "įjungti",
    "microbit.tiltAngle": "paversta kampu [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "bet kuris",
    "microbit.tiltDirectionMenu.back": "atgal",
    "microbit.tiltDirectionMenu.front": "pirmyn",
    "microbit.tiltDirectionMenu.left": "kairėn",
    "microbit.tiltDirectionMenu.right": "dešinėn",
    "microbit.whenButtonPressed": "kai paspaudi mygtuką [BTN]",
    "microbit.whenGesture": "kai [GESTURE]",
    "microbit.whenPinConnected": "kai prijungtas kištukas [PIN]",
    "microbit.whenTilted": "kai paversta [DIRECTION]",
    "music.categoryName": "Muzika",
    "music.changeTempo": "tempą padidink [TEMPO]",
    "music.drumBass": "(2) Bosinis būgnas",
    "music.drumBongo": "(13) Bongo būgnas",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9)  Strypeliai",
    "music.drumClosedHiHat": "(6) Uždaras haihetas",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Skrabalas",
    "music.drumCrashCymbal": "(4) „Crash“ lėkštės",
    "music.drumCuica": "(18) Kuika",
    "music.drumGuiro": "(16) Giras",
    "music.drumHandClap": "(8) Pliaukštelėjimas delnais",
    "music.drumOpenHiHat": "(5) Atviras haihetas",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Mažasis būgnas",
    "music.drumTambourine": "(7) Tambūrinas",
    "music.drumTriangle": "(12) Trikampis",
    "music.drumVibraslap": "(17) Vibraslapis",
    "music.drumWoodBlock": "(10) Trinkelė",
    "music.getTempo": "tempas",
    "music.instrumentBass": "(6) Bosas",
    "music.instrumentBassoon": "(14) Fagotas",
    "music.instrumentCello": "(8) Violončelė",
    "music.instrumentChoir": "(15) Choras",
    "music.instrumentClarinet": "(10) Klarnetas",
    "music.instrumentElectricGuitar": "(5) Elektrinė gitara",
    "music.instrumentElectricPiano": "(2) Sintezatorius",
    "music.instrumentFlute": "(12) Fleita",
    "music.instrumentGuitar": "(4) Gitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Muzikinė dėžutė",
    "music.instrumentOrgan": "(3) Vargonai",
    "music.instrumentPiano": "(1) Pianinas",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofonas",
    "music.instrumentSteelDrum": "(18) Plieno būgnas",
    "music.instrumentSynthLead": "(20) Solinis sintezatorius",
    "music.instrumentSynthPad": "(21) Sintezatorius",
    "music.instrumentTrombone": "(9) Trombonas",
    "music.instrumentVibraphone": "(16) Vibrafonas",
    "music.instrumentWoodenFlute": "(13) Medinė fleita",
    "music.midiPlayDrumForBeats": "groti būgnu [DRUM] tiek taktų: [BEATS]",
    "music.midiSetInstrument": "nustatyti instrumentą į [INSTRUMENT]",
    "music.playDrumForBeats": "groti būgnu [DRUM] tiek taktų: [BEATS]",
    "music.playNoteForBeats": "groti natą [NOTE] tiek taktų: [BEATS]",
    "music.restForBeats": "pauzė tiek taktų: [BEATS]",
    "music.setInstrument": "instrumentą nustatyti į [INSTRUMENT]",
    "music.setTempo": "keisti tempą į [TEMPO] ",
    "pen.categoryName": "Pieštukas",
    "pen.changeColorParam": "keisk pieštuko [COLOR_PARAM]per[VALUE]",
    "pen.changeHue": "keisk pieštuko spalvą per [HUE]",
    "pen.changeShade": "keisk pieštuko atspalvį per [SHADE]",
    "pen.changeSize": "keisk pieštuko dydį per [SIZE]",
    "pen.clear": "ištrinti viską",
    "pen.colorMenu.brightness": "šviesumas",
    "pen.colorMenu.color": "spalva",
    "pen.colorMenu.saturation": "sodrumas",
    "pen.colorMenu.transparency": "permatomumas",
    "pen.penDown": "pieštukas pieš",
    "pen.penUp": "pieštukas nebepieš",
    "pen.setColor": "keisti pieštuko spalvą į [COLOR]",
    "pen.setColorParam": "piešimo [COLOR_PARAM] = [VALUE]",
    "pen.setHue": "piešimo atspalvis = [HUE]",
    "pen.setShade": "keisti pieštuko atspalvį į [SHADE]",
    "pen.setSize": "keisti pieštuko dydį į [SIZE]",
    "pen.stamp": "antspaudas",
    "speech.defaultWhenIHearValue": "pirmyn",
    "speech.extensionName": "Skaityti tekstą",
    "speech.listenAndWait": "paklausyti ir laukti",
    "speech.speechReporter": "kalba",
    "speech.whenIHear": "kai išgirstu [PHRASE]",
    "text2speech.alto": "alto balsas",
    "text2speech.categoryName": "Skaityti tekstą",
    "text2speech.defaultTextToSpeak": "sveiki",
    "text2speech.giant": "milžino balsas",
    "text2speech.kitten": "kačiukas",
    "text2speech.setLanguageBlock": "keisti kalbą į [LANGUAGE]",
    "text2speech.setVoiceBlock": "keisti balsą į [VOICE]",
    "text2speech.speakAndWaitBlock": "sakyti [WORDS]",
    "text2speech.squeak": "cyptelėjimas",
    "text2speech.tenor": "tenoro balsas",
    "translate.categoryName": "Išversti",
    "translate.defaultTextToTranslate": "sveiki",
    "translate.translateBlock": "išversti [WORDS] į [LANGUAGE]",
    "translate.viewerLanguage": "kalba",
    "videoSensing.categoryName": "Vaizdo jutikliai",
    "videoSensing.direction": "kryptis",
    "videoSensing.motion": "judesys",
    "videoSensing.off": "Išjungti",
    "videoSensing.on": "Įjungti",
    "videoSensing.onFlipped": "kai apverčiama",
    "videoSensing.setVideoTransparency": "nustatyk video permatomumą į[TRANSPARENCY]",
    "videoSensing.sprite": "veikėjas",
    "videoSensing.stage": "scena",
    "videoSensing.videoOn": "video [ATTRIBUTE]iš[SUBJECT]",
    "videoSensing.videoToggle": "perjungti video į [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kai judesio vaizde > [REFERENCE]",
    "wedo2.getDistance": "atstumas",
    "wedo2.getTiltAngle": "paversta kryptimi [TILT_DIRECTION]",
    "wedo2.isTilted": "ar paversta [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "šen",
    "wedo2.motorDirection.forward": "ten",
    "wedo2.motorDirection.reverse": "atbulai",
    "wedo2.motorId.a": "variklis A",
    "wedo2.motorId.all": "visi varikliai",
    "wedo2.motorId.b": "variklis B",
    "wedo2.motorId.default": "variklis",
    "wedo2.motorOff": "išjungti [MOTOR_ID]",
    "wedo2.motorOn": "įjungti [MOTOR_ID]",
    "wedo2.motorOnFor": "įjungti [MOTOR_ID]  [DURATION] sekundžių",
    "wedo2.playNoteFor": "groti natą [NOTE]  [DURATION] s.",
    "wedo2.setLightHue": "spalvos tonas = [HUE]",
    "wedo2.setMotorDirection": "[MOTOR_ID] kryptis = [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "[MOTOR_ID] galia = [POWER]",
    "wedo2.tiltDirection.any": "bet kuris",
    "wedo2.tiltDirection.down": "žemyn",
    "wedo2.tiltDirection.left": "kairėn",
    "wedo2.tiltDirection.right": "dešinėn",
    "wedo2.tiltDirection.up": "aukštyn",
    "wedo2.whenDistance": "kai atstumas [OP] [REFERENCE]",
    "wedo2.whenTilted": "kai paversta [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Spalva",
    "paint.paintEditor.saturation": "Sodrumas",
    "paint.paintEditor.brightness": "Šviesumas",
    "paint.paintEditor.costume": "Kaukė",
    "paint.paintEditor.group": "Grupuoti",
    "paint.paintEditor.ungroup": "Išgrupuoti",
    "paint.paintEditor.undo": "Atšaukti",
    "paint.paintEditor.redo": "Grąžinti",
    "paint.paintEditor.forward": "Artyn",
    "paint.paintEditor.backward": "Tolyn",
    "paint.paintEditor.front": "Į priekį",
    "paint.paintEditor.back": "Atgal",
    "paint.paintEditor.more": "Daugiau",
    "paint.modeTools.brushSize": "Dydis",
    "paint.modeTools.eraserSize": "Trintuko dydis",
    "paint.modeTools.copy": "Kopijuoti",
    "paint.modeTools.paste": "Įklijuoti",
    "paint.modeTools.delete": "Šalinti",
    "paint.modeTools.curved": "Lenktas",
    "paint.modeTools.pointed": "Tiesus",
    "paint.modeTools.thickness": "Storis",
    "paint.modeTools.flipHorizontal": "Apversti horizontaliai",
    "paint.modeTools.flipVertical": "Apversti vertikaliai",
    "paint.modeTools.filled": "Užpildyta",
    "paint.modeTools.outlined": "Su kontūru",
    "paint.paintEditor.bitmap": "Keisti į piešinį taškais",
    "paint.paintEditor.vector": "Keisti į piešinį linijomis",
    "paint.paintEditor.fill": "Užpildymas",
    "paint.paintEditor.stroke": "Kontūrai",
    "paint.brushMode.brush": "Teptukas",
    "paint.eraserMode.eraser": "Trintukas",
    "paint.fillMode.fill": "Užpildyti",
    "paint.lineMode.line": "Linija",
    "paint.ovalMode.oval": "Apskritimas",
    "paint.rectMode.rect": "Stačiakampis",
    "paint.reshapeMode.reshape": "Pakeisti formą",
    "paint.roundedRectMode.roundedRect": "Užapvalintas stačiakampis",
    "paint.selectMode.select": "Pažymėti",
    "paint.textMode.text": "Tekstas",
    "paint.colorPicker.swap": "Sukeisti"
  },
  "hu": {
    "gui.alerts.lostPeripheralConnection": "A Scratch elvesztette a kapcsolatot ezzel: {extensionName}.",
    "gui.alerts.tryAgain": "Próbáld újra",
    "gui.alerts.download": "Letöltés",
    "gui.connection.reconnect": "Csatlakozz újra",
    "gui.backpack.costumeLabel": "jelmez",
    "gui.backpack.soundLabel": "hang",
    "gui.backpack.scriptLabel": "kód",
    "gui.backpack.spriteLabel": "szereplő",
    "gui.backpack.header": "Tálca",
    "gui.backpack.errorBackpack": "Hiba a tálca betöltésekor",
    "gui.backpack.loadingBackpack": "Betöltés...",
    "gui.backpack.more": "Több",
    "gui.backpack.emptyBackpack": "A tálca üres",
    "gui.unsupportedBrowser.label": "A böngésző nem támogatott",
    "gui.unsupportedBrowser.errorLabel": "Hiba történt",
    "gui.unsupportedBrowser.notRecommended": "Sajnáljuk, de úgy tűnik, olyan böngészőverziót használsz, amit a Scratch nem támogat. Javasoljuk, hogy frissíts egy támogatott böngésző legújabb verziójára, mint a  Google Chrome, a Mozilla Firefox, a Microsoft Edge vagy az Apple Safari.",
    "gui.unsupportedBrowser.description": "Sajnáljuk, de a Scratch nem támogatja ezt a böngészőt. Javasoljuk, hogy frissíts egy támogatott böngésző legújabb verziójára, mint a  Google Chrome, a Mozilla Firefox, a Microsoft Edge vagy az Apple Safari.",
    "gui.unsupportedBrowser.back": "Vissza",
    "gui.unsupportedBrowser.previewfaq": "Ha szeretnél többet megtuni, menj ide {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "GYIK",
    "gui.cards.all-tutorials": "Gyakorlatok",
    "gui.cards.shrink": "Kicsinyítés",
    "gui.cards.expand": "Kibont",
    "gui.cards.close": "Bezár",
    "gui.cards.more-things-to-try": "Még több minden kipróbálható!",
    "gui.cards.see-more": "Még több",
    "gui.comingSoon.message1": "Ne aggódj, rajta vagyunk {emoji}",
    "gui.comingSoon.message2": "Hamarosan...",
    "gui.comingSoon.message3": "Dolgozunk rajta {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nem találtunk eszközöket",
    "gui.connection.auto-scanning.prescan": "Legyen a készüléked a közelben, majd kezd meg a keresést.",
    "gui.connection.auto-scanning.pressbutton": "Nyomd meg a gombot az eszközödön.",
    "gui.connection.auto-scanning.start-search": "Keresés indítása",
    "gui.connection.connecting-searchbutton": "Keresés...",
    "gui.connection.auto-scanning.try-again": "Próbáld újra",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Csatlakoztatva",
    "gui.connection.disconnect": "Szétkapcsolás",
    "gui.connection.go-to-editor": "Menj a szerkesztőbe",
    "gui.connection.connecting-cancelbutton": "Csatlakozás…",
    "gui.connection.error.errorMessage": "Hoppá, úgy tűnik valami rosszul sikerült.",
    "gui.connection.error.tryagainbutton": "Próbáld újra",
    "gui.connection.error.helpbutton": "Súgó",
    "gui.connection.peripheral-name-label": "Eszköz neve",
    "gui.connection.connect": "Csatlakozás",
    "gui.connection.scanning.lookingforperipherals": "Készülékek keresése",
    "gui.connection.scanning.noPeripheralsFound": "Nem találtunk eszközöket",
    "gui.connection.scanning.instructions": "Válaszd ki az eszközödet a fenti listából.",
    "gui.connection.search": "Frissítés",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Győződj meg róla, hogy a Scratch Link telepítve van és fut",
    "gui.connection.unavailable.enablebluetooth": "Ellenőrizd, hogy a Bluetooth engedélyezve van-e",
    "gui.connection.unavailable.tryagainbutton": "Próbáld újra",
    "gui.connection.unavailable.helpbutton": "Súgó",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Indulás",
    "gui.controls.stop": "Állj",
    "gui.crashMessage.label": "Hoppá! Valami rosszul sikerült.",
    "gui.crashMessage.description": "Sajnáljuk, de úgy tűnik, a Scratch összeomlott. Ez a hiba aurtomatikusan jelentésre került a Scratch csapatának. Az újabb próbálkozáshoz frissítsd az oldalt. ",
    "gui.crashMessage.errorNumber": "A hibádat ezzel az azonosítóval naplóztuk: {errorId}",
    "gui.crashMessage.reload": "Újratöltés",
    "gui.customProcedures.myblockModalTitle": "Blokk létrehozása",
    "gui.customProcedures.addAnInputNumberText": "Bemenet hozzáadása",
    "gui.customProcedures.numberTextType": "szám vagy szöveg",
    "gui.customProcedures.addAnInputBoolean": "Bemenet hozzáadása",
    "gui.customProcedures.booleanType": "logikai",
    "gui.customProcedures.addALabel": "Címke hozzáadás",
    "gui.customProcedures.runWithoutScreenRefresh": "Futtatás képernyőfrissítés nélkül",
    "gui.customProcedures.cancel": "Mégsem",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Irány",
    "gui.directionPicker.rotationStyles.allAround": "Mindenfelé",
    "gui.directionPicker.rotationStyles.leftRight": "Balra-jobbra",
    "gui.directionPicker.rotationStyles.dontRotate": "Nem foroghat",
    "gui.gui.addExtension": "Bővítmény hozzáadása",
    "gui.gui.codeTab": "Kód",
    "gui.gui.backdropsTab": "Hátterek",
    "gui.gui.costumesTab": "Jelmezek",
    "gui.gui.soundsTab": "Hangok",
    "gui.extensionLibrary.comingSoon": "Hamarosan",
    "gui.extensionLibrary.requires": "Igények",
    "gui.extensionLibrary.collaboration": "Együttműködés",
    "gui.library.filterPlaceholder": "Keresés",
    "gui.library.allTag": "Minden",
    "gui.loader.message1": "Blokkok létrhozása ...",
    "gui.loader.message2": "Szereplők betöltése ...",
    "gui.loader.message3": "Hangok betöltése ...",
    "gui.loader.message4": "Bővítmények betöltése ...",
    "gui.loader.message5": "Vadászó macskák...",
    "gui.loader.message6": "A nanók átvitele ...",
    "gui.loader.message7": "A gobók megnövelése ...",
    "gui.loader.message8": "Emojik előkészítése ...",
    "gui.loader.headline": "Projekt betöltése",
    "gui.loader.creating": "Projekt létrehozása",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Saját dolgaim",
    "gui.accountMenu.myClasses": "Az osztályaim",
    "gui.accountMenu.myClass": "Az osztályom",
    "gui.accountMenu.accountSettings": "Fiókbeállítások",
    "gui.accountMenu.signOut": "Kijelentkezés",
    "gui.authorInfo.byUser": "{username} által",
    "gui.menuBar.seeProjectPage": "Vissza a projekt oldalára",
    "gui.menuBar.language": "Language",
    "general.username": "Felhasználónév",
    "general.password": "Jelszó",
    "general.signIn": "Jelentkezz be",
    "login.needHelp": "Segítséget szeretnél?",
    "form.validationRequired": "Ez a mező kötelező",
    "gui.menuBar.tutorialsLibrary": "Gyakorlatok",
    "gui.menuBar.restoreSprite": "Szereplő helyreállítása",
    "gui.menuBar.restoreSound": "Hang visszaállítása",
    "gui.menuBar.restoreCostume": "Jelmez visszaállítása",
    "gui.menuBar.restore": "Helyreállítás",
    "gui.menuBar.saveNow": "Mentés most",
    "gui.menuBar.saveAsCopy": "Mentés másolatként",
    "gui.menuBar.remix": "Remixelés",
    "gui.menuBar.new": "Új",
    "gui.menuBar.file": "Fájl",
    "gui.menuBar.downloadToComputer": "Letöltés saját gépre",
    "gui.menuBar.edit": "Szerkesztés",
    "gui.menuBar.turboModeOff": "Turbó mód kikapcsolása",
    "gui.menuBar.turboModeOn": "Turbó mód bekapcsolása",
    "gui.menuBar.modeMenu": "Mód",
    "gui.menuBar.normalMode": "Rendes kinézet",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Regisztrálj",
    "gui.menuBar.signIn": "Jelentkezz be",
    "gui.gui.projectTitlePlaceholder": "Project címe",
    "gui.menuBar.saveNowLink": "Mentés most",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Megosztva",
    "gui.menuBar.share": "Megosztás",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Súgó",
    "gui.modal.back": "Vissza",
    "gui.monitor.listMonitor.empty": "(üres)",
    "gui.monitor.listMonitor.listLength": "hosszúság {length}",
    "gui.monitor.contextMenu.default": "normál kijelző",
    "gui.monitor.contextMenu.large": "nagy kijelző",
    "gui.monitor.contextMenu.slider": "csúszka",
    "gui.monitor.contextMenu.sliderRange": "csúszka tartomány megváltoztatása",
    "gui.monitor.contextMenu.import": "importálás",
    "gui.monitor.contextMenu.export": "exportálás",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Lejátszás",
    "gui.playButton.stop": "Állj",
    "gui.gui.variableScopeOptionAllSprites": "Minden szereplőé",
    "gui.gui.variableScopeOptionSpriteOnly": "A kiválasztott szereplőé",
    "gui.gui.cloudVariableOption": "Megosztott változó (szerveren tárolt)",
    "gui.gui.variablePromptAllSpritesMessage": "Ez a változó minden szereplőek elérhető lesz",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Mégsem",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Állj",
    "gui.playbackStep.playMsg": "Lejátszás",
    "gui.playbackStep.loadingMsg": "Betöltés...",
    "gui.playbackStep.saveMsg": "Mentés",
    "gui.playbackStep.reRecordMsg": "Újrafelvétel",
    "gui.recordModal.title": "Hang felvétele",
    "gui.recordingStep.beginRecord": "Az alábbi gombra kattintva kezdheted a felvételt",
    "gui.recordingStep.permission": "{arrow}Az engedélyedre van szükségünk a mikrofonod használatához ",
    "gui.recordingStep.stop": "Felvétel leállítása",
    "gui.recordingStep.record": "Felvétel",
    "gui.sliderModal.min": "Minimum érték",
    "gui.sliderModal.max": "Maximum érték",
    "gui.sliderModal.title": "Csúszka tartomány megváltoztatása",
    "gui.sliderPrompt.cancel": "Mégsem",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Hang",
    "gui.soundEditor.play": "Lejátszás",
    "gui.soundEditor.stop": "Állj",
    "gui.soundEditor.copy": "Másolás",
    "gui.soundEditor.paste": "Beillesztés",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Törlés",
    "gui.soundEditor.save": "Mentés",
    "gui.soundEditor.undo": "Visszavonás",
    "gui.soundEditor.redo": "Mégis",
    "gui.soundEditor.faster": "Gyorsabban",
    "gui.soundEditor.slower": "Lassabban",
    "gui.soundEditor.echo": "Visszhang",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Hangosabban",
    "gui.soundEditor.softer": "Lágyabban",
    "gui.soundEditor.reverse": "Visszafelé",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Lenémítás",
    "gui.SpriteInfo.spritePlaceholder": "Név",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Szereplő",
    "gui.SpriteInfo.show": "Megjelenítés",
    "gui.SpriteInfo.size": "Méret",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplikálás",
    "gui.spriteSelectorItem.contextMenuExport": "exportálás",
    "gui.spriteSelectorItem.contextMenuDelete": "törlés",
    "gui.spriteSelector.addSpriteFromLibrary": "Válassz szereplőt",
    "gui.spriteSelector.addSpriteFromPaint": "Festés",
    "gui.spriteSelector.addSpriteFromSurprise": "Meglepetés",
    "gui.spriteSelector.addSpriteFromFile": "Szereplő feltöltés",
    "gui.stageHeader.stageSizeLarge": "Váltás nagy színpadra",
    "gui.stageHeader.stageSizeSmall": "Váltás kicsi színpadra",
    "gui.stageHeader.stageSizeFull": "Lépj be teljes képernyős üzemmódba",
    "gui.stageHeader.stageSizeUnFull": "Teljes képernyős üzemmód elhagyása",
    "gui.stageHeader.fullscreenControl": "A teljes képernyő szabályozása",
    "gui.spriteSelector.addBackdropFromLibrary": "Válassz hátteret",
    "gui.stageSelector.addBackdropFromPaint": "Festés",
    "gui.stageSelector.addBackdropFromSurprise": "Meglepetés",
    "gui.stageSelector.addBackdropFromFile": "Háttér feltöltése",
    "gui.stageSelector.stage": "Színpad",
    "gui.stageSelector.backdrops": "Hátterek",
    "gui.telemetryOptIn.label": "Statisztikák jelentése a Scratch javításához",
    "gui.telemetryOptIn.body1": "A Scratch Team mindig arra törekszik, hogy jobban megértse, hogyan használják a Scratch-et a világban. Az erőfeszítés támogatása érdekében engedélyezheti a Scratch számára, hogy automatikusan küldjön használati adatokat a Scratch Teamnek.",
    "gui.telemetryOptIn.body2": "Az általunk gyűjtött információk magukban foglalják a nyelvválasztást, a blokkok használatát és bizonyos eseményeket, mint például a mentés, a betöltés és egy projekt feltöltése. NEM gyűjtünk személyes adatokat. További információért olvasd el {privacyPolicyLink}adatvédelmi szabályzatunkat.",
    "gui.telemetryOptIn.privacyPolicyLink": "Adatvédelem",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Bezár",
    "gui.turboMode.active": "Turbó mód",
    "gui.webglModal.label": "A böngésződ nem támogatja a WebGL-t",
    "gui.webglModal.description": "A böngésződ vagy a számítógéped sajnálatos módon {webGlLink}. Ahhoz, hogy a Scratch 3.0 működjön, ez a technológia kell.",
    "gui.webglModal.webgllink": "WebGL nem támogatott",
    "gui.webglModal.back": "Vissza",
    "gui.webglModal.previewfaq": "Ha szeretnél többet megtuni, menj ide {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "GYIK",
    "gui.costumeLibrary.chooseABackdrop": "Válassz hátteret",
    "gui.costumeLibrary.chooseACostume": "Válassz jelmezt",
    "gui.costumeTab.addBackdropFromLibrary": "Válassz hátteret",
    "gui.costumeTab.addCostumeFromLibrary": "Válassz jelmezt",
    "gui.costumeTab.addBlankCostume": "Festés",
    "gui.costumeTab.addSurpriseCostume": "Meglepetés",
    "gui.costumeTab.addFileBackdrop": "Háttér feltöltése",
    "gui.costumeTab.addFileCostume": "Jelmez feltöltése",
    "gui.extensionLibrary.chooseAnExtension": "Válassz bővítményt",
    "gui.extensionLibrary.extensionUrl": "Írd be a bővítmény URL-jét",
    "gui.monitors.importListColumnPrompt": "Melyik oszlopot használjuk (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nem lehet elkezdeni a felvételt",
    "gui.soundLibrary.chooseASound": "Válassz hangot",
    "gui.soundTab.fileUploadSound": "Hang feltöltése",
    "gui.soundTab.surpriseSound": "Meglepetés",
    "gui.soundTab.recordSound": "Felvétel",
    "gui.soundTab.addSoundFromLibrary": "Válassz hangot",
    "gui.spriteLibrary.chooseASprite": "Válassz szereplőt",
    "gui.tipsLibrary.tutorials": "Válassz gyakorlatot",
    "gui.alerts.createsuccess": "Új projekt létrehozva.",
    "gui.alerts.createcopysuccess": "Projekt elmentve másolatként.",
    "gui.alerts.createremixsuccess": "Projekt elmentve remixként.",
    "gui.alerts.creating": "Új létrehozása...",
    "gui.alerts.creatingCopy": "Projekt másolása...",
    "gui.alerts.creatingRemix": "Projekt remixelése...",
    "gui.alerts.creatingError": "Nem lehetett létrehozni a projektet. Kérlek próbáld újra!",
    "gui.alerts.savingError": "A projektet nem lehet elmenteni.",
    "gui.alerts.savesuccess": "Projekt elmentve.",
    "gui.alerts.saving": "Projekt mentése...",
    "gui.alerts.cloudInfo": "Kérjük, vedd figyelembe, hogy a megosztott változó csak számot tárolhat, betűt vagy szimbólumot nem. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "További információ.",
    "gui.alerts.importing": "Importálás...",
    "gui.defaultProject.meow": "Miaú",
    "gui.defaultProject.variable": "az én változóm",
    "gui.howtos.intro-move-sayhello-hat.name": "Kezdő lépések",
    "gui.howtos.intro-move.step_stepMove": "Adj hozzá mozgás blokkot",
    "gui.howtos.add-a-move-block.step_stepSay": "Adj hozzá egy mond blockot",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Kattints a zöld zászlóra a kezdéshez",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animálj egy nevet",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Válassz egy betű szereplőt",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Hang lejátszása kattintáskor",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Válassz még egy betű szereplőt",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Változtasd meg a színt",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Válassz egy másik betű szereplőt és növeld meg.",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Válassz egy másik betű szereplőt és növeld meg.",
    "gui.howtos.imagine": "Képzelj el egy világot",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Írd Be Amit Mondani Szeretnél",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Nyomd meg a zöld zászlót az indításhoz",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Válassz egy hátteret",
    "gui.howtos.imagine.step_imagineChooseSprite": "Válassz egy szereplőt",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Válassz egy másik szereplőt",
    "gui.howtos.imagine.step_imagineLeftRight": "Mozogj balra-jobbra",
    "gui.howtos.imagine.step_imagineUpDown": "Mozogj fel-le",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Csússz egy ponthoz",
    "gui.howtos.imagine.step_imagineGrowShrink": "Növekedés és zsugorodás",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Válassz egy másik hátteret",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cseréld ki a háttereket",
    "gui.howtos.imagine.step_imagineRecordASound": "Hang hozzáadása",
    "gui.howtos.imagine.step_imagineChooseSound": "Válaszd ki a hangot",
    "gui.howtos.make-music.name": "Szerezz zenét",
    "gui.howtos.Make-Music.step_PickInstrument": "Válassz egy hangszer szereplőt",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Hang lejátszása kattintáskor",
    "gui.howtos.Make-Music.step_MakeSong": "Készíts egy dalt",
    "gui.howtos.make-music.step_MakeBeat": "Válassz egy dobot és alkoss ritmust",
    "gui.howtos.make-music.step_MakeBeatBox": "Válaszd ki a mikrofon szereplőt és a meglepetés beatboxot",
    "gui.howtos.story.name": "Hozz létre egy történetet",
    "gui.howtos.story.step_addbg": "Adj hozzá hátteret",
    "gui.howtos.story.step_addsprite": "Adj hozzá egy karaktert",
    "gui.howtos.story.step_saysomething": "Mondj valamit",
    "gui.howtos.story.step_addanothersprite": "Adj hozzá még egy karaktert",
    "gui.howtos.story.step_flip": "Megfordulás iránya",
    "gui.howtos.story.step_conversation": "Beszélgess",
    "gui.howtos.story.addanotherbg": "Adj hozzá egy újabb hátteret",
    "gui.howtos.story.step_swithbg": "Cseréld ki a háttereket",
    "gui.howtos.story.step_hidewizard": "Rejts el egy karaktert",
    "gui.howtos.story.step_showwizard": "Jeleníts meg egy karaktert",
    "gui.howtos.make-a-chase-game.name": "Készíts egy üldözős játékot",
    "gui.howtos.Chase-Game.step_BG": "Adj hozzá hátteret",
    "gui.howtos.chase-game.step_AddOcto": "Adj hozzá szereplőt",
    "gui.howtos.make-music.step_LeftRight": "Mozogj jobbra és balra a nyilakkal",
    "gui.howtos.Chase-Game.step_UpDown": "Mozogj fel és le a nyilakkal",
    "gui.howtos.Chase-Game.step_AddStar": "Adj hozzá még egy szereplőt",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mozgatás véletlenszerűen",
    "gui.howtos.Chase-Game.step_WhenTouch": "A polip szereplőnél, ha érinti, játssz le hangot",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Hozz létre egy pontszám változót",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "A polip szereplőnél, ha érinti, növeld a pontszámot",
    "gui.howtos.animate-char.name": "Animálj egy karaktert",
    "gui.howtos.animate-char.step_addbg": "Adj hozzá hátteret",
    "gui.howtos.animate-char.step_addsprite": "Adj hozzá szereplőt",
    "gui.howtos.animate-char.step_saysomething": "Mondj valamit",
    "gui.howtos.animate-char.step_addsound": "Adj hozzá hangot",
    "gui.howtos.animate-char.step_animatetalking": "Animáld a beszédet",
    "gui.howtos.animate-char.step_arrowkeys": "Mozogj a nyilakkal",
    "gui.howtos.animate-char.step_jump": "Ugorj",
    "gui.howtos.animate-char.step_changecolor": "Módosíts színt",
    "gui.howtos.make-a-game.name": "Készíts egy Klikkelős játékot",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Válassz szereplőt",
    "gui.howtos.make-a-game.step_GamePlaySound": "Hang lejátszása kattintáskor",
    "gui.howtos.make-a-game.step_GameAddScore": "Hozz létre egy pontszám változót",
    "gui.howtos.make-a-game.step_GameChangeScore": "Amikor a szereplőre kattintottak, növeld a pontszámot",
    "gui.howtos.make-a-game.step_Random": "Menj egy véletlen helyre",
    "gui.howtos.make-music.step_GameChangeColor": "Szín módosítása",
    "gui.howtos.make-music.step_ResetScore": "Pontszám lenullázása",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Válassz szereplőt",
    "gui.howtos.fly.step_stepflySaySomething": "Mondj valamit",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mozogj a nyílbillentyükkel",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Válaszd ki a szereplődet",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Pontszám hozzáadása",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Pontszám megtartása",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Következő jelmez",
    "gui.howtos.pong": "Pong játék",
    "gui.howtos.pong.step_pongAddBackdrop": "Adj hozzá hátteret",
    "gui.howtos.pong.step_pongAddBallSprite": "Adj hozzá egy labdát szereplőként",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Válaszd ki a labdát",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Pontszám hozzáadása",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Pontszám lenullázása",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Játék vége",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Válassz egy másik szereplőt",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Válassz egy másik szereplőt",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Ugorj fel és le",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Csússz körbe",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Válts jelmezeket",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animálj egy kalandjátékot",
    "gui.howtos.cartoon-network.step_CNcharacter": "Válaszd ki a megjeleníteni kívánt karakteredet",
    "gui.howtos.cartoon-network.step_CNsay": "Mondj valamit",
    "gui.howtos.cartoon-network.step_CNglide": "Csússz körbe",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Válassz ki egy üldözendő tárgyat ",
    "gui.howtos.cartoon-network.step_CNcollect": "Gyűjts tárgyakat",
    "gui.howtos.cartoon-network.step_CNvariable": "Hozz létre egy pontszám változót",
    "gui.howtos.cartoon-network.step_CNscore": "Pontszám megtartása",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Szintlépés: a háttér megváltoztatása",
    "gui.howtos.videosens.name": "Videóérzékelés",
    "gui.howtos.videosens.step_addextension": "Bővítmény hozzáadása",
    "gui.howtos.videosens.step_pet": "Dédelgessük a macskát",
    "gui.howtos.videosens.step_animate": "Animálj",
    "gui.howtos.videosens.step_pop": "Pukkassz ki egy léggömböt",
    "gui.howtos.say-it-out-loud": "Beszélő animációk létrehozása",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Text to Speech blokkok hozzáadása",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Mondj valamit",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Állíts be egy hangot",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Menj körbe",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Adj hozzá hátteret",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Adj hozzá még egy karaktert",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Adj elő egy dalt",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Szín módosítása",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Forogj körbe",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Növekedés és zsugorodás",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Válassz szereplőt",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Válassz hátteret",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Válassz egy másik szereplőt",
    "gui.howtos.talking.step_talesMoveAround": "Menj körbe",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Válassz egy másik hátteret",
    "gui.howtos.talking.step_talesAnimateTalking": "Animáld a beszédet",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Válassz egy másik hátteret",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Táncmozdulatok",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Adj hozzá szereplőt",
    "gui.howtos.add-sprite.step_addSprite": "Adj hozzá szereplőt",
    "gui.howtos.add-a-backdrop.name": "Adj hozzá hátteret",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Adj hozzá hátteret",
    "gui.howtos.change-size.name": "Módosítsd a méretet",
    "gui.howtos.change-size.step_changeSize": "Módosítsd a méretet",
    "gui.howtos.glide-around.name": "Csússz körbe",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Csússz körbe",
    "gui.howtos.change-size.step_glideAroundPoint": "Csússz egy ponthoz",
    "gui.howtos.record-a-sound.name": "Vegyél fel hangot",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Kattints a „felvétel” gombra",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Válaszd ki a hangot",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Forgasd meg",
    "gui.howtos.change-size.step_spinTurn": "Fordulj",
    "gui.howtos.change-size.step_spinPointInDirection": "Nézz az adott irányba",
    "gui.howtos.hide-and-show.name": "Rejtsd el és mutasd meg",
    "gui.howtos.change-size.step_hideAndShow": "Rejtsd el és mutasd meg",
    "gui.howtos.switch-costume.name": "Animálj egy szereplőt",
    "gui.howtos.change-size.step_switchCostumes": "Animálj egy szereplőt",
    "gui.howtos.move-around-with-arrow-keys.name": "Használd a nyilakat",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mozogj balra és jobbra",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mozogj fel és le",
    "gui.howtos.add-effects.name": "Adj hozzá hatásokat",
    "gui.howtos.videosens.step_addEffects": "Adj hozzá hatásokat",
    "gui.extension.music.name": "Zene",
    "gui.extension.music.description": "Játssz a hangszereken és a dobokon.",
    "gui.extension.pen.name": "Toll",
    "gui.extension.pen.description": "Rajzolj a szereplőkkel",
    "gui.extension.videosensing.name": "Videóérzékelés",
    "gui.extension.videosensing.description": "Érzékeld a mozgást a kamerával.",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Készíts beszélő projekteket",
    "gui.extension.translate.name": "Fordítás",
    "gui.extension.translate.description": "Fordítsd le a szöveget sok nyelvre.",
    "gui.extension.makeymakey.description": "Változtass mindent kulcssá.",
    "gui.extension.microbit.description": "Kapcsold össze a programjaidat a világgal.",
    "gui.extension.microbit.connectingMessage": "Kapcsolódás",
    "gui.extension.ev3.description": "Építs interaktív robotokat és sok mást.",
    "gui.extension.ev3.connectingMessage": "Csatlakozás. Győződj meg róla, hogy az EV3-ban lévő tű 1234-re van állítva.",
    "gui.extension.boost.description": "Keltsd életre robot alkotásaidat.",
    "gui.extension.boost.connectingMessage": "Kapcsolódás",
    "gui.extension.wedo2.description": "Építs motorokkal és érzékelőkkel.",
    "gui.extension.wedo2.connectingMessage": "Kapcsolódás",
    "gui.extension.gdxfor.description": "Nyomás, húzás, mozgás és forgás érzékelése.",
    "gui.extension.gdxfor.connectingMessage": "Kapcsolódás",
    "gui.libraryTags.all": "Minden",
    "gui.libraryTags.animals": "Állatok",
    "gui.libraryTags.dance": "Tánc",
    "gui.libraryTags.effects": "Hatások",
    "gui.libraryTags.fantasy": "Fantázia",
    "gui.libraryTags.fashion": "Divat",
    "gui.libraryTags.food": "Étel",
    "gui.libraryTags.indoors": "Beltér",
    "gui.libraryTags.loops": "Ciklusok",
    "gui.libraryTags.music": "Zene",
    "gui.libraryTags.notes": "Hangjegyek",
    "gui.libraryTags.outdoors": "Kültér",
    "gui.libraryTags.patterns": "Minták",
    "gui.libraryTags.people": "Emberek",
    "gui.libraryTags.percussion": "Ütőhangszerek",
    "gui.libraryTags.space": "Űr",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Vízalatt",
    "gui.libraryTags.voice": "Hang",
    "gui.libraryTags.wacky": "Hóbortos",
    "gui.libraryTags.animation": "Animáció",
    "gui.libraryTags.art": "Művészet",
    "gui.libraryTags.games": "Játékok",
    "gui.libraryTags.stories": "Történetek",
    "gui.libraryTags.letters": "Betűk",
    "gui.opcodeLabels.direction": "iránya",
    "gui.opcodeLabels.xposition": "x helyzete",
    "gui.opcodeLabels.yposition": "y helyzete",
    "gui.opcodeLabels.size": "mérete",
    "gui.opcodeLabels.costumename": "jelmez neve",
    "gui.opcodeLabels.costumenumber": "jelmez száma",
    "gui.opcodeLabels.backdropname": "háttér neve",
    "gui.opcodeLabels.backdropnumber": "háttér száma",
    "gui.opcodeLabels.volume": "hangereje",
    "gui.opcodeLabels.tempo": "tempó",
    "gui.opcodeLabels.answer": "válasz",
    "gui.opcodeLabels.loudness": "hangerő",
    "gui.opcodeLabels.username": "felhasználó",
    "gui.opcodeLabels.year": "év",
    "gui.opcodeLabels.month": "hónap",
    "gui.opcodeLabels.date": "nap",
    "gui.opcodeLabels.dayofweek": "hét napja",
    "gui.opcodeLabels.hour": "óra",
    "gui.opcodeLabels.minute": "perc",
    "gui.opcodeLabels.second": "másodperc",
    "gui.opcodeLabels.timer": "időmérő",
    "gui.projectLoader.loadError": "A kiválasztott projekt fájlt nem sikerült betölteni.",
    "gui.sharedMessages.backdrop": "háttér{index}",
    "gui.sharedMessages.costume": "jelmez{index}",
    "gui.sharedMessages.sprite": "szereplő{index}",
    "gui.sharedMessages.pop": "pukk",
    "gui.sharedMessages.replaceProjectWarning": "Meglévő projekt tartalmának felülírása?",
    "gui.sharedMessages.loadFromComputerTitle": "Feltöltés saját gépről",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch project",
    "boost.color.any": "bármely szín",
    "boost.color.black": "fekete",
    "boost.color.blue": "kék",
    "boost.color.green": "zöld",
    "boost.color.red": "piros",
    "boost.color.white": "fehér",
    "boost.color.yellow": "sárga",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] motor pozíciója",
    "boost.getTiltAngle": "[TILT_DIRECTION] billenési szög",
    "boost.motorDirection.backward": "arra",
    "boost.motorDirection.forward": "erre",
    "boost.motorDirection.reverse": "visszafelé",
    "boost.motorOff": "[MOTOR_ID] motor kikapcsolása",
    "boost.motorOn": "[MOTOR_ID] motor bekapcsolása",
    "boost.motorOnFor": "[MOTOR_ID] motor bekapcsolása [DURATION] másodpercig",
    "boost.motorOnForRotation": "[MOTOR_ID] motor bekapcsolása [ROTATION] fordulatra",
    "boost.seeingColor": "látsz [COLOR] téglát?",
    "boost.setLightHue": "lámpa színe legyen [HUE]",
    "boost.setMotorDirection": "[MOTOR_ID] motor beállítása [MOTOR_DIRECTION] irányba",
    "boost.setMotorPower": "[MOTOR_ID] motor sebessége legyen [POWER]%",
    "boost.tiltDirection.any": "bármelyik",
    "boost.tiltDirection.down": "le",
    "boost.tiltDirection.left": "balra",
    "boost.tiltDirection.right": "jobbra",
    "boost.tiltDirection.up": "fel",
    "boost.whenColor": "ha [COLOR] téglát látsz",
    "boost.whenTilted": "amikor [TILT_DIRECTION_ANY] irányba billentve",
    "ev3.beepNote": "[NOTE] hangjelzés lejátszása [TIME] másodpercig",
    "ev3.buttonPressed": "[PORT] gomb lenyomva?",
    "ev3.getBrightness": "fényerő",
    "ev3.getDistance": "távolság",
    "ev3.getMotorPosition": "[PORT] motor pozíciója",
    "ev3.motorSetPower": "[PORT] motor teljesítménye legyen [POWER] %",
    "ev3.motorTurnClockwise": "[PORT] motor forduljon erre [TIME] másodpercig",
    "ev3.motorTurnCounterClockwise": "[PORT] motor forduljon arra [TIME] másodpercig",
    "ev3.whenBrightnessLessThan": "amikor a fényerő < [DISTANCE]",
    "ev3.whenButtonPressed": "amikor [PORT] gomb lenyomva",
    "ev3.whenDistanceLessThan": "amikor a távolság < [DISTANCE]",
    "gdxfor.getAcceleration": "gyorsulás [DIRECTION] irányban",
    "gdxfor.getForce": "erő",
    "gdxfor.getSpin": "forgási sebesség [DIRECTION] irányban",
    "gdxfor.getTilt": "billenés szög [TILT]",
    "gdxfor.isFreeFalling": "zuhan?",
    "gdxfor.isTilted": "billen [TILT]?",
    "gdxfor.pulled": "meghúzva",
    "gdxfor.pushed": "benyomva",
    "gdxfor.shaken": "megrázva",
    "gdxfor.startedFalling": "zuhanni kezdett",
    "gdxfor.tiltDirectionMenu.any": "bármelyik",
    "gdxfor.tiltDirectionMenu.back": "leghátra",
    "gdxfor.tiltDirectionMenu.front": "legelőre",
    "gdxfor.tiltDirectionMenu.left": "balra",
    "gdxfor.tiltDirectionMenu.right": "jobbra",
    "gdxfor.turnedFaceDown": "lefelé fordítva",
    "gdxfor.turnedFaceUp": "felfelé fordítva",
    "gdxfor.whenForcePushedOrPulled": "amikor az erő-szenzor [PUSH_PULL]",
    "gdxfor.whenGesture": "amikor [GESTURE]",
    "gdxfor.whenTilted": "amikor billen [TILT]",
    "makeymakey.downArrow": "lefele nyíl",
    "makeymakey.downArrowShort": "le",
    "makeymakey.leftArrow": "balra nyíl",
    "makeymakey.leftArrowShort": "balra",
    "makeymakey.rightArrow": "jobbra nyíl",
    "makeymakey.rightArrowShort": "jobbra",
    "makeymakey.spaceKey": "szóköz",
    "makeymakey.upArrow": "felfele nyíl",
    "makeymakey.upArrowShort": "fel",
    "makeymakey.whenKeyPressed": "amikor [KEY] gomb lenyomva",
    "makeymakey.whenKeysPressedInOrder": "amikor [SEQUENCE] sorban lenyomva",
    "microbit.buttonsMenu.any": "bármelyik",
    "microbit.clearDisplay": "kijelző törlése",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "[MATRIX] megjelenítése",
    "microbit.displayText": "[TEXT] szöveg megjelenítése",
    "microbit.gesturesMenu.jumped": "átugrott",
    "microbit.gesturesMenu.moved": "elmozdult",
    "microbit.gesturesMenu.shaken": "megrázva",
    "microbit.isButtonPressed": "[BTN] gomb megnyomva?",
    "microbit.isTilted": "[DIRECTION] irányba billentve ?",
    "microbit.pinStateMenu.off": "ki",
    "microbit.pinStateMenu.on": "be",
    "microbit.tiltAngle": "[DIRECTION] billenési szög",
    "microbit.tiltDirectionMenu.any": "bármelyik",
    "microbit.tiltDirectionMenu.back": "hátul",
    "microbit.tiltDirectionMenu.front": "elöl",
    "microbit.tiltDirectionMenu.left": "balra",
    "microbit.tiltDirectionMenu.right": "jobbra",
    "microbit.whenButtonPressed": "amikor [BTN] gomb megnyomva",
    "microbit.whenGesture": "amikor [GESTURE]",
    "microbit.whenPinConnected": "amikor pin [PIN] csatlakoztatva",
    "microbit.whenTilted": "amikor [DIRECTION] irányba billentve",
    "music.categoryName": "Zene",
    "music.changeTempo": "tempó változzon [TEMPO]",
    "music.drumBass": "(2) Nagydob",
    "music.drumBongo": "(13) Bongó",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Kasztanyetta",
    "music.drumClosedHiHat": "(6) Zárt Hi-Hat",
    "music.drumConga": "(14) Konga",
    "music.drumCowbell": "(11) Kolomp",
    "music.drumCrashCymbal": "(4) Cintányér",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Taps",
    "music.drumOpenHiHat": "(5) Nyitott Hi-Hat",
    "music.drumSideStick": "(3) Dob pereme",
    "music.drumSnare": "(1) Pergődob",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangulum",
    "music.drumVibraslap": "(17) Kereplő",
    "music.drumWoodBlock": "(10) Fa kocka",
    "music.getTempo": "tempó",
    "music.instrumentBass": "(6) Basszus",
    "music.instrumentBassoon": "(14) Basszuskürt",
    "music.instrumentCello": "(8) Cselló",
    "music.instrumentChoir": "(15) Kórus",
    "music.instrumentClarinet": "(10) Klarinét",
    "music.instrumentElectricGuitar": "(5) Elektromos gitár",
    "music.instrumentElectricPiano": "(2) Elektromos zongora",
    "music.instrumentFlute": "(12) Furulya",
    "music.instrumentGuitar": "(4) Gitár",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Zenélő doboz",
    "music.instrumentOrgan": "(3) Orgona",
    "music.instrumentPiano": "(1) Zongora",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofon",
    "music.instrumentSteelDrum": "(18) Acél dob",
    "music.instrumentSynthLead": "(20) Szóló szintetizátor",
    "music.instrumentSynthPad": "(21) Szintetizátor érintőlap",
    "music.instrumentTrombone": "(9) Harsona",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Fa furulya",
    "music.midiPlayDrumForBeats": "játssz [DRUM] dobon [BEATS] ütemig",
    "music.midiSetInstrument": "hangszer legyen [INSTRUMENT]",
    "music.playDrumForBeats": "játssz [DRUM] dobon [BEATS] ütemig",
    "music.playNoteForBeats": "játszd le [NOTE] hangjegyet [BEATS] ütemig",
    "music.restForBeats": "szünetelj [BEATS] ütemig",
    "music.setInstrument": "hangszer legyen [INSTRUMENT]",
    "music.setTempo": "tempó legyen [TEMPO]",
    "pen.categoryName": "Toll",
    "pen.changeColorParam": "toll [COLOR_PARAM] változzon [VALUE]",
    "pen.changeHue": "toll színe változzon [HUE]",
    "pen.changeShade": "toll árnyalata változzon [SHADE]",
    "pen.changeSize": "toll mérete változzon [SIZE]",
    "pen.clear": "töröld a rajzokat",
    "pen.colorMenu.brightness": "fényerő",
    "pen.colorMenu.color": "szín",
    "pen.colorMenu.saturation": "telítettség",
    "pen.colorMenu.transparency": "átlátszóság",
    "pen.penDown": "tollat tedd le",
    "pen.penUp": "tollat emeld fel",
    "pen.setColor": "toll színe legyen [COLOR]",
    "pen.setColorParam": "toll [COLOR_PARAM] legyen [VALUE]",
    "pen.setHue": "toll színe legyen [HUE]",
    "pen.setShade": "toll árnyalata legyen [SHADE]",
    "pen.setSize": "toll mérete legyen [SIZE]",
    "pen.stamp": "készíts lenyomatot",
    "speech.defaultWhenIHearValue": "gyerünk",
    "speech.extensionName": "Felvétel szövegbe",
    "speech.listenAndWait": "hallgass és várj",
    "speech.speechReporter": "beszéd",
    "speech.whenIHear": "amikor hallom [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "üdv",
    "text2speech.giant": "óriás",
    "text2speech.kitten": "cica",
    "text2speech.setLanguageBlock": "nyelv legyen [LANGUAGE]",
    "text2speech.setVoiceBlock": "hang legyen [VOICE]",
    "text2speech.speakAndWaitBlock": "mondd [WORDS]",
    "text2speech.squeak": "vinnyogás",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Fordítás",
    "translate.defaultTextToTranslate": "üdv",
    "translate.translateBlock": "fordítsd le azt, hogy [WORDS] erre a nyelvre:[LANGUAGE]",
    "translate.viewerLanguage": "nyelv",
    "videoSensing.categoryName": "Videóérzékelés",
    "videoSensing.direction": "irány",
    "videoSensing.motion": "mozgás",
    "videoSensing.off": "ki",
    "videoSensing.on": "be",
    "videoSensing.onFlipped": "felpattintott",
    "videoSensing.setVideoTransparency": "videó átlátszósága legyen [TRANSPARENCY]",
    "videoSensing.sprite": "szereplő",
    "videoSensing.stage": "színpad",
    "videoSensing.videoOn": "video attribútum [ATTRIBUTE] [SUBJECT] tárgyban",
    "videoSensing.videoToggle": "videó kapcsolása [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "amikor a videó mozgása > [REFERENCE]",
    "wedo2.getDistance": "távolság",
    "wedo2.getTiltAngle": "[TILT_DIRECTION] billenési szög",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] irányba billenve?",
    "wedo2.motorDirection.backward": "arra",
    "wedo2.motorDirection.forward": "erre",
    "wedo2.motorDirection.reverse": "visszafelé",
    "wedo2.motorId.a": "A motor",
    "wedo2.motorId.all": "minden motor",
    "wedo2.motorId.b": "B motor",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "[MOTOR_ID] kikapcsolása",
    "wedo2.motorOn": "[MOTOR_ID] bekapcsolása",
    "wedo2.motorOnFor": "[MOTOR_ID] bekapcsolása [DURATION] másodpercig",
    "wedo2.playNoteFor": "[NOTE] hang lejátszása [DURATION] másodpercig",
    "wedo2.setLightHue": "lámpa színének beállítása erre: [HUE]",
    "wedo2.setMotorDirection": "[MOTOR_ID] beállítása [MOTOR_DIRECTION] irányba",
    "wedo2.startMotorPower": "[MOTOR_ID] teljesítménye legyen [POWER]",
    "wedo2.tiltDirection.any": "bármelyik",
    "wedo2.tiltDirection.down": "le",
    "wedo2.tiltDirection.left": "balra",
    "wedo2.tiltDirection.right": "jobbra",
    "wedo2.tiltDirection.up": "fel",
    "wedo2.whenDistance": "amikor [OP] távolság [REFERENCE]",
    "wedo2.whenTilted": "amikor [TILT_DIRECTION_ANY] irányba billentve",
    "paint.paintEditor.hue": "Szín",
    "paint.paintEditor.saturation": "Telítettség",
    "paint.paintEditor.brightness": "Fényerő",
    "paint.paintEditor.costume": "Jelmez",
    "paint.paintEditor.group": "Csoportosítás",
    "paint.paintEditor.ungroup": "Csoport bontása",
    "paint.paintEditor.undo": "Visszavonás",
    "paint.paintEditor.redo": "Mégis",
    "paint.paintEditor.forward": "Előreküld",
    "paint.paintEditor.backward": "Hátraküld",
    "paint.paintEditor.front": "Legelőre",
    "paint.paintEditor.back": "Leghátra",
    "paint.paintEditor.more": "Több",
    "paint.modeTools.brushSize": "Méret",
    "paint.modeTools.eraserSize": "Radír méret",
    "paint.modeTools.copy": "Másolás",
    "paint.modeTools.paste": "Beillesztés",
    "paint.modeTools.delete": "Törlés",
    "paint.modeTools.curved": "Ívelt",
    "paint.modeTools.pointed": "Csúcsos",
    "paint.modeTools.thickness": "Vastagság",
    "paint.modeTools.flipHorizontal": "Vízszintes tükrözés",
    "paint.modeTools.flipVertical": "Függőleges tükrözés",
    "paint.modeTools.filled": "Kitöltött",
    "paint.modeTools.outlined": "Körvonalazott",
    "paint.paintEditor.bitmap": "Konvertálás Bitképpé",
    "paint.paintEditor.vector": "Konvertálás Vektorképpe",
    "paint.paintEditor.fill": "Kitöltés",
    "paint.paintEditor.stroke": "Körvonal",
    "paint.brushMode.brush": "Ecset",
    "paint.eraserMode.eraser": "Radír",
    "paint.fillMode.fill": "Kitöltés",
    "paint.lineMode.line": "Vonal",
    "paint.ovalMode.oval": "Kör",
    "paint.rectMode.rect": "Téglalap",
    "paint.reshapeMode.reshape": "Újraformálás",
    "paint.roundedRectMode.roundedRect": "Kerekített téglalap",
    "paint.selectMode.select": "Kijelölés",
    "paint.textMode.text": "Szöveg",
    "paint.colorPicker.swap": "Csere"
  },
  "mi": {
    "gui.alerts.lostPeripheralConnection": "Kua ngaro te hononga o te Scratch ki {extensionName}.",
    "gui.alerts.tryAgain": "Whakamātauria Anō",
    "gui.alerts.download": "Tikiaketia",
    "gui.connection.reconnect": "Tūhonoa anōtia",
    "gui.backpack.costumeLabel": "kākahu",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Pīkau",
    "gui.backpack.errorBackpack": "Kua raru te tāuta pīkau",
    "gui.backpack.loadingBackpack": "Kei te utaina...",
    "gui.backpack.more": "Anō",
    "gui.backpack.emptyBackpack": "Kua kautahanga te Pīkau",
    "gui.unsupportedBrowser.label": "Kāore e tautokona te pūtirotiro",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Hoki atu",
    "gui.unsupportedBrowser.previewfaq": "Haere ki {previewFaqLink} ki te ako tonu.",
    "gui.unsupportedBrowser.previewfaqlinktext": "He Pātai Auau",
    "gui.cards.all-tutorials": "Ngā Akoranga",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Katia",
    "gui.cards.more-things-to-try": "Ētahi mahinga kē kia whakamātauria!",
    "gui.cards.see-more": "Tirohia anōtia",
    "gui.comingSoon.message1": "Kaua e māharahara, kei te ū tonu mātou {emoji}",
    "gui.comingSoon.message2": "Ākuanei kei konei...",
    "gui.comingSoon.message3": "Kei te hanga tonu mātou i tēnei {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Kāore i kitea te pūrere",
    "gui.connection.auto-scanning.prescan": "Whakatata mai tō pūrere, kātahi tīmatahia te rapu.",
    "gui.connection.auto-scanning.pressbutton": "Panaia te pātene o tō pūrere.",
    "gui.connection.auto-scanning.start-search": "Tīmatahia te Rapu",
    "gui.connection.connecting-searchbutton": "Kei te rapu...",
    "gui.connection.auto-scanning.try-again": "Whakamātauria anōtia",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Kua honoa",
    "gui.connection.disconnect": "Kua motukia",
    "gui.connection.go-to-editor": "Haere ki te Taupānga Whakatika",
    "gui.connection.connecting-cancelbutton": "Kei te hono...",
    "gui.connection.error.errorMessage": "Auē! Kua puta mai he raru.",
    "gui.connection.error.tryagainbutton": "Whakamātauria anōtia",
    "gui.connection.error.helpbutton": "Āwhina",
    "gui.connection.peripheral-name-label": "Ingoa pūrere",
    "gui.connection.connect": "Honoa",
    "gui.connection.scanning.lookingforperipherals": "Kei te rapu i ngā pūrere",
    "gui.connection.scanning.noPeripheralsFound": "Kāore i kitea te pūrere",
    "gui.connection.scanning.instructions": "Tīpakongia tō pūrere i te rārangi kei runga nei.",
    "gui.connection.search": "Whakahoua",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Āta titiro mēnā kua tāutahia te Scratch Link, kua whakahaerehia hoki.",
    "gui.connection.unavailable.enablebluetooth": "Kātahi, Whakakā i a Nihokikorangi",
    "gui.connection.unavailable.tryagainbutton": "Whakamātauria anōtia",
    "gui.connection.unavailable.helpbutton": "Āwhina",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Haere",
    "gui.controls.stop": "Katia",
    "gui.crashMessage.label": "Auē! Kua puta mai he raru.",
    "gui.crashMessage.description": "Aroha mai, ko te āhua nei kua hinga te Scratch. Kua tukuna atu he pūrongo mō tēnei iro ki te Scratch Team. Tēnā, whakahoungia te whārangi kia whakamātau anō.",
    "gui.crashMessage.errorNumber": "Kua tukuna tō hapa ki te rangitaki me te tautuhinga {errorId}",
    "gui.crashMessage.reload": "Whakahou",
    "gui.customProcedures.myblockModalTitle": "Hangaia tētahi Paraka",
    "gui.customProcedures.addAnInputNumberText": "Tāpirihia tētahi tāuru",
    "gui.customProcedures.numberTextType": "he nama, he kupu rānei",
    "gui.customProcedures.addAnInputBoolean": "Whakaurua tētahi tāuru",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Tāpirihia tētahi kupu tapanga:",
    "gui.customProcedures.runWithoutScreenRefresh": "Whakahaeretia, kāore he whakahounga o te mata",
    "gui.customProcedures.cancel": "Whakakore",
    "gui.customProcedures.ok": "Ka pai",
    "gui.SpriteInfo.direction": "Ahunga",
    "gui.directionPicker.rotationStyles.allAround": "Huri Noa",
    "gui.directionPicker.rotationStyles.leftRight": "Mauī/Katau",
    "gui.directionPicker.rotationStyles.dontRotate": "Kaua e takahuri",
    "gui.gui.addExtension": "Tāpirihia tētahi Torohanga",
    "gui.gui.codeTab": "Waehere",
    "gui.gui.backdropsTab": "Ngā Ārai Tuarongo",
    "gui.gui.costumesTab": "Ngā Kākahu",
    "gui.gui.soundsTab": "Ngā oro",
    "gui.extensionLibrary.comingSoon": "Ākuanei kei konei",
    "gui.extensionLibrary.requires": "Herenga",
    "gui.extensionLibrary.collaboration": "Tuituinga mahi",
    "gui.library.filterPlaceholder": "Rapua",
    "gui.library.allTag": "Te Katoa",
    "gui.loader.message1": "Kei te waihanga i ngā paraka … ",
    "gui.loader.message2": "Kei te utaina ngā parehe ...",
    "gui.loader.message3": "Kei te utaina ngā oro …",
    "gui.loader.message4": "Kei te utaina ngā torohanga ...",
    "gui.loader.message5": "Kei te āngia ngā ngeru …",
    "gui.loader.message6": "Kei te whakawhiti i ngā nano ...",
    "gui.loader.message7": "Kei te koeketia ngā gobo...",
    "gui.loader.message8": "Kei te whakarite i ngā ata pūāhua …",
    "gui.loader.headline": "Kei te Utaina te Kaupapa",
    "gui.loader.creating": "Kei te Waihanga i te Kaupapa",
    "gui.accountMenu.profile": "Huanga",
    "gui.accountMenu.myStuff": "Aku Mea",
    "gui.accountMenu.myClasses": "Aku Akomanga",
    "gui.accountMenu.myClass": "Taku Akomanga",
    "gui.accountMenu.accountSettings": "Ngā tautuhinga pūkete",
    "gui.accountMenu.signOut": "Takiputa",
    "gui.authorInfo.byUser": "nā{username}",
    "gui.menuBar.seeProjectPage": "Tirohia te Whārangi Kaupapa",
    "gui.menuBar.language": "Language",
    "general.username": "Ingoa Kaiwhakamahi",
    "general.password": "Kupu Hipa",
    "general.signIn": "Takiuru",
    "login.needHelp": "E Hia Āwhina Ana?",
    "form.validationRequired": "He mea here tēnei āpure",
    "gui.menuBar.tutorialsLibrary": "Ngā Akoranga",
    "gui.menuBar.restoreSprite": "Whakaora Parehe",
    "gui.menuBar.restoreSound": "Whakaora Oro",
    "gui.menuBar.restoreCostume": "Whakaora Kākahu",
    "gui.menuBar.restore": "Whakaora",
    "gui.menuBar.saveNow": "Tiakina ināianei",
    "gui.menuBar.saveAsCopy": "Tiakina hei tārua",
    "gui.menuBar.remix": "Whakarākeitia",
    "gui.menuBar.new": "Hou",
    "gui.menuBar.file": "Kōnae",
    "gui.menuBar.downloadToComputer": "Tiakina ki tō rorohiko",
    "gui.menuBar.edit": "Whakatikaina",
    "gui.menuBar.turboModeOff": "Wetohia te Aratau Kapongao",
    "gui.menuBar.turboModeOn": "Whakakāngia te Aratau Kapongao",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Hono mai ki te Scratch",
    "gui.menuBar.signIn": "Takiuru",
    "gui.gui.projectTitlePlaceholder": "Ingoa kaupapa ki konei",
    "gui.menuBar.saveNowLink": "Tiakina Ināianei",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Kua tuaritia",
    "gui.menuBar.share": "Tuaritia",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Āwhina",
    "gui.modal.back": "Hoki atu",
    "gui.monitor.listMonitor.empty": "(kāore he mea kei roto)",
    "gui.monitor.listMonitor.listLength": "roanga {length}",
    "gui.monitor.contextMenu.default": "pānui māori",
    "gui.monitor.contextMenu.large": "pānui rahi",
    "gui.monitor.contextMenu.slider": "rēreti",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "kaweake",
    "gui.monitor.contextMenu.export": "kaweake",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Mō ngā parehe katoa",
    "gui.gui.variableScopeOptionSpriteOnly": "Mō tēnei parehe anake",
    "gui.gui.cloudVariableOption": "Taurangi Raraunga Kapua (kei te tūmau)",
    "gui.gui.variablePromptAllSpritesMessage": "Ka wātea tēnei taurangi mō ngā parehe katoa.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Whakakore",
    "gui.prompt.ok": "Ka pai",
    "gui.playbackStep.stopMsg": "Katia",
    "gui.playbackStep.playMsg": "Whakatangihia",
    "gui.playbackStep.loadingMsg": "Kei te utaina...",
    "gui.playbackStep.saveMsg": "Tiakina",
    "gui.playbackStep.reRecordMsg": "Hopukina anōtia",
    "gui.recordModal.title": "Hopu Oro",
    "gui.recordingStep.beginRecord": "Tīmatahia te hopuoro mā te pāwhiri i te pātene kei raro nei",
    "gui.recordingStep.permission": "{arrow}Me whai whakaaetanga mātou i a koe kia whakamahia tō hopuoro",
    "gui.recordingStep.stop": "Katia te hopuoro",
    "gui.recordingStep.record": "Hopukina",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Oro",
    "gui.soundEditor.play": "Whakatangihia",
    "gui.soundEditor.stop": "Katia",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Tiakina",
    "gui.soundEditor.undo": "Wetekia",
    "gui.soundEditor.redo": "Mahia anōtia",
    "gui.soundEditor.faster": "Tere ake",
    "gui.soundEditor.slower": "Pōturi ake",
    "gui.soundEditor.echo": "Pāorooro",
    "gui.soundEditor.robot": "Karetao",
    "gui.soundEditor.louder": "Whakakaha i te oro",
    "gui.soundEditor.softer": "Ririki",
    "gui.soundEditor.reverse": "Hurikōaro",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Ingoa",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Parehe",
    "gui.SpriteInfo.show": "Whakaaturia",
    "gui.SpriteInfo.size": "Rahi",
    "gui.spriteSelectorItem.contextMenuDuplicate": "tāruatia",
    "gui.spriteSelectorItem.contextMenuExport": "kaweake",
    "gui.spriteSelectorItem.contextMenuDelete": "mukua",
    "gui.spriteSelector.addSpriteFromLibrary": "Kōwhiria tētahi Parehe",
    "gui.spriteSelector.addSpriteFromPaint": "Peita",
    "gui.spriteSelector.addSpriteFromSurprise": "Ohorere",
    "gui.spriteSelector.addSpriteFromFile": "Tukuatu Parehe",
    "gui.stageHeader.stageSizeLarge": "Panoni ki te atamira nui",
    "gui.stageHeader.stageSizeSmall": "Panoni ki te atamira iti",
    "gui.stageHeader.stageSizeFull": "Panoni ki te aratau mata katoa",
    "gui.stageHeader.stageSizeUnFull": "Puta atu i te aratau mata katoa",
    "gui.stageHeader.fullscreenControl": "Whakatina Mata Katoa",
    "gui.spriteSelector.addBackdropFromLibrary": "Kōwhiria tētahi Ārai Tuarongo",
    "gui.stageSelector.addBackdropFromPaint": "Peita",
    "gui.stageSelector.addBackdropFromSurprise": "Ohorere",
    "gui.stageSelector.addBackdropFromFile": "Tukuatu Ārai Tuarongo",
    "gui.stageSelector.stage": "Atamira",
    "gui.stageSelector.backdrops": "Ngā Ārai Tuarongo",
    "gui.telemetryOptIn.label": "Tukuna tauanga kia whakawhanake i te Scratch",
    "gui.telemetryOptIn.body1": "Ko te whāinga o te Tīma Scratch i ngā wā katoa kia mārama ake ka pēhea te Scratch ka whakamahia huri noa i te Ao. Hei āwhina i ēnei mahi, ka āhei koe te whakaae atu kia tuku aunoa te Scratch i ngā raraunga whakamahi ki te Tīma Scratch. ",
    "gui.telemetryOptIn.body2": "Ko te momo mōhiohio e kohia nei e mātou, ko te kōwhiringa reo, ngā paraka kua whakamahia, me ētahi o ngā takahanga pērā ki te tāuta, te tiaki me te tukuatu i ngā kaupapa. KA KORE mātou e kohi i ngā mōhiohio whaiaro. Tirohia tā mātou {privacyPolicyLink} ki te ako anō.",
    "gui.telemetryOptIn.privacyPolicyLink": "Kaupapa Here mō te Tūmataitinga",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Te Aratau Kapongao",
    "gui.webglModal.label": "Kāore a WebGL i te tautokona e tō pūtirotiro",
    "gui.webglModal.description": "Aroha mai, ko te āhua nei, he {webGlLink} nā tō rorohiko, pūtirotiro rānei. He herenga tērā kia taea ai te whakahaere i te Scratch 3.0.",
    "gui.webglModal.webgllink": "kāore e tautokona te WebGL",
    "gui.webglModal.back": "Hoki atu",
    "gui.webglModal.previewfaq": "Haere ki {previewFaqLink} ki te ako tonu.",
    "gui.webglModal.previewfaqlinktext": "He Pātai Auau",
    "gui.costumeLibrary.chooseABackdrop": "Kōwhiria tētahi Ārai Tuarongo",
    "gui.costumeLibrary.chooseACostume": "Kōwhiria he Kākahu",
    "gui.costumeTab.addBackdropFromLibrary": "Kōwhiria tētahi Ārai Tuarongo",
    "gui.costumeTab.addCostumeFromLibrary": "Kōwhiria he Kākahu",
    "gui.costumeTab.addBlankCostume": "Peita",
    "gui.costumeTab.addSurpriseCostume": "Ohorere",
    "gui.costumeTab.addFileBackdrop": "Tukuatu Ārai Tuarongo",
    "gui.costumeTab.addFileCostume": "Tukuatu Kākahu",
    "gui.extensionLibrary.chooseAnExtension": "Kōwhiria tētahi Torohanga",
    "gui.extensionLibrary.extensionUrl": "Tāurutia te URL mō te torohanga",
    "gui.monitors.importListColumnPrompt": "Ko tēhea te tīwae hei whakamahi (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Kāore i taea te tīmata i te hopu oro",
    "gui.soundLibrary.chooseASound": "Kōwhiria tētahi Oro",
    "gui.soundTab.fileUploadSound": "Tukuatu oro",
    "gui.soundTab.surpriseSound": "Ohorere",
    "gui.soundTab.recordSound": "Rēkoata",
    "gui.soundTab.addSoundFromLibrary": "Kōwhiria tētahi Oro",
    "gui.spriteLibrary.chooseASprite": "Kōwhiria tētahi Parehe",
    "gui.tipsLibrary.tutorials": "Kōwhiria he Akoranga",
    "gui.alerts.createsuccess": "Kua Waihangatia te Kaupapa Hou",
    "gui.alerts.createcopysuccess": "Kua tiakina te kaupapa hei tārua.",
    "gui.alerts.createremixsuccess": "Kua tiakina te kaupapa hei whakarākei.",
    "gui.alerts.creating": "Kei te waihanga mea hou...",
    "gui.alerts.creatingCopy": "Kei te tārua i te kaupapa...",
    "gui.alerts.creatingRemix": "Kei te whakarākei i te kaupapa...",
    "gui.alerts.creatingError": "Kāore i taea te waihanga kaupapa, whakamātauria anōtia!",
    "gui.alerts.savingError": "Kāore i taea te tiaki i te kaupapa.",
    "gui.alerts.savesuccess": "Kua tiakina te kaupapa.",
    "gui.alerts.saving": "Kei te tiaki i te kaupapa...",
    "gui.alerts.cloudInfo": "Kia mārama koe, ka taea ngā nama anake i ngā taurangi ā-ipurangi, kāore e tautokona ngā pūreta, ngā pūāhua rānei. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Kia ako kōrero anō.",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Miao",
    "gui.defaultProject.variable": "taku taurangi",
    "gui.howtos.intro-move-sayhello-hat.name": "Hei Tīmatanga",
    "gui.howtos.intro-move.step_stepMove": "Tāpirihia tetahi Paraka Neke me tētahi Paraka Kī",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Whakahākoritia tētahi Ingoa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Kōwhiria tētahi Parehe Pū",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Whakatangihia Tētahi Oro Ina Pāwhiria",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Kōwhiria tētahi Parehe Pū anō",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Panoni tae",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Kōwhiria tētahi Pū, ā, Tukua kia Tāwhiowhio",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Kōwhiria tētahi pū, ā, tukuna kia tipu!",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Hanga Pūoro",
    "gui.howtos.Make-Music.step_PickInstrument": "Kōwhiria tētahi Parehe Taonga Puoro",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Whakatangihia Oro Ina Pāwhiria",
    "gui.howtos.Make-Music.step_MakeSong": "Tito Waiata",
    "gui.howtos.make-music.step_MakeBeat": "Kōwhiria tētahi Pahū, ā, Titoa tētahi Taki",
    "gui.howtos.make-music.step_MakeBeatBox": "Kōwhiria te Parehe Hopuoro me te Pūrere Taki Whakaohorere",
    "gui.howtos.story.name": "Titoa tētahi Kōrero Paki",
    "gui.howtos.story.step_addbg": "Tāpirihia he Ārai Tuarongo",
    "gui.howtos.story.step_addsprite": "Tāpirihia he Kiripuaki",
    "gui.howtos.story.step_saysomething": "Kīia Tētahi Kōrero",
    "gui.howtos.story.step_addanothersprite": "Tāpirihia Tētahi Kiripuaki Anō",
    "gui.howtos.story.step_flip": "Whakawhiti i te Ahunga",
    "gui.howtos.story.step_conversation": "Whakawhitiwhiti Kōrero",
    "gui.howtos.story.addanotherbg": "Tāpiritia he Ārai Tuarongo Anō",
    "gui.howtos.story.step_swithbg": "Hurihia ngā Ārai Tuarongo",
    "gui.howtos.story.step_hidewizard": "Hunaia tētahi Kiripuaki",
    "gui.howtos.story.step_showwizard": "Whakaaturia he Kiripuaki",
    "gui.howtos.make-a-chase-game.name": "Waihangatia tētahi Kēmu Whaiwhai",
    "gui.howtos.Chase-Game.step_BG": "Tāpiritia he Ārai Tuarongo",
    "gui.howtos.chase-game.step_AddOcto": "Tāpiritia he Parehe",
    "gui.howtos.make-music.step_LeftRight": "Nekehia, Katau, Mauī rānei mā ngā Pātuhi Pere",
    "gui.howtos.Chase-Game.step_UpDown": "Nekehia ki Runga, ki Raro rānei mā ngā Pātuhi Pere",
    "gui.howtos.Chase-Game.step_AddStar": "Tāpirihia Tētahi Parehe Anō",
    "gui.howtos.Chase-Game.step_MoveRandom": "Nekeneke Matapōkere",
    "gui.howtos.Chase-Game.step_WhenTouch": "Mō te Parehe Wheke, Ina Pā atu, Whakatangihia te Oro",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Waihangatia tētahi Taurangi Piro",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Mō te Parehe Wheke, Ina Pā atu, Tāpirihia he Piro",
    "gui.howtos.animate-char.name": "Whakahākoritia tētahi Kiripuaki",
    "gui.howtos.animate-char.step_addbg": "Tāpirihia tētahi Ārai Tuarongo",
    "gui.howtos.animate-char.step_addsprite": "Tāpirihia tētahi Parehe",
    "gui.howtos.animate-char.step_saysomething": "Kīia Tētahi Kōrero",
    "gui.howtos.animate-char.step_addsound": "Tāpirihia he Oro",
    "gui.howtos.animate-char.step_animatetalking": "Whakahākoritia te Kōrero",
    "gui.howtos.animate-char.step_arrowkeys": "Nekehia mā ngā Pātuhi Pere",
    "gui.howtos.animate-char.step_jump": "Peke",
    "gui.howtos.animate-char.step_changecolor": "Panoni Tae",
    "gui.howtos.make-a-game.name": "Waihangatia tētahi Kēmu Pāwhiri",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Kōwhiria tētahi Parehe",
    "gui.howtos.make-a-game.step_GamePlaySound": "Whakatangihia Oro Ina Pāwhiria",
    "gui.howtos.make-a-game.step_GameAddScore": "Waihangatia tētahi Taurangi Piro",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ina Pāwhiritia, Whakapiki i ngā Piro ",
    "gui.howtos.make-a-game.step_Random": "Haere ki tētahi tūnga matapōkere",
    "gui.howtos.make-music.step_GameChangeColor": "Panoni Tae",
    "gui.howtos.make-music.step_ResetScore": "Tautuhia anō ngā Piro",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Whakahākoritia tētahi Kēmu Whakaari",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kōwhiria tētahi Kiripuaki kia Whakaatu",
    "gui.howtos.cartoon-network.step_CNsay": "Kīia Tētahi Kōrero",
    "gui.howtos.cartoon-network.step_CNglide": "Wania Noatia",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kōwhiria tētahi Ahanoa kia Whāia",
    "gui.howtos.cartoon-network.step_CNcollect": "Kohikohia he Ahanoa",
    "gui.howtos.cartoon-network.step_CNvariable": "Hangaia he Taurangi Piro",
    "gui.howtos.cartoon-network.step_CNscore": "Kaute i ngā Piro",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Taumata ake: Hurihia te Ārai Tuarongo",
    "gui.howtos.videosens.name": "He Tairongo Ataata",
    "gui.howtos.videosens.step_addextension": "Tāpirihia tētahi Torohanga",
    "gui.howtos.videosens.step_pet": "Haumiria te Ngeru",
    "gui.howtos.videosens.step_animate": "Whakahākoritia",
    "gui.howtos.videosens.step_pop": "Pahūngia tētahi Poihau",
    "gui.howtos.say-it-out-loud": "Waihanga Hākorikori Kōrero",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Tāpirihia ngā Kuputuhi ki ngā paraka Kōrero ",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Tautuhia tētahi Reo",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Nekeneke Huri Noa",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Tāpirihia tētahi Ārai Tuarongo",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Tāpirihia Tētahi Kiripuaki Anō",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Waiatatia tētahi Waiata",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Panoni Tae",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Tāwhiowhio te Haere",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Te Whakatipu me te Whakakauriki",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Tāpiritia he Parehe",
    "gui.howtos.add-sprite.step_addSprite": "Tāpiritia he Parehe",
    "gui.howtos.add-a-backdrop.name": "Tāpiritia he Ārai Tuarongo",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Panonitia te Nui",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Wania Noatia",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Hopu Tētahi Oro",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Tukuna kia Tāwhiowhio",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Huna me te Whakaatu",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Whakahākoritia tētahi Parehe",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Whakamahia ngā Pātuhi Pere",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Tāpiritia he Pānga",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Puoro",
    "gui.extension.music.description": "Whakatangi i ngā tāonga puoro me ngā pahū.",
    "gui.extension.pen.name": "Pene",
    "gui.extension.pen.description": "Mā te parehe e tuhi.",
    "gui.extension.videosensing.name": "He Paerongo Ataata",
    "gui.extension.videosensing.description": "Mā te kāmera te mahi paerongo nekenekehanga.",
    "gui.extension.text2speech.name": "Kuputuhi ki te Kōrero ",
    "gui.extension.text2speech.description": "Whakakōrerotia tō kaupapa.",
    "gui.extension.translate.name": "Whakawhitiwhiti Reo Ā-tuhi",
    "gui.extension.translate.description": "Whakahuri ngā tuhinga ki ngā reo maha.",
    "gui.extension.makeymakey.description": "Whakamahia te aha noa hei pātuhi.",
    "gui.extension.microbit.description": "Honohonoa ō kaupapa ki te ao.",
    "gui.extension.microbit.connectingMessage": "Kei te hono",
    "gui.extension.ev3.description": "Hangaia he karetao tauwhitiwhiti, te aha rānei.",
    "gui.extension.ev3.connectingMessage": "Kei te hono. Kia tika te tautuhi i te pine EV3 ki te 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Hanga me ngā pūkaha me ngā paerongo.",
    "gui.extension.wedo2.connectingMessage": "Kei te hono",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Te Katoa",
    "gui.libraryTags.animals": "Ngā Kararehe",
    "gui.libraryTags.dance": "Kanikani",
    "gui.libraryTags.effects": "Ngā pānga",
    "gui.libraryTags.fantasy": "Wawata",
    "gui.libraryTags.fashion": "Kākahu",
    "gui.libraryTags.food": "Kai",
    "gui.libraryTags.indoors": "Rō-whare",
    "gui.libraryTags.loops": "Koromeke",
    "gui.libraryTags.music": "Puoro",
    "gui.libraryTags.notes": "Tuhipoka",
    "gui.libraryTags.outdoors": "O Waho",
    "gui.libraryTags.patterns": "Tauira",
    "gui.libraryTags.people": "Tāngata",
    "gui.libraryTags.percussion": "Taonga papā",
    "gui.libraryTags.space": "Ātea",
    "gui.libraryTags.sports": "Hākinakina",
    "gui.libraryTags.underwater": "Raro wai",
    "gui.libraryTags.voice": "Reo",
    "gui.libraryTags.wacky": "Pukuhohe",
    "gui.libraryTags.animation": "Hākoritanga",
    "gui.libraryTags.art": "Toi",
    "gui.libraryTags.games": "Ngā Kēmu",
    "gui.libraryTags.stories": "Ngā Pakiwaitara",
    "gui.libraryTags.letters": "Ngā reta",
    "gui.opcodeLabels.direction": "ahunga",
    "gui.opcodeLabels.xposition": "tūnga x",
    "gui.opcodeLabels.yposition": "tūnga y",
    "gui.opcodeLabels.size": "rahi",
    "gui.opcodeLabels.costumename": "ingoa kākahu",
    "gui.opcodeLabels.costumenumber": "nama kākahu",
    "gui.opcodeLabels.backdropname": "ingoa ārai tuarongo",
    "gui.opcodeLabels.backdropnumber": "nama ārai tuarongo",
    "gui.opcodeLabels.volume": "kahaoro",
    "gui.opcodeLabels.tempo": "tere",
    "gui.opcodeLabels.answer": "whakautu",
    "gui.opcodeLabels.loudness": "hoihoi",
    "gui.opcodeLabels.username": "ingoa kaiwhakamahi",
    "gui.opcodeLabels.year": "tau",
    "gui.opcodeLabels.month": "marama",
    "gui.opcodeLabels.date": "te rā",
    "gui.opcodeLabels.dayofweek": "te rangi o te wiki",
    "gui.opcodeLabels.hour": "haora",
    "gui.opcodeLabels.minute": "miniti",
    "gui.opcodeLabels.second": "hēkona",
    "gui.opcodeLabels.timer": "taima",
    "gui.projectLoader.loadError": "Kāore i taea te uta i tēnā o ngā kōnae kaupapa.",
    "gui.sharedMessages.backdrop": "ārai tuarongo{index}",
    "gui.sharedMessages.costume": "kākahu{index}",
    "gui.sharedMessages.sprite": "Parehe{index}",
    "gui.sharedMessages.pop": "pakō",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Kaupapa Scratch",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "whakatangihia te oro [NOTE] mō ngā hēkona [TIME]",
    "ev3.buttonPressed": "kua pēhia te pātuhi [PORT]?",
    "ev3.getBrightness": "pīataata",
    "ev3.getDistance": "tawhiti",
    "ev3.getMotorPosition": "ahunga pūkaha[PORT]",
    "ev3.motorSetPower": "pūkaha[PORT] tautuhia te kaha ki[POWER] %",
    "ev3.motorTurnClockwise": "pūkaha [PORT] huri pēnei mō ngā hēkona [TIME]",
    "ev3.motorTurnCounterClockwise": "pūkaha [PORT]huri pērā mō ngā hēkona [TIME]",
    "ev3.whenBrightnessLessThan": "ina pīataata < [DISTANCE]",
    "ev3.whenButtonPressed": "inā pāwhiria te pātene [PORT]",
    "ev3.whenDistanceLessThan": "ina tawhiti < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "pere whakararo",
    "makeymakey.downArrowShort": "ki raro",
    "makeymakey.leftArrow": "pere mauī",
    "makeymakey.leftArrowShort": "mauī",
    "makeymakey.rightArrow": "pere katau",
    "makeymakey.rightArrowShort": "katau",
    "makeymakey.spaceKey": "mokowā",
    "makeymakey.upArrow": "pere whakarunga",
    "makeymakey.upArrowShort": "ki runga",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "noa",
    "microbit.clearDisplay": "ūkuia te mata",
    "microbit.defaultTextToDisplay": "Tēnā koe!",
    "microbit.displaySymbol": "whakaaturia [MATRIX]",
    "microbit.displayText": "whakaaturia [TEXT]",
    "microbit.gesturesMenu.jumped": "i peke",
    "microbit.gesturesMenu.moved": "i neke",
    "microbit.gesturesMenu.shaken": "i rūrū",
    "microbit.isButtonPressed": "[BTN] pātene i pēhia?",
    "microbit.isTilted": "kua tītaha ki[DIRECTION]?",
    "microbit.pinStateMenu.off": "weto",
    "microbit.pinStateMenu.on": "kā",
    "microbit.tiltAngle": "koki tītaha [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "noa",
    "microbit.tiltDirectionMenu.back": "muri",
    "microbit.tiltDirectionMenu.front": "mua",
    "microbit.tiltDirectionMenu.left": "mauī",
    "microbit.tiltDirectionMenu.right": "katau",
    "microbit.whenButtonPressed": "ina pēhia pātene [BTN] ",
    "microbit.whenGesture": "ina [GESTURE]",
    "microbit.whenPinConnected": "whakamātautau, ina honoa ki te pine [PIN]",
    "microbit.whenTilted": "ina tītaha ki [DIRECTION]",
    "music.categoryName": "Puoro",
    "music.changeTempo": "panonitia te tere mā te [TEMPO]",
    "music.drumBass": "(2) Pahū Nguru",
    "music.drumBongo": "(13) Pahū tamarua",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Poro rākau",
    "music.drumClosedHiHat": "(6) Hi-Hat kua Katia",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Pere-kau",
    "music.drumCrashCymbal": "(4) Tīwēwē Wheoro",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Pakipaki-ā-ringa",
    "music.drumOpenHiHat": "(5) Hi-Hat kua Huakina",
    "music.drumSideStick": "(3) Rākau Taha Pahū",
    "music.drumSnare": "(1) Pahū Rarā",
    "music.drumTambourine": "(7) Tatangi",
    "music.drumTriangle": "(12) Tapatoru",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Paraka Rākau",
    "music.getTempo": "tere",
    "music.instrumentBass": "(6) Reo Nguru",
    "music.instrumentBassoon": "(14) Pūhoru",
    "music.instrumentCello": "(8) Whiranui",
    "music.instrumentChoir": "(15) Tira Waiata",
    "music.instrumentClarinet": "(10) Rehu Matangi",
    "music.instrumentElectricGuitar": "(5) Kitā Hiko",
    "music.instrumentElectricPiano": "(2) Piana Hiko",
    "music.instrumentFlute": "(12) Pūtōrino",
    "music.instrumentGuitar": "(4) Kitā",
    "music.instrumentMarimba": "(19) Pakakau",
    "music.instrumentMusicBox": "(17) Pouaka Puoro",
    "music.instrumentOrgan": "(3) Ōkena",
    "music.instrumentPiano": "(1) Piana",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Pūtohe",
    "music.instrumentSteelDrum": "(18) Pahū Rino",
    "music.instrumentSynthLead": "(20) Kōtui Arataki",
    "music.instrumentSynthPad": "(21) Kōtui Papatū",
    "music.instrumentTrombone": "(9) Pūkumekume",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Pūtorino",
    "music.midiPlayDrumForBeats": "whakatangihia te pahū [DRUM] mō ngā taki [BEATS] ",
    "music.midiSetInstrument": "tautuhia te taonga puoro ki te [INSTRUMENT]",
    "music.playDrumForBeats": "whakatangihia te pahū [DRUM] mō ngā taki [BEATS] ",
    "music.playNoteForBeats": "whakatangihia te oro [NOTE] mō ngā taki [BEATS]",
    "music.restForBeats": "tatari mō ngā taki [BEATS]",
    "music.setInstrument": "tautuhia te taonga puoro ki te [INSTRUMENT]",
    "music.setTempo": "tautuhia te tere kia [TEMPO]",
    "pen.categoryName": "Pene",
    "pen.changeColorParam": "panonitia te [COLOR_PARAM] o te pene mā te [VALUE]",
    "pen.changeHue": "panonitia te tae o te pene mā te [HUE]",
    "pen.changeShade": "panonitia te kauruku o te pene mā te [SHADE]",
    "pen.changeSize": "panonitia te nui o te pene mā te [SIZE]",
    "pen.clear": "Kōmurutia te katoa",
    "pen.colorMenu.brightness": "pīataata",
    "pen.colorMenu.color": "tae",
    "pen.colorMenu.saturation": "waiwai",
    "pen.colorMenu.transparency": "pūatatata",
    "pen.penDown": "pene ki raro",
    "pen.penUp": "pene ki runga",
    "pen.setColor": "tautuhia te tae o te pene kia [COLOR]",
    "pen.setColorParam": "tautuhia te [COLOR_PARAM] o te pene kia [VALUE]",
    "pen.setHue": "tautuhia te tae o te pene kia [HUE]",
    "pen.setShade": "tautuhia te kauruku o te pene kia [SHADE]",
    "pen.setSize": "tautuhia te nui o te pene kia [SIZE]",
    "pen.stamp": "waitohu",
    "speech.defaultWhenIHearValue": "me haere tātou",
    "speech.extensionName": "Google Kōrero",
    "speech.listenAndWait": "whakarongo, tatari hoki",
    "speech.speechReporter": "kōrero",
    "speech.whenIHear": "ina rongo ahau i [PHRASE]",
    "text2speech.alto": "reo pekerangi",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "kākarepō",
    "text2speech.kitten": "punua ngeru",
    "text2speech.setLanguageBlock": "tautuhia te reo kia[LANGUAGE]",
    "text2speech.setVoiceBlock": "tautuhia te reo ki [VOICE]",
    "text2speech.speakAndWaitBlock": "kīia [WORDS]",
    "text2speech.squeak": "koekoe",
    "text2speech.tenor": "reo iere",
    "translate.categoryName": "Google Translate",
    "translate.defaultTextToTranslate": "kia ora",
    "translate.translateBlock": "whakawhitiwhitia [WORDS] ki te reo [LANGUAGE]",
    "translate.viewerLanguage": "reo",
    "videoSensing.categoryName": "He Tairongo Ataata",
    "videoSensing.direction": "ahunga",
    "videoSensing.motion": "nekenekehanga",
    "videoSensing.off": "weto",
    "videoSensing.on": "kā",
    "videoSensing.onFlipped": "ina whakawhitia",
    "videoSensing.setVideoTransparency": "tautuhia te pūatatata o te ataata kia [TRANSPARENCY]",
    "videoSensing.sprite": "parehe",
    "videoSensing.stage": "atamira",
    "videoSensing.videoOn": "ataata [ATTRIBUTE] kei [SUBJECT]",
    "videoSensing.videoToggle": "hurihia te ataata kia [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "ina te nekenekehanga o te ataata > [REFERENCE]",
    "wedo2.getDistance": "tawhiti",
    "wedo2.getTiltAngle": "koki tītaha [TILT_DIRECTION]",
    "wedo2.isTilted": "kua tītaha ki [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "tērā ahunga",
    "wedo2.motorDirection.forward": "tēnei ahunga",
    "wedo2.motorDirection.reverse": "ahu whakamuri",
    "wedo2.motorId.a": "pūkaha A",
    "wedo2.motorId.all": "ngā pūkaha katoa",
    "wedo2.motorId.b": "pūkaha B",
    "wedo2.motorId.default": "pūkaha",
    "wedo2.motorOff": "whakaweto [MOTOR_ID]",
    "wedo2.motorOn": "whakakā [MOTOR_ID]",
    "wedo2.motorOnFor": "whakakā[MOTOR_ID] mō ngā hēkona [DURATION]",
    "wedo2.playNoteFor": "whakatangihia te oro [NOTE] mō ngā hēkona[DURATION]",
    "wedo2.setLightHue": "tautuhia te tae māmā ki te [HUE]",
    "wedo2.setMotorDirection": "tautuhia te pūkaha [MOTOR_ID] kia huri [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "tautuhia te pūkaha [MOTOR_ID] kia [POWER] te kaha",
    "wedo2.tiltDirection.any": "noa",
    "wedo2.tiltDirection.down": "ki raro",
    "wedo2.tiltDirection.left": "mauī",
    "wedo2.tiltDirection.right": "katau",
    "wedo2.tiltDirection.up": "ki runga",
    "wedo2.whenDistance": "ina tawhiti [OP] [REFERENCE]",
    "wedo2.whenTilted": "ina tītaha [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Tae",
    "paint.paintEditor.saturation": "Waiwai",
    "paint.paintEditor.brightness": "Pīataata",
    "paint.paintEditor.costume": "Kākahu",
    "paint.paintEditor.group": "Whakarōpūngia",
    "paint.paintEditor.ungroup": "Wehea",
    "paint.paintEditor.undo": "Wetekia",
    "paint.paintEditor.redo": "Mahia anōtia",
    "paint.paintEditor.forward": "Ki mua",
    "paint.paintEditor.backward": "Ki muri",
    "paint.paintEditor.front": "Mua",
    "paint.paintEditor.back": "Hoki atu",
    "paint.paintEditor.more": "Anō",
    "paint.modeTools.brushSize": "Rahi",
    "paint.modeTools.eraserSize": "Te rahi kōmuru",
    "paint.modeTools.copy": "Tāruatia",
    "paint.modeTools.paste": "Whakapiri",
    "paint.modeTools.delete": "Mukua",
    "paint.modeTools.curved": "Ānau",
    "paint.modeTools.pointed": "Koi",
    "paint.modeTools.thickness": "Mātotoru",
    "paint.modeTools.flipHorizontal": "Pore whakapae",
    "paint.modeTools.flipVertical": "Pore poutū",
    "paint.modeTools.filled": "Kua kī",
    "paint.modeTools.outlined": "Kua whakahuahuatia",
    "paint.paintEditor.bitmap": "Whakawhitia hei Maheremoka",
    "paint.paintEditor.vector": "Whakawhitia hei Pere",
    "paint.paintEditor.fill": "Whakakīia",
    "paint.paintEditor.stroke": "Whakahuahua",
    "paint.brushMode.brush": "Paraihe",
    "paint.eraserMode.eraser": "Kōmuru",
    "paint.fillMode.fill": "Whakakīia",
    "paint.lineMode.line": "Rārangi",
    "paint.ovalMode.oval": "Porowhita",
    "paint.rectMode.rect": "Tapawhā Roa",
    "paint.reshapeMode.reshape": "Tāraia anōtia",
    "paint.roundedRectMode.roundedRect": "Tapawhā Roa Tōpuku",
    "paint.selectMode.select": "Kōwhiria",
    "paint.textMode.text": "Kuputuhi",
    "paint.colorPicker.swap": "Whakawhitia"
  },
  "mn": {
    "gui.alerts.lostPeripheralConnection": "Scratch {extensionName}-тэй холбоо тасарлаа ",
    "gui.alerts.tryAgain": "Дахин оролдох",
    "gui.alerts.download": "Татах",
    "gui.connection.reconnect": "Дахин холбогд",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "дуу",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "дүрс",
    "gui.backpack.header": "Үүргэвч",
    "gui.backpack.errorBackpack": "Үүргэвчний алдаа",
    "gui.backpack.loadingBackpack": "Ачаалж байна",
    "gui.backpack.more": "Цааш...",
    "gui.backpack.emptyBackpack": "Үүргэвч хоосон байна",
    "gui.unsupportedBrowser.label": "Энэ хөтөвч дээр ажиллуулах боломжгүй",
    "gui.unsupportedBrowser.errorLabel": "Алдаа гарлаа",
    "gui.unsupportedBrowser.notRecommended": "Биднийг уучлаарай. Та энэ хөтчөөр Scratch-г ашиглах боломжгүй тул та хөтчөө (Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safari-н) сүүлийн хувилбараар шинэчилнэ үү.",
    "gui.unsupportedBrowser.description": "Биднийг уучлаарай. Та энэ хөтчөөр Scratch-г ашиглах боломжгүй тул та хөтчөө (Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safari-н) сүүлийн хувилбараар шинэчилнэ үү.",
    "gui.unsupportedBrowser.back": "Буцах",
    "gui.unsupportedBrowser.previewfaq": "Цааш уншихыг хүсвэл{previewFaqLink}-т очно уу.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Түгээмэл асуултууд",
    "gui.cards.all-tutorials": "Дадлага хичээл",
    "gui.cards.shrink": "Жижигрүүлэх",
    "gui.cards.expand": "Томруулах",
    "gui.cards.close": "Хаах",
    "gui.cards.more-things-to-try": "Илүү их туршиж үзэх зүйлс",
    "gui.cards.see-more": "Илүү ихийг харах",
    "gui.comingSoon.message1": "Битгий санаа зовоорой, бид энийг сайжруулахаар ажиллаж байна {emoji}",
    "gui.comingSoon.message2": "Тун удахгүй...",
    "gui.comingSoon.message3": "Бид энийг сайжруулахаар ажиллаж байна {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Төхөөрөмж олдсонгүй",
    "gui.connection.auto-scanning.prescan": "Төхөөрөмжийг ойрхон байршуулаад, хайж эхлэнэ үү.",
    "gui.connection.auto-scanning.pressbutton": "Төхөөрөмж дээрх товчлуурыг дарна уу",
    "gui.connection.auto-scanning.start-search": "Хайж эхлэх",
    "gui.connection.connecting-searchbutton": "Хайж байна",
    "gui.connection.auto-scanning.try-again": "Дахин оролдох",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Холбогдсон",
    "gui.connection.disconnect": "Салгах",
    "gui.connection.go-to-editor": "Editor руу орох",
    "gui.connection.connecting-cancelbutton": "Холбогдож байна...",
    "gui.connection.error.errorMessage": "Яанаа, ямар нэг асуудал гарлаа.",
    "gui.connection.error.tryagainbutton": "Дахин оролдох",
    "gui.connection.error.helpbutton": "Тусламж",
    "gui.connection.peripheral-name-label": "Төхөөрөмжийн нэр",
    "gui.connection.connect": "Холбогд",
    "gui.connection.scanning.lookingforperipherals": "Төхөөрөмжүүд хайж байна",
    "gui.connection.scanning.noPeripheralsFound": "Төхөөрөмж олдсонгүй",
    "gui.connection.scanning.instructions": "Дээрх жагсаалтаас төхөөрөмжөө сонгоно уу.",
    "gui.connection.search": "Дахин хайх",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Scratch Link-г компьютер дээрээ суулгаж, ажиллуулж байгаа эсэхийг шалгана уу.",
    "gui.connection.unavailable.enablebluetooth": "Bluetooth асаалттай эсэхийг шалгана уу.",
    "gui.connection.unavailable.tryagainbutton": "Дахин оролдох",
    "gui.connection.unavailable.helpbutton": "Тусламж",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Эхэл",
    "gui.controls.stop": "Зогс",
    "gui.crashMessage.label": "Яанаа. Алдаа гарчихлаа.",
    "gui.crashMessage.description": "Уучлаарай, Scratch програм дээр алдаа гарлаа. Энэхүү алдааг бид автоматаар цааш мэдээлнэ. Энэ хуудсыг шинээр нээж үзээрэй.",
    "gui.crashMessage.errorNumber": "Алдааг {errorId}дугаартай бүртгэлээ.",
    "gui.crashMessage.reload": "Дахин ачаалла",
    "gui.customProcedures.myblockModalTitle": "Блок зохиох",
    "gui.customProcedures.addAnInputNumberText": "Оролт нэмэх",
    "gui.customProcedures.numberTextType": "тоо эсвэл эх",
    "gui.customProcedures.addAnInputBoolean": "Оролт нэмэх",
    "gui.customProcedures.booleanType": "булийн",
    "gui.customProcedures.addALabel": "Тэмдэглэгээ нэмэх",
    "gui.customProcedures.runWithoutScreenRefresh": "Дэлгэцийг шинээр сэргээлгүйгээр ажиллах",
    "gui.customProcedures.cancel": "Цуцлах",
    "gui.customProcedures.ok": "Тийм",
    "gui.SpriteInfo.direction": "Чиглэл",
    "gui.directionPicker.rotationStyles.allAround": "Эргэн тойронд",
    "gui.directionPicker.rotationStyles.leftRight": "Зүүн/Баруун",
    "gui.directionPicker.rotationStyles.dontRotate": "Битгий эргүүл",
    "gui.gui.addExtension": "Өргөтгөл нэмэх",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Дэвсгэрүүд",
    "gui.gui.costumesTab": "Өмсгөлүүд",
    "gui.gui.soundsTab": "Дуунууд",
    "gui.extensionLibrary.comingSoon": "Мөд удахгүй",
    "gui.extensionLibrary.requires": "Шаардлага",
    "gui.extensionLibrary.collaboration": " хамтран ажиллах",
    "gui.library.filterPlaceholder": "Хайх",
    "gui.library.allTag": "Бүх",
    "gui.loader.message1": "Блок зохиож байна...",
    "gui.loader.message2": "Дүрснүүдийг нээж байна...",
    "gui.loader.message3": "Дуунуудыг нээж байна...",
    "gui.loader.message4": "Өргөтгөлүүдийг ачаалж байна...",
    "gui.loader.message5": "Уншсаар л байна...",
    "gui.loader.message6": "Удахгүй нээлээ, тэвчээрэй!",
    "gui.loader.message7": "Уншсаар л...",
    "gui.loader.message8": "Эможинуудыг уншиж байна...",
    "gui.loader.headline": "Төслийг уншиж байна",
    "gui.loader.creating": "Төсөл үүсгэж байна",
    "gui.accountMenu.profile": "Профайл",
    "gui.accountMenu.myStuff": "Миний төслүүд",
    "gui.accountMenu.myClasses": "Миний ангиуд",
    "gui.accountMenu.myClass": "Миний анги",
    "gui.accountMenu.accountSettings": "Бүртгэлийн тохиргоо",
    "gui.accountMenu.signOut": "Бүртгэлээ гаргах",
    "gui.authorInfo.byUser": "төслийг бүтээгч{username}",
    "gui.menuBar.seeProjectPage": "Төслийн хуудсаар зочлох",
    "gui.menuBar.language": "Language",
    "general.username": "Хэрэглэгчийн нэр",
    "general.password": "Нэвтрэх үг",
    "general.signIn": "Нэвтэрч орох",
    "login.needHelp": "Тусламж хэрэгтэй юу?",
    "form.validationRequired": "Энэ хэсгийг бөглөх шаардлагатай",
    "gui.menuBar.tutorialsLibrary": "Дасгал хичээл",
    "gui.menuBar.restoreSprite": "Устгасан дүрсийг буцаах",
    "gui.menuBar.restoreSound": "Устгасан дууг буцаах",
    "gui.menuBar.restoreCostume": "Устгасан өмсгөлийг буцаах",
    "gui.menuBar.restore": "Устгах үйлдлийг буцаах",
    "gui.menuBar.saveNow": "Одоо хадгалах",
    "gui.menuBar.saveAsCopy": "Хуулбарлаж хадгалах",
    "gui.menuBar.remix": "Холих",
    "gui.menuBar.new": "Шинэ",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Өөрийнхөө компьютерт хадгалах",
    "gui.menuBar.edit": "Засах",
    "gui.menuBar.turboModeOff": "Хурдасгах горимыг болиулах",
    "gui.menuBar.turboModeOn": "Хурдасгах горимыг ажиллуулах",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Scratch-д бүртгүүлэх",
    "gui.menuBar.signIn": "Нэвтэрч орох",
    "gui.gui.projectTitlePlaceholder": "Төслийн нэр бичих",
    "gui.menuBar.saveNowLink": "Одоо хадгалах",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Хуваалцсан төсөл",
    "gui.menuBar.share": "Хуваалцах",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Тусламж",
    "gui.modal.back": "Буцах",
    "gui.monitor.listMonitor.empty": "(хоосон)",
    "gui.monitor.listMonitor.listLength": "урт {length}",
    "gui.monitor.contextMenu.default": "жижигрүүлэх",
    "gui.monitor.contextMenu.large": "томруулах",
    "gui.monitor.contextMenu.slider": "хөшүүрэг",
    "gui.monitor.contextMenu.sliderRange": "хөшүүргийн хязгаарыг өөрчлөх",
    "gui.monitor.contextMenu.import": "оруулах",
    "gui.monitor.contextMenu.export": "гаргах",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Тоглуулах",
    "gui.playButton.stop": "Зогсоох",
    "gui.gui.variableScopeOptionAllSprites": "Бүх дүрсэнд",
    "gui.gui.variableScopeOptionSpriteOnly": "Зөвхөн энэ дүрсэнд",
    "gui.gui.cloudVariableOption": "үүлэн хувьсагч (сервер дээр хадгалсан)",
    "gui.gui.variablePromptAllSpritesMessage": "Энэ хувьсагчийн бүх дүрсэнд ашиглана.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Цуцлах",
    "gui.prompt.ok": "Тийм",
    "gui.playbackStep.stopMsg": "Зогсоох",
    "gui.playbackStep.playMsg": "Тоглуулах",
    "gui.playbackStep.loadingMsg": "Уншиж байна...",
    "gui.playbackStep.saveMsg": "Хадгалах",
    "gui.playbackStep.reRecordMsg": "Шинээр бичих",
    "gui.recordModal.title": "Дуу бичих",
    "gui.recordingStep.beginRecord": "\"Бичих\" товчийг дармагц дууг бичиж эхлэнэ",
    "gui.recordingStep.permission": "{arrow}Микрофон ашиглах эрх олгоно уу",
    "gui.recordingStep.stop": "Дуу бичихийг зогсоох",
    "gui.recordingStep.record": "Дуу бичих",
    "gui.sliderModal.min": "Хамгийн бага утга",
    "gui.sliderModal.max": "Хамгийн их утга",
    "gui.sliderModal.title": "Хөшүүрэгний цар хүрээг өөрчлөх ",
    "gui.sliderPrompt.cancel": "Цуцлах",
    "gui.sliderPrompt.ok": "Тийм",
    "gui.soundEditor.sound": "Дуу",
    "gui.soundEditor.play": "Тоглуулах",
    "gui.soundEditor.stop": "Зогсоох",
    "gui.soundEditor.copy": "Хуулбарлах",
    "gui.soundEditor.paste": "Шилжүүлэх",
    "gui.soundEditor.copyToNew": "Сонгосон дууг шинэ дуу руу хуулах",
    "gui.soundEditor.delete": "Устгах",
    "gui.soundEditor.save": "Хадгалах",
    "gui.soundEditor.undo": "Буцаах",
    "gui.soundEditor.redo": "Буцаасан үйлдлийг сэргээх",
    "gui.soundEditor.faster": "Хурдасгах",
    "gui.soundEditor.slower": "Удаашруулах",
    "gui.soundEditor.echo": "Цуурайтуулах",
    "gui.soundEditor.robot": "Робот эффект оруулах",
    "gui.soundEditor.louder": "Чангалах",
    "gui.soundEditor.softer": "Зөөлрүүлэх",
    "gui.soundEditor.reverse": "Эргүүлэх",
    "gui.soundEditor.fadeOut": "Аажмаар султгах",
    "gui.soundEditor.fadeIn": "Аажмаар чангалах",
    "gui.soundEditor.mute": "Дүүгүй болгох",
    "gui.SpriteInfo.spritePlaceholder": "Нэр",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Дүрс",
    "gui.SpriteInfo.show": "Харуулах",
    "gui.SpriteInfo.size": "Хэмжээ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "хувилах",
    "gui.spriteSelectorItem.contextMenuExport": "компьютерт хадгалах",
    "gui.spriteSelectorItem.contextMenuDelete": "устгах",
    "gui.spriteSelector.addSpriteFromLibrary": "Дүрс сонгох",
    "gui.spriteSelector.addSpriteFromPaint": "Дүрс зурах",
    "gui.spriteSelector.addSpriteFromSurprise": "Дүрсийг санамсаргүйгээр сонго",
    "gui.spriteSelector.addSpriteFromFile": "Дүрс компьютероос оруулах",
    "gui.stageHeader.stageSizeLarge": "Тайзыг томруулах",
    "gui.stageHeader.stageSizeSmall": "Тайзыг жижигрүүлэх",
    "gui.stageHeader.stageSizeFull": "Дэлгэцийг томруулах",
    "gui.stageHeader.stageSizeUnFull": "Дэлгэцийг жижигрүүлэх",
    "gui.stageHeader.fullscreenControl": "Дэлгэцийг томруулах/жижигрүүлэх",
    "gui.spriteSelector.addBackdropFromLibrary": "Дэвсгэр сонгох",
    "gui.stageSelector.addBackdropFromPaint": "Тайз зурах",
    "gui.stageSelector.addBackdropFromSurprise": "Тайзыг санамсаргүйгээр сонго",
    "gui.stageSelector.addBackdropFromFile": "Дэвсгэрийг файлаас оруулах",
    "gui.stageSelector.stage": "Тайз",
    "gui.stageSelector.backdrops": "Дэвсгэрүүд",
    "gui.telemetryOptIn.label": "Scratch-г сайжруулах зорилгоор статистик мэдээг явуулах",
    "gui.telemetryOptIn.body1": "Scratch баг хүмүүс дэлхий даяар Scratch-г хэрхэн ашиглаж буйг мэдэж, хэрхэн сайжруулах хэрэгтэйг тогтмол судалж байдаг. Та бидний ажлыг дэмжин, Scratch баг руу автоматаар хэрэглээний мэдээллийг явуулах зөвшөөрлийг олгоорой.",
    "gui.telemetryOptIn.body2": "Бид хэлний сонголт, блокын хэрэглээ, төсөл хадгалах, төсөл нээх, интернэтэд байршуулах зэрэг үйлдлүүдийн мэдэллийг цуглуулдаг болно. Бид хэрэглэгчийн ямарваа хувийн мэдээллийг цуглуулдаггүй. {privacyPolicyLink}руу хандаж манай мэдээлэл авах журамтай танилцана уу.",
    "gui.telemetryOptIn.privacyPolicyLink": "Хувийн мэдээлэл хадгалах журам",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Алсаас хэмжих төхөөрөмжийг идэвхжүүлэх",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Алсаас хэмжих төхөөрөмжийг идэвхгүй болгох",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Хаах",
    "gui.turboMode.active": "Турбо горим",
    "gui.webglModal.label": "Таны интернэт хөтөч WebGL дэмждэггүй тул хандах боломжгүй байна",
    "gui.webglModal.description": "Харамсалтай нь таны компьютер эсвэл интернэт хөтөч{webGlLink}-гүй бололтой. Scratch 3.0 ашиглахын тулд энэ технологийг суулгасан байх шаардлагатай.",
    "gui.webglModal.webgllink": "WebGL дэмждэггүй",
    "gui.webglModal.back": "Буцах",
    "gui.webglModal.previewfaq": "Илүү ихийг мэдхийн тулд {previewFaqLink}-р зочилно уу.",
    "gui.webglModal.previewfaqlinktext": "Түгээмэл асуултууд",
    "gui.costumeLibrary.chooseABackdrop": "Дэвсгэр сонгох",
    "gui.costumeLibrary.chooseACostume": "Өмсгөл сонгох",
    "gui.costumeTab.addBackdropFromLibrary": "Дэвсгэр сонгох",
    "gui.costumeTab.addCostumeFromLibrary": "Өмсгөл сонгох",
    "gui.costumeTab.addBlankCostume": "Өмсгөл зурах",
    "gui.costumeTab.addSurpriseCostume": "Өмсгөлийг санамсаргүйгээр сонго",
    "gui.costumeTab.addFileBackdrop": "Дэвсгэрийг файлаас оруулах",
    "gui.costumeTab.addFileCostume": "Файлаас өмсгөл оруулах",
    "gui.extensionLibrary.chooseAnExtension": "Нэмэлт өргөтгөлүүд",
    "gui.extensionLibrary.extensionUrl": "Өргөтгөлийн URL-г оруулна уу",
    "gui.monitors.importListColumnPrompt": "Аль баганыг ашиглах вэ (1-{numberOfColumns}-с сонгоно уу)? ",
    "gui.recordingStep.alertMsg": "Дуу бичиж чадсангүй",
    "gui.soundLibrary.chooseASound": "Дуу сонгох",
    "gui.soundTab.fileUploadSound": "Дууг компьютероос оруулах",
    "gui.soundTab.surpriseSound": "Дууг санамсаргүйгээр сонгох",
    "gui.soundTab.recordSound": "Дуу бичих",
    "gui.soundTab.addSoundFromLibrary": "Дуу сонгох",
    "gui.spriteLibrary.chooseASprite": "Дүрс сонгох",
    "gui.tipsLibrary.tutorials": "Заавар сонгох",
    "gui.alerts.createsuccess": "Шинэ төслийг үүсгэлээ.",
    "gui.alerts.createcopysuccess": "Төслийг хуулбарлаж хадгаллаа.",
    "gui.alerts.createremixsuccess": "Төслийг өөрчлөн хадгаллаа.",
    "gui.alerts.creating": "Шинээр үүсгэж байна...",
    "gui.alerts.creatingCopy": "Төслийг хуулбарлаж байна...",
    "gui.alerts.creatingRemix": "Төслийг өөрчлөн нээж байна...",
    "gui.alerts.creatingError": "Төсөл үүсгэж чадсангүй. Дахин оролдоорой!",
    "gui.alerts.savingError": "Төслийг хадгалж чадсангүй.",
    "gui.alerts.savesuccess": "Төслийг хадгаллаа.",
    "gui.alerts.saving": "Төслийг хадгалж байна...",
    "gui.alerts.cloudInfo": "Үүлэн хувьсагчид зөвхөн тоо хадгалж болох бөгөөд үсэг, дүрс хадгалахгүйг санаарай. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Илүү ихийг судлах.",
    "gui.alerts.importing": "Төслийг оруулж байна",
    "gui.defaultProject.meow": "Миав",
    "gui.defaultProject.variable": "миний хувьсагч",
    "gui.howtos.intro-move-sayhello-hat.name": "Эхлэх",
    "gui.howtos.intro-move.step_stepMove": "Хөдөлгөх блок нэмцгээе",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Ногоон туган дээр дарж эхлүүлээрэй",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Нэрийг хөдөлгөөнд оруулах",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Үсэг сонгоорой",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Товчлуур дарагдахад дууг тоглуулах",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Өөр нэг үсэг сонгоорой",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Өнгийг соль",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Өөр үсэг сонгоод, эргүүлцгээе",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Өөр нэг үсэг сонгоод, томордог болгоё",
    "gui.howtos.imagine": "Төсөөллийн ертөнцөө бүтээцгээе",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Хэлэхийг хүссэн зүйлээ бичээрэй",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Ногоон туган дээр дарж эхлүүлээрэй",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Ямар нэг дэвсгэр сонгох",
    "gui.howtos.imagine.step_imagineChooseSprite": "Хүссэн дүрсээ сонгоорой",
    "gui.howtos.imagine.step_imagineFlyAround": "Спейс товчлуурыг дарж гулсуулаарай",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Өөр дүрс сонгоорой",
    "gui.howtos.imagine.step_imagineLeftRight": "Баруун, зүүн тийш хөдөлгөөрэй",
    "gui.howtos.imagine.step_imagineUpDown": "Дээш, доош хөдөлгөөрэй",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Өмсгөлүүдийг солиорой",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Ямарваа цэг рүү гулсах",
    "gui.howtos.imagine.step_imagineGrowShrink": "Томруулах, жижигрүүлэх",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Өөр дэвсгэр сонгох",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Дэвсгэрийг соль",
    "gui.howtos.imagine.step_imagineRecordASound": "Дуу нэмэх",
    "gui.howtos.imagine.step_imagineChooseSound": "Дуу сонгох",
    "gui.howtos.make-music.name": "Хөгжим зохиох",
    "gui.howtos.Make-Music.step_PickInstrument": "Хөгжмийн зэмсгэн дүрс сонгоорой",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Товчлуур дарагдахад дууг тоглуулах",
    "gui.howtos.Make-Music.step_MakeSong": "Дуу бүтээцгээе",
    "gui.howtos.make-music.step_MakeBeat": "Бөмбөр сонгоод, хэмнэл зохиоцгооё",
    "gui.howtos.make-music.step_MakeBeatBox": "Микрофоны Дүрс & Санамсаргүй Битбокс сонгох",
    "gui.howtos.story.name": "Үлгэр зохиоё",
    "gui.howtos.story.step_addbg": "Дэвсгэр нэмэх",
    "gui.howtos.story.step_addsprite": "Дүрс нэмээрэй",
    "gui.howtos.story.step_saysomething": "Харилцан яриа нэмье",
    "gui.howtos.story.step_addanothersprite": "Өөр дүр нэмье",
    "gui.howtos.story.step_flip": "Эргүүлэх чиглэлийг сонгох",
    "gui.howtos.story.step_conversation": "Харилцан яриа өрнүүлцгээе",
    "gui.howtos.story.addanotherbg": "Өөр дэвсгэр нэмэх",
    "gui.howtos.story.step_swithbg": "Дэвсгэр солих",
    "gui.howtos.story.step_hidewizard": "Дүрсийг нуух",
    "gui.howtos.story.step_showwizard": "Дүрсийг харагдуулах",
    "gui.howtos.make-a-chase-game.name": "Хөөцөлдөх тоглоом бүтээе",
    "gui.howtos.Chase-Game.step_BG": "Дэвсгэр нэмэх",
    "gui.howtos.chase-game.step_AddOcto": "Дүрс нэмэх",
    "gui.howtos.make-music.step_LeftRight": "Сумаар дүрсийг дээш, доош хөдөлгөе",
    "gui.howtos.Chase-Game.step_UpDown": "Сумаар дүрсийг дээш, доош хөдөлгөе",
    "gui.howtos.Chase-Game.step_AddStar": "Өөр дүрс нэмэе",
    "gui.howtos.Chase-Game.step_MoveRandom": "Санамсаргүйгээр хөдөлгөөнд оруулах",
    "gui.howtos.Chase-Game.step_WhenTouch": "Наймалж дүрс Од дүрсэнд хүрэхэд дуу тоглуулах",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Онооны хувьсагч үүсгэх",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Наймалж дүрсэнд хүрвэл оноо авах",
    "gui.howtos.animate-char.name": "Дүрсийг хөдөлгөөнд оруулцгаая",
    "gui.howtos.animate-char.step_addbg": "Дэвсгэр нэмэх",
    "gui.howtos.animate-char.step_addsprite": "Дүрс нэмэх",
    "gui.howtos.animate-char.step_saysomething": "Ямарваа зүйл хэлэх",
    "gui.howtos.animate-char.step_addsound": "Дуу нэмэх",
    "gui.howtos.animate-char.step_animatetalking": "Яриаг хөдөлгөөнд оруулцгаая",
    "gui.howtos.animate-char.step_arrowkeys": "Сум ашиглан дүрсийг хөдөлгөе",
    "gui.howtos.animate-char.step_jump": "Үсрүүлэх",
    "gui.howtos.animate-char.step_changecolor": "Өнгийг сольё",
    "gui.howtos.make-a-game.name": "Дардаг тоглоом хийцгээе",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Дүрс сонгох",
    "gui.howtos.make-a-game.step_GamePlaySound": "Товчлуур дарахад дуу тоглуулах",
    "gui.howtos.make-a-game.step_GameAddScore": "Онооны хувьсагч үүсгэх",
    "gui.howtos.make-a-game.step_GameChangeScore": "Товчлуур дарвал оноог нэмэгдүүлэх",
    "gui.howtos.make-a-game.step_Random": "Санамсаргүй байршил сонгох",
    "gui.howtos.make-music.step_GameChangeColor": "Өнгийг солих",
    "gui.howtos.make-music.step_ResetScore": "Оноог тэглэх",
    "gui.howtos.make-it-fly.name": "Дүрсийг нисгэх",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Тэнгэрийн зурагтай тайз нэмэх",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Дүр сонгох",
    "gui.howtos.fly.step_stepflySaySomething": "Ямарваа зүйл хэл",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Дүрсийг сумаар хөдөлгөх",
    "gui.howtos.fly.step_stepflyChooseObject": "Цуглуулах зүйл сонгох",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Дүрсийг хөдөлдөг болгох",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Дүрээ сонгох",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Оноог нэмэх",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Оноог хадгалах",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Үзэгдэх орчин нэмэх",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Үзэгдэх орчинг хөдөлгөөнд оруулах",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Дараагийн өмсгөл",
    "gui.howtos.pong": "Понг тоглоом хийцгээе",
    "gui.howtos.pong.step_pongAddBackdrop": "Дэвсгэр нэмэх",
    "gui.howtos.pong.step_pongAddBallSprite": "Бөмбөгний дүрс нэмэх",
    "gui.howtos.pong.step_pongBounceAround": "Дүрсийг ойлгуулах",
    "gui.howtos.pong.step_pongAddPaddle": "Цохиур нэмэх",
    "gui.howtos.pong.step_pongMoveThePaddle": "Цохиурыг хөдөлгөөнд оруулах",
    "gui.howtos.pong.step_pongSelectBallSprite": "Бөмбөгний дүрс сонгох",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Бөмбөгийг цохиурт хүрмэгц ойлгох код бичицгээе",
    "gui.howtos.pong.step_pongAddAScore": "Оноог нэмэх",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Цэснээс 'Оноо'-г сонгох",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "'Оноог өөрчлөх' блокыг оруулах",
    "gui.howtos.pong.step_pongResetScore": "Оноог тэглэх",
    "gui.howtos.pong.step_pongAddLineSprite": "Зураасны дүрс нэмэх",
    "gui.howtos.pong.step_pongGameOver": "Тоглоом дууслаа",
    "gui.howtos.code-cartoon": "Код бичиж хүүхэлдэйн кино бүтээе",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Ногоон туган дээр дарахад дүрс ярих болно",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Дүрс дээр дарах үед хөдлөх код бичье",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Өөр дүр сонгох",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Хасах тэмдэг дээр дарж жижигрүүлэх",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Дүрийг томруулж, жижигрүүлье",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Өөр дүр сонгох",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Дүрсийг үсрүүлэх",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Үзэгдэлийг солихын тулд дүрсэн дээр дарах",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Тойрч эргэлдэх",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Өмсгөлүүдийг солих",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Үлгэртээ нэмэх өөр дүрснүүд сонгох",
    "gui.howtos.cartoon-network": "Адал явдалт тоглоом бүтээцгээе",
    "gui.howtos.cartoon-network.step_CNcharacter": "Харагдах дүр сонгох",
    "gui.howtos.cartoon-network.step_CNsay": "Ямарваа зүйл хэл",
    "gui.howtos.cartoon-network.step_CNglide": "Тойрч эргэлдэх",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Хөөх зүйл сонгох",
    "gui.howtos.cartoon-network.step_CNcollect": "Юмс цуглуулах",
    "gui.howtos.cartoon-network.step_CNvariable": "Онооны хувьсагч үүсгэх",
    "gui.howtos.cartoon-network.step_CNscore": "Оноог хадгалах",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Түвшинг ахиулах: Дэвсгэр солих",
    "gui.howtos.videosens.name": "Бичлэг мэдрэгч",
    "gui.howtos.videosens.step_addextension": "Өргөтгөл нэмэх",
    "gui.howtos.videosens.step_pet": "Муурыг илэх",
    "gui.howtos.videosens.step_animate": "Анимэйшн бүтээцгээе",
    "gui.howtos.videosens.step_pop": "Бөмбөлгийг хагалцгаая",
    "gui.howtos.say-it-out-loud": "Харилцан яриатай анимэйшн бүтээх",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Эхийг яриа рүү хөрвүүлэх блок нэмэх",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Хүссэн зүйлээ хэлээрэй",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Дуу хоолой оруулах",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Хөдөлгөөнд оруулах",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Дэвсгэр нэмэх",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Өөр дүр нэмэх",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Дуу дуулах",
    "gui.howtos.say-it-out-loud.step_TXTColor": " Өнгийг солих",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Тойруулан эргэлдүүлэх",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Томруулах, жижигрүүлэх",
    "gui.howtos.talking": "Үлгэр хүүрнэх цаг",
    "gui.howtos.talking.step_talesAddExtension": "Бичгэн эхийг яриа болгох блок нэмэх",
    "gui.howtos.talking.step_talesChooseSprite": "Дүрс сонгох",
    "gui.howtos.talking.step_talesSaySomething": "Дүрийг яриулах",
    "gui.howtos.talking.step_talesChooseBackdrop": "Дэвсгэр сонгох",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Дараагийн дэвсгэр рүү шилжихийн тулд дүр дээр дарах",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Өөр дүрс сонгох",
    "gui.howtos.talking.step_talesMoveAround": "Хөдөлгөх",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Өөр дэвсгэр сонгох",
    "gui.howtos.talking.step_talesAnimateTalking": "Яриаг хөдөлгөөнд оруулцгаая",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Өөр дэвсгэр сонгох",
    "gui.howtos.talking.step_talesChooseSound": "Бүжгийн ая сонгох",
    "gui.howtos.talking.step_talesDanceMoves": "Бүжиглэцгээе",
    "gui.howtos.talking.step_talesAskAnswer": "\"Мэдрэхүй\" цэснээс \"Асуугаад хариул\" блокыг ашиглах",
    "gui.howtos.add-sprite.name": "Дүрс нэмэх",
    "gui.howtos.add-sprite.step_addSprite": "Дүрс нэмэх",
    "gui.howtos.add-a-backdrop.name": "Дэвсгэр нэмэх",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Дэвсгэр нэмэх",
    "gui.howtos.change-size.name": "Хэмжээг өөрчлөх",
    "gui.howtos.change-size.step_changeSize": "Хэмжээг өөрчлөх",
    "gui.howtos.glide-around.name": "Тойрч эргэлдэх",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Тойрч эргэлдэх",
    "gui.howtos.change-size.step_glideAroundPoint": "Ямарваа цэг рүү гулсах",
    "gui.howtos.record-a-sound.name": "Дуу бичих",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "'Дуунууд' цэсэн дээр дар",
    "gui.howtos.change-size.step_recordASoundClickRecord": "'Дуу бичих' товчлуурыг дарах",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Дуу бичих товчийг дарах",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Дуу сонгох",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Дуугаа тоглуулах",
    "gui.howtos.spin-video.name": "Дүрсийг эргэлдүүлэх",
    "gui.howtos.change-size.step_spinTurn": "Эргүүлэх",
    "gui.howtos.change-size.step_spinPointInDirection": "Чиглэл сонгох",
    "gui.howtos.hide-and-show.name": "Нуугаад харуулах",
    "gui.howtos.change-size.step_hideAndShow": "Нуугаад харуулах",
    "gui.howtos.switch-costume.name": "Дүрсийг хөдөлгөөнд оруулах",
    "gui.howtos.change-size.step_switchCostumes": "Дүрсийг хөдөлгөөнд оруулах",
    "gui.howtos.move-around-with-arrow-keys.name": "Сумнуудыг ашиглах",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Баруун, зүүн тийш хөдлөх",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Дээш, доош хөдөлгөх",
    "gui.howtos.add-effects.name": "Эффект нэмэх",
    "gui.howtos.videosens.step_addEffects": "Эффект нэмэх",
    "gui.extension.music.name": "Хөгжим",
    "gui.extension.music.description": "Хөгжмийн зэмсэг, бөмбөр тоглуулах",
    "gui.extension.pen.name": "Үзэг",
    "gui.extension.pen.description": "Дүрсээрээ зурах",
    "gui.extension.videosensing.name": "Бичлэг мэдрэгч",
    "gui.extension.videosensing.description": "Камераар хөдөлгөөн мэдрэх",
    "gui.extension.text2speech.name": "Бичмэл эхээс яриа рүү хөрвүүлэх",
    "gui.extension.text2speech.description": "Төслүүдээ ярьдаг болгох",
    "gui.extension.translate.name": "Орчуулах",
    "gui.extension.translate.description": "Эхийг олон хэл рүү хөрвүүлэх",
    "gui.extension.makeymakey.description": "Ямарваа зүйлийг товч болгон ашиглах",
    "gui.extension.microbit.description": "Төслөө бусадтай хуваалцъя",
    "gui.extension.microbit.connectingMessage": "Холбогдож байна",
    "gui.extension.ev3.description": "Хөдөлгөөнт робот зэргийг барих ",
    "gui.extension.ev3.connectingMessage": "Холбогдож байна. EV3 дээрх хөлийг 1234 болгож тохируулсанг эсэхийг нягтлаарай.",
    "gui.extension.boost.description": "Роботуудад амь оруулцгаая.",
    "gui.extension.boost.connectingMessage": "Холбогдож байна",
    "gui.extension.wedo2.description": "Мотор, мэдрэгч ашиглах",
    "gui.extension.wedo2.connectingMessage": "Холбогдож байна",
    "gui.extension.gdxfor.description": "Түлхэх, татах, хөдлөх, эргэлдэх хөдөлгөөнүүдийг мэдрэх",
    "gui.extension.gdxfor.connectingMessage": "Холбогдож байна",
    "gui.libraryTags.all": "Бүгд",
    "gui.libraryTags.animals": "Амьтад",
    "gui.libraryTags.dance": "Бүжиг",
    "gui.libraryTags.effects": "Эффект",
    "gui.libraryTags.fantasy": "Уран зөгнөлт",
    "gui.libraryTags.fashion": "Хувцас загвар",
    "gui.libraryTags.food": "Хоол",
    "gui.libraryTags.indoors": "Дотоод",
    "gui.libraryTags.loops": "Давталтууд",
    "gui.libraryTags.music": "Хөгжим",
    "gui.libraryTags.notes": "Нотууд",
    "gui.libraryTags.outdoors": "Гадаад",
    "gui.libraryTags.patterns": "Зураг хээ",
    "gui.libraryTags.people": "Хүмүүс",
    "gui.libraryTags.percussion": "Цохиур хөгжим",
    "gui.libraryTags.space": "Сансар огторгүй",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Усан доорх",
    "gui.libraryTags.voice": "Дуу, хоолой",
    "gui.libraryTags.wacky": "Өвөрмөц",
    "gui.libraryTags.animation": "Анимэйшн",
    "gui.libraryTags.art": "Урлаг",
    "gui.libraryTags.games": "Тоглоомнууд",
    "gui.libraryTags.stories": "Үлгэрүүд",
    "gui.libraryTags.letters": "Үсгүүд",
    "gui.opcodeLabels.direction": "чиглэл",
    "gui.opcodeLabels.xposition": "x - утга",
    "gui.opcodeLabels.yposition": "y - утга",
    "gui.opcodeLabels.size": "хэмжээ",
    "gui.opcodeLabels.costumename": "өмсгөлийн нэр",
    "gui.opcodeLabels.costumenumber": "өмсгөлийн дугаар",
    "gui.opcodeLabels.backdropname": "дэвсгэрийн нэр",
    "gui.opcodeLabels.backdropnumber": "дэвсгэрийн дугаар",
    "gui.opcodeLabels.volume": "дууны эрч",
    "gui.opcodeLabels.tempo": "хэм",
    "gui.opcodeLabels.answer": "хариулт",
    "gui.opcodeLabels.loudness": "дууны эрч",
    "gui.opcodeLabels.username": "хэрэглэгчийн нэр",
    "gui.opcodeLabels.year": "жил",
    "gui.opcodeLabels.month": "сар",
    "gui.opcodeLabels.date": "огноо",
    "gui.opcodeLabels.dayofweek": "долоо хоногийн өдөр",
    "gui.opcodeLabels.hour": "цаг",
    "gui.opcodeLabels.minute": "минут",
    "gui.opcodeLabels.second": "секунд",
    "gui.opcodeLabels.timer": "тоолуур",
    "gui.projectLoader.loadError": "Сонгосон төслийн файлыг нээж чадсангүй.",
    "gui.sharedMessages.backdrop": "дэвсгэр {index}",
    "gui.sharedMessages.costume": "өмсгөл {index}",
    "gui.sharedMessages.sprite": "Дүрс {index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Одоо хөгжүүлж буй төслийг устган, шинийг нээх үү?",
    "gui.sharedMessages.loadFromComputerTitle": "Компьютероос төсөл оруулах",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch төсөл",
    "boost.color.any": "ямар нэг өнгө",
    "boost.color.black": "хар",
    "boost.color.blue": "цэнхэр",
    "boost.color.green": "ногоон",
    "boost.color.red": "улаан",
    "boost.color.white": "цагаан",
    "boost.color.yellow": "шар",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] моторын байршил",
    "boost.getTiltAngle": "[TILT_DIRECTION] өнцгөөр хазайлга",
    "boost.motorDirection.backward": "тэрүүгээр",
    "boost.motorDirection.forward": "энүүгээр",
    "boost.motorDirection.reverse": "гэдрэг",
    "boost.motorOff": "[MOTOR_ID] мотор-г унтраа",
    "boost.motorOn": "[MOTOR_ID] моторыг асаа",
    "boost.motorOnFor": "[MOTOR_ID] моторыг [DURATION] секунд асаа",
    "boost.motorOnForRotation": "мотор [MOTOR_ID]-г [ROTATION] эргүүлэхээр асаа",
    "boost.seeingColor": "[COLOR] тоосгыг харж байна уу?",
    "boost.setLightHue": "гэрлийн өнгийг [HUE] болго",
    "boost.setMotorDirection": "[MOTOR_ID] моторын чиглэлийг [MOTOR_DIRECTION] болго",
    "boost.setMotorPower": "[MOTOR_ID] моторын хурдыг [POWER] % болго",
    "boost.tiltDirection.any": "аливаа",
    "boost.tiltDirection.down": "доошоо",
    "boost.tiltDirection.left": "зүүн",
    "boost.tiltDirection.right": "баруун",
    "boost.tiltDirection.up": "дээшээ",
    "boost.whenColor": "[COLOR] тоосгыг харсан бол",
    "boost.whenTilted": "[TILT_DIRECTION_ANY] чигт хазайсан бол",
    "ev3.beepNote": "[NOTE] нот-г [TIME] секундын турш дуугарга",
    "ev3.buttonPressed": "[PORT] товчлуурыг дарсан уу?",
    "ev3.getBrightness": "цайруулалт",
    "ev3.getDistance": "зай",
    "ev3.getMotorPosition": "моторын [PORT] -ын байрлал",
    "ev3.motorSetPower": "моторын [PORT] -ын хүчийг [POWER] болго",
    "ev3.motorTurnClockwise": "моторын [PORT] -г цагийн зүүний дагуу [TIME] секунд хөдөлгө",
    "ev3.motorTurnCounterClockwise": "моторын [PORT] -г цагийн зүүний эсрэг тийш [TIME] секунд хөдөлгө",
    "ev3.whenBrightnessLessThan": "цайруулалт < [DISTANCE] үед",
    "ev3.whenButtonPressed": "[PORT] товчлуурыг дарсан үед",
    "ev3.whenDistanceLessThan": "зай < [DISTANCE] үед",
    "gdxfor.getAcceleration": "[DIRECTION] зүгт хурдал",
    "gdxfor.getForce": "хүч",
    "gdxfor.getSpin": "[DIRECTION] хурдаар эргэлд",
    "gdxfor.getTilt": "өнцгийг [TILT] -р хазайлга",
    "gdxfor.isFreeFalling": "унаж байна уу?",
    "gdxfor.isTilted": "[TILT] өнцгөөр хазайсан байна уу?",
    "gdxfor.pulled": "гадагш татагдсан",
    "gdxfor.pushed": "дотогш түлхэгдсэн",
    "gdxfor.shaken": "сэгсрэгдсэн",
    "gdxfor.startedFalling": "унаж эхэлсэн",
    "gdxfor.tiltDirectionMenu.any": "аливаа",
    "gdxfor.tiltDirectionMenu.back": "ар тал",
    "gdxfor.tiltDirectionMenu.front": "нүүр тал",
    "gdxfor.tiltDirectionMenu.left": "зүүн",
    "gdxfor.tiltDirectionMenu.right": "баруун",
    "gdxfor.turnedFaceDown": "нүүр тал нь доош харсан",
    "gdxfor.turnedFaceUp": "нүүр тал нь дээш харсан",
    "gdxfor.whenForcePushedOrPulled": "хүч мэдрэгч [PUSH_PULL] мэдрэх үед",
    "gdxfor.whenGesture": "[GESTURE] мэдрэгдэх үед",
    "gdxfor.whenTilted": "[TILT] өнцгөөр хазайсан байхад",
    "makeymakey.downArrow": "доошоо сум",
    "makeymakey.downArrowShort": "доошоо",
    "makeymakey.leftArrow": "зүүн сум",
    "makeymakey.leftArrowShort": "зүүн",
    "makeymakey.rightArrow": "баруун сум",
    "makeymakey.rightArrowShort": "баруун",
    "makeymakey.spaceKey": "спейс товчлуур",
    "makeymakey.upArrow": "дээш сум",
    "makeymakey.upArrowShort": "дээш",
    "makeymakey.whenKeyPressed": "товчлуур [KEY] дарагдах үед",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] дарааллыг дарах үед",
    "microbit.buttonsMenu.any": "аливаа",
    "microbit.clearDisplay": "дэлгэцийг цэвэрлэ",
    "microbit.defaultTextToDisplay": "Sain uu!",
    "microbit.displaySymbol": "[MATRIX] -г дэлгэцээр гарга",
    "microbit.displayText": "[TEXT] -г дэлгэцээр гарга",
    "microbit.gesturesMenu.jumped": "үсэрсэн",
    "microbit.gesturesMenu.moved": "хөдөлсөн",
    "microbit.gesturesMenu.shaken": "сэгсрэгдсэн",
    "microbit.isButtonPressed": "[BTN] товчлуур дарагдсан уу?",
    "microbit.isTilted": "[DIRECTION] зүг рүү хазайсан байна уу?",
    "microbit.pinStateMenu.off": "Унтраа",
    "microbit.pinStateMenu.on": "Асаа",
    "microbit.tiltAngle": "өнцгийг [DIRECTION] -р хазайлга",
    "microbit.tiltDirectionMenu.any": "аливаа",
    "microbit.tiltDirectionMenu.back": "ар тал",
    "microbit.tiltDirectionMenu.front": "урд тал",
    "microbit.tiltDirectionMenu.left": "зүүн",
    "microbit.tiltDirectionMenu.right": "баруун",
    "microbit.whenButtonPressed": "[BTN] товчлуурыг дарсан үед",
    "microbit.whenGesture": "[GESTURE] мэдрэгдэх үед",
    "microbit.whenPinConnected": "[PIN] хөл холбогдсон үед",
    "microbit.whenTilted": "[DIRECTION] чигт хазайсан бол",
    "music.categoryName": "Хөгжим",
    "music.changeTempo": "эрчмийг [TEMPO]-р соль",
    "music.drumBass": "(2) том бөмбөр",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса хөгжмийн зэмсэг",
    "music.drumClaves": "(9) Цохиурт хөгжмийн зэмсэг",
    "music.drumClosedHiHat": "(6) Хаалттай товшлуур хөгжим",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Хонх",
    "music.drumCrashCymbal": "(4) Жингэнэх цан",
    "music.drumCuica": "(18) Күика бөмбөр",
    "music.drumGuiro": "(16) Гуйро",
    "music.drumHandClap": "(8) Алга ташилтын дуу",
    "music.drumOpenHiHat": "(5) Хаалттай товшлуур хөгжим",
    "music.drumSideStick": "(3) Давхар бөмбөрдөх",
    "music.drumSnare": "(18) Жижиг бөмбөр",
    "music.drumTambourine": "(7) Тамбурин",
    "music.drumTriangle": "(12) Гурвалжин",
    "music.drumVibraslap": "(17) Вибро слэп",
    "music.drumWoodBlock": "(10) Модон блок",
    "music.getTempo": "хэм",
    "music.instrumentBass": "(6) Басс",
    "music.instrumentBassoon": "(14) Үелэх бишгүүр",
    "music.instrumentCello": "(8) Том хуур",
    "music.instrumentChoir": "(15) Найрал дуу",
    "music.instrumentClarinet": "(10) Кларинет бишгүүр",
    "music.instrumentElectricGuitar": "(5) Цахилгаан гитар",
    "music.instrumentElectricPiano": "(2) Цахилгаан төгөлдөр хуур",
    "music.instrumentFlute": "(12) Лимбэ",
    "music.instrumentGuitar": "(4) Гитар",
    "music.instrumentMarimba": "(19) Маримба хөгжим",
    "music.instrumentMusicBox": "(17) Хөгжмийн хайрцаг",
    "music.instrumentOrgan": "(3) Орган хөгжим",
    "music.instrumentPiano": "(1) Төгөлдөр хуур",
    "music.instrumentPizzicato": "(7) Пиццикато",
    "music.instrumentSaxophone": "(11) Сакфофон",
    "music.instrumentSteelDrum": "(18) Ган бөмбөр",
    "music.instrumentSynthLead": "(20) Синтетик хөгжим",
    "music.instrumentSynthPad": "(21) Синтетик даралт",
    "music.instrumentTrombone": "(9) Тромбон үлээвэр хөгжим",
    "music.instrumentVibraphone": "(16) Вибрафон",
    "music.instrumentWoodenFlute": "(13) Модон бишгүүр",
    "music.midiPlayDrumForBeats": "[DRUM] бөмбөрийг [BEATS] хэмнэл тогло",
    "music.midiSetInstrument": "хөгжмийн зэмсгийг [INSTRUMENT] болго",
    "music.playDrumForBeats": "[DRUM] бөмбөрийг [BEATS] хэмнэл тогло",
    "music.playNoteForBeats": "[NOTE] нотыг [BEATS] хэмнэл тогло",
    "music.restForBeats": "[BEATS] хэмнэл завсарла",
    "music.setInstrument": "хөгжмийн зэмсгийг [INSTRUMENT] болго",
    "music.setTempo": "темпийг [TEMPO] болго",
    "pen.categoryName": "Үзэг",
    "pen.changeColorParam": "үзгийн [COLOR_PARAM] -г [VALUE] -р соль",
    "pen.changeHue": "үзэгний өнгийг [HUE] болго",
    "pen.changeShade": "үзэгний сүүдрийг [SHADE] болго",
    "pen.changeSize": "үзэгний хэмжээг [SIZE]-р өөрчил",
    "pen.clear": "бүгдийг арилга",
    "pen.colorMenu.brightness": "гэрэлтэлт",
    "pen.colorMenu.color": "өнгө",
    "pen.colorMenu.saturation": "нэвчилт",
    "pen.colorMenu.transparency": "тунгалагжилт",
    "pen.penDown": "зур",
    "pen.penUp": "зурахаа боль",
    "pen.setColor": "[COLOR] өнгийн үзэг",
    "pen.setColorParam": "үзэгний [COLOR_PARAM] -г [VALUE] болго",
    "pen.setHue": "үзэгний өнгийг [HUE] болго",
    "pen.setShade": "үзэгний сүүдрийг [SHADE] болго",
    "pen.setSize": "үзэгний хэмжээг [SIZE] болго",
    "pen.stamp": "дардас",
    "speech.defaultWhenIHearValue": "явцгаая",
    "speech.extensionName": "Яриаг Бичмэл эх болго",
    "speech.listenAndWait": "сонсоод хүлээ",
    "speech.speechReporter": "яриа",
    "speech.whenIHear": "[PHRASE] -г сонсох үед",
    "text2speech.alto": "алто",
    "text2speech.categoryName": "Бичмэл эхээс яриа рүү",
    "text2speech.defaultTextToSpeak": "Сайн уу",
    "text2speech.giant": "аврага",
    "text2speech.kitten": "муужгай",
    "text2speech.setLanguageBlock": "хэлийг [LANGUAGE] хэл болго",
    "text2speech.setVoiceBlock": "авиаг [VOICE] болго",
    "text2speech.speakAndWaitBlock": "[WORDS] үгийг хэл",
    "text2speech.squeak": "чахрах",
    "text2speech.tenor": "тенор хоолой",
    "translate.categoryName": "Орчуулах",
    "translate.defaultTextToTranslate": "Сайн уу",
    "translate.translateBlock": "[WORDS] -г [LANGUAGE] хэл лүү орчуул",
    "translate.viewerLanguage": "хэл",
    "videoSensing.categoryName": "Бичлэг мэдрэгч",
    "videoSensing.direction": "чиглэл",
    "videoSensing.motion": "хөдөлгөөн",
    "videoSensing.off": "Салга",
    "videoSensing.on": "Залга",
    "videoSensing.onFlipped": "эргүүлсэн",
    "videoSensing.setVideoTransparency": "бичлэгийн тунгалагжилтыг [TRANSPARENCY] болго",
    "videoSensing.sprite": "дүрс",
    "videoSensing.stage": "тайз",
    "videoSensing.videoOn": "[SUBJECT] -д оногдох нийт [ATTRIBUTE] -н тоо",
    "videoSensing.videoToggle": "бичлэгийг [VIDEO_STATE] болго",
    "videoSensing.whenMotionGreaterThan": "бичлэгийн хөдөлгөөн > [REFERENCE] үед",
    "wedo2.getDistance": "зай",
    "wedo2.getTiltAngle": "өнцгийг [TILT_DIRECTION] -р хазайлга",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] чигт хазайсан байна уу?",
    "wedo2.motorDirection.backward": "тэрүүгээр",
    "wedo2.motorDirection.forward": "тэр зам",
    "wedo2.motorDirection.reverse": "гэдрэг",
    "wedo2.motorId.a": "мотор A",
    "wedo2.motorId.all": "бүх моторууд",
    "wedo2.motorId.b": "мотор B",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": "мотор [MOTOR_ID] -г унтраа",
    "wedo2.motorOn": "мотор [MOTOR_ID] -г асаа",
    "wedo2.motorOnFor": "мотор [MOTOR_ID] -г [DURATION] секунд асаа",
    "wedo2.playNoteFor": "[NOTE] нотыг [DURATION] секунд тогло ",
    "wedo2.setLightHue": "гэрлийн өнгийг [HUE] болго",
    "wedo2.setMotorDirection": "мотор [MOTOR_ID] -н чиглэлийг [MOTOR_DIRECTION] болго",
    "wedo2.startMotorPower": "моторын [MOTOR_ID] -ын хүчийг [POWER] болго",
    "wedo2.tiltDirection.any": "аливаа",
    "wedo2.tiltDirection.down": "доошоо",
    "wedo2.tiltDirection.left": "зүүн",
    "wedo2.tiltDirection.right": "баруун",
    "wedo2.tiltDirection.up": "дээшээ",
    "wedo2.whenDistance": "зай [OP][REFERENCE] үед",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY] чигт хазайсан бол",
    "paint.paintEditor.hue": "Өнгө",
    "paint.paintEditor.saturation": "Нэвчилт",
    "paint.paintEditor.brightness": "Цайруулалт",
    "paint.paintEditor.costume": "Өмсгөл",
    "paint.paintEditor.group": "Бүлэг",
    "paint.paintEditor.ungroup": "Бүлэглэлт болиулах",
    "paint.paintEditor.undo": "Үйлдлийг буцаах",
    "paint.paintEditor.redo": "Буцаалтыг сэргээх",
    "paint.paintEditor.forward": "Урагшаа",
    "paint.paintEditor.backward": "Арагшаа",
    "paint.paintEditor.front": "Урд",
    "paint.paintEditor.back": "Ард",
    "paint.paintEditor.more": "Цааш...",
    "paint.modeTools.brushSize": "Хэмжээ",
    "paint.modeTools.eraserSize": "Баллуурын хэмжээ",
    "paint.modeTools.copy": "Хуулбарлах",
    "paint.modeTools.paste": "Хуулбарыг буулгах",
    "paint.modeTools.delete": "Устгах",
    "paint.modeTools.curved": "Мохой",
    "paint.modeTools.pointed": "Хурц",
    "paint.modeTools.thickness": "Зузаан",
    "paint.modeTools.flipHorizontal": "Хэвтээ тэнхлэгийн дагуу тонгоруулах",
    "paint.modeTools.flipVertical": "Босоо тэнхлэгийн дагуу тонгоруулах",
    "paint.modeTools.filled": "Дүүрсэн",
    "paint.modeTools.outlined": "Хүрээлсэн зураастай",
    "paint.paintEditor.bitmap": "Битмап-руу шилжүүлэх",
    "paint.paintEditor.vector": "Вектор-т шилжүүл",
    "paint.paintEditor.fill": "Дүүргэх",
    "paint.paintEditor.stroke": "Хүрээ зураас",
    "paint.brushMode.brush": "Бийр",
    "paint.eraserMode.eraser": "Баллуур",
    "paint.fillMode.fill": "Дүүргэх",
    "paint.lineMode.line": "Шугам",
    "paint.ovalMode.oval": "Тойрог",
    "paint.rectMode.rect": "Тэгш өнцөгт",
    "paint.reshapeMode.reshape": "Дүрсийг өөрчлөх",
    "paint.roundedRectMode.roundedRect": "Мөлгөр дөрвөлжин",
    "paint.selectMode.select": "Сонгох",
    "paint.textMode.text": "Текст",
    "paint.colorPicker.swap": "Сэлгэх"
  },
  "nl": {
    "gui.alerts.lostPeripheralConnection": "Scratch heeft geen verbinding meer met {extensionName}.",
    "gui.alerts.tryAgain": "Probeer opnieuw",
    "gui.alerts.download": "Downloaden",
    "gui.connection.reconnect": "Opnieuw verbinden",
    "gui.backpack.costumeLabel": "uiterlijk",
    "gui.backpack.soundLabel": "geluid",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Rugzak",
    "gui.backpack.errorBackpack": "Fout bij laden van de rugzak",
    "gui.backpack.loadingBackpack": "Laden ...",
    "gui.backpack.more": "Meer",
    "gui.backpack.emptyBackpack": "Rugzak is leeg",
    "gui.unsupportedBrowser.label": "Browser wordt niet ondersteund",
    "gui.unsupportedBrowser.errorLabel": "Er is iets fout gegaan",
    "gui.unsupportedBrowser.notRecommended": "Het spijt ons, het lijkt erop dat je een browserversie gebruikt waarin Scratch niet werkt. We raden aan om te updaten naar de laatste versie van een browser waarin Scratch wel werkt zoals Google Chrome, Mozilla Firefox, Microsoft Edge of Apple Safari. ",
    "gui.unsupportedBrowser.description": "Het spijt ons zeer, maar Scratch werkt niet in deze browser. We raden aan om te updaten naar de laatste versie van een browser waarin Scratch wel werkt, zoals Google Chrome, Mozilla Firefox, Microsoft Edge of Apple Safari. ",
    "gui.unsupportedBrowser.back": "Terug",
    "gui.unsupportedBrowser.previewfaq": "Meer weten? Ga naar {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Lessen",
    "gui.cards.shrink": "Verklein",
    "gui.cards.expand": "Vergroot",
    "gui.cards.close": "Sluiten",
    "gui.cards.more-things-to-try": "Meer dingen om te proberen!",
    "gui.cards.see-more": "Bekijk meer",
    "gui.comingSoon.message1": "Geen zorgen, wij zijn ermee bezig {emoji}",
    "gui.comingSoon.message2": "Binnenkort beschikbaar",
    "gui.comingSoon.message3": "Wordt aan gewerkt {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Geen apparaten gevonden",
    "gui.connection.auto-scanning.prescan": "Houd je apparaat in de buurt, begin dan met zoeken",
    "gui.connection.auto-scanning.pressbutton": "Druk op de knop op je apparaat",
    "gui.connection.auto-scanning.start-search": "Start met zoeken",
    "gui.connection.connecting-searchbutton": "Zoeken ...",
    "gui.connection.auto-scanning.try-again": "Probeer opnieuw",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update mijn Apparaat",
    "gui.connection.connected": "Verbonden",
    "gui.connection.disconnect": "Verbinding verbreken",
    "gui.connection.go-to-editor": "Ga naar de editor",
    "gui.connection.connecting-cancelbutton": "Bezig te verbinden ...",
    "gui.connection.error.errorMessage": "Oeps, het lijkt dat er iets mis gegaan is.",
    "gui.connection.error.tryagainbutton": "Probeer opnieuw",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Apparaatnaam",
    "gui.connection.connect": "Verbind",
    "gui.connection.scanning.lookingforperipherals": "Zoeken naar apparaten",
    "gui.connection.scanning.noPeripheralsFound": "Geen apparaten gevonden",
    "gui.connection.scanning.instructions": "Kies je apparaat in de lijst hierboven.",
    "gui.connection.search": "Ververs",
    "gui.connection.scanning.updatePeripheralButton": "Update mijn Apparaat",
    "gui.connection.unavailable.installscratchlink": "Zorg ervoor Scratch Link geïnstalleerd is en draait.",
    "gui.connection.unavailable.enablebluetooth": "Controleer dat Bluetooth aan staat",
    "gui.connection.unavailable.tryagainbutton": "Probeer opnieuw",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.connection.updatePeripheral.microBitConnect": "Verbind je {extensionName} met dit apparaat met een USB-kabel.",
    "gui.connection.updatePeripheral.pressUpdate": "Druk op \"Update Uitvoeren\" en geef toestemming om de update te voltooien.",
    "gui.connection.updatePeripheral.progress": "Aan het updaten, {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update geslaagd!",
    "gui.connection.updatePeripheral.updateFailed": "Update mislukt.",
    "gui.connection.updatePeripheral.goBackButton": "Ga terug",
    "gui.connection.updatePeripheral.updateNowButton": "Update Uitvoeren",
    "gui.connection.updatePeripheral.updateAgainButton": "Probeer opnieuw",
    "gui.controls.go": "Ga",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oeps! Er is iets fout gegaan.",
    "gui.crashMessage.description": "Het spijt ons, maar het ziet er naar uit dat Scratch het heeft begeven. Deze fout wordt automatisch gerapporteerd aan het Scratch Team. Ververs je pagina om opnieuw te proberen.",
    "gui.crashMessage.errorNumber": "Je pagina is vastgelopen, en dat is geregistreerd met ID{errorId}",
    "gui.crashMessage.reload": "Herladen",
    "gui.customProcedures.myblockModalTitle": "Maak een blok",
    "gui.customProcedures.addAnInputNumberText": "Voeg een invoer toe",
    "gui.customProcedures.numberTextType": "getal of tekst",
    "gui.customProcedures.addAnInputBoolean": "Voeg een invoer toe",
    "gui.customProcedures.booleanType": "booleaan",
    "gui.customProcedures.addALabel": "Voeg een label toe",
    "gui.customProcedures.runWithoutScreenRefresh": "Voer uit zonder het scherm te verversen",
    "gui.customProcedures.cancel": " Annuleren",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Richting",
    "gui.directionPicker.rotationStyles.allAround": "Helemaal meedraaien",
    "gui.directionPicker.rotationStyles.leftRight": "Links/rechts",
    "gui.directionPicker.rotationStyles.dontRotate": "Niet meedraaien",
    "gui.gui.addExtension": "Voeg een uitbreiding toe",
    "gui.gui.codeTab": "Code",
    "gui.gui.backdropsTab": "Achtergronden",
    "gui.gui.costumesTab": "Uiterlijken",
    "gui.gui.soundsTab": "Geluiden",
    "gui.extensionLibrary.comingSoon": "Binnenkort beschikbaar",
    "gui.extensionLibrary.requires": "Vereist",
    "gui.extensionLibrary.collaboration": "Samenwerking met",
    "gui.library.filterPlaceholder": "Zoek",
    "gui.library.allTag": "Alles",
    "gui.loader.message1": "Blokken maken ...",
    "gui.loader.message2": "Bezig sprites te laden ...",
    "gui.loader.message3": "Bezig geluiden te laden ...",
    "gui.loader.message4": "Uitbreiding laden ...",
    "gui.loader.message5": "Katten verzamelen ...",
    "gui.loader.message6": "Nano's doorgeven",
    "gui.loader.message7": "Gobo's opblazen ...",
    "gui.loader.message8": "Emojis voorbereiden …",
    "gui.loader.headline": "Project laden...",
    "gui.loader.creating": "Bezig een project te maken",
    "gui.accountMenu.profile": "Profiel",
    "gui.accountMenu.myStuff": "Mijn projecten",
    "gui.accountMenu.myClasses": "Mijn groepen",
    "gui.accountMenu.myClass": "Mijn groep",
    "gui.accountMenu.accountSettings": "Accountinstellingen",
    "gui.accountMenu.signOut": "Afmelden",
    "gui.authorInfo.byUser": "door {username}",
    "gui.menuBar.seeProjectPage": "Bekijk de project pagina",
    "gui.menuBar.language": "Taal",
    "general.username": "Gebruikersnaam",
    "general.password": "Wachtwoord",
    "general.signIn": "Inloggen",
    "login.needHelp": "Hulp nodig?",
    "form.validationRequired": "Dit veld is verplicht",
    "gui.menuBar.tutorialsLibrary": "Lessen",
    "gui.menuBar.restoreSprite": "Herstel sprite",
    "gui.menuBar.restoreSound": "Herstel geluid",
    "gui.menuBar.restoreCostume": "Herstel uiterlijk",
    "gui.menuBar.restore": "Herstel",
    "gui.menuBar.saveNow": "Nu opslaan",
    "gui.menuBar.saveAsCopy": "Opslaan als",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Nieuw",
    "gui.menuBar.file": "Bestand",
    "gui.menuBar.downloadToComputer": "Opslaan op je computer",
    "gui.menuBar.edit": "Bewerk",
    "gui.menuBar.turboModeOff": "Zet turbo modus uit",
    "gui.menuBar.turboModeOn": "Zet turbo modus aan",
    "gui.menuBar.modeMenu": "Manier",
    "gui.menuBar.normalMode": "Normale manier",
    "gui.menuBar.caturdayMode": "Zoterdag manier",
    "gui.menuBar.joinScratch": "Word Scratcher",
    "gui.menuBar.signIn": "Inloggen",
    "gui.gui.projectTitlePlaceholder": "Project titel hier",
    "gui.menuBar.saveNowLink": "Bewaar nu",
    "gui.menuBar.settings": "Instellingen",
    "gui.menuBar.isShared": "Gedeeld",
    "gui.menuBar.share": "Delen",
    "gui.menuBar.colorMode": "Kleurmodus",
    "gui.modal.help": "Help",
    "gui.modal.back": "Terug",
    "gui.monitor.listMonitor.empty": "(leeg)",
    "gui.monitor.listMonitor.listLength": "lengte {length}",
    "gui.monitor.contextMenu.default": "normaal uitlezen",
    "gui.monitor.contextMenu.large": "groot uitlezen",
    "gui.monitor.contextMenu.slider": "schuif",
    "gui.monitor.contextMenu.sliderRange": "verander schuifbereik",
    "gui.monitor.contextMenu.import": "importeren",
    "gui.monitor.contextMenu.export": "exporteren",
    "gui.monitor.contextMenu.hide": "verdwijn",
    "gui.playButton.play": "Spelen",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Voor alle sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Alleen voor deze sprite",
    "gui.gui.cloudVariableOption": "Cloud variabele (opgeslagen op de server)",
    "gui.gui.variablePromptAllSpritesMessage": "Deze variabele is beschikbaar in alle sprites.",
    "gui.gui.listPromptAllSpritesMessage": "Deze lijst zal beschikbaar zijn voor alle sprites.",
    "gui.prompt.cancel": " Annuleren",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Spelen",
    "gui.playbackStep.loadingMsg": "Laden ...",
    "gui.playbackStep.saveMsg": "Bewaar",
    "gui.playbackStep.reRecordMsg": "Opnieuw opnemen",
    "gui.recordModal.title": "Geluid opnemen",
    "gui.recordingStep.beginRecord": "Begin met opnemen door op de onderstaande knop te klikken",
    "gui.recordingStep.permission": "{arrow}We hebben je toestemming nodig om je microfoon te gebruiken",
    "gui.recordingStep.stop": "Stop met opnemen",
    "gui.recordingStep.record": "Opnemen",
    "gui.sliderModal.min": "Minimum waarde",
    "gui.sliderModal.max": "Maximum waarde",
    "gui.sliderModal.title": "Verander schuifbereik",
    "gui.sliderPrompt.cancel": "Annuleren",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Geluid",
    "gui.soundEditor.play": "Spelen",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Kopie maken ",
    "gui.soundEditor.paste": "Plakken",
    "gui.soundEditor.copyToNew": "Kopieer naar nieuw",
    "gui.soundEditor.delete": "Verwijder",
    "gui.soundEditor.save": "Opslaan",
    "gui.soundEditor.undo": "Ongedaan maken",
    "gui.soundEditor.redo": "Opnieuw",
    "gui.soundEditor.faster": "Sneller",
    "gui.soundEditor.slower": "Trager",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Luider",
    "gui.soundEditor.softer": "Zachter",
    "gui.soundEditor.reverse": "Keer om",
    "gui.soundEditor.fadeOut": "Fade uit",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Stil",
    "gui.SpriteInfo.spritePlaceholder": "Naam",
    "gui.SpriteInfo.showSpriteAction": "Toon sprite",
    "gui.SpriteInfo.hideSpriteAction": "Verberg sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Toon",
    "gui.SpriteInfo.size": "Grootte",
    "gui.spriteSelectorItem.contextMenuDuplicate": "dupliceren",
    "gui.spriteSelectorItem.contextMenuExport": "exporteren",
    "gui.spriteSelectorItem.contextMenuDelete": "verwijderen",
    "gui.spriteSelector.addSpriteFromLibrary": "Kies een sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Teken",
    "gui.spriteSelector.addSpriteFromSurprise": "Verrassing",
    "gui.spriteSelector.addSpriteFromFile": "Upload sprite",
    "gui.stageHeader.stageSizeLarge": "Schakel naar groot speelveld",
    "gui.stageHeader.stageSizeSmall": "Schakel naar klein speelveld",
    "gui.stageHeader.stageSizeFull": "Ga naar volledig scherm",
    "gui.stageHeader.stageSizeUnFull": "Verlaat full screen mode",
    "gui.stageHeader.fullscreenControl": "Volledig scherm besturing",
    "gui.spriteSelector.addBackdropFromLibrary": "Kies een achtergrond",
    "gui.stageSelector.addBackdropFromPaint": "Tekenen",
    "gui.stageSelector.addBackdropFromSurprise": "Verrassing",
    "gui.stageSelector.addBackdropFromFile": "Upload achtergrond",
    "gui.stageSelector.stage": "Speelveld",
    "gui.stageSelector.backdrops": "Achtergronden",
    "gui.telemetryOptIn.label": "Deel statistieken om Scratch te verbeteren",
    "gui.telemetryOptIn.body1": "Het Scratch-team is constant bezig om beter te begrijpen hoe Scratch wereldwijd gebruikt wordt. Om dit streven te ondersteunen, kun je Scratch toestaan om automatisch gebruiksgegevens te versturen naar het Scratch-team.",
    "gui.telemetryOptIn.body2": "De informatie die we verzamelen omvat taalkeuze, gebruik van blokken en een aantal acties zoals opslaan, laden en uploaden van een project. We verzamelen GEEN persoonlijke informatie. Zie ons {privacyPolicyLink} voor meer informatie.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacybeleid",
    "gui.telemetryOptIn.optInText": "Deel mijn gebruikersgegevens met het Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Schakel telemetrie in",
    "gui.telemetryOptIn.optOutText": "Deel mijn gebruikersgegevens niet met het Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Schakel telemetrie uit",
    "gui.telemetryOptIn.settingWasUpdated": "Je keuze is bijgewerkt.",
    "gui.telemetryOptIn.buttonClose": "Sluiten",
    "gui.turboMode.active": "Turbomodus",
    "gui.webglModal.label": "WebGL wordt niet door jouw browser ondersteund",
    "gui.webglModal.description": "Helaas lijkt het erop dat jouw browser of computer {webGlLink}. Dit heb je nodig om met Scratch 3.0 te werken.",
    "gui.webglModal.webgllink": "ondersteunt geen WebGL",
    "gui.webglModal.back": "Terug",
    "gui.webglModal.previewfaq": "Meer weten? Ga naar {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Kies een achtergrond",
    "gui.costumeLibrary.chooseACostume": "Kies een uiterlijk",
    "gui.costumeTab.addBackdropFromLibrary": "Kies een achtergrond",
    "gui.costumeTab.addCostumeFromLibrary": "Kies een uiterlijk",
    "gui.costumeTab.addBlankCostume": "Tekenen",
    "gui.costumeTab.addSurpriseCostume": "Verrassing",
    "gui.costumeTab.addFileBackdrop": "Upload achtergrond",
    "gui.costumeTab.addFileCostume": "Upload uiterlijk",
    "gui.extensionLibrary.chooseAnExtension": "Kies een uitbreiding",
    "gui.extensionLibrary.extensionUrl": "Geef de URL van de uitbreiding",
    "gui.monitors.importListColumnPrompt": "Welke kolom moet gebruikt worden (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Kon opname niet starten",
    "gui.soundLibrary.chooseASound": "Kies een geluid",
    "gui.soundTab.fileUploadSound": "Upload geluid",
    "gui.soundTab.surpriseSound": "Verrassing",
    "gui.soundTab.recordSound": "Opnemen",
    "gui.soundTab.addSoundFromLibrary": "Kies een geluid",
    "gui.spriteLibrary.chooseASprite": "Kies een sprite",
    "gui.tipsLibrary.tutorials": "Kies een handleiding",
    "gui.alerts.createsuccess": "Nieuw project gemaakt.",
    "gui.alerts.createcopysuccess": "Kopie van het project bewaard.",
    "gui.alerts.createremixsuccess": "Project bewaard als een remix.",
    "gui.alerts.creating": "Bezig met nieuw te maken ...",
    "gui.alerts.creatingCopy": "Project wordt gekopieerd ...",
    "gui.alerts.creatingRemix": "Project wordt geremixed",
    "gui.alerts.creatingError": "Kon het project niet maken. Probeer opnieuw!",
    "gui.alerts.savingError": "Project kon niet opgeslagen worden.",
    "gui.alerts.savesuccess": "Project is bewaard.",
    "gui.alerts.saving": "Project wordt bewaard ...",
    "gui.alerts.cloudInfo": "Let op, cloud variabelen kunnen alleen worden gebruikt voor getallen, niet voor tekst of symbolen. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Meer weten.",
    "gui.alerts.importing": "Bezig met importeren ...",
    "gui.defaultProject.meow": "Miauw",
    "gui.defaultProject.variable": "mijn variabele",
    "gui.howtos.intro-move-sayhello-hat.name": "Aan de slag",
    "gui.howtos.intro-move.step_stepMove": "Voeg een bewegingsblok toe",
    "gui.howtos.add-a-move-block.step_stepSay": "Voeg een \"zeg\" blok toe",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klik op de groene vlag om te starten",
    "gui.howtos.intro-getting-started-ASL.name": "Beginnen - ASL (Amerikaanse Gebarentaal)",
    "gui.howtos.animate-a-name.name": "Animeer een naam",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Kies een letter sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Klik om een geluid te spelen",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Kies een andere letter sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Verander kleur",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Kies een andere letter sprite & laat hem draaien",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Kies een andere letter sprite & laat die groeien",
    "gui.howtos.imagine": "Bedenk een wereld",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Typ wat je wilt zeggen",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klik op de groene vlag om te starten",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Kies een achtergrond",
    "gui.howtos.imagine.step_imagineChooseSprite": "Kies een sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Druk op spatie om te schuiven",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Kies een andere sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Beweeg naar links en rechts",
    "gui.howtos.imagine.step_imagineUpDown": "Beweeg omhoog en omlaag",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Verander uiterlijken",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Schuif ergens heen",
    "gui.howtos.imagine.step_imagineGrowShrink": "Groei en krimp",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Kies een andere achtergrond",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Verwissel achtergronden",
    "gui.howtos.imagine.step_imagineRecordASound": "Geluid toevoegen",
    "gui.howtos.imagine.step_imagineChooseSound": "Kies je geluid",
    "gui.howtos.make-music.name": "Maak muziek",
    "gui.howtos.Make-Music.step_PickInstrument": "Kies een instrument sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Klik om een geluid te spelen",
    "gui.howtos.Make-Music.step_MakeSong": "Maak een liedje",
    "gui.howtos.make-music.step_MakeBeat": "Kies een trommel & maak een beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Kies de microfoon sprite & de verrassingsbeatbox",
    "gui.howtos.story.name": "Maak een verhaal",
    "gui.howtos.story.step_addbg": "Voeg een achtergrond toe",
    "gui.howtos.story.step_addsprite": "Voeg een karakter toe",
    "gui.howtos.story.step_saysomething": "Zeg iets",
    "gui.howtos.story.step_addanothersprite": "Voeg een sprite toe",
    "gui.howtos.story.step_flip": "Draai de richting om",
    "gui.howtos.story.step_conversation": "Heb een gesprek",
    "gui.howtos.story.addanotherbg": "Voeg een achtergrond toe",
    "gui.howtos.story.step_swithbg": "Verwissel achtergronden",
    "gui.howtos.story.step_hidewizard": "Verberg een sprite",
    "gui.howtos.story.step_showwizard": "Laat een sprite zien",
    "gui.howtos.make-a-chase-game.name": "Maak een achtervolgingsspel",
    "gui.howtos.Chase-Game.step_BG": "Voeg een achtergrond toe",
    "gui.howtos.chase-game.step_AddOcto": "Voeg een sprite toe",
    "gui.howtos.make-music.step_LeftRight": "Beweeg rechts & links met de pijltjestoetsen",
    "gui.howtos.Chase-Game.step_UpDown": "Beweeg op & neer met de pijltjestoetsen",
    "gui.howtos.Chase-Game.step_AddStar": "Voeg nog een andere sprite toe",
    "gui.howtos.Chase-Game.step_MoveRandom": "Beweeg willekeurig",
    "gui.howtos.Chase-Game.step_WhenTouch": "In de inktvis sprite, speel geluid bij aanraken",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Maak een  variabele met de naam score",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In de inktvis sprite, verhoog score bij aanraken",
    "gui.howtos.animate-char.name": "Animeer een sprite",
    "gui.howtos.animate-char.step_addbg": "Voeg een achtergrond toe",
    "gui.howtos.animate-char.step_addsprite": "Voeg een sprite toe",
    "gui.howtos.animate-char.step_saysomething": "Zeg iets",
    "gui.howtos.animate-char.step_addsound": "Voeg geluid toe",
    "gui.howtos.animate-char.step_animatetalking": "Animeer spreken",
    "gui.howtos.animate-char.step_arrowkeys": "Beweeg met de pijltjestoetsen",
    "gui.howtos.animate-char.step_jump": "Spring",
    "gui.howtos.animate-char.step_changecolor": "Verander de kleur",
    "gui.howtos.make-a-game.name": "Maak een klikspel",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Kies een sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Klik om een geluid te spelen",
    "gui.howtos.make-a-game.step_GameAddScore": "Maak een  variabele met de naam score",
    "gui.howtos.make-a-game.step_GameChangeScore": "Klik om Score te verhogen",
    "gui.howtos.make-a-game.step_Random": "Ga naar een willekeurige positie",
    "gui.howtos.make-music.step_GameChangeColor": "Verander de kleur",
    "gui.howtos.make-music.step_ResetScore": "Score resetten",
    "gui.howtos.make-it-fly.name": "Laat het vliegen",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Kies een lucht als achtergrond",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Kies een personage",
    "gui.howtos.fly.step_stepflySaySomething": "Zeg iets",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Beweeg met de pijltjestoetsen",
    "gui.howtos.fly.step_stepflyChooseObject": "Kies een voorwerp om te verzamelen",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Laat het voorwerp bewegen",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Kies je sprite",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Voeg een score toe",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Houd score bij",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Voeg een omgeving toe",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Verplaats de omgeving",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Volgend uiterlijk",
    "gui.howtos.pong": "Pong-spel",
    "gui.howtos.pong.step_pongAddBackdrop": "Voeg een achtergrond toe",
    "gui.howtos.pong.step_pongAddBallSprite": "Voeg een bal-sprite toe",
    "gui.howtos.pong.step_pongBounceAround": "Rond stuiteren",
    "gui.howtos.pong.step_pongAddPaddle": "Voeg een batje toe",
    "gui.howtos.pong.step_pongMoveThePaddle": "Verplaats het batje",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selecteer de bal-sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Voeg code toe, zodat de bal van het batje af stuitert",
    "gui.howtos.pong.step_pongAddAScore": "Voeg een score toe",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Kies 'Score' in het menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Voeg het 'Verander Score'-blok in",
    "gui.howtos.pong.step_pongResetScore": "Score resetten",
    "gui.howtos.pong.step_pongAddLineSprite": "Voeg de lijn-sprite toe",
    "gui.howtos.pong.step_pongGameOver": "Game over",
    "gui.howtos.code-cartoon": "Codeer een cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Zeg iets als je op de groene vlag klikt",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animeer een personage als je er op klikt",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selecteer een ander personage",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Gebruik een min teken om te krimpen",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Laat een personage groeien en krimpen",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selecteer een ander personage",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Spring op en neer",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klik op een personage om de achtergrond te veranderen",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glijd rond",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Verander uiterlijken",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Kies meer personages om aan je cartoon toe te voegen",
    "gui.howtos.cartoon-network": "Animeer een avonturenspel",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kies een sprite om te verschijnen",
    "gui.howtos.cartoon-network.step_CNsay": "Zeg iets",
    "gui.howtos.cartoon-network.step_CNglide": "Glijd rond",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kies een sprite om achterna te jagen",
    "gui.howtos.cartoon-network.step_CNcollect": "Verzamel voorwerpen",
    "gui.howtos.cartoon-network.step_CNvariable": "Maak een variabele Score",
    "gui.howtos.cartoon-network.step_CNscore": "Houd score bij",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Maak mooier: Verander de achtergrond",
    "gui.howtos.videosens.name": "Video",
    "gui.howtos.videosens.step_addextension": "Voeg een uitbreiding toe",
    "gui.howtos.videosens.step_pet": "Vertroetel de kat",
    "gui.howtos.videosens.step_animate": "Animeer",
    "gui.howtos.videosens.step_pop": "Knal een ballon",
    "gui.howtos.say-it-out-loud": "Maak animaties die praten",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Voeg de Tekst naar Spraak blokken toe",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Zeg iets",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Stel een stem in",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Beweeg",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Voeg een achtergrond toe",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Voeg een sprite toe",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Voer een lied uit",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Verander de kleur",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Draai rond",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Groei en krimp",
    "gui.howtos.talking": "Pratende verhalen",
    "gui.howtos.talking.step_talesAddExtension": "Klik op de Tekst-naar-spraak blokken",
    "gui.howtos.talking.step_talesChooseSprite": "Kies een sprite",
    "gui.howtos.talking.step_talesSaySomething": "Laat een personage praten",
    "gui.howtos.talking.step_talesChooseBackdrop": "Kies een achtergrond",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klik op een personage voor de volgende achtergrond",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Kies een andere sprite",
    "gui.howtos.talking.step_talesMoveAround": "Beweeg",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Kies een andere achtergrond",
    "gui.howtos.talking.step_talesAnimateTalking": "Animeer spreken",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Kies een andere achtergrond",
    "gui.howtos.talking.step_talesChooseSound": "Kies een muziekje om op te dansen",
    "gui.howtos.talking.step_talesDanceMoves": "Dans bewegingen",
    "gui.howtos.talking.step_talesAskAnswer": "Haal de Vraag en antwoord blokken bij de categorie Waarnemen",
    "gui.howtos.add-sprite.name": "Voeg een sprite toe",
    "gui.howtos.add-sprite.step_addSprite": "Voeg een sprite toe",
    "gui.howtos.add-a-backdrop.name": "Voeg een achtergrond toe",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Voeg een achtergrond toe",
    "gui.howtos.change-size.name": "Verander grootte",
    "gui.howtos.change-size.step_changeSize": "Verander grootte",
    "gui.howtos.glide-around.name": "Glijd rond",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glijd rond",
    "gui.howtos.change-size.step_glideAroundPoint": "Schuif ergens heen",
    "gui.howtos.record-a-sound.name": "Neem een geluid op",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klik op het 'Geluiden'-tabblad",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klik op 'Opnemen'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Klik op de Opneemknop",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Kies je geluid",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Speel je geluid af",
    "gui.howtos.spin-video.name": "Laat 'm draaien",
    "gui.howtos.change-size.step_spinTurn": "Draai",
    "gui.howtos.change-size.step_spinPointInDirection": "Stel richting in",
    "gui.howtos.hide-and-show.name": "Kiekeboe",
    "gui.howtos.change-size.step_hideAndShow": "Kiekeboe",
    "gui.howtos.switch-costume.name": "Animeer een sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animeer een sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Gebruik pijltoetsen",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Beweeg naar links en rechts",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Beweeg omhoog en omlaag",
    "gui.howtos.add-effects.name": "Voeg effecten toe",
    "gui.howtos.videosens.step_addEffects": "Voeg effecten toe",
    "gui.extension.music.name": "Muziek",
    "gui.extension.music.description": "Speel instrumenten en drums.",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Teken met je sprites.",
    "gui.extension.videosensing.name": "Video",
    "gui.extension.videosensing.description": "Neem beweging waar met de camera",
    "gui.extension.text2speech.name": "Tekst naar spraak",
    "gui.extension.text2speech.description": "Laat je projecten praten",
    "gui.extension.translate.name": "Vertaal",
    "gui.extension.translate.description": "Vertaal tekst naar vele talen.",
    "gui.extension.makeymakey.description": "Verander alles in een knop",
    "gui.extension.microbit.description": "Verbind je projecten met de wereld.",
    "gui.extension.microbit.connectingMessage": "Bezig te verbinden",
    "gui.extension.ev3.description": "Bouw interactieve robots en meer.",
    "gui.extension.ev3.connectingMessage": "Bezig te verbinden. Zorg dat de pin op je EV3 op 1234 gezet is.",
    "gui.extension.boost.description": "Breng robotcreaties tot leven.",
    "gui.extension.boost.connectingMessage": "Bezig te verbinden",
    "gui.extension.wedo2.description": "Bouw met motoren en sensoren.",
    "gui.extension.wedo2.connectingMessage": "Bezig te verbinden",
    "gui.extension.gdxfor.description": "Waarnemen van duwen, trekken, bewegen en draaien",
    "gui.extension.gdxfor.connectingMessage": "Bezig te verbinden",
    "gui.libraryTags.all": "Alles",
    "gui.libraryTags.animals": "Dieren",
    "gui.libraryTags.dance": "Dansen",
    "gui.libraryTags.effects": "Effecten",
    "gui.libraryTags.fantasy": "Fantasie",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Voedsel",
    "gui.libraryTags.indoors": "Binnen",
    "gui.libraryTags.loops": "Lussen",
    "gui.libraryTags.music": "Muziek",
    "gui.libraryTags.notes": "Noten",
    "gui.libraryTags.outdoors": "Buiten",
    "gui.libraryTags.patterns": "Patronen",
    "gui.libraryTags.people": "Mensen",
    "gui.libraryTags.percussion": "Slagwerk",
    "gui.libraryTags.space": "Ruimte",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Onder water",
    "gui.libraryTags.voice": "Stem",
    "gui.libraryTags.wacky": "Gek",
    "gui.libraryTags.animation": "Animatie",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Spelletjes",
    "gui.libraryTags.stories": "Verhalen",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "richting",
    "gui.opcodeLabels.xposition": "x-positie",
    "gui.opcodeLabels.yposition": "y-positie",
    "gui.opcodeLabels.size": "grootte",
    "gui.opcodeLabels.costumename": "uiterlijk naam",
    "gui.opcodeLabels.costumenumber": "uiterlijk nummer",
    "gui.opcodeLabels.backdropname": "achtergrond naam",
    "gui.opcodeLabels.backdropnumber": "achtergrond nummer",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "antwoord",
    "gui.opcodeLabels.loudness": "volume",
    "gui.opcodeLabels.username": "gebruikersnaam",
    "gui.opcodeLabels.year": "jaar",
    "gui.opcodeLabels.month": "maand",
    "gui.opcodeLabels.date": "datum",
    "gui.opcodeLabels.dayofweek": "dag van de week",
    "gui.opcodeLabels.hour": "uur",
    "gui.opcodeLabels.minute": "minuut",
    "gui.opcodeLabels.second": "seconde",
    "gui.opcodeLabels.timer": "klok",
    "gui.projectLoader.loadError": "Het geselecteerde projectbestand kon niet geladen worden.",
    "gui.sharedMessages.backdrop": "achtergrond{index}",
    "gui.sharedMessages.costume": "uiterlijk{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "plop",
    "gui.sharedMessages.replaceProjectWarning": "Huidige project vervangen?",
    "gui.sharedMessages.loadFromComputerTitle": "Uploaden vanaf je computer",
    "gui.theme.default": "Origineel",
    "gui.theme.dark": "Donker",
    "gui.theme.highContrast": "Hoog contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "willekeurige kleur",
    "boost.color.black": "zwart",
    "boost.color.blue": "blauw",
    "boost.color.green": "groen",
    "boost.color.red": "rood",
    "boost.color.white": "wit",
    "boost.color.yellow": "geel",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] positie",
    "boost.getTiltAngle": "kantelhoek [TILT_DIRECTION]",
    "boost.motorDirection.backward": "daarheen",
    "boost.motorDirection.forward": "hierheen",
    "boost.motorDirection.reverse": "omkeren",
    "boost.motorOff": "zet motor [MOTOR_ID] uit",
    "boost.motorOn": "zet motor [MOTOR_ID] aan",
    "boost.motorOnFor": "zet motor [MOTOR_ID][DURATION] seconde aan",
    "boost.motorOnForRotation": "zet motor [MOTOR_ID] aan voor [ROTATION] omwentelingen",
    "boost.seeingColor": "is steen [COLOR]?",
    "boost.setLightHue": "zet lichtkleur op [HUE]",
    "boost.setMotorDirection": "zet motor [MOTOR_ID] richting op [MOTOR_DIRECTION]",
    "boost.setMotorPower": "zet motor [MOTOR_ID] snelheid op [POWER]%",
    "boost.tiltDirection.any": "willekeurig",
    "boost.tiltDirection.down": "omlaag",
    "boost.tiltDirection.left": "links",
    "boost.tiltDirection.right": "rechts",
    "boost.tiltDirection.up": "omhoog",
    "boost.whenColor": "als [COLOR] steen gezien",
    "boost.whenTilted": "als gekanteld naar [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "speel noot [NOTE][TIME]seconde",
    "ev3.buttonPressed": "knop [PORT]ingedrukt?",
    "ev3.getBrightness": "helderheid",
    "ev3.getDistance": "afstand",
    "ev3.getMotorPosition": "motor [PORT]positie",
    "ev3.motorSetPower": "zet motor [PORT]op [POWER]%",
    "ev3.motorTurnClockwise": "draai motor [PORT][TIME] seconde hierheen",
    "ev3.motorTurnCounterClockwise": "draai motor [PORT][TIME]seconde daarheen",
    "ev3.whenBrightnessLessThan": "als helderheid < [DISTANCE]",
    "ev3.whenButtonPressed": "als knop [PORT]ingedrukt is",
    "ev3.whenDistanceLessThan": "als afstand < [DISTANCE]",
    "gdxfor.getAcceleration": "versnelling [DIRECTION]",
    "gdxfor.getForce": "kracht",
    "gdxfor.getSpin": "draaisnelheid [DIRECTION]",
    "gdxfor.getTilt": "kantelhoek [TILT]",
    "gdxfor.isFreeFalling": "vallend?",
    "gdxfor.isTilted": "gekanteld [TILT]",
    "gdxfor.pulled": "getrokken",
    "gdxfor.pushed": "gedrukt",
    "gdxfor.shaken": "geschud",
    "gdxfor.startedFalling": "begonnen te vallen",
    "gdxfor.tiltDirectionMenu.any": "willekeurig",
    "gdxfor.tiltDirectionMenu.back": "achter",
    "gdxfor.tiltDirectionMenu.front": "voor",
    "gdxfor.tiltDirectionMenu.left": "links",
    "gdxfor.tiltDirectionMenu.right": "rechts",
    "gdxfor.turnedFaceDown": "gericht naar beneden",
    "gdxfor.turnedFaceUp": "gericht naar boven",
    "gdxfor.whenForcePushedOrPulled": "wanneer krachtsensor [PUSH_PULL]",
    "gdxfor.whenGesture": "wanneer [GESTURE]",
    "gdxfor.whenTilted": "als [TILT]gekanteld",
    "makeymakey.downArrow": "pijltje omlaag",
    "makeymakey.downArrowShort": "omlaag",
    "makeymakey.leftArrow": "pijltje links",
    "makeymakey.leftArrowShort": "links",
    "makeymakey.rightArrow": "pijltje rechts",
    "makeymakey.rightArrowShort": "rechts",
    "makeymakey.spaceKey": "spatie",
    "makeymakey.upArrow": "pijltje omhoog",
    "makeymakey.upArrowShort": "omhoog",
    "makeymakey.whenKeyPressed": "wanneer [KEY]toets ingedrukt wordt",
    "makeymakey.whenKeysPressedInOrder": "wanneer [SEQUENCE]in deze volgorde wordt ingedrukt",
    "microbit.buttonsMenu.any": "willekeurig",
    "microbit.clearDisplay": "wis het display",
    "microbit.defaultTextToDisplay": "Hallo!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "toon tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "gesprongen",
    "microbit.gesturesMenu.moved": "bewogen",
    "microbit.gesturesMenu.shaken": "geschud",
    "microbit.isButtonPressed": "knop [BTN]ingedrukt?",
    "microbit.isTilted": "gekanteld naar[DIRECTION]?",
    "microbit.pinStateMenu.off": "uit",
    "microbit.pinStateMenu.on": "aan",
    "microbit.tiltAngle": "kantelhoek [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "willekeurig",
    "microbit.tiltDirectionMenu.back": "achter",
    "microbit.tiltDirectionMenu.front": "voor",
    "microbit.tiltDirectionMenu.left": "links",
    "microbit.tiltDirectionMenu.right": "rechts",
    "microbit.whenButtonPressed": "als knop [BTN]ingedrukt is",
    "microbit.whenGesture": "als [GESTURE]",
    "microbit.whenPinConnected": "wanneer pin [PIN] is verbonden",
    "microbit.whenTilted": "als gekanteld naar [DIRECTION]",
    "music.categoryName": "Muziek",
    "music.changeTempo": "verander tempo met [TEMPO]",
    "music.drumBass": "(2) Basdrum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabassa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Gesloten Hihat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Koebel",
    "music.drumCrashCymbal": "(4) Crashbekken",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Handklap",
    "music.drumOpenHiHat": "(5) Open Hihat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snarentrom",
    "music.drumTambourine": "(7) Tamboerijn",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood Block",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Koor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Elektrische Gitaar",
    "music.instrumentElectricPiano": "(2) Elektrische Piano",
    "music.instrumentFlute": "(12) Fluit",
    "music.instrumentGuitar": "(4) Gitaar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Speeldoos",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofoon",
    "music.instrumentSteelDrum": "(18) Steeldrum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafoon",
    "music.instrumentWoodenFlute": "(13) Blokfluit",
    "music.midiPlayDrumForBeats": "speel drum [DRUM]gedurende[BEATS] maten",
    "music.midiSetInstrument": "maak instrument [INSTRUMENT]",
    "music.playDrumForBeats": "speel drum [DRUM]gedurende[BEATS] maten",
    "music.playNoteForBeats": "speel noot [NOTE] gedurende [BEATS]maten",
    "music.restForBeats": "[BEATS]maten rust",
    "music.setInstrument": "maak instrument [INSTRUMENT]",
    "music.setTempo": "maak tempo [TEMPO]",
    "pen.categoryName": "Pen",
    "pen.changeColorParam": "verander pen [COLOR_PARAM]met [VALUE]",
    "pen.changeHue": "verander penkleur met [HUE]",
    "pen.changeShade": "verander penhelderheid met [SHADE]",
    "pen.changeSize": "verander pendikte met [SIZE]",
    "pen.clear": "wis alles",
    "pen.colorMenu.brightness": "helderheid",
    "pen.colorMenu.color": "kleur",
    "pen.colorMenu.saturation": "verzadiging",
    "pen.colorMenu.transparency": "doorzichtigheid",
    "pen.penDown": "pen neer",
    "pen.penUp": "pen op",
    "pen.setColor": "maak penkleur [COLOR]",
    "pen.setColorParam": "maak pen [COLOR_PARAM] [VALUE]",
    "pen.setHue": "maak penkleur [HUE]",
    "pen.setShade": "maak penhelderheid [SHADE]",
    "pen.setSize": "maak pendikte [SIZE]",
    "pen.stamp": "stempel",
    "speech.defaultWhenIHearValue": "daar gaan we",
    "speech.extensionName": "Spraak naar tekst",
    "speech.listenAndWait": "luister en wacht",
    "speech.speechReporter": "spraak",
    "speech.whenIHear": "als ik [PHRASE]hoor",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Tekst naar spraak",
    "text2speech.defaultTextToSpeak": "hallo",
    "text2speech.giant": "reus",
    "text2speech.kitten": "katje",
    "text2speech.setLanguageBlock": "stel de taal in op [LANGUAGE]",
    "text2speech.setVoiceBlock": "zet stem op [VOICE]",
    "text2speech.speakAndWaitBlock": "zeg [WORDS]",
    "text2speech.squeak": "piep",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Vertaal",
    "translate.defaultTextToTranslate": "hallo",
    "translate.translateBlock": "vertaal [WORDS] naar [LANGUAGE]",
    "translate.viewerLanguage": "taal",
    "videoSensing.categoryName": "Video",
    "videoSensing.direction": "richting",
    "videoSensing.motion": "beweging",
    "videoSensing.off": "uit",
    "videoSensing.on": "aan",
    "videoSensing.onFlipped": "aan gespiegeld",
    "videoSensing.setVideoTransparency": "zet video transparantie op [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "speelveld",
    "videoSensing.videoOn": "video [ATTRIBUTE]van[SUBJECT]",
    "videoSensing.videoToggle": "zet video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "wanneer video beweging > [REFERENCE]",
    "wedo2.getDistance": "afstand",
    "wedo2.getTiltAngle": "kantelhoek [TILT_DIRECTION]",
    "wedo2.isTilted": "gekanteld [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "daarheen",
    "wedo2.motorDirection.forward": "hierheen",
    "wedo2.motorDirection.reverse": "omkeren",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motoren",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "zet [MOTOR_ID]uit",
    "wedo2.motorOn": "zet [MOTOR_ID]aan",
    "wedo2.motorOnFor": "zet [MOTOR_ID][DURATION]seconde aan",
    "wedo2.playNoteFor": "speel noot [NOTE][DURATION]seconde",
    "wedo2.setLightHue": "zet lichtkleur op [HUE]",
    "wedo2.setMotorDirection": "zet [MOTOR_ID]richting op [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "zet [MOTOR_ID]kracht op [POWER]",
    "wedo2.tiltDirection.any": "willekeurig",
    "wedo2.tiltDirection.down": "omlaag",
    "wedo2.tiltDirection.left": "links",
    "wedo2.tiltDirection.right": "rechts",
    "wedo2.tiltDirection.up": "omhoog",
    "wedo2.whenDistance": "als afstand [OP][REFERENCE]",
    "wedo2.whenTilted": "als gekanteld naar [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kleur",
    "paint.paintEditor.saturation": "Verzadiging",
    "paint.paintEditor.brightness": "Helderheid",
    "paint.paintEditor.costume": "Uiterlijk",
    "paint.paintEditor.group": "Groeperen",
    "paint.paintEditor.ungroup": "Groep opheffen",
    "paint.paintEditor.undo": "Ongedaan maken",
    "paint.paintEditor.redo": "Opnieuw",
    "paint.paintEditor.forward": "Naar voren",
    "paint.paintEditor.backward": "Naar achteren",
    "paint.paintEditor.front": "Naar voorgrond",
    "paint.paintEditor.back": "Naar achtergrond",
    "paint.paintEditor.more": "Meer",
    "paint.modeTools.brushSize": "Grootte",
    "paint.modeTools.eraserSize": "Gum-breedte",
    "paint.modeTools.copy": "Kopie maken ",
    "paint.modeTools.paste": "Plakken",
    "paint.modeTools.delete": "Verwijder",
    "paint.modeTools.curved": "Gebogen",
    "paint.modeTools.pointed": "Puntig",
    "paint.modeTools.thickness": "Dikte",
    "paint.modeTools.flipHorizontal": "Links-rechts omdraaien",
    "paint.modeTools.flipVertical": "Boven-onder omdraaien",
    "paint.modeTools.filled": "Gevuld",
    "paint.modeTools.outlined": "Omtrek",
    "paint.paintEditor.bitmap": "Zet om naar bitmap",
    "paint.paintEditor.vector": "Zet om naar vector",
    "paint.paintEditor.fill": "Vulling",
    "paint.paintEditor.stroke": "Omtrek",
    "paint.brushMode.brush": "Kwast",
    "paint.eraserMode.eraser": "Gum",
    "paint.fillMode.fill": "Vulling",
    "paint.lineMode.line": "Lijn",
    "paint.ovalMode.oval": "Cirkel",
    "paint.rectMode.rect": "Rechthoek",
    "paint.reshapeMode.reshape": "Opnieuw vormen",
    "paint.roundedRectMode.roundedRect": "Afgeronde rechthoek",
    "paint.selectMode.select": "Selecteren",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Wissel"
  },
  "ja": {
    "gui.alerts.lostPeripheralConnection": " {extensionName}への接続が失われました。",
    "gui.alerts.tryAgain": "もう一度試す ",
    "gui.alerts.download": "ダウンロード",
    "gui.connection.reconnect": "再接続",
    "gui.backpack.costumeLabel": "コスチューム",
    "gui.backpack.soundLabel": "音",
    "gui.backpack.scriptLabel": "スクリプト",
    "gui.backpack.spriteLabel": "スプライト",
    "gui.backpack.header": "バックパック",
    "gui.backpack.errorBackpack": "バックパックの読み込み時にエラーが発生しました",
    "gui.backpack.loadingBackpack": "読み込み中...",
    "gui.backpack.more": "もっと",
    "gui.backpack.emptyBackpack": "バックパックは空です",
    "gui.unsupportedBrowser.label": " ブラウザーはサポートされていません",
    "gui.unsupportedBrowser.errorLabel": "エラーが発生しました",
    "gui.unsupportedBrowser.notRecommended": "申し訳ありませんが、Scratchがサポートしていないブラウザーをお使いのようです。Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safariのようなサポートされたブラウザーの最新バージョンの使用をお勧めします。 ",
    "gui.unsupportedBrowser.description": "申し訳ありませんが、Scratchはこのブラウザーをサポートしていません。サポートしているGoogle Chrome, Mozilla Firefox, Microsoft Edge, Apple Safariのようなサポートされたブラウザーの最新バージョンの使用をお勧めします。 ",
    "gui.unsupportedBrowser.back": "戻る",
    "gui.unsupportedBrowser.previewfaq": "詳しくは、{previewFaqLink}をご覧下さい。",
    "gui.unsupportedBrowser.previewfaqlinktext": "よくある質問",
    "gui.cards.all-tutorials": "チュートリアル",
    "gui.cards.shrink": "縮小",
    "gui.cards.expand": "拡大",
    "gui.cards.close": "閉じる",
    "gui.cards.more-things-to-try": "これも試してみよう！",
    "gui.cards.see-more": "もっと見る",
    "gui.comingSoon.message1": "ご安心下さい。開発中です {emoji}",
    "gui.comingSoon.message2": "近日公開",
    "gui.comingSoon.message3": "開発中です {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "デバイスが見つかりませんでした",
    "gui.connection.auto-scanning.prescan": "デバイスを近くに置いて、検索を開始する",
    "gui.connection.auto-scanning.pressbutton": "デバイスのボタンを押す",
    "gui.connection.auto-scanning.start-search": "検索を開始",
    "gui.connection.connecting-searchbutton": "検索中...",
    "gui.connection.auto-scanning.try-again": "もう一度試す",
    "gui.connection.auto-scanning.updatePeripheralButton": "デバイスをアップデートする",
    "gui.connection.connected": "接続されました",
    "gui.connection.disconnect": "切断する",
    "gui.connection.go-to-editor": "エディターへ行く",
    "gui.connection.connecting-cancelbutton": "接続中です...",
    "gui.connection.error.errorMessage": "うわっ! 何か問題が発生したようです。",
    "gui.connection.error.tryagainbutton": "もう一度試す",
    "gui.connection.error.helpbutton": "ヘルプ",
    "gui.connection.peripheral-name-label": "デバイス名",
    "gui.connection.connect": "接続する",
    "gui.connection.scanning.lookingforperipherals": "デバイスを探索中",
    "gui.connection.scanning.noPeripheralsFound": "デバイスが見つかりませんでした",
    "gui.connection.scanning.instructions": "上のリストからデバイスを選んでください。",
    "gui.connection.search": "更新",
    "gui.connection.scanning.updatePeripheralButton": "デバイスをアップデートする",
    "gui.connection.unavailable.installscratchlink": "Scratch Linkがインストールされ、実行中であることを確認してください",
    "gui.connection.unavailable.enablebluetooth": "Bluetoothが有効になっていることを確認してください",
    "gui.connection.unavailable.tryagainbutton": "もう一度試す",
    "gui.connection.unavailable.helpbutton": "ヘルプ",
    "gui.connection.updatePeripheral.microBitConnect": "{extensionName}をUSBケーブルで接続してください",
    "gui.connection.updatePeripheral.pressUpdate": "「更新する」を押して、更新を完了します。",
    "gui.connection.updatePeripheral.progress": " {progressPercentage}% 更新中",
    "gui.connection.updatePeripheral.updateSuccessful": "アップデートが成功しました！",
    "gui.connection.updatePeripheral.updateFailed": "アップデートが失敗しました。",
    "gui.connection.updatePeripheral.goBackButton": "戻る",
    "gui.connection.updatePeripheral.updateNowButton": "更新する",
    "gui.connection.updatePeripheral.updateAgainButton": "もう一度やり直してください",
    "gui.controls.go": "実行",
    "gui.controls.stop": "止める",
    "gui.crashMessage.label": "うわっ! 何か問題が発生しました。",
    "gui.crashMessage.description": "申し訳ありません。Scratchがクラッシュしたようです。この問題はScratchチームに自動的に送信されました。ページを再読み込みしてください。",
    "gui.crashMessage.errorNumber": "エラーはID {errorId}として記録されました。",
    "gui.crashMessage.reload": "再読み込み",
    "gui.customProcedures.myblockModalTitle": "ブロックを作る",
    "gui.customProcedures.addAnInputNumberText": "引数を追加",
    "gui.customProcedures.numberTextType": "数値またはテキスト",
    "gui.customProcedures.addAnInputBoolean": "引数を追加",
    "gui.customProcedures.booleanType": "真偽値",
    "gui.customProcedures.addALabel": "ラベルのテキストを追加",
    "gui.customProcedures.runWithoutScreenRefresh": "画面を再描画せずに実行する",
    "gui.customProcedures.cancel": "キャンセル",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "向き",
    "gui.directionPicker.rotationStyles.allAround": "自由に回転",
    "gui.directionPicker.rotationStyles.leftRight": "左右のみ",
    "gui.directionPicker.rotationStyles.dontRotate": "回転しない",
    "gui.gui.addExtension": "拡張機能を追加",
    "gui.gui.codeTab": "コード",
    "gui.gui.backdropsTab": "背景",
    "gui.gui.costumesTab": "コスチューム",
    "gui.gui.soundsTab": "音",
    "gui.extensionLibrary.comingSoon": "近日公開",
    "gui.extensionLibrary.requires": "必要なもの",
    "gui.extensionLibrary.collaboration": "協力",
    "gui.library.filterPlaceholder": "検索",
    "gui.library.allTag": "すべて",
    "gui.loader.message1": "ブロックを作成中…",
    "gui.loader.message2": "スプライトを読み込み中…",
    "gui.loader.message3": "音を読み込み中…",
    "gui.loader.message4": "拡張機能を読み込み中…",
    "gui.loader.message5": "猫の群れを集めています…",
    "gui.loader.message6": "Nanoを送信中…",
    "gui.loader.message7": "Goboを膨らませています…",
    "gui.loader.message8": "絵文字を準備中…",
    "gui.loader.headline": "プロジェクトを読み込み中…",
    "gui.loader.creating": "プロジェクトを作る",
    "gui.accountMenu.profile": "プロフィール",
    "gui.accountMenu.myStuff": "私の作品",
    "gui.accountMenu.myClasses": "私のクラス",
    "gui.accountMenu.myClass": "自分のクラス",
    "gui.accountMenu.accountSettings": "アカウント設定",
    "gui.accountMenu.signOut": "サインアウト",
    "gui.authorInfo.byUser": "{username}作",
    "gui.menuBar.seeProjectPage": "プロジェクトページを見る",
    "gui.menuBar.language": "言語",
    "general.username": "ユーザー名",
    "general.password": "パスワード",
    "general.signIn": "サインイン",
    "login.needHelp": "ヘルプが必要ですか？",
    "form.validationRequired": "この項目は必須です",
    "gui.menuBar.tutorialsLibrary": "チュートリアル",
    "gui.menuBar.restoreSprite": "削除の取り消し（スプライト）",
    "gui.menuBar.restoreSound": "削除の取り消し（音）",
    "gui.menuBar.restoreCostume": "削除の取り消し（コスチューム）",
    "gui.menuBar.restore": "削除の取り消し",
    "gui.menuBar.saveNow": "直ちに保存",
    "gui.menuBar.saveAsCopy": "コピーを保存",
    "gui.menuBar.remix": "リミックス",
    "gui.menuBar.new": "新規",
    "gui.menuBar.file": "ファイル",
    "gui.menuBar.downloadToComputer": "コンピューターに保存する",
    "gui.menuBar.edit": "編集",
    "gui.menuBar.turboModeOff": "ターボモードを解除する",
    "gui.menuBar.turboModeOn": "ターボモードにする",
    "gui.menuBar.modeMenu": "モード",
    "gui.menuBar.normalMode": "通常モード",
    "gui.menuBar.caturdayMode": "ネコ曜日モード",
    "gui.menuBar.joinScratch": "Scratchに参加しよう",
    "gui.menuBar.signIn": "サインイン",
    "gui.gui.projectTitlePlaceholder": "プロジェクトのタイトルを入力",
    "gui.menuBar.saveNowLink": "直ちに保存",
    "gui.menuBar.settings": "設定",
    "gui.menuBar.isShared": "共有されたもの",
    "gui.menuBar.share": "共有する",
    "gui.menuBar.colorMode": "カラーモード",
    "gui.modal.help": "ヘルプ",
    "gui.modal.back": "戻る",
    "gui.monitor.listMonitor.empty": "(空)",
    "gui.monitor.listMonitor.listLength": "長さ {length}",
    "gui.monitor.contextMenu.default": "普通の表示",
    "gui.monitor.contextMenu.large": "大きな表示",
    "gui.monitor.contextMenu.slider": "スライダー",
    "gui.monitor.contextMenu.sliderRange": "スライダーの指定範囲を変更",
    "gui.monitor.contextMenu.import": "読み込み",
    "gui.monitor.contextMenu.export": "書き出し",
    "gui.monitor.contextMenu.hide": "隠す",
    "gui.playButton.play": "再生",
    "gui.playButton.stop": "止める",
    "gui.gui.variableScopeOptionAllSprites": "すべてのスプライト用",
    "gui.gui.variableScopeOptionSpriteOnly": "このスプライトのみ",
    "gui.gui.cloudVariableOption": "クラウド変数 (サーバーに保存)",
    "gui.gui.variablePromptAllSpritesMessage": "この変数はすべてのスプライトで利用できます。",
    "gui.gui.listPromptAllSpritesMessage": "このリストはすべてのスプライトで利用できます。",
    "gui.prompt.cancel": "キャンセル",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "停止",
    "gui.playbackStep.playMsg": "再生",
    "gui.playbackStep.loadingMsg": "読み込み中...",
    "gui.playbackStep.saveMsg": "保存",
    "gui.playbackStep.reRecordMsg": "再録音",
    "gui.recordModal.title": "録音",
    "gui.recordingStep.beginRecord": "下のボタンを押して録音する",
    "gui.recordingStep.permission": "{arrow}マイクの使用許可が必要です。",
    "gui.recordingStep.stop": "録音をやめる",
    "gui.recordingStep.record": "録音する",
    "gui.sliderModal.min": "最小値",
    "gui.sliderModal.max": "最大値",
    "gui.sliderModal.title": "スライダーの指定範囲を変更",
    "gui.sliderPrompt.cancel": "キャンセル",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "音",
    "gui.soundEditor.play": "再生",
    "gui.soundEditor.stop": "止める",
    "gui.soundEditor.copy": "コピー",
    "gui.soundEditor.paste": "貼り付け",
    "gui.soundEditor.copyToNew": "音をコピー",
    "gui.soundEditor.delete": "削除",
    "gui.soundEditor.save": "保存",
    "gui.soundEditor.undo": "元に戻す",
    "gui.soundEditor.redo": "やり直す",
    "gui.soundEditor.faster": "速く",
    "gui.soundEditor.slower": "遅く",
    "gui.soundEditor.echo": "エコー",
    "gui.soundEditor.robot": "ロボット",
    "gui.soundEditor.louder": "大きく",
    "gui.soundEditor.softer": "小さく",
    "gui.soundEditor.reverse": "逆向き",
    "gui.soundEditor.fadeOut": "フェードアウト",
    "gui.soundEditor.fadeIn": "フェードイン",
    "gui.soundEditor.mute": "ミュート",
    "gui.SpriteInfo.spritePlaceholder": "名前",
    "gui.SpriteInfo.showSpriteAction": "スプライトを表示する",
    "gui.SpriteInfo.hideSpriteAction": "スプライトを隠す",
    "gui.SpriteInfo.sprite": "スプライト",
    "gui.SpriteInfo.show": "表示する",
    "gui.SpriteInfo.size": "大きさ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "複製",
    "gui.spriteSelectorItem.contextMenuExport": "書き出し",
    "gui.spriteSelectorItem.contextMenuDelete": "削除",
    "gui.spriteSelector.addSpriteFromLibrary": "スプライトを選ぶ",
    "gui.spriteSelector.addSpriteFromPaint": "描く",
    "gui.spriteSelector.addSpriteFromSurprise": "サプライズ",
    "gui.spriteSelector.addSpriteFromFile": "スプライトをアップロード",
    "gui.stageHeader.stageSizeLarge": "大きなステージに切り替え",
    "gui.stageHeader.stageSizeSmall": "小さいステージに切り替える",
    "gui.stageHeader.stageSizeFull": "全画面表示にする",
    "gui.stageHeader.stageSizeUnFull": "全画面表示をやめる",
    "gui.stageHeader.fullscreenControl": "全画面表示",
    "gui.spriteSelector.addBackdropFromLibrary": "背景を選ぶ",
    "gui.stageSelector.addBackdropFromPaint": "描く",
    "gui.stageSelector.addBackdropFromSurprise": "サプライズ",
    "gui.stageSelector.addBackdropFromFile": "背景をアップロード",
    "gui.stageSelector.stage": "ステージ",
    "gui.stageSelector.backdrops": "背景",
    "gui.telemetryOptIn.label": "Scratchを改善するため統計情報を送信する",
    "gui.telemetryOptIn.body1": "Scratchチームは、世界中でScratchがどのように使われているかを、いつもよく理解しようとしています。 この作業をサポートするために、Scratchの利用情報をScratchチームに自動的に送信できます。",
    "gui.telemetryOptIn.body2": "集める情報には言語設定、ブロックの使用状況、保存や読み込み、アップロードなどのいくらかの行動が含まれます。私たちは個人情報を収集しません。詳しくは{privacyPolicyLink}をご覧ください。",
    "gui.telemetryOptIn.privacyPolicyLink": "プライバシー・ポリシー",
    "gui.telemetryOptIn.optInText": "Scratchチームと使用状況を共有する",
    "gui.telemetryOptIn.optInTooltip": "統計データの収集を開始する",
    "gui.telemetryOptIn.optOutText": "Scratchチームと使用状況を共有しない",
    "gui.telemetryOptIn.optOutTooltip": "統計データの収集をやめる",
    "gui.telemetryOptIn.settingWasUpdated": "設定が更新されました。",
    "gui.telemetryOptIn.buttonClose": "閉じる",
    "gui.turboMode.active": "ターボモード",
    "gui.webglModal.label": "ブラウザーはWebGLをサポートしていないようです",
    "gui.webglModal.description": "残念ながら、ブラウザーやコンピューターが{webGlLink}ようです。この技術はScratch 3.0の実行に必須です。",
    "gui.webglModal.webgllink": "WebGLをサポートしていない",
    "gui.webglModal.back": "戻る",
    "gui.webglModal.previewfaq": "詳しくは、{previewFaqLink}をご覧下さい。",
    "gui.webglModal.previewfaqlinktext": "よくある質問",
    "gui.costumeLibrary.chooseABackdrop": "背景を選ぶ",
    "gui.costumeLibrary.chooseACostume": "コスチュームを選ぶ",
    "gui.costumeTab.addBackdropFromLibrary": "背景を選ぶ",
    "gui.costumeTab.addCostumeFromLibrary": "コスチュームを選ぶ",
    "gui.costumeTab.addBlankCostume": " 描く",
    "gui.costumeTab.addSurpriseCostume": "サプライズ",
    "gui.costumeTab.addFileBackdrop": "背景をアップロード",
    "gui.costumeTab.addFileCostume": "コスチュームをアップロード",
    "gui.extensionLibrary.chooseAnExtension": "拡張機能を選ぶ",
    "gui.extensionLibrary.extensionUrl": "拡張機能のURLを入力",
    "gui.monitors.importListColumnPrompt": "どの欄を使いますか? (1-{numberOfColumns})",
    "gui.recordingStep.alertMsg": "録音を開始できません",
    "gui.soundLibrary.chooseASound": "音を選ぶ",
    "gui.soundTab.fileUploadSound": "音をアップロードする",
    "gui.soundTab.surpriseSound": "サプライズ",
    "gui.soundTab.recordSound": "録音する",
    "gui.soundTab.addSoundFromLibrary": " 音を選ぶ",
    "gui.spriteLibrary.chooseASprite": "スプライトを選ぶ",
    "gui.tipsLibrary.tutorials": "チュートリアルを選ぶ",
    "gui.alerts.createsuccess": "新しいプロジェクトが作成されました。",
    "gui.alerts.createcopysuccess": "プロジェクトのコピーが保存されました。",
    "gui.alerts.createremixsuccess": "プロジェクトのリミックスが保存されました。",
    "gui.alerts.creating": "プロジェクトを作成中...",
    "gui.alerts.creatingCopy": "プロジェクトをコピー中...",
    "gui.alerts.creatingRemix": "プロジェクトをリミックス中...",
    "gui.alerts.creatingError": "プロジェクトが作成できませんでした。もう一度お願いします。",
    "gui.alerts.savingError": "プロジェクトは保存できませんでした。",
    "gui.alerts.savesuccess": "プロジェクトが保存されました。",
    "gui.alerts.saving": "プロジェクトを保存中...",
    "gui.alerts.cloudInfo": "クラウド変数は数字のみサポートしています。文字や記号は入れられません。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "もっと詳しく。",
    "gui.alerts.importing": "読み込み中...",
    "gui.defaultProject.meow": "ニャー",
    "gui.defaultProject.variable": "変数",
    "gui.howtos.intro-move-sayhello-hat.name": "さあ、始めましょう",
    "gui.howtos.intro-move.step_stepMove": "動きのブロックを追加して、",
    "gui.howtos.add-a-move-block.step_stepSay": "「( )と言う」ブロックを追加する",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "旗をクリックして開始しよう",
    "gui.howtos.intro-getting-started-ASL.name": "Scratchをはじめよう (アメリカ手話)",
    "gui.howtos.animate-a-name.name": "名前を動かしてみよう",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "文字のスプライトを選ぼう",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "クリックすると音が鳴らせるよ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "他の文字のスプライトを選ぼう",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "色を変えてみよう",
    "gui.howtos.animate-a-name.step_AnimateSpin": "他の文字を選んで、回転させよう",
    "gui.howtos.animate-a-name.step_AnimateGrow": "他の文字を選んで、大きくしよう",
    "gui.howtos.imagine": "世界を想像しよう",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "あなたが伝えたいことをタイプして、",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "旗をクリックして開始しよう",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "背景をどれか選んで、",
    "gui.howtos.imagine.step_imagineChooseSprite": "スプライトを選ぼう",
    "gui.howtos.imagine.step_imagineFlyAround": "スペースキーを押して座標を変えてみよう",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "もうひとつスプライトを選んで、",
    "gui.howtos.imagine.step_imagineLeftRight": "左右に動かしたり、",
    "gui.howtos.imagine.step_imagineUpDown": "上下に動かしてみよう",
    "gui.howtos.imagine.step_imagineChangeCostumes": "コスチュームを変えたり、",
    "gui.howtos.imagine.step_imagineGlideToPoint": "指定の位置に滑らかに動かそう",
    "gui.howtos.imagine.step_imagineGrowShrink": "拡大したり、縮小してみよう",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "もうひとつ背景を選んで、",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "背景を切り替えてみよう",
    "gui.howtos.imagine.step_imagineRecordASound": "音を録音して、",
    "gui.howtos.imagine.step_imagineChooseSound": "録音した音を選ぼう",
    "gui.howtos.make-music.name": "音楽を作ろう",
    "gui.howtos.Make-Music.step_PickInstrument": "楽器のスプライトを選んで、",
    "gui.howtos.Make-Music.step_PlaySoundClick": "クリックして音が鳴らしてみよう",
    "gui.howtos.Make-Music.step_MakeSong": "サックスで曲を作ってみよう",
    "gui.howtos.make-music.step_MakeBeat": "ドラムでリズムをとったり、",
    "gui.howtos.make-music.step_MakeBeatBox": "マイクでびっくりビートボックスを作ろう",
    "gui.howtos.story.name": "物語を作ろう",
    "gui.howtos.story.step_addbg": "背景を追加しよう",
    "gui.howtos.story.step_addsprite": "キャラクターを追加して、",
    "gui.howtos.story.step_saysomething": "何かおしゃべりさせよう",
    "gui.howtos.story.step_addanothersprite": "もうひとつキャラクターを追加して、",
    "gui.howtos.story.step_flip": "向きを反転させて、",
    "gui.howtos.story.step_conversation": "おしゃべりさせよう",
    "gui.howtos.story.addanotherbg": "もうひとつ背景を加えて、",
    "gui.howtos.story.step_swithbg": "背景を切り替えてみよう",
    "gui.howtos.story.step_hidewizard": "魔法使いを隠そう",
    "gui.howtos.story.step_showwizard": "最初は魔法使いを表示しておこう",
    "gui.howtos.make-a-chase-game.name": "追跡ゲームを作ろう",
    "gui.howtos.Chase-Game.step_BG": "背景を追加して、",
    "gui.howtos.chase-game.step_AddOcto": "スプライトを追加しよう",
    "gui.howtos.make-music.step_LeftRight": "矢印キーで左右に動かしたり、",
    "gui.howtos.Chase-Game.step_UpDown": "矢印キーで上下に動かそう",
    "gui.howtos.Chase-Game.step_AddStar": "もうひとつスプライトを追加して、",
    "gui.howtos.Chase-Game.step_MoveRandom": "どこかの場所に動かして、",
    "gui.howtos.Chase-Game.step_WhenTouch": "タコが星に触れたら、音を鳴らそう",
    "gui.howtos.Chase-Game.step_ScoreVariable": "スコアの変数を作って、",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "タコが星に触れたら、スコアを加えよう",
    "gui.howtos.animate-char.name": "キャラクターを動かそう",
    "gui.howtos.animate-char.step_addbg": "背景を追加して、",
    "gui.howtos.animate-char.step_addsprite": "スプライトを追加しよう",
    "gui.howtos.animate-char.step_saysomething": "何かおしゃべりさせてみよう",
    "gui.howtos.animate-char.step_addsound": "音を追加して、",
    "gui.howtos.animate-char.step_animatetalking": "おしゃべりするアニメーションにしよう",
    "gui.howtos.animate-char.step_arrowkeys": "矢印キーで動かしたり、",
    "gui.howtos.animate-char.step_jump": "ジャンプさせたり、",
    "gui.howtos.animate-char.step_changecolor": "色を変えたりしてみよう",
    "gui.howtos.make-a-game.name": "クリッカーゲームを作ろう",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "ひとつスプライトを選んで、",
    "gui.howtos.make-a-game.step_GamePlaySound": "クリックで音が鳴るようにします",
    "gui.howtos.make-a-game.step_GameAddScore": "スコアの変数を作って、",
    "gui.howtos.make-a-game.step_GameChangeScore": "クリックしたらスコアを加えるようにしよう",
    "gui.howtos.make-a-game.step_Random": "どこかの場所へ行くようにしたり、",
    "gui.howtos.make-music.step_GameChangeColor": "色を変えたりしよう",
    "gui.howtos.make-music.step_ResetScore": "スコアのリセットを忘れないようにしよう",
    "gui.howtos.make-it-fly.name": "キャラクターを飛ばそう",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "空の背景を選んで、",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "キャラクターを選ぼう",
    "gui.howtos.fly.step_stepflySaySomething": "何かおしゃべりさせたり、",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "矢印キーで動かしてみよう",
    "gui.howtos.fly.step_stepflyChooseObject": "集める物体を選んで、",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "その物体を動かしてみよう",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "キャラクターを選び、",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "スコアの変数を追加して、",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "スコアをつけられるようにしよう",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "雲を追加し、",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "雲を動かして、",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "次のコスチュームにしよう",
    "gui.howtos.pong": "ピンポンゲーム",
    "gui.howtos.pong.step_pongAddBackdrop": "背景を追加して、",
    "gui.howtos.pong.step_pongAddBallSprite": "ボールのスプライトを追加しよう",
    "gui.howtos.pong.step_pongBounceAround": "周りでバウンドさせてみよう",
    "gui.howtos.pong.step_pongAddPaddle": "パドルを加えて、",
    "gui.howtos.pong.step_pongMoveThePaddle": "そのパドルを動かそう",
    "gui.howtos.pong.step_pongSelectBallSprite": "ボールを選んで、",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "ボールがパドルで跳ね返るよう、コードを加えよう",
    "gui.howtos.pong.step_pongAddAScore": "スコアの変数を追加して、",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "メニューから”スコア”を選択しよう",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "”スコアを～ずつ変える”を追加して、",
    "gui.howtos.pong.step_pongResetScore": "忘れずにスコアをリセットしておこう",
    "gui.howtos.pong.step_pongAddLineSprite": "Lineのスプライトを加えて、",
    "gui.howtos.pong.step_pongGameOver": "Lineに触れたらゲームオーバーにしよう",
    "gui.howtos.code-cartoon": "アニメ映画をコーディングしよう",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "旗が押されたときに何かを言わせよう",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "登場人物を押したら動くようにしよう",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "別の登場人物を選ぼう",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "小さくするにはマイナス符号を使うんだ",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "登場人物を大きくしたり、小さくできるよ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "別の登場人物を選んで、",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "上と下にジャンプさせよう",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "登場人物を押して、場面を変えよう",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "あちこちに滑るように動したり、",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "コスチュームを変えてみよう",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "アニメ映画の登場人物をもっと増やそう",
    "gui.howtos.cartoon-network": "アドベンチャーゲーム",
    "gui.howtos.cartoon-network.step_CNcharacter": "キャラクターを選んで表示して、",
    "gui.howtos.cartoon-network.step_CNsay": "何かおしゃべりさせよう",
    "gui.howtos.cartoon-network.step_CNglide": "あたりを滑らかに動くようにします",
    "gui.howtos.cartoon-network.step_CNpicksprite": "追っかけるものを選んで、",
    "gui.howtos.cartoon-network.step_CNcollect": "ものを集めるようにしよう",
    "gui.howtos.cartoon-network.step_CNvariable": "スコアの変数を作って、",
    "gui.howtos.cartoon-network.step_CNscore": "スコアをつけよう",
    "gui.howtos.cartoon-network.step_CNbackdrop": "レベルアップ: 背景を変えよう",
    "gui.howtos.videosens.name": "ビデオモーションセンサー",
    "gui.howtos.videosens.step_addextension": "拡張機能を追加します",
    "gui.howtos.videosens.step_pet": "ネコを撫でるとニャーと鳴くよ",
    "gui.howtos.videosens.step_animate": "触れると動くアニメにしよう",
    "gui.howtos.videosens.step_pop": "つつくと風船がいろんな場所に動くよ",
    "gui.howtos.say-it-out-loud": "おしゃべりするアニメを作ろう",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "音声合成のブロックを追加しよう",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "何かおしゃべりさせよう",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "声の種類を指定できます",
    "gui.howtos.say-it-out-loud.step_TXTMove": "あちこちに動かそう",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "背景を追加して、",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "他のキャラクターを追加しよう",
    "gui.howtos.say-it-out-loud.step_TXTSong": "BGMを流してみたり、",
    "gui.howtos.say-it-out-loud.step_TXTColor": "色を変化させてみよう",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "回転させたり、",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "拡大したり、縮小してみよう",
    "gui.howtos.talking": "おしゃべり",
    "gui.howtos.talking.step_talesAddExtension": "音声合成のブロックを追加しよう ",
    "gui.howtos.talking.step_talesChooseSprite": "スプライトを選んで、",
    "gui.howtos.talking.step_talesSaySomething": "キャラクターにしゃべりさせよう",
    "gui.howtos.talking.step_talesChooseBackdrop": "背景を選んで、",
    "gui.howtos.talking.step_talesSwitchBackdrop": "キャラクターを押して次の背景にしよう",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "もうひとつスプライトを選んで、",
    "gui.howtos.talking.step_talesMoveAround": "あちこちに動かそう",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "もうひとつ背景を選んで、",
    "gui.howtos.talking.step_talesAnimateTalking": "おしゃべりするアニメーションにしよう",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "別の背景を選んで、",
    "gui.howtos.talking.step_talesChooseSound": "ダンスの動きに合わせて、",
    "gui.howtos.talking.step_talesDanceMoves": "曲を選ぼう",
    "gui.howtos.talking.step_talesAskAnswer": "調べるカテゴリの”答え”と”～と聞いて待つ”を使ってみよう",
    "gui.howtos.add-sprite.name": "スプライトの追加方法",
    "gui.howtos.add-sprite.step_addSprite": "スプライトを追加しよう",
    "gui.howtos.add-a-backdrop.name": "背景の追加方法",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "背景を追加しよう",
    "gui.howtos.change-size.name": "大きさの変更方法",
    "gui.howtos.change-size.step_changeSize": "大きさを変更しよう",
    "gui.howtos.glide-around.name": "滑らかに動かす方法",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "滑らかに動そう",
    "gui.howtos.change-size.step_glideAroundPoint": "指定の位置に滑らかに動かそう",
    "gui.howtos.record-a-sound.name": "音の録音方法",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "音タブをクリックして、",
    "gui.howtos.change-size.step_recordASoundClickRecord": "”録音する”をクリックします",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "録音ボタンを押してみよう",
    "gui.howtos.change-size.step_recordASoundChooseSound": "録音した音を選択しよう",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "録音した音を再生してみよう",
    "gui.howtos.spin-video.name": "文字を回転させる方法",
    "gui.howtos.change-size.step_spinTurn": "回転させよう",
    "gui.howtos.change-size.step_spinPointInDirection": "向きを指定しよう",
    "gui.howtos.hide-and-show.name": "隠したり表示する方法",
    "gui.howtos.change-size.step_hideAndShow": "隠して、表示しよう",
    "gui.howtos.switch-costume.name": "スプライトに動きをつける方法",
    "gui.howtos.change-size.step_switchCostumes": "スプライトに動きをつけよう",
    "gui.howtos.move-around-with-arrow-keys.name": "矢印キーを使う方法",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "左右に動かそう",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "上下に動かそう",
    "gui.howtos.add-effects.name": "効果の追加方法",
    "gui.howtos.videosens.step_addEffects": "効果を追加しよう",
    "gui.extension.music.name": "音楽",
    "gui.extension.music.description": "楽器やドラムを演奏する。",
    "gui.extension.pen.name": "ペン",
    "gui.extension.pen.description": "スプライトで絵を描く。",
    "gui.extension.videosensing.name": "ビデオモーションセンサー",
    "gui.extension.videosensing.description": "カメラで動きを検知する。",
    "gui.extension.text2speech.name": "音声合成",
    "gui.extension.text2speech.description": "言葉をしゃべるプロジェクトを作ろう。",
    "gui.extension.translate.name": "翻訳",
    "gui.extension.translate.description": "色々な言語にテキストを翻訳する。",
    "gui.extension.makeymakey.description": "なんでもキーボードにしてみる。",
    "gui.extension.microbit.description": "プロジェクトを現実の世界と接続する。",
    "gui.extension.microbit.connectingMessage": "接続中",
    "gui.extension.ev3.description": "対話型ロボットなどを作る。",
    "gui.extension.ev3.connectingMessage": "接続中です。EV3のPINが1234に設定されていることを確認してください。",
    "gui.extension.boost.description": "ロボット作品に命を吹き込もう。",
    "gui.extension.boost.connectingMessage": "接続中",
    "gui.extension.wedo2.description": "モーターとセンサーを使って作る。",
    "gui.extension.wedo2.connectingMessage": "接続中",
    "gui.extension.gdxfor.description": "押す力、引く力、動き、回転を検出する。",
    "gui.extension.gdxfor.connectingMessage": "接続中",
    "gui.libraryTags.all": "すべて",
    "gui.libraryTags.animals": "動物",
    "gui.libraryTags.dance": "ダンス",
    "gui.libraryTags.effects": "効果",
    "gui.libraryTags.fantasy": "ファンタジー",
    "gui.libraryTags.fashion": "ファッション",
    "gui.libraryTags.food": "食べ物",
    "gui.libraryTags.indoors": "屋内",
    "gui.libraryTags.loops": "ループ",
    "gui.libraryTags.music": "音楽",
    "gui.libraryTags.notes": "音符",
    "gui.libraryTags.outdoors": "屋外",
    "gui.libraryTags.patterns": "模様",
    "gui.libraryTags.people": "人",
    "gui.libraryTags.percussion": "打楽器",
    "gui.libraryTags.space": "宇宙",
    "gui.libraryTags.sports": "スポーツ",
    "gui.libraryTags.underwater": "海中",
    "gui.libraryTags.voice": "声",
    "gui.libraryTags.wacky": "奇妙な音",
    "gui.libraryTags.animation": "アニメーション",
    "gui.libraryTags.art": "アート",
    "gui.libraryTags.games": "ゲーム",
    "gui.libraryTags.stories": "物語",
    "gui.libraryTags.letters": "文字",
    "gui.opcodeLabels.direction": "向き",
    "gui.opcodeLabels.xposition": "x座標",
    "gui.opcodeLabels.yposition": "y座標",
    "gui.opcodeLabels.size": "大きさ",
    "gui.opcodeLabels.costumename": "コスチューム名",
    "gui.opcodeLabels.costumenumber": "コスチュームの番号",
    "gui.opcodeLabels.backdropname": "背景の名前",
    "gui.opcodeLabels.backdropnumber": "背景の番号",
    "gui.opcodeLabels.volume": "音量",
    "gui.opcodeLabels.tempo": "テンポ",
    "gui.opcodeLabels.answer": "答え",
    "gui.opcodeLabels.loudness": "音量",
    "gui.opcodeLabels.username": "ユーザー名",
    "gui.opcodeLabels.year": "年",
    "gui.opcodeLabels.month": "月",
    "gui.opcodeLabels.date": "日",
    "gui.opcodeLabels.dayofweek": "曜日",
    "gui.opcodeLabels.hour": "時",
    "gui.opcodeLabels.minute": "分",
    "gui.opcodeLabels.second": "秒",
    "gui.opcodeLabels.timer": "タイマー",
    "gui.projectLoader.loadError": "選択されたプロジェクトファイルの読み込みに失敗しました。",
    "gui.sharedMessages.backdrop": "背景{index}",
    "gui.sharedMessages.costume": "コスチューム{index}",
    "gui.sharedMessages.sprite": "スプライト{index}",
    "gui.sharedMessages.pop": "ポップ",
    "gui.sharedMessages.replaceProjectWarning": "現在のプロジェクトの内容を置き換えますか？",
    "gui.sharedMessages.loadFromComputerTitle": "コンピューターから読み込む",
    "gui.theme.default": "オリジナル",
    "gui.theme.dark": "ダーク",
    "gui.theme.highContrast": "ハイコントラスト",
    "gui.gui.defaultProjectTitle": "Scratchのプロジェクト",
    "boost.color.any": "どれかの色",
    "boost.color.black": "黒",
    "boost.color.blue": "青",
    "boost.color.green": "緑",
    "boost.color.red": "赤",
    "boost.color.white": "白",
    "boost.color.yellow": "黄色",
    "boost.getMotorPosition": "モーター[MOTOR_REPORTER_ID]の位置 ",
    "boost.getTiltAngle": "[TILT_DIRECTION]方向の傾き",
    "boost.motorDirection.backward": "あちら向き",
    "boost.motorDirection.forward": "こちら向き",
    "boost.motorDirection.reverse": "逆向き",
    "boost.motorOff": "モーター[MOTOR_ID]をオフにする",
    "boost.motorOn": "モーター[MOTOR_ID]をオンにする",
    "boost.motorOnFor": "モーター[MOTOR_ID]を[DURATION]秒間オンにする",
    "boost.motorOnForRotation": "モーター[MOTOR_ID]を[ROTATION]回転させる",
    "boost.seeingColor": "[COLOR] を見ている？",
    "boost.setLightHue": "ライトの色を[HUE]にする",
    "boost.setMotorDirection": "モーター[MOTOR_ID]の向きを[MOTOR_DIRECTION]にする",
    "boost.setMotorPower": "モーター[MOTOR_ID]の速さを[POWER]%にする ",
    "boost.tiltDirection.any": "どれかの向き",
    "boost.tiltDirection.down": "下",
    "boost.tiltDirection.left": "左",
    "boost.tiltDirection.right": "右",
    "boost.tiltDirection.up": "上",
    "boost.whenColor": "[COLOR] を見たとき",
    "boost.whenTilted": "[TILT_DIRECTION_ANY]に傾いたとき",
    "ev3.beepNote": "[NOTE]の音符を[TIME]秒鳴らす",
    "ev3.buttonPressed": "ボタン[PORT]が押された",
    "ev3.getBrightness": "明るさ",
    "ev3.getDistance": "距離",
    "ev3.getMotorPosition": "モーター[PORT]の位置",
    "ev3.motorSetPower": "モーター[PORT]のパワーを[POWER]%にする",
    "ev3.motorTurnClockwise": "モーター[PORT]をこちら向きに[TIME]秒間回す",
    "ev3.motorTurnCounterClockwise": "モーター[PORT]をあちら向きに[TIME]秒間回す",
    "ev3.whenBrightnessLessThan": "明るさ < [DISTANCE]のとき",
    "ev3.whenButtonPressed": "ボタン[PORT]が押されたとき",
    "ev3.whenDistanceLessThan": "距離 < [DISTANCE]のとき",
    "gdxfor.getAcceleration": "[DIRECTION]方向への加速度",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "[DIRECTION]回転のはやさ",
    "gdxfor.getTilt": "[TILT]方向の傾き",
    "gdxfor.isFreeFalling": "落下中",
    "gdxfor.isTilted": "[TILT]に傾いた",
    "gdxfor.pulled": "引かれた",
    "gdxfor.pushed": "押された",
    "gdxfor.shaken": "振られた",
    "gdxfor.startedFalling": "落下を始めた",
    "gdxfor.tiltDirectionMenu.any": "どれかの向き",
    "gdxfor.tiltDirectionMenu.back": "後ろ",
    "gdxfor.tiltDirectionMenu.front": "前",
    "gdxfor.tiltDirectionMenu.left": "左",
    "gdxfor.tiltDirectionMenu.right": "右",
    "gdxfor.turnedFaceDown": "表面が下",
    "gdxfor.turnedFaceUp": "表面が上",
    "gdxfor.whenForcePushedOrPulled": "force sensorが[PUSH_PULL]とき",
    "gdxfor.whenGesture": "[GESTURE]とき",
    "gdxfor.whenTilted": "[TILT]に傾いたとき",
    "makeymakey.downArrow": "下向き矢印",
    "makeymakey.downArrowShort": "下",
    "makeymakey.leftArrow": "左向き矢印",
    "makeymakey.leftArrowShort": "左",
    "makeymakey.rightArrow": "右向き矢印",
    "makeymakey.rightArrowShort": "右",
    "makeymakey.spaceKey": "スペース",
    "makeymakey.upArrow": "上向き矢印",
    "makeymakey.upArrowShort": "上",
    "makeymakey.whenKeyPressed": "[KEY]キーが押されたとき",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE]が順番に押されたとき",
    "microbit.buttonsMenu.any": "どれかの",
    "microbit.clearDisplay": "画面を消す",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "[MATRIX]を表示する",
    "microbit.displayText": "[TEXT]を表示する",
    "microbit.gesturesMenu.jumped": "ジャンプした",
    "microbit.gesturesMenu.moved": "動いた",
    "microbit.gesturesMenu.shaken": "振られた",
    "microbit.isButtonPressed": "ボタン[BTN]が押された",
    "microbit.isTilted": "[DIRECTION]に傾いた",
    "microbit.pinStateMenu.off": "切",
    "microbit.pinStateMenu.on": "入",
    "microbit.tiltAngle": "[DIRECTION]方向の傾き",
    "microbit.tiltDirectionMenu.any": "どれかの向き",
    "microbit.tiltDirectionMenu.back": "後ろ",
    "microbit.tiltDirectionMenu.front": "前",
    "microbit.tiltDirectionMenu.left": "左",
    "microbit.tiltDirectionMenu.right": "右",
    "microbit.whenButtonPressed": "ボタン[BTN]が押されたとき",
    "microbit.whenGesture": "[GESTURE]とき",
    "microbit.whenPinConnected": "ピン[PIN]がつながったとき",
    "microbit.whenTilted": "[DIRECTION]に傾いたとき",
    "music.categoryName": "音楽",
    "music.changeTempo": "テンポを[TEMPO]ずつ変える",
    "music.drumBass": "(2) バスドラム",
    "music.drumBongo": "(13) ボンゴ",
    "music.drumCabasa": "(15) カバサ",
    "music.drumClaves": "(9) クラーベ",
    "music.drumClosedHiHat": "(6) クローズハイハット",
    "music.drumConga": "(14) コンガ",
    "music.drumCowbell": "(11) カウベル",
    "music.drumCrashCymbal": "(4) クラッシュシンバル",
    "music.drumCuica": "(18) クイーカ",
    "music.drumGuiro": "(16) ギロ",
    "music.drumHandClap": "(8) 手拍子",
    "music.drumOpenHiHat": "(5) オープンハイハット",
    "music.drumSideStick": "(3) サイドスティック",
    "music.drumSnare": "(1) スネアドラム",
    "music.drumTambourine": "(7) タンバリン",
    "music.drumTriangle": "(12) トライアングル",
    "music.drumVibraslap": "(17) ビブラスラップ",
    "music.drumWoodBlock": "(10) ウッドブロック",
    "music.getTempo": "テンポ",
    "music.instrumentBass": "(6) ベース",
    "music.instrumentBassoon": "(14) バスーン",
    "music.instrumentCello": "(8) チェロ",
    "music.instrumentChoir": "(15) 合唱団",
    "music.instrumentClarinet": "(10) クラリネット",
    "music.instrumentElectricGuitar": "(5) エレキギター",
    "music.instrumentElectricPiano": "(2) 電子ピアノ",
    "music.instrumentFlute": "(12) フルート",
    "music.instrumentGuitar": "(4) ギター",
    "music.instrumentMarimba": "(19) マリンバ",
    "music.instrumentMusicBox": "(17) ミュージックボックス",
    "music.instrumentOrgan": "(3) オルガン",
    "music.instrumentPiano": "(1) ピアノ",
    "music.instrumentPizzicato": "(7) ピチカート",
    "music.instrumentSaxophone": "(11) サクソフォン",
    "music.instrumentSteelDrum": "(18) スチールドラム",
    "music.instrumentSynthLead": "(20) シンセリード",
    "music.instrumentSynthPad": "(21) シンセパッド",
    "music.instrumentTrombone": "(9) トロンボーン",
    "music.instrumentVibraphone": "(16) ビブラフォン",
    "music.instrumentWoodenFlute": "(13) 木管フルート",
    "music.midiPlayDrumForBeats": "[DRUM]のドラムを[BEATS]拍鳴らす",
    "music.midiSetInstrument": "楽器を[INSTRUMENT]にする",
    "music.playDrumForBeats": "[DRUM]のドラムを[BEATS]拍鳴らす",
    "music.playNoteForBeats": "[NOTE]の音符を[BEATS]拍鳴らす",
    "music.restForBeats": "[BEATS]拍休む",
    "music.setInstrument": "楽器を[INSTRUMENT]にする",
    "music.setTempo": "テンポを[TEMPO]にする",
    "pen.categoryName": "ペン",
    "pen.changeColorParam": "ペンの[COLOR_PARAM]を[VALUE]ずつ変える",
    "pen.changeHue": "ペンの色を[HUE]ずつ変える",
    "pen.changeShade": "ペンの濃さを[SHADE]ずつ変える",
    "pen.changeSize": "ペンの太さを[SIZE]ずつ変える",
    "pen.clear": "全部消す",
    "pen.colorMenu.brightness": "明るさ",
    "pen.colorMenu.color": "色",
    "pen.colorMenu.saturation": "鮮やかさ",
    "pen.colorMenu.transparency": "透明度",
    "pen.penDown": "ペンを下ろす",
    "pen.penUp": "ペンを上げる",
    "pen.setColor": "ペンの色を[COLOR]にする",
    "pen.setColorParam": "ペンの[COLOR_PARAM]を[VALUE]にする",
    "pen.setHue": "ペンの色を[HUE]にする",
    "pen.setShade": "ペンの濃さを[SHADE]にする",
    "pen.setSize": "ペンの太さを[SIZE]にする",
    "pen.stamp": "スタンプ",
    "speech.defaultWhenIHearValue": "行こう",
    "speech.extensionName": "音声認識",
    "speech.listenAndWait": "聞いて",
    "speech.speechReporter": "音声",
    "speech.whenIHear": "[PHRASE]を聞いたとき",
    "text2speech.alto": "アルト",
    "text2speech.categoryName": "音声合成",
    "text2speech.defaultTextToSpeak": "こんにちは",
    "text2speech.giant": "巨人",
    "text2speech.kitten": "子猫",
    "text2speech.setLanguageBlock": "言語を[LANGUAGE]にする",
    "text2speech.setVoiceBlock": "声を[VOICE]にする",
    "text2speech.speakAndWaitBlock": "[WORDS]としゃべる",
    "text2speech.squeak": "ねずみ",
    "text2speech.tenor": "テノール",
    "translate.categoryName": "翻訳",
    "translate.defaultTextToTranslate": "こんにちは",
    "translate.translateBlock": "[WORDS]を[LANGUAGE]に翻訳する",
    "translate.viewerLanguage": "言語",
    "videoSensing.categoryName": "ビデオモーションセンサー",
    "videoSensing.direction": "向き",
    "videoSensing.motion": "モーション",
    "videoSensing.off": "切",
    "videoSensing.on": "入",
    "videoSensing.onFlipped": "左右反転",
    "videoSensing.setVideoTransparency": "ビデオの透明度を[TRANSPARENCY]にする",
    "videoSensing.sprite": "スプライト",
    "videoSensing.stage": "ステージ",
    "videoSensing.videoOn": "[SUBJECT]のビデオの[ATTRIBUTE]",
    "videoSensing.videoToggle": "ビデオを[VIDEO_STATE]にする",
    "videoSensing.whenMotionGreaterThan": "ビデオモーション > [REFERENCE]のとき",
    "wedo2.getDistance": "距離",
    "wedo2.getTiltAngle": "[TILT_DIRECTION]方向の傾き",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY]に傾いた",
    "wedo2.motorDirection.backward": "あちら向き",
    "wedo2.motorDirection.forward": "こちら向き",
    "wedo2.motorDirection.reverse": "逆向き",
    "wedo2.motorId.a": "モーターA",
    "wedo2.motorId.all": "すべてのモーター",
    "wedo2.motorId.b": "モーターB",
    "wedo2.motorId.default": "モーター",
    "wedo2.motorOff": "[MOTOR_ID]をオフにする",
    "wedo2.motorOn": "[MOTOR_ID]をオンにする",
    "wedo2.motorOnFor": "[MOTOR_ID]を[DURATION]秒間オンにする",
    "wedo2.playNoteFor": "[NOTE]の音符を[DURATION]秒間鳴らす",
    "wedo2.setLightHue": "ライトの色を[HUE]にする",
    "wedo2.setMotorDirection": "[MOTOR_ID]の方向を[MOTOR_DIRECTION]にする",
    "wedo2.startMotorPower": "[MOTOR_ID]のパワーを[POWER]にする",
    "wedo2.tiltDirection.any": "どれかの向き",
    "wedo2.tiltDirection.down": "下",
    "wedo2.tiltDirection.left": "左",
    "wedo2.tiltDirection.right": "右",
    "wedo2.tiltDirection.up": "上",
    "wedo2.whenDistance": "距離[OP][REFERENCE]のとき",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY]に傾いたとき",
    "paint.paintEditor.hue": "色",
    "paint.paintEditor.saturation": "鮮やかさ",
    "paint.paintEditor.brightness": "明るさ",
    "paint.paintEditor.costume": "コスチューム",
    "paint.paintEditor.group": "グループ化",
    "paint.paintEditor.ungroup": "グループ解除",
    "paint.paintEditor.undo": "取り消し",
    "paint.paintEditor.redo": "やり直し",
    "paint.paintEditor.forward": "手前に出す",
    "paint.paintEditor.backward": "奥に下げる",
    "paint.paintEditor.front": "最前面",
    "paint.paintEditor.back": "最背面",
    "paint.paintEditor.more": "もっと",
    "paint.modeTools.brushSize": "大きさ",
    "paint.modeTools.eraserSize": "消しゴムの大きさ",
    "paint.modeTools.copy": "コピー",
    "paint.modeTools.paste": "貼り付け",
    "paint.modeTools.delete": "削除",
    "paint.modeTools.curved": "滑らか",
    "paint.modeTools.pointed": "角ばった",
    "paint.modeTools.thickness": "太さ",
    "paint.modeTools.flipHorizontal": "左右反転",
    "paint.modeTools.flipVertical": "上下反転",
    "paint.modeTools.filled": "塗りつぶし",
    "paint.modeTools.outlined": "輪郭",
    "paint.paintEditor.bitmap": "ビットマップに変換",
    "paint.paintEditor.vector": "ベクターに変換",
    "paint.paintEditor.fill": "塗りつぶし",
    "paint.paintEditor.stroke": "枠線",
    "paint.brushMode.brush": "筆",
    "paint.eraserMode.eraser": "消しゴム",
    "paint.fillMode.fill": "塗りつぶし",
    "paint.lineMode.line": "直線",
    "paint.ovalMode.oval": "円",
    "paint.rectMode.rect": "四角形",
    "paint.reshapeMode.reshape": "形を変える",
    "paint.roundedRectMode.roundedRect": "角丸の長方形",
    "paint.selectMode.select": "選択",
    "paint.textMode.text": "テキスト",
    "paint.colorPicker.swap": "入れ替え"
  },
  "ja-Hira": {
    "gui.alerts.lostPeripheralConnection": " {extensionName}へのせつぞくがうしなわれました。",
    "gui.alerts.tryAgain": "もういちどためす ",
    "gui.alerts.download": "ダウンロード",
    "gui.connection.reconnect": "さいせつぞく",
    "gui.backpack.costumeLabel": "コスチューム",
    "gui.backpack.soundLabel": "おと",
    "gui.backpack.scriptLabel": "スクリプト",
    "gui.backpack.spriteLabel": "スプライト",
    "gui.backpack.header": "バックパック",
    "gui.backpack.errorBackpack": "バックパックのよみこみじにエラーがはっせいしました",
    "gui.backpack.loadingBackpack": "よみこみちゅう...",
    "gui.backpack.more": "もっと",
    "gui.backpack.emptyBackpack": "バックパックはからです",
    "gui.unsupportedBrowser.label": " ブラウザーはサポートされていません",
    "gui.unsupportedBrowser.errorLabel": "エラーがはっせいしました",
    "gui.unsupportedBrowser.notRecommended": "もうしわけありません。Scratchがサポートしていないバージョンのブラウザーをつかっているようです。Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safariのようなサポートされているブラウザーのさいしんばんをつかってください。",
    "gui.unsupportedBrowser.description": "もうしわけありません。Scratchはこのブラウザーをサポートしていません。Google Chrome, Mozilla Firefox, Microsoft Edge, Apple Safariのようなサポートされているブラウザーのさいしんばんをつかってください。",
    "gui.unsupportedBrowser.back": "もどる",
    "gui.unsupportedBrowser.previewfaq": "くわしくは、{previewFaqLink}をごらんください。",
    "gui.unsupportedBrowser.previewfaqlinktext": "よくあるしつもん",
    "gui.cards.all-tutorials": "チュートリアル",
    "gui.cards.shrink": "しゅくしょう",
    "gui.cards.expand": "かくだい",
    "gui.cards.close": "とじる",
    "gui.cards.more-things-to-try": "もっとやってみる!",
    "gui.cards.see-more": "もっとみる",
    "gui.comingSoon.message1": "ごあんしんください。かいはつちゅうです {emoji}",
    "gui.comingSoon.message2": "きんじつこうかい",
    "gui.comingSoon.message3": "かいはつちゅうです {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "デバイスがみつかりませんでした",
    "gui.connection.auto-scanning.prescan": "デバイスをちかくにおいて、けんさくをかいしする",
    "gui.connection.auto-scanning.pressbutton": "デバイスのボタンをおす",
    "gui.connection.auto-scanning.start-search": "けんさくをかいし",
    "gui.connection.connecting-searchbutton": "けんさくちゅう...",
    "gui.connection.auto-scanning.try-again": "もういちどくりかえす",
    "gui.connection.auto-scanning.updatePeripheralButton": "デバイスをアップデートする",
    "gui.connection.connected": "せつぞくされました",
    "gui.connection.disconnect": "せつだんする",
    "gui.connection.go-to-editor": "エディターへいく",
    "gui.connection.connecting-cancelbutton": "せつぞくちゅうです...",
    "gui.connection.error.errorMessage": "うわっ! なにか、もんだいがおきたようです。",
    "gui.connection.error.tryagainbutton": "もういちどくりかえす",
    "gui.connection.error.helpbutton": "ヘルプ",
    "gui.connection.peripheral-name-label": "デバイスめい",
    "gui.connection.connect": "せつぞくする",
    "gui.connection.scanning.lookingforperipherals": "デバイスをさがしています",
    "gui.connection.scanning.noPeripheralsFound": "デバイスがみつかりませんでした",
    "gui.connection.scanning.instructions": "うえのリストからデバイスをえらんでください。",
    "gui.connection.search": "こうしん",
    "gui.connection.scanning.updatePeripheralButton": "デバイスをアップデートする",
    "gui.connection.unavailable.installscratchlink": "Scratchリンクがインストールされ、うごいていることをかくにんしてください",
    "gui.connection.unavailable.enablebluetooth": "Bluetoothがゆうこうになっていることを、かくにんしてください",
    "gui.connection.unavailable.tryagainbutton": "もういちどくりかえす",
    "gui.connection.unavailable.helpbutton": "ヘルプ",
    "gui.connection.updatePeripheral.microBitConnect": " {extensionName}をUSBケーブルでせつぞくしてください",
    "gui.connection.updatePeripheral.pressUpdate": "「こうしんする」をおして、こうしんをかんりょうします。",
    "gui.connection.updatePeripheral.progress": "{progressPercentage}% こうしんちゅう",
    "gui.connection.updatePeripheral.updateSuccessful": "アップデートがせいこうしました！",
    "gui.connection.updatePeripheral.updateFailed": "アップデートがしっぱいしました。",
    "gui.connection.updatePeripheral.goBackButton": "もどる",
    "gui.connection.updatePeripheral.updateNowButton": "こうしんする",
    "gui.connection.updatePeripheral.updateAgainButton": "もういちどためす ",
    "gui.controls.go": "じっこう",
    "gui.controls.stop": "とめる",
    "gui.crashMessage.label": "うわっ! なにかもんだいがはっせいしました。",
    "gui.crashMessage.description": "もうしわけありません。Scratchがクラッシュしたようです。このもんだいはScratchチームにじどうてきにそうしんされました。ページをさいよみこみしてください。",
    "gui.crashMessage.errorNumber": "エラーはID {errorId}としてきろくされました。",
    "gui.crashMessage.reload": "さいよみこみ",
    "gui.customProcedures.myblockModalTitle": "ブロックをつくる",
    "gui.customProcedures.addAnInputNumberText": "ひきすうをついか",
    "gui.customProcedures.numberTextType": "すうちまたはテキスト",
    "gui.customProcedures.addAnInputBoolean": "ひきすうをついか",
    "gui.customProcedures.booleanType": "しんぎち",
    "gui.customProcedures.addALabel": "ラベルのテキストをついか",
    "gui.customProcedures.runWithoutScreenRefresh": "がめんをさいびょうがせずにじっこうする",
    "gui.customProcedures.cancel": "キャンセル",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "むき",
    "gui.directionPicker.rotationStyles.allAround": "じゆうにかいてん",
    "gui.directionPicker.rotationStyles.leftRight": "さゆうのみ",
    "gui.directionPicker.rotationStyles.dontRotate": "かいてんしない",
    "gui.gui.addExtension": "かくちょうきのうをついか",
    "gui.gui.codeTab": "コード",
    "gui.gui.backdropsTab": "はいけい",
    "gui.gui.costumesTab": "コスチューム",
    "gui.gui.soundsTab": "おと",
    "gui.extensionLibrary.comingSoon": "きんじつこうかい",
    "gui.extensionLibrary.requires": "ひつようなもの",
    "gui.extensionLibrary.collaboration": "きょうりょく",
    "gui.library.filterPlaceholder": "けんさく",
    "gui.library.allTag": "すべて",
    "gui.loader.message1": "ブロックをさくせいちゅう…",
    "gui.loader.message2": "スプライトをよみこみちゅう…",
    "gui.loader.message3": "おとをよみこみちゅう…",
    "gui.loader.message4": "かくちょうきのうをよみこみちゅう…",
    "gui.loader.message5": "ねこのむれをあつめています…",
    "gui.loader.message6": "Nanoをそうしんちゅう…",
    "gui.loader.message7": "Goboをふくらませています…",
    "gui.loader.message8": "えもじをじゅんびちゅう…",
    "gui.loader.headline": "プロジェクトをよみこみちゅう…",
    "gui.loader.creating": "プロジェクトをつくる",
    "gui.accountMenu.profile": "プロフィール",
    "gui.accountMenu.myStuff": "わたしのさくひん",
    "gui.accountMenu.myClasses": "わたしのクラス",
    "gui.accountMenu.myClass": "わたしのクラス",
    "gui.accountMenu.accountSettings": "アカウントせってい",
    "gui.accountMenu.signOut": "サインアウト",
    "gui.authorInfo.byUser": "{username}さく",
    "gui.menuBar.seeProjectPage": "プロジェクトページをみる",
    "gui.menuBar.language": "げんご",
    "general.username": "ユーザーめい",
    "general.password": "パスワード",
    "general.signIn": "サインイン",
    "login.needHelp": "ヘルプがひつようですか？",
    "form.validationRequired": "このこうもくはひっすです",
    "gui.menuBar.tutorialsLibrary": "チュートリアル",
    "gui.menuBar.restoreSprite": "さくじょのとりけし（スプライト）",
    "gui.menuBar.restoreSound": "さくじょのとりけし（おと）",
    "gui.menuBar.restoreCostume": "さくじょのとりけし（コスチューム）",
    "gui.menuBar.restore": "さくじょのとりけし",
    "gui.menuBar.saveNow": "ただちにほぞん",
    "gui.menuBar.saveAsCopy": "コピーをほぞん",
    "gui.menuBar.remix": "リミックス",
    "gui.menuBar.new": "しんき",
    "gui.menuBar.file": "ファイル",
    "gui.menuBar.downloadToComputer": "コンピューターにほぞんする",
    "gui.menuBar.edit": "へんしゅう",
    "gui.menuBar.turboModeOff": "ターボモードをかいじょする",
    "gui.menuBar.turboModeOn": "ターボモードにする",
    "gui.menuBar.modeMenu": "モード",
    "gui.menuBar.normalMode": "ノーマルモード",
    "gui.menuBar.caturdayMode": "ネコようびモード",
    "gui.menuBar.joinScratch": "Scratchにさんかしよう",
    "gui.menuBar.signIn": "サインイン",
    "gui.gui.projectTitlePlaceholder": "プロジェクトのタイトルをにゅうりょく",
    "gui.menuBar.saveNowLink": "ただちにほぞん",
    "gui.menuBar.settings": "せってい",
    "gui.menuBar.isShared": "きょうゆうされたもの",
    "gui.menuBar.share": "きょうゆうする",
    "gui.menuBar.colorMode": "カラーモード",
    "gui.modal.help": "ヘルプ",
    "gui.modal.back": "もどる",
    "gui.monitor.listMonitor.empty": "(から)",
    "gui.monitor.listMonitor.listLength": "ながさ{length}",
    "gui.monitor.contextMenu.default": "ふつうのひょうじ",
    "gui.monitor.contextMenu.large": "おおきなひょうじ",
    "gui.monitor.contextMenu.slider": "スライダー",
    "gui.monitor.contextMenu.sliderRange": "スライダーのしていはんいをへんこう",
    "gui.monitor.contextMenu.import": "よみこみ",
    "gui.monitor.contextMenu.export": "かきだし",
    "gui.monitor.contextMenu.hide": "かくす",
    "gui.playButton.play": "さいせい",
    "gui.playButton.stop": "とめる",
    "gui.gui.variableScopeOptionAllSprites": "すべてのスプライトよう",
    "gui.gui.variableScopeOptionSpriteOnly": "このスプライトのみ",
    "gui.gui.cloudVariableOption": "クラウドへんすう (サーバーにほぞんされます)",
    "gui.gui.variablePromptAllSpritesMessage": "このへんすうは、すべてのスプライトでつかえます。",
    "gui.gui.listPromptAllSpritesMessage": "このリストはすべてのスプライトでりようできます。",
    "gui.prompt.cancel": "キャンセル",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "ていし",
    "gui.playbackStep.playMsg": "さいせい",
    "gui.playbackStep.loadingMsg": "よみこみちゅう...",
    "gui.playbackStep.saveMsg": "ほぞん",
    "gui.playbackStep.reRecordMsg": "さいろくおん",
    "gui.recordModal.title": "ろくおん",
    "gui.recordingStep.beginRecord": "したのボタンをおしてろくおんする",
    "gui.recordingStep.permission": "{arrow}マイクのしようきょかがひつようです。",
    "gui.recordingStep.stop": "ろくおんをやめる",
    "gui.recordingStep.record": "ろくおんする",
    "gui.sliderModal.min": "さいしょうち",
    "gui.sliderModal.max": "さいだいち",
    "gui.sliderModal.title": "スライダーのしていはんいをへんこう",
    "gui.sliderPrompt.cancel": "キャンセル",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "おと",
    "gui.soundEditor.play": "さいせい",
    "gui.soundEditor.stop": "とめる",
    "gui.soundEditor.copy": "コピー",
    "gui.soundEditor.paste": "はりつけ",
    "gui.soundEditor.copyToNew": "おとをコピー",
    "gui.soundEditor.delete": "さくじょ",
    "gui.soundEditor.save": "ほぞん",
    "gui.soundEditor.undo": "もとにもどす",
    "gui.soundEditor.redo": "やりなおす",
    "gui.soundEditor.faster": "はやく",
    "gui.soundEditor.slower": "おそく",
    "gui.soundEditor.echo": "エコー",
    "gui.soundEditor.robot": "ロボット",
    "gui.soundEditor.louder": "おおきく",
    "gui.soundEditor.softer": "ちいさく",
    "gui.soundEditor.reverse": "ぎゃくむき",
    "gui.soundEditor.fadeOut": "フェードアウト",
    "gui.soundEditor.fadeIn": "フェードイン",
    "gui.soundEditor.mute": "ミュート",
    "gui.SpriteInfo.spritePlaceholder": "なまえ",
    "gui.SpriteInfo.showSpriteAction": "スプライトをひょうじする",
    "gui.SpriteInfo.hideSpriteAction": "スプライトをかくす",
    "gui.SpriteInfo.sprite": "スプライト",
    "gui.SpriteInfo.show": "ひょうじする",
    "gui.SpriteInfo.size": "おおきさ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "ふくせい",
    "gui.spriteSelectorItem.contextMenuExport": "かきだし",
    "gui.spriteSelectorItem.contextMenuDelete": "さくじょ",
    "gui.spriteSelector.addSpriteFromLibrary": "スプライトをえらぶ",
    "gui.spriteSelector.addSpriteFromPaint": "えがく",
    "gui.spriteSelector.addSpriteFromSurprise": "サプライズ",
    "gui.spriteSelector.addSpriteFromFile": "スプライトをアップロード",
    "gui.stageHeader.stageSizeLarge": "おおきなステージにきりかえ",
    "gui.stageHeader.stageSizeSmall": "ちいさいステージにきりかえる",
    "gui.stageHeader.stageSizeFull": "ぜんがめんひょうじにする",
    "gui.stageHeader.stageSizeUnFull": "ぜんがめんひょうじをやめる",
    "gui.stageHeader.fullscreenControl": "ぜんがめんひょうじ",
    "gui.spriteSelector.addBackdropFromLibrary": "はいけいをえらぶ",
    "gui.stageSelector.addBackdropFromPaint": "えがく",
    "gui.stageSelector.addBackdropFromSurprise": "サプライズ",
    "gui.stageSelector.addBackdropFromFile": "はいけいをアップロード",
    "gui.stageSelector.stage": "ステージ",
    "gui.stageSelector.backdrops": "はいけい",
    "gui.telemetryOptIn.label": "Scratchをかいぜんするためとうけいじょうほうをそうしんする",
    "gui.telemetryOptIn.body1": "Scratchチームは、せかいじゅうでScratchがどのようにつわれているかを、いつもよくりかいしようとしています。 このさぎょうをサポートするために、Scratchのしようじょうほうをスクラッチチームにじどうてきにそうしんできます。",
    "gui.telemetryOptIn.body2": "あつめるじょうほうには、げんごせってい、ブロックのしようじょうきょう、ほぞんやよみこみ、アップロードなどのいくらかのイベントがふくまれます。わたしたちはこじんじょうほうをしゅうしゅうしません。くわしくは{privacyPolicyLink}をごらんください。",
    "gui.telemetryOptIn.privacyPolicyLink": "プライバシー・ポリシー",
    "gui.telemetryOptIn.optInText": "Scratchチームとしようじょうきょうをきょうゆうする",
    "gui.telemetryOptIn.optInTooltip": "とうけいデータのしゅうしゅうをかいしする",
    "gui.telemetryOptIn.optOutText": "Scratchチームとしようじょうきょうをきょうゆうしない",
    "gui.telemetryOptIn.optOutTooltip": "とうけいデータのしゅうしゅうをやめる",
    "gui.telemetryOptIn.settingWasUpdated": "せっていがこうしんされました。",
    "gui.telemetryOptIn.buttonClose": "とじる",
    "gui.turboMode.active": "ターボモード",
    "gui.webglModal.label": "ブラウザーはWebGLをサポートしていないようです",
    "gui.webglModal.description": "ざんねんながら、ブラウザーやコンピューターが{webGlLink}ようです。このぎじゅつはScratch 3.0のじっこうにひっすです。",
    "gui.webglModal.webgllink": "WebGLをサポートしていない",
    "gui.webglModal.back": "もどる",
    "gui.webglModal.previewfaq": "くわしくは、{previewFaqLink}をごらんください。",
    "gui.webglModal.previewfaqlinktext": "よくあるしつもん",
    "gui.costumeLibrary.chooseABackdrop": "はいけいをえらぶ",
    "gui.costumeLibrary.chooseACostume": "コスチュームをえらぶ",
    "gui.costumeTab.addBackdropFromLibrary": "はいけいをえらぶ",
    "gui.costumeTab.addCostumeFromLibrary": "コスチュームをえらぶ",
    "gui.costumeTab.addBlankCostume": " えがく",
    "gui.costumeTab.addSurpriseCostume": "サプライズ",
    "gui.costumeTab.addFileBackdrop": "はいけいをアップロード",
    "gui.costumeTab.addFileCostume": "コスチュームをアップロード",
    "gui.extensionLibrary.chooseAnExtension": "かくちょうきのうをえらぶ",
    "gui.extensionLibrary.extensionUrl": "かくちょうきのうのURLをにゅうりょく",
    "gui.monitors.importListColumnPrompt": "どのらんをつかいますか? (1-{numberOfColumns})",
    "gui.recordingStep.alertMsg": "ろくおんをかいしできません",
    "gui.soundLibrary.chooseASound": "おとをえらぶ",
    "gui.soundTab.fileUploadSound": "おとをアップロードする",
    "gui.soundTab.surpriseSound": "サプライズ",
    "gui.soundTab.recordSound": "ろくおんする",
    "gui.soundTab.addSoundFromLibrary": " おとをえらぶ",
    "gui.spriteLibrary.chooseASprite": "スプライトをえらぶ",
    "gui.tipsLibrary.tutorials": "チュートリアルをえらぶ",
    "gui.alerts.createsuccess": "あたらしいプロジェクトがさくせいされました。",
    "gui.alerts.createcopysuccess": "プロジェクトのコピーがほぞんされました。",
    "gui.alerts.createremixsuccess": "プロジェクトのリミックスがほぞんされました。",
    "gui.alerts.creating": "プロジェクトをさくせいちゅう...",
    "gui.alerts.creatingCopy": "プロジェクトをコピーちゅう...",
    "gui.alerts.creatingRemix": "プロジェクトをリミックスちゅう...",
    "gui.alerts.creatingError": "プロジェクトがさくせいできませんでした。もういちどおねがいします。",
    "gui.alerts.savingError": "プロジェクトはほぞんできませんでした。",
    "gui.alerts.savesuccess": "プロジェクトがほぞんされました。",
    "gui.alerts.saving": "プロジェクトをほぞんちゅう...",
    "gui.alerts.cloudInfo": "クラウドへんすうはすうじのみサポートしています。もじやきごうはいれられません。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "もっとくわしく。",
    "gui.alerts.importing": "よみこみちゅう...",
    "gui.defaultProject.meow": "ニャー",
    "gui.defaultProject.variable": "へんすう",
    "gui.howtos.intro-move-sayhello-hat.name": "さあ、はじめましょう",
    "gui.howtos.intro-move.step_stepMove": "うごきブロックをついかして、",
    "gui.howtos.add-a-move-block.step_stepSay": "「( )という」ブロックをついかする",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "はたをクリックしてかいししよう",
    "gui.howtos.intro-getting-started-ASL.name": "Scratchをはじめよう (アメリカしゅわ)",
    "gui.howtos.animate-a-name.name": "なまえをうごかしてみよう",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "もじのスプライトをえらぼう",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "クリックするとおとをならせるよ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "ほかのもじのスプライトをえらぼう",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "いろをかえてみよう",
    "gui.howtos.animate-a-name.step_AnimateSpin": "ほかのもじをえらんで、かいてんさせよう",
    "gui.howtos.animate-a-name.step_AnimateGrow": "ほかのもじをえらんで、おおきくしよう",
    "gui.howtos.imagine": "せかいをそうぞうしよう",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "あなたがつたえたいことをタイプして、",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "はたをクリックして、かいししよう",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "はいけいをどれかえらんで、",
    "gui.howtos.imagine.step_imagineChooseSprite": "スプライトをえらぼう",
    "gui.howtos.imagine.step_imagineFlyAround": "スペースキーをおして、ざひょうをかえてみよう",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "もうひとつスプライトをえらんで、",
    "gui.howtos.imagine.step_imagineLeftRight": "さゆうにうごかしたり、",
    "gui.howtos.imagine.step_imagineUpDown": "じょうげにうごかしてみよう",
    "gui.howtos.imagine.step_imagineChangeCostumes": "コスチュームをかえたり、",
    "gui.howtos.imagine.step_imagineGlideToPoint": "していのいちに、なめらかにうごかそう",
    "gui.howtos.imagine.step_imagineGrowShrink": "おおきくしたり、ちいさくしてみよう",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "もうひとつはいけいをえらんで、",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "はいけいをきりかえてみよう",
    "gui.howtos.imagine.step_imagineRecordASound": "おとをろくおんして、",
    "gui.howtos.imagine.step_imagineChooseSound": "ろくおんしたおとをえらぼう",
    "gui.howtos.make-music.name": "おんがくをつくろう",
    "gui.howtos.Make-Music.step_PickInstrument": "がっきのスプライトをえらんで、",
    "gui.howtos.Make-Music.step_PlaySoundClick": "クリックしておとをならしてみよう",
    "gui.howtos.Make-Music.step_MakeSong": "サックスできょくをつくってみよう",
    "gui.howtos.make-music.step_MakeBeat": "ドラムでリズムをとったり、",
    "gui.howtos.make-music.step_MakeBeatBox": "マイクでびっくりビードボックスをつくろう",
    "gui.howtos.story.name": "ものがたりをつくろう",
    "gui.howtos.story.step_addbg": "はいけいをついかしよう",
    "gui.howtos.story.step_addsprite": "キャラクターをついかして、",
    "gui.howtos.story.step_saysomething": "なにかおしゃべりさせよう",
    "gui.howtos.story.step_addanothersprite": "もうひとつキャラクターをついかして、",
    "gui.howtos.story.step_flip": "むきをはんてんさせて、",
    "gui.howtos.story.step_conversation": "おしゃべりさせよう",
    "gui.howtos.story.addanotherbg": "もうひとつはいけいをくわえて、",
    "gui.howtos.story.step_swithbg": "はいけいをきりかえてみよう",
    "gui.howtos.story.step_hidewizard": "まほうつかいをかくそう",
    "gui.howtos.story.step_showwizard": "さいしょは、まほうつかいを、ひょうじしておこう",
    "gui.howtos.make-a-chase-game.name": "ついせきゲームをつくろう",
    "gui.howtos.Chase-Game.step_BG": "はいけいをついかして、",
    "gui.howtos.chase-game.step_AddOcto": "スプライトをついかしよう",
    "gui.howtos.make-music.step_LeftRight": "やじるしキーでさゆうにうごかしたり、",
    "gui.howtos.Chase-Game.step_UpDown": "やじるしキーでじょうげにうごかそう",
    "gui.howtos.Chase-Game.step_AddStar": "もうひとつスプライトをついかして、",
    "gui.howtos.Chase-Game.step_MoveRandom": "どこかのばしょにうごかして、",
    "gui.howtos.Chase-Game.step_WhenTouch": "タコがほしにふれたら、おとをならそう",
    "gui.howtos.Chase-Game.step_ScoreVariable": "スコアのへんすうをつくって、",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "タコがほしにふれたら、スコアをくわえよう",
    "gui.howtos.animate-char.name": "キャラクターをうごかそう",
    "gui.howtos.animate-char.step_addbg": "はいけいをついかして、",
    "gui.howtos.animate-char.step_addsprite": "スプライトをついかしよう",
    "gui.howtos.animate-char.step_saysomething": "なにかおしゃべりさせてみよう",
    "gui.howtos.animate-char.step_addsound": "おとをくわえて、",
    "gui.howtos.animate-char.step_animatetalking": "おしゃべりするアニメーションにしよう",
    "gui.howtos.animate-char.step_arrowkeys": "やじるしキーでうごかしたり、",
    "gui.howtos.animate-char.step_jump": "ジャンプさせたり、",
    "gui.howtos.animate-char.step_changecolor": "いろをかえたりしてみよう",
    "gui.howtos.make-a-game.name": "クリッカーゲームをつくろう",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "スプライトをえらんで、",
    "gui.howtos.make-a-game.step_GamePlaySound": "クリックでおとがなるようにします",
    "gui.howtos.make-a-game.step_GameAddScore": "スコアのへんすうをつくって、",
    "gui.howtos.make-a-game.step_GameChangeScore": "クリックしたらスコアを加えるようにしよう",
    "gui.howtos.make-a-game.step_Random": "どこかのばしょへいくようにしたり、",
    "gui.howtos.make-music.step_GameChangeColor": "いろをかえたりしよう",
    "gui.howtos.make-music.step_ResetScore": "スコアのリセットをわすれないようにしよう",
    "gui.howtos.make-it-fly.name": "キャラクターをとばそう",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "そらのはいけいをえらんで、",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "キャラクターをえらぼう",
    "gui.howtos.fly.step_stepflySaySomething": "なにかおしゃべりさせたり、",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "やじるしキーでうごかしてみよう",
    "gui.howtos.fly.step_stepflyChooseObject": "あつめるものをえらんで、",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "それをうごかしてみよう。",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "キャラクターをえらび、",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "スコアのへんすうをついかして、",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "スコアをつけられるようにしよう",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "くもをついかし、",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "くもをうごかして、",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "つぎのコスチュームにしてみよう",
    "gui.howtos.pong": "ピンポンゲーム",
    "gui.howtos.pong.step_pongAddBackdrop": "はいけいをついかして、",
    "gui.howtos.pong.step_pongAddBallSprite": "ボールのスプライトをついかしよう",
    "gui.howtos.pong.step_pongBounceAround": "まわりでバウンドさせてみよう",
    "gui.howtos.pong.step_pongAddPaddle": "パドルをくわえて、",
    "gui.howtos.pong.step_pongMoveThePaddle": "そのパドルをうごかそう",
    "gui.howtos.pong.step_pongSelectBallSprite": "ボールをえらんで、",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "ボールがパドルではねかえるよう、コードをくわえよう",
    "gui.howtos.pong.step_pongAddAScore": "スコアのへんすうをついかして、",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "メニューから”スコア”をせんたくしよう",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "”スコアを～ずつかえる”をついかして、",
    "gui.howtos.pong.step_pongResetScore": "わすれずにスコアをリセットしておこう",
    "gui.howtos.pong.step_pongAddLineSprite": "Lineのスプライトをくわえて、",
    "gui.howtos.pong.step_pongGameOver": "Lineにふれたらゲームオーバーにしよう",
    "gui.howtos.code-cartoon": "アニメえいがをコーディングしよう",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "はたがおされたときに、なにかをいわせよう",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "とうじょうじんぶつをおしたら、うごくようにしよう",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "べつのとうじょうじんぶつをえらぼう",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "ちいさくするには、マイナスふごうをつかうんだ",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "とうじょうじんぶつを、おおきくしたり、ちいさくできるよ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "べつのとうじょうじんぶつをえらんで、",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "じょうげにジャンプさせよう",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "とうじょうじんぶつをおして、ばめんをかえよう",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "あちこちに、すべるようにうごかしたり、",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "コスチュームをかえてみよう",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "アニメえいがの、とうじょうじんぶつを、もっとふやそう",
    "gui.howtos.cartoon-network": "アドベンチャーゲーム",
    "gui.howtos.cartoon-network.step_CNcharacter": "キャラクターをえらんで、ひょうじして、",
    "gui.howtos.cartoon-network.step_CNsay": "なにかおしゃべりさせよう",
    "gui.howtos.cartoon-network.step_CNglide": "なめらかにうごかす",
    "gui.howtos.cartoon-network.step_CNpicksprite": "おっかけるものをえらんで、",
    "gui.howtos.cartoon-network.step_CNcollect": "ものをあつめるようにしよう",
    "gui.howtos.cartoon-network.step_CNvariable": "スコアのへんすうをつくって、",
    "gui.howtos.cartoon-network.step_CNscore": "スコアをつけよう",
    "gui.howtos.cartoon-network.step_CNbackdrop": "レベルアップ: はいけいをかえよう",
    "gui.howtos.videosens.name": "ビデオモーションセンサー",
    "gui.howtos.videosens.step_addextension": "かくちょうきのうをついかします",
    "gui.howtos.videosens.step_pet": "ネコをなでるとニャーとなくよ",
    "gui.howtos.videosens.step_animate": "ふれるとうごくアニメにしよう",
    "gui.howtos.videosens.step_pop": "つつくとふうせんがいろんなばしょにうごくよ",
    "gui.howtos.say-it-out-loud": "おしゃべりするアニメをつくろう",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "おんせいごうせいのブロックをついかしよう",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "なにかおしゃべりさせよう",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "こえのしゅるいをしていできます",
    "gui.howtos.say-it-out-loud.step_TXTMove": "あちこちにうごかそう",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "はいけいをついかして、",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "キャラクターをついかしよう",
    "gui.howtos.say-it-out-loud.step_TXTSong": "BGMをながしてみたり、",
    "gui.howtos.say-it-out-loud.step_TXTColor": "いろをへんかさせてみよう",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "かいてんさせたり、",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "おおきくしたり、ちいさくしてみよう",
    "gui.howtos.talking": "おしゃべり",
    "gui.howtos.talking.step_talesAddExtension": "おんせいごうせいのブロックをついかしよう",
    "gui.howtos.talking.step_talesChooseSprite": "スプライトをえらんで、",
    "gui.howtos.talking.step_talesSaySomething": "キャラクターにおしゃべりさせよう",
    "gui.howtos.talking.step_talesChooseBackdrop": "はいけいをえらんで、",
    "gui.howtos.talking.step_talesSwitchBackdrop": "キャラクターをおして、つぎのはいけいにしよう",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "もうひとつスプライトをえらんで、",
    "gui.howtos.talking.step_talesMoveAround": "あちこちにうごかそう",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "もうひとつはいけいをえらんで、",
    "gui.howtos.talking.step_talesAnimateTalking": "おしゃべりするアニメーションにしよう",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "べつのはいけいをえらんで、",
    "gui.howtos.talking.step_talesChooseSound": "ダンスのうごきにあわせて、",
    "gui.howtos.talking.step_talesDanceMoves": "きょくをえらぼう",
    "gui.howtos.talking.step_talesAskAnswer": "しらべるカテゴリの\"こたえ\"と\"～ときいてまつ\"をつかってみよう",
    "gui.howtos.add-sprite.name": "スプライトのついかほうほう",
    "gui.howtos.add-sprite.step_addSprite": "スプライトをついかしよう",
    "gui.howtos.add-a-backdrop.name": "はいけいのついかほうほう",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "はいけいをついかしよう",
    "gui.howtos.change-size.name": "おおきさのへんこうほうほう",
    "gui.howtos.change-size.step_changeSize": "おおきさをへんこうしよう",
    "gui.howtos.glide-around.name": "なめらかにうごかすほうほう",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "なめらかにうごかそう",
    "gui.howtos.change-size.step_glideAroundPoint": "していのいちになめらかにうごかそう",
    "gui.howtos.record-a-sound.name": "おとのろくおんほうほう",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "おとタブをクリックして、",
    "gui.howtos.change-size.step_recordASoundClickRecord": "”ろくおんする”をクリックします",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "ろくおんボタンをおしてみよう",
    "gui.howtos.change-size.step_recordASoundChooseSound": "ろくおんしたおとをせんたくしよう",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "ろくおんしたおとをさいせいしてみよう",
    "gui.howtos.spin-video.name": "もじをかいてんさせるほうほう",
    "gui.howtos.change-size.step_spinTurn": "かいてんさせよう",
    "gui.howtos.change-size.step_spinPointInDirection": "むきをしていしよう",
    "gui.howtos.hide-and-show.name": "かくしたりひょうじするほうほう",
    "gui.howtos.change-size.step_hideAndShow": "かくして、ひょうじしよう",
    "gui.howtos.switch-costume.name": "スプライトにうごきをつけるほうほう",
    "gui.howtos.change-size.step_switchCostumes": "スプライトにうごきをつけよう",
    "gui.howtos.move-around-with-arrow-keys.name": "やじるしキーをつかうほうほう",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "さゆうにうごかそう",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "じょうげにうごかそう",
    "gui.howtos.add-effects.name": "こうかのついかほうほう",
    "gui.howtos.videosens.step_addEffects": "こうかをついかしよう",
    "gui.extension.music.name": "おんがく",
    "gui.extension.music.description": "がっきやドラムをえんそうする。",
    "gui.extension.pen.name": "ペン",
    "gui.extension.pen.description": "スプライトで、えをかく。",
    "gui.extension.videosensing.name": "ビデオモーションセンサー",
    "gui.extension.videosensing.description": "カメラでうごきをしらべる。",
    "gui.extension.text2speech.name": "おんせいごうせい",
    "gui.extension.text2speech.description": "ことばをしゃべるプロジェクトをつくろう。",
    "gui.extension.translate.name": "ほんやく",
    "gui.extension.translate.description": "いろいろなことばにテキストをほんやくします。",
    "gui.extension.makeymakey.description": "なんでもキーボードにしてみる。",
    "gui.extension.microbit.description": "あなたのプロジェクトを、ほんとうのせかいと、つなぎます。",
    "gui.extension.microbit.connectingMessage": "せつぞくちゅう",
    "gui.extension.ev3.description": "たいわするロボットなどをつくる。",
    "gui.extension.ev3.connectingMessage": "せつぞくちゅうです。EV3のピンが1234にせっていされていることを、かくにんしてください。",
    "gui.extension.boost.description": "ロボットさくひんに、いのちをふきこもう。",
    "gui.extension.boost.connectingMessage": "せつぞくちゅう",
    "gui.extension.wedo2.description": "モーターとセンサーをつかってつくる。",
    "gui.extension.wedo2.connectingMessage": "せつぞくちゅう",
    "gui.extension.gdxfor.description": "おすちから、ひくちから、うごきや、かいてんをけんしゅつする。",
    "gui.extension.gdxfor.connectingMessage": "せつぞくちゅう",
    "gui.libraryTags.all": "すべて",
    "gui.libraryTags.animals": "どうぶつ",
    "gui.libraryTags.dance": "ダンス",
    "gui.libraryTags.effects": "こうか",
    "gui.libraryTags.fantasy": "ファンタジー",
    "gui.libraryTags.fashion": "ファッション",
    "gui.libraryTags.food": "たべもの",
    "gui.libraryTags.indoors": "おくない",
    "gui.libraryTags.loops": "ループ",
    "gui.libraryTags.music": "おんがく",
    "gui.libraryTags.notes": "ノート",
    "gui.libraryTags.outdoors": "おくがい",
    "gui.libraryTags.patterns": "もよう",
    "gui.libraryTags.people": "ひと",
    "gui.libraryTags.percussion": "だがっき",
    "gui.libraryTags.space": "うちゅう",
    "gui.libraryTags.sports": "スポーツ",
    "gui.libraryTags.underwater": "かいちゅう",
    "gui.libraryTags.voice": "こえ",
    "gui.libraryTags.wacky": "きみょうなおと",
    "gui.libraryTags.animation": "アニメーション",
    "gui.libraryTags.art": "アート",
    "gui.libraryTags.games": "ゲーム",
    "gui.libraryTags.stories": "ものがたり",
    "gui.libraryTags.letters": "もじ",
    "gui.opcodeLabels.direction": "むき",
    "gui.opcodeLabels.xposition": "xざひょう",
    "gui.opcodeLabels.yposition": "yざひょう",
    "gui.opcodeLabels.size": "おおきさ",
    "gui.opcodeLabels.costumename": "コスチュームめい",
    "gui.opcodeLabels.costumenumber": "コスチュームのばんごう",
    "gui.opcodeLabels.backdropname": "はいけいのなまえ",
    "gui.opcodeLabels.backdropnumber": "はいけいのばんごう",
    "gui.opcodeLabels.volume": "おんりょう",
    "gui.opcodeLabels.tempo": "テンポ",
    "gui.opcodeLabels.answer": "こたえ",
    "gui.opcodeLabels.loudness": "おんりょう",
    "gui.opcodeLabels.username": "ユーザーめい",
    "gui.opcodeLabels.year": "ねん",
    "gui.opcodeLabels.month": "つき",
    "gui.opcodeLabels.date": "ひ",
    "gui.opcodeLabels.dayofweek": "ようび",
    "gui.opcodeLabels.hour": "じ",
    "gui.opcodeLabels.minute": "ぶん",
    "gui.opcodeLabels.second": "びょう",
    "gui.opcodeLabels.timer": "タイマー",
    "gui.projectLoader.loadError": "せんたくされたプロジェクトファイルのよみこみに、しっぱいしました。",
    "gui.sharedMessages.backdrop": "はいけい{index}",
    "gui.sharedMessages.costume": "コスチューム{index}",
    "gui.sharedMessages.sprite": "スプライト{index}",
    "gui.sharedMessages.pop": "ポップ",
    "gui.sharedMessages.replaceProjectWarning": "げんざいのプロジェクトのないようをおきかえますか？",
    "gui.sharedMessages.loadFromComputerTitle": "コンピューターからよみこむ",
    "gui.theme.default": "オリジナル",
    "gui.theme.dark": "ダーク",
    "gui.theme.highContrast": "ハイコントラスト",
    "gui.gui.defaultProjectTitle": "Scratchのプロジェクト",
    "boost.color.any": "どれかのいろ",
    "boost.color.black": "くろ",
    "boost.color.blue": "あお",
    "boost.color.green": "みどり",
    "boost.color.red": "あか",
    "boost.color.white": "しろ",
    "boost.color.yellow": "きいろ",
    "boost.getMotorPosition": "モーター[MOTOR_REPORTER_ID]のいち",
    "boost.getTiltAngle": "[TILT_DIRECTION]ほうこうのかたむき",
    "boost.motorDirection.backward": "あちらむき",
    "boost.motorDirection.forward": "こちらむき",
    "boost.motorDirection.reverse": "ぎゃくむき",
    "boost.motorOff": "モーター[MOTOR_ID]をオフにする",
    "boost.motorOn": "モーター[MOTOR_ID]をオンにする",
    "boost.motorOnFor": "モーター[MOTOR_ID]を[DURATION]びょうかんオンにする",
    "boost.motorOnForRotation": "モーター[MOTOR_ID]を[ROTATION]かいてんさせる",
    "boost.seeingColor": "[COLOR] をみている？",
    "boost.setLightHue": "ライトのいろを[HUE]にする",
    "boost.setMotorDirection": "モーター[MOTOR_ID]のむきを[MOTOR_DIRECTION]にする",
    "boost.setMotorPower": "モーター[MOTOR_ID]のはやさを[POWER]%にする",
    "boost.tiltDirection.any": "どれかのむき",
    "boost.tiltDirection.down": "した",
    "boost.tiltDirection.left": "ひだり",
    "boost.tiltDirection.right": "みぎ",
    "boost.tiltDirection.up": "うえ",
    "boost.whenColor": "[COLOR] をみたとき",
    "boost.whenTilted": "[TILT_DIRECTION_ANY]にかたむいたとき",
    "ev3.beepNote": "[NOTE]のおんぷを[TIME]びょうならす",
    "ev3.buttonPressed": "ボタン[PORT]がおされた",
    "ev3.getBrightness": "あかるさ",
    "ev3.getDistance": "きょり",
    "ev3.getMotorPosition": "モーター[PORT]のいち",
    "ev3.motorSetPower": "モーター[PORT]のパワーを[POWER]%にする",
    "ev3.motorTurnClockwise": "モーター[PORT]をこちらむきに[TIME]びょうかんまわす",
    "ev3.motorTurnCounterClockwise": "モーター[PORT]をあちらむきに[TIME]びょうかんまわす",
    "ev3.whenBrightnessLessThan": "あかるさ < [DISTANCE]のとき",
    "ev3.whenButtonPressed": "ボタン[PORT]がおされたとき",
    "ev3.whenDistanceLessThan": "きょり < [DISTANCE]のとき",
    "gdxfor.getAcceleration": "[DIRECTION]のかそく",
    "gdxfor.getForce": "ちから",
    "gdxfor.getSpin": "[DIRECTION]かいてんのはやさ",
    "gdxfor.getTilt": "[TILT]ほうこうのかたむき",
    "gdxfor.isFreeFalling": "らっかちゅう",
    "gdxfor.isTilted": "[TILT]にかたむいた",
    "gdxfor.pulled": "ひかれた",
    "gdxfor.pushed": "おされた",
    "gdxfor.shaken": "ふられた",
    "gdxfor.startedFalling": "らっかをはじめた",
    "gdxfor.tiltDirectionMenu.any": "どれかのむき",
    "gdxfor.tiltDirectionMenu.back": "うしろ",
    "gdxfor.tiltDirectionMenu.front": "まえ",
    "gdxfor.tiltDirectionMenu.left": "ひだり",
    "gdxfor.tiltDirectionMenu.right": "みぎ",
    "gdxfor.turnedFaceDown": "ひょうめんがした",
    "gdxfor.turnedFaceUp": "ひょうめんがうえ",
    "gdxfor.whenForcePushedOrPulled": "ちからのセンサーが[PUSH_PULL]とき",
    "gdxfor.whenGesture": "[GESTURE]とき",
    "gdxfor.whenTilted": "[TILT]にかたむいたとき",
    "makeymakey.downArrow": "したむきやじるし",
    "makeymakey.downArrowShort": "した",
    "makeymakey.leftArrow": "ひだりむきやじるし",
    "makeymakey.leftArrowShort": "ひだり",
    "makeymakey.rightArrow": "みぎむきやじるし",
    "makeymakey.rightArrowShort": "みぎ",
    "makeymakey.spaceKey": "スペース",
    "makeymakey.upArrow": "うわむきやじるし",
    "makeymakey.upArrowShort": "うえ",
    "makeymakey.whenKeyPressed": "[KEY]キーがおされたとき",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] がじゅんばんにおされたとき",
    "microbit.buttonsMenu.any": "どれかの",
    "microbit.clearDisplay": "がめんをけす",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "[MATRIX]をひょうじする",
    "microbit.displayText": "[TEXT]をひょうじする",
    "microbit.gesturesMenu.jumped": "ジャンプした",
    "microbit.gesturesMenu.moved": "うごいた",
    "microbit.gesturesMenu.shaken": "ふられた",
    "microbit.isButtonPressed": "ボタン[BTN]がおされた",
    "microbit.isTilted": "[DIRECTION]にかたむいた",
    "microbit.pinStateMenu.off": "きり",
    "microbit.pinStateMenu.on": "いり",
    "microbit.tiltAngle": "[DIRECTION]ほうこうのかたむき",
    "microbit.tiltDirectionMenu.any": "どれかのむき",
    "microbit.tiltDirectionMenu.back": "うしろ",
    "microbit.tiltDirectionMenu.front": "まえ",
    "microbit.tiltDirectionMenu.left": "ひだり",
    "microbit.tiltDirectionMenu.right": "みぎ",
    "microbit.whenButtonPressed": "ボタン[BTN]がおされたとき",
    "microbit.whenGesture": "[GESTURE]とき",
    "microbit.whenPinConnected": "ピン[PIN]がつながったとき",
    "microbit.whenTilted": "[DIRECTION]にかたむいたとき",
    "music.categoryName": "おんがく",
    "music.changeTempo": "テンポを[TEMPO]ずつかえる",
    "music.drumBass": "(2) バスドラム",
    "music.drumBongo": "(13) ボンゴ",
    "music.drumCabasa": "(15) カバサ",
    "music.drumClaves": "(9) クラーベ",
    "music.drumClosedHiHat": "(6) クローズハイハット",
    "music.drumConga": "(14) コンガ",
    "music.drumCowbell": "(11) カウベル",
    "music.drumCrashCymbal": "(4) クラッシュシンバル",
    "music.drumCuica": "(18) クイーカ",
    "music.drumGuiro": "(16) ギロ",
    "music.drumHandClap": "(8) てびょうし",
    "music.drumOpenHiHat": "(5) オープンハイハット",
    "music.drumSideStick": "(3) サイドスティック",
    "music.drumSnare": "(1) スネアドラム",
    "music.drumTambourine": "(7) タンバリン",
    "music.drumTriangle": "(12) トライアングル",
    "music.drumVibraslap": "(17) ビブラスラップ",
    "music.drumWoodBlock": "(10) ウッドブロック",
    "music.getTempo": "テンポ",
    "music.instrumentBass": "(6) ベース",
    "music.instrumentBassoon": "(14) バスーン",
    "music.instrumentCello": "(8) チェロ",
    "music.instrumentChoir": "(15) がっしょうだん",
    "music.instrumentClarinet": "(10) クラリネット",
    "music.instrumentElectricGuitar": "(5) エレキギター",
    "music.instrumentElectricPiano": "(2) でんしピアノ",
    "music.instrumentFlute": "(12) フルート",
    "music.instrumentGuitar": "(4) ギター",
    "music.instrumentMarimba": "(19) マリンバ",
    "music.instrumentMusicBox": "(17) ミュージックボックス",
    "music.instrumentOrgan": "(3) オルガン",
    "music.instrumentPiano": "(1) ピアノ",
    "music.instrumentPizzicato": "(7) ピチカート",
    "music.instrumentSaxophone": "(11) サクソフォン",
    "music.instrumentSteelDrum": "(18) スチールドラム",
    "music.instrumentSynthLead": "(20) シンセリード",
    "music.instrumentSynthPad": "(21) シンセパッド",
    "music.instrumentTrombone": "(9) トロンボーン",
    "music.instrumentVibraphone": "(16) ビブラフォン",
    "music.instrumentWoodenFlute": "(13) もっかんフルート",
    "music.midiPlayDrumForBeats": "[DRUM]のドラムを[BEATS]はくならす",
    "music.midiSetInstrument": "がっきを[INSTRUMENT]にする",
    "music.playDrumForBeats": "[DRUM]のドラムを[BEATS]はくならす",
    "music.playNoteForBeats": "[NOTE]のおんぷを[BEATS]はくならす",
    "music.restForBeats": "[BEATS]はくやすむ",
    "music.setInstrument": "がっきを[INSTRUMENT]にする",
    "music.setTempo": "テンポを[TEMPO]にする",
    "pen.categoryName": "ペン",
    "pen.changeColorParam": "ペンの[COLOR_PARAM]を[VALUE]ずつかえる",
    "pen.changeHue": "ペンのいろを[HUE]ずつかえる",
    "pen.changeShade": "ペンのこさを[SHADE]ずつかえる",
    "pen.changeSize": "ペンのふとさを[SIZE]ずつかえる",
    "pen.clear": "ぜんぶけす",
    "pen.colorMenu.brightness": "あかるさ",
    "pen.colorMenu.color": "いろ",
    "pen.colorMenu.saturation": "あざやかさ",
    "pen.colorMenu.transparency": "とうめいど",
    "pen.penDown": "ペンをおろす",
    "pen.penUp": "ペンをあげる",
    "pen.setColor": "ペンのいろを[COLOR]にする",
    "pen.setColorParam": "ペンの[COLOR_PARAM]を[VALUE]にする",
    "pen.setHue": "ペンのいろを[HUE]にする",
    "pen.setShade": "ペンのこさを[SHADE]にする",
    "pen.setSize": "ペンのふとさを[SIZE]にする",
    "pen.stamp": "スタンプ",
    "speech.defaultWhenIHearValue": "いこう",
    "speech.extensionName": "おんせいにんしき",
    "speech.listenAndWait": "きいて",
    "speech.speechReporter": "おんせい",
    "speech.whenIHear": "[PHRASE]をきいたとき",
    "text2speech.alto": "アルト",
    "text2speech.categoryName": "おんせいごうせい",
    "text2speech.defaultTextToSpeak": "こんにちは",
    "text2speech.giant": "きょじん",
    "text2speech.kitten": "こねこ",
    "text2speech.setLanguageBlock": "げんごを[LANGUAGE]にする",
    "text2speech.setVoiceBlock": "こえを[VOICE]にする",
    "text2speech.speakAndWaitBlock": "[WORDS]としゃべる",
    "text2speech.squeak": "ねずみ",
    "text2speech.tenor": "テノール",
    "translate.categoryName": "ほんやく",
    "translate.defaultTextToTranslate": "こんにちは",
    "translate.translateBlock": "[WORDS]を[LANGUAGE]にほんやくする",
    "translate.viewerLanguage": "げんご",
    "videoSensing.categoryName": "ビデオモーションセンサー",
    "videoSensing.direction": "むき",
    "videoSensing.motion": "モーション",
    "videoSensing.off": "きり",
    "videoSensing.on": "いり",
    "videoSensing.onFlipped": "さゆうはんてん",
    "videoSensing.setVideoTransparency": "ビデオのとうめいどを[TRANSPARENCY]にする",
    "videoSensing.sprite": "スプライト",
    "videoSensing.stage": "ステージ",
    "videoSensing.videoOn": "[SUBJECT]のビデオの[ATTRIBUTE]",
    "videoSensing.videoToggle": "ビデオを[VIDEO_STATE]にする",
    "videoSensing.whenMotionGreaterThan": "ビデオモーション > [REFERENCE]のとき",
    "wedo2.getDistance": "きょり",
    "wedo2.getTiltAngle": "[TILT_DIRECTION]ほうこうのかたむき",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY]にかたむいた",
    "wedo2.motorDirection.backward": "あちらむき",
    "wedo2.motorDirection.forward": "こちらむき",
    "wedo2.motorDirection.reverse": "ぎゃくむき",
    "wedo2.motorId.a": "モーターA",
    "wedo2.motorId.all": "すべてのモーター",
    "wedo2.motorId.b": "モーターB",
    "wedo2.motorId.default": "モーター",
    "wedo2.motorOff": "[MOTOR_ID]をオフにする",
    "wedo2.motorOn": "[MOTOR_ID]をオンにする",
    "wedo2.motorOnFor": "[MOTOR_ID]を[DURATION]びょうかんオンにする",
    "wedo2.playNoteFor": "[NOTE]のおんぷを[DURATION]びょうかんならす",
    "wedo2.setLightHue": "ライトのいろを[HUE]にする",
    "wedo2.setMotorDirection": "[MOTOR_ID]のほうこうを[MOTOR_DIRECTION]にする",
    "wedo2.startMotorPower": "[MOTOR_ID]のパワーを[POWER]にする",
    "wedo2.tiltDirection.any": "どれかのむき",
    "wedo2.tiltDirection.down": "した",
    "wedo2.tiltDirection.left": "ひだり",
    "wedo2.tiltDirection.right": "みぎ",
    "wedo2.tiltDirection.up": "うえ",
    "wedo2.whenDistance": "きょり[OP][REFERENCE]のとき",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY]にかたむいたとき",
    "paint.paintEditor.hue": "いろ",
    "paint.paintEditor.saturation": "あざやかさ",
    "paint.paintEditor.brightness": "あかるさ",
    "paint.paintEditor.costume": "コスチューム",
    "paint.paintEditor.group": "ぐるーぷか",
    "paint.paintEditor.ungroup": "グループかいじょ",
    "paint.paintEditor.undo": "とりけし",
    "paint.paintEditor.redo": "やりなおし",
    "paint.paintEditor.forward": "てまえにだす",
    "paint.paintEditor.backward": "おくにさげる",
    "paint.paintEditor.front": "さいぜんめん",
    "paint.paintEditor.back": "さいはいめん",
    "paint.paintEditor.more": "もっと",
    "paint.modeTools.brushSize": "おおきさ",
    "paint.modeTools.eraserSize": "けしごむのおおきさ",
    "paint.modeTools.copy": "コピー",
    "paint.modeTools.paste": "はりつけ",
    "paint.modeTools.delete": "さくじょ",
    "paint.modeTools.curved": "なめらか",
    "paint.modeTools.pointed": "かどばった",
    "paint.modeTools.thickness": "ふとさ",
    "paint.modeTools.flipHorizontal": "さゆうはんてん",
    "paint.modeTools.flipVertical": "じょうげはんてん",
    "paint.modeTools.filled": "ぬりつぶし",
    "paint.modeTools.outlined": "りんかく",
    "paint.paintEditor.bitmap": "ビットマップにへんかん",
    "paint.paintEditor.vector": "ベクターにへんかん",
    "paint.paintEditor.fill": "ぬりつぶし",
    "paint.paintEditor.stroke": "わくせん",
    "paint.brushMode.brush": "ふで",
    "paint.eraserMode.eraser": "けしごむ",
    "paint.fillMode.fill": "ぬりつぶし",
    "paint.lineMode.line": "ちょくせん",
    "paint.ovalMode.oval": "えん",
    "paint.rectMode.rect": "しかくけい",
    "paint.reshapeMode.reshape": "かたちをかえる",
    "paint.roundedRectMode.roundedRect": "かくまるのちょうほうけい",
    "paint.selectMode.select": "せんたく",
    "paint.textMode.text": "テキスト",
    "paint.colorPicker.swap": "いれかえ"
  },
  "nb": {
    "gui.alerts.lostPeripheralConnection": "Scratch mistet forbindelsen til {extensionName}.",
    "gui.alerts.tryAgain": "Prøv igjen",
    "gui.alerts.download": "Last ned",
    "gui.connection.reconnect": "Koble til igjen",
    "gui.backpack.costumeLabel": "drakt",
    "gui.backpack.soundLabel": "lyd",
    "gui.backpack.scriptLabel": "skript",
    "gui.backpack.spriteLabel": "figur",
    "gui.backpack.header": "Ryggsekk",
    "gui.backpack.errorBackpack": "Noe gikk feil med ryggsekken",
    "gui.backpack.loadingBackpack": "Laster...",
    "gui.backpack.more": "Mer",
    "gui.backpack.emptyBackpack": "Ryggsekken er tom",
    "gui.unsupportedBrowser.label": "Nettleseren støttes ikke",
    "gui.unsupportedBrowser.errorLabel": "Det oppstod en feil",
    "gui.unsupportedBrowser.notRecommended": "Beklager, men det ser dessverre ut til at du bruker en nettleser ikke virker med Scratch. Vi anbefaler at du oppgraderer til nyeste versjon av Google Chrome, Mozilla Firefox, Microsoft Edge eller Apple Safari.",
    "gui.unsupportedBrowser.description": "Beklager, men Scratch kan ikke brukes med denne nettleseren. Vi anbefaler at du oppgraderer til nyeste versjon av Google Chrome, Mozilla Firefox, Microsoft Edge eller Apple Safari.",
    "gui.unsupportedBrowser.back": "Tilbake",
    "gui.unsupportedBrowser.previewfaq": "Du finner mer informasjon under {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Spørsmål og svar",
    "gui.cards.all-tutorials": "Veiledninger",
    "gui.cards.shrink": "Skjul",
    "gui.cards.expand": "Åpne",
    "gui.cards.close": "Lukk",
    "gui.cards.more-things-to-try": "Andre ting du kan prøve",
    "gui.cards.see-more": "Vis flere",
    "gui.comingSoon.message1": "Ingen fare, vi arbeider med dette {emoji}",
    "gui.comingSoon.message2": "Kommer snart...",
    "gui.comingSoon.message3": "Vi arbeider med dette {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Fant ingen enheter",
    "gui.connection.auto-scanning.prescan": "Ha enheten i nærheten og start søk.",
    "gui.connection.auto-scanning.pressbutton": "Trykk på knappen på enheten din.",
    "gui.connection.auto-scanning.start-search": "Start søk",
    "gui.connection.connecting-searchbutton": "Søker...",
    "gui.connection.auto-scanning.try-again": "Prøv igjen",
    "gui.connection.auto-scanning.updatePeripheralButton": "Oppdater min enhet",
    "gui.connection.connected": "Tilkoblet",
    "gui.connection.disconnect": "Koble fra",
    "gui.connection.go-to-editor": "Gå til programredigering",
    "gui.connection.connecting-cancelbutton": "Kobler til...",
    "gui.connection.error.errorMessage": "Heisann, det ser ut til at noe gikk galt.",
    "gui.connection.error.tryagainbutton": "Prøv igjen",
    "gui.connection.error.helpbutton": "Hjelp",
    "gui.connection.peripheral-name-label": "Enhetsnavn",
    "gui.connection.connect": "Koble til",
    "gui.connection.scanning.lookingforperipherals": "Søker etter enheter",
    "gui.connection.scanning.noPeripheralsFound": "Fant ingen enheter",
    "gui.connection.scanning.instructions": "Velg din enhet i listen ovenfor",
    "gui.connection.search": "Søk igjen",
    "gui.connection.scanning.updatePeripheralButton": "Oppdater min enhet",
    "gui.connection.unavailable.installscratchlink": "Sjekk at du har installert og startet \"Scratch Link\"",
    "gui.connection.unavailable.enablebluetooth": "Sjekk at Bluetooth er skrudd på",
    "gui.connection.unavailable.tryagainbutton": "Prøv igjen",
    "gui.connection.unavailable.helpbutton": "Hjelp",
    "gui.connection.updatePeripheral.microBitConnect": "Bruk en USB-kabel for å koble din {extensionName} til denne enheten.",
    "gui.connection.updatePeripheral.pressUpdate": "Trykk \"Oppdater\" og vent til oppdateringen er ferdig.",
    "gui.connection.updatePeripheral.progress": "Oppdaterer {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Vellykket oppdatering!",
    "gui.connection.updatePeripheral.updateFailed": "Noe gikk feil med oppdateringen.",
    "gui.connection.updatePeripheral.goBackButton": "Tilbake",
    "gui.connection.updatePeripheral.updateNowButton": "Oppdater",
    "gui.connection.updatePeripheral.updateAgainButton": "Prøv igjen",
    "gui.controls.go": "Start",
    "gui.controls.stop": "Stopp",
    "gui.crashMessage.label": "Uff, noe gikk galt.",
    "gui.crashMessage.description": "Beklager, det ser ut til at Scratch har kræsjet. Feilen har blitt rapportert automatisk til utviklerne. Last inn siden på nytt for å prøve igjen.",
    "gui.crashMessage.errorNumber": "Feilen er logget med ID {errorId}",
    "gui.crashMessage.reload": "Last på nytt",
    "gui.customProcedures.myblockModalTitle": "Lag en kloss",
    "gui.customProcedures.addAnInputNumberText": "Legg til et felt",
    "gui.customProcedures.numberTextType": "tall eller tekst",
    "gui.customProcedures.addAnInputBoolean": "Legg til et felt",
    "gui.customProcedures.booleanType": "logisk verdi",
    "gui.customProcedures.addALabel": "Legg til tekst",
    "gui.customProcedures.runWithoutScreenRefresh": "Kjør uten å oppdatere skjermen",
    "gui.customProcedures.cancel": "Avbryt",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Retning",
    "gui.directionPicker.rotationStyles.allAround": "Fri rotasjon",
    "gui.directionPicker.rotationStyles.leftRight": "Vend sideveis",
    "gui.directionPicker.rotationStyles.dontRotate": "Ikke roter",
    "gui.gui.addExtension": "Hent tilleggsfunksjon",
    "gui.gui.codeTab": "Kode",
    "gui.gui.backdropsTab": "Bakgrunner",
    "gui.gui.costumesTab": "Drakter",
    "gui.gui.soundsTab": "Lyder",
    "gui.extensionLibrary.comingSoon": "Kommer snart",
    "gui.extensionLibrary.requires": "Utstyrsbehov",
    "gui.extensionLibrary.collaboration": "Samarbeid med",
    "gui.library.filterPlaceholder": "Søk",
    "gui.library.allTag": "Alle",
    "gui.loader.message1": "Lager klosser...",
    "gui.loader.message2": "Laster figurer...",
    "gui.loader.message3": "Laster inn lyder...",
    "gui.loader.message4": "Laster inn tilleggsfunksjoner...",
    "gui.loader.message5": "Gjeter katter...",
    "gui.loader.message6": "Sender nanoer...",
    "gui.loader.message7": "Setter opp goboer...",
    "gui.loader.message8": "Henter emoji...",
    "gui.loader.headline": "Laster prosjekt",
    "gui.loader.creating": "Oppretter prosjekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Mine ting",
    "gui.accountMenu.myClasses": "Mine klasser",
    "gui.accountMenu.myClass": "Min klasse",
    "gui.accountMenu.accountSettings": "Brukerinnstillinger",
    "gui.accountMenu.signOut": "Logg ut",
    "gui.authorInfo.byUser": "av {username}",
    "gui.menuBar.seeProjectPage": "Se prosjektsiden",
    "gui.menuBar.language": "Språk",
    "general.username": "Brukernavn",
    "general.password": "Passord",
    "general.signIn": "Logg inn",
    "login.needHelp": "Trenger du hjelp?",
    "form.validationRequired": "Dette feltet må fylles ut",
    "gui.menuBar.tutorialsLibrary": "Veiledninger",
    "gui.menuBar.restoreSprite": "Angle sletting av figur",
    "gui.menuBar.restoreSound": "Angre sletting av lyd",
    "gui.menuBar.restoreCostume": "Angre sletting av drakt",
    "gui.menuBar.restore": "Angre sletting",
    "gui.menuBar.saveNow": "Lagre nå",
    "gui.menuBar.saveAsCopy": "Lagre som kopi",
    "gui.menuBar.remix": "Remiks",
    "gui.menuBar.new": "Ny",
    "gui.menuBar.file": "Fil",
    "gui.menuBar.downloadToComputer": "Lagre på datamaskinen",
    "gui.menuBar.edit": "Rediger",
    "gui.menuBar.turboModeOff": "Skru av turbofart",
    "gui.menuBar.turboModeOn": "Skru på turbofart",
    "gui.menuBar.modeMenu": "AVANSERT",
    "gui.menuBar.normalMode": "Normalt",
    "gui.menuBar.caturdayMode": "Kattastrofalt",
    "gui.menuBar.joinScratch": "Bli Scratch-bruker",
    "gui.menuBar.signIn": "Logg inn",
    "gui.gui.projectTitlePlaceholder": "Prosjektets navn her",
    "gui.menuBar.saveNowLink": "Lagre nå",
    "gui.menuBar.settings": "Innstillinger",
    "gui.menuBar.isShared": "Lagt ut",
    "gui.menuBar.share": "Legg ut",
    "gui.menuBar.colorMode": "Farger",
    "gui.modal.help": "Hjelp",
    "gui.modal.back": "Tilbake",
    "gui.monitor.listMonitor.empty": "(tom)",
    "gui.monitor.listMonitor.listLength": "lengde {length}",
    "gui.monitor.contextMenu.default": "vanlig visning",
    "gui.monitor.contextMenu.large": "stor visning",
    "gui.monitor.contextMenu.slider": "skyveknapp",
    "gui.monitor.contextMenu.sliderRange": "endre verdiområde",
    "gui.monitor.contextMenu.import": "importer",
    "gui.monitor.contextMenu.export": "Eksporter",
    "gui.monitor.contextMenu.hide": "skjul",
    "gui.playButton.play": "Spill av",
    "gui.playButton.stop": "Stopp",
    "gui.gui.variableScopeOptionAllSprites": "For alle figurer",
    "gui.gui.variableScopeOptionSpriteOnly": "For denne figuren",
    "gui.gui.cloudVariableOption": "Nettvariabel (lagret på nettstedet til Scratch)",
    "gui.gui.variablePromptAllSpritesMessage": "Denne variabelen kan brukes av alle figurer",
    "gui.gui.listPromptAllSpritesMessage": "Alle figurer har tilgang til denne listen.",
    "gui.prompt.cancel": "Avbryt",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stopp",
    "gui.playbackStep.playMsg": "Spill av",
    "gui.playbackStep.loadingMsg": "Laster...",
    "gui.playbackStep.saveMsg": "Lagre",
    "gui.playbackStep.reRecordMsg": "Spill inn igjen",
    "gui.recordModal.title": "Spill inn lyd",
    "gui.recordingStep.beginRecord": "Klikk på knappen nedenfor for å starte opptak",
    "gui.recordingStep.permission": "{arrow}Du må godkjenne at Scratch bruker mikrofonen",
    "gui.recordingStep.stop": "Stopp opptak",
    "gui.recordingStep.record": "Spill inn lyd",
    "gui.sliderModal.min": "Laveste verdi",
    "gui.sliderModal.max": "Høyeste verdi",
    "gui.sliderModal.title": "Endre verdiområde",
    "gui.sliderPrompt.cancel": "Avbryt",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Lyd",
    "gui.soundEditor.play": "Spill av",
    "gui.soundEditor.stop": "Stopp",
    "gui.soundEditor.copy": "Kopier",
    "gui.soundEditor.paste": "Lim inn",
    "gui.soundEditor.copyToNew": "Kopi til ny",
    "gui.soundEditor.delete": "Slett",
    "gui.soundEditor.save": "Lagre",
    "gui.soundEditor.undo": "Angre",
    "gui.soundEditor.redo": "Gjør igjen",
    "gui.soundEditor.faster": "Raskere",
    "gui.soundEditor.slower": "Saktere",
    "gui.soundEditor.echo": "Ekko",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Høyere lyd",
    "gui.soundEditor.softer": "Svakere lyd",
    "gui.soundEditor.reverse": "Baklengs",
    "gui.soundEditor.fadeOut": "Ton ut",
    "gui.soundEditor.fadeIn": "Ton inn",
    "gui.soundEditor.mute": "Stille",
    "gui.SpriteInfo.spritePlaceholder": "Figurens navn",
    "gui.SpriteInfo.showSpriteAction": "Vis figuren",
    "gui.SpriteInfo.hideSpriteAction": "Skjul figuren",
    "gui.SpriteInfo.sprite": "Figur",
    "gui.SpriteInfo.show": "Vis",
    "gui.SpriteInfo.size": "Størrelse",
    "gui.spriteSelectorItem.contextMenuDuplicate": "lag en kopi",
    "gui.spriteSelectorItem.contextMenuExport": "eksport",
    "gui.spriteSelectorItem.contextMenuDelete": "slett",
    "gui.spriteSelector.addSpriteFromLibrary": "Velg en figur",
    "gui.spriteSelector.addSpriteFromPaint": "Tegn",
    "gui.spriteSelector.addSpriteFromSurprise": "Overraskelse",
    "gui.spriteSelector.addSpriteFromFile": "Last opp figur",
    "gui.stageHeader.stageSizeLarge": "Bytt til stor scene",
    "gui.stageHeader.stageSizeSmall": "Bytt til liten scene",
    "gui.stageHeader.stageSizeFull": "Gå til fullskjerm",
    "gui.stageHeader.stageSizeUnFull": "Avslutt fullskjerm",
    "gui.stageHeader.fullscreenControl": "Fullskjerm av/på",
    "gui.spriteSelector.addBackdropFromLibrary": "Velg et bakgrunnsbilde",
    "gui.stageSelector.addBackdropFromPaint": "Tegn",
    "gui.stageSelector.addBackdropFromSurprise": "Overraskelse",
    "gui.stageSelector.addBackdropFromFile": "Last opp bakgrunn",
    "gui.stageSelector.stage": "Scene",
    "gui.stageSelector.backdrops": "Bakgrunner",
    "gui.telemetryOptIn.label": "Send statistikk for å forbedre Scratch",
    "gui.telemetryOptIn.body1": "Scratch-gruppen studerer hvordan Scratch brukes rundt i verden. Du kan bidra ved å la Scratch automatisk sende inn statistikk over hvordan du bruker Scratch.",
    "gui.telemetryOptIn.body2": "Informasjonen som samles inn inn er blant annet hvilket språk du bruker Scartch på, hvilke klosser du bruker, og registrering av handlinger som for eksempel lagring, åpning og opplasting av prosjekter. Vi samler IKKE inn personinformasjon. Se {privacyPolicyLink} for mer informasjon.",
    "gui.telemetryOptIn.privacyPolicyLink": "Personvern",
    "gui.telemetryOptIn.optInText": "La Scratch-administratorene få tilgang til mine bruksdata",
    "gui.telemetryOptIn.optInTooltip": "Godta innsamling av statistiske bruksdata",
    "gui.telemetryOptIn.optOutText": "Ikke del mine bruksdata med Scratch-administratorene.",
    "gui.telemetryOptIn.optOutTooltip": "Slå av innsamling av statistiske bruksdata",
    "gui.telemetryOptIn.settingWasUpdated": "Dine valg er oppdatert.",
    "gui.telemetryOptIn.buttonClose": "Lukk",
    "gui.turboMode.active": "Turbo-hastighet",
    "gui.webglModal.label": "Nettleseren støtter ikke WebGL",
    "gui.webglModal.description": "Dessverre ser det ut til at din nettleser {webGlLink} som er nødvendig for Scratch 3.0.",
    "gui.webglModal.webgllink": "ikke støtter WebGL",
    "gui.webglModal.back": "Tilbake",
    "gui.webglModal.previewfaq": "Du finner mer informasjon under {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Spørsmål og svar",
    "gui.costumeLibrary.chooseABackdrop": "Velg et bakgrunnsbilde",
    "gui.costumeLibrary.chooseACostume": "Velg en drakt",
    "gui.costumeTab.addBackdropFromLibrary": "Velg et bakgrunnsbilde",
    "gui.costumeTab.addCostumeFromLibrary": "Velg en drakt",
    "gui.costumeTab.addBlankCostume": "Tegn",
    "gui.costumeTab.addSurpriseCostume": "Overraskelse",
    "gui.costumeTab.addFileBackdrop": "Last opp bakgrunn",
    "gui.costumeTab.addFileCostume": "Last opp drakt",
    "gui.extensionLibrary.chooseAnExtension": "Velg en tilleggsfunksjon",
    "gui.extensionLibrary.extensionUrl": "Skriv inn URL til tilleggsfunksjonen",
    "gui.monitors.importListColumnPrompt": "Hvilken kolonne skal brukes (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Feil ved start av innspilling",
    "gui.soundLibrary.chooseASound": "Velg en lyd",
    "gui.soundTab.fileUploadSound": "Last opp en lyd",
    "gui.soundTab.surpriseSound": "Overraskelse",
    "gui.soundTab.recordSound": "Spill inn lyd",
    "gui.soundTab.addSoundFromLibrary": "Velg en lyd",
    "gui.spriteLibrary.chooseASprite": "Velg en figur",
    "gui.tipsLibrary.tutorials": "Velg en veiledning",
    "gui.alerts.createsuccess": "Nytt prosjekt opprettet",
    "gui.alerts.createcopysuccess": "Prosjektet er lagret som kopi",
    "gui.alerts.createremixsuccess": "Prosjektet er lagret som remiks.",
    "gui.alerts.creating": "Oppretter...",
    "gui.alerts.creatingCopy": "Kopierer prosjektet...",
    "gui.alerts.creatingRemix": "Remikser prosjektet...",
    "gui.alerts.creatingError": "Noe gikk feil. Prøv å opprette nytt prosjekt igjen.",
    "gui.alerts.savingError": "Noe gikk feil ved lagring av prosjektet.",
    "gui.alerts.savesuccess": "Prosjektet er lagret.",
    "gui.alerts.saving": "Lagrer prosjektet...",
    "gui.alerts.cloudInfo": "Merk at nettvariabler kan bare lagre tall, ikke bokstaver eller symboler. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Les mer.",
    "gui.alerts.importing": "Importerer …",
    "gui.defaultProject.meow": "Mjau",
    "gui.defaultProject.variable": "min variabel",
    "gui.howtos.intro-move-sayhello-hat.name": "Kom i gang",
    "gui.howtos.intro-move.step_stepMove": "Legg til en gå-kloss",
    "gui.howtos.add-a-move-block.step_stepSay": "Legg til en \"si\"-kloss",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Start ved å klikke det grønne flagget",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animasjon med et navn",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Velg en bokstavfigur",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spill en lyd når den klikkes",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Velg en ny bokstavfigur",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Bytt farge",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Velg en ny bokstavfigur, la den rotere",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Velg en ny bokstavfigur og la den vokse",
    "gui.howtos.imagine": "Fantasiverden",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Skriv det figuren skal si",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klikk flagget for å starte",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Velg en bakgrunn",
    "gui.howtos.imagine.step_imagineChooseSprite": "Velg en figur",
    "gui.howtos.imagine.step_imagineFlyAround": "Trykk mellomrom for å gli bortover",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Velg en annen figur",
    "gui.howtos.imagine.step_imagineLeftRight": "Flytt sideveis",
    "gui.howtos.imagine.step_imagineUpDown": "Flytt opp og ned",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Bytt drakt",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Gli til et punkt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Større og mindre",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Velg en annen bakgrunn",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Bytt bakgrunn",
    "gui.howtos.imagine.step_imagineRecordASound": "Legg på lyd",
    "gui.howtos.imagine.step_imagineChooseSound": "Velg en lyd",
    "gui.howtos.make-music.name": "Lag musikk",
    "gui.howtos.Make-Music.step_PickInstrument": "Velg en instrumentfigur",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spill en lyd når den klikkes",
    "gui.howtos.Make-Music.step_MakeSong": "Lag musikk",
    "gui.howtos.make-music.step_MakeBeat": "Velg instrument og lag rytme",
    "gui.howtos.make-music.step_MakeBeatBox": "Velg mikrofonfigur og tilfeldig rytme",
    "gui.howtos.story.name": "Lag en fortelling",
    "gui.howtos.story.step_addbg": "Legg til en bakgrunn",
    "gui.howtos.story.step_addsprite": "Legg til en figur",
    "gui.howtos.story.step_saysomething": "Si noe",
    "gui.howtos.story.step_addanothersprite": "Legg til en ny figur",
    "gui.howtos.story.step_flip": "Bytt retning",
    "gui.howtos.story.step_conversation": "En samtale",
    "gui.howtos.story.addanotherbg": "Legg til en ny bakgrunn",
    "gui.howtos.story.step_swithbg": "Bytt bakgrunn",
    "gui.howtos.story.step_hidewizard": "Skjul en figur",
    "gui.howtos.story.step_showwizard": "Vis en figur",
    "gui.howtos.make-a-chase-game.name": "Lag et jaktspill",
    "gui.howtos.Chase-Game.step_BG": "Legg på en bakgrunn",
    "gui.howtos.chase-game.step_AddOcto": "Legg til en ny figur",
    "gui.howtos.make-music.step_LeftRight": "Flytt sideveis med piltastene",
    "gui.howtos.Chase-Game.step_UpDown": "Flytt opp og ned med piltastene",
    "gui.howtos.Chase-Game.step_AddStar": "Legg til en ny figur",
    "gui.howtos.Chase-Game.step_MoveRandom": "Tilfeldig bevegelse",
    "gui.howtos.Chase-Game.step_WhenTouch": "Få blekkspruten til å lage lyd ved berøring",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Lag en poengvariabel",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Legg til poeng når blekkspruten berøres",
    "gui.howtos.animate-char.name": "Animasjon av en figur",
    "gui.howtos.animate-char.step_addbg": "Legg til en bakgrunn",
    "gui.howtos.animate-char.step_addsprite": "Legg til en ny figur",
    "gui.howtos.animate-char.step_saysomething": "Si noe",
    "gui.howtos.animate-char.step_addsound": "Legg på lyd",
    "gui.howtos.animate-char.step_animatetalking": "Animasjon av snakking",
    "gui.howtos.animate-char.step_arrowkeys": "Bevegelse med piltastene",
    "gui.howtos.animate-char.step_jump": "Hopp",
    "gui.howtos.animate-char.step_changecolor": "Bytt farge",
    "gui.howtos.make-a-game.name": "Lag et klikkespill",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Velg en figur",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spill en lyd når den klikkes",
    "gui.howtos.make-a-game.step_GameAddScore": "Lag en poengvariabel",
    "gui.howtos.make-a-game.step_GameChangeScore": "Tell opp poeng ved klikk",
    "gui.howtos.make-a-game.step_Random": "Gå til et tilfeldig sted",
    "gui.howtos.make-music.step_GameChangeColor": "Bytt farge",
    "gui.howtos.make-music.step_ResetScore": "Nullstill poeng",
    "gui.howtos.make-it-fly.name": "Få den til å fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Velg en himmelbakgrunn",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Velg deg en figur",
    "gui.howtos.fly.step_stepflySaySomething": "Si noe",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Flytt med piltastene",
    "gui.howtos.fly.step_stepflyChooseObject": "Velg en ting som gir poeng",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Få tingen til å bevege seg",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Velg en figur",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Tell poeng",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Tell poeng",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Lag landskapet",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Bevegelig bakgrunn",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Neste drakt",
    "gui.howtos.pong": "Ballspillet Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Legg til en bakgrunn",
    "gui.howtos.pong.step_pongAddBallSprite": "Legg til en ball",
    "gui.howtos.pong.step_pongBounceAround": "Sprett omkring",
    "gui.howtos.pong.step_pongAddPaddle": "Legg til en racket",
    "gui.howtos.pong.step_pongMoveThePaddle": "Flytt racketen",
    "gui.howtos.pong.step_pongSelectBallSprite": "Velg ball-figuren",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Lag kode for å sprette ballen på racketen",
    "gui.howtos.pong.step_pongAddAScore": "Tell poeng",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Velg 'poeng' i menyen",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Sett inn en 'endre poeng'-kloss",
    "gui.howtos.pong.step_pongResetScore": "Nullstill poeng",
    "gui.howtos.pong.step_pongAddLineSprite": "Legg inn en kantlinje",
    "gui.howtos.pong.step_pongGameOver": "Slutt",
    "gui.howtos.code-cartoon": "Lag en tegneserie",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Si noe når flagget klikkes",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Figur som beveger seg når du klikker den",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Velg en annen figur",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Bruk minustegn for å gjøre figuren mindre",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Få figuren til å bli større eller mindre",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Velg en annen figur",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hopp opp og ned",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klikk en figur for å bytte bilde",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Gli omkring",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Bytt drakt",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Legg til nye figurer i tegneserien",
    "gui.howtos.cartoon-network": "Lag et eventyrspill med animasjon",
    "gui.howtos.cartoon-network.step_CNcharacter": "Velg figuren som skal vises",
    "gui.howtos.cartoon-network.step_CNsay": "Si noe",
    "gui.howtos.cartoon-network.step_CNglide": "Gli omkring",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Velg en ting å jakte på",
    "gui.howtos.cartoon-network.step_CNcollect": "Samle opp ting",
    "gui.howtos.cartoon-network.step_CNvariable": "Lag en poengvariabel",
    "gui.howtos.cartoon-network.step_CNscore": "Tell poeng",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Neste nivå: Ny bakgrunn",
    "gui.howtos.videosens.name": "Sansing med kamera",
    "gui.howtos.videosens.step_addextension": "Hent tilleggsfunksjon",
    "gui.howtos.videosens.step_pet": "Klapp katten",
    "gui.howtos.videosens.step_animate": "Animasjon",
    "gui.howtos.videosens.step_pop": "Sprekk en ballong",
    "gui.howtos.say-it-out-loud": "Lag animasjoner som snakker",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Hent klosser for tekst til tale",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Si noe",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Velg en stemme",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Flytt omkring",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Legg på en bakgrunn",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Legg til en ny figur",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Syng en sang",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Bytt farge",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Snurr rundt",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Større og mindre",
    "gui.howtos.talking": "Talende historier",
    "gui.howtos.talking.step_talesAddExtension": "Klikk for å legge til \"Tekst til tale\"-klossene",
    "gui.howtos.talking.step_talesChooseSprite": "Velg en figur",
    "gui.howtos.talking.step_talesSaySomething": "Få en figur til å snakke",
    "gui.howtos.talking.step_talesChooseBackdrop": "Velg et bakgrunnsbilde",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klikk en figur for å gå til neste bakgrunn",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Velg en annen figur",
    "gui.howtos.talking.step_talesMoveAround": "Flytt omkring",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Velg en annen bakgrunn",
    "gui.howtos.talking.step_talesAnimateTalking": "Animasjon av snakking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Velg en annen bakgrunn",
    "gui.howtos.talking.step_talesChooseSound": "Velg en sang å danse til",
    "gui.howtos.talking.step_talesDanceMoves": "Lag en dans",
    "gui.howtos.talking.step_talesAskAnswer": "Hent klossene for spørsmål og svar fra kategorien Sansing",
    "gui.howtos.add-sprite.name": "Legg til en ny figur",
    "gui.howtos.add-sprite.step_addSprite": "Legg til en ny figur",
    "gui.howtos.add-a-backdrop.name": "Legg på en bakgrunn",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Legg til en bakgrunn",
    "gui.howtos.change-size.name": "Endre størrelse",
    "gui.howtos.change-size.step_changeSize": "Endre størrelse",
    "gui.howtos.glide-around.name": "Gli omkring",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Gli omkring",
    "gui.howtos.change-size.step_glideAroundPoint": "Gli til et punkt",
    "gui.howtos.record-a-sound.name": "Ta opp en lyd",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klikk på 'lyder'-fanen",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikk 'ta opp'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Klikk på opptaksknappen",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Velg den nye lyden",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spill lyden",
    "gui.howtos.spin-video.name": "Få den til å snurre",
    "gui.howtos.change-size.step_spinTurn": "Snu",
    "gui.howtos.change-size.step_spinPointInDirection": "Bestem retning",
    "gui.howtos.hide-and-show.name": "Skjul og vis",
    "gui.howtos.change-size.step_hideAndShow": "Skjul og vis",
    "gui.howtos.switch-costume.name": "Animasjon av en figur",
    "gui.howtos.change-size.step_switchCostumes": "Animasjon av en figur",
    "gui.howtos.move-around-with-arrow-keys.name": "Bruk piltastene",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Flytt høyre og venstre",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Flytt opp og ned",
    "gui.howtos.add-effects.name": "Grafiske effekter",
    "gui.howtos.videosens.step_addEffects": "Grafiske effekter",
    "gui.extension.music.name": "Musikk",
    "gui.extension.music.description": "Spill instrumenter",
    "gui.extension.pen.name": "Penn",
    "gui.extension.pen.description": "Få figurene til å tegne",
    "gui.extension.videosensing.name": "Sansing med kamera",
    "gui.extension.videosensing.description": "La kameraet sanse bevegelser",
    "gui.extension.text2speech.name": "Tekst til tale",
    "gui.extension.text2speech.description": "Lag prosjekter som snakker",
    "gui.extension.translate.name": "Oversette",
    "gui.extension.translate.description": "Oversett tekst til andre språk",
    "gui.extension.makeymakey.description": "Bruk hva som helst som tastatur",
    "gui.extension.microbit.description": "Koble prosjektet ditt til den fysiske verden",
    "gui.extension.microbit.connectingMessage": "Kobler til",
    "gui.extension.ev3.description": "Lag interaktive roboter og maskiner",
    "gui.extension.ev3.connectingMessage": "Kobler til. Pass på at PIN-koden på din EV3 er satt til 1234.",
    "gui.extension.boost.description": "Lag liv i Lego-roboter.",
    "gui.extension.boost.connectingMessage": "Kobler til",
    "gui.extension.wedo2.description": "Bygg med motorer og sensorer",
    "gui.extension.wedo2.connectingMessage": "Kobler til",
    "gui.extension.gdxfor.description": "Sensor for kraft, bevegelse og rotasjon.",
    "gui.extension.gdxfor.connectingMessage": "Kobler til",
    "gui.libraryTags.all": "Alt",
    "gui.libraryTags.animals": "Dyr",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Effekter",
    "gui.libraryTags.fantasy": "Fantasi",
    "gui.libraryTags.fashion": "Mote",
    "gui.libraryTags.food": "Mat",
    "gui.libraryTags.indoors": "Innendørs",
    "gui.libraryTags.loops": "Musikkloop",
    "gui.libraryTags.music": "Musikk",
    "gui.libraryTags.notes": "Noter",
    "gui.libraryTags.outdoors": "Utendørs",
    "gui.libraryTags.patterns": "Mønstre",
    "gui.libraryTags.people": "Mennesker",
    "gui.libraryTags.percussion": "Slaginstrumenter",
    "gui.libraryTags.space": "Romfart",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Under vann",
    "gui.libraryTags.voice": "Stemme",
    "gui.libraryTags.wacky": "Rart",
    "gui.libraryTags.animation": "Animasjon",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Spill",
    "gui.libraryTags.stories": "Fortellinger",
    "gui.libraryTags.letters": "Bokstaver",
    "gui.opcodeLabels.direction": "retning",
    "gui.opcodeLabels.xposition": "x-posisjon",
    "gui.opcodeLabels.yposition": "y-posisjon",
    "gui.opcodeLabels.size": "størrelse",
    "gui.opcodeLabels.costumename": "draktnavn",
    "gui.opcodeLabels.costumenumber": "draktnummer",
    "gui.opcodeLabels.backdropname": "navn på bakgrunn",
    "gui.opcodeLabels.backdropnumber": "bakgrunnsnummer",
    "gui.opcodeLabels.volume": "volum",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "svar",
    "gui.opcodeLabels.loudness": "lydnivå",
    "gui.opcodeLabels.username": "brukernavn",
    "gui.opcodeLabels.year": "år",
    "gui.opcodeLabels.month": "måned",
    "gui.opcodeLabels.date": "dato",
    "gui.opcodeLabels.dayofweek": "ukedag",
    "gui.opcodeLabels.hour": "time",
    "gui.opcodeLabels.minute": "minutt",
    "gui.opcodeLabels.second": "sekund",
    "gui.opcodeLabels.timer": "sekundklokke",
    "gui.projectLoader.loadError": "Den valgte prosjektfilen kunne ikke lastes inn.",
    "gui.sharedMessages.backdrop": "bakgrunn{index}",
    "gui.sharedMessages.costume": "drakt{index}",
    "gui.sharedMessages.sprite": "Figur{index}",
    "gui.sharedMessages.pop": "plopp",
    "gui.sharedMessages.replaceProjectWarning": "Starte på nytt uten å lagre?",
    "gui.sharedMessages.loadFromComputerTitle": "Last opp fra datamaskinen",
    "gui.theme.default": "Vanlig",
    "gui.theme.dark": "Mørk",
    "gui.theme.highContrast": "Ekstra tydelig",
    "gui.gui.defaultProjectTitle": "Mitt Scratch-prosjekt",
    "boost.color.any": "hvilken som helst",
    "boost.color.black": "svart",
    "boost.color.blue": "blå",
    "boost.color.green": "grønn",
    "boost.color.red": "rød",
    "boost.color.white": "hvit",
    "boost.color.yellow": "gul",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] posisjon",
    "boost.getTiltAngle": "helningsvinkel [TILT_DIRECTION]",
    "boost.motorDirection.backward": "den andre veien",
    "boost.motorDirection.forward": "den ene veien",
    "boost.motorDirection.reverse": "bytt retning",
    "boost.motorOff": "skru av motor [MOTOR_ID]",
    "boost.motorOn": "skru på motor [MOTOR_ID]",
    "boost.motorOnFor": "kjør motor [MOTOR_ID] i [DURATION] sekunder",
    "boost.motorOnForRotation": "kjør motor [MOTOR_ID] rundt [ROTATION] rotasjoner",
    "boost.seeingColor": "ser [COLOR] kloss?",
    "boost.setLightHue": "sett lysfarge [HUE]",
    "boost.setMotorDirection": "velg motor [MOTOR_ID] retning [MOTOR_DIRECTION]",
    "boost.setMotorPower": "sett motor [MOTOR_ID] fart til [POWER] %",
    "boost.tiltDirection.any": "hvilken som helst",
    "boost.tiltDirection.down": "ned",
    "boost.tiltDirection.left": "venstre",
    "boost.tiltDirection.right": "høyre",
    "boost.tiltDirection.up": "opp",
    "boost.whenColor": "når [COLOR] kloss sett",
    "boost.whenTilted": "når helning [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tone [NOTE] i [TIME] sekunder",
    "ev3.buttonPressed": "knapp [PORT] trykket?",
    "ev3.getBrightness": "lysstyrke",
    "ev3.getDistance": "avstand",
    "ev3.getMotorPosition": "motor [PORT] vinkel",
    "ev3.motorSetPower": "motor [PORT] sett fart [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] kjør den ene veien i [TIME] sekunder",
    "ev3.motorTurnCounterClockwise": "motor [PORT] kjør den andre veien i [TIME] sekunder",
    "ev3.whenBrightnessLessThan": "når lysnivå < [DISTANCE]",
    "ev3.whenButtonPressed": "når knapp [PORT] trykkes",
    "ev3.whenDistanceLessThan": "når avstand < [DISTANCE]",
    "gdxfor.getAcceleration": "akselerasjon [DIRECTION]",
    "gdxfor.getForce": "kraft",
    "gdxfor.getSpin": "rotasjonsfart [DIRECTION]",
    "gdxfor.getTilt": "helningsvinkel [TILT]",
    "gdxfor.isFreeFalling": "fritt fall",
    "gdxfor.isTilted": "heller [TILT]?",
    "gdxfor.pulled": "trekkes",
    "gdxfor.pushed": "dyttes",
    "gdxfor.shaken": "ristet",
    "gdxfor.startedFalling": "begynner å falle",
    "gdxfor.tiltDirectionMenu.any": "hvilken som helst",
    "gdxfor.tiltDirectionMenu.back": "bakover",
    "gdxfor.tiltDirectionMenu.front": "framover",
    "gdxfor.tiltDirectionMenu.left": "venstre",
    "gdxfor.tiltDirectionMenu.right": "høyre",
    "gdxfor.turnedFaceDown": "vender forsiden ned",
    "gdxfor.turnedFaceUp": "vender forsiden opp",
    "gdxfor.whenForcePushedOrPulled": "når kraftsensoren [PUSH_PULL]",
    "gdxfor.whenGesture": "når [GESTURE]",
    "gdxfor.whenTilted": "ved helning [TILT]",
    "makeymakey.downArrow": "pil ned",
    "makeymakey.downArrowShort": "ned",
    "makeymakey.leftArrow": "pil venstre",
    "makeymakey.leftArrowShort": "venstre",
    "makeymakey.rightArrow": "pil høyre",
    "makeymakey.rightArrowShort": "høyre",
    "makeymakey.spaceKey": "mellomrom",
    "makeymakey.upArrow": "pil opp",
    "makeymakey.upArrowShort": "opp",
    "makeymakey.whenKeyPressed": "når [KEY] trykkes",
    "makeymakey.whenKeysPressedInOrder": "når [SEQUENCE] trykkes i rekkefølge",
    "microbit.buttonsMenu.any": "hvilken som helst",
    "microbit.clearDisplay": "tøm skjermen",
    "microbit.defaultTextToDisplay": "Hei!",
    "microbit.displaySymbol": "vis bilde [MATRIX]",
    "microbit.displayText": "vis tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "hoppet",
    "microbit.gesturesMenu.moved": "flyttet",
    "microbit.gesturesMenu.shaken": "ristet",
    "microbit.isButtonPressed": "[BTN] knapp trykket?",
    "microbit.isTilted": "helning [DIRECTION]?",
    "microbit.pinStateMenu.off": "av",
    "microbit.pinStateMenu.on": "på",
    "microbit.tiltAngle": "helningsvinkel [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "hvilken som helst",
    "microbit.tiltDirectionMenu.back": "bakover",
    "microbit.tiltDirectionMenu.front": "forover",
    "microbit.tiltDirectionMenu.left": "venstre",
    "microbit.tiltDirectionMenu.right": "høyre",
    "microbit.whenButtonPressed": "når [BTN] knapp trykkes",
    "microbit.whenGesture": "når [GESTURE]",
    "microbit.whenPinConnected": "når kontakt [PIN] trykkes",
    "microbit.whenTilted": "når helning [DIRECTION]",
    "music.categoryName": "Musikk",
    "music.changeTempo": "endre tempo med [TEMPO]",
    "music.drumBass": "(2) Stortromme",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Pinner",
    "music.drumClosedHiHat": "(6) Lukket hi-hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Kubjelle",
    "music.drumCrashCymbal": "(4) Crash cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Håndklapp",
    "music.drumOpenHiHat": "(5) Åpen hi-hat",
    "music.drumSideStick": "(3) Kantslag",
    "music.drumSnare": "(1) Skarptromme",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Treblokk",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Kontrabass",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Kor",
    "music.instrumentClarinet": "(10) Klarinett",
    "music.instrumentElectricGuitar": "(5) Elektrisk gitar",
    "music.instrumentElectricPiano": "(2) Elektrisk piano",
    "music.instrumentFlute": "(12) Fløyte",
    "music.instrumentGuitar": "(4) Gitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Spilledåse",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Steel drum",
    "music.instrumentSynthLead": "(20) Synth",
    "music.instrumentSynthPad": "(21) Synth-akkord",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Blokkfløyte",
    "music.midiPlayDrumForBeats": "trommeslag [DRUM] som varer [BEATS] taktslag",
    "music.midiSetInstrument": "velg instrument [INSTRUMENT]",
    "music.playDrumForBeats": "trommeslag [DRUM] som varer [BEATS] taktslag",
    "music.playNoteForBeats": "spill tone [NOTE] som varer [BEATS] taktslag",
    "music.restForBeats": "pause i [BEATS] taktslag",
    "music.setInstrument": "velg instrument [INSTRUMENT]",
    "music.setTempo": "sett tempo til [TEMPO]",
    "pen.categoryName": "Penn",
    "pen.changeColorParam": "endre pennens [COLOR_PARAM] med [VALUE]",
    "pen.changeHue": "endre pennfarge med [HUE]",
    "pen.changeShade": "endre pennens lysstyrke med [SHADE]",
    "pen.changeSize": "endre pennens bredde med [SIZE]",
    "pen.clear": "slett alt",
    "pen.colorMenu.brightness": "lysstyrke",
    "pen.colorMenu.color": "farge",
    "pen.colorMenu.saturation": "fargemetning",
    "pen.colorMenu.transparency": "gjennomsiktighet",
    "pen.penDown": "penn på",
    "pen.penUp": "penn av",
    "pen.setColor": "sett pennfarge til [COLOR]",
    "pen.setColorParam": "sett pennens [COLOR_PARAM] til [VALUE]",
    "pen.setHue": "sett pennens farge til [HUE]",
    "pen.setShade": "sett pennens lysstyrke til [SHADE]",
    "pen.setSize": "sett pennbredde til [SIZE]",
    "pen.stamp": "stemple avtrykk",
    "speech.defaultWhenIHearValue": "hør her",
    "speech.extensionName": "Tale til tekst",
    "speech.listenAndWait": "lytt og vent",
    "speech.speechReporter": "tale",
    "speech.whenIHear": "når jeg hører [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Tekst til tale",
    "text2speech.defaultTextToSpeak": "hei",
    "text2speech.giant": "kjempe",
    "text2speech.kitten": "kattunge",
    "text2speech.setLanguageBlock": "velg språk [LANGUAGE]",
    "text2speech.setVoiceBlock": "velg stemme [VOICE]",
    "text2speech.speakAndWaitBlock": "si [WORDS]",
    "text2speech.squeak": "knirk",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Oversette",
    "translate.defaultTextToTranslate": "hei",
    "translate.translateBlock": "oversett [WORDS] til [LANGUAGE]",
    "translate.viewerLanguage": "språk",
    "videoSensing.categoryName": "Sansing med kamera",
    "videoSensing.direction": "retning",
    "videoSensing.motion": "bevegelse",
    "videoSensing.off": "av",
    "videoSensing.on": "på",
    "videoSensing.onFlipped": "på speilvendt",
    "videoSensing.setVideoTransparency": "sett [TRANSPARENCY] gjennomsiktighet av video",
    "videoSensing.sprite": "figur",
    "videoSensing.stage": "scene",
    "videoSensing.videoOn": "video [ATTRIBUTE] på [SUBJECT]",
    "videoSensing.videoToggle": "sett video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "når videobevegelse > [REFERENCE]",
    "wedo2.getDistance": "avstand",
    "wedo2.getTiltAngle": "helningsvinkel [TILT_DIRECTION]",
    "wedo2.isTilted": "helning [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "den ene veien",
    "wedo2.motorDirection.forward": "den andre veien",
    "wedo2.motorDirection.reverse": "snu",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motorer",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "skru av [MOTOR_ID]",
    "wedo2.motorOn": "skru på [MOTOR_ID]",
    "wedo2.motorOnFor": "skru på [MOTOR_ID] i [DURATION] sekunder",
    "wedo2.playNoteFor": "spill tone [NOTE] i [DURATION] sekunder",
    "wedo2.setLightHue": "sett lysfarge [HUE]",
    "wedo2.setMotorDirection": "velg [MOTOR_ID] retning [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "sett [MOTOR_ID] fart [POWER]",
    "wedo2.tiltDirection.any": "hvilken som helst",
    "wedo2.tiltDirection.down": "ned",
    "wedo2.tiltDirection.left": "venstre",
    "wedo2.tiltDirection.right": "høyre",
    "wedo2.tiltDirection.up": "opp",
    "wedo2.whenDistance": "når avstand [OP] [REFERENCE]",
    "wedo2.whenTilted": "når helning [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Farge",
    "paint.paintEditor.saturation": "Fargemetning",
    "paint.paintEditor.brightness": "Lysstyrke",
    "paint.paintEditor.costume": "Drakt",
    "paint.paintEditor.group": "Gruppér",
    "paint.paintEditor.ungroup": "Del opp gruppe",
    "paint.paintEditor.undo": "Angre",
    "paint.paintEditor.redo": "Gjør igjen",
    "paint.paintEditor.forward": "Flytt frem",
    "paint.paintEditor.backward": "Flytt tilbake",
    "paint.paintEditor.front": "Foran alt",
    "paint.paintEditor.back": "Tilbake",
    "paint.paintEditor.more": "Flere",
    "paint.modeTools.brushSize": "Størrelse",
    "paint.modeTools.eraserSize": "Viskelærbredde",
    "paint.modeTools.copy": "Kopier",
    "paint.modeTools.paste": "Lim inn",
    "paint.modeTools.delete": "Slett",
    "paint.modeTools.curved": "Glatt",
    "paint.modeTools.pointed": "Skarp",
    "paint.modeTools.thickness": "Tykkelse",
    "paint.modeTools.flipHorizontal": "Speilvend",
    "paint.modeTools.flipVertical": "Opp ned",
    "paint.modeTools.filled": "Fylt",
    "paint.modeTools.outlined": "Omriss",
    "paint.paintEditor.bitmap": "Gå til pikselgrafikk",
    "paint.paintEditor.vector": "Gjør om til vektorgrafikk",
    "paint.paintEditor.fill": "Fyll",
    "paint.paintEditor.stroke": "Kant",
    "paint.brushMode.brush": "Malepensel",
    "paint.eraserMode.eraser": "Viskelær",
    "paint.fillMode.fill": "Fyll",
    "paint.lineMode.line": "Linje",
    "paint.ovalMode.oval": "Sirkel",
    "paint.rectMode.rect": "Rektangel",
    "paint.reshapeMode.reshape": "Bøy",
    "paint.roundedRectMode.roundedRect": "Avrundet rektangel",
    "paint.selectMode.select": "Velg",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Bytt"
  },
  "nn": {
    "gui.alerts.lostPeripheralConnection": "Scratch mista sambandet til {extensionName}.",
    "gui.alerts.tryAgain": "Prøv på nytt",
    "gui.alerts.download": "Last ned",
    "gui.connection.reconnect": "Kopla til på nytt",
    "gui.backpack.costumeLabel": "drakt",
    "gui.backpack.soundLabel": "lyd",
    "gui.backpack.scriptLabel": "skript",
    "gui.backpack.spriteLabel": "figur",
    "gui.backpack.header": "Ryggsekk",
    "gui.backpack.errorBackpack": "Feil ved lasting av ryggsekk",
    "gui.backpack.loadingBackpack": "Lastar …",
    "gui.backpack.more": "Fleire",
    "gui.backpack.emptyBackpack": "Ryggsekken er tom",
    "gui.unsupportedBrowser.label": "Nettlesaren er ikkje støtta",
    "gui.unsupportedBrowser.errorLabel": "Det oppstod ein feil",
    "gui.unsupportedBrowser.notRecommended": "Me er leie for det, men det ser dessverre ut til at du brukar ein nettlesar som Scratch ikkje støttar. Me rår deg til å oppgradera til nyaste versjon av anten Google Chrome, Mozilla Firefox, Microsoft Edge eller Apple Safari.",
    "gui.unsupportedBrowser.description": "Me er leie for det, men Scratch støttar dessverre ikkje nettlesaren du brukar. Me rår deg til å oppgradera til nyaste versjon av anten Google Chrome, Mozilla Firefox, Microsoft Edge eller Apple Safari.",
    "gui.unsupportedBrowser.back": "Tilbake",
    "gui.unsupportedBrowser.previewfaq": "Du finn meir informasjon på {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Spørsmål og svar",
    "gui.cards.all-tutorials": "Innføringar",
    "gui.cards.shrink": "Krymp",
    "gui.cards.expand": "Utvid",
    "gui.cards.close": "Lukk",
    "gui.cards.more-things-to-try": "Fleire ting å prøva!",
    "gui.cards.see-more": "Vis fleire",
    "gui.comingSoon.message1": "Slapp av – me er på saka {emoji}",
    "gui.comingSoon.message2": "Er rett rundt hjørnet …",
    "gui.comingSoon.message3": "Me arbeider med det {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Fann ingen einingar",
    "gui.connection.auto-scanning.prescan": "Har eininga i nærleiken, og start så søk.",
    "gui.connection.auto-scanning.pressbutton": "Trykk på knappen på eininga.",
    "gui.connection.auto-scanning.start-search": "Start søk",
    "gui.connection.connecting-searchbutton": "Søkjer …",
    "gui.connection.auto-scanning.try-again": "Prøv på nytt",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Tilkopla",
    "gui.connection.disconnect": "Kopla frå",
    "gui.connection.go-to-editor": "Tilbake til prosjektet",
    "gui.connection.connecting-cancelbutton": "Koplar til …",
    "gui.connection.error.errorMessage": "Å nei! Noko gjekk gale.",
    "gui.connection.error.tryagainbutton": "Prøv på nytt",
    "gui.connection.error.helpbutton": "Hjelp",
    "gui.connection.peripheral-name-label": "Einingsnamn",
    "gui.connection.connect": "Kopla til",
    "gui.connection.scanning.lookingforperipherals": "Søkjer etter einingar",
    "gui.connection.scanning.noPeripheralsFound": "Fann ikkje nokon einingar",
    "gui.connection.scanning.instructions": "Vel eininga di frå lista ovanfor.",
    "gui.connection.search": "Søk igjen",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Sjå til at du har installert og starta «Scratch Link»",
    "gui.connection.unavailable.enablebluetooth": "Sjå til at Bluetooth-støtte er slått på",
    "gui.connection.unavailable.tryagainbutton": "Prøv på nytt",
    "gui.connection.unavailable.helpbutton": "Hjelp",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Gå til",
    "gui.controls.stop": "Stopp",
    "gui.crashMessage.label": "Å nei! Noko gjekk gale.",
    "gui.crashMessage.description": "Det ser dessverre ut til at Scratch krasja. Feilen er automatisk meld til Scratch-gruppa. Prøv å oppdatera sida og prøv på nytt.",
    "gui.crashMessage.errorNumber": "Feilen vart logga med ID-en {errorId}",
    "gui.crashMessage.reload": "Last på nytt",
    "gui.customProcedures.myblockModalTitle": "Lag ein kloss",
    "gui.customProcedures.addAnInputNumberText": "Legg til eit felt",
    "gui.customProcedures.numberTextType": "tal eller tekst",
    "gui.customProcedures.addAnInputBoolean": "Legg til eit felt",
    "gui.customProcedures.booleanType": "logisk verdi",
    "gui.customProcedures.addALabel": "Legg til tekst",
    "gui.customProcedures.runWithoutScreenRefresh": "Køyr utan å oppdatera skjermen",
    "gui.customProcedures.cancel": "Avbryt",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Retning",
    "gui.directionPicker.rotationStyles.allAround": "Roter fritt",
    "gui.directionPicker.rotationStyles.leftRight": "Venstre–høgre",
    "gui.directionPicker.rotationStyles.dontRotate": "Ikkje roter",
    "gui.gui.addExtension": "Hent tilleggsfunksjon",
    "gui.gui.codeTab": "Kode",
    "gui.gui.backdropsTab": "Bakgrunnar",
    "gui.gui.costumesTab": "Drakter",
    "gui.gui.soundsTab": "Lydar",
    "gui.extensionLibrary.comingSoon": "Er rett rundt hjørnet",
    "gui.extensionLibrary.requires": "Utstyrskrav",
    "gui.extensionLibrary.collaboration": "Samarbeid med",
    "gui.library.filterPlaceholder": "Søk",
    "gui.library.allTag": "Alle",
    "gui.loader.message1": "Lagar klossar …",
    "gui.loader.message2": "Les inn figurar …",
    "gui.loader.message3": "Les inn lydar …",
    "gui.loader.message4": "Lastar inn tilleggsfunksjonar …",
    "gui.loader.message5": "Samlar kattar …",
    "gui.loader.message6": "Sender nanoar …",
    "gui.loader.message7": "Blåser opp goboar …",
    "gui.loader.message8": "Hentar emojiar …",
    "gui.loader.headline": "Les inn prosjekt",
    "gui.loader.creating": "Opprettar prosjekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Tinga mine",
    "gui.accountMenu.myClasses": "Klassane mine",
    "gui.accountMenu.myClass": "Klassen min",
    "gui.accountMenu.accountSettings": "Innstillingar",
    "gui.accountMenu.signOut": "Logg ut",
    "gui.authorInfo.byUser": "av {username}",
    "gui.menuBar.seeProjectPage": "Sjå prosjektsida",
    "gui.menuBar.language": "Language",
    "general.username": "Brukarnamn",
    "general.password": "Passord",
    "general.signIn": "Logg inn",
    "login.needHelp": "Treng du hjelp?",
    "form.validationRequired": "Feltet er obligatorisk",
    "gui.menuBar.tutorialsLibrary": "Innføringar",
    "gui.menuBar.restoreSprite": "Angra sletting av figur",
    "gui.menuBar.restoreSound": "Angra sletting av lyd",
    "gui.menuBar.restoreCostume": "Angra sletting av drakt",
    "gui.menuBar.restore": "Angra sletting",
    "gui.menuBar.saveNow": "Lagra no",
    "gui.menuBar.saveAsCopy": "Lagra som kopi",
    "gui.menuBar.remix": "Remiks",
    "gui.menuBar.new": "Ny",
    "gui.menuBar.file": "Fil",
    "gui.menuBar.downloadToComputer": "Lagra til datamaskina",
    "gui.menuBar.edit": "Rediger",
    "gui.menuBar.turboModeOff": "Slå av turbofart",
    "gui.menuBar.turboModeOn": "Slå på turbofart",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Vert Scratch-brukar",
    "gui.menuBar.signIn": "Logg inn",
    "gui.gui.projectTitlePlaceholder": "Namn på prosjektet",
    "gui.menuBar.saveNowLink": "Lagra no",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Lagt ut",
    "gui.menuBar.share": "Legg ut",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Hjelp",
    "gui.modal.back": "Tilbake",
    "gui.monitor.listMonitor.empty": "(tom)",
    "gui.monitor.listMonitor.listLength": "lengd {length}",
    "gui.monitor.contextMenu.default": "vanleg skrift",
    "gui.monitor.contextMenu.large": "stor skrift",
    "gui.monitor.contextMenu.slider": "glidebrytar",
    "gui.monitor.contextMenu.sliderRange": "endra verdiområde",
    "gui.monitor.contextMenu.import": "importer",
    "gui.monitor.contextMenu.export": "eksporter",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Spel av",
    "gui.playButton.stop": "Stopp",
    "gui.gui.variableScopeOptionAllSprites": "For alle figurar",
    "gui.gui.variableScopeOptionSpriteOnly": "For denne figuren",
    "gui.gui.cloudVariableOption": "Nettvariabel (lagra på Scratch-nettstaden)",
    "gui.gui.variablePromptAllSpritesMessage": "Variabelen vert tilgjengelege for alle figurane.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Avbryt",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stopp",
    "gui.playbackStep.playMsg": "Spel av",
    "gui.playbackStep.loadingMsg": "Les inn …",
    "gui.playbackStep.saveMsg": "Lagra",
    "gui.playbackStep.reRecordMsg": "Spel inn på nytt",
    "gui.recordModal.title": "Spel inn lyd",
    "gui.recordingStep.beginRecord": "Trykk på knappen nedanfor for å starta opptak",
    "gui.recordingStep.permission": "{arrow}Du må gje Scratch løyve til å bruka mikrofonen",
    "gui.recordingStep.stop": "Stopp opptak",
    "gui.recordingStep.record": "Spel inn",
    "gui.sliderModal.min": "Minste verdi",
    "gui.sliderModal.max": "Største verdi",
    "gui.sliderModal.title": "Endra verdiområde",
    "gui.sliderPrompt.cancel": "Avbryt",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Lyd",
    "gui.soundEditor.play": "Spel av",
    "gui.soundEditor.stop": "Stopp",
    "gui.soundEditor.copy": "Kopier",
    "gui.soundEditor.paste": "Lim inn",
    "gui.soundEditor.copyToNew": "Kopier til ny",
    "gui.soundEditor.delete": "Slett",
    "gui.soundEditor.save": "Lagra",
    "gui.soundEditor.undo": "Angra",
    "gui.soundEditor.redo": "Gjer om",
    "gui.soundEditor.faster": "Raskare",
    "gui.soundEditor.slower": "Saktare",
    "gui.soundEditor.echo": "Ekko",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Høgare",
    "gui.soundEditor.softer": "Lågare",
    "gui.soundEditor.reverse": "Baklengs",
    "gui.soundEditor.fadeOut": "Ton ut",
    "gui.soundEditor.fadeIn": "Ton inn",
    "gui.soundEditor.mute": "Demp",
    "gui.SpriteInfo.spritePlaceholder": "Namn",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Figur",
    "gui.SpriteInfo.show": "Vis",
    "gui.SpriteInfo.size": "Storleik",
    "gui.spriteSelectorItem.contextMenuDuplicate": "lag ein kopi",
    "gui.spriteSelectorItem.contextMenuExport": "eksporter",
    "gui.spriteSelectorItem.contextMenuDelete": "slett",
    "gui.spriteSelector.addSpriteFromLibrary": "Vel ein figur",
    "gui.spriteSelector.addSpriteFromPaint": "Teikn",
    "gui.spriteSelector.addSpriteFromSurprise": "Overrasking",
    "gui.spriteSelector.addSpriteFromFile": "Last opp figur",
    "gui.stageHeader.stageSizeLarge": "Byt til stor scene",
    "gui.stageHeader.stageSizeSmall": "Byt til lita scene",
    "gui.stageHeader.stageSizeFull": "Gå til fullskjerm",
    "gui.stageHeader.stageSizeUnFull": "Gå ut av fullskjerm",
    "gui.stageHeader.fullscreenControl": "Fullskjerm på/av",
    "gui.spriteSelector.addBackdropFromLibrary": "Vel eit bakgrunnsbilete",
    "gui.stageSelector.addBackdropFromPaint": "Teikn",
    "gui.stageSelector.addBackdropFromSurprise": "Overrasking",
    "gui.stageSelector.addBackdropFromFile": "Last opp bakgrunn",
    "gui.stageSelector.stage": "Scene",
    "gui.stageSelector.backdrops": "Bakgrunnar",
    "gui.telemetryOptIn.label": "Send statistikk for å forbetra Scratch",
    "gui.telemetryOptIn.body1": "Scratch-gruppa arbeider heile tida med å betre forstå korleis Scratch vert brukt. Du kan bidra inn her ved å la Scratch automatisk senda inn statistikk over korleis du brukar Scratch til Scratch-gruppa.",
    "gui.telemetryOptIn.body2": "Informasjonen me samlar inn er blant anna kva språk du brukar Scartch på og kor ofte du brukar dei ulike klossane, samt ulike handlingar, som for eksempel lagring, opning og opplasting av prosjekt. Me samlar IKKJE inn personinformasjon. Sjå {privacyPolicyLink} for meir informasjon.",
    "gui.telemetryOptIn.privacyPolicyLink": "personvernerklæringa vår",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbofart",
    "gui.webglModal.label": "Nettlesaren din støttar ikkje WebGL",
    "gui.webglModal.description": "Det ser dessverre ut til at nettlesaren eller maskina di {webGlLink}. Scratch 3.0 treng denne teknologien for å verka.",
    "gui.webglModal.webgllink": "ikkje støttar WebGL",
    "gui.webglModal.back": "Tilbake",
    "gui.webglModal.previewfaq": "Du finn meir informasjon på {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Spørsmål og svar",
    "gui.costumeLibrary.chooseABackdrop": "Vel eit bakgrunnsbilete",
    "gui.costumeLibrary.chooseACostume": "Vel ei drakt",
    "gui.costumeTab.addBackdropFromLibrary": "Vel eit bakgrunnsbilete",
    "gui.costumeTab.addCostumeFromLibrary": "Vel ei drakt",
    "gui.costumeTab.addBlankCostume": "Teikn",
    "gui.costumeTab.addSurpriseCostume": "Overrasking",
    "gui.costumeTab.addFileBackdrop": "Last opp bakgrunn",
    "gui.costumeTab.addFileCostume": "Last opp drakt",
    "gui.extensionLibrary.chooseAnExtension": "Vel ein tilleggsfunksjon",
    "gui.extensionLibrary.extensionUrl": "Skriv inn nettadressa til tilleggsfunksjonen",
    "gui.monitors.importListColumnPrompt": "Kva kolonne vil du bruka (1–{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Feil ved lydopptak",
    "gui.soundLibrary.chooseASound": "Vel ein lyd",
    "gui.soundTab.fileUploadSound": "Last opp ein lyd",
    "gui.soundTab.surpriseSound": "Overrasking",
    "gui.soundTab.recordSound": "Spel inn",
    "gui.soundTab.addSoundFromLibrary": "Vel ein lyd",
    "gui.spriteLibrary.chooseASprite": "Vel ein figur",
    "gui.tipsLibrary.tutorials": "Vel ei innføring",
    "gui.alerts.createsuccess": "Nytt prosjekt oppretta.",
    "gui.alerts.createcopysuccess": "Lagra kopi av prosjektet.",
    "gui.alerts.createremixsuccess": "Lagra remiks av prosjektet.",
    "gui.alerts.creating": "Lagar nytt …",
    "gui.alerts.creatingCopy": "Kopierer prosjekt …",
    "gui.alerts.creatingRemix": "Remiksar prosjekt …",
    "gui.alerts.creatingError": "Klarte ikkje oppretta prosjektet. Prøv på nytt!",
    "gui.alerts.savingError": "Klarte ikkje lagra prosjektet.",
    "gui.alerts.savesuccess": "Prosjektet vart lagra.",
    "gui.alerts.saving": "Lagrar prosjekt …",
    "gui.alerts.cloudInfo": "Merk at nettvariablar berre støttar tal, ikkje bokstavar eller symbol. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lær meir.",
    "gui.alerts.importing": "Importerer …",
    "gui.defaultProject.meow": "Mjau",
    "gui.defaultProject.variable": "min variabel",
    "gui.howtos.intro-move-sayhello-hat.name": "Kom i gang",
    "gui.howtos.intro-move.step_stepMove": "Legg til ein gå-kloss",
    "gui.howtos.add-a-move-block.step_stepSay": "Legg til ein sei-kloss",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Trykk på det grøne flagget for å starta",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Gjer eit namn levande",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Vel ein bokstavfigur",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spel lyd når trykt på",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Vel ein bokstav til",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Byt farge",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Vel ein bokstav til og få han til å snurra",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Vel ein bokstav til og få han til å veksa",
    "gui.howtos.imagine": "Fantasiverd",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Skriv inn det du vil at figuren skal seia",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Trykk på det grøne flagget for å starta",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Vel eit bakgrunnsbilete",
    "gui.howtos.imagine.step_imagineChooseSprite": "Vel ein figur",
    "gui.howtos.imagine.step_imagineFlyAround": "Trykk mellomromstasten for å gli bortover",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Vel ein annan figur",
    "gui.howtos.imagine.step_imagineLeftRight": "Flytt til venstre og høgre",
    "gui.howtos.imagine.step_imagineUpDown": "Flytt opp og ned",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Byt drakt",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Gli til eit punkt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Veks og krymp",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Vel eit anna bakgrunnsbilete",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Byt bakgrunn",
    "gui.howtos.imagine.step_imagineRecordASound": "Legg på lydeffekt",
    "gui.howtos.imagine.step_imagineChooseSound": "Vel lyd",
    "gui.howtos.make-music.name": "Lag musikk",
    "gui.howtos.Make-Music.step_PickInstrument": "Vel ein instrumentfigur",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spel lyd når trykt på",
    "gui.howtos.Make-Music.step_MakeSong": "Lag ein song",
    "gui.howtos.make-music.step_MakeBeat": "Vel ei tromme og lag ein melodi",
    "gui.howtos.make-music.step_MakeBeatBox": "Vel mikrofonfiguren og ein tilfeldig trommelyd",
    "gui.howtos.story.name": "Lag ei forteljing",
    "gui.howtos.story.step_addbg": "Legg på eit bakgrunnsbilete",
    "gui.howtos.story.step_addsprite": "Legg til ein figur",
    "gui.howtos.story.step_saysomething": "Sei noko",
    "gui.howtos.story.step_addanothersprite": "Legg til ein ny figur",
    "gui.howtos.story.step_flip": "Byt retning",
    "gui.howtos.story.step_conversation": "Ei samtale",
    "gui.howtos.story.addanotherbg": "Legg på endå eit bakgrunnsbilete",
    "gui.howtos.story.step_swithbg": "Byt bakgrunn",
    "gui.howtos.story.step_hidewizard": "Gøym figur",
    "gui.howtos.story.step_showwizard": "Vis figur",
    "gui.howtos.make-a-chase-game.name": "Lag eit jaktespel",
    "gui.howtos.Chase-Game.step_BG": "Legg på eit bakgrunnsbilete",
    "gui.howtos.chase-game.step_AddOcto": "Legg til ein figur",
    "gui.howtos.make-music.step_LeftRight": "Flytt til venstre og høgre med piltastane",
    "gui.howtos.Chase-Game.step_UpDown": "Flytt opp og ned med piltastane",
    "gui.howtos.Chase-Game.step_AddStar": "Legg til ein ny figur",
    "gui.howtos.Chase-Game.step_MoveRandom": "Flytt rundt tilfeldig",
    "gui.howtos.Chase-Game.step_WhenTouch": "Spel lyd når noko rører blekksprutfiguren",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Lag poengvariabel",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Legg til poeng når noko rører blekksprutfiguren",
    "gui.howtos.animate-char.name": "Gjer ein figur levande",
    "gui.howtos.animate-char.step_addbg": "Legg på eit bakgrunnsbilete",
    "gui.howtos.animate-char.step_addsprite": "Legg til ein ny figur",
    "gui.howtos.animate-char.step_saysomething": "Sei noko",
    "gui.howtos.animate-char.step_addsound": "Legg på lydar",
    "gui.howtos.animate-char.step_animatetalking": "Animasjon av snakking",
    "gui.howtos.animate-char.step_arrowkeys": "Flytt med piltastane",
    "gui.howtos.animate-char.step_jump": "Hopp",
    "gui.howtos.animate-char.step_changecolor": "Byt farge",
    "gui.howtos.make-a-game.name": "Lag eit klikkespel",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Veil ein figur",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spel lyd når trykt på",
    "gui.howtos.make-a-game.step_GameAddScore": "Lag poengvariabel",
    "gui.howtos.make-a-game.step_GameChangeScore": "Gje poeng når trykt på",
    "gui.howtos.make-a-game.step_Random": "Gå til tilfeldig plassering",
    "gui.howtos.make-music.step_GameChangeColor": "Byt farge",
    "gui.howtos.make-music.step_ResetScore": "Nullstill poeng",
    "gui.howtos.make-it-fly.name": "Få figuren til å fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Vel ein himmelbakgrunn",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Vel ein figur",
    "gui.howtos.fly.step_stepflySaySomething": "Sei noko",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Flytt rundt med piltastane",
    "gui.howtos.fly.step_stepflyChooseObject": "Vel noko å samla",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Få gjenstanden til å flytta på seg",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Vel ein figur",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Legg til poeng",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Tel poeng",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Legg til bakgrunn",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Flytt bakgrunnen",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Neste drakt",
    "gui.howtos.pong": "Ballspelet Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Legg på eit bakgrunnsbilete",
    "gui.howtos.pong.step_pongAddBallSprite": "Legg til ein ball",
    "gui.howtos.pong.step_pongBounceAround": "Sprett omkring",
    "gui.howtos.pong.step_pongAddPaddle": "Legg til ein rekkert",
    "gui.howtos.pong.step_pongMoveThePaddle": "Flytt rekkerten",
    "gui.howtos.pong.step_pongSelectBallSprite": "Vel ballfiguren",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Lag kode for å spretta ballen på rekkerten",
    "gui.howtos.pong.step_pongAddAScore": "Legg til poeng",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Vel «poeng» i menyen",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Set inn ein «endra poeng»-kloss",
    "gui.howtos.pong.step_pongResetScore": "Nullstill poenga",
    "gui.howtos.pong.step_pongAddLineSprite": "Legg til kantlinje",
    "gui.howtos.pong.step_pongGameOver": "Spelet er slutt",
    "gui.howtos.code-cartoon": "Lag ein teikneserie",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sei noko når ein trykkjer på det grøne flagget",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Gjer ein figur levande når ein trykkjer på han",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Vel ein annan figur",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Bruk minusteikn for å gjera figuren mindre",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Få figuren til å veksa og krympa",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Vel ein annan figur",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hopp opp og ned",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Trykk på ein figur for å byta scener",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Gli rundt",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Byt drakt",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Vel fleire figurar til teikneserien",
    "gui.howtos.cartoon-network": "Lag eit eventyrspel med animasjon",
    "gui.howtos.cartoon-network.step_CNcharacter": "Vel figuren du vil visa",
    "gui.howtos.cartoon-network.step_CNsay": "Sei noko",
    "gui.howtos.cartoon-network.step_CNglide": "Gli rundt",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Vel nokon å jakta på",
    "gui.howtos.cartoon-network.step_CNcollect": "Samla ting",
    "gui.howtos.cartoon-network.step_CNvariable": "Lag ein poengvariabel",
    "gui.howtos.cartoon-network.step_CNscore": "Tel poeng",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Neste nivå: Byt bakgrunn",
    "gui.howtos.videosens.name": "Sansing med kamera",
    "gui.howtos.videosens.step_addextension": "Hent tilleggsfunksjon",
    "gui.howtos.videosens.step_pet": "Klapp katten",
    "gui.howtos.videosens.step_animate": "Animasjonar",
    "gui.howtos.videosens.step_pop": "Sprekk ein ballong",
    "gui.howtos.say-it-out-loud": "Lag animasjonar som snakkar",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Hent klossar for tekst til tale",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sei noko",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Vel ein stemme",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Flytt rundt",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Legg på eit bakgrunnsbilete",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Legg til ein ny figur",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Syng ein song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Byt farge",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Snurr rundt",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Veks og krymp",
    "gui.howtos.talking": "Forteljingar med tale",
    "gui.howtos.talking.step_talesAddExtension": "Trykk for å leggja til «tekst til tale»-klossar",
    "gui.howtos.talking.step_talesChooseSprite": "Vel ein figur",
    "gui.howtos.talking.step_talesSaySomething": "Få ein figur til å snakka",
    "gui.howtos.talking.step_talesChooseBackdrop": "Vel eit bakgrunnsbilete",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Trykk på ein figur for å gå til neste bakgrunn",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Vel ein annan figur",
    "gui.howtos.talking.step_talesMoveAround": "Flytt rundt",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Vel eit anna bakgrunnsbilete",
    "gui.howtos.talking.step_talesAnimateTalking": "Animasjon av snakking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Vel eit anna bakgrunnsbilete",
    "gui.howtos.talking.step_talesChooseSound": "Vel ein song å dansa til",
    "gui.howtos.talking.step_talesDanceMoves": "Dansesteg",
    "gui.howtos.talking.step_talesAskAnswer": "Hent klossane for spørsmål og svar frå sansekategorien",
    "gui.howtos.add-sprite.name": "Legg til ein figur",
    "gui.howtos.add-sprite.step_addSprite": "Legg til ein figur",
    "gui.howtos.add-a-backdrop.name": "Legg på eit bakgrunnsbilete",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Legg på eit bakgrunnsbilete",
    "gui.howtos.change-size.name": "Endra storleik",
    "gui.howtos.change-size.step_changeSize": "Endra storleik",
    "gui.howtos.glide-around.name": "Gli rundt",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Gli rundt",
    "gui.howtos.change-size.step_glideAroundPoint": "Gli til eit punkt",
    "gui.howtos.record-a-sound.name": "Spel inn lydar",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Trykk på «lydar»-fana",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Trykk på «ta opp»",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Trykk på opptaksknappen",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Vel lyd",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spel av lyden",
    "gui.howtos.spin-video.name": "Få noko til å snurra rundt",
    "gui.howtos.change-size.step_spinTurn": "Snu",
    "gui.howtos.change-size.step_spinPointInDirection": "Vel retning",
    "gui.howtos.hide-and-show.name": "Gøym og vis",
    "gui.howtos.change-size.step_hideAndShow": "Gøym og vis",
    "gui.howtos.switch-costume.name": "Få ein figur til å røra seg",
    "gui.howtos.change-size.step_switchCostumes": "Få ein figur til å røra seg",
    "gui.howtos.move-around-with-arrow-keys.name": "Bruk piltastane",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Flytt til venstre og høgre",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Flytt opp og ned",
    "gui.howtos.add-effects.name": "Legg til effektar",
    "gui.howtos.videosens.step_addEffects": "Legg til effektar",
    "gui.extension.music.name": "Musikk",
    "gui.extension.music.description": "Spel musikkinstrument.",
    "gui.extension.pen.name": "Penn",
    "gui.extension.pen.description": "Få figurane til å teikna.",
    "gui.extension.videosensing.name": "Sansing med kamera",
    "gui.extension.videosensing.description": "Oppdag rørsle med kameraet.",
    "gui.extension.text2speech.name": "Tekst til tale",
    "gui.extension.text2speech.description": "Lag prosjekt som snakkar.",
    "gui.extension.translate.name": "Omsetjing",
    "gui.extension.translate.description": "Set om tekst til mange språk.",
    "gui.extension.makeymakey.description": "Bruk kva som helst som tastatur.",
    "gui.extension.microbit.description": "Kopla prosjekta til den fysiske verda.",
    "gui.extension.microbit.connectingMessage": "Koplar til",
    "gui.extension.ev3.description": "Bygg interaktive robotar og maskiner.",
    "gui.extension.ev3.connectingMessage": "Koplar til. Sjå til at PIN-koden på EV3-en er sett til 1234.",
    "gui.extension.boost.description": "Gjer robotskapningar levande.",
    "gui.extension.boost.connectingMessage": "Koplar til",
    "gui.extension.wedo2.description": "Bygg med motorar og sensorar.",
    "gui.extension.wedo2.connectingMessage": "Koplar til",
    "gui.extension.gdxfor.description": "Sans skyving, trekking, rørsle og snurring.",
    "gui.extension.gdxfor.connectingMessage": "Koplar til",
    "gui.libraryTags.all": "Alle",
    "gui.libraryTags.animals": "Dyr",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Effektar",
    "gui.libraryTags.fantasy": "Fantasi",
    "gui.libraryTags.fashion": "Mote",
    "gui.libraryTags.food": "Mat",
    "gui.libraryTags.indoors": "Innandørs",
    "gui.libraryTags.loops": "Musikksløyfer",
    "gui.libraryTags.music": "Musikk",
    "gui.libraryTags.notes": "Tonar",
    "gui.libraryTags.outdoors": "Utandørs",
    "gui.libraryTags.patterns": "Mønster",
    "gui.libraryTags.people": "Menneske",
    "gui.libraryTags.percussion": "Slaginstrument",
    "gui.libraryTags.space": "Romfart",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Nede i havet",
    "gui.libraryTags.voice": "Stemmer",
    "gui.libraryTags.wacky": "Merkeleg",
    "gui.libraryTags.animation": "Animasjonar",
    "gui.libraryTags.art": "Kunst",
    "gui.libraryTags.games": "Spel",
    "gui.libraryTags.stories": "Forteljingar",
    "gui.libraryTags.letters": "Bokstavar",
    "gui.opcodeLabels.direction": "retning",
    "gui.opcodeLabels.xposition": "x-posisjon",
    "gui.opcodeLabels.yposition": "y-posisjon",
    "gui.opcodeLabels.size": "storleik",
    "gui.opcodeLabels.costumename": "draktnamn",
    "gui.opcodeLabels.costumenumber": "draktnummer",
    "gui.opcodeLabels.backdropname": "bakgrunnsnamn",
    "gui.opcodeLabels.backdropnumber": "bakgrunnsnummer",
    "gui.opcodeLabels.volume": "lydstyrke",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "svar",
    "gui.opcodeLabels.loudness": "lydstyrke",
    "gui.opcodeLabels.username": "brukarnamn",
    "gui.opcodeLabels.year": "år",
    "gui.opcodeLabels.month": "månad",
    "gui.opcodeLabels.date": "dato",
    "gui.opcodeLabels.dayofweek": "vekedag",
    "gui.opcodeLabels.hour": "time",
    "gui.opcodeLabels.minute": "minutt",
    "gui.opcodeLabels.second": "sekund",
    "gui.opcodeLabels.timer": "sekundklokke",
    "gui.projectLoader.loadError": "Klarte ikkje lasta inn prosjektfila.",
    "gui.sharedMessages.backdrop": "bakgrunn{index}",
    "gui.sharedMessages.costume": "drakt{index}",
    "gui.sharedMessages.sprite": "Figur{index}",
    "gui.sharedMessages.pop": "plopp",
    "gui.sharedMessages.replaceProjectWarning": "Vil du byta ut innhaldet i gjeldande prosjekt?",
    "gui.sharedMessages.loadFromComputerTitle": "Last opp frå datamaskina",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch-prosjekt",
    "boost.color.any": "vilkårleg farge",
    "boost.color.black": "svart",
    "boost.color.blue": "blå",
    "boost.color.green": "grøn",
    "boost.color.red": "raud",
    "boost.color.white": "kvit",
    "boost.color.yellow": "gul",
    "boost.getMotorPosition": "posisjon til motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "hellingsvinkel [TILT_DIRECTION]",
    "boost.motorDirection.backward": "mot klokka",
    "boost.motorDirection.forward": "med klokka",
    "boost.motorDirection.reverse": "baklengs",
    "boost.motorOff": "slå av [MOTOR_ID]",
    "boost.motorOn": "slå på [MOTOR_ID]",
    "boost.motorOnFor": "slå på [MOTOR_ID] i [DURATION] sekund",
    "boost.motorOnForRotation": "roter [MOTOR_ID] [ROTATION] omdreiingar",
    "boost.seeingColor": "ser [COLOR] kloss?",
    "boost.setLightHue": "set lysfargen til [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID]-retning til [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID]-fart til [POWER] %",
    "boost.tiltDirection.any": "vilkårleg",
    "boost.tiltDirection.down": "ned",
    "boost.tiltDirection.left": "venstre",
    "boost.tiltDirection.right": "høgre",
    "boost.tiltDirection.up": "opp",
    "boost.whenColor": "når [COLOR] kloss vert sett",
    "boost.whenTilted": "ved helling [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tonen [NOTE] i [TIME] sekund",
    "ev3.buttonPressed": "knapp [PORT] trykt?",
    "ev3.getBrightness": "lysstyrke",
    "ev3.getDistance": "avstand",
    "ev3.getMotorPosition": "posisjon til motor [PORT]",
    "ev3.motorSetPower": "set styrken til motor [PORT] til [POWER] %",
    "ev3.motorTurnClockwise": "snu motor [PORT] med klokka i [TIME] sekund",
    "ev3.motorTurnCounterClockwise": "snu motor [PORT] mot klokka i [TIME] sekund",
    "ev3.whenBrightnessLessThan": "når lysstyrken < [DISTANCE]",
    "ev3.whenButtonPressed": "når knappen [PORT] er trykt",
    "ev3.whenDistanceLessThan": "når avstanden < [DISTANCE]",
    "gdxfor.getAcceleration": "akselerasjon [DIRECTION]",
    "gdxfor.getForce": "kraft",
    "gdxfor.getSpin": "rotasjonsfart [DIRECTION]",
    "gdxfor.getTilt": "hellingsvinkel [TILT]",
    "gdxfor.isFreeFalling": "i fritt fall?",
    "gdxfor.isTilted": "heller [TILT]?",
    "gdxfor.pulled": "trekt",
    "gdxfor.pushed": "skubba",
    "gdxfor.shaken": "rista",
    "gdxfor.startedFalling": "starta å falla",
    "gdxfor.tiltDirectionMenu.any": "vilkårleg",
    "gdxfor.tiltDirectionMenu.back": "bakover",
    "gdxfor.tiltDirectionMenu.front": "framover",
    "gdxfor.tiltDirectionMenu.left": "venstre",
    "gdxfor.tiltDirectionMenu.right": "høgre",
    "gdxfor.turnedFaceDown": "framsida ned",
    "gdxfor.turnedFaceUp": "framsida opp",
    "gdxfor.whenForcePushedOrPulled": "når kraftsensoren vert [PUSH_PULL]",
    "gdxfor.whenGesture": "når [GESTURE]",
    "gdxfor.whenTilted": "ved helling [TILT]",
    "makeymakey.downArrow": "pil ned",
    "makeymakey.downArrowShort": "ned",
    "makeymakey.leftArrow": "pil venstre",
    "makeymakey.leftArrowShort": "venstre",
    "makeymakey.rightArrow": "pil høgre",
    "makeymakey.rightArrowShort": "høgre",
    "makeymakey.spaceKey": "mellomrom",
    "makeymakey.upArrow": "pil opp",
    "makeymakey.upArrowShort": "opp",
    "makeymakey.whenKeyPressed": "når [KEY] vert trykt",
    "makeymakey.whenKeysPressedInOrder": "når [SEQUENCE] vert trykt i rekkjefølgje",
    "microbit.buttonsMenu.any": "vilkårleg",
    "microbit.clearDisplay": "tøm skjermen",
    "microbit.defaultTextToDisplay": "Hei!",
    "microbit.displaySymbol": "vis bilete [MATRIX]",
    "microbit.displayText": "vis tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "hoppa",
    "microbit.gesturesMenu.moved": "flytta",
    "microbit.gesturesMenu.shaken": "rista",
    "microbit.isButtonPressed": "[BTN]-knapp trykt?",
    "microbit.isTilted": "helling [DIRECTION]?",
    "microbit.pinStateMenu.off": "av",
    "microbit.pinStateMenu.on": "på",
    "microbit.tiltAngle": "hellingsvinkel [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "vilkårleg",
    "microbit.tiltDirectionMenu.back": "bakover",
    "microbit.tiltDirectionMenu.front": "framover",
    "microbit.tiltDirectionMenu.left": "venstre",
    "microbit.tiltDirectionMenu.right": "høgre",
    "microbit.whenButtonPressed": "når [BTN]-knappen er trykt",
    "microbit.whenGesture": "når [GESTURE]",
    "microbit.whenPinConnected": "når kontakten [PIN] får signal",
    "microbit.whenTilted": "ved helling [DIRECTION]",
    "music.categoryName": "Musikk",
    "music.changeTempo": "endra tempo med [TEMPO]",
    "music.drumBass": "(2) Stortromme",
    "music.drumBongo": "(13) Bongotromme",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Trepinnar",
    "music.drumClosedHiHat": "(6) Lukka hihat",
    "music.drumConga": "(14) Congatrommer",
    "music.drumCowbell": "(11) Kubjøller",
    "music.drumCrashCymbal": "(4) Krasjcymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Handklapping",
    "music.drumOpenHiHat": "(5) Open hihat",
    "music.drumSideStick": "(3) Kantslag",
    "music.drumSnare": "(1) Skarptromme",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Trekloss",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Kor",
    "music.instrumentClarinet": "(10) Klarinett",
    "music.instrumentElectricGuitar": "(5) Elektrisk gitar",
    "music.instrumentElectricPiano": "(2) Elektrisk piano",
    "music.instrumentFlute": "(12) Fløyte",
    "music.instrumentGuitar": "(4) Gitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Speledåse",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Oljefat",
    "music.instrumentSynthLead": "(20) Synthesizer (lead)",
    "music.instrumentSynthPad": "(21) Synthesizer (pad)",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Trefløyte",
    "music.midiPlayDrumForBeats": "trommeslag [DRUM] som varer i [BEATS] taktslag",
    "music.midiSetInstrument": "bruk instrumentet [INSTRUMENT]",
    "music.playDrumForBeats": "trommeslag [DRUM] som varer i [BEATS] taktslag",
    "music.playNoteForBeats": "spel tonen [NOTE] i [BEATS] taktslag",
    "music.restForBeats": "pause i [BEATS] taktslag",
    "music.setInstrument": "bruk instrumentet [INSTRUMENT]",
    "music.setTempo": "set tempo til [TEMPO]",
    "pen.categoryName": "Penn",
    "pen.changeColorParam": "endra pennens [COLOR_PARAM] med [VALUE]",
    "pen.changeHue": "endra pennefarge med [HUE]",
    "pen.changeShade": "endra penneskugge med [SHADE]",
    "pen.changeSize": "endra pennebreidd med [SIZE]",
    "pen.clear": "visk vekk alt",
    "pen.colorMenu.brightness": "lysstyrke",
    "pen.colorMenu.color": "farge",
    "pen.colorMenu.saturation": "fargemetting",
    "pen.colorMenu.transparency": "gjennomsikt",
    "pen.penDown": "penn ned",
    "pen.penUp": "penn opp",
    "pen.setColor": "bruk pennefargen [COLOR]",
    "pen.setColorParam": "set [COLOR_PARAM] til [VALUE]",
    "pen.setHue": "bruk pennefargen [HUE]",
    "pen.setShade": "set penneskugge til [SHADE]",
    "pen.setSize": "set pennebreidd til [SIZE]",
    "pen.stamp": "lag avtrykk",
    "speech.defaultWhenIHearValue": "kom igjen",
    "speech.extensionName": "Taleattkjenning",
    "speech.listenAndWait": "lytt og vent",
    "speech.speechReporter": "tale",
    "speech.whenIHear": "når eg høyrer [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Tekst til tale",
    "text2speech.defaultTextToSpeak": "hei",
    "text2speech.giant": "kjempe",
    "text2speech.kitten": "kattunge",
    "text2speech.setLanguageBlock": "set språket til [LANGUAGE]",
    "text2speech.setVoiceBlock": "bruk stemmen [VOICE]",
    "text2speech.speakAndWaitBlock": "les opp [WORDS]",
    "text2speech.squeak": "pipestemme",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Omsetjing",
    "translate.defaultTextToTranslate": "hei",
    "translate.translateBlock": "set om [WORDS] til [LANGUAGE]",
    "translate.viewerLanguage": "språk",
    "videoSensing.categoryName": "Sansing med kamera",
    "videoSensing.direction": "retning",
    "videoSensing.motion": "rørsle",
    "videoSensing.off": "av",
    "videoSensing.on": "på",
    "videoSensing.onFlipped": "spegelvend",
    "videoSensing.setVideoTransparency": "set gjennomsikt av video til [TRANSPARENCY]",
    "videoSensing.sprite": "figur",
    "videoSensing.stage": "scene",
    "videoSensing.videoOn": "video-[ATTRIBUTE] på [SUBJECT]",
    "videoSensing.videoToggle": "set video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "når videorørsle > [REFERENCE]",
    "wedo2.getDistance": "avstand",
    "wedo2.getTiltAngle": "hellingsvinkel [TILT_DIRECTION]",
    "wedo2.isTilted": "helling [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "mot klokka",
    "wedo2.motorDirection.forward": "med klokka",
    "wedo2.motorDirection.reverse": "baklengs",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alle motorar",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "slå av [MOTOR_ID]",
    "wedo2.motorOn": "slå på [MOTOR_ID]",
    "wedo2.motorOnFor": "slå på [MOTOR_ID] i [DURATION] sekund",
    "wedo2.playNoteFor": "spel tonen [NOTE] i [DURATION] sekund",
    "wedo2.setLightHue": "set lysfargen til [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID]-retninga til [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID]-styrken til [POWER]",
    "wedo2.tiltDirection.any": "vilkårleg",
    "wedo2.tiltDirection.down": "ned",
    "wedo2.tiltDirection.left": "venstre",
    "wedo2.tiltDirection.right": "høgre",
    "wedo2.tiltDirection.up": "opp",
    "wedo2.whenDistance": "når avstanden [OP] [REFERENCE]",
    "wedo2.whenTilted": "ved helling [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Farge",
    "paint.paintEditor.saturation": "Fargemetting",
    "paint.paintEditor.brightness": "Lysstyrke",
    "paint.paintEditor.costume": "Drakt",
    "paint.paintEditor.group": "Lag gruppe",
    "paint.paintEditor.ungroup": "Løys opp gruppe",
    "paint.paintEditor.undo": "Angra",
    "paint.paintEditor.redo": "Gjer om",
    "paint.paintEditor.forward": "Framover",
    "paint.paintEditor.backward": "Bakover",
    "paint.paintEditor.front": "Heilt fram",
    "paint.paintEditor.back": "Heilt bak",
    "paint.paintEditor.more": "Fleire",
    "paint.modeTools.brushSize": "Storleik",
    "paint.modeTools.eraserSize": "Viskelêrstorleik",
    "paint.modeTools.copy": "Kopier",
    "paint.modeTools.paste": "Lim inn",
    "paint.modeTools.delete": "Slett",
    "paint.modeTools.curved": "Glatt",
    "paint.modeTools.pointed": "Spiss",
    "paint.modeTools.thickness": "Strekbreidd",
    "paint.modeTools.flipHorizontal": "Spegelvend",
    "paint.modeTools.flipVertical": "Opp ned",
    "paint.modeTools.filled": "Fylt",
    "paint.modeTools.outlined": "Omriss",
    "paint.paintEditor.bitmap": "Gjer om til punktgrafikk",
    "paint.paintEditor.vector": "Gjer om til vektorgrafikk",
    "paint.paintEditor.fill": "Fyll",
    "paint.paintEditor.stroke": "Kantlinje",
    "paint.brushMode.brush": "Målarpensel",
    "paint.eraserMode.eraser": "Viskelêr",
    "paint.fillMode.fill": "Fyll",
    "paint.lineMode.line": "Linje",
    "paint.ovalMode.oval": "Sirkel",
    "paint.rectMode.rect": "Rektangel",
    "paint.reshapeMode.reshape": "Endra form",
    "paint.roundedRectMode.roundedRect": "Avrunda rektangel",
    "paint.selectMode.select": "Vel",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Byt"
  },
  "oc": {
    "gui.alerts.lostPeripheralConnection": "Scratch a perdut la connexion a {extensionName}",
    "gui.alerts.tryAgain": "Tornar ensajar",
    "gui.alerts.download": "Telecargar",
    "gui.connection.reconnect": "Torna connectar",
    "gui.backpack.costumeLabel": "costum",
    "gui.backpack.soundLabel": "son",
    "gui.backpack.scriptLabel": "escript",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Sac d'esquina",
    "gui.backpack.errorBackpack": "Error del cargament de la saca d'esquina",
    "gui.backpack.loadingBackpack": "Cargament...",
    "gui.backpack.more": "Mai",
    "gui.backpack.emptyBackpack": "La saca d'esquina es vuèja",
    "gui.unsupportedBrowser.label": "Navigator pas suportat",
    "gui.unsupportedBrowser.errorLabel": "I a agut una error",
    "gui.unsupportedBrowser.notRecommended": "Sèm desconsolats, mas sembla qu'utilizatz una version de navigator que Scratch supòrta pas. Vos aconselham de metre vòstre navigator a jorn, demest los navigators suportats tal coma Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "Sèm desconsolats, mas Scratch supòrta pas aquel navigator. Vos aconselham de metre vòstre navigator a jorn, demest los navigators suportats tal coma Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Endarrièr",
    "gui.unsupportedBrowser.previewfaq": "Per ne saber mai, anatz a {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Redusir",
    "gui.cards.expand": "Espandir",
    "gui.cards.close": "Tampar",
    "gui.cards.more-things-to-try": "Mai de causas d'ensajar !",
    "gui.cards.see-more": "Veire mai",
    "gui.comingSoon.message1": "Te'n fagas pas, nos en tracham ! {emoji}",
    "gui.comingSoon.message2": "Arriba lèu...",
    "gui.comingSoon.message3": "Sèm a i trabalhar {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Cap de periferic pas trobat",
    "gui.connection.auto-scanning.prescan": "Sarra ton aparelh, puèi comença la cerca.",
    "gui.connection.auto-scanning.pressbutton": "Premsa lo boton sus ton aparelh.",
    "gui.connection.auto-scanning.start-search": "Començar de cercar",
    "gui.connection.connecting-searchbutton": "Recèrca...",
    "gui.connection.auto-scanning.try-again": "Tornar ensajar",
    "gui.connection.auto-scanning.updatePeripheralButton": "Metre a jorn mon periferic",
    "gui.connection.connected": "Connectat",
    "gui.connection.disconnect": "Desconnectar",
    "gui.connection.go-to-editor": "Anar al Editor",
    "gui.connection.connecting-cancelbutton": "Connexion...",
    "gui.connection.error.errorMessage": "Nifle, sembla que quicòm se passèt mal.",
    "gui.connection.error.tryagainbutton": "Tornar ensajar",
    "gui.connection.error.helpbutton": "Ajuda",
    "gui.connection.peripheral-name-label": "Nom del periferic",
    "gui.connection.connect": "Connectar",
    "gui.connection.scanning.lookingforperipherals": "A cercar de periferics",
    "gui.connection.scanning.noPeripheralsFound": "Cap de periferic pas trobat",
    "gui.connection.scanning.instructions": "Selecciona ton periferic dins la tièra aquí-dessús.",
    "gui.connection.search": "Refrescar",
    "gui.connection.scanning.updatePeripheralButton": "Metre a jorn mon periferic",
    "gui.connection.unavailable.installscratchlink": "Assegura-te d'aver lo ligam Scratch Link installat e en foncionament.",
    "gui.connection.unavailable.enablebluetooth": "Verifica que lo Bluetooth es activat.",
    "gui.connection.unavailable.tryagainbutton": "Tornar ensajar",
    "gui.connection.unavailable.helpbutton": "Ajuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connectatz vòstre {extensionName} a aqueste periferic en utilizant un cable USB.",
    "gui.connection.updatePeripheral.pressUpdate": "Quichatz « Realizar la mesa a jorn » e autorizatz l’actualizacion per acabar.",
    "gui.connection.updatePeripheral.progress": "Mesa a jorn {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Mesa a jorn reüssida !",
    "gui.connection.updatePeripheral.updateFailed": "Fracàs de la mesa a jorn.",
    "gui.connection.updatePeripheral.goBackButton": "Tornar",
    "gui.connection.updatePeripheral.updateNowButton": "Realizar mesa a jorn",
    "gui.connection.updatePeripheral.updateAgainButton": "Tornar ensajar",
    "gui.controls.go": "Anar",
    "gui.controls.stop": "Arrestar",
    "gui.crashMessage.label": "Nifle ! Quicòm se passèt mal.",
    "gui.crashMessage.description": "Sèm desconsolats, mas sembla que Scratch plantèt. Aquel bug es estat reportat automaticament a l'Equipa Scratch. Refresca la pagina per tornar ensajar stp.",
    "gui.crashMessage.errorNumber": "La tieuna error foguèt registrada amb l'id {errorId}",
    "gui.crashMessage.reload": "Tornar cargar",
    "gui.customProcedures.myblockModalTitle": "Fargar un blòc",
    "gui.customProcedures.addAnInputNumberText": "Apondre una entrada",
    "gui.customProcedures.numberTextType": "nombre o tèxt",
    "gui.customProcedures.addAnInputBoolean": "Apondre una entrada",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Apondre una etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Aviar sens refrescar l'ecran",
    "gui.customProcedures.cancel": "Anullar",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direccion",
    "gui.directionPicker.rotationStyles.allAround": "Tot a l'entorn",
    "gui.directionPicker.rotationStyles.leftRight": "Esquèrra/Drecha",
    "gui.directionPicker.rotationStyles.dontRotate": "De virar pas",
    "gui.gui.addExtension": "Apondre Extension",
    "gui.gui.codeTab": "Còdi",
    "gui.gui.backdropsTab": "Fons",
    "gui.gui.costumesTab": "Costums",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "D'arribar lèu",
    "gui.extensionLibrary.requires": "Necessita",
    "gui.extensionLibrary.collaboration": "Collaboracion amb",
    "gui.library.filterPlaceholder": "Cercar",
    "gui.library.allTag": "Tot",
    "gui.loader.message1": "A fargar blòcs...",
    "gui.loader.message2": "A cargar sprites...",
    "gui.loader.message3": "A cargar sons ...",
    "gui.loader.message4": "A cargar d'extensions",
    "gui.loader.message5": "A amassar gats...",
    "gui.loader.message6": "A transmettre nanòs...",
    "gui.loader.message7": "A conflar gobòs",
    "gui.loader.message8": "A aprestar emojis...",
    "gui.loader.headline": "A cargar lo Projècte",
    "gui.loader.creating": "A crear lo projècte",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Mos afars",
    "gui.accountMenu.myClasses": "Mas Classas",
    "gui.accountMenu.myClass": "Ma Classa",
    "gui.accountMenu.accountSettings": "Reglatges de compte",
    "gui.accountMenu.signOut": "Se desconnectar",
    "gui.authorInfo.byUser": "per {username}",
    "gui.menuBar.seeProjectPage": "Veire la pagina del projècte",
    "gui.menuBar.language": "Lenga",
    "general.username": "Nom d'utilizaire",
    "general.password": "Senhal",
    "general.signIn": "Se connectar",
    "login.needHelp": "Besonh d'ajuda ?",
    "form.validationRequired": "Aquel camp es requesit",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.restoreSprite": "Restaurar Sprite",
    "gui.menuBar.restoreSound": "Restaurar Son",
    "gui.menuBar.restoreCostume": "Restaurar Costum",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Enregistrar ara",
    "gui.menuBar.saveAsCopy": "Enesgistrar coma còpia",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Nòu",
    "gui.menuBar.file": "Fichièr",
    "gui.menuBar.downloadToComputer": "Enregistra sus ton ordenador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Atudar lo Mode Turbo",
    "gui.menuBar.turboModeOn": "Alucar lo Mòde Turbo",
    "gui.menuBar.modeMenu": "Mòde",
    "gui.menuBar.normalMode": "Mòde normal",
    "gui.menuBar.caturdayMode": "Mòde catonièr",
    "gui.menuBar.joinScratch": "Juntar Scratch",
    "gui.menuBar.signIn": "Se connectar",
    "gui.gui.projectTitlePlaceholder": "Titol del projècte aquí",
    "gui.menuBar.saveNowLink": "Enregistrar Ara",
    "gui.menuBar.settings": "Paramètres",
    "gui.menuBar.isShared": "Partejat",
    "gui.menuBar.share": "Partejar",
    "gui.menuBar.colorMode": "Mòde color",
    "gui.modal.help": "Ajuda",
    "gui.modal.back": "Endarrièr",
    "gui.monitor.listMonitor.empty": "(void)",
    "gui.monitor.listMonitor.listLength": "longor {length}",
    "gui.monitor.contextMenu.default": "lectura normala",
    "gui.monitor.contextMenu.large": "lectura bèla",
    "gui.monitor.contextMenu.slider": "cursor",
    "gui.monitor.contextMenu.sliderRange": "cambiar l'espandi del cursor",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "amagar",
    "gui.playButton.play": "Jogar",
    "gui.playButton.stop": "Arrestar",
    "gui.gui.variableScopeOptionAllSprites": "Per totas las sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "Sonque per aquela sprite",
    "gui.gui.cloudVariableOption": "Variabla de Cloud (estocada sul servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Aquela variabla serà disponibla a totas las sprites",
    "gui.gui.listPromptAllSpritesMessage": "Aquela lista serà disponibla a totas las sprites",
    "gui.prompt.cancel": "Anullar",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Arrestar",
    "gui.playbackStep.playMsg": "Jogar",
    "gui.playbackStep.loadingMsg": "Cargament...",
    "gui.playbackStep.saveMsg": "Enregistrar",
    "gui.playbackStep.reRecordMsg": "Tornar enregistrar",
    "gui.recordModal.title": "Enregistrar son",
    "gui.recordingStep.beginRecord": "Començar d'enregistrar en clicant sul boton aquí dejos",
    "gui.recordingStep.permission": "{arrow}Necessitam la tieuna permission per utilizar lo microfòn",
    "gui.recordingStep.stop": "Arrestar d'enregistrar",
    "gui.recordingStep.record": "Enregistrar",
    "gui.sliderModal.min": "Valor minimala",
    "gui.sliderModal.max": "Valor maximal",
    "gui.sliderModal.title": "Cambiar l'espandi del cursor",
    "gui.sliderPrompt.cancel": "Anullar",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Son",
    "gui.soundEditor.play": "Jogar",
    "gui.soundEditor.stop": "Arrestar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Pegar",
    "gui.soundEditor.copyToNew": "Copiar cap a novèl",
    "gui.soundEditor.delete": "Escafar",
    "gui.soundEditor.save": "Enregistrar",
    "gui.soundEditor.undo": "Anullar",
    "gui.soundEditor.redo": "Tornar far",
    "gui.soundEditor.faster": "Mai lèu",
    "gui.soundEditor.slower": "Mens lèu",
    "gui.soundEditor.echo": "Resson",
    "gui.soundEditor.robot": "Robòt",
    "gui.soundEditor.louder": "Mai fòrt",
    "gui.soundEditor.softer": "Mai dòç",
    "gui.soundEditor.reverse": "Endarrèr",
    "gui.soundEditor.fadeOut": "Fondut entrant",
    "gui.soundEditor.fadeIn": "Fondut sortent",
    "gui.soundEditor.mute": "Silenciós",
    "gui.SpriteInfo.spritePlaceholder": "Nom",
    "gui.SpriteInfo.showSpriteAction": "Mostrar sprite",
    "gui.SpriteInfo.hideSpriteAction": "Rescondre sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Mostrar",
    "gui.SpriteInfo.size": "Talha",
    "gui.spriteSelectorItem.contextMenuDuplicate": "desdoblar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "escafar",
    "gui.spriteSelector.addSpriteFromLibrary": "Causir un sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Pintrar",
    "gui.spriteSelector.addSpriteFromSurprise": "Suspresa",
    "gui.spriteSelector.addSpriteFromFile": "Cargar un sprite",
    "gui.stageHeader.stageSizeLarge": "Cambiar per una scèna bèla",
    "gui.stageHeader.stageSizeSmall": "Cambiar per una scèna petita",
    "gui.stageHeader.stageSizeFull": "Passar en mòde plen ecran",
    "gui.stageHeader.stageSizeUnFull": "Quitar lo mòde plen ecran",
    "gui.stageHeader.fullscreenControl": "Contraròtle del plen ecran",
    "gui.spriteSelector.addBackdropFromLibrary": "Causir un fons",
    "gui.stageSelector.addBackdropFromPaint": "Pintrar",
    "gui.stageSelector.addBackdropFromSurprise": "Suspresa",
    "gui.stageSelector.addBackdropFromFile": "Cargar un fons",
    "gui.stageSelector.stage": "Scèna",
    "gui.stageSelector.backdrops": "Fons",
    "gui.telemetryOptIn.label": "Reportar las estatisticas per melhorar Scratch.",
    "gui.telemetryOptIn.body1": "L'Equipa Scratch es totjorn a cercar de comprendre melhor l'utilizacion de Scrach dins lo mond. Per ajudar aquel esfòrç, pòdes autorizar Scratch de mandar automaticament d'informacions d'utilizacion a l'Equipa Scratch.",
    "gui.telemetryOptIn.body2": "Las informacions que collectam compren la lenga utilizada, l'utilizacion dels blòcs, e qualques eveniments tal coma enregistrar, cargar e partejar un projècte. Collectam PAS d'informacions personalas. Pòdes legir nòstra {privacyPolicyLink} per mai d'informacions.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politica de confidencialitat",
    "gui.telemetryOptIn.optInText": "Partejar mas donadas d'utilizacion amb l'Equipa de Scratch",
    "gui.telemetryOptIn.optInTooltip": "Activar la telemetria",
    "gui.telemetryOptIn.optOutText": "De partejar pas mas donadas d'utilizacion amb l'Equipa Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Descativar la telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "Tos reglatges foguèron meses a jorn.",
    "gui.telemetryOptIn.buttonClose": "Tampar",
    "gui.turboMode.active": "Mòde Turbo",
    "gui.webglModal.label": "Lo teu navigator supòrta pas WebGL",
    "gui.webglModal.description": "Malastrosament, sembla que lo teu navegador o ordenador {webGlLink}. Aquela tecnologia es necessària per far foncionar Scratch 3.0.",
    "gui.webglModal.webgllink": "Supòrta pas WebGL",
    "gui.webglModal.back": "Endarrièr",
    "gui.webglModal.previewfaq": "Per ne saber mai, anatz a {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Causir fons",
    "gui.costumeLibrary.chooseACostume": "Causir un Costum",
    "gui.costumeTab.addBackdropFromLibrary": "Causir fons",
    "gui.costumeTab.addCostumeFromLibrary": "Causir un Costum",
    "gui.costumeTab.addBlankCostume": "Pintrar",
    "gui.costumeTab.addSurpriseCostume": "Suspresa",
    "gui.costumeTab.addFileBackdrop": "Cargar un fons",
    "gui.costumeTab.addFileCostume": "Cargar un Costum",
    "gui.extensionLibrary.chooseAnExtension": "Causir una extension",
    "gui.extensionLibrary.extensionUrl": "Dintrar l'URL de l'extension",
    "gui.monitors.importListColumnPrompt": "Quina colomna se deu utilizar (1-{numberOfColumns}) ?",
    "gui.recordingStep.alertMsg": "Posquèt pas començar l'enregistrament",
    "gui.soundLibrary.chooseASound": "Causir un son",
    "gui.soundTab.fileUploadSound": "Cargar un son",
    "gui.soundTab.surpriseSound": "Suspresa",
    "gui.soundTab.recordSound": "Enregistrar",
    "gui.soundTab.addSoundFromLibrary": "Causir un son",
    "gui.spriteLibrary.chooseASprite": "Causís a Sprite",
    "gui.tipsLibrary.tutorials": "Causir un Tutorial",
    "gui.alerts.createsuccess": "Novèl projècte creat.",
    "gui.alerts.createcopysuccess": "Projècte enregistrat coma un còpia.",
    "gui.alerts.createremixsuccess": "Projècte enregistrat coma un remix.",
    "gui.alerts.creating": "A crear un novèl...",
    "gui.alerts.creatingCopy": "A copiar lo projècte...",
    "gui.alerts.creatingRemix": "A remixar lo projècte...",
    "gui.alerts.creatingError": "Posquèt pas crear lo projècte. Torna ensajar stp !",
    "gui.alerts.savingError": "Lo projècte se posquèt pas enregistrar",
    "gui.alerts.savesuccess": "Projècte enregistrar",
    "gui.alerts.saving": "A enregistrar lo projècte",
    "gui.alerts.cloudInfo": "Vòlga plan notar, las variablas de cloud supòrtan pas que los nombres, pas de letras nimai de simbòls. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Ne saber mai.",
    "gui.alerts.importing": "A importar...",
    "gui.defaultProject.meow": "Miao",
    "gui.defaultProject.variable": "ma variabla",
    "gui.howtos.intro-move-sayhello-hat.name": "Per començar",
    "gui.howtos.intro-move.step_stepMove": "Apondre un blòc de moviment",
    "gui.howtos.add-a-move-block.step_stepSay": "Apondre un blòc de paraula",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Clicar lo drapèl verd per començar.",
    "gui.howtos.intro-getting-started-ASL.name": "Primièrs pases - Lenga dels signes estatsunidenca",
    "gui.howtos.animate-a-name.name": "Animar un nom",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Causir una Sprite de Letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Jogar un son quand es clicat",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Causir una autra Sprite de Letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Cambiar de color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Causir una autra Sprite de Letra & Far la virar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Causir una autra Sprite de Letra & Far la grandir",
    "gui.howtos.imagine": "Imagina un Mond",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Pica çò que vòles dire",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Clicar lo Drapèl Verd per Començar.",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Causir quin fons que siá",
    "gui.howtos.imagine.step_imagineChooseSprite": "Causir quina Sprite que siá",
    "gui.howtos.imagine.step_imagineFlyAround": "Apuejar sus la barra d'espaci per lisar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Causir un autra Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Bolegar Esquèrra-Drecha",
    "gui.howtos.imagine.step_imagineUpDown": "Bolegar Ennaut-Enbàs",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Cambiar los Costums",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Lisar cap a un punt",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grandir e Redusir",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Causir un Autre Fons",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Cambiar los Fons",
    "gui.howtos.imagine.step_imagineRecordASound": "Apondre un Son",
    "gui.howtos.imagine.step_imagineChooseSound": "Causís ton son",
    "gui.howtos.make-music.name": "Far de Musica",
    "gui.howtos.Make-Music.step_PickInstrument": "Causir una Sprite d'Instrument",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Jogar lo son quand es clicat",
    "gui.howtos.Make-Music.step_MakeSong": "Crear una cançon",
    "gui.howtos.make-music.step_MakeBeat": "Causir una percussion & Far un Ritme",
    "gui.howtos.make-music.step_MakeBeatBox": "Causir la Sprite de Microfòn & BoitaDeRitme Suspresa ",
    "gui.howtos.story.name": "Crear una Istòra",
    "gui.howtos.story.step_addbg": "Apondre un Fons",
    "gui.howtos.story.step_addsprite": "Apondre un Personatge",
    "gui.howtos.story.step_saysomething": "Dire Quicòm",
    "gui.howtos.story.step_addanothersprite": "Apondre un Autre Personatge",
    "gui.howtos.story.step_flip": "Cambiar de Direccion",
    "gui.howtos.story.step_conversation": "Aver una Conversa",
    "gui.howtos.story.addanotherbg": "Apondre un Autre Fons",
    "gui.howtos.story.step_swithbg": "Cambiar Los Fonzes",
    "gui.howtos.story.step_hidewizard": "Amagar un Personatge",
    "gui.howtos.story.step_showwizard": "Mostrar un Personatge",
    "gui.howtos.make-a-chase-game.name": "Far un Jòc de Corsejada",
    "gui.howtos.Chase-Game.step_BG": "Apondre un Fons",
    "gui.howtos.chase-game.step_AddOcto": "Apondre una Sprite",
    "gui.howtos.make-music.step_LeftRight": "Bolegar de Drecha e d'Esquèrra amb las Sagetas.",
    "gui.howtos.Chase-Game.step_UpDown": "Bolegar d'Ennaut & d'Enbàs amb las Sagetas",
    "gui.howtos.Chase-Game.step_AddStar": "Apondre una Autra Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Bolegar a l'azard ",
    "gui.howtos.Chase-Game.step_WhenTouch": "En Sprite de Pofre, Jogar de Son Quand Toca",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crear una Variable de Marca",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "En Sprite de Pofre, Apondre Marca Quand Toca.",
    "gui.howtos.animate-char.name": "Animar un Personatge",
    "gui.howtos.animate-char.step_addbg": "Apondre un Fons",
    "gui.howtos.animate-char.step_addsprite": "Apondre una Sprite",
    "gui.howtos.animate-char.step_saysomething": "Dire Quicòm",
    "gui.howtos.animate-char.step_addsound": "Apondre un Son",
    "gui.howtos.animate-char.step_animatetalking": "Animar las Paraulas",
    "gui.howtos.animate-char.step_arrowkeys": "Bolegar en Utilizant las Sagetas",
    "gui.howtos.animate-char.step_jump": "Sautar",
    "gui.howtos.animate-char.step_changecolor": "Cambiar de Color",
    "gui.howtos.make-a-game.name": "Far un Jòc de Clicar",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Causir una Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Jogar lo son quand es clicat",
    "gui.howtos.make-a-game.step_GameAddScore": "Crear una Variable de Marca",
    "gui.howtos.make-a-game.step_GameChangeScore": "Quand Clicat, Aumentar la Marca",
    "gui.howtos.make-a-game.step_Random": "Anar a una posicion al asard",
    "gui.howtos.make-music.step_GameChangeColor": "Cambiar de color",
    "gui.howtos.make-music.step_ResetScore": "Torna Metre la Marca a Zerò.",
    "gui.howtos.make-it-fly.name": "De Far Volar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Causir un Fon de Cèl",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Causir un Personatge",
    "gui.howtos.fly.step_stepflySaySomething": "Dire Quicòm",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Bolegar amb las Sagetas",
    "gui.howtos.fly.step_stepflyChooseObject": "Causir un Objècte de Collectar",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Far Bolegar un Objècte",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Causís ton Personatge",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Apondre una Marca",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Seguir la Marca",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Apondre un Païsatge",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Bolegar lo Païsatge",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Costum Seguent",
    "gui.howtos.pong": "Jòc de Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Apondre un Fons",
    "gui.howtos.pong.step_pongAddBallSprite": "Apondre una Sprite de Bala",
    "gui.howtos.pong.step_pongBounceAround": "Rebonbir a l'Entorn",
    "gui.howtos.pong.step_pongAddPaddle": "Apondre una Raqueta",
    "gui.howtos.pong.step_pongMoveThePaddle": "Bolegar la Raqueta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Seleccionar la Sprite de bala",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Apondre lo Còdi per Far Rebombir la Bala contra la Raqueta",
    "gui.howtos.pong.step_pongAddAScore": "Apondre una Marca",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Causir « Marca » al menú",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Inserir lo Blòc « Cambiar la Marca »",
    "gui.howtos.pong.step_pongResetScore": "Torna Metre la Marca a Zerò.",
    "gui.howtos.pong.step_pongAddLineSprite": "Apondre la Sprite Linha",
    "gui.howtos.pong.step_pongGameOver": "Fin de Partida",
    "gui.howtos.code-cartoon": "Causir un Animat",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dire Quicòm Quand Clicas lo Drapèl Verd",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animar un Personatge Quand Clicas dessús",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selecciona un Personatge Diferent",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Utilizar un Signe Mens per Venir Mai Petit",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Far Grandir o Demesir un Personatge",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selecciona un Personatge Diferent",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Sautar de Naut en Bas",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Clicar un Personatge per Cambiar de Scèna",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Lisar a l'entorn",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Cambiar los Costums",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Causir mai de Personatges d'Apondre al Animat",
    "gui.howtos.cartoon-network": "Animar un Jòc d'Aventura",
    "gui.howtos.cartoon-network.step_CNcharacter": "Causir un Personatge de Mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Dire Quicòm",
    "gui.howtos.cartoon-network.step_CNglide": "Lisar a l'entorn",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Causir un Objècte de Corsejar",
    "gui.howtos.cartoon-network.step_CNcollect": "Collectar d'Objèctes",
    "gui.howtos.cartoon-network.step_CNvariable": "Far una Variable de Marca",
    "gui.howtos.cartoon-network.step_CNscore": "Seguir la Marca",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Nivèl seguent : Cambiar lo Fons",
    "gui.howtos.videosens.name": "Percepcion de Video",
    "gui.howtos.videosens.step_addextension": "Apondre Extension",
    "gui.howtos.videosens.step_pet": "Amanhagar lo Gat",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Espetar un Balon",
    "gui.howtos.say-it-out-loud": "Crear d'Animacions que Parlan",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Apondre los blòcs Escriches de Dire",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dire Quicòm",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Causir una Votz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Bolegar a l'entorn",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Apondre un Fons",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Apondre un Autre Personatge",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cantar o Jogar una Cançon",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Cambiar de color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Virar",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grandir e Redusir",
    "gui.howtos.talking": "Contar",
    "gui.howtos.talking.step_talesAddExtension": "Clicar per Apondre de Blòcs Escriches de Dire",
    "gui.howtos.talking.step_talesChooseSprite": "Causís a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Far Parlar un Personatge",
    "gui.howtos.talking.step_talesChooseBackdrop": "Causir fons",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Clicar un Personatge per que se'n Ane al Fons Seguent",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Causir un autra Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Bolegar a l'entorn",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Causir un Autre Fons",
    "gui.howtos.talking.step_talesAnimateTalking": "Animar las Paraulas",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Causir un Autre Fons",
    "gui.howtos.talking.step_talesChooseSound": "Causir una Cançon per Dansar",
    "gui.howtos.talking.step_talesDanceMoves": "Moviments de Dansa",
    "gui.howtos.talking.step_talesAskAnswer": "Obtener lo Blòc Demanda e Respond dempuèi la Categoriá Sentir",
    "gui.howtos.add-sprite.name": "Apondre una Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Apondre una Sprite",
    "gui.howtos.add-a-backdrop.name": "Apondre un Fons",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Apondre un Fons",
    "gui.howtos.change-size.name": "Cambiar de Talha",
    "gui.howtos.change-size.step_changeSize": "Cambiar de Talha",
    "gui.howtos.glide-around.name": "Lisar a l'entorn",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Lisar a l'entorn",
    "gui.howtos.change-size.step_glideAroundPoint": "Lisar cap a un punt",
    "gui.howtos.record-a-sound.name": "Enregistrar un Son",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clicar sul Onglet « Sons »",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clicar « Enregistrar »",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Apiejar sul Boton « Enregistrar »",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Causís ton son",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Jòga ton Son",
    "gui.howtos.spin-video.name": "Far Virar",
    "gui.howtos.change-size.step_spinTurn": "Virar",
    "gui.howtos.change-size.step_spinPointInDirection": "Reglar la Direccion",
    "gui.howtos.hide-and-show.name": "Amagar e Mostrar",
    "gui.howtos.change-size.step_hideAndShow": "Amagar e Mostrar",
    "gui.howtos.switch-costume.name": "Animar una Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animar una Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Utilizar las Sagetas",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Bolegar de Drecha e d'Esquèrra",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Bolegar de Naut e Bas",
    "gui.howtos.add-effects.name": "Apondre d'Efièches",
    "gui.howtos.videosens.step_addEffects": "Apondre d'Efièches",
    "gui.extension.music.name": "Musica",
    "gui.extension.music.description": "Jogar d'Instruments e Percussions",
    "gui.extension.pen.name": "Estilò",
    "gui.extension.pen.description": "Dessenha amb tas Sprites",
    "gui.extension.videosensing.name": "Percepcion de Video",
    "gui.extension.videosensing.description": "Percebre de Moviment amb la Camèra",
    "gui.extension.text2speech.name": "Escriches de Dire",
    "gui.extension.text2speech.description": "Fa Parlar tos Projèctes",
    "gui.extension.translate.name": "Revirar",
    "gui.extension.translate.description": "Revirar lo text dins mantuna lenga",
    "gui.extension.makeymakey.description": "Tot Far coma una toca.",
    "gui.extension.microbit.description": "Connecta tos projèctes al mond.",
    "gui.extension.microbit.connectingMessage": "A se connectar",
    "gui.extension.ev3.description": "Bastir de robòts interactiu e mai.",
    "gui.extension.ev3.connectingMessage": "A se connectar. Assegura-te que lo pin de ton EV3 es reglat sus 1234.",
    "gui.extension.boost.description": "Balha vida a tas creations roboticas.",
    "gui.extension.boost.connectingMessage": "A se connectar",
    "gui.extension.wedo2.description": "Bastís amb motors e captors.",
    "gui.extension.wedo2.connectingMessage": "A se connectar",
    "gui.extension.gdxfor.description": "Percep butar, tirar, moviment e rotacion.",
    "gui.extension.gdxfor.connectingMessage": "A se connectar",
    "gui.libraryTags.all": "Tot",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dança",
    "gui.libraryTags.effects": "Efièches",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Mòda",
    "gui.libraryTags.food": "Noiridura",
    "gui.libraryTags.indoors": "Interiors",
    "gui.libraryTags.loops": "Boclas",
    "gui.libraryTags.music": "Musica",
    "gui.libraryTags.notes": "Nòtas",
    "gui.libraryTags.outdoors": "Exteriors",
    "gui.libraryTags.patterns": "Motius",
    "gui.libraryTags.people": "Gents",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Espaci",
    "gui.libraryTags.sports": "Espòrts",
    "gui.libraryTags.underwater": "Josmarin",
    "gui.libraryTags.voice": "Votz",
    "gui.libraryTags.wacky": "Folastre",
    "gui.libraryTags.animation": "Animacion",
    "gui.libraryTags.art": "rt",
    "gui.libraryTags.games": "Jòcs",
    "gui.libraryTags.stories": "Istòrias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "direccion",
    "gui.opcodeLabels.xposition": "posicion x",
    "gui.opcodeLabels.yposition": "posicion y",
    "gui.opcodeLabels.size": "talha",
    "gui.opcodeLabels.costumename": "nom del costum",
    "gui.opcodeLabels.costumenumber": "numèro del costum",
    "gui.opcodeLabels.backdropname": "nom del fons",
    "gui.opcodeLabels.backdropnumber": "numèro del fons",
    "gui.opcodeLabels.volume": "volum",
    "gui.opcodeLabels.tempo": "tempò",
    "gui.opcodeLabels.answer": "responsa",
    "gui.opcodeLabels.loudness": "intensitat",
    "gui.opcodeLabels.username": "nom d'utilizaire",
    "gui.opcodeLabels.year": "annada",
    "gui.opcodeLabels.month": "mes",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "jorn de la setmana",
    "gui.opcodeLabels.hour": "ora",
    "gui.opcodeLabels.minute": "minuta",
    "gui.opcodeLabels.second": "segonda",
    "gui.opcodeLabels.timer": "minutor",
    "gui.projectLoader.loadError": "Lo fichièr de projècte seleccionat capitèt pas de se cargar.",
    "gui.sharedMessages.backdrop": "fons{index}",
    "gui.sharedMessages.costume": "costum{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pòp",
    "gui.sharedMessages.replaceProjectWarning": "Remplaçar los contenguts del projècte en cors ?",
    "gui.sharedMessages.loadFromComputerTitle": "Carga a partir ton ordenador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Fosc",
    "gui.theme.highContrast": "Naut contraste",
    "gui.gui.defaultProjectTitle": "Projècte Scratch",
    "boost.color.any": "quina color que siá",
    "boost.color.black": "negre",
    "boost.color.blue": "blau",
    "boost.color.green": "verd",
    "boost.color.red": "roge",
    "boost.color.white": "blanc",
    "boost.color.yellow": "jaune",
    "boost.getMotorPosition": "posicion del motor [MOTOR_REPORTER_ID] ",
    "boost.getTiltAngle": "Anle d'enclinason [TILT_DIRECTION]",
    "boost.motorDirection.backward": "per aquí",
    "boost.motorDirection.forward": "per ailà",
    "boost.motorDirection.reverse": "endarrièr",
    "boost.motorOff": "atudar lo motor [MOTOR_ID]",
    "boost.motorOn": "alucar lo motor [MOTOR_ID]",
    "boost.motorOnFor": "Alucar lo motor [MOTOR_ID] pendent [DURATION] segondas",
    "boost.motorOnForRotation": "Alucar lo motor [MOTOR_ID] pendent [ROTATION] rotacions",
    "boost.seeingColor": "A veire la brica [COLOR] ?",
    "boost.setLightHue": "reglar la color del lum sus [HUE]",
    "boost.setMotorDirection": "Reglar la direccion del motor [MOTOR_ID] sus [MOTOR_DIRECTION]",
    "boost.setMotorPower": "Reglar la velocitat del motor [MOTOR_ID] sus [POWER] %",
    "boost.tiltDirection.any": "quin que siá",
    "boost.tiltDirection.down": "enbàs",
    "boost.tiltDirection.left": "esquèrra",
    "boost.tiltDirection.right": "drecha",
    "boost.tiltDirection.up": "ennaut",
    "boost.whenColor": "quand la brica de color [COLOR] es vista",
    "boost.whenTilted": "quand clinat  [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tindar la nòta [NOTE] pendent [TIME] s.",
    "ev3.buttonPressed": "boton [PORT] premsat ?",
    "ev3.getBrightness": "luminositat",
    "ev3.getDistance": "distància",
    "ev3.getMotorPosition": "posicion del motor [PORT]",
    "ev3.motorSetPower": "Poténcia del motor [PORT] reglat a [POWER] %",
    "ev3.motorTurnClockwise": "Motor [PORT] virant per aquí pendent [TIME] segondas",
    "ev3.motorTurnCounterClockwise": "Motor [PORT] virant per ailà pendent [TIME] segondas",
    "ev3.whenBrightnessLessThan": "quand la luminositat < [DISTANCE]",
    "ev3.whenButtonPressed": "quand lo boton [PORT] es premsat",
    "ev3.whenDistanceLessThan": "quand la distància < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleracion [DIRECTION]",
    "gdxfor.getForce": "fòrça",
    "gdxfor.getSpin": "Velocitat de rotacion  [DIRECTION]",
    "gdxfor.getTilt": "Angle d'enclinason [TILT]",
    "gdxfor.isFreeFalling": "A tombar ?",
    "gdxfor.isTilted": "clinat [TILT] ?",
    "gdxfor.pulled": "tirat ?",
    "gdxfor.pushed": "butat?",
    "gdxfor.shaken": "brandit",
    "gdxfor.startedFalling": "a començat de tombar",
    "gdxfor.tiltDirectionMenu.any": "quin que siá",
    "gdxfor.tiltDirectionMenu.back": "darrièr",
    "gdxfor.tiltDirectionMenu.front": "davant",
    "gdxfor.tiltDirectionMenu.left": "esquèrra",
    "gdxfor.tiltDirectionMenu.right": "drecha",
    "gdxfor.turnedFaceDown": "virat fàcia enbas",
    "gdxfor.turnedFaceUp": "virat fàcia ennaut",
    "gdxfor.whenForcePushedOrPulled": "quand lo captor de fòrça [PUSH_PULL]",
    "gdxfor.whenGesture": "quand [GESTURE]",
    "gdxfor.whenTilted": "quand clinat [TILT]",
    "makeymakey.downArrow": "sageta bas",
    "makeymakey.downArrowShort": "enbàs",
    "makeymakey.leftArrow": "sageta esquèrra",
    "makeymakey.leftArrowShort": "esquèrra",
    "makeymakey.rightArrow": "sageta drecha",
    "makeymakey.rightArrowShort": "drecha",
    "makeymakey.spaceKey": "espaci",
    "makeymakey.upArrow": "sageta naut",
    "makeymakey.upArrowShort": "ennaut",
    "makeymakey.whenKeyPressed": "quand la toca  [KEY] es premsada",
    "makeymakey.whenKeysPressedInOrder": "quand [SEQUENCE] son premsadas dins l'òrdre",
    "microbit.buttonsMenu.any": "quin que siá",
    "microbit.clearDisplay": "escafar l'ecran",
    "microbit.defaultTextToDisplay": "Adieu !",
    "microbit.displaySymbol": "afichar [MATRIX]",
    "microbit.displayText": "afichar lo tèxt [TEXT]",
    "microbit.gesturesMenu.jumped": "sautat",
    "microbit.gesturesMenu.moved": "bolegat",
    "microbit.gesturesMenu.shaken": "brandit",
    "microbit.isButtonPressed": "boton [BTN] premsat ?",
    "microbit.isTilted": "clinat [DIRECTION] ?",
    "microbit.pinStateMenu.off": "off",
    "microbit.pinStateMenu.on": "on",
    "microbit.tiltAngle": "enclinason [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "Quin que siá",
    "microbit.tiltDirectionMenu.back": "darrièr",
    "microbit.tiltDirectionMenu.front": "davant",
    "microbit.tiltDirectionMenu.left": "esquèrra",
    "microbit.tiltDirectionMenu.right": "drecha",
    "microbit.whenButtonPressed": "quand lo boton [BTN] es premsat",
    "microbit.whenGesture": "quand [GESTURE]",
    "microbit.whenPinConnected": "quand lo pin [PIN] es connectat",
    "microbit.whenTilted": "qaund clinat [DIRECTION]",
    "music.categoryName": "Musica",
    "music.changeTempo": "cambiar lo tempò per [TEMPO]",
    "music.drumBass": "(2) Caissa gròssa",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charleston tampada",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Sonalha",
    "music.drumCrashCymbal": "(4) Cimbala Crash",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Trucamans",
    "music.drumOpenHiHat": "(5) Charleston",
    "music.drumSideStick": "(3) Baston de costat",
    "music.drumSnare": "(1) Caissa clara",
    "music.drumTambourine": "(7) Tamborin",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Blòc de fusta",
    "music.getTempo": "tempò",
    "music.instrumentBass": "(6) Bassa",
    "music.instrumentBassoon": "(14) Basson",
    "music.instrumentCello": "(8) Violoncèl",
    "music.instrumentChoir": "(15) Corala",
    "music.instrumentClarinet": "(10) Clarineta",
    "music.instrumentElectricGuitar": "(5) Guitara Electrica",
    "music.instrumentElectricPiano": "(2) Pianò Electric ",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Guitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Boita de musica",
    "music.instrumentOrgan": "(3) Òrgue",
    "music.instrumentPiano": "(1) Pianò",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofòn",
    "music.instrumentSteelDrum": "(18) Tonèl d'acièr",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombòn",
    "music.instrumentVibraphone": "(16) Vibrafòn",
    "music.instrumentWoodenFlute": "(13) Flauta de fusta",
    "music.midiPlayDrumForBeats": "jogar la percussion [DRUM] pendent [BEATS] pulsacions",
    "music.midiSetInstrument": "reglar l'instrument sus [INSTRUMENT] ",
    "music.playDrumForBeats": "jogar la percussion [DRUM] al batèc [BEATS]",
    "music.playNoteForBeats": "jogar la nòta [NOTE] pendent [BEATS] pulsacions",
    "music.restForBeats": "pausa pendent [BEATS] pulsacions",
    "music.setInstrument": "reglar l'instrument sus [INSTRUMENT] ",
    "music.setTempo": "reglar lo tempò sus [TEMPO]",
    "pen.categoryName": "Estilò",
    "pen.changeColorParam": "cambiar [COLOR_PARAM] del estilò per [VALUE]",
    "pen.changeHue": "cambiar la color del estilò per [HUE]",
    "pen.changeShade": "cambiar la nuança del estilò per [SHADE]",
    "pen.changeSize": "cambiar la talha del estilò per [SIZE]",
    "pen.clear": "escafar tot",
    "pen.colorMenu.brightness": "luminositat",
    "pen.colorMenu.color": "amagar totes las sprites",
    "pen.colorMenu.saturation": "saturacion",
    "pen.colorMenu.transparency": "transparéncia",
    "pen.penDown": "estilò pausat",
    "pen.penUp": "estilò levat",
    "pen.setColor": "reglar la color de l'estilò sus [COLOR]",
    "pen.setColorParam": "reglar [COLOR_PARAM] del estilò per [VALUE]",
    "pen.setHue": "reglar la color del estilò per [HUE]",
    "pen.setShade": "reglar la nuança del estilò per [SHADE]",
    "pen.setSize": "reglar la talha del estilò per [SIZE]",
    "pen.stamp": "sagel",
    "speech.defaultWhenIHearValue": "Es partit !",
    "speech.extensionName": "Parlar per escriure",
    "speech.listenAndWait": "escotar e esperar",
    "speech.speechReporter": "paraula",
    "speech.whenIHear": "quand ausissi [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Escriches de Dire",
    "text2speech.defaultTextToSpeak": "Adieu",
    "text2speech.giant": "gigant",
    "text2speech.kitten": "gaton",
    "text2speech.setLanguageBlock": "reglar la lenga sus [LANGUAGE]",
    "text2speech.setVoiceBlock": "reglar la votz sus [VOICE]",
    "text2speech.speakAndWaitBlock": "dire [WORDS]",
    "text2speech.squeak": "coïnar",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Revirar",
    "translate.defaultTextToTranslate": "adieu",
    "translate.translateBlock": "traduire [WORDS] en [LANGUAGE]",
    "translate.viewerLanguage": "lenga",
    "videoSensing.categoryName": "Percepcion de Video",
    "videoSensing.direction": "direccion",
    "videoSensing.motion": "moviment",
    "videoSensing.off": "off",
    "videoSensing.on": "on",
    "videoSensing.onFlipped": "on flipped",
    "videoSensing.setVideoTransparency": "reglar la transparéncia sus [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "scèna",
    "videoSensing.videoOn": "[ATTRIBUTE] de la vidèo sus [SUBJECT]",
    "videoSensing.videoToggle": "Comutar la video sus [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "quand lo moviment de video > [REFERENCE]",
    "wedo2.getDistance": "distància",
    "wedo2.getTiltAngle": "Anle d'enclinason [TILT_DIRECTION]",
    "wedo2.isTilted": "clinat [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "per aquí",
    "wedo2.motorDirection.forward": "per ailà",
    "wedo2.motorDirection.reverse": "endarrièr",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "totes los motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "Atudar lo motor [MOTOR_ID] ",
    "wedo2.motorOn": "Alucar lo motor [MOTOR_ID]",
    "wedo2.motorOnFor": "Alucar lo motor [MOTOR_ID] pendent [DURATION] segondas",
    "wedo2.playNoteFor": "jogar la nòta [NOTE] pendent [DURATION] segondas",
    "wedo2.setLightHue": "reglar la color del lum sus [HUE]",
    "wedo2.setMotorDirection": "reglar la direccion del motor [MOTOR_ID] cap a [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "reglar la poténcia del motor [MOTOR_ID] sus [POWER]",
    "wedo2.tiltDirection.any": "quin que siá",
    "wedo2.tiltDirection.down": "enbàs",
    "wedo2.tiltDirection.left": "esquèrra",
    "wedo2.tiltDirection.right": "drecha",
    "wedo2.tiltDirection.up": "ennaut",
    "wedo2.whenDistance": "quand la distància [OP] [REFERENCE]",
    "wedo2.whenTilted": "quand clinat  [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturacion",
    "paint.paintEditor.brightness": "Luminositat",
    "paint.paintEditor.costume": "Costum",
    "paint.paintEditor.group": "Grop",
    "paint.paintEditor.ungroup": "Desgroupar",
    "paint.paintEditor.undo": "Anullar",
    "paint.paintEditor.redo": "Tornar far",
    "paint.paintEditor.forward": "Endavant",
    "paint.paintEditor.backward": "Endarrièr",
    "paint.paintEditor.front": "Davant",
    "paint.paintEditor.back": "Endarrièr",
    "paint.paintEditor.more": "Mai",
    "paint.modeTools.brushSize": "Talha",
    "paint.modeTools.eraserSize": "Talha de la goma",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Pegar",
    "paint.modeTools.delete": "Escafar",
    "paint.modeTools.curved": "Corbat",
    "paint.modeTools.pointed": "Ponchut",
    "paint.modeTools.thickness": "Espessor",
    "paint.modeTools.flipHorizontal": "Revirar Orizontalement",
    "paint.modeTools.flipVertical": "Revirar Verticalement",
    "paint.modeTools.filled": "Emplenat",
    "paint.modeTools.outlined": "Suslinhat",
    "paint.paintEditor.bitmap": "Convertir en Bitmap",
    "paint.paintEditor.vector": "Convertir en Vectors",
    "paint.paintEditor.fill": "Emplenar",
    "paint.paintEditor.stroke": "Suslinhar",
    "paint.brushMode.brush": "Bròssa",
    "paint.eraserMode.eraser": "Goma",
    "paint.fillMode.fill": "Emplenar",
    "paint.lineMode.line": "Linha",
    "paint.ovalMode.oval": "Cercle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Remodelar",
    "paint.roundedRectMode.roundedRect": "Rectangle arredondit",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Tèxt",
    "paint.colorPicker.swap": "Escambiar"
  },
  "or": {
    "gui.alerts.lostPeripheralConnection": "ସ୍କ୍ରାଚ୍ {extensionName} ସହିତ ସଂଯୋଗ ହରାଇଲା",
    "gui.alerts.tryAgain": "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
    "gui.alerts.download": "ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
    "gui.connection.reconnect": "ପୁଣି ସଂଯୋଗ କରନ୍ତୁ",
    "gui.backpack.costumeLabel": "ପୋଷାକ",
    "gui.backpack.soundLabel": "ଧ୍ୱନି",
    "gui.backpack.scriptLabel": "ସ୍କ୍ରିପ୍ଟ (ଲେଖା)",
    "gui.backpack.spriteLabel": "ସ୍ପ୍ରାଇଟ",
    "gui.backpack.header": "ବ୍ୟାକପ୍ୟାକ୍",
    "gui.backpack.errorBackpack": "ବ୍ୟାକପ୍ୟାକ୍ ଲୋଡ୍ କରିବାରେ ତ୍ରୁଟି",
    "gui.backpack.loadingBackpack": "ଲୋଡିଂ...",
    "gui.backpack.more": "ଆଉ",
    "gui.backpack.emptyBackpack": "ବ୍ୟାକପ୍ୟାକ୍ ଖାଲି ଅଛି",
    "gui.unsupportedBrowser.label": "ବ୍ରାଉଜର୍ ସମର୍ଥିତ ନୁହେଁ",
    "gui.unsupportedBrowser.errorLabel": "ଗୋଟାଏ ଭୂଲ୍ ହେଇଛି",
    "gui.unsupportedBrowser.notRecommended": "ଆମେ ବହୁତ ଦୁଖିତ, କିନ୍ତୁ ଏହା ଦେଖାଯାଉଛି ଯେ ଆପଣ ଏକ ବ୍ରାଉଜର୍ ସଂସ୍କରଣ ବ୍ୟବହାର କରୁଛନ୍ତି ଯାହା ସ୍କ୍ରାଚ୍ ସମର୍ଥନ କରେ ନାହିଁ | ଗୁଗୁଲ୍ କ୍ରୋମ୍, ମୋଜିଲା ଫାୟାରଫକ୍ସ, ମାଇକ୍ରୋସଫ୍ଟ ଏଜ୍ କିମ୍ବା ଆପଲ୍ ସଫାରି ପରି ଏକ ସମର୍ଥିତ ବ୍ରାଉଜରର ଅତ୍ୟାଧୁନିକ ସଂସ୍କରଣକୁ ଅପଡେଟ୍ କରିବାକୁ ଆମେ ସୁପାରିଶ କରୁ",
    "gui.unsupportedBrowser.description": "ଆମେ ବହୁତ ଦୁଖିତ, କିନ୍ତୁ ସ୍କ୍ରାଚ୍ ଏହି ବ୍ରାଉଜରକୁ ସମର୍ଥନ କରେନାହିଁ | ଗୁଗୁଲ୍ କ୍ରୋମ୍, ମୋଜିଲା ଫାୟାରଫକ୍ସ, ମାଇକ୍ରୋସଫ୍ଟ ଏଜ୍ କିମ୍ବା ଆପଲ୍ ସଫାରି ପରି ଏକ ସମର୍ଥିତ ବ୍ରାଉଜରର ସର୍ବଶେଷ ଭର୍ସନ (ସଂସ୍କରଣ)କୁ ଅପଡେଟ୍ କରିବାକୁ ଆମେ ସୁପାରିଶ କରୁ",
    "gui.unsupportedBrowser.back": "ପଛକୁ",
    "gui.unsupportedBrowser.previewfaq": "ଅଧିକ ଜାଣିବାକୁ, {previewFaqLink} ଲିଙ୍କ୍କୁ ଯାଆନ୍ତୁ",
    "gui.unsupportedBrowser.previewfaqlinktext": "ବାରମ୍ବାର ପଚରାଯାଉଥିବା ପ୍ରଶ୍ନଗୁଡିକ (FAQ)",
    "gui.cards.all-tutorials": "ଟ୍ୟୁଟୋରିଆଲ୍",
    "gui.cards.shrink": "ସଙ୍କୋଚନ କରନ୍ତୁ",
    "gui.cards.expand": "ବିସ୍ତାର କରନ୍ତୁ",
    "gui.cards.close": "ବନ୍ଦ",
    "gui.cards.more-things-to-try": "ଚେଷ୍ଟା କରିବାକୁ ଅଧିକ ଜିନିଷ!",
    "gui.cards.see-more": "ଆଉ ଦେଖନ୍ତୁ",
    "gui.comingSoon.message1": "ବ୍ୟସ୍ତ ହୁଅନ୍ତୁ ନାହିଁ, ଆମେ ଏହା ଉପରେ କାମ କରୁଛୁ {emoji}",
    "gui.comingSoon.message2": "ଶୀଘ୍ର ଆସୁଅଛି...",
    "gui.comingSoon.message3": "ଆମେ ଏହା ଉପରେ କାମ କରୁଛୁ {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "କୌଣସି ଡିଭାଇସ ମିଳିଲା ନାହିଁ",
    "gui.connection.auto-scanning.prescan": "ଆପଣଙ୍କର ଡିଭାଇସ୍ ପାଖରେ ରଖନ୍ତୁ, ତାପରେ ଖୋଜିବା ଆରମ୍ଭ କରନ୍ତୁ",
    "gui.connection.auto-scanning.pressbutton": "ଆପଣଙ୍କ ଡିଭାଇସରେ ବଟନ୍ ଦବାନ୍ତୁ",
    "gui.connection.auto-scanning.start-search": "ସନ୍ଧାନ ଆରମ୍ଭ କରନ୍ତୁ",
    "gui.connection.connecting-searchbutton": "ଖୋଜୁଛି ...",
    "gui.connection.auto-scanning.try-again": "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "ସଂଯୋଗ ହୋଇଛି",
    "gui.connection.disconnect": "ବିଚ୍ଛିନ୍ନ କରନ୍ତୁ",
    "gui.connection.go-to-editor": "ସମ୍ପାଦକକୁ ଯାଆନ୍ତୁ",
    "gui.connection.connecting-cancelbutton": "ସଂଯୋଗ କରୁଛୁ...",
    "gui.connection.error.errorMessage": "ଦେଖାଯାଉଛି କିଛି ଭୁଲ୍ ହୋଇଛି",
    "gui.connection.error.tryagainbutton": "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
    "gui.connection.error.helpbutton": "ସାହାଯ୍ୟ",
    "gui.connection.peripheral-name-label": "ଡିଭାଇସ ନାମ",
    "gui.connection.connect": "ସଂଯୋଗ କରନ୍ତୁ",
    "gui.connection.scanning.lookingforperipherals": "ଡିଭାଇସ ଖୋଜୁଛି",
    "gui.connection.scanning.noPeripheralsFound": "କୌଣସି ଡିଭାଇସ ମିଳିଲା ନାହିଁ",
    "gui.connection.scanning.instructions": "ଉପର ତାଲିକାରେ ଆପଣଙ୍କର ଡିଭାଇସ୍ ବାଛନ୍ତୁ",
    "gui.connection.search": "ସତେଜ କରନ୍ତୁ",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣଙ୍କର ସ୍କ୍ରାଚ୍ ଲିଙ୍କ୍ ସଂସ୍ଥାପିତ ଏବଂ ଚାଲୁଛି",
    "gui.connection.unavailable.enablebluetooth": "ଯାଞ୍ଚ କରନ୍ତୁ ଯେ ବ୍ଲୁଟୁଥ୍ ସକ୍ଷମ ହୋଇଛି",
    "gui.connection.unavailable.tryagainbutton": "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
    "gui.connection.unavailable.helpbutton": "ସାହାଯ୍ୟ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "ଯାଅ",
    "gui.controls.stop": "ବନ୍ଦ କର",
    "gui.crashMessage.label": "ଓହୋ! କିଛି ଭୁଲ ହୋଇ ଗଲା।",
    "gui.crashMessage.description": "ଆମେ ବହୁତ ଦୁଖିତ, କିନ୍ତୁ ଦେଖାଯାଉଛି ସ୍କ୍ରାଚ୍ ଦୁର୍ଘଟଣାଗ୍ରସ୍ତ ହୋଇଛି ଏହି ବଗ୍ ସ୍ୱୟଂଚାଳିତ ଭାବରେ ସ୍କ୍ରାଚ୍ ଦଳକୁ ରିପୋର୍ଟ କରାଯାଇଛି ପୁନର୍ବାର ଚେଷ୍ଟା କରିବାକୁ ଦୟାକରି ଆପଣଙ୍କର ପେଜ ରିଫ୍ରେଶ (page refresh) କରନ୍ତୁ",
    "gui.crashMessage.errorNumber": "ଆପଣଙ୍କର ତ୍ରୁଟି id {errorId} ସହିତ ଲଗ୍ ହୋଇଛି",
    "gui.crashMessage.reload": "ପୁଣି ଲୋଡ୍ କରନ୍ତୁ",
    "gui.customProcedures.myblockModalTitle": "ଏକ ବ୍ଲକ ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "gui.customProcedures.addAnInputNumberText": "ଏକ ଇନପୁଟ୍ ଯୋଡନ୍ତୁ",
    "gui.customProcedures.numberTextType": "ସଂଖ୍ୟା କିମ୍ବା ବର୍ଣ୍ଣ",
    "gui.customProcedures.addAnInputBoolean": "ଏକ ଇନପୁଟ୍ ଯୋଡନ୍ତୁ",
    "gui.customProcedures.booleanType": "ବୁଲିଅନ୍",
    "gui.customProcedures.addALabel": "ଏକ ଲେବଲ୍ ଯୋଡନ୍ତୁ",
    "gui.customProcedures.runWithoutScreenRefresh": "ସ୍କ୍ରିନ୍ ସତେଜ ବିନା ଚଲାନ୍ତୁ",
    "gui.customProcedures.cancel": "ବାତିଲ୍ କରନ୍ତୁ",
    "gui.customProcedures.ok": "ଠିକ୍ ଅଛି",
    "gui.SpriteInfo.direction": "ଦିଗ",
    "gui.directionPicker.rotationStyles.allAround": "ଚାରିଆଡେ",
    "gui.directionPicker.rotationStyles.leftRight": "ବାମ/ଡାହାଣ",
    "gui.directionPicker.rotationStyles.dontRotate": "ଘୁରାଅ ନାହିଁ",
    "gui.gui.addExtension": "ଏକ୍ସଟେନ୍ସନ୍ ଯୋଡନ୍ତୁ",
    "gui.gui.codeTab": "କୋଡ୍",
    "gui.gui.backdropsTab": "ପୃଷ୍ଠପଟ (ବେକଡ୍ରପ)",
    "gui.gui.costumesTab": "ପୋଷାକ",
    "gui.gui.soundsTab": "ଧ୍ୱନି",
    "gui.extensionLibrary.comingSoon": "ଶୀଘ୍ର ଆସୁଅଛି",
    "gui.extensionLibrary.requires": "ଆବଶ୍ୟକ କରେ",
    "gui.extensionLibrary.collaboration": "ସହଯୋଗ ସହିତ",
    "gui.library.filterPlaceholder": "ଖୋଜ",
    "gui.library.allTag": "ସମସ୍ତ",
    "gui.loader.message1": "ବ୍ଲକଗୁଡିକ ସୃଷ୍ଟି କରିବା…",
    "gui.loader.message2": "ସ୍ପ୍ରାଇଟସ ଲୋଡିଂ…",
    "gui.loader.message3": "ଧ୍ୱନି ଲୋଡିଂ…",
    "gui.loader.message4": "ଏକ୍ସଟେନ୍ସନ୍ ଲୋଡିଙ୍ଗ୍…",
    "gui.loader.message5": "ପଶୁପାଳନ…",
    "gui.loader.message6": "ନାନୋସ୍ ପ୍ରସାରଣ…",
    "gui.loader.message7": "ଇନଫ୍ଲେଟିଂ ଗୋବୋସ୍…",
    "gui.loader.message8": "ଇମୋଜି ପ୍ରସ୍ତୁତ କରିବା…",
    "gui.loader.headline": "ଲୋଡିଂ ପ୍ରୋଜେକ୍ଟ",
    "gui.loader.creating": "ପ୍ରୋଜେକ୍ଟ ସୃଷ୍ଟି କରିବା",
    "gui.accountMenu.profile": "ପ୍ରୋଫାଇଲ୍",
    "gui.accountMenu.myStuff": "ମୋର ଷ୍ଟଫ୍",
    "gui.accountMenu.myClasses": "ମୋ କ୍ଲାସ୍",
    "gui.accountMenu.myClass": "ମୋ କ୍ଲାସ୍",
    "gui.accountMenu.accountSettings": "ଖାତା ସେଟିଂ",
    "gui.accountMenu.signOut": "ସାଇନ ଆଉଟ",
    "gui.authorInfo.byUser": "{username} ଦ୍ୱାରା ",
    "gui.menuBar.seeProjectPage": "ପ୍ରୋଜେକ୍ଟ ପୃଷ୍ଠା ଦେଖନ୍ତୁ",
    "gui.menuBar.language": "Language",
    "general.username": "ୟୁଜର ନେମ୍",
    "general.password": "ପାସୱାର୍ଡ",
    "general.signIn": "ସାଇନ ଇନ୍",
    "login.needHelp": "ସାହାଯ୍ୟ ଦରକାର କି?",
    "form.validationRequired": "ଏହି ଫିଲ୍ଡ୍ ଦରକାର",
    "gui.menuBar.tutorialsLibrary": "ଟ୍ୟୁଟୋରିଆଲ୍",
    "gui.menuBar.restoreSprite": "ସ୍ପ୍ରାଇଟ ପୁନରୁଦ୍ଧାର(ରିସ୍ଟୋର) କରନ୍ତୁ",
    "gui.menuBar.restoreSound": "ଧ୍ୱନି ପୁନରୁଦ୍ଧାର(ରିସ୍ଟୋର) କରନ୍ତୁ",
    "gui.menuBar.restoreCostume": "ପୋଷାକ ପୁନରୁଦ୍ଧାର(ରିସ୍ଟୋର) କରନ୍ତୁ",
    "gui.menuBar.restore": "ପୁନରୁଦ୍ଧାର(ରିସ୍ଟୋର) କରନ୍ତୁ",
    "gui.menuBar.saveNow": "ବର୍ତ୍ତମାନ ସେଭ୍ କରନ୍ତୁ",
    "gui.menuBar.saveAsCopy": "ଏକ କପି ଭାବରେ ସେଭ୍ କରନ୍ତୁ",
    "gui.menuBar.remix": "ରିମିକ୍ସ",
    "gui.menuBar.new": "ନୂତନ",
    "gui.menuBar.file": "ଫାଇଲ୍",
    "gui.menuBar.downloadToComputer": "ଆପଣଙ୍କ କମ୍ପ୍ୟୁଟରକୁ ସେଭ୍ କରନ୍ତୁ",
    "gui.menuBar.edit": "ସଂପାଦନା କରନ୍ତୁ",
    "gui.menuBar.turboModeOff": "ଟର୍ବୋ ମୋଡ୍ ବନ୍ଦ(ଅଫ) କରନ୍ତୁ",
    "gui.menuBar.turboModeOn": "ଟର୍ବୋ ମୋଡ୍ ଟର୍ନ୍ ଅନ୍ କରନ୍ତୁ",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "ସ୍କ୍ରାଚ୍ ରେ ଯୋଗ ଦିଅନ୍ତୁ",
    "gui.menuBar.signIn": "ସାଇନ୍‌ ଇନ୍‌",
    "gui.gui.projectTitlePlaceholder": "ପ୍ରୋଜେକ୍ଟ ଟାଇଟଲ୍ ଏଠାରେ",
    "gui.menuBar.saveNowLink": "ବର୍ତ୍ତମାନ ସଞ୍ଚୟ କରନ୍ତୁ",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "ଅଂଶୀଦାର",
    "gui.menuBar.share": "ଅଂଶୀଦାର କରନ୍ତୁ",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "ସାହାଯ୍ୟ",
    "gui.modal.back": "ପଛକୁ",
    "gui.monitor.listMonitor.empty": "(ଖାଲି)",
    "gui.monitor.listMonitor.listLength": "ଦର୍ଘ୍ୟ {length}",
    "gui.monitor.contextMenu.default": "ସାଧାରଣ ପଠନ",
    "gui.monitor.contextMenu.large": "ବଡ଼ ପଠନ",
    "gui.monitor.contextMenu.slider": "ସ୍ଲାଇଡର୍",
    "gui.monitor.contextMenu.sliderRange": "ସ୍ଲାଇଡର୍ ରେଞ୍ଜ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.monitor.contextMenu.import": "ଆମଦାନି (ଇମ୍ପୋର୍ଟ)",
    "gui.monitor.contextMenu.export": "ରପ୍ତାନି (ଏକ୍ସପୋର୍ଟ)",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "ଖେଳନ୍ତୁ",
    "gui.playButton.stop": "ବନ୍ଦ କର",
    "gui.gui.variableScopeOptionAllSprites": "ସମସ୍ତ ସ୍ପ୍ରାଇଟ ପାଇଁ",
    "gui.gui.variableScopeOptionSpriteOnly": "କେବଳ ଏହି ସ୍ପ୍ରାଇଟ ପାଇଁ",
    "gui.gui.cloudVariableOption": "କ୍ଲାଉଡ୍ ଭେରିଏବଲ୍ (ସର୍ଭରରେ ଗଚ୍ଛିତ)",
    "gui.gui.variablePromptAllSpritesMessage": "ଏହି ଭେରିଏବଲ୍ ସମସ୍ତ ସ୍ପ୍ରାଇଟସ ପାଇଁ ଉପଲବ୍ଧ ହେବ",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "ବାତିଲ୍ କରନ୍ତୁ",
    "gui.prompt.ok": "ଠିକ୍ ଅଛି",
    "gui.playbackStep.stopMsg": "ବନ୍ଦ କର",
    "gui.playbackStep.playMsg": "ଖେଳନ୍ତୁ",
    "gui.playbackStep.loadingMsg": "ଲୋଡିଂ ...",
    "gui.playbackStep.saveMsg": "ସଞ୍ଚୟ କରନ୍ତୁ",
    "gui.playbackStep.reRecordMsg": "ପୁଣି ରେକର୍ଡ କରନ୍ତୁ",
    "gui.recordModal.title": "ରେକର୍ଡ ସାଉଣ୍ଡ",
    "gui.recordingStep.beginRecord": "ନିମ୍ନରେ ଥିବା ବଟନ୍ କ୍ଲିକ୍ କରି ରେକର୍ଡିଂ ଆରମ୍ଭ କରନ୍ତୁ",
    "gui.recordingStep.permission": "{arrow} ଆପଣଙ୍କର ମାଇକ୍ରୋଫୋନ୍ ବ୍ୟବହାର କରିବାକୁ ଆମେ ଆପଣଙ୍କର ଅନୁମତି ଆବଶ୍ୟକ କରୁ",
    "gui.recordingStep.stop": "ରେକର୍ଡିଂ ବନ୍ଦ କରନ୍ତୁ",
    "gui.recordingStep.record": "ରେକର୍ଡ କରନ୍ତୁ",
    "gui.sliderModal.min": "ସର୍ବନିମ୍ନ ମୂଲ୍ୟ",
    "gui.sliderModal.max": "ସର୍ବାଧିକ ମୂଲ୍ୟ",
    "gui.sliderModal.title": "ସ୍ଲାଇଡର୍ ରେଞ୍ଜ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.sliderPrompt.cancel": "ବାତିଲ୍ କରନ୍ତୁ",
    "gui.sliderPrompt.ok": "ଠିକ୍ ଅଛି",
    "gui.soundEditor.sound": "ଶବ୍ଦ",
    "gui.soundEditor.play": "ଖେଳନ୍ତୁ",
    "gui.soundEditor.stop": "ବନ୍ଦ କର",
    "gui.soundEditor.copy": "କପି କରନ୍ତୁ",
    "gui.soundEditor.paste": "ପେଷ୍ଟ କରନ୍ତୁ",
    "gui.soundEditor.copyToNew": "ନୂତନକୁ କପି କରନ୍ତୁ",
    "gui.soundEditor.delete": "ବିଲୋପ କରନ୍ତୁ",
    "gui.soundEditor.save": "ସଞ୍ଚୟ କରନ୍ତୁ",
    "gui.soundEditor.undo": "ପ୍ରତ୍ୟାଶିତ କରନ୍ତୁ (undo)",
    "gui.soundEditor.redo": "ପୁନର୍ବାର କରନ୍ତୁ",
    "gui.soundEditor.faster": "ଶୀଘ୍ର",
    "gui.soundEditor.slower": "ଧୀର",
    "gui.soundEditor.echo": "ଇକୋ",
    "gui.soundEditor.robot": "ରୋବଟ୍",
    "gui.soundEditor.louder": "ଉଚ୍ଚ ସ୍ୱର",
    "gui.soundEditor.softer": "ନରମ",
    "gui.soundEditor.reverse": "ଓଲଟା",
    "gui.soundEditor.fadeOut": "ଫେଡ ଆଉଟ",
    "gui.soundEditor.fadeIn": "ଫେଡ ଇନ",
    "gui.soundEditor.mute": "ଶବ୍ଦ ବନ୍ଦ",
    "gui.SpriteInfo.spritePlaceholder": "ନାମ",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "ସ୍ପ୍ରାଇଟ",
    "gui.SpriteInfo.show": "ଦେଖାନ୍ତୁ",
    "gui.SpriteInfo.size": "ଆକାର",
    "gui.spriteSelectorItem.contextMenuDuplicate": "ନକଲ",
    "gui.spriteSelectorItem.contextMenuExport": "ରପ୍ତାନି (ଏକ୍ସପୋର୍ଟ)",
    "gui.spriteSelectorItem.contextMenuDelete": "ଡିଲିଟ୍ କରନ୍ତୁ",
    "gui.spriteSelector.addSpriteFromLibrary": "ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.spriteSelector.addSpriteFromPaint": "ରଙ୍ଗ କରନ୍ତୁ",
    "gui.spriteSelector.addSpriteFromSurprise": "ଆଶ୍ଚର୍ଯ୍ୟ",
    "gui.spriteSelector.addSpriteFromFile": "ସ୍ପ୍ରାଇଟ ଅପଲୋଡ୍ କରନ୍ତୁ",
    "gui.stageHeader.stageSizeLarge": "ବଡ଼ ମଞ୍ଚକୁ ଯାଆନ୍ତୁ",
    "gui.stageHeader.stageSizeSmall": "ଛୋଟ ମଞ୍ଚକୁ ଯାଆନ୍ତୁ",
    "gui.stageHeader.stageSizeFull": "ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍ ମୋଡ୍ ପ୍ରବେଶ କରନ୍ତୁ",
    "gui.stageHeader.stageSizeUnFull": "ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍ ମୋଡ୍ ଛାଡନ୍ତୁ",
    "gui.stageHeader.fullscreenControl": "ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍ ନିୟନ୍ତ୍ରଣ",
    "gui.spriteSelector.addBackdropFromLibrary": "ଏକ ପୃଷ୍ଠଭୂମି(ବେକଡ୍ରପ) ବାଛନ୍ତୁ",
    "gui.stageSelector.addBackdropFromPaint": "ରଙ୍ଗ କରନ୍ତୁ",
    "gui.stageSelector.addBackdropFromSurprise": "ଆଶ୍ଚର୍ଯ୍ୟ",
    "gui.stageSelector.addBackdropFromFile": "ପୃଷ୍ଠଭୂମି(ବେକଡ୍ରପ) ଅପଲୋଡ୍ କରନ୍ତୁ",
    "gui.stageSelector.stage": "ପର୍ଯ୍ୟାୟ/ମଞ୍ଚ",
    "gui.stageSelector.backdrops": "ପୃଷ୍ଠପଟ(ବେକଡ୍ରପ) ଗୁଡିକ",
    "gui.telemetryOptIn.label": "ସ୍କ୍ରାଚ୍ ଉନ୍ନତି କରିବାକୁ ପରିସଂଖ୍ୟାନ ରିପୋର୍ଟ କରନ୍ତୁ",
    "gui.telemetryOptIn.body1": "ସ୍କ୍ରାଚ୍ ଦଳ ସର୍ବଦା ବିଶ୍ୱରେ ସ୍କ୍ରାଚ୍ କିପରି ବ୍ୟବହାର କରାଯାଏ ତାହା ଭଲ ଭାବରେ ବୁଝିବାକୁ ଚାହିଁଥାଏ । ଏହି ପ୍ରୟାସକୁ ସମର୍ଥନ କରିବାରେ ସାହାଯ୍ୟ କରିବାକୁ, ଆପଣ ସ୍କ୍ରାଚ୍ ଦଳକୁ ସ୍ୱୟଂଚାଳିତ ଭାବରେ ବ୍ୟବହାର ସୂଚନା ପଠାଇବାକୁ ଅନୁମତି ଦେଇପାରିବେ |",
    "gui.telemetryOptIn.body2": "ଆମେ ସଂଗ୍ରହ କରୁଥିବା ସୂଚନାରେ ଭାଷା ଚୟନ, ବ୍ଲକ୍ ବ୍ୟବହାର ଏବଂ କିଛି ଘଟଣା ଯେପରିକି ଏକ ପ୍ରୋଜେକ୍ଟ ସଞ୍ଚୟ, ଲୋଡିଂ ଏବଂ ଅପଲୋଡ୍ ଅନ୍ତର୍ଭୁକ୍ତ| ଆମେ କୌଣସି ବ୍ୟକ୍ତିଗତ ସୂଚନା ସଂଗ୍ରହ କରୁ ନାହିଁ । ଅଧିକ ସୂଚନା ପାଇଁ ଦୟାକରି ଆମର {privacyPolicyLink} ଦେଖନ୍ତୁ |",
    "gui.telemetryOptIn.privacyPolicyLink": "ଗୋପନୀୟତା ନୀତି",
    "gui.telemetryOptIn.optInText": "ସ୍କ୍ରାଚ୍ ଟିମ୍ ସହିତ ମୋର ବ୍ୟବହାର ତଥ୍ୟ ଅଂଶୀଦାର କରନ୍ତୁ",
    "gui.telemetryOptIn.optInTooltip": "ଟେଲିମେଟ୍ରି ସକ୍ଷମ କରନ୍ତୁ",
    "gui.telemetryOptIn.optOutText": "ସ୍କ୍ରାଚ୍ ଟିମ୍ ସହିତ ମୋର ବ୍ୟବହାର ତଥ୍ୟ ଅଂଶୀଦାର କରନ୍ତୁ ନାହିଁ",
    "gui.telemetryOptIn.optOutTooltip": "ଟେଲିମେଟ୍ରି ନିଷ୍କ୍ରିୟ କରନ୍ତୁ",
    "gui.telemetryOptIn.settingWasUpdated": "ଆପଣଙ୍କର ସେଟିଂ ଅଦ୍ୟତନ କରାଯାଇଥିଲା |",
    "gui.telemetryOptIn.buttonClose": "ବନ୍ଦ କରନ୍ତୁ",
    "gui.turboMode.active": "ଟର୍ବୋ ମୋଡ୍",
    "gui.webglModal.label": "ଆପଣଙ୍କର ବ୍ରାଉଜର୍ WebGL କୁ ସମର୍ଥନ କରେନାହିଁ",
    "gui.webglModal.description": "ଦୁର୍ଭାଗ୍ୟବଶତ ଏହା ଆପଣଙ୍କର ବ୍ରାଉଜର୍ କିମ୍ବା କମ୍ପ୍ୟୁଟର {webGlLink} ପରି ଦେଖାଯାଉଛି | ସ୍କ୍ରାଚ୍ 3.0 ଚାଲିବା ପାଇଁ ଏହି ଟେକ୍ନୋଲୋଜି ଆବଶ୍ୟକ",
    "gui.webglModal.webgllink": "WebGL କୁ ସମର୍ଥନ କରେନାହିଁ",
    "gui.webglModal.back": "ପଛକୁ",
    "gui.webglModal.previewfaq": "ଅଧିକ ଜାଣିବାକୁ, {previewFaqLink}କୁ ଯାଆନ୍ତୁ",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.costumeLibrary.chooseACostume": "ଏକ ପୋଷାକ ବାଛନ୍ତୁ",
    "gui.costumeTab.addBackdropFromLibrary": "ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.costumeTab.addCostumeFromLibrary": "ଏକ ପୋଷାକ ବାଛନ୍ତୁ",
    "gui.costumeTab.addBlankCostume": "ରଙ୍ଗ କରନ୍ତୁ",
    "gui.costumeTab.addSurpriseCostume": "ଆଶ୍ଚର୍ଯ୍ୟ",
    "gui.costumeTab.addFileBackdrop": "ପୃଷ୍ଠଭୂମି ଅପଲୋଡ୍ କରନ୍ତୁ",
    "gui.costumeTab.addFileCostume": "ପୋଷାକ ଅପଲୋଡ୍ କରନ୍ତୁ",
    "gui.extensionLibrary.chooseAnExtension": "ଏକ ଏକ୍ସଟେନ୍ସନ୍ ବାଛନ୍ତୁ",
    "gui.extensionLibrary.extensionUrl": "ଏକ୍ସଟେନ୍ସନ୍ର URL ଦିଅନ୍ତୁ ",
    "gui.monitors.importListColumnPrompt": "କେଉଁ ସ୍ତମ୍ଭ (କଲମ) ବ୍ୟବହାର କରାଯିବା ଉଚିତ୍ (1- {numberOfColumns})?",
    "gui.recordingStep.alertMsg": "ରେକର୍ଡିଂ ଆରମ୍ଭ କରିପାରିଲା ନାହିଁ",
    "gui.soundLibrary.chooseASound": "ଏକ ଧ୍ୱନି ବାଛନ୍ତୁ",
    "gui.soundTab.fileUploadSound": "ଧ୍ୱନି ଅପଲୋଡ୍ କରନ୍ତୁ",
    "gui.soundTab.surpriseSound": "ଆଶ୍ଚର୍ଯ୍ୟ",
    "gui.soundTab.recordSound": "ରେକର୍ଡ କରନ୍ତୁ",
    "gui.soundTab.addSoundFromLibrary": "ଏକ ଧ୍ୱନି ବାଛନ୍ତୁ",
    "gui.spriteLibrary.chooseASprite": "ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.tipsLibrary.tutorials": "ଏକ ଟ୍ୟୁଟୋରିଆଲ୍ ବାଛନ୍ତୁ",
    "gui.alerts.createsuccess": "ନୂତନ ପ୍ରକଳ୍ପ ସୃଷ୍ଟି",
    "gui.alerts.createcopysuccess": "ପ୍ରୋଜେକ୍ଟ ଏକ କପି ଭାବରେ ସେଭ୍ ହୋଇଛି",
    "gui.alerts.createremixsuccess": "ପ୍ରୋଜେକ୍ଟ ଏକ ରିମିକ୍ସ ଭାବରେ ସେଭ୍ ହୋଇଛି",
    "gui.alerts.creating": "ନୂତନ ସୃଷ୍ଟି…",
    "gui.alerts.creatingCopy": "ପ୍ରୋଜେକ୍ଟ କପି…",
    "gui.alerts.creatingRemix": "ରିମିକ୍ସ ପ୍ରୋଜେକ୍ଟ…",
    "gui.alerts.creatingError": "ପ୍ରକଳ୍ପ ସୃଷ୍ଟି କରିପାରିଲା ନାହିଁ ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ!",
    "gui.alerts.savingError": "ପ୍ରକଳ୍ପ ସଞ୍ଚୟ କରିପାରିଲା ନାହିଁ",
    "gui.alerts.savesuccess": "ପ୍ରୋଜେକ୍ଟ ସଞ୍ଚୟ ହୋଇଛି",
    "gui.alerts.saving": "ପ୍ରୋଜେକ୍ଟ ସଞ୍ଚୟ…",
    "gui.alerts.cloudInfo": "ଦୟାକରି ଧ୍ୟାନ ଦିଅନ୍ତୁ, କ୍ଲାଉଡ୍ ଭେରିଏବଲ୍ କେବଳ ସଂଖ୍ୟାକୁ ସମର୍ଥନ କରେ, କ୍ୟାରକ୍ଟର କିମ୍ବା ସିମବଲ ନୁହେଁ {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "ଆଉ ସିଖନ୍ତୁ",
    "gui.alerts.importing": "ଆମଦାନି…",
    "gui.defaultProject.meow": "ମିଆଉଁ",
    "gui.defaultProject.variable": "ମୋ ଭେରିଏବଲ୍",
    "gui.howtos.intro-move-sayhello-hat.name": "ଆରମ୍ଭ କରୁଛି",
    "gui.howtos.intro-move.step_stepMove": "ଏକ ମୁଭ୍ ବ୍ଲକ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepSay": "ଗୋଟିଏ କହିବା ବ୍ଲକ ଯୋଗ କରନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "ଆରମ୍ଭ କରିବାକୁ ସବୁଜ ପତାକା କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "ଏକ ନାମ ଆନିମେଟ କରନ୍ତୁ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "ଏକ ଚିଠି ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "କ୍ଲିକ୍ କଲାବେଳେ ଏକ ଧ୍ୱନି ବଜାନ୍ତୁ",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "ଅନ୍ୟ ଏକ କ୍ୟାରକ୍ଟର ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "ରଙ୍ଗ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.animate-a-name.step_AnimateSpin": "ଅନ୍ୟ ଏକ ଅକ୍ଷର ସ୍ପ୍ରାଇଟ ବାଛ ଏବଂ ଏହାକୁ ସ୍ପିନ୍ କର",
    "gui.howtos.animate-a-name.step_AnimateGrow": "ଅନ୍ୟ ଏକ ଅକ୍ଷର ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ ଏବଂ ଏହାକୁ ବଢ଼ାନ୍ତୁ ",
    "gui.howtos.imagine": "ଏକ ବିଶ୍ୱ କଳ୍ପନା କର",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "ଆପଣ ଯାହା କହିବାକୁ ଚାହୁଁଛନ୍ତି ଟାଇପ୍ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "ଆରମ୍ଭ କରିବାକୁ ସବୁଜ ପତାକା କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "ଯେ କୌଣସି ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChooseSprite": "ଯେ କୌଣସି ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.imagine.step_imagineFlyAround": "ଗ୍ଲାଇଡ୍ ପାଇଁ ସ୍ପେସ୍ କୀ ଦବାନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "ଅନ୍ୟ ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.imagine.step_imagineLeftRight": "ବାମ-ଡାହାଣକୁ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.imagine.step_imagineUpDown": "ଉପର କିମ୍ବା ତଳକୁ ଘୁଞ୍ଚନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChangeCostumes": "ପୋଷାକ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineGlideToPoint": "ଏକ ବିନ୍ଦୁ ପାଖକୁ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineGrowShrink": "ବଢ଼ାନ୍ତୁ ଏବଂ ସଙ୍କୋଚନ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "ଅନ୍ୟ ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "ବ୍ୟାକଡ୍ରପ୍ ସୁଇଚ୍ କରନ୍ତୁ",
    "gui.howtos.imagine.step_imagineRecordASound": "ଏକ ଧ୍ୱନି ଯୋଡନ୍ତୁ",
    "gui.howtos.imagine.step_imagineChooseSound": "ତୁମର ଧ୍ୱନି ବାଛ",
    "gui.howtos.make-music.name": "ସଂଗୀତ ପ୍ରସ୍ତୁତ କର",
    "gui.howtos.Make-Music.step_PickInstrument": "ଏକ ଇନଷ୍ଟ୍ରୁମେଣ୍ଟ୍ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.Make-Music.step_PlaySoundClick": "କ୍ଲିକ୍ କଲାବେଳେ ଧ୍ୱନି ଚଲାନ୍ତୁ",
    "gui.howtos.Make-Music.step_MakeSong": "ଏକ ଗୀତ ସୃଷ୍ଟି କରନ୍ତୁ",
    "gui.howtos.make-music.step_MakeBeat": "ଏକ ଡ୍ରମ୍ ବାଛନ୍ତୁ ଏବଂ ଏକ ବିଟ୍ ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "gui.howtos.make-music.step_MakeBeatBox": "ମାଇକ୍ରୋଫୋନ୍ ସ୍ପ୍ରାଇଟ ଏବଂ ସରପ୍ରାଇଜ୍ ବିଟବକ୍ସ ବାଛନ୍ତୁ",
    "gui.howtos.story.name": "ଏକ କାହାଣୀ ସୃଷ୍ଟି କରନ୍ତୁ",
    "gui.howtos.story.step_addbg": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.story.step_addsprite": "ଏକ କ୍ୟାରକ୍ଟର ଯୋଡନ୍ତୁ",
    "gui.howtos.story.step_saysomething": "କିଛି କୁହ",
    "gui.howtos.story.step_addanothersprite": "ଅନ୍ୟ ଏକ କ୍ୟାରକ୍ଟର ଯୋଡନ୍ତୁ",
    "gui.howtos.story.step_flip": "ଦିଗ ଫ୍ଲିପ୍ (ଓଲଟା) କରନ୍ତୁ",
    "gui.howtos.story.step_conversation": "ଏକ ବାର୍ତ୍ତାଳାପ କରନ୍ତୁ",
    "gui.howtos.story.addanotherbg": "ଅନ୍ୟ ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.story.step_swithbg": "ବ୍ୟାକଡ୍ରପ୍ ସୁଇଚ୍ କରନ୍ତୁ",
    "gui.howtos.story.step_hidewizard": "ଏକ କ୍ୟାରକ୍ଟର ଲୁଚାନ୍ତୁ",
    "gui.howtos.story.step_showwizard": "ଏକ କ୍ୟାରକ୍ଟର ଦେଖାନ୍ତୁ",
    "gui.howtos.make-a-chase-game.name": "ଏକ ଚେଜ୍ ଗେମ୍ (ଗୋଡେଇବା ଖେଳ) ପ୍ରସ୍ତୁତ କରନ୍ତୁ ",
    "gui.howtos.Chase-Game.step_BG": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.chase-game.step_AddOcto": "ଏକ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.make-music.step_LeftRight": "ଆରୋ କି ସହିତ ଡାହାଣ ଏବଂ ବାମକୁ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.Chase-Game.step_UpDown": "ଆରୋ କି ସହିତ ଉପର ଏବଂ ତଳକୁ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.Chase-Game.step_AddStar": "ଅନ୍ୟ ଏକ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.Chase-Game.step_MoveRandom": "ଅନିୟମିତ ଭାବରେ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.Chase-Game.step_WhenTouch": "ଅକ୍ଟୋପସ୍ ସ୍ପ୍ରାଇଟ ରେ, ପ୍ଲେ ସାଉଣ୍ଡକୁ ସ୍ପର୍ଶ କରିବାବେଳେ",
    "gui.howtos.Chase-Game.step_ScoreVariable": "ସ୍କୋର ଭେରିଏବଲ୍ ସୃଷ୍ଟି କରନ୍ତୁ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "ଅକ୍ଟୋପସ୍ ସ୍ପ୍ରାଇଟ ରେ, ସ୍କୋର ଯୋଡିବା ସମୟରେ...",
    "gui.howtos.animate-char.name": "ଏକ କ୍ୟାରକ୍ଟର ଆନିମେଟ କରନ୍ତୁ",
    "gui.howtos.animate-char.step_addbg": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.animate-char.step_addsprite": "ଏକ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.animate-char.step_saysomething": "କିଛି କୁହ",
    "gui.howtos.animate-char.step_addsound": "ଧ୍ୱନି ଯୋଡନ୍ତୁ",
    "gui.howtos.animate-char.step_animatetalking": "ଆନିମେଟ କଥାବାର୍ତ୍ତା",
    "gui.howtos.animate-char.step_arrowkeys": "ଆରୋ କି ବ୍ୟବହାର କରି ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.animate-char.step_jump": "ଡେଇଁପଡନ୍ତୁ",
    "gui.howtos.animate-char.step_changecolor": "ରଙ୍ଗ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.make-a-game.name": "ଏକ କ୍ଲିକର୍ ଗେମ୍ ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.make-a-game.step_GamePlaySound": "କ୍ଲିକ୍ କଲାବେଳେ ଧ୍ୱନି (ସାଉଣ୍ଡ) ଚଲାନ୍ତୁ",
    "gui.howtos.make-a-game.step_GameAddScore": "ସ୍କୋର ଭେରିଏବଲ୍ ସୃଷ୍ଟି କରନ୍ତୁ",
    "gui.howtos.make-a-game.step_GameChangeScore": "କ୍ଲିକ୍ କରିଲେ ସ୍କୋର୍ ବଢ଼ାନ୍ତୁ",
    "gui.howtos.make-a-game.step_Random": "ଏକ ରାଣ୍ଡୋମ (ଯାହାଇଛା) ପୋଜିସନକୁ ଯାଆନ୍ତୁ",
    "gui.howtos.make-music.step_GameChangeColor": "ରଙ୍ଗ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.make-music.step_ResetScore": "ସ୍କୋର ପୁଣି ରିସେଟ୍ କରନ୍ତୁ",
    "gui.howtos.make-it-fly.name": "ଏହାକୁ ଉଡ଼ାନ୍ତୁ",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "ଏକ ଆକାଶ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "ଏକ କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.fly.step_stepflySaySomething": "କିଛି କୁହ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "ଆରୋ କି ସହିତ ଗତି କର",
    "gui.howtos.fly.step_stepflyChooseObject": "ସଂଗ୍ରହ କରିବାକୁ ଏକ ବସ୍ତୁ ବାଛନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "ଅବଜେକ୍ଟ ମୁଭ୍ କର",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "ଆପଣଙ୍କର କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "ଏକ ସ୍କୋର ଯୋଡନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "ସ୍କୋର ରଖନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "ଦୃଶ୍ୟ ଯୋଡନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "ଦୃଶ୍ୟକୁ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "ପରବର୍ତ୍ତୀ ପୋଷାକ",
    "gui.howtos.pong": "ପଙ୍ଗ୍ ଗେମ୍",
    "gui.howtos.pong.step_pongAddBackdrop": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongAddBallSprite": "ଏକ ବଲ୍ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongBounceAround": "ବାଉନ୍ସ",
    "gui.howtos.pong.step_pongAddPaddle": "ଏକ ପ୍ୟାଡଲ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongMoveThePaddle": "ପ୍ୟାଡଲ୍ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.pong.step_pongSelectBallSprite": "ବଲ୍ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "ପ୍ୟାଡଲ୍ ରୁ ବଲ୍ ବାଉନ୍ସ କରିବାକୁ କୋଡ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongAddAScore": "ଏକ ସ୍କୋର ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "ମେନୁରୁ 'ସ୍କୋର' ବାଛନ୍ତୁ",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "ସ୍କୋର ପରିବର୍ତ୍ତନ' ବ୍ଲକ ସନ୍ନିବେଶ କରନ୍ତୁ",
    "gui.howtos.pong.step_pongResetScore": "ସ୍କୋର ପୁଣି ରିସେଟ୍ କରନ୍ତୁ",
    "gui.howtos.pong.step_pongAddLineSprite": "ଲାଇନ୍ ସ୍ପ୍ରାଇଟଟି ଯୋଡନ୍ତୁ",
    "gui.howtos.pong.step_pongGameOver": "ଖେଳ ସମାପ୍ତ",
    "gui.howtos.code-cartoon": "ଏକ କାର୍ଟୁନ୍ କୋଡ୍ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "ଯେତେବେଳେ ଆପଣ ସବୁଜ ପତାକା କ୍ଲିକ୍ କରନ୍ତି କିଛି କୁହନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "ଯେତେବେଳେ ଆପଣ ଏହାକୁ କ୍ଲିକ୍ କରିବେ ଏକ ଚରିତ୍ରକୁ ଜୀବନ୍ତ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "ଏକ ଭିନ୍ନ କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "ଛୋଟ ହେବାକୁ ଏକ ମାଇନସ୍ ସାଇନ୍ ବ୍ୟବହାର କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "ଗୋଟିଏ କ୍ୟାରକ୍ଟର ର ଆକାର ବଢ଼ାନ୍ତୁ ଏବଂ ଛୋଟ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "ଏକ ଭିନ୍ନ କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "ଉପରକୁ ଏବଂ ତଳକୁ ଡେଇଁପଡ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "ଦୃଶ୍ୟ ପରିବର୍ତ୍ତନ କରିବାକୁ ଏକ କ୍ୟାରକ୍ଟର କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "ଚାରିପାଖରେ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "ପୋଷାକ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "ଆପଣଙ୍କ କାର୍ଟୁନରେ ଯୋଡିବାକୁ ଅଧିକ କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.cartoon-network": "ଏକ ଦୁଃସାହସିକ ଖେଳକୁ ଆନିମେଟ କରନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNcharacter": "ଦେଖାଇବାକୁ ଏକ କ୍ୟାରକ୍ଟର ବାଛନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNsay": "କିଛି କୁହ",
    "gui.howtos.cartoon-network.step_CNglide": "ଚାରିପାଖରେ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNpicksprite": "ଗୋଡ଼ାଇବା ପାଇଁ ଏକ ବସ୍ତୁ ବାଛନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNcollect": "ବସ୍ତୁ ସଂଗ୍ରହ କରନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNvariable": "ଏକ ସ୍କୋର ଭେରିଏବଲ୍ ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNscore": "ସ୍କୋର ରଖନ୍ତୁ",
    "gui.howtos.cartoon-network.step_CNbackdrop": "ସ୍ତର ଅପ୍: ପୃଷ୍ଠଭୂମି ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.videosens.name": "ଭିଡିଓ ସେନ୍ସିଂ",
    "gui.howtos.videosens.step_addextension": "ଏକ୍ସଟେନ୍ସନ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.videosens.step_pet": "ବିଲେଇକୁ ପେଟ କରନ୍ତୁ  ",
    "gui.howtos.videosens.step_animate": "ଆନିମେଟ",
    "gui.howtos.videosens.step_pop": "ଏକ ବେଲୁନ୍ ପପ୍ କରନ୍ତୁ",
    "gui.howtos.say-it-out-loud": "କଥାବାର୍ତ୍ତା କରୁଥିବା ଆନିମେସନ୍ ସୃଷ୍ଟି କରନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "ସ୍ପିଚ୍ ବ୍ଲକ୍ ରେ ଟେକ୍ସଟ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "କିଛି କୁହ",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "ଏକ ସ୍ୱର ସେଟ୍ କରନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTMove": "ଚାରିପାଖକୁ ଯାଅ",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "ଅନ୍ୟ ଏକ କ୍ୟାରକ୍ଟର ଯୋଡନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTSong": "ଏକ ଗୀତ ପରିବେଷଣ କରନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTColor": "ରଙ୍ଗ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "ଚାରିପାଖରେ ଘୂର୍ଣ୍ଣନ କର",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "ବଢ଼ାନ୍ତୁ ଏବଂ ସଙ୍କୋଚନ କରନ୍ତୁ",
    "gui.howtos.talking": "କଥାବାର୍ତ୍ତାର କାହାଣୀ",
    "gui.howtos.talking.step_talesAddExtension": "ଟେକ୍ସଟ୍-ଟୁ-ସ୍ପିଚ୍ ବ୍ଲକ୍ ଯୋଡିବାକୁ କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.talking.step_talesChooseSprite": "ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesSaySomething": "ଏକ କ୍ୟାରକ୍ଟରକୁ କଥା କୁହ|ନ୍ତୁ",
    "gui.howtos.talking.step_talesChooseBackdrop": "ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesSwitchBackdrop": "ପରବର୍ତ୍ତୀ ପୃଷ୍ଠଭୂମିକୁ ଯିବାକୁ ଏକ କ୍ୟାରକ୍ଟର କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "ଅନ୍ୟ ଏକ ସ୍ପ୍ରାଇଟ ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesMoveAround": "ଚାରିପାଖକୁ ଯାଅ",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "ଅନ୍ୟ ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesAnimateTalking": "ଆନିମେଟ କରନ୍ତୁ କଥାବାର୍ତ୍ତା",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "ଅନ୍ୟ ଏକ ପୃଷ୍ଠଭୂମି ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesChooseSound": "ନୃତ୍ୟ କରିବାକୁ ଏକ ଗୀତ ବାଛନ୍ତୁ",
    "gui.howtos.talking.step_talesDanceMoves": "ଡାନ୍ସ ମୁଭ ଗୁଡିକ",
    "gui.howtos.talking.step_talesAskAnswer": "ସେନ୍ସିଂ ବର୍ଗରୁ ପଚାର ଏବଂ ଉତ୍ତର ବ୍ଲକଗୁଡିକ ପ୍ରାପ୍ତ କରନ୍ତୁ",
    "gui.howtos.add-sprite.name": "ଏକ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.add-sprite.step_addSprite": "ଏକ ସ୍ପ୍ରାଇଟ ଯୋଡନ୍ତୁ",
    "gui.howtos.add-a-backdrop.name": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଡନ୍ତୁ",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "ଏକ ପୃଷ୍ଠଭୂମି ଯୋଗ କରନ୍ତୁ",
    "gui.howtos.change-size.name": "ଆକାର ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.change-size.step_changeSize": "ଆକାର ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "gui.howtos.glide-around.name": "ଚାରିପାଖରେ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "ଚାରିପାଖରେ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ (ଖସନ୍ତୁ)",
    "gui.howtos.change-size.step_glideAroundPoint": "ଏକ ବିନ୍ଦୁଆଡକୁ ଗ୍ଲାଇଡ୍ କରନ୍ତୁ",
    "gui.howtos.record-a-sound.name": "ଏକ ଧ୍ୱନି ରେକର୍ଡ କରନ୍ତୁ",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "ସାଉଣ୍ଡ୍' ଟ୍ୟାବ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "ରେକର୍ଡ' କ୍ଲିକ୍ କରନ୍ତୁ",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "ରେକର୍ଡ ବଟନ୍ ଦବାନ୍ତୁ",
    "gui.howtos.change-size.step_recordASoundChooseSound": "ଆପଣଙ୍କର ଧ୍ୱନି ବାଛନ୍ତୁ",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "ଆପଣଙ୍କର ସାଉଣ୍ଡ୍ ଚଲାନ୍ତୁ",
    "gui.howtos.spin-video.name": "ଏହାକୁ ସ୍ପିନ୍ କରନ୍ତୁ",
    "gui.howtos.change-size.step_spinTurn": "ମୋଡ଼ନ୍ତୁ",
    "gui.howtos.change-size.step_spinPointInDirection": "ଦିଗ ସେଟ୍ କରନ୍ତୁ",
    "gui.howtos.hide-and-show.name": "ଲୁଚାନ୍ତୁ ଓ ଦେଖାନ୍ତୁ",
    "gui.howtos.change-size.step_hideAndShow": "ଲୁଚାନ୍ତୁ ଏବଂ ଦେଖାନ୍ତୁ",
    "gui.howtos.switch-costume.name": "ଏକ ସ୍ପ୍ରାଇଟ ଆନିମେସନ୍ କରନ୍ତୁ",
    "gui.howtos.change-size.step_switchCostumes": "ଏକ ସ୍ପ୍ରାଇଟ ଆନିମେସନ୍ କରନ୍ତୁ",
    "gui.howtos.move-around-with-arrow-keys.name": "ଆରୋ କି ବ୍ୟବହାର କରନ୍ତୁ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "ବାମ ଏବଂ ଡାହାଣକୁ ଘୁଞ୍ଚାନ୍ତୁ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "ଉପରକୁ ଏବଂ ତଳକୁ ଯାଆନ୍ତୁ",
    "gui.howtos.add-effects.name": "ଏଫେକ୍ଟସ୍ ଯୋଡନ୍ତୁ",
    "gui.howtos.videosens.step_addEffects": "ଏଫେକ୍ଟସ୍ ଯୋଡନ୍ତୁ",
    "gui.extension.music.name": "ସଙ୍ଗୀତ",
    "gui.extension.music.description": "ବାଦ୍ୟଯନ୍ତ୍ର ଏବଂ ଡ଼୍ରମ୍ ବଜାନ୍ତୁ",
    "gui.extension.pen.name": "କଲମ",
    "gui.extension.pen.description": "ତୁମର ସ୍ପ୍ରାଇଟସ ସହିତ ଅଙ୍କନ କର",
    "gui.extension.videosensing.name": "ଭିଡିଓ ସେନ୍ସିଂ",
    "gui.extension.videosensing.description": "କ୍ୟାମେରା ସହିତ ଗତିକୁ ଅନୁଭବ କରନ୍ତୁ",
    "gui.extension.text2speech.name": "ଭାଷଣକୁ ପାଠ",
    "gui.extension.text2speech.description": "ତୁମର ପ୍ରୋଜେକ୍ଟଗୁଡ଼ିକୁ କଥାବାର୍ତ୍ତା କରିବାର କ୍ଷମତା ଦିଅ",
    "gui.extension.translate.name": "ଅନୁବାଦ କରନ୍ତୁ",
    "gui.extension.translate.description": "ବାକ୍ୟଗୁଡ଼ିକ ଅନେକ ଭାଷାରେ ଅନୁବାଦ କରନ୍ତୁ",
    "gui.extension.makeymakey.description": "ଯେ କୌଣସି ଜିନିଷକୁ ଚାବିରେ ପରିଣତ କରନ୍ତୁ ।",
    "gui.extension.microbit.description": "ନିଜର ପ୍ରୋଜେକ୍ଟଗୁଡ଼ିକୁ ବିଶ୍ୱ ସହିତ ସଂଯୋଗ କରନ୍ତୁ",
    "gui.extension.microbit.connectingMessage": "ସଂଯୋଗ କରୁଛି",
    "gui.extension.ev3.description": "ଇଣ୍ଟରାକ୍ଟିଭ୍ ରୋବଟ୍ ନିର୍ମାଣ କରନ୍ତୁ ଏବଂ ଆଉ ଅଧିକ|",
    "gui.extension.ev3.connectingMessage": "ସଂଯୋଗ କରୁଛି, ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣଙ୍କର EV3 ରେ ଥିବା ପିନ୍ 1234 ରେ ସେଟ୍ ହୋଇଛି",
    "gui.extension.boost.description": "ରୋବୋଟିକ୍ ସୃଷ୍ଟିଗୁଡ଼ିକୁ ଜୀବନରେ ଆଣ",
    "gui.extension.boost.connectingMessage": "ସଂଯୋଗ କରୁଛି",
    "gui.extension.wedo2.description": "ମୋଟର ଏବଂ ସେନ୍ସରକୁ ନେଇ ନିର୍ମାଣ କରନ୍ତୁ",
    "gui.extension.wedo2.connectingMessage": "ସଂଯୋଗ କରୁଛି",
    "gui.extension.gdxfor.description": "\nଠେଲିବା, ଟାଣିବା, ଗତି, ଏବଂ ସ୍ପିନ୍କୁ ଅନୁଭବ କରନ୍ତୁ",
    "gui.extension.gdxfor.connectingMessage": "ସଂଯୋଗ କରୁଛି",
    "gui.libraryTags.all": "ସମସ୍ତ",
    "gui.libraryTags.animals": "ପଶୁମାନେ",
    "gui.libraryTags.dance": "ନୃତ୍ୟ",
    "gui.libraryTags.effects": "ପ୍ରଭାବ",
    "gui.libraryTags.fantasy": "କଳ୍ପନା",
    "gui.libraryTags.fashion": "ଫ୍ୟାଶନ୍",
    "gui.libraryTags.food": "ଖାଦ୍ୟ",
    "gui.libraryTags.indoors": "ଘର ଭିତରେ",
    "gui.libraryTags.loops": "ଲୁପ୍",
    "gui.libraryTags.music": "ସଙ୍ଗୀତ",
    "gui.libraryTags.notes": "ଟିପ୍ପଣୀ",
    "gui.libraryTags.outdoors": "ବାହାଘର",
    "gui.libraryTags.patterns": "ନମୁନା",
    "gui.libraryTags.people": "ଲୋକମାନେ",
    "gui.libraryTags.percussion": "ପରକ୍ୟୁସନ",
    "gui.libraryTags.space": "ସ୍ଥାନ",
    "gui.libraryTags.sports": "କ୍ରୀଡା",
    "gui.libraryTags.underwater": "ଅଣ୍ଡରୱାଟର (ପାଣି ଭିତରେ)",
    "gui.libraryTags.voice": "ସ୍ୱର",
    "gui.libraryTags.wacky": "ୱାକି",
    "gui.libraryTags.animation": "ଆନିମେସନ୍",
    "gui.libraryTags.art": "କଳା",
    "gui.libraryTags.games": "ଖେଳଗୁଡିକ",
    "gui.libraryTags.stories": "କାହାଣୀଗୁଡିକ",
    "gui.libraryTags.letters": "କ୍ୟାରକ୍ଟରଗୁଡ଼ିକ",
    "gui.opcodeLabels.direction": "ଦିଗ",
    "gui.opcodeLabels.xposition": "x ସ୍ଥିତି (ପୋଜିସନ)",
    "gui.opcodeLabels.yposition": "y ସ୍ଥିତି (ପୋଜିସନ)",
    "gui.opcodeLabels.size": "ଆକାର",
    "gui.opcodeLabels.costumename": "ପୋଷାକ ନାମ",
    "gui.opcodeLabels.costumenumber": "ପୋଷାକ ସଂଖ୍ୟା",
    "gui.opcodeLabels.backdropname": "ପୃଷ୍ଠପଟ ନାମ",
    "gui.opcodeLabels.backdropnumber": "ପୃଷ୍ଠପଟ ସଂଖ୍ୟା",
    "gui.opcodeLabels.volume": "ଭଲ୍ୟୁମ୍",
    "gui.opcodeLabels.tempo": "ଟେମ୍ପୋ",
    "gui.opcodeLabels.answer": "ଉତ୍ତର ଦିଅ",
    "gui.opcodeLabels.loudness": "ଉଚ୍ଚ ସ୍ୱର",
    "gui.opcodeLabels.username": "ୟୁଜର ନେମ୍",
    "gui.opcodeLabels.year": "ବର୍ଷ",
    "gui.opcodeLabels.month": "ମାସ",
    "gui.opcodeLabels.date": "ତାରିଖ",
    "gui.opcodeLabels.dayofweek": "ସପ୍ତାହର ଦିନ",
    "gui.opcodeLabels.hour": "ଘଣ୍ଟା",
    "gui.opcodeLabels.minute": "ମିନିଟ୍",
    "gui.opcodeLabels.second": "ଦ୍ୱିତୀୟ",
    "gui.opcodeLabels.timer": "ଟାଇମର୍",
    "gui.projectLoader.loadError": "ଚୟନ ହୋଇଥିବା ପ୍ରୋଜେକ୍ଟ ଫାଇଲ୍ ଲୋଡ୍ କରିବାରେ ବିଫଳ ହେଲା",
    "gui.sharedMessages.backdrop": "ପୃଷ୍ଠପଟ{index}",
    "gui.sharedMessages.costume": "ପୋଷାକ{index}",
    "gui.sharedMessages.sprite": "ସ୍ପ୍ରାଇଟ{index}",
    "gui.sharedMessages.pop": "ପପ୍",
    "gui.sharedMessages.replaceProjectWarning": "ସାମ୍ପ୍ରତିକ ପ୍ରକଳ୍ପର ବିଷୟବସ୍ତୁକୁ ବଦଳାନ୍ତୁ?",
    "gui.sharedMessages.loadFromComputerTitle": "ଆପଣଙ୍କ କମ୍ପ୍ୟୁଟରରୁ ଲୋଡ୍ କରନ୍ତୁ",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "ସ୍କ୍ରାଚ୍ ପ୍ରୋଜେକ୍ଟ",
    "boost.color.any": "ଯେକୌଣସି ରଙ୍ଗ",
    "boost.color.black": "କଳା",
    "boost.color.blue": "ନୀଳ",
    "boost.color.green": "ସବୁଜ",
    "boost.color.red": "ଲାଲ",
    "boost.color.white": "ଧଳା",
    "boost.color.yellow": "ହଳଦିଆ",
    "boost.getMotorPosition": "ମୋଟର  [MOTOR_REPORTER_ID] की स्थिति ",
    "boost.getTiltAngle": "ଝୁଙ୍କାଇବାର ଦିଗ [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ସେ ପଟେ",
    "boost.motorDirection.forward": "ଏ ପଟେ",
    "boost.motorDirection.reverse": "ଓଲଟା ପଟେ",
    "boost.motorOff": "[MOTOR_ID] ମୋଟର ବନ୍ଦ କର",
    "boost.motorOn": "[MOTOR_ID] ମୋଟର ଟର୍ନ୍ ଅନ୍ କରନ୍ତୁ",
    "boost.motorOnFor": "[MOTOR_ID] ମୋଟର ଚଲାନ୍ତୁ [DURATION] କ୍ଷଣ ପାଇଁ",
    "boost.motorOnForRotation": "[MOTOR_ID]ମୋଟର ଚଲାନ୍ତୁ [ROTATION] ରାଉଣ୍ଡ ପାଇଁ",
    "boost.seeingColor": "କେଉଁ [COLOR] ଇଟା ଦେଖିଲ?",
    "boost.setLightHue": "ଆଲୁଅ କଲଡର [HUE] ରଖ",
    "boost.setMotorDirection": "ମୋଟର [MOTOR_ID] ଦିଗ  [MOTOR_DIRECTION] ସେଟ୍ କରନ୍ତୁ",
    "boost.setMotorPower": "ମୋଟର  [MOTOR_ID] ଗତି ସ୍ଥିର କରନ୍ତୁ [POWER] % ଯାଏଁ ",
    "boost.tiltDirection.any": "କୌଣସି ",
    "boost.tiltDirection.down": "ତଳକୁ",
    "boost.tiltDirection.left": "ବାମ",
    "boost.tiltDirection.right": "ଡାହାଣ",
    "boost.tiltDirection.up": "ଉପର",
    "boost.whenColor": "ଯେତେବେଳେ ତୁମେ [COLOR] ଇଟା ଦେଖିବ",
    "boost.whenTilted": "ଝୁଙ୍କି ଥିଲା ବେଳେ [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "[NOTE] बीप लय को [TIME] क्षण तक चलाए ",
    "ev3.buttonPressed": "କେଉଁ [PORT] ବଟନ୍ ଦବେଇଲ?",
    "ev3.getBrightness": "ଉଜ୍ଜ୍ୱଳତା",
    "ev3.getDistance": "ଦୂରତା",
    "ev3.getMotorPosition": "[PORT] ମୋଟର ସ୍ଥିତି | ",
    "ev3.motorSetPower": "[PORT] ମୋଟର ଶକ୍ତି [POWER]% ସେଟ୍ କରନ୍ତୁ ",
    "ev3.motorTurnClockwise": " ମୋଟର କୁ [PORT] [TIME] ସେକେଣ୍ଡ ପାଇଁ ଏହି ପଟେ ବୁଲାନ୍ତୁ",
    "ev3.motorTurnCounterClockwise": " ମୋଟର କୁ [PORT] [TIME] ସେକେଣ୍ଡ ପାଇଁ ସେହି ପଟେ ବୁଲାନ୍ତୁ",
    "ev3.whenBrightnessLessThan": "ଯେତେବେଳେ ଉଜ୍ଜ୍ୱଳ < [DISTANCE]",
    "ev3.whenButtonPressed": "ଯେତେବେଳେ ବଟନ୍ [PORT] ଦବାଗଲା",
    "ev3.whenDistanceLessThan": "ଯେତେବେଳେ ଦୂରତା < [DISTANCE]",
    "gdxfor.getAcceleration": "ତ୍ୱରଣ [DIRECTION]",
    "gdxfor.getForce": "ବଳ",
    "gdxfor.getSpin": "ଘୂରିବା ଗତି [DIRECTION]",
    "gdxfor.getTilt": "ପ୍ଝୁଙ୍କିବା ର କୋଣ [TILT]",
    "gdxfor.isFreeFalling": "ପଡୁଛି?",
    "gdxfor.isTilted": " ଏହା କେତେ ଝୁଙ୍କିଛି [TILT]?",
    "gdxfor.pulled": "ଟଣା ଯାଇଥିବା",
    "gdxfor.pushed": "ଠେଲା ଯାଇଥିବା",
    "gdxfor.shaken": "କମ୍ପିତ",
    "gdxfor.startedFalling": "ପଡିବା ଆରମ୍ଭ କଲା",
    "gdxfor.tiltDirectionMenu.any": "ଯେକୌଣସି",
    "gdxfor.tiltDirectionMenu.back": "ପଛ",
    "gdxfor.tiltDirectionMenu.front": "ଆଗ",
    "gdxfor.tiltDirectionMenu.left": "ବାମ",
    "gdxfor.tiltDirectionMenu.right": "ଡାହାଣ",
    "gdxfor.turnedFaceDown": "ମୁହଁ ତଳକୁ ହୋଇଗଲା",
    "gdxfor.turnedFaceUp": "ମୁହଁ ଉପରୁକୁ ହୋଇଗଲା ",
    "gdxfor.whenForcePushedOrPulled": "ଯେବେ ଫୋର୍ସ ସେନ୍ସର [PUSH_PULL]",
    "gdxfor.whenGesture": "ଯେବେ [GESTURE]",
    "gdxfor.whenTilted": "ଯେତେବେଳେ ଝୁଂକିଛି [TILT]",
    "makeymakey.downArrow": "ତଳକୁ ତୀର ",
    "makeymakey.downArrowShort": "ତଳ",
    "makeymakey.leftArrow": "ବାମ ତୀର",
    "makeymakey.leftArrowShort": "ବାମ",
    "makeymakey.rightArrow": "ଡାହାଣ ତୀର",
    "makeymakey.rightArrowShort": "ଡାହାଣ",
    "makeymakey.spaceKey": "ଜାଗା",
    "makeymakey.upArrow": "ଉପର ତୀର",
    "makeymakey.upArrowShort": "ଉପର",
    "makeymakey.whenKeyPressed": "ଯେତେବେଳେ [KEY] ଚାବି ଦବାଗଲା",
    "makeymakey.whenKeysPressedInOrder": "ଯେତେବେଳେ [SEQUENCE] କ୍ରମରେ ଦବାଗଲା",
    "microbit.buttonsMenu.any": "କୌଣସି",
    "microbit.clearDisplay": "ସ୍କ୍ରିନ୍ ସଫା କର",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "ସ୍କ୍ରିନ୍ [MATRIX]",
    "microbit.displayText": "ଦୃଶ୍ୟ ଅକ୍ଷର [TEXT]",
    "microbit.gesturesMenu.jumped": "ଡେଇଁପଡ଼ିଲା",
    "microbit.gesturesMenu.moved": "ଘୁଞ୍ଚିଗଲା",
    "microbit.gesturesMenu.shaken": "ହଲିଗଲା",
    "microbit.isButtonPressed": "କୌ ବଟନ [BTN] ଚିପିଲ?",
    "microbit.isTilted": "ଝୁଙ୍କିଛି [DIRECTION] ?",
    "microbit.pinStateMenu.off": "ବନ୍ଦ",
    "microbit.pinStateMenu.on": "ଅନ୍",
    "microbit.tiltAngle": "ଝୁଙ୍କିବାର କୋଣ [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ଯେକୌଣସି",
    "microbit.tiltDirectionMenu.back": "ପଛକୁ",
    "microbit.tiltDirectionMenu.front": "ଆଗକୁ",
    "microbit.tiltDirectionMenu.left": "ବାମ",
    "microbit.tiltDirectionMenu.right": "ଡାହାଣ",
    "microbit.whenButtonPressed": "ଯେତେବେଳେ [BTN] ବଟନ୍ ଦବାଗଲା",
    "microbit.whenGesture": "ଯେବେ [GESTURE]",
    "microbit.whenPinConnected": "ଯେତେବେଳେ ପିନ୍ [PIN] ସଂଯୁକ୍ତ",
    "microbit.whenTilted": "ଯେବେ ଝୁଙ୍କିକି ଥିବ [DIRECTION] दिशामे झुका हो ",
    "music.categoryName": "ସଙ୍ଗୀତ",
    "music.changeTempo": "ତାଳ କୁ [TEMPO] ରେ ବଦଳାନ୍ତୁ  ",
    "music.drumBass": "(2) ବ୍ୟାସ୍ ଡ୍ରମ୍ ",
    "music.drumBongo": "(13) ବଙ୍ଗୋ",
    "music.drumCabasa": "(15)କାବାସା",
    "music.drumClaves": "(9) କ୍ଲାଭସ୍",
    "music.drumClosedHiHat": "(6)ବନ୍ଦ ହାଏ-ହାଟ",
    "music.drumConga": "(14) କଙ୍ଗା",
    "music.drumCowbell": "(11) ଗାଈ ଘଣ୍ଟି ",
    "music.drumCrashCymbal": "(4) ଝାଞ୍ଜ ",
    "music.drumCuica": "(18) କୁଇକା",
    "music.drumGuiro": "(16) ଗୁଇରୋ",
    "music.drumHandClap": "(8) କରତାଳି",
    "music.drumOpenHiHat": "(5) ଖୋଲ  ହାଇ-ହ୍ୟାଟ୍",
    "music.drumSideStick": "(3) ପାର୍ଶ୍ବ କାଠି",
    "music.drumSnare": "(1) ସ୍ନେର ଢୋଲ",
    "music.drumTambourine": "(7) ଡଫଲି",
    "music.drumTriangle": "(12) ତ୍ରିଭୁଜ",
    "music.drumVibraslap": "(17) ଭାଇବ୍ରାସ୍ଲାପ୍",
    "music.drumWoodBlock": "(10) କାଠ ବ୍ଲକ",
    "music.getTempo": "ଲୟ ",
    "music.instrumentBass": "(6) ବାସ୍",
    "music.instrumentBassoon": "(14) ବାସୂନ",
    "music.instrumentCello": "(8) ଚେଲୋ",
    "music.instrumentChoir": "(15) ଗାୟକ ମଣ୍ଡଳୀ",
    "music.instrumentClarinet": "(10) କ୍ଲାରିନେଟ୍",
    "music.instrumentElectricGuitar": "(5) ଇଲେକ୍ଟ୍ରିକ୍ ଗିଟାର୍",
    "music.instrumentElectricPiano": "(2)ଇଲେକ୍ଟ୍ରିକ୍ ପିଆନୋ",
    "music.instrumentFlute": "(12) ବଂଶୀ ",
    "music.instrumentGuitar": "(4) ଗିଟାର",
    "music.instrumentMarimba": "(19) ମାରିମ୍ବା",
    "music.instrumentMusicBox": "(17) ସଙ୍ଗୀତ ପେଡି ",
    "music.instrumentOrgan": "(3) ଅର୍ଗାନ",
    "music.instrumentPiano": "(1) ପିଆନୋ",
    "music.instrumentPizzicato": "(7) ପିଜିକାଟୋ",
    "music.instrumentSaxophone": "(11) ସାକ୍ସୋଫୋନ୍",
    "music.instrumentSteelDrum": "(18) ଷ୍ଟିଲ୍ ଡ୍ରମ୍",
    "music.instrumentSynthLead": "(20) ସିନ୍ଥ୍ ଲିଡ୍",
    "music.instrumentSynthPad": "(21) ସିନ୍ଥ ପ୍ୟାଡ୍",
    "music.instrumentTrombone": "(9) ଟ୍ରମ୍ବୋନ",
    "music.instrumentVibraphone": "(16) ଭିବ୍ରାଫୋନ୍",
    "music.instrumentWoodenFlute": "(13) କାଠ ବଂଶୀ",
    "music.midiPlayDrumForBeats": "[BEATS] ବିଟ୍ ପାଇଁ ଡ୍ରମ୍ [DRUM] ବଜାନ୍ତୁ",
    "music.midiSetInstrument": "ବାଦ୍ୟଯନ୍ତ୍ରକୁ [INSTRUMENT] ରେ ରଖନ୍ତୁ",
    "music.playDrumForBeats": "[BEATS] ବିଟ୍ ପାଇଁ ଡ୍ରମ୍ [DRUM] ବଜାନ୍ତୁ",
    "music.playNoteForBeats": "[BEATS] ବିଟ୍ ପାଇଁ [NOTE] ଟିପ୍ପଣୀ ସ୍ବର ବଜାନ୍ତୁ",
    "music.restForBeats": "ଏତିକି [BEATS] ତାଳ ପାଇଂ ରୁହ",
    "music.setInstrument": "ବାଦ୍ୟଯନ୍ତ୍ରକୁ [INSTRUMENT] ରେ ରଖନ୍ତୁ",
    "music.setTempo": " [TEMPO] ଲୟକୁ ସେଟ୍ କରନ୍ତୁ",
    "pen.categoryName": "କଲମ",
    "pen.changeColorParam": "[COLOR_PARAM] କଲମ କୁ [VALUE] ଦ୍ୱାରା ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "pen.changeHue": "କଲମ ରଙ୍ଗ [HUE] ଦ୍ୱାରା ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "pen.changeShade": "କଲମ ରଙ୍ଗର ଗଭୀରତା [SHADE] ଦ୍ୱାରା ପରିବର୍ତ୍ତନ ",
    "pen.changeSize": "କାଲାମ ର ଆକାର [SIZE] से ବଦଳାa",
    "pen.clear": "ସବୁ ଲିଭାଇ ଦିଅ",
    "pen.colorMenu.brightness": "ଉଜ୍ଜ୍ଵଳତା",
    "pen.colorMenu.color": "ରଙ୍ଗ",
    "pen.colorMenu.saturation": "ପରିପୂର୍ଣତା",
    "pen.colorMenu.transparency": "ପାରଦର୍ଶିତା",
    "pen.penDown": "ପେନ୍ ତଳକୁ",
    "pen.penUp": "ପେଁ ଉପରକୁ",
    "pen.setColor": "କଲମ ର ରଙ୍ଗ କୁ [COLOR] ରେ ରଖ",
    "pen.setColorParam": "କଲମ [COLOR_PARAM] କୁ  [VALUE] ରେ ରଖ",
    "pen.setHue": "କଲମ ର ରଙ୍ଗ କୁ [HUE] ରେ ରଖ",
    "pen.setShade": "କଲମ ର ଗଭୀରତା କୁ [SHADE] ରେ ରଖ",
    "pen.setSize": "କଲମ ର ଆକାର କୁ  [SIZE] ରେ ରଖ",
    "pen.stamp": "ଷ୍ଟାମ୍ପ ଲଗାଅ",
    "speech.defaultWhenIHearValue": "ଆରମ୍ଭ କରିବା",
    "speech.extensionName": "ଧ୍ୱନି ରୁ ଲିପି",
    "speech.listenAndWait": "ସୁନା ଏବଂ ଅପେକ୍ଷା କର",
    "speech.speechReporter": "ଭାଷଣ",
    "speech.whenIHear": "ମୁଁ ଯେତେବେଳେ [PHRASE] ଶୁଣିଲି",
    "text2speech.alto": "ଆଳାପ",
    "text2speech.categoryName": "ଲିପି ରୁ ଧ୍ୱନି",
    "text2speech.defaultTextToSpeak": "ନମସ୍କାର",
    "text2speech.giant": "ବିଶାଳକାୟ",
    "text2speech.kitten": "ବିଲେଇ ଛୁଆ",
    "text2speech.setLanguageBlock": " [LANGUAGE] ରେ ଭାଷା କୁ ରଖ",
    "text2speech.setVoiceBlock": " [VOICE] ଉପରେ ସ୍ବର ରଖ",
    "text2speech.speakAndWaitBlock": "କୁହ [WORDS]",
    "text2speech.squeak": "ଚିଲାଇବା",
    "text2speech.tenor": "ଉଚ୍ଚ ସ୍ଵର",
    "translate.categoryName": "ଅନୁବାଦ",
    "translate.defaultTextToTranslate": "ନମସ୍କାର",
    "translate.translateBlock": " [WORDS] କୁ [LANGUAGE] ରେ ଅନୁବାଦ କର",
    "translate.viewerLanguage": "ଭାଷା",
    "videoSensing.categoryName": "ଭିଡିଓ ଜାଣିବା",
    "videoSensing.direction": "ଦିଗ",
    "videoSensing.motion": "ଗତି",
    "videoSensing.off": "ବନ୍ଦ",
    "videoSensing.on": "ଚଳାଅ",
    "videoSensing.onFlipped": "ଓଲଟାଇବା ପରେ",
    "videoSensing.setVideoTransparency": "ଭିଡିଓ ପାରଦର୍ଶିତା କୁ [TRANSPARENCY] ରେ ରଖ",
    "videoSensing.sprite": "ସ୍ପ୍ରାଇଟ",
    "videoSensing.stage": "ମଞ୍ଚ",
    "videoSensing.videoOn": "ଭିଡିଓ [ATTRIBUTE]  [SUBJECT] ଉପରେ",
    "videoSensing.videoToggle": "ଭିଡିଓ କୁ ଘୂରାଅ [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "ଯେବେ ଭିଡିଓ ର ଗତି > [REFERENCE]",
    "wedo2.getDistance": "ଦୂରତ୍ବ",
    "wedo2.getTiltAngle": "ଝୁଙ୍କିବା ର ଦିଗ [TILT_DIRECTION]",
    "wedo2.isTilted": "ଝୁଙ୍କିବା [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ସେ ପଟେ",
    "wedo2.motorDirection.forward": "ଏ ପଟେ",
    "wedo2.motorDirection.reverse": "ଓଲଟା ପଟେ",
    "wedo2.motorId.a": "ମୋଟର A",
    "wedo2.motorId.all": "ସବୁ ମୋଟର",
    "wedo2.motorId.b": "ମୋଟର B ",
    "wedo2.motorId.default": "ମୋଟର",
    "wedo2.motorOff": "[MOTOR_ID] ବନ୍ଦ କର",
    "wedo2.motorOn": "[MOTOR_ID] ଚଳାଅ",
    "wedo2.motorOnFor": "[MOTOR_ID] କୁ [DURATION] ସେକେଣ୍ଡ ପାଇଁ ଚଳାଅ",
    "wedo2.playNoteFor": "[NOTE] ସ୍ବର କୁ [DURATION] ସେକେଣ୍ଡ ପାଇଁ ବଜାଅ",
    "wedo2.setLightHue": "ଆଲୁଅ ର ରଙ୍ଗ [HUE] ରଖ",
    "wedo2.setMotorDirection": "[MOTOR_ID] ର ଦିଗ କୁ [MOTOR_DIRECTION] ରଖ",
    "wedo2.startMotorPower": "[MOTOR_ID] ର କ୍ଷମତା [POWER] ରଖ",
    "wedo2.tiltDirection.any": "କୌଣସି",
    "wedo2.tiltDirection.down": "ତଳ",
    "wedo2.tiltDirection.left": "ବାମ",
    "wedo2.tiltDirection.right": "ଡାହାଣ",
    "wedo2.tiltDirection.up": "ଉପର",
    "wedo2.whenDistance": "ଯେବେ ଦୂରତା  [OP][REFERENCE]",
    "wedo2.whenTilted": "ଯେବେ ଝୁଙ୍କିକି ଥିବ [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "ରଙ୍ଗ",
    "paint.paintEditor.saturation": "ପରିପୂର୍ଣତା",
    "paint.paintEditor.brightness": "ଉଜ୍ଜ୍ୱଳତା",
    "paint.paintEditor.costume": "ପୋଷାକ",
    "paint.paintEditor.group": "ସମୂହ",
    "paint.paintEditor.ungroup": "ଅଲଗା କର",
    "paint.paintEditor.undo": "ଆଗ ପରି",
    "paint.paintEditor.redo": "ପୁଣି କର",
    "paint.paintEditor.forward": "ଆଗକୁ କର",
    "paint.paintEditor.backward": "ପଛକୁ କର",
    "paint.paintEditor.front": "ସାମନା",
    "paint.paintEditor.back": "ପଛପାଖ",
    "paint.paintEditor.more": "ଆହୁରି",
    "paint.modeTools.brushSize": "ଆକାର",
    "paint.modeTools.eraserSize": "ରବର ଆକାର",
    "paint.modeTools.copy": "ନକଲ କର",
    "paint.modeTools.paste": "ଲଗାଅ",
    "paint.modeTools.delete": "ଲିଭାଅ",
    "paint.modeTools.curved": "ବକ୍ର",
    "paint.modeTools.pointed": "ମୁନିଆ",
    "paint.modeTools.thickness": "ମୋଟେଇ",
    "paint.modeTools.flipHorizontal": "ଭୁସମାନ୍ତରାଳ ଭାବରେ ଓଲଟାଅ",
    "paint.modeTools.flipVertical": "ଭୁଲମ୍ବାକାରରେଓଲଟାଅ ",
    "paint.modeTools.filled": "ଭର୍ତି",
    "paint.modeTools.outlined": "ସୀମା ନିର୍ଦ୍ଧାରିତ",
    "paint.paintEditor.bitmap": "ବିଟମ୍ଯାପ ରେ ବଦଳେଇଦିଅ",
    "paint.paintEditor.vector": "ଭେକ୍ଟର ରେ ବଦଳେଇଦିଅ",
    "paint.paintEditor.fill": "ଭର୍ତି କର",
    "paint.paintEditor.stroke": "ସୀମା",
    "paint.brushMode.brush": "ବ୍ରଶ",
    "paint.eraserMode.eraser": "ରବର",
    "paint.fillMode.fill": "ଭର୍ତି କର",
    "paint.lineMode.line": "ରେଖା",
    "paint.ovalMode.oval": "ବୃତ୍ତ",
    "paint.rectMode.rect": "ଆୟତକାର",
    "paint.reshapeMode.reshape": "ପୁଣି ଆକାର ତିଆରିକର",
    "paint.roundedRectMode.roundedRect": "ବୃତ୍ତାକାର କୋଣ ବିଶିଷ୍ଟ ଆୟତକାର ",
    "paint.selectMode.select": "ବାଛ",
    "paint.textMode.text": "ଲେଖା",
    "paint.colorPicker.swap": "ପରସ୍ପର ମଧ୍ୟରେ ବଦଳେଇଦିଅ "
  },
  "uz": {
    "gui.alerts.lostPeripheralConnection": "{extensionName} dan aloqa uzildi",
    "gui.alerts.tryAgain": "Qaytadan harakat qilib ko'ring",
    "gui.alerts.download": "Yuklash",
    "gui.connection.reconnect": "Qayta ulanish",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Shaxsiy ombor",
    "gui.backpack.errorBackpack": "Orqa yuzni yuklashda xatolik yuz berdi",
    "gui.backpack.loadingBackpack": "Yuklanmoqda ...",
    "gui.backpack.more": "Ko'proq",
    "gui.backpack.emptyBackpack": "Orqa xalqa bo'sh",
    "gui.unsupportedBrowser.label": "Brauzer qo'llab-quvvatlanmaydi",
    "gui.unsupportedBrowser.errorLabel": "Xatolik yuz berdi",
    "gui.unsupportedBrowser.notRecommended": "Biz juda afsusdaman, lekin Scratch-ning qo'llab-quvvatlamaydigan brauzer versiyasidan foydalanayotganingizga o'xshaysiz. Biz Google Chrome, Mozilla Firefox, Microsoft Edge yoki Apple Safari kabi qo'llab-quvvatlanadigan brauzerning so'nggi versiyasini yangilashni tavsiya etamiz.",
    "gui.unsupportedBrowser.description": "Biz juda uzr so'raymiz, lekin Scratch bu brauzerni qo'llab-quvvatlamaydi. Biz Google Chrome, Mozilla Firefox, Microsoft Edge yoki Apple Safari kabi qo'llab-quvvatlanadigan brauzerning so'nggi versiyasini yangilashni tavsiya etamiz.",
    "gui.unsupportedBrowser.back": "Orqaga",
    "gui.unsupportedBrowser.previewfaq": "Ko'proq ma'lumot olish uchun {previewFaqLink} ga o'ting.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Ko'p so'raladigan savol",
    "gui.cards.all-tutorials": "O‘z-o‘zini o‘qitish",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Yopish",
    "gui.cards.more-things-to-try": "Takrorlash kerakli bo'lgan narsalar ko'p!",
    "gui.cards.see-more": "Yana ko'rish",
    "gui.comingSoon.message1": "xavotir olmang. Bu ish ustida ishlayapmiz.{emoji}",
    "gui.comingSoon.message2": "Tez kunda...",
    "gui.comingSoon.message3": "Biz uning ustida ishlayapmiz {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "U yerda yo'q",
    "gui.connection.auto-scanning.prescan": "Qurilmangizni yaqin qiling, so'ngra izlashni boshlang.",
    "gui.connection.auto-scanning.pressbutton": "Qurilmaning tugmasini bosing.",
    "gui.connection.auto-scanning.start-search": "Qidiruvni boshlash",
    "gui.connection.connecting-searchbutton": "Qidirilmoqda ...",
    "gui.connection.auto-scanning.try-again": "Qayta urinib ko'ring",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ulangan",
    "gui.connection.disconnect": "Ulanish tugatildi",
    "gui.connection.go-to-editor": "O'zgartirishga borish",
    "gui.connection.connecting-cancelbutton": "Ulanmoqda...",
    "gui.connection.error.errorMessage": "Bu yerda, nimadir notog'ri",
    "gui.connection.error.tryagainbutton": "Qayta urinib ko'ring",
    "gui.connection.error.helpbutton": "Yordam",
    "gui.connection.peripheral-name-label": "Qurilma nomi",
    "gui.connection.connect": "Ulanish",
    "gui.connection.scanning.lookingforperipherals": "Qurilma qidirilmoqda",
    "gui.connection.scanning.noPeripheralsFound": "Yangi qurilma yo'q",
    "gui.connection.scanning.instructions": "Yuqoridagi ro'yxatda qurilmangizni tanlang.",
    "gui.connection.search": "Yangilash",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Scratch Link o'rnatilgan va ishlayotganligini tekshirib ko'ring",
    "gui.connection.unavailable.enablebluetooth": "Bluetoothdan qo'llanilish mumkinligini tekshirib ko'ring",
    "gui.connection.unavailable.tryagainbutton": "Qayta urinib ko'ring",
    "gui.connection.unavailable.helpbutton": "Yordam",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Boshlash",
    "gui.controls.stop": "To'xtatish",
    "gui.crashMessage.label": "Bu yerda, nimadir notog'ri",
    "gui.crashMessage.description": "Uzur so'raymiz, scratchda qandaydir problema paydo bo'ldi. Bu problema avtomatik ravishda scratchga kirib keldi. Qaytadan saytga kiring.",
    "gui.crashMessage.errorNumber": "Bu muammo ID {errorId} orqala kirgan",
    "gui.crashMessage.reload": "Yangilash",
    "gui.customProcedures.myblockModalTitle": "Blok yaratish",
    "gui.customProcedures.addAnInputNumberText": "Kiritish qiymatini qo'shish",
    "gui.customProcedures.numberTextType": "raqam yoki matn",
    "gui.customProcedures.addAnInputBoolean": "Kiritish qiymatini qo'shish",
    "gui.customProcedures.booleanType": "mantiqiy qiymat",
    "gui.customProcedures.addALabel": "Yorliq qo'shish",
    "gui.customProcedures.runWithoutScreenRefresh": "Ekrani yangilamasdan ishga tushirish",
    "gui.customProcedures.cancel": "Bekor qilish",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Yo'nalish",
    "gui.directionPicker.rotationStyles.allAround": "Aylanish",
    "gui.directionPicker.rotationStyles.leftRight": "chap tomon / o'ng tomon",
    "gui.directionPicker.rotationStyles.dontRotate": "Aylanmaslik",
    "gui.gui.addExtension": "Kengaytirish buyrug'ini qo'shish",
    "gui.gui.codeTab": "Kod",
    "gui.gui.backdropsTab": "Fon",
    "gui.gui.costumesTab": "Ko'rinish",
    "gui.gui.soundsTab": "Ovoz",
    "gui.extensionLibrary.comingSoon": "Tez orada foydalanish mumkin",
    "gui.extensionLibrary.requires": "Talab qiladi",
    "gui.extensionLibrary.collaboration": "Birlashish",
    "gui.library.filterPlaceholder": "Qidiruv",
    "gui.library.allTag": "Hammasi",
    "gui.loader.message1": "Bloklar yaratilmoqda...",
    "gui.loader.message2": "Spraytlar yuklanmoqda ...",
    "gui.loader.message3": "Ovoz yuklanmoqda...",
    "gui.loader.message4": "Kengaytmalar yuklanmoqda ...",
    "gui.loader.message5": "Mushukni tishlab ketmoqda...",
    "gui.loader.message6": "Nanoni etkazib berish ...",
    "gui.loader.message7": "Goboni kengaytirish...",
    "gui.loader.message8": "Imo-ishoralarni tayyorlash ...",
    "gui.loader.headline": "Loyiha yuklanmoqda...",
    "gui.loader.creating": "Yaratilgan loyiha",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Mening ishlarim",
    "gui.accountMenu.myClasses": "Mening sinflarim",
    "gui.accountMenu.myClass": "Mening sinfim",
    "gui.accountMenu.accountSettings": "Hisob sozlamalari",
    "gui.accountMenu.signOut": "Chiqish",
    "gui.authorInfo.byUser": "Ishlab chiqaruvchi: {username}",
    "gui.menuBar.seeProjectPage": "Loyiha sahifasini ko'rish",
    "gui.menuBar.language": "Language",
    "general.username": "Foydalanuvchi nomi",
    "general.password": "Parol",
    "general.signIn": "Kirish",
    "login.needHelp": "Yordam kerakmi?",
    "form.validationRequired": "Bu maydon to'ldirilishi shart",
    "gui.menuBar.tutorialsLibrary": "Darsliklar",
    "gui.menuBar.restoreSprite": "Spraytni orqaga aylantirish",
    "gui.menuBar.restoreSound": "Ovozni tiklash",
    "gui.menuBar.restoreCostume": "Kostyumni tiklash",
    "gui.menuBar.restore": "Orqaga qaytarish",
    "gui.menuBar.saveNow": "Saqlash",
    "gui.menuBar.saveAsCopy": "Nusxasi sifatida saqlash",
    "gui.menuBar.remix": "Musiqiy qorishma",
    "gui.menuBar.new": "Yangi yaratish",
    "gui.menuBar.file": "Fayl",
    "gui.menuBar.downloadToComputer": "Kompyuteringizga saqlang",
    "gui.menuBar.edit": "Oʻzgartirish",
    "gui.menuBar.turboModeOff": "Turbo rejimini o'chiring",
    "gui.menuBar.turboModeOn": "Turbo rejimini yoqish",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "scratchga a'zo bo'lish",
    "gui.menuBar.signIn": "Kirish",
    "gui.gui.projectTitlePlaceholder": "Loyiha nomini kirgizing",
    "gui.menuBar.saveNowLink": "Darhol saqlash",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Ulashilgan",
    "gui.menuBar.share": "Ulashish",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Yordam",
    "gui.modal.back": "Orqaga",
    "gui.monitor.listMonitor.empty": "(Bo'sh)",
    "gui.monitor.listMonitor.listLength": "uzunligi {length}",
    "gui.monitor.contextMenu.default": "o'zgaruvchi nomi-qiymatini ko'rish",
    "gui.monitor.contextMenu.large": "o'zgaruvchi qiymatini kattalshtirib ko'rish",
    "gui.monitor.contextMenu.slider": "slayderdan foydalanish",
    "gui.monitor.contextMenu.sliderRange": "slayder oralig'ini o'zgartirish",
    "gui.monitor.contextMenu.import": "olib kelish",
    "gui.monitor.contextMenu.export": "eksport qilish",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Barcha spraytlarda foydalanish",
    "gui.gui.variableScopeOptionSpriteOnly": "Faqat bu spraytda foydalanish",
    "gui.gui.cloudVariableOption": "Cloud o'zgaruvchisi (serverda saqlanadi)",
    "gui.gui.variablePromptAllSpritesMessage": "Ushbu o'zgaruvchini barcha spritlarda foydalanish mumkin.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Bekor qilish",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "To'xtatish",
    "gui.playbackStep.playMsg": "O'ynash",
    "gui.playbackStep.loadingMsg": "Yuklanmoqda ...",
    "gui.playbackStep.saveMsg": "Saqlash",
    "gui.playbackStep.reRecordMsg": "Qayta ovoz yozish",
    "gui.recordModal.title": "Ovoz yozish",
    "gui.recordingStep.beginRecord": "Quyidagi tugmani bosib ovoz yozishni boshlang.",
    "gui.recordingStep.permission": "{arrow} Mikrofondan foydalanish uchun foydalanuvchining ruxsati kerak",
    "gui.recordingStep.stop": "Ovoz yozishni to'xtatish",
    "gui.recordingStep.record": "Ovoz yozish",
    "gui.sliderModal.min": "Minimal qiymat",
    "gui.sliderModal.max": "Maksimal qiymat",
    "gui.sliderModal.title": "Slayder oralig'ini o'zgartirish",
    "gui.sliderPrompt.cancel": "Bekor qilish",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Ovoz",
    "gui.soundEditor.play": "O'ynash",
    "gui.soundEditor.stop": "To'xtatish",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Saqlash",
    "gui.soundEditor.undo": "Orqaga aylantirish",
    "gui.soundEditor.redo": "Qaytarish",
    "gui.soundEditor.faster": "Tezlashtirish",
    "gui.soundEditor.slower": "Sekinlashtirish",
    "gui.soundEditor.echo": "Sado",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Kattaroq",
    "gui.soundEditor.softer": "Kichikroq",
    "gui.soundEditor.reverse": "Teskarisiga o'girish",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Nomi",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprayt",
    "gui.SpriteInfo.show": "Koʻrsatish",
    "gui.SpriteInfo.size": "O'lchami",
    "gui.spriteSelectorItem.contextMenuDuplicate": "nusxasini yaratish",
    "gui.spriteSelectorItem.contextMenuExport": "eksport qilish",
    "gui.spriteSelectorItem.contextMenuDelete": "o'chirish",
    "gui.spriteSelector.addSpriteFromLibrary": "Sprayt tanlash",
    "gui.spriteSelector.addSpriteFromPaint": "Chizish",
    "gui.spriteSelector.addSpriteFromSurprise": "Ajablanish",
    "gui.spriteSelector.addSpriteFromFile": "Spraytni yuklab olish",
    "gui.stageHeader.stageSizeLarge": "Katta bosqichga o'ting",
    "gui.stageHeader.stageSizeSmall": "Kichik bosqichga o'ting",
    "gui.stageHeader.stageSizeFull": "To'liq ekran rejimiga o'tish",
    "gui.stageHeader.stageSizeUnFull": "To'liq ekrandan chiqish",
    "gui.stageHeader.fullscreenControl": "To'liq ekran nazorati",
    "gui.spriteSelector.addBackdropFromLibrary": "Fonni tanlash",
    "gui.stageSelector.addBackdropFromPaint": "Chizish",
    "gui.stageSelector.addBackdropFromSurprise": "Ajablanish",
    "gui.stageSelector.addBackdropFromFile": "Orqa fonni yuklab olish",
    "gui.stageSelector.stage": "Sahna",
    "gui.stageSelector.backdrops": "Fonlar",
    "gui.telemetryOptIn.label": "Yo'naltirishni yaxshilash statistikasi",
    "gui.telemetryOptIn.body1": "Scratch jamoasi har doim Scratchning butun dunyoda qanday qo'llanilishini yaxshiroq tushunishga harakat qilmoqda. Ushbu ishni qo'llab-quvvatlash uchun, Scratch-dan foydalanish ma'lumotlarini avtomatik ravishda Scratch Team-ga yuborishingiz mumkin.",
    "gui.telemetryOptIn.body2": "Biz to'playdigan ma'lumotlarga tilni tanlash, blokni ishlatish va loyihani saqlash, yuklash va yuklash kabi ba'zi hodisalar kiradi. Biz shaxsiy ma'lumotlarni to'plamaymiz. Qo'shimcha ma'lumot olish uchun, iltimos, {privacyPolicyLink} -ga qarang.",
    "gui.telemetryOptIn.privacyPolicyLink": "Shaxsiy ma'lumotni himoya siyosati",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo Rejimi",
    "gui.webglModal.label": "Brauzeringiz WebGL-ni qo'llab-quvvatlamaydi",
    "gui.webglModal.description": "Afsuski, bu brauzeringiz yoki kompyuteringiz {webGlLink} ga \no'xshaydi. Ushbu texnologiya Scratch 3.0ni ishlatish uchun talab qilinadi.",
    "gui.webglModal.webgllink": "webgl-ni qo'llab-quvvatlamaydi",
    "gui.webglModal.back": "Orqaga",
    "gui.webglModal.previewfaq": "Ko'proq ma'lumot olish uchun {previewFaqLink} ga o'ting.",
    "gui.webglModal.previewfaqlinktext": "Ko'p so'raladigan savollar(Savol-javob)",
    "gui.costumeLibrary.chooseABackdrop": "Fonni tanlash",
    "gui.costumeLibrary.chooseACostume": "Ko'rinishni tanlash",
    "gui.costumeTab.addBackdropFromLibrary": "Fonni tanlash",
    "gui.costumeTab.addCostumeFromLibrary": "Ko'rinishni tanlash",
    "gui.costumeTab.addBlankCostume": "Chizish",
    "gui.costumeTab.addSurpriseCostume": "Ajablanish",
    "gui.costumeTab.addFileBackdrop": "Orqa fonni yuklab olish",
    "gui.costumeTab.addFileCostume": "Ko'rinishni yuklab olish",
    "gui.extensionLibrary.chooseAnExtension": "Kengaytmani tanlang",
    "gui.extensionLibrary.extensionUrl": "Kengaytma URL manzilini kiriting",
    "gui.monitors.importListColumnPrompt": "Qanday yangi chiziqdan foydalanilsin?(1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ovoz yozishni boshlab bo'lmaydi",
    "gui.soundLibrary.chooseASound": "Ovozni tanlash",
    "gui.soundTab.fileUploadSound": "Ovozni yuklash",
    "gui.soundTab.surpriseSound": "Ajablanish",
    "gui.soundTab.recordSound": "Ovoz yozish",
    "gui.soundTab.addSoundFromLibrary": "Ovozni tanlash",
    "gui.spriteLibrary.chooseASprite": "Sprayt tanlash",
    "gui.tipsLibrary.tutorials": "Bir darslik tanlash",
    "gui.alerts.createsuccess": "Yangi loyiha yaratildi.",
    "gui.alerts.createcopysuccess": "Loyiha nusxasi sifatida saqlandi.",
    "gui.alerts.createremixsuccess": "Loyiha remix sifatida saqlandi.",
    "gui.alerts.creating": "Yangi yaratish ...",
    "gui.alerts.creatingCopy": "Loyihani nusxalash ...",
    "gui.alerts.creatingRemix": "Loyihani qayta tuzish ...",
    "gui.alerts.creatingError": "Loyihani yaratib bo'lmadi. Qayta urinib ko'ring!",
    "gui.alerts.savingError": "Loyihani saqlab bo'lmadi.",
    "gui.alerts.savesuccess": "Loyiha saqlandi.",
    "gui.alerts.saving": "Loyihani saqlash ...",
    "gui.alerts.cloudInfo": "Bulutli o'zgaruvchilar faqat harflar yoki belgilar emas, balki raqamlarni qo'llab-quvvatlaydi. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Ko'proq ma'lumot oling.",
    "gui.alerts.importing": "Import qilinmoqda ...",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "mening o'zgaruvchim",
    "gui.howtos.intro-move-sayhello-hat.name": "Boshlash",
    "gui.howtos.intro-move.step_stepMove": "Ko'chirish bloklarini qo'shing",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Nomidan multfilm yaratish",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Harf spraytini tanlash",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Tugmani bosganda ovozni ijro etish",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Boshqa harf spraytini tanlash",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Rangni o'zgartirish",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Boshqa harf spraytini tanlab aylantirish",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Boshqa harf spraytini tanlab kengaytirish",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Musiqa yaratish",
    "gui.howtos.Make-Music.step_PickInstrument": "Musiqiy asbob spraytini tanlash",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Tugmani bosganda ovozni tinglash",
    "gui.howtos.Make-Music.step_MakeSong": "Qo'shiq yaratish",
    "gui.howtos.make-music.step_MakeBeat": "Barabanni tanlang & ritm yarating",
    "gui.howtos.make-music.step_MakeBeatBox": "Sprite & Surprise Beatbox mikrofonini tanlang",
    "gui.howtos.story.name": "Hikoya yaratish",
    "gui.howtos.story.step_addbg": "Orqa fon qo'shish",
    "gui.howtos.story.step_addsprite": "Belgini qo'shish",
    "gui.howtos.story.step_saysomething": "Nima bo'lsa ham gapirish ",
    "gui.howtos.story.step_addanothersprite": "Boshqa belgini qo'shish",
    "gui.howtos.story.step_flip": "Yo'nalishni o'zgartirish",
    "gui.howtos.story.step_conversation": "Suhbat qurish",
    "gui.howtos.story.addanotherbg": "Boshqa fon qo'shish",
    "gui.howtos.story.step_swithbg": "Fonni almashtirish",
    "gui.howtos.story.step_hidewizard": "Belgilarni yashirish",
    "gui.howtos.story.step_showwizard": "Belgini ko'rsatish",
    "gui.howtos.make-a-chase-game.name": "Tutish o'yinini yaratish",
    "gui.howtos.Chase-Game.step_BG": "Orqa fon qo'shish",
    "gui.howtos.chase-game.step_AddOcto": "Sprayt qo'shish",
    "gui.howtos.make-music.step_LeftRight": "Yo'nalish tugmalari bilan o'ng va chapga harakatlantirish",
    "gui.howtos.Chase-Game.step_UpDown": "Yo'nalish tugmalari bilan yuqoriga va pastga harakatlantirish",
    "gui.howtos.Chase-Game.step_AddStar": "Boshqa sprayt qo'shish",
    "gui.howtos.Chase-Game.step_MoveRandom": "Tasodifiy harakatlanish",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ahtapot sprayt tegilganda tovush chiqarish",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Hisob o'zgaruvchisini yaratish",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ahtapot sprayt tegilganda skor qo'shish",
    "gui.howtos.animate-char.name": "Belgilarni multfilm orqali yaratish",
    "gui.howtos.animate-char.step_addbg": "Orqa fon qo'shish",
    "gui.howtos.animate-char.step_addsprite": "Sprayt qo'shish",
    "gui.howtos.animate-char.step_saysomething": "Nima bo'lsa ham gapirish ",
    "gui.howtos.animate-char.step_addsound": "Ovoz qo'shish",
    "gui.howtos.animate-char.step_animatetalking": "Dialogni multfilm orqali gapirish",
    "gui.howtos.animate-char.step_arrowkeys": "Ko'rsatgich belgisidan foydalanganda harakatlanish",
    "gui.howtos.animate-char.step_jump": "Sakrash",
    "gui.howtos.animate-char.step_changecolor": "Rangni o'zgartirish",
    "gui.howtos.make-a-game.name": "Bosish o'yinini yaratish",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Sprayt-ni tanlash",
    "gui.howtos.make-a-game.step_GamePlaySound": "Tugmani bosganda ovozni tinglash",
    "gui.howtos.make-a-game.step_GameAddScore": "Hisob o'zgaruvchisini yaratish",
    "gui.howtos.make-a-game.step_GameChangeScore": "Hisobni oshirish tugmasini bosganingizda",
    "gui.howtos.make-a-game.step_Random": "Xohlagan vaqtda harakatlanish",
    "gui.howtos.make-music.step_GameChangeColor": "Rangni o'zgartirish",
    "gui.howtos.make-music.step_ResetScore": "Hisobni qayta tiklash",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Sarguzasht o'yinini harakatlantirish",
    "gui.howtos.cartoon-network.step_CNcharacter": "Ko'rsatiladigan belgi tanlang",
    "gui.howtos.cartoon-network.step_CNsay": "Nimadir soʻzlang",
    "gui.howtos.cartoon-network.step_CNglide": "Sirpanadigan darajada harakatlanish",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Izlanish uchun ob'ektni tanlang",
    "gui.howtos.cartoon-network.step_CNcollect": "Elementlarni to'plash",
    "gui.howtos.cartoon-network.step_CNvariable": "Hisob o'zgaruvchisini yarating",
    "gui.howtos.cartoon-network.step_CNscore": "Hisobni saqlash",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Yuqori daraja: fonni o'zgartirish",
    "gui.howtos.videosens.name": "Vidioni taqiqlash",
    "gui.howtos.videosens.step_addextension": "Kengaytmani qo'shish",
    "gui.howtos.videosens.step_pet": "Mushukni erkalsh",
    "gui.howtos.videosens.step_animate": "Multfilm yaratish",
    "gui.howtos.videosens.step_pop": "Sharni yorish",
    "gui.howtos.say-it-out-loud": "So'zlashadigan multfilm yaratish",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Nutq bloklariga matn qo'shing",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Nimani bo'lsa ham gapirish",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Ovozni sozlash",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Ko'chiring",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Orqa fon qo'shish",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Boshqa belgini qo'shish",
    "gui.howtos.say-it-out-loud.step_TXTSong": " Qo'shiqni maqtash",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Rangni oʻzgartiring",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Atrofida aylaning",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Kattalshib kichkinalashib",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Sprayt qo'shish",
    "gui.howtos.add-sprite.step_addSprite": "Sprayt qo'shish",
    "gui.howtos.add-a-backdrop.name": "Orqa fon qo'shish",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Hajmini o'zgartirish",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Sirpanadigan darajada harakatlanish",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Ovoz yozish",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Aylanadigan qilib yaratish",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Berkitish va ko'rsatish",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Spraytdan multfilm yaratish",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Ko'rsatgich belgilaridan foydalanish",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Effektlarni qo'shish",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Musiqa",
    "gui.extension.music.description": "Musiqa saboblari va barabanlarni ijro etish",
    "gui.extension.pen.name": "Qalam",
    "gui.extension.pen.description": "Spraytdan foydalanib chizib ko'ring",
    "gui.extension.videosensing.name": "Vidioni taqiqlash",
    "gui.extension.videosensing.description": "Kamera bilan harakatlanishning ma'nosi.",
    "gui.extension.text2speech.name": "Matn ovozini o'zgartirish",
    "gui.extension.text2speech.description": "Loyihalaringizni muhokama qiling.",
    "gui.extension.translate.name": "Tarjima",
    "gui.extension.translate.description": "Matnni turli xil tillarga tarjima qilib ko'ring.",
    "gui.extension.makeymakey.description": "Nima bo'lsa ham klavyatura orqala yaratib ko'ring",
    "gui.extension.microbit.description": "Loyihani dunyo bilan ulashib ko'ring",
    "gui.extension.microbit.connectingMessage": "Unalmoqda...",
    "gui.extension.ev3.description": "Interaktiv robotlarni va boshqalarni yarating.",
    "gui.extension.ev3.connectingMessage": "Ulanmoqda...EV3 dagi pin 1234 ga o'rnatilganligi tekshirib ko'ring",
    "gui.extension.boost.description": "Robot mavjudotlariga hayotga olib keling",
    "gui.extension.boost.connectingMessage": "Ulanmoqda...",
    "gui.extension.wedo2.description": "Motor va sensorlardan foydalanib yaratib ko'ring",
    "gui.extension.wedo2.connectingMessage": "Ulanmoqda...",
    "gui.extension.gdxfor.description": "Surish, tortish, harakat va aylanishni sezish",
    "gui.extension.gdxfor.connectingMessage": "Ulanmoqda...",
    "gui.libraryTags.all": "Hammasi",
    "gui.libraryTags.animals": "Hayvonlar",
    "gui.libraryTags.dance": "Raqs",
    "gui.libraryTags.effects": "Ta'sir",
    "gui.libraryTags.fantasy": "Fantastika",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Oziq-ovqat",
    "gui.libraryTags.indoors": "Uy ichkarisida",
    "gui.libraryTags.loops": "Takrorlash",
    "gui.libraryTags.music": "Musiqa",
    "gui.libraryTags.notes": "Nota",
    "gui.libraryTags.outdoors": "Tashqarida",
    "gui.libraryTags.patterns": "Naqshlar",
    "gui.libraryTags.people": "Odamlar",
    "gui.libraryTags.percussion": "Cholg'u asbob",
    "gui.libraryTags.space": "Kosmos",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Dengiz osti",
    "gui.libraryTags.voice": "Ovozi",
    "gui.libraryTags.wacky": "G'alati tovush",
    "gui.libraryTags.animation": "Animatsiya",
    "gui.libraryTags.art": "San’at",
    "gui.libraryTags.games": "O‘yinlar",
    "gui.libraryTags.stories": "Hikoyalar",
    "gui.libraryTags.letters": "Harflar",
    "gui.opcodeLabels.direction": "yo'nalish",
    "gui.opcodeLabels.xposition": "x kordinatasi",
    "gui.opcodeLabels.yposition": "y kordinatasi",
    "gui.opcodeLabels.size": "o'lcham",
    "gui.opcodeLabels.costumename": "kostyum nomi",
    "gui.opcodeLabels.costumenumber": "kostyum raqami",
    "gui.opcodeLabels.backdropname": "fon nomi",
    "gui.opcodeLabels.backdropnumber": "fon raqami",
    "gui.opcodeLabels.volume": "ovoz",
    "gui.opcodeLabels.tempo": "Zarba tezligi",
    "gui.opcodeLabels.answer": "javob",
    "gui.opcodeLabels.loudness": "tovush",
    "gui.opcodeLabels.username": "foydalanuvchi ismi",
    "gui.opcodeLabels.year": "yil",
    "gui.opcodeLabels.month": "oy",
    "gui.opcodeLabels.date": "sana",
    "gui.opcodeLabels.dayofweek": "hafta kuni",
    "gui.opcodeLabels.hour": "soat",
    "gui.opcodeLabels.minute": "daqiqa",
    "gui.opcodeLabels.second": "soniya",
    "gui.opcodeLabels.timer": "taymer",
    "gui.projectLoader.loadError": "Tanlangan loyiha faylini yuklab bo'lmadi.",
    "gui.sharedMessages.backdrop": "fon {index}",
    "gui.sharedMessages.costume": "kostyum{index} ",
    "gui.sharedMessages.sprite": "Sprayt {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Xozirgi loyihani mazmunini almashtiringmi?",
    "gui.sharedMessages.loadFromComputerTitle": "Kompyuteringizdan yuklab oling",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch loyihasi",
    "boost.color.any": "ixtiyoriy rang",
    "boost.color.black": "qora",
    "boost.color.blue": "havo rang",
    "boost.color.green": "yashil",
    "boost.color.red": "qizil",
    "boost.color.white": "oq",
    "boost.color.yellow": "sariq",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] positsiyasi",
    "boost.getTiltAngle": " [TILT_DIRECTION] burilish burchagi",
    "boost.motorDirection.backward": "shu yo'l",
    "boost.motorDirection.forward": "shu yo'l",
    "boost.motorDirection.reverse": "teskari",
    "boost.motorOff": "motor [MOTOR_ID]  ni ochiring",
    "boost.motorOn": "motor [MOTOR_ID] ni yoqing",
    "boost.motorOnFor": "motorni [MOTOR_ID] soniyalar [DURATION] davomida aylantiring",
    "boost.motorOnForRotation": "motorni aylantiring [MOTOR_ID] aylanishi [ROTATION] uchun",
    "boost.seeingColor": " [COLOR] rangdagi g'ishtni ko'ryapsizmi?",
    "boost.setLightHue": "ochiq rangni [HUE] ga o'rnatish",
    "boost.setMotorDirection": "motorni joylashtirish [MOTOR_ID] yo'nalishi [MOTOR_DIRECTION]",
    "boost.setMotorPower": "motorni [MOTOR_ID] tezligini [POWER] ga qo'ying",
    "boost.tiltDirection.any": "Hech narsa",
    "boost.tiltDirection.down": "pastga",
    "boost.tiltDirection.left": "chapga",
    "boost.tiltDirection.right": "oʻngga",
    "boost.tiltDirection.up": "tepaga",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "[TILT_DIRECTION_ANY] o'girildikda",
    "ev3.beepNote": "[TIME] soniya davomida [NOTE] ta ovozli signal eshitiladi",
    "ev3.buttonPressed": "tugma [PORT] bosildimi?",
    "ev3.getBrightness": "yorqinlik",
    "ev3.getDistance": "masofa",
    "ev3.getMotorPosition": "motor [PORT] holatiga o'tish",
    "ev3.motorSetPower": "motor [PORT] kuchini [POWER] % sozlash",
    "ev3.motorTurnClockwise": "[PORT] Motorni [TIME] soniya davomida ushbu tomonga aylantiring",
    "ev3.motorTurnCounterClockwise": "[PORT] Motorni [TIME] soniya davomida u er tomonga aylantiring",
    "ev3.whenBrightnessLessThan": "Yorqinligi < [DISTANCE] bo'lganda",
    "ev3.whenButtonPressed": "[PORT] tugmasi bosilganda",
    "ev3.whenDistanceLessThan": "masofa < [DISTANCE]",
    "gdxfor.getAcceleration": "tezlashtirish [DIRECTION]",
    "gdxfor.getForce": "kuch",
    "gdxfor.getSpin": "siqish tezligi [DIRECTION]",
    "gdxfor.getTilt": " [TILT] egilish",
    "gdxfor.isFreeFalling": "tushganmi?",
    "gdxfor.isTilted": "egilish burchagi [TILT]?",
    "gdxfor.pulled": "tortdi",
    "gdxfor.pushed": "itarib yuborishdi",
    "gdxfor.shaken": "Shoklandi",
    "gdxfor.startedFalling": "tushib ketdi",
    "gdxfor.tiltDirectionMenu.any": "Hech narsa",
    "gdxfor.tiltDirectionMenu.back": "orqaga",
    "gdxfor.tiltDirectionMenu.front": "oldinga",
    "gdxfor.tiltDirectionMenu.left": "chapga",
    "gdxfor.tiltDirectionMenu.right": "oʻngga",
    "gdxfor.turnedFaceDown": "yuzini pastga qaratdi",
    "gdxfor.turnedFaceUp": "yuzi yuqoriga ko'tarildi",
    "gdxfor.whenForcePushedOrPulled": "Majburiy sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "[GESTURE] bo'lganda",
    "gdxfor.whenTilted": "[TILT] yiqilganida ",
    "makeymakey.downArrow": "past ko'rsatgich",
    "makeymakey.downArrowShort": "pastga",
    "makeymakey.leftArrow": "chap ko'rsatgich",
    "makeymakey.leftArrowShort": "chapga",
    "makeymakey.rightArrow": "Oʻng koʻrsatkichi",
    "makeymakey.rightArrowShort": "oʻngga",
    "makeymakey.spaceKey": "bo'sh joy",
    "makeymakey.upArrow": "yuqori ko'rsatgich",
    "makeymakey.upArrowShort": "tepaga",
    "makeymakey.whenKeyPressed": "[KEY] tugma bosilganda",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] tartibda bosilganda ",
    "microbit.buttonsMenu.any": "Hech narsa",
    "microbit.clearDisplay": "aniq ko'rsatiladi",
    "microbit.defaultTextToDisplay": "Salom!",
    "microbit.displaySymbol": "ekran [MATRIX]",
    "microbit.displayText": "ekran yozuvi [TEXT]",
    "microbit.gesturesMenu.jumped": "sakragan",
    "microbit.gesturesMenu.moved": "harakatlangan",
    "microbit.gesturesMenu.shaken": "silkingan",
    "microbit.isButtonPressed": "[BTN] tugmasini bosdingizmi?",
    "microbit.isTilted": "[DIRECTION] tomoniga egilish?",
    "microbit.pinStateMenu.off": "o‘chiq",
    "microbit.pinStateMenu.on": "yoniq",
    "microbit.tiltAngle": "burilish burchagi [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "Hech narsa",
    "microbit.tiltDirectionMenu.back": "orqaga",
    "microbit.tiltDirectionMenu.front": "oldinga",
    "microbit.tiltDirectionMenu.left": "chapga",
    "microbit.tiltDirectionMenu.right": "oʻngga",
    "microbit.whenButtonPressed": "[BTN] tugmasi bosilganda",
    "microbit.whenGesture": "[GESTURE] bo'lganda",
    "microbit.whenPinConnected": "pin [PIN] ulanganda",
    "microbit.whenTilted": "egilib [DIRECTION]",
    "music.categoryName": "Musiqa",
    "music.changeTempo": "tezlikni [TEMPO] o'zgartirish",
    "music.drumBass": "(2) Baraban ",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Kabasa",
    "music.drumClaves": "(9) Klave",
    "music.drumClosedHiHat": "(6) yopiq hay-het",
    "music.drumConga": "(14) konga",
    "music.drumCowbell": "(11) Kovbell",
    "music.drumCrashCymbal": "(4) Kresh",
    "music.drumCuica": "(18) Kuika",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Qarsak",
    "music.drumOpenHiHat": "(5) Ochiq hay-het",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Kichik baraban",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Uchburchak",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Korobo'chka",
    "music.getTempo": "tezlik",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fago't",
    "music.instrumentCello": "(8) Violonchel ",
    "music.instrumentChoir": "(15) Xo'r",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Elektr gitara",
    "music.instrumentElectricPiano": "(2) Elektr pianino",
    "music.instrumentFlute": "(12) Fleyta",
    "music.instrumentGuitar": "(4) Gitara",
    "music.instrumentMarimba": "(19) Marimba ",
    "music.instrumentMusicBox": "(17) Musiqa qutisi",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Pianino",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksafon",
    "music.instrumentSteelDrum": "(18) Temirli baraban",
    "music.instrumentSynthLead": "(20) Sentezator",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Yog'ochli Floyd",
    "music.midiPlayDrumForBeats": "[DRUM] asbobda [BEATS] zarbada ijro etish",
    "music.midiSetInstrument": "asbobni [INSTRUMENT]ga sozlash",
    "music.playDrumForBeats": "[DRUM] asbobda [BEATS] zarbada ijro etish",
    "music.playNoteForBeats": "[NOTE] ni [BEATS] zarbada ijro etish",
    "music.restForBeats": "[BEATS] zarba kutish",
    "music.setInstrument": "asbobni [INSTRUMENT] ga sozlash",
    "music.setTempo": "tezlikni [TEMPO] ga sozlash",
    "pen.categoryName": "Qalam ",
    "pen.changeColorParam": "qalamni [COLOR_PARAM] [VALUE] ga o'zgartirish ",
    "pen.changeHue": "qalam rangini [HUE] ga o'zgartirish",
    "pen.changeShade": "[SHADE] tomonidan qalam shadi o'zgarishi",
    "pen.changeSize": "qalam o'lchamini [SIZE] ga o'zgartirish",
    "pen.clear": "tozalash",
    "pen.colorMenu.brightness": "yorqinlik",
    "pen.colorMenu.color": "rang",
    "pen.colorMenu.saturation": "to'qlik",
    "pen.colorMenu.transparency": "tiniqlik",
    "pen.penDown": "qalamni tushirish",
    "pen.penUp": "qalamni ko'tarish",
    "pen.setColor": "qalam rangini [COLOR] ga sozlash",
    "pen.setColorParam": "qalamni [COLOR_PARAM] [VALUE] ga sozlash",
    "pen.setHue": "qalam rangini [HUE] ga sozlash",
    "pen.setShade": "[SHADE] ga sozlamalarni joylashtirish",
    "pen.setSize": "qalam o'lchamini [SIZE] ga sozlash",
    "pen.stamp": "pechat qo'yish",
    "speech.defaultWhenIHearValue": "kettik",
    "speech.extensionName": "Matnga nutq",
    "speech.listenAndWait": "tinglash va kutish",
    "speech.speechReporter": "Nutq",
    "speech.whenIHear": "Quyidagi yozuvni eshitganimda [PHRASE]",
    "text2speech.alto": "Alto",
    "text2speech.categoryName": "Matn ovozini o'zgartirish",
    "text2speech.defaultTextToSpeak": "salom",
    "text2speech.giant": "ulkan ",
    "text2speech.kitten": "mushukcha",
    "text2speech.setLanguageBlock": "tilni [LANGUAGE]ga sozlash",
    "text2speech.setVoiceBlock": "ovozni [VOICE] ga sozlash ",
    "text2speech.speakAndWaitBlock": "gapirish [WORDS]",
    "text2speech.squeak": "g'ichirlash ",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Tarjima",
    "translate.defaultTextToTranslate": "salom",
    "translate.translateBlock": "[WORDS] ni [LANGUAGE] ga tarjima qilish",
    "translate.viewerLanguage": "til",
    "videoSensing.categoryName": "vidioni aniqlash",
    "videoSensing.direction": "yo'nalish",
    "videoSensing.motion": "harakat",
    "videoSensing.off": "o'chirish",
    "videoSensing.on": "yoqish",
    "videoSensing.onFlipped": "tirnalgan",
    "videoSensing.setVideoTransparency": "vidio shaffofligini [TRANSPARENCY] ga sozlash",
    "videoSensing.sprite": "sprayt",
    "videoSensing.stage": "bosqichda",
    "videoSensing.videoOn": "vidio [ATTRIBUTE] da [SUBJECT]",
    "videoSensing.videoToggle": "video [VIDEO_STATE] yoqing",
    "videoSensing.whenMotionGreaterThan": "vidio harakati > [REFERENCE] bo'lganda",
    "wedo2.getDistance": "masofa",
    "wedo2.getTiltAngle": " [TILT_DIRECTION] burilish burchagi",
    "wedo2.isTilted": "tilga olingan [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "shu yo'l",
    "wedo2.motorDirection.forward": "shu yo'l",
    "wedo2.motorDirection.reverse": "teskari",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "hamma matorlar",
    "wedo2.motorId.b": "mator B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "[MOTOR_ID] ni o'chiring",
    "wedo2.motorOn": "[MOTOR_ID] ni yoqing",
    "wedo2.motorOnFor": "[DURATION] soniya uchun [MOTOR_ID] yoqing",
    "wedo2.playNoteFor": "[DURATION] soniya uchun [NOTE] eslatmasini ijro eting",
    "wedo2.setLightHue": "ochiq rangni [HUE] ga o'rnatish",
    "wedo2.setMotorDirection": "[MOTOR_ID] yo'nalishini [MOTOR_DIRECTION] tomonga o'rnatish",
    "wedo2.startMotorPower": "[MOTOR_ID] kuchini [POWER] ga qo'ying",
    "wedo2.tiltDirection.any": "Hech narsa",
    "wedo2.tiltDirection.down": "pastga",
    "wedo2.tiltDirection.left": "chapga",
    "wedo2.tiltDirection.right": "oʻngga",
    "wedo2.tiltDirection.up": "tepaga",
    "wedo2.whenDistance": "[OP] [REFERENCE] ga yetganingizda",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY] o'girildikda",
    "paint.paintEditor.hue": "Rang",
    "paint.paintEditor.saturation": "To'yinganlik",
    "paint.paintEditor.brightness": "Yorqinlik",
    "paint.paintEditor.costume": "Kostyum",
    "paint.paintEditor.group": "Guruh",
    "paint.paintEditor.ungroup": "Guruhlashni bekor qilish",
    "paint.paintEditor.undo": "Bekor qilish",
    "paint.paintEditor.redo": "Qaytarish",
    "paint.paintEditor.forward": "Oldiga",
    "paint.paintEditor.backward": "Orqaga",
    "paint.paintEditor.front": "Eng oldiga",
    "paint.paintEditor.back": "Eng orqaga",
    "paint.paintEditor.more": "Ko'proq",
    "paint.modeTools.brushSize": "O'lchami",
    "paint.modeTools.eraserSize": "O'chirg'ich o'lchami",
    "paint.modeTools.copy": "Nusxa olish",
    "paint.modeTools.paste": "Joylashtirish",
    "paint.modeTools.delete": "O'chirish",
    "paint.modeTools.curved": "Egri",
    "paint.modeTools.pointed": "Ko'rsatilgan",
    "paint.modeTools.thickness": "Qalinligi",
    "paint.modeTools.flipHorizontal": "Chapdan o'ngga burish",
    "paint.modeTools.flipVertical": "Yuqoridan pastga burish",
    "paint.modeTools.filled": "Bo'yash",
    "paint.modeTools.outlined": "Qisqartirilgan",
    "paint.paintEditor.bitmap": "Rastr tasvirga o'zgartirish",
    "paint.paintEditor.vector": "Vektor tasvirga o'zgartirish",
    "paint.paintEditor.fill": "To'ldirish",
    "paint.paintEditor.stroke": "Ramqa",
    "paint.brushMode.brush": "Kistichka",
    "paint.eraserMode.eraser": "O'chirg'ich",
    "paint.fillMode.fill": "Bo'yash",
    "paint.lineMode.line": "Chiziq",
    "paint.ovalMode.oval": "Aylana",
    "paint.rectMode.rect": "Toʻrtburchak",
    "paint.reshapeMode.reshape": "Burchakli to'rtburchak",
    "paint.roundedRectMode.roundedRect": "Aval shakl berish",
    "paint.selectMode.select": "Tanlash",
    "paint.textMode.text": "Yozuv",
    "paint.colorPicker.swap": "Almashtirish"
  },
  "th": {
    "gui.alerts.lostPeripheralConnection": "Scratch สูญเสียการเชื่อมต่อไปยัง {extensionName}",
    "gui.alerts.tryAgain": "ลองใหม่อีกครั้ง",
    "gui.alerts.download": "ดาวน์โหลด",
    "gui.connection.reconnect": "เชื่อมต่อใหม่",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "กระเป๋าเป้",
    "gui.backpack.errorBackpack": "เกิดความผิดพลาดขณะโหลดกระเป๋าเป้",
    "gui.backpack.loadingBackpack": "กำลังโหลด...",
    "gui.backpack.more": "เพิ่มเติม",
    "gui.backpack.emptyBackpack": "กระเป๋าเป้ว่างเปล่า",
    "gui.unsupportedBrowser.label": "ไม่รองรับเบราเซอร์",
    "gui.unsupportedBrowser.errorLabel": "เกิดข้อผิดพลาดขึ้น",
    "gui.unsupportedBrowser.notRecommended": "เราเสียใจมาก แต่ดูเหมือนว่าคุณกำลังใช้เบราว์เซอร์รุ่นที่ Scratch ไม่รองรับ เราแนะนำให้อัปเดตเบราว์เซอร์ที่รองรับให้เป็นเวอร์ชั่นล่าสุด เช่น Google Chrome , Mozilla Firefox, Microsoft Edge หรือ Apple Safari",
    "gui.unsupportedBrowser.description": "เราเสียใจมาก แต่ Scratch ไม่รองรับเบราว์เซอร์นี้ เราแนะนำให้อัปเดตเบราว์เซอร์ที่รองรับให้เป็นเวอร์ชั่นล่าสุด เช่น Google Chrome , Mozilla Firefox, Microsoft Edge หรือ Apple Safari",
    "gui.unsupportedBrowser.back": "ย้อนกลับ",
    "gui.unsupportedBrowser.previewfaq": "เรียนรู้เพิ่มเติม ไปที่ {previewFaqLink} ",
    "gui.unsupportedBrowser.previewfaqlinktext": "คำถามพบบ่อย",
    "gui.cards.all-tutorials": "บทเรียน",
    "gui.cards.shrink": "หด",
    "gui.cards.expand": "คลี่ออก",
    "gui.cards.close": "ปิด",
    "gui.cards.more-things-to-try": "มีอีกเยอะให้ลอง!",
    "gui.cards.see-more": "ดูเพิ่มเติม",
    "gui.comingSoon.message1": "ไม่ต้องกังวล เรากำลังทำอยู่ {emoji}",
    "gui.comingSoon.message2": "เร็วๆ นี้...",
    "gui.comingSoon.message3": "เรากำลังทำอยู่ {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "ไม่พบอุปกรณ์",
    "gui.connection.auto-scanning.prescan": "นำอุปกรณ์ของคุณมาใกล้ๆ จากนั้นเริ่มค้นหา",
    "gui.connection.auto-scanning.pressbutton": "กดปุ่มที่อุปกรณ์ของคุณ",
    "gui.connection.auto-scanning.start-search": "เริ่มค้นหา",
    "gui.connection.connecting-searchbutton": "ค้นหา...",
    "gui.connection.auto-scanning.try-again": "ลองใหม่อีกครั้ง",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "เชื่อมต่อแล้ว",
    "gui.connection.disconnect": "ตัดการเชื่อมต่อ",
    "gui.connection.go-to-editor": "กลับไปยังตัวแก้ไขโค้ด",
    "gui.connection.connecting-cancelbutton": "กำลังเชื่อมต่อ...",
    "gui.connection.error.errorMessage": "อ๊ะ ดูเหมือนว่ามีบางอย่างผิดพลาด",
    "gui.connection.error.tryagainbutton": "ลองใหม่อีกครั้ง",
    "gui.connection.error.helpbutton": "ช่วยเหลือ",
    "gui.connection.peripheral-name-label": "ชื่ออุปกรณ์",
    "gui.connection.connect": "เชื่อมต่อ",
    "gui.connection.scanning.lookingforperipherals": "กำลังมองหาอุปกรณ์",
    "gui.connection.scanning.noPeripheralsFound": "ไม่พบอุปกรณ์",
    "gui.connection.scanning.instructions": "เลือกอุปกรณ์ของคุณในรายการด้านบน",
    "gui.connection.search": "รีเฟรช",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "ตรวจสอบว่าคุณได้ติดตั้ง Scratch Link และเปิดใช้งานอยู่",
    "gui.connection.unavailable.enablebluetooth": "ตรวจสอบว่าเปิด Bluetooth แล้ว",
    "gui.connection.unavailable.tryagainbutton": "ลองใหม่อีกครั้ง",
    "gui.connection.unavailable.helpbutton": "ช่วยเหลือ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "ไป",
    "gui.controls.stop": "หยุด",
    "gui.crashMessage.label": "อุ๊ย! มีบางอย่างผิดพลาด",
    "gui.crashMessage.description": "เราเสียใจมาก แต่ดูเหมือนว่า Scratch เกิดขัดข้องขึ้น ข้อผิดพลาดนี้ได้รายงานโดยอัตโนมัติไปยังทีม Scratch แล้ว โปรดรีเฟรชหน้าเว็บของคุณเพื่อลองอีกครั้ง",
    "gui.crashMessage.errorNumber": "ข้อผิดพลาดของคุณได้ถูกเก็บบันทึกไว้ด้วยไอดี {errorId}",
    "gui.crashMessage.reload": "โหลดใหม่",
    "gui.customProcedures.myblockModalTitle": "สร้างบล็อกใหม่",
    "gui.customProcedures.addAnInputNumberText": "เพิ่มช่องรับ",
    "gui.customProcedures.numberTextType": "ตัวเลขหรือข้อความ",
    "gui.customProcedures.addAnInputBoolean": "เพิ่มช่องรับ",
    "gui.customProcedures.booleanType": "บูลีน",
    "gui.customProcedures.addALabel": "เพิ่มข้อความ",
    "gui.customProcedures.runWithoutScreenRefresh": "รันโดยไม่รีเฟรชหน้าจอ ",
    "gui.customProcedures.cancel": "ยกเลิก",
    "gui.customProcedures.ok": "ตกลง",
    "gui.SpriteInfo.direction": "ทิศทาง",
    "gui.directionPicker.rotationStyles.allAround": "รอบด้าน",
    "gui.directionPicker.rotationStyles.leftRight": "ซ้าย/ขวา",
    "gui.directionPicker.rotationStyles.dontRotate": "อย่าหมุน",
    "gui.gui.addExtension": "เพิ่มส่วนขยาย",
    "gui.gui.codeTab": "โค้ด",
    "gui.gui.backdropsTab": "ฉากหลัง",
    "gui.gui.costumesTab": "คอสตูม",
    "gui.gui.soundsTab": "เสียง",
    "gui.extensionLibrary.comingSoon": "เร็วๆ นี้",
    "gui.extensionLibrary.requires": "ต้องการ",
    "gui.extensionLibrary.collaboration": "ร่วมมือกับ",
    "gui.library.filterPlaceholder": "ค้นหา",
    "gui.library.allTag": "ทั้งหมด",
    "gui.loader.message1": "กำลังสร้างบล็อก ...",
    "gui.loader.message2": "กำลังโหลดสไปรต์ …",
    "gui.loader.message3": "กำลังโหลดเสียง ...",
    "gui.loader.message4": "กำลังโหลดส่วนขยาย ...",
    "gui.loader.message5": "จับแมวใส่กระด้ง …",
    "gui.loader.message6": "กำลังส่ง Nano …",
    "gui.loader.message7": "กำลังเป่า Gobo …",
    "gui.loader.message8": "กำลังเตรียมอิโมจิ ...",
    "gui.loader.headline": "กำลังโหลดโครงงาน",
    "gui.loader.creating": "การสร้างโครงการ",
    "gui.accountMenu.profile": "โปรไฟล์",
    "gui.accountMenu.myStuff": "ผลงานของฉัน",
    "gui.accountMenu.myClasses": "ชั้นเรียนของฉัน",
    "gui.accountMenu.myClass": "ชั้นเรียนของฉัน",
    "gui.accountMenu.accountSettings": "ตั้งค่าบัญชี",
    "gui.accountMenu.signOut": "ลงชื่อออก",
    "gui.authorInfo.byUser": "โดย {username}",
    "gui.menuBar.seeProjectPage": "ดูหน้าโครงงาน",
    "gui.menuBar.language": "Language",
    "general.username": "ชื่อผู้ใช้",
    "general.password": "รหัสผ่าน",
    "general.signIn": "ลงชื่อเข้าใช้",
    "login.needHelp": "ต้องการความช่วยเหลือ?",
    "form.validationRequired": "ช่องกรอกนี้ต้องใส่",
    "gui.menuBar.tutorialsLibrary": "บทเรียน",
    "gui.menuBar.restoreSprite": "กู้คืนสไปร์ท",
    "gui.menuBar.restoreSound": "กู้คืนเสียง",
    "gui.menuBar.restoreCostume": "กู้คืนคอสตูม",
    "gui.menuBar.restore": "กู้คืน",
    "gui.menuBar.saveNow": "บันทึกทันที",
    "gui.menuBar.saveAsCopy": "บันทึกเป็น",
    "gui.menuBar.remix": "รีมิกซ์",
    "gui.menuBar.new": "ใหม่",
    "gui.menuBar.file": "แฟ้ม",
    "gui.menuBar.downloadToComputer": "บันทึกลงในคอมพิวเตอร์ของคุณ",
    "gui.menuBar.edit": "แก้ไข",
    "gui.menuBar.turboModeOff": "ปิดโหมดเทอร์โบ",
    "gui.menuBar.turboModeOn": "เปิดโหมดเทอร์โบ",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "เข้าร่วม Scratch",
    "gui.menuBar.signIn": "ลงชื่อเข้าใช้",
    "gui.gui.projectTitlePlaceholder": "ชื่อโครงงานที่นี่",
    "gui.menuBar.saveNowLink": "บันทึกเลย",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "แบ่งปัน",
    "gui.menuBar.share": "แชร์",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "ช่วยเหลือ",
    "gui.modal.back": "ย้อนกลับ",
    "gui.monitor.listMonitor.empty": "(ว่างเปล่า)",
    "gui.monitor.listMonitor.listLength": "ความยาว {length}",
    "gui.monitor.contextMenu.default": "เปลี่ยนเป็นจอปกติ",
    "gui.monitor.contextMenu.large": "เปลี่ยนเป็นจอใหญ่",
    "gui.monitor.contextMenu.slider": "ตัวเลื่อน",
    "gui.monitor.contextMenu.sliderRange": "เปลี่ยนระยะตัวเลื่อน",
    "gui.monitor.contextMenu.import": "นำเข้า",
    "gui.monitor.contextMenu.export": "ส่งออก",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "เล่น",
    "gui.playButton.stop": "หยุด",
    "gui.gui.variableScopeOptionAllSprites": "สำหรับสไปรต์ทั้งหมด",
    "gui.gui.variableScopeOptionSpriteOnly": "สำหรับสไปรต์นี้เท่านั้น",
    "gui.gui.cloudVariableOption": "ตัวแปรคลาวด์ (เก็บไว้บนเซิร์ฟเวอร์)",
    "gui.gui.variablePromptAllSpritesMessage": "ตัวแปรนี้จะมีให้ใช้สำหรับสไปร์ททั้งหมด",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "ยกเลิก",
    "gui.prompt.ok": "ตกลง",
    "gui.playbackStep.stopMsg": "หยุด",
    "gui.playbackStep.playMsg": "เล่น",
    "gui.playbackStep.loadingMsg": "กำลังโหลด...",
    "gui.playbackStep.saveMsg": "บันทึก",
    "gui.playbackStep.reRecordMsg": "บันทึกใหม่",
    "gui.recordModal.title": "บันทึกเสียง",
    "gui.recordingStep.beginRecord": "เริ่มการอัดบันทึกโดยการคลิกปุ่มข้างล่าง",
    "gui.recordingStep.permission": "{arrow}เราต้องได้รับอนุญาตจากคุณเพื่อใช้ไมโครโฟน",
    "gui.recordingStep.stop": "หยุดการอัดบันทึก",
    "gui.recordingStep.record": "อัดบันทึก",
    "gui.sliderModal.min": "ค่าต่ำสุด",
    "gui.sliderModal.max": "ค่าสูงสุด",
    "gui.sliderModal.title": "เปลี่ยนระยะตัวเลื่อน",
    "gui.sliderPrompt.cancel": "ยกเลิก",
    "gui.sliderPrompt.ok": "ตกลง",
    "gui.soundEditor.sound": "เสียง",
    "gui.soundEditor.play": "เล่น",
    "gui.soundEditor.stop": "หยุด",
    "gui.soundEditor.copy": "คัดลอก",
    "gui.soundEditor.paste": "วาง",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "ลบ",
    "gui.soundEditor.save": "บันทึก",
    "gui.soundEditor.undo": "ย้อนกลับ",
    "gui.soundEditor.redo": "ทำซ้ำ",
    "gui.soundEditor.faster": "เร็วขึ้น",
    "gui.soundEditor.slower": "ช้าลง",
    "gui.soundEditor.echo": "สะท้อน",
    "gui.soundEditor.robot": "หุ่นยนต์",
    "gui.soundEditor.louder": "ดัง",
    "gui.soundEditor.softer": "เบา",
    "gui.soundEditor.reverse": "กลับด้าน",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "ชื่อ",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "สไปรต์",
    "gui.SpriteInfo.show": "แสดง",
    "gui.SpriteInfo.size": "ขนาด",
    "gui.spriteSelectorItem.contextMenuDuplicate": "ทำซ้ำ",
    "gui.spriteSelectorItem.contextMenuExport": "ส่งออก",
    "gui.spriteSelectorItem.contextMenuDelete": "ลบ",
    "gui.spriteSelector.addSpriteFromLibrary": "เลือกสไปรต์",
    "gui.spriteSelector.addSpriteFromPaint": "วาดรูป",
    "gui.spriteSelector.addSpriteFromSurprise": "เซอร์ไพรส์",
    "gui.spriteSelector.addSpriteFromFile": "อัปโหลดสไปรต์",
    "gui.stageHeader.stageSizeLarge": "เปลี่ยนเป็นเวทีใหญ่",
    "gui.stageHeader.stageSizeSmall": "เปลี่ยนเป็นเวทีเล็ก",
    "gui.stageHeader.stageSizeFull": "เข้าโหมดเต็มจอ",
    "gui.stageHeader.stageSizeUnFull": "ออกจากโหมดเต็มจอ",
    "gui.stageHeader.fullscreenControl": "สลับโหมดเต็มจอ",
    "gui.spriteSelector.addBackdropFromLibrary": "เลือกฉากหลัง",
    "gui.stageSelector.addBackdropFromPaint": "วาดรูป",
    "gui.stageSelector.addBackdropFromSurprise": "เซอร์ไพรส์",
    "gui.stageSelector.addBackdropFromFile": "อัปโหลดฉากหลัง",
    "gui.stageSelector.stage": "เวที",
    "gui.stageSelector.backdrops": "ฉากหลัง",
    "gui.telemetryOptIn.label": "รายงานสถิติเพื่อพัฒนาปรับปรุง Scratch",
    "gui.telemetryOptIn.body1": "ทีมงาน Scratch พยายามหาวิธีที่จะเข้าใจว่าคนทั่วโลกใช้ Scratch อย่างไรบ้างอยู่เสมอ เพื่อช่วยสนับสนุนความพยายามเหล่านี้ คุณสามารถอนุญาตให้ Scratch ส่งข้อมูลการใช้งานต่าง ๆ ให้ทีมงาน Scratch โดยอัตโนมัติ",
    "gui.telemetryOptIn.body2": "ข้อมูลที่เรารวบรวมนั้นประกอบด้วย ภาษาที่เลือก การใช้บล็อก และเหตุการณ์บางอย่างเช่น การบันทึก การโหลด และการอัปโหลดโครงงาน เราจะไม่เก็บข้อมูลส่วนตัวใด ๆ ทั้งสิ้น กรุณาเยี่ยมชม {privacyPolicyLink} เพื่อดูรายละเอียดเพิ่มเติม",
    "gui.telemetryOptIn.privacyPolicyLink": "นโยบายความเป็นส่วนตัว",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "โหมดเทอร์โบ",
    "gui.webglModal.label": "เบราเซอร์ของคุณไม่รองรับ WebGL",
    "gui.webglModal.description": "น่าเสียดาย ดูเหมือนเบราเซอร์หรือคอมพิวเตอร์ของคุณ {webGlLink}  เทคโนโลยีนี้จำเป็นสำหรับการทำงานของ Scratch 3.0",
    "gui.webglModal.webgllink": "ไม่รองรับ WebGL",
    "gui.webglModal.back": "ย้อนกลับ",
    "gui.webglModal.previewfaq": "เรียนรู้เพิ่มเติม ไปที่ {previewFaqLink} ",
    "gui.webglModal.previewfaqlinktext": "คำถามพบบ่อย",
    "gui.costumeLibrary.chooseABackdrop": "เลือกฉากหลัง",
    "gui.costumeLibrary.chooseACostume": "เลือกคอสตูม",
    "gui.costumeTab.addBackdropFromLibrary": "เลือกฉากหลัง",
    "gui.costumeTab.addCostumeFromLibrary": "เลือกคอสตูม",
    "gui.costumeTab.addBlankCostume": "วาดรูป",
    "gui.costumeTab.addSurpriseCostume": "เซอร์ไพรส์",
    "gui.costumeTab.addFileBackdrop": "อัปโหลดฉากหลัง",
    "gui.costumeTab.addFileCostume": "อัปโหลดคอสตูม",
    "gui.extensionLibrary.chooseAnExtension": "เลือกส่วนขยาย",
    "gui.extensionLibrary.extensionUrl": "ใส่ URL ของส่วนขยาย",
    "gui.monitors.importListColumnPrompt": "คอลัมน์ไหนที่ควรจะนำมาใช้ (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "ไม่สามารถเริ่มบันทึกได้",
    "gui.soundLibrary.chooseASound": "เลือกเสียง",
    "gui.soundTab.fileUploadSound": "อัปโหลดเสียง",
    "gui.soundTab.surpriseSound": "เซอร์ไพรส์",
    "gui.soundTab.recordSound": "บันทึก",
    "gui.soundTab.addSoundFromLibrary": "เลือกเสียง",
    "gui.spriteLibrary.chooseASprite": "เลือกสไปรต์",
    "gui.tipsLibrary.tutorials": "เลือกบทเรียน",
    "gui.alerts.createsuccess": "โครงงานใหม่ได้ถูกสร้างแล้ว",
    "gui.alerts.createcopysuccess": "บันทึกโครงงานเป็นแบบสำเนา",
    "gui.alerts.createremixsuccess": "โครงงานบันทึกในฐานะรีมิกซ์",
    "gui.alerts.creating": "กำลังสร้างขึ้นใหม่…",
    "gui.alerts.creatingCopy": "กำลังคัดลอกโครงงาน...",
    "gui.alerts.creatingRemix": "กำลังรีมิกซ์โครงงาน…",
    "gui.alerts.creatingError": "ไม่สามารถสร้างโครงการได้ โปรดลองใหม่อีกครั้ง",
    "gui.alerts.savingError": "โครงการไม่สามารถบันทึกได้",
    "gui.alerts.savesuccess": "โครงงานถูกบันทึกแล้ว",
    "gui.alerts.saving": "กำลังบันทึกโครงงาน...",
    "gui.alerts.cloudInfo": "โปรดทราบว่า ตัวแปรคลาวด์รอบรับเฉพาะตัวเลขเท่านั้น ใช้ตัวอักษรหรือเครื่องหมายไม่ได้ {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "เรียนรู้เพิ่มเติม",
    "gui.alerts.importing": "กำลังนำเข้า...",
    "gui.defaultProject.meow": "เหมียว",
    "gui.defaultProject.variable": "ตัวแปรของฉัน",
    "gui.howtos.intro-move-sayhello-hat.name": "เริ่มต้น",
    "gui.howtos.intro-move.step_stepMove": "เพิ่มบล็อกเคลื่อนไหว",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "ทำป้ายชื่อแบบแอนิเมชัน",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "เลือกสไปรต์ตัวอักษร",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "เล่นเสียงเมื่อคลิก",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "เลือกสไปรต์ตัวอักษรอื่นๆ",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "เปลี่ยนสี",
    "gui.howtos.animate-a-name.step_AnimateSpin": "เลือกสไปรต์ตัวอักษรอื่นๆ และทำให้มันหมุน",
    "gui.howtos.animate-a-name.step_AnimateGrow": "เลือกสไปรต์ตัวอักษรอื่นๆ และทำให้มันใหญ่ขึ้น",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "กดปุ่มสเปลซบาร์เพื่อเหิน",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "เหินไปสู่จุดหมาย",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "สร้างเสียงดนตรี",
    "gui.howtos.Make-Music.step_PickInstrument": "เลือกสไปรต์เครื่องดนตรี",
    "gui.howtos.Make-Music.step_PlaySoundClick": "เล่นเสียงเมื่อคลิก",
    "gui.howtos.Make-Music.step_MakeSong": "สร้างเสียงเพลง",
    "gui.howtos.make-music.step_MakeBeat": "เลือกกลองและสร้างจังหวะ",
    "gui.howtos.make-music.step_MakeBeatBox": "เลือกสไปรต์ไมโครโฟนและสร้างเซอร์ไพรส์บีตบ็อกซ์",
    "gui.howtos.story.name": "สร้างเนื้อเรื่อง",
    "gui.howtos.story.step_addbg": "เพิ่มฉากหลัง",
    "gui.howtos.story.step_addsprite": "เพิ่มตัวละคร",
    "gui.howtos.story.step_saysomething": "พูดอะไรสักอย่าง",
    "gui.howtos.story.step_addanothersprite": "เพิ่มตัวละครอีกตัว",
    "gui.howtos.story.step_flip": "พลิกทิศทาง",
    "gui.howtos.story.step_conversation": "เริ่มสนทนา",
    "gui.howtos.story.addanotherbg": "เพิ่มฉากหลังอีกฉาก",
    "gui.howtos.story.step_swithbg": "สลับฉากหลัง",
    "gui.howtos.story.step_hidewizard": "ซ่อนตัวละคร",
    "gui.howtos.story.step_showwizard": "แสดงตัวละคร",
    "gui.howtos.make-a-chase-game.name": "สร้างเกมไล่จับ",
    "gui.howtos.Chase-Game.step_BG": "เพิ่มฉากหลัง",
    "gui.howtos.chase-game.step_AddOcto": "เพิ่มสไปรต์",
    "gui.howtos.make-music.step_LeftRight": "ขยับซ้าย-ขวาด้วยปุ่มลูกศร",
    "gui.howtos.Chase-Game.step_UpDown": "ขยับขึ้น-ลงด้วยปุ่มลูกศร",
    "gui.howtos.Chase-Game.step_AddStar": "เพิ่มอีกสไปรต์",
    "gui.howtos.Chase-Game.step_MoveRandom": "เคลื่อนที่แบบสุ่ม",
    "gui.howtos.Chase-Game.step_WhenTouch": "ที่สไปรต์หมึกสาย เล่นเสียงเมื่อโดนแตะ",
    "gui.howtos.Chase-Game.step_ScoreVariable": "สร้างตัวแปรคะแนน",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "ที่สไปรต์หมึกสาย เพิ่มคะแนนเมื่อโดนแตะ",
    "gui.howtos.animate-char.name": "ทำแอนิเมชั่นให้ตัวละคร",
    "gui.howtos.animate-char.step_addbg": "เพิ่มฉากหลัง",
    "gui.howtos.animate-char.step_addsprite": "เพิ่มสไปรต์",
    "gui.howtos.animate-char.step_saysomething": "พูดอะไรสักอย่าง",
    "gui.howtos.animate-char.step_addsound": "เพิ่มเสียง",
    "gui.howtos.animate-char.step_animatetalking": "ทำให้การพูดเคลื่อนไหว",
    "gui.howtos.animate-char.step_arrowkeys": "เคลื่อนไหวโดยใช้ปุ่มลูกศร",
    "gui.howtos.animate-char.step_jump": "กระโดด",
    "gui.howtos.animate-char.step_changecolor": "เปลี่ยนสี",
    "gui.howtos.make-a-game.name": "สร้างเกมคลิกคลิก",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "เลือกสไปรต์",
    "gui.howtos.make-a-game.step_GamePlaySound": "เล่นเสียงเมื่อคลิก",
    "gui.howtos.make-a-game.step_GameAddScore": "สร้างตัวแปรคะแนน",
    "gui.howtos.make-a-game.step_GameChangeScore": "เมื่อคลิกเพิ่มคะแนน",
    "gui.howtos.make-a-game.step_Random": "ไปที่ตำแหน่งสุ่ม",
    "gui.howtos.make-music.step_GameChangeColor": "เปลี่ยนสี",
    "gui.howtos.make-music.step_ResetScore": "ตั้งค่าคะแนนให้เป็นศูนย์",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "พูดอะไรสักอย่าง",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "เพิ่มคะแนน",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "เก็บคะแนนไว้",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "เพิ่มฉากหลัง",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "เพิ่มคะแนน",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "ตั้งค่าคะแนนให้เป็นศูนย์",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "เหินไปรอบๆ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "ทำเกมผจญภัยแบบเคลื่อนไหว",
    "gui.howtos.cartoon-network.step_CNcharacter": "เลือกตัวละครออกไปแสดง",
    "gui.howtos.cartoon-network.step_CNsay": "พูดอะไรสักอย่าง",
    "gui.howtos.cartoon-network.step_CNglide": "เหินไปรอบๆ",
    "gui.howtos.cartoon-network.step_CNpicksprite": "เลือกสิ่งของให้ไล่จับ",
    "gui.howtos.cartoon-network.step_CNcollect": "เก็บรวบรวมสิ่งของ",
    "gui.howtos.cartoon-network.step_CNvariable": "สร้างตัวแปรคะแนน",
    "gui.howtos.cartoon-network.step_CNscore": "เก็บคะแนนไว้",
    "gui.howtos.cartoon-network.step_CNbackdrop": "เลเวลอัป : เปลี่ยนฉากหลัง",
    "gui.howtos.videosens.name": "การตรวจจับวิดีโอ",
    "gui.howtos.videosens.step_addextension": "เพิ่มส่วนขยาย",
    "gui.howtos.videosens.step_pet": "ลูบแมว",
    "gui.howtos.videosens.step_animate": "ทำให้เคลื่อนไหวได้",
    "gui.howtos.videosens.step_pop": "ทำลูกโป่งให้แตก",
    "gui.howtos.say-it-out-loud": "สร้างแอนิเมชั่นที่พูดได้",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "เพิ่มบล็อกข้อความเป็นเสียงพูด",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "พูดอะไรสักอย่าง",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "ตั้งค่าเสียงคน",
    "gui.howtos.say-it-out-loud.step_TXTMove": "เคลื่อนที่ไปรอบ ๆ",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "เพิ่มฉากหลัง",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "เพิ่มตัวละครอีกตัว",
    "gui.howtos.say-it-out-loud.step_TXTSong": "เล่นดนตรี",
    "gui.howtos.say-it-out-loud.step_TXTColor": "เปลี่ยนสี",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "หมุนไปรอบๆ",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "ขยายขึ้นและหดลง",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "เพิ่มสไปรต์",
    "gui.howtos.add-sprite.step_addSprite": "เพิ่มสไปรต์",
    "gui.howtos.add-a-backdrop.name": "เพิ่มฉากหลัง",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "เพิ่มฉากหลัง",
    "gui.howtos.change-size.name": "เปลี่ยนขนาด",
    "gui.howtos.change-size.step_changeSize": "เปลี่ยนขนาด",
    "gui.howtos.glide-around.name": "เหินไปรอบๆ",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "เหินไปรอบๆ",
    "gui.howtos.change-size.step_glideAroundPoint": "เหินไปสู่จุดหมาย",
    "gui.howtos.record-a-sound.name": "บันทึกเสียง",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "หมุนมัน",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "ซ่อนและแสดง",
    "gui.howtos.change-size.step_hideAndShow": "ซ่อนและแสดง",
    "gui.howtos.switch-costume.name": "ทำแอนิเมชันให้สไปรต์",
    "gui.howtos.change-size.step_switchCostumes": "ทำแอนิเมชันให้สไปรต์",
    "gui.howtos.move-around-with-arrow-keys.name": "ใช้ปุ่มลูกศร",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "ใส่เอฟเฟกต์",
    "gui.howtos.videosens.step_addEffects": "ใส่เอฟเฟกต์",
    "gui.extension.music.name": "ดนตรี",
    "gui.extension.music.description": "เล่นเครื่องดนตรีและกลอง",
    "gui.extension.pen.name": "ปากกา",
    "gui.extension.pen.description": "วาดด้วยสไปรต์ของคุณ",
    "gui.extension.videosensing.name": "การตรวจจับวิดีโอ",
    "gui.extension.videosensing.description": "ตรวจจับการเคลื่อนไหวด้วยกล้อง",
    "gui.extension.text2speech.name": "ข้อความเป็นเสียงพูด",
    "gui.extension.text2speech.description": "ทำให้โครงงานของคุณพูดได้",
    "gui.extension.translate.name": "แปลภาษา",
    "gui.extension.translate.description": "แปลข้อความเป็นหลายภาษา",
    "gui.extension.makeymakey.description": "ทำทุกอย่างให้เป็นกุญแจ",
    "gui.extension.microbit.description": "เชื่อมต่อโครงงานของคุณกับทั่วโลก",
    "gui.extension.microbit.connectingMessage": "กำลังเชื่อมต่อ",
    "gui.extension.ev3.description": "สร้างหุ่นยนต์โต้ตอบและอื่นๆ",
    "gui.extension.ev3.connectingMessage": "กำลังเชื่อมต่อ ตรวจสอบให้แน่ใจว่าขาของ EV3 ตั้งไว้ที่ 1234",
    "gui.extension.boost.description": "ทำสิ่งประดิษฐ์หุ่นยนต์ให้มีชีวิต",
    "gui.extension.boost.connectingMessage": "กำลังเชื่อมต่อ",
    "gui.extension.wedo2.description": "สร้างด้วยมอเตอร์และเซนเซอร์",
    "gui.extension.wedo2.connectingMessage": "กำลังเชื่อมต่อ",
    "gui.extension.gdxfor.description": "รับรู้การผลัก การดึง การเคลื่อนไหว และการหมุน",
    "gui.extension.gdxfor.connectingMessage": "กำลังเชื่อมต่อ",
    "gui.libraryTags.all": "ทั้งหมด",
    "gui.libraryTags.animals": "สัตว์",
    "gui.libraryTags.dance": "การเต้นรำ",
    "gui.libraryTags.effects": "เอฟเฟกต์",
    "gui.libraryTags.fantasy": "ความเพ้อฝัน",
    "gui.libraryTags.fashion": "แฟชั่น",
    "gui.libraryTags.food": "อาหาร",
    "gui.libraryTags.indoors": "ในบ้าน",
    "gui.libraryTags.loops": "ลูป",
    "gui.libraryTags.music": "ดนตรี",
    "gui.libraryTags.notes": "โน้ต",
    "gui.libraryTags.outdoors": "นอกบ้าน",
    "gui.libraryTags.patterns": "ลวดลาย",
    "gui.libraryTags.people": "ผู้คน",
    "gui.libraryTags.percussion": "เครื่องเคาะ",
    "gui.libraryTags.space": "อวกาศ",
    "gui.libraryTags.sports": "กีฬา",
    "gui.libraryTags.underwater": "ใต้น้ำ",
    "gui.libraryTags.voice": "เสียงคน",
    "gui.libraryTags.wacky": "ประหลาด",
    "gui.libraryTags.animation": "แอนิเมชัน",
    "gui.libraryTags.art": "ศิลปะ",
    "gui.libraryTags.games": "เกม",
    "gui.libraryTags.stories": "เรื่องราว",
    "gui.libraryTags.letters": "ตัวอักษร",
    "gui.opcodeLabels.direction": "ทิศทาง",
    "gui.opcodeLabels.xposition": "ตำแหน่ง x ",
    "gui.opcodeLabels.yposition": "ตำแหน่ง y",
    "gui.opcodeLabels.size": "ขนาด",
    "gui.opcodeLabels.costumename": "ชื่อคอสตูม",
    "gui.opcodeLabels.costumenumber": "หมายเลขคอสตูม",
    "gui.opcodeLabels.backdropname": "ชื่อฉากหลัง",
    "gui.opcodeLabels.backdropnumber": "หมายเลขฉากหลัง",
    "gui.opcodeLabels.volume": "ระดับเสียง",
    "gui.opcodeLabels.tempo": "จังหวะ",
    "gui.opcodeLabels.answer": "คำตอบ",
    "gui.opcodeLabels.loudness": "ระดับความดัง",
    "gui.opcodeLabels.username": "ชื่อผู้ใช้",
    "gui.opcodeLabels.year": "ปี",
    "gui.opcodeLabels.month": "เดือน",
    "gui.opcodeLabels.date": "วันที่",
    "gui.opcodeLabels.dayofweek": "วันของสัปดาห์",
    "gui.opcodeLabels.hour": "ชั่วโมง",
    "gui.opcodeLabels.minute": "นาที",
    "gui.opcodeLabels.second": "วินาที",
    "gui.opcodeLabels.timer": "ตัวจับเวลา",
    "gui.projectLoader.loadError": "ไฟล์โครงงานที่เลือกไม่สามารถโหลดได้",
    "gui.sharedMessages.backdrop": "ฉากหลัง{index}",
    "gui.sharedMessages.costume": "คอสตูม{index}",
    "gui.sharedMessages.sprite": "สไปรต์{index}",
    "gui.sharedMessages.pop": "ป๊อบ",
    "gui.sharedMessages.replaceProjectWarning": "แทนที่เนื้อหาของโครงงานปัจจุบันหรือไม่?",
    "gui.sharedMessages.loadFromComputerTitle": "อัปโหลดจากคอมพิวเตอร์ของคุณ",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "โครงงาน Scratch",
    "boost.color.any": "any color",
    "boost.color.black": "ดำ",
    "boost.color.blue": "น้ำเงิน",
    "boost.color.green": "เขียว",
    "boost.color.red": "แดง",
    "boost.color.white": "ขาว",
    "boost.color.yellow": "เหลือง",
    "boost.getMotorPosition": "ตำแหน่งมอเตอร์ [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "มุมเอียง [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ทางนั้น",
    "boost.motorDirection.forward": "ทางนี้",
    "boost.motorDirection.reverse": "ย้อนกลับ",
    "boost.motorOff": "ปิดมอเตอร์ [MOTOR_ID]",
    "boost.motorOn": "เปิดมอเตอร์ [MOTOR_ID]",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "ตั้งสีหลอดไฟเป็น [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "ทิศใดก็ได้",
    "boost.tiltDirection.down": "ลง",
    "boost.tiltDirection.left": "ซ้าย",
    "boost.tiltDirection.right": "ขวา",
    "boost.tiltDirection.up": "ขึ้น",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "เมื่อเอียง [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "เล่นโน้ต [NOTE] เป็นเวลา [TIME] วินาที",
    "ev3.buttonPressed": "ปุ่ม [PORT] ถูกกด?",
    "ev3.getBrightness": "ความสว่าง",
    "ev3.getDistance": "ระยะห่าง",
    "ev3.getMotorPosition": "ตำแหน่งมอเตอร์ [PORT]",
    "ev3.motorSetPower": "ตั้งค่ากำลังมอเตอร์ [PORT] เป็น [POWER] %",
    "ev3.motorTurnClockwise": "มอเตอร์ [PORT] หมุนทางนี้ เป็นเวลา [TIME] วินาที",
    "ev3.motorTurnCounterClockwise": "มอเตอร์ [PORT] หมุนทางนั้น เป็นเวลา [TIME] วินาที",
    "ev3.whenBrightnessLessThan": "เมื่อความสว่าง < [DISTANCE]",
    "ev3.whenButtonPressed": "เมื่อกดปุ่ม [PORT]",
    "ev3.whenDistanceLessThan": "เมื่อระยะห่าง < [DISTANCE]",
    "gdxfor.getAcceleration": "เร่ง [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "ตกไหม?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "เขย่า",
    "gdxfor.startedFalling": "เริ่มตกลงมา",
    "gdxfor.tiltDirectionMenu.any": "ทิศใดก็ได้",
    "gdxfor.tiltDirectionMenu.back": "หลัง",
    "gdxfor.tiltDirectionMenu.front": "หน้า",
    "gdxfor.tiltDirectionMenu.left": "ซ้าย",
    "gdxfor.tiltDirectionMenu.right": "ขวา",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "เมื่อ [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "ลูกศรลง",
    "makeymakey.downArrowShort": "ลง",
    "makeymakey.leftArrow": "ลูกศรซ้าย",
    "makeymakey.leftArrowShort": "ซ้าย",
    "makeymakey.rightArrow": "ลูกศรขวา",
    "makeymakey.rightArrowShort": "ขวา",
    "makeymakey.spaceKey": "สเปซบาร์",
    "makeymakey.upArrow": "ลูกศรขึ้น",
    "makeymakey.upArrowShort": "ขึ้น",
    "makeymakey.whenKeyPressed": "เมื่อคีย์ [KEY] ถูกกด",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "ทิศใดก็ได้",
    "microbit.clearDisplay": "ล้างหน้าจอ",
    "microbit.defaultTextToDisplay": "Sawasdee!",
    "microbit.displaySymbol": "แสดง [MATRIX]",
    "microbit.displayText": "แสดงข้อความ [TEXT]",
    "microbit.gesturesMenu.jumped": "กระโดด",
    "microbit.gesturesMenu.moved": "เคลื่อนไหว",
    "microbit.gesturesMenu.shaken": "เขย่า",
    "microbit.isButtonPressed": "ปุ่ม [BTN] ถูกกด?",
    "microbit.isTilted": "เอียง [DIRECTION]?",
    "microbit.pinStateMenu.off": "ปิด",
    "microbit.pinStateMenu.on": "เปิด",
    "microbit.tiltAngle": "มุมเอียง [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ทิศใดก็ได้",
    "microbit.tiltDirectionMenu.back": "หลัง",
    "microbit.tiltDirectionMenu.front": "หน้า",
    "microbit.tiltDirectionMenu.left": "ซ้าย",
    "microbit.tiltDirectionMenu.right": "ขวา",
    "microbit.whenButtonPressed": "เมื่อปุ่ม [BTN] ถูกกด",
    "microbit.whenGesture": "เมื่อ [GESTURE]",
    "microbit.whenPinConnected": "เมื่อขา [PIN] เชื่อมต่อแล้ว",
    "microbit.whenTilted": "เมื่อเอียง [DIRECTION]",
    "music.categoryName": "ดนตรี",
    "music.changeTempo": "เปลี่ยนความเร็วทีละ [TEMPO]",
    "music.drumBass": "(2) กลองใหญ่",
    "music.drumBongo": "(13) บองโก",
    "music.drumCabasa": "(15) คาบาซา",
    "music.drumClaves": "(9) เคลฟ",
    "music.drumClosedHiHat": "(6) ฉาบไฮแฮทปิด",
    "music.drumConga": "(14) คองกา",
    "music.drumCowbell": "(11) คาวเบล",
    "music.drumCrashCymbal": "(4) ฉาบ",
    "music.drumCuica": "(18) คุยกา",
    "music.drumGuiro": "(16) กวีโร",
    "music.drumHandClap": "(8) ตบมือ",
    "music.drumOpenHiHat": "(5) ฉาบไฮแฮทเปิด",
    "music.drumSideStick": "(3) ไซด์สติค",
    "music.drumSnare": "(1) กลองเล็ก",
    "music.drumTambourine": "(7) แทมบูรีน",
    "music.drumTriangle": "(12) กิ๋ง",
    "music.drumVibraslap": "(17) ไวบราสแลป",
    "music.drumWoodBlock": "(10) วูดบล็อก",
    "music.getTempo": "จังหวะ",
    "music.instrumentBass": "(6) เบส",
    "music.instrumentBassoon": "(14) บาสซูน",
    "music.instrumentCello": "(8) เชลโล",
    "music.instrumentChoir": "(15) เสียงประสาน",
    "music.instrumentClarinet": "(10) แคลริเน็ต",
    "music.instrumentElectricGuitar": "(5) กีต้าร์ไฟฟ้า ",
    "music.instrumentElectricPiano": "(2) เปียโนไฟฟ้า",
    "music.instrumentFlute": "(12) ฟลูต",
    "music.instrumentGuitar": "(4) กีตาร์",
    "music.instrumentMarimba": "(19) มาริมบา",
    "music.instrumentMusicBox": "(17) กล่องดนตรี ",
    "music.instrumentOrgan": "(3) ออร์แกน",
    "music.instrumentPiano": "(1) เปียโน",
    "music.instrumentPizzicato": "(7) พิซซิคาโต",
    "music.instrumentSaxophone": "(11) แซกโซโฟน",
    "music.instrumentSteelDrum": "(18) กลองเหล็ก",
    "music.instrumentSynthLead": "(20) ซินธ์ลีด",
    "music.instrumentSynthPad": "(21) ซินธ์แพด",
    "music.instrumentTrombone": "(9) ทรอมโบน",
    "music.instrumentVibraphone": "(16) ไวปราโฟน",
    "music.instrumentWoodenFlute": "(13) ฟลูตไม้",
    "music.midiPlayDrumForBeats": "เล่น [DRUM] [BEATS] จังหวะ",
    "music.midiSetInstrument": "ตั้งเครื่องดนตรีเป็น [INSTRUMENT]",
    "music.playDrumForBeats": "เล่น [DRUM] [BEATS] จังหวะ",
    "music.playNoteForBeats": "เล่นโน๊ต [NOTE] [BEATS] จังหวะ",
    "music.restForBeats": "หยุด [BEATS] จังหวะ",
    "music.setInstrument": "ตั้งเครื่องดนตรีเป็น [INSTRUMENT]",
    "music.setTempo": "ตั้งค่าความเร็วเป็น [TEMPO]จังหวะต่อนาที ",
    "pen.categoryName": "ปากกา",
    "pen.changeColorParam": "เปลี่ยน [COLOR_PARAM] ปากกาทีละ [VALUE]",
    "pen.changeHue": "เปลี่ยนสีปากกาทีละ [HUE]",
    "pen.changeShade": "เปลี่ยนเฉดสีปากกาทีละ [SHADE]",
    "pen.changeSize": "เปลี่ยนขนาดปากกาทีละ [SIZE]",
    "pen.clear": "ลบทั้งหมด",
    "pen.colorMenu.brightness": "ความสว่าง",
    "pen.colorMenu.color": "สี",
    "pen.colorMenu.saturation": "ความอิ่มตัวของสี",
    "pen.colorMenu.transparency": "ความโปร่งใส",
    "pen.penDown": "จรดปากกา",
    "pen.penUp": "ยกปากกาขึ้น",
    "pen.setColor": "ตั้งค่าสีปากกาเป็น [COLOR]",
    "pen.setColorParam": "ตั้งค่า [COLOR_PARAM] ปากกาเป็น[VALUE]",
    "pen.setHue": "ตั้งสีปากกาเป็น [HUE]",
    "pen.setShade": "ตั้งค่าเฉดสีเป็น [SHADE]",
    "pen.setSize": "ตั้งขนาดปากกาเป็น [SIZE]",
    "pen.stamp": "ประทับ",
    "speech.defaultWhenIHearValue": "เริ่มเลย!",
    "speech.extensionName": "เสียงพูดเป็นข้อความ",
    "speech.listenAndWait": "ฟังและรอ",
    "speech.speechReporter": "เสียงพูด",
    "speech.whenIHear": "เมื่อฉันได้ยิน [PHRASE]",
    "text2speech.alto": "อัลโต",
    "text2speech.categoryName": "ข้อความเป็นเสียงพูด",
    "text2speech.defaultTextToSpeak": "สวัสดี",
    "text2speech.giant": "ไจแอนท์",
    "text2speech.kitten": "ลูกแมว",
    "text2speech.setLanguageBlock": "ตั้งภาษาเป็น [LANGUAGE]",
    "text2speech.setVoiceBlock": "ตั้งเสียงเป็น  [VOICE]",
    "text2speech.speakAndWaitBlock": "พูด [WORDS]",
    "text2speech.squeak": "เอี๊ยด ๆ",
    "text2speech.tenor": "เทเนอร์",
    "translate.categoryName": "แปลภาษา",
    "translate.defaultTextToTranslate": "สวัสดี",
    "translate.translateBlock": "แปล [WORDS] เป็น [LANGUAGE]",
    "translate.viewerLanguage": "ภาษา",
    "videoSensing.categoryName": "การตรวจจับวิดีโอ",
    "videoSensing.direction": "ทิศทาง",
    "videoSensing.motion": "การเคลื่อนไหว",
    "videoSensing.off": "ปิด",
    "videoSensing.on": "เปิด",
    "videoSensing.onFlipped": "พลิก",
    "videoSensing.setVideoTransparency": "ตั้งค่าความโปร่งใสของวิดีโอเป็น [TRANSPARENCY]",
    "videoSensing.sprite": "สไปรต์",
    "videoSensing.stage": "เวที",
    "videoSensing.videoOn": "[ATTRIBUTE] วิดีโอ บน [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] วิดีโอ",
    "videoSensing.whenMotionGreaterThan": "เมื่อวิดีโอเคลื่อนไหว > [REFERENCE]",
    "wedo2.getDistance": "ระยะทาง",
    "wedo2.getTiltAngle": "มุมเอียง [TILT_DIRECTION]",
    "wedo2.isTilted": "เอียง [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ทางนั้น",
    "wedo2.motorDirection.forward": "ทางนี้",
    "wedo2.motorDirection.reverse": "ย้อนกลับ",
    "wedo2.motorId.a": "มอเตอร์ A",
    "wedo2.motorId.all": "มอเตอร์ทั้งหมด",
    "wedo2.motorId.b": "มอเตอร์ B",
    "wedo2.motorId.default": "มอเตอร์",
    "wedo2.motorOff": "ปิดมอเตอร์[MOTOR_ID] ",
    "wedo2.motorOn": "เปิดมอเตอร์ [MOTOR_ID]",
    "wedo2.motorOnFor": "เปิดมอเตอร์ [MOTOR_ID] เป็นเวลา [DURATION] วินาที",
    "wedo2.playNoteFor": "เล่นโน้ต [NOTE] เป็นเวลา [DURATION] วินาที",
    "wedo2.setLightHue": "ตั้งสีหลอดไฟเป็น [HUE]",
    "wedo2.setMotorDirection": "ตั้งทิศทางมอเตอร์ [MOTOR_ID] เป็น [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "ตั้งค่ากำลังมอเตอร์ [MOTOR_ID] เป็น [POWER]",
    "wedo2.tiltDirection.any": "ทิศใดก็ได้",
    "wedo2.tiltDirection.down": "ลง",
    "wedo2.tiltDirection.left": "ซ้าย",
    "wedo2.tiltDirection.right": "ขวา",
    "wedo2.tiltDirection.up": "ขึ้น",
    "wedo2.whenDistance": "เมื่อระยะห่าง [OP] [REFERENCE]",
    "wedo2.whenTilted": "เมื่อเอียง [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "สี",
    "paint.paintEditor.saturation": "ความอิ่มตัว",
    "paint.paintEditor.brightness": "ความสว่าง",
    "paint.paintEditor.costume": "คอสตูม",
    "paint.paintEditor.group": "กลุ่ม",
    "paint.paintEditor.ungroup": "แยกกลุ่ม",
    "paint.paintEditor.undo": "ย้อนกลับ",
    "paint.paintEditor.redo": "ทำซ้ำ",
    "paint.paintEditor.forward": "มาข้างหน้า",
    "paint.paintEditor.backward": "ไปข้างหลัง",
    "paint.paintEditor.front": "หน้าสุด",
    "paint.paintEditor.back": "หลังสุด",
    "paint.paintEditor.more": "เพิ่มเติม",
    "paint.modeTools.brushSize": "ขนาด",
    "paint.modeTools.eraserSize": "ขนาดยางลบ",
    "paint.modeTools.copy": "คัดลอก",
    "paint.modeTools.paste": "วาง",
    "paint.modeTools.delete": "ลบ",
    "paint.modeTools.curved": "โค้ง",
    "paint.modeTools.pointed": "แหลม",
    "paint.modeTools.thickness": "ความหนา",
    "paint.modeTools.flipHorizontal": "พลิกแนวนอน",
    "paint.modeTools.flipVertical": "พลิกแนวตั้ง",
    "paint.modeTools.filled": "เติมสี",
    "paint.modeTools.outlined": "สีขอบ",
    "paint.paintEditor.bitmap": "แปลงเป็นบิตแมป",
    "paint.paintEditor.vector": "แปลงเป็นเวกเตอร์",
    "paint.paintEditor.fill": "สีพื้น",
    "paint.paintEditor.stroke": "สีขอบ",
    "paint.brushMode.brush": "แปรง",
    "paint.eraserMode.eraser": "ยางลบ",
    "paint.fillMode.fill": "สีพื้น",
    "paint.lineMode.line": "เส้น",
    "paint.ovalMode.oval": "วงกลม",
    "paint.rectMode.rect": "สี่เหลี่ยม",
    "paint.reshapeMode.reshape": "จัดรูปร่างใหม่",
    "paint.roundedRectMode.roundedRect": "สี่เหลี่ยมขอบมน",
    "paint.selectMode.select": "เลือก",
    "paint.textMode.text": "ข้อความ",
    "paint.colorPicker.swap": "สลับสี"
  },
  "km": {
    "gui.alerts.lostPeripheralConnection": "កម្មវិធី​ Scratch បានដាច់ទំនាក់ទំនងនឹង{extensionName}ហើយ។",
    "gui.alerts.tryAgain": "ព្យាយាមម្តងទៀត",
    "gui.alerts.download": "ទាញយក",
    "gui.connection.reconnect": "ភ្ជាប់ម្តងទៀត",
    "gui.backpack.costumeLabel": "រូបរាង",
    "gui.backpack.soundLabel": "សម្លេង",
    "gui.backpack.scriptLabel": "ស្រ្គីប",
    "gui.backpack.spriteLabel": "តួអង្គ",
    "gui.backpack.header": "កាបូបស្ពាយ",
    "gui.backpack.errorBackpack": "មានបញ្ហាពេលដំណើរការកាបូបស្ពាយ",
    "gui.backpack.loadingBackpack": "កំពុងដំណើរការ...",
    "gui.backpack.more": "ច្រើនទៀត",
    "gui.backpack.emptyBackpack": "កាបូបស្ពាយទទេ",
    "gui.unsupportedBrowser.label": "កម្មវិធីរុករកមិនអាចប្រើបាន",
    "gui.unsupportedBrowser.errorLabel": "មានបញ្ហាមួយបានកើតឡើង",
    "gui.unsupportedBrowser.notRecommended": "ជំនាន់នៃកម្មវិធីរុករកដែលអ្នកកំពុងប្រើមិនអាចប្រើជាមួយ Scratch បានទេ។ សូមប្រើកម្មវិធីរុករកជំនាន់ចុងក្រោយដូចជា Google Chrome, Mozilla Firefox, Microsoft Edge, ឬ Apple Safari ។",
    "gui.unsupportedBrowser.description": "កម្មវិធីរុករកដែលអ្នកកំពុងប្រើមិនអាចប្រើជាមួយ Scratch បានទេ។ សូមប្រើកម្មវិធីរុករកជំនាន់ចុងក្រោយដូចជា Google Chrome, Mozilla Firefox, Microsoft Edge, ឬ Apple Safari ។",
    "gui.unsupportedBrowser.back": "ត្រឡប់",
    "gui.unsupportedBrowser.previewfaq": "ដើម្បីដឹងបន្ថែម សូមទៅកាន់{previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "សំណួរពេញនិយម",
    "gui.cards.all-tutorials": "ការបង្ហាញ",
    "gui.cards.shrink": "បង្រួម",
    "gui.cards.expand": "ពង្រីក",
    "gui.cards.close": "បិទ",
    "gui.cards.more-things-to-try": "របស់ច្រើនទៀតសម្រាប់សាក!",
    "gui.cards.see-more": "មើលច្រើនទៀត",
    "gui.comingSoon.message1": "កុំបារម្ភ! ពួកយើងកំពុងតែធ្វើការលើហ្នឹងហើយ {emoji}",
    "gui.comingSoon.message2": "មកដល់ឆាប់ៗ...",
    "gui.comingSoon.message3": "ពួកយើងកំពុងតែធ្វើការលើហ្នឹងហើយ {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "រកមិនឃើញឧបករណ៍ទេ",
    "gui.connection.auto-scanning.prescan": "ដាក់ឧបករណ៍នៅជិតៗនេះ រួចចាប់ផ្តើមស្វែងរក",
    "gui.connection.auto-scanning.pressbutton": "ចុចប៊ូតុងលើឧបករណ៍របស់អ្នក",
    "gui.connection.auto-scanning.start-search": "ចាប់ផ្តើមស្វែងរក",
    "gui.connection.connecting-searchbutton": "កំពុងស្វែងរក...",
    "gui.connection.auto-scanning.try-again": "សាកម្តងទៀត",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "បានភ្ជាប់",
    "gui.connection.disconnect": "ផ្តាច់",
    "gui.connection.go-to-editor": "ទៅកាន់កម្មវិធីសរសេរ",
    "gui.connection.connecting-cancelbutton": "កំពុងភ្ជាប់...",
    "gui.connection.error.errorMessage": "អុញនុះ! ដូចជាមានអីខុស!",
    "gui.connection.error.tryagainbutton": "សាកម្តងទៀត",
    "gui.connection.error.helpbutton": "ជំនួយ",
    "gui.connection.peripheral-name-label": "ឈ្មោះឧបករណ៍",
    "gui.connection.connect": "ភ្ជាប់",
    "gui.connection.scanning.lookingforperipherals": "កំពុងរកមើលឧបករណ៍",
    "gui.connection.scanning.noPeripheralsFound": "រកមិនឃើញឧបករណ៍ទេ",
    "gui.connection.scanning.instructions": "ជ្រើសរើសឧបករណ៍របស់អ្នកពីក្នុងបញ្ជីខាងលើ",
    "gui.connection.search": "ធ្វើជាថ្មី",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "សូមឲ្យប្រាកដថាអ្នកបានដំឡើង Scratch Link ហើយវាកំពុងដំណើរការ",
    "gui.connection.unavailable.enablebluetooth": "ពិនិត្យថា Bluetooth ត្រូវបានបើក",
    "gui.connection.unavailable.tryagainbutton": "សាកម្តងទៀត",
    "gui.connection.unavailable.helpbutton": "ជំនួយ",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "ទៅ",
    "gui.controls.stop": "ឈប់",
    "gui.crashMessage.label": "អុញនុះ! មានអីខុសហើយ!",
    "gui.crashMessage.description": "សុំទោសផង Scratch បានឈប់ដំណើរការហើយ! បញ្ហានេះត្រូវបានរាយការណ៍ទៅកាន់ក្រុម Scratch ហើយ។ សូមដំណើរការទំព័រជាថ្មី ដើម្បីសាកល្បងម្តងទៀត ។",
    "gui.crashMessage.errorNumber": "បញ្ហានេះត្រូវបានកត់ត្រាទុកដោយលេខសម្គាល់ {errorId}",
    "gui.crashMessage.reload": "ដំណើរការជាថ្មី",
    "gui.customProcedures.myblockModalTitle": "បង្កើតប្លុកមួយ",
    "gui.customProcedures.addAnInputNumberText": "បញ្ចូលតម្លៃ",
    "gui.customProcedures.numberTextType": "លេខ ឬអត្ថបទ",
    "gui.customProcedures.addAnInputBoolean": "បញ្ចូលតម្លៃ",
    "gui.customProcedures.booleanType": "ប៊ូលីន",
    "gui.customProcedures.addALabel": "បន្ថែមស្លាក",
    "gui.customProcedures.runWithoutScreenRefresh": "ដំណើរការដោយមិនបាច់លោតទំព័រជាថ្មី",
    "gui.customProcedures.cancel": "បោះបង់",
    "gui.customProcedures.ok": "យល់ព្រម",
    "gui.SpriteInfo.direction": "ទិសដៅ",
    "gui.directionPicker.rotationStyles.allAround": "ពេញមួយជុំ",
    "gui.directionPicker.rotationStyles.leftRight": "ឆ្វេង/ស្តាំ",
    "gui.directionPicker.rotationStyles.dontRotate": "កុំបង្វិល",
    "gui.gui.addExtension": "បន្ថែមកម្មវិធីបន្ថែម",
    "gui.gui.codeTab": "កូដ",
    "gui.gui.backdropsTab": "ផ្ទាំងខាងក្រោយ",
    "gui.gui.costumesTab": "រូបរាង",
    "gui.gui.soundsTab": "សម្លេង",
    "gui.extensionLibrary.comingSoon": "ជិតមកដល់ហើយ",
    "gui.extensionLibrary.requires": "ទាមទារ",
    "gui.extensionLibrary.collaboration": "ការសហការជាមួយ",
    "gui.library.filterPlaceholder": "ស្វែងរក",
    "gui.library.allTag": "ទាំងអស់",
    "gui.loader.message1": "កំពុងបង្កើតប្លុក...",
    "gui.loader.message2": "កំពុងដំណើរការតួអង្គ...",
    "gui.loader.message3": "កំពុងដំណើរការសម្លេង...",
    "gui.loader.message4": "កំពុងដំណើរការកម្មវិធីបន្ថែម...",
    "gui.loader.message5": "កំពុងដេញចាប់ឆ្មា...",
    "gui.loader.message6": "ចាំមួយភ្លែតទៅ...",
    "gui.loader.message7": "សុំចាក់សាំងសិន...",
    "gui.loader.message8": "កំពុងរៀបចំសញ្ញាអារម្មណ៍",
    "gui.loader.headline": "កំពុងដំណើរការកិច្ចការ",
    "gui.loader.creating": "កំពុងបង្កើតកិច្ចការ",
    "gui.accountMenu.profile": "ប្រវត្តិរូប",
    "gui.accountMenu.myStuff": "កិច្ចការខ្ញុំ",
    "gui.accountMenu.myClasses": "ថ្នាក់ខ្ញុំ",
    "gui.accountMenu.myClass": "ថ្នាក់ខ្ញុំ",
    "gui.accountMenu.accountSettings": "ការកំណត់គណនី",
    "gui.accountMenu.signOut": "ចាកចេញ",
    "gui.authorInfo.byUser": "ដោយ​ {username}",
    "gui.menuBar.seeProjectPage": "មើលទំព័រកិច្ចការ",
    "gui.menuBar.language": "Language",
    "general.username": "ឈ្មោះគណនី",
    "general.password": "ពាក្យសម្ងាត់",
    "general.signIn": "ចូល",
    "login.needHelp": "ត្រូវការជំនួយទេ?",
    "form.validationRequired": "ប្រអប់ទិន្នន័យនេះចាំបាច់ត្រូវបំពេញ",
    "gui.menuBar.tutorialsLibrary": "ការបង្រៀន",
    "gui.menuBar.restoreSprite": "ទាញយកតួអង្គមកវិញ",
    "gui.menuBar.restoreSound": "ទាញយកសម្លេងមកវិញ",
    "gui.menuBar.restoreCostume": "ទាញយករូបរាងមកវិញ",
    "gui.menuBar.restore": "ស្តារមកវិញ",
    "gui.menuBar.saveNow": "រក្សាទុកឥឡូវ",
    "gui.menuBar.saveAsCopy": "រក្សាទុកជាច្បាប់ថ្មី",
    "gui.menuBar.remix": "កែបន្ថែម",
    "gui.menuBar.new": "ថ្មី",
    "gui.menuBar.file": "ឯកសារ",
    "gui.menuBar.downloadToComputer": "រក្សាទុកក្នុងកុំព្យូទ័រ",
    "gui.menuBar.edit": "កែសម្រួល",
    "gui.menuBar.turboModeOff": "បិទម៉ូត Turbo",
    "gui.menuBar.turboModeOn": "បើកម៉ូត Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "បង្កើតគណនី Scratch",
    "gui.menuBar.signIn": "ចូល",
    "gui.gui.projectTitlePlaceholder": "ដាក់ចំណងជើងកិច្ចការទីនេះ",
    "gui.menuBar.saveNowLink": "រក្សាទុកឥឡូវ",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "កិច្ចការបានចែករំលែក",
    "gui.menuBar.share": "ចែករំលែក",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "ជំនួយ",
    "gui.modal.back": "ក្រោយ",
    "gui.monitor.listMonitor.empty": "(ទទេ)",
    "gui.monitor.listMonitor.listLength": "ប្រវែង{length}",
    "gui.monitor.contextMenu.default": "អេក្រង់ធម្មតា",
    "gui.monitor.contextMenu.large": "អេក្រង់ធំ",
    "gui.monitor.contextMenu.slider": "រំកិល",
    "gui.monitor.contextMenu.sliderRange": "ប្តូរដែនរំកិល",
    "gui.monitor.contextMenu.import": "នាំចូល",
    "gui.monitor.contextMenu.export": "នាំចេញ",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "លេង",
    "gui.playButton.stop": "ឈប់",
    "gui.gui.variableScopeOptionAllSprites": "សម្រាប់តួអង្គទាំងអស់",
    "gui.gui.variableScopeOptionSpriteOnly": "សម្រាប់តែតួអង្គនេះប៉ុណ្ណោះ",
    "gui.gui.cloudVariableOption": "អថេរលើបណ្តាញ (ផ្ទុកក្នុងម៉ាស៊ីនបម្រើ)",
    "gui.gui.variablePromptAllSpritesMessage": "អថេរនេះនឹងអាចប្រើបានជាមួយនឹងតួអង្គទាំងអស់",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "បោះបង់",
    "gui.prompt.ok": "យល់ព្រម",
    "gui.playbackStep.stopMsg": "ឈប់",
    "gui.playbackStep.playMsg": "លេង",
    "gui.playbackStep.loadingMsg": "កំពុងដំណើរការ...",
    "gui.playbackStep.saveMsg": "រក្សាទុក",
    "gui.playbackStep.reRecordMsg": "ថតម្តងទៀត",
    "gui.recordModal.title": "ថតសម្លេង",
    "gui.recordingStep.beginRecord": "ចាប់ផ្តើមថតដោយចុចប៊ូតុងខាងក្រោម",
    "gui.recordingStep.permission": "{arrow}យើងត្រូវការការអនុញ្ញាតពីអ្នកដើម្បីអាចប្រើម៉ៃក្រូហ្វូនបាន",
    "gui.recordingStep.stop": "ឈប់ថត",
    "gui.recordingStep.record": "ថត",
    "gui.sliderModal.min": "តម្លៃអប្បបរមា",
    "gui.sliderModal.max": "តម្លៃអតិបរមា",
    "gui.sliderModal.title": "ប្តូរដែនរំកិល",
    "gui.sliderPrompt.cancel": "បោះបង់",
    "gui.sliderPrompt.ok": "យល់ព្រម",
    "gui.soundEditor.sound": "សម្លេង",
    "gui.soundEditor.play": "លេង",
    "gui.soundEditor.stop": "ឈប់",
    "gui.soundEditor.copy": "ចម្លង",
    "gui.soundEditor.paste": "ភ្ជាប់",
    "gui.soundEditor.copyToNew": "ចម្លងជាថ្មី",
    "gui.soundEditor.delete": "លុប",
    "gui.soundEditor.save": "រក្សាទុក",
    "gui.soundEditor.undo": "មិនធ្វើវិញ",
    "gui.soundEditor.redo": "ធ្វើឡើងវិញ",
    "gui.soundEditor.faster": "លឿនជាងមុន",
    "gui.soundEditor.slower": "យឺតជាងមុន",
    "gui.soundEditor.echo": "សម្លេងឡង",
    "gui.soundEditor.robot": "រ៉ូបូ",
    "gui.soundEditor.louder": "លឺជាងមុន",
    "gui.soundEditor.softer": "ខ្សោយជាងមុន",
    "gui.soundEditor.reverse": "បញ្ច្រាស់",
    "gui.soundEditor.fadeOut": "ថយម្តងបន្តិច",
    "gui.soundEditor.fadeIn": "កើនម្តងបន្តិច",
    "gui.soundEditor.mute": "បិទសម្លេង",
    "gui.SpriteInfo.spritePlaceholder": "ឈ្មោះ",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "តួអង្គ",
    "gui.SpriteInfo.show": "បង្ហាញ",
    "gui.SpriteInfo.size": "ទំហំ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "ចម្លង",
    "gui.spriteSelectorItem.contextMenuExport": "នាំចេញ",
    "gui.spriteSelectorItem.contextMenuDelete": "លុប",
    "gui.spriteSelector.addSpriteFromLibrary": "ជ្រើសតួអង្គ",
    "gui.spriteSelector.addSpriteFromPaint": "កម្មវិធីគូរ",
    "gui.spriteSelector.addSpriteFromSurprise": "ចៃដន្យ",
    "gui.spriteSelector.addSpriteFromFile": "ផ្ទុកពីកុំព្យូទ័រ",
    "gui.stageHeader.stageSizeLarge": "ប្តូរទៅឆាកធំ",
    "gui.stageHeader.stageSizeSmall": "ប្តូរទៅឆាកតូច",
    "gui.stageHeader.stageSizeFull": "ចូលទៅកាន់ម៉ូតអេក្រង់ពេញ",
    "gui.stageHeader.stageSizeUnFull": "ចេញពីម៉ូតអេក្រង់ពេញ",
    "gui.stageHeader.fullscreenControl": "ប៊ូតុងចេញចូលម៉ូតអេក្រង់ពេញ",
    "gui.spriteSelector.addBackdropFromLibrary": "ជ្រើសផ្ទាំងខាងក្រោយ",
    "gui.stageSelector.addBackdropFromPaint": "កម្មវិធីគូរ",
    "gui.stageSelector.addBackdropFromSurprise": "ចៃដន្យ",
    "gui.stageSelector.addBackdropFromFile": "ផ្ទុកពីកុំព្យូទ័រ",
    "gui.stageSelector.stage": "ឆាក",
    "gui.stageSelector.backdrops": "ផ្ទាំងខាងក្រោយ",
    "gui.telemetryOptIn.label": "រាយការណ៍ពីស្ថិតិដើម្បីធ្វើឲ្យ Scratch កាន់តែប្រសើរ",
    "gui.telemetryOptIn.body1": "ក្រុម Scratch តែងតែស្វែងយល់ឲ្យកាន់តែច្បាស់អំពីរបៀបដែល Scratch ត្រូវបានប្រើប្រាស់នៅជុំវិញពិភពលោក។ ដើម្បីជួយដល់កិច្ចខិតខំប្រឹងប្រែងនេះ អ្នកអាចអនុញ្ញាតឱ្យកម្មវិធី Scratch ផ្ញើព័ត៌មានប្រើប្រាស់ទៅក្រុម Scratch ដោយស្វ័យប្រវត្តិ។",
    "gui.telemetryOptIn.body2": "ព័ត៌មានដែលយើងប្រមូលរួមមានការជ្រើសរើសភាសា ការប្រើប្រាស់ប្លុក និងព្រឹត្តិការណ៍មួយចំនួនដូចជាការរក្សាទុក ការបើកកិច្ចការ និងការផ្ទុកកិច្ចការឡើង។ យើងមិនប្រមូលព័ត៌មានផ្ទាល់ខ្លួនទេ។ សូមមើល {privacyPolicyLink} របស់យើង សម្រាប់ព័ត៌មានបន្ថែម។",
    "gui.telemetryOptIn.privacyPolicyLink": "គោលការណ៍ឯកជនភាព",
    "gui.telemetryOptIn.optInText": "ចែករំលែកទិន្នន័យពីការប្រើប្រាស់របស់ខ្ញុំជាមួយនឹង Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "បើកការប្រមូលទិន្នន័យ",
    "gui.telemetryOptIn.optOutText": "កុំចែករំលែកទិន្នន័យពីការប្រើប្រាស់របស់ខ្ញុំជាមួយនឹង Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "បិទការប្រមូលទិន្នន័យ",
    "gui.telemetryOptIn.settingWasUpdated": "ការកំណត់របស់អ្នកត្រូវបានកែប្រែ និងរក្សាទុក។",
    "gui.telemetryOptIn.buttonClose": "បិទ",
    "gui.turboMode.active": "ម៉ូត Turbo",
    "gui.webglModal.label": "កម្មវិធីរុករកមិនអាចប្រើ WebGL បានទេ",
    "gui.webglModal.description": "កម្មវិធីរុករក ឬកុំព្យូទ័ររបស់អ្នក {webGlLink}។  Scratch 3.0 ត្រូវការបច្ចេកវិទ្យានេះទើបអាចដំណើរការបាន។",
    "gui.webglModal.webgllink": "មិនអាចប្រើ WebGL ទេ",
    "gui.webglModal.back": "ទៅក្រោយ",
    "gui.webglModal.previewfaq": "ដើម្បីយល់ដឹងបន្ថែម សូមចូលទៅកាន់{previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "សំណួរពេញនិយម",
    "gui.costumeLibrary.chooseABackdrop": "ជ្រើសផ្ទាំងខាងក្រោយ",
    "gui.costumeLibrary.chooseACostume": "ជ្រើសរើសរូបរាង",
    "gui.costumeTab.addBackdropFromLibrary": "ជ្រើសផ្ទាំងខាងក្រោយ",
    "gui.costumeTab.addCostumeFromLibrary": "ជ្រើសរើសរូបរាង",
    "gui.costumeTab.addBlankCostume": "កម្មវិធីគូរ",
    "gui.costumeTab.addSurpriseCostume": "ចៃដន្យ",
    "gui.costumeTab.addFileBackdrop": "ផ្ទុកពីកុំព្យូទ័រ",
    "gui.costumeTab.addFileCostume": "ផ្ទុកពីកុំព្យូទ័រ",
    "gui.extensionLibrary.chooseAnExtension": "ជ្រើសរើសកម្មវិធីបន្ថែម",
    "gui.extensionLibrary.extensionUrl": "បញ្ចូលតំណ URL នៃកម្មវិធីបន្ថែម",
    "gui.monitors.importListColumnPrompt": "តើគួរប្រើជួរមួយណា (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "មិនអាចចាប់ផ្តើមថតទេ",
    "gui.soundLibrary.chooseASound": "ជ្រើសរើសសម្លេង",
    "gui.soundTab.fileUploadSound": "ផ្ទុកពីកុំព្យូទ័រ",
    "gui.soundTab.surpriseSound": "ចៃដន្យ",
    "gui.soundTab.recordSound": "ថត",
    "gui.soundTab.addSoundFromLibrary": "ជ្រើសរើសសម្លេង",
    "gui.spriteLibrary.chooseASprite": "ជ្រើសតួអង្គ",
    "gui.tipsLibrary.tutorials": "ជ្រើសរើសការបង្ហាញ",
    "gui.alerts.createsuccess": "បានបង្កើតកិច្ចការថ្មីមួយ",
    "gui.alerts.createcopysuccess": "កិច្ចការត្រូវបានរក្សាទុកជាកិច្ចការថ្មី",
    "gui.alerts.createremixsuccess": "បានចម្លងកិច្ចការសម្រាប់កែបន្ថែម",
    "gui.alerts.creating": "កំពុងបង្កើតថ្មី...",
    "gui.alerts.creatingCopy": "កំពុងចម្លងកិច្ចការ...",
    "gui.alerts.creatingRemix": "កំពុងចម្លងកិច្ចការសម្រាប់កែបន្ថែម...",
    "gui.alerts.creatingError": "មិនអាចបង្កើតកិច្ចការទេ! សូមសាកម្តងទៀត!",
    "gui.alerts.savingError": "រក្សាទុកកិច្ចការមិនបានទេ",
    "gui.alerts.savesuccess": "បានរក្សាទុកកិច្ចការ",
    "gui.alerts.saving": "កំពុងរក្សាកិច្ចការទុក...",
    "gui.alerts.cloudInfo": "សូមចាំថាអថេរលើបណ្តាញអាចតែជាលេខប៉ុណ្ណោះ មិនអាចជាអក្សរ ឬសញ្ញាទេ។ {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "ស្វែងយល់បន្ថែម",
    "gui.alerts.importing": "កំពុងនាំចូល...",
    "gui.defaultProject.meow": "ម៉ែវ",
    "gui.defaultProject.variable": "អថេរខ្ញុំ",
    "gui.howtos.intro-move-sayhello-hat.name": "ចាប់ផ្តើម",
    "gui.howtos.intro-move.step_stepMove": "បន្ថែមប្លុកផ្លាស់ទី",
    "gui.howtos.add-a-move-block.step_stepSay": "បន្ថែមប្លុកនិយាយ",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "ចុចទង់បៃតងដើម្បីចាប់ផ្តើម",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "ធ្វើឈ្មោះមានចលនា",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "ជ្រើសតួអង្គជាអក្សរ",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "លេងសម្លេងពេលចុច",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "ជ្រើសតួអង្គជាអក្សរមួយទៀត",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "ប្តូរពណ៌",
    "gui.howtos.animate-a-name.step_AnimateSpin": "ជ្រើសតួអង្គជាអក្សរមួយទៀត រួចធ្វើឲ្យវាវិល",
    "gui.howtos.animate-a-name.step_AnimateGrow": "ជ្រើសតួអង្គជាអក្សរមួយទៀត រួចធ្វើឲ្យវារីកធំ",
    "gui.howtos.imagine": "ស្រមៃពីពិភពមួយ",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "វាយនូវអ្វីដែលអ្នកចង់និយាយ ",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "ចុចទង់បៃតងដើម្បីចាប់ផ្តើម",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយណាមួយ",
    "gui.howtos.imagine.step_imagineChooseSprite": "ជ្រើសតួអង្គណាមួយ",
    "gui.howtos.imagine.step_imagineFlyAround": "ចុចច្នុចដកឃ្លាដើម្បីរអិល",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "ជ្រើសតួអង្គមួយទៀត",
    "gui.howtos.imagine.step_imagineLeftRight": "ផ្លាស់ទីឆ្វេងស្ដាំ",
    "gui.howtos.imagine.step_imagineUpDown": "ផ្លាស់ទីឡើងចុះ",
    "gui.howtos.imagine.step_imagineChangeCostumes": "ប្ដូររូបរាង",
    "gui.howtos.imagine.step_imagineGlideToPoint": "រអិលទៅចំនុចមួយ",
    "gui.howtos.imagine.step_imagineGrowShrink": "រីក និងរួម",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយមួយទៀត",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "ប្តូរផ្ទាំងខាងក្រោយ",
    "gui.howtos.imagine.step_imagineRecordASound": "បន្ថែមសម្លេងមួយ",
    "gui.howtos.imagine.step_imagineChooseSound": "ជ្រើសរើសសម្លេងរបស់អ្នក",
    "gui.howtos.make-music.name": "បង្កើតតន្រ្តី",
    "gui.howtos.Make-Music.step_PickInstrument": "ជ្រើសតួអង្គជាឧបករណ៍តន្រ្តី",
    "gui.howtos.Make-Music.step_PlaySoundClick": "លេងសម្លេងពេលចុច",
    "gui.howtos.Make-Music.step_MakeSong": "បង្កើតចម្រៀងមួយ",
    "gui.howtos.make-music.step_MakeBeat": "ជ្រើសរូបស្គរមួយ ហើយបង្កើតជាសម្លេងបុក",
    "gui.howtos.make-music.step_MakeBeatBox": "ជ្រើសតួអង្គជារូបម៉ៃក្រូហ្វូន ហើយដាក់សម្លេងចៃដន្យ",
    "gui.howtos.story.name": "បង្កើតរឿងមួយ",
    "gui.howtos.story.step_addbg": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.story.step_addsprite": "បន្ថែមតួអង្គមួយ",
    "gui.howtos.story.step_saysomething": "និយាយអ្វីមួយ",
    "gui.howtos.story.step_addanothersprite": "បន្ថែមតួអង្គមួយទៀត",
    "gui.howtos.story.step_flip": "ត្រឡប់ទិសដៅ",
    "gui.howtos.story.step_conversation": "ធ្វើការសន្ទនា",
    "gui.howtos.story.addanotherbg": "បន្ថែមផ្ទាំងខាងក្រោយមួយទៀត",
    "gui.howtos.story.step_swithbg": "ប្តូរផ្ទាំងខាងក្រោយ",
    "gui.howtos.story.step_hidewizard": "លាក់តួអង្គមួយ",
    "gui.howtos.story.step_showwizard": "បង្ហាញតួអង្គមួយ",
    "gui.howtos.make-a-chase-game.name": "បង្កើតហ្គេមដេញចាប់",
    "gui.howtos.Chase-Game.step_BG": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.chase-game.step_AddOcto": "បន្ថែម​តួអង្គ",
    "gui.howtos.make-music.step_LeftRight": "ផ្លាស់ទីឆ្វេងស្តាំដោយប្រើច្នុចសញ្ញាព្រួញ",
    "gui.howtos.Chase-Game.step_UpDown": "ផ្លាស់ទីឡើងចុះដោយប្រើច្នុចសញ្ញាព្រួញ",
    "gui.howtos.Chase-Game.step_AddStar": "បន្ថែមតួអង្គមួយទៀត",
    "gui.howtos.Chase-Game.step_MoveRandom": "ផ្លាស់ទីចៃដន្យ",
    "gui.howtos.Chase-Game.step_WhenTouch": "សម្រាប់តួអង្គត្រីមឹក ពេលចុចលេងសម្លេង",
    "gui.howtos.Chase-Game.step_ScoreVariable": "បង្កើតអថេរពិន្ទុ",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "សម្រាប់តួអង្គត្រីមឹក ពេលចុចថែមពិន្ទុ",
    "gui.howtos.animate-char.name": "ធ្វើឲ្យតួអង្គមានចលនា",
    "gui.howtos.animate-char.step_addbg": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.animate-char.step_addsprite": "បន្ថែម​តួអង្គ",
    "gui.howtos.animate-char.step_saysomething": "និយាយអ្វីមួយ",
    "gui.howtos.animate-char.step_addsound": "បន្ថែមសម្លេង",
    "gui.howtos.animate-char.step_animatetalking": "ធ្វើចលនាពេលនិយាយ",
    "gui.howtos.animate-char.step_arrowkeys": "ផ្លាស់ទីដោយប្រើច្នុចសញ្ញាព្រួញ",
    "gui.howtos.animate-char.step_jump": "លោត",
    "gui.howtos.animate-char.step_changecolor": "ប្តូរពណ៌",
    "gui.howtos.make-a-game.name": "បង្កើតហ្គេមចុច",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "ជ្រើសតួអង្គ",
    "gui.howtos.make-a-game.step_GamePlaySound": "លេងសម្លេងពេលចុច",
    "gui.howtos.make-a-game.step_GameAddScore": "បង្កើតអថេរពិន្ទុ",
    "gui.howtos.make-a-game.step_GameChangeScore": "ពេលចុច បង្កើនពិន្ទុ",
    "gui.howtos.make-a-game.step_Random": "ទៅកាន់ទីតាំងចៃដន្យមួយ",
    "gui.howtos.make-music.step_GameChangeColor": "ប្តូរពណ៌",
    "gui.howtos.make-music.step_ResetScore": "កំណត់ពិន្ទុឡើងវិញ",
    "gui.howtos.make-it-fly.name": "ធ្វើឲ្យវាហោះ",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយជាមេឃ",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "ជ្រើសតួអង្គមួយ",
    "gui.howtos.fly.step_stepflySaySomething": "និយាយអ្វីមួយ",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "ផ្លាស់ទីដោយប្រើច្នុចសញ្ញាព្រួញ",
    "gui.howtos.fly.step_stepflyChooseObject": "ជ្រើសរើសវត្ថុដែលត្រូវប្រមូល",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "ធ្វើអោយវត្ថុផ្លាស់ទី",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "ជ្រើសរើសតួអង្គរបស់អ្នក",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "បន្ថែមពិន្ទុ",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "កត់ត្រាពិន្ទុ",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "បន្ថែមឆាក",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "ផ្លាស់ទីឆាក",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "រូបរាងបន្ទាប់",
    "gui.howtos.pong": "ហ្គេមបាល់លោត",
    "gui.howtos.pong.step_pongAddBackdrop": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.pong.step_pongAddBallSprite": "បន្ថែមតួអង្គជាបាល់",
    "gui.howtos.pong.step_pongBounceAround": "លោតចុះឡើង",
    "gui.howtos.pong.step_pongAddPaddle": "បន្ថែមចង្វា",
    "gui.howtos.pong.step_pongMoveThePaddle": "ផ្លាស់ទីចង្វា",
    "gui.howtos.pong.step_pongSelectBallSprite": "ជ្រើសរើសតួអង្គជាបាល់",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "បន្ថែមកូដដើម្បីឲ្យបាល់ខ្ទាត់ពីចង្វា",
    "gui.howtos.pong.step_pongAddAScore": "បន្ថែមពិន្ទុ",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "ជ្រើសរើសពិន្ទុពីម៉ឺនុយ",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "បញ្ចូលប្លុក​ \"កែពិន្ទុ\"",
    "gui.howtos.pong.step_pongResetScore": "កំណត់ពិន្ទុឡើងវិញ",
    "gui.howtos.pong.step_pongAddLineSprite": "បន្ថែមតួអង្គជាបន្ទាត់",
    "gui.howtos.pong.step_pongGameOver": "ហ្គេមបញ្ចប់",
    "gui.howtos.code-cartoon": "សរសេរកូដបង្កើតរឿងតុក្កតា",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "និយាយអ្វីមួយនៅពេលអ្នកចុចលើទង់",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "ធ្វើឲ្យតួអង្គមានចលនានៅពេលអ្នកចុចវា",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "ជ្រើសរើសតួអង្គមួយផ្សេងទៀត",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "ប្រើសញ្ញាដកដើម្បីឱ្យវារួមតូច",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "ធ្វើឲ្យតួអង្គរីកនិងរួម",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "ជ្រើសរើសតួអង្គមួយផ្សេងទៀត",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "លោតឡើងចុះ",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "ចុចតួអង្គដើម្បីប្ដូរឈុតឆាក",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "រអិលចុះឡើង",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "ប្ដូររូបរាង",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "ជ្រើសតួអង្គច្រើនទៀតដើម្បីបន្ថែមទៅក្នុងរឿងតុក្កតារបស់អ្នក",
    "gui.howtos.cartoon-network": "បង្កើតហ្គេមបែបផ្សងព្រេងដែលមានរូបជីវចល",
    "gui.howtos.cartoon-network.step_CNcharacter": "ជ្រើសរើសតួដើម្បីបង្ហាញ",
    "gui.howtos.cartoon-network.step_CNsay": "និយាយអ្វីមួយ",
    "gui.howtos.cartoon-network.step_CNglide": "រអិលចុះឡើង",
    "gui.howtos.cartoon-network.step_CNpicksprite": "ជ្រើសរើសវត្ថុដែលត្រូវដេញតាម",
    "gui.howtos.cartoon-network.step_CNcollect": "ប្រមូលវត្ថុនានា",
    "gui.howtos.cartoon-network.step_CNvariable": "បង្កើតអថេរសម្រាប់ពិន្ទុ",
    "gui.howtos.cartoon-network.step_CNscore": "កត់ត្រាពិន្ទុ",
    "gui.howtos.cartoon-network.step_CNbackdrop": "កម្រិតបន្ទាប់៖ ប្តូរផ្ទាំងខាងក្រោយ",
    "gui.howtos.videosens.name": "ញ្ញាណតាមវីដេអូ",
    "gui.howtos.videosens.step_addextension": "បន្ថែមកម្មវិធីបន្ថែម",
    "gui.howtos.videosens.step_pet": "ចិញ្ចឹមឆ្មា",
    "gui.howtos.videosens.step_animate": "ធ្វើឲ្យមានចលនា",
    "gui.howtos.videosens.step_pop": "ចាក់ប៉េងប៉ោង",
    "gui.howtos.say-it-out-loud": "បង្កើតរូបជីវចលដែលនិយាយ",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "បន្ថែមប្លុក \"អត្ថបទទៅសម្លេង\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "និយាយអ្វីមួយ",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "កំណត់សម្លេង",
    "gui.howtos.say-it-out-loud.step_TXTMove": "ផ្លាស់ទីចុះឡើង",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "បន្ថែមតួអង្គមួយទៀត",
    "gui.howtos.say-it-out-loud.step_TXTSong": "សម្តែងចម្រៀងមួយ",
    "gui.howtos.say-it-out-loud.step_TXTColor": "ប្តូរពណ៌",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "វិលមួយជុំ",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "រីក និងរួម",
    "gui.howtos.talking": "រឿងនិទាននិយាយ",
    "gui.howtos.talking.step_talesAddExtension": "ដើម្បីបន្ថែមប្លុក \"អត្ថបទទៅសម្លេង\"",
    "gui.howtos.talking.step_talesChooseSprite": "ជ្រើសតួអង្គ",
    "gui.howtos.talking.step_talesSaySomething": "ធ្វើឲ្យតួអង្គនិយាយ",
    "gui.howtos.talking.step_talesChooseBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយ",
    "gui.howtos.talking.step_talesSwitchBackdrop": "ចុចតួអង្គដើម្បីទៅកាន់ផ្ទៃខាងក្រោយបន្ទាប់",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "ជ្រើសតួអង្គមួយទៀត",
    "gui.howtos.talking.step_talesMoveAround": "ផ្លាស់ទីចុះឡើង",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយមួយទៀត",
    "gui.howtos.talking.step_talesAnimateTalking": "ធ្វើចលនាពេលនិយាយ",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "ជ្រើសផ្ទាំងខាងក្រោយមួយទៀត",
    "gui.howtos.talking.step_talesChooseSound": "ជ្រើសបទចម្រៀងដើម្បីរាំ",
    "gui.howtos.talking.step_talesDanceMoves": "ជំហានរាំ",
    "gui.howtos.talking.step_talesAskAnswer": "យកប្លុកសួរ និងឆ្លើយ ក្នុងប្រភេទ \"ញ្ញាណ\"",
    "gui.howtos.add-sprite.name": "បន្ថែម​តួអង្គ",
    "gui.howtos.add-sprite.step_addSprite": "បន្ថែម​តួអង្គ",
    "gui.howtos.add-a-backdrop.name": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "បន្ថែមផ្ទាំងខាងក្រោយ",
    "gui.howtos.change-size.name": "ប្តូរទំហំ",
    "gui.howtos.change-size.step_changeSize": "ប្តូរទំហំ",
    "gui.howtos.glide-around.name": "រអិលចុះឡើង",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "រអិលចុះឡើង",
    "gui.howtos.change-size.step_glideAroundPoint": "រអិលទៅចំនុចមួយ",
    "gui.howtos.record-a-sound.name": "ថតសម្លេង",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "ចុចលើផ្ទាំង \"សម្លេង\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "ចុច​ \"ថត\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "ចុចប៊ូតុងថត",
    "gui.howtos.change-size.step_recordASoundChooseSound": "ជ្រើសរើសសម្លេងរបស់អ្នក",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "លេងសំឡេងរបស់អ្នក",
    "gui.howtos.spin-video.name": "ធ្វើឲ្យវាវិល",
    "gui.howtos.change-size.step_spinTurn": "បែរ",
    "gui.howtos.change-size.step_spinPointInDirection": "កំណត់ទិសដៅ",
    "gui.howtos.hide-and-show.name": "លាក់ និងបង្ហាញ",
    "gui.howtos.change-size.step_hideAndShow": "លាក់ និងបង្ហាញ",
    "gui.howtos.switch-costume.name": "ធ្វើតួអង្គឲ្យមានចលនា",
    "gui.howtos.change-size.step_switchCostumes": "ធ្វើតួអង្គឲ្យមានចលនា",
    "gui.howtos.move-around-with-arrow-keys.name": "ប្រើច្នុចសញ្ញាព្រួញ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "ផ្លាស់ទីឆ្វេងស្ដាំ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "ផ្លាស់ទីឡើងចុះ",
    "gui.howtos.add-effects.name": "បន្ថែមបែបផែន",
    "gui.howtos.videosens.step_addEffects": "បន្ថែមបែបផែន",
    "gui.extension.music.name": "តន្រ្តី",
    "gui.extension.music.description": "លេងឧបករណ៍តន្រ្តី និងស្គរ",
    "gui.extension.pen.name": "ប៊ិច",
    "gui.extension.pen.description": "គូរដោយប្រើតួអង្គរបស់អ្នក",
    "gui.extension.videosensing.name": "ញ្ញាណតាមវីដេអូ",
    "gui.extension.videosensing.description": "ចាប់ចលនាដោយប្រើកាមេរ៉ា",
    "gui.extension.text2speech.name": "អត្ថបទទៅសម្លេង",
    "gui.extension.text2speech.description": "ធ្វើឲ្យតួអង្គក្នុងកិច្ចការរបស់អ្នកនិយាយ",
    "gui.extension.translate.name": "បកប្រែ",
    "gui.extension.translate.description": "បកប្រែអត្ថបទទៅភាសាជាច្រើន",
    "gui.extension.makeymakey.description": "យកអ្វីធ្វើជាច្នុចក៏បាន",
    "gui.extension.microbit.description": "ភ្ជាប់កិច្ចការរបស់អ្នកជាមួយនឹងពិភពលោក។",
    "gui.extension.microbit.connectingMessage": "កំពុងភ្ជាប់",
    "gui.extension.ev3.description": "បង្កើតរ៉ូបូតមានចលនា និង របស់ជាច្រើនទៀត។",
    "gui.extension.ev3.connectingMessage": "កំពុងភ្ជាប់! សូមឲ្យប្រាកដថាលេខសម្គាល់នៅលើឧបករណ៍ EV3 របស់អ្នកត្រូវបានដាក់ទៅជា 1234 ។",
    "gui.extension.boost.description": "បង្កើតឧបករណ៍រ៉ូបូត",
    "gui.extension.boost.connectingMessage": "កំពុងភ្ជាប់",
    "gui.extension.wedo2.description": "បង្កើតដោយប្រើម៉ូទ័រ និងឧបករណ៍ចាប់សញ្ញា",
    "gui.extension.wedo2.connectingMessage": "កំពុងភ្ជាប់...",
    "gui.extension.gdxfor.description": "ដឹងពីការរុញ ការទាញ ចលនា និង រង្វិល។",
    "gui.extension.gdxfor.connectingMessage": "កំពុងភ្ជាប់...",
    "gui.libraryTags.all": "ទាំងអស់",
    "gui.libraryTags.animals": "សត្វ",
    "gui.libraryTags.dance": "រាំ",
    "gui.libraryTags.effects": "បែបផែន",
    "gui.libraryTags.fantasy": "ស្រមើស្រមៃ",
    "gui.libraryTags.fashion": "ម៉ូត",
    "gui.libraryTags.food": "អាហារ",
    "gui.libraryTags.indoors": "ខាងក្នុង",
    "gui.libraryTags.loops": "រង្វិលជុំ",
    "gui.libraryTags.music": "តន្រ្តី",
    "gui.libraryTags.notes": "ណូត",
    "gui.libraryTags.outdoors": "ខាងក្រៅ",
    "gui.libraryTags.patterns": "ក្រឡា",
    "gui.libraryTags.people": "មនុស្ស",
    "gui.libraryTags.percussion": "សម្លេងវាយ",
    "gui.libraryTags.space": "លំហ",
    "gui.libraryTags.sports": "កីឡា",
    "gui.libraryTags.underwater": "ក្នុងទឹក",
    "gui.libraryTags.voice": "សម្លេង",
    "gui.libraryTags.wacky": "សម្លេងចម្លែកៗ",
    "gui.libraryTags.animation": "រូបជីវចល",
    "gui.libraryTags.art": "សិល្បៈ",
    "gui.libraryTags.games": "ហ្គេម",
    "gui.libraryTags.stories": "រឿង",
    "gui.libraryTags.letters": "តួអក្សរ",
    "gui.opcodeLabels.direction": "ទិសដៅ",
    "gui.opcodeLabels.xposition": "ទីតាំង x",
    "gui.opcodeLabels.yposition": "ទីតាំង y",
    "gui.opcodeLabels.size": "ទំហំ",
    "gui.opcodeLabels.costumename": "ឈ្មោះរូបរាង",
    "gui.opcodeLabels.costumenumber": "លេខរូបរាង",
    "gui.opcodeLabels.backdropname": "ឈ្មោះផ្ទាំងខាងក្រោយ",
    "gui.opcodeLabels.backdropnumber": "លេខផ្ទាំងខាងក្រោយ",
    "gui.opcodeLabels.volume": "កម្រិតសម្លេង",
    "gui.opcodeLabels.tempo": "ចង្វាក់",
    "gui.opcodeLabels.answer": "ចម្លើយ",
    "gui.opcodeLabels.loudness": "កម្រិតឮ",
    "gui.opcodeLabels.username": "ឈ្មោះគណនី",
    "gui.opcodeLabels.year": "ឆ្នាំ",
    "gui.opcodeLabels.month": "ខែ",
    "gui.opcodeLabels.date": "ថ្ងៃខែ",
    "gui.opcodeLabels.dayofweek": "ថ្ងៃប្រចាំសប្តាហ៍",
    "gui.opcodeLabels.hour": "ម៉ោង",
    "gui.opcodeLabels.minute": "នាទី",
    "gui.opcodeLabels.second": "វិនាទី",
    "gui.opcodeLabels.timer": "ម៉ោងរាប់ថយក្រោយ",
    "gui.projectLoader.loadError": "ឯកសារកិច្ចការដែលត្រូវបានជ្រើសរើសមិនអាចបើកបានទេ។",
    "gui.sharedMessages.backdrop": "ផ្ទាំងខាងក្រោយ {index}",
    "gui.sharedMessages.costume": "រូបរាង {index}",
    "gui.sharedMessages.sprite": "តួអង្គ {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "ជំនួសខ្លឹមសារនៃកិច្ចការបច្ចុប្បន្នមែនទេ?",
    "gui.sharedMessages.loadFromComputerTitle": "ដំណើរការពីកុំព្យូទ័ររបស់អ្នក",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "កិច្ចការ Scratch",
    "boost.color.any": "ពណ៌ណាមួយ",
    "boost.color.black": "ខ្មៅ",
    "boost.color.blue": "ខៀវ",
    "boost.color.green": "បៃតង",
    "boost.color.red": "ក្រហម",
    "boost.color.white": "ស",
    "boost.color.yellow": "លឿង",
    "boost.getMotorPosition": "ទីតាំងម៉ូទ័រ [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "លម្អៀងមុំ [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ទៅក្រោយ",
    "boost.motorDirection.forward": "ទៅមុខ",
    "boost.motorDirection.reverse": "បញ្ច្រាស់",
    "boost.motorOff": "បិទម៉ូទ័រ [MOTOR_ID]",
    "boost.motorOn": "បើកម៉ូទ័រ [MOTOR_ID]",
    "boost.motorOnFor": "បង្វិលម៉ូទ័រ [MOTOR_ID] រយៈពេល [DURATION] វិនាទី",
    "boost.motorOnForRotation": "បង្វិលម៉ូទ័រ [MOTOR_ID] ចំនួន [ROTATION] ជុំ",
    "boost.seeingColor": "ឃើញដុំពណ៌ [COLOR]?",
    "boost.setLightHue": "ដាក់ពណ៌របស់ភ្លើងទៅជា [HUE]",
    "boost.setMotorDirection": "ដាក់ទិសដៅរបស់ [MOTOR_ID] ទៅជា [MOTOR_DIRECTION]",
    "boost.setMotorPower": "ដាក់ល្បឿនម៉ូទ័រ [MOTOR_ID] ត្រឹម [POWER] %",
    "boost.tiltDirection.any": "ខ្លះ",
    "boost.tiltDirection.down": "ចុះក្រោម",
    "boost.tiltDirection.left": "ឆ្វេង",
    "boost.tiltDirection.right": "ស្ដាំ",
    "boost.tiltDirection.up": "លើ",
    "boost.whenColor": "ពេលឃើញពណ៌ [COLOR]",
    "boost.whenTilted": "ពេលលំអៀង [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "លេងណូត [NOTE] រយៈពេល​ [TIME] វិនាទី",
    "ev3.buttonPressed": "ប៊ូតុងលើ [PORT] ត្រូវបានចុច?",
    "ev3.getBrightness": "កម្រិតពន្លឺ",
    "ev3.getDistance": "កម្រិតចម្ងាយ",
    "ev3.getMotorPosition": "ទីតាំងម៉ូទ័រ [PORT] ",
    "ev3.motorSetPower": "ដាក់ថាមពលម៉ូទ័រ [PORT] ត្រឹម [POWER] %",
    "ev3.motorTurnClockwise": "ម៉ូទ័រ [PORT] បែរតាមទ្រនិចនាឡិការយៈពេល [TIME] វិនាទី",
    "ev3.motorTurnCounterClockwise": "ម៉ូទ័រ [PORT] បែរបញ្ច្រាសទ្រនិចនាឡិការយៈពេល [TIME] វិនាទី",
    "ev3.whenBrightnessLessThan": "ពេលកម្រិតពន្លឺ < [DISTANCE]",
    "ev3.whenButtonPressed": "ពេលប៊ូតុង [PORT] បានចុច",
    "ev3.whenDistanceLessThan": "ពេលចម្ងាយ < [DISTANCE]",
    "gdxfor.getAcceleration": "សំទុះ [DIRECTION]",
    "gdxfor.getForce": "កម្លាំង",
    "gdxfor.getSpin": "ល្បឿនបង្វិល [DIRECTION]",
    "gdxfor.getTilt": "លម្អៀងមុំ [TILT]",
    "gdxfor.isFreeFalling": "ធ្លាក់សេរី?",
    "gdxfor.isTilted": "លំអៀង [TILT]?",
    "gdxfor.pulled": "ត្រូវបានទាញ",
    "gdxfor.pushed": "ត្រូវបានរុញ",
    "gdxfor.shaken": "ញាក់",
    "gdxfor.startedFalling": "បានចាប់ផ្តើមធ្លាក់",
    "gdxfor.tiltDirectionMenu.any": "ណាមួយ",
    "gdxfor.tiltDirectionMenu.back": "ក្រោយ",
    "gdxfor.tiltDirectionMenu.front": "មុខ",
    "gdxfor.tiltDirectionMenu.left": "ឆ្វេង",
    "gdxfor.tiltDirectionMenu.right": "ស្តាំ",
    "gdxfor.turnedFaceDown": "បែរមុខចុះ",
    "gdxfor.turnedFaceUp": "បែរមុខឡើង",
    "gdxfor.whenForcePushedOrPulled": "ពេលសិនស័រកម្លាំង [PUSH_PULL]",
    "gdxfor.whenGesture": "ពេល [GESTURE]",
    "gdxfor.whenTilted": "ពេលលំអៀង [TILT]",
    "makeymakey.downArrow": "ព្រួញខាងក្រោម",
    "makeymakey.downArrowShort": "ចុះក្រោម",
    "makeymakey.leftArrow": "ព្រួញខាង​ឆ្វេង",
    "makeymakey.leftArrowShort": "ឆ្វេង",
    "makeymakey.rightArrow": "ព្រួញ​ខាងស្ដាំ",
    "makeymakey.rightArrowShort": "ស្តាំ",
    "makeymakey.spaceKey": "ច្នុចដក​ឃ្លា",
    "makeymakey.upArrow": "ព្រួញ​ខាង​លើ",
    "makeymakey.upArrowShort": "លើ",
    "makeymakey.whenKeyPressed": "ពេលចុច [KEY]",
    "makeymakey.whenKeysPressedInOrder": "ពេលចុច [SEQUENCE] តាមលំដាប់",
    "microbit.buttonsMenu.any": "ណាមួយ",
    "microbit.clearDisplay": "សម្អាតអេក្រង់",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "បង្ហាញ [MATRIX]",
    "microbit.displayText": "បង្ហាញអត្ថបទ [TEXT]",
    "microbit.gesturesMenu.jumped": "បានលោត",
    "microbit.gesturesMenu.moved": "បានផ្លាស់ទី",
    "microbit.gesturesMenu.shaken": "ញាក់",
    "microbit.isButtonPressed": "ប៊ូតុង [BTN] ​ត្រូវ​បាន​ចុច?",
    "microbit.isTilted": "លំអៀង [DIRECTION]?",
    "microbit.pinStateMenu.off": "បិទ",
    "microbit.pinStateMenu.on": "បើក",
    "microbit.tiltAngle": "លម្អៀងមុំ [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "ណាមួយ",
    "microbit.tiltDirectionMenu.back": "ត្រឡប់",
    "microbit.tiltDirectionMenu.front": "មុខ",
    "microbit.tiltDirectionMenu.left": "ឆ្វេង",
    "microbit.tiltDirectionMenu.right": "ស្តាំ",
    "microbit.whenButtonPressed": "ពេលប៊ូតុង [BTN] ​ត្រូវ​បាន​ចុច",
    "microbit.whenGesture": "ពេល [GESTURE]",
    "microbit.whenPinConnected": "ពេលម្ជុលតំណរ [PIN] ត្រូវបានភ្ជាប់",
    "microbit.whenTilted": "ពេលលំអៀង [DIRECTION]",
    "music.categoryName": "តន្រ្តី",
    "music.changeTempo": "ប្តូរចង្វាក់ចំនួន [TEMPO]",
    "music.drumBass": "(2) Bass Drum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Closed Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) ទះដៃ",
    "music.drumOpenHiHat": "(5) Open Hi-Hat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snare Drum",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood Block",
    "music.getTempo": "ចង្វាក់",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Choir",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Electric Guitar",
    "music.instrumentElectricPiano": "(2) Electric Piano",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Guitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Music Box",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Wooden Flute",
    "music.midiPlayDrumForBeats": "លេងសូរ [DRUM] ចំនួន [BEATS] ប៊ីត",
    "music.midiSetInstrument": "ដាក់ឧបករណ៍ទៅជា [INSTRUMENT]",
    "music.playDrumForBeats": "លេងសូរ [DRUM] ចំនួន [BEATS] ប៊ីត",
    "music.playNoteForBeats": "លេងណូត [NOTE] ចំនួន [BEATS] ប៊ីត",
    "music.restForBeats": "ផ្អាកចំនួន [BEATS] ប៊ីត",
    "music.setInstrument": "ដាក់ឧបករណ៍ទៅជា [INSTRUMENT]",
    "music.setTempo": "ដាក់ចង្វាក់ត្រឹម [TEMPO]",
    "pen.categoryName": "ប៊ិច",
    "pen.changeColorParam": "ប្តូរ [COLOR_PARAM] របស់ប៊ិចចំនួន [VALUE]",
    "pen.changeHue": "ប្ដូរពណ៌ប៊ិចចំនួន [HUE]",
    "pen.changeShade": "ប្តូរកម្រិតដិតរបស់ប៊ិចចំនួន [SHADE]",
    "pen.changeSize": "ប្តូរទំហំប៊ិចចំនួន [SIZE]",
    "pen.clear": "លុបទាំងអស់",
    "pen.colorMenu.brightness": "កម្រិតពន្លឺ",
    "pen.colorMenu.color": "ពណ៌",
    "pen.colorMenu.saturation": "កម្រិត​ដិត",
    "pen.colorMenu.transparency": "កម្រិតឆ្លុះ",
    "pen.penDown": "ចាប់គូស",
    "pen.penUp": "ឈប់គូស",
    "pen.setColor": "ដាក់ពណ៌ប៊ិចទៅជា [COLOR]",
    "pen.setColorParam": "ដាក់ [COLOR_PARAM] របស់ប៊ិចត្រឹម [VALUE]",
    "pen.setHue": "ដាក់ពណ៌ប៊ិចទៅជា [HUE]",
    "pen.setShade": "ដាក់កម្រិតដឹតរបស់ប៊ិចត្រឹម [SHADE]",
    "pen.setSize": "ដាក់ទំហំប៊ិចត្រឹម [SIZE]",
    "pen.stamp": "ដាក់ផ្តិតរូប",
    "speech.defaultWhenIHearValue": "ចាប់ផ្តើមធ្វើ",
    "speech.extensionName": "សម្តីទៅជាអត្ថបទ",
    "speech.listenAndWait": "ស្តាប់ ហើយចាំ",
    "speech.speechReporter": "សម្តី",
    "speech.whenIHear": "ពេលខ្ញុំលឺ [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "អត្ថបទទៅសម្លេង",
    "text2speech.defaultTextToSpeak": "សួស្តី",
    "text2speech.giant": "យក្ស",
    "text2speech.kitten": "កូនឆ្មា",
    "text2speech.setLanguageBlock": "ដាក់ភាសាទៅជា [LANGUAGE]",
    "text2speech.setVoiceBlock": "ដាក់សម្លេងទៅជា [VOICE]",
    "text2speech.speakAndWaitBlock": "និយាយ [WORDS]",
    "text2speech.squeak": "ស្រែកញ៉េក",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "បកប្រែ",
    "translate.defaultTextToTranslate": "សួស្តី",
    "translate.translateBlock": "បកប្រែ [WORDS] ទៅជាភាសា [LANGUAGE]",
    "translate.viewerLanguage": "ភាសា",
    "videoSensing.categoryName": "ញ្ញាណតាមវីដេអូ",
    "videoSensing.direction": "ទិសដៅ",
    "videoSensing.motion": "ចលនា",
    "videoSensing.off": "បិទ",
    "videoSensing.on": "បើក",
    "videoSensing.onFlipped": "ត្រឡប់",
    "videoSensing.setVideoTransparency": "ដាក់កម្រិតឆ្លុះរបស់វីដេអូត្រឹម [TRANSPARENCY]",
    "videoSensing.sprite": "តួអង្គ",
    "videoSensing.stage": "ឆាក",
    "videoSensing.videoOn": "[ATTRIBUTE] របស់វីដេអូទៅលើ [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] វីដេអូ",
    "videoSensing.whenMotionGreaterThan": "ពេលកម្រិតចលនាក្នុងវីដេអូ > [REFERENCE]",
    "wedo2.getDistance": "ចម្ងាយ",
    "wedo2.getTiltAngle": "លម្អៀងមុំ [TILT_DIRECTION]",
    "wedo2.isTilted": "លំអៀង [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ទៅក្រោយ",
    "wedo2.motorDirection.forward": "ទៅមុខ",
    "wedo2.motorDirection.reverse": "បញ្ច្រាស់",
    "wedo2.motorId.a": "ម៉ូទ័រ A",
    "wedo2.motorId.all": "ម៉ូទ័រទាំងអស់",
    "wedo2.motorId.b": "ម៉ូទ័រ B",
    "wedo2.motorId.default": "ម៉ូទ័រ",
    "wedo2.motorOff": "បិទម៉ូទ័រ [MOTOR_ID]",
    "wedo2.motorOn": "បើកម៉ូទ័រ [MOTOR_ID]",
    "wedo2.motorOnFor": "បើកម៉ូទ័រ [MOTOR_ID] រយៈពេល [DURATION] វិនាទី",
    "wedo2.playNoteFor": "លេងណូត [NOTE] រយៈពេល​ [DURATION] វិនាទី",
    "wedo2.setLightHue": "ដាក់ពណ៌ភ្លើងទៅជា [HUE]",
    "wedo2.setMotorDirection": "ដាក់ទិសដៅរបស់ [MOTOR_ID] ទៅជា [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "ដាក់ថាមពលម៉ូទ័រ [MOTOR_ID] ត្រឹម [POWER] %",
    "wedo2.tiltDirection.any": "ណាមួយ",
    "wedo2.tiltDirection.down": "ចុះក្រោម",
    "wedo2.tiltDirection.left": "ឆ្វេង",
    "wedo2.tiltDirection.right": "ស្តាំ",
    "wedo2.tiltDirection.up": "លើ",
    "wedo2.whenDistance": "ពេលចម្ងាយ [OP] [REFERENCE]",
    "wedo2.whenTilted": "ពេលលំអៀង [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "ពណ៌",
    "paint.paintEditor.saturation": "កម្រិតដិត",
    "paint.paintEditor.brightness": "កម្រិតពន្លឺ",
    "paint.paintEditor.costume": "រូបរាង",
    "paint.paintEditor.group": "ដាក់ក្រុម",
    "paint.paintEditor.ungroup": "បំបែកក្រុម",
    "paint.paintEditor.undo": "មិនធ្វើវិញ",
    "paint.paintEditor.redo": "ធ្វើឡើងវិញ",
    "paint.paintEditor.forward": "ទៅមុខ",
    "paint.paintEditor.backward": "ថយក្រោយ",
    "paint.paintEditor.front": "មុខគេ",
    "paint.paintEditor.back": "ក្រោយគេ",
    "paint.paintEditor.more": "ច្រើនទៀត",
    "paint.modeTools.brushSize": "ទំហំ",
    "paint.modeTools.eraserSize": "ទំហំជ័រលុប",
    "paint.modeTools.copy": "ចម្លង",
    "paint.modeTools.paste": "ភ្ជាប់",
    "paint.modeTools.delete": "លុប",
    "paint.modeTools.curved": "កោង",
    "paint.modeTools.pointed": "ស្រួច",
    "paint.modeTools.thickness": "កម្រាស់",
    "paint.modeTools.flipHorizontal": "ត្រឡប់ផ្ដេក",
    "paint.modeTools.flipVertical": "ត្រឡប់ឈរ",
    "paint.modeTools.filled": "មានផ្ទៃ",
    "paint.modeTools.outlined": "មានគ្រោង",
    "paint.paintEditor.bitmap": "បម្លែងជា Bitmap",
    "paint.paintEditor.vector": "បម្លែងជា Vector",
    "paint.paintEditor.fill": "ផ្ទៃ",
    "paint.paintEditor.stroke": "បន្ទាត់គែម",
    "paint.brushMode.brush": "ជក់",
    "paint.eraserMode.eraser": "ជ័រលុប",
    "paint.fillMode.fill": "ផ្ទៃ",
    "paint.lineMode.line": "បន្ទាត់",
    "paint.ovalMode.oval": "រង្វង់",
    "paint.rectMode.rect": "ចតុកោណកែង",
    "paint.reshapeMode.reshape": "កែរូបរាង",
    "paint.roundedRectMode.roundedRect": "ចតុកោណកែងជ្រុងមូល",
    "paint.selectMode.select": "ជ្រើសរើស",
    "paint.textMode.text": "អត្ថបទ",
    "paint.colorPicker.swap": "ប្តូរពណ៌"
  },
  "pl": {
    "gui.alerts.lostPeripheralConnection": "Scratch stracił połączenie z {extensionName}.",
    "gui.alerts.tryAgain": "Spróbuj ponownie",
    "gui.alerts.download": "Pobierz",
    "gui.connection.reconnect": "Połącz ponownie",
    "gui.backpack.costumeLabel": "kostium",
    "gui.backpack.soundLabel": "dźwięk",
    "gui.backpack.scriptLabel": "skrypt",
    "gui.backpack.spriteLabel": "duszek",
    "gui.backpack.header": "Plecak",
    "gui.backpack.errorBackpack": "Błąd wczytywania plecaka",
    "gui.backpack.loadingBackpack": "Ładowanie...",
    "gui.backpack.more": "Więcej",
    "gui.backpack.emptyBackpack": "Plecak jest pusty",
    "gui.unsupportedBrowser.label": "Przeglądarka nie jest wspierana",
    "gui.unsupportedBrowser.errorLabel": "Wystąpił błąd",
    "gui.unsupportedBrowser.notRecommended": "Bardzo przepraszamy, ale wygląda na to, że używasz wersję przeglądarki, która nie jest obsługiwana przez Scratch. Polecamy zainstalować aktualizację do najnowszej wersji obsługiwanej przeglądarki n.p. Google Chrome, Mozilla Firefox, Microsoft Edge lub Apple Safari.",
    "gui.unsupportedBrowser.description": "Bardzo przepraszamy, ale Scratch nie obsługuje tej przeglądarki. Polecamy zmienić przeglądarkę na obsługiwaną, n.p. Google Chrome, Mozilla Firefox, Microsoft Edge lub Apple Safari.",
    "gui.unsupportedBrowser.back": "Powrót",
    "gui.unsupportedBrowser.previewfaq": "Aby dowiedzieć się więcej, odwiedź {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Najczęściej zadawane pytania (FAQ)",
    "gui.cards.all-tutorials": "Samouczki",
    "gui.cards.shrink": "Zmniejsz",
    "gui.cards.expand": "Rozwiń",
    "gui.cards.close": "Zamknij",
    "gui.cards.more-things-to-try": "Więcej rzeczy do spróbowania!",
    "gui.cards.see-more": "Zobacz więcej",
    "gui.comingSoon.message1": "Nie martw się, pracujemy nad tym {emoji}",
    "gui.comingSoon.message2": "Już wkrótce...",
    "gui.comingSoon.message3": "Pracujemy nad tym {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nie znaleziono urządzeń",
    "gui.connection.auto-scanning.prescan": "Umieść swoje urządzenie w pobliżu, a następnie rozpocznij szukać.",
    "gui.connection.auto-scanning.pressbutton": "Naciśnij przycisk na swoim urządzeniu",
    "gui.connection.auto-scanning.start-search": "Zacznij szukać",
    "gui.connection.connecting-searchbutton": "Szukanie...",
    "gui.connection.auto-scanning.try-again": "Spróbuj ponownie",
    "gui.connection.auto-scanning.updatePeripheralButton": "Zaktualizuj moje urządzenie",
    "gui.connection.connected": "Połączone",
    "gui.connection.disconnect": "Rozłącz",
    "gui.connection.go-to-editor": "Przejdź do edytora",
    "gui.connection.connecting-cancelbutton": "Trwa łączenie...",
    "gui.connection.error.errorMessage": "Ups, wygląda na to, że coś poszło nie tak.",
    "gui.connection.error.tryagainbutton": "Spróbuj ponownie",
    "gui.connection.error.helpbutton": "Pomoc",
    "gui.connection.peripheral-name-label": "Nazwa urządzenia",
    "gui.connection.connect": "Połącz",
    "gui.connection.scanning.lookingforperipherals": "Trwa szukanie urządzeń",
    "gui.connection.scanning.noPeripheralsFound": "Nie znaleziono urządzeń",
    "gui.connection.scanning.instructions": "Wybierz urządzenie z powyższej listy.",
    "gui.connection.search": "Odśwież",
    "gui.connection.scanning.updatePeripheralButton": "Zaktualizuj moje urządzenie",
    "gui.connection.unavailable.installscratchlink": "Upewnij się, że zainstalowałeś Scratch Link, oraz że aplikacja jest uruchomiona.",
    "gui.connection.unavailable.enablebluetooth": "Upewnij się, że usługa Bluetooth jest włączona",
    "gui.connection.unavailable.tryagainbutton": "Spróbuj ponownie",
    "gui.connection.unavailable.helpbutton": "Pomoc",
    "gui.connection.updatePeripheral.microBitConnect": "Połącz swoje urządzenie{extensionName} z tym urządzeniem za pomocą kabla USB.",
    "gui.connection.updatePeripheral.pressUpdate": "Kliknij \"Zaktualizuj\" i pozwól na dokończenie aktualizacji.",
    "gui.connection.updatePeripheral.progress": "Aktualizowanie {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Zaktualizowano pomyślnie!",
    "gui.connection.updatePeripheral.updateFailed": "Aktualizacja nie powiodła się.",
    "gui.connection.updatePeripheral.goBackButton": "Powrót",
    "gui.connection.updatePeripheral.updateNowButton": "Zaktualizuj",
    "gui.connection.updatePeripheral.updateAgainButton": "Spróbuj ponownie",
    "gui.controls.go": "Idź",
    "gui.controls.stop": "Zatrzymaj",
    "gui.crashMessage.label": "Ups! Coś poszło nie tak.",
    "gui.crashMessage.description": "Przykro nam, ale wygląda na to, że program Scratch uległ crashowi. Ten błąd został automatycznie zgłoszony do zespołu firmy Scratch. Odśwież stronę, aby spróbować ponownie.",
    "gui.crashMessage.errorNumber": "Twój błąd został zgłoszony pod numerem {errorId}",
    "gui.crashMessage.reload": "Załaduj ponownie",
    "gui.customProcedures.myblockModalTitle": "Utwórz blok",
    "gui.customProcedures.addAnInputNumberText": "Dodaj dane wejściowe",
    "gui.customProcedures.numberTextType": "liczba lub tekst",
    "gui.customProcedures.addAnInputBoolean": "Dodaj dane wejściowe",
    "gui.customProcedures.booleanType": "Boolean",
    "gui.customProcedures.addALabel": "Dodaj etykietę",
    "gui.customProcedures.runWithoutScreenRefresh": "Wykonaj bez odświeżania ekranu",
    "gui.customProcedures.cancel": "Anuluj",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Kierunek",
    "gui.directionPicker.rotationStyles.allAround": "Dookoła",
    "gui.directionPicker.rotationStyles.leftRight": "lewo/prawo",
    "gui.directionPicker.rotationStyles.dontRotate": "nie obracaj",
    "gui.gui.addExtension": "Dodaj rozszerzenie",
    "gui.gui.codeTab": "Skrypt",
    "gui.gui.backdropsTab": "Tła",
    "gui.gui.costumesTab": "Kostiumy",
    "gui.gui.soundsTab": "Dźwięki",
    "gui.extensionLibrary.comingSoon": "Już wkrótce",
    "gui.extensionLibrary.requires": "Wymagania",
    "gui.extensionLibrary.collaboration": "Współpraca z ",
    "gui.library.filterPlaceholder": "Szukaj",
    "gui.library.allTag": "Wszystko",
    "gui.loader.message1": "Tworzenie bloków...",
    "gui.loader.message2": "Ładowanie duszków...",
    "gui.loader.message3": "Ładowanie dźwięków",
    "gui.loader.message4": "Ładowanie rozszerzeń...",
    "gui.loader.message5": "Hodowanie kotów...",
    "gui.loader.message6": "Transmitowanie Nano...",
    "gui.loader.message7": "Pompowanie Gobo...",
    "gui.loader.message8": "Przygotowywanie emotikon...",
    "gui.loader.headline": "Ładowanie projektu",
    "gui.loader.creating": "Tworzenie projektu",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Moje rzeczy",
    "gui.accountMenu.myClasses": "Moje lekcje",
    "gui.accountMenu.myClass": "Moja klasa",
    "gui.accountMenu.accountSettings": "Ustawienia konta",
    "gui.accountMenu.signOut": "Wyloguj się",
    "gui.authorInfo.byUser": "przez {username}",
    "gui.menuBar.seeProjectPage": "Przejdź do strony projektu",
    "gui.menuBar.language": "Język",
    "general.username": "Nazwa użytkownika",
    "general.password": "Hasło",
    "general.signIn": "Zaloguj się",
    "login.needHelp": "Czy potrzebujesz pomocy?",
    "form.validationRequired": "To pole jest wymagane",
    "gui.menuBar.tutorialsLibrary": "Samouczki",
    "gui.menuBar.restoreSprite": "Przywróć duszka",
    "gui.menuBar.restoreSound": "Przywróć dźwięk",
    "gui.menuBar.restoreCostume": "Przywróć kostium",
    "gui.menuBar.restore": "Przywróć",
    "gui.menuBar.saveNow": "Zapisz teraz",
    "gui.menuBar.saveAsCopy": "Zapisz jako kopię",
    "gui.menuBar.remix": "Remiks",
    "gui.menuBar.new": "Nowy",
    "gui.menuBar.file": "Plik",
    "gui.menuBar.downloadToComputer": "Zapisz na swoim komputerze ",
    "gui.menuBar.edit": "Edycja",
    "gui.menuBar.turboModeOff": "Wyłącz tryb turbo",
    "gui.menuBar.turboModeOn": "Włącz tryb turbo",
    "gui.menuBar.modeMenu": "Tryb",
    "gui.menuBar.normalMode": "Normalny tryb",
    "gui.menuBar.caturdayMode": "Tryb koci",
    "gui.menuBar.joinScratch": "Dołącz do Scratch",
    "gui.menuBar.signIn": "Zaloguj się",
    "gui.gui.projectTitlePlaceholder": "Tutaj wpisz tytuł projektu",
    "gui.menuBar.saveNowLink": "Zapisz",
    "gui.menuBar.settings": "Ustawienia",
    "gui.menuBar.isShared": "Udostępnione",
    "gui.menuBar.share": "Udostępnij",
    "gui.menuBar.colorMode": "Tryb Kolorów",
    "gui.modal.help": "Pomoc",
    "gui.modal.back": "Powrót",
    "gui.monitor.listMonitor.empty": "(puste)",
    "gui.monitor.listMonitor.listLength": "długość {length}",
    "gui.monitor.contextMenu.default": "normalny widok",
    "gui.monitor.contextMenu.large": "powiększony widok",
    "gui.monitor.contextMenu.slider": "suwak",
    "gui.monitor.contextMenu.sliderRange": "Zmień zakres suwaka",
    "gui.monitor.contextMenu.import": "importuj",
    "gui.monitor.contextMenu.export": "eksportuj",
    "gui.monitor.contextMenu.hide": "ukryj",
    "gui.playButton.play": "Zagraj",
    "gui.playButton.stop": "Zatrzymaj",
    "gui.gui.variableScopeOptionAllSprites": "Dla wszystkich duszków",
    "gui.gui.variableScopeOptionSpriteOnly": "Tylko dla tego duszka",
    "gui.gui.cloudVariableOption": "Zmienna w chmurze (przechowywana na serwerze)",
    "gui.gui.variablePromptAllSpritesMessage": "Ta zmienna będzie dostępna dla wszystkich duszków.",
    "gui.gui.listPromptAllSpritesMessage": "Ta lista będzie dostępna dla wszystkich duszków.",
    "gui.prompt.cancel": "Anuluj",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Zatrzymaj",
    "gui.playbackStep.playMsg": "Zagraj",
    "gui.playbackStep.loadingMsg": "Ładowanie...",
    "gui.playbackStep.saveMsg": "Zapisz",
    "gui.playbackStep.reRecordMsg": "Nagraj ponownie",
    "gui.recordModal.title": "Nagraj dźwięk",
    "gui.recordingStep.beginRecord": "Rozpocznij nagrywanie, klikając przycisk poniżej",
    "gui.recordingStep.permission": "{arrow}Potrzebujemy twojego pozwolenia na używanie mikrofonu",
    "gui.recordingStep.stop": "Zatrzymaj nagrywanie",
    "gui.recordingStep.record": "Nagraj",
    "gui.sliderModal.min": "Najmniejsza wartość",
    "gui.sliderModal.max": "Największa wartość",
    "gui.sliderModal.title": "Zmień zakres suwaka",
    "gui.sliderPrompt.cancel": "Anuluj",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Dźwięk",
    "gui.soundEditor.play": "Zagraj",
    "gui.soundEditor.stop": "Zatrzymaj",
    "gui.soundEditor.copy": "Kopiuj",
    "gui.soundEditor.paste": "Wklej",
    "gui.soundEditor.copyToNew": "Skopiuj do Nowych",
    "gui.soundEditor.delete": "Usuń",
    "gui.soundEditor.save": "Zapisz",
    "gui.soundEditor.undo": "Cofnij",
    "gui.soundEditor.redo": "Ponów",
    "gui.soundEditor.faster": "Szybciej",
    "gui.soundEditor.slower": "Wolniej",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robotyczny głos",
    "gui.soundEditor.louder": "Głośniej",
    "gui.soundEditor.softer": "Zmiękczenie",
    "gui.soundEditor.reverse": "Odwróć",
    "gui.soundEditor.fadeOut": "Wycisz koniec",
    "gui.soundEditor.fadeIn": "Wycisz początek",
    "gui.soundEditor.mute": "Wycisz",
    "gui.SpriteInfo.spritePlaceholder": "Imię",
    "gui.SpriteInfo.showSpriteAction": "Pokaż duszka",
    "gui.SpriteInfo.hideSpriteAction": "Ukryj duszka",
    "gui.SpriteInfo.sprite": "Duszek",
    "gui.SpriteInfo.show": "Pokaż",
    "gui.SpriteInfo.size": "Rozmiar",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplikuj",
    "gui.spriteSelectorItem.contextMenuExport": "eksportuj",
    "gui.spriteSelectorItem.contextMenuDelete": "usuń",
    "gui.spriteSelector.addSpriteFromLibrary": "Wybierz duszka",
    "gui.spriteSelector.addSpriteFromPaint": "Maluj",
    "gui.spriteSelector.addSpriteFromSurprise": "Niespodzianka",
    "gui.spriteSelector.addSpriteFromFile": "Wczytaj duszka",
    "gui.stageHeader.stageSizeLarge": "Przełącz na większą scenę",
    "gui.stageHeader.stageSizeSmall": "Przełącz na małą scenę",
    "gui.stageHeader.stageSizeFull": "Wejdź do trybu pełnego ekranu",
    "gui.stageHeader.stageSizeUnFull": "Wyjdź z trybu pełnoekranowego",
    "gui.stageHeader.fullscreenControl": "Kontrola pełnego ekranu",
    "gui.spriteSelector.addBackdropFromLibrary": "Wybierz tło",
    "gui.stageSelector.addBackdropFromPaint": "Maluj",
    "gui.stageSelector.addBackdropFromSurprise": "Niespodzianka",
    "gui.stageSelector.addBackdropFromFile": "Wczytaj tło",
    "gui.stageSelector.stage": "Scena",
    "gui.stageSelector.backdrops": "Tła",
    "gui.telemetryOptIn.label": "Zgłoś statystyki, aby ulepszyć Scratch",
    "gui.telemetryOptIn.body1": "Twórcy Scratcha ciągle starają się zrozumieć, w jaki sposób ludzie z całego świata używają Scratcha. Żeby im to ułatwić, możesz zgodzić się, żeby Scratch wysyłał do swoich twórców informacje o tym, jak jest używany.",
    "gui.telemetryOptIn.body2": "Informacje, które zbieramy zawierają wybór języka, użytek bloków, i niektóre wydarzenia jak zapisywanie, wczytywanie, i udostępnianie projektu. NIE zbieramy żadnych danych osobistych. Proszę zapoznać się z naszym {privacyPolicyLink}, aby uzyskać więcej informacji.",
    "gui.telemetryOptIn.privacyPolicyLink": "Polityka prywatności",
    "gui.telemetryOptIn.optInText": "Udostępnij dane Zespołowi Scratch",
    "gui.telemetryOptIn.optInTooltip": "Włącz telemetrię",
    "gui.telemetryOptIn.optOutText": "Nie udostępniaj danych Zespołowi Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Wyłącz telemetrię",
    "gui.telemetryOptIn.settingWasUpdated": "Ustawienia zostały zapisane.",
    "gui.telemetryOptIn.buttonClose": "Zamknij",
    "gui.turboMode.active": "Tryb turbo",
    "gui.webglModal.label": "Twoja przeglądarka nie wspiera WebGL",
    "gui.webglModal.description": "Niestety, wygląda na to, że twoja przeglądarka lub komputer {webGlLink}. Ta technologia jest potrzebna do uruchomienia Scratcha 3.0.",
    "gui.webglModal.webgllink": "nie wspiera WebG",
    "gui.webglModal.back": "Powrót",
    "gui.webglModal.previewfaq": "Aby dowiedzieć się więcej, odwiedź {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Najczęściej zadawane pytania (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "Wybierz tło",
    "gui.costumeLibrary.chooseACostume": "Wybierz kostium",
    "gui.costumeTab.addBackdropFromLibrary": "Wybierz tło",
    "gui.costumeTab.addCostumeFromLibrary": "Wybierz kostium",
    "gui.costumeTab.addBlankCostume": "Maluj",
    "gui.costumeTab.addSurpriseCostume": "Niespodzianka",
    "gui.costumeTab.addFileBackdrop": "Prześlij tło",
    "gui.costumeTab.addFileCostume": "Prześlij kostium",
    "gui.extensionLibrary.chooseAnExtension": "Wybierz rozszerzenie",
    "gui.extensionLibrary.extensionUrl": "Wpisz adres URL rozszerzenia",
    "gui.monitors.importListColumnPrompt": "Która kolumna powinna być użyta (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Rozpoczęcie odtwarzania nie powiodło się",
    "gui.soundLibrary.chooseASound": "Wybierz dźwięk",
    "gui.soundTab.fileUploadSound": "Prześlij dźwięk",
    "gui.soundTab.surpriseSound": "Niespodzianka",
    "gui.soundTab.recordSound": "Nagraj",
    "gui.soundTab.addSoundFromLibrary": "Wybierz dźwięk",
    "gui.spriteLibrary.chooseASprite": "Wybierz duszka",
    "gui.tipsLibrary.tutorials": "Wybierz tutorial",
    "gui.alerts.createsuccess": "Nowy projekt został utworzony.",
    "gui.alerts.createcopysuccess": "Projekt zapisany jako kopia",
    "gui.alerts.createremixsuccess": "Projekt zapisany jako remiks.",
    "gui.alerts.creating": "Trwa tworzenie nowego projektu...",
    "gui.alerts.creatingCopy": "Trwa kopiowanie projektu...",
    "gui.alerts.creatingRemix": "Trwa remiksowanie projektu...",
    "gui.alerts.creatingError": "Nie można stworzyć projektu. Prosimy spróbować ponownie!",
    "gui.alerts.savingError": "Projekt nie mógł zostać zapisany.",
    "gui.alerts.savesuccess": "Projekt zapisany.",
    "gui.alerts.saving": "Zapisywanie projektu...",
    "gui.alerts.cloudInfo": "Pamiętaj, że zmienne w chmurze obsługują jedynie liczby, a nie litery i symbole. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Dowiedz się więcej.",
    "gui.alerts.importing": "Importowanie...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "moja zmienna",
    "gui.howtos.intro-move-sayhello-hat.name": "Wprowadzenie",
    "gui.howtos.intro-move.step_stepMove": "Dodaj blok przesunięcia",
    "gui.howtos.add-a-move-block.step_stepSay": "Dodaj blok 'powiedz'",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Aby zacząć, kliknij zieloną flagę",
    "gui.howtos.intro-getting-started-ASL.name": "Pierwsze Kroki - ASL",
    "gui.howtos.animate-a-name.name": "Animuj imię",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Wybierz duszka będącego literą",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Po kliknięciu zagraj dźwięk",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Wybierz kolejną literę",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Zmień kolor",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Wybierz następną literę i spraw, by się obracała",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Wybierz kolejną literę i spraw, by się powiększyła",
    "gui.howtos.imagine": "Wyobraź sobie świat",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Napisz, co chcesz powiedzieć",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Kliknij zieloną flagę, aby rozpocząć",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Wybierz dowolne tło",
    "gui.howtos.imagine.step_imagineChooseSprite": "Wybierz dowolnego duszka",
    "gui.howtos.imagine.step_imagineFlyAround": "Naciśnij spację, aby lecieć",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Wybierz innego duszka",
    "gui.howtos.imagine.step_imagineLeftRight": "Przesuwaj lewo-prawo",
    "gui.howtos.imagine.step_imagineUpDown": "Przesuwaj góra-dół",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Zmień kostiumy",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Leć do punktu",
    "gui.howtos.imagine.step_imagineGrowShrink": "Rośnij i kurcz się",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Wybierz inne tło",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Zmieniaj tła",
    "gui.howtos.imagine.step_imagineRecordASound": "Dodaj dźwięk",
    "gui.howtos.imagine.step_imagineChooseSound": "Wybierz swój dźwięk",
    "gui.howtos.make-music.name": "Twórz muzykę",
    "gui.howtos.Make-Music.step_PickInstrument": "Wybierz duszka instrumentu",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Po kliknięciu zagraj dźwięk",
    "gui.howtos.Make-Music.step_MakeSong": "Stwórz piosenkę",
    "gui.howtos.make-music.step_MakeBeat": "Wybierz bęben i twórz bit",
    "gui.howtos.make-music.step_MakeBeatBox": "Wybierz duszka mikrofonu i beatbox-niespodziankę",
    "gui.howtos.story.name": "Stwórz historię",
    "gui.howtos.story.step_addbg": "Dodaj Tło",
    "gui.howtos.story.step_addsprite": "Dodaj postać",
    "gui.howtos.story.step_saysomething": "Powiedz coś",
    "gui.howtos.story.step_addanothersprite": "Dodaj inną postać",
    "gui.howtos.story.step_flip": "Kierunek obrotu",
    "gui.howtos.story.step_conversation": "Porozmawiaj",
    "gui.howtos.story.addanotherbg": "Dodaj inne tło",
    "gui.howtos.story.step_swithbg": "Zmieniaj tła",
    "gui.howtos.story.step_hidewizard": "Ukryj postać",
    "gui.howtos.story.step_showwizard": "Pokaż postać",
    "gui.howtos.make-a-chase-game.name": "Zrób grę gonitwę",
    "gui.howtos.Chase-Game.step_BG": "Dodaj Tło",
    "gui.howtos.chase-game.step_AddOcto": "Dodaj duszka",
    "gui.howtos.make-music.step_LeftRight": "Przesuwaj w prawo i w lewo klawiszami strzałek",
    "gui.howtos.Chase-Game.step_UpDown": "Przesuwaj w górę i w dół klawiszami strzałek",
    "gui.howtos.Chase-Game.step_AddStar": "Dodaj duszka",
    "gui.howtos.Chase-Game.step_MoveRandom": "Poruszaj losowo",
    "gui.howtos.Chase-Game.step_WhenTouch": "Przy dotykaniu duszka Ośmiornicy, odtwarzaj dźwięk",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Twórz zmienną wyniku",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "W skrypcie duszka ośmiornicy, kiedy dotyka dodaj wynik",
    "gui.howtos.animate-char.name": "Animuj Postać",
    "gui.howtos.animate-char.step_addbg": "Dodaj Tło",
    "gui.howtos.animate-char.step_addsprite": "Dodaj duszka",
    "gui.howtos.animate-char.step_saysomething": "Powiedz coś",
    "gui.howtos.animate-char.step_addsound": "Dodaj dźwięk",
    "gui.howtos.animate-char.step_animatetalking": "Animuj rozmowę",
    "gui.howtos.animate-char.step_arrowkeys": "Poruszaj za pomocą strzałek",
    "gui.howtos.animate-char.step_jump": "Skacz",
    "gui.howtos.animate-char.step_changecolor": "Zmień kolor",
    "gui.howtos.make-a-game.name": "Zrób grę klikera",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Wybierz duszka",
    "gui.howtos.make-a-game.step_GamePlaySound": "Po kliknięciu zagraj dźwięk",
    "gui.howtos.make-a-game.step_GameAddScore": "Utwórz zmienną wyniku",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kiedy kliknięto, zwiększ wynik",
    "gui.howtos.make-a-game.step_Random": "Przejdź do losowo wybranej pozycji",
    "gui.howtos.make-music.step_GameChangeColor": "Zmień kolor",
    "gui.howtos.make-music.step_ResetScore": "Zresetuj wynik",
    "gui.howtos.make-it-fly.name": "Spraw, aby latał",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Wybierz tło nieba",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Wybierz postać",
    "gui.howtos.fly.step_stepflySaySomething": "Powiedz coś",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Poruszaj strzałkami",
    "gui.howtos.fly.step_stepflyChooseObject": "Wybierz obiekt do zbierania",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Spraw, aby obiekt się poruszał",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Wybierz swoją postać",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Dodaj wynik",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Zapisz wynik",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Dodaj scenerię",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Poruszaj scenerią",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Następny kostium",
    "gui.howtos.pong": "Odbijanie piłeczki",
    "gui.howtos.pong.step_pongAddBackdrop": "Dodaj Tło",
    "gui.howtos.pong.step_pongAddBallSprite": "Dodaj duszka - piłkę",
    "gui.howtos.pong.step_pongBounceAround": "Odbijanie się",
    "gui.howtos.pong.step_pongAddPaddle": "Dodaj paletkę",
    "gui.howtos.pong.step_pongMoveThePaddle": "Poruszaj paletką",
    "gui.howtos.pong.step_pongSelectBallSprite": "Wybierz duszka - piłkę",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Dodaj kod, aby odbijać piłkę paletką",
    "gui.howtos.pong.step_pongAddAScore": "Dodaj wynik",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Wybierz \"Wynik\" z menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Wstaw klocek „zmień Wynik”",
    "gui.howtos.pong.step_pongResetScore": "Zresetuj wynik",
    "gui.howtos.pong.step_pongAddLineSprite": "Dodaj duszka linii",
    "gui.howtos.pong.step_pongGameOver": "Koniec gry",
    "gui.howtos.code-cartoon": "Zakoduj kreskówkę",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Powiedz coś po kliknięciu zielonej flagi",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animuj postać po kliknięciu jej",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Wybierz inną postać",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Użyj minusa by zmniejszać",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Spraw, by postać rosła i kurczyła się",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Wybierz inną postać",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Skacz w górę i w dół",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Kliknij postać aby zmieniać sceny",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Leć dookoła",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Zmieniaj kostiumy",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Wybierz więcej postaci do Twojej kreskówki",
    "gui.howtos.cartoon-network": "Animuj Grę Przygodową",
    "gui.howtos.cartoon-network.step_CNcharacter": "Wybierz postać do pokazania",
    "gui.howtos.cartoon-network.step_CNsay": "Powiedz coś",
    "gui.howtos.cartoon-network.step_CNglide": "Leć dookoła",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Wybierz obiekt do śledzenia",
    "gui.howtos.cartoon-network.step_CNcollect": "Zbieraj obiekty",
    "gui.howtos.cartoon-network.step_CNvariable": "Utwórz zmienną wyniku",
    "gui.howtos.cartoon-network.step_CNscore": "Zapisz wynik",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Poziom Wyżej: Zmień Tło",
    "gui.howtos.videosens.name": "Czujniki wideo",
    "gui.howtos.videosens.step_addextension": "Dodaj rozszerzenie",
    "gui.howtos.videosens.step_pet": "Pogłaszcz kota",
    "gui.howtos.videosens.step_animate": "Animuj",
    "gui.howtos.videosens.step_pop": "Przebij balon",
    "gui.howtos.say-it-out-loud": "Twórz animacje, które mówią",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Dodaj bloki zmiany tekstu na mowę",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Powiedz coś",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Ustaw głos",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Poruszać się",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Dodaj Tło",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Dodaj inną postać",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Wykonaj utwór",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Zmień kolor",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Zakręć do okoła",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Rosnąć i kurczyć się",
    "gui.howtos.talking": "Opowiadanie opowieści",
    "gui.howtos.talking.step_talesAddExtension": "Kliknij, aby dodać bloki zamiany tekstu na mowę",
    "gui.howtos.talking.step_talesChooseSprite": "Wybierz duszka",
    "gui.howtos.talking.step_talesSaySomething": "Spraw, by postać przemówiła",
    "gui.howtos.talking.step_talesChooseBackdrop": "Wybierz tło",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Kliknij postać aby przejść do następnego tła",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Wybierz innego duszka",
    "gui.howtos.talking.step_talesMoveAround": "Poruszaj się",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Wybierz inne tło",
    "gui.howtos.talking.step_talesAnimateTalking": "Animuj rozmowę",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Wybierz inne tło",
    "gui.howtos.talking.step_talesChooseSound": "Wybierz utwór do zatańczenia",
    "gui.howtos.talking.step_talesDanceMoves": "Ruchy taneczne",
    "gui.howtos.talking.step_talesAskAnswer": "Wybierz bloki pytania i odpowiedzi z kategorii \"Czujniki\"",
    "gui.howtos.add-sprite.name": "Dodaj duszka",
    "gui.howtos.add-sprite.step_addSprite": "Dodaj duszka",
    "gui.howtos.add-a-backdrop.name": "Dodaj Tło",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Dodaj Tło",
    "gui.howtos.change-size.name": "Zmień rozmiar",
    "gui.howtos.change-size.step_changeSize": "Zmień rozmiar",
    "gui.howtos.glide-around.name": "Ślizgaj się wokół",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Leć dookoła",
    "gui.howtos.change-size.step_glideAroundPoint": "Leć do punktu",
    "gui.howtos.record-a-sound.name": "Nagraj dźwięk",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Kliknij zakładkę „Dźwięki”",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Kliknij \"Nagraj\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Naciśnij przycisk nagrywania",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Wybierz swój dźwięk",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Zagraj swój dźwięk",
    "gui.howtos.spin-video.name": "Spraw, aby to się kręciło",
    "gui.howtos.change-size.step_spinTurn": "Obróć",
    "gui.howtos.change-size.step_spinPointInDirection": "Ustaw kierunek",
    "gui.howtos.hide-and-show.name": "Ukryj i pokaż",
    "gui.howtos.change-size.step_hideAndShow": "Ukryj i pokaż",
    "gui.howtos.switch-costume.name": "Animuj duszka",
    "gui.howtos.change-size.step_switchCostumes": "Animuj duszka",
    "gui.howtos.move-around-with-arrow-keys.name": "Użyj strzałek",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Poruszaj w lewo i w prawo",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Poruszaj w górę i w dół",
    "gui.howtos.add-effects.name": "Dodaj efekty",
    "gui.howtos.videosens.step_addEffects": "Dodaj efekty",
    "gui.extension.music.name": "Muzyka",
    "gui.extension.music.description": "Graj na instrumentach i bębnach.",
    "gui.extension.pen.name": "Pisak",
    "gui.extension.pen.description": "Narysuj za pomocą swoich duszków",
    "gui.extension.videosensing.name": "Czujniki wideo",
    "gui.extension.videosensing.description": "Wykrywa ruch dzięki kamerze.",
    "gui.extension.text2speech.name": "Tekst na Mowę",
    "gui.extension.text2speech.description": "Spraw by twoje projekty mówiły",
    "gui.extension.translate.name": "Tłumacz",
    "gui.extension.translate.description": "Tłumacz tekst na wiele języków.",
    "gui.extension.makeymakey.description": "Zamień wszystko w klawisz.",
    "gui.extension.microbit.description": "Podziel się projektami ze światem.",
    "gui.extension.microbit.connectingMessage": "Łączenie",
    "gui.extension.ev3.description": "Buduj interaktywne roboty i inne rzeczy.",
    "gui.extension.ev3.connectingMessage": "Łączenie. Upewnij się, że PIN na twoim EV3 ustawiony jest na 1234.",
    "gui.extension.boost.description": "Ożyw robota.",
    "gui.extension.boost.connectingMessage": "Łączenie",
    "gui.extension.wedo2.description": "Buduj za pomocą silników i czujników.",
    "gui.extension.wedo2.connectingMessage": "Łączenie",
    "gui.extension.gdxfor.description": "Wykrywaj naciskanie, ciągnięcie, ruch i obrót.",
    "gui.extension.gdxfor.connectingMessage": "Łączenie",
    "gui.libraryTags.all": "Wszystko",
    "gui.libraryTags.animals": "Zwierzęta",
    "gui.libraryTags.dance": "Taniec",
    "gui.libraryTags.effects": "Efekty",
    "gui.libraryTags.fantasy": "Fikcja",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Jedzenie",
    "gui.libraryTags.indoors": "W pomieszczeniu",
    "gui.libraryTags.loops": "Pętle",
    "gui.libraryTags.music": "Muzyka",
    "gui.libraryTags.notes": "Notatki",
    "gui.libraryTags.outdoors": "Na zewnątrz",
    "gui.libraryTags.patterns": "Wzory",
    "gui.libraryTags.people": "Ludzie",
    "gui.libraryTags.percussion": "Perkusja",
    "gui.libraryTags.space": "Kosmos",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Pod wodą",
    "gui.libraryTags.voice": "Głos",
    "gui.libraryTags.wacky": "Zwariowany",
    "gui.libraryTags.animation": "Animacja",
    "gui.libraryTags.art": "Sztuka",
    "gui.libraryTags.games": "Gry",
    "gui.libraryTags.stories": "Opowiadania",
    "gui.libraryTags.letters": "Litery",
    "gui.opcodeLabels.direction": "Kierunek",
    "gui.opcodeLabels.xposition": "Pozycja x",
    "gui.opcodeLabels.yposition": "Pozycja y",
    "gui.opcodeLabels.size": "rozmiar",
    "gui.opcodeLabels.costumename": "Nazwa kostiumu",
    "gui.opcodeLabels.costumenumber": "numer kostiumu",
    "gui.opcodeLabels.backdropname": "Tło: nazwa",
    "gui.opcodeLabels.backdropnumber": "numer tła",
    "gui.opcodeLabels.volume": "Głośność",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "Odpowiedź",
    "gui.opcodeLabels.loudness": "Głośność",
    "gui.opcodeLabels.username": "Nazwa użytkownika",
    "gui.opcodeLabels.year": "Rok",
    "gui.opcodeLabels.month": "Miesiąc",
    "gui.opcodeLabels.date": "Data",
    "gui.opcodeLabels.dayofweek": "Dzień tygodnia",
    "gui.opcodeLabels.hour": "Godzina",
    "gui.opcodeLabels.minute": "Minuta",
    "gui.opcodeLabels.second": "Sekunda",
    "gui.opcodeLabels.timer": "Stoper",
    "gui.projectLoader.loadError": "Wybrany plik projektu nie mógł zostać załadowany.",
    "gui.sharedMessages.backdrop": "tło{index}",
    "gui.sharedMessages.costume": "kostium{index}",
    "gui.sharedMessages.sprite": "Duszek{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Czy zastąpić zawartość bieżącego projektu?",
    "gui.sharedMessages.loadFromComputerTitle": "Wczytaj ze swojego komputera",
    "gui.theme.default": "Oryginalny",
    "gui.theme.dark": "Ciemny",
    "gui.theme.highContrast": "Wysoki Kontrast",
    "gui.gui.defaultProjectTitle": "Projekt Scratch",
    "boost.color.any": "dowolny kolor",
    "boost.color.black": "czarny",
    "boost.color.blue": "niebieski",
    "boost.color.green": "zielony",
    "boost.color.red": "czerwony",
    "boost.color.white": "biały",
    "boost.color.yellow": "żółty",
    "boost.getMotorPosition": "pozycja silnika [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "Kąt pochylenia [TILT_DIRECTION]",
    "boost.motorDirection.backward": "w tamten sposób",
    "boost.motorDirection.forward": "w ten sposób",
    "boost.motorDirection.reverse": "odwróć",
    "boost.motorOff": "wyłącz silnik [MOTOR_ID]",
    "boost.motorOn": "włącz silnik [MOTOR_ID]",
    "boost.motorOnFor": "włącz silnik [MOTOR_ID] na [DURATION] sekund",
    "boost.motorOnForRotation": "włącz silnik [MOTOR_ID] na [ROTATION] obrotów",
    "boost.seeingColor": "widzi [COLOR] klocek?",
    "boost.setLightHue": "Ustaw kolor światła na [HUE]",
    "boost.setMotorDirection": "ustaw kierunek obrotu silnika [MOTOR_ID] na [MOTOR_DIRECTION]",
    "boost.setMotorPower": "ustaw moc silnika [MOTOR_ID] na [POWER] %",
    "boost.tiltDirection.any": "dowolnie",
    "boost.tiltDirection.down": "w dół",
    "boost.tiltDirection.left": "w lewo",
    "boost.tiltDirection.right": "w prawo",
    "boost.tiltDirection.up": "w górę",
    "boost.whenColor": "kiedy widzi [COLOR] klocek",
    "boost.whenTilted": "Gdy pochylony [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "graj nutę [NOTE] przez [TIME] sekund",
    "ev3.buttonPressed": "Klawisz [PORT] naciśnięty?",
    "ev3.getBrightness": "jasność",
    "ev3.getDistance": "odległość",
    "ev3.getMotorPosition": "pozycja silnika [PORT]",
    "ev3.motorSetPower": "ustaw moc silnika [PORT] na [POWER] %",
    "ev3.motorTurnClockwise": "Obróć silnik [PORT] do ruchu wskazówek zegara na [TIME] sekund",
    "ev3.motorTurnCounterClockwise": "obracaj silnik [PORT] w tę stronę przez [TIME] sekund",
    "ev3.whenBrightnessLessThan": "Gdy jasność < [DISTANCE]",
    "ev3.whenButtonPressed": "Gdy klawisz [PORT] naciśnięty",
    "ev3.whenDistanceLessThan": "Gdy odległość < [DISTANCE]",
    "gdxfor.getAcceleration": "przyśpieszenie [DIRECTION]",
    "gdxfor.getForce": "siła",
    "gdxfor.getSpin": "prędkość wirowania [DIRECTION]",
    "gdxfor.getTilt": "kąt nachylenia [TILT]",
    "gdxfor.isFreeFalling": "spada?",
    "gdxfor.isTilted": "nachylony [TILT]?",
    "gdxfor.pulled": "pociągnięty",
    "gdxfor.pushed": "wciśnięty",
    "gdxfor.shaken": "potrząśnięty",
    "gdxfor.startedFalling": "zaczęło spadać",
    "gdxfor.tiltDirectionMenu.any": "dowolny",
    "gdxfor.tiltDirectionMenu.back": "na spód",
    "gdxfor.tiltDirectionMenu.front": "na wierzch",
    "gdxfor.tiltDirectionMenu.left": "lewo",
    "gdxfor.tiltDirectionMenu.right": "prawo",
    "gdxfor.turnedFaceDown": "odwrócony w dół",
    "gdxfor.turnedFaceUp": "odwrócony do góry",
    "gdxfor.whenForcePushedOrPulled": "kiedy czujnik siły [PUSH_PULL]",
    "gdxfor.whenGesture": "kiedy [GESTURE]",
    "gdxfor.whenTilted": "kiedy nachylony [TILT]",
    "makeymakey.downArrow": "strzałka w dół",
    "makeymakey.downArrowShort": "dół",
    "makeymakey.leftArrow": "strzałka w lewo",
    "makeymakey.leftArrowShort": "lewo",
    "makeymakey.rightArrow": "strzałka w prawo",
    "makeymakey.rightArrowShort": "prawo",
    "makeymakey.spaceKey": "spacja",
    "makeymakey.upArrow": "strzałka w górę",
    "makeymakey.upArrowShort": "góra",
    "makeymakey.whenKeyPressed": "kiedy naciśnięto klawisz [KEY]",
    "makeymakey.whenKeysPressedInOrder": "kiedy naciśnięto kolejno [SEQUENCE]",
    "microbit.buttonsMenu.any": "Dowolny",
    "microbit.clearDisplay": "wyczyść wyświetlacz",
    "microbit.defaultTextToDisplay": "Cześć!",
    "microbit.displaySymbol": "wyświetl [MATRIX]",
    "microbit.displayText": "wyświetl tekst [TEXT]",
    "microbit.gesturesMenu.jumped": "podrzucony",
    "microbit.gesturesMenu.moved": "poruszony",
    "microbit.gesturesMenu.shaken": "potrząśnięty",
    "microbit.isButtonPressed": "[BTN] przycisk naciśnięty?",
    "microbit.isTilted": "nachylony [DIRECTION]",
    "microbit.pinStateMenu.off": "wyłączony",
    "microbit.pinStateMenu.on": "włączony",
    "microbit.tiltAngle": "kąt nachylenia [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "Dowolny",
    "microbit.tiltDirectionMenu.back": "do tyłu",
    "microbit.tiltDirectionMenu.front": "do przodu",
    "microbit.tiltDirectionMenu.left": "w lewo",
    "microbit.tiltDirectionMenu.right": "w prawo",
    "microbit.whenButtonPressed": "Gdy [BTN]naciśnięty",
    "microbit.whenGesture": "kiedy [GESTURE]",
    "microbit.whenPinConnected": "kiedy pin[PIN]połączony",
    "microbit.whenTilted": "gdy nachylony[DIRECTION]",
    "music.categoryName": "Muzyka",
    "music.changeTempo": "zmień tempo na [TEMPO]",
    "music.drumBass": "(2) Bęben basowy",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Klawesy",
    "music.drumClosedHiHat": "(6) Zamknięty hi-hat",
    "music.drumConga": "(14) bęben Konga",
    "music.drumCowbell": "(11) Krowi dzwonek",
    "music.drumCrashCymbal": "(4) talerz uderzany pałeczką",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Klaśnięcie",
    "music.drumOpenHiHat": "(5) Otwarty hi-hat",
    "music.drumSideStick": "(3) Uderzenie o obręcz",
    "music.drumSnare": "(1) Werbel",
    "music.drumTambourine": "(7) Tamburyn",
    "music.drumTriangle": "(12) Trójkąt",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Drewniany klocek",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Wiolonczela",
    "music.instrumentChoir": "(15) Chór",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Gitara elektryczna",
    "music.instrumentElectricPiano": "(2) Pianino elektroniczne ",
    "music.instrumentFlute": "(12) Flet",
    "music.instrumentGuitar": "(4) Gitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Pozytywka",
    "music.instrumentOrgan": "(3) Organy",
    "music.instrumentPiano": "(1) Pianino",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Stalowy bęben",
    "music.instrumentSynthLead": "(26) Wiodący dźwięk syntezatora",
    "music.instrumentSynthPad": "(21) Pad syntezatora",
    "music.instrumentTrombone": "(9) Puzon",
    "music.instrumentVibraphone": "(16) Wibrafon",
    "music.instrumentWoodenFlute": "(13) Drewniany flet",
    "music.midiPlayDrumForBeats": "graj na [DRUM] przez [BEATS] taktów",
    "music.midiSetInstrument": "ustaw instrument na [INSTRUMENT]",
    "music.playDrumForBeats": "graj na [DRUM] przez [BEATS] taktów",
    "music.playNoteForBeats": "zagraj nutę [NOTE] przez [BEATS] taktów",
    "music.restForBeats": "pauzuj przez [BEATS] taktów",
    "music.setInstrument": "ustaw instrument na [INSTRUMENT]",
    "music.setTempo": "ustaw tempo na [TEMPO]",
    "pen.categoryName": "Pisak",
    "pen.changeColorParam": "Zmień [COLOR_PARAM]pisaka o[VALUE]",
    "pen.changeHue": "Zmień kolor pisaka o [HUE]",
    "pen.changeShade": "Zmień odcień pisaka o [SHADE]",
    "pen.changeSize": "Zmień rozmiar pisaka o [SIZE]",
    "pen.clear": "wyczyść wszystko ",
    "pen.colorMenu.brightness": "Jasność",
    "pen.colorMenu.color": "Kolor",
    "pen.colorMenu.saturation": "nasycenie",
    "pen.colorMenu.transparency": "przezroczystość",
    "pen.penDown": "Przyłóż pisak",
    "pen.penUp": "Podnieś pisak ",
    "pen.setColor": "Ustaw kolor pisaka na [COLOR]",
    "pen.setColorParam": "Ustaw [COLOR_PARAM]pisaka na [VALUE]",
    "pen.setHue": "Ustaw kolor pisaka na [HUE]",
    "pen.setShade": "Ustaw odcień pisaka na [SHADE]",
    "pen.setSize": "Ustaw rozmiar pisaka na [SIZE]",
    "pen.stamp": "Stempluj",
    "speech.defaultWhenIHearValue": "chodźmy",
    "speech.extensionName": "Mowa na tekst",
    "speech.listenAndWait": "posłuchaj i czekaj",
    "speech.speechReporter": "mowa",
    "speech.whenIHear": "kiedy wykryję dźwięk [PHRASE]",
    "text2speech.alto": "kobiecy",
    "text2speech.categoryName": "Tekst na Mowę",
    "text2speech.defaultTextToSpeak": "cześć",
    "text2speech.giant": "zmodyfikowany",
    "text2speech.kitten": "kociątko",
    "text2speech.setLanguageBlock": "ustaw język na [LANGUAGE]",
    "text2speech.setVoiceBlock": "Ustaw głos na [VOICE]",
    "text2speech.speakAndWaitBlock": "Powiedz [WORDS]",
    "text2speech.squeak": "dziecięcy",
    "text2speech.tenor": "męski",
    "translate.categoryName": "Tłumacz",
    "translate.defaultTextToTranslate": "cześć",
    "translate.translateBlock": "tłumacz [WORDS] na [LANGUAGE]",
    "translate.viewerLanguage": "język",
    "videoSensing.categoryName": "Czujniki wideo",
    "videoSensing.direction": "Kierunek",
    "videoSensing.motion": "ruch",
    "videoSensing.off": "wyłączony",
    "videoSensing.on": "włączony",
    "videoSensing.onFlipped": "na odwróconym",
    "videoSensing.setVideoTransparency": "ustaw transparentność wideo na [TRANSPARENCY]",
    "videoSensing.sprite": "duszek",
    "videoSensing.stage": "scena",
    "videoSensing.videoOn": "nagranie wideo [ATTRIBUTE] na [SUBJECT]",
    "videoSensing.videoToggle": " [VIDEO_STATE] nagranie wideo ",
    "videoSensing.whenMotionGreaterThan": "kiedy ruch wideo > [REFERENCE]",
    "wedo2.getDistance": "odległość",
    "wedo2.getTiltAngle": "Kąt pochylenia [TILT_DIRECTION]",
    "wedo2.isTilted": "Pochylony [TILT_DIRECTION_ANY]",
    "wedo2.motorDirection.backward": "w tamten sposób",
    "wedo2.motorDirection.forward": "w ten sposób",
    "wedo2.motorDirection.reverse": "odwróć",
    "wedo2.motorId.a": "silnik A",
    "wedo2.motorId.all": "wszystkie silniki",
    "wedo2.motorId.b": "silnik B",
    "wedo2.motorId.default": "silnik",
    "wedo2.motorOff": "Wyłącz silnik [MOTOR_ID]",
    "wedo2.motorOn": "Włącz silnik [MOTOR_ID]",
    "wedo2.motorOnFor": "Włącz silnik [MOTOR_ID] na [DURATION] sekund",
    "wedo2.playNoteFor": "Graj nutę [NOTE] przez [DURATION] sekund",
    "wedo2.setLightHue": "Ustaw kolor światła na [HUE]",
    "wedo2.setMotorDirection": "Ustaw kierunek silnika [MOTOR_ID] na [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "Ustaw moc silnika [MOTOR_ID] na [POWER]",
    "wedo2.tiltDirection.any": "Dowolny",
    "wedo2.tiltDirection.down": "dół",
    "wedo2.tiltDirection.left": "lewo",
    "wedo2.tiltDirection.right": "prawo",
    "wedo2.tiltDirection.up": "góra",
    "wedo2.whenDistance": "Gdy dystans [OP] [REFERENCE]",
    "wedo2.whenTilted": "Gdy pochylony [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kolor",
    "paint.paintEditor.saturation": "Nasycenie",
    "paint.paintEditor.brightness": "Jasność",
    "paint.paintEditor.costume": "Kostium",
    "paint.paintEditor.group": "Grupuj",
    "paint.paintEditor.ungroup": "Rozgrupuj",
    "paint.paintEditor.undo": "Cofnij",
    "paint.paintEditor.redo": "Ponów",
    "paint.paintEditor.forward": "Do przodu",
    "paint.paintEditor.backward": "Do tyłu",
    "paint.paintEditor.front": "Przód",
    "paint.paintEditor.back": "Powrót",
    "paint.paintEditor.more": "Więcej",
    "paint.modeTools.brushSize": "Rozmiar",
    "paint.modeTools.eraserSize": "Wielkość gumki",
    "paint.modeTools.copy": "Kopiuj",
    "paint.modeTools.paste": "Wklej",
    "paint.modeTools.delete": "Usuń",
    "paint.modeTools.curved": "Zakrzywiony",
    "paint.modeTools.pointed": "Wskazany",
    "paint.modeTools.thickness": "Grubość",
    "paint.modeTools.flipHorizontal": "Odwróć w płaszczyźnie poziomej",
    "paint.modeTools.flipVertical": "Odwróć w płaszczyźnie pionowej",
    "paint.modeTools.filled": "Wypełniony",
    "paint.modeTools.outlined": "Kontur",
    "paint.paintEditor.bitmap": "Przekształć w bitmapę",
    "paint.paintEditor.vector": "Konwertuj na wektor",
    "paint.paintEditor.fill": "Wypełnij",
    "paint.paintEditor.stroke": "Zarys",
    "paint.brushMode.brush": "Pędzel",
    "paint.eraserMode.eraser": "Gumka",
    "paint.fillMode.fill": "Wypełnij",
    "paint.lineMode.line": "Linia",
    "paint.ovalMode.oval": "Okrąg",
    "paint.rectMode.rect": "Prostokąt",
    "paint.reshapeMode.reshape": "Przekształć",
    "paint.roundedRectMode.roundedRect": "Zaokrąglony prostokąt",
    "paint.selectMode.select": "Wybierz",
    "paint.textMode.text": "Tekst",
    "paint.colorPicker.swap": "Zamień"
  },
  "pt": {
    "gui.alerts.lostPeripheralConnection": "O Scratch perdeu a ligação a {extensionName}.",
    "gui.alerts.tryAgain": "Tentar de Novo",
    "gui.alerts.download": "Descarregar",
    "gui.connection.reconnect": "Voltar a Ligar",
    "gui.backpack.costumeLabel": "traje",
    "gui.backpack.soundLabel": "som",
    "gui.backpack.scriptLabel": "guião",
    "gui.backpack.spriteLabel": "actor",
    "gui.backpack.header": "Mochila",
    "gui.backpack.errorBackpack": "Erro ao carregar a mochila",
    "gui.backpack.loadingBackpack": "Carregando…",
    "gui.backpack.more": "Mais",
    "gui.backpack.emptyBackpack": "A mochila está vazia",
    "gui.unsupportedBrowser.label": "O navegador não é suportado",
    "gui.unsupportedBrowser.errorLabel": "Ocorreu um Erro",
    "gui.unsupportedBrowser.notRecommended": "Pedimos desculpa, mas parece que está a utilizar uma versão de navegador não suportada pelo Scratch. Recomendamos a actualização para a versão mais recente de um navegador suportado, tal como o Google Chrome, o Mozilla Firefox, o Microsoft Edge ou o Safari.",
    "gui.unsupportedBrowser.description": "Pedimos desculpa, mas o Scratch não suporta este navegador. Recomendamos a actualização para a versão mais recente de um navegador suportado, tal como o Google Chrome, o Mozilla Firefox, o Microsoft Edge ou o Safari.",
    "gui.unsupportedBrowser.back": "Voltar",
    "gui.unsupportedBrowser.previewfaq": "Para saber mais, vá a {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "PF",
    "gui.cards.all-tutorials": "Tutoriais",
    "gui.cards.shrink": "Reduzir",
    "gui.cards.expand": "Expandir",
    "gui.cards.close": "Fechar",
    "gui.cards.more-things-to-try": "Mais coisas a experimentar!",
    "gui.cards.see-more": "Ver mais",
    "gui.comingSoon.message1": "Não se preocupe, estamos a trabalhar afincadamente nisto {emoji}",
    "gui.comingSoon.message2": "Em Breve...",
    "gui.comingSoon.message3": "Estamos a trabalhar afincadamente nisto {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Não foram encontrados dispositivos",
    "gui.connection.auto-scanning.prescan": "Mantenha o seu dispositivo por perto, depois comece uma procura.",
    "gui.connection.auto-scanning.pressbutton": "Pressione o botão no seu dispositivo.",
    "gui.connection.auto-scanning.start-search": "Começar Procura",
    "gui.connection.connecting-searchbutton": "Procurando…",
    "gui.connection.auto-scanning.try-again": "Tentar de novo",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Ligado",
    "gui.connection.disconnect": "Desligar",
    "gui.connection.go-to-editor": "Ir para o Editor",
    "gui.connection.connecting-cancelbutton": "Ligando…",
    "gui.connection.error.errorMessage": "Ops, parece que algo correu mal.",
    "gui.connection.error.tryagainbutton": "Tentar de novo",
    "gui.connection.error.helpbutton": "Ajuda",
    "gui.connection.peripheral-name-label": "Nome do dispositivo",
    "gui.connection.connect": "Ligar",
    "gui.connection.scanning.lookingforperipherals": "Procurando dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "Não foram encontrados dispositivos",
    "gui.connection.scanning.instructions": "Seleccione o seu dispositivo na lista abaixo.",
    "gui.connection.search": "Refrescar",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Assegure-se de que tem o Scratch Link instalado e em execução",
    "gui.connection.unavailable.enablebluetooth": "Verifique se o Bluetooth está activo",
    "gui.connection.unavailable.tryagainbutton": "Tentar de novo",
    "gui.connection.unavailable.helpbutton": "Ajuda",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Começar",
    "gui.controls.stop": "Parar",
    "gui.crashMessage.label": "Oh lá! Algo correu mal.",
    "gui.crashMessage.description": "Lamentamos, mas aparentemente o Scratch parou. Este erro foi reportado automaticamente à Equipa Scratch. Por favor refresque a sua página para tentar de novo.",
    "gui.crashMessage.errorNumber": "O seu erro foi registado com o identificador {errorId}",
    "gui.crashMessage.reload": "Recarregar",
    "gui.customProcedures.myblockModalTitle": "Criar um Bloco",
    "gui.customProcedures.addAnInputNumberText": "Adicionar uma entrada",
    "gui.customProcedures.numberTextType": "numérica ou textual",
    "gui.customProcedures.addAnInputBoolean": "Adicionar uma entrada",
    "gui.customProcedures.booleanType": "booleana",
    "gui.customProcedures.addALabel": "Adicionar uma etiqueta",
    "gui.customProcedures.runWithoutScreenRefresh": "Executar sem actualizar o ecrã",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direcção",
    "gui.directionPicker.rotationStyles.allAround": "Girar a Toda a Volta",
    "gui.directionPicker.rotationStyles.leftRight": "Olhar apenas para a esquerda e para a direita",
    "gui.directionPicker.rotationStyles.dontRotate": "Não rodar",
    "gui.gui.addExtension": "Adicionar Extensão",
    "gui.gui.codeTab": "Código",
    "gui.gui.backdropsTab": "Cenários",
    "gui.gui.costumesTab": "Trajes",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Em Breve",
    "gui.extensionLibrary.requires": "Requere",
    "gui.extensionLibrary.collaboration": "Colaboração com",
    "gui.library.filterPlaceholder": "Procurar",
    "gui.library.allTag": "Tudo",
    "gui.loader.message1": "A criar blocos …",
    "gui.loader.message2": "A carregar os actores …",
    "gui.loader.message3": "A carregar os sons …",
    "gui.loader.message4": "A carregar extensões …",
    "gui.loader.message5": "A apascentar gatos …",
    "gui.loader.message6": "A transmitir nanos …",
    "gui.loader.message7": "A soprar balões …",
    "gui.loader.message8": "A preparar emojis …",
    "gui.loader.headline": "A Carregar o Projecto",
    "gui.loader.creating": "Criando Projecto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "As Minhas Coisas",
    "gui.accountMenu.myClasses": "As Minhas Turmas",
    "gui.accountMenu.myClass": "A Minha Turma",
    "gui.accountMenu.accountSettings": "Configurações da conta",
    "gui.accountMenu.signOut": "Sair",
    "gui.authorInfo.byUser": "por {username}",
    "gui.menuBar.seeProjectPage": "Ver Página do Projecto",
    "gui.menuBar.language": "Language",
    "general.username": "Nome de utilizador",
    "general.password": "Palavra-passe",
    "general.signIn": "Entrar",
    "login.needHelp": "Precisa de Ajuda?",
    "form.validationRequired": "Este campo é obrigatório",
    "gui.menuBar.tutorialsLibrary": "Tutoriais",
    "gui.menuBar.restoreSprite": "Recuperar Actor",
    "gui.menuBar.restoreSound": "Recuperar Som",
    "gui.menuBar.restoreCostume": "Recuperar Traje",
    "gui.menuBar.restore": "Recuperar",
    "gui.menuBar.saveNow": "Guardar agora",
    "gui.menuBar.saveAsCopy": "Guardar como cópia",
    "gui.menuBar.remix": "Remisturar",
    "gui.menuBar.new": "Novo",
    "gui.menuBar.file": "Arquivo",
    "gui.menuBar.downloadToComputer": "Descarregar para o seu computador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desligar o Modo Turbo",
    "gui.menuBar.turboModeOn": "Ligar o Modo Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Aderir ao Scratch",
    "gui.menuBar.signIn": "Entrar",
    "gui.gui.projectTitlePlaceholder": "Introduza aqui o título do projecto",
    "gui.menuBar.saveNowLink": "Guardar Agora",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Partilhado",
    "gui.menuBar.share": "Partilhar",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ajuda",
    "gui.modal.back": "Voltar",
    "gui.monitor.listMonitor.empty": "(vazia)",
    "gui.monitor.listMonitor.listLength": "comprimento {length}",
    "gui.monitor.contextMenu.default": "visor normal",
    "gui.monitor.contextMenu.large": "visor grande",
    "gui.monitor.contextMenu.slider": "deslizador",
    "gui.monitor.contextMenu.sliderRange": "alterar gama de valores do deslizador",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Tocar",
    "gui.playButton.stop": "Parar",
    "gui.gui.variableScopeOptionAllSprites": "Para todos os actores",
    "gui.gui.variableScopeOptionSpriteOnly": "Apenas para este actor",
    "gui.gui.cloudVariableOption": "Variável de nuvem (guardada em servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variável estará disponível para todos os actores.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Parar",
    "gui.playbackStep.playMsg": "Tocar",
    "gui.playbackStep.loadingMsg": "Carregando…",
    "gui.playbackStep.saveMsg": "Guardar",
    "gui.playbackStep.reRecordMsg": "Voltar a Gravar",
    "gui.recordModal.title": "Gravar Som",
    "gui.recordingStep.beginRecord": "Começar a gravar clicando no botão abaixo",
    "gui.recordingStep.permission": "{arrow}Precisamos da sua permissão para usar o seu microfone",
    "gui.recordingStep.stop": "Parar a gravação",
    "gui.recordingStep.record": "Gravar",
    "gui.sliderModal.min": "Valor mínimo",
    "gui.sliderModal.max": "Valor máximo",
    "gui.sliderModal.title": "Alterar gama de valores do deslizador",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Som",
    "gui.soundEditor.play": "Tocar",
    "gui.soundEditor.stop": "Parar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Colar",
    "gui.soundEditor.copyToNew": "Copiar para Novo",
    "gui.soundEditor.delete": "Remover",
    "gui.soundEditor.save": "Guardar",
    "gui.soundEditor.undo": "Desfazer",
    "gui.soundEditor.redo": "Refazer",
    "gui.soundEditor.faster": "Acelerar",
    "gui.soundEditor.slower": "Retardar",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robô",
    "gui.soundEditor.louder": "Maior Volume",
    "gui.soundEditor.softer": "Menor Volume",
    "gui.soundEditor.reverse": "Inverter",
    "gui.soundEditor.fadeOut": "Desaparecer gradualmente",
    "gui.soundEditor.fadeIn": "Aparecer gradualmente",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nome",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Actor",
    "gui.SpriteInfo.show": "Mostrar",
    "gui.SpriteInfo.size": "Tamanho",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "remover",
    "gui.spriteSelector.addSpriteFromLibrary": "Escolher um Actor",
    "gui.spriteSelector.addSpriteFromPaint": "Pintar",
    "gui.spriteSelector.addSpriteFromSurprise": "Surpresa",
    "gui.spriteSelector.addSpriteFromFile": "Carregar Actor",
    "gui.stageHeader.stageSizeLarge": "Mudar para um palco grande",
    "gui.stageHeader.stageSizeSmall": "Mudar para palco pequeno",
    "gui.stageHeader.stageSizeFull": "Iniciar modo de ecrã completo",
    "gui.stageHeader.stageSizeUnFull": "Sair do modo de ecrã completo",
    "gui.stageHeader.fullscreenControl": "Controlo de Ecrã Completo",
    "gui.spriteSelector.addBackdropFromLibrary": "Escolher um Cenário",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Surpresa",
    "gui.stageSelector.addBackdropFromFile": "Carregar Cenário",
    "gui.stageSelector.stage": "Palco",
    "gui.stageSelector.backdrops": "Cenários",
    "gui.telemetryOptIn.label": "Reportar estatísticas para melhorar o Scratch",
    "gui.telemetryOptIn.body1": "A Equipa Scratch está sempre a tentar compreender melhor como o Scratch é usado em todo o mundo. Para ajudar a apoiar este esforço, pode permitir que o Scratch envie automaticamente informação de uso para a Equipa Scratch.",
    "gui.telemetryOptIn.body2": "A informação que recolhemos inclui a selecção da língua, a utilização dos blocos e alguns eventos tais como guardar, abrir e carregar um projecto. NÃO recolhemos nenhuma informação pessoal. Por favor veja as nossas {privacyPolicyLink} para mais informações.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de Privacidade",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "O Seu Navegador Não Suporta WebGL",
    "gui.webglModal.description": "Aparentemente o seu navegador ou computador {webGlLink}. Esta tecnologia é necessária para que o Scratch 3.0 funcione.",
    "gui.webglModal.webgllink": "não suporta WebGL",
    "gui.webglModal.back": "Voltar",
    "gui.webglModal.previewfaq": "Para saber mais, vá a {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "PF",
    "gui.costumeLibrary.chooseABackdrop": "Escolher um Cenário",
    "gui.costumeLibrary.chooseACostume": "Escolher um Traje",
    "gui.costumeTab.addBackdropFromLibrary": "Escolher um Cenário",
    "gui.costumeTab.addCostumeFromLibrary": "Escolher um Traje",
    "gui.costumeTab.addBlankCostume": "Pintar",
    "gui.costumeTab.addSurpriseCostume": "Surpresa",
    "gui.costumeTab.addFileBackdrop": "Carregar Cenário",
    "gui.costumeTab.addFileCostume": "Carregar Traje",
    "gui.extensionLibrary.chooseAnExtension": "Escolher uma Extensão",
    "gui.extensionLibrary.extensionUrl": "Introduza o URL da extensão",
    "gui.monitors.importListColumnPrompt": "Que coluna deve ser usada (1 – {numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Não foi possível iniciar gravação",
    "gui.soundLibrary.chooseASound": "Escolher um Som",
    "gui.soundTab.fileUploadSound": "Carregar Som",
    "gui.soundTab.surpriseSound": "Surpresa",
    "gui.soundTab.recordSound": "Gravar",
    "gui.soundTab.addSoundFromLibrary": "Escolher um Som",
    "gui.spriteLibrary.chooseASprite": "Escolher um Actor",
    "gui.tipsLibrary.tutorials": "Escolher um Tutorial",
    "gui.alerts.createsuccess": "Criado novo projecto.",
    "gui.alerts.createcopysuccess": "Projecto guardado como cópia.",
    "gui.alerts.createremixsuccess": "Projecto guardado como uma remistura.",
    "gui.alerts.creating": "A criar novo…",
    "gui.alerts.creatingCopy": "A copiar o projecto…",
    "gui.alerts.creatingRemix": "A remisturar o projecto…",
    "gui.alerts.creatingError": "Não foi possível criar o projecto. Por favor tente novamente!",
    "gui.alerts.savingError": "Não foi possível guardar o projecto.",
    "gui.alerts.savesuccess": "Projecto guardado.",
    "gui.alerts.saving": "A guardar o projecto…",
    "gui.alerts.cloudInfo": "Por favor note que as variáveis de nuvem suportam apenas números, e não letras ou símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Saber mais.",
    "gui.alerts.importing": "A importar…",
    "gui.defaultProject.meow": "Miau!",
    "gui.defaultProject.variable": "a minha variável",
    "gui.howtos.intro-move-sayhello-hat.name": "Começar",
    "gui.howtos.intro-move.step_stepMove": "Adicionar um Bloco de Movimento",
    "gui.howtos.add-a-move-block.step_stepSay": "Adicione um bloco «diz»",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Clicar na bandeira verde para começar",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animar um Nome",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Escolher um Actor Letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Tocar um Som Quando Clicado",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Escolher Outro Actor Letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Alterar a Cor",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Escolher Outro Actor Letra e Fazê-lo Girar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Escolher Outro Actor Letra e Fazê-lo Crescer",
    "gui.howtos.imagine": "Imaginar um Mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Digitar o Que Quiser Dizer",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Clicar na Bandeira Verde para Começar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Escolher Qualquer Fundo",
    "gui.howtos.imagine.step_imagineChooseSprite": "Escolher Qualquer Actor",
    "gui.howtos.imagine.step_imagineFlyAround": "Carregar na Tecla Espaço para Deslizar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Escolher Outro Actor",
    "gui.howtos.imagine.step_imagineLeftRight": "Mover para a Esquerda e para a Direita",
    "gui.howtos.imagine.step_imagineUpDown": "Mover para Cima e para Baixo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Alterar Trajes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Deslizar para um Ponto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Aumentar e Diminuir",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Escolher Outro Cenário",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Mudar de Cenários",
    "gui.howtos.imagine.step_imagineRecordASound": "Adicionar um Som",
    "gui.howtos.imagine.step_imagineChooseSound": "Escolher o Seu Som",
    "gui.howtos.make-music.name": "Fazer Música",
    "gui.howtos.Make-Music.step_PickInstrument": "Escolher um Actor Instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Tocar um Som Quando Clicado",
    "gui.howtos.Make-Music.step_MakeSong": "Criar um Som",
    "gui.howtos.make-music.step_MakeBeat": "Escolher uma Percussão e Fazer um Ritmo",
    "gui.howtos.make-music.step_MakeBeatBox": "Escolher o Actor Microfone e uma Caixa de Ritmos Surpresa",
    "gui.howtos.story.name": "Criar uma Estória",
    "gui.howtos.story.step_addbg": "Adicionar um Cenário",
    "gui.howtos.story.step_addsprite": "Adicionar um Personagem",
    "gui.howtos.story.step_saysomething": "Dizer Alguma Coisa",
    "gui.howtos.story.step_addanothersprite": "Adicionar Outro Personagem",
    "gui.howtos.story.step_flip": "Inverter Direcção",
    "gui.howtos.story.step_conversation": "Ter uma Conversa",
    "gui.howtos.story.addanotherbg": "Adicionar Outro Cenário",
    "gui.howtos.story.step_swithbg": "Mudar de Cenários",
    "gui.howtos.story.step_hidewizard": "Esconder um Personagem",
    "gui.howtos.story.step_showwizard": "Mostrar um Personagem",
    "gui.howtos.make-a-chase-game.name": "Fazer um Jogo de Perseguição",
    "gui.howtos.Chase-Game.step_BG": "Adicionar um Cenário",
    "gui.howtos.chase-game.step_AddOcto": "Adicionar um Actor",
    "gui.howtos.make-music.step_LeftRight": "Mover Para a Esquerda e Para a Direita Usando as Setas",
    "gui.howtos.Chase-Game.step_UpDown": "Mover Para Cima e Para Baixo Usando as Setas",
    "gui.howtos.Chase-Game.step_AddStar": "Adicionar Outro Actor",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mover ao Acaso",
    "gui.howtos.Chase-Game.step_WhenTouch": "No Actor Polvo, Tocar Som Quando Tocar",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Criar uma Variável de Pontuação",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "No Actor Polvo, Adicionar à Pontuação Quando a Tocar",
    "gui.howtos.animate-char.name": "Animar um Personagem",
    "gui.howtos.animate-char.step_addbg": "Adicionar um Cenário",
    "gui.howtos.animate-char.step_addsprite": "Adicionar um Actor",
    "gui.howtos.animate-char.step_saysomething": "Dizer Alguma Coisa",
    "gui.howtos.animate-char.step_addsound": "Adicionar Som",
    "gui.howtos.animate-char.step_animatetalking": "Animar Fala",
    "gui.howtos.animate-char.step_arrowkeys": "Mover Usando as Setas do Teclado",
    "gui.howtos.animate-char.step_jump": "Saltar",
    "gui.howtos.animate-char.step_changecolor": "Alterar a Cor",
    "gui.howtos.make-a-game.name": "Fazer um Jogo de Cliques",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Escolher um Actor",
    "gui.howtos.make-a-game.step_GamePlaySound": "Tocar um Som Quando Clicado",
    "gui.howtos.make-a-game.step_GameAddScore": "Criar uma Variável de Pontuação",
    "gui.howtos.make-a-game.step_GameChangeScore": "Quando Clicado Aumentar a Pontuação",
    "gui.howtos.make-a-game.step_Random": "Ir para uma posição ao acaso",
    "gui.howtos.make-music.step_GameChangeColor": "Alterar a Cor",
    "gui.howtos.make-music.step_ResetScore": "Reiniciar a Pontuação",
    "gui.howtos.make-it-fly.name": "Fazê-lo Voar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Escolher um Cenário com o Céu",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Escolher um Personagem",
    "gui.howtos.fly.step_stepflySaySomething": "Dizer Alguma Coisa",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mover Com as Setas do Teclado",
    "gui.howtos.fly.step_stepflyChooseObject": "Escolher um Objecto para Recolher",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fazer o Objecto Mover-se",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Seleccionar o Seu Personagem",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Adicionar a Pontuação",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Manter a Pontuação",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Adicionar uma Paisagem",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mover o Cenário",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Próximo Traje",
    "gui.howtos.pong": "Jogo do Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Adicionar um Cenário",
    "gui.howtos.pong.step_pongAddBallSprite": "Adicionar um Actor Bola",
    "gui.howtos.pong.step_pongBounceAround": "Pular Por Aí",
    "gui.howtos.pong.step_pongAddPaddle": "Adicionar uma Raquete",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mover a Raquete",
    "gui.howtos.pong.step_pongSelectBallSprite": "Seleccionar o Actor Bola",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Adicionar Código para Ressaltar a Bola na Raquete",
    "gui.howtos.pong.step_pongAddAScore": "Adicionar a Pontuação",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Escolher «Pontuação» no Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Inserir o Bloco «Adiciona à Pontuação»",
    "gui.howtos.pong.step_pongResetScore": "Reiniciar a Pontuação",
    "gui.howtos.pong.step_pongAddLineSprite": "Adicionar o Actor Linha",
    "gui.howtos.pong.step_pongGameOver": "Fim do Jogo",
    "gui.howtos.code-cartoon": "Programar um Desenho Animado",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Dizer Alguma Coisa Quando Clicar na Bandeira Verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animar um Personagem Quando Clicar Nele",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selecionar um Personagem Diferente",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Usar um Sinal de Menos para Ficar Mais Pequeno",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Fazer um Personagem Aumentar e Diminuir",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Seleccionar um Personagem Diferente",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Saltar para Cima e para Baixo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Clicar num Personagem para Alterar as Cenas",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Deslizar Por Aí",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Alterar Trajes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Escolher Mais Personagens para Adicionar ao Seu Desenho Animado",
    "gui.howtos.cartoon-network": "Animar um Jogo de Aventuras",
    "gui.howtos.cartoon-network.step_CNcharacter": "Escolher uma Personagem a Mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Dizer Alguma Coisa",
    "gui.howtos.cartoon-network.step_CNglide": "Deslizar Por Aí",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Escolher um Objecto para Perseguir",
    "gui.howtos.cartoon-network.step_CNcollect": "Recolher Objectos",
    "gui.howtos.cartoon-network.step_CNvariable": "Criar uma Variável de Pontuação",
    "gui.howtos.cartoon-network.step_CNscore": "Manter a Pontuação",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Subida de Nível: Alterar Cenário",
    "gui.howtos.videosens.name": "Sensores de Vídeo",
    "gui.howtos.videosens.step_addextension": "Adicionar Extensão",
    "gui.howtos.videosens.step_pet": "Festinhas ao Gato",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Rebentar um Balão",
    "gui.howtos.say-it-out-loud": "Criar Animações que Falam",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Adicionar o Texto a Blocos de Fala",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Dizer Alguma Coisa",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Seleccionar uma Voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mover",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Adicionar um Cenário",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Adicionar Outro Personagem",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cantar uma Canção",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Alterar a Cor",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Girar",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Aumentar e Diminuir",
    "gui.howtos.talking": "Falando Estórias",
    "gui.howtos.talking.step_talesAddExtension": "Clicar para Adicionar os Blocos de Texto para Fala",
    "gui.howtos.talking.step_talesChooseSprite": "Escolher um Actor",
    "gui.howtos.talking.step_talesSaySomething": "Fazer um Personagem Falar",
    "gui.howtos.talking.step_talesChooseBackdrop": "Escolher um Cenário",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Clicar num Personagem para Ir para o Próximo Cenário",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Escolher Outro Actor",
    "gui.howtos.talking.step_talesMoveAround": "Mover Por Aí",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Escolher Outro Cenário",
    "gui.howtos.talking.step_talesAnimateTalking": "Animar Fala",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Escolher Outro Cenário",
    "gui.howtos.talking.step_talesChooseSound": "Escolher uma Música para Dançar",
    "gui.howtos.talking.step_talesDanceMoves": "Passos de Dança",
    "gui.howtos.talking.step_talesAskAnswer": "Obter os Blocos de Perguntas e Respostas da Categoria Sensores",
    "gui.howtos.add-sprite.name": "Adicionar um Actor",
    "gui.howtos.add-sprite.step_addSprite": "Adicionar um Actor",
    "gui.howtos.add-a-backdrop.name": "Adicionar um Cenário",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Adicionar um Cenário",
    "gui.howtos.change-size.name": "Alterar o Tamanho",
    "gui.howtos.change-size.step_changeSize": "Alterar o Tamanho",
    "gui.howtos.glide-around.name": "Deslizar Por Aí",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Deslizar Por Aí",
    "gui.howtos.change-size.step_glideAroundPoint": "Deslizar para um Ponto",
    "gui.howtos.record-a-sound.name": "Gravar um Som",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clicar no Separador «Som»",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clicar em «Gravar»",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pressionar o Botão Gravar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Escolher o Seu Som",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Tocar o Seu Som",
    "gui.howtos.spin-video.name": "Fazê-la Girar",
    "gui.howtos.change-size.step_spinTurn": "Girar",
    "gui.howtos.change-size.step_spinPointInDirection": "Alterar a Direcção",
    "gui.howtos.hide-and-show.name": "Mostrar e Esconder",
    "gui.howtos.change-size.step_hideAndShow": "Esconder e Mostrar",
    "gui.howtos.switch-costume.name": "Animar um Actor",
    "gui.howtos.change-size.step_switchCostumes": "Animar um Actor",
    "gui.howtos.move-around-with-arrow-keys.name": "Usar as Setas do Teclado",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mover para a Esquerda e para a Direita",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mover para Cima e para Baixo",
    "gui.howtos.add-effects.name": "Adicionar Efeitos",
    "gui.howtos.videosens.step_addEffects": "Adicionar Efeitos",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toque instrumentos e percussão.",
    "gui.extension.pen.name": "Caneta",
    "gui.extension.pen.description": "Desenhe com os seus actores.",
    "gui.extension.videosensing.name": "Vídeo Sensorial",
    "gui.extension.videosensing.description": "Use a câmara para sentir movimento.",
    "gui.extension.text2speech.name": "Texto para Fala",
    "gui.extension.text2speech.description": "Faça os seus projectos falar.",
    "gui.extension.translate.name": "Traduzir",
    "gui.extension.translate.description": "Traduza texto para muitas línguas.",
    "gui.extension.makeymakey.description": "Transforme tudo numa tecla.",
    "gui.extension.microbit.description": "Ligue os seus projectos ao mundo.",
    "gui.extension.microbit.connectingMessage": "Ligando",
    "gui.extension.ev3.description": "Crie robôs interactivos e muito mais.",
    "gui.extension.ev3.connectingMessage": "Ligando. Assegure-se de que o pino no seu EV3 está configurado para 1234.",
    "gui.extension.boost.description": "Dê vida a criações robóticas.",
    "gui.extension.boost.connectingMessage": "Ligando",
    "gui.extension.wedo2.description": "Construa com motores e sensores.",
    "gui.extension.wedo2.connectingMessage": "Ligando",
    "gui.extension.gdxfor.description": "Detecte puxões, empurrões, movimento e rotação.",
    "gui.extension.gdxfor.connectingMessage": "Ligando",
    "gui.libraryTags.all": "Tudo",
    "gui.libraryTags.animals": "Animais",
    "gui.libraryTags.dance": "Dança",
    "gui.libraryTags.effects": "Efeitos",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Comida",
    "gui.libraryTags.indoors": "Interior",
    "gui.libraryTags.loops": "Ciclos de som",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exterior",
    "gui.libraryTags.patterns": "Padrões",
    "gui.libraryTags.people": "Pessoas",
    "gui.libraryTags.percussion": "Percussão",
    "gui.libraryTags.space": "Espaço",
    "gui.libraryTags.sports": "Desporto",
    "gui.libraryTags.underwater": "Debaixo de água",
    "gui.libraryTags.voice": "Vozes",
    "gui.libraryTags.wacky": "Maluquices",
    "gui.libraryTags.animation": "Animações",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Jogos",
    "gui.libraryTags.stories": "Estórias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "direcção",
    "gui.opcodeLabels.xposition": "x da posição",
    "gui.opcodeLabels.yposition": "y da posição",
    "gui.opcodeLabels.size": "tamanho",
    "gui.opcodeLabels.costumename": "nome do traje",
    "gui.opcodeLabels.costumenumber": "número do traje",
    "gui.opcodeLabels.backdropname": "nome do cenário",
    "gui.opcodeLabels.backdropnumber": "número do cenário",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "andamento",
    "gui.opcodeLabels.answer": "resposta",
    "gui.opcodeLabels.loudness": "volume no microfone",
    "gui.opcodeLabels.username": "nome de utilizador",
    "gui.opcodeLabels.year": "ano actual",
    "gui.opcodeLabels.month": "mês actual",
    "gui.opcodeLabels.date": "data actual",
    "gui.opcodeLabels.dayofweek": "dia da semana actual",
    "gui.opcodeLabels.hour": "hora actual",
    "gui.opcodeLabels.minute": "minuto actual",
    "gui.opcodeLabels.second": "segundo actual",
    "gui.opcodeLabels.timer": "valor do cronómetro",
    "gui.projectLoader.loadError": "Falhou o carregamento do arquivo de projecto que foi seleccionado.",
    "gui.sharedMessages.backdrop": "Cenário {index}",
    "gui.sharedMessages.costume": "Traje {index}",
    "gui.sharedMessages.sprite": "o actor {index}",
    "gui.sharedMessages.pop": "Pop!",
    "gui.sharedMessages.replaceProjectWarning": "Substituir o conteúdo do projecto corrente?",
    "gui.sharedMessages.loadFromComputerTitle": "Carregar a partir do seu computador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Projecto Scratch",
    "boost.color.any": "de qualquer cor",
    "boost.color.black": "preto",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "vermelho",
    "boost.color.white": "branco",
    "boost.color.yellow": "amarelo",
    "boost.getMotorPosition": "a posição do motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "o ângulo da inclinação [TILT_DIRECTION]",
    "boost.motorDirection.backward": "para ali",
    "boost.motorDirection.forward": "para aqui",
    "boost.motorDirection.reverse": "ao contrário",
    "boost.motorOff": "desliga o motor [MOTOR_ID]",
    "boost.motorOn": "liga o motor [MOTOR_ID]",
    "boost.motorOnFor": "roda o motor [MOTOR_ID] durante [DURATION] s",
    "boost.motorOnForRotation": "roda o motor [MOTOR_ID] [ROTATION] rotações",
    "boost.seeingColor": "está a ver um tijolo [COLOR]",
    "boost.setLightHue": "altera a cor da luz para [HUE]",
    "boost.setMotorDirection": "altera a direcção do motor [MOTOR_ID] para [MOTOR_DIRECTION]",
    "boost.setMotorPower": "altera a velocidade do motor [MOTOR_ID] para [POWER] %",
    "boost.tiltDirection.any": "para qualquer lado",
    "boost.tiltDirection.down": "para baixo",
    "boost.tiltDirection.left": "para a esquerda",
    "boost.tiltDirection.right": "para a direita",
    "boost.tiltDirection.up": "cima",
    "boost.whenColor": "Quando vir o tijolo [COLOR] ",
    "boost.whenTilted": "Quando for inclinado [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "toca a nota [NOTE] durante [TIME]s",
    "ev3.buttonPressed": "o botão [PORT] está a ser pressionado",
    "ev3.getBrightness": "o brilho",
    "ev3.getDistance": "a distância",
    "ev3.getMotorPosition": "a posição do motor [PORT]",
    "ev3.motorSetPower": "altera a potência do motor [PORT] para [POWER]%",
    "ev3.motorTurnClockwise": "roda o motor [PORT] para aqui durante [TIME] s",
    "ev3.motorTurnCounterClockwise": "roda o motor [PORT]para ali durante [TIME] s",
    "ev3.whenBrightnessLessThan": "Quando o brilho for menor que [DISTANCE]",
    "ev3.whenButtonPressed": "Quando o botão [PORT] for pressionado",
    "ev3.whenDistanceLessThan": "Quando a distância for menor que [DISTANCE]",
    "gdxfor.getAcceleration": "a aceleração [DIRECTION]",
    "gdxfor.getForce": "a força",
    "gdxfor.getSpin": "a velocidade de rotação [DIRECTION]",
    "gdxfor.getTilt": "o ângulo de inclinação [TILT]",
    "gdxfor.isFreeFalling": "a cair",
    "gdxfor.isTilted": "está inclinado [TILT]",
    "gdxfor.pulled": "for puxado",
    "gdxfor.pushed": "for empurrado",
    "gdxfor.shaken": "for abanado",
    "gdxfor.startedFalling": "começar a cair",
    "gdxfor.tiltDirectionMenu.any": "para qualquer lado",
    "gdxfor.tiltDirectionMenu.back": "para trás",
    "gdxfor.tiltDirectionMenu.front": "para a frente",
    "gdxfor.tiltDirectionMenu.left": "para a esquerda",
    "gdxfor.tiltDirectionMenu.right": "para a direita",
    "gdxfor.turnedFaceDown": "está com a face para baixo",
    "gdxfor.turnedFaceUp": "está com a face para cima",
    "gdxfor.whenForcePushedOrPulled": "Quando o sensor de força [PUSH_PULL]",
    "gdxfor.whenGesture": "Quando [GESTURE]",
    "gdxfor.whenTilted": "Quando for inclinado [TILT]",
    "makeymakey.downArrow": "seta para baixo",
    "makeymakey.downArrowShort": "baixo",
    "makeymakey.leftArrow": "seta para a esquerda",
    "makeymakey.leftArrowShort": "esquerda",
    "makeymakey.rightArrow": "seta para a direita",
    "makeymakey.rightArrowShort": "direita",
    "makeymakey.spaceKey": "espaço",
    "makeymakey.upArrow": "seta para cima",
    "makeymakey.upArrowShort": "cima",
    "makeymakey.whenKeyPressed": "Quando a tecla [KEY] for pressionada",
    "makeymakey.whenKeysPressedInOrder": "Quando [SEQUENCE] forem pressionadas por ordem",
    "microbit.buttonsMenu.any": "qualquer",
    "microbit.clearDisplay": "apaga o ecrã",
    "microbit.defaultTextToDisplay": "Ola!",
    "microbit.displaySymbol": "mostra [MATRIX]",
    "microbit.displayText": "mostra o texto [TEXT]",
    "microbit.gesturesMenu.jumped": "saltar",
    "microbit.gesturesMenu.moved": "se mover",
    "microbit.gesturesMenu.shaken": "for abanado",
    "microbit.isButtonPressed": "o botão [BTN] está a ser pressionado",
    "microbit.isTilted": "está inclinado [DIRECTION]",
    "microbit.pinStateMenu.off": "desligado",
    "microbit.pinStateMenu.on": "ligado",
    "microbit.tiltAngle": "o ângulo da inclinação [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "para qualquer lado",
    "microbit.tiltDirectionMenu.back": "para trás",
    "microbit.tiltDirectionMenu.front": "para a frente",
    "microbit.tiltDirectionMenu.left": "para a esquerda",
    "microbit.tiltDirectionMenu.right": "para a direita",
    "microbit.whenButtonPressed": "Quando o botão [BTN] for pressionado",
    "microbit.whenGesture": "Quando [GESTURE]",
    "microbit.whenPinConnected": "Quando o pino [PIN] for ligado",
    "microbit.whenTilted": "Quando for inclinado [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "adiciona [TEMPO] bpm ao teu andamento",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabaça",
    "music.drumClaves": "(9) Clavas",
    "music.drumClosedHiHat": "(6) Pratos de Choque Fechados",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Caneca",
    "music.drumCrashCymbal": "(4) Prato de Ataque",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Reco-Reco",
    "music.drumHandClap": "(8) Palmas",
    "music.drumOpenHiHat": "(5) Pratos de Choque Abertos",
    "music.drumSideStick": "(3) Golpe no Fuste da Tarola",
    "music.drumSnare": "(1) Caixa",
    "music.drumTambourine": "(7) Pandeireta",
    "music.drumTriangle": "(12) Triângulo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Bloco Sonoro",
    "music.getTempo": "o andamento",
    "music.instrumentBass": "(6) Baixo",
    "music.instrumentBassoon": "(14) Fagote",
    "music.instrumentCello": "(8) Violoncelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra Eléctrica",
    "music.instrumentElectricPiano": "(2) Piano Eléctrico",
    "music.instrumentFlute": "(12) Flauta Transversal",
    "music.instrumentGuitar": "(4) Guitarra",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caixa de Música",
    "music.instrumentOrgan": "(3) Órgão",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofone",
    "music.instrumentSteelDrum": "(18) Tambor de Aço",
    "music.instrumentSynthLead": "(20) Sintetizador Melódico",
    "music.instrumentSynthPad": "(21) Sintetizador de Fundo",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafone",
    "music.instrumentWoodenFlute": "(13) Flauta de Madeira",
    "music.midiPlayDrumForBeats": "toca a percussão [DRUM] durante [BEATS] tempos",
    "music.midiSetInstrument": "altera o teu instrumento para [INSTRUMENT]",
    "music.playDrumForBeats": "toca a percussão [DRUM] durante [BEATS] tempos",
    "music.playNoteForBeats": "toca a nota [NOTE] durante [BEATS] tempos",
    "music.restForBeats": "faz uma pausa de [BEATS] tempos",
    "music.setInstrument": "altera a teu instrumento para [INSTRUMENT]",
    "music.setTempo": "altera o teu andamento para [TEMPO] bpm",
    "pen.categoryName": "Caneta",
    "pen.changeColorParam": "adiciona a [COLOR_PARAM] da tua caneta o valor [VALUE]",
    "pen.changeHue": "adiciona [HUE] à cor da tua caneta",
    "pen.changeShade": "adiciona [SHADE] ao tom da tua caneta",
    "pen.changeSize": "adiciona [SIZE] à espessura da tua caneta",
    "pen.clear": "apaga tudo do palco",
    "pen.colorMenu.brightness": "o brilho",
    "pen.colorMenu.color": "o matiz",
    "pen.colorMenu.saturation": "a saturação",
    "pen.colorMenu.transparency": "a transparência",
    "pen.penDown": "baixa a tua caneta",
    "pen.penUp": "levanta a tua caneta",
    "pen.setColor": "altera a cor da tua caneta para [COLOR]",
    "pen.setColorParam": "altera [COLOR_PARAM] da tua caneta para [VALUE]",
    "pen.setHue": "altera a cor da tua caneta para [HUE]",
    "pen.setShade": "altera o tom da tua caneta para [SHADE]",
    "pen.setSize": "altera a espessura da tua caneta para [SIZE]",
    "pen.stamp": "carimba-te",
    "speech.defaultWhenIHearValue": "vamos a isso",
    "speech.extensionName": "Converter Fala para Texto",
    "speech.listenAndWait": "ouve e espera",
    "speech.speechReporter": "o texto falado",
    "speech.whenIHear": "Quando eu ouvir [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Texto para Fala",
    "text2speech.defaultTextToSpeak": "Olá!",
    "text2speech.giant": "gigante",
    "text2speech.kitten": "gatinho",
    "text2speech.setLanguageBlock": "altera a língua para [LANGUAGE]",
    "text2speech.setVoiceBlock": "altera a voz para [VOICE]",
    "text2speech.speakAndWaitBlock": "fala [WORDS]",
    "text2speech.squeak": "guincho",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traduzir",
    "translate.defaultTextToTranslate": "olá",
    "translate.translateBlock": "a tradução de [WORDS] para [LANGUAGE]",
    "translate.viewerLanguage": "a língua",
    "videoSensing.categoryName": "Sensores de Vídeo",
    "videoSensing.direction": "a direcção",
    "videoSensing.motion": "o movimento",
    "videoSensing.off": "desligado",
    "videoSensing.on": "ligado",
    "videoSensing.onFlipped": "ligado e espelhado",
    "videoSensing.setVideoTransparency": "altera a transparência do vídeo para [TRANSPARENCY] %",
    "videoSensing.sprite": "ti mesmo",
    "videoSensing.stage": "o palco",
    "videoSensing.videoOn": "[ATTRIBUTE] do vídeo em [SUBJECT]",
    "videoSensing.videoToggle": "altera o estado do vídeo para [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "Quando o movimento do vídeo exceder [REFERENCE]",
    "wedo2.getDistance": "a distância",
    "wedo2.getTiltAngle": "o ângulo da inclinação [TILT_DIRECTION]",
    "wedo2.isTilted": "está inclinado [TILT_DIRECTION_ANY]",
    "wedo2.motorDirection.backward": "para ali",
    "wedo2.motorDirection.forward": "para aqui",
    "wedo2.motorDirection.reverse": "para trás",
    "wedo2.motorId.a": "o motor A",
    "wedo2.motorId.all": "todos os motores",
    "wedo2.motorId.b": "o motor B",
    "wedo2.motorId.default": "o motor",
    "wedo2.motorOff": "desliga [MOTOR_ID]",
    "wedo2.motorOn": "liga [MOTOR_ID]",
    "wedo2.motorOnFor": "liga [MOTOR_ID] durante [DURATION] s",
    "wedo2.playNoteFor": "toca a nota [NOTE] durante [DURATION] s",
    "wedo2.setLightHue": "altera a cor da luz para [HUE]",
    "wedo2.setMotorDirection": "altera a direcção de [MOTOR_ID] para [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "altera a potência de [MOTOR_ID] para [POWER]",
    "wedo2.tiltDirection.any": "para qualquer lado",
    "wedo2.tiltDirection.down": "para baixo",
    "wedo2.tiltDirection.left": "para a esquerda",
    "wedo2.tiltDirection.right": "para a direita",
    "wedo2.tiltDirection.up": "para cima",
    "wedo2.whenDistance": "Quando a distância for [OP] [REFERENCE]",
    "wedo2.whenTilted": "Quando for inclinado [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Matiz",
    "paint.paintEditor.saturation": "Saturação",
    "paint.paintEditor.brightness": "Brilho",
    "paint.paintEditor.costume": "Traje",
    "paint.paintEditor.group": "Agrupar",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Desfazer",
    "paint.paintEditor.redo": "Refazer",
    "paint.paintEditor.forward": "Avançar",
    "paint.paintEditor.backward": "Recuar",
    "paint.paintEditor.front": "Para a Frente",
    "paint.paintEditor.back": "Para Trás",
    "paint.paintEditor.more": "Mais",
    "paint.modeTools.brushSize": "Tamanho",
    "paint.modeTools.eraserSize": "Tamanho da borracha",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Colar",
    "paint.modeTools.delete": "Remover",
    "paint.modeTools.curved": "Arredondado",
    "paint.modeTools.pointed": "Em Ângulo",
    "paint.modeTools.thickness": "Espessura",
    "paint.modeTools.flipHorizontal": "Inverter Horizontalmente",
    "paint.modeTools.flipVertical": "Inverter Verticalmente",
    "paint.modeTools.filled": "A cheio",
    "paint.modeTools.outlined": "Com contorno",
    "paint.paintEditor.bitmap": "Converter para Bitmap",
    "paint.paintEditor.vector": "Converter para Vectorial",
    "paint.paintEditor.fill": "Interior",
    "paint.paintEditor.stroke": "Contorno",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Borracha",
    "paint.fillMode.fill": "Preencher",
    "paint.lineMode.line": "Linha",
    "paint.ovalMode.oval": "Círculo",
    "paint.rectMode.rect": "Rectângulo",
    "paint.reshapeMode.reshape": "Remodelar",
    "paint.roundedRectMode.roundedRect": "Rectângulo Arredondado",
    "paint.selectMode.select": "Seleccionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Trocar"
  },
  "pt-br": {
    "gui.alerts.lostPeripheralConnection": "O Scratch perdeu a conexão com {extensionName}.",
    "gui.alerts.tryAgain": "Tente Novamente",
    "gui.alerts.download": "Baixar",
    "gui.connection.reconnect": "Reconectar",
    "gui.backpack.costumeLabel": "fantasia",
    "gui.backpack.soundLabel": "som",
    "gui.backpack.scriptLabel": "código",
    "gui.backpack.spriteLabel": "ator",
    "gui.backpack.header": "Mochila",
    "gui.backpack.errorBackpack": "Erro ao carregar a mochila",
    "gui.backpack.loadingBackpack": "Carregando...",
    "gui.backpack.more": "Mais",
    "gui.backpack.emptyBackpack": "A mochila está vazia",
    "gui.unsupportedBrowser.label": "O navegador não é suportado",
    "gui.unsupportedBrowser.errorLabel": "Ocorreu um Erro",
    "gui.unsupportedBrowser.notRecommended": "Sentimos muito, mas parece que você está utilizando uma versão de navegador não suportada pelo Scratch. Nós recomendamos a atualização para a versão mais recente de um navegador como o Google Chrome, Mozilla Firefox, Microsoft Edge ou Safari. ",
    "gui.unsupportedBrowser.description": "Sentimos muito, mas o Scratch não suporta este navegador. Nós recomendamos a atualização para a versão mais recente de um navegador como o Google Chrome, Mozilla Firefox, Microsoft Edge ou Safari. ",
    "gui.unsupportedBrowser.back": "Voltar",
    "gui.unsupportedBrowser.previewfaq": "Para aprender mais, vá para {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Perguntas frequentes",
    "gui.cards.all-tutorials": "Tutoriais",
    "gui.cards.shrink": "Reduzir",
    "gui.cards.expand": "Expandir",
    "gui.cards.close": "Fechar",
    "gui.cards.more-things-to-try": "Mais coisas para experimentar!",
    "gui.cards.see-more": "Veja mais",
    "gui.comingSoon.message1": "Não se preocupe, estamos trabalhando nisso {emoji}",
    "gui.comingSoon.message2": "Em Breve...",
    "gui.comingSoon.message3": "Estamos trabalhando nisso {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nenhum dispositivo encontrado",
    "gui.connection.auto-scanning.prescan": "Tenha seu dispositivo em mãos e então comece a busca.",
    "gui.connection.auto-scanning.pressbutton": "Pressione o botão no seu dispositivo.",
    "gui.connection.auto-scanning.start-search": "Inicie a Busca",
    "gui.connection.connecting-searchbutton": "Procurando...",
    "gui.connection.auto-scanning.try-again": "Tente novamente",
    "gui.connection.auto-scanning.updatePeripheralButton": "Atualizar meu Dispositivo",
    "gui.connection.connected": "Conectado",
    "gui.connection.disconnect": "Desconectar",
    "gui.connection.go-to-editor": "Ir para o Editor",
    "gui.connection.connecting-cancelbutton": "Conectando...",
    "gui.connection.error.errorMessage": "Ooops! Parece que deu algo errado. ",
    "gui.connection.error.tryagainbutton": "Tente novamente",
    "gui.connection.error.helpbutton": "Ajuda",
    "gui.connection.peripheral-name-label": "Nome do dispositivo",
    "gui.connection.connect": "Conectar",
    "gui.connection.scanning.lookingforperipherals": "Procurando por dispositivos",
    "gui.connection.scanning.noPeripheralsFound": "Nenhum dispositivo encontrado",
    "gui.connection.scanning.instructions": "Selecione seu dispositivo na lista acima.",
    "gui.connection.search": "Atualizar",
    "gui.connection.scanning.updatePeripheralButton": "Atualizar meu Dispositivo",
    "gui.connection.unavailable.installscratchlink": "Confirme que o Scratch Link está instalado e funcionando ",
    "gui.connection.unavailable.enablebluetooth": "Verifique se o Bluetooth está ligado",
    "gui.connection.unavailable.tryagainbutton": "Tente novamente",
    "gui.connection.unavailable.helpbutton": "Ajuda",
    "gui.connection.updatePeripheral.microBitConnect": "Conecte seu {extensionName} neste dispositivo usando o cabo USB.",
    "gui.connection.updatePeripheral.pressUpdate": "Pressione \"Atualizar\" e permita que a atualização finalize.",
    "gui.connection.updatePeripheral.progress": "Atualizando {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Atualização bem sucedida!",
    "gui.connection.updatePeripheral.updateFailed": "A atualização falhou.",
    "gui.connection.updatePeripheral.goBackButton": "Voltar",
    "gui.connection.updatePeripheral.updateNowButton": "Atualizar",
    "gui.connection.updatePeripheral.updateAgainButton": "Tentar Novamente",
    "gui.controls.go": "Ir",
    "gui.controls.stop": "Pare",
    "gui.crashMessage.label": "Ooops! Algo deu errado.",
    "gui.crashMessage.description": "Parece que o Scratch parou de funcionar. Este erro foi automaticamente reportado para a Equipe Scratch . Atualize sua página para tentar novamente.",
    "gui.crashMessage.errorNumber": "Seu erro foi registrado com o ID {errorId}",
    "gui.crashMessage.reload": "Recarregue",
    "gui.customProcedures.myblockModalTitle": "Criar um Bloco",
    "gui.customProcedures.addAnInputNumberText": "Adicionar uma entrada",
    "gui.customProcedures.numberTextType": "numérica ou texto",
    "gui.customProcedures.addAnInputBoolean": "Adicionar uma entrada",
    "gui.customProcedures.booleanType": "booleana",
    "gui.customProcedures.addALabel": "Adicionar um rótulo",
    "gui.customProcedures.runWithoutScreenRefresh": "Executar sem atualização de tela",
    "gui.customProcedures.cancel": "Cancelar",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direção",
    "gui.directionPicker.rotationStyles.allAround": "Rotação Completa",
    "gui.directionPicker.rotationStyles.leftRight": "Esquerda/Direita",
    "gui.directionPicker.rotationStyles.dontRotate": "Não gire",
    "gui.gui.addExtension": "Adicionar uma Extensão",
    "gui.gui.codeTab": "Código",
    "gui.gui.backdropsTab": "Cenários",
    "gui.gui.costumesTab": "Fantasias",
    "gui.gui.soundsTab": "Sons",
    "gui.extensionLibrary.comingSoon": "Em Breve ",
    "gui.extensionLibrary.requires": "Requer",
    "gui.extensionLibrary.collaboration": "Em colaboração com",
    "gui.library.filterPlaceholder": "Buscar",
    "gui.library.allTag": "Tudo",
    "gui.loader.message1": "Criando blocos...",
    "gui.loader.message2": "Carregando atores...",
    "gui.loader.message3": "Carregando sons...",
    "gui.loader.message4": "Carregando extensões...",
    "gui.loader.message5": "Reunindo a gataria...",
    "gui.loader.message6": "Transmitindo nanos...",
    "gui.loader.message7": "Inflando gobos...",
    "gui.loader.message8": "Preparando emojis...",
    "gui.loader.headline": "Carregando Projeto",
    "gui.loader.creating": "Criando Projeto",
    "gui.accountMenu.profile": "Perfil",
    "gui.accountMenu.myStuff": "Minhas Criações",
    "gui.accountMenu.myClasses": "Minhas Aulas",
    "gui.accountMenu.myClass": "Minha turma",
    "gui.accountMenu.accountSettings": "Configurações de conta",
    "gui.accountMenu.signOut": "Sair",
    "gui.authorInfo.byUser": "por {username}",
    "gui.menuBar.seeProjectPage": "Veja a Página do Projeto",
    "gui.menuBar.language": "Idioma",
    "general.username": "Nome de usuário",
    "general.password": "Senha",
    "general.signIn": "Entrar",
    "login.needHelp": "Precisa de ajuda?",
    "form.validationRequired": "Este campo é obrigatório",
    "gui.menuBar.tutorialsLibrary": "Tutoriais",
    "gui.menuBar.restoreSprite": "Restaurar Ator",
    "gui.menuBar.restoreSound": "Restaurar Som",
    "gui.menuBar.restoreCostume": "Restaurar a Fantasia",
    "gui.menuBar.restore": "Restaurar",
    "gui.menuBar.saveNow": "Salvar agora",
    "gui.menuBar.saveAsCopy": "Salvar como cópia",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Novo",
    "gui.menuBar.file": "Arquivo",
    "gui.menuBar.downloadToComputer": "Baixar para o seu computador",
    "gui.menuBar.edit": "Editar",
    "gui.menuBar.turboModeOff": "Desligar o Modo Turbo",
    "gui.menuBar.turboModeOn": "Ligar Modo Turbo",
    "gui.menuBar.modeMenu": "Modo",
    "gui.menuBar.normalMode": "Modo normal",
    "gui.menuBar.caturdayMode": "Modo dia do gato",
    "gui.menuBar.joinScratch": "Inscreva-se",
    "gui.menuBar.signIn": "Entrar",
    "gui.gui.projectTitlePlaceholder": "Título do projeto",
    "gui.menuBar.saveNowLink": "Salvar agora",
    "gui.menuBar.settings": "Configurações",
    "gui.menuBar.isShared": "Compartilhado",
    "gui.menuBar.share": "Compartilhar",
    "gui.menuBar.colorMode": "Modo de Cor",
    "gui.modal.help": "Ajuda",
    "gui.modal.back": "Voltar",
    "gui.monitor.listMonitor.empty": "(vazio)",
    "gui.monitor.listMonitor.listLength": "Comprimento {length}",
    "gui.monitor.contextMenu.default": "letras tamanho normal",
    "gui.monitor.contextMenu.large": "letras grandes",
    "gui.monitor.contextMenu.slider": "controle deslizante",
    "gui.monitor.contextMenu.sliderRange": "mudar o intervalo",
    "gui.monitor.contextMenu.import": "importar",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "esconder",
    "gui.playButton.play": "Tocar",
    "gui.playButton.stop": "Pare",
    "gui.gui.variableScopeOptionAllSprites": "Para todos os atores",
    "gui.gui.variableScopeOptionSpriteOnly": "Apenas para este ator",
    "gui.gui.cloudVariableOption": "Variável na nuvem (armazenada no servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "Esta variável ficará disponível para todos os atores.",
    "gui.gui.listPromptAllSpritesMessage": "Esta lista estará disponível para todos os atores.",
    "gui.prompt.cancel": "Cancelar",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Parar",
    "gui.playbackStep.playMsg": "Tocar",
    "gui.playbackStep.loadingMsg": "Carregando...",
    "gui.playbackStep.saveMsg": "Salvar",
    "gui.playbackStep.reRecordMsg": "Regravar",
    "gui.recordModal.title": "Gravar Som",
    "gui.recordingStep.beginRecord": "Comece a gravação clicando no botão abaixo",
    "gui.recordingStep.permission": "{arrow}Precisamos da sua permissão para usar seu microfone",
    "gui.recordingStep.stop": "Parar gravação",
    "gui.recordingStep.record": "Gravar",
    "gui.sliderModal.min": "Valor mínimo",
    "gui.sliderModal.max": "Valor máximo",
    "gui.sliderModal.title": "Mudar o intervalo",
    "gui.sliderPrompt.cancel": "Cancelar",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Som",
    "gui.soundEditor.play": "Jogar",
    "gui.soundEditor.stop": "Parar",
    "gui.soundEditor.copy": "Copiar",
    "gui.soundEditor.paste": "Colar",
    "gui.soundEditor.copyToNew": "Copiar como novo",
    "gui.soundEditor.delete": "Apagar",
    "gui.soundEditor.save": "Salvar",
    "gui.soundEditor.undo": "Desfazer",
    "gui.soundEditor.redo": "Refazer",
    "gui.soundEditor.faster": "Mais Rápido",
    "gui.soundEditor.slower": "Mais Devagar",
    "gui.soundEditor.echo": "Eco",
    "gui.soundEditor.robot": "Robô",
    "gui.soundEditor.louder": "Mais Alto",
    "gui.soundEditor.softer": "Mais Baixo",
    "gui.soundEditor.reverse": "Inverter",
    "gui.soundEditor.fadeOut": "Desaparecer",
    "gui.soundEditor.fadeIn": "Aparecer",
    "gui.soundEditor.mute": "Silenciar",
    "gui.SpriteInfo.spritePlaceholder": "Nome",
    "gui.SpriteInfo.showSpriteAction": "Mostrar sprite",
    "gui.SpriteInfo.hideSpriteAction": "Esconder sprite",
    "gui.SpriteInfo.sprite": "Ator",
    "gui.SpriteInfo.show": "Mostrar",
    "gui.SpriteInfo.size": "Tamanho",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicar",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "apagar",
    "gui.spriteSelector.addSpriteFromLibrary": "Selecione um Ator",
    "gui.spriteSelector.addSpriteFromPaint": "Pintar",
    "gui.spriteSelector.addSpriteFromSurprise": "Surpresa",
    "gui.spriteSelector.addSpriteFromFile": "Enviar Ator",
    "gui.stageHeader.stageSizeLarge": "Mudar para um palco maior",
    "gui.stageHeader.stageSizeSmall": "Mude para um palco pequeno",
    "gui.stageHeader.stageSizeFull": "Entrar no modo de tela cheia",
    "gui.stageHeader.stageSizeUnFull": "Sair do modo de tela cheia",
    "gui.stageHeader.fullscreenControl": "Controle de Tela Cheia",
    "gui.spriteSelector.addBackdropFromLibrary": "Selecionar Cenário",
    "gui.stageSelector.addBackdropFromPaint": "Pintar",
    "gui.stageSelector.addBackdropFromSurprise": "Surpresa",
    "gui.stageSelector.addBackdropFromFile": "Carregar Cenário",
    "gui.stageSelector.stage": "Palco",
    "gui.stageSelector.backdrops": "Cenários",
    "gui.telemetryOptIn.label": "Reporte estatísticas para melhorar o Scratch",
    "gui.telemetryOptIn.body1": "A equipe do Scratch está sempre buscando entender melhor como o Scratch é usado ao redor do mundo. Para ajudá-la nesse sentido, você pode permitir que o Scratch envie, automaticamente, informações de seu uso para a equipe do Scratch.",
    "gui.telemetryOptIn.body2": "A informação que coletamos inclui seleção de idioma, blocos utilizados, e alguns eventos como salvar, carregar e fazer o upload de um projeto. Nós NÃO coletamos nenhuma informação pessoal. Por favor, veja nossa {privacyPolicyLink} para mais informação.",
    "gui.telemetryOptIn.privacyPolicyLink": "Política de Privacidade",
    "gui.telemetryOptIn.optInText": "Compartilhar meus dados de utilização com a Equipe Scratch",
    "gui.telemetryOptIn.optInTooltip": "Ativar telemetria",
    "gui.telemetryOptIn.optOutText": "Não compartilhar meus dados de utilização com a Equipe Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Desativar telemetria. ",
    "gui.telemetryOptIn.settingWasUpdated": "Sua configuração foi atualizada.",
    "gui.telemetryOptIn.buttonClose": "Fechar",
    "gui.turboMode.active": "Modo Turbo",
    "gui.webglModal.label": "Seu navegador não suporta WebGL",
    "gui.webglModal.description": "Infelizmente seu navegador ou computador, {webGlLink}. Esta tecnologia é necessária para executar o Scratch 3.0.",
    "gui.webglModal.webgllink": "não suporta WebGL",
    "gui.webglModal.back": "Voltar",
    "gui.webglModal.previewfaq": "Para aprender mais, vá para {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Perguntas frequentes",
    "gui.costumeLibrary.chooseABackdrop": "Selecionar Cenário",
    "gui.costumeLibrary.chooseACostume": "Escolher Fantasia",
    "gui.costumeTab.addBackdropFromLibrary": "Selecionar Cenário",
    "gui.costumeTab.addCostumeFromLibrary": "Escolher Fantasia",
    "gui.costumeTab.addBlankCostume": "Pintar",
    "gui.costumeTab.addSurpriseCostume": "Surpresa",
    "gui.costumeTab.addFileBackdrop": "Carregar Cenário",
    "gui.costumeTab.addFileCostume": "Carregar Fantasia",
    "gui.extensionLibrary.chooseAnExtension": "Escolha uma Extensão",
    "gui.extensionLibrary.extensionUrl": "Insira o URL para a extensão",
    "gui.monitors.importListColumnPrompt": "Qual coluna deveria ser utilizada (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Não conseguiu iniciar a gravação",
    "gui.soundLibrary.chooseASound": "Selecione um Som",
    "gui.soundTab.fileUploadSound": "Carregar Som",
    "gui.soundTab.surpriseSound": "Surpresa",
    "gui.soundTab.recordSound": "Gravar",
    "gui.soundTab.addSoundFromLibrary": "Selecionar um Som",
    "gui.spriteLibrary.chooseASprite": "Selecione um Ator",
    "gui.tipsLibrary.tutorials": "Escolher um tutorial",
    "gui.alerts.createsuccess": "Novo projeto criado.",
    "gui.alerts.createcopysuccess": "Projeto salvo como cópia.",
    "gui.alerts.createremixsuccess": "Projeto salvo como remix.",
    "gui.alerts.creating": "Criando novo...",
    "gui.alerts.creatingCopy": "Copiando projeto...",
    "gui.alerts.creatingRemix": "Remixando projeto...",
    "gui.alerts.creatingError": "Não foi possível criar o projeto. Por favor, tente novamente!",
    "gui.alerts.savingError": "Projeto não pode ser salvo.",
    "gui.alerts.savesuccess": "Projeto salvo.",
    "gui.alerts.saving": "Salvando projeto...",
    "gui.alerts.cloudInfo": "Por favor, note que as variáveis em nuvem suportam apenas números, não letras ou símbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Aprenda mais. ",
    "gui.alerts.importing": "Importando...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "minha variável",
    "gui.howtos.intro-move-sayhello-hat.name": "Primeiros Passos",
    "gui.howtos.intro-move.step_stepMove": "Adicione um bloco de movimento",
    "gui.howtos.add-a-move-block.step_stepSay": "Adicione um bloco diga",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Clique na bandeira verde para iniciar",
    "gui.howtos.intro-getting-started-ASL.name": "Primeiros Passos - ASL",
    "gui.howtos.animate-a-name.name": "Anime um Nome",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Escolha um Ator Letra",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Toque uma Música Quando Clicado",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Escolha Outro Ator Letra",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Mude cor",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Escolha Outro Ator Letra & Faça-o Girar",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Escolha outro Ator Letra & Faça-o Crescer",
    "gui.howtos.imagine": "Imagine um Mundo",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Digite o que Quer Dizer",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Clique na Bandeira Verde para Iniciar",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Escolha Qualquer Pano de Fundo",
    "gui.howtos.imagine.step_imagineChooseSprite": "Escolha Qualquer Ator",
    "gui.howtos.imagine.step_imagineFlyAround": "Pressione Espaço para Deslizar",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Escolha Outro Ator",
    "gui.howtos.imagine.step_imagineLeftRight": "Mexa-se da Esquerda para a Direita",
    "gui.howtos.imagine.step_imagineUpDown": "Mexa-se de Cima para Baixo",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Mude de Fantasia",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Deslize até um Ponto",
    "gui.howtos.imagine.step_imagineGrowShrink": "Aumente ou diminua",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Escolher Outro Cenário",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Trocar Cenário",
    "gui.howtos.imagine.step_imagineRecordASound": "Adicionar um som",
    "gui.howtos.imagine.step_imagineChooseSound": "Escolha Seu Som",
    "gui.howtos.make-music.name": "Faça Música",
    "gui.howtos.Make-Music.step_PickInstrument": "Escolha um Ator Instrumento",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Toque Um Som Quando Clicado",
    "gui.howtos.Make-Music.step_MakeSong": "Crie uma Canção",
    "gui.howtos.make-music.step_MakeBeat": "Escolha um Tambor & Faça uma Batida",
    "gui.howtos.make-music.step_MakeBeatBox": "Selecione o Ator Microfone & Beatbox Surpresa",
    "gui.howtos.story.name": "Crie uma História",
    "gui.howtos.story.step_addbg": "Adicione um Cenário",
    "gui.howtos.story.step_addsprite": "Adicione um Personagem",
    "gui.howtos.story.step_saysomething": "Diga Algo",
    "gui.howtos.story.step_addanothersprite": "Adicione Outro Personagem",
    "gui.howtos.story.step_flip": "Mude a Direção",
    "gui.howtos.story.step_conversation": "Crie um Diálogo",
    "gui.howtos.story.addanotherbg": "Adicione Outro Cenário",
    "gui.howtos.story.step_swithbg": "Trocar Cenário",
    "gui.howtos.story.step_hidewizard": "Esconda um Personagem",
    "gui.howtos.story.step_showwizard": "Mostre um Personagem",
    "gui.howtos.make-a-chase-game.name": "Faça um Jogo de Perseguição",
    "gui.howtos.Chase-Game.step_BG": "Adicione um Cenário",
    "gui.howtos.chase-game.step_AddOcto": "Adicione um Ator",
    "gui.howtos.make-music.step_LeftRight": "Mova para a Direita & Esquerda com as Setas do Teclado",
    "gui.howtos.Chase-Game.step_UpDown": "Mova para Cima & para Baixo com as Setas do Teclado",
    "gui.howtos.Chase-Game.step_AddStar": "Adicione Outro Ator",
    "gui.howtos.Chase-Game.step_MoveRandom": "Mova Aleatoriamente",
    "gui.howtos.Chase-Game.step_WhenTouch": "Quando Tocar no Ator Polvo, Toque o Som",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Crie uma Variável de Pontuação",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Quando Tocar no Ator Polvo, Adicione a Pontuação",
    "gui.howtos.animate-char.name": "Anime um Ator",
    "gui.howtos.animate-char.step_addbg": "Adicione um Cenário",
    "gui.howtos.animate-char.step_addsprite": "Adicione um Ator",
    "gui.howtos.animate-char.step_saysomething": "Diga Algo",
    "gui.howtos.animate-char.step_addsound": "Adicione Som",
    "gui.howtos.animate-char.step_animatetalking": "Anime uma Fala",
    "gui.howtos.animate-char.step_arrowkeys": "Mova Usando as Setas",
    "gui.howtos.animate-char.step_jump": "Pular",
    "gui.howtos.animate-char.step_changecolor": "Mude a Cor",
    "gui.howtos.make-a-game.name": "Faça um Jogo de Clicar",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Escolha Um Ator",
    "gui.howtos.make-a-game.step_GamePlaySound": "Toque Um Som Quando Clicado",
    "gui.howtos.make-a-game.step_GameAddScore": "Crie uma Variável de Pontuação",
    "gui.howtos.make-a-game.step_GameChangeScore": "Quando Clicado, Aumentar a Pontuação",
    "gui.howtos.make-a-game.step_Random": "Vá para posição aleatória",
    "gui.howtos.make-music.step_GameChangeColor": "Mude a Cor",
    "gui.howtos.make-music.step_ResetScore": "Reinicie a Pontuação",
    "gui.howtos.make-it-fly.name": "Faça Algo Voar",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Escolha um Fundo para o Céu",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Escolha um personagem",
    "gui.howtos.fly.step_stepflySaySomething": "Diga Algo",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mova Usando as Setas do Teclado",
    "gui.howtos.fly.step_stepflyChooseObject": "Escolha um Objeto para Coletar",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Escolha um Objeto para se Mover",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Selecione seu Personagem",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Adicione Pontuação",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Mantenha Pontuação",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Adicionar Cenário",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mova o Cenário",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Próxima Fantasia",
    "gui.howtos.pong": "Jogo tipo Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Adicione um Cenário",
    "gui.howtos.pong.step_pongAddBallSprite": "Adicione uma Bola",
    "gui.howtos.pong.step_pongBounceAround": "Pule por Aí",
    "gui.howtos.pong.step_pongAddPaddle": "Adicione uma Raquete",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mova a Raquete",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selecione o Ator da Bola",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Adicione Código para Fazer a Bola Quicar da Raquete",
    "gui.howtos.pong.step_pongAddAScore": "Adicione Pontuação",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Escolha \"Pontuação\" do Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insira o Bloco \"Adicione à Pontuação\"",
    "gui.howtos.pong.step_pongResetScore": "Reinicie a Pontuação",
    "gui.howtos.pong.step_pongAddLineSprite": "Adicione uma Linha",
    "gui.howtos.pong.step_pongGameOver": "Fim de Jogo",
    "gui.howtos.code-cartoon": "Programe uma Animação",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Diga Algo Quando Clicar na Bandeira Verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Anime um Personagem Quando Clicar Nele",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Selecione Outro Personagem",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use o Sinal de Menos para Ficar Menor",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Faça um Personagem Crescer e Diminuir",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Selecione Outro Personagem",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Pule",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Clique em um Personagem para Mudar de Cena",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Deslize Por Aí",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Mude de Fantasia",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Escolha Mais Personagens para Adicionar à sua Animação",
    "gui.howtos.cartoon-network": "Anime um Jogo de Aventura",
    "gui.howtos.cartoon-network.step_CNcharacter": "Escolha um personagem para mostrar",
    "gui.howtos.cartoon-network.step_CNsay": "Diga Algo",
    "gui.howtos.cartoon-network.step_CNglide": "Deslize Por Aí",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Escolha um Objeto para Perseguir",
    "gui.howtos.cartoon-network.step_CNcollect": "Colete Objetos",
    "gui.howtos.cartoon-network.step_CNvariable": "Crie uma Variável de Pontuação",
    "gui.howtos.cartoon-network.step_CNscore": "Mantenha Pontuação",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Subiu de Nível: Altere o Cenário",
    "gui.howtos.videosens.name": "Detecção de Vídeo",
    "gui.howtos.videosens.step_addextension": "Adicionar uma Extensão",
    "gui.howtos.videosens.step_pet": "Faça Carinho no Gato",
    "gui.howtos.videosens.step_animate": "Animar",
    "gui.howtos.videosens.step_pop": "Estoure o Balão",
    "gui.howtos.say-it-out-loud": "Crie Animações que falam",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Adicione o Texto para os blocos de Fala",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Diga Algo",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Definir uma Voz",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mova Por Aí",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Adicione um Cenário",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Adicione Outro Personagem",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cante uma Música",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Mude a Cor",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Gire",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Aumente ou diminua",
    "gui.howtos.talking": "Contando Histórias",
    "gui.howtos.talking.step_talesAddExtension": "Clique para Adicionar Blocos de Texto-para-Fala",
    "gui.howtos.talking.step_talesChooseSprite": "Selecione um Ator",
    "gui.howtos.talking.step_talesSaySomething": "Faça um Personagem Falar",
    "gui.howtos.talking.step_talesChooseBackdrop": "Selecionar Cenário",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Clique em um Personagem para Ir ao Próximo Pano de Fundo",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Escolha Outro Ator",
    "gui.howtos.talking.step_talesMoveAround": "Mova Por Aí",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Escolher Outro Cenário",
    "gui.howtos.talking.step_talesAnimateTalking": "Anime uma Fala",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Escolher Outro Cenário",
    "gui.howtos.talking.step_talesChooseSound": "Escolha uma Música e Dance",
    "gui.howtos.talking.step_talesDanceMoves": "Passos de Dança",
    "gui.howtos.talking.step_talesAskAnswer": "Pegue os Blocos de Pergunta e Resposta da Categoria Sensores",
    "gui.howtos.add-sprite.name": "Adicione um Ator",
    "gui.howtos.add-sprite.step_addSprite": "Adicione um Ator",
    "gui.howtos.add-a-backdrop.name": "Adicione um Cenário",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Adicione um Cenário",
    "gui.howtos.change-size.name": "Mude o Tamanho",
    "gui.howtos.change-size.step_changeSize": "Mude o Tamanho",
    "gui.howtos.glide-around.name": "Deslize Por Aí",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Deslize Por Aí",
    "gui.howtos.change-size.step_glideAroundPoint": "Deslize até um Ponto",
    "gui.howtos.record-a-sound.name": "Grave um Som",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Clique na Aba \"Sons\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Clique em 'Gravar'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pressione o botão Gravar",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Escolha Seu Som",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Toque Seu Som",
    "gui.howtos.spin-video.name": "Faça-o girar",
    "gui.howtos.change-size.step_spinTurn": "Vire",
    "gui.howtos.change-size.step_spinPointInDirection": "Mude a Direção",
    "gui.howtos.hide-and-show.name": "Esconde-Esconde",
    "gui.howtos.change-size.step_hideAndShow": "Esconde-Esconde",
    "gui.howtos.switch-costume.name": "Anime um Ator",
    "gui.howtos.change-size.step_switchCostumes": "Anime um Ator",
    "gui.howtos.move-around-with-arrow-keys.name": "Use as Setas do Teclado",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Mova para a esquerda e para a direita",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mova para cima e para baixo",
    "gui.howtos.add-effects.name": "Adicionar Efeitos",
    "gui.howtos.videosens.step_addEffects": "Adicionar Efeitos",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "Toque instrumentos e tambores.",
    "gui.extension.pen.name": "Caneta",
    "gui.extension.pen.description": "Desenhe com os seus atores.",
    "gui.extension.videosensing.name": "Detecção de Vídeo",
    "gui.extension.videosensing.description": "Detecte movimento com a câmera.",
    "gui.extension.text2speech.name": "Texto para Fala",
    "gui.extension.text2speech.description": "Faça seus projetos falarem",
    "gui.extension.translate.name": "Traduzir",
    "gui.extension.translate.description": "Traduza texto para várias línguas.",
    "gui.extension.makeymakey.description": "Transforme tudo em uma tecla.",
    "gui.extension.microbit.description": "Conecte seus projetos ao mundo.",
    "gui.extension.microbit.connectingMessage": "Conectando",
    "gui.extension.ev3.description": "Construa robôs e outras coisas interativas.",
    "gui.extension.ev3.connectingMessage": "Conectando. Garanta que o pin no seu EV3 esteja configurado para 1234.",
    "gui.extension.boost.description": "Traga criações robóticas para a vida",
    "gui.extension.boost.connectingMessage": "Conectando",
    "gui.extension.wedo2.description": "Crie com motores e sensores.",
    "gui.extension.wedo2.connectingMessage": "Conectando",
    "gui.extension.gdxfor.description": "Detecte se empurrar, puxar, movimentos e giros.",
    "gui.extension.gdxfor.connectingMessage": "Conectando",
    "gui.libraryTags.all": "Tudo",
    "gui.libraryTags.animals": "Animais",
    "gui.libraryTags.dance": "Dança",
    "gui.libraryTags.effects": "Efeitos",
    "gui.libraryTags.fantasy": "Imaginários",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Comida",
    "gui.libraryTags.indoors": "Interior",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "Notas",
    "gui.libraryTags.outdoors": "Exterior",
    "gui.libraryTags.patterns": "Padrões",
    "gui.libraryTags.people": "Pessoas",
    "gui.libraryTags.percussion": "Percussão",
    "gui.libraryTags.space": "Espaço",
    "gui.libraryTags.sports": "Esportes",
    "gui.libraryTags.underwater": "Embaixo d'água",
    "gui.libraryTags.voice": "Voz",
    "gui.libraryTags.wacky": "Maluco",
    "gui.libraryTags.animation": "Animações",
    "gui.libraryTags.art": "Arte",
    "gui.libraryTags.games": "Jogos",
    "gui.libraryTags.stories": "Histórias",
    "gui.libraryTags.letters": "Letras",
    "gui.opcodeLabels.direction": "direção",
    "gui.opcodeLabels.xposition": "posição x",
    "gui.opcodeLabels.yposition": "posição y",
    "gui.opcodeLabels.size": "tamanho",
    "gui.opcodeLabels.costumename": "nome da fantasia",
    "gui.opcodeLabels.costumenumber": "fantasia número",
    "gui.opcodeLabels.backdropname": "nome do cenário",
    "gui.opcodeLabels.backdropnumber": "cenário número",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "ritmo",
    "gui.opcodeLabels.answer": "resposta",
    "gui.opcodeLabels.loudness": "nível de ruído",
    "gui.opcodeLabels.username": "nome de usuário",
    "gui.opcodeLabels.year": "ano",
    "gui.opcodeLabels.month": "mês",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "dia da semana",
    "gui.opcodeLabels.hour": "hora",
    "gui.opcodeLabels.minute": "minuto",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronômetro",
    "gui.projectLoader.loadError": "O arquivo do projeto selecionado falhou ao carregar. ",
    "gui.sharedMessages.backdrop": "cenário{index}",
    "gui.sharedMessages.costume": "fantasia{index}",
    "gui.sharedMessages.sprite": "Ator{index}",
    "gui.sharedMessages.pop": "saltar",
    "gui.sharedMessages.replaceProjectWarning": "Substituir conteúdos do projeto atual?",
    "gui.sharedMessages.loadFromComputerTitle": "Carregar do seu computador",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Escuro",
    "gui.theme.highContrast": "Alto Contraste",
    "gui.gui.defaultProjectTitle": "Projeto Scratch",
    "boost.color.any": "qualquer cor",
    "boost.color.black": "preto",
    "boost.color.blue": "azul",
    "boost.color.green": "verde",
    "boost.color.red": "vermelho",
    "boost.color.white": "branco",
    "boost.color.yellow": "amarelo",
    "boost.getMotorPosition": "posição do motor [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "ângulo de inclinação [TILT_DIRECTION]",
    "boost.motorDirection.backward": "por aí",
    "boost.motorDirection.forward": "por aqui",
    "boost.motorDirection.reverse": "inverter",
    "boost.motorOff": "desligue o motor [MOTOR_ID]",
    "boost.motorOn": "ligue o motor [MOTOR_ID]",
    "boost.motorOnFor": "ligue o motor [MOTOR_ID] por [DURATION] segundos",
    "boost.motorOnForRotation": "ligue o motor [MOTOR_ID] por [ROTATION] rotações",
    "boost.seeingColor": "vendo bloco [COLOR]?",
    "boost.setLightHue": "defina a cor como [HUE]",
    "boost.setMotorDirection": "mude a direção do motor [MOTOR_ID] para [MOTOR_DIRECTION]",
    "boost.setMotorPower": "mude a velocidade do motor [MOTOR_ID] para [POWER] %",
    "boost.tiltDirection.any": "qualquer",
    "boost.tiltDirection.down": "baixo",
    "boost.tiltDirection.left": "esquerda",
    "boost.tiltDirection.right": "direita",
    "boost.tiltDirection.up": "para cima",
    "boost.whenColor": "quando um bloco [COLOR] for visto",
    "boost.whenTilted": "quando inclinado para [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "som de bip [NOTE] por [TIME] segundos",
    "ev3.buttonPressed": "botão [PORT] pressionado?",
    "ev3.getBrightness": "brilho",
    "ev3.getDistance": "distância",
    "ev3.getMotorPosition": "posição do motor [PORT]",
    "ev3.motorSetPower": "defina potência do motor [PORT] em [POWER] %",
    "ev3.motorTurnClockwise": "gire o motor [PORT] nesse sentido por [TIME] segundos",
    "ev3.motorTurnCounterClockwise": "gire o motor [PORT] naquele sentido por [TIME] segundos",
    "ev3.whenBrightnessLessThan": "quando brilho < [DISTANCE]",
    "ev3.whenButtonPressed": "quando botão [PORT] for pressionado",
    "ev3.whenDistanceLessThan": "quando distância < [DISTANCE]",
    "gdxfor.getAcceleration": "aceleração [DIRECTION]",
    "gdxfor.getForce": "força",
    "gdxfor.getSpin": "velocidade de rotação [DIRECTION]",
    "gdxfor.getTilt": "ângulo de inclinação para [TILT]",
    "gdxfor.isFreeFalling": "caindo?",
    "gdxfor.isTilted": "inclinado para [TILT]?",
    "gdxfor.pulled": "puxado",
    "gdxfor.pushed": "empurrado",
    "gdxfor.shaken": "agitado",
    "gdxfor.startedFalling": "começar a cair",
    "gdxfor.tiltDirectionMenu.any": "qualquer",
    "gdxfor.tiltDirectionMenu.back": "trás",
    "gdxfor.tiltDirectionMenu.front": "frente",
    "gdxfor.tiltDirectionMenu.left": "esquerda",
    "gdxfor.tiltDirectionMenu.right": "direita",
    "gdxfor.turnedFaceDown": "virado para baixo",
    "gdxfor.turnedFaceUp": "virado para cima",
    "gdxfor.whenForcePushedOrPulled": "quando o sensor de força estiver sendo [PUSH_PULL]",
    "gdxfor.whenGesture": "quando [GESTURE]",
    "gdxfor.whenTilted": "quando inclinado para [TILT]",
    "makeymakey.downArrow": "seta para baixo",
    "makeymakey.downArrowShort": "baixo",
    "makeymakey.leftArrow": "seta para esquerda",
    "makeymakey.leftArrowShort": "esquerda",
    "makeymakey.rightArrow": "seta para direita",
    "makeymakey.rightArrowShort": "direita",
    "makeymakey.spaceKey": "espaço",
    "makeymakey.upArrow": "seta para cima",
    "makeymakey.upArrowShort": "para cima",
    "makeymakey.whenKeyPressed": "quando a tecla [KEY] for pressionada",
    "makeymakey.whenKeysPressedInOrder": "quando [SEQUENCE] forem pressionados em ordem",
    "microbit.buttonsMenu.any": "qualquer",
    "microbit.clearDisplay": "limpe a tela",
    "microbit.defaultTextToDisplay": "Oi!",
    "microbit.displaySymbol": "exiba [MATRIX]",
    "microbit.displayText": "exiba o texto [TEXT]",
    "microbit.gesturesMenu.jumped": "pular",
    "microbit.gesturesMenu.moved": "mover",
    "microbit.gesturesMenu.shaken": "agitar",
    "microbit.isButtonPressed": "botão [BTN] pressionado?",
    "microbit.isTilted": "inclinado para [DIRECTION]?",
    "microbit.pinStateMenu.off": "desligado",
    "microbit.pinStateMenu.on": "ligado",
    "microbit.tiltAngle": "ângulo de inclinação para [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "qualquer",
    "microbit.tiltDirectionMenu.back": "trás",
    "microbit.tiltDirectionMenu.front": "frente",
    "microbit.tiltDirectionMenu.left": "esquerda",
    "microbit.tiltDirectionMenu.right": "direita",
    "microbit.whenButtonPressed": "quando o botão [BTN] for pressionado",
    "microbit.whenGesture": "quando [GESTURE]",
    "microbit.whenPinConnected": "quando o pino [PIN] for conectado",
    "microbit.whenTilted": "quando inclinado para [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "alterar ritmo por [TEMPO]",
    "music.drumBass": "(2) Bumbo",
    "music.drumBongo": "(13) Bongô",
    "music.drumCabasa": "(15) Afoxé",
    "music.drumClaves": "(9) Claves Cubanas",
    "music.drumClosedHiHat": "(6) Prato Chimbau",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Chocalho",
    "music.drumCrashCymbal": "(4) Prato",
    "music.drumCuica": "(18) Cuíca",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Palmas",
    "music.drumOpenHiHat": "(5) Prato Hi-Hat",
    "music.drumSideStick": "(3) Bastão Lateral",
    "music.drumSnare": "(1) Tarol",
    "music.drumTambourine": "(7) Pandeiro",
    "music.drumTriangle": "(12) Triângulo",
    "music.drumVibraslap": "(17) Queixada",
    "music.drumWoodBlock": "(10) Bloco Sonoro",
    "music.getTempo": "ritmo",
    "music.instrumentBass": "(6) Baixo",
    "music.instrumentBassoon": "(14) Fagote",
    "music.instrumentCello": "(8) Violoncelo",
    "music.instrumentChoir": "(15) Coral",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) Guitarra Elétrica",
    "music.instrumentElectricPiano": "(2) Teclado",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) Violão",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caixa de Música",
    "music.instrumentOrgan": "(3) Órgão",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofone",
    "music.instrumentSteelDrum": "(18) Tambor de Aço",
    "music.instrumentSynthLead": "(20) Sintetizador principal",
    "music.instrumentSynthPad": "(21) Bloco Sintetizador",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibrafone",
    "music.instrumentWoodenFlute": "(13) Flauta de madeira",
    "music.midiPlayDrumForBeats": "toque instrumento [DRUM] por [BEATS] batidas",
    "music.midiSetInstrument": "mudar instrumento para [INSTRUMENT]",
    "music.playDrumForBeats": "toque instrumento [DRUM] por [BEATS] batidas",
    "music.playNoteForBeats": "toque a nota [NOTE] por [BEATS] batidas",
    "music.restForBeats": "pausa por [BEATS] batidas",
    "music.setInstrument": "mudar instrumento para [INSTRUMENT]",
    "music.setTempo": "ajuste ritmo para [TEMPO]",
    "pen.categoryName": "Caneta",
    "pen.changeColorParam": "adicione [VALUE] [COLOR_PARAM] da caneta",
    "pen.changeHue": "adicione [HUE] a cor da caneta ",
    "pen.changeShade": "adicione [SHADE] a tonalidade da caneta ",
    "pen.changeSize": "adicione [SIZE] ao tamanho da caneta",
    "pen.clear": "apague tudo",
    "pen.colorMenu.brightness": "ao brilho",
    "pen.colorMenu.color": "a cor",
    "pen.colorMenu.saturation": "a saturação",
    "pen.colorMenu.transparency": "a transparência",
    "pen.penDown": "use a caneta",
    "pen.penUp": "levante a caneta",
    "pen.setColor": "mude a cor da caneta para [COLOR]",
    "pen.setColorParam": "mude [COLOR_PARAM] da caneta para [VALUE]",
    "pen.setHue": "mude a cor da caneta para [HUE]",
    "pen.setShade": "mude a tonalidade da caneta para [SHADE]",
    "pen.setSize": "mude o tamanho da caneta para [SIZE]",
    "pen.stamp": "carimbe",
    "speech.defaultWhenIHearValue": "vamos lá",
    "speech.extensionName": "Transformação de Fala em Texto",
    "speech.listenAndWait": "escute e espere",
    "speech.speechReporter": "fala",
    "speech.whenIHear": "quando eu escutar [PHRASE]",
    "text2speech.alto": "loud",
    "text2speech.categoryName": "Texto para Fala",
    "text2speech.defaultTextToSpeak": "olá",
    "text2speech.giant": "gigante",
    "text2speech.kitten": "gatinho",
    "text2speech.setLanguageBlock": "defina o idioma como [LANGUAGE]",
    "text2speech.setVoiceBlock": "defina a voz para [VOICE]",
    "text2speech.speakAndWaitBlock": "fale [WORDS]",
    "text2speech.squeak": "rangido",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traduzir",
    "translate.defaultTextToTranslate": "olá",
    "translate.translateBlock": "traduza [WORDS] para [LANGUAGE]",
    "translate.viewerLanguage": "idioma",
    "videoSensing.categoryName": "Detecção de Vídeo",
    "videoSensing.direction": "direção",
    "videoSensing.motion": "movimento",
    "videoSensing.off": "desligado",
    "videoSensing.on": "ligado",
    "videoSensing.onFlipped": "ligado invertido",
    "videoSensing.setVideoTransparency": "ajuste transparência do vídeo para [TRANSPARENCY]",
    "videoSensing.sprite": "ator",
    "videoSensing.stage": "palco",
    "videoSensing.videoOn": "vídeo [ATTRIBUTE] para [SUBJECT]",
    "videoSensing.videoToggle": "mude vídeo para [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "quando detectar sensor de vídeo > [REFERENCE]",
    "wedo2.getDistance": "distância",
    "wedo2.getTiltAngle": "ângulo de inclinação [TILT_DIRECTION]",
    "wedo2.isTilted": "inclinado para [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "por aí",
    "wedo2.motorDirection.forward": "por aqui",
    "wedo2.motorDirection.reverse": "inverter",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "todos os motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "desligue o motor [MOTOR_ID]",
    "wedo2.motorOn": "ligue o motor [MOTOR_ID]",
    "wedo2.motorOnFor": "ligue o motor [MOTOR_ID] por [DURATION] segundos",
    "wedo2.playNoteFor": "toque a nota [NOTE] por [DURATION] segundos",
    "wedo2.setLightHue": "defina a cor como [HUE]",
    "wedo2.setMotorDirection": "defina a direção de [MOTOR_ID] como [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "defina a potência de [MOTOR_ID] como [POWER]",
    "wedo2.tiltDirection.any": "qualquer",
    "wedo2.tiltDirection.down": "baixo",
    "wedo2.tiltDirection.left": "esquerda",
    "wedo2.tiltDirection.right": "direita",
    "wedo2.tiltDirection.up": "para cima",
    "wedo2.whenDistance": "quando distância [OP] [REFERENCE]",
    "wedo2.whenTilted": "quando inclinado para [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Cor",
    "paint.paintEditor.saturation": "Saturação",
    "paint.paintEditor.brightness": "Brilho",
    "paint.paintEditor.costume": "Fantasia",
    "paint.paintEditor.group": "Agrupar",
    "paint.paintEditor.ungroup": "Desagrupar",
    "paint.paintEditor.undo": "Desfazer",
    "paint.paintEditor.redo": "Refazer",
    "paint.paintEditor.forward": "Pra frente",
    "paint.paintEditor.backward": "Pra Trás",
    "paint.paintEditor.front": "Frente",
    "paint.paintEditor.back": "Atrás",
    "paint.paintEditor.more": "Mais",
    "paint.modeTools.brushSize": "Tamanho",
    "paint.modeTools.eraserSize": "Tamanho da borracha",
    "paint.modeTools.copy": "Copiar",
    "paint.modeTools.paste": "Colar",
    "paint.modeTools.delete": "Apagar",
    "paint.modeTools.curved": "Curvado",
    "paint.modeTools.pointed": "Apontado",
    "paint.modeTools.thickness": "Espessura",
    "paint.modeTools.flipHorizontal": "Espelhar Horizontalmente",
    "paint.modeTools.flipVertical": "Espelhar Verticalmente",
    "paint.modeTools.filled": "Preenchido",
    "paint.modeTools.outlined": "Contornar",
    "paint.paintEditor.bitmap": "Converter para Bitmap",
    "paint.paintEditor.vector": "Converter pra Vetor",
    "paint.paintEditor.fill": "Preencher",
    "paint.paintEditor.stroke": "Contornar",
    "paint.brushMode.brush": "Pincel",
    "paint.eraserMode.eraser": "Apagador",
    "paint.fillMode.fill": "Preencher",
    "paint.lineMode.line": "Linha",
    "paint.ovalMode.oval": "Círculo",
    "paint.rectMode.rect": "Retângulo",
    "paint.reshapeMode.reshape": "Remodelar",
    "paint.roundedRectMode.roundedRect": "Retângulo Arredondado",
    "paint.selectMode.select": "Selecionar",
    "paint.textMode.text": "Texto",
    "paint.colorPicker.swap": "Troque"
  },
  "rap": {
    "gui.alerts.lostPeripheralConnection": "ko ŋaro a te hahaʾo hai {extensionName}.",
    "gui.alerts.tryAgain": "ka aŋa haka ʾou",
    "gui.alerts.download": "haka topa",
    "gui.connection.reconnect": "ka haka uru",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "pute",
    "gui.backpack.errorBackpack": "ko hape ā i te haī haŋa o te putē",
    "gui.backpack.loadingBackpack": "haī...",
    "gui.backpack.more": "te tahi",
    "gui.backpack.emptyBackpack": "ina etahi meʾe i rote putē",
    "gui.unsupportedBrowser.label": "te navegador kai tano",
    "gui.unsupportedBrowser.errorLabel": "ko ai a e tahi hape",
    "gui.unsupportedBrowser.notRecommended": "ko te aroha, ko hapeʾa te Scratch kai tano te version o ta navegador. Ka aŋa haka ʾou te versión hopeʾa o te navegador hai soporte, pahe Google Chrome, Mozilla Firefox, Microsoft Edge o Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "a tuʾa ",
    "gui.unsupportedBrowser.previewfaq": "mo ata aŋi aŋi, ka uru ki te {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "te rava ʾui (FAQ)",
    "gui.cards.all-tutorials": "haka hapi",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "puru",
    "gui.cards.more-things-to-try": "¡a ta rahi te meʾe mo haka atu!",
    "gui.cards.see-more": "ata uʾi",
    "gui.comingSoon.message1": "ina koe ko tipa tipa, i matou e aŋa a mo ra meʾe {emoji}",
    "gui.comingSoon.message2": "Na he oho mai…",
    "gui.comingSoon.message3": "e aŋa a mo ra meʾe {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "ka ravaʾa a te dispositivo",
    "gui.connection.auto-scanning.prescan": "e hahine te dispositivo e ka haʾamata te kimi",
    "gui.connection.auto-scanning.pressbutton": "ka ŋatu te pito pito o ta dispositivo ",
    "gui.connection.auto-scanning.start-search": "ē haʾamata te kimi",
    "gui.connection.connecting-searchbutton": " e kimi ā...",
    "gui.connection.auto-scanning.try-again": "e aŋa haka ʾou",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "ko raʾu a",
    "gui.connection.disconnect": "ka hore",
    "gui.connection.go-to-editor": "e oho ki te editor",
    "gui.connection.connecting-cancelbutton": "e kimi a te raʾu …",
    "gui.connection.error.errorMessage": "Ups, ko hapeʾa e tahi meʾe",
    "gui.connection.error.tryagainbutton": "e aŋa haka ʾou",
    "gui.connection.error.helpbutton": "hāʾuʾu",
    "gui.connection.peripheral-name-label": "iŋoa o te dispositivo",
    "gui.connection.connect": "Conectar",
    "gui.connection.scanning.lookingforperipherals": "ē kimi ā te dispositivo",
    "gui.connection.scanning.noPeripheralsFound": "ka ravaʾa a te dispositivo",
    "gui.connection.scanning.instructions": "ka tuhita dispositivo hāŋa",
    "gui.connection.search": "haka a",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "ka uʾi riva riva a na ai ko hahaʾo a te scratch link instalado",
    "gui.connection.unavailable.enablebluetooth": "ka uʾi riva riva ko tanoʾa te bluetooth",
    "gui.connection.unavailable.tryagainbutton": "e aŋa haka ʾou",
    "gui.connection.unavailable.helpbutton": "hāʾuʾu",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "oho",
    "gui.controls.stop": "noho",
    "gui.crashMessage.label": "¡Ups! Ko hapeʾa e tahi meʾe",
    "gui.crashMessage.description": "ko te aroha, ko mate a te Scrach, ko haka aŋi aŋi a ki te Scratch nunaʾa. ka haī te pagina e ka aŋa hakaʾou.",
    "gui.crashMessage.errorNumber": "Su error ha sido registrado con id {errorId}",
    "gui.crashMessage.reload": "ka haī haka ʾou ",
    "gui.customProcedures.myblockModalTitle": "he manaʾu mo āŋa e tahi avahata poto roa mekerā",
    "gui.customProcedures.addAnInputNumberText": "ka hahaʾo te oʾo",
    "gui.customProcedures.numberTextType": "numera o papaʾi",
    "gui.customProcedures.addAnInputBoolean": "ka hahaʾo te oʾo",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "hahaʾo te parau papaʾi",
    "gui.customProcedures.runWithoutScreenRefresh": "ē āŋa i tu hora a",
    "gui.customProcedures.cancel": "haka motu",
    "gui.customProcedures.ok": "haʾatiʾa",
    "gui.SpriteInfo.direction": "ara",
    "gui.directionPicker.rotationStyles.allAround": "ki te taʾatoʾa kona",
    "gui.directionPicker.rotationStyles.leftRight": "maūi - mataʾu",
    "gui.directionPicker.rotationStyles.dontRotate": "ina ko teka",
    "gui.gui.addExtension": "ka hahaʾo te haka roa roa",
    "gui.gui.codeTab": "he ta",
    "gui.gui.backdropsTab": "tuʾa nui",
    "gui.gui.costumesTab": "diseños",
    "gui.gui.soundsTab": "pakeke",
    "gui.extensionLibrary.comingSoon": "na he oho mai",
    "gui.extensionLibrary.requires": "e ai",
    "gui.extensionLibrary.collaboration": "hai hāʾuʾu o",
    "gui.library.filterPlaceholder": "kimi",
    "gui.library.allTag": "taʾatoʾa",
    "gui.loader.message1": "e aŋa te bloques…",
    "gui.loader.message2": "haī te sprites...",
    "gui.loader.message3": "haī te pakeke...",
    "gui.loader.message4": "haī a te haka roa roa...",
    "gui.loader.message5": "pastoreando kuri...",
    "gui.loader.message6": "e tatara te nanos...",
    "gui.loader.message7": "e puhi a te korovo...",
    "gui.loader.message8": "haka titika te emojis...",
    "gui.loader.headline": "e haī a te aŋa",
    "gui.loader.creating": "e aŋa a te aŋa",
    "gui.accountMenu.profile": "he ariŋa",
    "gui.accountMenu.myStuff": "taʾaku meʾe",
    "gui.accountMenu.myClasses": "taʾaku hapi",
    "gui.accountMenu.myClass": "taʾaku hapi",
    "gui.accountMenu.accountSettings": "configuración o te cuenta",
    "gui.accountMenu.signOut": "eʾa",
    "gui.authorInfo.byUser": "hai {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "gui.menuBar.language": "Language",
    "general.username": "iŋoa o te usuario",
    "general.password": "Contraseña",
    "general.signIn": "ka mataki te sesión",
    "login.needHelp": "ko haŋa a koe mo hāʾuʾu atu?",
    "form.validationRequired": "te kona nei ē aŋa",
    "gui.menuBar.tutorialsLibrary": "haka hapi",
    "gui.menuBar.restoreSprite": "haka aŋa haka ʾou te sprite",
    "gui.menuBar.restoreSound": "haka aŋa haka ʾou te pakeke",
    "gui.menuBar.restoreCostume": "haka titika te diseño",
    "gui.menuBar.restore": "haka titika",
    "gui.menuBar.saveNow": "ka hapaʾo i te hora nei",
    "gui.menuBar.saveAsCopy": "ka hapaʾo te copia",
    "gui.menuBar.remix": "e aŋa haka ʾou",
    "gui.menuBar.new": "apī",
    "gui.menuBar.file": "parau hapaʾo",
    "gui.menuBar.downloadToComputer": "hapaʾo te kona apapa",
    "gui.menuBar.edit": "haka titika",
    "gui.menuBar.turboModeOff": "ka haka hore hai Turbo",
    "gui.menuBar.turboModeOn": "ē āŋa hai huru turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "ka rao mai ki te Scratch",
    "gui.menuBar.signIn": "ka mataki te sesión",
    "gui.gui.projectTitlePlaceholder": "iŋoa o te aŋa i nei",
    "gui.menuBar.saveNowLink": "ka hapaʾo i te hora nei",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "e amui",
    "gui.menuBar.share": "vaʾai",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "hāʾuʾu",
    "gui.modal.back": "a tuʾa ",
    "gui.monitor.listMonitor.empty": "(kore)",
    "gui.monitor.listMonitor.listLength": "roa roa o te {length}",
    "gui.monitor.contextMenu.default": "normal readout",
    "gui.monitor.contextMenu.large": "nui nui tano",
    "gui.monitor.contextMenu.slider": "haka nini",
    "gui.monitor.contextMenu.sliderRange": "e kamiare te rango p te deslizador ",
    "gui.monitor.contextMenu.import": "e maʾu mai mai haho",
    "gui.monitor.contextMenu.export": "exportar",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "For all sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "For this sprite only",
    "gui.gui.cloudVariableOption": "variable i te raŋi (hapaʾo i rote servidor)",
    "gui.gui.variablePromptAllSpritesMessage": "te variable nei he rovaʾa koe i te sprite taʾa toʾa",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "haka motu",
    "gui.prompt.ok": "haʾatiʾa",
    "gui.playbackStep.stopMsg": "oho",
    "gui.playbackStep.playMsg": "haka āŋa",
    "gui.playbackStep.loadingMsg": "haī...",
    "gui.playbackStep.saveMsg": "hapaʾo ",
    "gui.playbackStep.reRecordMsg": "e graba haka ʾou",
    "gui.recordModal.title": "ka graba te pakeke",
    "gui.recordingStep.beginRecord": "mo haʾamata te grabacion ka ŋatu hai clic te rua pito pito",
    "gui.recordingStep.permission": "{arrow} e hatiʾa mai koe mo aŋa hai microfono",
    "gui.recordingStep.stop": "haka noho te grabacion",
    "gui.recordingStep.record": "hapaʾo",
    "gui.sliderModal.min": "te mau iti",
    "gui.sliderModal.max": "te mau rahi",
    "gui.sliderModal.title": "e kamiare te rango p te deslizador ",
    "gui.sliderPrompt.cancel": "haka motu",
    "gui.sliderPrompt.ok": "haʾatiʾa",
    "gui.soundEditor.sound": "pakeke",
    "gui.soundEditor.play": "haka āŋa",
    "gui.soundEditor.stop": "oho",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "hapaʾo ",
    "gui.soundEditor.undo": "moumou",
    "gui.soundEditor.redo": "he anga haka ʾou",
    "gui.soundEditor.faster": "ata horohorou",
    "gui.soundEditor.slower": "ata kora iti",
    "gui.soundEditor.echo": "reʾo ŋaro",
    "gui.soundEditor.robot": "makini",
    "gui.soundEditor.louder": "a ta puai",
    "gui.soundEditor.softer": "a ta rehe",
    "gui.soundEditor.reverse": "rori",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "iŋoa",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "haka tikeʾa",
    "gui.SpriteInfo.size": "he haito",
    "gui.spriteSelectorItem.contextMenuDuplicate": "haka rahi",
    "gui.spriteSelectorItem.contextMenuExport": "exportar",
    "gui.spriteSelectorItem.contextMenuDelete": "haka kore",
    "gui.spriteSelector.addSpriteFromLibrary": "Choose a Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "ka paru",
    "gui.spriteSelector.addSpriteFromSurprise": "he mahia etahi meʾe",
    "gui.spriteSelector.addSpriteFromFile": "haka eke te meʾe",
    "gui.stageHeader.stageSizeLarge": "ka kamiare te escenario iti iti ",
    "gui.stageHeader.stageSizeSmall": "ka kamiare te escenario nui nui",
    "gui.stageHeader.stageSizeFull": "e oho ki te teata nui nui",
    "gui.stageHeader.stageSizeUnFull": "e eʾa mai te teata nui nui",
    "gui.stageHeader.fullscreenControl": "control ki te teata nui nui",
    "gui.spriteSelector.addBackdropFromLibrary": "ka aʾaru te tuʾa nui",
    "gui.stageSelector.addBackdropFromPaint": "ka paru",
    "gui.stageSelector.addBackdropFromSurprise": "he mahia etahi meʾe",
    "gui.stageSelector.addBackdropFromFile": "ka haka ēke te tuʾa nui",
    "gui.stageSelector.stage": "Ahu",
    "gui.stageSelector.backdrops": "tuʾa nui",
    "gui.telemetryOptIn.label": "e haka ite te estadistica ki te Scratch ",
    "gui.telemetryOptIn.body1": "te nunaʾa o te Scratch e kimi a pehe ana aŋa te Scratcha a te Ao taʾatoʾa. mo haʾuʾu nei aŋa , e riva ro mo hatiʾa ki te Scratch mo haka oho te información automatico ki te nunaʾa aŋa o te Scratch.",
    "gui.telemetryOptIn.body2": "te información e haʾaputu nei, he reʾo, aŋa o te bloques e he aŋa vara vara pahe hapaʾo, haī e he eke te aŋa. E ko toʾo te información o te unʾu. e riva ro mo ʾui {privacyPolicyLink} mo te tahi información.",
    "gui.telemetryOptIn.privacyPolicyLink": "poritika o te privacidad",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "modo turbo",
    "gui.webglModal.label": "ta navegador ina kai tano mo te WebGL",
    "gui.webglModal.description": "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Scratch 3.0 to run.",
    "gui.webglModal.webgllink": "e ko tano te WebGL",
    "gui.webglModal.back": "a tuʾa ",
    "gui.webglModal.previewfaq": "mo ata aŋi aŋi, ka uru ki te {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "te rava ʾui (FAQ)",
    "gui.costumeLibrary.chooseABackdrop": "ka aʾaru te tuʾa nui",
    "gui.costumeLibrary.chooseACostume": "ka tuhi te diseño",
    "gui.costumeTab.addBackdropFromLibrary": "ka aʾaru te tuʾa nui",
    "gui.costumeTab.addCostumeFromLibrary": "ka tuhi te diseño",
    "gui.costumeTab.addBlankCostume": "ka paru",
    "gui.costumeTab.addSurpriseCostume": "he mahia etahi meʾe",
    "gui.costumeTab.addFileBackdrop": "ka haka ēke te tuʾa nui",
    "gui.costumeTab.addFileCostume": "Upload Costume",
    "gui.extensionLibrary.chooseAnExtension": "ka tuhi taʾa roa roa hāŋa",
    "gui.extensionLibrary.extensionUrl": "ka hahaʾo te URL o te haka roa roa",
    "gui.monitors.importListColumnPrompt": "¿he aha te tika mo aŋa (1-{numberOfColumns}?",
    "gui.recordingStep.alertMsg": "kai tano ʾa mo haʾamata te gravacion",
    "gui.soundLibrary.chooseASound": "ka tuhi taʾa meʾe hāŋa",
    "gui.soundTab.fileUploadSound": "ka hahaʾo te pakeke",
    "gui.soundTab.surpriseSound": "he mahia etahi meʾe",
    "gui.soundTab.recordSound": "hapaʾo",
    "gui.soundTab.addSoundFromLibrary": "ka tuhi taʾa meʾe hāŋa",
    "gui.spriteLibrary.chooseASprite": "Choose a Sprite",
    "gui.tipsLibrary.tutorials": "ka tuhi te meʾe mo haka hapī atu",
    "gui.alerts.createsuccess": "aŋa api aŋa era",
    "gui.alerts.createcopysuccess": "aŋa hapaʾo pahe aŋa hakaʾou e tahi",
    "gui.alerts.createremixsuccess": "ko hapaʾo a te aŋa pahe aŋa api haka ʾou",
    "gui.alerts.creating": "e aŋa a haka ʾou...",
    "gui.alerts.creatingCopy": "e haka aŋa haka ʾou te rua aŋa…",
    "gui.alerts.creatingRemix": "he aŋa haka ʾou te aŋa…",
    "gui.alerts.creatingError": "kai tano mo aŋa te aŋa, e riva ro mo aŋa haka ʾou",
    "gui.alerts.savingError": "kai tano ā mo hapaʾo te aŋa",
    "gui.alerts.savesuccess": "ko hapaʾo a te aŋa",
    "gui.alerts.saving": "hapaʾo a te aŋa...",
    "gui.alerts.cloudInfo": "ka manaʾu koe te variables i te raŋi e riva ro no mo hahaʾo te numera, taʾe te tiaraʾa e taʾe te simbolos. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "mo te ʾui",
    "gui.alerts.importing": "mai haho",
    "gui.defaultProject.meow": "reʾo kuri",
    "gui.defaultProject.variable": "toʾoku variable",
    "gui.howtos.intro-move-sayhello-hat.name": "mo haʾamata",
    "gui.howtos.intro-move.step_stepMove": "ka hahaʾo te bloque o te makenu",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "haka makenu te iŋoa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "ka tuhi etahi sprite o te tiaraʾa",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "mo ŋatu hai clic, e ŋatu e tahi pakeke",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "ka tuhi te ria tiaraʾa",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "ka kamiare te peni",
    "gui.howtos.animate-a-name.step_AnimateSpin": "ka tuhi te rua tiaraʾa e ka haka teka",
    "gui.howtos.animate-a-name.step_AnimateGrow": "ka tuhi te rua tiaraʾa e ka aŋa mo haka nui nui",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "ka manaʾu mo āŋa te himene",
    "gui.howtos.Make-Music.step_PickInstrument": "ka tuhi te sprite o te meʾe mo haka taŋi",
    "gui.howtos.Make-Music.step_PlaySoundClick": "mo ŋatu e koe te clic, e ŋatu te pakeke",
    "gui.howtos.Make-Music.step_MakeSong": "ka aŋa te hīmene",
    "gui.howtos.make-music.step_MakeBeat": "ka tuhi te tampuru ē ka aŋa te makenu",
    "gui.howtos.make-music.step_MakeBeatBox": "ka tuhi te sprite microfono e i te avahata pakeke pahe sorpresa",
    "gui.howtos.story.name": "e aŋa te aʾamu",
    "gui.howtos.story.step_addbg": "ka hahaʾo te tuʾa nui",
    "gui.howtos.story.step_addsprite": "ka hahaʾo te kope",
    "gui.howtos.story.step_saysomething": "ka ki e tahi meʾe",
    "gui.howtos.story.step_addanothersprite": "ka hahaʾo te rua kope",
    "gui.howtos.story.step_flip": "ka rori toʾu kona",
    "gui.howtos.story.step_conversation": "ka vanaŋa koe ki te tahi",
    "gui.howtos.story.addanotherbg": "ka hahaʾo te rua tuʾa nui",
    "gui.howtos.story.step_swithbg": "ka rori te tuʾa nui",
    "gui.howtos.story.step_hidewizard": "ka naʾa te kope",
    "gui.howtos.story.step_showwizard": "ka haka tikeʾa e tahi kope",
    "gui.howtos.make-a-chase-game.name": "ka āŋa te haka taŋi tampuru",
    "gui.howtos.Chase-Game.step_BG": "ka hahaʾo te tuʾa nui",
    "gui.howtos.chase-game.step_AddOcto": "Add a Sprite",
    "gui.howtos.make-music.step_LeftRight": "ka makenu ki te mataʾu e ki te maui hai teʾa",
    "gui.howtos.Chase-Game.step_UpDown": "ka makenu ki ruŋa e ki raro hai teʾa",
    "gui.howtos.Chase-Game.step_AddStar": "ka hahaʾo hakaʾou te sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "ka makenu pahe aleatoria",
    "gui.howtos.Chase-Game.step_WhenTouch": "i te sprite heke, mo ŋatu he ŋaroʾa koe te pakeke",
    "gui.howtos.Chase-Game.step_ScoreVariable": "ka aŋa te variable \"tuki\"",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "i te sprite heke, mo ŋatu e hahaʾo te tuki",
    "gui.howtos.animate-char.name": "ka haka makenu e tahi kope",
    "gui.howtos.animate-char.step_addbg": "ka hahaʾo te tuʾa nui",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "ka ki e tahi meʾe",
    "gui.howtos.animate-char.step_addsound": "ka hahaʾo te pakeke",
    "gui.howtos.animate-char.step_animatetalking": "ka haka aŋa te vānaŋa",
    "gui.howtos.animate-char.step_arrowkeys": "ka makenu hai pito pito o te teʾa",
    "gui.howtos.animate-char.step_jump": "ka rere",
    "gui.howtos.animate-char.step_changecolor": "ka kamiare te peni",
    "gui.howtos.make-a-game.name": "mo āŋa e ŋatu hai clic",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pick A Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "mo ŋatu e koe te clic, e ŋatu te pakeke",
    "gui.howtos.make-a-game.step_GameAddScore": "ka aŋa te variable \"tuki\"",
    "gui.howtos.make-a-game.step_GameChangeScore": "mo ŋatu te clic he iri te tuki",
    "gui.howtos.make-a-game.step_Random": "ē oho ki te kona aleatoria",
    "gui.howtos.make-music.step_GameChangeColor": "ka kamiare te peni",
    "gui.howtos.make-music.step_ResetScore": "ka haʾamata haka ʾou te tuki",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "kori ē he hora mo kimi a rote reka",
    "gui.howtos.cartoon-network.step_CNcharacter": "ka tuhi te kope mo haka tikeʾa",
    "gui.howtos.cartoon-network.step_CNsay": "ka ki e tahi meʾe",
    "gui.howtos.cartoon-network.step_CNglide": "haka pei",
    "gui.howtos.cartoon-network.step_CNpicksprite": "ka tuhi he aha te meʾe mo tute mo rovaʾa",
    "gui.howtos.cartoon-network.step_CNcollect": "runu mai te meʾe",
    "gui.howtos.cartoon-network.step_CNvariable": "ka aŋa te variable \"tuki\"",
    "gui.howtos.cartoon-network.step_CNscore": "e hapaʾo te tataku oʾou",
    "gui.howtos.cartoon-network.step_CNbackdrop": "ka iri koe te nivel: e ka kamiare te tuʾa nui",
    "gui.howtos.videosens.name": "Sensor de video",
    "gui.howtos.videosens.step_addextension": "ka hahaʾo te haka roa roa",
    "gui.howtos.videosens.step_pet": "ka tauromi te kuri",
    "gui.howtos.videosens.step_animate": "ka haka makenu",
    "gui.howtos.videosens.step_pop": "ka ŋaʾaha te korobo",
    "gui.howtos.say-it-out-loud": "ka āŋa te kori mo vānāŋa",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "ka hahaʾo te bloques o te \"papaʾi ki te reʾo\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "ka ki e tahi meʾe",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "ka tuhi ta reʾo haŋa",
    "gui.howtos.say-it-out-loud.step_TXTMove": "ka makenua koe",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "ka hahaʾo te tuʾa nui",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "ka hahaʾo te rua kope",
    "gui.howtos.say-it-out-loud.step_TXTSong": "ka haka taŋi te himene",
    "gui.howtos.say-it-out-loud.step_TXTColor": "ka kamiare te peni",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "ka teka",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "ka haka nui nui e ka haka iti iti",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Add a Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Add a Sprite",
    "gui.howtos.add-a-backdrop.name": "ka hahaʾo te tuʾa nui",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "ka rori",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "haka pei",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "hapaʾo te meʾe mo ŋaroā",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "ka haka teka",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "te kio",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animate a Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "e āŋa hai pito pito o te teʾa",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "e hahaʾo te efectos",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Música",
    "gui.extension.music.description": "ka haka taŋi te rahi o te meʾe pahe tampuru",
    "gui.extension.pen.name": "pentara",
    "gui.extension.pen.description": "Draw with your sprites.",
    "gui.extension.videosensing.name": "Sensor de video",
    "gui.extension.videosensing.description": "Detecta movimientos con la cámara.",
    "gui.extension.text2speech.name": "papaʾi hai reʾo",
    "gui.extension.text2speech.description": "ka hahaʾo te reʾo ki taʾa āŋa",
    "gui.extension.translate.name": "huri vanāŋa",
    "gui.extension.translate.description": "ka huri ki te rahi o te reʾo",
    "gui.extension.makeymakey.description": "ka rori taʾatoʾa meʾe i te etahi no pito pito",
    "gui.extension.microbit.description": "ka hahaʾo taʾa āŋa mo haka tikeʾa ki te tahi hau o te ao",
    "gui.extension.microbit.connectingMessage": "e raʾu a",
    "gui.extension.ev3.description": "ka āŋa te makini haka tere e te tahi meʾe",
    "gui.extension.ev3.connectingMessage": "raʾu. Ka aŋi aŋi ana ai te PIN o toʾu V3 KO 1234.",
    "gui.extension.boost.description": "ka vaʾai te ora ki te aŋa aʾau páhe robotica",
    "gui.extension.boost.connectingMessage": "e raʾu a",
    "gui.extension.wedo2.description": "ka āŋa hai motores e he sensores",
    "gui.extension.wedo2.connectingMessage": "e raʾu a",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "e raʾu a",
    "gui.libraryTags.all": "taʾatoʾa",
    "gui.libraryTags.animals": "manu tere henua",
    "gui.libraryTags.dance": "ori",
    "gui.libraryTags.effects": "Efectos",
    "gui.libraryTags.fantasy": "Fantasía",
    "gui.libraryTags.fashion": "haka nehe nehe",
    "gui.libraryTags.food": "kai",
    "gui.libraryTags.indoors": "rori ki tuʾa",
    "gui.libraryTags.loops": "Bucles",
    "gui.libraryTags.music": "Música",
    "gui.libraryTags.notes": "papaʾi",
    "gui.libraryTags.outdoors": "i haho",
    "gui.libraryTags.patterns": "Patrones",
    "gui.libraryTags.people": "nunaʾa",
    "gui.libraryTags.percussion": "haka taŋi tampuru",
    "gui.libraryTags.space": "kona",
    "gui.libraryTags.sports": "makenu hakari",
    "gui.libraryTags.underwater": "raro o te vaikava",
    "gui.libraryTags.voice": "reʾo",
    "gui.libraryTags.wacky": "maʾa maʾa mira mira",
    "gui.libraryTags.animation": "haka makenu",
    "gui.libraryTags.art": "tapura",
    "gui.libraryTags.games": "kori",
    "gui.libraryTags.stories": "āʾāmu",
    "gui.libraryTags.letters": "tiaraʾa",
    "gui.opcodeLabels.direction": "ara",
    "gui.opcodeLabels.xposition": "he noho o te x",
    "gui.opcodeLabels.yposition": "he noho o te y",
    "gui.opcodeLabels.size": "he haito",
    "gui.opcodeLabels.costumename": "iŋoa o te diseño",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "iŋoa o te tuʾa nui",
    "gui.opcodeLabels.backdropnumber": "tataku o te tuʾa nui",
    "gui.opcodeLabels.volume": "re´o o te computador",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "pahono",
    "gui.opcodeLabels.loudness": "volumen o te pakeke",
    "gui.opcodeLabels.username": "iŋoa o te  usuario",
    "gui.opcodeLabels.year": "matahiti",
    "gui.opcodeLabels.month": "avaʾe",
    "gui.opcodeLabels.date": "mahana",
    "gui.opcodeLabels.dayofweek": "mahana o te tapati",
    "gui.opcodeLabels.hour": "hōra",
    "gui.opcodeLabels.minute": "minuti",
    "gui.opcodeLabels.second": "segundo",
    "gui.opcodeLabels.timer": "cronómetro",
    "gui.projectLoader.loadError": "kai tano mo haī te aŋa haŋa era",
    "gui.sharedMessages.backdrop": "tuʾa nui {index}",
    "gui.sharedMessages.costume": "diseño {index}",
    "gui.sharedMessages.sprite": "Sprite {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "¿e hahaʾo te rua aŋa o te aŋa e aŋa mai ena?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "rori",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "haka tano te peni o te morī ki te [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "taʾatoʾa meʾe",
    "boost.tiltDirection.down": "raro",
    "boost.tiltDirection.left": "maūi",
    "boost.tiltDirection.right": "mataʾu",
    "boost.tiltDirection.up": "ruŋa",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "mo haka taha ki [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
    "ev3.buttonPressed": "button [PORT] pressed?",
    "ev3.getBrightness": "ʾuira",
    "ev3.getDistance": "roa ki",
    "ev3.getMotorPosition": "te noho o te motor [PORT]",
    "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "a he te uira < [DISTANCE]",
    "ev3.whenButtonPressed": "ki ŋatu te pito pito [PORT]",
    "ev3.whenDistanceLessThan": "a he te roa haka tano < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "puai",
    "gdxfor.getSpin": "te horou o te teka [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "¿e hiŋa?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "taʾatoʾa meʾe",
    "gdxfor.tiltDirectionMenu.back": "i tuʾa",
    "gdxfor.tiltDirectionMenu.front": "a muʾa ki te tahi",
    "gdxfor.tiltDirectionMenu.left": "maūi",
    "gdxfor.tiltDirectionMenu.right": "mataʾu",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "ki he te sensor o te puai [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "ki haka taha [TILT]",
    "makeymakey.downArrow": "teʾa ki raro",
    "makeymakey.downArrowShort": "raro",
    "makeymakey.leftArrow": "teʾa maui",
    "makeymakey.leftArrowShort": "maūi",
    "makeymakey.rightArrow": "teʾa mataʾu",
    "makeymakey.rightArrowShort": "mataʾu",
    "makeymakey.spaceKey": "kona",
    "makeymakey.upArrow": "teʾa ki ruŋa",
    "makeymakey.upArrowShort": "ruŋa",
    "makeymakey.whenKeyPressed": "mo ŋatu te pito pito [KEY]",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "taʾatoʾa meʾe",
    "microbit.clearDisplay": "miaitaki te teata",
    "microbit.defaultTextToDisplay": "¡Iorana!",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "haka tikeʾa te papaʾi[TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] button pressed?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "haka mate",
    "microbit.pinStateMenu.on": "haka pura",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "taʾatoʾa meʾe",
    "microbit.tiltDirectionMenu.back": "i tuʾa",
    "microbit.tiltDirectionMenu.front": "a muʾa ki te tahi",
    "microbit.tiltDirectionMenu.left": "maūi",
    "microbit.tiltDirectionMenu.right": "mataʾu",
    "microbit.whenButtonPressed": "mo ŋatu te pito pito [BTN]",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "mo hahaʾo te pin [PIN]",
    "microbit.whenTilted": "mo haka taha ki te [DIRECTION]",
    "music.categoryName": "Música",
    "music.changeTempo": "change tempo by [TEMPO]",
    "music.drumBass": "(2) Bombo",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Charles cerrado",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cencerro",
    "music.drumCrashCymbal": "(4) Platillo crash",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Güiro",
    "music.drumHandClap": "(8) Palmada",
    "music.drumOpenHiHat": "(5) Charles abierto",
    "music.drumSideStick": "(3) Golpe lateral",
    "music.drumSnare": "(1) avahata mob haka taŋi",
    "music.drumTambourine": "(7) Pandereta",
    "music.drumTriangle": "(12) taimana",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) avahata tenito",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bajo",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violonchelo",
    "music.instrumentChoir": "(15) Coro",
    "music.instrumentClarinet": "(10) Clarinete",
    "music.instrumentElectricGuitar": "(5) kitara electronico",
    "music.instrumentElectricPiano": "(2) Piano eléctrico",
    "music.instrumentFlute": "(12) Flauta",
    "music.instrumentGuitar": "(4) kitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Caja de música",
    "music.instrumentOrgan": "(3) Órgano",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofón",
    "music.instrumentSteelDrum": "(18) Tambor metálico",
    "music.instrumentSynthLead": "(20) Sintetizador melódico",
    "music.instrumentSynthPad": "(21) Sintetizador de fondo",
    "music.instrumentTrombone": "(9) Trombón",
    "music.instrumentVibraphone": "(16) Vibráfono",
    "music.instrumentWoodenFlute": "(13) Flauta de madera",
    "music.midiPlayDrumForBeats": "haka taŋi te tampuru [DRUM] Aa rote [BEATS] hora",
    "music.midiSetInstrument": "haka tano te meʾe mo haka taŋi ki te [INSTRUMENT]",
    "music.playDrumForBeats": "haka taŋi te tampuru [DRUM] Aa rote [BEATS] hora",
    "music.playNoteForBeats": "haka taŋi te nota [NOTE] a rote [BEATS] hora",
    "music.restForBeats": "he mou o te [BEATS] hora",
    "music.setInstrument": "haka tano te meʾe mo haka taŋi ki te [INSTRUMENT]",
    "music.setTempo": "ka vaʾai te tempo ki te mau [TEMPO]",
    "pen.categoryName": "pentara",
    "pen.changeColorParam": "change pen [COLOR_PARAM] by [VALUE]",
    "pen.changeHue": "ka kamiare te kiea o te pentara por [HUE]",
    "pen.changeShade": "ka kamiare te kohu o te pentara ki te [SHADE]",
    "pen.changeSize": "ka kamiare te nui nui o te pentara ki te [SIZE]",
    "pen.clear": "haka kore tahi",
    "pen.colorMenu.brightness": "ʾuira",
    "pen.colorMenu.color": "kiʾea",
    "pen.colorMenu.saturation": "saturación",
    "pen.colorMenu.transparency": "transparency",
    "pen.penDown": "haka turu te pentara",
    "pen.penUp": "haka iri te pentara",
    "pen.setColor": "haka tano te kiea o te pentara ko te [COLOR]",
    "pen.setColorParam": "set pen [COLOR_PARAM] to [VALUE]",
    "pen.setHue": "haka tano te kiea o te pentara ko te [HUE]",
    "pen.setShade": "haka tano te kohu o te pentara ki te [SHADE]",
    "pen.setSize": "haka tano te nui nui o te pentara ki te [SIZE]",
    "pen.stamp": "tapa´o",
    "speech.defaultWhenIHearValue": "matu",
    "speech.extensionName": "e haka tano ʾa te reʾo",
    "speech.listenAndWait": "e haka roŋo e he tiaki",
    "speech.speechReporter": "vanaŋa papaʾi",
    "speech.whenIHear": "ki ŋaroʾa [PHRASE]",
    "text2speech.alto": "contralto",
    "text2speech.categoryName": "papaʾi hai reʾo",
    "text2speech.defaultTextToSpeak": "iorana",
    "text2speech.giant": "nui nui tetu",
    "text2speech.kitten": "kuri iti",
    "text2speech.setLanguageBlock": "haka tano te reʾo ki te [LANGUAGE]",
    "text2speech.setVoiceBlock": "ka hahaʾo te reʾo ki te [VOICE]",
    "text2speech.speakAndWaitBlock": "e ki [WORDS]",
    "text2speech.squeak": "chillido",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "huri vanāŋa",
    "translate.defaultTextToTranslate": "iorana",
    "translate.translateBlock": "ka huri [WORDS] ki te [LANGUAGE]",
    "translate.viewerLanguage": "reʾo",
    "videoSensing.categoryName": "Sensor de video",
    "videoSensing.direction": "ara",
    "videoSensing.motion": "makenu",
    "videoSensing.off": "haka mate",
    "videoSensing.on": "haka pura",
    "videoSensing.onFlipped": "on flipped",
    "videoSensing.setVideoTransparency": "haka tano te maeha o te teata ki te [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "ahu",
    "videoSensing.videoOn": "video [ATTRIBUTE] on [SUBJECT]",
    "videoSensing.videoToggle": "turn video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "a he te makenu o te teata [REFERENCE]",
    "wedo2.getDistance": "roa ki",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "rori",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "te taʾatoʾa motores",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "ka haka taŋi[NOTE] hai hora [DURATION] piere",
    "wedo2.setLightHue": "haka tano te peni o te morī ki te [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "taʾatoʾa meʾe",
    "wedo2.tiltDirection.down": "raro",
    "wedo2.tiltDirection.left": "maūi",
    "wedo2.tiltDirection.right": "mataʾu",
    "wedo2.tiltDirection.up": "ruŋa",
    "wedo2.whenDistance": "a he te roa haka tano [OP] [REFERENCE]",
    "wedo2.whenTilted": "mo haka taha ki [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Kiʾea",
    "paint.paintEditor.saturation": "Saturación",
    "paint.paintEditor.brightness": "ʾUira",
    "paint.paintEditor.costume": "Diseño",
    "paint.paintEditor.group": "piri",
    "paint.paintEditor.ungroup": "haka kore te piri",
    "paint.paintEditor.undo": "moumou",
    "paint.paintEditor.redo": "he anga haka ʾou",
    "paint.paintEditor.forward": "a muʾa",
    "paint.paintEditor.backward": "A tuʾa ",
    "paint.paintEditor.front": "i muʾa",
    "paint.paintEditor.back": "a tuʾa ",
    "paint.paintEditor.more": "te tahi",
    "paint.modeTools.brushSize": "he haito",
    "paint.modeTools.eraserSize": "he nui nui o te ua ua haka kore",
    "paint.modeTools.copy": "ko tuʾu meʾe a",
    "paint.modeTools.paste": "pipiri",
    "paint.modeTools.delete": "haka kore",
    "paint.modeTools.curved": "pikopiko",
    "paint.modeTools.pointed": "titika",
    "paint.modeTools.thickness": "peŋo peŋo",
    "paint.modeTools.flipHorizontal": "haka teka pahe hau titika",
    "paint.modeTools.flipVertical": "e rori mo haka titika",
    "paint.modeTools.filled": "hāʾī",
    "paint.modeTools.outlined": "Contorneado",
    "paint.paintEditor.bitmap": "haka āŋa ki te mapa bits",
    "paint.paintEditor.vector": "e rori ki te vector",
    "paint.paintEditor.fill": "hāʾī",
    "paint.paintEditor.stroke": "Tītī",
    "paint.brushMode.brush": "purumu paru",
    "paint.eraserMode.eraser": "ua ua haka kore",
    "paint.fillMode.fill": "hāʾī",
    "paint.lineMode.line": "hore hore",
    "paint.ovalMode.oval": "taka taka",
    "paint.rectMode.rect": "avahata poto roa",
    "paint.reshapeMode.reshape": "e hoki mo haka titika te āŋa",
    "paint.roundedRectMode.roundedRect": "avahata poto roa hai titi taka taka",
    "paint.selectMode.select": "tuhi",
    "paint.textMode.text": "papaʾi",
    "paint.colorPicker.swap": "rori"
  },
  "ro": {
    "gui.alerts.lostPeripheralConnection": "Scratch a pierdut conexiunea cu {extensionName}.",
    "gui.alerts.tryAgain": "Încearcă din nou",
    "gui.alerts.download": "Descarcă",
    "gui.connection.reconnect": "Reconectare",
    "gui.backpack.costumeLabel": "costum",
    "gui.backpack.soundLabel": "sunet",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "personaj",
    "gui.backpack.header": "Rucsac",
    "gui.backpack.errorBackpack": "Eroare încărcare rucsac",
    "gui.backpack.loadingBackpack": "Se încarcă...",
    "gui.backpack.more": "Altele",
    "gui.backpack.emptyBackpack": "Rucsacul este gol",
    "gui.unsupportedBrowser.label": "Browser incompatibil",
    "gui.unsupportedBrowser.errorLabel": "A apărut o eroare",
    "gui.unsupportedBrowser.notRecommended": "Ne pare foarte rău, dar se pare că utilizați o versiune de browser incompatibilă cu Scratch. Vă recomandăm să folosiți cea mai nouă versiune a unui browser compatibil, ca Google Chrome, Mozilla Firefox, Microsoft Edge sau Apple Safari.",
    "gui.unsupportedBrowser.description": "Ne pare foarte rău, dar Scratch nu funcționează în acest browser. Vă recomandăm să folosiți cea mai nouă versiune a unui browser compatibil, ca Google Chrome, Mozilla Firefox, Microsoft Edge sau Apple Safari.",
    "gui.unsupportedBrowser.back": "Înapoi",
    "gui.unsupportedBrowser.previewfaq": "Pentru mai multe detalii, accesați {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Întrebări frecvente",
    "gui.cards.all-tutorials": "Tutoriale",
    "gui.cards.shrink": "Micșorează",
    "gui.cards.expand": "Extinde",
    "gui.cards.close": "Închide",
    "gui.cards.more-things-to-try": "Mai multe lucruri de încercat!",
    "gui.cards.see-more": "Vezi mai multe",
    "gui.comingSoon.message1": "Nu-ți face griji, ne ocupăm de asta {emoji}",
    "gui.comingSoon.message2": "În curând...",
    "gui.comingSoon.message3": "Lucrăm la asta {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nu s-au găsit dispozitive.",
    "gui.connection.auto-scanning.prescan": "Plasează dispozitivul în apropiere, apoi începe căutarea.",
    "gui.connection.auto-scanning.pressbutton": "Apasă butonul de pe dispozitiv.",
    "gui.connection.auto-scanning.start-search": "Începe căutarea",
    "gui.connection.connecting-searchbutton": "Se caută...",
    "gui.connection.auto-scanning.try-again": "Încearcă din nou",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Conectat",
    "gui.connection.disconnect": "Deconectează",
    "gui.connection.go-to-editor": "Mergi la Editor",
    "gui.connection.connecting-cancelbutton": "Se conectează...",
    "gui.connection.error.errorMessage": "Hopa! Ceva nu a mers bine.",
    "gui.connection.error.tryagainbutton": "Încearcă din nou",
    "gui.connection.error.helpbutton": "Ajutor",
    "gui.connection.peripheral-name-label": "Nume dispozitiv",
    "gui.connection.connect": "Conectează",
    "gui.connection.scanning.lookingforperipherals": "Se caută dispozitive",
    "gui.connection.scanning.noPeripheralsFound": "Nu s-au găsit dispozitive.",
    "gui.connection.scanning.instructions": "Selectează dispozitivul tău din listă.",
    "gui.connection.search": "Actualizează",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Asigură-te că ai Scratch Link instalat și pornit",
    "gui.connection.unavailable.enablebluetooth": "Verifică dacă Bluetooth-ul e activat",
    "gui.connection.unavailable.tryagainbutton": "Încearcă din nou",
    "gui.connection.unavailable.helpbutton": "Ajutor",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Mergi",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Hopa! Ceva nu a mers bine.",
    "gui.crashMessage.description": "Ne pare rău, dar se pare că Scratch s-a blocat. Eroarea a fost transmisă automat echipei Scratch. Te rugăm să reîncarci pagina pentru a continua.",
    "gui.crashMessage.errorNumber": "Eroarea a fost înregistrată cu id {errorId}",
    "gui.crashMessage.reload": "Reîncarcă",
    "gui.customProcedures.myblockModalTitle": "Creează un bloc",
    "gui.customProcedures.addAnInputNumberText": "Adaugă o intrare",
    "gui.customProcedures.numberTextType": "număr sau text",
    "gui.customProcedures.addAnInputBoolean": "Adaugă o intrare",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Adaugă o etichetă",
    "gui.customProcedures.runWithoutScreenRefresh": "Rulează fără împrospătarea ecranului",
    "gui.customProcedures.cancel": "Renunţă",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Direcția",
    "gui.directionPicker.rotationStyles.allAround": "de jur împrejur",
    "gui.directionPicker.rotationStyles.leftRight": "stânga-dreapta",
    "gui.directionPicker.rotationStyles.dontRotate": "nu roti",
    "gui.gui.addExtension": "Adaugă o extensie",
    "gui.gui.codeTab": "Cod",
    "gui.gui.backdropsTab": "Decoruri",
    "gui.gui.costumesTab": "Costume",
    "gui.gui.soundsTab": "Sunete",
    "gui.extensionLibrary.comingSoon": "În curând",
    "gui.extensionLibrary.requires": "Necesită",
    "gui.extensionLibrary.collaboration": "Colaborare cu",
    "gui.library.filterPlaceholder": "Caută",
    "gui.library.allTag": "Tot",
    "gui.loader.message1": "Creare blocuri ...",
    "gui.loader.message2": "Se încarcă personaje...",
    "gui.loader.message3": "Se încarcă sunete...",
    "gui.loader.message4": "Se încarcă extensii...",
    "gui.loader.message5": "Adunăm pisici ...",
    "gui.loader.message6": "Îl pieptănăm pe Nano...",
    "gui.loader.message7": "Îl umflăm pe Gobo...",
    "gui.loader.message8": "Pregătim emoji-urile...",
    "gui.loader.headline": "Se încarcă proiectul",
    "gui.loader.creating": "Se creează proiectul",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Materialele mele",
    "gui.accountMenu.myClasses": "Clasele mele",
    "gui.accountMenu.myClass": "Clasa mea",
    "gui.accountMenu.accountSettings": "Setările contului",
    "gui.accountMenu.signOut": "Ieșire",
    "gui.authorInfo.byUser": "de {username}",
    "gui.menuBar.seeProjectPage": "Vezi pagina proiectului",
    "gui.menuBar.language": "Language",
    "general.username": "Utilizator",
    "general.password": "Parola",
    "general.signIn": "Logare",
    "login.needHelp": "Ai nevoie de ajutor?",
    "form.validationRequired": "Acest câmp este obligatoriu",
    "gui.menuBar.tutorialsLibrary": "Tutoriale",
    "gui.menuBar.restoreSprite": "Anulează ștergere personaj",
    "gui.menuBar.restoreSound": "Anulează ștergere sunet",
    "gui.menuBar.restoreCostume": "Anulează ștergere costum",
    "gui.menuBar.restore": "Anulează ștergere",
    "gui.menuBar.saveNow": "Salvează acum",
    "gui.menuBar.saveAsCopy": "Salveaza o copie",
    "gui.menuBar.remix": "Remixează",
    "gui.menuBar.new": "Nou",
    "gui.menuBar.file": "Fișier",
    "gui.menuBar.downloadToComputer": "Salvează pe calculatorul tău",
    "gui.menuBar.edit": "Editează",
    "gui.menuBar.turboModeOff": "Dezactivează modul Turbo",
    "gui.menuBar.turboModeOn": "Activează modul Turbo",
    "gui.menuBar.modeMenu": "Mod",
    "gui.menuBar.normalMode": "Mod normal",
    "gui.menuBar.caturdayMode": "Mod pisicos",
    "gui.menuBar.joinScratch": "Alătură-te Scratch",
    "gui.menuBar.signIn": "Logare",
    "gui.gui.projectTitlePlaceholder": "Titlul proiectului se scrie aici",
    "gui.menuBar.saveNowLink": "Salvează acum",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Partajat",
    "gui.menuBar.share": "Partajează",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Ajutor",
    "gui.modal.back": "Înapoi",
    "gui.monitor.listMonitor.empty": "(gol)",
    "gui.monitor.listMonitor.listLength": "lungime {length}",
    "gui.monitor.contextMenu.default": "afișaj normal",
    "gui.monitor.contextMenu.large": "afișare in format mare",
    "gui.monitor.contextMenu.slider": "cursor",
    "gui.monitor.contextMenu.sliderRange": "modifică interval cursor",
    "gui.monitor.contextMenu.import": "importă",
    "gui.monitor.contextMenu.export": "exportă",
    "gui.monitor.contextMenu.hide": "ascunde",
    "gui.playButton.play": "Redare",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Pentru toate personajele",
    "gui.gui.variableScopeOptionSpriteOnly": "Doar pentru acest personaj",
    "gui.gui.cloudVariableOption": "Variabilă Cloud (stocată pe server)",
    "gui.gui.variablePromptAllSpritesMessage": "Această variabilă va fi accesibilă tuturor personajelor.",
    "gui.gui.listPromptAllSpritesMessage": "Această listă va fi accesibilă tuturor personajelor.",
    "gui.prompt.cancel": "Renunţă",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Redare",
    "gui.playbackStep.loadingMsg": "Se încarcă...",
    "gui.playbackStep.saveMsg": "Salvează",
    "gui.playbackStep.reRecordMsg": "Re-înregistrare",
    "gui.recordModal.title": "Înregistrare sunet",
    "gui.recordingStep.beginRecord": "Începe înregistrarea apăsând butonul de mai jos",
    "gui.recordingStep.permission": "{arrow} Avem nevoie de permisiunea ta pentru folosirea microfonului",
    "gui.recordingStep.stop": "Oprește inregistrarea",
    "gui.recordingStep.record": "Înregistrare",
    "gui.sliderModal.min": "Valoare minimă",
    "gui.sliderModal.max": "Valoare maximă",
    "gui.sliderModal.title": "Modifică interval cursor",
    "gui.sliderPrompt.cancel": "Anulează",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Sunet",
    "gui.soundEditor.play": "Redare",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Copiază",
    "gui.soundEditor.paste": "Lipește",
    "gui.soundEditor.copyToNew": "Copiază către unul nou",
    "gui.soundEditor.delete": "Șterge",
    "gui.soundEditor.save": "Salvează",
    "gui.soundEditor.undo": "Anulează ultima modificare",
    "gui.soundEditor.redo": "Refă acțiunea anulată",
    "gui.soundEditor.faster": "Mai rapid",
    "gui.soundEditor.slower": "Mai lent",
    "gui.soundEditor.echo": "Ecou",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Mai puternic",
    "gui.soundEditor.softer": "Mai încet",
    "gui.soundEditor.reverse": "Inversează",
    "gui.soundEditor.fadeOut": "Terminare graduală",
    "gui.soundEditor.fadeIn": "Pornire graduală",
    "gui.soundEditor.mute": "Amuțește",
    "gui.SpriteInfo.spritePlaceholder": "Numele",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Personaj",
    "gui.SpriteInfo.show": "Arată",
    "gui.SpriteInfo.size": "Dimensiune",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplică",
    "gui.spriteSelectorItem.contextMenuExport": "exportă",
    "gui.spriteSelectorItem.contextMenuDelete": "șterge",
    "gui.spriteSelector.addSpriteFromLibrary": "Alege un personaj",
    "gui.spriteSelector.addSpriteFromPaint": "Desenează",
    "gui.spriteSelector.addSpriteFromSurprise": "Surpriză",
    "gui.spriteSelector.addSpriteFromFile": "Încarcă personaj",
    "gui.stageHeader.stageSizeLarge": "Comută scenă mare",
    "gui.stageHeader.stageSizeSmall": "Comută scenă mică",
    "gui.stageHeader.stageSizeFull": "Intră în mod ecran complet",
    "gui.stageHeader.stageSizeUnFull": "Ieși din mod ecran complet",
    "gui.stageHeader.fullscreenControl": "Control ecran complet",
    "gui.spriteSelector.addBackdropFromLibrary": "Alege un Decor",
    "gui.stageSelector.addBackdropFromPaint": "Desenează",
    "gui.stageSelector.addBackdropFromSurprise": "Surpriză",
    "gui.stageSelector.addBackdropFromFile": "Încarcă decor",
    "gui.stageSelector.stage": "Scenă",
    "gui.stageSelector.backdrops": "Decoruri",
    "gui.telemetryOptIn.label": "Raportează date statistice pentru a îmbunătăți Scratch.",
    "gui.telemetryOptIn.body1": "Echipa Scratch încearcă mereu să înțeleagă mai bine modul în care Scratch este folosit în întreaga lume. Pentru a sprijini acest efort, puteți permite ca Scratch să trimită automat informații de utilizare către echipa Scratch.",
    "gui.telemetryOptIn.body2": "Informațiile pe care le colectăm includ limba selectată, utilizarea blocurilor și unele evenimente ca salvarea, deschiderea și încărcarea online a unui proiect. NU COLECTĂM nici o infrormație personală. Vezi {privacyPolicyLink} pentru mai multe detalii.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politica de confidențialitate",
    "gui.telemetryOptIn.optInText": "Trimite datele mele de utilizare Echipei Scratch",
    "gui.telemetryOptIn.optInTooltip": "Activează telemetria",
    "gui.telemetryOptIn.optOutText": "Nu trimite datele mele de utilizare Echipei Scratch",
    "gui.telemetryOptIn.optOutTooltip": "Dezactivează telemetria",
    "gui.telemetryOptIn.settingWasUpdated": "Setarea a fost actualizată.",
    "gui.telemetryOptIn.buttonClose": "Închide",
    "gui.turboMode.active": "Modul Turbo",
    "gui.webglModal.label": "Browser-ul tău nu e compatibil cu WebGL",
    "gui.webglModal.description": "Din păcate se pare că browser-ul sau computerul tău {webGlLink}. Această tehnologie este necesară pentru a rula Scratch 3.0.",
    "gui.webglModal.webgllink": "nu e compatibil cu WebGL",
    "gui.webglModal.back": "Înapoi",
    "gui.webglModal.previewfaq": "Pentru mai multe detalii, accesați {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Întrebări frecvente",
    "gui.costumeLibrary.chooseABackdrop": "Alege un decor",
    "gui.costumeLibrary.chooseACostume": "Alege un costum",
    "gui.costumeTab.addBackdropFromLibrary": "Alege un decor",
    "gui.costumeTab.addCostumeFromLibrary": "Alege un costum",
    "gui.costumeTab.addBlankCostume": "Desenează",
    "gui.costumeTab.addSurpriseCostume": "Surpriză",
    "gui.costumeTab.addFileBackdrop": "Încarcă decor",
    "gui.costumeTab.addFileCostume": "Încarcă un costum",
    "gui.extensionLibrary.chooseAnExtension": "Alege o extensie",
    "gui.extensionLibrary.extensionUrl": "Introdu URL-ul extensiei",
    "gui.monitors.importListColumnPrompt": "Ce coloană trebuie folosită (1-{numberOfColumns}) ?",
    "gui.recordingStep.alertMsg": "Nu s-a putut înregistra",
    "gui.soundLibrary.chooseASound": "Alege un sunet",
    "gui.soundTab.fileUploadSound": "Încarcă sunet",
    "gui.soundTab.surpriseSound": "Surpriză",
    "gui.soundTab.recordSound": "Înregistrare",
    "gui.soundTab.addSoundFromLibrary": "Alege un sunet",
    "gui.spriteLibrary.chooseASprite": "Alege un personaj",
    "gui.tipsLibrary.tutorials": "Alege un tutorial",
    "gui.alerts.createsuccess": "S-a creeat un proiect nou.",
    "gui.alerts.createcopysuccess": "Proiect salvat în copie.",
    "gui.alerts.createremixsuccess": "Proiect salvat ca remix.",
    "gui.alerts.creating": "Se creează...",
    "gui.alerts.creatingCopy": "Se copiază proiectul...",
    "gui.alerts.creatingRemix": "Se remixează proiectul...",
    "gui.alerts.creatingError": "Proiectul nu a putut fi creat. Încercați din nou!",
    "gui.alerts.savingError": "Proiectul nu a putut fi salvat.",
    "gui.alerts.savesuccess": "Proiect salvat.",
    "gui.alerts.saving": "Se salvează proiectul ...",
    "gui.alerts.cloudInfo": "Te rog reține că variabilele cloud pot conține doar numere, nu litere sau simboluri. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Află mai multe.",
    "gui.alerts.importing": "Se importă...",
    "gui.defaultProject.meow": "Miau",
    "gui.defaultProject.variable": "variabila mea",
    "gui.howtos.intro-move-sayhello-hat.name": "Să începem",
    "gui.howtos.intro-move.step_stepMove": "Adaugă un bloc de mișcare",
    "gui.howtos.add-a-move-block.step_stepSay": "Adaugă un bloc spune",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Fă clic pe steagul verde pentru a porni",
    "gui.howtos.intro-getting-started-ASL.name": "Să începem - ASL (limbaj mimico-gestual american)",
    "gui.howtos.animate-a-name.name": "Animează un nume",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Alege o literă ca personaj",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Redă un sunet când se face clic",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Alege o altă literă ca personaj",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Schimbă culoarea",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Alege încă o literă și fă-o să se rotească",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Alege o altă literă și fă-o să se mărească",
    "gui.howtos.imagine": "Imaginează-ți o lume",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tastează ceea ce vrei să spui",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Apasă steagul verde pentru a începe",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Alege orice decor",
    "gui.howtos.imagine.step_imagineChooseSprite": "Alege orice personaj",
    "gui.howtos.imagine.step_imagineFlyAround": "Apasă tasta spațiu pentru a glisa",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Alege alt personaj",
    "gui.howtos.imagine.step_imagineLeftRight": "Mișcă Stânga-Dreapta",
    "gui.howtos.imagine.step_imagineUpDown": "Mișcă Sus-Jos",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Schimbă Costumele",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glisare până la un punct",
    "gui.howtos.imagine.step_imagineGrowShrink": "Mărește și Micșorează",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Alege alt decor",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Schimbă decorurile",
    "gui.howtos.imagine.step_imagineRecordASound": "Adaugă un sunet",
    "gui.howtos.imagine.step_imagineChooseSound": "Alege-ți Sunetul",
    "gui.howtos.make-music.name": "Creează Muzică",
    "gui.howtos.Make-Music.step_PickInstrument": "Alege un instrument muzical ca personaj",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Redă un sunet când se face clic",
    "gui.howtos.Make-Music.step_MakeSong": "Creează un cântec",
    "gui.howtos.make-music.step_MakeBeat": "Alege o tobă și fă un ritm",
    "gui.howtos.make-music.step_MakeBeatBox": "Alege personajul Microfon (Microphone) și un beatbox aleator",
    "gui.howtos.story.name": "Creează o poveste",
    "gui.howtos.story.step_addbg": "Adaugă un decor",
    "gui.howtos.story.step_addsprite": "Adaugă un personaj",
    "gui.howtos.story.step_saysomething": "Spune ceva",
    "gui.howtos.story.step_addanothersprite": "Adaugă încă un personaj",
    "gui.howtos.story.step_flip": "Inversează direcția",
    "gui.howtos.story.step_conversation": "Poartă o conversație",
    "gui.howtos.story.addanotherbg": "Adaugă alt decor",
    "gui.howtos.story.step_swithbg": "Comutare Decoruri",
    "gui.howtos.story.step_hidewizard": "Ascunde un personaj",
    "gui.howtos.story.step_showwizard": "Afisează un personaj",
    "gui.howtos.make-a-chase-game.name": "Creează un joc de urmărire",
    "gui.howtos.Chase-Game.step_BG": "Adaugă un Decor",
    "gui.howtos.chase-game.step_AddOcto": "Adaugă un Personaj",
    "gui.howtos.make-music.step_LeftRight": "Deplasare stânga-dreapta cu tastele săgeți",
    "gui.howtos.Chase-Game.step_UpDown": "Deplasare sus-jos cu tastele săgeți",
    "gui.howtos.Chase-Game.step_AddStar": "Mai adaugă un personaj",
    "gui.howtos.Chase-Game.step_MoveRandom": "Deplasare aleatoare",
    "gui.howtos.Chase-Game.step_WhenTouch": "Pentru personajul Caracatiță (Octopus), redă sunet la atingerea cu celălalt personaj",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Creează o variabilă pentru scor",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Pentru personajul Caracatiță (Octopus), la atingere crește scorul",
    "gui.howtos.animate-char.name": "Animează un personaj",
    "gui.howtos.animate-char.step_addbg": "Adaugă un decor",
    "gui.howtos.animate-char.step_addsprite": "Adaugă un personaj",
    "gui.howtos.animate-char.step_saysomething": "Spune ceva",
    "gui.howtos.animate-char.step_addsound": "Adaugă sunet",
    "gui.howtos.animate-char.step_animatetalking": "Animează vorbirea",
    "gui.howtos.animate-char.step_arrowkeys": "Mișcă cu tastele săgeți",
    "gui.howtos.animate-char.step_jump": "Sari",
    "gui.howtos.animate-char.step_changecolor": "Schimbă culoarea",
    "gui.howtos.make-a-game.name": "Creează un joc de îndemânare",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Alege un personaj",
    "gui.howtos.make-a-game.step_GamePlaySound": "Redă un sunet când se face clic",
    "gui.howtos.make-a-game.step_GameAddScore": "Creează o variabilă pentru scor",
    "gui.howtos.make-a-game.step_GameChangeScore": "Mărește scorul când se dă clic pe personaj",
    "gui.howtos.make-a-game.step_Random": "Mergi la o poziție aleatoare",
    "gui.howtos.make-music.step_GameChangeColor": "Schimbă culoarea",
    "gui.howtos.make-music.step_ResetScore": "Resetează scorul",
    "gui.howtos.make-it-fly.name": "Fă-l să zboare",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Alege un fundal pentru cer",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Alege un personaj",
    "gui.howtos.fly.step_stepflySaySomething": "Spune ceva",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Mișcă cu tastele săgeți",
    "gui.howtos.fly.step_stepflyChooseObject": "Alege un obiect de colectat",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Fă obiectul să se miște",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Alege-ți personajul",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Adaugă un scor",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Ține scorul",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Adaugă un peisaj",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Mișcă peisajul",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Costumul următor",
    "gui.howtos.pong": "Joc Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Adaugă un decor",
    "gui.howtos.pong.step_pongAddBallSprite": "Adaugă un personaj minge",
    "gui.howtos.pong.step_pongBounceAround": "Ricoșează ",
    "gui.howtos.pong.step_pongAddPaddle": "Adaugă o paletă",
    "gui.howtos.pong.step_pongMoveThePaddle": "Mișcă paleta",
    "gui.howtos.pong.step_pongSelectBallSprite": "Selectează personajul minge",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Adaugă cod pentru ricoșarea mingii din paletă",
    "gui.howtos.pong.step_pongAddAScore": "Adaugă o variabilă pentru scor",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Alege 'Scor' din meniu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Introdu blocul 'Modifică scor'",
    "gui.howtos.pong.step_pongResetScore": "Resetează scorul",
    "gui.howtos.pong.step_pongAddLineSprite": "Adaugă personajul linie",
    "gui.howtos.pong.step_pongGameOver": "Final joc",
    "gui.howtos.code-cartoon": "Programează un desen animat",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Spune ceva atunci când apeși steagul verde",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animează un personaj atunci când îl apeși",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Alege un personaj diferit",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Folosește un semn minus pentru a micșora",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Mărește și micșorează un personaj",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Alege un personaj diferit",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Sări în sus și în jos",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Apasă pe un personaj pentru a schimba scenele",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Alunecă ici-colo",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Schimbă costumele",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Alege și alte personaje de adăugat în desenul tău animat",
    "gui.howtos.cartoon-network": "Animează un joc de aventuri",
    "gui.howtos.cartoon-network.step_CNcharacter": "Alege un personaj de afișat",
    "gui.howtos.cartoon-network.step_CNsay": "Spune ceva",
    "gui.howtos.cartoon-network.step_CNglide": "Alunecă ici-colo",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Alege un obiect de urmărit",
    "gui.howtos.cartoon-network.step_CNcollect": "Colectează obiecte",
    "gui.howtos.cartoon-network.step_CNvariable": "Creează o variabilă pentru scor",
    "gui.howtos.cartoon-network.step_CNscore": "Ține scorul",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Următorul nivel: schimbă decorul",
    "gui.howtos.videosens.name": "Detectare video",
    "gui.howtos.videosens.step_addextension": "Adaugă o extensie",
    "gui.howtos.videosens.step_pet": "Mângâie pisica",
    "gui.howtos.videosens.step_animate": "Animează",
    "gui.howtos.videosens.step_pop": "Sparge un balon",
    "gui.howtos.say-it-out-loud": "Crează o animație care vorbește",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Adaugă blocuri Text în Vorbire",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Spune ceva",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Setează o voce",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Mișcă de jur împrejur",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Adaugă un decor",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Adaugă încă un personaj",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Cântă un cântec",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Schimbă culoarea",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Rotește",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Crește și micșorează",
    "gui.howtos.talking": "Povești Vorbite",
    "gui.howtos.talking.step_talesAddExtension": "Apasă pentru a adăuga blocurile de tip Text-către-Vorbire",
    "gui.howtos.talking.step_talesChooseSprite": "Alege un personaj",
    "gui.howtos.talking.step_talesSaySomething": "Fă un personaj să vorbească",
    "gui.howtos.talking.step_talesChooseBackdrop": "Alege un decor",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Apasă un personaj pentru a merge la următorul fundal",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Alege alt personaj",
    "gui.howtos.talking.step_talesMoveAround": "Mișcă ici și colo",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Alege alt decor",
    "gui.howtos.talking.step_talesAnimateTalking": "Animează vorbirea",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Alege alt decor",
    "gui.howtos.talking.step_talesChooseSound": "Alege un cântec pentru dans",
    "gui.howtos.talking.step_talesDanceMoves": "Mișcări de dans",
    "gui.howtos.talking.step_talesAskAnswer": "Ia blocurile Întrebare și Răspuns din categoria Detectare",
    "gui.howtos.add-sprite.name": "Adaugă un personaj",
    "gui.howtos.add-sprite.step_addSprite": "Adaugă un personaj",
    "gui.howtos.add-a-backdrop.name": "Adaugă un decor",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Adaugă un decor",
    "gui.howtos.change-size.name": "Modifică mărimea",
    "gui.howtos.change-size.step_changeSize": "Modifică mărimea",
    "gui.howtos.glide-around.name": "Alunecă ici-colo",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Alunecă ici-colo",
    "gui.howtos.change-size.step_glideAroundPoint": "Glisare până la un punct",
    "gui.howtos.record-a-sound.name": "Înregistrează un sunet",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Apasă pe tab-ul 'Sunete'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Apasă 'Înregistrează'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Apasă butonul Înregistrează",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Alege-ți sunetul",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Redă-ți sunetul",
    "gui.howtos.spin-video.name": "Fă-l să se răsucească",
    "gui.howtos.change-size.step_spinTurn": "Întoarce",
    "gui.howtos.change-size.step_spinPointInDirection": "Setează direcția",
    "gui.howtos.hide-and-show.name": "Ascunde și arată",
    "gui.howtos.change-size.step_hideAndShow": "Ascunde și arată",
    "gui.howtos.switch-costume.name": "Animează un personaj",
    "gui.howtos.change-size.step_switchCostumes": "Animează un personaj",
    "gui.howtos.move-around-with-arrow-keys.name": "Folosește tastele săgeți",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": " Mișcă în stânga și-n dreapta ",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Mișcă în sus și în jos",
    "gui.howtos.add-effects.name": "Adaugă efecte",
    "gui.howtos.videosens.step_addEffects": "Adaugă efecte",
    "gui.extension.music.name": "Muzică",
    "gui.extension.music.description": "Cântă la instrumente și tobe",
    "gui.extension.pen.name": "Stilou",
    "gui.extension.pen.description": "Desenează cu personajele tale.",
    "gui.extension.videosensing.name": "Detectare video",
    "gui.extension.videosensing.description": "Detectează mișcarea cu ajutorul camerei.",
    "gui.extension.text2speech.name": "Text în Vorbire",
    "gui.extension.text2speech.description": "Fă-ți proiectul să vorbească",
    "gui.extension.translate.name": "Traducere",
    "gui.extension.translate.description": "Tradu texte în alte limbi.",
    "gui.extension.makeymakey.description": "Transformă orice obiect într-un buton.",
    "gui.extension.microbit.description": "Conectează-ți proiectele cu lumea.",
    "gui.extension.microbit.connectingMessage": "Conectare",
    "gui.extension.ev3.description": "Construiește roboți interactivi și mai mult decât atât.",
    "gui.extension.ev3.connectingMessage": "Conectare. Asigură-te că pin-ul dispozitivului EV3 este 1234.",
    "gui.extension.boost.description": "Adu la viață creaturi robotizate.",
    "gui.extension.boost.connectingMessage": "Conectare",
    "gui.extension.wedo2.description": "Construiește cu motorașe și senzori.",
    "gui.extension.wedo2.connectingMessage": "Conectare",
    "gui.extension.gdxfor.description": "Simte împingerea, tragerea, mișcarea și rotirea.",
    "gui.extension.gdxfor.connectingMessage": "Conectare",
    "gui.libraryTags.all": "Tot",
    "gui.libraryTags.animals": "Animale",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Efecte",
    "gui.libraryTags.fantasy": "Fantezie",
    "gui.libraryTags.fashion": "Modă",
    "gui.libraryTags.food": "Mâncare",
    "gui.libraryTags.indoors": "Interioare",
    "gui.libraryTags.loops": "Repetitive",
    "gui.libraryTags.music": "Muzica",
    "gui.libraryTags.notes": "Note",
    "gui.libraryTags.outdoors": "Exterioare",
    "gui.libraryTags.patterns": "Șabloane",
    "gui.libraryTags.people": "Oameni",
    "gui.libraryTags.percussion": "Percuție",
    "gui.libraryTags.space": "Spațiu",
    "gui.libraryTags.sports": "Sporturi",
    "gui.libraryTags.underwater": "Subacvatic",
    "gui.libraryTags.voice": "Voce",
    "gui.libraryTags.wacky": "Trăznite",
    "gui.libraryTags.animation": "Animații",
    "gui.libraryTags.art": "Arta",
    "gui.libraryTags.games": "Jocuri",
    "gui.libraryTags.stories": "Povești",
    "gui.libraryTags.letters": "Litere",
    "gui.opcodeLabels.direction": "direcția",
    "gui.opcodeLabels.xposition": "poziția x",
    "gui.opcodeLabels.yposition": "poziția y",
    "gui.opcodeLabels.size": "mărime",
    "gui.opcodeLabels.costumename": "denumire costum",
    "gui.opcodeLabels.costumenumber": "numărul costumului",
    "gui.opcodeLabels.backdropname": "denumire decor",
    "gui.opcodeLabels.backdropnumber": "nr. decor",
    "gui.opcodeLabels.volume": "volum",
    "gui.opcodeLabels.tempo": "ritm",
    "gui.opcodeLabels.answer": "răspuns",
    "gui.opcodeLabels.loudness": "intensitate sunet",
    "gui.opcodeLabels.username": "nume utilizator",
    "gui.opcodeLabels.year": "anul",
    "gui.opcodeLabels.month": "luna",
    "gui.opcodeLabels.date": "data",
    "gui.opcodeLabels.dayofweek": "ziua săptămânii",
    "gui.opcodeLabels.hour": "ora",
    "gui.opcodeLabels.minute": "minutul",
    "gui.opcodeLabels.second": "secunda",
    "gui.opcodeLabels.timer": "cronometru",
    "gui.projectLoader.loadError": "Fișierul proiectului selectat nu a putut fi încărcat.",
    "gui.sharedMessages.backdrop": "decor{index}",
    "gui.sharedMessages.costume": "costum{index}",
    "gui.sharedMessages.sprite": "Personaj{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Confirmi înlocuirea proiectului curent ?",
    "gui.sharedMessages.loadFromComputerTitle": "Încarcă de pe calculator",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Proiect Scratch",
    "boost.color.any": "orice culoare",
    "boost.color.black": "negru",
    "boost.color.blue": "albastru",
    "boost.color.green": "verde",
    "boost.color.red": "roșu",
    "boost.color.white": "alb",
    "boost.color.yellow": "galben",
    "boost.getMotorPosition": "poziția motorului [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "unghiul de înclinare [TILT_DIRECTION]",
    "boost.motorDirection.backward": "înapoi",
    "boost.motorDirection.forward": "înainte",
    "boost.motorDirection.reverse": "inversează",
    "boost.motorOff": "oprește motorul [MOTOR_ID]",
    "boost.motorOn": "pornește motorul [MOTOR_ID]",
    "boost.motorOnFor": "pornește motorul [MOTOR_ID] pentru [DURATION] secunde",
    "boost.motorOnForRotation": "pornește motorul [MOTOR_ID] pentru [ROTATION] rotații",
    "boost.seeingColor": "vezi cărămida [COLOR]?",
    "boost.setLightHue": "setează culoare LED la [HUE]",
    "boost.setMotorDirection": "setează motorul [MOTOR_ID] în direcția [MOTOR_DIRECTION]",
    "boost.setMotorPower": "setează viteza motorului [MOTOR_ID] la [POWER] %",
    "boost.tiltDirection.any": "în orice direcție",
    "boost.tiltDirection.down": "în jos",
    "boost.tiltDirection.left": "în stânga",
    "boost.tiltDirection.right": "în dreapta",
    "boost.tiltDirection.up": "în sus",
    "boost.whenColor": "când este vizibilă cărămida [COLOR]",
    "boost.whenTilted": "când este înclinat [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "semnal sonor nota [NOTE] pentru [TIME] secunde",
    "ev3.buttonPressed": "butonul [PORT]este apăsat?",
    "ev3.getBrightness": "strălucire",
    "ev3.getDistance": "distanța",
    "ev3.getMotorPosition": "motor [PORT] poziția",
    "ev3.motorSetPower": "motor [PORT] setează putere la [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] rotește înainte [TIME] secunde",
    "ev3.motorTurnCounterClockwise": "motor [PORT] rotește înapoi [TIME] secunde",
    "ev3.whenBrightnessLessThan": "când strălucirea  < [DISTANCE]",
    "ev3.whenButtonPressed": "când butonul [PORT] este apăsat",
    "ev3.whenDistanceLessThan": "când distanța < [DISTANCE]",
    "gdxfor.getAcceleration": "accelerație[DIRECTION]",
    "gdxfor.getForce": "forță",
    "gdxfor.getSpin": "viteza rotației[DIRECTION]",
    "gdxfor.getTilt": "unghi de înclinare [TILT]",
    "gdxfor.isFreeFalling": "în cădere?",
    "gdxfor.isTilted": "înclinat [TILT]?",
    "gdxfor.pulled": "tras",
    "gdxfor.pushed": "împins",
    "gdxfor.shaken": "scuturat",
    "gdxfor.startedFalling": "cădere începută",
    "gdxfor.tiltDirectionMenu.any": "în orice direcție",
    "gdxfor.tiltDirectionMenu.back": "în spate",
    "gdxfor.tiltDirectionMenu.front": "în față",
    "gdxfor.tiltDirectionMenu.left": "în stânga",
    "gdxfor.tiltDirectionMenu.right": "în dreapta",
    "gdxfor.turnedFaceDown": "întors cu fața în jos",
    "gdxfor.turnedFaceUp": "întors cu fața în sus",
    "gdxfor.whenForcePushedOrPulled": "când senzorul de forță este [PUSH_PULL]",
    "gdxfor.whenGesture": "când e [GESTURE]",
    "gdxfor.whenTilted": "la înclinarea [TILT]",
    "makeymakey.downArrow": "săgeată jos",
    "makeymakey.downArrowShort": "jos",
    "makeymakey.leftArrow": "săgeată stânga",
    "makeymakey.leftArrowShort": "stânga",
    "makeymakey.rightArrow": "săgeată dreapta",
    "makeymakey.rightArrowShort": "dreapta",
    "makeymakey.spaceKey": "spațiu",
    "makeymakey.upArrow": "săgeată sus",
    "makeymakey.upArrowShort": "sus",
    "makeymakey.whenKeyPressed": "la apăsarea tastei [KEY]",
    "makeymakey.whenKeysPressedInOrder": "la apăsarea în ordine a [SEQUENCE]",
    "microbit.buttonsMenu.any": "oricare",
    "microbit.clearDisplay": "șterge ecran",
    "microbit.defaultTextToDisplay": "Salut!",
    "microbit.displaySymbol": "afișează [MATRIX]",
    "microbit.displayText": "afișează textul [TEXT]",
    "microbit.gesturesMenu.jumped": "sărit",
    "microbit.gesturesMenu.moved": "mutat",
    "microbit.gesturesMenu.shaken": "scuturat",
    "microbit.isButtonPressed": "butonul [BTN] este apăsat?",
    "microbit.isTilted": "înclinat [DIRECTION]?",
    "microbit.pinStateMenu.off": "oprit",
    "microbit.pinStateMenu.on": "pornit",
    "microbit.tiltAngle": "unghiul de înclinare [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "oricare",
    "microbit.tiltDirectionMenu.back": "în spate",
    "microbit.tiltDirectionMenu.front": "în față",
    "microbit.tiltDirectionMenu.left": "în stânga",
    "microbit.tiltDirectionMenu.right": "în dreapta",
    "microbit.whenButtonPressed": "când butonul [BTN] este apăsat",
    "microbit.whenGesture": "când e [GESTURE]",
    "microbit.whenPinConnected": "când pinul [PIN] este conectat",
    "microbit.whenTilted": "când este înclinat[DIRECTION]",
    "music.categoryName": "Muzica",
    "music.changeTempo": "schimbă ritmul cu [TEMPO]",
    "music.drumBass": "(2) Tobă mare",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Bețe",
    "music.drumClosedHiHat": "(6) Hi-Hat închis",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Cinel Crash ",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Aplauze",
    "music.drumOpenHiHat": "(5) Hi-Hat deschis",
    "music.drumSideStick": "(3) Bătaie pe margine",
    "music.drumSnare": "(1) Tobă Snare ",
    "music.drumTambourine": "(7) Tamburină",
    "music.drumTriangle": "(12) Trianglu",
    "music.drumVibraslap": " (17) Vibraslap",
    "music.drumWoodBlock": "(10) Bloc de lemn",
    "music.getTempo": "ritm",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Violoncel",
    "music.instrumentChoir": "(15) Cor",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Chitară electrică",
    "music.instrumentElectricPiano": "(2) Pian electric",
    "music.instrumentFlute": "(12) Flaut",
    "music.instrumentGuitar": "(4) Chitară",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Cutie muzicală",
    "music.instrumentOrgan": "(3) Orgă",
    "music.instrumentPiano": "(1) Pian",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofon",
    "music.instrumentSteelDrum": "(18) Tobă din oțel",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Flaut de lemn",
    "music.midiPlayDrumForBeats": "cântă la tobă [DRUM] pentru [BEATS] bătăi",
    "music.midiSetInstrument": "setează instrumentul la [INSTRUMENT]",
    "music.playDrumForBeats": "cântă la tobă [DRUM] pentru [BEATS] bătăi",
    "music.playNoteForBeats": "cântă nota  [NOTE] pentru [BEATS]  bătăi",
    "music.restForBeats": "ia o pauză pentru  [BEATS] bătăi",
    "music.setInstrument": "setează instrument la [INSTRUMENT]",
    "music.setTempo": "setează viteaza la [TEMPO]",
    "pen.categoryName": "Stilou",
    "pen.changeColorParam": "schimbă [COLOR_PARAM] stiloului cu [VALUE]",
    "pen.changeHue": "schimbă culoarea stiloului cu [HUE]",
    "pen.changeShade": "schimbă nuanța stiloului cu [SHADE]",
    "pen.changeSize": "schimbă grosimea stiloului cu [SIZE]",
    "pen.clear": "șterge tot",
    "pen.colorMenu.brightness": "strălucirea",
    "pen.colorMenu.color": "culoarea",
    "pen.colorMenu.saturation": "saturația",
    "pen.colorMenu.transparency": "transparența",
    "pen.penDown": "stilou jos",
    "pen.penUp": "stilou sus",
    "pen.setColor": "setează culoarea stiloului la [COLOR]",
    "pen.setColorParam": "setează [COLOR_PARAM] stiloului la [VALUE]",
    "pen.setHue": "setează culoarea stiloului la [HUE]",
    "pen.setShade": "setează nuanța stiloului la [SHADE]",
    "pen.setSize": "setează grosimea stiloului la [SIZE]",
    "pen.stamp": "ștampila",
    "speech.defaultWhenIHearValue": "să începem",
    "speech.extensionName": "Recunoaștere vocală",
    "speech.listenAndWait": "ascultă și așteaptă",
    "speech.speechReporter": "text vorbit",
    "speech.whenIHear": "când aud [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text în Vorbire",
    "text2speech.defaultTextToSpeak": "salut",
    "text2speech.giant": "uriaș",
    "text2speech.kitten": "pisicuță",
    "text2speech.setLanguageBlock": "setează limba [LANGUAGE]",
    "text2speech.setVoiceBlock": "setează vocea  [VOICE]",
    "text2speech.speakAndWaitBlock": "spune [WORDS]",
    "text2speech.squeak": "chiţăit",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Traducere",
    "translate.defaultTextToTranslate": "salut",
    "translate.translateBlock": "tradu [WORDS] în [LANGUAGE]",
    "translate.viewerLanguage": "limbă",
    "videoSensing.categoryName": "Detectare video",
    "videoSensing.direction": "direcția",
    "videoSensing.motion": "mișcarea",
    "videoSensing.off": "oprit",
    "videoSensing.on": "pornit",
    "videoSensing.onFlipped": "pornit în oglindă",
    "videoSensing.setVideoTransparency": "setează transparența video la [TRANSPARENCY]",
    "videoSensing.sprite": "personaj",
    "videoSensing.stage": "scenă",
    "videoSensing.videoOn": "[ATTRIBUTE] video față de [SUBJECT]",
    "videoSensing.videoToggle": "setează video ca [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "când mișcarea video > [REFERENCE]",
    "wedo2.getDistance": "distanța",
    "wedo2.getTiltAngle": "unghiul de înclinare [TILT_DIRECTION]",
    "wedo2.isTilted": "este înclinat [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "înapoi",
    "wedo2.motorDirection.forward": "înainte",
    "wedo2.motorDirection.reverse": "inversează",
    "wedo2.motorId.a": "motorul A",
    "wedo2.motorId.all": "toate motoarele",
    "wedo2.motorId.b": "motorul B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "oprește [MOTOR_ID] ",
    "wedo2.motorOn": "pornește [MOTOR_ID] ",
    "wedo2.motorOnFor": "pornește [MOTOR_ID]  pentru [DURATION] secunde",
    "wedo2.playNoteFor": "cântă nota [NOTE] pentru [DURATION] secunde",
    "wedo2.setLightHue": "setează culoare LED la [HUE]",
    "wedo2.setMotorDirection": "setează direcția [MOTOR_ID] pe [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "setează puterea [MOTOR_ID] la [POWER]",
    "wedo2.tiltDirection.any": "în orice direcție",
    "wedo2.tiltDirection.down": "în jos",
    "wedo2.tiltDirection.left": "în stânga",
    "wedo2.tiltDirection.right": "în dreapta",
    "wedo2.tiltDirection.up": "în sus",
    "wedo2.whenDistance": "când distanța [OP] [REFERENCE]",
    "wedo2.whenTilted": "când este înclinat [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Culoare",
    "paint.paintEditor.saturation": "Saturație",
    "paint.paintEditor.brightness": "Strălucire",
    "paint.paintEditor.costume": "Costum",
    "paint.paintEditor.group": "Grupează",
    "paint.paintEditor.ungroup": "Degrupează",
    "paint.paintEditor.undo": "Anulează ultima modificare",
    "paint.paintEditor.redo": "Refă acțiunea anulată",
    "paint.paintEditor.forward": "În față",
    "paint.paintEditor.backward": "În spate",
    "paint.paintEditor.front": "Primul",
    "paint.paintEditor.back": "Înapoi",
    "paint.paintEditor.more": "Altele",
    "paint.modeTools.brushSize": "Dimensiune",
    "paint.modeTools.eraserSize": "Grosimea radierei",
    "paint.modeTools.copy": "Copiază",
    "paint.modeTools.paste": "Lipește",
    "paint.modeTools.delete": "Șterge",
    "paint.modeTools.curved": "Curbat",
    "paint.modeTools.pointed": "Unghi",
    "paint.modeTools.thickness": "Grosime",
    "paint.modeTools.flipHorizontal": "Întoarce orizontal",
    "paint.modeTools.flipVertical": "Întoarce vertical",
    "paint.modeTools.filled": "Plin",
    "paint.modeTools.outlined": "Contur",
    "paint.paintEditor.bitmap": "Convertește la bitmap",
    "paint.paintEditor.vector": "Convertește în format vectorial",
    "paint.paintEditor.fill": "Umplere",
    "paint.paintEditor.stroke": "Contur",
    "paint.brushMode.brush": "Pensulă",
    "paint.eraserMode.eraser": "Radieră",
    "paint.fillMode.fill": "Umplere",
    "paint.lineMode.line": "Linie",
    "paint.ovalMode.oval": "Cerc",
    "paint.rectMode.rect": "Dreptunghi",
    "paint.reshapeMode.reshape": "Remodelează",
    "paint.roundedRectMode.roundedRect": "Dreptunghi rotunjit",
    "paint.selectMode.select": "Selectează",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Schimbă"
  },
  "ru": {
    "gui.alerts.lostPeripheralConnection": "Scratch потерял связь с {extensionName}.",
    "gui.alerts.tryAgain": "Попробуй еще раз",
    "gui.alerts.download": "Скачать",
    "gui.connection.reconnect": "Переподключиться",
    "gui.backpack.costumeLabel": "костюм",
    "gui.backpack.soundLabel": "звук",
    "gui.backpack.scriptLabel": "скрипт",
    "gui.backpack.spriteLabel": "спрайт",
    "gui.backpack.header": "Рюкзак",
    "gui.backpack.errorBackpack": "Ошибка при загрузке рюкзака",
    "gui.backpack.loadingBackpack": "Загрузка…",
    "gui.backpack.more": "Ещё",
    "gui.backpack.emptyBackpack": "Рюкзак пуст",
    "gui.unsupportedBrowser.label": "Браузер не поддерживается",
    "gui.unsupportedBrowser.errorLabel": "Произошла ошибка",
    "gui.unsupportedBrowser.notRecommended": "Нам очень жаль, но вы используете версию браузера, которую не поддерживает Scratch. Мы советует воспользоваться последними версиями таких браузеров как Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.description": "Нам очень жаль, но Scratch не поддерживает этот браузер.  Мы советует воспользоваться последними версиями таких браузеров как Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "Чтобы узнать больше, перейдите к {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "ЧаВО",
    "gui.cards.all-tutorials": "Учебники",
    "gui.cards.shrink": "Свернуть",
    "gui.cards.expand": "Развернуть",
    "gui.cards.close": "Закрыть",
    "gui.cards.more-things-to-try": "Дополнительные возможности!",
    "gui.cards.see-more": "Узнать больше",
    "gui.comingSoon.message1": "Не волнуйтесь, мы работаем над этим {emoji}",
    "gui.comingSoon.message2": "Скоро…",
    "gui.comingSoon.message3": "Мы работаем над этим {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Устройства не обнаружены",
    "gui.connection.auto-scanning.prescan": "Поставьте ваше устройство поблизости и начните поиск",
    "gui.connection.auto-scanning.pressbutton": "Нажмите кнопку на вашем устройстве.",
    "gui.connection.auto-scanning.start-search": "Начать поиск",
    "gui.connection.connecting-searchbutton": "Поиск...",
    "gui.connection.auto-scanning.try-again": "Попробуйте еще",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Подключено",
    "gui.connection.disconnect": "Отсоединить",
    "gui.connection.go-to-editor": "Перейти к редактору",
    "gui.connection.connecting-cancelbutton": "Соединяю...",
    "gui.connection.error.errorMessage": "Ой, кажется что-то пошло не так.",
    "gui.connection.error.tryagainbutton": "Попробуйте еще",
    "gui.connection.error.helpbutton": "Помощь",
    "gui.connection.peripheral-name-label": "Название устройства",
    "gui.connection.connect": "Соединить",
    "gui.connection.scanning.lookingforperipherals": "Идет поиск устройств",
    "gui.connection.scanning.noPeripheralsFound": "Устройства не обнаружены",
    "gui.connection.scanning.instructions": "Выберите свое устройство из списка",
    "gui.connection.search": "Обновить",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Убедитесь в том, что вы установили и запустили Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "Проверьте, включён ли Bluetooth",
    "gui.connection.unavailable.tryagainbutton": "Попробовать еще",
    "gui.connection.unavailable.helpbutton": "Помощь",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Вперед",
    "gui.controls.stop": "Остановить",
    "gui.crashMessage.label": "Упс! Что-то пошло не так.",
    "gui.crashMessage.description": "Нам очень жаль, но похоже что Scratch дал сбой. Сообщение об ошибке было автоматически отправлено команде Scratch. Пожалуйста, обновите страницу чтобы попробовать еще раз.",
    "gui.crashMessage.errorNumber": "Ваша ошибка зарегистрирована как {errorId}",
    "gui.crashMessage.reload": "Перезагрузить",
    "gui.customProcedures.myblockModalTitle": "Создать блок",
    "gui.customProcedures.addAnInputNumberText": "Добавить значение",
    "gui.customProcedures.numberTextType": "число или текст",
    "gui.customProcedures.addAnInputBoolean": "Добавить значение",
    "gui.customProcedures.booleanType": "логическое",
    "gui.customProcedures.addALabel": "Добавить подпись",
    "gui.customProcedures.runWithoutScreenRefresh": "Запустить без обновления экрана",
    "gui.customProcedures.cancel": "Отменить",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Направление",
    "gui.directionPicker.rotationStyles.allAround": "Кругом",
    "gui.directionPicker.rotationStyles.leftRight": "Влево/направо",
    "gui.directionPicker.rotationStyles.dontRotate": "Не вращать",
    "gui.gui.addExtension": "Добавить расширение",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Фоны",
    "gui.gui.costumesTab": "Костюмы",
    "gui.gui.soundsTab": "Звуки",
    "gui.extensionLibrary.comingSoon": "Скоро…",
    "gui.extensionLibrary.requires": "Требуются",
    "gui.extensionLibrary.collaboration": "В сотрудничестве",
    "gui.library.filterPlaceholder": "Поиск",
    "gui.library.allTag": "Все",
    "gui.loader.message1": "Создание блоков…",
    "gui.loader.message2": "Загрузка спрайтов…",
    "gui.loader.message3": "Загрузка звуков…",
    "gui.loader.message4": "Загрузка расширений…",
    "gui.loader.message5": "Пасём котов…",
    "gui.loader.message6": "Передача наночастиц…",
    "gui.loader.message7": "Надувание гобо…",
    "gui.loader.message8": "Подготовка смайликов…",
    "gui.loader.headline": "Загрузка проекта",
    "gui.loader.creating": "Создать проект",
    "gui.accountMenu.profile": "Профиль",
    "gui.accountMenu.myStuff": "Мои работы",
    "gui.accountMenu.myClasses": "Мои классы",
    "gui.accountMenu.myClass": "Мой класс",
    "gui.accountMenu.accountSettings": "Настройки аккаунта",
    "gui.accountMenu.signOut": "Выйти",
    "gui.authorInfo.byUser": "от{username}",
    "gui.menuBar.seeProjectPage": "Посмотреть страницу проекта",
    "gui.menuBar.language": "Language",
    "general.username": "Имя пользователя",
    "general.password": "Пароль",
    "general.signIn": "Войти",
    "login.needHelp": "Нужна помощь?",
    "form.validationRequired": "Это поле обязательно для заполнения",
    "gui.menuBar.tutorialsLibrary": "Руководства",
    "gui.menuBar.restoreSprite": "Восстановить Спрайт",
    "gui.menuBar.restoreSound": "Восстановить Звук",
    "gui.menuBar.restoreCostume": "Восстановить Костюм",
    "gui.menuBar.restore": "Восстановить",
    "gui.menuBar.saveNow": "Сохранить сейчас",
    "gui.menuBar.saveAsCopy": "Сохранить как копию",
    "gui.menuBar.remix": "Ремикс",
    "gui.menuBar.new": "Новый",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Сохранить на свой компьютер",
    "gui.menuBar.edit": "Редактировать",
    "gui.menuBar.turboModeOff": "Выключить Турбо режим",
    "gui.menuBar.turboModeOn": "Включить Турбо режим",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Присоединяйся",
    "gui.menuBar.signIn": "Войти",
    "gui.gui.projectTitlePlaceholder": "Название проекта",
    "gui.menuBar.saveNowLink": "Сохранить сейчас",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Доступен всем",
    "gui.menuBar.share": "Поделиться",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Помощь",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(пусто)",
    "gui.monitor.listMonitor.listLength": "длина {length}",
    "gui.monitor.contextMenu.default": "стандартный вид",
    "gui.monitor.contextMenu.large": "крупный вид",
    "gui.monitor.contextMenu.slider": "рычажок",
    "gui.monitor.contextMenu.sliderRange": "изменить диапазон рычажка",
    "gui.monitor.contextMenu.import": "импорт",
    "gui.monitor.contextMenu.export": "экспорт",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Играть",
    "gui.playButton.stop": "Остановить",
    "gui.gui.variableScopeOptionAllSprites": "Для всех спрайтов",
    "gui.gui.variableScopeOptionSpriteOnly": "Только для этого спрайта",
    "gui.gui.cloudVariableOption": "Облачная переменная (хранится на сервере)",
    "gui.gui.variablePromptAllSpritesMessage": "Эта переменная будет доступна для всех спрайтов.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Отменить",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Остановить",
    "gui.playbackStep.playMsg": "Проиграть",
    "gui.playbackStep.loadingMsg": "Загрузка…",
    "gui.playbackStep.saveMsg": "Сохранить",
    "gui.playbackStep.reRecordMsg": "Перезаписать",
    "gui.recordModal.title": "Записать звук",
    "gui.recordingStep.beginRecord": "Начните записывать, кликнув кнопку ниже",
    "gui.recordingStep.permission": "{arrow}Нам требуется ваше разрешение для использования вашего микрофона",
    "gui.recordingStep.stop": "Остановить запись",
    "gui.recordingStep.record": "Записать",
    "gui.sliderModal.min": "Минимальное значение",
    "gui.sliderModal.max": "Максимальное значение",
    "gui.sliderModal.title": "Изменить диапазон рычажка",
    "gui.sliderPrompt.cancel": "Отмена",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Звук",
    "gui.soundEditor.play": "Играть",
    "gui.soundEditor.stop": "Остановить",
    "gui.soundEditor.copy": "Копировать",
    "gui.soundEditor.paste": "Вставить",
    "gui.soundEditor.copyToNew": "Копировать в Новый Звук",
    "gui.soundEditor.delete": "Удалить",
    "gui.soundEditor.save": "Сохранить",
    "gui.soundEditor.undo": "Отменить",
    "gui.soundEditor.redo": "Вернуть",
    "gui.soundEditor.faster": "Быстрее",
    "gui.soundEditor.slower": "Медленнее",
    "gui.soundEditor.echo": "Эхо",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "Громче",
    "gui.soundEditor.softer": "Тише",
    "gui.soundEditor.reverse": "Развернуть",
    "gui.soundEditor.fadeOut": "Затухание",
    "gui.soundEditor.fadeIn": "Усиление",
    "gui.soundEditor.mute": "Заглушить",
    "gui.SpriteInfo.spritePlaceholder": "Название",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Показать",
    "gui.SpriteInfo.size": "Размер",
    "gui.spriteSelectorItem.contextMenuDuplicate": "дублировать",
    "gui.spriteSelectorItem.contextMenuExport": "экспорт",
    "gui.spriteSelectorItem.contextMenuDelete": "удалить",
    "gui.spriteSelector.addSpriteFromLibrary": "Выбрать спрайт",
    "gui.spriteSelector.addSpriteFromPaint": "Нарисовать",
    "gui.spriteSelector.addSpriteFromSurprise": "Сюрприз",
    "gui.spriteSelector.addSpriteFromFile": "Загрузить спрайт",
    "gui.stageHeader.stageSizeLarge": "Большая сцена",
    "gui.stageHeader.stageSizeSmall": "Маленькая сцена",
    "gui.stageHeader.stageSizeFull": "Перейти в полноэкранный режим",
    "gui.stageHeader.stageSizeUnFull": "Выйти из полноэкранного режима",
    "gui.stageHeader.fullscreenControl": "Полноэкранный режим",
    "gui.spriteSelector.addBackdropFromLibrary": "Выбрать фон",
    "gui.stageSelector.addBackdropFromPaint": "Нарисовать",
    "gui.stageSelector.addBackdropFromSurprise": "Сюрприз",
    "gui.stageSelector.addBackdropFromFile": "Загрузить фон",
    "gui.stageSelector.stage": "Сцена",
    "gui.stageSelector.backdrops": "Фоны",
    "gui.telemetryOptIn.label": "Отправь статистику, чтобы улучшить Scratch",
    "gui.telemetryOptIn.body1": "Команда Scratch всегда хочет понять как Scratch используется во всем мире. Чтобы помочь в поддержке, вы можете разрешить Scratch автоматически отправлять информацию об использовании команде Scratch!",
    "gui.telemetryOptIn.body2": "Мы собираем информацию о языке, использовании блоков и некоторые других событий, как сохранение, загрузка и загрузка проекта. Мы НЕ собираем личную информацию. Пожалуйста, посмотрите {privacyPolicyLink} для большего ознакомления. ",
    "gui.telemetryOptIn.privacyPolicyLink": "Политика конфиденциальности",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Турбо режим",
    "gui.webglModal.label": "Ваш браузер не поддерживает WebGL",
    "gui.webglModal.description": "К сожалению, похоже ваш браузер или компьютер {webGlLink}. Эта технология необходима для запуска Scratch 3.0.",
    "gui.webglModal.webgllink": "не поддерживает WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "Чтобы узнать больше, перейдите к {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "ЧаВО",
    "gui.costumeLibrary.chooseABackdrop": "Выбрать фон",
    "gui.costumeLibrary.chooseACostume": "Выбрать костюм",
    "gui.costumeTab.addBackdropFromLibrary": "Выбрать фон",
    "gui.costumeTab.addCostumeFromLibrary": "Выбрать костюм",
    "gui.costumeTab.addBlankCostume": "Рисовать",
    "gui.costumeTab.addSurpriseCostume": "Сюрприз",
    "gui.costumeTab.addFileBackdrop": "Загрузить фон",
    "gui.costumeTab.addFileCostume": "Загрузить костюм",
    "gui.extensionLibrary.chooseAnExtension": "Выбрать дополнение",
    "gui.extensionLibrary.extensionUrl": "Введи URL расширения",
    "gui.monitors.importListColumnPrompt": "Какая колонка должна быть использована (1- {numberOfColumns})? ",
    "gui.recordingStep.alertMsg": "Не удалось начать запись",
    "gui.soundLibrary.chooseASound": "Выбрать звук",
    "gui.soundTab.fileUploadSound": "Загрузить звук",
    "gui.soundTab.surpriseSound": "Сюрприз",
    "gui.soundTab.recordSound": "Записать",
    "gui.soundTab.addSoundFromLibrary": "Выбрать звук",
    "gui.spriteLibrary.chooseASprite": "Выбрать спрайт",
    "gui.tipsLibrary.tutorials": "Выбрать руководство",
    "gui.alerts.createsuccess": "Создан новый проект.",
    "gui.alerts.createcopysuccess": "Проект сохранён как копия.",
    "gui.alerts.createremixsuccess": "Проект сохранён как ремикс.",
    "gui.alerts.creating": "Создание нового ...",
    "gui.alerts.creatingCopy": "Копирование проекта ...",
    "gui.alerts.creatingRemix": "Создание ремикса проекта ...",
    "gui.alerts.creatingError": "Не удалось создать проект. Попробуйте еще раз!",
    "gui.alerts.savingError": "Проект не может быть сохранён",
    "gui.alerts.savesuccess": "Проект сохранён.",
    "gui.alerts.saving": "Сохранение проекта...",
    "gui.alerts.cloudInfo": "Не забудьте, что облачные переменные могут быть только цифрами, а не буквами или символами. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Узнать больше.",
    "gui.alerts.importing": "Импортируется...",
    "gui.defaultProject.meow": "Мяу",
    "gui.defaultProject.variable": "моя переменная",
    "gui.howtos.intro-move-sayhello-hat.name": "С чего начать",
    "gui.howtos.intro-move.step_stepMove": "Добавить подвижный блок",
    "gui.howtos.add-a-move-block.step_stepSay": "Добавь блок \"сказать\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Нажми на зелёный флаг чтобы начать",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Анимировать имя",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Выберите спрайт буквы",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Проигрывать звук при нажатии",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Выберите другой спрайт буквы",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Изменить цвет",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Выберите другой спрайт и заставьте его крутиться",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Выберите другой спрайт буквы и увеличьте его.",
    "gui.howtos.imagine": "Представь себе мир",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Введи то что ты хочешь сказать",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Нажми на зеленый флаг чтобы начать",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Выбери любой фон",
    "gui.howtos.imagine.step_imagineChooseSprite": "Выбери любой спрайт",
    "gui.howtos.imagine.step_imagineFlyAround": "Нажми на клавишу пробела чтобы плыть",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Выбери другой спрайт",
    "gui.howtos.imagine.step_imagineLeftRight": "Перемещайся влево-вправо",
    "gui.howtos.imagine.step_imagineUpDown": "Перемещайся вверх-вниз",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Меняй костюмы",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Плыви к точке",
    "gui.howtos.imagine.step_imagineGrowShrink": "Расти и уменьшайся",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Выбери другой фон",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Переключай фоны",
    "gui.howtos.imagine.step_imagineRecordASound": "Добавь звук",
    "gui.howtos.imagine.step_imagineChooseSound": "Выбери звук",
    "gui.howtos.make-music.name": "Создайте музыку",
    "gui.howtos.Make-Music.step_PickInstrument": "Выберите спрайт инструмента",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Играть звук при нажатии",
    "gui.howtos.Make-Music.step_MakeSong": "Создайте песню",
    "gui.howtos.make-music.step_MakeBeat": "Выберите барабаны и создайте ритм",
    "gui.howtos.make-music.step_MakeBeatBox": "Выберите спрайт микрофона и битбокс с сюрпризом",
    "gui.howtos.story.name": "Создать историю",
    "gui.howtos.story.step_addbg": "Добавьте фон",
    "gui.howtos.story.step_addsprite": "Добавить персонаж",
    "gui.howtos.story.step_saysomething": "Скажите что-нибудь",
    "gui.howtos.story.step_addanothersprite": "Добавить другого персонажа",
    "gui.howtos.story.step_flip": "Противоподлжное направление",
    "gui.howtos.story.step_conversation": "Завести разговор",
    "gui.howtos.story.addanotherbg": "Добавить другой фон",
    "gui.howtos.story.step_swithbg": "Переключить фоны",
    "gui.howtos.story.step_hidewizard": "Спрятать персонаж",
    "gui.howtos.story.step_showwizard": "Показать персонаж",
    "gui.howtos.make-a-chase-game.name": "Создать игру с погоней",
    "gui.howtos.Chase-Game.step_BG": "Добавьте фон",
    "gui.howtos.chase-game.step_AddOcto": "Добавь спрайт",
    "gui.howtos.make-music.step_LeftRight": "Перемещение вправо и влево при помощи клавиш со стрелками",
    "gui.howtos.Chase-Game.step_UpDown": "Перемещение вверх и вниз при помощи клавиш со стрелками ",
    "gui.howtos.Chase-Game.step_AddStar": "Добавить другой спрайт",
    "gui.howtos.Chase-Game.step_MoveRandom": "Двигаться в случайном направлении",
    "gui.howtos.Chase-Game.step_WhenTouch": "В спрайте осьминога при нажатии проигрывать звук",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Создать переменную счёта",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "В спрайте осьминога при касании добавлять счет",
    "gui.howtos.animate-char.name": "Анимировать персонаж",
    "gui.howtos.animate-char.step_addbg": "Добавьте фон",
    "gui.howtos.animate-char.step_addsprite": "Добавь спрайт",
    "gui.howtos.animate-char.step_saysomething": "Скажите что-нибудь",
    "gui.howtos.animate-char.step_addsound": "Добавьте звук",
    "gui.howtos.animate-char.step_animatetalking": "Анимировать разговор",
    "gui.howtos.animate-char.step_arrowkeys": "Двигаться при помощи стрелок",
    "gui.howtos.animate-char.step_jump": "Прыгать",
    "gui.howtos.animate-char.step_changecolor": "Изменить цвет",
    "gui.howtos.make-a-game.name": "Создать игру кликер",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Выбрать спрайт",
    "gui.howtos.make-a-game.step_GamePlaySound": "Играть звук при нажатии",
    "gui.howtos.make-a-game.step_GameAddScore": "Создать переменную счёта",
    "gui.howtos.make-a-game.step_GameChangeScore": "Увеличить счёт при нажатии",
    "gui.howtos.make-a-game.step_Random": "Перейти к случайной позиции",
    "gui.howtos.make-music.step_GameChangeColor": "Изменить цвет",
    "gui.howtos.make-music.step_ResetScore": "Сбросить счёт",
    "gui.howtos.make-it-fly.name": "Полетаем?",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Выбери фон с небом",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Выбери персонаж",
    "gui.howtos.fly.step_stepflySaySomething": "Скажи что-нибудь",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Перемещайся кнопками стрелок",
    "gui.howtos.fly.step_stepflyChooseObject": "Выбери объект для собирания",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Заставь объект перемещаться",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Выбери персонаж",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Добавь счет",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Веди счет",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Добавь пейзаж",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Перемещай пейзаж",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Следующий костюм",
    "gui.howtos.pong": "Игра в пинг-понг",
    "gui.howtos.pong.step_pongAddBackdrop": "Добавь фон",
    "gui.howtos.pong.step_pongAddBallSprite": "Добавь спрайт Ball (мяч)",
    "gui.howtos.pong.step_pongBounceAround": "Прыгай туда-сюда",
    "gui.howtos.pong.step_pongAddPaddle": "Добавь ракетку",
    "gui.howtos.pong.step_pongMoveThePaddle": "Перемещай ракетку",
    "gui.howtos.pong.step_pongSelectBallSprite": "Выбери спрайт Ball (мяч).",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Добавь команды чтобы отражать мяч ракеткой ",
    "gui.howtos.pong.step_pongAddAScore": "Добавь счет",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Выбери ‘Счет’ из меню.",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Добавь блок ‘Изменить Счет’",
    "gui.howtos.pong.step_pongResetScore": "Сбросить счёт",
    "gui.howtos.pong.step_pongAddLineSprite": "Добавь спрайт Line (линия)",
    "gui.howtos.pong.step_pongGameOver": "Конец игры",
    "gui.howtos.code-cartoon": "Запрограммируй мультфильм",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Скажи что-нибудь, когда нажмешь на зеленый флаг",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Оживи персонаж нажатием",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Выбери другой персонаж",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Используй знак минус для уменьшения объекта",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Заставь персонаж расти и уменьшаться",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Выбери другой персонаж",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Попрыгай вверх-вниз",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Нажимай на персонаж для смены сцен",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Поплавай вокруг",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Меняй костюмы",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Выбери больше персонажей для добавления в мультфильм",
    "gui.howtos.cartoon-network": "Анимируй игру-приключение",
    "gui.howtos.cartoon-network.step_CNcharacter": "Выбери персонажа для шоу",
    "gui.howtos.cartoon-network.step_CNsay": "Скажите что-нибудь",
    "gui.howtos.cartoon-network.step_CNglide": "Плавное движение",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Выберите объект для преследования",
    "gui.howtos.cartoon-network.step_CNcollect": "Собирай объекты",
    "gui.howtos.cartoon-network.step_CNvariable": "Сделай переменную счёта",
    "gui.howtos.cartoon-network.step_CNscore": "Продолжай подсчитывать",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Новый уровень: Измени фон ",
    "gui.howtos.videosens.name": "Видео распознавание",
    "gui.howtos.videosens.step_addextension": "Добавить расширение",
    "gui.howtos.videosens.step_pet": "Приручи кота",
    "gui.howtos.videosens.step_animate": "Анимировать",
    "gui.howtos.videosens.step_pop": "Хлопнуть шарик",
    "gui.howtos.say-it-out-loud": "Создать говорящую анимацию",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Добавить блоки \"Текста в Речь\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Скажи что-нибудь",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Установить голос",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Кружить",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Добавьте фон",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Добавить другого персонажа",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Исполнить песню",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Изменить цвет",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Покрутить",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Расти и уменьшаться",
    "gui.howtos.talking": "Говорящие сказки",
    "gui.howtos.talking.step_talesAddExtension": "Нажми для добавления блоков Текст-в-Речь",
    "gui.howtos.talking.step_talesChooseSprite": "Выбери спрайт",
    "gui.howtos.talking.step_talesSaySomething": "Заставь персонаж говорить",
    "gui.howtos.talking.step_talesChooseBackdrop": "Выбери фон",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Нажми на персонаж для перехода к следующему фону",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Выбери другой спрайт",
    "gui.howtos.talking.step_talesMoveAround": "Перемещайся поблизости",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Выбери другой фон",
    "gui.howtos.talking.step_talesAnimateTalking": "Оживи разговор",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Выбери другой фон",
    "gui.howtos.talking.step_talesChooseSound": "Выбери песню чтобы потанцевать под нее",
    "gui.howtos.talking.step_talesDanceMoves": "Танцевальные движения",
    "gui.howtos.talking.step_talesAskAnswer": "Используй блоки \"спросить\" и \"ответ\" из категории Сенсоры",
    "gui.howtos.add-sprite.name": "Добавь спрайт",
    "gui.howtos.add-sprite.step_addSprite": "Добавь спрайт",
    "gui.howtos.add-a-backdrop.name": "Добавьте фон",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Добавь фон",
    "gui.howtos.change-size.name": "Изменить размер",
    "gui.howtos.change-size.step_changeSize": "Меняй размер",
    "gui.howtos.glide-around.name": "Плыть кругом",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Поплавай вокруг",
    "gui.howtos.change-size.step_glideAroundPoint": "Плыви к точке",
    "gui.howtos.record-a-sound.name": "Записать звук",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Щелкни на вкладке ‘Звуки’.",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Нажми ‘Записать’.",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Нажми на кнопку Записать",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Выбери звук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Играй звук",
    "gui.howtos.spin-video.name": "Сделать вращение",
    "gui.howtos.change-size.step_spinTurn": "Повернись",
    "gui.howtos.change-size.step_spinPointInDirection": "Установи направление",
    "gui.howtos.hide-and-show.name": "Скрыть и показать",
    "gui.howtos.change-size.step_hideAndShow": "Скрыть и показать",
    "gui.howtos.switch-costume.name": "Анимировать спрайт",
    "gui.howtos.change-size.step_switchCostumes": "Оживи спрайт",
    "gui.howtos.move-around-with-arrow-keys.name": "Используй клавиши со стрелками",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Перемещайся влево и вправо",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Перемещайся вверх и вниз",
    "gui.howtos.add-effects.name": "Добавь эффекты",
    "gui.howtos.videosens.step_addEffects": "Добавь эффекты",
    "gui.extension.music.name": "Музыка",
    "gui.extension.music.description": "Играть на инструментах и барабанах.",
    "gui.extension.pen.name": "Перо",
    "gui.extension.pen.description": "Рисуй своими спрайтами.",
    "gui.extension.videosensing.name": "Видео распознавание",
    "gui.extension.videosensing.description": "Распознай движение с видео камеры",
    "gui.extension.text2speech.name": "Текст в речь",
    "gui.extension.text2speech.description": "Оживи свои проекты речью!",
    "gui.extension.translate.name": "Перевести",
    "gui.extension.translate.description": "Переводи текст на другие языки.",
    "gui.extension.makeymakey.description": "Превратить что угодно в ключ.",
    "gui.extension.microbit.description": "Свяжи свои проекты с миром",
    "gui.extension.microbit.connectingMessage": "Соединение",
    "gui.extension.ev3.description": "Создавайте интерактивных роботов.",
    "gui.extension.ev3.connectingMessage": "Подключение. Убедитесь, что пин-код на вашем EV3 задан, как 1234",
    "gui.extension.boost.description": "Вдохните в робота жизнь.",
    "gui.extension.boost.connectingMessage": "Соединение",
    "gui.extension.wedo2.description": "Стройте с помощью моторов и датчиков.",
    "gui.extension.wedo2.connectingMessage": "Соединение",
    "gui.extension.gdxfor.description": "Измеряет толкающие и тянущие усилия, движение и повороты.",
    "gui.extension.gdxfor.connectingMessage": "Соединение",
    "gui.libraryTags.all": "Все",
    "gui.libraryTags.animals": "Животные",
    "gui.libraryTags.dance": "Танец",
    "gui.libraryTags.effects": "Эффекты",
    "gui.libraryTags.fantasy": "Фантастика",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Еда",
    "gui.libraryTags.indoors": "В помещении",
    "gui.libraryTags.loops": "Циклы",
    "gui.libraryTags.music": "Музыка",
    "gui.libraryTags.notes": "Заметки",
    "gui.libraryTags.outdoors": "На открытом воздухе",
    "gui.libraryTags.patterns": "Узоры",
    "gui.libraryTags.people": "Люди",
    "gui.libraryTags.percussion": "Перкуссия",
    "gui.libraryTags.space": "Космос",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Подводный мир",
    "gui.libraryTags.voice": "Голос",
    "gui.libraryTags.wacky": "Безумцы",
    "gui.libraryTags.animation": "Анимация",
    "gui.libraryTags.art": "Искусство",
    "gui.libraryTags.games": "Игры",
    "gui.libraryTags.stories": "Истории",
    "gui.libraryTags.letters": "Буквы",
    "gui.opcodeLabels.direction": "направление",
    "gui.opcodeLabels.xposition": "положение x",
    "gui.opcodeLabels.yposition": "положение y",
    "gui.opcodeLabels.size": "размер",
    "gui.opcodeLabels.costumename": "имя костюма",
    "gui.opcodeLabels.costumenumber": "номер костюма",
    "gui.opcodeLabels.backdropname": "имя фона",
    "gui.opcodeLabels.backdropnumber": "номер фона",
    "gui.opcodeLabels.volume": "громкость",
    "gui.opcodeLabels.tempo": "темп",
    "gui.opcodeLabels.answer": "ответ",
    "gui.opcodeLabels.loudness": "громкость",
    "gui.opcodeLabels.username": "имя пользователя",
    "gui.opcodeLabels.year": "год",
    "gui.opcodeLabels.month": "месяц",
    "gui.opcodeLabels.date": "дата",
    "gui.opcodeLabels.dayofweek": "день недели",
    "gui.opcodeLabels.hour": "час",
    "gui.opcodeLabels.minute": "минута",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Не удалось загрузить файл проекта, который был выбран.",
    "gui.sharedMessages.backdrop": "фон {index}",
    "gui.sharedMessages.costume": "костюм {index}",
    "gui.sharedMessages.sprite": "Спрайт {index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Заменить содержимое текущего проекта?",
    "gui.sharedMessages.loadFromComputerTitle": "Загрузить с компьютера",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Проект Scratch",
    "boost.color.any": "любой цвет",
    "boost.color.black": "черный",
    "boost.color.blue": "синий",
    "boost.color.green": "зеленый",
    "boost.color.red": "красный",
    "boost.color.white": "белый",
    "boost.color.yellow": "желтый",
    "boost.getMotorPosition": "позиция мотора [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "угол наклона [TILT_DIRECTION]",
    "boost.motorDirection.backward": "туда",
    "boost.motorDirection.forward": "сюда",
    "boost.motorDirection.reverse": "изменить направление",
    "boost.motorOff": "выключить мотор [MOTOR_ID]",
    "boost.motorOn": "включить мотор [MOTOR_ID]",
    "boost.motorOnFor": "включить мотор [MOTOR_ID] на [DURATION] секунд",
    "boost.motorOnForRotation": "включить мотор [MOTOR_ID] на [ROTATION] оборотов",
    "boost.seeingColor": "виден [COLOR] кирпич?",
    "boost.setLightHue": "установить цвет лампочки [HUE]",
    "boost.setMotorDirection": "установить направление мотора [MOTOR_ID] в [MOTOR_DIRECTION]",
    "boost.setMotorPower": "установить скорость [MOTOR_ID] в [POWER] %",
    "boost.tiltDirection.any": "любая",
    "boost.tiltDirection.down": "вниз",
    "boost.tiltDirection.left": "налево",
    "boost.tiltDirection.right": "направо",
    "boost.tiltDirection.up": "вверх",
    "boost.whenColor": "когда виден [COLOR] кирпич",
    "boost.whenTilted": "когда наклонён [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "играть ноту [NOTE] [TIME] секунд",
    "ev3.buttonPressed": "кнопка [PORT] нажата?",
    "ev3.getBrightness": "яркость",
    "ev3.getDistance": "расстояние",
    "ev3.getMotorPosition": "позиция мотора [PORT]",
    "ev3.motorSetPower": "мотор [PORT] установить мощность [POWER] %",
    "ev3.motorTurnClockwise": "мотор [PORT] повернуть сюда на [TIME] секунд",
    "ev3.motorTurnCounterClockwise": "мотор [PORT] повернуть туда на [TIME] секунд",
    "ev3.whenBrightnessLessThan": "когда яркость < [DISTANCE]",
    "ev3.whenButtonPressed": "когда кнопка [PORT] нажата",
    "ev3.whenDistanceLessThan": "когда расстояние < [DISTANCE]",
    "gdxfor.getAcceleration": "ускорение [DIRECTION]",
    "gdxfor.getForce": "сила",
    "gdxfor.getSpin": "скорость вращения [DIRECTION]",
    "gdxfor.getTilt": "угол наклона [TILT]",
    "gdxfor.isFreeFalling": "падение?",
    "gdxfor.isTilted": "наклонён [TILT]?",
    "gdxfor.pulled": "вытянут",
    "gdxfor.pushed": "нажат",
    "gdxfor.shaken": "встряхнут",
    "gdxfor.startedFalling": "начал падать",
    "gdxfor.tiltDirectionMenu.any": "любая",
    "gdxfor.tiltDirectionMenu.back": "задний",
    "gdxfor.tiltDirectionMenu.front": "передний",
    "gdxfor.tiltDirectionMenu.left": "левый ",
    "gdxfor.tiltDirectionMenu.right": "правый",
    "gdxfor.turnedFaceDown": "повернут лицом вниз",
    "gdxfor.turnedFaceUp": "повернут лицом вверх",
    "gdxfor.whenForcePushedOrPulled": "когда датчик приложения силы [PUSH_PULL]",
    "gdxfor.whenGesture": "когда [GESTURE]",
    "gdxfor.whenTilted": "когда наклонён [TILT]",
    "makeymakey.downArrow": "стрелка вниз",
    "makeymakey.downArrowShort": "вниз",
    "makeymakey.leftArrow": "стрелка влево",
    "makeymakey.leftArrowShort": "влево",
    "makeymakey.rightArrow": "стрелка вправо",
    "makeymakey.rightArrowShort": "направо",
    "makeymakey.spaceKey": "пробел",
    "makeymakey.upArrow": "стрелка вверх",
    "makeymakey.upArrowShort": "вверх",
    "makeymakey.whenKeyPressed": "когда [KEY] клавиша нажата",
    "makeymakey.whenKeysPressedInOrder": "при нажатии по порядку [SEQUENCE]",
    "microbit.buttonsMenu.any": "любой из",
    "microbit.clearDisplay": "очистить дисплей",
    "microbit.defaultTextToDisplay": "Привет!",
    "microbit.displaySymbol": "отобразить [MATRIX]",
    "microbit.displayText": "показать текст [TEXT]",
    "microbit.gesturesMenu.jumped": "подпрыгнули",
    "microbit.gesturesMenu.moved": "передвинулись",
    "microbit.gesturesMenu.shaken": "встряхнули",
    "microbit.isButtonPressed": "[BTN] кнопка нажата?",
    "microbit.isTilted": "наклонён [DIRECTION]?",
    "microbit.pinStateMenu.off": "выключить",
    "microbit.pinStateMenu.on": "включить",
    "microbit.tiltAngle": "угол наклона [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "любой из",
    "microbit.tiltDirectionMenu.back": "назад",
    "microbit.tiltDirectionMenu.front": "вперёд",
    "microbit.tiltDirectionMenu.left": "влево",
    "microbit.tiltDirectionMenu.right": "направо",
    "microbit.whenButtonPressed": "когда [BTN] кнопка нажата",
    "microbit.whenGesture": "когда [GESTURE]",
    "microbit.whenPinConnected": "когда подключён пин [PIN]",
    "microbit.whenTilted": "когда наклонён [DIRECTION]",
    "music.categoryName": "Музыка",
    "music.changeTempo": "изменить темп на [TEMPO]",
    "music.drumBass": "(2) Большой барабан",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клаве",
    "music.drumClosedHiHat": "(16) Закрытый Хай-Хэт",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Ковбелл",
    "music.drumCrashCymbal": "(4) Крэш-тарелка",
    "music.drumCuica": "(18) Куика",
    "music.drumGuiro": "(16) Гуиро",
    "music.drumHandClap": "(8) Хлопок",
    "music.drumOpenHiHat": "(5) Открытый Хай-Хет",
    "music.drumSideStick": "(3) Римшот",
    "music.drumSnare": "(1) Малый барабан",
    "music.drumTambourine": "(7) Бубен",
    "music.drumTriangle": "(12) Треугольник",
    "music.drumVibraslap": "(17) Вибраслэп",
    "music.drumWoodBlock": "(10) Коробочка",
    "music.getTempo": "темп",
    "music.instrumentBass": "(6) Бас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Виолончель",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларнет",
    "music.instrumentElectricGuitar": "(5) Электрогитара",
    "music.instrumentElectricPiano": "(2) Электрическое пианино",
    "music.instrumentFlute": "(12) Флейта",
    "music.instrumentGuitar": "(4) Гитара",
    "music.instrumentMarimba": "(19) Маримба",
    "music.instrumentMusicBox": "(17) Музыкальная шкатулка",
    "music.instrumentOrgan": "(3) Орган",
    "music.instrumentPiano": "(1) Фортепиано",
    "music.instrumentPizzicato": "(7) Пиццикато",
    "music.instrumentSaxophone": "(11) Саксофон",
    "music.instrumentSteelDrum": "(18) Стальной барабан",
    "music.instrumentSynthLead": "(20) Ведущий синтезатор",
    "music.instrumentSynthPad": "(21) Синтезатор с функциями драм-машины",
    "music.instrumentTrombone": "(9) Тромбон",
    "music.instrumentVibraphone": "(16) Вибрафон",
    "music.instrumentWoodenFlute": "(13) Деревянная флейта",
    "music.midiPlayDrumForBeats": "барабану играть [DRUM]  [BEATS] бита",
    "music.midiSetInstrument": "изменить инструмент на [INSTRUMENT]",
    "music.playDrumForBeats": "барабану играть [DRUM]  [BEATS] бита",
    "music.playNoteForBeats": "играй ноту [NOTE] [BEATS] бита",
    "music.restForBeats": "пауза в течение [BEATS] бит",
    "music.setInstrument": "изменить инструмент на [INSTRUMENT]",
    "music.setTempo": "установить темп [TEMPO]",
    "pen.categoryName": "Перо",
    "pen.changeColorParam": "изменить [COLOR_PARAM] пера на [VALUE]",
    "pen.changeHue": "изменить цвет пера на [HUE]",
    "pen.changeShade": "изменить оттенок пера на [SHADE]",
    "pen.changeSize": "изменить размер пера на [SIZE]",
    "pen.clear": "стереть всё",
    "pen.colorMenu.brightness": "яркость",
    "pen.colorMenu.color": "цвет",
    "pen.colorMenu.saturation": "насыщенность",
    "pen.colorMenu.transparency": "прозрачность",
    "pen.penDown": "опустить перо",
    "pen.penUp": "поднять перо",
    "pen.setColor": "установить для пера цвет [COLOR]",
    "pen.setColorParam": "установить [COLOR_PARAM] пера [VALUE]",
    "pen.setHue": "установить цвет пера [HUE]",
    "pen.setShade": "установить оттенок пера [SHADE]",
    "pen.setSize": "установить размер пера [SIZE]",
    "pen.stamp": "печать",
    "speech.defaultWhenIHearValue": "начать движение",
    "speech.extensionName": "Речь в Текст",
    "speech.listenAndWait": "слушать и ждать",
    "speech.speechReporter": "речь",
    "speech.whenIHear": "когда я слышу [PHRASE]",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "Текст в речь",
    "text2speech.defaultTextToSpeak": "привет",
    "text2speech.giant": "гигант",
    "text2speech.kitten": "котенок",
    "text2speech.setLanguageBlock": "установить [LANGUAGE] язык",
    "text2speech.setVoiceBlock": "установить [VOICE] голос",
    "text2speech.speakAndWaitBlock": "сказать [WORDS] ",
    "text2speech.squeak": "писк",
    "text2speech.tenor": "тенор",
    "translate.categoryName": "Перевести",
    "translate.defaultTextToTranslate": "привет",
    "translate.translateBlock": "перевести [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "язык",
    "videoSensing.categoryName": "Видео Распознавание",
    "videoSensing.direction": "направление",
    "videoSensing.motion": "движение",
    "videoSensing.off": "выключить",
    "videoSensing.on": "включить",
    "videoSensing.onFlipped": "включить в обратную",
    "videoSensing.setVideoTransparency": "установить прозрачность видео  [TRANSPARENCY]",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "сцена",
    "videoSensing.videoOn": "видео [ATTRIBUTE]  на [SUBJECT]",
    "videoSensing.videoToggle": "включить видео [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "когда скорость видео > [REFERENCE]",
    "wedo2.getDistance": "расстояние",
    "wedo2.getTiltAngle": "угол наклона[TILT_DIRECTION]",
    "wedo2.isTilted": "наклонён [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "туда",
    "wedo2.motorDirection.forward": "сюда",
    "wedo2.motorDirection.reverse": "изменить направление",
    "wedo2.motorId.a": "мотор A",
    "wedo2.motorId.all": "все моторы",
    "wedo2.motorId.b": "мотор B",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": "выключить [MOTOR_ID]",
    "wedo2.motorOn": "включить [MOTOR_ID]",
    "wedo2.motorOnFor": "включить [MOTOR_ID] на [DURATION] секунд",
    "wedo2.playNoteFor": "играть ноту [NOTE] [DURATION] секунд",
    "wedo2.setLightHue": "установить цвет лампочки [HUE]",
    "wedo2.setMotorDirection": "установить направление [MOTOR_ID] в [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "установить мощность [MOTOR_ID] в [POWER]",
    "wedo2.tiltDirection.any": "любая",
    "wedo2.tiltDirection.down": "вниз",
    "wedo2.tiltDirection.left": "влево",
    "wedo2.tiltDirection.right": "направо",
    "wedo2.tiltDirection.up": "вверх",
    "wedo2.whenDistance": "когда расстояние [OP] [REFERENCE]",
    "wedo2.whenTilted": "когда наклонён [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Цвет",
    "paint.paintEditor.saturation": "Насыщенность",
    "paint.paintEditor.brightness": "Яркость",
    "paint.paintEditor.costume": "Костюм",
    "paint.paintEditor.group": "Группировать",
    "paint.paintEditor.ungroup": "Разгруппировать",
    "paint.paintEditor.undo": "Отменить",
    "paint.paintEditor.redo": "Переделать",
    "paint.paintEditor.forward": "Вперёд",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "На передний план",
    "paint.paintEditor.back": "На задний план",
    "paint.paintEditor.more": "Ещё",
    "paint.modeTools.brushSize": "Размер",
    "paint.modeTools.eraserSize": "Ширина ластика",
    "paint.modeTools.copy": "Копировать",
    "paint.modeTools.paste": "Вставить",
    "paint.modeTools.delete": "Удалить",
    "paint.modeTools.curved": "Изогнуть",
    "paint.modeTools.pointed": "Заострить",
    "paint.modeTools.thickness": "Толщина",
    "paint.modeTools.flipHorizontal": "Отразить по горизонтали",
    "paint.modeTools.flipVertical": "Отразить по вертикали",
    "paint.modeTools.filled": "Залитый",
    "paint.modeTools.outlined": "Обведённый",
    "paint.paintEditor.bitmap": "Конвертировать в растровую графику",
    "paint.paintEditor.vector": "Конвертировать в векторную графику",
    "paint.paintEditor.fill": "Заливка",
    "paint.paintEditor.stroke": "Контур",
    "paint.brushMode.brush": "Кисть",
    "paint.eraserMode.eraser": "Ластик",
    "paint.fillMode.fill": "Заливка",
    "paint.lineMode.line": "Линия",
    "paint.ovalMode.oval": "Круг",
    "paint.rectMode.rect": "Прямоугольник",
    "paint.reshapeMode.reshape": "Изменение формы",
    "paint.roundedRectMode.roundedRect": "Скруглённый Прямоугольник",
    "paint.selectMode.select": "Выбрать",
    "paint.textMode.text": "Текст",
    "paint.colorPicker.swap": "Заменить"
  },
  "nso": {
    "gui.alerts.lostPeripheralConnection": "Scratch se lahlegetšwe ke kgokaganyo go{extensionName}",
    "gui.alerts.tryAgain": "Leka Gape",
    "gui.alerts.download": "Fegolla",
    "gui.connection.reconnect": "Kgokaganya gape",
    "gui.backpack.costumeLabel": "khosetšhumo",
    "gui.backpack.soundLabel": "modumo",
    "gui.backpack.scriptLabel": "sengwalwa",
    "gui.backpack.spriteLabel": "motšeakarolo",
    "gui.backpack.header": "Mokotlana wa go atha magetleng",
    "gui.backpack.errorBackpack": "Go bile le bothata go laiša morwalana wa go atha magetleng",
    "gui.backpack.loadingBackpack": "E a Laiša...",
    "gui.backpack.more": "Go feta",
    "gui.backpack.emptyBackpack": "Morwalana wa go atha magetleng ga o na selo",
    "gui.unsupportedBrowser.label": "Sephetli ga se thekgwe",
    "gui.unsupportedBrowser.errorLabel": "Phošo E Diregatše",
    "gui.unsupportedBrowser.notRecommended": "Tshwarelo, go itaetša okare Scratch ga e thekge mohuta  wo o o šomišago wa sephetli. Re go kgothaletša gore o tsenye mohuta wa moragorago wa sephetli seo se thekgwago go swana le Google Chrome, Mozilla Firefox, Microsoft Edge, goba Apple Safari.",
    "gui.unsupportedBrowser.description": "Tshwarelo, go itaetša okare Scratch ga e thekge mohuta wo o o šomišago wa sephetli. Re go kgothaletša gore o tsenye mohuta wa moragorago wa sephetli seo se thekgwago go swana le Google Chrome, Mozilla Firefox, Microsoft Edge, goba Apple Safari.",
    "gui.unsupportedBrowser.back": "Morago",
    "gui.unsupportedBrowser.previewfaq": "Go ithuta go feta, eya go {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Dithutišo",
    "gui.cards.shrink": "Hunyela",
    "gui.cards.expand": "Godiša",
    "gui.cards.close": "Tswalela",
    "gui.cards.more-things-to-try": "Dilo tšeo di oketšegilego tšeo o ka di lekago!",
    "gui.cards.see-more": "Bona tše oketšegilego",
    "gui.comingSoon.message1": "O se belaele, re šomana nayo{emoji}",
    "gui.comingSoon.message2": "E a tla e se kgale...",
    "gui.comingSoon.message3": "Re gare re šoma ka yona{emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Ga go na didirišwa tšeo di humanwego",
    "gui.connection.auto-scanning.prescan": "Swara sedirišwa sa gago kgauswi gomme o thome go nyaka",
    "gui.connection.auto-scanning.pressbutton": "Kgotla konopi go sedirišwa sa gago",
    "gui.connection.auto-scanning.start-search": "Thomiša go nyaka",
    "gui.connection.connecting-searchbutton": "Nyaka...",
    "gui.connection.auto-scanning.try-again": "Leka gape",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Kgokagane",
    "gui.connection.disconnect": "Hakolla",
    "gui.connection.go-to-editor": "Eya go Thulaganyo",
    "gui.connection.connecting-cancelbutton": "Kgokaganya...",
    "gui.connection.error.errorMessage": "Mmalo, go itaetša o kare se sengwe ga se se sepele gabotse.",
    "gui.connection.error.tryagainbutton": "Leka gape",
    "gui.connection.error.helpbutton": "Thuša",
    "gui.connection.peripheral-name-label": "Leina la sedirišwa",
    "gui.connection.connect": "Kgokaganya",
    "gui.connection.scanning.lookingforperipherals": "Go nyaka didirišwa",
    "gui.connection.scanning.noPeripheralsFound": "Ga go na didirišwa tšeo di humanwego",
    "gui.connection.scanning.instructions": "Kgetha sedirišwa sa gago tatelanong ya ka godimo",
    "gui.connection.search": "Tsošeletša",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Netefatša gore o na  e tsentšhitšwe Scratch Link ebile e a šoma",
    "gui.connection.unavailable.enablebluetooth": "Lebelela gore Bluetooth e tšhumilwe",
    "gui.connection.unavailable.tryagainbutton": "Leka gape",
    "gui.connection.unavailable.helpbutton": "Thuša",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Sepela",
    "gui.controls.stop": "Ema",
    "gui.crashMessage.label": "Mmalo! se sengwe ga se a sepela gabotse.",
    "gui.crashMessage.description": "Tshwarelo,go itaetša okare Scratch e phuhlame. Se se begilwe ka go itiriša go sehlopha sa Scratch. Hle tsošeletša letlakala la gago o leke gape.",
    "gui.crashMessage.errorNumber": "Phošo ya gago e tsentšhitšwe ka boitsebišo{errorId}",
    "gui.crashMessage.reload": "Laišaleswa",
    "gui.customProcedures.myblockModalTitle": "Dira Poloko",
    "gui.customProcedures.addAnInputNumberText": "Oketša ka go ba le seabe",
    "gui.customProcedures.numberTextType": "nomoro goba sengwalwa",
    "gui.customProcedures.addAnInputBoolean": "Oketša ka go ba le seabe",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Oketša setlankana",
    "gui.customProcedures.runWithoutScreenRefresh": "Šoma ntle go tsošološa skrini",
    "gui.customProcedures.cancel": "Khansela",
    "gui.customProcedures.ok": "Go lokile",
    "gui.SpriteInfo.direction": "Taetšo",
    "gui.directionPicker.rotationStyles.allAround": "Go Dikologa Ka Moka",
    "gui.directionPicker.rotationStyles.leftRight": "La nngele/ La goja",
    "gui.directionPicker.rotationStyles.dontRotate": "O seke wa dikološa",
    "gui.gui.addExtension": "Oketša koketšo",
    "gui.gui.codeTab": "Khoutu",
    "gui.gui.backdropsTab": "Bokamorago",
    "gui.gui.costumesTab": "Dikhostšhumo",
    "gui.gui.soundsTab": "Medumo",
    "gui.extensionLibrary.comingSoon": "E a tla e se kgale",
    "gui.extensionLibrary.requires": "E hloka",
    "gui.extensionLibrary.collaboration": "Tšhomišano le",
    "gui.library.filterPlaceholder": "Nyaka",
    "gui.library.allTag": "Ka moka",
    "gui.loader.message1": "Go hlama dipoloko",
    "gui.loader.message2": "E laiša batšeakarolo...",
    "gui.loader.message3": "E laiša medumo...",
    "gui.loader.message4": "E laiša dikoketšo...",
    "gui.loader.message5": "Go diša dikatse...",
    "gui.loader.message6": "E fetiša di nano",
    "gui.loader.message7": "Butšwetša di gobo...",
    "gui.loader.message8": "Go beakanya diemoji",
    "gui.loader.headline": "E laiša Projeke",
    "gui.loader.creating": "Go Hlama Projeke",
    "gui.accountMenu.profile": "Boemo",
    "gui.accountMenu.myStuff": "Dilo Tša Ka",
    "gui.accountMenu.myClasses": "Diphapoši Tša Ka",
    "gui.accountMenu.myClass": "Phapoši Ya Ka",
    "gui.accountMenu.accountSettings": "Ditokišo tša Akhaonte",
    "gui.accountMenu.signOut": "Etšwa",
    "gui.authorInfo.byUser": "ke{username}",
    "gui.menuBar.seeProjectPage": "Bona Letlakala la Projeke",
    "gui.menuBar.language": "Language",
    "general.username": "Leinatšhomišo",
    "general.password": "Password",
    "general.signIn": "Go tsena",
    "login.needHelp": "O nyaka thušo?",
    "form.validationRequired": "Lefapha le le a nyakega",
    "gui.menuBar.tutorialsLibrary": "Dithutišo",
    "gui.menuBar.restoreSprite": "Tsošološa Motšeakarolo",
    "gui.menuBar.restoreSound": "Tsošološa modumo",
    "gui.menuBar.restoreCostume": "Tsošološa khosetšhumo",
    "gui.menuBar.restore": "Tsošološa",
    "gui.menuBar.saveNow": "Boloka gona bjale",
    "gui.menuBar.saveAsCopy": "Boloka bjalo ka khophi",
    "gui.menuBar.remix": "Hlakantšha",
    "gui.menuBar.new": "Ntshwa",
    "gui.menuBar.file": "Faele",
    "gui.menuBar.downloadToComputer": "Boloka khomphuteng ya gago",
    "gui.menuBar.edit": "Rulaganya",
    "gui.menuBar.turboModeOff": "Tima Mokgwa wa Turbo",
    "gui.menuBar.turboModeOn": "Tšhuma Mokgwa wa Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Tsenela Scratch",
    "gui.menuBar.signIn": "Go tsena",
    "gui.gui.projectTitlePlaceholder": "Sehlogo sa Projeke mo",
    "gui.menuBar.saveNowLink": "Boloka Go Na Bjale",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Abelane",
    "gui.menuBar.share": "Abela",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Thuša",
    "gui.modal.back": "Morago",
    "gui.monitor.listMonitor.empty": "( a go na selo)",
    "gui.monitor.listMonitor.listLength": "botelele{length}",
    "gui.monitor.contextMenu.default": "Tshedimošo ya setlwaedi",
    "gui.monitor.contextMenu.large": "Tshedimošo e kgolo",
    "gui.monitor.contextMenu.slider": "setheledi",
    "gui.monitor.contextMenu.sliderRange": "Fetola mathomo le magomo a setheledi",
    "gui.monitor.contextMenu.import": "thekontle",
    "gui.monitor.contextMenu.export": "iša ka ntle",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Bapala",
    "gui.playButton.stop": "Ema",
    "gui.gui.variableScopeOptionAllSprites": "Go batšeakarolo kamoka",
    "gui.gui.variableScopeOptionSpriteOnly": "Go motšeakarolo o fela",
    "gui.gui.cloudVariableOption": "Phapanyo lerung ( e bolokilwe go sever)",
    "gui.gui.variablePromptAllSpritesMessage": "Phapanyo ye e tla humanego go batšeakarolo ka moka",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Khansela",
    "gui.prompt.ok": "Go lokile",
    "gui.playbackStep.stopMsg": "Ema",
    "gui.playbackStep.playMsg": "Bapala",
    "gui.playbackStep.loadingMsg": "E a Laiša...",
    "gui.playbackStep.saveMsg": "Boloka",
    "gui.playbackStep.reRecordMsg": "Gatiša leswa",
    "gui.recordModal.title": "Gatiša Modumo",
    "gui.recordingStep.beginRecord": "Thoma go gatiša ka go kgotla konopi ya ka fase",
    "gui.recordingStep.permission": "{arrow}Re hloka tumelelo ya gago go šomiša maekrofone ya gago",
    "gui.recordingStep.stop": "Emiša go gatiša",
    "gui.recordingStep.record": "Gatiša",
    "gui.sliderModal.min": "Boleng bja fase",
    "gui.sliderModal.max": "Boleng bja godimo",
    "gui.sliderModal.title": "Fetola mathomo le magomo a setheledi",
    "gui.sliderPrompt.cancel": "Khansela",
    "gui.sliderPrompt.ok": "Go lokile",
    "gui.soundEditor.sound": "Modumo",
    "gui.soundEditor.play": "Bapala",
    "gui.soundEditor.stop": "Ema",
    "gui.soundEditor.copy": "Kopisa",
    "gui.soundEditor.paste": "Momaretša",
    "gui.soundEditor.copyToNew": "Kopisetša go e mpsha",
    "gui.soundEditor.delete": "Phumula",
    "gui.soundEditor.save": "Boloka",
    "gui.soundEditor.undo": "Dirolla",
    "gui.soundEditor.redo": "Dira gape",
    "gui.soundEditor.faster": "Ka lebelo",
    "gui.soundEditor.slower": "Ka go nanya",
    "gui.soundEditor.echo": "Ekho",
    "gui.soundEditor.robot": "Roboto",
    "gui.soundEditor.louder": "Godimonyana",
    "gui.soundEditor.softer": "Boletiana",
    "gui.soundEditor.reverse": "Revese",
    "gui.soundEditor.fadeOut": "Timelela",
    "gui.soundEditor.fadeIn": "Tšwelela",
    "gui.soundEditor.mute": "Homotša",
    "gui.SpriteInfo.spritePlaceholder": "Leina",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Motšeakarolo",
    "gui.SpriteInfo.show": "Laetša",
    "gui.SpriteInfo.size": "Bogolo",
    "gui.spriteSelectorItem.contextMenuDuplicate": "pedifatša",
    "gui.spriteSelectorItem.contextMenuExport": "iša ntle",
    "gui.spriteSelectorItem.contextMenuDelete": "Phumula",
    "gui.spriteSelector.addSpriteFromLibrary": "Kgetha Motšeakarolo",
    "gui.spriteSelector.addSpriteFromPaint": "Penta",
    "gui.spriteSelector.addSpriteFromSurprise": "Makala",
    "gui.spriteSelector.addSpriteFromFile": "Laiša Motšeakarolo",
    "gui.stageHeader.stageSizeLarge": "Fetolela go sefala se segolo",
    "gui.stageHeader.stageSizeSmall": "Fetolela go sefala se sennyane",
    "gui.stageHeader.stageSizeFull": "Tsena mo go mokgwa wa go tlala wa skrini",
    "gui.stageHeader.stageSizeUnFull": "Etšwa mo go mokgwa wa go tlala wa skrini",
    "gui.stageHeader.fullscreenControl": "Taolo ye e Feletšego ya Skrini",
    "gui.spriteSelector.addBackdropFromLibrary": "Kgetha Bokamorago",
    "gui.stageSelector.addBackdropFromPaint": "Penta",
    "gui.stageSelector.addBackdropFromSurprise": "Makala",
    "gui.stageSelector.addBackdropFromFile": "Laiša Bokamorago",
    "gui.stageSelector.stage": "Sefala",
    "gui.stageSelector.backdrops": "Bokamorago",
    "gui.telemetryOptIn.label": "Bega dipalopalo go kaonafatša Scratch",
    "gui.telemetryOptIn.body1": "Sehlopha sa Scratch se dula se nyaka go kwešiša bokaone gore Scratch e šomišwa bjang go ralala le lefase. Go leka go thekga maiteko a, o ka dumelela Scratch go romela tshedimošo ya tirišo go Sehlopha sa Scratch ka go itiriša.",
    "gui.telemetryOptIn.body2": "Tshedimošo yeo re e kgoboketšago e akaretša go kgetha polelo, go šomiša dipoloko,le dilo tša go swana le go boloka, go laiša le go tsenya projeke. GA RE kgobaketše tshedimošo ya motho. Hle bona{privacyPolicyLink}ya rena gore o hwetše tshedimošo ka botlalo.",
    "gui.telemetryOptIn.privacyPolicyLink": "Pholisi ya Sephiri",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Mokgwa wa Turbo",
    "gui.webglModal.label": "Sephetli sa gago ga se thekge WebGL",
    "gui.webglModal.description": "Ka bomadimabe go itaetša okare sephetli goba khomphutha{webGlLink}.Theknolotši ye e a hlokagala gore Scratch 3.0 e šome.",
    "gui.webglModal.webgllink": "Ga e thekge WebGL",
    "gui.webglModal.back": "Morago",
    "gui.webglModal.previewfaq": "Go ithuta go feta mo, eya go {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Kgetha Bokamorago",
    "gui.costumeLibrary.chooseACostume": "Kgetha Khosetšhumo",
    "gui.costumeTab.addBackdropFromLibrary": "Kgetha Bokamorago",
    "gui.costumeTab.addCostumeFromLibrary": "Kgetha Khosetšhumo",
    "gui.costumeTab.addBlankCostume": "Penta",
    "gui.costumeTab.addSurpriseCostume": "Makala",
    "gui.costumeTab.addFileBackdrop": "Laiša Bokamorago",
    "gui.costumeTab.addFileCostume": "Laiša Khosetšhumo",
    "gui.extensionLibrary.chooseAnExtension": "Kgetha Koketšo",
    "gui.extensionLibrary.extensionUrl": "Tsenya URL ya koketšo",
    "gui.monitors.importListColumnPrompt": "Ke kholomo efe yeo e swanetšego go šomišwa (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ga se e kgone go thoma go gatiša",
    "gui.soundLibrary.chooseASound": "Kgetha Modumo",
    "gui.soundTab.fileUploadSound": "Laiša Modumo",
    "gui.soundTab.surpriseSound": "Makala",
    "gui.soundTab.recordSound": "Gatiša",
    "gui.soundTab.addSoundFromLibrary": "Kgetha Modumo",
    "gui.spriteLibrary.chooseASprite": "Kgetha Motšeakarolo",
    "gui.tipsLibrary.tutorials": "Kgetha Thutišo",
    "gui.alerts.createsuccess": "Projeke e mpsha e hlamilwe.",
    "gui.alerts.createcopysuccess": "Projeke e bolokilwe bjalo ka khophi.",
    "gui.alerts.createremixsuccess": "Projeke e bolokilwe bjalo ka hlakantšho.",
    "gui.alerts.creating": "Go hlama leswa...",
    "gui.alerts.creatingCopy": "Go kopisa projeke...",
    "gui.alerts.creatingRemix": "Go hlakanya projeke...",
    "gui.alerts.creatingError": "Projeke e paletšwe ke go hlangwa. Hle,  leka gape!",
    "gui.alerts.savingError": "Projeke ga se ya boloka.",
    "gui.alerts.savesuccess": "Projeke e bolokilwe.",
    "gui.alerts.saving": "Projeke e a bolokega.....",
    "gui.alerts.cloudInfo": "Hle lemoga, phapanyo ya leru e thekga fela dinomoro, e sego maletere le dika.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Ithute go feta.",
    "gui.alerts.importing": "Go tliša...",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "phapanyo ya ka",
    "gui.howtos.intro-move-sayhello-hat.name": "Go thomiša",
    "gui.howtos.intro-move.step_stepMove": "Oketša poloko ya go šuta",
    "gui.howtos.add-a-move-block.step_stepSay": "Oketša poloko ya go bolela",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Kgotla folaga ye talamorogo gore o thome",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Phediša leina",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Kgetha Motšeakarolo wa Leletere",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Bapala modumo ge go tobetšwa",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Kgetha Motšeakarolo wo Mongwe wa Leletere",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Fetola Mmala",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Kgetha Motšeakarolo wo mongwe wa leletere gomme o dire gore a dikologe",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Kgetha Motšeakarolo O Mongwe wa Leletere gomme o Dire Gore A Gole",
    "gui.howtos.imagine": "Nagana Lefase",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tlanya Seo o Nyakago go se Bolela",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Kgotla folaga e talamorogo go thoma",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Kgetha bokamorago bjo bongwe le bjo bongwe",
    "gui.howtos.imagine.step_imagineChooseSprite": "Kgetha Motšeakarolo Ofe Kapa Ofe",
    "gui.howtos.imagine.step_imagineFlyAround": "Kgotla Konopi ya Sekgoba gore o Thwethe",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Kgetha Motšeakarolo O Mongwe",
    "gui.howtos.imagine.step_imagineLeftRight": "Šuta go La nngele- La go ja",
    "gui.howtos.imagine.step_imagineUpDown": "Šuta o e ya Godimo- Fase",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Fetola Khosetšhumo",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Thwethela sešupong",
    "gui.howtos.imagine.step_imagineGrowShrink": "Godiša o be o Hunyele",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Kgetha Bokamorago Bo Bongwe",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Fetola bokamorago",
    "gui.howtos.imagine.step_imagineRecordASound": "Tlaleletša ka Modumo",
    "gui.howtos.imagine.step_imagineChooseSound": "Kgetha Modumo Wa Gago",
    "gui.howtos.make-music.name": "Dira Mmino",
    "gui.howtos.Make-Music.step_PickInstrument": "Kgetha Motšeakarolo wa Seletšo",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Bapala Modumo ge go Tobetšwa",
    "gui.howtos.Make-Music.step_MakeSong": "Hlama Koša",
    "gui.howtos.make-music.step_MakeBeat": "Kgetha Moropa gomme O dire Morethetho",
    "gui.howtos.make-music.step_MakeBeatBox": "Kgetha Motšeakarolo wa Maekrofounu le Lepokisi la Semaka  la Medumo",
    "gui.howtos.story.name": "Hlama Kanegelo",
    "gui.howtos.story.step_addbg": "Oketša Bokamorago",
    "gui.howtos.story.step_addsprite": "Oketša Moanegwa",
    "gui.howtos.story.step_saysomething": "Bolela Se Sengwe",
    "gui.howtos.story.step_addanothersprite": "Oketša Moanegwa o mongwe",
    "gui.howtos.story.step_flip": "Phethola Taetšo",
    "gui.howtos.story.step_conversation": "E ba le Poledišano",
    "gui.howtos.story.addanotherbg": "Oketša Bokamorago Bjo Bongwe",
    "gui.howtos.story.step_swithbg": "Fetola Bokamorago",
    "gui.howtos.story.step_hidewizard": "Khutiša Moanegwa",
    "gui.howtos.story.step_showwizard": "Laetša Moanegwa",
    "gui.howtos.make-a-chase-game.name": "Dira Papadi ya go Kitimišana",
    "gui.howtos.Chase-Game.step_BG": "Oketša Bokamorago",
    "gui.howtos.chase-game.step_AddOcto": "Oketša Motšeakarolo",
    "gui.howtos.make-music.step_LeftRight": "Šuta go La go ja le La nngele ka Dikonope tša Marungwana",
    "gui.howtos.Chase-Game.step_UpDown": "Šuta o eya Godimo le Fase ka Dikonopi tša Marungwana",
    "gui.howtos.Chase-Game.step_AddStar": "Oketša Motšeakarolo o Mongwe",
    "gui.howtos.Chase-Game.step_MoveRandom": "Šuta o sa Hlaole",
    "gui.howtos.Chase-Game.step_WhenTouch": "Mo go Motšeakarolo wa Okthophase Ge o Kgoma go Bapala Modumo",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Hlama Phapanyo ya Dintlha",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Mo go Motšeakarolo wa Okthophase, Ge o Kgoma go Tsenya Dintlha",
    "gui.howtos.animate-char.name": "Swantšha Moanegwa",
    "gui.howtos.animate-char.step_addbg": "Oketša Bokamorago",
    "gui.howtos.animate-char.step_addsprite": "Oketša Motšeakaralo",
    "gui.howtos.animate-char.step_saysomething": "Bolela Se Sengwe",
    "gui.howtos.animate-char.step_addsound": "Oketša modumo",
    "gui.howtos.animate-char.step_animatetalking": "Phediša go bolela",
    "gui.howtos.animate-char.step_arrowkeys": "Šuta o šomiša Dikonopi tša Marungwana",
    "gui.howtos.animate-char.step_jump": "Fofa",
    "gui.howtos.animate-char.step_changecolor": "Fetola Mmala",
    "gui.howtos.make-a-game.name": "Dira papadi ya go tobetša",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Kgetha Motšeakarolo",
    "gui.howtos.make-a-game.step_GamePlaySound": "Bapala Modumo ge go Tobetšwa",
    "gui.howtos.make-a-game.step_GameAddScore": "Hlama Phapanyo ya Dintlha",
    "gui.howtos.make-a-game.step_GameChangeScore": "Oketša Dintlha ge go Tobetšwa",
    "gui.howtos.make-a-game.step_Random": "Eya boemong ba go se hlaole",
    "gui.howtos.make-music.step_GameChangeColor": "Fetola Mmala",
    "gui.howtos.make-music.step_ResetScore": "Beakanya dintlha leswa",
    "gui.howtos.make-it-fly.name": "Dira gore e Fofe",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Kgetha Bokamorago bja Leratadima",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Kgetha Moanegwa",
    "gui.howtos.fly.step_stepflySaySomething": "Bolela Se Sengwe",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Šutiša ka Dikopi tša Marungwana",
    "gui.howtos.fly.step_stepflyChooseObject": "Kgetha Selo seo o ka se Tšeago",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Dira gore Selo se Šute",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Kgetha Moanegwa Wa Gago",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Oketša Ntlha",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Boloka Dintlha",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Oketša Tikologo",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Šutiša Tikologo",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Khosetšhumo ye e latelago",
    "gui.howtos.pong": "Papadi ya Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Oketša Bokamorago",
    "gui.howtos.pong.step_pongAddBallSprite": "Oketša Motseakarolo wa kgwele",
    "gui.howtos.pong.step_pongBounceAround": "Fofafofiša go Dikologa",
    "gui.howtos.pong.step_pongAddPaddle": "Tsenya Sesoki",
    "gui.howtos.pong.step_pongMoveThePaddle": "Šutiša Sesoki",
    "gui.howtos.pong.step_pongSelectBallSprite": "Kgetha Motšeakarolo wa Kgwele",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Tsenya Khoutu gore o Fofafofiše Kgwele Go Tloga go Sesoki",
    "gui.howtos.pong.step_pongAddAScore": "Oketša Ntlha",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Kgetha ' dintlha' go lenaneo la ditaelo",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Tsenya poloko ya ' gofetola dintlha'",
    "gui.howtos.pong.step_pongResetScore": "Beakanya dintlha leswa",
    "gui.howtos.pong.step_pongAddLineSprite": "Tsenya Motseakarolo wa mothaladi",
    "gui.howtos.pong.step_pongGameOver": "Papadi e Fedile",
    "gui.howtos.code-cartoon": "Khouta Popo",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Bolela Se Sengwe Ge O Tobetša Folaga ye Talamorogo",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Phediša Moanegwa ge o Mo Tobetša",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Kgetha Moanegwa yo a Fapanego",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Šomiša Leswao la go Ntšha gore o be o Monnnyane.",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Dira gore Moanegwa a Gole goba a Hunyele",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Kgetha Moanegwa yo a Fapanego",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Fofela godimo le fase",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Tobetša Moanegwa Gore o Fetole Tikologo",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Thwetha go dikologa",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Fetola Khosetšhumo",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Kgetha Baanegwa ba Oketšegilego go Oketša go Dipopaye tša gago",
    "gui.howtos.cartoon-network": "Phediša Papadi ya Boithabišo",
    "gui.howtos.cartoon-network.step_CNcharacter": "Kgetha Moanegwa o Mmontšhe",
    "gui.howtos.cartoon-network.step_CNsay": "Bolela Se Sengwe",
    "gui.howtos.cartoon-network.step_CNglide": "Thwetha go dikologa",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Kgetha selo seo o ka se Kitimišago",
    "gui.howtos.cartoon-network.step_CNcollect": "Kgoboketša Dilo",
    "gui.howtos.cartoon-network.step_CNvariable": "Dira Phapanyo ya Dintlha",
    "gui.howtos.cartoon-network.step_CNscore": "Boloka Dintlha",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Eya boemong bja godimo: Fetola Bokamorago",
    "gui.howtos.videosens.name": "Sekhwi sa Video",
    "gui.howtos.videosens.step_addextension": "Oketša Koketšo",
    "gui.howtos.videosens.step_pet": "Forohla Katse",
    "gui.howtos.videosens.step_animate": "Phela",
    "gui.howtos.videosens.step_pop": "Thuntšha Palune",
    "gui.howtos.say-it-out-loud": "Hlama Diphedi Tša Go Bolela",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Lokela sengwalwa go dipoloko tša polelo",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Bolela Se Sengwe",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Bea Lentšu",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Sepelasepela",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Oketša Bokamorago",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Oketša Moanegwa o Mongwe",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Opela koša",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Fetola Mmala",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Dikološa",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Godiša o be o Hunyetše",
    "gui.howtos.talking": "Dikanegelo tša go Bolela",
    "gui.howtos.talking.step_talesAddExtension": "Tobetša gore o Tsenye Dipoloko Tša  go Sengwalwa go ya go Polelo",
    "gui.howtos.talking.step_talesChooseSprite": "Kgetha Motšeakarolo",
    "gui.howtos.talking.step_talesSaySomething": "Dira gore Moanegwa a Bolele",
    "gui.howtos.talking.step_talesChooseBackdrop": "Kgetha Bokamorago",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Tobetša Moanegwa gore a ye go Bokamorago Bjo Bo Latelago",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Kgetha Motšeakarolo O Mongwe",
    "gui.howtos.talking.step_talesMoveAround": "Sepelasepela",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Kgetha bokamorago bjo bongwe",
    "gui.howtos.talking.step_talesAnimateTalking": "Phediša go Bolela",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Kgetha Bokamorago bo Bongwe",
    "gui.howtos.talking.step_talesChooseSound": "Kgetha Koša yeo o ka e Binelago",
    "gui.howtos.talking.step_talesDanceMoves": "Meragelo Ya Go Bina",
    "gui.howtos.talking.step_talesAskAnswer": "Hwetša Dipoloko tša dipotšišo le dikarabo go tšwa Lefapheng la Dikhwi.",
    "gui.howtos.add-sprite.name": "Oketša Motšeakarolo",
    "gui.howtos.add-sprite.step_addSprite": "Oketša Motšeakarolo",
    "gui.howtos.add-a-backdrop.name": "Oketša Bokamorago",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Oketša Bokamorago",
    "gui.howtos.change-size.name": "Fetola Bogolo",
    "gui.howtos.change-size.step_changeSize": "Fetola Bogolo",
    "gui.howtos.glide-around.name": "Thwetha go dikologa",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Thwetha go dikologa",
    "gui.howtos.change-size.step_glideAroundPoint": "Thwethela Sešupong",
    "gui.howtos.record-a-sound.name": "Gatiša Modumo",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Tobetša Tab ya' Modumo'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Tobetša ' Gatiša'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Kgotla Konopi Ya Go Gatiša",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Kgetha Modumo Wa Gago",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Bapala Modumo Wa Gago",
    "gui.howtos.spin-video.name": "Dira gore e Dikologe",
    "gui.howtos.change-size.step_spinTurn": "Retološa",
    "gui.howtos.change-size.step_spinPointInDirection": "Bea Taetšo",
    "gui.howtos.hide-and-show.name": "Khutiša o be o Laetše",
    "gui.howtos.change-size.step_hideAndShow": "Khutiša o be o Laetše",
    "gui.howtos.switch-costume.name": "Phediša Motšeakarolo",
    "gui.howtos.change-size.step_switchCostumes": "Phediša Motšeakarolo",
    "gui.howtos.move-around-with-arrow-keys.name": "Šomiša Dikonope tša Marungwana",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Šuta go La nngele le La Go ja",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Šuta o e ya Godimo le Fase",
    "gui.howtos.add-effects.name": "Oketša dikhuetšo",
    "gui.howtos.videosens.step_addEffects": "Oketša dikhuetšo",
    "gui.extension.music.name": "Mmino",
    "gui.extension.music.description": "Bapala diletšwa le meropa.",
    "gui.extension.pen.name": "Pene",
    "gui.extension.pen.description": "Thala ka batšeakarolo ba gago.",
    "gui.extension.videosensing.name": "Sekhwi sa Video",
    "gui.extension.videosensing.description": "Ekwa mosepelo ka khamera.",
    "gui.extension.text2speech.name": "Sengwalwa go ya go Polelo",
    "gui.extension.text2speech.description": "Dira diprojeke tša gago gore di bolele.",
    "gui.extension.translate.name": "Fetolela",
    "gui.extension.translate.description": "Fetolela sengwalwa go maleme a mantši",
    "gui.extension.makeymakey.description": "Dira se sengwe le se sengwe gore ebe konopi.",
    "gui.extension.microbit.description": "Kgokaganya diprojeke tša gago le lefase.",
    "gui.extension.microbit.connectingMessage": "kgokagantšha...",
    "gui.extension.ev3.description": "Aga diroboto tša go šomišana le go feta",
    "gui.extension.ev3.connectingMessage": "Kgokagantšha. Netefatša gore nomoro ya sephiri go EV3  ya gago e beilwe go 1234.",
    "gui.extension.boost.description": "Dira dihlamo tša diroboto gore di phele.",
    "gui.extension.boost.connectingMessage": "Kgokaganya...",
    "gui.extension.wedo2.description": "Aga dimmotho le dikwi.",
    "gui.extension.wedo2.connectingMessage": "kgokagantšha...",
    "gui.extension.gdxfor.description": "Ekwa go kgorometša, go goga, mosepelo le modikologo.",
    "gui.extension.gdxfor.connectingMessage": "kgokagantšha...",
    "gui.libraryTags.all": "Ka Moka",
    "gui.libraryTags.animals": "Diphoofolo",
    "gui.libraryTags.dance": "Bina",
    "gui.libraryTags.effects": "Khuetšo",
    "gui.libraryTags.fantasy": "Boikgopolelo",
    "gui.libraryTags.fashion": "Fešene",
    "gui.libraryTags.food": "Dijo",
    "gui.libraryTags.indoors": "Ka ngwakong",
    "gui.libraryTags.loops": "Poeletšo ya melawana mo lenaneong",
    "gui.libraryTags.music": "Mmino",
    "gui.libraryTags.notes": "Dinoutsu",
    "gui.libraryTags.outdoors": "Kantle",
    "gui.libraryTags.patterns": "Dipaterone",
    "gui.libraryTags.people": "Batho",
    "gui.libraryTags.percussion": "go betha seletšwa gore se ntšhe modumo",
    "gui.libraryTags.space": "lefaufau",
    "gui.libraryTags.sports": "Dipapadi",
    "gui.libraryTags.underwater": "ka fase ga meetse",
    "gui.libraryTags.voice": "Lentšu",
    "gui.libraryTags.wacky": "Bogafi",
    "gui.libraryTags.animation": "Go phediša",
    "gui.libraryTags.art": "Bokgabo",
    "gui.libraryTags.games": "Dipapadi",
    "gui.libraryTags.stories": "Dikanegelo",
    "gui.libraryTags.letters": "Maletere",
    "gui.opcodeLabels.direction": "taetšo",
    "gui.opcodeLabels.xposition": "boemo ba x",
    "gui.opcodeLabels.yposition": "boemo ba y",
    "gui.opcodeLabels.size": "bogolo",
    "gui.opcodeLabels.costumename": "leina la khosetšhumo",
    "gui.opcodeLabels.costumenumber": "nomoro ya khosetšhumo",
    "gui.opcodeLabels.backdropname": "leina la bokamorago",
    "gui.opcodeLabels.backdropnumber": "nomoro ya bokamorago",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "lebelo",
    "gui.opcodeLabels.answer": "karabo",
    "gui.opcodeLabels.loudness": "lešata",
    "gui.opcodeLabels.username": "leinatšhomišo",
    "gui.opcodeLabels.year": "ngwaga",
    "gui.opcodeLabels.month": "kgwedi",
    "gui.opcodeLabels.date": "letšatšikgwedi",
    "gui.opcodeLabels.dayofweek": "letšatši la beke",
    "gui.opcodeLabels.hour": "iri",
    "gui.opcodeLabels.minute": "motsotso",
    "gui.opcodeLabels.second": "motsotswana",
    "gui.opcodeLabels.timer": "sešupi sa nako",
    "gui.projectLoader.loadError": "Faele ya projeke yeo e kgethilwego e paletšwe ke go laišega.",
    "gui.sharedMessages.backdrop": "bokamorago{index}",
    "gui.sharedMessages.costume": "khosetšhumo{index}",
    "gui.sharedMessages.sprite": "Motšeakarolo{index}",
    "gui.sharedMessages.pop": "thunya",
    "gui.sharedMessages.replaceProjectWarning": "Bea bakeng sa diteng tša projeke ye.",
    "gui.sharedMessages.loadFromComputerTitle": "Laiša go tšwa khomphuthareng ya gago",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Projeke ya Scratch",
    "boost.color.any": "mmala o mongwe le o mongwe",
    "boost.color.black": "ntsho",
    "boost.color.blue": "talalerata",
    "boost.color.green": "talamorogo",
    "boost.color.red": "khwibidu",
    "boost.color.white": "tšhweu",
    "boost.color.yellow": "serolwana",
    "boost.getMotorPosition": "boemo bja mmotho [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "sekamiša sekhutlo [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ka tsela yela",
    "boost.motorDirection.forward": "ka tsela ye",
    "boost.motorDirection.reverse": "ribese",
    "boost.motorOff": "Tima mmotho [MOTOR_ID]",
    "boost.motorOn": "Bulela mmotho [MOTOR_ID]",
    "boost.motorOnFor": "Bulela mmotho [MOTOR_ID] metsotswana ye [DURATION]",
    "boost.motorOnForRotation": "bulela mmotho [MOTOR_ID]  medikologo ye [ROTATION]",
    "boost.seeingColor": "go bona [COLOR] wa setena?",
    "boost.setLightHue": "bea mmala wa seetša go [HUE]",
    "boost.setMotorDirection": "bea taetšo ya mmotho [MOTOR_ID] go [MOTOR_DIRECTION] ",
    "boost.setMotorPower": "bea lebelo la mmotho [MOTOR_ID] go [POWER] %",
    "boost.tiltDirection.any": "efe kapa efe",
    "boost.tiltDirection.down": "fase",
    "boost.tiltDirection.left": "la nngele",
    "boost.tiltDirection.right": "la goja",
    "boost.tiltDirection.up": "godimo",
    "boost.whenColor": "Ge o bona setena se se [COLOR]",
    "boost.whenTilted": "ge o sekamišitše [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "letša noto [NOTE] metsotswana ye [TIME]",
    "ev3.buttonPressed": "konopi [PORT] e tobeditšwe",
    "ev3.getBrightness": "go taga",
    "ev3.getDistance": "bokgole",
    "ev3.getMotorPosition": "boemo bja mmotho [PORT]",
    "ev3.motorSetPower": "mmotho [PORT] o bulela maatla [POWER] %",
    "ev3.motorTurnClockwise": "mmotho [PORT] o retologela ka mo metsotswana ye [TIME] ",
    "ev3.motorTurnCounterClockwise": "mmotho [PORT] o retologela ka mo metsotswana ye [TIME] ",
    "ev3.whenBrightnessLessThan": "ge go tagile < [DISTANCE]",
    "ev3.whenButtonPressed": "ge konopi ya [PORT] e tobetšwa ",
    "ev3.whenDistanceLessThan": "ge bokgole < [DISTANCE]",
    "gdxfor.getAcceleration": "oketša makhura [DIRECTION]",
    "gdxfor.getForce": "maatla",
    "gdxfor.getSpin": "lebelo la go dikološa [DIRECTION]",
    "gdxfor.getTilt": "sekamiša sekhutlo [TILT]",
    "gdxfor.isFreeFalling": "e a wa?",
    "gdxfor.isTilted": "sekamišitše [TILT]?",
    "gdxfor.pulled": "gogile",
    "gdxfor.pushed": "kgoromeditše",
    "gdxfor.shaken": "šikinyegile",
    "gdxfor.startedFalling": "thomile go wa",
    "gdxfor.tiltDirectionMenu.any": "efe kapa efe",
    "gdxfor.tiltDirectionMenu.back": "morago",
    "gdxfor.tiltDirectionMenu.front": "pele",
    "gdxfor.tiltDirectionMenu.left": "la nngele",
    "gdxfor.tiltDirectionMenu.right": "la goja",
    "gdxfor.turnedFaceDown": "inamišitše sefahlego ",
    "gdxfor.turnedFaceUp": "išitše sefahlego godimo",
    "gdxfor.whenForcePushedOrPulled": "ge sekwi sa maatla se [PUSH_PULL]",
    "gdxfor.whenGesture": "ge [GESTURE]",
    "gdxfor.whenTilted": "ge e sekamišitšwe [TILT]",
    "makeymakey.downArrow": "mosebe wa go lebelela fase",
    "makeymakey.downArrowShort": "fase",
    "makeymakey.leftArrow": "mosebe wa go lanngele",
    "makeymakey.leftArrowShort": "lanngele",
    "makeymakey.rightArrow": "mosebe wa go la go ja",
    "makeymakey.rightArrowShort": "la goja",
    "makeymakey.spaceKey": "sekgoba",
    "makeymakey.upArrow": "mosebe wa go lebelela godimo",
    "makeymakey.upArrowShort": "godimo",
    "makeymakey.whenKeyPressed": "ge konope [KEY] e tobetšwa",
    "makeymakey.whenKeysPressedInOrder": "ge [SEQUENCE] e tobetšwa ka mokgwa wa maleba",
    "microbit.buttonsMenu.any": "efe kapa efe",
    "microbit.clearDisplay": "tloša taetšo",
    "microbit.defaultTextToDisplay": "Dumela!",
    "microbit.displaySymbol": "bontšha [MATRIX]",
    "microbit.displayText": "bontšha sengwalwa [TEXT]",
    "microbit.gesturesMenu.jumped": "fofile",
    "microbit.gesturesMenu.moved": "šutile",
    "microbit.gesturesMenu.shaken": "šikinyegile",
    "microbit.isButtonPressed": "[BTN] konopi e tobeditšwe",
    "microbit.isTilted": "e sekamišitšwe [DIRECTION]?",
    "microbit.pinStateMenu.off": "timile",
    "microbit.pinStateMenu.on": "tšhuma",
    "microbit.tiltAngle": "sekamiša khutlo [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "efe kapa efe",
    "microbit.tiltDirectionMenu.back": "morago",
    "microbit.tiltDirectionMenu.front": "pele",
    "microbit.tiltDirectionMenu.left": "lanngele",
    "microbit.tiltDirectionMenu.right": "la goja",
    "microbit.whenButtonPressed": "ge konopi [BTN] e tobeditšwe",
    "microbit.whenGesture": "ge [GESTURE]",
    "microbit.whenPinConnected": "ge nomoro ya sephiri [PIN] e kgokagantšwe",
    "microbit.whenTilted": "ge e sekamišitšwe [DIRECTION]",
    "music.categoryName": "Mmino",
    "music.changeTempo": "fetola tempo ka [TEMPO]",
    "music.drumBass": "(2) Moropa wa Peisi",
    "music.drumBongo": "(13)Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Hi-Hat yeo e tswalelegilego",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4)Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Go phaphatha matsogo",
    "music.drumOpenHiHat": "(5) Hi-Hat yeo e bulegilego",
    "music.drumSideStick": "(3) Kota ya ka thoko",
    "music.drumSnare": "(1) Snare Drum",
    "music.drumTambourine": "(7) Thamporini",
    "music.drumTriangle": "(12) Khutlotharo",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Poloko ya Leplanka",
    "music.getTempo": "lebelo",
    "music.instrumentBass": "(6) Peisi",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Khwaere",
    "music.instrumentClarinet": "(10) Klarinete",
    "music.instrumentElectricGuitar": "(5) Katara ya Mohlagase",
    "music.instrumentElectricPiano": "(2) Piano ya Mohlagase",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Katara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Lepokisi la Mmino",
    "music.instrumentOrgan": "(3) Okene",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Moropatšhipi",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Flute ya kota",
    "music.midiPlayDrumForBeats": "bapala moropa [DRUM] go dira [BEATS] merethetho",
    "music.midiSetInstrument": "bea seletšwa go [INSTRUMENT]",
    "music.playDrumForBeats": "bapala moropa [DRUM] go dira [BEATS] merethetho",
    "music.playNoteForBeats": "bapala noto [NOTE] ya [BEATS] merethetho",
    "music.restForBeats": "khuletša [BEATS] merethetho",
    "music.setInstrument": "bea seletšwa go [INSTRUMENT]",
    "music.setTempo": "bea lebelo go [TEMPO]",
    "pen.categoryName": "Pene",
    "pen.changeColorParam": "fetola pene [COLOR_PARAM] ka [VALUE]",
    "pen.changeHue": "fetola mmala wa pene ka [HUE]",
    "pen.changeShade": "fetola mošidi wa pene ka [SHADE]",
    "pen.changeSize": "fetola bogolo bja pene ka [SIZE]",
    "pen.clear": "phumula ka moka",
    "pen.colorMenu.brightness": "go taga",
    "pen.colorMenu.color": "mmala",
    "pen.colorMenu.saturation": "tlopelo",
    "pen.colorMenu.transparency": "bonagatšago",
    "pen.penDown": "pene fase",
    "pen.penUp": "emiša pene",
    "pen.setColor": "bea mmala wa pene go [COLOR]",
    "pen.setColorParam": "bea pene [COLOR_PARAM] GO [VALUE]",
    "pen.setHue": "bea mmala wa pene go [HUE]",
    "pen.setShade": "bea moriti wa pene go [SHADE]",
    "pen.setSize": "bea bogolo bja pene go [SIZE]",
    "pen.stamp": "setempe",
    "speech.defaultWhenIHearValue": "a re ye",
    "speech.extensionName": "Polelo go ya go Sengwalwa",
    "speech.listenAndWait": "theeletša gomme o lete",
    "speech.speechReporter": "polelo",
    "speech.whenIHear": "ge ke ekwa [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Sengwalwa go ya go Polelo",
    "text2speech.defaultTextToSpeak": "dumela",
    "text2speech.giant": "lekgema",
    "text2speech.kitten": "katsana",
    "text2speech.setLanguageBlock": "bea polelo go [LANGUAGE]",
    "text2speech.setVoiceBlock": "bea lentšu go [VOICE]",
    "text2speech.speakAndWaitBlock": "bolela [WORDS]",
    "text2speech.squeak": "tswinya",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Fetolela",
    "translate.defaultTextToTranslate": "dumela",
    "translate.translateBlock": "fetolela [WORDS] go [LANGUAGE]",
    "translate.viewerLanguage": "polelo",
    "videoSensing.categoryName": "Sekhwi sa Video",
    "videoSensing.direction": "taetšo",
    "videoSensing.motion": "mosepelo",
    "videoSensing.off": "timile",
    "videoSensing.on": "Tšhuma",
    "videoSensing.onFlipped": "ge e phethotšwe",
    "videoSensing.setVideoTransparency": "bea ponagatšo ya video go [TRANSPARENCY]",
    "videoSensing.sprite": "motšeakarolo",
    "videoSensing.stage": "sefala",
    "videoSensing.videoOn": "video [ATTRIBUTE] go [SUBJECT]",
    "videoSensing.videoToggle": "sotha video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "ge mosepelo wa video > [REFERENCE]",
    "wedo2.getDistance": "bokgole",
    "wedo2.getTiltAngle": "sekamiša sekhutlo [TILT_DIRECTION]",
    "wedo2.isTilted": "sekamišetša [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "Ke tsela yela",
    "wedo2.motorDirection.forward": "ka tsela ye",
    "wedo2.motorDirection.reverse": "ribese",
    "wedo2.motorId.a": "mmotho wa A",
    "wedo2.motorId.all": "memotho ka moka",
    "wedo2.motorId.b": "mmotho wa B",
    "wedo2.motorId.default": "mmotho",
    "wedo2.motorOff": "tima [MOTOR_ID]",
    "wedo2.motorOn": "tšhuma [MOTOR_ID]",
    "wedo2.motorOnFor": "bulela  [MOTOR_ID] metsotswana e [DURATION]",
    "wedo2.playNoteFor": "bapala noto [NOTE]  metsotswana ye [DURATION]",
    "wedo2.setLightHue": "bea mmala wa seetša go [HUE]",
    "wedo2.setMotorDirection": "bea taetšo ya [MOTOR_ID] go [MOTOR_DIRECTION] ",
    "wedo2.startMotorPower": "bea maatla a [MOTOR_ID] go [POWER]",
    "wedo2.tiltDirection.any": "efe kapa efe",
    "wedo2.tiltDirection.down": "fase",
    "wedo2.tiltDirection.left": "lanngele",
    "wedo2.tiltDirection.right": "la goja",
    "wedo2.tiltDirection.up": "godimo",
    "wedo2.whenDistance": "ge bo kgole [OP] [REFERENCE]",
    "wedo2.whenTilted": "ge e sekamišitše [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Mmala",
    "paint.paintEditor.saturation": "Tlopelo",
    "paint.paintEditor.brightness": "Go taga",
    "paint.paintEditor.costume": "Khosetšhumo",
    "paint.paintEditor.group": "Sehlopha",
    "paint.paintEditor.ungroup": "Hlopholla",
    "paint.paintEditor.undo": "Dirolla",
    "paint.paintEditor.redo": "Dira gape",
    "paint.paintEditor.forward": "Pele",
    "paint.paintEditor.backward": "Morago",
    "paint.paintEditor.front": "Pele",
    "paint.paintEditor.back": "Morago",
    "paint.paintEditor.more": "Go feta",
    "paint.modeTools.brushSize": "Bogolo",
    "paint.modeTools.eraserSize": "Bogolo bja sephumodi",
    "paint.modeTools.copy": "Kopiša",
    "paint.modeTools.paste": "Momaretša",
    "paint.modeTools.delete": "Phumula",
    "paint.modeTools.curved": "Kgopame",
    "paint.modeTools.pointed": "Šupile",
    "paint.modeTools.thickness": "Bokoto",
    "paint.modeTools.flipHorizontal": "Phethola go Rapama",
    "paint.modeTools.flipVertical": "Go phethola go tsepa",
    "paint.modeTools.filled": "Tladitšwe",
    "paint.modeTools.outlined": "Hlalositšwe",
    "paint.paintEditor.bitmap": "Fetolela go Bitmap",
    "paint.paintEditor.vector": "Fetolela go Vector",
    "paint.paintEditor.fill": "Tlatša",
    "paint.paintEditor.stroke": "Hlalosa",
    "paint.brushMode.brush": "Poraša",
    "paint.eraserMode.eraser": "Sephumodi",
    "paint.fillMode.fill": "Tlatša",
    "paint.lineMode.line": "Mothalo",
    "paint.ovalMode.oval": "Sediko",
    "paint.rectMode.rect": "Khutlonne",
    "paint.reshapeMode.reshape": "Bopaleswa",
    "paint.roundedRectMode.roundedRect": "Khutlonne ya go dirwa nkgokolo",
    "paint.selectMode.select": "Kgetha",
    "paint.textMode.text": "Sengwalwa",
    "paint.colorPicker.swap": "Fetola"
  },
  "tn": {
    "gui.alerts.lostPeripheralConnection": "Scratch e latlhegetswe ke kgokagano go {extensionName}",
    "gui.alerts.tryAgain": "Leka gape",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Momaganya gape",
    "gui.backpack.costumeLabel": "seaparo",
    "gui.backpack.soundLabel": "modumo",
    "gui.backpack.scriptLabel": "mokwalo",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Mokotla",
    "gui.backpack.errorBackpack": "Phoso ya go tsenya kgetsana ya mokotla",
    "gui.backpack.loadingBackpack": "Re a tsenya...",
    "gui.backpack.more": "Oketsegileng",
    "gui.backpack.emptyBackpack": "Kgetsana ya mokotla e lolea ",
    "gui.unsupportedBrowser.label": "Sediriswa sa go phuruphutsha ga se a tshegediwa",
    "gui.unsupportedBrowser.errorLabel": "Go diragetse phoso",
    "gui.unsupportedBrowser.notRecommended": "Re maswabi, fela go lebega ekete o dirisa sephuruphutshi se Scratch e sa se tshegetseng. Re go gakolola gore o tlhabololele sephurubhutshi sa gago go Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "Re maswabi, fela Scratch ga e tshegetse sephuruphutshi se. Re go gakolola gore o tlhabololele sephuruphutshi go mofuta o montšhwa o o tshegeditsweng jaaka Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Morago",
    "gui.unsupportedBrowser.previewfaq": "Go ithuta mo go oketsegileng {previewFaqLink}",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Dirutwa",
    "gui.cards.shrink": "Fokotsega",
    "gui.cards.expand": "Atolosa",
    "gui.cards.close": "Tswala",
    "gui.cards.more-things-to-try": "Dilo di le dintsi go di leka!",
    "gui.cards.see-more": "Bona go le gontsi",
    "gui.comingSoon.message1": "Se tshwenyege, re mo go yona{emoji}",
    "gui.comingSoon.message2": "E a latela",
    "gui.comingSoon.message3": "Re dira mo go yona {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Go go na didiriswa tse di fitlhetsweng",
    "gui.connection.auto-scanning.prescan": "Thola sediriswa sa gago fa gaufi, mme o simolole go batlisisa",
    "gui.connection.auto-scanning.pressbutton": "Tobetsa konopo e e mo sedirisweng sa gago",
    "gui.connection.auto-scanning.start-search": "Simolola go phuruphutsha",
    "gui.connection.connecting-searchbutton": "Phuruphutsha...",
    "gui.connection.auto-scanning.try-again": "Leka gape",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Gokaganye",
    "gui.connection.disconnect": "Gokaganyolola",
    "gui.connection.go-to-editor": "E ya go Motseleganyi",
    "gui.connection.connecting-cancelbutton": "Gokaganya",
    "gui.connection.error.errorMessage": "Oops, go lebega sengwe se sa tsamaya sentle.",
    "gui.connection.error.tryagainbutton": "Leka gape",
    "gui.connection.error.helpbutton": "Thusa",
    "gui.connection.peripheral-name-label": "Leina la sediriswa",
    "gui.connection.connect": "golaganya",
    "gui.connection.scanning.lookingforperipherals": "Go batlana le didiriswa",
    "gui.connection.scanning.noPeripheralsFound": "Go go na didiriswa tse di fitlhetsweng",
    "gui.connection.scanning.instructions": "Tlhopha sediriswa sa gago mo lenaaneng le le fa godimo",
    "gui.connection.search": "Ntšhwafatsa",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Netefatsa gore o na le kgokagano ya Scratch e e tsentsweng e bile e dira",
    "gui.connection.unavailable.enablebluetooth": "Lekola fa Bluetooth e dira",
    "gui.connection.unavailable.tryagainbutton": "Leka gape",
    "gui.connection.unavailable.helpbutton": "Thusa",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Tsamaya",
    "gui.controls.stop": "Ema",
    "gui.crashMessage.label": "Oops! sengwe ga se a tsamaya sentle",
    "gui.crashMessage.description": "Re maswabi, fela go lebega ekete Scratch se phutlhame. Khukhwane e, e setse e begetswe setlhopha sa Scratch. Ka kopo ntšhwafatsa tsebe ya gago go leka gape.",
    "gui.crashMessage.errorNumber": "Phoso ya gago e tsentshitswe ka id {errorId}",
    "gui.crashMessage.reload": "Tlhatlhelela gape",
    "gui.customProcedures.myblockModalTitle": "Dira lebokoso",
    "gui.customProcedures.addAnInputNumberText": "Oketsa ka tshwaelo",
    "gui.customProcedures.numberTextType": "Palo ya molaetsa",
    "gui.customProcedures.addAnInputBoolean": "Oketsa ka tshwaelo",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Oketsa ka leina",
    "gui.customProcedures.runWithoutScreenRefresh": "Dirisa ntle le screen refresh",
    "gui.customProcedures.cancel": "Phimola",
    "gui.customProcedures.ok": "Go siame",
    "gui.SpriteInfo.direction": "Kaelo",
    "gui.directionPicker.rotationStyles.allAround": "Gotlhe",
    "gui.directionPicker.rotationStyles.leftRight": "Molema/Moja",
    "gui.directionPicker.rotationStyles.dontRotate": "O seka wa dikolosa",
    "gui.gui.addExtension": "Oketsa",
    "gui.gui.codeTab": "Khoutu",
    "gui.gui.backdropsTab": "Ditatlhelo morago",
    "gui.gui.costumesTab": "Diaparo",
    "gui.gui.soundsTab": "Medumo",
    "gui.extensionLibrary.comingSoon": "E a latela",
    "gui.extensionLibrary.requires": "tlhoka",
    "gui.extensionLibrary.collaboration": "Tirisano le",
    "gui.library.filterPlaceholder": "Batla",
    "gui.library.allTag": "Tsotlhe",
    "gui.loader.message1": "Go dira diboloko",
    "gui.loader.message2": "Go tsenya DiSprite",
    "gui.loader.message3": "Go tsenya medumo",
    "gui.loader.message4": "Go tsenya dikoketso",
    "gui.loader.message5": "Go rua dikatse",
    "gui.loader.message6": "Tshelano ya nanos",
    "gui.loader.message7": "Go tlhatlhosa gobos",
    "gui.loader.message8": "Go baakanya emojis …",
    "gui.loader.headline": "Go tsenya Porojeke",
    "gui.loader.creating": "Go simolola Porojeke",
    "gui.accountMenu.profile": "Tebogo ya sefatlhego mo letlhakoreng",
    "gui.accountMenu.myStuff": "Dilo tsame",
    "gui.accountMenu.myClasses": "Di phaphusi tsame",
    "gui.accountMenu.myClass": "Phaphusi yame",
    "gui.accountMenu.accountSettings": "Thulaganyo ya account",
    "gui.accountMenu.signOut": "Tswa",
    "gui.authorInfo.byUser": "ka {username}",
    "gui.menuBar.seeProjectPage": "Lebelela tsebe ya Porojeke",
    "gui.menuBar.language": "Language",
    "general.username": "Leinatiriso",
    "general.password": "Nomore ya sephiri",
    "general.signIn": "Tsena",
    "login.needHelp": "A o tlhoka thuso?",
    "form.validationRequired": "Lefelo le, le a tlhokega",
    "gui.menuBar.tutorialsLibrary": "Dirutwa",
    "gui.menuBar.restoreSprite": "Busetsa Sprite",
    "gui.menuBar.restoreSound": "Busetsa Modumo",
    "gui.menuBar.restoreCostume": "Busetsa Seaparo",
    "gui.menuBar.restore": "Busetsa",
    "gui.menuBar.saveNow": "Boloka jaanong",
    "gui.menuBar.saveAsCopy": "Boloka jaaka setshwantso",
    "gui.menuBar.remix": "Tlhakanya gape",
    "gui.menuBar.new": "Mo bosheng",
    "gui.menuBar.file": "Faele",
    "gui.menuBar.downloadToComputer": "Boloka mo khomputareng ya gago.",
    "gui.menuBar.edit": "Sekaseka",
    "gui.menuBar.turboModeOff": "Tima Turbo Mode",
    "gui.menuBar.turboModeOn": "Tshuma Turbo Mode",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Tsenela Scratch",
    "gui.menuBar.signIn": "Tsena",
    "gui.gui.projectTitlePlaceholder": "Setlhogo sa Porojeke fa",
    "gui.menuBar.saveNowLink": "Boloka jaanong",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Abelanwe",
    "gui.menuBar.share": "Abela",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Thusa",
    "gui.modal.back": "Morago",
    "gui.monitor.listMonitor.empty": "(lolea)",
    "gui.monitor.listMonitor.listLength": "botelele {length}",
    "gui.monitor.contextMenu.default": "Puiso ya tlwaelo",
    "gui.monitor.contextMenu.large": "readout e kgolo",
    "gui.monitor.contextMenu.slider": "sereledi",
    "gui.monitor.contextMenu.sliderRange": "Fetola direledi tse di farologaneng",
    "gui.monitor.contextMenu.import": "tsenya",
    "gui.monitor.contextMenu.export": "romela",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Tshameka",
    "gui.playButton.stop": "Ema",
    "gui.gui.variableScopeOptionAllSprites": "Go di sprites tsotlhe",
    "gui.gui.variableScopeOptionSpriteOnly": "Sprite sena fela",
    "gui.gui.cloudVariableOption": "Dipharologano tsa maru (bolokilwe mo server)",
    "gui.gui.variablePromptAllSpritesMessage": "Phetogo e , e tla nna teng go di sprites tsotlhe",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Phimola",
    "gui.prompt.ok": "Go siame",
    "gui.playbackStep.stopMsg": "Ema",
    "gui.playbackStep.playMsg": "Tshameka",
    "gui.playbackStep.loadingMsg": "Re a tsenya...",
    "gui.playbackStep.saveMsg": "Boloka",
    "gui.playbackStep.reRecordMsg": "Rekota gape",
    "gui.recordModal.title": "Rekota Modumo",
    "gui.recordingStep.beginRecord": "Simolola go rekota ka go tobetsa konopo e e fa tlase",
    "gui.recordingStep.permission": "{arrow}Re tlhoka tetla ya gago go dirisa maekerofounu wa gago",
    "gui.recordingStep.stop": "Emisa go gatisa",
    "gui.recordingStep.record": "Gatisa",
    "gui.sliderModal.min": "Boleng jo bo kwa tlase",
    "gui.sliderModal.max": "Boleng jo bo kwa godimo",
    "gui.sliderModal.title": "Fetola direledi tse di farologaneng",
    "gui.sliderPrompt.cancel": "Phimola",
    "gui.sliderPrompt.ok": "Go siame",
    "gui.soundEditor.sound": "Modumo",
    "gui.soundEditor.play": "Tshameka",
    "gui.soundEditor.stop": "Ema",
    "gui.soundEditor.copy": "Kopa",
    "gui.soundEditor.paste": "Kgomaretsa",
    "gui.soundEditor.copyToNew": "Kopa go e ntšhwa",
    "gui.soundEditor.delete": "Phimola",
    "gui.soundEditor.save": "Boloka",
    "gui.soundEditor.undo": "Sutlha",
    "gui.soundEditor.redo": "Dira gape",
    "gui.soundEditor.faster": "Bonako",
    "gui.soundEditor.slower": "Bonya",
    "gui.soundEditor.echo": "Modumo wa fa o bua",
    "gui.soundEditor.robot": "Roboto",
    "gui.soundEditor.louder": "Godingwana",
    "gui.soundEditor.softer": "Tlasenyana",
    "gui.soundEditor.reverse": "Dirolola",
    "gui.soundEditor.fadeOut": "nyelela kwa ntle",
    "gui.soundEditor.fadeIn": "nyelela ka mo gare",
    "gui.soundEditor.mute": "Didimatsa",
    "gui.SpriteInfo.spritePlaceholder": "Leina",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Bontsha",
    "gui.SpriteInfo.size": "Bogolo",
    "gui.spriteSelectorItem.contextMenuDuplicate": "gabedi",
    "gui.spriteSelectorItem.contextMenuExport": "romela",
    "gui.spriteSelectorItem.contextMenuDelete": "phimola",
    "gui.spriteSelector.addSpriteFromLibrary": "Tlhopha Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Taka",
    "gui.spriteSelector.addSpriteFromSurprise": "Kgakgamatso",
    "gui.spriteSelector.addSpriteFromFile": "Bula Sprite",
    "gui.stageHeader.stageSizeLarge": "Fetogela go kgato e kgolo",
    "gui.stageHeader.stageSizeSmall": "Fetogela go kgato e nnye",
    "gui.stageHeader.stageSizeFull": "Tsena mo sekerining se se tletseng",
    "gui.stageHeader.stageSizeUnFull": "Tswaya mo sekerining se se tletseng",
    "gui.stageHeader.fullscreenControl": "Taolo ya sekerini se se tletseng",
    "gui.spriteSelector.addBackdropFromLibrary": "Tlhopha Tatlhelo morago",
    "gui.stageSelector.addBackdropFromPaint": "Taka",
    "gui.stageSelector.addBackdropFromSurprise": "Kgakgamatso",
    "gui.stageSelector.addBackdropFromFile": "Bula Tatlhelo morago",
    "gui.stageSelector.stage": "Serala",
    "gui.stageSelector.backdrops": "Ditatlhelo morago",
    "gui.telemetryOptIn.label": "Bega dipalopalo go tlhabolola Scratch",
    "gui.telemetryOptIn.body1": "Setlhopha sa Scratch se leka ka dinako tsotlhe go tlhaloganya gore Scratch se dirisiwa jang lefatshe ka bophara. Go thusa go tshegetsa maiteko a, o ka dumelela Scratch go romela tiriso ya tshedimosetso go setlhopha sa Scratch ka boyona.",
    "gui.telemetryOptIn.body2": "Tshedimosetso e re e kgobokanyang e akaretsa tlhopho ya puo, tiriso ya diboloko, ditiragalo dingwe jaaka go boloka, go tsenya le go bula porojeke. Ka kopo lebelela {privacyPolicyLink} go bona tshedimosetso e ntsi.",
    "gui.telemetryOptIn.privacyPolicyLink": "Melao ya Sephiri",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Mokgwa wa turbo",
    "gui.webglModal.label": "Sephuruphutshi sa gago ga se tshegetse  WebGL",
    "gui.webglModal.description": "Ka bomadimabe go lebega ekete sephuruphutshi kgotsa khomputara ya gago {webGlLink}. Thekenoloji e, e a tlhokega mo tsamaisong ya  Scratch 3.0 ",
    "gui.webglModal.webgllink": "ga e tshegetse  WebGL",
    "gui.webglModal.back": "Morago",
    "gui.webglModal.previewfaq": "Go ithuta mo go oketsegileng, e ya go {previewFaqLink}",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Tlhopha Tatlhelo morago",
    "gui.costumeLibrary.chooseACostume": "Tlhopha seaparo",
    "gui.costumeTab.addBackdropFromLibrary": "Tlhopha Tatlhelo morago",
    "gui.costumeTab.addCostumeFromLibrary": "Tlhopha seaparo",
    "gui.costumeTab.addBlankCostume": "Taka",
    "gui.costumeTab.addSurpriseCostume": "Kgakgamatso",
    "gui.costumeTab.addFileBackdrop": "Bula Tatlhelo morago",
    "gui.costumeTab.addFileCostume": "Bula seaparo",
    "gui.extensionLibrary.chooseAnExtension": "Tlhopha koketso",
    "gui.extensionLibrary.extensionUrl": "Tsenya URL ya koketso",
    "gui.monitors.importListColumnPrompt": "Ke kholomo efe e e tshwanetseng go dirisiwa ({numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ga go a kgonagala go simolola go rekota",
    "gui.soundLibrary.chooseASound": "Tlhopha Modumo",
    "gui.soundTab.fileUploadSound": "Bula Modumo",
    "gui.soundTab.surpriseSound": "Kgakgamatso",
    "gui.soundTab.recordSound": "Gatisa",
    "gui.soundTab.addSoundFromLibrary": "Tlhopha Modumo",
    "gui.spriteLibrary.chooseASprite": "Tlhopha Sprite",
    "gui.tipsLibrary.tutorials": "Tlhopha serutwa",
    "gui.alerts.createsuccess": "Porojeke e ntšhwa e tlhamilwe.",
    "gui.alerts.createcopysuccess": "Porojeke e bolokilwe jaaka khopi.",
    "gui.alerts.createremixsuccess": "Porojeke e bolokilwe jaaka tlhakanyo",
    "gui.alerts.creating": "Go tlhama ... e ntšhwa",
    "gui.alerts.creatingCopy": "Go kwalolola porojeke...",
    "gui.alerts.creatingRemix": "Tlhakanyo ya porojeke",
    "gui.alerts.creatingError": "E reteletswe ke go tlhama porojeke. Ka kopo leka gape!",
    "gui.alerts.savingError": "Porojeke e reteletswe ke go boloka.",
    "gui.alerts.savesuccess": "Porojeke e bolokilwe.",
    "gui.alerts.saving": "E boloka porojeke...",
    "gui.alerts.cloudInfo": "Ka kopo ela tlhoko, leru la pharologanyo le tshegetsa dipalo, eseng ditlhaka kgotsa matshwao.{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Ithute go le gontsi.",
    "gui.alerts.importing": "E romela...",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "pharologanyo ya me",
    "gui.howtos.intro-move-sayhello-hat.name": "Go simolola",
    "gui.howtos.intro-move.step_stepMove": "Oketsa ka boloko jwa go tsamaya",
    "gui.howtos.add-a-move-block.step_stepSay": "Oketsa ka boloko jwa go bua",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Tobetsa folaga e e botala jwa tlhaga go simolola",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Tlhama leina",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Tlhopha Sprite sa tlhaka",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Tshameka modumo fa o tobeditse",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Tlhopha Sprite ya tlhaka e nngwe",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Fetola mmala",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Tlhopha Sprite sa tlhaka se sengwe mme o dire gore se dikologe",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Tlhopha Sprite sa tlhaka se sengwe mme o dire gore se gole",
    "gui.howtos.imagine": "Akanya ka Lefatshe",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Tlanya se o batlang go se bua",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Tobetsa folaga ya botala ba tlhaga go simolola",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Tlhopha Tatlhelomorago nngwe le nngwe",
    "gui.howtos.imagine.step_imagineChooseSprite": "Tlhopha Sprite sengwe le sengwe",
    "gui.howtos.imagine.step_imagineFlyAround": "Tobetsa konopo ya go bula phatlha go phaphalala",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Tlhopha Sprite se sengwe",
    "gui.howtos.imagine.step_imagineLeftRight": "Tsamaela kwa Molema-Moja",
    "gui.howtos.imagine.step_imagineUpDown": "Tsamaela kwa Godimo-Tlase",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Fetola Diaparo",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Phaphalela gongwe",
    "gui.howtos.imagine.step_imagineGrowShrink": "Gola le go hunyela",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Tlhopha Tatlhelelomorago e nngwe",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Fetola Ditlhatlhelomorago",
    "gui.howtos.imagine.step_imagineRecordASound": "Oketsa Modumo",
    "gui.howtos.imagine.step_imagineChooseSound": "Tlhopha modumo wa gago",
    "gui.howtos.make-music.name": "Dira Mmino",
    "gui.howtos.Make-Music.step_PickInstrument": "Tlhopha Sprite sa Sediriswa",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Tshameka Modumo fa o Tobeditse",
    "gui.howtos.Make-Music.step_MakeSong": "Tlhama Pina",
    "gui.howtos.make-music.step_MakeBeat": "Tlhopha Moropa mme o Dire Moporo",
    "gui.howtos.make-music.step_MakeBeatBox": "Tlhopha Sprite sa maekerofouno mme o Gakgamatse Lebokoso la Moporo",
    "gui.howtos.story.name": "Tlhama Kgang",
    "gui.howtos.story.step_addbg": "Oketsa ka Tatlhelomorago",
    "gui.howtos.story.step_addsprite": "Oketsa ka motshameki",
    "gui.howtos.story.step_saysomething": "Bua sengwe",
    "gui.howtos.story.step_addanothersprite": "Oketsa ka motshameki o mongwe",
    "gui.howtos.story.step_flip": "Tlola Kaelo",
    "gui.howtos.story.step_conversation": "Nna le Puisano",
    "gui.howtos.story.addanotherbg": "Tsenya Tatlhelomorago e nngwe",
    "gui.howtos.story.step_swithbg": "Fetola Ditlhatlhelomorago",
    "gui.howtos.story.step_hidewizard": "Fitlha motshameki",
    "gui.howtos.story.step_showwizard": "Bontsha motshameki",
    "gui.howtos.make-a-chase-game.name": "Dira motshameko wa go lelekisa",
    "gui.howtos.Chase-Game.step_BG": "Oketsa ka Tatlhelomorago",
    "gui.howtos.chase-game.step_AddOcto": "Oketsa ka Sprite",
    "gui.howtos.make-music.step_LeftRight": "Tsamaela kwa Mojeng le Molema ka dikonopo tsa metsu",
    "gui.howtos.Chase-Game.step_UpDown": "Tsamaela kwa Godimo le Tlase ka dikonopo tsa metsu",
    "gui.howtos.Chase-Game.step_AddStar": "Oketsa ka Sprite se sengwe",
    "gui.howtos.Chase-Game.step_MoveRandom": "Tsamaya fela",
    "gui.howtos.Chase-Game.step_WhenTouch": "Mo go Sprite sa Okotopase, fa o Kgoma Tshameka Modumo",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Tlhama pharologanyo ya maduo",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Mo go Sprite sa Okotopase fa o Kgoma Oketsa Maduo",
    "gui.howtos.animate-char.name": "Dira motshameki",
    "gui.howtos.animate-char.step_addbg": "Oketsa ka Tatlhelomorago",
    "gui.howtos.animate-char.step_addsprite": "Oketsa ka Sprite",
    "gui.howtos.animate-char.step_saysomething": "Bua sengwe",
    "gui.howtos.animate-char.step_addsound": "Oketsa Modumo",
    "gui.howtos.animate-char.step_animatetalking": "Dira puo",
    "gui.howtos.animate-char.step_arrowkeys": "Tsamaya o dirisa dikonopo tsa metsu",
    "gui.howtos.animate-char.step_jump": "Tlola",
    "gui.howtos.animate-char.step_changecolor": "Fetola mmala",
    "gui.howtos.make-a-game.name": "Dira Motshameko wa go tobetsa",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Tlhopha Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Tshameka Modumo fa o Tobeditse",
    "gui.howtos.make-a-game.step_GameAddScore": "Tlhama pharologanyo ya maduo",
    "gui.howtos.make-a-game.step_GameChangeScore": "Fa o tobeditse godisa maduo",
    "gui.howtos.make-a-game.step_Random": "E ya felo gongwe fela",
    "gui.howtos.make-music.step_GameChangeColor": "Fetola mmala",
    "gui.howtos.make-music.step_ResetScore": "Dira maduo gape",
    "gui.howtos.make-it-fly.name": "Dira gore e fofe",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Tlhopha lemorago la loapi",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Tlhopha motshameki",
    "gui.howtos.fly.step_stepflySaySomething": "Bua sengwe",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Tsamaisa ka dikonopo ya motsu",
    "gui.howtos.fly.step_stepflyChooseObject": "Tlhopha sengwe go se tsaya",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Dira gore sengwe se tsamaye",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Tlhpha motshameki wa gago",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Oketsa ka maduo",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Tshwara maduo",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Oketsa ka lefelo le lentle",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Tsamaisa lefelo le lentle",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Seaparo se se latelang",
    "gui.howtos.pong": "Motshameko wa Vidio",
    "gui.howtos.pong.step_pongAddBackdrop": "Oketsa ka Tatlhelomorago",
    "gui.howtos.pong.step_pongAddBallSprite": "Oketsa ka Sprite sa kgwele",
    "gui.howtos.pong.step_pongBounceAround": "Tlolatlola mo tikologong",
    "gui.howtos.pong.step_pongAddPaddle": "Oketsa ka sediriswa sa go fudua metsi go tsamaisa mokoro",
    "gui.howtos.pong.step_pongMoveThePaddle": "Tsamaisa sediriswa sa go fudua metsi",
    "gui.howtos.pong.step_pongSelectBallSprite": "Tlhopha Sprite sa kgwele",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Oketsa ka khoutu ya go tlolatlolisa kgwele go tswa mo sedirisweng sa go fudua metsi",
    "gui.howtos.pong.step_pongAddAScore": "Oketsa ka maduo",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Tlhopha 'Maduo' go tswa mo Menung",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Tsenya Boloko ba 'Fetola Maduo ' ",
    "gui.howtos.pong.step_pongResetScore": "Dira maduo gape",
    "gui.howtos.pong.step_pongAddLineSprite": "Oketsa ka Sprite sa mothalo",
    "gui.howtos.pong.step_pongGameOver": "Bokhutlo jwa motshameko",
    "gui.howtos.code-cartoon": "Dira togwana ya setshwantsho sa metlae",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Bua sengwe fa o tobetsa folaga e e botala ba tlhaga",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Dira khathune ya motshameki fa o e tobetsa",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Tlhopha motshameki o o farologaneng",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Dirisa letshwao la ntsha go inyenyefatsa",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Dira motshameki gore a gole le go hunyela",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Tlhopha motshameki yo o farologaneng",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Tlolela kwa godimo le kwa tlase",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Tobetsa motshameki go fetola lefelo le lentle",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Phaphalala mo tikologong",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Fetola Diaparo",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Tlhopha batshameki ba le bantsi go oketsa khathunu ya gago",
    "gui.howtos.cartoon-network": "Dira khathune ya motshameko wa bogatlhamelamasisi",
    "gui.howtos.cartoon-network.step_CNcharacter": "Tlhopha motshameki go bontsha",
    "gui.howtos.cartoon-network.step_CNsay": "Bua sengwe",
    "gui.howtos.cartoon-network.step_CNglide": "Phaphalala mo tikologong",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Tlhopha sediriswa go se lelekisa",
    "gui.howtos.cartoon-network.step_CNcollect": "Kgobokanya didiriswa",
    "gui.howtos.cartoon-network.step_CNvariable": "Dira maduo a pharololganyo",
    "gui.howtos.cartoon-network.step_CNscore": "Tshwara maduo",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Dira selekanyo: Fetola Tatlhelomorago",
    "gui.howtos.videosens.name": "Maikutlo a vidio",
    "gui.howtos.videosens.step_addextension": "Oketsa",
    "gui.howtos.videosens.step_pet": "Nna le seruiwaratwa sa katse",
    "gui.howtos.videosens.step_animate": "Khathune",
    "gui.howtos.videosens.step_pop": "Thunya balunu",
    "gui.howtos.say-it-out-loud": "Tlhama khathune e e buang",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Oketsa ka molaetsa mo dibolokong tsa puo",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Bua sengwe",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Dira lentswe",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Tsamaya tsamaya",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Oketsa ka Tatlhelomorago",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Oketsa ka motshameki o mongwe",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Diragatsa pina",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Fetola mmala",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Dikologa mo tikologong",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Gola le go hunyela",
    "gui.howtos.talking": "Ditlhamane tse di buang",
    "gui.howtos.talking.step_talesAddExtension": "Tobetsa go oketsa ka molaetsa mo Bolokong jwa Puo",
    "gui.howtos.talking.step_talesChooseSprite": "Tlhopha Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Dira gore Motshameki a Bue",
    "gui.howtos.talking.step_talesChooseBackdrop": "Tlhopha Tatlhelo morago",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Tobetsa Motshameki go ya mo Tatlhelomoragong e e latelang",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Tlhopha Sprite se sengwe",
    "gui.howtos.talking.step_talesMoveAround": "Tsamaya tsamaya",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Tlhopha Tatlhelelomorago e nngwe",
    "gui.howtos.talking.step_talesAnimateTalking": "Dira puo",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Tlhopha Tatlhelelomorago e nngwe",
    "gui.howtos.talking.step_talesChooseSound": "Tlhopha pina go bina",
    "gui.howtos.talking.step_talesDanceMoves": "Mefuta ya go bina",
    "gui.howtos.talking.step_talesAskAnswer": "Batla Diboloko tsa go Botsa le go Araba go tswa mo Karolong ya Maikutlo",
    "gui.howtos.add-sprite.name": "Oketsa ka Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Oketsa ka Sprite",
    "gui.howtos.add-a-backdrop.name": "Oketsa ka Tatlhelomorago",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Oketsa ka Tatlhelomorago",
    "gui.howtos.change-size.name": "Fetola Bogolo",
    "gui.howtos.change-size.step_changeSize": "Fetola Bogolo",
    "gui.howtos.glide-around.name": "Phaphalala mo tikologong",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Phaphalala mo tikologong",
    "gui.howtos.change-size.step_glideAroundPoint": "Phaphalela gongwe",
    "gui.howtos.record-a-sound.name": "Rekota Modumo",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Tobetsa Tab ya 'Medumo' ",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Tobetsa 'Rekota'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Tobetsa konopo ya go rekota",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Tlhopha modumo wa gago",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Tshameka Modumo wa gago",
    "gui.howtos.spin-video.name": "E dire gore e dikologe",
    "gui.howtos.change-size.step_spinTurn": "Retolosa",
    "gui.howtos.change-size.step_spinPointInDirection": "Dira Kaelo",
    "gui.howtos.hide-and-show.name": "Go fitlha le Go bontsha",
    "gui.howtos.change-size.step_hideAndShow": "Go fitlha le Go bontsha",
    "gui.howtos.switch-costume.name": "Dira khathunu ya Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Dira khathunu ya Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Dirisa dikonopo tsa metsu",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Tsamaisetsa kwa Moja le Molema",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Tsamaisetsa kwa Godimo le Tlase",
    "gui.howtos.add-effects.name": "Oketsa ka Matswela",
    "gui.howtos.videosens.step_addEffects": "Oketsa ka Matswela",
    "gui.extension.music.name": "Mmino",
    "gui.extension.music.description": "Tshameka didiriswa le meropa",
    "gui.extension.pen.name": "Pene",
    "gui.extension.pen.description": "Thala ka DiSprite tsa gago",
    "gui.extension.videosensing.name": "Maikutlo a vidio",
    "gui.extension.videosensing.description": "Batla motsamao ka khamera",
    "gui.extension.text2speech.name": "Romela molaetsa ka puo",
    "gui.extension.text2speech.description": "Dira diporojeke tsa gago gore di bue",
    "gui.extension.translate.name": "Ranola",
    "gui.extension.translate.description": "Ranolela molaetsa mo dipuong di le dintsi",
    "gui.extension.makeymakey.description": "Dira sengwe le sengwe go nna konopo",
    "gui.extension.microbit.description": "Golaganya porojeke ya gago le lefatshe",
    "gui.extension.microbit.connectingMessage": "E a golaganya",
    "gui.extension.ev3.description": "Aga diroboto le tse dingwe tsa tirisano",
    "gui.extension.ev3.connectingMessage": "Go golaganya. Netefatsa gore lomapo lo lo mo EV3 le diretswe mo 1234.",
    "gui.extension.boost.description": "Tlisa ditlhangwa tsa roboto mo botshelong",
    "gui.extension.boost.connectingMessage": "E a golaganya",
    "gui.extension.wedo2.description": "Aga motšhini o o dupelelang.",
    "gui.extension.wedo2.connectingMessage": "E a golaganya",
    "gui.extension.gdxfor.description": "Dupelela go kgarametsa, go goga, motsamao le go dikologa",
    "gui.extension.gdxfor.connectingMessage": "E a golaganya",
    "gui.libraryTags.all": "Tsotlhe",
    "gui.libraryTags.animals": "Diphologolo",
    "gui.libraryTags.dance": "Bina",
    "gui.libraryTags.effects": "Selebego",
    "gui.libraryTags.fantasy": "Toro kgotsa sengwe se se akanyeditsweng",
    "gui.libraryTags.fashion": "Fešene",
    "gui.libraryTags.food": "Dijo",
    "gui.libraryTags.indoors": "Teng ga kago",
    "gui.libraryTags.loops": "Dilupu",
    "gui.libraryTags.music": "Mmino",
    "gui.libraryTags.notes": "Dintlha",
    "gui.libraryTags.outdoors": "Kwa ntle",
    "gui.libraryTags.patterns": "Dipaterone",
    "gui.libraryTags.people": "Batho",
    "gui.libraryTags.percussion": "Diletso tse di letswang ka go tshekinngwa",
    "gui.libraryTags.space": "Phatlha",
    "gui.libraryTags.sports": "Metshameko",
    "gui.libraryTags.underwater": "Ka fatlase ga mesti",
    "gui.libraryTags.voice": "Lentswe",
    "gui.libraryTags.wacky": "Kgatlhisa",
    "gui.libraryTags.animation": "Khathunu",
    "gui.libraryTags.art": "Botaki",
    "gui.libraryTags.games": "Metshameko",
    "gui.libraryTags.stories": "Dikgang",
    "gui.libraryTags.letters": "Makwalo",
    "gui.opcodeLabels.direction": "kaelo",
    "gui.opcodeLabels.xposition": "boemo jwa x",
    "gui.opcodeLabels.yposition": "boemo jwa y",
    "gui.opcodeLabels.size": "selekanyo",
    "gui.opcodeLabels.costumename": "leina la diaparo",
    "gui.opcodeLabels.costumenumber": "palo ya seaparo",
    "gui.opcodeLabels.backdropname": "latlhela morago leina",
    "gui.opcodeLabels.backdropnumber": "Tatlhelomorago ya palo",
    "gui.opcodeLabels.volume": "maemo a modumo",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "karabo",
    "gui.opcodeLabels.loudness": "modumo",
    "gui.opcodeLabels.username": "leinatiriso",
    "gui.opcodeLabels.year": "ngwaga",
    "gui.opcodeLabels.month": "kgwedi",
    "gui.opcodeLabels.date": "letlha",
    "gui.opcodeLabels.dayofweek": "letsatsi la beke",
    "gui.opcodeLabels.hour": "ura",
    "gui.opcodeLabels.minute": "motsotso",
    "gui.opcodeLabels.second": "motsotswana",
    "gui.opcodeLabels.timer": "tshupanako",
    "gui.projectLoader.loadError": "Faele ya porojeke e e neng e tlhophilwe e reteletswe ke go tsenya tshedimosetso",
    "gui.sharedMessages.backdrop": "Tatlhelomorago {index}",
    "gui.sharedMessages.costume": "Seaparo {index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "thwanya",
    "gui.sharedMessages.replaceProjectWarning": "Emisetsa diteng tsa porojeke ya jaanong",
    "gui.sharedMessages.loadFromComputerTitle": "Tsenya tshedimosetso go tswa mo khomputareng ya gago",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Porojeke ya Scratch",
    "boost.color.any": "mmala mongwe le mongwe",
    "boost.color.black": "ntsho",
    "boost.color.blue": "botala jwa loapi",
    "boost.color.green": "tala",
    "boost.color.red": "khibidu",
    "boost.color.white": "tshweu",
    "boost.color.yellow": "serolwana",
    "boost.getMotorPosition": "motšhini [MOTOR_REPORTER_ID] maemo",
    "boost.getTiltAngle": "sekamisa enkele [TILT_DIRECTION]",
    "boost.motorDirection.backward": "ka tsela ele",
    "boost.motorDirection.forward": "ka tsela e",
    "boost.motorDirection.reverse": "busetsa morago",
    "boost.motorOff": "tima motšhini [MOTOR_ID] ",
    "boost.motorOn": "tshuma motšhini [MOTOR_ID] ",
    "boost.motorOnFor": "tshuma motšhini [MOTOR_ID] [DURATION] metsotswana",
    "boost.motorOnForRotation": "tshuma motšhini [MOTOR_ID] [ROTATION] ditshekeletso",
    "boost.seeingColor": "a o bona [COLOR] setena?",
    "boost.setLightHue": "tshuma lebone la mmala go [HUE]",
    "boost.setMotorDirection": "tlhagisa motšhini [MOTOR_ID] kaelo [MOTOR_DIRECTION]",
    "boost.setMotorPower": "tlhagisa motšhini [MOTOR_ID] lebelo go [POWER] %",
    "boost.tiltDirection.any": "sengwe",
    "boost.tiltDirection.down": "tlase",
    "boost.tiltDirection.left": "molema",
    "boost.tiltDirection.right": "moja",
    "boost.tiltDirection.up": "godimo",
    "boost.whenColor": "fa [COLOR] wa setena o bonwe",
    "boost.whenTilted": "fa e sekamisitswe [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "letsa noto [NOTE] ya [TIME] metsotswana",
    "ev3.buttonPressed": "konopo [PORT] tobeditswe?",
    "ev3.getBrightness": "phatshimo",
    "ev3.getDistance": "sekgala",
    "ev3.getMotorPosition": "motšhini [PORT] maemo",
    "ev3.motorSetPower": "motšhini [PORT] tlhagisa maatla [POWER] %",
    "ev3.motorTurnClockwise": "motšhini [PORT] retologela ka fa [TIME] metsotswana",
    "ev3.motorTurnCounterClockwise": "motšhini [PORT] retologela ka fale [TIME] metsotswana",
    "ev3.whenBrightnessLessThan": "fa phatsimo < [DISTANCE]",
    "ev3.whenButtonPressed": "fa konopo [PORT] e gateletswe",
    "ev3.whenDistanceLessThan": "fa sekgala < [DISTANCE]",
    "gdxfor.getAcceleration": "koketso [DIRECTION]",
    "gdxfor.getForce": "maatla",
    "gdxfor.getSpin": "dikolosa lebelo [DIRECTION]",
    "gdxfor.getTilt": "sekamisa enkele [TILT]",
    "gdxfor.isFreeFalling": " a o a wa?",
    "gdxfor.isTilted": "sekametse [TILT]?",
    "gdxfor.pulled": "gogilwe",
    "gdxfor.pushed": "kgarameletsa",
    "gdxfor.shaken": "reketlisiwa",
    "gdxfor.startedFalling": "simolola go wa",
    "gdxfor.tiltDirectionMenu.any": "sengwe",
    "gdxfor.tiltDirectionMenu.back": "kwa morago",
    "gdxfor.tiltDirectionMenu.front": "fa pele",
    "gdxfor.tiltDirectionMenu.left": "molema",
    "gdxfor.tiltDirectionMenu.right": "moja",
    "gdxfor.turnedFaceDown": "fetoletse sefatlhego kwa tlase",
    "gdxfor.turnedFaceUp": "fetoletse sefatlhego kwa godimo",
    "gdxfor.whenForcePushedOrPulled": "fa maatla a dupelela  [PUSH_PULL]",
    "gdxfor.whenGesture": "fa [GESTURE]",
    "gdxfor.whenTilted": "fa e sekamisitswe [TILT]",
    "makeymakey.downArrow": "tshupo tlase",
    "makeymakey.downArrowShort": "tlase",
    "makeymakey.leftArrow": "tshupo molema",
    "makeymakey.leftArrowShort": "molema",
    "makeymakey.rightArrow": "tshupo moja",
    "makeymakey.rightArrowShort": "moja",
    "makeymakey.spaceKey": "sebaka",
    "makeymakey.upArrow": "tshupo godimo",
    "makeymakey.upArrowShort": "godimo",
    "makeymakey.whenKeyPressed": "fa [KEY] konopo e tobeditswe",
    "makeymakey.whenKeysPressedInOrder": "fa [SEQUENCE] e tobeditswe ka tolamo",
    "microbit.buttonsMenu.any": "sengwe",
    "microbit.clearDisplay": "phepafatsa dipontsho",
    "microbit.defaultTextToDisplay": "Dumela!",
    "microbit.displaySymbol": "bontsha [MATRIX]",
    "microbit.displayText": "bontsha setlhangwa [TEXT]",
    "microbit.gesturesMenu.jumped": "tloletse",
    "microbit.gesturesMenu.moved": "sutisitswe",
    "microbit.gesturesMenu.shaken": "reketlisiwa",
    "microbit.isButtonPressed": "[BTN] konopo e gateletswe?",
    "microbit.isTilted": "sekamisitswe [DIRECTION]?",
    "microbit.pinStateMenu.off": "timile",
    "microbit.pinStateMenu.on": "tshubile",
    "microbit.tiltAngle": "sekamisa enkele [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "sengwe",
    "microbit.tiltDirectionMenu.back": "kwa morago",
    "microbit.tiltDirectionMenu.front": "fa pele",
    "microbit.tiltDirectionMenu.left": "molema",
    "microbit.tiltDirectionMenu.right": "moja",
    "microbit.whenButtonPressed": "fa [BTN] konopo e tobeditswe",
    "microbit.whenGesture": "fa [GESTURE]",
    "microbit.whenPinConnected": "fa lomapo [PIN] golagane",
    "microbit.whenTilted": "fa le sekamisitswe [DIRECTION]",
    "music.categoryName": "Mmino",
    "music.changeTempo": "fetola lebelo ka go [TEMPO]",
    "music.drumBass": "(2) Moropa wa Base",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": " (9) tsa dikotana",
    "music.drumClosedHiHat": "(6) Hi-Hat e etswalegileng",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Tleloko ya kgomo",
    "music.drumCrashCymbal": "(4) Semebala e e opanngwang",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Opa Seatla",
    "music.drumOpenHiHat": "(5) Bula Hi-Hat",
    "music.drumSideStick": "(3) Thobane ya fa Tlhakoreng",
    "music.drumSnare": "(1) Moropa wa Senare",
    "music.drumTambourine": "(7) Moropana",
    "music.drumTriangle": "(12) Khutlotharo",
    "music.drumVibraslap": "(17) seletswa sa lerapo la motlhagare",
    "music.drumWoodBlock": "(10) Sesane",
    "music.getTempo": "lebelo",
    "music.instrumentBass": "(6) Base",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Seletswa sa Cello",
    "music.instrumentChoir": "(15) Khwaere",
    "music.instrumentClarinet": "(10) Kelarinete",
    "music.instrumentElectricGuitar": "(5) Katara ya Motlakase",
    "music.instrumentElectricPiano": "(2) Piano ya Motlakase",
    "music.instrumentFlute": "(12) Fulutu",
    "music.instrumentGuitar": "(4) Katara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Lebokoso la Mmino",
    "music.instrumentOrgan": "(3) Okene",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Sekesefone",
    "music.instrumentSteelDrum": "(18) Moropa wa Tshipi",
    "music.instrumentSynthLead": "(20) motlhabeletsi",
    "music.instrumentSynthPad": "(21) motseeletsi",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Fulutu ya legong",
    "music.midiPlayDrumForBeats": "tshameka moropa [DRUM] wa [BEATS] meporo",
    "music.midiSetInstrument": "tlhagisa sediriswa go [INSTRUMENT]",
    "music.playDrumForBeats": "tshameka moropa [DRUM] wa [BEATS] meporo",
    "music.playNoteForBeats": "tshameka noto [NOTE] ya [BEATS] meporo",
    "music.restForBeats": "ikhuletse [BEATS] meporo",
    "music.setInstrument": "tlhagisa sediriswa go [INSTRUMENT]",
    "music.setTempo": "tlhagisa lebelo go [TEMPO]",
    "pen.categoryName": "Pene",
    "pen.changeColorParam": "fetola pene [COLOR_PARAM] ka [VALUE]",
    "pen.changeHue": "fetola mmala wa pene ka [HUE]",
    "pen.changeShade": "fetola mmala wa pene ka [SHADE]",
    "pen.changeSize": "fetola bogolo ba pene ka [SIZE]",
    "pen.clear": "phimola tsotlhe",
    "pen.colorMenu.brightness": "phatshimo",
    "pen.colorMenu.color": "mmala",
    "pen.colorMenu.saturation": "Go tlala",
    "pen.colorMenu.transparency": "bosengbofitlha",
    "pen.penDown": "pene fatshe",
    "pen.penUp": "pene godimo",
    "pen.setColor": "tlhagisa mmala wa pene go [COLOR]",
    "pen.setColorParam": "tlhagisa pene [COLOR_PARAM] go [VALUE]",
    "pen.setHue": "tlhagisa mmala wa pene go [HUE]",
    "pen.setShade": "tlhagisa mmala wa pene go [SHADE]",
    "pen.setSize": "tlhagisa bogolo ba pene go [SIZE]",
    "pen.stamp": "setempe",
    "speech.defaultWhenIHearValue": "a re tsamaye",
    "speech.extensionName": "Puo ya Molaetsa",
    "speech.listenAndWait": "reetsa mme o eme",
    "speech.speechReporter": "puo",
    "speech.whenIHear": "fa ke utlwa [PHRASE]",
    "text2speech.alto": "lentswe la bobedi",
    "text2speech.categoryName": "Romela molaetsa ka puo",
    "text2speech.defaultTextToSpeak": "dumela",
    "text2speech.giant": "seganka",
    "text2speech.kitten": "katsana",
    "text2speech.setLanguageBlock": "tlhagisa puo go [LANGUAGE]",
    "text2speech.setVoiceBlock": "tlhagisa lentswe go [VOICE]",
    "text2speech.speakAndWaitBlock": "bua [WORDS]",
    "text2speech.squeak": "lela",
    "text2speech.tenor": "lentswe la boraro",
    "translate.categoryName": "Ranola",
    "translate.defaultTextToTranslate": "dumela",
    "translate.translateBlock": "ranola [WORDS] go [LANGUAGE]",
    "translate.viewerLanguage": "puo",
    "videoSensing.categoryName": "Maikutlo a vidio",
    "videoSensing.direction": "kaelo",
    "videoSensing.motion": "tshikinyego",
    "videoSensing.off": "timile",
    "videoSensing.on": "tshubile",
    "videoSensing.onFlipped": "timile",
    "videoSensing.setVideoTransparency": "tlhagisa bosengbofitlha ba video [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "kgato",
    "videoSensing.videoOn": "video [ATTRIBUTE] mo [SUBJECT]",
    "videoSensing.videoToggle": "tshuma video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "fa video e tshameka > [REFERENCE]",
    "wedo2.getDistance": "sekgala",
    "wedo2.getTiltAngle": "sekamisa enkele [TILT_DIRECTION]",
    "wedo2.isTilted": "sekametse [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "ka tsela ele",
    "wedo2.motorDirection.forward": "ka tsela e",
    "wedo2.motorDirection.reverse": "busetswa kwa morago",
    "wedo2.motorId.a": "motšhini A",
    "wedo2.motorId.all": "metšhini yotlhe",
    "wedo2.motorId.b": "motšhini B",
    "wedo2.motorId.default": "motšhini",
    "wedo2.motorOff": "tima [MOTOR_ID] ",
    "wedo2.motorOn": "tshuma [MOTOR_ID] ",
    "wedo2.motorOnFor": "tshuma [MOTOR_ID] [DURATION] metsotswana",
    "wedo2.playNoteFor": "tshameka noto [NOTE] [DURATION] metsotswana",
    "wedo2.setLightHue": "tshuma lebone la mmala go [HUE]",
    "wedo2.setMotorDirection": "tlhagisa [MOTOR_ID] kaelo go [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "tlhagisa [MOTOR_ID] maatla go [POWER]",
    "wedo2.tiltDirection.any": "nngwe le nngwe",
    "wedo2.tiltDirection.down": "tlase",
    "wedo2.tiltDirection.left": "molema",
    "wedo2.tiltDirection.right": "moja",
    "wedo2.tiltDirection.up": "godimo",
    "wedo2.whenDistance": "fa sekgala [OP] [REFERENCE]",
    "wedo2.whenTilted": "fa e sekamisitswe [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Mmala",
    "paint.paintEditor.saturation": "Go tlala",
    "paint.paintEditor.brightness": "Phatsimo",
    "paint.paintEditor.costume": "Seaparo",
    "paint.paintEditor.group": "Setlhopa",
    "paint.paintEditor.ungroup": "Kgobokanyolola",
    "paint.paintEditor.undo": "Sutlha",
    "paint.paintEditor.redo": "Dira gape",
    "paint.paintEditor.forward": "Kwa pele",
    "paint.paintEditor.backward": "Kwa morago",
    "paint.paintEditor.front": "Fa pele",
    "paint.paintEditor.back": "Morago",
    "paint.paintEditor.more": "Oketsegileng",
    "paint.modeTools.brushSize": "Tlolela kwa godimo le tlase",
    "paint.modeTools.eraserSize": "Bogolo jwa sephimodi",
    "paint.modeTools.copy": "Kopa",
    "paint.modeTools.paste": "Kgomaretsa",
    "paint.modeTools.delete": "Phimola",
    "paint.modeTools.curved": "Obegile",
    "paint.modeTools.pointed": "Supile",
    "paint.modeTools.thickness": "Bokima",
    "paint.modeTools.flipHorizontal": "Tlola go tswa mo letlhakoreng go ya go letlhakore le lengwe",
    "paint.modeTools.flipVertical": "Tlolela kwa godimo le tlase",
    "paint.modeTools.filled": "Tladitswe",
    "paint.modeTools.outlined": "Tlhalositswe",
    "paint.paintEditor.bitmap": "Fetolela go Bitmap",
    "paint.paintEditor.vector": "Fetolela go Vector",
    "paint.paintEditor.fill": "Tlatsa",
    "paint.paintEditor.stroke": "Tlhalosa",
    "paint.brushMode.brush": "Gotlha",
    "paint.eraserMode.eraser": "Sephimodi",
    "paint.fillMode.fill": "Tlatsa",
    "paint.lineMode.line": "Mola",
    "paint.ovalMode.oval": "Sediko",
    "paint.rectMode.rect": "Khutlho nne tsepa",
    "paint.reshapeMode.reshape": "Bopa gape ",
    "paint.roundedRectMode.roundedRect": "Dikhutlonnetsepa tse di golokang",
    "paint.selectMode.select": "Tlhopha",
    "paint.textMode.text": "Mokwalo",
    "paint.colorPicker.swap": "Refosana"
  },
  "sk": {
    "gui.alerts.lostPeripheralConnection": "Scratch stratil spojenie s {extensionName}.",
    "gui.alerts.tryAgain": "Skús znova uložiť",
    "gui.alerts.download": "Ulož",
    "gui.connection.reconnect": "Znova pripoj",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Batoh",
    "gui.backpack.errorBackpack": "Chyba pri otváraní batohu",
    "gui.backpack.loadingBackpack": "Otváram...",
    "gui.backpack.more": "Viac",
    "gui.backpack.emptyBackpack": "Batoh je prázdny",
    "gui.unsupportedBrowser.label": "Scratch 3.0 nepodporuje tento prehliadač.",
    "gui.unsupportedBrowser.errorLabel": "Vyskytla sa chyba.",
    "gui.unsupportedBrowser.notRecommended": "Zdá sa, že používate prehliadač, ktorý Scratch 3.0 nepodporuje. Odporúčame prejsť na súčasnú verziu niektorého z prehliadačov Google Chrome, Mozilla Firefox, Microsoft Edge alebo Apple Safari.",
    "gui.unsupportedBrowser.description": "Je nám ľúto, ale Scratch 3.0 nepodporuje tento prehliadač. Odporúčame prejsť na súčasnú verziu niektorého z prehliadačov Google Chrome, Mozilla Firefox, Microsoft Edge alebo Apple Safari.",
    "gui.unsupportedBrowser.back": "Späť",
    "gui.unsupportedBrowser.previewfaq": "Ak chcete zistiť viac, navštívte {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Často kladené otázky",
    "gui.cards.all-tutorials": "Návody",
    "gui.cards.shrink": "Zbaľ",
    "gui.cards.expand": "Rozbaľ",
    "gui.cards.close": "Ukonči",
    "gui.cards.more-things-to-try": "Vyskúšaj aj iné",
    "gui.cards.see-more": "Ukáž viac",
    "gui.comingSoon.message1": "Na tomto ešte pracujeme {emoji}",
    "gui.comingSoon.message2": "Už čoskoro...",
    "gui.comingSoon.message3": "Na tomto ešte pracujeme {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Nenašli sa zariadenia",
    "gui.connection.auto-scanning.prescan": "Umiestni zariadenie blízko počítača a spusti vyhľadávanie.",
    "gui.connection.auto-scanning.pressbutton": "Stlač tlačidlo na zariadení.",
    "gui.connection.auto-scanning.start-search": "Vyhľadaj",
    "gui.connection.connecting-searchbutton": "Vyhľadávam...",
    "gui.connection.auto-scanning.try-again": "Skús znova",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Pripojené",
    "gui.connection.disconnect": "Odpoj",
    "gui.connection.go-to-editor": "Prejdi do Editora",
    "gui.connection.connecting-cancelbutton": "Pripájam...",
    "gui.connection.error.errorMessage": "Ojoj, zdá sa, že sa niečo pokazilo.",
    "gui.connection.error.tryagainbutton": "Skús znova",
    "gui.connection.error.helpbutton": "Pomocník",
    "gui.connection.peripheral-name-label": "Meno zariadenia",
    "gui.connection.connect": "Pripoj",
    "gui.connection.scanning.lookingforperipherals": "Vyhľadávam zariadenia",
    "gui.connection.scanning.noPeripheralsFound": "Nenašiel som žiadne zariadenie",
    "gui.connection.scanning.instructions": "Vyber si zariadenie zo zoznamu",
    "gui.connection.search": "Znova",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Máš nainštalovaný a spustený program Scratch Link?",
    "gui.connection.unavailable.enablebluetooth": "Skontroluj, či je Bluetooth zapnutý",
    "gui.connection.unavailable.tryagainbutton": "Skús znova",
    "gui.connection.unavailable.helpbutton": "Pomocník",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Spusti",
    "gui.controls.stop": "Zastav",
    "gui.crashMessage.label": "Ojoj, niečo sa pokazilo.",
    "gui.crashMessage.description": "Je nám ľúto, ale zdá sa, že Scratch práve havaroval. Chybu systém automaticky oznámil tímu Scratch. Obnov stránku a skús začať znova. ",
    "gui.crashMessage.errorNumber": "Túto chybu sme zaevidovali s číslom {errorId}",
    "gui.crashMessage.reload": "Znova načítaj",
    "gui.customProcedures.myblockModalTitle": "Nový blok",
    "gui.customProcedures.addAnInputNumberText": "Pridaj vstup",
    "gui.customProcedures.numberTextType": "číslo alebo text",
    "gui.customProcedures.addAnInputBoolean": "Pridaj vstup",
    "gui.customProcedures.booleanType": "logický",
    "gui.customProcedures.addALabel": "Pridaj nápis",
    "gui.customProcedures.runWithoutScreenRefresh": "Vykonaj bez obnovenia obrazovky",
    "gui.customProcedures.cancel": "Odmietni",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Smer",
    "gui.directionPicker.rotationStyles.allAround": "dokola",
    "gui.directionPicker.rotationStyles.leftRight": "vľavo-vpravo",
    "gui.directionPicker.rotationStyles.dontRotate": "neotáčaj",
    "gui.gui.addExtension": "Pridaj rozšírenie",
    "gui.gui.codeTab": "Scenáre",
    "gui.gui.backdropsTab": "Pozadia",
    "gui.gui.costumesTab": "Kostýmy",
    "gui.gui.soundsTab": "Zvuky",
    "gui.extensionLibrary.comingSoon": "Už čoskoro...",
    "gui.extensionLibrary.requires": "Vyžaduje",
    "gui.extensionLibrary.collaboration": "V spolupráci s",
    "gui.library.filterPlaceholder": "Hľadať",
    "gui.library.allTag": "Všetko",
    "gui.loader.message1": "Vytváram bloky...",
    "gui.loader.message2": "Otváram postavy...",
    "gui.loader.message3": "Otváram zvuky...",
    "gui.loader.message4": "Otváram rozšírenie...",
    "gui.loader.message5": "Hľadám procesor...",
    "gui.loader.message6": "Prenášam debny...",
    "gui.loader.message7": "Vypúšťam prebytočný vzduch...",
    "gui.loader.message8": "Otváram emoji...",
    "gui.loader.headline": "Otváram projekt",
    "gui.loader.creating": "Vytváram projekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Moje veci",
    "gui.accountMenu.myClasses": "Moje triedy",
    "gui.accountMenu.myClass": "Moja trieda",
    "gui.accountMenu.accountSettings": "Nastavenia účtu",
    "gui.accountMenu.signOut": "Odhlás sa",
    "gui.authorInfo.byUser": "od {username}",
    "gui.menuBar.seeProjectPage": "Prejdi na stránku projektu",
    "gui.menuBar.language": "Language",
    "general.username": "Meno",
    "general.password": "Heslo",
    "general.signIn": "Prihlás sa",
    "login.needHelp": "Potrebuješ pomoc?",
    "form.validationRequired": "Toto pole je povinné",
    "gui.menuBar.tutorialsLibrary": "Návody",
    "gui.menuBar.restoreSprite": "Vráť postavu",
    "gui.menuBar.restoreSound": "Vráť zvuk",
    "gui.menuBar.restoreCostume": "Vráť kostým",
    "gui.menuBar.restore": "Vráť",
    "gui.menuBar.saveNow": "Ulož",
    "gui.menuBar.saveAsCopy": "Ulož ako",
    "gui.menuBar.remix": "Remixuj",
    "gui.menuBar.new": "Nový",
    "gui.menuBar.file": "Súbor",
    "gui.menuBar.downloadToComputer": "Ulož do počítača",
    "gui.menuBar.edit": "Úpravy",
    "gui.menuBar.turboModeOff": "Vypni turbo",
    "gui.menuBar.turboModeOn": "Zapni turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Pripoj sa k Scratchu",
    "gui.menuBar.signIn": "Prihlás sa",
    "gui.gui.projectTitlePlaceholder": "Napíš názov projektu",
    "gui.menuBar.saveNowLink": "Ulož",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Zdieľaný",
    "gui.menuBar.share": "Zdieľaj",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Pomocník",
    "gui.modal.back": "Späť",
    "gui.monitor.listMonitor.empty": "(prázdny)",
    "gui.monitor.listMonitor.listLength": "dĺžka {length}",
    "gui.monitor.contextMenu.default": "normálne",
    "gui.monitor.contextMenu.large": "iba hodnota",
    "gui.monitor.contextMenu.slider": "ako posúvač",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "načítaj",
    "gui.monitor.contextMenu.export": "ulož",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "Pre všetky postavy",
    "gui.gui.variableScopeOptionSpriteOnly": "Len pre túto postavu",
    "gui.gui.cloudVariableOption": "Cloudová premenná (uložená na serveri)",
    "gui.gui.variablePromptAllSpritesMessage": "Táto premenná bude dostupná pre všetky postavy",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Odmietni",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Zastav",
    "gui.playbackStep.playMsg": "Zahraj",
    "gui.playbackStep.loadingMsg": "Otváram...",
    "gui.playbackStep.saveMsg": "Ulož",
    "gui.playbackStep.reRecordMsg": "Nahraj znova",
    "gui.recordModal.title": "Nahraj zvuk",
    "gui.recordingStep.beginRecord": "Stlač tlačidlo dolu a začni nahrávať ",
    "gui.recordingStep.permission": "{arrow}Použitie mikrofónu si vyžaduje tvoj súhlas",
    "gui.recordingStep.stop": "Skonči nahrávať",
    "gui.recordingStep.record": "Nahraj",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "zvuk",
    "gui.soundEditor.play": "Zahraj",
    "gui.soundEditor.stop": "Zastav",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Ulož",
    "gui.soundEditor.undo": "Naspäť",
    "gui.soundEditor.redo": "Znova",
    "gui.soundEditor.faster": "Rýchlejšie",
    "gui.soundEditor.slower": "Pomalšie",
    "gui.soundEditor.echo": "Ozvena",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Hlasnejšie",
    "gui.soundEditor.softer": "Tichšie",
    "gui.soundEditor.reverse": "Odzadu",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Meno",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Postava",
    "gui.SpriteInfo.show": "Ukáž",
    "gui.SpriteInfo.size": "Veľkosť",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplikuj",
    "gui.spriteSelectorItem.contextMenuExport": "ulož",
    "gui.spriteSelectorItem.contextMenuDelete": "zruš",
    "gui.spriteSelector.addSpriteFromLibrary": "Vyber si postavu",
    "gui.spriteSelector.addSpriteFromPaint": "Nakresli",
    "gui.spriteSelector.addSpriteFromSurprise": "Náhodne",
    "gui.spriteSelector.addSpriteFromFile": "Zo súboru",
    "gui.stageHeader.stageSizeLarge": "Prepni na veľkú scénu",
    "gui.stageHeader.stageSizeSmall": "Prepni na malú scénu",
    "gui.stageHeader.stageSizeFull": "Prejdi na  režim celej obrazovky",
    "gui.stageHeader.stageSizeUnFull": "Ukonči režim celej obrazovky",
    "gui.stageHeader.fullscreenControl": "Na celú obrazovku",
    "gui.spriteSelector.addBackdropFromLibrary": "Vyber si pozadie",
    "gui.stageSelector.addBackdropFromPaint": "Nakresli",
    "gui.stageSelector.addBackdropFromSurprise": "Náhodne",
    "gui.stageSelector.addBackdropFromFile": "Zo súboru",
    "gui.stageSelector.stage": "Scéna",
    "gui.stageSelector.backdrops": "Pozadia",
    "gui.telemetryOptIn.label": "Odošli štatistické údaje na zlepšenie verzie Scratch 3.0",
    "gui.telemetryOptIn.body1": "Autori prostredia sa snažia lepšie rozumieť, ako sa používa Scratch 3.0. Ak nám chcete v tomto úsilí pomôcť, dovolte, aby sme automaticky dostávali informácie o práci s ním.",
    "gui.telemetryOptIn.body2": "Zbierame informácie o voľbe jazyka, používaní blokov a niektorých akcií, napr. ukladaní, otváraní a nahrávaní projektu. NEZBIERAME žiadne osobné údaje. Prosíme, prečítaj si {privacyPolicyLink} a získaj viac informácii.",
    "gui.telemetryOptIn.privacyPolicyLink": "Zásady ochrany súkromia",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo",
    "gui.webglModal.label": "Váš prehliadač nepodporuje WebGL.",
    "gui.webglModal.description": "Žiaľ, zdá sa, že váš prehliadač alebo počítač nemá {webGlLink}. Táto technológia je nevyhnutná na správne fungovanie Scratch 3.0.",
    "gui.webglModal.webgllink": "nepodporuje WebGL",
    "gui.webglModal.back": "Späť",
    "gui.webglModal.previewfaq": "Ak chcete zistiť viac, navštívte {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Často kladené otázky",
    "gui.costumeLibrary.chooseABackdrop": "Vyber si pozadie",
    "gui.costumeLibrary.chooseACostume": "Vyber si kostým",
    "gui.costumeTab.addBackdropFromLibrary": "Vyber si pozadie",
    "gui.costumeTab.addCostumeFromLibrary": "Vyber si kostým",
    "gui.costumeTab.addBlankCostume": "Nakresli",
    "gui.costumeTab.addSurpriseCostume": "Náhodne",
    "gui.costumeTab.addFileBackdrop": "Zo súboru",
    "gui.costumeTab.addFileCostume": "Zo súboru",
    "gui.extensionLibrary.chooseAnExtension": "Vyber si rozšírenie",
    "gui.extensionLibrary.extensionUrl": "Zadaj webovú adresu rozšírenia",
    "gui.monitors.importListColumnPrompt": "Ktorý stĺpec mám použiť (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Nemôžem začať nahrávať zvuk",
    "gui.soundLibrary.chooseASound": "Vyber si zvuk",
    "gui.soundTab.fileUploadSound": "Zo súboru",
    "gui.soundTab.surpriseSound": "Náhodne",
    "gui.soundTab.recordSound": "Nahraj",
    "gui.soundTab.addSoundFromLibrary": "Vyber si zvuk",
    "gui.spriteLibrary.chooseASprite": "Vyber si postavu",
    "gui.tipsLibrary.tutorials": "Vyber si návod",
    "gui.alerts.createsuccess": "Nový projekt vytvorený.",
    "gui.alerts.createcopysuccess": "Kópia projektu bola uložená.",
    "gui.alerts.createremixsuccess": "Odvodený projekt bol uložený.",
    "gui.alerts.creating": "Vytváram nový projekt...",
    "gui.alerts.creatingCopy": "Kopírujem projekt...",
    "gui.alerts.creatingRemix": "Vytváram odvodený projekt...",
    "gui.alerts.creatingError": "Nepodarilo sa vytvoriť projekt. Prosím, skús znova!",
    "gui.alerts.savingError": "Projekt sa nepodarilo uložiť.",
    "gui.alerts.savesuccess": "Projekt bol uložený.",
    "gui.alerts.saving": "Ukladám projekt...",
    "gui.alerts.cloudInfo": "Pozor, hodnotou cloudovej premennej môže byť iba číslo, nie znak alebo slovo. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Zisti viac",
    "gui.alerts.importing": "Importing…",
    "gui.defaultProject.meow": "Mňau",
    "gui.defaultProject.variable": "premenná",
    "gui.howtos.intro-move-sayhello-hat.name": "Smelo začni",
    "gui.howtos.intro-move.step_stepMove": "Pridaj blok pre pohyb ",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Rozhýb písmená",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Použi písmeno ako kostým",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Zahraj zvuk, ak sa na postavu klikne",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Urob ďalšiu postavu s kostýmom písmena",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Zmeň farbu písmena",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Vyber si ďalšie písmeno a roztoč ho",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Nech sa ti písmeno zväčšuje a zmenšuje",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Urob si kapelu",
    "gui.howtos.Make-Music.step_PickInstrument": "Vytvor postavu s kostýmom hudobného nástroja",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Zahraj zvuk pri kliknutí",
    "gui.howtos.Make-Music.step_MakeSong": "Vytvor pesničku",
    "gui.howtos.make-music.step_MakeBeat": "Vyber si bubon a zabubnuj",
    "gui.howtos.make-music.step_MakeBeatBox": "Vytvor postavu s kostýmom mikrofónu",
    "gui.howtos.story.name": "Vytvor si príbeh",
    "gui.howtos.story.step_addbg": "Pridaj pozadie",
    "gui.howtos.story.step_addsprite": "Pridaj postavu",
    "gui.howtos.story.step_saysomething": "Použi blok povedz",
    "gui.howtos.story.step_addanothersprite": "Pridaj ďalšiu postavu",
    "gui.howtos.story.step_flip": "Prevráť kostým",
    "gui.howtos.story.step_conversation": "Urob rozhovor",
    "gui.howtos.story.addanotherbg": "Pridaj ďalšie pozadie",
    "gui.howtos.story.step_swithbg": "Zmeň pozadie",
    "gui.howtos.story.step_hidewizard": "Skry postavu",
    "gui.howtos.story.step_showwizard": "Ukáž postavu",
    "gui.howtos.make-a-chase-game.name": "Vyrob si naháňačku",
    "gui.howtos.Chase-Game.step_BG": "Zvoľ pozadie",
    "gui.howtos.chase-game.step_AddOcto": "Pridaj postavu",
    "gui.howtos.make-music.step_LeftRight": "Hýb postavou vľavo a vpravo",
    "gui.howtos.Chase-Game.step_UpDown": "Hýb postavou hore a dolu",
    "gui.howtos.Chase-Game.step_AddStar": "Pridaj ďalšiu postavu",
    "gui.howtos.Chase-Game.step_MoveRandom": "Nech sa hýbe náhodne",
    "gui.howtos.Chase-Game.step_WhenTouch": "Keď sa dotkne chobotnice, nech zahrá zvuk",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Vytvor premennú skóre",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Nech chobotnica počíta skóre",
    "gui.howtos.animate-char.name": "Animuj postavu",
    "gui.howtos.animate-char.step_addbg": "Pridaj pozadie",
    "gui.howtos.animate-char.step_addsprite": "Pridaj postavu",
    "gui.howtos.animate-char.step_saysomething": "Použi blok povedz",
    "gui.howtos.animate-char.step_addsound": "Pridaj zvuk",
    "gui.howtos.animate-char.step_animatetalking": "Striedaj kostýmy",
    "gui.howtos.animate-char.step_arrowkeys": "Použi šípky",
    "gui.howtos.animate-char.step_jump": "Vyskoč",
    "gui.howtos.animate-char.step_changecolor": "Zmeň postave farbu",
    "gui.howtos.make-a-game.name": "Vytvárame hru s klikaním",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Vyber si postavu",
    "gui.howtos.make-a-game.step_GamePlaySound": "Zahraj zvuk po kliknutí",
    "gui.howtos.make-a-game.step_GameAddScore": "Vytvor premennú skóre",
    "gui.howtos.make-a-game.step_GameChangeScore": "Pri kliknutí zvýš skóre",
    "gui.howtos.make-a-game.step_Random": "Choď na náhodnú pozíciu",
    "gui.howtos.make-music.step_GameChangeColor": "Zmeň postave farbu",
    "gui.howtos.make-music.step_ResetScore": "Vynuluj skóre",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Vytvor si dobrodružnú hru",
    "gui.howtos.cartoon-network.step_CNcharacter": "Zvoľ si postavu, ktorú ukážeš",
    "gui.howtos.cartoon-network.step_CNsay": "Použi blok povedz",
    "gui.howtos.cartoon-network.step_CNglide": "Použi kĺzanie",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Koho budeš naháňať?",
    "gui.howtos.cartoon-network.step_CNcollect": "Zbieraj veci",
    "gui.howtos.cartoon-network.step_CNvariable": "Počítaj skóre pomocou premennej",
    "gui.howtos.cartoon-network.step_CNscore": "Počítaj skóre",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Poď na vyššiu úroveň: Zmeň pozadie",
    "gui.howtos.videosens.name": "Využi video snímanie",
    "gui.howtos.videosens.step_addextension": "Pridaj rozšírenie",
    "gui.howtos.videosens.step_pet": "Pohladkaj mačku",
    "gui.howtos.videosens.step_animate": "Rozhýb postavu",
    "gui.howtos.videosens.step_pop": "Odraz balón",
    "gui.howtos.say-it-out-loud": "Vytvor si hovoriace postavy",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Pridaj rozšírenie na syntézu reči",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Nastav hlas",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Pridaj pohyb",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Pridaj pozadie",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Pridaj ďalšiu postavu",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Pridaj zvuky",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Zmeň farby",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Roztoč postavu",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Zväčšuj a zmenšuj",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Pridaj postavu",
    "gui.howtos.add-sprite.step_addSprite": "Pridaj postavu",
    "gui.howtos.add-a-backdrop.name": "Pridaj pozadie",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Pridaj pozadie",
    "gui.howtos.change-size.name": "Zmeň veľkosť",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Kĺž sa po scéne",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Nahraj zvuk",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Roztoč postavu",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Skry a ukáž",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Rozhýb postavu",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Riaď postavu šípkami",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Pridaj efekty",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Hudba",
    "gui.extension.music.description": "Hráme na nástroje a bicie.",
    "gui.extension.pen.name": "Pero",
    "gui.extension.pen.description": "Kreslíme perom.",
    "gui.extension.videosensing.name": "Video zisťovanie",
    "gui.extension.videosensing.description": "Vnímame pohyby pomocou kamery.",
    "gui.extension.text2speech.name": "Syntéza reči",
    "gui.extension.text2speech.description": "Dajme postavám hlas.",
    "gui.extension.translate.name": "Preklad",
    "gui.extension.translate.description": "Prekladáme text do iného jazyka.",
    "gui.extension.makeymakey.description": "Vyrábame si vlastné klávesy.",
    "gui.extension.microbit.description": "Programujme fyzické zariadenia.",
    "gui.extension.microbit.connectingMessage": "Pripájam sa",
    "gui.extension.ev3.description": "Vytvárame roboty a robotické hračky.",
    "gui.extension.ev3.connectingMessage": "Pripájam sa. Presvedč sa, že pin na tvojom EV3 je nastavený na 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Pracujeme s motormi a senzormi.",
    "gui.extension.wedo2.connectingMessage": "Pripájam sa",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Všetko",
    "gui.libraryTags.animals": "Zvieratá",
    "gui.libraryTags.dance": "Tanec",
    "gui.libraryTags.effects": "Efekty",
    "gui.libraryTags.fantasy": "Fantázia",
    "gui.libraryTags.fashion": "Móda",
    "gui.libraryTags.food": "Jedlo",
    "gui.libraryTags.indoors": "Vnútri",
    "gui.libraryTags.loops": "Slučky",
    "gui.libraryTags.music": "Hudba",
    "gui.libraryTags.notes": "Noty",
    "gui.libraryTags.outdoors": "Vonku",
    "gui.libraryTags.patterns": "Vzory",
    "gui.libraryTags.people": "Ľudia",
    "gui.libraryTags.percussion": "Bicie",
    "gui.libraryTags.space": "Vesmír",
    "gui.libraryTags.sports": "Šport",
    "gui.libraryTags.underwater": "Pod vodou",
    "gui.libraryTags.voice": "Hlasy",
    "gui.libraryTags.wacky": "Šašoviny",
    "gui.libraryTags.animation": "Animácie",
    "gui.libraryTags.art": "Umenie",
    "gui.libraryTags.games": "Hry",
    "gui.libraryTags.stories": "Príbehy",
    "gui.libraryTags.letters": "Písmená",
    "gui.opcodeLabels.direction": "smer",
    "gui.opcodeLabels.xposition": "pozícia x",
    "gui.opcodeLabels.yposition": "pozícia y",
    "gui.opcodeLabels.size": "veľkosť",
    "gui.opcodeLabels.costumename": "meno kostýmu",
    "gui.opcodeLabels.costumenumber": "číslo kostýmu",
    "gui.opcodeLabels.backdropname": "meno pozadia",
    "gui.opcodeLabels.backdropnumber": "číslo pozadia",
    "gui.opcodeLabels.volume": "hlasitosť",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "odpoveď",
    "gui.opcodeLabels.loudness": "hlasitosť",
    "gui.opcodeLabels.username": "používateľ",
    "gui.opcodeLabels.year": "rok",
    "gui.opcodeLabels.month": "mesiac",
    "gui.opcodeLabels.date": "deň v mesiaci",
    "gui.opcodeLabels.dayofweek": "deň v týždni",
    "gui.opcodeLabels.hour": "hodina",
    "gui.opcodeLabels.minute": "minúta",
    "gui.opcodeLabels.second": "sekunda",
    "gui.opcodeLabels.timer": "časovač",
    "gui.projectLoader.loadError": "Zvolený projekt sa nepodarilo otvoriť.",
    "gui.sharedMessages.backdrop": "pozadie{index}",
    "gui.sharedMessages.costume": "kostým{index}",
    "gui.sharedMessages.sprite": "Postava{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.loadFromComputerTitle": "Otvor z počítača",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Projekt v prostredí Scratch",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "tón [NOTE] hraj [TIME] s",
    "ev3.buttonPressed": "stlačené tlačidlo [PORT]?",
    "ev3.getBrightness": "jas",
    "ev3.getDistance": "vzdialenosť",
    "ev3.getMotorPosition": "pozícia motora [PORT]",
    "ev3.motorSetPower": "nastav výkon motora [PORT] na [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] otáčaj vpravo [TIME] s",
    "ev3.motorTurnCounterClockwise": "motor [PORT] otáčaj vľavo [TIME] s",
    "ev3.whenBrightnessLessThan": "pri jase < [DISTANCE]",
    "ev3.whenButtonPressed": "pri stlačení tlačidla [PORT]",
    "ev3.whenDistanceLessThan": "pri vzdialenosti < [DISTANCE]",
    "gdxfor.getAcceleration": "zrýchenie [DIRECTION]",
    "gdxfor.getForce": "sila",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "šípka dole",
    "makeymakey.downArrowShort": "dole",
    "makeymakey.leftArrow": "šípka vľavo",
    "makeymakey.leftArrowShort": "vľavo",
    "makeymakey.rightArrow": "šípka vpravo",
    "makeymakey.rightArrowShort": "vpravo",
    "makeymakey.spaceKey": "medzerník",
    "makeymakey.upArrow": "šípka hore",
    "makeymakey.upArrowShort": "hore",
    "makeymakey.whenKeyPressed": "pri stlačení klávesu [KEY]",
    "makeymakey.whenKeysPressedInOrder": "pri stlačení postupnosti [SEQUENCE]",
    "microbit.buttonsMenu.any": "hociktorý",
    "microbit.clearDisplay": "zmaž displej",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "zobraz [MATRIX]",
    "microbit.displayText": "zobraz text [TEXT]",
    "microbit.gesturesMenu.jumped": "skoku",
    "microbit.gesturesMenu.moved": "pohybe",
    "microbit.gesturesMenu.shaken": "zatrasení",
    "microbit.isButtonPressed": "tlačidlo [BTN] stlačené?",
    "microbit.isTilted": "náklon smerom [DIRECTION]?",
    "microbit.pinStateMenu.off": "vypnutý",
    "microbit.pinStateMenu.on": "zapnutý",
    "microbit.tiltAngle": "uhol náklonu [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "hociktorý",
    "microbit.tiltDirectionMenu.back": "dozadu",
    "microbit.tiltDirectionMenu.front": "dopredu",
    "microbit.tiltDirectionMenu.left": "vľavo",
    "microbit.tiltDirectionMenu.right": "vpravo",
    "microbit.whenButtonPressed": "pri stlačení tlačidla [BTN]",
    "microbit.whenGesture": "pri geste [GESTURE]",
    "microbit.whenPinConnected": "pri zapojení pinu [PIN]",
    "microbit.whenTilted": "pri náklone [DIRECTION]",
    "music.categoryName": "Hudba",
    "music.changeTempo": "zmeň tempo o [TEMPO]",
    "music.drumBass": "(2) bubon",
    "music.drumBongo": "(13) bongo",
    "music.drumCabasa": "(15) cabasa",
    "music.drumClaves": "(9) claves",
    "music.drumClosedHiHat": "(6) zatvorená hajka",
    "music.drumConga": "(14) konga",
    "music.drumCowbell": "(11) kravský zvonec",
    "music.drumCrashCymbal": "(4) činely",
    "music.drumCuica": "(18) netlmená cuica",
    "music.drumGuiro": "(16) guiro",
    "music.drumHandClap": "(8) tlesknutie",
    "music.drumOpenHiHat": "(5) otvorená hajka",
    "music.drumSideStick": "(3) okraj bubna",
    "music.drumSnare": "(1) bubienok",
    "music.drumTambourine": "(7) tamburína",
    "music.drumTriangle": "(12) triangel",
    "music.drumVibraslap": "(17) vibraslap",
    "music.drumWoodBlock": "(10) drevený blok",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) kontrabas",
    "music.instrumentBassoon": "(14) fagot",
    "music.instrumentCello": "(8) violončelo",
    "music.instrumentChoir": "(15) zbor",
    "music.instrumentClarinet": "(10) klarinet",
    "music.instrumentElectricGuitar": "(5) elektrická gitara",
    "music.instrumentElectricPiano": "(2) elektrické klávesy",
    "music.instrumentFlute": "(12) flauta",
    "music.instrumentGuitar": "(4) gitara",
    "music.instrumentMarimba": "(19) marimba",
    "music.instrumentMusicBox": "(17) hracia skrinka",
    "music.instrumentOrgan": "(3) organ",
    "music.instrumentPiano": "(1) klavír",
    "music.instrumentPizzicato": "(7) brnkanie prstom",
    "music.instrumentSaxophone": "(11) saxofón",
    "music.instrumentSteelDrum": "(18) plechový bubienok",
    "music.instrumentSynthLead": "(20) syntetizátor sólo",
    "music.instrumentSynthPad": "(21) syntetizátor pozadie",
    "music.instrumentTrombone": "(9) trombón",
    "music.instrumentVibraphone": "(16) vibrafón",
    "music.instrumentWoodenFlute": "(13) zobcová flauta",
    "music.midiPlayDrumForBeats": "zabubnuj [DRUM] taktov [BEATS]",
    "music.midiSetInstrument": "nastav nástroj na [INSTRUMENT]",
    "music.playDrumForBeats": "zabubnuj [DRUM] taktov [BEATS]",
    "music.playNoteForBeats": "zahraj tón [NOTE] taktov [BEATS]",
    "music.restForBeats": "nehraj taktov [BEATS]",
    "music.setInstrument": "nastav nástroj na [INSTRUMENT]",
    "music.setTempo": "nastav tempo na [TEMPO]",
    "pen.categoryName": "Pero",
    "pen.changeColorParam": "zmeň [COLOR_PARAM] pera o [VALUE]",
    "pen.changeHue": "zmeň farbu pera o [HUE]",
    "pen.changeShade": "zmeň odtieň pera o [SHADE]",
    "pen.changeSize": "zmeň hrúbku pera o [SIZE]",
    "pen.clear": "zmaž",
    "pen.colorMenu.brightness": "jas",
    "pen.colorMenu.color": "farba",
    "pen.colorMenu.saturation": "sýtosť",
    "pen.colorMenu.transparency": "priehľadnosť",
    "pen.penDown": "pero zapni",
    "pen.penUp": "pero vypni",
    "pen.setColor": "nastav farbu pera na [COLOR]",
    "pen.setColorParam": "nastav [COLOR_PARAM] pera na [VALUE]",
    "pen.setHue": "nastav farbu pera na[HUE]",
    "pen.setShade": "nastav odtieň pera na [SHADE]",
    "pen.setSize": "nastav hrúbku pera na [SIZE]",
    "pen.stamp": "opečiatkuj",
    "speech.defaultWhenIHearValue": "idem na to",
    "speech.extensionName": "rozpoznávanie reči",
    "speech.listenAndWait": "vypočuj a rozpoznaj",
    "speech.speechReporter": "rozpoznaj",
    "speech.whenIHear": "pri vete [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "ahoj",
    "text2speech.giant": "obor",
    "text2speech.kitten": "mačiatko",
    "text2speech.setLanguageBlock": "nastav jazyk na [LANGUAGE]",
    "text2speech.setVoiceBlock": "nastav hlas na [VOICE]",
    "text2speech.speakAndWaitBlock": "povedz [WORDS]",
    "text2speech.squeak": "pisklavo",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "prelož",
    "translate.defaultTextToTranslate": "ahoj",
    "translate.translateBlock": "prelož [WORDS] do [LANGUAGE]",
    "translate.viewerLanguage": "jazyk",
    "videoSensing.categoryName": "Video snímanie",
    "videoSensing.direction": "smer",
    "videoSensing.motion": "pohyb",
    "videoSensing.off": "vypni",
    "videoSensing.on": "zapni",
    "videoSensing.onFlipped": "prepni",
    "videoSensing.setVideoTransparency": "nastav priehľadnosť snímania na [TRANSPARENCY]",
    "videoSensing.sprite": "postava",
    "videoSensing.stage": "scéna",
    "videoSensing.videoOn": "snímaný [ATTRIBUTE] na [SUBJECT]",
    "videoSensing.videoToggle": "[VIDEO_STATE] snímanie",
    "videoSensing.whenMotionGreaterThan": "pri snímanom pohybe > [REFERENCE]",
    "wedo2.getDistance": "vzdialenosť",
    "wedo2.getTiltAngle": "uhol náklonu [TILT_DIRECTION]",
    "wedo2.isTilted": "náklon [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "vľavo",
    "wedo2.motorDirection.forward": "vpravo",
    "wedo2.motorDirection.reverse": "opačný",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "oba motory",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "vypni motor [MOTOR_ID]",
    "wedo2.motorOn": "zapni motor [MOTOR_ID]",
    "wedo2.motorOnFor": "zapni motor [MOTOR_ID] na [DURATION] s",
    "wedo2.playNoteFor": "tón [NOTE] hraj [DURATION] s",
    "wedo2.setLightHue": "nastav farbu svetla [HUE]",
    "wedo2.setMotorDirection": "nastav smer [MOTOR_ID] na [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "nastav rýchlosť motora [MOTOR_ID] na [POWER]",
    "wedo2.tiltDirection.any": "hociktorý",
    "wedo2.tiltDirection.down": "dole",
    "wedo2.tiltDirection.left": "vľavo",
    "wedo2.tiltDirection.right": "vpravo",
    "wedo2.tiltDirection.up": "hore",
    "wedo2.whenDistance": "pri vzdialenosti [OP] ako [REFERENCE]",
    "wedo2.whenTilted": "pri naklonení [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "farba",
    "paint.paintEditor.saturation": "sýtosť",
    "paint.paintEditor.brightness": "jas",
    "paint.paintEditor.costume": "kostým",
    "paint.paintEditor.group": "Spoj",
    "paint.paintEditor.ungroup": "Rozdeľ",
    "paint.paintEditor.undo": "Naspäť",
    "paint.paintEditor.redo": "Znova",
    "paint.paintEditor.forward": "Dopredu",
    "paint.paintEditor.backward": "Dozadu",
    "paint.paintEditor.front": "Navrch",
    "paint.paintEditor.back": "Naspodok",
    "paint.paintEditor.more": "Viac",
    "paint.modeTools.brushSize": "hrúbka",
    "paint.modeTools.eraserSize": "hrúbka gumy",
    "paint.modeTools.copy": "Kopíruj",
    "paint.modeTools.paste": "Vlož",
    "paint.modeTools.delete": "Zmaž",
    "paint.modeTools.curved": "Krivky",
    "paint.modeTools.pointed": "Hroty",
    "paint.modeTools.thickness": "Hrúbka",
    "paint.modeTools.flipHorizontal": "prevráť vodorovne",
    "paint.modeTools.flipVertical": "prevráť zvislo",
    "paint.modeTools.filled": "výplň",
    "paint.modeTools.outlined": "obrys",
    "paint.paintEditor.bitmap": "zmeň na raster",
    "paint.paintEditor.vector": "zmeň na vektory",
    "paint.paintEditor.fill": "výplň",
    "paint.paintEditor.stroke": "obrys",
    "paint.brushMode.brush": "štetec",
    "paint.eraserMode.eraser": "guma",
    "paint.fillMode.fill": "výplň",
    "paint.lineMode.line": "úsečka",
    "paint.ovalMode.oval": "elipsa (Shift: Kružnica)",
    "paint.rectMode.rect": "obdĺžnik (Shift: štvorec)",
    "paint.reshapeMode.reshape": "uprav tvar",
    "paint.roundedRectMode.roundedRect": "zaoblený obdĺžnik",
    "paint.selectMode.select": "označ",
    "paint.textMode.text": "text",
    "paint.colorPicker.swap": "zameň farby"
  },
  "sl": {
    "gui.alerts.lostPeripheralConnection": "Scratch je izgubil povezavo do {extensionName}.",
    "gui.alerts.tryAgain": "Poskusi ponovno",
    "gui.alerts.download": "Prenesi",
    "gui.connection.reconnect": "Ponovno poveži",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Shramba delčkov kode",
    "gui.backpack.errorBackpack": "Napaka pri nalaganju shrambe delčkov kode",
    "gui.backpack.loadingBackpack": "Nalagam...",
    "gui.backpack.more": "Več",
    "gui.backpack.emptyBackpack": "Shramba delčkov kode je prazna",
    "gui.unsupportedBrowser.label": "Ta brskalnik ni podprt",
    "gui.unsupportedBrowser.errorLabel": "Prišlo je do napake",
    "gui.unsupportedBrowser.notRecommended": "Kaže, da žal uporabljaš tisto različico brskalnika, ki je Scratch ne podpira. Priporočamo uporabo najnovejših različic brskalnikov Google Chrome, Mozilla Firefox, Microsoft Edge ali Apple Safari.",
    "gui.unsupportedBrowser.description": "Scratch žal ne podpira tega brskalnika. Priporočamo uporabo novejših različic brskalnikov kot so Google Chrome, Mozilla Firefox, Microsoft Edge ali Apple Safari.",
    "gui.unsupportedBrowser.back": "Nazaj",
    "gui.unsupportedBrowser.previewfaq": "Da izveš več, pojdi na {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Pogosta vprašanja",
    "gui.cards.all-tutorials": "Vadnice",
    "gui.cards.shrink": "Skrči",
    "gui.cards.expand": "Razširi",
    "gui.cards.close": "Zapri",
    "gui.cards.more-things-to-try": "Poskusi še več stvari!",
    "gui.cards.see-more": "Oglej si še",
    "gui.comingSoon.message1": "Ne skrbi, delamo na tem {emoji}",
    "gui.comingSoon.message2": "Kmalu ...",
    "gui.comingSoon.message3": "Delamo na tem {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Ni najdenih naprav",
    "gui.connection.auto-scanning.prescan": "Poskrbi, da je naprava v bližini in nato prični z iskanjem.",
    "gui.connection.auto-scanning.pressbutton": "Na napravi pritisni na gumb.",
    "gui.connection.auto-scanning.start-search": "Začni z iskanjem",
    "gui.connection.connecting-searchbutton": "Iščem...",
    "gui.connection.auto-scanning.try-again": "Poskusi ponovno",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Povezano",
    "gui.connection.disconnect": "Prekini povezavo",
    "gui.connection.go-to-editor": "V urejevalnik",
    "gui.connection.connecting-cancelbutton": "Povezovanje...",
    "gui.connection.error.errorMessage": "Ups, nekaj je šlo narobe.",
    "gui.connection.error.tryagainbutton": "Poskusi ponovno",
    "gui.connection.error.helpbutton": "Pomoč",
    "gui.connection.peripheral-name-label": "Ime naprave",
    "gui.connection.connect": "Poveži",
    "gui.connection.scanning.lookingforperipherals": "Iščem naprave",
    "gui.connection.scanning.noPeripheralsFound": "Ni najdenih naprav",
    "gui.connection.scanning.instructions": "Izberi napravo z zgornjega spiska.",
    "gui.connection.search": "Osveži",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Preveri, če je Scratch Link nameščen in zagnan",
    "gui.connection.unavailable.enablebluetooth": "Preveri, če je Blootooth omogočen",
    "gui.connection.unavailable.tryagainbutton": "Poskusi ponovno",
    "gui.connection.unavailable.helpbutton": "Pomoč",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Pojdi",
    "gui.controls.stop": "Ustavi",
    "gui.crashMessage.label": "To pa je nerodno! Nekaj je šlo narobe.",
    "gui.crashMessage.description": "Žal nam je, a kaže, da je Scractch prenehal delovati. Ekipa, ki skrbi za razvoj Scratcha, je bila že avtomatično obveščena. Prosimo, osveži stran in poskusi znova. ",
    "gui.crashMessage.errorNumber": "Tvoja napaka je bila zabeležena s št. {errorId}",
    "gui.crashMessage.reload": "Ponovno naloži",
    "gui.customProcedures.myblockModalTitle": "Ustvari blok",
    "gui.customProcedures.addAnInputNumberText": "Dodaj vnos",
    "gui.customProcedures.numberTextType": "število ali besedilo",
    "gui.customProcedures.addAnInputBoolean": "Dodaj vnos",
    "gui.customProcedures.booleanType": "logične vrednosti",
    "gui.customProcedures.addALabel": "Dodaj oznako",
    "gui.customProcedures.runWithoutScreenRefresh": "Izvajaj brez osveževanja",
    "gui.customProcedures.cancel": "Prekliči",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Smer",
    "gui.directionPicker.rotationStyles.allAround": "Vsepovsod",
    "gui.directionPicker.rotationStyles.leftRight": "Levo/Desno",
    "gui.directionPicker.rotationStyles.dontRotate": "Ne obračaj",
    "gui.gui.addExtension": "Dodaj razširitev",
    "gui.gui.codeTab": "Koda",
    "gui.gui.backdropsTab": "Ozadja",
    "gui.gui.costumesTab": "Videzi",
    "gui.gui.soundsTab": "Zvoki",
    "gui.extensionLibrary.comingSoon": "Kmalu...",
    "gui.extensionLibrary.requires": "Potrebno je",
    "gui.extensionLibrary.collaboration": "Sodelovanje z",
    "gui.library.filterPlaceholder": "Išči",
    "gui.library.allTag": "Vse",
    "gui.loader.message1": "Ustvarjanje blokov",
    "gui.loader.message2": "Nalagam figure ...",
    "gui.loader.message3": "Nalagam zvoke ...",
    "gui.loader.message4": "Nalagam razširitve ...",
    "gui.loader.message5": "Krotenje mačk ...",
    "gui.loader.message6": "Uf si me pa namučil s to zahtevo ...",
    "gui.loader.message7": "Ja, jaz pa naj delam in delam ... Še malo ...",
    "gui.loader.message8": "Priprava smeškov ...",
    "gui.loader.headline": "Nalagam projekt",
    "gui.loader.creating": "Ustvarjam projekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Moje stvari",
    "gui.accountMenu.myClasses": "Moji razredi",
    "gui.accountMenu.myClass": "Moj razred",
    "gui.accountMenu.accountSettings": "Nastavitve računa",
    "gui.accountMenu.signOut": "Izpiši se",
    "gui.authorInfo.byUser": "avtor: {username}",
    "gui.menuBar.seeProjectPage": "Glej stran projekta",
    "gui.menuBar.language": "Language",
    "general.username": "Uporabniško ime",
    "general.password": "Geslo",
    "general.signIn": "Vpiši se",
    "login.needHelp": "Potrebuješ pomoč?",
    "form.validationRequired": "To polje je obvezno",
    "gui.menuBar.tutorialsLibrary": "Vadnice",
    "gui.menuBar.restoreSprite": "Povrni figuro",
    "gui.menuBar.restoreSound": "Povrni zvok",
    "gui.menuBar.restoreCostume": "Povrni videz",
    "gui.menuBar.restore": "Povrni",
    "gui.menuBar.saveNow": "Shrani takoj",
    "gui.menuBar.saveAsCopy": "Shrani kot kopijo",
    "gui.menuBar.remix": "Predelaj",
    "gui.menuBar.new": "Nov",
    "gui.menuBar.file": "Datoteka",
    "gui.menuBar.downloadToComputer": "Shrani na računalnik",
    "gui.menuBar.edit": "Uredi",
    "gui.menuBar.turboModeOff": "Izključi Turbo način",
    "gui.menuBar.turboModeOn": "Vključi Turbo način",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Pridruži se Scratchu",
    "gui.menuBar.signIn": "Vpiši se",
    "gui.gui.projectTitlePlaceholder": "Tukaj je naslov projekt",
    "gui.menuBar.saveNowLink": "Shrani takoj",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Deljeno",
    "gui.menuBar.share": "Deli",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Pomoč",
    "gui.modal.back": "Nazaj",
    "gui.monitor.listMonitor.empty": "(prazno)",
    "gui.monitor.listMonitor.listLength": "dolžina {length}",
    "gui.monitor.contextMenu.default": "navaden prikaz",
    "gui.monitor.contextMenu.large": "velik prikaz",
    "gui.monitor.contextMenu.slider": "drsnik",
    "gui.monitor.contextMenu.sliderRange": "spremeni območje drsnika",
    "gui.monitor.contextMenu.import": "uvozi",
    "gui.monitor.contextMenu.export": "izvozi",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Predvajaj",
    "gui.playButton.stop": "Ustavi",
    "gui.gui.variableScopeOptionAllSprites": "Za vse figure",
    "gui.gui.variableScopeOptionSpriteOnly": "Samo za to figuro",
    "gui.gui.cloudVariableOption": "Spremenljivka v oblaku (shranjena na strežniku)",
    "gui.gui.variablePromptAllSpritesMessage": "Ta spremenljivka bo na voljo vsem figuram.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Prekliči",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Ustavi",
    "gui.playbackStep.playMsg": "Predvajaj",
    "gui.playbackStep.loadingMsg": "Nalagam ...",
    "gui.playbackStep.saveMsg": "Shrani",
    "gui.playbackStep.reRecordMsg": "Ponovno posnemi",
    "gui.recordModal.title": "Posnemi zvok",
    "gui.recordingStep.beginRecord": "Zaženi snemanje s klikom na spodnji gumb",
    "gui.recordingStep.permission": "{arrow}Potrebujemo dovoljenje za uporabo tvojega mikrofona",
    "gui.recordingStep.stop": "Ustavi snemanje",
    "gui.recordingStep.record": "Snemaj",
    "gui.sliderModal.min": "Najmanjša vrednost",
    "gui.sliderModal.max": "Največja vrednost",
    "gui.sliderModal.title": "Spremeni območje drsnika",
    "gui.sliderPrompt.cancel": "Prekliči",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Zvok",
    "gui.soundEditor.play": "Predvajaj",
    "gui.soundEditor.stop": "Ustavi",
    "gui.soundEditor.copy": "Kopiraj",
    "gui.soundEditor.paste": "Prilepi",
    "gui.soundEditor.copyToNew": "Kopiraj v novo",
    "gui.soundEditor.delete": "Izbriši",
    "gui.soundEditor.save": "Shrani",
    "gui.soundEditor.undo": "Razveljavi",
    "gui.soundEditor.redo": "Uveljavi",
    "gui.soundEditor.faster": "Hitreje",
    "gui.soundEditor.slower": "Počasneje",
    "gui.soundEditor.echo": "Odmev",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Glasneje",
    "gui.soundEditor.softer": "Mehkeje",
    "gui.soundEditor.reverse": "Obrni",
    "gui.soundEditor.fadeOut": "Znižuj glasnost",
    "gui.soundEditor.fadeIn": "Zvišuj glasnost",
    "gui.soundEditor.mute": "Utišaj",
    "gui.SpriteInfo.spritePlaceholder": "Ime",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Figura",
    "gui.SpriteInfo.show": "Pokaži",
    "gui.SpriteInfo.size": "Velikost",
    "gui.spriteSelectorItem.contextMenuDuplicate": "podvoji",
    "gui.spriteSelectorItem.contextMenuExport": "izvozi",
    "gui.spriteSelectorItem.contextMenuDelete": "zbriši",
    "gui.spriteSelector.addSpriteFromLibrary": "Izberi figuro",
    "gui.spriteSelector.addSpriteFromPaint": "Nariši",
    "gui.spriteSelector.addSpriteFromSurprise": "Presenečenje",
    "gui.spriteSelector.addSpriteFromFile": "Naloži figuro",
    "gui.stageHeader.stageSizeLarge": "Preklopi na večji oder",
    "gui.stageHeader.stageSizeSmall": "Preklopi na manjši oder",
    "gui.stageHeader.stageSizeFull": "Vklopi celozaslonski način",
    "gui.stageHeader.stageSizeUnFull": "Izhod iz celozaslonskega načina",
    "gui.stageHeader.fullscreenControl": "Celozaslonski način",
    "gui.spriteSelector.addBackdropFromLibrary": "Izberi ozadje",
    "gui.stageSelector.addBackdropFromPaint": "Paint",
    "gui.stageSelector.addBackdropFromSurprise": "Presenečenje",
    "gui.stageSelector.addBackdropFromFile": "Naloži ozadje",
    "gui.stageSelector.stage": "Oder",
    "gui.stageSelector.backdrops": "Ozadja",
    "gui.telemetryOptIn.label": "Sporoči statistiko, da pomagaš izboljšati Scratch",
    "gui.telemetryOptIn.body1": "Ekipa Scratch ves čas poskuša bolje razumeti, kako se Scratch uporablja širom sveta. K tem prizadevanjem lahko pripomoreš tako, da Scratchu dovoliš, da samodejno pošilja podatke o uporabi. ",
    "gui.telemetryOptIn.body2": "Informacije, ki jih zbiramo,  vsebujejo izbiro jezika, uporabo blokov in določene akcije, kot so shranjevanje, nalaganje in prenos projektov na splet. NE ZBIRAMO nobenih osebnih podatkov. Prosimo, oglej si povezavo {privacyPolicyLink} za več informacij.",
    "gui.telemetryOptIn.privacyPolicyLink": "Politika zasebnosti",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo način",
    "gui.webglModal.label": "Tvoj brskalnik ne podpira WebGL",
    "gui.webglModal.description": "Videti je, da tvoj brskalnik žal ne podpira {webGlLink}. Ta tehnologija je nujna, da Scratch 3.0 deluje.",
    "gui.webglModal.webgllink": "ne podpira WebGL",
    "gui.webglModal.back": "Nazaj",
    "gui.webglModal.previewfaq": "Da izveš več, pojdi na {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Pogosta vprašanja",
    "gui.costumeLibrary.chooseABackdrop": "Izberi ozadje",
    "gui.costumeLibrary.chooseACostume": "Izberi videz",
    "gui.costumeTab.addBackdropFromLibrary": "Izberi ozadje",
    "gui.costumeTab.addCostumeFromLibrary": "Izberi videz",
    "gui.costumeTab.addBlankCostume": "Nariši",
    "gui.costumeTab.addSurpriseCostume": "Presenečenje",
    "gui.costumeTab.addFileBackdrop": "Naloži ozadje",
    "gui.costumeTab.addFileCostume": "Naloži videz",
    "gui.extensionLibrary.chooseAnExtension": "Izberi razširitev",
    "gui.extensionLibrary.extensionUrl": "Dodaj URL naslov razširitve",
    "gui.monitors.importListColumnPrompt": "Kateri stolpec naj bo uporabljen (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ni bilo mogoče snemati",
    "gui.soundLibrary.chooseASound": "Izberi zvok",
    "gui.soundTab.fileUploadSound": "Naloži zvočni posnetek...",
    "gui.soundTab.surpriseSound": "Presenečenje",
    "gui.soundTab.recordSound": "Snemaj",
    "gui.soundTab.addSoundFromLibrary": "Izberi zvok",
    "gui.spriteLibrary.chooseASprite": "Izberi figuro",
    "gui.tipsLibrary.tutorials": "Izberi vadnico.",
    "gui.alerts.createsuccess": "Nov projekt je ustvarjen.",
    "gui.alerts.createcopysuccess": "Projekt je shranjen kot kopija.",
    "gui.alerts.createremixsuccess": "Projekt shranjen kot predelava.",
    "gui.alerts.creating": "Ustvarjanje novega...",
    "gui.alerts.creatingCopy": "Kopiram projekt...",
    "gui.alerts.creatingRemix": "Predelujem projekt...",
    "gui.alerts.creatingError": "Projekta ni bilo možno ustvariti. Prosim, poskusite ponovno!",
    "gui.alerts.savingError": "Nismo mogli shraniti projekta.",
    "gui.alerts.savesuccess": "Projekt je shranjen.",
    "gui.alerts.saving": "Shranjujem projekt...",
    "gui.alerts.cloudInfo": "Oblačne spremenljivke podpirajo zgolj številke in ne črk ali simbolov. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Nauči se več.",
    "gui.alerts.importing": "Uvažam...",
    "gui.defaultProject.meow": "Mijav",
    "gui.defaultProject.variable": "moja spremenljivka",
    "gui.howtos.intro-move-sayhello-hat.name": "Prvi koraki",
    "gui.howtos.intro-move.step_stepMove": "Dodaj blok za premik",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animiraj ime",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Izberi figuro uge črke",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Ob kliku predvajaj zvok",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Izberi figuro druge črko",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Spremeni barvo",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Izberi drugo črko in povzroči, da se zavrti",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Izberi drugo črko in povzroči, da se poveča",
    "gui.howtos.imagine": "Predstavljaj si svet",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Vtipkaj, kar želiš reči",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Za začetek klikni na zeleno zastavico",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Izberi katerokoli ozadje",
    "gui.howtos.imagine.step_imagineChooseSprite": "Izberi katerokoli figuro",
    "gui.howtos.imagine.step_imagineFlyAround": "Pritisni presledek za drsenje",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Izberi drugo figuro",
    "gui.howtos.imagine.step_imagineLeftRight": "Premakni levo ali desno",
    "gui.howtos.imagine.step_imagineUpDown": "Premakni gor ali dol",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Spremeni kostume",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Pridrsaj do točke",
    "gui.howtos.imagine.step_imagineGrowShrink": "Povečaj in zmanjšaj",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Izberi drugo ozadje",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Zamenjaj ozadja",
    "gui.howtos.imagine.step_imagineRecordASound": "Dodaj zvok",
    "gui.howtos.imagine.step_imagineChooseSound": "Izberi svoj zvok",
    "gui.howtos.make-music.name": "Ustvari glasbo",
    "gui.howtos.Make-Music.step_PickInstrument": "Izberi figuro glasbila",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Ob kliku predvajaj zvok",
    "gui.howtos.Make-Music.step_MakeSong": "Ustvari pesem",
    "gui.howtos.make-music.step_MakeBeat": "Izberi boben in udari po njem",
    "gui.howtos.make-music.step_MakeBeatBox": "Izberi figuro Mikrofon & Beatbox presenečenja",
    "gui.howtos.story.name": "Ustvari zgodbo",
    "gui.howtos.story.step_addbg": "Dodaj ozadje",
    "gui.howtos.story.step_addsprite": "Dodaj figuro",
    "gui.howtos.story.step_saysomething": "Reci kaj",
    "gui.howtos.story.step_addanothersprite": "Dodaj še en lik",
    "gui.howtos.story.step_flip": "Obrni smer",
    "gui.howtos.story.step_conversation": "Pogovarjaj se",
    "gui.howtos.story.addanotherbg": "Dodaj ozadje",
    "gui.howtos.story.step_swithbg": "Zamenjaj ozadja",
    "gui.howtos.story.step_hidewizard": "Skrij figuro",
    "gui.howtos.story.step_showwizard": "Pokaži figuro",
    "gui.howtos.make-a-chase-game.name": "Ustvari Igro lovljenja",
    "gui.howtos.Chase-Game.step_BG": "Dodaj ozadje",
    "gui.howtos.chase-game.step_AddOcto": "Dodaj figuro",
    "gui.howtos.make-music.step_LeftRight": "Premikaj levo in desno s smernimi puščicami ",
    "gui.howtos.Chase-Game.step_UpDown": "S smernima puščicama se premikaj gor in dol",
    "gui.howtos.Chase-Game.step_AddStar": "Dodaj naslednjo figuro",
    "gui.howtos.Chase-Game.step_MoveRandom": "Premikaj naključno",
    "gui.howtos.Chase-Game.step_WhenTouch": "Pri figuri Hobotnice, ko se jo dotakne, predvajaj zvok",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Ustvari spremenljivko za rezultat",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Pri figuri Hobotnice, ko se jo dotakne, dodaj rezultat",
    "gui.howtos.animate-char.name": "Animiraj figuro",
    "gui.howtos.animate-char.step_addbg": "Dodaj ozadje",
    "gui.howtos.animate-char.step_addsprite": "Dodaj figuro",
    "gui.howtos.animate-char.step_saysomething": "Reci kaj",
    "gui.howtos.animate-char.step_addsound": "Dodaj zvok",
    "gui.howtos.animate-char.step_animatetalking": "Animiraj pogovor",
    "gui.howtos.animate-char.step_arrowkeys": "Premikaj se s smernimi puščicami",
    "gui.howtos.animate-char.step_jump": "Skoči",
    "gui.howtos.animate-char.step_changecolor": "Spremeni barvo",
    "gui.howtos.make-a-game.name": "Ustvari Igro klikanja",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Izberi figuro",
    "gui.howtos.make-a-game.step_GamePlaySound": "Ob kliku predvajaj zvok",
    "gui.howtos.make-a-game.step_GameAddScore": "Ustvari spremenljivko za rezultat",
    "gui.howtos.make-a-game.step_GameChangeScore": "Ob kliku povečaj število točk",
    "gui.howtos.make-a-game.step_Random": "Pojdi na naključno mesto",
    "gui.howtos.make-music.step_GameChangeColor": "Spremeni barvo",
    "gui.howtos.make-music.step_ResetScore": "Ponastavi rezultat",
    "gui.howtos.make-it-fly.name": "Naj leti",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Izberi nebo za ozadje",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Izberi lik",
    "gui.howtos.fly.step_stepflySaySomething": "Reci kaj",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Premikaj se s smernimi puščicami",
    "gui.howtos.fly.step_stepflyChooseObject": "Izberi predmet za zbiranje",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Naj se objekt premakne",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Izberi svoj lik",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Dodaj točke",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Štej točke",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Dodaj sceno",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Premakni sceno",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Naslednji kostum",
    "gui.howtos.pong": "Igra Pong",
    "gui.howtos.pong.step_pongAddBackdrop": "Dodaj ozadje",
    "gui.howtos.pong.step_pongAddBallSprite": "Dodaj figuro žoge",
    "gui.howtos.pong.step_pongBounceAround": "Odbijaj se naokrog",
    "gui.howtos.pong.step_pongAddPaddle": "Dodaj lopar",
    "gui.howtos.pong.step_pongMoveThePaddle": "Premakni lopar",
    "gui.howtos.pong.step_pongSelectBallSprite": "Izberi figuro žoge",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Dodaj kodo, da se bo žoga odbila od loparja",
    "gui.howtos.pong.step_pongAddAScore": "Dodaj točke",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Izberi 'točke' v meniju",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Vstavi blok 'spremeni točke'",
    "gui.howtos.pong.step_pongResetScore": "Ponastavi rezultat",
    "gui.howtos.pong.step_pongAddLineSprite": "Dodaj figuro črte",
    "gui.howtos.pong.step_pongGameOver": "Konec igre",
    "gui.howtos.code-cartoon": "Programiraj risanko",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Reci kaj, ko klikneš na zeleno zastavo",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animiraj lik, ko klikneš nanj",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Izberi drug lik",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Uporabi znak minus za pomanjšanje",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Naredi, da se bo lik večal in manjšal",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Izberi drug lik",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Skači gor in dol",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klikni na lik, da zamenjaš sceno",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Drsi naokrog",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Spremeni kostume",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Izberi več likov za tvojo risanko",
    "gui.howtos.cartoon-network": "Animiraj pustolovsko igro",
    "gui.howtos.cartoon-network.step_CNcharacter": "Izberi lik za prikaz",
    "gui.howtos.cartoon-network.step_CNsay": "Reci kaj",
    "gui.howtos.cartoon-network.step_CNglide": "Drsi",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Izberi lik za lovljenje",
    "gui.howtos.cartoon-network.step_CNcollect": "Zbiraj predmete",
    "gui.howtos.cartoon-network.step_CNvariable": "Ustvari spremenljivko za rezultat",
    "gui.howtos.cartoon-network.step_CNscore": "Štej točke",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Naslednja stopnja: Spremeni ozadje",
    "gui.howtos.videosens.name": "Video zaznavanje",
    "gui.howtos.videosens.step_addextension": "Dodaj razširitev",
    "gui.howtos.videosens.step_pet": "Mačka Tačka",
    "gui.howtos.videosens.step_animate": "Animiraj",
    "gui.howtos.videosens.step_pop": "Poči balon",
    "gui.howtos.say-it-out-loud": "Ustvari govoreče živali",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Dodaj blok za pretvorbo besedila v govor",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Reci kaj",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Nastavi glas",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Premikaj okoli",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Dodaj ozadje",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Dodaj še en lik",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Izvedi pesem",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Spremeni barvo",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Zavrti okoli",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Povečaj in zmanjšaj",
    "gui.howtos.talking": "Govoreče pripovedi",
    "gui.howtos.talking.step_talesAddExtension": "Klikni za dodajo Besedilo-v-govor blokov",
    "gui.howtos.talking.step_talesChooseSprite": "Izberi figuro",
    "gui.howtos.talking.step_talesSaySomething": "Naj tvoj lik spregovori",
    "gui.howtos.talking.step_talesChooseBackdrop": "Izberi ozadje",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klikni na lik, da gre na naslednje ozadje",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Izberi drugo figuro",
    "gui.howtos.talking.step_talesMoveAround": "Premikaj se naokrog",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Izberi drugo ozadje",
    "gui.howtos.talking.step_talesAnimateTalking": "Animiraj pogovor",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Izberi drugo ozadje",
    "gui.howtos.talking.step_talesChooseSound": "Izberi skladbo za ples",
    "gui.howtos.talking.step_talesDanceMoves": "Plesni gibi",
    "gui.howtos.talking.step_talesAskAnswer": "Pridobi vprašaj in odgovori bloke iz zaznavne kategorije",
    "gui.howtos.add-sprite.name": "Dodaj figuro",
    "gui.howtos.add-sprite.step_addSprite": "Dodaj figuro",
    "gui.howtos.add-a-backdrop.name": "Dodaj ozadje",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Dodaj ozadje",
    "gui.howtos.change-size.name": "Spremeni velikost",
    "gui.howtos.change-size.step_changeSize": "Spremeni velikost",
    "gui.howtos.glide-around.name": "Drsi",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Drsi naokrog",
    "gui.howtos.change-size.step_glideAroundPoint": "Drsi do točke",
    "gui.howtos.record-a-sound.name": "Posnami zvok",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klikni na zavihek 'Zvoki'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klikni 'Snemaj'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Pritisni gumb za snemanje",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Izberi svoj zvok",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Predvajaj svoj zvok",
    "gui.howtos.spin-video.name": "Naj se vrti",
    "gui.howtos.change-size.step_spinTurn": "Obrni",
    "gui.howtos.change-size.step_spinPointInDirection": "Nastavi smer",
    "gui.howtos.hide-and-show.name": "Skrij in pokaži",
    "gui.howtos.change-size.step_hideAndShow": "Skrij in pokaži",
    "gui.howtos.switch-costume.name": "Animiraj figuro",
    "gui.howtos.change-size.step_switchCostumes": "Animiraj figuro",
    "gui.howtos.move-around-with-arrow-keys.name": "Uporabi smerne puščice",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Premakni levo in desno",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Premakni gor in dol",
    "gui.howtos.add-effects.name": "Dodaj učinke",
    "gui.howtos.videosens.step_addEffects": "Dodaj učinke",
    "gui.extension.music.name": "Glasba",
    "gui.extension.music.description": "Igraj glasbila.",
    "gui.extension.pen.name": "Svinčnik",
    "gui.extension.pen.description": "Riši s figurami.",
    "gui.extension.videosensing.name": "Video zaznavanje",
    "gui.extension.videosensing.description": "Nadzor gibanja s kamero",
    "gui.extension.text2speech.name": "Besedilo v govor",
    "gui.extension.text2speech.description": "Naj tvoji projekti spregovorijo.",
    "gui.extension.translate.name": "Prevedi",
    "gui.extension.translate.description": "Prevedi v različne jezike.",
    "gui.extension.makeymakey.description": "Poljubno stvar spremeni v tipko.",
    "gui.extension.microbit.description": "Poveži svoje projekte s svetom.",
    "gui.extension.microbit.connectingMessage": "Povezovanje",
    "gui.extension.ev3.description": "Ustvari interaktivne robote in ... .",
    "gui.extension.ev3.connectingMessage": "Povezovanje. preveri, da je pin na EV3 nastavljen na 1234.",
    "gui.extension.boost.description": "Oživi robotske kreacije.",
    "gui.extension.boost.connectingMessage": "Povezovanje",
    "gui.extension.wedo2.description": "Gradi z motorji in senzorji.",
    "gui.extension.wedo2.connectingMessage": "Povezovanje",
    "gui.extension.gdxfor.description": "Zaznaj poriv, povlakm gibanje in vrtenje.",
    "gui.extension.gdxfor.connectingMessage": "Povezovanje",
    "gui.libraryTags.all": "Vse",
    "gui.libraryTags.animals": "Živali",
    "gui.libraryTags.dance": "Pleši",
    "gui.libraryTags.effects": "Učinki",
    "gui.libraryTags.fantasy": "Domišljija",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Hrana",
    "gui.libraryTags.indoors": "Notranjost",
    "gui.libraryTags.loops": "Zanke",
    "gui.libraryTags.music": "Glasba",
    "gui.libraryTags.notes": "Zapiski",
    "gui.libraryTags.outdoors": "Zunanjost",
    "gui.libraryTags.patterns": "Vzorci",
    "gui.libraryTags.people": "Osebe",
    "gui.libraryTags.percussion": "Tolkala",
    "gui.libraryTags.space": "Vesolje",
    "gui.libraryTags.sports": "Šport",
    "gui.libraryTags.underwater": "Pod vodo",
    "gui.libraryTags.voice": "Glas",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animacije",
    "gui.libraryTags.art": "Umetnost",
    "gui.libraryTags.games": "Igre",
    "gui.libraryTags.stories": "Zgodbe",
    "gui.libraryTags.letters": "Črke",
    "gui.opcodeLabels.direction": "smer",
    "gui.opcodeLabels.xposition": "položaj x",
    "gui.opcodeLabels.yposition": "položaj y",
    "gui.opcodeLabels.size": "velikost",
    "gui.opcodeLabels.costumename": "ime videza",
    "gui.opcodeLabels.costumenumber": "številka preobleke",
    "gui.opcodeLabels.backdropname": "ime ozadja",
    "gui.opcodeLabels.backdropnumber": "številka ozadja",
    "gui.opcodeLabels.volume": "glasnost",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "odgovor",
    "gui.opcodeLabels.loudness": "glasnost",
    "gui.opcodeLabels.username": "uporabniško ime",
    "gui.opcodeLabels.year": "leto",
    "gui.opcodeLabels.month": "mesec",
    "gui.opcodeLabels.date": "datum",
    "gui.opcodeLabels.dayofweek": "dan v tednu",
    "gui.opcodeLabels.hour": "ura",
    "gui.opcodeLabels.minute": "minuta",
    "gui.opcodeLabels.second": "sekunda",
    "gui.opcodeLabels.timer": "štoparica",
    "gui.projectLoader.loadError": "Izbrana projektna datoteka se ni naložila.",
    "gui.sharedMessages.backdrop": "ozadje{index}",
    "gui.sharedMessages.costume": "preobleka{index}",
    "gui.sharedMessages.sprite": "Lik{index}",
    "gui.sharedMessages.pop": "poberi",
    "gui.sharedMessages.replaceProjectWarning": "Ali zamenjam vsebino trenutnega projekta?",
    "gui.sharedMessages.loadFromComputerTitle": "Naloži z računalnika",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch projekt",
    "boost.color.any": "poljubna barva",
    "boost.color.black": "črna",
    "boost.color.blue": "modra",
    "boost.color.green": "zelena",
    "boost.color.red": "rdeča",
    "boost.color.white": "bela",
    "boost.color.yellow": "rumena",
    "boost.getMotorPosition": "položaj motorja [MOTOR_REPORTER_ID] ",
    "boost.getTiltAngle": "kot nagiba [TILT_DIRECTION]",
    "boost.motorDirection.backward": "v tisto smer",
    "boost.motorDirection.forward": "v to smer",
    "boost.motorDirection.reverse": "obratno",
    "boost.motorOff": "izklopi motor [MOTOR_ID] ",
    "boost.motorOn": "vklopi motor [MOTOR_ID] ",
    "boost.motorOnFor": "vklopi [MOTOR_ID] za [DURATION] sekund",
    "boost.motorOnForRotation": "vklopi motor [MOTOR_ID] za [ROTATION] obratov",
    "boost.seeingColor": "vidiš kocko, ki je [COLOR] ?",
    "boost.setLightHue": "nastavi barvo svetlobe na [HUE]",
    "boost.setMotorDirection": "nastavi smer motorja [MOTOR_ID] na [MOTOR_DIRECTION]",
    "boost.setMotorPower": "motorju [MOTOR_ID] nastavi moč na [POWER] %",
    "boost.tiltDirection.any": "poljubna",
    "boost.tiltDirection.down": "dol",
    "boost.tiltDirection.left": "levo",
    "boost.tiltDirection.right": "desno",
    "boost.tiltDirection.up": "gor",
    "boost.whenColor": "ko vidiš kocko, ki je [COLOR]",
    "boost.whenTilted": "ko je nagnjen [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "zapiskaj noto [NOTE] za [TIME] sekund",
    "ev3.buttonPressed": "je gumb na [PORT] pritisnjen?",
    "ev3.getBrightness": "svetlost",
    "ev3.getDistance": "razdalja",
    "ev3.getMotorPosition": "položaj motorja na [PORT]",
    "ev3.motorSetPower": "motorju na [PORT] nastavi moč na [POWER] %",
    "ev3.motorTurnClockwise": "motor na [PORT] obrni v smeri ure  [TIME] sekund",
    "ev3.motorTurnCounterClockwise": "motor [PORT]obrni v nasprotni smeri ure za  [TIME] sekund",
    "ev3.whenBrightnessLessThan": "ko je svetlost < [DISTANCE]",
    "ev3.whenButtonPressed": "ko je gumb na [PORT] pritisnjen",
    "ev3.whenDistanceLessThan": "ko je razdalja < [DISTANCE]",
    "gdxfor.getAcceleration": "pospešek [DIRECTION]",
    "gdxfor.getForce": "moč",
    "gdxfor.getSpin": "hitrost vrtenja [DIRECTION]",
    "gdxfor.getTilt": "kot nagiba [TILT]",
    "gdxfor.isFreeFalling": "padajoč?",
    "gdxfor.isTilted": "nagnjeno [TILT]?",
    "gdxfor.pulled": "potegnjen",
    "gdxfor.pushed": "potisnjen",
    "gdxfor.shaken": "streseno",
    "gdxfor.startedFalling": "začetek padanja",
    "gdxfor.tiltDirectionMenu.any": "poljubna",
    "gdxfor.tiltDirectionMenu.back": "zadaj",
    "gdxfor.tiltDirectionMenu.front": "spredaj",
    "gdxfor.tiltDirectionMenu.left": "levo",
    "gdxfor.tiltDirectionMenu.right": "desno",
    "gdxfor.turnedFaceDown": "obrnjen navzdol",
    "gdxfor.turnedFaceUp": "obrnjen navzgor",
    "gdxfor.whenForcePushedOrPulled": "ko je senzor sile [PUSH_PULL]",
    "gdxfor.whenGesture": "ko je [GESTURE]",
    "gdxfor.whenTilted": "ko je nagnjeno [TILT]",
    "makeymakey.downArrow": "puščica dol",
    "makeymakey.downArrowShort": "dol",
    "makeymakey.leftArrow": "puščica levo",
    "makeymakey.leftArrowShort": "levo",
    "makeymakey.rightArrow": "puščica desno",
    "makeymakey.rightArrowShort": "desno",
    "makeymakey.spaceKey": "presledek",
    "makeymakey.upArrow": "puščica gor",
    "makeymakey.upArrowShort": "gor",
    "makeymakey.whenKeyPressed": "ko je pritisnjena tipka [KEY] ",
    "makeymakey.whenKeysPressedInOrder": "ko so tipke [SEQUENCE] pritisnjene v določenem vrstnem redu",
    "microbit.buttonsMenu.any": "poljubna",
    "microbit.clearDisplay": "pobriši prikazovalnik",
    "microbit.defaultTextToDisplay": "Živjo!",
    "microbit.displaySymbol": "prikaži [MATRIX]",
    "microbit.displayText": "prikaži besedilo [TEXT]",
    "microbit.gesturesMenu.jumped": "poskok",
    "microbit.gesturesMenu.moved": "premaknjeno",
    "microbit.gesturesMenu.shaken": "streseno",
    "microbit.isButtonPressed": "[BTN] gumb pritisnjen?",
    "microbit.isTilted": "nagnjeno [DIRECTION]?",
    "microbit.pinStateMenu.off": "izključi",
    "microbit.pinStateMenu.on": "vključi",
    "microbit.tiltAngle": "kot nagiba [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "poljubna",
    "microbit.tiltDirectionMenu.back": "zadaj",
    "microbit.tiltDirectionMenu.front": "spredaj",
    "microbit.tiltDirectionMenu.left": "levo",
    "microbit.tiltDirectionMenu.right": "desno",
    "microbit.whenButtonPressed": "ko je gumb [BTN]pritisnjen",
    "microbit.whenGesture": "ko je [GESTURE]",
    "microbit.whenPinConnected": "ko je pin [PIN] povezan",
    "microbit.whenTilted": "ko je nagnjen [DIRECTION]",
    "music.categoryName": "Glasba",
    "music.changeTempo": "spremeni tempo za [TEMPO]",
    "music.drumBass": "(2) Veliki boben",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Ropotulja kabasa",
    "music.drumClaves": "(9) Palčke claves",
    "music.drumClosedHiHat": "(6) zaprte činele",
    "music.drumConga": "(14) Konga bobni",
    "music.drumCowbell": "(11) Kravji zvonec",
    "music.drumCrashCymbal": "(4) Crash činela",
    "music.drumCuica": "(18) Boben Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Plosk",
    "music.drumOpenHiHat": "(5) Enojna činela",
    "music.drumSideStick": "(3) zvok Side Stick",
    "music.drumSnare": "(1) Mali boben",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Udarec na vibrafon",
    "music.drumWoodBlock": "(10) Leseni blok",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) fagot",
    "music.instrumentCello": "(8) Čelo",
    "music.instrumentChoir": "(15) Zbor",
    "music.instrumentClarinet": "(10) Klarinet",
    "music.instrumentElectricGuitar": "(5) Električna kitara",
    "music.instrumentElectricPiano": "(2) Električni klavir",
    "music.instrumentFlute": "(12) Piščal",
    "music.instrumentGuitar": "(4) Kitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Lajna",
    "music.instrumentOrgan": "(3) Orgle",
    "music.instrumentPiano": "(1) Klavir",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saksofon",
    "music.instrumentSteelDrum": "(18) Kovinski boben",
    "music.instrumentSynthLead": "(20) sintetizator - vodilni zvok",
    "music.instrumentSynthPad": "(21) Sintesajzer",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) lesena piščal",
    "music.midiPlayDrumForBeats": "na bobnu [DRUM] zaigraj [BEATS] udarcev",
    "music.midiSetInstrument": "nastavi inštrument na [INSTRUMENT]",
    "music.playDrumForBeats": "zaigraj na boben [DRUM] za [BEATS] udarcev",
    "music.playNoteForBeats": "predvajaj noto [NOTE] za[BEATS] udarce",
    "music.restForBeats": "pavza za [BEATS] udarcev",
    "music.setInstrument": "nastavi inštrument na [INSTRUMENT]",
    "music.setTempo": "nastavi tempo na [TEMPO]",
    "pen.categoryName": "Svinčnik",
    "pen.changeColorParam": "spremeni pero [COLOR_PARAM] za [VALUE]",
    "pen.changeHue": "spremeni barvo peresa za [HUE]",
    "pen.changeShade": "spremeni senco peresa za [SHADE]",
    "pen.changeSize": "spremeni velikost peresa za [SIZE]",
    "pen.clear": "izbriši vse",
    "pen.colorMenu.brightness": "svetlost",
    "pen.colorMenu.color": "barva",
    "pen.colorMenu.saturation": "nasičenost",
    "pen.colorMenu.transparency": "prosojnost",
    "pen.penDown": "spusti pero",
    "pen.penUp": "dvigni pero",
    "pen.setColor": "nastavi barvo peresa na [COLOR]",
    "pen.setColorParam": "nastavi pero [COLOR_PARAM] na [VALUE]",
    "pen.setHue": "nastavi barvo peresa na [HUE]",
    "pen.setShade": "nastavi senco peresa na [SHADE]",
    "pen.setSize": "nastavi velikost peresa na [SIZE]",
    "pen.stamp": "žig",
    "speech.defaultWhenIHearValue": "začnimo",
    "speech.extensionName": "Govor v besedilo",
    "speech.listenAndWait": "poslušaj in čakaj",
    "speech.speechReporter": "govor",
    "speech.whenIHear": "ko slišim [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "besedilo v govor",
    "text2speech.defaultTextToSpeak": "Zdravo",
    "text2speech.giant": "velikan",
    "text2speech.kitten": "mucek",
    "text2speech.setLanguageBlock": "nastavi jezik na [LANGUAGE]",
    "text2speech.setVoiceBlock": "nastavi glas na [VOICE]",
    "text2speech.speakAndWaitBlock": "reci [WORDS]",
    "text2speech.squeak": "cviljenje",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Prevedi",
    "translate.defaultTextToTranslate": "Zdravo",
    "translate.translateBlock": "prevedi [WORDS] v [LANGUAGE]",
    "translate.viewerLanguage": "jezik",
    "videoSensing.categoryName": "Video zaznavanje",
    "videoSensing.direction": "smer",
    "videoSensing.motion": "gibanje",
    "videoSensing.off": "izključi",
    "videoSensing.on": "vključi",
    "videoSensing.onFlipped": "vključeno zrcaljenje",
    "videoSensing.setVideoTransparency": "nastavi prosojnost videa na [TRANSPARENCY]",
    "videoSensing.sprite": "figura",
    "videoSensing.stage": "oder",
    "videoSensing.videoOn": "video [ATTRIBUTE] pri [SUBJECT]",
    "videoSensing.videoToggle": "nastavi video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "ko je video premik > [REFERENCE]",
    "wedo2.getDistance": "razdalja",
    "wedo2.getTiltAngle": "kot nagiba [TILT_DIRECTION]",
    "wedo2.isTilted": "nagnjen [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "v tisto smer",
    "wedo2.motorDirection.forward": "v to smer",
    "wedo2.motorDirection.reverse": "obratno",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "vsi motorji",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "izključi [MOTOR_ID] ",
    "wedo2.motorOn": "vključi [MOTOR_ID] ",
    "wedo2.motorOnFor": "vključi [MOTOR_ID]za [DURATION] sekund",
    "wedo2.playNoteFor": "predvajaj noto [NOTE] za [DURATION] sekund",
    "wedo2.setLightHue": "snastavi barvo svetlobe na [HUE]",
    "wedo2.setMotorDirection": "nastavi smer [MOTOR_ID] na [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "za [MOTOR_ID] nastavi moč na [POWER]",
    "wedo2.tiltDirection.any": "poljubna",
    "wedo2.tiltDirection.down": "dol",
    "wedo2.tiltDirection.left": "levo",
    "wedo2.tiltDirection.right": "desno",
    "wedo2.tiltDirection.up": "gor",
    "wedo2.whenDistance": "ko je razdalja [OP] [REFERENCE]",
    "wedo2.whenTilted": "ko je nagnjen [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Barva",
    "paint.paintEditor.saturation": "nasičenost",
    "paint.paintEditor.brightness": "Svetlost",
    "paint.paintEditor.costume": "Videz",
    "paint.paintEditor.group": "Združi",
    "paint.paintEditor.ungroup": "Razdruži",
    "paint.paintEditor.undo": "Razveljavi",
    "paint.paintEditor.redo": "Uveljavi",
    "paint.paintEditor.forward": "naprej",
    "paint.paintEditor.backward": "nazaj",
    "paint.paintEditor.front": "Spredaj",
    "paint.paintEditor.back": "Nazaj",
    "paint.paintEditor.more": "Več",
    "paint.modeTools.brushSize": "Velikost",
    "paint.modeTools.eraserSize": "Širina radirke",
    "paint.modeTools.copy": "Kopiraj",
    "paint.modeTools.paste": "prilepi",
    "paint.modeTools.delete": "Izbriši",
    "paint.modeTools.curved": "Zaobljeno",
    "paint.modeTools.pointed": "Točkovno",
    "paint.modeTools.thickness": "debelina",
    "paint.modeTools.flipHorizontal": "Obrni vodoravno",
    "paint.modeTools.flipVertical": "Obrni navpično",
    "paint.modeTools.filled": "polnitev",
    "paint.modeTools.outlined": "očrtano",
    "paint.paintEditor.bitmap": "Pretvori v bitno sliko",
    "paint.paintEditor.vector": "Pretvori v vektorsko sliko",
    "paint.paintEditor.fill": "Zapolni",
    "paint.paintEditor.stroke": "Obroba",
    "paint.brushMode.brush": "Čopič",
    "paint.eraserMode.eraser": "Radirka",
    "paint.fillMode.fill": "Zapolni",
    "paint.lineMode.line": "Črta",
    "paint.ovalMode.oval": "Krog",
    "paint.rectMode.rect": "Pravokotnik",
    "paint.reshapeMode.reshape": "Preoblikuj",
    "paint.roundedRectMode.roundedRect": "Zaokrožen pravokotnik",
    "paint.selectMode.select": "Izberi",
    "paint.textMode.text": "Besedilo",
    "paint.colorPicker.swap": "zamenjaj"
  },
  "sr": {
    "gui.alerts.lostPeripheralConnection": "Скрач је изгубио везу ка {extensionName}.",
    "gui.alerts.tryAgain": "Покушај поново",
    "gui.alerts.download": "Преузми",
    "gui.connection.reconnect": "Поновно повезивање",
    "gui.backpack.costumeLabel": "костим",
    "gui.backpack.soundLabel": "звук",
    "gui.backpack.scriptLabel": "програм",
    "gui.backpack.spriteLabel": "лик",
    "gui.backpack.header": "Остава",
    "gui.backpack.errorBackpack": "Грешка при учитавању оставе",
    "gui.backpack.loadingBackpack": "Учитавање...",
    "gui.backpack.more": "Више",
    "gui.backpack.emptyBackpack": "Остава је празна",
    "gui.unsupportedBrowser.label": "Прегледач интернета није подржан",
    "gui.unsupportedBrowser.errorLabel": "Појавила се грешка",
    "gui.unsupportedBrowser.notRecommended": "Јако нам је жао, али изгледа да користиш верзију прегледача интернета коју Скрач не подржава. Препоручујемо да извршиш ажурирање тако да користиш последњу верзију подржаних прегледача као што су  Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.description": "Јако нам је жао, али Скрач не подржава овај прегледач интернета. Препоручујемо да извршиш ажурирање тако да користиш последњу верзију подржаних прегледача као што су Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "Да сазнаш више, иди на  {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Најчешћа питања",
    "gui.cards.all-tutorials": "Приручници",
    "gui.cards.shrink": "Умањи",
    "gui.cards.expand": "Увећај",
    "gui.cards.close": "Затвори",
    "gui.cards.more-things-to-try": "Више ствари за испробавање!",
    "gui.cards.see-more": "Погледај више",
    "gui.comingSoon.message1": "Не брини, радимо на томе  {emoji}",
    "gui.comingSoon.message2": "Очекуј убрзо",
    "gui.comingSoon.message3": "Тренутно радимо на томе {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Нема уређаја",
    "gui.connection.auto-scanning.prescan": "Постави свој уређај близу, затим почни са претраживањем.",
    "gui.connection.auto-scanning.pressbutton": "Притисни дугме на свом уређају.",
    "gui.connection.auto-scanning.start-search": "Почни претраживање",
    "gui.connection.connecting-searchbutton": "Претражујем...",
    "gui.connection.auto-scanning.try-again": "Пробај поново",
    "gui.connection.auto-scanning.updatePeripheralButton": "Ажурирај мој уређај",
    "gui.connection.connected": "Повезан",
    "gui.connection.disconnect": "Искључи",
    "gui.connection.go-to-editor": "Иди у едитор",
    "gui.connection.connecting-cancelbutton": "Повезивање...",
    "gui.connection.error.errorMessage": "Упс, изгледа да нешто није уреду.",
    "gui.connection.error.tryagainbutton": "Пробај поново",
    "gui.connection.error.helpbutton": "Помоћ",
    "gui.connection.peripheral-name-label": "Име уређаја",
    "gui.connection.connect": "Повежи",
    "gui.connection.scanning.lookingforperipherals": "Тражим уређаје",
    "gui.connection.scanning.noPeripheralsFound": "Нема уређаја",
    "gui.connection.scanning.instructions": "Изабери свој уређај са листе.",
    "gui.connection.search": "Освежи",
    "gui.connection.scanning.updatePeripheralButton": "Ажурирај мој уређај",
    "gui.connection.unavailable.installscratchlink": "Увери се да си инсталирао Скрач везу и да ради",
    "gui.connection.unavailable.enablebluetooth": "Провери де ли је блутут омогућен",
    "gui.connection.unavailable.tryagainbutton": "Пробај поново",
    "gui.connection.unavailable.helpbutton": "Помоћ",
    "gui.connection.updatePeripheral.microBitConnect": "Повежи твој {extensionName} са овим уређајем помоћу УСБ кабла.",
    "gui.connection.updatePeripheral.pressUpdate": "Притисни \"Изврши ажурирање\" и омогући да се ажурирање заврши.",
    "gui.connection.updatePeripheral.progress": "Ажурирам {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Успешно ажурирање!",
    "gui.connection.updatePeripheral.updateFailed": "Ажурирање није успело.",
    "gui.connection.updatePeripheral.goBackButton": "Врати се",
    "gui.connection.updatePeripheral.updateNowButton": "Изврши ажурирање",
    "gui.connection.updatePeripheral.updateAgainButton": "Покушај поново",
    "gui.controls.go": "Крени",
    "gui.controls.stop": "Заустави",
    "gui.crashMessage.label": "Ух! Нешто није у реду.",
    "gui.crashMessage.description": "Жао нам је, али изгледа да је Скреч престао са радом. Овај проблем је аутоматски послат Скреч тиму. Молим те, освежи своју страницу да пробаш поново.",
    "gui.crashMessage.errorNumber": "Твоја грешка је евидентирана под идентификатором {errorId}",
    "gui.crashMessage.reload": "Поново учитај",
    "gui.customProcedures.myblockModalTitle": "Направи блок",
    "gui.customProcedures.addAnInputNumberText": "Додај улаз",
    "gui.customProcedures.numberTextType": "број или текст",
    "gui.customProcedures.addAnInputBoolean": "Додај унос",
    "gui.customProcedures.booleanType": "булов израз",
    "gui.customProcedures.addALabel": "Додај натпис",
    "gui.customProcedures.runWithoutScreenRefresh": "Изврши без освежавања екрана",
    "gui.customProcedures.cancel": "Откажи",
    "gui.customProcedures.ok": "У реду",
    "gui.SpriteInfo.direction": "Смер",
    "gui.directionPicker.rotationStyles.allAround": "На све стране",
    "gui.directionPicker.rotationStyles.leftRight": "Лево/десно",
    "gui.directionPicker.rotationStyles.dontRotate": "Без окретања",
    "gui.gui.addExtension": "Додај проширење",
    "gui.gui.codeTab": "Програм",
    "gui.gui.backdropsTab": "Позадине",
    "gui.gui.costumesTab": "Костими",
    "gui.gui.soundsTab": "Звукови",
    "gui.extensionLibrary.comingSoon": "Очекуј убрзо",
    "gui.extensionLibrary.requires": "Захтева",
    "gui.extensionLibrary.collaboration": "Сарадња са",
    "gui.library.filterPlaceholder": "Тражи",
    "gui.library.allTag": "Сви",
    "gui.loader.message1": "Стварање блокова ...",
    "gui.loader.message2": "Учитавам ликове...",
    "gui.loader.message3": "Учитавам звукове...",
    "gui.loader.message4": "Учитавам проширења...",
    "gui.loader.message5": "Маце у стаду...",
    "gui.loader.message6": "Преносим наное...",
    "gui.loader.message7": "Проширујем гобое...",
    "gui.loader.message8": "Припремам смајлије...",
    "gui.loader.headline": "Учитавам пројекат",
    "gui.loader.creating": "Прављење пројекта",
    "gui.accountMenu.profile": "Профил",
    "gui.accountMenu.myStuff": "Моје ствари",
    "gui.accountMenu.myClasses": "Моја класе",
    "gui.accountMenu.myClass": "Моја класа",
    "gui.accountMenu.accountSettings": "Подешавања налога",
    "gui.accountMenu.signOut": "Одјава",
    "gui.authorInfo.byUser": "по {username}",
    "gui.menuBar.seeProjectPage": "Погледај страну пројекта",
    "gui.menuBar.language": "Језик",
    "general.username": "Име за пријаву",
    "general.password": "Лозинка",
    "general.signIn": "Пријави се",
    "login.needHelp": "Да ли ти је потребна помоћ?",
    "form.validationRequired": "Ово поље је обавезно",
    "gui.menuBar.tutorialsLibrary": "Приручници",
    "gui.menuBar.restoreSprite": "Поврати лик",
    "gui.menuBar.restoreSound": "Поврати звук",
    "gui.menuBar.restoreCostume": "Поврати костим",
    "gui.menuBar.restore": "Поврати",
    "gui.menuBar.saveNow": "Сачувај одмах",
    "gui.menuBar.saveAsCopy": "Сачувај као копију",
    "gui.menuBar.remix": "Преради",
    "gui.menuBar.new": "Ново",
    "gui.menuBar.file": "Датотека",
    "gui.menuBar.downloadToComputer": "Сачувај на свом рачунару",
    "gui.menuBar.edit": "Уреди",
    "gui.menuBar.turboModeOff": "Искључи турбо начин",
    "gui.menuBar.turboModeOn": "Укључи турбо начин",
    "gui.menuBar.modeMenu": "Мод",
    "gui.menuBar.normalMode": "Нормалан мод",
    "gui.menuBar.caturdayMode": "Мачкаст мод",
    "gui.menuBar.joinScratch": "Придужи се Скрачу",
    "gui.menuBar.signIn": "Пријави се",
    "gui.gui.projectTitlePlaceholder": "Наслов пројекта",
    "gui.menuBar.saveNowLink": "Сачувај одмах",
    "gui.menuBar.settings": "Подешавања",
    "gui.menuBar.isShared": "Дељено",
    "gui.menuBar.share": "Објави (дели)",
    "gui.menuBar.colorMode": "Режим боја",
    "gui.modal.help": "Помоћ",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(празно)",
    "gui.monitor.listMonitor.listLength": "дужина {length}",
    "gui.monitor.contextMenu.default": "нормалан приказ",
    "gui.monitor.contextMenu.large": "велики приказ",
    "gui.monitor.contextMenu.slider": "клизач",
    "gui.monitor.contextMenu.sliderRange": "промени опсег клизача",
    "gui.monitor.contextMenu.import": "увези",
    "gui.monitor.contextMenu.export": "извези",
    "gui.monitor.contextMenu.hide": "сакриј",
    "gui.playButton.play": "Репродукуј",
    "gui.playButton.stop": "Заустави",
    "gui.gui.variableScopeOptionAllSprites": "За све ликове",
    "gui.gui.variableScopeOptionSpriteOnly": "Само за овај лик",
    "gui.gui.cloudVariableOption": "Променљива у облаку (чува се на серверу путем интернета)",
    "gui.gui.variablePromptAllSpritesMessage": "Променљива ће да буде доступна свим ликовима.",
    "gui.gui.listPromptAllSpritesMessage": "Ова листа ће бити доступна свим ликовима.",
    "gui.prompt.cancel": "Откажи",
    "gui.prompt.ok": "У реду",
    "gui.playbackStep.stopMsg": "Заустави",
    "gui.playbackStep.playMsg": "Репродукуј",
    "gui.playbackStep.loadingMsg": "Учитавање...",
    "gui.playbackStep.saveMsg": "Сачувај",
    "gui.playbackStep.reRecordMsg": "Поново сними",
    "gui.recordModal.title": "Сними звук",
    "gui.recordingStep.beginRecord": "Почни да снимаш притиснувши дугме испод",
    "gui.recordingStep.permission": "{arrow}Потребна нам је твоја дозвола да би употребили твој микрофон",
    "gui.recordingStep.stop": "Заустави снимање",
    "gui.recordingStep.record": "Сними",
    "gui.sliderModal.min": "минимална вредност",
    "gui.sliderModal.max": "максимална вредност",
    "gui.sliderModal.title": "Промени опсег клизача",
    "gui.sliderPrompt.cancel": "Откажи",
    "gui.sliderPrompt.ok": "У реду",
    "gui.soundEditor.sound": "Звук",
    "gui.soundEditor.play": "Репродукуј",
    "gui.soundEditor.stop": "Заустави",
    "gui.soundEditor.copy": "Умножи",
    "gui.soundEditor.paste": "Уметни",
    "gui.soundEditor.copyToNew": "Умножи у нови",
    "gui.soundEditor.delete": "Обриши",
    "gui.soundEditor.save": "Сачувај",
    "gui.soundEditor.undo": "Опозови",
    "gui.soundEditor.redo": "Понови",
    "gui.soundEditor.faster": "Брже",
    "gui.soundEditor.slower": "Спорије",
    "gui.soundEditor.echo": "Одјек",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "Гласније",
    "gui.soundEditor.softer": "Мекше",
    "gui.soundEditor.reverse": "Окрени",
    "gui.soundEditor.fadeOut": "Постепено изблди",
    "gui.soundEditor.fadeIn": "Постепено прикажи",
    "gui.soundEditor.mute": "Искључи звук",
    "gui.SpriteInfo.spritePlaceholder": "Име",
    "gui.SpriteInfo.showSpriteAction": "Прикажи лик",
    "gui.SpriteInfo.hideSpriteAction": "Сакриј лик",
    "gui.SpriteInfo.sprite": "Лик",
    "gui.SpriteInfo.show": "Прикажи",
    "gui.SpriteInfo.size": "Величина",
    "gui.spriteSelectorItem.contextMenuDuplicate": "умножи",
    "gui.spriteSelectorItem.contextMenuExport": "извези",
    "gui.spriteSelectorItem.contextMenuDelete": "обриши",
    "gui.spriteSelector.addSpriteFromLibrary": "Изабери лик",
    "gui.spriteSelector.addSpriteFromPaint": "Насликај",
    "gui.spriteSelector.addSpriteFromSurprise": "Изненађење",
    "gui.spriteSelector.addSpriteFromFile": "Пошаљи лик",
    "gui.stageHeader.stageSizeLarge": "Пребаци на велику сцену",
    "gui.stageHeader.stageSizeSmall": "Пребаци на малу сцену",
    "gui.stageHeader.stageSizeFull": "Уђи у приказ преко целог екрана",
    "gui.stageHeader.stageSizeUnFull": "Изађи из приказа преко целог екрана",
    "gui.stageHeader.fullscreenControl": "Цео екран",
    "gui.spriteSelector.addBackdropFromLibrary": "Одабери позадину",
    "gui.stageSelector.addBackdropFromPaint": "Насликај",
    "gui.stageSelector.addBackdropFromSurprise": "Изненађење",
    "gui.stageSelector.addBackdropFromFile": "Пошаљи позадину",
    "gui.stageSelector.stage": "Позорница",
    "gui.stageSelector.backdrops": "Позадине",
    "gui.telemetryOptIn.label": "Шаљи статистику да би усавршио Скрач",
    "gui.telemetryOptIn.body1": "Скрач тим се стално труди да открије како се Скрач користи широм света. Да би помогао, можеш дозволити Скрачу да аутоматски шаље информације о коришћењу Скрач тиму. ",
    "gui.telemetryOptIn.body2": "Информације које прикупљамо укључују избор језика, употребу блокова, и неке догађаје као што је чување, учитавање и слање пројеката. Ми НЕ сакупљамо личне податке. Молимо, погледајте нашу {privacyPolicyLink} за више података.",
    "gui.telemetryOptIn.privacyPolicyLink": "Политика приватности",
    "gui.telemetryOptIn.optInText": "Дели моје податке о коришћењу са Скрач тимом",
    "gui.telemetryOptIn.optInTooltip": "Омогући телеметрију",
    "gui.telemetryOptIn.optOutText": "Немој да делиш моје податке о коришћењу са Скрач тимом",
    "gui.telemetryOptIn.optOutTooltip": "Онемогући телеметрију",
    "gui.telemetryOptIn.settingWasUpdated": "Твоје подешавање је ажурирано.",
    "gui.telemetryOptIn.buttonClose": "Затвори",
    "gui.turboMode.active": "Турбо начин",
    "gui.webglModal.label": "Твој прегледач интернета не подржава WebGL",
    "gui.webglModal.description": "Нажалост изгледа да је твој прегледач интернета или рачунар {webGlLink}. Ова технологија је неопходна да би Скрач 3.0 радио.",
    "gui.webglModal.webgllink": "не подржава WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "Да сазнаш више, иди на  {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Најчешћа питања",
    "gui.costumeLibrary.chooseABackdrop": "Одабери позадину",
    "gui.costumeLibrary.chooseACostume": "Изабери костим",
    "gui.costumeTab.addBackdropFromLibrary": "Одабери позадину",
    "gui.costumeTab.addCostumeFromLibrary": "Изабери костим",
    "gui.costumeTab.addBlankCostume": "Насликај",
    "gui.costumeTab.addSurpriseCostume": "Изненађење",
    "gui.costumeTab.addFileBackdrop": "Пошаљи позадину",
    "gui.costumeTab.addFileCostume": "Пошаљи костим",
    "gui.extensionLibrary.chooseAnExtension": "Изабери проширење",
    "gui.extensionLibrary.extensionUrl": "Унеси URL проширења",
    "gui.monitors.importListColumnPrompt": "Која колона треба да се користи (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Не могу да започнем снимање",
    "gui.soundLibrary.chooseASound": "Изабери звук",
    "gui.soundTab.fileUploadSound": "Пошаљи звук",
    "gui.soundTab.surpriseSound": "Изненађење",
    "gui.soundTab.recordSound": "Сними",
    "gui.soundTab.addSoundFromLibrary": "Изабери звук",
    "gui.spriteLibrary.chooseASprite": "Изабери лик",
    "gui.tipsLibrary.tutorials": "Изабери приручник",
    "gui.alerts.createsuccess": "Нови пројекат је направљен.",
    "gui.alerts.createcopysuccess": "Пројекат је сачуван као копија.",
    "gui.alerts.createremixsuccess": "Пројекат сачуван као ремикс.",
    "gui.alerts.creating": "Прављење новог...",
    "gui.alerts.creatingCopy": "Прављење умножка пројекта...",
    "gui.alerts.creatingRemix": "Ремиксовање пројекта...",
    "gui.alerts.creatingError": "Не могу да направим пројекат. Молим те пробај поново!",
    "gui.alerts.savingError": "Не могу да сачувам пројекат.",
    "gui.alerts.savesuccess": "Пројекат је сачуван.",
    "gui.alerts.saving": "Чување пројекта...",
    "gui.alerts.cloudInfo": "Имајте у виду да променњиве у облаку могу бити само бројеви, а не могу бити слова и симболи {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Сазнај више.",
    "gui.alerts.importing": "Учитава се...",
    "gui.defaultProject.meow": "Мјау",
    "gui.defaultProject.variable": "моја променљива",
    "gui.howtos.intro-move-sayhello-hat.name": "Први кораци",
    "gui.howtos.intro-move.step_stepMove": "Додај блок за покрет",
    "gui.howtos.add-a-move-block.step_stepSay": "Додај блок за изговор",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Кликни на зелену заставу да би покренуо",
    "gui.howtos.intro-getting-started-ASL.name": "Први кораци (на знаковном језику)",
    "gui.howtos.animate-a-name.name": "Анимирај име",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Изабери лик слова",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Репродукуј звук када се кликне",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Изабери још један лик слова",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Промени боју",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Изабери још један лик слова и нека се врти",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Изабери још један лик слова и учини нека расте",
    "gui.howtos.imagine": "Замисли свет",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Напиши шта желиш да изговориш",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Кликни на зелену заставицу да би почео",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Изабери позадину",
    "gui.howtos.imagine.step_imagineChooseSprite": "Изабери било који лик",
    "gui.howtos.imagine.step_imagineFlyAround": "Притисни размак да би клизао",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Изабери други лик",
    "gui.howtos.imagine.step_imagineLeftRight": "Кретање лево-десно",
    "gui.howtos.imagine.step_imagineUpDown": "Кретање горе-доле",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Промени костиме",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Клизи до тачке",
    "gui.howtos.imagine.step_imagineGrowShrink": "Повећавање и смањивање",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Изабери другу позадину",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Измени позадине",
    "gui.howtos.imagine.step_imagineRecordASound": "Додај звук",
    "gui.howtos.imagine.step_imagineChooseSound": "Изабери свој звук",
    "gui.howtos.make-music.name": "Стварај музику",
    "gui.howtos.Make-Music.step_PickInstrument": "Изабери лик инструмента",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Када је кликнуто репродукуј звук",
    "gui.howtos.Make-Music.step_MakeSong": "Направи песму",
    "gui.howtos.make-music.step_MakeBeat": "Изабери бубањ и направи ритам",
    "gui.howtos.make-music.step_MakeBeatBox": "Изабери лик микрофона и beatbox изненађење",
    "gui.howtos.story.name": "Направи причу",
    "gui.howtos.story.step_addbg": "Додај позадину",
    "gui.howtos.story.step_addsprite": "Додај лик",
    "gui.howtos.story.step_saysomething": "Кажи нешто",
    "gui.howtos.story.step_addanothersprite": "Додај још једног лика",
    "gui.howtos.story.step_flip": "Обрни правац",
    "gui.howtos.story.step_conversation": "Разговарај",
    "gui.howtos.story.addanotherbg": "Додај још једну позадину",
    "gui.howtos.story.step_swithbg": "Измени позадине",
    "gui.howtos.story.step_hidewizard": "Сакриј лик",
    "gui.howtos.story.step_showwizard": "Прикажи лик",
    "gui.howtos.make-a-chase-game.name": "Направи игру потере",
    "gui.howtos.Chase-Game.step_BG": "Додај позадину",
    "gui.howtos.chase-game.step_AddOcto": "Додај лик",
    "gui.howtos.make-music.step_LeftRight": "Кретање десно и лево употребом тастера са стрелицама",
    "gui.howtos.Chase-Game.step_UpDown": "Кретање горе и доле употребом тастера са стрелицама",
    "gui.howtos.Chase-Game.step_AddStar": "Додај још један лик",
    "gui.howtos.Chase-Game.step_MoveRandom": "Насумично кретање",
    "gui.howtos.Chase-Game.step_WhenTouch": "Код лика хоботнице, када је додирнут репродукуј звук",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Направи променљиву са бодовима",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "У оквиру лика хоботнице, када се додирне додај бодове",
    "gui.howtos.animate-char.name": "Анимирај лик",
    "gui.howtos.animate-char.step_addbg": "Додај позадину",
    "gui.howtos.animate-char.step_addsprite": "Додај лик",
    "gui.howtos.animate-char.step_saysomething": "Кажи нешто",
    "gui.howtos.animate-char.step_addsound": "Додај звук",
    "gui.howtos.animate-char.step_animatetalking": "Анимирај говор",
    "gui.howtos.animate-char.step_arrowkeys": "Померај користећи тастере са стрелицама",
    "gui.howtos.animate-char.step_jump": "Скок",
    "gui.howtos.animate-char.step_changecolor": "Промени боју",
    "gui.howtos.make-a-game.name": "Направи clicker игру",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Изабери лик",
    "gui.howtos.make-a-game.step_GamePlaySound": "Када је кликнуто репродукуј звук",
    "gui.howtos.make-a-game.step_GameAddScore": "Направи променљиву са бодовима",
    "gui.howtos.make-a-game.step_GameChangeScore": "Када је кликнуто повећај поене",
    "gui.howtos.make-a-game.step_Random": "Иди на насумичан положај",
    "gui.howtos.make-music.step_GameChangeColor": "Промени боју",
    "gui.howtos.make-music.step_ResetScore": "Поништи бодове",
    "gui.howtos.make-it-fly.name": "Учини да лети",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Изабери небо као позадину",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Изабери лик",
    "gui.howtos.fly.step_stepflySaySomething": "Кажи нешто",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Кретање тастерима са стрелицама",
    "gui.howtos.fly.step_stepflyChooseObject": "Изабери објекат за сакупљање",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Нека се објекат креће",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Изабери свој лик",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Додај бодовање",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Задржи бодовање",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Додај декорацију",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Пређи на декорацију",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Следећи костим",
    "gui.howtos.pong": "Понг игра",
    "gui.howtos.pong.step_pongAddBackdrop": "Додај позадину",
    "gui.howtos.pong.step_pongAddBallSprite": "Додај лик лопте",
    "gui.howtos.pong.step_pongBounceAround": "Скакуће унаоколо",
    "gui.howtos.pong.step_pongAddPaddle": "Додај рекет",
    "gui.howtos.pong.step_pongMoveThePaddle": "Помеери рекет",
    "gui.howtos.pong.step_pongSelectBallSprite": "Изабери лик лопте",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Додај код да лопта одскочи са рекета",
    "gui.howtos.pong.step_pongAddAScore": "Додај бодовање",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Изабери \"Бодовање\" из менија",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Изабери блок \"Измена бодовања\"",
    "gui.howtos.pong.step_pongResetScore": "Поништи бодове",
    "gui.howtos.pong.step_pongAddLineSprite": "Додај лик линије",
    "gui.howtos.pong.step_pongGameOver": "Крај игре",
    "gui.howtos.code-cartoon": "Програмирај цртани филм",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Кажи нешто када кликнеш на зелену заставицу",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Анимирај лик када кликнеш на њега",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Изабери други лик",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Употреби знак минус да би смањио",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Учини да лик расте и смањује се",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Изабери други лик",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Скачи горе доле",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Кликни на лик да би променио сцену",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Клизи унаоколо",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Промени костиме",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Изабери више ликова које ћеш додати свом цртаном филму",
    "gui.howtos.cartoon-network": "Анимирај Игрицу Авантуру",
    "gui.howtos.cartoon-network.step_CNcharacter": "Изабери и прикажи лика",
    "gui.howtos.cartoon-network.step_CNsay": "Кажи нешто",
    "gui.howtos.cartoon-network.step_CNglide": "Клизи унаоколо",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Изабери предмет за праћење ",
    "gui.howtos.cartoon-network.step_CNcollect": "Сакупи предмете",
    "gui.howtos.cartoon-network.step_CNvariable": "Направи варијаблу за поене",
    "gui.howtos.cartoon-network.step_CNscore": "Задржи бодовање",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Промени позадину",
    "gui.howtos.videosens.name": "Видео детекција",
    "gui.howtos.videosens.step_addextension": "Додај проширење",
    "gui.howtos.videosens.step_pet": "Помази мацу",
    "gui.howtos.videosens.step_animate": "Анимирај",
    "gui.howtos.videosens.step_pop": "Пукни балон",
    "gui.howtos.say-it-out-loud": "Направи анимације које причају",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Додај текст у говорне блокове",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Кажи нешто",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Подеси Глас",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Померај се унаоколо",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Додај позадину",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Додај још једног лика",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Отпевај песму",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Промени боју",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Врти се унаоколо",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Повећавање и смањивање",
    "gui.howtos.talking": "Причање приче",
    "gui.howtos.talking.step_talesAddExtension": "Кликни да би додао Текст-у-говор блокове",
    "gui.howtos.talking.step_talesChooseSprite": "Изабери лик",
    "gui.howtos.talking.step_talesSaySomething": "Учнини да лик говори",
    "gui.howtos.talking.step_talesChooseBackdrop": "Одабери позадину",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Кликни на лик да би прешао на следећу позадину",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Изабери други лик",
    "gui.howtos.talking.step_talesMoveAround": "Померај се унаоколо",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Изабери другу позадину",
    "gui.howtos.talking.step_talesAnimateTalking": "Анимирај говор",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Изабери другу позадину",
    "gui.howtos.talking.step_talesChooseSound": "Изабери песму за плес",
    "gui.howtos.talking.step_talesDanceMoves": "Плесни покрети",
    "gui.howtos.talking.step_talesAskAnswer": "Додај блокове питања и одговора из категорије осећаја",
    "gui.howtos.add-sprite.name": "Додај лик",
    "gui.howtos.add-sprite.step_addSprite": "Додај лик",
    "gui.howtos.add-a-backdrop.name": "Додај позадину",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Додај позадину",
    "gui.howtos.change-size.name": "Промени величину",
    "gui.howtos.change-size.step_changeSize": "Промени величину",
    "gui.howtos.glide-around.name": "Клизи унаоколо",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Клизи унаоколо",
    "gui.howtos.change-size.step_glideAroundPoint": "Клизи до тачке",
    "gui.howtos.record-a-sound.name": "Сними звук",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Изабери табулатор \"Звуци\"",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Притисни \"Сними\"",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Притисни дугме за снимање",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Изабери свој звук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Репродукуј свој звук",
    "gui.howtos.spin-video.name": "Нека се врти",
    "gui.howtos.change-size.step_spinTurn": "Окрени",
    "gui.howtos.change-size.step_spinPointInDirection": "Одреди смер",
    "gui.howtos.hide-and-show.name": "Сакриј и прикажи",
    "gui.howtos.change-size.step_hideAndShow": "Сакриј и прикажи",
    "gui.howtos.switch-costume.name": "Анимирај лик",
    "gui.howtos.change-size.step_switchCostumes": "Анимирај лик",
    "gui.howtos.move-around-with-arrow-keys.name": "Употреби тастере са стрелицама",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Помери лево и десно",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Помери горе и доле",
    "gui.howtos.add-effects.name": "Додај ефекте",
    "gui.howtos.videosens.step_addEffects": "Додај ефекте",
    "gui.extension.music.name": "Музика",
    "gui.extension.music.description": "Свирај инструменте и бубњеве.",
    "gui.extension.pen.name": "Оловка",
    "gui.extension.pen.description": "Цртај помоћу својих ликова.",
    "gui.extension.videosensing.name": "Видео детекција",
    "gui.extension.videosensing.description": "Детектуј кретање камером.",
    "gui.extension.text2speech.name": "Текст у Говор",
    "gui.extension.text2speech.description": "Учини да пројекти пропричају",
    "gui.extension.translate.name": "Преведи",
    "gui.extension.translate.description": "Преводи текст на разне језике.",
    "gui.extension.makeymakey.description": "Претвори било шта у кључ.",
    "gui.extension.microbit.description": "Повежи своје пројекте са светом.",
    "gui.extension.microbit.connectingMessage": "Повезивање",
    "gui.extension.ev3.description": "Гради интерактивне роботе и још много тога.",
    "gui.extension.ev3.connectingMessage": "Повезујем се. Провери да ли је пин на твом EV3 постављен на 1234.",
    "gui.extension.boost.description": "Оживи роботске креације.",
    "gui.extension.boost.connectingMessage": "Повезивање",
    "gui.extension.wedo2.description": "Гради са моторима и сензорима.",
    "gui.extension.wedo2.connectingMessage": "Повезивање",
    "gui.extension.gdxfor.description": "Детектуј гурање, повлачење, кретање и окретање.",
    "gui.extension.gdxfor.connectingMessage": "Повезивање",
    "gui.libraryTags.all": "Сви",
    "gui.libraryTags.animals": "Животиње",
    "gui.libraryTags.dance": "Плес",
    "gui.libraryTags.effects": "Ефекти",
    "gui.libraryTags.fantasy": "Фантазија",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Храна",
    "gui.libraryTags.indoors": "Унутра",
    "gui.libraryTags.loops": "Петље",
    "gui.libraryTags.music": "Музика",
    "gui.libraryTags.notes": "Белешке",
    "gui.libraryTags.outdoors": "Природа",
    "gui.libraryTags.patterns": "Шаблони",
    "gui.libraryTags.people": "Људи",
    "gui.libraryTags.percussion": "Удараљке",
    "gui.libraryTags.space": "Свемир",
    "gui.libraryTags.sports": "Спортови",
    "gui.libraryTags.underwater": "Под водом",
    "gui.libraryTags.voice": "Глас",
    "gui.libraryTags.wacky": "Откачено",
    "gui.libraryTags.animation": "Анимација",
    "gui.libraryTags.art": "Уметност",
    "gui.libraryTags.games": "Игре",
    "gui.libraryTags.stories": "Приче",
    "gui.libraryTags.letters": "Слова",
    "gui.opcodeLabels.direction": "смер",
    "gui.opcodeLabels.xposition": "x положај",
    "gui.opcodeLabels.yposition": "y положај",
    "gui.opcodeLabels.size": "величина",
    "gui.opcodeLabels.costumename": "име костима",
    "gui.opcodeLabels.costumenumber": "број костима",
    "gui.opcodeLabels.backdropname": "име позадине",
    "gui.opcodeLabels.backdropnumber": "број позадине",
    "gui.opcodeLabels.volume": "јачина звука",
    "gui.opcodeLabels.tempo": "темпо",
    "gui.opcodeLabels.answer": "одговор",
    "gui.opcodeLabels.loudness": "јачина звука",
    "gui.opcodeLabels.username": "корисничко име",
    "gui.opcodeLabels.year": "година",
    "gui.opcodeLabels.month": "месец",
    "gui.opcodeLabels.date": "датум",
    "gui.opcodeLabels.dayofweek": "дан у недељи",
    "gui.opcodeLabels.hour": "сат",
    "gui.opcodeLabels.minute": "минут",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "тајмер",
    "gui.projectLoader.loadError": "Изабрана датотека пројекта није успела да се учита.",
    "gui.sharedMessages.backdrop": "позадина{index}",
    "gui.sharedMessages.costume": "костим{index}",
    "gui.sharedMessages.sprite": "Лик{index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Заменити садржај тренутног пројекта?",
    "gui.sharedMessages.loadFromComputerTitle": "Пошаљи са свог рачунара",
    "gui.theme.default": "Оригинал",
    "gui.theme.dark": "Тамно",
    "gui.theme.highContrast": "Велики контраст",
    "gui.gui.defaultProjectTitle": "Скрач пројекат",
    "boost.color.any": "било која боја",
    "boost.color.black": "црна",
    "boost.color.blue": "плава",
    "boost.color.green": "зелена",
    "boost.color.red": "црвена",
    "boost.color.white": "бела",
    "boost.color.yellow": "жута",
    "boost.getMotorPosition": "место мотора [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "угао нагиба [TILT_DIRECTION]",
    "boost.motorDirection.backward": "онај смер",
    "boost.motorDirection.forward": "овај смер",
    "boost.motorDirection.reverse": "промени",
    "boost.motorOff": "искључи мотор [MOTOR_ID]",
    "boost.motorOn": "укључи мотор [MOTOR_ID]",
    "boost.motorOnFor": "укључи мотор [MOTOR_ID] током [DURATION] секунди",
    "boost.motorOnForRotation": "укључи мотор [MOTOR_ID] током [ROTATION] окрета",
    "boost.seeingColor": "виђена је [COLOR] цигла?",
    "boost.setLightHue": "подеси боју светлости на [HUE]",
    "boost.setMotorDirection": "подеси смер мотора [MOTOR_ID]: [MOTOR_DIRECTION]",
    "boost.setMotorPower": "подеси брзину мотора [MOTOR_ID] на [POWER] %",
    "boost.tiltDirection.any": "било који",
    "boost.tiltDirection.down": "доле",
    "boost.tiltDirection.left": "лево",
    "boost.tiltDirection.right": "десно",
    "boost.tiltDirection.up": "горе",
    "boost.whenColor": "када је цигла боје [COLOR] виђена",
    "boost.whenTilted": "када је нагнуто [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "изведи ноту [NOTE] током [TIME] секунди",
    "ev3.buttonPressed": "дугме [PORT] је притиснуто?",
    "ev3.getBrightness": "осветљеност",
    "ev3.getDistance": "растојање",
    "ev3.getMotorPosition": "мотор [PORT]: место",
    "ev3.motorSetPower": "мотор [PORT]: подеси снагу [POWER] %",
    "ev3.motorTurnClockwise": "мотор [PORT]: окрени овако током [TIME] секунди",
    "ev3.motorTurnCounterClockwise": "мотор [PORT]: окрени овако током [TIME] секунди",
    "ev3.whenBrightnessLessThan": "кад је осветљеност < [DISTANCE]",
    "ev3.whenButtonPressed": "када је дугме [PORT] притиснуто",
    "ev3.whenDistanceLessThan": "када је растојање < [DISTANCE]",
    "gdxfor.getAcceleration": "убрзање [DIRECTION]",
    "gdxfor.getForce": "сила",
    "gdxfor.getSpin": "брзина обртања [DIRECTION]",
    "gdxfor.getTilt": "угао нагиба [TILT]",
    "gdxfor.isFreeFalling": "пада?",
    "gdxfor.isTilted": "нагнуто [TILT]?",
    "gdxfor.pulled": "повучено",
    "gdxfor.pushed": "гурнуто",
    "gdxfor.shaken": "протресен",
    "gdxfor.startedFalling": "пад је почео",
    "gdxfor.tiltDirectionMenu.any": "било који",
    "gdxfor.tiltDirectionMenu.back": "назад",
    "gdxfor.tiltDirectionMenu.front": "напред",
    "gdxfor.tiltDirectionMenu.left": "лево",
    "gdxfor.tiltDirectionMenu.right": "десно",
    "gdxfor.turnedFaceDown": "окренут наниже",
    "gdxfor.turnedFaceUp": "окренут навише",
    "gdxfor.whenForcePushedOrPulled": "када је сензор силе [PUSH_PULL]",
    "gdxfor.whenGesture": "када је [GESTURE]",
    "gdxfor.whenTilted": "када је нагнуто [TILT]",
    "makeymakey.downArrow": "стрелица доле",
    "makeymakey.downArrowShort": "доле",
    "makeymakey.leftArrow": "стрелица лево",
    "makeymakey.leftArrowShort": "лево",
    "makeymakey.rightArrow": "стрелица десно",
    "makeymakey.rightArrowShort": "десно",
    "makeymakey.spaceKey": "размак",
    "makeymakey.upArrow": "стрелица горе",
    "makeymakey.upArrowShort": "горе",
    "makeymakey.whenKeyPressed": "када је дирка [KEY] притиснута",
    "makeymakey.whenKeysPressedInOrder": "када је [SEQUENCE] притиснуто по реду",
    "microbit.buttonsMenu.any": "било који",
    "microbit.clearDisplay": "обриши екран",
    "microbit.defaultTextToDisplay": "Здраво!",
    "microbit.displaySymbol": "прикажи [MATRIX]",
    "microbit.displayText": "прикажи текст [TEXT]",
    "microbit.gesturesMenu.jumped": "скок",
    "microbit.gesturesMenu.moved": "померен",
    "microbit.gesturesMenu.shaken": "протресен",
    "microbit.isButtonPressed": "[BTN] дугме притиснуто?",
    "microbit.isTilted": "нагнуто [DIRECTION]?",
    "microbit.pinStateMenu.off": "искључено",
    "microbit.pinStateMenu.on": "укључено",
    "microbit.tiltAngle": "угао нагиба [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "било који",
    "microbit.tiltDirectionMenu.back": "назад",
    "microbit.tiltDirectionMenu.front": "напред",
    "microbit.tiltDirectionMenu.left": "лево",
    "microbit.tiltDirectionMenu.right": "десно",
    "microbit.whenButtonPressed": "када је [BTN] дугме притиснуто",
    "microbit.whenGesture": "када је [GESTURE]",
    "microbit.whenPinConnected": "када је пин [PIN] повезан",
    "microbit.whenTilted": "када је нагнуто [DIRECTION]",
    "music.categoryName": "Музика",
    "music.changeTempo": "промени темпо за [TEMPO]",
    "music.drumBass": "(2) Бас бубањ",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клавес",
    "music.drumClosedHiHat": "(6) Затворена контра-чинела",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Звоно за краве",
    "music.drumCrashCymbal": "(4) Креш чинела",
    "music.drumCuica": "(18) Куика",
    "music.drumGuiro": "(16) Гиро",
    "music.drumHandClap": "(8) Пљесак дланом",
    "music.drumOpenHiHat": "(5) Отворена контра-чинела",
    "music.drumSideStick": "(3) Ивица добоша",
    "music.drumSnare": "(1) Добош",
    "music.drumTambourine": "(7) Даире",
    "music.drumTriangle": "(12) Троугао",
    "music.drumVibraslap": "(17) Вибраслап",
    "music.drumWoodBlock": "(10) Дрвени блок",
    "music.getTempo": "темпо",
    "music.instrumentBass": "(6) Бас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Виолончело",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларинет",
    "music.instrumentElectricGuitar": "(5) Електрична гитара",
    "music.instrumentElectricPiano": "(2) Електрични клавир",
    "music.instrumentFlute": "(12) Флаута",
    "music.instrumentGuitar": "(4) Гитара",
    "music.instrumentMarimba": "(19) Маримба",
    "music.instrumentMusicBox": "(17) Музичка кутија",
    "music.instrumentOrgan": "(3) Оргуље",
    "music.instrumentPiano": "(1) Клавир",
    "music.instrumentPizzicato": "(7) Пицикато",
    "music.instrumentSaxophone": "(11) Саксофон",
    "music.instrumentSteelDrum": "(18) Метални бубањ",
    "music.instrumentSynthLead": "(20) Синти вођица",
    "music.instrumentSynthPad": "(21) Синти педала",
    "music.instrumentTrombone": "(9) Тромбон",
    "music.instrumentVibraphone": "(16) Вибрафон",
    "music.instrumentWoodenFlute": "(13) Дрвена флаута",
    "music.midiPlayDrumForBeats": "удараљка [DRUM] током [BEATS] откуцаја",
    "music.midiSetInstrument": "нека инструмент буде [INSTRUMENT]",
    "music.playDrumForBeats": "удараљка [DRUM] током [BEATS] откуцаја",
    "music.playNoteForBeats": "свирај ноту [NOTE] током [BEATS] откуцаја",
    "music.restForBeats": "пауза [BEATS] откуцаја",
    "music.setInstrument": "нека инструмент буде [INSTRUMENT]",
    "music.setTempo": "нека темпо буде [TEMPO]",
    "pen.categoryName": "Оловка",
    "pen.changeColorParam": "промени [COLOR_PARAM] оловке за [VALUE]",
    "pen.changeHue": "промени боју оловке за [HUE]",
    "pen.changeShade": "промени сенку оловке за [SHADE]",
    "pen.changeSize": "промени дебљину оловке за [SIZE]",
    "pen.clear": "обриши све",
    "pen.colorMenu.brightness": "осветљеност",
    "pen.colorMenu.color": "боја",
    "pen.colorMenu.saturation": "засићење",
    "pen.colorMenu.transparency": "провидност",
    "pen.penDown": "спусти оловку",
    "pen.penUp": "подигни оловку",
    "pen.setColor": "нека боја оловке буде [COLOR]",
    "pen.setColorParam": "нека [COLOR_PARAM] оловке буде [VALUE]",
    "pen.setHue": "нека боја оловке буде [HUE]",
    "pen.setShade": "нека сенка оловке буде [SHADE]",
    "pen.setSize": "нека дебљина оловке буде [SIZE]",
    "pen.stamp": "печат",
    "speech.defaultWhenIHearValue": "хајдемо",
    "speech.extensionName": "Говор у текст",
    "speech.listenAndWait": "слушај и чекај",
    "speech.speechReporter": "говор",
    "speech.whenIHear": "када чујем [PHRASE]",
    "text2speech.alto": "алт",
    "text2speech.categoryName": "Текст у Говор",
    "text2speech.defaultTextToSpeak": "здраво",
    "text2speech.giant": "џин",
    "text2speech.kitten": "маца",
    "text2speech.setLanguageBlock": "нека језик буде [LANGUAGE]",
    "text2speech.setVoiceBlock": "нека глас буде [VOICE]",
    "text2speech.speakAndWaitBlock": "изговори [WORDS]",
    "text2speech.squeak": "писак",
    "text2speech.tenor": "тенор",
    "translate.categoryName": "Преведи",
    "translate.defaultTextToTranslate": "здраво",
    "translate.translateBlock": "преведи [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "језик",
    "videoSensing.categoryName": "Видео детекција",
    "videoSensing.direction": "смер",
    "videoSensing.motion": "кретање",
    "videoSensing.off": "искључено",
    "videoSensing.on": "укључено",
    "videoSensing.onFlipped": "измени укљученост",
    "videoSensing.setVideoTransparency": "нека провидност видеа буде  [TRANSPARENCY]",
    "videoSensing.sprite": "лик",
    "videoSensing.stage": "позорница",
    "videoSensing.videoOn": "видео [ATTRIBUTE] на [SUBJECT]",
    "videoSensing.videoToggle": "нека видео буде [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "када је кретање видеа > [REFERENCE]",
    "wedo2.getDistance": "растојање",
    "wedo2.getTiltAngle": "угао нагиба [TILT_DIRECTION]",
    "wedo2.isTilted": "нагнуто [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "онај смер",
    "wedo2.motorDirection.forward": "овај смер",
    "wedo2.motorDirection.reverse": "промени",
    "wedo2.motorId.a": "Мотор A",
    "wedo2.motorId.all": "сви мотори",
    "wedo2.motorId.b": "мотор B",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": "искључи [MOTOR_ID]",
    "wedo2.motorOn": "укључи [MOTOR_ID]",
    "wedo2.motorOnFor": "укључи [MOTOR_ID] током [DURATION] секунди",
    "wedo2.playNoteFor": "свирај ноту [NOTE] током [DURATION] секунди",
    "wedo2.setLightHue": "подеси боју светлости на [HUE]",
    "wedo2.setMotorDirection": "подеси смер [MOTOR_ID] у [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "подеси снагу [MOTOR_ID] на [POWER]",
    "wedo2.tiltDirection.any": "било који",
    "wedo2.tiltDirection.down": "доле",
    "wedo2.tiltDirection.left": "лево",
    "wedo2.tiltDirection.right": "десно",
    "wedo2.tiltDirection.up": "горе",
    "wedo2.whenDistance": "када је растојање [OP] од [REFERENCE]",
    "wedo2.whenTilted": "када је нагнуто [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Боја",
    "paint.paintEditor.saturation": "Засићење",
    "paint.paintEditor.brightness": "Осветљеност",
    "paint.paintEditor.costume": "Костим",
    "paint.paintEditor.group": "Групиши",
    "paint.paintEditor.ungroup": "Разгрупиши",
    "paint.paintEditor.undo": "Опозови",
    "paint.paintEditor.redo": "Понови",
    "paint.paintEditor.forward": "Напред",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "Напред",
    "paint.paintEditor.back": "Назад",
    "paint.paintEditor.more": "Више",
    "paint.modeTools.brushSize": "Величина",
    "paint.modeTools.eraserSize": "Величина брисача",
    "paint.modeTools.copy": "Умножи",
    "paint.modeTools.paste": "Уметни",
    "paint.modeTools.delete": "Обриши",
    "paint.modeTools.curved": "Заобљено",
    "paint.modeTools.pointed": "Шиљаст",
    "paint.modeTools.thickness": "Дебљина",
    "paint.modeTools.flipHorizontal": "Обрни хоризонтално",
    "paint.modeTools.flipVertical": "Обрни вертикално",
    "paint.modeTools.filled": "Попуњено",
    "paint.modeTools.outlined": "Контура",
    "paint.paintEditor.bitmap": "Преведи у растерски облик",
    "paint.paintEditor.vector": "Преведи у векторски облик",
    "paint.paintEditor.fill": "Попуни",
    "paint.paintEditor.stroke": "Контура",
    "paint.brushMode.brush": "Четкица",
    "paint.eraserMode.eraser": "Брисач",
    "paint.fillMode.fill": "Попуни",
    "paint.lineMode.line": "Линија",
    "paint.ovalMode.oval": "Круг",
    "paint.rectMode.rect": "Правоугаоник",
    "paint.reshapeMode.reshape": "Преобликуј",
    "paint.roundedRectMode.roundedRect": "Заобљени правоугаоник",
    "paint.selectMode.select": "Изабери",
    "paint.textMode.text": "Текст",
    "paint.colorPicker.swap": "Замени"
  },
  "fi": {
    "gui.alerts.lostPeripheralConnection": "Scratch menetti yhteyden {extensionName} -laajennukseen.",
    "gui.alerts.tryAgain": "Yritä uudelleen",
    "gui.alerts.download": "Lataa",
    "gui.connection.reconnect": "Yhdistä uudelleen",
    "gui.backpack.costumeLabel": "asuste",
    "gui.backpack.soundLabel": "ääni",
    "gui.backpack.scriptLabel": "skripti",
    "gui.backpack.spriteLabel": "hahmo",
    "gui.backpack.header": "Reppu",
    "gui.backpack.errorBackpack": "Virhe reppua ladattaessa",
    "gui.backpack.loadingBackpack": "Ladataan...",
    "gui.backpack.more": "Enemmän",
    "gui.backpack.emptyBackpack": "Reppu on tyhjä",
    "gui.unsupportedBrowser.label": "Selainta ei tueta",
    "gui.unsupportedBrowser.errorLabel": "Tapahtui virhe",
    "gui.unsupportedBrowser.notRecommended": "Olemme pahoillamme, mutta näyttää siltä, ​​että käytät selainversiota, jota Scratch ei tue. Suosittelemme päivittämään tuetun selaimen uusimman version, kuten Google Chromen, Mozilla Firefoxin, Microsoft Edgen tai Apple Safarin.",
    "gui.unsupportedBrowser.description": "Olemme pahoillamme, mutta Scratch ei tue tätä selainta. Suosittelemme päivittämään tuetun selaimen uusimman version, kuten Google Chromen, Mozilla Firefoxin, Microsoft Edgen tai Apple Safarin.",
    "gui.unsupportedBrowser.back": "Takaisin",
    "gui.unsupportedBrowser.previewfaq": "Lukeaksesi lisää siirry {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "UKK",
    "gui.cards.all-tutorials": "Oppitunnit",
    "gui.cards.shrink": "Pienennä",
    "gui.cards.expand": "Laajenna",
    "gui.cards.close": "Sulje",
    "gui.cards.more-things-to-try": "Lisää kokeiltavia asioita!",
    "gui.cards.see-more": "Lue lisää",
    "gui.comingSoon.message1": "Älä huoli, toteutamme sitä {emoji}",
    "gui.comingSoon.message2": "Tulossa pian...",
    "gui.comingSoon.message3": "Toteutamme sitä {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Laitteita ei löytynyt",
    "gui.connection.auto-scanning.prescan": "Tuo laite lähelle ja aloita haku.",
    "gui.connection.auto-scanning.pressbutton": "Paina laitteen painiketta.",
    "gui.connection.auto-scanning.start-search": "Aloita haku",
    "gui.connection.connecting-searchbutton": "Haetaan...",
    "gui.connection.auto-scanning.try-again": "Yritä uudelleen",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Yhdistetty",
    "gui.connection.disconnect": "Katkaise yhteys",
    "gui.connection.go-to-editor": "Siirry editoriin",
    "gui.connection.connecting-cancelbutton": "Yhdistetään...",
    "gui.connection.error.errorMessage": "Hupsis, näyttää siltä, että jokin meni pieleen.",
    "gui.connection.error.tryagainbutton": "Yritä uudelleen",
    "gui.connection.error.helpbutton": "Apua",
    "gui.connection.peripheral-name-label": "Laitteen nimi",
    "gui.connection.connect": "Yhdistä",
    "gui.connection.scanning.lookingforperipherals": "Etsitään laitteita",
    "gui.connection.scanning.noPeripheralsFound": "Laitteita ei löytynyt",
    "gui.connection.scanning.instructions": "Valitse laitteesi ylläolevalta listalta.",
    "gui.connection.search": "Päivitä",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Varmista, että Scratch Link on asennettu ja käynnissä",
    "gui.connection.unavailable.enablebluetooth": "Tarkista, että Bluetooth on käytössä",
    "gui.connection.unavailable.tryagainbutton": "Yritä uudelleen",
    "gui.connection.unavailable.helpbutton": "Apua",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Mene",
    "gui.controls.stop": "Pysäytä",
    "gui.crashMessage.label": "Hupsis! Jokin meni pieleen.",
    "gui.crashMessage.description": "Olemme pahoillamme, mutta näyttää siltä, että Scratch kaatui. Tästä viasta on automaattisesti ilmoitettu Scratch-tiimille. Päivitä sivu yrittääksesi uudelleen.",
    "gui.crashMessage.errorNumber": "Virheesi kirjattiin tunnuksella {errorId}",
    "gui.crashMessage.reload": "Lataa uudelleen",
    "gui.customProcedures.myblockModalTitle": "Tee lohko",
    "gui.customProcedures.addAnInputNumberText": "Lisää syöte",
    "gui.customProcedures.numberTextType": "luku tai teksti",
    "gui.customProcedures.addAnInputBoolean": "Lisää syöte",
    "gui.customProcedures.booleanType": "totuusarvo",
    "gui.customProcedures.addALabel": "Lisää nimike",
    "gui.customProcedures.runWithoutScreenRefresh": "Suorita ilman ruudunpäivitystä",
    "gui.customProcedures.cancel": "Peruuta",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Suunta",
    "gui.directionPicker.rotationStyles.allAround": "Joka suuntaan",
    "gui.directionPicker.rotationStyles.leftRight": "Vasen/Oikea",
    "gui.directionPicker.rotationStyles.dontRotate": "Älä kierrä",
    "gui.gui.addExtension": "Lisää laajennus",
    "gui.gui.codeTab": "Koodi",
    "gui.gui.backdropsTab": "Taustat",
    "gui.gui.costumesTab": "Asusteet",
    "gui.gui.soundsTab": "Äänet",
    "gui.extensionLibrary.comingSoon": "Tulossa pian",
    "gui.extensionLibrary.requires": "Vaatii",
    "gui.extensionLibrary.collaboration": "Yhteistyössä",
    "gui.library.filterPlaceholder": "Haku",
    "gui.library.allTag": "Kaikki",
    "gui.loader.message1": "Luodaan lohkoja...",
    "gui.loader.message2": "Hahmoja ladataan...",
    "gui.loader.message3": "Ääniä ladataan...",
    "gui.loader.message4": "Laajennuksia ladataan...",
    "gui.loader.message5": "Paimennetaan kissoja...",
    "gui.loader.message6": "Siirretään nanoja...",
    "gui.loader.message7": "Kasvatetaan goboja...",
    "gui.loader.message8": "Valmistellaan hymiöitä...",
    "gui.loader.headline": "Projektia ladataan",
    "gui.loader.creating": "Luodaan projektia",
    "gui.accountMenu.profile": "Profiili",
    "gui.accountMenu.myStuff": "Omat tavarat",
    "gui.accountMenu.myClasses": "Luokkani",
    "gui.accountMenu.myClass": "Luokkani",
    "gui.accountMenu.accountSettings": "Tunnuksen asetukset",
    "gui.accountMenu.signOut": "Kirjaudu ulos",
    "gui.authorInfo.byUser": "tekijä: {username}",
    "gui.menuBar.seeProjectPage": "Katso projektisivu",
    "gui.menuBar.language": "Language",
    "general.username": "Käyttäjänimi",
    "general.password": "Salasana",
    "general.signIn": "Kirjaudu sisään",
    "login.needHelp": "Tarvitsetko apua?",
    "form.validationRequired": "Kenttä on pakollinen",
    "gui.menuBar.tutorialsLibrary": "Oppitunnit",
    "gui.menuBar.restoreSprite": "Palauta hahmo",
    "gui.menuBar.restoreSound": "Palauta ääni",
    "gui.menuBar.restoreCostume": "Palauta asuste",
    "gui.menuBar.restore": "Palauta",
    "gui.menuBar.saveNow": "Tallenna nyt",
    "gui.menuBar.saveAsCopy": "Tallenna kopio",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Uusi",
    "gui.menuBar.file": "Tiedosto",
    "gui.menuBar.downloadToComputer": "Tallenna tietokoneellesi",
    "gui.menuBar.edit": "Muokkaa",
    "gui.menuBar.turboModeOff": "Sammuta turbotila",
    "gui.menuBar.turboModeOn": "Käynnistä turbotila",
    "gui.menuBar.modeMenu": "Tila",
    "gui.menuBar.normalMode": "Normaalitila",
    "gui.menuBar.caturdayMode": "Kissantai-tila",
    "gui.menuBar.joinScratch": "Liity Scratchiin",
    "gui.menuBar.signIn": "Kirjaudu sisään",
    "gui.gui.projectTitlePlaceholder": "Projektin otsikko tähän",
    "gui.menuBar.saveNowLink": "Tallenna nyt",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Jaetut",
    "gui.menuBar.share": "Jaa",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Apua",
    "gui.modal.back": "Takaisin",
    "gui.monitor.listMonitor.empty": "(tyhjä)",
    "gui.monitor.listMonitor.listLength": "pituus {length}",
    "gui.monitor.contextMenu.default": "normaali näyttö",
    "gui.monitor.contextMenu.large": "suuri näyttö",
    "gui.monitor.contextMenu.slider": "säädin",
    "gui.monitor.contextMenu.sliderRange": "muuta säätimen rajoja",
    "gui.monitor.contextMenu.import": "tuo",
    "gui.monitor.contextMenu.export": "vie",
    "gui.monitor.contextMenu.hide": "piilota",
    "gui.playButton.play": "Pelaa",
    "gui.playButton.stop": "Pysäytä",
    "gui.gui.variableScopeOptionAllSprites": "Kaikille hahmoille",
    "gui.gui.variableScopeOptionSpriteOnly": "Vain tälle hahmolle",
    "gui.gui.cloudVariableOption": "Pilvimuuttuja (tallennettu palvelimelle)",
    "gui.gui.variablePromptAllSpritesMessage": "Tämä muuttuja on saatavilla kaikille hahmoille.",
    "gui.gui.listPromptAllSpritesMessage": "Tämä lista on saatavilla kaikille hahmoille.",
    "gui.prompt.cancel": "Peru",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Pysäytä",
    "gui.playbackStep.playMsg": "Soita",
    "gui.playbackStep.loadingMsg": "Ladataan...",
    "gui.playbackStep.saveMsg": "Tallenna",
    "gui.playbackStep.reRecordMsg": "Äänitä uudelleen",
    "gui.recordModal.title": "Äänitä ääni",
    "gui.recordingStep.beginRecord": "Aloita tallennus napsauttamalla alla olevaa painiketta",
    "gui.recordingStep.permission": "{arrow}Tarvitsemme lupasi, jotta mikrofonia voidaan käyttää",
    "gui.recordingStep.stop": "Lopeta tallennus",
    "gui.recordingStep.record": "Äänitä",
    "gui.sliderModal.min": "Vähimmäisarvo",
    "gui.sliderModal.max": "Enimmäisarvo",
    "gui.sliderModal.title": "Muuta säätimen rajoja",
    "gui.sliderPrompt.cancel": "Peruuta",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Ääni",
    "gui.soundEditor.play": "Soita",
    "gui.soundEditor.stop": "Pysäytä",
    "gui.soundEditor.copy": "Kopioi",
    "gui.soundEditor.paste": "Liitä",
    "gui.soundEditor.copyToNew": "Kopioi uuteen",
    "gui.soundEditor.delete": "Poista",
    "gui.soundEditor.save": "Tallenna",
    "gui.soundEditor.undo": "Kumoa",
    "gui.soundEditor.redo": "Tee uudelleen",
    "gui.soundEditor.faster": "Nopeammin",
    "gui.soundEditor.slower": "Hitaammin",
    "gui.soundEditor.echo": "Kaiku",
    "gui.soundEditor.robot": "Robotti",
    "gui.soundEditor.louder": "Voimakkaammin",
    "gui.soundEditor.softer": "Pehmeämmin",
    "gui.soundEditor.reverse": "Vaihda suuntaa",
    "gui.soundEditor.fadeOut": "Häivytä",
    "gui.soundEditor.fadeIn": "Voimista",
    "gui.soundEditor.mute": "Vaimenna",
    "gui.SpriteInfo.spritePlaceholder": "Nimi",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Hahmo",
    "gui.SpriteInfo.show": "Näytä",
    "gui.SpriteInfo.size": "Koko",
    "gui.spriteSelectorItem.contextMenuDuplicate": "monista",
    "gui.spriteSelectorItem.contextMenuExport": "vie",
    "gui.spriteSelectorItem.contextMenuDelete": "poista",
    "gui.spriteSelector.addSpriteFromLibrary": "Valitse hahmo",
    "gui.spriteSelector.addSpriteFromPaint": "Piirrä",
    "gui.spriteSelector.addSpriteFromSurprise": "Yllätä",
    "gui.spriteSelector.addSpriteFromFile": "Lataa hahmo",
    "gui.stageHeader.stageSizeLarge": "Vaihda suureen esiintymislavaan",
    "gui.stageHeader.stageSizeSmall": "Vaihda pieneen esiintymislavaan",
    "gui.stageHeader.stageSizeFull": "Siirry koko ruudun tilaan",
    "gui.stageHeader.stageSizeUnFull": "Poistu koko ruudun tilasta",
    "gui.stageHeader.fullscreenControl": "Koko ruudun hallinta",
    "gui.spriteSelector.addBackdropFromLibrary": "Valitse tausta",
    "gui.stageSelector.addBackdropFromPaint": "Piirrä",
    "gui.stageSelector.addBackdropFromSurprise": "Yllätä",
    "gui.stageSelector.addBackdropFromFile": "Lataa tausta",
    "gui.stageSelector.stage": "Esiintymislava",
    "gui.stageSelector.backdrops": "Taustat",
    "gui.telemetryOptIn.label": "Raportoi tilastoja Scratchin parantamiseksi",
    "gui.telemetryOptIn.body1": "Scratch-tiimi on kiinnostunut siitä, miten Scratchia käytetään ympäri maailmaa. Auttaaksesi tätä työtä voit sallia, että Scratch lähettää automaattisesti käyttötietoja Scratch-tiimille.",
    "gui.telemetryOptIn.body2": "Keräämämme tieto sisältää kielivalinnan, lohkojen käytön ja muutamia tapahtumia, kuten tallennuksen, latauksen ja projektin lähetyksen. Me EMME kerää mitään henkilökohtaisia tietoa. Katso {privacyPolicyLink} lisätietojen saamiseksi.",
    "gui.telemetryOptIn.privacyPolicyLink": "tietosuojamenettelymme",
    "gui.telemetryOptIn.optInText": "Jaa käyttötietoni Scratch-tiimille",
    "gui.telemetryOptIn.optInTooltip": "Ota tietojen lähetys käyttöön",
    "gui.telemetryOptIn.optOutText": "Älä jaa käyttötietojani Scratch-tiimille",
    "gui.telemetryOptIn.optOutTooltip": "Poista tietojen lähetys käytöstä",
    "gui.telemetryOptIn.settingWasUpdated": "Asetuksesi päivitettiin.",
    "gui.telemetryOptIn.buttonClose": "Sulje",
    "gui.turboMode.active": "Turbotila",
    "gui.webglModal.label": "Selaimesi ei tue WebGL:ää",
    "gui.webglModal.description": "Valitettavasti näyttää siltä, ettei selaimesi tai tietokoneesi {webGlLink}. Tätä teknologiaa tarvitaan Scratch 3.0:n toimimiseksi.",
    "gui.webglModal.webgllink": "ei tue WebGL:ää",
    "gui.webglModal.back": "Takaisin",
    "gui.webglModal.previewfaq": "Lukeaksesi lisää siirry {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "UKK",
    "gui.costumeLibrary.chooseABackdrop": "Valitse tausta",
    "gui.costumeLibrary.chooseACostume": "Valitse asuste",
    "gui.costumeTab.addBackdropFromLibrary": "Valitse tausta",
    "gui.costumeTab.addCostumeFromLibrary": "Valitse asuste",
    "gui.costumeTab.addBlankCostume": "Piirrä",
    "gui.costumeTab.addSurpriseCostume": "Yllätä",
    "gui.costumeTab.addFileBackdrop": "Lataa tausta",
    "gui.costumeTab.addFileCostume": "Lataa asuste",
    "gui.extensionLibrary.chooseAnExtension": "Valitse laajennus",
    "gui.extensionLibrary.extensionUrl": "Syötä liitännäisen verkko-osoite",
    "gui.monitors.importListColumnPrompt": "Mitä saraketta tulisi käyttää (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Ei voi aloittaa äänitystä",
    "gui.soundLibrary.chooseASound": "Valitse ääni",
    "gui.soundTab.fileUploadSound": "Lataa ääni",
    "gui.soundTab.surpriseSound": "Yllätä",
    "gui.soundTab.recordSound": "Äänitä",
    "gui.soundTab.addSoundFromLibrary": "Valitse ääni",
    "gui.spriteLibrary.chooseASprite": "Valitse hahmo",
    "gui.tipsLibrary.tutorials": "Valitse oppitunti",
    "gui.alerts.createsuccess": "Uusi projekti luotu.",
    "gui.alerts.createcopysuccess": "Projekti on tallennettu kopiona.",
    "gui.alerts.createremixsuccess": "Projekti on tallennettu remiksinä.",
    "gui.alerts.creating": "Luodaan uutta...",
    "gui.alerts.creatingCopy": "Projektia kopioidaan...",
    "gui.alerts.creatingRemix": "Projektia remiksataan...",
    "gui.alerts.creatingError": "Projektia ei voitu luoda. Yritä uudelleen!",
    "gui.alerts.savingError": "Projektia ei voitu tallentaa.",
    "gui.alerts.savesuccess": "Projekti tallennettu.",
    "gui.alerts.saving": "Projektia tallennetaan...",
    "gui.alerts.cloudInfo": "Huomaa, että pilvimuuttujat tukevat vain numeroita, eivät kirjaimia tai symboleja. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lisätietoja.",
    "gui.alerts.importing": "Tuodaan...",
    "gui.defaultProject.meow": "Mau",
    "gui.defaultProject.variable": "muuttujani",
    "gui.howtos.intro-move-sayhello-hat.name": "Aloitus",
    "gui.howtos.intro-move.step_stepMove": "Lisää liikelohko",
    "gui.howtos.add-a-move-block.step_stepSay": "Lisää sano-lohko",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klikkaa vihreää lippua aloittaaksesi",
    "gui.howtos.intro-getting-started-ASL.name": "Aloitus - ASL",
    "gui.howtos.animate-a-name.name": "Animoi nimi",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Valitse kirjainhahmo",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Klikattaessa soita ääni",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Valitse toinen kirjainhahmo",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Muuta väriä",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Valitse toinen kirjainhahmo ja aseta se pyörimään",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Valitse toinen kirjainhahmo ja aseta se kasvamaan",
    "gui.howtos.imagine": "Kuvittele maailma",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Kirjoita mitä haluat sanoa",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klikkaa vihreää lippua aloittaaksesi",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Valitse mikä tahansa tausta",
    "gui.howtos.imagine.step_imagineChooseSprite": "Valitse mikä tahansa hahmo",
    "gui.howtos.imagine.step_imagineFlyAround": "Paina välilyöntiä liukuaksesi",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Valitse toinen hahmo",
    "gui.howtos.imagine.step_imagineLeftRight": "Liiku vasen-oikea",
    "gui.howtos.imagine.step_imagineUpDown": "Liiku ylös-alas",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Vaihda asusteita",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Liu'u pisteeseen",
    "gui.howtos.imagine.step_imagineGrowShrink": "Kasva ja kutistu",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Valitse toinen tausta",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Vaihda taustoja",
    "gui.howtos.imagine.step_imagineRecordASound": "Lisää ääni",
    "gui.howtos.imagine.step_imagineChooseSound": "Valitse äänesi",
    "gui.howtos.make-music.name": "Tee musiikkia",
    "gui.howtos.Make-Music.step_PickInstrument": "Valitse soitinhahmo",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Klikattaessa soita ääni",
    "gui.howtos.Make-Music.step_MakeSong": "Luo laulu",
    "gui.howtos.make-music.step_MakeBeat": "Valitse rumpu ja aseta sille rytmi",
    "gui.howtos.make-music.step_MakeBeatBox": "Valitse mikrofoni-hahmo ja yllätä beatboksaamalla",
    "gui.howtos.story.name": "Luo tarina",
    "gui.howtos.story.step_addbg": "Lisää tausta",
    "gui.howtos.story.step_addsprite": "Lisää hahmo",
    "gui.howtos.story.step_saysomething": "Sano jotain",
    "gui.howtos.story.step_addanothersprite": "Lisää toinen hahmo",
    "gui.howtos.story.step_flip": "Käännä suunta",
    "gui.howtos.story.step_conversation": "Keskustele",
    "gui.howtos.story.addanotherbg": "Lisää toinen tausta",
    "gui.howtos.story.step_swithbg": "Vaihda taustoja",
    "gui.howtos.story.step_hidewizard": "Piilota hahmo",
    "gui.howtos.story.step_showwizard": "Näytä hahmo",
    "gui.howtos.make-a-chase-game.name": "Tee jahtauspeli",
    "gui.howtos.Chase-Game.step_BG": "Lisää tausta",
    "gui.howtos.chase-game.step_AddOcto": "Lisää hahmo",
    "gui.howtos.make-music.step_LeftRight": "Liiku nuolinäppäimillä oikealle ja vasemmalle",
    "gui.howtos.Chase-Game.step_UpDown": "Liiku nuolinäppäimillä ylös ja alas",
    "gui.howtos.Chase-Game.step_AddStar": "Lisää toinen hahmo",
    "gui.howtos.Chase-Game.step_MoveRandom": "Liiku satunnaisesti",
    "gui.howtos.Chase-Game.step_WhenTouch": "Mustekala-hahmon koskettaessa toista ääni",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Luo pistemäärä-muuttuja",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Mustekala-hahmon koskettaessa lisää pisteitä",
    "gui.howtos.animate-char.name": "Animoi hahmo",
    "gui.howtos.animate-char.step_addbg": "Lisää tausta",
    "gui.howtos.animate-char.step_addsprite": "Lisää hahmo",
    "gui.howtos.animate-char.step_saysomething": "Sano jotain",
    "gui.howtos.animate-char.step_addsound": "Lisää ääni",
    "gui.howtos.animate-char.step_animatetalking": "Animoi puhetta",
    "gui.howtos.animate-char.step_arrowkeys": "Liiku nuolinäppäimillä",
    "gui.howtos.animate-char.step_jump": "Hyppää",
    "gui.howtos.animate-char.step_changecolor": "Muuta väriä",
    "gui.howtos.make-a-game.name": "Tee klikkailupeli",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Valitse hahmo",
    "gui.howtos.make-a-game.step_GamePlaySound": "Klikattaessa soita ääni",
    "gui.howtos.make-a-game.step_GameAddScore": "Luo pistemäärä-muuttuja",
    "gui.howtos.make-a-game.step_GameChangeScore": "Kun klikataan, kasvata pisteitä",
    "gui.howtos.make-a-game.step_Random": "Siirry satunnaiseen sijaintiin",
    "gui.howtos.make-music.step_GameChangeColor": "Muuta väriä",
    "gui.howtos.make-music.step_ResetScore": "Nollaa pisteet",
    "gui.howtos.make-it-fly.name": "Lennätä hahmoa",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Valitse taivas taustaksi",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Valitse hahmo",
    "gui.howtos.fly.step_stepflySaySomething": "Sano jotain",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Liiku nuolinäppäimillä",
    "gui.howtos.fly.step_stepflyChooseObject": "Valitse kerättävä kohde",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Tee kohteesta liikkuva",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Valitse hahmosi",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Lisää pisteet",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Säilytä pisteet",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Lisää maisema",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Liikuta maisemaa",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Seuraava asuste",
    "gui.howtos.pong": "Pong-peli",
    "gui.howtos.pong.step_pongAddBackdrop": "Lisää tausta",
    "gui.howtos.pong.step_pongAddBallSprite": "Lisää pallohahmo",
    "gui.howtos.pong.step_pongBounceAround": "Kimpoile ympäriinsä",
    "gui.howtos.pong.step_pongAddPaddle": "Lisää maila",
    "gui.howtos.pong.step_pongMoveThePaddle": "Liikuta mailaa",
    "gui.howtos.pong.step_pongSelectBallSprite": "Valitse pallohahmo",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Lisää koodi, joka kimmottaa pallon mailasta",
    "gui.howtos.pong.step_pongAddAScore": "Lisää pisteet",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Valitse 'Pisteet' valikosta",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Aseta \"lisää muuttujaan Pisteet\" -lohko paikoilleen",
    "gui.howtos.pong.step_pongResetScore": "Nollaa pisteet",
    "gui.howtos.pong.step_pongAddLineSprite": "Lisää viivahahmo",
    "gui.howtos.pong.step_pongGameOver": "Pelin loppu",
    "gui.howtos.code-cartoon": "Koodaa sarjakuva",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Sano jotakin, kun klikkaat vihreää lipua",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animoi hahmo, kun klikkaat sitä",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Valitse toinen hahmo",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Käytä miinusmerkkiä pienentääksesi",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Kasvata ja kutista hahmoa",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Valitse toinen hahmo",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hyppää ylös ja alas",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Napsauta hahmoa vaihtaaksesi näkymää",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Liu'u ympäri",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Vaihda asusteita",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Valitse lisää hahmoja, jotka haluat lisätä sarjakuvaasi",
    "gui.howtos.cartoon-network": "Animoi seikkailupeli",
    "gui.howtos.cartoon-network.step_CNcharacter": "Valitse näytettävä hahmo",
    "gui.howtos.cartoon-network.step_CNsay": "Sano jotain",
    "gui.howtos.cartoon-network.step_CNglide": "Liu'u ympäri",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Valitse jahdattava kohde",
    "gui.howtos.cartoon-network.step_CNcollect": "Kerää kohteita",
    "gui.howtos.cartoon-network.step_CNvariable": "Tee pistemäärä-muuttuja",
    "gui.howtos.cartoon-network.step_CNscore": "Säilytä pisteet",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Tason nosto: vaihda tausta",
    "gui.howtos.videosens.name": "Videohavainnointi",
    "gui.howtos.videosens.step_addextension": "Lisää laajennus",
    "gui.howtos.videosens.step_pet": "Paijaa kissaa",
    "gui.howtos.videosens.step_animate": "Animoi",
    "gui.howtos.videosens.step_pop": "Poksauta ilmapallo",
    "gui.howtos.say-it-out-loud": "Luo puhuvia animaatioita",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Lisää teksti puheeksi -lohkoja",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Sano jotain",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Aseta ääni",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Liikuskele",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Lisää tausta",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Lisää toinen hahmo",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Esitä laulu",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Muuta väriä",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Pyöri ympäri",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Kasva ja kutistu",
    "gui.howtos.talking": "Puhuvat tarinat",
    "gui.howtos.talking.step_talesAddExtension": "Klikkaa lisätäksesi teksti puheeksi -lohkoja",
    "gui.howtos.talking.step_talesChooseSprite": "Valitse hahmo",
    "gui.howtos.talking.step_talesSaySomething": "Aseta hahmo puhumaan",
    "gui.howtos.talking.step_talesChooseBackdrop": "Valitse tausta",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klikkaa hahmoa siirtyäksesi seuraavaan taustaan",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Valitse toinen hahmo",
    "gui.howtos.talking.step_talesMoveAround": "Liikuskele",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Valitse toinen tausta",
    "gui.howtos.talking.step_talesAnimateTalking": "Animoi puhetta",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Valitse toinen tausta",
    "gui.howtos.talking.step_talesChooseSound": "Valitse tanssittava kappale",
    "gui.howtos.talking.step_talesDanceMoves": "Tanssiliikkeet",
    "gui.howtos.talking.step_talesAskAnswer": "Hanki kysymys- ja vastauslohkot tuntoaisti-luokasta",
    "gui.howtos.add-sprite.name": "Lisää hahmo",
    "gui.howtos.add-sprite.step_addSprite": "Lisää hahmo",
    "gui.howtos.add-a-backdrop.name": "Lisää tausta",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Lisää tausta",
    "gui.howtos.change-size.name": "Kasvata kokoa",
    "gui.howtos.change-size.step_changeSize": "Kasvata kokoa",
    "gui.howtos.glide-around.name": "Liu'u ympäri",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Liu'u ympäri",
    "gui.howtos.change-size.step_glideAroundPoint": "Liu'u pisteeseen",
    "gui.howtos.record-a-sound.name": "Äänitä ääni",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Paina 'Äänet'-välilehteä",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Paina 'Nauhoita'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Paina nauhoituspainiketta",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Valitse äänesi",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Soita äänesi",
    "gui.howtos.spin-video.name": "Aseta se pyörimään",
    "gui.howtos.change-size.step_spinTurn": "Käänny",
    "gui.howtos.change-size.step_spinPointInDirection": "Aseta suunta",
    "gui.howtos.hide-and-show.name": "Piilota ja näytä",
    "gui.howtos.change-size.step_hideAndShow": "Piilota ja näytä",
    "gui.howtos.switch-costume.name": "Animoi hahmo",
    "gui.howtos.change-size.step_switchCostumes": "Animoi hahmo",
    "gui.howtos.move-around-with-arrow-keys.name": "Käytä nuolinäppäimiä",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Liiku vasemmalle ja oikealle",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Liiku ylös ja alas",
    "gui.howtos.add-effects.name": "Lisää tehosteita",
    "gui.howtos.videosens.step_addEffects": "Lisää tehosteita",
    "gui.extension.music.name": "Musiikki",
    "gui.extension.music.description": "Soita soittimia ja rumpuja.",
    "gui.extension.pen.name": "Kynä",
    "gui.extension.pen.description": "Piirrä hahmoillasi.",
    "gui.extension.videosensing.name": "Videohavainnointi",
    "gui.extension.videosensing.description": "Havaitse liike kameran avulla.",
    "gui.extension.text2speech.name": "Teksti puheeksi",
    "gui.extension.text2speech.description": "Tee projektisi puhuviksi.",
    "gui.extension.translate.name": "Käännä",
    "gui.extension.translate.description": "Käännä tekstiä useille kielille.",
    "gui.extension.makeymakey.description": "Tee mistä tahansa näppäin.",
    "gui.extension.microbit.description": "Yhdistä projektisi maailman kanssa.",
    "gui.extension.microbit.connectingMessage": "Yhdistetään",
    "gui.extension.ev3.description": "Rakenna vuorovaikutteisia robotteja ja paljon muuta.",
    "gui.extension.ev3.connectingMessage": "Yhdistetään. Varmista, että EV3:n PIN-koodi on 1234.",
    "gui.extension.boost.description": "Herätä robottiluomukset henkiin.",
    "gui.extension.boost.connectingMessage": "Yhdistetään",
    "gui.extension.wedo2.description": "Rakenna käyttäen moottoreita ja sensoreita.",
    "gui.extension.wedo2.connectingMessage": "Yhdistetään",
    "gui.extension.gdxfor.description": "Havaitse työntö, veto, liike ja pyöriminen.",
    "gui.extension.gdxfor.connectingMessage": "Yhdistetään",
    "gui.libraryTags.all": "Kaikki",
    "gui.libraryTags.animals": "Eläimet",
    "gui.libraryTags.dance": "Tanssi",
    "gui.libraryTags.effects": "Efektit",
    "gui.libraryTags.fantasy": "Fantasia",
    "gui.libraryTags.fashion": "Muoti",
    "gui.libraryTags.food": "Ruoka",
    "gui.libraryTags.indoors": "Sisällä",
    "gui.libraryTags.loops": "Toistorakenteet",
    "gui.libraryTags.music": "Musiikki",
    "gui.libraryTags.notes": "Nuotit",
    "gui.libraryTags.outdoors": "Ulkona",
    "gui.libraryTags.patterns": "Kuviot",
    "gui.libraryTags.people": "Ihmiset",
    "gui.libraryTags.percussion": "Rummut",
    "gui.libraryTags.space": "Avaruus",
    "gui.libraryTags.sports": "Urheilu",
    "gui.libraryTags.underwater": "Vedenalainen",
    "gui.libraryTags.voice": "Ääni",
    "gui.libraryTags.wacky": "Outo",
    "gui.libraryTags.animation": "Animaatio",
    "gui.libraryTags.art": "Taide",
    "gui.libraryTags.games": "Pelit",
    "gui.libraryTags.stories": "Tarinat",
    "gui.libraryTags.letters": "Kirjaimet",
    "gui.opcodeLabels.direction": "suunta",
    "gui.opcodeLabels.xposition": "x-sijainti",
    "gui.opcodeLabels.yposition": "y-sijainti",
    "gui.opcodeLabels.size": "koko",
    "gui.opcodeLabels.costumename": "asusteen nimi",
    "gui.opcodeLabels.costumenumber": "asusteen numero",
    "gui.opcodeLabels.backdropname": "taustan nimi",
    "gui.opcodeLabels.backdropnumber": "taustan numero",
    "gui.opcodeLabels.volume": "äänenvoimakkuus",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "vastaus",
    "gui.opcodeLabels.loudness": "äänentaso",
    "gui.opcodeLabels.username": "käyttäjänimi",
    "gui.opcodeLabels.year": "vuosi",
    "gui.opcodeLabels.month": "kuukausi",
    "gui.opcodeLabels.date": "päiväys",
    "gui.opcodeLabels.dayofweek": "viikonpäivä",
    "gui.opcodeLabels.hour": "tunti",
    "gui.opcodeLabels.minute": "minuutti",
    "gui.opcodeLabels.second": "sekunti",
    "gui.opcodeLabels.timer": "ajastin",
    "gui.projectLoader.loadError": "Valitun projektitiedoston lataaminen epäonnistui.",
    "gui.sharedMessages.backdrop": "tausta{index}",
    "gui.sharedMessages.costume": "asuste{index}",
    "gui.sharedMessages.sprite": "Hahmo{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Korvataanko nykyisen projektin sisältö?",
    "gui.sharedMessages.loadFromComputerTitle": "Avaa tietokoneeltasi",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch-projekti",
    "boost.color.any": "mikä tahansa väri",
    "boost.color.black": "musta",
    "boost.color.blue": "sininen",
    "boost.color.green": "vihreä",
    "boost.color.red": "punainen",
    "boost.color.white": "valkoinen",
    "boost.color.yellow": "keltainen",
    "boost.getMotorPosition": "moottorin [MOTOR_REPORTER_ID] asento",
    "boost.getTiltAngle": "kallista suuntaan [TILT_DIRECTION]",
    "boost.motorDirection.backward": "tuohon suuntaan",
    "boost.motorDirection.forward": "tähän suuntaan",
    "boost.motorDirection.reverse": "vaihda suuntaa",
    "boost.motorOff": "laita moottori [MOTOR_ID] pois päältä",
    "boost.motorOn": "laita moottori [MOTOR_ID] päälle",
    "boost.motorOnFor": "käynnistä moottori [MOTOR_ID] [DURATION] sekunniksi",
    "boost.motorOnForRotation": "käynnistä moottori [MOTOR_ID] [ROTATION] kierroksen ajan",
    "boost.seeingColor": "näkeekö värin [COLOR]?",
    "boost.setLightHue": "aseta valon väriksi [HUE]",
    "boost.setMotorDirection": "aseta moottorin [MOTOR_ID] suunnaksi [MOTOR_DIRECTION]",
    "boost.setMotorPower": "aseta moottorin [MOTOR_ID] nopeudeksi [POWER] %",
    "boost.tiltDirection.any": "mikä tahansa",
    "boost.tiltDirection.down": "alas",
    "boost.tiltDirection.left": "vasen",
    "boost.tiltDirection.right": "oikea",
    "boost.tiltDirection.up": "ylös",
    "boost.whenColor": "kun [COLOR] nähty",
    "boost.whenTilted": "kun kallistettu suuntaan [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "soita nuottia [NOTE] [TIME] sekuntia",
    "ev3.buttonPressed": "onko nappia painettu portissa [PORT]?",
    "ev3.getBrightness": "kirkkaus",
    "ev3.getDistance": "etäisyys",
    "ev3.getMotorPosition": "moottorin [PORT] asento",
    "ev3.motorSetPower": "aseta moottorin [PORT] tehoksi [POWER] %",
    "ev3.motorTurnClockwise": "käännä moottoria [PORT] myötäpäivään [TIME] sekuntia",
    "ev3.motorTurnCounterClockwise": "käännä moottoria [PORT] vastapäivään [TIME] sekuntia",
    "ev3.whenBrightnessLessThan": "kun kirkkaus < [DISTANCE]",
    "ev3.whenButtonPressed": "kun nappia painetaan portissa [PORT]",
    "ev3.whenDistanceLessThan": "kun etäisyys < [DISTANCE]",
    "gdxfor.getAcceleration": "kiihtyvyys [DIRECTION]",
    "gdxfor.getForce": "voima",
    "gdxfor.getSpin": "pyörimisnopeus [DIRECTION]",
    "gdxfor.getTilt": "kallistuskulma [TILT]",
    "gdxfor.isFreeFalling": "putoaako?",
    "gdxfor.isTilted": "onko kallistus [TILT]?",
    "gdxfor.pulled": "vedetään",
    "gdxfor.pushed": "työnnetään",
    "gdxfor.shaken": "ravistettu",
    "gdxfor.startedFalling": "putoaminen alkoi",
    "gdxfor.tiltDirectionMenu.any": "mikä tahansa",
    "gdxfor.tiltDirectionMenu.back": "taka",
    "gdxfor.tiltDirectionMenu.front": "etu",
    "gdxfor.tiltDirectionMenu.left": "vasen",
    "gdxfor.tiltDirectionMenu.right": "oikea",
    "gdxfor.turnedFaceDown": "käännetty alaspäin",
    "gdxfor.turnedFaceUp": "käännetty ylöspäin",
    "gdxfor.whenForcePushedOrPulled": "kun voima-anturia [PUSH_PULL]",
    "gdxfor.whenGesture": "kun on [GESTURE]",
    "gdxfor.whenTilted": "kun kallistus [TILT]",
    "makeymakey.downArrow": "nuoli alas",
    "makeymakey.downArrowShort": "alas",
    "makeymakey.leftArrow": "nuoli vasemmalle",
    "makeymakey.leftArrowShort": "vasen",
    "makeymakey.rightArrow": "nuoli oikealle",
    "makeymakey.rightArrowShort": "oikea",
    "makeymakey.spaceKey": "välilyönti",
    "makeymakey.upArrow": "nuoli ylös",
    "makeymakey.upArrowShort": "ylös",
    "makeymakey.whenKeyPressed": "kun [KEY]-näppäintä painetaan",
    "makeymakey.whenKeysPressedInOrder": "kun [SEQUENCE] painetaan järjestyksessä",
    "microbit.buttonsMenu.any": "mikä tahansa",
    "microbit.clearDisplay": "tyhjennä näyttö",
    "microbit.defaultTextToDisplay": "Hei!",
    "microbit.displaySymbol": "näytä [MATRIX]",
    "microbit.displayText": "näytä teksti [TEXT]",
    "microbit.gesturesMenu.jumped": "hypätty",
    "microbit.gesturesMenu.moved": "siirretty",
    "microbit.gesturesMenu.shaken": "ravistettu",
    "microbit.isButtonPressed": "onko nappia [BTN] painettu?",
    "microbit.isTilted": "onko kallistus suuntaan [DIRECTION]?",
    "microbit.pinStateMenu.off": "pois",
    "microbit.pinStateMenu.on": "päälle",
    "microbit.tiltAngle": "kallista suuntaan [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "mikä tahansa",
    "microbit.tiltDirectionMenu.back": "taka",
    "microbit.tiltDirectionMenu.front": "etu",
    "microbit.tiltDirectionMenu.left": "vasen",
    "microbit.tiltDirectionMenu.right": "oikea",
    "microbit.whenButtonPressed": "kun nappia [BTN] painetaan",
    "microbit.whenGesture": "kun on [GESTURE]",
    "microbit.whenPinConnected": "kun nasta [PIN] yhdistetty",
    "microbit.whenTilted": "kun kallistettu suuntaan [DIRECTION]",
    "music.categoryName": "Musiikki",
    "music.changeTempo": "lisää tempoa arvolla [TEMPO]",
    "music.drumBass": "(2) Bassorumpu",
    "music.drumBongo": "(13) Bongo-rumpu",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Rytmikapulat",
    "music.drumClosedHiHat": "(6) Suljettu hi-hat",
    "music.drumConga": "(14) Conga-rumpu",
    "music.drumCowbell": "(11) Lehmänkello",
    "music.drumCrashCymbal": "(4) Crash-lautanen",
    "music.drumCuica": "(18) Cuica-rumpu",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Taputus",
    "music.drumOpenHiHat": "(5) Avoin hi-hat",
    "music.drumSideStick": "(3) Sivuisku rumpuun",
    "music.drumSnare": "(1) Virvelirumpu",
    "music.drumTambourine": "(7) Tamburiini",
    "music.drumTriangle": "(12) Triangeli",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Puupalikka",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Basso",
    "music.instrumentBassoon": "(14) Fagotti",
    "music.instrumentCello": "(8) Sello",
    "music.instrumentChoir": "(15) Kuoro",
    "music.instrumentClarinet": "(10) Klarinetti",
    "music.instrumentElectricGuitar": "(5) Sähkökitara",
    "music.instrumentElectricPiano": "(2) Sähköpiano",
    "music.instrumentFlute": "(12) Huilu",
    "music.instrumentGuitar": "(4) Kitara",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Soittorasia",
    "music.instrumentOrgan": "(3) Urut",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Näppäily",
    "music.instrumentSaxophone": "(11) Saksofoni",
    "music.instrumentSteelDrum": "(18) Tynnyrirumpu",
    "music.instrumentSynthLead": "(20) Syntetisaattori (lead-efekti)",
    "music.instrumentSynthPad": "(21) Syntetisaattori (pad-efekti)",
    "music.instrumentTrombone": "(9) Pasuuna",
    "music.instrumentVibraphone": "(16) Vibrafoni",
    "music.instrumentWoodenFlute": "(13) Puuhuilu",
    "music.midiPlayDrumForBeats": "soita rumpua [DRUM] [BEATS] iskun ajan",
    "music.midiSetInstrument": "aseta soittimeksi [INSTRUMENT]",
    "music.playDrumForBeats": "soita rumpua [DRUM] [BEATS] iskun ajan",
    "music.playNoteForBeats": "soita nuottia [NOTE] [BEATS] iskun ajan",
    "music.restForBeats": "tauko [BEATS] iskun ajan",
    "music.setInstrument": "aseta soittimeksi [INSTRUMENT]",
    "music.setTempo": "aseta tempoksi [TEMPO]",
    "pen.categoryName": "Kynä",
    "pen.changeColorParam": "lisää kynän väriä [COLOR_PARAM] arvolla [VALUE]",
    "pen.changeHue": "lisää kynän väriä arvolla [HUE]",
    "pen.changeShade": "lisää kynän tummuutta arvolla [SHADE]",
    "pen.changeSize": "lisää kynän kokoa arvolla [SIZE]",
    "pen.clear": "pyyhi kaikki",
    "pen.colorMenu.brightness": "kirkkaus",
    "pen.colorMenu.color": "väri",
    "pen.colorMenu.saturation": "värikylläisyys",
    "pen.colorMenu.transparency": "läpinäkyvyys",
    "pen.penDown": "kynä alas",
    "pen.penUp": "kynä ylös",
    "pen.setColor": "aseta kynän väriksi [COLOR]",
    "pen.setColorParam": "aseta kynän värin [COLOR_PARAM] arvoksi [VALUE]",
    "pen.setHue": "aseta kynän väriksi [HUE]",
    "pen.setShade": "aseta kynän tummuudeksi [SHADE]",
    "pen.setSize": "aseta kynän kooksi [SIZE]",
    "pen.stamp": "leimaa",
    "speech.defaultWhenIHearValue": "mennään",
    "speech.extensionName": "Puhe tekstiksi",
    "speech.listenAndWait": "kuuntele ja odota",
    "speech.speechReporter": "puhe",
    "speech.whenIHear": "kun kuulen [PHRASE]",
    "text2speech.alto": "altto",
    "text2speech.categoryName": "Teksti puheeksi",
    "text2speech.defaultTextToSpeak": "hei",
    "text2speech.giant": "jätti",
    "text2speech.kitten": "kissanpentu",
    "text2speech.setLanguageBlock": "aseta kieleksi [LANGUAGE]",
    "text2speech.setVoiceBlock": "aseta ääneksi [VOICE]",
    "text2speech.speakAndWaitBlock": "puhu [WORDS]",
    "text2speech.squeak": "vingahdus",
    "text2speech.tenor": "tenori",
    "translate.categoryName": "Käännä",
    "translate.defaultTextToTranslate": "hei",
    "translate.translateBlock": "käännä [WORDS] kielelle [LANGUAGE]",
    "translate.viewerLanguage": "kieli",
    "videoSensing.categoryName": "Videohavainnointi",
    "videoSensing.direction": "suunta",
    "videoSensing.motion": "liike",
    "videoSensing.off": "pois",
    "videoSensing.on": "päälle",
    "videoSensing.onFlipped": "käännettäessä",
    "videoSensing.setVideoTransparency": "aseta videon läpinäkyvyys arvoon [TRANSPARENCY]",
    "videoSensing.sprite": "hahmo",
    "videoSensing.stage": "esiintymislava",
    "videoSensing.videoOn": "[SUBJECT]n [ATTRIBUTE] videolla",
    "videoSensing.videoToggle": "kytke video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "kun videon liike > [REFERENCE]",
    "wedo2.getDistance": "etäisyys",
    "wedo2.getTiltAngle": "kallista suuntaan [TILT_DIRECTION]",
    "wedo2.isTilted": "onko kallistettu suuntaan [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "tuohon suuntaan",
    "wedo2.motorDirection.forward": "tähän suuntaan",
    "wedo2.motorDirection.reverse": "vaihda suuntaa",
    "wedo2.motorId.a": "moottori A",
    "wedo2.motorId.all": "kaikki moottorit",
    "wedo2.motorId.b": "moottori B",
    "wedo2.motorId.default": "moottori",
    "wedo2.motorOff": "laita [MOTOR_ID] pois päältä",
    "wedo2.motorOn": "laita [MOTOR_ID] päälle",
    "wedo2.motorOnFor": "laita [MOTOR_ID] päälle [DURATION] sekunniksi",
    "wedo2.playNoteFor": "soita nuottia [NOTE] [DURATION] sekuntia",
    "wedo2.setLightHue": "aseta valon väriksi [HUE]",
    "wedo2.setMotorDirection": "aseta moottorin [MOTOR_ID] suunnaksi [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "aseta moottorin [MOTOR_ID] teho arvoon [POWER]",
    "wedo2.tiltDirection.any": "mikä tahansa",
    "wedo2.tiltDirection.down": "alas",
    "wedo2.tiltDirection.left": "vasen",
    "wedo2.tiltDirection.right": "oikea",
    "wedo2.tiltDirection.up": "ylös",
    "wedo2.whenDistance": "kun etäisyys [OP] [REFERENCE]",
    "wedo2.whenTilted": "kun kallistettu suuntaan [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Väri",
    "paint.paintEditor.saturation": "Värikylläisyys",
    "paint.paintEditor.brightness": "Kirkkaus",
    "paint.paintEditor.costume": "Asuste",
    "paint.paintEditor.group": "Ryhmitä",
    "paint.paintEditor.ungroup": "Pura ryhmitys",
    "paint.paintEditor.undo": "Kumoa",
    "paint.paintEditor.redo": "Tee uudelleen",
    "paint.paintEditor.forward": "Eteenpäin",
    "paint.paintEditor.backward": "Taaksepäin",
    "paint.paintEditor.front": "Eteen",
    "paint.paintEditor.back": "Taakse",
    "paint.paintEditor.more": "Enemmän",
    "paint.modeTools.brushSize": "Koko",
    "paint.modeTools.eraserSize": "Kumin koko",
    "paint.modeTools.copy": "Kopioi",
    "paint.modeTools.paste": "Liitä",
    "paint.modeTools.delete": "Poista",
    "paint.modeTools.curved": "Kaartuva",
    "paint.modeTools.pointed": "Teräväkärkinen",
    "paint.modeTools.thickness": "Paksuus",
    "paint.modeTools.flipHorizontal": "Käännä vaakasuoraan",
    "paint.modeTools.flipVertical": "Käännä pystysuoraan",
    "paint.modeTools.filled": "Täytetty",
    "paint.modeTools.outlined": "Ääriviivallinen",
    "paint.paintEditor.bitmap": "Muunna bittikartaksi",
    "paint.paintEditor.vector": "Muunna vektoriksi",
    "paint.paintEditor.fill": "Täytä",
    "paint.paintEditor.stroke": "Ääriviiva",
    "paint.brushMode.brush": "Sivellin",
    "paint.eraserMode.eraser": "Pyyhekumi",
    "paint.fillMode.fill": "Täytä",
    "paint.lineMode.line": "Viiva",
    "paint.ovalMode.oval": "Ympyrä",
    "paint.rectMode.rect": "Suorakulmio",
    "paint.reshapeMode.reshape": "Muotoile uudelleen",
    "paint.roundedRectMode.roundedRect": "Pyöristetty suorakulmio",
    "paint.selectMode.select": "Valitse",
    "paint.textMode.text": "Teksti",
    "paint.colorPicker.swap": "Vaihda"
  },
  "sv": {
    "gui.alerts.lostPeripheralConnection": "Scratch tappade kontakt med{extensionName}.",
    "gui.alerts.tryAgain": "Försök igen",
    "gui.alerts.download": "Ladda ned",
    "gui.connection.reconnect": "Återanslut",
    "gui.backpack.costumeLabel": "klädsel",
    "gui.backpack.soundLabel": "ljud",
    "gui.backpack.scriptLabel": "skript",
    "gui.backpack.spriteLabel": "sprajt",
    "gui.backpack.header": "Ryggsäck",
    "gui.backpack.errorBackpack": "Problem att ladda ryggsäcken",
    "gui.backpack.loadingBackpack": "Laddar...",
    "gui.backpack.more": "Mer",
    "gui.backpack.emptyBackpack": "Ryggsäcken är tom",
    "gui.unsupportedBrowser.label": "Webbläsaren stöds ej",
    "gui.unsupportedBrowser.errorLabel": "Ett fel uppstod",
    "gui.unsupportedBrowser.notRecommended": "Vi ber om ursäkt, det verkar som du använder en version av webbläsare som inte stödjer Scratch. Vi rekommenderar att du uppdaterar till en webbläsare som vi stödjer, exempelvis Google Chrome, Mozilla Firefox, Microsoft Edge, eller Apples Safari.",
    "gui.unsupportedBrowser.description": "Vi ber om ursäkt, men Scratch stödjer inte den här webbläsaren. Vi rekommenderar att du prövar en annan webbläsare som vi stödjer, exempelvis Google Chrome, Mozilla Firefox, Microsoft Edge, eller Apples Safari.",
    "gui.unsupportedBrowser.back": "Placera längst bak",
    "gui.unsupportedBrowser.previewfaq": "För att läsa mer, gå till {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Handledningar",
    "gui.cards.shrink": "Förminska",
    "gui.cards.expand": "Förstora",
    "gui.cards.close": "Stäng",
    "gui.cards.more-things-to-try": "Fler saker att pröva!",
    "gui.cards.see-more": "Läs mera",
    "gui.comingSoon.message1": "Det är lugnt, vi jobbar på det {emoji}",
    "gui.comingSoon.message2": "Kommer snart...",
    "gui.comingSoon.message3": "Vi jobbar på det {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Enheter saknas",
    "gui.connection.auto-scanning.prescan": "Ha din enhet i närheten, sök sedan efter den.",
    "gui.connection.auto-scanning.pressbutton": "Tryck på knappen på din enhet.",
    "gui.connection.auto-scanning.start-search": "Börja söka",
    "gui.connection.connecting-searchbutton": "Söker...",
    "gui.connection.auto-scanning.try-again": "Försök igen",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Uppkopplad",
    "gui.connection.disconnect": "Koppla ur",
    "gui.connection.go-to-editor": "Gå till redigeraren",
    "gui.connection.connecting-cancelbutton": "Kopplar upp...",
    "gui.connection.error.errorMessage": "Hoppsan, det verkar som om något gick fel.",
    "gui.connection.error.tryagainbutton": "Försök igen",
    "gui.connection.error.helpbutton": "Hjälp",
    "gui.connection.peripheral-name-label": "Enhetens namn",
    "gui.connection.connect": "Koppla upp",
    "gui.connection.scanning.lookingforperipherals": "Letar efter enheter",
    "gui.connection.scanning.noPeripheralsFound": "Enheter saknas",
    "gui.connection.scanning.instructions": "Välj din enhet i ovanstående lista.",
    "gui.connection.search": "Uppdatera",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Se till att du har Scratchkopplingen installerad och igång",
    "gui.connection.unavailable.enablebluetooth": "Kolla så att bluetooth är igång",
    "gui.connection.unavailable.tryagainbutton": "Försök igen",
    "gui.connection.unavailable.helpbutton": "Hjälp",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Starta",
    "gui.controls.stop": "Stoppa",
    "gui.crashMessage.label": "Oj! Något gick fel.",
    "gui.crashMessage.description": "Vi ber om ursäkt men det verkar som om Scratch har kraschat. Denna bugg har automatiskt rapporterats till Scratch teamet. Var snäll och uppdatera din sida för att försöka igen.",
    "gui.crashMessage.errorNumber": "Ditt fel loggades med id {errorId}",
    "gui.crashMessage.reload": "Uppdatera",
    "gui.customProcedures.myblockModalTitle": "Skapa ett block",
    "gui.customProcedures.addAnInputNumberText": "Lägg till en indata",
    "gui.customProcedures.numberTextType": "siffror eller text",
    "gui.customProcedures.addAnInputBoolean": "Lägg till en indata",
    "gui.customProcedures.booleanType": "boolesk",
    "gui.customProcedures.addALabel": "Lägg till en etikett",
    "gui.customProcedures.runWithoutScreenRefresh": "Kör utan skärmuppdatering",
    "gui.customProcedures.cancel": "Avbryt",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Riktning",
    "gui.directionPicker.rotationStyles.allAround": "Rotera",
    "gui.directionPicker.rotationStyles.leftRight": "Vänster/Höger",
    "gui.directionPicker.rotationStyles.dontRotate": "Rotera inte",
    "gui.gui.addExtension": "Lägg till ett tillägg",
    "gui.gui.codeTab": "Kod",
    "gui.gui.backdropsTab": "Bakgrunder",
    "gui.gui.costumesTab": "Klädslar",
    "gui.gui.soundsTab": "Ljud",
    "gui.extensionLibrary.comingSoon": "Kommer snart",
    "gui.extensionLibrary.requires": "Kräver",
    "gui.extensionLibrary.collaboration": "Samarbetar med",
    "gui.library.filterPlaceholder": "Sök",
    "gui.library.allTag": "Alla",
    "gui.loader.message1": "Skapa block ...",
    "gui.loader.message2": "Laddar sprajtar...",
    "gui.loader.message3": "Laddar ljud...",
    "gui.loader.message4": "Laddar tillägg...",
    "gui.loader.message5": "Samlar katter...",
    "gui.loader.message6": "Överför nanos...",
    "gui.loader.message7": "Förstorar gobos...",
    "gui.loader.message8": "Förbereder emojis ...",
    "gui.loader.headline": "Laddar projekt",
    "gui.loader.creating": "Skapa projekt",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Mina grejer",
    "gui.accountMenu.myClasses": "Mina klasser",
    "gui.accountMenu.myClass": "Min klass",
    "gui.accountMenu.accountSettings": "Kontoinställningar",
    "gui.accountMenu.signOut": "Logga ut",
    "gui.authorInfo.byUser": "av {username}",
    "gui.menuBar.seeProjectPage": "Se projektsidan",
    "gui.menuBar.language": "Language",
    "general.username": "Användarnamn",
    "general.password": "Lösenord",
    "general.signIn": "Logga in",
    "login.needHelp": "Behöver du hjälp?",
    "form.validationRequired": "Fältet är nödvändigt",
    "gui.menuBar.tutorialsLibrary": "Handledningar",
    "gui.menuBar.restoreSprite": "Återställ sprajt",
    "gui.menuBar.restoreSound": "Ta tillbaka ljud",
    "gui.menuBar.restoreCostume": "Ta tillbaka sprajt",
    "gui.menuBar.restore": "Återställ",
    "gui.menuBar.saveNow": "Spara nu",
    "gui.menuBar.saveAsCopy": "Spara som kopia",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "Nytt",
    "gui.menuBar.file": "Arkiv",
    "gui.menuBar.downloadToComputer": "Spara till din dator",
    "gui.menuBar.edit": "Redigera",
    "gui.menuBar.turboModeOff": "Stäng av turboläge",
    "gui.menuBar.turboModeOn": "Sätt på turboläge",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Gå med Scratch",
    "gui.menuBar.signIn": "Logga in",
    "gui.gui.projectTitlePlaceholder": "Projektets titel här",
    "gui.menuBar.saveNowLink": "Spara nu",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Delade",
    "gui.menuBar.share": "Dela",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Hjälp",
    "gui.modal.back": "Tillbaka",
    "gui.monitor.listMonitor.empty": "(tom)",
    "gui.monitor.listMonitor.listLength": "längd {length}",
    "gui.monitor.contextMenu.default": "normal avläsning",
    "gui.monitor.contextMenu.large": "stor avläsning",
    "gui.monitor.contextMenu.slider": "reglage",
    "gui.monitor.contextMenu.sliderRange": "ändra skjutreglagets omfång",
    "gui.monitor.contextMenu.import": "importera",
    "gui.monitor.contextMenu.export": "exportera",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Spela upp",
    "gui.playButton.stop": "Stoppa",
    "gui.gui.variableScopeOptionAllSprites": "För alla sprajtar",
    "gui.gui.variableScopeOptionSpriteOnly": "Enbart för denna sprajt",
    "gui.gui.cloudVariableOption": "Molnvariabel (sparad på servern)",
    "gui.gui.variablePromptAllSpritesMessage": "Variabeln blir tillgänglig för alla sprajtar.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Avbryt",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stoppa",
    "gui.playbackStep.playMsg": "Spela upp",
    "gui.playbackStep.loadingMsg": "Laddar...",
    "gui.playbackStep.saveMsg": "Spara",
    "gui.playbackStep.reRecordMsg": "Spela in igen",
    "gui.recordModal.title": "Spela in nytt ljud",
    "gui.recordingStep.beginRecord": "Klicka på knappen nedan för att starta inspelningen",
    "gui.recordingStep.permission": "{arrow}Vi behöver ditt tillstånd för att använda mikrofonen",
    "gui.recordingStep.stop": "Stoppa inspelningen",
    "gui.recordingStep.record": "Spela in",
    "gui.sliderModal.min": "Minivärde",
    "gui.sliderModal.max": "Maxvärde",
    "gui.sliderModal.title": "Ändra skjutreglagets omfång",
    "gui.sliderPrompt.cancel": "Avbryt",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Ljud",
    "gui.soundEditor.play": "Spela upp",
    "gui.soundEditor.stop": "Stoppa",
    "gui.soundEditor.copy": "Kopiera",
    "gui.soundEditor.paste": "Klistra in",
    "gui.soundEditor.copyToNew": "Kopiera till ny",
    "gui.soundEditor.delete": "Radera",
    "gui.soundEditor.save": "Spara",
    "gui.soundEditor.undo": "Ångra",
    "gui.soundEditor.redo": "Gör om",
    "gui.soundEditor.faster": "Snabbare",
    "gui.soundEditor.slower": "Långsammare",
    "gui.soundEditor.echo": "Eko",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Högre",
    "gui.soundEditor.softer": "Lägre",
    "gui.soundEditor.reverse": "Baklänges",
    "gui.soundEditor.fadeOut": "Tona ut",
    "gui.soundEditor.fadeIn": "Tona in",
    "gui.soundEditor.mute": "Tyst",
    "gui.SpriteInfo.spritePlaceholder": "Namn",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Sprajt",
    "gui.SpriteInfo.show": "Visa",
    "gui.SpriteInfo.size": "Storlek",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kopiera",
    "gui.spriteSelectorItem.contextMenuExport": "exportera",
    "gui.spriteSelectorItem.contextMenuDelete": "radera",
    "gui.spriteSelector.addSpriteFromLibrary": "Välj en sprajt",
    "gui.spriteSelector.addSpriteFromPaint": "Måla",
    "gui.spriteSelector.addSpriteFromSurprise": "Överraska",
    "gui.spriteSelector.addSpriteFromFile": "Ladda upp sprajt",
    "gui.stageHeader.stageSizeLarge": "Byt till en större scen",
    "gui.stageHeader.stageSizeSmall": "Byt till en mindre scen",
    "gui.stageHeader.stageSizeFull": "Byt till fullskärmsläge",
    "gui.stageHeader.stageSizeUnFull": "Gå ur fullskärmsläge",
    "gui.stageHeader.fullscreenControl": "Fullskärmsläge",
    "gui.spriteSelector.addBackdropFromLibrary": "Välj en bakgrund",
    "gui.stageSelector.addBackdropFromPaint": "Måla",
    "gui.stageSelector.addBackdropFromSurprise": "Överraska",
    "gui.stageSelector.addBackdropFromFile": "Ladda upp bakgrund",
    "gui.stageSelector.stage": "Scen",
    "gui.stageSelector.backdrops": "Bakgrunder",
    "gui.telemetryOptIn.label": "Rapporterar statistik för att förbättra Scratch",
    "gui.telemetryOptIn.body1": "Scratchteamet försöker hela tiden förstå hur Scratch används runt om i världen. För att hjälpa till kan du låta Scratch automatiskt skicka användarinformation till Scratchteamet.",
    "gui.telemetryOptIn.body2": "Informationen som vi samlar in inkluderar val av språk, använda block och några händelser som spara, öppna och ladda upp ett projekt. Vi SAMLAR INTE in någon personlig information. Läs mer om vår {privacyPolicyLink}.",
    "gui.telemetryOptIn.privacyPolicyLink": "Sekretess",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Aktivera fjärrmätning",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Inaktivera fjärrmätning",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Stäng",
    "gui.turboMode.active": "Turboläge",
    "gui.webglModal.label": "Din webbläsare stödjer inte WebGL",
    "gui.webglModal.description": "Tyvärr verkar det som om din webbläsare eller dator {webGlLink}. Tekniken behövs för att Scratch 3.0 ska fungera.",
    "gui.webglModal.webgllink": "stödjer inte webGL",
    "gui.webglModal.back": "Tillbaka",
    "gui.webglModal.previewfaq": "För att läsa mer, gå till {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Välj en bakgrund",
    "gui.costumeLibrary.chooseACostume": "Välj en klädsel",
    "gui.costumeTab.addBackdropFromLibrary": "Välj en bakgrund",
    "gui.costumeTab.addCostumeFromLibrary": "Välj en klädsel",
    "gui.costumeTab.addBlankCostume": "Måla",
    "gui.costumeTab.addSurpriseCostume": "Överraska",
    "gui.costumeTab.addFileBackdrop": "Ladda upp bakgrund",
    "gui.costumeTab.addFileCostume": "Ladda upp klädsel",
    "gui.extensionLibrary.chooseAnExtension": "Välj ett tillägg",
    "gui.extensionLibrary.extensionUrl": "Skriv in en URL till tillägget",
    "gui.monitors.importListColumnPrompt": "Vilken kolumn ska användas (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Kunde inte starta inspelning",
    "gui.soundLibrary.chooseASound": "Välj ett ljud",
    "gui.soundTab.fileUploadSound": "Ladda upp ljud från fil",
    "gui.soundTab.surpriseSound": "Överraska",
    "gui.soundTab.recordSound": "Spela in",
    "gui.soundTab.addSoundFromLibrary": "Välj ett ljud",
    "gui.spriteLibrary.chooseASprite": "Välj en sprajt",
    "gui.tipsLibrary.tutorials": "Välj en handledning",
    "gui.alerts.createsuccess": "Nytt projekt skapat.",
    "gui.alerts.createcopysuccess": "Projektet sparat som en kopia.",
    "gui.alerts.createremixsuccess": "Projektet sparat som en remix.",
    "gui.alerts.creating": "Skapar nytt...",
    "gui.alerts.creatingCopy": "Kopierar projektet...",
    "gui.alerts.creatingRemix": "Remixar projektet...",
    "gui.alerts.creatingError": "Kunde inte skapa projektet. Försök igen!",
    "gui.alerts.savingError": "Projektet kunde inte sparas.",
    "gui.alerts.savesuccess": "Projektet sparat.",
    "gui.alerts.saving": "Sparar projektet...",
    "gui.alerts.cloudInfo": "Observera att molnvariabler enbart stödjer siffror, inte bokstäver eller symboler. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Lär dig mer.",
    "gui.alerts.importing": "Importerar...",
    "gui.defaultProject.meow": "Mjau",
    "gui.defaultProject.variable": "min variabel",
    "gui.howtos.intro-move-sayhello-hat.name": "Kom igång",
    "gui.howtos.intro-move.step_stepMove": "Lägg till ett rörelseblock",
    "gui.howtos.add-a-move-block.step_stepSay": "Lägg till ett \"säg\"-block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Klicka på den gröna flaggan för att starta",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animera ett namn",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Välj en bokstavssprajt",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Spela ett ljud när den klickas på",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Välj en annan bokstavssprajt",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Ändra färg",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Välj en annan bokstavssprajt & låt den snurra",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Välj en annan bokstavssprajt & låt den växa",
    "gui.howtos.imagine": "Föreställ dig en värld",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Skriv vad du vill säga",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Klicka på den gröna flaggan för att starta",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Välj en bakgrund",
    "gui.howtos.imagine.step_imagineChooseSprite": "Välj en sprajt",
    "gui.howtos.imagine.step_imagineFlyAround": "Tryck på mellanslag för att glida",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Välj en annan sprajt",
    "gui.howtos.imagine.step_imagineLeftRight": "Flytta vänster-höger",
    "gui.howtos.imagine.step_imagineUpDown": "Flytta upp-ned",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Byt klädsel",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glid till ett ställe",
    "gui.howtos.imagine.step_imagineGrowShrink": "Växa och krympa",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Välj en annan bakgrund",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Växla bakgrunder",
    "gui.howtos.imagine.step_imagineRecordASound": "Lägg till ett Ljud",
    "gui.howtos.imagine.step_imagineChooseSound": "Välj ditt ljud",
    "gui.howtos.make-music.name": "Skapa musik",
    "gui.howtos.Make-Music.step_PickInstrument": "Välj en instrumentsprajt",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Spela ljud när den klickas på",
    "gui.howtos.Make-Music.step_MakeSong": "Skapa en sång",
    "gui.howtos.make-music.step_MakeBeat": "Välj en Trumma & Skapa en rytm",
    "gui.howtos.make-music.step_MakeBeatBox": "Välj mikrofonsprajten & överaskning beatbox",
    "gui.howtos.story.name": "Skapa en berättelse",
    "gui.howtos.story.step_addbg": "Lägg till en bakgrund",
    "gui.howtos.story.step_addsprite": "Lägg till en figur",
    "gui.howtos.story.step_saysomething": "Säg någonting",
    "gui.howtos.story.step_addanothersprite": "Lägg till en annan figur",
    "gui.howtos.story.step_flip": "Växla riktning",
    "gui.howtos.story.step_conversation": "Ha en konversation",
    "gui.howtos.story.addanotherbg": "Lägg till en annan bakgrund",
    "gui.howtos.story.step_swithbg": "Växla bakgrunder",
    "gui.howtos.story.step_hidewizard": "Göm en figur",
    "gui.howtos.story.step_showwizard": "Visa en figur",
    "gui.howtos.make-a-chase-game.name": "Gör ett Jaga Spel",
    "gui.howtos.Chase-Game.step_BG": "Lägg till en bakgrund",
    "gui.howtos.chase-game.step_AddOcto": "Lägg till en sprajt",
    "gui.howtos.make-music.step_LeftRight": "Flytta höger & vänster med piltangenterna",
    "gui.howtos.Chase-Game.step_UpDown": "Flytta uppåt & nedåt med piltangenterna",
    "gui.howtos.Chase-Game.step_AddStar": "Lägg till en ny sprajt",
    "gui.howtos.Chase-Game.step_MoveRandom": "Slumpmässig rörelse",
    "gui.howtos.Chase-Game.step_WhenTouch": "I bläckfisksprajten, när rör vid spela ljud",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Skapa poängvariabel",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "I bläckfisksprajten, när rör vid öka poäng",
    "gui.howtos.animate-char.name": "Animera en figur",
    "gui.howtos.animate-char.step_addbg": "Lägg till en bakgrund",
    "gui.howtos.animate-char.step_addsprite": "Lägg till en sprajt",
    "gui.howtos.animate-char.step_saysomething": "Säg någonting",
    "gui.howtos.animate-char.step_addsound": "Lägg till ljud",
    "gui.howtos.animate-char.step_animatetalking": "Animera tal",
    "gui.howtos.animate-char.step_arrowkeys": "Flytta med piltangenterna",
    "gui.howtos.animate-char.step_jump": "Hoppa",
    "gui.howtos.animate-char.step_changecolor": "Ändra färg",
    "gui.howtos.make-a-game.name": "Gör ett Klicka Spel",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Välj en sprajt",
    "gui.howtos.make-a-game.step_GamePlaySound": "Spela ljud när den klickas på",
    "gui.howtos.make-a-game.step_GameAddScore": "Skapa poängvariabel",
    "gui.howtos.make-a-game.step_GameChangeScore": "När klickad på öka poängen",
    "gui.howtos.make-a-game.step_Random": "Gå till en slumpmässig position",
    "gui.howtos.make-music.step_GameChangeColor": "Ändra Färg",
    "gui.howtos.make-music.step_ResetScore": "Nollställ Poäng",
    "gui.howtos.make-it-fly.name": "Gör så att det flyger",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Välj en himmel som bakgrund",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Välj en figur",
    "gui.howtos.fly.step_stepflySaySomething": "Säg någonting",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Flytta med piltangenterna",
    "gui.howtos.fly.step_stepflyChooseObject": "Välj ett objekt att samla",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Få objektet att röra på sig",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Välj din figur",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Lägg till poäng",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Håll reda på poäng",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Lägg till bakgrund",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Flytta landskapet",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Nästa klädsel",
    "gui.howtos.pong": "Pongspel",
    "gui.howtos.pong.step_pongAddBackdrop": "Lägg till en bakgrund",
    "gui.howtos.pong.step_pongAddBallSprite": "Lägg till en bollsprajt",
    "gui.howtos.pong.step_pongBounceAround": "Studsa omkring",
    "gui.howtos.pong.step_pongAddPaddle": "Lägg till en bräda",
    "gui.howtos.pong.step_pongMoveThePaddle": "Flytta brädan",
    "gui.howtos.pong.step_pongSelectBallSprite": "Välj bollsprajten",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Lägg till kod för att studsa av brädan",
    "gui.howtos.pong.step_pongAddAScore": "Lägg till en poäng",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Välj 'Poäng' från menyn",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Infoga 'Ändra-poäng-blocket'",
    "gui.howtos.pong.step_pongResetScore": "Nollställ poäng",
    "gui.howtos.pong.step_pongAddLineSprite": "Lägg till linjesprajten",
    "gui.howtos.pong.step_pongGameOver": "Game over",
    "gui.howtos.code-cartoon": "Koda en tecknad serie",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Säg någonting när du klickar på den gröna flaggan",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animera en figur när du klickar på den",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Välj en annan figur",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Förminska med minustecknet ",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Gör så att en figur växer och krymper",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Välj en annan figur",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Hoppa uppåt och nedåt",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Klicka på en figur för att byta bakgrund",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glid omkring",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Byt klädsel",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Välj fler figurer till din tecknade serie",
    "gui.howtos.cartoon-network": "Animera ett äventyrsspel",
    "gui.howtos.cartoon-network.step_CNcharacter": "Välj en figur att visa",
    "gui.howtos.cartoon-network.step_CNsay": "Säg någonting",
    "gui.howtos.cartoon-network.step_CNglide": "Glid omkring",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Välj någonting att jaga",
    "gui.howtos.cartoon-network.step_CNcollect": "Samla saker",
    "gui.howtos.cartoon-network.step_CNvariable": "Skapa en variabel för poäng",
    "gui.howtos.cartoon-network.step_CNscore": "Håll reda på poäng",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Levla upp: Byt bakgrund",
    "gui.howtos.videosens.name": "Video - Känna av",
    "gui.howtos.videosens.step_addextension": "Lägg till ett tillägg",
    "gui.howtos.videosens.step_pet": "Klappa katten",
    "gui.howtos.videosens.step_animate": "Animera",
    "gui.howtos.videosens.step_pop": "Smäll en ballong",
    "gui.howtos.say-it-out-loud": "Skapa animationer som kan prata",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Lägg till text i ett tal-block",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Säg någonting",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Sätt upp röst",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Flytta runt",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Lägg till en bakgrund",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Lägg till en annan figur",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Spela upp en låt",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Ändra färg",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Snurra runt",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Växa och krympa",
    "gui.howtos.talking": "Berättelser som pratar",
    "gui.howtos.talking.step_talesAddExtension": "Klicka för att lägga till tal-blocket",
    "gui.howtos.talking.step_talesChooseSprite": "Välj en sprajt",
    "gui.howtos.talking.step_talesSaySomething": "Gör så att en figur pratar",
    "gui.howtos.talking.step_talesChooseBackdrop": "Välj en bakgrund",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Klicka på en figur för att byta till nästa bakgrund",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Välj en annan sprajt",
    "gui.howtos.talking.step_talesMoveAround": "Flytta runt",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Välj en annan bakgrund",
    "gui.howtos.talking.step_talesAnimateTalking": "Animera tal",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Välj en annan bakgrund",
    "gui.howtos.talking.step_talesChooseSound": "Välj en låt att dansa till",
    "gui.howtos.talking.step_talesDanceMoves": "Danssteg",
    "gui.howtos.talking.step_talesAskAnswer": "Hämta Fråga-svar-blocket från Känna av",
    "gui.howtos.add-sprite.name": "Lägg till en sprajt",
    "gui.howtos.add-sprite.step_addSprite": "Lägg till en sprajt",
    "gui.howtos.add-a-backdrop.name": "Lägg till en bakgrund",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Lägg till en bakgrund",
    "gui.howtos.change-size.name": "Ändra storlek",
    "gui.howtos.change-size.step_changeSize": "Ändra storlek",
    "gui.howtos.glide-around.name": "Glid omkring",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glid omkring",
    "gui.howtos.change-size.step_glideAroundPoint": "Glid till ett ställe",
    "gui.howtos.record-a-sound.name": "Spela in ett ljud",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Klicka på ljudfliken",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Klicka på 'Spela in'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Tryck på spela-in-knappen",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Välj ditt ljud",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Spela upp ditt ljud",
    "gui.howtos.spin-video.name": "Få den att snurra",
    "gui.howtos.change-size.step_spinTurn": "Vänd",
    "gui.howtos.change-size.step_spinPointInDirection": "Sätt riktning",
    "gui.howtos.hide-and-show.name": "Göm och visa",
    "gui.howtos.change-size.step_hideAndShow": "Göm och visa",
    "gui.howtos.switch-costume.name": "Animera en sprajt",
    "gui.howtos.change-size.step_switchCostumes": "Animera en sprajt",
    "gui.howtos.move-around-with-arrow-keys.name": "Använd piltangenterna",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Flytta vänster och höger",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Flytta uppåt och nedåt",
    "gui.howtos.add-effects.name": "Lägg till effekter",
    "gui.howtos.videosens.step_addEffects": "Lägg till effekter",
    "gui.extension.music.name": "Musik",
    "gui.extension.music.description": "Spela instrument och trummor.",
    "gui.extension.pen.name": "Penna",
    "gui.extension.pen.description": "Låt dina sprajts rita.",
    "gui.extension.videosensing.name": "Video - Känna av",
    "gui.extension.videosensing.description": "Känn av rörelse med kameran.",
    "gui.extension.text2speech.name": "Text till tal",
    "gui.extension.text2speech.description": "Gör så att dina projekt pratar.",
    "gui.extension.translate.name": "Översätta",
    "gui.extension.translate.description": "Översätt text till många språk.",
    "gui.extension.makeymakey.description": "Gör vad som helst till en tangent.",
    "gui.extension.microbit.description": "Koppla upp dina projekt med världen.",
    "gui.extension.microbit.connectingMessage": "Kopplar upp",
    "gui.extension.ev3.description": "Bygg interaktiva robotar och annat.",
    "gui.extension.ev3.connectingMessage": "Kopplar upp. Kolla att pinkoden på din EV3 är satt till 1234.",
    "gui.extension.boost.description": "Ge liv åt dina robotar.",
    "gui.extension.boost.connectingMessage": "Kopplar upp",
    "gui.extension.wedo2.description": "Bygg med motorer och sensorer.",
    "gui.extension.wedo2.connectingMessage": "Kopplar upp",
    "gui.extension.gdxfor.description": "Känn av knuffa, dra, rörelse och rotation.",
    "gui.extension.gdxfor.connectingMessage": "Kopplar upp",
    "gui.libraryTags.all": "Alla",
    "gui.libraryTags.animals": "Djur",
    "gui.libraryTags.dance": "Dansa",
    "gui.libraryTags.effects": "Effekter",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Mode",
    "gui.libraryTags.food": "Mat",
    "gui.libraryTags.indoors": "Inomhus",
    "gui.libraryTags.loops": "Loopar",
    "gui.libraryTags.music": "Musik",
    "gui.libraryTags.notes": "Toner",
    "gui.libraryTags.outdoors": "Utomhus",
    "gui.libraryTags.patterns": "Mönster",
    "gui.libraryTags.people": "Människor",
    "gui.libraryTags.percussion": "Slagverk",
    "gui.libraryTags.space": "Rymden",
    "gui.libraryTags.sports": "Sport",
    "gui.libraryTags.underwater": "Under vatten",
    "gui.libraryTags.voice": "Röst",
    "gui.libraryTags.wacky": "Knäppt",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Konst",
    "gui.libraryTags.games": "Spel",
    "gui.libraryTags.stories": "Berättelser",
    "gui.libraryTags.letters": "Bokstäver",
    "gui.opcodeLabels.direction": "riktning",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "storlek",
    "gui.opcodeLabels.costumename": "klädselnamn",
    "gui.opcodeLabels.costumenumber": "klädselnummer",
    "gui.opcodeLabels.backdropname": "bakgrundsnamn",
    "gui.opcodeLabels.backdropnumber": "bakgrundsnummer",
    "gui.opcodeLabels.volume": "volym ",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "svar",
    "gui.opcodeLabels.loudness": "ljudstyrka",
    "gui.opcodeLabels.username": "användarnamn ",
    "gui.opcodeLabels.year": "år ",
    "gui.opcodeLabels.month": "månad ",
    "gui.opcodeLabels.date": "dag ",
    "gui.opcodeLabels.dayofweek": "veckodag ",
    "gui.opcodeLabels.hour": "timmar ",
    "gui.opcodeLabels.minute": "minuter ",
    "gui.opcodeLabels.second": "sekunder ",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "Den valda projektfilen misslyckades att ladda.",
    "gui.sharedMessages.backdrop": "bakgrund{index}",
    "gui.sharedMessages.costume": "klädsel{index}",
    "gui.sharedMessages.sprite": "Sprajt{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Ersätt innehållet i det aktuella projektet?",
    "gui.sharedMessages.loadFromComputerTitle": "Ladda upp från din dator",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratchprojekt",
    "boost.color.any": "vilken färg som helst",
    "boost.color.black": "svart",
    "boost.color.blue": "blå",
    "boost.color.green": "grön",
    "boost.color.red": "röd",
    "boost.color.white": "vit",
    "boost.color.yellow": "gul",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "lutningsvinkel [TILT_DIRECTION]",
    "boost.motorDirection.backward": "andra hållet",
    "boost.motorDirection.forward": "detta hållet",
    "boost.motorDirection.reverse": "ändra riktning",
    "boost.motorOff": "vrid motor [MOTOR_ID] av",
    "boost.motorOn": "vrid motor [MOTOR_ID] på",
    "boost.motorOnFor": "vrid motor [MOTOR_ID] i [DURATION] sekunder",
    "boost.motorOnForRotation": "vrid motor [MOTOR_ID] i [ROTATION] rotationer",
    "boost.seeingColor": "ser [COLOR] kloss?",
    "boost.setLightHue": "sätt ljusets färg till [HUE]",
    "boost.setMotorDirection": "sätt motor [MOTOR_ID] riktning [MOTOR_DIRECTION]",
    "boost.setMotorPower": "sätt motor [MOTOR_ID] hastighet till [POWER] %",
    "boost.tiltDirection.any": "någon",
    "boost.tiltDirection.down": "ned",
    "boost.tiltDirection.left": "vänster",
    "boost.tiltDirection.right": "höger",
    "boost.tiltDirection.up": "upp",
    "boost.whenColor": "när [COLOR] kloss upptäcks",
    "boost.whenTilted": "om lutar [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "spela ton [NOTE] i [TIME]sekunder",
    "ev3.buttonPressed": "knapp [PORT] nedtryckt?",
    "ev3.getBrightness": "ljusstyrka",
    "ev3.getDistance": "avstånd",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "motor [PORT] sätt kraft [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] rotera medsols i [TIME] sekunder",
    "ev3.motorTurnCounterClockwise": "motor [PORT] rotera motsols i [TIME] sekunder",
    "ev3.whenBrightnessLessThan": "om ljusstyrka < [DISTANCE]",
    "ev3.whenButtonPressed": "när knapp [PORT] trycks ned",
    "ev3.whenDistanceLessThan": "när avstånd < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "kraft",
    "gdxfor.getSpin": "rotationshastighet [DIRECTION]",
    "gdxfor.getTilt": "lutningsvinkel [TILT]",
    "gdxfor.isFreeFalling": "fritt fall?",
    "gdxfor.isTilted": "lutar [TILT]?",
    "gdxfor.pulled": "dragits",
    "gdxfor.pushed": "knuffad",
    "gdxfor.shaken": "skaka",
    "gdxfor.startedFalling": "börjar falla",
    "gdxfor.tiltDirectionMenu.any": "någon",
    "gdxfor.tiltDirectionMenu.back": "tillbaka",
    "gdxfor.tiltDirectionMenu.front": "översta",
    "gdxfor.tiltDirectionMenu.left": "vänster",
    "gdxfor.tiltDirectionMenu.right": "höger",
    "gdxfor.turnedFaceDown": "vände logotyp nedåt",
    "gdxfor.turnedFaceUp": "vände logotyp uppåt",
    "gdxfor.whenForcePushedOrPulled": "när kraftsensorn [PUSH_PULL]",
    "gdxfor.whenGesture": "om [GESTURE]",
    "gdxfor.whenTilted": "när lutar [TILT]",
    "makeymakey.downArrow": "nedåtpil",
    "makeymakey.downArrowShort": "ned",
    "makeymakey.leftArrow": "vänsterpil",
    "makeymakey.leftArrowShort": "vänster",
    "makeymakey.rightArrow": "högerpil",
    "makeymakey.rightArrowShort": "höger",
    "makeymakey.spaceKey": "mellanslag",
    "makeymakey.upArrow": "uppåtpil",
    "makeymakey.upArrowShort": "upp",
    "makeymakey.whenKeyPressed": "när [KEY] tangenten trycks ned",
    "makeymakey.whenKeysPressedInOrder": "när [SEQUENCE] trycks ned efter varandra",
    "microbit.buttonsMenu.any": "någon",
    "microbit.clearDisplay": "rensa skärmen",
    "microbit.defaultTextToDisplay": "Hej!",
    "microbit.displaySymbol": "visa [MATRIX]",
    "microbit.displayText": "visa text [TEXT]",
    "microbit.gesturesMenu.jumped": "hoppa",
    "microbit.gesturesMenu.moved": "rör sig",
    "microbit.gesturesMenu.shaken": "skaka",
    "microbit.isButtonPressed": "[BTN] knappen nedtryckt?",
    "microbit.isTilted": "luta [DIRECTION]?",
    "microbit.pinStateMenu.off": "av",
    "microbit.pinStateMenu.on": "på",
    "microbit.tiltAngle": "luta riktning [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "någon",
    "microbit.tiltDirectionMenu.back": "tillbaka",
    "microbit.tiltDirectionMenu.front": "översta",
    "microbit.tiltDirectionMenu.left": "vänster",
    "microbit.tiltDirectionMenu.right": "höger",
    "microbit.whenButtonPressed": "om knapp [BTN] trycks ned",
    "microbit.whenGesture": "om [GESTURE]",
    "microbit.whenPinConnected": "När pin [PIN] är kopplad",
    "microbit.whenTilted": "om lutar [DIRECTION]",
    "music.categoryName": "Musik",
    "music.changeTempo": "ändra tempo med [TEMPO]",
    "music.drumBass": "(2) Bastrumma",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Stängd Hi-Hat",
    "music.drumConga": "(14) Congas",
    "music.drumCowbell": "(11) Koskälla",
    "music.drumCrashCymbal": "(4) Crashcymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Handklapp",
    "music.drumOpenHiHat": "(5) Öppen Hi-Hat",
    "music.drumSideStick": "(3) Kantslag",
    "music.drumSnare": "(1) Virveltrumma",
    "music.drumTambourine": "(7) Tamburin",
    "music.drumTriangle": "(12) Triangel",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Träblock",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagott",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Kör",
    "music.instrumentClarinet": "(10) Klarinett",
    "music.instrumentElectricGuitar": "(5) Elgitarr",
    "music.instrumentElectricPiano": "(2) Elpiano",
    "music.instrumentFlute": "(12) Flöjt",
    "music.instrumentGuitar": "(4) Gitarr",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Speldosa",
    "music.instrumentOrgan": "(3) Orgel",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxofon",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Träflöjt",
    "music.midiPlayDrumForBeats": "spela trumma [DRUM]i [BEATS] takter",
    "music.midiSetInstrument": "sätt instrument till [INSTRUMENT]",
    "music.playDrumForBeats": "spela trumma [DRUM]i [BEATS] takter",
    "music.playNoteForBeats": "spela not [NOTE]i [BEATS]takter",
    "music.restForBeats": "pausa i [BEATS]takter",
    "music.setInstrument": "sätt instrument till [INSTRUMENT]",
    "music.setTempo": "sätt tempo till [TEMPO]",
    "pen.categoryName": "Penna",
    "pen.changeColorParam": "ändra pennans [COLOR_PARAM]med [VALUE]",
    "pen.changeHue": "ändra pennans färg med [HUE]",
    "pen.changeShade": "ändra pennans skugga med [SHADE]",
    "pen.changeSize": "ändra pennans storlek med [SIZE]",
    "pen.clear": "radera allt",
    "pen.colorMenu.brightness": "ljusstyrka",
    "pen.colorMenu.color": "färg",
    "pen.colorMenu.saturation": "mättnad",
    "pen.colorMenu.transparency": "genomskinlighet",
    "pen.penDown": "penna ned",
    "pen.penUp": "penna upp",
    "pen.setColor": "sätt pennans färg [COLOR]",
    "pen.setColorParam": "sätt penna [COLOR_PARAM]till [VALUE]",
    "pen.setHue": "sätt pennans färg till [HUE]",
    "pen.setShade": "sätt pennans skugga till [SHADE]",
    "pen.setSize": "sätt pennans storlek [SIZE]",
    "pen.stamp": "stämpla",
    "speech.defaultWhenIHearValue": "kör igång",
    "speech.extensionName": "Tal till text",
    "speech.listenAndWait": "lyssna och vänta",
    "speech.speechReporter": "tala",
    "speech.whenIHear": "när jag hör [PHRASE]",
    "text2speech.alto": "alt",
    "text2speech.categoryName": "Text till tal",
    "text2speech.defaultTextToSpeak": "hej",
    "text2speech.giant": "jätte",
    "text2speech.kitten": "kattunge",
    "text2speech.setLanguageBlock": "sätt språk till [LANGUAGE]",
    "text2speech.setVoiceBlock": "sätt röst till [VOICE]",
    "text2speech.speakAndWaitBlock": "säg [WORDS]",
    "text2speech.squeak": "pip",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Översätta",
    "translate.defaultTextToTranslate": "hej",
    "translate.translateBlock": "översätt [WORDS] till [LANGUAGE]",
    "translate.viewerLanguage": "språk",
    "videoSensing.categoryName": "Video - Känna av",
    "videoSensing.direction": "riktning",
    "videoSensing.motion": "rörelse",
    "videoSensing.off": "av",
    "videoSensing.on": "på",
    "videoSensing.onFlipped": "vid förändring",
    "videoSensing.setVideoTransparency": "sätt videotransparens till [TRANSPARENCY]",
    "videoSensing.sprite": "sprajt",
    "videoSensing.stage": "scen",
    "videoSensing.videoOn": "video [ATTRIBUTE]på [SUBJECT]",
    "videoSensing.videoToggle": "sätt video till [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "när videorörelse > [REFERENCE]",
    "wedo2.getDistance": "avstånd",
    "wedo2.getTiltAngle": "lutningsvinkel [TILT_DIRECTION]",
    "wedo2.isTilted": "lutar [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "andra hållet",
    "wedo2.motorDirection.forward": "detta hållet",
    "wedo2.motorDirection.reverse": "ändra riktning",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "alla motorer",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "stoppa [MOTOR_ID]",
    "wedo2.motorOn": "starta [MOTOR_ID]",
    "wedo2.motorOnFor": "starta [MOTOR_ID] i [DURATION] sekunder",
    "wedo2.playNoteFor": "spela ton [NOTE] i [DURATION] sekunder",
    "wedo2.setLightHue": "sätt ljusets färg till [HUE]",
    "wedo2.setMotorDirection": "sätt [MOTOR_ID] riktning till [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "sätt kraften på [MOTOR_ID] till [POWER]",
    "wedo2.tiltDirection.any": "någon",
    "wedo2.tiltDirection.down": "ned",
    "wedo2.tiltDirection.left": "vänster",
    "wedo2.tiltDirection.right": "höger",
    "wedo2.tiltDirection.up": "upp",
    "wedo2.whenDistance": "om avstånd [OP] [REFERENCE]",
    "wedo2.whenTilted": "om lutar [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Färg",
    "paint.paintEditor.saturation": "Mättnad",
    "paint.paintEditor.brightness": "Ljusstyrka",
    "paint.paintEditor.costume": "Klädsel",
    "paint.paintEditor.group": "Gruppera",
    "paint.paintEditor.ungroup": "Dela upp grupp",
    "paint.paintEditor.undo": "Ångra",
    "paint.paintEditor.redo": "Gör om",
    "paint.paintEditor.forward": "Framåt",
    "paint.paintEditor.backward": "Bakåt",
    "paint.paintEditor.front": "Placera längst fram",
    "paint.paintEditor.back": "Placera längst bak",
    "paint.paintEditor.more": "Mer",
    "paint.modeTools.brushSize": "Storlek",
    "paint.modeTools.eraserSize": "Suddgummi storlek",
    "paint.modeTools.copy": "Kopiera",
    "paint.modeTools.paste": "Klistra in",
    "paint.modeTools.delete": "Radera",
    "paint.modeTools.curved": "Böjd",
    "paint.modeTools.pointed": "Spetsig",
    "paint.modeTools.thickness": "Tjocklek",
    "paint.modeTools.flipHorizontal": "Vänd vågrätt",
    "paint.modeTools.flipVertical": "Vänd lodrätt",
    "paint.modeTools.filled": "Fylld",
    "paint.modeTools.outlined": "Ofylld",
    "paint.paintEditor.bitmap": "Gör till bitmapp",
    "paint.paintEditor.vector": "Konvertera till vektor",
    "paint.paintEditor.fill": "Fyll",
    "paint.paintEditor.stroke": "Kontur",
    "paint.brushMode.brush": "Pensel",
    "paint.eraserMode.eraser": "Radergummi",
    "paint.fillMode.fill": "Fyll",
    "paint.lineMode.line": "Linje",
    "paint.ovalMode.oval": "Cirkel",
    "paint.rectMode.rect": "Rektangel",
    "paint.reshapeMode.reshape": "Omforma",
    "paint.roundedRectMode.roundedRect": "Rektangel rundade hörn",
    "paint.selectMode.select": "Välj",
    "paint.textMode.text": "Text",
    "paint.colorPicker.swap": "Växla färg"
  },
  "vi": {
    "gui.alerts.lostPeripheralConnection": "Scratch đã mất kết nối với {extensionName}",
    "gui.alerts.tryAgain": "Vui lòng thử lại",
    "gui.alerts.download": "Tải xuống",
    "gui.connection.reconnect": "Kết nối lại",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Ba lô",
    "gui.backpack.errorBackpack": "Không thể tải lên ba lô",
    "gui.backpack.loadingBackpack": "Đang tải ...",
    "gui.backpack.more": "Nhiều hơn",
    "gui.backpack.emptyBackpack": "Ba lô trống",
    "gui.unsupportedBrowser.label": "Trình duyệt web không hỗ trợ",
    "gui.unsupportedBrowser.errorLabel": "Có lỗi đã xảy ra",
    "gui.unsupportedBrowser.notRecommended": "Chúng tôi thực sự lấy làm tiếc, nhưng có vẻ như phiên bản trình duyệt web hiện tại của bạn không được Scratch hỗ trợ. Chúng tôi khuyến cáo bạn cập nhật lên phiên bản mới nhất của những trình duyệt web được hỗ trợ như Google Chrome, Mozilla Firefox, Microsoft Edge, hoặc Apple Safari. ",
    "gui.unsupportedBrowser.description": "Chúng tôi rất xin lỗi, nhưng Scratch không hỗ trợ trình duyệt này. Chúng tôi khuyến cáo bạn cập nhật lên phiên bản mới nhất của những trình duyệt web được hỗ trợ như Google Chrome, Mozilla Firefox, Microsoft Edge, hoặc Apple Safari.",
    "gui.unsupportedBrowser.back": "Trở về",
    "gui.unsupportedBrowser.previewfaq": "Để biết thêm chi tiết, truy cập {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Những câu hỏi thường gặp",
    "gui.cards.all-tutorials": "Hướng dẫn",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Mở rộng",
    "gui.cards.close": "Đóng",
    "gui.cards.more-things-to-try": "Thêm nhiều thứ nữa để thử!",
    "gui.cards.see-more": "Xem thêm",
    "gui.comingSoon.message1": "Đừng lo, chúng tôi làm việc với tính năng này {emoji}",
    "gui.comingSoon.message2": "Sắp có...",
    "gui.comingSoon.message3": "Chúng tôi đang làm việc với tính năng này {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Không tìm thấy thiết bị nào",
    "gui.connection.auto-scanning.prescan": "Đặt thiết bị của bạn ở gần, và bắt đầu tìm kiếm.",
    "gui.connection.auto-scanning.pressbutton": "Bấm nút trên thiết bị của bạn",
    "gui.connection.auto-scanning.start-search": "Bắt đầu tìm kiếm",
    "gui.connection.connecting-searchbutton": "Đang tìm kiếm...",
    "gui.connection.auto-scanning.try-again": "Thử lại",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Đã kết nối",
    "gui.connection.disconnect": "Ngắt kết nối",
    "gui.connection.go-to-editor": "Đi đến trình biên tập",
    "gui.connection.connecting-cancelbutton": "Đang kết nối...",
    "gui.connection.error.errorMessage": "Ôi, có vấn đề gì đó xảy ra.",
    "gui.connection.error.tryagainbutton": "Thử lại",
    "gui.connection.error.helpbutton": "Trợ giúp",
    "gui.connection.peripheral-name-label": "Tên thiết bị",
    "gui.connection.connect": "Kết nối",
    "gui.connection.scanning.lookingforperipherals": "Đang tìm kiếm thiết bị",
    "gui.connection.scanning.noPeripheralsFound": "Không tìm thấy thiết bị nào",
    "gui.connection.scanning.instructions": "Chọn thiết bị của bạn trong danh sách phía trên",
    "gui.connection.search": "Làm mới",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Hãy chắc chắn rằng bạn đã cài và chạy Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "Hãy kiểm tra kết nối Bluetooth bật hay chưa",
    "gui.connection.unavailable.tryagainbutton": "Thử lại",
    "gui.connection.unavailable.helpbutton": "Trợ giúp",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Đi",
    "gui.controls.stop": "Dừng lại",
    "gui.crashMessage.label": "Oops! Có vấn đề xảy ra.",
    "gui.crashMessage.description": "Chúng tôi rất xin lỗi, nhưng có vẻ như Scratch đã gặp vấn đề. Lỗi này đã được thông báo đến đội ngũ của Scratch. Hãy thử tải lại trang của bạn",
    "gui.crashMessage.errorNumber": "Lỗi đã được lưu lại với ID {errorId}",
    "gui.crashMessage.reload": "Tải lại",
    "gui.customProcedures.myblockModalTitle": "Tạo một khối",
    "gui.customProcedures.addAnInputNumberText": "Thêm dữ liệu đầu vào",
    "gui.customProcedures.numberTextType": "số hay chữ",
    "gui.customProcedures.addAnInputBoolean": "Thêm dữ liệu đầu vào",
    "gui.customProcedures.booleanType": "điều kiện",
    "gui.customProcedures.addALabel": "Thêm nhãn",
    "gui.customProcedures.runWithoutScreenRefresh": "Chạy mà không làm mới màn hình",
    "gui.customProcedures.cancel": "Hủy",
    "gui.customProcedures.ok": "OK",
    "gui.SpriteInfo.direction": "Hướng di chuyển",
    "gui.directionPicker.rotationStyles.allAround": "Xung quanh",
    "gui.directionPicker.rotationStyles.leftRight": "Trái/Phải",
    "gui.directionPicker.rotationStyles.dontRotate": "Không quay",
    "gui.gui.addExtension": "Thêm phần mở rộng",
    "gui.gui.codeTab": "code",
    "gui.gui.backdropsTab": "Phông nền",
    "gui.gui.costumesTab": "Trang phục",
    "gui.gui.soundsTab": "Âm thanh",
    "gui.extensionLibrary.comingSoon": "Xuất hiện sớm",
    "gui.extensionLibrary.requires": "Yêu cầu",
    "gui.extensionLibrary.collaboration": "Cộng tác với",
    "gui.library.filterPlaceholder": "Tìm kiếm",
    "gui.library.allTag": "Tất cả",
    "gui.loader.message1": "Tạo ra các khối ...",
    "gui.loader.message2": "Đang tải nhân vật ...",
    "gui.loader.message3": "Tải âm thanh ...",
    "gui.loader.message4": "Đang tải phần mở rộng",
    "gui.loader.message5": "bầy mèo ...",
    "gui.loader.message6": "Đang tải trí tuệ của bạn ...",
    "gui.loader.message7": "Đang tải nhân vật ...",
    "gui.loader.message8": "Chuân bị emoji...",
    "gui.loader.headline": "Đang tải dự án",
    "gui.loader.creating": "Đang tạo dự án",
    "gui.accountMenu.profile": "Trang cá nhân",
    "gui.accountMenu.myStuff": "Chương trình của tôi",
    "gui.accountMenu.myClasses": "Các lớp học của tôi",
    "gui.accountMenu.myClass": "Lớp học của tôi",
    "gui.accountMenu.accountSettings": "Thiết lập tài khoản",
    "gui.accountMenu.signOut": "Đăng xuất",
    "gui.authorInfo.byUser": "bởi {username}",
    "gui.menuBar.seeProjectPage": "Xem trang Dự án",
    "gui.menuBar.language": "Language",
    "general.username": "Tên đăng nhập",
    "general.password": "Mật khẩu",
    "general.signIn": "Đăng nhập",
    "login.needHelp": "Cần trợ giúp?",
    "form.validationRequired": "Trường này là bắt buộc",
    "gui.menuBar.tutorialsLibrary": "Hướng dẫn",
    "gui.menuBar.restoreSprite": "Khôi phục Nhân vật",
    "gui.menuBar.restoreSound": "Khôi phục âm thanh",
    "gui.menuBar.restoreCostume": "Khôi phục hình dạng",
    "gui.menuBar.restore": "Khôi phục",
    "gui.menuBar.saveNow": "Lưu bây giờ",
    "gui.menuBar.saveAsCopy": "Lưu bản sao ",
    "gui.menuBar.remix": "Phối lại",
    "gui.menuBar.new": "Mới",
    "gui.menuBar.file": "Tập tin",
    "gui.menuBar.downloadToComputer": "Lưu về máy tính",
    "gui.menuBar.edit": "Chỉnh sửa",
    "gui.menuBar.turboModeOff": "Tắt chế độ Turbo",
    "gui.menuBar.turboModeOn": "Bật chế độ Turbo",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Tham gia Scratch",
    "gui.menuBar.signIn": "Đăng nhập",
    "gui.gui.projectTitlePlaceholder": "Đề tên ở đây",
    "gui.menuBar.saveNowLink": "Lưu bây giờ",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Đã chia sẻ",
    "gui.menuBar.share": "Chia sẻ",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Trợ giúp",
    "gui.modal.back": "Trở về",
    "gui.monitor.listMonitor.empty": "(trống)",
    "gui.monitor.listMonitor.listLength": "độ dài {length}",
    "gui.monitor.contextMenu.default": "chế độ đọc bình thường",
    "gui.monitor.contextMenu.large": "chế độ đọc lớn",
    "gui.monitor.contextMenu.slider": "thanh trượt",
    "gui.monitor.contextMenu.sliderRange": "thay đổi phạm vi thanh trượt",
    "gui.monitor.contextMenu.import": "nhập vào",
    "gui.monitor.contextMenu.export": "xuất ra",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Chơi",
    "gui.playButton.stop": "Dừng lại",
    "gui.gui.variableScopeOptionAllSprites": "Cho tất cả nhân vật",
    "gui.gui.variableScopeOptionSpriteOnly": "Chỉ nhân vật này",
    "gui.gui.cloudVariableOption": "Biến số (lưu tại máy chủ)",
    "gui.gui.variablePromptAllSpritesMessage": "Biến này sẽ có sẵn cho tất cả nhân vật.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Hủy",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Dừng lại",
    "gui.playbackStep.playMsg": "Chơi",
    "gui.playbackStep.loadingMsg": "Đang tải ...",
    "gui.playbackStep.saveMsg": "Lưu",
    "gui.playbackStep.reRecordMsg": "thu âm lại",
    "gui.recordModal.title": "Thu lại âm thanh ",
    "gui.recordingStep.beginRecord": "Bắt đầu ghi âm bằng cách ấn nút bên dưới",
    "gui.recordingStep.permission": "{arrow}Chúng tôi cần bạn cho phép để sử dụng micro",
    "gui.recordingStep.stop": "Dừng ghi âm",
    "gui.recordingStep.record": "Ghi lại",
    "gui.sliderModal.min": "Giá trị nhỏ nhất",
    "gui.sliderModal.max": "Giá trị lớn nhất",
    "gui.sliderModal.title": "Thay đổi phạm vi thanh trượt",
    "gui.sliderPrompt.cancel": "Hủy",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Âm thanh",
    "gui.soundEditor.play": "Chơi",
    "gui.soundEditor.stop": "Dừng lại",
    "gui.soundEditor.copy": "Sao chép",
    "gui.soundEditor.paste": "Dán",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Xóa",
    "gui.soundEditor.save": "Lưu",
    "gui.soundEditor.undo": "Hoàn tác",
    "gui.soundEditor.redo": "Làm lại ",
    "gui.soundEditor.faster": "Nhanh hơn",
    "gui.soundEditor.slower": "chậm hơn",
    "gui.soundEditor.echo": "Tiếng vang",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "To hơn",
    "gui.soundEditor.softer": "nhẹ hơn",
    "gui.soundEditor.reverse": "Đảo ngược",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Tên",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Nhân vật",
    "gui.SpriteInfo.show": "Xuất hiện",
    "gui.SpriteInfo.size": "Kích thước ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "nhân bản",
    "gui.spriteSelectorItem.contextMenuExport": "xuất ra",
    "gui.spriteSelectorItem.contextMenuDelete": "xoá",
    "gui.spriteSelector.addSpriteFromLibrary": "Chọn một Nhân vật",
    "gui.spriteSelector.addSpriteFromPaint": "Vẽ",
    "gui.spriteSelector.addSpriteFromSurprise": "Bất ngờ",
    "gui.spriteSelector.addSpriteFromFile": "Tải Nhân vật lên",
    "gui.stageHeader.stageSizeLarge": "Chuyển qua sân khấu lớn",
    "gui.stageHeader.stageSizeSmall": "Chuyển sang phông nền nhỏ",
    "gui.stageHeader.stageSizeFull": "Chuyển đến chế độ toàn màn hình",
    "gui.stageHeader.stageSizeUnFull": "Thoát toàn màn hình",
    "gui.stageHeader.fullscreenControl": "điều khiển toàn màn hình",
    "gui.spriteSelector.addBackdropFromLibrary": "Chọn một Phông nền",
    "gui.stageSelector.addBackdropFromPaint": "Vẽ",
    "gui.stageSelector.addBackdropFromSurprise": "Bất ngờ",
    "gui.stageSelector.addBackdropFromFile": "Tải phông nền",
    "gui.stageSelector.stage": "Sân khấu",
    "gui.stageSelector.backdrops": "Phông nền",
    "gui.telemetryOptIn.label": "Gửi số liệu thống kê để giúp cải thiện Scratch",
    "gui.telemetryOptIn.body1": "Scratch Team luôn muốn biết thêm về việc Scratch được sử dụng như thế nào ở khắp thế giới. Để hỗ trợ chúng tôi, bạn có thể cho phép Scratch tự động gửi thông tin sử dụng đến Scratch Team.",
    "gui.telemetryOptIn.body2": "Thông tin chúng tôi thu thập bao gồm lựa chọn ngôn ngữ, thời gian sử dụng, và một số thao tác như lưu, tải lên và lấy xuống một dự án. Chúng tôi KHÔNG thu thập bất cứ thông tin cá nhân nào. Xin xem chính sách bảo mật {privacyPolicyLink}của chúng tôi để biết thêm chi tiết.",
    "gui.telemetryOptIn.privacyPolicyLink": "Chinh sách Bảo mật",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Chế độ Turbo",
    "gui.webglModal.label": "Trình duyệt của bạn không hỗ trợ WebGL",
    "gui.webglModal.description": "Có vẻ như tình duyệt của bạn hoặc máy tính {webGlLink}. Công nghệ mới này cần thiết để vận hành Scratch 3.0.",
    "gui.webglModal.webgllink": "không hỗ trợ WebGL",
    "gui.webglModal.back": "Trở về",
    "gui.webglModal.previewfaq": "Để biết thêm chi tiết, đi đến {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Những câu hỏi thường gặp",
    "gui.costumeLibrary.chooseABackdrop": "Chọn một Phông nền",
    "gui.costumeLibrary.chooseACostume": "Chọn một trang phục",
    "gui.costumeTab.addBackdropFromLibrary": "Chọn một Phông nền",
    "gui.costumeTab.addCostumeFromLibrary": "thay đổi trang phục ",
    "gui.costumeTab.addBlankCostume": "Vẽ",
    "gui.costumeTab.addSurpriseCostume": "Bất ngờ",
    "gui.costumeTab.addFileBackdrop": "Tải Phông nền",
    "gui.costumeTab.addFileCostume": "tải trang phục lên",
    "gui.extensionLibrary.chooseAnExtension": "Chọn Phần mở rộng",
    "gui.extensionLibrary.extensionUrl": "Thêm đường dẫn URL mở rộng",
    "gui.monitors.importListColumnPrompt": "Nên dùng cột nào? (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Không thể bắt đầu thu âm",
    "gui.soundLibrary.chooseASound": "chọn âm thanh ",
    "gui.soundTab.fileUploadSound": "Tải âm thanh lên",
    "gui.soundTab.surpriseSound": "Bất ngờ",
    "gui.soundTab.recordSound": "Ghi lại",
    "gui.soundTab.addSoundFromLibrary": "chọn âm thanh ",
    "gui.spriteLibrary.chooseASprite": "Chọn một Nhân vật",
    "gui.tipsLibrary.tutorials": "Chọn một bài hướng dẫn",
    "gui.alerts.createsuccess": "Dự án mới đã được tạo xong.",
    "gui.alerts.createcopysuccess": "Dự án đã được lưu dưới dạng bản sao.",
    "gui.alerts.createremixsuccess": "Dự án đã được lưu thành một bản phối lại.",
    "gui.alerts.creating": "Đang tạo mới...",
    "gui.alerts.creatingCopy": "Đang copy dự án...",
    "gui.alerts.creatingRemix": "Đang phối lại dự án...",
    "gui.alerts.creatingError": "Không thể tạo dự án. Vui lòng thử lại!",
    "gui.alerts.savingError": "Không thể lưu dự án.",
    "gui.alerts.savesuccess": "Dự án đã được lưu.",
    "gui.alerts.saving": "Đang lưu dự án...",
    "gui.alerts.cloudInfo": "Xin lưu ý, biến số cloud chỉ hỗ trợ dạng số, không hỗ trợ dạng chữ cái và biểu tượng. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Tỉm hiểu thêm.",
    "gui.alerts.importing": "Đang nhập...",
    "gui.defaultProject.meow": "Meo",
    "gui.defaultProject.variable": "biến của tôi",
    "gui.howtos.intro-move-sayhello-hat.name": "Bắt đầu",
    "gui.howtos.intro-move.step_stepMove": "Thêm một khối di chuyển",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Làm tên chuyển động",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Lấy một nhân vật chữ cái",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Phát âm thanh khi bấm vào",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Lấy một nhân vật chữ cái khác",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Thay đổi màu",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Lấy nhân vật chữ cái khác và làm nó quay",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Lấy nhân vật chữ cái khác & làm nó lớn lên",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Gõ những gì bạn muốn nói",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Nháy chuột vào biểu tượng Cờ Xanh để bắt đầu",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Chọn phông nền bất kỳ",
    "gui.howtos.imagine.step_imagineChooseSprite": "Chọn nhân vật bất kỳ",
    "gui.howtos.imagine.step_imagineFlyAround": "Nhấn phím Space để trượt",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Chọn nhân vật khác",
    "gui.howtos.imagine.step_imagineLeftRight": "Di chuyển Trái-Phải",
    "gui.howtos.imagine.step_imagineUpDown": "Di chuyển Lên-Xuống",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Thay đổi trang phục",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Trượt đến một điểm",
    "gui.howtos.imagine.step_imagineGrowShrink": "Phóng to và thu nhỏ",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Chọn phông nền khác",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Chuyển Phông nền",
    "gui.howtos.imagine.step_imagineRecordASound": "Thêm một âm thanh",
    "gui.howtos.imagine.step_imagineChooseSound": "Chọn âm thanh",
    "gui.howtos.make-music.name": "Sáng tác âm nhạc",
    "gui.howtos.Make-Music.step_PickInstrument": "Lấy một nhân vật nhạc cụ",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Phát âm thanh khi được nhấn vào",
    "gui.howtos.Make-Music.step_MakeSong": "Tạo ra một bài hát",
    "gui.howtos.make-music.step_MakeBeat": "Chọn trống & tạo nhịp điệu",
    "gui.howtos.make-music.step_MakeBeatBox": "Chọn nhân vật Micro và Beatbox Ngẫu nhiên",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Thêm một Phông nền",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Nói gì đó",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Chuyển đổi Phông nền",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Làm trò chơi đuổi bắt",
    "gui.howtos.Chase-Game.step_BG": "Thêm một Phông nền",
    "gui.howtos.chase-game.step_AddOcto": "Thêm một Nhân vật",
    "gui.howtos.make-music.step_LeftRight": "Di chuyển sang trái và phải bằng phím mũi tên",
    "gui.howtos.Chase-Game.step_UpDown": "Di chuyển lên xuống bằng phím mũi tên",
    "gui.howtos.Chase-Game.step_AddStar": "Thêm nhân vật khác",
    "gui.howtos.Chase-Game.step_MoveRandom": "Di chuyển một cách ngẫu nhiên",
    "gui.howtos.Chase-Game.step_WhenTouch": "Đối với nhân vật Bạch tuộc, khi chạm vào thì phát âm thanh",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Thêm biến Điểm",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Đối với nhân vật Bạch tuộc, khi chạm vào ghi thêm điểm",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Thêm một Phông nền",
    "gui.howtos.animate-char.step_addsprite": "Thêm một Nhân vật",
    "gui.howtos.animate-char.step_saysomething": "Nói gì đó",
    "gui.howtos.animate-char.step_addsound": "Thêm Âm thanh",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Thay đổi Màu sắc",
    "gui.howtos.make-a-game.name": "Tạo một trò chơi Bấm và bấm",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Lấy một nhân vật",
    "gui.howtos.make-a-game.step_GamePlaySound": "Phát âm thanh khi được nhấn vào",
    "gui.howtos.make-a-game.step_GameAddScore": "Thêm biến Điểm",
    "gui.howtos.make-a-game.step_GameChangeScore": "Khi được nhấn, tăng điểm số lên",
    "gui.howtos.make-a-game.step_Random": "Đi đến vị trí ngẫu nhiên",
    "gui.howtos.make-music.step_GameChangeColor": "Thay đổi Màu sắc",
    "gui.howtos.make-music.step_ResetScore": "Đặt lại điểm",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Thêm một Phông nền",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Trượt xung quanh",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Thay đổi trang phục",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Nói gì đó",
    "gui.howtos.cartoon-network.step_CNglide": "Trượt xung quanh",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Tạo một biến số để ghi điểm",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Cảm biến Video",
    "gui.howtos.videosens.step_addextension": "Thêm phần mở rộng",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Thêm các lệnh Văn bản-thành-Tiếng nói",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Nói gì đó",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Di chuyển xung quanh",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Thêm một Phông nền",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Thêm nhân vật khác",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Trình điễn một bản nhạc",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Thay đổi Màu sắc",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Xoay vòng",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Phóng to và thu nhỏ",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Thêm một Nhân vật",
    "gui.howtos.add-sprite.step_addSprite": "Thêm một Nhân vật",
    "gui.howtos.add-a-backdrop.name": "Thêm một phông nền",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Thêm một Phông nền",
    "gui.howtos.change-size.name": "Thay đổi kích thước",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Trượt xung quanh",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Ghi lại âm thanh",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Làm nó Xoay",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Ẩn và hiện",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Tạo hiệu ứng hoạt hình cho nhân vật",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Dùng các phím mũi tên",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Thêm Hiệu ứng",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.extension.music.name": "Âm nhạc",
    "gui.extension.music.description": "Chơi nhạc cụ và trống",
    "gui.extension.pen.name": "Bút vẽ",
    "gui.extension.pen.description": "Vẽ bằng các nhân vật của bạn.",
    "gui.extension.videosensing.name": "Cảm biến Video",
    "gui.extension.videosensing.description": "Nhận diện chuyển động với máy ảnh",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Dịch",
    "gui.extension.translate.description": "Dịch văn bản ra nhiều ngôn ngữ.",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.microbit.description": "Kết nối dự án của bạn với thế giới.",
    "gui.extension.microbit.connectingMessage": "Đang kết nối",
    "gui.extension.ev3.description": "Làm những con rô-bốt tương tác và hơn thế nữa.",
    "gui.extension.ev3.connectingMessage": "Đang kết nối. Hãy chắc chắn rằng mã PIN trên EV3 của bạn là 1234.",
    "gui.extension.boost.description": "Bring robotic creations to life.",
    "gui.extension.boost.connectingMessage": "Connecting",
    "gui.extension.wedo2.description": "Xây dựng với mô-tơ và cảm biến.",
    "gui.extension.wedo2.connectingMessage": "Đang kết nối",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "Connecting",
    "gui.libraryTags.all": "Tất cả",
    "gui.libraryTags.animals": "Động vật",
    "gui.libraryTags.dance": "Khiêu vũ",
    "gui.libraryTags.effects": "Hiệu ứng",
    "gui.libraryTags.fantasy": "Tưởng tượng",
    "gui.libraryTags.fashion": "Thời trang",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Trong nhà",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Âm nhạc",
    "gui.libraryTags.notes": "Các lưu ý",
    "gui.libraryTags.outdoors": "Ngoài trời",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "Con người",
    "gui.libraryTags.percussion": "Bộ gõ",
    "gui.libraryTags.space": "Khoảng trắng",
    "gui.libraryTags.sports": "Thể thao",
    "gui.libraryTags.underwater": "Dưới nước",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Phim hoạt hình",
    "gui.libraryTags.art": "Nghệ thuật",
    "gui.libraryTags.games": "Trò chơi",
    "gui.libraryTags.stories": "Những câu chuyện",
    "gui.libraryTags.letters": "Ký tự",
    "gui.opcodeLabels.direction": "hướng",
    "gui.opcodeLabels.xposition": "vị trí-x",
    "gui.opcodeLabels.yposition": "vị trí-y",
    "gui.opcodeLabels.size": "kích thước",
    "gui.opcodeLabels.costumename": "tên trang phục",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "tên phông nền",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "âm lượng",
    "gui.opcodeLabels.tempo": "nhịp độ",
    "gui.opcodeLabels.answer": "trả lời",
    "gui.opcodeLabels.loudness": "độ ồn",
    "gui.opcodeLabels.username": "tên đăng nhập",
    "gui.opcodeLabels.year": "năm",
    "gui.opcodeLabels.month": "tháng",
    "gui.opcodeLabels.date": "ngày",
    "gui.opcodeLabels.dayofweek": "ngày trong tuần",
    "gui.opcodeLabels.hour": "giờ",
    "gui.opcodeLabels.minute": "phút",
    "gui.opcodeLabels.second": "giây",
    "gui.opcodeLabels.timer": "đồng hồ bấm giờ",
    "gui.projectLoader.loadError": "Tải file dự án thất bại.",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Bạn có muốn thay thế nội dung của dự án hiện tại?",
    "gui.sharedMessages.loadFromComputerTitle": "Mở từ máy tính",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Dự án Scratch",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "Phát nốt [NOTE] trong vòng [TIME] giây",
    "ev3.buttonPressed": "Nút [PORT] đã được ấn?",
    "ev3.getBrightness": "độ sáng",
    "ev3.getDistance": "khoảng cách",
    "ev3.getMotorPosition": "Đặt mô-tơ của đầu ra[PORT] đo độ xoay tổng cộng",
    "ev3.motorSetPower": "Đặt mô-tơ của đầu ra [PORT]với sức mạnh [POWER]%",
    "ev3.motorTurnClockwise": "Đặt mô-tơ của đầu ra [PORT] xoay chiều kim đồng hồ trong vòng [TIME] giây",
    "ev3.motorTurnCounterClockwise": "Đặt mô-tơ của đầu ra [PORT] xoay ngược chiều kim đồng hồ trong vòng [TIME] giây",
    "ev3.whenBrightnessLessThan": "khi độ sáng < [DISTANCE]",
    "ev3.whenButtonPressed": "khi nút [PORT] được bấm",
    "ev3.whenDistanceLessThan": "khi khoảng cách < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "mũi tên xuống",
    "makeymakey.downArrowShort": "xuống",
    "makeymakey.leftArrow": "mũi tên trái",
    "makeymakey.leftArrowShort": "trái",
    "makeymakey.rightArrow": "mũi tên phải",
    "makeymakey.rightArrowShort": "bên phải",
    "makeymakey.spaceKey": "phím trắng",
    "makeymakey.upArrow": "mũi tên lên",
    "makeymakey.upArrowShort": "lên",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microbit.buttonsMenu.any": "bất kỳ",
    "microbit.clearDisplay": "xóa hiển thị",
    "microbit.defaultTextToDisplay": "Xin chào!",
    "microbit.displaySymbol": "hiển thị [MATRIX]",
    "microbit.displayText": "hiển thị văn bản [TEXT]",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] được bấm?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.pinStateMenu.off": "tắt",
    "microbit.pinStateMenu.on": "bật",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "bất kỳ",
    "microbit.tiltDirectionMenu.back": "phía sau cùng",
    "microbit.tiltDirectionMenu.front": "phía trên cùng",
    "microbit.tiltDirectionMenu.left": "trái",
    "microbit.tiltDirectionMenu.right": "bên phải",
    "microbit.whenButtonPressed": "when [BTN] button pressed",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "music.categoryName": "Âm nhạc",
    "music.changeTempo": "thay đổi nhịp độ một lượng [TEMPO]",
    "music.drumBass": "(2) Trống Bass",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Đôi dùi gỗ",
    "music.drumClosedHiHat": "(6) Chũm chọe",
    "music.drumConga": "(14)Conga",
    "music.drumCowbell": "(11) Cowbel",
    "music.drumCrashCymbal": "(4) Chũm choẹ trung",
    "music.drumCuica": "(18) Culca",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Hand Clap",
    "music.drumOpenHiHat": "(5) Chũm chọe ",
    "music.drumSideStick": "(3) Side stick",
    "music.drumSnare": "(1) Trống lẫy ",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Hình tam giác ",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Mảnh ghép gỗ",
    "music.getTempo": "nhịp độ",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Đàn viô-lông-xen",
    "music.instrumentChoir": "(15) Đội đồng ca ",
    "music.instrumentClarinet": "(10)",
    "music.instrumentElectricGuitar": "(5) Guitar điện",
    "music.instrumentElectricPiano": "(2) Đàn Piano điện",
    "music.instrumentFlute": "(12) Sáo",
    "music.instrumentGuitar": "(4) Đàn guitar",
    "music.instrumentMarimba": "(19) Mộc cầm",
    "music.instrumentMusicBox": "(17) Hộp nhạc",
    "music.instrumentOrgan": "(3) Đàn organ",
    "music.instrumentPiano": "(1) đàn Piano",
    "music.instrumentPizzicato": "(7) Móc dây",
    "music.instrumentSaxophone": "(11) Kèn Saxophone ",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lea",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) thanh sáo gỗ",
    "music.midiPlayDrumForBeats": "chơi trống [DRUM] trong [BEATS] nhịp",
    "music.midiSetInstrument": "đặt nhạc cụ là [INSTRUMENT]",
    "music.playDrumForBeats": "chơi trống [DRUM] trong [BEATS] nhịp",
    "music.playNoteForBeats": "chơi nốt nhạc [NOTE] trong [BEATS] nhịp",
    "music.restForBeats": "nghỉ trong [BEATS] nhịp",
    "music.setInstrument": "đặt nhạc cụ là [INSTRUMENT]",
    "music.setTempo": "thay đổi nhịp độ thành [TEMPO]",
    "pen.categoryName": "Bút vẽ",
    "pen.changeColorParam": "thay đổi [COLOR_PARAM] bút một lượng [VALUE]",
    "pen.changeHue": "thay đổi màu bút vẽ bằng [HUE]",
    "pen.changeShade": "đổi độ đậm bút vẽ bằng [SHADE]",
    "pen.changeSize": "thay đổi độ dày của nét bút [SIZE]",
    "pen.clear": "Xóa tất cả",
    "pen.colorMenu.brightness": "độ sáng",
    "pen.colorMenu.color": "màu",
    "pen.colorMenu.saturation": "độ bão hòa",
    "pen.colorMenu.transparency": "độ trong suốt",
    "pen.penDown": "đặt bút",
    "pen.penUp": "nhấc bút",
    "pen.setColor": "chọn bút màu [COLOR]",
    "pen.setColorParam": "đặt [COLOR_PARAM] bút bằng [VALUE]",
    "pen.setHue": "chọn bút màu [HUE]",
    "pen.setShade": "đặt độ đậm của bút vẽ thành [SHADE]",
    "pen.setSize": "đặt kích thước bút vẽ bằng [SIZE]",
    "pen.stamp": "in hình",
    "speech.defaultWhenIHearValue": "let''s go",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "listen and wait",
    "speech.speechReporter": "speech",
    "speech.whenIHear": "when I hear [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "xin chào",
    "text2speech.giant": "giant",
    "text2speech.kitten": "kitten",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "set voice to [VOICE]",
    "text2speech.speakAndWaitBlock": "nói [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Dịch",
    "translate.defaultTextToTranslate": "xin chào",
    "translate.translateBlock": "dịch [WORDS] sang ngôn ngữ [LANGUAGE]",
    "translate.viewerLanguage": "language",
    "videoSensing.categoryName": "Cảm biến Video",
    "videoSensing.direction": "hướng",
    "videoSensing.motion": "chuyển động",
    "videoSensing.off": "tắt",
    "videoSensing.on": "bật",
    "videoSensing.onFlipped": "khi lật",
    "videoSensing.setVideoTransparency": "đặt độ trong suốt của video thành [TRANSPARENCY]",
    "videoSensing.sprite": "nhân vật",
    "videoSensing.stage": "Sân khấu",
    "videoSensing.videoOn": "mở [ATTRIBUTE] trên [SUBJECT]",
    "videoSensing.videoToggle": "mở video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "khi chuyển động của video > [REFERENCE]",
    "wedo2.getDistance": "khoảng cách",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "huớng kia",
    "wedo2.motorDirection.forward": "hướng này",
    "wedo2.motorDirection.reverse": "đảo ngược",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "chơi nốt nhạc trong [NOTE] trong [DURATION] giây",
    "wedo2.setLightHue": "set light color to [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "bất kỳ",
    "wedo2.tiltDirection.down": "xuống",
    "wedo2.tiltDirection.left": "trái",
    "wedo2.tiltDirection.right": "bên phải",
    "wedo2.tiltDirection.up": "lên",
    "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Màu",
    "paint.paintEditor.saturation": "Độ bão hòa",
    "paint.paintEditor.brightness": "Độ sáng",
    "paint.paintEditor.costume": "Trang phục",
    "paint.paintEditor.group": "Nhóm",
    "paint.paintEditor.ungroup": "Hủy nhóm",
    "paint.paintEditor.undo": "Hoàn tác",
    "paint.paintEditor.redo": "Làm lại ",
    "paint.paintEditor.forward": "Đưa lên phía trên",
    "paint.paintEditor.backward": "Đưa ra phía sau",
    "paint.paintEditor.front": "Đưa lên phía trên cùng",
    "paint.paintEditor.back": "Đưa ra phía sau cùng",
    "paint.paintEditor.more": "Nhiều hơn",
    "paint.modeTools.brushSize": "Kích thước ",
    "paint.modeTools.eraserSize": "Kích thước tẩy",
    "paint.modeTools.copy": "Sao chép",
    "paint.modeTools.paste": "Dán",
    "paint.modeTools.delete": "Xóa",
    "paint.modeTools.curved": "Uốn cong",
    "paint.modeTools.pointed": "Góc nhọn",
    "paint.modeTools.thickness": "Độ dày ngòi bút",
    "paint.modeTools.flipHorizontal": "Lật ngang",
    "paint.modeTools.flipVertical": "Lật dọc",
    "paint.modeTools.filled": "Hình đầy",
    "paint.modeTools.outlined": "Hình rỗng",
    "paint.paintEditor.bitmap": "Chuyển thành Bitmap",
    "paint.paintEditor.vector": "Chuyển thành Vector",
    "paint.paintEditor.fill": "Tô",
    "paint.paintEditor.stroke": "Viền",
    "paint.brushMode.brush": "Cọ vẽ",
    "paint.eraserMode.eraser": "Tẩy",
    "paint.fillMode.fill": "Tô",
    "paint.lineMode.line": "Dòng",
    "paint.ovalMode.oval": "Hình tròn",
    "paint.rectMode.rect": "Hình chữ nhật",
    "paint.reshapeMode.reshape": "Đổi hình dạng",
    "paint.roundedRectMode.roundedRect": "Hình vuông góc tròn",
    "paint.selectMode.select": "Chọn",
    "paint.textMode.text": "Văn bản",
    "paint.colorPicker.swap": "Đổi màu"
  },
  "tr": {
    "gui.alerts.lostPeripheralConnection": "Scratch ile {extensionName} bağlantısı kesildi.",
    "gui.alerts.tryAgain": "Tekrar Dene",
    "gui.alerts.download": "İndir",
    "gui.connection.reconnect": "Tekrar Bağlan",
    "gui.backpack.costumeLabel": "kostüm",
    "gui.backpack.soundLabel": "ses",
    "gui.backpack.scriptLabel": "dizi",
    "gui.backpack.spriteLabel": "kukla",
    "gui.backpack.header": "Sırt Çantası",
    "gui.backpack.errorBackpack": "Sırt çantası yüklenirken hata oluştu",
    "gui.backpack.loadingBackpack": "Yükleniyor...",
    "gui.backpack.more": "Daha Fazla",
    "gui.backpack.emptyBackpack": "Sırt Çantası boş",
    "gui.unsupportedBrowser.label": "Web tarayıcınız desteklenmiyor",
    "gui.unsupportedBrowser.errorLabel": "Bir Hata Oluştu.",
    "gui.unsupportedBrowser.notRecommended": "Maalesef Scratch' in desteklemediği bir tarayıcı sürümü kullanıyorsunuz. Google Chrome, Mozilla Firefox, Microsoft Edge veya Apple Safari gibi desteklenen bir tarayıcının en son sürümüne güncelleme yapmanızı öneririz.",
    "gui.unsupportedBrowser.description": "Maalesef Scratch bu tarayıcıyı desteklemiyor. Google Chrome, Mozilla Firefox, Microsoft Edge veya Apple Safari gibi desteklenen bir tarayıcının en son sürümüne güncelleme yapmanızı öneririz.",
    "gui.unsupportedBrowser.back": "Geri",
    "gui.unsupportedBrowser.previewfaq": "Daha fazlası öğrenmek için {previewFaqLink} bağlantısını ziyaret edin.",
    "gui.unsupportedBrowser.previewfaqlinktext": "SSS",
    "gui.cards.all-tutorials": "Öğreticiler",
    "gui.cards.shrink": "Küçült",
    "gui.cards.expand": "Açıkla",
    "gui.cards.close": "Kapat",
    "gui.cards.more-things-to-try": "Denemek için daha fazla şey!",
    "gui.cards.see-more": "Daha fazla görüntüle",
    "gui.comingSoon.message1": "Endişelenmeyin, üzerinde çalışıyoruz {emoji}",
    "gui.comingSoon.message2": "Çok Yakında...",
    "gui.comingSoon.message3": "Üzerinde çalışıyoruz {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Cihaz bulunamadı",
    "gui.connection.auto-scanning.prescan": "Aramayı başlatmak için cihazını yakınında bulundur.",
    "gui.connection.auto-scanning.pressbutton": "Cihazındaki düğmeye bas.",
    "gui.connection.auto-scanning.start-search": "Aramaya Başla",
    "gui.connection.connecting-searchbutton": "Aranıyor...",
    "gui.connection.auto-scanning.try-again": "Tekrar dene",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Bağlandı",
    "gui.connection.disconnect": "Bağlantıyı Kes",
    "gui.connection.go-to-editor": "Editöre Git",
    "gui.connection.connecting-cancelbutton": "Bağlanıyor...",
    "gui.connection.error.errorMessage": "Hoop! Bir şeyler yanlış gitti.",
    "gui.connection.error.tryagainbutton": "Tekrar dene",
    "gui.connection.error.helpbutton": "Yardım",
    "gui.connection.peripheral-name-label": "Cihaz adı",
    "gui.connection.connect": "Bağlan",
    "gui.connection.scanning.lookingforperipherals": "Cihazlar aranıyor",
    "gui.connection.scanning.noPeripheralsFound": "Cihaz bulunamadı",
    "gui.connection.scanning.instructions": "Yukarıdaki listeden cihazını seç.",
    "gui.connection.search": "Yenile",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Scratch Link programının kurulduğundan ve çalıştığından emin ol",
    "gui.connection.unavailable.enablebluetooth": "Bluetooth'un etkinleştirildiğini kontrol et",
    "gui.connection.unavailable.tryagainbutton": "Tekrar dene",
    "gui.connection.unavailable.helpbutton": "Yardım",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Git",
    "gui.controls.stop": "Durdur",
    "gui.crashMessage.label": "Hoop! Bir hata oldu.",
    "gui.crashMessage.description": "Çok üzgünüz,  Scratch çökmüş görünüyor. Bu sorun Scratch Takımına otomatik olarak iletildi. Lütfen sayfayı yenileyerek tekrar deneyiniz.",
    "gui.crashMessage.errorNumber": "{errorId} numaralı bir hata kaydedildi.",
    "gui.crashMessage.reload": "Yeniden yükle",
    "gui.customProcedures.myblockModalTitle": "Bir Blok Oluştur",
    "gui.customProcedures.addAnInputNumberText": "Bir girdi ekle",
    "gui.customProcedures.numberTextType": "sayı veya metin",
    "gui.customProcedures.addAnInputBoolean": "Bir girdi ekle",
    "gui.customProcedures.booleanType": "mantıksal",
    "gui.customProcedures.addALabel": "Bir etiket ekle",
    "gui.customProcedures.runWithoutScreenRefresh": "Ekranı yenilemeden çalışsın",
    "gui.customProcedures.cancel": "Vazgeç",
    "gui.customProcedures.ok": "Tamam",
    "gui.SpriteInfo.direction": "Yön",
    "gui.directionPicker.rotationStyles.allAround": "her yöne dön",
    "gui.directionPicker.rotationStyles.leftRight": "sağa-sola",
    "gui.directionPicker.rotationStyles.dontRotate": "döndürme",
    "gui.gui.addExtension": "Eklenti Ekle",
    "gui.gui.codeTab": "Kod",
    "gui.gui.backdropsTab": "Dekorlar",
    "gui.gui.costumesTab": "Kostümler",
    "gui.gui.soundsTab": "Sesler",
    "gui.extensionLibrary.comingSoon": "Çok Yakında",
    "gui.extensionLibrary.requires": "Gereksinimler",
    "gui.extensionLibrary.collaboration": "İşbirliği ile",
    "gui.library.filterPlaceholder": "Ara",
    "gui.library.allTag": "Tümü",
    "gui.loader.message1": "Bloklar yaratılıyor ...",
    "gui.loader.message2": "Kuklalar yükleniyor ...",
    "gui.loader.message3": "Sesler yükleniyor ...",
    "gui.loader.message4": "Eklentiler yükleniyor ...",
    "gui.loader.message5": "Kediler toplanıyor...",
    "gui.loader.message6": "Nanolar iletiliyor ...",
    "gui.loader.message7": "Gobolar şişiriliyor ...",
    "gui.loader.message8": "Emojiler hazırlanıyor ...",
    "gui.loader.headline": "Proje Yükleniyor",
    "gui.loader.creating": "Proje Oluştur",
    "gui.accountMenu.profile": "Profil",
    "gui.accountMenu.myStuff": "Kendiminkiler",
    "gui.accountMenu.myClasses": "Sınıflarım",
    "gui.accountMenu.myClass": "Sınıfım",
    "gui.accountMenu.accountSettings": "Hesap ayarları",
    "gui.accountMenu.signOut": "Çıkış",
    "gui.authorInfo.byUser": "{username} tarafından",
    "gui.menuBar.seeProjectPage": "Proje sayfasına bak",
    "gui.menuBar.language": "Dil",
    "general.username": "Kullanıcı Adı",
    "general.password": "Şifre",
    "general.signIn": "Giriş",
    "login.needHelp": "Yardım mı Lazım?",
    "form.validationRequired": "Bu alan gerekli",
    "gui.menuBar.tutorialsLibrary": "Eğitici Dersler",
    "gui.menuBar.restoreSprite": "Kuklayı Geri Getir",
    "gui.menuBar.restoreSound": "Sesi Geri Getir",
    "gui.menuBar.restoreCostume": "Kostümü Geri Getir",
    "gui.menuBar.restore": "Geri Getir",
    "gui.menuBar.saveNow": "Şimdi kaydet",
    "gui.menuBar.saveAsCopy": "Kopya olarak kaydet",
    "gui.menuBar.remix": "Katkı Yap",
    "gui.menuBar.new": "Yeni",
    "gui.menuBar.file": "Dosya",
    "gui.menuBar.downloadToComputer": "Bilgisayarına kaydet",
    "gui.menuBar.edit": "Düzenle",
    "gui.menuBar.turboModeOff": "Turbo Modu kapat",
    "gui.menuBar.turboModeOn": "Turbo Modu aç",
    "gui.menuBar.modeMenu": "Mod",
    "gui.menuBar.normalMode": "Normal mod",
    "gui.menuBar.caturdayMode": "Kedartesi modu",
    "gui.menuBar.joinScratch": "Scratch'a Katıl",
    "gui.menuBar.signIn": "Giriş",
    "gui.gui.projectTitlePlaceholder": "Proje başlığı buraya",
    "gui.menuBar.saveNowLink": "Şimdi kaydet",
    "gui.menuBar.settings": "Ayarlar",
    "gui.menuBar.isShared": "Paylaşılan",
    "gui.menuBar.share": "Paylaş",
    "gui.menuBar.colorMode": "Renk Modu",
    "gui.modal.help": "Yardım",
    "gui.modal.back": "Geri",
    "gui.monitor.listMonitor.empty": "(boş)",
    "gui.monitor.listMonitor.listLength": "uzunluğu {length}",
    "gui.monitor.contextMenu.default": "normal görünüm",
    "gui.monitor.contextMenu.large": "geniş görünüm",
    "gui.monitor.contextMenu.slider": "slider",
    "gui.monitor.contextMenu.sliderRange": "Kaygan aralığını ayarla",
    "gui.monitor.contextMenu.import": "içe aktar",
    "gui.monitor.contextMenu.export": "dışarıya aktar",
    "gui.monitor.contextMenu.hide": "gizle",
    "gui.playButton.play": "Çal",
    "gui.playButton.stop": "Durdur",
    "gui.gui.variableScopeOptionAllSprites": "Tüm kuklalar için",
    "gui.gui.variableScopeOptionSpriteOnly": "Sadece bu kukla için",
    "gui.gui.cloudVariableOption": "Bulut değişkeni (sunucuda saklanır)",
    "gui.gui.variablePromptAllSpritesMessage": "Bu değişken tüm kuklalar için geçerli olacak.",
    "gui.gui.listPromptAllSpritesMessage": "Bu liste tüm kuklalara açık olacak.",
    "gui.prompt.cancel": "Vazgeç",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Durdur",
    "gui.playbackStep.playMsg": "Çal",
    "gui.playbackStep.loadingMsg": "Yükleniyor...",
    "gui.playbackStep.saveMsg": "Kaydet",
    "gui.playbackStep.reRecordMsg": "Yeniden kaydet",
    "gui.recordModal.title": "Ses Kaydet",
    "gui.recordingStep.beginRecord": "Aşağıdaki düğmeye tıklayarak kayda başlayın",
    "gui.recordingStep.permission": "{arrow}Mikrofonunuzu kullanmak için izninize ihtiyacımız var",
    "gui.recordingStep.stop": "Kaydı durdur",
    "gui.recordingStep.record": "Kaydet",
    "gui.sliderModal.min": "En düşük değer",
    "gui.sliderModal.max": "En yüksek değer",
    "gui.sliderModal.title": "Kaygan aralığını ayarla",
    "gui.sliderPrompt.cancel": "İptal",
    "gui.sliderPrompt.ok": "Tamam",
    "gui.soundEditor.sound": "Ses",
    "gui.soundEditor.play": "Çal",
    "gui.soundEditor.stop": "Durdur",
    "gui.soundEditor.copy": "Kopyala",
    "gui.soundEditor.paste": "Yapıştır",
    "gui.soundEditor.copyToNew": "Yenisine kopyala",
    "gui.soundEditor.delete": "Sil",
    "gui.soundEditor.save": "Kaydet",
    "gui.soundEditor.undo": "Geri Al",
    "gui.soundEditor.redo": "Geri Al",
    "gui.soundEditor.faster": "Daha hızlı",
    "gui.soundEditor.slower": "Daha Yavaş",
    "gui.soundEditor.echo": "Yankı",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Daha sesli",
    "gui.soundEditor.softer": "Daha Yumuşak",
    "gui.soundEditor.reverse": "Tersi",
    "gui.soundEditor.fadeOut": "sesi azalt",
    "gui.soundEditor.fadeIn": "Sesi çoğalt",
    "gui.soundEditor.mute": "Sustur",
    "gui.SpriteInfo.spritePlaceholder": "İsim",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Kukla",
    "gui.SpriteInfo.show": "Göster",
    "gui.SpriteInfo.size": "Büyüklük",
    "gui.spriteSelectorItem.contextMenuDuplicate": "kopyasını çıkart",
    "gui.spriteSelectorItem.contextMenuExport": "dışarıya aktar",
    "gui.spriteSelectorItem.contextMenuDelete": "sil",
    "gui.spriteSelector.addSpriteFromLibrary": "Bir Kukla Seç",
    "gui.spriteSelector.addSpriteFromPaint": "Çizim",
    "gui.spriteSelector.addSpriteFromSurprise": "Sürpriz",
    "gui.spriteSelector.addSpriteFromFile": "Kuklayı yükle",
    "gui.stageHeader.stageSizeLarge": "Geniş ekrana geç",
    "gui.stageHeader.stageSizeSmall": "Küçük sahneye geç",
    "gui.stageHeader.stageSizeFull": "Tam ekran moduna geç",
    "gui.stageHeader.stageSizeUnFull": "Tam ekran modundan çık",
    "gui.stageHeader.fullscreenControl": "Tam Ekran Kontrolü",
    "gui.spriteSelector.addBackdropFromLibrary": "Bir Dekor Seç",
    "gui.stageSelector.addBackdropFromPaint": "Çizim",
    "gui.stageSelector.addBackdropFromSurprise": "Sürpriz",
    "gui.stageSelector.addBackdropFromFile": "Dekor Yükle",
    "gui.stageSelector.stage": "Sahne",
    "gui.stageSelector.backdrops": "Dekorlar",
    "gui.telemetryOptIn.label": "Scratch'ı iyileştirmek için istatistikleri raporla.",
    "gui.telemetryOptIn.body1": "Scratch Ekibi, her zaman Scratch'in tüm dünyada nasıl kullanıldığını daha iyi anlamaya çalışmaktadır. Bu çabaya destek olmak için Scratch'in, kullanımı ile ilgili bilgileri Scratch Ekibine otomatik olarak göndermesine izin verebilirsiniz. ",
    "gui.telemetryOptIn.body2": "Topladığımız bilgiler şunları içerir; blok kullanımı, kaydetme, geri yükleme ve proje yükleme gibi olaylar. Kişisel bilgileri TOPLAMIYORUZ. Lütfen daha fazla detay için {privacyPolicyLink} inceleyiniz.",
    "gui.telemetryOptIn.privacyPolicyLink": "Gizlilik İlkesi",
    "gui.telemetryOptIn.optInText": "Kullanım verilerimi Scratch Ekibi ile paylaş",
    "gui.telemetryOptIn.optInTooltip": "Telemetriyi aç",
    "gui.telemetryOptIn.optOutText": "Kullanım verilerimi Scratch Ekibi ile paylaşma",
    "gui.telemetryOptIn.optOutTooltip": "Telemetriyi kapat",
    "gui.telemetryOptIn.settingWasUpdated": "Ayarlarınız güncellendi.",
    "gui.telemetryOptIn.buttonClose": "Kapat",
    "gui.turboMode.active": "Turbo Modu",
    "gui.webglModal.label": "Web Tarayıcınızın WebGL Desteği Bulunmamaktadır",
    "gui.webglModal.description": "Maalesef tarayıcınız veya bilgisayarınız {webGlLink} gibi görünüyor. Scratch 3.0'ın çalışması için bu teknoloji gereklidir.",
    "gui.webglModal.webgllink": "WebGL desteğiniz bulunmamaktadır",
    "gui.webglModal.back": "Geri",
    "gui.webglModal.previewfaq": "Daha fazlası için, {previewFaqLink} bağlantısını ziyaret edin.",
    "gui.webglModal.previewfaqlinktext": "SSS",
    "gui.costumeLibrary.chooseABackdrop": "Bir Dekor Seç",
    "gui.costumeLibrary.chooseACostume": "Bir Kostüm Seç",
    "gui.costumeTab.addBackdropFromLibrary": "Bir Dekor Seç",
    "gui.costumeTab.addCostumeFromLibrary": "Bir Kostüm Seç",
    "gui.costumeTab.addBlankCostume": "Çizim",
    "gui.costumeTab.addSurpriseCostume": "Sürpriz",
    "gui.costumeTab.addFileBackdrop": "Dekor Yükle",
    "gui.costumeTab.addFileCostume": "Kostüm Yükle",
    "gui.extensionLibrary.chooseAnExtension": "Bir Uzantı Seç",
    "gui.extensionLibrary.extensionUrl": "Uzantının URL'ini giriniz",
    "gui.monitors.importListColumnPrompt": "Hangi sütun kullanılmalı (1-{numberOfColumns}) ?",
    "gui.recordingStep.alertMsg": "Kayıda başlanamıyor",
    "gui.soundLibrary.chooseASound": "Bir Ses Seç",
    "gui.soundTab.fileUploadSound": "Ses Yükle",
    "gui.soundTab.surpriseSound": "Sürpriz",
    "gui.soundTab.recordSound": "Kaydet",
    "gui.soundTab.addSoundFromLibrary": "Bir Ses Seç",
    "gui.spriteLibrary.chooseASprite": "Bir Kukla Seç",
    "gui.tipsLibrary.tutorials": "Bir Öğretici Ders Seç",
    "gui.alerts.createsuccess": "Yeni Proje oluşturuldu.",
    "gui.alerts.createcopysuccess": "Proje kopya olarak kaydedildi.",
    "gui.alerts.createremixsuccess": "Proje katkı olarak kaydedildi.",
    "gui.alerts.creating": "Yeni oluşturuluyor...",
    "gui.alerts.creatingCopy": "Proje kopyalanıyor...",
    "gui.alerts.creatingRemix": "Proje katkılanıyor...",
    "gui.alerts.creatingError": "Projeniz kaydedilemedi. Lütfen tekrar deneyin!",
    "gui.alerts.savingError": "Proje kaydedilemedi.",
    "gui.alerts.savesuccess": "Proje kaydedildi.",
    "gui.alerts.saving": "Proje kaydediliyor...",
    "gui.alerts.cloudInfo": "Lütfen dikkat, bulut değişkenleri sadece sayıları destekler; harfler ve semboller desteklenmiyor. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Daha fazlasını öğren.",
    "gui.alerts.importing": "İçe aktarılıyor...",
    "gui.defaultProject.meow": "Miyav",
    "gui.defaultProject.variable": "değişkenim",
    "gui.howtos.intro-move-sayhello-hat.name": "Başlayalım",
    "gui.howtos.intro-move.step_stepMove": "Bir hareket bloğu ekle",
    "gui.howtos.add-a-move-block.step_stepSay": "Bir \"de\" bloğu ekle",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Başlamak için yeşil bayrağa tıkla",
    "gui.howtos.intro-getting-started-ASL.name": "Başlarken - ASL",
    "gui.howtos.animate-a-name.name": "Bir ismi Hareketlendir",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Bir Harf Kuklası Seç",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Tıklandığında Bir Ses Çal",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Başka Bir Harf Kuklası Seç",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Renk değiştir",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Başka Bir Harf Kuklası Seç ve Döndür",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Başka Bir Harf Kuklası Seç ve Büyüt",
    "gui.howtos.imagine": "Bir dünya hayal et",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Ne demek istediğini yaz",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Başlamak için yeşil bayrağa tıkla",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Herhangi Bir Dekor Seç",
    "gui.howtos.imagine.step_imagineChooseSprite": "Herhangi Bir Kukla Seç",
    "gui.howtos.imagine.step_imagineFlyAround": "Kaymak için boşluk tuşuna bas.",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Başka Bir Kukla Seç",
    "gui.howtos.imagine.step_imagineLeftRight": "Sola-sağa hareket et",
    "gui.howtos.imagine.step_imagineUpDown": "Aşağı-Yukarı Hareket Et",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Kostüm Değiştir",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Bir Noktaya Kay",
    "gui.howtos.imagine.step_imagineGrowShrink": "Büyü ve Küçül",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Başka Bir Dekor Seç",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Dekorları Değiştir",
    "gui.howtos.imagine.step_imagineRecordASound": "Bir Ses Ekle",
    "gui.howtos.imagine.step_imagineChooseSound": "Bir Ses Seç",
    "gui.howtos.make-music.name": "Müzik Yap",
    "gui.howtos.Make-Music.step_PickInstrument": "Bir Enstrüman Kuklası Seç",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Tıklandığında Ses Çal",
    "gui.howtos.Make-Music.step_MakeSong": "Bir Şarkı Oluştur",
    "gui.howtos.make-music.step_MakeBeat": "Bir Davul Seç & Bir Vuruş Yap",
    "gui.howtos.make-music.step_MakeBeatBox": "Mikrofon Kuklası  ve Sürpriz Beatbox Seç",
    "gui.howtos.story.name": "Hikaye Yarat",
    "gui.howtos.story.step_addbg": "Bir Dekor Ekle",
    "gui.howtos.story.step_addsprite": "Bir Karakter Ekle",
    "gui.howtos.story.step_saysomething": "Birşeyler Söyle",
    "gui.howtos.story.step_addanothersprite": "Başka Karakter Ekle",
    "gui.howtos.story.step_flip": "Yönü Çevir",
    "gui.howtos.story.step_conversation": "Görüşme yap",
    "gui.howtos.story.addanotherbg": "başka bir Dekor Ekle",
    "gui.howtos.story.step_swithbg": "Dekorları Değiştir",
    "gui.howtos.story.step_hidewizard": "Bir Karakteri Gizle",
    "gui.howtos.story.step_showwizard": "Bir Karakteri Göster",
    "gui.howtos.make-a-chase-game.name": "Bir Takip Oyunu Yap",
    "gui.howtos.Chase-Game.step_BG": "Bir Dekor Ekle",
    "gui.howtos.chase-game.step_AddOcto": "Bir Kukla Ekle",
    "gui.howtos.make-music.step_LeftRight": "Ok Tuşlarıyla Sağa ve Sola Hareket Et",
    "gui.howtos.Chase-Game.step_UpDown": "Ok Tuşları ile Aşağı ve Yukarı Hareket Et",
    "gui.howtos.Chase-Game.step_AddStar": "Başka Bir Kukla Ekle",
    "gui.howtos.Chase-Game.step_MoveRandom": "Rastgele Hareket Et",
    "gui.howtos.Chase-Game.step_WhenTouch": "Ahtapot kuklasında, ses çala tıklandığında",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Skor Değişkeni Oluştur",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Ahtaopot Kuklada Skor Ekleye Dokununca",
    "gui.howtos.animate-char.name": "Bir Karakteri Canlandır",
    "gui.howtos.animate-char.step_addbg": "Bir Dekor Ekle",
    "gui.howtos.animate-char.step_addsprite": "Bir Kukla Ekle",
    "gui.howtos.animate-char.step_saysomething": "Birşeyler Söyle",
    "gui.howtos.animate-char.step_addsound": "Ses Ekle",
    "gui.howtos.animate-char.step_animatetalking": "Konuşmayı Canlandır",
    "gui.howtos.animate-char.step_arrowkeys": "Ok Tuşlarıyla Hareket Ettir",
    "gui.howtos.animate-char.step_jump": "Zıpla",
    "gui.howtos.animate-char.step_changecolor": "Renk Değiştir",
    "gui.howtos.make-a-game.name": "Bir Tıkırtı Oyunu Yap",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Bir Kukla Seç",
    "gui.howtos.make-a-game.step_GamePlaySound": "Tıklandığında Ses Çal",
    "gui.howtos.make-a-game.step_GameAddScore": "Skor Değişkeni Oluştur",
    "gui.howtos.make-a-game.step_GameChangeScore": "Tıklandığında Sokuru Artır",
    "gui.howtos.make-a-game.step_Random": "Rastgele bir konuma git",
    "gui.howtos.make-music.step_GameChangeColor": "Renk Değiştir",
    "gui.howtos.make-music.step_ResetScore": "Skoru Sıfırla",
    "gui.howtos.make-it-fly.name": "Uçur",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Bir Gök Dekoru Seç",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Bir Karakter Seç",
    "gui.howtos.fly.step_stepflySaySomething": "Birşeyler Söyle",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Ok Tuşlarıyla Hareket Et",
    "gui.howtos.fly.step_stepflyChooseObject": "Toplanacak Bir Nesne Seç",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Nesneyi Hareket Ettir",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Karakterini Seç",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Puan Ekle",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Puan Say",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Sahne dekoru ekle",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Sahneyi Hareket Ettir",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Sonraki Kostüm",
    "gui.howtos.pong": "Pong Oyunu",
    "gui.howtos.pong.step_pongAddBackdrop": "Bir Dekor Ekle",
    "gui.howtos.pong.step_pongAddBallSprite": "Bir Top Kuklası Ekle",
    "gui.howtos.pong.step_pongBounceAround": "Dört Kenardan Sek",
    "gui.howtos.pong.step_pongAddPaddle": "Bir Raket Ekle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Raketi Hareket Ettir",
    "gui.howtos.pong.step_pongSelectBallSprite": "Top Kuklasını Seç",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Topu Raketten Sektirecek kod ekle",
    "gui.howtos.pong.step_pongAddAScore": "Puan Ekle",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Menüden \"Puan\" Seç:",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "\"Puan Değiştir\" bloğunu araya ekle",
    "gui.howtos.pong.step_pongResetScore": "Skoru Sıfırla",
    "gui.howtos.pong.step_pongAddLineSprite": "Çizgi Kuklasını Ekle",
    "gui.howtos.pong.step_pongGameOver": "Oyun Bitti",
    "gui.howtos.code-cartoon": "Çizgi Film Kodla",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Yeşil Bayrağı Tıkladığında Bir Şey Söyle",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Tıkladığında Bir Karakteri Canlandır",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Değişik bir Karakter Seç",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Küçültmek İçin Eksi İşaretini Kullanın.",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Bir Karakteri Büyütüp Küçült.",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Değişik bir Karakter Seç",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Aşağı Yukarı Zıpla",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Sahneleri Değiştirmek İçin Bir Karaktere Tıklayın",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Etrafta Süzül",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Kostüm Değiştir",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Çizgi Filmine Eklemek İçin Daha Fazla Karakter Seç",
    "gui.howtos.cartoon-network": "Bir Macera Oyununu Canlandır",
    "gui.howtos.cartoon-network.step_CNcharacter": "Gösterilecek Kukla Seç",
    "gui.howtos.cartoon-network.step_CNsay": "Birşeyler Söyle",
    "gui.howtos.cartoon-network.step_CNglide": "Etrafta Süzül",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Takip için Bir Nesne Seçin",
    "gui.howtos.cartoon-network.step_CNcollect": "Nesneleri Topla",
    "gui.howtos.cartoon-network.step_CNvariable": "Puan Değişkeni Oluşturun",
    "gui.howtos.cartoon-network.step_CNscore": "Puan Say",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Seviye Atla: Arka Planı Değiştir",
    "gui.howtos.videosens.name": "Video Algılama",
    "gui.howtos.videosens.step_addextension": "Eklenti Ekle",
    "gui.howtos.videosens.step_pet": "Kediyi okşa",
    "gui.howtos.videosens.step_animate": "Canlandır",
    "gui.howtos.videosens.step_pop": "Bir balon patlat.",
    "gui.howtos.say-it-out-loud": "Konuşan Animasyonlar Yaratın",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Metni Konuşma bloklarını ekle",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Birşeyler Söyle",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Bir Ses Ayarla",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Hareket Et",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Bir Dekor Ekle",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Başka Karakter Ekle",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Şarkı söyle",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Renk Değiştir",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Etrafında dön",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Büyü ve Küçül",
    "gui.howtos.talking": "Konuşan Hikayeler",
    "gui.howtos.talking.step_talesAddExtension": "Metni Konuşma Bloklarını Eklemek İçin Tıkla",
    "gui.howtos.talking.step_talesChooseSprite": "Bir Kukla Seç",
    "gui.howtos.talking.step_talesSaySomething": "Bir Karakteri Konuştur",
    "gui.howtos.talking.step_talesChooseBackdrop": "Bir Dekor Seç",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Dekorları Değiştirmek İçin Bir Karaktere Tıklayın",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Başka Bir Kukla Seç",
    "gui.howtos.talking.step_talesMoveAround": "Hareket Et",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Başka Bir Dekor Seç",
    "gui.howtos.talking.step_talesAnimateTalking": "Konuşmayı Canlandır",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Başka Bir Dekor Seç",
    "gui.howtos.talking.step_talesChooseSound": "Dans Edilecek Bir Şarkı Seç",
    "gui.howtos.talking.step_talesDanceMoves": "Dans Hareketleri",
    "gui.howtos.talking.step_talesAskAnswer": "Algılama Kategorisinden Ask ve Cevap Bloklarını Al",
    "gui.howtos.add-sprite.name": "Bir Kukla Ekle",
    "gui.howtos.add-sprite.step_addSprite": "Bir Kukla Ekle",
    "gui.howtos.add-a-backdrop.name": "Bir Dekor Ekle",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Bir Dekor Ekle",
    "gui.howtos.change-size.name": "Boyutu değiştir",
    "gui.howtos.change-size.step_changeSize": "Boyutu değiştir",
    "gui.howtos.glide-around.name": "Etrafta Süzül",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Etrafta Süzül",
    "gui.howtos.change-size.step_glideAroundPoint": "Bir noktaya kay",
    "gui.howtos.record-a-sound.name": "Bir Ses Kaydet",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "\"Sesler\" Sekmesini Tıkla",
    "gui.howtos.change-size.step_recordASoundClickRecord": "'Kaydet'i Tıkla",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Kaydet Düğmesine Bas",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Bir Ses Seç",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Sesini Çal",
    "gui.howtos.spin-video.name": "Etrafında döndür",
    "gui.howtos.change-size.step_spinTurn": "Dön",
    "gui.howtos.change-size.step_spinPointInDirection": "Yön Ayarla",
    "gui.howtos.hide-and-show.name": "Gizle & Göster",
    "gui.howtos.change-size.step_hideAndShow": "Gizle & Göster",
    "gui.howtos.switch-costume.name": "Bir Kostümü Hareketlendir",
    "gui.howtos.change-size.step_switchCostumes": "Bir kuklayı canlandır",
    "gui.howtos.move-around-with-arrow-keys.name": "Ok tuşlarını kullan",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Sola ve Sağa Hareket Et",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Aşağı ve Yukarı Hareket Et",
    "gui.howtos.add-effects.name": "Etkiler ekle",
    "gui.howtos.videosens.step_addEffects": "Etkiler ekle",
    "gui.extension.music.name": "Müzik",
    "gui.extension.music.description": "Çalgıları ve davulları çal.",
    "gui.extension.pen.name": "Kalem",
    "gui.extension.pen.description": "Kuklan ile çiz.",
    "gui.extension.videosensing.name": "Video Algılama",
    "gui.extension.videosensing.description": "Kamera ile hareketi algıla.",
    "gui.extension.text2speech.name": "Metinden Sese",
    "gui.extension.text2speech.description": "Projeni konuştur.",
    "gui.extension.translate.name": "Çeviri",
    "gui.extension.translate.description": "Metni birçok dile çevir.",
    "gui.extension.makeymakey.description": "Herşeyi dokunmatik yap.",
    "gui.extension.microbit.description": "Projelerini dünya ile paylaş.",
    "gui.extension.microbit.connectingMessage": "Bağlanıyor",
    "gui.extension.ev3.description": "Etkileşimli robotlar ve daha fazlasını oluştur.",
    "gui.extension.ev3.connectingMessage": "Bağlanıyor. EV3'teki Pinin 1234 olarak ayarlandığından emin ol.",
    "gui.extension.boost.description": "Robotik kreasyonları hayata geçirin.",
    "gui.extension.boost.connectingMessage": "Bağlanıyor",
    "gui.extension.wedo2.description": "Motorlar ve sensörler ile yap.",
    "gui.extension.wedo2.connectingMessage": "Bağlanıyor",
    "gui.extension.gdxfor.description": "İtme, çekme, hareket, ve döndürme algıla.",
    "gui.extension.gdxfor.connectingMessage": "Bağlanıyor",
    "gui.libraryTags.all": "Tümü",
    "gui.libraryTags.animals": "Hayvanlar",
    "gui.libraryTags.dance": "Dans",
    "gui.libraryTags.effects": "Etkiler",
    "gui.libraryTags.fantasy": "Fantezi",
    "gui.libraryTags.fashion": "Moda",
    "gui.libraryTags.food": "Yiyecek",
    "gui.libraryTags.indoors": "Bina içi",
    "gui.libraryTags.loops": "Döngüler",
    "gui.libraryTags.music": "Müzik",
    "gui.libraryTags.notes": "Notalar",
    "gui.libraryTags.outdoors": "Bina dışı",
    "gui.libraryTags.patterns": "Desenler",
    "gui.libraryTags.people": "İnsanlar",
    "gui.libraryTags.percussion": "Vurmalılar",
    "gui.libraryTags.space": "Uzay",
    "gui.libraryTags.sports": "Sporlar",
    "gui.libraryTags.underwater": "Su altı",
    "gui.libraryTags.voice": "Ses",
    "gui.libraryTags.wacky": "Tuhaf",
    "gui.libraryTags.animation": "Animasyon",
    "gui.libraryTags.art": "Sanat",
    "gui.libraryTags.games": "Oyunlar",
    "gui.libraryTags.stories": "Hikayeler",
    "gui.libraryTags.letters": "Harfler",
    "gui.opcodeLabels.direction": "yön",
    "gui.opcodeLabels.xposition": "x konumu",
    "gui.opcodeLabels.yposition": "y konumu",
    "gui.opcodeLabels.size": "büyüklük",
    "gui.opcodeLabels.costumename": "kostüm ismi",
    "gui.opcodeLabels.costumenumber": "kostüm numarası",
    "gui.opcodeLabels.backdropname": "dekorun adı",
    "gui.opcodeLabels.backdropnumber": "dekor numarası",
    "gui.opcodeLabels.volume": "ses düzeyi",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "cevap",
    "gui.opcodeLabels.loudness": "ses yüksekliği",
    "gui.opcodeLabels.username": "kullanıcı adı",
    "gui.opcodeLabels.year": "yıl",
    "gui.opcodeLabels.month": "ay",
    "gui.opcodeLabels.date": "tarih",
    "gui.opcodeLabels.dayofweek": "haftanın günü",
    "gui.opcodeLabels.hour": "saat",
    "gui.opcodeLabels.minute": "dakika",
    "gui.opcodeLabels.second": "saniye",
    "gui.opcodeLabels.timer": "zamanlayıcı",
    "gui.projectLoader.loadError": "Seçilen proje dosyası yüklenemedi.",
    "gui.sharedMessages.backdrop": "dekor {index}",
    "gui.sharedMessages.costume": "kostüm {index}",
    "gui.sharedMessages.sprite": "Kukla {index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Mevcut projenin üstüne yazayım mı?",
    "gui.sharedMessages.loadFromComputerTitle": "Bilgisayarından yükle",
    "gui.theme.default": "Orijinal",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "Yüksek Kontrast",
    "gui.gui.defaultProjectTitle": "Scratch Projesi",
    "boost.color.any": "herhangi bir renk",
    "boost.color.black": "siyah",
    "boost.color.blue": "mavi",
    "boost.color.green": "yeşil",
    "boost.color.red": "kırmızı",
    "boost.color.white": "beyaz",
    "boost.color.yellow": "sarı",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] motorunun konumu",
    "boost.getTiltAngle": "eğim açısı [TILT_DIRECTION]",
    "boost.motorDirection.backward": "diğer tarafa",
    "boost.motorDirection.forward": "bu tarafa",
    "boost.motorDirection.reverse": "tersine",
    "boost.motorOff": "[MOTOR_ID] numaralı motoru kapat",
    "boost.motorOn": "[MOTOR_ID] numaralı motoru aç",
    "boost.motorOnFor": "[MOTOR_ID] numaralı motoru [DURATION] saniye çalıştır",
    "boost.motorOnForRotation": "[MOTOR_ID] numaralı motoru [ROTATION] tur çalıştır",
    "boost.seeingColor": "[COLOR] parça görüyor musun?",
    "boost.setLightHue": "ışık rengini [HUE] olarak ayarla",
    "boost.setMotorDirection": "motor [MOTOR_ID] motorunun yönünü [MOTOR_DIRECTION] olarak ayarla",
    "boost.setMotorPower": "motor [MOTOR_ID] gücünü % [POWER] ayarla",
    "boost.tiltDirection.any": "herhangi",
    "boost.tiltDirection.down": "aşağı",
    "boost.tiltDirection.left": "sol",
    "boost.tiltDirection.right": "sağ",
    "boost.tiltDirection.up": "yukarı",
    "boost.whenColor": "parça, [COLOR] renginde görüldüğünde",
    "boost.whenTilted": "[TILT_DIRECTION_ANY] eğildiğinde",
    "ev3.beepNote": "[NOTE] notasını [TIME] saniye çal",
    "ev3.buttonPressed": "[PORT] düğmesi basıldı mı?",
    "ev3.getBrightness": "parlaklık",
    "ev3.getDistance": "mesafe",
    "ev3.getMotorPosition": "[PORT] motor konumu",
    "ev3.motorSetPower": "[PORT] motor gücünü % [POWER] yap",
    "ev3.motorTurnClockwise": "[PORT] motorunu > yönünde [TIME] saniye döndür",
    "ev3.motorTurnCounterClockwise": "[PORT] motorunu < yönünde [TIME] saniye döndür",
    "ev3.whenBrightnessLessThan": "parlaklık < [DISTANCE] olduğunda",
    "ev3.whenButtonPressed": "[PORT] düğmesine basıldığında",
    "ev3.whenDistanceLessThan": "mesafe < [DISTANCE] olduğunda",
    "gdxfor.getAcceleration": "ivme [DIRECTION]",
    "gdxfor.getForce": "güç",
    "gdxfor.getSpin": "devir hızı [DIRECTION]",
    "gdxfor.getTilt": "eğim açısı [TILT]",
    "gdxfor.isFreeFalling": "düşüyor mu?",
    "gdxfor.isTilted": "[TILT] eğimli mi?",
    "gdxfor.pulled": "çekilmiş",
    "gdxfor.pushed": "itilmiş",
    "gdxfor.shaken": "sallanmış",
    "gdxfor.startedFalling": "düşmeye başlamış",
    "gdxfor.tiltDirectionMenu.any": "herhangi yöne",
    "gdxfor.tiltDirectionMenu.back": "geriye",
    "gdxfor.tiltDirectionMenu.front": "öne",
    "gdxfor.tiltDirectionMenu.left": "sola",
    "gdxfor.tiltDirectionMenu.right": "sağa",
    "gdxfor.turnedFaceDown": "yüzü aşağı dönük",
    "gdxfor.turnedFaceUp": "yüzü yukarı dönük",
    "gdxfor.whenForcePushedOrPulled": "kuvvet sensörü [PUSH_PULL]",
    "gdxfor.whenGesture": "[GESTURE] olduğunda",
    "gdxfor.whenTilted": "Eğim [TILT] olduğunda",
    "makeymakey.downArrow": "aşağı ok",
    "makeymakey.downArrowShort": "aşağı",
    "makeymakey.leftArrow": "sol ok",
    "makeymakey.leftArrowShort": "sol",
    "makeymakey.rightArrow": "sağ ok",
    "makeymakey.rightArrowShort": "sağ",
    "makeymakey.spaceKey": "boşluk",
    "makeymakey.upArrow": "yukarı ok",
    "makeymakey.upArrowShort": "yukarı",
    "makeymakey.whenKeyPressed": "[KEY] tuşu basılınca",
    "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] dizisi sırayla basılınca",
    "microbit.buttonsMenu.any": "herhangi",
    "microbit.clearDisplay": "ekranı temizle",
    "microbit.defaultTextToDisplay": "Merhaba!",
    "microbit.displaySymbol": "[MATRIX]göster",
    "microbit.displayText": "[TEXT] metnini göster",
    "microbit.gesturesMenu.jumped": "atlanmış",
    "microbit.gesturesMenu.moved": "taşınmış",
    "microbit.gesturesMenu.shaken": "sallanmış",
    "microbit.isButtonPressed": "[BTN] düğmesi basıldı mı?",
    "microbit.isTilted": "[DIRECTION] eğildi mi?",
    "microbit.pinStateMenu.off": "kapalı",
    "microbit.pinStateMenu.on": "açık",
    "microbit.tiltAngle": "[DIRECTION] eğim açısı",
    "microbit.tiltDirectionMenu.any": "herhangi",
    "microbit.tiltDirectionMenu.back": "geri",
    "microbit.tiltDirectionMenu.front": "ön",
    "microbit.tiltDirectionMenu.left": "sol",
    "microbit.tiltDirectionMenu.right": "sağ",
    "microbit.whenButtonPressed": "[BTN] düğmesi basıldığında",
    "microbit.whenGesture": "[GESTURE] olduğunda",
    "microbit.whenPinConnected": "[PIN] pini bağlandığında",
    "microbit.whenTilted": "[DIRECTION] eğildiğinde",
    "music.categoryName": "Müzik",
    "music.changeTempo": "tempoyu [TEMPO] yap",
    "music.drumBass": "(2) Bas Davul",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Bagetler",
    "music.drumClosedHiHat": "(6) Kapalı Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Çan",
    "music.drumCrashCymbal": "(4) Çarpışma Zili",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Alkışla",
    "music.drumOpenHiHat": "(5) Açık Hi-Hat",
    "music.drumSideStick": "(3) yan Çubuk",
    "music.drumSnare": "(1) Trampet",
    "music.drumTambourine": "(7) Tef",
    "music.drumTriangle": "(12) Üçgen",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Fagot",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bas",
    "music.instrumentBassoon": "(14) Fagot",
    "music.instrumentCello": "(8) Çello",
    "music.instrumentChoir": "(15) Koro",
    "music.instrumentClarinet": "(10) Klarnet",
    "music.instrumentElectricGuitar": "(5) Elektro Gitar",
    "music.instrumentElectricPiano": "(2) Elektro Piyano",
    "music.instrumentFlute": "(12) Flüt",
    "music.instrumentGuitar": "(4) Gitar",
    "music.instrumentMarimba": "(19) Klisifon",
    "music.instrumentMusicBox": "(17) Müzik Kutusu",
    "music.instrumentOrgan": "(3) Org",
    "music.instrumentPiano": "(1) Piyano",
    "music.instrumentPizzicato": "(7) Parmak Hareketi",
    "music.instrumentSaxophone": "(11) Saksafon",
    "music.instrumentSteelDrum": "(18) Çelik Tambur",
    "music.instrumentSynthLead": "(20) Synth Kurşun",
    "music.instrumentSynthPad": "(21) Synth Padi",
    "music.instrumentTrombone": "(9) Trombon",
    "music.instrumentVibraphone": "(16) Vibrafon",
    "music.instrumentWoodenFlute": "(13) Tahta Flüt",
    "music.midiPlayDrumForBeats": "[DRUM] davulunu [BEATS] vuruş çal",
    "music.midiSetInstrument": "Enstrümanı [INSTRUMENT] yap",
    "music.playDrumForBeats": "[DRUM] davulunu [BEATS] vuruş çal",
    "music.playNoteForBeats": "[NOTE] notasını [BEATS] vuruşunda çal",
    "music.restForBeats": "[BEATS] vuruş durakla",
    "music.setInstrument": "Enstrümanı [INSTRUMENT] yap",
    "music.setTempo": "tempoyu [TEMPO] yap",
    "pen.categoryName": "Kalem",
    "pen.changeColorParam": "kalem [COLOR_PARAM] [VALUE] artır",
    "pen.changeHue": "kalem rengini [HUE] artır",
    "pen.changeShade": "kalem tonunu [SHADE] artır",
    "pen.changeSize": "kalem kalınlığını [SIZE] artır",
    "pen.clear": "tümünü sil",
    "pen.colorMenu.brightness": "parlaklık",
    "pen.colorMenu.color": "rengi",
    "pen.colorMenu.saturation": "doygunluk",
    "pen.colorMenu.transparency": "saydamlık",
    "pen.penDown": "kalemi bastır",
    "pen.penUp": "kalemi kaldır",
    "pen.setColor": "kalem rengini [COLOR] yap",
    "pen.setColorParam": "kalem [COLOR_PARAM] [VALUE] yap",
    "pen.setHue": "kalem rengini [HUE] yap",
    "pen.setShade": "kalem tonunu [SHADE] yap",
    "pen.setSize": "kalem kalınlığını [SIZE] yap",
    "pen.stamp": "damgala",
    "speech.defaultWhenIHearValue": "hadi başlayalım",
    "speech.extensionName": "Konuşmadan Yazıya",
    "speech.listenAndWait": "dinle ve bekle",
    "speech.speechReporter": "konuşma",
    "speech.whenIHear": "[PHRASE] ifadesini duyduğunda",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Metinden Sese",
    "text2speech.defaultTextToSpeak": "merhaba",
    "text2speech.giant": "dev",
    "text2speech.kitten": "kedi yavrusu",
    "text2speech.setLanguageBlock": "dili [LANGUAGE]'ye ayarla",
    "text2speech.setVoiceBlock": "sesi [VOICE]e ayarla",
    "text2speech.speakAndWaitBlock": "konuş [WORDS]",
    "text2speech.squeak": "ciyak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Çeviri",
    "translate.defaultTextToTranslate": "merhaba",
    "translate.translateBlock": "[WORDS] metnini [LANGUAGE] diline çevir",
    "translate.viewerLanguage": "dil",
    "videoSensing.categoryName": "Video Algılama",
    "videoSensing.direction": "yönü",
    "videoSensing.motion": "hareketi",
    "videoSensing.off": "kapat",
    "videoSensing.on": "aç",
    "videoSensing.onFlipped": "ters çevrilmiş",
    "videoSensing.setVideoTransparency": "videonun saydamlığını [TRANSPARENCY] yap",
    "videoSensing.sprite": "kuklanın",
    "videoSensing.stage": "sahnenin",
    "videoSensing.videoOn": "[SUBJECT] video [ATTRIBUTE] ",
    "videoSensing.videoToggle": "videoyu [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "video hareketi > [REFERENCE] olduğunda",
    "wedo2.getDistance": "mesafe",
    "wedo2.getTiltAngle": "[TILT_DIRECTION] eğim açısı",
    "wedo2.isTilted": "[TILT_DIRECTION_ANY] eğildi mi?",
    "wedo2.motorDirection.backward": "diğer tarafa",
    "wedo2.motorDirection.forward": "bu tarafa",
    "wedo2.motorDirection.reverse": "tersine",
    "wedo2.motorId.a": "A motoru",
    "wedo2.motorId.all": "tüm motorlar",
    "wedo2.motorId.b": "B motoru",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "[MOTOR_ID] u kapat",
    "wedo2.motorOn": "[MOTOR_ID] u aç",
    "wedo2.motorOnFor": "[MOTOR_ID] u [DURATION] saniye çalıştır",
    "wedo2.playNoteFor": "[NOTE] notasını [DURATION] saniye çal ",
    "wedo2.setLightHue": "ışık rengini [HUE] 'ye ayarla",
    "wedo2.setMotorDirection": "[MOTOR_ID] yönünü [MOTOR_DIRECTION]'a ayarla",
    "wedo2.startMotorPower": "[MOTOR_ID] gücünü [POWER]'e ayarla",
    "wedo2.tiltDirection.any": "herhangi",
    "wedo2.tiltDirection.down": "aşağı",
    "wedo2.tiltDirection.left": "sol",
    "wedo2.tiltDirection.right": "sağ",
    "wedo2.tiltDirection.up": "yukarı",
    "wedo2.whenDistance": "mesafe  [OP] [REFERENCE] olduğunda",
    "wedo2.whenTilted": "[TILT_DIRECTION_ANY] eğildiğinde",
    "paint.paintEditor.hue": "Renk",
    "paint.paintEditor.saturation": "Doygunluk",
    "paint.paintEditor.brightness": "Parlaklık",
    "paint.paintEditor.costume": "Kostüm",
    "paint.paintEditor.group": "Grup",
    "paint.paintEditor.ungroup": "Grubu Dağıt",
    "paint.paintEditor.undo": "Geri Al",
    "paint.paintEditor.redo": "İleri Al",
    "paint.paintEditor.forward": "Öne",
    "paint.paintEditor.backward": "Geriye",
    "paint.paintEditor.front": "En Öne",
    "paint.paintEditor.back": "En Geriye",
    "paint.paintEditor.more": "Daha Fazla",
    "paint.modeTools.brushSize": "Büyüklük",
    "paint.modeTools.eraserSize": "Silgi boyutu",
    "paint.modeTools.copy": "Kopyala",
    "paint.modeTools.paste": "Yapıştır",
    "paint.modeTools.delete": "Sil",
    "paint.modeTools.curved": "Kavisli",
    "paint.modeTools.pointed": "işaretlendi",
    "paint.modeTools.thickness": "Kalınlık",
    "paint.modeTools.flipHorizontal": "Yatay Çevir",
    "paint.modeTools.flipVertical": "Dikey Çevir",
    "paint.modeTools.filled": "Dolmuş",
    "paint.modeTools.outlined": "Ana Hatlarıyla Çizilen ",
    "paint.paintEditor.bitmap": "Bitmap'e Dönüştür",
    "paint.paintEditor.vector": "Vektöre Dönüştür",
    "paint.paintEditor.fill": "Doldur",
    "paint.paintEditor.stroke": "Kontur",
    "paint.brushMode.brush": "Fırça",
    "paint.eraserMode.eraser": "silgi",
    "paint.fillMode.fill": "Doldur",
    "paint.lineMode.line": "Çizgi",
    "paint.ovalMode.oval": "Çember",
    "paint.rectMode.rect": "Dikdörtgen",
    "paint.reshapeMode.reshape": "Şekli değiştir",
    "paint.roundedRectMode.roundedRect": "Yuvarlatılmış dikdörtgen",
    "paint.selectMode.select": "Seç",
    "paint.textMode.text": "Metin",
    "paint.colorPicker.swap": "Değiştir"
  },
  "uk": {
    "gui.alerts.lostPeripheralConnection": "Скретч втратив з'єднання з {extensionName}.",
    "gui.alerts.tryAgain": "Спробуйте ще раз",
    "gui.alerts.download": "Завантажити",
    "gui.connection.reconnect": "Перепід'єднання",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Сховок",
    "gui.backpack.errorBackpack": "Збій завантаження сховку",
    "gui.backpack.loadingBackpack": "Завантаження",
    "gui.backpack.more": "Більше",
    "gui.backpack.emptyBackpack": "Сховок порожній",
    "gui.unsupportedBrowser.label": "Оглядач не підтримується",
    "gui.unsupportedBrowser.errorLabel": "Виникла помилка",
    "gui.unsupportedBrowser.notRecommended": "Нам дуже шкода, але, схоже, ви використовуєте версію браузера, яку Скретч не підтримує. Рекомендується оновитися до останньої версії підтримуваного веб-переглядача, наприклад Google Chrome, Mozilla Firefox, Microsoft Edge або Apple Safari.",
    "gui.unsupportedBrowser.description": "Нам дуже шкода, але Скретч не підтримує цей браузер. Рекомендується оновитися до останньої версії підтримуваного веб-переглядача, наприклад Google Chrome, Mozilla Firefox, Microsoft Edge або Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "Щоб дізнатись більше, перейдіть на {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "Що запитують?",
    "gui.cards.all-tutorials": "Посібники",
    "gui.cards.shrink": "Зменшити",
    "gui.cards.expand": "Розгорнути",
    "gui.cards.close": "Закрити",
    "gui.cards.more-things-to-try": "Спробуй більше!",
    "gui.cards.see-more": "Дивитись ще",
    "gui.comingSoon.message1": "Не хвилюйтесь, ми над цим {emoji}",
    "gui.comingSoon.message2": "Незабаром...",
    "gui.comingSoon.message3": "Ми над цим працюємо {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Пристроїв не знайдено",
    "gui.connection.auto-scanning.prescan": "Розмістіть пристрій поблизу, а потім розпочніть пошук.",
    "gui.connection.auto-scanning.pressbutton": "Натисніть кнопку на своєму пристрої.",
    "gui.connection.auto-scanning.start-search": "Розпочати пошук",
    "gui.connection.connecting-searchbutton": "Пошук...",
    "gui.connection.auto-scanning.try-again": "Спробуйте ще раз",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "Під'єднано",
    "gui.connection.disconnect": "Роз'єднати",
    "gui.connection.go-to-editor": "До Редактора",
    "gui.connection.connecting-cancelbutton": "Під'єднання...",
    "gui.connection.error.errorMessage": "На жаль, щось пішло не так.",
    "gui.connection.error.tryagainbutton": "Спробуйте ще раз",
    "gui.connection.error.helpbutton": "Допомога",
    "gui.connection.peripheral-name-label": "Ім'я пристрою",
    "gui.connection.connect": "Під'єднати",
    "gui.connection.scanning.lookingforperipherals": "Пошук пристроїв",
    "gui.connection.scanning.noPeripheralsFound": "Пристроїв не знайдено",
    "gui.connection.scanning.instructions": "Оберіть ваш пристрій зі списку",
    "gui.connection.search": "Оновити",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "Переконайтеся, що Scratch Link встановлено та запущено",
    "gui.connection.unavailable.enablebluetooth": "Перевірте, що Bluetooth увімкнено",
    "gui.connection.unavailable.tryagainbutton": "Спробуйте ще раз",
    "gui.connection.unavailable.helpbutton": "Допомога",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "Виконати",
    "gui.controls.stop": "Зупинити",
    "gui.crashMessage.label": "Ой! Щось пішло не так.",
    "gui.crashMessage.description": "Схоже на те, що в Скретчі, на жаль, трапилась аварія. Повідомлення про цей недолік автоматично надіслано до Команди розробників Скретчу. Оновіть сторінку, щоб спробувати ще раз.",
    "gui.crashMessage.errorNumber": "Ваша помилка зареєстрована з ідентифікатором {errorId}",
    "gui.crashMessage.reload": "Перезавантажити",
    "gui.customProcedures.myblockModalTitle": "Створити блок",
    "gui.customProcedures.addAnInputNumberText": "Отримати",
    "gui.customProcedures.numberTextType": "число або текст",
    "gui.customProcedures.addAnInputBoolean": "Отримувати",
    "gui.customProcedures.booleanType": "логічне значення",
    "gui.customProcedures.addALabel": "Додати напис",
    "gui.customProcedures.runWithoutScreenRefresh": "Виконання без оновлення екрану",
    "gui.customProcedures.cancel": "Скасувати",
    "gui.customProcedures.ok": "Гаразд",
    "gui.SpriteInfo.direction": "Напрям",
    "gui.directionPicker.rotationStyles.allAround": "Навколо",
    "gui.directionPicker.rotationStyles.leftRight": "Зліва-направо",
    "gui.directionPicker.rotationStyles.dontRotate": "Не обертати",
    "gui.gui.addExtension": "Додати розширення",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Тло",
    "gui.gui.costumesTab": "Образи",
    "gui.gui.soundsTab": "Звуки",
    "gui.extensionLibrary.comingSoon": "Незабаром",
    "gui.extensionLibrary.requires": "Необхідно",
    "gui.extensionLibrary.collaboration": "Співпраця з",
    "gui.library.filterPlaceholder": "Шукати",
    "gui.library.allTag": "Усі",
    "gui.loader.message1": "Створення блоків ...",
    "gui.loader.message2": "Завантаження спрайтів...",
    "gui.loader.message3": "Завантаження звуків ...",
    "gui.loader.message4": "Завантаження розширень ...",
    "gui.loader.message5": "А ми вигулюємо котів …",
    "gui.loader.message6": "Передавання нано …",
    "gui.loader.message7": "Надування гобо …",
    "gui.loader.message8": "Готуємо емоджі ...",
    "gui.loader.headline": "Завантаження проєкту",
    "gui.loader.creating": "Створення проекту",
    "gui.accountMenu.profile": "Профіль",
    "gui.accountMenu.myStuff": "Мої проекти",
    "gui.accountMenu.myClasses": "Мої класи",
    "gui.accountMenu.myClass": "Мій клас",
    "gui.accountMenu.accountSettings": "Налаштування облікового запису",
    "gui.accountMenu.signOut": "Вийти",
    "gui.authorInfo.byUser": " {username}",
    "gui.menuBar.seeProjectPage": "Перегляд сторінки проєкту",
    "gui.menuBar.language": "Language",
    "general.username": "Ім'я користувача",
    "general.password": "Пароль",
    "general.signIn": "Увійти",
    "login.needHelp": "Потрібна допомога?",
    "form.validationRequired": "Це поле обов'язкове для заповнення",
    "gui.menuBar.tutorialsLibrary": "Посібники",
    "gui.menuBar.restoreSprite": "Відновити спрайт",
    "gui.menuBar.restoreSound": "Відновити звук",
    "gui.menuBar.restoreCostume": "Відновити образ",
    "gui.menuBar.restore": "Відновити",
    "gui.menuBar.saveNow": "Зберегти негайно",
    "gui.menuBar.saveAsCopy": "Зберегти як копію",
    "gui.menuBar.remix": "Ремікс",
    "gui.menuBar.new": "Новий",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Вивантажити на ваш комп’ютер",
    "gui.menuBar.edit": "Правка",
    "gui.menuBar.turboModeOff": "Вимкнути турбо-режим",
    "gui.menuBar.turboModeOn": "Ввімкнути турбо-режим",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "Приєднатись",
    "gui.menuBar.signIn": "Увійти",
    "gui.gui.projectTitlePlaceholder": "Тут назва проєкту",
    "gui.menuBar.saveNowLink": "Зберегти негайно",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "Опубліковане",
    "gui.menuBar.share": "Поділитись",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "Допомога",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(порожньо)",
    "gui.monitor.listMonitor.listLength": "всього {length}",
    "gui.monitor.contextMenu.default": "з назвою",
    "gui.monitor.contextMenu.large": "тільки дані",
    "gui.monitor.contextMenu.slider": "слайдер",
    "gui.monitor.contextMenu.sliderRange": "змінити діапазон слайдера",
    "gui.monitor.contextMenu.import": "імпорт",
    "gui.monitor.contextMenu.export": "експорт",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "Відтворити",
    "gui.playButton.stop": "Зупинити",
    "gui.gui.variableScopeOptionAllSprites": "Для усіх спрайтів",
    "gui.gui.variableScopeOptionSpriteOnly": "Тільки для цього спрайту",
    "gui.gui.cloudVariableOption": "\"Хмарна\" змінна (зберігається на сервері)",
    "gui.gui.variablePromptAllSpritesMessage": "Ця змінна буде доступна для всіх спрайтів.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Скасувати",
    "gui.prompt.ok": "Гаразд",
    "gui.playbackStep.stopMsg": "Зупинити",
    "gui.playbackStep.playMsg": "Відтворити",
    "gui.playbackStep.loadingMsg": "Завантаження",
    "gui.playbackStep.saveMsg": "Зберегти",
    "gui.playbackStep.reRecordMsg": "Перезаписати",
    "gui.recordModal.title": "Запис звуку",
    "gui.recordingStep.beginRecord": "Почніть запис, натиснувши кнопку нижче",
    "gui.recordingStep.permission": "{arrow}Нам потрібен ваш дозвіл на використання мікрофону",
    "gui.recordingStep.stop": "Зупинити запис",
    "gui.recordingStep.record": "Записати",
    "gui.sliderModal.min": "Найменше значення",
    "gui.sliderModal.max": "Найбільше значення",
    "gui.sliderModal.title": "Змінити діапазон слайдера",
    "gui.sliderPrompt.cancel": "Скасувати",
    "gui.sliderPrompt.ok": "Гаразд",
    "gui.soundEditor.sound": "Звук",
    "gui.soundEditor.play": "Відтворити",
    "gui.soundEditor.stop": "Зупинити",
    "gui.soundEditor.copy": "Копія",
    "gui.soundEditor.paste": "Вставити",
    "gui.soundEditor.copyToNew": "Копіювати до нового",
    "gui.soundEditor.delete": "Вилучити",
    "gui.soundEditor.save": "Зберегти",
    "gui.soundEditor.undo": "Скасувати",
    "gui.soundEditor.redo": "Повернути",
    "gui.soundEditor.faster": "Швидше",
    "gui.soundEditor.slower": "Повільніше",
    "gui.soundEditor.echo": "Відлуння",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "Голосніше",
    "gui.soundEditor.softer": "Тихіше",
    "gui.soundEditor.reverse": "Обернути",
    "gui.soundEditor.fadeOut": "Затухання",
    "gui.soundEditor.fadeIn": "Посилення",
    "gui.soundEditor.mute": "Заглушити",
    "gui.SpriteInfo.spritePlaceholder": "Назва",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Показати",
    "gui.SpriteInfo.size": "Розмір",
    "gui.spriteSelectorItem.contextMenuDuplicate": "дублювати",
    "gui.spriteSelectorItem.contextMenuExport": "експорт",
    "gui.spriteSelectorItem.contextMenuDelete": "вилучити",
    "gui.spriteSelector.addSpriteFromLibrary": "Обрати спрайт",
    "gui.spriteSelector.addSpriteFromPaint": "Малювати",
    "gui.spriteSelector.addSpriteFromSurprise": "Сюрприз",
    "gui.spriteSelector.addSpriteFromFile": "Вивантажити спрайт",
    "gui.stageHeader.stageSizeLarge": "Перемкнути на велику сцену",
    "gui.stageHeader.stageSizeSmall": "Перемкнути на малу сцену",
    "gui.stageHeader.stageSizeFull": "Увімкнути повноекранний режим",
    "gui.stageHeader.stageSizeUnFull": "Вийти з повноекранного режиму",
    "gui.stageHeader.fullscreenControl": "Повноекранний режим",
    "gui.spriteSelector.addBackdropFromLibrary": "Обрати тло",
    "gui.stageSelector.addBackdropFromPaint": "Намалювати",
    "gui.stageSelector.addBackdropFromSurprise": "Сюрприз",
    "gui.stageSelector.addBackdropFromFile": "Вивантажити тло",
    "gui.stageSelector.stage": "Сцена",
    "gui.stageSelector.backdrops": "Тло",
    "gui.telemetryOptIn.label": "Надсилайте статистику, щоб покращити Скретч",
    "gui.telemetryOptIn.body1": "Розробники з Scratch Team завжди прагнуть краще зрозуміти, як Скретч використовується у всьому світі. Щоб допомогти підтримати ці зусилля, ви можете дозволити автоматично надсилати інформацію про використання в Scratch Team.",
    "gui.telemetryOptIn.body2": "Інформація, яку ми збираємо, включає вибір мови, використання блоків та деякі події, такі як збереження, завантаження та вивантаження проєкту. Ми не збираємо особисту інформацію. Будь ласка, перегляньте {privacyPolicyLink} для отримання додаткової інформації.",
    "gui.telemetryOptIn.privacyPolicyLink": "Політика конфіденційності",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Режим турбо",
    "gui.webglModal.label": "Ваш оглядач не підтримує WebGL",
    "gui.webglModal.description": "На жаль, ваш оглядач або комп'ютер {webGlLink}. Ця технологія потрібна для запуску Scratch 3.0.",
    "gui.webglModal.webgllink": "не підтримує WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "Щоб дізнатись більше, перейдіть на {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "Що запитують?",
    "gui.costumeLibrary.chooseABackdrop": "Оберіть тло",
    "gui.costumeLibrary.chooseACostume": "Обрати образ",
    "gui.costumeTab.addBackdropFromLibrary": "Обрати тло",
    "gui.costumeTab.addCostumeFromLibrary": "Обрати образ",
    "gui.costumeTab.addBlankCostume": "Малювати",
    "gui.costumeTab.addSurpriseCostume": "Сюрприз",
    "gui.costumeTab.addFileBackdrop": "Вивантажити тло",
    "gui.costumeTab.addFileCostume": "Вивантажити образ",
    "gui.extensionLibrary.chooseAnExtension": "Оберіть розширення",
    "gui.extensionLibrary.extensionUrl": "Введи URL розширення",
    "gui.monitors.importListColumnPrompt": "Який стовпчик використовувати (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Не вдалось розпочати запис",
    "gui.soundLibrary.chooseASound": "Оберіть звук",
    "gui.soundTab.fileUploadSound": "Вивантажити звук",
    "gui.soundTab.surpriseSound": "Сюрприз",
    "gui.soundTab.recordSound": "Записати",
    "gui.soundTab.addSoundFromLibrary": "Обрати звук",
    "gui.spriteLibrary.chooseASprite": "Оберіть спрайт",
    "gui.tipsLibrary.tutorials": "Обрати посібник",
    "gui.alerts.createsuccess": "Новий проєкт створено.",
    "gui.alerts.createcopysuccess": "Проєкт збережено як копію.",
    "gui.alerts.createremixsuccess": "Проєкт збережено як ремікс.",
    "gui.alerts.creating": "Створення нового...",
    "gui.alerts.creatingCopy": "Копіювання проєкту...",
    "gui.alerts.creatingRemix": "Реміксування проєкту...",
    "gui.alerts.creatingError": "Не вдалося створити проєкт. Будь ласка спробуйте ще раз!",
    "gui.alerts.savingError": "Проєкт не збережено.",
    "gui.alerts.savesuccess": "Проєкт збережено.",
    "gui.alerts.saving": "Збереження проєкту...",
    "gui.alerts.cloudInfo": "Пам'ятайте, що хмарні змінні можуть містити лише числа, але не літери чи символи. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Дізнатись більше.",
    "gui.alerts.importing": "Імпортування...",
    "gui.defaultProject.meow": "Няв",
    "gui.defaultProject.variable": "моя змінна",
    "gui.howtos.intro-move-sayhello-hat.name": "Розпочати",
    "gui.howtos.intro-move.step_stepMove": "Додати блок руху",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Анімувати ім'я",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Оберіть літеру-спрайт",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Відтворити звук по натиску",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Оберіть іншу літеру-спрайт",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Зміна кольору",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Оберіть спрайти для літер та обертайте їх",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Оберіть спрайти для літер та збільшіть їх",
    "gui.howtos.imagine": "Уявити світ",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Напишіть що ви хочете сказати",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Натисніть зелений прапорець щоб почати",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Виберіть тло",
    "gui.howtos.imagine.step_imagineChooseSprite": "Виберіть спрайт",
    "gui.howtos.imagine.step_imagineFlyAround": "Натисніть пробіл щоб ковзати",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Виберіть інший спрайт",
    "gui.howtos.imagine.step_imagineLeftRight": "Рухайтесь Вліво-Вправо",
    "gui.howtos.imagine.step_imagineUpDown": "Рухайтесь Вверх-Вниз",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Змініть костюм",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Ковзайте до точки",
    "gui.howtos.imagine.step_imagineGrowShrink": "Збільшити та зменшити",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Виберіть інше тло",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Змінити тло",
    "gui.howtos.imagine.step_imagineRecordASound": "Додайте звук",
    "gui.howtos.imagine.step_imagineChooseSound": "Виберіть ваш звук",
    "gui.howtos.make-music.name": "Створити музику",
    "gui.howtos.Make-Music.step_PickInstrument": "Обрати інструмент спрайту",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Відтворити звук по натиску",
    "gui.howtos.Make-Music.step_MakeSong": "Створити пісню",
    "gui.howtos.make-music.step_MakeBeat": "Оберіть барабан і зробіть удар",
    "gui.howtos.make-music.step_MakeBeatBox": "Обрати мікрофон для спрайту та створити бітбокс",
    "gui.howtos.story.name": "Створити історію",
    "gui.howtos.story.step_addbg": "Додати тло",
    "gui.howtos.story.step_addsprite": "Додати персонаж",
    "gui.howtos.story.step_saysomething": "Сказати щось",
    "gui.howtos.story.step_addanothersprite": "Додати інший персонаж",
    "gui.howtos.story.step_flip": "Обернути напрям",
    "gui.howtos.story.step_conversation": "Розмовляти",
    "gui.howtos.story.addanotherbg": "Додати інший персонаж",
    "gui.howtos.story.step_swithbg": "Змінити тло",
    "gui.howtos.story.step_hidewizard": "Сховати персонаж",
    "gui.howtos.story.step_showwizard": "Показати персонаж",
    "gui.howtos.make-a-chase-game.name": "Зробіть ігри-переслідування",
    "gui.howtos.Chase-Game.step_BG": "Додати тло",
    "gui.howtos.chase-game.step_AddOcto": "Додайте спрайт",
    "gui.howtos.make-music.step_LeftRight": "Рух праворуч-ліворуч клавішами зі стрілками",
    "gui.howtos.Chase-Game.step_UpDown": "Рух вгору-вниз клавішами зі стрілками",
    "gui.howtos.Chase-Game.step_AddStar": "Додати ще один спрайт",
    "gui.howtos.Chase-Game.step_MoveRandom": "Випадковий рух",
    "gui.howtos.Chase-Game.step_WhenTouch": "Спрайт \"Восьминіг\" відтворює звуки при торканні",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Створити змінну-лічильник",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "Для спрайта Восьминіг торкання збільшує рахунок",
    "gui.howtos.animate-char.name": "Анімувати персонаж",
    "gui.howtos.animate-char.step_addbg": "Додати тло",
    "gui.howtos.animate-char.step_addsprite": "Додати спрайт",
    "gui.howtos.animate-char.step_saysomething": "Сказати щось",
    "gui.howtos.animate-char.step_addsound": "Додати звук",
    "gui.howtos.animate-char.step_animatetalking": "Анімувати розмову",
    "gui.howtos.animate-char.step_arrowkeys": "Рухати клавішами-стрілками",
    "gui.howtos.animate-char.step_jump": "Стрибати",
    "gui.howtos.animate-char.step_changecolor": "Змінити колір",
    "gui.howtos.make-a-game.name": "Зробіть ігри-натискання",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Обрати спрайт",
    "gui.howtos.make-a-game.step_GamePlaySound": "Відтворити звук по натиску",
    "gui.howtos.make-a-game.step_GameAddScore": "Створити змінну-лічильник",
    "gui.howtos.make-a-game.step_GameChangeScore": "При натисканні збільшити рахунок",
    "gui.howtos.make-a-game.step_Random": "Перейти у випадкову позиціцю",
    "gui.howtos.make-music.step_GameChangeColor": "Змінити колір",
    "gui.howtos.make-music.step_ResetScore": "Скинути рахунок",
    "gui.howtos.make-it-fly.name": "Примусьте його літати",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Виберіть фон неба",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Обери персонажа",
    "gui.howtos.fly.step_stepflySaySomething": "Сказати щось",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Рухайтесь за допомогою клавіш",
    "gui.howtos.fly.step_stepflyChooseObject": "Виберіть об'єкт для збирання",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Примусьте об'єкт літати",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Оберіть вашого персонажа",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Додати рахунок",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Зберегти рахунок",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Додати декорації",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Перемістіть декорації",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Наступний образ",
    "gui.howtos.pong": "Створи гру",
    "gui.howtos.pong.step_pongAddBackdrop": "Додати тло",
    "gui.howtos.pong.step_pongAddBallSprite": "Додайте м'яч",
    "gui.howtos.pong.step_pongBounceAround": "Відбиватись навколо",
    "gui.howtos.pong.step_pongAddPaddle": "Додайте весло",
    "gui.howtos.pong.step_pongMoveThePaddle": "Перемістіть весло",
    "gui.howtos.pong.step_pongSelectBallSprite": "Оберіть м'яч",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Додайте код щоб м'яч відбивався від весла",
    "gui.howtos.pong.step_pongAddAScore": "Додайте рахунок",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Оберіть 'Рахунок' з меню",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Вставте блок 'Змінити рахунок'",
    "gui.howtos.pong.step_pongResetScore": "Скинути рахунок",
    "gui.howtos.pong.step_pongAddLineSprite": "Додайте лінію",
    "gui.howtos.pong.step_pongGameOver": "Кінець гри",
    "gui.howtos.code-cartoon": "Кодувати мультик",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Сказати щось, коли натиснуто зелений прапор",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Анімувати персонажа якщо його тицьнули",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Обрати іншого персонажа",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Використати знак мінусу, щоб отримати менший розмір",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Зробити персонажа більшим або меншим",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Обрати іншого персонажа",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Стрибати вгору-вниз",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Тицьнути персонажа щоб змінити сцену",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Ковзати навколо",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Змініть костюм",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Додати інші персонажі для свого мультика",
    "gui.howtos.cartoon-network": "Анімація у пригодницькій грі",
    "gui.howtos.cartoon-network.step_CNcharacter": "Обрати персонаж для показу",
    "gui.howtos.cartoon-network.step_CNsay": "Скажи щось",
    "gui.howtos.cartoon-network.step_CNglide": "Ковзати навколо",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Обрати об'єкт для переслідування",
    "gui.howtos.cartoon-network.step_CNcollect": "Збирання об'єктів",
    "gui.howtos.cartoon-network.step_CNvariable": "Створити змінну-лічильник",
    "gui.howtos.cartoon-network.step_CNscore": "Зберегти рахунок",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Поглиблений рівень: Змінити тло",
    "gui.howtos.videosens.name": "Відеосенсор",
    "gui.howtos.videosens.step_addextension": "Додати розширення",
    "gui.howtos.videosens.step_pet": "Котик",
    "gui.howtos.videosens.step_animate": "Анімувати",
    "gui.howtos.videosens.step_pop": "Лопнути кульку",
    "gui.howtos.say-it-out-loud": "Створити анімації, що говорять",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Додати блоки \"Текст у мову\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Сказати щось",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Встановити голос",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Рухатись навколо",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Додати тло",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Додати інший персонаж",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Виконати пісню",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Змінити колір",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Обертатися навколо",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Збільшити та зменшити",
    "gui.howtos.talking": "Розповісти казки",
    "gui.howtos.talking.step_talesAddExtension": "Тицьнути, щоб додати блоки \"Текст у мову\"",
    "gui.howtos.talking.step_talesChooseSprite": "Обрати спрайт",
    "gui.howtos.talking.step_talesSaySomething": "Зробити, щоб персонаж говорив",
    "gui.howtos.talking.step_talesChooseBackdrop": "Обрати тло",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Тицьнути персонажа щоб змінити тло на наступне",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Виберіть інший спрайт",
    "gui.howtos.talking.step_talesMoveAround": "Рухатись навколо",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Виберіть інше тло",
    "gui.howtos.talking.step_talesAnimateTalking": "Анімувати розмову",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Виберіть інше тло",
    "gui.howtos.talking.step_talesChooseSound": "Обрати пісню для танцю",
    "gui.howtos.talking.step_talesDanceMoves": "Рухи танцю",
    "gui.howtos.talking.step_talesAskAnswer": "Отримати блоки запитань та відповідей із категорії \"Датчики\"",
    "gui.howtos.add-sprite.name": "Додайте спрайт",
    "gui.howtos.add-sprite.step_addSprite": "Додайте спрайт",
    "gui.howtos.add-a-backdrop.name": "Додати тло",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Додати тло",
    "gui.howtos.change-size.name": "Змінити розмір",
    "gui.howtos.change-size.step_changeSize": "Змінити розмір",
    "gui.howtos.glide-around.name": "Ковзати навколо",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Ковзати навколо",
    "gui.howtos.change-size.step_glideAroundPoint": "Ковзайте до точки",
    "gui.howtos.record-a-sound.name": "Запис звуку",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Натисніть на вкладку 'Звук'",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Натисніть 'Запис'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Натисніть кнопку запису",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Виберіть ваш звук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Відтворіть ваш звук",
    "gui.howtos.spin-video.name": "Змусити обертатись",
    "gui.howtos.change-size.step_spinTurn": "Поверніть",
    "gui.howtos.change-size.step_spinPointInDirection": "Оберіть напрям",
    "gui.howtos.hide-and-show.name": "Сховати й показати",
    "gui.howtos.change-size.step_hideAndShow": "Сховати й показати",
    "gui.howtos.switch-costume.name": "Анімувати спрайт",
    "gui.howtos.change-size.step_switchCostumes": "Анімувати спрайт",
    "gui.howtos.move-around-with-arrow-keys.name": "Використання клавіш-стрілок",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Рухайтесь вправо і вліво",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Рухайтесь вверх і вниз",
    "gui.howtos.add-effects.name": "Додати ефекти",
    "gui.howtos.videosens.step_addEffects": "Додати ефекти",
    "gui.extension.music.name": "Музика",
    "gui.extension.music.description": "Грати на інструментах та барабанах.",
    "gui.extension.pen.name": "Олівець",
    "gui.extension.pen.description": "Малювати за допомогою спрайтів.",
    "gui.extension.videosensing.name": "Відеоспостереження",
    "gui.extension.videosensing.description": "Визначити рух за допомогою камери.",
    "gui.extension.text2speech.name": "Текст у мову",
    "gui.extension.text2speech.description": "Розмови в ваших проєктах",
    "gui.extension.translate.name": "Перекласти",
    "gui.extension.translate.description": "Переклад тексту на різні мови.",
    "gui.extension.makeymakey.description": "Зробити щось через клавіші-контакти",
    "gui.extension.microbit.description": "Під'єднати ваші проєкти до навколишнього світу",
    "gui.extension.microbit.connectingMessage": "Під'єднання",
    "gui.extension.ev3.description": "Створити інтерактивних роботів і більше.",
    "gui.extension.ev3.connectingMessage": "Під'єднання. Переконайтеся, що пін на вашому EV3 встановлено на 1234.",
    "gui.extension.boost.description": "Доведіть робототехнічні творіння до життя.",
    "gui.extension.boost.connectingMessage": "З'єднання",
    "gui.extension.wedo2.description": "Працюємо з двигунами та сенсорами",
    "gui.extension.wedo2.connectingMessage": "Під'єднання",
    "gui.extension.gdxfor.description": "Датчики поштовху, тяги, руху і обертання.",
    "gui.extension.gdxfor.connectingMessage": "З'єднання",
    "gui.libraryTags.all": "Усі",
    "gui.libraryTags.animals": "Тварини",
    "gui.libraryTags.dance": "Танцювальна музика",
    "gui.libraryTags.effects": "Ефекти",
    "gui.libraryTags.fantasy": "Фантазії",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Їжа",
    "gui.libraryTags.indoors": "У приміщенні",
    "gui.libraryTags.loops": "Фрагменти",
    "gui.libraryTags.music": "Музика",
    "gui.libraryTags.notes": "Примітки",
    "gui.libraryTags.outdoors": "Поза приміщенням",
    "gui.libraryTags.patterns": "Візерунки",
    "gui.libraryTags.people": "Люди",
    "gui.libraryTags.percussion": "Перкусія",
    "gui.libraryTags.space": "Космос",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Під водою",
    "gui.libraryTags.voice": "Голос",
    "gui.libraryTags.wacky": "Дивне",
    "gui.libraryTags.animation": "Анімації",
    "gui.libraryTags.art": "Арт",
    "gui.libraryTags.games": "Ігри",
    "gui.libraryTags.stories": "Історії",
    "gui.libraryTags.letters": "Літери",
    "gui.opcodeLabels.direction": "напрям",
    "gui.opcodeLabels.xposition": "значення x",
    "gui.opcodeLabels.yposition": "значення y",
    "gui.opcodeLabels.size": "розмір",
    "gui.opcodeLabels.costumename": "ім’я образу",
    "gui.opcodeLabels.costumenumber": "образ #",
    "gui.opcodeLabels.backdropname": "ім’я тла",
    "gui.opcodeLabels.backdropnumber": "тло #",
    "gui.opcodeLabels.volume": "гучність",
    "gui.opcodeLabels.tempo": "темп",
    "gui.opcodeLabels.answer": "відповідь",
    "gui.opcodeLabels.loudness": "гучність",
    "gui.opcodeLabels.username": "користувач",
    "gui.opcodeLabels.year": "рік",
    "gui.opcodeLabels.month": "місяць",
    "gui.opcodeLabels.date": "дата",
    "gui.opcodeLabels.dayofweek": "день тижня",
    "gui.opcodeLabels.hour": "година",
    "gui.opcodeLabels.minute": "хвилина ",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Не вдалося завантажити обраний файл проєкту.",
    "gui.sharedMessages.backdrop": "тло{index}",
    "gui.sharedMessages.costume": "образ{index}",
    "gui.sharedMessages.sprite": "Спрайт{index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Замінити вміст поточного проєкту?",
    "gui.sharedMessages.loadFromComputerTitle": "Завантажити з вашого комп’ютера",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Скретч-проєкт",
    "boost.color.any": "будь-який колір",
    "boost.color.black": "чорний",
    "boost.color.blue": "синій",
    "boost.color.green": "зелений",
    "boost.color.red": "червоний",
    "boost.color.white": "білий",
    "boost.color.yellow": "жовтий",
    "boost.getMotorPosition": "позиція [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "кут нахилу [TILT_DIRECTION]",
    "boost.motorDirection.backward": "за годинником",
    "boost.motorDirection.forward": "проти годинника",
    "boost.motorDirection.reverse": "обернути",
    "boost.motorOff": "вимкнути [MOTOR_ID]",
    "boost.motorOn": "увімкнути [MOTOR_ID]",
    "boost.motorOnFor": "увімкнути [MOTOR_ID] на [DURATION] секунд",
    "boost.motorOnForRotation": "увімкнути [MOTOR_ID] на [ROTATION] оборотів",
    "boost.seeingColor": "бачить кубик кольору [COLOR] ?",
    "boost.setLightHue": "встановити колір світла в [HUE]",
    "boost.setMotorDirection": "встановити [MOTOR_ID] напрям [MOTOR_DIRECTION]",
    "boost.setMotorPower": "встановити [MOTOR_ID] швидкість в [POWER] %",
    "boost.tiltDirection.any": "будь-який",
    "boost.tiltDirection.down": "вниз",
    "boost.tiltDirection.left": "ліворуч",
    "boost.tiltDirection.right": "праворуч",
    "boost.tiltDirection.up": "вгору",
    "boost.whenColor": "якщо бачить кубик кольору [COLOR] то",
    "boost.whenTilted": "коли нахил [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "пищати [NOTE] [TIME] секунд",
    "ev3.buttonPressed": "кнопку [PORT] натиснуто?",
    "ev3.getBrightness": "яскравість",
    "ev3.getDistance": "відстань",
    "ev3.getMotorPosition": "позиція двигуна [PORT]",
    "ev3.motorSetPower": "встановити потужність [PORT] в [POWER] %",
    "ev3.motorTurnClockwise": "увімкнути двигун [PORT] у такому напрямі на [TIME] секунд",
    "ev3.motorTurnCounterClockwise": "увімкнути двигун [PORT] у  зворотньому напрямі на [TIME] секунд",
    "ev3.whenBrightnessLessThan": "якщо яскравість < [DISTANCE]",
    "ev3.whenButtonPressed": "якщо кнопку [PORT] натиснуто",
    "ev3.whenDistanceLessThan": "якщо дистанція < [DISTANCE]",
    "gdxfor.getAcceleration": "прискорення [DIRECTION]",
    "gdxfor.getForce": "сила",
    "gdxfor.getSpin": "швидкість обертання [DIRECTION]",
    "gdxfor.getTilt": "кут нахилу [TILT]",
    "gdxfor.isFreeFalling": "падає?",
    "gdxfor.isTilted": "нахил [TILT]?",
    "gdxfor.pulled": "виштовхнуто",
    "gdxfor.pushed": "заштовхнуто",
    "gdxfor.shaken": "струснуто",
    "gdxfor.startedFalling": "початок падіння",
    "gdxfor.tiltDirectionMenu.any": "будь-який",
    "gdxfor.tiltDirectionMenu.back": "назад",
    "gdxfor.tiltDirectionMenu.front": "вперед",
    "gdxfor.tiltDirectionMenu.left": "ліворуч",
    "gdxfor.tiltDirectionMenu.right": "праворуч",
    "gdxfor.turnedFaceDown": "лицем донизу",
    "gdxfor.turnedFaceUp": "лицем вверх",
    "gdxfor.whenForcePushedOrPulled": "поки сенсор сили [PUSH_PULL]",
    "gdxfor.whenGesture": "коли [GESTURE]",
    "gdxfor.whenTilted": "коли нахилено [TILT]",
    "makeymakey.downArrow": "стрілка вниз",
    "makeymakey.downArrowShort": "вниз",
    "makeymakey.leftArrow": "стрілка ліворуч",
    "makeymakey.leftArrowShort": "ліворуч",
    "makeymakey.rightArrow": "стрілка праворуч",
    "makeymakey.rightArrowShort": "праворуч",
    "makeymakey.spaceKey": "пропуск",
    "makeymakey.upArrow": "стрілка вгору",
    "makeymakey.upArrowShort": "вгору",
    "makeymakey.whenKeyPressed": "поки клавішу [KEY] натиснуто",
    "makeymakey.whenKeysPressedInOrder": "поки натиснуто по порядку [SEQUENCE]",
    "microbit.buttonsMenu.any": "будь-який",
    "microbit.clearDisplay": "очистити дисплей",
    "microbit.defaultTextToDisplay": "Привіт!",
    "microbit.displaySymbol": "показати [MATRIX]",
    "microbit.displayText": "показати текст [TEXT]",
    "microbit.gesturesMenu.jumped": "підкинуто",
    "microbit.gesturesMenu.moved": "рухається",
    "microbit.gesturesMenu.shaken": "струснуто",
    "microbit.isButtonPressed": "кнопку [BTN] натиснуто?",
    "microbit.isTilted": "нахил [DIRECTION]?",
    "microbit.pinStateMenu.off": "Вимк",
    "microbit.pinStateMenu.on": "Увімкн",
    "microbit.tiltAngle": "кут нахилу [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "будь-який",
    "microbit.tiltDirectionMenu.back": "назад",
    "microbit.tiltDirectionMenu.front": "вперед",
    "microbit.tiltDirectionMenu.left": "ліворуч",
    "microbit.tiltDirectionMenu.right": "праворуч",
    "microbit.whenButtonPressed": "коли кнопку [BTN] натиснуто",
    "microbit.whenGesture": "коли [GESTURE]",
    "microbit.whenPinConnected": "коли контакт [PIN] приєднано",
    "microbit.whenTilted": "коли нахил [DIRECTION]",
    "music.categoryName": "Музика",
    "music.changeTempo": "змінити темп на [TEMPO]",
    "music.drumBass": "(2) Великий басовий барабан",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клавесин",
    "music.drumClosedHiHat": "(6) Закритий хет",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Дзвіночок",
    "music.drumCrashCymbal": "(4) Удар тарілок",
    "music.drumCuica": "(18) Куїка",
    "music.drumGuiro": "(16) Гуїро",
    "music.drumHandClap": "(8) Плескіт долонь",
    "music.drumOpenHiHat": "(5) Відкритий високий хет",
    "music.drumSideStick": "(3) Удар по ободу",
    "music.drumSnare": "(1) Малий барабан",
    "music.drumTambourine": "(7) Тамбурин",
    "music.drumTriangle": "(12) Трикутник",
    "music.drumVibraslap": "(17) Вібруючий слеп",
    "music.drumWoodBlock": "(10) Дерев’яна коробка",
    "music.getTempo": "темп",
    "music.instrumentBass": "(6) Бас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Віолончель",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларнет",
    "music.instrumentElectricGuitar": "(5) Електрогітара",
    "music.instrumentElectricPiano": "(2) Електропіаніно",
    "music.instrumentFlute": "(12) Флейта",
    "music.instrumentGuitar": "(4) Гітара",
    "music.instrumentMarimba": "(19) Марімба",
    "music.instrumentMusicBox": "(17) Музична скринька",
    "music.instrumentOrgan": "(3) Орган",
    "music.instrumentPiano": "(1) Піаніно",
    "music.instrumentPizzicato": "(7) Піцикато",
    "music.instrumentSaxophone": "(11) Саксофон",
    "music.instrumentSteelDrum": "(18) Стальний барабан",
    "music.instrumentSynthLead": "(20) Ведучий синтезатор",
    "music.instrumentSynthPad": "(21) Синтезатор Pad",
    "music.instrumentTrombone": "(9) Тромбон",
    "music.instrumentVibraphone": "(16) Вібрафон",
    "music.instrumentWoodenFlute": "(13) Дерев’яна флейта",
    "music.midiPlayDrumForBeats": "програти на барабані [DRUM] [BEATS] ударів",
    "music.midiSetInstrument": "грати інструментом [INSTRUMENT]",
    "music.playDrumForBeats": "програти на барабані [DRUM] [BEATS] ударів",
    "music.playNoteForBeats": "програти ноту [NOTE] [BEATS] тактів",
    "music.restForBeats": "пауза [BEATS] тактів",
    "music.setInstrument": "грати інструментом [INSTRUMENT]",
    "music.setTempo": "встановити темп в [TEMPO]",
    "pen.categoryName": "Олівець",
    "pen.changeColorParam": "змінити [COLOR_PARAM] олівця на [VALUE]",
    "pen.changeHue": "змінити колір олівця на [HUE]",
    "pen.changeShade": "змінити тінь олівця на [SHADE]",
    "pen.changeSize": "змінити розмір олівця на [SIZE]",
    "pen.clear": "очистити все",
    "pen.colorMenu.brightness": "яскравість",
    "pen.colorMenu.color": "колір",
    "pen.colorMenu.saturation": "насиченість",
    "pen.colorMenu.transparency": "прозорість",
    "pen.penDown": "опустити олівець",
    "pen.penUp": "підняти олівець",
    "pen.setColor": "надати олівцю колір [COLOR]",
    "pen.setColorParam": "надати [COLOR_PARAM] олівця значення [VALUE]",
    "pen.setHue": "задати колір олівця [HUE]",
    "pen.setShade": "задати тінь олівця [SHADE]",
    "pen.setSize": "задати розмір олівця [SIZE]",
    "pen.stamp": "штамп",
    "speech.defaultWhenIHearValue": "вперед",
    "speech.extensionName": "Проказати текст",
    "speech.listenAndWait": "слухати і чекати",
    "speech.speechReporter": "мовлення",
    "speech.whenIHear": "коли я чую [PHRASE]",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "Текст-у-Мову",
    "text2speech.defaultTextToSpeak": "привіт",
    "text2speech.giant": "гігант",
    "text2speech.kitten": "котик",
    "text2speech.setLanguageBlock": "встановити мову [LANGUAGE]",
    "text2speech.setVoiceBlock": "встановити голос як [VOICE]",
    "text2speech.speakAndWaitBlock": "говорити [WORDS]",
    "text2speech.squeak": "писк",
    "text2speech.tenor": "тенор",
    "translate.categoryName": "Перекласти",
    "translate.defaultTextToTranslate": "привіт",
    "translate.translateBlock": "перекласти [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "мова",
    "videoSensing.categoryName": "Відеоспостереження",
    "videoSensing.direction": "напрям",
    "videoSensing.motion": "рух",
    "videoSensing.off": "Вимк",
    "videoSensing.on": "Увімкн",
    "videoSensing.onFlipped": "перевернуто",
    "videoSensing.setVideoTransparency": "встановити прозорість відео в [TRANSPARENCY]",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "сцена",
    "videoSensing.videoOn": "відео [ATTRIBUTE] на [SUBJECT]",
    "videoSensing.videoToggle": "перемкнути відео [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "коли рух відео > [REFERENCE]",
    "wedo2.getDistance": "відстань",
    "wedo2.getTiltAngle": "кут нахилу [TILT_DIRECTION]",
    "wedo2.isTilted": "нахилено [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "за годинником",
    "wedo2.motorDirection.forward": "проти годинника",
    "wedo2.motorDirection.reverse": "обернути",
    "wedo2.motorId.a": "двигун A",
    "wedo2.motorId.all": "всі двигуни",
    "wedo2.motorId.b": "двигун B",
    "wedo2.motorId.default": "двигун",
    "wedo2.motorOff": "[MOTOR_ID] вимкнути",
    "wedo2.motorOn": "[MOTOR_ID] увімкнути",
    "wedo2.motorOnFor": "увімкнути [MOTOR_ID] на [DURATION] секунд",
    "wedo2.playNoteFor": "грати ноту [NOTE] [DURATION] секунд",
    "wedo2.setLightHue": "встановити колір світла в [HUE]",
    "wedo2.setMotorDirection": "встановити напрям [MOTOR_ID] [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "встановити потужність [MOTOR_ID] [POWER]",
    "wedo2.tiltDirection.any": "будь-який",
    "wedo2.tiltDirection.down": "вниз",
    "wedo2.tiltDirection.left": "ліворуч",
    "wedo2.tiltDirection.right": "праворуч",
    "wedo2.tiltDirection.up": "вгору",
    "wedo2.whenDistance": "коли дистанція [OP] [REFERENCE]",
    "wedo2.whenTilted": "коли нахил [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "Колір",
    "paint.paintEditor.saturation": "Насиченість",
    "paint.paintEditor.brightness": "Яскравість",
    "paint.paintEditor.costume": "Образ",
    "paint.paintEditor.group": "Групувати",
    "paint.paintEditor.ungroup": "Розгрупувати",
    "paint.paintEditor.undo": "Скасувати",
    "paint.paintEditor.redo": "Повернути",
    "paint.paintEditor.forward": "Вперед",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "Попереду",
    "paint.paintEditor.back": "Позаду",
    "paint.paintEditor.more": "Більше",
    "paint.modeTools.brushSize": "Розмір",
    "paint.modeTools.eraserSize": "Розмір зтирачки",
    "paint.modeTools.copy": "Копія",
    "paint.modeTools.paste": "Вставити",
    "paint.modeTools.delete": "Вилучити",
    "paint.modeTools.curved": "Крива",
    "paint.modeTools.pointed": "Кути",
    "paint.modeTools.thickness": "Товщина",
    "paint.modeTools.flipHorizontal": "Право-ліво",
    "paint.modeTools.flipVertical": "Верх-низ",
    "paint.modeTools.filled": "Заповнення",
    "paint.modeTools.outlined": "Межа",
    "paint.paintEditor.bitmap": "У растрове",
    "paint.paintEditor.vector": "У векторне",
    "paint.paintEditor.fill": "Заповнення",
    "paint.paintEditor.stroke": "Межа",
    "paint.brushMode.brush": "Пензель",
    "paint.eraserMode.eraser": "Гумка",
    "paint.fillMode.fill": "Заповнення",
    "paint.lineMode.line": "Лінія",
    "paint.ovalMode.oval": "Коло",
    "paint.rectMode.rect": "Прямокутник",
    "paint.reshapeMode.reshape": "Реформувати",
    "paint.roundedRectMode.roundedRect": "Закруглений прямокутник",
    "paint.selectMode.select": "Обрати",
    "paint.textMode.text": "Текст",
    "paint.colorPicker.swap": "Поміняти"
  },
  "zh-cn": {
    "gui.alerts.lostPeripheralConnection": "Scratch与{extensionName}的连接已断开。",
    "gui.alerts.tryAgain": "重试",
    "gui.alerts.download": "下载",
    "gui.connection.reconnect": "重新连接",
    "gui.backpack.costumeLabel": "造型",
    "gui.backpack.soundLabel": "声音",
    "gui.backpack.scriptLabel": "脚本",
    "gui.backpack.spriteLabel": "角色",
    "gui.backpack.header": "书包",
    "gui.backpack.errorBackpack": "载入书包时出错了",
    "gui.backpack.loadingBackpack": "载入中……",
    "gui.backpack.more": "更多",
    "gui.backpack.emptyBackpack": "书包是空的",
    "gui.unsupportedBrowser.label": "不支持当前浏览器",
    "gui.unsupportedBrowser.errorLabel": "出错了",
    "gui.unsupportedBrowser.notRecommended": "我们十分抱歉，Scratch不支持您正在使用的浏览器，我们建议您升级到我们所支持的浏览器的最新版本，例如Chrome、火狐、Edge或者Safari。",
    "gui.unsupportedBrowser.description": "我们十分抱歉，Scratch并不支持您当前使用的浏览器，我们建议您升级到我们所支持的浏览器的最新版，例如Chrome、火狐、Edge或者Safari。",
    "gui.unsupportedBrowser.back": "返回",
    "gui.unsupportedBrowser.previewfaq": "访问{previewFaqLink}，了解更多。",
    "gui.unsupportedBrowser.previewfaqlinktext": "常见问题",
    "gui.cards.all-tutorials": "教程",
    "gui.cards.shrink": "收起",
    "gui.cards.expand": "展开",
    "gui.cards.close": "关闭",
    "gui.cards.more-things-to-try": "再试试这些！",
    "gui.cards.see-more": "更多技巧",
    "gui.comingSoon.message1": "别急，我们还在做这个 {emoji}",
    "gui.comingSoon.message2": "即将启用...",
    "gui.comingSoon.message3": "还在开发 {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "没有发现任何设备",
    "gui.connection.auto-scanning.prescan": "把设备放在边上，然后开始搜索",
    "gui.connection.auto-scanning.pressbutton": "按下设备上的按钮",
    "gui.connection.auto-scanning.start-search": "开始搜索",
    "gui.connection.connecting-searchbutton": "正在搜索……",
    "gui.connection.auto-scanning.try-again": "重试",
    "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.connected": "已连接",
    "gui.connection.disconnect": "断开连接",
    "gui.connection.go-to-editor": "返回编辑器",
    "gui.connection.connecting-cancelbutton": "正在连接……",
    "gui.connection.error.errorMessage": "呀，好像出错了。",
    "gui.connection.error.tryagainbutton": "重试",
    "gui.connection.error.helpbutton": "帮助",
    "gui.connection.peripheral-name-label": "设备名称",
    "gui.connection.connect": "连接",
    "gui.connection.scanning.lookingforperipherals": "正在查找设备",
    "gui.connection.scanning.noPeripheralsFound": "没有发现任何设备",
    "gui.connection.scanning.instructions": "选择上面列出的设备。",
    "gui.connection.search": "刷新",
    "gui.connection.scanning.updatePeripheralButton": "Update my Device",
    "gui.connection.unavailable.installscratchlink": "确保Scratch Link已安装并正在运行",
    "gui.connection.unavailable.enablebluetooth": "请检查蓝牙已经开启",
    "gui.connection.unavailable.tryagainbutton": "重试",
    "gui.connection.unavailable.helpbutton": "帮助",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "运行",
    "gui.controls.stop": "停止",
    "gui.crashMessage.label": "呀，出错了。",
    "gui.crashMessage.description": "很抱歉，Scratch出故障了。这个问题已经自动报告给Scratch开发团队。请刷新页面再试试。",
    "gui.crashMessage.errorNumber": "该错误已记录，编号{errorId}",
    "gui.crashMessage.reload": "重新载入",
    "gui.customProcedures.myblockModalTitle": "制作新的积木",
    "gui.customProcedures.addAnInputNumberText": "添加输入项",
    "gui.customProcedures.numberTextType": "数字或文本",
    "gui.customProcedures.addAnInputBoolean": "添加输入项",
    "gui.customProcedures.booleanType": "布尔值",
    "gui.customProcedures.addALabel": "添加文本标签：",
    "gui.customProcedures.runWithoutScreenRefresh": "运行时不刷新屏幕",
    "gui.customProcedures.cancel": "取消",
    "gui.customProcedures.ok": "完成",
    "gui.SpriteInfo.direction": "方向",
    "gui.directionPicker.rotationStyles.allAround": "任意旋转",
    "gui.directionPicker.rotationStyles.leftRight": "左右翻转",
    "gui.directionPicker.rotationStyles.dontRotate": "不旋转",
    "gui.gui.addExtension": "添加扩展",
    "gui.gui.codeTab": "代码",
    "gui.gui.backdropsTab": "背景",
    "gui.gui.costumesTab": "造型",
    "gui.gui.soundsTab": "声音",
    "gui.extensionLibrary.comingSoon": "即将启用",
    "gui.extensionLibrary.requires": "系统需求",
    "gui.extensionLibrary.collaboration": "合作者",
    "gui.library.filterPlaceholder": "搜索",
    "gui.library.allTag": "所有",
    "gui.loader.message1": "正在创建积木……",
    "gui.loader.message2": "载入角色……",
    "gui.loader.message3": "载入声音……",
    "gui.loader.message4": "加载扩展……",
    "gui.loader.message5": "呼唤小猫……",
    "gui.loader.message6": "传送Nano……",
    "gui.loader.message7": "给Gobo充气 …",
    "gui.loader.message8": "准备表情……",
    "gui.loader.headline": "载入作品",
    "gui.loader.creating": "新建作品",
    "gui.accountMenu.profile": "个人资料",
    "gui.accountMenu.myStuff": "我的东西",
    "gui.accountMenu.myClasses": "我的所有班级",
    "gui.accountMenu.myClass": "我的班级",
    "gui.accountMenu.accountSettings": "账号设置",
    "gui.accountMenu.signOut": "登出",
    "gui.authorInfo.byUser": "作者{username}",
    "gui.menuBar.seeProjectPage": "查看作品页面",
    "gui.menuBar.language": "Language",
    "general.username": "用户名",
    "general.password": "密码",
    "general.signIn": "登录",
    "login.needHelp": "需要帮助？",
    "form.validationRequired": "必填字段",
    "gui.menuBar.tutorialsLibrary": "教程",
    "gui.menuBar.restoreSprite": "复原删除的角色",
    "gui.menuBar.restoreSound": "复原删除的声音",
    "gui.menuBar.restoreCostume": "复原删除的造型",
    "gui.menuBar.restore": "恢复",
    "gui.menuBar.saveNow": "立即保存",
    "gui.menuBar.saveAsCopy": "保存副本",
    "gui.menuBar.remix": "改编",
    "gui.menuBar.new": "新作品",
    "gui.menuBar.file": "文件",
    "gui.menuBar.downloadToComputer": "保存到电脑",
    "gui.menuBar.edit": "编辑",
    "gui.menuBar.turboModeOff": "关闭加速模式",
    "gui.menuBar.turboModeOn": "打开加速模式",
    "gui.menuBar.modeMenu": "Mode",
    "gui.menuBar.normalMode": "Normal mode",
    "gui.menuBar.caturdayMode": "Caturday mode",
    "gui.menuBar.joinScratch": "加入 Scratch",
    "gui.menuBar.signIn": "登录",
    "gui.gui.projectTitlePlaceholder": "在此填写作品标题",
    "gui.menuBar.saveNowLink": "立即保存",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "已分享",
    "gui.menuBar.share": "分享",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "帮助",
    "gui.modal.back": "返回",
    "gui.monitor.listMonitor.empty": "(空)",
    "gui.monitor.listMonitor.listLength": "长度{length}",
    "gui.monitor.contextMenu.default": "正常显示",
    "gui.monitor.contextMenu.large": "大字显示",
    "gui.monitor.contextMenu.slider": "滑杆",
    "gui.monitor.contextMenu.sliderRange": "改变滑块范围",
    "gui.monitor.contextMenu.import": "导入",
    "gui.monitor.contextMenu.export": "导出",
    "gui.monitor.contextMenu.hide": "hide",
    "gui.playButton.play": "播放",
    "gui.playButton.stop": "停止",
    "gui.gui.variableScopeOptionAllSprites": "适用于所有角色",
    "gui.gui.variableScopeOptionSpriteOnly": "仅适用于当前角色",
    "gui.gui.cloudVariableOption": "云变量 (存储在服务器上)",
    "gui.gui.variablePromptAllSpritesMessage": "所有角色都可使用该变量。",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "取消",
    "gui.prompt.ok": "确定",
    "gui.playbackStep.stopMsg": "停止",
    "gui.playbackStep.playMsg": "播放",
    "gui.playbackStep.loadingMsg": "载入中……",
    "gui.playbackStep.saveMsg": "保存",
    "gui.playbackStep.reRecordMsg": "重新录制",
    "gui.recordModal.title": "录制声音",
    "gui.recordingStep.beginRecord": "点击下方的按钮开始录制",
    "gui.recordingStep.permission": "{arrow}我们需要你的许可才能使用麦克风。",
    "gui.recordingStep.stop": "停止录制",
    "gui.recordingStep.record": "录制",
    "gui.sliderModal.min": "最小值",
    "gui.sliderModal.max": "最大值",
    "gui.sliderModal.title": "改变滑块范围",
    "gui.sliderPrompt.cancel": "取消",
    "gui.sliderPrompt.ok": "确定",
    "gui.soundEditor.sound": "声音",
    "gui.soundEditor.play": "播放",
    "gui.soundEditor.stop": "停止",
    "gui.soundEditor.copy": "复制",
    "gui.soundEditor.paste": "粘贴",
    "gui.soundEditor.copyToNew": "新拷贝",
    "gui.soundEditor.delete": "删除",
    "gui.soundEditor.save": "保存",
    "gui.soundEditor.undo": "撤销",
    "gui.soundEditor.redo": "重做",
    "gui.soundEditor.faster": "快一点",
    "gui.soundEditor.slower": "慢一点",
    "gui.soundEditor.echo": "回声",
    "gui.soundEditor.robot": "机械化",
    "gui.soundEditor.louder": "响一点",
    "gui.soundEditor.softer": "轻一点",
    "gui.soundEditor.reverse": "反转",
    "gui.soundEditor.fadeOut": "渐弱",
    "gui.soundEditor.fadeIn": "渐强",
    "gui.soundEditor.mute": "静音",
    "gui.SpriteInfo.spritePlaceholder": "名字",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "角色",
    "gui.SpriteInfo.show": "显示",
    "gui.SpriteInfo.size": "大小",
    "gui.spriteSelectorItem.contextMenuDuplicate": "复制",
    "gui.spriteSelectorItem.contextMenuExport": "导出",
    "gui.spriteSelectorItem.contextMenuDelete": "删除",
    "gui.spriteSelector.addSpriteFromLibrary": "选择一个角色",
    "gui.spriteSelector.addSpriteFromPaint": "绘制",
    "gui.spriteSelector.addSpriteFromSurprise": "随机",
    "gui.spriteSelector.addSpriteFromFile": "上传角色",
    "gui.stageHeader.stageSizeLarge": "放大舞台",
    "gui.stageHeader.stageSizeSmall": "缩小舞台",
    "gui.stageHeader.stageSizeFull": "进入全屏模式",
    "gui.stageHeader.stageSizeUnFull": "退出全屏模式",
    "gui.stageHeader.fullscreenControl": "全屏模式",
    "gui.spriteSelector.addBackdropFromLibrary": "选择一个背景",
    "gui.stageSelector.addBackdropFromPaint": "绘制",
    "gui.stageSelector.addBackdropFromSurprise": "随机",
    "gui.stageSelector.addBackdropFromFile": "上传背景",
    "gui.stageSelector.stage": "舞台",
    "gui.stageSelector.backdrops": "背景",
    "gui.telemetryOptIn.label": "统计使用情况并发送给Scratch",
    "gui.telemetryOptIn.body1": "允许Scratch自动发送使用情况信息给Scratch团队，帮助我们了解Scratch在全世界的使用情况。",
    "gui.telemetryOptIn.body2": "我们收集的信息包括所选语言、积木使用情况以及诸如保存、加载和上传作品等功能的使用情况。我们不会收集任何个人信息。请查看我们的{privacyPolicyLink}了解更多信息。",
    "gui.telemetryOptIn.privacyPolicyLink": "隐私政策",
    "gui.telemetryOptIn.optInText": "与Scratch团队分享我的使用数据",
    "gui.telemetryOptIn.optInTooltip": "发送统计信息",
    "gui.telemetryOptIn.optOutText": "不要把我的使用数据分享给Scratch团队",
    "gui.telemetryOptIn.optOutTooltip": "不发送统计信息",
    "gui.telemetryOptIn.settingWasUpdated": "你的设置已更新",
    "gui.telemetryOptIn.buttonClose": "关闭",
    "gui.turboMode.active": "加速模式",
    "gui.webglModal.label": "你的浏览器不支持WebGL",
    "gui.webglModal.description": "非常遗憾，你的电脑或浏览器{webGlLink}。Scratch 3.0需要该技术才能运行。",
    "gui.webglModal.webgllink": "不支持WebGL",
    "gui.webglModal.back": "返回",
    "gui.webglModal.previewfaq": "访问{previewFaqLink}，了解更多。",
    "gui.webglModal.previewfaqlinktext": "常见问题",
    "gui.costumeLibrary.chooseABackdrop": "选择一个背景",
    "gui.costumeLibrary.chooseACostume": "选择一个造型",
    "gui.costumeTab.addBackdropFromLibrary": "选择一个背景",
    "gui.costumeTab.addCostumeFromLibrary": "选择一个造型",
    "gui.costumeTab.addBlankCostume": "绘制",
    "gui.costumeTab.addSurpriseCostume": "随机",
    "gui.costumeTab.addFileBackdrop": "上传背景",
    "gui.costumeTab.addFileCostume": "上传造型",
    "gui.extensionLibrary.chooseAnExtension": "选择一个扩展",
    "gui.extensionLibrary.extensionUrl": "键入扩展的URL",
    "gui.monitors.importListColumnPrompt": "使用第几列（1-{numberOfColumns}）？",
    "gui.recordingStep.alertMsg": "无法启动录音",
    "gui.soundLibrary.chooseASound": "选择一个声音",
    "gui.soundTab.fileUploadSound": "上传声音",
    "gui.soundTab.surpriseSound": "随机",
    "gui.soundTab.recordSound": "录制",
    "gui.soundTab.addSoundFromLibrary": "选择一个声音",
    "gui.spriteLibrary.chooseASprite": "选择一个角色",
    "gui.tipsLibrary.tutorials": "选择一个教程",
    "gui.alerts.createsuccess": "作品已创建。",
    "gui.alerts.createcopysuccess": "作品已保存为副本。",
    "gui.alerts.createremixsuccess": "改编作品已保存。",
    "gui.alerts.creating": "正在创建...",
    "gui.alerts.creatingCopy": "正在复制作品……",
    "gui.alerts.creatingRemix": "正在改编作品……",
    "gui.alerts.creatingError": "无法创建作品。 请再试一次！",
    "gui.alerts.savingError": "作品未能保存。",
    "gui.alerts.savesuccess": "作品已保存。",
    "gui.alerts.saving": "正在保存作品……",
    "gui.alerts.cloudInfo": "请注意，云变量只支持数字，不能存放字母和符号。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "进一步了解。",
    "gui.alerts.importing": "正在导入……",
    "gui.defaultProject.meow": "喵",
    "gui.defaultProject.variable": "我的变量",
    "gui.howtos.intro-move-sayhello-hat.name": "入门",
    "gui.howtos.intro-move.step_stepMove": "添加「移动」积木",
    "gui.howtos.add-a-move-block.step_stepSay": "添加「说…」积木",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "点击绿旗运行",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "姓名动画",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "选一个字母角色",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "点击时播放声音",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "另选一个字母角色",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "改变颜色",
    "gui.howtos.animate-a-name.step_AnimateSpin": "选一个字母，让它旋转",
    "gui.howtos.animate-a-name.step_AnimateGrow": "另选一个字母，让它变大",
    "gui.howtos.imagine": "幻想世界",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "键入想说的话",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "点击绿旗开始运行",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "选择任意背景",
    "gui.howtos.imagine.step_imagineChooseSprite": "选择任意角色",
    "gui.howtos.imagine.step_imagineFlyAround": "按空格键控制滑动",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "另选一个角色",
    "gui.howtos.imagine.step_imagineLeftRight": "左右移动",
    "gui.howtos.imagine.step_imagineUpDown": "上下移动",
    "gui.howtos.imagine.step_imagineChangeCostumes": "改变造型",
    "gui.howtos.imagine.step_imagineGlideToPoint": "滑动到某处",
    "gui.howtos.imagine.step_imagineGrowShrink": "变大变小",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "另选一个背景",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "切换背景",
    "gui.howtos.imagine.step_imagineRecordASound": "添加一个声音",
    "gui.howtos.imagine.step_imagineChooseSound": "选择已录制的声音",
    "gui.howtos.make-music.name": "制作音乐",
    "gui.howtos.Make-Music.step_PickInstrument": "选一个乐器角色",
    "gui.howtos.Make-Music.step_PlaySoundClick": "点击时播放声音",
    "gui.howtos.Make-Music.step_MakeSong": "创作乐曲",
    "gui.howtos.make-music.step_MakeBeat": "选一种鼓，演奏鼓点",
    "gui.howtos.make-music.step_MakeBeatBox": "用麦克风角色演唱节奏口技",
    "gui.howtos.story.name": "创作故事",
    "gui.howtos.story.step_addbg": "添加一个背景",
    "gui.howtos.story.step_addsprite": "添加一个角色",
    "gui.howtos.story.step_saysomething": "让角色说些话",
    "gui.howtos.story.step_addanothersprite": "添加另一个角色",
    "gui.howtos.story.step_flip": "翻转方向",
    "gui.howtos.story.step_conversation": "进行对话",
    "gui.howtos.story.addanotherbg": "添加另一个背景",
    "gui.howtos.story.step_swithbg": "切换背景",
    "gui.howtos.story.step_hidewizard": "隐藏一个角色",
    "gui.howtos.story.step_showwizard": "展示一个角色",
    "gui.howtos.make-a-chase-game.name": "制作追赶游戏",
    "gui.howtos.Chase-Game.step_BG": "添加一个背景",
    "gui.howtos.chase-game.step_AddOcto": "添加一个角色",
    "gui.howtos.make-music.step_LeftRight": "用方向键控制左右移动",
    "gui.howtos.Chase-Game.step_UpDown": "用方向键控制上下移动",
    "gui.howtos.Chase-Game.step_AddStar": "添加另一个角色",
    "gui.howtos.Chase-Game.step_MoveRandom": "随机移动",
    "gui.howtos.Chase-Game.step_WhenTouch": "让章鱼被碰到的时候发出声音",
    "gui.howtos.Chase-Game.step_ScoreVariable": "建立一个得分变量",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "让章鱼被碰到时，增加得分",
    "gui.howtos.animate-char.name": "角色动画",
    "gui.howtos.animate-char.step_addbg": "添加一个背景",
    "gui.howtos.animate-char.step_addsprite": "添加一个角色",
    "gui.howtos.animate-char.step_saysomething": "让角色说些话",
    "gui.howtos.animate-char.step_addsound": "添加声音",
    "gui.howtos.animate-char.step_animatetalking": "交谈动画",
    "gui.howtos.animate-char.step_arrowkeys": "使用方向键移动",
    "gui.howtos.animate-char.step_jump": "跳跃",
    "gui.howtos.animate-char.step_changecolor": "改变颜色",
    "gui.howtos.make-a-game.name": "制作消除游戏",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "挑选一个角色",
    "gui.howtos.make-a-game.step_GamePlaySound": "点击时播放声音",
    "gui.howtos.make-a-game.step_GameAddScore": "建立一个得分变量",
    "gui.howtos.make-a-game.step_GameChangeScore": "被点击时增加分数",
    "gui.howtos.make-a-game.step_Random": "移动到随机位置",
    "gui.howtos.make-music.step_GameChangeColor": "改变颜色",
    "gui.howtos.make-music.step_ResetScore": "把得分清零",
    "gui.howtos.make-it-fly.name": "让角色飞行",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "选一个天空的背景",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "选择一个角色",
    "gui.howtos.fly.step_stepflySaySomething": "让角色说些话",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "用方向键控制移动",
    "gui.howtos.fly.step_stepflyChooseObject": "选择要采集的对象",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "让对象移动",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "点选你的角色",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "添加分数变量",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "保存成绩",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "加入景物",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "让景物移动",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "换成下一个造型",
    "gui.howtos.pong": "乒乓球游戏",
    "gui.howtos.pong.step_pongAddBackdrop": "添加一个背景",
    "gui.howtos.pong.step_pongAddBallSprite": "添加球体角色",
    "gui.howtos.pong.step_pongBounceAround": "让球反弹",
    "gui.howtos.pong.step_pongAddPaddle": "添加滑板",
    "gui.howtos.pong.step_pongMoveThePaddle": "控制滑板移动",
    "gui.howtos.pong.step_pongSelectBallSprite": "点选球体角色",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "添加代码让球体碰到滑板反弹",
    "gui.howtos.pong.step_pongAddAScore": "添加分数变量",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "从菜单中选择「分数」",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "插入「改变分数」积木",
    "gui.howtos.pong.step_pongResetScore": "把得分清零",
    "gui.howtos.pong.step_pongAddLineSprite": "添加线条角色",
    "gui.howtos.pong.step_pongGameOver": "碰到红线游戏结束",
    "gui.howtos.code-cartoon": "编制卡通",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "点击绿旗时说点什么",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "点击角色时的动画效果",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "选择一个不同的角色",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "用减号让角色缩小",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "让角色放大缩小",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "选择一个不同的角色",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "上下跳动",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "点击角色来切换场景",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "滑来滑去",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "改变造型",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "选择更多角色加入你的卡通",
    "gui.howtos.cartoon-network": "冒险游戏动画",
    "gui.howtos.cartoon-network.step_CNcharacter": "选择要显示的角色",
    "gui.howtos.cartoon-network.step_CNsay": "让角色说些话",
    "gui.howtos.cartoon-network.step_CNglide": "滑来滑去",
    "gui.howtos.cartoon-network.step_CNpicksprite": "选择要捕捉的目标",
    "gui.howtos.cartoon-network.step_CNcollect": "收集物品",
    "gui.howtos.cartoon-network.step_CNvariable": "建立分数变量",
    "gui.howtos.cartoon-network.step_CNscore": "保存成绩",
    "gui.howtos.cartoon-network.step_CNbackdrop": "过关：改变背景",
    "gui.howtos.videosens.name": "视频侦测",
    "gui.howtos.videosens.step_addextension": "添加扩展",
    "gui.howtos.videosens.step_pet": "爱抚猫咪",
    "gui.howtos.videosens.step_animate": "动画",
    "gui.howtos.videosens.step_pop": "戳破气球",
    "gui.howtos.say-it-out-loud": "创建会说话的动画",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "添加文字朗读扩展积木",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "让角色说些话",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "设置语音",
    "gui.howtos.say-it-out-loud.step_TXTMove": "四处移动",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "添加一个背景",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "添加另一个角色",
    "gui.howtos.say-it-out-loud.step_TXTSong": "演奏一首歌",
    "gui.howtos.say-it-out-loud.step_TXTColor": "改变颜色",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "原地转动",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "变大变小",
    "gui.howtos.talking": "朗读文字",
    "gui.howtos.talking.step_talesAddExtension": "点击添加文字朗读积木",
    "gui.howtos.talking.step_talesChooseSprite": "选择一个角色",
    "gui.howtos.talking.step_talesSaySomething": "让角色朗读文字",
    "gui.howtos.talking.step_talesChooseBackdrop": "选择一个背景",
    "gui.howtos.talking.step_talesSwitchBackdrop": "点击角色时进入下一个背景",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "另选一个角色",
    "gui.howtos.talking.step_talesMoveAround": "四处移动",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "另选一个背景",
    "gui.howtos.talking.step_talesAnimateTalking": "交谈动画",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "另选一个背景",
    "gui.howtos.talking.step_talesChooseSound": "选一个跳舞的歌曲",
    "gui.howtos.talking.step_talesDanceMoves": "舞步",
    "gui.howtos.talking.step_talesAskAnswer": "从侦测区拖出「询问」和「回答」积木",
    "gui.howtos.add-sprite.name": "添加一个角色",
    "gui.howtos.add-sprite.step_addSprite": "添加一个角色",
    "gui.howtos.add-a-backdrop.name": "添加一个背景",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "添加一个背景",
    "gui.howtos.change-size.name": "变大变小",
    "gui.howtos.change-size.step_changeSize": "变大变小",
    "gui.howtos.glide-around.name": "滑来滑去",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "滑来滑去",
    "gui.howtos.change-size.step_glideAroundPoint": "滑动到某处",
    "gui.howtos.record-a-sound.name": "录制声音",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "点击「声音」标签页",
    "gui.howtos.change-size.step_recordASoundClickRecord": "点击「录制」",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "按下录制按钮",
    "gui.howtos.change-size.step_recordASoundChooseSound": "选择已录制的声音",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "播放录制的声音",
    "gui.howtos.spin-video.name": "让字母旋转",
    "gui.howtos.change-size.step_spinTurn": "转动",
    "gui.howtos.change-size.step_spinPointInDirection": "设置方向",
    "gui.howtos.hide-and-show.name": "隐藏和出现",
    "gui.howtos.change-size.step_hideAndShow": "隐藏和出现",
    "gui.howtos.switch-costume.name": "角色动画",
    "gui.howtos.change-size.step_switchCostumes": "角色动画",
    "gui.howtos.move-around-with-arrow-keys.name": "使用方向键",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "左右移动",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "上下移动",
    "gui.howtos.add-effects.name": "添加一些效果",
    "gui.howtos.videosens.step_addEffects": "添加视觉效果",
    "gui.extension.music.name": "音乐",
    "gui.extension.music.description": "演奏乐器，敲锣打鼓。",
    "gui.extension.pen.name": "画笔",
    "gui.extension.pen.description": "绘制角色。",
    "gui.extension.videosensing.name": "视频侦测",
    "gui.extension.videosensing.description": "使用摄像头侦测运动。",
    "gui.extension.text2speech.name": "文字朗读",
    "gui.extension.text2speech.description": "让你的作品开口说话",
    "gui.extension.translate.name": "翻译",
    "gui.extension.translate.description": "把文字翻译成多种语言。",
    "gui.extension.makeymakey.description": "把任何东西变成按键",
    "gui.extension.microbit.description": "把作品连接到实体世界。",
    "gui.extension.microbit.connectingMessage": "正在连接",
    "gui.extension.ev3.description": "搭建交互机器人等。",
    "gui.extension.ev3.connectingMessage": "正在连接。请确保EV3上的识别码(PIN)已经设置为1234。",
    "gui.extension.boost.description": "生动有趣的机器人创作",
    "gui.extension.boost.connectingMessage": "正在连接",
    "gui.extension.wedo2.description": "支持马达和传感器。",
    "gui.extension.wedo2.connectingMessage": "正在连接",
    "gui.extension.gdxfor.description": "感受推拉动转。",
    "gui.extension.gdxfor.connectingMessage": "正在连接",
    "gui.libraryTags.all": "所有",
    "gui.libraryTags.animals": "动物",
    "gui.libraryTags.dance": "舞蹈",
    "gui.libraryTags.effects": "效果",
    "gui.libraryTags.fantasy": "奇幻",
    "gui.libraryTags.fashion": "时尚",
    "gui.libraryTags.food": "食物",
    "gui.libraryTags.indoors": "室内",
    "gui.libraryTags.loops": "可循环",
    "gui.libraryTags.music": "音乐",
    "gui.libraryTags.notes": "音符",
    "gui.libraryTags.outdoors": "户外",
    "gui.libraryTags.patterns": "图案",
    "gui.libraryTags.people": "人物",
    "gui.libraryTags.percussion": "打击乐器",
    "gui.libraryTags.space": "太空",
    "gui.libraryTags.sports": "运动",
    "gui.libraryTags.underwater": "水下",
    "gui.libraryTags.voice": "人声",
    "gui.libraryTags.wacky": "古怪",
    "gui.libraryTags.animation": "动画",
    "gui.libraryTags.art": "艺术",
    "gui.libraryTags.games": "游戏",
    "gui.libraryTags.stories": "故事",
    "gui.libraryTags.letters": "字母",
    "gui.opcodeLabels.direction": "方向",
    "gui.opcodeLabels.xposition": "x 坐标",
    "gui.opcodeLabels.yposition": "y 坐标",
    "gui.opcodeLabels.size": "大小",
    "gui.opcodeLabels.costumename": "造型名称",
    "gui.opcodeLabels.costumenumber": "造型编号",
    "gui.opcodeLabels.backdropname": "背景名称",
    "gui.opcodeLabels.backdropnumber": "背景编号",
    "gui.opcodeLabels.volume": "音量",
    "gui.opcodeLabels.tempo": "演奏速度",
    "gui.opcodeLabels.answer": "回答",
    "gui.opcodeLabels.loudness": "响度",
    "gui.opcodeLabels.username": "用户名",
    "gui.opcodeLabels.year": "年",
    "gui.opcodeLabels.month": "月",
    "gui.opcodeLabels.date": "日",
    "gui.opcodeLabels.dayofweek": "星期",
    "gui.opcodeLabels.hour": "时",
    "gui.opcodeLabels.minute": "分",
    "gui.opcodeLabels.second": "秒",
    "gui.opcodeLabels.timer": "计时器",
    "gui.projectLoader.loadError": "加载作品文件失败。",
    "gui.sharedMessages.backdrop": "背景{index}",
    "gui.sharedMessages.costume": "造型{index}",
    "gui.sharedMessages.sprite": "角色{index}",
    "gui.sharedMessages.pop": "啵",
    "gui.sharedMessages.replaceProjectWarning": "是否丢弃当前作品中尚未保存的内容？",
    "gui.sharedMessages.loadFromComputerTitle": "从电脑中打开",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch作品",
    "boost.color.any": "任何颜色",
    "boost.color.black": "黑色",
    "boost.color.blue": "蓝色",
    "boost.color.green": "绿色",
    "boost.color.red": "黄色",
    "boost.color.white": "白色",
    "boost.color.yellow": "黄色",
    "boost.getMotorPosition": "马达 [MOTOR_REPORTER_ID] 位置",
    "boost.getTiltAngle": "向[TILT_DIRECTION]倾角",
    "boost.motorDirection.backward": "逆时针",
    "boost.motorDirection.forward": "顺时针",
    "boost.motorDirection.reverse": "反转",
    "boost.motorOff": "关闭马达 [MOTOR_ID]",
    "boost.motorOn": "开启马达 [MOTOR_ID]",
    "boost.motorOnFor": "使马达 [MOTOR_ID]转动 [DURATION] 秒",
    "boost.motorOnForRotation": "使马达 [MOTOR_ID]转动 [ROTATION] 圈",
    "boost.seeingColor": "看到 [COLOR]积木 ?",
    "boost.setLightHue": "将灯光颜色设为[HUE]",
    "boost.setMotorDirection": "将马达[MOTOR_ID] 方向设为 [MOTOR_DIRECTION]",
    "boost.setMotorPower": "将马达 [MOTOR_ID] 速度设为 [POWER]%",
    "boost.tiltDirection.any": "任意方向",
    "boost.tiltDirection.down": "下",
    "boost.tiltDirection.left": "左",
    "boost.tiltDirection.right": "右",
    "boost.tiltDirection.up": "上",
    "boost.whenColor": "当看到[COLOR]积木",
    "boost.whenTilted": "当向[TILT_DIRECTION_ANY]倾斜",
    "ev3.beepNote": "鸣笛[NOTE][TIME]秒",
    "ev3.buttonPressed": "按下按钮[PORT]？",
    "ev3.getBrightness": "亮度",
    "ev3.getDistance": "距离",
    "ev3.getMotorPosition": "马达[PORT]的位置",
    "ev3.motorSetPower": "马达[PORT]功率设为[POWER]%",
    "ev3.motorTurnClockwise": "马达[PORT]正转[TIME]秒",
    "ev3.motorTurnCounterClockwise": "马达[PORT]反转[TIME]秒",
    "ev3.whenBrightnessLessThan": "当亮度 < [DISTANCE]",
    "ev3.whenButtonPressed": "当按下按钮[PORT]",
    "ev3.whenDistanceLessThan": "当距离 < [DISTANCE]",
    "gdxfor.getAcceleration": "向[DIRECTION]的加速度",
    "gdxfor.getForce": "受力",
    "gdxfor.getSpin": "向[DIRECTION]的旋转速度",
    "gdxfor.getTilt": "向[TILT]倾角",
    "gdxfor.isFreeFalling": "自由落体？",
    "gdxfor.isTilted": "向[TILT]倾斜？",
    "gdxfor.pulled": "拉扯",
    "gdxfor.pushed": "挤压",
    "gdxfor.shaken": "被晃动",
    "gdxfor.startedFalling": "开始自由落体",
    "gdxfor.tiltDirectionMenu.any": "任意方向",
    "gdxfor.tiltDirectionMenu.back": "后",
    "gdxfor.tiltDirectionMenu.front": "前",
    "gdxfor.tiltDirectionMenu.left": "左",
    "gdxfor.tiltDirectionMenu.right": "右",
    "gdxfor.turnedFaceDown": "正面向下",
    "gdxfor.turnedFaceUp": "正面向上",
    "gdxfor.whenForcePushedOrPulled": "当力传感器被[PUSH_PULL]",
    "gdxfor.whenGesture": "当传感器[GESTURE]",
    "gdxfor.whenTilted": "当向[TILT]倾斜",
    "makeymakey.downArrow": "↓",
    "makeymakey.downArrowShort": "下",
    "makeymakey.leftArrow": "←",
    "makeymakey.leftArrowShort": "左",
    "makeymakey.rightArrow": "→",
    "makeymakey.rightArrowShort": "右",
    "makeymakey.spaceKey": "空格",
    "makeymakey.upArrow": "↑",
    "makeymakey.upArrowShort": "上",
    "makeymakey.whenKeyPressed": "当按下 [KEY] 键",
    "makeymakey.whenKeysPressedInOrder": "当依次按下[SEQUENCE]键时",
    "microbit.buttonsMenu.any": "任意",
    "microbit.clearDisplay": "清空屏幕",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "显示[MATRIX]",
    "microbit.displayText": "显示文本[TEXT]",
    "microbit.gesturesMenu.jumped": "抛起",
    "microbit.gesturesMenu.moved": "移动",
    "microbit.gesturesMenu.shaken": "晃动",
    "microbit.isButtonPressed": "按下[BTN]按钮？",
    "microbit.isTilted": "向[DIRECTION]倾斜？",
    "microbit.pinStateMenu.off": "低电平",
    "microbit.pinStateMenu.on": "高电平",
    "microbit.tiltAngle": "向[DIRECTION]倾角",
    "microbit.tiltDirectionMenu.any": "任意",
    "microbit.tiltDirectionMenu.back": "后",
    "microbit.tiltDirectionMenu.front": "前",
    "microbit.tiltDirectionMenu.left": "左",
    "microbit.tiltDirectionMenu.right": "右",
    "microbit.whenButtonPressed": "当按下[BTN]按钮",
    "microbit.whenGesture": "当被[GESTURE]",
    "microbit.whenPinConnected": "当引脚[PIN]接地",
    "microbit.whenTilted": "当向[DIRECTION]倾斜",
    "music.categoryName": "音乐",
    "music.changeTempo": "将演奏速度增加[TEMPO]",
    "music.drumBass": "(2) 低音鼓",
    "music.drumBongo": "(13) 邦戈鼓",
    "music.drumCabasa": "(15) 卡巴萨",
    "music.drumClaves": "(9) 音棒",
    "music.drumClosedHiHat": "(6) 闭击踩镲",
    "music.drumConga": "(14) 康加鼓",
    "music.drumCowbell": "(11) 牛铃",
    "music.drumCrashCymbal": "(4) 碎音钹",
    "music.drumCuica": "(18) 锯加鼓",
    "music.drumGuiro": "(16) 刮瓜",
    "music.drumHandClap": "(8) 手掌",
    "music.drumOpenHiHat": "(5) 开击踩镲",
    "music.drumSideStick": "(3) 敲鼓边",
    "music.drumSnare": "(1) 小军鼓",
    "music.drumTambourine": "(7) 铃鼓",
    "music.drumTriangle": "(12) 三角铁",
    "music.drumVibraslap": "(17) 颤音器",
    "music.drumWoodBlock": "(10) 木鱼",
    "music.getTempo": "演奏速度",
    "music.instrumentBass": "(6) 贝斯",
    "music.instrumentBassoon": "(14) 巴松管",
    "music.instrumentCello": "(8) 大提琴",
    "music.instrumentChoir": "(15) 唱诗班",
    "music.instrumentClarinet": "(10) 单簧管",
    "music.instrumentElectricGuitar": "(5) 电吉他",
    "music.instrumentElectricPiano": "(2) 电钢琴",
    "music.instrumentFlute": "(12) 长笛",
    "music.instrumentGuitar": "(4) 吉他",
    "music.instrumentMarimba": "(19) 马林巴琴",
    "music.instrumentMusicBox": "(17) 八音盒",
    "music.instrumentOrgan": "(3) 风琴",
    "music.instrumentPiano": "(1) 钢琴",
    "music.instrumentPizzicato": "(7) 拨弦",
    "music.instrumentSaxophone": "(11) 萨克斯管",
    "music.instrumentSteelDrum": "(18) 钢鼓",
    "music.instrumentSynthLead": "(20) 合成主音",
    "music.instrumentSynthPad": "(21) 合成柔音",
    "music.instrumentTrombone": "(9) 长号",
    "music.instrumentVibraphone": "(16) 颤音琴",
    "music.instrumentWoodenFlute": "(13) 木长笛",
    "music.midiPlayDrumForBeats": "击打 [DRUM] [BEATS] 拍",
    "music.midiSetInstrument": "将乐器设为 [INSTRUMENT]",
    "music.playDrumForBeats": "击打 [DRUM] [BEATS] 拍",
    "music.playNoteForBeats": "演奏音符[NOTE][BEATS]拍",
    "music.restForBeats": "休止[BEATS]拍",
    "music.setInstrument": "将乐器设为 [INSTRUMENT]",
    "music.setTempo": "将演奏速度设定为[TEMPO]",
    "pen.categoryName": "画笔",
    "pen.changeColorParam": "将笔的 [COLOR_PARAM] 增加[VALUE]",
    "pen.changeHue": "将笔的颜色增加[HUE]",
    "pen.changeShade": "将笔的亮度增加[SHADE]",
    "pen.changeSize": "将笔的粗细增加[SIZE]",
    "pen.clear": "全部擦除",
    "pen.colorMenu.brightness": "亮度",
    "pen.colorMenu.color": "颜色",
    "pen.colorMenu.saturation": "饱和度",
    "pen.colorMenu.transparency": "透明度",
    "pen.penDown": "落笔",
    "pen.penUp": "抬笔",
    "pen.setColor": "将笔的颜色设为[COLOR]",
    "pen.setColorParam": "将笔的 [COLOR_PARAM] 设为[VALUE]",
    "pen.setHue": "将笔的颜色设为[HUE]",
    "pen.setShade": "将笔的亮度设为[SHADE]",
    "pen.setSize": "将笔的粗细设为[SIZE]",
    "pen.stamp": "图章",
    "speech.defaultWhenIHearValue": "开始",
    "speech.extensionName": "语音识别",
    "speech.listenAndWait": "听候语音输入",
    "speech.speechReporter": "语音输入",
    "speech.whenIHear": "当听到[PHRASE]",
    "text2speech.alto": "中音",
    "text2speech.categoryName": "文字朗读",
    "text2speech.defaultTextToSpeak": "你好",
    "text2speech.giant": "巨人",
    "text2speech.kitten": "小猫",
    "text2speech.setLanguageBlock": "将朗读语言设置为[LANGUAGE]",
    "text2speech.setVoiceBlock": "使用 [VOICE] 嗓音",
    "text2speech.speakAndWaitBlock": "朗读 [WORDS]",
    "text2speech.squeak": "尖细",
    "text2speech.tenor": "男高音",
    "translate.categoryName": "翻译",
    "translate.defaultTextToTranslate": "你好",
    "translate.translateBlock": "将 [WORDS] 译为 [LANGUAGE]",
    "translate.viewerLanguage": "访客语言",
    "videoSensing.categoryName": "视频侦测",
    "videoSensing.direction": "方向",
    "videoSensing.motion": "运动",
    "videoSensing.off": "关闭",
    "videoSensing.on": "开启",
    "videoSensing.onFlipped": "镜像开启",
    "videoSensing.setVideoTransparency": "将视频透明度设为[TRANSPARENCY]",
    "videoSensing.sprite": "角色",
    "videoSensing.stage": "舞台",
    "videoSensing.videoOn": "相对于[SUBJECT]的视频[ATTRIBUTE]",
    "videoSensing.videoToggle": "[VIDEO_STATE]摄像头",
    "videoSensing.whenMotionGreaterThan": "当视频运动 > [REFERENCE]",
    "wedo2.getDistance": "距离",
    "wedo2.getTiltAngle": "向[TILT_DIRECTION]倾角",
    "wedo2.isTilted": "向[TILT_DIRECTION_ANY]倾斜？",
    "wedo2.motorDirection.backward": "逆时针",
    "wedo2.motorDirection.forward": "顺时针",
    "wedo2.motorDirection.reverse": "反转",
    "wedo2.motorId.a": "马达A",
    "wedo2.motorId.all": "所有马达",
    "wedo2.motorId.b": "马达B",
    "wedo2.motorId.default": "马达",
    "wedo2.motorOff": "关闭[MOTOR_ID]",
    "wedo2.motorOn": "开启[MOTOR_ID]",
    "wedo2.motorOnFor": "开启[MOTOR_ID][DURATION]秒",
    "wedo2.playNoteFor": "演奏音符[NOTE][DURATION]秒",
    "wedo2.setLightHue": "将灯光颜色设为[HUE]",
    "wedo2.setMotorDirection": "将[MOTOR_ID]转向设为[MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "将[MOTOR_ID]功率设为[POWER]",
    "wedo2.tiltDirection.any": "任意方向",
    "wedo2.tiltDirection.down": "下",
    "wedo2.tiltDirection.left": "左",
    "wedo2.tiltDirection.right": "右",
    "wedo2.tiltDirection.up": "上",
    "wedo2.whenDistance": "当距离[OP][REFERENCE]",
    "wedo2.whenTilted": "当向[TILT_DIRECTION_ANY]倾斜",
    "paint.paintEditor.hue": "颜色",
    "paint.paintEditor.saturation": "饱和度",
    "paint.paintEditor.brightness": "亮度",
    "paint.paintEditor.costume": "造型",
    "paint.paintEditor.group": "组合",
    "paint.paintEditor.ungroup": "拆散",
    "paint.paintEditor.undo": "撤销",
    "paint.paintEditor.redo": "重做",
    "paint.paintEditor.forward": "往前放",
    "paint.paintEditor.backward": "往后放",
    "paint.paintEditor.front": "放最前面",
    "paint.paintEditor.back": "放最后面",
    "paint.paintEditor.more": "更多",
    "paint.modeTools.brushSize": "粗细",
    "paint.modeTools.eraserSize": "橡皮擦大小",
    "paint.modeTools.copy": "复制",
    "paint.modeTools.paste": "粘贴",
    "paint.modeTools.delete": "删除",
    "paint.modeTools.curved": "曲线",
    "paint.modeTools.pointed": "折线",
    "paint.modeTools.thickness": "粗细",
    "paint.modeTools.flipHorizontal": "水平翻转",
    "paint.modeTools.flipVertical": "垂直翻转",
    "paint.modeTools.filled": "实心",
    "paint.modeTools.outlined": "轮廓",
    "paint.paintEditor.bitmap": "转换为位图",
    "paint.paintEditor.vector": "转换为矢量图",
    "paint.paintEditor.fill": "填充",
    "paint.paintEditor.stroke": "轮廓",
    "paint.brushMode.brush": "画笔",
    "paint.eraserMode.eraser": "橡皮擦",
    "paint.fillMode.fill": "填充",
    "paint.lineMode.line": "线段",
    "paint.ovalMode.oval": "圆",
    "paint.rectMode.rect": "矩形",
    "paint.reshapeMode.reshape": "变形",
    "paint.roundedRectMode.roundedRect": "圆角矩形",
    "paint.selectMode.select": "选择",
    "paint.textMode.text": "文本",
    "paint.colorPicker.swap": "交换"
  },
  "zh-tw": {
    "gui.alerts.lostPeripheralConnection": "Scratch 與 {extensionName} 的連線中斷。",
    "gui.alerts.tryAgain": "再試一次",
    "gui.alerts.download": "下載",
    "gui.connection.reconnect": "重新連接",
    "gui.backpack.costumeLabel": "造型",
    "gui.backpack.soundLabel": "音效",
    "gui.backpack.scriptLabel": "程式",
    "gui.backpack.spriteLabel": "角色",
    "gui.backpack.header": "背包",
    "gui.backpack.errorBackpack": "載入背包時發生錯誤",
    "gui.backpack.loadingBackpack": "正在載入…",
    "gui.backpack.more": "更多資訊",
    "gui.backpack.emptyBackpack": "背包空無一物",
    "gui.unsupportedBrowser.label": "瀏覽器不支援",
    "gui.unsupportedBrowser.errorLabel": "發生錯誤",
    "gui.unsupportedBrowser.notRecommended": "很抱歉，這個版本的瀏覽器無法支援 Scratch。建議你改用其它的，像是 Google Chrome、Mozilla Firefox、Microsoft Edge、Apple Safari。",
    "gui.unsupportedBrowser.description": "很抱歉，這個瀏覽器無法支援 Scratch。建議你改用其它的，像是 Google Chrome、Mozilla Firefox、Microsoft Edge、Apple Safari。",
    "gui.unsupportedBrowser.back": "返回",
    "gui.unsupportedBrowser.previewfaq": "若要進一步瞭解，請至 {previewFaqLink}。",
    "gui.unsupportedBrowser.previewfaqlinktext": "常見問答",
    "gui.cards.all-tutorials": "教程",
    "gui.cards.shrink": "縮小",
    "gui.cards.expand": "放大",
    "gui.cards.close": "關閉",
    "gui.cards.more-things-to-try": "試試其它東西！",
    "gui.cards.see-more": "觀看更多",
    "gui.comingSoon.message1": "別擔心，我們在做囉 {emoji}",
    "gui.comingSoon.message2": "即將推出...",
    "gui.comingSoon.message3": "我們在做囉 {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "沒有找到裝置",
    "gui.connection.auto-scanning.prescan": "把你的裝置放得近一些，然後再開始搜索。",
    "gui.connection.auto-scanning.pressbutton": "按下裝置上的按鈕。",
    "gui.connection.auto-scanning.start-search": "開始搜尋",
    "gui.connection.connecting-searchbutton": "正在搜尋…",
    "gui.connection.auto-scanning.try-again": "再試一次",
    "gui.connection.auto-scanning.updatePeripheralButton": "更新我的設備",
    "gui.connection.connected": "裝置已連線",
    "gui.connection.disconnect": "中斷裝置連線",
    "gui.connection.go-to-editor": "回到編輯器",
    "gui.connection.connecting-cancelbutton": "正在連線...",
    "gui.connection.error.errorMessage": "喔，好像有什麼地方出錯了。",
    "gui.connection.error.tryagainbutton": "再試一次",
    "gui.connection.error.helpbutton": "幫助",
    "gui.connection.peripheral-name-label": "裝置名稱",
    "gui.connection.connect": "開始連線",
    "gui.connection.scanning.lookingforperipherals": "正在尋找裝置",
    "gui.connection.scanning.noPeripheralsFound": "沒有找到裝置",
    "gui.connection.scanning.instructions": "在列表中選擇你的裝置",
    "gui.connection.search": "重新整理",
    "gui.connection.scanning.updatePeripheralButton": "更新我的設備",
    "gui.connection.unavailable.installscratchlink": "確定你已經安裝並執行 Scratch Link",
    "gui.connection.unavailable.enablebluetooth": "檢查藍牙是否開啟",
    "gui.connection.unavailable.tryagainbutton": "再試一次",
    "gui.connection.unavailable.helpbutton": "幫助",
    "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
    "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
    "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
    "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
    "gui.connection.updatePeripheral.updateFailed": "Update failed.",
    "gui.connection.updatePeripheral.goBackButton": "Go Back",
    "gui.connection.updatePeripheral.updateNowButton": "Do Update",
    "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
    "gui.controls.go": "開始",
    "gui.controls.stop": "停止",
    "gui.crashMessage.label": "哎呀！發生了一些錯誤。",
    "gui.crashMessage.description": "很抱歉，看起來 Scratch 崩潰了，錯誤已自動回報給 Scratch 團隊，請重新整理你的頁面，再試一次吧！",
    "gui.crashMessage.errorNumber": "錯誤已被紀錄，id 為 {errorId}",
    "gui.crashMessage.reload": "重新載入",
    "gui.customProcedures.myblockModalTitle": "建立一個積木",
    "gui.customProcedures.addAnInputNumberText": "添加輸入方塊",
    "gui.customProcedures.numberTextType": "數字或文字",
    "gui.customProcedures.addAnInputBoolean": "添加輸入方塊",
    "gui.customProcedures.booleanType": "布林值",
    "gui.customProcedures.addALabel": "添加說明文字",
    "gui.customProcedures.runWithoutScreenRefresh": "執行完畢再更新畫面",
    "gui.customProcedures.cancel": "取消",
    "gui.customProcedures.ok": "確定",
    "gui.SpriteInfo.direction": "方向",
    "gui.directionPicker.rotationStyles.allAround": "不設限",
    "gui.directionPicker.rotationStyles.leftRight": "左-右",
    "gui.directionPicker.rotationStyles.dontRotate": "不旋轉",
    "gui.gui.addExtension": "添加擴展",
    "gui.gui.codeTab": "程式",
    "gui.gui.backdropsTab": "背景",
    "gui.gui.costumesTab": "造型",
    "gui.gui.soundsTab": "音效",
    "gui.extensionLibrary.comingSoon": "即將推出",
    "gui.extensionLibrary.requires": "需求",
    "gui.extensionLibrary.collaboration": "合作者",
    "gui.library.filterPlaceholder": "搜尋",
    "gui.library.allTag": "全部",
    "gui.loader.message1": "正在創建積木…",
    "gui.loader.message2": "正在載入角色…",
    "gui.loader.message3": "正在載入音效…",
    "gui.loader.message4": "正在載入擴展…",
    "gui.loader.message5": "Herding cats …",
    "gui.loader.message6": "Transmitting nanos …",
    "gui.loader.message7": "Inflating gobos …",
    "gui.loader.message8": "正在準備表情符號…",
    "gui.loader.headline": "正在載入專案",
    "gui.loader.creating": "正在創建專案",
    "gui.accountMenu.profile": "個人資料",
    "gui.accountMenu.myStuff": "我的東西",
    "gui.accountMenu.myClasses": "我的所有班級",
    "gui.accountMenu.myClass": "我的班級",
    "gui.accountMenu.accountSettings": "帳戶設定",
    "gui.accountMenu.signOut": "登出",
    "gui.authorInfo.byUser": "建立者 {username}",
    "gui.menuBar.seeProjectPage": "切換到專案頁面",
    "gui.menuBar.language": "Language",
    "general.username": "用戶名稱",
    "general.password": "用戶密碼",
    "general.signIn": "登入",
    "login.needHelp": "需要幫助？",
    "form.validationRequired": "必填欄位",
    "gui.menuBar.tutorialsLibrary": "教程",
    "gui.menuBar.restoreSprite": "復原角色",
    "gui.menuBar.restoreSound": "復原音效",
    "gui.menuBar.restoreCostume": "復原造型",
    "gui.menuBar.restore": "復原",
    "gui.menuBar.saveNow": "儲存",
    "gui.menuBar.saveAsCopy": "另存成複本",
    "gui.menuBar.remix": "改編",
    "gui.menuBar.new": "新建專案",
    "gui.menuBar.file": "檔案",
    "gui.menuBar.downloadToComputer": "下載到你的電腦",
    "gui.menuBar.edit": "編輯",
    "gui.menuBar.turboModeOff": "關閉加速模式",
    "gui.menuBar.turboModeOn": "開啟加速模式",
    "gui.menuBar.modeMenu": "模式",
    "gui.menuBar.normalMode": "正常模式",
    "gui.menuBar.caturdayMode": "貓塊模式",
    "gui.menuBar.joinScratch": "加入 Scratch",
    "gui.menuBar.signIn": "登入",
    "gui.gui.projectTitlePlaceholder": "在這輸入專案名稱",
    "gui.menuBar.saveNowLink": "立刻儲存",
    "gui.menuBar.settings": "Settings",
    "gui.menuBar.isShared": "已分享",
    "gui.menuBar.share": "分享",
    "gui.menuBar.colorMode": "Color Mode",
    "gui.modal.help": "幫助",
    "gui.modal.back": "返回",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "長度 {length}",
    "gui.monitor.contextMenu.default": "一般顯示",
    "gui.monitor.contextMenu.large": "大型顯示",
    "gui.monitor.contextMenu.slider": "滑桿",
    "gui.monitor.contextMenu.sliderRange": "變更滑桿數值範圍",
    "gui.monitor.contextMenu.import": "匯入",
    "gui.monitor.contextMenu.export": "匯出",
    "gui.monitor.contextMenu.hide": "隱藏",
    "gui.playButton.play": "播放",
    "gui.playButton.stop": "停止",
    "gui.gui.variableScopeOptionAllSprites": "適用於所有角色",
    "gui.gui.variableScopeOptionSpriteOnly": "僅適用當前角色",
    "gui.gui.cloudVariableOption": "雲端變數（儲存於伺服器）",
    "gui.gui.variablePromptAllSpritesMessage": "這個變數適用於所有角色。",
    "gui.gui.listPromptAllSpritesMessage": "此清單將適用於所有角色。",
    "gui.prompt.cancel": "取消",
    "gui.prompt.ok": "確定",
    "gui.playbackStep.stopMsg": "停止",
    "gui.playbackStep.playMsg": "播放",
    "gui.playbackStep.loadingMsg": "正在載入…",
    "gui.playbackStep.saveMsg": "儲存",
    "gui.playbackStep.reRecordMsg": "重新錄音",
    "gui.recordModal.title": "錄音",
    "gui.recordingStep.beginRecord": "點擊下方按鈕開始錄製",
    "gui.recordingStep.permission": "{arrow} 我們需要你的允許才能使用麥克風",
    "gui.recordingStep.stop": "停止錄製",
    "gui.recordingStep.record": "錄製",
    "gui.sliderModal.min": "最小值",
    "gui.sliderModal.max": "最大值",
    "gui.sliderModal.title": "變更滑桿數值範圍",
    "gui.sliderPrompt.cancel": "取消",
    "gui.sliderPrompt.ok": "確定",
    "gui.soundEditor.sound": "音效",
    "gui.soundEditor.play": "播放",
    "gui.soundEditor.stop": "停止",
    "gui.soundEditor.copy": "複製",
    "gui.soundEditor.paste": "貼上",
    "gui.soundEditor.copyToNew": "複製",
    "gui.soundEditor.delete": "刪除",
    "gui.soundEditor.save": "保存",
    "gui.soundEditor.undo": "復原",
    "gui.soundEditor.redo": "重做",
    "gui.soundEditor.faster": "快播",
    "gui.soundEditor.slower": "慢播",
    "gui.soundEditor.echo": "回音",
    "gui.soundEditor.robot": "機器",
    "gui.soundEditor.louder": "響亮",
    "gui.soundEditor.softer": "輕柔",
    "gui.soundEditor.reverse": "反轉",
    "gui.soundEditor.fadeOut": "淡出",
    "gui.soundEditor.fadeIn": "淡入",
    "gui.soundEditor.mute": "靜音",
    "gui.SpriteInfo.spritePlaceholder": "名稱",
    "gui.SpriteInfo.showSpriteAction": "Show sprite",
    "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
    "gui.SpriteInfo.sprite": "角色",
    "gui.SpriteInfo.show": "顯示",
    "gui.SpriteInfo.size": "尺寸",
    "gui.spriteSelectorItem.contextMenuDuplicate": "複製",
    "gui.spriteSelectorItem.contextMenuExport": "匯出",
    "gui.spriteSelectorItem.contextMenuDelete": "刪除",
    "gui.spriteSelector.addSpriteFromLibrary": "選個角色",
    "gui.spriteSelector.addSpriteFromPaint": "繪畫",
    "gui.spriteSelector.addSpriteFromSurprise": "驚喜",
    "gui.spriteSelector.addSpriteFromFile": "上傳",
    "gui.stageHeader.stageSizeLarge": "模式切換 - 大舞台",
    "gui.stageHeader.stageSizeSmall": "模式切換 - 小舞台",
    "gui.stageHeader.stageSizeFull": "模式切換 - 全螢幕",
    "gui.stageHeader.stageSizeUnFull": "離開全螢幕模式",
    "gui.stageHeader.fullscreenControl": "顯示模式切換",
    "gui.spriteSelector.addBackdropFromLibrary": "選個背景",
    "gui.stageSelector.addBackdropFromPaint": "繪畫",
    "gui.stageSelector.addBackdropFromSurprise": "驚喜",
    "gui.stageSelector.addBackdropFromFile": "上傳",
    "gui.stageSelector.stage": "舞台",
    "gui.stageSelector.backdrops": "背景",
    "gui.telemetryOptIn.label": "回報統計數據以協助改善 Scratch",
    "gui.telemetryOptIn.body1": "Scratch 團隊希望能深入瞭解 Scratch 在世界各地的使用情況。如果可以的話，希望你能允許 Scratch 將你的使用情形紀錄下來並發送給 Scratch 團隊。",
    "gui.telemetryOptIn.body2": "我們會蒐集的資訊包含了語言的選擇、積木的使用量，還有一些事件，像是儲存、載入、上傳專案。我們保證不會收集任何個人資訊。你可以觀看我們的 {privacyPolicyLink} 以進一步瞭解相關訊息。",
    "gui.telemetryOptIn.privacyPolicyLink": "隱私政策",
    "gui.telemetryOptIn.optInText": "分享我的使用數據給 Scratch 團隊",
    "gui.telemetryOptIn.optInTooltip": "啟用遙測",
    "gui.telemetryOptIn.optOutText": "不要分享我的使用數據給 Scratch 團隊",
    "gui.telemetryOptIn.optOutTooltip": "停用遙測",
    "gui.telemetryOptIn.settingWasUpdated": "設定已更新。",
    "gui.telemetryOptIn.buttonClose": "關閉",
    "gui.turboMode.active": "加速模式",
    "gui.webglModal.label": "你的瀏覽器不支援 WebGL",
    "gui.webglModal.description": "似乎你的瀏覽器或裝置 {webGlLink}，這是讓 Scratch 3.0 運作的必要技術。",
    "gui.webglModal.webgllink": "不支援 WebGL",
    "gui.webglModal.back": "返回",
    "gui.webglModal.previewfaq": "若要進一步瞭解，請至 {previewFaqLink}。",
    "gui.webglModal.previewfaqlinktext": "常見問答",
    "gui.costumeLibrary.chooseABackdrop": "範例背景",
    "gui.costumeLibrary.chooseACostume": "範例造型",
    "gui.costumeTab.addBackdropFromLibrary": "選個背景",
    "gui.costumeTab.addCostumeFromLibrary": "選個造型",
    "gui.costumeTab.addBlankCostume": "繪畫",
    "gui.costumeTab.addSurpriseCostume": "驚喜",
    "gui.costumeTab.addFileBackdrop": "上傳",
    "gui.costumeTab.addFileCostume": "上傳",
    "gui.extensionLibrary.chooseAnExtension": "選擇擴充功能",
    "gui.extensionLibrary.extensionUrl": "輸入擴充功能的網址",
    "gui.monitors.importListColumnPrompt": "該使用哪一欄（1-{numberOfColumns}）？",
    "gui.recordingStep.alertMsg": "無法開始錄製",
    "gui.soundLibrary.chooseASound": "範例音效",
    "gui.soundTab.fileUploadSound": "上傳",
    "gui.soundTab.surpriseSound": "驚喜",
    "gui.soundTab.recordSound": "錄製",
    "gui.soundTab.addSoundFromLibrary": "選個音效",
    "gui.spriteLibrary.chooseASprite": "範例角色",
    "gui.tipsLibrary.tutorials": "選擇教程",
    "gui.alerts.createsuccess": "專案創建成功。",
    "gui.alerts.createcopysuccess": "已另存為複本。",
    "gui.alerts.createremixsuccess": "已另存為改編本。",
    "gui.alerts.creating": "正在創建新的專案…",
    "gui.alerts.creatingCopy": "正在複製專案…",
    "gui.alerts.creatingRemix": "正在改編專案…",
    "gui.alerts.creatingError": "專案無法創建，麻煩再試一次！",
    "gui.alerts.savingError": "專案無法儲存。",
    "gui.alerts.savesuccess": "專案儲存成功。",
    "gui.alerts.saving": "正在儲存專案…",
    "gui.alerts.cloudInfo": "注意，雲端變數目前只支援數字，不能存取文字等其它符號。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "進一步瞭解",
    "gui.alerts.importing": "正在匯入…",
    "gui.defaultProject.meow": "Meow",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "新手入門",
    "gui.howtos.intro-move.step_stepMove": "添加一個移動積木",
    "gui.howtos.add-a-move-block.step_stepSay": "添加一個說出積木",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "點擊綠旗以執行程式",
    "gui.howtos.intro-getting-started-ASL.name": "入門-美國手語",
    "gui.howtos.animate-a-name.name": "姓名動畫",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "選擇一個字母",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "當被點擊時播放一個音效",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "選擇另一個字母",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "更改顏色",
    "gui.howtos.animate-a-name.step_AnimateSpin": "選擇另一個字母並讓它旋轉",
    "gui.howtos.animate-a-name.step_AnimateGrow": "選擇另一個字母並讓它縮放",
    "gui.howtos.imagine": "想像的世界",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "輸入你想要說的內容",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "點擊綠旗運行看看",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "選個背景",
    "gui.howtos.imagine.step_imagineChooseSprite": "選個角色",
    "gui.howtos.imagine.step_imagineFlyAround": "按下空白鍵就可以滑行",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "選另一個角色",
    "gui.howtos.imagine.step_imagineLeftRight": "左右移動",
    "gui.howtos.imagine.step_imagineUpDown": "上下移動",
    "gui.howtos.imagine.step_imagineChangeCostumes": "變更造型",
    "gui.howtos.imagine.step_imagineGlideToPoint": "滑行到一個地方",
    "gui.howtos.imagine.step_imagineGrowShrink": "放大與縮小",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "選另一個背景",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "切換背景",
    "gui.howtos.imagine.step_imagineRecordASound": "新增一個音效",
    "gui.howtos.imagine.step_imagineChooseSound": "選個音效",
    "gui.howtos.make-music.name": "音樂創作",
    "gui.howtos.Make-Music.step_PickInstrument": "選擇一個樂器當角色",
    "gui.howtos.Make-Music.step_PlaySoundClick": "當被點擊時播放音效",
    "gui.howtos.Make-Music.step_MakeSong": "創建一首歌曲",
    "gui.howtos.make-music.step_MakeBeat": "選擇一種樂器並打出節拍",
    "gui.howtos.make-music.step_MakeBeatBox": "選擇角色 Microphone（麥克風）& 用驚喜按鈕產生 Beatbox",
    "gui.howtos.story.name": "創作故事",
    "gui.howtos.story.step_addbg": "添加一個背景",
    "gui.howtos.story.step_addsprite": "添加一個角色",
    "gui.howtos.story.step_saysomething": "讓角色說些話",
    "gui.howtos.story.step_addanothersprite": "加入另一個角色",
    "gui.howtos.story.step_flip": "翻轉造型",
    "gui.howtos.story.step_conversation": "開始對話",
    "gui.howtos.story.addanotherbg": "添加其它背景",
    "gui.howtos.story.step_swithbg": "切換背景",
    "gui.howtos.story.step_hidewizard": "隱藏一個角色",
    "gui.howtos.story.step_showwizard": "顯示一個角色",
    "gui.howtos.make-a-chase-game.name": "創作一個追逐遊戲",
    "gui.howtos.Chase-Game.step_BG": "添加一個背景",
    "gui.howtos.chase-game.step_AddOcto": "添加一個角色",
    "gui.howtos.make-music.step_LeftRight": "用方向鍵左右移動",
    "gui.howtos.Chase-Game.step_UpDown": "用方向鍵上下移動",
    "gui.howtos.Chase-Game.step_AddStar": "添加其他角色",
    "gui.howtos.Chase-Game.step_MoveRandom": "任意移動",
    "gui.howtos.Chase-Game.step_WhenTouch": "當碰到 Octopus（章魚）角色時播放音效",
    "gui.howtos.Chase-Game.step_ScoreVariable": "創建一個變數以紀錄分數",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "當碰到 Octopus（章魚）角色時添加分數",
    "gui.howtos.animate-char.name": "讓角色動起來",
    "gui.howtos.animate-char.step_addbg": "添加一個背景",
    "gui.howtos.animate-char.step_addsprite": "添加一個角色",
    "gui.howtos.animate-char.step_saysomething": "讓角色說些話",
    "gui.howtos.animate-char.step_addsound": "新增聲音",
    "gui.howtos.animate-char.step_animatetalking": "讓角色說些話",
    "gui.howtos.animate-char.step_arrowkeys": "用方向鍵移動",
    "gui.howtos.animate-char.step_jump": "跳躍",
    "gui.howtos.animate-char.step_changecolor": "更改顏色",
    "gui.howtos.make-a-game.name": "創作一個點擊遊戲",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "挑選一個角色",
    "gui.howtos.make-a-game.step_GamePlaySound": "當被點擊時播放音效",
    "gui.howtos.make-a-game.step_GameAddScore": "創建一個變數以紀錄分數",
    "gui.howtos.make-a-game.step_GameChangeScore": "單擊時增加分數",
    "gui.howtos.make-a-game.step_Random": "定位到隨機位置",
    "gui.howtos.make-music.step_GameChangeColor": "更改顏色",
    "gui.howtos.make-music.step_ResetScore": "重設分數",
    "gui.howtos.make-it-fly.name": "讓它飛吧",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "選個天空背景",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "選擇一個角色",
    "gui.howtos.fly.step_stepflySaySomething": "讓角色說些話",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "用方向鍵移動",
    "gui.howtos.fly.step_stepflyChooseObject": "選個要收集的東西",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "讓東西動起來",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "選個主角",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "加入得分",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "紀錄分數",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "加入景物",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "移動佈景",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "下個造型",
    "gui.howtos.pong": "乒乓球遊戲",
    "gui.howtos.pong.step_pongAddBackdrop": "添加一個背景",
    "gui.howtos.pong.step_pongAddBallSprite": "添加一個球當角色",
    "gui.howtos.pong.step_pongBounceAround": "碰到邊緣就反彈",
    "gui.howtos.pong.step_pongAddPaddle": "添加一個球拍",
    "gui.howtos.pong.step_pongMoveThePaddle": "控制球拍",
    "gui.howtos.pong.step_pongSelectBallSprite": "選取角色球",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "加入碰到球拍就反彈的程式",
    "gui.howtos.pong.step_pongAddAScore": "加入得分",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "從選單選擇「得分」",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "插入「變數得分改變為」積木",
    "gui.howtos.pong.step_pongResetScore": "重設分數",
    "gui.howtos.pong.step_pongAddLineSprite": "添加線條的角色",
    "gui.howtos.pong.step_pongGameOver": "遊戲結束",
    "gui.howtos.code-cartoon": "動畫編程",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "點擊綠旗圖示時讓角色說些話",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "點擊角色時讓它動起來",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "選個其它的角色",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "輸入負數讓角色變得愈來愈小",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "讓角色放大與縮小",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "選個其它的角色",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "跳上跳下",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "點擊角色以變更場景",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "角色滑行",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "變更造型",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "在你的動畫中加入更多角色",
    "gui.howtos.cartoon-network": "探險遊戲做動畫",
    "gui.howtos.cartoon-network.step_CNcharacter": "選一個你想用的角色",
    "gui.howtos.cartoon-network.step_CNsay": "讓角色說些話",
    "gui.howtos.cartoon-network.step_CNglide": "角色滑行",
    "gui.howtos.cartoon-network.step_CNpicksprite": "選一個要追逐的對象",
    "gui.howtos.cartoon-network.step_CNcollect": "要收集的東西",
    "gui.howtos.cartoon-network.step_CNvariable": "建立一個紀錄得分的變數",
    "gui.howtos.cartoon-network.step_CNscore": "紀錄分數",
    "gui.howtos.cartoon-network.step_CNbackdrop": "進一步：改變背景",
    "gui.howtos.videosens.name": "視訊偵測",
    "gui.howtos.videosens.step_addextension": "添加擴展",
    "gui.howtos.videosens.step_pet": "餵食貓咪",
    "gui.howtos.videosens.step_animate": "讓它動起來",
    "gui.howtos.videosens.step_pop": "彈出一個氣球",
    "gui.howtos.say-it-out-loud": "創作對話的動畫",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "加入文字轉語音積木",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "讓角色說些話",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "選擇一種語音",
    "gui.howtos.say-it-out-loud.step_TXTMove": "四處移動",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "添加一個背景",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "加入另一個角色",
    "gui.howtos.say-it-out-loud.step_TXTSong": "演奏一首歌曲",
    "gui.howtos.say-it-out-loud.step_TXTColor": "更改顏色",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "讓角色旋轉",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "放大與縮小",
    "gui.howtos.talking": "說個故事",
    "gui.howtos.talking.step_talesAddExtension": "點擊以添加文字轉語音的積木",
    "gui.howtos.talking.step_talesChooseSprite": "範例角色",
    "gui.howtos.talking.step_talesSaySomething": "讓角色講點話",
    "gui.howtos.talking.step_talesChooseBackdrop": "範例背景",
    "gui.howtos.talking.step_talesSwitchBackdrop": "點擊角色以切換到下一個場景",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "選另一個角色",
    "gui.howtos.talking.step_talesMoveAround": "四處移動",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "選另一個背景",
    "gui.howtos.talking.step_talesAnimateTalking": "讓角色說些話",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "選另一個背景",
    "gui.howtos.talking.step_talesChooseSound": "選個跳舞用的音樂",
    "gui.howtos.talking.step_talesDanceMoves": "舞蹈動作",
    "gui.howtos.talking.step_talesAskAnswer": "從偵測類中找到詢問並回答的積木",
    "gui.howtos.add-sprite.name": "添加一個角色",
    "gui.howtos.add-sprite.step_addSprite": "添加一個角色",
    "gui.howtos.add-a-backdrop.name": "添加一個背景",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "添加一個背景",
    "gui.howtos.change-size.name": "尺寸改變",
    "gui.howtos.change-size.step_changeSize": "尺寸改變",
    "gui.howtos.glide-around.name": "角色滑行",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "角色滑行",
    "gui.howtos.change-size.step_glideAroundPoint": "滑行到一個地方",
    "gui.howtos.record-a-sound.name": "聲音錄製",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "切換到「音效」頁籤",
    "gui.howtos.change-size.step_recordASoundClickRecord": "點擊「錄製」",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "按下錄製按鈕",
    "gui.howtos.change-size.step_recordASoundChooseSound": "選個音效",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "播放你的音效",
    "gui.howtos.spin-video.name": "角色旋轉",
    "gui.howtos.change-size.step_spinTurn": "轉向",
    "gui.howtos.change-size.step_spinPointInDirection": "設置方向",
    "gui.howtos.hide-and-show.name": "隱藏和顯示",
    "gui.howtos.change-size.step_hideAndShow": "隱藏和顯示",
    "gui.howtos.switch-costume.name": "角色動畫",
    "gui.howtos.change-size.step_switchCostumes": "角色動畫",
    "gui.howtos.move-around-with-arrow-keys.name": "用方向鍵控制",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "左右移動",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "上下移動",
    "gui.howtos.add-effects.name": "添加一些效果",
    "gui.howtos.videosens.step_addEffects": "添加一些效果",
    "gui.extension.music.name": "音樂",
    "gui.extension.music.description": "演奏樂器與節拍。",
    "gui.extension.pen.name": "畫筆",
    "gui.extension.pen.description": "使用你的角色來畫圖。",
    "gui.extension.videosensing.name": "視訊偵測",
    "gui.extension.videosensing.description": "使用攝影機偵測動作。",
    "gui.extension.text2speech.name": "文字轉語音",
    "gui.extension.text2speech.description": "讓你的專案能夠說話",
    "gui.extension.translate.name": "翻譯",
    "gui.extension.translate.description": "將文字訊息翻譯為各國語言。",
    "gui.extension.makeymakey.description": "把任何東西變成鑰匙。",
    "gui.extension.microbit.description": "讓你的專案與實體世界連結。",
    "gui.extension.microbit.connectingMessage": "正在連線",
    "gui.extension.ev3.description": "創作互動機器人以及更多。",
    "gui.extension.ev3.connectingMessage": "正在連接，請確定 EV3 主機上的 Pin 碼已設為 1234。",
    "gui.extension.boost.description": "將機器人創造帶入現實生活。",
    "gui.extension.boost.connectingMessage": "正在連線",
    "gui.extension.wedo2.description": "運用馬達與感測器進行創作。",
    "gui.extension.wedo2.connectingMessage": "正在連線",
    "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
    "gui.extension.gdxfor.connectingMessage": "正在連線",
    "gui.libraryTags.all": "全部",
    "gui.libraryTags.animals": "動物",
    "gui.libraryTags.dance": "舞蹈",
    "gui.libraryTags.effects": "效果",
    "gui.libraryTags.fantasy": "魔幻",
    "gui.libraryTags.fashion": "時尚",
    "gui.libraryTags.food": "食物",
    "gui.libraryTags.indoors": "室內",
    "gui.libraryTags.loops": "循環",
    "gui.libraryTags.music": "音樂",
    "gui.libraryTags.notes": "音階",
    "gui.libraryTags.outdoors": "戶外",
    "gui.libraryTags.patterns": "圖案",
    "gui.libraryTags.people": "人物",
    "gui.libraryTags.percussion": "節奏",
    "gui.libraryTags.space": "太空",
    "gui.libraryTags.sports": "運動",
    "gui.libraryTags.underwater": "水中",
    "gui.libraryTags.voice": "人聲",
    "gui.libraryTags.wacky": "滑稽",
    "gui.libraryTags.animation": "動畫",
    "gui.libraryTags.art": "藝術",
    "gui.libraryTags.games": "遊戲",
    "gui.libraryTags.stories": "故事",
    "gui.libraryTags.letters": "字母",
    "gui.opcodeLabels.direction": "方向",
    "gui.opcodeLabels.xposition": "x 座標",
    "gui.opcodeLabels.yposition": "y 座標",
    "gui.opcodeLabels.size": "尺寸",
    "gui.opcodeLabels.costumename": "造型名稱",
    "gui.opcodeLabels.costumenumber": "造型編號",
    "gui.opcodeLabels.backdropname": "背景名稱",
    "gui.opcodeLabels.backdropnumber": "背景編號",
    "gui.opcodeLabels.volume": "音量",
    "gui.opcodeLabels.tempo": "演奏速度",
    "gui.opcodeLabels.answer": "詢問的答案",
    "gui.opcodeLabels.loudness": "聲音響度",
    "gui.opcodeLabels.username": "用戶名稱",
    "gui.opcodeLabels.year": "年",
    "gui.opcodeLabels.month": "月",
    "gui.opcodeLabels.date": "日",
    "gui.opcodeLabels.dayofweek": "週",
    "gui.opcodeLabels.hour": "時",
    "gui.opcodeLabels.minute": "分",
    "gui.opcodeLabels.second": "秒",
    "gui.opcodeLabels.timer": "計時器",
    "gui.projectLoader.loadError": "所選的專案檔案載入失敗。",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "是否取代現有專案？",
    "gui.sharedMessages.loadFromComputerTitle": "從你的電腦挑選",
    "gui.theme.default": "Original",
    "gui.theme.dark": "Dark",
    "gui.theme.highContrast": "High Contrast",
    "gui.gui.defaultProjectTitle": "Scratch 專案",
    "boost.color.any": "任何顏色",
    "boost.color.black": "黑色",
    "boost.color.blue": "藍色",
    "boost.color.green": "綠色",
    "boost.color.red": "紅色",
    "boost.color.white": "白色",
    "boost.color.yellow": "黃色",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] 轉向角度",
    "boost.getTiltAngle": "傾斜角度 [TILT_DIRECTION]",
    "boost.motorDirection.backward": "逆時針",
    "boost.motorDirection.forward": "順時針",
    "boost.motorDirection.reverse": "相反",
    "boost.motorOff": "[MOTOR_ID] 停止",
    "boost.motorOn": "[MOTOR_ID] 啟動",
    "boost.motorOnFor": "[MOTOR_ID] 啟動 持續 [DURATION] 秒",
    "boost.motorOnForRotation": "[MOTOR_ID] 啟動 持續 [ROTATION] 圈",
    "boost.seeingColor": "看到顏色 [COLOR]？",
    "boost.setLightHue": "LED 顏色設為 [HUE]",
    "boost.setMotorDirection": "[MOTOR_ID] 方向設為 [MOTOR_DIRECTION]",
    "boost.setMotorPower": "[MOTOR_ID] 動力設為 [POWER] %",
    "boost.tiltDirection.any": "任何",
    "boost.tiltDirection.down": "向下",
    "boost.tiltDirection.left": "向左",
    "boost.tiltDirection.right": "向右",
    "boost.tiltDirection.up": "向上",
    "boost.whenColor": "當顏色 [COLOR]  被看到",
    "boost.whenTilted": "當傾斜 [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "演奏音階 [NOTE] 持續 [TIME] 秒",
    "ev3.buttonPressed": "按鈕 [PORT] 被按下？",
    "ev3.getBrightness": "亮度",
    "ev3.getDistance": "距離",
    "ev3.getMotorPosition": "馬達 埠[PORT] 轉向角度",
    "ev3.motorSetPower": "馬達 埠[PORT] 動力設為 [POWER] %",
    "ev3.motorTurnClockwise": "馬達 埠[PORT] 順時針旋轉 [TIME] 秒",
    "ev3.motorTurnCounterClockwise": "馬達 埠[PORT] 逆時針旋轉 [TIME] 秒",
    "ev3.whenBrightnessLessThan": "當亮度 < [DISTANCE]",
    "ev3.whenButtonPressed": "當按鈕 [PORT] 被按下",
    "ev3.whenDistanceLessThan": "當距離 < [DISTANCE]",
    "gdxfor.getAcceleration": "加速度 [DIRECTION]",
    "gdxfor.getForce": "力量",
    "gdxfor.getSpin": "旋轉速度 [DIRECTION]",
    "gdxfor.getTilt": "傾斜角度 [TILT]",
    "gdxfor.isFreeFalling": "自由掉落？",
    "gdxfor.isTilted": "傾斜 [TILT]？",
    "gdxfor.pulled": "向外拉",
    "gdxfor.pushed": "向內推",
    "gdxfor.shaken": "晃動",
    "gdxfor.startedFalling": "開始掉落",
    "gdxfor.tiltDirectionMenu.any": "任何",
    "gdxfor.tiltDirectionMenu.back": "向下",
    "gdxfor.tiltDirectionMenu.front": "向上",
    "gdxfor.tiltDirectionMenu.left": "向左",
    "gdxfor.tiltDirectionMenu.right": "向右",
    "gdxfor.turnedFaceDown": "背面朝上",
    "gdxfor.turnedFaceUp": "正面朝上",
    "gdxfor.whenForcePushedOrPulled": "當重力感測器[PUSH_PULL]",
    "gdxfor.whenGesture": "當 [GESTURE]",
    "gdxfor.whenTilted": "當傾斜 [TILT]",
    "makeymakey.downArrow": "向下",
    "makeymakey.downArrowShort": "向下",
    "makeymakey.leftArrow": "向左",
    "makeymakey.leftArrowShort": "向左",
    "makeymakey.rightArrow": "向右",
    "makeymakey.rightArrowShort": "向右",
    "makeymakey.spaceKey": "空白",
    "makeymakey.upArrow": "向上",
    "makeymakey.upArrowShort": "向上",
    "makeymakey.whenKeyPressed": "當 [KEY] 按鈕被按下",
    "makeymakey.whenKeysPressedInOrder": "當 [SEQUENCE] 按鈕被依序按下",
    "microbit.buttonsMenu.any": "任何",
    "microbit.clearDisplay": "清空畫面",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.displaySymbol": "顯示圖示 [MATRIX]",
    "microbit.displayText": "顯示文字 [TEXT]",
    "microbit.gesturesMenu.jumped": "跳動",
    "microbit.gesturesMenu.moved": "移動",
    "microbit.gesturesMenu.shaken": "晃動",
    "microbit.isButtonPressed": "按鈕 [BTN] 被按下？",
    "microbit.isTilted": "傾斜 [DIRECTION]？",
    "microbit.pinStateMenu.off": "關閉",
    "microbit.pinStateMenu.on": "開啟",
    "microbit.tiltAngle": "傾斜角度 [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "任何",
    "microbit.tiltDirectionMenu.back": "向下",
    "microbit.tiltDirectionMenu.front": "向上",
    "microbit.tiltDirectionMenu.left": "向左",
    "microbit.tiltDirectionMenu.right": "向右",
    "microbit.whenButtonPressed": "當按鈕 [BTN] 被按下",
    "microbit.whenGesture": "當 [GESTURE]",
    "microbit.whenPinConnected": "當引腳 [PIN] 接地",
    "microbit.whenTilted": "當傾斜 [DIRECTION]",
    "music.categoryName": "音樂",
    "music.changeTempo": "演奏速度改變 [TEMPO]",
    "music.drumBass": "(2) 低音鼓",
    "music.drumBongo": "(13) 邦加鼓",
    "music.drumCabasa": "(15) 鐵沙鈴",
    "music.drumClaves": "(9) 梆子",
    "music.drumClosedHiHat": "(6) 合起的腳踏鈸",
    "music.drumConga": "(14) 康加鼓",
    "music.drumCowbell": "(11) 牛鈴",
    "music.drumCrashCymbal": "(4) 碎音鈸",
    "music.drumCuica": "(18) 庫加鼓",
    "music.drumGuiro": "(16) 刮瓜",
    "music.drumHandClap": "(8) 拍掌",
    "music.drumOpenHiHat": "(5) 打開的腳踏鈸",
    "music.drumSideStick": "(3) 鼓邊敲擊",
    "music.drumSnare": "(1) 軍鼓",
    "music.drumTambourine": "(7) 鈴鼓",
    "music.drumTriangle": "(12) 三角鐵",
    "music.drumVibraslap": "(17) 振盪器",
    "music.drumWoodBlock": "(10) 木魚",
    "music.getTempo": "演奏速度",
    "music.instrumentBass": "(6) 貝斯",
    "music.instrumentBassoon": "(14) 低音管",
    "music.instrumentCello": "(8) 大提琴",
    "music.instrumentChoir": "(15) 人聲合唱",
    "music.instrumentClarinet": "(10) 單簧管",
    "music.instrumentElectricGuitar": "(5) 電吉他",
    "music.instrumentElectricPiano": "(2) 電子琴",
    "music.instrumentFlute": "(12) 長笛",
    "music.instrumentGuitar": "(4) 吉他",
    "music.instrumentMarimba": "(19) 馬林巴",
    "music.instrumentMusicBox": "(17) 音樂盒",
    "music.instrumentOrgan": "(3) 風琴",
    "music.instrumentPiano": "(1) 鋼琴",
    "music.instrumentPizzicato": "(7) 撥奏",
    "music.instrumentSaxophone": "(11) 薩克斯風",
    "music.instrumentSteelDrum": "(18) 鋼鼓",
    "music.instrumentSynthLead": "(20) 合成主音",
    "music.instrumentSynthPad": "(21) 合成柔音",
    "music.instrumentTrombone": "(9) 長號",
    "music.instrumentVibraphone": "(16) 顫音琴",
    "music.instrumentWoodenFlute": "(13) 木笛",
    "music.midiPlayDrumForBeats": "演奏節拍 [DRUM] [BEATS] 拍",
    "music.midiSetInstrument": "演奏樂器設為 [INSTRUMENT]",
    "music.playDrumForBeats": "演奏節拍 [DRUM] [BEATS] 拍",
    "music.playNoteForBeats": "演奏音階 [NOTE] [BEATS] 拍",
    "music.restForBeats": "演奏休息 [BEATS] 拍",
    "music.setInstrument": "演奏樂器設為 [INSTRUMENT]",
    "music.setTempo": "演奏速度設為 [TEMPO]",
    "pen.categoryName": "畫筆",
    "pen.changeColorParam": "筆跡 [COLOR_PARAM] 改變 [VALUE]",
    "pen.changeHue": "筆跡顏色改變 [HUE]",
    "pen.changeShade": "筆跡亮度改變 [SHADE]",
    "pen.changeSize": "筆跡寬度改變 [SIZE]",
    "pen.clear": "筆跡全部清除",
    "pen.colorMenu.brightness": "亮度",
    "pen.colorMenu.color": "顏色",
    "pen.colorMenu.saturation": "彩度",
    "pen.colorMenu.transparency": "透明度",
    "pen.penDown": "下筆",
    "pen.penUp": "停筆",
    "pen.setColor": "筆跡顏色設為 [COLOR]",
    "pen.setColorParam": "筆跡 [COLOR_PARAM] 設為 [VALUE]",
    "pen.setHue": "筆跡顏色設為 [HUE]",
    "pen.setShade": "筆跡亮度設為 [SHADE]",
    "pen.setSize": "筆跡寬度設為 [SIZE]",
    "pen.stamp": "蓋章",
    "speech.defaultWhenIHearValue": "開始吧",
    "speech.extensionName": "語音識別",
    "speech.listenAndWait": "收聽並等待",
    "speech.speechReporter": "語音文本",
    "speech.whenIHear": "當收到語音 [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "文字轉語音",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "低沉",
    "text2speech.kitten": "小貓",
    "text2speech.setLanguageBlock": "語言設為 [LANGUAGE]",
    "text2speech.setVoiceBlock": "語音設為 [VOICE]",
    "text2speech.speakAndWaitBlock": "唸出 [WORDS]",
    "text2speech.squeak": "尖細",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "翻譯",
    "translate.defaultTextToTranslate": "hello",
    "translate.translateBlock": "文字 [WORDS] 翻譯成 [LANGUAGE]",
    "translate.viewerLanguage": "瀏覽者的語言",
    "videoSensing.categoryName": "視訊偵測",
    "videoSensing.direction": "方向",
    "videoSensing.motion": "動作",
    "videoSensing.off": "關閉",
    "videoSensing.on": "開啟",
    "videoSensing.onFlipped": "翻轉",
    "videoSensing.setVideoTransparency": "視訊透明度設為 [TRANSPARENCY]",
    "videoSensing.sprite": "角色",
    "videoSensing.stage": "舞台",
    "videoSensing.videoOn": "[SUBJECT] 的視訊 [ATTRIBUTE]",
    "videoSensing.videoToggle": "視訊設為 [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "當視訊動作 > [REFERENCE]",
    "wedo2.getDistance": "距離",
    "wedo2.getTiltAngle": "傾斜角度 [TILT_DIRECTION]",
    "wedo2.isTilted": "傾斜 [TILT_DIRECTION_ANY]？",
    "wedo2.motorDirection.backward": "逆時針",
    "wedo2.motorDirection.forward": "順時針",
    "wedo2.motorDirection.reverse": "相反",
    "wedo2.motorId.a": "馬達 A",
    "wedo2.motorId.all": "馬達 A 與 B",
    "wedo2.motorId.b": "馬達 B",
    "wedo2.motorId.default": "馬達",
    "wedo2.motorOff": "[MOTOR_ID] 停止",
    "wedo2.motorOn": "[MOTOR_ID] 啟動",
    "wedo2.motorOnFor": "[MOTOR_ID] 啟動 持續 [DURATION] 秒",
    "wedo2.playNoteFor": "演奏音階 [NOTE] 持續 [DURATION] 秒",
    "wedo2.setLightHue": "LED 顏色設為 [HUE]",
    "wedo2.setMotorDirection": "[MOTOR_ID] 方向設為 [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "[MOTOR_ID] 動力設為 [POWER]",
    "wedo2.tiltDirection.any": "任何",
    "wedo2.tiltDirection.down": "向下",
    "wedo2.tiltDirection.left": "向左",
    "wedo2.tiltDirection.right": "向右",
    "wedo2.tiltDirection.up": "向上",
    "wedo2.whenDistance": "當距離 [OP] [REFERENCE]",
    "wedo2.whenTilted": "當傾斜 [TILT_DIRECTION_ANY]",
    "paint.paintEditor.hue": "顏色",
    "paint.paintEditor.saturation": "彩度",
    "paint.paintEditor.brightness": "亮度",
    "paint.paintEditor.costume": "造型",
    "paint.paintEditor.group": "建立群組",
    "paint.paintEditor.ungroup": "解散群組",
    "paint.paintEditor.undo": "復原",
    "paint.paintEditor.redo": "重做",
    "paint.paintEditor.forward": "上移一層",
    "paint.paintEditor.backward": "下移一層",
    "paint.paintEditor.front": "移到最上層",
    "paint.paintEditor.back": "移到最下層",
    "paint.paintEditor.more": "更多",
    "paint.modeTools.brushSize": "尺寸",
    "paint.modeTools.eraserSize": "擦子寬度",
    "paint.modeTools.copy": "複製",
    "paint.modeTools.paste": "貼上",
    "paint.modeTools.delete": "刪除",
    "paint.modeTools.curved": "圓弧",
    "paint.modeTools.pointed": "尖角",
    "paint.modeTools.thickness": "線條寬度",
    "paint.modeTools.flipHorizontal": "橫向翻轉",
    "paint.modeTools.flipVertical": "直向翻轉",
    "paint.modeTools.filled": "填滿",
    "paint.modeTools.outlined": "外框",
    "paint.paintEditor.bitmap": "轉換成點陣圖",
    "paint.paintEditor.vector": "轉換成向量圖",
    "paint.paintEditor.fill": "填滿",
    "paint.paintEditor.stroke": "外框",
    "paint.brushMode.brush": "筆刷",
    "paint.eraserMode.eraser": "擦子",
    "paint.fillMode.fill": "填滿",
    "paint.lineMode.line": "線條",
    "paint.ovalMode.oval": "圓形",
    "paint.rectMode.rect": "方形",
    "paint.reshapeMode.reshape": "重新塑形",
    "paint.roundedRectMode.roundedRect": "圓角方形",
    "paint.selectMode.select": "選取",
    "paint.textMode.text": "文字",
    "paint.colorPicker.swap": "交換"
  }
};
